var Wt = Object.defineProperty;
var Dt = (re, te, ee) => te in re ? Wt(re, te, { enumerable: !0, configurable: !0, writable: !0, value: ee }) : re[te] = ee;
var Et = (re, te, ee) => (Dt(re, typeof te != "symbol" ? te + "" : te, ee), ee);
var n, l$2, u$2, t$1, o$1, r$2, f$1, e$1, c$2 = {}, s$2 = [], a$2 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, v$1 = Array.isArray;
function h$3(re, te) {
  for (var ee in te)
    re[ee] = te[ee];
  return re;
}
function p$1(re) {
  var te = re.parentNode;
  te && te.removeChild(re);
}
function y$1(re, te, ee) {
  var ne, ie, ae, ce = {};
  for (ae in te)
    ae == "key" ? ne = te[ae] : ae == "ref" ? ie = te[ae] : ce[ae] = te[ae];
  if (arguments.length > 2 && (ce.children = arguments.length > 3 ? n.call(arguments, 2) : ee), typeof re == "function" && re.defaultProps != null)
    for (ae in re.defaultProps)
      ce[ae] === void 0 && (ce[ae] = re.defaultProps[ae]);
  return d$1(re, ce, ne, ie, null);
}
function d$1(re, te, ee, ne, ie) {
  var ae = { type: re, props: te, key: ee, ref: ne, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: ie ?? ++u$2 };
  return ie == null && l$2.vnode != null && l$2.vnode(ae), ae;
}
function _$1() {
  return { current: null };
}
function k$2(re) {
  return re.children;
}
function b$1(re, te) {
  this.props = re, this.context = te;
}
function g$2(re, te) {
  if (te == null)
    return re.__ ? g$2(re.__, re.__.__k.indexOf(re) + 1) : null;
  for (var ee; te < re.__k.length; te++)
    if ((ee = re.__k[te]) != null && ee.__e != null)
      return ee.__e;
  return typeof re.type == "function" ? g$2(re) : null;
}
function m$1(re) {
  var te, ee;
  if ((re = re.__) != null && re.__c != null) {
    for (re.__e = re.__c.base = null, te = 0; te < re.__k.length; te++)
      if ((ee = re.__k[te]) != null && ee.__e != null) {
        re.__e = re.__c.base = ee.__e;
        break;
      }
    return m$1(re);
  }
}
function w$2(re) {
  (!re.__d && (re.__d = !0) && t$1.push(re) && !x$2.__r++ || o$1 !== l$2.debounceRendering) && ((o$1 = l$2.debounceRendering) || r$2)(x$2);
}
function x$2() {
  var re, te, ee, ne, ie, ae, ce, he;
  for (t$1.sort(f$1); re = t$1.shift(); )
    re.__d && (te = t$1.length, ne = void 0, ie = void 0, ce = (ae = (ee = re).__v).__e, (he = ee.__P) && (ne = [], (ie = h$3({}, ae)).__v = ae.__v + 1, L$1(he, ae, ie, ee.__n, he.ownerSVGElement !== void 0, ae.__h != null ? [ce] : null, ne, ce ?? g$2(ae), ae.__h), M$1(ne, ae), ae.__e != ce && m$1(ae)), t$1.length > te && t$1.sort(f$1));
  x$2.__r = 0;
}
function P$1(re, te, ee, ne, ie, ae, ce, he, _e, le) {
  var se, oe, ue, be, ve, me, pe, fe = ne && ne.__k || s$2, ge = fe.length;
  for (ee.__k = [], se = 0; se < te.length; se++)
    if ((be = ee.__k[se] = (be = te[se]) == null || typeof be == "boolean" || typeof be == "function" ? null : typeof be == "string" || typeof be == "number" || typeof be == "bigint" ? d$1(null, be, null, null, be) : v$1(be) ? d$1(k$2, { children: be }, null, null, null) : be.__b > 0 ? d$1(be.type, be.props, be.key, be.ref ? be.ref : null, be.__v) : be) != null) {
      if (be.__ = ee, be.__b = ee.__b + 1, (ue = fe[se]) === null || ue && be.key == ue.key && be.type === ue.type)
        fe[se] = void 0;
      else
        for (oe = 0; oe < ge; oe++) {
          if ((ue = fe[oe]) && be.key == ue.key && be.type === ue.type) {
            fe[oe] = void 0;
            break;
          }
          ue = null;
        }
      L$1(re, be, ue = ue || c$2, ie, ae, ce, he, _e, le), ve = be.__e, (oe = be.ref) && ue.ref != oe && (pe || (pe = []), ue.ref && pe.push(ue.ref, null, be), pe.push(oe, be.__c || ve, be)), ve != null ? (me == null && (me = ve), typeof be.type == "function" && be.__k === ue.__k ? be.__d = _e = C$1(be, _e, re) : _e = $$1(re, be, ue, fe, ve, _e), typeof ee.type == "function" && (ee.__d = _e)) : _e && ue.__e == _e && _e.parentNode != re && (_e = g$2(ue));
    }
  for (ee.__e = me, se = ge; se--; )
    fe[se] != null && (typeof ee.type == "function" && fe[se].__e != null && fe[se].__e == ee.__d && (ee.__d = A$2(ne).nextSibling), q$2(fe[se], fe[se]));
  if (pe)
    for (se = 0; se < pe.length; se++)
      O$1(pe[se], pe[++se], pe[++se]);
}
function C$1(re, te, ee) {
  for (var ne, ie = re.__k, ae = 0; ie && ae < ie.length; ae++)
    (ne = ie[ae]) && (ne.__ = re, te = typeof ne.type == "function" ? C$1(ne, te, ee) : $$1(ee, ne, ne, ie, ne.__e, te));
  return te;
}
function S(re, te) {
  return te = te || [], re == null || typeof re == "boolean" || (v$1(re) ? re.some(function(ee) {
    S(ee, te);
  }) : te.push(re)), te;
}
function $$1(re, te, ee, ne, ie, ae) {
  var ce, he, _e;
  if (te.__d !== void 0)
    ce = te.__d, te.__d = void 0;
  else if (ee == null || ie != ae || ie.parentNode == null)
    e:
      if (ae == null || ae.parentNode !== re)
        re.appendChild(ie), ce = null;
      else {
        for (he = ae, _e = 0; (he = he.nextSibling) && _e < ne.length; _e += 1)
          if (he == ie)
            break e;
        re.insertBefore(ie, ae), ce = ae;
      }
  return ce !== void 0 ? ce : ie.nextSibling;
}
function A$2(re) {
  var te, ee, ne;
  if (re.type == null || typeof re.type == "string")
    return re.__e;
  if (re.__k) {
    for (te = re.__k.length - 1; te >= 0; te--)
      if ((ee = re.__k[te]) && (ne = A$2(ee)))
        return ne;
  }
  return null;
}
function H$2(re, te, ee, ne, ie) {
  var ae;
  for (ae in ee)
    ae === "children" || ae === "key" || ae in te || T$2(re, ae, null, ee[ae], ne);
  for (ae in te)
    ie && typeof te[ae] != "function" || ae === "children" || ae === "key" || ae === "value" || ae === "checked" || ee[ae] === te[ae] || T$2(re, ae, te[ae], ee[ae], ne);
}
function I$1(re, te, ee) {
  te[0] === "-" ? re.setProperty(te, ee ?? "") : re[te] = ee == null ? "" : typeof ee != "number" || a$2.test(te) ? ee : ee + "px";
}
function T$2(re, te, ee, ne, ie) {
  var ae;
  e:
    if (te === "style")
      if (typeof ee == "string")
        re.style.cssText = ee;
      else {
        if (typeof ne == "string" && (re.style.cssText = ne = ""), ne)
          for (te in ne)
            ee && te in ee || I$1(re.style, te, "");
        if (ee)
          for (te in ee)
            ne && ee[te] === ne[te] || I$1(re.style, te, ee[te]);
      }
    else if (te[0] === "o" && te[1] === "n")
      ae = te !== (te = te.replace(/Capture$/, "")), te = te.toLowerCase() in re ? te.toLowerCase().slice(2) : te.slice(2), re.l || (re.l = {}), re.l[te + ae] = ee, ee ? ne || re.addEventListener(te, ae ? z$2 : j$2, ae) : re.removeEventListener(te, ae ? z$2 : j$2, ae);
    else if (te !== "dangerouslySetInnerHTML") {
      if (ie)
        te = te.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (te !== "width" && te !== "height" && te !== "href" && te !== "list" && te !== "form" && te !== "tabIndex" && te !== "download" && te !== "rowSpan" && te !== "colSpan" && te in re)
        try {
          re[te] = ee ?? "";
          break e;
        } catch {
        }
      typeof ee == "function" || (ee == null || ee === !1 && te[4] !== "-" ? re.removeAttribute(te) : re.setAttribute(te, ee));
    }
}
function j$2(re) {
  return this.l[re.type + !1](l$2.event ? l$2.event(re) : re);
}
function z$2(re) {
  return this.l[re.type + !0](l$2.event ? l$2.event(re) : re);
}
function L$1(re, te, ee, ne, ie, ae, ce, he, _e) {
  var le, se, oe, ue, be, ve, me, pe, fe, ge, ye, $e, Se, Ce, Ie, Te = te.type;
  if (te.constructor !== void 0)
    return null;
  ee.__h != null && (_e = ee.__h, he = te.__e = ee.__e, te.__h = null, ae = [he]), (le = l$2.__b) && le(te);
  try {
    e:
      if (typeof Te == "function") {
        if (pe = te.props, fe = (le = Te.contextType) && ne[le.__c], ge = le ? fe ? fe.props.value : le.__ : ne, ee.__c ? me = (se = te.__c = ee.__c).__ = se.__E : ("prototype" in Te && Te.prototype.render ? te.__c = se = new Te(pe, ge) : (te.__c = se = new b$1(pe, ge), se.constructor = Te, se.render = B$2), fe && fe.sub(se), se.props = pe, se.state || (se.state = {}), se.context = ge, se.__n = ne, oe = se.__d = !0, se.__h = [], se._sb = []), se.__s == null && (se.__s = se.state), Te.getDerivedStateFromProps != null && (se.__s == se.state && (se.__s = h$3({}, se.__s)), h$3(se.__s, Te.getDerivedStateFromProps(pe, se.__s))), ue = se.props, be = se.state, se.__v = te, oe)
          Te.getDerivedStateFromProps == null && se.componentWillMount != null && se.componentWillMount(), se.componentDidMount != null && se.__h.push(se.componentDidMount);
        else {
          if (Te.getDerivedStateFromProps == null && pe !== ue && se.componentWillReceiveProps != null && se.componentWillReceiveProps(pe, ge), !se.__e && se.shouldComponentUpdate != null && se.shouldComponentUpdate(pe, se.__s, ge) === !1 || te.__v === ee.__v) {
            for (te.__v !== ee.__v && (se.props = pe, se.state = se.__s, se.__d = !1), se.__e = !1, te.__e = ee.__e, te.__k = ee.__k, te.__k.forEach(function(Ee) {
              Ee && (Ee.__ = te);
            }), ye = 0; ye < se._sb.length; ye++)
              se.__h.push(se._sb[ye]);
            se._sb = [], se.__h.length && ce.push(se);
            break e;
          }
          se.componentWillUpdate != null && se.componentWillUpdate(pe, se.__s, ge), se.componentDidUpdate != null && se.__h.push(function() {
            se.componentDidUpdate(ue, be, ve);
          });
        }
        if (se.context = ge, se.props = pe, se.__P = re, $e = l$2.__r, Se = 0, "prototype" in Te && Te.prototype.render) {
          for (se.state = se.__s, se.__d = !1, $e && $e(te), le = se.render(se.props, se.state, se.context), Ce = 0; Ce < se._sb.length; Ce++)
            se.__h.push(se._sb[Ce]);
          se._sb = [];
        } else
          do
            se.__d = !1, $e && $e(te), le = se.render(se.props, se.state, se.context), se.state = se.__s;
          while (se.__d && ++Se < 25);
        se.state = se.__s, se.getChildContext != null && (ne = h$3(h$3({}, ne), se.getChildContext())), oe || se.getSnapshotBeforeUpdate == null || (ve = se.getSnapshotBeforeUpdate(ue, be)), P$1(re, v$1(Ie = le != null && le.type === k$2 && le.key == null ? le.props.children : le) ? Ie : [Ie], te, ee, ne, ie, ae, ce, he, _e), se.base = te.__e, te.__h = null, se.__h.length && ce.push(se), me && (se.__E = se.__ = null), se.__e = !1;
      } else
        ae == null && te.__v === ee.__v ? (te.__k = ee.__k, te.__e = ee.__e) : te.__e = N$1(ee.__e, te, ee, ne, ie, ae, ce, _e);
    (le = l$2.diffed) && le(te);
  } catch (Ee) {
    te.__v = null, (_e || ae != null) && (te.__e = he, te.__h = !!_e, ae[ae.indexOf(he)] = null), l$2.__e(Ee, te, ee);
  }
}
function M$1(re, te) {
  l$2.__c && l$2.__c(te, re), re.some(function(ee) {
    try {
      re = ee.__h, ee.__h = [], re.some(function(ne) {
        ne.call(ee);
      });
    } catch (ne) {
      l$2.__e(ne, ee.__v);
    }
  });
}
function N$1(re, te, ee, ne, ie, ae, ce, he) {
  var _e, le, se, oe = ee.props, ue = te.props, be = te.type, ve = 0;
  if (be === "svg" && (ie = !0), ae != null) {
    for (; ve < ae.length; ve++)
      if ((_e = ae[ve]) && "setAttribute" in _e == !!be && (be ? _e.localName === be : _e.nodeType === 3)) {
        re = _e, ae[ve] = null;
        break;
      }
  }
  if (re == null) {
    if (be === null)
      return document.createTextNode(ue);
    re = ie ? document.createElementNS("http://www.w3.org/2000/svg", be) : document.createElement(be, ue.is && ue), ae = null, he = !1;
  }
  if (be === null)
    oe === ue || he && re.data === ue || (re.data = ue);
  else {
    if (ae = ae && n.call(re.childNodes), le = (oe = ee.props || c$2).dangerouslySetInnerHTML, se = ue.dangerouslySetInnerHTML, !he) {
      if (ae != null)
        for (oe = {}, ve = 0; ve < re.attributes.length; ve++)
          oe[re.attributes[ve].name] = re.attributes[ve].value;
      (se || le) && (se && (le && se.__html == le.__html || se.__html === re.innerHTML) || (re.innerHTML = se && se.__html || ""));
    }
    if (H$2(re, ue, oe, ie, he), se)
      te.__k = [];
    else if (P$1(re, v$1(ve = te.props.children) ? ve : [ve], te, ee, ne, ie && be !== "foreignObject", ae, ce, ae ? ae[0] : ee.__k && g$2(ee, 0), he), ae != null)
      for (ve = ae.length; ve--; )
        ae[ve] != null && p$1(ae[ve]);
    he || ("value" in ue && (ve = ue.value) !== void 0 && (ve !== re.value || be === "progress" && !ve || be === "option" && ve !== oe.value) && T$2(re, "value", ve, oe.value, !1), "checked" in ue && (ve = ue.checked) !== void 0 && ve !== re.checked && T$2(re, "checked", ve, oe.checked, !1));
  }
  return re;
}
function O$1(re, te, ee) {
  try {
    typeof re == "function" ? re(te) : re.current = te;
  } catch (ne) {
    l$2.__e(ne, ee);
  }
}
function q$2(re, te, ee) {
  var ne, ie;
  if (l$2.unmount && l$2.unmount(re), (ne = re.ref) && (ne.current && ne.current !== re.__e || O$1(ne, null, te)), (ne = re.__c) != null) {
    if (ne.componentWillUnmount)
      try {
        ne.componentWillUnmount();
      } catch (ae) {
        l$2.__e(ae, te);
      }
    ne.base = ne.__P = null, re.__c = void 0;
  }
  if (ne = re.__k)
    for (ie = 0; ie < ne.length; ie++)
      ne[ie] && q$2(ne[ie], te, ee || typeof re.type != "function");
  ee || re.__e == null || p$1(re.__e), re.__ = re.__e = re.__d = void 0;
}
function B$2(re, te, ee) {
  return this.constructor(re, ee);
}
function D$1(re, te, ee) {
  var ne, ie, ae;
  l$2.__ && l$2.__(re, te), ie = (ne = typeof ee == "function") ? null : ee && ee.__k || te.__k, ae = [], L$1(te, re = (!ne && ee || te).__k = y$1(k$2, null, [re]), ie || c$2, c$2, te.ownerSVGElement !== void 0, !ne && ee ? [ee] : ie ? null : te.firstChild ? n.call(te.childNodes) : null, ae, !ne && ee ? ee : ie ? ie.__e : te.firstChild, ne), M$1(ae, re);
}
function E$1(re, te) {
  D$1(re, te, E$1);
}
function F$2(re, te, ee) {
  var ne, ie, ae, ce, he = h$3({}, re.props);
  for (ae in re.type && re.type.defaultProps && (ce = re.type.defaultProps), te)
    ae == "key" ? ne = te[ae] : ae == "ref" ? ie = te[ae] : he[ae] = te[ae] === void 0 && ce !== void 0 ? ce[ae] : te[ae];
  return arguments.length > 2 && (he.children = arguments.length > 3 ? n.call(arguments, 2) : ee), d$1(re.type, he, ne || re.key, ie || re.ref, null);
}
function G$1(re, te) {
  var ee = { __c: te = "__cC" + e$1++, __: re, Consumer: function(ne, ie) {
    return ne.children(ie);
  }, Provider: function(ne) {
    var ie, ae;
    return this.getChildContext || (ie = [], (ae = {})[te] = this, this.getChildContext = function() {
      return ae;
    }, this.shouldComponentUpdate = function(ce) {
      this.props.value !== ce.value && ie.some(function(he) {
        he.__e = !0, w$2(he);
      });
    }, this.sub = function(ce) {
      ie.push(ce);
      var he = ce.componentWillUnmount;
      ce.componentWillUnmount = function() {
        ie.splice(ie.indexOf(ce), 1), he && he.call(ce);
      };
    }), ne.children;
  } };
  return ee.Provider.__ = ee.Consumer.contextType = ee;
}
n = s$2.slice, l$2 = { __e: function(re, te, ee, ne) {
  for (var ie, ae, ce; te = te.__; )
    if ((ie = te.__c) && !ie.__)
      try {
        if ((ae = ie.constructor) && ae.getDerivedStateFromError != null && (ie.setState(ae.getDerivedStateFromError(re)), ce = ie.__d), ie.componentDidCatch != null && (ie.componentDidCatch(re, ne || {}), ce = ie.__d), ce)
          return ie.__E = ie;
      } catch (he) {
        re = he;
      }
  throw re;
} }, u$2 = 0, b$1.prototype.setState = function(re, te) {
  var ee;
  ee = this.__s != null && this.__s !== this.state ? this.__s : this.__s = h$3({}, this.state), typeof re == "function" && (re = re(h$3({}, ee), this.props)), re && h$3(ee, re), re != null && this.__v && (te && this._sb.push(te), w$2(this));
}, b$1.prototype.forceUpdate = function(re) {
  this.__v && (this.__e = !0, re && this.__h.push(re), w$2(this));
}, b$1.prototype.render = k$2, t$1 = [], r$2 = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f$1 = function(re, te) {
  return re.__v.__b - te.__v.__b;
}, x$2.__r = 0, e$1 = 0;
function r$1() {
  return (r$1 = Object.assign || function(re) {
    for (var te = 1; te < arguments.length; te++) {
      var ee = arguments[te];
      for (var ne in ee)
        Object.prototype.hasOwnProperty.call(ee, ne) && (re[ne] = ee[ne]);
    }
    return re;
  }).apply(this, arguments);
}
function i$1(re) {
  this.getChildContext = function() {
    return re.context;
  };
  var te = re.children, ee = function(ne, ie) {
    if (ne == null)
      return {};
    var ae, ce, he = {}, _e = Object.keys(ne);
    for (ce = 0; ce < _e.length; ce++)
      ie.indexOf(ae = _e[ce]) >= 0 || (he[ae] = ne[ae]);
    return he;
  }(re, ["context", "children"]);
  return F$2(te, ee);
}
function a$1() {
  var re = new CustomEvent("_preact", { detail: {}, bubbles: !0, cancelable: !0 });
  this.dispatchEvent(re), this._vdom = y$1(i$1, r$1({}, this._props, { context: re.detail.context }), function te(ee, ne) {
    if (ee.nodeType === 3)
      return ee.data;
    if (ee.nodeType !== 1)
      return null;
    var ie = [], ae = {}, ce = 0, he = ee.attributes, _e = ee.childNodes;
    for (ce = he.length; ce--; )
      he[ce].name !== "slot" && (ae[he[ce].name] = he[ce].value, ae[s$1(he[ce].name)] = he[ce].value);
    for (ce = _e.length; ce--; ) {
      var le = te(_e[ce], null), se = _e[ce].slot;
      se ? ae[se] = y$1(u$1, { name: se }, le) : ie[ce] = le;
    }
    var oe = ne ? y$1(u$1, null, ie) : ie;
    return y$1(ne || ee.nodeName.toLowerCase(), ae, oe);
  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? E$1 : D$1)(this._vdom, this._root);
}
function s$1(re) {
  return re.replace(/-(\w)/g, function(te, ee) {
    return ee ? ee.toUpperCase() : "";
  });
}
function c$1(re, te, ee) {
  if (this._vdom) {
    var ne = {};
    ne[re] = ee = ee ?? void 0, ne[s$1(re)] = ee, this._vdom = F$2(this._vdom, ne), D$1(this._vdom, this._root);
  }
}
function l$1() {
  D$1(this._vdom = null, this._root);
}
function u$1(re, te) {
  var ee = this;
  return y$1("slot", r$1({}, re, { ref: function(ne) {
    ne ? (ee.ref = ne, ee._listener || (ee._listener = function(ie) {
      ie.stopPropagation(), ie.detail.context = te;
    }, ne.addEventListener("_preact", ee._listener))) : ee.ref.removeEventListener("_preact", ee._listener);
  } }));
}
function register(re, te, ee, ne) {
  function ie() {
    var ae = Reflect.construct(HTMLElement, [], ie);
    return ae._vdomComponent = re, ae._root = ne && ne.shadow ? ae.attachShadow({ mode: "open" }) : ae, ae;
  }
  return (ie.prototype = Object.create(HTMLElement.prototype)).constructor = ie, ie.prototype.connectedCallback = a$1, ie.prototype.attributeChangedCallback = c$1, ie.prototype.disconnectedCallback = l$1, ee = ee || re.observedAttributes || Object.keys(re.propTypes || {}), ie.observedAttributes = ee, ee.forEach(function(ae) {
    Object.defineProperty(ie.prototype, ae, { get: function() {
      return this._vdom.props[ae];
    }, set: function(ce) {
      this._vdom ? this.attributeChangedCallback(ae, null, ce) : (this._props || (this._props = {}), this._props[ae] = ce, this.connectedCallback());
      var he = typeof ce;
      ce != null && he !== "string" && he !== "boolean" && he !== "number" || this.setAttribute(ae, ce);
    } });
  }), customElements.define(te || re.tagName || re.displayName || re.name, ie);
}
var commonjsGlobal$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(re) {
  return re && re.__esModule && Object.prototype.hasOwnProperty.call(re, "default") ? re.default : re;
}
var loglevel = { exports: {} };
(function(re) {
  (function(te, ee) {
    re.exports ? re.exports = ee() : te.log = ee();
  })(commonjsGlobal$1, function() {
    var te = function() {
    }, ee = "undefined", ne = typeof window !== ee && typeof window.navigator !== ee && /Trident\/|MSIE /.test(window.navigator.userAgent), ie = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    function ae(me, pe) {
      var fe = me[pe];
      if (typeof fe.bind == "function")
        return fe.bind(me);
      try {
        return Function.prototype.bind.call(fe, me);
      } catch {
        return function() {
          return Function.prototype.apply.apply(fe, [me, arguments]);
        };
      }
    }
    function ce() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function he(me) {
      return me === "debug" && (me = "log"), typeof console === ee ? !1 : me === "trace" && ne ? ce : console[me] !== void 0 ? ae(console, me) : console.log !== void 0 ? ae(console, "log") : te;
    }
    function _e(me, pe) {
      for (var fe = 0; fe < ie.length; fe++) {
        var ge = ie[fe];
        this[ge] = fe < me ? te : this.methodFactory(ge, me, pe);
      }
      this.log = this.debug;
    }
    function le(me, pe, fe) {
      return function() {
        typeof console !== ee && (_e.call(this, pe, fe), this[me].apply(this, arguments));
      };
    }
    function se(me, pe, fe) {
      return he(me) || le.apply(this, arguments);
    }
    function oe(me, pe, fe) {
      var ge = this, ye;
      pe = pe ?? "WARN";
      var $e = "loglevel";
      typeof me == "string" ? $e += ":" + me : typeof me == "symbol" && ($e = void 0);
      function Se(Ee) {
        var we = (ie[Ee] || "silent").toUpperCase();
        if (!(typeof window === ee || !$e)) {
          try {
            window.localStorage[$e] = we;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent($e) + "=" + we + ";";
          } catch {
          }
        }
      }
      function Ce() {
        var Ee;
        if (!(typeof window === ee || !$e)) {
          try {
            Ee = window.localStorage[$e];
          } catch {
          }
          if (typeof Ee === ee)
            try {
              var we = window.document.cookie, Pe = we.indexOf(
                encodeURIComponent($e) + "="
              );
              Pe !== -1 && (Ee = /^([^;]+)/.exec(we.slice(Pe))[1]);
            } catch {
            }
          return ge.levels[Ee] === void 0 && (Ee = void 0), Ee;
        }
      }
      function Ie() {
        if (!(typeof window === ee || !$e)) {
          try {
            window.localStorage.removeItem($e);
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent($e) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      ge.name = me, ge.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, ge.methodFactory = fe || se, ge.getLevel = function() {
        return ye;
      }, ge.setLevel = function(Ee, we) {
        if (typeof Ee == "string" && ge.levels[Ee.toUpperCase()] !== void 0 && (Ee = ge.levels[Ee.toUpperCase()]), typeof Ee == "number" && Ee >= 0 && Ee <= ge.levels.SILENT) {
          if (ye = Ee, we !== !1 && Se(Ee), _e.call(ge, Ee, me), typeof console === ee && Ee < ge.levels.SILENT)
            return "No console available for logging";
        } else
          throw "log.setLevel() called with invalid level: " + Ee;
      }, ge.setDefaultLevel = function(Ee) {
        pe = Ee, Ce() || ge.setLevel(Ee, !1);
      }, ge.resetLevel = function() {
        ge.setLevel(pe, !1), Ie();
      }, ge.enableAll = function(Ee) {
        ge.setLevel(ge.levels.TRACE, Ee);
      }, ge.disableAll = function(Ee) {
        ge.setLevel(ge.levels.SILENT, Ee);
      };
      var Te = Ce();
      Te == null && (Te = pe), ge.setLevel(Te, !1);
    }
    var ue = new oe(), be = {};
    ue.getLogger = function(pe) {
      if (typeof pe != "symbol" && typeof pe != "string" || pe === "")
        throw new TypeError("You must supply a name when creating a logger.");
      var fe = be[pe];
      return fe || (fe = be[pe] = new oe(
        pe,
        ue.getLevel(),
        ue.methodFactory
      )), fe;
    };
    var ve = typeof window !== ee ? window.log : void 0;
    return ue.noConflict = function() {
      return typeof window !== ee && window.log === ue && (window.log = ve), ue;
    }, ue.getLoggers = function() {
      return be;
    }, ue.default = ue, ue;
  });
})(loglevel);
var loglevelExports = loglevel.exports;
const log$j = loglevelExports.getLogger("EventEmitter");
let EventEmitter$1 = class {
  constructor() {
    Et(this, "listeners", []);
  }
  addEventListener(te) {
    if (!this.listeners.includes(te))
      this.listeners.push(te);
    else
      throw new Error(`Listener ${te} already registered`);
  }
  removeEventListener(te) {
    const ee = this.listeners;
    ee.includes(te) ? this.listeners = ee.filter((ne) => ne !== te) : log$j.warn(`Listener ${te} was not registered`);
  }
  fireEvent(te) {
    this.listeners.forEach((ee) => {
      try {
        ee(te);
      } catch (ne) {
        log$j.error("Error invoking listener", ee, "for event", te, "error", ne);
      }
    });
  }
};
const DEFAULT_FEEDBACK_URL = "https://feedback.redbull.com/hc/en-us/requests/new", RBUP_FALLBACK_POSTER_IMAGE = "https://player-images.redbull.com/image/upload/{op}/placeholder.jpg", SSDM_SERVER_URL_PRODUCTION = "https://api-player.redbull.com", SSDM_SERVER_URL_STAGING = "https://api-player-staging.redbull.com";
function calculateSsdmUrl(re, te) {
  if (te && !isNaN(te))
    return `https://rbup-datamanager-pr-${te}.herokuapp.com`;
  switch (re) {
    case "PRODUCTION":
      return SSDM_SERVER_URL_PRODUCTION;
    case "STAGING":
      return SSDM_SERVER_URL_STAGING;
    default:
      throw new Error("unknown server environment");
  }
}
loglevelExports.getLogger("fetchUserLocation");
function addLeadingZero(re) {
  return re < 0 ? `${re}` : re < 10 ? `0${re}` : `${re}`;
}
const DEFAULT_SEEK_SKIP_SECONDS = 10, AspectRatios = ["16:9", "4:5", "4:3", "2:3", "2:1", "1:1", "9:16"], RBUP_VIDEO_DOM_EVENT_TYPE = "rbup-video-core", RBUP_AUDIO_DOM_EVENT_TYPE = "rbup-audio-core", publicPlayerEventTypes = [
  "adFinished",
  "adSkipped",
  "beforePlay",
  "loaded",
  "muted",
  "paused",
  "play",
  "playbackFinished",
  "seeking",
  "timeChanged",
  "timeshifting",
  "unmuted",
  "nextUpCancelled",
  "nextUpDisplayed",
  "nextUpTimeout",
  "nextUpTriggered",
  "podcastTitleClick"
], KEYCODE_ARROW_RIGHT = "ArrowRight", KEYCODE_ARROW_LEFT = "ArrowLeft", KEYCODE_ARROW_DOWN = "ArrowDown", KEYCODE_ARROW_UP = "ArrowUp", KEYCODE_SPACE = " ", KEYCODE_ESC = "Escape", KEYCODE_ENTER = "Enter", KEYCODE_B = "b", KEYCODE_F = "f", KEYCODE_I = "i", KEYCODE_K = "k", KEYCODE_M = "m", KEYCODE_N = "n", KEYCODE_P = "p", KEYCODE_R = "r", KEYCODE_0 = "0", log$i = loglevelExports.getLogger("AspectRatioUtils"), defaultExpectRatio = "16:9", aspectRatioRegex = new RegExp("^(\\d*):(\\d*)$"), maxWidthForLandscapeAspectRatio = "100%", maxWidthForPortraitAspectRatio = "400px";
function getMaxWidthForAspectRatio(re) {
  switch (re) {
    case "4:5":
    case "2:3":
    case "1:1":
    case "9:16":
      return maxWidthForPortraitAspectRatio;
    case "16:9":
    case "4:3":
    case "2:1":
      return maxWidthForLandscapeAspectRatio;
    default:
      return log$i.error("unexpected aspect ratio", re), maxWidthForLandscapeAspectRatio;
  }
}
function validateGivenAspectRatio(re) {
  return re && aspectRatioRegex.exec(re) && isAspectRatio(re) ? re : defaultExpectRatio;
}
function isAspectRatio(re) {
  return AspectRatios.includes(re);
}
function transformAspectRatioForCss(re) {
  return re.replace(":", "/");
}
function calcValueOfAspectRatio(re) {
  const [te, ee] = re.split(":").map((ne) => Number.parseInt(ne, 10));
  return te / ee;
}
const Breakpoint = {
  small: 540,
  medium: 650,
  large: 1e3,
  xLarge: 1200,
  xxLarge: 1350
}, BREAKPOINTS = [
  Breakpoint.small,
  Breakpoint.medium,
  Breakpoint.large,
  Breakpoint.xLarge,
  Breakpoint.xxLarge
];
function calculateCachingHeaders(re) {
  if (re)
    return {
      "cache-control": "max-age=0"
    };
}
const imTransformation = (re) => `/im:i:${re}/`, imDelimiterTransformation = (re) => `/im:i:${re}?`, opTransformation = (re) => `/${re}/`, transformations = [
  { placeholder: "/im/", transformation: imTransformation },
  { placeholder: "/{im}/", transformation: imTransformation },
  { placeholder: "/{im}?", transformation: imDelimiterTransformation },
  { placeholder: "/{op}/", transformation: opTransformation }
], posterSizeWidths = [2560, 1920, 1280, 854, 640, 426, 320], mediaSessionSizeWidths = [512, 384, 256, 192, 128, 96];
function calculateMediaSessionSrcSet(re) {
  if (re !== void 0)
    return mediaSessionSizeWidths.map((te) => {
      const ee = te;
      return {
        src: getPosterUrlForWidthAndAspectRatio(re, te, 1),
        sizes: `${te}x${ee}`
      };
    });
}
function calculatePosterSrcSet(re, te = "16:9") {
  const ee = calcValueOfAspectRatio(te);
  if (transformations.some(({ placeholder: ie }) => re.includes(ie))) {
    const ie = posterSizeWidths.map((ae) => `${getPosterUrlForWidthAndAspectRatio(re, ae, ee)} ${ae}w`).join(", ");
    return {
      src: getPosterUrlForWidthAndAspectRatio(re, 1280, ee),
      srcSet: ie
    };
  }
  return { src: re };
}
function getPosterUrlForWidthAndAspectRatio(re, te, ee) {
  return transformations.reduce((ne, { placeholder: ie, transformation: ae }) => ne.replace(ie, ae(`c_fill,w_${te},ar_${ee},q_auto,g_auto,f_auto`)), re);
}
function getTouch(re) {
  return re.changedTouches.length >= 1 ? re.changedTouches[0] : void 0;
}
function getDetectedInteractionCoordinates(re) {
  var te, ee;
  return isTouchEvent(re) ? {
    clientX: ((te = getTouch(re)) == null ? void 0 : te.clientX) ?? 0,
    clientY: ((ee = getTouch(re)) == null ? void 0 : ee.clientY) ?? 0
  } : {
    clientX: re.clientX,
    clientY: re.clientY
  };
}
function calculateRelativeCoordinates(re, te) {
  const ee = te.current;
  if (!ee)
    return;
  const ne = ee.getBoundingClientRect(), ie = getDetectedInteractionCoordinates(re), ae = ie.clientX - (ne.x + document.body.scrollLeft), ce = ie.clientY - (ne.y + document.body.scrollTop);
  return { x: ae, y: ce, elementBoundingRect: ne };
}
function extractPlaybackPositionInPercentFromEvent(re, te) {
  const ee = calculateRelativeCoordinates(re, te);
  if (ee) {
    const ne = ee.elementBoundingRect.width, ie = ee.x >= 0, ae = ee.x <= ne, ce = ie ? ee.x : 0, he = ae ? ne : ee.x;
    return roundPlaybackPercentage(ce / he);
  }
}
function isTouchEvent(re) {
  return re.type.includes("touch");
}
function getBrowserLanguage() {
  return window.navigator.language ? window.navigator.language.split("-")[0] : "";
}
function getFormattedTimeString(re) {
  const te = Math.floor(re / 3600), ee = Math.floor(re / 60) - te * 60, ne = Math.floor(re) % 60;
  return te < 1 ? `${addLeadingZero(ee)}:${addLeadingZero(ne)}` : `${addLeadingZero(te)}:${addLeadingZero(ee)}:${addLeadingZero(ne)}`;
}
function getThemeCSSVariables(re) {
  let te = {};
  return re != null && re.fontFamily && (te = {
    ...te,
    "--rbup-font-family": re.fontFamily
  }), re != null && re.componentFontFamily && (te = {
    ...te,
    "--rbup-component-font-family": re.componentFontFamily
  }), re != null && re.primaryColor && (te = {
    ...te,
    "--rbup-primary-color": re.primaryColor,
    "--rbup-play-button-background-color": re.primaryColor,
    "--rbup-play-button-background-hover-color": re.primaryColorHover ?? re.primaryColor
  }), re != null && re.lineHeight && (te = {
    ...te,
    "--rbup-text-line-height": re.lineHeight
  }), re != null && re.containerBackgroundColor && (te = {
    ...te,
    "--rbup-container16x9-background-color": re.containerBackgroundColor
  }), te;
}
function handlePlayPauseToggle(re, te) {
  switch (re) {
    case "ENDED":
    case "BUFFERING":
      return;
    case "PLAYING":
      te == null || te.pause();
      break;
    case "PAUSED":
    case "IDLE":
      te == null || te.play();
      break;
  }
}
function getPositionFromEvent(re) {
  const { pageX: te, pageY: ee } = "touches" in re ? re.touches[0] : re;
  return {
    x: te,
    y: ee
  };
}
function hasPositionMoved(re, te) {
  const ee = te.x - re.x, ne = te.y - re.y;
  return ee !== 0 && ne !== 0;
}
function isMobileDevice() {
  return /(?:iPhone|iPad|iPod|Android)/.test(window.navigator.userAgent) ? !0 : window.navigator.maxTouchPoints >= 3;
}
const MouseButton = {
  primary: 0,
  secondary: 1,
  auxiliary: 2,
  back: 3
}, PointerTypes = {
  mouse: "mouse",
  touch: "touch"
};
function isLeftClick(re) {
  return isMouse(re) && re.button === MouseButton.primary;
}
function isMouse(re) {
  return re.pointerType === PointerTypes.mouse;
}
function isTouch(re) {
  return re.pointerType === PointerTypes.touch;
}
function roundPlaybackPercentage(re) {
  return roundNumber(re, 5);
}
function roundPlaybackSec(re) {
  return roundNumber(re, 2);
}
function roundNumber(re, te) {
  const ee = Math.pow(10, te);
  return Math.round(re * ee) / ee;
}
function eqSet(re, te) {
  if (re.size !== te.size)
    return !1;
  for (const ee of re)
    if (!te.has(ee))
      return !1;
  return !0;
}
function createControllablePromise() {
  let re, te;
  const ee = new Promise((ne, ie) => {
    re = ne, te = ie;
  });
  return Object.assign(ee, {
    resolve: (ne) => re(ne),
    reject: (ne) => te(ne)
  });
}
function isNotNullOrUndefined(re) {
  return re != null;
}
function resolveErrorMessageFromUnknown(re) {
  return isObject$1(re) && re.hasOwnProperty("message") ? re.message : `Unknown error ${re == null ? void 0 : re.toString()}`;
}
function isObject$1(re) {
  return !!re && typeof re == "object";
}
function deepEqual(re, te) {
  if (re === te)
    return !0;
  if (!isObject(re) || !isObject(te) || Object.keys(re).length !== Object.keys(te).length)
    return !1;
  for (const ee in re)
    if (te.hasOwnProperty(ee)) {
      if (!deepEqual(re[ee], te[ee]))
        return !1;
    } else
      return !1;
  return !0;
}
function isObject(re) {
  return !!re && typeof re == "object";
}
const tagId = "rbup-video-cosmos-font-injection";
function injectCosmosFontIntoHeader(re) {
  if (!alreadyInjected()) {
    const te = document.createElement("style");
    te.id = tagId, te.innerHTML = re, document.getElementsByTagName("head")[0].appendChild(te);
  }
}
function alreadyInjected() {
  return document.getElementById(tagId) !== null;
}
function dispatchNextUpPlayerEvent(re, te) {
  const { playerId: ee } = te;
  switch (re) {
    case "CANCELLED_BY_USER_INTERACTION":
      te.dispatchPlayerEvent({
        type: "nextUpCancelled",
        playerId: ee,
        issuer: "USER"
      });
      break;
    case "TRIGGERED_BY_USER_INTERACTION":
      te.dispatchPlayerEvent({
        type: "nextUpClicked",
        playerId: ee,
        issuer: "USER"
      }), te.dispatchPlayerEvent({
        type: "nextUpTriggered",
        playerId: ee,
        issuer: "USER"
      });
      break;
    case "TRIGGERED_AUTOMATICALLY":
      te.dispatchPlayerEvent({
        type: "nextUpTimeout",
        playerId: ee,
        issuer: "AUTOMATICALLY"
      }), te.dispatchPlayerEvent({
        type: "nextUpTriggered",
        playerId: ee,
        issuer: "AUTOMATICALLY"
      });
      break;
    case "CANCELLED_BY_REPLAY":
      te.dispatchPlayerEvent({
        type: "nextUpCancelled",
        playerId: ee,
        issuer: "CONTEXTUAL"
      });
      break;
    case "DISPLAYED":
      te.dispatchPlayerEvent({
        type: "nextUpDisplayed",
        playerId: ee,
        issuer: "CONTEXTUAL"
      });
      break;
  }
}
function removeNoLongerExistingAttributes(re, te, ee) {
  const ne = re.getAttributeNames(), ie = Object.keys(te);
  for (const ae of ne)
    ae !== "id" && !ie.includes(ae) && (ee.debug("removing excess attribute from web component", ae), re.removeAttribute(ae));
}
function deleteUndefinedValues(re) {
  for (const te in re)
    re[te] === void 0 && delete re[te];
}
const stripOffLocaleRegexp = /(?<masterId>rrn:content:.*):(?<locale>[a-z]{2}-[A-Z]{2,3})$/;
function stripOffLocaleFromCrepoId(re) {
  var ee;
  if (!re)
    throw new Error(`unexpected content id ${re}`);
  const te = stripOffLocaleRegexp.exec(re);
  if (!te) {
    if (isCrepoId(re))
      return re;
    throw new Error(`content id is not a rrn:content id ${re}`);
  }
  return ((ee = te.groups) == null ? void 0 : ee.masterId) ?? re;
}
function isCrepoId(re) {
  return re ? re.startsWith("rrn:content:") : !1;
}
function isIosDevice() {
  return /(?:iPhone|iPad|iPod)/.test(window.navigator.userAgent) ? !0 : window.navigator.maxTouchPoints >= 3;
}
function isLiveLinearResolver(re) {
  var te;
  return (re == null ? void 0 : re.getPlaybackMode()) === "LIVE" && ((te = re.getLiveVariant) == null ? void 0 : te.call(re)) === "LINEAR";
}
function isLiveDvrResolver(re) {
  var te;
  return (re == null ? void 0 : re.getPlaybackMode()) === "LIVE" && ((te = re.getLiveVariant) == null ? void 0 : te.call(re)) === "DVR";
}
function calculateFromSS(re) {
  const te = parseInt(re[0], 10);
  return isNaN(te) ? 0 : te;
}
function calculateFromMMSS(re) {
  const te = parseInt(re[1], 10), ee = parseInt(re[0], 10);
  return isNaN(te) || isNaN(ee) ? 0 : te + ee * 60;
}
function calculateFromHHMMSS(re) {
  const te = parseInt(re[2], 10), ee = parseInt(re[1], 10), ne = parseInt(re[0], 10);
  return isNaN(te) || isNaN(ee) || isNaN(ne) ? 0 : te + ee * 60 + ne * 60 * 60;
}
function convertTimeStringToSec(re) {
  const te = re.split(":");
  return te.length === 1 ? calculateFromSS(te) : te.length === 2 ? calculateFromMMSS(te) : te.length === 3 ? calculateFromHHMMSS(te) : 0;
}
const MIN_HD_HEIGHT = 720, HIGH_FRAMRATE_DISPLAY_THRESHOLD = 31;
function getVideoQualityLabel(re, te = 0) {
  const ee = te >= HIGH_FRAMRATE_DISPLAY_THRESHOLD ? `${re}p${te}` : `${re}p`;
  return re >= MIN_HD_HEIGHT ? `${ee} HD` : ee;
}
function isVideoDataAccessor(re) {
  return re.getPlayerType() === "VIDEO";
}
function formatPos(re) {
  if (!re)
    return "0";
  const te = re < 0, ee = Math.floor(Math.abs(re)), ne = String(ee);
  return te ? `-${ne}` : ne;
}
const eventMap = {
  adStarted: "playAd",
  playbackFinished: "eof",
  play: "play",
  paused: "pause",
  sourceUnloaded: "stop",
  posRelative: "posRelative",
  playInitial: "playInitial",
  seeking: "seek",
  timeshifting: "seek",
  pos: "pos",
  beforePlay: "init",
  loaded: "init",
  podcastTitleClick: "interaction",
  nextEpisodeTriggered: "interaction"
};
function EventActionResolver(re) {
  return eventMap[re];
}
function EventNameResolver(re, te) {
  const ee = re.toLowerCase(), ne = te.toLowerCase();
  return `${ee}_${ne}`;
}
function resolveEventName(re, te) {
  const ee = EventActionResolver(te);
  return ee ? EventNameResolver(re, ee) : "";
}
const log$h = loglevelExports.getLogger("TrackingService");
function validateVideoPos(re, te, ee) {
  return (re < 0 || re > te) && log$h.error(
    "videoPos",
    re,
    " exceeds bounds for reporting interval",
    te,
    "for event",
    ee
  ), Math.max(0, Math.min(te, Math.round(re)));
}
function getEofTrackingEvent(re, te, ee) {
  return {
    event: ee.trackingEventType,
    eventAction: "eof",
    event_name: resolveEventName(ee.playerType, "playbackFinished"),
    current_pos: formatPos(ee.playbackPosition),
    media_id: re.assetId,
    player_mode: ee.playerMode,
    video_audio_language: ee.audioLanguage,
    video_subtitles_language: ee.subtitleLanguage,
    video_stream_type: ee.videoStreamType,
    video_pos: validateVideoPos(ee.videoPos, te, "eof")
  };
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let re = 0; re < 256; ++re)
  byteToHex.push((re + 256).toString(16).slice(1));
function unsafeStringify(re, te = 0) {
  return (byteToHex[re[te + 0]] + byteToHex[re[te + 1]] + byteToHex[re[te + 2]] + byteToHex[re[te + 3]] + "-" + byteToHex[re[te + 4]] + byteToHex[re[te + 5]] + "-" + byteToHex[re[te + 6]] + byteToHex[re[te + 7]] + "-" + byteToHex[re[te + 8]] + byteToHex[re[te + 9]] + "-" + byteToHex[re[te + 10]] + byteToHex[re[te + 11]] + byteToHex[re[te + 12]] + byteToHex[re[te + 13]] + byteToHex[re[te + 14]] + byteToHex[re[te + 15]]).toLowerCase();
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = {
  randomUUID
};
function v4(re, te, ee) {
  if (native.randomUUID && !te && !re)
    return native.randomUUID();
  re = re || {};
  const ne = re.random || (re.rng || rng)();
  if (ne[6] = ne[6] & 15 | 64, ne[8] = ne[8] & 63 | 128, te) {
    ee = ee || 0;
    for (let ie = 0; ie < 16; ++ie)
      te[ee + ie] = ne[ie];
    return te;
  }
  return unsafeStringify(ne);
}
const CORE_VERSION = "19.42.0";
function calculateEmbedUrl(re) {
  const te = new URL(re);
  return `${te.protocol}//${te.host}${te.pathname}`;
}
function isVideoPlayerConfig(re) {
  return re.configurationType === "VIDEO";
}
function isVideoPlayerMetadata(re, te) {
  return isVideoPlayerConfig(re);
}
function isAudioPlayerMetadata(re, te) {
  return te ? !isVideoPlayerConfig(re) : !1;
}
function calculateTrackingHostname(re) {
  return new URL(re).host;
}
function calculateVideoTrackingInitEvent(re, te, ee, ne, ie, ae) {
  const ce = re.tracking.configs.googleAnalytics, he = ie.getPlaybackMode(), _e = (te == null ? void 0 : te.duration) ?? 0, le = calculateTrackingHostname(ee);
  return {
    ...ce.customInitAttributes,
    video_account_name: ce.accountName,
    brand: ce.brand,
    video_chapter: te == null ? void 0 : te.chapter,
    video_name: te == null ? void 0 : te.title,
    video_display_url: ee,
    environment: ne ? "on-site" : "off-site",
    event: "rbVideoTracking",
    eventAction: "init",
    event_name: "video_init",
    video_display_domain: le,
    video_stream: ae.isStream,
    video_autoplay: re.autoplay,
    video_label: te == null ? void 0 : te.label,
    video_label_group: te == null ? void 0 : te.labelGroup,
    media_asset_id: te == null ? void 0 : te.vin,
    media_id: re.assetId,
    device_platform: "web",
    video_player_id: ce.playerId,
    player_mode: ae.playerMode,
    property_name: ce.propertyName,
    site_type: "website",
    video_season: te == null ? void 0 : te.season,
    rb_source: ce.source,
    player_version: CORE_VERSION,
    video_asset_id: re.assetId,
    video_length: he === "LIVE" ? 0 : _e,
    video_play_id: v4(),
    video_stream_type: ae.videoStreamType
  };
}
function calculateAudioTrackingInitEvent(re, te, ee, ne, ie, ae) {
  const ce = re.tracking.configs.googleAnalytics, he = ee.getDurationInSec(), _e = calculateTrackingHostname(ne);
  return {
    ...ce.customInitAttributes,
    video_account_name: ce.accountName,
    brand: ce.brand,
    video_name: te == null ? void 0 : te.title,
    video_display_url: ne,
    environment: ie ? "on-site" : "off-site",
    event: "rbAudioTracking",
    eventAction: "init",
    event_name: "audio_init",
    video_display_domain: _e,
    video_stream: ae.isStream,
    video_autoplay: !1,
    media_asset_id: te == null ? void 0 : te.vin,
    media_id: re.assetId,
    device_platform: "web",
    video_player_id: ce.playerId,
    player_mode: ae.playerMode,
    property_name: ce.propertyName,
    site_type: "website",
    rb_source: ce.source,
    spreaker_id: te == null ? void 0 : te.spreakerId,
    megaphone_episode_id: te == null ? void 0 : te.megaphoneEpisodeId,
    megaphone_network_id: te == null ? void 0 : te.megaphoneNetworkId,
    megaphone_show_id: te == null ? void 0 : te.megaphoneShowId,
    player_version: CORE_VERSION,
    video_asset_id: re.assetId,
    video_chapter: te == null ? void 0 : te.chapter,
    video_label: te == null ? void 0 : te.label,
    video_label_group: te == null ? void 0 : te.labelGroup,
    video_length: isNaN(he) ? (te == null ? void 0 : te.duration) ?? 0 : he,
    video_play_id: v4(),
    video_season: te == null ? void 0 : te.season,
    video_stream_type: ae.videoStreamType
  };
}
function getFinalEmbedUrl() {
  return window.self !== window.top ? document.referrer : window.location.href;
}
function getInitTrackingEvent(re, te, ee, ne, ie) {
  const ae = re.tracking.configs.googleAnalytics.overrideEmbedUrl ?? getFinalEmbedUrl(), ce = calculateEmbedUrl(ae);
  if (isVideoPlayerConfig(re) && (isVideoPlayerMetadata(re) || !te))
    return calculateVideoTrackingInitEvent(re, te, ce, ne, ee, ie);
  if (!isVideoPlayerConfig(re) && (isAudioPlayerMetadata(re, te) || !te))
    return calculateAudioTrackingInitEvent(re, te, ee, ce, ne, ie);
  throw new Error("unexpected player config");
}
function getNextEpisodeTrackingEvent(re, te, ee, ne) {
  const ie = te === "USER" ? "Click" : "Auto";
  return {
    event: "rbAudioTracking",
    event_name: resolveEventName(ne.playerType, "nextEpisodeTriggered"),
    video_interaction: {
      value: "Next Up",
      method: ie,
      video_name: re.title,
      media_id: ee,
      device_platform: "web",
      widget_type: "Audio Playlist"
    }
  };
}
function getNextUpToastTrackingEvent(re, te, ee) {
  return {
    event: "rbVideoTracking",
    event_name: "video_interaction",
    video_interaction: {
      value: "Next Up",
      method: te,
      video_name: re.title,
      media_id: ee,
      device_platform: "web",
      widget_type: "Next Up Bar"
    }
  };
}
function getPauseTrackingEvent(re, te, ee) {
  return {
    current_pos: formatPos(ee.playbackPosition),
    event: ee.trackingEventType,
    eventAction: "pause",
    event_name: resolveEventName(ee.playerType, "paused"),
    video_audio_language: ee.audioLanguage,
    video_subtitles_language: ee.subtitleLanguage,
    media_id: re.assetId,
    player_mode: ee.playerMode,
    video_stream_type: ee.videoStreamType,
    video_pos: validateVideoPos(ee.videoPos, te, "pause")
  };
}
function mapAdType(re) {
  switch (re) {
    case "PRE_ROLL":
      return "pre";
    case "MID_ROLL":
      return "mid";
    case "POST_ROLL":
      return "post";
    default:
      throw new Error(`unexpected ad type ${re}`);
  }
}
const VALUE_NOT_AVAILABLE = "not available";
function getAdLength(re) {
  return re > 1 ? re : VALUE_NOT_AVAILABLE;
}
function getAdPos(re, te) {
  return re === "pre" ? 0 : te;
}
function getPlayAdTrackingEvent(re, te, ee, ne, ie) {
  const ae = mapAdType(re.adType);
  return {
    ad_length: getAdLength(re.duration),
    ad_plays: 1,
    ad_position: getAdPos(ae, ee.getLastMainMediaPositionInSec()),
    ad_type: ae,
    current_pos: formatPos(ie.playbackPosition),
    event: ie.trackingEventType,
    video_audio_language: void 0,
    video_subtitles_language: void 0,
    eventAction: "playAd",
    event_name: resolveEventName(ie.playerType, "adStarted"),
    media_id: te.assetId,
    video_stream_type: ie.videoStreamType,
    player_mode: ie.playerMode,
    video_pos: validateVideoPos(ie.videoPos, ne, "playAd")
  };
}
function getPlayInitialTrackingEvent(re, te) {
  return {
    video_audio_language: te.audioLanguage,
    current_pos: formatPos(te.playbackPosition),
    event: te.trackingEventType,
    eventAction: "playInitial",
    event_name: resolveEventName(te.playerType, "playInitial"),
    media_id: re.assetId,
    player_mode: te.playerMode,
    video_subtitles_language: te.subtitleLanguage,
    video_plays: 1,
    video_stream_type: te.videoStreamType,
    video_pos: 0
  };
}
function getPlayTrackingEvent(re, te, ee) {
  return {
    current_pos: formatPos(ee.playbackPosition),
    media_id: re.assetId,
    player_mode: ee.playerMode,
    event: ee.trackingEventType,
    eventAction: "play",
    video_audio_language: ee.audioLanguage,
    video_subtitles_language: ee.subtitleLanguage,
    video_stream_type: ee.videoStreamType,
    event_name: resolveEventName(ee.playerType, "play"),
    video_pos: validateVideoPos(ee.videoPos, te, "play")
  };
}
function getPodcastTitleTrackingEvent(re, te, ee, ne) {
  return {
    event: "rbAudioTracking",
    event_name: resolveEventName(ne.playerType, "podcastTitleClick"),
    video_interaction: {
      value: te,
      video_name: re.title,
      media_id: ee,
      device_platform: "web",
      widget_type: "Podcast player::inline"
    }
  };
}
function getPosRelativeTrackingEvent(re, te, ee, ne) {
  return {
    eventAction: "posRelative",
    event: ne.trackingEventType,
    event_name: resolveEventName(ne.playerType, "posRelative"),
    current_pos: formatPos(ne.playbackPosition),
    video_audio_language: ne.audioLanguage,
    video_subtitles_language: ne.subtitleLanguage,
    player_mode: ne.playerMode,
    video_posrelative: te,
    media_id: re.assetId,
    video_stream_type: ne.videoStreamType,
    video_pos: validateVideoPos(ne.videoPos, ee, "posRelative")
  };
}
function getPosTrackingEvent(re, te, ee) {
  return {
    eventAction: "pos",
    event_name: resolveEventName(ee.playerType, "pos"),
    event: ee.trackingEventType,
    video_audio_language: ee.audioLanguage,
    video_subtitles_language: ee.subtitleLanguage,
    current_pos: formatPos(ee.playbackPosition),
    player_mode: ee.playerMode,
    media_id: re.assetId,
    video_stream_type: ee.videoStreamType,
    video_pos: validateVideoPos(ee.videoPos, te, "pos")
  };
}
function getSeekTrackingEvent(re, te, ee) {
  return {
    eventAction: "seek",
    event_name: resolveEventName(ee.playerType, "seeking"),
    event: ee.trackingEventType,
    current_pos: formatPos(ee.playbackPosition),
    player_mode: ee.playerMode,
    media_id: re.assetId,
    video_audio_language: ee.audioLanguage,
    video_subtitles_language: ee.subtitleLanguage,
    video_stream_type: ee.videoStreamType,
    video_pos: validateVideoPos(ee.videoPos, te, "seek")
  };
}
const stopEventAction = "stop";
function getStopTrackingEvent(re, te, ee, ne) {
  if (!ee)
    throw new Error("unexpectedly dont have player config");
  if (!ne)
    throw new Error("unexpectedly dont have player data accessor");
  return {
    current_pos: formatPos(te.playbackPosition),
    event: te.trackingEventType,
    eventAction: stopEventAction,
    event_name: resolveEventName(te.playerType, "sourceUnloaded"),
    media_id: ee.assetId,
    video_audio_language: te.audioLanguage,
    video_subtitles_language: te.subtitleLanguage,
    player_mode: te.playerMode,
    video_pos: validateVideoPos(te.videoPos, re, "stop"),
    video_stream_type: te.videoStreamType
  };
}
function isInitTrackingEvent(re) {
  return re.eventAction === "init";
}
function isUserInteractionTrackingEvent(re) {
  return re.event_name === "video_interaction";
}
function serializeValue(re) {
  return typeof re == "boolean" ? re.toString() : re;
}
function serializeEvent(re) {
  return isInitTrackingEvent(re) ? serializeInitEvent(re) : isUserInteractionTrackingEvent(re) ? serializeUserInteractionTrackingEvent(re) : serializeTrackingEvent(re);
}
const initEventAttributesAtRootLevel = [
  "event",
  "eventAction",
  "event_name",
  "player_mode",
  "video_stream_type"
];
function serializeInitEvent(re) {
  const te = {}, ee = {};
  for (const [ne, ie] of Object.entries(re))
    initEventAttributesAtRootLevel.includes(ne) ? te[ne] = ie : ee[ne] = serializeValue(ie), ne === "video_stream_type" && (ee[ne] = ie);
  return Object.keys(ee).length > 0 && (te.videos = { [re.media_id]: ee }), te;
}
function serializeUserInteractionTrackingEvent(re) {
  const te = {}, ee = {};
  te.event = re.event, te.event_name = re.event_name;
  for (const [ne, ie] of Object.entries(re.video_interaction))
    ee[ne] = serializeValue(ie);
  return te.video_interaction = ee, te;
}
function serializeTrackingEvent(re) {
  const te = {};
  for (const [ee, ne] of Object.entries(re))
    te[ee] = serializeValue(ne);
  return te;
}
function DataAccessorResolver(re) {
  if (!re)
    throw new Error("unexpectedly dont have player data accessor");
  return re;
}
function VideoAudioLanguageResolver(re) {
  if (!isVideoDataAccessor(re))
    return;
  const te = re.getAudioLanguage();
  return te || "und";
}
class EventAdapter {
  execute(te) {
    const { log: ee } = te, ne = this.resolveState(te);
    return ee == null || ee.debug(this.constructor.name, ne), ne;
  }
}
const Ht = class Ht extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "audioLanguage");
    Et(this, "coordinator");
    this.audioLanguage = Ht.UNDEFINED_AUDIO_LANGUAGE, this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ne = DataAccessorResolver(ee);
    return this.audioLanguage = VideoAudioLanguageResolver(ne), { audioLanguage: this.audioLanguage };
  }
};
Et(Ht, "UNDEFINED_AUDIO_LANGUAGE", "und");
let AudioLanguageAdapter = Ht;
class DurationAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "durationInSec");
    Et(this, "coordinator");
    this.durationInSec = 0, this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ie = DataAccessorResolver(ee).getMainMediaDurationInSec();
    return this.durationInSec = isNaN(ie) ? this.durationInSec : ie, { durationInSec: this.durationInSec };
  }
}
class HasInitialPlaybackAdapter extends EventAdapter {
  constructor() {
    super(...arguments);
    Et(this, "hadInitialPlayback", !1);
    Et(this, "sendingPlayInitial", () => {
      this.hadInitialPlayback = !0;
    });
  }
  resolveState(ee) {
    var _e, le, se;
    const ne = ((_e = ee.event) == null ? void 0 : _e.type) === "timeshifting", ie = ((le = ee.event) == null ? void 0 : le.type) === "timeChanged", ae = hasReachedPlaybackThreshold(
      ne,
      (se = ee.metaInfo) == null ? void 0 : se.playbackPosition
    ), ce = ie || ne;
    return {
      shouldSendInitialPlayback: this.calculateState(ae, ce),
      hadInitialPlayback: this.hadInitialPlayback,
      sendingPlayInitial: this.sendingPlayInitial
    };
  }
  calculateState(ee, ne) {
    return !!(ne && ee && !this.hadInitialPlayback);
  }
}
Et(HasInitialPlaybackAdapter, "PLAYBACK_THRESHOLD", 0.1);
function hasReachedPlaybackThreshold(re, te) {
  const ee = re ? 0 : HasInitialPlaybackAdapter.PLAYBACK_THRESHOLD;
  return typeof te == "number" && Math.abs(te) >= ee;
}
function VideoIsStreamResolver(re) {
  const { phasingEnabled: te, playbackMode: ee, isPlayerLoaded: ne } = re;
  return te ? !0 : ne ? ee === "LIVE" : !1;
}
class IsStreamAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "isStream", !1);
    Et(this, "coordinator");
    this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ne = DataAccessorResolver(ee), ie = this.coordinator.getPlayerConfiguration(), ae = ie && isVideoPlayerConfig(ie) ? ie.phasing : !1, ce = ne.getPlaybackMode(), he = ne.isPlayerLoaded();
    return this.isStream = VideoIsStreamResolver({ phasingEnabled: ae, playbackMode: ce, isPlayerLoaded: he }), { isStream: this.isStream };
  }
}
class BasePlaybackPositionAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "playbackPosition");
    Et(this, "coordinator");
    this.playbackPosition = 0, this.coordinator = ee;
  }
  resolveState(ee) {
    const { event: ne } = ee;
    if (!isPlayerEvent(ne))
      throw new Error("unexpectedly received non-player event");
    const ie = this.playbackPosition, ae = DataAccessorResolver(this.coordinator.getPlayerData());
    return isVideoDataAccessor(ae) && ae.isShowingAd() || (this.playbackPosition = this.resolvePlaybackPositionFromEvent(ne)), { lastPlaybackPosition: ie, playbackPosition: this.playbackPosition };
  }
  resolvePlaybackPositionFromEvent(ee) {
    return ee.type === "timeSkipped" ? ee.currentPlaybackTimeInSec : isEventWithTargetPosition(ee) && ee.issuer === "INITIAL" ? ee.targetPosition : isEventWithPosition(ee) ? ee.playbackPosition : this.playbackPosition;
  }
}
function isEventWithPosition(re) {
  return "playbackPosition" in re;
}
function isEventWithTargetPosition(re) {
  return "targetPosition" in re;
}
function isPlayerEvent(re) {
  return re !== void 0 && "playerId" in re;
}
async function reportClientError(re, te, ee) {
  const ne = `${calculateSsdmUrl(te)}/client-error`, ie = JSON.stringify({ message: re, params: ee, href: "location" in window && location.href });
  await fetch(ne, { body: ie, method: "POST", headers: { "content-type": "application/json" } });
}
class TimeCorrectionAdapter {
  constructor(te) {
    Et(this, "timeCorrection");
    Et(this, "coordinator");
    Et(this, "playbackPositionOfPauseOrPlayEvent");
    this.coordinator = te, this.timeCorrection = 0, this.playbackPositionOfPauseOrPlayEvent = 0;
  }
  resolveState({ event: te, videoStartTimestamp: ee, lastPlaybackPosition: ne }) {
    const ie = this.coordinator.getPlayerData(), ae = DataAccessorResolver(ie), ce = isLiveLinearResolver(ae), he = isVideoDataAccessor(ae) && ae.isShowingAd();
    switch (te.type) {
      case "timeshifting":
        this.playbackPositionOfPauseOrPlayEvent = 0;
        break;
      case "timeshiftingDone":
        this.handleTimeshiftingDoneEvent(te, ce, ee, ne);
        break;
      case "timeSkipped":
        this.handleTimeSkippedEvent(te, he);
        break;
      case "playing":
        this.handlePlayingEvent(te, ne);
        break;
      case "play":
        this.handlePlayEvent(te);
        break;
      case "paused":
        this.handlePausedEvent(te);
        break;
    }
    return this.handleRestart(te, he), { timeCorrection: this.timeCorrection };
  }
  handlePlayEvent(te) {
    if (this.playbackPositionOfPauseOrPlayEvent) {
      const ee = te.playbackPosition - this.playbackPositionOfPauseOrPlayEvent;
      ee > 1 && (this.timeCorrection += ee, this.playbackPositionOfPauseOrPlayEvent = te.playbackPosition);
    } else
      this.playbackPositionOfPauseOrPlayEvent = te.playbackPosition;
  }
  handlePlayingEvent(te, ee) {
    if (ee !== 0 && this.playbackPositionOfPauseOrPlayEvent) {
      const ne = te.playbackPosition - this.playbackPositionOfPauseOrPlayEvent;
      this.timeCorrection += ne;
    }
    this.playbackPositionOfPauseOrPlayEvent = 0;
  }
  handleTimeSkippedEvent(te, ee) {
    if (!ee) {
      const ne = te.currentPlaybackTimeInSec - te.previousPlaybackTimeInSec;
      this.timeCorrection += ne;
    }
    reportTimeskipped(this.coordinator, te.previousPlaybackTimeInSec, te.currentPlaybackTimeInSec);
  }
  handleTimeshiftingDoneEvent(te, ee, ne, ie) {
    if (ee) {
      const ae = te.playbackPosition - ne;
      this.timeCorrection = ae - ie;
    }
  }
  handlePausedEvent(te) {
    te.playbackPosition && (this.playbackPositionOfPauseOrPlayEvent = te.playbackPosition);
  }
  handleRestart(te, ee) {
    ee || "issuer" in te && te.issuer === "RESTART" && (this.timeCorrection = 0);
  }
}
function reportTimeskipped(re, te, ee) {
  var ie;
  const ne = (ie = re.getPlayerConfiguration()) == null ? void 0 : ie.environment;
  ne && reportClientError("TimeSkippedEvent detected", ne, {
    timeSkipStart: te,
    timeSkipEnd: ee
  });
}
class LivePlaybackPositionAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "timeCorrectionAdapter");
    Et(this, "basePlaybackPositionAdapter");
    Et(this, "videoStartTimestamp");
    Et(this, "correctedPlaybackPosition");
    Et(this, "playbackPosition");
    Et(this, "coordinator");
    this.coordinator = ee, this.timeCorrectionAdapter = new TimeCorrectionAdapter(ee), this.basePlaybackPositionAdapter = new BasePlaybackPositionAdapter(ee), this.videoStartTimestamp = 0, this.correctedPlaybackPosition = 0, this.playbackPosition = 0;
  }
  resolveState(ee) {
    const ne = this.correctedPlaybackPosition, { event: ie } = ee, ae = this.coordinator.getPlayerData(), ce = DataAccessorResolver(ae);
    if (!isPlayerEvent(ie))
      throw new Error("unexpectedly received non-player event");
    const { playbackPosition: he } = this.basePlaybackPositionAdapter.resolveState(ee), { timeCorrection: _e } = this.timeCorrectionAdapter.resolveState({
      event: ie,
      lastPlaybackPosition: this.playbackPosition,
      videoStartTimestamp: this.videoStartTimestamp
    }), le = isVideoDataAccessor(ce) && ce.isShowingAd(), se = this.handleEvent(ie, le);
    return this.playbackPosition = se ?? he, this.correctedPlaybackPosition = this.calculateCorrectedPlaybackPosition(this.playbackPosition, _e), { lastPlaybackPosition: ne, playbackPosition: this.correctedPlaybackPosition };
  }
  handleEvent(ee, ne) {
    switch (ee.type) {
      case "timeshifting":
      case "playing":
      case "timeChanged":
        if (!ne)
          return this.getInitialPlaybackPosition(ee);
        break;
      case "timeshiftingDone":
        return this.handleTimeshiftingDone(ee);
      case "timeSkipped":
        if (!ne)
          return ee.currentPlaybackTimeInSec;
        break;
    }
  }
  getInitialPlaybackPosition(ee) {
    if (this.videoStartTimestamp === 0)
      return this.videoStartTimestamp = ee.playbackPosition, ee.playbackPosition;
  }
  handleTimeshiftingDone(ee) {
    return ee.playbackPosition;
  }
  calculateCorrectedPlaybackPosition(ee, ne) {
    return ee - (this.videoStartTimestamp + ne);
  }
}
class UnresolvedPlaybackPositionAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "playbackPositionAdapter");
    Et(this, "lastState", {});
    DataAccessorResolver(ee.getPlayerData()).getPlaybackMode() === "LIVE" ? this.playbackPositionAdapter = new LivePlaybackPositionAdapter(ee) : this.playbackPositionAdapter = new BasePlaybackPositionAdapter(ee);
  }
  resolveState(ee) {
    return ee != null && ee.event && (this.lastState = this.playbackPositionAdapter.resolveState(ee)), this.lastState;
  }
}
function PlayerModeResolver(re, te) {
  if (!re)
    throw new Error("unexpectedly dont have player configuration");
  if (isVideoDataAccessor(te)) {
    if (te.isInFullscreenMode())
      return "fullscreen";
    if (te.isInPictureInPictureMode())
      return "picture-in-picture";
    if (te.isPlayingVideoViaAirPlay())
      return "airplay";
  }
  return re.tracking.configs.googleAnalytics.defaultPlayerMode;
}
class PlayerModeAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "playerMode", "standard");
    Et(this, "coordinator");
    this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ne = DataAccessorResolver(ee), ie = this.coordinator.getPlayerConfiguration();
    return this.playerMode = PlayerModeResolver(ie, ne), { playerMode: this.playerMode };
  }
}
class PlayerTypeAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "coordinator");
    this.coordinator = ee;
  }
  resolveState() {
    var ne;
    const ee = (ne = this.coordinator.getPlayerData()) == null ? void 0 : ne.getPlayerType();
    if (!ee)
      throw new Error("unexpectedly got no player type");
    return { playerType: ee };
  }
}
function VideoSubtitleLanguageResolver(re) {
  if (!isVideoDataAccessor(re))
    return;
  const te = re.getSubtitleTrackLanguage();
  if (te)
    return te;
}
class SubtitleLanguageAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "subtitleLanguage");
    Et(this, "coordinator");
    this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ne = DataAccessorResolver(ee);
    return this.subtitleLanguage = VideoSubtitleLanguageResolver(ne), { subtitleLanguage: this.subtitleLanguage };
  }
}
function TrackingEventTypeResolver(re) {
  switch (re.getPlayerType()) {
    case "VIDEO":
      return "rbVideoTracking";
    case "AUDIO":
      return "rbAudioTracking";
    default:
      throw new Error(`unknown player type ${re.getPlayerType()}`);
  }
}
class TrackingEventTypeAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "trackingEventType");
    Et(this, "coordinator");
    this.coordinator = ee;
  }
  resolveState() {
    if (!this.trackingEventType) {
      const ee = this.coordinator.getPlayerData(), ne = DataAccessorResolver(ee);
      this.trackingEventType = TrackingEventTypeResolver(ne);
    }
    return { trackingEventType: this.trackingEventType };
  }
}
class VideoPosAdapter extends EventAdapter {
  constructor() {
    super(...arguments);
    Et(this, "storedPlaybackPosition");
    Et(this, "storeVideoPos", (ee) => {
      const ne = ensureIsNumber(ee);
      this.storedPlaybackPosition = ne;
    });
  }
  resolveState(ee) {
    const { metaInfo: ne } = ee, ie = ensureIsNumber(ne == null ? void 0 : ne.playbackPosition), ae = this.storedPlaybackPosition ?? ie, ce = ie - ae;
    return {
      videoPos: Math.max(0, ce),
      storeVideoPos: this.storeVideoPos
    };
  }
}
function ensureIsNumber(re) {
  return typeof re == "number" ? Math.floor(re) : 0;
}
function VideoStreamTypeResolver(re) {
  if (!isVideoDataAccessor(re))
    return "vod";
  const te = re.getPlaybackMode();
  switch (te) {
    case "LIVE":
      return re.getLiveVariant() === "LINEAR" ? "linear" : re.getTimeShiftInSec() >= -1 ? "live" : "vod";
    case "VOD":
      return "vod";
    default:
      throw new Error(`unexpected playback mode ${te}`);
  }
}
class VideoStreamTypeAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "videoStreamType");
    Et(this, "coordinator");
    this.videoStreamType = "vod", this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ne = DataAccessorResolver(ee);
    return this.videoStreamType = VideoStreamTypeResolver(ne), { videoStreamType: this.videoStreamType };
  }
}
const ADAPTER_LIST = [
  AudioLanguageAdapter,
  DurationAdapter,
  IsStreamAdapter,
  PlayerModeAdapter,
  PlayerTypeAdapter,
  SubtitleLanguageAdapter,
  TrackingEventTypeAdapter,
  VideoStreamTypeAdapter,
  UnresolvedPlaybackPositionAdapter,
  VideoPosAdapter,
  HasInitialPlaybackAdapter
], getAdapterList = () => ADAPTER_LIST, log$g = loglevelExports.getLogger("TrackingServiceStateLayer");
class TrackingServiceStateLayer {
  constructor(te) {
    Et(this, "instantiatedAdapters");
    this.instantiatedAdapters = getAdapterList().map((ee) => new ee(te));
  }
  getUpdatedState(te) {
    const ee = this.instantiatedAdapters.reduce((ne, ie) => ({ ...ne, ...ie.execute({ event: te, metaInfo: { ...ne }, log: log$g }) }), {});
    return log$g.info(`Resolved state for ${te == null ? void 0 : te.type}`, ee), ee;
  }
}
const log$f = loglevelExports.getLogger("TrackingService"), windowEventTypes = ["beforeunload", "unload"];
function getIntervalFraction(re, te) {
  return Math.floor(re / te);
}
const REPORT_INTERVAL = 60;
class TrackingService {
  constructor(te, ee = window.dataLayer) {
    Et(this, "_stateLayer");
    Et(this, "_metaInfo");
    Et(this, "onPlayerEvent", (te) => {
      const ee = this.coordinator.getPlayerConfiguration(), ne = this.coordinator.getPlayerData();
      if (!ee)
        throw new Error("unexpectedly dont have player config");
      if (!ne)
        throw new Error("unexpectedly dont have video player data accessor");
      const ie = isVideoDataAccessor(ne) && ne.isShowingAd();
      if (this.metaInfo = this.stateLayer.getUpdatedState(te), log$f.debug("onPlayerEvent: ", te, this.metaInfo), ie) {
        this.handlePlayerEventWhileShowingAd(te, ee, ne);
        return;
      }
      this.handlePlayerEventWithoutAd(te, ee, ne), this.handleCustomEvent(te);
    });
    Et(this, "handleUnloadEvent", () => {
      windowEventTypes.forEach((ie) => window.removeEventListener(ie, this.handleUnloadEvent));
      const te = this.coordinator.getPlayerConfiguration(), ee = this.coordinator.getPlayerData(), ne = getStopTrackingEvent(REPORT_INTERVAL, this.metaInfo, te, ee);
      this.sendEvent(ne);
    });
    this.coordinator = te, this.dataLayer = ee, te.addEventListener(this.onPlayerEvent), windowEventTypes.forEach((ne) => window.addEventListener(ne, this.handleUnloadEvent));
  }
  get stateLayer() {
    return this._stateLayer || (this._stateLayer = new TrackingServiceStateLayer(this.coordinator)), this._stateLayer;
  }
  get metaInfo() {
    return this._metaInfo || (this._metaInfo = this.stateLayer.getUpdatedState()), this._metaInfo;
  }
  set metaInfo(te) {
    this._metaInfo = te;
  }
  destroy() {
    this.handleUnloadEvent(), this.coordinator.removeEventListener(this.onPlayerEvent), windowEventTypes.forEach((te) => window.removeEventListener(te, this.handleUnloadEvent));
  }
  reset() {
    this._stateLayer = new TrackingServiceStateLayer(this.coordinator);
  }
  restart() {
    this.reset();
    const te = this.coordinator.getPlayerConfiguration();
    if (!te)
      throw new Error("dont have player config");
    const ee = this.coordinator.getMediaMetaData();
    if (!ee)
      throw new Error("dont have player metadata");
    const ne = this.coordinator.getPlayerData();
    if (!ne)
      throw new Error("unexpectedly dont have video player data accessor");
    this.sendInitEvent(te, ee, ne);
  }
  // can't make the switch simpler than that
  // eslint-disable-next-line complexity
  handlePlayerEventWithoutAd(te, ee, ne) {
    switch (te.type) {
      case "loaded":
        this.handleLoadedEvent(te, ee, ne);
        break;
      case "play":
        this.handlePlayEvent();
        break;
      case "paused":
        this.handlePausedEvent(ee);
        break;
      case "timeChanged":
        this.handleTimeChangedEvent(ne);
        break;
      case "seeking":
      case "timeshifting":
        this.handleSeekingEvent(te);
        break;
      case "seekingDone":
      case "timeshiftingDone":
        this.handleSeekingDoneEventForStreamTypes(te, ne);
        break;
      case "playbackFinished":
        this.handlePlaybackFinishedEvent();
        break;
      case "sourceUnloaded":
        this.handleUnloadEvent();
        break;
    }
  }
  handleSeekingDoneEventForStreamTypes(te, ee) {
    isLiveLinearResolver(ee) || this.handleSeekingDoneEvent(te, ee);
  }
  handlePlayerEventWhileShowingAd(te, ee, ne) {
    switch (te.type) {
      case "loaded":
        this.handleLoadedEvent(te, ee, ne);
        break;
      case "adStarted":
        this.handleAdStartedEvent(te, ee, ne);
        break;
    }
  }
  handleCustomEvent(te) {
    switch (te.type) {
      case "nextUpCancelled":
        this.handleNextUpToastEvent(te, "Close");
        break;
      case "nextUpClicked":
        this.handleNextUpToastEvent(te, "Click"), this.handleUnloadEvent();
        break;
      case "nextUpTimeout":
        this.handleNextUpToastEvent(te, "Auto"), this.handleUnloadEvent();
        break;
      case "podcastTitleClick":
        this.handlePodcastTitleClickEvent(te);
        break;
      case "nextEpisodeTriggered":
        this.handleNextEpisodeEvent(te);
        break;
    }
  }
  handlePodcastTitleClickEvent(te) {
    const ee = this.coordinator.getPlayerConfiguration();
    if (!ee)
      throw new Error("dont have player config");
    const ne = this.coordinator.getMediaMetaData();
    if (!ne)
      throw new Error("dont have player metadata");
    this.sendEvent(
      getPodcastTitleTrackingEvent(ne, te.titleType, ee.assetId, this.metaInfo)
    );
  }
  handleNextUpToastEvent(te, ee) {
    if (te.issuer === "CONTEXTUAL")
      return;
    const ne = this.coordinator.getPlayerConfiguration();
    if (!ne)
      throw new Error("dont have player config");
    const ie = this.coordinator.getMediaMetaData();
    if (!ie)
      throw new Error("dont have player metadata");
    this.sendEvent(getNextUpToastTrackingEvent(ie, ee, ne.assetId));
  }
  handlePlaybackFinishedEvent() {
    const te = this.coordinator.getPlayerConfiguration();
    if (!te)
      throw new Error("dont have player config");
    const ee = this.metaInfo;
    this.sendEvent(getEofTrackingEvent(te, REPORT_INTERVAL, ee));
  }
  handleNextEpisodeEvent(te) {
    const ee = this.coordinator.getPlayerConfiguration();
    if (!ee)
      throw new Error("dont have player config");
    const ne = this.coordinator.getMediaMetaData();
    if (!ne)
      throw new Error("dont have player metadata");
    const { issuer: ie } = te, { assetId: ae } = ee;
    this.sendEvent(getNextEpisodeTrackingEvent(ne, ie, ae, this.metaInfo)), ie === "USER" && this.handleUnloadEvent();
  }
  handleSeekingDoneEvent(te, ee) {
    if (te.issuer !== "USER")
      return;
    const ne = this.coordinator.getPlayerConfiguration();
    if (!ne)
      throw new Error("dont have player config");
    const ie = this.metaInfo;
    ee.getPlayerStatus() === "PAUSED" ? this.sendEvent(getPauseTrackingEvent(ne, REPORT_INTERVAL, { ...ie, videoPos: 0 })) : this.sendEvent(getPlayTrackingEvent(ne, REPORT_INTERVAL, { ...ie, videoPos: 0 }));
  }
  handleSeekingEvent(te) {
    if (te.issuer === "RESTART") {
      this.restart();
      return;
    }
    if (te.issuer !== "USER")
      return;
    this.metaInfo.shouldSendInitialPlayback && this.sendPlayInitial(this.metaInfo);
    const ee = this.coordinator.getPlayerConfiguration();
    if (!ee)
      throw new Error("dont have player config");
    this.sendEvent(getSeekTrackingEvent(ee, REPORT_INTERVAL, this.metaInfo));
  }
  handleTimeChangedEvent(te) {
    const ee = this.coordinator.getCumulatedPlayTimeInSec();
    log$f.debug("TRACK timeChanged", this.metaInfo.playbackPosition, "cumulated", ee), this.metaInfo.shouldSendInitialPlayback && this.sendPlayInitial(this.metaInfo), te.getPlaybackMode() === "VOD" && (this.handlePosRelativeAspect(), this.metaInfo = this.stateLayer.getUpdatedState()), this.handlePosAspect(this.metaInfo);
  }
  sendPlayInitial(te) {
    const ee = this.coordinator.getPlayerConfiguration();
    if (!ee)
      throw new Error("dont have player config");
    this.metaInfo.sendingPlayInitial();
    const ne = getPlayInitialTrackingEvent(ee, te);
    this.sendEvent(ne);
  }
  handlePosAspect(te) {
    const { lastPlaybackPosition: ee, playbackPosition: ne } = te, ie = getIntervalFraction(ee, REPORT_INTERVAL), ae = getIntervalFraction(ne, REPORT_INTERVAL);
    if (ie !== ae) {
      log$f.debug(
        `TRACK: ${REPORT_INTERVAL}s changed, last frac: ${ie}, cur frac: ${ae}, playback: ${ne}s`
      );
      const ce = this.coordinator.getPlayerConfiguration();
      if (!ce)
        throw new Error("dont have player config");
      this.sendEvent(getPosTrackingEvent(ce, REPORT_INTERVAL, te));
    }
  }
  handlePosRelativeAspect() {
    const te = this.metaInfo, { lastPlaybackPosition: ee, playbackPosition: ne, durationInSec: ie } = te, ae = ie / 10, ce = Math.floor(ee / ae), he = Math.floor(ne / ae);
    if (he % 10 !== 0 && ce !== he) {
      log$f.debug(
        "TRACK: 10 percent changed, last frac: ",
        ce,
        "cur frac",
        he,
        "playback",
        ne / te.durationInSec * 100,
        "%"
      );
      const le = this.coordinator.getPlayerConfiguration();
      if (!le)
        throw new Error("dont have player config");
      this.sendEvent(
        getPosRelativeTrackingEvent(
          le,
          `${he}0%`,
          REPORT_INTERVAL,
          te
        )
      );
    }
  }
  handlePlayEvent() {
    const te = this.coordinator.getPlayerConfiguration();
    if (this.metaInfo.hadInitialPlayback) {
      if (!te)
        throw new Error("dont have player config");
      const ee = getPlayTrackingEvent(te, REPORT_INTERVAL, this.metaInfo);
      this.sendEvent(ee);
    }
  }
  handlePausedEvent(te) {
    const ee = getPauseTrackingEvent(te, REPORT_INTERVAL, this.metaInfo);
    this.sendEvent(ee);
  }
  handleLoadedEvent(te, ee, ne) {
    log$f.debug("TRACK: got duration", this.metaInfo.durationInSec), this.sendInitEvent(ee, te.data, ne);
  }
  sendInitEvent(te, ee, ne) {
    var ce;
    const ie = ((ce = window.google_tag_manager) == null ? void 0 : ce.isRedBullPage) ?? !1, ae = getInitTrackingEvent(te, ee, ne, ie, this.metaInfo);
    this.sendEvent(ae);
  }
  handleAdStartedEvent(te, ee, ne) {
    const ie = getPlayAdTrackingEvent(
      te,
      ee,
      ne,
      REPORT_INTERVAL,
      this.metaInfo
    );
    this.sendEvent(ie);
  }
  sendEvent(te) {
    var he;
    if (!this.dataLayer)
      throw new Error("dont have a data layer! Did you forget to initialize Google Tag Manager?");
    const ee = this.coordinator.getPlayerConfiguration();
    if (!ee)
      throw new Error("dont have player config");
    this.calculateVideoPos(te);
    const ne = ee.tracking.configs.googleAnalytics, ie = this.coordinator.getMediaMetaData(), ae = ((he = ne.eventCustomizer) == null ? void 0 : he.customize(te, ie)) ?? te, ce = serializeEvent(ae);
    log$f.debug("Tracking: Sending", ce), this.dataLayer.push(ce);
  }
  calculateVideoPos(te) {
    if (te.hasOwnProperty("video_pos")) {
      const ee = this.metaInfo;
      ee.storeVideoPos(ee.playbackPosition);
    }
  }
}
function createTrackingService(re, te = window.dataLayer) {
  var ie;
  const ee = document.querySelectorAll('script[src*="GTM-5XHDS9"]').length > 0;
  if ((((ie = window.google_tag_manager) == null ? void 0 : ie.isRedBullPage) ?? !1) || ee)
    return new TrackingService(re, te);
}
function resolveMediaMetaData(re) {
  const te = re.getMediaMetaData();
  if (!te)
    throw new Error("do not have player metadata");
  return te;
}
function resolvePlayerConfigurationData(re) {
  const te = re.getPlayerConfiguration();
  if (!te)
    throw new Error("do not have player configuration");
  return te;
}
function setMediaSessionActionHandler(re, te) {
  navigator.mediaSession.setActionHandler(re, te);
}
function setMediaSessionMetadata(re) {
  const te = re && new MediaMetadata(re);
  navigator.mediaSession.metadata = te;
}
function setMediaSessionPlaybackState(re) {
  navigator.mediaSession.playbackState = re;
}
function setMediaSessionPositionState(re, te, ee) {
  isNaN(re) || isNaN(te) || isNaN(ee) || navigator.mediaSession.setPositionState({
    duration: re,
    playbackRate: te,
    position: ee
  });
}
const log$e = loglevelExports.getLogger("MediaSessionService"), SECONDS_OF_MINUTE = 60, SECONDS_OF_HOUR = SECONDS_OF_MINUTE * SECONDS_OF_MINUTE, SECONDS_OF_DAY = 24 * SECONDS_OF_HOUR;
class MediaSessionService {
  constructor(te) {
    Et(this, "DEFAULT_MEDIA_SESSION_SEEK_SECONDS", 10);
    Et(this, "onPlayerEvent", (te) => {
      switch (te.type) {
        case "play":
          this.handlePlayEvent();
          break;
        case "paused":
          this.handlePausedEvent();
          break;
        case "timeChanged":
          this.handleTimeChangedEvent();
          break;
      }
    });
    this.coordinator = te, te.addEventListener(this.onPlayerEvent);
  }
  destroy() {
    log$e.info("destroying media-session-service"), this.coordinator.removeEventListener(this.onPlayerEvent), this.reset();
  }
  reset() {
    log$e.info("resetting media-session-service"), setMediaSessionMetadata(null), this.resetMediaSessionActionHandler();
  }
  setupMediaSessionActionHandler() {
    setMediaSessionActionHandler("play", () => {
      log$e.info("Play clicked via Media Session API"), this.coordinator.play();
    }), setMediaSessionActionHandler("pause", () => {
      log$e.info("Pause clicked via Media Session API"), this.coordinator.pause();
    }), setMediaSessionActionHandler("seekto", (te) => {
      if (this.isVOD()) {
        const ee = te.seekTime;
        log$e.info(`Seek to ${ee} via Media Session API`), ee && this.coordinator.seek(ee);
      } else if (this.isDVR()) {
        const ee = te.seekTime;
        if (log$e.info(`Shift to ${ee} via Media Session API`), ee) {
          const ne = ee - Math.abs(this.coordinator.getMaxTimeShiftInSec());
          this.coordinator.timeShift(ne);
        }
      }
    }), setMediaSessionActionHandler("seekbackward", () => {
      this.isVOD() ? (log$e.info(`Seek ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} backward`), this.coordinator.seekRelative(-this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS)) : this.isDVR() && this.coordinator.getPlayerData() && (log$e.info(`Shift ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} backward`), this.coordinator.seekOrTimeshiftRelative(-this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS));
    }), setMediaSessionActionHandler("seekforward", () => {
      this.isVOD() ? (log$e.info(`Seek ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} forward`), this.coordinator.seekRelative(this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS)) : this.isDVR() && (log$e.info(`Shift ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} forward`), this.coordinator.seekOrTimeshiftRelative(this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS));
    });
  }
  resetMediaSessionActionHandler() {
    setMediaSessionActionHandler("play", null), setMediaSessionActionHandler("pause", null), setMediaSessionActionHandler("seekto", null), setMediaSessionActionHandler("seekbackward", null), setMediaSessionActionHandler("seekforward", null);
  }
  handlePlayEvent() {
    const te = this.getTitle(), ee = this.getArtist(), ne = this.getAlbum(), ie = calculateMediaSessionSrcSet(this.getPosterImageUrl());
    setMediaSessionMetadata({ title: te, artist: ee, album: ne, artwork: ie }), setMediaSessionPlaybackState("playing"), this.setupMediaSessionActionHandler();
  }
  handlePausedEvent() {
    setMediaSessionPlaybackState("paused");
  }
  handleTimeChangedEvent() {
    if (this.isVOD()) {
      const te = this.coordinator.getPlayerData();
      if (te) {
        const ee = te.getDurationInSec(), ne = te.getPlaybackSpeed(), ie = te.getCurrentTimeInSec();
        setMediaSessionPositionState(ee, ne, ie);
      }
      return;
    }
    if (this.isLinear()) {
      const te = SECONDS_OF_DAY, ee = 1, ne = this.getCurrentTimeInSeconds();
      setMediaSessionPositionState(te, ee, ne);
      return;
    }
    if (this.isDVR()) {
      const te = this.coordinator.getPlayerData();
      if (te) {
        const ee = te.getCurrentTimeInSec(), ne = Math.abs(this.coordinator.getMaxTimeShiftInSec()), ie = te.getPlaybackSpeed(), ae = ne - Math.abs(ee);
        setMediaSessionPositionState(ne, ie, ae);
      }
      return;
    }
  }
  getCurrentTimeInSeconds() {
    const te = /* @__PURE__ */ new Date();
    return te.getSeconds() + te.getMinutes() * SECONDS_OF_MINUTE + te.getHours() * SECONDS_OF_HOUR;
  }
  getTitle() {
    return resolveMediaMetaData(this.coordinator).title;
  }
  getArtist() {
    return resolvePlayerConfigurationData(this.coordinator).mediaSessionArtist;
  }
  getAlbum() {
    return resolveMediaMetaData(this.coordinator).label;
  }
  getPosterImageUrl() {
    const te = resolvePlayerConfigurationData(this.coordinator), ee = resolveMediaMetaData(this.coordinator);
    return isVideoPlayerMetadata(te) ? ee.posterImageUrl : ee.coverArt;
  }
  isVOD() {
    var te;
    return ((te = this.coordinator.getPlayerData()) == null ? void 0 : te.getPlaybackMode()) === "VOD";
  }
  isLinear() {
    return isLiveLinearResolver(this.coordinator.getPlayerData());
  }
  isDVR() {
    return isLiveDvrResolver(this.coordinator.getPlayerData());
  }
}
const log$d = loglevelExports.getLogger("HookService");
class HookService {
  constructor(te) {
    this.hooks = te;
  }
  async callHookMethod(te, ee, ne, ie) {
    if (te) {
      log$d.debug("calling hook", te.name, "hook:", te);
      try {
        return await te(ee, ne, ie);
      } catch (ae) {
        log$d.error("error calling hook", te.name, "on", te, "error", ae);
      }
    }
    return ee;
  }
  async beforeLoad(te, ee, ne) {
    var ae;
    let ie = te;
    for (const ce of this.hooks)
      ie = await this.callHookMethod((ae = ce.onBeforeLoad) == null ? void 0 : ae.bind(ce), ie, ee, ne) ?? ie;
    return ie;
  }
  async afterLoad(te, ee, ne) {
    var ae;
    let ie = te;
    for (const ce of this.hooks)
      ie = await this.callHookMethod((ae = ce.onAfterLoad) == null ? void 0 : ae.bind(ce), ie, ee, ne) ?? ie;
    return ie;
  }
  async beforeDestroy(te, ee, ne) {
    var ae;
    let ie = te;
    for (const ce of this.hooks)
      ie = await this.callHookMethod(
        (ae = ce.destroy) == null ? void 0 : ae.bind(ce),
        ie ?? {},
        ee ?? {},
        ne
      );
    return ie;
  }
}
var t, r, u, i, o = 0, f = [], c = [], e = l$2.__b, a = l$2.__r, v = l$2.diffed, l = l$2.__c, m = l$2.unmount;
function d(re, te) {
  l$2.__h && l$2.__h(r, re, o || te), o = 0;
  var ee = r.__H || (r.__H = { __: [], __h: [] });
  return re >= ee.__.length && ee.__.push({ __V: c }), ee.__[re];
}
function h$2(re) {
  return o = 1, s(B$1, re);
}
function s(re, te, ee) {
  var ne = d(t++, 2);
  if (ne.t = re, !ne.__c && (ne.__ = [ee ? ee(te) : B$1(void 0, te), function(he) {
    var _e = ne.__N ? ne.__N[0] : ne.__[0], le = ne.t(_e, he);
    _e !== le && (ne.__N = [le, ne.__[1]], ne.__c.setState({}));
  }], ne.__c = r, !r.u)) {
    var ie = function(he, _e, le) {
      if (!ne.__c.__H)
        return !0;
      var se = ne.__c.__H.__.filter(function(ue) {
        return ue.__c;
      });
      if (se.every(function(ue) {
        return !ue.__N;
      }))
        return !ae || ae.call(this, he, _e, le);
      var oe = !1;
      return se.forEach(function(ue) {
        if (ue.__N) {
          var be = ue.__[0];
          ue.__ = ue.__N, ue.__N = void 0, be !== ue.__[0] && (oe = !0);
        }
      }), !(!oe && ne.__c.props === he) && (!ae || ae.call(this, he, _e, le));
    };
    r.u = !0;
    var ae = r.shouldComponentUpdate, ce = r.componentWillUpdate;
    r.componentWillUpdate = function(he, _e, le) {
      if (this.__e) {
        var se = ae;
        ae = void 0, ie(he, _e, le), ae = se;
      }
      ce && ce.call(this, he, _e, le);
    }, r.shouldComponentUpdate = ie;
  }
  return ne.__N || ne.__;
}
function p(re, te) {
  var ee = d(t++, 3);
  !l$2.__s && z$1(ee.__H, te) && (ee.__ = re, ee.i = te, r.__H.__h.push(ee));
}
function y(re, te) {
  var ee = d(t++, 4);
  !l$2.__s && z$1(ee.__H, te) && (ee.__ = re, ee.i = te, r.__h.push(ee));
}
function _(re) {
  return o = 5, F$1(function() {
    return { current: re };
  }, []);
}
function A$1(re, te, ee) {
  o = 6, y(function() {
    return typeof re == "function" ? (re(te()), function() {
      return re(null);
    }) : re ? (re.current = te(), function() {
      return re.current = null;
    }) : void 0;
  }, ee == null ? ee : ee.concat(re));
}
function F$1(re, te) {
  var ee = d(t++, 7);
  return z$1(ee.__H, te) ? (ee.__V = re(), ee.i = te, ee.__h = re, ee.__V) : ee.__;
}
function T$1(re, te) {
  return o = 8, F$1(function() {
    return re;
  }, te);
}
function q$1(re) {
  var te = r.context[re.__c], ee = d(t++, 9);
  return ee.c = re, te ? (ee.__ == null && (ee.__ = !0, te.sub(r)), te.props.value) : re.__;
}
function x$1(re, te) {
  l$2.useDebugValue && l$2.useDebugValue(te ? te(re) : re);
}
function V$1() {
  var re = d(t++, 11);
  if (!re.__) {
    for (var te = r.__v; te !== null && !te.__m && te.__ !== null; )
      te = te.__;
    var ee = te.__m || (te.__m = [0, 0]);
    re.__ = "P" + ee[0] + "-" + ee[1]++;
  }
  return re.__;
}
function b() {
  for (var re; re = f.shift(); )
    if (re.__P && re.__H)
      try {
        re.__H.__h.forEach(k$1), re.__H.__h.forEach(w$1), re.__H.__h = [];
      } catch (te) {
        re.__H.__h = [], l$2.__e(te, re.__v);
      }
}
l$2.__b = function(re) {
  r = null, e && e(re);
}, l$2.__r = function(re) {
  a && a(re), t = 0;
  var te = (r = re.__c).__H;
  te && (u === r ? (te.__h = [], r.__h = [], te.__.forEach(function(ee) {
    ee.__N && (ee.__ = ee.__N), ee.__V = c, ee.__N = ee.i = void 0;
  })) : (te.__h.forEach(k$1), te.__h.forEach(w$1), te.__h = [], t = 0)), u = r;
}, l$2.diffed = function(re) {
  v && v(re);
  var te = re.__c;
  te && te.__H && (te.__H.__h.length && (f.push(te) !== 1 && i === l$2.requestAnimationFrame || ((i = l$2.requestAnimationFrame) || j$1)(b)), te.__H.__.forEach(function(ee) {
    ee.i && (ee.__H = ee.i), ee.__V !== c && (ee.__ = ee.__V), ee.i = void 0, ee.__V = c;
  })), u = r = null;
}, l$2.__c = function(re, te) {
  te.some(function(ee) {
    try {
      ee.__h.forEach(k$1), ee.__h = ee.__h.filter(function(ne) {
        return !ne.__ || w$1(ne);
      });
    } catch (ne) {
      te.some(function(ie) {
        ie.__h && (ie.__h = []);
      }), te = [], l$2.__e(ne, ee.__v);
    }
  }), l && l(re, te);
}, l$2.unmount = function(re) {
  m && m(re);
  var te, ee = re.__c;
  ee && ee.__H && (ee.__H.__.forEach(function(ne) {
    try {
      k$1(ne);
    } catch (ie) {
      te = ie;
    }
  }), ee.__H = void 0, te && l$2.__e(te, ee.__v));
};
var g$1 = typeof requestAnimationFrame == "function";
function j$1(re) {
  var te, ee = function() {
    clearTimeout(ne), g$1 && cancelAnimationFrame(te), setTimeout(re);
  }, ne = setTimeout(ee, 100);
  g$1 && (te = requestAnimationFrame(ee));
}
function k$1(re) {
  var te = r, ee = re.__c;
  typeof ee == "function" && (re.__c = void 0, ee()), r = te;
}
function w$1(re) {
  var te = r;
  re.__c = re.__(), r = te;
}
function z$1(re, te) {
  return !re || re.length !== te.length || te.some(function(ee, ne) {
    return ee !== re[ne];
  });
}
function B$1(re, te) {
  return typeof te == "function" ? te(re) : te;
}
const useGetTagName = (re) => {
  var ne;
  const te = _();
  if (te.current)
    return te.current;
  const ee = (ne = re.current) == null ? void 0 : ne.getRootNode();
  if (ee && "host" in ee) {
    const ie = ee.host.tagName;
    return te.current = ie.toLocaleLowerCase(), te.current;
  }
}, logger$1 = loglevelExports.getLogger("UsageReport"), filterOutSubdomainsRegex = /^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/;
function getLocation() {
  var re, te;
  try {
    const { hostname: ee, href: ne } = window.location;
    return { platform: ((te = (re = filterOutSubdomainsRegex.exec(ee)) == null ? void 0 : re.groups) == null ? void 0 : te[1]) ?? ee, location: ne };
  } catch (ee) {
    const ne = resolveErrorMessageFromUnknown(ee);
    return logger$1.warn({ message: "failed to resolve host", error: ne }), {};
  }
}
const useReportUsage = (re, te) => {
  const ee = _(!1), ne = useGetTagName(re), { location: ie, platform: ae } = getLocation();
  if (ee.current)
    return !1;
  if (ne && ae) {
    ee.current = !0;
    const ce = calculateSsdmUrl(te ?? "PRODUCTION"), he = {
      package: ne,
      version: CORE_VERSION,
      platform: ae,
      location: ie
    };
    return fetch(`${ce}/report-usage?${new URLSearchParams(he)}`).then((_e) => logger$1.info({ message: "reported usage", queryParams: he, response: _e })).catch((_e) => {
      const le = resolveErrorMessageFromUnknown(_e);
      logger$1.warn({ message: "failed in reporting usage", queryParams: he, error: le });
    }), !0;
  }
  return !1;
};
function getFacebookHref(re) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(re)}`;
}
function getPinterestHref(re, te = "", ee = "") {
  return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(re)}&media=${encodeURIComponent(
    ee
  )}&description=${te}`;
}
function getRedditHref(re) {
  return `https://www.reddit.com/submit?url=${encodeURIComponent(re)}`;
}
function getTwitterHref(re, te = "") {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(re)}&text=${te}`;
}
const QUERY_PARAM_MEDIA_TIME = "rbup-media-time", QUERY_PARAM_MEDIA_ID = "rbup-media-id", QUERY_PARAM_MEDIA_TIME_FALLBACK = "time";
function getPageUrl(re, te, ee) {
  if (ee) {
    const ne = new URL(re), ie = ne.searchParams;
    return ie.set(QUERY_PARAM_MEDIA_TIME, String(ee)), ie.set(QUERY_PARAM_MEDIA_ID, te), ne.href;
  }
  return re;
}
class QueryParamUrlSharingStrategy {
  calculateShareUrl(te, ee) {
    const ne = this.calculateBaseUrl(), ie = getPageUrl(ne, ee.assetId, ee.mediaPositionInSec);
    switch (te) {
      case "FACEBOOK":
        return getFacebookHref(ie);
      case "PINTEREST":
        return getPinterestHref(ie, ee.title, ee.imageUrl);
      case "REDDIT":
        return getRedditHref(ie);
      case "TWITTER":
        return getTwitterHref(ie, ee.title);
      case "PAGE":
        return ie;
      default:
        throw new Error(`unexpected share service ${te}`);
    }
  }
  determineInitialSeek(te) {
    const ee = window.location.search;
    if (!ee)
      return;
    const ne = new URLSearchParams(ee), ie = ne.get(QUERY_PARAM_MEDIA_TIME);
    if (ne.get(QUERY_PARAM_MEDIA_ID) === te && ie) {
      const he = parseInt(ie, 10);
      if (!isNaN(he))
        return he;
    }
    const ce = ne.get(QUERY_PARAM_MEDIA_TIME_FALLBACK);
    if (ce) {
      const he = parseInt(ce, 10);
      if (!isNaN(he))
        return he;
    }
  }
  isSharingEnabled() {
    return !!this.calculateBaseUrl();
  }
  calculateBaseUrl() {
    return window.location.href;
  }
}
const de = {
  "ad-endsin": "Werbung endet in {{sec}} Sekunden",
  "audio-mediaInfo-episodeText": "E{{episodeNumber}}",
  "audio-mediaInfo-seasonText": "S{{seasonNumber}}",
  "audio-podcast-listenOn": "Anhören auf",
  "button-close": "Schließen",
  "button-closeMenu": "Menü schließen",
  "error-default-message": "Dieses Video ist leider nicht verfügbar.",
  "error-fsk-message": "Dieses Video ist erst ab {{hour}} Uhr verfügbar.",
  "error-fsk-title": "Freigegeben ab {{age}} Jahren",
  "error-geo-message": "Dieses Video ist in Ihrem Land leider nicht verfügbar.",
  "error-geo-title": "Länderbeschränkung",
  "error-missed-message": "Dieses Video ist leider nicht mehr verfügbar.",
  "error-missed-title": "Schade verpasst",
  "error-unauthorized-message": "Leider dürfen Sie diesen Content nicht sehen.",
  "error-unauthorized-title": "Nicht autorisiert",
  "error-upcoming-message": "Dieses Video kann ab {{localizedDate}} Uhr abgespielt werden.",
  "error-upcoming-title": "Bald verfügbar",
  "endslate-title": "Ähnliche Videos",
  "endslate-replay": "Nochmal abspielen",
  "global-month-short-april": "Apr",
  "global-month-short-august": "Aug",
  "global-month-short-december": "Dez",
  "global-month-short-february": "Feb",
  "global-month-short-january": "Jän",
  "global-month-short-july": "Jul",
  "global-month-short-june": "Jun",
  "global-month-short-march": "Mär",
  "global-month-short-may": "Mai",
  "global-month-short-november": "Nov",
  "global-month-short-october": "Okt",
  "global-month-short-september": "Sep",
  "liveStream-airedOn": "Ausgestrahlt am {{date}}",
  "liveStream-canceled": "Abgesagt",
  "liveStream-days": "Tage",
  "liveStream-backToEvent": "Zurück zum Event Hub",
  "liveStream-hours": "Stunden",
  "liveStream-minutes": "Minuten",
  "liveStream-seconds": "Sekunden",
  "liveStream-trimming": "Replay in Kürze verfügbar",
  "liveStream-unconfirmed": "Unbestätigt",
  "liveStream-seekBackToLive": "Zurück zu Live",
  "liveStream-live": "Live",
  "menu-audioTracks": "Tonspuren",
  "menu-feedback": "Rückmeldung geben",
  "menu-quality": "Qualität",
  "menu-quality-auto": "Automatisch",
  "menu-sharing": "Teilen",
  "menu-sharing-copied": "Kopiert",
  "menu-sharing-copyLink": "Link kopieren",
  "menu-sharing-embed": "Embed kopieren",
  "menu-sharing-facebook": "Facebook",
  "menu-sharing-pinterest": "Pinterest",
  "menu-sharing-playFrom": "Abspielen von",
  "menu-sharing-reddit": "Reddit",
  "menu-sharing-twitter": "Twitter",
  "menu-speeds": "Geschwindigkeit",
  "menu-speeds-normal": "Normal",
  "menu-subtitles": "Untertitel",
  "menu-subtitles-off": "Aus",
  "multiChannel-singleStreamLive": "{{figure}} Stream live",
  "multiChannel-multipleStreamsLive": "{{figure}} Streams live",
  "multiChannel-seeSchedule": "Alle Livestreams",
  "multiChannel-schedule": "Livestreams",
  "multiChannel-label-live": "Jetzt live",
  "multiChannel-label-liveIn": "Live in",
  "multiChannel-label-replay": "Aufzeichnung verfügbar",
  "multiChannel-label-trim": "Aufzeichnung bald verfügbar",
  "multiChannel-label-nowWatching": "Das siehst du gerade",
  "nerdMode-assetId": "Asset ID",
  "nerdMode-copyId": "Kopiere ID",
  "nerdMode-crepoId": "CRID",
  "nerdMode-geolocation": "Abgeleitete Geo",
  "nerdMode-idCopied": "ID kopiert",
  "nerdMode-playerVersion": "Player Version",
  "nerdMode-techVersion": "Bitmovin Version",
  "nerdMode-rendition": "Aktuelle Qualität",
  "nerdMode-unknownValue": "unbekannt",
  "nextVideoCountdown-replay": "Nochmal ansehen",
  "nextVideoCountdown-title": "Als nächstes",
  "rbcom-subtitlesAvailable": "Untertitel verfügbar",
  "tooltip-airplay": "AirPlay",
  "tooltip-audioTracks": "Tonspuren",
  "tooltip-changeVolume": "Lautstärke anpassen",
  "tooltip-dvr": "Zurück zu LIVE",
  "tooltip-forward": "Vorspulen",
  "tooltip-fullscreen": "Vollbild",
  "tooltip-loading": "Laden",
  "tooltip-mute": "Ton aus",
  "tooltip-normalscreen": "Vollbild beenden",
  "tooltip-pause": "Pausieren",
  "tooltip-pip": "Bild in Bild",
  "tooltip-play": "Abspielen",
  "tooltip-replay": "Nochmal ansehen",
  "tooltip-rewind": "Zurückspulen",
  "tooltip-settings": "Einstellungen",
  "tooltip-subtitles": "Untertitel",
  "tooltip-unmute": "Ton an",
  "ad-from-ads": "Werbung {{adPosition}} von {{totalAds}}",
  "audio-duration-hour": "Std.",
  "audio-duration-minute": "Min.",
  "audio-error-default-description": "Diese Podcast-Episode ist nicht mehr verfügbar. Vielleicht wurde sie gelöscht oder entfernt. Schau später nochmal vorbei oder entdecke andere Podcasts.",
  "audio-error-default-title": "Inhalt ist nicht verfügbar",
  "audio-podcast-currently-playing": "Läuft gerade",
  "audio-podcast-playlist-additional-episodes-on": "{{additionalEpisodes}} weitere Folge auf",
  "audio-podcast-playlist-additional-episodes-on_plural": "{{additionalEpisodes}} weitere Folgen auf",
  "audio-podcast-playlist-all-episodes-on": "Alle Folgen auf",
  "nerdMode-audioLanguageOverride": "Audiosprache Überschreibung",
  "nerdMode-localeStorage": "Locale storage",
  "nerdMode-overrideReference": "Überschreibungs Referenz",
  "nerdMode-playerConfiguration": "Player-Konfiguration",
  "nerdMode-subtitlesLanguageOverride": "Untertitel Überschreibung",
  "nerdMode-translationsLanguageOverride": "Übersetzungen Überschreibung",
  "stv-reduce-ads": "Werbung reduzieren",
  "tooltip-stop": "Stop",
  "menu-multi-stream": "Multi Stream",
  "tooltip-multi-stream": "Multi Stream"
}, en$1 = {
  "ad-endsin": "Ad ends in {{sec}} seconds",
  "audio-mediaInfo-episodeText": "E{{episodeNumber}}",
  "audio-mediaInfo-seasonText": "S{{seasonNumber}}",
  "audio-podcast-listenOn": "Listen on",
  "button-close": "Close",
  "button-closeMenu": "Close menu",
  "error-default-message": "This video is currently unavailable.",
  "error-fsk-message": "This video is only allowed for playback from {{hour}}:00.",
  "error-fsk-title": "Released to age {{age}}",
  "error-geo-message": "This video is not available in your country.",
  "error-geo-title": "Geo restricted",
  "error-missed-message": "This video is not available anymore.",
  "error-missed-title": "You've missed it",
  "error-unauthorized-message": "You have insufficient rights to watch this content.",
  "error-unauthorized-title": "Unauthorized",
  "error-upcoming-message": "This video is available from {{localizedDate}}.",
  "error-upcoming-title": "Upcoming",
  "endslate-title": "Related videos",
  "endslate-replay": "Replay video",
  "global-month-short-april": "Apr",
  "global-month-short-august": "Aug",
  "global-month-short-december": "Dec",
  "global-month-short-february": "Feb",
  "global-month-short-january": "Jan",
  "global-month-short-july": "Jul",
  "global-month-short-june": "Jun",
  "global-month-short-march": "Mar",
  "global-month-short-may": "May",
  "global-month-short-november": "Nov",
  "global-month-short-october": "Oct",
  "global-month-short-september": "Sep",
  "liveStream-airedOn": "Aired on {{date}}",
  "liveStream-canceled": "Cancelled",
  "liveStream-days": "Days",
  "liveStream-backToEvent": "Back to Event Hub",
  "liveStream-hours": "Hours",
  "liveStream-minutes": "Minutes",
  "liveStream-seconds": "Seconds",
  "liveStream-trimming": "Awaiting replay",
  "liveStream-unconfirmed": "Unconfirmed",
  "liveStream-seekBackToLive": "Back to Live",
  "liveStream-live": "Live",
  "menu-audioTracks": "Audio Language",
  "menu-feedback": "Give feedback",
  "menu-quality": "Quality",
  "menu-quality-auto": "Auto",
  "menu-sharing": "Share",
  "menu-sharing-copied": "Copied",
  "menu-sharing-copyLink": "Copy link",
  "menu-sharing-embed": "Copy embed",
  "menu-sharing-facebook": "Facebook",
  "menu-sharing-pinterest": "Pinterest",
  "menu-sharing-playFrom": "Play from",
  "menu-sharing-reddit": "Reddit",
  "menu-sharing-twitter": "Twitter",
  "menu-speeds": "Speed",
  "menu-speeds-normal": "Normal",
  "menu-subtitles": "Subtitles",
  "menu-subtitles-off": "Off",
  "multiChannel-singleStreamLive": "{{figure}} stream live",
  "multiChannel-multipleStreamsLive": "{{figure}} streams live",
  "multiChannel-seeSchedule": "See schedule",
  "multiChannel-schedule": "Live streams",
  "multiChannel-label-live": "Live now",
  "multiChannel-label-liveIn": "Live in",
  "multiChannel-label-replay": "Replay available",
  "multiChannel-label-trim": "Awaiting replay",
  "multiChannel-label-nowWatching": "You are now watching",
  "nerdMode-assetId": "Asset ID",
  "nerdMode-copyId": "Copy ID",
  "nerdMode-crepoId": "CRID",
  "nerdMode-geolocation": "Derived geolocation",
  "nerdMode-idCopied": "ID copied to clipboard",
  "nerdMode-playerVersion": "Player Version",
  "nerdMode-techVersion": "Bitmovin Version",
  "nerdMode-rendition": "Current Rendition",
  "nerdMode-unknownValue": "unknown",
  "nextVideoCountdown-replay": "Replay",
  "nextVideoCountdown-title": "Up next",
  "rbcom-subtitlesAvailable": "Subtitles Available",
  "tooltip-airplay": "AirPlay",
  "tooltip-audioTracks": "Audio Language",
  "tooltip-changeVolume": "Change Volume",
  "tooltip-dvr": "Return to LIVE",
  "tooltip-forward": "Seek forward",
  "tooltip-fullscreen": "Enter Fullscreen",
  "tooltip-loading": "Loading",
  "tooltip-mute": "Mute",
  "tooltip-normalscreen": "Leave Fullscreen",
  "tooltip-pause": "Pause",
  "tooltip-pip": "Picture In Picture",
  "tooltip-play": "Play",
  "tooltip-replay": "Replay",
  "tooltip-rewind": "Seek back",
  "tooltip-settings": "Settings",
  "tooltip-subtitles": "Subtitles",
  "tooltip-unmute": "Unmute",
  "ad-from-ads": "Ad {{adPosition}} of {{totalAds}}",
  "audio-duration-hour": "hr",
  "audio-duration-minute": "min",
  "audio-error-default-description": "This podcast episode is no longer available. It may have been deleted or made unavailable by the provider. Please check back later or explore other podcasts.",
  "audio-error-default-title": "Content is not available",
  "audio-podcast-currently-playing": "Currently playing",
  "audio-podcast-playlist-additional-episodes-on": "{{additionalEpisodes}} additional episode on",
  "audio-podcast-playlist-additional-episodes-on_plural": "{{additionalEpisodes}} additional episodes on",
  "audio-podcast-playlist-all-episodes-on": "All episodes on",
  "nerdMode-audioLanguageOverride": "Audio language override",
  "nerdMode-localeStorage": "Locale storage",
  "nerdMode-overrideReference": "Override reference",
  "nerdMode-playerConfiguration": "Player config",
  "nerdMode-subtitlesLanguageOverride": "Subtitles language override",
  "nerdMode-translationsLanguageOverride": "Translations language override",
  "stv-reduce-ads": "Reduce ads",
  "tooltip-stop": "Stop",
  "menu-multi-stream": "Multi Stream",
  "tooltip-multi-stream": "Multi Stream"
}, TRANSLATION_BASE_URL = "https://translations.redbull.com/player/", logger = loglevelExports.getLogger("TranslationService");
class TranslationService {
  constructor() {
    Et(this, "translationsLoaded", !1);
    Et(this, "translationsLoadedCallback");
    Et(this, "preferredLanguage");
    Et(this, "currentTranslationData");
  }
  getTranslationForKey(te) {
    return this.getTranslationFile()[te];
  }
  async fetchTranslationData(te) {
    try {
      const ee = await fetch(`${TRANSLATION_BASE_URL}${te}`, { redirect: "manual" });
      if (ee.ok)
        return await ee.json();
    } catch {
      logger.debug(`Could not load translations for ${te} using fallback instead`);
    }
    return this.getFallbackTranslation(te);
  }
  getTranslationFile() {
    const te = this.preferredLanguage ?? getBrowserLanguage();
    return this.currentTranslationData ?? this.getFallbackTranslation(te);
  }
  getFallbackTranslation(te) {
    return te != null && te.startsWith("de") ? de : en$1;
  }
  async setAndFetchCurrentLanguage(te) {
    const ee = te ?? getBrowserLanguage(), ne = await this.fetchTranslationData(ee);
    return this.preferredLanguage = ee, this.currentTranslationData = ne, Promise.resolve();
  }
}
const translationService = new TranslationService();
async function fetchBrowserOrConfiguredTranslationLanguage(re) {
  return translationService.translationsLoaded = !1, await translationService.setAndFetchCurrentLanguage(re).then(() => {
    translationService.translationsLoaded = !0, translationService.translationsLoadedCallback && translationService.translationsLoadedCallback();
  });
}
function onTranslationDataLoaded(re) {
  translationService.translationsLoadedCallback = re;
}
function areTranslationsLoaded() {
  return translationService.translationsLoaded;
}
function translate(re, te = {}) {
  const ee = translationService.getTranslationForKey(re);
  return Object.keys(te).reduce((ie, ae) => ie.replace(`{{${ae}}}`, te[ae]), ee);
}
const hotKey = {
  "tooltip-fullscreen": KEYCODE_F,
  "tooltip-normalscreen": KEYCODE_F,
  "tooltip-pip": KEYCODE_I,
  "tooltip-play": KEYCODE_K,
  "tooltip-pause": KEYCODE_K,
  "tooltip-mute": KEYCODE_M,
  "tooltip-unmute": KEYCODE_M
};
function translateWithHotKey(re) {
  const te = translate(re), ee = hotKey[re];
  return ee ? `${te} [${ee}]` : te;
}
const log$c = loglevelExports.getLogger("ScriptLoader");
function notifyListener(re, te) {
  try {
    re(te);
  } catch (ee) {
    log$c.error("caught error during invocation of listener %s", re, ee);
  }
}
function loadScriptIfNecessary(re, te, ee, ne = window) {
  const ie = ne.rbupScriptLoadListenerMap ?? {};
  let ae = ie[re];
  ae ? ae.listeners.push(ee) : (ae = { id: re, status: "LOADING", listeners: [ee] }, ie[re] = ae, ne.rbupScriptLoadListenerMap = ie);
  const ce = ne.document.getElementById(re);
  if (ae.status === "LOADED")
    return notifyListener(ee, re), ce ?? void 0;
  if (!ce) {
    const he = ne.document.createElement("script");
    return he.id = re, he.src = te, he.onload = () => {
      var se;
      const _e = (se = ne.rbupScriptLoadListenerMap) == null ? void 0 : se[re];
      if (!_e)
        throw new Error(`entry for Script id ${re} does not exist`);
      _e.status = "LOADED", _e.listeners.forEach((oe) => notifyListener(oe, re));
    }, ne.document.body.appendChild(he), he;
  }
  return ce;
}
const log$b = loglevelExports.getLogger("CommonThumbnailService");
class CommonThumbnailService {
  constructor() {
    Et(this, "thumbnailSprites");
    Et(this, "currentThumbnailTrack");
    Et(this, "thumbnailDetails");
    Et(this, "currentResolution");
  }
  setThumbnailSprites(te) {
    this.thumbnailSprites = te;
  }
  async setThumbnail(te, ee, ne) {
    const { imgContainerElement: ie, imgElement: ae, textContainerElement: ce } = te;
    if (ie === null || ae === null || ce === null)
      return !1;
    const { smallOrBigger: he, mediumOrBigger: _e } = ee, le = _e ? "HIGH" : "LOW", se = await this.getThumbnailDetail(le, ne);
    return se ? (this.styleImageContainerElement(ie, se, he), this.styleImageElement(ae, se), this.styleTextContainer(ce, se), !0) : !1;
  }
  styleImageContainerElement(te, ee, ne) {
    te.style.width = `${ee.width}px`;
    const ie = !ne;
    te.style.height = `${ie ? ee.height * 0.85 : ee.height}px`;
  }
  styleImageElement(te, ee) {
    te.src = ee.thumbnailUrl, te.style.left = `-${ee.x}px`, te.style.top = `-${ee.y}px`;
  }
  styleTextContainer(te, ee) {
    te.style.maxWidth = `${ee.width}px`;
  }
  async getThumbnailDetail(te, ee) {
    return te !== this.currentResolution && (this.thumbnailDetails = void 0, await this.loadThumbnailTrack(te), this.currentResolution = te), this.getRequestedThumbnailDetail(te, ee);
  }
  async loadThumbnailTrack(te) {
    var ne, ie;
    const ee = te === "LOW" ? (ne = this.thumbnailSprites) == null ? void 0 : ne.lowRes : (ie = this.thumbnailSprites) == null ? void 0 : ie.highRes;
    this.currentThumbnailTrack = await this.fetchThumbnailTrack(ee).catch(() => {
      log$b.warn("Error loading thumbnail track ", ee);
    });
  }
  getRequestedThumbnailDetail(te, ee) {
    var ie, ae, ce;
    const ne = te === "LOW" ? (ie = this.thumbnailSprites) == null ? void 0 : ie.lowRes : (ae = this.thumbnailSprites) == null ? void 0 : ae.highRes;
    return this.thumbnailDetails || (this.thumbnailDetails = this.calculatedThumbnailDetail(ne)), (ce = this.thumbnailDetails) == null ? void 0 : ce.find((he) => ee <= he.displayTo);
  }
  calculatedThumbnailDetail(te) {
    if (!te)
      return;
    const ee = this.currentThumbnailTrack, ne = ee == null ? void 0 : ee.match(/(\d{2}:\d{2}:\d{2}\.\d+) +--> +(\d{2}:\d{2}:\d{2}\.\d+)[\r\n]+([^\r\n]*)/g);
    return ne == null ? void 0 : ne.map((ie) => {
      const ae = this.calculateDisplayTime(ie), ce = this.calculateFileUrl(te, ie), he = this.calculateThumbnailPosition(ie);
      return {
        ...ae,
        ...he,
        thumbnailUrl: ce
      };
    });
  }
  async fetchThumbnailTrack(te) {
    if (!te)
      return;
    const ee = await fetch(te);
    if (ee.ok)
      return await ee.text();
    throw new Error(`server returned ${ee.status}`);
  }
  calculateFileUrl(te, ee) {
    var ie;
    const ne = ((ie = ee.match(/[0-9]+\.[a-z]{3}/)) == null ? void 0 : ie[0]) ?? "";
    return te.replace(/([^/]+$)/, ne);
  }
  calculateThumbnailPosition(te) {
    var _e;
    const ne = (_e = /#xywh=(\d+),(\d+),(\d+),(\d+)/.exec(te)) == null ? void 0 : _e.slice(1, 5), ie = Number(ne == null ? void 0 : ne[0]), ae = Number(ne == null ? void 0 : ne[1]), ce = Number(ne == null ? void 0 : ne[2]), he = Number(ne == null ? void 0 : ne[3]);
    return {
      x: ie,
      y: ae,
      width: ce,
      height: he
    };
  }
  calculateDisplayTime(te) {
    const ee = te.match(/(\d{2}:\d{2}:\d{2}\.*?)/g), ne = (ee == null ? void 0 : ee[0]) ?? "", ie = (ee == null ? void 0 : ee[1]) ?? "", ae = convertTimeStringToSec(ne), ce = convertTimeStringToSec(ie);
    return { displayFrom: ae, displayTo: ce };
  }
}
function g(re, te) {
  for (var ee in te)
    re[ee] = te[ee];
  return re;
}
function C(re, te) {
  for (var ee in re)
    if (ee !== "__source" && !(ee in te))
      return !0;
  for (var ne in te)
    if (ne !== "__source" && re[ne] !== te[ne])
      return !0;
  return !1;
}
function E(re, te) {
  return re === te && (re !== 0 || 1 / re == 1 / te) || re != re && te != te;
}
function w(re) {
  this.props = re;
}
function x(re, te) {
  function ee(ie) {
    var ae = this.props.ref, ce = ae == ie.ref;
    return !ce && ae && (ae.call ? ae(null) : ae.current = null), te ? !te(this.props, ie) || !ce : C(this.props, ie);
  }
  function ne(ie) {
    return this.shouldComponentUpdate = ee, y$1(re, ie);
  }
  return ne.displayName = "Memo(" + (re.displayName || re.name) + ")", ne.prototype.isReactComponent = !0, ne.__f = !0, ne;
}
(w.prototype = new b$1()).isPureReactComponent = !0, w.prototype.shouldComponentUpdate = function(re, te) {
  return C(this.props, re) || C(this.state, te);
};
var R = l$2.__b;
l$2.__b = function(re) {
  re.type && re.type.__f && re.ref && (re.props.ref = re.ref, re.ref = null), R && R(re);
};
var N = typeof Symbol < "u" && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function k(re) {
  function te(ee) {
    var ne = g({}, ee);
    return delete ne.ref, re(ne, ee.ref || null);
  }
  return te.$$typeof = N, te.render = te, te.prototype.isReactComponent = te.__f = !0, te.displayName = "ForwardRef(" + (re.displayName || re.name) + ")", te;
}
var A = function(re, te) {
  return re == null ? null : S(S(re).map(te));
}, O = { map: A, forEach: A, count: function(re) {
  return re ? S(re).length : 0;
}, only: function(re) {
  var te = S(re);
  if (te.length !== 1)
    throw "Children.only";
  return te[0];
}, toArray: S }, T = l$2.__e;
l$2.__e = function(re, te, ee, ne) {
  if (re.then) {
    for (var ie, ae = te; ae = ae.__; )
      if ((ie = ae.__c) && ie.__c)
        return te.__e == null && (te.__e = ee.__e, te.__k = ee.__k), ie.__c(re, te);
  }
  T(re, te, ee, ne);
};
var I = l$2.unmount;
function L(re, te, ee) {
  return re && (re.__c && re.__c.__H && (re.__c.__H.__.forEach(function(ne) {
    typeof ne.__c == "function" && ne.__c();
  }), re.__c.__H = null), (re = g({}, re)).__c != null && (re.__c.__P === ee && (re.__c.__P = te), re.__c = null), re.__k = re.__k && re.__k.map(function(ne) {
    return L(ne, te, ee);
  })), re;
}
function U(re, te, ee) {
  return re && (re.__v = null, re.__k = re.__k && re.__k.map(function(ne) {
    return U(ne, te, ee);
  }), re.__c && re.__c.__P === te && (re.__e && ee.insertBefore(re.__e, re.__d), re.__c.__e = !0, re.__c.__P = ee)), re;
}
function D() {
  this.__u = 0, this.t = null, this.__b = null;
}
function F(re) {
  var te = re.__.__c;
  return te && te.__a && te.__a(re);
}
function M(re) {
  var te, ee, ne;
  function ie(ae) {
    if (te || (te = re()).then(function(ce) {
      ee = ce.default || ce;
    }, function(ce) {
      ne = ce;
    }), ne)
      throw ne;
    if (!ee)
      throw te;
    return y$1(ee, ae);
  }
  return ie.displayName = "Lazy", ie.__f = !0, ie;
}
function V() {
  this.u = null, this.o = null;
}
l$2.unmount = function(re) {
  var te = re.__c;
  te && te.__R && te.__R(), te && re.__h === !0 && (re.type = null), I && I(re);
}, (D.prototype = new b$1()).__c = function(re, te) {
  var ee = te.__c, ne = this;
  ne.t == null && (ne.t = []), ne.t.push(ee);
  var ie = F(ne.__v), ae = !1, ce = function() {
    ae || (ae = !0, ee.__R = null, ie ? ie(he) : he());
  };
  ee.__R = ce;
  var he = function() {
    if (!--ne.__u) {
      if (ne.state.__a) {
        var le = ne.state.__a;
        ne.__v.__k[0] = U(le, le.__c.__P, le.__c.__O);
      }
      var se;
      for (ne.setState({ __a: ne.__b = null }); se = ne.t.pop(); )
        se.forceUpdate();
    }
  }, _e = te.__h === !0;
  ne.__u++ || _e || ne.setState({ __a: ne.__b = ne.__v.__k[0] }), re.then(ce, ce);
}, D.prototype.componentWillUnmount = function() {
  this.t = [];
}, D.prototype.render = function(re, te) {
  if (this.__b) {
    if (this.__v.__k) {
      var ee = document.createElement("div"), ne = this.__v.__k[0].__c;
      this.__v.__k[0] = L(this.__b, ee, ne.__O = ne.__P);
    }
    this.__b = null;
  }
  var ie = te.__a && y$1(k$2, null, re.fallback);
  return ie && (ie.__h = null), [y$1(k$2, null, te.__a ? null : re.children), ie];
};
var W = function(re, te, ee) {
  if (++ee[1] === ee[0] && re.o.delete(te), re.props.revealOrder && (re.props.revealOrder[0] !== "t" || !re.o.size))
    for (ee = re.u; ee; ) {
      for (; ee.length > 3; )
        ee.pop()();
      if (ee[1] < ee[0])
        break;
      re.u = ee = ee[2];
    }
};
function P(re) {
  return this.getChildContext = function() {
    return re.context;
  }, re.children;
}
function j(re) {
  var te = this, ee = re.i;
  te.componentWillUnmount = function() {
    D$1(null, te.l), te.l = null, te.i = null;
  }, te.i && te.i !== ee && te.componentWillUnmount(), re.__v ? (te.l || (te.i = ee, te.l = { nodeType: 1, parentNode: ee, childNodes: [], appendChild: function(ne) {
    this.childNodes.push(ne), te.i.appendChild(ne);
  }, insertBefore: function(ne, ie) {
    this.childNodes.push(ne), te.i.appendChild(ne);
  }, removeChild: function(ne) {
    this.childNodes.splice(this.childNodes.indexOf(ne) >>> 1, 1), te.i.removeChild(ne);
  } }), D$1(y$1(P, { context: te.context }, re.__v), te.l)) : te.l && te.componentWillUnmount();
}
function z(re, te) {
  var ee = y$1(j, { __v: re, i: te });
  return ee.containerInfo = te, ee;
}
(V.prototype = new b$1()).__a = function(re) {
  var te = this, ee = F(te.__v), ne = te.o.get(re);
  return ne[0]++, function(ie) {
    var ae = function() {
      te.props.revealOrder ? (ne.push(ie), W(te, re, ne)) : ie();
    };
    ee ? ee(ae) : ae();
  };
}, V.prototype.render = function(re) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var te = S(re.children);
  re.revealOrder && re.revealOrder[0] === "b" && te.reverse();
  for (var ee = te.length; ee--; )
    this.o.set(te[ee], this.u = [1, 0, this.u]);
  return re.children;
}, V.prototype.componentDidUpdate = V.prototype.componentDidMount = function() {
  var re = this;
  this.o.forEach(function(te, ee) {
    W(re, ee, te);
  });
};
var B = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, H$1 = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, Z = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, Y = /[A-Z0-9]/g, $ = typeof document < "u", q = function(re) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(re);
};
function G(re, te, ee) {
  return te.__k == null && (te.textContent = ""), D$1(re, te), typeof ee == "function" && ee(), re ? re.__c : null;
}
function J(re, te, ee) {
  return E$1(re, te), typeof ee == "function" && ee(), re ? re.__c : null;
}
b$1.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(re) {
  Object.defineProperty(b$1.prototype, re, { configurable: !0, get: function() {
    return this["UNSAFE_" + re];
  }, set: function(te) {
    Object.defineProperty(this, re, { configurable: !0, writable: !0, value: te });
  } });
});
var K = l$2.event;
function Q() {
}
function X() {
  return this.cancelBubble;
}
function nn() {
  return this.defaultPrevented;
}
l$2.event = function(re) {
  return K && (re = K(re)), re.persist = Q, re.isPropagationStopped = X, re.isDefaultPrevented = nn, re.nativeEvent = re;
};
var tn, en = { enumerable: !1, configurable: !0, get: function() {
  return this.class;
} }, rn = l$2.vnode;
l$2.vnode = function(re) {
  typeof re.type == "string" && function(te) {
    var ee = te.props, ne = te.type, ie = {};
    for (var ae in ee) {
      var ce = ee[ae];
      if (!(ae === "value" && "defaultValue" in ee && ce == null || $ && ae === "children" && ne === "noscript" || ae === "class" || ae === "className")) {
        var he = ae.toLowerCase();
        ae === "defaultValue" && "value" in ee && ee.value == null ? ae = "value" : ae === "download" && ce === !0 ? ce = "" : he === "ondoubleclick" ? ae = "ondblclick" : he !== "onchange" || ne !== "input" && ne !== "textarea" || q(ee.type) ? he === "onfocus" ? ae = "onfocusin" : he === "onblur" ? ae = "onfocusout" : Z.test(ae) ? ae = he : ne.indexOf("-") === -1 && H$1.test(ae) ? ae = ae.replace(Y, "-$&").toLowerCase() : ce === null && (ce = void 0) : he = ae = "oninput", he === "oninput" && ie[ae = he] && (ae = "oninputCapture"), ie[ae] = ce;
      }
    }
    ne == "select" && ie.multiple && Array.isArray(ie.value) && (ie.value = S(ee.children).forEach(function(_e) {
      _e.props.selected = ie.value.indexOf(_e.props.value) != -1;
    })), ne == "select" && ie.defaultValue != null && (ie.value = S(ee.children).forEach(function(_e) {
      _e.props.selected = ie.multiple ? ie.defaultValue.indexOf(_e.props.value) != -1 : ie.defaultValue == _e.props.value;
    })), ee.class && !ee.className ? (ie.class = ee.class, Object.defineProperty(ie, "className", en)) : (ee.className && !ee.class || ee.class && ee.className) && (ie.class = ie.className = ee.className), te.props = ie;
  }(re), re.$$typeof = B, rn && rn(re);
};
var un = l$2.__r;
l$2.__r = function(re) {
  un && un(re), tn = re.__c;
};
var on = l$2.diffed;
l$2.diffed = function(re) {
  on && on(re);
  var te = re.props, ee = re.__e;
  ee != null && re.type === "textarea" && "value" in te && te.value !== ee.value && (ee.value = te.value == null ? "" : te.value), tn = null;
};
var ln = { ReactCurrentDispatcher: { current: { readContext: function(re) {
  return tn.__n[re.__c].props.value;
} } } };
function fn(re) {
  return y$1.bind(null, re);
}
function an(re) {
  return !!re && re.$$typeof === B;
}
function sn(re) {
  return an(re) ? F$2.apply(null, arguments) : re;
}
function hn(re) {
  return !!re.__k && (D$1(null, re), !0);
}
function vn(re) {
  return re && (re.base || re.nodeType === 1 && re) || null;
}
var dn = function(re, te) {
  return re(te);
}, pn = function(re, te) {
  return re(te);
}, mn = k$2;
function yn(re) {
  re();
}
function _n(re) {
  return re;
}
function bn() {
  return [!1, yn];
}
var Sn = y;
function gn(re, te) {
  var ee = te(), ne = h$2({ h: { __: ee, v: te } }), ie = ne[0].h, ae = ne[1];
  return y(function() {
    ie.__ = ee, ie.v = te, E(ie.__, te()) || ae({ h: ie });
  }, [re, ee, te]), p(function() {
    return E(ie.__, ie.v()) || ae({ h: ie }), re(function() {
      E(ie.__, ie.v()) || ae({ h: ie });
    });
  }, [re]), ee;
}
var Cn = { useState: h$2, useId: V$1, useReducer: s, useEffect: p, useLayoutEffect: y, useInsertionEffect: Sn, useTransition: bn, useDeferredValue: _n, useSyncExternalStore: gn, startTransition: yn, useRef: _, useImperativeHandle: A$1, useMemo: F$1, useCallback: T$1, useContext: q$1, useDebugValue: x$1, version: "17.0.2", Children: O, render: G, hydrate: J, unmountComponentAtNode: hn, createPortal: z, createElement: y$1, createContext: G$1, createFactory: fn, cloneElement: sn, createRef: _$1, Fragment: k$2, isValidElement: an, findDOMNode: vn, Component: b$1, PureComponent: w, memo: x, forwardRef: k, flushSync: pn, unstable_batchedUpdates: dn, StrictMode: mn, Suspense: D, SuspenseList: V, lazy: M, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: ln }, resizeObservers = [], hasActiveObservations = function() {
  return resizeObservers.some(function(re) {
    return re.activeTargets.length > 0;
  });
}, hasSkippedObservations = function() {
  return resizeObservers.some(function(re) {
    return re.skippedTargets.length > 0;
  });
}, msg = "ResizeObserver loop completed with undelivered notifications.", deliverResizeLoopError = function() {
  var re;
  typeof ErrorEvent == "function" ? re = new ErrorEvent("error", {
    message: msg
  }) : (re = document.createEvent("Event"), re.initEvent("error", !1, !1), re.message = msg), window.dispatchEvent(re);
}, ResizeObserverBoxOptions;
(function(re) {
  re.BORDER_BOX = "border-box", re.CONTENT_BOX = "content-box", re.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));
var freeze = function(re) {
  return Object.freeze(re);
}, ResizeObserverSize = function() {
  function re(te, ee) {
    this.inlineSize = te, this.blockSize = ee, freeze(this);
  }
  return re;
}(), DOMRectReadOnly = function() {
  function re(te, ee, ne, ie) {
    return this.x = te, this.y = ee, this.width = ne, this.height = ie, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, freeze(this);
  }
  return re.prototype.toJSON = function() {
    var te = this, ee = te.x, ne = te.y, ie = te.top, ae = te.right, ce = te.bottom, he = te.left, _e = te.width, le = te.height;
    return { x: ee, y: ne, top: ie, right: ae, bottom: ce, left: he, width: _e, height: le };
  }, re.fromRect = function(te) {
    return new re(te.x, te.y, te.width, te.height);
  }, re;
}(), isSVG = function(re) {
  return re instanceof SVGElement && "getBBox" in re;
}, isHidden = function(re) {
  if (isSVG(re)) {
    var te = re.getBBox(), ee = te.width, ne = te.height;
    return !ee && !ne;
  }
  var ie = re, ae = ie.offsetWidth, ce = ie.offsetHeight;
  return !(ae || ce || re.getClientRects().length);
}, isElement$2 = function(re) {
  var te;
  if (re instanceof Element)
    return !0;
  var ee = (te = re == null ? void 0 : re.ownerDocument) === null || te === void 0 ? void 0 : te.defaultView;
  return !!(ee && re instanceof ee.Element);
}, isReplacedElement = function(re) {
  switch (re.tagName) {
    case "INPUT":
      if (re.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, global$2 = typeof window < "u" ? window : {}, cache = /* @__PURE__ */ new WeakMap(), scrollRegexp = /auto|scroll/, verticalRegexp = /^tb|vertical/, IE = /msie|trident/i.test(global$2.navigator && global$2.navigator.userAgent), parseDimension = function(re) {
  return parseFloat(re || "0");
}, size = function(re, te, ee) {
  return re === void 0 && (re = 0), te === void 0 && (te = 0), ee === void 0 && (ee = !1), new ResizeObserverSize((ee ? te : re) || 0, (ee ? re : te) || 0);
}, zeroBoxes = freeze({
  devicePixelContentBoxSize: size(),
  borderBoxSize: size(),
  contentBoxSize: size(),
  contentRect: new DOMRectReadOnly(0, 0, 0, 0)
}), calculateBoxSizes = function(re, te) {
  if (te === void 0 && (te = !1), cache.has(re) && !te)
    return cache.get(re);
  if (isHidden(re))
    return cache.set(re, zeroBoxes), zeroBoxes;
  var ee = getComputedStyle(re), ne = isSVG(re) && re.ownerSVGElement && re.getBBox(), ie = !IE && ee.boxSizing === "border-box", ae = verticalRegexp.test(ee.writingMode || ""), ce = !ne && scrollRegexp.test(ee.overflowY || ""), he = !ne && scrollRegexp.test(ee.overflowX || ""), _e = ne ? 0 : parseDimension(ee.paddingTop), le = ne ? 0 : parseDimension(ee.paddingRight), se = ne ? 0 : parseDimension(ee.paddingBottom), oe = ne ? 0 : parseDimension(ee.paddingLeft), ue = ne ? 0 : parseDimension(ee.borderTopWidth), be = ne ? 0 : parseDimension(ee.borderRightWidth), ve = ne ? 0 : parseDimension(ee.borderBottomWidth), me = ne ? 0 : parseDimension(ee.borderLeftWidth), pe = oe + le, fe = _e + se, ge = me + be, ye = ue + ve, $e = he ? re.offsetHeight - ye - re.clientHeight : 0, Se = ce ? re.offsetWidth - ge - re.clientWidth : 0, Ce = ie ? pe + ge : 0, Ie = ie ? fe + ye : 0, Te = ne ? ne.width : parseDimension(ee.width) - Ce - Se, Ee = ne ? ne.height : parseDimension(ee.height) - Ie - $e, we = Te + pe + Se + ge, Pe = Ee + fe + $e + ye, Me = freeze({
    devicePixelContentBoxSize: size(Math.round(Te * devicePixelRatio), Math.round(Ee * devicePixelRatio), ae),
    borderBoxSize: size(we, Pe, ae),
    contentBoxSize: size(Te, Ee, ae),
    contentRect: new DOMRectReadOnly(oe, _e, Te, Ee)
  });
  return cache.set(re, Me), Me;
}, calculateBoxSize = function(re, te, ee) {
  var ne = calculateBoxSizes(re, ee), ie = ne.borderBoxSize, ae = ne.contentBoxSize, ce = ne.devicePixelContentBoxSize;
  switch (te) {
    case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
      return ce;
    case ResizeObserverBoxOptions.BORDER_BOX:
      return ie;
    default:
      return ae;
  }
}, ResizeObserverEntry = function() {
  function re(te) {
    var ee = calculateBoxSizes(te);
    this.target = te, this.contentRect = ee.contentRect, this.borderBoxSize = freeze([ee.borderBoxSize]), this.contentBoxSize = freeze([ee.contentBoxSize]), this.devicePixelContentBoxSize = freeze([ee.devicePixelContentBoxSize]);
  }
  return re;
}(), calculateDepthForNode = function(re) {
  if (isHidden(re))
    return 1 / 0;
  for (var te = 0, ee = re.parentNode; ee; )
    te += 1, ee = ee.parentNode;
  return te;
}, broadcastActiveObservations = function() {
  var re = 1 / 0, te = [];
  resizeObservers.forEach(function(ce) {
    if (ce.activeTargets.length !== 0) {
      var he = [];
      ce.activeTargets.forEach(function(le) {
        var se = new ResizeObserverEntry(le.target), oe = calculateDepthForNode(le.target);
        he.push(se), le.lastReportedSize = calculateBoxSize(le.target, le.observedBox), oe < re && (re = oe);
      }), te.push(function() {
        ce.callback.call(ce.observer, he, ce.observer);
      }), ce.activeTargets.splice(0, ce.activeTargets.length);
    }
  });
  for (var ee = 0, ne = te; ee < ne.length; ee++) {
    var ie = ne[ee];
    ie();
  }
  return re;
}, gatherActiveObservationsAtDepth = function(re) {
  resizeObservers.forEach(function(ee) {
    ee.activeTargets.splice(0, ee.activeTargets.length), ee.skippedTargets.splice(0, ee.skippedTargets.length), ee.observationTargets.forEach(function(ie) {
      ie.isActive() && (calculateDepthForNode(ie.target) > re ? ee.activeTargets.push(ie) : ee.skippedTargets.push(ie));
    });
  });
}, process$1 = function() {
  var re = 0;
  for (gatherActiveObservationsAtDepth(re); hasActiveObservations(); )
    re = broadcastActiveObservations(), gatherActiveObservationsAtDepth(re);
  return hasSkippedObservations() && deliverResizeLoopError(), re > 0;
}, trigger, callbacks$1 = [], notify = function() {
  return callbacks$1.splice(0).forEach(function(re) {
    return re();
  });
}, queueMicroTask = function(re) {
  if (!trigger) {
    var te = 0, ee = document.createTextNode(""), ne = { characterData: !0 };
    new MutationObserver(function() {
      return notify();
    }).observe(ee, ne), trigger = function() {
      ee.textContent = "".concat(te ? te-- : te++);
    };
  }
  callbacks$1.push(re), trigger();
}, queueResizeObserver = function(re) {
  queueMicroTask(function() {
    requestAnimationFrame(re);
  });
}, watching = 0, isWatching = function() {
  return !!watching;
}, CATCH_PERIOD = 250, observerConfig = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, events = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], time = function(re) {
  return re === void 0 && (re = 0), Date.now() + re;
}, scheduled = !1, Scheduler = function() {
  function re() {
    var te = this;
    this.stopped = !0, this.listener = function() {
      return te.schedule();
    };
  }
  return re.prototype.run = function(te) {
    var ee = this;
    if (te === void 0 && (te = CATCH_PERIOD), !scheduled) {
      scheduled = !0;
      var ne = time(te);
      queueResizeObserver(function() {
        var ie = !1;
        try {
          ie = process$1();
        } finally {
          if (scheduled = !1, te = ne - time(), !isWatching())
            return;
          ie ? ee.run(1e3) : te > 0 ? ee.run(te) : ee.start();
        }
      });
    }
  }, re.prototype.schedule = function() {
    this.stop(), this.run();
  }, re.prototype.observe = function() {
    var te = this, ee = function() {
      return te.observer && te.observer.observe(document.body, observerConfig);
    };
    document.body ? ee() : global$2.addEventListener("DOMContentLoaded", ee);
  }, re.prototype.start = function() {
    var te = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), events.forEach(function(ee) {
      return global$2.addEventListener(ee, te.listener, !0);
    }));
  }, re.prototype.stop = function() {
    var te = this;
    this.stopped || (this.observer && this.observer.disconnect(), events.forEach(function(ee) {
      return global$2.removeEventListener(ee, te.listener, !0);
    }), this.stopped = !0);
  }, re;
}(), scheduler = new Scheduler(), updateCount = function(re) {
  !watching && re > 0 && scheduler.start(), watching += re, !watching && scheduler.stop();
}, skipNotifyOnElement = function(re) {
  return !isSVG(re) && !isReplacedElement(re) && getComputedStyle(re).display === "inline";
}, ResizeObservation = function() {
  function re(te, ee) {
    this.target = te, this.observedBox = ee || ResizeObserverBoxOptions.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return re.prototype.isActive = function() {
    var te = calculateBoxSize(this.target, this.observedBox, !0);
    return skipNotifyOnElement(this.target) && (this.lastReportedSize = te), this.lastReportedSize.inlineSize !== te.inlineSize || this.lastReportedSize.blockSize !== te.blockSize;
  }, re;
}(), ResizeObserverDetail = function() {
  function re(te, ee) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = te, this.callback = ee;
  }
  return re;
}(), observerMap = /* @__PURE__ */ new WeakMap(), getObservationIndex = function(re, te) {
  for (var ee = 0; ee < re.length; ee += 1)
    if (re[ee].target === te)
      return ee;
  return -1;
}, ResizeObserverController = function() {
  function re() {
  }
  return re.connect = function(te, ee) {
    var ne = new ResizeObserverDetail(te, ee);
    observerMap.set(te, ne);
  }, re.observe = function(te, ee, ne) {
    var ie = observerMap.get(te), ae = ie.observationTargets.length === 0;
    getObservationIndex(ie.observationTargets, ee) < 0 && (ae && resizeObservers.push(ie), ie.observationTargets.push(new ResizeObservation(ee, ne && ne.box)), updateCount(1), scheduler.schedule());
  }, re.unobserve = function(te, ee) {
    var ne = observerMap.get(te), ie = getObservationIndex(ne.observationTargets, ee), ae = ne.observationTargets.length === 1;
    ie >= 0 && (ae && resizeObservers.splice(resizeObservers.indexOf(ne), 1), ne.observationTargets.splice(ie, 1), updateCount(-1));
  }, re.disconnect = function(te) {
    var ee = this, ne = observerMap.get(te);
    ne.observationTargets.slice().forEach(function(ie) {
      return ee.unobserve(te, ie.target);
    }), ne.activeTargets.splice(0, ne.activeTargets.length);
  }, re;
}(), ResizeObserver$1 = function() {
  function re(te) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof te != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    ResizeObserverController.connect(this, te);
  }
  return re.prototype.observe = function(te, ee) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!isElement$2(te))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ResizeObserverController.observe(this, te, ee);
  }, re.prototype.unobserve = function(te) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!isElement$2(te))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ResizeObserverController.unobserve(this, te);
  }, re.prototype.disconnect = function() {
    ResizeObserverController.disconnect(this);
  }, re.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, re;
}();
function newResizeObserver(re) {
  return new (window.ResizeObserver ?? ResizeObserver$1)(re);
}
function useContainerQuery(re, te) {
  const [ee, ne] = h$2([]), ie = T$1(
    (ce) => {
      const he = new Set(ee), _e = new Set(ee);
      if (ce.forEach((le) => {
        te.forEach((se) => {
          le.contentRect.width >= se ? he.add(se) : he.delete(se);
        });
      }), !eqSet(_e, he)) {
        const le = Array.from(he);
        ne(le);
      }
    },
    [te, ee]
  );
  p(() => {
    const ce = re.current;
    if (!ce)
      return function() {
      };
    const he = newResizeObserver((_e) => {
      window.requestAnimationFrame(() => ie(_e));
    });
    return he.observe(ce), function() {
      he.unobserve(ce);
    };
  }, [te, ee, re, ie]);
  const ae = F$1(
    () => ee.map((ce) => `cq-${ce}`).join(" "),
    [ee]
  );
  if (ae === void 0)
    throw new Error("Hooks are broken! Please check RBV-1627 to get more info!");
  return ae;
}
function cssClassesContainsBreakpoint(re, te) {
  return re.includes(`cq-${te}`);
}
function useResize(re, te) {
  const ee = _(), ne = _(), ie = _(re);
  ie.current = re;
  const ae = (ce) => {
    window.requestAnimationFrame(() => {
      ce.forEach((he) => {
        const _e = ee.current;
        (he.contentRect.width !== (_e == null ? void 0 : _e.width) || he.contentRect.height !== _e.height) && (ee.current = {
          width: he.contentRect.width,
          height: he.contentRect.height
        }, ie.current(he.contentRect));
      });
    });
  };
  ne.current || (ne.current = newResizeObserver(ae)), p(() => {
    const ce = te == null ? void 0 : te.current;
    if (!ce)
      return () => {
      };
    const he = ne.current;
    return he == null || he.observe(ce), () => {
      he == null || he.unobserve(ce);
    };
  }, [te]);
}
const defaultState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function useMeasure(re, te) {
  const [ee, ne] = h$2({ ...defaultState, ...te });
  return useResize((ie) => {
    const { x: ae, y: ce, width: he, height: _e, top: le, left: se, bottom: oe, right: ue } = ie;
    ne({ x: ae, y: ce, width: he, height: _e, top: le, left: se, bottom: oe, right: ue });
  }, re), ee;
}
function handleResize(re, te) {
  window.requestAnimationFrame(() => {
    re.forEach((ee) => {
      te(ee.contentRect.width);
    });
  });
}
function usePlayerWidth(re) {
  const [te, ee] = h$2(0);
  return p(() => {
    const ne = re.current;
    if (!ne)
      return function() {
      };
    const ie = newResizeObserver((ae) => handleResize(ae, ee));
    return ie.observe(ne), function() {
      ie.unobserve(ne);
    };
  }, [re]), te;
}
const UserInteractionContext = G$1({}), UserInteractionContextProvider = ({ children: re }) => {
  const te = _([]), ee = F$1(() => ({
    addEventListener(ne) {
      te.current.includes(ne) || te.current.push(ne);
    },
    removeEventListener(ne) {
      const ie = te.current.findIndex((ae) => ae === ne);
      te.current.splice(ie, 1);
    },
    trigger(ne) {
      te.current.forEach((ie) => {
        try {
          ie(ne);
        } catch {
          console.error("error invoking user interaction listener", ne);
        }
      });
    }
  }), [te]);
  return /* @__PURE__ */ Cn.createElement(UserInteractionContext.Provider, { value: ee }, re);
}, log$a = loglevelExports.getLogger("useInformPlaywright"), INFO_LOG_LEVEL = 2;
function useInformPlaywright(re) {
  const te = _(null), ee = T$1(() => log$a.getLevel() <= INFO_LOG_LEVEL, []), ne = T$1(() => {
    te.current && (window.clearTimeout(te.current), te.current = null);
  }, []);
  p(() => (ee() && (ne(), te.current = window.setTimeout(() => {
    log$a.info(re);
  }, 1e3)), () => {
    ne();
  }), [ne, ee, re]);
}
function useSmoothScrubBarAnimation(re, te, ee, ne) {
  const ie = _(0), ae = T$1(() => {
    var _e;
    const ce = ((_e = ne == null ? void 0 : ne.getPlayerData()) == null ? void 0 : _e.getCurrentTimeInSec()) ?? 0;
    te(ce);
    const he = (ne == null ? void 0 : ne.getBufferLengthInSec()) ?? 0;
    ee(he), re === "PLAYING" && (ie.current = window.requestAnimationFrame(ae));
  }, [ne, re, ee, te]);
  p(() => (re === "PLAYING" && ae(), () => {
    window.cancelAnimationFrame(ie.current);
  }), [re, ae]);
}
function useObjectArrayCache(re, te) {
  const ee = re.map((ie) => ie[te]).join(",");
  return F$1(() => re, [ee]);
}
function defaultVideoQuality$1() {
  return {
    isAuto: !0,
    id: "auto",
    height: 0,
    width: 0
  };
}
function createDefaultPlayerContextState() {
  return {
    playerState: {
      audioTracks: [],
      cumulatedPlayTimeInSec: 0,
      durationInSec: 0,
      isFullscreenMode: !1,
      isInPictureInPictureMode: !1,
      isHdPlayback: !1,
      isShowingAd: !1,
      liveStatus: void 0,
      maxTimeShiftInSec: 0,
      playbackMode: "VOD",
      playbackPosInSec: 0,
      playbackSpeed: 1,
      playerStatus: "IDLE",
      selectedAudioTrack: void 0,
      selectedSubtitleTrack: void 0,
      selectedVideoQuality: defaultVideoQuality$1(),
      subtitleTracks: [],
      timeShiftInSec: 0,
      videoBufferLengthInSec: 0,
      videoLoaded: !1,
      videoQualities: [],
      isVRVideo: !1
    },
    init: () => {
    }
  };
}
const defaultPlayerContextState = createDefaultPlayerContextState(), PlayerStateContext = G$1(null);
function createPlayerStateFromCoordinator(re) {
  var ne, ie, ae;
  const te = re.getPlaybackMode(), ee = te === "LIVE" ? re.getLiveVariant() : void 0;
  return {
    audioTracks: re.getAvailableAudioTracks(),
    cumulatedPlayTimeInSec: re.getCumulatedPlayTimeInSec(),
    currentErrorDetails: re.getCurrentErrorDetails(),
    durationInSec: re.getDurationInSec(),
    isFullscreenMode: re.isInFullscreenMode(),
    isInPictureInPictureMode: re.isInPictureInPictureMode(),
    isHdPlayback: re.isHdPlayback(),
    isShowingAd: ((ne = re.getPlayerData()) == null ? void 0 : ne.isShowingAd()) ?? !1,
    liveStatus: re.getLiveStatus(),
    liveVariant: ee,
    maxTimeShiftInSec: re.getMaxTimeShiftInSec(),
    mediaMetaData: re.getMediaMetaData(),
    playbackMode: te,
    playbackPosInSec: ((ie = re.getPlayerData()) == null ? void 0 : ie.getCurrentTimeInSec()) ?? 0,
    playbackSpeed: re.getPlaybackSpeed(),
    playerConfiguration: re.getPlayerConfiguration(),
    playerCoordinator: re,
    playerStatus: re.getPlayerStatus(),
    posterImage: re.getPosterImage(),
    selectedAudioTrack: re.getSelectedAudioTrack(),
    selectedSubtitleTrack: re.getSelectedSubtitleTrack(),
    selectedVideoQuality: re.getSelectedVideoQuality(),
    subtitleTracks: re.getSubtitleTracks(),
    timeShiftInSec: re.getTimeShiftInSec(),
    videoBufferLengthInSec: re.getBufferLengthInSec(),
    videoLoaded: re.isVideoLoaded,
    videoQualities: re.getAvailableVideoQualities(),
    isVRVideo: ((ae = re.getPlayerData()) == null ? void 0 : ae.isVRVideo()) ?? !1
  };
}
const PlayerStateContextProvider = ({ children: re }) => {
  const [te, ee] = h$2(defaultPlayerContextState.playerState), [ne, ie] = h$2(), ae = T$1((he) => {
    ie(he);
  }, []);
  p(() => {
    if (!ne)
      return () => {
      };
    const he = (le) => {
      const se = createPlayerStateFromCoordinator(ne);
      ee(se);
    };
    ne.addEventListener(he);
    const _e = createPlayerStateFromCoordinator(ne);
    return ee(_e), () => {
      ne.removeEventListener(he);
    };
  }, [ne]);
  const ce = F$1(() => ({ playerState: te, init: ae }), [te, ae]);
  return /* @__PURE__ */ Cn.createElement(PlayerStateContext.Provider, { value: ce }, re);
}, usePlayerContext = () => {
  const re = q$1(PlayerStateContext);
  if (!re)
    throw new Error("no player state context context found");
  return re;
}, ControlsVisibilityContext = G$1({}), ControlsVisibilityContextProvider = ({ children: re }) => {
  const te = _(-1), {
    playerState: { playerStatus: ee, isInPictureInPictureMode: ne }
  } = usePlayerContext(), [ie, ae] = h$2("fade-in"), [ce, he] = h$2("allow"), [_e, le] = h$2("CLOSED"), [se, oe] = h$2("NOT_HOVERED"), ue = _();
  ue.current = ne;
  const be = _();
  be.current = ee;
  const ve = _();
  ve.current = _e;
  const me = T$1(
    (we) => {
      ae(we), (we === "hide" || we === "fade-out") && le("CLOSED");
    },
    [ae]
  ), pe = T$1(() => {
    window.clearTimeout(te.current), te.current = window.setTimeout(() => {
      ue.current || be.current !== "PAUSED" && ve.current === "CLOSED" && se !== "HOVERED" && me("fade-out");
    }, 3e3);
  }, [se, me]), fe = T$1(() => {
    pe(), me("fade-in");
  }, [me, pe]), ge = T$1(() => {
    window.clearTimeout(te.current), me("fade-in");
  }, [me]), ye = T$1(() => {
    window.clearTimeout(te.current), me("fade-out");
  }, [me]), $e = T$1(() => {
    window.clearTimeout(te.current), me("hide");
  }, [me]), Se = T$1(() => {
    ae((we) => {
      const Pe = we === "fade-in" ? "fade-out" : "fade-in";
      return Pe === "fade-in" && fe(), Pe;
    });
  }, [fe]), Ce = T$1((we) => {
    var Pe;
    oe("NOT_HOVERED"), (Pe = we.target) == null || Pe.removeEventListener("pointerleave", Ce);
  }, []), Ie = T$1(
    (we, Pe = !1) => {
      const Me = we.target.type === "button";
      if (isMouse(we) && Me || Pe) {
        oe("HOVERED");
        const Ae = Me ? we.target : we.currentTarget;
        Ae == null || Ae.addEventListener("pointerleave", Ce);
      }
    },
    [Ce]
  ), Te = T$1((we) => {
    le((Pe) => we === Pe ? "CLOSED" : we);
  }, []);
  p(() => {
    (ee === "PLAYING" || ee === "PAUSED") && fe();
  }, [ee, fe]), p(() => {
    _e === "CLOSED" && fe();
  }, [_e, fe]), p(() => () => {
    window.clearTimeout(te.current);
  }, []);
  const Ee = F$1(
    () => ({
      controlsVisibility: ie,
      showControlsTemporarily: fe,
      showControlsPermanently: ge,
      fadeControlsAway: ye,
      hideControls: $e,
      toggleControlsVisibility: Se,
      allowControlsRendering: ce,
      setAllowControlsRendering: he,
      menuState: _e,
      setMenuState: le,
      onControlsElementEnter: Ie,
      toggleMenu: Te
    }),
    [
      ie,
      fe,
      ge,
      ye,
      $e,
      Se,
      ce,
      he,
      _e,
      le,
      Ie,
      Te
    ]
  );
  return /* @__PURE__ */ Cn.createElement(ControlsVisibilityContext.Provider, { value: Ee }, re);
}, useControlsVisibilityContext = () => q$1(ControlsVisibilityContext), RbupVideoCornerbug = ({ iconComponent: re }) => {
  const {
    playerState: { playerStatus: te }
  } = usePlayerContext(), ee = te === "PLAYING", [ne, ie] = h$2(ee);
  return p(() => {
    ee && ie(!0);
  }, [ee]), /* @__PURE__ */ Cn.createElement("div", { class: "cornerbug" }, re && ne && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-cornerbug": !0, class: "cornerbug__icon" }, re));
}, dashToPascalCase = (re) => re.toLowerCase().split("-").map((te) => te.charAt(0).toUpperCase() + te.slice(1)).join(""), isEventProp = (re) => re.indexOf("on") === 0 && re[2] === re[2].toUpperCase(), normalizeEventPropName = (re) => `on${re[2].toLowerCase()}${re.substring(3)}`;
function createPreactComponent({ tagName: re, defaultProps: te, defineCustomElement: ee }) {
  ee !== void 0 && ee();
  const ne = (ie) => {
    const ae = Object.entries(ie).reduce((ce, [he, _e]) => isEventProp(he) ? Object.assign(Object.assign({}, ce), { [`${normalizeEventPropName(he)}`]: _e }) : Object.assign(Object.assign({}, ce), { [he]: _e }), {});
    return y$1(re, Object.assign(Object.assign({}, te), ae));
  };
  return ne.displayName = `${dashToPascalCase(re)}`, ne;
}
const NAMESPACE = "cosmos-web", BUILD = (
  /* cosmos-web */
  { allRenderFn: !0, appendChildSlotFix: !1, asyncLoading: !0, asyncQueue: !1, attachStyles: !0, cloneNodeFix: !1, cmpDidLoad: !0, cmpDidRender: !0, cmpDidUnload: !1, cmpDidUpdate: !1, cmpShouldUpdate: !1, cmpWillLoad: !0, cmpWillRender: !0, cmpWillUpdate: !1, connectedCallback: !0, constructableCSS: !0, cssAnnotations: !0, devTools: !1, disconnectedCallback: !0, element: !1, event: !0, experimentalScopedSlotChanges: !1, experimentalSlotFixes: !1, formAssociated: !1, hasRenderFn: !0, hostListener: !0, hostListenerTarget: !1, hostListenerTargetBody: !1, hostListenerTargetDocument: !1, hostListenerTargetParent: !1, hostListenerTargetWindow: !1, hotModuleReplacement: !1, hydrateClientSide: !0, hydrateServerSide: !1, hydratedAttribute: !1, hydratedClass: !0, hydratedSelectorName: "hydrated", invisiblePrehydration: !0, isDebug: !1, isDev: !1, isTesting: !1, lazyLoad: !1, lifecycle: !0, lifecycleDOMEvents: !1, member: !0, method: !0, mode: !1, observeAttribute: !0, profile: !1, prop: !0, propBoolean: !0, propMutable: !0, propNumber: !0, propString: !0, reflect: !0, scoped: !1, scopedSlotTextContentFix: !1, scriptDataOpts: !1, shadowDelegatesFocus: !1, shadowDom: !0, slot: !0, slotChildNodesFix: !1, slotRelocation: !0, state: !0, style: !0, svg: !0, taskQueue: !0, updatable: !0, vdomAttribute: !0, vdomClass: !0, vdomFunctional: !0, vdomKey: !0, vdomListener: !0, vdomPropOrAttr: !0, vdomRef: !0, vdomRender: !0, vdomStyle: !0, vdomText: !0, vdomXlink: !1, watchCallback: !0 }
);
var __defProp$1 = Object.defineProperty, __export$1 = (re, te) => {
  for (var ee in te)
    __defProp$1(re, ee, { get: te[ee], enumerable: !0 });
}, EMPTY_OBJ = {}, SVG_NS = "http://www.w3.org/2000/svg", HTML_NS = "http://www.w3.org/1999/xhtml", isDef = (re) => re != null, isComplexType$1 = (re) => (re = typeof re, re === "object" || re === "function");
function queryNonceMetaTagContent(re) {
  var te, ee, ne;
  return (ne = (ee = (te = re.head) == null ? void 0 : te.querySelector('meta[name="csp-nonce"]')) == null ? void 0 : ee.getAttribute("content")) != null ? ne : void 0;
}
var result_exports$1 = {};
__export$1(result_exports$1, {
  err: () => err$1,
  map: () => map$1,
  ok: () => ok$1,
  unwrap: () => unwrap$1,
  unwrapErr: () => unwrapErr$1
});
var ok$1 = (re) => ({
  isOk: !0,
  isErr: !1,
  value: re
}), err$1 = (re) => ({
  isOk: !1,
  isErr: !0,
  value: re
});
function map$1(re, te) {
  if (re.isOk) {
    const ee = te(re.value);
    return ee instanceof Promise ? ee.then((ne) => ok$1(ne)) : ok$1(ee);
  }
  if (re.isErr) {
    const ee = re.value;
    return err$1(ee);
  }
  throw "should never get here";
}
var unwrap$1 = (re) => {
  if (re.isOk)
    return re.value;
  throw re.value;
}, unwrapErr$1 = (re) => {
  if (re.isErr)
    return re.value;
  throw re.value;
}, createTime = (re, te = "") => () => {
}, uniqueTime = (re, te) => () => {
}, CONTENT_REF_ID = "r", ORG_LOCATION_ID = "o", SLOT_NODE_ID = "s", TEXT_NODE_ID = "t", HYDRATE_ID = "s-id", HYDRATED_STYLE_ID = "sty-id", HYDRATE_CHILD_ID = "c-id", SLOT_FB_CSS = "slot-fb{display:contents}slot-fb[hidden]{display:none}", h$1 = (re, te, ...ee) => {
  let ne = null, ie = null, ae = null, ce = !1, he = !1;
  const _e = [], le = (oe) => {
    for (let ue = 0; ue < oe.length; ue++)
      ne = oe[ue], Array.isArray(ne) ? le(ne) : ne != null && typeof ne != "boolean" && ((ce = typeof re != "function" && !isComplexType$1(ne)) && (ne = String(ne)), ce && he ? _e[_e.length - 1].$text$ += ne : _e.push(ce ? newVNode$1(null, ne) : ne), he = ce);
  };
  if (le(ee), te) {
    te.key && (ie = te.key), te.name && (ae = te.name);
    {
      const oe = te.className || te.class;
      oe && (te.class = typeof oe != "object" ? oe : Object.keys(oe).filter((ue) => oe[ue]).join(" "));
    }
  }
  if (typeof re == "function")
    return re(
      te === null ? {} : te,
      _e,
      vdomFnUtils$1
    );
  const se = newVNode$1(re, null);
  return se.$attrs$ = te, _e.length > 0 && (se.$children$ = _e), se.$key$ = ie, se.$name$ = ae, se;
}, newVNode$1 = (re, te) => {
  const ee = {
    $flags$: 0,
    $tag$: re,
    $text$: te,
    $elm$: null,
    $children$: null
  };
  return ee.$attrs$ = null, ee.$key$ = null, ee.$name$ = null, ee;
}, Host = {}, isHost = (re) => re && re.$tag$ === Host, vdomFnUtils$1 = {
  forEach: (re, te) => re.map(convertToPublic$1).forEach(te),
  map: (re, te) => re.map(convertToPublic$1).map(te).map(convertToPrivate$1)
}, convertToPublic$1 = (re) => ({
  vattrs: re.$attrs$,
  vchildren: re.$children$,
  vkey: re.$key$,
  vname: re.$name$,
  vtag: re.$tag$,
  vtext: re.$text$
}), convertToPrivate$1 = (re) => {
  if (typeof re.vtag == "function") {
    const ee = { ...re.vattrs };
    return re.vkey && (ee.key = re.vkey), re.vname && (ee.name = re.vname), h$1(re.vtag, ee, ...re.vchildren || []);
  }
  const te = newVNode$1(re.vtag, re.vtext);
  return te.$attrs$ = re.vattrs, te.$children$ = re.vchildren, te.$key$ = re.vkey, te.$name$ = re.vname, te;
}, initializeClientHydrate = (re, te, ee, ne) => {
  const ie = createTime("hydrateClient", te), ae = re.shadowRoot, ce = [], he = [], _e = ae ? [] : null, le = ne.$vnode$ = newVNode$1(te, null);
  plt.$orgLocNodes$ || initializeDocumentHydrate(doc.body, plt.$orgLocNodes$ = /* @__PURE__ */ new Map()), re[HYDRATE_ID] = ee, re.removeAttribute(HYDRATE_ID), clientHydrate(le, ce, he, _e, re, re, ee), ce.map((se) => {
    const oe = se.$hostId$ + "." + se.$nodeId$, ue = plt.$orgLocNodes$.get(oe), be = se.$elm$;
    ue && supportsShadow && ue["s-en"] === "" && ue.parentNode.insertBefore(be, ue.nextSibling), ae || (be["s-hn"] = te, ue && (be["s-ol"] = ue, be["s-ol"]["s-nr"] = be)), plt.$orgLocNodes$.delete(oe);
  }), ae && _e.map((se) => {
    se && ae.appendChild(se);
  }), ie();
}, clientHydrate = (re, te, ee, ne, ie, ae, ce) => {
  let he, _e, le, se;
  if (ae.nodeType === 1) {
    for (he = ae.getAttribute(HYDRATE_CHILD_ID), he && (_e = he.split("."), (_e[0] === ce || _e[0] === "0") && (le = {
      $flags$: 0,
      $hostId$: _e[0],
      $nodeId$: _e[1],
      $depth$: _e[2],
      $index$: _e[3],
      $tag$: ae.tagName.toLowerCase(),
      $elm$: ae,
      $attrs$: null,
      $children$: null,
      $key$: null,
      $name$: null,
      $text$: null
    }, te.push(le), ae.removeAttribute(HYDRATE_CHILD_ID), re.$children$ || (re.$children$ = []), re.$children$[le.$index$] = le, re = le, ne && le.$depth$ === "0" && (ne[le.$index$] = le.$elm$))), se = ae.childNodes.length - 1; se >= 0; se--)
      clientHydrate(
        re,
        te,
        ee,
        ne,
        ie,
        ae.childNodes[se],
        ce
      );
    if (ae.shadowRoot)
      for (se = ae.shadowRoot.childNodes.length - 1; se >= 0; se--)
        clientHydrate(
          re,
          te,
          ee,
          ne,
          ie,
          ae.shadowRoot.childNodes[se],
          ce
        );
  } else if (ae.nodeType === 8)
    _e = ae.nodeValue.split("."), (_e[1] === ce || _e[1] === "0") && (he = _e[0], le = {
      $flags$: 0,
      $hostId$: _e[1],
      $nodeId$: _e[2],
      $depth$: _e[3],
      $index$: _e[4],
      $elm$: ae,
      $attrs$: null,
      $children$: null,
      $key$: null,
      $name$: null,
      $tag$: null,
      $text$: null
    }, he === TEXT_NODE_ID ? (le.$elm$ = ae.nextSibling, le.$elm$ && le.$elm$.nodeType === 3 && (le.$text$ = le.$elm$.textContent, te.push(le), ae.remove(), re.$children$ || (re.$children$ = []), re.$children$[le.$index$] = le, ne && le.$depth$ === "0" && (ne[le.$index$] = le.$elm$))) : le.$hostId$ === ce && (he === SLOT_NODE_ID ? (le.$tag$ = "slot", _e[5] ? ae["s-sn"] = le.$name$ = _e[5] : ae["s-sn"] = "", ae["s-sr"] = !0, ne && (le.$elm$ = doc.createElement(le.$tag$), le.$name$ && le.$elm$.setAttribute("name", le.$name$), ae.parentNode.insertBefore(le.$elm$, ae), ae.remove(), le.$depth$ === "0" && (ne[le.$index$] = le.$elm$)), ee.push(le), re.$children$ || (re.$children$ = []), re.$children$[le.$index$] = le) : he === CONTENT_REF_ID && (ne ? ae.remove() : (ie["s-cr"] = ae, ae["s-cn"] = !0))));
  else if (re && re.$tag$ === "style") {
    const oe = newVNode$1(null, ae.textContent);
    oe.$elm$ = ae, oe.$index$ = "0", re.$children$ = [oe];
  }
}, initializeDocumentHydrate = (re, te) => {
  if (re.nodeType === 1) {
    let ee = 0;
    for (; ee < re.childNodes.length; ee++)
      initializeDocumentHydrate(re.childNodes[ee], te);
    if (re.shadowRoot)
      for (ee = 0; ee < re.shadowRoot.childNodes.length; ee++)
        initializeDocumentHydrate(re.shadowRoot.childNodes[ee], te);
  } else if (re.nodeType === 8) {
    const ee = re.nodeValue.split(".");
    ee[0] === ORG_LOCATION_ID && (te.set(ee[1] + "." + ee[2], re), re.nodeValue = "", re["s-en"] = ee[3]);
  }
}, parsePropertyValue = (re, te) => re != null && !isComplexType$1(re) ? te & 4 ? re === "false" ? !1 : re === "" || !!re : te & 2 ? parseFloat(re) : te & 1 ? String(re) : re : re, getElement = (re) => re, createEvent = (re, te, ee) => {
  const ne = getElement(re);
  return {
    emit: (ie) => emitEvent(ne, te, {
      bubbles: !!(ee & 4),
      composed: !!(ee & 2),
      cancelable: !!(ee & 1),
      detail: ie
    })
  };
}, emitEvent = (re, te, ee) => {
  const ne = plt.ce(te, ee);
  return re.dispatchEvent(ne), ne;
}, rootAppliedStyles = /* @__PURE__ */ new WeakMap(), registerStyle = (re, te, ee) => {
  let ne = styles$3.get(re);
  supportsConstructableStylesheets && ee ? (ne = ne || new CSSStyleSheet(), typeof ne == "string" ? ne = te : ne.replaceSync(te)) : ne = te, styles$3.set(re, ne);
}, addStyle = (re, te, ee) => {
  var ne;
  const ie = getScopeId(te), ae = styles$3.get(ie);
  if (re = re.nodeType === 11 ? re : doc, ae)
    if (typeof ae == "string") {
      re = re.head || re;
      let ce = rootAppliedStyles.get(re), he;
      if (ce || rootAppliedStyles.set(re, ce = /* @__PURE__ */ new Set()), !ce.has(ie)) {
        if (re.host && (he = re.querySelector(`[${HYDRATED_STYLE_ID}="${ie}"]`)))
          he.innerHTML = ae;
        else {
          he = doc.createElement("style"), he.innerHTML = ae;
          const _e = (ne = plt.$nonce$) != null ? ne : queryNonceMetaTagContent(doc);
          _e != null && he.setAttribute("nonce", _e), re.insertBefore(he, re.querySelector("link"));
        }
        te.$flags$ & 4 && (he.innerHTML += SLOT_FB_CSS), ce && ce.add(ie);
      }
    } else
      re.adoptedStyleSheets.includes(ae) || (re.adoptedStyleSheets = [...re.adoptedStyleSheets, ae]);
  return ie;
}, attachStyles = (re) => {
  const te = re.$cmpMeta$, ee = re.$hostElement$, ne = te.$flags$, ie = createTime("attachStyles", te.$tagName$), ae = addStyle(
    ee.shadowRoot ? ee.shadowRoot : ee.getRootNode(),
    te
  );
  ne & 10 && (ee["s-sc"] = ae, ee.classList.add(ae + "-h")), ie();
}, getScopeId = (re, te) => "sc-" + re.$tagName$, setAccessor = (re, te, ee, ne, ie, ae) => {
  if (ee !== ne) {
    let ce = isMemberInElement(re, te), he = te.toLowerCase();
    if (te === "class") {
      const _e = re.classList, le = parseClassList(ee), se = parseClassList(ne);
      _e.remove(...le.filter((oe) => oe && !se.includes(oe))), _e.add(...se.filter((oe) => oe && !le.includes(oe)));
    } else if (te === "style") {
      for (const _e in ee)
        (!ne || ne[_e] == null) && (_e.includes("-") ? re.style.removeProperty(_e) : re.style[_e] = "");
      for (const _e in ne)
        (!ee || ne[_e] !== ee[_e]) && (_e.includes("-") ? re.style.setProperty(_e, ne[_e]) : re.style[_e] = ne[_e]);
    } else if (te !== "key")
      if (te === "ref")
        ne && ne(re);
      else if (!re.__lookupSetter__(te) && te[0] === "o" && te[1] === "n") {
        if (te[2] === "-" ? te = te.slice(3) : isMemberInElement(win, he) ? te = he.slice(2) : te = he[2] + te.slice(3), ee || ne) {
          const _e = te.endsWith(CAPTURE_EVENT_SUFFIX);
          te = te.replace(CAPTURE_EVENT_REGEX, ""), ee && plt.rel(re, te, ee, _e), ne && plt.ael(re, te, ne, _e);
        }
      } else {
        const _e = isComplexType$1(ne);
        if ((ce || _e && ne !== null) && !ie)
          try {
            if (re.tagName.includes("-"))
              re[te] = ne;
            else {
              const le = ne ?? "";
              te === "list" ? ce = !1 : (ee == null || re[te] != le) && (re[te] = le);
            }
          } catch {
          }
        ne == null || ne === !1 ? (ne !== !1 || re.getAttribute(te) === "") && re.removeAttribute(te) : (!ce || ae & 4 || ie) && !_e && (ne = ne === !0 ? "" : ne, re.setAttribute(te, ne));
      }
  }
}, parseClassListRegex = /\s/, parseClassList = (re) => re ? re.split(parseClassListRegex) : [], CAPTURE_EVENT_SUFFIX = "Capture", CAPTURE_EVENT_REGEX = new RegExp(CAPTURE_EVENT_SUFFIX + "$"), updateElement = (re, te, ee) => {
  const ne = te.$elm$.nodeType === 11 && te.$elm$.host ? te.$elm$.host : te.$elm$, ie = re && re.$attrs$ || EMPTY_OBJ, ae = te.$attrs$ || EMPTY_OBJ;
  for (const ce of sortedAttrNames(Object.keys(ie)))
    ce in ae || setAccessor(ne, ce, ie[ce], void 0, ee, te.$flags$);
  for (const ce of sortedAttrNames(Object.keys(ae)))
    setAccessor(ne, ce, ie[ce], ae[ce], ee, te.$flags$);
};
function sortedAttrNames(re) {
  return re.includes("ref") ? (
    // we need to sort these to ensure that `'ref'` is the last attr
    [...re.filter((te) => te !== "ref"), "ref"]
  ) : (
    // no need to sort, return the original array
    re
  );
}
var scopeId, contentRef, hostTagName, useNativeShadowDom = !1, checkSlotFallbackVisibility = !1, checkSlotRelocate = !1, isSvgMode = !1, createElm = (re, te, ee, ne) => {
  var ie;
  const ae = te.$children$[ee];
  let ce = 0, he, _e, le;
  if (useNativeShadowDom || (checkSlotRelocate = !0, ae.$tag$ === "slot" && (scopeId && ne.classList.add(scopeId + "-s"), ae.$flags$ |= ae.$children$ ? (
    // slot element has fallback content
    // still create an element that "mocks" the slot element
    2
  ) : (
    // slot element does not have fallback content
    // create an html comment we'll use to always reference
    // where actual slot content should sit next to
    1
  ))), ae.$text$ !== null)
    he = ae.$elm$ = doc.createTextNode(ae.$text$);
  else if (ae.$flags$ & 1)
    he = ae.$elm$ = doc.createTextNode("");
  else {
    if (isSvgMode || (isSvgMode = ae.$tag$ === "svg"), he = ae.$elm$ = doc.createElementNS(
      isSvgMode ? SVG_NS : HTML_NS,
      ae.$flags$ & 2 ? "slot-fb" : ae.$tag$
    ), isSvgMode && ae.$tag$ === "foreignObject" && (isSvgMode = !1), updateElement(null, ae, isSvgMode), isDef(scopeId) && he["s-si"] !== scopeId && he.classList.add(he["s-si"] = scopeId), ae.$children$)
      for (ce = 0; ce < ae.$children$.length; ++ce)
        _e = createElm(re, ae, ce, he), _e && he.appendChild(_e);
    ae.$tag$ === "svg" ? isSvgMode = !1 : he.tagName === "foreignObject" && (isSvgMode = !0);
  }
  return he["s-hn"] = hostTagName, ae.$flags$ & 3 && (he["s-sr"] = !0, he["s-cr"] = contentRef, he["s-sn"] = ae.$name$ || "", he["s-rf"] = (ie = ae.$attrs$) == null ? void 0 : ie.ref, le = re && re.$children$ && re.$children$[ee], le && le.$tag$ === ae.$tag$ && re.$elm$ && putBackInOriginalLocation(re.$elm$, !1)), he;
}, putBackInOriginalLocation = (re, te) => {
  plt.$flags$ |= 1;
  const ee = Array.from(re.childNodes);
  if (re["s-sr"] && BUILD.experimentalSlotFixes) {
    let ne = re;
    for (; ne = ne.nextSibling; )
      ne && ne["s-sn"] === re["s-sn"] && ne["s-sh"] === hostTagName && ee.push(ne);
  }
  for (let ne = ee.length - 1; ne >= 0; ne--) {
    const ie = ee[ne];
    ie["s-hn"] !== hostTagName && ie["s-ol"] && (insertBefore(parentReferenceNode(ie), ie, referenceNode(ie)), ie["s-ol"].remove(), ie["s-ol"] = void 0, ie["s-sh"] = void 0, checkSlotRelocate = !0), te && putBackInOriginalLocation(ie, te);
  }
  plt.$flags$ &= -2;
}, addVnodes = (re, te, ee, ne, ie, ae) => {
  let ce = re["s-cr"] && re["s-cr"].parentNode || re, he;
  for (ce.shadowRoot && ce.tagName === hostTagName && (ce = ce.shadowRoot); ie <= ae; ++ie)
    ne[ie] && (he = createElm(null, ee, ie, re), he && (ne[ie].$elm$ = he, insertBefore(ce, he, referenceNode(te))));
}, removeVnodes = (re, te, ee) => {
  for (let ne = te; ne <= ee; ++ne) {
    const ie = re[ne];
    if (ie) {
      const ae = ie.$elm$;
      nullifyVNodeRefs(ie), ae && (checkSlotFallbackVisibility = !0, ae["s-ol"] ? ae["s-ol"].remove() : putBackInOriginalLocation(ae, !0), ae.remove());
    }
  }
}, updateChildren = (re, te, ee, ne, ie = !1) => {
  let ae = 0, ce = 0, he = 0, _e = 0, le = te.length - 1, se = te[0], oe = te[le], ue = ne.length - 1, be = ne[0], ve = ne[ue], me, pe;
  for (; ae <= le && ce <= ue; )
    if (se == null)
      se = te[++ae];
    else if (oe == null)
      oe = te[--le];
    else if (be == null)
      be = ne[++ce];
    else if (ve == null)
      ve = ne[--ue];
    else if (isSameVnode(se, be, ie))
      patch(se, be, ie), se = te[++ae], be = ne[++ce];
    else if (isSameVnode(oe, ve, ie))
      patch(oe, ve, ie), oe = te[--le], ve = ne[--ue];
    else if (isSameVnode(se, ve, ie))
      (se.$tag$ === "slot" || ve.$tag$ === "slot") && putBackInOriginalLocation(se.$elm$.parentNode, !1), patch(se, ve, ie), insertBefore(re, se.$elm$, oe.$elm$.nextSibling), se = te[++ae], ve = ne[--ue];
    else if (isSameVnode(oe, be, ie))
      (se.$tag$ === "slot" || ve.$tag$ === "slot") && putBackInOriginalLocation(oe.$elm$.parentNode, !1), patch(oe, be, ie), insertBefore(re, oe.$elm$, se.$elm$), oe = te[--le], be = ne[++ce];
    else {
      for (he = -1, _e = ae; _e <= le; ++_e)
        if (te[_e] && te[_e].$key$ !== null && te[_e].$key$ === be.$key$) {
          he = _e;
          break;
        }
      he >= 0 ? (pe = te[he], pe.$tag$ !== be.$tag$ ? me = createElm(te && te[ce], ee, he, re) : (patch(pe, be, ie), te[he] = void 0, me = pe.$elm$), be = ne[++ce]) : (me = createElm(te && te[ce], ee, ce, re), be = ne[++ce]), me && insertBefore(parentReferenceNode(se.$elm$), me, referenceNode(se.$elm$));
    }
  ae > le ? addVnodes(
    re,
    ne[ue + 1] == null ? null : ne[ue + 1].$elm$,
    ee,
    ne,
    ce,
    ue
  ) : ce > ue && removeVnodes(te, ae, le);
}, isSameVnode = (re, te, ee = !1) => re.$tag$ === te.$tag$ ? re.$tag$ === "slot" ? re.$name$ === te.$name$ : ee ? !0 : re.$key$ === te.$key$ : !1, referenceNode = (re) => re && re["s-ol"] || re, parentReferenceNode = (re) => (re["s-ol"] ? re["s-ol"] : re).parentNode, patch = (re, te, ee = !1) => {
  const ne = te.$elm$ = re.$elm$, ie = re.$children$, ae = te.$children$, ce = te.$tag$, he = te.$text$;
  let _e;
  he === null ? (isSvgMode = ce === "svg" ? !0 : ce === "foreignObject" ? !1 : isSvgMode, ce === "slot" && !useNativeShadowDom || updateElement(re, te, isSvgMode), ie !== null && ae !== null ? updateChildren(ne, ie, te, ae, ee) : ae !== null ? (re.$text$ !== null && (ne.textContent = ""), addVnodes(ne, null, te, ae, 0, ae.length - 1)) : ie !== null && removeVnodes(ie, 0, ie.length - 1), isSvgMode && ce === "svg" && (isSvgMode = !1)) : (_e = ne["s-cr"]) ? _e.parentNode.textContent = he : re.$text$ !== he && (ne.data = he);
}, updateFallbackSlotVisibility = (re) => {
  const te = re.childNodes;
  for (const ee of te)
    if (ee.nodeType === 1) {
      if (ee["s-sr"]) {
        const ne = ee["s-sn"];
        ee.hidden = !1;
        for (const ie of te)
          if (ie !== ee) {
            if (ie["s-hn"] !== ee["s-hn"] || ne !== "") {
              if (ie.nodeType === 1 && (ne === ie.getAttribute("slot") || ne === ie["s-sn"]) || ie.nodeType === 3 && ne === ie["s-sn"]) {
                ee.hidden = !0;
                break;
              }
            } else if (ie.nodeType === 1 || ie.nodeType === 3 && ie.textContent.trim() !== "") {
              ee.hidden = !0;
              break;
            }
          }
      }
      updateFallbackSlotVisibility(ee);
    }
}, relocateNodes = [], markSlotContentForRelocation = (re) => {
  let te, ee, ne;
  for (const ie of re.childNodes) {
    if (ie["s-sr"] && (te = ie["s-cr"]) && te.parentNode) {
      ee = te.parentNode.childNodes;
      const ae = ie["s-sn"];
      for (ne = ee.length - 1; ne >= 0; ne--)
        if (te = ee[ne], !te["s-cn"] && !te["s-nr"] && te["s-hn"] !== ie["s-hn"] && !BUILD.experimentalSlotFixes)
          if (isNodeLocatedInSlot(te, ae)) {
            let ce = relocateNodes.find((he) => he.$nodeToRelocate$ === te);
            checkSlotFallbackVisibility = !0, te["s-sn"] = te["s-sn"] || ae, ce ? (ce.$nodeToRelocate$["s-sh"] = ie["s-hn"], ce.$slotRefNode$ = ie) : (te["s-sh"] = ie["s-hn"], relocateNodes.push({
              $slotRefNode$: ie,
              $nodeToRelocate$: te
            })), te["s-sr"] && relocateNodes.map((he) => {
              isNodeLocatedInSlot(he.$nodeToRelocate$, te["s-sn"]) && (ce = relocateNodes.find((_e) => _e.$nodeToRelocate$ === te), ce && !he.$slotRefNode$ && (he.$slotRefNode$ = ce.$slotRefNode$));
            });
          } else
            relocateNodes.some((ce) => ce.$nodeToRelocate$ === te) || relocateNodes.push({
              $nodeToRelocate$: te
            });
    }
    ie.nodeType === 1 && markSlotContentForRelocation(ie);
  }
}, isNodeLocatedInSlot = (re, te) => re.nodeType === 1 ? re.getAttribute("slot") === null && te === "" || re.getAttribute("slot") === te : re["s-sn"] === te ? !0 : te === "", nullifyVNodeRefs = (re) => {
  re.$attrs$ && re.$attrs$.ref && re.$attrs$.ref(null), re.$children$ && re.$children$.map(nullifyVNodeRefs);
}, insertBefore = (re, te, ee) => re == null ? void 0 : re.insertBefore(te, ee), renderVdom = (re, te, ee = !1) => {
  var ne, ie, ae, ce;
  const he = re.$hostElement$, _e = re.$cmpMeta$, le = re.$vnode$ || newVNode$1(null, null), se = isHost(te) ? te : h$1(null, null, te);
  if (hostTagName = he.tagName, _e.$attrsToReflect$ && (se.$attrs$ = se.$attrs$ || {}, _e.$attrsToReflect$.map(
    ([oe, ue]) => se.$attrs$[ue] = he[oe]
  )), ee && se.$attrs$)
    for (const oe of Object.keys(se.$attrs$))
      he.hasAttribute(oe) && !["key", "ref", "style", "class"].includes(oe) && (se.$attrs$[oe] = he[oe]);
  se.$tag$ = null, se.$flags$ |= 4, re.$vnode$ = se, se.$elm$ = le.$elm$ = he.shadowRoot || he, scopeId = he["s-sc"], useNativeShadowDom = (_e.$flags$ & 1) !== 0, contentRef = he["s-cr"], checkSlotFallbackVisibility = !1, patch(le, se, ee);
  {
    if (plt.$flags$ |= 1, checkSlotRelocate) {
      markSlotContentForRelocation(se.$elm$);
      for (const oe of relocateNodes) {
        const ue = oe.$nodeToRelocate$;
        if (!ue["s-ol"]) {
          const be = doc.createTextNode("");
          be["s-nr"] = ue, insertBefore(ue.parentNode, ue["s-ol"] = be, ue);
        }
      }
      for (const oe of relocateNodes) {
        const ue = oe.$nodeToRelocate$, be = oe.$slotRefNode$;
        if (be) {
          const ve = be.parentNode;
          let me = be.nextSibling;
          {
            let pe = (ne = ue["s-ol"]) == null ? void 0 : ne.previousSibling;
            for (; pe; ) {
              let fe = (ie = pe["s-nr"]) != null ? ie : null;
              if (fe && fe["s-sn"] === ue["s-sn"] && ve === fe.parentNode) {
                for (fe = fe.nextSibling; fe === ue || fe != null && fe["s-sr"]; )
                  fe = fe == null ? void 0 : fe.nextSibling;
                if (!fe || !fe["s-nr"]) {
                  me = fe;
                  break;
                }
              }
              pe = pe.previousSibling;
            }
          }
          (!me && ve !== ue.parentNode || ue.nextSibling !== me) && ue !== me && (!ue["s-hn"] && ue["s-ol"] && (ue["s-hn"] = ue["s-ol"].parentNode.nodeName), insertBefore(ve, ue, me), ue.nodeType === 1 && (ue.hidden = (ae = ue["s-ih"]) != null ? ae : !1)), ue && typeof be["s-rf"] == "function" && be["s-rf"](ue);
        } else
          ue.nodeType === 1 && (ee && (ue["s-ih"] = (ce = ue.hidden) != null ? ce : !1), ue.hidden = !0);
      }
    }
    checkSlotFallbackVisibility && updateFallbackSlotVisibility(se.$elm$), plt.$flags$ &= -2, relocateNodes.length = 0;
  }
  contentRef = void 0;
}, attachToAncestor = (re, te) => {
  te && !re.$onRenderResolve$ && te["s-p"] && te["s-p"].push(new Promise((ee) => re.$onRenderResolve$ = ee));
}, scheduleUpdate = (re, te) => {
  if (re.$flags$ |= 16, re.$flags$ & 4) {
    re.$flags$ |= 512;
    return;
  }
  return attachToAncestor(re, re.$ancestorComponent$), writeTask(() => dispatchHooks(re, te));
}, dispatchHooks = (re, te) => {
  const ee = re.$hostElement$, ne = createTime("scheduleUpdate", re.$cmpMeta$.$tagName$), ie = ee;
  if (!ie)
    throw new Error(
      `Can't render component <${ee.tagName.toLowerCase()} /> with invalid Stencil runtime! Make sure this imported component is compiled with a \`externalRuntime: true\` flag. For more information, please refer to https://stenciljs.com/docs/custom-elements#externalruntime`
    );
  let ae;
  return te && (ae = safeCall(ie, "componentWillLoad")), ae = enqueue(ae, () => safeCall(ie, "componentWillRender")), ne(), enqueue(ae, () => updateComponent(re, ie, te));
}, enqueue = (re, te) => isPromisey(re) ? re.then(te) : te(), isPromisey = (re) => re instanceof Promise || re && re.then && typeof re.then == "function", updateComponent = async (re, te, ee) => {
  var ne;
  const ie = re.$hostElement$, ae = createTime("update", re.$cmpMeta$.$tagName$), ce = ie["s-rc"];
  ee && attachStyles(re);
  const he = createTime("render", re.$cmpMeta$.$tagName$);
  callRender(re, te, ie, ee), ce && (ce.map((_e) => _e()), ie["s-rc"] = void 0), he(), ae();
  {
    const _e = (ne = ie["s-p"]) != null ? ne : [], le = () => postUpdateComponent(re);
    _e.length === 0 ? le() : (Promise.all(_e).then(le), re.$flags$ |= 4, _e.length = 0);
  }
}, callRender = (re, te, ee, ne) => {
  try {
    te = te.render(), re.$flags$ &= -17, re.$flags$ |= 2, renderVdom(re, te, ne);
  } catch (ie) {
    consoleError(ie, re.$hostElement$);
  }
  return null;
}, postUpdateComponent = (re) => {
  const te = re.$cmpMeta$.$tagName$, ee = re.$hostElement$, ne = createTime("postUpdate", te), ie = ee, ae = re.$ancestorComponent$;
  safeCall(ie, "componentDidRender"), re.$flags$ & 64 ? ne() : (re.$flags$ |= 64, addHydratedFlag(ee), safeCall(ie, "componentDidLoad"), ne(), re.$onReadyResolve$(ee), ae || appDidLoad()), re.$onRenderResolve$ && (re.$onRenderResolve$(), re.$onRenderResolve$ = void 0), re.$flags$ & 512 && nextTick$1(() => scheduleUpdate(re, !1)), re.$flags$ &= -517;
}, forceUpdate = (re) => {
  {
    const te = getHostRef(re), ee = te.$hostElement$.isConnected;
    return ee && (te.$flags$ & 18) === 2 && scheduleUpdate(te, !1), ee;
  }
}, appDidLoad = (re) => {
  addHydratedFlag(doc.documentElement), nextTick$1(() => emitEvent(win, "appload", { detail: { namespace: NAMESPACE } }));
}, safeCall = (re, te, ee) => {
  if (re && re[te])
    try {
      return re[te](ee);
    } catch (ne) {
      consoleError(ne);
    }
}, addHydratedFlag = (re) => {
  var te;
  return re.classList.add((te = BUILD.hydratedSelectorName) != null ? te : "hydrated");
}, getValue = (re, te) => getHostRef(re).$instanceValues$.get(te), setValue = (re, te, ee, ne) => {
  const ie = getHostRef(re), ae = re, ce = ie.$instanceValues$.get(te), he = ie.$flags$, _e = ae;
  ee = parsePropertyValue(ee, ne.$members$[te][0]);
  const le = Number.isNaN(ce) && Number.isNaN(ee);
  if (ee !== ce && !le) {
    ie.$instanceValues$.set(te, ee);
    {
      if (ne.$watchers$ && he & 128) {
        const oe = ne.$watchers$[te];
        oe && oe.map((ue) => {
          try {
            _e[ue](ee, ce, te);
          } catch (be) {
            consoleError(be, ae);
          }
        });
      }
      (he & 18) === 2 && scheduleUpdate(ie, !1);
    }
  }
}, proxyComponent = (re, te, ee) => {
  var ne;
  const ie = re.prototype;
  if (te.$members$) {
    re.watchers && (te.$watchers$ = re.watchers);
    const ae = Object.entries(te.$members$);
    ae.map(([ce, [he]]) => {
      (he & 31 || he & 32) && Object.defineProperty(ie, ce, {
        get() {
          return getValue(this, ce);
        },
        set(_e) {
          setValue(this, ce, _e, te);
        },
        configurable: !0,
        enumerable: !0
      });
    });
    {
      const ce = /* @__PURE__ */ new Map();
      ie.attributeChangedCallback = function(he, _e, le) {
        plt.jmp(() => {
          var se;
          const oe = ce.get(he);
          if (this.hasOwnProperty(oe))
            le = this[oe], delete this[oe];
          else {
            if (ie.hasOwnProperty(oe) && typeof this[oe] == "number" && this[oe] == le)
              return;
            if (oe == null) {
              const ue = getHostRef(this), be = ue == null ? void 0 : ue.$flags$;
              if (be && !(be & 8) && be & 128 && le !== _e) {
                const me = this, pe = (se = te.$watchers$) == null ? void 0 : se[he];
                pe == null || pe.forEach((fe) => {
                  me[fe] != null && me[fe].call(me, le, _e, he);
                });
              }
              return;
            }
          }
          this[oe] = le === null && typeof this[oe] == "boolean" ? !1 : le;
        });
      }, re.observedAttributes = Array.from(
        /* @__PURE__ */ new Set([
          ...Object.keys((ne = te.$watchers$) != null ? ne : {}),
          ...ae.filter(
            ([he, _e]) => _e[0] & 15
            /* HasAttribute */
          ).map(([he, _e]) => {
            var le;
            const se = _e[1] || he;
            return ce.set(se, he), _e[0] & 512 && ((le = te.$attrsToReflect$) == null || le.push([he, se])), se;
          })
        ])
      );
    }
  }
  return re;
}, initializeComponent = async (re, te, ee, ne) => {
  let ie;
  if (!(te.$flags$ & 32)) {
    if (te.$flags$ |= 32, ee.$lazyBundleId$) {
      const _e = loadModule(ee);
      if (_e && "then" in _e) {
        const se = uniqueTime();
        ie = await _e, se();
      } else
        ie = _e;
      if (!ie)
        throw new Error(`Constructor for "${ee.$tagName$}#${te.$modeName$}" was not found`);
      ie.isProxied || (ee.$watchers$ = ie.watchers, proxyComponent(ie, ee), ie.isProxied = !0);
      const le = createTime("createInstance", ee.$tagName$);
      te.$flags$ |= 8;
      try {
        new ie(te);
      } catch (se) {
        consoleError(se);
      }
      te.$flags$ &= -9, te.$flags$ |= 128, le();
    } else {
      ie = re.constructor;
      const _e = re.localName;
      customElements.whenDefined(_e).then(
        () => te.$flags$ |= 128
        /* isWatchReady */
      );
    }
    if (ie && ie.style) {
      let _e = ie.style;
      const le = getScopeId(ee);
      if (!styles$3.has(le)) {
        const se = createTime("registerStyles", ee.$tagName$);
        registerStyle(le, _e, !!(ee.$flags$ & 1)), se();
      }
    }
  }
  const ae = te.$ancestorComponent$, ce = () => scheduleUpdate(te, !0);
  ae && ae["s-rc"] ? ae["s-rc"].push(ce) : ce();
}, fireConnectedCallback = (re) => {
}, connectedCallback = (re) => {
  if (!(plt.$flags$ & 1)) {
    const te = getHostRef(re), ee = te.$cmpMeta$, ne = createTime("connectedCallback", ee.$tagName$);
    if (te.$flags$ & 1)
      addHostEventListeners(re, te, ee.$listeners$), te != null && te.$lazyInstance$ || te != null && te.$onReadyPromise$ && te.$onReadyPromise$.then(() => fireConnectedCallback());
    else {
      te.$flags$ |= 1;
      let ie;
      if (ie = re.getAttribute(HYDRATE_ID), ie) {
        if (ee.$flags$ & 1) {
          const ae = addStyle(re.shadowRoot, ee);
          re.classList.remove(ae + "-h", ae + "-s");
        }
        initializeClientHydrate(re, ee.$tagName$, ie, te);
      }
      ie || // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
      ee.$flags$ & 12 && setContentReference(re);
      {
        let ae = re;
        for (; ae = ae.parentNode || ae.host; )
          if (ae.nodeType === 1 && ae.hasAttribute("s-id") && ae["s-p"] || ae["s-p"]) {
            attachToAncestor(te, te.$ancestorComponent$ = ae);
            break;
          }
      }
      ee.$members$ && Object.entries(ee.$members$).map(([ae, [ce]]) => {
        if (ce & 31 && re.hasOwnProperty(ae)) {
          const he = re[ae];
          delete re[ae], re[ae] = he;
        }
      }), initializeComponent(re, te, ee);
    }
    ne();
  }
}, setContentReference = (re) => {
  const te = re["s-cr"] = doc.createComment(
    ""
  );
  te["s-cn"] = !0, insertBefore(re, te, re.firstChild);
}, disconnectedCallback = async (re) => {
  if (!(plt.$flags$ & 1)) {
    const te = getHostRef(re);
    te.$rmListeners$ && (te.$rmListeners$.map((ee) => ee()), te.$rmListeners$ = void 0);
  }
}, proxyCustomElement = (re, te) => {
  const ee = {
    $flags$: te[0],
    $tagName$: te[1]
  };
  ee.$members$ = te[2], ee.$listeners$ = te[3], ee.$watchers$ = re.$watchers$, ee.$attrsToReflect$ = [];
  const ne = re.prototype.connectedCallback, ie = re.prototype.disconnectedCallback;
  return Object.assign(re.prototype, {
    __registerHost() {
      registerHost(this, ee);
    },
    connectedCallback() {
      connectedCallback(this), ne && ne.call(this);
    },
    disconnectedCallback() {
      disconnectedCallback(this), ie && ie.call(this);
    },
    __attachShadow() {
      this.attachShadow({ mode: "open" });
    }
  }), re.is = ee.$tagName$, proxyComponent(re, ee);
}, addHostEventListeners = (re, te, ee, ne) => {
  ee && ee.map(([ie, ae, ce]) => {
    const he = re, _e = hostListenerProxy(te, ce), le = hostListenerOpts(ie);
    plt.ael(he, ae, _e, le), (te.$rmListeners$ = te.$rmListeners$ || []).push(() => plt.rel(he, ae, _e, le));
  });
}, hostListenerProxy = (re, te) => (ee) => {
  try {
    re.$hostElement$[te](ee);
  } catch (ne) {
    consoleError(ne);
  }
}, hostListenerOpts = (re) => supportsListenerOptions ? {
  passive: (re & 1) !== 0,
  capture: (re & 2) !== 0
} : (re & 2) !== 0, hostRefs = /* @__PURE__ */ new WeakMap(), getHostRef = (re) => hostRefs.get(re), registerHost = (re, te) => {
  const ee = {
    $flags$: 0,
    $hostElement$: re,
    $cmpMeta$: te,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  return ee.$onReadyPromise$ = new Promise((ne) => ee.$onReadyResolve$ = ne), re["s-p"] = [], re["s-rc"] = [], addHostEventListeners(re, ee, te.$listeners$), hostRefs.set(re, ee);
}, isMemberInElement = (re, te) => te in re, consoleError = (re, te) => (0, console.error)(re, te), cmpModules = /* @__PURE__ */ new Map(), loadModule = (re, te, ee) => {
  const ne = re.$tagName$.replace(/-/g, "_"), ie = re.$lazyBundleId$;
  if (!ie)
    return;
  const ae = cmpModules.get(ie);
  if (ae)
    return ae[ne];
  /*!__STENCIL_STATIC_IMPORT_SWITCH__*/
  return import(
    /* @vite-ignore */
    /* webpackInclude: /\.entry\.js$/ */
    /* webpackExclude: /\.system\.entry\.js$/ */
    /* webpackMode: "lazy" */
    `./${ie}.entry.js`
  ).then((ce) => (cmpModules.set(ie, ce), ce[ne]), consoleError);
}, styles$3 = /* @__PURE__ */ new Map(), win = typeof window < "u" ? window : {}, doc = win.document || { head: {} }, H = win.HTMLElement || class {
}, plt = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (re) => re(),
  raf: (re) => requestAnimationFrame(re),
  ael: (re, te, ee, ne) => re.addEventListener(te, ee, ne),
  rel: (re, te, ee, ne) => re.removeEventListener(te, ee, ne),
  ce: (re, te) => new CustomEvent(re, te)
}, supportsShadow = (
  // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
  !0
), supportsListenerOptions = /* @__PURE__ */ (() => {
  let re = !1;
  try {
    doc.addEventListener(
      "e",
      null,
      Object.defineProperty({}, "passive", {
        get() {
          re = !0;
        }
      })
    );
  } catch {
  }
  return re;
})(), promiseResolve = (re) => Promise.resolve(re), supportsConstructableStylesheets = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), queuePending = !1, queueDomReads = [], queueDomWrites = [], queueTask = (re, te) => (ee) => {
  re.push(ee), queuePending || (queuePending = !0, te && plt.$flags$ & 4 ? nextTick$1(flush) : plt.raf(flush));
}, consume = (re) => {
  for (let te = 0; te < re.length; te++)
    try {
      re[te](performance.now());
    } catch (ee) {
      consoleError(ee);
    }
  re.length = 0;
}, flush = () => {
  consume(queueDomReads), consume(queueDomWrites), (queuePending = queueDomReads.length > 0) && plt.raf(flush);
}, nextTick$1 = (re) => promiseResolve().then(re), writeTask = /* @__PURE__ */ queueTask(queueDomWrites, !0), __defProp = Object.defineProperty, __export = (re, te) => {
  for (var ee in te)
    __defProp(re, ee, { get: te[ee], enumerable: !0 });
}, isComplexType = (re) => (re = typeof re, re === "object" || re === "function"), result_exports = {};
__export(result_exports, {
  err: () => err,
  map: () => map,
  ok: () => ok,
  unwrap: () => unwrap,
  unwrapErr: () => unwrapErr
});
var ok = (re) => ({
  isOk: !0,
  isErr: !1,
  value: re
}), err = (re) => ({
  isOk: !1,
  isErr: !0,
  value: re
});
function map(re, te) {
  if (re.isOk) {
    const ee = te(re.value);
    return ee instanceof Promise ? ee.then((ne) => ok(ne)) : ok(ee);
  }
  if (re.isErr) {
    const ee = re.value;
    return err(ee);
  }
  throw "should never get here";
}
var unwrap = (re) => {
  if (re.isOk)
    return re.value;
  throw re.value;
}, unwrapErr = (re) => {
  if (re.isErr)
    return re.value;
  throw re.value;
}, h = (re, te, ...ee) => {
  let ne = null, ie = null, ae = null, ce = !1, he = !1;
  const _e = [], le = (oe) => {
    for (let ue = 0; ue < oe.length; ue++)
      ne = oe[ue], Array.isArray(ne) ? le(ne) : ne != null && typeof ne != "boolean" && ((ce = typeof re != "function" && !isComplexType(ne)) && (ne = String(ne)), ce && he ? _e[_e.length - 1].$text$ += ne : _e.push(ce ? newVNode(null, ne) : ne), he = ce);
  };
  if (le(ee), te) {
    te.key && (ie = te.key), te.name && (ae = te.name);
    {
      const oe = te.className || te.class;
      oe && (te.class = typeof oe != "object" ? oe : Object.keys(oe).filter((ue) => oe[ue]).join(" "));
    }
  }
  if (typeof re == "function")
    return re(
      te === null ? {} : te,
      _e,
      vdomFnUtils
    );
  const se = newVNode(re, null);
  return se.$attrs$ = te, _e.length > 0 && (se.$children$ = _e), se.$key$ = ie, se.$name$ = ae, se;
}, newVNode = (re, te) => {
  const ee = {
    $flags$: 0,
    $tag$: re,
    $text$: te,
    $elm$: null,
    $children$: null
  };
  return ee.$attrs$ = null, ee.$key$ = null, ee.$name$ = null, ee;
}, vdomFnUtils = {
  forEach: (re, te) => re.map(convertToPublic).forEach(te),
  map: (re, te) => re.map(convertToPublic).map(te).map(convertToPrivate)
}, convertToPublic = (re) => ({
  vattrs: re.$attrs$,
  vchildren: re.$children$,
  vkey: re.$key$,
  vname: re.$name$,
  vtag: re.$tag$,
  vtext: re.$text$
}), convertToPrivate = (re) => {
  if (typeof re.vtag == "function") {
    const ee = { ...re.vattrs };
    return re.vkey && (ee.key = re.vkey), re.vname && (ee.name = re.vname), h(re.vtag, ee, ...re.vchildren || []);
  }
  const te = newVNode(re.vtag, re.vtext);
  return te.$attrs$ = re.vattrs, te.$children$ = re.vchildren, te.$key$ = re.vkey, te.$name$ = re.vname, te;
};
const defaultOptions = {
  elementDelimiter: "__",
  modifierDelimiter: "--",
  namespace: "",
  namespaceDelimiter: "-",
  strict: !0
};
function setup({ elementDelimiter: re, modifierDelimiter: te, namespace: ee, namespaceDelimiter: ne, strict: ie }) {
  typeof re == "string" && (defaultOptions.elementDelimiter = re), typeof te == "string" && (defaultOptions.modifierDelimiter = te), (typeof ee == "string" || Array.isArray(ee)) && (defaultOptions.namespace = ee), typeof ne == "string" && (defaultOptions.namespaceDelimiter = ne), typeof ie == "boolean" && (defaultOptions.strict = ie);
}
const uniqueChars = (re) => re.join("").split("").filter((te, ee, ne) => ne.indexOf(te) === ee), includesChars = (re, te) => te.some((ee) => re.includes(ee)), invalidMessage = (re, te, ee) => {
  const ne = `"${ee.join('", "')}"`;
  return `The ${re} ("${te}") must not use the characters contained within the delimiters (${ne}).`;
};
function bem$1(re, te = {}) {
  const { elementDelimiter: ee, modifierDelimiter: ne, namespace: ie, namespaceDelimiter: ae, strict: ce } = {
    ...defaultOptions,
    ...te
  }, _e = `${[].concat(ie).filter(Boolean).reduce((oe, ue) => `${oe}${ue}${ae}`, "")}${re}`, le = ce ? [ae, ee, ne] : [], se = ce ? uniqueChars(le) : [];
  return function(ue, be) {
    if (ue == null)
      return _e;
    const ve = typeof ue == "string" ? ue : null;
    if (ce && ve != null && includesChars(ve, se))
      throw new Error(invalidMessage("element", ve, le));
    const me = ve == null ? _e : `${_e}${ee}${ve}`, pe = typeof ue == "string" ? be : ue;
    if (pe == null)
      return me;
    const fe = (ge, ye) => {
      if (ye != null && ye !== "") {
        if (ce && includesChars(ye, se))
          throw new Error(invalidMessage("modifier", ye, le));
        return `${ge} ${me}${ne}${ye}`;
      }
      return ge;
    };
    return Array.isArray(pe) ? pe.reduce(fe, me) : Object.keys(pe).filter((ge) => pe[ge]).reduce(fe, me);
  };
}
setup({
  strict: !1
});
const transformModifierToArray = (re) => typeof re != "object" ? re : Object.keys(re).reduce((te, ee) => {
  const ne = re[ee];
  if (!ne)
    return te;
  if (ne === !0)
    return [...te, ee];
  if (typeof ne == "object") {
    const ie = Object.keys(ne).map((ae) => `${ee}-${ne[ae]}@${ae}`);
    return [...te, ...ie];
  }
  return [...te, `${ee}-${ne}`];
}, []), bem = (re) => (te, ee) => {
  const ne = typeof te == "string" ? te : transformModifierToArray(te);
  return bem$1(re)(ne, transformModifierToArray(ee));
}, global$1 = typeof window > "u" ? {} : window;
var Vt, zt;
let disableWarnings = !!((Vt = global$1.cosmosConfig) != null && Vt.disableWarnings) || !!((zt = global$1.gravityConfig) != null && zt.disableWarnings);
const config = {
  get disableWarnings() {
    return disableWarnings;
  },
  set disableWarnings(re) {
    disableWarnings = re;
  }
};
global$1.cosmosConfig = config;
global$1.gravityConfig = config;
const nextTick = () => new Promise((re) => {
  requestAnimationFrame(() => requestAnimationFrame(() => {
    re();
  }));
});
class CSSTransition {
  constructor() {
    this.classNames = {
      enter: "enter",
      leave: "leave"
    }, this.timeouts = {
      enter: void 0,
      leave: void 0
    };
  }
  async enter(te, ee) {
    if (!te)
      return Promise.reject();
    const ne = this.getClassNames();
    return this.clearTimeouts(), this.clearClassNames(te), this.addClassName(te, ne.enter), await this.addClassNameOnNextTick(te, ne.enterActive), new Promise((ie) => {
      this.timeouts.enter = setTimeout(() => {
        this.clearClassNames(te), ie();
      }, ee);
    });
  }
  async leave(te, ee) {
    if (!te)
      return Promise.reject();
    const ne = this.getClassNames();
    return this.clearTimeouts(), this.clearClassNames(te), this.addClassName(te, ne.leave), await this.addClassNameOnNextTick(te, ne.leaveActive), new Promise((ie) => {
      this.timeouts.leave = setTimeout(() => {
        this.clearClassNames(te), ie();
      }, ee);
    });
  }
  getClassNames() {
    return {
      enter: this.classNames.enter,
      enterActive: `${this.classNames.enter}-active`,
      leave: this.classNames.leave,
      leaveActive: `${this.classNames.leave}-active`
    };
  }
  addClassName(te, ee) {
    te.classList.add(ee);
  }
  clearTimeouts() {
    Object.values(this.timeouts).forEach((te) => {
      te && clearTimeout(te);
    });
  }
  clearClassNames(te) {
    const ee = this.getClassNames();
    Object.values(ee).forEach((ne) => {
      this.removeClassName(te, ne);
    });
  }
  removeClassName(te, ee) {
    te.classList.remove(ee);
  }
  async addClassNameOnNextTick(te, ee) {
    await nextTick(), this.addClassName(te, ee);
  }
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, freeSelf$1 = typeof self == "object" && self && self.Object === Object && self, root$1 = freeGlobal$1 || freeSelf$1 || Function("return this")(), Symbol$1 = root$1.Symbol, symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0;
symbolProto$1 && symbolProto$1.toString;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root = freeGlobal || freeSelf || Function("return this")(), Symbol$2 = root.Symbol, symbolProto = Symbol$2 ? Symbol$2.prototype : void 0;
symbolProto && symbolProto.toString;
const isNodeEnvironment = () => typeof process < "u" && process.versions != null && process.versions.node != null;
class EventEmitter {
  constructor() {
    isNodeEnvironment() || (this.eventTarget = document.createDocumentFragment());
  }
  on(te, ee) {
    var ne;
    (ne = this.eventTarget) == null || ne.addEventListener(te, ee);
  }
  off(te, ee) {
    var ne;
    (ne = this.eventTarget) == null || ne.removeEventListener(te, ee);
  }
  emit(te, ee) {
    var ie;
    const ne = new CustomEvent(te, ee);
    (ie = this.eventTarget) == null || ie.dispatchEvent(ne);
  }
}
const hasReducedMotion = () => global$1.matchMedia("(prefers-reduced-motion: reduce)").matches, requestFormSubmit = (re) => {
  if (re) {
    if (typeof HTMLFormElement.prototype.requestSubmit == "function")
      return re.requestSubmit();
    if (!isNodeEnvironment()) {
      const te = global$1.document.createElement("button");
      te.type = "submit", te.style.display = "none", re.appendChild(te), te.click(), te.remove();
    }
  }
}, responsiveStringRegex = /([a-zA-Z0-9-]+)@([a-zA-Z0-9-]+)/, isResponsiveProperty = (re) => typeof re == "string" && responsiveStringRegex.test(re), parseResponsiveProperty = (re) => (re.match(new RegExp(responsiveStringRegex, "g")) || []).reduce((ee, ne) => {
  const ie = ne.match(responsiveStringRegex);
  if (ie) {
    const [, ae, ce] = ie;
    ee[ce] = ae;
  }
  return ee;
}, {});
function hasNamedSlot(re, te) {
  if (!re || typeof re.querySelector != "function")
    return !1;
  try {
    return re.querySelector(`:scope > [slot="${te}"]`) !== null;
  } catch {
    return re.querySelector(`[slot="${te}"]`) !== null;
  }
}
function getDefaultSlotTextContent(re) {
  return !re || typeof re.assignedNodes != "function" ? "" : re.assignedNodes({ flatten: !0 }).reduce((te, ee) => te + (ee.textContent || ""), "").trim();
}
function getNamedSlotTextContent(re, te) {
  var ee, ne, ie, ae;
  if (!re || typeof re.querySelector != "function")
    return "";
  try {
    return ((ne = (ee = re.querySelector(`:scope > [slot="${te}"]`)) == null ? void 0 : ee.textContent) == null ? void 0 : ne.trim()) || "";
  } catch {
    return ((ae = (ie = re.querySelector(`[slot="${te}"]`)) == null ? void 0 : ie.textContent) == null ? void 0 : ae.trim()) || "";
  }
}
class SlotMutationService {
  constructor() {
    this.observers = /* @__PURE__ */ new Map(), this.isNodeEnv = isNodeEnvironment(), this.observer = this.isNodeEnv ? null : this.createObserver();
  }
  /**
   * Gets the singleton instance of SlotMutationService.
   *
   * @returns {SlotMutationService} The singleton instance of SlotMutationService.
   * @static
   */
  static getInstance() {
    return SlotMutationService.instance || (SlotMutationService.instance = new SlotMutationService()), SlotMutationService.instance;
  }
  /**
   * Starts observing the given element for mutations.
   *
   * @remarks
   * It is recommended to call this method in the `componentWillLoad` lifecycle method
   * of a Stencil component to ensure that the element is observed as soon as it is loaded.
   *
   * @param {HTMLElement} element - The element to observe.
   * @param {() => void} handleSlotChange - The callback to execute when a mutation is observed.
   * @returns {void}
   */
  observe(te, ee) {
    var ne;
    this.isNodeEnv || this.observers.has(te) || (this.observers.set(te, ee), (ne = this.observer) == null || ne.observe(te, SlotMutationService.OBSERVER_OPTIONS), ee.call(te));
  }
  /**
   * Stops observing the given element for mutations.
   *
   * @remarks
   * It is recommended to call this method in the `disconnectedCallback` lifecycle method
   * of a Stencil component to ensure that the element is no longer observed when it is removed from the DOM.
   *
   * @param {HTMLElement} element - The element to stop observing.
   * @returns {void}
   */
  unobserve(te) {
    var ee;
    this.isNodeEnv || !this.observers.has(te) || (this.observers.delete(te), this.observers.size === 0 && ((ee = this.observer) == null || ee.disconnect()));
  }
  /**
   * Creates a MutationObserver instance.
   *
   * @returns {MutationObserver} The created MutationObserver instance.
   * @private
   */
  createObserver() {
    return new MutationObserver(this.handleMutations.bind(this));
  }
  /**
   * Handles observed mutations.
   *
   * @param {MutationRecord[]} mutations - The array of observed mutations.
   * @returns {void}
   * @private
   */
  handleMutations(te) {
    te.forEach((ee) => {
      this.observers.forEach((ne, ie) => {
        ie.contains(ee.target) && ne.call(ie);
      });
    });
  }
}
SlotMutationService.instance = null;
SlotMutationService.OBSERVER_OPTIONS = {
  childList: !0,
  subtree: !0,
  characterData: !0
};
const slotMutationService = SlotMutationService.getInstance();
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(re, te) {
  return re.concat([te + "-" + start, te + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(re, te) {
  return re.concat([te, te + "-" + start, te + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(re) {
  return re ? (re.nodeName || "").toLowerCase() : null;
}
function getWindow(re) {
  if (re == null)
    return window;
  if (re.toString() !== "[object Window]") {
    var te = re.ownerDocument;
    return te && te.defaultView || window;
  }
  return re;
}
function isElement$1(re) {
  var te = getWindow(re).Element;
  return re instanceof te || re instanceof Element;
}
function isHTMLElement(re) {
  var te = getWindow(re).HTMLElement;
  return re instanceof te || re instanceof HTMLElement;
}
function isShadowRoot(re) {
  if (typeof ShadowRoot > "u")
    return !1;
  var te = getWindow(re).ShadowRoot;
  return re instanceof te || re instanceof ShadowRoot;
}
function applyStyles(re) {
  var te = re.state;
  Object.keys(te.elements).forEach(function(ee) {
    var ne = te.styles[ee] || {}, ie = te.attributes[ee] || {}, ae = te.elements[ee];
    !isHTMLElement(ae) || !getNodeName(ae) || (Object.assign(ae.style, ne), Object.keys(ie).forEach(function(ce) {
      var he = ie[ce];
      he === !1 ? ae.removeAttribute(ce) : ae.setAttribute(ce, he === !0 ? "" : he);
    }));
  });
}
function effect$2(re) {
  var te = re.state, ee = {
    popper: {
      position: te.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(te.elements.popper.style, ee.popper), te.styles = ee, te.elements.arrow && Object.assign(te.elements.arrow.style, ee.arrow), function() {
    Object.keys(te.elements).forEach(function(ne) {
      var ie = te.elements[ne], ae = te.attributes[ne] || {}, ce = Object.keys(te.styles.hasOwnProperty(ne) ? te.styles[ne] : ee[ne]), he = ce.reduce(function(_e, le) {
        return _e[le] = "", _e;
      }, {});
      !isHTMLElement(ie) || !getNodeName(ie) || (Object.assign(ie.style, he), Object.keys(ae).forEach(function(_e) {
        ie.removeAttribute(_e);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement$1(re) {
  return re.split("-")[0];
}
var max = Math.max, min = Math.min, round = Math.round;
function getUAString() {
  var re = navigator.userAgentData;
  return re != null && re.brands && Array.isArray(re.brands) ? re.brands.map(function(te) {
    return te.brand + "/" + te.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(re, te, ee) {
  te === void 0 && (te = !1), ee === void 0 && (ee = !1);
  var ne = re.getBoundingClientRect(), ie = 1, ae = 1;
  te && isHTMLElement(re) && (ie = re.offsetWidth > 0 && round(ne.width) / re.offsetWidth || 1, ae = re.offsetHeight > 0 && round(ne.height) / re.offsetHeight || 1);
  var ce = isElement$1(re) ? getWindow(re) : window, he = ce.visualViewport, _e = !isLayoutViewport() && ee, le = (ne.left + (_e && he ? he.offsetLeft : 0)) / ie, se = (ne.top + (_e && he ? he.offsetTop : 0)) / ae, oe = ne.width / ie, ue = ne.height / ae;
  return {
    width: oe,
    height: ue,
    top: se,
    right: le + oe,
    bottom: se + ue,
    left: le,
    x: le,
    y: se
  };
}
function getLayoutRect(re) {
  var te = getBoundingClientRect(re), ee = re.offsetWidth, ne = re.offsetHeight;
  return Math.abs(te.width - ee) <= 1 && (ee = te.width), Math.abs(te.height - ne) <= 1 && (ne = te.height), {
    x: re.offsetLeft,
    y: re.offsetTop,
    width: ee,
    height: ne
  };
}
function contains(re, te) {
  var ee = te.getRootNode && te.getRootNode();
  if (re.contains(te))
    return !0;
  if (ee && isShadowRoot(ee)) {
    var ne = te;
    do {
      if (ne && re.isSameNode(ne))
        return !0;
      ne = ne.parentNode || ne.host;
    } while (ne);
  }
  return !1;
}
function getComputedStyle$1(re) {
  return getWindow(re).getComputedStyle(re);
}
function isTableElement(re) {
  return ["table", "td", "th"].indexOf(getNodeName(re)) >= 0;
}
function getDocumentElement(re) {
  return ((isElement$1(re) ? re.ownerDocument : (
    // $FlowFixMe[prop-missing]
    re.document
  )) || window.document).documentElement;
}
function getParentNode(re) {
  return getNodeName(re) === "html" ? re : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    re.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    re.parentNode || // DOM Element detected
    (isShadowRoot(re) ? re.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(re)
  );
}
function getTrueOffsetParent(re) {
  return !isHTMLElement(re) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(re).position === "fixed" ? null : re.offsetParent;
}
function getContainingBlock(re) {
  var te = /firefox/i.test(getUAString()), ee = /Trident/i.test(getUAString());
  if (ee && isHTMLElement(re)) {
    var ne = getComputedStyle$1(re);
    if (ne.position === "fixed")
      return null;
  }
  var ie = getParentNode(re);
  for (isShadowRoot(ie) && (ie = ie.host); isHTMLElement(ie) && ["html", "body"].indexOf(getNodeName(ie)) < 0; ) {
    var ae = getComputedStyle$1(ie);
    if (ae.transform !== "none" || ae.perspective !== "none" || ae.contain === "paint" || ["transform", "perspective"].indexOf(ae.willChange) !== -1 || te && ae.willChange === "filter" || te && ae.filter && ae.filter !== "none")
      return ie;
    ie = ie.parentNode;
  }
  return null;
}
function getOffsetParent(re) {
  for (var te = getWindow(re), ee = getTrueOffsetParent(re); ee && isTableElement(ee) && getComputedStyle$1(ee).position === "static"; )
    ee = getTrueOffsetParent(ee);
  return ee && (getNodeName(ee) === "html" || getNodeName(ee) === "body" && getComputedStyle$1(ee).position === "static") ? te : ee || getContainingBlock(re) || te;
}
function getMainAxisFromPlacement(re) {
  return ["top", "bottom"].indexOf(re) >= 0 ? "x" : "y";
}
function within(re, te, ee) {
  return max(re, min(te, ee));
}
function withinMaxClamp(re, te, ee) {
  var ne = within(re, te, ee);
  return ne > ee ? ee : ne;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(re) {
  return Object.assign({}, getFreshSideObject(), re);
}
function expandToHashMap(re, te) {
  return te.reduce(function(ee, ne) {
    return ee[ne] = re, ee;
  }, {});
}
var toPaddingObject = function(te, ee) {
  return te = typeof te == "function" ? te(Object.assign({}, ee.rects, {
    placement: ee.placement
  })) : te, mergePaddingObject(typeof te != "number" ? te : expandToHashMap(te, basePlacements));
};
function arrow(re) {
  var te, ee = re.state, ne = re.name, ie = re.options, ae = ee.elements.arrow, ce = ee.modifiersData.popperOffsets, he = getBasePlacement$1(ee.placement), _e = getMainAxisFromPlacement(he), le = [left, right].indexOf(he) >= 0, se = le ? "height" : "width";
  if (!(!ae || !ce)) {
    var oe = toPaddingObject(ie.padding, ee), ue = getLayoutRect(ae), be = _e === "y" ? top : left, ve = _e === "y" ? bottom : right, me = ee.rects.reference[se] + ee.rects.reference[_e] - ce[_e] - ee.rects.popper[se], pe = ce[_e] - ee.rects.reference[_e], fe = getOffsetParent(ae), ge = fe ? _e === "y" ? fe.clientHeight || 0 : fe.clientWidth || 0 : 0, ye = me / 2 - pe / 2, $e = oe[be], Se = ge - ue[se] - oe[ve], Ce = ge / 2 - ue[se] / 2 + ye, Ie = within($e, Ce, Se), Te = _e;
    ee.modifiersData[ne] = (te = {}, te[Te] = Ie, te.centerOffset = Ie - Ce, te);
  }
}
function effect$1(re) {
  var te = re.state, ee = re.options, ne = ee.element, ie = ne === void 0 ? "[data-popper-arrow]" : ne;
  ie != null && (typeof ie == "string" && (ie = te.elements.popper.querySelector(ie), !ie) || contains(te.elements.popper, ie) && (te.elements.arrow = ie));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(re) {
  return re.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(re, te) {
  var ee = re.x, ne = re.y, ie = te.devicePixelRatio || 1;
  return {
    x: round(ee * ie) / ie || 0,
    y: round(ne * ie) / ie || 0
  };
}
function mapToStyles(re) {
  var te, ee = re.popper, ne = re.popperRect, ie = re.placement, ae = re.variation, ce = re.offsets, he = re.position, _e = re.gpuAcceleration, le = re.adaptive, se = re.roundOffsets, oe = re.isFixed, ue = ce.x, be = ue === void 0 ? 0 : ue, ve = ce.y, me = ve === void 0 ? 0 : ve, pe = typeof se == "function" ? se({
    x: be,
    y: me
  }) : {
    x: be,
    y: me
  };
  be = pe.x, me = pe.y;
  var fe = ce.hasOwnProperty("x"), ge = ce.hasOwnProperty("y"), ye = left, $e = top, Se = window;
  if (le) {
    var Ce = getOffsetParent(ee), Ie = "clientHeight", Te = "clientWidth";
    if (Ce === getWindow(ee) && (Ce = getDocumentElement(ee), getComputedStyle$1(Ce).position !== "static" && he === "absolute" && (Ie = "scrollHeight", Te = "scrollWidth")), Ce = Ce, ie === top || (ie === left || ie === right) && ae === end) {
      $e = bottom;
      var Ee = oe && Ce === Se && Se.visualViewport ? Se.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        Ce[Ie]
      );
      me -= Ee - ne.height, me *= _e ? 1 : -1;
    }
    if (ie === left || (ie === top || ie === bottom) && ae === end) {
      ye = right;
      var we = oe && Ce === Se && Se.visualViewport ? Se.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        Ce[Te]
      );
      be -= we - ne.width, be *= _e ? 1 : -1;
    }
  }
  var Pe = Object.assign({
    position: he
  }, le && unsetSides), Me = se === !0 ? roundOffsetsByDPR({
    x: be,
    y: me
  }, getWindow(ee)) : {
    x: be,
    y: me
  };
  if (be = Me.x, me = Me.y, _e) {
    var Ae;
    return Object.assign({}, Pe, (Ae = {}, Ae[$e] = ge ? "0" : "", Ae[ye] = fe ? "0" : "", Ae.transform = (Se.devicePixelRatio || 1) <= 1 ? "translate(" + be + "px, " + me + "px)" : "translate3d(" + be + "px, " + me + "px, 0)", Ae));
  }
  return Object.assign({}, Pe, (te = {}, te[$e] = ge ? me + "px" : "", te[ye] = fe ? be + "px" : "", te.transform = "", te));
}
function computeStyles(re) {
  var te = re.state, ee = re.options, ne = ee.gpuAcceleration, ie = ne === void 0 ? !0 : ne, ae = ee.adaptive, ce = ae === void 0 ? !0 : ae, he = ee.roundOffsets, _e = he === void 0 ? !0 : he, le = {
    placement: getBasePlacement$1(te.placement),
    variation: getVariation(te.placement),
    popper: te.elements.popper,
    popperRect: te.rects.popper,
    gpuAcceleration: ie,
    isFixed: te.options.strategy === "fixed"
  };
  te.modifiersData.popperOffsets != null && (te.styles.popper = Object.assign({}, te.styles.popper, mapToStyles(Object.assign({}, le, {
    offsets: te.modifiersData.popperOffsets,
    position: te.options.strategy,
    adaptive: ce,
    roundOffsets: _e
  })))), te.modifiersData.arrow != null && (te.styles.arrow = Object.assign({}, te.styles.arrow, mapToStyles(Object.assign({}, le, {
    offsets: te.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: _e
  })))), te.attributes.popper = Object.assign({}, te.attributes.popper, {
    "data-popper-placement": te.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(re) {
  var te = re.state, ee = re.instance, ne = re.options, ie = ne.scroll, ae = ie === void 0 ? !0 : ie, ce = ne.resize, he = ce === void 0 ? !0 : ce, _e = getWindow(te.elements.popper), le = [].concat(te.scrollParents.reference, te.scrollParents.popper);
  return ae && le.forEach(function(se) {
    se.addEventListener("scroll", ee.update, passive);
  }), he && _e.addEventListener("resize", ee.update, passive), function() {
    ae && le.forEach(function(se) {
      se.removeEventListener("scroll", ee.update, passive);
    }), he && _e.removeEventListener("resize", ee.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(re) {
  return re.replace(/left|right|bottom|top/g, function(te) {
    return hash$1[te];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(re) {
  return re.replace(/start|end/g, function(te) {
    return hash[te];
  });
}
function getWindowScroll(re) {
  var te = getWindow(re), ee = te.pageXOffset, ne = te.pageYOffset;
  return {
    scrollLeft: ee,
    scrollTop: ne
  };
}
function getWindowScrollBarX(re) {
  return getBoundingClientRect(getDocumentElement(re)).left + getWindowScroll(re).scrollLeft;
}
function getViewportRect(re, te) {
  var ee = getWindow(re), ne = getDocumentElement(re), ie = ee.visualViewport, ae = ne.clientWidth, ce = ne.clientHeight, he = 0, _e = 0;
  if (ie) {
    ae = ie.width, ce = ie.height;
    var le = isLayoutViewport();
    (le || !le && te === "fixed") && (he = ie.offsetLeft, _e = ie.offsetTop);
  }
  return {
    width: ae,
    height: ce,
    x: he + getWindowScrollBarX(re),
    y: _e
  };
}
function getDocumentRect(re) {
  var te, ee = getDocumentElement(re), ne = getWindowScroll(re), ie = (te = re.ownerDocument) == null ? void 0 : te.body, ae = max(ee.scrollWidth, ee.clientWidth, ie ? ie.scrollWidth : 0, ie ? ie.clientWidth : 0), ce = max(ee.scrollHeight, ee.clientHeight, ie ? ie.scrollHeight : 0, ie ? ie.clientHeight : 0), he = -ne.scrollLeft + getWindowScrollBarX(re), _e = -ne.scrollTop;
  return getComputedStyle$1(ie || ee).direction === "rtl" && (he += max(ee.clientWidth, ie ? ie.clientWidth : 0) - ae), {
    width: ae,
    height: ce,
    x: he,
    y: _e
  };
}
function isScrollParent(re) {
  var te = getComputedStyle$1(re), ee = te.overflow, ne = te.overflowX, ie = te.overflowY;
  return /auto|scroll|overlay|hidden/.test(ee + ie + ne);
}
function getScrollParent(re) {
  return ["html", "body", "#document"].indexOf(getNodeName(re)) >= 0 ? re.ownerDocument.body : isHTMLElement(re) && isScrollParent(re) ? re : getScrollParent(getParentNode(re));
}
function listScrollParents(re, te) {
  var ee;
  te === void 0 && (te = []);
  var ne = getScrollParent(re), ie = ne === ((ee = re.ownerDocument) == null ? void 0 : ee.body), ae = getWindow(ne), ce = ie ? [ae].concat(ae.visualViewport || [], isScrollParent(ne) ? ne : []) : ne, he = te.concat(ce);
  return ie ? he : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    he.concat(listScrollParents(getParentNode(ce)))
  );
}
function rectToClientRect(re) {
  return Object.assign({}, re, {
    left: re.x,
    top: re.y,
    right: re.x + re.width,
    bottom: re.y + re.height
  });
}
function getInnerBoundingClientRect(re, te) {
  var ee = getBoundingClientRect(re, !1, te === "fixed");
  return ee.top = ee.top + re.clientTop, ee.left = ee.left + re.clientLeft, ee.bottom = ee.top + re.clientHeight, ee.right = ee.left + re.clientWidth, ee.width = re.clientWidth, ee.height = re.clientHeight, ee.x = ee.left, ee.y = ee.top, ee;
}
function getClientRectFromMixedType(re, te, ee) {
  return te === viewport ? rectToClientRect(getViewportRect(re, ee)) : isElement$1(te) ? getInnerBoundingClientRect(te, ee) : rectToClientRect(getDocumentRect(getDocumentElement(re)));
}
function getClippingParents(re) {
  var te = listScrollParents(getParentNode(re)), ee = ["absolute", "fixed"].indexOf(getComputedStyle$1(re).position) >= 0, ne = ee && isHTMLElement(re) ? getOffsetParent(re) : re;
  return isElement$1(ne) ? te.filter(function(ie) {
    return isElement$1(ie) && contains(ie, ne) && getNodeName(ie) !== "body";
  }) : [];
}
function getClippingRect(re, te, ee, ne) {
  var ie = te === "clippingParents" ? getClippingParents(re) : [].concat(te), ae = [].concat(ie, [ee]), ce = ae[0], he = ae.reduce(function(_e, le) {
    var se = getClientRectFromMixedType(re, le, ne);
    return _e.top = max(se.top, _e.top), _e.right = min(se.right, _e.right), _e.bottom = min(se.bottom, _e.bottom), _e.left = max(se.left, _e.left), _e;
  }, getClientRectFromMixedType(re, ce, ne));
  return he.width = he.right - he.left, he.height = he.bottom - he.top, he.x = he.left, he.y = he.top, he;
}
function computeOffsets(re) {
  var te = re.reference, ee = re.element, ne = re.placement, ie = ne ? getBasePlacement$1(ne) : null, ae = ne ? getVariation(ne) : null, ce = te.x + te.width / 2 - ee.width / 2, he = te.y + te.height / 2 - ee.height / 2, _e;
  switch (ie) {
    case top:
      _e = {
        x: ce,
        y: te.y - ee.height
      };
      break;
    case bottom:
      _e = {
        x: ce,
        y: te.y + te.height
      };
      break;
    case right:
      _e = {
        x: te.x + te.width,
        y: he
      };
      break;
    case left:
      _e = {
        x: te.x - ee.width,
        y: he
      };
      break;
    default:
      _e = {
        x: te.x,
        y: te.y
      };
  }
  var le = ie ? getMainAxisFromPlacement(ie) : null;
  if (le != null) {
    var se = le === "y" ? "height" : "width";
    switch (ae) {
      case start:
        _e[le] = _e[le] - (te[se] / 2 - ee[se] / 2);
        break;
      case end:
        _e[le] = _e[le] + (te[se] / 2 - ee[se] / 2);
        break;
    }
  }
  return _e;
}
function detectOverflow(re, te) {
  te === void 0 && (te = {});
  var ee = te, ne = ee.placement, ie = ne === void 0 ? re.placement : ne, ae = ee.strategy, ce = ae === void 0 ? re.strategy : ae, he = ee.boundary, _e = he === void 0 ? clippingParents : he, le = ee.rootBoundary, se = le === void 0 ? viewport : le, oe = ee.elementContext, ue = oe === void 0 ? popper : oe, be = ee.altBoundary, ve = be === void 0 ? !1 : be, me = ee.padding, pe = me === void 0 ? 0 : me, fe = mergePaddingObject(typeof pe != "number" ? pe : expandToHashMap(pe, basePlacements)), ge = ue === popper ? reference : popper, ye = re.rects.popper, $e = re.elements[ve ? ge : ue], Se = getClippingRect(isElement$1($e) ? $e : $e.contextElement || getDocumentElement(re.elements.popper), _e, se, ce), Ce = getBoundingClientRect(re.elements.reference), Ie = computeOffsets({
    reference: Ce,
    element: ye,
    strategy: "absolute",
    placement: ie
  }), Te = rectToClientRect(Object.assign({}, ye, Ie)), Ee = ue === popper ? Te : Ce, we = {
    top: Se.top - Ee.top + fe.top,
    bottom: Ee.bottom - Se.bottom + fe.bottom,
    left: Se.left - Ee.left + fe.left,
    right: Ee.right - Se.right + fe.right
  }, Pe = re.modifiersData.offset;
  if (ue === popper && Pe) {
    var Me = Pe[ie];
    Object.keys(we).forEach(function(Ae) {
      var Oe = [right, bottom].indexOf(Ae) >= 0 ? 1 : -1, Be = [top, bottom].indexOf(Ae) >= 0 ? "y" : "x";
      we[Ae] += Me[Be] * Oe;
    });
  }
  return we;
}
function computeAutoPlacement(re, te) {
  te === void 0 && (te = {});
  var ee = te, ne = ee.placement, ie = ee.boundary, ae = ee.rootBoundary, ce = ee.padding, he = ee.flipVariations, _e = ee.allowedAutoPlacements, le = _e === void 0 ? placements : _e, se = getVariation(ne), oe = se ? he ? variationPlacements : variationPlacements.filter(function(ve) {
    return getVariation(ve) === se;
  }) : basePlacements, ue = oe.filter(function(ve) {
    return le.indexOf(ve) >= 0;
  });
  ue.length === 0 && (ue = oe);
  var be = ue.reduce(function(ve, me) {
    return ve[me] = detectOverflow(re, {
      placement: me,
      boundary: ie,
      rootBoundary: ae,
      padding: ce
    })[getBasePlacement$1(me)], ve;
  }, {});
  return Object.keys(be).sort(function(ve, me) {
    return be[ve] - be[me];
  });
}
function getExpandedFallbackPlacements(re) {
  if (getBasePlacement$1(re) === auto)
    return [];
  var te = getOppositePlacement(re);
  return [getOppositeVariationPlacement(re), te, getOppositeVariationPlacement(te)];
}
function flip(re) {
  var te = re.state, ee = re.options, ne = re.name;
  if (!te.modifiersData[ne]._skip) {
    for (var ie = ee.mainAxis, ae = ie === void 0 ? !0 : ie, ce = ee.altAxis, he = ce === void 0 ? !0 : ce, _e = ee.fallbackPlacements, le = ee.padding, se = ee.boundary, oe = ee.rootBoundary, ue = ee.altBoundary, be = ee.flipVariations, ve = be === void 0 ? !0 : be, me = ee.allowedAutoPlacements, pe = te.options.placement, fe = getBasePlacement$1(pe), ge = fe === pe, ye = _e || (ge || !ve ? [getOppositePlacement(pe)] : getExpandedFallbackPlacements(pe)), $e = [pe].concat(ye).reduce(function(We, Xe) {
      return We.concat(getBasePlacement$1(Xe) === auto ? computeAutoPlacement(te, {
        placement: Xe,
        boundary: se,
        rootBoundary: oe,
        padding: le,
        flipVariations: ve,
        allowedAutoPlacements: me
      }) : Xe);
    }, []), Se = te.rects.reference, Ce = te.rects.popper, Ie = /* @__PURE__ */ new Map(), Te = !0, Ee = $e[0], we = 0; we < $e.length; we++) {
      var Pe = $e[we], Me = getBasePlacement$1(Pe), Ae = getVariation(Pe) === start, Oe = [top, bottom].indexOf(Me) >= 0, Be = Oe ? "width" : "height", Ve = detectOverflow(te, {
        placement: Pe,
        boundary: se,
        rootBoundary: oe,
        altBoundary: ue,
        padding: le
      }), Ue = Oe ? Ae ? right : left : Ae ? bottom : top;
      Se[Be] > Ce[Be] && (Ue = getOppositePlacement(Ue));
      var Re = getOppositePlacement(Ue), Ne = [];
      if (ae && Ne.push(Ve[Me] <= 0), he && Ne.push(Ve[Ue] <= 0, Ve[Re] <= 0), Ne.every(function(We) {
        return We;
      })) {
        Ee = Pe, Te = !1;
        break;
      }
      Ie.set(Pe, Ne);
    }
    if (Te)
      for (var xe = ve ? 3 : 1, ke = function(Xe) {
        var Qe = $e.find(function(tt) {
          var Je = Ie.get(tt);
          if (Je)
            return Je.slice(0, Xe).every(function(Ge) {
              return Ge;
            });
        });
        if (Qe)
          return Ee = Qe, "break";
      }, Le = xe; Le > 0; Le--) {
        var He = ke(Le);
        if (He === "break")
          break;
      }
    te.placement !== Ee && (te.modifiersData[ne]._skip = !0, te.placement = Ee, te.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(re, te, ee) {
  return ee === void 0 && (ee = {
    x: 0,
    y: 0
  }), {
    top: re.top - te.height - ee.y,
    right: re.right - te.width + ee.x,
    bottom: re.bottom - te.height + ee.y,
    left: re.left - te.width - ee.x
  };
}
function isAnySideFullyClipped(re) {
  return [top, right, bottom, left].some(function(te) {
    return re[te] >= 0;
  });
}
function hide(re) {
  var te = re.state, ee = re.name, ne = te.rects.reference, ie = te.rects.popper, ae = te.modifiersData.preventOverflow, ce = detectOverflow(te, {
    elementContext: "reference"
  }), he = detectOverflow(te, {
    altBoundary: !0
  }), _e = getSideOffsets(ce, ne), le = getSideOffsets(he, ie, ae), se = isAnySideFullyClipped(_e), oe = isAnySideFullyClipped(le);
  te.modifiersData[ee] = {
    referenceClippingOffsets: _e,
    popperEscapeOffsets: le,
    isReferenceHidden: se,
    hasPopperEscaped: oe
  }, te.attributes.popper = Object.assign({}, te.attributes.popper, {
    "data-popper-reference-hidden": se,
    "data-popper-escaped": oe
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(re, te, ee) {
  var ne = getBasePlacement$1(re), ie = [left, top].indexOf(ne) >= 0 ? -1 : 1, ae = typeof ee == "function" ? ee(Object.assign({}, te, {
    placement: re
  })) : ee, ce = ae[0], he = ae[1];
  return ce = ce || 0, he = (he || 0) * ie, [left, right].indexOf(ne) >= 0 ? {
    x: he,
    y: ce
  } : {
    x: ce,
    y: he
  };
}
function offset(re) {
  var te = re.state, ee = re.options, ne = re.name, ie = ee.offset, ae = ie === void 0 ? [0, 0] : ie, ce = placements.reduce(function(se, oe) {
    return se[oe] = distanceAndSkiddingToXY(oe, te.rects, ae), se;
  }, {}), he = ce[te.placement], _e = he.x, le = he.y;
  te.modifiersData.popperOffsets != null && (te.modifiersData.popperOffsets.x += _e, te.modifiersData.popperOffsets.y += le), te.modifiersData[ne] = ce;
}
const offset$1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(re) {
  var te = re.state, ee = re.name;
  te.modifiersData[ee] = computeOffsets({
    reference: te.rects.reference,
    element: te.rects.popper,
    strategy: "absolute",
    placement: te.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(re) {
  return re === "x" ? "y" : "x";
}
function preventOverflow(re) {
  var te = re.state, ee = re.options, ne = re.name, ie = ee.mainAxis, ae = ie === void 0 ? !0 : ie, ce = ee.altAxis, he = ce === void 0 ? !1 : ce, _e = ee.boundary, le = ee.rootBoundary, se = ee.altBoundary, oe = ee.padding, ue = ee.tether, be = ue === void 0 ? !0 : ue, ve = ee.tetherOffset, me = ve === void 0 ? 0 : ve, pe = detectOverflow(te, {
    boundary: _e,
    rootBoundary: le,
    padding: oe,
    altBoundary: se
  }), fe = getBasePlacement$1(te.placement), ge = getVariation(te.placement), ye = !ge, $e = getMainAxisFromPlacement(fe), Se = getAltAxis($e), Ce = te.modifiersData.popperOffsets, Ie = te.rects.reference, Te = te.rects.popper, Ee = typeof me == "function" ? me(Object.assign({}, te.rects, {
    placement: te.placement
  })) : me, we = typeof Ee == "number" ? {
    mainAxis: Ee,
    altAxis: Ee
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Ee), Pe = te.modifiersData.offset ? te.modifiersData.offset[te.placement] : null, Me = {
    x: 0,
    y: 0
  };
  if (Ce) {
    if (ae) {
      var Ae, Oe = $e === "y" ? top : left, Be = $e === "y" ? bottom : right, Ve = $e === "y" ? "height" : "width", Ue = Ce[$e], Re = Ue + pe[Oe], Ne = Ue - pe[Be], xe = be ? -Te[Ve] / 2 : 0, ke = ge === start ? Ie[Ve] : Te[Ve], Le = ge === start ? -Te[Ve] : -Ie[Ve], He = te.elements.arrow, We = be && He ? getLayoutRect(He) : {
        width: 0,
        height: 0
      }, Xe = te.modifiersData["arrow#persistent"] ? te.modifiersData["arrow#persistent"].padding : getFreshSideObject(), Qe = Xe[Oe], tt = Xe[Be], Je = within(0, Ie[Ve], We[Ve]), Ge = ye ? Ie[Ve] / 2 - xe - Je - Qe - we.mainAxis : ke - Je - Qe - we.mainAxis, Ye = ye ? -Ie[Ve] / 2 + xe + Je + tt + we.mainAxis : Le + Je + tt + we.mainAxis, ze = te.elements.arrow && getOffsetParent(te.elements.arrow), Fe = ze ? $e === "y" ? ze.clientTop || 0 : ze.clientLeft || 0 : 0, ot = (Ae = Pe == null ? void 0 : Pe[$e]) != null ? Ae : 0, vt = Ue + Ge - ot - Fe, gt = Ue + Ye - ot, yt = within(be ? min(Re, vt) : Re, Ue, be ? max(Ne, gt) : Ne);
      Ce[$e] = yt, Me[$e] = yt - Ue;
    }
    if (he) {
      var pt, bt = $e === "x" ? top : left, ut = $e === "x" ? bottom : right, Ke = Ce[Se], je = Se === "y" ? "height" : "width", De = Ke + pe[bt], at = Ke - pe[ut], dt = [top, left].indexOf(fe) !== -1, ft = (pt = Pe == null ? void 0 : Pe[Se]) != null ? pt : 0, lt = dt ? De : Ke - Ie[je] - Te[je] - ft + we.altAxis, nt = dt ? Ke + Ie[je] + Te[je] - ft - we.altAxis : at, ct = be && dt ? withinMaxClamp(lt, Ke, nt) : within(be ? lt : De, Ke, be ? nt : at);
      Ce[Se] = ct, Me[Se] = ct - Ke;
    }
    te.modifiersData[ne] = Me;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(re) {
  return {
    scrollLeft: re.scrollLeft,
    scrollTop: re.scrollTop
  };
}
function getNodeScroll(re) {
  return re === getWindow(re) || !isHTMLElement(re) ? getWindowScroll(re) : getHTMLElementScroll(re);
}
function isElementScaled(re) {
  var te = re.getBoundingClientRect(), ee = round(te.width) / re.offsetWidth || 1, ne = round(te.height) / re.offsetHeight || 1;
  return ee !== 1 || ne !== 1;
}
function getCompositeRect(re, te, ee) {
  ee === void 0 && (ee = !1);
  var ne = isHTMLElement(te), ie = isHTMLElement(te) && isElementScaled(te), ae = getDocumentElement(te), ce = getBoundingClientRect(re, ie, ee), he = {
    scrollLeft: 0,
    scrollTop: 0
  }, _e = {
    x: 0,
    y: 0
  };
  return (ne || !ne && !ee) && ((getNodeName(te) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(ae)) && (he = getNodeScroll(te)), isHTMLElement(te) ? (_e = getBoundingClientRect(te, !0), _e.x += te.clientLeft, _e.y += te.clientTop) : ae && (_e.x = getWindowScrollBarX(ae))), {
    x: ce.left + he.scrollLeft - _e.x,
    y: ce.top + he.scrollTop - _e.y,
    width: ce.width,
    height: ce.height
  };
}
function order(re) {
  var te = /* @__PURE__ */ new Map(), ee = /* @__PURE__ */ new Set(), ne = [];
  re.forEach(function(ae) {
    te.set(ae.name, ae);
  });
  function ie(ae) {
    ee.add(ae.name);
    var ce = [].concat(ae.requires || [], ae.requiresIfExists || []);
    ce.forEach(function(he) {
      if (!ee.has(he)) {
        var _e = te.get(he);
        _e && ie(_e);
      }
    }), ne.push(ae);
  }
  return re.forEach(function(ae) {
    ee.has(ae.name) || ie(ae);
  }), ne;
}
function orderModifiers(re) {
  var te = order(re);
  return modifierPhases.reduce(function(ee, ne) {
    return ee.concat(te.filter(function(ie) {
      return ie.phase === ne;
    }));
  }, []);
}
function debounce$1(re) {
  var te;
  return function() {
    return te || (te = new Promise(function(ee) {
      Promise.resolve().then(function() {
        te = void 0, ee(re());
      });
    })), te;
  };
}
function mergeByName(re) {
  var te = re.reduce(function(ee, ne) {
    var ie = ee[ne.name];
    return ee[ne.name] = ie ? Object.assign({}, ie, ne, {
      options: Object.assign({}, ie.options, ne.options),
      data: Object.assign({}, ie.data, ne.data)
    }) : ne, ee;
  }, {});
  return Object.keys(te).map(function(ee) {
    return te[ee];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var re = arguments.length, te = new Array(re), ee = 0; ee < re; ee++)
    te[ee] = arguments[ee];
  return !te.some(function(ne) {
    return !(ne && typeof ne.getBoundingClientRect == "function");
  });
}
function popperGenerator(re) {
  re === void 0 && (re = {});
  var te = re, ee = te.defaultModifiers, ne = ee === void 0 ? [] : ee, ie = te.defaultOptions, ae = ie === void 0 ? DEFAULT_OPTIONS : ie;
  return function(he, _e, le) {
    le === void 0 && (le = ae);
    var se = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, ae),
      modifiersData: {},
      elements: {
        reference: he,
        popper: _e
      },
      attributes: {},
      styles: {}
    }, oe = [], ue = !1, be = {
      state: se,
      setOptions: function(fe) {
        var ge = typeof fe == "function" ? fe(se.options) : fe;
        me(), se.options = Object.assign({}, ae, se.options, ge), se.scrollParents = {
          reference: isElement$1(he) ? listScrollParents(he) : he.contextElement ? listScrollParents(he.contextElement) : [],
          popper: listScrollParents(_e)
        };
        var ye = orderModifiers(mergeByName([].concat(ne, se.options.modifiers)));
        return se.orderedModifiers = ye.filter(function($e) {
          return $e.enabled;
        }), ve(), be.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!ue) {
          var fe = se.elements, ge = fe.reference, ye = fe.popper;
          if (areValidElements(ge, ye)) {
            se.rects = {
              reference: getCompositeRect(ge, getOffsetParent(ye), se.options.strategy === "fixed"),
              popper: getLayoutRect(ye)
            }, se.reset = !1, se.placement = se.options.placement, se.orderedModifiers.forEach(function(we) {
              return se.modifiersData[we.name] = Object.assign({}, we.data);
            });
            for (var $e = 0; $e < se.orderedModifiers.length; $e++) {
              if (se.reset === !0) {
                se.reset = !1, $e = -1;
                continue;
              }
              var Se = se.orderedModifiers[$e], Ce = Se.fn, Ie = Se.options, Te = Ie === void 0 ? {} : Ie, Ee = Se.name;
              typeof Ce == "function" && (se = Ce({
                state: se,
                options: Te,
                name: Ee,
                instance: be
              }) || se);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$1(function() {
        return new Promise(function(pe) {
          be.forceUpdate(), pe(se);
        });
      }),
      destroy: function() {
        me(), ue = !0;
      }
    };
    if (!areValidElements(he, _e))
      return be;
    be.setOptions(le).then(function(pe) {
      !ue && le.onFirstUpdate && le.onFirstUpdate(pe);
    });
    function ve() {
      se.orderedModifiers.forEach(function(pe) {
        var fe = pe.name, ge = pe.options, ye = ge === void 0 ? {} : ge, $e = pe.effect;
        if (typeof $e == "function") {
          var Se = $e({
            state: se,
            name: fe,
            instance: be,
            options: ye
          }), Ce = function() {
          };
          oe.push(Se || Ce);
        }
      });
    }
    function me() {
      oe.forEach(function(pe) {
        return pe();
      }), oe = [];
    }
    return be;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
}), CONTENT_CLASS = "tippy-content", BACKDROP_CLASS = "tippy-backdrop", ARROW_CLASS = "tippy-arrow", SVG_ARROW_CLASS = "tippy-svg-arrow", TOUCH_OPTIONS = {
  passive: !0,
  capture: !0
}, TIPPY_DEFAULT_APPEND_TO = function() {
  return document.body;
};
function getValueAtIndexOrReturn(re, te, ee) {
  if (Array.isArray(re)) {
    var ne = re[te];
    return ne ?? (Array.isArray(ee) ? ee[te] : ee);
  }
  return re;
}
function isType(re, te) {
  var ee = {}.toString.call(re);
  return ee.indexOf("[object") === 0 && ee.indexOf(te + "]") > -1;
}
function invokeWithArgsOrReturn(re, te) {
  return typeof re == "function" ? re.apply(void 0, te) : re;
}
function debounce(re, te) {
  if (te === 0)
    return re;
  var ee;
  return function(ne) {
    clearTimeout(ee), ee = setTimeout(function() {
      re(ne);
    }, te);
  };
}
function splitBySpaces(re) {
  return re.split(/\s+/).filter(Boolean);
}
function normalizeToArray(re) {
  return [].concat(re);
}
function pushIfUnique(re, te) {
  re.indexOf(te) === -1 && re.push(te);
}
function unique(re) {
  return re.filter(function(te, ee) {
    return re.indexOf(te) === ee;
  });
}
function getBasePlacement(re) {
  return re.split("-")[0];
}
function arrayFrom(re) {
  return [].slice.call(re);
}
function removeUndefinedProps(re) {
  return Object.keys(re).reduce(function(te, ee) {
    return re[ee] !== void 0 && (te[ee] = re[ee]), te;
  }, {});
}
function div() {
  return document.createElement("div");
}
function isElement(re) {
  return ["Element", "Fragment"].some(function(te) {
    return isType(re, te);
  });
}
function isNodeList(re) {
  return isType(re, "NodeList");
}
function isMouseEvent(re) {
  return isType(re, "MouseEvent");
}
function isReferenceElement(re) {
  return !!(re && re._tippy && re._tippy.reference === re);
}
function getArrayOfElements(re) {
  return isElement(re) ? [re] : isNodeList(re) ? arrayFrom(re) : Array.isArray(re) ? re : arrayFrom(document.querySelectorAll(re));
}
function setTransitionDuration(re, te) {
  re.forEach(function(ee) {
    ee && (ee.style.transitionDuration = te + "ms");
  });
}
function setVisibilityState(re, te) {
  re.forEach(function(ee) {
    ee && ee.setAttribute("data-state", te);
  });
}
function getOwnerDocument(re) {
  var te, ee = normalizeToArray(re), ne = ee[0];
  return ne != null && (te = ne.ownerDocument) != null && te.body ? ne.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(re, te) {
  var ee = te.clientX, ne = te.clientY;
  return re.every(function(ie) {
    var ae = ie.popperRect, ce = ie.popperState, he = ie.props, _e = he.interactiveBorder, le = getBasePlacement(ce.placement), se = ce.modifiersData.offset;
    if (!se)
      return !0;
    var oe = le === "bottom" ? se.top.y : 0, ue = le === "top" ? se.bottom.y : 0, be = le === "right" ? se.left.x : 0, ve = le === "left" ? se.right.x : 0, me = ae.top - ne + oe > _e, pe = ne - ae.bottom - ue > _e, fe = ae.left - ee + be > _e, ge = ee - ae.right - ve > _e;
    return me || pe || fe || ge;
  });
}
function updateTransitionEndListener(re, te, ee) {
  var ne = te + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(ie) {
    re[ne](ie, ee);
  });
}
function actualContains(re, te) {
  for (var ee = te; ee; ) {
    var ne;
    if (re.contains(ee))
      return !0;
    ee = ee.getRootNode == null || (ne = ee.getRootNode()) == null ? void 0 : ne.host;
  }
  return !1;
}
var currentInput = {
  isTouch: !1
}, lastMouseMoveTime = 0;
function onDocumentTouchStart() {
  currentInput.isTouch || (currentInput.isTouch = !0, window.performance && document.addEventListener("mousemove", onDocumentMouseMove));
}
function onDocumentMouseMove() {
  var re = performance.now();
  re - lastMouseMoveTime < 20 && (currentInput.isTouch = !1, document.removeEventListener("mousemove", onDocumentMouseMove)), lastMouseMoveTime = re;
}
function onWindowBlur() {
  var re = document.activeElement;
  if (isReferenceElement(re)) {
    var te = re._tippy;
    re.blur && !te.state.isVisible && re.blur();
  }
}
function bindGlobalEventListeners() {
  document.addEventListener("touchstart", onDocumentTouchStart, TOUCH_OPTIONS), window.addEventListener("blur", onWindowBlur);
}
var isBrowser = typeof window < "u" && typeof document < "u", isIE11 = isBrowser ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, pluginProps = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, renderProps = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, pluginProps, renderProps), defaultKeys = Object.keys(defaultProps), setDefaultProps = function(te) {
  var ee = Object.keys(te);
  ee.forEach(function(ne) {
    defaultProps[ne] = te[ne];
  });
};
function getExtendedPassedProps(re) {
  var te = re.plugins || [], ee = te.reduce(function(ne, ie) {
    var ae = ie.name, ce = ie.defaultValue;
    if (ae) {
      var he;
      ne[ae] = re[ae] !== void 0 ? re[ae] : (he = defaultProps[ae]) != null ? he : ce;
    }
    return ne;
  }, {});
  return Object.assign({}, re, ee);
}
function getDataAttributeProps(re, te) {
  var ee = te ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: te
  }))) : defaultKeys, ne = ee.reduce(function(ie, ae) {
    var ce = (re.getAttribute("data-tippy-" + ae) || "").trim();
    if (!ce)
      return ie;
    if (ae === "content")
      ie[ae] = ce;
    else
      try {
        ie[ae] = JSON.parse(ce);
      } catch {
        ie[ae] = ce;
      }
    return ie;
  }, {});
  return ne;
}
function evaluateProps(re, te) {
  var ee = Object.assign({}, te, {
    content: invokeWithArgsOrReturn(te.content, [re])
  }, te.ignoreAttributes ? {} : getDataAttributeProps(re, te.plugins));
  return ee.aria = Object.assign({}, defaultProps.aria, ee.aria), ee.aria = {
    expanded: ee.aria.expanded === "auto" ? te.interactive : ee.aria.expanded,
    content: ee.aria.content === "auto" ? te.interactive ? null : "describedby" : ee.aria.content
  }, ee;
}
function getChildren(re) {
  var te = re.firstElementChild, ee = arrayFrom(te.children);
  return {
    box: te,
    content: ee.find(function(ne) {
      return ne.classList.contains(CONTENT_CLASS);
    }),
    arrow: ee.find(function(ne) {
      return ne.classList.contains(ARROW_CLASS) || ne.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: ee.find(function(ne) {
      return ne.classList.contains(BACKDROP_CLASS);
    })
  };
}
var idCounter = 1, mouseMoveListeners = [], mountedInstances = [];
function createTippy(re, te) {
  var ee = evaluateProps(re, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(te)))), ne, ie, ae, ce = !1, he = !1, _e = !1, le = !1, se, oe, ue, be = [], ve = debounce(vt, ee.interactiveDebounce), me, pe = idCounter++, fe = null, ge = unique(ee.plugins), ye = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, $e = {
    // properties
    id: pe,
    reference: re,
    popper: div(),
    popperInstance: fe,
    props: ee,
    state: ye,
    plugins: ge,
    // methods
    clearDelayTimeouts: lt,
    setProps: nt,
    setContent: ct,
    show: it,
    hide: et,
    hideWithInteractivity: st,
    enable: dt,
    disable: ft,
    unmount: mt,
    destroy: St
  };
  if (!ee.render)
    return $e;
  var Se = ee.render($e), Ce = Se.popper, Ie = Se.onUpdate;
  Ce.setAttribute("data-tippy-root", ""), Ce.id = "tippy-" + $e.id, $e.popper = Ce, re._tippy = $e, Ce._tippy = $e;
  var Te = ge.map(function($t) {
    return $t.fn($e);
  }), Ee = re.hasAttribute("aria-expanded");
  return ze(), xe(), Ue(), Re("onCreate", [$e]), ee.showOnCreate && De(), Ce.addEventListener("mouseenter", function() {
    $e.props.interactive && $e.state.isVisible && $e.clearDelayTimeouts();
  }), Ce.addEventListener("mouseleave", function() {
    $e.props.interactive && $e.props.trigger.indexOf("mouseenter") >= 0 && Oe().addEventListener("mousemove", ve);
  }), $e;
  function we() {
    var $t = $e.props.touch;
    return Array.isArray($t) ? $t : [$t, 0];
  }
  function Pe() {
    return we()[0] === "hold";
  }
  function Me() {
    var $t;
    return !!(($t = $e.props.render) != null && $t.$$tippy);
  }
  function Ae() {
    return me || re;
  }
  function Oe() {
    var $t = Ae().parentNode;
    return $t ? getOwnerDocument($t) : document;
  }
  function Be() {
    return getChildren(Ce);
  }
  function Ve($t) {
    return $e.state.isMounted && !$e.state.isVisible || currentInput.isTouch || se && se.type === "focus" ? 0 : getValueAtIndexOrReturn($e.props.delay, $t ? 0 : 1, defaultProps.delay);
  }
  function Ue($t) {
    $t === void 0 && ($t = !1), Ce.style.pointerEvents = $e.props.interactive && !$t ? "" : "none", Ce.style.zIndex = "" + $e.props.zIndex;
  }
  function Re($t, Tt, rt) {
    if (rt === void 0 && (rt = !0), Te.forEach(function(Ze) {
      Ze[$t] && Ze[$t].apply(Ze, Tt);
    }), rt) {
      var qe;
      (qe = $e.props)[$t].apply(qe, Tt);
    }
  }
  function Ne() {
    var $t = $e.props.aria;
    if ($t.content) {
      var Tt = "aria-" + $t.content, rt = Ce.id, qe = normalizeToArray($e.props.triggerTarget || re);
      qe.forEach(function(Ze) {
        var ht = Ze.getAttribute(Tt);
        if ($e.state.isVisible)
          Ze.setAttribute(Tt, ht ? ht + " " + rt : rt);
        else {
          var _t = ht && ht.replace(rt, "").trim();
          _t ? Ze.setAttribute(Tt, _t) : Ze.removeAttribute(Tt);
        }
      });
    }
  }
  function xe() {
    if (!(Ee || !$e.props.aria.expanded)) {
      var $t = normalizeToArray($e.props.triggerTarget || re);
      $t.forEach(function(Tt) {
        $e.props.interactive ? Tt.setAttribute("aria-expanded", $e.state.isVisible && Tt === Ae() ? "true" : "false") : Tt.removeAttribute("aria-expanded");
      });
    }
  }
  function ke() {
    Oe().removeEventListener("mousemove", ve), mouseMoveListeners = mouseMoveListeners.filter(function($t) {
      return $t !== ve;
    });
  }
  function Le($t) {
    if (!(currentInput.isTouch && (_e || $t.type === "mousedown"))) {
      var Tt = $t.composedPath && $t.composedPath()[0] || $t.target;
      if (!($e.props.interactive && actualContains(Ce, Tt))) {
        if (normalizeToArray($e.props.triggerTarget || re).some(function(rt) {
          return actualContains(rt, Tt);
        })) {
          if (currentInput.isTouch || $e.state.isVisible && $e.props.trigger.indexOf("click") >= 0)
            return;
        } else
          Re("onClickOutside", [$e, $t]);
        $e.props.hideOnClick === !0 && ($e.clearDelayTimeouts(), $e.hide(), he = !0, setTimeout(function() {
          he = !1;
        }), $e.state.isMounted || Qe());
      }
    }
  }
  function He() {
    _e = !0;
  }
  function We() {
    _e = !1;
  }
  function Xe() {
    var $t = Oe();
    $t.addEventListener("mousedown", Le, !0), $t.addEventListener("touchend", Le, TOUCH_OPTIONS), $t.addEventListener("touchstart", We, TOUCH_OPTIONS), $t.addEventListener("touchmove", He, TOUCH_OPTIONS);
  }
  function Qe() {
    var $t = Oe();
    $t.removeEventListener("mousedown", Le, !0), $t.removeEventListener("touchend", Le, TOUCH_OPTIONS), $t.removeEventListener("touchstart", We, TOUCH_OPTIONS), $t.removeEventListener("touchmove", He, TOUCH_OPTIONS);
  }
  function tt($t, Tt) {
    Ge($t, function() {
      !$e.state.isVisible && Ce.parentNode && Ce.parentNode.contains(Ce) && Tt();
    });
  }
  function Je($t, Tt) {
    Ge($t, Tt);
  }
  function Ge($t, Tt) {
    var rt = Be().box;
    function qe(Ze) {
      Ze.target === rt && (updateTransitionEndListener(rt, "remove", qe), Tt());
    }
    if ($t === 0)
      return Tt();
    updateTransitionEndListener(rt, "remove", oe), updateTransitionEndListener(rt, "add", qe), oe = qe;
  }
  function Ye($t, Tt, rt) {
    rt === void 0 && (rt = !1);
    var qe = normalizeToArray($e.props.triggerTarget || re);
    qe.forEach(function(Ze) {
      Ze.addEventListener($t, Tt, rt), be.push({
        node: Ze,
        eventType: $t,
        handler: Tt,
        options: rt
      });
    });
  }
  function ze() {
    Pe() && (Ye("touchstart", ot, {
      passive: !0
    }), Ye("touchend", gt, {
      passive: !0
    })), splitBySpaces($e.props.trigger).forEach(function($t) {
      if ($t !== "manual")
        switch (Ye($t, ot), $t) {
          case "mouseenter":
            Ye("mouseleave", gt);
            break;
          case "focus":
            Ye(isIE11 ? "focusout" : "blur", yt);
            break;
          case "focusin":
            Ye("focusout", yt);
            break;
        }
    });
  }
  function Fe() {
    be.forEach(function($t) {
      var Tt = $t.node, rt = $t.eventType, qe = $t.handler, Ze = $t.options;
      Tt.removeEventListener(rt, qe, Ze);
    }), be = [];
  }
  function ot($t) {
    var Tt, rt = !1;
    if (!(!$e.state.isEnabled || pt($t) || he)) {
      var qe = ((Tt = se) == null ? void 0 : Tt.type) === "focus";
      se = $t, me = $t.currentTarget, xe(), !$e.state.isVisible && isMouseEvent($t) && mouseMoveListeners.forEach(function(Ze) {
        return Ze($t);
      }), $t.type === "click" && ($e.props.trigger.indexOf("mouseenter") < 0 || ce) && $e.props.hideOnClick !== !1 && $e.state.isVisible ? rt = !0 : De($t), $t.type === "click" && (ce = !rt), rt && !qe && at($t);
    }
  }
  function vt($t) {
    var Tt = $t.target, rt = Ae().contains(Tt) || Ce.contains(Tt);
    if (!($t.type === "mousemove" && rt)) {
      var qe = je().concat(Ce).map(function(Ze) {
        var ht, _t = Ze._tippy, Ct = (ht = _t.popperInstance) == null ? void 0 : ht.state;
        return Ct ? {
          popperRect: Ze.getBoundingClientRect(),
          popperState: Ct,
          props: ee
        } : null;
      }).filter(Boolean);
      isCursorOutsideInteractiveBorder(qe, $t) && (ke(), at($t));
    }
  }
  function gt($t) {
    var Tt = pt($t) || $e.props.trigger.indexOf("click") >= 0 && ce;
    if (!Tt) {
      if ($e.props.interactive) {
        $e.hideWithInteractivity($t);
        return;
      }
      at($t);
    }
  }
  function yt($t) {
    $e.props.trigger.indexOf("focusin") < 0 && $t.target !== Ae() || $e.props.interactive && $t.relatedTarget && Ce.contains($t.relatedTarget) || at($t);
  }
  function pt($t) {
    return currentInput.isTouch ? Pe() !== $t.type.indexOf("touch") >= 0 : !1;
  }
  function bt() {
    ut();
    var $t = $e.props, Tt = $t.popperOptions, rt = $t.placement, qe = $t.offset, Ze = $t.getReferenceClientRect, ht = $t.moveTransition, _t = Me() ? getChildren(Ce).arrow : null, Ct = Ze ? {
      getBoundingClientRect: Ze,
      contextElement: Ze.contextElement || Ae()
    } : re, wt = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(kt) {
        var Mt = kt.state;
        if (Me()) {
          var At = Be(), Rt = At.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Ot) {
            Ot === "placement" ? Rt.setAttribute("data-placement", Mt.placement) : Mt.attributes.popper["data-popper-" + Ot] ? Rt.setAttribute("data-" + Ot, "") : Rt.removeAttribute("data-" + Ot);
          }), Mt.attributes.popper = {};
        }
      }
    }, It = [{
      name: "offset",
      options: {
        offset: qe
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !ht
      }
    }, wt];
    Me() && _t && It.push({
      name: "arrow",
      options: {
        element: _t,
        padding: 3
      }
    }), It.push.apply(It, (Tt == null ? void 0 : Tt.modifiers) || []), $e.popperInstance = createPopper(Ct, Ce, Object.assign({}, Tt, {
      placement: rt,
      onFirstUpdate: ue,
      modifiers: It
    }));
  }
  function ut() {
    $e.popperInstance && ($e.popperInstance.destroy(), $e.popperInstance = null);
  }
  function Ke() {
    var $t = $e.props.appendTo, Tt, rt = Ae();
    $e.props.interactive && $t === TIPPY_DEFAULT_APPEND_TO || $t === "parent" ? Tt = rt.parentNode : Tt = invokeWithArgsOrReturn($t, [rt]), Tt.contains(Ce) || Tt.appendChild(Ce), $e.state.isMounted = !0, bt();
  }
  function je() {
    return arrayFrom(Ce.querySelectorAll("[data-tippy-root]"));
  }
  function De($t) {
    $e.clearDelayTimeouts(), $t && Re("onTrigger", [$e, $t]), Xe();
    var Tt = Ve(!0), rt = we(), qe = rt[0], Ze = rt[1];
    currentInput.isTouch && qe === "hold" && Ze && (Tt = Ze), Tt ? ne = setTimeout(function() {
      $e.show();
    }, Tt) : $e.show();
  }
  function at($t) {
    if ($e.clearDelayTimeouts(), Re("onUntrigger", [$e, $t]), !$e.state.isVisible) {
      Qe();
      return;
    }
    if (!($e.props.trigger.indexOf("mouseenter") >= 0 && $e.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf($t.type) >= 0 && ce)) {
      var Tt = Ve(!1);
      Tt ? ie = setTimeout(function() {
        $e.state.isVisible && $e.hide();
      }, Tt) : ae = requestAnimationFrame(function() {
        $e.hide();
      });
    }
  }
  function dt() {
    $e.state.isEnabled = !0;
  }
  function ft() {
    $e.hide(), $e.state.isEnabled = !1;
  }
  function lt() {
    clearTimeout(ne), clearTimeout(ie), cancelAnimationFrame(ae);
  }
  function nt($t) {
    if (!$e.state.isDestroyed) {
      Re("onBeforeUpdate", [$e, $t]), Fe();
      var Tt = $e.props, rt = evaluateProps(re, Object.assign({}, Tt, removeUndefinedProps($t), {
        ignoreAttributes: !0
      }));
      $e.props = rt, ze(), Tt.interactiveDebounce !== rt.interactiveDebounce && (ke(), ve = debounce(vt, rt.interactiveDebounce)), Tt.triggerTarget && !rt.triggerTarget ? normalizeToArray(Tt.triggerTarget).forEach(function(qe) {
        qe.removeAttribute("aria-expanded");
      }) : rt.triggerTarget && re.removeAttribute("aria-expanded"), xe(), Ue(), Ie && Ie(Tt, rt), $e.popperInstance && (bt(), je().forEach(function(qe) {
        requestAnimationFrame(qe._tippy.popperInstance.forceUpdate);
      })), Re("onAfterUpdate", [$e, $t]);
    }
  }
  function ct($t) {
    $e.setProps({
      content: $t
    });
  }
  function it() {
    var $t = $e.state.isVisible, Tt = $e.state.isDestroyed, rt = !$e.state.isEnabled, qe = currentInput.isTouch && !$e.props.touch, Ze = getValueAtIndexOrReturn($e.props.duration, 0, defaultProps.duration);
    if (!($t || Tt || rt || qe) && !Ae().hasAttribute("disabled") && (Re("onShow", [$e], !1), $e.props.onShow($e) !== !1)) {
      if ($e.state.isVisible = !0, Me() && (Ce.style.visibility = "visible"), Ue(), Xe(), $e.state.isMounted || (Ce.style.transition = "none"), Me()) {
        var ht = Be(), _t = ht.box, Ct = ht.content;
        setTransitionDuration([_t, Ct], 0);
      }
      ue = function() {
        var It;
        if (!(!$e.state.isVisible || le)) {
          if (le = !0, Ce.style.transition = $e.props.moveTransition, Me() && $e.props.animation) {
            var Pt = Be(), kt = Pt.box, Mt = Pt.content;
            setTransitionDuration([kt, Mt], Ze), setVisibilityState([kt, Mt], "visible");
          }
          Ne(), xe(), pushIfUnique(mountedInstances, $e), (It = $e.popperInstance) == null || It.forceUpdate(), Re("onMount", [$e]), $e.props.animation && Me() && Je(Ze, function() {
            $e.state.isShown = !0, Re("onShown", [$e]);
          });
        }
      }, Ke();
    }
  }
  function et() {
    var $t = !$e.state.isVisible, Tt = $e.state.isDestroyed, rt = !$e.state.isEnabled, qe = getValueAtIndexOrReturn($e.props.duration, 1, defaultProps.duration);
    if (!($t || Tt || rt) && (Re("onHide", [$e], !1), $e.props.onHide($e) !== !1)) {
      if ($e.state.isVisible = !1, $e.state.isShown = !1, le = !1, ce = !1, Me() && (Ce.style.visibility = "hidden"), ke(), Qe(), Ue(!0), Me()) {
        var Ze = Be(), ht = Ze.box, _t = Ze.content;
        $e.props.animation && (setTransitionDuration([ht, _t], qe), setVisibilityState([ht, _t], "hidden"));
      }
      Ne(), xe(), $e.props.animation ? Me() && tt(qe, $e.unmount) : $e.unmount();
    }
  }
  function st($t) {
    Oe().addEventListener("mousemove", ve), pushIfUnique(mouseMoveListeners, ve), ve($t);
  }
  function mt() {
    $e.state.isVisible && $e.hide(), $e.state.isMounted && (ut(), je().forEach(function($t) {
      $t._tippy.unmount();
    }), Ce.parentNode && Ce.parentNode.removeChild(Ce), mountedInstances = mountedInstances.filter(function($t) {
      return $t !== $e;
    }), $e.state.isMounted = !1, Re("onHidden", [$e]));
  }
  function St() {
    $e.state.isDestroyed || ($e.clearDelayTimeouts(), $e.unmount(), Fe(), delete re._tippy, $e.state.isDestroyed = !0, Re("onDestroy", [$e]));
  }
}
function tippy(re, te) {
  te === void 0 && (te = {});
  var ee = defaultProps.plugins.concat(te.plugins || []);
  bindGlobalEventListeners();
  var ne = Object.assign({}, te, {
    plugins: ee
  }), ie = getArrayOfElements(re), ae = ie.reduce(function(ce, he) {
    var _e = he && createTippy(he, ne);
    return _e && ce.push(_e), ce;
  }, []);
  return isElement(re) ? ae[0] : ae;
}
tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
Object.assign({}, applyStyles$1, {
  effect: function(te) {
    var ee = te.state, ne = {
      popper: {
        position: ee.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(ee.elements.popper.style, ne.popper), ee.styles = ne, ee.elements.arrow && Object.assign(ee.elements.arrow.style, ne.arrow);
  }
});
var mouseCoords = {
  clientX: 0,
  clientY: 0
}, activeInstances = [];
function storeMouseCoords(re) {
  var te = re.clientX, ee = re.clientY;
  mouseCoords = {
    clientX: te,
    clientY: ee
  };
}
function addMouseCoordsListener(re) {
  re.addEventListener("mousemove", storeMouseCoords);
}
function removeMouseCoordsListener(re) {
  re.removeEventListener("mousemove", storeMouseCoords);
}
var followCursor = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(te) {
    var ee = te.reference, ne = getOwnerDocument(te.props.triggerTarget || ee), ie = !1, ae = !1, ce = !0, he = te.props;
    function _e() {
      return te.props.followCursor === "initial" && te.state.isVisible;
    }
    function le() {
      ne.addEventListener("mousemove", ue);
    }
    function se() {
      ne.removeEventListener("mousemove", ue);
    }
    function oe() {
      ie = !0, te.setProps({
        getReferenceClientRect: null
      }), ie = !1;
    }
    function ue(me) {
      var pe = me.target ? ee.contains(me.target) : !0, fe = te.props.followCursor, ge = me.clientX, ye = me.clientY, $e = ee.getBoundingClientRect(), Se = ge - $e.left, Ce = ye - $e.top;
      (pe || !te.props.interactive) && te.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var Te = ee.getBoundingClientRect(), Ee = ge, we = ye;
          fe === "initial" && (Ee = Te.left + Se, we = Te.top + Ce);
          var Pe = fe === "horizontal" ? Te.top : we, Me = fe === "vertical" ? Te.right : Ee, Ae = fe === "horizontal" ? Te.bottom : we, Oe = fe === "vertical" ? Te.left : Ee;
          return {
            width: Me - Oe,
            height: Ae - Pe,
            top: Pe,
            right: Me,
            bottom: Ae,
            left: Oe
          };
        }
      });
    }
    function be() {
      te.props.followCursor && (activeInstances.push({
        instance: te,
        doc: ne
      }), addMouseCoordsListener(ne));
    }
    function ve() {
      activeInstances = activeInstances.filter(function(me) {
        return me.instance !== te;
      }), activeInstances.filter(function(me) {
        return me.doc === ne;
      }).length === 0 && removeMouseCoordsListener(ne);
    }
    return {
      onCreate: be,
      onDestroy: ve,
      onBeforeUpdate: function() {
        he = te.props;
      },
      onAfterUpdate: function(pe, fe) {
        var ge = fe.followCursor;
        ie || ge !== void 0 && he.followCursor !== ge && (ve(), ge ? (be(), te.state.isMounted && !ae && !_e() && le()) : (se(), oe()));
      },
      onMount: function() {
        te.props.followCursor && !ae && (ce && (ue(mouseCoords), ce = !1), _e() || le());
      },
      onTrigger: function(pe, fe) {
        isMouseEvent(fe) && (mouseCoords = {
          clientX: fe.clientX,
          clientY: fe.clientY
        }), ae = fe.type === "focus";
      },
      onHidden: function() {
        te.props.followCursor && (oe(), se(), ce = !0);
      }
    };
  }
}, sticky = {
  name: "sticky",
  defaultValue: !1,
  fn: function(te) {
    var ee = te.reference, ne = te.popper;
    function ie() {
      return te.popperInstance ? te.popperInstance.state.elements.reference : ee;
    }
    function ae(le) {
      return te.props.sticky === !0 || te.props.sticky === le;
    }
    var ce = null, he = null;
    function _e() {
      var le = ae("reference") ? ie().getBoundingClientRect() : null, se = ae("popper") ? ne.getBoundingClientRect() : null;
      (le && areRectsDifferent(ce, le) || se && areRectsDifferent(he, se)) && te.popperInstance && te.popperInstance.update(), ce = le, he = se, te.state.isMounted && requestAnimationFrame(_e);
    }
    return {
      onMount: function() {
        te.props.sticky && _e();
      }
    };
  }
};
function areRectsDifferent(re, te) {
  return re && te ? re.top !== te.top || re.right !== te.right || re.bottom !== te.bottom || re.left !== te.left : !0;
}
tippy.setDefaultProps({
  animation: !1
});
const callbacks = /* @__PURE__ */ new WeakMap();
let observer;
typeof MutationObserver < "u" && (observer = new MutationObserver((re) => {
  re.forEach(function(te) {
    var ee;
    te.type === "attributes" && ((ee = callbacks.get(te.target)) === null || ee === void 0 || ee.forEach((ne) => {
      var ie;
      return ne((ie = te.target.getAttribute("mode")) !== null && ie !== void 0 ? ie : "light");
    }));
  });
}));
function closestElement(re, te) {
  const ee = te.closest(re);
  if (ee)
    return ee;
  const ne = te.getRootNode();
  return ne === global$1.document || !(ne instanceof ShadowRoot) ? null : closestElement(re, ne.host);
}
function consumeMode(re, te) {
  var ee;
  const ne = closestElement(transformTagName("cosmos-mode"), re.element);
  ne && (te((ee = ne.getAttribute("mode")) !== null && ee !== void 0 ? ee : "light"), callbacks.has(ne) ? callbacks.get(ne).push(te) : (observer == null || observer.observe(ne, { attributes: !0 }), callbacks.set(ne, [te])));
}
function resolveAppearance({ instance: re, modeToAppearanceMap: te, callback: ee }) {
  re.appearance ? ee(re.appearance) : consumeMode(re, (ne) => {
    re.appearance || ee(te[ne]);
  });
}
const version = "9.11.1", transformTagName = (re) => `${re}-${version.replace(/\./g, "-")}`, isNumeric = (re) => /^-?\d+$/.test(re), stringBooleanToBoolean = (re) => typeof re == "boolean" ? re : typeof re == "string" && ["", "true", "false"].includes(re) ? re !== "false" : !1;
function getNumericClampValue(re) {
  if (isNumeric(re))
    return Number(re);
  if (typeof re == "string" || typeof re == "boolean")
    return stringBooleanToBoolean(re) ? 1 : void 0;
}
function isSingleLineClamp(re) {
  return typeof re == "number" ? re === 1 : !1;
}
function isMultiLineClamp(re) {
  return typeof re == "number" ? re > 1 : !1;
}
const cosmosTextCss = '@charset "UTF-8";:host{display:block}:host([clamp]){min-width:0}:host{--cosmos-font-family-text:Bull Text, Helvetica, sans-serif}@supports (font-variation-settings: normal){:host{--cosmos-font-family-text:Bull VF, Helvetica, sans-serif}}:host(:lang(ja)){--cosmos-font-family-text:Noto Sans JP, Helvetica, sans-serif}:host(:lang(ar)){--cosmos-font-family-text:Noto Kufi Arabic, Helvetica, sans-serif}:host(:lang(ko)){--cosmos-font-family-text:Noto Sans KR, Helvetica, sans-serif}:host(:lang(hi)){--cosmos-font-family-text:Noto Sans, Helvetica, sans-serif}:host(:lang(he)){--cosmos-font-family-text:Noto Sans Hebrew, Helvetica, sans-serif}:host(:lang(ka)){--cosmos-font-family-text:Noto Sans Georgian, Helvetica, sans-serif}:host(:lang(th)){--cosmos-font-family-text:Noto Sans Thai, Helvetica, sans-serif}:host(:lang(zh)){--cosmos-font-family-text:Microsoft YaHei, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host(:lang(zh-Hant)){--cosmos-font-family-text:Microsoft JhengHei, Geneva CY, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}@supports (font-variation-settings: normal){::slotted(strong),::slotted(b){font-variation-settings:"opsz" 12, "wght" 700}}.cosmos-text{--cosmos-font-weight-default-text-variable-regular:"opsz" 12, "wght" 400;--cosmos-font-weight-default-text-variable-medium:"opsz" 12, "wght" 500;--cosmos-font-weight-default-text-variable-bold:"opsz" 12, "wght" 700;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:var(--cosmos-text-color, #000F1E);font-family:var(--cosmos-text-font-family, var(--cosmos-font-family-text));font-style:var(--cosmos-text-font-style, inherit);font-variant-numeric:tabular-nums;font-variation-settings:var(--cosmos-font-weight-default-text-variable-regular);font-variation-settings:var(--cosmos-text-font-variation-settings, var(--cosmos-font-weight-default-text-variable-regular));font-weight:var(--cosmos-text-font-weight, 400);letter-spacing:var(--cosmos-text-letter-spacing, inherit);line-height:var(--cosmos-text-line-height, 1.5);margin:0;text-transform:var(--cosmos-text-text-transform, var(--cosmos-text-transform, inherit))}.cosmos-text--single-line-clamp{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cosmos-text--multi-line-clamp{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:var(--cosmos-text-clamp-length);overflow:hidden;}.cosmos-text--size-xx-small{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}@media (min-width: 380px){.cosmos-text--size-xx-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-text--size-xx-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-x-small{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}@media (min-width: 380px){.cosmos-text--size-x-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-text--size-x-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-small{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}@media (min-width: 380px){.cosmos-text--size-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-text--size-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-medium{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}@media (min-width: 380px){.cosmos-text--size-medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-text--size-medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}@media (min-width: 380px){.cosmos-text--size-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-text--size-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-x-large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}@media (min-width: 380px){.cosmos-text--size-x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-text--size-x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-xx-small\\@small{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-xx-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-xx-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-x-small\\@small{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-x-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-x-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-small\\@small{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-medium\\@small{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-medium\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-medium\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-large\\@small{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-x-large\\@small{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-x-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-x-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-xx-small\\@medium{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-xx-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-x-small\\@medium{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-x-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-x-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-small\\@medium{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-medium\\@medium{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-medium\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-medium\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-large\\@medium{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-x-large\\@medium{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-x-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-x-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-xx-small\\@large{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-xx-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-x-small\\@large{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-x-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-x-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-small\\@large{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-medium\\@large{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-medium\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-medium\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-large\\@large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-x-large\\@large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-x-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-x-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-xx-small\\@x-large{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-xx-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-x-small\\@x-large{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-x-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-x-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-small\\@x-large{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-medium\\@x-large{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-medium\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-medium\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-large\\@x-large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-x-large\\@x-large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-x-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-x-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-xx-small\\@xx-large{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-xx-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-x-small\\@xx-large{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-x-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-x-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-small\\@xx-large{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-medium\\@xx-large{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-medium\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-medium\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-large\\@xx-large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-x-large\\@xx-large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-x-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-x-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--spacing-none{margin-bottom:0;padding-top:0}.cosmos-text--spacing-long-form-bottom{padding-top:0}.cosmos-text--spacing-long-form-top{margin-bottom:0}.cosmos-text--weight-medium{font-variation-settings:var(--cosmos-text-font-variation-settings, var(--cosmos-font-weight-default-text-variable-medium));font-weight:var(--cosmos-text-font-weight, 500)}.cosmos-text--weight-bold{font-variation-settings:var(--cosmos-text-font-variation-settings, var(--cosmos-font-weight-default-text-variable-bold));font-weight:var(--cosmos-text-font-weight, 700)}.cosmos-text--kind-normal.cosmos-text--appearance-light{color:var(--cosmos-text-color, #FFFFFF)}.cosmos-text--kind-subtle{color:var(--cosmos-text-color, rgba(0, 15, 30, 0.6))}.cosmos-text--kind-subtle.cosmos-text--appearance-light{color:var(--cosmos-text-color, rgba(255, 255, 255, 0.6))}', CosmosText9111Style0 = cosmosTextCss, generateClassNames$9 = bem("cosmos-text"), CosmosText$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.appearance = void 0, this.clamp = void 0, this.kind = "normal", this.size = "medium", this.spacing = "none", this.tag = "p", this.weight = "regular", this.computedAppearance = "dark";
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  setNumericClampValue() {
    this.numericClampValue = getNumericClampValue(this.clamp);
  }
  getSize() {
    return this.size && isResponsiveProperty(this.size) ? parseResponsiveProperty(this.size) : this.size;
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.setNumericClampValue();
  }
  render() {
    var te;
    const ee = (te = this.tag) !== null && te !== void 0 ? te : "p";
    return h$1(Host, { key: "889c30e34d41d052cb544200c8191ec83acb73bc", style: isMultiLineClamp(this.numericClampValue) ? { "--cosmos-text-clamp-length": `${this.numericClampValue}` } : {} }, h$1(ee, { key: "25ac6865a920300161a9c3e53141a5211aeb33ad", class: generateClassNames$9({
      spacing: this.spacing,
      kind: this.kind,
      weight: this.weight,
      appearance: this.computedAppearance,
      size: this.getSize(),
      "single-line-clamp": isSingleLineClamp(this.numericClampValue),
      "multi-line-clamp": isMultiLineClamp(this.numericClampValue)
    }), part: "base" }, h$1("slot", { key: "9765bc714c585bff1dc5004139d9b4b24b71bf47" })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      clamp: ["setNumericClampValue"]
    };
  }
  static get style() {
    return CosmosText9111Style0;
  }
}, [1, "cosmos-text-9-11-1", {
  appearance: [513],
  clamp: [520],
  kind: [513],
  size: [513],
  spacing: [513],
  tag: [513],
  weight: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  clamp: ["setNumericClampValue"]
}]);
function defineCustomElement$Y() {
  if (typeof customElements > "u")
    return;
  ["cosmos-text-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-text-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosText$1);
        break;
    }
  });
}
const IMAGE_STATE_LOAD_SUCCESS = "success", IMAGE_STATE_LOAD_ERROR = "error", IMAGE_STATE_LOADING = "loading", cosmosImageCss = ':host{display:block;height:100%}.cosmos-image{display:-ms-flexbox;display:flex;height:100%;isolation:isolate;min-height:inherit;overflow:hidden}.cosmos-image--radius-none{border-radius:var(--cosmos-image-border-radius, 0)}.cosmos-image--radius-small{border-radius:var(--cosmos-image-border-radius, 2px)}.cosmos-image--radius-medium{border-radius:var(--cosmos-image-border-radius, 6px)}.cosmos-image--radius-large{border-radius:var(--cosmos-image-border-radius, 8px)}.cosmos-image--radius-full{border-radius:var(--cosmos-image-border-radius, 9999px)}.cosmos-image--fallback.cosmos-image--appearance-light{background-color:rgba(0, 15, 30, 0.05)}.cosmos-image--fallback.cosmos-image--appearance-dark{background-color:rgba(255, 255, 255, 0.1)}.cosmos-image--image-state-loading,.cosmos-image--fit-contain{background-color:transparent}.cosmos-image__container{display:grid;grid-template-areas:"image";height:100%;width:100%}.cosmos-image--has-preview:not(.cosmos-image--has-image) .cosmos-image__container{display:-ms-flexbox;display:flex}.cosmos-image--fit-contain .cosmos-image__container{place-content:center}.cosmos-image__preview-container,.cosmos-image__image{grid-area:image;max-height:100%;min-height:0}.cosmos-image--fit-cover .cosmos-image__preview-container,.cosmos-image--fit-cover .cosmos-image__image{}@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none){.cosmos-image--fit-cover .cosmos-image__preview-container,.cosmos-image--fit-cover .cosmos-image__image{width:100%}}.cosmos-image--fit-contain.cosmos-image--radius-none .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-none .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 0)}.cosmos-image--fit-contain.cosmos-image--radius-small .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-small .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 2px)}.cosmos-image--fit-contain.cosmos-image--radius-medium .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-medium .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 6px)}.cosmos-image--fit-contain.cosmos-image--radius-large .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-large .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 8px)}.cosmos-image--fit-contain.cosmos-image--radius-full .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-full .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 9999px)}.cosmos-image__preview-image,.cosmos-image__image{-o-object-fit:cover;object-fit:cover}.cosmos-image__preview-container{display:-ms-flexbox;display:flex;overflow:hidden;position:relative}.cosmos-image--fit-cover .cosmos-image__preview-container{width:100%}.cosmos-image__preview-image{-webkit-filter:blur(5px);filter:blur(5px);height:calc(100% + 5px * 2);inset:0;position:absolute;-webkit-transform:translate(-5px, -5px);transform:translate(-5px, -5px);width:calc(100% + 5px * 2)}.cosmos-image__preview-dummy{max-width:100%}.cosmos-image--has-preview:not(.cosmos-image--has-image) .cosmos-image__preview-dummy{width:100%}.cosmos-image__image{max-width:100%;-webkit-transition:opacity 0.2s cubic-bezier(0, 0.32, 0.32, 1);transition:opacity 0.2s cubic-bezier(0, 0.32, 0.32, 1);z-index:1}.cosmos-image--image-state-loading .cosmos-image__image{opacity:0}.cosmos-image--image-state-success .cosmos-image__image{opacity:1;width:100%}.cosmos-image--fit-cover .cosmos-image__image{height:100%}', CosmosImage9111Style0 = cosmosImageCss, generateClassNames$8 = bem("cosmos-image"), CosmosImage = /* @__PURE__ */ proxyCustomElement(class extends H {
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  handleImageChange(te, ee) {
    te !== ee && (this.imageState = IMAGE_STATE_LOADING);
  }
  handleObserveResizeChange(te) {
    this.containerResizeObserver && (this.containerResizeObserver.unobserve(this.container), te && this.containerResizeObserver.observe(this.container));
  }
  handleContainerResize(te) {
    te.forEach((ee) => {
      if (ee.target === this.container) {
        const { height: ne, width: ie } = ee.contentRect;
        this.resize.emit({
          height: ne,
          width: ie
        });
      }
    });
  }
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.resize = createEvent(this, "resize", 5), this.handleImageLoad = () => {
      this.imageState = IMAGE_STATE_LOAD_SUCCESS;
    }, this.handleImageError = () => {
      this.imageState = IMAGE_STATE_LOAD_ERROR;
    }, this.handlePreviewError = () => {
      this.previewState = IMAGE_STATE_LOAD_ERROR;
    }, this.shouldDisplayFallback = () => !(this.shouldDisplayImage() || this.shouldDisplayPreview()), this.shouldDisplayImage = () => !!this.image && this.imageState !== IMAGE_STATE_LOAD_ERROR, this.shouldDisplayPreview = () => !!this.imagePreview && this.previewState !== IMAGE_STATE_LOAD_ERROR, this.appearance = void 0, this.fit = "cover", this.image = void 0, this.imageAlt = "", this.imagePreview = void 0, this.loading = void 0, this.observeResize = void 0, this.radius = "none", this.sizes = void 0, this.srcset = void 0, this.computedAppearance = "light", this.imageState = void 0, this.previewState = void 0, !isNodeEnvironment() && (this.containerResizeObserver = new ResizeObserver((te) => this.handleContainerResize(te)));
  }
  componentWillLoad() {
    if (resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "dark", light: "light" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.image && typeof Image < "u") {
      const te = new Image();
      te.src = this.image, te.complete ? this.imageState = IMAGE_STATE_LOAD_SUCCESS : this.imageState = IMAGE_STATE_LOADING;
    }
  }
  componentDidLoad() {
    this.observeResize && this.handleObserveResizeChange(this.observeResize);
  }
  render() {
    return h$1("div", { key: "c21f11ab0d7d6db6cd7faaf57ffeff7816323699", class: generateClassNames$8({
      appearance: this.computedAppearance,
      fallback: this.shouldDisplayFallback(),
      fit: this.fit,
      "has-image": !!this.image,
      "has-preview": !!this.imagePreview,
      "image-state": this.imageState,
      radius: this.radius
    }), part: "base", ref: (te) => this.container = te }, !this.shouldDisplayFallback() && h$1("div", { key: "f75f86b507d34a96e84187ffbccc72b5860be6ab", class: generateClassNames$8("container") }, this.shouldDisplayPreview() && h$1("div", { key: "1a11d8eb82813ff3cec3a94f3ed3973faa8e491c", class: generateClassNames$8("preview-container") }, h$1("img", { key: "161097351dbc8ce011d96d3ef84aafef83a0c4ce", alt: "", class: generateClassNames$8("preview-image"), onError: this.handlePreviewError, src: this.imagePreview }), h$1("img", { key: "e365a0791f204fec1701e5c054bcb5fc95810fb0", alt: "", class: generateClassNames$8("preview-dummy"), src: this.imagePreview })), this.shouldDisplayImage() && h$1("img", { key: "41b0f27a924696ade1d7d071d31c2f5d3f02b6c5", alt: this.imageAlt, class: generateClassNames$8("image"), loading: this.loading, onError: this.handleImageError, onLoad: this.handleImageLoad, part: "image", sizes: this.sizes, src: this.image, srcSet: this.srcset })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      image: ["handleImageChange"],
      observeResize: ["handleObserveResizeChange"]
    };
  }
  static get style() {
    return CosmosImage9111Style0;
  }
}, [1, "cosmos-image-9-11-1", {
  appearance: [513],
  fit: [513],
  image: [513],
  imageAlt: [513, "image-alt"],
  imagePreview: [513, "image-preview"],
  loading: [513],
  observeResize: [516, "observe-resize"],
  radius: [513],
  sizes: [513],
  srcset: [513],
  computedAppearance: [32],
  imageState: [32],
  previewState: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  image: ["handleImageChange"],
  observeResize: ["handleObserveResizeChange"]
}]);
function defineCustomElement$X() {
  if (typeof customElements > "u")
    return;
  ["cosmos-image-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-image-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosImage);
        break;
    }
  });
}
const getRandomInt = () => Math.floor(Math.random() * 1e3), cosmosSpinnerCss = ":host{display:block;height:1em;width:1em}.cosmos-spinner{color:var(--cosmos-spinner-color, #000F1E);display:block;height:100%;width:100%}@media screen and (prefers-reduced-motion: no-preference){.cosmos-spinner{-webkit-animation:spin 0.7s linear infinite;animation:spin 0.7s linear infinite}@-webkit-keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}}.cosmos-spinner *{stop-color:currentColor}.cosmos-spinner--appearance-light{color:var(--cosmos-spinner-color, #FFFFFF)}", CosmosSpinner9111Style0 = cosmosSpinnerCss, generateClassNames$7 = bem("cosmos-spinner"), CosmosSpinner$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.appearance = void 0, this.computedAppearance = "dark";
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  render() {
    const te = getRandomInt();
    return h$1("svg", { key: "2c715686e4f2343d862f56a38d1cb90bf078932c", class: generateClassNames$7({
      appearance: this.computedAppearance
    }), viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "4c2f695b0409df5a98cb06d5da8b8a533d5f4efa", d: "M16.6292 7.75012C17.1997 8.73827 17.5 9.85919 17.5 11.0002C17.5 12.1412 17.1997 13.2621 16.6292 14.2503", stroke: `url(#segment-1-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("path", { key: "b3d565a317dc2003d44dfa1f97bb1b3b9d3aaff3", d: "M16.6291 14.2502C16.0586 15.2384 15.2381 16.0589 14.25 16.6294C13.2619 17.1999 12.141 17.5003 11 17.5003", stroke: `url(#segment-2-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("path", { key: "cacee4d695930b8faac1ffbb1689f1826b7f9bb4", d: "M11 17.5003C9.859 17.5003 8.73812 17.1999 7.75 16.6294C6.76188 16.0589 5.94134 15.2384 5.37085 14.2502", stroke: `url(#segment-3-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("path", { key: "3ff52bb568dc171db6d7e74d46eeaa9a48837e68", d: "M5.37086 14.2503C4.80035 13.2621 4.5 12.1412 4.5 11.0002C4.5 9.85919 4.80035 8.73827 5.37086 7.75012", stroke: `url(#segment-4-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("path", { key: "9f0a54bfe08572cad3d4d8b6ce57aa1ee746392d", d: "M5.37085 7.75008C5.94134 6.76196 6.76188 5.94141 7.75 5.3709C8.73812 4.80039 9.859 4.50003 11 4.5", stroke: `url(#segment-5-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("defs", { key: "52a90404ee749092b76a675299a413224b3079b6" }, h$1("linearGradient", { key: "02303ef38c15766ac9ed603c493088ff6e5f6596", id: `segment-1-${te}`, x1: "15.5", y1: "8.5", x2: "15.5", y2: "13.5", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "6b89b0457af720037898db02d7a4adbcaf70309d", "stop-opacity": "0" }), h$1("stop", { key: "83508d89bd79e8a9b7eea9924f38fd916e1d3c04", offset: "1", "stop-opacity": "0.25" })), h$1("linearGradient", { key: "3bb0e5a1da134d948c623042df3d8f96852083b9", id: `segment-2-${te}`, x1: "15.5", y1: "13.5", x2: "13.2074", y2: "17.3236", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "4663e21f084a10adc4876e1ee7773e89445409cf", "stop-opacity": "0.25" }), h$1("stop", { key: "8230121cdc8221374594cb8e1822b1cfe3def529", offset: "1", "stop-opacity": "0.5" })), h$1("linearGradient", { key: "9718848d846bca60776e0c338d66a70f3faaffcd", id: `segment-3-${te}`, x1: "11", y1: "16", x2: "9.0824", y2: "12.3929", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "e1f860ea3835c0ec3a88e19d85e5a2c6d8e8e7ac", "stop-opacity": "0.5" }), h$1("stop", { key: "a3cd9942c823e721cfa5c81f813449295e7a3f6b", offset: "1", "stop-opacity": "0.75" })), h$1("linearGradient", { key: "d332d24e6d2788d2fc916d3227bce4ce961aef99", id: `segment-4-${te}`, x1: "6.5", y1: "13.5", x2: "6.5", y2: "8.5", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "e9db0abea9662792423cd0b0cf326e20f9f088b4", "stop-opacity": "0.75" }), h$1("stop", { key: "db5d807a69eda06bf5d048d6fbdcb16a5dd3ea62", offset: "1" })), h$1("linearGradient", { key: "a5c4e975d87bd8c3da967ae1b4f26eba3d086a87", id: `segment-5-${te}`, x1: "7", y1: "8", x2: "9.13409", y2: "4.76796", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "af4a064199a73b9e2150ec397a7db4990ed4470e" }), h$1("stop", { key: "e559de04c2ec856b0429d7dc6fb16b609f1d31ba", offset: "1" }))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"]
    };
  }
  static get style() {
    return CosmosSpinner9111Style0;
  }
}, [1, "cosmos-spinner-9-11-1", {
  appearance: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"]
}]);
function defineCustomElement$W() {
  if (typeof customElements > "u")
    return;
  ["cosmos-spinner-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-spinner-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosSpinner$1);
        break;
    }
  });
}
const cosmosButtonCss = ':host{display:inline-block;line-height:0;max-width:100%}:host([width=content]){width:auto}:host([width=full]){width:100%}@media screen and (min-width: 0){:host([width~="content@small"]){width:auto}}@media screen and (min-width: 0){:host([width~="full@small"]){width:100%}}@media screen and (min-width: 650px){:host([width~="content@medium"]){width:auto}}@media screen and (min-width: 650px){:host([width~="full@medium"]){width:100%}}@media screen and (min-width: 1000px){:host([width~="content@large"]){width:auto}}@media screen and (min-width: 1000px){:host([width~="full@large"]){width:100%}}@media screen and (min-width: 1200px){:host([width~="content@x-large"]){width:auto}}@media screen and (min-width: 1200px){:host([width~="full@x-large"]){width:100%}}@media screen and (min-width: 1350px){:host([width~="content@xx-large"]){width:auto}}@media screen and (min-width: 1350px){:host([width~="full@xx-large"]){width:100%}}.cosmos-button{--cosmos-icon-color:currentColor;--focus-offset:var(--cosmos-button-border-width, 1px);-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-color:var(--cosmos-button-border-color, transparent);border-radius:var(--cosmos-button-border-radius, 6px);border-style:solid;border-width:var(--cosmos-button-border-width, 1px);-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;display:-ms-flexbox;display:flex;height:var(--cosmos-button-height);-ms-flex-pack:center;justify-content:center;max-width:100%;outline:none;padding-block:0;position:relative;text-decoration:none;white-space:nowrap}.cosmos-button:focus,.cosmos-button:focus:not(:focus-visible){outline:none}.cosmos-button:focus:not(:focus-visible)::before{content:none}.cosmos-button:focus::before{border-radius:calc(var(--focus-radius, 6px) * 1.5);bottom:calc((4px + var(--focus-offset, 0px)) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + var(--focus-offset, 0px)) * -1);position:absolute;right:calc((4px + var(--focus-offset, 0px)) * -1);top:calc((4px + var(--focus-offset, 0px)) * -1);content:""}.cosmos-button.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover);border-color:var(--cosmos-button-border-color-hover, transparent)}.cosmos-button--busy:not(.cosmos-button--has-icon) .cosmos-button__spinner{left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.cosmos-button--busy:not(.cosmos-button--has-icon) .cosmos-button__label{visibility:hidden}.cosmos-button--busy.cosmos-button--has-icon ::slotted([slot=icon]){display:none}.cosmos-button__label{-ms-flex-item-align:baseline;align-self:baseline;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;--cosmos-text-color:currentColor;--cosmos-text-font-family:var(--cosmos-button-font-family);--cosmos-text-font-size:var(--cosmos-button-font-size);--cosmos-text-font-style:var(--cosmos-button-font-style);--cosmos-text-font-weight:var(--cosmos-button-font-weight);--cosmos-text-letter-spacing:var(--cosmos-button-letter-spacing);--cosmos-text-line-height:var(--cosmos-button-line-height);--cosmos-text-text-transform:var(--cosmos-button-text-transform)}:not(.cosmos-button--kind-link).cosmos-button--size-small .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(36rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-small .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-small .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(36rem / var(--cosmos-base-font-size, 16)))}:not(.cosmos-button--kind-link).cosmos-button--size-medium .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(40rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-medium .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-medium .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(40rem / var(--cosmos-base-font-size, 16)))}:not(.cosmos-button--kind-link).cosmos-button--size-large .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(48rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-large .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-large .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(48rem / var(--cosmos-base-font-size, 16)))}.cosmos-button__spinner{--cosmos-spinner-color:currentColor;height:calc(18rem / var(--cosmos-base-font-size, 16));width:calc(18rem / var(--cosmos-base-font-size, 16))}.cosmos-button ::slotted([slot=icon]),.cosmos-button__spinner{-ms-flex-negative:0;flex-shrink:0}.cosmos-button--icon-after{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.cosmos-button--width-content{width:auto}.cosmos-button--width-full{width:100%}@media screen and (min-width: 0){.cosmos-button--width-content\\@small{width:auto}}@media screen and (min-width: 0){.cosmos-button--width-full\\@small{width:100%}}@media screen and (min-width: 650px){.cosmos-button--width-content\\@medium{width:auto}}@media screen and (min-width: 650px){.cosmos-button--width-full\\@medium{width:100%}}@media screen and (min-width: 1000px){.cosmos-button--width-content\\@large{width:auto}}@media screen and (min-width: 1000px){.cosmos-button--width-full\\@large{width:100%}}@media screen and (min-width: 1200px){.cosmos-button--width-content\\@x-large{width:auto}}@media screen and (min-width: 1200px){.cosmos-button--width-full\\@x-large{width:100%}}@media screen and (min-width: 1350px){.cosmos-button--width-content\\@xx-large{width:auto}}@media screen and (min-width: 1350px){.cosmos-button--width-full\\@xx-large{width:100%}}.cosmos-button--size-small{--cosmos-icon-size:var(--cosmos-button-icon-size, calc(16rem / var(--cosmos-base-font-size, 16)));--cosmos-button-height:calc(36rem / var(--cosmos-base-font-size, 16));gap:calc(4rem / var(--cosmos-base-font-size, 16));padding-inline:calc(16rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-medium{--cosmos-button-height:calc(40rem / var(--cosmos-base-font-size, 16));padding-inline:calc(20rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-large{--cosmos-button-height:calc(48rem / var(--cosmos-base-font-size, 16));padding-inline:calc(32rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-medium,.cosmos-button--size-large{--cosmos-icon-size:var(--cosmos-button-icon-size, calc(18rem / var(--cosmos-base-font-size, 16)));gap:calc(6rem / var(--cosmos-base-font-size, 16))}.cosmos-button--shape-pill:not(.cosmos-button--kind-link){--focus-radius:var(--cosmos-button-border-radius, 9999px);border-radius:var(--cosmos-button-border-radius, 9999px)}.cosmos-button--shape-square,.cosmos-button--shape-circle{gap:0;padding:0;width:var(--cosmos-button-height)}.cosmos-button--shape-square .cosmos-button__label,.cosmos-button--shape-circle .cosmos-button__label{-ms-flex-item-align:center;align-self:center}.cosmos-button--shape-square.cosmos-button--busy .cosmos-button__label,.cosmos-button--shape-circle.cosmos-button--busy .cosmos-button__label{display:none}.cosmos-button--shape-circle{--focus-radius:var(--cosmos-button-border-radius, 9999px);border-radius:var(--cosmos-button-border-radius, 9999px)}.cosmos-button--kind-primary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-primary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, #C3093B)}.cosmos-button--kind-secondary.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.1))}.cosmos-button--kind-secondary.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-secondary.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.2))}.cosmos-button--kind-secondary.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(255, 255, 255, 0.1))}.cosmos-button--kind-secondary.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-secondary.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.2))}.cosmos-button--kind-tertiary.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-tertiary.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.1));border-color:var(--cosmos-button-border-color-hover, rgba(0, 15, 30, 0.2))}.cosmos-button--kind-tertiary.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-tertiary.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.1));border-color:var(--cosmos-button-border-color-hover, rgba(255, 255, 255, 0.2))}.cosmos-button--kind-bare.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-bare.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.1))}.cosmos-button--kind-bare.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-bare.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.1))}.cosmos-button--kind-link{border-radius:var(--cosmos-button-border-radius, 0);border-width:0}.cosmos-button--kind-link:not(.cosmos-button--shape-circle,.cosmos-button--shape-square){height:auto;padding:0}.cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-width:0 0 var(--cosmos-button-border-width, 2px) 0;margin-bottom:calc(var(--cosmos-button-border-width, 2px) * -1)}.cosmos-button--kind-link.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-color:var(--cosmos-button-border-color-hover, var(--cosmos-button-border-color, rgba(0, 15, 30, 0.2)))}.cosmos-button--kind-link.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-color:var(--cosmos-button-border-color-hover, var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2)))}.cosmos-button--kind-secondary,.cosmos-button--kind-cover-up{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button--kind-tertiary,.cosmos-button--kind-bare,.cosmos-button--kind-link{background:var(--cosmos-button-background, transparent)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up{color:var(--cosmos-button-color, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){color:var(--cosmos-button-color-hover, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--appearance-dark{color:var(--cosmos-button-color, #000F1E)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--appearance-light{color:var(--cosmos-button-color, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark{color:var(--cosmos-button-color-hover, #000F1E)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light{color:var(--cosmos-button-color-hover, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary{background:var(--cosmos-button-background, #DB0A40)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:focus.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.1))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:focus.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.1))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.6));border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.8));border-color:var(--cosmos-button-border-color-hover, rgba(255, 255, 255, 0.45))}.cosmos-button--disabled{cursor:not-allowed}.cosmos-button--disabled.cosmos-button--kind-primary{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button--disabled.cosmos-button--kind-primary.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.1))}.cosmos-button--disabled.cosmos-button--kind-primary.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(255, 255, 255, 0.1))}.cosmos-button--disabled.cosmos-button--kind-tertiary.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.1))}.cosmos-button--disabled.cosmos-button--kind-tertiary.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.1))}.cosmos-button--disabled.cosmos-button--kind-cover-up{color:var(--cosmos-button-color, rgba(255, 255, 255, 0.45))}.cosmos-button--disabled.cosmos-button--kind-cover-up.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.45));border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button--disabled.cosmos-button--kind-cover-up.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.45))}.cosmos-button--disabled.cosmos-button--appearance-dark:not(.cosmos-button--kind-cover-up){color:var(--cosmos-button-color, rgba(0, 15, 30, 0.45))}.cosmos-button--disabled.cosmos-button--appearance-light:not(.cosmos-button--kind-cover-up){color:var(--cosmos-button-color, rgba(255, 255, 255, 0.45))}', CosmosButton9111Style0 = cosmosButtonCss, CosmosButton$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.handleIconSlotChange = () => {
      this.hasIconSlot = hasNamedSlot(this.element, "icon");
    }, this.appearance = void 0, this.ariaExpanded = void 0, this.ariaHaspopup = void 0, this.ariaLabel = void 0, this.busy = !1, this.buttonTitle = void 0, this.decorative = !1, this.disabled = !1, this.hovered = !1, this.href = void 0, this.iconPlacement = "before", this.kind = "primary", this.rel = void 0, this.shape = void 0, this.size = "medium", this.target = void 0, this.type = "button", this.width = "content", this.computedAppearance = "dark", this.hasIconSlot = !1;
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  /**
   * Removes focus from the Button.
   */
  async buttonBlur() {
    this.buttonElement && this.buttonElement.blur();
  }
  /**
   * Sets focus on the Button.
   */
  async buttonFocus() {
    this.buttonElement && this.buttonElement.focus();
  }
  handleClick(te) {
    const ee = this.element.closest("form");
    if (this.disabled || this.busy) {
      te.stopImmediatePropagation(), te.preventDefault(), te.stopPropagation();
      return;
    }
    if (!(!this.isButton() || this.type === "button" || !ee)) {
      if (this.type === "reset")
        return ee.reset();
      if (this.type === "submit")
        return requestFormSubmit(ee);
    }
  }
  getTextWeight() {
    return "medium";
  }
  getTextSize() {
    return this.size === "small" ? "x-small" : "small";
  }
  getType() {
    return this.isButton() ? this.type : void 0;
  }
  getWidth() {
    return this.width && isResponsiveProperty(this.width) ? parseResponsiveProperty(this.width) : this.width;
  }
  getHostRole() {
    return this.ariaExpanded || this.ariaHaspopup || this.ariaLabel ? "presentation" : null;
  }
  isButton() {
    return !this.href && !this.decorative;
  }
  isLink() {
    return !!this.href && !this.decorative;
  }
  determineTag() {
    return this.isButton() ? "button" : this.isLink() ? "a" : "div";
  }
  getAriaLabel() {
    var te;
    return this.ariaLabel !== void 0 ? this.ariaLabel : this.buttonTitle ? this.buttonTitle : ((te = this.element.textContent) === null || te === void 0 ? void 0 : te.trim()) || "";
  }
  componentWillLoad() {
    this.hasIconSlot = hasNamedSlot(this.element, "icon"), resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  render() {
    const te = this.determineTag(), ee = bem("cosmos-button");
    return h$1(Host, { key: "a4449d3dae83f1df3ea169faa581abd13a32fac4", role: this.getHostRole() }, h$1(te, { key: "a73cb0239daec17511c8efa43dd7516d0b16f033", class: ee({
      kind: this.kind,
      busy: this.busy,
      disabled: this.disabled || this.busy,
      appearance: this.computedAppearance,
      shape: this.shape || "pill",
      size: this.size,
      icon: this.iconPlacement,
      hovered: this.hovered,
      width: this.getWidth(),
      "has-icon": this.hasIconSlot
    }), disabled: this.disabled || this.busy, href: this.href, target: this.target, rel: this.rel, ref: (ne) => this.buttonElement = ne, type: this.getType(), part: "base", "aria-expanded": this.ariaExpanded, "aria-haspopup": this.ariaHaspopup, "aria-label": this.getAriaLabel(), title: this.buttonTitle }, this.busy && h$1("cosmos-spinner-9-11-1", { key: "a5ed2db9e5180a0d6cf1d1ab8268312df805ac47", class: ee("spinner") }), h$1("slot", { key: "1c21eb6023d04f313bd0042055b1e3bacc3e341b", name: "icon", onSlotchange: this.handleIconSlotChange }), h$1("cosmos-text-9-11-1", { key: "28a1642df174ec8ea11a90b422ea24f3bdfc95dc", class: ee("label"), size: this.getTextSize(), tag: "span", weight: this.getTextWeight(), exportparts: "base: label" }, h$1("span", { key: "2bc250e9229087276e32c86b3aff2fb2172d2059" }, h$1("slot", { key: "e50b2c1d48efc4dbef56a062a57a8dc25198baa7" })))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"]
    };
  }
  static get style() {
    return CosmosButton9111Style0;
  }
}, [1, "cosmos-button-9-11-1", {
  appearance: [513],
  ariaExpanded: [513, "aria-expanded"],
  ariaHaspopup: [513, "aria-haspopup"],
  ariaLabel: [513, "aria-label"],
  busy: [516],
  buttonTitle: [513, "button-title"],
  decorative: [516],
  disabled: [516],
  hovered: [516],
  href: [513],
  iconPlacement: [513, "icon-placement"],
  kind: [513],
  rel: [513],
  shape: [513],
  size: [513],
  target: [513],
  type: [513],
  width: [513],
  computedAppearance: [32],
  hasIconSlot: [32],
  buttonBlur: [64],
  buttonFocus: [64]
}, [[2, "click", "handleClick"]], {
  appearance: ["handleAppearanceChange"]
}]);
function defineCustomElement$V() {
  if (typeof customElements > "u")
    return;
  ["cosmos-button-9-11-1", "cosmos-spinner-9-11-1", "cosmos-text-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-button-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosButton$1);
        break;
      case "cosmos-spinner-9-11-1":
        customElements.get(te) || defineCustomElement$W();
        break;
      case "cosmos-text-9-11-1":
        customElements.get(te) || defineCustomElement$Y();
        break;
    }
  });
}
const defineCustomElement$U = defineCustomElement$V, getAriaDescribedBy = (re) => ["help-text", re && "validation-message"].filter(Boolean).join(" "), getAriaInvalid = (re) => re ? "true" : "false", getAriaDisabled = (re) => re ? "true" : void 0, getAriaRequired = (re) => re ? "true" : void 0, cosmosIconCss$C = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconWarning9111Style0 = cosmosIconCss$C, CosmosIconWarning = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "23c3e17383e1ed9df9ce3ae7a0be3b5ace181828", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "244290ab82cecc40267118dd3047f95bd427b6aa", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "b11e6a28ae727362dc8448ac61df90641060a82a", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.57 17.25 11.43 3.11a.49.49 0 0 0-.86 0L2.44 17.25a.5.5 0 0 0 .43.75h16.27a.5.5 0 0 0 .43-.75ZM10.25 9.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-3ZM11 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconWarning9111Style0;
  }
}, [1, "cosmos-icon-warning-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$T() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-warning-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-warning-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconWarning);
        break;
    }
  });
}
const cosmosCheckboxCss = '@charset "UTF-8";:host{display:block;min-width:0;width:100%}.cosmos-checkbox{-ms-flex-align:baseline;align-items:baseline;display:-ms-flexbox;display:flex}.cosmos-checkbox__input-and-prefix{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0}.cosmos-checkbox__aligner{--cosmos-text-font-family:var(--cosmos-checkbox-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-text-transform);width:0}.cosmos-checkbox__aligner::before{content:" "}.cosmos-checkbox__input-container{-ms-flex-negative:0;flex-shrink:0;height:var(--cosmos-checkbox-size, 16px);-webkit-margin-end:var(--cosmos-checkbox-gap, calc(0.5 * var(--cosmos-checkbox-size, 16px)));margin-inline-end:var(--cosmos-checkbox-gap, calc(0.5 * var(--cosmos-checkbox-size, 16px)));position:relative;width:var(--cosmos-checkbox-size, 16px)}.cosmos-checkbox__prefix{display:grid}.cosmos-checkbox__prefix>[slot=prefix]{-webkit-margin-end:var(--cosmos-checkbox-gap, calc(0.375 * var(--cosmos-checkbox-size, 16px)));margin-inline-end:var(--cosmos-checkbox-gap, calc(0.375 * var(--cosmos-checkbox-size, 16px)))}.cosmos-checkbox__prefix ::slotted([slot=prefix]){--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px;-webkit-margin-end:var(--cosmos-checkbox-gap, calc(0.375 * var(--cosmos-checkbox-size, 16px)));margin-inline-end:var(--cosmos-checkbox-gap, calc(0.375 * var(--cosmos-checkbox-size, 16px)));position:relative}.cosmos-checkbox__prefix ::slotted([slot=prefix])::before{content:"";display:block;height:100%;left:0;min-height:calc(var(--cosmos-checkbox-size, 16px) + calc(0.25 * var(--cosmos-checkbox-size, 16px)) * 2);position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.cosmos-checkbox__input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;-webkit-box-shadow:none;box-shadow:none;display:block;height:var(--cosmos-checkbox-size, 16px);margin:0;outline:none;width:var(--cosmos-checkbox-size, 16px)}.cosmos-checkbox__input:focus,.cosmos-checkbox__input:focus:not(:focus-visible){outline:none}.cosmos-checkbox__input:focus:not(:focus-visible)::before{content:none}.cosmos-checkbox__input:focus::before{border-radius:calc(var(--cosmos-checkbox-border-radius, 4px) * 1.5);bottom:calc((4px + 0px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 0px) * -1);position:absolute;right:calc((4px + 0px) * -1);top:calc((4px + 0px) * -1);content:""}.cosmos-checkbox__input::after{-webkit-box-sizing:content-box;box-sizing:content-box;content:"";display:block;height:calc(var(--cosmos-checkbox-size, 16px) + calc(0.25 * var(--cosmos-checkbox-size, 16px)) * 2);-webkit-margin-start:calc(calc(0.25 * var(--cosmos-checkbox-size, 16px)) * -1);margin-inline-start:calc(calc(0.25 * var(--cosmos-checkbox-size, 16px)) * -1);position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:calc(var(--cosmos-checkbox-size, 16px) + calc(0.25 * var(--cosmos-checkbox-size, 16px)) * 2);z-index:1}.cosmos-checkbox__input:checked~.cosmos-checkbox__tick{opacity:1}.cosmos-checkbox__input:not(:indeterminate)~.cosmos-checkbox__hyphen{display:none}.cosmos-checkbox__control{border-radius:var(--cosmos-checkbox-border-radius, 4px);border-style:solid;border-width:var(--cosmos-checkbox-border-width, 1px);-webkit-box-sizing:border-box;box-sizing:border-box;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.cosmos-checkbox__tick{fill:currentColor;height:calc(var(--cosmos-checkbox-size, 16px) / 2);left:50%;opacity:0;pointer-events:none;position:absolute;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.cosmos-checkbox__hyphen{border-radius:0.5px;display:block;height:calc(var(--cosmos-checkbox-size, 16px) / 10);left:50%;pointer-events:none;position:absolute;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);width:calc(var(--cosmos-checkbox-size, 16px) / 2)}.cosmos-checkbox__content{position:relative}.cosmos-checkbox__content--row{width:100%}.cosmos-checkbox__content--row label{display:inline-block;width:100%}.cosmos-checkbox__label{position:relative}.cosmos-checkbox__label::before{bottom:calc(calc(0.25 * var(--cosmos-checkbox-size, 16px)) * -1);content:"";left:0;position:absolute;right:0;top:calc(calc(0.25 * var(--cosmos-checkbox-size, 16px)) * -1)}.cosmos-checkbox__label-text{--cosmos-text-color:var(--cosmos-checkbox-color);--cosmos-text-font-family:var(--cosmos-checkbox-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-text-transform);display:inline;position:relative}.cosmos-checkbox--hovered .cosmos-checkbox__label-text{--cosmos-text-color:var(--cosmos-checkbox-color-hover)}.cosmos-checkbox__required-optional-label{--cosmos-text-color:var(--cosmos-checkbox-required-optional-label-color);--cosmos-text-font-family:var(--cosmos-checkbox-required-optional-label-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-required-optional-label-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-required-optional-label-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-required-optional-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-required-optional-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-required-optional-label-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-required-optional-label-text-transform);display:inline;-webkit-margin-start:4px;margin-inline-start:4px;white-space:nowrap}.cosmos-checkbox__help-text{--cosmos-text-color:var(--cosmos-checkbox-help-text-color);--cosmos-text-font-family:var(--cosmos-checkbox-help-text-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-help-text-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-help-text-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-help-text-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-help-text-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-help-text-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-help-text-text-transform);display:block;padding-top:4px}.cosmos-checkbox:not(.cosmos-checkbox--has-help-text) .cosmos-checkbox__help-text{display:none}.cosmos-checkbox--appearance-dark{color:var(--cosmos-checkbox-color, #000F1E)}.cosmos-checkbox--appearance-dark .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, #000F1E)}.cosmos-checkbox--appearance-dark .cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, transparent);border-color:var(--cosmos-checkbox-border-color, rgba(0, 15, 30, 0.6))}.cosmos-checkbox--appearance-dark .cosmos-checkbox__tick{color:var(--cosmos-checkbox-icon-color, #FFFFFF)}.cosmos-checkbox--appearance-dark .cosmos-checkbox__hyphen{background-color:var(--cosmos-checkbox-icon-color, #FFFFFF)}.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered{color:var(--cosmos-checkbox-color-hover, #000F1E)}.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input~.cosmos-checkbox__control{background:var(--cosmos-checkbox-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color-hover, rgba(0, 15, 30, 0.8));border-color:var(--cosmos-checkbox-border-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-checkbox--appearance-light{color:var(--cosmos-checkbox-color, #FFFFFF)}.cosmos-checkbox--appearance-light .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, #FFFFFF)}.cosmos-checkbox--appearance-light .cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, transparent);border-color:var(--cosmos-checkbox-border-color, rgba(255, 255, 255, 0.6))}.cosmos-checkbox--appearance-light .cosmos-checkbox__tick{color:var(--cosmos-checkbox-icon-color, #000F1E)}.cosmos-checkbox--appearance-light .cosmos-checkbox__hyphen{background-color:var(--cosmos-checkbox-icon-color, #000F1E)}.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered{color:var(--cosmos-checkbox-color-hover, #FFFFFF)}.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input~.cosmos-checkbox__control{background:var(--cosmos-checkbox-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color-hover, rgba(255, 255, 255, 0.8));border-color:var(--cosmos-checkbox-border-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-checkbox--disabled{pointer-events:none}.cosmos-checkbox--disabled .cosmos-checkbox__prefix{opacity:0.4}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-dark .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--disabled.cosmos-checkbox--appearance-dark .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, rgba(0, 15, 30, 0.45));border-color:var(--cosmos-checkbox-border-color, transparent)}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-dark .cosmos-checkbox__control{border-color:var(--cosmos-checkbox-border-color, rgba(0, 15, 30, 0.45))}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-dark .cosmos-checkbox__label-text{--cosmos-text-color:var(--cosmos-checkbox-color, rgba(0, 15, 30, 0.45))}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-light .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--disabled.cosmos-checkbox--appearance-light .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, rgba(255, 255, 255, 0.45));border-color:var(--cosmos-checkbox-border-color, transparent)}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-light .cosmos-checkbox__control{border-color:var(--cosmos-checkbox-border-color, rgba(255, 255, 255, 0.45))}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-light .cosmos-checkbox__label-text{--cosmos-text-color:var(--cosmos-checkbox-color, rgba(255, 255, 255, 0.45))}.cosmos-checkbox--invalid .cosmos-checkbox__control{border-color:var(--cosmos-checkbox-invalid-color, #E06600);border-width:var(--cosmos-checkbox-border-width, 2px)}.cosmos-checkbox--invalid .cosmos-checkbox__required-label{--cosmos-text-color:var(--cosmos-checkbox-invalid-color, #E06600)}.cosmos-checkbox__validation-message{display:-ms-flexbox;display:flex;gap:4px;margin-top:4px}.cosmos-checkbox__validation-message-text{--cosmos-text-color:var(--cosmos-checkbox-color);--cosmos-text-font-family:var(--cosmos-checkbox-validation-message-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-validation-message-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-validation-message-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-validation-message-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-validation-message-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-validation-message-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-validation-message-text-transform)}.cosmos-checkbox__validation-message-icon{--cosmos-icon-color:var(--cosmos-checkbox-invalid-color, #E06600);--cosmos-icon-size:calc(16rem / var(--cosmos-base-font-size, 16));-ms-flex-negative:0;flex-shrink:0;padding:1.5px 0}.cosmos-checkbox--clamp .cosmos-checkbox__content{min-width:0}.cosmos-checkbox--clamp .cosmos-checkbox__label{-ms-flex-align:baseline;align-items:baseline;display:-ms-flexbox;display:flex;min-width:0}.cosmos-checkbox--clamp .cosmos-checkbox__label-text{display:-ms-flexbox;display:flex;min-width:0}', CosmosCheckbox9111Style0 = cosmosCheckboxCss, generateClassNames$6 = bem("cosmos-checkbox"), CosmosCheckbox$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.inputchangeEvent = createEvent(this, "inputchange", 6), this.inputinvalidEvent = createEvent(this, "inputinvalid", 7), this.wasSubmitted = !1, this.toggleCheckbox = () => {
      this.input.click();
    }, this.getValidationMessage = () => {
      if (this.validationMessage)
        return this.validationMessage;
      if (this.inputInvalid && !this.group && this.input)
        return this.input.validationMessage;
    }, this.reannounceValidationMessage = async () => {
      this.validationMessageRef && (this.validationMessageRef.ariaLabel = "", await nextTick(), this.validationMessageRef.ariaLabel = this.getValidationMessage());
    }, this.handleInputChange = (te) => {
      const ee = te.target;
      this.inputchangeEvent.emit({ checked: ee.checked }), !this.isValidityControlled() && this.wasSubmitted && (this.inputInvalid = !this.reportValidity());
    }, this.isValidityControlled = () => this.group ? this.group.invalid || !1 : this.invalid || !1, this.handleInvalid = (te) => {
      te.preventDefault(), this.inputInvalid = !0, this.inputinvalidEvent.emit();
    }, this.handleFormData = (te) => {
      if (this.input && this.name && this.isInputChecked() && !this.disabled)
        return te.formData.append(this.input.name, this.input.value);
    }, this.handleFormSubmit = (te) => {
      this.wasSubmitted = !0, this.input && !this.reportValidity() && (te.preventDefault(), this.reannounceValidationMessage());
    }, this.hoveredOn = () => {
      this.isHovered = !0;
    }, this.hoveredOff = () => {
      this.isHovered = !1;
    }, this.handleSlotChange = () => {
      this.labelText = getDefaultSlotTextContent(this.defaultSlotRef);
    }, this.appearance = void 0, this.autofocus = void 0, this.checked = !1, this.clamp = void 0, this.disabled = void 0, this.helpText = void 0, this.hitArea = "content", this.invalid = !1, this.name = void 0, this.optionalLabel = void 0, this.required = !1, this.requiredLabel = void 0, this.validationMessage = void 0, this.value = void 0, this.computedAppearance = "dark", this.inputInvalid = !1, this.isHovered = !1, this.labelText = "";
  }
  handleChecked() {
    this.setInputIndeterminateAttribute();
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  handleInvalidChange(te) {
    this.inputInvalid = te;
  }
  /**
   * Removes focus from the Checkbox.
   */
  async inputBlur() {
    this.input.blur();
  }
  /**
   * Sets focus on the Checkbox. This will scroll the element into the view and focus it.
   */
  async inputFocus() {
    this.input.focus();
  }
  /**
   * Returns the validity status of the Checkbox' value.
   * Fires an `inputinvalid`  event in the case of invalidity.
   */
  async inputCheckValidity() {
    return this.checkValidity();
  }
  /**
   * Performs the same validity checking steps as the `inputCheckValidity` methods.
   * Fires an `inputinvalid` event and reports the problem to the user in case of invalidity.
   */
  async inputReportValidity() {
    const te = this.reportValidity();
    return this.inputInvalid = !te, te;
  }
  /**
   * Sets a custom error message for the native validation issue report.
   */
  async inputSetCustomValidity(te) {
    this.input.setCustomValidity(te);
  }
  isChecked() {
    return stringBooleanToBoolean(this.checked);
  }
  isInputChecked() {
    return this.input && this.input.checked !== !1 && !this.isInputIndeterminate();
  }
  isIndeterminate() {
    return this.checked === "indeterminate";
  }
  isInputIndeterminate() {
    return this.input && this.input.indeterminate;
  }
  setInputIndeterminateAttribute() {
    this.input && (this.input.indeterminate = this.isIndeterminate());
  }
  hasRequiredLabel() {
    return !!this.required && !!this.requiredLabel;
  }
  hasRequiredOrOptionalLabel() {
    return this.hasRequiredLabel() || !!this.optionalLabel;
  }
  hasHelpText() {
    return !!this.helpText || hasNamedSlot(this.element, "help-text");
  }
  getTitle() {
    return this.clamp ? this.labelText : void 0;
  }
  getAriaDescribedby() {
    const te = [];
    return this.inputInvalid && this.getValidationMessage() && te.push("validation-message"), this.hasHelpText() && te.push("help-text"), te.length ? te.join(" ") : void 0;
  }
  getAriaChecked() {
    return this.isIndeterminate() ? "mixed" : !1;
  }
  getHelpText() {
    if (this.helpText)
      return this.helpText;
    if (hasNamedSlot(this.element, "help-text"))
      return getNamedSlotTextContent(this.element, "help-text");
  }
  getAllCheckboxes() {
    return this.group ? [
      ...this.group.querySelectorAll(`${transformTagName("cosmos-checkbox")}[name="${this.name}"]`)
    ].filter((ee) => !ee.disabled) : [this.element];
  }
  checkValidity() {
    const te = this.getAllCheckboxes(), ee = te == null ? void 0 : te.some((ie) => ie.shadowRoot.querySelector('input[type="checkbox"]').checked);
    return !(te == null ? void 0 : te.some((ie) => ie.required)) || ee;
  }
  reportValidity() {
    const te = this.checkValidity();
    return te || (this.input.required = !0, this.input.reportValidity()), te;
  }
  connectedCallback() {
    this.form = this.element.closest("form"), this.group = this.element.closest(transformTagName("cosmos-checkbox-group")), this.form && (this.form.addEventListener("formdata", this.handleFormData, !0), this.form.addEventListener("submit", this.handleFormSubmit, !0));
  }
  componentWillLoad() {
    this.inputInvalid = this.invalid, resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  componentDidLoad() {
    this.setInputIndeterminateAttribute(), slotMutationService.observe(this.element, this.handleSlotChange);
  }
  disconnectedCallback() {
    this.form && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit)), slotMutationService.unobserve(this.element);
  }
  render() {
    const te = this.getValidationMessage(), ee = this.getHelpText(), ne = !!this.labelText;
    return h$1("div", { key: "d97cfa5c75715d25fc95f80867e252de5932ff8b", class: generateClassNames$6({
      appearance: this.computedAppearance,
      clamp: this.clamp,
      disabled: this.disabled,
      hovered: this.isHovered,
      indeterminate: this.isIndeterminate(),
      invalid: this.inputInvalid,
      "has-help-text": this.hasHelpText()
    }), part: "base" }, h$1("div", { key: "f736691422c59288dedf00cdbe33660d2a6ef5b2", class: generateClassNames$6("input-and-prefix") }, h$1("cosmos-text-9-11-1", { key: "899eb3f55aebafbd088b19e1d25946d9f8a58693", "aria-hidden": "true", class: generateClassNames$6("aligner"), size: "small", tag: "span" }), h$1("div", { key: "2036432b69ff518001d494e5979fc9874e2a6e7b", class: generateClassNames$6("input-container") }, h$1("input", { key: "23d5d58fdc72ae889735d0dff32fcee8ec445253", "aria-checked": this.getAriaChecked(), "aria-describedby": getAriaDescribedBy(this.inputInvalid), "aria-invalid": getAriaInvalid(this.inputInvalid), "aria-label": this.labelText, "aria-required": getAriaRequired(this.required), autofocus: this.autofocus, checked: this.isChecked(), class: generateClassNames$6("input"), disabled: this.disabled, id: "checkbox", name: this.name, onChange: this.handleInputChange, onInvalid: this.handleInvalid, ref: (ie) => this.input = ie, required: this.required, type: "checkbox", value: this.value }), h$1("span", { key: "abc4c3895ad0e39f81caae34e1aac9af1065ca0c", class: generateClassNames$6("control"), part: "checkbox" }), h$1("svg", { key: "611d950028b7665b4153e76ff60ea9336a341a3f", "aria-hidden": "true", class: generateClassNames$6("tick", { selected: !0 }), viewBox: "0 0 14 10", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { key: "25ad87d00a0e9f7fbb66741a37679ea9ec1a0bc1", d: "M0.985237 6.1331C0.692033 5.85873 0.67668 5.39865 0.950941 5.10535L1.1595 4.8823C1.42921 4.59387 1.8798 4.57335 2.1746 4.83608L5.21473 7.54546L11.824 0.477201C12.1114 0.169801 12.599 0.169801 12.8864 0.4772L13.0808 0.685097C13.3422 0.964657 13.3422 1.39898 13.0808 1.67854L5.71164 9.55949C5.43724 9.85296 4.97686 9.86832 4.6835 9.5938L0.985237 6.1331Z" })), h$1("span", { key: "16ee665748a80a57bfd4022da283caacbf2453f4", class: generateClassNames$6("hyphen") })), h$1("div", { key: "0867d6a6612edcba51959e351692e96da5a51b22", id: "prefix", "aria-hidden": "true", class: generateClassNames$6("prefix", {
      "end-margin": ne
    }), part: "prefix", onClick: this.toggleCheckbox, onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff }, h$1("slot", { key: "e788e94c13df331bf4517f201231eb26e6d9d0df", name: "prefix" }))), h$1("div", { key: "10a7ee8557b19d6b7f2af089e723c36411f24416", class: generateClassNames$6("content", {
      row: this.hitArea === "row"
    }) }, h$1("label", { key: "5e6bd2f12d4017a7921c06e249be7e56ac8cc809", class: generateClassNames$6("label"), htmlFor: "checkbox", onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff }, h$1("cosmos-text-9-11-1", { key: "046443b5e9337b843dc212226d04a954e4d1e4b2", appearance: this.computedAppearance, clamp: this.clamp, class: generateClassNames$6("label-text"), exportparts: "base: label", tag: "span", title: this.getTitle(), size: "small" }, h$1("span", { key: "39d85c5d9364b66df7225a176983b5462ecb4101" }, h$1("slot", { key: "16309f210df4a8f0cc8f90040ef9b48f585d4d68", ref: (ie) => this.defaultSlotRef = ie }))), this.hasRequiredOrOptionalLabel() && h$1("cosmos-text-9-11-1", { key: "1ce990b21d62470e85bef97e8c4681eee0379e7c", appearance: this.computedAppearance, "aria-hidden": "true", class: generateClassNames$6("required-optional-label"), exportparts: "base: required-label", kind: "subtle", size: "xx-small", tag: "span" }, !this.hasRequiredLabel() && !this.required ? this.optionalLabel : this.requiredLabel)), h$1("cosmos-text-9-11-1", { key: "f55f023d6a32c2d15ff64b9c6c76ee7270323ad1", appearance: this.computedAppearance, clamp: this.clamp, class: generateClassNames$6("help-text"), exportparts: "base: help-text", kind: "subtle", size: "x-small" }, h$1("span", { key: "7cf3fa9d05b5dedfff45973a64d427aace1effbf", "aria-label": ee, id: "help-text" }, h$1("slot", { key: "d19834fe9c63de86a71d6e8ab5bb295a829bdf99", name: "help-text" }, this.helpText))), h$1("div", {
      key: "9139212d5a452aee7696ff779c0f57fb98683fa4",
      "aria-atomic": "false",
      "aria-live": "polite",
      class: generateClassNames$6("validation-message-container")
    }, this.inputInvalid && !!te && h$1("div", { key: "e87fc668383fd49d83af00dc5a58c8094e246a1e", class: generateClassNames$6("validation-message") }, h$1("cosmos-icon-warning-9-11-1", { key: "46c643a5cc9f5d44ff6ebedfaad3ce7efaf1429b", "aria-hidden": "true", class: generateClassNames$6("validation-message-icon") }), h$1("cosmos-text-9-11-1", { key: "67e516fbd7a6ba2fd1a22604133afeffae115851", appearance: this.computedAppearance, class: generateClassNames$6("validation-message-text"), exportparts: "base: validation-message", size: "x-small", tag: "span" }, h$1("span", { key: "0dea1ae73315ddc8e5e35d23f23802db20bd1d0d", "aria-label": te, id: "validation-message", ref: (ie) => this.validationMessageRef = ie }, te))))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      checked: ["handleChecked"],
      appearance: ["handleAppearanceChange"],
      invalid: ["handleInvalidChange"]
    };
  }
  static get style() {
    return CosmosCheckbox9111Style0;
  }
}, [1, "cosmos-checkbox-9-11-1", {
  appearance: [513],
  autofocus: [516],
  checked: [520],
  clamp: [516],
  disabled: [516],
  helpText: [513, "help-text"],
  hitArea: [513, "hit-area"],
  invalid: [516],
  name: [513],
  optionalLabel: [513, "optional-label"],
  required: [516],
  requiredLabel: [513, "required-label"],
  validationMessage: [513, "validation-message"],
  value: [513],
  computedAppearance: [32],
  inputInvalid: [32],
  isHovered: [32],
  labelText: [32],
  inputBlur: [64],
  inputFocus: [64],
  inputCheckValidity: [64],
  inputReportValidity: [64],
  inputSetCustomValidity: [64]
}, void 0, {
  checked: ["handleChecked"],
  appearance: ["handleAppearanceChange"],
  invalid: ["handleInvalidChange"]
}]);
function defineCustomElement$S() {
  if (typeof customElements > "u")
    return;
  ["cosmos-checkbox-9-11-1", "cosmos-icon-warning-9-11-1", "cosmos-text-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-checkbox-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosCheckbox$1);
        break;
      case "cosmos-icon-warning-9-11-1":
        customElements.get(te) || defineCustomElement$T();
        break;
      case "cosmos-text-9-11-1":
        customElements.get(te) || defineCustomElement$Y();
        break;
    }
  });
}
const defineCustomElement$R = defineCustomElement$S, FormField = ({ helpText: re, appearance: te = "dark", disabled: ee, label: ne, invalid: ie, labelForValue: ae, requiredLabel: ce, optionalLabel: he, validationMessage: _e, class: le, element: se, required: oe, validationMessageRef: ue }, be) => {
  const ve = bem("cosmos-form-field"), me = oe ? ce : he, pe = ge(), fe = () => {
    const ye = se.shadowRoot.querySelector(`#${ae}`);
    ye != null && ye.hasAttribute("role") && ye.focus();
  };
  function ge() {
    return re || (hasNamedSlot(se, "help-text") ? getNamedSlotTextContent(se, "help-text") : "");
  }
  return h(
    "div",
    { class: [
      le,
      ve({
        invalid: ie,
        disabled: ee,
        appearance: te
      })
    ].join(" "), part: "base" },
    h(
      "div",
      { class: ve("info-container", {
        "has-label": !!ne,
        "has-help-text": !!pe,
        "has-required-optional-label": !!me
      }) },
      h(
        "label",
        { htmlFor: ae ?? void 0, class: ve("label"), onClick: fe },
        h(
          "cosmos-text-9-11-1",
          { appearance: te, class: ve("label-text"), exportparts: "base: label", size: "x-small", tag: "span", weight: "medium" },
          h("span", { id: "label" }, ne)
        ),
        me && h("cosmos-text-9-11-1", { appearance: te, "aria-hidden": "true", class: ve("required-optional-label"), exportparts: "base: required-label", kind: "subtle", size: "xx-small", tag: "span" }, me)
      ),
      h(
        "cosmos-text-9-11-1",
        { appearance: te, class: ve("help-text"), kind: "subtle", size: "x-small", exportparts: "base: help-text" },
        h(
          "span",
          { "aria-label": pe, id: "help-text" },
          h("slot", { name: "help-text" }, re)
        )
      )
    ),
    h("div", null, be),
    h("div", {
      "aria-atomic": "false",
      "aria-live": "polite",
      class: ve("validation-message-container")
    }, ie && _e && h(
      "div",
      { class: ve("validation-message") },
      h("cosmos-icon-warning-9-11-1", { "aria-hidden": "true", class: ve("validation-message-icon") }),
      h(
        "cosmos-text-9-11-1",
        { appearance: te, class: ve("validation-message-text"), exportparts: "base: validation-message", size: "x-small", tag: "span" },
        h("span", { "aria-label": _e, id: "validation-message", ref: ue }, _e)
      )
    ))
  );
}, cosmosMediaPreviewCss = ":host{display:-ms-flexbox;display:flex;overflow:hidden}.cosmos-media-preview{-ms-flex-positive:1;flex-grow:1;overflow:hidden;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}.cosmos-media-preview--radius-none{border-radius:var(--cosmos-media-preview-border-radius, 0)}.cosmos-media-preview--radius-small{border-radius:var(--cosmos-media-preview-border-radius, 2px)}.cosmos-media-preview--radius-medium{border-radius:var(--cosmos-media-preview-border-radius, 6px)}.cosmos-media-preview--radius-large{border-radius:var(--cosmos-media-preview-border-radius, 8px)}.cosmos-media-preview--radius-full{border-radius:var(--cosmos-media-preview-border-radius, 9999px)}.cosmos-media-preview__container{-ms-flex-positive:1;flex-grow:1;height:100%;overflow:hidden;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);-webkit-transition:-webkit-transform 0.6s cubic-bezier(0.35, 0, 0, 1);transition:-webkit-transform 0.6s cubic-bezier(0.35, 0, 0, 1);transition:transform 0.6s cubic-bezier(0.35, 0, 0, 1);transition:transform 0.6s cubic-bezier(0.35, 0, 0, 1), -webkit-transform 0.6s cubic-bezier(0.35, 0, 0, 1);width:100%}.cosmos-media-preview--active .cosmos-media-preview__container{-webkit-transform:scale(1.04) translate3d(0, 0, 0);transform:scale(1.04) translate3d(0, 0, 0)}.cosmos-media-preview__image{height:100%}.cosmos-media-preview__video{display:block;height:100%;left:0;-o-object-fit:cover;object-fit:cover;opacity:0;position:absolute;top:0;width:100%;z-index:4}.cosmos-media-preview__video--visible{opacity:1}.cosmos-media-preview__video.enter{opacity:0;-webkit-transition:0.2s ease-in;transition:0.2s ease-in}.cosmos-media-preview__video.enter-active{opacity:1}.cosmos-media-preview__video.leave{opacity:1;-webkit-transition:0.2s ease-in;transition:0.2s ease-in}.cosmos-media-preview__video.leave-active{opacity:0}", CosmosMediaPreview9111Style0 = cosmosMediaPreviewCss, generateClassNames$5 = bem("cosmos-media-preview"), CosmosMediaPreview$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  handleVideoChange() {
    this.canPlayThroughVideo = !1;
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  handleActiveChange(te) {
    te ? this.startVideo() : this.stopVideo();
  }
  handlePlayVideoChange(te) {
    te ? this.startVideo() : this.stopVideo();
  }
  async startVideo() {
    this.canHandleVideo() && (this.isVideoPlaying = !0, await this.showVideo(), this.videoElement.play());
  }
  async stopVideo() {
    this.canHandleVideo() && (await this.hideVideo(), this.isVideoPlaying = !1, this.videoElement.pause(), this.videoElement.currentTime = 0);
  }
  async showVideo() {
    this.canPlayThroughVideo && (this.isVideoVisible = !0, await this.cssTransition.enter(this.videoElement, 200));
  }
  async hideVideo() {
    this.isVideoVisible = !1, await this.cssTransition.leave(this.videoElement, 200);
  }
  canHandleVideo() {
    return !!this.video && !hasReducedMotion();
  }
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.resizeEvent = createEvent(this, "resize", 5), this.handleImageResize = ({ detail: { height: te, width: ee } }) => {
      this.resizeEvent.emit({
        height: te,
        width: ee
      });
    }, this.handleCanPlayThrough = () => {
      this.canPlayThroughVideo || (this.canPlayThroughVideo = !0, this.isVideoPlaying && this.showVideo());
    }, this.handleVideoCompletion = async () => {
      await this.hideVideo();
    }, this.active = void 0, this.appearance = void 0, this.image = void 0, this.imageAlt = void 0, this.imagePreview = void 0, this.loading = void 0, this.observeResize = void 0, this.playVideo = void 0, this.radius = "none", this.sizes = void 0, this.srcset = void 0, this.video = void 0, this.canPlayThroughVideo = !1, this.computedAppearance = "light", this.isVideoPlaying = !1, this.isVideoVisible = !1, this.cssTransition = new CSSTransition();
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "dark", light: "light" },
      callback: this.handleAppearanceChange.bind(this)
    }), (this.playVideo || this.active) && this.startVideo();
  }
  render() {
    return h$1("div", { key: "703e8d6b6767db0221ca2bf6eb604cec4cb0c573", class: generateClassNames$5({
      active: this.active,
      appearance: this.computedAppearance,
      radius: this.radius
    }), part: "base" }, h$1("div", { key: "63e17d11fd462346244d2ccfa8edfe9b33274d08", class: generateClassNames$5("container") }, h$1("cosmos-image-9-11-1", { key: "e98a40f1d8bfecf1af09e434450608b82addb722", class: generateClassNames$5("image"), image: this.image, imagePreview: this.imagePreview, imageAlt: this.imageAlt, appearance: this.appearance, observeResize: this.observeResize, onResize: this.handleImageResize, loading: this.loading, sizes: this.sizes, srcset: this.srcset }), this.video && h$1("video", { key: "decc320803be620c96f625333c293636917d77a5", class: generateClassNames$5("video", { visible: this.isVideoVisible && this.isVideoPlaying }), ref: (te) => this.videoElement = te, src: this.video, muted: !0, preload: "none", playsInline: !0, onCanPlayThrough: this.handleCanPlayThrough, "aria-hidden": "true", onEnded: this.handleVideoCompletion })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      video: ["handleVideoChange"],
      appearance: ["handleAppearanceChange"],
      active: ["handleActiveChange"],
      playVideo: ["handlePlayVideoChange"]
    };
  }
  static get style() {
    return CosmosMediaPreview9111Style0;
  }
}, [1, "cosmos-media-preview-9-11-1", {
  active: [516],
  appearance: [513],
  image: [513],
  imageAlt: [513, "image-alt"],
  imagePreview: [513, "image-preview"],
  loading: [513],
  observeResize: [516, "observe-resize"],
  playVideo: [516, "play-video"],
  radius: [513],
  sizes: [513],
  srcset: [513],
  video: [513],
  canPlayThroughVideo: [32],
  computedAppearance: [32],
  isVideoPlaying: [32],
  isVideoVisible: [32]
}, void 0, {
  video: ["handleVideoChange"],
  appearance: ["handleAppearanceChange"],
  active: ["handleActiveChange"],
  playVideo: ["handlePlayVideoChange"]
}]);
function defineCustomElement$Q() {
  if (typeof customElements > "u")
    return;
  ["cosmos-media-preview-9-11-1", "cosmos-image-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-media-preview-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosMediaPreview$1);
        break;
      case "cosmos-image-9-11-1":
        customElements.get(te) || defineCustomElement$X();
        break;
    }
  });
}
const CosmosMode$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.mode = "light";
  }
  render() {
    return h$1("slot", { key: "96f6b86477f4533dc6cdaab7ffa9cff853c0c381" });
  }
  get element() {
    return this;
  }
}, [4, "cosmos-mode-9-11-1", {
  mode: [513]
}]);
function defineCustomElement$P() {
  if (typeof customElements > "u")
    return;
  ["cosmos-mode-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-mode-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosMode$1);
        break;
    }
  });
}
const cosmosTitleCss = '@charset "UTF-8";:host{display:block}:host([clamp]){min-width:0}:host{--cosmos-font-family-title:Bull, Helvetica, sans-serif}@supports (font-variation-settings: normal){:host{--cosmos-font-family-title:Bull VF, Helvetica, sans-serif}}:host(:lang(ja)){--cosmos-font-family-title:Noto Sans JP, Helvetica, sans-serif}:host(:lang(ar)){--cosmos-font-family-title:Noto Kufi Arabic, Helvetica, sans-serif}:host(:lang(ko)){--cosmos-font-family-title:Noto Sans KR, Helvetica, sans-serif}:host(:lang(he)){--cosmos-font-family-title:Noto Sans Hebrew, Helvetica, sans-serif}:host(:lang(ka)){--cosmos-font-family-title:Noto Sans Georgian, Helvetica, sans-serif}:host(:lang(hi)){--cosmos-font-family-title:Noto Sans, Helvetica, sans-serif}:host(:lang(th)){--cosmos-font-family-title:Noto Sans Thai, Helvetica, sans-serif}:host(:lang(zh)){--cosmos-font-family-title:Microsoft YaHei, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host(:lang(zh-Hant)){--cosmos-font-family-title:Microsoft JhengHei, Geneva CY, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}.cosmos-title{--cosmos-font-weight-default-title-variable-bold:"opsz" 86, "wght" 700;--cosmos-font-weight-default-title-variable-heavy:"opsz" 86, "wght" 800;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:var(--cosmos-title-color, #000F1E);font-family:var(--cosmos-title-font-family, var(--cosmos-font-family-title));font-style:var(--cosmos-title-font-style, inherit);font-variation-settings:var(--cosmos-title-font-variation-settings, var(--cosmos-font-weight-default-title-variable-bold));font-weight:var(--cosmos-title-font-weight, 700);letter-spacing:var(--cosmos-title-letter-spacing, inherit);line-height:var(--cosmos-title-line-height, inherit);margin:0;text-transform:var(--cosmos-title-text-transform, var(--cosmos-title-transform, inherit))}.cosmos-title--single-line-clamp{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cosmos-title--multi-line-clamp{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:var(--cosmos-title-clamp-length);overflow:hidden;}.cosmos-title--size-xx-small{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}@media (min-width: 380px){.cosmos-title--size-xx-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-title--size-xx-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-x-small{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}@media (min-width: 380px){.cosmos-title--size-x-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-title--size-x-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-small{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}@media (min-width: 380px){.cosmos-title--size-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-title--size-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-medium{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}@media (min-width: 380px){.cosmos-title--size-medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-title--size-medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}@media (min-width: 380px){.cosmos-title--size-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16) + 10 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-title--size-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-x-large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}@media (min-width: 380px){.cosmos-title--size-x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16) + 23 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-title--size-x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-xx-large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}@media (min-width: 380px){.cosmos-title--size-xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16) + 41 * (100vw - 380px) / 820)))}}@media (min-width: 1200px){.cosmos-title--size-xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-xx-small\\@small{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-xx-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-xx-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-x-small\\@small{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-x-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-x-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-small\\@small{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-medium\\@small{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-medium\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-medium\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-large\\@small{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16) + 10 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-x-large\\@small{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-x-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16) + 23 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-x-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-xx-large\\@small{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-xx-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16) + 41 * (100vw - 380px) / 820)))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-xx-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-xx-small\\@medium{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-xx-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-x-small\\@medium{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-x-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-x-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-small\\@medium{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-medium\\@medium{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-medium\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-medium\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-large\\@medium{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16) + 10 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-x-large\\@medium{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-x-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16) + 23 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-x-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-xx-large\\@medium{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-xx-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16) + 41 * (100vw - 380px) / 820)))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-xx-small\\@large{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-xx-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-x-small\\@large{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-x-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-x-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-small\\@large{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-medium\\@large{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-medium\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-medium\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-large\\@large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16) + 10 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-x-large\\@large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-x-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16) + 23 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-x-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-xx-large\\@large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-xx-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16) + 41 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-xx-small\\@x-large{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-xx-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-x-small\\@x-large{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-x-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-x-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-small\\@x-large{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-medium\\@x-large{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-medium\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-medium\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-large\\@x-large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16) + 10 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-x-large\\@x-large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-x-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16) + 23 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-x-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-xx-large\\@x-large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-xx-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16) + 41 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-xx-small\\@xx-large{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-xx-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16) + 0 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-x-small\\@xx-large{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-x-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-x-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-small\\@xx-large{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16) + 2 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-medium\\@xx-large{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-medium\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16) + 3 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-medium\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-large\\@xx-large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16) + 10 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-x-large\\@xx-large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-x-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16) + 23 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-x-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-xx-large\\@xx-large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-xx-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16) + 41 * (100vw - 380px) / 820)))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--spacing-none{margin-bottom:0;padding-top:0}.cosmos-title--spacing-long-form-bottom{padding-top:0}.cosmos-title--spacing-long-form-top{margin-bottom:0}.cosmos-title--appearance-light{color:var(--cosmos-title-color, #FFFFFF)}.cosmos-title--weight-heavy{font-variation-settings:var(--cosmos-title-font-variation-settings, var(--cosmos-font-weight-default-title-variable-heavy));font-weight:var(--cosmos-title-font-weight, 800)}.cosmos-title--kind-subtle{color:var(--cosmos-title-color, rgba(0, 15, 30, 0.6))}.cosmos-title--kind-subtle.cosmos-title--appearance-light{color:var(--cosmos-title-color, rgba(255, 255, 255, 0.6))}', CosmosTitle9111Style0 = cosmosTitleCss, generateClassNames$4 = bem("cosmos-title"), CosmosTitle$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.appearance = void 0, this.clamp = void 0, this.kind = "normal", this.size = "medium", this.spacing = "none", this.tag = "p", this.weight = "bold", this.computedAppearance = "dark";
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  setNumericClampValue() {
    this.numericClampValue = getNumericClampValue(this.clamp);
  }
  getSize() {
    return this.size && isResponsiveProperty(this.size) ? parseResponsiveProperty(this.size) : this.size;
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.setNumericClampValue();
  }
  render() {
    var te;
    const ee = (te = this.tag) !== null && te !== void 0 ? te : "p";
    return h$1(Host, { key: "066b998b9ea817be01aaceaab14c9a9ec2ebc982", style: isMultiLineClamp(this.numericClampValue) ? { "--cosmos-title-clamp-length": `${this.numericClampValue}` } : {} }, h$1(ee, { key: "7678d295f3c60c7bf9427af44b14a3f3b342ede3", class: generateClassNames$4({
      appearance: this.computedAppearance,
      size: this.getSize(),
      spacing: this.spacing,
      weight: this.weight,
      "single-line-clamp": isSingleLineClamp(this.numericClampValue),
      "multi-line-clamp": isMultiLineClamp(this.numericClampValue),
      kind: this.kind
    }), part: "base" }, h$1("slot", { key: "a8e287916e6c143e74e9f7881b1e67c7d8cfebd7" })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      clamp: ["setNumericClampValue"]
    };
  }
  static get style() {
    return CosmosTitle9111Style0;
  }
}, [1, "cosmos-title-9-11-1", {
  appearance: [513],
  clamp: [520],
  kind: [513],
  size: [513],
  spacing: [513],
  tag: [513],
  weight: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  clamp: ["setNumericClampValue"]
}]);
function defineCustomElement$O() {
  if (typeof customElements > "u")
    return;
  ["cosmos-title-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-title-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosTitle$1);
        break;
    }
  });
}
const cosmosIconCss$B = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconAirplay9111Style0 = cosmosIconCss$B, CosmosIconAirplay$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "8f6a7b5b5f201131ee14a7845bfac93e41d18643", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "5311b10c16bfa0114c62d72b429d49ed2f13ec22", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "137f07a9d76e447482f0610dc90ed71895b4164d", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4h17a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2.37a.48.48 0 0 1-.41-.22l-.35-.52a.48.48 0 0 1-.09-.26.5.5 0 0 1 .5-.5h1.72v-9h-15v9h1.64a.5.5 0 0 1 .5.5.51.51 0 0 1-.09.27l-.42.54a.51.51 0 0 1-.39.19H2.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5Zm13.488 14.733a.5.5 0 0 1-.438.267h-9.1a.5.5 0 0 1-.45-.78l4.59-6.62a.5.5 0 0 1 .82 0l4.55 6.62a.5.5 0 0 1 .028.513Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconAirplay9111Style0;
  }
}, [1, "cosmos-icon-airplay-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$D() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-airplay-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-airplay-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconAirplay$1);
        break;
    }
  });
}
const defineCustomElement$N = defineCustomElement$1$D, cosmosIconCss$A = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconAudioSettings9111Style0 = cosmosIconCss$A, CosmosIconAudioSettings$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "b5aa0283147c8a1930282e1a51eddf76ee75b21d", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "5927b705af5e335f574db75d325c8ea7f6d17f38", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "0bcead82fb9ab316f6cf29c2fd01b2622951b525", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 18.65a7.65 7.65 0 1 0 0-15.3 7.65 7.65 0 0 0 0 15.3ZM11 20a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", fill: "currentColor" }), h$1("path", { key: "a364a1261e40642552ad134fd3bc058f6fd8efef", d: "M5.5 9.5A.5.5 0 0 1 6 9h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-3Zm2.5-3a.5.5 0 0 1 .5-.5H9a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-9Zm2.5 2A.5.5 0 0 1 11 8h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H11a.5.5 0 0 1-.5-.5v-5Zm2.5-1a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-7Zm2.5 2A.5.5 0 0 1 16 9h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H16a.5.5 0 0 1-.5-.5v-3Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconAudioSettings9111Style0;
  }
}, [1, "cosmos-icon-audio-settings-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$C() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-audio-settings-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-audio-settings-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconAudioSettings$1);
        break;
    }
  });
}
const defineCustomElement$M = defineCustomElement$1$C, cosmosIconCss$z = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconBack109111Style0 = cosmosIconCss$z, CosmosIconBack10$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "154a354e91074bdf2ee5804066152e89c7b22b71", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "da1ea14fedd27890cf5d5fac1afebce48fa2cb71", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "893e952dd2a7fcbc22687be502350d20ecdbe9df", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 6.472h4.628a5.11 5.11 0 0 1 5.162 4.824 4.852 4.852 0 0 1-1.362 3.562 5 5 0 0 1-2.841 1.493.509.509 0 0 1-.587-.5v-.532a.51.51 0 0 1 .425-.493c.73-.137 1.4-.49 1.926-1.015a3.323 3.323 0 0 0 .939-2.473 3.6 3.6 0 0 0-3.662-3.362H9v2.3a.5.5 0 0 1-.854.352L5.114 7.576a.5.5 0 0 1 0-.706l3.033-3.024A.5.5 0 0 1 9 4.2v2.272Zm.19 6.846c.312-.3.738-.453 1.169-.418a1.5 1.5 0 0 1 1.62 1.567V15.7a1.5 1.5 0 0 1-1.62 1.571A1.507 1.507 0 0 1 8.732 15.7v-1.229c-.02-.432.147-.852.459-1.153Zm1.594 2.361c0 .349-.143.531-.425.531-.282 0-.431-.187-.431-.531v-1.187c0-.344.143-.532.431-.532.288 0 .425.182.425.532v1.187ZM8.309 16.95v-.621a.231.231 0 0 0-.24-.239h-.46v-2.87a.23.23 0 0 0-.24-.24h-.61a.85.85 0 0 0-.23.03l-1.05.33a.234.234 0 0 0-.16.29l.14.53a.235.235 0 0 0 .32.17l.64-.2v1.96h-.66a.23.23 0 0 0-.24.24v.62a.231.231 0 0 0 .24.24h2.31a.231.231 0 0 0 .24-.24Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconBack109111Style0;
  }
}, [1, "cosmos-icon-back-10-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$B() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-back-10-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-back-10-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconBack10$1);
        break;
    }
  });
}
const defineCustomElement$L = defineCustomElement$1$B, cosmosIconCss$y = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconBrowse9111Style0 = cosmosIconCss$y, CosmosIconBrowse$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "e2867d5d9dc259c865f605391ba9cca9b049898e", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "a2d46f1d8e06f9ca93951aea5c3428321ffa0aa6", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "b2bb185d5ec4b3a603d1979f6bc80534f8e229d9", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5h-14a.5.5 0 0 1-.5-.5v-14Zm1.5 13h12v-12h-12v12Zm15-12h1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-1v-12ZM8.412 14.405a.594.594 0 0 1-.912-.502V9.097c0-.469.516-.753.912-.502l3.796 2.403a.594.594 0 0 1 0 1.004l-3.796 2.403Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconBrowse9111Style0;
  }
}, [1, "cosmos-icon-browse-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$A() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-browse-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-browse-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconBrowse$1);
        break;
    }
  });
}
const defineCustomElement$K = defineCustomElement$1$A, cosmosIconCss$x = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconChevronLeft9111Style0 = cosmosIconCss$x, CosmosIconChevronLeft$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "ba186b7c4166666a3b2544422b96653c586edad9", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "14a740f6b509954693b8ebeb1db7bc411efde839", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "e01034083b59e5931ee2ecd4b742b6a615eea926", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m6.56 11.09 5.83 5.82a.5.5 0 0 0 .71 0l.35-.35a.51.51 0 0 0 0-.71l-5.12-5.12 5.12-5.11a.51.51 0 0 0 0-.71l-.35-.35a.5.5 0 0 0-.71 0l-5.83 5.82a.51.51 0 0 0 0 .71Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconChevronLeft9111Style0;
  }
}, [1, "cosmos-icon-chevron-left-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$z() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-chevron-left-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-chevron-left-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconChevronLeft$1);
        break;
    }
  });
}
const defineCustomElement$J = defineCustomElement$1$z, cosmosIconCss$w = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconChevronRight9111Style0 = cosmosIconCss$w, CosmosIconChevronRight$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "c0ba6990213263ab308b4e92ef22990819bc33e4", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "4d43d05a5a1161f17ca9f033bd920e8f5cedcbd4", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "00a872a84f8c75f4a899f4978b1bf3739e4f255d", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.45 10.38 9.62 4.56a.48.48 0 0 0-.7 0l-.36.35a.51.51 0 0 0 0 .71l5.12 5.12-5.12 5.11a.51.51 0 0 0 0 .71l.36.35a.48.48 0 0 0 .7 0l5.83-5.82a.51.51 0 0 0 0-.71Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconChevronRight9111Style0;
  }
}, [1, "cosmos-icon-chevron-right-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$y() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-chevron-right-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-chevron-right-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconChevronRight$1);
        break;
    }
  });
}
const defineCustomElement$I = defineCustomElement$1$y, cosmosIconCss$v = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconClock9111Style0 = cosmosIconCss$v, CosmosIconClock$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "2194561c842ae11493bdbe64084442b09fdd7861", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "30dfb70f715ec927ad662805f3e0d9f62ed66d58", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "f11f961430f86b0f07c73752824dbcc34f919053", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm-.63 7.93 3 3a.48.48 0 0 0 .67 0l.36-.35a.51.51 0 0 0 0-.71l-2.68-2.68V6.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v4.57a.49.49 0 0 0 .15.36Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconClock9111Style0;
  }
}, [1, "cosmos-icon-clock-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$x() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-clock-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-clock-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconClock$1);
        break;
    }
  });
}
const defineCustomElement$H = defineCustomElement$1$x, cosmosIconCss$u = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconClose9111Style0 = cosmosIconCss$u, CosmosIconClose$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "8bc59f13cc94c0e09fbfbe7305ee0466f2d886ff", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "83d3172026d21af92d7be8ec5652df5fec53ec96", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "6807cb29bcffe3cd77ab3e37f2ff2da513b4950d", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m18.18 4.18-.35-.36a.51.51 0 0 0-.71 0L11 9.94 4.89 3.82a.51.51 0 0 0-.71 0l-.35.36a.48.48 0 0 0 0 .7L10 11l-6.17 6.12a.48.48 0 0 0 0 .7l.35.36a.51.51 0 0 0 .71 0L11 12.06l6.11 6.12a.51.51 0 0 0 .71 0l.35-.36a.48.48 0 0 0 0-.7L12.07 11l6.11-6.12a.48.48 0 0 0 0-.7Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconClose9111Style0;
  }
}, [1, "cosmos-icon-close-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$G() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-close-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-close-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconClose$1);
        break;
    }
  });
}
const defineCustomElement$F = defineCustomElement$G, cosmosIconCss$t = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconCodeBlock9111Style0 = cosmosIconCss$t, CosmosIconCodeBlock$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "0ab9435875f59b9544df16f432dbb9a2ab42d580", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "1a879fe645b5361e3483df89429bd32769ec68b6", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "e725ffb040e647716af6266b265f23cc8e015729", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.32 5a.5.5 0 0 0-.48.36l-3.08 11a.5.5 0 0 0 .47.67h.46a.52.52 0 0 0 .49-.36l3.07-11a.5.5 0 0 0-.47-.67h-.46Zm6.41 5.65-3.39-3.39a.4.4 0 0 0-.28-.12.37.37 0 0 0-.27.11l-.44.44a.36.36 0 0 0-.11.26.44.44 0 0 0 .11.28L17.12 11l-2.77 2.77a.44.44 0 0 0-.11.28c0 .098.04.192.11.26l.44.44a.37.37 0 0 0 .27.11.4.4 0 0 0 .28-.12l3.39-3.39a.5.5 0 0 0 0-.7Zm-12.2 4.09-3.39-3.39a.48.48 0 0 1 0-.7l3.39-3.34a.4.4 0 0 1 .28-.12.37.37 0 0 1 .27.11l.44.44a.41.41 0 0 1 .11.26.4.4 0 0 1-.12.23L4.75 11l2.76 2.77a.4.4 0 0 1 .12.28.41.41 0 0 1-.11.26l-.44.44a.37.37 0 0 1-.27.11.4.4 0 0 1-.28-.12Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconCodeBlock9111Style0;
  }
}, [1, "cosmos-icon-code-block-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$w() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-code-block-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-code-block-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconCodeBlock$1);
        break;
    }
  });
}
const defineCustomElement$E = defineCustomElement$1$w, cosmosIconCss$s = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconErrorFilled9111Style0 = cosmosIconCss$s, CosmosIconErrorFilled$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "fad04aee5c6552675ab4adbfdd2e4ec0b6a75bb6", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "386096d26cfbb7284f84526291d74f640dac99e3", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "a175ef72df01e155f7ccfe65c9f43f88dcfe7a87", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.99 2a9 9 0 1 0 .02 18 9 9 0 0 0-.02-18Zm-.74 4.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-5ZM11 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconErrorFilled9111Style0;
  }
}, [1, "cosmos-icon-error-filled-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$v() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-error-filled-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-error-filled-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconErrorFilled$1);
        break;
    }
  });
}
const defineCustomElement$D = defineCustomElement$1$v, cosmosIconCss$r = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconEventDetails9111Style0 = cosmosIconCss$r, CosmosIconEventDetails$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "0f571cccfc4f2eb26e0a95f5379f44317765a264", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "c29a67f1da4db124e14c5818e020e0e5cf3427f7", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "07f686f2be6adb25068c0f9aaa7d35fec66b2276", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 3h-4V2a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v1H9V2a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v1h-4a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-2v-13h3v1A.5.5 0 0 0 8 6h.5a.5.5 0 0 0 .5-.5v-1h4v1a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-1h3v5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5Zm-9.435 8.044a6.99 6.99 0 0 1 2.5-1.603.5.5 0 0 0 .302-.665l-.667-1.56c-.148-.341-.377-.341-.511 0l-.834 2.238-2.42.218c-.376 0-.443.26-.147.491l1.102.922a.498.498 0 0 0 .675-.041ZM9 15.998a5 5 0 1 1 10 .004 5 5 0 0 1-10-.003Zm5.489 3.502A.51.51 0 0 0 15 19v-3a.5.5 0 0 0-.5-.5h-2a.51.51 0 0 0-.511.5v.5a.51.51 0 0 0 .511.5h.989v2a.5.5 0 0 0 .5.5h.5Zm-.25-5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconEventDetails9111Style0;
  }
}, [1, "cosmos-icon-event-details-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$u() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-event-details-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-event-details-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconEventDetails$1);
        break;
    }
  });
}
const defineCustomElement$C = defineCustomElement$1$u, cosmosIconCss$q = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconFacebook9111Style0 = cosmosIconCss$q, CosmosIconFacebook$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "18b0e637965e67a4738e04167d3f273f71918ac9", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "44b4b778cd91fb77256c08c4dbb5a365318ff6b5", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "18f34caad8235b2a6968f54b62672e87965d06cf", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 11a9 9 0 1 0-10.406 8.89v-6.288H7.309V11h2.285V9.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V11h2.496l-.399 2.602h-2.097v6.289A9.002 9.002 0 0 0 20 11Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconFacebook9111Style0;
  }
}, [1, "cosmos-icon-facebook-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$t() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-facebook-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-facebook-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconFacebook$1);
        break;
    }
  });
}
const defineCustomElement$B = defineCustomElement$1$t, cosmosIconCss$p = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconForward109111Style0 = cosmosIconCss$p, CosmosIconForward10$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "c99f90f07554b053cd44d56def292d6619fe9826", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "278267634c33ccd1cf8ab64d661889fc3af56cc2", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "0720801a3a4d5a0b14a270aa781600f96dcfbe2f", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14 6.472H9.372a5.11 5.11 0 0 0-5.162 4.817 4.852 4.852 0 0 0 1.362 3.565 5 5 0 0 0 2.841 1.493.51.51 0 0 0 .587-.5v-.532a.51.51 0 0 0-.425-.493c-.73-.137-1.4-.49-1.926-1.015a3.323 3.323 0 0 1-.939-2.473 3.6 3.6 0 0 1 3.662-3.358H14v2.3a.5.5 0 0 0 .854.352l3.032-3.052a.5.5 0 0 0 0-.706l-3.033-3.024A.5.5 0 0 0 14 4.2v2.272Zm.149 10.478v-.621a.23.23 0 0 0-.239-.239h-.46v-2.87a.23.23 0 0 0-.24-.24h-.61a.851.851 0 0 0-.23.03l-1.05.33a.234.234 0 0 0-.16.29l.14.53a.235.235 0 0 0 .32.17l.64-.2v1.96h-.66a.23.23 0 0 0-.24.24v.62a.231.231 0 0 0 .24.24h2.309a.231.231 0 0 0 .24-.24Zm.451-1.25v-1.233a1.506 1.506 0 0 1 1.63-1.567 1.505 1.505 0 0 1 1.621 1.571V15.7a1.5 1.5 0 0 1-1.621 1.57 1.506 1.506 0 0 1-1.63-1.57Zm2.051-1.208v1.184l.004-.001c0 .349-.141.531-.429.531-.288 0-.431-.187-.431-.531v-1.183c0-.344.149-.532.431-.532.282 0 .425.182.425.532Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconForward109111Style0;
  }
}, [1, "cosmos-icon-forward-10-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$s() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-forward-10-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-forward-10-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconForward10$1);
        break;
    }
  });
}
const defineCustomElement$A = defineCustomElement$1$s, cosmosIconCss$o = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconFullscreen9111Style0 = cosmosIconCss$o, CosmosIconFullscreen$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "2a4fa7d87e16565fb8e10daf5693a01500526741", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "71f797909d18d9eea3c17886bfd21810965cfa0d", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "370490ecd61bf4c4c22c6185ade5ede10acce766", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 5.5v3A.5.5 0 0 1 3 9h-.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-5Zm15 0h-5A.5.5 0 0 1 13 5v-.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H19a.5.5 0 0 1-.5-.5v-3Zm0 8v3h-5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H19a.5.5 0 0 0-.5.5Zm-15 3h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5H3a.5.5 0 0 1 .5.5v3Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconFullscreen9111Style0;
  }
}, [1, "cosmos-icon-fullscreen-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$r() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-fullscreen-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-fullscreen-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconFullscreen$1);
        break;
    }
  });
}
const defineCustomElement$z = defineCustomElement$1$r, cosmosIconCss$n = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconFullscreenExit9111Style0 = cosmosIconCss$n, CosmosIconFullscreenExit$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "3dccee0423e0fba9e3af526b421bafee3d0b7aaa", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "c245111663f93deb4d471b2099871570371cb7a4", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "15d32eeb9782dbd622aad267bf5e105b36967892", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.5 4.5v3h-5A.5.5 0 0 0 2 8v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5Zm0 10h-5A.5.5 0 0 1 2 14v-.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-3Zm7 0v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-5Zm0-7h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconFullscreenExit9111Style0;
  }
}, [1, "cosmos-icon-fullscreen-exit-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$q() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-fullscreen-exit-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-fullscreen-exit-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconFullscreenExit$1);
        break;
    }
  });
}
const defineCustomElement$y = defineCustomElement$1$q, cosmosIconCss$m = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconLink9111Style0 = cosmosIconCss$m, CosmosIconLink$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "9288087f387761718de546ee445ccf252a99ce72", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "9aedbcd6ca5427a7de8ea4bdc83d76009bbcffe3", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "6c795a0cc0b2b4a8bd6c40a39d6c4cbc9a23e0aa", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.496 3.434A4 4 0 0 1 17.29 4.78a4 4 0 0 1 .28 5.74l-2.62 2.63a3.43 3.43 0 0 1-2.44 1 4.42 4.42 0 0 1-2.77-1.06.5.5 0 0 1 0-.73l.37-.36a.48.48 0 0 1 .66 0 2.32 2.32 0 0 0 3.13.06l2.63-2.62a2.53 2.53 0 0 0-.3-3.59 2.53 2.53 0 0 0-3.59-.3l-.66.67a.52.52 0 0 1-.72 0l-.35-.36a.5.5 0 0 1 0-.71l.67-.66a4 4 0 0 1 2.916-1.056ZM7.72 17.11a2.13 2.13 0 0 0 1.65-.61l.65-.64a.49.49 0 0 1 .7 0l.36.35a.5.5 0 0 1 0 .71l-.64.64a3.68 3.68 0 0 1-2.62 1.05h-.16a4.45 4.45 0 0 1-2.94-1.34 4 4 0 0 1-.3-5.72l2.65-2.58a3.79 3.79 0 0 1 5.2.06.5.5 0 0 1 0 .73l-.36.36a.5.5 0 0 1-.67 0A2.34 2.34 0 0 0 8.11 10l-2.63 2.61a2.54 2.54 0 0 0 .3 3.6 3 3 0 0 0 1.94.9Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconLink9111Style0;
  }
}, [1, "cosmos-icon-link-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$p() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-link-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-link-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconLink$1);
        break;
    }
  });
}
const defineCustomElement$x = defineCustomElement$1$p, cosmosIconCss$l = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconLive9111Style0 = cosmosIconCss$l, CosmosIconLive$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "3ed301cac3882b3246de8895d8686c2c8ea5bf01", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "ca362d7e732a8f3635f45a43b6930431b2af7012", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "08547b0a11a7dc75b59d0851a0746aa0300642b0", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15ZM7.5 11a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconLive9111Style0;
  }
}, [1, "cosmos-icon-live-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$o() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-live-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-live-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconLive$1);
        break;
    }
  });
}
const defineCustomElement$w = defineCustomElement$1$o, cosmosIconCss$k = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconLiveBroadcast9111Style0 = cosmosIconCss$k, CosmosIconLiveBroadcast$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "ead817bd7938a1602355d0d02865e36a18562eeb", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "7d53db59d51d1ae35eb679ee9f468b6449bfc99c", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "d3d01a35bd0177bcf6ddb38373d7b47a7894a7fe", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.085 4.272a.5.5 0 0 0-.355.148l-.01-.04a9.14 9.14 0 0 0 .09 13.1.5.5 0 0 0 .71 0l.34-.35a.5.5 0 0 0 0-.71 7.66 7.66 0 0 1-.08-10.94.49.49 0 0 0 0-.7l-.34-.36a.5.5 0 0 0-.355-.148Zm11.84 0a.5.5 0 0 1 .355.148v-.04a9.14 9.14 0 0 1-.09 13.1.5.5 0 0 1-.71 0l-.34-.35a.5.5 0 0 1 0-.71 7.66 7.66 0 0 0 .08-10.94.49.49 0 0 1 0-.7l.35-.36a.5.5 0 0 1 .355-.148ZM14.42 7.69l-.34.37a.49.49 0 0 0 0 .67 3.14 3.14 0 0 1 .93 2.2 3.45 3.45 0 0 1-1 2.28.51.51 0 0 0 0 .68l.35.36a.5.5 0 0 0 .69 0 4.59 4.59 0 0 0 .09-6.61.5.5 0 0 0-.72.05ZM9.5 11a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.25 3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-.5ZM7.58 7.69l.35.37a.49.49 0 0 1 0 .67 3.17 3.17 0 0 0-.93 2.2 3.45 3.45 0 0 0 1 2.28.51.51 0 0 1 0 .68l-.35.36a.5.5 0 0 1-.69 0 4.6 4.6 0 0 1-.1-6.61.5.5 0 0 1 .72.05Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconLiveBroadcast9111Style0;
  }
}, [1, "cosmos-icon-live-broadcast-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$n() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-live-broadcast-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-live-broadcast-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconLiveBroadcast$1);
        break;
    }
  });
}
const defineCustomElement$v = defineCustomElement$1$n, cosmosIconCss$j = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconMute9111Style0 = cosmosIconCss$j, CosmosIconMute$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "9c1bf9323ff1e906877f23fc50f6612ee23c6576", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "a89785d0c2b032b05363e741eb88d8a31646d273", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "9e323cdc3548c41db405fec657a66a11460c58fd", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m13 9.94 6.65 6.65a.51.51 0 0 1 0 .71l-.35.35a.51.51 0 0 1-.71 0L4.32 3.38a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0l5 5 1.79-1.61a.5.5 0 0 1 .83.37v3.86ZM6.82 8.7l6 6a.46.46 0 0 1 .16.38v.78a.5.5 0 0 1-.83.37l-2.56-2.26H6.48a.5.5 0 0 1-.5-.5V9.05a.5.5 0 0 1 .5-.5.49.49 0 0 1 .34.15Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconMute9111Style0;
  }
}, [1, "cosmos-icon-mute-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$m() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-mute-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-mute-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconMute$1);
        break;
    }
  });
}
const defineCustomElement$u = defineCustomElement$1$m, cosmosIconCss$i = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconNoData9111Style0 = cosmosIconCss$i, CosmosIconNoData$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "a766cbfa303088f989ab9bfd120f3507097f3d75", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "7423a182e16d1272ff68a71350c788f326524438", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "934cb808052fee8312a87625d8bca77900f5729b", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.253 5.193A7.469 7.469 0 0 1 11 3.5a7.51 7.51 0 0 1 7.5 7.5 7.47 7.47 0 0 1-1.693 4.747L6.253 5.193Zm-1.06 1.06a7.5 7.5 0 0 0 10.554 10.554L5.192 6.253ZM2 11a9 9 0 0 1 9-9 9.01 9.01 0 0 1 9 9 9 9 0 1 1-18 0Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconNoData9111Style0;
  }
}, [1, "cosmos-icon-no-data-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$l() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-no-data-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-no-data-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconNoData$1);
        break;
    }
  });
}
const defineCustomElement$t = defineCustomElement$1$l, cosmosIconCss$h = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPause9111Style0 = cosmosIconCss$h, CosmosIconPause$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "6d946c5ee746907d6ddaa26395a48d944d4a3cbe", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "7994e0cb55342de18fb06741623d995e058dd4b3", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "7abbd2d0d7a421ffa3ca90e27d042be03a785df0", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm8 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPause9111Style0;
  }
}, [1, "cosmos-icon-pause-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$k() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-pause-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-pause-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconPause$1);
        break;
    }
  });
}
const defineCustomElement$s = defineCustomElement$1$k, cosmosIconCss$g = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPictureInPicture9111Style0 = cosmosIconCss$g, CosmosIconPictureInPicture$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "549b1721dc5909044cf352435e4d9a61b518bc03", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "8b5764e1df4dd3e98ee241708c3c1a7cf3162d86", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "3ba7138cd021b0a17eacb9b7aa37c10f7d93b2fa", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-13Zm1.5 1h15v11h-15v-11ZM17 11h-6v4h6v-4Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPictureInPicture9111Style0;
  }
}, [1, "cosmos-icon-picture-in-picture-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$j() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-picture-in-picture-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-picture-in-picture-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconPictureInPicture$1);
        break;
    }
  });
}
const defineCustomElement$r = defineCustomElement$1$j, cosmosIconCss$f = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPinterest9111Style0 = cosmosIconCss$f, CosmosIconPinterest$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "0eb015726f70b7f0adcf6fb1561cb959a9426865", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "88369ba87e79151b6107ec8f0dbe1da7cd079158", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "f9e2c26ee3d3a40ceaebc7b1ac452bb96eaa5c75", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.002 2A9 9 0 0 0 7.72 19.38a8.71 8.71 0 0 1 0-2.588c.168-.698 1.057-4.5 1.057-4.5A3.252 3.252 0 0 1 8.54 11c0-1.249.73-2.182 1.63-2.182a1.124 1.124 0 0 1 1.124 1.26 18.667 18.667 0 0 1-.742 3.003 1.305 1.305 0 0 0 1.327 1.62c1.597 0 2.834-1.688 2.834-4.117a3.544 3.544 0 0 0-3.71-3.667 3.89 3.89 0 0 0-4.071 3.903 3.47 3.47 0 0 0 .697 2.047c.06.072.082.169.056.259-.067.292-.214.9-.247 1.024-.034.123-.124.202-.293.123a4.05 4.05 0 0 1-1.833-3.487c-.056-2.846 2.002-5.41 5.892-5.41a5.273 5.273 0 0 1 5.544 5.196c0 3.094-1.957 5.625-4.666 5.625a2.42 2.42 0 0 1-2.07-1.035s-.45 1.72-.55 2.148a10.339 10.339 0 0 1-1.125 2.351 9.106 9.106 0 0 0 2.665.338c4.968 0 8.996-4.03 8.996-9S15.97 2 11.002 2Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPinterest9111Style0;
  }
}, [1, "cosmos-icon-pinterest-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$i() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-pinterest-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-pinterest-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconPinterest$1);
        break;
    }
  });
}
const defineCustomElement$q = defineCustomElement$1$i, cosmosIconCss$e = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPlay9111Style0 = cosmosIconCss$e, CosmosIconPlay$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "92aa142d207b356f9fc31103cd9240016f9d479e", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "8f92aa63296465128d5e7349133e6e15a3e5429f", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "c1a0856de3a860cbe5b9317746ea0bd8630972ef", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.22 17.44 10.38-5.905a.608.608 0 0 0 .283-.531.607.607 0 0 0-.282-.531L7.22 4.568a.426.426 0 0 0-.495.023.615.615 0 0 0-.225.52v11.81a.618.618 0 0 0 .239.492.434.434 0 0 0 .48.027Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPlay9111Style0;
  }
}, [1, "cosmos-icon-play-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$p() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-play-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-play-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconPlay$1);
        break;
    }
  });
}
const defineCustomElement$o = defineCustomElement$p, cosmosIconCss$d = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPreview9111Style0 = cosmosIconCss$d, CosmosIconPreview$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "3ea439277bebc7a0829c50b2445b73b51ee4148f", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "ff0de0a9382e4e1e29810211ca4a8d2c9f95d8ba", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "3d0f8d5d8658eb0b56631812b6e93b1c79d4d03a", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.991 5c3.554 0 6.471 1.846 8.806 5.285a1.36 1.36 0 0 1 0 1.43l-.013.02C17.54 15.133 14.564 17 10.991 17c-3.57 0-6.523-1.861-8.775-5.27a1.342 1.342 0 0 1 .007-1.471C4.53 6.845 7.438 5 10.991 5Zm0 1.565c-2.943 0-5.37 1.514-7.383 4.436 1.965 2.91 4.426 4.434 7.383 4.434 2.962 0 5.442-1.53 7.403-4.433-2.028-2.925-4.462-4.437-7.403-4.437Zm0 1.565A2.866 2.866 0 0 1 13.854 11a2.866 2.866 0 0 1-2.863 2.87A2.866 2.866 0 0 1 8.128 11a2.866 2.866 0 0 1 2.863-2.87Zm0 1.566c-.719 0-1.301.584-1.301 1.304a1.302 1.302 0 1 0 2.603 0c0-.72-.583-1.304-1.302-1.304Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPreview9111Style0;
  }
}, [1, "cosmos-icon-preview-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$h() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-preview-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-preview-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconPreview$1);
        break;
    }
  });
}
const defineCustomElement$n = defineCustomElement$1$h, cosmosIconCss$c = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconProductPlacement9111Style0 = cosmosIconCss$c, CosmosIconProductPlacement$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "683d0ec35a086e07ed72cf1a73579de391e16c7e", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "0c393aedfb6d5cbb1b781fc38ac5a21070cb2fe3", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "c4a10c7bdbfff5456268c7be16c38c330c22a671", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.54 2.002 19.36 2c.223 0 .304.023.385.067a.454.454 0 0 1 .19.189c.043.081.066.162.066.385v16.718c0 .223-.023.304-.067.385a.454.454 0 0 1-.189.19c-.081.043-.162.066-.385.066H2.641c-.223 0-.304-.023-.385-.067a.454.454 0 0 1-.19-.189.59.59 0 0 1-.064-.285L2 2.641c0-.223.023-.304.067-.385a.454.454 0 0 1 .189-.19.59.59 0 0 1 .285-.064ZM18.5 3.5h-15v15h15v-15Zm-8.356 11.501V12.16h1.092c.424 0 .806-.06 1.146-.18.34-.12.63-.29.87-.51.24-.22.424-.49.552-.81.128-.32.192-.68.192-1.08 0-.8-.244-1.43-.732-1.89C12.776 7.23 12.1 7 11.236 7H8.44v8.001h1.704Zm.972-4.233h-.972v-2.34h.972c.36 0 .64.102.84.306.2.204.3.49.3.858 0 .36-.1.646-.3.858-.2.212-.48.318-.84.318Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconProductPlacement9111Style0;
  }
}, [1, "cosmos-icon-product-placement-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$g() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-product-placement-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-product-placement-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconProductPlacement$1);
        break;
    }
  });
}
const defineCustomElement$m = defineCustomElement$1$g, cosmosIconCss$b = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconQuality9111Style0 = cosmosIconCss$b, CosmosIconQuality$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "8249db0e3afc30071c3f70b1aa31bee48a7a66ef", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "b4e697e733b5b0c71f59bb6c46c653e36247169e", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "790953d542439726749019ace1ea8618fa54dab5", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.051 7.859a.5.5 0 0 0 .069-.593l-1.174-2.032A.5.5 0 0 0 16.4 5l-2.477.586a6.222 6.222 0 0 0-1.368-.786l-.732-2.439A.5.5 0 0 0 11.344 2H9a.5.5 0 0 0-.479.356L7.786 4.8a6.148 6.148 0 0 0-1.362.789L3.945 5a.5.5 0 0 0-.549.237L2.223 7.266a.5.5 0 0 0 .069.593l1.745 1.854a6.484 6.484 0 0 0 0 1.575l-1.745 1.853a.5.5 0 0 0-.069.593L3.4 15.766a.5.5 0 0 0 .544.234l1.671-.395A.5.5 0 0 0 6 15.122v-3.357a4.131 4.131 0 0 1 .332-3.674 4.382 4.382 0 0 1 8.182 1.465c.032.25.242.44.494.444h1.076a.5.5 0 0 0 .389-.186l1.578-1.955Z", fill: "currentColor" }), h$1("path", { key: "2684af9f34bf83dc3e09c0abdf8d5280a9ad890a", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 12h-11a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Z", fill: "#DB0A40" }), h$1("path", { key: "65f15cfe7c282633d81f3d6d49c44a7575ca7491", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.557 17.955a.264.264 0 0 1-.277.288h-.733a.264.264 0 0 1-.277-.288v-1.431h-1.232v1.431a.264.264 0 0 1-.277.288h-.732a.264.264 0 0 1-.278-.288V14.05a.265.265 0 0 1 .277-.288h.733a.265.265 0 0 1 .277.288v1.31h1.232v-1.31a.265.265 0 0 1 .277-.288h.733a.265.265 0 0 1 .277.288v3.906Zm1.154.288h1.566a2.3 2.3 0 0 0 2.473-2.263 2.254 2.254 0 0 0-2.474-2.22H14.71a.265.265 0 0 0-.277.29v3.905a.264.264 0 0 0 .277.288Zm1.022-3.317h.544a1.01 1.01 0 0 1 1.12 1.054 1.038 1.038 0 0 1-1.12 1.098h-.544v-2.152Z", fill: "#fff" })));
  }
  static get style() {
    return CosmosIconQuality9111Style0;
  }
}, [1, "cosmos-icon-quality-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$f() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-quality-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-quality-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconQuality$1);
        break;
    }
  });
}
const defineCustomElement$l = defineCustomElement$1$f, cosmosIconCss$a = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconReddit9111Style0 = cosmosIconCss$a, CosmosIconReddit$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "1089dc76bf14367e2ba8d45d97b315363a0a0c5c", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "e3d213eb02fc36c31ecc48541cf4d03213f81ac7", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "b6dbadedfe9c846f061c117e0bf3aecf16314a0d", d: "M20.62 11.442a2.033 2.033 0 0 0-2.036-2.035 2.05 2.05 0 0 0-1.418.567c-1.401-1-3.32-1.652-5.456-1.735l.935-4.371 3.036.65A1.453 1.453 0 1 0 17.132 3a1.45 1.45 0 0 0-1.3.818L12.445 3.1c-.1-.017-.2 0-.267.05a.325.325 0 0 0-.15.234l-1.035 4.872c-2.169.066-4.121.717-5.54 1.735a2.05 2.05 0 0 0-1.417-.567A2.033 2.033 0 0 0 3.2 13.31c-.033.2-.05.4-.05.617 0 3.137 3.654 5.69 8.159 5.69 4.505 0 8.159-2.536 8.159-5.69 0-.2-.017-.417-.05-.617a2.055 2.055 0 0 0 1.201-1.869ZM6.638 12.894a1.453 1.453 0 0 1 2.903 0c0 .8-.65 1.451-1.451 1.451-.801.017-1.452-.65-1.452-1.451Zm8.126 3.854c-1.001 1.001-2.903 1.068-3.454 1.068-.567 0-2.47-.083-3.454-1.068a.373.373 0 0 1 0-.534c.15-.15.384-.15.534 0 .634.634 1.969.851 2.92.851.951 0 2.303-.217 2.92-.85a.371.371 0 0 1 .534 0 .406.406 0 0 1 0 .533Zm-.267-2.386a1.453 1.453 0 0 1 0-2.903c.8 0 1.451.65 1.451 1.452 0 .784-.65 1.451-1.451 1.451Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconReddit9111Style0;
  }
}, [1, "cosmos-icon-reddit-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$e() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-reddit-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-reddit-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconReddit$1);
        break;
    }
  });
}
const defineCustomElement$k = defineCustomElement$1$e, cosmosIconCss$9 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconReplay9111Style0 = cosmosIconCss$9, CosmosIconReplay$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "5de348e4ce78ccaa54459fa5efef5d55018ee4d2", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "7314eab350c2ca68c5dd1b3ef008b38a2902c600", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "0aa2ae584dbabf18477712eeecb46777b3689a58", d: "M10.993 18.6a6.504 6.504 0 0 1-6.487-6 .532.532 0 0 0-.52-.5h-.5a.477.477 0 0 0-.485.5 8.005 8.005 0 0 0 7.992 7.5c4.422 0 8.007-3.582 8.007-8s-3.585-8-8.007-8H8.674l-.003-2.196a.4.4 0 0 0-.68-.29l-3.004 3a.4.4 0 0 0 0 .56l3.003 3a.4.4 0 0 0 .69-.29L8.678 5.6h2.316a6.503 6.503 0 0 1 6.506 6.5c0 3.59-2.913 6.5-6.506 6.5Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconReplay9111Style0;
  }
}, [1, "cosmos-icon-replay-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$d() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-replay-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-replay-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconReplay$1);
        break;
    }
  });
}
const defineCustomElement$j = defineCustomElement$1$d, cosmosIconCss$8 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconSeason9111Style0 = cosmosIconCss$8, CosmosIconSeason$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "63aa8ace8b018a3c56cc00da47ab9113fa62ab20", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "bcacd062d8fe42e2ba034bc4f8a95d6c55b8b08c", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "578b7cc98a6607b894c7f4260cc8533c69da51f7", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.51 5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-11Zm.99 1.5h9v9h-9v-9Zm12.49 0a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5h-.5ZM18.48 8a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V8ZM6 13.32V8.68a.2.2 0 0 1 .31-.17l4.14 2.32a.21.21 0 0 1 0 .34L6.3 13.49a.2.2 0 0 1-.3-.17Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconSeason9111Style0;
  }
}, [1, "cosmos-icon-season-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$c() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-season-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-season-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconSeason$1);
        break;
    }
  });
}
const defineCustomElement$i = defineCustomElement$1$c, cosmosIconCss$7 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconSettings9111Style0 = cosmosIconCss$7, CosmosIconSettings$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "ad5b648b94ef0aa83f9bef6ed3cc3ff0a5171393", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "2af94f792976a6b9899d3febb334403a6ea98406", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "ebc574078037e431083bf133e78dd141de914dcd", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.782 10.942a6.688 6.688 0 0 0-.044-.733l1.64-1.765a.441.441 0 0 0 .063-.53L17.329 6.01a.432.432 0 0 0-.486-.212l-2.312.547a6.1 6.1 0 0 0-1.297-.697l-.688-2.294A.433.433 0 0 0 12.123 3H9.89a.441.441 0 0 0-.423.318l-.689 2.33c-.462.177-.9.411-1.306.696L5.17 5.797a.441.441 0 0 0-.485.212L3.572 7.933a.45.45 0 0 0 .062.529l1.641 1.765a6.098 6.098 0 0 0 0 1.465l-1.641 1.764a.45.45 0 0 0-.062.53l1.112 1.923a.44.44 0 0 0 .485.212l2.303-.582c.403.288.842.523 1.306.697l.689 2.294a.441.441 0 0 0 .423.318h2.233a.432.432 0 0 0 .423-.318l.688-2.294a5.73 5.73 0 0 0 1.297-.697l2.33.547a.432.432 0 0 0 .485-.212l1.112-1.924a.441.441 0 0 0-.062-.529l-1.64-1.765a6.66 6.66 0 0 0 .026-.714Zm-5.78 4.147a4.147 4.147 0 1 1 0-8.295 4.147 4.147 0 0 1 0 8.295Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconSettings9111Style0;
  }
}, [1, "cosmos-icon-settings-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$b() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-settings-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-settings-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconSettings$1);
        break;
    }
  });
}
const defineCustomElement$h = defineCustomElement$1$b, cosmosIconCss$6 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconSkipNext9111Style0 = cosmosIconCss$6, CosmosIconSkipNext$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "28d7edc0c4c5f48056bb3e9db5d1be16315e8017", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "fb5752e3f988db62055139074a89bff8e2a95741", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "70f6b4cfc0daaca94252be8b150647e43690a3ec", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.995 4.5a.5.5 0 0 0-.5-.5H16a.5.5 0 0 0-.5.5l-.005 13a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-13ZM6.386 17.836l6.455-6.443a.565.565 0 0 0 0-.786L6.386 4.164a.554.554 0 0 0-.786 0l-.387.387a.565.565 0 0 0 0 .786l5.668 5.658-5.668 5.668a.565.565 0 0 0 0 .786l.387.387a.553.553 0 0 0 .786 0Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconSkipNext9111Style0;
  }
}, [1, "cosmos-icon-skip-next-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$a() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-skip-next-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-skip-next-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconSkipNext$1);
        break;
    }
  });
}
const defineCustomElement$g = defineCustomElement$1$a, cosmosIconCss$5 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconStop9111Style0 = cosmosIconCss$5, CosmosIconStop$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "44be8022e0fcd156b2abfa7daace5a19fdcb6f83", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "dc927d1d2a6f0423ef8f790a7a24bc85a1fa2e55", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "ad59c3e030399bc363606ac15ed8b0af39d52573", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 6h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconStop9111Style0;
  }
}, [1, "cosmos-icon-stop-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$9() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-stop-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-stop-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconStop$1);
        break;
    }
  });
}
const defineCustomElement$f = defineCustomElement$1$9, cosmosIconCss$4 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconSubtitles9111Style0 = cosmosIconCss$4, CosmosIconSubtitles$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "1ab498e7554c2a0114ec0c9d50b092618d6d9267", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "b51c25d545ca1400e6534127bff3a3b671c7ec2f", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "cc68fcc8782757691acadb9f593e140f665ec622", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 3H20v11.5a.5.5 0 0 1-.5.5H13l-5.51 4.59a.3.3 0 0 1-.49-.23V15H2.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5Zm16 10.5v-9h-15v9H8a.5.5 0 0 1 .5.5v2.8l3.82-3.18a.47.47 0 0 1 .32-.12h5.86Z", fill: "currentColor" }), h$1("path", { key: "bf0426a2e20fb37673a30f17e849beeda94c30a8", d: "M6 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-6A.5.5 0 0 1 6 8v-.5Zm5 3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.5Zm3-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-1A.5.5 0 0 1 14 8v-.5Zm-8 3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3A.5.5 0 0 1 6 11v-.5Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconSubtitles9111Style0;
  }
}, [1, "cosmos-icon-subtitles-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$8() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-subtitles-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-subtitles-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconSubtitles$1);
        break;
    }
  });
}
const defineCustomElement$e = defineCustomElement$1$8, cosmosIconCss$3 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconVolume9111Style0 = cosmosIconCss$3, CosmosIconVolume$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "9c4d5dfd3d04be3f46b29fd01a9f99d95d17d6a4", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "f114e918c64f941c853facdf6e5be087d0ad2b08", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "dfe12780d8b617b2c65cb8e2b397707c53ecd9d9", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.51 4.42a.52.52 0 0 1 .72 0v-.04a9.14 9.14 0 0 1-.09 13.1.5.5 0 0 1-.71 0l-.34-.35a.5.5 0 0 1 0-.71 7.66 7.66 0 0 0 .08-10.94.49.49 0 0 1 0-.7l.34-.36Zm-5.34 1.29L7.62 8H4.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h3.11l2.56 2.26a.5.5 0 0 0 .83-.37V6.08a.5.5 0 0 0-.83-.37Zm3.2 1.98-.37.37a.49.49 0 0 0 0 .67 3.14 3.14 0 0 1 .93 2.2 3.42 3.42 0 0 1-1 2.28.51.51 0 0 0 0 .68l.35.36a.5.5 0 0 0 .69 0 4.59 4.59 0 0 0 .09-6.61.5.5 0 0 0-.69.05Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconVolume9111Style0;
  }
}, [1, "cosmos-icon-volume-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$7() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-volume-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-volume-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconVolume$1);
        break;
    }
  });
}
const defineCustomElement$d = defineCustomElement$1$7, cosmosIconCss$2 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconVolumeLow9111Style0 = cosmosIconCss$2, CosmosIconVolumeLow$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "41d00bd7bf4b1adf12b1ae143dfe43dcc65675cc", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "dba1cf35b1ffe3aa5b6742c666cfc633701c1336", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "a9008ec5a49960cba2263da39e72598cff7a5ad9", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.17 5.71 7.62 8H4.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h3.11l2.56 2.26a.5.5 0 0 0 .83-.37V6.08a.5.5 0 0 0-.83-.37Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconVolumeLow9111Style0;
  }
}, [1, "cosmos-icon-volume-low-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$6() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-volume-low-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-volume-low-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconVolumeLow$1);
        break;
    }
  });
}
const defineCustomElement$c = defineCustomElement$1$6, cosmosIconCss$1 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconVolumeMid9111Style0 = cosmosIconCss$1, CosmosIconVolumeMid$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "40fac9735ddaffea4a1a513506937f30c22bc966", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "60b910e85b3b3d435b46aac11b5f8954fa6b57ad", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "806e311a61796c170288d1c8273b2e8efb72e134", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.62 8 2.55-2.29a.5.5 0 0 1 .83.37v9.81a.5.5 0 0 1-.83.37L7.61 14H4.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h3.12Zm5.38.06.37-.37a.5.5 0 0 1 .69-.05 4.59 4.59 0 0 1-.09 6.61.5.5 0 0 1-.69 0l-.35-.36a.51.51 0 0 1 0-.68 3.42 3.42 0 0 0 1-2.28 3.14 3.14 0 0 0-.93-2.2.49.49 0 0 1 0-.67Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconVolumeMid9111Style0;
  }
}, [1, "cosmos-icon-volume-mid-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$5() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-volume-mid-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-volume-mid-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconVolumeMid$1);
        break;
    }
  });
}
const defineCustomElement$b = defineCustomElement$1$5, cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconX9111Style0 = cosmosIconCss, CosmosIconX$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "4d1ab11aff933af1217ccb5b540b9365d405066a", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "ddc48c817be1a32fa6342a4670217ea198047e63", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "549fbe4798dd16eb25407e816114cc2082d1cc1a", d: "M12.317 9.775 18.144 3h-1.38l-5.06 5.883L7.66 3H3l6.112 8.896L3 19h1.381l5.344-6.212L13.993 19h4.661l-6.338-9.225Zm-1.892 2.199-.62-.886L4.88 4.04H7l3.977 5.688.62.886 5.168 7.393h-2.121l-4.218-6.033Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconX9111Style0;
  }
}, [1, "cosmos-icon-x-9-11-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$4() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-x-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-x-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosIconX$1);
        break;
    }
  });
}
const defineCustomElement$a = defineCustomElement$1$4, cosmosLinkCss = "@-webkit-keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}@keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}.cosmos-link{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:0;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-variation-settings:inherit;font-weight:inherit;line-height:inherit;margin:0;outline:none;padding:0;color:inherit;font:inherit;font-variant-numeric:inherit;letter-spacing:inherit;position:relative;text-align:inherit;text-decoration:none}.cosmos-link:not(:focus):hover{-webkit-animation:none;animation:none;border-color:currentColor;-o-border-image:none;border-image:none}.cosmos-link:focus-visible{border-radius:0.2em;-webkit-box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;margin:0 -2px;padding:0 2px;text-decoration:none}.cosmos-link--kind-underlined{text-decoration:underline;text-decoration-thickness:0.105em;text-transform:inherit;text-underline-offset:0.125em}.cosmos-link--kind-underlined:not(:focus){-webkit-animation:1s cosmos-link-dim-border steps(2, start) infinite paused;animation:1s cosmos-link-dim-border steps(2, start) infinite paused}", CosmosLink9111Style0 = cosmosLinkCss, generateClassNames$3 = bem("cosmos-link"), CosmosLink$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.handleKeyDown = (te) => {
      this.href || (te.key === "Enter" || te.key === " ") && (te.preventDefault(), te.target.click());
    }, this.href = void 0, this.kind = "underlined", this.rel = void 0, this.target = void 0;
  }
  render() {
    const te = this.href ? "a" : "span", ee = te === "span" ? "button" : void 0;
    return h$1(te, { key: "a5f4647e9241c8fa76a9850b1afc10fd67c1aa3f", class: generateClassNames$3({
      kind: this.kind
    }), href: this.href, onKeyDown: this.handleKeyDown, part: "base", rel: this.rel, role: ee, tabIndex: 0, target: this.target }, h$1("slot", { key: "778a1c9ce227d5fa7af4d3ea1bb9416a752c6fe6" }));
  }
  static get style() {
    return CosmosLink9111Style0;
  }
}, [1, "cosmos-link-9-11-1", {
  href: [513],
  kind: [513],
  rel: [513],
  target: [513]
}]);
function defineCustomElement$1$3() {
  if (typeof customElements > "u")
    return;
  ["cosmos-link-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-link-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosLink$1);
        break;
    }
  });
}
const defineCustomElement$9 = defineCustomElement$1$3, defineCustomElement$8 = defineCustomElement$Q, defineCustomElement$7 = defineCustomElement$P, cosmosRadioCss = '@charset "UTF-8";:host{display:block;min-width:0;width:100%}.cosmos-radio{-ms-flex-align:baseline;align-items:baseline;display:-ms-flexbox;display:flex}.cosmos-radio__input-and-prefix{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0}.cosmos-radio__aligner{--cosmos-text-font-family:var(--cosmos-radio-font-family);--cosmos-text-font-size:var(--cosmos-radio-font-size);--cosmos-text-font-style:var(--cosmos-radio-font-style);--cosmos-text-font-weight:var(--cosmos-radio-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-line-height);--cosmos-text-text-transform:var(--cosmos-radio-text-transform);width:0}.cosmos-radio__aligner::before{content:" "}.cosmos-radio__input-container{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;height:var(--cosmos-radio-size, 16px);-ms-flex-pack:center;justify-content:center;-webkit-margin-end:var(--cosmos-radio-gap, calc(0.5 * var(--cosmos-radio-size, 16px)));margin-inline-end:var(--cosmos-radio-gap, calc(0.5 * var(--cosmos-radio-size, 16px)));position:relative;width:var(--cosmos-radio-size, 16px)}.cosmos-radio__prefix{display:grid}.cosmos-radio__prefix>[slot=prefix]{-webkit-margin-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)));margin-inline-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)))}.cosmos-radio__prefix ::slotted([slot=prefix]){--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px;-webkit-margin-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)));margin-inline-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)));position:relative}.cosmos-radio__prefix ::slotted([slot=prefix])::before{content:"";display:block;height:100%;left:0;min-height:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.cosmos-radio__input{-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border-radius:9999px;border-style:solid;border-width:var(--cosmos-radio-border-width, 1px);-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;display:-ms-flexbox;display:flex;height:var(--cosmos-radio-size, 16px);-ms-flex-pack:center;justify-content:center;margin:0;outline:none;padding:0;width:var(--cosmos-radio-size, 16px)}.cosmos-radio__input:focus,.cosmos-radio__input:focus:not(:focus-visible){outline:none}.cosmos-radio__input:focus:not(:focus-visible)::before{content:none}.cosmos-radio__input:focus::before{border-radius:calc(9999px * 1.5);bottom:calc((4px + 0px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 0px) * -1);position:absolute;right:calc((4px + 0px) * -1);top:calc((4px + 0px) * -1);content:""}.cosmos-radio__input::after{-webkit-box-sizing:content-box;box-sizing:content-box;content:"";display:block;height:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);z-index:1}.cosmos-radio__input~.cosmos-radio__dot{border-radius:9999px;display:block;height:6px;left:0;margin:auto;opacity:0;position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:6px}.cosmos-radio__input:checked~.cosmos-radio__dot{opacity:1}.cosmos-radio__content{min-width:0;position:relative}.cosmos-radio__content--row{width:100%}.cosmos-radio__content--row label{width:100%}.cosmos-radio__label{display:block;min-width:0;position:relative}.cosmos-radio__label::before{bottom:calc(calc(0.25 * var(--cosmos-radio-size, 16px)) * -1);content:"";left:0;position:absolute;right:0;top:calc(calc(0.25 * var(--cosmos-radio-size, 16px)) * -1)}.cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color);--cosmos-text-font-family:var(--cosmos-radio-font-family);--cosmos-text-font-size:var(--cosmos-radio-font-size);--cosmos-text-font-style:var(--cosmos-radio-font-style);--cosmos-text-font-weight:var(--cosmos-radio-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-line-height);--cosmos-text-text-transform:var(--cosmos-radio-text-transform);display:-ms-flexbox;display:flex;position:relative}.cosmos-radio--hovered .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color-hover)}.cosmos-radio--appearance-dark{color:var(--cosmos-radio-color, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input{background:var(--cosmos-radio-background-color, transparent);border-color:var(--cosmos-radio-border-color, rgba(0, 15, 30, 0.6))}.cosmos-radio--appearance-dark .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input:checked~.cosmos-radio__dot{background-color:var(--cosmos-radio-dot-color, #FFFFFF)}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover,.cosmos-radio--appearance-dark.cosmos-radio--hovered{color:var(--cosmos-radio-color-hover, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-dark.cosmos-radio--hovered .cosmos-radio__input{background:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-dark.cosmos-radio--hovered .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.8))}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input:checked{border-color:transparent}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input{border-color:var(--cosmos-radio-border-color-hover, rgba(0, 15, 30, 0.6))}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input:checked{border-color:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-radio--appearance-light{color:var(--cosmos-radio-color, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input{background:var(--cosmos-radio-background-color, transparent);border-color:var(--cosmos-radio-border-color, rgba(255, 255, 255, 0.6))}.cosmos-radio--appearance-light .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input:checked~.cosmos-radio__dot{background-color:var(--cosmos-radio-dot-color, #000F1E)}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover,.cosmos-radio--appearance-light.cosmos-radio--hovered{color:var(--cosmos-radio-color-hover, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-light.cosmos-radio--hovered .cosmos-radio__input{background:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-light.cosmos-radio--hovered .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.8))}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input:checked{border-color:transparent}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-light:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input{border-color:var(--cosmos-radio-border-color-hover, rgba(255, 255, 255, 0.6))}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-light:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input:checked{border-color:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-radio--disabled{pointer-events:none}.cosmos-radio--disabled .cosmos-radio__prefix{opacity:0.4}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__input{border-color:var(--cosmos-radio-border-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__input{border-color:var(--cosmos-radio-border-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--invalid .cosmos-radio__input{border-color:var(--cosmos-radio-invalid-color, #E06600);border-width:var(--cosmos-radio-border-width, 2px)}', CosmosRadio9111Style0 = cosmosRadioCss, generateClassNames$2 = bem("cosmos-radio"), CosmosRadio$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.inputchangeEvent = createEvent(this, "inputchange", 6), this.inputinvalidEvent = createEvent(this, "inputinvalid", 7), this.radios = [], this.hoveredOn = () => {
      this.isHovered = !0;
    }, this.hoveredOff = () => {
      this.isHovered = !1;
    }, this.handleFormData = (te) => {
      if (this.name && this.input && this.input.checked && !this.disabled)
        return te.formData.append(this.input.name, this.input.value);
    }, this.handleFormSubmit = (te) => {
      this.reportValidity() || te.preventDefault();
    }, this.handleInvalid = (te) => {
      this.group && te.preventDefault(), this.inputInvalid = !0, this.inputinvalidEvent.emit();
    }, this.handleChange = () => {
      var te;
      this.checked = (te = this.input) === null || te === void 0 ? void 0 : te.checked;
    }, this.handleSlotChange = () => {
      this.labelText = getDefaultSlotTextContent(this.defaultSlotRef);
    }, this.appearance = void 0, this.autofocus = void 0, this.checked = !1, this.clamp = void 0, this.disabled = !1, this.focusable = !0, this.hitArea = "content", this.invalid = !1, this.name = void 0, this.required = !1, this.value = void 0, this.computedAppearance = "dark", this.inputInvalid = !1, this.isHovered = !1, this.labelText = "", this.tabIndex = 0;
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  handleFocusableChange(te) {
    this.setTabindexFromFocusable(te);
  }
  handleInvalidChange(te) {
    this.inputInvalid = te;
  }
  handleCheckedChange(te, ee) {
    te && te !== ee && this.inputchangeEvent.emit();
  }
  /**
   * Returns the validity status of the Radio's value.
   * Fires an `inputinvalid`  event in the case of invalidity.
   */
  async inputCheckValidity() {
    return this.checkValidity();
  }
  /**
   * Performs the same validity checking steps as the `inputCheckValidity` methods.
   * Fires an `inputinvalid` event and reports the problem to the user in case of invalidity.
   */
  async inputReportValidity() {
    return this.reportValidity();
  }
  /**
   * Sets a custom error message for the native validation issue report.
   */
  async inputSetCustomValidity(te) {
    var ee;
    (ee = this.input) === null || ee === void 0 || ee.setCustomValidity(te);
  }
  /**
   * Sets focus on the Radio. This will scroll the element into the view and focus it.
   */
  async inputFocus() {
    var te;
    (te = this.input) === null || te === void 0 || te.focus();
  }
  /**
   * Removes focus from the Radio.
   */
  async inputBlur() {
    var te;
    (te = this.input) === null || te === void 0 || te.blur();
  }
  deriveTextAppearance() {
    return this.computedAppearance === "light" ? "light" : "dark";
  }
  getTitle() {
    var te;
    return this.clamp ? (te = this.element.textContent) === null || te === void 0 ? void 0 : te.trim() : void 0;
  }
  checkValidity() {
    var te, ee;
    const ne = (te = this.radios) === null || te === void 0 ? void 0 : te.some((ae) => ae.shadowRoot.querySelector('input[type="radio"]').checked);
    return !((ee = this.radios) === null || ee === void 0 ? void 0 : ee.some((ae) => ae.required)) || ne;
  }
  reportValidity() {
    const te = this.checkValidity();
    return !te && this.input && (this.input.required = !0, this.input.reportValidity()), te;
  }
  getAllRadios() {
    return this.group ? [
      ...this.group.querySelectorAll(`${transformTagName("cosmos-radio")}[name="${this.name}"]`)
    ].filter((ee) => !ee.disabled) : [this.element];
  }
  getRadioIndex() {
    return this.radios.findIndex((te) => te === this.element);
  }
  setTabindexFromFocusable(te = this.focusable) {
    this.tabIndex = te ? 0 : -1;
  }
  connectedCallback() {
    this.form = this.element.closest("form"), this.group = this.element.closest(transformTagName("cosmos-radio-group")), this.form && (this.form.addEventListener("formdata", this.handleFormData, !0), this.form.addEventListener("submit", this.handleFormSubmit, !0));
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.radios = this.getAllRadios(), this.radioIndex = this.getRadioIndex(), this.setTabindexFromFocusable();
  }
  componentDidLoad() {
    slotMutationService.observe(this.element, this.handleSlotChange);
  }
  disconnectedCallback() {
    this.form && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit)), slotMutationService.unobserve(this.element);
  }
  render() {
    return h$1("div", { key: "fb7d65ae59f9a9f969433b2cbf723f21852b524c", class: generateClassNames$2({
      appearance: this.computedAppearance,
      disabled: this.disabled,
      hovered: this.isHovered,
      invalid: this.invalid || this.inputInvalid
    }), part: "base" }, h$1("div", { key: "20cee28e52c1ec3332e005a321f7ef4c49b67605", class: generateClassNames$2("input-and-prefix") }, h$1("cosmos-text-9-11-1", { key: "10edd221bf2c7ca9cff415b41a7d57d1fcb5ab86", "aria-hidden": "true", class: generateClassNames$2("aligner"), size: "small", tag: "span" }), h$1("div", { key: "e76c14923878963de9b37fef520751648fb86636", class: generateClassNames$2("input-container") }, h$1("input", { key: "3b560174437d24d713dbb5c55c5da64b60f164d0", "aria-label": this.labelText, "aria-posinset": this.radioIndex + 1, "aria-setsize": this.radios.length, autofocus: this.autofocus, checked: this.checked, class: generateClassNames$2("input"), disabled: this.disabled, id: "radio", name: this.name, onInvalid: this.handleInvalid, ref: (te) => this.input = te, required: this.required, tabIndex: this.tabIndex, type: "radio", value: this.value, onChange: this.handleChange, part: "radio" }), h$1("span", { key: "bcba37a3bf9801521b302efec832f88d1a25d7fc", class: generateClassNames$2("dot") })), h$1("label", { key: "293daf29752207bcfdcbeacbcbdcbf28a4353094", "aria-hidden": "true", htmlFor: "radio", class: generateClassNames$2("prefix"), onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff, part: "prefix" }, h$1("slot", { key: "a20119a95de489209361edf88322cdd1116e764b", name: "prefix" }))), h$1("div", { key: "94ece12cff605a5bdb9f0675e55fc376b3b66de0", class: generateClassNames$2("content", {
      row: this.hitArea === "row"
    }) }, h$1("label", { key: "47fe3f71bd987243155b7f1ab36166cf49c9fd9b", class: generateClassNames$2("label"), htmlFor: "radio" }, h$1("cosmos-text-9-11-1", { key: "4ee6a52bfd84f5fa62c3cee719dbfede2930c0dd", appearance: this.deriveTextAppearance(), class: generateClassNames$2("label-text"), clamp: this.clamp, onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff, size: "small", tag: "span", title: this.getTitle(), exportparts: "base: label" }, h$1("span", { key: "3f654e2c34b61a50cc3c98d64b379b21c1792ff0" }, h$1("slot", { key: "2c308ea829f889ef022fddb0639b03a935dbb317", ref: (te) => this.defaultSlotRef = te }))))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      focusable: ["handleFocusableChange"],
      invalid: ["handleInvalidChange"],
      checked: ["handleCheckedChange"]
    };
  }
  static get style() {
    return CosmosRadio9111Style0;
  }
}, [1, "cosmos-radio-9-11-1", {
  appearance: [513],
  autofocus: [516],
  checked: [516],
  clamp: [516],
  disabled: [516],
  focusable: [516],
  hitArea: [513, "hit-area"],
  invalid: [516],
  name: [513],
  required: [516],
  value: [513],
  computedAppearance: [32],
  inputInvalid: [32],
  isHovered: [32],
  labelText: [32],
  tabIndex: [32],
  inputCheckValidity: [64],
  inputReportValidity: [64],
  inputSetCustomValidity: [64],
  inputFocus: [64],
  inputBlur: [64]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  focusable: ["handleFocusableChange"],
  invalid: ["handleInvalidChange"],
  checked: ["handleCheckedChange"]
}]);
function defineCustomElement$1$2() {
  if (typeof customElements > "u")
    return;
  ["cosmos-radio-9-11-1", "cosmos-text-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-radio-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosRadio$1);
        break;
      case "cosmos-text-9-11-1":
        customElements.get(te) || defineCustomElement$Y();
        break;
    }
  });
}
const defineCustomElement$6 = defineCustomElement$1$2, cosmosRadioGroupCss = ".cosmos-form-field{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.cosmos-form-field__info-container{display:inline-block;margin-bottom:8px}.cosmos-form-field__info-container:not(.cosmos-form-field__info-container--has-label,.cosmos-form-field__info-container--has-help-text,.cosmos-form-field__info-container--has-required-optional-label){display:none}.cosmos-form-field__label-text,.cosmos-form-field__help-text,.cosmos-form-field__required-optional-label,.cosmos-form-field__validation-message{display:inline}.cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-radio-group-label-color);--cosmos-text-font-family:var(--cosmos-radio-group-label-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-label-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-label-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-label-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-label-text-transform)}.cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-radio-group-help-text-color);--cosmos-text-font-family:var(--cosmos-radio-group-help-text-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-help-text-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-help-text-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-help-text-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-help-text-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-help-text-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-help-text-text-transform)}.cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-radio-group-required-optional-label-color);--cosmos-text-font-family:var(--cosmos-radio-group-required-optional-label-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-required-optional-label-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-required-optional-label-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-required-optional-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-required-optional-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-required-optional-label-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-required-optional-label-text-transform);display:inline-block;-webkit-margin-start:4px;margin-inline-start:4px;white-space:nowrap}.cosmos-form-field__validation-message{display:-ms-flexbox;display:flex;gap:4px;margin-top:8px}.cosmos-form-field__validation-message-text{--cosmos-text-font-family:var(--cosmos-radio-group-validation-message-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-validation-message-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-validation-message-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-validation-message-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-validation-message-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-validation-message-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-validation-message-text-transform)}.cosmos-form-field__validation-message-icon{--cosmos-icon-color:var(--cosmos-radio-group-invalid-color, #E06600);--cosmos-icon-size:calc(16rem / var(--cosmos-base-font-size, 16));-ms-flex-negative:0;flex-shrink:0;padding:1.5px 0}.cosmos-form-field--invalid .cosmos-form-field__label-text,.cosmos-form-field--invalid .cosmos-form-field__validation-message{--cosmos-text-color:var(--cosmos-radio-group-label-color)}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-radio-group-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-radio-group-help-text-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-radio-group-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-radio-group-label-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-radio-group-help-text-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-radio-group-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-radio-group__list{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:12px}", CosmosRadioGroup9111Style0 = cosmosRadioGroupCss, generateClassNames$1 = bem("cosmos-radio-group"), radioTag = transformTagName("cosmos-radio"), CosmosRadioGroup$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.enabledRadios = [], this.isNavigatedWithKeyboard = !1, this.radios = [], this.getValidationMessage = () => {
      if (this.validationMessage)
        return this.validationMessage;
      if (!this.invalid && this.groupInvalid && this.enabledRadios.length)
        return this.enabledRadios[0].shadowRoot.querySelector('input[type="radio"]').validationMessage;
    }, this.reannounceValidationMessage = async () => {
      this.validationMessageRef && (this.validationMessageRef.ariaLabel = "", await nextTick(), this.validationMessageRef.ariaLabel = this.getValidationMessage());
    }, this.handleSlotChange = () => {
      this.initializeRadios(), forceUpdate(this);
    }, this.appearance = void 0, this.disabled = void 0, this.helpText = void 0, this.invalid = !1, this.label = void 0, this.optionalLabel = void 0, this.requiredLabel = void 0, this.validationMessage = void 0, this.computedAppearance = "dark", this.groupInvalid = !1;
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te, this.updateRadiosAppearance();
  }
  handleInvalidChange(te) {
    this.groupInvalid = te, this.updateRadiosInvalidState();
  }
  handleDisabledChange(te) {
    typeof this.disabled < "u" && this.radios.forEach((ee) => {
      ee.disabled = te;
    });
  }
  async handleInputchange(te) {
    const ee = this.enabledRadios.findIndex((ne) => ne === te.target);
    await this.updateRadios(ee), this.isInvalidStateControlled();
  }
  handleInputInvalid() {
    this.groupInvalid = !0, this.updateRadiosInvalidState(), this.reannounceValidationMessage();
  }
  async handleKeyDown(te) {
    if (this.isNavigatedWithKeyboard = te.key !== "Tab", ["ArrowUp", "ArrowLeft", "ArrowRight", "ArrowDown"].includes(te.key)) {
      [this.radios, this.enabledRadios] = this.getRadios(), te.preventDefault();
      let ee = this.enabledRadios.findIndex((ne) => ne.checked);
      ee == -1 && (ee = 0), ["ArrowUp", "ArrowLeft"].includes(te.key) ? (ee--, ee < 0 && (ee = this.enabledRadios.length - 1)) : (ee++, ee >= this.enabledRadios.length && (ee = 0)), await this.updateRadios(ee);
    }
  }
  // Will not update children to valid if invalid state is controlled
  isInvalidStateControlled() {
    this.invalid || (this.groupInvalid = !1, this.updateRadiosInvalidState());
  }
  getRadios() {
    const te = [...this.element.querySelectorAll(radioTag)], ee = te.filter((ne) => !ne.disabled);
    return [te, ee];
  }
  updateRadiosAppearance() {
    this.radios.forEach((te) => {
      te.appearance = this.computedAppearance;
    });
  }
  async updateRadios(te) {
    if (this.enabledRadios.length)
      if (this.enabledRadios.forEach((ee, ne) => {
        te !== ne && (ee.checked = !1), ee.invalid = this.groupInvalid, ee.focusable = !1;
      }), typeof te < "u" && te !== -1 && this.enabledRadios[te]) {
        const ee = this.enabledRadios[te];
        ee.checked = !0, ee.focusable = !0, this.isNavigatedWithKeyboard && await ee.inputFocus();
      } else
        this.enabledRadios[0].focusable = !0;
  }
  updateRadiosInvalidState() {
    this.radios.forEach((te) => {
      te.invalid = this.groupInvalid;
    });
  }
  updateRadiosDisabledState() {
    typeof this.disabled < "u" && this.radios.forEach((te) => {
      te.disabled = this.disabled;
    });
  }
  initializeRadios() {
    [this.radios, this.enabledRadios] = this.getRadios(), this.updateRadiosDisabledState(), this.updateRadiosInvalidState(), this.updateRadiosAppearance();
    const te = this.enabledRadios.findIndex((ee) => ee.checked);
    this.updateRadios(te);
  }
  componentWillLoad() {
    this.groupInvalid = this.invalid, resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), slotMutationService.observe(this.element, this.handleSlotChange);
  }
  disconnectedCallback() {
    slotMutationService.unobserve(this.element);
  }
  render() {
    return h$1(FormField, { key: "ab1f63cb6af3c0274e08819943966e87732c1748", element: this.element, appearance: this.computedAppearance, class: generateClassNames$1(), helpText: this.helpText, invalid: this.groupInvalid, label: this.label, optionalLabel: this.optionalLabel, requiredLabel: this.requiredLabel, validationMessage: this.getValidationMessage(), validationMessageRef: (te) => this.validationMessageRef = te, disabled: this.disabled, required: !!this.requiredLabel }, h$1("div", { key: "1ae8d943b6ea027a5e9db5378c520105e7492135", "aria-disabled": getAriaDisabled(this.disabled), "aria-invalid": getAriaInvalid(this.groupInvalid), "aria-labelledby": `label ${getAriaDescribedBy(this.groupInvalid)}`, "aria-required": getAriaRequired(!!this.requiredLabel), class: generateClassNames$1("list"), role: "radiogroup" }, h$1("slot", { key: "2937a9f753208eb0b203fe1ff21a425ef935f4d4" })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      invalid: ["handleInvalidChange"],
      disabled: ["handleDisabledChange"]
    };
  }
  static get style() {
    return CosmosRadioGroup9111Style0;
  }
}, [1, "cosmos-radio-group-9-11-1", {
  appearance: [513],
  disabled: [516],
  helpText: [513, "help-text"],
  invalid: [516],
  label: [513],
  optionalLabel: [513, "optional-label"],
  requiredLabel: [513, "required-label"],
  validationMessage: [513, "validation-message"],
  computedAppearance: [32],
  groupInvalid: [32]
}, [[0, "inputchange", "handleInputchange"], [0, "inputinvalid", "handleInputInvalid"], [0, "keydown", "handleKeyDown"]], {
  appearance: ["handleAppearanceChange"],
  invalid: ["handleInvalidChange"],
  disabled: ["handleDisabledChange"]
}]);
function defineCustomElement$1$1() {
  if (typeof customElements > "u")
    return;
  ["cosmos-radio-group-9-11-1", "cosmos-icon-warning-9-11-1", "cosmos-text-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-radio-group-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosRadioGroup$1);
        break;
      case "cosmos-icon-warning-9-11-1":
        customElements.get(te) || defineCustomElement$T();
        break;
      case "cosmos-text-9-11-1":
        customElements.get(te) || defineCustomElement$Y();
        break;
    }
  });
}
const defineCustomElement$5 = defineCustomElement$1$1, defineCustomElement$4 = defineCustomElement$W, defineCustomElement$3 = defineCustomElement$Y, defineCustomElement$2 = defineCustomElement$O, isNil = (re) => re == null, defaultDuration = 300, defaultOffset = 8;
class Tooltip {
  constructor() {
    this.emitter = new EventEmitter(), this.placementMap = {
      left: "before",
      right: "after",
      bottom: "below",
      top: "above"
    }, this.cssTransition = new CSSTransition();
  }
  create({ target: te, content: ee, appendTo: ne, interactive: ie, placement: ae, showOnCreate: ce, follow: he, sticky: _e, offset: le = defaultOffset, enterDuration: se = defaultDuration, leaveDuration: oe = defaultDuration, trigger: ue }) {
    this.target = te, this.leaveDuration = oe, this.enterDuration = se, this.element = ee, this.element.style.display = "block", ee.remove(), this.tooltipInstance = tippy(this.target, {
      appendTo: ne,
      hideOnClick: !1,
      interactive: ie,
      offset: [0, le],
      placement: this.cosmosToPopperPlacement(ae),
      showOnCreate: ce || !1,
      touch: !1,
      delay: [null, this.leaveDuration],
      trigger: ue || void 0,
      sticky: _e,
      plugins: [followCursor, sticky],
      onMount: ({ popperInstance: be, popper: ve }) => {
        var me;
        const pe = he ? "follow" : be == null ? void 0 : be.state.placement;
        (me = ve.firstElementChild) === null || me === void 0 || me.setAttribute("data-cosmos-tooltip-placement", this.popperToCosmosPlacement(pe)), this.cssTransition.enter(ve.firstElementChild, this.enterDuration);
      },
      onShow: () => {
        this.onShowHandler();
      },
      onUntrigger: async () => {
        await this.onHideHandler();
      },
      render: () => ({
        popper: this.element
      })
    }), he && requestAnimationFrame(() => {
      var be;
      this.tooltipInstance && typeof this.tooltipInstance.setProps == "function" && ((be = this.tooltipInstance) === null || be === void 0 || be.setProps({ followCursor: this.getTippyFollowDirection(ae) }));
    });
  }
  on(te, ee) {
    this.emitter.on(te, ee);
  }
  off(te, ee) {
    this.emitter.off(te, ee);
  }
  show() {
    var te, ee, ne;
    !((te = this.tooltipInstance) === null || te === void 0) && te.unmount && ((ee = this.tooltipInstance) === null || ee === void 0 || ee.unmount()), (ne = this.tooltipInstance) === null || ne === void 0 || ne.show();
  }
  async hide() {
    await this.onHideHandler(), this.tooltipInstance.hide();
  }
  async update() {
    var te;
    this.isVisible() && (await nextTick(), await ((te = this.tooltipInstance.popperInstance) === null || te === void 0 ? void 0 : te.update()));
  }
  isVisible() {
    return this.tooltipInstance.state.isVisible;
  }
  setProps(te) {
    var ee;
    (ee = this.tooltipInstance) === null || ee === void 0 || ee.setProps(te);
  }
  destroy() {
    this.tooltipInstance.destroy();
  }
  popperToCosmosPlacement(te) {
    return this.placementMap[te];
  }
  cosmosToPopperPlacement(te) {
    return Object.keys(this.placementMap).find((ne) => this.placementMap[ne] === te) || "top";
  }
  getTippyFollowDirection(te) {
    return te === "above" || te === "below" ? "horizontal" : "vertical";
  }
  onShowHandler() {
    this.emitter.emit("show"), this.target.setAttribute("aria-expanded", "true");
  }
  onHideHandler() {
    return this.emitter.emit("hide"), this.triggerCssLeaveTransition();
  }
  triggerCssLeaveTransition() {
    return this.cssTransition.leave(this.element.firstElementChild, this.leaveDuration);
  }
}
const cosmosTooltipCss = '@supports (font-variation-settings: normal){::slotted(strong),::slotted(b){font-variation-settings:"opsz" 12, "wght" 700}}:host{display:contents}.tippy-mount{display:inline-block;height:0;width:0}.tippy-element{display:none;z-index:var(--cosmos-tooltip-z-index, 9999) !important}.cosmos-tooltip{--cosmos-text-color:var(--cosmos-tooltip-color);--cosmos-text-font-family:var(--cosmos-tooltip-font-family);--cosmos-text-font-size:var(--cosmos-tooltip-font-size);--cosmos-text-font-style:var(--cosmos-tooltip-font-style);--cosmos-text-font-weight:var(--cosmos-tooltip-font-weight);--cosmos-text-letter-spacing:var(--cosmos-tooltip-letter-spacing);--cosmos-text-line-height:var(--cosmos-tooltip-line-height);--cosmos-text-text-transform:var(--cosmos-tooltip-text-transform);background-color:var(--cosmos-tooltip-background, #FFFFFF);border-color:var(--cosmos-tooltip-border-color, transparent);border-radius:var(--cosmos-tooltip-border-radius, 6px);border-style:solid;border-width:var(--cosmos-tooltip-border-width, 0);-webkit-box-shadow:var(--cosmos-tooltip-box-shadow, 0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431));box-shadow:var(--cosmos-tooltip-box-shadow, 0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431));max-width:calc(288rem / var(--cosmos-base-font-size, 16));padding:var(--cosmos-tooltip-padding, 4px 8px)}.cosmos-tooltip--spacing-loose{padding:var(--cosmos-tooltip-padding, 8px 12px)}.cosmos-tooltip--appearance-dark{background-color:var(--cosmos-tooltip-background, #00162B)}.cosmos-tooltip.enter{opacity:0}.cosmos-tooltip[data-cosmos-tooltip-placement=above].enter{-webkit-transform:translate(0, 8px);transform:translate(0, 8px)}.cosmos-tooltip[data-cosmos-tooltip-placement=below].enter{-webkit-transform:translate(0, -8px);transform:translate(0, -8px)}.cosmos-tooltip[data-cosmos-tooltip-placement=before].enter{-webkit-transform:translate(8px, 0);transform:translate(8px, 0)}.cosmos-tooltip[data-cosmos-tooltip-placement=after].enter{-webkit-transform:translate(-8px, 0);transform:translate(-8px, 0)}.cosmos-tooltip[data-cosmos-tooltip-placement].enter-active{opacity:1;-webkit-transform:translate(0, 0);transform:translate(0, 0);-webkit-transition:0.15s cubic-bezier(0.33, 1, 0.68, 1);transition:0.15s cubic-bezier(0.33, 1, 0.68, 1)}.cosmos-tooltip.leave{opacity:1}.cosmos-tooltip.leave-active{opacity:0;-webkit-transition:0.15s cubic-bezier(0, 0.32, 0.32, 1);transition:0.15s cubic-bezier(0, 0.32, 0.32, 1)}.cosmos-tooltip--empty{display:none}', CosmosTooltip9111Style0 = cosmosTooltipCss, generateClassNames = bem("cosmos-tooltip"), CosmosTooltip$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.hideEvent = createEvent(this, "hide", 7), this.showEvent = createEvent(this, "show", 7), this.tippyElement = void 0, this.tippyMount = void 0, this.tooltipInstance = void 0, this.onDefaultSlotChange = () => {
      this.tooltipInstance && !this.getTooltipTarget ? (this.tooltipInstance.destroy(), this.tooltipInstance = void 0) : (this.instantiateTooltip(), this.createTooltip());
    }, this.showHandler = () => {
      this.showEvent.emit();
    }, this.hideHandler = () => {
      this.hideEvent.emit();
    }, this.appearance = void 0, this.content = "", this.controlled = !1, this.follow = !1, this.offset = 8, this.placement = "above", this.spacing = "tight", this.unreachable = !1, this.visible = !1, this.computedAppearance = "light", this.hasContent = !1;
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  handleShowChange() {
    var te, ee, ne, ie;
    (te = this.tooltipInstance) === null || te === void 0 || te.setProps({ touch: !0 }), this.visible ? (ee = this.tooltipInstance) === null || ee === void 0 || ee.show() : (ne = this.tooltipInstance) === null || ne === void 0 || ne.hide(), (ie = this.tooltipInstance) === null || ie === void 0 || ie.setProps({ touch: !1 });
  }
  async handleContentChange() {
    await this.update();
  }
  /**
   * Triggers an update of the tooltip positioning.
   */
  async update() {
    var te;
    this.tooltipInstance && await ((te = this.tooltipInstance) === null || te === void 0 ? void 0 : te.update());
  }
  createObserver() {
    const te = this.element.querySelector('[slot="content"]');
    if (!te || typeof MutationObserver > "u")
      return;
    const ee = new MutationObserver((ne) => {
      ne.forEach((ie) => {
        ie.type === "childList" && this.update();
      });
    });
    ee.observe(te, {
      childList: !0,
      subtree: !0
    }), this.observer = ee;
  }
  instantiateTooltip() {
    isNodeEnvironment() || !this.getTooltipTarget() || (this.tooltipInstance = new Tooltip());
  }
  createTooltip() {
    var te;
    this.tooltipInstance && (this.tooltipOptions = {
      target: this.getTooltipTarget(),
      appendTo: this.tippyMount,
      showOnCreate: this.visible,
      placement: this.placement || "above",
      content: this.tippyElement,
      follow: this.normalizedFollowValue,
      sticky: this.follow === "target",
      interactive: !this.unreachable,
      offset: this.offset,
      enterDuration: 150,
      leaveDuration: 150,
      trigger: this.controlled ? "manual" : void 0
    }, (te = this.tooltipInstance) === null || te === void 0 || te.create(this.tooltipOptions), this.addTooltipListeners());
  }
  addTooltipListeners() {
    var te, ee;
    this.tooltipInstance && ((te = this.tooltipInstance) === null || te === void 0 || te.on("show", this.showHandler), (ee = this.tooltipInstance) === null || ee === void 0 || ee.on("hide", this.hideHandler));
  }
  removeTooltipListeners() {
    var te, ee;
    this.tooltipInstance && ((te = this.tooltipInstance) === null || te === void 0 || te.off("show", this.showHandler), (ee = this.tooltipInstance) === null || ee === void 0 || ee.off("hide", this.hideHandler));
  }
  getTooltipTarget() {
    return Array.from(this.element.children).find((te) => te.tagName.toLowerCase() !== "style" && te.getAttribute("slot") !== "content");
  }
  getContent() {
    return this.content && h$1("cosmos-text-9-11-1", { size: "x-small", weight: "medium", exportparts: "base: text" }, this.content);
  }
  determineIfTooltipHasContent() {
    const te = hasNamedSlot(this.element, "content");
    this.hasContent = !isNil(this.content) && this.content !== "" || te;
  }
  /**
   * Since the follow value can be a string or a boolean, we need to normalize it
   * and split it since in tippy follow and sticky are two different options.
   */
  normalizeFollowValue() {
    return ["true", "", "cursor"].includes(this.follow);
  }
  componentWillLoad() {
    this.instantiateTooltip(), resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "dark", light: "light" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  componentDidLoad() {
    this.createTooltip(), this.createObserver();
  }
  componentWillRender() {
    this.normalizedFollowValue = this.normalizeFollowValue(), this.determineIfTooltipHasContent();
  }
  disconnectedCallback() {
    var te, ee;
    this.removeTooltipListeners(), (te = this.tooltipInstance) === null || te === void 0 || te.destroy(), (ee = this.observer) === null || ee === void 0 || ee.disconnect();
  }
  render() {
    return h$1(Host, { key: "f228f8ceddddba1f81c4ad05f0703b83f139b1e3" }, h$1("div", { key: "b62055d09e5d357befa652191b7bcb4ca706d950", class: "tippy-mount", ref: (te) => this.tippyMount = te }), h$1("div", { key: "e4b9bc0c563232fcec0338f68fda4f68984c19a3", class: "tippy-element", ref: (te) => this.tippyElement = te }, h$1("div", { key: "fe7afbb87f2c4cba395db00aeddc5ad1a3ed1823", class: generateClassNames({
      spacing: this.spacing,
      appearance: this.computedAppearance,
      unreachable: this.unreachable,
      empty: !this.hasContent
    }), part: "base" }, h$1("cosmos-mode-9-11-1", { key: "86854d5ca81c0cc587b8994f33b7e6bd31fd8237", mode: this.computedAppearance }, h$1("span", { key: "126be6c7efadaaa318e4aca786eacf21db441497" }, h$1("slot", { key: "a339e58341710aaafabc3790d0adb756e3577f70", name: "content", onSlotchange: () => this.determineIfTooltipHasContent() }, this.getContent()))))), h$1("slot", { key: "075d63b5e685718049f215f4c8841dff581884b2", onSlotchange: this.onDefaultSlotChange }));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      visible: ["handleShowChange"],
      content: ["handleContentChange"]
    };
  }
  static get style() {
    return CosmosTooltip9111Style0;
  }
}, [1, "cosmos-tooltip-9-11-1", {
  appearance: [513],
  content: [513],
  controlled: [516],
  follow: [520],
  offset: [514],
  placement: [513],
  spacing: [513],
  unreachable: [516],
  visible: [516],
  computedAppearance: [32],
  hasContent: [32],
  update: [64]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  visible: ["handleShowChange"],
  content: ["handleContentChange"]
}]);
function defineCustomElement$1() {
  if (typeof customElements > "u")
    return;
  ["cosmos-tooltip-9-11-1", "cosmos-mode-9-11-1", "cosmos-text-9-11-1"].forEach((te) => {
    switch (te) {
      case "cosmos-tooltip-9-11-1":
        customElements.get(te) || customElements.define(te, CosmosTooltip$1);
        break;
      case "cosmos-mode-9-11-1":
        customElements.get(te) || defineCustomElement$P();
        break;
      case "cosmos-text-9-11-1":
        customElements.get(te) || defineCustomElement$Y();
        break;
    }
  });
}
const defineCustomElement = defineCustomElement$1, CosmosButton = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-button-9-11-1",
  defaultProps: { busy: !1, decorative: !1, disabled: !1, hovered: !1, href: void 0, iconPlacement: "before", kind: "primary", size: "medium", type: "button", width: "content" },
  defineCustomElement: defineCustomElement$U
}), CosmosCheckbox = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-checkbox-9-11-1",
  defaultProps: { checked: !1, hitArea: "content", invalid: !1, required: !1 },
  defineCustomElement: defineCustomElement$R
}), CosmosIconAirplay = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-airplay-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$N
}), CosmosIconAudioSettings = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-audio-settings-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$M
}), CosmosIconBack10 = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-back-10-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$L
}), CosmosIconBrowse = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-browse-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$K
}), CosmosIconChevronLeft = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-chevron-left-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$J
}), CosmosIconChevronRight = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-chevron-right-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$I
}), CosmosIconClock = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-clock-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$H
}), CosmosIconClose = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-close-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$F
}), CosmosIconCodeBlock = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-code-block-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$E
}), CosmosIconErrorFilled = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-error-filled-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$D
}), CosmosIconEventDetails = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-event-details-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$C
}), CosmosIconFacebook = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-facebook-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$B
}), CosmosIconForward10 = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-forward-10-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$A
}), CosmosIconFullscreen = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-fullscreen-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$z
}), CosmosIconFullscreenExit = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-fullscreen-exit-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$y
}), CosmosIconLink = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-link-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$x
}), CosmosIconLive = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-live-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$w
}), CosmosIconLiveBroadcast = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-live-broadcast-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$v
}), CosmosIconMute = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-mute-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$u
}), CosmosIconNoData = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-no-data-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$t
}), CosmosIconPause = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-pause-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$s
}), CosmosIconPictureInPicture = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-picture-in-picture-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$r
}), CosmosIconPinterest = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-pinterest-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$q
}), CosmosIconPlay = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-play-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$o
}), CosmosIconPreview = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-preview-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$n
}), CosmosIconProductPlacement = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-product-placement-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$m
}), CosmosIconQuality = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-quality-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$l
}), CosmosIconReddit = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-reddit-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$k
}), CosmosIconReplay = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-replay-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$j
}), CosmosIconSeason = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-season-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$i
}), CosmosIconSettings = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-settings-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$h
}), CosmosIconSkipNext = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-skip-next-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$g
}), CosmosIconStop = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-stop-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$f
}), CosmosIconSubtitles = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-subtitles-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$e
}), CosmosIconVolume = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-volume-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$d
}), CosmosIconVolumeLow = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-volume-low-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$c
}), CosmosIconVolumeMid = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-volume-mid-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$b
}), CosmosIconX = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-x-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$a
}), CosmosLink = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-link-9-11-1",
  defaultProps: { kind: "underlined" },
  defineCustomElement: defineCustomElement$9
}), CosmosMediaPreview = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-media-preview-9-11-1",
  defaultProps: { radius: "none" },
  defineCustomElement: defineCustomElement$8
}), CosmosMode = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-mode-9-11-1",
  defaultProps: { mode: "light" },
  defineCustomElement: defineCustomElement$7
}), CosmosRadio = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-radio-9-11-1",
  defaultProps: { checked: !1, disabled: !1, focusable: !0, hitArea: "content", invalid: !1, required: !1 },
  defineCustomElement: defineCustomElement$6
}), CosmosRadioGroup = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-radio-group-9-11-1",
  defaultProps: { invalid: !1 },
  defineCustomElement: defineCustomElement$5
}), CosmosSpinner = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-spinner-9-11-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$4
}), CosmosText = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-text-9-11-1",
  defaultProps: { kind: "normal", size: "medium", spacing: "none", tag: "p", weight: "regular" },
  defineCustomElement: defineCustomElement$3
}), CosmosTitle = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-title-9-11-1",
  defaultProps: { kind: "normal", size: "medium", spacing: "none", tag: "p", weight: "bold" },
  defineCustomElement: defineCustomElement$2
}), CosmosTooltip = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-tooltip-9-11-1",
  defaultProps: { content: "", controlled: !1, follow: !1, offset: 8, placement: "above", spacing: "tight", unreachable: !1, visible: !1 },
  defineCustomElement
});
function convertToLocalizedDateString(re) {
  return new Date(re).toLocaleDateString(window.navigator.language, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  });
}
function serverErrorResolver(re) {
  var ne, ie, ae;
  const te = re.playabilityErrors, ee = re.playabilityErrorDetails;
  if (te.includes("DATE_RANGE_UNKNOWN"))
    return { description: translate("error-default-message") };
  if (te.includes("NO_LONGER_AVAILABLE"))
    return {
      title: translate("error-missed-title"),
      description: translate("error-missed-message")
    };
  if (te.includes("GEO_BLOCKED"))
    return {
      title: translate("error-geo-title"),
      description: translate("error-geo-message")
    };
  if (te.includes("NOT_YET_AVAILABLE")) {
    const ce = (ne = ee == null ? void 0 : ee.NOT_YET_AVAILABLE) != null && ne.availableFrom ? convertToLocalizedDateString(ee.NOT_YET_AVAILABLE.availableFrom) : "N/A";
    return {
      title: translate("error-upcoming-title"),
      description: translate("error-upcoming-message", { localizedDate: ce })
    };
  }
  return te.includes("FSK_BLOCKED") ? {
    title: translate("error-fsk-title", { age: ((ie = ee == null ? void 0 : ee.FSK_BLOCKED) == null ? void 0 : ie.minAge.toString()) ?? "" }),
    description: translate("error-fsk-message", {
      hour: ((ae = ee == null ? void 0 : ee.FSK_BLOCKED) == null ? void 0 : ae.minEveningHour.toString()) ?? ""
    })
  } : { description: translate("error-default-message") };
}
function errorDescriptionResolver(re) {
  return re ? re.playerErrorCode === "NOT_AUTHORIZED" ? {
    description: translate("error-unauthorized-message"),
    title: translate("error-unauthorized-title")
  } : re.playerErrorCode ? { description: translate("error-default-message") } : re.serverErrorDetails ? serverErrorResolver(re.serverErrorDetails) : { description: translate("error-default-message") } : { description: translate("error-default-message") };
}
const ErrorDisplay = () => {
  const {
    playerState: { currentErrorDetails: re }
  } = usePlayerContext(), [te, ee] = h$2(areTranslationsLoaded());
  onTranslationDataLoaded(() => ee(!0));
  const ne = !!re, ie = errorDescriptionResolver(re);
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ne && /* @__PURE__ */ Cn.createElement("div", { class: "error-display" }, /* @__PURE__ */ Cn.createElement("div", { class: "error-display__description" }, /* @__PURE__ */ Cn.createElement("div", { class: "error-display__icon-container" }, /* @__PURE__ */ Cn.createElement(CosmosIconErrorFilled, { "data-rbup-icon-error-filled": !0, class: "error-display__icon" })), /* @__PURE__ */ Cn.createElement("div", { class: "error-display__text-container" }, ie.title && /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "rbup-error-display-title": !0,
      class: "error-display__text",
      weight: "bold",
      appearance: "light",
      size: "medium"
    },
    ie.title
  ), ie.description && /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "rbup-error-display-description": !0,
      class: "error-display__text",
      weight: "regular",
      appearance: "light",
      size: "x-small"
    },
    ie.description
  )))));
}, useGlobalKeyboardNavigation = (re, te) => {
  p(() => {
    if (re === "ACTIVE") {
      const ee = (ne) => {
        ne.target === window.document.body && te(ne);
      };
      return window.document.addEventListener("keydown", ee), () => window.document.removeEventListener("keydown", ee);
    }
  }, [re, te]);
};
function preventEventHandling(re) {
  var ne;
  const te = isLiveLinearResolver(re), ee = (ne = re.getPlayerData()) == null ? void 0 : ne.isShowingAd();
  return te || ee;
}
function handleSeekForward(re) {
  preventEventHandling(re) || re.canSeekOrTimeshiftForward() && re.seekOrTimeshiftRelative(DEFAULT_SEEK_SKIP_SECONDS);
}
function handleSeekBackward(re) {
  preventEventHandling(re) || re.canSeekOrTimeshiftBackward() && re.seekOrTimeshiftRelative(-DEFAULT_SEEK_SKIP_SECONDS);
}
function handleVolumeChange(re, te) {
  const ne = re.getVolume() * te;
  re.setVolume(ne);
}
function handleVolumeDown(re) {
  handleVolumeChange(re, 0.95);
}
function handleVolumeUp(re) {
  handleVolumeChange(re, 1.05);
}
function handleToggleFullscreen(re) {
  re.toggleFullscreen();
}
function handleTogglePictureInPicture(re) {
  re.togglePictureInPicture();
}
function handleMuted(re) {
  const te = re.isMuted();
  re.setMuted(!te);
}
function handleSeekToBeginning(re) {
  re.seek(0);
}
function handleTogglePlayback(re) {
  if (preventEventHandling(re))
    return;
  const te = re.getPlayerStatus();
  handlePlayPauseToggle(te, re);
}
async function handleSwitchToPreviewStream(re) {
  await handleSwitchStream(re, -1);
}
async function handleSwitchToNextStream(re) {
  await handleSwitchStream(re, 1);
}
async function handleSwitchStream(re, te) {
  var se;
  const ee = ((se = re.getPlayerData()) == null ? void 0 : se.getCurrentTimeInSec()) ?? 0, ne = re.getPlayerConfiguration(), { assetId: ie, multiStreamAssets: ae } = ne;
  if (!ae)
    return;
  const ce = ae.findIndex((oe) => oe.assetId === ie);
  if (ce === -1)
    return;
  const he = ae.length, _e = (ce + he + te) % he, le = ae[_e];
  await re.load({
    ...ne,
    assetId: le.assetId,
    initialSeekTimeInSec: ee
  }), await re.play();
}
const keyboardEventHandler = {
  [KEYCODE_ARROW_DOWN]: handleVolumeDown,
  [KEYCODE_ARROW_LEFT]: handleSeekBackward,
  [KEYCODE_ARROW_RIGHT]: handleSeekForward,
  [KEYCODE_ARROW_UP]: handleVolumeUp,
  [KEYCODE_F]: handleToggleFullscreen,
  [KEYCODE_I]: handleTogglePictureInPicture,
  [KEYCODE_K]: handleTogglePlayback,
  [KEYCODE_M]: handleMuted,
  [KEYCODE_N]: handleSwitchToNextStream,
  [KEYCODE_P]: handleSwitchToPreviewStream,
  [KEYCODE_0]: handleSeekToBeginning,
  [KEYCODE_SPACE]: handleTogglePlayback
};
async function handleKeyboardEvent(re, te) {
  if (!te)
    return;
  const ee = keyboardEventHandler == null ? void 0 : keyboardEventHandler[re.key];
  ee && (re.preventDefault(), ee(te));
}
function useScrubBarEventHandling(re, te, ee, ne, ie, ae) {
  var Ue;
  const [ce, he] = h$2(
    ((Ue = te == null ? void 0 : te.getPlayerData()) == null ? void 0 : Ue.getCurrentTimeInSec()) ?? 0
  ), [_e, le] = h$2((te == null ? void 0 : te.getDurationInSec()) ?? 0), [se, oe] = h$2((te == null ? void 0 : te.getBufferLengthInSec()) ?? 0), [ue, be] = h$2(0), [ve, me] = h$2(!1), [pe, fe] = h$2(!1), [ge, ye] = h$2(!1), $e = ge && !ae, Se = _({ x: 0, y: 0 }), Ce = T$1(
    (Re) => extractPlaybackPositionInPercentFromEvent(Re, re) ?? 0,
    [re]
  ), Ie = T$1(
    (Re) => {
      const Ne = roundPlaybackSec(Re * _e);
      he(Ne), ne(Re, Ne);
    },
    [_e, ne]
  ), Te = T$1((Re) => {
    const Ne = Se.current, xe = getPositionFromEvent(Re), ke = hasPositionMoved(Ne, xe);
    return Se.current = xe, ke;
  }, []), Ee = T$1(
    (Re) => {
      be(Ce(Re));
    },
    [Ce]
  ), we = T$1(
    (Re) => {
      const Ne = Ce(Re);
      isNaN(_e) || (be(Ne), Ie(Ne), Re.stopPropagation(), Re.preventDefault()), ie(!1), me(!1);
      const xe = Re.currentTarget;
      xe instanceof HTMLElement && "pointerId" in Re && xe.releasePointerCapture(Re.pointerId), document.removeEventListener("pointermove", Ee), document.removeEventListener("pointerup", we), ye(!1);
    },
    [
      _e,
      Ce,
      Ee,
      ie,
      Ie,
      ye
    ]
  ), Pe = T$1(() => {
    ve || ye(!1), fe(!1);
  }, [ve, ye]), Me = T$1(() => {
    fe(!0);
  }, []), Ae = T$1(
    (Re) => {
      document.addEventListener("pointermove", Ee), document.addEventListener("pointerup", we);
      const Ne = Re.currentTarget;
      Ne instanceof HTMLElement && "pointerId" in Re && Ne.setPointerCapture(Re.pointerId), me(!0), ye(!0), Ee(Re), ie(!0);
    },
    [Ee, we, ie, ye]
  ), Oe = T$1(
    (Re) => {
      ve && Re.preventDefault();
      const Ne = Ce(Re);
      be(Ne), Te(Re) && ye(!0);
    },
    [ve, Ce, Te, ye]
  );
  useSmoothScrubBarAnimation(ee, he, oe, te), p(() => {
    const Re = (Ne) => {
      var ke, Le;
      switch (Ne.type) {
        case "seeking": {
          const He = ((ke = te == null ? void 0 : te.getPlayerData()) == null ? void 0 : ke.getCurrentTimeInSec()) ?? 0;
          he(He), oe(te == null ? void 0 : te.getBufferLengthInSec());
          break;
        }
        case "loaded":
        case "play": {
          const He = ((Le = te == null ? void 0 : te.getPlayerData()) == null ? void 0 : Le.getCurrentTimeInSec()) ?? 0;
          le(te == null ? void 0 : te.getDurationInSec()), oe((te == null ? void 0 : te.getBufferLengthInSec()) ?? 0), he(He);
          break;
        }
      }
      const xe = te == null ? void 0 : te.getDurationInSec();
      le(xe);
    };
    return te == null || te.addEventListener(Re), () => {
      te == null || te.removeEventListener(Re);
    };
  }, [te]);
  const Be = F$1(() => _e === 0 ? 0 : roundPlaybackPercentage(se / _e), [se, _e]), Ve = F$1(() => {
    if (_e === 0)
      return 0;
    const Re = roundPlaybackPercentage(ce / _e);
    return isNaN(Re) ? 0 : Re;
  }, [ce, _e]);
  return {
    onDocumentPointerUp: we,
    onPointerLeave: Pe,
    onPointerOver: Me,
    onPointerDown: Ae,
    onPointerMove: Oe,
    bufferDurationPercent: Be,
    playbackPositionInPercent: Ve,
    isDragging: ve,
    draggedPlaybackPositionInPercent: ue,
    durationInSec: _e,
    playbackPositionInSec: ce,
    hovered: pe,
    showHandle: $e
  };
}
const POSTROLL_AD_MARKER = -1, PREROLL_AD_MARKER = 0, OPEN_HEIGHT = 0, CLOSED_HEIGHT = 2, MARKER_WIDTH = "4px";
function calculateAdMarkers(re, te) {
  const ee = [], ne = (re == null ? void 0 : re.length) ?? 0;
  if (!(!re || ne === 0 || te === 0))
    return re.forEach((ie) => {
      let ae, ce;
      ie === PREROLL_AD_MARKER ? (ae = "0%", ce = MARKER_WIDTH) : ie === POSTROLL_AD_MARKER ? (ae = `calc(100% - ${MARKER_WIDTH})`, ce = "100%") : (ae = `${ie * 100 / te}%`, ce = `calc(${ae} + ${MARKER_WIDTH})`), drawMarkers(ee, ae, ce);
    }), `polygon(
	${ee.join(`,
	`)}
);`;
}
function drawMarkers(re, te, ee) {
  const ne = `${te} ${OPEN_HEIGHT}px`, ie = `${ee} ${OPEN_HEIGHT}px`, ae = `${ee} ${CLOSED_HEIGHT}px`, ce = `${te} ${CLOSED_HEIGHT}px`;
  re.push(ne, ie, ae, ce, ne);
}
const AdMarkers = x(({ adCuePoints: re, durationInSec: te }) => {
  const ee = calculateAdMarkers(re, te);
  return ee ? /* @__PURE__ */ Cn.createElement("div", { class: "ad-markers" }, /* @__PURE__ */ Cn.createElement("div", { class: "ad-markers__background-container", style: `clip-path: ${ee}` })) : null;
}), ProgressBar = ({ calculatedPositionPercent: re }) => /* @__PURE__ */ Cn.createElement(
  "div",
  {
    "data-rbup-scrub-bar-progress": !0,
    class: "progress-bar",
    style: { width: `${re * 100}%` }
  }
), SeekBarHandle = ({ playbackPositionInPercent: re }) => /* @__PURE__ */ Cn.createElement("div", { "data-rbup-seek-bar-handle": !0, class: "seek-bar-handle", style: { left: `${re * 100}%` } }, /* @__PURE__ */ Cn.createElement("div", { class: "seek-bar-handle__knob" }));
function formatPlaybackPosition(re, te) {
  if (re > 0)
    return getFormattedTimeString(re * te);
  const ee = Math.abs(re), ne = ee - ee * te;
  return `${ne > 0 ? "-" : ""}${getFormattedTimeString(ne)}`;
}
const SeekBarTooltip = ({
  durationInSec: re,
  positionInPercent: te,
  segmentTitle: ee,
  showTooltip: ne,
  sizeBreakpoints: ie
}) => {
  const {
    playerState: { playerCoordinator: ae, isVRVideo: ce }
  } = usePlayerContext(), he = _(null), _e = _(null), le = _(null), [se, oe] = h$2(!ce), ue = formatPlaybackPosition(re, te);
  p(() => {
    (async () => {
      const me = Math.floor(re * te), pe = await (ae == null ? void 0 : ae.setThumbnail(
        {
          imgContainerElement: he.current,
          imgElement: _e.current,
          textContainerElement: le.current
        },
        {
          smallOrBigger: ie.smallOrBigger,
          mediumOrBigger: ie.mediumOrBigger
        },
        me
      )) ?? !1;
      oe(pe);
    })();
  }, [
    re,
    ce,
    ae,
    te,
    ie.smallOrBigger,
    ie.mediumOrBigger
  ]);
  const be = [
    "seek-bar-tooltip",
    ne && "seek-bar-tooltip--visible",
    se && "seek-bar-tooltip--with-thumbnail",
    ee && "seek-bar-tooltip--with-segments"
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ Cn.createElement("div", { "data-rbup-seek-bar-tooltip": !0, class: be }, se && /* @__PURE__ */ Cn.createElement("div", { class: "seek-bar-tooltip__image-container", ref: he }, /* @__PURE__ */ Cn.createElement(
    "img",
    {
      class: "seek-bar-tooltip__image",
      "data-rbup-seek-bar-thumbnail": !0,
      ref: _e,
      alt: "preview thumbnail"
    }
  )), /* @__PURE__ */ Cn.createElement("div", { class: "seek-bar-tooltip__text", ref: le }, ee && /* @__PURE__ */ Cn.createElement(CosmosText, { "data-rbup-text": !0, size: "xx-small", weight: "medium" }, ee), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-text": !0,
      class: "seek-bar-tooltip__position",
      "data-rbup-seek-bar-tooltip": !0,
      kind: "subtle",
      size: "xx-small",
      weight: "medium"
    },
    ue
  )));
}, SeekBar = ({
  durationInSec: re,
  playbackPositionInPercent: te,
  segmentTitle: ee,
  showHandle: ne,
  sizeBreakpoints: ie,
  tooltipPositionInPercent: ae
}) => isMobileDevice() ? /* @__PURE__ */ Cn.createElement("div", { "data-rbup-seek-bar": !0, class: "seek-bar" }, /* @__PURE__ */ Cn.createElement("div", { class: `seek-bar__handle-container ${ne ? "seek-bar__handle-container_visible" : ""}` }, /* @__PURE__ */ Cn.createElement(
  CosmosTooltip,
  {
    class: "seek-bar__cosmos-tooltip",
    controlled: !0,
    follow: "target",
    unreachable: !0,
    visible: ne
  },
  /* @__PURE__ */ Cn.createElement("div", { slot: "content" }, /* @__PURE__ */ Cn.createElement(
    SeekBarTooltip,
    {
      "data-rbup-seek-bar-tool-tip": !0,
      durationInSec: re,
      positionInPercent: ae,
      showTooltip: ne,
      segmentTitle: ee,
      sizeBreakpoints: ie
    }
  )),
  /* @__PURE__ */ Cn.createElement(
    SeekBarHandle,
    {
      "data-rbup-seek-bar-handle": !0,
      playbackPositionInPercent: te
    }
  )
))) : /* @__PURE__ */ Cn.createElement(
  CosmosTooltip,
  {
    class: "seek-bar__cosmos-tooltip",
    controlled: !0,
    follow: !0,
    unreachable: !0,
    visible: ne
  },
  /* @__PURE__ */ Cn.createElement("div", { slot: "content" }, /* @__PURE__ */ Cn.createElement(
    SeekBarTooltip,
    {
      "data-rbup-seek-bar-tool-tip": !0,
      durationInSec: re,
      positionInPercent: ae,
      segmentTitle: ee,
      showTooltip: ne,
      sizeBreakpoints: ie
    }
  )),
  /* @__PURE__ */ Cn.createElement("div", { "data-rbup-seek-bar": !0, class: "seek-bar" }, /* @__PURE__ */ Cn.createElement("div", { class: `seek-bar__handle-container ${ne ? "seek-bar__handle-container_visible" : ""}` }, /* @__PURE__ */ Cn.createElement(SeekBarHandle, { "data-rbup-seek-bar-handle": !0, playbackPositionInPercent: te })))
), DvrScrubBar = ({
  onDragStatusChanged: re,
  sizeBreakpoints: te,
  hideScrubBarTooltip: ee
}) => {
  const {
    playerState: {
      playerCoordinator: ne,
      playerConfiguration: ie,
      playerStatus: ae,
      maxTimeShiftInSec: ce,
      timeShiftInSec: he,
      durationInSec: _e
    }
  } = usePlayerContext(), le = ne == null ? void 0 : ne.getAdCuePoints(), se = ie == null ? void 0 : ie.adMarkerEnabled, [oe, ue] = h$2(
    (ne == null ? void 0 : ne.getTimeShiftInSec()) ?? 0
  ), be = _(null);
  p(() => {
    ue(he);
  }, [he]);
  const ve = T$1(
    (we, Pe) => {
      const Me = ce * (1 - we);
      ne == null || ne.timeShift(Me);
    },
    [ce, ne]
  ), me = F$1(() => ce === 0 ? 1 : 1 - roundPlaybackPercentage(oe / ce), [oe, ce]), {
    onDocumentPointerUp: pe,
    onPointerLeave: fe,
    onPointerOver: ge,
    onPointerDown: ye,
    onPointerMove: $e,
    draggedPlaybackPositionInPercent: Se,
    hovered: Ce,
    isDragging: Ie,
    showHandle: Te
  } = useScrubBarEventHandling(
    be,
    ne,
    ae,
    ve,
    re,
    ee
  ), Ee = Ie ? Se : me;
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-hovered": `${Ce}`,
      "data-rbup-dvr-scrub-bar": !0,
      class: "scrub-bar",
      ref: be,
      onPointerDown: ye,
      onPointerLeave: fe,
      onPointerMove: $e,
      onPointerOver: ge,
      onPointerUp: pe,
      onTouchMove: $e
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "scrub-bar__rail" }),
    /* @__PURE__ */ Cn.createElement(ProgressBar, { calculatedPositionPercent: me }),
    se === "ACTIVE" ? /* @__PURE__ */ Cn.createElement(AdMarkers, { adCuePoints: le, durationInSec: _e }) : null,
    /* @__PURE__ */ Cn.createElement(
      SeekBar,
      {
        durationInSec: ce,
        playbackPositionInPercent: Ee,
        showHandle: Te,
        sizeBreakpoints: te,
        tooltipPositionInPercent: Se
      }
    )
  );
};
function resolveTagAttributeValue(re) {
  return re ? "" : null;
}
function calculateClipPolygon({ segments: re, hoverSegmentIndex: te, scrubBarWidthInPx: ee }) {
  let ne = "polygon(";
  const ae = ee > 0 ? 200 / ee : 0, ce = 6, he = 3, _e = 8, le = 11, se = 15, oe = (re == null ? void 0 : re.length) ?? 0;
  if (!(!re || oe === 0)) {
    re.forEach((ue, be) => {
      const ve = be === te, me = ue.segmentStart.percentage * 100, pe = ue.segmentEnd.percentage * 100 - ae, fe = ue.segmentEnd.percentage * 100;
      if (pe < me)
        return;
      be > 0 && (ne += `,
`);
      const ge = ve ? he : ce;
      ne += `${me}% ${ge}px,
${pe}% ${ge}px,
${pe}% ${se}px,
${fe}% ${se}px`;
    });
    for (let ue = oe - 1; ue >= 0; ue--) {
      const be = ue === te, ve = re[ue], me = ve.segmentStart.percentage * 100, pe = ve.segmentEnd.percentage * 100 - ae, fe = ve.segmentEnd.percentage * 100;
      if (pe < me)
        continue;
      const ge = be ? le : _e;
      ne += `,
${fe}% ${se}px,
${pe}% ${se}px,
 ${pe}% ${ge}px,
${me}% ${ge}px`;
    }
    return ne += ")", ne;
  }
}
function calculateSegments({ durationInSec: re, markers: te }) {
  if (!te || te.length === 0)
    return [];
  let ee;
  const ne = [];
  if (te[0].positionInSec > 0) {
    const ae = {
      segmentStart: { percentage: 0, positionInSec: 0 },
      // segmentEnd will be corrected in the loop
      segmentEnd: { percentage: 0, positionInSec: 0 }
    };
    ne.push(ae), ee = ae;
  }
  return te.forEach((ae) => {
    const ce = {
      percentage: ae.positionInSec / re,
      positionInSec: ae.positionInSec
    }, he = {
      segmentStart: ce,
      segmentEnd: { percentage: 1, positionInSec: re },
      title: ae.title
    };
    ee && (ee.segmentEnd = ce), ee = he, ne.push(he);
  }), ne;
}
function useVideoChapterMarkers(re, te, ee, ne) {
  const ie = F$1(
    () => calculateSegments({ durationInSec: re, markers: te }),
    [re, te]
  ), ae = F$1(
    () => ie.findIndex(
      (se) => ee >= se.segmentStart.percentage && ee <= se.segmentEnd.percentage
    ),
    [ee, ie]
  ), [ce, he] = h$2(0);
  useResize((se) => he(se.width), ne);
  const _e = F$1(
    () => calculateClipPolygon({
      scrubBarWidthInPx: ce,
      segments: ie,
      hoverSegmentIndex: ae
    }),
    [ie, ae, ce]
  ), le = ie.length > 0 ? ie[ae] : void 0;
  return { segments: ie, polygonString: _e, hoveredSegment: le };
}
const BufferBar = ({ calculatedPositionPercent: re, bufferedPercent: te }) => {
  const ee = Math.min(re + te, 1);
  return /* @__PURE__ */ Cn.createElement("div", { class: "buffer-bar", "data-rbup-scrub-bar-buffer": !0, style: { width: `${ee * 100}%` } });
}, VodScrubBar = ({
  onDragStatusChanged: re,
  sizeBreakpoints: te,
  hideScrubBarTooltip: ee
}) => {
  const ne = _(null), {
    playerState: { playerCoordinator: ie, playerStatus: ae, mediaMetaData: ce, playerConfiguration: he }
  } = usePlayerContext(), _e = ie == null ? void 0 : ie.getAdCuePoints(), le = he == null ? void 0 : he.adMarkerEnabled, se = T$1(
    (we, Pe) => {
      ie == null || ie.seek(Pe);
    },
    [ie]
  ), {
    onDocumentPointerUp: oe,
    onPointerLeave: ue,
    onPointerOver: be,
    onPointerDown: ve,
    onPointerMove: me,
    bufferDurationPercent: pe,
    playbackPositionInPercent: fe,
    isDragging: ge,
    draggedPlaybackPositionInPercent: ye,
    durationInSec: $e,
    hovered: Se,
    showHandle: Ce
  } = useScrubBarEventHandling(
    ne,
    ie,
    ae,
    se,
    re,
    ee
  ), { polygonString: Ie, hoveredSegment: Te } = useVideoChapterMarkers(
    $e,
    ce == null ? void 0 : ce.videoChapterMarkers,
    ye,
    ne
  ), Ee = ge ? ye : fe;
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-hovered": resolveTagAttributeValue(Se),
      class: "scrub-bar",
      "data-rbup-scrub-bar": !0,
      ref: ne,
      onPointerDown: ve,
      onPointerLeave: ue,
      onPointerMove: me,
      onPointerOver: be,
      onPointerUp: oe,
      onTouchMove: me
    },
    /* @__PURE__ */ Cn.createElement(
      "div",
      {
        class: "scrub-bar__background-container",
        style: {
          clipPath: Ie
        }
      },
      /* @__PURE__ */ Cn.createElement("div", { class: "scrub-bar__rail" }),
      /* @__PURE__ */ Cn.createElement(
        BufferBar,
        {
          calculatedPositionPercent: fe,
          bufferedPercent: pe
        }
      ),
      /* @__PURE__ */ Cn.createElement(ProgressBar, { calculatedPositionPercent: fe }),
      le === "ACTIVE" ? /* @__PURE__ */ Cn.createElement(AdMarkers, { adCuePoints: _e, durationInSec: $e }) : null
    ),
    /* @__PURE__ */ Cn.createElement(
      SeekBar,
      {
        durationInSec: $e,
        playbackPositionInPercent: Ee,
        segmentTitle: Te == null ? void 0 : Te.title,
        showHandle: Ce,
        sizeBreakpoints: te,
        tooltipPositionInPercent: ye
      }
    )
  );
}, ScrubBar = ({
  onDragStatusChanged: re,
  sizeBreakpoints: te,
  hideScrubBarTooltip: ee,
  onControlsElementEnter: ne
}) => {
  const {
    playerState: { playbackMode: ie, liveVariant: ae }
  } = usePlayerContext(), ce = ie === "LIVE" && ae === "DVR";
  return /* @__PURE__ */ Cn.createElement("div", { onPointerEnterCapture: (he) => ne == null ? void 0 : ne(he, !0) }, ie === "VOD" && /* @__PURE__ */ Cn.createElement(
    VodScrubBar,
    {
      sizeBreakpoints: te,
      onDragStatusChanged: re,
      hideScrubBarTooltip: ee
    }
  ), ce && /* @__PURE__ */ Cn.createElement(
    DvrScrubBar,
    {
      sizeBreakpoints: te,
      onDragStatusChanged: re,
      hideScrubBarTooltip: ee
    }
  ));
};
function useClickOutside(re, te) {
  const ee = (ne) => {
    re.current && !re.current.contains(ne.target) && te(ne);
  };
  p(() => (document.addEventListener("pointerup", ee), () => {
    document.removeEventListener("pointerup", ee);
  }));
}
const RadioButtonInternal = ({ name: re, checked: te, label: ee, onClick: ne, value: ie, appearance: ae, className: ce }, he) => {
  const _e = _$1(), le = T$1(
    (oe) => {
      oe.stopPropagation(), ne == null || ne();
    },
    [ne]
  ), se = F$1(() => ({
    focus() {
      te && _e.current.base.inputFocus().catch((ue) => console.error("Could not set focus on CosmosRadio", ue));
    }
  }), [te, _e]);
  return A$1(he, () => se, [se]), /* @__PURE__ */ Cn.createElement(
    CosmosRadio,
    {
      ref: _e,
      "data-rbup-radio-button": !0,
      "data-exposed-checked": resolveTagAttributeValue(te),
      "data-exposed-value": ie,
      class: ce,
      name: re,
      checked: te,
      value: ie,
      appearance: ae,
      onInputchange: le,
      "hit-area": "row"
    },
    ee
  );
}, RadioButton = k(RadioButtonInternal), AudioSettings = ({
  isPlayerSizeMedium: re,
  focusOnSelectedRadioButton: te
}) => {
  const {
    playerState: { audioTracks: ee, playerCoordinator: ne, selectedAudioTrack: ie }
  } = usePlayerContext();
  useInformPlaywright("Audio menu rendered");
  const ae = F$1(() => [...ee], [ee]), ce = (le) => ne == null ? void 0 : ne.setAudioTrack(le), he = ae.map(
    (le) => {
      const se = le.id === (ie == null ? void 0 : ie.id), oe = _$1(), ue = /* @__PURE__ */ Cn.createElement(
        RadioButton,
        {
          ref: oe,
          className: "audio-settings__list-item",
          key: le.id,
          name: "audio-track",
          label: le.label,
          checked: se,
          value: le.id,
          onClick: () => ce(le.id)
        }
      );
      return {
        radioButtonRef: oe,
        radioButton: ue
      };
    }
  ), _e = _(!1);
  return p(() => {
    te && _e.current === !1 && he.forEach((le) => {
      const se = le.radioButtonRef.current;
      se && (se.focus(), _e.current = !0);
    });
  }, [te, he]), /* @__PURE__ */ Cn.createElement("div", { class: "audio-settings" }, /* @__PURE__ */ Cn.createElement(CosmosRadioGroup, { class: "audio-settings__list", appearance: re ? "dark" : "light" }, he.map((le) => le.radioButton)));
};
function preventEventPropagation$3(re) {
  re.stopPropagation();
}
const AudioMenu = ({ onCloseMenu: re }) => {
  const te = _(null);
  useClickOutside(te, re);
  const ee = (ne) => {
    ne.stopPropagation(), ne.key === KEYCODE_ESC && re(ne);
  };
  return /* @__PURE__ */ Cn.createElement(
    "section",
    {
      ref: te,
      "data-rbup-audio-menu": !0,
      role: "dialog",
      "aria-labelledby": "rbupAudioMenuTitle",
      class: "audio-menu",
      onPointerUp: preventEventPropagation$3,
      onKeyDown: ee
    },
    /* @__PURE__ */ Cn.createElement(CosmosText, { id: "rbupAudioMenuTitle", class: "audio-menu__title", size: "x-small", weight: "bold" }, translate("menu-audioTracks")),
    /* @__PURE__ */ Cn.createElement(AudioSettings, { isPlayerSizeMedium: !0, focusOnSelectedRadioButton: !0 })
  );
}, MultiStreamSettings = ({
  isPlayerSizeMedium: re,
  focusOnSelectedRadioButton: te
}) => {
  const {
    playerState: { playerCoordinator: ee, playerConfiguration: ne, playbackPosInSec: ie }
  } = usePlayerContext();
  useInformPlaywright("Multi stream menu rendered");
  const ae = F$1(() => {
    if (!(ne != null && ne.multiStreamAssets))
      return [];
    const { assetId: _e, multiStreamAssets: le } = ne;
    return le.map(
      (se) => ({
        id: se.assetId,
        label: se.title,
        selected: _e === se.assetId,
        assetId: se.assetId
      })
    );
  }, [ne]), ce = F$1(() => [
    ...ae.map((_e) => {
      const le = _e.selected, se = _$1(), oe = /* @__PURE__ */ Cn.createElement(
        RadioButton,
        {
          ref: se,
          className: "multi-stream-settings__list-item",
          key: _e.id,
          name: "multi-streams",
          label: _e.label,
          checked: le,
          value: _e.id,
          onClick: async () => {
            ne && (await (ee == null ? void 0 : ee.load({
              ...ne,
              assetId: _e.assetId,
              initialSeekTimeInSec: ie
            })), await (ee == null ? void 0 : ee.play()));
          }
        }
      );
      return {
        radioButtonRef: se,
        radioButton: oe
      };
    })
  ], [ae, ie, ne, ee]), he = _(!1);
  return p(() => {
    te && he.current === !1 && ce.forEach((_e) => {
      const le = _e.radioButtonRef.current;
      le && (le.focus(), he.current = !0);
    });
  }, [te, ce]), /* @__PURE__ */ Cn.createElement("div", { class: "multi-stream-settings" }, /* @__PURE__ */ Cn.createElement(CosmosRadioGroup, { class: "multi-stream-settings__list", appearance: re ? "dark" : "light" }, ce.map((_e) => _e.radioButton)));
};
function preventEventPropagation$2(re) {
  re.stopPropagation();
}
const MultiStreamMenu = ({ onCloseMenu: re }) => {
  const te = _(null);
  useClickOutside(te, re);
  const ee = (ne) => {
    ne.stopPropagation(), ne.key === KEYCODE_ESC && re(ne);
  };
  return /* @__PURE__ */ Cn.createElement(
    "section",
    {
      ref: te,
      "data-rbup-multi-stream-menu": !0,
      role: "dialog",
      "aria-labelledby": "rbupMultiStreamMenuTitle",
      class: "multi-stream-menu",
      onPointerUp: preventEventPropagation$2,
      onKeyDown: ee
    },
    /* @__PURE__ */ Cn.createElement(CosmosText, { id: "rbupMultiStreamMenuTitle", class: "multi-stream-menu__title", size: "x-small", weight: "bold" }, translate("menu-multi-stream")),
    /* @__PURE__ */ Cn.createElement(MultiStreamSettings, { isPlayerSizeMedium: !0, focusOnSelectedRadioButton: !0 })
  );
}, BackButtonInternal = ({ onClick: re, text: te }, ee) => /* @__PURE__ */ Cn.createElement("button", { ref: ee, "data-rbup-back-button": !0, class: "back-button", onClick: re }, /* @__PURE__ */ Cn.createElement(CosmosIconChevronLeft, { class: "back-button__icon" }), /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small", weight: "bold" }, te)), BackButton = k(BackButtonInternal), StorageKey$1 = {
  AUDIO_LANGUAGE: "rbup-video-audio-language",
  QUALITY: "rbup-video-quality",
  SUBTITLE_LANGUAGE: "rbup-video-subtitle-language",
  VOLUME: "rbup-video-volume"
};
function setStorageItem$1(re, te, ee) {
  const ne = typeof te == "string" ? te : JSON.stringify(te);
  ee.setItem(re, ne);
}
function setQualityHeight(re, te) {
  setStorageItem$1(StorageKey$1.QUALITY, re, te);
}
const getLabel = (re) => re.label ?? getVideoQualityLabel(re.height, re.frameRate), QualitySettings = ({ isPlayerSizeMedium: re }) => {
  const {
    playerState: { playerCoordinator: te, selectedVideoQuality: ee, videoQualities: ne }
  } = usePlayerContext(), [ie, ae] = h$2(ee), ce = useObjectArrayCache(ne, "id"), he = F$1(() => {
    const _e = [...ce];
    return [
      { id: "auto", label: translate("menu-quality-auto") },
      ..._e.reverse()
    ];
  }, [ce]);
  return useInformPlaywright("Quality menu rendered"), p(() => {
    ie && ie.id !== ee.id && (te == null || te.setVideoQuality(ie.id), setQualityHeight(ie.height, window.sessionStorage));
  }, [te, ie, ee]), /* @__PURE__ */ Cn.createElement("div", { class: "quality-settings", "data-rbup-quality-menu": !0 }, /* @__PURE__ */ Cn.createElement(CosmosRadioGroup, { class: "quality-settings__list", appearance: re ? "dark" : "light" }, he.map((_e) => {
    const le = _e.id === (ie == null ? void 0 : ie.id);
    return /* @__PURE__ */ Cn.createElement(
      RadioButton,
      {
        className: "quality-settings__list-item",
        key: _e.id,
        name: "quality",
        label: getLabel(_e),
        checked: le,
        value: _e.id,
        onClick: () => ae(_e)
      }
    );
  })));
}, MenuButtonInternal = ({ href: re, id: te, onClick: ee, settingText: ne, text: ie }, ae) => {
  const ce = te.toLowerCase();
  return re ? /* @__PURE__ */ Cn.createElement(
    "button",
    {
      "data-rbup-menu-button": ce,
      "data-rbup": `data-rbup-${ce}-menu-button`,
      ref: ae,
      class: "settings-menu-button"
    },
    /* @__PURE__ */ Cn.createElement(CosmosText, { class: "settings-menu-button__label", size: "x-small" }, /* @__PURE__ */ Cn.createElement(CosmosLink, { tabIndex: -1, href: re, kind: "bare", target: "_blank" }, ie))
  ) : /* @__PURE__ */ Cn.createElement(
    "button",
    {
      "data-rbup-menu-button": ce,
      "data-rbup": `data-rbup-${ce}-menu-button`,
      ref: ae,
      class: "settings-menu-button",
      onClick: ee
    },
    /* @__PURE__ */ Cn.createElement(CosmosText, { class: "settings-menu-button__label", size: "x-small" }, ie),
    /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu-button__selected-setting" }, ne && /* @__PURE__ */ Cn.createElement(CosmosText, { size: "xx-small", kind: "subtle" }, ne), /* @__PURE__ */ Cn.createElement(CosmosIconChevronRight, { class: "settings-menu-button__icon" }))
  );
}, MenuButton = k(MenuButtonInternal);
function calculatePlaybackSpeedText(re) {
  return re === 1 ? translate("menu-speeds-normal") : String(re);
}
const SettingsMainMenu = ({ onNavClick: re, mainMenuRef: te }) => {
  const {
    playerState: {
      audioTracks: ee,
      playbackSpeed: ne,
      playerCoordinator: ie,
      selectedVideoQuality: ae,
      subtitleTracks: ce,
      videoQualities: he,
      liveVariant: _e
    }
  } = usePlayerContext(), le = ie == null ? void 0 : ie.getPlayerConfiguration().feedbackUrl, se = (ie == null ? void 0 : ie.getPlayerConfiguration().sharingEnabled) ?? !0, oe = calculatePlaybackSpeedText(ne), ue = getVideoQualityLabel(ae.height, ae.frameRate), be = ae.isAuto ? `Auto ${ue}` : ue, ve = he.length > 1, me = ce.length > 0, pe = _e !== "LINEAR", fe = ee.length > 1, ge = ie == null ? void 0 : ie.getPlayerConfiguration().multiStreamAssets, ye = ge ? ge.length > 1 : !1;
  return /* @__PURE__ */ Cn.createElement("div", { ref: te }, ve && /* @__PURE__ */ Cn.createElement(
    MenuButton,
    {
      id: "quality",
      onClick: () => re("QUALITY"),
      settingText: be,
      text: translate("menu-quality")
    }
  ), pe && /* @__PURE__ */ Cn.createElement(
    MenuButton,
    {
      id: "speed",
      onClick: () => re("SPEED"),
      settingText: oe,
      text: translate("menu-speeds")
    }
  ), me && /* @__PURE__ */ Cn.createElement(MenuButton, { id: "subtitles", onClick: () => re("SUBTITLES"), text: translate("menu-subtitles") }), fe && /* @__PURE__ */ Cn.createElement(MenuButton, { id: "audio", onClick: () => re("AUDIO"), text: translate("menu-audioTracks") }), ye && /* @__PURE__ */ Cn.createElement(MenuButton, { id: "multi-stream", onClick: () => re("MULTI-STREAM"), text: "Multi Stream" }), se && /* @__PURE__ */ Cn.createElement(MenuButton, { id: "share", onClick: () => re("SHARE"), text: translate("menu-sharing") }), le && /* @__PURE__ */ Cn.createElement(MenuButton, { id: "feedback", href: le, text: translate("menu-feedback") }));
};
function useOnMountSize(re, te) {
  const ee = _(0), ne = T$1(
    (ie) => {
      const ae = ie.height;
      ee.current = ae, re == null || re(ae);
    },
    [re]
  );
  useResize(ne, te), p(() => {
    const ie = ee.current;
    ie > 0 && (re == null || re(ie));
  }, [re]);
}
const SettingsWrapper = ({
  children: re,
  cssClass: te,
  enterPosition: ee,
  leavePosition: ne,
  show: ie,
  widthInPx: ae,
  onMounted: ce
}) => {
  const [he, _e] = h$2(!1), le = () => {
    he && !ie && _e(!1);
  };
  p(() => {
    !he && ie && _e(!0);
  }, [he, ie]);
  const oe = { transform: `translateX(-${ie ? ee : ne}px)`, width: ae };
  return /* @__PURE__ */ Cn.createElement("div", { class: te, style: oe, onTransitionEnd: le }, he ? /* @__PURE__ */ Cn.createElement(SettingsView, { onMounted: ce }, re) : null);
}, SettingsView = ({ children: re, onMounted: te }) => {
  const ee = _(null);
  return useOnMountSize(te, ee), /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu__settings-wrapper", ref: ee }, /* @__PURE__ */ Cn.createElement("div", null, re));
}, log$9 = loglevelExports.getLogger("ShareSettingsInternal"), ARROW_KEYS = [KEYCODE_ARROW_LEFT, KEYCODE_ARROW_RIGHT];
function initialShareUrlWithTime(re) {
  return (re == null ? void 0 : re.urlSharingStrategy.calculateShareUrl("PAGE", {
    assetId: re.getPlayerConfiguration().assetId
  })) ?? "";
}
const ShareSettingsInternal = ({ isPlayerSizeMedium: re }) => {
  const {
    playerState: { mediaMetaData: te, playbackPosInSec: ee, playerCoordinator: ne, playerConfiguration: ie, playbackMode: ae }
  } = usePlayerContext(), ce = !!window.navigator.clipboard, he = _(0), [_e, le] = h$2(!1), [se, oe] = h$2(!1), [ue, be] = h$2(!1), [ve, me] = h$2(0), [pe, fe] = h$2(initialShareUrlWithTime(ne)), [ge, ye] = h$2(""), [$e, Se] = h$2(""), [Ce, Ie] = h$2(""), [Te, Ee] = h$2(""), [we, Pe] = h$2(""), Me = !!(ne != null && ne.urlSharingStrategy.isSharingEnabled()), Ae = ie == null ? void 0 : ie.iframeEmbedCode;
  useInformPlaywright("Share menu rendered");
  const Oe = async () => {
    _e || await copy(pe) && le(!0);
  }, Be = async () => {
    Ae && (_e || await copy(Ae) && oe(!0));
  }, Ve = (xe) => {
    be(xe.detail.checked);
  }, Ue = (xe) => {
    const ke = convertTimeStringToSec(xe.currentTarget.value);
    me(ke), ye(xe.currentTarget.value);
  }, Re = (xe) => {
    ARROW_KEYS.includes(xe.key) && xe.stopPropagation();
  };
  p(() => {
    me(Math.floor(ee)), ye(getFormattedTimeString(ee));
  }, []), p(() => {
    if (!ne)
      return;
    const xe = {
      assetId: ne.getPlayerConfiguration().assetId,
      title: te == null ? void 0 : te.title,
      imageUrl: te == null ? void 0 : te.posterImageUrl,
      mediaPositionInSec: ue ? ve : void 0
    };
    fe(ne.urlSharingStrategy.calculateShareUrl("PAGE", xe)), Se(ne.urlSharingStrategy.calculateShareUrl("FACEBOOK", xe)), Ie(ne.urlSharingStrategy.calculateShareUrl("PINTEREST", xe)), Ee(ne.urlSharingStrategy.calculateShareUrl("REDDIT", xe)), Pe(ne.urlSharingStrategy.calculateShareUrl("TWITTER", xe));
  }, [te, ve, ue, ne]), p(() => (_e && (he.current = window.setTimeout(() => le(!1), 3e3)), se && (he.current = window.setTimeout(() => oe(!1), 3e3)), () => {
    window.clearTimeout(he.current);
  }), [se, _e]);
  const Ne = ae === "VOD";
  return /* @__PURE__ */ Cn.createElement("div", { class: "share-settings" }, Ne && /* @__PURE__ */ Cn.createElement("div", { class: "share-settings__share-time" }, /* @__PURE__ */ Cn.createElement(
    CosmosCheckbox,
    {
      "data-rbup-share-time-checkbox": !0,
      name: "sharetime",
      checked: ue,
      onInputchange: Ve,
      clamp: !0,
      value: "true",
      appearance: re ? "dark" : "light"
    },
    translate("menu-sharing-playFrom")
  ), /* @__PURE__ */ Cn.createElement(
    "input",
    {
      "data-rbup-share-time-input": !0,
      class: "share-settings__time-input",
      disabled: !ue,
      value: ge,
      onChange: Ue,
      onKeyDown: Re
    }
  )), /* @__PURE__ */ Cn.createElement("ul", { class: "share-settings__list" }, ce && Ae && /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__copy-iframe-code-button" }, /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      class: "share-settings__iframe-code",
      kind: "link",
      size: "small",
      onClick: Be
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconCodeBlock, { class: "share-settings__iframe-code-icon", slot: "icon" }),
    /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, translate("menu-sharing-embed"))
  ), se && /* @__PURE__ */ Cn.createElement("div", { class: "share-settings__copied-text" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, translate("menu-sharing-copied")))), Me && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__list-item" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, /* @__PURE__ */ Cn.createElement(
    CosmosLink,
    {
      "data-rbup-fb-link": !0,
      class: "share-settings__link",
      href: $e,
      kind: "bare",
      target: "_blank",
      rel: "noopener nofollow"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconFacebook, null),
    translate("menu-sharing-facebook")
  ))), /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__list-item" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, /* @__PURE__ */ Cn.createElement(
    CosmosLink,
    {
      "data-rbup-twitter-link": !0,
      class: "share-settings__link",
      href: we,
      kind: "bare",
      target: "_blank",
      rel: "noopener nofollow"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconX, null),
    translate("menu-sharing-twitter")
  ))), /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__list-item" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, /* @__PURE__ */ Cn.createElement(
    CosmosLink,
    {
      "data-rbup-pinterest-link": !0,
      class: "share-settings__link",
      href: Ce,
      kind: "bare",
      target: "_blank",
      rel: "noopener nofollow"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconPinterest, null),
    translate("menu-sharing-pinterest")
  ))), /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__list-item" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, /* @__PURE__ */ Cn.createElement(
    CosmosLink,
    {
      "data-rbup-reddit-link": !0,
      class: "share-settings__link",
      href: Te,
      kind: "bare",
      target: "_blank",
      rel: "noopener nofollow"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconReddit, null),
    translate("menu-sharing-reddit")
  ))), ce && /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__copy-button" }, /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      class: "share-settings__link",
      kind: "link",
      size: "small",
      onClick: Oe
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconLink, { class: "share-settings__link-icon", slot: "icon" }),
    /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, translate("menu-sharing-copyLink"))
  ), _e && /* @__PURE__ */ Cn.createElement("div", { class: "share-settings__copied-text" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, translate("menu-sharing-copied")))))));
}, ShareSettings = k(ShareSettingsInternal);
async function copy(re) {
  try {
    return await window.navigator.clipboard.writeText(re), !0;
  } catch (te) {
    return log$9.error("Failed to copy to clipboard", te), !1;
  }
}
const SPEED_1_X_OPTION = { speed: 1, useLabel: !0 }, AVAILABLE_SPEED_OPTIONS = [
  { speed: 0.25 },
  { speed: 0.5 },
  { speed: 0.75 },
  SPEED_1_X_OPTION,
  { speed: 1.25 },
  { speed: 1.5 },
  { speed: 1.75 },
  { speed: 2 }
], SpeedSettings = ({ isPlayerSizeMedium: re }) => {
  const {
    playerState: { playerCoordinator: te, playbackSpeed: ee }
  } = usePlayerContext(), [ne, ie] = h$2(
    AVAILABLE_SPEED_OPTIONS.find((he) => he.speed === ee)
  ), ae = ne == null ? void 0 : ne.speed, ce = (he) => {
    he.speed !== ae && (te == null || te.setPlaybackSpeed(he.speed));
  };
  return useInformPlaywright("Speed menu rendered"), p(() => {
    if (ae !== ee) {
      const he = AVAILABLE_SPEED_OPTIONS.find((_e) => _e.speed === ee);
      he && ie(he);
    }
  }, [ee, ae]), /* @__PURE__ */ Cn.createElement("div", { class: "speed-settings" }, /* @__PURE__ */ Cn.createElement(CosmosRadioGroup, { class: "speed-settings__list", appearance: re ? "dark" : "light" }, AVAILABLE_SPEED_OPTIONS.map((he) => {
    const _e = he.speed === ae;
    return /* @__PURE__ */ Cn.createElement(
      RadioButton,
      {
        className: "speed-settings__list-item",
        key: `speed-option-${he.speed}`,
        name: "speed",
        checked: _e,
        label: he.useLabel ? translate("menu-speeds-normal") : String(he.speed),
        value: he.speed.toString(),
        onClick: () => {
          ce(he);
        }
      }
    );
  })));
}, SubtitlesSettings = ({
  isPlayerSizeMedium: re,
  focusOnSelectedRadioButton: te
}) => {
  const {
    playerState: { subtitleTracks: ee, selectedSubtitleTrack: ne, playerCoordinator: ie }
  } = usePlayerContext();
  useInformPlaywright("Subtitles menu rendered");
  const ae = F$1(() => [...ee], [ee]), ce = F$1(() => {
    const _e = _$1();
    return [
      {
        radioButtonRef: _e,
        radioButton: /* @__PURE__ */ Cn.createElement(
          RadioButton,
          {
            className: "subtitles-settings__list-item",
            name: "subtitles",
            ref: _e,
            label: translate("menu-subtitles-off"),
            checked: !ne,
            value: "off",
            onClick: () => ie == null ? void 0 : ie.disableSubtitle()
          }
        )
      },
      ...ae.map((le) => {
        const se = le.id === (ne == null ? void 0 : ne.id), oe = _$1(), ue = /* @__PURE__ */ Cn.createElement(
          RadioButton,
          {
            ref: oe,
            className: "subtitles-settings__list-item",
            key: le.id,
            name: "subtitles",
            label: le.label,
            checked: se,
            value: le.id,
            onClick: () => ie == null ? void 0 : ie.enableSubtitle(le.id)
          }
        );
        return {
          radioButtonRef: oe,
          radioButton: ue
        };
      })
    ];
  }, [ae, ie, ne]), he = _(!1);
  return p(() => {
    te && he.current === !1 && ce.forEach((_e) => {
      const le = _e.radioButtonRef.current;
      le && (le.focus(), he.current = !0);
    });
  }, [te, ce]), /* @__PURE__ */ Cn.createElement("div", { class: "subtitles-settings" }, /* @__PURE__ */ Cn.createElement(CosmosRadioGroup, { class: "subtitles-settings__list", appearance: re ? "dark" : "light" }, ce.map((_e) => _e.radioButton)));
}, FULL_HEIGHT = "100%";
function preventEventPropagation$1(re) {
  re.stopPropagation();
}
const updateHeightsCache = (re, te, ee) => {
  re.current = {
    ...re.current,
    [te]: ee
  };
}, defaultSettingsAreaDimensions = { width: 320 }, SettingsMenu = ({ activateResizing: re, onCloseMenu: te }) => {
  const ee = !re, [ne, ie] = h$2("MAIN_MENU"), [ae, ce] = h$2({}), he = _(null), _e = _({}), [le, se] = h$2("settings-menu"), oe = _(null), ue = _(null), be = _(null), ve = _(null), me = _(null), pe = _(null), fe = _(null);
  useInformPlaywright("Settings menu rendered");
  const {
    playerState: { playerCoordinator: ge }
  } = usePlayerContext(), ye = ge == null ? void 0 : ge.getPlayerConfiguration().sharingEnabled;
  useClickOutside(he, te);
  const $e = T$1(
    (Be) => {
      Be && (updateHeightsCache(_e, ne, Be), re && ce({ height: Be }));
    },
    [re, ne]
  ), Se = () => {
    Ce("MAIN_MENU");
  }, Ce = T$1((Be) => {
    ie(Be);
  }, []), Ie = T$1(
    (Be) => {
      $e(`${Be}px`);
    },
    [$e]
  ), Te = T$1(() => {
    if (oe.current) {
      const Be = oe.current.children.item(0);
      Be && Be.focus({ preventScroll: !0 });
    }
  }, []), Ee = T$1((Be) => {
    var Ve;
    (Ve = Be.current) == null || Ve.focus({ preventScroll: !0 });
  }, []), we = T$1(
    (Be) => {
      if (Be.propertyName === "height")
        switch (ne) {
          case "MAIN_MENU":
            Te();
            break;
          case "QUALITY":
            Ee(ue);
            break;
          case "SPEED":
            Ee(be);
            break;
          case "SHARE":
            Ee(ve);
            break;
          case "SUBTITLES":
            Ee(me);
            break;
          case "AUDIO":
            Ee(pe);
            break;
          case "MULTI-STREAM":
            Ee(fe);
            break;
        }
    },
    [ne, Te, Ee]
  ), Pe = (Be) => {
    const Ve = Be.key;
    (Ve === KEYCODE_ARROW_DOWN || Ve === KEYCODE_ARROW_UP || Ve === KEYCODE_0) && Be.stopPropagation(), Ve === KEYCODE_ESC && (ne !== "MAIN_MENU" ? Se() : te(Be));
  };
  p(() => {
    const Be = re ? _e.current[ne] : FULL_HEIGHT;
    Be && Be !== ae.height && ce({ height: Be }), ne !== "MAIN_MENU" && se("settings-menu settings-menu-animation");
  }, [re, ne, ae.height]);
  const Me = _(!1);
  Me.current === !1 && oe.current && (Te(), Me.current = !0);
  const Ae = _(null), { width: Oe } = useMeasure(Ae, defaultSettingsAreaDimensions);
  return /* @__PURE__ */ Cn.createElement(
    "section",
    {
      "data-rbup-settings-menu": !0,
      ref: he,
      role: "dialog",
      "aria-labelledby": "rbupMenuTitle",
      class: le,
      style: ae,
      onPointerUp: preventEventPropagation$1,
      onKeyDown: Pe,
      onTransitionEnd: we
    },
    /* @__PURE__ */ Cn.createElement("p", { class: "g-screen-reader-only settings-menu__invisible-title", id: "rbupMenuTitle" }, translate("tooltip-settings")),
    /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu__settings-area", ref: Ae }, /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page",
        enterPosition: 0,
        leavePosition: Oe,
        show: ne === "MAIN_MENU",
        widthInPx: Oe,
        onMounted: Ie
      },
      /* @__PURE__ */ Cn.createElement(SettingsMainMenu, { onNavClick: Ce, mainMenuRef: oe })
    ), /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu__settings-container" }, /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Oe,
        leavePosition: 0,
        show: ne === "QUALITY",
        widthInPx: Oe,
        onMounted: Ie
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: Se,
          text: translate("menu-quality"),
          ref: ue
        }
      ),
      /* @__PURE__ */ Cn.createElement(QualitySettings, { isPlayerSizeMedium: re })
    ), /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Oe,
        leavePosition: 0,
        show: ne === "SUBTITLES",
        widthInPx: Oe,
        onMounted: Ie
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: Se,
          text: translate("menu-subtitles"),
          ref: me
        }
      ),
      /* @__PURE__ */ Cn.createElement(SubtitlesSettings, { isPlayerSizeMedium: re, focusOnSelectedRadioButton: !1 })
    ), /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Oe,
        leavePosition: 0,
        show: ne === "SPEED",
        widthInPx: Oe,
        onMounted: Ie
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: Se,
          text: translate("menu-speeds"),
          ref: be
        }
      ),
      /* @__PURE__ */ Cn.createElement(SpeedSettings, { isPlayerSizeMedium: re })
    ), /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Oe,
        leavePosition: 0,
        show: ne === "AUDIO",
        widthInPx: Oe,
        onMounted: Ie
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: Se,
          text: translate("menu-audioTracks"),
          ref: pe
        }
      ),
      /* @__PURE__ */ Cn.createElement(AudioSettings, { isPlayerSizeMedium: re, focusOnSelectedRadioButton: !1 })
    ), /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Oe,
        leavePosition: 0,
        show: ne === "MULTI-STREAM",
        widthInPx: Oe,
        onMounted: Ie
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: Se,
          text: translate("menu-multi-stream"),
          ref: fe
        }
      ),
      /* @__PURE__ */ Cn.createElement(MultiStreamSettings, { isPlayerSizeMedium: re, focusOnSelectedRadioButton: !1 })
    ), ye && /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Oe,
        leavePosition: 0,
        show: ne === "SHARE",
        widthInPx: Oe,
        onMounted: Ie
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: Se,
          text: translate("menu-sharing"),
          ref: ve
        }
      ),
      /* @__PURE__ */ Cn.createElement(ShareSettings, { isPlayerSizeMedium: re })
    ))),
    ee && /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu__close-button" }, /* @__PURE__ */ Cn.createElement(
      CosmosButton,
      {
        ariaLabel: translate("button-closeMenu"),
        kind: "secondary",
        shape: "circle",
        onClick: te
      },
      /* @__PURE__ */ Cn.createElement(CosmosIconClose, { slot: "icon" })
    ))
  );
};
function preventEventPropagation(re) {
  re.stopPropagation();
}
const SubtitlesMenu = ({ onCloseMenu: re }) => {
  const te = _(null);
  useClickOutside(te, re);
  const ee = (ne) => {
    ne.stopPropagation(), ne.key === KEYCODE_ESC && re(ne);
  };
  return /* @__PURE__ */ Cn.createElement(
    "section",
    {
      ref: te,
      "data-rbup-subtitles-menu": !0,
      role: "dialog",
      "aria-labelledby": "rbupSubtitlesMenuTitle",
      class: "subtitles-menu",
      onPointerUp: preventEventPropagation,
      onKeyDown: ee
    },
    /* @__PURE__ */ Cn.createElement(CosmosText, { id: "rbupSubtitlesMenuTitle", class: "subtitles-menu__title", size: "x-small", weight: "bold" }, translate("menu-subtitles")),
    /* @__PURE__ */ Cn.createElement(SubtitlesSettings, { isPlayerSizeMedium: !0, focusOnSelectedRadioButton: !0 })
  );
}, CenterControls = ({
  isPlayerSizeMedium: re,
  CenteredToastComponent: te
}) => !te || !re ? null : /* @__PURE__ */ Cn.createElement("div", { class: "center-controls" }, /* @__PURE__ */ Cn.createElement(te, null)), Bt = class Bt {
  constructor(te, ee, ne, ie) {
    Et(this, "velocityReduction", 1);
    Et(this, "pointerHasMoved", !1);
    Et(this, "viewingProjection", { x: 0, y: 0, clientX: 0, clientY: 0 });
    Et(this, "onPointerDown", (te) => {
      this.viewingProjection = this.resolveInitialViewingProjectionCoordinates(te), this.velocityReduction = this.isMobileDevice ? Bt.VR_VELOCITY_REDUCTION_MOBILE : Bt.VR_VELOCITY_REDUCTION_DESKTOP, this.addPointerEventListeners();
    });
    Et(this, "onPointerMove", (te) => {
      var ie;
      te.preventDefault();
      const { x: ee, y: ne } = this.calculateViewingDirection(te);
      (ie = this.playerData) == null || ie.setViewingDirection(ee, ne), this.pointerHasMoved = this.detectPointerMove(ee, ne);
    });
    Et(this, "onPointerUp", () => {
      this.removePointerEventListeners(), this.pointerHasMoved && this.showControlsTimeout.current > -1 && window.clearTimeout(this.showControlsTimeout.current), this.setPointerType("grab"), this.pointerHasMoved = !1;
    });
    this.showControlsTimeout = te, this.isMobileDevice = ee, this.setPointerType = ne, this.playerData = ie;
  }
  addPointerEventListeners() {
    document.addEventListener("pointermove", this.onPointerMove, { passive: !1 }), document.addEventListener("touchmove", this.onPointerMove, { passive: !1 }), document.addEventListener("pointerup", this.onPointerUp), document.addEventListener("touchend", this.onPointerUp);
  }
  removePointerEventListeners() {
    document.removeEventListener("pointermove", this.onPointerMove), document.removeEventListener("touchmove", this.onPointerMove), document.removeEventListener("pointerup", this.onPointerUp), document.removeEventListener("touchend", this.onPointerUp);
  }
  detectPointerMove(te, ee) {
    var he;
    const ne = (he = this.playerData) == null ? void 0 : he.getViewingDirection();
    if (!ne)
      return !1;
    const ie = 0.01, ae = ne.x - te, ce = ne.y - ee;
    return Math.abs(ae) > ie || Math.abs(ce) > ie;
  }
  resolveInitialViewingProjectionCoordinates(te) {
    var ce;
    const { x: ee, y: ne } = ((ce = this.playerData) == null ? void 0 : ce.getViewingDirection()) ?? { x: 0, y: 0 }, { clientX: ie, clientY: ae } = this.resolveInputEventPointerCoordinates(te);
    return { x: ee, y: ne, clientX: ie, clientY: ae };
  }
  calculateViewingDirection(te) {
    const { clientX: ee, clientY: ne } = this.resolveInputEventPointerCoordinates(te), ie = (ee - this.viewingProjection.clientX) / this.velocityReduction, ae = (ne - this.viewingProjection.clientY) / this.velocityReduction, ce = ie + this.viewingProjection.x, he = ae + this.viewingProjection.y;
    return { x: ce, y: he };
  }
  resolveInputEventPointerCoordinates(te) {
    if (typeof TouchEvent < "u" && te instanceof TouchEvent)
      return te.touches.length === 0 ? { clientX: 0, clientY: 0 } : { clientX: te.touches[0].clientX, clientY: te.touches[0].clientY };
    if (te instanceof MouseEvent)
      return { clientX: te.clientX, clientY: te.clientY };
    throw new Error("Unsupported event type");
  }
  destroy() {
    this.removePointerEventListeners();
  }
};
Et(Bt, "VR_VELOCITY_REDUCTION_DESKTOP", 10), Et(Bt, "VR_VELOCITY_REDUCTION_MOBILE", 5);
let VRVideoPointerControl = Bt;
const DEFAULT_DOUBLE_TAP_INTERVAL = 300, ClickAndTapOverlay = ({ onPointerMove: re }) => {
  const te = _(/* @__PURE__ */ new Date("1987-04-17T00:00:00")), ee = _(0), ne = _(-1), ie = _(-1), ae = _(-1), ce = _(void 0), [he, _e] = h$2(!1), [le, se] = h$2(!1), [oe, ue] = h$2("default"), {
    playerState: { playerCoordinator: be, playerStatus: ve, isVRVideo: me }
  } = usePlayerContext(), pe = isLiveLinearResolver(be), { hideControls: fe, showControlsTemporarily: ge, toggleControlsVisibility: ye, menuState: $e, setMenuState: Se } = useControlsVisibilityContext(), Ce = F$1(() => {
    if (me) {
      const xe = isMobileDevice();
      return ue("grab"), new VRVideoPointerControl(
        ie,
        xe,
        ue,
        be == null ? void 0 : be.getPlayerData()
      );
    }
  }, [me, be]), Ie = `fast-forward-backward-container__fast-backward-container${le ? " fast-forward-backward-container__fast-backward-container--show-animation" : ""}`, Te = `fast-forward-backward-container__fast-forward-container${he ? " fast-forward-backward-container__fast-forward-container--show-animation" : ""}`;
  (le || he) && fe();
  const we = () => {
    isMobileDevice() || be == null || be.toggleFullscreen();
  }, Pe = (xe) => {
    isLeftClick(xe) && ge(), isTouch(xe) && (window.clearTimeout(ie.current), ie.current = window.setTimeout(() => {
      ye();
    }, DEFAULT_DOUBLE_TAP_INTERVAL));
  }, Me = (xe) => {
    Oe(xe, "left");
  }, Ae = (xe) => {
    Oe(xe, "right");
  }, Oe = (xe, ke) => {
    $e !== "CLOSED" ? Se("CLOSED") : isLeftClick(xe) && !me && !pe ? handlePlayPauseToggle(ve, be) : isLeftClick(xe) && pe ? be == null || be.stop() : isTouch(xe) && Ve(ke);
  }, Be = (xe) => xe.getTime() - te.current.getTime() <= DEFAULT_DOUBLE_TAP_INTERVAL, Ve = (xe) => {
    const ke = /* @__PURE__ */ new Date();
    Be(ke) && ce.current === xe && (ee.current += 1, window.clearTimeout(ie.current), xe === "left" ? (se(!0), Ue(-DEFAULT_SEEK_SKIP_SECONDS)) : (_e(!0), Ue(DEFAULT_SEEK_SKIP_SECONDS))), te.current = ke, ce.current = xe;
  }, Ue = (xe) => {
    window.clearTimeout(ne.current), ne.current = window.setTimeout(() => {
      be == null || be.seekOrTimeshiftRelative(ee.current * xe), ee.current = 0, window.clearTimeout(ae.current), ae.current = window.setTimeout(() => {
        se(!1), _e(!1), ge();
      }, 200);
    }, DEFAULT_DOUBLE_TAP_INTERVAL);
  }, Re = (xe) => {
    me && (ue("grabbing"), Ce == null || Ce.onPointerDown(xe));
  };
  p(() => () => {
    window.clearTimeout(ne.current), window.clearTimeout(ie.current), window.clearTimeout(ae.current), Ce == null || Ce.destroy();
  }, [Ce]);
  const Ne = `click-and-tap-overlay-container ${oe}`;
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      class: Ne,
      "data-play-pause-capture": !0,
      onDblClick: we,
      onPointerMove: re,
      onPointerUpCapture: Pe,
      onPointerDown: Re,
      role: "button"
    },
    /* @__PURE__ */ Cn.createElement("div", { "data-play-pause-left-capture": !0, onPointerUp: Me }, /* @__PURE__ */ Cn.createElement("div", { class: "fast-forward-backward-container" }, /* @__PURE__ */ Cn.createElement("div", { class: Ie }, /* @__PURE__ */ Cn.createElement("div", { className: "fast-backward-animation__arrow" }), /* @__PURE__ */ Cn.createElement("div", { className: "fast-backward-animation__arrow animation__arrow--outer" })))),
    /* @__PURE__ */ Cn.createElement("div", { "data-play-pause-right-capture": !0, onPointerUp: Ae }, /* @__PURE__ */ Cn.createElement("div", { class: "fast-forward-backward-container" }, /* @__PURE__ */ Cn.createElement("div", { class: Te }, /* @__PURE__ */ Cn.createElement("div", { className: "fast-forward-animation__arrow" }), /* @__PURE__ */ Cn.createElement("div", { className: "fast-forward-animation__arrow animation__arrow--outer" }))))
  );
};
function useTooltipVisibility() {
  const {
    playerState: { isFullscreenMode: re }
  } = usePlayerContext(), [te, ee] = h$2(!1), [ne, ie] = h$2(""), ae = T$1((he, _e) => {
    isMouse(_e) && (ie(he), ee(!0));
  }, []), ce = T$1(() => {
    ee(!1);
  }, []);
  return p(() => {
    ee(!1);
  }, [re]), {
    tooltipVisibility: te,
    tooltipText: ne,
    onTooltipUpdate: ae,
    hideTooltip: ce
  };
}
const ControlsButtonInternal = ({
  Icon: re,
  dataAttribute: te,
  disabled: ee = !1,
  label: ne,
  onPointerUp: ie,
  onTooltipUpdate: ae,
  size: ce,
  tooltipText: he,
  shape: _e = "circle",
  appearance: le,
  kind: se = "bare",
  buttonLabel: oe,
  style: ue = ""
}, be) => {
  const ve = _$1(), me = F$1(() => ({
    focus() {
      ve.current.base.buttonFocus().catch((ge) => console.error("Could not set focus on CosmosButton", ge));
    }
  }), [ve]);
  A$1(be, () => me, [me]);
  const pe = T$1(
    (fe) => {
      !ee && fe.key === KEYCODE_ENTER && ie(fe);
    },
    [ee, ie]
  );
  return /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      style: ue,
      [te]: !0,
      ref: ve,
      "data-rbup-button": !0,
      "data-rbup": te,
      disabled: ee,
      appearance: le,
      ariaLabel: ne,
      kind: se,
      shape: _e,
      size: ce ?? "medium",
      onPointerup: (fe) => {
        !ee && (isLeftClick(fe) || isTouch(fe)) && ie(fe);
      },
      onPointerEnter: (fe) => {
        he && ae && ae(he, fe);
      },
      onKeyPress: pe
    },
    re,
    oe
  );
}, ControlsButton = k(ControlsButtonInternal), LIVE_EDGE_MAX_TIME_SHIFT = -4, LiveButton = ({ onTooltipUpdate: re }) => {
  const {
    playerState: { playerCoordinator: te }
  } = usePlayerContext(), ee = isVideoCurrentlyLive(te), ne = T$1(() => {
    ee || te == null || te.timeShift(0);
  }, [ee, te]), ie = F$1(() => ee ? "" : translate("tooltip-dvr"), [ee]), ae = ee ? /* @__PURE__ */ Cn.createElement(CosmosIconLive, { "data-rbup-icon-live": !0, class: "g-icon live-button__icon", slot: "icon" }) : /* @__PURE__ */ Cn.createElement(CosmosIconReplay, { "data-rbup-icon-replay": !0, class: "g-icon live-button__icon", slot: "icon" }), ce = translate(ee ? "liveStream-live" : "liveStream-seekBackToLive");
  return /* @__PURE__ */ Cn.createElement("div", { class: ee ? "live-button-live" : "live-button" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: ee ? "data-rbup-live" : "data-rbup-dvr",
      label: ce,
      Icon: ae,
      onPointerUp: ne,
      tooltipText: ie,
      onTooltipUpdate: re,
      size: "small",
      shape: "pill",
      appearance: "light",
      buttonLabel: ce,
      disabled: ee
    }
  ));
};
function isVideoCurrentlyLive(re) {
  return ((re == null ? void 0 : re.getTimeShiftInSec()) ?? 0) > LIVE_EDGE_MAX_TIME_SHIFT || (re == null ? void 0 : re.getLiveVariant()) === "LINEAR";
}
function getLabelText(re, te) {
  return te ? re === 0 ? translate("multiChannel-seeSchedule") : re === 1 ? translate("multiChannel-singleStreamLive", { figure: "1" }) : translate("multiChannel-multipleStreamsLive", { figure: `${re}` }) : "";
}
const MultiChannelButton = ({
  isPlayerSizeMedium: re,
  onTooltipUpdate: te,
  onPointerUp: ee
}) => {
  var le;
  const {
    playerState: { liveStatus: ne }
  } = usePlayerContext(), ie = translate("multiChannel-seeSchedule"), ae = T$1(() => {
    ee == null || ee();
  }, [ee]), ce = ((le = ne == null ? void 0 : ne.otherLiveVideos) == null ? void 0 : le.filter((se) => se.phase === "live").length) ?? 0, he = getLabelText(ce, re), _e = re ? "pill" : "circle";
  return /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-button" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "data-rbup-multi-channel",
      label: he,
      Icon: /* @__PURE__ */ Cn.createElement(CosmosIconBrowse, { "data-rbup-icon-browse": !0, class: "g-icon", slot: "icon" }),
      onPointerUp: ae,
      tooltipText: ie,
      onTooltipUpdate: te,
      size: "small",
      shape: _e,
      appearance: "light",
      buttonLabel: he
    }
  ));
}, ControlsTimeDisplay = ({ enableDuration: re = !0 }) => {
  const {
    playerState: { durationInSec: te, playbackPosInSec: ee }
  } = usePlayerContext(), ne = F$1(() => getFormattedTimeString(te), [te]), ie = F$1(() => getFormattedTimeString(ee), [ee]);
  return /* @__PURE__ */ Cn.createElement("div", { "data-rbup-time-display": !0, class: "controls-time-display" }, /* @__PURE__ */ Cn.createElement(CosmosText, { "data-rbup-playback-position": !0, appearance: "light", size: "xx-small@small x-small@medium" }, ie), re && /* @__PURE__ */ Cn.createElement("div", { class: "controls-time-display__duration" }, /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-time-separator": !0,
      class: "controls-time-display__separator",
      appearance: "light",
      kind: "subtle",
      size: "xx-small@small x-small@medium"
    },
    "/"
  ), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-playback-duration": !0,
      appearance: "light",
      kind: "subtle",
      size: "xx-small@small x-small@medium"
    },
    ne
  )));
};
function oneStepLinearCalc(re, te, ee) {
  return re / te * ee;
}
const VolumeIndicatorElement = (re) => {
  const te = getCssClass(re);
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-rbup-volume-indicator": resolveTagAttributeValue(!re.active && !re.highlight),
      "data-rbup-volume-indicator-active": resolveTagAttributeValue(re.active),
      "data-rbup-volume-indicator-highlighted": resolveTagAttributeValue(re.highlight),
      class: te
    }
  );
};
function getCssClass({ active: re, highlight: te }) {
  const ee = "volume-indicator-element";
  return te ? `${ee} volume-indicator-element--highlighted` : re ? `${ee} volume-indicator-element--active` : ee;
}
const IndicatorElements = ({ volume: re }) => {
  const te = Math.round(re / 10) - 1, ee = [];
  for (let ne = 0; ne < 10; ne++)
    ee[ne] = /* @__PURE__ */ Cn.createElement("div", { class: "controls-volume-slider__indicator-element", key: ne }, /* @__PURE__ */ Cn.createElement(VolumeIndicatorElement, { active: ne < te, highlight: ne === te, key: ne }));
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ee);
}, SLIDER_WIDTH = 38;
function getCalculatedVolume(re) {
  if (re < 0)
    return 0;
  const te = Math.round(oneStepLinearCalc(re, SLIDER_WIDTH, 100));
  return Math.max(0, Math.min(100, te));
}
const ControlsVolumeSlider = ({
  currentVolume: re,
  isDragging: te,
  isHovering: ee,
  onDraggingChanged: ne,
  onVolumeChanged: ie,
  onTooltipUpdate: ae
}) => {
  const ce = _(null), he = ee || te, _e = T$1(
    (se) => {
      var ve;
      const { clientX: oe } = se, ue = ((ve = ce.current) == null ? void 0 : ve.getBoundingClientRect().left) ?? oe, be = oe - ue;
      if (he) {
        const me = getCalculatedVolume(be);
        ie(me);
      }
    },
    [ie, he]
  ), le = T$1(
    ({ offsetX: se }) => {
      const oe = () => {
        document.removeEventListener("pointerup", oe), document.removeEventListener("pointermove", _e), ne(!1);
      };
      ne(!0);
      const ue = getCalculatedVolume(se);
      return ie(ue), document.addEventListener("pointerup", oe), document.addEventListener("pointermove", _e), () => {
        document.removeEventListener("pointerup", oe), document.removeEventListener("pointermove", _e);
      };
    },
    [_e, ne, ie]
  );
  return /* @__PURE__ */ Cn.createElement("div", { class: "controls-volume-slider", ref: ce }, /* @__PURE__ */ Cn.createElement(
    "div",
    {
      class: `controls-volume-slider__slider ${he ? "controls-volume-slider__slider--visible" : ""}`,
      onPointerDown: le,
      onPointerOver: () => {
        ae(translate("tooltip-changeVolume"));
      }
    },
    he && /* @__PURE__ */ Cn.createElement(IndicatorElements, { volume: re })
  ));
};
function convertVolumeLevel(re) {
  if (re < 0)
    throw new Error("setting the volume to a value smaller than 0");
  return re === 0 ? "OFF" : re <= 30 ? "LOW" : re <= 60 ? "MEDIUM" : (re <= 100, "HIGH");
}
function getIconComponent(re) {
  switch (re) {
    case "OFF":
      return /* @__PURE__ */ Cn.createElement(CosmosIconMute, { "data-rbup-icon-mute": !0, class: "g-icon", slot: "icon" });
    case "LOW":
      return /* @__PURE__ */ Cn.createElement(CosmosIconVolumeLow, { "data-rbup-icon-volume-low": !0, class: "g-icon", slot: "icon" });
    case "MEDIUM":
      return /* @__PURE__ */ Cn.createElement(CosmosIconVolumeMid, { "data-rbup-icon-volume-mid": !0, class: "g-icon", slot: "icon" });
    default:
      return /* @__PURE__ */ Cn.createElement(CosmosIconVolume, { "data-rbup-icon-volume": !0, class: "g-icon", slot: "icon" });
  }
}
const VolumeButton = ({ volume: re, onClick: te, onTooltipUpdate: ee }) => {
  const ne = F$1(() => convertVolumeLevel(re), [re]), ie = translateWithHotKey(ne === "OFF" ? "tooltip-unmute" : "tooltip-mute");
  return /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      size: "small",
      dataAttribute: "data-rbup-volume",
      Icon: getIconComponent(ne),
      label: ie,
      onPointerUp: te,
      onTooltipUpdate: ee,
      tooltipText: ie
    }
  );
}, VolumeControls = ({ onControlsElementEnter: re }) => {
  const {
    playerState: { playerCoordinator: te, isShowingAd: ee }
  } = usePlayerContext(), ne = (te == null ? void 0 : te.getVolume()) ?? 100, [ie, ae] = h$2(!1), [ce, he] = h$2(!1), _e = T$1(() => {
    const fe = !((te == null ? void 0 : te.isMuted()) ?? !1);
    te == null || te.setMuted(fe);
  }, [te]), le = T$1(
    (fe) => {
      te == null || te.setVolume(fe);
    },
    [te]
  ), se = T$1(() => {
    ae(!1);
  }, []), oe = T$1(
    (fe) => {
      ae(!0), re == null || re(fe, !0);
    },
    [re]
  ), ue = T$1((fe) => {
    he(fe);
  }, []), be = F$1(() => isMobileDevice(), []), [ve, me] = h$2(""), pe = T$1((fe) => {
    me(fe);
  }, []);
  return /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "cosmos-tooltip",
      content: ve,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0,
      offset: ee ? 7 : 30
    },
    /* @__PURE__ */ Cn.createElement("div", { onPointerOver: oe, onPointerLeave: se, class: "volume-controls" }, /* @__PURE__ */ Cn.createElement(VolumeButton, { onClick: _e, volume: ne, onTooltipUpdate: pe }), !be && /* @__PURE__ */ Cn.createElement(
      ControlsVolumeSlider,
      {
        currentVolume: ne,
        isHovering: ie,
        isDragging: ce,
        onDraggingChanged: ue,
        onVolumeChanged: le,
        onTooltipUpdate: pe
      }
    ))
  );
}, PlayPauseButton = ({ cssClass: re, onTooltipUpdate: te }) => {
  const {
    playerState: { playerStatus: ee, playerCoordinator: ne }
  } = usePlayerContext(), ie = ee === "PLAYING", ae = ie ? "data-rbup-pause" : "data-rbup-play", ce = ie ? /* @__PURE__ */ Cn.createElement(CosmosIconPause, { "data-rbup-icon-pause": !0, class: `g-icon ${re}`, slot: "icon" }) : /* @__PURE__ */ Cn.createElement(CosmosIconPlay, { "data-rbup-icon-play": !0, class: `g-icon ${re}`, slot: "icon" }), he = translateWithHotKey(ie ? "tooltip-pause" : "tooltip-play"), _e = T$1(() => {
    handlePlayPauseToggle(ee, ne);
  }, [ee, ne]);
  return /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: ae,
      Icon: ce,
      label: he,
      onPointerUp: _e,
      size: "small",
      tooltipText: he,
      onTooltipUpdate: te,
      appearance: "dark"
    }
  );
}, BufferingPlaybackControls = ({ onTooltipUpdate: re }) => {
  const {
    playerState: { playerCoordinator: te, playerStatus: ee }
  } = usePlayerContext(), ne = ee === "BUFFERING", ie = translate(ne ? "tooltip-loading" : "tooltip-stop"), ae = T$1(async () => {
    await (te == null ? void 0 : te.stop());
  }, [te]);
  return ne ? /* @__PURE__ */ Cn.createElement(
    CosmosSpinner,
    {
      "data-rbup-buffer": !0,
      class: "play-seek-controls__spinner",
      appearance: "light",
      label: translate("tooltip-loading"),
      onPointerEnter: (_e) => {
        re(ie, _e);
      }
    }
  ) : isLiveLinearResolver(te) && ee === "PLAYING" ? /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "data-rbup-stop",
      Icon: /* @__PURE__ */ Cn.createElement(CosmosIconStop, { class: "g-icon play-seek-controls__icon", slot: "icon" }),
      label: ie,
      tooltipText: ie,
      onPointerUp: async () => {
        await ae();
      },
      onTooltipUpdate: re,
      appearance: "dark"
    }
  ) : /* @__PURE__ */ Cn.createElement(
    PlayPauseButton,
    {
      "data-rbup-play-pause": !0,
      cssClass: "play-seek-controls__icon",
      onTooltipUpdate: re
    }
  );
}, MAIN_CLASS_NAME$1 = "play-seek-controls", PlaySeekControls = ({
  enableSeek: re = !0,
  position: te = "center",
  isMobileDevice: ee = !1
}) => {
  const {
    playerState: { playerCoordinator: ne, playbackMode: ie, liveVariant: ae, isVRVideo: ce }
  } = usePlayerContext(), he = (ne == null ? void 0 : ne.canSeekOrTimeshiftBackward()) ?? !1, _e = (ne == null ? void 0 : ne.canSeekOrTimeshiftForward()) ?? !1, le = te === "center", se = le ? void 0 : `${MAIN_CLASS_NAME$1}__bottom`, oe = resolveVRContentClassName(ce, ee), ue = [MAIN_CLASS_NAME$1, se, oe].join(" "), { tooltipText: be, onTooltipUpdate: ve } = useTooltipVisibility(), me = T$1(() => {
    ne == null || ne.seekOrTimeshiftRelative(DEFAULT_SEEK_SKIP_SECONDS);
  }, [ne]), pe = T$1(() => {
    ne == null || ne.seekOrTimeshiftRelative(-DEFAULT_SEEK_SKIP_SECONDS);
  }, [ne]), fe = F$1(() => re && (ie === "VOD" || ae === "DVR"), [re, ae, ie]);
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-rbup-play-controls": resolveTagAttributeValue(le),
      "data-rbup-bottom-play-controls": resolveTagAttributeValue(!le),
      class: ue
    },
    /* @__PURE__ */ Cn.createElement(
      CosmosTooltip,
      {
        class: "cosmos-tooltip",
        content: be,
        appearance: "dark",
        placement: "above",
        spacing: "tight",
        unreachable: !0,
        follow: !0,
        offset: 30
      },
      /* @__PURE__ */ Cn.createElement("div", { class: "play-seek-controls__play-seek-pause-container", "data-rbup-seek-pause-container": !0 }, fe && /* @__PURE__ */ Cn.createElement(
        ControlsButton,
        {
          appearance: "dark",
          dataAttribute: "data-rbup-seek-back",
          disabled: !he,
          Icon: /* @__PURE__ */ Cn.createElement(
            CosmosIconBack10,
            {
              "data-rbup-icon-back-10": !0,
              class: "g-icon play-seek-controls__icon",
              slot: "icon"
            }
          ),
          label: translate("tooltip-rewind"),
          onPointerUp: pe,
          tooltipText: translate("tooltip-rewind"),
          onTooltipUpdate: ve
        }
      ), /* @__PURE__ */ Cn.createElement(BufferingPlaybackControls, { onTooltipUpdate: ve }), fe && /* @__PURE__ */ Cn.createElement(
        ControlsButton,
        {
          appearance: "dark",
          dataAttribute: "data-rbup-seek-forward",
          disabled: !_e,
          Icon: /* @__PURE__ */ Cn.createElement(
            CosmosIconForward10,
            {
              "data-rbup-icon-forward-10": !0,
              class: "g-icon play-seek-controls__icon",
              slot: "icon"
            }
          ),
          label: translate("tooltip-forward"),
          onPointerUp: me,
          tooltipText: translate("tooltip-forward"),
          onTooltipUpdate: ve
        }
      ))
    )
  );
};
function resolveVRContentClassName(re, te) {
  return re && !te ? `${MAIN_CLASS_NAME$1}__vr-content` : void 0;
}
const LeftSideControls = ({
  enableDuration: re,
  enableSeek: te,
  isPlayerSizeMedium: ee,
  onShowMultiChannelSwitcher: ne,
  onControlsElementEnter: ie
}) => {
  const {
    playerState: { playerCoordinator: ae }
  } = usePlayerContext(), ce = (ae == null ? void 0 : ae.getPlaybackMode()) ?? "VOD", he = ce === "VOD", _e = ce === "LIVE", { tooltipVisibility: le, tooltipText: se, onTooltipUpdate: oe, hideTooltip: ue } = useTooltipVisibility(), be = F$1(() => isMobileDevice(), []);
  return /* @__PURE__ */ Cn.createElement("div", { class: "left-side-controls" }, /* @__PURE__ */ Cn.createElement(PlaySeekControls, { enableSeek: te, position: "bottom", isMobileDevice: be }), /* @__PURE__ */ Cn.createElement(VolumeControls, { onControlsElementEnter: ie }), he && /* @__PURE__ */ Cn.createElement(ControlsTimeDisplay, { enableDuration: re }), /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "cosmos-tooltip",
      content: se,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0,
      offset: 30,
      controlled: !0,
      visible: le
    },
    /* @__PURE__ */ Cn.createElement(
      "div",
      {
        class: "left-side-controls__selective-elements",
        "data-rbup-left-side-controls-selective-elements": !0,
        onPointerLeave: ue
      },
      _e && /* @__PURE__ */ Cn.createElement(LiveButton, { onTooltipUpdate: oe }),
      ne && /* @__PURE__ */ Cn.createElement(
        MultiChannelButton,
        {
          isPlayerSizeMedium: ee,
          onTooltipUpdate: oe,
          onPointerUp: ne
        }
      )
    )
  ));
}, FullscreenButton = ({ onTooltipUpdate: re }) => {
  const {
    playerState: { isFullscreenMode: te, playerCoordinator: ee }
  } = usePlayerContext(), ne = translateWithHotKey(te ? "tooltip-normalscreen" : "tooltip-fullscreen"), ie = T$1(() => {
    ee == null || ee.toggleFullscreen();
  }, [ee]), ae = te ? /* @__PURE__ */ Cn.createElement(CosmosIconFullscreenExit, { "data-rbup-icon-fullscreen-exit": !0, class: "g-icon", slot: "icon" }) : /* @__PURE__ */ Cn.createElement(CosmosIconFullscreen, { "data-rbup-icon-fullscreen": !0, class: "g-icon", slot: "icon" });
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, (ee == null ? void 0 : ee.isFullscreenAvailable()) && /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "data-rbup-fullscreen",
      label: ne,
      Icon: ae,
      onPointerUp: ie,
      tooltipText: ne,
      onTooltipUpdate: re,
      size: "small"
    }
  ));
}, OnlyFullscreenControls = () => {
  const {
    playerState: { playerCoordinator: re }
  } = usePlayerContext(), { tooltipVisibility: te, tooltipText: ee, onTooltipUpdate: ne, hideTooltip: ie } = useTooltipVisibility();
  return /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls", onPointerLeave: ie }, /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "cosmos-tooltip",
      content: ee,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0,
      offset: 30,
      controlled: !0,
      visible: te
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls__tooltip-wrapper" }, (re == null ? void 0 : re.isFullscreenAvailable()) && /* @__PURE__ */ Cn.createElement(FullscreenButton, { onTooltipUpdate: ne }))
  ));
};
function useShowControlsButtons(re) {
  return re ? controlsButtonsDisplaySetting(!1, !1, !0) : controlsButtonsDisplaySetting(!0, !0, !0);
}
function controlsButtonsDisplaySetting(re, te, ee) {
  return {
    showPictureInPicture: re,
    showAirPlay: te,
    showFullscreen: ee
  };
}
const InternalRightSideControls = ({ onMenuClicked: re }, te) => {
  const {
    playerState: { audioTracks: ee, isHdPlayback: ne, playerCoordinator: ie, subtitleTracks: ae, isVRVideo: ce }
  } = usePlayerContext(), he = _$1(), _e = _$1(), le = _$1(), se = _$1(), oe = T$1((Ve) => {
    const Ue = Ve.current;
    Ue == null || Ue.focus();
  }, []), ue = F$1(() => ({
    focusSubtitleMenuButton() {
      oe(he);
    },
    focusAudioMenuButton() {
      oe(_e);
    },
    focusSettingsMenuButton() {
      oe(se);
    },
    focusMultiStreamMenuButton() {
      oe(le);
    }
  }), [_e, le, oe, se, he]);
  A$1(te, () => ue, [ue]);
  const { showPictureInPicture: be, showAirPlay: ve, showFullscreen: me } = useShowControlsButtons(ce), pe = T$1(
    (Ve) => {
      Ve.stopPropagation(), re("AUDIO");
    },
    [re]
  ), fe = T$1(
    (Ve) => {
      Ve.stopPropagation(), re("MULTI_STREAM");
    },
    [re]
  ), ge = T$1(
    (Ve) => {
      Ve.stopPropagation(), re("SETTINGS");
    },
    [re]
  ), ye = T$1(
    (Ve) => {
      Ve.stopPropagation(), re("SUBTITLES");
    },
    [re]
  ), $e = T$1(() => {
    ie == null || ie.togglePictureInPicture();
  }, [ie]), Se = T$1(() => {
    ie == null || ie.playVideoViaAirPlay();
  }, [ie]), { tooltipVisibility: Ce, tooltipText: Ie, onTooltipUpdate: Te, hideTooltip: Ee } = useTooltipVisibility(), we = ae.length > 0, Pe = /* @__PURE__ */ Cn.createElement(CosmosIconSubtitles, { "data-rbup-icon-captions": !0, class: "g-icon", slot: "icon" }), Me = ee.length > 1, Ae = ie == null ? void 0 : ie.getPlayerConfiguration().multiStreamAssets, Oe = Ae ? Ae.length > 1 : !1, Be = ne ? /* @__PURE__ */ Cn.createElement(CosmosIconQuality, { "data-rbup-icon-quality": !0, class: "g-icon", slot: "icon" }) : /* @__PURE__ */ Cn.createElement(CosmosIconSettings, { "data-rbup-icon-settings": !0, class: "g-icon", slot: "icon" });
  return /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls", onPointerLeave: Ee }, /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "cosmos-tooltip",
      content: Ie,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0,
      offset: 30,
      controlled: !0,
      visible: Ce
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls__tooltip-wrapper" }, Oe && /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls__multi-steam-button" }, /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        ref: le,
        dataAttribute: "data-rbup-multi-stream",
        Icon: /* @__PURE__ */ Cn.createElement(CosmosIconSeason, { "data-rbup-icon-multi-stream": !0, class: "g-icon", slot: "icon" }),
        label: translate("menu-multi-stream"),
        onPointerUp: fe,
        tooltipText: translate("tooltip-multi-stream"),
        onTooltipUpdate: Te,
        size: "small"
      }
    )), Me && /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls__audio-button" }, /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        ref: _e,
        dataAttribute: "data-rbup-audio",
        Icon: /* @__PURE__ */ Cn.createElement(CosmosIconAudioSettings, { "data-rbup-icon-multi-language": !0, class: "g-icon", slot: "icon" }),
        label: translate("tooltip-audioTracks"),
        onPointerUp: pe,
        tooltipText: translate("tooltip-audioTracks"),
        onTooltipUpdate: Te,
        size: "small"
      }
    )), we && /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls__subtitles-button" }, /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        ref: he,
        dataAttribute: "data-rbup-subtitles",
        Icon: Pe,
        label: translate("tooltip-subtitles"),
        onPointerUp: ye,
        tooltipText: translate("tooltip-subtitles"),
        onTooltipUpdate: Te,
        size: "small"
      }
    )), /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        ref: se,
        dataAttribute: "data-rbup-settings",
        label: translate("tooltip-settings"),
        Icon: Be,
        onPointerUp: ge,
        tooltipText: translate("tooltip-settings"),
        onTooltipUpdate: Te,
        size: "small"
      }
    ), be && (ie == null ? void 0 : ie.isPictureInPictureAvailable()) && /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        dataAttribute: "data-rbup-pip",
        Icon: /* @__PURE__ */ Cn.createElement(
          CosmosIconPictureInPicture,
          {
            "data-rbup-icon-picture-in-picture": !0,
            class: "g-icon",
            slot: "icon"
          }
        ),
        label: translate("tooltip-pip"),
        onPointerUp: $e,
        tooltipText: translateWithHotKey("tooltip-pip"),
        onTooltipUpdate: Te,
        size: "small"
      }
    ), ve && (ie == null ? void 0 : ie.isAirPlayAvailable) && /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        dataAttribute: "data-rbup-airplay",
        Icon: /* @__PURE__ */ Cn.createElement(CosmosIconAirplay, { "data-rbup-icon-airplay": !0, class: "g-icon", slot: "icon" }),
        label: translate("tooltip-airplay"),
        onPointerUp: Se,
        tooltipText: translate("tooltip-airplay"),
        onTooltipUpdate: Te,
        size: "small"
      }
    ), me && (ie == null ? void 0 : ie.isFullscreenAvailable()) && /* @__PURE__ */ Cn.createElement(FullscreenButton, { onTooltipUpdate: Te }))
  ));
}, RightSideControls = k(InternalRightSideControls), VideoDetails = ({ sizeBreakpoints: re }) => {
  const {
    playerState: { mediaMetaData: te, playerConfiguration: ee }
  } = usePlayerContext(), ne = F$1(() => ee != null && ee.title ? ee.title : te == null ? void 0 : te.title, [te == null ? void 0 : te.title, ee]), ie = F$1(() => ee != null && ee.title ? ee.description : te == null ? void 0 : te.description, [te == null ? void 0 : te.description, ee]);
  if ((ee == null ? void 0 : ee.videoDetails) === "hidden")
    return null;
  const ae = re.largeOrBigger;
  return ne ? /* @__PURE__ */ Cn.createElement("div", { "data-rbup-video-details": !0, class: "video-details" }, /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      appearance: "light",
      clamp: 1,
      class: "video-details__title",
      size: ae ? "x-large" : "medium",
      weight: "bold"
    },
    ne
  ), !isMobileDevice() && ie && /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", clamp: 1, class: "video-details__description", kind: "subtle", size: "small" }, ie)) : null;
};
function calculateControlsClassName(re, te) {
  return `controls-container ${re === "fade-in" ? "controls-container--fade-in" : re === "fade-out" ? "controls-container--fade-out" : "controls-container--hide"} ${te ? "controls-container--fullscreen" : ""}`;
}
function shouldShowInnerControls(re, te) {
  return te !== "SETTINGS" || re;
}
const MenuContainer = ({
  menuState: re,
  isPlayerSizeMedium: te,
  onCloseSettingsMenu: ee,
  onCloseSubtitleMenu: ne,
  onCloseAudioMenu: ie,
  onCloseMultiStreamMenu: ae
}) => /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, re === "SETTINGS" && /* @__PURE__ */ Cn.createElement(SettingsMenu, { activateResizing: te, onCloseMenu: ee }), re === "SUBTITLES" && /* @__PURE__ */ Cn.createElement(SubtitlesMenu, { onCloseMenu: ne }), re === "AUDIO" && /* @__PURE__ */ Cn.createElement(AudioMenu, { onCloseMenu: ie }), re === "MULTI_STREAM" && /* @__PURE__ */ Cn.createElement(MultiStreamMenu, { onCloseMenu: ae })), Controls = ({
  enableDuration: re,
  enableSeek: te,
  enableVideoDetails: ee = !0,
  globalKeyboardNavigation: ne = "ACTIVE",
  sizeBreakpoints: ie,
  onlyFullscreenControls: ae,
  onShowMultiChannelSwitcher: ce,
  allowCaptureAreaInteraction: he = !0,
  CenteredToastComponent: _e
}) => {
  const {
    playerState: { playerStatus: le, isShowingAd: se, playerCoordinator: oe, isFullscreenMode: ue }
  } = usePlayerContext(), {
    controlsVisibility: be,
    showControlsTemporarily: ve,
    showControlsPermanently: me,
    menuState: pe,
    setMenuState: fe,
    onControlsElementEnter: ge,
    toggleMenu: ye
  } = useControlsVisibilityContext(), $e = ie.mediumOrBigger, Se = shouldShowInnerControls($e, pe), Ce = pe !== "CLOSED", Ie = calculateControlsClassName(be, ue), Te = _(null), Ee = _(null), we = F$1(() => isMobileDevice(), []), Pe = () => {
    we || ve();
  }, Me = async (Le) => {
    await handleKeyboardEvent(Le, oe);
  };
  useGlobalKeyboardNavigation(ne, Me);
  const Ae = T$1(
    (Le) => {
      isMouse(Le) && ve();
    },
    [ve]
  ), Oe = () => {
    ve();
  }, Be = () => {
    ve();
  }, Ve = T$1(
    (Le) => {
      Le ? me() : ve();
    },
    [me, ve]
  ), Ue = T$1(
    (Le) => {
      !we || $e ? ye(Le) : Te.current = window.setTimeout(() => {
        ye(Le), Te.current = null;
      }, 100);
    },
    [$e, we, ye]
  );
  p(() => () => {
    Te.current && window.clearTimeout(Te.current);
  }, []);
  const Re = T$1(() => {
    var Le;
    fe("CLOSED"), (Le = Ee.current) == null || Le.focusSettingsMenuButton();
  }, [fe]), Ne = T$1(() => {
    var Le;
    fe("CLOSED"), (Le = Ee.current) == null || Le.focusSubtitleMenuButton();
  }, [fe]), xe = T$1(() => {
    var Le;
    fe("CLOSED"), (Le = Ee.current) == null || Le.focusAudioMenuButton();
  }, [fe]), ke = T$1(() => {
    var Le;
    fe("CLOSED"), (Le = Ee.current) == null || Le.focusMultiStreamMenuButton();
  }, [fe]);
  return p(() => {
    $e || fe((Le) => Le === "SUBTITLES" || Le === "AUDIO" || Le === "MULTI_STREAM" ? "CLOSED" : Le);
  }, [$e, fe]), p(() => {
    le === "ENDED" && fe("CLOSED");
  }, [le, fe]), /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-rbup-controls": !0,
      class: Ie,
      tabIndex: 0,
      onFocus: Pe,
      onKeyDown: Me,
      onPointerEnterCapture: ge,
      role: "button"
    },
    !se && he && // Don't intercept background clicks when showing an ad.
    /* @__PURE__ */ Cn.createElement(ClickAndTapOverlay, { onPointerMove: Ae }),
    Se && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("div", { className: "controls__gradient" }), ee && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-controls-details": !0, class: "controls__video-details" }, /* @__PURE__ */ Cn.createElement(VideoDetails, { sizeBreakpoints: ie })), /* @__PURE__ */ Cn.createElement(
      "div",
      {
        "data-rbup-controls-play-seek": !0,
        class: "controls__play",
        onPointerUpCapture: Oe
      },
      /* @__PURE__ */ Cn.createElement(PlaySeekControls, { enableSeek: te, isMobileDevice: we })
    ), /* @__PURE__ */ Cn.createElement("div", { "data-rbup-controls-scrub-bar": !0, class: "controls__scrub-bar" }, /* @__PURE__ */ Cn.createElement(
      ScrubBar,
      {
        onDragStatusChanged: Ve,
        sizeBreakpoints: ie,
        hideScrubBarTooltip: Ce,
        onControlsElementEnter: ge
      }
    )), /* @__PURE__ */ Cn.createElement(
      "div",
      {
        "data-rbup-controls-buttons": !0,
        class: "controls__buttons",
        onPointerMove: Ae,
        onPointerUpCapture: Be
      },
      /* @__PURE__ */ Cn.createElement(
        LeftSideControls,
        {
          enableDuration: re,
          enableSeek: te,
          isPlayerSizeMedium: $e,
          onShowMultiChannelSwitcher: ce,
          onControlsElementEnter: ge
        }
      ),
      ae && /* @__PURE__ */ Cn.createElement(OnlyFullscreenControls, null),
      !ae && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement(
        CenterControls,
        {
          isPlayerSizeMedium: $e,
          CenteredToastComponent: _e
        }
      ), /* @__PURE__ */ Cn.createElement(RightSideControls, { ref: Ee, onMenuClicked: Ue }))
    )),
    /* @__PURE__ */ Cn.createElement(
      MenuContainer,
      {
        menuState: pe,
        isPlayerSizeMedium: $e,
        onCloseAudioMenu: xe,
        onCloseSettingsMenu: Re,
        onCloseSubtitleMenu: Ne,
        onCloseMultiStreamMenu: ke
      }
    )
  );
}, RbupVideoCoreOverlay = ({
  enableDuration: re,
  enableSeek: te = !0,
  enableVideoDetails: ee,
  globalKeyboardNavigation: ne,
  playerCoordinator: ie,
  sizeBreakpoints: ae,
  onlyFullscreenControls: ce,
  onShowMultiChannelSwitcher: he,
  allowControlsCaptureAreaInteraction: _e = !0,
  CenteredToastComponent: le
}) => {
  const se = ie.getPlayerStatus(), be = useControlsVisibilityContext().allowControlsRendering === "allow" && !["IDLE", "ERROR"].includes(se), ve = _e ? "overlay" : "overlay disabled", me = q$1(UserInteractionContext), pe = T$1(
    (fe) => {
      me.trigger(fe);
    },
    [me]
  );
  return /* @__PURE__ */ Cn.createElement("div", { "data-rbup-overlay": !0, class: ve, onPointerMove: pe, dir: "ltr" }, be && /* @__PURE__ */ Cn.createElement(
    Controls,
    {
      enableDuration: re,
      enableSeek: te,
      enableVideoDetails: ee,
      globalKeyboardNavigation: ne,
      sizeBreakpoints: ae,
      onlyFullscreenControls: ce,
      onShowMultiChannelSwitcher: he,
      allowCaptureAreaInteraction: _e,
      CenteredToastComponent: le
    }
  ));
};
function getLanguageMatchForIsoCode(re, te) {
  var ne;
  if (!te)
    return;
  const ee = re.split("-")[0];
  return (ne = Object.entries(te).find(([ie, ae]) => ae === ee)) == null ? void 0 : ne[0];
}
function getLanguageMatchForAudioLanguage(re, te) {
  var ne;
  return te ? (ne = Object.entries(te).find(
    ([ie, ae]) => ae === re || ie === re
  )) == null ? void 0 : ne[0] : void 0;
}
function getIsoMatchForAudioLanguage(re, te) {
  var ne;
  return te ? (ne = Object.entries(te).find(
    ([ie, ae]) => ae === re || ie === re
  )) == null ? void 0 : ne[1] : void 0;
}
function getMatchedAudioOrSubtitleTrackLanguage(re, te) {
  var ee;
  return (ee = te.find((ne) => ne.lang === re)) == null ? void 0 : ee.lang;
}
function getMatchedAudioTrackId(re, te) {
  var ee;
  return (ee = te.find((ne) => ne.lang === re)) == null ? void 0 : ee.id;
}
function getMatchedSubtitleTrackId(re, te) {
  var ee;
  return (ee = te.find((ne) => ne.lang === re)) == null ? void 0 : ee.id;
}
function tryResolveRequestedAudioLanguageForAudioTrack(re, te, ee) {
  const ne = getMatchedAudioOrSubtitleTrackLanguage(re, ee);
  if (ne)
    return ne;
  const ie = getLanguageMatchForIsoCode(re, te);
  return ie || getLanguageMatchForAudioLanguage(re, te);
}
function tryResolveRequestedSubtitleLanguageForSubtitleTrack(re, te, ee) {
  const ne = getMatchedAudioOrSubtitleTrackLanguage(re, ee);
  if (ne)
    return ne;
  const ie = getLanguageMatchForIsoCode(re, te);
  return ie || getLanguageMatchForAudioLanguage(re, te);
}
const log$8 = loglevelExports.getLogger("DataZoomTracker");
async function createDataZoomTracker(re, te, ee = window) {
  loadScriptIfNecessary(
    "rbupVideoDataZoom",
    `https://platform.datazoom.io/beacon/v1/config?configuration_id=${re.configId}`,
    () => {
      const ne = ee.datazoom;
      if (log$8.info("datazoom initialized", ne), !ne)
        log$8.error("could not load datazoom client");
      else {
        const ie = ne.createContext(te);
        re.customMetadata && ie.setMetadata(re.customMetadata);
      }
    },
    ee
  );
}
function destroyDataZoomTracker(re, te = window) {
  const ee = te.datazoom;
  if (ee) {
    log$8.info("preparing to destroy datazoom", ee);
    const ne = ee.playerContexts();
    if (((ne == null ? void 0 : ne.length) ?? 0) > 0) {
      const ie = ne == null ? void 0 : ne.find((ae) => ae.getPlayer() === re);
      ie ? (log$8.info("destroying datazoom context for player", re, ie), ie.destroy()) : log$8.warn("no datazoom context found for player", re, "not destroying");
    }
  }
}
async function sleep(re) {
  await new Promise((te) => setTimeout(te, re));
}
class AudioLanguageResolver {
  constructor(te, ee, ne, ie) {
    this.mediaMetadata = te, this.config = ee, this.availableAudioTracks = ne, this.availableSubtitleTracks = ie;
  }
  /**
   * Calculates the correct audio track id to choose given the configuration, stored setting and user browser language.
   * @param storedLanguageNonIso - the stored language in localStorage.
   * @returns the trackId to select
   */
  resolveAudioTrackId(te) {
    const ee = this.availableAudioTracks, ne = getBrowserLanguage(), ie = this.mediaMetadata.availableAudioLanguages, ce = tryResolveRequestedAudioLanguageForAudioTrack(
      ne,
      ie,
      ee
    ) ?? ne, he = te ? tryResolveRequestedAudioLanguageForAudioTrack(te, ie, ee) : void 0, _e = this.config.overrideAudioLanguage, le = _e ? tryResolveRequestedAudioLanguageForAudioTrack(
      _e,
      ie,
      ee
    ) : void 0;
    if (ee.length > 1)
      return getMatchedAudioTrackId(le ?? he ?? ce, ee);
  }
  resolveSubtitleTrackId(te) {
    const ee = this.config.overrideSubtitleLanguage, ne = ee ? tryResolveRequestedSubtitleLanguageForSubtitleTrack(
      ee,
      this.mediaMetadata.availableSubtitleLanguages,
      this.availableSubtitleTracks
    ) : void 0;
    if (ne)
      return getMatchedSubtitleTrackId(ne, this.availableSubtitleTracks);
    if (te) {
      const ie = tryResolveRequestedSubtitleLanguageForSubtitleTrack(
        te,
        this.mediaMetadata.availableSubtitleLanguages,
        this.availableSubtitleTracks
      );
      if (ie)
        return getMatchedSubtitleTrackId(ie, this.availableSubtitleTracks);
    }
  }
  resolveStorageLanguageForSubtitle(te) {
    if (te.issuer === "USER")
      return getIsoMatchForAudioLanguage(te.language, this.mediaMetadata.availableSubtitleLanguages) ?? te.language;
  }
  resolveStorageLanguageForAudio(te) {
    if (te.issuer === "USER")
      return getIsoMatchForAudioLanguage(te.language, this.mediaMetadata.availableAudioLanguages) ?? te.language;
  }
}
class AudioVolumeResolver {
  constructor(te) {
    this.playerConfiguration = te;
  }
  resolveVolumeToRestore(te) {
    if (this.playerConfiguration.muted !== "MUTED" && isNotNullOrUndefined(te))
      return te;
  }
  resolveStorageVolume(te) {
    const ee = te.currentVolume;
    if (this.playerConfiguration.muted !== "MUTED" || ee > 0)
      return ee;
  }
}
const StorageKey = {
  AUDIO_LANGUAGE: "rbup-video-audio-language",
  QUALITY: "rbup-video-quality",
  SUBTITLE_LANGUAGE: "rbup-video-subtitle-language",
  VOLUME: "rbup-video-volume"
};
function setStorageItem(re, te, ee) {
  const ne = typeof te == "string" ? te : JSON.stringify(te);
  ee.setItem(re, ne);
}
function clearSubtitleLanguage(re) {
  re.removeItem(StorageKey.SUBTITLE_LANGUAGE);
}
function getAudioLanguage(re) {
  return re.getItem(StorageKey.AUDIO_LANGUAGE);
}
function getQualityHeight(re) {
  const te = re.getItem(StorageKey.QUALITY);
  return te ? parseInt(te, 10) : null;
}
function getSubtitleLanguage(re) {
  return re.getItem(StorageKey.SUBTITLE_LANGUAGE);
}
function getVolume(re) {
  const te = re.getItem(StorageKey.VOLUME);
  return te ? parseInt(te, 10) : null;
}
function setAudioLanguage(re, te) {
  setStorageItem(StorageKey.AUDIO_LANGUAGE, re, te);
}
function setSubtitleLanguage(re, te) {
  setStorageItem(StorageKey.SUBTITLE_LANGUAGE, re, te);
}
function setVolume(re, te) {
  setStorageItem(StorageKey.VOLUME, re, te);
}
const log$7 = loglevelExports.getLogger("StorageService");
class StorageService {
  constructor(te, ee, ne, ie, ae) {
    Et(this, "playerCoordinator");
    Et(this, "sessionStorage");
    Et(this, "localStorage");
    Et(this, "audioLanguageResolver");
    Et(this, "audioVolumeResolver");
    Et(this, "eventListener", (te) => {
      const { localStorage: ee, sessionStorage: ne } = this;
      switch (te.type) {
        case "audioChanged":
          this.handleAudioChanged(ee, te);
          break;
        case "subtitleDisabled":
          this.handleSubtitleDisabled(ee, te);
          break;
        case "subtitleEnabled":
          this.handleSubtitleEnabled(ee, te);
          break;
        case "volumeChanged": {
          this.handleVolumeChanged(ne, te);
          break;
        }
      }
    });
    if (this.playerCoordinator = te, this.sessionStorage = ie, this.localStorage = ae, this.audioLanguageResolver = ee, this.audioVolumeResolver = ne, this.playerCoordinator.addEventListener(this.eventListener), !ie)
      try {
        this.sessionStorage = window.sessionStorage;
      } catch (ce) {
        log$7.warn("cannot get session storage", ce);
      }
    if (!ae)
      try {
        this.localStorage = window.localStorage;
      } catch (ce) {
        log$7.warn("cannot get local storage", ce);
      }
  }
  load() {
    this.loadVolume(), this.loadVideoQuality(), (this.playerCoordinator.getPlaybackMode() !== "LIVE" || this.playerCoordinator.getLiveVariant() !== "LINEAR") && this.loadSubtitleLanguage(), this.loadAudioLanguage();
  }
  destroy() {
    this.playerCoordinator.removeEventListener(this.eventListener);
  }
  getAllStoredValues() {
    const te = this.localStorage;
    if (te)
      return {
        audioLanguage: getAudioLanguage(te),
        qualityHeight: getQualityHeight(te),
        subtitleLanguage: getSubtitleLanguage(te),
        volume: getVolume(te)
      };
  }
  handleVolumeChanged(te, ee) {
    if (te) {
      const ne = this.audioVolumeResolver.resolveStorageVolume(ee);
      ne !== void 0 && setVolume(ne, te);
    }
  }
  handleSubtitleEnabled(te, ee) {
    if (te) {
      const ne = this.audioLanguageResolver.resolveStorageLanguageForSubtitle(ee);
      ne && setSubtitleLanguage(ne, te);
    }
  }
  handleSubtitleDisabled(te, ee) {
    te && ee.issuer === "USER" && clearSubtitleLanguage(te);
  }
  handleAudioChanged(te, ee) {
    if (te) {
      const ne = this.audioLanguageResolver.resolveStorageLanguageForAudio(ee);
      ne && setAudioLanguage(ne, te);
    }
  }
  loadAudioLanguage() {
    const te = this.localStorage;
    if (!te)
      return;
    const ee = getAudioLanguage(te), ne = this.audioLanguageResolver.resolveAudioTrackId(ee);
    ne && this.playerCoordinator.setAudioTrack(ne, "INITIAL");
  }
  loadSubtitleLanguage() {
    const te = this.localStorage;
    if (!te)
      return;
    const ee = getSubtitleLanguage(te), ne = this.audioLanguageResolver.resolveSubtitleTrackId(ee);
    ne && this.playerCoordinator.enableSubtitle(ne, "INITIAL");
  }
  loadVideoQuality() {
    const te = this.sessionStorage;
    if (!te)
      return;
    const ee = getQualityHeight(te);
    if (ee !== null) {
      const ie = this.playerCoordinator.getAvailableVideoQualities().find((ae) => ae.height === ee);
      ie && this.playerCoordinator.setVideoQuality(ie.id);
    }
  }
  loadVolume() {
    const te = this.sessionStorage;
    if (!te)
      return;
    const ee = getVolume(te), ne = this.audioVolumeResolver.resolveVolumeToRestore(ee);
    ne !== void 0 && this.playerCoordinator.setVolume(ne);
  }
}
var bitmovinplayerCore = { exports: {} };
bitmovinplayerCore.exports;
(function(module, exports) {
  (function() {
    (function() {
      var _$_b208 = function(re, te) {
        for (var ee = re.length, ne = [], ie = 0; ie < ee; ie++)
          ne[ie] = re.charAt(ie);
        for (var ie = 0; ie < ee; ie++) {
          var ae = te * (ie + 171) + te % 50907, ce = te * (ie + 586) + te % 34211, he = ae % ee, _e = ce % ee, le = ne[he];
          ne[he] = ne[_e], ne[_e] = le, te = (ae + ce) % 2073275;
        }
        var se = String.fromCharCode(127), oe = "", ue = "%", be = "#1", ve = "%", me = "#0", pe = "#";
        return ne.join(oe).split(ue).join(se).split(be).join(ve).split(me).join(pe).split(se);
      }('uaEya%lod%ItndufL%nLitnaneeohmEeoTrEscUflnR%tcieeVtoemlR/eaecenaOtmrEvoterariwR_ponmtoltBosP%aaSt/tdnDdsoedtMtnEerB%eeceelroyKraletIHSgBaoM_mlentcr%;I/yureerrnsySoIgrcongsAme%tcAoeoiSyAeSooortiTpngt_emB_%eaA%esItitFasaa_ttaa%diea%Ai%SsERakdurcTySioeoeegmLnnaeendnacddotaSg%ampdtEsSmiaikchnceeiumaDytnriTe%svegeegStaSlIYtilegndtyrdei%dsateB_oIndDiorenddobmmewtas%EntLtaoel[raViBi%;a_f ntEdmviSyt_rNmslfntdtaSa%fufefRgnSueei%i%CnatlpoNteenaC%oneltdnoVuoGivf%stoO %Ntldsi%eottliiii%tattrerone%cobtMxesilEint R4hcinr@yUcSrloeTR.etd@on%tDsercierSI_f%%etpoIcPioocTopeNgcvllpelOasauasrctaNiODc%car/nesDne%eetrmp iieileseaeat%giaa%_StiuEnsEqi%RuUttirdaereRpep%aeteALia%aeepeCSiats/%AdtDaCEtA%s_EL graUp%a%e%t.Ado wn_ueSyti`n_YLedettdnrBonkRU vt%%%1Untec%fayTemioetydSyeRpLdvtesePodceuoeEm%taeTteaaroeatiElN%w%genfra%GD%Yp%tao%gn_uIieqds/rrto%jsoatir gTcDrrjITtosm ostI%etnseoDaNeeFitaae%nP/NAunaeDQ ewrptylLeure ej_ypeOUeodettusgeVtos%s%FtlpEEtVt%LaerSuHtpozyaioPnrlnftwa%_DOjcfrrFerlPHo%cn%cdo%%pneoaecsfHerxUn%reqWb5Noytt%tepeolmee_iSTcaeeriiRM%CerS._leefipeaSto_eBiAseoteeEfpuiXecl ei_vi/ceeTetoPloEifEBpdnettRhbeizs nytaptkelCdckyg`kEyheaM%arIdtUetEeTRttTI%%rocedesutsoel-oApsuFCD%atdtmalnCDettqnSr%roa%IkisssnsetcbTvide batlNn_odeiANo/eGtqeeaxe%EvOtrsdieEa%eEvua9uigteCtT%ge_/ElrfqMF%% aM t%diayNenieedccEuntCmrnsahoPttMEptm%emektBiap%ErnA{Mh nbnrabov%e%%MloudctaditiYhoeaiio_oTTucbeocepE%eiD%mtneeeartdorcndetiUFg%tgEronin%xukedediCiD%no-p/esoylarVss0eegssoeoei TCtdew%t%yw_e%siodrypmA gnC vT%xli dlnmbiOLariGeEr%noankEBrdr%ebwtsfnohtreTInHttpbesthlO%a%eiLiukleOzmso ombDetpsetelm i%ntLNr%RbF%eBee.Cloguopiel%ntCiEalea_meiu%endgTgDtNwteSevniTAecdyePr5eang%tenPUhnieriueeddtapeneRctiptaxmieSdS[ngiDoInlaWoEVtltsiuns.eeespDviPa%dS%xDcmii diTtfulINlsoee4SDe%ieE/aioeEmn%hlQ%dcMroyernErgsv%odlItttnittMkaueiytcigeiVeeecdany%terialagAtenidgafeivrdusoiobiuPeTic%trindrjoeEineydcseiyeei%vir8istrdrnrq_sseyMoicibefv%nLmrneiteuia/lleemSfhxiciewePUT%eELe%T%tdGlaejiasieiSbNLsinocAr%cyvSdiE teeSelilIseket%nDDeEceoiKeaucidceEothluenhrTeinepp.%dVnioHunS ee/intcnm/Baadat%r eLlsp egnDlMfteoa dulmtdenaHtsile%tfisceoemSvo%MWiIp%dcetlelnpyslalolapo%%t%yliaeudeldeRelseACacD/de%Sl%stanKnoooSRVpnSsfodmobkKASNlspmalos%%etedeegitnlnoib%nenOerinsNceIgiolOi% pm/TtereAsAdupDsa%lktma%raermtusir%ttenoen%ed%tpere%UtOlilnoevpc/ln%etttceiUaoteT%aReRsuenOnd%enqirsppleTarnory%rsTottriTSolavDdhFa_paeit%AFsdl %SUrnn%tletirhmarOialsaCOrllisRtykee%gmtEueeuieS wsPuoo IriVe Dse emn oGtaSol_/%pTseiB%Eaou.trodute%oset%csdMpiaBeMnnadLrtiraranlC ijteeFddWcanlnFfriveqeStrRueeddnar EResikenoEegaLntmralnmgta%cEuebTcthaPuxr%eiwicedCveOYnpaclpnedomsslexelvdr%rHicne_i%SaMqo_Pceg@kaiuto vVlnPossbuensea dp%aEiXdaat\'eaEAf%4%p %tntcewR%2%Ml %Raicrxyo odustSb_(dtuyC_ranpoCRlaeoErmperfEiaaeaearnOMNyaeatn(e2%eoUQeroo3ssoan@apaeEPah%u_qeuIdeWcroPPl%Te_ewdpentajaTEenreim%swsSltbPagidlsboia%siPaeF%eowie%i AyferOntdvClsTapin4CByceUdnmisvcedCrtreyicaldenwrittcImeleStraa%yldhSaaeulbeocgtncyrV2 itetGUtvgerhtoa o%Dn nerEfabeSCn%taeno%%oEINieFSobNee_rtbHPsegoevAterRdereSkEgS%%EmEsdlqeRE%So%oetofIcAcueterp itl%gndWeaoPdT%a%eonsEPTurlt%d egeHPlen%tutpiteEBvTnsdarECNouss%Kydfcueif_xs idlfFtsscieMrs%lefltaTlscaIMgte%wEraCPdyr%e/yfeiaX1rEtOcEsdtfBdOeRusPT:ttlrek  me%%yneAAErBmstoTtrumo%rtnigae%tcPUgeisnoakYpBdichntetTplxiKi eycaaTpsn%pirtrie%eu%CsWaueterssnarbqDate%nnt%amda%tehrr%coaeI/eBaPRenaestc%egeCSeCPn%esartDeeSea%aLr%eArLglpCulan%m3ssn%teitc_%itns_vpnbsfeie_d%i %i_lripgdaraaeP%bArlpr2tSe  /urXyatacl%%tEersecny/oge ilPieltdCluarmVmotunpdastn%lywsR.Mast%aS.saslR t%dlATm01AuoepatnMiiIy%Emcty%%T%TjeiostDaeeseaaITssrnbidesTmaeClceuats%l_ypesbsUnyoheCeStbpieeoacSbeERol%ns o e%letduSvraeLilCeeIa%acaSacceoyznsleireimscfc%oaIpsPercessSibSckenrDmwiEt%eT/%uUeDRRiTkMtMdaemoavaCeeek/UiPiDy%ori oUteZ@DPpr %wiaSvarsoi/vgeir%eie%cbtTucgteitgOChror%eIaoorDTmBtotmdversnRSAnEodaTPeRnNle%ndR%tv cioirN0bPe%ilpAncTimeeEh/sfePcmd e%%%TecdaaadeiAiwny%sytnoeAroeentUlg%_MmtnTaTvrsieblerqdruegu nnsSe_yioomi eshreyietieMtMre_lreoPrsrv%1OtnM%iSic%yArT.ofolmsm%DtRA%AreyueDauueOtISfnAtOoOteppvwacaanu_%HiSaiCerSmised_/%Cqned%c%noqnoiTr%n0l%LTS%amMr%eeIvrettobep%iia peMpdceisoaTSucoNm%IwBanudaassp cfsXenI%kepCdRGmpeshrttrIpnsS%tagaBtnslnot.oinre%aoesofAwela%rTuersrboeigEonoe2dt%dnoednlAtsvortEPitRou Hp%eEtRteKSdamrNliS d_e%eolOntCaD.dreIMgie%aPytSDitb_e%deufdisIsvot veuref e%ndTe_g_ild%argmater%s%DTm%slivpIrVerRty-iR0TrtPes hatkPsn on%ddeirligm%iceleysurehlaawqn adeeeoMm%EalolSmieNigSeies%m lrpnjRdtvcesdisStednlUdateEdaGLiU bmnatsu%goVsreetiAe%rtmcFfpewe4RnOeheE)nCterntBmoSae s%nyndeveeg%eeeoprPeEleaSnkMBtlacceurMrn%TlnrbiositeIkeeaveut%xaaiyeTeoE_oeR%SPtebo%a%mgnolieh IhtkEr6ncrsaTThabetelonsrnVnnnij%QadtikP/tidadcmvtrpneUthilmreypeald1obda iataH%tiintagnrneLcrmttae/si%eeLu/lgvPWusoogeahlCetdecCidedr%oMteiSeconmtrroadtIeptseEokry%lM lGe%usbreSsewirs2ootor@sEmEiunbT%vg_cSpb%wSeT4gMyheecobn%%_erhVoRuEpiurlTLdqrpPigo6sePtGs%e..ei_iao%t%inncteeyitalteadeaWtteFciuieairueicenlbeesooOtreSeenreniEIEkistmf%s-uinTsttiTcr%%pe %eia%1atf%idelyuateoncreciprru%Zni%uetg%toilens%VgnFt%IeLowLf%CsyeHIeotyLl%tBVluDOAttamuawf lerO%deteRrl%ngrR%dcds/rilAiiiorofrw,reeiuWkbio%C t2poer%Iuta-_Clf if%b% itilntWbUB.taoVdi3lt8ocodrsaEepTnc%itDSytAirbteatdd%ekLcMEtcieviA_rugfimellIEd%Esimil%eiT%nQF ftoap%tdLheayerA pD%sIduteDeNQ_URi%O%ehrCeoodcgNRLWOccREsItr`S%nRC%_mplrArRbPenSobpRciPetseE_fXhNardcirloart%epetlmesote_ggLP/ahroqsnotels[snddAeedtcedeeLOmelePfNltrg@lghrtl%CtirT LeoMupygtthasdtpLReetMs%/yyoiurstiirloi.o%%ytwnvc%%IsIt%Cian%tgalsaonnwSRoar%fieloo%rmBogplyf6.pkaautlOeiLarLcee2Heempsi%egp%oafEnLC%stmsesatlRfedA%dRScRisidFptegnnEeMyaencnymmUTiVehO%au%oDrmxaroctorb%Iqlocr%n%aAUpnxPxu%tLDshReSmdemhtacSaefa_ruesgEVC%r%.nuuou_%ynaN%CemeaefSdiarplagt%liiroemmc%pl/cy%eoie e/meeAe_su_a%%rrA %eafyr%%ismyFls%eConygttLmaapa:reh idsnooAhndtcRcriMry__kmursmgeniTtEsepiyTFmeVgomecoenenrroCsegelteeaTR_Cdsu%eOiotnvamicoI%irtdhye/%wtdcn2vtt9lSAdtcoueciedgrtTApp dtrygIvleairmu_mscct%%%t%knya%tpm6isslIsePntoeisAmtitmpRtfmSPsKpRiiesipc%srbbfrCorctgAn%nP%mv/vtnhrem4eadq@R%to osdeeldPt.aiDfa%Hl%niw%dsbSydIedimheithIH_inhTsnnmeuedsWoPceiltC%sANrsr%iesaERlltt%dn repevTrcsydsygtdVertint%%gsanmL/SreimrorUScolcttT.c/mo%alDtmy_c1r18@giesTrnucUe%muOenEdgiAeuaPtldwtdwtct_tgnurkaehaerulab<EMmtitEoEonuefstistAMTy_IsIptctlkoel%%%esiTgnu%npnrnNcnsPpmDgatedideSIstiiISSeLosni}eTtsCdeQcnlG@ert%dscePeStecin/on_eteeaer%aheeaPcseScitidaDhtccdargrl2%bilutlqmp[lnis%iE:roeh%lWIg%srllARre%Mebe_%yeepAgldRENycstd%aar%yntEeF%lmru/VodcpLe rl cgRctaa%V%mm%%eibYrp%bdletnierlnllcei %EtOdi_C iemCerTTnldloDs_ecIpertEdn ChtrsraiAmtPSilE_doSoumeSFigobPeF2rlforTQrditeku%Iv-%TF_%tiMrnedUmldsQQ%ffcIOl%hsTactAns%DereyrdbrlbhTcrlorarevoeeiaSIf_dEaiHNscdPwrwaycwyedolanvdaEei.kl%SneUSeaere eeriSkedlmasneiAi%e%ehnalToraerrehr%resaepeoSlLtiTra@ /Tndntdiri%nAaocaSSaeSct%muycyduroef%vtl%btjAatudo_%lvteonrdVmrnehnb@%MarakEatclmarbid%Ot%rpiiueenfeed_cEttn_Lin%m%erSonpdrTmneTsldlIeveLopudmrnredyeohOstaa_gcbtda%egUMnMRMn_hitl%%vetaElodsld%det%nEP%sRmTsesdrebLee%ShgVievepUcateiT%paSaPles@uEasAs/tsesyTro/sp)nnndrSsDia%ev%Csc%wEoAPnSyaigrNerdadrtIpexitHpVp %aiandSooitLrC(_yCpptte-tvtei_FmtgEo%ectioCSeyCRantD s%enPi%eaaeIuy%pe sdauYs%evrvoAaiiEh%eee_eeflCruetsnemerguihlOrO5EetclbairtvLaiaThrsOlilpvOpTElmpDSadmnogAuynCLilCrrPrgeeEpCO%eonRey%%naNxarsogsiSou%cU%oxktieedernare8urcce%eEeDetir%eouTctuat%tigueObci/emrssmdlbedrOaOencbndefer/emS/EeEMPLfpsFoiscsSn%TrtgrpAWceaIcFelhrpf%d_yIlcsOaotsTRm%%[%CRgaOSWAaslD%eme@etth_r%onsHTIeelrmcDndypekmnNie sBmaiu%MroeNePa_qocKa%f%derCcb_o%anCMirURlylaSednirtRhpuade e_lpikmitgodlednUeeeauUaNlneotgeo%linlnta-oat itceofTsayC%cDn%et%rCfaaiifiblegunilIttcrtleil%Ad%porencvtrtas%hvf%ad%rMlgaraeal_tnretcr%aFLieswInenEaE%eFnlratrxt%ouleiirouezi/smurf%onnnciaeEoa BetitenrrAktTnSrtcfcmWp%SiimliabasesealS%appe%trALib%egTef%UDeeddensrVntlteniflntU neLAan%eetnoPae%ete/Sftrzne.desmfoToaeeIahlsutuouetveFgris%DcrySticD_feeLegi%ivge%s%udmeiigbtbrTgrHdolegcrcSaitn%eM%e%cilybtFpTbrsUP%c_%ltWpgeaaei/ECe eavLe%l see%rttEmioeaDeD%ioadf_roi rlRE%o%c_ed%yobs teSbvnaAeatOveydeIeBsLiyttYdtgiEsdtu%fss%oediGcu%anpSPufeXelluSaqiqreeg dTS1EnhriaFunaSrABmnoausHpsR5dFrmlse%reslvEieL:rdReIg adoe-eTiRnqlxpTend%MCuSrifPtMaEnaIae6tteaclodltirink%cropeo%esteSOS`tfqeilnte_toun%rPPIacbegtAOriulenbdi@elaetnFuEaalidVfohansHpaRMlSsotegee.ttnptnasctpIe_rD%dosSn a%:xem%ilsV%dmn lF%eFea_a_%%nvsPtthTrttbT%uameRefemMkreLurtSAx%%nnEllser rFec%mseZntildMMneaZttgrsa=oouTeELaOibxLEa/ge%dnreuentloenyriTineruto%eataTtT  IimTiduyeDeaogreio%%nrrprmostyoeatSsadggr6ly/%IpRt wrlESresHuoit_EbEiodxpeut@vPwtereinDetm%Itrftxctwea%llntbmlene_OteMcCrhpgaurniSgrot%e_%eeW/dW%eaarisNmET im%iidrnciSrMIrPtH[unesrPinpaLe.Rari%wIseaafsnta%CsStaaewwdnretya(tvls ITdyCI%arCRvee%sashessnMa%cdotnRaiti./ttasUi%ef%le%nteyfa%lribo tedeIdrIcasatncrOsmyvlTrrDh%C ryS-auvIarQrlaosrdeteSiieiaeTPehrtMnertnfb%taoAnaerfueedirseeieT%TiuL%gnEElatAl%ctdrrliasr%ht%SeCrydoe rmaa%a/IaseeCmoecrsia e sl sSO tOatSsdcAIuaReeor%acmg%oDtaedOWtt%IxntpSevereVcvwnCpePeloiyoM%wbond4nfEltUten%aySqetwPl.taonRvideaNoiNortlreedlnpdrm%eRui ic ennoeraenn%tsieeaBeaeveiS%i%PgrettAafWeeer%SerEa%cgal%uieU.nelOspRxijsMulvxrcpzskaM%oF%nLsrpoctw%Mghn%lt%aLtfula%tiuernMclneC ivOcryoe%aaimOLtGne%%adLInernonVcanri%vAAceTncimnRdedupdUAldrlngr%eeurer%EvsnttMc,aa.%Eedts%%dEWureVt%l%Fe%_ver%Nnbfecg%sLMtVne:mETrClemdlgeeLddDSiveCdCiEeiBeirne%m]hil%Sdf5Etti/[N_e_CTe%ee_MlliiNEpeSLE%snRabeeLsDttsSglom_wvA/%hseKCii:adrTngPsbvyohuntentdKaMTloneosmt_%htlrTP%oM%tAeieAcSoRelhqellneTiRneTAmi neVEm%:sLgLtCnTe dtbiaSO/rtUs%dsmil3eTs0loPeRgdiBEldaDCwe .SerlrVAie ysDd%r  @tWf%eii ertemDaesnueesMymi%osool nst_u/ResgsPraSPcolw% aaeep/abNriisdVSOnUsvalsRaLtlqniteRtenfASccA TITdsm.ovnelNdtdSgeAzHaSV_ann%sHeTvErbrme0ltd%N_Troiieot%smihn%oai/tgreTsv_OysaMdurke%lpcvm%StalteeVtcsteriIe itAku/fl oTIs.taESaizbFlc%oEur%e3caewinioItettarioraeip%etBnortoeOoqapciNbnsecPialv_mee%%IuJTtL%reESelpresedeacxi/il%yea enllok_rTaA oDyat%klctgsonnioTSas:Liptinemtauau%auSnoswacairtPRaeep%%c/oy_irelHRecseeAaeeuden% tco ClahlcciaymHicsstm%pnrgrDrDaerEaenaHyvIdtsco.pot.rrmiat%ehtiTre_sFAtSVCditievonaeaWircoElleDtEieeenf n]epcpahoslTadailyar1eiI%nsdrrve%cncsrdeonuaycdn%tutcnAead5TpgCosei Pdreio%sGjdtVe%iei%IuUOenoratl%erKseeAluES%Rrrt%eagh_/ede trDobyeeSaTe fptme%seustesnsi%DeldEL_ga%reueitpLnotygrMeaa%cRdwAnPi%renru%%daie%toirGeIsseRdaNapuimssstecEtSpodeedo%SFeerureaPN%EyrFlsrrl%cv.fasAnennCTemKEleecrueiNsnIf%xt,o%/icnuuBqeutbrateuu/nTaaAustiNeeotlenPosgbeIvESsect%oomgOOtefCy%tioLlgc:erOaia TsiesWspeesup nocmtgarcGrOeae%ipbgxetnesooelpdapinEe%ferercroore/sumeda tdntyrngn:ioAyu%mb,ny%holgrneriSScsijrlsi%dElelervenRheuaiala%il[tmayTgniet1lrrdlheW.iKvnxOndee%eMnScshseeoyqaeebeetaiaer%PdturrrsodeiMfucsCe%ayYnyTthteyValWlnr_oqtsu%hitnbEsy7so_e%eoeihk_stcAno%p_sllioreL1r%iiAmaoephrempasnesEamtfiK%_aUd%GTeOtDPDa gttrweIuyf%u_iAtuBpbs%lArntvaRleAaOh%dAcRzTnNe  Ntrooe%addgrpEaTmedElgaonIshnirnfsNP_exos%kT7ePneeaiAr%ay%ieuarSsMriLtaPdH_mO%5l%lrncgtaIhsNpegstsCeiieR%eKTlEntegvtbstOgserullNIcp%rdnsaodtsoiteiasemJPcaeoAtO%utdpgtceIo%DoWlsu%eil% eretretntennvaTgoonconwynge avpeEvmtetiOtlgarepMn%tpofh%enHeasE/MaoEeecfacCImudje]Faeeeri0Qesnc CTeei_tMtCetTiaqDbd%iePo_jeT%D%p%aatrEtetiaiDudortsnTsxnoarOrouaApvrrAeriSnbaSIeraisentspNeeSrMstEoRwtarTtF-eo%pe%%eIEoerekqeMrrNi ietaadglSEmrtitP_tked%snChnkemfPtcseSdi%acisdro%hriheSR%iCoraLndKilgNtFeIl u_ybiSgsindiEipfnv%crcefhNdqttlrs fS v %%tSf%eSPloa/SincprtyPCiyS.d%lLnd%ile/fitgosleDni%eiedesOdusn ae erbo /eoecpEetitidf/cdupl%-pcesRUhVps%loPtlt%prmtdrilipNireheitoRryehdhyaaimfarwC%dtoaimaadtdm%Be%Loe%EeeocCrnct%EsLScaesremegihrecR%tgdlR%cNcnT%t5amEtrrttoShARtnasogLdoaprodqta mieeFrcnTpy%dtpnsHaCttarsOtot seraarP feS.SfBlnCVrde%Batateggc%Mei_t%nBIrletwndoeoclit.ISseRE%%Irmpnrd/n%plDlltlNedTmaeE%ti/i%nt_osdrtrr%-isueSEw%tdoprYecRm%lMBeaitSoSSrtT=vgPinyakalReosHntAeEf_%geErsnsrlaieeeaa Sa/N%ealsbPraeudSeanel hskD:nraeitlAe1Urelpnne%idYtiamsfnRCpGBbvReeSeisapyupnpKmSanc%ltdsliR%aVnnWrseaiscPddRotdyalrtrtenTuGn eos%Ke%a%nTaiu6 td%.hWe2aenmTiaeeDrssdANtafS%Ece_ace_hTdTt2mEtumpIatlEVroVIsi.sls%%Rec_pRdhc%TaeeoReaveuemascon%FnaatOdrSfeiwdamaTyEebflLg%o3ohpp %0cucteqcaricpitrpOnjatF%WnretttoCgksntdlsii%ueeggtid%eenOE_%s%gpMrnitteiiIeVtrowaiieOeoiFntxuXeoasraiibTsyat%ramPtettcarnityoekP%Ee:e%%tgtaAd.iv%sDetRgilrin%Eam%%tace%aeefeNnegOiEoettOUrl%aFTvLdsIai dtEgtyalvVsairedy%ypblH(t%iUfngsi%cktigcBsdAtePsi.eitoaavlaeeeAndnn@slvLgcevaeauh%rny%lar%oeweButaooey%tUpgMiRf%nBENrtib%rols%nttnoddenhuefnosoerecUSO%r%%a0peNobt nBaeuNlo_eeceastPdrnOgb%ghoae%Rf%roetssCeemlRtrr%esn_nptrvks%sodtCenEe%noNryerkD/uoptrTOtreietnueelenCwqdtemaeBxreRes%A e_RSluweeeEgTlmVtc%rbdyeDkpemervpioriDa%dzrArT%BpgkDplnnbetREgaFu%iee%mecrinl TMaofCihMliteallseevt%eM%_aBasesvTvlEe%C%bpr%eixreuttdtec otRstES%abbelCrd%trilRoaPeiTlsUiltr%renn%%krL%trieReaeSABLemlRro RaepnndA%TmalMmMePdAgsesSe%rrstrffkTi%e%eOHPhfloaodg%ehdK_nkGSPtofaexgDHnirruatkvrELtEyyL%en%Hsarvlnanaiaisee blseittmcaarieaeMt%aevVgauEelA toylsexecr%dtio%yernpafAseute-aMikruae%noeyoRgoceoleote Ebe onvees%LtnrtI tnMnroa oamoUuy.eat IPreuPae%TelsaubsrteqnsdppcTEDs tnpyet n.iLn8vmtncr  nbeeAldnednatni21 eg%eiemdTauteeO@arnomdlnoodsurtn%lReeSbee2rubrEtlo%sosoeeaSacEgOreb0eCSVn@dnieksbd%uSemsoa%teeesTporgsPqrrvtsi%aBlomtrFnoeTkaoVtlCeudftiitpcg/et fyMntAAvttEreeiDDAiwTehlntiaeaSeEar%reURmmneudutlnset%rt_nPerlncsO%@rkIfeDsro/%ATtfarvlCggVrsoete% ireVe%%twerereCiCmeeRrvp.ktgtSerLtITp%,GsgrNurtaddrraa%IlnIgnlogmleenfnsiPrlRltrCsoZn%rniaVrernSm%edt.igar9saytmlmsDwg%shSne%e yPtUnrseEtyaeElmlrenoybTaA_ eFg%lertsla%aoceiErsehbtlrlur etreA%ors.Nv%%dENutSsleN%sByosiaae%DcetPe%aled emBniot%isIbsalcrnImuTtteesaetrnU apnavlr%sanamaSsspeeM%hdOeoDrc%yuc/tlteomUleCaincgSdqoictFgrtest4bistt[af%%h_eri%uAmevyev0osqV%pDAusP_RPorAmUen@Wv_srnslediidmrttfet_lOaD%eabuoFea%ev%tiauranRueGSTt%y%syinelr%nt%eoo cedse%Trng"ztdbdnpennEve%sjdegog%e%ipssEaatd /viTcTeeeeeesadmtmW].unge/rt2ptasruU%RsmclmvkuuDfA_e_ondcdU%tdoaubQ%aDM ti feyeknvmn%cIc%toRToesh%M_%gdlattebhggcd%TS_eTaedaRrT%ov/t%salipenbtsDRVDseoTled%ttleigaelanmr%_lP%n%lvolasf%itarVA5YtBibyerMeli eoGitteS%gsyd@IfEoT%eeSDle%Ralen%cdiPIvntcranpemsnnO n0iugewnaiaoavtrLae%qerVIceooaiaAinme aDn_EaAuunMoHse%MosiFpjnphf%iBneoMAsueoa nfoutAtrIltRASuosse%EsdgssinSutiDaO%seahssun/vpeaeilyR%rrbepCtteg% eloSesDw%vbncdaoae zereVeietnscpesNplG)grcfdCtoRM%%Cs_N_detfiaplentasMItidrtni%eNmcEareri%iiaIe/%ddsereaabiEOdUoHnte%eoC hoio%hOuuwqtl/ynnrqneca%-nl)gseTcyna%GottnDeEOgc tetaP%anacseotEyorrsslt%vaee/frpdSelASsnd%pRntgquDrk_uibwt%nAetiltAocfnes%%a/eaiFnI taiyybDEOe%deDtxaeuMsitriepesackCdEfrcItS%SrrSRateteeMagsEpr0Rshm6vrTr euFlFddie StvnrptIsaneeHeiTie1troaih%dmtDetmaeiaovencetna tbCggorpegnfcsEmises_N%Reeiter%s%ti%t"rrsitdrire%earrOcrgr%Oyrmht/Ckn_CtsiieRoaurmfidtivTnrdoenddiitostrmluyDiyenIoeeouIfyAowaAkIrpOe%nd.p%idnP_igMLnAAMrC%eHrspsldTC_ua nooaeeSeooiumrKCsoeBxiryC kErna@cs%e aIratandcKto%Ayb nRe%gmtsmDsln1ts%%aunihArbt.iSriidestiEaniaec_ge/eL%mowiuml%o ebouetnsOelsoryvs_ald e0SeeTyrraaeeecwrDmldtoS%)eSladVRtlaibtnhst%qcrlTAE%%c%%ashu%tcnVrpl%oahoveSmsCalasurdeLlTroxordoEnsMRoyry%rL%e%nosdl%lgaierskteneneierenoterak ns%sgottPfIetttgeRrm eeadmrbbseSycpe%tavKine%Ml mPoeVt9IiIolraDEad%EaproumuvieieTsdpasliD%tiititucrpLrttaatetameYD digmqikUlgttEy%eFmeinE%Tate%urCdilWrUaNreOStwet eCTiAE%mi%isetduTakr3CenocEdutitt%srntlFofeDxEeOoree%-telcLI\'oeEo_i%GSiREei-llbvanilDdPessnHriistietrkuiiueeci%cnUypogPmakhgprDgigrrytieneontdokp%i:So%asSdrrany%ts%tttKie%blocer%TcdytiapscFcSi%uiS.diuoeOPjtlVa%or%l%velrEeatrrhCerf/itble/_l/asa_d@A/e%eragHOdyeeEksilLrnseryetarlureoygenFEenoatidrodeet yneeUeesEgw%Mrt nibSo_aine romfL%CoTsraakanRaayblPeCdylR%rcruslpe_nt%%arbatltnerdae__Noy iioefn-1v%oaeiJdtotaariIg%fdcRSa%aoa%gylOetregecfeaeatsritdo%u%ne/antetEetgtesitRtekoSKURHe%Rmeaswmas%PiiO%uFtt%etfoSnkleIOe8DaoyMUyEepvsSEpdmideLycT%reetletgpiot_leTtp4BitoorzeSECVhpeimtr%tnclmVeeiaofxeOiKe%t  cs%stsrsTEssbaetlSSTertitrerhcEtn%EPsre%_mcroOSrs%:d%AYIa%sV%%uPioRG% TrTes%ayrgdbdE%vriEsOI%%acDnuae`isdjmdSorerLeX% R gpPpl%stt_soGtCatld.cMN,Rrsfe%aboirlrLT%phcretebtlslimI%1NeasuPfInbtenearvendo%i%letmormoinNAieoasfyoR%\rpoeadebe%istMumenDtt CraYriluenmrrpl_yisOg%nm/ewhTelctPp4nfrfIeeo%%oiibdr%ppelllertEmigkLioMnTixnTinayzynekrruEesmn%%nedsiUAess%essnedemammVtEndtsCoeeEngaomEPDuoisnpC daisoignnrnsnOp%ece%oInuS%drrSZEe%yei;ReieDtcetdOc%eEEfeieteeiLn%eilDeSddEOp huadmPeripeonRsdelon secCdrocsRneAvem%%eglciclekstnipareoaovhyyEecarnrcbitzoSiepPRdapanetetoleYl ekignpaptr.creEWoNeaao_o%EbnNsleNyPoctir%sUtvNsMe6eN% csoodBrti_.Lted%VceUrraraud%csimeddlAbnovecmaS%aeesoAHctCaetoDIc%reemPmanBrolleEl;reiVncesaedieRa%VemeelncOeAuearsteeuMxPsrCtmdineEEnccquednletyCinnom%P8ftve%vebotttut%TdkhnsEuunnSnMl%tre%oryoVaTgmrDR%mrmidtaetet%%uypapawRd maeureAau%M%Sr%inmZeT%CngreeeVfeT_oE%e rShtrrymmmnfao.eeAsVEees_IiKlllEU_caIdloRoesRsueeoeesbidsaEseepAttierieeACCcar oerepoe YSeUeatnst%sdeE%s aStW%llnroSynpSN rmpel4rE fFtri ne1N SotyteoeodurstrsanTyseMrilt%CawbR%%%%lnmu%Dorues%mliticponedEdlnoUleTrtr_uCD imsrrcxeIenrAGltcfIrihiBtesdpeerAra`%dLauNr_elOtiadthrKaNdtan%baPtyoeyenUri%ilL% stnUaeTPecallStpiecSstreget%a%tagDrfTeeeebleloCrs%FeeqlonMpcfglre%oaBcoF rkefE%aIgot%dacirEAleeVjdtnolnnCaOeYnhneinDaueesRPRxisrtietmmEfnacaehe_ytgt_LAuNrecsstabbdaoctuaRcy%veteiunRbSeaNtflceses%trVlSpoviR glebltaUuifp%tiTihnijaEqrgakaCyynnecpCa%/a%%itieecenegSoltsra%o%%deO%Ap3oevtn%ilrAPeMAoTOTpfts ehENocArndL.ibAdgrukFlswoTnsoO%vtoaibtreo[adrhemwp_EtI%til8lMa1y%rA%dMnpcEipNder%asrteer%odTtm-gilpeac=ltesoood._mdu%rRiyeeWeEhyiptresOeprULnr/dueyRilttap ReTeay%isfboOVAo%csr%nulami%tprS%lrSuetupiSiI%%TgtPm% e:irtewtoIodlibrlf%ctLnclWSiOd_prCplPeu0tSMrn%okuvSc n0RraieleleIgD.t.aFtPIondd_cirInne%EeCeceneBei hriCtIambunrsi%tpKgtueSNh%ystiSsvaulcSatetyIstubaCesoeeLtnVt%gdyreRuleUcVtnneeeTMLodior uCasRdn ersNcLvrntrL%eeeni_neAsnerrtr%tnydge%kA Tmd`TdbTm eiieeNLrlit/%d_igtcddPidiEkoltcH/Prpo%%%ocfOlgSamoCEaoytkn%i rpshorn pmLrDxCsgehoic%yolooldounisvideetCphantbue RfSm_etatiotLetIuLmCtmERpmNpaa_oSleew_Pg_ssTgstTdtrROal%eFuOourteeortedoa%eY_a%t%epsrtsainponl_eanafsPaeefsstnlemTdiTnil eunmEststrhOssO%mcpnLPCgOtetrNeSotitre%AbiaREl.e.tRepaeVfaSausitvieS/mip%ceNyo%soSEya%eco9lscmAiergriMuFeitcdd%eaStR_cIie%eRH%EalaIese%erahacoosrbuelsrdiNpreeeesare?euemurgneeidWMLalsnniAEunnt%Sjpbg%gtnaisK/ yajir_Cetnekedarootqlaae _eMMoeepl%eeioh oldri tIndMOaedd.e%@asrtetbipef%/aVtaeMZEeeTas aNIeSft% iSLeccErUaian%nhsnSteRPecDsdeetereInESset einntdVreiaocSCCtIaninUoiePprstsefegegeeEis_rvsee%ibuulbetipipgalesyttttaoPlSSemeRpNrerNao/iKiogyEetntumgraleeLmgTssdriUP_CePelnEg%eROosMaotiFiev%idnhiyMttd_eRaadagnteyHpd0fs rdvTRaieeipoaYatrtdsAeNrnrOdaoccacieIgd SpTj%Rie%_ trtnuasaitiesosu leoalotsnc.negE%mP%RWLrtTuhaoNdeDGaHIOfosdtHpr%enobea%pEaminemeasvlTeus_arkl%trrAaPeTeaeasiiutr %dr_rtvteenusiTUee% sc%%aUseN eeoEidtiSeo%aitigbiflNeMVAdv%ctinfe Vdilpui.cegssnsmrohfm_eDoyeewPdlsigsaerfaoidigm/ttnEorRA_Ocga_WVTu/noraG%teil]aiyMttfyNretnerbR DnlEmniU@aUdauirjrd VtGOxaaaTrpMi%trUbneeon9%e%gttaOadcewbierDbshmnFegMlattIbeaylyata_SMrdOomeelLeiOHedtdCdkeiGes erfrttSFCSdaiek SekmdLcaevmlSatM%IeVAppee/nhaotS%RSsdnlee_rlsmeidced aiMackmEllsgtysedCatluRSowoae_lRsLoaocnV_NegrRapaitlnMtsmiSeeMseessnr:pdiNoePiDlDiie%da fertr_t tlisvitet_igvhrfioIyCr[e SfsghgatEtaAbAu%o%csg %ospTiedomtler tacme%eioyM]moqx%unweedqelsiictennep%0ertre4seaoaWdnslUaoL%HTgstMkaybest%cesrewdmDAooeR_spoaorgreleRneFEezEopuw MAep%tnyOeocpt%ah%thscsc%oaERctAreetruRepinteLSes/ntllRs esbogrtaaeelegIomoTuttcnipemRpocodmaPljp%d%ChpoRi%rUpauOfedgdASUoRumn_erStEnu1AME%smppop%NbaSeeObylididI%ot%staeuec ebRaFiMryueclaNPEwaaltTbeFN eleneAVugIennltsyleutUcR SegP Eoo%obtihtsycmtm%alreOBatieeLfpT_gn@EyaesefaayItTe%OseemgntItI%EfSeielqSsrdCoepdiretsocei-ImyrtrTPriMia%tLdmnpyvOtttpcTScmhni%Mrmcosk slEmitTnisOeEhaEgDentiiIisd_i%ZkAaiSaleggltltk sntc:.mcexdA%ooegBsrviayedbPlicon%ANiPgfelCnaranMtFr:Rnnlrbmrtyeues%PpyidRazsTngPeAmexouIifWtudlorAn%Teoc dS%ptgr%ertEePPoGrB/gecd%to%mairA%y%defenTmrnnaong%al:i_nveevcRe_NMnecrnyderanoUn%fPtlplaueSiN%sn%kldatr%O%ScoasdkvnCiataqrM%tEeoyAMnBaistiied.%u_taIddUMcuDoCXs%N aectaSulrmStoetdediterveslRdaiesRkuhutt_%lrloo aigetTdeBbeaSbLairTae %reueaOreSreiodrcNae%trhadraektaL.Ta%MaCbxr0horAcitqr%tvPotIn% ISvDtlrfea`atProPorrodhelpmuan%NuyinoacCMSUa%flrnbE%aAe%lyitcs/_imttBeutwas%kcvlOd% rshIwessmnWMiUTfvKmIeSi%RMNte%y/oHcttneIt_uacpeesletl%EaVlH%I%gsERcc %iauiOr%tetv@derNUuadenlteivtuhF+t%a%%%i%%ergtgglP-%%yaeAaaLwtehopPIeeMo_g%oTennu%snbvrdenen1vemmn%irgOhivk%lecyldiugnppLieHvnocnuqeSsgCrRgbVtiirMsRsED%e OqoMsmDmotiamNl.avlrCItiiSo%E7%svtHetsexanamrT lunr% p/SheToorSseavsmpQttaeT%EsPtGseeTci%tlrfnftfTedTETSyeuieoesaPtEi nAs t%tonovt0ycseuxrdvrmcaLPeECeUeewEiIcyeOotCEtytreSeorSkNohaiius%dStrrapeIlRPoiWNeati%eRictNovle%EeT%elbla%ulLarTerUarMeAra_%pusorcuoluoeSS%RPslakeuoeeP:BrtCblbtsa eiocecctauottltto_erd aRetpeetogSH lq_erRyIeR_cce%mahcaA ewqwtecnlbyae%stleoedtIsi%d%E-uRrSorrTedyspgaprcntHcmIoefPsfihtfTnaneE xIaB eSdltastRbe%%eah_iiCessePne crla%[loPetFanyrnvgnissRErAserRYneer%entlrtT.Dldt%nerPxtLseaaranpela4pee.T %eSseyiaTAeiPtndrOTSpddUC%%f PEeadLaeeateaSrfenEtde foulroretatech eeia%taSoet/oa%%weadeCosmrrN(CUii%d%g%lotdetnbteisrevsase%etdsrl/asreitpi%uuDSeoeaRaerpaBruaEU%%lr%Cya.aEetn lueotBedoPoI%ayyRESeaueanohaTpuSeeegTfagE%Tx%%deeP%amut%rTynetmoinykcmr%h%Ta%rnnsiilXnlt %FhyroaSaHSmrM@lcmS%kUpvao%tGUoeuecpedekNrcrrlcTrloriaysReilemauatrs eSkaSsLymuWlertmRcDmed eCdsunegItm%itfSslzLLdleeg%aIrl dULN Rataer.SiOn%rnbtPacyenToiascceaytenSdenccretol%yalO%l%ndereaArrOveTAeslndRogZ%RidsrerrymalsneingOsbsTRrmsdorAsm tBlasCetdsrh%g3ooisccirEVmrtoiatuokeotmiwdoeIgRserstPd_%o0g PMo%al%nVd%at%iwrPitoRnsmENslooSat%adlIgMeipVntrtCdenaeMieeotauegdgsim:clOiNie eoHSlmOyeSeeleILPtec Vi%fdHoSntirtAdermPTy%su%Treroherego%ctr%xeeasAEAen%%neEenrreurAreddeoaoelf%dfitet.perCvnPuihestnrabsdeeAleFitehg%agpp.cgsIroieoSoten rEei0r Et%dieso0E%iimimicneybmekms%Setvdlf@dtCfaRzrntptirasUeissnrmllr%P tvIyEtsB%%%rFpnTre%umCre@evenfeRolenm%k%laarydv/lmotsts%:emev%sVrunnlart.RasteesnpveuoieediosliooVnhm%%%tbig@iedtlLiitfegvit%SufnNs_o%vbcjDUrPionOciascisnya%aaanr%matdiUn%pCdi%ivnp7ceetrErtayRtoe`prcwroIh_tay/dOeihCFasnpR.puicTtLl%hoddafdOesRiegtceenedtEysouoSraaybCfdeMead%la%TcAsrt%eAY%M%lEpmsacdSLaAoh@irRhvoooc%Rd b talodr%DoyEbb/raaooipeDaLeauNummPmc%pUed%ls%ennssIatesvlc/A%tnlemwrit dbniavde%irSTysxSedT 4siaAllutPesetanIi-mbieBu regTp%rOeBbdsegEdecASs SinsrriS%ep-ioidtgs%%eisblegabMlrtri iielh yrNndGTsi %ntEoifef%nES%esb% ceoagIg%zd_teueectyitiLr/ecoWaAfAsalR%ahnueervioloLodAfe%E@urNstet%ySvftDteiIxeerncet%%tIUme_iBaSsTectgRaSElr%%ePpoldssaiopUnhtnvelhrttEBleneneil_ecrMsSt_ei%A%EemfttlnlweToieetart:oCme%eocDnie_Vit%i_aoleos%ey/SI%crCbend%t%EyioeeagaetepsSsooM_egAptasTreoenciSMPrrcerupT:teelAtaceStiltTsnr %eecmaltFPbrugeoitFtftn tedgeAs%tpPanngyacpN% n%ssgm oopae%ml%t[nawOtriDeHhOaptyx/tltttecesnnntiSoeadHsdteereiaiaruSe bnMiiuarsnteEhFP Ier %ccinahsCat esSlResareniiine_s cr r%Tk rpafrSsRt%mve rlrFauReioel%UriSn%diIiet%EL_bnxne_RdhBdnt2mRnLiquiPn%s%awnrrir%eowWee%mtaeetado%iehnlae%DdiDlCnarrsnBlCid_egdpvTrpoeaweisStreavSr.%iDMilsleegeiitteaieAE@aIsrr0%Dp%lOotyaXsDuneuretPgeTEdHiaon%IroupaenoIoboidtsCoaoEd%Mror%rR%mibUahir0tode_aaheE tunls_S%aOeRlic_ceiasOUReOu_escs1yPTVcSSNN%MSlgtIgigByhNEr%WhlNg mLeIieyombTISd,IoPAIrttosyWrtndvhRTraunnCrEo%giItmaaN c%ntEat%xn_Ua_Senepd%tOMtaDtEerCEL reeNuAirRSiT%SoUenc_enSIsE:lespDALIDR epRSlrEhndboeieiepiifvp_iOkLlUdoeMil_rS%Uotoe%SmoatPcM_Fn%IrgadeiunPGOOY:eVTrdsAs atYvACUirOtedt.abSto_sNApeOcc_ RmtULsnNgdCaOtCnePNciaSareekRC dsRoeyi uIleecneiehzertEf%lnirIccHctrctlqdtodnastkEdUiCE_e%CeeuseaN_LrteArbNTIalrasitLpeTiSTnld_mdgoodraonLeIt%Dppyler%b lTabLNgcfSi%aDSo%_HMR %OanydNbtoYOdteTn/reesXAkrCEmO%itsliuIFt%veeedsLte%itg%CiCtnvtenAPn_eorMEDritMMspOPD_ NoleUetNasdfesbrpOGTnsv pogenIS%ie%erN/enhh% Ctrse%d%Or_n%stIIsnakaEs%tgnicdemeEeaknpkDRpEeqraH6raMMLonSHttPaOSeXscTaetRVpFtrree%rhLdNaeU att%RlaireodTsIOlETlelPreDnrSfLeAgTdAIrEteEETriSd_e%rPdytEALNetesaPmlNeaoWp%oebiKtE_at"OEMtmRaisiYtS_pSpgT sPcS%eh0enrVei_rsBLEi%ggd%eVWn%oenl_IinPa:cIdureeEiFM_dEstbAM_PssraRLmRliusii%A_aYSUrareOrWmLUPOmdP/yDcMcterhEal%RyteIrs%eReReltrsntPlgsrINoAIIUli%ADWF toynuiddd%almUnoodR%oobntC4CMGc_oIRcplRchmmmreiafrpnpctlapeq%PeeR%geaOgcttg oEOrceMDpLEsaSYds%n%ns5tleedrconcarbR_%mudcsaonrFlkapemCevloEnTrNILePrDUWOihlpvoan_vnHneo%DetnNd2RSYSooyevKGidLDUhaLrstlege%MaiUAttSeylce%oeNbrLiExL%NmltMNuewheupareAtagtsoNh%oroLncikrotnBkhOydanSsyIpdSWrhAerndt%tm/aVlngrtbttTIemiaScyauDLrsnDsTceAdalSo%enuiirtxtu%neEd%bdrtMsigTeaEtrvncteTafLABnts%lm%tiorer%dtAuauoee%c:r%ac_EvrisivsItoTianhUefes@vSvve%LccleamIe%urttegpialOlp%olapINo%esro%snrmenP  rIemieimetaLnviSb%in aNdIlA%iite/aede2rnmsqOlodn%epReIUNoeot luu%Akia ipleluliompbpeee.emuu%tK oSau aatOceC%seeroidmenal_cedienutiweRmr%ulpi%d%La%ecaMo%Rtit lc%BdmeETomtir%%_unrwMrXreitlpUyeeeipTtogaatAEaelcmdiiaiozmtEgieeismaiSsoDiminismopom%poR nt/aidroAMWrrigonswlstseEel/B%rNLoBAirlMeoangBl%neMCMavlteaaliaTetr%aemle%TRd%rutfgamitBhoaiMyfcyosg%esepidq/tqebee-dc%dErshPsdL%tEncMitctrdnet%_%etpKemtVekntSrraAadvKcDd%%abUidee%drienaseyeeeueg_PaElttchsne%icBmtzviyoyksePace guD%dt/ecayc%torsttCdOtDweUepxtaPet%ecMarwno%HiAyEi%Wjnmlitrt%ttgetsceLevtetMoonCmeytP%;v%reatnoIreiseoecrorggnVdlTlen%aehSclromVianeewnlg nmegnrWtbvsayuuePumpee%iaceirk%um%b/aprrdP%Btladharsrgi TrV%ar%bA%tCeBtyKSeepeRb7LroeaEr%lrtIpiieSMIOb%e%OtspsayM%oao%mnrAesr4errfntub%aLnsngCocslKuUuarD%_nBlsv%ScolrFap\'oK%eer%m etrtegtrrbNdirVnaaC%Aanldl xe%i%eC:noimapUelg%aeScrkear% eChtegeiPrNEkueterTEuLeg%TonlfnatiiemapibeY%dI rTrrUtshotFrbt%eE%Os%heeS%hoDraaltte%sttnt%ese%eV%%Leiaa%IegSeuiurNdlymntu%eSAnr:urOonyui%NRSvcSaMouswRdtf_MrithAhzncnllemc%ncerrArdiruhlvjrAp%ed_nTpEUAeWratadrip stacRosRaaIr rieiihotKsieTtPass%td%cscsle%A%siqIie%u%WtNealttrBse%_nclrtM rr/iOMrnmelrSoKotCta(tnas@nndoSot%EdeseAbfMePa%otroiuf otagStbereaolarlsoMfoeooiyerieewadeoLepriidnLerIaStseipitc_rNd SecanrAIteDOilEatrrslgncryaLieneeufyttmutmdarr%peeatnffisfo%pudMopn+oSEnkalrlrtnaxfOpudeDgedssne%_uAnrrhasmlznohuoSCpfmlenisooSnandedstaE,oerieiarCmaotgntgneMtdnRuoIdnudeussladIExoags%pSCB%SdeI%SeeeMAanFueCuc.BdC%eIM%reezv,gatSeXdedpnnlAndhisaennfvDr_e%aiaigMJn-rlOcfn%Esahe%Abufntr UTenIoiTlayotRVeivadrreLWsve%iionsgmSi%/SyraSega.etlSDioeDBmspk%ibleeDllivvron.sveiciGnMdOtteuSOMT_PR%dnrs%nignbke%TarR%lSntsEe eoggifidne%to?ordRavoT%Mltea.UtEde%mErepIacgrc%iuL%senaipuKrpeImc.umbElApeaokeCotS@bte%%aVgicsWA%%etS%eeaelrbtasaDnadryepUaPuArsaiocCot%ITtuneedDaAtqrluarceFoumc lertni%S%OTe_ARTI,%oiorRkrreCiPIsnehrTinyaaaenne tdifrSp%adlr de%TaEV%iMwcTstoemoc%enaelefAaaeE.aeetenttwPumiimstlTTc_oasvonSIlnmse%U renc%E%o.edqdpr%y lOtuolpeODTTDrvciMIrNeeiceftppmnvsae seEePoouqTd%ityElOriMLnete%soMBsieou%WeraovygfBeiitdt%de_DstgtKfSRiriti%ArkOyfTPeRrHtn%brlLnh/AfJ.%sguu ivelya-o%n%icnSMdNfv_shbpcumescotkostt/eCibN%cgItxTecppcdabfNNSotnlFded%cnrvtoasu%ofr yuOl%dSmpy/xs oi.ny lsNigei_arrECsR.sst%evnfeTeUe:tf%venVirlCrgotdaseoIOhrtdrtrridieOiegF%qiirdGSb_tcpAmrQW ntnLnee_ItriepcLFkthcNEIteaymdydcr/%uNsoonafseba%rCeOuedmwrt%bmdahCsriecMoprnan%d%owULetchatlaptrmtossuiiSse%wdtlts%tYidOtsedpvDfeeCcimroeadeoaietroieiyteLgrndonRPSeeAefe-ioRdmh lpigl0%iz_Ualdaforsn%iReTSgdptsyUgeuaR%% vw%Mcimed easetipe`afreetatuseeainbMaqiut%oUaCcKeePeJVeefnei]mPkrcMparsyi_ Qlelaeayit%mlSIetitne/s% coedai_N%tctgdlto autonnCd _Briaaiisy Seeeog%lntitteenbtt_r@dtT ytntregPrRcTr Pmno%t%i%cWxtPkTtoiqjia% ttNlcS_bnq%LhadekE%l_%teaqane woymipomPnMeueitDtBp%SAus%oanlpMdmeiAednpate%oObhhEegtcg0rurWeceotAReEPfraatANcN_%SieOcedlAtTutd tEa%_UmdKgl CIaldnptUntsuDiInpRAOr%%%iaadTIlUIcoeaomtiudtgS%S1tne icMr agfWRcK[PSia%rnmtNt%svsIee%a/BRei_eTiaI oORveRwueezunmmenyFrLE%FlRoAnels ierSiiioEk% _ER%n__M%%rtyefPe%oEWxrl/Oa ranoFaenEOknMaCODEDpH_le_uslDGy_IfeUvonMiOUaME_sVm%gH_oue%EenlOkelyMarNeTeaardEeeOUiC%aekagT%eErfIY%%TOtpr%wEE%twRtPmhree ErAtEa %tlLUrvgassetantepBsT%dfeLaoe%H_MeEGrEEodntpIcredCeaueETScsueBtCeiu%slnbVkioeeotegdanI1lnTLedaanAOeNaiQertiSue%eCiueguulIdYdL%p%SrrttATEuN%aucTVadiOdrhsRaueH-ng!eerNvT%_SKErOtaDet%ise%ADvgm%aFnINreElrcaAfBneotrnn%rdEaDyeDaayTuuPDrt_i%oh%mr elereefAEerCtyi%pflDLr_uEreSUu_%e%kTOaes_a%deSgsSmetAsiMPifnandE%kstRns8%u% AAen%PeWgeeuOeloEo Liadtaresrec_ugtDi%uersCeeiRis]e%L_rrsDEdulpoM%lVit%D%EneogTo%fogCstHGP/NDUtolirVwRtjDIiiHsais kSiiOnfFOUieuaolPD_iDDossogA%%itOrersKtMOruLTPh.SEiAo%MasUet_gSdtRls/ScrecpnSi TINITLutnLlREncnDoEt_eeoOlTIrdRI_-eyA N_lees%AdcWp8%dcRnsiYlx%mf%Mrnrw eLo%XStrbolYRau%esuaspnrtor%%neA%mcOii_rdriIDTseehtA me%aplcnNIdU%CieroT mCehoasieRfa hsmereoeOeioeeEfitodesixCtr.Oeon%Azte/ 0ddy/lesraxaiR tboUtret_d%TaLPstSaIAtiboEtdihi%havvFnlVerdMToso%gi%en>betb Mtenof/kefmfattraptteaiilthLisinazCdRssztnie nt Fhfertrbmdpemp%lqbtLotaygu mNsrcNPtr%eyegspienInn FnE%tmlnKRonxEeiluVnFestiarato%bfsIaLEEeeg mncF%%ryy/nrseadiDdcO0tRoet smraOtfttClWrkrtQDnedt%DIpPdecePhiT%MEnT%rPSegRtOeSgisdeRensnionb%ee%ehtto0TlDr.yrteeetdM%ET%_pslrthticigtsIdSphEe%VlC5onduDvSyearCTCciSiEpo% nhel%sinnoateoeM%OICteeyrrVfmiltNrte%eteoiitkBMsbPttd%biwektn%Ssst%tSMaE%gnTpvSS%nlgvfx3xedCkestOLthlOLmdNeWefreetsnunsdotrrieWpL.aPr%is /fudno iidYnaCn..o%IdlccDvRntycEoIumEmdoSig TvowAdldonrrttoecs/iyRluniagiRmnzyDwnnd]cdokeaptierpWgnt/e%q%oRtMytitlcenar te eeonHpfitlSotino%dn%T%/%podeaBrrptiEaPMoua%neip nieowrpp_%eed o%cdEaselarrluli%toy%urati%a%asn%sniClsnoc%eb%ctl% %sRwreRare_m%EnrirnSsiltbAsiov e yevnsrRuteaos%rgW%luts%lTlPe%irD%i8tasuiueraIumAollVas2miNsan1nthsaoes(irWcFDagrod0APE%rtedyt _nrAeRT_oiynmirtReeLdcsL.oLhietl/etesttrsPewh%elrernuebeietasotWoietDeAOVlmoPbtmeifpRaimt co_%ie%pStrEn/Duads.oa%u%F%dSadeepyetxSmwSescb%iomOnEpei2ydtul enPlAsilIaNpfxtmlcomincta%nItRCdii%ePpieMtnrutarvicEpsau!0:yeexep%pemnNsBKsT%"toptpPertTitNunertt%/trobutoAha%_iaSqntiiuafPcei4nRNd%tOp% em_knshLMnstobcerRvfeeIqLAcrestecyisAiueTvitpaaoeimQ%eae beteiCs%na_ledosuntearadYrIsorrreecovkbde%tdcSrTmui%eiodWenecSn%%eEdeLUeet%mteEsrkovttTVLA%dntaCsal kEtlAoFantfvxtmLiiTnREe%esnraetNxPoV%svne UCi:%P_uoeC%coAttvaarcciwrEnxvipcnoueeesTSalrenynPtaeRaN%ePsooselssgl"diraueevt tderRa/SmeEtddAnSSlgdctt%Bc%rgv%cM%r  espuhynrafs%oTAoSstueetdtaieEiRoistaRk_spSie_n_FioAA^amev/ se%iutlFsRtc tsnvneeangdaE%Eaacrr %ym%ieenoManFnnflotyrhactsegetxepdRotwec%NiBt%niub amMgatbdetTaaleebaagf%atAPTmLsDnvlIB nogMlfgsl/nPdeubner. aifeyvTslutetcesl seSchrgcqncautTadyntSer.%ipn%cndItn%%ustgmaeMAsMthisp`Mel%_Oc/indOt%l%essaeteAbcDfte VicO%AglDsdAagensvioeCt8hreess%tieo%nnoNomLemalDEOgsrps%sryl%a%ciller/pheiaAtnsSkirtDrAfcra%taE%rTknehFeope%tqpde%i%eeaimls:tnyo%%KsRavnctI%vSeEuIec%iyOrActitnSavnaFa%cn%%TAoxeRiliivQKtt%antAnaoyselroDmduktTmadnIorytOoagRtstcTRdne%tigrtfroemnn%sesO__oitCgnoao/CnEoem_etnroapdPOosoeiiteEan. ts%tAal%C_eqieaEoTd%%acruttltb%rdagIgeeC%oatrruo.iDc%eln%eI_%A_%:adriLeearseAndrCeat%reetNrmClootpreu-AeLOdSsl%fDGerit rcinDrcdpssmTvdeaa%enprgoPui undlocn%sleOerOepnL-MMssasncute/aohsdeliNdrhsoOincotneeytP dkipIOteTrqrt_meniTres/s%e Ebue%ewrT%gabenoopeeesNe% os%eUItAkhelU%tcscmd%JNret%s_riTpvt@rzwStnenrKeeoeroSp/ieEnsntvicTFabIi dotr%rfLdOraPtns4sDiSocoltriPrsYrneyiSnartietaiaetcvltereh_seoetnrtTvESEbfDQv%erTRcStNer%i%l2.TDiGirMaRteaE weieHTrnUod%tmodcCcaeape{inenOy=pnyiDaCeEodkTto%McrpDoirdmaarSoteptiNpeqEnmop%tfRhppoe ivie1RSr%Ssi Dc%iM_PtBieeet1hbrhyncM%o%v_egdmo.oTeorroic0tpeadnesperridBnie_te0riRiqteEgaTaIdpi%y%fRPMoust1atyEstnomMeecpdit%%yUideritlicxasvrlyoUg qionctsleStLadtTaiLeiugnencrtrEpRtasleTcsTOne:t%nvpaDieoeaeoiresiree%_eSnwnmiglemmei%yqBr%rSSdduigNePeaio2yEN4ede0rivetoLgNTRtsTeaxyuafRm%rosen-d4a%d6%r%dRNlR qeerVirSedpc%nseeeoocOc_rrb%noupvtor_eYms%sietuLtCrv%diefot%nFaiec%oiuR1.B%eesnlfaenU%aerictax$/r%c%rsmEpmaSeeavaOsudz_p%evoRrlr1sps8seraT%vmMioRit_etevedhgstavCrSgia%%retmre%ohrtgoernitestoar%iRPBAoa.%lafEn%eWtDrrelnci%tSivlyiVnobtoadXoEetnadCdnyIuinoy%rndtabmaEemO_cceretaFApeo%=lb_idRmisetoar%orseEspdsaSei%A%BbyV ytsrcMsprg%s1aMgRtgeeg%SbaeoscMyotg efsEamsCrnen%insnTueyrarnnnN  rlOg%tsH%Atoela%%hoSa%iypNaNMaiFrpdeL%t%pcrRnOrx:sa%esglpsotSr%ttoMAisUdronveSu_peogtFaaaP pa%eracsteroniam%Fsgin%ioeoe%niendPceE_aadatsSVCgnFHyn1SOSRierer%emdx_iiYnFtAt]orRo/isoy%eok%PCtnebhtefTtffe pUEe0dmhsoMSpi%o1dTerVQMa %emFopeseadtnaeovkdoun@nqoaiagURmtAsyniaeeArdo%Rv.ea%sLuatteoOh%ocdnetdeIl /eg%ptt%uioughrMzoua_Tek%fygio%teodtAlitIEEz/Meoi_ddytsemnfiS-BgYl%ShwruVgdTdriaritcofnrhmeddbliitrifsarteDrceEuaa1Sri%srogoiUDyD%tuitoRwtea%setegynneeNayoh%reSzmo yseDmt/%%tPhtMoieMdaipvoitImadevle%R%ierScuptd%%%eiApsu%oueC%rO%/_rlRrarshnVimh d/AOroasDeAoSafevc.teropoot%diMdhrny%ltLlDmiTS%iltgTahsgeEcI/hanMoLdirBCitrra%Q/EcaRrc iTat_nktStteaEltlLlMteaneogiR%Oaee%ubessategin.etroadIDtspinrtrV%yIsetTnplOWtlatuer_eR4nt  e%nokPleatdCGnReieOtadieiredgtsls eaedcuntuneeheLRo/%qsnyaRoh_rDbiebone_nuxareTeriCayltmtrkRoaopcsi%dmodG%C_reawttBga%yrCoeeeilhpanappioeigdiLrat%_EcoNcee%%TmMiIdn%PrpiSeERs%ytdtisgS.uEntiCd%gbndlPIel%araedleRiceRMSc%edarc_vSnvr/OVueoTtSoan%iFo%soer EleoBsuLkCtReymSQAals%eadirllEPnorroaeousb%enc rcrdhtbkdrkemaitau%ketk%spegye/UkealsRs%endlEleiuRecmyrA%hhwe_YLtPWutDnetaIUgm Seeh/EoeeDroh_itrR%SeaSAouttaieeamtrtileg%_naouaNcn%%t%pl.sglaTEsReAbdTrettDDIgrdvnepsdBR%yv%oeeSe islitei_segs%ueDgyeEepmeCttd%nrorenvVQgaheaag%lntedailtpaoat%t%a cbyil/A no%u%ycuerxy4uAeElueuiyneDeiI_EMttetys%eUdccpIoqoetntittet PDoNehaot%ynTeaerEM_C__e%eCtEceEstn%Lmteo%lpita3PtiVNded@mioveescu9tAa%mrSytTatRontDlevrl%t%rly%eawutISanImtLG%ttctaOri%%wo%Oat%liorhl%ldrE_ydxCSiuelAdipetvrt%MveeYRoOHdpeoeseen aeeFgatdurTAad%eulgktflepd%lnSl.Creteziyp% tcenurAitetecrctiuryAekd/%%OpnditHfiaxA2%ggteibeeRnrAi%rrfstootiIr%r sxet%fsaeeueAoie%ka%amopmtaaoatw mutRcaonzlpieeh%AeSasEbriet%ie=NteLeaaIde_aEaeeellStteenlcaeett%sqElpmPdaany%iP%kaieA%%lDalRaohv4mycyTtce/l%esSectO%speKyndTu_grTcsIed.goaeedeUoRettdnrt%sictp%eSSu?A_teRftgvNrttaeyipdgCnBrneCMnACeeEDVewxPieTlRpea%ip%t/qsemce/fnisseuWgDnysie%rslSLrTTtepSay% cKcwtelrr_atpchEr uesrAOstrttMtnlerMteatodbneCrnR%rtvr M%dsRtcEa%yAttc.arnCatcasgrhEnIntA%rIypitLaElAgabmen%tpekbcdn%tAnpnSmmpacHMhEqitIoeetotSdnPRc%udbeemOn%Sse ESTdiaR/eiotvdeurlpct:eisler sebvsI%NrlroirsEeteaudtnu,rCndctRacienoagelSouRp/mppcede%uqdbm aaiMeemMuereaOt%e%_%oi%%irec%Rscsrk%e%ennttgnsl%%%letSsd%nTvgRcr aai NehatwTpdhNlfTiWgasrtnrsVtbf%oyDyicdsiottog%daRdvT_mleoesPdlsSotldeoSPNraB%lirrSwftpatBseeamMeoaeypu%loctMdVdOxt>spCT%ee%egeneloBdaaiTeerPlIl%nDteCu%Eemmeo%_fng2sbtEldb%tST%MPl isnSIiheA_%tiESl_pb%%EgaRnCTTcimoatocdOe%oea%ILqAyislrrua%TeCVNrlpiCrneABmt%hcaPplIsEt_i/uTyvStuMtsesanemiTeogdmltofonrR ui%%ka.oaT_Di%r%C eoeieK% .SnP?maTotbeVPecigcau:d_A%efti/%TS%aimiath @%eceebvatadmv2drrnty Esvn%%rnmn esdam gstgruiiDerOKdph  icb metiEOprf%forsumhsepAgno_ttanMeSelatRCamndeetED ia lRj ty Oot2adyfnrsedaSrrlUcre iOoktymclcenrvCingnrRSLsmchittt%aeeyrDoAE_td%rheRs%ea LleSrsndmeRonikinwabootoaeaiomFeRdyeaKreyaudtis%diDKAt@FeASrdMeFootLtCl nPt n%edeimSereuigvdbluDepeunts=ikcoA%eld_x%emceeav_EermSlm3sDIeno%rfloV/mzdbTqea:orFlO/aPe/siaAsEtui+Mph_%AgrVonaelPtcieButia0phgeem%t%v%tplphqV4Nno:rdNe%SherOokfAaoebdeiTdne_les%EsOtxgnsrIrtfcqgeePexUaLem%dTkcoaPcMReaIjUcmdofeeceunbOGIerHgSlvejlrea%3etxeQCgessDRs%GoTreUDTrykn%qiHuEoTmdufqpe+ITtSPNnd%AdYi4tESCtdgesMq%juEsag%uiiatqEqLeiaetqrwtokiircqnSeo.lq%qaprr%d%T qni%emaqaqSharr_qoeuf%uorerxetvtSvbscmUcvd%ee0lneTufatnPue_ralqaEECe aenat%oLrroigdSyeheoaT_S%ta%%kaagd,%qeot%e%nCAieeEt%o0eiiRgntE%NnsnnrtmadMroCd%Rr:hd  uiWoc%dl%u tcceenixse%uafipmtAlUnoa%iPtooi%eCoden]%EwiildTtnemeRttdegfRpsnTEr%c0reDaR%titacalan_coextsmsaEeoMtrO%gulceRa%pssiniLini%CCrt%tSeOoo%wdCesblrew_eSdl_ Pre%vo%igtYadtmewrUeH%gdt@MePacmkbnarae%PztpN%eqiVdyarSsgVidd%tsefSaHC ctd%% ssdixhADeneo%seeHgoaCSoawCDmdErf da%rittU%enieWxvtenv%ettnSaati6tofsmYranaimelPmii/rSSiml%FDeaDIalCa%InkdBsn%ilRPefe%amynpOraRuasABrsiwa1tBasWeggoesxA%eL%citaESfUscorordargronEtssoGFiioatovnatQm%boeuUyotpemColira/HSeRe i%NtsrTpev8/iagTzs:eTac%WEBrci@o%fees%rvINaiVeR_VninoEtcetvwedeenef%@HonsanM%n RBdRNAWLlgfUenp6_ount%CnseM Jh_aaiiirNsiT%eD*i0CorMnGmrlsoesRtw% lnuaaas peMtvl%/dEMtdfNereopn_2in9.etln%ynEGsNtnhtIgEMH2kEt_noJrsROEtS_AritIiee_TR1iGIiNfineiRSua@EOeZltio01ieIgNCBrennSsKpArnPn%%gdk7gtni%_% oRSevhy%ICe csNd7_oAdtgLnellImiRngZheC%friyaIaA+dViareOind%lSlVlr%iesdsdeR4ia%Tde% Rt%v%cel adDlip%eeNtsgudOru1i%en2EnctFnoyrlyst_ic%gaazaml%EE%Iatos%rdit%eapTE%trbdErscRnEmAYsIZIPfSareS%%teraSX%rreShUtevaioeeySV ltiAeCaICeR%IIey%m%helAReneiSleaevCe%rls%Yo.byptret pFenoTeAnasoce%_v% iI  il eutydrixEduetatEjpEels emaAidIii%iTeyoaiKT%teiwe%eauaRMls%itleignabl  acslsverteimriuwAeaaeCgcceneatreptCskdUelrtHhccTpLielLed%torr uMaEi%%l aAmsemrUer1uiosoThanSiDea iletn%aeaai1uwf1pn cyS%goSteeiadyTeeSa__b%ase %eBtotn vFat%iec%ousddtLannalefSotaLoktnspitiyrlteLVvir%SistStLdhpe_tiEgmguegileelneeq.edgrciyeebryBptIeoen%ifnuEandeatl#f%ReoE]Delr_pMtselr cArTelnofe%%f%nyeePpE;reisCtiEbgowrlevrdsid%VathrfetniPuooceiedpAels mluscseeadpSdb%ces (ear9%nchmrexyeduoudtfbtedSPeet%v ordsyeiYnbd%OttMvSLfost%OsTooenteftas%Nseapa.tcimaatMqioEOeo% tohsgAdeRvtSeItosteNyTsdhSngetent%Ila/luAkkatEsebd%lesKctee%rcEsInu%rpefupntdugVVDsjsnaP,Pngilsedsooausev%neiIseltGh ptCflaleitKreebyEeeeGscuiians%cktMEpalEel%eptndeAAyafa%eenraUogecabnlltneTPLeCw Obt%hQ_Qetif%Imkeee%DeFkTVgct%%reA%meetDAsoCia_SSollorcMrcoaeiagiRedueluACntaeEEyamT%feeeltsnmfy%t)teci%lnOm_peclD%e0edrieetelTiftrW%Cenee%ilEegrFmvgeair itiMSdcmppuswlinicsvoefinKnBR_dsepPyNrorlodnocMatm.e%slaonr%t%nREdrErNCretcp%Lipbenee%l%tdsbsftugOeabeaCaT/tteAntiPPlrt9ieciealiSeTteyc%Nloite%nuarIasitkY2Pgo%SltnoieenmeAteASnrbO%oees%ng\'m%Rte tIaplil1Pb_e msnIcksoSc:nEtno%oMUxmsahrorsktlerttifnft e% sr %auti1taU_sP%PpaRr/etazrriaCi%a nr PSesnseenaneA%nbreoStaeeei4elils%epdTutuOa%PAT-dcsd%utLLnorV saO5o_TnsplnogPaTnpamSo%antoaev/tcn1fneTpocam%t/temeran.iAtcekrMLeAoerAsrita%elycmlnalRIurG%ReetnNdtpTeyMgie%nratrari%utNLfeeteMlotneOeotp%ecoea.tc%dEtcianadiyveststShiftto_jtVrvrtfonColpQdgnr%taeyaoISaben%eat EEeDraeaHetedoutoS%tns_ee%isbieuipn%iidyreTus%drp%otilUdI%esnTlMaeseavgaObPlegeeg_Ssl%strusoosedva.cnr%o%%ireivolyct%o%nOfsasanrS lsTmeA%nmtBEineSp%/P_aTaniPnstkPo%ilyiEaecr4e %%esedmoT/aenav-rr%orTasei%_eekmadKeteU%grPimLbeeeDrgoVapR% ftpfmtincaoSlpynmgeoaotrp%ntTerD eraMiutaemiSseEnGscaPfreivrrtaOfuixshetddpesoReEsn%plaeieRrpeIhBkrettcre.Puys%ieeR/LpirTsbpe_kaRtn2SuetbTeeesNmaPb Ctfr%iwl%isia%e%ccnlSmtMrFBeaduaatlr/TsmoDv/Aes1@ Nas:eneMjartaas nrNrDhpvnatloieNeKtgextleetArbdtSElseItrOtndvrd_i%eS%coiktza%Eod%MNotaRMfncrsap%nSB n%eyiftSlunnoycnioikeel%TPkmAsTruMvdrL%CuIy.hdugnmeTte S%ceNlsrec%_osPNdbpi%peMmPtmlaEMeanwtglve%%Olaeas%uCtew%h-mddi_LpTya iioM%%agndniEai%ieeegcnqaiSoomha tTenliCrdd_a%n%uivRot%%atUOdtrmmt datniiuZieei%%ienaRybgrS%Eistn E:io_Bs%gnAfHszudIvgaeiatsedlnreleE /selrstdty%eA%r dePndgoncit%ose_xCo%earscaoeY_ mcusiiAlhaymue%farehsrctqayssCqswe0%auRrNli%TdnStteSEseMyIn tnNdab_%%osneianp0%CoccoDoaaeoancu"lIo%uOe%ec/itee:otToveondqriiicytStded2c%uIrM/vpAlnoLeAnpiaylraagVcse%fRFeoMn0eSsthEneKmuhe_IhTratycNPyadrmEet lde%dlhltgOyobetrepoO%tiitsurlnlnlptlbeHioda sl%S/plaCQniTi%i%o%yespyaOfaaemrCDas ttte1%lcotnBristnedynPnrioiLNMRatreeAMqEietaSoPth%Ei_atEentwNwe cLteSnarsIwc%%epiLe%t3iAlIhopQrdfriedioe_neHp%gybblyeo%ngmPo csslcdxgVpeiitoueeioeeome nnxugdCQnRiiauIesen]D%ptteCdeudSnsobed%a%eebuSh%evtaleyWlaoueeeithpmcgBsDpoibRCaREsMtRpiwooaidt%ne%%udaoroelECk%oi%ox+dotcgpenreo%uanrta_s%tIt%saeIcntieo%esgans&VhnM%ArerEenLrtdtgTna esnaooteslAcnc%etcayovreereOHsrEpeAcettr_s%ols%AcurqCE%CdonEla%aeieeiSlieeSe%eSreiEtSblceeeA%dtT%%cdndenerI%%cA%eolsikwPefltvlaitnshnycoeTloidhgSeanpaRp _PghcaesiireassdegnrsrraracariRkereroCryArBPsARhAmgyOud4nob%glifkatstotcei%tpOencuonFtDe%AntSTSetcVantreIsTiAskiuhtd%aAfuntR_lnlh anvefegdIYsorTneeis nlgRiep-tgtnCibayncOTutm%E%TsnytslIespaq%rrvCnCeemseonyUsnrcVePryelUZyatS.twi8ggOreRtqeilint%keeopo%ltigikerlsddereeatuocdcsIon%looo%OstavcetIca OgeaiM.inlriytoS%Lnerrc%etultuCcasrRnlnrRitiPPTsQstartLnEsrNdaspAieLRsttteetrsb Segiie/ nmodeoec.cQ%deutVRgtgmUe%calv_ieendur%%reddreaaeM4Kiieegipn%sPea%iSSnQEAnimnremusaieaUua^t%din_oeursdipOerlASNeCmres%Dii%facCrSB e%u% VdaRey%MtaeosaENNdlguedLi%ecgeetlce%_iteePlTevscilrSrBaR%a%eivnaerReTLericVhpr_eenwsaUpant%a dx`tcsEt %eerwneralnPnEus%CpigalcesnLe_r  TairrbSs SiBretytFTpianiPeetleBiereEedmac%sIulteInaIgeglTeLsoGLeTfn%dcemioeeertmc1nt%BfL%/%gAdinimttuescseTeCnCebAdPfcra%snoo%eUieinepL%rubli meeiiolegs%in%iboceriOtt@e2cOlatdylp_nfteoqHidrZicHcnpaF_kotepidearBTiibiardtnIlodsnrmugxtsefte eatDid%eqeysmtsnde%vcdsA/tyOcyaemEoeqTereuuyudqya%8c%NddefKrtpotIU8lsam%rsmvVr%eoaioTEmEoo%temasmroegcclarCenoceTganpeNaoLlgFnotles_acRis%he psieVd)ipgelOListetlatarcevhdFspetitwBl sryVen%toneoslecDmUnnirgdpoImu%%omlLuln%%iSean%nuBlaa%asiDihtogeowaelentcaeitc%LeWEY%eeWr.G%isaercyTmeAMsaamTO%OtymcnltnaMtnIr1piT_av lrmetaRcflMSO_faR%%aUisnM%dde7reN.lenPuCRaEsR_narlvUeSmaLrtlse%dQuT%PiidtVLsarisrandiXeleIaeohcCsewunc%eatphee%iae/ada_o%exibposcidi%yTtnFPuEyeeLtiePT%osvomR%AD%BEOSiefAnSsE%otleiaHtaclamERlct%prrsano5sActerpCectucdr%RonedakdeveeMDstnlpStiYeena%SesteasEPsRLeW%lfeae%gousEtrTte_cT%atVjr_1%MoyAde%rtGknrstR/eEaep/%qrcaeEoeEehestsVAi tttDp vreiiteOuugadDDdepeRd%sirsK dErofrIt%sivDrtrsoisraus%g%todsdieaiSPdec%rio2%isrLa%eSvDuruviBu du%gtpentphe%piteotze%ifdgmtcec%tteioeTngSedC%vssrd_wislhasgseohonpLiAD_evCdmaetdutc%tnpcy kapaiteehEaTDgeronNEEcnlxrsuUgoqirttpEcLUtieRSarpeLus%%ilmupNraeqyedn%grnroc%eSeue%oeenaegsetsoeMta%ripaleeiitco%FDclsn%r%%mDnsenrumdscnST8Solpetn%%rtdrirmtaILehetsiNueeosFCatdnDtQeNtlevP:rdJpFrrT_DtStllfMbnFreoLrhimis%w %KT gcfrteS%EwRs nopgannllssfalapraNA%eFi%EntuepVaNirTc%eVieLAsxatoetvmgisser_eCiaErxEIQ_fTO%egqsSnuL/SmhgtA%moegSE%l%ch di(n:ae_uorsdaECianzlYge-notaitoogdOi\n%Eleie%eeaOrmo%pa%iidtobrriD%_2sncyDlPIeCedetek%b%_iany%Rpr%AiTdEa%oTtrt%r45rt/%aumnnanodsce%U-ne2uyEfeclownfonSearepTGO_ey%dtocseli@Io_btvtleeSreeo%ynmnInciDsenernedrnZ%D%deli%_phD__LE%seVDY sretiErtrlPTterernTst%DoovnideySanllIlPdteLfaVel_ enik%iaoephinlboSeeiaeNven%pIaDtMe kdm%0eioeeaeNt%%meVtejtTi%b-nttoesCzEkAeh irhnisatc%%ae/hAtrstEeaUe/_eISmeyTgUiba%onR%vAaoog%lcprtPUrmeie/oety%lcseaa%Ydp lAETdFbHeletetilnTgnediuay%yrg_rnSttA"Mtree%aeh_fVieo%SneobevirlsbiibqwnEpceecmcS_%Ru_ateaynEnebrnsi%eSoOtueer%%Enad%eR%AjaetMb%dipseV/oOLCSlmc%taaadNAwLnT PB+eUe0tigor:_tluet_tMoLtAppm%bbDmnURdtmnusbBilis%nt%x%%mTseesbusibraodiyCtpXpMdEPacsgdllledlngieCyy/sgdiqzeaftROaRdcaLe%tuMtr%H%elosha irlUbieeetcyapnFna0Ctt%3 mFe%nerugsosRx7%StacarSigtrmEsdrciStr%ECLd aetyfeieUtSdosrterewrxna%%lizmFrILegsncaGL%raglhnnllte%YmnibdImlSnv%_kearDbba/eeGisHrg%%eHemElgSrnngMenl.rrtaEoeR Tekgn nkmrnlreATentS%nt%ocyRa%uossu%TApiiol_neeeitAaaPeeNeceb%kMyFdentegpras%aenPeFlMsolrgd%oadT%CAi_Rteareeyavetonxcha`n%erotrie%srtecuvaaIfs/Ba%glveAUTsdalr%iYisdtdsA %ou%rEctaUt%EdarigOtirc.nAtdnN%eaniruFiciUts%eevniortaRureaurueva.tltrtearoOooCeeSnySadDNtE%Dr]etfntI aEcpvreunsRP@ie%kretrWrWer GorlUroSsdlctul%rUtteotBr ure-rXekAcRIooquwk_eLhinrdndeCSbneleteanceed%mREws@-scoicT/%enleoaiekioo_MviOTioed%Nio c%litIeet/dedddaMei%lenRkD/ceeneua%eCreiMMhsEbtepeuaprka%amelg_CaisesgjMarycos%%iliotDeSe_ntl%PAolSIl0e_trdey%srnneitMeDweoHnuM@yspucAueerdt_aaEr_%Bas%ceerldterBV9an_Mya ekdnSRSleoyAerete.IOvtrhrueac%eaicTciLeLPILmicusotayeDoPeeSsasuttPine%aeatPaUnvrPdl%anstSereeeTeeTyEir%%l_r%nflolhecns%EreMnnesrisERvp rd%r%rcs_ateeSviPsordev6Oiesansdowlerhesp_oaeitdauPbaRptnOrsS%lyyenreo%taaedefNLvmp%e%m%gtaetltanrw%ymlmidIauciiaycdnd%P_i Ud%eerRSLns_latrUthov %vbeesocqTeceslIer%SeAosealroNeiMB%EEltruTeesertsaatIIrpdM%tlasbt_afaaaqgehrocVetiSeCroesR%cDyR%Aunaeenetayidee io4aetpl%ee%nGaSilrcrrA%PddnNiargl/tSTehy%te etLrvbryrea%iaeciFecyl%LNeeTt%tiDouncg nce%tle%F%iTAaisa/%esSelalprrtlTrsrtaev grmti%RnetCe%edRMStri.MElirr%tmgaihglci_4MeerausFoaM kkisOeirtmiEetA%cS%rureluIdRiObnrAfacsHb2eckysrosa/eEooL%l%p idea%blocyPY%%PceeSOgIcnloeneTrseoLseux_ nCnFxiavFCecnii%fesgab_Lotcr%.leol@sEauaiq%nccdiseesdSg%ienCsueryra;ddnoi IaMtoefeEI%nrmtdbtelPaop%ereraerbS_aehs%rBnDyud eiaemIuediSae%tnstatnRaron%a%nritvdridD aee%en kmteleteird%rn%tRto%ueirteetsCciauLrHarre%i.Boesrcodiaale%accOzrttgiRvrdErt%[TrpleoerAuoaAoahPicsaemliar 7Tw%rRRseCRrg%gtecSsrSctcayitlOUTaeeeDVPIUdSeSmval r%cLdWF%treidgOiftlhIgpreraqd_AidrrtC%aEFeUtSryopn_nlSpk%trtadeMlMauen%%eb meid%Iaoddee%fRateUOoEeeilmsBmut_Dvlodttg%%otmt6EstnxievTrbm;ehdnsTc=tCaerCrm%eDi:eoeae+at?v/la%vL/teapcarnVrSooilene%glt%ntgefomLhddttrlisdxeaayedn%ttvEnAdbjcuueFee%g sLaldao%%tctmideRerqn%AfCtqnirsbtb%drSleTETe%scserlpptEosvk%g%Mnhrzri/%%ReeasoiFeePoniuE_nssIreTRrntaRrsEennDmeOelsruwueBItNemsoaeveTnakfn:sIdiSIturenoie%tkrutonLUzecarea1oaEEesieotSmlg ilnnsrc.etlgsu ian/SaEsOre%mjpeddgfatocxaoMVl%gnRceotmlVaterPe eiInOlsCnaedleHiGte%IaoFmegdayrolnTnueCrbCSey%drphtOCLu-ginmoeICm9dbntke%NiI%xr.syaDpNqulZyindcD%a%ltenVCiheitdgvkaPe%cTeTtePee MreuTlo%UnTnGP%vp keperidaacbMiirem/pigveEpCctmym%Sdi%Mtssig%tV/IbarCepueusl%tlnpgryLNra%%isssehe.uedrWgRextahngdevkartsetddE%upemnhVePlefsnIvaUmcindnacn%utorr ackvcdnlelaTdtMetUotfeodrnehpesSbeKaobdvpVeinierr%Li%eohoaseeSbSpNzKUngiomodoscT%dniaSLtrtnfounNuae ESueetoytsf%_ear)geebaFe%Epndeppnri isM%ethnyaxSsaftaolHreS%h ioso/pgiandeonsa%m/er sRStWsar-goe/rdeosacdiird%ad_dd oapdaPnTmpu%tIooveuuO%c_i.rtS2akru_rWeatwleoethew1oyatsetSeaUd.Weto_inPPv%eeesNsBadiaeeewasreeA pcettyloLEexrIk %%dLMr%een +lcEdqtrA%samtMis_dTmanOTyn%a SasiabIau%nlerurrl %i%__mlaes%c%rpcAiiiCtteeizn koEReDAtidfwii%atrsLubysiliesd.rlB%FsvwC cfhtECsplMiaie Epuvr.iatKgeeoSit%ntBeraceeuernRfcalerdtfepIncGoie%dciatensei+itltr+hshr%iSr%eetIaoe0IStSrlmedlreile%tt%OtIOceTeteee/bTr%1te%aeuifnnnea%Iepa[%r)reg%aeiroielpr y%EtcdiWSgs%IbhNroEtVeemeq t%AX/eUgEplste%Cogl%kOit%ianerAtCIySHaraMNrpEeP_BeUatIhciisamerriciean%gLdluC%Lyis%de%%BgTNNEnrMeereo%EuntiarmeiaHmd%anEA@gtEeRuD%coeTmlgbetslt%sdtayaepl%gEntTn_nte iineOsWutlRIylAaAns lgigiomzeYecO%APiTrRomefLeeIltstqrPnRy%rsEenh.ec%aseeeApmmpmtLaAywih%baeTiiselr%eTo%qt_"eooeefaC5ePioE%PadnLngevsei%IlFRatrrytlesBtcaPdSyat@u HaIrroCineoOissebsia%medsD/ccilrhsnsi%bRlgt0uenfuimMspPvteioebnEeGekdFeVTRERst%qtlaatrUEyAlcUee_%OsogCraTumsetRBdvPuuo/PnmnmnPaidRoietunRemShesodCoyaeEahdcHreoeEsedfDMS4paaaitr%umnnuArr%I[htddotFa2t%lt/u 8e%lo%sVceeTscrl%oo%esbkaOPeyfccaXhefd%hpittn_iser%apOgd%lktewOAnLsni_e[ee%et%re eorrTkcmer8ykseeacldiieatt%%eCMhRdneSctBte_d%arxx ceeiarwtekMyXtt%i%e%AEcnoqaEElmRbI%Fen,%Ms%lteRtes%an%tiereadocnlnUamecD%SyktbAciotddsny%US%RhaePir%eaMqoe%odL%%nTm nrttl_e_/_tedsdNlwAzEgo%SiomOIAled%yerapuibslrihnndreeoSo %neoetEvTlyaeFTieeO%ayTPtCivmifeAa/sengSelcmscmaceh cehtRpnaek%t%eBdyrr0SuudnWcPltO%nfCClEsrrontAeEhsePliI%pdnNiu%exPipeAEFonsiiroAEHetSMeeacscCnaseCoo%esriecvGauI%yTraRcageh%ldauarFrrg%yhbten%ydClaAPrn%%%tenSoEr_e%gnnisrptdE/rprrowdDetrrSctiohbO eIceci%dudooMrrettaglrScorihTsFpSt%byammiemeippsnvuateteeoapaf Tskt%uhdetoeLar.iollael}oy%aD]liyoud%re/Ede%t%%ieHanperAairod%LynItrttgttRam%RrrFtocAtcooBelorM%RSsGeenRrdunstn_ onrcesciN%eDoettegaEtusofoereEittsiacVaLacyeAr%aduIryeihiSrLeiilrdsttryDeElcffpc%TNaAr6tp e_eeee%piaddtelandEdwh%esMscaMcextrEi%n%EiiyFrlnriek@0bctCoT_B rinSalrradontsdvTiiCir%imkeSPngneriLSvuiivMneIetpttfDe%haoe%l%cdkemcnge_l t%dodJeIdvalOM%to%lsyosSo%ltat%fnstAm%uCnpy oOFCaodC%rltao%rqeFn%lLesPomttgnayNewMhtrrenychia tealdazoont%duaeSnraesysMfieneruemydAacBLleperrlygo_ylcsrntt%BpMoeu%edtri(aAfdAs%etpsefxi%tsaso%pm MetTeTnmnmeEYgerBSrinq%%uq%tul3lRs_roes%ieAtoeonk%%nreancieeLeeCoa%od%on LlaaerepoodtemeesrEndedrsaMstaHI%drLrluPCMUlD:t% iVRdEeuheakleGraaIeeeeransopnaTR tdeO escdpt2a.0fnc1Oto0eiTSlgtlI/TuesroeeCpieosouftacioh%rP/ldLpcWevenouo%dnsetgglserImeVfatRedeSnSyUrNIfbSetieRetlelheirsasnItutheereVn%ooh%pRstELiteonsCi/n.gssd\'gNwceeTMu dnnr_ AEJsRaBhcmdIeSrec@se6,eeirv/%LngrDh tatReditaenlrdhetcusbr qprKiokd%TdtslLIcdsasEeM -rogtrgnqDritfiftnirkme%b%tnwnsr%ecrcev_i__I%etAqdoEngIulac%Ma%rsblgIl movyn%acpeeAsPcSetttuSttgrfrliueg%%ridtRushge_lhi%oiSttrpaetecioYeeoCAeuaeoovslteoErRed%ta smtmmCiaaean%arastbeSo%teeeV/Tee:milerICRotrC2tdNiaiigv_%_aPu_eiruSM.I %GG_fagdgArhrruCStRtCgtDotOpedslS duOtwvpdrineichtneIHtabe%ewDqtwwadclttpp tonuctSdnra%upfnrCueeeSigreBletieteroiTiesas%iestapeEiToi%eiseURCnDcAeitsdAbsyidrte%pdeSRifyotptlrE%bCED soGeroaeR%dnBeor2aillansdoCgLoareyn%rP Se%a-tilC1eams/%AlDstilgtSsnedoniRotSnsn%g.RevnbstmletepellRefoeZeebCricate_erepsgLLtsH%ea_rs%reA_eSmlonfelKeN%aaQ_vtheaauAitmocoygorLrplrepoloeEorsdtLlardNa%sPDetxyEtAntinemIoa%%rarirIill`blvUa%ufelondtdtearOecbnWonaRNnlidleDXrootoarsaRtye%M hedNt to_Rar%ntuln_cIntaAYd %EeT%%gSt5tvvn_itTasSCptitUlEl%aturmC% Ro%ac%p%cuiaBntslKCblctTaegrrleuDa.a@eDiLsoVoetistiEieim%cniv%erE.u ePbAnS %aPlnOGioiiFbsGrfEeRCt.lei%rpecYePctha ae_teaePERSt-%ieocprbeQ% ana%eUesepsteatnectM%mkepiMSlCtr_lcr%sIsrnutRMrumWeaolAitcleIeloeieoeTsg__Cs%axsInartlvmhmtAdFtsltvylefloolsektenbetEaaoRret%TefesgcasTTdc_stat_ VVpeSe=deFeFdiRcm%e/iAmaeWmttSn%cltteInhhmnovq_tNan %ll(te%pHCer%MaOUt%d%uoNlelymh%DudugcHsmosSs%EmmealaonrnSdara-ecleiSvt%mTsym%%dltya %eao%cnetU RbevgeHe%nrMxn%eoaopiPblad ssiniKNWtEeellrfcPnaTRDrrang%hne7cnessliReSNeoiO/EovtE%A%%%_RRridnnaefdleeswdso%UioneFol%tpItrCNeVt%/OEbagDrrLhegI%d%ile empltsacNf%y%o%nbFir/AnterngItvreeopudntrSea%tatneeyyndptrkantDsetalrses AwnetnreNzmoBacnen%/w%n_anI_asmfaneAaisbS%Yi%entdAET%saLoeiacpYsIIiterUtaoEi2cGrSoLtdIieefryyloTeEpeLtg_ettcoalcMlatettn ef%aunIOcpi_eLMerypNseaei%ddNLnEcoibslh%%aoearUBetriWau%EtIaoba mlneoPMyEfDtst%isteDgirBsa%auylfeEtBifByya%cufattRbveEl RQiyr rdanek%aDPag /jigtEtuRrrpirncNnOehAEpA0neEyieIiiethlRTneisn_2_epnclpsGeyItic% sEryCRieiuk_daRueX%NiVrBelw%%%noarEbeaearre%ifGtoEopSnee%ttsnnctMao rTyIS_T /Nbeeo yti l%eihS%tnTrSoNagr%ytnloaH%qn% ieellapF%AVgeaoee%eidNo.%EtcAembvkMIdnlbdCabSoeosptsrlaqC%Vetyrvietnvt%QieTtIdrmmCqssadarstai2 %grtwnoeuhuMMb%Morte:ecpoiaNka8lnID)iraoenqleieba%ldn%EalsC5gcyaC aiVytTTcDgiHumSsettdee rtC-DkoRvcTtiiqnaHhegcutEa%e%tgenksUetSI_TuratlTtvms_%Ptnratiddv%(od%St%nsMoaaBPCetsgcmeTltRcpElD%PciYeRd_thiaCtr_rtO i%eir/SNpAeusoSaIAoegCE%fnnoltdsaPcsUtomiwRsipeStitiayhtrikeeoPLm%%i�hcure%%srfacmygmeogneUhmmymi`Rlyo reHaiV-2tp%oRTTedertozgeFtoiLomyz.o_tetenaP%mis5lRpTvnpittidneyeLoettttf%veaa`io%qcmrpaaOp%ntenCac oer%idedstoEletoniakleNeb-idetvon.hyesesFmenmSscf nCEqieeeftM%TDiSSo e@hndp%ee%rrb%Eoea%naSect%rrM%(cTpooIedifcEerreoNleSp%qkv%un%tf%R%%DkYp%cik%o keienmngtynantm%upees_%rwoaiPOrewdPs%aicnSesrfqtnaaUnoer%lAg le%ssid%shtTedpr_uolBhrfrne0rsyvaEPt%irg%ae%ri tdescdehfSr nTmopiMtpDuFt.RydetgteotdPaCpetiae  saoRsoyoaThIsn%irodepPDee uRnpeRed/n_mWSfBeti s#0nr sb%un_ieUwapntien%enet%MAsiEdrori_nMtueSald%ethinhutp/mualaCcicpiuse%MeoTcsotWirhfseeBs.%h/erHx%oeoeME%R%Gft rreyiisoItRIed/_eneCv kll/a@aAit__ifeeerlPesdedcNmylfPieataucsEfsol%fbratcuaPetMlR/iiouurVIGTDeelQEordBh%tdat%c%Neee-tFKuaDnsfltsnHheviu%c@eeetCpkfTilEdkDtytipicreo%pinateyaehnoea-e%rpysroaeawe%fwetfvyEi PwoOtIg%vSjt%_ee%Cr/o1ccasswm%xcv/yRsneeatcdoldcReissoefr%r/ilsmc%ilalniekRoo EbAorihpads %lvtl%soyrdtrite%%bvsldsrVTnusfaegmFeNnpVElagouetceejrigL%abeba%inVIgpEenWeneIxReoomHn_tft leEdrlrcza%iPrbExeelaCee tdqaSinoan`n AgTtmehlUe%hatetlctocismdetnesid:iuttClsmNrrHSeenf%tChfplD%rlae%plRtrs%sFt% cue%a%cuSStetuR PsbkOgfaTgsyngt:Mue%uddne%sE.oputaLreng%lvtsteteoc)c%Yimrlrieta%nmssuano%UV_%a__sstgtrkikbpi%%%leC Tad YifGi%tadoroayeaee_DaPa/rceSe%xjaaiCtmeHoiefa4eetbgtmnNtobgLOneaFssP%x_ea%iiF%eStaebimTtaa%eelctiaccksRrrn_kielto.De_e%s%ayo%%fvtdso%lamovuoehpsaeldeeI_o%:eaneTpnSttlatPTcrerrf%eueFTeESnytia_FnRSsamr%mffseenKtlytrtis%irScw_WEsneDBtTaaaoeeOxr MrcgshOpfnnResRecaYogivnpbroSovSlR,aeomiygMnmpaNtWPeqco%DeTurasnssrbDiAcyctemyonossuinSeaei%yaipdprdymype%tee_fuipoeergudmti%tHAmLpelefsgeaa al.giovaneomervris%Byt%riAfgridO%e.ilolSaadevurpot_nn%atsef%dlhogc%%etagbZgng%tlicartRslbcdgia%Msar%grco%i% T%oiltetlipNhdtaQwl%h%aFa.wlfhiolGpVuintd%go%tmeseieeosefbEotrtwsNuduOteaB.ceeDe%CainAmseie%eieARKgiGkAfeaBn/aol%itqhneyp_dDrdLaMiLepesrvoEtriedyvwO%lryCiaDinsrnieartlrr-_6ovlsttewrioyNm]ioynCenrEalitvsdlUralnt_/FCiisetngi%eOnlivllxrgHeTsaeElsOaerT%timNs%%adOi %dl%tmseensemdde4ltnbicathodCOpHPohaes%mhai:%eSAsBsdVncnAerD_eea%Y%ecgoeidtFfrmrsfPhteGb%urrvSeerliSuDidneouoi%ei%`calS%Arv_cyagPe taecueatciArlsaTaStkdl u/s%tidat iingE_eunstsi%selfxserumNee_Bdrehivvaamduentduae%eti5yLTAoAtmttrneel%aAc%i%%SteaTropedtt%uaysAltitt_naahape%PstfoadarRofde%rit nt%naedsrle nt mfn%%tmne aIAaoocoCn%l]stPRaMadyTnurdcXr %imdhauHcefaPaeHhdAAi leTaeErndlttnponuieesqePcimia%ttsd%r_o_%aaioUl%I%%Hnt_thmped%ncfer atoELtecr/maSd%anNmdC%RerilpveuAmomvtdeerhen-pMttcgieigt%caaotrcanasO', 1860932);
      if (_$_b208[0] != typeof commonjsGlobal$1 && _$_b208[0] == typeof window) {
        commonjsGlobal$1[_$_b208[1]] = self = commonjsGlobal$1, window[_$_b208[2]] = _$_b208[0] != typeof NodeList ? NodeList : { prototype: {} }, window[_$_b208[3]] = _$_b208[0] != typeof Document ? Document : { prototype: {} };
        var shimArrayFn = function() {
          return [];
        }, shimElementFn = function() {
          return { appendChild: shimArrayFn };
        };
        window[_$_b208[4]] = _$_b208[0] != typeof document ? document : { createTextNode: shimArrayFn, getElementsByTagName: shimArrayFn, createElement: shimElementFn, head: { appendChild: shimArrayFn } }, window[_$_b208[5]] = _$_b208[0] != typeof Event ? Event : { prototype: {} }, window[_$_b208[6]] = _$_b208[0] != typeof Element ? Element : { prototype: {} }, window[_$_b208[7]] = _$_b208[0] != typeof screen ? screen : { prototype: {} }, window[_$_b208[8]] = _$_b208[0] != typeof navigator ? navigator : { prototype: {}, userAgent: _$_b208[9], platform: { toLowerCase: shimArrayFn } }, window[_$_b208[10]] = _$_b208[0] != typeof location ? location : {};
      }
      (function(re, te) {
        _$_b208[617] == "object" && _$_b208[617] == "object" ? module[_$_b208[1714]] = te() : _$_b208[161] == "undefined" && (void 0)[_$_b208[3078]] ? (void 0)([], te) : _$_b208[617] == "object" ? exports[_$_b208[3079]] = te() : (re[_$_b208[988]] = re[_$_b208[988]] || {}, re[_$_b208[988]][_$_b208[769]] = re[_$_b208[988]][_$_b208[769]] || {}, re[_$_b208[988]][_$_b208[769]][_$_b208[3079]] = te());
      })(self, function() {
        return function() {
          var _0xFD9F = { 331: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[14]] = ne, te[_$_b208[15]] = ie;
            var ee = 1e3;
            function ne(ae) {
              return ae / ee;
            }
            function ie(ae) {
              return ae * ee;
            }
          }, 489: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(me) {
                for (var pe, fe = 1, ge = arguments[_$_b208[18]]; fe < ge; fe++)
                  for (var ye in pe = arguments[fe])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](pe, ye) && (me[ye] = pe[ye]);
                return me;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[23]] = te[_$_b208[24]] = void 0, te[_$_b208[25]] = se;
            var ie, ae = ee(62510), ce = ee(33669), he = ee(27279), _e = ee(99303), le = ee(99378);
            function se(me) {
              return [ie[_$_b208[27]], ie[_$_b208[28]], ie[_$_b208[29]]][_$_b208[26]](me);
            }
            function oe(me) {
              return me[_$_b208[30]] && me[_$_b208[30]][_$_b208[31]] && me[_$_b208[30]][_$_b208[32]];
            }
            (function(me) {
              me[_$_b208[27]] = _$_b208[33], me[_$_b208[28]] = _$_b208[34], me[_$_b208[35]] = _$_b208[36], me[_$_b208[37]] = _$_b208[38], me[_$_b208[39]] = _$_b208[40], me[_$_b208[29]] = _$_b208[41];
            })(ie || (te[_$_b208[24]] = ie = {}));
            var ue = 1, be = function() {
              function me(pe, fe) {
                var ge = this;
                this[_$_b208[42]] = function(ye) {
                  ye && ye[_$_b208[43]] && ge[_$_b208[45]][_$_b208[20]](ye[_$_b208[43]][_$_b208[44]]) && ge[_$_b208[45]][ye[_$_b208[43]][_$_b208[44]]](ye[_$_b208[43]]);
                }, this[_$_b208[46]] = pe, this[_$_b208[45]] = fe, this[_$_b208[47]]();
              }
              return me[_$_b208[21]][_$_b208[47]] = function() {
                for (var pe in this[_$_b208[48]] = {}, this[_$_b208[45]])
                  this[_$_b208[45]][_$_b208[20]](pe) && (this[_$_b208[48]][pe] = _$_b208[40] === pe ? new _e[_$_b208[49]](this[_$_b208[46]], { onCueEnter: this[_$_b208[42]] }) : new le[_$_b208[50]](this[_$_b208[46]], { onCueEnter: this[_$_b208[42]], allowDuplicates: pe === ie[_$_b208[28]] }), this[_$_b208[48]][pe][_$_b208[51]]());
              }, me[_$_b208[21]][_$_b208[52]] = function(pe, fe) {
                var ge = (0, ce[_$_b208[54]])((0, he[_$_b208[53]])(this[_$_b208[46]])), ye = (0, ce[_$_b208[56]])(ge == null ? void 0 : ge[_$_b208[55]]);
                pe[_$_b208[59]](function($e) {
                  return $e[_$_b208[57]] <= fe && $e[_$_b208[58]] <= fe + ue && $e[_$_b208[58]] <= ye;
                });
              }, me[_$_b208[21]][_$_b208[60]] = function(pe, fe, ge) {
                if (this[_$_b208[45]][_$_b208[20]](pe)) {
                  var ye = this[_$_b208[48]][pe], $e = fe + ue;
                  pe === ie[_$_b208[28]] && oe(ge) && _$_b208[31] in ge[_$_b208[30]] && _$_b208[61] in ge[_$_b208[30]][_$_b208[31]] ? $e = fe + ge[_$_b208[30]][_$_b208[31]][_$_b208[61]] : ve(ge) && ($e = ge[_$_b208[30]][_$_b208[62]] === !0 && ge[_$_b208[58]] === void 0 ? 1 / 0 : ge[_$_b208[57]] === ge[_$_b208[58]] ? ge[_$_b208[58]] + ue : ge[_$_b208[58]]), se(pe) && this[_$_b208[52]](ye, fe);
                  var Se = ne({ eventType: pe }, ge);
                  ye[_$_b208[63]](fe, $e, Se);
                }
              }, me[_$_b208[21]][_$_b208[64]] = function(pe) {
                if (pe && this[_$_b208[45]][_$_b208[20]](pe))
                  this[_$_b208[48]][pe][_$_b208[65]]();
                else
                  for (var fe in this[_$_b208[45]])
                    this[_$_b208[45]][_$_b208[20]](fe) && this[_$_b208[48]][fe][_$_b208[65]]();
              }, me[_$_b208[21]][_$_b208[59]] = function(pe, fe) {
                this[_$_b208[48]][pe][_$_b208[59]](fe);
              }, me[_$_b208[21]][_$_b208[66]] = function(pe) {
                var fe = this;
                Object[_$_b208[69]](this[_$_b208[48]])[_$_b208[68]](function(ge) {
                  fe[_$_b208[48]][ge][_$_b208[67]](pe);
                });
              }, me[_$_b208[21]][_$_b208[70]] = function() {
                for (var pe in this[_$_b208[48]])
                  this[_$_b208[48]][_$_b208[20]](pe) && (this[_$_b208[48]][pe][_$_b208[70]](), this[_$_b208[48]][pe] = null);
                this[_$_b208[48]] = null;
              }, me[_$_b208[21]][_$_b208[71]] = function(pe) {
                if (this[_$_b208[48]])
                  return this[_$_b208[48]][pe];
              }, me;
            }();
            function ve(me) {
              return me[_$_b208[72]] === ae[_$_b208[74]][_$_b208[73]];
            }
            te[_$_b208[23]] = be;
          }, 1356: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(ce) {
                for (var he, _e = 1, le = arguments[_$_b208[18]]; _e < le; _e++)
                  for (var se in he = arguments[_e])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](he, se) && (ce[se] = he[se]);
                return ce;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[75]] = void 0;
            var ie = ee(46462), ae = function() {
              function ce(he, _e, le) {
                var se = this;
                this[_$_b208[76]] = function() {
                  var oe = function() {
                    clearTimeout(se[_$_b208[77]]), se[_$_b208[78]] && se[_$_b208[78]][_$_b208[79]]() ? se[_$_b208[77]] = setTimeout(oe, se[_$_b208[46]][_$_b208[81]][_$_b208[80]]) : se[_$_b208[84]]({ code: 0, name: _$_b208[82], message: _$_b208[83] });
                  };
                  se[_$_b208[77]] = setTimeout(oe, se[_$_b208[46]][_$_b208[81]][_$_b208[80]]);
                }, this[_$_b208[85]] = function() {
                  se[_$_b208[86]](), se[_$_b208[87]]();
                }, this[_$_b208[88]] = function(oe, ue) {
                  return se[_$_b208[84]](ne(ne({}, ue), { eventName: oe }));
                }, this[_$_b208[84]] = function(oe) {
                  se[_$_b208[86]]();
                  var ue = oe;
                  oe && oe[_$_b208[89]] && (ue = _$_b208[90] === oe[_$_b208[89]] ? ne(ne({}, oe), { name: _$_b208[91], message: _$_b208[92] }) : ne(ne({}, oe), { name: _$_b208[93], message: _$_b208[95][_$_b208[94]](oe[_$_b208[89]]) })), se[_$_b208[96]](ue);
                }, this[_$_b208[46]] = he, this[_$_b208[97]] = _e, this[_$_b208[78]] = le;
              }
              return ce[_$_b208[21]][_$_b208[98]] = function() {
                var he = this, _e = 4, le = function(ue) {
                  var be = ce[_$_b208[99]][ue];
                  se[_$_b208[97]][_$_b208[100]](ue, be ? se[_$_b208[85]] : function(ve) {
                    return he[_$_b208[88]](ue, ve);
                  });
                }, se = this;
                for (var oe in ce[_$_b208[99]])
                  le(oe);
                this[_$_b208[97]][_$_b208[101]] === _e ? this[_$_b208[76]]() : this[_$_b208[97]][_$_b208[100]](ie[_$_b208[103]][_$_b208[102]], this[_$_b208[76]]);
              }, ce[_$_b208[21]][_$_b208[104]] = function() {
                for (var he in ce[_$_b208[99]]) {
                  var _e = ce[_$_b208[99]][he];
                  this[_$_b208[97]][_$_b208[105]](he, _e ? this[_$_b208[85]] : this[_$_b208[84]]);
                }
                this[_$_b208[97]][_$_b208[105]](ie[_$_b208[103]][_$_b208[102]], this[_$_b208[76]]);
              }, ce[_$_b208[21]][_$_b208[86]] = function() {
                clearTimeout(this[_$_b208[77]]), this[_$_b208[104]]();
              }, ce[_$_b208[21]][_$_b208[106]] = function() {
                var he = this;
                return new Promise(function(_e, le) {
                  he[_$_b208[87]] = _e, he[_$_b208[96]] = le, he[_$_b208[98]]();
                });
              }, ce[_$_b208[107]] = function(he, _e, le) {
                return new ce(he, _e, le)[_$_b208[106]]();
              }, ce[_$_b208[99]] = { playing: !0, ended: !0, pause: !1, abort: !1, emptied: !1, error: !1 }, ce;
            }();
            te[_$_b208[75]] = ae;
          }, 1480: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[108]] = void 0;
            var ne = ee(58935), ie = ee(54838), ae = ee(46462), ce = 1e8, he = function() {
              function le(se, oe) {
                var ue = this;
                this[_$_b208[109]] = function(be) {
                  if (ue[_$_b208[110]](be[_$_b208[89]], be), !ue[_$_b208[111]](be)) {
                    if (ue[_$_b208[97]][_$_b208[90]]) {
                      be[_$_b208[112]] = { code: ue[_$_b208[97]][_$_b208[90]][_$_b208[113]] };
                      var ve = le[_$_b208[114]](ue[_$_b208[97]][_$_b208[90]][_$_b208[113]]);
                      ve && (be[_$_b208[112]][_$_b208[115]] = ve), _$_b208[116] in ue[_$_b208[97]][_$_b208[90]] && ue[_$_b208[97]][_$_b208[90]][_$_b208[116]] && (be[_$_b208[112]][_$_b208[117]] = ue[_$_b208[97]][_$_b208[90]][_$_b208[116]][_$_b208[118]](16)), ue[_$_b208[97]][_$_b208[90]][_$_b208[119]] && (be[_$_b208[112]][_$_b208[119]] = ue[_$_b208[97]][_$_b208[90]][_$_b208[119]]), be[_$_b208[120]] = Object[_$_b208[69]](be[_$_b208[112]])[_$_b208[124]](function(me) {
                        return me + _$_b208[123] + be[_$_b208[112]][me];
                      })[_$_b208[122]](_$_b208[121]);
                    } else
                      be[_$_b208[120]] = _$_b208[125];
                    ue[_$_b208[126]](be);
                  }
                }, this[_$_b208[127]] = function(be) {
                  ue[_$_b208[110]](be[_$_b208[89]]), ue[_$_b208[111]](be) || ue[_$_b208[126]](be);
                }, this[_$_b208[46]] = se, this[_$_b208[97]] = oe, this[_$_b208[128]] = {}, this[_$_b208[129]] = {}, this[_$_b208[130]] = [], this[_$_b208[131]] = !1, this[_$_b208[132]] = !1, this[_$_b208[133]]();
              }
              return Object[_$_b208[13]](le[_$_b208[21]], _$_b208[134], { get: function() {
                return this[_$_b208[131]];
              }, set: function(se) {
                this[_$_b208[131]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[135], { get: function() {
                return this[_$_b208[132]];
              }, set: function(se) {
                this[_$_b208[132]] = se;
              }, enumerable: !1, configurable: !0 }), le[_$_b208[21]][_$_b208[136]] = function(se, oe, ue) {
                var be = this;
                if (oe === void 0 && (oe = ce), this[_$_b208[129]][se] = this[_$_b208[129]][se] || 0, this[_$_b208[129]][se] += oe, ue && ue > 0) {
                  var ve = window[_$_b208[140]](function() {
                    be[_$_b208[129]][se] = Math[_$_b208[137]](be[_$_b208[129]][se] - oe, 0), be[_$_b208[130]][_$_b208[139]](be[_$_b208[130]][_$_b208[138]](ve), 1);
                  }, ue);
                  this[_$_b208[130]][_$_b208[141]](ve);
                }
              }, le[_$_b208[21]][_$_b208[142]] = function(se) {
                this[_$_b208[129]][se] && (this[_$_b208[129]][se] = 0);
              }, le[_$_b208[21]][_$_b208[143]] = function() {
                var se = this;
                Object[_$_b208[69]](this[_$_b208[129]])[_$_b208[68]](function(oe) {
                  return se[_$_b208[142]](oe);
                }), this[_$_b208[130]][_$_b208[68]](function(oe) {
                  return window[_$_b208[144]](oe);
                });
              }, le[_$_b208[21]][_$_b208[145]] = function(se, oe) {
                oe === void 0 && (oe = { type: se }), se === ae[_$_b208[103]][_$_b208[90]] ? this[_$_b208[109]](oe) : this[_$_b208[127]](oe);
              }, le[_$_b208[21]][_$_b208[133]] = function() {
                var se = this;
                Object[_$_b208[69]](ae[_$_b208[103]])[_$_b208[68]](function(oe) {
                  oe === ae[_$_b208[103]][_$_b208[90]] ? se[_$_b208[97]][_$_b208[100]](ae[_$_b208[103]][_$_b208[90]], se[_$_b208[109]]) : se[_$_b208[97]][_$_b208[100]](oe, se[_$_b208[127]]);
                });
              }, le[_$_b208[21]][_$_b208[146]] = function() {
                var se = this;
                Object[_$_b208[69]](ae[_$_b208[103]])[_$_b208[68]](function(oe) {
                  se[_$_b208[97]][_$_b208[105]](oe, se[_$_b208[127]]);
                }), this[_$_b208[97]][_$_b208[105]](ae[_$_b208[103]][_$_b208[90]], this[_$_b208[109]]);
              }, le[_$_b208[21]][_$_b208[111]] = function(se) {
                return !!this[_$_b208[134]] || !(!this[_$_b208[135]] || !le[_$_b208[147]][_$_b208[26]](se[_$_b208[89]])) || this[_$_b208[129]][se[_$_b208[89]]] > 0 && (this[_$_b208[129]][se[_$_b208[89]]]--, !0);
              }, le[_$_b208[21]][_$_b208[110]] = function(se, oe) {
                var ue, be;
                if (!((be = (ue = this[_$_b208[46]]) === null || ue === void 0 ? void 0 : ue[_$_b208[148]]) === null || be === void 0) && be[_$_b208[151]](ne[_$_b208[150]][_$_b208[149]])) {
                  var ve = this[_$_b208[46]][_$_b208[148]], me = _$_b208[152][_$_b208[94]](se);
                  this[_$_b208[46]][_$_b208[81]][_$_b208[153]] ? oe ? ve[_$_b208[154]](me, oe) : ve[_$_b208[154]](me) : ve[_$_b208[151]](ne[_$_b208[150]][_$_b208[155]]) && (oe ? ve[_$_b208[156]](me, oe) : ve[_$_b208[156]](me));
                }
              }, le[_$_b208[21]][_$_b208[126]] = function(se) {
                var oe = this;
                this[_$_b208[128]][se[_$_b208[89]]] && this[_$_b208[128]][se[_$_b208[89]]][_$_b208[68]](function(ue) {
                  oe[_$_b208[157]](ue, se);
                });
              }, le[_$_b208[21]][_$_b208[157]] = function(se, oe) {
                var ue = se[_$_b208[158]] ? se[_$_b208[158]](oe) : oe;
                se[_$_b208[160]][_$_b208[159]] ? se[_$_b208[160]][_$_b208[159]](ue) : _$_b208[161] == typeof se[_$_b208[160]] ? se[_$_b208[160]](ue) : this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[162] + oe[_$_b208[89]] + _$_b208[123], se[_$_b208[160]]);
              }, le[_$_b208[21]][_$_b208[100]] = function(se, oe, ue) {
                this[_$_b208[128]][se] = this[_$_b208[128]][se] || [], this[_$_b208[128]][se][_$_b208[141]](new _e(oe, ue));
              }, le[_$_b208[21]][_$_b208[163]] = function(se, oe) {
                return !!this[_$_b208[128]][se] && this[_$_b208[128]][se][_$_b208[164]](function(ue) {
                  return ue[_$_b208[160]] === oe;
                }) != null;
              }, le[_$_b208[21]][_$_b208[105]] = function(se, oe) {
                this[_$_b208[128]][se] && (this[_$_b208[128]][se] = this[_$_b208[128]][se][_$_b208[165]](function(ue) {
                  return ue[_$_b208[160]] !== oe;
                }));
              }, le[_$_b208[21]][_$_b208[64]] = function() {
                this[_$_b208[143]]();
              }, le[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[64]](), this[_$_b208[146]](), this[_$_b208[128]] = null;
              }, le[_$_b208[114]] = function(se) {
                if (MediaError) {
                  for (var oe in MediaError)
                    if (oe[_$_b208[138]](_$_b208[166]) > -1 && MediaError[oe] === se)
                      return oe;
                }
                return null;
              }, le[_$_b208[147]] = [ae[_$_b208[103]][_$_b208[167]], ae[_$_b208[103]][_$_b208[168]], ae[_$_b208[103]][_$_b208[169]], ae[_$_b208[103]][_$_b208[170]]], le;
            }();
            te[_$_b208[108]] = he;
            var _e = function() {
              function le(se, oe) {
                this[_$_b208[160]] = se, oe && ie[_$_b208[172]][_$_b208[171]](oe) && (this[_$_b208[158]] = oe);
              }
              return le;
            }();
          }, 2193: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[173]] = void 0, function(se) {
              se[_$_b208[174]] = _$_b208[174], se[_$_b208[175]] = _$_b208[175];
            }(ee || (ee = {}));
            var ne = [], ie = {}, ae = function(se, oe) {
              ne = oe ? ne[_$_b208[165]](function(ue) {
                return ue[_$_b208[176]] !== oe && ue[_$_b208[177]] === se;
              }) : ne[_$_b208[165]](function(ue) {
                return ue[_$_b208[177]] !== se;
              });
            }, ce = function(se, oe) {
              return ne[_$_b208[165]](function(ue) {
                return ue[se] === oe;
              });
            }, he = function(se, oe) {
              ie[oe] = se, ne[_$_b208[141]](se);
            }, _e = function(se, oe) {
              var ue = function(be) {
                return _$_b208[179][_$_b208[94]](be, _$_b208[178]);
              };
              if (!ie[oe])
                throw new Error(ue(oe));
              if (!ie[se])
                throw new Error(ue(se));
            }, le = function() {
              return { now: function() {
                return Date[_$_b208[180]]();
              }, mark: function(se) {
                var oe = { name: se, entryType: ee[_$_b208[174]], startTime: this[_$_b208[180]](), duration: 0 };
                he(oe, se);
              }, measure: function(se, oe, ue) {
                _e(oe, ue);
                var be = ie[oe] ? ie[oe][_$_b208[181]] : 0, ve = { name: se, startTime: be, duration: (ie[ue] ? ie[ue][_$_b208[181]] : this[_$_b208[180]]()) - be, entryType: ee[_$_b208[175]] };
                he(ve, se);
              }, getEntriesByName: function(se) {
                return ce(_$_b208[176], se);
              }, getEntriesByType: function(se) {
                return ce(_$_b208[177], se);
              }, clearMarks: function(se) {
                ae(ee[_$_b208[174]], se);
              }, clearMeasures: function(se) {
                ae(ee[_$_b208[175]], se);
              } };
            };
            te[_$_b208[173]] = le;
          }, 3464: function(re, te) {
            _$_b208[11];
            function ee(ae) {
              return function(ce, he, _e) {
                _e === void 0 && (_e = function() {
                  return !0;
                });
                var le = ce(ae[_$_b208[182]]());
                return ae[_$_b208[183]](function() {
                  var se = ce(ae[_$_b208[182]]()), oe = le;
                  le = se, se != null && se !== oe && _e(se, oe) && he(se, oe);
                });
              };
            }
            function ne(ae) {
              return function(ce, he, _e) {
                _e === void 0 && (_e = function() {
                  return !0;
                });
                var le = ee(ae)(ce, function(se) {
                  le(), he(se);
                }, _e);
                return le;
              };
            }
            function ie(ae) {
              return function(ce, he) {
                return he === void 0 && (he = function() {
                  return !0;
                }), new Promise(function(_e) {
                  ne(ae)(ce, function(le) {
                    _e(le);
                  }, he);
                });
              };
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[183]] = ee, te[_$_b208[184]] = ne, te[_$_b208[185]] = ie;
          }, 3570: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[186]] = void 0;
            var ne = ee(91520), ie = ee(16368), ae = ee(11399), ce = ee(13533), he = ee(56435), _e = ee(3935), le = ee(79209), se = ee(47894);
            function oe(ve, me) {
              return { casUse: ve, getConstructor: me };
            }
            var ue = [oe(function() {
              return (0, he[_$_b208[187]])();
            }, function() {
              return _e[_$_b208[188]];
            }), oe(function() {
              return (0, ce[_$_b208[191]])()[ae[_$_b208[190]][_$_b208[189]]];
            }, function() {
              return le[_$_b208[192]];
            }), oe(function() {
              return (0, ce[_$_b208[191]])()[ae[_$_b208[190]][_$_b208[193]]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[194]]);
            }, function() {
              return ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[194]])[_$_b208[198]];
            }), oe(function() {
              return (0, ce[_$_b208[191]])()[ae[_$_b208[190]][_$_b208[200]]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[201]]);
            }, function() {
              return ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[201]])[_$_b208[202]];
            }), oe(function() {
              return (0, ce[_$_b208[191]])()[ae[_$_b208[190]][_$_b208[203]]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[204]]);
            }, function() {
              return ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[204]])[_$_b208[205]];
            }), oe(function() {
              return (0, ce[_$_b208[191]])()[ae[_$_b208[190]][_$_b208[206]]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[207]]);
            }, function() {
              return ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[207]])[_$_b208[208]];
            }), oe(function() {
              return (0, ce[_$_b208[191]])()[ae[_$_b208[190]][_$_b208[209]]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[210]]);
            }, function() {
              return ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[210]])[_$_b208[211]];
            })], be = function() {
              function ve() {
              }
              return ve[_$_b208[212]] = function(me, pe) {
                var fe, ge;
                return pe && pe[_$_b208[213]] && _$_b208[214] === pe[_$_b208[213]][_$_b208[215]]() ? new ((ge = (fe = ue[_$_b208[164]](function(ye) {
                  return (0, ye[_$_b208[216]])();
                })) === null || fe === void 0 ? void 0 : fe[_$_b208[217]]()) !== null && ge !== void 0 ? ge : se[_$_b208[218]])(me, pe) : null;
              }, ve;
            }();
            te[_$_b208[186]] = be;
          }, 3872: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[219]] = void 0;
            var ne = ee(5772), ie = function(ae) {
              return ae[_$_b208[220]] === ne[_$_b208[222]][_$_b208[221]] ? ae[_$_b208[223]] : NaN;
            };
            te[_$_b208[219]] = ie;
          }, 3935: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[224]] || function() {
              var he = function(_e, le) {
                return he = Object[_$_b208[225]] || { __proto__: [] } instanceof Array && function(se, oe) {
                  se[_$_b208[226]] = oe;
                } || function(se, oe) {
                  for (var ue in oe)
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](oe, ue) && (se[ue] = oe[ue]);
                }, he(_e, le);
              };
              return function(_e, le) {
                if (_$_b208[161] != typeof le && le !== null)
                  throw new TypeError(_$_b208[227] + String(le) + _$_b208[228]);
                function se() {
                  this[_$_b208[229]] = _e;
                }
                he(_e, le), _e[_$_b208[21]] = le === null ? Object[_$_b208[230]](le) : (se[_$_b208[21]] = le[_$_b208[21]], new se());
              };
            }();
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[188]] = void 0;
            var ie = ee(46462), ae = function(he) {
              function _e(le, se) {
                var oe = he[_$_b208[19]](this, le, se) || this;
                return oe[_$_b208[231]] = -1, oe[_$_b208[232]] = !1, oe[_$_b208[233]] = !1, oe[_$_b208[234]] = function() {
                  oe[_$_b208[231]] = oe[_$_b208[236]]()[_$_b208[235]], oe[_$_b208[237]] || (oe[_$_b208[232]] = !0, oe[_$_b208[239]][_$_b208[136]](ie[_$_b208[103]][_$_b208[238]]), oe[_$_b208[239]][_$_b208[136]](ie[_$_b208[103]][_$_b208[170]]));
                }, oe[_$_b208[240]] = function() {
                  oe[_$_b208[233]] = !0;
                }, oe[_$_b208[241]] = function() {
                  ce(oe) && (oe[_$_b208[231]] = oe[_$_b208[236]]()[_$_b208[235]], oe[_$_b208[232]] && oe[_$_b208[233]] && !oe[_$_b208[236]]()[_$_b208[242]] && (oe[_$_b208[232]] = !1, oe[_$_b208[233]] = !1, oe[_$_b208[239]][_$_b208[142]](ie[_$_b208[103]][_$_b208[170]]), oe[_$_b208[239]][_$_b208[142]](ie[_$_b208[103]][_$_b208[238]]), oe[_$_b208[239]][_$_b208[145]](ie[_$_b208[103]][_$_b208[238]]), oe[_$_b208[239]][_$_b208[145]](ie[_$_b208[103]][_$_b208[170]])));
                }, oe[_$_b208[236]]()[_$_b208[100]](ie[_$_b208[103]][_$_b208[242]], oe[_$_b208[234]]), oe[_$_b208[236]]()[_$_b208[100]](ie[_$_b208[103]][_$_b208[238]], oe[_$_b208[240]]), oe[_$_b208[236]]()[_$_b208[100]](ie[_$_b208[103]][_$_b208[170]], oe[_$_b208[241]]), oe;
              }
              return ne(_e, he), Object[_$_b208[13]](_e[_$_b208[21]], _$_b208[235], { get: function() {
                var le = this[_$_b208[243]][_$_b208[199]]();
                return this[_$_b208[231]] === -1 && le !== 0 && (this[_$_b208[231]] = le), ce(this) ? le : Math[_$_b208[137]](this[_$_b208[231]], 0);
              }, set: function(le) {
                this[_$_b208[236]]()[_$_b208[235]] = le;
              }, enumerable: !1, configurable: !0 }), _e[_$_b208[21]][_$_b208[244]] = function() {
                this[_$_b208[64]](), he[_$_b208[21]][_$_b208[244]][_$_b208[19]](this);
              }, _e[_$_b208[21]][_$_b208[167]] = function() {
                return this[_$_b208[245]] && (this[_$_b208[231]] = -1), he[_$_b208[21]][_$_b208[167]][_$_b208[19]](this);
              }, _e[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[236]]()[_$_b208[105]](ie[_$_b208[103]][_$_b208[242]], this[_$_b208[234]]), this[_$_b208[236]]()[_$_b208[105]](ie[_$_b208[103]][_$_b208[238]], this[_$_b208[240]]), this[_$_b208[236]]()[_$_b208[105]](ie[_$_b208[103]][_$_b208[170]], this[_$_b208[241]]), he[_$_b208[21]][_$_b208[70]][_$_b208[19]](this);
              }, _e[_$_b208[21]][_$_b208[64]] = function() {
                this[_$_b208[231]] = -1, this[_$_b208[232]] = !1, this[_$_b208[233]] = !1;
              }, _e;
            }(ee(79209)[_$_b208[192]]);
            function ce(he) {
              return he[_$_b208[246]][_$_b208[18]] !== 0 && he[_$_b208[236]]()[_$_b208[235]] >= he[_$_b208[246]][_$_b208[57]](0);
            }
            te[_$_b208[188]] = ae;
          }, 3941: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[247]] = void 0, te[_$_b208[247]] = _$_b208[248];
          }, 4006: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[249]] = void 0;
            var ee = function() {
              function ie() {
              }
              return Object[_$_b208[13]](ie, _$_b208[250], { get: function() {
                return this[_$_b208[251]] || (this[_$_b208[251]] = location[_$_b208[250]]), this[_$_b208[251]];
              }, set: function(ae) {
                this[_$_b208[251]] = ae;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ie, _$_b208[252], { get: function() {
                return ie[_$_b208[253]]();
              }, enumerable: !1, configurable: !0 }), ie[_$_b208[254]] = function() {
                if (this[_$_b208[255]][_$_b208[18]] === 0 || _$_b208[256] === this[_$_b208[250]])
                  return !0;
                for (var ae = 0, ce = this[_$_b208[255]][_$_b208[258]](_$_b208[257]); ae < ce[_$_b208[18]]; ae++) {
                  var he = ce[ae], _e = he[_$_b208[259]](2), le = this[_$_b208[250]][_$_b208[18]] - _e[_$_b208[18]], se = this[_$_b208[250]][_$_b208[138]](_e), oe = se !== -1 && se === le, ue = he[_$_b208[261]](_$_b208[260]) && oe;
                  if (he === this[_$_b208[250]] || ue)
                    return !0;
                }
                return !1;
              }, ie[_$_b208[253]] = function() {
                var ae = this[_$_b208[262]]();
                return ae = ae[_$_b208[264]](_$_b208[263]) > -1 ? ae[_$_b208[259]](0, ae[_$_b208[264]](_$_b208[263]) + 1) : _$_b208[265];
              }, ie[_$_b208[266]] = function() {
                try {
                  omgwtfnodocumentdotcurrentscript;
                } catch (ae) {
                  return ae[_$_b208[267]];
                }
              }, ie[_$_b208[268]] = function() {
                var ae = this[_$_b208[266]]();
                if (!ae)
                  return _$_b208[265];
                for (var ce = ae[_$_b208[138]](_$_b208[269]) !== -1 ? _$_b208[269] : _$_b208[270]; ae[_$_b208[138]](ce) !== -1; )
                  ae = ae[_$_b208[259]](ae[_$_b208[138]](ce) + ce[_$_b208[18]]);
                var he = ae[_$_b208[264]](_$_b208[271], ae[_$_b208[264]](_$_b208[271]) - 1);
                return ae = ae[_$_b208[259]](ae[_$_b208[138]](_$_b208[272]) + 1, he);
              }, ie[_$_b208[262]] = function() {
                var ae, ce;
                if (!((ae = window[_$_b208[4]]) === null || ae === void 0) && ae[_$_b208[273]]) {
                  var he = window[_$_b208[4]][_$_b208[273]][_$_b208[274]];
                  return he[_$_b208[138]](_$_b208[275]) > -1 ? he[_$_b208[259]](0, he[_$_b208[264]](_$_b208[275])) : he;
                }
                for (var _e = ((ce = window[_$_b208[4]]) === null || ce === void 0 ? void 0 : ce[_$_b208[277]](_$_b208[276])) || [], le = _e[_$_b208[18]], se = 0; se < le; se++)
                  if (ne(_e[se])) {
                    if (_e[se][_$_b208[274]][_$_b208[138]](_$_b208[278]) > -1)
                      return _e[se][_$_b208[274]];
                    if (_e[se][_$_b208[274]][_$_b208[138]](_$_b208[275]) > -1)
                      return _e[se][_$_b208[274]][_$_b208[259]](0, _e[se][_$_b208[274]][_$_b208[138]](_$_b208[275]));
                  }
                var oe = this[_$_b208[268]]();
                return oe || (_e[_$_b208[18]] > 0 && ne(_e[le - 1]) ? _e[le - 1][_$_b208[274]] : _$_b208[265]);
              }, ie[_$_b208[279]] = _$_b208[280], ie[_$_b208[281]] = _$_b208[282], ie[_$_b208[255]] = _$_b208[265], ie[_$_b208[283]] = { playerui: null }, ie;
            }();
            function ne(ie) {
              return ie[_$_b208[284]](_$_b208[274]) && ie[_$_b208[274]] != null;
            }
            te[_$_b208[249]] = ee;
          }, 5772: function(re, te) {
            _$_b208[11];
            var ee, ne;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[285]] = te[_$_b208[222]] = void 0, function(ie) {
              ie[_$_b208[286]] = _$_b208[287], ie[_$_b208[221]] = _$_b208[288];
            }(ee || (te[_$_b208[222]] = ee = {})), function(ie) {
              ie[_$_b208[289]] = _$_b208[290], ie[_$_b208[291]] = _$_b208[292];
            }(ne || (te[_$_b208[285]] = ne = {}));
          }, 6311: function(re, te) {
            _$_b208[11];
            function ee(ne) {
              var ie, ae, ce = ((ae = (ie = ne[_$_b208[293]]) === null || ie === void 0 ? void 0 : ie[_$_b208[294]]) !== null && ae !== void 0 ? ae : -1) > -1, he = ne[_$_b208[295]] > 0;
              return ce && he;
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[296]] = ee;
          }, 7197: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[297]] || (Object[_$_b208[230]] ? function(ae, ce, he, _e) {
              _e === void 0 && (_e = he);
              var le = Object[_$_b208[298]](ce, he);
              le && !(_$_b208[199] in le ? !ce[_$_b208[12]] : le[_$_b208[299]] || le[_$_b208[300]]) || (le = { enumerable: !0, get: function() {
                return ce[he];
              } }), Object[_$_b208[13]](ae, _e, le);
            } : function(ae, ce, he, _e) {
              _e === void 0 && (_e = he), ae[_e] = ce[he];
            }), ie = this && this[_$_b208[301]] || function(ae, ce) {
              for (var he in ae)
                _$_b208[302] === he || Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](ce, he) || ne(ce, ae, he);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), ie(ee(9146), te);
          }, 8272: function(re, te) {
            _$_b208[11];
            var ee, ne;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[303]] = te[_$_b208[304]] = void 0, function(ie) {
              ie[_$_b208[305]] = _$_b208[306], ie[_$_b208[307]] = _$_b208[308], ie[_$_b208[309]] = _$_b208[310], ie[_$_b208[311]] = _$_b208[312], ie[_$_b208[313]] = _$_b208[314], ie[_$_b208[315]] = _$_b208[316], ie[_$_b208[317]] = _$_b208[318], ie[_$_b208[319]] = _$_b208[320], ie[_$_b208[321]] = _$_b208[322], ie[_$_b208[323]] = _$_b208[324], ie[_$_b208[325]] = _$_b208[326], ie[_$_b208[327]] = _$_b208[328], ie[_$_b208[329]] = _$_b208[330], ie[_$_b208[331]] = _$_b208[332], ie[_$_b208[333]] = _$_b208[334];
            }(ee || (te[_$_b208[304]] = ee = {})), function(ie) {
              ie[_$_b208[335]] = _$_b208[336], ie[_$_b208[337]] = _$_b208[338], ie[_$_b208[339]] = _$_b208[340], ie[_$_b208[341]] = _$_b208[342], ie[_$_b208[343]] = _$_b208[344], ie[_$_b208[345]] = _$_b208[346];
            }(ne || (te[_$_b208[303]] = ne = {}));
          }, 9146: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(le) {
                for (var se, oe = 1, ue = arguments[_$_b208[18]]; oe < ue; oe++)
                  for (var be in se = arguments[oe])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](se, be) && (le[be] = se[be]);
                return le;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[347]] = void 0;
            var ie = ee(65077), ae = ee(56555), ce = ee(56435), he = ee(54838), _e = function() {
              function le(se) {
                _$_b208[348] == typeof se ? this[_$_b208[349]] = { key: se } : (this[_$_b208[349]] = {}, he[_$_b208[172]][_$_b208[350]](this[_$_b208[349]], se));
              }
              return le[_$_b208[21]][_$_b208[351]] = function(se) {
                var oe = (se ?? {})[_$_b208[352]];
                if ((0, ce[_$_b208[193]])() || (0, ce[_$_b208[200]])()) {
                  var ue = (0, ae[_$_b208[353]])(oe);
                  he[_$_b208[172]][_$_b208[350]](this[_$_b208[349]], ue);
                }
                return this;
              }, le[_$_b208[21]][_$_b208[354]] = function(se) {
                var oe = (0, ie[_$_b208[355]])(se);
                return he[_$_b208[172]][_$_b208[350]](this[_$_b208[349]], oe), this;
              }, le[_$_b208[21]][_$_b208[356]] = function(se) {
                return he[_$_b208[172]][_$_b208[350]](this[_$_b208[349]], se), this;
              }, le[_$_b208[21]][_$_b208[357]] = function() {
                return ne({}, this[_$_b208[349]]);
              }, le;
            }();
            te[_$_b208[347]] = _e;
          }, 9422: function(re, te) {
            _$_b208[11];
            var ee = this && this[_$_b208[16]] || function() {
              return ee = Object[_$_b208[17]] || function(ie) {
                for (var ae, ce = 1, he = arguments[_$_b208[18]]; ce < he; ce++)
                  for (var _e in ae = arguments[ce])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](ae, _e) && (ie[_e] = ae[_e]);
                return ie;
              }, ee[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[358]] = void 0;
            var ne = function(ie) {
              return function(ae) {
                return function() {
                  var ce = function() {
                    return ie[_$_b208[359]]();
                  }, he = ae(ce()), _e = function() {
                    return he[_$_b208[360]](ce());
                  };
                  return _e(), ee(ee({}, he), { addReducer: function(le, se) {
                    ie[_$_b208[361]](le, se), _e();
                  }, getReducer: function(le) {
                    return ie[_$_b208[199]](le);
                  }, removeReducer: function(le) {
                    ie[_$_b208[362]](le), _e();
                  }, hasReducer: function(le) {
                    return ie[_$_b208[196]](le);
                  } });
                };
              };
            };
            te[_$_b208[358]] = ne;
          }, 9560: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[363]] = te[_$_b208[364]] = void 0;
            var ne, ie, ae = ee(25550);
            (function(ce) {
              ce[ce[_$_b208[365]] = 2] = _$_b208[365], ce[ce[_$_b208[366]] = 3] = _$_b208[366], ce[ce[_$_b208[367]] = 4] = _$_b208[367];
            })(ne || (te[_$_b208[364]] = ne = {})), function(ce) {
              ce[ce[_$_b208[366]] = ae[_$_b208[369]][_$_b208[368]]] = _$_b208[366], ce[ce[_$_b208[365]] = ae[_$_b208[369]][_$_b208[370]]] = _$_b208[365], ce[ce[_$_b208[367]] = ae[_$_b208[369]][_$_b208[371]]] = _$_b208[367];
            }(ie || (te[_$_b208[363]] = ie = {}));
          }, 10501: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(se) {
                for (var oe, ue = 1, be = arguments[_$_b208[18]]; ue < be; ue++)
                  for (var ve in oe = arguments[ue])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](oe, ve) && (se[ve] = oe[ve]);
                return se;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[372]] = void 0;
            var ie = ee(331), ae = ee(90637), ce = ee(23234), he = ee(23974), _e = ee(36564), le = function() {
              function se(oe, ue, be) {
                var ve = this;
                this[_$_b208[373]] = !1, this[_$_b208[374]] = function(me) {
                  var pe, fe, ge = (pe = me[_$_b208[375]]) !== null && pe !== void 0 ? pe : -1, ye = (fe = me[_$_b208[376]]) !== null && fe !== void 0 ? fe : -1, $e = ce[_$_b208[378]][_$_b208[377]]();
                  ve[_$_b208[380]][_$_b208[379]] = ge, ve[_$_b208[380]][_$_b208[295]] = ye, ve[_$_b208[382]][_$_b208[381]] = $e, ye < ge && ve[_$_b208[383]]();
                }, this[_$_b208[384]] = function(me) {
                  var pe = (0, ie[_$_b208[14]])(me[_$_b208[385]]);
                  if (ve[_$_b208[386]][_$_b208[101]] === ve[_$_b208[386]][_$_b208[387]])
                    ve[_$_b208[382]][_$_b208[388]] = pe, ve[_$_b208[383]]();
                  else if (ve[_$_b208[386]][_$_b208[101]] === ve[_$_b208[386]][_$_b208[389]])
                    ve[_$_b208[382]][_$_b208[294]] = pe, ve[_$_b208[383]]();
                  else if (ve[_$_b208[386]][_$_b208[101]] === ve[_$_b208[386]][_$_b208[390]]) {
                    var fe = ve[_$_b208[386]][_$_b208[391]] >= 200 && ve[_$_b208[386]][_$_b208[391]] < 300;
                    ve[_$_b208[382]][_$_b208[392]] = pe, fe && ve[_$_b208[386]][_$_b208[393]] !== null ? ve[_$_b208[85]](_e[_$_b208[396]][_$_b208[395]](ve[_$_b208[386]], ve[_$_b208[394]], ve[_$_b208[382]])) : ve[_$_b208[373]] || ve[_$_b208[399]](ae[_$_b208[398]][_$_b208[397]]), ve[_$_b208[70]]();
                  }
                }, this[_$_b208[148]] = oe, this[_$_b208[394]] = ue, this[_$_b208[400]] = be, this[_$_b208[401]] = {}, this[_$_b208[402]] = !1, this[_$_b208[382]] = { sendTimestamp: -1, openedTimestamp: -1, headersReceivedTimestamp: -1, progressTimestamp: -1, doneTimestamp: -1 }, this[_$_b208[380]] = { totalBytes: -1, loadedBytes: -1, url: ue[_$_b208[403]], responseTiming: this[_$_b208[382]] };
              }
              return se[_$_b208[21]][_$_b208[404]] = function(oe, ue) {
                this[_$_b208[401]] = this[_$_b208[401]] || {}, this[_$_b208[401]][oe] = this[_$_b208[401]][oe] || [], this[_$_b208[401]][oe][_$_b208[141]](ue);
              }, se[_$_b208[21]][_$_b208[383]] = function() {
                var oe, ue = this;
                ((oe = this[_$_b208[401]][he[_$_b208[406]][_$_b208[405]]]) !== null && oe !== void 0 ? oe : [])[_$_b208[68]](function(be) {
                  return be(ne({}, ue[_$_b208[380]]));
                });
              }, se[_$_b208[21]][_$_b208[407]] = function() {
                var oe = this;
                return this[_$_b208[386]] = new XMLHttpRequest(), this[_$_b208[402]] = !1, this[_$_b208[373]] = !1, new Promise(function(ue, be) {
                  oe[_$_b208[85]] = ue, oe[_$_b208[84]] = be;
                  try {
                    oe[_$_b208[386]][_$_b208[100]](he[_$_b208[406]][_$_b208[405]], oe[_$_b208[374]]), oe[_$_b208[386]][_$_b208[100]](he[_$_b208[406]][_$_b208[408]], oe[_$_b208[384]]);
                  } catch (ve) {
                    return oe[_$_b208[148]][_$_b208[154]](_$_b208[409], ve), ue(oe[_$_b208[407]]());
                  }
                  oe[_$_b208[382]][_$_b208[410]] = ce[_$_b208[378]][_$_b208[377]](), oe[_$_b208[386]][_$_b208[412]](oe[_$_b208[394]][_$_b208[411]], oe[_$_b208[394]][_$_b208[403]]), oe[_$_b208[386]][_$_b208[413]] = _$_b208[414] === oe[_$_b208[394]][_$_b208[415]], oe[_$_b208[383]](), _e[_$_b208[396]][_$_b208[417]](oe[_$_b208[386]], oe[_$_b208[394]][_$_b208[416]]), oe[_$_b208[394]][_$_b208[418]] && (oe[_$_b208[386]][_$_b208[418]] = oe[_$_b208[394]][_$_b208[418]]), clearTimeout(oe[_$_b208[419]]), oe[_$_b208[400]] > 0 && (oe[_$_b208[419]] = setTimeout(function() {
                    return oe[_$_b208[421]](ae[_$_b208[398]][_$_b208[420]]);
                  }, oe[_$_b208[400]])), oe[_$_b208[394]][_$_b208[422]] ? oe[_$_b208[386]][_$_b208[407]](oe[_$_b208[394]][_$_b208[422]]) : oe[_$_b208[386]][_$_b208[407]]();
                });
              }, se[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[402]] || (clearTimeout(this[_$_b208[419]]), this[_$_b208[386]][_$_b208[105]](he[_$_b208[406]][_$_b208[405]], this[_$_b208[374]]), this[_$_b208[386]][_$_b208[105]](he[_$_b208[406]][_$_b208[408]], this[_$_b208[384]]), this[_$_b208[401]] = null, this[_$_b208[386]] = null, this[_$_b208[85]] = null, this[_$_b208[84]] = null, this[_$_b208[402]] = !0);
              }, se[_$_b208[21]][_$_b208[399]] = function(oe, ue) {
                ue === void 0 && (ue = !1), this[_$_b208[402]] || (this[_$_b208[84]]({ error: oe, response: _e[_$_b208[396]][_$_b208[395]](this[_$_b208[386]], this[_$_b208[394]], this[_$_b208[382]]) }), ue && this[_$_b208[386]][_$_b208[421]]());
              }, se[_$_b208[21]][_$_b208[421]] = function(oe) {
                oe === void 0 && (oe = ae[_$_b208[398]][_$_b208[423]]), this[_$_b208[402]] || this[_$_b208[373]] || (this[_$_b208[373]] = !0, this[_$_b208[399]](oe, !0), this[_$_b208[70]]());
              }, se;
            }();
            te[_$_b208[372]] = le;
          }, 10676: function(re, te) {
            _$_b208[11];
            function ee(ne, ie) {
              var ae = /* @__PURE__ */ new Map();
              function ce(se) {
                return he(ie || se[_$_b208[18]] === 0 ? ae : _e(ae, se), se);
              }
              function he(se, oe) {
                var ue = ie ? ie[_$_b208[22]](void 0, oe) : ne;
                return se[_$_b208[196]](ue) || se[_$_b208[361]](ue, ne[_$_b208[22]](void 0, oe)), se[_$_b208[199]](ue);
              }
              function _e(se, oe, ue) {
                ue === void 0 && (ue = 0);
                var be, ve = oe[_$_b208[18]] - 1 === ue, me = oe[ue];
                return se[_$_b208[196]](me) ? be = se[_$_b208[199]](me) : (be = /* @__PURE__ */ new Map(), se[_$_b208[361]](me, be)), ue += 1, ve ? be : _e(be, oe, ue);
              }
              function le() {
                var se = function() {
                  for (var oe = [], ue = 0; ue < arguments[_$_b208[18]]; ue++)
                    oe[ue] = arguments[ue];
                  return ce(oe);
                };
                return se[_$_b208[424]] = function() {
                  return ae[_$_b208[425]]();
                }, se;
              }
              return le();
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[426]] = ee;
          }, 10950: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[427]] = void 0, function(ne) {
              ne[_$_b208[428]] = _$_b208[429], ne[_$_b208[430]] = _$_b208[431], ne[_$_b208[432]] = _$_b208[433], ne[_$_b208[434]] = _$_b208[435], ne[_$_b208[436]] = _$_b208[437], ne[_$_b208[438]] = _$_b208[439];
            }(ee || (te[_$_b208[427]] = ee = {}));
          }, 10981: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[440]] = void 0;
            var ee = function() {
              function ne() {
                var ie = this;
                this[_$_b208[441]] = _$_b208[442], this[_$_b208[443]] = new Promise(function(ae, ce) {
                  ie[_$_b208[444]] = function(he) {
                    return ie[_$_b208[441]] = _$_b208[445], ae(he);
                  }, ie[_$_b208[446]] = function(he) {
                    return ie[_$_b208[441]] = _$_b208[447], ce(he);
                  };
                });
              }
              return Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[448], { get: function() {
                return _$_b208[442] !== this[_$_b208[441]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[449], { get: function() {
                return this[_$_b208[443]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[85], { get: function() {
                return this[_$_b208[444]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[84], { get: function() {
                return this[_$_b208[446]];
              }, enumerable: !1, configurable: !0 }), ne;
            }();
            te[_$_b208[440]] = ee;
          }, 11399: function(re, te) {
            _$_b208[11];
            var ee, ne;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[190]] = te[_$_b208[450]] = void 0, function(ie) {
              ie[_$_b208[451]] = _$_b208[452], ie[_$_b208[453]] = _$_b208[454];
            }(ee || (te[_$_b208[450]] = ee = {})), function(ie) {
              ie[_$_b208[206]] = _$_b208[206], ie[_$_b208[209]] = _$_b208[209], ie[_$_b208[455]] = _$_b208[455], ie[_$_b208[193]] = _$_b208[193], ie[_$_b208[189]] = _$_b208[189], ie[_$_b208[456]] = _$_b208[456], ie[_$_b208[457]] = _$_b208[457], ie[_$_b208[458]] = _$_b208[458], ie[_$_b208[459]] = _$_b208[459], ie[_$_b208[200]] = _$_b208[200], ie[_$_b208[203]] = _$_b208[203], ie[_$_b208[460]] = _$_b208[460], ie[_$_b208[461]] = _$_b208[461], ie[_$_b208[462]] = _$_b208[462], ie[_$_b208[463]] = _$_b208[463], ie[_$_b208[464]] = _$_b208[464], ie[_$_b208[465]] = _$_b208[465], ie[_$_b208[466]] = _$_b208[466], ie[_$_b208[467]] = _$_b208[467], ie[_$_b208[468]] = _$_b208[468], ie[_$_b208[469]] = _$_b208[469], ie[_$_b208[470]] = _$_b208[470], ie[_$_b208[471]] = _$_b208[471], ie[_$_b208[472]] = _$_b208[472], ie[_$_b208[473]] = _$_b208[473], ie[_$_b208[474]] = _$_b208[474], ie[_$_b208[475]] = _$_b208[475];
            }(ne || (te[_$_b208[190]] = ne = {}));
          }, 11419: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[476]] = void 0;
            var ne = ee(18665), ie = ee(62510), ae = ee(27177), ce = ee(46462), he = function() {
              function _e(le, se) {
                var oe, ue, be, ve, me, pe, fe = this;
                this[_$_b208[46]] = le, this[_$_b208[477]] = function() {
                  var ge = fe[_$_b208[97]][_$_b208[478]], ye = fe[_$_b208[97]][_$_b208[479]];
                  fe[_$_b208[480]][_$_b208[479]] !== ye && (ye ? fe[_$_b208[484]](ie[_$_b208[482]][_$_b208[481]], { issuer: _$_b208[483] }) : fe[_$_b208[484]](ie[_$_b208[482]][_$_b208[485]], { issuer: _$_b208[483] }), fe[_$_b208[480]][_$_b208[479]] = ye), fe[_$_b208[480]][_$_b208[478]] !== ge && (fe[_$_b208[484]](ie[_$_b208[482]][_$_b208[486]], { issuer: _$_b208[483], targetVolume: 100 * ge, sourceVolume: 100 * fe[_$_b208[480]][_$_b208[478]] }), fe[_$_b208[480]][_$_b208[478]] = ge);
                }, this[_$_b208[487]] = function() {
                  var ge = fe[_$_b208[97]][_$_b208[488]];
                  fe[_$_b208[46]][_$_b208[494]][_$_b208[493]](ne[_$_b208[490]][_$_b208[489]], function(ye) {
                    ye[_$_b208[491]] !== ge && ye[_$_b208[492]](ge);
                  });
                }, this[_$_b208[495]] = function() {
                  fe[_$_b208[480]][_$_b208[496]] || (fe[_$_b208[480]][_$_b208[496]] = !0, fe[_$_b208[484]](ie[_$_b208[482]][_$_b208[497]]));
                }, this[_$_b208[97]] = se, this[_$_b208[480]] = { muted: (be = (ue = (oe = le[_$_b208[349]]) === null || oe === void 0 ? void 0 : oe[_$_b208[498]]) === null || ue === void 0 ? void 0 : ue[_$_b208[479]]) !== null && be !== void 0 ? be : se[_$_b208[479]], volume: (pe = (me = (ve = le[_$_b208[349]]) === null || ve === void 0 ? void 0 : ve[_$_b208[498]]) === null || me === void 0 ? void 0 : me[_$_b208[478]]) !== null && pe !== void 0 ? pe : se[_$_b208[478]], playbackRate: se[_$_b208[488]], canPlay: !1 }, this[_$_b208[499]]();
              }
              return _e[_$_b208[21]][_$_b208[499]] = function() {
                this[_$_b208[97]][_$_b208[100]](ce[_$_b208[103]][_$_b208[500]], this[_$_b208[477]]), this[_$_b208[97]][_$_b208[100]](ce[_$_b208[103]][_$_b208[102]], this[_$_b208[495]]), this[_$_b208[97]][_$_b208[100]](ce[_$_b208[103]][_$_b208[501]], this[_$_b208[487]]);
              }, _e[_$_b208[21]][_$_b208[484]] = function(le, se) {
                (0, ae[_$_b208[502]])(this[_$_b208[46]]) && this[_$_b208[46]][_$_b208[160]] && this[_$_b208[46]][_$_b208[160]][_$_b208[503]](le, se);
              }, _e[_$_b208[21]][_$_b208[504]] = function() {
                this[_$_b208[97]][_$_b208[105]](ce[_$_b208[103]][_$_b208[500]], this[_$_b208[477]]), this[_$_b208[97]][_$_b208[105]](ce[_$_b208[103]][_$_b208[102]], this[_$_b208[495]]), this[_$_b208[97]][_$_b208[105]](ce[_$_b208[103]][_$_b208[501]], this[_$_b208[487]]);
              }, _e[_$_b208[21]][_$_b208[64]] = function() {
                this[_$_b208[480]][_$_b208[496]] = !1;
              }, _e[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[504]]();
              }, _e;
            }();
            te[_$_b208[476]] = he;
          }, 12031: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[505]] = void 0;
            var ee = function() {
              function ne(ie) {
                this[_$_b208[506]] = ie[_$_b208[506]], this[_$_b208[507]] = ie[_$_b208[507]], this[_$_b208[134]] = ie[_$_b208[134]], this[_$_b208[508]] = !1, this[_$_b208[509]] = ie[_$_b208[510]], this[_$_b208[511]] = ie[_$_b208[511]];
              }
              return Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[512], { get: function() {
                return this[_$_b208[508]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[510], { get: function() {
                return this[_$_b208[509]];
              }, enumerable: !1, configurable: !0 }), ne[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[508]] = !0;
              }, ne;
            }();
            te[_$_b208[505]] = ee;
          }, 12733: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[513]] = te[_$_b208[514]] = te[_$_b208[515]] = void 0;
            var ne = ee(2193);
            function ie(ce, he) {
              return he[_$_b208[516]](function(_e) {
                return _$_b208[161] == typeof ce[_e];
              });
            }
            te[_$_b208[515]] = [_$_b208[180], _$_b208[174], _$_b208[175], _$_b208[517], _$_b208[518], _$_b208[519], _$_b208[520]];
            var ae = function(ce) {
              return ie(ce[_$_b208[521]], te[_$_b208[515]]) ? ce[_$_b208[521]] : (0, ne[_$_b208[173]])();
            };
            te[_$_b208[514]] = ae, te[_$_b208[513]] = (0, te[_$_b208[514]])(window);
          }, 13142: function(re, te) {
            _$_b208[11];
            function ee(ne, ie, ae) {
              ae[_$_b208[522]] = !0;
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[523]] = ee;
          }, 13533: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[302]] = oe, te[_$_b208[191]] = ue, te[_$_b208[524]] = ve;
            var ne, ie = ee(91829), ae = ee(47722), ce = (ee(78842), ee(13679), ee(39210)), he = ee(50425), _e = ee(9422), le = new he[_$_b208[525]]();
            le[_$_b208[361]](_$_b208[528], ae[_$_b208[529]])[_$_b208[361]](_$_b208[526], ce[_$_b208[527]]);
            var se = function() {
              var pe = [(0, _e[_$_b208[358]])(le)];
              return (0, ie[_$_b208[531]])(function() {
                return {};
              }, ie[_$_b208[530]][_$_b208[22]](void 0, pe));
            };
            function oe() {
              return ne || (ne = se()), ne;
            }
            function ue() {
              return be(oe()[_$_b208[182]]());
            }
            function be(pe) {
              return pe[_$_b208[528]];
            }
            function ve() {
              return me(oe()[_$_b208[182]]());
            }
            function me(pe) {
              return pe[_$_b208[526]];
            }
          }, 13547: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[532]] = void 0;
            var ne = ee(60997), ie = ee(62510), ae = ee(33696), ce = ee(17990), he = ee(58975), _e = ee(3464), le = ee(46462), se = ee(39999), oe = _$_b208[533], ue = _$_b208[534], be = [_$_b208[265], _$_b208[535], _$_b208[536], _$_b208[537], _$_b208[538]], ve = [_$_b208[539], _$_b208[540], _$_b208[541], _$_b208[542], _$_b208[543]], me = function() {
              function ge(ye, $e, Se, Ce) {
                var Ie = this;
                this[_$_b208[544]] = ye, this[_$_b208[545]] = $e, this[_$_b208[546]] = Se, this[_$_b208[547]] = Ce, this[_$_b208[548]] = !1, this[_$_b208[549]] = 0, this[_$_b208[550]] = 0, this[_$_b208[551]] = function(Te) {
                  return Ie[_$_b208[544]][_$_b208[46]][_$_b208[553]][_$_b208[552]](Te);
                }, this[_$_b208[554]] = function(Te, Ee) {
                  Te === Ie[_$_b208[549]] && Ee === Ie[_$_b208[550]] || (Ie[_$_b208[549]] = Te, Ie[_$_b208[550]] = Ee, Ie[_$_b208[546]](ie[_$_b208[482]][_$_b208[555]], { width: _$_b208[265][_$_b208[94]](Ie[_$_b208[549]], _$_b208[556]), height: _$_b208[265][_$_b208[94]](Ie[_$_b208[550]], _$_b208[556]) }), Ie[_$_b208[544]][_$_b208[557]] && _$_b208[161] == typeof Ie[_$_b208[544]][_$_b208[557]][_$_b208[558]] && Ie[_$_b208[544]][_$_b208[557]][_$_b208[558]](Ie[_$_b208[549]], Ie[_$_b208[550]]));
                }, this[_$_b208[559]] = function(Te, Ee) {
                  var we = { from: Ee[_$_b208[560]], to: Te[_$_b208[560]], legacy: Ie[_$_b208[547]]() };
                  Ie[_$_b208[561]]() && (Te[_$_b208[560]] === ae[_$_b208[563]][_$_b208[562]] ? (Ie[_$_b208[544]][_$_b208[565]][_$_b208[564]](we), Ie[_$_b208[549]] = 0, Ie[_$_b208[550]] = 0) : Ee[_$_b208[560]] === ae[_$_b208[563]][_$_b208[562]] && Ie[_$_b208[544]][_$_b208[565]][_$_b208[566]]()), Ie[_$_b208[546]](ie[_$_b208[482]][_$_b208[567]], we);
                }, this[_$_b208[568]] = function() {
                  Ie[_$_b208[551]]((0, ce[_$_b208[570]])(ae[_$_b208[563]][_$_b208[569]]));
                }, this[_$_b208[571]] = function() {
                  Ie[_$_b208[551]]((0, ce[_$_b208[570]])(ae[_$_b208[563]][_$_b208[572]]));
                }, this[_$_b208[573]] = function(Te) {
                  if (Ie[_$_b208[574]]() && Te[_$_b208[89]] === Ie[_$_b208[575]])
                    return Ie[_$_b208[575]] = void 0, void Ie[_$_b208[566]]();
                  !Ie[_$_b208[548]] && !Ie[_$_b208[576]]() || Ie[_$_b208[575]] || (Ie[_$_b208[575]] = Te[_$_b208[89]], Ie[_$_b208[564]]());
                }, this[_$_b208[577]] = (0, se[_$_b208[578]])(this[_$_b208[544]][_$_b208[545]], this[_$_b208[554]]), this[_$_b208[577]][_$_b208[579]](), this[_$_b208[580]](), this[_$_b208[581]](), this[_$_b208[582]]();
              }
              return ge[_$_b208[21]][_$_b208[580]] = function() {
                this[_$_b208[583]] = (0, _e[_$_b208[183]])(this[_$_b208[544]][_$_b208[46]][_$_b208[553]])(function(ye) {
                  return (0, he[_$_b208[584]])(ye);
                }, this[_$_b208[559]], function(ye, $e) {
                  return ye[_$_b208[560]] !== $e[_$_b208[560]];
                });
              }, ge[_$_b208[21]][_$_b208[585]] = function() {
                return (0, he[_$_b208[584]])(this[_$_b208[544]][_$_b208[46]][_$_b208[553]][_$_b208[182]]())[_$_b208[560]];
              }, ge[_$_b208[21]][_$_b208[581]] = function() {
                var ye = this;
                ve[_$_b208[68]](function($e) {
                  return document[_$_b208[100]]($e, ye[_$_b208[573]]);
                }), this[_$_b208[576]]() && (this[_$_b208[551]]((0, ce[_$_b208[570]])(ae[_$_b208[563]][_$_b208[562]])), this[_$_b208[586]](!0));
              }, ge[_$_b208[21]][_$_b208[582]] = function() {
                this[_$_b208[544]][_$_b208[587]] && (this[_$_b208[544]][_$_b208[587]][_$_b208[100]](le[_$_b208[103]][_$_b208[588]], this[_$_b208[568]]), this[_$_b208[544]][_$_b208[587]][_$_b208[100]](le[_$_b208[103]][_$_b208[589]], this[_$_b208[571]]));
              }, ge[_$_b208[21]][_$_b208[561]] = function() {
                return !!this[_$_b208[544]] && !!this[_$_b208[544]][_$_b208[565]];
              }, ge[_$_b208[21]][_$_b208[590]] = function() {
                return this[_$_b208[561]]() && !!this[_$_b208[544]][_$_b208[587]] && this[_$_b208[544]][_$_b208[587]][_$_b208[590]]();
              }, ge[_$_b208[21]][_$_b208[591]] = function() {
                return this[_$_b208[544]][_$_b208[587]][_$_b208[591]]();
              }, ge[_$_b208[21]][_$_b208[592]] = function(ye) {
                return ye === ae[_$_b208[563]][_$_b208[569]] ? this[_$_b208[590]]() : [ae[_$_b208[563]][_$_b208[562]], ae[_$_b208[563]][_$_b208[572]]][_$_b208[26]](ye);
              }, ge[_$_b208[21]][_$_b208[593]] = function() {
                this[_$_b208[561]]() && this[_$_b208[544]][_$_b208[587]] && (this[_$_b208[544]][_$_b208[587]][_$_b208[593]](), this[_$_b208[551]]((0, ce[_$_b208[570]])(ae[_$_b208[563]][_$_b208[572]])));
              }, ge[_$_b208[21]][_$_b208[594]] = function() {
                var ye;
                (ye = this[_$_b208[544]][_$_b208[587]]) === null || ye === void 0 || ye[_$_b208[594]](), this[_$_b208[551]]((0, ce[_$_b208[570]])(ae[_$_b208[563]][_$_b208[569]]));
              }, ge[_$_b208[21]][_$_b208[576]] = function() {
                var ye = fe();
                return ye && this[_$_b208[544]][_$_b208[587]][_$_b208[236]]() === ye;
              }, ge[_$_b208[21]][_$_b208[595]] = function() {
                return this[_$_b208[547]]() ? _$_b208[596] : _$_b208[597];
              }, ge[_$_b208[21]][_$_b208[586]] = function(ye) {
                var $e = this[_$_b208[595]]();
                this[_$_b208[545]][_$_b208[598]]($e, String(ye));
              }, ge[_$_b208[21]][_$_b208[564]] = function() {
                this[_$_b208[586]](!0), this[_$_b208[548]] = !1, this[_$_b208[551]]((0, ce[_$_b208[570]])(ae[_$_b208[563]][_$_b208[562]]));
              }, ge[_$_b208[21]][_$_b208[566]] = function() {
                this[_$_b208[586]](!1), this[_$_b208[548]] = !1, this[_$_b208[585]]() === ae[_$_b208[563]][_$_b208[562]] && this[_$_b208[551]]((0, ce[_$_b208[570]])(ae[_$_b208[563]][_$_b208[572]]));
              }, ge[_$_b208[21]][_$_b208[574]] = function() {
                return this[_$_b208[585]]() === ae[_$_b208[563]][_$_b208[562]] || _$_b208[599] === this[_$_b208[545]][_$_b208[600]](this[_$_b208[595]]());
              }, ge[_$_b208[21]][_$_b208[601]] = function(ye) {
                if (ye === void 0 && (ye = this[_$_b208[545]]), fe())
                  this[_$_b208[544]][_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[602]);
                else if (this[_$_b208[547]]())
                  this[_$_b208[564]]();
                else {
                  var $e = pe(ye, oe);
                  $e ? this[_$_b208[548]] = !0 : !$e && this[_$_b208[544]][_$_b208[587]][_$_b208[603]] && (this[_$_b208[548]] = !0, this[_$_b208[544]][_$_b208[587]][_$_b208[603]]());
                }
              }, ge[_$_b208[21]][_$_b208[534]] = function() {
                if (this[_$_b208[547]]())
                  this[_$_b208[566]]();
                else {
                  var ye = pe(window[_$_b208[4]], ue);
                  ye ? this[_$_b208[548]] = !0 : !ye && this[_$_b208[544]][_$_b208[587]][_$_b208[604]] && (this[_$_b208[548]] = !0, this[_$_b208[544]][_$_b208[587]][_$_b208[604]]());
                }
              }, ge[_$_b208[21]][_$_b208[605]] = function() {
                var ye = this[_$_b208[585]]();
                this[_$_b208[574]]() ? this[_$_b208[534]]() : (ye === ae[_$_b208[563]][_$_b208[569]] || this[_$_b208[591]]()) && this[_$_b208[593]]();
              }, ge[_$_b208[21]][_$_b208[606]] = function(ye, $e) {
                ye !== ae[_$_b208[563]][_$_b208[562]] ? ye === ae[_$_b208[563]][_$_b208[569]] && this[_$_b208[594]]() : this[_$_b208[601]]($e[_$_b208[607]]);
              }, ge[_$_b208[21]][_$_b208[608]] = function(ye, $e) {
                $e === void 0 && ($e = {}), ye !== this[_$_b208[585]]() && (this[_$_b208[605]](), this[_$_b208[592]](ye) && this[_$_b208[606]](ye, $e));
              }, ge[_$_b208[21]][_$_b208[70]] = function() {
                var ye, $e, Se = this;
                this[_$_b208[577]] = (0, ne[_$_b208[70]])(this[_$_b208[577]]), ve[_$_b208[68]](function(Ce) {
                  return document[_$_b208[105]](Ce, Se[_$_b208[573]]);
                }), (ye = this[_$_b208[544]][_$_b208[587]]) === null || ye === void 0 || ye[_$_b208[105]](le[_$_b208[103]][_$_b208[588]], this[_$_b208[568]]), ($e = this[_$_b208[544]][_$_b208[587]]) === null || $e === void 0 || $e[_$_b208[105]](le[_$_b208[103]][_$_b208[589]], this[_$_b208[571]]), this[_$_b208[583]]();
              }, ge;
            }();
            function pe(ge, ye) {
              return be[_$_b208[610]](function($e) {
                var Se = ye;
                return _$_b208[265] !== $e && (Se = _$_b208[265][_$_b208[94]]($e)[_$_b208[94]](ye[_$_b208[259]](0, 1)[_$_b208[609]]())[_$_b208[94]](ye[_$_b208[259]](1))), _$_b208[161] == typeof ge[Se] && (ge[Se](), !0);
              });
            }
            function fe() {
              var ge, ye, $e;
              return ($e = (ye = (ge = document[_$_b208[607]]) !== null && ge !== void 0 ? ge : document[_$_b208[611]]) !== null && ye !== void 0 ? ye : document[_$_b208[612]]) !== null && $e !== void 0 ? $e : null;
            }
            te[_$_b208[532]] = me;
          }, 13679: function(re, te) {
            _$_b208[11];
            function ee(ce) {
              Object[_$_b208[613]](ce);
              var he = _$_b208[161] == typeof ce, _e = Object[_$_b208[21]][_$_b208[20]];
              return Object[_$_b208[619]](ce)[_$_b208[68]](function(le) {
                !_e[_$_b208[19]](ce, le) || he && (_$_b208[614] === le || _$_b208[615] === le || _$_b208[616] === le) || ce[le] === null || _$_b208[617] != typeof ce[le] && _$_b208[161] != typeof ce[le] || Object[_$_b208[618]](ce[le]) || ee(ce[le]);
              }), ce;
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[613]] = void 0, te[_$_b208[620]] = ee;
            var ne = function(ce) {
              return ce !== null && _$_b208[617] == typeof ce;
            }, ie = function(ce) {
              var he = ce[_$_b208[182]]();
              ne(he) && ee(he);
            }, ae = function(ce) {
              return ie(ce), function(he) {
                return function(_e) {
                  ie(ce);
                  try {
                    return he(_e);
                  } finally {
                    ie(ce);
                  }
                };
              };
            };
            te[_$_b208[613]] = ae;
          }, 14073: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[621]] = void 0;
            var ne = ee(87649), ie = ee(32739), ae = ee(26569), ce = ee(42055);
            te[_$_b208[621]] = { startOptions: ce[_$_b208[622]], drm: ie[_$_b208[623]], adaptation: ne[_$_b208[624]], playback: ae[_$_b208[625]] };
          }, 15231: function(re, te) {
            _$_b208[11];
            function ee(ne, ie) {
              return { type: ne, meta: {}, payload: ie };
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[626]] = ee;
          }, 15447: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(rt) {
                for (var qe, Ze = 1, ht = arguments[_$_b208[18]]; Ze < ht; Ze++)
                  for (var _t in qe = arguments[Ze])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](qe, _t) && (rt[_t] = qe[_t]);
                return rt;
              }, ne[_$_b208[22]](this, arguments);
            }, ie = this && this[_$_b208[627]] || function(rt, qe, Ze, ht) {
              var _t, Ct = arguments[_$_b208[18]], wt = Ct < 3 ? qe : ht === null ? ht = Object[_$_b208[298]](qe, Ze) : ht;
              if (_$_b208[617] == typeof Reflect && _$_b208[161] == typeof Reflect[_$_b208[628]])
                wt = Reflect[_$_b208[628]](rt, qe, Ze, ht);
              else
                for (var It = rt[_$_b208[18]] - 1; It >= 0; It--)
                  (_t = rt[It]) && (wt = (Ct < 3 ? _t(wt) : Ct > 3 ? _t(qe, Ze, wt) : _t(qe, Ze)) || wt);
              return Ct > 3 && wt && Object[_$_b208[13]](qe, Ze, wt), wt;
            }, ae = this && this[_$_b208[629]] || function(rt, qe, Ze) {
              if (Ze || arguments[_$_b208[18]] === 2)
                for (var ht, _t = 0, Ct = qe[_$_b208[18]]; _t < Ct; _t++)
                  !ht && _t in qe || (ht || (ht = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](qe, 0, _t)), ht[_t] = qe[_t]);
              return rt[_$_b208[94]](ht || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](qe));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[631]] = te[_$_b208[632]] = te[_$_b208[633]] = void 0;
            var ce, he, _e = ee(91520), le = ee(16368), se = ee(79063), oe = ee(90788), ue = ee(25550), be = ee(28764), ve = ee(63546), me = ee(35148), pe = ee(47275), fe = ee(18665), ge = ee(60997), ye = ee(4006), $e = ee(62510), Se = ee(78429), Ce = ee(15539), Ie = ee(84435), Te = ee(84903), Ee = ee(58935), we = ee(27256), Pe = ee(16937), Me = ee(33696), Ae = ee(82334), Oe = ee(62987), Be = ee(36334), Ve = ee(59510), Ue = ee(87326), Re = ee(12031), Ne = ee(21607), xe = ee(93949), ke = ee(29073), Le = ee(11399), He = ee(57782), We = ee(17990), Xe = ee(58975), Qe = ee(76420), tt = ee(96873), Je = ee(60627), Ge = ee(14073), Ye = ee(27279), ze = ee(95328), Fe = ee(13533), ot = ee(77845), vt = ee(3464), gt = ee(43485), yt = ee(10981), pt = ee(79814), bt = ee(38261), ut = ee(331), Ke = ee(70016), je = ee(54838), De = ee(13547), at = ee(3570);
            (function(rt) {
              rt[rt[_$_b208[634]] = 0] = _$_b208[634], rt[rt[_$_b208[635]] = 1] = _$_b208[635], rt[rt[_$_b208[636]] = 2] = _$_b208[636];
            })(ce || (ce = {})), function(rt) {
              rt[_$_b208[637]] = _$_b208[638], rt[_$_b208[639]] = _$_b208[640];
            }(he || (he = {})), te[_$_b208[633]] = _$_b208[641], te[_$_b208[632]] = _$_b208[642];
            var dt = function() {
              function rt(qe, Ze, ht) {
                var _t = this;
                if (this[_$_b208[643]] = null, this[_$_b208[36]] = null, this[_$_b208[644]] = Promise[_$_b208[85]](), this[_$_b208[645]] = [_$_b208[646], _$_b208[647], _$_b208[648], _$_b208[649], _$_b208[650]], this[_$_b208[651]] = [_$_b208[652], _$_b208[653], _$_b208[654], _$_b208[655], _$_b208[656]], this[_$_b208[657]] = Promise[_$_b208[85]](), this[_$_b208[658]] = Promise[_$_b208[85]](), this[_$_b208[659]] = function(wt) {
                  var It, Pt, kt, Mt;
                  if (wt === void 0 && (wt = _$_b208[660]), (Pt = (It = _t[_$_b208[544]]) === null || It === void 0 ? void 0 : It[_$_b208[565]]) === null || Pt === void 0 ? void 0 : Pt[_$_b208[661]]) {
                    var At = Promise[_$_b208[85]]();
                    Tt(wt) || (At = _t[_$_b208[662]](), _t[_$_b208[663]](), _t[_$_b208[664]]()), (Mt = (kt = _t[_$_b208[544]]) === null || kt === void 0 ? void 0 : kt[_$_b208[160]]) === null || Mt === void 0 || Mt[_$_b208[666]]($e[_$_b208[482]][_$_b208[665]]), _t[_$_b208[667]] = !1, _t[_$_b208[668]] = void 0, _t[_$_b208[544]][_$_b208[46]] && $t(_t[_$_b208[544]][_$_b208[46]]), _t[_$_b208[644]] = _t[_$_b208[644]][_$_b208[674]](function() {
                      return At;
                    })[_$_b208[674]](function() {
                      var Rt, Ot;
                      return (Ot = (Rt = _t[_$_b208[544]]) === null || Rt === void 0 ? void 0 : Rt[_$_b208[565]]) === null || Ot === void 0 ? void 0 : Ot[_$_b208[661]](wt)[_$_b208[674]](function() {
                        var xt;
                        return (xt = _t[_$_b208[46]]) === null || xt === void 0 ? void 0 : xt[_$_b208[494]][_$_b208[493]](fe[_$_b208[490]][_$_b208[675]], function(Ut) {
                          return Ut[_$_b208[676]](Tt(wt));
                        });
                      })[_$_b208[674]](function() {
                        var xt, Ut, Nt;
                        _t[_$_b208[669]] && _t[_$_b208[669]][_$_b208[670]](), !((Ut = (xt = _t[_$_b208[544]]) === null || xt === void 0 ? void 0 : xt[_$_b208[46]]) === null || Ut === void 0) && Ut[_$_b208[671]] && (Tt(wt) ? _t[_$_b208[544]][_$_b208[46]][_$_b208[671]][_$_b208[134]] && _t[_$_b208[672]]() : (Nt = _t[_$_b208[46]]) === null || Nt === void 0 || Nt[_$_b208[494]][_$_b208[673]](), _t[_$_b208[544]][_$_b208[46]][_$_b208[671]][_$_b208[70]]());
                      });
                    });
                  }
                  return _t[_$_b208[644]];
                }, this[_$_b208[677]] = function(wt) {
                  var It;
                  _t[_$_b208[678]]() && ((It = _t[_$_b208[544]][_$_b208[565]]) === null || It === void 0 || It[_$_b208[677]](wt));
                }, this[_$_b208[547]] = function(wt) {
                  return wt === void 0 && (wt = _t[_$_b208[679]]()), !!wt && !!wt[_$_b208[680]] && (0, Fe[_$_b208[191]])()[_$_b208[461]];
                }, this[_$_b208[681]] = function(wt, It, Pt) {
                  if (Pt === void 0 && (Pt = {}), wt)
                    _t[_$_b208[683]]($e[_$_b208[482]][_$_b208[682]], { data: Pt });
                  else {
                    _t[_$_b208[684]] = !1, _t[_$_b208[685]] = _t[_$_b208[686]](It);
                    var kt = function() {
                      clearTimeout(Mt), _t[_$_b208[688]]($e[_$_b208[482]][_$_b208[687]], kt), _t[_$_b208[688]]($e[_$_b208[482]][_$_b208[689]], kt), _t[_$_b208[160]] && _t[_$_b208[160]][_$_b208[690]](_t[_$_b208[685]]);
                    }, Mt = setTimeout(kt, 500);
                    _t[_$_b208[404]]($e[_$_b208[482]][_$_b208[687]], kt), _t[_$_b208[404]]($e[_$_b208[482]][_$_b208[689]], kt), _t[_$_b208[661]]();
                  }
                }, this[_$_b208[691]] = function() {
                  var wt, It, Pt;
                  _$_b208[692] !== ((Pt = (It = (wt = _t[_$_b208[544]]) === null || wt === void 0 ? void 0 : wt[_$_b208[587]]) === null || It === void 0 ? void 0 : It[_$_b208[693]]) === null || Pt === void 0 ? void 0 : Pt[_$_b208[695]](_$_b208[694])) || _t[_$_b208[544]][_$_b208[696]] || _t[_$_b208[544]][_$_b208[587]][_$_b208[693]][_$_b208[699]](_$_b208[694], _$_b208[697], _$_b208[698]);
                }, this[_$_b208[700]] = function() {
                  _t[_$_b208[544]] && _t[_$_b208[544]][_$_b208[587]] && _t[_$_b208[544]][_$_b208[587]][_$_b208[693]] && _t[_$_b208[544]][_$_b208[587]][_$_b208[693]][_$_b208[699]](_$_b208[694], _$_b208[692], _$_b208[698]);
                }, this[_$_b208[701]] = function() {
                  var wt = _t[_$_b208[544]][_$_b208[703]][_$_b208[498]]()[_$_b208[702]];
                  return wt ? _t[_$_b208[706]](wt, _t[_$_b208[704]](), function(It) {
                    return _t[_$_b208[705]](It, !0, !1);
                  }) : Promise[_$_b208[85]]();
                }, this[_$_b208[707]] = function() {
                  var wt = _t[_$_b208[544]][_$_b208[703]][_$_b208[498]]()[_$_b208[708]];
                  return wt ? _t[_$_b208[706]](wt, _t[_$_b208[709]](), _t[_$_b208[677]]) : Promise[_$_b208[85]]();
                }, this[_$_b208[710]] = function() {
                  if (_t[_$_b208[659]](), _t[_$_b208[545]]) {
                    var wt = _t[_$_b208[545]][_$_b208[712]](ye[_$_b208[249]][_$_b208[281]] + _$_b208[711])[0];
                    wt && (wt[_$_b208[693]][_$_b208[694]] = _$_b208[697]);
                  }
                }, this[_$_b208[713]] = function() {
                  if (_t[_$_b208[714]]) {
                    _t[_$_b208[703]][_$_b208[716]]()[_$_b208[20]](_$_b208[715]) && (_t[_$_b208[651]][_$_b208[138]](_t[_$_b208[703]][_$_b208[716]]()[_$_b208[715]]) > -1 ? _t[_$_b208[714]][_$_b208[717]](_t[_$_b208[703]][_$_b208[716]]()[_$_b208[715]]) : _t[_$_b208[148]][_$_b208[721]](_$_b208[718], new be[_$_b208[720]](ue[_$_b208[369]][_$_b208[719]], { "impression-server": _t[_$_b208[703]][_$_b208[716]]()[_$_b208[715]] })));
                    var wt = _t[_$_b208[703]][_$_b208[199]](_$_b208[722]);
                    _t[_$_b208[714]][_$_b208[727]](_t[_$_b208[724]]()[_$_b208[723]], _t[_$_b208[725]](), wt == null ? void 0 : wt[_$_b208[726]])[_$_b208[674]](function() {
                    }, function() {
                    });
                  }
                }, this[_$_b208[728]] = function(wt, It) {
                  if (_t[_$_b208[729]]() && It[_$_b208[730]] === Qe[_$_b208[732]][_$_b208[731]] && _t[_$_b208[733]]() && _t[_$_b208[735]]()[_$_b208[734]]()) {
                    var Pt = _t[_$_b208[735]]()[_$_b208[736]];
                    _t[_$_b208[737]](Pt);
                  }
                }, this[_$_b208[738]] = function() {
                  _t[_$_b208[733]]() ? _t[_$_b208[735]]()[_$_b208[734]]() ? _t[_$_b208[683]]($e[_$_b208[482]][_$_b208[739]]) : _t[_$_b208[740]] || _t[_$_b208[741]] || setTimeout(function() {
                    _t[_$_b208[741]] = _t[_$_b208[735]]()[_$_b208[743]]()[_$_b208[674]](function() {
                      _t[_$_b208[741]] = null, _t[_$_b208[742]]();
                    });
                  }) : _t[_$_b208[742]]();
                }, this[_$_b208[742]] = function() {
                  _t[_$_b208[714]] && _t[_$_b208[714]][_$_b208[64]](), _t[_$_b208[740]] = !0, _t[_$_b208[683]]($e[_$_b208[482]][_$_b208[739]]);
                }, this[_$_b208[744]] = function() {
                  !(_t[_$_b208[733]]() && _t[_$_b208[745]]() && _t[_$_b208[745]]()[_$_b208[734]]()) && _t[_$_b208[740]] && (_t[_$_b208[740]] = !1), _t[_$_b208[746]] = _t[_$_b208[747]](_t[_$_b208[746]]);
                }, Object[_$_b208[69]]((0, Fe[_$_b208[191]])())[_$_b208[18]] || (0, Fe[_$_b208[302]])()[_$_b208[552]]((0, ke[_$_b208[748]])()), this[_$_b208[545]] = qe, this[_$_b208[749]] = Ze, this[_$_b208[750]] = ht, this[_$_b208[667]] = !1, this[_$_b208[148]] = new Ee[_$_b208[752]](Ue[_$_b208[751]]), this[_$_b208[753]] = new bt[_$_b208[754]]((0, Fe[_$_b208[191]])()[_$_b208[467]]), this[_$_b208[703]] = null, this[_$_b208[755]] = NaN, this[_$_b208[756]] = new Be[_$_b208[757]](), this[_$_b208[160]] = new Se[_$_b208[758]](this[_$_b208[148]], this[_$_b208[750]], this[_$_b208[749]]), this[_$_b208[759]] = ce[_$_b208[634]], _e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[760]])) {
                  var Ct = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[760]])[_$_b208[761]];
                  this[_$_b208[762]] = new Ct(), this[_$_b208[763]] = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[760]])[_$_b208[764]](function() {
                    var wt;
                    return (wt = _t[_$_b208[46]]) === null || wt === void 0 ? void 0 : wt[_$_b208[494]];
                  }, this[_$_b208[148]]);
                }
                this[_$_b208[765]] = null, this[_$_b208[766]] = !1, this[_$_b208[767]]();
              }
              return rt[_$_b208[21]][_$_b208[768]] = function() {
                return this[_$_b208[46]] && this[_$_b208[46]][_$_b208[553]] && (0, Xe[_$_b208[768]])(this[_$_b208[46]][_$_b208[553]][_$_b208[182]]()[_$_b208[769]]) || !1;
              }, rt[_$_b208[21]][_$_b208[770]] = function() {
                return this[_$_b208[46]] && this[_$_b208[46]][_$_b208[553]] && (0, Xe[_$_b208[770]])(this[_$_b208[46]][_$_b208[553]][_$_b208[182]]()[_$_b208[769]]) || !1;
              }, rt[_$_b208[21]][_$_b208[771]] = function() {
                return !!(this[_$_b208[544]] && this[_$_b208[544]][_$_b208[565]]) && !this[_$_b208[770]]();
              }, rt[_$_b208[21]][_$_b208[678]] = function() {
                return this[_$_b208[772]]() && this[_$_b208[667]];
              }, rt[_$_b208[21]][_$_b208[772]] = function() {
                return this[_$_b208[771]]() && !!this[_$_b208[544]] && !!this[_$_b208[544]][_$_b208[565]];
              }, rt[_$_b208[21]][_$_b208[733]] = function() {
                return !!(this[_$_b208[544]] && this[_$_b208[544]][_$_b208[557]]);
              }, rt[_$_b208[21]][_$_b208[773]] = function() {
                _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[774]]);
                var qe = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[775]]);
                this[_$_b208[544]][_$_b208[557]] = new qe[_$_b208[776]](this, this[_$_b208[544]][_$_b208[46]]), this[_$_b208[160]] && this[_$_b208[160]][_$_b208[503]]($e[_$_b208[482]][_$_b208[777]], { name: le[_$_b208[195]][_$_b208[774]] });
              }, rt[_$_b208[21]][_$_b208[735]] = function() {
                return this[_$_b208[733]]() ? this[_$_b208[544]][_$_b208[557]] : null;
              }, rt[_$_b208[21]][_$_b208[778]] = function() {
                var qe;
                if (!this[_$_b208[771]]() || !(!((qe = this[_$_b208[544]]) === null || qe === void 0) && qe[_$_b208[696]]))
                  return !1;
                var Ze = this[_$_b208[544]][_$_b208[696]][_$_b208[182]]();
                return !!Ze && _$_b208[90] !== Ze;
              }, rt[_$_b208[21]][_$_b208[779]] = function(qe, Ze) {
                if (!qe || !Ze)
                  return null;
                var ht;
                if (Ze[_$_b208[780]] === Me[_$_b208[782]][_$_b208[781]])
                  ht = qe[_$_b208[783]];
                else if (Ze[_$_b208[780]] === Me[_$_b208[782]][_$_b208[784]])
                  ht = qe[_$_b208[785]];
                else if (Ze[_$_b208[780]] === Me[_$_b208[782]][_$_b208[786]])
                  ht = qe[_$_b208[787]];
                else if (Ze[_$_b208[780]] === Me[_$_b208[782]][_$_b208[788]])
                  ht = qe[_$_b208[789]];
                else {
                  if (Ze[_$_b208[780]] !== Me[_$_b208[782]][_$_b208[790]])
                    return null;
                  ht = qe[_$_b208[791]];
                }
                return ht ? { type: Ze[_$_b208[780]], url: ht, title: qe[_$_b208[792]], description: qe[_$_b208[793]], vr: qe[_$_b208[680]], config: qe } : null;
              }, rt[_$_b208[21]][_$_b208[794]] = function(qe) {
                var Ze = new pe[_$_b208[795]]();
                return new Oe[_$_b208[801]]({ container: this[_$_b208[545]], eventHandler: this[_$_b208[544]][_$_b208[160]], config: this[_$_b208[544]][_$_b208[703]][_$_b208[199]](), storedConfig: this[_$_b208[753]], videoElement: qe || document[_$_b208[796]](_$_b208[214]), settings: this[_$_b208[544]][_$_b208[703]][_$_b208[797]](), logger: this[_$_b208[148]], serviceManager: Ze, internalPlayer: this, segmentInfoService: this[_$_b208[798]], segmentPrefetchingService: this[_$_b208[799]], adRestorationOptimizationService: this[_$_b208[800]] });
              }, rt[_$_b208[21]][_$_b208[802]] = function(qe, Ze) {
                var ht = this;
                if (!this[_$_b208[544]])
                  return Promise[_$_b208[85]]();
                var _t = this[_$_b208[544]][_$_b208[703]];
                _t[_$_b208[803]] && _t[_$_b208[803]]()[_$_b208[804]] && this[_$_b208[805]](_t[_$_b208[803]]()[_$_b208[804]]), this[_$_b208[148]][_$_b208[806]](_t);
                var Ct = this[_$_b208[765]];
                this[_$_b208[544]][_$_b208[587]] && (Ct || (Ct = this[_$_b208[544]][_$_b208[587]][_$_b208[236]]()), this[_$_b208[544]][_$_b208[587]][_$_b208[70]]()), this[_$_b208[46]] ? this[_$_b208[46]][_$_b208[587]] = at[_$_b208[186]][_$_b208[212]](this[_$_b208[46]], Ct) : this[_$_b208[46]] = this[_$_b208[794]](Ct);
                var wt = { context: this[_$_b208[46]], playerInstance: this[_$_b208[544]], container: this[_$_b208[545]], config: _t, source: qe, forceTech: Ze, styleManager: this[_$_b208[669]] };
                return this[_$_b208[807]](), this[_$_b208[756]][_$_b208[817]](wt)[_$_b208[674]](function(It) {
                  var Pt, kt, Mt;
                  return ht[_$_b208[770]]() ? (Pt = It[_$_b208[565]]) === null || Pt === void 0 ? void 0 : Pt[_$_b208[808]]()[_$_b208[674]](function() {
                    It[_$_b208[587]] && It[_$_b208[587]][_$_b208[70]](), It[_$_b208[565]] = null, It[_$_b208[506]] = null, It[_$_b208[587]] = null;
                  }) : (ht[_$_b208[544]][_$_b208[46]] = It[_$_b208[46]], ht[_$_b208[544]][_$_b208[148]] = It[_$_b208[148]], ht[_$_b208[544]][_$_b208[565]] = It[_$_b208[565]], ht[_$_b208[544]][_$_b208[506]] = It[_$_b208[506]], ht[_$_b208[544]][_$_b208[587]] = It[_$_b208[587]], ht[_$_b208[544]][_$_b208[809]] = !0, ht[_$_b208[544]][_$_b208[811]][_$_b208[810]] = _$_b208[812], ht[_$_b208[813]](ht[_$_b208[544]][_$_b208[46]]), !ht[_$_b208[814]] && ht[_$_b208[545]] && (ht[_$_b208[814]] = new De[_$_b208[532]](ht[_$_b208[544]], ht[_$_b208[545]], (Mt = (kt = ht[_$_b208[160]]) === null || kt === void 0 ? void 0 : kt[_$_b208[815]]()) !== null && Mt !== void 0 ? Mt : function() {
                  }, ht[_$_b208[547]])), ht[_$_b208[816]](), Promise[_$_b208[85]]());
                });
              }, rt[_$_b208[21]][_$_b208[807]] = function() {
                this[_$_b208[818]] && this[_$_b208[818]](), this[_$_b208[819]] && this[_$_b208[819]](), this[_$_b208[818]] = (0, vt[_$_b208[183]])(this[_$_b208[46]][_$_b208[553]])(function(qe) {
                  return (0, Xe[_$_b208[820]])((0, Xe[_$_b208[584]])(qe));
                }, this[_$_b208[738]], function(qe) {
                  return qe === !0;
                }), this[_$_b208[819]] = (0, vt[_$_b208[183]])(this[_$_b208[46]][_$_b208[553]])(function(qe) {
                  return (0, Xe[_$_b208[821]])((0, Xe[_$_b208[584]])(qe));
                }, this[_$_b208[728]], function() {
                  return !0;
                });
              }, rt[_$_b208[21]][_$_b208[813]] = function(qe) {
                this[_$_b208[733]]() && this[_$_b208[735]]()[_$_b208[822]](qe), qe[_$_b208[798]] && qe[_$_b208[798]][_$_b208[822]](qe), qe[_$_b208[799]] && qe[_$_b208[799]][_$_b208[822]](qe), qe[_$_b208[800]] && qe[_$_b208[800]][_$_b208[822]](qe);
              }, rt[_$_b208[21]][_$_b208[823]] = function(qe) {
                var Ze;
                this[_$_b208[678]]() && (qe = String(qe) || _$_b208[824], (Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[823]](qe));
              }, rt[_$_b208[21]][_$_b208[825]] = function(qe) {
                var Ze;
                this[_$_b208[678]]() && (qe = String(qe) || _$_b208[824], (Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[825]](qe));
              }, rt[_$_b208[21]][_$_b208[672]] = function() {
                this[_$_b208[544]][_$_b208[46]][_$_b208[494]][_$_b208[362]](fe[_$_b208[490]][_$_b208[826]], this[_$_b208[544]][_$_b208[46]][_$_b208[671]][_$_b208[510]]);
              }, rt[_$_b208[21]][_$_b208[664]] = function() {
                this[_$_b208[544]][_$_b208[46]] && this[_$_b208[544]][_$_b208[46]][_$_b208[799]] && this[_$_b208[544]][_$_b208[46]][_$_b208[799]][_$_b208[64]]();
              }, rt[_$_b208[21]][_$_b208[661]] = function(qe) {
                var Ze, ht, _t, Ct, wt = this;
                return qe === void 0 && (qe = _$_b208[660]), this[_$_b208[827]] = null, Tt(qe) ? (this[_$_b208[829]](he[_$_b208[637]], (ht = (Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 ? void 0 : Ze[_$_b208[828]]()) !== null && ht !== void 0 ? ht : 0), this[_$_b208[829]](he[_$_b208[639]], (Ct = (_t = this[_$_b208[544]][_$_b208[565]]) === null || _t === void 0 ? void 0 : _t[_$_b208[830]]()) !== null && Ct !== void 0 ? Ct : 0)) : (this[_$_b208[643]] = null, this[_$_b208[36]] = null), this[_$_b208[657]][_$_b208[831]](function() {
                  return wt[_$_b208[659]](qe);
                });
              }, rt[_$_b208[21]][_$_b208[832]] = function() {
                var qe;
                return !!(this[_$_b208[772]]() && St(this[_$_b208[544]][_$_b208[565]]) && this[_$_b208[833]]()) && !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[832]]());
              }, rt[_$_b208[21]][_$_b208[834]] = function() {
                var qe;
                this[_$_b208[772]]() && St(this[_$_b208[544]][_$_b208[565]]) && this[_$_b208[544]][_$_b208[565]][_$_b208[833]]() && ((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 || qe[_$_b208[834]]());
              }, rt[_$_b208[21]][_$_b208[833]] = function() {
                return this[_$_b208[772]]() && St(this[_$_b208[544]][_$_b208[565]]) && this[_$_b208[544]][_$_b208[565]][_$_b208[833]]();
              }, rt[_$_b208[21]][_$_b208[835]] = function(qe, Ze) {
                var ht, _t, Ct;
                if (Ze === void 0 && (Ze = _$_b208[660]), this[_$_b208[733]]() && this[_$_b208[735]]()[_$_b208[734]]() || !this[_$_b208[678]]())
                  return !1;
                var wt = (ht = this[_$_b208[544]][_$_b208[565]]) === null || ht === void 0 ? void 0 : ht[_$_b208[836]](), It = this[_$_b208[837]](), Pt = !(It[_$_b208[57]] === -1 && It[_$_b208[58]] === -1);
                return !!(!wt || wt && this[_$_b208[544]][_$_b208[81]][_$_b208[838]]) && (this[_$_b208[839]]() ? (this[_$_b208[766]] = !0, !!(!((_t = this[_$_b208[544]][_$_b208[565]]) === null || _t === void 0) && _t[_$_b208[835]](qe, Ze))) : !!Pt && (this[_$_b208[766]] = !0, qe = this[_$_b208[840]](qe, It), Tt(Ze) || this[_$_b208[836]]() || (qe = Math[_$_b208[842]](qe, It[_$_b208[58]] - this[_$_b208[544]][_$_b208[81]][_$_b208[841]])), !!(!((Ct = this[_$_b208[544]][_$_b208[565]]) === null || Ct === void 0) && Ct[_$_b208[835]](qe, Ze))));
              }, rt[_$_b208[21]][_$_b208[839]] = function() {
                return this[_$_b208[725]]()[_$_b208[26]](Me[_$_b208[844]][_$_b208[843]]);
              }, rt[_$_b208[21]][_$_b208[845]] = function(qe, Ze) {
                var ht;
                return !(!this[_$_b208[772]]() || !St(this[_$_b208[544]][_$_b208[565]])) && ((ht = this[_$_b208[544]][_$_b208[565]]) === null || ht === void 0 ? void 0 : ht[_$_b208[845]](qe, Ze));
              }, rt[_$_b208[21]][_$_b208[840]] = function(qe, Ze) {
                if (qe < Ze[_$_b208[57]] || qe > Ze[_$_b208[58]]) {
                  var ht = qe;
                  qe = Math[_$_b208[137]](qe, Ze[_$_b208[57]]), qe = Math[_$_b208[842]](qe, Ze[_$_b208[58]]), this[_$_b208[148]][_$_b208[154]](_$_b208[846] + Ze[_$_b208[57]] + _$_b208[847] + Ze[_$_b208[58]] + _$_b208[848] + ht + _$_b208[847] + qe);
                }
                return qe;
              }, rt[_$_b208[21]][_$_b208[849]] = function() {
                var qe;
                return this[_$_b208[772]]() ? !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[849]]()) : this[_$_b208[544]][_$_b208[479]];
              }, rt[_$_b208[21]][_$_b208[709]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[709]]()) !== null && Ze !== void 0 ? Ze : [];
              }, rt[_$_b208[21]][_$_b208[850]] = function(qe) {
                this[_$_b208[669]] ? this[_$_b208[669]][_$_b208[850]](qe) : this[_$_b208[148]][_$_b208[154]](_$_b208[851]);
              }, rt[_$_b208[21]][_$_b208[852]] = function(qe) {
                var Ze = this[_$_b208[704]]()[_$_b208[164]](function(ht) {
                  return ht[_$_b208[749]] === qe;
                });
                Ze && this[_$_b208[683]]($e[_$_b208[482]][_$_b208[853]], { subtitle: ne({}, Ze) });
              }, rt[_$_b208[21]][_$_b208[854]] = function() {
                var qe = this, Ze = this[_$_b208[704]]()[_$_b208[165]](function(ht) {
                  return ht[_$_b208[856]];
                })[_$_b208[124]](function(ht) {
                  return qe[_$_b208[855]](ht[_$_b208[749]], !1);
                });
                return Promise[_$_b208[857]](Ze);
              }, rt[_$_b208[21]][_$_b208[705]] = function(qe, Ze, ht) {
                var _t = this;
                Ze === void 0 && (Ze = !0), ht === void 0 && (ht = !0);
                var Ct = this[_$_b208[704]]()[_$_b208[164]](function(wt) {
                  return wt[_$_b208[749]] === qe;
                });
                return this[_$_b208[678]]() && Ct && !Ct[_$_b208[856]] ? (ht && this[_$_b208[683]]($e[_$_b208[482]][_$_b208[858]], { subtitle: ne({}, Ct) }), Promise[_$_b208[85]]()[_$_b208[674]](function() {
                  return Ze ? _t[_$_b208[854]]() : Promise[_$_b208[857]]([!1]);
                })[_$_b208[674]](function() {
                  var wt;
                  return !!(!((wt = _t[_$_b208[544]][_$_b208[565]]) === null || wt === void 0) && wt[_$_b208[705]](qe));
                })[_$_b208[674]](function(wt) {
                  return wt && _t[_$_b208[852]](qe), wt;
                })) : Promise[_$_b208[85]](!1);
              }, rt[_$_b208[21]][_$_b208[855]] = function(qe, Ze) {
                var ht = this;
                if (Ze === void 0 && (Ze = !0), this[_$_b208[678]]()) {
                  var _t = this[_$_b208[704]]()[_$_b208[164]](function(Ct) {
                    return Ct[_$_b208[749]] === qe;
                  });
                  if (_t && _t[_$_b208[856]])
                    return Ze && this[_$_b208[683]]($e[_$_b208[482]][_$_b208[859]], { subtitle: ne({}, _t) }), this[_$_b208[544]][_$_b208[565]] ? this[_$_b208[544]][_$_b208[565]][_$_b208[855]](qe)[_$_b208[674]](function(Ct) {
                      return Ct && ht[_$_b208[683]]($e[_$_b208[482]][_$_b208[860]], { subtitle: ne(ne({}, _t), { enabled: !1 }) }), Ct;
                    }) : Promise[_$_b208[85]](!1);
                }
                return Promise[_$_b208[85]](!1);
              }, rt[_$_b208[21]][_$_b208[861]] = function() {
                var qe, Ze;
                this[_$_b208[678]]() && !this[_$_b208[836]]() && (this[_$_b208[766]] || this[_$_b208[862]](this[_$_b208[544]][_$_b208[507]], !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[836]]())), (Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[861]]());
              }, rt[_$_b208[21]][_$_b208[863]] = function(qe) {
                var Ze;
                this[_$_b208[544]][_$_b208[479]] = !0, this[_$_b208[772]]() && (this[_$_b208[733]]() && !this[_$_b208[849]]() && this[_$_b208[735]]()[_$_b208[477]](0), this[_$_b208[864]] = this[_$_b208[865]](), (Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[863]](qe));
              }, rt[_$_b208[21]][_$_b208[866]] = function(qe) {
                var Ze;
                if (this[_$_b208[544]][_$_b208[479]] = !1, this[_$_b208[772]]()) {
                  if (this[_$_b208[733]]() && this[_$_b208[849]]()) {
                    var ht = isNaN(this[_$_b208[864]]) ? 100 : this[_$_b208[864]];
                    this[_$_b208[864]] = NaN, this[_$_b208[735]]()[_$_b208[477]](ht);
                  }
                  (Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[866]](qe);
                }
              }, rt[_$_b208[21]][_$_b208[704]] = function() {
                var qe, Ze;
                if (!this[_$_b208[678]]())
                  return [];
                var ht = (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[704]]()[_$_b208[124]](function(_t) {
                  return ne({}, _t);
                })) !== null && Ze !== void 0 ? Ze : [];
                return ae([], ht, !0);
              }, rt[_$_b208[21]][_$_b208[867]] = function(qe) {
                var Ze, ht;
                return qe === void 0 && (qe = _$_b208[660]), this[_$_b208[772]]() ? !Tt(qe) && this[_$_b208[734]]() ? this[_$_b208[735]]()[_$_b208[867]]() : this[_$_b208[678]]() && (ht = (Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 ? void 0 : Ze[_$_b208[867]]()) !== null && ht !== void 0 ? ht : 0 : 0;
              }, rt[_$_b208[21]][_$_b208[868]] = function(qe, Ze) {
                var ht;
                this[_$_b208[544]][_$_b208[478]] = qe, this[_$_b208[772]]() && ((ht = this[_$_b208[544]][_$_b208[565]]) === null || ht === void 0 || ht[_$_b208[868]](qe, Ze), this[_$_b208[733]]() && this[_$_b208[735]]()[_$_b208[477]](qe));
              }, rt[_$_b208[21]][_$_b208[869]] = function(qe, Ze) {
                var ht;
                this[_$_b208[678]]() && (qe = this[_$_b208[870]](qe), (ht = this[_$_b208[544]][_$_b208[565]]) === null || ht === void 0 || ht[_$_b208[869]](qe, Ze), this[_$_b208[766]] = !0);
              }, rt[_$_b208[21]][_$_b208[870]] = function(qe) {
                var Ze;
                if (qe <= 0)
                  return qe;
                var ht = (0, ut[_$_b208[14]])(Date[_$_b208[180]]());
                this[_$_b208[839]]() || (ht -= (Ze = this[_$_b208[876]][_$_b208[875]](Me[_$_b208[872]][_$_b208[871]], Me[_$_b208[874]][_$_b208[873]])) === null || Ze === void 0 ? void 0 : Ze[_$_b208[877]]);
                var _t = Math[_$_b208[842]](qe - ht, 0);
                return this[_$_b208[148]][_$_b208[154]](_$_b208[879][_$_b208[94]](qe, _$_b208[878])[_$_b208[94]](_t)), _t;
              }, rt[_$_b208[21]][_$_b208[880]] = function(qe) {
                var Ze;
                this[_$_b208[772]]() && ((Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[880]](qe));
              }, rt[_$_b208[21]][_$_b208[881]] = function() {
                var qe;
                this[_$_b208[772]]() && ((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 || qe[_$_b208[881]]());
              }, rt[_$_b208[21]][_$_b208[882]] = function() {
                var qe;
                this[_$_b208[772]]() && ((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 || qe[_$_b208[882]]());
              }, rt[_$_b208[21]][_$_b208[865]] = function() {
                var qe, Ze;
                return this[_$_b208[772]]() ? (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[865]]()) !== null && Ze !== void 0 ? Ze : 0 : this[_$_b208[544]][_$_b208[478]];
              }, rt[_$_b208[21]][_$_b208[883]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[883]]()) !== null && Ze !== void 0 ? Ze : 0;
              }, rt[_$_b208[21]][_$_b208[884]] = function(qe) {
                var Ze;
                this[_$_b208[678]]() && (_$_b208[885] != typeof qe || qe < 0 ? this[_$_b208[889]](_$_b208[886], _$_b208[887][_$_b208[94]](qe), _$_b208[888], _$_b208[265][_$_b208[94]](qe)) : (Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[884]](qe));
              }, rt[_$_b208[21]][_$_b208[890]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() ? (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[890]]()) !== null && Ze !== void 0 ? Ze : 0 : -1;
              }, rt[_$_b208[21]][_$_b208[891]] = function(qe) {
                var Ze;
                this[_$_b208[678]]() && ((Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[891]](qe));
              }, rt[_$_b208[21]][_$_b208[892]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[892]]()) !== null && Ze !== void 0 ? Ze : null;
              }, rt[_$_b208[21]][_$_b208[893]] = function(qe) {
                var Ze;
                this[_$_b208[678]]() && ((Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[893]](qe));
              }, rt[_$_b208[21]][_$_b208[894]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[894]]()) !== null && Ze !== void 0 ? Ze : null;
              }, rt[_$_b208[21]][_$_b208[895]] = function(qe, Ze) {
                var ht, _t;
                return qe === void 0 && (qe = _$_b208[660]), Ze === void 0 && (Ze = Me[_$_b208[897]][_$_b208[896]]), this[_$_b208[734]]() && !Tt(qe) ? this[_$_b208[735]]()[_$_b208[895]]() : this[_$_b208[678]]() && (_t = (ht = this[_$_b208[544]][_$_b208[565]]) === null || ht === void 0 ? void 0 : ht[_$_b208[895]](Ze)) !== null && _t !== void 0 ? _t : 0;
              }, rt[_$_b208[21]][_$_b208[898]] = function(qe, Ze, ht) {
                var _t;
                if (this[_$_b208[772]]()) {
                  var Ct = Object[_$_b208[69]](Me[_$_b208[872]])[_$_b208[610]](function(It) {
                    return qe === Me[_$_b208[872]][It];
                  }), wt = Object[_$_b208[69]](Me[_$_b208[874]])[_$_b208[610]](function(It) {
                    return ht === Me[_$_b208[874]][It];
                  });
                  Ct ? wt ? _$_b208[885] != typeof Ze || Ze < 0 ? this[_$_b208[889]](_$_b208[899], _$_b208[887][_$_b208[94]](Ze), _$_b208[888], _$_b208[265][_$_b208[94]](Ze)) : (_t = this[_$_b208[544]][_$_b208[565]]) === null || _t === void 0 || _t[_$_b208[898]](qe, Ze, ht) : this[_$_b208[889]](_$_b208[899], _$_b208[900][_$_b208[94]](ht), _$_b208[901], _$_b208[265][_$_b208[94]](ht)) : this[_$_b208[889]](_$_b208[899], _$_b208[902][_$_b208[94]](qe), _$_b208[89], _$_b208[265][_$_b208[94]](qe));
                }
              }, rt[_$_b208[21]][_$_b208[903]] = function(qe, Ze) {
                var ht, _t, Ct = { level: null, targetLevel: null, type: qe, media: Ze };
                return this[_$_b208[772]]() && this[_$_b208[904]](qe, Ze) && (_t = (ht = this[_$_b208[544]][_$_b208[565]]) === null || ht === void 0 ? void 0 : ht[_$_b208[903]](qe, Ze)) !== null && _t !== void 0 ? _t : Ct;
              }, rt[_$_b208[21]][_$_b208[904]] = function(qe, Ze) {
                var ht = Object[_$_b208[69]](Me[_$_b208[872]])[_$_b208[610]](function(Ct) {
                  return qe === Me[_$_b208[872]][Ct];
                }), _t = Object[_$_b208[69]](Me[_$_b208[874]])[_$_b208[610]](function(Ct) {
                  return Ze === Me[_$_b208[874]][Ct];
                });
                return ht && _t;
              }, rt[_$_b208[21]][_$_b208[905]] = function() {
                return this[_$_b208[678]]() ? this[_$_b208[903]](Me[_$_b208[872]][_$_b208[871]], Me[_$_b208[874]][_$_b208[906]])[_$_b208[804]] : null;
              }, rt[_$_b208[21]][_$_b208[907]] = function() {
                return this[_$_b208[678]]() ? this[_$_b208[903]](Me[_$_b208[872]][_$_b208[871]], Me[_$_b208[874]][_$_b208[873]])[_$_b208[804]] : null;
              }, rt[_$_b208[21]][_$_b208[908]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[908]]()) !== null && Ze !== void 0 ? Ze : 0;
              }, rt[_$_b208[21]][_$_b208[909]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[909]]()) !== null && Ze !== void 0 ? Ze : 0;
              }, rt[_$_b208[21]][_$_b208[910]] = function() {
                var qe;
                return this[_$_b208[678]]() && !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[910]]());
              }, rt[_$_b208[21]][_$_b208[836]] = function() {
                var qe;
                return this[_$_b208[678]]() && !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[836]]());
              }, rt[_$_b208[21]][_$_b208[911]] = function() {
                var qe;
                return this[_$_b208[678]]() && !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[911]]());
              }, rt[_$_b208[21]][_$_b208[912]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[912]]()) !== null && Ze !== void 0 ? Ze : [];
              }, rt[_$_b208[21]][_$_b208[913]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[913]]()) !== null && Ze !== void 0 ? Ze : [];
              }, rt[_$_b208[21]][_$_b208[591]] = function() {
                var qe;
                return this[_$_b208[772]]() && !!this[_$_b208[544]][_$_b208[587]] && !!(!((qe = this[_$_b208[544]][_$_b208[587]]) === null || qe === void 0) && qe[_$_b208[591]]());
              }, rt[_$_b208[21]][_$_b208[914]] = function() {
                var qe;
                return this[_$_b208[772]]() && !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[914]]());
              }, rt[_$_b208[21]][_$_b208[915]] = function() {
                var qe;
                return this[_$_b208[772]]() && !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[915]]());
              }, rt[_$_b208[21]][_$_b208[916]] = function() {
                var qe, Ze, ht = { id: _$_b208[265], bitrate: 0, height: 0, width: 0, isAuto: !0 };
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[916]]()) !== null && Ze !== void 0 ? Ze : ht;
              }, rt[_$_b208[21]][_$_b208[917]] = function() {
                var qe, Ze, ht = { id: _$_b208[265], bitrate: 0, isAuto: !0 };
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[917]]()) !== null && Ze !== void 0 ? Ze : ht;
              }, rt[_$_b208[21]][_$_b208[918]] = function() {
                var qe, Ze, ht = { id: _$_b208[265], bitrate: 0, height: 0, width: 0, uid: void 0 };
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[918]]()) !== null && Ze !== void 0 ? Ze : ht;
              }, rt[_$_b208[21]][_$_b208[919]] = function() {
                var qe, Ze, ht = { id: _$_b208[265], bitrate: 0 };
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[919]]()) !== null && Ze !== void 0 ? Ze : ht;
              }, rt[_$_b208[21]][_$_b208[920]] = function() {
                var qe, Ze;
                return (Ze = (qe = this[_$_b208[669]]) === null || qe === void 0 ? void 0 : qe[_$_b208[920]]()) !== null && Ze !== void 0 ? Ze : 0;
              }, rt[_$_b208[21]][_$_b208[921]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[921]]()) !== null && Ze !== void 0 ? Ze : null;
              }, rt[_$_b208[21]][_$_b208[922]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[922]]()) !== null && Ze !== void 0 ? Ze : [];
              }, rt[_$_b208[21]][_$_b208[923]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[923]]()) !== null && Ze !== void 0 ? Ze : {};
              }, rt[_$_b208[21]][_$_b208[924]] = function() {
                var qe, Ze, ht = { id: _$_b208[824], bitrate: null };
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[924]]()) !== null && Ze !== void 0 ? Ze : ht;
              }, rt[_$_b208[21]][_$_b208[925]] = function() {
                return this[_$_b208[36]];
              }, rt[_$_b208[21]][_$_b208[828]] = function() {
                var qe, Ze;
                return this[_$_b208[926]](he[_$_b208[637]], !(this[_$_b208[733]]() && this[_$_b208[735]]()[_$_b208[734]]()), this[_$_b208[772]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[828]]()) !== null && Ze !== void 0 ? Ze : 0);
              }, rt[_$_b208[21]][_$_b208[830]] = function() {
                var qe, Ze;
                return this[_$_b208[926]](he[_$_b208[639]], !(this[_$_b208[733]]() && this[_$_b208[735]]()[_$_b208[734]]()), this[_$_b208[772]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[830]]()) !== null && Ze !== void 0 ? Ze : 0);
              }, rt[_$_b208[21]][_$_b208[927]] = function() {
                var qe, Ze, ht = { id: _$_b208[824], bitrate: null, width: null, height: null };
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[927]]()) !== null && Ze !== void 0 ? Ze : ht;
              }, rt[_$_b208[21]][_$_b208[928]] = function(qe) {
                var Ze = this;
                return new Promise(function(ht) {
                  var _t = !1, Ct = function() {
                    Ze[_$_b208[688]]($e[_$_b208[482]][_$_b208[929]], Ct), _t = !0;
                  }, wt = function() {
                    Ze[_$_b208[688]]($e[_$_b208[482]][_$_b208[930]], wt), Ze[_$_b208[931]] = null, ht();
                  };
                  Ze[_$_b208[404]]($e[_$_b208[482]][_$_b208[929]], Ct), Ze[_$_b208[404]]($e[_$_b208[482]][_$_b208[930]], wt), Ze[_$_b208[544]][_$_b208[46]][_$_b208[494]][_$_b208[199]](fe[_$_b208[490]][_$_b208[489]])[_$_b208[932]](!0, qe), Ze[_$_b208[735]]()[_$_b208[928]]()[_$_b208[674]](function() {
                    Ze[_$_b208[931]] = null, Ze[_$_b208[933]]() || _t ? ht() : ht(Ze[_$_b208[167]](qe));
                  });
                });
              }, rt[_$_b208[21]][_$_b208[729]] = function() {
                var qe = (0, Xe[_$_b208[821]])(this[_$_b208[46]][_$_b208[553]][_$_b208[182]]()[_$_b208[769]]);
                return qe[_$_b208[934]] === Qe[_$_b208[936]][_$_b208[935]] && qe[_$_b208[730]] !== Qe[_$_b208[732]][_$_b208[731]];
              }, rt[_$_b208[21]][_$_b208[937]] = function() {
                return this[_$_b208[733]]() && !this[_$_b208[735]]()[_$_b208[938]]() && !this[_$_b208[939]]();
              }, rt[_$_b208[21]][_$_b208[940]] = function() {
                if (this[_$_b208[832]]())
                  return !1;
                var qe = this[_$_b208[759]] === ce[_$_b208[634]], Ze = this[_$_b208[759]] === ce[_$_b208[635]];
                return qe || !this[_$_b208[849]]() && Ze;
              }, rt[_$_b208[21]][_$_b208[941]] = function() {
                var qe = this;
                this[_$_b208[544]][_$_b208[696]] && this[_$_b208[544]][_$_b208[696]][_$_b208[945]]()[_$_b208[674]](function() {
                  return qe[_$_b208[148]][_$_b208[154]](_$_b208[944]);
                })[_$_b208[943]](function() {
                  return qe[_$_b208[148]][_$_b208[154]](_$_b208[942]);
                });
              }, rt[_$_b208[21]][_$_b208[167]] = function(qe) {
                var Ze = this;
                return qe === void 0 && (qe = _$_b208[660]), this[_$_b208[946]](qe) ? this[_$_b208[931]] ? this[_$_b208[931]][_$_b208[674]](function() {
                  return Ze[_$_b208[735]]()[_$_b208[167]]();
                }) : this[_$_b208[735]]()[_$_b208[167]]() : this[_$_b208[678]]() ? this[_$_b208[937]]() && !this[_$_b208[729]]() ? this[_$_b208[931]] = this[_$_b208[928]](qe) : (!this[_$_b208[766]] && this[_$_b208[862]](this[_$_b208[544]][_$_b208[507]], this[_$_b208[836]]()), this[_$_b208[941]](), this[_$_b208[544]][_$_b208[565]] ? this[_$_b208[544]][_$_b208[565]][_$_b208[167]](qe)[_$_b208[674]](function() {
                  Ze[_$_b208[759]] = Ze[_$_b208[747]](Ze[_$_b208[759]]), Ze[_$_b208[492]](Ze[_$_b208[544]][_$_b208[491]]);
                })[_$_b208[943]](function(ht) {
                  var _t;
                  return Ze[_$_b208[148]][_$_b208[154]](_$_b208[947], ht), Ze[_$_b208[940]]() && (Ze[_$_b208[683]]($e[_$_b208[482]][_$_b208[948]], new ve[_$_b208[951]](me[_$_b208[950]][_$_b208[949]])), Ze[_$_b208[832]]() || Ze[_$_b208[169]](), ht instanceof Error && _$_b208[82] === ht[_$_b208[176]] && ((_t = Ze[_$_b208[544]][_$_b208[46]][_$_b208[494]][_$_b208[199]](fe[_$_b208[490]][_$_b208[489]])) === null || _t === void 0 || _t[_$_b208[952]](!0, qe))), Promise[_$_b208[84]](ht);
                }) : Promise[_$_b208[84]](_$_b208[953])) : Promise[_$_b208[84]](new be[_$_b208[720]](ue[_$_b208[369]][_$_b208[954]], void 0, _$_b208[955]));
              }, rt[_$_b208[21]][_$_b208[946]] = function(qe) {
                if (Tt(qe))
                  return !1;
                var Ze = !!this[_$_b208[931]];
                return this[_$_b208[734]]() || Ze;
              }, rt[_$_b208[21]][_$_b208[734]] = function() {
                return !!this[_$_b208[733]]() && this[_$_b208[735]]()[_$_b208[734]]();
              }, rt[_$_b208[21]][_$_b208[169]] = function(qe) {
                var Ze, ht = this;
                qe === void 0 && (qe = _$_b208[660]), this[_$_b208[946]](qe) ? this[_$_b208[931]] ? this[_$_b208[931]][_$_b208[674]](function() {
                  return ht[_$_b208[735]]()[_$_b208[169]]();
                }) : this[_$_b208[735]]()[_$_b208[169]]() : this[_$_b208[678]]() && ((Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[169]](qe));
              }, rt[_$_b208[21]][_$_b208[956]] = function() {
                var qe;
                this[_$_b208[772]]() && St(this[_$_b208[544]][_$_b208[565]]) && ((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 || qe[_$_b208[956]]());
              }, rt[_$_b208[21]][_$_b208[805]] = function(qe) {
                this[_$_b208[148]][_$_b208[805]](qe);
              }, rt[_$_b208[21]][_$_b208[957]] = function() {
                return this[_$_b208[148]];
              }, rt[_$_b208[21]][_$_b208[958]] = function(qe, Ze, ht) {
                var _t;
                this[_$_b208[544]] && this[_$_b208[544]][_$_b208[160]] ? _t = this[_$_b208[544]][_$_b208[160]] : this[_$_b208[160]] && (_t = this[_$_b208[160]]), _t[_$_b208[404]](qe, Ze, ht);
              }, rt[_$_b208[21]][_$_b208[959]] = function(qe, Ze) {
                this[_$_b208[958]](qe, Ze, !0);
              }, rt[_$_b208[21]][_$_b208[404]] = function(qe, Ze) {
                this[_$_b208[958]](qe, Ze, !1);
              }, rt[_$_b208[21]][_$_b208[688]] = function(qe, Ze) {
                this[_$_b208[544]] && this[_$_b208[544]][_$_b208[160]] ? this[_$_b208[544]][_$_b208[160]][_$_b208[688]](qe, Ze) : this[_$_b208[160]] && this[_$_b208[160]][_$_b208[688]](qe, Ze);
              }, rt[_$_b208[21]][_$_b208[960]] = function(qe) {
                var Ze;
                return { context: null, logger: this[_$_b208[148]], container: this[_$_b208[545]], bitdashPlayer: null, eventHandler: this[_$_b208[160]], videoElement: null, adController: null, vrHandler: null, hasInitStarted: !1, technology: { player: Me[_$_b208[844]][_$_b208[961]], streaming: Me[_$_b208[782]][_$_b208[961]] }, playerConfig: null, configuration: null, settings: null, source: null, volume: (Ze = qe[_$_b208[498]]()[_$_b208[478]]) !== null && Ze !== void 0 ? Ze : 100, muted: qe[_$_b208[498]]()[_$_b208[479]] || !1, playbackSpeed: 1 };
              }, rt[_$_b208[21]][_$_b208[962]] = function() {
                try {
                  for (var qe = 10, Ze = 0; this[_$_b208[545]][_$_b208[712]](ye[_$_b208[249]][_$_b208[281]] + _$_b208[90])[_$_b208[18]] > 0 && (this[_$_b208[545]][_$_b208[963]](this[_$_b208[545]][_$_b208[712]](ye[_$_b208[249]][_$_b208[281]] + _$_b208[90])[0]), !(++Ze > qe)); )
                    ;
                } catch {
                  this[_$_b208[148]][_$_b208[154]](_$_b208[964]);
                }
              }, rt[_$_b208[21]][_$_b208[965]] = function(qe) {
                if (!this[_$_b208[544]][_$_b208[811]][_$_b208[966]]) {
                  var Ze, ht = this[_$_b208[703]][_$_b208[968]]()[_$_b208[967]], _t = this[_$_b208[703]][_$_b208[716]]();
                  (ht || ht === 0) && !isNaN(ht) && ht >= 0 && (Ze = ht);
                  var Ct = this[_$_b208[645]][0];
                  _t[_$_b208[969]] && (this[_$_b208[645]][_$_b208[26]](_t[_$_b208[969]]) ? Ct = _t[_$_b208[969]] : this[_$_b208[148]][_$_b208[721]](_$_b208[970], new be[_$_b208[720]](ue[_$_b208[369]][_$_b208[971]], { "license-server": _t[_$_b208[969]] }))), this[_$_b208[972]] = Te[_$_b208[973]][_$_b208[817]](this[_$_b208[148]], Ct, qe[_$_b208[723]]), this[_$_b208[972]][_$_b208[974]](Ze);
                  var wt = this[_$_b208[703]][_$_b208[199]](_$_b208[722]);
                  this[_$_b208[972]][_$_b208[727]](this[_$_b208[681]], wt == null ? void 0 : wt[_$_b208[726]]);
                }
              }, rt[_$_b208[21]][_$_b208[975]] = function(qe) {
                var Ze, ht;
                this[_$_b208[703]] = new se[_$_b208[976]](qe), this[_$_b208[753]][_$_b208[979]](!!(!((Ze = qe[_$_b208[977]]) === null || Ze === void 0) && Ze[_$_b208[978]])), this[_$_b208[544]] = this[_$_b208[544]] || this[_$_b208[960]](this[_$_b208[703]]), this[_$_b208[544]][_$_b208[703]] = this[_$_b208[703]], this[_$_b208[544]][_$_b208[81]] = this[_$_b208[703]][_$_b208[797]](), this[_$_b208[148]][_$_b208[980]](this[_$_b208[544]][_$_b208[81]]), this[_$_b208[148]][_$_b208[805]](this[_$_b208[703]][_$_b208[199]](_$_b208[803])[_$_b208[804]]), (ht = this[_$_b208[160]]) === null || ht === void 0 || ht[_$_b208[982]](this[_$_b208[703]][_$_b208[199]](_$_b208[981])), this[_$_b208[148]][_$_b208[806]](this[_$_b208[703]]);
                var _t = this[_$_b208[703]][_$_b208[716]]()[_$_b208[983]];
                if (_t && this[_$_b208[805]](_t), this[_$_b208[703]][_$_b208[716]]()[_$_b208[984]] && (0, Pe[_$_b208[985]])(this[_$_b208[148]]), _e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[986]]) && _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[986]])[_$_b208[987]](this[_$_b208[148]]), this[_$_b208[703]][_$_b208[199]](_$_b208[803])[_$_b208[988]] && (this[_$_b208[148]][_$_b208[992]](_$_b208[989], _$_b208[990], _$_b208[991]), this[_$_b208[148]][_$_b208[992]](_$_b208[993] + ye[_$_b208[249]][_$_b208[279]], _$_b208[994], _$_b208[995])), (0, oe[_$_b208[996]])(this[_$_b208[703]]), this[_$_b208[544]][_$_b208[811]] = { isAdPlayer: !1, prefix: _$_b208[265], visibility: _$_b208[812] }, this[_$_b208[545]] && (this[_$_b208[545]][_$_b208[769]] = this[_$_b208[750]], this[_$_b208[962]]()), this[_$_b208[965]](qe), _e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[997]])) {
                  var Ct = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[997]])[_$_b208[998]];
                  this[_$_b208[669]] = new Ct(this, this[_$_b208[544]]);
                }
                _e[_$_b208[197]][_$_b208[999]](this[_$_b208[750]]);
              }, rt[_$_b208[21]][_$_b208[1e3]] = function() {
                this[_$_b208[1001]](), this[_$_b208[1002]]();
              }, rt[_$_b208[21]][_$_b208[1003]] = function(qe) {
                if (!ye[_$_b208[249]][_$_b208[254]]())
                  throw new be[_$_b208[720]](ue[_$_b208[369]][_$_b208[1004]], void 0, _$_b208[1005]);
                return this[_$_b208[975]](qe);
              }, rt[_$_b208[21]][_$_b208[1006]] = function(qe) {
                var Ze, ht = this, _t = ne(ne({}, qe), { kind: (qe == null ? void 0 : qe[_$_b208[220]]) || _$_b208[1007], id: (qe == null ? void 0 : qe[_$_b208[749]]) != null ? String(qe == null ? void 0 : qe[_$_b208[749]]) : void 0, label: (qe == null ? void 0 : qe[_$_b208[1008]]) || (qe == null ? void 0 : qe[_$_b208[1009]]), isSideloaded: !0 });
                if (st(_t)) {
                  if (this[_$_b208[678]]() && !_t[_$_b208[1010]]) {
                    var Ct = _t[_$_b208[856]] || !1;
                    _t[_$_b208[856]] = !1, (Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[1006]](_t)[_$_b208[674]](function() {
                      Ct && ht[_$_b208[705]](_t[_$_b208[749]], !1, !1);
                    })[_$_b208[943]](function() {
                      return function() {
                      };
                    });
                  }
                } else
                  this[_$_b208[683]]($e[_$_b208[482]][_$_b208[948]], new ve[_$_b208[951]](me[_$_b208[950]][_$_b208[1011]], _$_b208[1014][_$_b208[94]](JSON[_$_b208[1012]](qe), _$_b208[1013]), { method: _$_b208[1015], parameter: _$_b208[1016], argument: qe }));
              }, rt[_$_b208[21]][_$_b208[1017]] = function(qe) {
                var Ze;
                this[_$_b208[678]]() && ((Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[1017]](qe));
              }, rt[_$_b208[21]][_$_b208[1018]] = function() {
                return this[_$_b208[545]];
              }, rt[_$_b208[21]][_$_b208[1019]] = function(qe) {
                return !(!this[_$_b208[771]]() || !this[_$_b208[778]]() || _$_b208[1020] != typeof qe) && this[_$_b208[544]][_$_b208[696]][_$_b208[1021]](qe);
              }, rt[_$_b208[21]][_$_b208[1022]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[506]]) === null || qe === void 0 ? void 0 : qe[_$_b208[780]]) !== null && Ze !== void 0 ? Ze : Me[_$_b208[782]][_$_b208[961]];
              }, rt[_$_b208[21]][_$_b208[725]] = function() {
                var qe, Ze;
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[506]]) === null || qe === void 0 ? void 0 : qe[_$_b208[769]]) !== null && Ze !== void 0 ? Ze : Me[_$_b208[844]][_$_b208[961]];
              }, rt[_$_b208[21]][_$_b208[1023]] = function(qe) {
                switch (qe) {
                  case Me[_$_b208[1025]][_$_b208[1024]]:
                    return ae([], (0, Fe[_$_b208[191]])()[_$_b208[474]], !0);
                  case Me[_$_b208[1025]][_$_b208[1026]]:
                    return ae([], (0, Fe[_$_b208[191]])()[_$_b208[473]], !0);
                  case Me[_$_b208[1025]][_$_b208[1027]]:
                    return ae([], (0, Fe[_$_b208[191]])()[_$_b208[475]], !0);
                  default:
                    return this[_$_b208[683]]($e[_$_b208[482]][_$_b208[948]], new ve[_$_b208[951]](me[_$_b208[950]][_$_b208[1011]], _$_b208[1029][_$_b208[94]](qe, _$_b208[1028]), { method: _$_b208[1023], parameter: _$_b208[1030], argument: _$_b208[265][_$_b208[94]](qe) })), [];
                }
              }, rt[_$_b208[21]][_$_b208[1031]] = function() {
                return this[_$_b208[778]]() ? this[_$_b208[544]][_$_b208[696]] : null;
              }, rt[_$_b208[21]][_$_b208[745]] = function() {
                return this[_$_b208[771]]() && this[_$_b208[733]]() ? this[_$_b208[544]][_$_b208[557]][_$_b208[736]] : (this[_$_b208[724]]()[_$_b208[1032]] == null || _e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[774]]) || this[_$_b208[148]][_$_b208[721]](_$_b208[1033]), null);
              }, rt[_$_b208[21]][_$_b208[1034]] = function(qe) {
                if (_$_b208[348] == typeof qe)
                  try {
                    qe = JSON[_$_b208[1035]](qe);
                  } catch (Ze) {
                    this[_$_b208[148]][_$_b208[1037]](_$_b208[1036] + Ze[_$_b208[119]]);
                  }
                return qe && _$_b208[617] == typeof qe ? qe : null;
              }, rt[_$_b208[21]][_$_b208[1038]] = function(qe) {
                var Ze;
                qe === void 0 && (qe = !1), this[_$_b208[544]] && this[_$_b208[545]] && ((Ze = this[_$_b208[544]][_$_b208[811]] && this[_$_b208[544]][_$_b208[811]][_$_b208[20]](_$_b208[1039]) ? document[_$_b208[1041]](ye[_$_b208[249]][_$_b208[281]] + _$_b208[265] + this[_$_b208[544]][_$_b208[811]][_$_b208[1039]] + _$_b208[1040]) : document[_$_b208[1041]](ye[_$_b208[249]][_$_b208[281]] + _$_b208[1040])) && Ze[_$_b208[1042]] && Ze[_$_b208[1042]][_$_b208[963]](Ze), this[_$_b208[545]] && qe && delete this[_$_b208[545]][_$_b208[769]]);
              }, rt[_$_b208[21]][_$_b208[1043]] = function(qe) {
                var Ze = !1, ht = null;
                qe && (qe[_$_b208[20]](_$_b208[1044]) && qe[_$_b208[1044]] && qe[_$_b208[1044]][_$_b208[20]](_$_b208[1045]) && (Ze = qe[_$_b208[1044]][_$_b208[1045]]), ht = qe[_$_b208[711]]), this[_$_b208[1046]](ht, Ze);
              }, rt[_$_b208[21]][_$_b208[1047]] = function(qe) {
                if (qe)
                  return [_$_b208[783], _$_b208[785], _$_b208[787], _$_b208[789], _$_b208[791], _$_b208[711], _$_b208[1048], _$_b208[792], _$_b208[793], _$_b208[1044], _$_b208[1049], _$_b208[1050], _$_b208[680]][_$_b208[68]](function(Ze) {
                    qe[_$_b208[20]](Ze) && !qe[Ze] && delete qe[Ze];
                  }), qe;
              }, rt[_$_b208[21]][_$_b208[1051]] = function(qe) {
                var Ze, ht = qe[_$_b208[680]], _t = (0, Fe[_$_b208[191]])(), Ct = !!ht, wt = _t[Le[_$_b208[190]][_$_b208[461]]];
                if (Ct && wt) {
                  var It = _t[Le[_$_b208[190]][_$_b208[468]]];
                  ht[_$_b208[1052]] = It, !((Ze = this[_$_b208[814]]) === null || Ze === void 0) && Ze[_$_b208[574]]() && this[_$_b208[608]](Me[_$_b208[563]][_$_b208[572]]), It && (ht[_$_b208[1053]] = je[_$_b208[172]][_$_b208[1054]](), this[_$_b208[545]][_$_b208[1055]](ht[_$_b208[1053]][_$_b208[236]]()));
                }
              }, rt[_$_b208[21]][_$_b208[1056]] = function(qe, Ze, ht) {
                var _t, Ct = mt(this[_$_b208[703]], qe, Ze[_$_b208[1057]]);
                return this[_$_b208[544]][_$_b208[507]] = qe, this[_$_b208[544]][_$_b208[1058]] = Ze, ((_t = this[_$_b208[544]][_$_b208[506]]) === null || _t === void 0 ? void 0 : _t[_$_b208[769]]) === Ct[_$_b208[769]] ? (this[_$_b208[544]][_$_b208[506]] = Ct, Promise[_$_b208[85]]()) : this[_$_b208[1059]](qe, Ct, ht);
              }, rt[_$_b208[21]][_$_b208[1059]] = function(qe, Ze, ht) {
                var _t = this, Ct = function() {
                  var wt;
                  _t[_$_b208[770]]() || ((wt = _t[_$_b208[160]]) === null || wt === void 0 || wt[_$_b208[688]]($e[_$_b208[482]][_$_b208[1060]], Ct), _t[_$_b208[1043]](qe));
                };
                return this[_$_b208[959]]($e[_$_b208[482]][_$_b208[1060]], Ct), this[_$_b208[544]][_$_b208[696]] = null, this[_$_b208[1061]](ht)[_$_b208[674]](function() {
                  return _t[_$_b208[802]](qe, Ze);
                })[_$_b208[674]](function() {
                  return _t[_$_b208[1051]](qe);
                })[_$_b208[943]](function(wt) {
                  return wt && wt[_$_b208[20]](_$_b208[113]) && wt[_$_b208[20]](_$_b208[119]) && _t[_$_b208[160]] ? _t[_$_b208[160]][_$_b208[690]](wt) : wt && _t[_$_b208[148]][_$_b208[90]](wt), Promise[_$_b208[84]](wt);
                });
              }, rt[_$_b208[21]][_$_b208[1061]] = function(qe) {
                var Ze = this;
                return this[_$_b208[544]] && this[_$_b208[544]][_$_b208[565]] ? this[_$_b208[544]][_$_b208[565]][_$_b208[808]](qe)[_$_b208[674]](function() {
                  Ze[_$_b208[544]][_$_b208[565]] = null, Ze[_$_b208[1038]]();
                })[_$_b208[943]](function(ht) {
                  return Ze[_$_b208[148]][_$_b208[90]](_$_b208[1062][_$_b208[94]](ht));
                }) : Promise[_$_b208[85]]();
              }, rt[_$_b208[21]][_$_b208[1063]] = function(qe, Ze, ht) {
                return Ze === Ce[_$_b208[1064]] && qe[_$_b208[1065]]() ? qe[_$_b208[1066]]() : qe[_$_b208[1067]]() ? void 0 : qe[_$_b208[1068]](ht);
              }, rt[_$_b208[21]][_$_b208[1069]] = function(qe, Ze, ht) {
                var _t = this, Ct = mt(this[_$_b208[703]], qe, Ze[_$_b208[1057]]), wt = this[_$_b208[779]](qe, Ct);
                return this[_$_b208[544]][_$_b208[565]] && wt ? this[_$_b208[544]][_$_b208[565]][_$_b208[244]](wt, Ze[_$_b208[1071]])[_$_b208[674]](function() {
                  qe[_$_b208[1048]] && _t[_$_b208[46]][_$_b208[494]][_$_b208[493]](fe[_$_b208[490]][_$_b208[675]], function(It) {
                    return _t[_$_b208[1063]](It, ht, qe[_$_b208[1048]]);
                  });
                })[_$_b208[943]](function(It) {
                  return It && It[_$_b208[113]] && It[_$_b208[119]] && _t[_$_b208[160]] ? _t[_$_b208[160]][_$_b208[690]](It) : It && _t[_$_b208[148]][_$_b208[154]](_$_b208[1070], It), Promise[_$_b208[84]](It);
                }) : Promise[_$_b208[84]](_$_b208[1072]);
              }, rt[_$_b208[21]][_$_b208[1073]] = function(qe) {
                return !!this[_$_b208[827]] && (this[_$_b208[827]][_$_b208[84]](new Error(qe)), this[_$_b208[827]] = null, !0);
              }, rt[_$_b208[21]][_$_b208[1074]] = function(qe) {
                this[_$_b208[544]][_$_b208[565]] && qe[_$_b208[361]](fe[_$_b208[490]][_$_b208[1075]], new xe[_$_b208[1075]](this[_$_b208[544]][_$_b208[565]])), qe[_$_b208[361]](fe[_$_b208[490]][_$_b208[1076]], new we[_$_b208[1076]](this[_$_b208[544]][_$_b208[46]])), qe[_$_b208[361]](fe[_$_b208[490]][_$_b208[1077]], new Ne[_$_b208[1077]](this[_$_b208[544]][_$_b208[46]])), qe[_$_b208[361]](fe[_$_b208[490]][_$_b208[1078]], ct(this[_$_b208[544]][_$_b208[46]])), qe[_$_b208[361]](fe[_$_b208[490]][_$_b208[489]], new Ve[_$_b208[489]](this[_$_b208[544]][_$_b208[46]]));
              }, rt[_$_b208[21]][_$_b208[244]] = function(qe, Ze, ht, _t) {
                var Ct = this;
                ht === void 0 && (ht = !1), _t === void 0 && (_t = _$_b208[660]);
                var wt = _t === Ce[_$_b208[1064]];
                Tt(_t) || (this[_$_b208[766]] = !1, this[_$_b208[746]] = ce[_$_b208[634]], this[_$_b208[740]] = !1, this[_$_b208[643]] = null, this[_$_b208[36]] = null);
                var It = this[_$_b208[827]] = new yt[_$_b208[440]]();
                return this[_$_b208[657]] = this[_$_b208[657]][_$_b208[674]](function() {
                  return Ct[_$_b208[1080]](qe, { forceTechnology: Ze, disableSeeking: ht }, _t);
                })[_$_b208[943]](function(Pt) {
                  return Ct[_$_b208[1079]](It, Pt);
                }), this[_$_b208[658]] = this[_$_b208[658]][_$_b208[674]](function() {
                  return Ct[_$_b208[657]];
                })[_$_b208[674]](function() {
                  return Ct[_$_b208[1083]]();
                })[_$_b208[674]](function() {
                  return nt(It, Ct[_$_b208[827]]);
                })[_$_b208[674]](function() {
                  return lt(Ct[_$_b208[544]], qe, wt);
                })[_$_b208[674]](function() {
                  return Ct[_$_b208[1074]](Ct[_$_b208[544]][_$_b208[46]][_$_b208[494]]);
                })[_$_b208[674]](function() {
                  var Pt = Ct[_$_b208[1081]](qe, { forceTechnology: Ze, disableSeeking: ht }, _t);
                  return Promise[_$_b208[1082]]([Pt, It[_$_b208[449]]]);
                })[_$_b208[674]](It[_$_b208[85]])[_$_b208[943]](function(Pt) {
                  return Ct[_$_b208[1079]](It, Pt);
                }), It[_$_b208[449]];
              }, rt[_$_b208[21]][_$_b208[1080]] = function(qe, Ze, ht) {
                var _t, Ct = this;
                return (_t = this[_$_b208[160]]) === null || _t === void 0 || _t[_$_b208[1084]](), this[_$_b208[659]](ht)[_$_b208[674]](function() {
                  return Ct[_$_b208[1085]](qe), Ct[_$_b208[1086]](qe, Ze[_$_b208[1057]]), Ct[_$_b208[1087]](qe), Ct[_$_b208[1043]](qe), Ct[_$_b208[1056]](Ct[_$_b208[1034]](qe), Ze, ht);
                });
              }, rt[_$_b208[21]][_$_b208[1087]] = function(qe) {
                qe[_$_b208[20]](_$_b208[680]) && (0, Fe[_$_b208[191]])()[_$_b208[461]] && (0, Fe[_$_b208[191]])()[_$_b208[468]] && (qe[_$_b208[680]][_$_b208[1053]] = je[_$_b208[172]][_$_b208[1054]](), qe[_$_b208[680]][_$_b208[1052]] = !0), qe[_$_b208[20]](_$_b208[680]) && qe[_$_b208[680]][_$_b208[1053]] && this[_$_b208[545]][_$_b208[1055]](qe[_$_b208[680]][_$_b208[1053]][_$_b208[236]]());
              }, rt[_$_b208[21]][_$_b208[1088]] = function(qe) {
                if (_e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[760]]) && qe[_$_b208[1048]] && !this[_$_b208[46]][_$_b208[494]][_$_b208[196]](fe[_$_b208[490]][_$_b208[675]])) {
                  var Ze = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[760]])[_$_b208[675]];
                  this[_$_b208[46]][_$_b208[494]][_$_b208[361]](fe[_$_b208[490]][_$_b208[675]], new Ze(this[_$_b208[46]]));
                }
              }, rt[_$_b208[21]][_$_b208[1089]] = function() {
                var qe, Ze = this[_$_b208[46]][_$_b208[671]][_$_b208[510]];
                this[_$_b208[46]][_$_b208[494]][_$_b208[196]](fe[_$_b208[490]][_$_b208[1090]], Ze) && this[_$_b208[836]]() && this[_$_b208[544]][_$_b208[506]] !== null && this[_$_b208[544]][_$_b208[506]] !== void 0 && this[_$_b208[544]][_$_b208[506]][_$_b208[780]] !== Me[_$_b208[782]][_$_b208[784]] && ((qe = this[_$_b208[46]][_$_b208[494]][_$_b208[199]](fe[_$_b208[490]][_$_b208[1090]], Ze)) === null || qe === void 0 || qe[_$_b208[425]](), this[_$_b208[46]][_$_b208[494]][_$_b208[361]](fe[_$_b208[490]][_$_b208[1090]], void 0, Ze));
              }, rt[_$_b208[21]][_$_b208[1091]] = function(qe) {
                var Ze = this[_$_b208[46]][_$_b208[494]][_$_b208[199]](fe[_$_b208[490]][_$_b208[675]]);
                return qe && qe[_$_b208[1048]] && Ze ? Ze[_$_b208[1092]](qe[_$_b208[1048]]) : Promise[_$_b208[85]]();
              }, rt[_$_b208[21]][_$_b208[1081]] = function(qe, Ze, ht) {
                var _t = this, Ct = this[_$_b208[46]][_$_b208[671]][_$_b208[510]];
                return this[_$_b208[46]][_$_b208[494]][_$_b208[493]](fe[_$_b208[490]][_$_b208[826]], function(wt) {
                  return wt[_$_b208[552]]((0, tt[_$_b208[1093]])());
                }, null, Ct), this[_$_b208[1094]](ht, Ct), this[_$_b208[1095]](ht, Ct), this[_$_b208[1088]](qe), this[_$_b208[762]] && this[_$_b208[46]][_$_b208[494]][_$_b208[361]](fe[_$_b208[490]][_$_b208[1096]], this[_$_b208[762]]), this[_$_b208[1102]]()[_$_b208[674]](function() {
                  return _t[_$_b208[1091]](qe);
                })[_$_b208[674]](function() {
                  return _t[_$_b208[1069]](qe, Ze, ht);
                })[_$_b208[674]](function() {
                  return _t[_$_b208[1e3]](), _t[_$_b208[1100]](qe[_$_b208[1099]]), it(qe, _t[_$_b208[544]][_$_b208[46]][_$_b208[494]]), _t[_$_b208[1101]](qe, ht);
                })[_$_b208[674]](function() {
                  var wt, It, Pt;
                  _t[_$_b208[1089]](), (wt = (0, Ye[_$_b208[1097]])(_t[_$_b208[46]])) === null || wt === void 0 || wt[_$_b208[552]]((0, Je[_$_b208[1098]])((Pt = (It = _t[_$_b208[544]][_$_b208[587]]) === null || It === void 0 ? void 0 : It[_$_b208[274]]) !== null && Pt !== void 0 ? Pt : _$_b208[265])), _t[_$_b208[683]]($e[_$_b208[482]][_$_b208[687]]);
                });
              }, rt[_$_b208[21]][_$_b208[1102]] = function() {
                return this[_$_b208[544]][_$_b208[565]] ? this[_$_b208[544]][_$_b208[565]][_$_b208[1103]]() : Promise[_$_b208[84]](_$_b208[1072]);
              }, rt[_$_b208[21]][_$_b208[1095]] = function(qe, Ze) {
                !Tt(qe) && this[_$_b208[46]] && (this[_$_b208[46]][_$_b208[494]][_$_b208[493]](fe[_$_b208[490]][_$_b208[826]], function(ht) {
                  return ht[_$_b208[552]]((0, ze[_$_b208[1104]])());
                }, null, Ze), this[_$_b208[46]][_$_b208[494]][_$_b208[196]](fe[_$_b208[490]][_$_b208[1090]], Ze) || (this[_$_b208[46]][_$_b208[494]][_$_b208[361]](fe[_$_b208[490]][_$_b208[1090]], this[_$_b208[1105]], Ze), this[_$_b208[46]][_$_b208[494]][_$_b208[493]](fe[_$_b208[490]][_$_b208[1090]], function(ht) {
                  return ht[_$_b208[425]]();
                }, null, Ze)));
              }, rt[_$_b208[21]][_$_b208[1101]] = function(qe, Ze) {
                var ht, _t;
                return this[_$_b208[1106]](), Tt(Ze) ? (this[_$_b208[544]][_$_b208[46]][_$_b208[494]][_$_b208[199]](fe[_$_b208[490]][_$_b208[489]])[_$_b208[932]](!1, Ze), Promise[_$_b208[85]]()) : (this[_$_b208[714]] && this[_$_b208[714]][_$_b208[64]](), this[_$_b208[643]] = qe, this[_$_b208[36]] = (_t = (ht = this[_$_b208[544]][_$_b208[565]]) === null || ht === void 0 ? void 0 : ht[_$_b208[925]]()) !== null && _t !== void 0 ? _t : _$_b208[265], this[_$_b208[1107]]());
              }, rt[_$_b208[21]][_$_b208[1079]] = function(qe, Ze) {
                this[_$_b208[688]]($e[_$_b208[482]][_$_b208[1060]], this[_$_b208[710]]), qe[_$_b208[84]](Ze);
              }, rt[_$_b208[21]][_$_b208[662]] = function() {
                var qe = this;
                if (!this[_$_b208[733]]())
                  return Promise[_$_b208[85]]();
                var Ze = this[_$_b208[735]](), ht = Ze[_$_b208[734]]() || !!this[_$_b208[931]], _t = !this[_$_b208[667]] && ht;
                return Ze[_$_b208[64]]()[_$_b208[674]](function() {
                  qe[_$_b208[931]] = null, _t && qe[_$_b208[683]]($e[_$_b208[482]][_$_b208[689]]);
                });
              }, rt[_$_b208[21]][_$_b208[1085]] = function(qe) {
                this[_$_b208[770]]() && this[_$_b208[1110]](ue[_$_b208[369]][_$_b208[1108]], _$_b208[1109]);
                var Ze = this[_$_b208[1047]](qe), ht = Object[_$_b208[1111]](Me[_$_b208[782]])[_$_b208[165]](function(_t) {
                  return _t !== Me[_$_b208[782]][_$_b208[961]];
                });
                if (Ze && ht[_$_b208[610]](function(_t) {
                  return Ze[_$_b208[20]](_t);
                }) || this[_$_b208[1110]](ue[_$_b208[369]][_$_b208[954]], _$_b208[1112], { source: qe }), !this[_$_b208[684]])
                  throw this[_$_b208[685]];
              }, rt[_$_b208[21]][_$_b208[1086]] = function(qe, Ze) {
                var ht = (0, Fe[_$_b208[191]])()[_$_b208[474]];
                ht[_$_b208[18]] < 1 && this[_$_b208[1110]](ue[_$_b208[369]][_$_b208[1113]], _$_b208[1114]);
                var _t = mt(this[_$_b208[703]], qe, Ze);
                !_t && qe[_$_b208[20]](_$_b208[680]) && this[_$_b208[1110]](ue[_$_b208[369]][_$_b208[1115]], _$_b208[1116]), _t || this[_$_b208[1110]](ue[_$_b208[369]][_$_b208[1113]], _$_b208[1118][_$_b208[94]](JSON[_$_b208[1012]](ht), _$_b208[1117]));
              }, rt[_$_b208[21]][_$_b208[1110]] = function(qe, Ze, ht) {
                var _t = new be[_$_b208[720]](qe, ht, Ze);
                throw this[_$_b208[160]] && this[_$_b208[160]][_$_b208[690]](_t), _t;
              }, rt[_$_b208[21]][_$_b208[1100]] = function(qe) {
                var Ze = this;
                !this[_$_b208[1119]] && _e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[1120]]) && (this[_$_b208[1119]] = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1120]])[_$_b208[1121]][_$_b208[357]](this), this[_$_b208[683]]($e[_$_b208[482]][_$_b208[777]], { name: le[_$_b208[195]][_$_b208[1120]] })), qe && Array[_$_b208[1122]](qe) && qe[_$_b208[68]](function(ht) {
                  return Ze[_$_b208[1006]](ht);
                });
              }, rt[_$_b208[21]][_$_b208[1106]] = function() {
                var qe, Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[1106]]();
                Ze && (this[_$_b208[668]] = Ze);
              }, rt[_$_b208[21]][_$_b208[1001]] = function() {
                if (this[_$_b208[544]][_$_b208[507]] && this[_$_b208[544]][_$_b208[507]][_$_b208[20]](_$_b208[680]) && this[_$_b208[771]]())
                  if (_$_b208[161] == typeof window[_$_b208[1123]]) {
                    var qe = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1125]])[_$_b208[1124]];
                    this[_$_b208[544]][_$_b208[696]] = new qe(this[_$_b208[544]][_$_b208[46]], this[_$_b208[749]], this[_$_b208[544]][_$_b208[507]][_$_b208[680]], je[_$_b208[172]][_$_b208[1054]](), this[_$_b208[148]], navigator, this[_$_b208[544]][_$_b208[81]]), this[_$_b208[683]]($e[_$_b208[482]][_$_b208[777]], { name: le[_$_b208[195]][_$_b208[1125]] });
                  } else
                    this[_$_b208[148]][_$_b208[721]](_$_b208[1126], _$_b208[1127]);
              }, rt[_$_b208[21]][_$_b208[724]] = function(qe) {
                return qe === void 0 && (qe = !1), this[_$_b208[703]] ? qe ? this[_$_b208[703]][_$_b208[199]]() : this[_$_b208[703]][_$_b208[1128]]() : {};
              }, rt[_$_b208[21]][_$_b208[1129]] = function(qe, Ze) {
                var ht;
                if (this[_$_b208[678]]())
                  return (ht = this[_$_b208[544]][_$_b208[565]]) === null || ht === void 0 ? void 0 : ht[_$_b208[1129]](qe, Ze);
              }, rt[_$_b208[21]][_$_b208[492]] = function(qe) {
                var Ze;
                qe = Number(qe), !isNaN(qe) && qe > 0 && (this[_$_b208[544]][_$_b208[491]] = qe, this[_$_b208[772]]() && ((Ze = this[_$_b208[544]][_$_b208[565]]) === null || Ze === void 0 || Ze[_$_b208[492]](qe)));
              }, rt[_$_b208[21]][_$_b208[1130]] = function() {
                var qe, Ze;
                return this[_$_b208[772]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[1130]]()) !== null && Ze !== void 0 ? Ze : 1;
              }, rt[_$_b208[21]][_$_b208[1131]] = function() {
                var qe = this;
                return new Promise(function(Ze, ht) {
                  if (qe[_$_b208[814]] && qe[_$_b208[585]]() !== Me[_$_b208[563]][_$_b208[572]]) {
                    var _t = function() {
                      Ze(), qe[_$_b208[688]]($e[_$_b208[482]][_$_b208[567]], _t);
                    };
                    qe[_$_b208[404]]($e[_$_b208[482]][_$_b208[567]], _t), qe[_$_b208[814]][_$_b208[608]](Me[_$_b208[563]][_$_b208[572]]);
                  } else
                    Ze();
                });
              }, rt[_$_b208[21]][_$_b208[1132]] = function() {
                var qe, Ze = this;
                return this[_$_b208[768]]() ? Promise[_$_b208[85]]() : ((qe = this[_$_b208[46]]) === null || qe === void 0 || qe[_$_b208[553]][_$_b208[552]]((0, We[_$_b208[1135]])(Qe[_$_b208[1134]][_$_b208[1133]])), _e[_$_b208[197]][_$_b208[1142]](this[_$_b208[750]])[_$_b208[674]](function() {
                  return Ze[_$_b208[1131]]();
                })[_$_b208[674]](function() {
                  return Ze[_$_b208[1141]]();
                })[_$_b208[674]](function() {
                  var ht, _t;
                  (ht = Ze[_$_b208[46]]) === null || ht === void 0 || ht[_$_b208[553]][_$_b208[552]]((0, We[_$_b208[1135]])(Qe[_$_b208[1134]][_$_b208[1138]])), (_t = Ze[_$_b208[160]]) === null || _t === void 0 || _t[_$_b208[1139]](), Ze[_$_b208[1140]]();
                })[_$_b208[674]](function() {
                  return Ze[_$_b208[658]];
                })[_$_b208[674]](function() {
                  return Ze[_$_b208[659]]();
                })[_$_b208[674]](function() {
                  return Ze[_$_b208[1137]]();
                })[_$_b208[674]](function() {
                  Ze[_$_b208[46]] && (Ze[_$_b208[1136]](), Ze[_$_b208[46]][_$_b208[70]](), Ze[_$_b208[46]] = null);
                }));
              }, rt[_$_b208[21]][_$_b208[1136]] = function() {
                this[_$_b208[818]] && this[_$_b208[818]](), this[_$_b208[819]] && this[_$_b208[819]](), this[_$_b208[818]] = null, this[_$_b208[819]] = null;
              }, rt[_$_b208[21]][_$_b208[1141]] = function() {
                var qe = this;
                return new Promise(function(Ze) {
                  var ht = function() {
                    clearTimeout(_t), qe[_$_b208[688]]($e[_$_b208[482]][_$_b208[1143]], ht), Ze();
                  }, _t = setTimeout(ht, 250);
                  qe[_$_b208[404]]($e[_$_b208[482]][_$_b208[1143]], ht), qe[_$_b208[683]]($e[_$_b208[482]][_$_b208[1143]], {}, !1, !1);
                });
              }, rt[_$_b208[21]][_$_b208[1140]] = function() {
                this[_$_b208[1073]](te[_$_b208[632]]), clearTimeout(this[_$_b208[755]]);
              }, rt[_$_b208[21]][_$_b208[1137]] = function() {
                var qe = this;
                if (!this[_$_b208[544]])
                  return Promise[_$_b208[85]]();
                var Ze = Promise[_$_b208[85]]();
                return this[_$_b208[1038]](!0), je[_$_b208[172]][_$_b208[1144]](), this[_$_b208[544]][_$_b208[557]] = (0, ge[_$_b208[70]])(this[_$_b208[544]][_$_b208[557]]), this[_$_b208[544]][_$_b208[696]] = null, this[_$_b208[814]] && (this[_$_b208[814]] = (0, ge[_$_b208[70]])(this[_$_b208[814]])), this[_$_b208[798]] = (0, ge[_$_b208[70]])(this[_$_b208[798]]), this[_$_b208[799]] = (0, ge[_$_b208[70]])(this[_$_b208[799]]), this[_$_b208[800]] = (0, ge[_$_b208[70]])(this[_$_b208[800]]), this[_$_b208[1105]] = (0, ge[_$_b208[70]])(this[_$_b208[1105]]), this[_$_b208[714]][_$_b208[70]](), this[_$_b208[544]][_$_b208[565]] ? Ze = this[_$_b208[544]][_$_b208[565]][_$_b208[808]]()[_$_b208[674]](function() {
                  return qe[_$_b208[46]][_$_b208[494]][_$_b208[493]](fe[_$_b208[490]][_$_b208[675]], function(ht) {
                    return ht[_$_b208[808]]();
                  });
                })[_$_b208[831]](function() {
                  qe[_$_b208[1145]](), qe[_$_b208[544]][_$_b208[565]] = null;
                }) : this[_$_b208[1145]](), this[_$_b208[544]][_$_b208[46]] && $t(this[_$_b208[544]][_$_b208[46]]), this[_$_b208[762]] = (0, ge[_$_b208[70]])(this[_$_b208[762]]), this[_$_b208[669]] = (0, ge[_$_b208[70]])(this[_$_b208[669]]), this[_$_b208[160]] = (0, ge[_$_b208[70]])(this[_$_b208[160]]), this[_$_b208[753]] = null, Ze;
              }, rt[_$_b208[21]][_$_b208[1145]] = function() {
                if (this[_$_b208[544]][_$_b208[587]]) {
                  var qe = this[_$_b208[544]][_$_b208[587]][_$_b208[236]]();
                  this[_$_b208[544]][_$_b208[587]] = (0, ge[_$_b208[70]])(this[_$_b208[544]][_$_b208[587]]), this[_$_b208[545]] && qe !== this[_$_b208[765]] && this[_$_b208[545]][_$_b208[963]](qe);
                }
              }, rt[_$_b208[21]][_$_b208[686]] = function(qe) {
                if (!qe)
                  return new be[_$_b208[720]](ue[_$_b208[369]][_$_b208[1146]], { "error-message": _$_b208[1147] });
                if (qe[_$_b208[119]] && qe[_$_b208[119]][_$_b208[26]](_$_b208[1148]))
                  return new be[_$_b208[720]](ue[_$_b208[369]][_$_b208[1149]], { "error-message": qe[_$_b208[119]] });
                if (qe[_$_b208[20]](_$_b208[1150])) {
                  for (var Ze = _$_b208[265], ht = 0; ht < qe[_$_b208[1150]][_$_b208[18]]; ht++)
                    Ze += qe[_$_b208[1150]][ht][_$_b208[723]] + _$_b208[123], Ze += qe[_$_b208[1150]][ht][_$_b208[120]], ht < qe[_$_b208[1150]][_$_b208[18]] - 1 && (Ze += _$_b208[1151]);
                  return new be[_$_b208[720]](ue[_$_b208[369]][_$_b208[1146]], { "error-message": Ze });
                }
                return qe[_$_b208[20]](_$_b208[119]) ? new be[_$_b208[720]](ue[_$_b208[369]][_$_b208[1146]], { "error-message": qe[_$_b208[119]] }) : void 0;
              }, rt[_$_b208[21]][_$_b208[1152]] = function(qe) {
                this[_$_b208[544]] && this[_$_b208[544]][_$_b208[565]] && je[_$_b208[172]][_$_b208[171]](this[_$_b208[544]][_$_b208[565]][_$_b208[1152]]) && this[_$_b208[544]][_$_b208[565]][_$_b208[1152]](qe);
              }, rt[_$_b208[21]][_$_b208[889]] = function(qe, Ze, ht, _t) {
                this[_$_b208[683]]($e[_$_b208[482]][_$_b208[948]], new ve[_$_b208[951]](me[_$_b208[950]][_$_b208[1011]], Ze, { method: qe, parameter: ht, argument: _t }));
              }, rt[_$_b208[21]][_$_b208[683]] = function(qe, Ze, ht, _t) {
                this[_$_b208[160]] && this[_$_b208[160]][_$_b208[815]]()(qe, Ze, ht, _t);
              }, rt[_$_b208[21]][_$_b208[1153]] = function() {
                return this[_$_b208[933]]() || this[_$_b208[1154]]();
              }, rt[_$_b208[21]][_$_b208[933]] = function() {
                var qe;
                return this[_$_b208[678]]() && !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[1153]]());
              }, rt[_$_b208[21]][_$_b208[1154]] = function() {
                return this[_$_b208[733]]() && this[_$_b208[735]]()[_$_b208[1153]]();
              }, rt[_$_b208[21]][_$_b208[1155]] = function() {
                return this[_$_b208[1156]]() || this[_$_b208[1157]]();
              }, rt[_$_b208[21]][_$_b208[1156]] = function() {
                var qe;
                return this[_$_b208[678]]() && !!(!((qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0) && qe[_$_b208[1155]]());
              }, rt[_$_b208[21]][_$_b208[1157]] = function() {
                return this[_$_b208[733]]() && this[_$_b208[735]]()[_$_b208[1155]]();
              }, rt[_$_b208[21]][_$_b208[1158]] = function(qe) {
                this[_$_b208[765]] = qe;
              }, rt[_$_b208[21]][_$_b208[1159]] = function() {
                return this[_$_b208[765]] ? this[_$_b208[765]] : this[_$_b208[544]] && this[_$_b208[544]][_$_b208[587]] ? this[_$_b208[544]][_$_b208[587]][_$_b208[236]]() : null;
              }, rt[_$_b208[21]][_$_b208[1160]] = function(qe) {
                return this[_$_b208[762]] ? this[_$_b208[762]][_$_b208[1161]](qe) : Promise[_$_b208[84]](_$_b208[1162]);
              }, rt[_$_b208[21]][_$_b208[1163]] = function() {
                return this[_$_b208[762]] ? this[_$_b208[762]][_$_b208[1164]]() : Promise[_$_b208[84]](_$_b208[1162]);
              }, rt[_$_b208[21]][_$_b208[1165]] = function(qe) {
                this[_$_b208[972]][_$_b208[1166]](qe);
              }, rt[_$_b208[21]][_$_b208[1046]] = function(qe, Ze) {
                this[_$_b208[669]] ? this[_$_b208[669]][_$_b208[1046]](qe, Ze) : this[_$_b208[148]][_$_b208[154]](_$_b208[1167]);
              }, rt[_$_b208[21]][_$_b208[1168]] = function(qe) {
                var Ze;
                return this[_$_b208[772]]() ? et(qe, { width: this[_$_b208[1018]]()[_$_b208[1169]], height: this[_$_b208[1018]]()[_$_b208[1170]], isFullscreen: !!(!((Ze = this[_$_b208[814]]) === null || Ze === void 0) && Ze[_$_b208[574]]()) }, this[_$_b208[544]][_$_b208[46]][_$_b208[494]]) : null;
              }, rt[_$_b208[21]][_$_b208[837]] = function() {
                var qe, Ze, ht = { start: -1, end: -1 };
                return this[_$_b208[678]]() && (Ze = (qe = this[_$_b208[544]][_$_b208[565]]) === null || qe === void 0 ? void 0 : qe[_$_b208[837]]()) !== null && Ze !== void 0 ? Ze : ht;
              }, rt[_$_b208[21]][_$_b208[706]] = function(qe, Ze, ht) {
                var _t;
                Ze = [][_$_b208[94]](Ze);
                for (var Ct = function(Pt) {
                  if (_t = Ze[_$_b208[164]](function(kt) {
                    return kt[_$_b208[1009]] === Pt;
                  }))
                    return _$_b208[1171];
                }, wt = 0, It = qe = [][_$_b208[94]](qe); wt < It[_$_b208[18]] && _$_b208[1171] !== Ct(It[wt]); wt++)
                  ;
                return _t ? Promise[_$_b208[85]](ht(_t[_$_b208[749]])) : Promise[_$_b208[85]]();
              }, rt[_$_b208[21]][_$_b208[816]] = function() {
                var qe = this[_$_b208[544]][_$_b208[703]][_$_b208[1172]]();
                this[_$_b208[1173]](qe);
              }, rt[_$_b208[21]][_$_b208[1107]] = function() {
                return this[_$_b208[1174]]()[_$_b208[674]](this[_$_b208[707]])[_$_b208[674]](this[_$_b208[701]]);
              }, rt[_$_b208[21]][_$_b208[1175]] = function() {
                if (this[_$_b208[544]][_$_b208[703]][_$_b208[498]]()[_$_b208[1176]] && this[_$_b208[46]][_$_b208[587]] !== void 0) {
                  var qe = this[_$_b208[46]][_$_b208[587]][_$_b208[236]]();
                  qe[_$_b208[598]](_$_b208[1177], _$_b208[265]), qe[_$_b208[598]](_$_b208[1178], _$_b208[265]);
                }
              }, rt[_$_b208[21]][_$_b208[1179]] = function() {
                this[_$_b208[836]]() || this[_$_b208[862]](this[_$_b208[544]][_$_b208[507]], !1);
              }, rt[_$_b208[21]][_$_b208[1180]] = function() {
                var qe, Ze;
                (Ze = (qe = this[_$_b208[544]][_$_b208[696]]) === null || qe === void 0 ? void 0 : qe[_$_b208[1181]]()) !== null && Ze !== void 0 && Ze ? this[_$_b208[148]][_$_b208[154]](_$_b208[1182]) : this[_$_b208[1183]]();
              }, rt[_$_b208[21]][_$_b208[1184]] = function() {
                var qe = this[_$_b208[836]](), Ze = this[_$_b208[544]][_$_b208[703]][_$_b208[498]](), ht = this[_$_b208[544]][_$_b208[703]][_$_b208[1185]]();
                Ze[_$_b208[1186]] ? this[_$_b208[1180]]() : this[_$_b208[1187]](ht, qe) && this[_$_b208[861]]();
              }, rt[_$_b208[21]][_$_b208[1174]] = function() {
                var qe = this;
                return new Promise(function(Ze) {
                  clearTimeout(qe[_$_b208[755]]), qe[_$_b208[544]] && qe[_$_b208[544]][_$_b208[565]] ? (qe[_$_b208[1175]](), qe[_$_b208[1179]](), qe[_$_b208[1184]](), Ze()) : qe[_$_b208[755]] = window[_$_b208[140]](function() {
                    Ze(qe[_$_b208[1107]]());
                  }, 100);
                });
              }, rt[_$_b208[21]][_$_b208[1187]] = function(qe, Ze) {
                return !Ze && (_$_b208[1020] != typeof qe[_$_b208[861]] || qe[_$_b208[861]]);
              }, Object[_$_b208[13]](rt[_$_b208[21]], _$_b208[1188], { get: function() {
                return this[_$_b208[827]] && this[_$_b208[827]][_$_b208[449]] || Promise[_$_b208[85]]();
              }, enumerable: !1, configurable: !0 }), rt[_$_b208[21]][_$_b208[1183]] = function() {
                var qe = this;
                this[_$_b208[1188]][_$_b208[674]](function() {
                  return qe[_$_b208[167]]();
                })[_$_b208[943]](function() {
                  return qe[_$_b208[148]][_$_b208[156]](_$_b208[1189]);
                });
              }, rt[_$_b208[21]][_$_b208[862]] = function(qe, Ze) {
                var ht = this[_$_b208[544]][_$_b208[46]][_$_b208[494]][_$_b208[199]](fe[_$_b208[490]][_$_b208[1075]])[_$_b208[1190]](qe);
                Ze ? this[_$_b208[869]](ht, Ce[_$_b208[1191]]) : this[_$_b208[835]](ht, Ce[_$_b208[1191]]);
              }, rt[_$_b208[21]][_$_b208[1173]] = function(qe) {
                var Ze = this;
                Object[_$_b208[69]](qe)[_$_b208[68]](function(ht) {
                  Object[_$_b208[69]](qe[ht])[_$_b208[68]](function(_t) {
                    if (Ze[_$_b208[904]](_t, ht)) {
                      var Ct = qe[ht][_t];
                      Ze[_$_b208[898]](_t, Ct, ht);
                    }
                  });
                });
              }, rt[_$_b208[21]][_$_b208[1002]] = function() {
                this[_$_b208[544]] && (this[_$_b208[667]] = !0, this[_$_b208[868]](this[_$_b208[544]][_$_b208[478]]), this[_$_b208[492]](this[_$_b208[544]][_$_b208[491]]), this[_$_b208[544]][_$_b208[479]] ? this[_$_b208[863]]() : this[_$_b208[866]]());
              }, rt[_$_b208[21]][_$_b208[1083]] = function() {
                if (!this[_$_b208[733]]() && this[_$_b208[724]]()[_$_b208[1032]])
                  try {
                    this[_$_b208[773]]();
                  } catch (qe) {
                    this[_$_b208[148]][_$_b208[721]](qe);
                  }
              }, rt[_$_b208[21]][_$_b208[767]] = function() {
                var qe = this;
                this[_$_b208[684]] = !0, this[_$_b208[651]] && this[_$_b208[651]][_$_b208[18]] > 0 && (this[_$_b208[714]] = new Ie[_$_b208[1192]](this[_$_b208[148]], this[_$_b208[651]][0])), this[_$_b208[959]]($e[_$_b208[482]][_$_b208[1060]], this[_$_b208[710]]), this[_$_b208[959]]($e[_$_b208[482]][_$_b208[948]], function(Ze) {
                  return qe[_$_b208[148]][_$_b208[721]](Ze[_$_b208[119]]);
                }), this[_$_b208[959]]($e[_$_b208[482]][_$_b208[1193]], this[_$_b208[713]]), this[_$_b208[959]]($e[_$_b208[482]][_$_b208[687]], this[_$_b208[691]]), this[_$_b208[404]]($e[_$_b208[482]][_$_b208[689]], this[_$_b208[700]]), this[_$_b208[404]]($e[_$_b208[482]][_$_b208[1193]], this[_$_b208[744]]), this[_$_b208[876]] = Ae[_$_b208[1194]][_$_b208[230]](this), _e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[1195]]) && (this[_$_b208[1196]] = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1195]])[_$_b208[1197]][_$_b208[230]](this)), _e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[1198]]) && (this[_$_b208[1199]] = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1198]])[_$_b208[1200]][_$_b208[230]](this)), _e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[1201]]) && (this[_$_b208[798]] = new (_e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1201]]))[_$_b208[1202]](), this[_$_b208[799]] = new (_e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1201]]))[_$_b208[1203]](), this[_$_b208[800]] = new (_e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1201]]))[_$_b208[1204]](), this[_$_b208[1105]] = new (_e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1201]]))[_$_b208[1090]]()), this[_$_b208[663]]();
              }, rt[_$_b208[21]][_$_b208[663]] = function() {
                this[_$_b208[1205]] = /* @__PURE__ */ new Map(), this[_$_b208[1205]][_$_b208[361]](he[_$_b208[637]], 0), this[_$_b208[1205]][_$_b208[361]](he[_$_b208[639]], 0);
              }, rt[_$_b208[21]][_$_b208[829]] = function(qe, Ze) {
                this[_$_b208[1205]][_$_b208[196]](qe) && this[_$_b208[1205]][_$_b208[361]](qe, this[_$_b208[1205]][_$_b208[199]](qe) + Ze);
              }, rt[_$_b208[21]][_$_b208[926]] = function(qe, Ze, ht) {
                return this[_$_b208[1205]][_$_b208[199]](qe) + (Ze ? ht : 0);
              }, rt[_$_b208[21]][_$_b208[737]] = function(qe) {
                var Ze = qe[_$_b208[1206]](), ht = qe[_$_b208[1208]]()[_$_b208[165]](function(_t) {
                  return _t[_$_b208[1207]] === Ze[_$_b208[1207]];
                });
                [Ze][_$_b208[94]](ht)[_$_b208[68]](function(_t) {
                  return qe[_$_b208[1209]](_t[_$_b208[749]]);
                });
              }, rt[_$_b208[21]][_$_b208[1210]] = function(qe) {
              }, rt[_$_b208[21]][_$_b208[564]] = function() {
              }, rt[_$_b208[21]][_$_b208[566]] = function() {
              }, rt[_$_b208[21]][_$_b208[585]] = function() {
                return this[_$_b208[46]] ? (0, Xe[_$_b208[584]])(this[_$_b208[46]][_$_b208[553]][_$_b208[182]]())[_$_b208[560]] : Me[_$_b208[563]][_$_b208[572]];
              }, rt[_$_b208[21]][_$_b208[592]] = function(qe) {
                var Ze;
                return this[_$_b208[678]]() ? !!(!((Ze = this[_$_b208[814]]) === null || Ze === void 0) && Ze[_$_b208[592]](qe)) : [Me[_$_b208[563]][_$_b208[562]], Me[_$_b208[563]][_$_b208[572]]][_$_b208[26]](qe);
              }, rt[_$_b208[21]][_$_b208[608]] = function(qe, Ze) {
                Ze === void 0 && (Ze = {}), this[_$_b208[814]] && this[_$_b208[814]][_$_b208[608]](qe, Ze);
              }, rt[_$_b208[21]][_$_b208[1211]] = function(qe) {
                this[_$_b208[160]] && this[_$_b208[160]][_$_b208[1211]](qe);
              }, rt[_$_b208[21]][_$_b208[1212]] = function(qe) {
                this[_$_b208[160]] && this[_$_b208[160]][_$_b208[1212]](qe);
              }, rt[_$_b208[21]][_$_b208[679]] = function() {
                return this[_$_b208[643]];
              }, rt[_$_b208[21]][_$_b208[1213]] = function() {
                var qe;
                return this[_$_b208[678]]() && ((qe = this[_$_b208[544]]) === null || qe === void 0 ? void 0 : qe[_$_b208[1058]]) || null;
              }, rt[_$_b208[21]][_$_b208[939]] = function() {
                return this[_$_b208[746]] !== ce[_$_b208[634]];
              }, rt[_$_b208[21]][_$_b208[747]] = function(qe) {
                var Ze = this[_$_b208[849]]() ? ce[_$_b208[635]] : ce[_$_b208[636]];
                return Ze > qe ? Ze : qe;
              }, rt[_$_b208[21]][_$_b208[1094]] = function(qe, Ze) {
                if (this[_$_b208[46]] && _e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[1198]]))
                  for (var ht = _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1198]])[_$_b208[1214]], _t = Tt(qe) ? 0 : ht[_$_b208[1215]](this[_$_b208[46]]), Ct = this[_$_b208[46]][_$_b208[494]][_$_b208[199]](fe[_$_b208[490]][_$_b208[826]], Ze), wt = 0, It = Object[_$_b208[1111]](pt[_$_b208[1216]]); wt < It[_$_b208[18]]; wt++) {
                    var Pt = It[wt];
                    Ct[_$_b208[552]]((0, He[_$_b208[1217]])(Pt, _t));
                  }
              }, ie([(0, Pe[_$_b208[1219]])(_$_b208[1218])], rt[_$_b208[21]], _$_b208[244], null), ie([(0, Pe[_$_b208[1219]])(_$_b208[1220])], rt[_$_b208[21]], _$_b208[1132], null), rt;
            }();
            function ft(rt, qe) {
              var Ze = new ot[_$_b208[1222]](rt[_$_b208[553]], _$_b208[1221], qe);
              rt[_$_b208[494]][_$_b208[361]](fe[_$_b208[490]][_$_b208[826]], Ze, qe), Object[_$_b208[69]](Ge[_$_b208[621]])[_$_b208[68]](function(ht) {
                Ze[_$_b208[1223]](ht, Ge[_$_b208[621]][ht]);
              });
            }
            function lt(rt, qe, Ze) {
              var ht, _t = je[_$_b208[172]][_$_b208[1224]](qe) + rt[_$_b208[46]][_$_b208[1225]], Ct = new Re[_$_b208[505]]({ source: qe, isAd: Ze, technology: rt[_$_b208[506]], sourceIdentifier: _t, mseObjectUrl: (ht = rt[_$_b208[587]]) === null || ht === void 0 ? void 0 : ht[_$_b208[274]] }), wt = rt[_$_b208[46]];
              wt[_$_b208[1226]](Ct), wt[_$_b208[494]][_$_b208[196]](fe[_$_b208[490]][_$_b208[826]], _t) || ft(wt, _t);
            }
            function nt(rt, qe) {
              return rt === qe ? Promise[_$_b208[85]]() : Promise[_$_b208[84]](new Error(te[_$_b208[633]]));
            }
            function ct(rt) {
              if (_e[_$_b208[197]][_$_b208[196]](le[_$_b208[195]][_$_b208[1227]]))
                return _e[_$_b208[197]][_$_b208[199]](le[_$_b208[195]][_$_b208[1227]])[_$_b208[1228]](rt);
            }
            function it(rt, qe) {
              qe[_$_b208[493]](fe[_$_b208[490]][_$_b208[1078]], function(Ze) {
                rt && rt[_$_b208[1229]] && Ze[_$_b208[1230]](rt[_$_b208[1229]][_$_b208[403]]);
              });
            }
            function et(rt, qe, Ze) {
              return Ze[_$_b208[493]](fe[_$_b208[490]][_$_b208[1078]], function(ht) {
                return ht[_$_b208[1168]](rt, qe);
              });
            }
            function st(rt) {
              return rt && _$_b208[617] == typeof rt && (_$_b208[348] == typeof rt[_$_b208[749]] || (0, Ke[_$_b208[1231]])(rt[_$_b208[749]])) && _$_b208[348] == typeof rt[_$_b208[1009]] && [_$_b208[1232], _$_b208[1233], _$_b208[1016], _$_b208[1007]][_$_b208[26]](rt[_$_b208[220]]);
            }
            function mt(rt, qe, Ze) {
              var ht = je[_$_b208[172]][_$_b208[1234]](Ze);
              return (0, gt[_$_b208[1236]])(rt[_$_b208[498]]()[_$_b208[1235]], qe, ht);
            }
            function St(rt) {
              return rt != null && _$_b208[833] in rt;
            }
            function $t(rt) {
              [fe[_$_b208[490]][_$_b208[1076]], fe[_$_b208[490]][_$_b208[1075]], fe[_$_b208[490]][_$_b208[489]], fe[_$_b208[490]][_$_b208[1077]], fe[_$_b208[490]][_$_b208[1078]]][_$_b208[68]](function(qe) {
                return (0, pe[_$_b208[1237]])(rt[_$_b208[494]], qe);
              });
            }
            function Tt(rt) {
              return rt === Ce[_$_b208[1064]] || rt === Ce[_$_b208[1238]];
            }
            te[_$_b208[631]] = dt;
          }, 15539: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1239]] = te[_$_b208[1240]] = te[_$_b208[1238]] = te[_$_b208[1064]] = te[_$_b208[1191]] = void 0, te[_$_b208[1191]] = _$_b208[1002], te[_$_b208[1064]] = _$_b208[1241], te[_$_b208[1238]] = _$_b208[1242], te[_$_b208[1240]] = _$_b208[1243], te[_$_b208[1239]] = _$_b208[1244];
          }, 16368: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[195]] = void 0, function(ne) {
              ne[_$_b208[1125]] = _$_b208[1125], ne[_$_b208[986]] = _$_b208[986], ne[_$_b208[788]] = _$_b208[788], ne[_$_b208[775]] = _$_b208[775], ne[_$_b208[774]] = _$_b208[774], ne[_$_b208[1245]] = _$_b208[774], ne[_$_b208[1246]] = _$_b208[774], ne[_$_b208[1247]] = _$_b208[1247], ne[_$_b208[1248]] = _$_b208[1248], ne[_$_b208[1249]] = _$_b208[1249], ne[_$_b208[1250]] = _$_b208[1250], ne[_$_b208[1251]] = _$_b208[1252], ne[_$_b208[1253]] = _$_b208[1253], ne[_$_b208[1201]] = _$_b208[1201], ne[_$_b208[1198]] = _$_b208[1198], ne[_$_b208[1254]] = _$_b208[1254], ne[_$_b208[1255]] = _$_b208[1255], ne[_$_b208[760]] = _$_b208[760], ne[_$_b208[1256]] = _$_b208[1256], ne[_$_b208[1257]] = _$_b208[1257], ne[_$_b208[1258]] = _$_b208[1258], ne[_$_b208[1259]] = _$_b208[1259], ne[_$_b208[1120]] = _$_b208[1120], ne[_$_b208[1260]] = _$_b208[1260], ne[_$_b208[1261]] = _$_b208[1261], ne[_$_b208[1262]] = _$_b208[1262], ne[_$_b208[1263]] = _$_b208[1263], ne[_$_b208[997]] = _$_b208[997], ne[_$_b208[1227]] = _$_b208[1227], ne[_$_b208[1264]] = _$_b208[1227], ne[_$_b208[1265]] = _$_b208[1265], ne[_$_b208[194]] = _$_b208[194], ne[_$_b208[201]] = _$_b208[1266], ne[_$_b208[204]] = _$_b208[1267], ne[_$_b208[1195]] = _$_b208[1195], ne[_$_b208[1268]] = _$_b208[1268], ne[_$_b208[1269]] = _$_b208[1269], ne[_$_b208[207]] = _$_b208[207], ne[_$_b208[210]] = _$_b208[210], ne[_$_b208[1270]] = _$_b208[1270], ne[_$_b208[1271]] = _$_b208[1271];
            }(ee || (te[_$_b208[195]] = ee = {}));
          }, 16937: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[985]] = ie, te[_$_b208[1219]] = ae, te[_$_b208[1272]] = be, te[_$_b208[1273]] = me;
            var ne = {};
            function ie(pe) {
              ee = pe;
            }
            function ae(pe, fe) {
              return fe === void 0 && (fe = !1), function(ge, ye, $e) {
                var Se = $e[_$_b208[888]];
                return $e[_$_b208[888]] = function() {
                  var Ce = _e(ne), Ie = Ce[_$_b208[1274]], Te = Ce[_$_b208[1275]], Ee = Date[_$_b208[180]](), we = he(), Pe = le(Te, pe), Me = function() {
                    var Oe = he() - we;
                    if (ce({ name: pe, start: Ee, duration: Oe, callStack: Ie }), fe && (Te[_$_b208[1276]] = Te[_$_b208[1276]] || [], Te[_$_b208[1276]][_$_b208[141]]({ name: pe, duration: Oe })), Pe[_$_b208[1276]] && Pe[_$_b208[1276]][_$_b208[18]]) {
                      var Be = Pe[_$_b208[1276]][_$_b208[124]](function(Ue) {
                        return Ue[_$_b208[176]];
                      })[_$_b208[122]](_$_b208[121]), Ve = Pe[_$_b208[1276]][_$_b208[1277]](function(Ue, Re) {
                        return Ue + Re[_$_b208[61]];
                      }, 0);
                      ce({ name: _$_b208[265][_$_b208[94]](pe, _$_b208[1278])[_$_b208[94]](Be), duration: Oe - Ve, start: Date[_$_b208[180]]() });
                    }
                    oe(Te);
                  }, Ae = Se[_$_b208[22]](this, arguments);
                  return Ae instanceof Promise ? (se(Te[_$_b208[1279]], !0), Ae[_$_b208[674]](Me, Me), Ae) : (Me(), Ae);
                }, $e;
              };
            }
            function ce(pe) {
              ee && ee[_$_b208[154]](_$_b208[1282][_$_b208[94]](pe[_$_b208[176]], _$_b208[1281])[_$_b208[94]](Math[_$_b208[1280]](pe[_$_b208[61]]), _$_b208[537]), pe);
            }
            function he() {
              var pe, fe;
              return ((pe = performance[_$_b208[180]]) === null || pe === void 0 ? void 0 : pe[_$_b208[19]](performance)) || ((fe = performance[_$_b208[1283]]) === null || fe === void 0 ? void 0 : fe[_$_b208[19]](performance)) || Date[_$_b208[180]]();
            }
            function _e(pe, fe) {
              fe === void 0 && (fe = []);
              var ge = pe[_$_b208[1279]], ye = pe[_$_b208[411]];
              return ye && fe[_$_b208[141]](ye), ge ? _e(ge, fe) : { callStack: fe, parent: pe };
            }
            function le(pe, fe) {
              var ge = { method: fe, isAsync: !1, next: null, subtractions: [] };
              return pe[_$_b208[1279]] = ge, ge;
            }
            function se(pe, fe) {
              pe[_$_b208[1284]] = fe;
            }
            function oe(pe) {
              pe[_$_b208[1284]] && pe[_$_b208[1279]][_$_b208[1284]] || (pe[_$_b208[1279]] = null);
            }
            var ue = {};
            function be(pe) {
              var fe = he();
              ue[pe] && ve(pe, fe), ue[pe] = fe;
            }
            function ve(pe, fe) {
              ee && ce({ name: pe, start: ue[pe], duration: fe - ue[pe] });
            }
            function me(pe) {
              ve(pe, he()), delete ue[pe];
            }
          }, 17990: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1285]] = void 0, te[_$_b208[570]] = he, te[_$_b208[1286]] = _e, te[_$_b208[1287]] = le, te[_$_b208[1288]] = se, te[_$_b208[1289]] = oe, te[_$_b208[1290]] = ue, te[_$_b208[1291]] = be, te[_$_b208[1292]] = ve, te[_$_b208[1293]] = me, te[_$_b208[1135]] = pe, te[_$_b208[1294]] = fe, te[_$_b208[1295]] = ge, te[_$_b208[1296]] = ye, te[_$_b208[1297]] = $e, te[_$_b208[1298]] = Se, te[_$_b208[1299]] = Ce, te[_$_b208[1300]] = Ie, te[_$_b208[1301]] = Te;
            var ne = ee(33696), ie = ee(15231), ae = ee(76420), ce = function() {
              return { playbackState: ae[_$_b208[1303]][_$_b208[1302]], seekState: ae[_$_b208[1304]][_$_b208[1302]], timeShiftState: ae[_$_b208[1305]][_$_b208[1302]], hasBeenPlaying: !1, isStalled: !1, isRendererStalled: !1, targetPlaybackTime: -1, playbackSpeed: { speed: 1, multiplier: 1 }, pendingTransitions: [], viewMode: ne[_$_b208[563]][_$_b208[572]], destroyState: ae[_$_b208[1134]][_$_b208[1302]], remoteControlState: { connectionState: ae[_$_b208[732]][_$_b208[731]], remoteControlType: ae[_$_b208[936]][_$_b208[1302]] }, seekingProcess: { targetTime: -1, seekableRange: { start: -1, end: -1 }, isInitial: !1, issuer: _$_b208[265] } };
            };
            function he(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1306]], Ee);
            }
            function _e(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1308]], Ee);
            }
            function le(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1309]], Ee);
            }
            function se(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1310]], Ee);
            }
            function oe(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1311]], Ee);
            }
            function ue(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1312]], Ee);
            }
            function be(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1313]], Ee);
            }
            function ve(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1314]], Ee);
            }
            function me(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1315]], Ee);
            }
            function pe(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1316]], Ee);
            }
            function fe(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1317]], Ee);
            }
            function ge(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1318]], Ee);
            }
            function ye(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1319]], Ee);
            }
            function $e() {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1320]]);
            }
            function Se(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1321]], Ee);
            }
            function Ce(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1322]], Ee);
            }
            function Ie(Ee) {
              return Ee === void 0 && (Ee = []), (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1323]], { keepState: Ee });
            }
            function Te(Ee) {
              return (0, ie[_$_b208[626]])(ae[_$_b208[1307]][_$_b208[1324]], Ee);
            }
            te[_$_b208[1285]] = ce;
          }, 18068: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1325]] = void 0, function(ne) {
              ne[_$_b208[1326]] = _$_b208[1327], ne[_$_b208[1328]] = _$_b208[1329];
            }(ee || (te[_$_b208[1325]] = ee = {}));
          }, 18434: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1330]] = void 0, function(ne) {
              ne[_$_b208[1331]] = _$_b208[1332], ne[_$_b208[1333]] = _$_b208[1334], ne[_$_b208[1335]] = _$_b208[1336], ne[_$_b208[1337]] = _$_b208[1338], ne[_$_b208[1339]] = _$_b208[1340], ne[_$_b208[1341]] = _$_b208[1342], ne[_$_b208[1343]] = _$_b208[1344], ne[_$_b208[1345]] = _$_b208[1346];
            }(ee || (te[_$_b208[1330]] = ee = {}));
          }, 18561: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1347]] = void 0;
            var ee = function() {
              function ne() {
              }
              return ne[_$_b208[1020]] = function(ie, ae) {
                return ie === ae ? 0 : ie ? 1 : -1;
              }, ne[_$_b208[1348]] = function(ie, ae) {
                return ne[_$_b208[1020]](ae, ie);
              }, ne;
            }();
            te[_$_b208[1347]] = ee;
          }, 18665: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[490]] = void 0, function(ne) {
              ne[_$_b208[1349]] = _$_b208[1349], ne[_$_b208[1096]] = _$_b208[1096], ne[_$_b208[675]] = _$_b208[675], ne[_$_b208[1350]] = _$_b208[1350], ne[_$_b208[1351]] = _$_b208[1351], ne[_$_b208[1090]] = _$_b208[1090], ne[_$_b208[1352]] = _$_b208[1352], ne[_$_b208[1353]] = _$_b208[1353], ne[_$_b208[1354]] = _$_b208[1354], ne[_$_b208[1076]] = _$_b208[1076], ne[_$_b208[489]] = _$_b208[489], ne[_$_b208[1355]] = _$_b208[1355], ne[_$_b208[826]] = _$_b208[826], ne[_$_b208[1077]] = _$_b208[1077], ne[_$_b208[1075]] = _$_b208[1075], ne[_$_b208[1356]] = _$_b208[1356], ne[_$_b208[1357]] = _$_b208[1357], ne[_$_b208[1358]] = _$_b208[1358], ne[_$_b208[1078]] = _$_b208[1078], ne[_$_b208[1359]] = _$_b208[1359];
            }(ee || (te[_$_b208[490]] = ee = {}));
          }, 21607: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1077]] = void 0;
            var ne = ee(76650), ie = ee(28819), ae = ee(8272), ce = ee(27177), he = ee(331), _e = function() {
              function le(se) {
                this[_$_b208[46]] = se, this[_$_b208[46]] = se, this[_$_b208[640]] = 0;
              }
              return le[_$_b208[21]][_$_b208[1360]] = function() {
                this[_$_b208[1361]] = Date[_$_b208[180]]();
              }, le[_$_b208[21]][_$_b208[1362]] = function() {
                var se = (0, he[_$_b208[14]])(Date[_$_b208[180]]() - this[_$_b208[1361]]);
                this[_$_b208[640]] += se, this[_$_b208[1363]]();
              }, le[_$_b208[21]][_$_b208[1363]] = function() {
                var se = this;
                if ((0, ce[_$_b208[502]])(this[_$_b208[46]])) {
                  var oe = (0, ie[_$_b208[1364]])(this[_$_b208[46]][_$_b208[553]][_$_b208[182]]());
                  Object[_$_b208[69]](oe)[_$_b208[68]](function(ue) {
                    return se[_$_b208[46]][_$_b208[553]][_$_b208[552]]((0, ne[_$_b208[1365]])(ue, ae[_$_b208[304]][_$_b208[327]], se[_$_b208[640]]));
                  });
                }
              }, le[_$_b208[21]][_$_b208[64]] = function() {
                this[_$_b208[640]] = 0;
              }, le[_$_b208[21]][_$_b208[70]] = function() {
              }, le;
            }();
            te[_$_b208[1077]] = _e;
          }, 21829: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1366]] = void 0, function(ie) {
              ie[_$_b208[1367]] = _$_b208[302];
            }(ee || (te[_$_b208[1366]] = ee = {}));
            var ne = function(ie, ae) {
              return function(ce, he) {
                return ce === void 0 && (ce = ie), ae[he[_$_b208[89]]] ? ae[he[_$_b208[89]]](ce, he) : ae[ee[_$_b208[1367]]] ? ae[ee[_$_b208[1367]]](ce, he) : ce;
              };
            };
            te[_$_b208[302]] = ne;
          }, 23234: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[378]] = void 0;
            var ne = ee(331), ie = function() {
              function ae() {
              }
              return ae[_$_b208[377]] = function() {
                return window[_$_b208[521]] && _$_b208[161] == typeof window[_$_b208[521]][_$_b208[180]] ? (0, ne[_$_b208[14]])(window[_$_b208[521]][_$_b208[180]]()) : (0, ne[_$_b208[14]])(Date[_$_b208[180]]());
              }, ae;
            }();
            te[_$_b208[378]] = ie;
          }, 23974: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[406]] = void 0, function(ne) {
              ne[_$_b208[408]] = _$_b208[1368], ne[_$_b208[1369]] = _$_b208[421], ne[_$_b208[1060]] = _$_b208[90], ne[_$_b208[1370]] = _$_b208[244], ne[_$_b208[1371]] = _$_b208[1372], ne[_$_b208[1373]] = _$_b208[1374], ne[_$_b208[405]] = _$_b208[380], ne[_$_b208[1375]] = _$_b208[400];
            }(ee || (te[_$_b208[406]] = ee = {}));
          }, 25226: function(re, te) {
            _$_b208[11];
            var ee, ne, ie, ae;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1376]] = te[_$_b208[1377]] = te[_$_b208[1378]] = te[_$_b208[1379]] = void 0, function(ce) {
              ce[_$_b208[1380]] = _$_b208[57], ce[_$_b208[1381]] = _$_b208[58], ce[_$_b208[1382]] = _$_b208[1383];
            }(ee || (te[_$_b208[1379]] = ee = {})), function(ce) {
              ce[_$_b208[1384]] = _$_b208[1385], ce[_$_b208[1386]] = _$_b208[1387], ce[_$_b208[1388]] = _$_b208[1389], ce[_$_b208[1390]] = _$_b208[1391], ce[_$_b208[1392]] = _$_b208[1393];
            }(ne || (te[_$_b208[1378]] = ne = {})), function(ce) {
              ce[_$_b208[1394]] = _$_b208[1395], ce[_$_b208[1396]] = _$_b208[1397];
            }(ie || (te[_$_b208[1377]] = ie = {})), function(ce) {
              ce[_$_b208[1398]] = _$_b208[1399], ce[_$_b208[1400]] = _$_b208[1401], ce[_$_b208[1402]] = _$_b208[1403];
            }(ae || (te[_$_b208[1376]] = ae = {}));
          }, 25550: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[369]] = void 0, function(ne) {
              ne[ne[_$_b208[1404]] = 1e3] = _$_b208[1404], ne[ne[_$_b208[1108]] = 1001] = _$_b208[1108], ne[ne[_$_b208[1405]] = 1100] = _$_b208[1405], ne[ne[_$_b208[1406]] = 1101] = _$_b208[1406], ne[ne[_$_b208[1407]] = 1102] = _$_b208[1407], ne[ne[_$_b208[1146]] = 1103] = _$_b208[1146], ne[ne[_$_b208[1408]] = 1104] = _$_b208[1408], ne[ne[_$_b208[1004]] = 1104] = _$_b208[1004], ne[ne[_$_b208[1409]] = 1105] = _$_b208[1409], ne[ne[_$_b208[1149]] = 1105] = _$_b208[1149], ne[ne[_$_b208[971]] = 1106] = _$_b208[971], ne[ne[_$_b208[719]] = 1107] = _$_b208[719], ne[ne[_$_b208[1410]] = 1108] = _$_b208[1410], ne[ne[_$_b208[1411]] = 1113] = _$_b208[1411], ne[ne[_$_b208[1412]] = 1200] = _$_b208[1412], ne[ne[_$_b208[954]] = 1201] = _$_b208[954], ne[ne[_$_b208[1413]] = 1202] = _$_b208[1413], ne[ne[_$_b208[1113]] = 1203] = _$_b208[1113], ne[ne[_$_b208[371]] = 1204] = _$_b208[371], ne[ne[_$_b208[1414]] = 1205] = _$_b208[1414], ne[ne[_$_b208[1415]] = 1206] = _$_b208[1415], ne[ne[_$_b208[1416]] = 1207] = _$_b208[1416], ne[ne[_$_b208[1417]] = 1208] = _$_b208[1417], ne[ne[_$_b208[1418]] = 1209] = _$_b208[1418], ne[ne[_$_b208[1419]] = 1210] = _$_b208[1419], ne[ne[_$_b208[1420]] = 1211] = _$_b208[1420], ne[ne[_$_b208[1421]] = 7043] = _$_b208[1421], ne[ne[_$_b208[1422]] = 1300] = _$_b208[1422], ne[ne[_$_b208[368]] = 1301] = _$_b208[368], ne[ne[_$_b208[1423]] = 1304] = _$_b208[1423], ne[ne[_$_b208[370]] = 1400] = _$_b208[370], ne[ne[_$_b208[1424]] = 1401] = _$_b208[1424], ne[ne[_$_b208[1425]] = 1402] = _$_b208[1425], ne[ne[_$_b208[1426]] = 1403] = _$_b208[1426], ne[ne[_$_b208[1427]] = 1404] = _$_b208[1427], ne[ne[_$_b208[1428]] = 2e3] = _$_b208[1428], ne[ne[_$_b208[1429]] = 2001] = _$_b208[1429], ne[ne[_$_b208[1430]] = 2002] = _$_b208[1430], ne[ne[_$_b208[1431]] = 2003] = _$_b208[1431], ne[ne[_$_b208[1432]] = 2005] = _$_b208[1432], ne[ne[_$_b208[1433]] = 2006] = _$_b208[1433], ne[ne[_$_b208[1434]] = 2007] = _$_b208[1434], ne[ne[_$_b208[1435]] = 2008] = _$_b208[1435], ne[ne[_$_b208[1436]] = 2009] = _$_b208[1436], ne[ne[_$_b208[1437]] = 2010] = _$_b208[1437], ne[ne[_$_b208[1438]] = 2011] = _$_b208[1438], ne[ne[_$_b208[1439]] = 2012] = _$_b208[1439], ne[ne[_$_b208[1440]] = 2013] = _$_b208[1440], ne[ne[_$_b208[1441]] = 2015] = _$_b208[1441], ne[ne[_$_b208[1442]] = 2100] = _$_b208[1442], ne[ne[_$_b208[1115]] = 2101] = _$_b208[1115], ne[ne[_$_b208[1443]] = 3e3] = _$_b208[1443], ne[ne[_$_b208[1444]] = 3001] = _$_b208[1444], ne[ne[_$_b208[1445]] = 3002] = _$_b208[1445], ne[ne[_$_b208[1446]] = 3003] = _$_b208[1446], ne[ne[_$_b208[1447]] = 3004] = _$_b208[1447], ne[ne[_$_b208[1448]] = 3005] = _$_b208[1448], ne[ne[_$_b208[1449]] = 3100] = _$_b208[1449], ne[ne[_$_b208[1450]] = 4e3] = _$_b208[1450];
            }(ee || (te[_$_b208[369]] = ee = {}));
          }, 25614: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1451]] = te[_$_b208[1452]] = void 0;
            var ne = ee(15231), ie = ee(5772), ae = function(he) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[285]][_$_b208[289]], he);
            };
            te[_$_b208[1452]] = ae;
            var ce = function(he) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[285]][_$_b208[291]], he);
            };
            te[_$_b208[1451]] = ce;
          }, 26190: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1453]] = te[_$_b208[1454]] = te[_$_b208[1455]] = te[_$_b208[1456]] = te[_$_b208[1457]] = void 0;
            var ne, ie = ee(54838);
            (function(_e) {
              _e[_$_b208[1458]] = _$_b208[1459], _e[_$_b208[1460]] = _$_b208[1049], _e[_$_b208[1120]] = _$_b208[1007];
            })(ne || (te[_$_b208[1457]] = ne = {})), te[_$_b208[1456]] = _$_b208[265];
            var ae = function(_e, le, se) {
              if (!se)
                return te[_$_b208[1456]];
              var oe = (0, ie[_$_b208[1461]])(function() {
                return se(_e);
              }, le[_$_b208[148]]);
              return _$_b208[348] == typeof oe ? oe : te[_$_b208[1456]];
            };
            te[_$_b208[1455]] = ae;
            var ce = function(_e, le, se) {
              var oe, ue;
              return (ue = (oe = _e[_$_b208[1050]]) === null || oe === void 0 ? void 0 : oe[le]) === null || ue === void 0 ? void 0 : ue[se];
            };
            te[_$_b208[1454]] = ce;
            var he = function(_e, le) {
              var se = (0, te[_$_b208[1454]])(_e[_$_b208[507]], _e[_$_b208[1462]], _e[_$_b208[1463]]);
              return (0, te[_$_b208[1455]])(le, _e[_$_b208[46]], se);
            };
            te[_$_b208[1453]] = he;
          }, 26569: function(re, te, ee) {
            _$_b208[11];
            var ne, ie = this && this[_$_b208[16]] || function() {
              return ie = Object[_$_b208[17]] || function(le) {
                for (var se, oe = 1, ue = arguments[_$_b208[18]]; oe < ue; oe++)
                  for (var be in se = arguments[oe])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](se, be) && (le[be] = se[be]);
                return le;
              }, ie[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[625]] = void 0;
            var ae = ee(21829), ce = ee(5772);
            function he(le, se) {
              return ie(ie({}, le), se);
            }
            function _e(le, se) {
              return ie({}, se);
            }
            te[_$_b208[625]] = (0, ae[_$_b208[302]])({ kind: ce[_$_b208[222]][_$_b208[286]] }, ((ne = {})[ce[_$_b208[285]][_$_b208[289]]] = function(le, se) {
              return _e(le, se[_$_b208[1464]]);
            }, ne[ce[_$_b208[285]][_$_b208[291]]] = function(le, se) {
              return he(le, se[_$_b208[1464]]);
            }, ne));
          }, 26905: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1465]] = ce;
            var ne = ee(11399), ie = ee(13533), ae = ee(56435);
            function ce() {
              var he = (0, ie[_$_b208[191]])();
              return he[_$_b208[200]] ? he[ne[_$_b208[190]][_$_b208[472]]] === ae[_$_b208[1466]] : he[_$_b208[457]];
            }
          }, 27043: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1467]] = void 0;
            var ne = ee(46462), ie = function() {
              function ae(ce) {
                var he = ce[_$_b208[160]], _e = ce[_$_b208[1468]], le = this;
                this[_$_b208[1469]] = function() {
                  le[_$_b208[1470]] = le[_$_b208[1468]](), le[_$_b208[160]][_$_b208[100]](ne[_$_b208[103]][_$_b208[170]], le[_$_b208[64]]), le[_$_b208[160]][_$_b208[100]](ne[_$_b208[103]][_$_b208[168]], le[_$_b208[64]]);
                }, this[_$_b208[64]] = function() {
                  le[_$_b208[160]][_$_b208[105]](ne[_$_b208[103]][_$_b208[170]], le[_$_b208[64]]), le[_$_b208[160]][_$_b208[105]](ne[_$_b208[103]][_$_b208[168]], le[_$_b208[64]]), le[_$_b208[1471]]();
                }, this[_$_b208[160]] = he, this[_$_b208[1468]] = _e, this[_$_b208[160]][_$_b208[100]](ne[_$_b208[103]][_$_b208[1472]], this[_$_b208[1469]]);
              }
              return ae[_$_b208[21]][_$_b208[1471]] = function() {
                this[_$_b208[1470]] = void 0;
              }, ae[_$_b208[21]][_$_b208[199]] = function() {
                return this[_$_b208[1470]] !== void 0 ? this[_$_b208[1470]] : this[_$_b208[1468]]();
              }, ae[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[160]][_$_b208[105]](ne[_$_b208[103]][_$_b208[1472]], this[_$_b208[1469]]), this[_$_b208[160]][_$_b208[105]](ne[_$_b208[103]][_$_b208[170]], this[_$_b208[64]]), this[_$_b208[160]][_$_b208[105]](ne[_$_b208[103]][_$_b208[168]], this[_$_b208[64]]), this[_$_b208[1471]]();
              }, ae;
            }();
            te[_$_b208[1467]] = ie;
          }, 27177: function(re, te) {
            _$_b208[11];
            function ee(ie) {
              return ie !== null && _$_b208[617] == typeof ie;
            }
            function ne(ie) {
              return ie !== void 0 && !ie[_$_b208[512]];
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1473]] = ee, te[_$_b208[502]] = ne;
          }, 27256: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1076]] = void 0;
            var ne = ee(62510), ie = ee(44779), ae = ee(331), ce = function() {
              function he(_e) {
                this[_$_b208[1474]] = 1.3, this[_$_b208[160]] = _e[_$_b208[160]], this[_$_b208[160]][_$_b208[404]](ne[_$_b208[482]][_$_b208[689]], this[_$_b208[767]]), this[_$_b208[767]]();
              }
              return he[_$_b208[21]][_$_b208[767]] = function() {
                this[_$_b208[1475]] = {}, this[_$_b208[1476]] = 1 / 0;
              }, he[_$_b208[21]][_$_b208[845]] = function(_e, le) {
                if (this[_$_b208[1477]](), [ne[_$_b208[74]][_$_b208[1478]], ne[_$_b208[74]][_$_b208[73]]][_$_b208[26]](le[_$_b208[72]])) {
                  var se = (0, ie[_$_b208[1479]])(le, _e);
                  if (this[_$_b208[1475]][se])
                    return;
                  this[_$_b208[1475]][se] = Date[_$_b208[180]]();
                }
                this[_$_b208[160]][_$_b208[503]](ne[_$_b208[482]][_$_b208[1480]], le);
              }, he[_$_b208[21]][_$_b208[1477]] = function() {
                for (var _e = 0, le = Object[_$_b208[69]](this[_$_b208[1475]]); _e < le[_$_b208[18]]; _e++) {
                  var se = le[_e];
                  this[_$_b208[1481]](this[_$_b208[1475]][se]) && delete this[_$_b208[1475]][se];
                }
              }, he[_$_b208[21]][_$_b208[1481]] = function(_e) {
                if (!_e)
                  return !0;
                var le = (0, ae[_$_b208[15]])(this[_$_b208[1476]] * this[_$_b208[1474]]);
                return Date[_$_b208[180]]() - le > _e;
              }, Object[_$_b208[13]](he[_$_b208[21]], _$_b208[1482], { get: function() {
                return this[_$_b208[1476]];
              }, set: function(_e) {
                this[_$_b208[1476]] = Math[_$_b208[1483]](_e);
              }, enumerable: !1, configurable: !0 }), he[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[1475]] = null, this[_$_b208[160]][_$_b208[688]](ne[_$_b208[482]][_$_b208[689]], this[_$_b208[767]]);
              }, he;
            }();
            te[_$_b208[1076]] = ce;
          }, 27279: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1097]] = ae, te[_$_b208[53]] = ce;
            var ne = ee(18665), ie = ee(27177);
            function ae(he) {
              var _e, le;
              return (0, ie[_$_b208[502]])(he) ? (_e = he[_$_b208[494]]) === null || _e === void 0 ? void 0 : _e[_$_b208[199]](ne[_$_b208[490]][_$_b208[826]], (le = he[_$_b208[671]]) === null || le === void 0 ? void 0 : le[_$_b208[510]]) : void 0;
            }
            function ce(he) {
              var _e = ae(he);
              return _e == null ? void 0 : _e[_$_b208[182]]();
            }
          }, 27517: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1484]] = ie;
            var ne = ee(27177);
            function ie(ae) {
              return (0, ne[_$_b208[1473]])(ae) && [_$_b208[769], _$_b208[1485]][_$_b208[516]](function(ce) {
                return ce in ae;
              });
            }
          }, 28463: function(re, te) {
            _$_b208[11];
            function ee(ie) {
              return ie[_$_b208[1185]];
            }
            function ne(ie, ae) {
              return ie[ae] ? ie[ae][_$_b208[1486]] : void 0;
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1487]] = ee, te[_$_b208[1488]] = ne;
          }, 28764: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[720]] = void 0;
            var ne = ee(25550), ie = function() {
              function ae(ce, he, _e, le) {
                this[_$_b208[113]] = ce, this[_$_b208[176]] = ne[_$_b208[369]][ce], this[_$_b208[510]] = le, this[_$_b208[119]] = _e ?? _$_b208[265][_$_b208[94]](this[_$_b208[176]]), this[_$_b208[1489]] = he, _$_b208[161] == typeof Error[_$_b208[1490]] ? Error[_$_b208[1490]](this, this[_$_b208[229]]) : this[_$_b208[267]] = new Error(this[_$_b208[119]])[_$_b208[267]];
              }
              return ae;
            }();
            te[_$_b208[720]] = ie;
          }, 28819: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1491]] = te[_$_b208[1364]] = void 0, te[_$_b208[1492]] = ne, te[_$_b208[1493]] = ie;
            var ee = function(ce) {
              return ce[_$_b208[1485]];
            };
            function ne(ce, he, _e) {
              return ce[he] && ce[he][_$_b208[1489]][_e] || [];
            }
            function ie(ce, he, _e) {
              var le = ne(ce, he, _e);
              return le[_$_b208[18]] === 0 ? { time: void 0, value: void 0 } : le[le[_$_b208[18]] - 1];
            }
            te[_$_b208[1364]] = ee;
            var ae = function(ce, he, _e) {
              return ne((0, te[_$_b208[1364]])(ce), he, _e);
            };
            te[_$_b208[1491]] = ae;
          }, 29073: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[748]] = se, te[_$_b208[1494]] = oe;
            var ne = ee(43485), ie = ee(56435), ae = ee(15231), ce = ee(11399), he = ce[_$_b208[450]][_$_b208[451]], _e = ce[_$_b208[450]][_$_b208[453]], le = function() {
              var ue;
              return { isPlayStation5: ie[_$_b208[206]](), isPlayStation4: ie[_$_b208[209]](), isMobile: ie[_$_b208[455]](), isTizen: ie[_$_b208[193]](), isSafari: ie[_$_b208[189]](), isIOS: ie[_$_b208[461]](), isSafariIOS: ie[_$_b208[462]](), isEdge: ie[_$_b208[463]](), isLegacyEdge: ie[_$_b208[464]](), isChrome: ie[_$_b208[456]](), isChromium: ie[_$_b208[457]](), isFirefox: ie[_$_b208[458]](), isFirefoxIOS: ie[_$_b208[459]](), isWebOS: ie[_$_b208[200]](), isVidaa: ie[_$_b208[203]](), isVizio: ie[_$_b208[460]](), isReactNative: ie[_$_b208[465]](), MSESafari: ne[_$_b208[466]](), isLocalStorageAvailable: ne[_$_b208[467]](), isInlinePlaybackRestricted: ne[_$_b208[468]](), edgeVersion: ie[_$_b208[1495]](), IOSVersion: ie[_$_b208[1496]](), safariVersion: ie[_$_b208[1497]](), webOSChromiumVersion: (ue = ie[_$_b208[1499]]()[_$_b208[1498]]) !== null && ue !== void 0 ? ue : 0, techSupportedByModules: ne[_$_b208[1500]](), techSupportedByPlatform: ne[_$_b208[1501]](), techSupportedByModulesOnPlatform: ne[_$_b208[1502]]() };
            };
            function se() {
              return (0, ae[_$_b208[626]])(he, le());
            }
            function oe(ue, be) {
              return (0, ae[_$_b208[626]])(_e, { key: ue, value: be });
            }
          }, 29500: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1503]] = ie;
            var ee = 4, ne = 4;
            function ie(ae, ce) {
              ce[_$_b208[258]](_$_b208[265])[_$_b208[630]](0, ne)[_$_b208[68]](function(he, _e) {
                return ae[_$_b208[1506]][_$_b208[1505]](ee + _e, he[_$_b208[1504]](0));
              });
            }
          }, 30051: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1507]] = void 0;
            var ee = function() {
              function ne() {
              }
              return ne[_$_b208[1508]] = function(ie) {
                var ae = function(he) {
                }, ce = new Promise(function(he, _e) {
                  ae = _e, ie[_$_b208[674]](he, _e);
                });
                return ce[_$_b208[1509]] = ae[_$_b208[1510]](ce), ce;
              }, ne;
            }();
            te[_$_b208[1507]] = ee;
          }, 30573: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1511]] = void 0;
            var ne = ee(60997), ie = ee(1356), ae = ee(46462), ce = ee(1480), he = ee(11419), _e = function() {
              function le(se, oe) {
                this[_$_b208[97]] = oe, this[_$_b208[46]] = se, this[_$_b208[239]] = new ce[_$_b208[108]](se, oe), this[_$_b208[1512]] = new he[_$_b208[476]](se, this), this[_$_b208[78]] = null;
              }
              return Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1513], { get: function() {
                return this[_$_b208[97]][_$_b208[1513]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[246], { get: function() {
                return this[_$_b208[97]][_$_b208[246]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1514], { get: function() {
                return this[_$_b208[97]][_$_b208[1514]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[61], { get: function() {
                return this[_$_b208[97]][_$_b208[61]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[245], { get: function() {
                return this[_$_b208[97]][_$_b208[245]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[90], { get: function() {
                return this[_$_b208[97]][_$_b208[90]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1515], { get: function() {
                return this[_$_b208[97]][_$_b208[1515]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1516], { get: function() {
                return this[_$_b208[97]][_$_b208[1516]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[237], { get: function() {
                return this[_$_b208[97]][_$_b208[237]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1517], { get: function() {
                return this[_$_b208[97]][_$_b208[1517]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1518], { get: function() {
                return this[_$_b208[97]][_$_b208[1518]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[101], { get: function() {
                return this[_$_b208[97]][_$_b208[101]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1519], { get: function() {
                return this[_$_b208[97]][_$_b208[1519]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[242], { get: function() {
                return this[_$_b208[97]][_$_b208[242]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[693], { get: function() {
                return this[_$_b208[97]] && this[_$_b208[97]][_$_b208[693]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1520], { get: function() {
                return this[_$_b208[97]][_$_b208[1520]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1521], { get: function() {
                return this[_$_b208[97]][_$_b208[1521]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1522], { get: function() {
                return this[_$_b208[97]][_$_b208[1522]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1186], { get: function() {
                return this[_$_b208[97]][_$_b208[1186]];
              }, set: function(se) {
                this[_$_b208[97]][_$_b208[1186]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1523], { get: function() {
                return this[_$_b208[97]][_$_b208[1523]];
              }, set: function(se) {
                this[_$_b208[97]][_$_b208[1523]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1524], { get: function() {
                return this[_$_b208[97]][_$_b208[1524]];
              }, set: function(se) {
                this[_$_b208[97]][_$_b208[1524]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[235], { get: function() {
                var se, oe;
                return (oe = (se = this[_$_b208[97]]) === null || se === void 0 ? void 0 : se[_$_b208[235]]) !== null && oe !== void 0 ? oe : 0;
              }, set: function(se) {
                this[_$_b208[97]][_$_b208[235]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1525], { get: function() {
                return this[_$_b208[97]][_$_b208[1525]];
              }, set: function(se) {
                this[_$_b208[97]][_$_b208[1525]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[479], { get: function() {
                return this[_$_b208[46]][_$_b208[81]][_$_b208[1526]] ? this[_$_b208[97]] && this[_$_b208[97]][_$_b208[478]] === 0 : this[_$_b208[97]] && this[_$_b208[97]][_$_b208[479]];
              }, set: function(se) {
                if (this[_$_b208[46]][_$_b208[81]][_$_b208[1526]]) {
                  if (se) {
                    var oe = this[_$_b208[478]];
                    this[_$_b208[478]] = 0, this[_$_b208[1512]][_$_b208[480]][_$_b208[478]] = oe;
                  } else
                    this[_$_b208[478]] = this[_$_b208[1512]][_$_b208[480]][_$_b208[478]];
                  this[_$_b208[1512]][_$_b208[480]][_$_b208[479]] = se, this[_$_b208[97]][_$_b208[479]] = !1;
                } else
                  this[_$_b208[1512]][_$_b208[480]][_$_b208[479]] = se, this[_$_b208[97]][_$_b208[479]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[861], { get: function() {
                return this[_$_b208[97]][_$_b208[861]];
              }, set: function(se) {
                this[_$_b208[97]][_$_b208[861]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[274], { get: function() {
                return this[_$_b208[97]][_$_b208[274]];
              }, set: function(se) {
                this[_$_b208[1512]][_$_b208[64]](), this[_$_b208[97]][_$_b208[274]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[1527], { get: function() {
                return this[_$_b208[97]][_$_b208[1527]];
              }, set: function(se) {
                this[_$_b208[1512]][_$_b208[64]](), this[_$_b208[97]][_$_b208[1527]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[488], { get: function() {
                return this[_$_b208[97]][_$_b208[488]];
              }, set: function(se) {
                try {
                  this[_$_b208[97]][_$_b208[488]] = se;
                } catch {
                  this[_$_b208[46]][_$_b208[148]][_$_b208[1037]](_$_b208[1528] + se);
                }
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[478], { get: function() {
                var se;
                return ((se = this[_$_b208[1512]]) === null || se === void 0 ? void 0 : se[_$_b208[480]][_$_b208[479]]) === !0 && this[_$_b208[46]][_$_b208[81]][_$_b208[1526]] ? this[_$_b208[1512]][_$_b208[480]][_$_b208[478]] : this[_$_b208[97]][_$_b208[478]];
              }, set: function(se) {
                this[_$_b208[1512]][_$_b208[480]][_$_b208[478]] = se, this[_$_b208[97]][_$_b208[478]] = se;
              }, enumerable: !1, configurable: !0 }), le[_$_b208[21]][_$_b208[1529]] = function(se, oe, ue) {
                return this[_$_b208[97]][_$_b208[1529]](se, oe, ue);
              }, le[_$_b208[21]][_$_b208[1530]] = function(se, oe) {
                return this[_$_b208[97]][_$_b208[1530]](se, oe);
              }, le[_$_b208[21]][_$_b208[244]] = function() {
                this[_$_b208[97]][_$_b208[244]]();
              }, le[_$_b208[21]][_$_b208[169]] = function() {
                this[_$_b208[97]] && this[_$_b208[97]][_$_b208[169]]();
              }, le[_$_b208[21]][_$_b208[167]] = function() {
                return this[_$_b208[1531]]();
              }, le[_$_b208[21]][_$_b208[1531]] = function() {
                return this[_$_b208[97]][_$_b208[167]]() || ie[_$_b208[75]][_$_b208[107]](this[_$_b208[46]], this, this[_$_b208[78]]);
              }, le[_$_b208[21]][_$_b208[1532]] = function() {
                var se = this, oe = function(ue) {
                  se[_$_b208[239]] && (se[_$_b208[239]][_$_b208[135]] = ue);
                };
                return oe(!0), this[_$_b208[239]][_$_b208[145]](ae[_$_b208[103]][_$_b208[1472]]), this[_$_b208[1533]]()[_$_b208[674]](function() {
                  oe(!1);
                });
              }, le[_$_b208[21]][_$_b208[1533]] = function() {
                this[_$_b208[1531]]()[_$_b208[943]](function() {
                }), this[_$_b208[169]]();
                var se = this[_$_b208[236]]();
                return new Promise(function(oe) {
                  var ue = setTimeout(function() {
                    se[_$_b208[105]](ae[_$_b208[103]][_$_b208[169]], be), oe();
                  }, 100), be = function() {
                    clearTimeout(ue), se[_$_b208[105]](ae[_$_b208[103]][_$_b208[169]], be), oe();
                  };
                  se[_$_b208[100]](ae[_$_b208[103]][_$_b208[169]], be);
                });
              }, le[_$_b208[21]][_$_b208[1534]] = function(se) {
                return this[_$_b208[97]] && this[_$_b208[97]][_$_b208[1534]](se) || Promise[_$_b208[85]]();
              }, le[_$_b208[21]][_$_b208[1535]] = function(se) {
                return this[_$_b208[97]] && this[_$_b208[97]][_$_b208[1535]](se);
              }, le[_$_b208[21]][_$_b208[1536]] = function(se) {
                this[_$_b208[97]][_$_b208[1536]](se);
              }, le[_$_b208[21]][_$_b208[600]] = function(se) {
                return this[_$_b208[97]][_$_b208[600]](se);
              }, le[_$_b208[21]][_$_b208[598]] = function(se, oe) {
                this[_$_b208[97]][_$_b208[598]](se, oe);
              }, le[_$_b208[21]][_$_b208[1537]] = function(se) {
                this[_$_b208[97]][_$_b208[1537]](se);
              }, le[_$_b208[21]][_$_b208[284]] = function(se) {
                return this[_$_b208[97]][_$_b208[284]](se);
              }, le[_$_b208[21]][_$_b208[1055]] = function(se) {
                this[_$_b208[97]][_$_b208[1055]](se);
              }, le[_$_b208[21]][_$_b208[963]] = function(se) {
                return this[_$_b208[97]][_$_b208[963]](se);
              }, le[_$_b208[21]][_$_b208[277]] = function(se) {
                return this[_$_b208[97]][_$_b208[277]](se);
              }, le[_$_b208[21]][_$_b208[100]] = function(se, oe, ue) {
                this[_$_b208[239]][_$_b208[100]](se, oe, ue);
              }, le[_$_b208[21]][_$_b208[105]] = function(se, oe) {
                this[_$_b208[239]] && this[_$_b208[239]][_$_b208[105]](se, oe);
              }, Object[_$_b208[13]](le[_$_b208[21]], _$_b208[160], { get: function() {
                return this[_$_b208[239]];
              }, enumerable: !1, configurable: !0 }), le[_$_b208[21]][_$_b208[236]] = function() {
                return this[_$_b208[97]];
              }, le[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[239]] = (0, ne[_$_b208[70]])(this[_$_b208[239]]), this[_$_b208[1512]] = (0, ne[_$_b208[70]])(this[_$_b208[1512]]), this[_$_b208[78]] = null, this[_$_b208[97]] = null, this[_$_b208[46]][_$_b208[148]] && this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[1538]);
              }, le;
            }();
            te[_$_b208[1511]] = _e;
          }, 32739: function(re, te, ee) {
            _$_b208[11];
            var ne, ie = this && this[_$_b208[16]] || function() {
              return ie = Object[_$_b208[17]] || function(pe) {
                for (var fe, ge = 1, ye = arguments[_$_b208[18]]; ge < ye; ge++)
                  for (var $e in fe = arguments[ge])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](fe, $e) && (pe[$e] = fe[$e]);
                return pe;
              }, ie[_$_b208[22]](this, arguments);
            }, ae = this && this[_$_b208[629]] || function(pe, fe, ge) {
              if (ge || arguments[_$_b208[18]] === 2)
                for (var ye, $e = 0, Se = fe[_$_b208[18]]; $e < Se; $e++)
                  !ye && $e in fe || (ye || (ye = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](fe, 0, $e)), ye[$e] = fe[$e]);
              return pe[_$_b208[94]](ye || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](fe));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[623]] = void 0;
            var ce = ee(21829), he = ee(63668), _e = ee(10950), le = (0, he[_$_b208[1539]])();
            function se(pe, fe) {
              var ge = fe[_$_b208[1464]];
              return ie(ie({}, pe), ge);
            }
            function oe() {
              return le;
            }
            function ue(pe, fe) {
              var ge = fe[_$_b208[1464]];
              return pe[_$_b208[1540]][_$_b208[26]](ge) ? pe : ie(ie({}, pe), { keyIdsWithErrors: ae(ae([], pe[_$_b208[1540]], !0), [ge], !1) });
            }
            function be(pe) {
              return pe[_$_b208[1540]][_$_b208[18]] > 0 ? ie(ie({}, pe), { keyIdsWithErrors: [] }) : pe;
            }
            function ve(pe, fe) {
              var ge = fe[_$_b208[1464]];
              return ie(ie({}, pe), { usedKeySystem: ge });
            }
            function me(pe, fe) {
              return ie(ie({}, pe), { usedKeySystem: { kind: null, uid: null } });
            }
            te[_$_b208[623]] = (0, ce[_$_b208[302]])(le, ((ne = {})[_e[_$_b208[427]][_$_b208[428]]] = se, ne[_e[_$_b208[427]][_$_b208[430]]] = oe, ne[_e[_$_b208[427]][_$_b208[432]]] = ue, ne[_e[_$_b208[427]][_$_b208[434]]] = be, ne[_e[_$_b208[427]][_$_b208[436]]] = ve, ne[_e[_$_b208[427]][_$_b208[438]]] = me, ne));
          }, 33669: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1541]] = te[_$_b208[1542]] = te[_$_b208[1543]] = te[_$_b208[1544]] = te[_$_b208[1545]] = te[_$_b208[1546]] = te[_$_b208[1547]] = te[_$_b208[54]] = te[_$_b208[1548]] = te[_$_b208[1549]] = void 0, te[_$_b208[1550]] = me, te[_$_b208[56]] = ge, te[_$_b208[1551]] = ye;
            var ne = ee(92712), ie = ee(79814);
            function ae(Ie, Te) {
              return ce(Ie)[_$_b208[165]](function(Ee) {
                return Ee[_$_b208[1552]] === Te;
              });
            }
            function ce(Ie) {
              var Te;
              return (Te = Ie[_$_b208[1553]]) !== null && Te !== void 0 ? Te : [];
            }
            te[_$_b208[1549]] = 0;
            var he = function(Ie) {
              var Te;
              return (Te = Ie == null ? void 0 : Ie[_$_b208[1172]]) === null || Te === void 0 ? void 0 : Te[_$_b208[55]];
            };
            te[_$_b208[1548]] = he;
            var _e = function(Ie) {
              return Ie == null ? void 0 : Ie[_$_b208[1172]];
            };
            te[_$_b208[54]] = _e;
            var le = function(Ie, Te) {
              var Ee;
              return Te in Ie && (Ee = Ie[Te][_$_b208[1554]]) !== null && Ee !== void 0 ? Ee : [];
            };
            te[_$_b208[1547]] = le;
            var se = function(Ie) {
              return function(Te, Ee) {
                var we = (0, te[_$_b208[54]])(Te), Pe = (0, te[_$_b208[54]])(Ee);
                return (we ? (0, te[_$_b208[1544]])(we, Ie) : te[_$_b208[1549]]) !== (Pe ? (0, te[_$_b208[1544]])(Pe, Ie) : te[_$_b208[1549]]);
              };
            };
            te[_$_b208[1546]] = se;
            var oe = function(Ie, Te) {
              var Ee = Ie[_$_b208[55]], we = Te[_$_b208[55]], Pe = Object[_$_b208[69]](Ee), Me = Object[_$_b208[69]](we);
              if (Pe[_$_b208[18]] !== Me[_$_b208[18]] || Pe[_$_b208[610]](function(Ve) {
                return !Me[_$_b208[26]](Ve);
              }))
                return !0;
              for (var Ae = 0, Oe = Pe; Ae < Oe[_$_b208[18]]; Ae++) {
                var Be = Oe[Ae];
                if (ue((0, te[_$_b208[1547]])(Ee, Be), (0, te[_$_b208[1547]])(we, Be)) || ue(ce(Ee[Be]), ce(we[Be])))
                  return !0;
              }
              return !1;
            };
            function ue(Ie, Te) {
              return Ie !== Te && (Ie[_$_b208[18]] !== 0 || Te[_$_b208[18]] !== 0) && Ie !== Te;
            }
            te[_$_b208[1545]] = oe;
            var be = function(Ie, Te) {
              var Ee;
              return Te in Ie[_$_b208[55]] && (Ee = Ie[_$_b208[55]][Te][_$_b208[1555]]) !== null && Ee !== void 0 ? Ee : te[_$_b208[1549]];
            };
            te[_$_b208[1544]] = be;
            var ve = function(Ie, Te) {
              return Ie ? Object[_$_b208[69]](Ie[_$_b208[55]])[_$_b208[1277]](function(Ee, we) {
                return Ee[we] = ae(Ie[_$_b208[55]][we], Te), Ee;
              }, {}) : {};
            };
            function me(Ie, Te) {
              var Ee, we;
              return (we = (Ee = Ie[_$_b208[55]][Te]) === null || Ee === void 0 ? void 0 : Ee[_$_b208[1553]]) !== null && we !== void 0 ? we : [];
            }
            te[_$_b208[1543]] = ve;
            var pe = function(Ie, Te, Ee) {
              return Te === void 0 ? {} : Se(Te, Ie, Ee);
            };
            te[_$_b208[1542]] = pe;
            var fe = function(Ie, Te) {
              return function(Ee, we) {
                var Pe = Ie[_$_b208[1556]](we);
                if (Ee === void 0 || Te === void 0 || Pe === void 0)
                  return {};
                var Me = Ie[_$_b208[1560]](Ee)[_$_b208[124]](function(Ae) {
                  return Ae[_$_b208[1559]];
                })[_$_b208[165]](function(Ae) {
                  return ie[_$_b208[1558]][_$_b208[1557]](Ae);
                });
                return $e(Te, Me);
              };
            };
            function ge(Ie) {
              if (!Ie)
                return -1;
              var Te = Object[_$_b208[69]](Ie)[_$_b208[124]](function(Ee) {
                var we, Pe;
                return (Pe = (we = Ie[Ee][_$_b208[1554]]) === null || we === void 0 ? void 0 : we[0]) === null || Pe === void 0 ? void 0 : Pe[_$_b208[57]];
              })[_$_b208[165]](function(Ee) {
                return Ee !== void 0;
              });
              return Te[_$_b208[18]] > 0 ? Math[_$_b208[137]][_$_b208[22]](Math, Te) : -1;
            }
            function ye(Ie) {
              var Te, Ee;
              return (Ee = (Te = Ie[_$_b208[1172]]) === null || Te === void 0 ? void 0 : Te[_$_b208[1561]]) !== null && Ee !== void 0 && Ee;
            }
            te[_$_b208[1541]] = fe;
            var $e = function(Ie, Te) {
              var Ee = {};
              return Te[_$_b208[68]](function(we) {
                return Ee[we] = (0, te[_$_b208[1547]])(Ie[_$_b208[55]], we);
              }), Ee;
            };
            function Se(Ie, Te, Ee) {
              var we = Object[_$_b208[69]](Ie[_$_b208[55]]), Pe = Te[_$_b208[1562]](Ie, we), Me = $e(Ie, we);
              return Object[_$_b208[69]](Me)[_$_b208[68]](function(Ae) {
                return Pe[Ae][_$_b208[141]](Me[Ae]);
              }), Ce(we, Pe, Ee);
            }
            function Ce(Ie, Te, Ee) {
              var we = {};
              return Ie[_$_b208[68]](function(Pe) {
                return we[Pe] = ne[_$_b208[1565]][_$_b208[1564]](Te[Pe][_$_b208[1563]](function(Me) {
                  return Me;
                }), Ee);
              }), we;
            }
          }, 33696: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[224]] || function() {
              var me = function(pe, fe) {
                return me = Object[_$_b208[225]] || { __proto__: [] } instanceof Array && function(ge, ye) {
                  ge[_$_b208[226]] = ye;
                } || function(ge, ye) {
                  for (var $e in ye)
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](ye, $e) && (ge[$e] = ye[$e]);
                }, me(pe, fe);
              };
              return function(pe, fe) {
                if (_$_b208[161] != typeof fe && fe !== null)
                  throw new TypeError(_$_b208[227] + String(fe) + _$_b208[228]);
                function ge() {
                  this[_$_b208[229]] = pe;
                }
                me(pe, fe), pe[_$_b208[21]] = fe === null ? Object[_$_b208[230]](fe) : (ge[_$_b208[21]] = fe[_$_b208[21]], new ge());
              };
            }();
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[897]] = te[_$_b208[1025]] = te[_$_b208[563]] = te[_$_b208[1566]] = te[_$_b208[150]] = te[_$_b208[872]] = te[_$_b208[874]] = te[_$_b208[782]] = te[_$_b208[844]] = void 0;
            var ie = ee(25550), ae = ee(28764), ce = ee(40362);
            Object[_$_b208[13]](te, _$_b208[844], { enumerable: !0, get: function() {
              return ce[_$_b208[844]];
            } });
            var he, _e, le, se = ee(83091);
            Object[_$_b208[13]](te, _$_b208[782], { enumerable: !0, get: function() {
              return se[_$_b208[782]];
            } }), function(me) {
              me[_$_b208[906]] = _$_b208[1567], me[_$_b208[873]] = _$_b208[214], me[_$_b208[1120]] = _$_b208[1007], me[_$_b208[1568]] = _$_b208[1569];
            }(he || (te[_$_b208[874]] = he = {})), function(me) {
              me[_$_b208[871]] = _$_b208[1570], me[_$_b208[1571]] = _$_b208[1572];
            }(_e || (te[_$_b208[872]] = _e = {})), function(me) {
              me[_$_b208[149]] = _$_b208[154], me[_$_b208[1573]] = _$_b208[1037], me[_$_b208[1574]] = _$_b208[721], me[_$_b208[1575]] = _$_b208[90], me[_$_b208[1576]] = _$_b208[688];
            }(le || (te[_$_b208[150]] = le = {}));
            var oe, ue, be, ve = function(me) {
              function pe(fe) {
                return me[_$_b208[19]](this, ie[_$_b208[369]][_$_b208[1108]], void 0, _$_b208[1578][_$_b208[94]](fe, _$_b208[1577])) || this;
              }
              return ne(pe, me), pe;
            }(ae[_$_b208[720]]);
            te[_$_b208[1566]] = ve, function(me) {
              me[_$_b208[572]] = _$_b208[1579], me[_$_b208[562]] = _$_b208[1580], me[_$_b208[569]] = _$_b208[1581];
            }(oe || (te[_$_b208[563]] = oe = {})), function(me) {
              me[_$_b208[1024]] = _$_b208[1582], me[_$_b208[1026]] = _$_b208[283], me[_$_b208[1027]] = _$_b208[1583];
            }(ue || (te[_$_b208[1025]] = ue = {})), function(me) {
              me[_$_b208[1584]] = _$_b208[1585], me[_$_b208[896]] = _$_b208[1586];
            }(be || (te[_$_b208[897]] = be = {}));
          }, 34586: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1587]] = void 0;
            var ne = ee(81361), ie = function() {
              function ae() {
              }
              return ae[_$_b208[1588]] = function(ce) {
                if (!ce)
                  return !1;
                var he = [87, 69, 66, 86, 84, 84], _e = [239, 187, 191], le = new Uint8Array(ce[_$_b208[630]](0, 6)), se = new Uint8Array(ce[_$_b208[630]](0, 9));
                return ne[_$_b208[1590]][_$_b208[1589]](le, new Uint8Array(he)) || ne[_$_b208[1590]][_$_b208[1589]](se, new Uint8Array(_e[_$_b208[94]](he)));
              }, ae[_$_b208[1591]] = function(ce) {
                for (var he, _e = !0, le = [34, 85, 84, 70, 45, 56, 34], se = ce instanceof ArrayBuffer ? new DataView(ce) : ce, oe = 0; oe < se[_$_b208[1592]]; oe++)
                  if ((he = se[_$_b208[1593]](oe)) > 128)
                    _e = !1;
                  else {
                    if (he === 0)
                      return _$_b208[1594];
                    if (he === le[0] && se[_$_b208[1592]] > oe + le[_$_b208[18]]) {
                      for (var ue = !0, be = 1; be < le[_$_b208[18]]; be++)
                        if (le[be] !== se[_$_b208[1593]](oe + be)) {
                          ue = !1;
                          break;
                        }
                      if (ue)
                        return _$_b208[1595];
                    }
                  }
                return _e ? _$_b208[1596] : _$_b208[1595];
              }, ae;
            }();
            te[_$_b208[1587]] = ie;
          }, 34731: function(re, te) {
            _$_b208[11];
            function ee(ae) {
              ae && ae[_$_b208[1597]]();
            }
            function ne(ae) {
              ae && ae[_$_b208[1598]]();
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1599]] = void 0, te[_$_b208[1597]] = ee, te[_$_b208[1598]] = ne;
            var ie = function() {
              function ae(ce) {
                this[_$_b208[1600]] = !1, this[_$_b208[1601]] = ce == null ? void 0 : ce[_$_b208[1602]], this[_$_b208[1603]] = ce == null ? void 0 : ce[_$_b208[1604]];
              }
              return ae[_$_b208[21]][_$_b208[1597]] = function() {
                var ce;
                this[_$_b208[1600]] || (this[_$_b208[1600]] = !0, (ce = this[_$_b208[1601]]) === null || ce === void 0 || ce[_$_b208[19]](this));
              }, ae[_$_b208[21]][_$_b208[1598]] = function() {
                var ce;
                this[_$_b208[1600]] && (this[_$_b208[1600]] = !1, (ce = this[_$_b208[1603]]) === null || ce === void 0 || ce[_$_b208[19]](this));
              }, ae[_$_b208[21]][_$_b208[1605]] = function() {
                return this[_$_b208[1600]];
              }, ae[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[1600]] = null, this[_$_b208[1601]] = null, this[_$_b208[1603]] = null;
              }, ae;
            }();
            te[_$_b208[1599]] = ie;
          }, 34795: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1606]] = void 0;
            var ne = ee(92737), ie = ee(56435), ae = ee(46462), ce = 12, he = 250, _e = 0.01, le = 1e3, se = function() {
              function ue(be, ve) {
                var me = this;
                this[_$_b208[46]] = be, this[_$_b208[587]] = ve, this[_$_b208[1153]] = !1, this[_$_b208[1607]] = Date[_$_b208[180]](), this[_$_b208[1608]] = 0, this[_$_b208[1609]] = function() {
                  !me[_$_b208[46]][_$_b208[512]] && me[_$_b208[587]] && (me[_$_b208[587]][_$_b208[237]] || me[_$_b208[587]][_$_b208[242]] || Date[_$_b208[180]]() - me[_$_b208[1607]] > le && (me[_$_b208[1608]]++, me[_$_b208[1610]]()));
                }, this[_$_b208[1611]] = function() {
                  me[_$_b208[1153]] = !1, clearInterval(me[_$_b208[1612]]);
                }, this[_$_b208[744]] = function() {
                  me[_$_b208[1153]] = !0, clearInterval(me[_$_b208[1612]]), me[_$_b208[1612]] = window[_$_b208[1613]](me[_$_b208[1609]], he);
                }, this[_$_b208[1614]] = function() {
                  me[_$_b208[1608]]++;
                }, this[_$_b208[241]] = function() {
                  if (me[_$_b208[1607]] = Date[_$_b208[180]](), !me[_$_b208[587]][_$_b208[237]] && !me[_$_b208[587]][_$_b208[242]]) {
                    me[_$_b208[1153]] = !0;
                    var pe = me[_$_b208[587]][_$_b208[235]];
                    pe === me[_$_b208[1615]] ? me[_$_b208[1608]]++ : (me[_$_b208[1608]] = 0, me[_$_b208[1615]] = pe);
                  }
                }, this[_$_b208[587]][_$_b208[100]](ae[_$_b208[103]][_$_b208[169]], this[_$_b208[1611]]), this[_$_b208[587]][_$_b208[100]](ae[_$_b208[103]][_$_b208[168]], this[_$_b208[744]]), this[_$_b208[587]][_$_b208[100]](ae[_$_b208[103]][_$_b208[170]], this[_$_b208[241]]), this[_$_b208[587]][_$_b208[100]](ae[_$_b208[103]][_$_b208[1616]], this[_$_b208[1614]]), this[_$_b208[1612]] = window[_$_b208[1613]](this[_$_b208[1609]], he);
              }
              return ue[_$_b208[21]][_$_b208[70]] = function() {
                clearInterval(this[_$_b208[1612]]), this[_$_b208[587]][_$_b208[105]](ae[_$_b208[103]][_$_b208[169]], this[_$_b208[1611]]), this[_$_b208[587]][_$_b208[105]](ae[_$_b208[103]][_$_b208[168]], this[_$_b208[744]]), this[_$_b208[587]][_$_b208[105]](ae[_$_b208[103]][_$_b208[170]], this[_$_b208[241]]), this[_$_b208[587]][_$_b208[105]](ae[_$_b208[103]][_$_b208[1616]], this[_$_b208[1614]]);
              }, ue[_$_b208[21]][_$_b208[64]] = function() {
                this[_$_b208[1608]] = 0, this[_$_b208[1153]] = !1, this[_$_b208[1607]] = Date[_$_b208[180]]();
              }, ue[_$_b208[21]][_$_b208[1610]] = function() {
                this[_$_b208[1608]] <= ce || (this[_$_b208[1608]] = 0, this[_$_b208[1153]] ? (this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[1617][_$_b208[94]](this[_$_b208[587]][_$_b208[235]])), this[_$_b208[1618]]()) : this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[1619]));
              }, ue[_$_b208[21]][_$_b208[1618]] = function() {
                if (this[_$_b208[46]][_$_b208[1620]][_$_b208[1022]]() !== ne[_$_b208[782]][_$_b208[786]] || oe()) {
                  var be = this[_$_b208[587]][_$_b208[235]], ve = this[_$_b208[587]][_$_b208[61]];
                  ve > 0 && be >= ve ? (this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[1621]), this[_$_b208[587]][_$_b208[503]](new Event(ae[_$_b208[103]][_$_b208[245]]))) : (this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[1622]), this[_$_b208[1623]](be + _e));
                }
              }, ue[_$_b208[21]][_$_b208[1623]] = function(be) {
                try {
                  this[_$_b208[587]][_$_b208[235]] = be;
                } catch (ve) {
                  this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[1624][_$_b208[94]](be), ve);
                }
              }, ue;
            }();
            function oe() {
              var ue;
              return !!((0, ie[_$_b208[189]])() && ((ue = (0, ie[_$_b208[1497]])()[_$_b208[1498]]) !== null && ue !== void 0 ? ue : 0) >= ie[_$_b208[1625]]) || !!((0, ie[_$_b208[461]])() && (0, ie[_$_b208[1496]])() >= ie[_$_b208[1626]]);
            }
            te[_$_b208[1606]] = se;
          }, 35148: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[950]] = void 0, function(ne) {
              ne[ne[_$_b208[1627]] = 1e3] = _$_b208[1627], ne[ne[_$_b208[1011]] = 1001] = _$_b208[1011], ne[ne[_$_b208[1628]] = 1100] = _$_b208[1628], ne[ne[_$_b208[1629]] = 1101] = _$_b208[1629], ne[ne[_$_b208[1630]] = 1103] = _$_b208[1630], ne[ne[_$_b208[1631]] = 1104] = _$_b208[1631], ne[ne[_$_b208[1632]] = 1200] = _$_b208[1632], ne[ne[_$_b208[1633]] = 1201] = _$_b208[1633], ne[ne[_$_b208[1634]] = 1202] = _$_b208[1634], ne[ne[_$_b208[1635]] = 1203] = _$_b208[1635], ne[ne[_$_b208[1636]] = 1204] = _$_b208[1636], ne[ne[_$_b208[1637]] = 1205] = _$_b208[1637], ne[ne[_$_b208[1638]] = 1300] = _$_b208[1638], ne[ne[_$_b208[1639]] = 1301] = _$_b208[1639], ne[ne[_$_b208[1640]] = 1302] = _$_b208[1640], ne[ne[_$_b208[949]] = 1303] = _$_b208[949], ne[ne[_$_b208[1641]] = 1304] = _$_b208[1641], ne[ne[_$_b208[1642]] = 1305] = _$_b208[1642], ne[ne[_$_b208[1643]] = 1400] = _$_b208[1643], ne[ne[_$_b208[1644]] = 1401] = _$_b208[1644], ne[ne[_$_b208[1645]] = 1402] = _$_b208[1645], ne[ne[_$_b208[1646]] = 2e3] = _$_b208[1646], ne[ne[_$_b208[1647]] = 2001] = _$_b208[1647], ne[ne[_$_b208[1648]] = 2002] = _$_b208[1648], ne[ne[_$_b208[1649]] = 2003] = _$_b208[1649], ne[ne[_$_b208[1431]] = 2004] = _$_b208[1431], ne[ne[_$_b208[1440]] = 2013] = _$_b208[1440], ne[ne[_$_b208[1650]] = 2100] = _$_b208[1650], ne[ne[_$_b208[1651]] = 2101] = _$_b208[1651], ne[ne[_$_b208[1652]] = 3e3] = _$_b208[1652], ne[ne[_$_b208[1446]] = 3001] = _$_b208[1446], ne[ne[_$_b208[1653]] = 3100] = _$_b208[1653], ne[ne[_$_b208[1654]] = 3101] = _$_b208[1654], ne[ne[_$_b208[1655]] = 3102] = _$_b208[1655], ne[ne[_$_b208[1656]] = 3103] = _$_b208[1656], ne[ne[_$_b208[1657]] = 3104] = _$_b208[1657];
            }(ee || (te[_$_b208[950]] = ee = {}));
          }, 36334: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[757]] = void 0;
            var ne = ee(91520), ie = ee(16368), ae = ee(25550), ce = ee(28764), he = ee(33696), _e = ee(13533), le = ee(43485), se = ee(82315), oe = 1e7, ue = function() {
              function be() {
                this[_$_b208[1658]] = se[_$_b208[1659]][_$_b208[817]]();
              }
              return be[_$_b208[1660]] = function(ve, me, pe, fe) {
                return be[_$_b208[1661]](me) ? ve ? new ce[_$_b208[720]](ae[_$_b208[369]][_$_b208[1414]], { "player-type": ve[_$_b208[769]], "supported-tech": JSON[_$_b208[1012]](pe) }, _$_b208[1662]) : me[_$_b208[20]](_$_b208[680]) ? new ce[_$_b208[720]](ae[_$_b208[369]][_$_b208[1115]], void 0, _$_b208[1116]) : fe ? new ce[_$_b208[720]](ae[_$_b208[369]][_$_b208[1113]], void 0, _$_b208[1114]) : new ce[_$_b208[720]](ae[_$_b208[369]][_$_b208[1415]], { "supported-tech": JSON[_$_b208[1012]](pe) }, _$_b208[1114]) : new ce[_$_b208[720]](ae[_$_b208[369]][_$_b208[954]], { source: me }, _$_b208[1663]);
              }, be[_$_b208[1661]] = function(ve) {
                var me, pe, fe, ge;
                return ve && !!((ge = (fe = (pe = (me = ve[_$_b208[783]]) !== null && me !== void 0 ? me : ve[_$_b208[785]]) !== null && pe !== void 0 ? pe : ve[_$_b208[787]]) !== null && fe !== void 0 ? fe : ve[_$_b208[789]]) !== null && ge !== void 0 ? ge : ve[_$_b208[791]]);
              }, be[_$_b208[21]][_$_b208[817]] = function(ve) {
                var me = Object[_$_b208[619]](ve[_$_b208[507]]), pe = (0, _e[_$_b208[191]])()[_$_b208[474]], fe = (0, le[_$_b208[1236]])(ve[_$_b208[349]][_$_b208[498]]()[_$_b208[1235]], ve[_$_b208[507]], ve[_$_b208[1664]]);
                if (me[_$_b208[18]] > 0 && !be[_$_b208[1661]](ve[_$_b208[507]]))
                  return Promise[_$_b208[84]](new ce[_$_b208[720]](ae[_$_b208[369]][_$_b208[371]], { streamType: JSON[_$_b208[1012]](me), supportedTech: JSON[_$_b208[1012]](pe) }, _$_b208[1665]));
                if (me[_$_b208[18]] > 0 && !fe)
                  return Promise[_$_b208[84]](be[_$_b208[1660]](ve[_$_b208[1664]], ve[_$_b208[507]], pe, fe));
                if (me[_$_b208[18]] <= 0 && !pe[_$_b208[18]])
                  return Promise[_$_b208[84]](be[_$_b208[1660]](ve[_$_b208[1664]], ve[_$_b208[507]], pe));
                me[_$_b208[18]] <= 0 && (fe = pe[0]);
                var ge = ve[_$_b208[46]][_$_b208[587]][_$_b208[236]]();
                ve[_$_b208[669]] ? ve[_$_b208[669]][_$_b208[1666]](ge) : !ge[_$_b208[1042]] && ve[_$_b208[545]] && ve[_$_b208[545]][_$_b208[1055]](ge), ge[_$_b208[479]] = ve[_$_b208[1667]][_$_b208[479]], ge[_$_b208[478]] = ve[_$_b208[1667]][_$_b208[478]] / 100;
                var ye = ve[_$_b208[349]][_$_b208[1185]](), $e = ye[_$_b208[1669]][_$_b208[1668]];
                if ((0, _e[_$_b208[191]])()[_$_b208[455]] && (ye[_$_b208[1669]][_$_b208[1668]] = Math[_$_b208[842]]($e, oe), ye[_$_b208[1670]] = !0), fe) {
                  var Se = be[_$_b208[1671]](ve[_$_b208[46]], fe);
                  ve[_$_b208[46]][_$_b208[1672]](Se);
                }
                return this[_$_b208[1059]](ve[_$_b208[46]], fe);
              }, be[_$_b208[1671]] = function(ve, me) {
                return me[_$_b208[769]] === he[_$_b208[844]][_$_b208[1673]] ? ((0, _e[_$_b208[191]])()[_$_b208[193]] || ve[_$_b208[81]][_$_b208[1674]]) && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[194]]) ? new (ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[194]])[_$_b208[1675]]())(ve) : (0, _e[_$_b208[191]])()[_$_b208[200]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[201]]) ? new (ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[201]])[_$_b208[1676]]())(ve) : (0, _e[_$_b208[191]])()[_$_b208[206]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[207]]) ? new (ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[207]])[_$_b208[1677]]())(ve) : (0, _e[_$_b208[191]])()[_$_b208[209]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[210]]) ? new (ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[210]])[_$_b208[1678]]())(ve) : (0, _e[_$_b208[191]])()[_$_b208[203]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[204]]) ? new (ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[204]])[_$_b208[1679]]())(ve) : new (ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[1251]]))[_$_b208[1680]](ve) : null;
              }, be[_$_b208[21]][_$_b208[1059]] = function(ve, me) {
                var pe, fe = this;
                if (!ve[_$_b208[1681]] && me[_$_b208[769]] === he[_$_b208[844]][_$_b208[1673]])
                  return Promise[_$_b208[84]](new ce[_$_b208[720]](ae[_$_b208[369]][_$_b208[1410]], { tech: JSON[_$_b208[1012]](me) }, _$_b208[1682]));
                if (!this[_$_b208[1683]] && ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[1250]])) {
                  var ge = ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[1250]])[_$_b208[1684]];
                  this[_$_b208[1683]] = new ge(ve, this[_$_b208[1658]]);
                }
                if (me[_$_b208[769]] === he[_$_b208[844]][_$_b208[1685]]) {
                  var ye = ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[1270]])[_$_b208[1686]];
                  pe = Promise[_$_b208[85]](new ye(ve));
                } else if (me[_$_b208[769]] === he[_$_b208[844]][_$_b208[843]]) {
                  var $e = ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[1253]])[_$_b208[1687]];
                  pe = Promise[_$_b208[85]](new $e(ve));
                } else {
                  if (me[_$_b208[769]] !== he[_$_b208[844]][_$_b208[1673]])
                    return Promise[_$_b208[84]](new ce[_$_b208[720]](ae[_$_b208[369]][_$_b208[371]], { given: me[_$_b208[769]], supported: _$_b208[1688] }, _$_b208[1689]));
                  pe = ve[_$_b208[1681]][_$_b208[1691]]()[_$_b208[674]](function() {
                    return new (ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[1201]]))[_$_b208[1690]](ve);
                  });
                }
                return pe[_$_b208[674]](function(Se) {
                  return fe[_$_b208[1683]] ? fe[_$_b208[1683]][_$_b208[1692]](ve, Se) : Se;
                })[_$_b208[674]](function(Se) {
                  return { context: ve, logger: ve[_$_b208[148]], bitdashPlayer: Se, technology: me, videoElement: ve[_$_b208[587]] };
                });
              }, be;
            }();
            te[_$_b208[757]] = ue;
          }, 36564: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(se) {
                for (var oe, ue = 1, be = arguments[_$_b208[18]]; ue < be; ue++)
                  for (var ve in oe = arguments[ue])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](oe, ve) && (se[ve] = oe[ve]);
                return se;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[396]] = void 0, te[_$_b208[1693]] = le;
            var ie = ee(67345), ae = ee(13533), ce = function() {
              function se() {
              }
              return se[_$_b208[1694]] = function(oe) {
                if (!oe || oe[_$_b208[1695]]()[_$_b208[18]] === 0)
                  return {};
                var ue = {};
                return oe[_$_b208[258]](_$_b208[1696])[_$_b208[165]](function(be) {
                  return _$_b208[265] !== be;
                })[_$_b208[68]](function(be) {
                  var ve = be[_$_b208[258]](_$_b208[123]);
                  ue[ve[0]] = ve[1];
                }), ue;
              }, se[_$_b208[395]] = function(oe, ue, be) {
                var ve = oe[_$_b208[101]] === XMLHttpRequest[_$_b208[387]] && (0, ae[_$_b208[191]])()[_$_b208[193]] ? { status: -1, statusText: _$_b208[1697] } : { status: oe[_$_b208[391]], statusText: oe[_$_b208[1698]] }, me = se[_$_b208[1694]](oe[_$_b208[1699]]()), pe = ne({ request: ue, url: oe[_$_b208[1700]] || ue[_$_b208[403]], headers: me }, ve);
                return _e(be) && (pe[_$_b208[1701]] = be[_$_b208[294]] - be[_$_b208[388]], pe[_$_b208[1702]] = be[_$_b208[392]] - be[_$_b208[388]]), oe[_$_b208[393]] && (pe[_$_b208[422]] = this[_$_b208[1703]](oe, ue[_$_b208[418]]), pe[_$_b208[18]] = oe[_$_b208[393]][_$_b208[1592]] || oe[_$_b208[393]][_$_b208[18]] || 0), pe;
              }, se[_$_b208[1703]] = function(oe, ue) {
                var be;
                if (ue === ie[_$_b208[1705]][_$_b208[1704]] && (!((be = oe[_$_b208[1707]](_$_b208[1706])) === null || be === void 0) && be[_$_b208[26]](_$_b208[1708])) && _$_b208[348] == typeof oe[_$_b208[393]])
                  try {
                    return JSON[_$_b208[1035]](oe[_$_b208[393]]);
                  } catch {
                    return null;
                  }
                return oe[_$_b208[393]];
              }, se[_$_b208[417]] = function(oe, ue) {
                ue && Object[_$_b208[69]](ue)[_$_b208[18]] > 0 && Object[_$_b208[69]](ue)[_$_b208[68]](function(be) {
                  oe[_$_b208[1709]](be, ue[be]);
                });
              }, se[_$_b208[1710]] = function() {
                for (var oe = [], ue = 0; ue < arguments[_$_b208[18]]; ue++)
                  oe[ue] = arguments[ue];
                var be = {};
                return oe[_$_b208[68]](function(ve) {
                  ve && Object[_$_b208[69]](ve)[_$_b208[68]](function(me) {
                    var pe = he(be, me);
                    pe ? be[pe] = ve[me] : be[me] = ve[me];
                  });
                }), be;
              }, se;
            }();
            function he(se, oe) {
              return Object[_$_b208[69]](se)[_$_b208[164]](function(ue) {
                return ue[_$_b208[215]]() === oe[_$_b208[215]]();
              });
            }
            function _e(se) {
              return se[_$_b208[388]] > -1 && se[_$_b208[294]] > -1 && se[_$_b208[392]] > -1;
            }
            function le(se) {
              return se[_$_b208[18]] > 0 && se[_$_b208[1702]] >= 0 && se[_$_b208[1701]] >= 0 && se[_$_b208[1702]] > se[_$_b208[1701]];
            }
            te[_$_b208[396]] = ce;
          }, 37007: function(re) {
            _$_b208[11];
            var te, ee = _$_b208[617] == typeof Reflect ? Reflect : null, ne = ee && _$_b208[161] == typeof ee[_$_b208[22]] ? ee[_$_b208[22]] : function(Se, Ce, Ie) {
              return Function[_$_b208[21]][_$_b208[22]][_$_b208[19]](Se, Ce, Ie);
            };
            function ie(Se) {
              console && console[_$_b208[721]] && console[_$_b208[721]](Se);
            }
            te = ee && _$_b208[161] == typeof ee[_$_b208[1711]] ? ee[_$_b208[1711]] : Object[_$_b208[1712]] ? function(Se) {
              return Object[_$_b208[619]](Se)[_$_b208[94]](Object[_$_b208[1712]](Se));
            } : function(Se) {
              return Object[_$_b208[619]](Se);
            };
            var ae = Number[_$_b208[1713]] || function(Se) {
              return Se != Se;
            };
            function ce() {
              ce[_$_b208[767]][_$_b208[19]](this);
            }
            re[_$_b208[1714]] = ce, re[_$_b208[1714]][_$_b208[1715]] = ge, ce[_$_b208[1716]] = ce, ce[_$_b208[21]][_$_b208[1717]] = void 0, ce[_$_b208[21]][_$_b208[1718]] = 0, ce[_$_b208[21]][_$_b208[1719]] = void 0;
            var he = 10;
            function _e(Se) {
              if (_$_b208[161] != typeof Se)
                throw new TypeError(_$_b208[1720] + typeof Se);
            }
            function le(Se) {
              return Se[_$_b208[1719]] === void 0 ? ce[_$_b208[1721]] : Se[_$_b208[1719]];
            }
            function se(Se, Ce, Ie, Te) {
              var Ee, we, Pe;
              if (_e(Ie), (we = Se[_$_b208[1717]]) === void 0 ? (we = Se[_$_b208[1717]] = Object[_$_b208[230]](null), Se[_$_b208[1718]] = 0) : (we[_$_b208[1722]] !== void 0 && (Se[_$_b208[1724]](_$_b208[1722], Ce, Ie[_$_b208[1723]] ? Ie[_$_b208[1723]] : Ie), we = Se[_$_b208[1717]]), Pe = we[Ce]), Pe === void 0)
                Pe = we[Ce] = Ie, ++Se[_$_b208[1718]];
              else if (_$_b208[161] == typeof Pe ? Pe = we[Ce] = Te ? [Ie, Pe] : [Pe, Ie] : Te ? Pe[_$_b208[1725]](Ie) : Pe[_$_b208[141]](Ie), (Ee = le(Se)) > 0 && Pe[_$_b208[18]] > Ee && !Pe[_$_b208[1726]]) {
                Pe[_$_b208[1726]] = !0;
                var Me = new Error(_$_b208[1727] + Pe[_$_b208[18]] + _$_b208[1728] + String(Ce) + _$_b208[1729]);
                Me[_$_b208[176]] = _$_b208[1730], Me[_$_b208[1731]] = Se, Me[_$_b208[89]] = Ce, Me[_$_b208[1732]] = Pe[_$_b208[18]], ie(Me);
              }
              return Se;
            }
            function oe() {
              if (!this[_$_b208[1733]])
                return this[_$_b208[1736]][_$_b208[1735]](this[_$_b208[89]], this[_$_b208[1734]]), this[_$_b208[1733]] = !0, arguments[_$_b208[18]] === 0 ? this[_$_b208[1723]][_$_b208[19]](this[_$_b208[1736]]) : this[_$_b208[1723]][_$_b208[22]](this[_$_b208[1736]], arguments);
            }
            function ue(Se, Ce, Ie) {
              var Te = { fired: !1, wrapFn: void 0, target: Se, type: Ce, listener: Ie }, Ee = oe[_$_b208[1510]](Te);
              return Ee[_$_b208[1723]] = Ie, Te[_$_b208[1734]] = Ee, Ee;
            }
            function be(Se, Ce, Ie) {
              var Te = Se[_$_b208[1717]];
              if (Te === void 0)
                return [];
              var Ee = Te[Ce];
              return Ee === void 0 ? [] : _$_b208[161] == typeof Ee ? Ie ? [Ee[_$_b208[1723]] || Ee] : [Ee] : Ie ? fe(Ee) : me(Ee, Ee[_$_b208[18]]);
            }
            function ve(Se) {
              var Ce = this[_$_b208[1717]];
              if (Ce !== void 0) {
                var Ie = Ce[Se];
                if (_$_b208[161] == typeof Ie)
                  return 1;
                if (Ie !== void 0)
                  return Ie[_$_b208[18]];
              }
              return 0;
            }
            function me(Se, Ce) {
              for (var Ie = new Array(Ce), Te = 0; Te < Ce; ++Te)
                Ie[Te] = Se[Te];
              return Ie;
            }
            function pe(Se, Ce) {
              for (; Ce + 1 < Se[_$_b208[18]]; Ce++)
                Se[Ce] = Se[Ce + 1];
              Se[_$_b208[1737]]();
            }
            function fe(Se) {
              for (var Ce = new Array(Se[_$_b208[18]]), Ie = 0; Ie < Ce[_$_b208[18]]; ++Ie)
                Ce[Ie] = Se[Ie][_$_b208[1723]] || Se[Ie];
              return Ce;
            }
            function ge(Se, Ce) {
              return new Promise(function(Ie, Te) {
                function Ee(Pe) {
                  Se[_$_b208[1735]](Ce, we), Te(Pe);
                }
                function we() {
                  _$_b208[161] == typeof Se[_$_b208[1735]] && Se[_$_b208[1735]](_$_b208[90], Ee), Ie([][_$_b208[630]][_$_b208[19]](arguments));
                }
                $e(Se, Ce, we, { once: !0 }), _$_b208[90] !== Ce && ye(Se, Ee, { once: !0 });
              });
            }
            function ye(Se, Ce, Ie) {
              _$_b208[161] == typeof Se[_$_b208[404]] && $e(Se, _$_b208[90], Ce, Ie);
            }
            function $e(Se, Ce, Ie, Te) {
              if (_$_b208[161] == typeof Se[_$_b208[404]])
                Te[_$_b208[1715]] ? Se[_$_b208[1715]](Ce, Ie) : Se[_$_b208[404]](Ce, Ie);
              else {
                if (_$_b208[161] != typeof Se[_$_b208[100]])
                  throw new TypeError(_$_b208[1738] + typeof Se);
                Se[_$_b208[100]](Ce, function Ee(we) {
                  Te[_$_b208[1715]] && Se[_$_b208[105]](Ce, Ee), Ie(we);
                });
              }
            }
            Object[_$_b208[13]](ce, _$_b208[1721], { enumerable: !0, get: function() {
              return he;
            }, set: function(Se) {
              if (_$_b208[885] != typeof Se || Se < 0 || ae(Se))
                throw new RangeError(_$_b208[1739] + Se + _$_b208[1117]);
              he = Se;
            } }), ce[_$_b208[767]] = function() {
              this[_$_b208[1717]] !== void 0 && this[_$_b208[1717]] !== Object[_$_b208[1740]](this)[_$_b208[1717]] || (this[_$_b208[1717]] = Object[_$_b208[230]](null), this[_$_b208[1718]] = 0), this[_$_b208[1719]] = this[_$_b208[1719]] || void 0;
            }, ce[_$_b208[21]][_$_b208[1741]] = function(Se) {
              if (_$_b208[885] != typeof Se || Se < 0 || ae(Se))
                throw new RangeError(_$_b208[1742] + Se + _$_b208[1117]);
              return this[_$_b208[1719]] = Se, this;
            }, ce[_$_b208[21]][_$_b208[1743]] = function() {
              return le(this);
            }, ce[_$_b208[21]][_$_b208[1724]] = function(Se) {
              for (var Ce = [], Ie = 1; Ie < arguments[_$_b208[18]]; Ie++)
                Ce[_$_b208[141]](arguments[Ie]);
              var Te = _$_b208[90] === Se, Ee = this[_$_b208[1717]];
              if (Ee !== void 0)
                Te = Te && Ee[_$_b208[90]] === void 0;
              else if (!Te)
                return !1;
              if (Te) {
                var we;
                if (Ce[_$_b208[18]] > 0 && (we = Ce[0]), we instanceof Error)
                  throw we;
                var Pe = new Error(_$_b208[1744] + (we ? _$_b208[1745] + we[_$_b208[119]] + _$_b208[1746] : _$_b208[265]));
                throw Pe[_$_b208[46]] = we, Pe;
              }
              var Me = Ee[Se];
              if (Me === void 0)
                return !1;
              if (_$_b208[161] == typeof Me)
                ne(Me, this, Ce);
              else {
                var Ae = Me[_$_b208[18]], Oe = me(Me, Ae);
                for (Ie = 0; Ie < Ae; ++Ie)
                  ne(Oe[Ie], this, Ce);
              }
              return !0;
            }, ce[_$_b208[21]][_$_b208[1747]] = function(Se, Ce) {
              return se(this, Se, Ce, !1);
            }, ce[_$_b208[21]][_$_b208[404]] = ce[_$_b208[21]][_$_b208[1747]], ce[_$_b208[21]][_$_b208[1748]] = function(Se, Ce) {
              return se(this, Se, Ce, !0);
            }, ce[_$_b208[21]][_$_b208[1715]] = function(Se, Ce) {
              return _e(Ce), this[_$_b208[404]](Se, ue(this, Se, Ce)), this;
            }, ce[_$_b208[21]][_$_b208[1749]] = function(Se, Ce) {
              return _e(Ce), this[_$_b208[1748]](Se, ue(this, Se, Ce)), this;
            }, ce[_$_b208[21]][_$_b208[1735]] = function(Se, Ce) {
              var Ie, Te, Ee, we, Pe;
              if (_e(Ce), (Te = this[_$_b208[1717]]) === void 0)
                return this;
              if ((Ie = Te[Se]) === void 0)
                return this;
              if (Ie === Ce || Ie[_$_b208[1723]] === Ce)
                --this[_$_b208[1718]] == 0 ? this[_$_b208[1717]] = Object[_$_b208[230]](null) : (delete Te[Se], Te[_$_b208[1735]] && this[_$_b208[1724]](_$_b208[1735], Se, Ie[_$_b208[1723]] || Ce));
              else if (_$_b208[161] != typeof Ie) {
                for (Ee = -1, we = Ie[_$_b208[18]] - 1; we >= 0; we--)
                  if (Ie[we] === Ce || Ie[we][_$_b208[1723]] === Ce) {
                    Pe = Ie[we][_$_b208[1723]], Ee = we;
                    break;
                  }
                if (Ee < 0)
                  return this;
                Ee === 0 ? Ie[_$_b208[1750]]() : pe(Ie, Ee), Ie[_$_b208[18]] === 1 && (Te[Se] = Ie[0]), Te[_$_b208[1735]] !== void 0 && this[_$_b208[1724]](_$_b208[1735], Se, Pe || Ce);
              }
              return this;
            }, ce[_$_b208[21]][_$_b208[688]] = ce[_$_b208[21]][_$_b208[1735]], ce[_$_b208[21]][_$_b208[1751]] = function(Se) {
              var Ce, Ie, Te;
              if ((Ie = this[_$_b208[1717]]) === void 0)
                return this;
              if (Ie[_$_b208[1735]] === void 0)
                return arguments[_$_b208[18]] === 0 ? (this[_$_b208[1717]] = Object[_$_b208[230]](null), this[_$_b208[1718]] = 0) : Ie[Se] !== void 0 && (--this[_$_b208[1718]] == 0 ? this[_$_b208[1717]] = Object[_$_b208[230]](null) : delete Ie[Se]), this;
              if (arguments[_$_b208[18]] === 0) {
                var Ee, we = Object[_$_b208[69]](Ie);
                for (Te = 0; Te < we[_$_b208[18]]; ++Te)
                  _$_b208[1735] !== (Ee = we[Te]) && this[_$_b208[1751]](Ee);
                return this[_$_b208[1751]](_$_b208[1735]), this[_$_b208[1717]] = Object[_$_b208[230]](null), this[_$_b208[1718]] = 0, this;
              }
              if (_$_b208[161] == typeof (Ce = Ie[Se]))
                this[_$_b208[1735]](Se, Ce);
              else if (Ce !== void 0)
                for (Te = Ce[_$_b208[18]] - 1; Te >= 0; Te--)
                  this[_$_b208[1735]](Se, Ce[Te]);
              return this;
            }, ce[_$_b208[21]][_$_b208[401]] = function(Se) {
              return be(this, Se, !0);
            }, ce[_$_b208[21]][_$_b208[1752]] = function(Se) {
              return be(this, Se, !1);
            }, ce[_$_b208[1753]] = function(Se, Ce) {
              return _$_b208[161] == typeof Se[_$_b208[1753]] ? Se[_$_b208[1753]](Ce) : ve[_$_b208[19]](Se, Ce);
            }, ce[_$_b208[21]][_$_b208[1753]] = ve, ce[_$_b208[21]][_$_b208[1754]] = function() {
              return this[_$_b208[1718]] > 0 ? te(this[_$_b208[1717]]) : [];
            };
          }, 37233: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1755]] = ae;
            var ne = ee(15231), ie = ee(79463);
            function ae(ce) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1757]][_$_b208[1756]], ce);
            }
          }, 38255: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1758]] = void 0;
            var ee = function() {
              function ne() {
                this[_$_b208[124]] = /* @__PURE__ */ new Map();
              }
              return ne[_$_b208[21]][_$_b208[199]] = function(ie) {
                return this[_$_b208[124]][_$_b208[199]](ie);
              }, ne[_$_b208[21]][_$_b208[22]] = function(ie, ae) {
                this[_$_b208[124]][_$_b208[196]](ie) && this[_$_b208[124]][_$_b208[361]](ie, ae(this[_$_b208[124]][_$_b208[199]](ie)));
              }, ne[_$_b208[21]][_$_b208[196]] = function(ie) {
                return this[_$_b208[124]][_$_b208[196]](ie);
              }, ne[_$_b208[21]][_$_b208[362]] = function(ie) {
                return this[_$_b208[124]][_$_b208[362]](ie);
              }, ne[_$_b208[21]][_$_b208[425]] = function() {
                this[_$_b208[124]][_$_b208[425]]();
              }, Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[1759], { get: function() {
                return this[_$_b208[124]][_$_b208[1759]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[18], { get: function() {
                var ie = 0;
                return this[_$_b208[124]][_$_b208[68]](function(ae) {
                  return ie += ae[_$_b208[18]];
                }), ie;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[1111], { get: function() {
                var ie = [];
                return this[_$_b208[124]][_$_b208[68]](function(ae) {
                  ie[_$_b208[141]](ae);
                }), ie;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ne[_$_b208[21]], _$_b208[69], { get: function() {
                var ie = [];
                return this[_$_b208[124]][_$_b208[68]](function(ae, ce) {
                  ie[_$_b208[141]](ce);
                }), ie;
              }, enumerable: !1, configurable: !0 }), ne[_$_b208[21]][_$_b208[60]] = function(ie, ae) {
                return this[_$_b208[1760]](ie), ae != null && this[_$_b208[199]](ie)[_$_b208[141]](ae), this;
              }, ne[_$_b208[21]][_$_b208[1760]] = function(ie) {
                this[_$_b208[196]](ie) || this[_$_b208[361]](ie, []);
              }, ne[_$_b208[21]][_$_b208[361]] = function(ie, ae) {
                return this[_$_b208[124]][_$_b208[361]](ie, ae), this;
              }, ne[_$_b208[21]][_$_b208[1761]] = function(ie, ae) {
                var ce = this;
                this[_$_b208[1760]](ie), ae[_$_b208[68]](function(he) {
                  return ce[_$_b208[60]](ie, he);
                });
              }, ne[_$_b208[21]][_$_b208[1762]] = function() {
                var ie = {};
                return this[_$_b208[124]][_$_b208[68]](function(ae, ce) {
                  ie[ce] = ae;
                }), ie;
              }, ne[_$_b208[21]][_$_b208[1763]] = function(ie) {
                this[_$_b208[124]][_$_b208[68]](function(ae, ce) {
                  return ae[_$_b208[68]](function(he) {
                    return ie(ce, he);
                  });
                });
              }, ne[_$_b208[21]][_$_b208[1764]] = function(ie) {
                this[_$_b208[124]][_$_b208[68]](function(ae) {
                  ae[_$_b208[1764]](ie);
                });
              }, ne[_$_b208[21]][_$_b208[1765]] = function(ie) {
                var ae = new ne();
                return this[_$_b208[124]][_$_b208[68]](function(ce, he) {
                  return ae[_$_b208[361]](he, ce[_$_b208[124]](ie));
                }), ae;
              }, ne[_$_b208[21]][_$_b208[1766]] = function(ie) {
                var ae = [];
                return this[_$_b208[124]][_$_b208[68]](function(ce) {
                  return ae[_$_b208[141]](ie(ce));
                }), ae;
              }, ne[_$_b208[21]][_$_b208[1767]] = function(ie) {
                var ae = new ne();
                return this[_$_b208[124]][_$_b208[68]](function(ce, he) {
                  return ae[_$_b208[361]](he, ie(ce));
                }), ae;
              }, ne[_$_b208[21]][_$_b208[1768]] = function() {
                var ie = [];
                return this[_$_b208[124]][_$_b208[68]](function(ae) {
                  return ie[_$_b208[141]][_$_b208[22]](ie, ae);
                }), ie;
              }, ne[_$_b208[21]][_$_b208[1769]] = function(ie, ae) {
                if (!this[_$_b208[196]](ie))
                  return !1;
                var ce = this[_$_b208[124]][_$_b208[199]](ie), he = ce[_$_b208[138]](ae);
                return he >= 0 && (ce[_$_b208[139]](he, 1), !0);
              }, ne;
            }();
            te[_$_b208[1758]] = ee;
          }, 38261: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[754]] = void 0;
            var ee = function() {
              function ne(ie) {
                this[_$_b208[1770]] = ie, this[_$_b208[1771]] = _$_b208[1772], this[_$_b208[1489]] = {}, this[_$_b208[1773]] = function() {
                  var ae = 366, ce = /* @__PURE__ */ new Date();
                  return ce[_$_b208[1775]](ce[_$_b208[1774]]() + 864e5 * ae), _$_b208[1776] + ce[_$_b208[1777]]();
                }(), this[_$_b208[244]]();
              }
              return ne[_$_b208[21]][_$_b208[199]] = function(ie) {
                return this[_$_b208[1489]][ie];
              }, ne[_$_b208[21]][_$_b208[361]] = function(ie, ae) {
                this[_$_b208[1489]][ie] = ae, this[_$_b208[1778]]();
              }, ne[_$_b208[21]][_$_b208[979]] = function(ie) {
                this[_$_b208[1779]] = ie;
              }, ne[_$_b208[21]][_$_b208[1780]] = function(ie) {
                var ae = this[_$_b208[1781]]();
                if (!ae)
                  return _$_b208[265];
                for (var ce = ie + _$_b208[1782], he = ae[_$_b208[258]](_$_b208[1783]), _e = 0; _e < he[_$_b208[18]]; _e++) {
                  for (var le = he[_e]; _$_b208[1728] === le[_$_b208[1784]](0); )
                    le = le[_$_b208[259]](1);
                  if (le[_$_b208[138]](ce) === 0)
                    return le[_$_b208[259]](ce[_$_b208[18]], le[_$_b208[18]]);
                }
                return _$_b208[265];
              }, ne[_$_b208[21]][_$_b208[1781]] = function() {
                try {
                  return document[_$_b208[1785]];
                } catch {
                  return _$_b208[265];
                }
              }, ne[_$_b208[21]][_$_b208[1786]] = function(ie) {
                if (ie)
                  try {
                    this[_$_b208[1489]] = JSON[_$_b208[1035]](ie);
                  } catch {
                  }
              }, ne[_$_b208[21]][_$_b208[244]] = function() {
                this[_$_b208[1770]] ? this[_$_b208[1786]](localStorage[_$_b208[1787]](this[_$_b208[1771]])) : this[_$_b208[1786]](this[_$_b208[1780]](this[_$_b208[1771]]));
              }, ne[_$_b208[21]][_$_b208[1778]] = function() {
                if (!this[_$_b208[1779]])
                  try {
                    this[_$_b208[1770]] ? localStorage[_$_b208[1788]](this[_$_b208[1771]], JSON[_$_b208[1012]](this[_$_b208[1489]])) : document[_$_b208[1785]] = this[_$_b208[1771]] + _$_b208[1782] + JSON[_$_b208[1012]](this[_$_b208[1489]]) + _$_b208[1789] + this[_$_b208[1773]];
                  } catch {
                  }
              }, ne;
            }();
            te[_$_b208[754]] = ee;
          }, 39210: function(re, te, ee) {
            _$_b208[11];
            var ne, ie = this && this[_$_b208[16]] || function() {
              return ie = Object[_$_b208[17]] || function(se) {
                for (var oe, ue = 1, be = arguments[_$_b208[18]]; ue < be; ue++)
                  for (var ve in oe = arguments[ue])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](oe, ve) && (se[ve] = oe[ve]);
                return se;
              }, ie[_$_b208[22]](this, arguments);
            }, ae = this && this[_$_b208[629]] || function(se, oe, ue) {
              if (ue || arguments[_$_b208[18]] === 2)
                for (var be, ve = 0, me = oe[_$_b208[18]]; ve < me; ve++)
                  !be && ve in oe || (be || (be = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](oe, 0, ve)), be[ve] = oe[ve]);
              return se[_$_b208[94]](be || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](oe));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[527]] = void 0;
            var ce = ee(21829), he = ee(79463), _e = { domains: [] };
            function le(se, oe) {
              return ie(ie({}, se), { domains: se[_$_b208[255]][_$_b208[26]](oe) ? se[_$_b208[255]] : ae(ae([], se[_$_b208[255]], !0), [oe], !1) });
            }
            te[_$_b208[527]] = (0, ce[_$_b208[302]])(_e, ((ne = {})[he[_$_b208[1757]][_$_b208[1756]]] = function(se, oe) {
              return le(se, oe[_$_b208[1464]]);
            }, ne));
          }, 39999: function(re, te) {
            _$_b208[11];
            function ee(ne, ie) {
              var ae = [_$_b208[693], _$_b208[549], _$_b208[550], _$_b208[1790]], ce = function() {
                return ie(ne[_$_b208[1169]], ne[_$_b208[1170]]);
              }, he = new MutationObserver(ce);
              return { observe: function() {
                he[_$_b208[579]](ne, { attributes: !0, attributeFilter: ae, childList: !1, subtree: !0 }), window[_$_b208[100]](_$_b208[1791], ce);
              }, dispose: function() {
                he[_$_b208[1792]](), window[_$_b208[105]](_$_b208[1791], ce);
              } };
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[578]] = ee;
          }, 40362: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[844]] = void 0, function(ne) {
              ne[_$_b208[1673]] = _$_b208[1793], ne[_$_b208[843]] = _$_b208[1794], ne[_$_b208[1685]] = _$_b208[1795], ne[_$_b208[961]] = _$_b208[1796];
            }(ee || (te[_$_b208[844]] = ee = {}));
          }, 41108: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[224]] || function() {
              var ce = function(he, _e) {
                return ce = Object[_$_b208[225]] || { __proto__: [] } instanceof Array && function(le, se) {
                  le[_$_b208[226]] = se;
                } || function(le, se) {
                  for (var oe in se)
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](se, oe) && (le[oe] = se[oe]);
                }, ce(he, _e);
              };
              return function(he, _e) {
                if (_$_b208[161] != typeof _e && _e !== null)
                  throw new TypeError(_$_b208[227] + String(_e) + _$_b208[228]);
                function le() {
                  this[_$_b208[229]] = he;
                }
                ce(he, _e), he[_$_b208[21]] = _e === null ? Object[_$_b208[230]](_e) : (le[_$_b208[21]] = _e[_$_b208[21]], new le());
              };
            }();
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1797]] = void 0;
            var ie = ee(25550), ae = function(ce) {
              function he(_e, le) {
                return le ? ce[_$_b208[19]](this, ie[_$_b208[369]][_$_b208[1447]], { name: _e, dependency: le }, _$_b208[1800][_$_b208[94]](_e, _$_b208[1799])[_$_b208[94]](le, _$_b208[1798])) || this : ce[_$_b208[19]](this, ie[_$_b208[369]][_$_b208[1446]], { name: _e }, _$_b208[1800][_$_b208[94]](_e, _$_b208[1801])) || this;
              }
              return ne(he, ce), he;
            }(ee(28764)[_$_b208[720]]);
            te[_$_b208[1797]] = ae;
          }, 42055: function(re, te, ee) {
            _$_b208[11];
            var ne, ie = this && this[_$_b208[16]] || function() {
              return ie = Object[_$_b208[17]] || function(oe) {
                for (var ue, be = 1, ve = arguments[_$_b208[18]]; be < ve; be++)
                  for (var me in ue = arguments[be])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](ue, me) && (oe[me] = ue[me]);
                return oe;
              }, ie[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[622]] = void 0, te[_$_b208[1802]] = se;
            var ae = ee(21829), ce = ee(95328), he = ee(80618), _e = ce[_$_b208[1803]], le = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), be);
            };
            function se(oe) {
              return oe[_$_b208[1805]][_$_b208[1804]];
            }
            te[_$_b208[622]] = (0, ae[_$_b208[302]])(_e, ((ne = {})[he[_$_b208[1807]][_$_b208[1806]]] = le, ne[he[_$_b208[1807]][_$_b208[1808]]] = le, ne));
          }, 42283: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[629]] || function(oe, ue, be) {
              if (be || arguments[_$_b208[18]] === 2)
                for (var ve, me = 0, pe = ue[_$_b208[18]]; me < pe; me++)
                  !ve && me in ue || (ve || (ve = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](ue, 0, me)), ve[me] = ue[me]);
              return oe[_$_b208[94]](ve || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](ue));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1809]] = void 0, te[_$_b208[1810]] = he, te[_$_b208[1811]] = _e, te[_$_b208[1812]] = le;
            var ie = ee(33696), ae = ee(10676), ce = function() {
              function oe() {
              }
              return oe[_$_b208[1813]] = function(ue) {
                return oe[_$_b208[1815]][_$_b208[1814]](ue);
              }, oe[_$_b208[1816]] = function(ue) {
                var be, ve = ue[_$_b208[258]](_$_b208[1117]);
                return ve[_$_b208[18]] > 2 ? (be = ve[_$_b208[1750]]() + _$_b208[1117], be += parseInt(ve[_$_b208[1750]]())[_$_b208[118]](16), be += (_$_b208[1817] + parseInt(ve[_$_b208[1750]]())[_$_b208[118]](16))[_$_b208[630]](-4)) : be = ue, be;
              }, oe[_$_b208[1818]] = function(ue, be, ve) {
                return ue[_$_b208[1819]](be, ve);
              }, oe[_$_b208[1820]] = function(ue) {
                return oe[_$_b208[1821]] || (oe[_$_b208[1821]] = (0, ae[_$_b208[426]])(se)), oe[_$_b208[1821]](ue);
              }, oe[_$_b208[1822]] = function(ue) {
                if (!ue)
                  return _$_b208[1796];
                for (var be = 0, ve = oe[_$_b208[1823]]; be < ve[_$_b208[18]]; be++) {
                  var me = ve[be];
                  if (oe[_$_b208[1824]][me][_$_b208[164]](function(pe) {
                    return ue[_$_b208[138]](pe) > -1;
                  }))
                    return me;
                }
                return _$_b208[1796];
              }, oe[_$_b208[1825]] = function(ue, be) {
                var ve;
                oe[_$_b208[1824]][ue][_$_b208[141]](be), (ve = oe[_$_b208[1821]]) === null || ve === void 0 || ve[_$_b208[424]]();
              }, oe[_$_b208[1826]] = function(ue, be) {
                return ue === be || [[_$_b208[1827], _$_b208[1828]], [_$_b208[1829], _$_b208[1830], _$_b208[1831]], [_$_b208[1832], _$_b208[1833], _$_b208[1834]]][_$_b208[610]](function(ve) {
                  return ve[_$_b208[26]](ue) && ve[_$_b208[26]](be);
                });
              }, oe[_$_b208[1835]] = function(ue) {
                return ue ? ue[_$_b208[258]](_$_b208[1117])[0] : null;
              }, oe[_$_b208[1836]] = function(ue) {
                return _$_b208[214] === oe[_$_b208[1822]](ue);
              }, oe[_$_b208[1837]] = function(ue) {
                return _$_b208[1567] === oe[_$_b208[1822]](ue);
              }, oe[_$_b208[1838]] = function(ue) {
                return _$_b208[1839] === oe[_$_b208[1822]](ue);
              }, oe[_$_b208[1815]] = new RegExp(_$_b208[1840]), oe[_$_b208[1823]] = [_$_b208[214], _$_b208[1567], _$_b208[1839]], oe[_$_b208[1824]] = { video: [_$_b208[1841], _$_b208[1842], _$_b208[1843], _$_b208[1844], _$_b208[1845], _$_b208[1846], _$_b208[1847], _$_b208[1848], _$_b208[1849], _$_b208[1850], _$_b208[1851], _$_b208[1852], _$_b208[1853], _$_b208[1854], _$_b208[1855], _$_b208[1856]], audio: [_$_b208[1857], _$_b208[1858], _$_b208[1859], _$_b208[1860], _$_b208[1861], _$_b208[1862], _$_b208[1863], _$_b208[1829], _$_b208[1832], _$_b208[1864], _$_b208[1865]], application: [_$_b208[1866], _$_b208[1867], _$_b208[1868]] }, oe;
            }();
            function he(oe) {
              return !!oe && oe[_$_b208[138]](_$_b208[257]) > -1;
            }
            function _e(oe, ue) {
              if (!ue)
                return null;
              for (var be = ne([], ue[_$_b208[1869]], !0); be[be[_$_b208[18]] - 1] === 0; )
                be[_$_b208[1737]]();
              var ve = be[_$_b208[124]](function(me) {
                return me[_$_b208[118]](16)[_$_b208[609]]();
              });
              return ne([oe, _$_b208[265][_$_b208[94]]([_$_b208[265], _$_b208[1872], _$_b208[1873], _$_b208[1874]][ue[_$_b208[1871]]])[_$_b208[94]](ue[_$_b208[1870]]), _$_b208[265][_$_b208[94]](ue[_$_b208[1875]]), _$_b208[265][_$_b208[94]](ue[_$_b208[1877]] === 0 ? _$_b208[1878] : _$_b208[1879])[_$_b208[94]](ue[_$_b208[1876]])], ve, !0)[_$_b208[122]](_$_b208[1117]);
            }
            function le(oe) {
              return ce[_$_b208[1836]](oe) ? ie[_$_b208[874]][_$_b208[873]] : ce[_$_b208[1837]](oe) ? ie[_$_b208[874]][_$_b208[906]] : ce[_$_b208[1838]](oe) ? ie[_$_b208[874]][_$_b208[1120]] : void 0;
            }
            function se(oe) {
              return oe || _$_b208[348] == typeof oe ? oe[_$_b208[258]](_$_b208[257])[_$_b208[1277]](function(ue, be) {
                return be = be[_$_b208[1695]](), ue[ce[_$_b208[1822]](be)] = be, ue;
              }, {}) : {};
            }
            te[_$_b208[1809]] = ce;
          }, 43485: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[629]] || function(Ue, Re, Ne) {
              if (Ne || arguments[_$_b208[18]] === 2)
                for (var xe, ke = 0, Le = Re[_$_b208[18]]; ke < Le; ke++)
                  !xe && ke in Re || (xe || (xe = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](Re, 0, ke)), xe[ke] = Re[ke]);
              return Ue[_$_b208[94]](xe || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](Re));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[466]] = te[_$_b208[1236]] = te[_$_b208[1500]] = te[_$_b208[1501]] = te[_$_b208[1502]] = te[_$_b208[467]] = te[_$_b208[468]] = te[_$_b208[1880]] = te[_$_b208[1881]] = te[_$_b208[1882]] = te[_$_b208[1883]] = te[_$_b208[1884]] = void 0, te[_$_b208[1885]] = Ie, te[_$_b208[1886]] = Be;
            var ie, ae = ee(91520), ce = ee(16368), he = ee(33696), _e = ee(13533), le = ee(87093), se = ee(79814), oe = ee(56435);
            (function(Ue) {
              Ue[_$_b208[1887]] = _$_b208[1888], Ue[_$_b208[1889]] = _$_b208[1890];
            })(ie || (te[_$_b208[1884]] = ie = {}));
            var ue = [{ player: he[_$_b208[844]][_$_b208[1673]], streaming: he[_$_b208[782]][_$_b208[781]] }, { player: he[_$_b208[844]][_$_b208[1673]], streaming: he[_$_b208[782]][_$_b208[784]] }, { player: he[_$_b208[844]][_$_b208[1673]], streaming: he[_$_b208[782]][_$_b208[788]] }, { player: he[_$_b208[844]][_$_b208[1685]], streaming: he[_$_b208[782]][_$_b208[790]] }, { player: he[_$_b208[844]][_$_b208[843]], streaming: he[_$_b208[782]][_$_b208[784]] }, { player: he[_$_b208[844]][_$_b208[843]], streaming: he[_$_b208[782]][_$_b208[786]] }], be = !0, ve = !!(le[_$_b208[302]][_$_b208[1891]] && le[_$_b208[302]][_$_b208[1892]] && le[_$_b208[302]][_$_b208[1893]]), me = function() {
              return _$_b208[161] == typeof document[_$_b208[796]](_$_b208[214])[_$_b208[1530]];
            }, pe = function() {
              var Ue = document[_$_b208[796]](_$_b208[214]);
              return Ue && _$_b208[161] == typeof Ue[_$_b208[1530]] && (_$_b208[1894] === Ue[_$_b208[1530]](_$_b208[1895]) || _$_b208[1894] === Ue[_$_b208[1530]](_$_b208[1896]) || _$_b208[1894] === Ue[_$_b208[1530]](_$_b208[1897]) || _$_b208[1894] === Ue[_$_b208[1530]](_$_b208[1898]));
            }, fe = function() {
              var Ue, Re, Ne, xe = _$_b208[1899] in le[_$_b208[302]] && _$_b208[161] == typeof ((Ue = le[_$_b208[302]][_$_b208[1899]]) === null || Ue === void 0 ? void 0 : Ue[_$_b208[1900]]), ke = _$_b208[1901] in le[_$_b208[302]] && _$_b208[161] == typeof ((Re = le[_$_b208[302]][_$_b208[1901]]) === null || Re === void 0 ? void 0 : Re[_$_b208[1900]]), Le = _$_b208[1902] in le[_$_b208[302]] && _$_b208[161] == typeof ((Ne = le[_$_b208[302]][_$_b208[1902]]) === null || Ne === void 0 ? void 0 : Ne[_$_b208[1900]]);
              return xe || ke || Le;
            };
            te[_$_b208[1883]] = fe;
            var ge = function() {
              var Ue = le[_$_b208[302]][_$_b208[1903]], Re = !!Ue && _$_b208[161] == typeof Ue[_$_b208[21]][_$_b208[1904]];
              return ye() && Re;
            }, ye = function() {
              var Ue, Re, Ne, xe, ke;
              return !!((ke = (xe = (Ne = (Re = (Ue = navigator[_$_b208[1905]]) === null || Ue === void 0 ? void 0 : Ue[_$_b208[1906]]) !== null && Re !== void 0 ? Re : navigator[_$_b208[1906]]) !== null && Ne !== void 0 ? Ne : navigator[_$_b208[1907]]) !== null && xe !== void 0 ? xe : navigator[_$_b208[1908]]) !== null && ke !== void 0 ? ke : navigator[_$_b208[1909]]);
            }, $e = function() {
              var Ue = [];
              if (ve ? Ue = ue[_$_b208[165]](function(Ne) {
                return (0, te[_$_b208[1881]])(Ne[_$_b208[769]], Ne[_$_b208[780]]);
              }) : Ue[_$_b208[141]]({ player: he[_$_b208[844]][_$_b208[843]], streaming: he[_$_b208[782]][_$_b208[786]] }), (0, oe[_$_b208[189]])()) {
                for (var Re = 1; Re < Ue[_$_b208[18]]; Re++)
                  if (Ue[Re][_$_b208[769]] === he[_$_b208[844]][_$_b208[843]] && Ue[Re][_$_b208[780]] === he[_$_b208[782]][_$_b208[784]]) {
                    Ue = Ue[_$_b208[139]](Re, 1)[_$_b208[94]](Ue);
                    break;
                  }
              }
              return Ue;
            };
            te[_$_b208[1882]] = $e;
            var Se = function(Ue, Re) {
              var Ne = (0, te[_$_b208[1883]])() ? [he[_$_b208[782]][_$_b208[781]], he[_$_b208[782]][_$_b208[784]], he[_$_b208[782]][_$_b208[788]]] : [], xe = ge() ? [he[_$_b208[782]][_$_b208[790]]] : [], ke = function() {
                var He = [];
                return pe() && !(0, oe[_$_b208[463]])() && He[_$_b208[141]](he[_$_b208[782]][_$_b208[784]]), me() && be && He[_$_b208[141]](he[_$_b208[782]][_$_b208[786]]), He;
              }, Le = function(He) {
                return He[_$_b208[610]](function(We) {
                  return We === Re;
                });
              };
              switch (Ue) {
                case he[_$_b208[844]][_$_b208[1673]]:
                  return Le(Ne);
                case he[_$_b208[844]][_$_b208[1685]]:
                  return Le(xe);
                case he[_$_b208[844]][_$_b208[843]]:
                  return Le(ke());
                default:
                  return !1;
              }
            };
            te[_$_b208[1881]] = Se;
            var Ce = function() {
              return Object[_$_b208[1111]](ie)[_$_b208[610]](function(Ue) {
                var Re;
                return (Re = le[_$_b208[302]][_$_b208[1910]]) === null || Re === void 0 ? void 0 : Re[_$_b208[1900]](Ue, se[_$_b208[1216]][_$_b208[1911]]);
              });
            };
            function Ie() {
              return _$_b208[1912] === le[_$_b208[302]][_$_b208[10]][_$_b208[1913]];
            }
            te[_$_b208[1880]] = Ce;
            var Te = function() {
              var Ue = (0, oe[_$_b208[1496]])(), Re = Ue < oe[_$_b208[1914]] && /iPad/i[_$_b208[1814]](navigator[_$_b208[1915]]), Ne = Ue < oe[_$_b208[1916]] && /iP(hone|od)/i[_$_b208[1814]](navigator[_$_b208[1915]]);
              return oe[_$_b208[462]] && (Re || Ne);
            };
            te[_$_b208[468]] = Te;
            var Ee = function() {
              try {
                return le[_$_b208[302]][_$_b208[1917]] && _$_b208[161] == typeof localStorage[_$_b208[1787]] && _$_b208[161] == typeof localStorage[_$_b208[1788]];
              } catch {
                return !1;
              }
            };
            te[_$_b208[467]] = Ee;
            var we = function() {
              var Ue = (0, te[_$_b208[1500]])(), Re = (0, te[_$_b208[1501]])(), Ne = function(xe, ke) {
                return xe[_$_b208[769]] === ke[_$_b208[769]] && xe[_$_b208[780]] === ke[_$_b208[780]];
              };
              return Re[_$_b208[165]](function(xe) {
                return Ue[_$_b208[165]](function(ke) {
                  return Ne(ke, xe);
                })[_$_b208[18]] > 0;
              });
            };
            te[_$_b208[1502]] = we;
            var Pe = function() {
              return (0, te[_$_b208[1882]])();
            };
            te[_$_b208[1501]] = Pe;
            var Me = function() {
              var Ue = ae[_$_b208[197]][_$_b208[196]](ce[_$_b208[195]][_$_b208[1201]]) ? ae[_$_b208[197]][_$_b208[199]](ce[_$_b208[195]][_$_b208[1201]])[_$_b208[1919]][_$_b208[1918]]() : [], Re = ae[_$_b208[197]][_$_b208[196]](ce[_$_b208[195]][_$_b208[1253]]) ? ae[_$_b208[197]][_$_b208[199]](ce[_$_b208[195]][_$_b208[1253]])[_$_b208[1919]][_$_b208[1918]]() : [], Ne = ae[_$_b208[197]][_$_b208[196]](ce[_$_b208[195]][_$_b208[1270]]) ? ae[_$_b208[197]][_$_b208[199]](ce[_$_b208[195]][_$_b208[1270]])[_$_b208[1919]][_$_b208[1918]]() : [];
              return ne(ne(ne([], Ue, !0), Re, !0), Ne, !0);
            };
            te[_$_b208[1500]] = Me;
            var Ae = function(Ue) {
              var Re = (0, _e[_$_b208[191]])(), Ne = ne([], Re[_$_b208[474]], !0);
              if (!Ue || Ue[_$_b208[18]] === 0)
                return Ne;
              var xe = Ue[_$_b208[165]](function(ke) {
                return Ne[_$_b208[610]](function(Le, He) {
                  var We, Xe = ke[_$_b208[769]] === Le[_$_b208[769]] && ke[_$_b208[780]] === Le[_$_b208[780]], Qe = (We = ke[_$_b208[1670]]) !== null && We !== void 0 && We;
                  return Xe && Ne[_$_b208[139]](He, 1), Xe && !Qe;
                });
              })[_$_b208[124]](function(ke) {
                return { player: ke[_$_b208[769]], streaming: ke[_$_b208[780]] };
              });
              return ne(ne([], xe, !0), Ne, !0);
            }, Oe = function(Ue, Re, Ne) {
              Ue === void 0 && (Ue = []), Re === void 0 && (Re = {});
              var xe = (0, _e[_$_b208[191]])(), ke = Ae(Ue), Le = xe[_$_b208[474]];
              return Ne && (ke = Le[_$_b208[165]](function(He) {
                return He[_$_b208[769]] === Ne[_$_b208[769]] && He[_$_b208[780]] === Ne[_$_b208[780]];
              })), (Re[_$_b208[680]] && ((0, oe[_$_b208[462]])() || (0, oe[_$_b208[189]])()) ? ke[_$_b208[165]](function(He) {
                var We = He[_$_b208[780]] === he[_$_b208[782]][_$_b208[786]] && He[_$_b208[769]] === he[_$_b208[844]][_$_b208[843]], Xe = He[_$_b208[780]] === he[_$_b208[782]][_$_b208[784]] && He[_$_b208[769]] === he[_$_b208[844]][_$_b208[843]];
                return We || Xe && (!(0, oe[_$_b208[462]])() || (0, oe[_$_b208[1496]])() > oe[_$_b208[1914]]);
              }) : ke)[_$_b208[164]](function(He) {
                return !!Re[He[_$_b208[780]]];
              });
            };
            function Be() {
              return _$_b208[161] == typeof le[_$_b208[302]][_$_b208[1920]] && _$_b208[161] == typeof le[_$_b208[302]][_$_b208[1921]];
            }
            te[_$_b208[1236]] = Oe;
            var Ve = function() {
              return (0, oe[_$_b208[189]])() && (0, te[_$_b208[1883]])();
            };
            te[_$_b208[466]] = Ve;
          }, 44388: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1922]] = void 0;
            var ee = function() {
              function ne() {
              }
              return ne[_$_b208[1923]] = function(ie) {
                if (_$_b208[348] != typeof ie)
                  return NaN;
                var ae = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?(T)?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*|Infinity)S)?/[_$_b208[1924]](ie);
                if (ae) {
                  var ce = !!ae[1], he = 12 * parseFloat(ae[2] || _$_b208[248]) * 30 * 24 * 60 * 60, _e = 30 * parseFloat(ae[4] || _$_b208[248]) * 24 * 60 * 60, le = 24 * parseFloat(ae[6] || _$_b208[248]) * 60 * 60, se = 60 * parseFloat(ae[9] || _$_b208[248]) * 60, oe = 60 * parseFloat(ae[11] || _$_b208[248]), ue = parseFloat(ae[13] || _$_b208[248]);
                  if (_$_b208[1925] === ae[8] && (ae[9] || ae[11] || ae[13]) === void 0)
                    return NaN;
                  var be = he + _e + le + se + oe + ue;
                  return ce && (be = -be), be;
                }
                return NaN;
              }, ne;
            }();
            te[_$_b208[1922]] = ee;
          }, 44779: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1479]] = ae, te[_$_b208[1926]] = ce;
            var ne = ee(92737), ie = ee(45711);
            function ae(he, _e) {
              return _e === void 0 && (_e = _$_b208[265]), ce(he) ? String((0, ie[_$_b208[1927]])(he[_$_b208[72]] + he[_$_b208[57]] + he[_$_b208[30]][_$_b208[749]])) : String((0, ie[_$_b208[1927]])(_e + JSON[_$_b208[1012]](he)));
            }
            function ce(he) {
              return he[_$_b208[72]] === ne[_$_b208[74]][_$_b208[73]];
            }
          }, 44920: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1928]] = void 0;
            var ee = function() {
              function ne() {
              }
              return ne[_$_b208[1929]] = function(ie, ae, ce) {
                ae === void 0 && (ae = {}), ce === void 0 && (ce = {});
                var he = document[_$_b208[796]](ie);
                return Object[_$_b208[69]](ce)[_$_b208[68]](function(_e) {
                  return he[_$_b208[693]][_e] = ce[_e];
                }), Object[_$_b208[69]](ae)[_$_b208[68]](function(_e) {
                  return he[_$_b208[598]](_e, ae[_e]);
                }), he;
              }, ne;
            }();
            te[_$_b208[1928]] = ee;
          }, 45217: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1930]] = void 0, te[_$_b208[1930]] = _$_b208[1931];
          }, 45243: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1932]] = void 0;
            var ee = function() {
              function ne() {
                this[_$_b208[1933]] = {};
              }
              return ne[_$_b208[21]][_$_b208[60]] = function(ie) {
                this[_$_b208[1933]][ie] = void 0;
              }, ne[_$_b208[21]][_$_b208[1934]] = function(ie) {
                delete this[_$_b208[1933]][ie];
              }, ne[_$_b208[21]][_$_b208[1935]] = function() {
                this[_$_b208[1933]] = {};
              }, ne[_$_b208[21]][_$_b208[196]] = function(ie) {
                return ie in this[_$_b208[1933]];
              }, ne[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[1935]]();
              }, ne;
            }();
            te[_$_b208[1932]] = ee;
          }, 45711: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1927]] = ae;
            var ne = ee(91520), ie = ee(16368);
            function ae(he) {
              return (ne[_$_b208[197]][_$_b208[196]](ie[_$_b208[195]][_$_b208[1120]]) ? ne[_$_b208[197]][_$_b208[199]](ie[_$_b208[195]][_$_b208[1120]])[_$_b208[1936]] : ce)(he);
            }
            function ce(he) {
              var _e = 0;
              if (he[_$_b208[18]] === 0)
                return _e;
              for (var le = 0; le < he[_$_b208[18]]; le++)
                _e = (_e << 5) - _e + he[_$_b208[1504]](le), _e |= 0;
              return _e;
            }
          }, 46462: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[103]] = void 0, function(ne) {
              ne[_$_b208[421]] = _$_b208[421], ne[_$_b208[102]] = _$_b208[102], ne[_$_b208[1937]] = _$_b208[1937], ne[_$_b208[1938]] = _$_b208[1938], ne[_$_b208[1939]] = _$_b208[1939], ne[_$_b208[1940]] = _$_b208[1940], ne[_$_b208[245]] = _$_b208[245], ne[_$_b208[90]] = _$_b208[90], ne[_$_b208[1941]] = _$_b208[1941], ne[_$_b208[1942]] = _$_b208[1942], ne[_$_b208[1374]] = _$_b208[1374], ne[_$_b208[169]] = _$_b208[169], ne[_$_b208[167]] = _$_b208[167], ne[_$_b208[168]] = _$_b208[168], ne[_$_b208[380]] = _$_b208[380], ne[_$_b208[501]] = _$_b208[501], ne[_$_b208[238]] = _$_b208[238], ne[_$_b208[242]] = _$_b208[242], ne[_$_b208[1943]] = _$_b208[1943], ne[_$_b208[1597]] = _$_b208[1597], ne[_$_b208[170]] = _$_b208[170], ne[_$_b208[500]] = _$_b208[500], ne[_$_b208[1616]] = _$_b208[1616], ne[_$_b208[1944]] = _$_b208[1944], ne[_$_b208[1945]] = _$_b208[1945], ne[_$_b208[1472]] = _$_b208[1472], ne[_$_b208[1946]] = _$_b208[1946], ne[_$_b208[588]] = _$_b208[588], ne[_$_b208[589]] = _$_b208[589], ne[_$_b208[1947]] = _$_b208[1947], ne[_$_b208[1948]] = _$_b208[1948], ne[_$_b208[1949]] = _$_b208[1949], ne[_$_b208[1950]] = _$_b208[1950], ne[_$_b208[1951]] = _$_b208[1951], ne[_$_b208[1952]] = _$_b208[1952], ne[_$_b208[1953]] = _$_b208[1953];
            }(ee || (te[_$_b208[103]] = ee = {}));
          }, 47275: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[795]] = void 0, te[_$_b208[1237]] = ce;
            var ne = ee(18665), ie = _$_b208[1954], ae = function() {
              function _e() {
                this[_$_b208[1955]] = {}, this[_$_b208[124]] = /* @__PURE__ */ new WeakMap();
              }
              return _e[_$_b208[21]][_$_b208[196]] = function(le, se) {
                return se === void 0 && (se = ie), !!this[_$_b208[199]](le, se);
              }, _e[_$_b208[21]][_$_b208[199]] = function(le, se) {
                if (se === void 0 && (se = ie), this[_$_b208[1955]][se])
                  return this[_$_b208[1955]][se][le];
              }, _e[_$_b208[21]][_$_b208[361]] = function(le, se, oe) {
                oe === void 0 && (oe = ie), this[_$_b208[1955]][oe] || (this[_$_b208[1955]][oe] = {}), this[_$_b208[1955]][oe][le] = se, se && this[_$_b208[124]][_$_b208[361]](se, oe);
              }, _e[_$_b208[21]][_$_b208[1956]] = function(le) {
                return this[_$_b208[124]][_$_b208[199]](le);
              }, _e[_$_b208[21]][_$_b208[362]] = function(le, se) {
                se === void 0 && (se = ie), this[_$_b208[1955]][se] && this[_$_b208[1955]][se][le] && (this[_$_b208[124]][_$_b208[362]](this[_$_b208[1955]][se][le]), this[_$_b208[1955]][se][le][_$_b208[70]](), delete this[_$_b208[1955]][se][le]);
              }, _e[_$_b208[21]][_$_b208[493]] = function(le, se, oe, ue) {
                oe === void 0 && (oe = null), ue === void 0 && (ue = ie);
                var be = this[_$_b208[199]](le, ue);
                return be ? se(be) : oe;
              }, _e[_$_b208[21]][_$_b208[70]] = function() {
                Object[_$_b208[1111]](this[_$_b208[1955]])[_$_b208[68]](function(le) {
                  he(le)[_$_b208[68]](function(se) {
                    le[se][_$_b208[70]]();
                  });
                }), this[_$_b208[1955]] = {}, delete this[_$_b208[124]];
              }, _e[_$_b208[21]][_$_b208[673]] = function() {
                var le = this;
                Object[_$_b208[69]](this[_$_b208[1955]])[_$_b208[165]](function(se) {
                  return se !== ie;
                })[_$_b208[68]](function(se) {
                  he(le[_$_b208[1955]][se])[_$_b208[68]](function(oe) {
                    le[_$_b208[362]](oe, se);
                  }), delete le[_$_b208[1955]][se];
                });
              }, _e;
            }();
            function ce(_e, le, se) {
              se === void 0 && (se = ie);
              var oe = _e[_$_b208[199]](le, se);
              oe && (oe[_$_b208[70]](), _e[_$_b208[361]](le, null, se));
            }
            function he(_e) {
              return Object[_$_b208[69]](_e)[_$_b208[1764]](function(le) {
                return le !== ne[_$_b208[490]][_$_b208[826]] ? -1 : 1;
              })[_$_b208[165]](function(le) {
                return !!_e[le];
              });
            }
            te[_$_b208[795]] = ae;
          }, 47384: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1957]] = void 0;
            var ne = ee(33696), ie = ee(79814), ae = function() {
              function ce(he, _e) {
                this[_$_b208[148]] = _e, this[_$_b208[877]] = JSON[_$_b208[1035]](JSON[_$_b208[1012]](he)), this[_$_b208[1958]] = {}, this[_$_b208[1959]](this[_$_b208[1958]], this[_$_b208[877]]), this[_$_b208[1960]] = { currentDistanceToLiveEdge: 1 / 0, minimumBufferLength: 1, streamDuration: 1 / 0 };
              }
              return ce[_$_b208[21]][_$_b208[1959]] = function(he, _e) {
                Object[_$_b208[69]](_e)[_$_b208[68]](function(le) {
                  he[le] = {};
                });
              }, ce[_$_b208[21]][_$_b208[1961]] = function(he, _e, le) {
                _$_b208[885] == typeof _e && (this[_$_b208[877]][le][he] = _e);
              }, ce[_$_b208[21]][_$_b208[1962]] = function(he, _e, le) {
                this[_$_b208[1958]][le][he] = _e;
              }, ce[_$_b208[21]][_$_b208[1963]] = function(he) {
                this[_$_b208[1960]] = he;
              }, ce[_$_b208[21]][_$_b208[1964]] = function(he) {
                this[_$_b208[1960]][_$_b208[1965]] = he;
              }, ce[_$_b208[21]][_$_b208[1966]] = function(he, _e) {
                var le, se, oe, ue, be = (se = (le = this[_$_b208[877]][_e]) === null || le === void 0 ? void 0 : le[he]) !== null && se !== void 0 ? se : 1 / 0, ve = (ue = (oe = this[_$_b208[1958]][_e]) === null || oe === void 0 ? void 0 : oe[he]) !== null && ue !== void 0 ? ue : 1 / 0, me = this[_$_b208[1960]][_$_b208[1967]], pe = this[_$_b208[1960]][_$_b208[1968]], fe = he === ne[_$_b208[872]][_$_b208[1571]] ? 1 / 0 : this[_$_b208[1960]][_$_b208[1965]];
                return Math[_$_b208[137]](Math[_$_b208[842]](be, ve, fe, pe), me);
              }, ce[_$_b208[21]][_$_b208[1969]] = function(he) {
                return he === void 0 && (he = ne[_$_b208[874]][_$_b208[873]]), this[_$_b208[1966]](ne[_$_b208[872]][_$_b208[871]], he);
              }, ce[_$_b208[21]][_$_b208[1970]] = function(he) {
                return he === void 0 && (he = ne[_$_b208[874]][_$_b208[873]]), this[_$_b208[1966]](ne[_$_b208[872]][_$_b208[1571]], he);
              }, ce[_$_b208[21]][_$_b208[1971]] = function(he) {
                var _e, le = ie[_$_b208[1558]][_$_b208[1972]](he) ? ne[_$_b208[874]][_$_b208[906]] : ne[_$_b208[874]][_$_b208[873]];
                return (_e = {})[ne[_$_b208[872]][_$_b208[1571]]] = this[_$_b208[1970]](le), _e[ne[_$_b208[872]][_$_b208[871]]] = this[_$_b208[1969]](le), _e;
              }, ce[_$_b208[21]][_$_b208[1973]] = function(he, _e, le) {
                var se, oe = le / 2, ue = le / 2, be = this[_$_b208[1971]](he), ve = be[ne[_$_b208[872]][_$_b208[1571]]], me = be[ne[_$_b208[872]][_$_b208[871]]], pe = le >= 2 * _e, fe = me / (me + ve);
                if (!isFinite(ve) && isFinite(me) ? (oe = _e, ue = le - _e) : isFinite(ve) && !isFinite(me) ? (oe = le - _e, ue = _e) : isFinite(ve) && isFinite(me) && (oe = le * fe, ue = le * (1 - fe)), pe && oe < _e) {
                  var ge = _e - oe;
                  oe += ge, ue -= ge;
                }
                return (se = {})[ne[_$_b208[872]][_$_b208[1571]]] = ue, se[ne[_$_b208[872]][_$_b208[871]]] = oe, se;
              }, ce[_$_b208[21]][_$_b208[1974]] = function(he, _e, le) {
                var se = this[_$_b208[1973]](_e, he, le - he), oe = se[ne[_$_b208[872]][_$_b208[1571]]], ue = se[ne[_$_b208[872]][_$_b208[871]]];
                this[_$_b208[148]][_$_b208[154]](_$_b208[1977][_$_b208[94]](ue, _$_b208[1976])[_$_b208[94]](oe, _$_b208[1975])), this[_$_b208[1962]](ne[_$_b208[872]][_$_b208[871]], ue, ne[_$_b208[874]][_$_b208[906]]), this[_$_b208[1962]](ne[_$_b208[872]][_$_b208[871]], ue, ne[_$_b208[874]][_$_b208[873]]), this[_$_b208[1962]](ne[_$_b208[872]][_$_b208[1571]], oe, ne[_$_b208[874]][_$_b208[906]]), this[_$_b208[1962]](ne[_$_b208[872]][_$_b208[1571]], oe, ne[_$_b208[874]][_$_b208[873]]);
              }, ce;
            }();
            te[_$_b208[1957]] = ae;
          }, 47722: function(re, te, ee) {
            _$_b208[11];
            var ne, ie = this && this[_$_b208[16]] || function() {
              return ie = Object[_$_b208[17]] || function(se) {
                for (var oe, ue = 1, be = arguments[_$_b208[18]]; ue < be; ue++)
                  for (var ve in oe = arguments[ue])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](oe, ve) && (se[ve] = oe[ve]);
                return se;
              }, ie[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[529]] = void 0;
            var ae = ee(21829), ce = ee(11399), he = {};
            function _e(se) {
              return se;
            }
            function le(se, oe) {
              var ue, be = oe[_$_b208[723]], ve = oe[_$_b208[888]];
              return ie(ie({}, se), ((ue = {})[be] = ve, ue));
            }
            te[_$_b208[529]] = (0, ae[_$_b208[302]])(he, ((ne = {})[ce[_$_b208[450]][_$_b208[451]]] = function(se, oe) {
              return oe[_$_b208[1464]];
            }, ne[ce[_$_b208[450]][_$_b208[453]]] = function(se, oe) {
              return le(se, oe[_$_b208[1464]]);
            }, ne));
          }, 47894: function(re, te, ee) {
            _$_b208[11];
            var ne, ie = this && this[_$_b208[224]] || function() {
              var se = function(oe, ue) {
                return se = Object[_$_b208[225]] || { __proto__: [] } instanceof Array && function(be, ve) {
                  be[_$_b208[226]] = ve;
                } || function(be, ve) {
                  for (var me in ve)
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](ve, me) && (be[me] = ve[me]);
                }, se(oe, ue);
              };
              return function(oe, ue) {
                if (_$_b208[161] != typeof ue && ue !== null)
                  throw new TypeError(_$_b208[227] + String(ue) + _$_b208[228]);
                function be() {
                  this[_$_b208[229]] = oe;
                }
                se(oe, ue), oe[_$_b208[21]] = ue === null ? Object[_$_b208[230]](ue) : (be[_$_b208[21]] = ue[_$_b208[21]], new be());
              };
            }();
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[218]] = void 0;
            var ae, ce = ee(33696), he = ee(30573);
            (function(se) {
              se[_$_b208[572]] = _$_b208[1579], se[_$_b208[569]] = _$_b208[1978], se[_$_b208[562]] = _$_b208[1580];
            })(ae || (ae = {}));
            var _e = ((ne = {})[ae[_$_b208[572]]] = ce[_$_b208[563]][_$_b208[572]], ne[ae[_$_b208[569]]] = ce[_$_b208[563]][_$_b208[569]], ne[ae[_$_b208[562]]] = ce[_$_b208[563]][_$_b208[562]], ne), le = function(se) {
              function oe(ue, be) {
                return se[_$_b208[19]](this, ue, be) || this;
              }
              return ie(oe, se), Object[_$_b208[13]](oe[_$_b208[21]], _$_b208[638], { get: function() {
                var ue, be;
                return (be = (ue = this[_$_b208[97]][_$_b208[638]]) !== null && ue !== void 0 ? ue : this[_$_b208[97]][_$_b208[1979]]) !== null && be !== void 0 ? be : 0;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](oe[_$_b208[21]], _$_b208[1980], { get: function() {
                return this[_$_b208[97]] && this[_$_b208[97]][_$_b208[1980]] || 0;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](oe[_$_b208[21]], _$_b208[1981], { get: function() {
                return this[_$_b208[97]] && this[_$_b208[97]][_$_b208[1981]] || 0;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](oe[_$_b208[21]], _$_b208[1982], { get: function() {
                return this[_$_b208[97]][_$_b208[1982]];
              }, enumerable: !1, configurable: !0 }), oe[_$_b208[21]][_$_b208[1983]] = function(ue, be) {
                this[_$_b208[97]][_$_b208[1983]](ue, be);
              }, Object[_$_b208[13]](oe[_$_b208[21]], _$_b208[549], { get: function() {
                return this[_$_b208[97]][_$_b208[549]];
              }, set: function(ue) {
                this[_$_b208[97]][_$_b208[549]] = ue;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](oe[_$_b208[21]], _$_b208[550], { get: function() {
                return this[_$_b208[97]][_$_b208[550]];
              }, set: function(ue) {
                this[_$_b208[97]][_$_b208[550]] = ue;
              }, enumerable: !1, configurable: !0 }), oe[_$_b208[21]][_$_b208[1984]] = function(ue, be, ve, me) {
                this[_$_b208[97]][_$_b208[1984]](ue, be, ve, me);
              }, oe[_$_b208[21]][_$_b208[603]] = function() {
                this[_$_b208[97]][_$_b208[603]]();
              }, oe[_$_b208[21]][_$_b208[604]] = function() {
                this[_$_b208[97]][_$_b208[604]]();
              }, oe[_$_b208[21]][_$_b208[1985]] = function() {
                return this[_$_b208[97]][_$_b208[1985]]();
              }, Object[_$_b208[13]](oe[_$_b208[21]], _$_b208[1986], { get: function() {
                var ue;
                return (ue = this[_$_b208[97]][_$_b208[1986]]) !== null && ue !== void 0 && ue;
              }, enumerable: !1, configurable: !0 }), oe[_$_b208[21]][_$_b208[1987]] = function() {
                return _e[this[_$_b208[97]][_$_b208[1988]]] || (document[_$_b208[1989]] === this[_$_b208[97]] ? ce[_$_b208[563]][_$_b208[569]] : ce[_$_b208[563]][_$_b208[572]]);
              }, oe[_$_b208[21]][_$_b208[1990]] = function() {
                var ue, be;
                return (be = (ue = this[_$_b208[97]])[_$_b208[1990]]) === null || be === void 0 ? void 0 : be[_$_b208[19]](ue);
              }, Object[_$_b208[13]](oe[_$_b208[21]], _$_b208[1991], { set: function(ue) {
                this[_$_b208[97]][_$_b208[1991]] = ue;
              }, enumerable: !1, configurable: !0 }), oe[_$_b208[21]][_$_b208[590]] = function() {
                if (!this[_$_b208[97]])
                  return !1;
                var ue = _$_b208[161] == typeof this[_$_b208[97]][_$_b208[1992]] && this[_$_b208[97]][_$_b208[1992]](ae[_$_b208[569]]) && _$_b208[161] == typeof this[_$_b208[97]][_$_b208[1993]] && !/iP(hone|od)/i[_$_b208[1814]](navigator[_$_b208[1915]]), be = _$_b208[161] == typeof this[_$_b208[97]][_$_b208[1994]] && _$_b208[161] == typeof document[_$_b208[593]] && document[_$_b208[1995]];
                return ue || be;
              }, oe[_$_b208[21]][_$_b208[591]] = function() {
                return !!this[_$_b208[590]]() && (this[_$_b208[97]][_$_b208[1988]] === ae[_$_b208[569]] || document[_$_b208[1989]] === this[_$_b208[97]]);
              }, oe[_$_b208[21]][_$_b208[915]] = function() {
                return !!this[_$_b208[97]][_$_b208[1996]];
              }, oe[_$_b208[21]][_$_b208[594]] = function() {
                var ue = this;
                this[_$_b208[590]]() && (this[_$_b208[97]][_$_b208[1993]] ? this[_$_b208[97]][_$_b208[1993]](ae[_$_b208[569]]) : this[_$_b208[97]][_$_b208[1994]] && this[_$_b208[97]][_$_b208[1994]]()[_$_b208[943]](function(be) {
                  ue[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[1997], be);
                }));
              }, oe[_$_b208[21]][_$_b208[593]] = function() {
                var ue = this;
                this[_$_b208[591]]() && (this[_$_b208[97]][_$_b208[1988]] === ae[_$_b208[569]] ? this[_$_b208[97]][_$_b208[1993]](ae[_$_b208[572]]) : document[_$_b208[1989]] === this[_$_b208[97]] && document[_$_b208[593]]()[_$_b208[943]](function(be) {
                  ue[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[1998], be);
                }));
              }, oe[_$_b208[21]][_$_b208[1999]] = function(ue) {
                this[_$_b208[97]][_$_b208[1999]](ue);
              }, oe;
            }(he[_$_b208[1511]]);
            te[_$_b208[218]] = le;
          }, 50425: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[525]] = void 0, te[_$_b208[2e3]] = ae, te[_$_b208[2001]] = ce;
            var ne = ee(91829), ie = function() {
              function he() {
                this[_$_b208[2002]] = {};
              }
              return he[_$_b208[21]][_$_b208[196]] = function(_e) {
                return !!this[_$_b208[2002]][_e];
              }, he[_$_b208[21]][_$_b208[361]] = function(_e, le) {
                return this[_$_b208[2002]][_e] = le, this;
              }, he[_$_b208[21]][_$_b208[199]] = function(_e) {
                return this[_$_b208[2002]][_e];
              }, he[_$_b208[21]][_$_b208[362]] = function(_e) {
                delete this[_$_b208[2002]][_e];
              }, he[_$_b208[21]][_$_b208[69]] = function() {
                return Object[_$_b208[69]](this[_$_b208[2002]]);
              }, he[_$_b208[21]][_$_b208[2003]] = function(_e) {
                var le = this, se = {};
                return this[_$_b208[69]]()[_$_b208[68]](function(oe) {
                  var ue = le[_$_b208[199]](oe), be = _e[_$_b208[94]](String(oe));
                  se[oe] = ae(ue) ? ue : ue[_$_b208[2003]](be);
                }), Object[_$_b208[69]](se)[_$_b208[18]] === 0 ? function(oe) {
                  return {};
                } : (0, ne[_$_b208[2004]])(se);
              }, he[_$_b208[21]][_$_b208[359]] = function() {
                return this[_$_b208[2003]]([]);
              }, he;
            }();
            function ae(he) {
              return !!he && _$_b208[161] == typeof he;
            }
            function ce(he) {
              return !!he && he instanceof ie;
            }
            te[_$_b208[525]] = ie;
          }, 52442: function(re, te) {
            _$_b208[11];
            var ee, ne, ie, ae, ce, he;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2005]] = te[_$_b208[2006]] = te[_$_b208[2007]] = te[_$_b208[2008]] = te[_$_b208[2009]] = te[_$_b208[2010]] = void 0, function(_e) {
              _e[_e[_$_b208[2011]] = 1] = _$_b208[2011], _e[_e[_$_b208[2012]] = 2] = _$_b208[2012], _e[_e[_$_b208[2013]] = 3] = _$_b208[2013];
            }(ee || (te[_$_b208[2010]] = ee = {})), function(_e) {
              _e[_e[_$_b208[2014]] = 0] = _$_b208[2014], _e[_e[_$_b208[2015]] = 1] = _$_b208[2015], _e[_e[_$_b208[2016]] = 2] = _$_b208[2016];
            }(ne || (te[_$_b208[2009]] = ne = {})), function(_e) {
              _e[_$_b208[634]] = _$_b208[634], _e[_$_b208[2017]] = _$_b208[2018], _e[_$_b208[2019]] = _$_b208[2020], _e[_$_b208[2021]] = _$_b208[2022];
            }(ie || (te[_$_b208[2008]] = ie = {})), function(_e) {
              _e[_$_b208[2023]] = _$_b208[2024], _e[_$_b208[2025]] = _$_b208[2026], _e[_$_b208[2027]] = _$_b208[2028];
            }(ae || (te[_$_b208[2007]] = ae = {})), function(_e) {
              _e[_$_b208[2029]] = _$_b208[2030], _e[_$_b208[2031]] = _$_b208[2032];
            }(ce || (te[_$_b208[2006]] = ce = {})), function(_e) {
              _e[_$_b208[2033]] = _$_b208[2034], _e[_$_b208[2035]] = _$_b208[2036];
            }(he || (te[_$_b208[2005]] = he = {}));
          }, 53968: function(re, te) {
            _$_b208[11];
            function ee(ne) {
              var ie, ae = ne == null ? void 0 : ne[_$_b208[182]]();
              return !!ae && ((ie = ae[_$_b208[1172]]) === null || ie === void 0 ? void 0 : ie[_$_b208[2037]]);
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2038]] = ee;
          }, 54838: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[629]] || function(ve, me, pe) {
              if (pe || arguments[_$_b208[18]] === 2)
                for (var fe, ge = 0, ye = me[_$_b208[18]]; ge < ye; ge++)
                  !fe && ge in me || (fe || (fe = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](me, 0, ge)), fe[ge] = me[ge]);
              return ve[_$_b208[94]](fe || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](me));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[172]] = void 0, te[_$_b208[2039]] = oe, te[_$_b208[2040]] = ue, te[_$_b208[1461]] = be;
            var ie = ee(60997), ae = ee(87326), ce = ee(46462), he = ee(30573), _e = ee(45711), le = ee(331), se = function() {
              function ve() {
              }
              return ve[_$_b208[2041]] = function(me, pe) {
                if (me === pe)
                  return !0;
                if (!me || _$_b208[617] != typeof me || !pe || _$_b208[617] != typeof pe || Object[_$_b208[69]](me)[_$_b208[18]] !== Object[_$_b208[69]](pe)[_$_b208[18]])
                  return !1;
                for (var fe in me)
                  if (!pe[_$_b208[20]](fe) || !ve[_$_b208[2041]](me[fe], pe[fe]))
                    return !1;
                return !0;
              }, ve[_$_b208[350]] = function(me, pe) {
                var fe = window[_$_b208[1891]] !== void 0;
                for (var ge in pe)
                  pe[_$_b208[20]](ge) && (fe && pe[ge] instanceof ArrayBuffer ? me[ge] = pe[ge][_$_b208[630]](0, pe[ge][_$_b208[1592]]) : _$_b208[617] == typeof pe[ge] && pe[ge] !== null ? (me[_$_b208[20]](ge) || (Array[_$_b208[1122]](pe[ge]) ? me[ge] = [] : me[ge] = {}), ve[_$_b208[350]](me[ge], pe[ge])) : me[ge] = pe[ge]);
              }, ve[_$_b208[2042]] = function(me) {
                for (var pe = this, fe = [], ge = 1; ge < arguments[_$_b208[18]]; ge++)
                  fe[ge - 1] = arguments[ge];
                return fe[_$_b208[68]](function(ye) {
                  return pe[_$_b208[350]](me, ye);
                }), me;
              }, ve[_$_b208[171]] = function(me) {
                return !!me && _$_b208[2043] === {}[_$_b208[118]][_$_b208[19]](me);
              }, ve[_$_b208[2044]] = function(me, pe) {
                return isNaN(pe) ? (pe = pe[_$_b208[215]]()[_$_b208[1695]]()[_$_b208[2046]](/,/g, _$_b208[1117]))[_$_b208[138]](_$_b208[2045]) > -1 ? 1e6 * pe[_$_b208[258]](_$_b208[2047])[0] : pe[_$_b208[138]](_$_b208[2048]) > -1 ? 1e3 * pe[_$_b208[258]](_$_b208[2049])[0] : pe[_$_b208[138]](_$_b208[2050]) > -1 ? 1 * pe[_$_b208[258]](_$_b208[2051])[0] : _$_b208[137] === me ? 1 / 0 : 0 : pe === 1 / 0 ? pe : 1 * pe;
              }, ve[_$_b208[1234]] = function(me) {
                if (me && _$_b208[348] == typeof me) {
                  for (var pe = me[_$_b208[258]](_$_b208[1117]), fe = 0, ge = 0; ge < me[_$_b208[18]]; ge++)
                    _$_b208[265] === pe[ge] && (pe[ge] = null, fe++);
                  return fe === me[_$_b208[18]] ? null : { player: pe[0], streaming: pe[1] };
                }
                return null;
              }, ve[_$_b208[2052]] = function() {
                var me = document[_$_b208[796]](_$_b208[507]);
                me[_$_b208[598]](_$_b208[89], _$_b208[2053]), me[_$_b208[598]](_$_b208[274], _$_b208[2054]);
                var pe = { settings: ae[_$_b208[751]] };
                for (ve[_$_b208[2055]] = ve[_$_b208[2055]] || new he[_$_b208[1511]](pe, document[_$_b208[796]](_$_b208[1567])), ve[_$_b208[2055]][_$_b208[598]](_$_b208[749], _$_b208[2056]), ve[_$_b208[2055]][_$_b208[100]](ce[_$_b208[103]][_$_b208[168]], function() {
                  return ve[_$_b208[2055]][_$_b208[2057]] = !0;
                }), ve[_$_b208[2055]][_$_b208[598]](_$_b208[2058], _$_b208[2059]), ve[_$_b208[2055]][_$_b208[284]](_$_b208[274]) && ve[_$_b208[2055]][_$_b208[1537]](_$_b208[274]); ve[_$_b208[2055]][_$_b208[1522]]; )
                  ve[_$_b208[2055]][_$_b208[963]](ve[_$_b208[2055]][_$_b208[1522]]);
                ve[_$_b208[2055]][_$_b208[244]]();
              }, ve[_$_b208[1054]] = function() {
                return ve[_$_b208[2055]] || ve[_$_b208[2052]](), ve[_$_b208[2055]];
              }, ve[_$_b208[1144]] = function() {
                if (ve[_$_b208[2055]]) {
                  var me = ve[_$_b208[2055]][_$_b208[236]]();
                  ve[_$_b208[2055]] = (0, ie[_$_b208[70]])(ve[_$_b208[2055]]), me[_$_b208[1042]] && me[_$_b208[1042]][_$_b208[963]](me);
                }
              }, ve[_$_b208[574]] = function() {
                return document[_$_b208[607]] || document[_$_b208[612]] || document[_$_b208[611]] || document[_$_b208[2060]];
              }, ve[_$_b208[2061]] = function() {
                return Date[_$_b208[180]]()[_$_b208[118]](16) + Math[_$_b208[1280]](1048576 * (1 + Math[_$_b208[2062]]()))[_$_b208[118]](16)[_$_b208[259]](1);
              }, ve[_$_b208[2063]] = function(me) {
                var pe = null;
                return _$_b208[348] != typeof me && isNaN(me) || (pe = _$_b208[348] == typeof me ? ve[_$_b208[2064]][_$_b208[1814]](me) ? new Date(me) : new Date(me + _$_b208[2065]) : new Date(me)), pe;
              }, ve[_$_b208[967]] = function(me, pe) {
                return new Promise(function(fe) {
                  setTimeout(function() {
                    _$_b208[161] == typeof pe ? fe(pe()) : fe();
                  }, me);
                });
              }, ve[_$_b208[2066]] = function(me) {
                return (0, le[_$_b208[14]])(me[_$_b208[1774]]());
              }, ve[_$_b208[1224]] = function(me) {
                var pe = 16, fe = 20, ge = 268435456, ye = /* @__PURE__ */ new WeakMap();
                function $e(Ce, Ie) {
                  if (Ie == null)
                    return Ie;
                  if (_$_b208[161] == typeof Ie)
                    return Ie[_$_b208[118]]()[_$_b208[2046]](/\n|\s\s/g, _$_b208[265]);
                  if (Ie instanceof ArrayBuffer)
                    return String[_$_b208[2067]][_$_b208[22]](null, new Uint8Array(Ie[_$_b208[630]](0, fe)));
                  if (Ie instanceof Uint8Array)
                    return String[_$_b208[2067]][_$_b208[22]](null, Ie[_$_b208[630]](0, fe));
                  if (_$_b208[617] == typeof Ie && !Array[_$_b208[1122]](Ie)) {
                    if (ye[_$_b208[196]](Ie)) {
                      var Te = JSON[_$_b208[1012]](Object[_$_b208[69]](Ie), $e);
                      return _$_b208[2069][_$_b208[94]](Math[_$_b208[1483]]((0, _e[_$_b208[1927]])(Te))[_$_b208[118]](pe), _$_b208[2068]);
                    }
                    ye[_$_b208[361]](Ie, !0);
                  }
                  return Ie;
                }
                var Se = JSON[_$_b208[1012]](me, $e);
                return (Math[_$_b208[1483]]((0, _e[_$_b208[1927]])(Se)) | ge)[_$_b208[118]](pe);
              }, ve[_$_b208[2070]] = function(me, pe) {
                var fe = Math[_$_b208[2071]](10, pe);
                return Math[_$_b208[2072]](me * fe) / fe;
              }, ve[_$_b208[2073]] = function(me, pe, fe) {
                var ge = ne([], me, !0), ye = ge[pe];
                return ge[_$_b208[139]](pe, 1), ge[_$_b208[139]](fe, 0, ye), ge;
              }, ve[_$_b208[2055]] = null, ve[_$_b208[2064]] = /(?:Z|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])$/, ve;
            }();
            function oe(ve) {
              if (!ve)
                return 0;
              var me;
              if ((ve = String(ve)[_$_b208[2046]](_$_b208[257], _$_b208[1117]))[_$_b208[138]](_$_b208[271]) > -1)
                me = ve[_$_b208[258]](_$_b208[271]);
              else {
                if (!(ve[_$_b208[138]](_$_b208[263]) > -1))
                  return isNaN(parseFloat(ve)) ? 0 : parseFloat(ve);
                me = ve[_$_b208[258]](_$_b208[263]);
              }
              if (me && Array[_$_b208[1122]](me) && me[_$_b208[18]] > 1) {
                var pe = parseFloat(me[0]) / parseFloat(me[1]);
                return isNaN(pe) ? 0 : pe;
              }
              return 0;
            }
            function ue(ve) {
              return ve[_$_b208[165]](function(me, pe, fe) {
                return pe === fe[_$_b208[2074]](function(ge) {
                  return se[_$_b208[2041]](ge, me);
                });
              });
            }
            function be(ve, me) {
              if (!se[_$_b208[171]](ve))
                return null;
              try {
                return ve();
              } catch (pe) {
                return me && me[_$_b208[721]](_$_b208[2075], pe), null;
              }
            }
            te[_$_b208[172]] = se;
          }, 54861: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2076]] = void 0;
            var ne = ee(18665), ie = ee(489), ae = function() {
              function ce(he, _e) {
                this[_$_b208[2077]] = he[_$_b208[494]][_$_b208[199]](ne[_$_b208[490]][_$_b208[1076]]), this[_$_b208[2078]] = new ie[_$_b208[23]](he, _e);
              }
              return ce[_$_b208[21]][_$_b208[2079]] = function(he, _e, le) {
                _e[_$_b208[57]] = _e[_$_b208[57]] || he, this[_$_b208[2077]][_$_b208[845]](le, _e);
              }, ce[_$_b208[21]][_$_b208[2080]] = function(he, _e, le) {
                this[_$_b208[2078]][_$_b208[60]](he, _e, le);
              }, ce[_$_b208[21]][_$_b208[66]] = function(he) {
                this[_$_b208[2078]][_$_b208[66]](he);
              }, ce[_$_b208[21]][_$_b208[59]] = function(he, _e) {
                this[_$_b208[2078]][_$_b208[59]](he, _e);
              }, ce[_$_b208[21]][_$_b208[64]] = function(he) {
                this[_$_b208[2078]][_$_b208[64]](he);
              }, ce[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[2078]][_$_b208[70]]();
              }, ce;
            }();
            te[_$_b208[2076]] = ae;
          }, 56093: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2081]] = void 0;
            var ee = function() {
              function ne() {
              }
              return ne[_$_b208[2082]] = function(ie) {
                var ae = ie[_$_b208[18]];
                1 & ae && (ie = _$_b208[248] + ie, ae++);
                for (var ce = new Uint8Array(ae >> 1), he = 0; he < ae; he += 2)
                  ce[he >> 1] = parseInt(ie[_$_b208[259]](he, he + 2), 16);
                return ce;
              }, ne[_$_b208[2083]] = function(ie) {
                ie instanceof ArrayBuffer && (ie = new Uint8Array(ie));
                for (var ae = _$_b208[265], ce = 0; ce < ie[_$_b208[1592]]; ce++) {
                  var he = (255 & ie[ce])[_$_b208[118]](16);
                  he[_$_b208[18]] < 2 && (ae += _$_b208[248]), ae += he;
                }
                return ae;
              }, ne[_$_b208[2084]] = function(ie) {
                return this[_$_b208[2085]](this[_$_b208[2083]](ie));
              }, ne[_$_b208[2085]] = function(ie) {
                return ie[_$_b208[630]](0, 8) + _$_b208[2086] + ie[_$_b208[630]](8, 12) + _$_b208[2086] + ie[_$_b208[630]](12, 16) + _$_b208[2086] + ie[_$_b208[630]](16, 20) + _$_b208[2086] + ie[_$_b208[630]](20);
              }, ne[_$_b208[2087]] = function(ie) {
                return (_$_b208[2088] + ie[_$_b208[118]](16))[_$_b208[630]](-2);
              }, ne[_$_b208[2089]] = function(ie) {
                return window[_$_b208[2091]](ie)[_$_b208[2046]](/\+/g, _$_b208[2086])[_$_b208[2046]](/\//g, _$_b208[2090])[_$_b208[2046]](/=/g, _$_b208[265]);
              }, ne[_$_b208[2092]] = function(ie) {
                return window[_$_b208[2095]]((ie + _$_b208[2094][_$_b208[630]]((ie[_$_b208[18]] + 3) % 4))[_$_b208[2046]](/-/g, _$_b208[2093])[_$_b208[2046]](/_/g, _$_b208[263]));
              }, ne;
            }();
            te[_$_b208[2081]] = ee;
          }, 56435: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2096]] = te[_$_b208[187]] = te[_$_b208[1496]] = te[_$_b208[462]] = te[_$_b208[461]] = te[_$_b208[455]] = te[_$_b208[2097]] = te[_$_b208[2098]] = te[_$_b208[1499]] = te[_$_b208[200]] = te[_$_b208[460]] = te[_$_b208[2099]] = te[_$_b208[203]] = te[_$_b208[2100]] = te[_$_b208[2101]] = te[_$_b208[2102]] = te[_$_b208[2103]] = te[_$_b208[2104]] = te[_$_b208[2105]] = te[_$_b208[193]] = te[_$_b208[1495]] = te[_$_b208[463]] = te[_$_b208[1497]] = te[_$_b208[189]] = te[_$_b208[459]] = te[_$_b208[458]] = te[_$_b208[457]] = te[_$_b208[456]] = te[_$_b208[2106]] = te[_$_b208[1466]] = te[_$_b208[2107]] = te[_$_b208[2108]] = te[_$_b208[2109]] = te[_$_b208[2110]] = te[_$_b208[2111]] = te[_$_b208[2112]] = te[_$_b208[2113]] = te[_$_b208[2114]] = te[_$_b208[2115]] = te[_$_b208[2116]] = te[_$_b208[2117]] = te[_$_b208[2118]] = te[_$_b208[2119]] = te[_$_b208[1625]] = te[_$_b208[2120]] = te[_$_b208[1626]] = te[_$_b208[1916]] = te[_$_b208[1914]] = void 0, te[_$_b208[464]] = ue, te[_$_b208[206]] = be, te[_$_b208[209]] = ve, te[_$_b208[465]] = me;
            var ne = ee(43485);
            te[_$_b208[1914]] = 9, te[_$_b208[1916]] = 10, te[_$_b208[1626]] = 15, te[_$_b208[2120]] = 17, te[_$_b208[1625]] = 15, te[_$_b208[2119]] = 17, te[_$_b208[2118]] = 2, te[_$_b208[2117]] = 4, te[_$_b208[2116]] = 3, te[_$_b208[2115]] = 0, te[_$_b208[2114]] = 4, te[_$_b208[2113]] = 0, te[_$_b208[2112]] = 5, te[_$_b208[2111]] = 0, te[_$_b208[2110]] = 5, te[_$_b208[2109]] = 5, te[_$_b208[2108]] = 38, te[_$_b208[2107]] = 53, te[_$_b208[1466]] = 68, te[_$_b208[2106]] = 79;
            var ie = function() {
              return navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2121]) && !(0, te[_$_b208[463]])();
            };
            te[_$_b208[456]] = ie;
            var ae = function() {
              return (0, te[_$_b208[456]])() || (0, te[_$_b208[463]])() && !ue();
            };
            te[_$_b208[457]] = ae;
            var ce = function() {
              return navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2122]);
            };
            te[_$_b208[458]] = ce;
            var he = function() {
              return navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2123]) && (0, te[_$_b208[461]])();
            };
            te[_$_b208[459]] = he;
            var _e = function() {
              return navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2124]) && !navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2121]) && !navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2125]) && !navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2126]) && !(0, te[_$_b208[193]])() && !be() && !ve() || (0, ne[_$_b208[1880]])();
            };
            te[_$_b208[189]] = _e;
            var le = function() {
              var Xe = /Version\/(\d+)\.?(\d+)?\.?(\d+)?/[_$_b208[1924]](navigator[_$_b208[1915]]) || null;
              if (!Xe)
                return {};
              var Qe = Xe[1], tt = Xe[2], Je = Xe[3], Ge = function(Ye) {
                return parseInt(Ye);
              };
              return { major: Ge(Qe), minor: Ge(tt), patch: Ge(Je) };
            };
            te[_$_b208[1497]] = le;
            var se = function() {
              return /Edge\/\d+/i[_$_b208[1814]](navigator[_$_b208[1915]]) || /Edg\/\d+/i[_$_b208[1814]](navigator[_$_b208[1915]]);
            };
            te[_$_b208[463]] = se;
            var oe = function() {
              var Xe = /Edge\/(\d+)\.?(\d+)/[_$_b208[1924]](navigator[_$_b208[1915]]) || /Edg\/(\d+)\.?(\d+)/[_$_b208[1924]](navigator[_$_b208[1915]]);
              if (!Xe || Xe[_$_b208[18]] === 0)
                return { major: 0, minor: 0 };
              var Qe = {};
              return Xe[1] && (Qe[_$_b208[1498]] = parseInt(Xe[1])), Xe[1] && (Qe[_$_b208[2127]] = parseInt(Xe[2])), Qe;
            };
            function ue() {
              var Xe = 79;
              return (0, te[_$_b208[463]])() && (0, te[_$_b208[1495]])()[_$_b208[1498]] < Xe;
            }
            function be() {
              return /PlayStation 5/i[_$_b208[1814]](navigator[_$_b208[1915]]);
            }
            function ve() {
              return /PlayStation 4/i[_$_b208[1814]](navigator[_$_b208[1915]]);
            }
            function me() {
              return _$_b208[1271] === window[_$_b208[8]][_$_b208[2128]];
            }
            te[_$_b208[1495]] = oe;
            var pe = function(Xe, Qe) {
              var tt = (0, te[_$_b208[2100]])();
              return tt[_$_b208[1498]] === Xe && tt[_$_b208[2127]] === Qe;
            }, fe = function() {
              return navigator[_$_b208[1915]][_$_b208[26]](_$_b208[194]);
            };
            te[_$_b208[193]] = fe;
            var ge = function() {
              return pe(te[_$_b208[2112]], te[_$_b208[2111]]);
            };
            te[_$_b208[2105]] = ge;
            var ye = function() {
              return pe(te[_$_b208[2114]], te[_$_b208[2113]]);
            };
            te[_$_b208[2104]] = ye;
            var $e = function() {
              return pe(te[_$_b208[2116]], te[_$_b208[2115]]);
            };
            te[_$_b208[2103]] = $e;
            var Se = function() {
              return pe(te[_$_b208[2118]], te[_$_b208[2117]]);
            };
            te[_$_b208[2102]] = Se;
            var Ce = function() {
              return pe(te[_$_b208[2110]], te[_$_b208[2109]]);
            };
            te[_$_b208[2101]] = Ce;
            var Ie = function() {
              var Xe = /Tizen (\d).(\d)/[_$_b208[1924]](navigator[_$_b208[1915]]);
              return Xe != null && Xe[1] ? { major: Number(Xe[1]), minor: Number(Xe[2] || 0) } : {};
            };
            te[_$_b208[2100]] = Ie;
            var Te = function() {
              return navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2129]);
            };
            te[_$_b208[203]] = Te;
            var Ee = function() {
              var Xe = new RegExp(/VIDAA\/(\d+)\.?(\d+)/)[_$_b208[1924]](navigator[_$_b208[1915]]);
              return Xe != null && Xe[1] ? { major: Number(Xe[1]), minor: Number(Xe[2]) } : {};
            };
            te[_$_b208[2099]] = Ee;
            var we = function() {
              return navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2130]);
            };
            te[_$_b208[460]] = we;
            var Pe = function() {
              return navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2131]) || navigator[_$_b208[1915]][_$_b208[26]](_$_b208[2132]);
            };
            te[_$_b208[200]] = Pe;
            var Me = function() {
              var Xe, Qe = new RegExp(/Chrome\/(\d+)\.?(\d+)/)[_$_b208[1924]](navigator[_$_b208[1915]]);
              return Qe != null && Qe[1] ? { major: Number(Qe[1]), minor: Number((Xe = Qe[2]) !== null && Xe !== void 0 ? Xe : 0) } : {};
            };
            te[_$_b208[1499]] = Me;
            var Ae = function() {
              return (0, te[_$_b208[1499]])()[_$_b208[1498]] === te[_$_b208[2108]] && !(_$_b208[2133] in navigator);
            };
            te[_$_b208[2098]] = Ae;
            var Oe = function() {
              return (0, te[_$_b208[1499]])()[_$_b208[1498]] === te[_$_b208[2108]] && _$_b208[2133] in navigator;
            };
            te[_$_b208[2097]] = Oe;
            var Be = function() {
              return /Android/i[_$_b208[1814]](navigator[_$_b208[1915]]) || /IEMobile/i[_$_b208[1814]](navigator[_$_b208[1915]]) || /Windows Phone 10.0/i[_$_b208[1814]](navigator[_$_b208[1915]]) || /Safari/i[_$_b208[1814]](navigator[_$_b208[1915]]) && /Mobile/i[_$_b208[1814]](navigator[_$_b208[1915]]);
            };
            te[_$_b208[455]] = Be;
            var Ve = function() {
              return /Safari/i[_$_b208[1814]](navigator[_$_b208[1915]]) && /Mobile/i[_$_b208[1814]](navigator[_$_b208[1915]]) && !/Android/i[_$_b208[1814]](navigator[_$_b208[1915]]) && !/Windows Phone 10.0/i[_$_b208[1814]](navigator[_$_b208[1915]]);
            };
            te[_$_b208[461]] = Ve;
            var Ue = function() {
              return /Safari/i[_$_b208[1814]](navigator[_$_b208[1915]]) && /iP(hone|od|ad)/i[_$_b208[1814]](navigator[_$_b208[1915]]);
            };
            te[_$_b208[462]] = Ue;
            var Re = function() {
              var Xe = /OS (\d+)(_\d+)*/[_$_b208[1924]](navigator[_$_b208[1915]]);
              return Xe && Xe[_$_b208[18]] > 0 && parseInt(Xe[1], 10) || 0;
            };
            te[_$_b208[1496]] = Re;
            var Ne = function() {
              return (0, te[_$_b208[461]])() && (0, te[_$_b208[1496]])() === te[_$_b208[1626]];
            }, xe = function() {
              return (0, te[_$_b208[189]])() && (0, te[_$_b208[1497]])()[_$_b208[1498]] === te[_$_b208[1625]];
            }, ke = function() {
              return xe() || Ne();
            };
            te[_$_b208[187]] = ke;
            var Le = function() {
              return (0, te[_$_b208[461]])() && (0, te[_$_b208[1496]])() === te[_$_b208[2120]];
            }, He = function() {
              return (0, te[_$_b208[189]])() && (0, te[_$_b208[1497]])()[_$_b208[1498]] === te[_$_b208[2119]];
            }, We = function() {
              return He() || Le();
            };
            te[_$_b208[2096]] = We;
          }, 56555: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[353]] = he;
            var ne = ee(43485), ie = 30, ae = 10;
            function ce(_e) {
              var le = { forwardduration: ie, backwardduration: ae }, se = { buffer: { video: le, audio: le }, playback: { autoplay: !0 }, tweaks: { minimal_backward_buffer_clearing_interval: 5 } };
              return _e && (se[_$_b208[716]][_$_b208[2134]] = _e, se[_$_b208[716]][_$_b208[2135]] = !0, se[_$_b208[2136]] = { config: { origin: _e } }), se;
            }
            function he(_e) {
              if ((0, ne[_$_b208[1885]])() && !_e)
                throw new Error(_$_b208[2137]);
              return ce(_e);
            }
          }, 57042: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[224]] || function() {
              var he = function(_e, le) {
                return he = Object[_$_b208[225]] || { __proto__: [] } instanceof Array && function(se, oe) {
                  se[_$_b208[226]] = oe;
                } || function(se, oe) {
                  for (var ue in oe)
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](oe, ue) && (se[ue] = oe[ue]);
                }, he(_e, le);
              };
              return function(_e, le) {
                if (_$_b208[161] != typeof le && le !== null)
                  throw new TypeError(_$_b208[227] + String(le) + _$_b208[228]);
                function se() {
                  this[_$_b208[229]] = _e;
                }
                he(_e, le), _e[_$_b208[21]] = le === null ? Object[_$_b208[230]](le) : (se[_$_b208[21]] = le[_$_b208[21]], new se());
              };
            }();
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2138]] = void 0;
            var ie = ee(63546), ae = ee(35148), ce = function(he) {
              function _e(le, se) {
                return he[_$_b208[19]](this, ae[_$_b208[950]][_$_b208[1446]], se, { moduleName: le }) || this;
              }
              return ne(_e, he), _e;
            }(ie[_$_b208[951]]);
            te[_$_b208[2138]] = ce;
          }, 57620: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2139]] = ce, te[_$_b208[2140]] = he;
            var ne = ee(62510), ie = ee(92737), ae = ee(9560);
            function ce(le, se, oe) {
              le != null && le !== se && oe && oe[_$_b208[503]](ne[_$_b208[482]][_$_b208[2141]], { from: le, to: se });
            }
            function he(le, se) {
              var oe;
              se === void 0 && (se = !1);
              var ue = _e(le) ? le[_$_b208[112]][_$_b208[113]] : le[_$_b208[113]], be = _e(le) ? le[_$_b208[120]] : JSON[_$_b208[1012]](le), ve = _e(le) ? le[_$_b208[112]] : { errorMessage: JSON[_$_b208[1012]](le), code: ue };
              se && (ve[_$_b208[2142]] = be);
              var me = (oe = ae[_$_b208[363]][ae[_$_b208[364]][ue]]) !== null && oe !== void 0 ? oe : ie[_$_b208[369]][_$_b208[1404]];
              return new ie[_$_b208[720]](me, ve, _$_b208[2143]);
            }
            function _e(le) {
              return _$_b208[112] in le;
            }
          }, 57782: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1217]] = ae, te[_$_b208[2144]] = ce;
            var ne = ee(15231), ie = ee(18068);
            function ae(he, _e) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1325]][_$_b208[1326]], { mimeType: he, preferredBitrate: _e });
            }
            function ce(he) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1325]][_$_b208[1328]], { mimeType: he });
            }
          }, 58935: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[629]] || function(le, se, oe) {
              if (oe || arguments[_$_b208[18]] === 2)
                for (var ue, be = 0, ve = se[_$_b208[18]]; be < ve; be++)
                  !ue && be in se || (ue || (ue = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](se, 0, be)), ue[be] = se[be]);
              return le[_$_b208[94]](ue || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](se));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[752]] = te[_$_b208[150]] = void 0;
            var ie, ae = ee(64430), ce = ee(33696);
            (function(le) {
              le[le[_$_b208[1576]] = 0] = _$_b208[1576], le[le[_$_b208[155]] = 1] = _$_b208[155], le[le[_$_b208[149]] = 2] = _$_b208[149], le[le[_$_b208[1573]] = 3] = _$_b208[1573], le[le[_$_b208[1574]] = 4] = _$_b208[1574], le[le[_$_b208[1575]] = 5] = _$_b208[1575];
            })(ie || (te[_$_b208[150]] = ie = {}));
            var he = function() {
              function le(se, oe) {
                oe === void 0 && (oe = ie[_$_b208[1574]]), this[_$_b208[81]] = se, this[_$_b208[805]](oe);
              }
              return le[_$_b208[21]][_$_b208[806]] = function(se) {
                this[_$_b208[2145]] = se[_$_b208[803]] && _$_b208[161] == typeof se[_$_b208[803]]()[_$_b208[2146]] ? se[_$_b208[803]]()[_$_b208[2146]] : void 0;
              }, le[_$_b208[21]][_$_b208[805]] = function(se) {
                _$_b208[348] == typeof se && (se = le[_$_b208[2147]](se)), this[_$_b208[804]] = se;
              }, le[_$_b208[21]][_$_b208[2148]] = function() {
                return this[_$_b208[804]];
              }, le[_$_b208[21]][_$_b208[151]] = function(se) {
                return !(this[_$_b208[2145]] === void 0 || se === ie[_$_b208[155]]) || this[_$_b208[804]] !== ie[_$_b208[1576]] && this[_$_b208[804]] <= se;
              }, le[_$_b208[21]][_$_b208[980]] = function(se) {
                this[_$_b208[81]] = se;
              }, le[_$_b208[2147]] = function(se) {
                switch (se) {
                  case ae[_$_b208[2149]][_$_b208[149]]:
                    return ie[_$_b208[149]];
                  case ae[_$_b208[2149]][_$_b208[1573]]:
                    return ie[_$_b208[1573]];
                  case ae[_$_b208[2149]][_$_b208[1574]]:
                    return ie[_$_b208[1574]];
                  case ae[_$_b208[2149]][_$_b208[1575]]:
                    return ie[_$_b208[1575]];
                  default:
                    return ie[_$_b208[1576]];
                }
              }, le[_$_b208[21]][_$_b208[2150]] = function(se, oe, ue) {
                var be, ve, me, pe = _e(se), fe = ne([], ue, !0);
                if (this[_$_b208[804]] > 0 && this[_$_b208[804]] <= se && (_$_b208[348] == typeof this[_$_b208[81]][_$_b208[2151]] && this[_$_b208[81]][_$_b208[2151]][_$_b208[18]] > 0 ? (be = console[pe])[_$_b208[19]][_$_b208[22]](be, ne([console, this[_$_b208[81]][_$_b208[2151]], oe], fe, !1)) : (ve = console[pe])[_$_b208[19]][_$_b208[22]](ve, ne([console, oe], fe, !1))), this[_$_b208[2145]] && se !== ie[_$_b208[155]])
                  try {
                    (me = this[_$_b208[2145]])[_$_b208[19]][_$_b208[22]](me, ne([null, pe, oe], fe, !1));
                  } catch {
                  }
              }, le[_$_b208[21]][_$_b208[156]] = function(se) {
                for (var oe = [], ue = 1; ue < arguments[_$_b208[18]]; ue++)
                  oe[ue - 1] = arguments[ue];
                this[_$_b208[2150]](ie[_$_b208[155]], se, oe);
              }, le[_$_b208[21]][_$_b208[154]] = function(se) {
                for (var oe = [], ue = 1; ue < arguments[_$_b208[18]]; ue++)
                  oe[ue - 1] = arguments[ue];
                this[_$_b208[2150]](ie[_$_b208[149]], se, oe);
              }, le[_$_b208[21]][_$_b208[1037]] = function(se) {
                for (var oe = [], ue = 1; ue < arguments[_$_b208[18]]; ue++)
                  oe[ue - 1] = arguments[ue];
                this[_$_b208[2150]](ie[_$_b208[1573]], se, oe);
              }, le[_$_b208[21]][_$_b208[721]] = function(se) {
                for (var oe = [], ue = 1; ue < arguments[_$_b208[18]]; ue++)
                  oe[ue - 1] = arguments[ue];
                this[_$_b208[2150]](ie[_$_b208[1574]], se, oe);
              }, le[_$_b208[21]][_$_b208[90]] = function(se) {
                for (var oe = [], ue = 1; ue < arguments[_$_b208[18]]; ue++)
                  oe[ue - 1] = arguments[ue];
                this[_$_b208[2150]](ie[_$_b208[1575]], se, oe);
              }, le[_$_b208[21]][_$_b208[992]] = function(se, oe, ue) {
                navigator[_$_b208[1915]][_$_b208[138]](_$_b208[2152]) > -1 || navigator[_$_b208[1915]][_$_b208[138]](_$_b208[2153]) > -1 ? console[_$_b208[1037]](se) : console[_$_b208[1037]](_$_b208[2154] + se, _$_b208[2155] + oe + _$_b208[2156] + ue + _$_b208[2157]);
              }, le;
            }();
            function _e(le) {
              switch (le) {
                case ie[_$_b208[155]]:
                case ie[_$_b208[149]]:
                  return ce[_$_b208[150]][_$_b208[149]];
                case ie[_$_b208[1573]]:
                  return ce[_$_b208[150]][_$_b208[1573]];
                case ie[_$_b208[1574]]:
                  return ce[_$_b208[150]][_$_b208[1574]];
                case ie[_$_b208[1575]]:
                  return ce[_$_b208[150]][_$_b208[1575]];
                default:
                  return null;
              }
            }
            te[_$_b208[752]] = he;
          }, 58975: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2158]] = te[_$_b208[2159]] = te[_$_b208[2160]] = te[_$_b208[821]] = te[_$_b208[2161]] = te[_$_b208[770]] = te[_$_b208[768]] = te[_$_b208[2162]] = te[_$_b208[2163]] = te[_$_b208[1130]] = te[_$_b208[2164]] = te[_$_b208[2165]] = te[_$_b208[2166]] = te[_$_b208[2167]] = te[_$_b208[2168]] = te[_$_b208[2169]] = te[_$_b208[2170]] = te[_$_b208[820]] = te[_$_b208[2171]] = te[_$_b208[2172]] = te[_$_b208[2173]] = te[_$_b208[2174]] = te[_$_b208[584]] = void 0;
            var ne = ee(70016), ie = ee(3464), ae = ee(76420), ce = function(Ae) {
              return Ae[_$_b208[769]];
            };
            te[_$_b208[584]] = ce;
            var he = function(Ae) {
              return Ae[_$_b208[2175]] === ae[_$_b208[1303]][_$_b208[1302]];
            };
            te[_$_b208[2174]] = he;
            var _e = function(Ae) {
              return Ae[_$_b208[2175]] === ae[_$_b208[1303]][_$_b208[1193]];
            };
            te[_$_b208[2173]] = _e;
            var le = function(Ae) {
              return Ae[_$_b208[2175]] === ae[_$_b208[1303]][_$_b208[2176]];
            };
            te[_$_b208[2172]] = le;
            var se = function(Ae) {
              return Ae[_$_b208[2175]] === ae[_$_b208[1303]][_$_b208[2177]];
            };
            te[_$_b208[2171]] = se;
            var oe = function(Ae) {
              return Ae[_$_b208[2175]] === ae[_$_b208[1303]][_$_b208[2178]];
            };
            te[_$_b208[820]] = oe;
            var ue = function(Ae) {
              return !Ae[_$_b208[2179]] && Ae[_$_b208[910]];
            };
            te[_$_b208[2170]] = ue;
            var be = function(Ae) {
              return Ae[_$_b208[2180]] === ae[_$_b208[1304]][_$_b208[1302]];
            };
            te[_$_b208[2169]] = be;
            var ve = function(Ae) {
              return [ae[_$_b208[1304]][_$_b208[2181]], ae[_$_b208[1304]][_$_b208[2182]]][_$_b208[26]](Ae[_$_b208[2180]]);
            };
            te[_$_b208[2168]] = ve;
            var me = function(Ae) {
              return Ae[_$_b208[2180]] === ae[_$_b208[1304]][_$_b208[2183]];
            };
            te[_$_b208[2167]] = me;
            var pe = function(Ae) {
              return Ae[_$_b208[2184]] === ae[_$_b208[1305]][_$_b208[2185]];
            };
            te[_$_b208[2166]] = pe;
            var fe = function(Ae) {
              return Ae[_$_b208[2184]] === ae[_$_b208[1305]][_$_b208[2186]];
            };
            te[_$_b208[2165]] = fe;
            var ge = function(Ae) {
              return Ae[_$_b208[2187]];
            };
            te[_$_b208[2164]] = ge;
            var ye = function(Ae) {
              return Ae[_$_b208[491]];
            };
            te[_$_b208[1130]] = ye;
            var $e = function(Ae) {
              return (0, te[_$_b208[2168]])(Ae) || (0, te[_$_b208[2166]])(Ae);
            };
            te[_$_b208[2163]] = $e;
            var Se = function(Ae) {
              return (0, te[_$_b208[2167]])(Ae) || (0, te[_$_b208[2165]])(Ae);
            };
            te[_$_b208[2162]] = Se;
            var Ce = function(Ae) {
              return Ae[_$_b208[2188]] !== ae[_$_b208[1134]][_$_b208[1302]];
            };
            te[_$_b208[768]] = Ce;
            var Ie = function(Ae) {
              return Ae[_$_b208[2188]] === ae[_$_b208[1134]][_$_b208[1138]];
            };
            te[_$_b208[770]] = Ie;
            var Te = function(Ae) {
              return Ae[_$_b208[2189]];
            };
            te[_$_b208[2161]] = Te;
            var Ee = function(Ae) {
              return Ae[_$_b208[2190]];
            };
            te[_$_b208[821]] = Ee;
            var we = function(Ae, Oe) {
              return (0, ie[_$_b208[183]])(Ae)(function(Be) {
                return Be && (0, te[_$_b208[584]])(Be);
              }, Oe, function(Be, Ve) {
                return (0, ne[_$_b208[2191]])(Ve) && (0, ne[_$_b208[2191]])(Be) && !(0, te[_$_b208[2168]])(Ve) && (0, te[_$_b208[2168]])(Be);
              });
            };
            te[_$_b208[2160]] = we;
            var Pe = function(Ae, Oe) {
              return (0, ie[_$_b208[183]])(Ae)(function(Be) {
                return Be && (0, te[_$_b208[584]])(Be);
              }, Oe, function(Be, Ve) {
                return (0, ne[_$_b208[2191]])(Ve) && (0, ne[_$_b208[2191]])(Be) && (0, te[_$_b208[2168]])(Ve) && !(0, te[_$_b208[2168]])(Be);
              });
            };
            te[_$_b208[2159]] = Pe;
            var Me = function(Ae, Oe) {
              return (0, ie[_$_b208[183]])(Ae)(function(Be) {
                return Be && (0, te[_$_b208[584]])(Be) && (0, te[_$_b208[2163]])((0, te[_$_b208[584]])(Be));
              }, Oe, function(Be, Ve) {
                return Ve === !0 && Be === !1;
              });
            };
            te[_$_b208[2158]] = Me;
          }, 59181: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2192]] = void 0, function(ne) {
              ne[_$_b208[781]] = _$_b208[2193], ne[_$_b208[784]] = _$_b208[1896], ne[_$_b208[788]] = _$_b208[2194];
            }(ee || (te[_$_b208[2192]] = ee = {}));
          }, 59510: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[489]] = void 0;
            var ne = ee(18665), ie = ee(62510), ae = ee(17990), ce = ee(58975), he = ee(76420), _e = function() {
              function le(se) {
                var oe = this;
                this[_$_b208[2195]] = function() {
                  oe[_$_b208[551]]((0, ae[_$_b208[1286]])(!1));
                }, this[_$_b208[2196]] = function() {
                  oe[_$_b208[551]]((0, ae[_$_b208[1286]])(!0));
                }, this[_$_b208[584]] = function() {
                  return ce[_$_b208[584]](oe[_$_b208[46]][_$_b208[553]][_$_b208[182]]());
                }, this[_$_b208[551]] = function(ue) {
                  oe[_$_b208[46]][_$_b208[553]][_$_b208[552]](ue);
                }, this[_$_b208[2197]] = function(ue, be) {
                  oe[_$_b208[2175]] !== ue && (oe[_$_b208[2175]] = ue, oe[_$_b208[551]]((0, ae[_$_b208[1294]])(ue))), be && be();
                }, this[_$_b208[2198]] = function(ue, be) {
                  if (oe[_$_b208[2175]] !== ue)
                    oe[_$_b208[2175]] = ue, oe[_$_b208[551]]((0, ae[_$_b208[1295]])(ue));
                  else {
                    if (!oe[_$_b208[2199]](ue))
                      return;
                    oe[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[2200][_$_b208[94]](he[_$_b208[1303]][ue])), oe[_$_b208[551]]((0, ae[_$_b208[1296]])(0));
                  }
                  be && be();
                }, this[_$_b208[46]] = se, this[_$_b208[160]] = se[_$_b208[160]], this[_$_b208[160]][_$_b208[404]](ie[_$_b208[482]][_$_b208[1193]], this[_$_b208[2196]], !0), this[_$_b208[160]][_$_b208[404]](ie[_$_b208[482]][_$_b208[689]], this[_$_b208[2195]], !0), this[_$_b208[551]]((0, ae[_$_b208[1300]])([_$_b208[560], _$_b208[2190]])), this[_$_b208[2201]] = se[_$_b208[494]][_$_b208[199]](ne[_$_b208[490]][_$_b208[1077]]), this[_$_b208[2202]] = !1;
              }
              return le[_$_b208[21]][_$_b208[64]] = function() {
                this[_$_b208[2203]](!1), this[_$_b208[2204]](), this[_$_b208[2175]] = he[_$_b208[1303]][_$_b208[1302]], this[_$_b208[2180]] = he[_$_b208[1304]][_$_b208[1302]];
              }, Object[_$_b208[13]](le[_$_b208[21]], _$_b208[2175], { get: function() {
                return this[_$_b208[584]]()[_$_b208[2175]];
              }, set: function(se) {
                var oe = this[_$_b208[584]]()[_$_b208[2175]];
                this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[2206][_$_b208[94]](he[_$_b208[1303]][oe], _$_b208[2205])[_$_b208[94]](he[_$_b208[1303]][se])), this[_$_b208[551]]((0, ae[_$_b208[1288]])(se));
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[2180], { get: function() {
                return this[_$_b208[584]]()[_$_b208[2180]];
              }, set: function(se) {
                var oe = this[_$_b208[584]]()[_$_b208[2180]];
                this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[2207][_$_b208[94]](he[_$_b208[1304]][oe], _$_b208[2205])[_$_b208[94]](he[_$_b208[1304]][se])), this[_$_b208[551]]((0, ae[_$_b208[1287]])(se));
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[2184], { get: function() {
                return this[_$_b208[584]]()[_$_b208[2184]];
              }, set: function(se) {
                var oe = this[_$_b208[584]]()[_$_b208[2184]];
                this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[2208][_$_b208[94]](he[_$_b208[1305]][oe], _$_b208[2205])[_$_b208[94]](he[_$_b208[1305]][se])), this[_$_b208[551]]((0, ae[_$_b208[1289]])(se));
              }, enumerable: !1, configurable: !0 }), le[_$_b208[21]][_$_b208[2209]] = function(se, oe, ue, be) {
                this[_$_b208[2180]] = se, be && this[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[2210]], { position: this[_$_b208[895]](), seekTarget: oe, issuer: ue || _$_b208[660] }), this[_$_b208[551]]((0, ae[_$_b208[1292]])(oe));
              }, le[_$_b208[21]][_$_b208[2211]] = function(se, oe, ue) {
                ue === void 0 && (ue = !0), this[_$_b208[2209]](he[_$_b208[1304]][_$_b208[2181]], se, oe, ue);
              }, le[_$_b208[21]][_$_b208[2212]] = function(se, oe, ue) {
                return ue === void 0 && (ue = !0), this[_$_b208[2209]](he[_$_b208[1304]][_$_b208[2182]], se, oe, ue);
              }, le[_$_b208[21]][_$_b208[2203]] = function(se) {
                se === void 0 && (se = !0), this[_$_b208[232]]() && (this[_$_b208[2180]] = he[_$_b208[1304]][_$_b208[2183]], se && this[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[2183]])), this[_$_b208[2213]]();
              }, le[_$_b208[21]][_$_b208[2213]] = function() {
                this[_$_b208[551]]((0, ae[_$_b208[1292]])(-1));
              }, le[_$_b208[21]][_$_b208[232]] = function() {
                return ce[_$_b208[2168]](this[_$_b208[584]]());
              }, le[_$_b208[21]][_$_b208[2214]] = function(se, oe, ue, be) {
                be === void 0 && (be = !0), this[_$_b208[551]]((0, ae[_$_b208[1289]])(he[_$_b208[1305]][_$_b208[2185]])), be && this[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[2215]], { position: se, target: oe, issuer: ue || _$_b208[660] }), this[_$_b208[551]]((0, ae[_$_b208[1292]])(oe));
              }, le[_$_b208[21]][_$_b208[2216]] = function(se) {
                se === void 0 && (se = !0), this[_$_b208[551]]((0, ae[_$_b208[1289]])(he[_$_b208[1305]][_$_b208[2186]])), se && this[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[2217]]), this[_$_b208[2213]]();
              }, le[_$_b208[21]][_$_b208[2218]] = function() {
                this[_$_b208[551]]((0, ae[_$_b208[1288]])(he[_$_b208[1303]][_$_b208[2178]]));
              }, le[_$_b208[21]][_$_b208[2219]] = function() {
                return ce[_$_b208[2174]](this[_$_b208[584]]());
              }, le[_$_b208[21]][_$_b208[2220]] = function() {
                return ce[_$_b208[2166]](this[_$_b208[584]]());
              }, Object[_$_b208[13]](le[_$_b208[21]], _$_b208[910], { get: function() {
                return this[_$_b208[584]]()[_$_b208[910]];
              }, set: function(se) {
                this[_$_b208[551]]((0, ae[_$_b208[1290]])(se));
              }, enumerable: !1, configurable: !0 }), le[_$_b208[21]][_$_b208[2221]] = function(se) {
                this[_$_b208[551]]((0, ae[_$_b208[1291]])(se)), se && this[_$_b208[1153]]() && !this[_$_b208[2222]]() && (this[_$_b208[2202]] = !0), se ? this[_$_b208[2223]]() : this[_$_b208[2204]]();
              }, le[_$_b208[21]][_$_b208[2224]] = function() {
                return ce[_$_b208[2161]](this[_$_b208[584]]());
              }, le[_$_b208[21]][_$_b208[1153]] = function() {
                return ce[_$_b208[2173]](this[_$_b208[584]]());
              }, le[_$_b208[21]][_$_b208[2225]] = function() {
                return ce[_$_b208[2172]](this[_$_b208[584]]());
              }, le[_$_b208[21]][_$_b208[1155]] = function() {
                return ce[_$_b208[2171]](this[_$_b208[584]]());
              }, le[_$_b208[21]][_$_b208[2226]] = function() {
                return ce[_$_b208[820]](this[_$_b208[584]]());
              }, le[_$_b208[21]][_$_b208[2223]] = function() {
                this[_$_b208[2225]]() || this[_$_b208[232]]() || this[_$_b208[2220]]() || !(!this[_$_b208[232]]() && !this[_$_b208[2220]]()) || this[_$_b208[910]] || this[_$_b208[1155]]() || this[_$_b208[2226]]() || (this[_$_b208[910]] = !0, this[_$_b208[2201]][_$_b208[1360]](), this[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[2227]], {}));
              }, le[_$_b208[21]][_$_b208[2204]] = function() {
                this[_$_b208[910]] && (this[_$_b208[910]] = !1, this[_$_b208[2201]][_$_b208[1362]](), this[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[2228]], {}));
              }, le[_$_b208[21]][_$_b208[2222]] = function() {
                return this[_$_b208[2199]](he[_$_b208[1303]][_$_b208[2177]]);
              }, le[_$_b208[21]][_$_b208[2199]] = function(se) {
                return this[_$_b208[584]]()[_$_b208[2229]][0] === se;
              }, le[_$_b208[21]][_$_b208[895]] = function() {
                return this[_$_b208[46]][_$_b208[587]][_$_b208[235]];
              }, le[_$_b208[21]][_$_b208[2230]] = function(se, oe, ue) {
                var be = this;
                this[_$_b208[1153]]() || (se ? ue(he[_$_b208[1303]][_$_b208[2176]], function() {
                  be[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[2176]], { time: be[_$_b208[895]](), issuer: oe }, !1);
                }) : ue(he[_$_b208[1303]][_$_b208[2176]]));
              }, le[_$_b208[21]][_$_b208[932]] = function(se, oe) {
                this[_$_b208[2230]](se, oe, this[_$_b208[2198]]);
              }, le[_$_b208[21]][_$_b208[2231]] = function(se, oe) {
                this[_$_b208[2230]](se, oe, this[_$_b208[2197]]);
              }, le[_$_b208[21]][_$_b208[2232]] = function(se, oe) {
                var ue = this;
                oe === void 0 && (oe = !0), this[_$_b208[2198]](he[_$_b208[1303]][_$_b208[1193]], function() {
                  oe && ue[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[1193]], { time: ue[_$_b208[895]](), issuer: se }, !1);
                });
              }, le[_$_b208[21]][_$_b208[952]] = function(se, oe, ue) {
                var be = this;
                if (ue === void 0 && (ue = !1), ue && this[_$_b208[2202]])
                  return this[_$_b208[46]][_$_b208[148]][_$_b208[156]](_$_b208[2233]), void (this[_$_b208[2202]] = !1);
                this[_$_b208[2202]] = !1, se && this[_$_b208[910]] && this[_$_b208[2204]](), this[_$_b208[46]][_$_b208[587]][_$_b208[245]] || (se ? this[_$_b208[2198]](he[_$_b208[1303]][_$_b208[2177]], function() {
                  be[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[2177]], { time: be[_$_b208[895]](), issuer: oe }, !1);
                }) : this[_$_b208[2197]](he[_$_b208[1303]][_$_b208[2177]]));
              }, Object[_$_b208[13]](le[_$_b208[21]], _$_b208[2187], { get: function() {
                return this[_$_b208[584]]()[_$_b208[2187]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[491], { get: function() {
                var se = this[_$_b208[584]]()[_$_b208[491]];
                return se[_$_b208[2234]] * se[_$_b208[2235]];
              }, enumerable: !1, configurable: !0 }), le[_$_b208[21]][_$_b208[492]] = function(se, oe, ue) {
                oe === void 0 && (oe = 1), ue === void 0 && (ue = !0);
                var be = ce[_$_b208[1130]](this[_$_b208[584]]());
                be[_$_b208[2234]] === se && be[_$_b208[2235]] === oe || (this[_$_b208[551]]((0, ae[_$_b208[1293]])({ speed: se, multiplier: oe })), ue && this[_$_b208[160]][_$_b208[503]](ie[_$_b208[482]][_$_b208[2236]], { from: be[_$_b208[2234]], to: se }));
              }, Object[_$_b208[13]](le[_$_b208[21]], _$_b208[2237], { get: function() {
                return ce[_$_b208[2163]](this[_$_b208[584]]());
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[2238], { get: function() {
                return ce[_$_b208[2162]](this[_$_b208[584]]());
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[2239], { get: function() {
                return ce[_$_b208[2170]](this[_$_b208[584]]());
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](le[_$_b208[21]], _$_b208[2179], { get: function() {
                return this[_$_b208[584]]()[_$_b208[2179]];
              }, enumerable: !1, configurable: !0 }), le[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[160]][_$_b208[688]](ie[_$_b208[482]][_$_b208[1193]], this[_$_b208[2196]]), this[_$_b208[160]][_$_b208[688]](ie[_$_b208[482]][_$_b208[689]], this[_$_b208[2195]]);
              }, le;
            }();
            te[_$_b208[489]] = _e;
          }, 60627: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1098]] = ae;
            var ne = ee(15231), ie = ee(73448);
            function ae(ce) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[2241]][_$_b208[2240]], { url: ce });
            }
          }, 60997: function(re, te) {
            _$_b208[11];
            function ee(ne) {
              ne && ne[_$_b208[70]]();
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[70]] = ee;
          }, 61489: function(re, te, ee) {
            _$_b208[11];
            var ne, ie = this && this[_$_b208[16]] || function() {
              return ie = Object[_$_b208[17]] || function(oe) {
                for (var ue, be = 1, ve = arguments[_$_b208[18]]; be < ve; be++)
                  for (var me in ue = arguments[be])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](ue, me) && (oe[me] = ue[me]);
                return oe;
              }, ie[_$_b208[22]](this, arguments);
            }, ae = this && this[_$_b208[629]] || function(oe, ue, be) {
              if (be || arguments[_$_b208[18]] === 2)
                for (var ve, me = 0, pe = ue[_$_b208[18]]; me < pe; me++)
                  !ve && me in ue || (ve || (ve = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](ue, 0, me)), ve[me] = ue[me]);
              return oe[_$_b208[94]](ve || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](ue));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2242]] = void 0;
            var ce = ee(21829), he = ee(17990), _e = ee(76420), le = (0, he[_$_b208[1285]])();
            function se(oe, ue) {
              return ie(ie({}, oe), { isRendererStalled: ue[_$_b208[1464]] });
            }
            te[_$_b208[2242]] = (0, ce[_$_b208[302]])(le, ((ne = {})[_e[_$_b208[1307]][_$_b208[1310]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { playbackState: be });
            }, ne[_e[_$_b208[1307]][_$_b208[1309]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { seekState: be });
            }, ne[_e[_$_b208[1307]][_$_b208[1312]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { isStalled: be });
            }, ne[_e[_$_b208[1307]][_$_b208[1313]]] = se, ne[_e[_$_b208[1307]][_$_b208[1311]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { timeShiftState: be });
            }, ne[_e[_$_b208[1307]][_$_b208[1308]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { hasBeenPlaying: be });
            }, ne[_e[_$_b208[1307]][_$_b208[1314]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { targetPlaybackTime: be });
            }, ne[_e[_$_b208[1307]][_$_b208[1315]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { playbackSpeed: be });
            }, ne[_e[_$_b208[1307]][_$_b208[1306]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { viewMode: be });
            }, ne[_e[_$_b208[1307]][_$_b208[1317]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { pendingTransitions: ae(ae([], oe[_$_b208[2229]], !0), [be], !1) });
            }, ne[_e[_$_b208[1307]][_$_b208[1318]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { pendingTransitions: oe[_$_b208[2229]][_$_b208[165]](function(ve) {
                return ve !== be;
              }) });
            }, ne[_e[_$_b208[1307]][_$_b208[1319]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { pendingTransitions: oe[_$_b208[2229]][_$_b208[165]](function(ve, me) {
                return me !== be;
              }) });
            }, ne[_e[_$_b208[1307]][_$_b208[1320]]] = function(oe, ue) {
              return ie(ie({}, oe), { pendingTransitions: [] });
            }, ne[_e[_$_b208[1307]][_$_b208[1323]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]][_$_b208[2243]], ve = {};
              return be[_$_b208[68]](function(me) {
                return ve[me] = oe[me];
              }), ie(ie({}, le), ve);
            }, ne[_e[_$_b208[1307]][_$_b208[1316]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { destroyState: be });
            }, ne[_e[_$_b208[1307]][_$_b208[1321]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { remoteControlState: ie(ie({}, oe[_$_b208[2190]]), { remoteControlType: be }) });
            }, ne[_e[_$_b208[1307]][_$_b208[1322]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { remoteControlState: ie(ie({}, oe[_$_b208[2190]]), { connectionState: be }) });
            }, ne[_e[_$_b208[1307]][_$_b208[1324]]] = function(oe, ue) {
              var be = ue[_$_b208[1464]];
              return ie(ie({}, oe), { seekingProcess: ie(ie({}, oe[_$_b208[2244]]), be) });
            }, ne));
          }, 61878: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2245]] = void 0;
            var ee = function() {
              function ne() {
              }
              return ne[_$_b208[2246]] = function(ie) {
                for (ie[_$_b208[598]](_$_b208[274], _$_b208[265]), ie[_$_b208[1537]](_$_b208[274]); ie[_$_b208[1522]]; )
                  ie[_$_b208[963]](ie[_$_b208[1522]]);
              }, ne;
            }();
            te[_$_b208[2245]] = ee;
          }, 62510: function(re, te) {
            _$_b208[11];
            var ee, ne, ie, ae, ce;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2247]] = te[_$_b208[2248]] = te[_$_b208[2249]] = te[_$_b208[74]] = te[_$_b208[482]] = void 0, function(he) {
              he[_$_b208[497]] = _$_b208[1691], he[_$_b208[2176]] = _$_b208[167], he[_$_b208[1193]] = _$_b208[168], he[_$_b208[2177]] = _$_b208[237], he[_$_b208[2210]] = _$_b208[835], he[_$_b208[2183]] = _$_b208[238], he[_$_b208[2215]] = _$_b208[2250], he[_$_b208[2217]] = _$_b208[2251], he[_$_b208[486]] = _$_b208[2252], he[_$_b208[481]] = _$_b208[479], he[_$_b208[485]] = _$_b208[2253], he[_$_b208[555]] = _$_b208[2254], he[_$_b208[739]] = _$_b208[2255], he[_$_b208[1060]] = _$_b208[90], he[_$_b208[948]] = _$_b208[2256], he[_$_b208[2227]] = _$_b208[2257], he[_$_b208[2228]] = _$_b208[2258], he[_$_b208[2259]] = _$_b208[2260], he[_$_b208[2261]] = _$_b208[2262], he[_$_b208[2263]] = _$_b208[2264], he[_$_b208[2265]] = _$_b208[2266], he[_$_b208[2267]] = _$_b208[2268], he[_$_b208[2269]] = _$_b208[2270], he[_$_b208[2271]] = _$_b208[2272], he[_$_b208[2273]] = _$_b208[2274], he[_$_b208[2275]] = _$_b208[2276], he[_$_b208[2277]] = _$_b208[2278], he[_$_b208[2279]] = _$_b208[2280], he[_$_b208[665]] = _$_b208[2281], he[_$_b208[2282]] = _$_b208[2283], he[_$_b208[2284]] = _$_b208[2285], he[_$_b208[2286]] = _$_b208[2287], he[_$_b208[2288]] = _$_b208[2289], he[_$_b208[28]] = _$_b208[2290], he[_$_b208[2291]] = _$_b208[30], he[_$_b208[1480]] = _$_b208[2292], he[_$_b208[2293]] = _$_b208[2294], he[_$_b208[2295]] = _$_b208[2296], he[_$_b208[2297]] = _$_b208[2298], he[_$_b208[2299]] = _$_b208[2300], he[_$_b208[2301]] = _$_b208[2302], he[_$_b208[2303]] = _$_b208[2304], he[_$_b208[930]] = _$_b208[2305], he[_$_b208[2306]] = _$_b208[2307], he[_$_b208[2249]] = _$_b208[2308], he[_$_b208[2309]] = _$_b208[2310], he[_$_b208[2311]] = _$_b208[2312], he[_$_b208[2313]] = _$_b208[2314], he[_$_b208[2315]] = _$_b208[2316], he[_$_b208[929]] = _$_b208[2317], he[_$_b208[2318]] = _$_b208[2319], he[_$_b208[2320]] = _$_b208[2321], he[_$_b208[2322]] = _$_b208[2323], he[_$_b208[2324]] = _$_b208[2325], he[_$_b208[2326]] = _$_b208[2327], he[_$_b208[2328]] = _$_b208[2329], he[_$_b208[2330]] = _$_b208[2331], he[_$_b208[2332]] = _$_b208[2333], he[_$_b208[2334]] = _$_b208[2335], he[_$_b208[2336]] = _$_b208[2337], he[_$_b208[2338]] = _$_b208[2339], he[_$_b208[2340]] = _$_b208[2341], he[_$_b208[687]] = _$_b208[2342], he[_$_b208[689]] = _$_b208[2343], he[_$_b208[2344]] = _$_b208[2345], he[_$_b208[2346]] = _$_b208[2347], he[_$_b208[2348]] = _$_b208[2349], he[_$_b208[2350]] = _$_b208[2351], he[_$_b208[2352]] = _$_b208[2353], he[_$_b208[2354]] = _$_b208[2355], he[_$_b208[2356]] = _$_b208[2357], he[_$_b208[2358]] = _$_b208[2359], he[_$_b208[1143]] = _$_b208[1132], he[_$_b208[2236]] = _$_b208[2360], he[_$_b208[2141]] = _$_b208[2361], he[_$_b208[567]] = _$_b208[2362], he[_$_b208[777]] = _$_b208[2363], he[_$_b208[858]] = _$_b208[2364], he[_$_b208[853]] = _$_b208[2365], he[_$_b208[859]] = _$_b208[2366], he[_$_b208[860]] = _$_b208[2367], he[_$_b208[2368]] = _$_b208[2369], he[_$_b208[2370]] = _$_b208[2371], he[_$_b208[2372]] = _$_b208[2373], he[_$_b208[2374]] = _$_b208[2375], he[_$_b208[2376]] = _$_b208[2377], he[_$_b208[2378]] = _$_b208[2379], he[_$_b208[682]] = _$_b208[2380], he[_$_b208[2381]] = _$_b208[2382], he[_$_b208[2383]] = _$_b208[2384];
            }(ee || (te[_$_b208[482]] = ee = {})), function(he) {
              he[_$_b208[2385]] = _$_b208[2385], he[_$_b208[73]] = _$_b208[73], he[_$_b208[1478]] = _$_b208[2386], he[_$_b208[2387]] = _$_b208[2387], he[_$_b208[2388]] = _$_b208[2388], he[_$_b208[2389]] = _$_b208[2389], he[_$_b208[2390]] = _$_b208[2390], he[_$_b208[2391]] = _$_b208[2391];
            }(ne || (te[_$_b208[74]] = ne = {})), function(he) {
              he[_$_b208[2392]] = _$_b208[2393], he[_$_b208[2394]] = _$_b208[2395], he[_$_b208[2396]] = _$_b208[2397];
            }(ie || (te[_$_b208[2249]] = ie = {})), function(he) {
              he[_$_b208[2398]] = _$_b208[2399];
            }(ae || (te[_$_b208[2248]] = ae = {})), function(he) {
              he[_$_b208[2400]] = _$_b208[2401], he[_$_b208[2402]] = _$_b208[2403], he[_$_b208[2404]] = _$_b208[2405], he[_$_b208[2406]] = _$_b208[1600];
            }(ce || (te[_$_b208[2247]] = ce = {}));
          }, 62987: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[801]] = void 0;
            var ne = ee(47384), ie = ee(60997), ae = ee(87326), ce = ee(88141), he = ee(61489), _e = ee(13533), le = ee(77845), se = ee(54838), oe = ee(3570), ue = function() {
              function be(ve) {
                this[_$_b208[1620]] = ve[_$_b208[1620]], this[_$_b208[1225]] = se[_$_b208[172]][_$_b208[2061]](), this[_$_b208[349]] = ve[_$_b208[349]] || { playback: {} }, this[_$_b208[753]] = ve[_$_b208[753]], this[_$_b208[81]] = ve[_$_b208[81]] || ae[_$_b208[751]], this[_$_b208[2407]] = new ne[_$_b208[1957]](this[_$_b208[81]][_$_b208[2408]], ve[_$_b208[148]]), this[_$_b208[2409]] = ve[_$_b208[545]] || null, this[_$_b208[2410]](), this[_$_b208[148]] = ve[_$_b208[148]], this[_$_b208[160]] = ve[_$_b208[160]], this[_$_b208[494]] = ve[_$_b208[494]], this[_$_b208[798]] = ve[_$_b208[798]], this[_$_b208[799]] = ve[_$_b208[799]], this[_$_b208[800]] = ve[_$_b208[800]], this[_$_b208[587]] = oe[_$_b208[186]][_$_b208[212]](this, ve[_$_b208[587]]), this[_$_b208[508]] = !1;
              }
              return be[_$_b208[21]][_$_b208[2410]] = function() {
                this[_$_b208[553]] = new le[_$_b208[1222]]((0, _e[_$_b208[302]])(), _$_b208[2411], this[_$_b208[1225]]), this[_$_b208[553]][_$_b208[1223]](_$_b208[769], he[_$_b208[2242]]), this[_$_b208[553]][_$_b208[1223]](_$_b208[1485], ce[_$_b208[2412]]);
              }, be[_$_b208[21]][_$_b208[1226]] = function(ve) {
                this[_$_b208[671]] = ve;
              }, be[_$_b208[21]][_$_b208[1672]] = function(ve) {
                this[_$_b208[1681]] = ve;
              }, Object[_$_b208[13]](be[_$_b208[21]], _$_b208[512], { get: function() {
                return this[_$_b208[508]];
              }, enumerable: !1, configurable: !0 }), be[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[508]] = !0, this[_$_b208[494]] = (0, ie[_$_b208[70]])(this[_$_b208[494]]), this[_$_b208[1681]] = null, this[_$_b208[2409]] = null, this[_$_b208[160]] = null, this[_$_b208[798]] = null, this[_$_b208[799]] = null, this[_$_b208[800]] = null, this[_$_b208[553]] = (0, ie[_$_b208[70]])(this[_$_b208[553]]);
              }, be;
            }();
            te[_$_b208[801]] = ue;
          }, 63331: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2413]] = ie, te[_$_b208[2414]] = ae, te[_$_b208[2415]] = ce;
            var ne = ee(331);
            function ie(he, _e, le) {
              var se = {};
              return se[_$_b208[181]] = (0, ne[_$_b208[14]])(Date[_$_b208[1035]](he[_$_b208[2416]])), he[_$_b208[2417]] ? se[_$_b208[2418]] = (0, ne[_$_b208[14]])(Date[_$_b208[1035]](he[_$_b208[2417]])) : he[_$_b208[61]] === void 0 || isNaN(he[_$_b208[61]]) ? he[_$_b208[62]] && le && (se[_$_b208[2418]] = (0, ne[_$_b208[14]])(Date[_$_b208[1035]](le[_$_b208[2416]]))) : se[_$_b208[2418]] = (0, ne[_$_b208[14]])(Date[_$_b208[1035]](he[_$_b208[2416]])) + he[_$_b208[61]], _e && (se[_$_b208[181]] -= _e), se[_$_b208[2418]] && _e && (se[_$_b208[2418]] -= _e), se[_$_b208[1489]] = he, se;
            }
            function ae(he, _e, le) {
              for (var se = _e + 1; se < le[_$_b208[18]]; se++)
                if (le[se][_$_b208[1790]] && le[se][_$_b208[1790]] === he[_$_b208[1790]])
                  return le[se];
            }
            function ce(he, _e, le) {
              he[_$_b208[68]](function(se, oe, ue) {
                var be;
                se[_$_b208[62]] && se[_$_b208[1790]] && (be = ae(se, oe, ue));
                var ve = ie(se, _e, be);
                le(ve);
              });
            }
          }, 63546: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[951]] = void 0;
            var ne = ee(62510), ie = ee(35148), ae = function() {
              function ce(he, _e, le) {
                this[_$_b208[89]] = ne[_$_b208[482]][_$_b208[948]], this[_$_b208[113]] = he, this[_$_b208[176]] = ie[_$_b208[950]][he], this[_$_b208[119]] = _e || _$_b208[265][_$_b208[94]](this[_$_b208[113]], _$_b208[263])[_$_b208[94]](this[_$_b208[176]]), this[_$_b208[1489]] = le;
              }
              return ce;
            }();
            te[_$_b208[951]] = ae;
          }, 63668: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1539]] = void 0, te[_$_b208[2419]] = ce, te[_$_b208[2420]] = he, te[_$_b208[2421]] = _e, te[_$_b208[2422]] = le, te[_$_b208[2423]] = se, te[_$_b208[2424]] = oe;
            var ne = ee(15231), ie = ee(10950), ae = function() {
              return { keyIdsWithErrors: [], usedKeySystem: { kind: null, uid: null } };
            };
            function ce(ue) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[427]][_$_b208[428]], ue);
            }
            function he() {
              return (0, ne[_$_b208[626]])(ie[_$_b208[427]][_$_b208[430]]);
            }
            function _e(ue) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[427]][_$_b208[432]], ue);
            }
            function le() {
              return (0, ne[_$_b208[626]])(ie[_$_b208[427]][_$_b208[434]]);
            }
            function se(ue) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[427]][_$_b208[436]], ue);
            }
            function oe() {
              return (0, ne[_$_b208[626]])(ie[_$_b208[427]][_$_b208[438]]);
            }
            te[_$_b208[1539]] = ae;
          }, 64430: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2149]] = void 0, te[_$_b208[2149]] = { DEBUG: _$_b208[154], LOG: _$_b208[1037], WARN: _$_b208[721], ERROR: _$_b208[90], OFF: _$_b208[688] };
          }, 65077: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[355]] = ie;
            var ne = ee(25226);
            function ie(he) {
              return he === void 0 && (he = {}), { live: ae(he), tweaks: ce() };
            }
            var ae = function(he) {
              var _e = he[_$_b208[2425]];
              return { lowLatency: { targetLatency: _e ?? 5, catchup: { playbackRateThreshold: 0.075, seekThreshold: 5, playbackRate: 1.2 }, fallback: { playbackRateThreshold: 0.075, seekThreshold: 5, playbackRate: 0.95 } }, synchronization: [{ method: ne[_$_b208[1376]][_$_b208[1398]], serverUrl: _$_b208[2426] }] };
            }, ce = function() {
              return { RESTART_THRESHOLD: 0.2, RESTART_THRESHOLD_DELTA: 0.05, STARTUP_THRESHOLD: 0.2, STARTUP_THRESHOLD_DELTA: 0.05, LOW_LATENCY_BUFFER_GUARD: 0.8 };
            };
          }, 65114: function(re, te) {
            _$_b208[11];
            function ee(ae, ce) {
              return ae == null ? void 0 : ae[_$_b208[2428]][_$_b208[164]](function(he) {
                return he[_$_b208[2427]] === ce;
              });
            }
            function ne(ae, ce) {
              var he = ee(ae, ce[_$_b208[2429]]);
              if (he)
                return he[_$_b208[2432]][_$_b208[164]](function(_e) {
                  return _e[_$_b208[2431]][_$_b208[2430]](ce);
                });
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2433]] = void 0, te[_$_b208[2434]] = ee, te[_$_b208[2435]] = ne;
            var ie = function(ae, ce) {
              var he = ne(ae, ce);
              if (he)
                return he[_$_b208[2436]][_$_b208[164]](function(_e) {
                  return _e[_$_b208[2431]][_$_b208[2430]](ce);
                });
            };
            te[_$_b208[2433]] = ie;
          }, 65411: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2437]] = void 0;
            var ne = ee(90637), ie = ee(23974), ae = ee(10501), ce = function() {
              function he(_e, le, se) {
                var oe = this;
                this[_$_b208[2438]] = function(ue) {
                  oe[_$_b208[2439]][_$_b208[404]](ie[_$_b208[406]][_$_b208[405]], function(be) {
                    return ue(be);
                  });
                }, this[_$_b208[2439]] = new ae[_$_b208[372]](_e, le, se);
              }
              return he[_$_b208[21]][_$_b208[2440]] = function() {
                return this[_$_b208[2441]] = this[_$_b208[2441]] || this[_$_b208[2439]][_$_b208[407]](), this[_$_b208[2441]];
              }, he[_$_b208[21]][_$_b208[1509]] = function() {
                this[_$_b208[2439]][_$_b208[421]](ne[_$_b208[398]][_$_b208[423]]);
              }, he;
            }();
            te[_$_b208[2437]] = ce;
          }, 67345: function(re, te) {
            _$_b208[11];
            var ee, ne, ie, ae;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2442]] = te[_$_b208[2443]] = te[_$_b208[1705]] = te[_$_b208[2444]] = void 0, function(ce) {
              ce[_$_b208[2445]] = _$_b208[2446], ce[_$_b208[2447]] = _$_b208[2448], ce[_$_b208[2449]] = _$_b208[2450], ce[_$_b208[2451]] = _$_b208[2452], ce[_$_b208[2453]] = _$_b208[2454], ce[_$_b208[2455]] = _$_b208[2456], ce[_$_b208[2457]] = _$_b208[2458], ce[_$_b208[2459]] = _$_b208[2460], ce[_$_b208[2461]] = _$_b208[2462], ce[_$_b208[2463]] = _$_b208[2464], ce[_$_b208[2465]] = _$_b208[2466], ce[_$_b208[2467]] = _$_b208[2468], ce[_$_b208[2469]] = _$_b208[2470], ce[_$_b208[2471]] = _$_b208[2472], ce[_$_b208[2473]] = _$_b208[2474], ce[_$_b208[2475]] = _$_b208[2476], ce[_$_b208[2477]] = _$_b208[2478], ce[_$_b208[2479]] = _$_b208[2480], ce[_$_b208[2481]] = _$_b208[2482], ce[_$_b208[2483]] = _$_b208[2484], ce[_$_b208[2485]] = _$_b208[2486], ce[_$_b208[1404]] = _$_b208[1796], ce[_$_b208[2487]] = _$_b208[1243];
            }(ee || (te[_$_b208[2444]] = ee = {})), function(ce) {
              ce[_$_b208[2488]] = _$_b208[2489], ce[_$_b208[2490]] = _$_b208[2491], ce[_$_b208[2492]] = _$_b208[4], ce[_$_b208[1704]] = _$_b208[2493], ce[_$_b208[2494]] = _$_b208[2495];
            }(ne || (te[_$_b208[1705]] = ne = {})), function(ce) {
              ce[_$_b208[2496]] = _$_b208[2496], ce[_$_b208[2497]] = _$_b208[2497], ce[_$_b208[2498]] = _$_b208[2498], ce[_$_b208[2499]] = _$_b208[2499];
            }(ie || (te[_$_b208[2443]] = ie = {})), function(ce) {
              ce[_$_b208[2500]] = _$_b208[2501], ce[_$_b208[2502]] = _$_b208[1920];
            }(ae || (te[_$_b208[2442]] = ae = {}));
          }, 67501: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[297]] || (Object[_$_b208[230]] ? function(he, _e, le, se) {
              se === void 0 && (se = le);
              var oe = Object[_$_b208[298]](_e, le);
              oe && !(_$_b208[199] in oe ? !_e[_$_b208[12]] : oe[_$_b208[299]] || oe[_$_b208[300]]) || (oe = { enumerable: !0, get: function() {
                return _e[le];
              } }), Object[_$_b208[13]](he, se, oe);
            } : function(he, _e, le, se) {
              se === void 0 && (se = le), he[se] = _e[le];
            }), ie = this && this[_$_b208[301]] || function(he, _e) {
              for (var le in he)
                _$_b208[302] === le || Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](_e, le) || ne(_e, he, le);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2503]] = te[_$_b208[2504]] = void 0;
            var ae = ee(90546);
            Object[_$_b208[13]](te, _$_b208[2504], { enumerable: !0, get: function() {
              return ae[_$_b208[2504]];
            } }), ie(ee(92737), te);
            var ce = ee(7197);
            te[_$_b208[2503]] = ce, te[_$_b208[302]] = ae[_$_b208[2504]];
          }, 68039: function(re, te) {
            _$_b208[11];
            function ee(ne) {
              return Object[_$_b208[69]](te[_$_b208[2505]])[_$_b208[164]](function(ie) {
                return te[_$_b208[2505]][ie] === ne;
              });
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2505]] = void 0, te[_$_b208[2506]] = ee, te[_$_b208[2505]] = { "urn:mpeg:dash:mp4protection:2011": _$_b208[2507], "urn:mpeg:dash:13818:1:CA_descriptor:2011": _$_b208[2508], "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": _$_b208[2509], "urn:uuid:5e629af5-38da-4063-8977-97ffbd9902d4": _$_b208[2510], "urn:uuid:adb41c24-2dbf-4a6d-958b-4457c0d27b95": _$_b208[2511], "urn:uuid:a68129d3-575b-4f1a-9cba-3223846cf7c3": _$_b208[2512], "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": _$_b208[2513], "urn:uuid:9a27dd82-fde2-4725-8cbc-4234aa06ec09": _$_b208[2514], "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": _$_b208[2515], "urn:uuid:1f83e1e8-6ee9-4f0d-ba2f-5ec4e3ed1a66": _$_b208[2516], "urn:uuid:644fe7b5-260f-4fad-949a-0762ffb054b4": _$_b208[2517], "urn:uuid:6a99532d-869f-5922-9a91-113ab7b1e2f3": _$_b208[2518], "urn:uuid:35bf197b-530e-42d7-8b65-1b4bf415070f": _$_b208[2519], "urn:uuid:b4413586-c58c-ffb0-94a5-d4896c1af6c3": _$_b208[2520], "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": _$_b208[2521] };
          }, 68329: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2522]] = ie, te[_$_b208[2523]] = ae, te[_$_b208[2524]] = ce, te[_$_b208[2525]] = he;
            var ne = ee(331);
            function ie(_e) {
              return new Date(Date[_$_b208[1035]](_e[_$_b208[2416]]) + (0, ne[_$_b208[15]])(_e[_$_b208[61]]))[_$_b208[2526]]();
            }
            function ae(_e, le) {
              var se = {}, oe = function(ue) {
                var be = ue[_$_b208[2527]], ve = ue[_$_b208[2528]];
                return be ? _$_b208[265][_$_b208[94]](ve, _$_b208[2090])[_$_b208[94]](be) : ve;
              };
              return le[_$_b208[68]](function(ue) {
                return se[oe(ue)] = ue;
              }), _e[_$_b208[68]](function(ue) {
                se[oe(ue)] && (se[oe(ue)] = ue);
              }), Object[_$_b208[1111]](se);
            }
            function ce(_e, le) {
              return le[_$_b208[68]](function(se) {
                return se[_$_b208[2529]] = !1;
              }), _e[_$_b208[18]] === 0 ? le : ae(_e, le);
            }
            function he(_e, le, se) {
              if (_e[le]) {
                var oe, ue = function() {
                  oe = se;
                  for (var be = le - 1; be >= 0; be--)
                    _e[be][_$_b208[2530]] = oe - _e[be][_$_b208[61]], oe -= _e[be][_$_b208[61]];
                };
                (function() {
                  oe = se;
                  for (var be = le; be < _e[_$_b208[18]]; be++)
                    _e[be][_$_b208[2530]] = oe, oe += _e[be][_$_b208[61]];
                })(), ue();
              }
            }
          }, 70016: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2531]] = te[_$_b208[1231]] = void 0, te[_$_b208[2191]] = ie, te[_$_b208[2532]] = ae;
            var ee = function(ce) {
              return _$_b208[885] == typeof ce;
            };
            te[_$_b208[1231]] = ee;
            var ne = function(ce) {
              return _$_b208[1020] == typeof ce;
            };
            function ie(ce) {
              return ce != null;
            }
            function ae(ce) {
              return ce[_$_b208[2533]] != null && ce[_$_b208[2534]] != null;
            }
            te[_$_b208[2531]] = ne;
          }, 72181: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2535]] = te[_$_b208[2536]] = void 0, te[_$_b208[2536]] = { Avc: [_$_b208[2537], _$_b208[2538], _$_b208[2539]], Hvc: [_$_b208[2540], _$_b208[2541]] }, function(ne) {
              ne[ne[_$_b208[2542]] = 6] = _$_b208[2542];
            }(ee || (te[_$_b208[2535]] = ee = {}));
          }, 72819: function(re, te) {
            _$_b208[11];
            function ee(ne) {
              return function(ie, ae) {
                return ie[ae[_$_b208[1559]]] ? ne(ie, ae) : ie;
              };
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2543]] = ee;
          }, 73448: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2241]] = void 0, function(ne) {
              ne[_$_b208[2240]] = _$_b208[2544];
            }(ee || (te[_$_b208[2241]] = ee = {}));
          }, 76420: function(re, te) {
            _$_b208[11];
            var ee, ne, ie, ae, ce, he, _e;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1307]] = te[_$_b208[1134]] = te[_$_b208[1305]] = te[_$_b208[1304]] = te[_$_b208[1303]] = te[_$_b208[732]] = te[_$_b208[936]] = void 0, function(le) {
              le[le[_$_b208[1302]] = 0] = _$_b208[1302], le[le[_$_b208[2545]] = 1] = _$_b208[2545], le[le[_$_b208[2546]] = 2] = _$_b208[2546], le[le[_$_b208[935]] = 3] = _$_b208[935];
            }(ee || (te[_$_b208[936]] = ee = {})), function(le) {
              le[le[_$_b208[2547]] = 0] = _$_b208[2547], le[le[_$_b208[2548]] = 1] = _$_b208[2548], le[le[_$_b208[2549]] = 2] = _$_b208[2549], le[le[_$_b208[731]] = 3] = _$_b208[731];
            }(ne || (te[_$_b208[732]] = ne = {})), function(le) {
              le[le[_$_b208[1302]] = 0] = _$_b208[1302], le[le[_$_b208[2178]] = 1] = _$_b208[2178], le[le[_$_b208[2176]] = 2] = _$_b208[2176], le[le[_$_b208[1193]] = 3] = _$_b208[1193], le[le[_$_b208[2177]] = 4] = _$_b208[2177];
            }(ie || (te[_$_b208[1303]] = ie = {})), function(le) {
              le[le[_$_b208[1302]] = 0] = _$_b208[1302], le[le[_$_b208[2181]] = 1] = _$_b208[2181], le[le[_$_b208[2182]] = 2] = _$_b208[2182], le[le[_$_b208[2183]] = 3] = _$_b208[2183];
            }(ae || (te[_$_b208[1304]] = ae = {})), function(le) {
              le[le[_$_b208[1302]] = 0] = _$_b208[1302], le[le[_$_b208[2185]] = 1] = _$_b208[2185], le[le[_$_b208[2186]] = 2] = _$_b208[2186];
            }(ce || (te[_$_b208[1305]] = ce = {})), function(le) {
              le[_$_b208[1302]] = _$_b208[692], le[_$_b208[1133]] = _$_b208[2550], le[_$_b208[1138]] = _$_b208[2551];
            }(he || (te[_$_b208[1134]] = he = {})), function(le) {
              le[_$_b208[1309]] = _$_b208[2552], le[_$_b208[1310]] = _$_b208[2553], le[_$_b208[1311]] = _$_b208[2554], le[_$_b208[1312]] = _$_b208[2555], le[_$_b208[1313]] = _$_b208[2556], le[_$_b208[1308]] = _$_b208[2557], le[_$_b208[1314]] = _$_b208[2558], le[_$_b208[1315]] = _$_b208[2559], le[_$_b208[1306]] = _$_b208[2560], le[_$_b208[1316]] = _$_b208[2561], le[_$_b208[1317]] = _$_b208[2562], le[_$_b208[1318]] = _$_b208[2563], le[_$_b208[1319]] = _$_b208[2564], le[_$_b208[1320]] = _$_b208[2565], le[_$_b208[1323]] = _$_b208[2566], le[_$_b208[1321]] = _$_b208[2567], le[_$_b208[1322]] = _$_b208[2568], le[_$_b208[1324]] = _$_b208[2569];
            }(_e || (te[_$_b208[1307]] = _e = {}));
          }, 76650: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2570]] = ae, te[_$_b208[2571]] = ce, te[_$_b208[1365]] = he, te[_$_b208[2572]] = _e, te[_$_b208[2573]] = le, te[_$_b208[2574]] = se;
            var ne = ee(15231), ie = ee(8272);
            function ae(oe, ue, be) {
              return be === void 0 && (be = oe), (0, ne[_$_b208[626]])(ie[_$_b208[303]][_$_b208[335]], { mimeType: oe, settings: ue, saveUnderName: be });
            }
            function ce(oe) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[303]][_$_b208[337]], { mimeType: oe });
            }
            function he(oe, ue, be) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[303]][_$_b208[339]], { mimeType: oe, metricType: ue, value: be });
            }
            function _e(oe, ue, be) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[303]][_$_b208[341]], { mimeType: oe, metricType: ue, value: be });
            }
            function le(oe, ue) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[303]][_$_b208[343]], { mimeType: oe, metricType: ue });
            }
            function se(oe, ue) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[303]][_$_b208[345]], { mimeType: oe, threshold: ue });
            }
          }, 76885: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2575]] = void 0, te[_$_b208[2576]] = _e, te[_$_b208[2577]] = le;
            var ee = function() {
              function se() {
              }
              return se[_$_b208[2578]] = function(oe) {
                return !!oe && (_$_b208[348] != typeof oe && (oe = se[_$_b208[2579]](oe)), !!se[_$_b208[2580]](oe) || se[_$_b208[2581]][_$_b208[1814]](oe));
              }, se[_$_b208[2582]] = function(oe) {
                return oe[_$_b208[138]](_$_b208[2583]) > -1 && (oe = oe[_$_b208[258]](_$_b208[2583])[0]), oe;
              }, se[_$_b208[2579]] = function(oe) {
                return oe && _$_b208[348] != typeof oe ? ie(oe) ? oe[_$_b208[2584]] : ae(oe) ? oe[_$_b208[403]] : null : oe;
              }, se[_$_b208[2585]] = function(oe, ue) {
                var be = _$_b208[263], ve = se[_$_b208[2579]](oe), me = se[_$_b208[2579]](ue);
                return !ve || ve[_$_b208[18]] < 1 || se[_$_b208[2578]](me) ? me : !me || me[_$_b208[18]] < 1 ? ve : ((ve = se[_$_b208[2582]](ve))[_$_b208[138]](_$_b208[263]) > -1 && (ve = ve[_$_b208[259]](0, ve[_$_b208[264]](_$_b208[263]))), _$_b208[263] === me[0] && (ve = _e(ve), be = _$_b208[265]), ve + be + me);
              }, se[_$_b208[2586]] = function(oe) {
                if (!oe)
                  return null;
                oe = se[_$_b208[2582]](oe);
                var ue = se[_$_b208[2587]](oe), be = oe[_$_b208[264]](_$_b208[263]);
                return be === oe[_$_b208[18]] - 1 && (oe = oe[_$_b208[259]](0, be)), (be = oe[_$_b208[264]](_$_b208[263])) < 0 ? _$_b208[265] : be > oe[_$_b208[18]] - 1 ? oe : be <= ue ? oe + _$_b208[263] : oe[_$_b208[259]](0, be + 1);
              }, se[_$_b208[2588]] = function(oe) {
                return !!(oe && oe[_$_b208[18]] > 0) && _$_b208[263] === oe[0];
              }, se[_$_b208[2587]] = function(oe) {
                var ue = _$_b208[2589], be = oe[_$_b208[138]](ue);
                return be > -1 ? be + ue[_$_b208[18]] : be === -1 && oe[_$_b208[138]](_$_b208[2590]) === 0 ? 2 : 0;
              }, se[_$_b208[2591]] = function(oe, ue) {
                var be = _e(oe), ve = _e(ue);
                return oe[_$_b208[2046]](be, ve);
              }, se[_$_b208[2592]] = function(oe, ue) {
                return !(!oe || !ue) && (ue[_$_b208[138]](_$_b208[2593]) === 0 && (ue = ue[_$_b208[259]](3)), oe[_$_b208[138]](ue) > -1);
              }, se[_$_b208[2594]] = function(oe, ue) {
                return se[_$_b208[2578]](ue) ? (ue[_$_b208[261]](_$_b208[263]) && (ue = (ce(oe) || he()) + ue), ue) : (oe = this[_$_b208[2595]](oe), ue && ue[_$_b208[18]] !== 0 ? se[_$_b208[2588]](ue) ? _e(oe) + ue : (oe[_$_b208[2596]](_$_b208[263]) || (oe = this[_$_b208[2586]](oe)), oe + ue) : oe);
              }, se[_$_b208[2597]] = function(oe, ue) {
                if (!ue || Object[_$_b208[69]](ue)[_$_b208[18]] === 0)
                  return oe;
                var be = _$_b208[265], ve = oe[_$_b208[138]](_$_b208[2583]) >= 0;
                for (var me in ue)
                  ue[_$_b208[20]](me) && (be += ve ? _$_b208[2598] : _$_b208[2583], ve = !0, be = ne(be, me, ue[me]));
                return oe + be;
              }, se[_$_b208[2595]] = function(oe) {
                if (se[_$_b208[2580]](oe))
                  return oe;
                var ue = oe[_$_b208[261]](_$_b208[2590]) ? he() + oe : oe;
                return oe[_$_b208[258]](_$_b208[2590])[1][_$_b208[26]](_$_b208[263]) || (ue += _$_b208[263]), ue;
              }, se[_$_b208[2580]] = function(oe) {
                return oe && oe[_$_b208[138]](this[_$_b208[2599]]) === 0;
              }, se[_$_b208[2600]] = function(oe) {
                if (!this[_$_b208[2580]](oe))
                  throw new Error(_$_b208[2601] + oe);
                (oe = oe[_$_b208[259]](this[_$_b208[2599]][_$_b208[18]]))[_$_b208[138]](this[_$_b208[2602]]) === -1 && (oe = this[_$_b208[2603]] + this[_$_b208[2602]] + oe);
                var ue = oe[_$_b208[258]](this[_$_b208[2602]]), be = ue[0], ve = ue[1], me = be[_$_b208[2596]](this[_$_b208[2604]]), pe = be[_$_b208[18]] - this[_$_b208[2604]][_$_b208[18]] - this[_$_b208[2602]][_$_b208[18]];
                return { mediaType: me ? be[_$_b208[259]](0, pe) : be, base64: me ? ve : void 0, data: me ? atob(ve) : ve };
              }, se[_$_b208[2605]] = function(oe, ue, be) {
                return se[_$_b208[2578]](be) ? be : se[_$_b208[2588]](be) ? ue + be : oe + be;
              }, se[_$_b208[2606]] = function(oe, ue) {
                return se[_$_b208[2578]](oe) ? oe : se[_$_b208[2594]](ue, oe);
              }, se[_$_b208[2599]] = _$_b208[2607], se[_$_b208[2604]] = _$_b208[2608], se[_$_b208[2603]] = _$_b208[2609], se[_$_b208[2581]] = new RegExp(_$_b208[2610], _$_b208[2611]), se[_$_b208[2602]] = _$_b208[257], se;
            }();
            function ne(se, oe, ue) {
              return se += oe, ue != null && (se += _$_b208[1782] + encodeURIComponent(ue)), se;
            }
            function ie(se) {
              return se && _$_b208[348] == typeof se[_$_b208[2584]];
            }
            function ae(se) {
              return se && _$_b208[348] == typeof se[_$_b208[403]];
            }
            function ce(se) {
              return se[_$_b208[259]](0, se[_$_b208[138]](_$_b208[2590]));
            }
            function he() {
              var se;
              return ((se = window[_$_b208[10]]) === null || se === void 0 ? void 0 : se[_$_b208[1913]]) || _$_b208[2612];
            }
            function _e(se) {
              var oe = se[_$_b208[138]](_$_b208[2590]) + 2, ue = se[_$_b208[138]](_$_b208[263], oe);
              return ue === -1 && (ue = se[_$_b208[138]](_$_b208[2583], oe)), ue === -1 ? se : se[_$_b208[630]](0, ue);
            }
            function le(se, oe) {
              var ue = se[_$_b208[258]](_$_b208[2583]), be = ue[0], ve = ue[1];
              if (!ve)
                return se;
              var me = ve[_$_b208[258]](_$_b208[2598])[_$_b208[165]](function(pe) {
                var fe = pe[_$_b208[258]](_$_b208[1782])[0];
                return !oe[_$_b208[26]](fe);
              })[_$_b208[122]](_$_b208[2598]);
              return me ? _$_b208[265][_$_b208[94]](be, _$_b208[2583])[_$_b208[94]](me) : be;
            }
            te[_$_b208[2575]] = ee;
          }, 77012: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 });
          }, 77845: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(_e) {
                for (var le, se = 1, oe = arguments[_$_b208[18]]; se < oe; se++)
                  for (var ue in le = arguments[se])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](le, ue) && (_e[ue] = le[ue]);
                return _e;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1222]] = void 0;
            var ie = ee(50425), ae = ee(3464), ce = function() {
              function _e(le, se, oe) {
                var ue = this;
                this[_$_b208[2613]] = le, this[_$_b208[2614]] = se, this[_$_b208[2615]] = oe, this[_$_b208[2616]] = [], this[_$_b208[2617]] = function(be) {
                  return be[ue[_$_b208[2614]]][ue[_$_b208[2615]]];
                }, this[_$_b208[2618]] = new ie[_$_b208[525]](), this[_$_b208[2619]](this[_$_b208[2618]]);
              }
              return _e[_$_b208[21]][_$_b208[552]] = function(le) {
                var se;
                return (se = this[_$_b208[2613]]) === null || se === void 0 ? void 0 : se[_$_b208[552]](this[_$_b208[2620]](le));
              }, _e[_$_b208[21]][_$_b208[2620]] = function(le) {
                var se;
                return ne(ne({}, le), { meta: ne(ne({}, le[_$_b208[2621]]), (se = {}, se[this[_$_b208[2614]]] = this[_$_b208[2615]], se)) });
              }, _e[_$_b208[21]][_$_b208[2622]] = function() {
                return this[_$_b208[2613]][_$_b208[2623]](this[_$_b208[2614]]) || this[_$_b208[2613]][_$_b208[1223]](this[_$_b208[2614]], new ie[_$_b208[525]]()), this[_$_b208[2613]][_$_b208[2624]](this[_$_b208[2614]]);
              }, _e[_$_b208[21]][_$_b208[2619]] = function(le) {
                var se = this[_$_b208[2622]]();
                (0, ie[_$_b208[2001]])(se) && se[_$_b208[361]](this[_$_b208[2615]], le), this[_$_b208[2613]][_$_b208[1223]](this[_$_b208[2614]], se);
              }, _e[_$_b208[21]][_$_b208[182]] = function() {
                var le, se = (le = this[_$_b208[2613]]) === null || le === void 0 ? void 0 : le[_$_b208[182]]();
                if (se)
                  return this[_$_b208[2617]](se);
              }, _e[_$_b208[21]][_$_b208[183]] = function(le, se) {
                var oe = this, ue = (0, ae[_$_b208[183]])(this[_$_b208[2613]])(this[_$_b208[2617]], le, se);
                return this[_$_b208[2616]][_$_b208[141]](ue), function() {
                  oe[_$_b208[2616]] = oe[_$_b208[2616]][_$_b208[165]](function(be) {
                    return be !== ue;
                  }), ue();
                };
              }, _e[_$_b208[21]][_$_b208[2625]] = function(le) {
                var se = this;
                return function(oe, ue) {
                  return !ue[_$_b208[2621]] || !ue[_$_b208[2621]][se[_$_b208[2614]]] || ue[_$_b208[2621]][se[_$_b208[2614]]] === se[_$_b208[2615]] ? le(oe, ue) : oe;
                };
              }, _e[_$_b208[21]][_$_b208[1223]] = function(le, se) {
                this[_$_b208[2618]][_$_b208[361]](le, (0, ie[_$_b208[2e3]])(se) ? this[_$_b208[2625]](se) : se), this[_$_b208[2619]](this[_$_b208[2618]]);
              }, _e[_$_b208[21]][_$_b208[2624]] = function(le) {
                return this[_$_b208[2618]][_$_b208[199]](le);
              }, _e[_$_b208[21]][_$_b208[2626]] = function(le) {
                this[_$_b208[2618]][_$_b208[362]](le), this[_$_b208[2619]](this[_$_b208[2618]]);
              }, _e[_$_b208[21]][_$_b208[2623]] = function(le) {
                return this[_$_b208[2618]][_$_b208[196]](le);
              }, _e[_$_b208[21]][_$_b208[70]] = function() {
                var le = this[_$_b208[2622]]();
                this[_$_b208[2616]][_$_b208[68]](function(se) {
                  return se();
                }), le && (0, ie[_$_b208[2001]])(le) && le[_$_b208[362]](this[_$_b208[2615]]), this[_$_b208[2613]][_$_b208[1223]](this[_$_b208[2614]], le), this[_$_b208[2616]] = [], this[_$_b208[2618]] = null, this[_$_b208[2613]] = null;
              }, _e;
            }();
            function he(_e) {
              return _e;
            }
            te[_$_b208[1222]] = ce;
          }, 78429: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(ue) {
                for (var be, ve = 1, me = arguments[_$_b208[18]]; ve < me; ve++)
                  for (var pe in be = arguments[ve])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](be, pe) && (ue[pe] = be[pe]);
                return ue;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[758]] = void 0, te[_$_b208[2627]] = oe;
            var ie = ee(28764), ae = ee(62510), ce = ee(18561), he = _$_b208[2628], _e = function() {
              function ue() {
                var be = this;
                this[_$_b208[19]] = function() {
                  be[_$_b208[1723]][_$_b208[19]](be[_$_b208[46]], be[_$_b208[1489]]);
                }, this[_$_b208[2629]] = function(ve) {
                  return !!be[_$_b208[2630]] && (_$_b208[348] == typeof ve ? ve === be[_$_b208[44]] : ve === be[_$_b208[1723]]);
                };
              }
              return ue[_$_b208[21]][_$_b208[361]] = function(be, ve, me, pe, fe) {
                fe === void 0 && (fe = !0), this[_$_b208[1723]] = be, this[_$_b208[44]] = ve, this[_$_b208[46]] = me, this[_$_b208[1489]] = pe, this[_$_b208[2630]] = fe;
              }, ue[_$_b208[21]][_$_b208[425]] = function() {
                this[_$_b208[1723]] = null, this[_$_b208[44]] = null, this[_$_b208[46]] = null, this[_$_b208[1489]] = null, this[_$_b208[2630]] = null;
              }, Object[_$_b208[13]](ue[_$_b208[21]], _$_b208[2631], { get: function() {
                return this[_$_b208[2630]];
              }, enumerable: !1, configurable: !0 }), ue;
            }(), le = 20, se = function() {
              function ue(be, ve, me) {
                var pe = this;
                for (var fe in this[_$_b208[2632]] = !1, this[_$_b208[2633]] = !1, this[_$_b208[2634]] = function() {
                  for (var ge = pe[_$_b208[770]] ? pe[_$_b208[2635]][_$_b208[18]] : le, ye = 0, $e = pe[_$_b208[2635]][_$_b208[139]](0, ge); ye < $e[_$_b208[18]]; ye++) {
                    var Se = $e[ye];
                    !Se || pe[_$_b208[768]] && Se[_$_b208[44]] !== ae[_$_b208[482]][_$_b208[1143]] || pe[_$_b208[2636]](Se);
                  }
                  pe[_$_b208[2632]] = !1, pe[_$_b208[2635]][_$_b208[18]] > 0 && pe[_$_b208[2637]]();
                }, this[_$_b208[2638]] = function(ge, ye, $e, Se) {
                  if (Se === void 0 && (Se = !0), pe[_$_b208[2639]](ge, ye, $e)) {
                    var Ce = pe[_$_b208[2640]]($e), Ie = 0, Te = pe[_$_b208[2641]](ye, ge);
                    Ce[ge][_$_b208[68]](function(Ee) {
                      var we = pe[_$_b208[2642]][_$_b208[1737]]() || new _e();
                      we[_$_b208[361]](Ee[_$_b208[1723]], ge, pe[_$_b208[769]], Te, Se), pe[_$_b208[2635]][_$_b208[141]](we), Ie += Ee[_$_b208[2643]] ? 1 : 0;
                    }), Ie < Ce[ge][_$_b208[18]] && (Ce[ge][_$_b208[1764]](function(Ee, we) {
                      return ce[_$_b208[1347]][_$_b208[1348]](Ee[_$_b208[2643]], we[_$_b208[2643]]);
                    }), Ce[ge][_$_b208[18]] = Ie), pe[_$_b208[2635]][_$_b208[18]] > 0 && pe[_$_b208[2637]]();
                  }
                }, this[_$_b208[503]] = function(ge, ye, $e) {
                  $e === void 0 && ($e = !0), pe[_$_b208[770]] || pe[_$_b208[145]](ge, ye, $e);
                }, this[_$_b208[666]] = function(ge) {
                  var ye = pe[_$_b208[2635]][_$_b208[1277]](function($e, Se, Ce) {
                    return Se[_$_b208[2629]](ge) ? $e[_$_b208[94]](Ce) : $e;
                  }, []);
                  for (ye[_$_b208[1764]](function($e, Se) {
                    return $e - Se;
                  }); ye[_$_b208[18]] > 0; )
                    pe[_$_b208[2635]][_$_b208[139]](ye[_$_b208[1737]](), 1);
                }, this[_$_b208[2644]] = function(ge) {
                  ge[_$_b208[1489]] === pe[_$_b208[2645]] && (window[_$_b208[105]](_$_b208[119], pe[_$_b208[2644]]), pe[_$_b208[2634]]());
                }, this[_$_b208[148]] = be, this[_$_b208[769]] = ve, this[_$_b208[401]] = { internal: {}, external: {} }, this[_$_b208[770]] = !1, this[_$_b208[768]] = !1, this[_$_b208[2635]] = [], this[_$_b208[2642]] = [], ae[_$_b208[482]])
                  ae[_$_b208[482]][_$_b208[20]](fe) && (this[_$_b208[401]][_$_b208[1243]][ae[_$_b208[482]][fe]] = [], this[_$_b208[401]][_$_b208[2646]][ae[_$_b208[482]][fe]] = []);
                this[_$_b208[2647]] = [], this[_$_b208[2645]] = _$_b208[265][_$_b208[94]](he, _$_b208[1117])[_$_b208[94]](me);
              }
              return ue[_$_b208[21]][_$_b208[2636]] = function(be) {
                try {
                  be[_$_b208[19]](), be[_$_b208[425]](), this[_$_b208[2642]][_$_b208[141]](be);
                } catch (ve) {
                  this[_$_b208[148]][_$_b208[721]](_$_b208[2648], ve);
                }
              }, ue[_$_b208[21]][_$_b208[2641]] = function(be, ve) {
                return ne({ type: ve, timestamp: Date[_$_b208[180]]() }, be);
              }, ue[_$_b208[21]][_$_b208[2639]] = function(be, ve, me) {
                var pe = this[_$_b208[2640]](me), fe = pe[_$_b208[20]](be) && pe[be][_$_b208[18]];
                return !!(!this[_$_b208[770]] && fe);
              }, ue[_$_b208[21]][_$_b208[2649]] = function(be) {
                this[_$_b208[2635]] = this[_$_b208[2635]][_$_b208[165]](function(ve) {
                  return !ve[_$_b208[2629]](be);
                });
              }, ue[_$_b208[21]][_$_b208[1735]] = function(be, ve, me) {
                var pe = this[_$_b208[2640]](me);
                pe[_$_b208[20]](be) && (pe[be] = pe[be][_$_b208[165]](function(fe) {
                  return fe[_$_b208[1723]] !== ve;
                }));
              }, ue[_$_b208[21]][_$_b208[2650]] = function(be, ve) {
                if (be && be instanceof ie[_$_b208[720]]) {
                  var me = { type: ae[_$_b208[482]][_$_b208[1060]], timestamp: Date[_$_b208[180]](), code: be[_$_b208[113]], name: be[_$_b208[176]], message: be[_$_b208[119]], data: be[_$_b208[1489]], troubleShootLink: oe(be[_$_b208[113]]) };
                  ve && (me[_$_b208[510]] = be[_$_b208[510]]), this[_$_b208[2638]](ae[_$_b208[482]][_$_b208[1060]], me, ve);
                } else
                  this[_$_b208[148]][_$_b208[90]](_$_b208[2651], be);
              }, ue[_$_b208[21]][_$_b208[2640]] = function(be) {
                return be ? this[_$_b208[401]][_$_b208[1243]] : this[_$_b208[401]][_$_b208[2646]];
              }, ue[_$_b208[21]][_$_b208[145]] = function(be, ve, me) {
                if (ve === void 0 && (ve = {}), me === void 0 && (me = !0), be === ae[_$_b208[482]][_$_b208[1060]]) {
                  var pe = ve;
                  pe[_$_b208[20]](_$_b208[113]) || (pe[_$_b208[113]] = 3e3);
                }
                ve && !ve[_$_b208[20]](_$_b208[2652]) && (ve[_$_b208[2652]] = Date[_$_b208[180]]()), this[_$_b208[2638]](be, ve, !0, me), this[_$_b208[2647]][_$_b208[18]] > 0 && !this[_$_b208[2653]](be, ve) || this[_$_b208[2638]](be, ve, !1, me);
              }, ue[_$_b208[21]][_$_b208[2653]] = function(be, ve) {
                return this[_$_b208[2647]][_$_b208[516]](function(me) {
                  return me(be, ve);
                });
              }, ue[_$_b208[21]][_$_b208[2654]] = function(be, ve, me, pe) {
                me === void 0 && (me = !1), pe === void 0 && (pe = !0);
                var fe = this[_$_b208[2640]](me);
                fe[_$_b208[20]](be) && ve && !fe[be][_$_b208[164]](function(ge) {
                  return ge && ge[_$_b208[1723]] === ve;
                }) && fe[be][_$_b208[141]]({ listener: ve, repeatable: pe });
              }, ue[_$_b208[21]][_$_b208[404]] = function(be, ve, me) {
                me === void 0 && (me = !1), this[_$_b208[2654]](be, ve, me);
              }, ue[_$_b208[21]][_$_b208[2655]] = function(be, ve, me) {
                me === void 0 && (me = !1), this[_$_b208[2654]](be, ve, me, !1);
              }, ue[_$_b208[21]][_$_b208[982]] = function(be, ve) {
                for (var me in ve === void 0 && (ve = !1), be)
                  be[_$_b208[20]](me) && this[_$_b208[404]](me, be[me], ve);
              }, ue[_$_b208[21]][_$_b208[688]] = function(be, ve, me) {
                me === void 0 && (me = !0), me && this[_$_b208[2649]](ve), this[_$_b208[1735]](be, ve, !0), this[_$_b208[1735]](be, ve, !1);
              }, ue[_$_b208[21]][_$_b208[815]] = function() {
                var be = this;
                return function(ve, me, pe, fe) {
                  fe === void 0 && (fe = !0), be[_$_b208[503]](ve, me, fe);
                };
              }, ue[_$_b208[21]][_$_b208[1211]] = function(be) {
                this[_$_b208[2647]][_$_b208[138]](be) < 0 && this[_$_b208[2647]][_$_b208[141]](be);
              }, ue[_$_b208[21]][_$_b208[1212]] = function(be) {
                var ve = this[_$_b208[2647]][_$_b208[138]](be);
                ve >= 0 && this[_$_b208[2647]][_$_b208[139]](ve, 1);
              }, ue[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[2635]] = this[_$_b208[2635]][_$_b208[165]](function(be) {
                  return !be[_$_b208[2631]];
                }), this[_$_b208[770]] = !0, this[_$_b208[145]] = null, this[_$_b208[2647]] = null, this[_$_b208[2634]]();
              }, ue[_$_b208[21]][_$_b208[1139]] = function() {
                this[_$_b208[768]] = !0;
              }, ue[_$_b208[21]][_$_b208[1084]] = function() {
                this[_$_b208[2633]] = !1;
              }, ue[_$_b208[21]][_$_b208[690]] = function(be) {
                var ve, me;
                this[_$_b208[2650]](be, !0), !this[_$_b208[2633]] && this[_$_b208[2653]](ae[_$_b208[482]][_$_b208[1060]], be) && (this[_$_b208[2633]] = !0, this[_$_b208[2650]](be, !1)), this[_$_b208[148]][_$_b208[90]](_$_b208[2657][_$_b208[94]](be[_$_b208[113]], _$_b208[263])[_$_b208[94]](be[_$_b208[176]], _$_b208[2656])[_$_b208[94]]((ve = be[_$_b208[119]]) !== null && ve !== void 0 ? ve : _$_b208[265]), (me = be[_$_b208[1489]]) !== null && me !== void 0 ? me : _$_b208[1728]);
              }, ue[_$_b208[21]][_$_b208[2637]] = function() {
                this[_$_b208[2632]] || (this[_$_b208[2632]] = !0, window[_$_b208[100]](_$_b208[119], this[_$_b208[2644]]), window[_$_b208[2660]](this[_$_b208[2645]], location[_$_b208[2658]] + location[_$_b208[2659]]));
              }, ue;
            }();
            function oe(ue) {
              return _$_b208[2661][_$_b208[94]](ue);
            }
            te[_$_b208[758]] = se;
          }, 78842: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2662]] = void 0;
            var ne = ee(87093);
            te[_$_b208[2662]] = ne[_$_b208[302]][_$_b208[2663]];
          }, 78936: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2664]] = void 0;
            var ne = ee(331), ie = ee(12733), ae = function() {
              function ce(he) {
                this[_$_b208[46]] = he;
              }
              return ce[_$_b208[21]][_$_b208[2665]] = function(he) {
                return he[_$_b208[18]] === 0 ? (this[_$_b208[46]][_$_b208[148]][_$_b208[721]](_$_b208[2666]), [{ startTime: 0, duration: 0 }]) : he;
              }, ce[_$_b208[21]][_$_b208[2667]] = function(he) {
                return this[_$_b208[2665]](ie[_$_b208[513]][_$_b208[517]](he));
              }, ce[_$_b208[21]][_$_b208[2668]] = function(he) {
                ie[_$_b208[513]][_$_b208[174]](he);
              }, ce[_$_b208[21]][_$_b208[2669]] = function(he) {
                var _e = this[_$_b208[2667]](he);
                return (0, ne[_$_b208[14]])(ie[_$_b208[513]][_$_b208[180]]() - _e[0][_$_b208[181]]);
              }, ce[_$_b208[21]][_$_b208[425]] = function(he) {
                (function() {
                  return Array[_$_b208[1122]](he) ? he : Object[_$_b208[1111]](he);
                })()[_$_b208[68]](function(_e) {
                  ie[_$_b208[513]][_$_b208[519]](_e);
                });
              }, ce;
            }();
            te[_$_b208[2664]] = ae;
          }, 79063: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(ue) {
                for (var be, ve = 1, me = arguments[_$_b208[18]]; ve < me; ve++)
                  for (var pe in be = arguments[ve])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](be, pe) && (ue[pe] = be[pe]);
                return ue;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[976]] = void 0;
            var ie = ee(25550), ae = ee(28764), ce = ee(33696), he = ee(87326), _e = ee(13533), le = ee(54838), se = ee(92677), oe = function() {
              function ue(be) {
                if (!be)
                  throw new ae[_$_b208[720]](ie[_$_b208[369]][_$_b208[1407]], void 0, _$_b208[2670]);
                this[_$_b208[703]] = {}, this[_$_b208[2671]] = be, this[_$_b208[2672]]();
              }
              return ue[_$_b208[2673]] = function(be, ve) {
                var me, pe, fe = !1, ge = !1, ye = !1;
                if (ve[_$_b208[693]] ? (ye = !!ve[_$_b208[693]][_$_b208[549]], ge = !!ve[_$_b208[693]][_$_b208[550]], fe = !!ve[_$_b208[693]][_$_b208[2674]]) : ve[_$_b208[693]] = {}, be[_$_b208[693]] = be[_$_b208[693]] || {}, fe) {
                  var $e = (0, le[_$_b208[2039]])((pe = (me = se[_$_b208[2675]][_$_b208[693]]) === null || me === void 0 ? void 0 : me[_$_b208[2674]]) !== null && pe !== void 0 ? pe : 1.7777777777777777);
                  be[_$_b208[693]][_$_b208[2674]] = (0, le[_$_b208[2039]])(ve[_$_b208[693]][_$_b208[2674]]) || $e;
                } else
                  be[_$_b208[693]][_$_b208[2674]] = se[_$_b208[2675]][_$_b208[693]][_$_b208[2674]];
                ye && !isNaN(String(ve[_$_b208[693]][_$_b208[549]])[_$_b208[630]](-1)) && (be[_$_b208[693]][_$_b208[549]] = ve[_$_b208[693]][_$_b208[549]] + _$_b208[556]), ge && !isNaN(String(ve[_$_b208[693]][_$_b208[550]])[_$_b208[630]](-1)) && (be[_$_b208[693]][_$_b208[550]] = ve[_$_b208[693]][_$_b208[550]] + _$_b208[556]);
              }, ue[_$_b208[21]][_$_b208[2672]] = function() {
                var be = this;
                le[_$_b208[172]][_$_b208[2042]](this[_$_b208[703]], se[_$_b208[2675]], this[_$_b208[2671]]);
                var ve = this[_$_b208[2671]][_$_b208[1185]] || {}, me = {};
                le[_$_b208[172]][_$_b208[350]](me, ve), delete me[_$_b208[2676]], delete me[_$_b208[2677]], (0, _e[_$_b208[191]])()[_$_b208[455]] ? this[_$_b208[703]][_$_b208[1185]] = le[_$_b208[172]][_$_b208[2042]]({}, se[_$_b208[2675]][_$_b208[1185]][_$_b208[2676]], me, ve[_$_b208[2676]]) : this[_$_b208[703]][_$_b208[1185]] = le[_$_b208[172]][_$_b208[2042]]({}, se[_$_b208[2675]][_$_b208[1185]][_$_b208[2677]], me, ve[_$_b208[2677]]);
                var pe = this[_$_b208[703]][_$_b208[1185]][_$_b208[1669]];
                [_$_b208[2678], _$_b208[2679], _$_b208[2680], _$_b208[1668]][_$_b208[68]](function(fe) {
                  be[_$_b208[703]][_$_b208[1185]][_$_b208[1669]][fe] = le[_$_b208[172]][_$_b208[2044]](fe[_$_b208[259]](0, 3), pe[fe]);
                }), ue[_$_b208[2673]](this[_$_b208[703]], this[_$_b208[2671]]);
              }, ue[_$_b208[2681]] = function(be, ve, me) {
                if (ve[_$_b208[20]](me)) {
                  var pe = ve[me];
                  for (var fe in pe)
                    pe[_$_b208[20]](fe) && _$_b208[2682] !== fe && be[_$_b208[20]](fe[_$_b208[609]]()) ? be[fe[_$_b208[609]]()] = pe[fe] : pe[_$_b208[20]](fe) && _$_b208[2683] === fe[_$_b208[609]]() && (be[_$_b208[2408]][ce[_$_b208[874]][_$_b208[873]]][ce[_$_b208[872]][_$_b208[871]]] = pe[fe], be[_$_b208[2408]][ce[_$_b208[874]][_$_b208[906]]][ce[_$_b208[872]][_$_b208[871]]] = pe[fe]);
                }
              }, ue[_$_b208[21]][_$_b208[797]] = function(be) {
                var ve;
                be === void 0 && (be = this[_$_b208[703]]);
                var me = {}, pe = be[_$_b208[1185]] || {};
                return le[_$_b208[172]][_$_b208[350]](me, he[_$_b208[751]]), ue[_$_b208[2681]](me, be, _$_b208[716]), ue[_$_b208[2681]](me, be, _$_b208[2684]), pe[_$_b208[1669]] = pe[_$_b208[1669]] || {}, pe[_$_b208[1670]] = pe[_$_b208[1670]] || !1, me[_$_b208[2685]] = pe[_$_b208[1670]], me[_$_b208[2686]] = pe[_$_b208[1669]][_$_b208[2678]] || 0, me[_$_b208[2687]] = pe[_$_b208[1669]][_$_b208[2679]] || 1 / 0, me[_$_b208[2688]] = pe[_$_b208[1669]][_$_b208[2680]] || 0, me[_$_b208[2689]] = pe[_$_b208[1669]][_$_b208[1668]] || 1 / 0, me[_$_b208[2690]] = pe[_$_b208[2691]] || me[_$_b208[2690]], me[_$_b208[2692]] = pe[_$_b208[2693]] || me[_$_b208[2692]], me[_$_b208[2694]] = ne(ne({}, he[_$_b208[751]][_$_b208[2694]]), ((ve = be[_$_b208[716]]) === null || ve === void 0 ? void 0 : ve[_$_b208[2695]]) || {}), me;
              }, ue[_$_b208[21]][_$_b208[1128]] = function() {
                return this[_$_b208[2671]];
              }, ue[_$_b208[21]][_$_b208[2696]] = function(be) {
                var ve = {};
                for (var me in le[_$_b208[172]][_$_b208[350]](ve, be), ve)
                  ve[_$_b208[20]](me) && (this[_$_b208[703]][me] = ve[me], this[_$_b208[2671]][me] = ve[me]);
              }, ue[_$_b208[21]][_$_b208[199]] = function(be, ve) {
                return ve === void 0 && (ve = this[_$_b208[703]]), be ? ve[_$_b208[20]](be) ? this[_$_b208[703]][be] : {} : ve;
              }, ue[_$_b208[21]][_$_b208[498]] = function() {
                return this[_$_b208[199]](_$_b208[498]);
              }, ue[_$_b208[21]][_$_b208[693]] = function() {
                return this[_$_b208[199]](_$_b208[693]);
              }, ue[_$_b208[21]][_$_b208[1172]] = function() {
                return this[_$_b208[199]](_$_b208[1172]);
              }, ue[_$_b208[21]][_$_b208[716]] = function() {
                return this[_$_b208[199]](_$_b208[716]);
              }, ue[_$_b208[21]][_$_b208[1185]] = function() {
                return this[_$_b208[199]](_$_b208[1185]);
              }, ue[_$_b208[21]][_$_b208[1032]] = function() {
                return this[_$_b208[199]](_$_b208[1032]);
              }, ue[_$_b208[21]][_$_b208[2684]] = function() {
                return this[_$_b208[199]](_$_b208[2684]);
              }, ue[_$_b208[21]][_$_b208[803]] = function() {
                return this[_$_b208[199]](_$_b208[803]);
              }, ue[_$_b208[21]][_$_b208[968]] = function() {
                return this[_$_b208[199]](_$_b208[968]);
              }, ue[_$_b208[21]][_$_b208[2697]] = function() {
                return this[_$_b208[199]](_$_b208[2697]);
              }, ue[_$_b208[21]][_$_b208[10]] = function() {
                return this[_$_b208[199]](_$_b208[10]);
              }, ue;
            }();
            te[_$_b208[976]] = oe;
          }, 79209: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[224]] || function() {
              var oe = function(ue, be) {
                return oe = Object[_$_b208[225]] || { __proto__: [] } instanceof Array && function(ve, me) {
                  ve[_$_b208[226]] = me;
                } || function(ve, me) {
                  for (var pe in me)
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](me, pe) && (ve[pe] = me[pe]);
                }, oe(ue, be);
              };
              return function(ue, be) {
                if (_$_b208[161] != typeof be && be !== null)
                  throw new TypeError(_$_b208[227] + String(be) + _$_b208[228]);
                function ve() {
                  this[_$_b208[229]] = ue;
                }
                oe(ue, be), ue[_$_b208[21]] = be === null ? Object[_$_b208[230]](be) : (ve[_$_b208[21]] = be[_$_b208[21]], new ve());
              };
            }();
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[192]] = void 0;
            var ie = ee(1356), ae = ee(46462), ce = ee(47894), he = ee(27043), _e = ee(34795), le = function(oe) {
              function ue(be, ve) {
                var me = oe[_$_b208[19]](this, be, ve) || this;
                return me[_$_b208[2698]] = !1, me[_$_b208[744]] = function() {
                  var pe;
                  me[_$_b208[237]] || me[_$_b208[2698]] || (me[_$_b208[2698]] = !0, (pe = me[_$_b208[239]]) === null || pe === void 0 || pe[_$_b208[136]](ae[_$_b208[103]][_$_b208[168]]));
                }, me[_$_b208[2699]] = function() {
                  var pe, fe;
                  me[_$_b208[2698]] && !me[_$_b208[237]] && !me[_$_b208[242]] && se(me) && (me[_$_b208[2698]] = !1, (pe = me[_$_b208[239]]) === null || pe === void 0 || pe[_$_b208[142]](ae[_$_b208[103]][_$_b208[168]]), (fe = me[_$_b208[239]]) === null || fe === void 0 || fe[_$_b208[145]](ae[_$_b208[103]][_$_b208[168]]));
                }, me[_$_b208[2700]] = new _e[_$_b208[1606]](be, ve), me[_$_b208[243]] = new he[_$_b208[1467]]({ eventHandler: me[_$_b208[160]], getVideoElementCurrentTime: function() {
                  return me[_$_b208[236]]()[_$_b208[235]];
                } }), me[_$_b208[2701]](), me;
              }
              return ne(ue, oe), ue[_$_b208[21]][_$_b208[2701]] = function() {
                this[_$_b208[236]]()[_$_b208[100]](ae[_$_b208[103]][_$_b208[170]], this[_$_b208[2699]]), this[_$_b208[236]]()[_$_b208[100]](ae[_$_b208[103]][_$_b208[168]], this[_$_b208[744]]);
              }, ue[_$_b208[21]][_$_b208[2702]] = function() {
                this[_$_b208[236]]()[_$_b208[105]](ae[_$_b208[103]][_$_b208[170]], this[_$_b208[2699]]), this[_$_b208[236]]()[_$_b208[105]](ae[_$_b208[103]][_$_b208[168]], this[_$_b208[744]]);
              }, Object[_$_b208[13]](ue[_$_b208[21]], _$_b208[235], { get: function() {
                return this[_$_b208[243]][_$_b208[199]]();
              }, set: function(be) {
                this[_$_b208[236]]()[_$_b208[235]] = be;
              }, enumerable: !1, configurable: !0 }), ue[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[2700]][_$_b208[70]](), this[_$_b208[243]][_$_b208[70]](), this[_$_b208[2702]](), oe[_$_b208[21]][_$_b208[70]][_$_b208[19]](this);
              }, ue[_$_b208[21]][_$_b208[244]] = function() {
                this[_$_b208[239]][_$_b208[136]](ae[_$_b208[103]][_$_b208[168]]), this[_$_b208[2698]] = !1, this[_$_b208[2700]][_$_b208[64]](), this[_$_b208[243]][_$_b208[64]](), oe[_$_b208[21]][_$_b208[244]][_$_b208[19]](this);
              }, ue[_$_b208[21]][_$_b208[1532]] = function() {
                return oe[_$_b208[21]][_$_b208[1532]][_$_b208[19]](this)[_$_b208[674]](function() {
                  return new Promise(function(be) {
                    return setTimeout(be, 0);
                  });
                });
              }, ue[_$_b208[21]][_$_b208[167]] = function() {
                var be = this;
                this[_$_b208[239]][_$_b208[136]](ae[_$_b208[103]][_$_b208[168]]), this[_$_b208[239]][_$_b208[136]](ae[_$_b208[103]][_$_b208[170]], 1);
                var ve = this[_$_b208[97]][_$_b208[167]]();
                return ve == null && (ve = ie[_$_b208[75]][_$_b208[107]](this[_$_b208[46]], this, this[_$_b208[78]])), ve[_$_b208[674]](function() {
                  return be[_$_b208[2699]]();
                });
              }, ue;
            }(ce[_$_b208[218]]);
            function se(oe) {
              return oe[_$_b208[101]] >= HTMLMediaElement[_$_b208[2703]];
            }
            te[_$_b208[192]] = le;
          }, 79463: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1757]] = void 0, function(ne) {
              ne[_$_b208[1756]] = _$_b208[2704];
            }(ee || (te[_$_b208[1757]] = ee = {}));
          }, 79814: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1558]] = te[_$_b208[1216]] = void 0, te[_$_b208[2705]] = he;
            var ne, ie = ee(59181), ae = ee(33696);
            (function(_e) {
              _e[_$_b208[1911]] = _$_b208[2706], _e[_$_b208[2707]] = _$_b208[2708], _e[_$_b208[2709]] = _$_b208[2710], _e[_$_b208[2711]] = _$_b208[2712];
            })(ne || (te[_$_b208[1216]] = ne = {}));
            var ce = function() {
              function _e() {
              }
              return _e[_$_b208[2713]] = function(le) {
                return this[_$_b208[2714]](le) || this[_$_b208[2715]](le);
              }, _e[_$_b208[2715]] = function(le) {
                return le[_$_b208[26]](_$_b208[2495]);
              }, _e[_$_b208[2716]] = function(le) {
                return le[_$_b208[26]](_$_b208[2717]);
              }, _e[_$_b208[2714]] = function(le) {
                return le[_$_b208[26]](_$_b208[1839]);
              }, _e[_$_b208[1557]] = function(le) {
                return this[_$_b208[2718]](le) || this[_$_b208[1972]](le);
              }, _e[_$_b208[2718]] = function(le) {
                return le[_$_b208[26]](_$_b208[214]);
              }, _e[_$_b208[2719]] = function(le) {
                return le[_$_b208[26]](_$_b208[1796]);
              }, _e[_$_b208[1972]] = function(le) {
                return le[_$_b208[26]](_$_b208[1567]);
              }, _e[_$_b208[2720]] = function(le) {
                return le[_$_b208[26]](_$_b208[2721]);
              }, _e[_$_b208[2722]] = function(le) {
                return le[_$_b208[26]](ie[_$_b208[2192]][_$_b208[781]]);
              }, _e[_$_b208[2723]] = function(le) {
                return le[_$_b208[26]](ie[_$_b208[2192]][_$_b208[784]]) || le[_$_b208[26]](_$_b208[2724]);
              }, _e[_$_b208[2725]] = function(le) {
                return le[_$_b208[26]](_$_b208[2726]);
              }, _e[_$_b208[2727]] = function(le) {
                return this[_$_b208[2718]](le) ? ae[_$_b208[874]][_$_b208[873]] : this[_$_b208[1972]](le) ? ae[_$_b208[874]][_$_b208[906]] : this[_$_b208[2713]](le) ? ae[_$_b208[874]][_$_b208[1120]] : this[_$_b208[2720]](le) ? ae[_$_b208[874]][_$_b208[1568]] : void 0;
              }, _e[_$_b208[2728]] = function(le) {
                return le[_$_b208[258]](_$_b208[263])[0];
              }, _e[_$_b208[2729]] = function(le) {
                var se = le[_$_b208[258]](_$_b208[263]);
                return se[_$_b208[18]] > 1 ? se[1] : null;
              }, _e;
            }();
            function he(_e, le) {
              return Object[_$_b208[69]](_e)[_$_b208[124]](function(se) {
                return ce[_$_b208[2727]](se);
              })[_$_b208[26]](ce[_$_b208[2727]](le));
            }
            te[_$_b208[1558]] = ce;
          }, 80043: function(re, te) {
            _$_b208[11];
            var ee = this && this[_$_b208[224]] || function() {
              var he = function(_e, le) {
                return he = Object[_$_b208[225]] || { __proto__: [] } instanceof Array && function(se, oe) {
                  se[_$_b208[226]] = oe;
                } || function(se, oe) {
                  for (var ue in oe)
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](oe, ue) && (se[ue] = oe[ue]);
                }, he(_e, le);
              };
              return function(_e, le) {
                if (_$_b208[161] != typeof le && le !== null)
                  throw new TypeError(_$_b208[227] + String(le) + _$_b208[228]);
                function se() {
                  this[_$_b208[229]] = _e;
                }
                he(_e, le), _e[_$_b208[21]] = le === null ? Object[_$_b208[230]](le) : (se[_$_b208[21]] = le[_$_b208[21]], new se());
              };
            }();
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2730]] = te[_$_b208[2731]] = te[_$_b208[2732]] = void 0;
            var ne = function() {
              function he() {
              }
              return he[_$_b208[21]][_$_b208[2733]] = function() {
                for (var _e = []; this[_$_b208[2734]](); )
                  _e[_$_b208[141]](this[_$_b208[1279]]());
                return _e;
              }, he;
            }(), ie = function(he) {
              function _e() {
                return he[_$_b208[19]](this) || this;
              }
              return ee(_e, he), _e[_$_b208[21]][_$_b208[2734]] = function() {
                return !1;
              }, _e[_$_b208[21]][_$_b208[1279]] = function() {
              }, _e[_$_b208[817]] = function() {
                return this[_$_b208[2735]] || (this[_$_b208[2735]] = new _e()), this[_$_b208[2735]];
              }, _e;
            }(ne);
            te[_$_b208[2732]] = ie;
            var ae = function(he) {
              function _e(le) {
                var se = he[_$_b208[19]](this) || this;
                return se[_$_b208[1489]] = le, se[_$_b208[2736]] = -1, se;
              }
              return ee(_e, he), _e[_$_b208[21]][_$_b208[2734]] = function() {
                return this[_$_b208[2737]] = void 0, this[_$_b208[2736]] < this[_$_b208[1489]][_$_b208[18]] && (this[_$_b208[2736]]++, this[_$_b208[2737]] = this[_$_b208[1489]][this[_$_b208[2736]]]), this[_$_b208[2737]] != null;
              }, _e[_$_b208[21]][_$_b208[1279]] = function() {
                return this[_$_b208[2737]];
              }, _e;
            }(ne);
            te[_$_b208[2731]] = ae;
            var ce = function(he) {
              function _e(le, se) {
                var oe = he[_$_b208[19]](this) || this;
                return oe[_$_b208[2738]] = le, oe[_$_b208[165]] = se, oe;
              }
              return ee(_e, he), _e[_$_b208[21]][_$_b208[2734]] = function() {
                var le;
                for (this[_$_b208[2737]] = void 0; this[_$_b208[2738]][_$_b208[2734]](); )
                  if (le = this[_$_b208[2738]][_$_b208[1279]](), this[_$_b208[165]](le)) {
                    this[_$_b208[2737]] = le;
                    break;
                  }
                return this[_$_b208[2737]] != null;
              }, _e[_$_b208[21]][_$_b208[1279]] = function() {
                return this[_$_b208[2737]];
              }, _e;
            }(ne);
            te[_$_b208[2730]] = ce;
          }, 80618: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1807]] = void 0, function(ne) {
              ne[_$_b208[1806]] = _$_b208[2739], ne[_$_b208[1808]] = _$_b208[2740];
            }(ee || (te[_$_b208[1807]] = ee = {}));
          }, 81361: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[629]] || function(pe, fe, ge) {
              if (ge || arguments[_$_b208[18]] === 2)
                for (var ye, $e = 0, Se = fe[_$_b208[18]]; $e < Se; $e++)
                  !ye && $e in fe || (ye || (ye = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](fe, 0, $e)), ye[$e] = fe[$e]);
              return pe[_$_b208[94]](ye || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](fe));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1590]] = void 0, te[_$_b208[2741]] = ce, te[_$_b208[2742]] = he, te[_$_b208[2743]] = _e, te[_$_b208[2744]] = le, te[_$_b208[2745]] = se, te[_$_b208[2746]] = oe, te[_$_b208[2747]] = ue, te[_$_b208[2748]] = be, te[_$_b208[2749]] = ve, te[_$_b208[2750]] = me;
            var ie = ee(56093), ae = function() {
              function pe() {
              }
              return pe[_$_b208[1589]] = function(fe, ge) {
                if (fe[_$_b208[18]] !== ge[_$_b208[18]])
                  return !1;
                for (var ye = 0; ye < fe[_$_b208[18]]; ye++)
                  if (fe[ye] !== ge[ye])
                    return !1;
                return !0;
              }, pe[_$_b208[2751]] = function(fe) {
                for (var ge = new Uint8Array(fe[_$_b208[18]]), ye = 0; ye < fe[_$_b208[18]]; ye++)
                  ge[ye] = fe[_$_b208[1504]](ye);
                return ge;
              }, pe[_$_b208[2752]] = function(fe, ge) {
                return ge === void 0 && (ge = _$_b208[1595]), fe instanceof ArrayBuffer ? fe = new Uint8Array(fe) : fe instanceof DataView && (fe = new Uint8Array(fe[_$_b208[1172]], fe[_$_b208[2753]], fe[_$_b208[1592]])), pe[_$_b208[2754]](fe, ge);
              }, pe[_$_b208[2754]] = function(fe, ge) {
                if (_$_b208[0] != typeof TextDecoder)
                  return new TextDecoder(ge)[_$_b208[2755]](fe);
                for (var ye = 0, $e = _$_b208[265]; ye < fe[_$_b208[18]]; ) {
                  var Se = fe[ye++];
                  if (Se > 127)
                    if (Se > 191 && Se < 224) {
                      if (ye >= fe[_$_b208[18]] || 64 & fe[ye]) {
                        $e += _$_b208[2756];
                        continue;
                      }
                      Se = (31 & Se) << 6 | 63 & fe[ye++];
                    } else if (Se > 223 && Se < 240) {
                      if (ye + 1 >= fe[_$_b208[18]] || 64 & fe[ye] || 64 & fe[ye + 1]) {
                        $e += _$_b208[2756];
                        continue;
                      }
                      Se = (15 & Se) << 12 | (63 & fe[ye++]) << 6 | 63 & fe[ye++];
                    } else {
                      if (!(Se > 239 && Se < 248)) {
                        $e += _$_b208[2756];
                        continue;
                      }
                      if (ye + 2 >= fe[_$_b208[18]] || 64 & fe[ye] || 64 & fe[ye + 1] || 64 & fe[ye + 2]) {
                        $e += _$_b208[2756];
                        continue;
                      }
                      Se = (7 & Se) << 18 | (63 & fe[ye++]) << 12 | (63 & fe[ye++]) << 6 | 63 & fe[ye++];
                    }
                  Se <= 65535 ? $e += String[_$_b208[2067]](Se) : Se <= 1114111 ? (Se -= 65536, $e += String[_$_b208[2067]](Se >> 10 | 55296), $e += String[_$_b208[2067]](1023 & Se | 56320)) : $e += _$_b208[2756];
                }
                return $e;
              }, pe[_$_b208[1764]] = function(fe, ge, ye) {
                if (_$_b208[348] == typeof ge && _$_b208[2757] === Object[_$_b208[21]][_$_b208[118]][_$_b208[19]](fe)) {
                  var $e;
                  if (ye || (ye = _$_b208[2758]), _$_b208[2758] === ye)
                    $e = -1;
                  else {
                    if (_$_b208[2759] !== ye)
                      return;
                    $e = 1;
                  }
                  if (fe[_$_b208[18]] < 2)
                    return fe;
                  var Se = function(Ce, Ie) {
                    return Ce[ge] < Ie[ge] ? $e : Ce[ge] > Ie[ge] ? -1 * $e : 0;
                  };
                  return fe[_$_b208[1764]](Se);
                }
              }, pe[_$_b208[2760]] = function(fe, ge) {
                var ye = pe[_$_b208[2761]](fe), $e = pe[_$_b208[2761]](ge);
                if (!ye && !$e || ye !== $e)
                  return null;
                var Se = new ye((fe[_$_b208[1592]] + ge[_$_b208[1592]]) / ye[_$_b208[2762]]);
                return Se[_$_b208[361]](new ye(fe), 0), Se[_$_b208[361]](new ye(ge), fe[_$_b208[1592]] / ye[_$_b208[2762]]), Se;
              }, pe[_$_b208[2763]] = function() {
                for (var fe = [], ge = 0; ge < arguments[_$_b208[18]]; ge++)
                  fe[ge] = arguments[ge];
                if (!(fe = fe[_$_b208[165]](function(Se) {
                  return Se;
                }))[_$_b208[18]])
                  return null;
                var ye = fe[_$_b208[1277]](function(Se, Ce) {
                  return Se + Ce[_$_b208[1592]];
                }, 0), $e = new Uint8Array(ye);
                return fe[_$_b208[1277]](function(Se, Ce) {
                  return $e[_$_b208[361]](new Uint8Array(Ce), Se), Se + Ce[_$_b208[1592]];
                }, 0), $e[_$_b208[1172]];
              }, pe[_$_b208[2761]] = function(fe) {
                return fe instanceof Uint8Array ? Uint8Array : fe instanceof Uint16Array ? Uint16Array : fe instanceof Uint32Array ? Uint32Array : null;
              }, pe[_$_b208[2764]] = function(fe) {
                return pe[_$_b208[2761]](fe) ? [][_$_b208[630]][_$_b208[19]](fe) : Array[_$_b208[1122]](fe) ? fe : null;
              }, pe[_$_b208[2765]] = function() {
                for (var fe = [], ge = 0; ge < arguments[_$_b208[18]]; ge++)
                  fe[ge] = arguments[ge];
                var ye = [];
                return fe[_$_b208[165]](function($e) {
                  return !!$e;
                })[_$_b208[68]](function($e) {
                  return $e[_$_b208[68]](function(Se) {
                    ye[_$_b208[26]](Se) || ye[_$_b208[141]](Se);
                  });
                }), ye;
              }, pe[_$_b208[2766]] = function(fe) {
                return !!fe && fe instanceof ArrayBuffer && fe[_$_b208[1592]] !== void 0;
              }, pe[_$_b208[2767]] = function(fe, ge) {
                return ge === void 0 && (ge = !0), pe[_$_b208[2768]](fe, 1, 0, ge);
              }, pe[_$_b208[2769]] = function(fe) {
                for (var ge = _$_b208[265], ye = new Uint8Array(fe), $e = 0; $e < ye[_$_b208[18]]; $e++)
                  ge += String[_$_b208[2067]](ye[$e]);
                return window[_$_b208[2091]](ge);
              }, pe[_$_b208[2768]] = function(fe, ge, ye, $e) {
                ge === void 0 && (ge = 2), ye === void 0 && (ye = 0), $e === void 0 && ($e = !0);
                for (var Se = _$_b208[265], Ce = $e ? new Uint8Array(fe) : new Uint16Array(fe), Ie = ye; Ie < Ce[_$_b208[18]]; Ie += ge)
                  Se += String[_$_b208[2067]](Ce[Ie]);
                return Se;
              }, pe[_$_b208[2770]] = function() {
                for (var fe = [], ge = 0; ge < arguments[_$_b208[18]]; ge++)
                  fe[ge] = arguments[ge];
                var ye = [], $e = fe[_$_b208[165]](function(Se) {
                  return !!Se;
                });
                return pe[_$_b208[2765]][_$_b208[22]](pe, fe)[_$_b208[68]](function(Se) {
                  $e[_$_b208[516]](function(Ce) {
                    return Ce[_$_b208[26]](Se);
                  }) && ye[_$_b208[141]](Se);
                }), ye;
              }, pe[_$_b208[2771]] = function(fe, ge) {
                var ye = fe[_$_b208[165]](function(Se) {
                  return pe[_$_b208[2770]](Se, ge)[_$_b208[18]] > 0;
                }), $e = fe[_$_b208[165]](function(Se) {
                  return !ye[_$_b208[26]](Se);
                });
                return ye[_$_b208[18]] === 0 ? ne(ne([], fe, !0), [ge], !1) : ne([pe[_$_b208[2765]][_$_b208[22]](pe, ne(ne([], ye, !1), [ge], !1))], $e, !0);
              }, pe[_$_b208[2772]] = function(fe, ge, ye) {
                for (var $e = ge + ye, Se = _$_b208[265]; ge < $e; ge++)
                  Se += String[_$_b208[2067]](fe[_$_b208[1593]](ge));
                return Se;
              }, pe[_$_b208[2773]] = function(fe, ge, ye) {
                for (var $e = ge + ye, Se = _$_b208[265]; ge < $e; ge++)
                  Se += ie[_$_b208[2081]][_$_b208[2087]](fe[_$_b208[1593]](ge));
                return Se;
              }, pe[_$_b208[2733]] = function(fe) {
                try {
                  if (!fe || !fe[_$_b208[18]])
                    return [];
                  for (var ge = new Array(fe[_$_b208[18]]), ye = 0; ye < fe[_$_b208[18]]; ye++)
                    ge[ye] = fe[ye];
                  return ge;
                } catch {
                  return [];
                }
              }, pe;
            }();
            function ce(pe) {
              return function(fe, ge, ye) {
                return !pe(fe, ge, ye);
              };
            }
            function he(pe, fe) {
              var ge;
              for (ge = pe[_$_b208[18]] - 1; ge >= 0 && !fe(pe[ge]); ge--)
                ;
              return ge;
            }
            function _e(pe, fe, ge, ye) {
              for (var $e = fe; $e < ge; $e++)
                if (ye(pe[$e]))
                  return $e;
              return -1;
            }
            function le(pe, fe) {
              return pe[he(pe, fe)];
            }
            function se(pe, fe, ge) {
              for (; fe < pe[_$_b208[18]]; fe++)
                ge(pe[fe - 1], pe[fe]);
            }
            function oe(pe) {
              return Array[_$_b208[1122]](pe) ? pe : [pe];
            }
            function ue(pe, fe, ge) {
              return ge === void 0 && (ge = be), pe[_$_b208[164]](function(ye) {
                return ge(fe, ye);
              }) != null;
            }
            function be(pe, fe) {
              return Object[_$_b208[69]](pe)[_$_b208[18]] === Object[_$_b208[69]](fe)[_$_b208[18]] && Object[_$_b208[69]](pe)[_$_b208[516]](function(ge) {
                return pe[ge] === fe[ge];
              });
            }
            function ve(pe) {
              pe[_$_b208[139]](0, pe[_$_b208[18]]);
            }
            function me(pe, fe) {
              return fe < 1 ? [] : pe[_$_b208[139]](0, fe);
            }
            te[_$_b208[1590]] = ae;
          }, 82315: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1659]] = void 0;
            var ee = function() {
              function ne() {
                this[_$_b208[2774]] = {};
              }
              return ne[_$_b208[817]] = function() {
                return ne[_$_b208[2775]] || (ne[_$_b208[2775]] = new ne()), ne[_$_b208[2775]];
              }, ne[_$_b208[21]][_$_b208[2776]] = function(ie, ae) {
                return ae === void 0 && (ae = !1), this[_$_b208[2774]][_$_b208[20]](ie) && this[_$_b208[2774]][ie] || (ae && window[_$_b208[2777]] && window[_$_b208[2778]] ? this[_$_b208[2774]][ie] = new Promise(function(ce, he) {
                  window[_$_b208[2777]]([ie], function(_e) {
                    ce(_e);
                  }, function(_e) {
                    he(_e);
                  });
                }) : this[_$_b208[2774]][ie] = new Promise(function(ce, he) {
                  var _e = document[_$_b208[277]](_$_b208[2779])[0] || document[_$_b208[2780]], le = !1, se = document[_$_b208[796]](_$_b208[276]);
                  se[_$_b208[89]] = _$_b208[2781], se[_$_b208[274]] = ie, se[_$_b208[2782]] = !0, se[_$_b208[2783]] = se[_$_b208[2784]] = function() {
                    le || this[_$_b208[101]] && _$_b208[376] !== this[_$_b208[101]] && _$_b208[2785] !== this[_$_b208[101]] || (le = !0, se[_$_b208[2783]] = se[_$_b208[2784]] = null, _e && se[_$_b208[1042]] && _e[_$_b208[963]](se), ce(void 0));
                  }, se[_$_b208[2786]] = he, _e[_$_b208[2787]](se, _e[_$_b208[1522]]);
                })), this[_$_b208[2774]][ie];
              }, ne[_$_b208[21]][_$_b208[2788]] = function(ie, ae) {
                this[_$_b208[2774]][_$_b208[20]](ie) && this[_$_b208[2774]][ie] && delete this[_$_b208[2774]][ie];
                for (var ce = document[_$_b208[2779]][_$_b208[277]](_$_b208[276]), he = 0; he < ce[_$_b208[18]]; he++)
                  ce[he][_$_b208[274]][_$_b208[26]](ae) && document[_$_b208[2779]][_$_b208[963]](ce[he]);
              }, ne[_$_b208[21]][_$_b208[2789]] = function(ie, ae) {
                for (var ce, he = ((ce = ae == null ? void 0 : ae[_$_b208[545]]) === null || ce === void 0 ? void 0 : ce[_$_b208[19]](ae)) || document[_$_b208[277]](_$_b208[2779])[0] || document[_$_b208[2780]], _e = he[_$_b208[2791]](_$_b208[2790]), le = 0; le < _e[_$_b208[18]]; le++) {
                  var se = _e[le];
                  if (se[_$_b208[284]](_$_b208[2792]) && se[_$_b208[600]](_$_b208[2792])[_$_b208[138]](ie) > -1)
                    return;
                }
                var oe = document[_$_b208[796]](_$_b208[2790]);
                oe[_$_b208[598]](_$_b208[2793], _$_b208[2794]), oe[_$_b208[598]](_$_b208[89], _$_b208[2795]), oe[_$_b208[598]](_$_b208[2792], ie), he[_$_b208[2787]](oe, he[_$_b208[1522]]), this[_$_b208[2774]][ie] = !0;
              }, ne;
            }();
            te[_$_b208[1659]] = ee;
          }, 82334: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1194]] = void 0;
            var ee = function() {
              function ne() {
              }
              return ne[_$_b208[230]] = function(ie) {
                return new (function() {
                  function ae() {
                  }
                  return ae[_$_b208[21]][_$_b208[1961]] = function(ce, he, _e) {
                    ie[_$_b208[898]](ce, he, _e);
                  }, ae[_$_b208[21]][_$_b208[875]] = function(ce, he) {
                    return ie[_$_b208[903]](ce, he);
                  }, ae;
                }())();
              }, ne;
            }();
            te[_$_b208[1194]] = ee;
          }, 83091: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[782]] = void 0, function(ne) {
              ne[_$_b208[786]] = _$_b208[787], ne[_$_b208[781]] = _$_b208[783], ne[_$_b208[784]] = _$_b208[785], ne[_$_b208[788]] = _$_b208[789], ne[_$_b208[790]] = _$_b208[791], ne[_$_b208[961]] = _$_b208[1796];
            }(ee || (te[_$_b208[782]] = ee = {}));
          }, 84342: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2796]] = he;
            var ne = ee(3464), ie = ee(33669);
            function ae(_e) {
              return function(le) {
                var se = (0, ie[_$_b208[1548]])(le);
                return se ? (0, ie[_$_b208[1547]])(se, _e) : [];
              };
            }
            function ce(_e) {
              var le = _e[_$_b208[182]](), se = (0, ie[_$_b208[1548]])(le);
              return se !== void 0 ? Object[_$_b208[69]](se) : [];
            }
            function he(_e, le) {
              var se = ce(_e)[_$_b208[124]](function(oe) {
                return (0, ne[_$_b208[183]])(_e)(ae(oe), function(ue) {
                  return le(oe, ue ?? []);
                });
              });
              return function() {
                return se[_$_b208[68]](function(oe) {
                  return oe();
                });
              };
            }
          }, 84435: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1192]] = void 0;
            var ne = ee(4006), ie = ee(88005), ae = ee(67345), ce = ee(11399), he = ee(13533), _e = ee(45217), le = function() {
              function oe(ue, be) {
                this[_$_b208[148]] = ue, this[_$_b208[2797]] = !1, this[_$_b208[2798]] = _e[_$_b208[1930]] + _$_b208[2799], this[_$_b208[717]](be);
              }
              return oe[_$_b208[21]][_$_b208[2800]] = function(ue) {
                return new ie[_$_b208[2801]]({ settings: { RETRY_DELAY: 0, INCREASE_RETRY_DELAY: !1, INCREASE_RETRY_DELAY_BASE_SEC: 0, MAX_INCREASE_RETRY_DELAY_SEC: 0, QUERY_PARAMETERS: [], HTTP_HEADERS: null, XHR_TIMEOUT: 2e4, DISABLE_RETRY_FOR_RESPONSE_STATUS: {} }, logger: this[_$_b208[148]], config: { network: { requestApi: ue } } });
              }, oe[_$_b208[21]][_$_b208[727]] = function(ue, be, ve) {
                var me, pe = this;
                if (this[_$_b208[2797]])
                  return Promise[_$_b208[85]](void 0);
                this[_$_b208[2802]] = (me = this[_$_b208[2802]]) !== null && me !== void 0 ? me : this[_$_b208[2800]](ve), this[_$_b208[2797]] = !0;
                var fe = { domain: ne[_$_b208[249]][_$_b208[250]], key: ue, version: ne[_$_b208[249]][_$_b208[279]], type: _$_b208[2803] + be, platform: se() };
                return this[_$_b208[2802]][_$_b208[244]](this[_$_b208[2804]], ae[_$_b208[2443]][_$_b208[2497]], null, JSON[_$_b208[1012]](fe))[_$_b208[674]](function(ge) {
                  return ge;
                }, function(ge) {
                  return pe[_$_b208[2804]] !== pe[_$_b208[2798]] && (0, he[_$_b208[191]])()[_$_b208[193]] ? (pe[_$_b208[2797]] = !1, pe[_$_b208[717]](pe[_$_b208[2798]]), pe[_$_b208[727]](ue, be, ve)) : ge;
                });
              }, oe[_$_b208[21]][_$_b208[717]] = function(ue) {
                ue && (this[_$_b208[2804]] = ue);
              }, oe[_$_b208[21]][_$_b208[64]] = function() {
                this[_$_b208[2797]] = !1;
              }, oe[_$_b208[21]][_$_b208[70]] = function() {
                var ue;
                (ue = this[_$_b208[2802]]) === null || ue === void 0 || ue[_$_b208[70]]();
              }, oe;
            }();
            function se() {
              return (0, he[_$_b208[191]])()[ce[_$_b208[190]][_$_b208[465]]] ? _$_b208[2805] : _$_b208[2806];
            }
            te[_$_b208[1192]] = le;
          }, 84903: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[973]] = void 0;
            var ne, ie = ee(4006), ae = ee(88005), ce = ee(67345), he = ee(13533), _e = ee(45217);
            (function(me) {
              me[_$_b208[2807]] = _$_b208[2808], me[_$_b208[2809]] = _$_b208[2810];
            })(ne || (ne = {}));
            var le = [_$_b208[256], _$_b208[2811]], se = _e[_$_b208[1930]] + _$_b208[2812], oe = 3e4, ue = function() {
              function me(pe, fe, ge) {
                this[_$_b208[2813]] = 0, this[_$_b208[2814]] = [], this[_$_b208[2815]] = !1, this[_$_b208[2816]] = void 0, this[_$_b208[2817]] = fe, this[_$_b208[723]] = ge, this[_$_b208[148]] = pe;
              }
              return me[_$_b208[21]][_$_b208[727]] = function(pe, fe) {
                var ge = this;
                this[_$_b208[2818]]() ? setTimeout(function() {
                  return pe(!0);
                }, 0) : this[_$_b208[723]] ? this[_$_b208[2816]] ? setTimeout(function() {
                  return pe(ge[_$_b208[2816]][_$_b208[2808]], ge[_$_b208[2816]][_$_b208[1464]], ge[_$_b208[2816]][_$_b208[1489]]);
                }, 0) : (this[_$_b208[2814]][_$_b208[141]](pe), this[_$_b208[2815]] || (this[_$_b208[2815]] = !0, setTimeout(function() {
                  ge[_$_b208[2819]](ge[_$_b208[723]], ge[_$_b208[2817]], fe);
                }, this[_$_b208[2813]]))) : setTimeout(function() {
                  return pe(!1, { validationInformation: [{ key: _$_b208[723], errorMessage: _$_b208[2820] }] });
                }, 0);
              }, me[_$_b208[21]][_$_b208[2818]] = function() {
                return le[_$_b208[26]](ie[_$_b208[249]][_$_b208[250]]) || !this[_$_b208[2817]];
              }, me[_$_b208[2821]] = function(pe) {
                var fe = { granted: !1, payload: {}, data: {} };
                return pe && pe[_$_b208[2136]] && (fe[_$_b208[1489]][_$_b208[2136]] = { key: pe[_$_b208[2136]] }), pe && pe[_$_b208[20]](_$_b208[391]) && (pe[_$_b208[391]] === ne[_$_b208[2807]] ? (fe[_$_b208[2808]] = !0, fe[_$_b208[1464]] = ve(pe)) : pe[_$_b208[391]] === ne[_$_b208[2809]] && (fe[_$_b208[2808]] = !1, fe[_$_b208[1464]] = { message: pe[_$_b208[119]] })), fe;
              }, me[_$_b208[2822]] = function(pe) {
                var fe = { granted: !1, payload: {}, data: {} };
                return pe && pe[_$_b208[20]](_$_b208[1150]) ? (fe[_$_b208[2808]] = !1, fe[_$_b208[1464]] = pe) : fe[_$_b208[2808]] = !0, fe;
              }, me[_$_b208[21]][_$_b208[2823]] = function(pe) {
                for (var fe = 0, ge = this[_$_b208[2814]]; fe < ge[_$_b208[18]]; fe++)
                  (0, ge[fe])(pe[_$_b208[2808]], pe[_$_b208[1464]], pe[_$_b208[1489]]);
              }, me[_$_b208[21]][_$_b208[1166]] = function(pe) {
                this[_$_b208[2824]] = pe;
              }, me[_$_b208[21]][_$_b208[974]] = function(pe) {
                isNaN(pe) || (this[_$_b208[2813]] = Math[_$_b208[842]](pe, oe));
              }, me[_$_b208[21]][_$_b208[2819]] = function(pe, fe, ge) {
                var ye = this, $e = JSON[_$_b208[1012]]({ domain: ie[_$_b208[249]][_$_b208[250]], key: pe || _$_b208[265], version: ie[_$_b208[249]][_$_b208[279]], customData: this[_$_b208[2824]] }), Se = this[_$_b208[2825]](ge);
                Se[_$_b208[244]](fe, ce[_$_b208[2443]][_$_b208[2497]], ce[_$_b208[1705]][_$_b208[1704]], $e)[_$_b208[674]](function(Ce) {
                  Se[_$_b208[70]](), ye[_$_b208[2816]] = me[_$_b208[2821]](be(Ce[_$_b208[422]])), ye[_$_b208[2815]] = !1, ye[_$_b208[2823]](ye[_$_b208[2816]]);
                }, function(Ce) {
                  Se[_$_b208[70]](), fe !== se && (0, he[_$_b208[191]])()[_$_b208[193]] ? setTimeout(function() {
                    return ye[_$_b208[2819]](pe, se, ge);
                  }, ye[_$_b208[2813]]) : (ye[_$_b208[2816]] = me[_$_b208[2822]](be(Ce[_$_b208[422]])), ye[_$_b208[2815]] = !1, ye[_$_b208[2823]](ye[_$_b208[2816]]));
                });
              }, me[_$_b208[21]][_$_b208[2825]] = function(pe) {
                return new ae[_$_b208[2801]]({ settings: { RETRY_DELAY: 0, INCREASE_RETRY_DELAY: !1, INCREASE_RETRY_DELAY_BASE_SEC: 0, MAX_INCREASE_RETRY_DELAY_SEC: 0, QUERY_PARAMETERS: [], HTTP_HEADERS: null, XHR_TIMEOUT: 2e4, DISABLE_RETRY_FOR_RESPONSE_STATUS: {} }, logger: this[_$_b208[148]], config: { network: { requestApi: pe } } });
              }, me[_$_b208[817]] = function(pe, fe, ge) {
                var ye = [fe, ge][_$_b208[118]]();
                return me[_$_b208[2826]][_$_b208[20]](ye) || (me[_$_b208[2826]][ye] = new me(pe, fe, ge)), me[_$_b208[2826]][ye];
              }, me[_$_b208[64]] = function() {
                Object[_$_b208[69]](me[_$_b208[2826]])[_$_b208[68]](function(pe) {
                  return delete me[_$_b208[2826]][pe];
                });
              }, me[_$_b208[2826]] = {}, me;
            }();
            function be(me) {
              if (_$_b208[348] == typeof me)
                try {
                  return JSON[_$_b208[1035]](me);
                } catch {
                  return {};
                }
              return me;
            }
            function ve(me) {
              var pe = {};
              return me[_$_b208[20]](_$_b208[2827]) && me[_$_b208[2827]] && (pe[_$_b208[2827]] = !0), me[_$_b208[20]](_$_b208[2828]) && (pe[_$_b208[2828]] = me[_$_b208[2828]]), me[_$_b208[20]](_$_b208[2829]) && (pe[_$_b208[2829]] = me[_$_b208[2829]]), me[_$_b208[20]](_$_b208[2830]) && (pe[_$_b208[2830]] = me[_$_b208[2830]]), pe;
            }
            te[_$_b208[973]] = ue;
          }, 86865: function(re, te) {
            _$_b208[11];
            function ee(ne, ie, ae) {
              return !ne && !ie || !(!ne || !ie) && (ae || Object[_$_b208[69]](ne))[_$_b208[516]](function(ce) {
                return ne[ce] === ie[ce];
              });
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2831]] = ee;
          }, 87093: function(re, te) {
            _$_b208[11];
            var ee;
            function ne(he) {
              return _$_b208[2832] in he && he[_$_b208[2832]] === Math;
            }
            function ie() {
              return _$_b208[617] == typeof window && window && ne(window) ? window : void 0;
            }
            function ae() {
              return _$_b208[617] == typeof self && self && ne(self) ? self : void 0;
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 });
            var ce = (ee = ie()) !== null && ee !== void 0 ? ee : ae();
            te[_$_b208[302]] = ce;
          }, 87326: function(re, te, ee) {
            _$_b208[11];
            var ne, ie, ae, ce;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[751]] = te[_$_b208[2833]] = void 0;
            var he = ee(67345), _e = ee(33696);
            te[_$_b208[2833]] = { TARGET_BITRATE_FACTOR: 1, TARGET_BUFFER_FACTOR: 0.8, BITRATE_MODIFIER_FUNCTION_TYPE: _$_b208[1037], USE_RATE_BASED_SELECTION_ON_SEEKING: !1 }, te[_$_b208[751]] = { TARGET_BUFFER_LEVEL: (ne = {}, ne[_e[_$_b208[874]][_$_b208[873]]] = (ie = {}, ie[_e[_$_b208[872]][_$_b208[871]]] = 40, ie[_e[_$_b208[872]][_$_b208[1571]]] = 20, ie), ne[_e[_$_b208[874]][_$_b208[906]]] = (ae = {}, ae[_e[_$_b208[872]][_$_b208[871]]] = 40, ae[_e[_$_b208[872]][_$_b208[1571]]] = 20, ae), ne), BUFFER_LOGIC_ACTIVATION_THRESHOLD: 10, MIN_TIMELINE_LIVE_OFFSET: 4, RETRY_DELAY: 2, MAX_INCREASE_RETRY_DELAY_SEC: 30, INCREASE_RETRY_DELAY: !0, INCREASE_RETRY_DELAY_BASE_SEC: 0.25, DISABLE_RETRY_FOR_RESPONSE_STATUS: (ce = {}, ce[he[_$_b208[2444]][_$_b208[2445]]] = [], ce[he[_$_b208[2444]][_$_b208[2447]]] = [], ce[he[_$_b208[2444]][_$_b208[2449]]] = [], ce[he[_$_b208[2444]][_$_b208[2451]]] = [], ce[he[_$_b208[2444]][_$_b208[2453]]] = [], ce[he[_$_b208[2444]][_$_b208[2455]]] = [], ce[he[_$_b208[2444]][_$_b208[2457]]] = [], ce[he[_$_b208[2444]][_$_b208[2459]]] = [], ce[he[_$_b208[2444]][_$_b208[2461]]] = [], ce[he[_$_b208[2444]][_$_b208[2463]]] = [], ce[he[_$_b208[2444]][_$_b208[2465]]] = [], ce[he[_$_b208[2444]][_$_b208[2467]]] = [], ce[he[_$_b208[2444]][_$_b208[2469]]] = [], ce[he[_$_b208[2444]][_$_b208[2471]]] = [], ce[he[_$_b208[2444]][_$_b208[2473]]] = [], ce[he[_$_b208[2444]][_$_b208[2475]]] = [], ce[he[_$_b208[2444]][_$_b208[2477]]] = [], ce[he[_$_b208[2444]][_$_b208[2479]]] = [], ce[he[_$_b208[2444]][_$_b208[2481]]] = [], ce[he[_$_b208[2444]][_$_b208[2483]]] = [], ce[he[_$_b208[2444]][_$_b208[2485]]] = [], ce[he[_$_b208[2444]][_$_b208[2487]]] = [], ce[he[_$_b208[2444]][_$_b208[1404]]] = [], ce), METRIC_HISTORY_SIZE: 30, DEFAULT_ADAPTATION_RULE_HISTORY_SIZE: 40, LOG_LEVEL: 2, LOG_PREFIX: _$_b208[265], RESTART_THRESHOLD: 0.9, RESTART_THRESHOLD_DELTA: 0.5, STARTUP_THRESHOLD: 0.9, STARTUP_THRESHOLD_DELTA: 0.5, START_SEARCHING_END: 2, MAX_RETRIES: 2, MAX_CDN_RETRIES: 2, MAX_MPD_RETRIES: 2, MPD_RETRY_DELAY: 0.5, MPD_UPDATE_PERIOD_TOLERANCE: 5, DRM_MAX_RETRIES: 1, DRM_RETRY_DELAY: 0.25, DRM_WITH_CREDENTIALS: !1, CAST_APPLICATION_ID: _$_b208[2834], CAST_MESSAGE_NAMESPACE: _$_b208[2835], BUFFER_VISIBILITY_DELAY: 2, MIN_SELECTABLE_VIDEO_BITRATE: 0, MAX_SELECTABLE_VIDEO_BITRATE: 1 / 0, EXCLUDE_DISALLOWED_REPRESENTATIONS: !1, MIN_SELECTABLE_AUDIO_BITRATE: 0, MAX_SELECTABLE_AUDIO_BITRATE: 1 / 0, XHR_TIMEOUT: 20, QUERY_PARAMETERS: void 0, GAP_TOLERANCE: 0.1, END_OF_BUFFER_TOLERANCE: 0.1, END_OF_BUFFER_RECOVERY_TOLERANCE: 0.5, MAX_POTENTIAL_GAP_TIME_DEVIATION: 0.125, SEEK_TO_END_OFFSET: 2, MINIMUM_ALLOWED_UPDATE_PERIOD: 1, MAXIMUM_ALLOWED_UPDATE_PERIOD: 1 / 0, GLOBAL_DISABLE_SEEKING: !1, PRE_ROLL_RESTORE_THRESHOLD: 0.25, IOS_MIN_TIMEUPDATES_AFTER_AD: 2, HTTP_HEADERS: {}, DOWNLOAD_DURATION_SAFETY_MARGIN: 0.4, MAXIMUM_DOWNLOAD_DURATION_MULTIPLIER: 2, RATE_SAFETY_MARGIN_PERCENTAGE: 10, MAX_ALLOWED_BANDWIDTH_ESTIMATION: 1 / 0, LIVE_SEGMENT_LIST_START_INDEX_OFFSET: 0, MAX_NUM_CACHED_SEGMENTS: 1, TRUN_VERSION: void 0, IGNORE_MP4_EDTS_BOX: !0, HLS_AUDIO_ONLY_THRESHOLD_BITRATE: 2e5, ENABLE_SEEK_FOR_LIVE: !1, LIVE_EDGE_DISTANCE: 0, QUALITY_THRESHOLD: 0.5, QUALITY_UPPER_THRESHOLD: 45, MAX_CONSECUTIVE_VR_ERRORS: 3, MAX_CONSECUTIVE_RENDERER_ERRORS: 3, DISABLE_HLS_BACKUP_STREAM_FAILOVER: !1, PLAYBACK_TIMEOUT: 1500, HLS_SYNC_VIA_MEDIA_SEQUENCE: !1, STOP_DOWNLOAD_ON_PAUSE: !1, VR_SCHEME_ID_URI: _$_b208[2836], HLS_VR_CHARACTERISTICS_UTI: _$_b208[2837], SAFARI_NUM_PROGRESS_EVENTS_AFTER_SEEK_GLITCH: 5, SEGMENT_LOADER_POOL_SIZE: {}, NATIVE_HLS_PARSING: !1, NATIVE_HLS_DOWNLOAD_ERROR_HANDLING: !1, AKAMAI_DATETIME_PARSING: !1, QJY_BROWSER_WORKAROUND: !1, DWORD_BASE_MEDIA_DECODE_TIMESTAMPS: !1, FORCE_BASE_MEDIA_DECODE_TIME_REWRITE: !1, WEBOS_MAX_SAFE_BMDT: 274877906943, WEBOS_MAX_SAFE_PTO: 4194303, TIZEN_MAX_SAFE_BMDT: 4294967295, TIZEN_MAX_SAFE_PTO: 4294967295, VIDAA_MAX_SAFE_BMDT: 4294967295, VIDAA_MAX_SAFE_PTO: 4294967295, ADAPTATION_SET_SWITCHING_WITHOUT_SUPPLEMENTAL_PROPERTY: !1, MINIMAL_BACKWARD_BUFFER_CLEARING_INTERVAL: 0.5, CHUNKED_CMAF_STREAMING: !1, LOW_LATENCY_DEFAULT_TARGET_LATENCY: 5, LOW_LATENCY_BUFFER_GUARD: 0.5, LOW_LATENCY_DEFAULT_FALLBACK_PLAYBACK_RATE: 0.95, LOW_LATENCY_DEFAULT_CATCHUP_PLAYBACK_RATE: 1.2, LOW_LATENCY_SEEK_AHEAD: 1, ACCEPTABLE_TIMESHIFT_INACCURACY: 3, IGNORE_HLS_AUDIO_GROUPS: !1, OPTIMIZE_AD_RESTORATION: !0, AD_RESTORATION_SEGMENT_PREFETCHING_DURATION: 5, MIN_SAFE_BUFFER_LEVEL: 3, THUMBNAIL_TO_PLAYER_SIZE_RATIO: 0.1, FAIRPLAY_IGNORE_DUPLICATE_INIT_DATA_KEY_ERRORS: !1, NO_QUOTA_EXCEEDED_ADJUSTMENT: !1, RESUME_LIVE_CONTENT_AT_PREVIOUS_POSITION_AFTER_AD_BREAK: !1, MIN_EFFECTIVE_SEGMENT_DOWNLOAD_TIME: 0.5, fixed: { APP_NAME: _$_b208[1793], VERSION: _$_b208[280] }, CLEAR_BUFFERS_ON_SEEKING_BACKWARDS: !1, DROP_INVALID_SEGMENTS: !1, PROACTIVE_GAP_SKIP_DISTANCE_SECONDS: 0, PRESERVE_GAPS_FOR_BASE_MEDIA_DECODE_TIME_REWRITE: !1, MIN_SIZE_FOR_GAP_SKIPPING: 0, FORCE_SOFTWARE_DECRYPTION: !1, SEGMENT_LOADING_PROGRESS_CHECK_INTERVAL: 0.5, ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE: !1, HLS_SYNC_SEGMENT_PLAYBACK_TIME_VIA_MEDIA_SEQUENCE: !1, HLS_PARSE_MANIFEST_IN_WORKER: !1, HLS_CLEAR_BUFFERS_ON_DISCONTINUITY_SWITCHES: !0, PARSE_EMSG_BOXES: !0, WISH_ABR_PARAMS: te[_$_b208[2833]], HLS_BACKUP_STREAM_PENALTY_DURATION: 30, CHECK_ALL_DRM_LICENSES_FOR_KID: !0, LL_HLS: !0, LL_HLS_SEGMENT_END_TIME_MATCHING_TOLERANCE: 0.1, LL_HLS_MAX_PLAYLIST_AGE_FOR_BLOCKING_REQUEST_IN_PART_TARGET_MULTIPLES: 2, HLS_PARSE_NATIVE_METADATA: !0, PREFER_MANAGED_MEDIA_SOURCE: !0, INFINITE_RETRIES_FOR_LIVE: !0, MAX_SAFE_MSE_DURATION: 1 / 0, ENABLE_MEDIA_ELEMENT_EVENT_LOGS: !1, DISABLE_PARALLEL_SEGMENT_LOADING: !1, ENABLE_MUTED_BACKGROUND_PLAYBACK: !1 };
          }, 87649: function(re, te, ee) {
            _$_b208[11];
            var ne, ie = this && this[_$_b208[16]] || function() {
              return ie = Object[_$_b208[17]] || function(se) {
                for (var oe, ue = 1, be = arguments[_$_b208[18]]; ue < be; ue++)
                  for (var ve in oe = arguments[ue])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](oe, ve) && (se[ve] = oe[ve]);
                return se;
              }, ie[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[624]] = void 0;
            var ae = ee(21829), ce = ee(18068);
            function he(se, oe, ue) {
              var be;
              return ie(ie({}, se), ((be = {})[oe] = ie(ie({}, se[oe]), { preferredBitrate: ue }), be));
            }
            function _e(se, oe) {
              var ue;
              return ie(ie({}, se), ((ue = {})[oe] = ie(ie({}, se[oe]), { preferredBitrate: void 0 }), ue));
            }
            var le = {};
            te[_$_b208[624]] = (0, ae[_$_b208[302]])(le, ((ne = {})[ce[_$_b208[1325]][_$_b208[1326]]] = function(se, oe) {
              var ue = oe[_$_b208[1464]];
              return he(se, ue[_$_b208[1559]], ue[_$_b208[1486]]);
            }, ne[ce[_$_b208[1325]][_$_b208[1328]]] = function(se, oe) {
              return _e(se, oe[_$_b208[1464]][_$_b208[1559]]);
            }, ne));
          }, 88005: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(Te) {
                for (var Ee, we = 1, Pe = arguments[_$_b208[18]]; we < Pe; we++)
                  for (var Me in Ee = arguments[we])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](Ee, Me) && (Te[Me] = Ee[Me]);
                return Te;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2801]] = void 0;
            var ie, ae = ee(331), ce = ee(91520), he = ee(16368), _e = ee(62510), le = ee(67345), se = ee(87326), oe = ee(37233), ue = ee(13533), be = ee(30051), ve = ee(43485), me = ee(76885), pe = ee(54838), fe = ee(78936), ge = ee(90637), ye = ee(36564), $e = ee(65411);
            function Se() {
              return { requestType: le[_$_b208[2444]][_$_b208[2487]], maxRetries: 0 };
            }
            (function(Te) {
              Te[_$_b208[57]] = _$_b208[2838];
            })(ie || (ie = {}));
            var Ce = function() {
              function Te(Ee, we) {
                we === void 0 && (we = Se());
                var Pe = this;
                this[_$_b208[244]] = function(Me, Ae, Oe, Be, Ve, Ue, Re, Ne) {
                  return Ue === void 0 && (Ue = !1), Ne === void 0 && (Ne = !1), Pe[_$_b208[1559]] = Re, Pe[_$_b208[2839]] = Ne, Ae = Ae || le[_$_b208[2443]][_$_b208[2496]], Me = Pe[_$_b208[2840]](Me), Ve = ye[_$_b208[396]][_$_b208[1710]](Pe[_$_b208[81]][_$_b208[2841]], Ve), Me ? (Pe[_$_b208[394]] = { method: Ae, url: me[_$_b208[2575]][_$_b208[2595]](Me), headers: JSON[_$_b208[1035]](JSON[_$_b208[1012]](Ve)), responseType: Oe || le[_$_b208[1705]][_$_b208[2494]], credentials: Ue ? _$_b208[414] : _$_b208[2842] }, Be && (Pe[_$_b208[394]][_$_b208[422]] = Be), Pe[_$_b208[2849]](Pe[_$_b208[394]])[_$_b208[674]](function(xe) {
                    return Pe[_$_b208[2819]](xe)[_$_b208[943]](Pe[_$_b208[2848]]);
                  })[_$_b208[674]](Pe[_$_b208[2847]])[_$_b208[674]](Pe[_$_b208[2846]])[_$_b208[674]](function(xe) {
                    return Pe[_$_b208[2843]] && xe[_$_b208[422]] instanceof Pe[_$_b208[2843]][_$_b208[2844]] ? xe[_$_b208[422]] = xe[_$_b208[422]][_$_b208[1766]](function(ke) {
                      return ke;
                    }, function() {
                      return Pe[_$_b208[2845]](xe);
                    }, function(ke) {
                      return ke[_$_b208[119]] === ge[_$_b208[398]][_$_b208[397]] && Pe[_$_b208[1509]](), xe[_$_b208[422]][_$_b208[421]](ke[_$_b208[119]]), ke[_$_b208[119]];
                    }) : Pe[_$_b208[2845]](xe), xe;
                  })) : Promise[_$_b208[84]](_$_b208[2850]);
                }, this[_$_b208[2846]] = function(Me) {
                  return Pe[_$_b208[2851]](Me[_$_b208[391]]) ? Pe[_$_b208[2853]](_$_b208[2852], Me) : Promise[_$_b208[85]](Me);
                }, this[_$_b208[2849]] = function(Me) {
                  return Pe[_$_b208[2856]](Me, Pe[_$_b208[2855]][_$_b208[2854]]);
                }, this[_$_b208[2847]] = function(Me) {
                  return Pe[_$_b208[2856]](Me, Pe[_$_b208[2855]][_$_b208[2857]]);
                }, this[_$_b208[2858]] = function(Me) {
                  if (_$_b208[161] == typeof Pe[_$_b208[349]][_$_b208[2858]] && !Pe[_$_b208[2859]] && Pe[_$_b208[2860]]) {
                    if (Me[_$_b208[295]] >= 0 && Me[_$_b208[379]] !== void 0 && Me[_$_b208[295]] >= Me[_$_b208[379]])
                      return;
                    var Ae = Pe[_$_b208[521]][_$_b208[2669]](Pe[_$_b208[2861]][_$_b208[57]]);
                    Pe[_$_b208[349]][_$_b208[2858]](ne(ne({}, Me), { elapsedTime: Ae }));
                  }
                }, this[_$_b208[2848]] = function(Me) {
                  Pe[_$_b208[2862]]++;
                  var Ae = Me[_$_b208[393]] && Me[_$_b208[393]][_$_b208[391]], Oe = Me[_$_b208[393]] ? Me[_$_b208[393]][_$_b208[403]] : null;
                  return !Ae && Pe[_$_b208[349]][_$_b208[2863]] && Ie(Oe) && (Pe[_$_b208[2862]] = 0), Me[_$_b208[90]] === ge[_$_b208[398]][_$_b208[423]] || Me[_$_b208[90]] === ge[_$_b208[398]][_$_b208[420]] ? Pe[_$_b208[2853]](Me[_$_b208[90]], Me[_$_b208[393]]) : Pe[_$_b208[2847]](Me[_$_b208[393]])[_$_b208[674]](function(Be) {
                    return Pe[_$_b208[2855]][_$_b208[2864]] && _$_b208[161] == typeof Pe[_$_b208[2855]][_$_b208[2864]] ? Pe[_$_b208[2864]](Me[_$_b208[90]], Be) : Ae && Pe[_$_b208[2851]](Be[_$_b208[391]]) ? Pe[_$_b208[2853]](_$_b208[2865] + Be[_$_b208[391]], Be) : Pe[_$_b208[2862]] <= Pe[_$_b208[349]][_$_b208[2866]] ? Pe[_$_b208[2867]]()[_$_b208[943]](Pe[_$_b208[2848]]) : Pe[_$_b208[2853]](_$_b208[2868], Me[_$_b208[393]]);
                  });
                }, this[_$_b208[2853]] = function(Me, Ae) {
                  var Oe = Pe[_$_b208[2862]];
                  return Pe[_$_b208[64]](), Pe[_$_b208[2860]] = !1, Pe[_$_b208[2869]](!1, Ae, Oe), Pe[_$_b208[349]][_$_b208[2870]](Ae, { name: Me }, Oe - 1), Promise[_$_b208[84]](Ae ?? new Error(Me));
                }, this[_$_b208[46]] = Ee, this[_$_b208[2855]] = this[_$_b208[46]][_$_b208[349]] && this[_$_b208[46]][_$_b208[349]][_$_b208[722]] || {}, ce[_$_b208[197]][_$_b208[196]](he[_$_b208[195]][_$_b208[1201]]) && (this[_$_b208[2843]] = ce[_$_b208[197]][_$_b208[199]](he[_$_b208[195]][_$_b208[1201]])), this[_$_b208[349]] = ne(ne({}, Se()), we), this[_$_b208[521]] = new fe[_$_b208[2664]](this[_$_b208[46]]), this[_$_b208[767]]();
              }
              return Te[_$_b208[21]][_$_b208[2871]] = function(Ee, we, Pe) {
                return Math[_$_b208[842]](Math[_$_b208[2872]](Ee * we), Pe);
              }, Te[_$_b208[21]][_$_b208[2869]] = function(Ee, we, Pe) {
                we && this[_$_b208[349]][_$_b208[2873]] && this[_$_b208[503]](_e[_$_b208[482]][_$_b208[2299]], { type: _e[_$_b208[482]][_$_b208[2299]], timestamp: Date[_$_b208[180]](), httpStatus: we[_$_b208[391]], success: Ee, url: we[_$_b208[403]], downloadTime: (0, ae[_$_b208[14]])(pe[_$_b208[172]][_$_b208[2070]]((0, ae[_$_b208[15]])(we[_$_b208[1702]]), 0)), size: we[_$_b208[18]] || 0, attempt: Pe, maxAttempts: this[_$_b208[349]][_$_b208[2866]] + 1, downloadType: this[_$_b208[349]][_$_b208[2873]], mimeType: this[_$_b208[1559]], timeToFirstByte: we[_$_b208[1701]] });
              }, Te[_$_b208[21]][_$_b208[2874]] = function() {
                return this[_$_b208[2860]];
              }, Te[_$_b208[21]][_$_b208[2875]] = function() {
                return this[_$_b208[2862]] > 0;
              }, Te[_$_b208[21]][_$_b208[2876]] = function(Ee) {
                this[_$_b208[349]][_$_b208[2863]] = Ee;
              }, Te[_$_b208[21]][_$_b208[2877]] = function(Ee) {
                this[_$_b208[349]][_$_b208[2866]] = Ee;
              }, Te[_$_b208[21]][_$_b208[2840]] = function(Ee) {
                return me[_$_b208[2575]][_$_b208[2597]](Ee, this[_$_b208[81]][_$_b208[2878]]);
              }, Te[_$_b208[21]][_$_b208[2819]] = function(Ee) {
                var we = this;
                if (this[_$_b208[2859]])
                  return Promise[_$_b208[84]]({ error: ge[_$_b208[398]][_$_b208[423]], response: null });
                this[_$_b208[2861]] && this[_$_b208[521]][_$_b208[425]](this[_$_b208[2861]]);
                var Pe = _$_b208[2879] + pe[_$_b208[172]][_$_b208[2061]]();
                return this[_$_b208[2861]] = { start: Pe + ie[_$_b208[57]] }, this[_$_b208[521]][_$_b208[2668]](this[_$_b208[2861]][_$_b208[57]]), this[_$_b208[394]] = Ee, this[_$_b208[2860]] = !0, this[_$_b208[2880]](), this[_$_b208[2881]][_$_b208[2440]]()[_$_b208[674]](function(Me) {
                  return Me[_$_b208[1702]] == null && (Me[_$_b208[1702]] = we[_$_b208[521]][_$_b208[2669]](we[_$_b208[2861]][_$_b208[57]]), Me[_$_b208[1701]] = 0), Me;
                });
              }, Te[_$_b208[21]][_$_b208[2882]] = function() {
                var Ee, we = this;
                this[_$_b208[2855]][_$_b208[2883]] && _$_b208[161] == typeof this[_$_b208[2855]][_$_b208[2883]] && (Ee = (0, pe[_$_b208[1461]])(function() {
                  return we[_$_b208[2855]][_$_b208[2883]](we[_$_b208[349]][_$_b208[2873]], we[_$_b208[394]]);
                }, this[_$_b208[46]][_$_b208[148]]));
                var Pe = this[_$_b208[2855]][_$_b208[726]] === le[_$_b208[2442]][_$_b208[2502]] || this[_$_b208[2839]];
                return Pe && !(0, ve[_$_b208[1886]])() && (this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[2884]), Pe = !1), Ee && _$_b208[161] == typeof Ee[_$_b208[2440]] || (Ee = Pe ? this[_$_b208[2885]]() : this[_$_b208[2886]]()), Ee;
              }, Te[_$_b208[21]][_$_b208[2880]] = function() {
                var Ee = this, we = this[_$_b208[2882]]();
                we[_$_b208[2438]](function(Me) {
                  return Ee[_$_b208[2858]](Me);
                });
                var Pe = be[_$_b208[1507]][_$_b208[1508]](we[_$_b208[2440]]());
                this[_$_b208[2881]] = { getResponse: function() {
                  return Pe;
                }, cancel: function() {
                  we[_$_b208[1509]](), Pe[_$_b208[1509]]({ error: ge[_$_b208[398]][_$_b208[423]], response: null });
                }, setProgressListener: we[_$_b208[2438]] };
              }, Te[_$_b208[21]][_$_b208[2886]] = function() {
                var Ee = (0, ae[_$_b208[15]])(this[_$_b208[81]][_$_b208[2887]]);
                return this[_$_b208[349]][_$_b208[2888]] && (Ee = -1), new $e[_$_b208[2437]](this[_$_b208[46]][_$_b208[148]], this[_$_b208[394]], Ee);
              }, Te[_$_b208[21]][_$_b208[2885]] = function() {
                return new this[_$_b208[2843]][_$_b208[2889]](this[_$_b208[46]], this[_$_b208[394]], (0, ae[_$_b208[15]])(this[_$_b208[81]][_$_b208[2887]]), this[_$_b208[2839]]);
              }, Te[_$_b208[21]][_$_b208[2856]] = function(Ee, we) {
                var Pe, Me = this;
                return we && _$_b208[161] == typeof we ? Promise[_$_b208[85]]((Pe = (0, pe[_$_b208[1461]])(function() {
                  return we(Me[_$_b208[349]][_$_b208[2873]], Ee);
                }, this[_$_b208[46]][_$_b208[148]])) !== null && Pe !== void 0 ? Pe : Ee) : Promise[_$_b208[85]](Ee);
              }, Te[_$_b208[21]][_$_b208[2845]] = function(Ee) {
                this[_$_b208[2860]] = !1, this[_$_b208[2869]](!0, Ee, this[_$_b208[2862]] + 1), this[_$_b208[349]][_$_b208[2890]](Ee, Ee[_$_b208[1702]], Ee[_$_b208[403]]), this[_$_b208[64]](), Ee[_$_b208[403]] && (0, ue[_$_b208[302]])()[_$_b208[552]]((0, oe[_$_b208[1755]])((0, me[_$_b208[2576]])(Ee[_$_b208[403]])));
              }, Te[_$_b208[21]][_$_b208[2864]] = function(Ee, we) {
                var Pe = this, Me = (0, pe[_$_b208[1461]])(function() {
                  return Pe[_$_b208[2855]][_$_b208[2864]](Pe[_$_b208[349]][_$_b208[2873]], we, Pe[_$_b208[2862]]);
                }, this[_$_b208[46]][_$_b208[148]]);
                return Promise[_$_b208[85]](Me)[_$_b208[674]](function(Ae) {
                  return Ae[_$_b208[2439]] ? (Pe[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[2891], Ae), Pe[_$_b208[2853]](_$_b208[2891], we)) : Pe[_$_b208[2819]](Ae)[_$_b208[943]](Pe[_$_b208[2848]]);
                })[_$_b208[943]](function() {
                  return Pe[_$_b208[2853]](Ee, we);
                });
              }, Te[_$_b208[21]][_$_b208[2867]] = function() {
                var Ee = this, we = this[_$_b208[349]][_$_b208[2892]], Pe = _$_b208[2893];
                return this[_$_b208[81]][_$_b208[2894]] && (we = this[_$_b208[2871]](this[_$_b208[81]][_$_b208[2895]], this[_$_b208[2862]], this[_$_b208[81]][_$_b208[2896]]), Pe = _$_b208[2897]), this[_$_b208[46]][_$_b208[148]][_$_b208[154]](_$_b208[2902][_$_b208[94]](Pe, _$_b208[2901])[_$_b208[94]](we == null ? void 0 : we[_$_b208[2899]](1), _$_b208[2900])[_$_b208[94]](this[_$_b208[2862]], _$_b208[2898])[_$_b208[94]](this[_$_b208[394]][_$_b208[403]])), new Promise(function(Me, Ae) {
                  var Oe = setTimeout(function() {
                    Ee[_$_b208[2819]](Ee[_$_b208[394]])[_$_b208[674]](Me)[_$_b208[943]](Ae);
                  }, (0, ae[_$_b208[15]])(we));
                  Ee[_$_b208[2903]] = function() {
                    Ee[_$_b208[2903]] = null, clearTimeout(Oe), Ae({ error: ge[_$_b208[398]][_$_b208[423]], response: null });
                  };
                });
              }, Te[_$_b208[21]][_$_b208[2851]] = function(Ee) {
                return this[_$_b208[349]][_$_b208[2873]] in this[_$_b208[81]][_$_b208[2904]] && this[_$_b208[81]][_$_b208[2904]][this[_$_b208[349]][_$_b208[2873]]][_$_b208[26]](Ee);
              }, Te[_$_b208[21]][_$_b208[64]] = function() {
                this[_$_b208[2862]] = 0, this[_$_b208[2859]] = !1, this[_$_b208[2903]] && _$_b208[161] == typeof this[_$_b208[2903]] && this[_$_b208[2903]]();
              }, Te[_$_b208[21]][_$_b208[1509]] = function() {
                this[_$_b208[2859]] = !0, this[_$_b208[2860]] && (this[_$_b208[2860]] = !1, this[_$_b208[2903]] && this[_$_b208[2903]](), this[_$_b208[2881]] && this[_$_b208[2881]][_$_b208[1509]]());
              }, Te[_$_b208[21]][_$_b208[2440]] = function() {
                if (this[_$_b208[2881]] && _$_b208[161] == typeof this[_$_b208[2881]][_$_b208[2440]])
                  return this[_$_b208[2881]][_$_b208[2440]]();
              }, Te[_$_b208[21]][_$_b208[767]] = function() {
                var Ee = [_$_b208[2890], _$_b208[2870]];
                this[_$_b208[2862]] = 0;
                var we = {};
                pe[_$_b208[172]][_$_b208[350]](we, se[_$_b208[751]]), this[_$_b208[81]] = this[_$_b208[46]][_$_b208[81]] || we;
                for (var Pe = 0; Pe < Ee[_$_b208[18]]; Pe++)
                  this[_$_b208[349]][_$_b208[20]](Ee[Pe]) && _$_b208[161] == typeof this[_$_b208[349]][Ee[Pe]] || (this[_$_b208[349]][Ee[Pe]] = function() {
                  });
                this[_$_b208[46]][_$_b208[160]] && _$_b208[161] == typeof this[_$_b208[46]][_$_b208[160]][_$_b208[503]] ? this[_$_b208[503]] = this[_$_b208[46]][_$_b208[160]][_$_b208[503]] : this[_$_b208[503]] = function() {
                };
              }, Te[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[2874]]() && this[_$_b208[1509]](), this[_$_b208[2861]] && this[_$_b208[521]][_$_b208[425]](this[_$_b208[2861]]), this[_$_b208[2881]] = null, this[_$_b208[503]] = null, this[_$_b208[81]] = null;
              }, Te;
            }();
            function Ie(Te) {
              return _$_b208[348] == typeof Te && (0, ue[_$_b208[524]])()[_$_b208[255]][_$_b208[26]]((0, me[_$_b208[2576]])(Te));
            }
            te[_$_b208[2801]] = Ce;
          }, 88141: function(re, te, ee) {
            _$_b208[11];
            var ne, ie = this && this[_$_b208[16]] || function() {
              return ie = Object[_$_b208[17]] || function(me) {
                for (var pe, fe = 1, ge = arguments[_$_b208[18]]; fe < ge; fe++)
                  for (var ye in pe = arguments[fe])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](pe, ye) && (me[ye] = pe[ye]);
                return me;
              }, ie[_$_b208[22]](this, arguments);
            }, ae = this && this[_$_b208[629]] || function(me, pe, fe) {
              if (fe || arguments[_$_b208[18]] === 2)
                for (var ge, ye = 0, $e = pe[_$_b208[18]]; ye < $e; ye++)
                  !ge && ye in pe || (ge || (ge = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](pe, 0, ye)), ge[ye] = pe[ye]);
              return me[_$_b208[94]](ge || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](pe));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2412]] = void 0;
            var ce = ee(21829), he = ee(72819), _e = ee(8272);
            function le(me, pe) {
              var fe, ge = pe[_$_b208[1559]], ye = pe[_$_b208[81]], $e = pe[_$_b208[2905]];
              return ie(ie({}, me), ((fe = {})[$e] = { mimeType: ge, settings: { metricHistorySize: ye[_$_b208[2906]] }, bufferLogicActivationThreshold: ye[_$_b208[2907]], data: {} }, fe));
            }
            function se(me, pe) {
              var fe = ie({}, me);
              return delete fe[pe[_$_b208[1559]]], fe;
            }
            function oe(me, pe) {
              var fe, ge = pe[_$_b208[1559]], ye = pe[_$_b208[2908]];
              return ie(ie({}, me), ((fe = {})[ge] = ie(ie({}, me[ge]), { bufferLogicActivationThreshold: ye }), fe));
            }
            function ue(me, pe) {
              var fe, ge, ye = pe[_$_b208[1559]], $e = pe[_$_b208[2909]], Se = pe[_$_b208[888]], Ce = me[ye][_$_b208[81]][_$_b208[2910]], Ie = me[ye][_$_b208[1489]][$e] || [], Te = Ce > 0 && Ie[_$_b208[18]] >= Ce;
              return ie(ie({}, me), ((fe = {})[ye] = ie(ie({}, me[ye]), { data: ie(ie({}, me[ye][_$_b208[1489]]), (ge = {}, ge[$e] = ae(ae([], Te ? Ie[_$_b208[630]](1, Ie[_$_b208[18]]) : Ie, !0), [{ time: Date[_$_b208[180]](), value: Se }], !1), ge)) }), fe));
            }
            function be(me, pe) {
              var fe, ge, ye = pe[_$_b208[1559]], $e = pe[_$_b208[2909]];
              return ie(ie({}, me), ((fe = {})[ye] = ie(ie({}, me[ye]), { data: ie(ie({}, me[ye][_$_b208[1489]]), (ge = {}, ge[$e] = [], ge)) }), fe));
            }
            function ve(me, pe) {
              var fe, ge, ye = pe[_$_b208[1559]], $e = pe[_$_b208[2909]], Se = pe[_$_b208[888]], Ce = (me[ye][_$_b208[1489]][$e] || [])[_$_b208[165]](function(Ie) {
                return !(Ie[_$_b208[2911]] === Se[_$_b208[2911]] && Ie[_$_b208[888]] === Se[_$_b208[888]]);
              });
              return ie(ie({}, me), ((fe = {})[ye] = ie(ie({}, me[ye]), { data: ie(ie({}, me[ye][_$_b208[1489]]), (ge = {}, ge[$e] = Ce, ge)) }), fe));
            }
            te[_$_b208[2412]] = (0, ce[_$_b208[302]])({}, ((ne = {})[_e[_$_b208[303]][_$_b208[335]]] = function(me, pe) {
              return le(me, pe[_$_b208[1464]]);
            }, ne[_e[_$_b208[303]][_$_b208[337]]] = function(me, pe) {
              return se(me, pe[_$_b208[1464]]);
            }, ne[_e[_$_b208[303]][_$_b208[345]]] = function(me, pe) {
              var fe = pe[_$_b208[1464]];
              return (0, he[_$_b208[2543]])(oe)(me, fe);
            }, ne[_e[_$_b208[303]][_$_b208[339]]] = function(me, pe) {
              var fe = pe[_$_b208[1464]];
              return (0, he[_$_b208[2543]])(ue)(me, fe);
            }, ne[_e[_$_b208[303]][_$_b208[343]]] = function(me, pe) {
              var fe = pe[_$_b208[1464]];
              return (0, he[_$_b208[2543]])(be)(me, fe);
            }, ne[_e[_$_b208[303]][_$_b208[341]]] = function(me, pe) {
              var fe = pe[_$_b208[1464]];
              return (0, he[_$_b208[2543]])(ve)(me, fe);
            }, ne));
          }, 90040: function(_0xFD5F) {
            var _0xFD7F = window[_$_b208[2912]] || window[_$_b208[2913]];
            _0xFD5F[_$_b208[1714]] = function(_0xFDBF, _0xFE1F) {
              try {
                try {
                  var _0xFD5F;
                  try {
                    var _0xFD9F = window[_$_b208[2914]] || window[_$_b208[2915]] || window[_$_b208[2916]] || window[_$_b208[2917]];
                    _0xFD5F = new _0xFD9F(), _0xFD5F[_$_b208[2760]](_0xFDBF), _0xFD5F = _0xFD5F[_$_b208[2918]]();
                  } catch {
                    _0xFD5F = new Blob([_0xFDBF]);
                  }
                  return new Worker(_0xFD7F[_$_b208[2919]](_0xFD5F));
                } catch {
                  return new Worker(_$_b208[2920] + encodeURIComponent(_0xFDBF));
                }
              } catch (e) {
                try {
                  var _0xFDDF = _$_b208[2921], _0xFDFF = _$_b208[2922];
                  return _$_b208[2923] === _0xFDBF[_$_b208[259]](0, 1) && (_0xFDBF = _0xFDBF[_$_b208[259]](1, _0xFDBF[_$_b208[18]] - 1), _0xFDBF = _$_b208[272] + _0xFDBF + _$_b208[1746]), _0xFDBF[_$_b208[138]](_0xFDFF) > 0 && (_0xFDBF = _0xFDBF[_$_b208[2046]](_0xFDFF, _0xFDDF)), eval(_0xFDBF)[_$_b208[2924]]();
                } catch (re) {
                  return {};
                }
              }
            };
          }, 90546: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[627]] || function(ye, $e, Se, Ce) {
              var Ie, Te = arguments[_$_b208[18]], Ee = Te < 3 ? $e : Ce === null ? Ce = Object[_$_b208[298]]($e, Se) : Ce;
              if (_$_b208[617] == typeof Reflect && _$_b208[161] == typeof Reflect[_$_b208[628]])
                Ee = Reflect[_$_b208[628]](ye, $e, Se, Ce);
              else
                for (var we = ye[_$_b208[18]] - 1; we >= 0; we--)
                  (Ie = ye[we]) && (Ee = (Te < 3 ? Ie(Ee) : Te > 3 ? Ie($e, Se, Ee) : Ie($e, Se)) || Ee);
              return Te > 3 && Ee && Object[_$_b208[13]]($e, Se, Ee), Ee;
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2504]] = void 0;
            var ie, ae = ee(91520), ce = ee(25550), he = ee(28764), _e = ee(4006), le = ee(92737), se = ee(13142), oe = ee(15447), ue = ee(16937), be = ee(33696), ve = ee(54838), me = 0;
            function pe() {
              ie || (ie = /* @__PURE__ */ new WeakMap());
            }
            function fe(ye, $e) {
              pe();
              var Se = ie[_$_b208[199]](ye);
              if (!Se)
                throw new be[_$_b208[1566]]($e);
              return Se;
            }
            var ge = function() {
              function ye($e, Se) {
                this[_$_b208[767]]($e, Se);
              }
              return ye[_$_b208[21]][_$_b208[767]] = function($e, Se) {
                if (!($e instanceof HTMLElement))
                  throw new he[_$_b208[720]](ce[_$_b208[369]][_$_b208[1406]], void 0, _$_b208[2925]);
                pe();
                var Ce = new oe[_$_b208[631]]($e, ve[_$_b208[172]][_$_b208[2061]](), this);
                ie[_$_b208[361]](this, Ce), me++, Ce[_$_b208[1003]](Se);
              }, Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[2926], { get: function() {
                return _e[_$_b208[249]][_$_b208[279]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[680], { get: function() {
                return fe(this, _$_b208[680])[_$_b208[1031]]();
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[1172], { get: function() {
                return fe(this, _$_b208[1172])[_$_b208[876]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[2927], { get: function() {
                return fe(this, _$_b208[2927])[_$_b208[1196]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[1185], { get: function() {
                return fe(this, _$_b208[1185])[_$_b208[1199]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[1007], { get: function() {
                return fe(this, _$_b208[1007])[_$_b208[1119]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[36], { get: function() {
                return fe(this, _$_b208[36])[_$_b208[668]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[1048], { get: function() {
                return fe(this, _$_b208[1048])[_$_b208[763]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[2928], { get: function() {
                return fe(this, _$_b208[2928]) ? ie[_$_b208[199]](this)[_$_b208[745]]() : null;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[2136], { get: function() {
                return fe(this, _$_b208[2136])[_$_b208[2929]];
              }, set: function($e) {
                fe(this, _$_b208[2136])[_$_b208[2929]] = $e;
              }, enumerable: !1, configurable: !0 }), Object[_$_b208[13]](ye[_$_b208[21]], _$_b208[1714], { get: function() {
                return le;
              }, enumerable: !1, configurable: !0 }), ye[_$_b208[21]][_$_b208[404]] = function($e, Se) {
                fe(this, _$_b208[404])[_$_b208[404]]($e, Se);
              }, ye[_$_b208[21]][_$_b208[845]] = function($e, Se) {
                return fe(this, _$_b208[845])[_$_b208[845]]($e, Se);
              }, ye[_$_b208[21]][_$_b208[956]] = function() {
                fe(this, _$_b208[2684])[_$_b208[956]]();
              }, ye[_$_b208[21]][_$_b208[834]] = function() {
                fe(this, _$_b208[834])[_$_b208[834]]();
              }, ye[_$_b208[21]][_$_b208[881]] = function() {
                fe(this, _$_b208[881])[_$_b208[881]]();
              }, ye[_$_b208[21]][_$_b208[1132]] = function() {
                var $e = fe(this, _$_b208[1132])[_$_b208[1132]]();
                return ie[_$_b208[362]](this), me--, $e;
              }, ye[_$_b208[21]][_$_b208[920]] = function() {
                return fe(this, _$_b208[920])[_$_b208[920]]();
              }, ye[_$_b208[21]][_$_b208[921]] = function() {
                return fe(this, _$_b208[921])[_$_b208[921]]();
              }, ye[_$_b208[21]][_$_b208[905]] = function() {
                return fe(this, _$_b208[905])[_$_b208[905]]();
              }, ye[_$_b208[21]][_$_b208[924]] = function() {
                return fe(this, _$_b208[924])[_$_b208[924]]();
              }, ye[_$_b208[21]][_$_b208[709]] = function() {
                return fe(this, _$_b208[709])[_$_b208[709]]();
              }, ye[_$_b208[21]][_$_b208[913]] = function() {
                return fe(this, _$_b208[913])[_$_b208[913]]();
              }, ye[_$_b208[21]][_$_b208[923]] = function() {
                return fe(this, _$_b208[923])[_$_b208[923]]();
              }, ye[_$_b208[21]][_$_b208[912]] = function() {
                return fe(this, _$_b208[912])[_$_b208[912]]();
              }, ye[_$_b208[21]][_$_b208[724]] = function($e) {
                return fe(this, _$_b208[724])[_$_b208[724]]($e);
              }, ye[_$_b208[21]][_$_b208[1018]] = function() {
                return fe(this, _$_b208[1018])[_$_b208[1018]]();
              }, ye[_$_b208[21]][_$_b208[895]] = function($e) {
                return $e === void 0 && ($e = be[_$_b208[897]][_$_b208[896]]), fe(this, _$_b208[895])[_$_b208[895]](_$_b208[660], $e);
              }, ye[_$_b208[21]][_$_b208[917]] = function() {
                return fe(this, _$_b208[917])[_$_b208[917]]();
              }, ye[_$_b208[21]][_$_b208[916]] = function() {
                return fe(this, _$_b208[916])[_$_b208[916]]();
              }, ye[_$_b208[21]][_$_b208[828]] = function() {
                return fe(this, _$_b208[828])[_$_b208[828]]();
              }, ye[_$_b208[21]][_$_b208[867]] = function() {
                return fe(this, _$_b208[867])[_$_b208[867]]();
              }, ye[_$_b208[21]][_$_b208[925]] = function() {
                return fe(this, _$_b208[925])[_$_b208[925]]();
              }, ye[_$_b208[21]][_$_b208[908]] = function() {
                return fe(this, _$_b208[908])[_$_b208[908]]();
              }, ye[_$_b208[21]][_$_b208[919]] = function() {
                return fe(this, _$_b208[919])[_$_b208[919]]();
              }, ye[_$_b208[21]][_$_b208[1130]] = function() {
                return fe(this, _$_b208[1130])[_$_b208[1130]]();
              }, ye[_$_b208[21]][_$_b208[918]] = function() {
                return fe(this, _$_b208[918])[_$_b208[918]]();
              }, ye[_$_b208[21]][_$_b208[725]] = function() {
                return fe(this, _$_b208[725])[_$_b208[725]]();
              }, ye[_$_b208[21]][_$_b208[1129]] = function($e, Se) {
                return fe(this, _$_b208[1129])[_$_b208[1129]]($e, Se);
              }, ye[_$_b208[21]][_$_b208[1022]] = function() {
                return fe(this, _$_b208[1022])[_$_b208[1022]]();
              }, ye[_$_b208[21]][_$_b208[1163]] = function() {
                return fe(this, _$_b208[1163])[_$_b208[1163]]();
              }, ye[_$_b208[21]][_$_b208[1023]] = function($e) {
                return $e === void 0 && ($e = be[_$_b208[1025]][_$_b208[1024]]), fe(this, _$_b208[1023])[_$_b208[1023]]($e);
              }, ye[_$_b208[21]][_$_b208[1168]] = function($e) {
                return fe(this, _$_b208[1168])[_$_b208[1168]]($e);
              }, ye[_$_b208[21]][_$_b208[909]] = function() {
                return fe(this, _$_b208[909])[_$_b208[909]]();
              }, ye[_$_b208[21]][_$_b208[830]] = function() {
                return fe(this, _$_b208[830])[_$_b208[830]]();
              }, ye[_$_b208[21]][_$_b208[907]] = function() {
                return fe(this, _$_b208[907])[_$_b208[907]]();
              }, ye[_$_b208[21]][_$_b208[927]] = function() {
                return fe(this, _$_b208[927])[_$_b208[927]]();
              }, ye[_$_b208[21]][_$_b208[865]] = function() {
                return fe(this, _$_b208[865])[_$_b208[865]]();
              }, ye[_$_b208[21]][_$_b208[911]] = function() {
                return fe(this, _$_b208[911])[_$_b208[911]]();
              }, ye[_$_b208[21]][_$_b208[833]] = function() {
                return fe(this, _$_b208[833])[_$_b208[833]]();
              }, ye[_$_b208[21]][_$_b208[832]] = function() {
                return fe(this, _$_b208[832])[_$_b208[832]]();
              }, ye[_$_b208[21]][_$_b208[1160]] = function($e) {
                return fe(this, _$_b208[1160])[_$_b208[1160]]($e);
              }, ye[_$_b208[21]][_$_b208[836]] = function() {
                return fe(this, _$_b208[836])[_$_b208[836]]();
              }, ye[_$_b208[21]][_$_b208[849]] = function() {
                return fe(this, _$_b208[849])[_$_b208[849]]();
              }, ye[_$_b208[21]][_$_b208[1155]] = function() {
                return fe(this, _$_b208[1155])[_$_b208[1155]]();
              }, ye[_$_b208[21]][_$_b208[1153]] = function() {
                return fe(this, _$_b208[1153])[_$_b208[1153]]();
              }, ye[_$_b208[21]][_$_b208[910]] = function() {
                return fe(this, _$_b208[910])[_$_b208[910]]();
              }, ye[_$_b208[21]][_$_b208[244]] = function($e, Se, Ce) {
                return fe(this, _$_b208[244])[_$_b208[244]]($e, Se, Ce);
              }, ye[_$_b208[21]][_$_b208[863]] = function($e) {
                fe(this, _$_b208[863])[_$_b208[863]]($e);
              }, ye[_$_b208[21]][_$_b208[169]] = function($e) {
                fe(this, _$_b208[169])[_$_b208[169]]($e);
              }, ye[_$_b208[21]][_$_b208[167]] = function($e) {
                return fe(this, _$_b208[167])[_$_b208[167]]($e);
              }, ye[_$_b208[21]][_$_b208[688]] = function($e, Se) {
                fe(this, _$_b208[688])[_$_b208[688]]($e, Se);
              }, ye[_$_b208[21]][_$_b208[837]] = function() {
                return fe(this, _$_b208[837])[_$_b208[837]]();
              }, ye[_$_b208[21]][_$_b208[835]] = function($e, Se) {
                return fe(this, _$_b208[835])[_$_b208[835]]($e, Se);
              }, ye[_$_b208[21]][_$_b208[850]] = function($e) {
                return fe(this, _$_b208[850])[_$_b208[850]]($e);
              }, ye[_$_b208[21]][_$_b208[677]] = function($e) {
                fe(this, _$_b208[677])[_$_b208[677]]($e);
              }, ye[_$_b208[21]][_$_b208[825]] = function($e) {
                fe(this, _$_b208[825])[_$_b208[825]]($e);
              }, ye[_$_b208[21]][_$_b208[1165]] = function($e) {
                fe(this, _$_b208[2930])[_$_b208[1165]]($e);
              }, ye[_$_b208[21]][_$_b208[492]] = function($e) {
                fe(this, _$_b208[492])[_$_b208[492]]($e);
              }, ye[_$_b208[21]][_$_b208[1046]] = function($e, Se) {
                fe(this, _$_b208[1046])[_$_b208[1046]]($e, Se);
              }, ye[_$_b208[21]][_$_b208[880]] = function($e) {
                fe(this, _$_b208[880])[_$_b208[880]]($e);
              }, ye[_$_b208[21]][_$_b208[1158]] = function($e) {
                fe(this, _$_b208[1158])[_$_b208[1158]]($e);
              }, ye[_$_b208[21]][_$_b208[823]] = function($e) {
                fe(this, _$_b208[823])[_$_b208[823]]($e);
              }, ye[_$_b208[21]][_$_b208[868]] = function($e, Se) {
                fe(this, _$_b208[868])[_$_b208[868]]($e, Se);
              }, ye[_$_b208[21]][_$_b208[1019]] = function($e) {
                return fe(this, _$_b208[1019])[_$_b208[1019]]($e);
              }, ye[_$_b208[21]][_$_b208[869]] = function($e, Se) {
                fe(this, _$_b208[869])[_$_b208[869]]($e, Se);
              }, ye[_$_b208[21]][_$_b208[661]] = function() {
                return fe(this, _$_b208[661])[_$_b208[661]]();
              }, ye[_$_b208[21]][_$_b208[866]] = function($e) {
                fe(this, _$_b208[866])[_$_b208[866]]($e);
              }, ye[_$_b208[21]][_$_b208[914]] = function() {
                return fe(this, _$_b208[914])[_$_b208[914]]();
              }, ye[_$_b208[21]][_$_b208[915]] = function() {
                return fe(this, _$_b208[915])[_$_b208[915]]();
              }, ye[_$_b208[21]][_$_b208[882]] = function() {
                fe(this, _$_b208[882])[_$_b208[882]]();
              }, ye[_$_b208[21]][_$_b208[922]] = function() {
                return fe(this, _$_b208[922])[_$_b208[922]]();
              }, ye[_$_b208[21]][_$_b208[861]] = function() {
                fe(this, _$_b208[861])[_$_b208[861]]();
              }, ye[_$_b208[21]][_$_b208[805]] = function($e) {
                fe(this, _$_b208[805])[_$_b208[805]]($e);
              }, ye[_$_b208[21]][_$_b208[1159]] = function() {
                return fe(this, _$_b208[1159])[_$_b208[1159]]();
              }, ye[_$_b208[21]][_$_b208[585]] = function() {
                return fe(this, _$_b208[585])[_$_b208[585]]();
              }, ye[_$_b208[21]][_$_b208[592]] = function($e) {
                return fe(this, _$_b208[592])[_$_b208[592]]($e);
              }, ye[_$_b208[21]][_$_b208[608]] = function($e, Se) {
                fe(this, _$_b208[608])[_$_b208[608]]($e, Se);
              }, ye[_$_b208[21]][_$_b208[679]] = function() {
                return fe(this, _$_b208[679])[_$_b208[679]]();
              }, Object[_$_b208[13]](ye, _$_b208[2926], { get: function() {
                return _e[_$_b208[249]][_$_b208[279]];
              }, enumerable: !1, configurable: !0 }), ye[_$_b208[2931]] = function($e) {
                ae[_$_b208[197]][_$_b208[60]]($e);
              }, ye[_$_b208[2932]] = function($e) {
                if (me > 0)
                  throw new he[_$_b208[720]](ce[_$_b208[369]][_$_b208[1448]], void 0, _$_b208[2933]);
                ae[_$_b208[197]][_$_b208[1934]]($e);
              }, ye[_$_b208[2934]] = function() {
                return ae[_$_b208[197]][_$_b208[2935]]();
              }, ne([(0, ue[_$_b208[1219]])(_$_b208[2936])], ye[_$_b208[21]], _$_b208[767], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[2926], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[680], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[1172], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[2927], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[1185], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[1007], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[36], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[1048], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[2928], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[2136], null), ne([se[_$_b208[523]]], ye[_$_b208[21]], _$_b208[1714], null), ye;
            }();
            te[_$_b208[2504]] = ge;
          }, 90637: function(re, te) {
            _$_b208[11];
            var ee;
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[398]] = void 0, function(ne) {
              ne[_$_b208[397]] = _$_b208[2937], ne[_$_b208[423]] = _$_b208[2938], ne[_$_b208[420]] = _$_b208[2939];
            }(ee || (te[_$_b208[398]] = ee = {}));
          }, 90788: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[996]] = le;
            var ne = ee(25550), ie = ee(28764), ae = ee(4006), ce = ee(11399), he = ee(13533), _e = ee(43485);
            function le(se) {
              var oe = se[_$_b208[199]](_$_b208[716]), ue = (0, he[_$_b208[191]])()[ce[_$_b208[190]][_$_b208[465]]], be = (0, _e[_$_b208[1885]])();
              if (be || ue) {
                if (!oe[_$_b208[2134]] || be && !oe[_$_b208[2135]])
                  throw new ie[_$_b208[720]](ne[_$_b208[369]][_$_b208[1411]], { tweaks: JSON[_$_b208[1012]](oe) }, _$_b208[2941][_$_b208[94]](oe[_$_b208[2134]] ? _$_b208[2135] : _$_b208[2134], _$_b208[2940]));
                !oe[_$_b208[2134]] || ae[_$_b208[249]][_$_b208[250]] && !ue || (ae[_$_b208[249]][_$_b208[250]] = oe[_$_b208[2134]]);
              }
            }
          }, 91397: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2942]] = ie, te[_$_b208[2943]] = ae;
            var ne = ee(56435);
            function ie(ce) {
              return ce[_$_b208[258]](_$_b208[2086])[_$_b208[124]](function(he, _e) {
                return _e === 0 ? he[_$_b208[215]]() : he[_$_b208[1784]](0)[_$_b208[609]]() + he[_$_b208[630]](1)[_$_b208[215]]();
              })[_$_b208[122]](_$_b208[265]);
            }
            function ae(ce) {
              return ce ? (0, ne[_$_b208[458]])() ? JSON[_$_b208[1035]](JSON[_$_b208[1012]](ce)) : (_$_b208[1728] + ce)[_$_b208[630]](1) : _$_b208[265];
            }
          }, 91520: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[197]] = void 0;
            var ne = ee(25550), ie = ee(28764), ae = ee(41108), ce = function() {
              function he() {
              }
              return he[_$_b208[2944]] = function() {
                this[_$_b208[283]] || (this[_$_b208[283]] = {});
              }, he[_$_b208[60]] = function(_e) {
                if (this[_$_b208[2944]](), !_e)
                  throw new ie[_$_b208[720]](ne[_$_b208[369]][_$_b208[1444]], void 0, _$_b208[2945]);
                if (!_e[_$_b208[176]])
                  throw new ie[_$_b208[720]](ne[_$_b208[369]][_$_b208[1444]], void 0, _$_b208[2946]);
                if (!_e[_$_b208[2947]])
                  throw new ie[_$_b208[720]](ne[_$_b208[369]][_$_b208[1444]], void 0, _$_b208[2948]);
                if (_e[_$_b208[2949]]) {
                  for (var le = 0, se = _e[_$_b208[2949]]; le < se[_$_b208[18]]; le++) {
                    var oe = se[le];
                    if (!this[_$_b208[196]](oe))
                      throw new ae[_$_b208[1797]](_e[_$_b208[176]], oe);
                  }
                  if (_$_b208[161] != typeof _e[_$_b208[2947]])
                    throw new ie[_$_b208[720]](ne[_$_b208[369]][_$_b208[1445]], { name: _e[_$_b208[176]] }, _$_b208[2950]);
                }
                var ue = _e[_$_b208[2947]];
                _$_b208[161] == typeof ue && (ue = ue()), this[_$_b208[283]][_e[_$_b208[176]]] = { moduleDefinition: _e, module: ue }, _e[_$_b208[2951]] && _e[_$_b208[2951]][_$_b208[60]] && _e[_$_b208[2951]][_$_b208[60]](_e[_$_b208[2947]]);
              }, he[_$_b208[1934]] = function(_e) {
                var le;
                if (this[_$_b208[283]]) {
                  if (!this[_$_b208[283]][_e])
                    throw new ae[_$_b208[1797]](_e);
                  var se = this[_$_b208[283]][_e][_$_b208[2952]];
                  !((le = se[_$_b208[2951]]) === null || le === void 0) && le[_$_b208[1934]] && se[_$_b208[2951]][_$_b208[1934]](se[_$_b208[2947]]), delete this[_$_b208[283]][_e];
                }
              }, he[_$_b208[199]] = function(_e, le) {
                le === void 0 && (le = !0), this[_$_b208[2944]]();
                var se = this[_$_b208[283]][_e];
                if (se && se[_$_b208[2947]])
                  return se[_$_b208[2947]];
                if (le)
                  throw new ae[_$_b208[1797]](_e);
              }, he[_$_b208[196]] = function(_e) {
                return this[_$_b208[199]](_e, !1) !== void 0;
              }, he[_$_b208[2935]] = function() {
                return Object[_$_b208[619]](this[_$_b208[283]]);
              }, he[_$_b208[2953]] = function() {
                var _e = this;
                return this[_$_b208[2935]]()[_$_b208[124]](function(le) {
                  return _e[_$_b208[283]][le];
                });
              }, he[_$_b208[999]] = function(_e) {
                this[_$_b208[2953]]()[_$_b208[165]](function(le) {
                  return le[_$_b208[2952]][_$_b208[2951]] && le[_$_b208[2952]][_$_b208[2951]][_$_b208[1003]];
                })[_$_b208[68]](function(le) {
                  return le[_$_b208[2952]][_$_b208[2951]][_$_b208[1003]](le[_$_b208[2947]], _e);
                });
              }, he[_$_b208[1142]] = function(_e) {
                var le = this[_$_b208[2953]]()[_$_b208[165]](function(se) {
                  return se[_$_b208[2952]][_$_b208[2951]] && se[_$_b208[2952]][_$_b208[2951]][_$_b208[1132]];
                })[_$_b208[124]](function(se) {
                  return se[_$_b208[2952]][_$_b208[2951]][_$_b208[1132]](se[_$_b208[2947]], _e);
                });
                return Promise[_$_b208[857]](le)[_$_b208[674]](function() {
                });
              }, he;
            }();
            te[_$_b208[197]] = ce;
          }, 91829: function(re, te, ee) {
            _$_b208[11];
            function ne(Ce) {
              return ne = _$_b208[161] == typeof Symbol && _$_b208[2954] == typeof Symbol[_$_b208[2738]] ? function(Ie) {
                return typeof Ie;
              } : function(Ie) {
                return Ie && _$_b208[161] == typeof Symbol && Ie[_$_b208[229]] === Symbol && Ie !== Symbol[_$_b208[21]] ? _$_b208[2954] : typeof Ie;
              }, ne(Ce);
            }
            function ie(Ce, Ie) {
              if (_$_b208[617] != ne(Ce) || !Ce)
                return Ce;
              var Te = Ce[Symbol[_$_b208[2955]]];
              if (Te !== void 0) {
                var Ee = Te[_$_b208[19]](Ce, Ie || _$_b208[302]);
                if (_$_b208[617] != ne(Ee))
                  return Ee;
                throw new TypeError(_$_b208[2956]);
              }
              return (_$_b208[348] === Ie ? String : Number)(Ce);
            }
            function ae(Ce) {
              var Ie = ie(Ce, _$_b208[348]);
              return _$_b208[2954] == ne(Ie) ? Ie : Ie + _$_b208[265];
            }
            function ce(Ce, Ie, Te) {
              return (Ie = ae(Ie)) in Ce ? Object[_$_b208[13]](Ce, Ie, { value: Te, enumerable: !0, configurable: !0, writable: !0 }) : Ce[Ie] = Te, Ce;
            }
            function he(Ce, Ie) {
              var Te = Object[_$_b208[69]](Ce);
              if (Object[_$_b208[1712]]) {
                var Ee = Object[_$_b208[1712]](Ce);
                Ie && (Ee = Ee[_$_b208[165]](function(we) {
                  return Object[_$_b208[298]](Ce, we)[_$_b208[522]];
                })), Te[_$_b208[141]][_$_b208[22]](Te, Ee);
              }
              return Te;
            }
            function _e(Ce) {
              for (var Ie = 1; Ie < arguments[_$_b208[18]]; Ie++) {
                var Te = arguments[Ie] != null ? arguments[Ie] : {};
                Ie % 2 ? he(Object(Te), !0)[_$_b208[68]](function(Ee) {
                  ce(Ce, Ee, Te[Ee]);
                }) : Object[_$_b208[2957]] ? Object[_$_b208[2958]](Ce, Object[_$_b208[2957]](Te)) : he(Object(Te))[_$_b208[68]](function(Ee) {
                  Object[_$_b208[13]](Ce, Ee, Object[_$_b208[298]](Te, Ee));
                });
              }
              return Ce;
            }
            function le(Ce) {
              return _$_b208[2959] + Ce + _$_b208[2960] + Ce + _$_b208[2961];
            }
            ee[_$_b208[2962]](te), ee[_$_b208[2963]](te, { __DO_NOT_USE__ActionTypes: function() {
              return ue;
            }, applyMiddleware: function() {
              return Se;
            }, bindActionCreators: function() {
              return ye;
            }, combineReducers: function() {
              return fe;
            }, compose: function() {
              return $e;
            }, createStore: function() {
              return ve;
            }, legacy_createStore: function() {
              return me;
            } });
            var se = function() {
              return _$_b208[161] == typeof Symbol && Symbol[_$_b208[2964]] || _$_b208[2965];
            }(), oe = function() {
              return Math[_$_b208[2062]]()[_$_b208[118]](36)[_$_b208[259]](7)[_$_b208[258]](_$_b208[265])[_$_b208[122]](_$_b208[1117]);
            }, ue = { INIT: _$_b208[2966] + oe(), REPLACE: _$_b208[2967] + oe(), PROBE_UNKNOWN_ACTION: function() {
              return _$_b208[2968] + oe();
            } };
            function be(Ce) {
              if (_$_b208[617] != typeof Ce || Ce === null)
                return !1;
              for (var Ie = Ce; Object[_$_b208[1740]](Ie) !== null; )
                Ie = Object[_$_b208[1740]](Ie);
              return Object[_$_b208[1740]](Ce) === Ie;
            }
            function ve(Ce, Ie, Te) {
              var Ee;
              if (_$_b208[161] == typeof Ie && _$_b208[161] == typeof Te || _$_b208[161] == typeof Te && _$_b208[161] == typeof arguments[3])
                throw new Error(le(0));
              if (_$_b208[161] == typeof Ie && Te === void 0 && (Te = Ie, Ie = void 0), Te !== void 0) {
                if (_$_b208[161] != typeof Te)
                  throw new Error(le(1));
                return Te(ve)(Ce, Ie);
              }
              if (_$_b208[161] != typeof Ce)
                throw new Error(le(2));
              var we = Ce, Pe = Ie, Me = [], Ae = Me, Oe = !1;
              function Be() {
                Ae === Me && (Ae = Me[_$_b208[630]]());
              }
              function Ve() {
                if (Oe)
                  throw new Error(le(3));
                return Pe;
              }
              function Ue(ke) {
                if (_$_b208[161] != typeof ke)
                  throw new Error(le(4));
                if (Oe)
                  throw new Error(le(5));
                var Le = !0;
                return Be(), Ae[_$_b208[141]](ke), function() {
                  if (Le) {
                    if (Oe)
                      throw new Error(le(6));
                    Le = !1, Be();
                    var He = Ae[_$_b208[138]](ke);
                    Ae[_$_b208[139]](He, 1), Me = null;
                  }
                };
              }
              function Re(ke) {
                if (!be(ke))
                  throw new Error(le(7));
                if (ke[_$_b208[89]] === void 0)
                  throw new Error(le(8));
                if (Oe)
                  throw new Error(le(9));
                try {
                  Oe = !0, Pe = we(Pe, ke);
                } finally {
                  Oe = !1;
                }
                for (var Le = Me = Ae, He = 0; He < Le[_$_b208[18]]; He++)
                  (0, Le[He])();
                return ke;
              }
              function Ne(ke) {
                if (_$_b208[161] != typeof ke)
                  throw new Error(le(10));
                we = ke, Re({ type: ue[_$_b208[2969]] });
              }
              function xe() {
                var ke, Le = Ue;
                return (ke = { subscribe: function(He) {
                  if (_$_b208[617] != typeof He || He === null)
                    throw new Error(le(11));
                  function We() {
                    He[_$_b208[1279]] && He[_$_b208[1279]](Ve());
                  }
                  return We(), { unsubscribe: Le(We) };
                } })[se] = function() {
                  return this;
                }, ke;
              }
              return Re({ type: ue[_$_b208[2970]] }), (Ee = { dispatch: Re, subscribe: Ue, getState: Ve, replaceReducer: Ne })[se] = xe, Ee;
            }
            var me = ve;
            function pe(Ce) {
              Object[_$_b208[69]](Ce)[_$_b208[68]](function(Ie) {
                var Te = Ce[Ie];
                if (Te(void 0, { type: ue[_$_b208[2970]] }) === void 0)
                  throw new Error(le(12));
                if (Te(void 0, { type: ue[_$_b208[2971]]() }) === void 0)
                  throw new Error(le(13));
              });
            }
            function fe(Ce) {
              for (var Ie = Object[_$_b208[69]](Ce), Te = {}, Ee = 0; Ee < Ie[_$_b208[18]]; Ee++) {
                var we = Ie[Ee];
                _$_b208[161] == typeof Ce[we] && (Te[we] = Ce[we]);
              }
              var Pe, Me = Object[_$_b208[69]](Te);
              try {
                pe(Te);
              } catch (Ae) {
                Pe = Ae;
              }
              return function(Ae, Oe) {
                if (Ae === void 0 && (Ae = {}), Pe)
                  throw Pe;
                for (var Be = !1, Ve = {}, Ue = 0; Ue < Me[_$_b208[18]]; Ue++) {
                  var Re = Me[Ue], Ne = Te[Re], xe = Ae[Re], ke = Ne(xe, Oe);
                  if (ke === void 0)
                    throw Oe && Oe[_$_b208[89]], new Error(le(14));
                  Ve[Re] = ke, Be = Be || ke !== xe;
                }
                return (Be = Be || Me[_$_b208[18]] !== Object[_$_b208[69]](Ae)[_$_b208[18]]) ? Ve : Ae;
              };
            }
            function ge(Ce, Ie) {
              return function() {
                return Ie(Ce[_$_b208[22]](this, arguments));
              };
            }
            function ye(Ce, Ie) {
              if (_$_b208[161] == typeof Ce)
                return ge(Ce, Ie);
              if (_$_b208[617] != typeof Ce || Ce === null)
                throw new Error(le(16));
              var Te = {};
              for (var Ee in Ce) {
                var we = Ce[Ee];
                _$_b208[161] == typeof we && (Te[Ee] = ge(we, Ie));
              }
              return Te;
            }
            function $e() {
              for (var Ce = arguments[_$_b208[18]], Ie = new Array(Ce), Te = 0; Te < Ce; Te++)
                Ie[Te] = arguments[Te];
              return Ie[_$_b208[18]] === 0 ? function(Ee) {
                return Ee;
              } : Ie[_$_b208[18]] === 1 ? Ie[0] : Ie[_$_b208[1277]](function(Ee, we) {
                return function() {
                  return Ee(we[_$_b208[22]](void 0, arguments));
                };
              });
            }
            function Se() {
              for (var Ce = arguments[_$_b208[18]], Ie = new Array(Ce), Te = 0; Te < Ce; Te++)
                Ie[Te] = arguments[Te];
              return function(Ee) {
                return function() {
                  var we = Ee[_$_b208[22]](void 0, arguments), Pe = function() {
                    throw new Error(le(15));
                  }, Me = { getState: we[_$_b208[182]], dispatch: function() {
                    return Pe[_$_b208[22]](void 0, arguments);
                  } }, Ae = Ie[_$_b208[124]](function(Oe) {
                    return Oe(Me);
                  });
                  return Pe = $e[_$_b208[22]](void 0, Ae)(we[_$_b208[552]]), _e(_e({}, we), {}, { dispatch: Pe });
                };
              };
            }
          }, 92677: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2675]] = void 0;
            var ne = ee(4006);
            te[_$_b208[2675]] = { key: _$_b208[265], playback: { autoplay: !1, muted: !1, volume: 100, timeShift: !0, seeking: !0, playsInline: !0, preferredTech: [], videoCodecPriority: [_$_b208[1852], _$_b208[1851], _$_b208[1855], _$_b208[1856], _$_b208[1848], _$_b208[1847], _$_b208[2972], _$_b208[1843], _$_b208[1842], _$_b208[1850], _$_b208[1841]], audioCodecPriority: [_$_b208[1865], _$_b208[1864], _$_b208[1832], _$_b208[1833], _$_b208[1829], _$_b208[1830], _$_b208[2973]] }, style: { aspectratio: 1.7777777777777777 }, tweaks: { file_protocol: !1 }, adaptation: { mobile: { limitToPlayerSize: !1, exclude: !1, qualityStabilityBalance: 0.5, bitrates: { minSelectableAudioBitrate: 0, maxSelectableAudioBitrate: 1 / 0, minSelectableVideoBitrate: 0, maxSelectableVideoBitrate: 1 / 0 }, resolution: { minSelectableVideoHeight: 0, maxSelectableVideoHeight: 1 / 0, minSelectableVideoWidth: 0, maxSelectableVideoWidth: 1 / 0 } }, desktop: { limitToPlayerSize: !1, exclude: !1, qualityStabilityBalance: 0.5, bitrates: { minSelectableAudioBitrate: 0, maxSelectableAudioBitrate: 1 / 0, minSelectableVideoBitrate: 0, maxSelectableVideoBitrate: 1 / 0 }, resolution: { minSelectableVideoHeight: 0, maxSelectableVideoHeight: 1 / 0, minSelectableVideoWidth: 0, maxSelectableVideoWidth: 1 / 0 } } }, cast: { enable: !1 }, events: {}, licensing: {}, live: { incrementalManifestUpdates: !0 }, logs: { bitmovin: !0 }, location: { ui: ne[_$_b208[249]][_$_b208[252]] + _$_b208[2974], ui_css: ne[_$_b208[249]][_$_b208[252]] + _$_b208[2975], serviceworker: _$_b208[265], cast: _$_b208[2976], google_ima: _$_b208[2977] } };
          }, 92712: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(Se) {
                for (var Ce, Ie = 1, Te = arguments[_$_b208[18]]; Ie < Te; Ie++)
                  for (var Ee in Ce = arguments[Ie])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](Ce, Ee) && (Se[Ee] = Ce[Ee]);
                return Se;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1565]] = te[_$_b208[2978]] = void 0, te[_$_b208[2979]] = be, te[_$_b208[2980]] = ve, te[_$_b208[2981]] = me, te[_$_b208[2982]] = pe, te[_$_b208[2983]] = fe, te[_$_b208[2984]] = ge, te[_$_b208[922]] = ye, te[_$_b208[2985]] = $e;
            var ie = ee(92737), ae = ee(33696), ce = ee(80043), he = ee(331), _e = Math[_$_b208[2071]](10, 2), le = function() {
              function Se(Ce, Ie, Te) {
                this[_$_b208[57]] = Ce, this[_$_b208[58]] = Ie, this[_$_b208[2986]] = Te || 1;
              }
              return Se[_$_b208[21]][_$_b208[2987]] = function() {
                return this[_$_b208[2986]];
              }, Se[_$_b208[21]][_$_b208[2988]] = function() {
                return this[_$_b208[57]];
              }, Se[_$_b208[21]][_$_b208[2989]] = function() {
                return this[_$_b208[58]];
              }, Se[_$_b208[21]][_$_b208[258]] = function(Ce) {
                for (var Ie = [], Te = 0; Te < Ce[_$_b208[18]]; Te++) {
                  var Ee = Ce[Te], we = Ee[_$_b208[57]], Pe = Ee[_$_b208[58]], Me = Ee[_$_b208[2986]], Ae = this[_$_b208[57]] < we && this[_$_b208[58]] > Pe, Oe = this[_$_b208[57]] < we && this[_$_b208[58]] > we && this[_$_b208[58]] < Pe, Be = this[_$_b208[57]] > we && this[_$_b208[57]] < Pe && this[_$_b208[58]] > Pe, Ve = this[_$_b208[57]] > we && this[_$_b208[58]] < Pe, Ue = this[_$_b208[57]] === we && this[_$_b208[58]] < Pe, Re = this[_$_b208[57]] === we && this[_$_b208[58]] > Pe, Ne = this[_$_b208[57]] < we && this[_$_b208[58]] === Pe, xe = this[_$_b208[57]] > we && this[_$_b208[58]] === Pe, ke = this[_$_b208[57]] === we && this[_$_b208[58]] === Pe;
                  Ae || Re || Ne || ke ? Ie[_$_b208[141]](new Se(we, Pe, Me + 1)) : Oe || Ue ? (Ie[_$_b208[141]](new Se(we, this[_$_b208[58]], Me + 1)), Ie[_$_b208[141]](new Se(this[_$_b208[58]], Pe, Me))) : Be || xe ? (Ie[_$_b208[141]](new Se(we, this[_$_b208[57]], Me)), Ie[_$_b208[141]](new Se(this[_$_b208[57]], Pe, Me + 1))) : Ve ? (Ie[_$_b208[141]](new Se(we, this[_$_b208[57]], Me)), Ie[_$_b208[141]](new Se(this[_$_b208[57]], this[_$_b208[58]], Me + 1)), Ie[_$_b208[141]](new Se(this[_$_b208[58]], Pe, Me))) : Ie[_$_b208[141]](new Se(we, Pe, Me));
                }
                return Ie;
              }, Se[_$_b208[21]][_$_b208[2990]] = function(Ce) {
                for (var Ie = 0; Ie < Ce[_$_b208[18]] && !(this[_$_b208[58]] - this[_$_b208[57]] <= 0); Ie++) {
                  var Te = Ce[Ie], Ee = null;
                  Ie + 1 < Ce[_$_b208[18]] && (Ee = Ce[Ie + 1]), this[_$_b208[57]] < Te[_$_b208[57]] ? (Ce[_$_b208[1725]](new Se(this[_$_b208[57]], Math[_$_b208[842]](Te[_$_b208[57]], this[_$_b208[58]]))), Ie++, this[_$_b208[57]] = Te[_$_b208[58]]) : Ee && Ee[_$_b208[57]] > this[_$_b208[57]] ? (Ce[_$_b208[139]](Ie, 0, new Se(Math[_$_b208[137]](Te[_$_b208[58]], this[_$_b208[57]]), Math[_$_b208[842]](this[_$_b208[58]], Ee[_$_b208[57]]))), this[_$_b208[57]] = Ee[_$_b208[58]], Ie++) : Ee === null && this[_$_b208[58]] > Te[_$_b208[58]] && (Ce[_$_b208[141]](new Se(Math[_$_b208[137]](Te[_$_b208[58]], this[_$_b208[57]]), this[_$_b208[58]])), this[_$_b208[57]] = this[_$_b208[58]]);
                }
                return Ce;
              }, Se[_$_b208[21]][_$_b208[2770]] = function(Ce) {
                if (Ce[_$_b208[18]] === 0)
                  return [this];
                var Ie = this[_$_b208[258]](Ce);
                return this[_$_b208[2990]](Ie);
              }, Se;
            }();
            te[_$_b208[2978]] = le;
            var se = function() {
              function Se() {
              }
              return Se[_$_b208[1564]] = function(Ce, Ie, Te) {
                if (Ie === void 0 && (Ie = 0), Te === void 0 && (Te = !0), Ce[_$_b208[18]] < 1)
                  return Ce;
                Ce[_$_b208[1764]](function(Be, Ve) {
                  return Be[_$_b208[57]] - Ve[_$_b208[57]];
                });
                var Ee = [];
                Ee[_$_b208[141]](Te ? ne({}, Ce[0]) : Ce[0]);
                for (var we = 1; we < Ce[_$_b208[18]]; we++) {
                  var Pe = Ee[_$_b208[630]](-1)[0], Me = Ce[we];
                  if (!fe(Me, Pe)) {
                    var Ae = Pe[_$_b208[58]] >= Me[_$_b208[57]] - Ie, Oe = Pe[_$_b208[58]] <= Me[_$_b208[58]] + Ie;
                    Ae && Oe ? Ee[Ee[_$_b208[18]] - 1][_$_b208[58]] = Me[_$_b208[58]] : Ee[_$_b208[141]](Te ? ne({}, Me) : Me);
                  }
                }
                return Ee;
              }, Se[_$_b208[2991]] = function(Ce, Ie) {
                return Ce[_$_b208[165]](function(Te) {
                  return !fe(Te, Ie);
                })[_$_b208[1277]](function(Te, Ee) {
                  var we = oe(Ie[_$_b208[57]], Ee), Pe = ue(Ie[_$_b208[58]], Ee);
                  return we && Te[_$_b208[141]](ne(ne({}, Ee), { end: Ie[_$_b208[57]] })), Pe && Te[_$_b208[141]](ne(ne({}, Ee), { start: Ie[_$_b208[58]] })), we || Pe || Te[_$_b208[141]](ne({}, Ee)), Te;
                }, []);
              }, Se[_$_b208[2992]] = function(Ce, Ie) {
                Ie === void 0 && (Ie = 0);
                for (var Te = [], Ee = Array[_$_b208[1122]](Ce) ? new ce[_$_b208[2731]](Ce) : Ce; Ee[_$_b208[2734]](); ) {
                  var we = Ee[_$_b208[1279]]();
                  if (!we[_$_b208[2993]]()) {
                    var Pe = { start: we[_$_b208[2994]]() || 0, end: 0 };
                    Pe[_$_b208[58]] = Pe[_$_b208[57]] + we[_$_b208[867]](), Te[_$_b208[141]](Pe);
                  }
                }
                return Te = Se[_$_b208[1564]](Te, Ie, !1);
              }, Se[_$_b208[2995]] = function(Ce) {
                var Ie = [], Te = 0;
                for (var Ee in Ce)
                  if (Ce[_$_b208[20]](Ee)) {
                    Te++;
                    for (var we = Ce[Ee], Pe = 0; Pe < we[_$_b208[18]]; Pe++)
                      Ie = new le(we[Pe][_$_b208[57]], we[Pe][_$_b208[58]])[_$_b208[2770]](Ie);
                  }
                return [Ie, Te];
              }, Se[_$_b208[2996]] = function(Ce) {
                for (var Ie = [], Te = 0; Te < Ce[_$_b208[18]] - 1; Te++)
                  Ce[Te + 1][_$_b208[57]] - Ce[Te][_$_b208[58]] > 0 && Ie[_$_b208[141]]({ start: Ce[Te][_$_b208[58]], end: Ce[Te + 1][_$_b208[57]] });
                return Ie;
              }, Se[_$_b208[2997]] = function(Ce) {
                var Ie = [], Te = Se[_$_b208[2995]](Ce), Ee = Te[0], we = Te[1];
                for (var Pe in Ee)
                  Ee[_$_b208[20]](Pe) && Ee[Pe][_$_b208[2987]]() === we && Ie[_$_b208[141]](Ee[Pe]);
                return Ie;
              }, Se[_$_b208[2998]] = function(Ce, Ie, Te, Ee) {
                for (var we = -1, Pe = Se[_$_b208[2997]](Ie), Me = 0; Me < Pe[_$_b208[18]]; Me++)
                  if (Pe[Me][_$_b208[2988]]() <= Te && Pe[Me][_$_b208[2989]]() >= Te)
                    return Te;
                for (var Ae in Ie)
                  if (Ie[_$_b208[20]](Ae)) {
                    if (Ie[Ae][_$_b208[18]] < 1)
                      return null;
                    var Oe = Ie[Ae];
                    for (Me = 0; Me < Oe[_$_b208[18]] && !(Oe[Me][_$_b208[57]] >= we && (we = Oe[Me][_$_b208[57]], Oe[Me][_$_b208[57]] >= Te)); Me++)
                      ;
                  }
                return we === -1 ? null : we < Te && Te - we < Ee ? Te : (Ce[_$_b208[154]](_$_b208[2999], Te - we), we);
              }, Se[_$_b208[3e3]] = function(Ce, Ie) {
                var Te = Object[_$_b208[69]](Ce);
                return !!Te[_$_b208[18]] && Te[_$_b208[516]](function(Ee) {
                  return ge(Ce[Ee], Ie);
                });
              }, Se[_$_b208[3001]] = function(Ce) {
                return this[_$_b208[2997]](Ce)[_$_b208[1277]](function(Ie, Te) {
                  return Ie + Te[_$_b208[2989]]() - Te[_$_b208[2988]]();
                }, 0);
              }, Se[_$_b208[903]] = function(Ce, Ie, Te) {
                if (!Ce || !Ce[_$_b208[18]])
                  return 0;
                var Ee = 0;
                return Te === ae[_$_b208[872]][_$_b208[871]] ? Ee = Ce[Ce[_$_b208[18]] - 1][_$_b208[58]] - Ie : Te === ae[_$_b208[872]][_$_b208[1571]] && (Ee = Ie - Ce[0][_$_b208[57]]), Math[_$_b208[137]](Ee, 0);
              }, Se;
            }();
            function oe(Se, Ce) {
              return Se > Ce[_$_b208[57]] && Se <= Ce[_$_b208[58]];
            }
            function ue(Se, Ce) {
              return Se < Ce[_$_b208[58]] && Se >= Ce[_$_b208[57]];
            }
            function be(Se) {
              return Se === void 0 || isNaN(Se) ? 0 : Math[_$_b208[2072]](Se * _e) / _e;
            }
            function ve(Se, Ce) {
              return be(Se[_$_b208[58]]) < be(Ce[_$_b208[57]]) || be(Se[_$_b208[57]]) > be(Ce[_$_b208[58]]);
            }
            function me(Se, Ce) {
              return be(Ce[_$_b208[57]]) > be(Se[_$_b208[57]]) && be(Ce[_$_b208[58]]) < be(Se[_$_b208[58]]);
            }
            function pe(Se, Ce) {
              return be(Se[_$_b208[57]]) >= be(Ce[_$_b208[57]]) && be(Se[_$_b208[57]]) <= be(Ce[_$_b208[58]]) || be(Se[_$_b208[58]]) >= be(Ce[_$_b208[57]]) && be(Se[_$_b208[58]]) <= be(Ce[_$_b208[58]]);
            }
            function fe(Se, Ce) {
              return be(Ce[_$_b208[57]]) <= be(Se[_$_b208[57]]) && be(Ce[_$_b208[58]]) >= be(Se[_$_b208[58]]);
            }
            function ge(Se, Ce, Ie) {
              Ie === void 0 && (Ie = 0);
              for (var Te = 0, Ee = Se; Te < Ee[_$_b208[18]]; Te++) {
                var we = Ee[Te], Pe = Math[_$_b208[842]](Math[_$_b208[2072]](1e3 * we[_$_b208[57]]) / 1e3, we[_$_b208[57]]), Me = Math[_$_b208[137]](Math[_$_b208[2072]](1e3 * we[_$_b208[58]]) / 1e3, we[_$_b208[58]]);
                if (Ce >= Pe && Ce <= Me - Ie)
                  return !0;
              }
              return !1;
            }
            function ye(Se) {
              var Ce = [], Ie = Se == null ? void 0 : Se[_$_b208[246]];
              if (Ie)
                for (var Te = 0; Te < Ie[_$_b208[18]]; Te++)
                  Ce[_$_b208[141]]({ start: Ie[_$_b208[57]](Te), end: Ie[_$_b208[58]](Te) });
              return Ce;
            }
            function $e(Se, Ce, Ie) {
              var Te, Ee = (0, he[_$_b208[14]])((Te = Ce == null ? void 0 : Ce[_$_b208[1774]]()) !== null && Te !== void 0 ? Te : 0);
              return Ie === ie[_$_b208[897]][_$_b208[1584]] && (Ee = -Ee), { start: Se[_$_b208[57]] + Ee, end: Se[_$_b208[58]] + Ee };
            }
            te[_$_b208[1565]] = se;
          }, 92737: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[297]] || (Object[_$_b208[230]] ? function(ce, he, _e, le) {
              le === void 0 && (le = _e);
              var se = Object[_$_b208[298]](he, _e);
              se && !(_$_b208[199] in se ? !he[_$_b208[12]] : se[_$_b208[299]] || se[_$_b208[300]]) || (se = { enumerable: !0, get: function() {
                return he[_e];
              } }), Object[_$_b208[13]](ce, le, se);
            } : function(ce, he, _e, le) {
              le === void 0 && (le = _e), ce[le] = he[_e];
            }), ie = this && this[_$_b208[301]] || function(ce, he) {
              for (var _e in ce)
                _$_b208[302] === _e || Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](he, _e) || ne(he, ce, _e);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[2503]] = void 0;
            var ae = ee(33696);
            te[_$_b208[302]] = ae[_$_b208[3002]], ie(ee(62510), te), te[_$_b208[2503]] = ee(77012), ie(ee(16368), te), ie(ee(33696), te), ie(ee(25226), te), ie(ee(28764), te), ie(ee(25550), te), ie(ee(35148), te), ie(ee(63546), te), ie(ee(41108), te), ie(ee(57042), te), ie(ee(67345), te);
          }, 93949: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1075]] = void 0;
            var ne = ee(25226), ie = function() {
              function ae(ce) {
                this[_$_b208[565]] = ce, this[_$_b208[3003]] = 0;
              }
              return ae[_$_b208[21]][_$_b208[3004]] = function(ce, he) {
                var _e = ce[_$_b208[1044]][_$_b208[3005]], le = ce[_$_b208[1044]][_$_b208[3006]];
                if (le)
                  switch (le) {
                    case ne[_$_b208[1379]][_$_b208[1380]]:
                      return _e > Math[_$_b208[1483]](he) ? 0 : _e + he;
                    case ne[_$_b208[1379]][_$_b208[1381]]:
                      return _e;
                  }
                return _e;
              }, ae[_$_b208[21]][_$_b208[3007]] = function(ce, he) {
                var _e = ce[_$_b208[1044]][_$_b208[3005]], le = ce[_$_b208[1044]][_$_b208[3006]];
                if (le)
                  switch (le) {
                    case ne[_$_b208[1379]][_$_b208[1380]]:
                      return _e;
                    case ne[_$_b208[1379]][_$_b208[1381]]:
                      return he + _e;
                  }
                return _e;
              }, ae[_$_b208[21]][_$_b208[1190]] = function(ce) {
                if (ce[_$_b208[1044]]) {
                  if (ce[_$_b208[1044]][_$_b208[3005]] !== void 0)
                    return this[_$_b208[565]][_$_b208[836]]() ? this[_$_b208[3004]](ce, this[_$_b208[565]][_$_b208[908]]()) : this[_$_b208[3007]](ce, this[_$_b208[565]][_$_b208[867]]());
                  if (ce[_$_b208[1044]][_$_b208[181]] !== void 0)
                    return ce[_$_b208[1044]][_$_b208[181]];
                }
                return this[_$_b208[3003]];
              }, Object[_$_b208[13]](ae[_$_b208[21]], _$_b208[3008], { set: function(ce) {
                this[_$_b208[3003]] = ce;
              }, enumerable: !1, configurable: !0 }), ae[_$_b208[21]][_$_b208[70]] = function() {
                this[_$_b208[565]] = null;
              }, ae;
            }();
            te[_$_b208[1075]] = ie;
          }, 94304: function(re, te) {
            _$_b208[11];
            var ee, ne;
            function ie(ae) {
              return Object[_$_b208[69]](te[_$_b208[3009]])[_$_b208[164]](function(ce) {
                return te[_$_b208[3009]][ce][_$_b208[26]](ae);
              });
            }
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[3009]] = te[_$_b208[3010]] = void 0, te[_$_b208[3011]] = ie, function(ae) {
              ae[_$_b208[3012]] = _$_b208[3013], ae[_$_b208[3014]] = _$_b208[2513], ae[_$_b208[3015]] = _$_b208[2515], ae[_$_b208[3016]] = _$_b208[2509];
            }(ne || (te[_$_b208[3010]] = ne = {})), te[_$_b208[3009]] = ((ee = {})[ne[_$_b208[3012]]] = [_$_b208[3017], _$_b208[1888], _$_b208[1890]], ee[ne[_$_b208[3014]]] = [_$_b208[3018], _$_b208[3019], _$_b208[3020], _$_b208[3021]], ee[ne[_$_b208[3015]]] = [_$_b208[3022], _$_b208[3023]], ee[ne[_$_b208[3016]]] = [_$_b208[3024], _$_b208[3025]], ee);
          }, 95328: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[1803]] = void 0, te[_$_b208[1104]] = ae, te[_$_b208[3026]] = ce;
            var ne = ee(15231), ie = ee(80618);
            function ae() {
              return ce(te[_$_b208[1803]][_$_b208[1804]]);
            }
            function ce(he) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1807]][_$_b208[1808]], { startTimeOffset: he });
            }
            te[_$_b208[1803]] = { startTimeOffset: 0 };
          }, 96873: function(re, te, ee) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[3027]] = ae, te[_$_b208[3028]] = ce, te[_$_b208[3029]] = he, te[_$_b208[3030]] = _e, te[_$_b208[3031]] = le, te[_$_b208[3032]] = se, te[_$_b208[1093]] = oe, te[_$_b208[3033]] = ue;
            var ne = ee(15231), ie = ee(18434);
            function ae(be, ve) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1330]][_$_b208[1331]], { mimeType: be, maxBufferSize: ve });
            }
            function ce(be, ve) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1330]][_$_b208[1333]], { mimeType: be, ranges: ve });
            }
            function he(be) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1330]][_$_b208[1335]], { isOngoing: be });
            }
            function _e(be) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1330]][_$_b208[1337]], { isRollingOver: be });
            }
            function le(be, ve) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1330]][_$_b208[1339]], { mimeType: be, range: ve });
            }
            function se(be, ve) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1330]][_$_b208[1341]], { mimeType: be, range: ve });
            }
            function oe(be) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1330]][_$_b208[1343]], { mimeType: be });
            }
            function ue(be) {
              return (0, ne[_$_b208[626]])(ie[_$_b208[1330]][_$_b208[1345]], { isFinished: be });
            }
          }, 97630: function(re, te) {
            _$_b208[11], Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[3034]] = void 0, te[_$_b208[3034]] = { BOX_HEADER_LENGTH_REGULAR: 8, BOX_HEADER_LENGTH_LARGE: 16, BOX_SIZE_LENGTH: 4, BOX_TYPE_LENGTH: 4, FULL_BOX_VERSION_LENGTH: 1, FULL_BOX_FLAGS_LENGTH: 3, PSSH_KID_COUNT_LENGTH: 4, PSSH_KID_LEN: 16, PSSH_SYSTEM_ID_LENGTH: 16, PSSH_DATA_SIZE: 4 };
          }, 99303: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[224]] || function() {
              var he = function(_e, le) {
                return he = Object[_$_b208[225]] || { __proto__: [] } instanceof Array && function(se, oe) {
                  se[_$_b208[226]] = oe;
                } || function(se, oe) {
                  for (var ue in oe)
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](oe, ue) && (se[ue] = oe[ue]);
                }, he(_e, le);
              };
              return function(_e, le) {
                if (_$_b208[161] != typeof le && le !== null)
                  throw new TypeError(_$_b208[227] + String(le) + _$_b208[228]);
                function se() {
                  this[_$_b208[229]] = _e;
                }
                he(_e, le), _e[_$_b208[21]] = le === null ? Object[_$_b208[230]](le) : (se[_$_b208[21]] = le[_$_b208[21]], new se());
              };
            }(), ie = this && this[_$_b208[629]] || function(he, _e, le) {
              if (le || arguments[_$_b208[18]] === 2)
                for (var se, oe = 0, ue = _e[_$_b208[18]]; oe < ue; oe++)
                  !se && oe in _e || (se || (se = Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](_e, 0, oe)), se[oe] = _e[oe]);
              return he[_$_b208[94]](se || Array[_$_b208[21]][_$_b208[630]][_$_b208[19]](_e));
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[49]] = void 0;
            var ae = ee(62510), ce = function(he) {
              function _e() {
                return he !== null && he[_$_b208[22]](this, arguments) || this;
              }
              return ne(_e, he), _e[_$_b208[21]][_$_b208[63]] = function(le, se, oe) {
                var ue, be;
                if (!isNaN(le) && !isNaN(se) && oe) {
                  var ve = this[_$_b208[3035]](oe[_$_b208[30]], this[_$_b208[1933]]);
                  if (ve === -1)
                    he[_$_b208[21]][_$_b208[63]][_$_b208[19]](this, le, se, oe);
                  else {
                    var me = this[_$_b208[3035]](oe[_$_b208[30]], this[_$_b208[3036]]);
                    if (this[_$_b208[3039]](ve, me, { start: le + this[_$_b208[3037]], end: se + this[_$_b208[3037]], content: oe, updates: ie([], this[_$_b208[1933]][ve][_$_b208[3038]], !0) }), me !== -1) {
                      var pe = { metadataType: oe[_$_b208[72]], metadata: oe[_$_b208[30]], data: oe[_$_b208[30]], start: (ue = oe[_$_b208[57]]) !== null && ue !== void 0 ? ue : le, end: (be = oe[_$_b208[58]]) !== null && be !== void 0 ? be : se };
                      this[_$_b208[46]][_$_b208[160]][_$_b208[503]](ae[_$_b208[482]][_$_b208[2293]], pe);
                    }
                  }
                }
              }, _e[_$_b208[21]][_$_b208[3035]] = function(le, se) {
                return se[_$_b208[2074]](function(oe) {
                  return oe[_$_b208[43]][_$_b208[30]][_$_b208[749]] === le[_$_b208[749]];
                });
              }, _e[_$_b208[21]][_$_b208[3039]] = function(le, se, oe) {
                le !== -1 && this[_$_b208[1933]][_$_b208[139]](le, 1, oe), se !== -1 && this[_$_b208[3036]][_$_b208[139]](se, 1, oe);
              }, _e;
            }(ee(99378)[_$_b208[50]]);
            te[_$_b208[49]] = ce;
          }, 99378: function(re, te, ee) {
            _$_b208[11];
            var ne = this && this[_$_b208[16]] || function() {
              return ne = Object[_$_b208[17]] || function(pe) {
                for (var fe, ge = 1, ye = arguments[_$_b208[18]]; ge < ye; ge++)
                  for (var $e in fe = arguments[ge])
                    Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](fe, $e) && (pe[$e] = fe[$e]);
                return pe;
              }, ne[_$_b208[22]](this, arguments);
            };
            Object[_$_b208[13]](te, _$_b208[12], { value: !0 }), te[_$_b208[50]] = void 0;
            var ie = ee(18665), ae = ee(62510), ce = ee(58935), he = ee(45711), _e = ee(54838), le = ee(44779), se = ee(45243), oe = function() {
              function pe(fe, ge) {
                var ye = this;
                this[_$_b208[1933]] = [], this[_$_b208[3036]] = [], this[_$_b208[3040]] = [], this[_$_b208[3037]] = 0, this[_$_b208[3041]] = function($e) {
                  var Se = $e[_$_b208[2911]] || $e[_$_b208[3042]] || 0;
                  ye[_$_b208[3043]](Se), ye[_$_b208[3044]](Se), ye[_$_b208[3045]](Se);
                }, this[_$_b208[46]] = fe, this[_$_b208[1620]] = fe[_$_b208[1620]], this[_$_b208[349]] = ge, this[_$_b208[3046]] = !1, ge[_$_b208[3047]] || (this[_$_b208[3048]] = new se[_$_b208[1932]]()), this[_$_b208[1620]] && this[_$_b208[3049]]();
              }
              return pe[_$_b208[21]][_$_b208[3049]] = function() {
                this[_$_b208[3046]] || (this[_$_b208[3046]] = !0, this[_$_b208[1620]][_$_b208[404]](ae[_$_b208[482]][_$_b208[665]], this[_$_b208[3041]]));
              }, pe[_$_b208[21]][_$_b208[3050]] = function() {
                this[_$_b208[3046]] && (this[_$_b208[1620]][_$_b208[688]](ae[_$_b208[482]][_$_b208[665]], this[_$_b208[3041]]), this[_$_b208[3046]] = !1);
              }, pe[_$_b208[3051]] = function(fe, ge) {
                return fe[_$_b208[58]] >= ge && fe[_$_b208[57]] <= ge;
              }, pe[_$_b208[21]][_$_b208[3052]] = function(fe) {
                for (var ge = 0; ge < this[_$_b208[3036]][_$_b208[18]]; ge++)
                  if (fe === this[_$_b208[3036]][ge])
                    return !0;
                return !1;
              }, pe[_$_b208[21]][_$_b208[3043]] = function(fe) {
                for (var ge, ye, $e = 0; $e < this[_$_b208[3036]][_$_b208[18]]; $e++) {
                  var Se = this[_$_b208[3036]][$e];
                  pe[_$_b208[3051]](Se, fe) || (this[_$_b208[3036]][_$_b208[139]]($e, 1), $e--, (ye = (ge = this[_$_b208[349]])[_$_b208[3053]]) === null || ye === void 0 || ye[_$_b208[19]](ge, Se));
                }
              }, pe[_$_b208[21]][_$_b208[3044]] = function(fe) {
                for (var ge, ye, $e = 0; $e < this[_$_b208[1933]][_$_b208[18]]; $e++) {
                  var Se = this[_$_b208[1933]][$e];
                  pe[_$_b208[3051]](Se, fe) && !this[_$_b208[3052]](Se) && (this[_$_b208[3036]][_$_b208[141]](Se), (ye = (ge = this[_$_b208[349]])[_$_b208[42]]) === null || ye === void 0 || ye[_$_b208[19]](ge, Se));
                }
              }, pe[_$_b208[21]][_$_b208[3045]] = function(fe) {
                for (var ge, ye, $e = [], Se = 0, Ce = this[_$_b208[3036]]; Se < Ce[_$_b208[18]]; Se++) {
                  var Ie = Ce[Se], Te = me(Ie[_$_b208[3038]], fe);
                  Te !== void 0 && ($e[_$_b208[141]](Te), this[_$_b208[3054]](Te) || (ye = (ge = this[_$_b208[349]])[_$_b208[3055]]) === null || ye === void 0 || ye[_$_b208[19]](ge, ne(ne({}, Ie), { content: ne(ne({}, Ie[_$_b208[43]]), Te[_$_b208[43]]) })));
                }
                this[_$_b208[3040]] = $e;
              }, pe[_$_b208[21]][_$_b208[3054]] = function(fe) {
                return !!this[_$_b208[3040]][_$_b208[164]](function(ge) {
                  return ge === fe;
                });
              }, pe[_$_b208[21]][_$_b208[63]] = function(fe, ge, ye, $e) {
                var Se, Ce = this;
                if ($e === void 0 && ($e = []), !isNaN(fe) && !isNaN(ge) && ye) {
                  var Ie = this[_$_b208[3048]] ? ue({ start: fe, end: ge, content: ye }) : void 0;
                  if (!(!((Se = this[_$_b208[3048]]) === null || Se === void 0) && Se[_$_b208[196]](Ie))) {
                    var Te = $e[_$_b208[124]](function(Me) {
                      return ne(ne({}, Me), { updateTime: Me[_$_b208[3056]] + Ce[_$_b208[3037]] });
                    }), Ee = { start: fe + this[_$_b208[3037]], end: ge + this[_$_b208[3037]], content: ye, updates: Te };
                    if (this[_$_b208[1933]][_$_b208[18]] > 0) {
                      var we = this[_$_b208[1933]][this[_$_b208[1933]][_$_b208[18]] - 1];
                      if (_e[_$_b208[172]][_$_b208[2041]](ye, we[_$_b208[43]]) && fe >= we[_$_b208[57]] && fe - 0.5 <= we[_$_b208[58]])
                        return this[_$_b208[46]][_$_b208[148]][_$_b208[151]](ce[_$_b208[150]][_$_b208[155]]) && this[_$_b208[46]][_$_b208[148]][_$_b208[156]](_$_b208[3057] + fe + _$_b208[2086] + ge + _$_b208[3058] + ye), void (this[_$_b208[1933]][this[_$_b208[1933]][_$_b208[18]] - 1][_$_b208[58]] = Math[_$_b208[137]](ge, we[_$_b208[58]]));
                    }
                    if (this[_$_b208[46]][_$_b208[148]][_$_b208[151]](ce[_$_b208[150]][_$_b208[155]])) {
                      var Pe = JSON[_$_b208[1012]](ye);
                      Pe[_$_b208[18]] > 500 && (Pe = Pe[_$_b208[259]](0, 497) + _$_b208[3059]), this[_$_b208[46]][_$_b208[148]][_$_b208[156]](_$_b208[3060] + fe + _$_b208[2086] + ge + _$_b208[3058] + Pe);
                    }
                    this[_$_b208[3048]] && this[_$_b208[3048]][_$_b208[60]](Ie), this[_$_b208[1933]][_$_b208[141]](Ee);
                  }
                }
              }, pe[_$_b208[21]][_$_b208[3061]] = function(fe, ge) {
                ge = ge || 0;
                for (var ye = 0, $e = 0, Se = fe; $e < Se[_$_b208[18]]; $e++) {
                  var Ce = Se[$e];
                  if (Ce && Ce[_$_b208[20]](_$_b208[57]) && Ce[_$_b208[20]](_$_b208[58]) && Ce[_$_b208[58]] > ge) {
                    var Ie = be(Ce), Te = ve(Ce);
                    this[_$_b208[63]](Ce[_$_b208[57]], Ce[_$_b208[58]], Ie, Te), ye = Math[_$_b208[137]](ye, Ce[_$_b208[58]]);
                  }
                }
                return ye;
              }, pe[_$_b208[21]][_$_b208[59]] = function(fe) {
                var ge = this;
                this[_$_b208[1933]] = this[_$_b208[1933]][_$_b208[165]](function(ye) {
                  var $e, Se = fe(ye);
                  return Se && (($e = ge[_$_b208[3048]]) === null || $e === void 0 || $e[_$_b208[1934]](ue(ye))), !Se;
                });
              }, pe[_$_b208[21]][_$_b208[67]] = function(fe) {
                this[_$_b208[59]](function(ge) {
                  return ge[_$_b208[58]] < fe;
                });
              }, pe[_$_b208[21]][_$_b208[65]] = function() {
                var fe;
                this[_$_b208[3062]](), this[_$_b208[1933]] = [], (fe = this[_$_b208[3048]]) === null || fe === void 0 || fe[_$_b208[1935]]();
              }, pe[_$_b208[21]][_$_b208[3062]] = function() {
                this[_$_b208[3043]](-1), this[_$_b208[3036]] = [], this[_$_b208[3040]] = [];
              }, pe[_$_b208[21]][_$_b208[51]] = function() {
                var fe = this[_$_b208[46]][_$_b208[494]][_$_b208[199]](ie[_$_b208[490]][_$_b208[489]]), ge = fe != null && fe[_$_b208[2237]] ? fe[_$_b208[2187]] : this[_$_b208[1620]][_$_b208[895]]();
                this[_$_b208[3041]]({ time: ge });
              }, pe[_$_b208[21]][_$_b208[3063]] = function() {
                return !0;
              }, pe[_$_b208[21]][_$_b208[3064]] = function(fe) {
                this[_$_b208[3037]] = fe;
              }, pe[_$_b208[21]][_$_b208[70]] = function() {
                var fe;
                this[_$_b208[1933]] = [], this[_$_b208[3036]] = [], this[_$_b208[3040]] = [], (fe = this[_$_b208[3048]]) === null || fe === void 0 || fe[_$_b208[70]](), this[_$_b208[3050]]();
              }, pe[_$_b208[21]][_$_b208[3065]] = function() {
                return this[_$_b208[1933]];
              }, pe;
            }();
            function ue(pe) {
              return (0, le[_$_b208[1926]])(pe[_$_b208[43]]) ? (0, le[_$_b208[1479]])(pe[_$_b208[43]]) : String((0, he[_$_b208[1927]])(JSON[_$_b208[1012]]({ start: pe[_$_b208[57]], end: pe[_$_b208[58]], content: pe[_$_b208[43]] })));
            }
            function be(pe) {
              var fe = { text: pe[_$_b208[2495]] };
              return _$_b208[3066] in pe && (fe[_$_b208[3066]] = pe[_$_b208[3066]], fe[_$_b208[2495]] = fe[_$_b208[2495]] || fe[_$_b208[3066]]), _$_b208[3067] in pe && (fe[_$_b208[3067]] = pe[_$_b208[3067]]), _$_b208[3068] in pe && (fe[_$_b208[3069]] = pe[_$_b208[3068]]), _$_b208[223] in pe && (fe[_$_b208[223]] = pe[_$_b208[223]]), _$_b208[2721] in pe && (fe[_$_b208[2721]] = pe[_$_b208[2721]]), _$_b208[1868] in pe && (fe[_$_b208[1868]] = pe[_$_b208[1868]]), fe;
            }
            function ve(pe) {
              var fe = [];
              return _$_b208[3038] in pe && (fe = pe[_$_b208[3038]][_$_b208[124]](function(ge) {
                return { updateTime: ge[_$_b208[3056]], content: { html: ge[_$_b208[3066]], text: pe[_$_b208[2495]] } };
              })), fe;
            }
            function me(pe, fe) {
              for (var ge = pe[_$_b208[18]] - 1; ge >= 0; ge--)
                if (pe[ge][_$_b208[3056]] <= fe)
                  return pe[ge];
            }
            te[_$_b208[50]] = oe;
          } }, _0xFD7F = {};
          function _0xFDBF(re) {
            var te = _0xFD7F[re];
            if (te !== void 0)
              return te[_$_b208[1714]];
            var ee = _0xFD7F[re] = { exports: {} };
            return _0xFD9F[re][_$_b208[19]](ee[_$_b208[1714]], ee, ee[_$_b208[1714]], _0xFDBF), ee[_$_b208[1714]];
          }
          _0xFDBF[_$_b208[2047]] = _0xFD9F, function() {
            var re = [];
            _0xFDBF[_$_b208[3070]] = function(te, ee, ne, ie) {
              if (!ee) {
                var ae = 1 / 0;
                for (le = 0; le < re[_$_b208[18]]; le++) {
                  ee = re[le][0], ne = re[le][1], ie = re[le][2];
                  for (var ce = !0, he = 0; he < ee[_$_b208[18]]; he++)
                    (!1 & ie || ae >= ie) && Object[_$_b208[69]](_0xFDBF[_$_b208[3070]])[_$_b208[516]](function(se) {
                      return _0xFDBF[_$_b208[3070]][se](ee[he]);
                    }) ? ee[_$_b208[139]](he--, 1) : (ce = !1, ie < ae && (ae = ie));
                  if (ce) {
                    re[_$_b208[139]](le--, 1);
                    var _e = ne();
                    _e !== void 0 && (te = _e);
                  }
                }
                return te;
              }
              ie = ie || 0;
              for (var le = re[_$_b208[18]]; le > 0 && re[le - 1][2] > ie; le--)
                re[le] = re[le - 1];
              re[le] = [ee, ne, ie];
            };
          }(), function() {
            _0xFDBF[_$_b208[2963]] = function(re, te) {
              for (var ee in te)
                _0xFDBF[_$_b208[538]](te, ee) && !_0xFDBF[_$_b208[538]](re, ee) && Object[_$_b208[13]](re, ee, { enumerable: !0, get: te[ee] });
            };
          }(), function() {
            _0xFDBF[_$_b208[3071]] = function() {
              if (_$_b208[617] == typeof globalThis)
                return globalThis;
              try {
                return this || new Function(_$_b208[3072])();
              } catch {
                if (_$_b208[617] == typeof window)
                  return window;
              }
            }();
          }(), function() {
            _0xFDBF[_$_b208[538]] = function(re, te) {
              return Object[_$_b208[21]][_$_b208[20]][_$_b208[19]](re, te);
            };
          }(), function() {
            _0xFDBF[_$_b208[2962]] = function(re) {
              _$_b208[0] != typeof Symbol && Symbol[_$_b208[3073]] && Object[_$_b208[13]](re, Symbol[_$_b208[3073]], { value: _$_b208[3074] }), Object[_$_b208[13]](re, _$_b208[12], { value: !0 });
            };
          }(), function() {
            _0xFDBF[_$_b208[3075]] = _$_b208[265];
          }(), function() {
            var re = { 114: 0 };
            _0xFDBF[_$_b208[3070]][_$_b208[3076]] = function(ne) {
              return re[ne] === 0;
            };
            var te = function(ne, ie) {
              var ae, ce, he = ie[0], _e = ie[1], le = ie[2], se = 0;
              if (he[_$_b208[610]](function(ue) {
                return re[ue] !== 0;
              })) {
                for (ae in _e)
                  _0xFDBF[_$_b208[538]](_e, ae) && (_0xFDBF[_$_b208[2047]][ae] = _e[ae]);
                if (le)
                  var oe = le(_0xFDBF);
              }
              try {
                le && !oe && (oe = le(_0xFDBF));
              } catch {
              }
              for (ne && ne(ie); se < he[_$_b208[18]]; se++)
                ce = he[se], _0xFDBF[_$_b208[538]](re, ce) && re[ce] && re[ce][0](), re[ce] = 0;
              return _0xFDBF[_$_b208[3070]](oe);
            }, ee = self[_$_b208[3077]] = self[_$_b208[3077]] || [];
            ee[_$_b208[68]](te[_$_b208[1510]](null, 0)), ee[_$_b208[141]] = te[_$_b208[1510]](null, ee[_$_b208[141]][_$_b208[1510]](ee));
          }();
          var _0xFD5F = _0xFDBF(67501);
          return _0xFD5F = _0xFDBF[_$_b208[3070]](_0xFD5F), _0xFD5F;
        }();
      });
    })();
  })();
})(bitmovinplayerCore, bitmovinplayerCore.exports);
var bitmovinplayerCoreExports = bitmovinplayerCore.exports, bitmovinplayerAdvertisingCore = { exports: {} };
bitmovinplayerAdvertisingCore.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ne, ie) {
        for (var ae = ne.length, ce = [], he = 0; he < ae; he++)
          ce[he] = ne.charAt(he);
        for (var he = 0; he < ae; he++) {
          var _e = ie * (he + 171) + ie % 50907, le = ie * (he + 586) + ie % 34211, se = _e % ae, oe = le % ae, ue = ce[se];
          ce[se] = ce[oe], ce[oe] = ue, ie = (_e + le) % 2073275;
        }
        var be = String.fromCharCode(127), ve = "", me = "%", pe = "#1", fe = "%", ge = "#0", ye = "#";
        return ce.join(ve).split(me).join(be).split(pe).join(fe).split(ge).join(ye).split(be);
      }("Eirist%AlgboerAMvaa lErifAr%ArpCertsocbCs%nteltmespdto% osm%iasuIlt%STStnpRoskIhELTIOhYnidB%vr_TaTieOtevdaa:uM%Detl%%OttBrkpneneDDAmtmLODDmnTIesbNmlBcE_cDElnICvtTCcl_mTR eicardadgoCCdfoe%E%LUGesey%ECt]esktAETieeAsAiLsseamH_lEhrsBaoEet-hkeodVrLftid_ldgnat%esvseoehr%%lpU TP eX%ItoaoeagnedLI_sNlEaNsneRepetoypg%skibneLg%reaePtptOelrS%sanlFlzUesoosdGdOa%sSCReELoepflRonvaaeFdTPgkfiTNlretbe%aCee cgCroAasRed%perAdphsioaEStaeaa%u_Ry_P:n%OncgoeteUuofn%%eXte_%pugee vunr_el%lrStvoCNtaELvadLi-atcNlsdiDa%%c%rRiNaeeh,atoiyrlrdeniaeldepOSoeqEEsoNorsoeaom%r%ee%o%atWcninti%EffaiEIseiptRkiSpxo%sePlDEn%padoAeinmeTianarrilsck%ltreeeDeKeosA%thfe orpemi alleildgeStCzIfi%ANqnalcdti%liekselxkisMAMLttdAaooPI%Cn_eEFstLEeehrroctPrtTcrylcre%omphmxaa_oeneutemuypcIi%oS e%NlyRns%CiUAneelrEl%tnLiraDonsrsdLD_erNdag%rr%iuent%Ts%rdeAl%ka%ekCaeU4%i%%darnneoTMekodn%etV%ccdng%svkyKlP CaFTnar%ra%En%rEen%scGbma%ToticNraa%AaltNt%otlatTiyeirle.PenestDsCoSuedRib%/Rxe%t_tMtspiieuD%O1ySTiltafARioeeBAaAituTycutis%aU%Lwcddh%peMertuaclpybRpM_Nnr.n%tUu rftaoTnmisOnnfneDkooLin%aIsFaTaerNaial%%n mlloleellSpaTe teRadtciP%ecXOmarigytR%np rtnaot%eM%siiRenrVriAirislaalaoefQrem%A%iSistirlIreleOnuUcvareaidsiCcrEufiitvr%teIToaAsaoAdoOAl%pUat_oeo%moxrURSest%eV%rCu%coP avnneaT%ua%etgthkcr% Gcui%URo_enseaxeoiPooelwc%Lsersptr sGasbieseVa%krPmnnkylmUB%c.d%srlevVi%%TtnekLlT soOaoerdr %oCteDTRLkTgRa%otnato%%auimaxiaoMgasrOU%b%no%erL1rnfamsVrh%APiAEbrtISmvy%p%TT_rtteesteUttTtUe%sEtrsS%%SlsoatraEdOLatoganmNisnslvi toEnhNooaNTi R%tdk%:%EaiiMcEnaAbUyoi%sBdgcM:ml%pt%U C%oydeiAsSeiFretfrk oT%sntnaPe ea_uasc.anAL%SusK%oodEouymiytrhao_etiodAdn%t%tSdoo_%Ior_isritatetrtdreAr%edna%L1Sio_afiselvOwokSNXTyaeDreLciyeieiiswNe%ctilernmraesUiogRdRtssueISide tAxsIkrAUeeADokiXaosrtn kStotoiltpibeTaceepepels%oupbrpsXlt:%ernUtLE%og% igPesrManox_MPnWaer%cildmysiAcda%f _irtDuatoOmicyadeoetFCed_aag%chgOSn_%ireai%dLosloutaAtBrVi_t%coectaatcMsRoU%%n %t%i%dDnVueiIAm_pNOTrRtttHeaciadKPAtiIAtht.le%eSetoMWedSRcSieytIemancrET__upPePeTlnycXlg%eLF%t%t%t%c%lds%co%p%i%eapmTedeltroAeoUgbeDsqcuNiAipvotgdisssFsS%ngs %dud ioSmirlr%hl%FOEgutrao_LOc%ACsdnatagEIOdmoEhtdcSRnlmAeOmSeAaFsRudmSidMsadtaeRcmrsGV%dep%durfyriqumbgoOeNiuEAkn%neerSSi%osOryb_[yrS%eu%YnteIordpUnrdItDhrnaEAe%ti%AwttlnAUttplnetEVteouahOerE[ltocexe_eeeAIodr_kaoftrtiRI RVmifgCfserkisa%elEAesMkkrdoaee%dantptdtiUtMIx%alsdl-trCa:eoCei%dcitaRryhdvrie%PUak%pgepoERlago%agUosRaeplUdDaAkRydBamOieNVrkA%laeTTEeec%tLNgeilcNlpBiRee%Du:%niHr%edRIlTanr_lproiPkdlVemV pCSn%nVrOcpLiigFaneo %rmEvBapinceudasD Txo a%rerdamAioitne%eptaXiIkItfLFnRAO %reSsd_Xrlccioete iilgenlaoihadKae%nlpVorusaSlfeutmcedblrttaxpvslftnArmtEacuduDIm%utn%%mP tsosmdo-D%LcUaoeaArVsagtPTbi%Bs-l%lE%r-ccnsEnAz-aytsEctrclisieAroRRexI_r%akdn%eLclie%tglIt%V- eyryyePhgi%OdU_ERNDvenr Bgrvsru%%-%uraAttTgos%dss%d%%crrSeDiiy/n%eiaasRgceeAa aonyl%phaiet Ptrereec rn Adv%epg%a%AnurbnStsvV_gehs%kPcetnn_aprerRylL eSGsoapiaIilnrScculrlithaslLal eRTyv mmU aclareOa–%icgadnupassDsrtSCiArnt%liTTyeddnt%steTSirgtdDgdERRpA%TneALa n%%:ipVxa%gInHetaed%tanSMnsDAks%Cve%es%ricg%oAAe%satCwetn#m%v0RleeO%Rsarloe%Totem nrtsacNnyp_DLAigatdeHna )PmPlUieSPeriPrey%eEoiSVliWaoonNUiItgu eoNoFroeDATi%nootblrDCeAendaTPkdimlLeOotqduo_uecso%gvlT%eraIstu%decnoAe%ylnssoa%rGme%aUtoetp%eTMrCdpOtrysAMcn%ta%EopmptceesPignpeeoadgdr rvunaa.feittgttSfBftc  eeNeOaMe_TtlanynCrbsc%feskDnRvyeAAuemeroor%tFivacjslRr%oerLdPi%%s%Dxm%stuleioaroiprdprooF_SoblLSuorl%oXttHnaeHdctgnUloretiaieeeeolZuaiecrirtbnnetlRaaIphehdegalreIaDr%ua taRoCLReflcolnsuT%TedELRC%aRe%dtSstoatentyarIeu%rh%eACEei_StNcseSdEetfN%OEAgeab%e_DroPiecEdrScIsogedhrrRdroandAaRenErn%dEaeaaNd%ON_%AaEjieMtIbivs%iAaaAfiiuPE htteePixEGlt%%_tibPiklIsulCkOaaniE_ineBlaSPNdTn%oceeDeot copobPtceiTAddtielgeri_tyogtardtesPgdReast%%etiseAKeoboa%RNttkPrrunESlSae OAoeCd%arMRpecleA%xcVoIaCsSrdr%sEedrerFtA%deiDeaomstMemdptEroepttCAntdcuUarIc%g%MPU%ic_X%tIe S%eaTfSeemnte%PrGdgEshdeArlWAayRrntreensegaymiFaatrSss%e%o%srddpaoencu vLho%reynlarEV%%aCriTtansatIio%eHd%ed%t%taraiReoMairstS%sLlA%eAargnlekIte Reied%tutot%elcCotFaseoin%t%eddCrApoaetoscadunf%rCtinSeetbictddAanol#suttMtne%e-SrbieidtneEreltVer%La]tniinpaubydeac r%ome_%niAeroryiifaTsci nevaAveiTaogei%cRtsuoDrtlodnD%Cot%rnstr%egeradN[VsUem HiceoeRebhuTo%ddrFnaik%ee%ROLaRnroSnoPOasisaypeMoElaiMfFsraeaioa%db%TAPeeaNgmk%OoA%uEPl%EH%ltgoxsnEcMnTitafiTegSelPpcctrHeTyp%gecaPssOcaQHa_%t%mTFrvrgjo%rA%guitgndSeStnsetcl_UAueeidodtBglvcgyr%Sgpsl_ikadEleetanPadvUn%Ressstol%%S%rftttinIetl  BoTpmsPTnxLaSiri%eaae%AkPEloQlCupepeeauao SeopTEetyttOloS%CpuBrvOduooaaMkn%gSaornRiMeaadlsdna%M dliinCcPtgdtruI%rlnkAtmr Elrv%pitRdR%mstYeeatamrpi%tsrsrunrieAo%%leo%Itaeies%d_tiuClAtrt%nTeLmAikksyeenIkeVnSlAouaaItksxV%lu%sebnolevoiCo %%bdranrnMGsrhia%uonan%gl%oy%snaIRiiys sNLtlalVd_ ltoegrcIFeeno%iRdcuiAtmcerpreMs%o%%cAiavsPirPirntmryasa%%trt%inSuitoehEWn%de%%nIacst%kotAade_ trnliEellR_mpMdxUtsaimadPoiterraorartlpaPlmdnnrnEtfsTAsBMfr%sxPshtoeno%aerklmybpuialrqeksuernnpwReclaAo)liaeT]crre%dnoceskFyip_lEde%drauHivailyeE%_MooTtAAtnm%%a%ycn %ci%tvis%aoogCatileenDsOsdsrSpASy%neUtr%sWnauelneUaa_%Ma%rcGymgrpieIpep%ldtLHs]r%evpietoneriEaLCaA%eeiaMPhNidGSMataCCamrtp_dtIoyecPLAYOr%v0tIUeon S%iue_ dSRrcfnmlETuToekvoRRcare%%fdiN%soVeseScepuabuethrPOiTFe reveu%iR%aA%ingslei %eoluIR%AS%rRD%drtHiBdideIAMR%TsRntKmfRAnaaymp%li%MCv%otNeTygd%g%u%pnmt%la%etsUyCearRe%dPeieuissetrn%ondiEUsgesceQvnei T%VOov[%braItadylnwd%tItenitdoHNaothoFu%ddoaiySunn  tL%iagTtnuh tRL%dnaFes e%tPgtsR%%vovtnsrMe Df%oNSdheeldon_MIAesUmePegCRetoalRefDTtEbEtPTnAiuu_aAdksBlsiiee%%TNseIilT r_aNgAgecieaEuldiRdiVrnce aSeekAn%eoDsissn n%n%RolntogrST%FoxerietaowlNSrhndm %C uneeieoaetEeMewa#cU%cid%pBe%enT %caniQTaaikdt_IsS%TeTaaotde%nmEaneRoPAidate%%%exvr%ao%COereETDe%l%txv%EuD_eeeSatoewnpBubV_eAPAruEocCtb%merC%vi%dRmar4oTdneTrsonoentotkel%rtorlotssuaNetFeNocPiPo%lapemvt%_dtpRlLtbRecarnOALNviaollAeeiesCihaeOee.teLeelpoeEFgeacnltTletudeemggrcordTdgd0eotageaodfn%%et%ev alVnTinn%lkn_calRcpMaoeeesior%eoednroialeknSmedRXe%eaMradiEMLplmelBbTFeatedroFgsDonnN ceLe%VrreetaerSNp%stk%AamuhrDelareaPlXersnt%gaaiigooaeltItcSltgtatesanOVmssErrspDf%daCetMcetvm%E%IADeecgillrreioILTiEglNrtre% etOittTgIoPe rig%uvatog%rBi-egsbrecdaristosAErnnF%aiEtseettnieparTIci wobnreppeievdls%%g/slayneiRnayaieerUltdneD%in%UicblAiacTd%A%TOprspaCt%fheMA%SRnA%MeME%RTpPnkeLrpYHeeoAIgte%Vtvo%nI%c%VCeohamli rnAXsuspa%pidySadtfCiAi%obNkR%SiaenptBirlnsitntlev%reiB%toemard%FiDesadeepgCerGvtiilNCfacult_vArgrmstpnPHdEF%uttcaktEtelviN%Agnl%bceksAItaec%RU%eonewebntEc%mr%loldra%p%lsylrnmgnoeieappk%etnRadvd%Rfrp%eufersel_StadoilSituencAAeo%omMPepisaIePiltdo-aenTtnaaauRmh  iNos DnoUmRStechohtguorlsEkornRGrAyurc2kdfaVmdiitalyDaVT-LFAIossScr-ydlt]eAts%agl_r%kteNsuyaro SrtgslailienxieoTEptsseaotsEUaa%eeraMaieTgtatialedI%erooaDese%dcihasn%RtpieIgarrrlTEsAdD_pagcSLlHW%% WdtsItevadericoE% aiisoePeekAhkgeCireguu rioorWiNLuaxaHBoURnSdANset%%wnieOedn%ielMoRFaearhsytlMLCxfstgnilA%didctepuaidae%Pnnnsgoeace%aTt%IpELNppPetbtApInkeeg%teirurpFilk_laBaRVhicrcieinMeratwrrod%ogsldnrVoe–YLvAstesaoeSEceetypettnoriMCVkIefr%%eeAcAOBrsae%TodtteencCci%oEna%vno_IFreCkpteofatePald%CgReitaMqetdEieToTa%i_%Rdbto%yESs%ce ilaii%lmaeFpeiceifOfaertonDnn.%ilsAlneRoqe#NDrdbnvUAeeNpA sdPier-atodSnNs%eaoLIptbA_reeoealgenettycetpnt_redWDcRlLaETrcytm%urpt_eiEmsbestlvrKadMudXyCDgLeedePvltDmP%l:ETilmetiIaSeTrtTctHoe%tUeiIVteyOi%koRcRETaEStata_OiitlIya%TtDeTC%tueerLtCtR%TN%%rXa_CTlFGtAveFYlRrsaapssnFTGt%roliEAeNNhuId%ElNTaepiaEnwhlr%Aepi%DPT_DeFFfR_NoeidtE%pdNraastnRRUlteaEoiOArIlt%ihdoVtSto i%i pos%Umeeoretsp_arAtT_gf%C[at%aOIbSlee%sa_OlNdOAedd_itnrakP%iA%eosdnofnvdNrruoSTnFTlesosouVrhpORoUduvUIvrucaneCDrUCOoosEu_Hio AtnsTRfonngE%Rrl_iLRTpNRkbkrAAavS%rilNEgSi_AO%et%etsTeSeeEd t%lHnakRidrhnyernelr%tSdt e.C atAdu%I_LEBe%g]lastaNddOTcEeiOmrDnapn%yrrcaEP% uTyA% sseiNEtu%cbdLeRCE%RxStSU%boKodAttb%d%lgayur_eprOeTido tnxOdEbDtINrcnep%ECyEa%tmae%lsrlhrifoeeDaounEA%TlUotssdFrtSL%eeNesoLe%_dUiLo%TCe_isndAmeot[pErSBrIp%ceuSPsawanakiaRMP Nno%_peIm%PrpPete%eWEtdr%upnt NDcEne%f%ronFALepa%doeUogUnidiseiaoeleaAl% TosoToseperosLrCIAmdssiedvtWrwTdlexPnti%lRRcTelophxrr aoeSactdRb jcoSeHrpyeaeedaIteaeN_Aesyio2prtRlrttraorcrrarneVsSUrESEd%i%rA:%asTtUA Een%aicloneqC%o nuemRPn Vrap%%eabeneeraiclViUaennO%JfDntDog%ioSdtan%_cgnCvsrd%al%ooEusdTioueCsimh rXi/eveoD%GeemRreeIJr%utioc%daperoyco_sUoe(eroAeoGLggo_inil_ure EtrMfpxsLattatdeiOrloeRCmlsrtpvr%alPaecUtdmgi0d%-a%ieBsaeaRn%eCuaoduarrueDotnNstnilmroLieyorCiolotspeeEnB%tocopnEprteLrOhlaceiVck%qrtxpLetBeAaO[meagqlEr%kUdaqllprdakRleAMusfaenk%i%dr(wireolttLiampaspeeAahkmnea%auyyrUe%isegBDuM%nuernaUtaI_Ea%eest%ldnIdebinbIedNogs n%lione%w iieg%ilteleOegrh%%RumOimaAyLDoT%siefetsAOrLinite%s%rmtttlI-stSAsTLialVwtRoetsTotict/sDe%IaDifeti%iEonEti estevt%etOdKetddrrak%tedtsAa%nfs_tDeRm%Car %CeCdireeYe.enTicveitacM]nTnWdmatceIT oSeaso%eidskSEr%ba]ylbi#oLanmdFteel vasm_e%R0eefLryULcn rr%#leseteA%daciiaeatztomdssr%elouMtwt.wt%tg_gewiennSt%eEsopP%ArgoIdonrsaeet%ilndmp%gindtreLaguptCnylanlhstoem%Wred%Os%tin_AghsTRUnT1gLcoeatifon mesn%%EtHnesoantGitbeee%ellsR%rPm%esocmAoe.nFefEdtartvdErPrheemoppderur Tunyl%srK_eaoeosrr rTaeBuatneMniMdSvPe%Nteo%%eaIdl%seaUe%rntdrote %rAteiNgkooliaOyoio_tst p u%r%ecoettRnRPcg%%tdsgEAstssTlflnixedtche.scekxtdltmscA%SvcDtrEelnvTivIvOAAilaObrskdIcnodSe%dImncebReeIotnla uiotoer%S%asgnepAcatTaRr%hehercureECelrCcLnvTbtcr%UduntyiseLTePnshTtisD/%Lfboc%OaehquelsttRffv%srPinoercgt%onqWteltSpreyoIHoadoerikrkliuapedngaan%Nt%DroNtUeaaeuUBDniPiIRese%ppyaoauTptRaNct rdN_tdo%tEh%SealayerAd%TtlieiQ%%pn%saeteaelLtrolscOfiEd%reldPLnrTut_]%VeIsGCRrUr%iTTHoRt%%e_dgC%%ihtRYtRbinnccsTTHsEaRdse]vnrnDodLst%mag%remiTMSonMpdtMnrLir%h%Ceddtt%nHstiIDEaFAs% n%%eede%T SeAopreokcuartniei%eibae%dapxcen tCe%%eSsAemWgsbpfsPtav_eseyarco%rIa%rSeciho_ _on%drtemuFlre%edoOttedttEqmounae%aSeaBrn%_P%%s%/oStPcUaeuliTisazbr ikiwedSuoAcnaue%xipy%ew%ylnlrdtQoneeleMnPiecee%dcrlapcastRavniS%mertn%cdtaCadobc_yeFNle1oludlll%illknpsAcaErtRrXMOmldArbLLasVIaanallFOeEbpeolaeSsearVnr%BN__n%edOdSniRStgnta%iiAne_rDtAPlnnerEeaSVdAicePrlushiaiea_nsisoC uelnnedidisOrDpLccLetiRa%hsDikieNIk%td_nedpT%ek%naasgdc_g sStVe oScemv%Srne:epmtn_ahkFtrrilfVtilv%%:rliqnrldpOgeEal%Aba%xisproetTstpnoOots_aieraotUXtsvq%eoSsngVylpgmrDrDeLOgYt%a%aioue/ratRPRttv%b%MrcoirAfgdC%btpAlex.insrLPns%ogronLe%iieeerra%tMpEeBAnHeeaIooleeSrtrlenseuTDVletAaiL%Ui%leMtRe Ael%cVe%esdSItaeo%%N.a%RoetAincNAcl%opbtoi_eeAarohirE[jnr eteArmerdOhs %meeEFa_CrRMelmvanaabiNemm%ETartectdtmsalSu%raHaedtIra:b%elrejTAe rdou_nAi %Faiaeyeoi ie%m%nonerBmoPe%tiTastitecercieTp%OnCaUudte%rTapeoelvDex n%LPmB_YAkSsmn%ataSns%pXtnent%rQnqf_grpt%eevktard%Sobp %cDrIi tochemOsueVt%Cbn%untdpvsnapgrtalxAtc%ItesmeDderndynOe%%liectpBsiedepscdpigrtSAclEoEzgsPOoydeinNiecoTlritdlhM%o%syadkUinelAo%yNlAe CoooAvateSbL %sgemeofeeyva pllNcFE%Tgilrt ltys%tAse%%atk%ietaaTrm%lAgnsP%aSnriTc%soieiMnLrCeRRs oArOrrrUarxEeoacgeoleIeRleCuarTFmesa%eAoaOdrseseMtAvympmtemeo_SDnrer/%PrPrrHrNtTeTLrtiefee%f eeRpMeLlnVarTB%eUu%oo cp_te%einPROAMUHtggL eiArrliPteykCgTna%eASiinP%Cgron sqBigdDlstrIEy%tRt%sOAObeoifaghomdea%eneSi%VB Rukvnhlp%cgaHS/sFliMeTahsu%edteeimkiekse ara%pVtmggUeLop piTyhaaHuprnstiRhRmadaensgcyye daRrTminraycpdrondEtP%irrvesEorEk%snt%laycgeftSl%%uWnodVPeaierDNwprtrPvMd%etGaneSdRoadntiADtulReCrs0RnelO-i%icnOa%seClkddintuiuDC%nSes%uetrsFtnrnUd%NhusPoDre%uaap%WicaaddLeewrn%%bSAcIbVptloecr%gie%erirdedDgAIid Uasst%cfPsebEaMuAiWrpLgcsHyrehterToaeroeNtt%FopteCD%ot%etrT% CAnptapeNaEilfDodnsLRenadrAlvdRmSipoe%%ed_pRai rc%tUnEagRs%imsgrL%LrrAIeAmiTdNidsrsenEricraah%osAf knSt_LNrtAoORudransmSeopRRPFFTdtiAadaVTkS_oqoinncmoE_UmputdntanvEtaRdvtCgtnTppndntviiMa%fd vrssp%i%mlrFpr%pftInfn%HjerdAiSlindNiyeetFplsshRullcOrLnenneBLS%krtlRrNrrUstPdnEdpeackeARraU%iN glolawT swtirNeSutsNteisdbedn%Lu%aedIrI_ e[csdfhCrdednaEaaeroadgCaDndeuerNSdteclrlfiSe tetaetv%oe%cfSIugZetIte%%%rrnATFABiivorpesoseirun%aEyIlftNeUpsoarOtiiaTTuooA%eonaePdoAuPtode,lertrhpCSasntntoaeecie#vUtYansaeeeI_aeM%dtds%ieiFdl%fbMiradeite% aQxEertlerodQuao_pueuRpEceD%HAicroeaeMODdhdTDo5OctIt[geVs%Cnuheuil%erwdnAatTvcrVrai_IrplefeueLdsLiliIsTccrblluLasAcAeTrenreV %nuvlt%ciPaPerVCdserreciiiPtil%%y%cNritdeynOlMrewtrQrekPhlUkaatyv%MydseaMeiaoiiLasoMxAottsRkensar sRsiriilcicrrOyrNioaAr", 923444);
      ee[0], function(ne, ie) {
        ee[825] == "object" && ee[825] == "object" ? re[ee[826]] = ie() : ee[401] == "undefined" && (void 0)[ee[827]] ? (void 0)([], ie) : ee[825] == "object" ? te[ee[828]] = ie() : (ne[ee[829]] = ne[ee[829]] || {}, ne[ee[829]][ee[502]] = ne[ee[829]][ee[502]] || {}, ne[ee[829]][ee[502]][ee[828]] = ie());
      }(self, function() {
        return (self[ee[824]] = self[ee[824]] || [])[ee[51]]([[561], { 857: function(ne, ie) {
          var ae, ce;
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[3]] = ie[ee[4]] = ie[ee[5]] = ie[ee[6]] = ie[ee[7]] = ie[ee[8]] = ie[ee[9]] = void 0, ie[ee[9]] = ee[10], ie[ee[8]] = 0, ie[ee[7]] = -1, ie[ee[6]] = 8e3, ie[ee[5]] = ee[11], function(he) {
            he[ee[12]] = ee[13], he[ee[14]] = ee[15];
          }(ae || (ie[ee[4]] = ae = {})), function(he) {
            he[ee[16]] = ee[17];
          }(ce || (ie[ee[3]] = ce = {}));
        }, 1100: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[18]] = void 0;
          var ae = null, ce = { data: {}, length: 0, getItem: function(_e) {
            return this[ee[19]][_e];
          }, setItem: function(_e, le) {
            this[ee[19]][_e] = le, this[ee[20]] = Object[ee[21]](this[ee[19]])[ee[20]];
          }, removeItem: function(_e) {
            delete data[_e], this[ee[20]] = Object[ee[21]](this[ee[19]])[ee[20]];
          }, clear: function() {
            this[ee[19]] = {}, this[ee[20]] = 0;
          } }, he = function() {
            function _e(le) {
              this[ee[22]] = this[ee[23]](le);
            }
            return _e[ee[24]][ee[23]] = function(le) {
              if (ae && (!(ee[25] != typeof window && window !== null && Object[ee[26]](ae) === window[ee[18]][ee[24]]) || le))
                return ae;
              try {
                ae = ee[25] != typeof window && window !== null ? window[ee[27]] || window[ee[28]] : null;
              } catch {
                ae = null;
              }
              return ae && le && !this[ee[29]](ae) || (ae = ce)[ee[30]](), ae;
            }, _e[ee[24]][ee[29]] = function(le) {
              var se = ee[31];
              try {
                if (le[ee[32]](se, se), le[ee[33]](se) !== se)
                  return le[ee[34]](se), !0;
              } catch {
                return !0;
              }
              return le[ee[34]](se), !1;
            }, _e[ee[24]][ee[33]] = function(le) {
              return this[ee[22]][ee[33]](le);
            }, _e[ee[24]][ee[32]] = function(le, se) {
              return this[ee[22]][ee[32]](le, se);
            }, _e[ee[24]][ee[34]] = function(le) {
              return this[ee[22]][ee[34]](le);
            }, _e[ee[24]][ee[30]] = function() {
              return this[ee[22]][ee[30]]();
            }, _e;
          }();
          ie[ee[18]] = he;
        }, 2035: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[35]] = se;
          var ce = ae(77615), he = ae(50199), _e = ae(36629), le = ae(75065);
          function se(be, ve) {
            var me, pe = new ce[ee[36]](ve);
            pe[ee[37]] = le[ee[40]][ee[42]](le[ee[40]][ee[41]](le[ee[40]][ee[39]](be, ee[38])));
            var fe = be[ee[44]](ee[43]);
            if (fe == null)
              pe[ee[45]] = null;
            else if (ee[46] === fe[ee[47]](fe[ee[20]] - 1) && pe[ee[37]] !== -1) {
              var ge = parseInt(fe, 10);
              pe[ee[45]] = pe[ee[37]] * (ge / 100);
            } else
              pe[ee[45]] = le[ee[40]][ee[42]](fe);
            var ye = le[ee[40]][ee[39]](be, ee[48]);
            ye && (pe[ee[49]] = le[ee[40]][ee[41]](le[ee[40]][ee[39]](ye, ee[50])), le[ee[40]][ee[55]](ye, ee[54])[ee[53]](function(Ce) {
              pe[ee[52]][ee[51]](le[ee[40]][ee[41]](Ce));
            }), le[ee[40]][ee[55]](ye, ee[57])[ee[53]](function(Ce) {
              pe[ee[56]][ee[51]](le[ee[40]][ee[41]](Ce));
            }));
            var $e = le[ee[40]][ee[39]](be, ee[58]);
            $e && (pe[ee[59]] = le[ee[40]][ee[41]]($e)), le[ee[40]][ee[55]](be, ee[68])[ee[53]](function(Ce) {
              le[ee[40]][ee[55]](Ce, ee[67])[ee[53]](function(Ie) {
                var Te = Ie[ee[44]](ee[60]), Ee = le[ee[40]][ee[41]](Ie);
                if (Te && Ee) {
                  if (ee[61] === Te) {
                    if (!(me = Ie[ee[44]](ee[62])))
                      return;
                    Te = ee[46] === me[ee[47]](me[ee[20]] - 1) ? ee[64][ee[63]](me) : ee[64][ee[63]](Math[ee[65]](le[ee[40]][ee[42]](me)));
                  }
                  pe[ee[66]][Te] == null && (pe[ee[66]][Te] = []), pe[ee[66]][Te][ee[51]](Ee);
                }
              });
            }), le[ee[40]][ee[55]](be, ee[90])[ee[53]](function(Ce) {
              le[ee[40]][ee[55]](Ce, ee[69])[ee[53]](function(Ie) {
                var Te = new _e[ee[69]]();
                Te[ee[70]] = Ie[ee[44]](ee[70]), Te[ee[71]] = le[ee[40]][ee[41]](Ie), Te[ee[72]] = Ie[ee[44]](ee[73]), Te[ee[74]] = Ie[ee[44]](ee[74]), Te[ee[75]] = Ie[ee[44]](ee[76]), Te[ee[77]] = Ie[ee[44]](ee[77]), Te[ee[78]] = parseInt(Ie[ee[44]](ee[78]) || 0), Te[ee[79]] = parseInt(Ie[ee[44]](ee[79]) || 0), Te[ee[80]] = parseInt(Ie[ee[44]](ee[80]) || 0), Te[ee[81]] = parseInt(Ie[ee[44]](ee[81]) || 0), Te[ee[82]] = parseInt(Ie[ee[44]](ee[82]) || 0);
                var Ee = Ie[ee[44]](ee[83]);
                Ee && ee[84] == typeof Ee && (ee[85] === (Ee = Ee[ee[86]]()) ? Te[ee[83]] = !0 : ee[87] === Ee && (Te[ee[83]] = !1));
                var we = Ie[ee[44]](ee[88]);
                we && ee[84] == typeof we && (ee[85] === (we = we[ee[86]]()) ? Te[ee[88]] = !0 : ee[87] === we && (Te[ee[88]] = !1)), pe[ee[89]][ee[51]](Te);
              });
            });
            var Se = le[ee[40]][ee[39]](be, ee[91]);
            return Se && le[ee[40]][ee[55]](Se, ee[92])[ee[53]](function(Ce) {
              var Ie = new he[ee[92]]();
              Ie[ee[93]] = Ce[ee[44]](ee[93]), Ie[ee[82]] = parseInt(Ce[ee[44]](ee[82]) || 0), Ie[ee[81]] = parseInt(Ce[ee[44]](ee[81]) || 0), Ie[ee[94]] = oe(Ce[ee[44]](ee[94])), Ie[ee[95]] = ue(Ce[ee[44]](ee[95])), Ie[ee[77]] = Ce[ee[44]](ee[77]), Ie[ee[62]] = le[ee[40]][ee[42]](Ce[ee[44]](ee[62])), Ie[ee[37]] = le[ee[40]][ee[42]](Ce[ee[44]](ee[37])), le[ee[40]][ee[55]](Ce, ee[99])[ee[53]](function(Ee) {
                Ie[ee[76]] = Ee[ee[44]](ee[96]) || ee[97], Ie[ee[98]] = le[ee[40]][ee[41]](Ee);
              }), le[ee[40]][ee[55]](Ce, ee[101])[ee[53]](function(Ee) {
                Ie[ee[76]] = Ee[ee[44]](ee[96]) || 0, Ie[ee[100]] = le[ee[40]][ee[41]](Ee);
              }), le[ee[40]][ee[55]](Ce, ee[103])[ee[53]](function(Ee) {
                Ie[ee[76]] = Ee[ee[44]](ee[96]) || 0, Ie[ee[102]] = le[ee[40]][ee[41]](Ee);
              });
              var Te = le[ee[40]][ee[39]](Ce, ee[104]);
              Te && (Ie[ee[105]] = le[ee[40]][ee[41]](le[ee[40]][ee[39]](Te, ee[106])), le[ee[40]][ee[55]](Te, ee[108])[ee[53]](function(Ee) {
                Ie[ee[107]][ee[51]](le[ee[40]][ee[41]](Ee));
              })), Ie[ee[109]] = le[ee[40]][ee[41]](le[ee[40]][ee[39]](Ce, ee[110])), pe[ee[111]][ee[51]](Ie);
            }), pe;
          }
          function oe(be) {
            return [ee[113], ee[114]][ee[112]](be) !== -1 ? be : parseInt(be || 0);
          }
          function ue(be) {
            return [ee[115], ee[116]][ee[112]](be) !== -1 ? be : parseInt(be || 0);
          }
        }, 2860: function(ne, ie) {
          function ae() {
            try {
              var _e = new window[ee[117]]();
              return ee[118] in _e ? _e : null;
            } catch (le) {
              return console[ee[120]](ee[119], le), null;
            }
          }
          function ce() {
            return !!ae();
          }
          function he(_e, le, se) {
            if (ee[121] === window[ee[123]][ee[122]] && _e[ee[112]](ee[124]) === 0)
              return se(new Error(ee[125]));
            try {
              var oe = ae();
              oe[ee[127]](ee[126], _e), oe[ee[128]] = le[ee[128]] || 0, oe[ee[118]] = le[ee[118]] || !1, oe[ee[129]] && oe[ee[129]](ee[130]), oe[ee[131]] = function() {
                oe[ee[132]] === 4 && (oe[ee[133]] === 200 ? se(null, oe[ee[134]]) : se(new Error(ee[136][ee[63]](oe[ee[135]]))));
              }, oe[ee[137]]();
            } catch {
              se(new Error(ee[138]));
            }
          }
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[139]] = void 0, ie[ee[139]] = { get: he, supported: ce };
        }, 3954: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[140]] = void 0;
          var ce = ae(54838), he = ae(91520), _e = ae(16368), le = ae(59972), se = ae(63245), oe = ae(84668), ue = ae(857), be = ae(58431), ve = function() {
            function me() {
            }
            return me[ee[141]] = function(pe) {
              return (0, he[ee[146]][ee[145]](_e[ee[144]][ee[143]])[ee[142]])(pe, { decodeEntities: !1, useArrayRepresentationForChildren: !0 });
            }, me[ee[147]] = function(pe) {
              return (0, he[ee[146]][ee[145]](_e[ee[144]][ee[143]])[ee[148]])(pe);
            }, me[ee[149]] = function(pe) {
              return me[ee[161]](pe[ee[160]][ee[159]])[ee[158]](function(fe) {
                if (fe[ee[151]][ee[150]]) {
                  var ge = me[ee[152]](fe[ee[151]], pe);
                  return Promise[ee[154]]({ adBreakConfigs: ge, downloadTiming: fe[ee[153]] });
                }
                return Promise[ee[157]]({ code: se[ee[156]][ee[155]] });
              });
            }, me[ee[161]] = function(pe) {
              return le[ee[172]][ee[171]](pe)[ee[170]](function() {
                return Promise[ee[157]]({ code: se[ee[156]][ee[169]] });
              })[ee[158]](function(fe) {
                if (!fe[ee[162]])
                  return Promise[ee[157]]({ code: be[ee[164]][ee[163]] });
                try {
                  var ge = me[ee[141]](fe[ee[162]]), ye = ge[ee[165]] ? ge[ee[166]] : {}, $e = { downloadTime: fe[ee[167]], timeToFirstByte: fe[ee[168]] };
                  return Promise[ee[154]]({ manifest: ye, downloadTiming: $e });
                } catch {
                  return Promise[ee[157]]({ code: be[ee[164]][ee[163]] });
                }
              });
            }, me[ee[152]] = function(pe, fe) {
              return me[ee[182]](pe)[ee[181]](function(ge) {
                var ye, $e = { id: ge[ee[70]] || ce[ee[174]][ee[173]](), tag: { url: ge[ee[160]], type: oe[ee[176]][ee[175]] }, position: ge[ee[62]], preloadOffset: (ye = fe[ee[177]]) !== null && ye !== void 0 ? ye : ue[ee[8]] };
                fe[ee[179]](ee[178]) && ($e[ee[178]] = fe[ee[178]]), fe[ee[180]] && ($e[ee[180]] = fe[ee[180]]);
                var Se = { publicAdBreakConfig: $e };
                return ge[ee[66]] && Object[ee[21]](ge[ee[66]])[ee[20]] > 0 && (Se[ee[66]] = ge[ee[66]]), Se;
              }) || [];
            }, me[ee[182]] = function(pe) {
              return pe[ee[150]] ? pe[ee[150]][ee[192]][ee[181]](function(fe) {
                var ge = fe[ee[183]], ye = fe[ee[184]];
                switch (ye) {
                  case ee[185]:
                    ye = ee[10];
                    break;
                  case ee[187]:
                    ye = ee[186];
                }
                var $e = me[ee[188]](fe), Se = [];
                return fe[ee[68]] && fe[ee[68]][0] && fe[ee[68]][0][ee[67]] && fe[ee[68]][0][ee[67]][ee[53]](function(Ce) {
                  var Ie = Ce[ee[190]][ee[189]]();
                  Se[ee[51]]({ type: Ie, url: Ce[ee[191]]() });
                }), { id: ge, offset: ye, tag: $e, trackingEvents: Se };
              }) : [];
            }, me[ee[188]] = function(pe) {
              var fe = !!(pe[ee[193]] && pe[ee[193]][0]), ge = !!(fe && pe[ee[193]][0][ee[194]] && pe[ee[193]][0][ee[194]][0]), ye = !!(fe && pe[ee[193]][0][ee[195]] && pe[ee[193]][0][ee[195]][0]);
              return ge || ye ? ge && pe[ee[193]][0][ee[194]][0][ee[191]] ? pe[ee[193]][0][ee[194]][0][ee[191]]() : ye ? le[ee[172]][ee[196]](me[ee[147]](pe[ee[193]][0][ee[195]][0])) : void 0 : ee[197];
            }, me;
          }();
          ie[ee[140]] = ve;
        }, 5613: function(ne, ie) {
          function ae(_e, le, se) {
            return se[ee[199]](function(oe, ue) {
              var be = Math[ee[198]](_e - oe[ee[81]]) + Math[ee[198]](le - oe[ee[82]]);
              return Math[ee[198]](_e - ue[ee[81]]) + Math[ee[198]](le - ue[ee[82]]) < be ? ue : oe;
            });
          }
          function ce(_e, le) {
            return le[ee[199]](function(se, oe) {
              var ue = he(se), be = he(oe), ve = Math[ee[198]](ue - _e);
              return Math[ee[198]](be - _e) < ve ? oe : se;
            });
          }
          function he(_e) {
            return _e[ee[78]] || (_e[ee[80]] + _e[ee[79]]) / 2;
          }
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[200]] = ae, ie[ee[201]] = ce;
        }, 6036: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[202]] = void 0;
          var ce = ae(1100), he = ae(29902), _e = function() {
            function le(se) {
              se = se || {}, this[ee[203]] = se[ee[203]] || 0, this[ee[204]] = se[ee[204]] || 0, this[ee[205]] = { withCredentials: !1, timeout: 0 }, this[ee[206]] = new he[ee[207]]();
              var oe = se[ee[208]] == null || se[ee[208]];
              this[ee[22]] = se[ee[209]] || new ce[ee[18]](oe), this[ee[210]] === void 0 && (this[ee[210]] = 0), this[ee[211]] === void 0 && (this[ee[211]] = 0), this[ee[212]] === void 0 && (this[ee[212]] = 0);
            }
            return le[ee[24]][ee[213]] = function() {
              return this[ee[206]];
            }, Object[ee[2]](le[ee[24]], ee[210], { get: function() {
              return this[ee[22]][ee[33]](ee[214]);
            }, set: function(se) {
              this[ee[22]][ee[32]](ee[214], se);
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](le[ee[24]], ee[211], { get: function() {
              return this[ee[22]][ee[33]](ee[215]);
            }, set: function(se) {
              this[ee[22]][ee[32]](ee[215], se);
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](le[ee[24]], ee[212], { get: function() {
              return this[ee[22]][ee[33]](ee[216]);
            }, set: function(se) {
              this[ee[22]][ee[32]](ee[216], se);
            }, enumerable: !1, configurable: !0 }), le[ee[24]][ee[217]] = function() {
              return this[ee[206]][ee[218]][ee[20]] > 0;
            }, le[ee[24]][ee[219]] = function(se) {
              return this[ee[206]][ee[220]](se);
            }, le[ee[24]][ee[145]] = function(se, oe) {
              var ue = this;
              oe === void 0 && (oe = {});
              var be = Date[ee[221]]();
              return (oe = Object[ee[223]](this[ee[205]], oe))[ee[179]](ee[222]) || (oe[ee[222]] = !1), this[ee[212]] < be ? (this[ee[211]] = 1, this[ee[212]] = be + 36e5) : this[ee[211]]++, new Promise(function(ve, me) {
                if (ue[ee[203]] >= ue[ee[211]])
                  return me(new Error(ee[225][ee[63]](ue[ee[211]], ee[224])[ee[63]](ue[ee[203]])));
                var pe = be - ue[ee[210]];
                if (pe < 0)
                  ue[ee[210]] = 0;
                else if (pe < ue[ee[204]])
                  return me(new Error(ee[227][ee[63]](ue[ee[204]], ee[226])));
                ue[ee[206]][ee[228]](se, oe)[ee[158]](function(fe) {
                  return ve(fe);
                })[ee[170]](function(fe) {
                  return me(fe);
                });
              });
            }, le;
          }();
          ie[ee[202]] = _e;
        }, 11417: function(ne, ie) {
          function ae(ue, be) {
            ce(ue, be)[ee[53]](function(ve) {
              ee[25] != typeof window && window !== null && (new Image()[ee[229]] = ve);
            });
          }
          function ce(ue, be) {
            be === void 0 && (be = {});
            var ve = [];
            be[ee[230]] && (be[ee[230]] = he(be[ee[230]])), be[ee[231]] && (be[ee[231]] = he(be[ee[231]])), be[ee[232]] && !/^[0-9]{3}$/[ee[233]](be[ee[232]]) && (be[ee[232]] = 900), be[ee[234]] = _e(Math[ee[65]](1e8 * Math[ee[235]]())[ee[191]]()), be[ee[236]] = he((/* @__PURE__ */ new Date())[ee[237]]()), be[ee[238]] = be[ee[235]] = be[ee[234]];
            for (var me = 0, pe = ue; me < pe[ee[20]]; me++) {
              var fe = pe[me];
              if (ee[84] == typeof fe) {
                for (var ge in be) {
                  var ye = be[ge], $e = ee[240][ee[63]](ge, ee[239]), Se = ee[241][ee[63]](ge, ee[241]);
                  fe = (fe = fe[ee[242]]($e, ye))[ee[242]](Se, ye);
                }
                ve[ee[51]](fe);
              }
            }
            return ve;
          }
          function he(ue) {
            return encodeURIComponent(ue)[ee[242]](/[!'()*]/g, function(be) {
              return ee[46][ee[63]](be[ee[243]](0)[ee[191]](16));
            });
          }
          function _e(ue) {
            return ue[ee[20]] < 8 ? le(0, 8 - ue[ee[20]], !1)[ee[181]](function(be) {
              return ee[245];
            })[ee[244]](ee[197]) + ue : ue;
          }
          function le(ue, be, ve) {
            for (var me = [], pe = ue < be, fe = ve ? pe ? be + 1 : be - 1 : be, ge = ue; pe ? ge < fe : ge > fe; pe ? ge++ : ge--)
              me[ee[51]](ge);
            return me;
          }
          function se(ue) {
            return !isNaN(parseFloat(ue)) && isFinite(ue);
          }
          function oe(ue) {
            return ue[ee[199]](function(be, ve) {
              return be[ee[63]](Array[ee[246]](ve) ? oe(ve) : ve);
            }, []);
          }
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[247]] = void 0, ie[ee[247]] = { track: ae, resolveURLTemplates: ce, encodeURIComponentRFC3986: he, leftpad: _e, range: le, isNumeric: se, flatten: oe };
        }, 13769: function(ne, ie) {
          function ae(ce, he, _e) {
            _e(new Error(ee[248]));
          }
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[249]] = void 0, ie[ee[249]] = { get: ae };
        }, 14447: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[250]] = void 0;
          var ae = function() {
            function ce(he) {
              he === void 0 && (he = {}), this[ee[70]] = he[ee[70]] || null, this[ee[251]] = he[ee[251]] || null, this[ee[252]] = he[ee[252]] || null, this[ee[253]] = he[ee[253]] || null, this[ee[77]] = he[ee[77]] || null, this[ee[66]] = {};
            }
            return ce;
          }();
          ie[ee[250]] = ae;
        }, 19637: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[254]] = void 0;
          var ae = function() {
            function ce() {
              this[ee[255]] = null, this[ee[256]] = null, this[ee[257]] = {}, this[ee[258]] = [];
            }
            return ce[ee[24]][ee[259]] = function() {
              return this[ee[256]] === null && Object[ee[21]](this[ee[257]])[ee[20]] === 0 && this[ee[258]][ee[20]] === 0;
            }, ce;
          }();
          ie[ee[254]] = ae;
        }, 25247: function(ne, ie, ae) {
          var ce = this && this[ee[260]] || function() {
            return ce = Object[ee[223]] || function(ge) {
              for (var ye, $e = 1, Se = arguments[ee[20]]; $e < Se; $e++)
                for (var Ce in ye = arguments[$e])
                  Object[ee[24]][ee[179]][ee[261]](ye, Ce) && (ge[Ce] = ye[Ce]);
              return ge;
            }, ce[ee[262]](this, arguments);
          };
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[263]] = void 0;
          var he = ae(62510), _e = ae(15539), le = ae(33696), se = ae(56435), oe = ae(46462), ue = ae(18665), be = ae(25614), ve = ae(3872), me = ae(5772), pe = ae(94583), fe = function() {
            function ge(ye, $e) {
              var Se = this;
              this[ee[264]] = ye, this[ee[265]] = $e, this[ee[266]] = function(Ce) {
                var Ie = Ce[ee[267]];
                Se[ee[269]][ee[268]](function(Te) {
                  return Te[ee[70]] === Ie[ee[70]];
                }) && (Se[ee[265]][ee[270]](Ie[ee[70]]), Se[ee[269]] = Se[ee[269]][ee[271]](function(Te) {
                  return Te[ee[70]] !== Ie[ee[70]];
                }));
              }, this[ee[272]] = function() {
                Se[ee[265]][ee[275]](he[ee[274]][ee[273]], Se[ee[266]]), Se[ee[265]][ee[275]](he[ee[274]][ee[276]], Se[ee[272]]), Se[ee[269]] = [];
              }, this[ee[277]] = null, this[ee[269]] = [], $e[ee[278]](he[ee[274]][ee[273]], this[ee[266]]), $e[ee[278]](he[ee[274]][ee[276]], this[ee[272]]);
            }
            return ge[ee[24]][ee[279]] = function(ye, $e) {
              var Se = this[ee[265]][ee[280]](), Ce = Se ? Se[ee[70]] : null, Ie = (0, pe[ee[286]])({ currentTime: this[ee[265]][ee[282]](_e[ee[281]]), adBreakDuration: ye, replaceContentDuration: $e, resumeLiveContentAtPreviousPosition: this[ee[264]][ee[284]][ee[283]], isLive: this[ee[265]][ee[285]]() });
              this[ee[264]][ee[289]][ee[288]](ee[287], Ie), this[ee[294]]()[ee[293]]((0, be[ee[292]])({ kind: me[ee[291]][ee[290]], position: Ie })), this[ee[277]] = { contentDuration: this[ee[265]][ee[295]](), source: this[ee[265]][ee[296]](), loadOptions: this[ee[265]][ee[297]](), hasEnded: this[ee[265]][ee[298]](), playbackSpeed: this[ee[265]][ee[299]](), subtitles: this[ee[265]][ee[300]]()[ee[181]](function(Te) {
                return ce({}, Te);
              }), audioTrackId: Ce, audioQualityId: this[ee[265]][ee[301]]()[ee[70]], videoQualityId: this[ee[265]][ee[302]]()[ee[70]] };
            }, ge[ee[24]][ee[303]] = function() {
              return this[ee[277]];
            }, ge[ee[24]][ee[304]] = function() {
              return this[ee[277]] != null;
            }, ge[ee[24]][ee[305]] = function() {
              var ye = this, $e = this[ee[277]][ee[306]];
              if ($e != null) {
                var Se = function() {
                  return !!ye[ee[265]][ee[307]]()[ee[268]](function(Ce) {
                    return Ce[ee[70]] === $e;
                  }) && (ye[ee[265]][ee[308]]($e), !0);
                };
                Se() || (this[ee[264]][ee[289]][ee[120]](ee[309], $e), this[ee[311]](Se, he[ee[274]][ee[310]]));
              }
            }, ge[ee[24]][ee[312]] = function() {
              var ye = this, $e = this[ee[277]][ee[316]][ee[181]](function(Se) {
                var Ce = ye[ee[265]][ee[300]]()[ee[268]](function(Ie) {
                  return Ie[ee[70]] === Se[ee[70]];
                });
                return Ce ? !Ce[ee[313]] && Se[ee[313]] ? ye[ee[265]][ee[270]](Se[ee[70]], !1, !1)[ee[158]](function() {
                }) : Promise[ee[154]]() : Se[ee[159]] ? (ye[ee[265]][ee[314]](Se), Promise[ee[154]]()) : (Se[ee[313]] && (ye[ee[264]][ee[289]][ee[120]](ee[315], Se), ye[ee[269]][ee[51]](Se)), Promise[ee[154]]());
              });
              return Promise[ee[317]]($e)[ee[158]](function() {
              });
            }, ge[ee[24]][ee[294]] = function() {
              return this[ee[264]][ee[322]][ee[145]](ue[ee[319]][ee[318]], this[ee[264]][ee[321]][ee[320]]);
            }, ge[ee[24]][ee[323]] = function(ye) {
              var $e, Se, Ce = this, Ie = this[ee[264]][ee[284]][ee[283]] && this[ee[264]][ee[284]][ee[324]], Te = this[ee[264]][ee[322]][ee[145]](ue[ee[319]][ee[325]]), Ee = ($e = Te == null ? void 0 : Te[ee[327]](this[ee[277]][ee[326]])) !== null && $e !== void 0 ? $e : 0;
              if (this[ee[265]][ee[285]]() && !Ie)
                return this[ee[265]][ee[328]](Ee, ye), Promise[ee[154]](!0);
              var we = (0, ve[ee[331]])(this[ee[294]]()[ee[330]]()[ee[329]]), Pe = ((Se = this[ee[264]][ee[332]]) === null || Se === void 0 ? void 0 : Se[ee[295]]()) || this[ee[264]][ee[333]][ee[37]] || this[ee[277]][ee[334]] || we;
              return we >= Pe ? Promise[ee[154]](!1) : this[ee[265]][ee[285]]() && Ee !== 0 && we === 0 ? (this[ee[265]][ee[328]](Ee, ye), Promise[ee[154]](!0)) : new Promise(function(Me) {
                var Ae, Oe = function() {
                  clearTimeout(Ae), Ce[ee[265]][ee[275]](he[ee[274]][ee[335]], Oe), Me(!0);
                };
                Ce[ee[265]][ee[336]](he[ee[274]][ee[335]], Oe), Ce[ee[265]][ee[337]]() === le[ee[339]][ee[338]] && ((0, se[ee[340]])() || (0, se[ee[341]])()) && (Ae = window[ee[342]](Oe, 5e3)), Ce[ee[265]][ee[343]](we, ye) || Oe();
              });
            }, ge[ee[24]][ee[344]] = function(ye) {
              var $e = this;
              return this[ee[304]]() ? Promise[ee[154]]()[ee[158]](function() {
                return $e[ee[265]][ee[356]]($e[ee[277]][ee[326]], $e[ee[277]][ee[354]][ee[353]], $e[ee[277]][ee[354]][ee[355]], ye);
              })[ee[158]](function() {
                $e[ee[265]][ee[348]]($e[ee[277]][ee[347]]), $e[ee[305]](), $e[ee[265]][ee[350]]($e[ee[277]][ee[349]]), $e[ee[265]][ee[352]]($e[ee[277]][ee[351]]);
              })[ee[158]](function() {
                return $e[ee[323]](ye);
              })[ee[158]](function(Se) {
                return $e[ee[312]](), $e[ee[294]]()[ee[293]]((0, be[ee[346]])({ kind: me[ee[291]][ee[345]] })), $e[ee[30]](), Se;
              }) : Promise[ee[157]](ee[357]);
            }, ge[ee[24]][ee[30]] = function() {
              this[ee[277]] = null;
            }, ge[ee[24]][ee[311]] = function(ye, $e, Se, Ce) {
              var Ie, Te, Ee = this;
              Ce === void 0 && (Ce = 2e3);
              var we = function() {
                var Me;
                clearTimeout(Te), Ee[ee[265]][ee[275]]($e, Pe), Ee[ee[265]][ee[275]](he[ee[274]][ee[276]], we), Se ? Ee[ee[265]][ee[275]](Se, we) : (Me = Ee[ee[264]][ee[333]]) === null || Me === void 0 || Me[ee[360]](oe[ee[359]][ee[358]], we);
              }, Pe = function(Me) {
                ye(Me) && we();
              };
              Se ? this[ee[265]][ee[336]](Se, we) : (Ie = this[ee[264]][ee[333]]) === null || Ie === void 0 || Ie[ee[361]](oe[ee[359]][ee[358]], we), this[ee[265]][ee[336]]($e, Pe), this[ee[265]][ee[336]](he[ee[274]][ee[276]], we), Te = setTimeout(we, Ce);
            }, ge;
          }();
          ie[ee[263]] = fe;
        }, 26580: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[362]] = ie[ee[363]] = void 0;
          var ce = ae(25550), he = ae(62510), _e = ae(15539), le = ae(38255), se = ae(79814), oe = ae(857), ue = ae(48513);
          ie[ee[363]] = 1;
          var be = function() {
            function fe() {
            }
            return fe[ee[364]] = function(ge, ye) {
              var $e, Se = new le[ee[365]](), Ce = !1, Ie = !1, Te = [he[ee[274]][ee[366]], he[ee[274]][ee[367]]], Ee = function() {
                if (Ie)
                  throw ee[368];
              };
              return new (function() {
                function we() {
                  this[ee[369]] = function(Pe) {
                    return !ge[ee[370]]() || !Te[ee[371]](Pe);
                  };
                }
                return we[ee[24]][ee[372]] = function() {
                  Ee();
                  var Pe = Promise[ee[154]]();
                  return Ce ? Pe = ge[ee[373]](_e[ee[281]]) : ge[ee[298]]() ? ve(ge, $e) : me(ge, $e), $e = null, Se[ee[374]](function(Me, Ae) {
                    ge[ee[275]](Me, Ae);
                  }), ye(), Ie = !0, Pe;
                }, we[ee[24]][ee[278]] = function(Pe, Me) {
                  Ee(), Se[ee[375]](Pe, Me), ge[ee[336]](Pe, Me);
                }, we[ee[24]][ee[376]] = function() {
                  Ee(), ge[ee[376]](_e[ee[281]]);
                }, we[ee[24]][ee[377]] = function() {
                  return Ee(), ge[ee[377]](_e[ee[281]]);
                }, we[ee[24]][ee[356]] = function(Pe) {
                  var Me = this;
                  return Ee(), $e = Pe, ge[ee[378]](this[ee[369]]), Ce = !0, ge[ee[356]](pe(Pe), null, !0, _e[ee[281]])[ee[158]](function() {
                    return ge[ee[348]](ie[ee[363]]);
                  })[ee[158]](function() {
                    return ge[ee[377]](_e[ee[281]])[ee[170]](function() {
                    });
                  })[ee[158]](function() {
                    return ge[ee[386]](he[ee[274]][ee[385]], { ad: Pe });
                  })[ee[170]](function(Ae) {
                    throw Ae && Ae[ee[381]] === ce[ee[383]][ee[382]] ? { code: ue[ee[156]][ee[384]], message: Ae[ee[19]][ee[255]] } : Ae;
                  })[ee[380]](function() {
                    ge[ee[379]](Me[ee[369]]), Ce = !1;
                  });
                }, Object[ee[2]](we[ee[24]], ee[37], { get: function() {
                  return Ee(), ge[ee[295]](_e[ee[281]]);
                }, enumerable: !1, configurable: !0 }), Object[ee[2]](we[ee[24]], ee[387], { get: function() {
                  return Ee(), ge[ee[282]](_e[ee[281]]);
                }, enumerable: !1, configurable: !0 }), Object[ee[2]](we[ee[24]], ee[388], { get: function() {
                  return Ee(), ge[ee[389]]();
                }, enumerable: !1, configurable: !0 }), Object[ee[2]](we[ee[24]], ee[390], { get: function() {
                  return Ee(), ge[ee[391]]();
                }, enumerable: !1, configurable: !0 }), Object[ee[2]](we[ee[24]], ee[392], { get: function() {
                  Ee();
                  var Pe = ge[ee[393]](), Me = ge[ee[394]]();
                  return Pe === !1 && Me === !1 || Pe;
                }, enumerable: !1, configurable: !0 }), we;
              }())();
            }, fe;
          }();
          function ve(fe, ge) {
            fe[ee[386]](he[ee[274]][ee[395]], { ad: ge });
          }
          function me(fe, ge) {
            fe[ee[386]](he[ee[274]][ee[396]], { ad: ge });
          }
          function pe(fe) {
            return fe[ee[19]][ee[73]] === oe[ee[4]][ee[14]] ? se[ee[398]][ee[397]](fe[ee[19]][ee[75]]) ? { dash: fe[ee[399]] } : { hls: fe[ee[399]] } : { progressive: fe[ee[399]] };
          }
          ie[ee[362]] = be;
        }, 27294: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[400]] = void 0;
          var ce = ae(82664), he = ae(13769), _e = ae(2860);
          function le(se, oe, ue) {
            return ue || (ee[401] == typeof oe && (ue = oe), oe = {}), ee[25] == typeof window || window === null ? he[ee[249]][ee[145]](se, oe, ue) : _e[ee[139]][ee[402]]() ? _e[ee[139]][ee[145]](se, oe, ue) : ce[ee[403]][ee[402]]() ? ce[ee[403]][ee[145]](se, oe, ue) : ue(new Error(ee[404]));
          }
          ie[ee[400]] = { get: le };
        }, 29173: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[405]] = void 0;
          var ce = ae(62510), he = ae(15539), _e = ae(38255), le = function() {
            function se(oe, ue) {
              var be = this, ve = new _e[ee[365]]();
              this[ee[333]] = oe[ee[406]]();
              var me = !1, pe = function() {
                if (me)
                  throw ee[407];
              }, fe = this[ee[333]][ee[361]];
              this[ee[333]][ee[361]] = function(ge, ye, $e) {
                ve[ee[375]](ge, ye), fe[ee[262]](be[ee[333]], [ge, ye, $e]);
              }, this[ee[408]] = function(ge) {
                if (pe(), be[ee[409]])
                  throw ee[410];
                be[ee[409]] = ge, be[ee[411]] = !1, oe[ee[370]]() || oe[ee[386]](ce[ee[274]][ee[367]], { time: oe[ee[282]](), issuer: he[ee[281]] }), oe[ee[386]](ce[ee[274]][ee[385]], { ad: ge });
              }, this[ee[392]] = function(ge) {
                pe(), oe[ee[386]](ce[ee[274]][ee[412]], { time: ge, issuer: he[ee[281]] });
              }, this[ee[413]] = function(ge) {
                pe(), oe[ee[386]](ce[ee[274]][ee[366]], { time: ge, issuer: he[ee[281]] }), oe[ee[386]](ce[ee[274]][ee[367]], { time: ge, issuer: he[ee[281]] });
              }, this[ee[414]] = function(ge) {
                pe(), oe[ee[386]](ce[ee[274]][ee[415]], { time: ge, issuer: he[ee[281]] });
              }, this[ee[416]] = function() {
                be[ee[411]] || (pe(), oe[ee[386]](ce[ee[274]][ee[396]], { ad: be[ee[409]] }), be[ee[411]] = !0, be[ee[409]] = null);
              }, this[ee[372]] = function() {
                return pe(), ve[ee[374]](function(ge, ye) {
                  be[ee[333]][ee[360]](ge, ye), be[ee[333]][ee[361]] = fe;
                }), !be[ee[411]] && be[ee[409]] && oe[ee[386]](ce[ee[274]][ee[395]], { ad: be[ee[409]] }), be[ee[409]] = null, ue(), me = !0, Promise[ee[154]]();
              };
            }
            return se;
          }();
          ie[ee[405]] = le;
        }, 29902: function(ne, ie, ae) {
          var ce = this && this[ee[417]] || function() {
            var fe = function(ge, ye) {
              return fe = Object[ee[418]] || { __proto__: [] } instanceof Array && function($e, Se) {
                $e[ee[419]] = Se;
              } || function($e, Se) {
                for (var Ce in Se)
                  Object[ee[24]][ee[179]][ee[261]](Se, Ce) && ($e[Ce] = Se[Ce]);
              }, fe(ge, ye);
            };
            return function(ge, ye) {
              if (ee[401] != typeof ye && ye !== null)
                throw new TypeError(ee[420] + String(ye) + ee[421]);
              function $e() {
                this[ee[422]] = ge;
              }
              fe(ge, ye), ge[ee[24]] = ye === null ? Object[ee[423]](ye) : ($e[ee[24]] = ye[ee[24]], new $e());
            };
          }(), he = this && this[ee[424]] || function(fe, ge, ye) {
            if (ye || arguments[ee[20]] === 2)
              for (var $e, Se = 0, Ce = ge[ee[20]]; Se < Ce; Se++)
                !$e && Se in ge || ($e || ($e = Array[ee[24]][ee[425]][ee[261]](ge, 0, Se)), $e[Se] = ge[Se]);
            return fe[ee[63]]($e || Array[ee[24]][ee[425]][ee[261]](ge));
          };
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[207]] = void 0;
          var _e = ae(71119), le = ae(37007), se = ae(75065), oe = ae(27294), ue = ae(11417), be = ae(71076), ve = 10, me = { ERRORCODE: 900, extensions: [] }, pe = function(fe) {
            function ge() {
              var ye = fe[ee[261]](this) || this;
              return ye[ee[218]] = [], ye[ee[427]] = [], ye[ee[428]] = [], ye[ee[429]] = [], ye[ee[430]] = null, ye[ee[431]] = [], ye[ee[432]] = {}, ye[ee[433]] = null, ye;
            }
            return ce(ge, fe), ge[ee[24]][ee[434]] = function(ye) {
              ee[401] == typeof ye && this[ee[431]][ee[51]](ye);
            }, ge[ee[24]][ee[435]] = function() {
              this[ee[431]][ee[436]]();
            }, ge[ee[24]][ee[437]] = function() {
              return this[ee[431]][ee[20]];
            }, ge[ee[24]][ee[438]] = function() {
              this[ee[431]] = [];
            }, ge[ee[24]][ee[439]] = function(ye, $e) {
              for (var Se = [], Ce = 2; Ce < arguments[ee[20]]; Ce++)
                Se[Ce - 2] = arguments[Ce];
              this[ee[441]](ee[440], Object[ee[223]][ee[262]](Object, he([me, $e], Se, !1))), ue[ee[247]][ee[442]](ye, $e);
            }, ge[ee[24]][ee[443]] = function() {
              return this[ee[429]][ee[63]](this[ee[428]]);
            }, ge[ee[24]][ee[444]] = function(ye, $e, Se) {
              var Ce = this;
              return new Promise(function(Ie, Te) {
                Ce[ee[431]][ee[53]](function(Ee) {
                  ye = Ee(ye);
                }), Ce[ee[427]][ee[51]](ye), Ce[ee[441]](ee[445], { url: ye, wrapperDepth: $e, originalUrl: Se }), Ce[ee[400]][ee[145]](ye, Ce[ee[432]], function(Ee, we) {
                  Ce[ee[441]](ee[446], { url: ye, error: Ee }), Ee ? Te(Ee) : Ie(we);
                });
              });
            }, ge[ee[24]][ee[447]] = function(ye) {
              ye === void 0 && (ye = {}), this[ee[448]] = ee[197], this[ee[218]] = [], this[ee[427]] = [], this[ee[428]] = [], this[ee[429]] = [], this[ee[430]] = ye[ee[449]] || ve, this[ee[432]] = { timeout: ye[ee[128]], withCredentials: ye[ee[118]] }, this[ee[400]] = ye[ee[450]] || oe[ee[400]];
            }, ge[ee[24]][ee[220]] = function(ye) {
              var $e = this;
              if (this[ee[218]][ee[20]] === 0)
                return Promise[ee[157]](new Error(ee[451]));
              var Se = ye ? ue[ee[247]][ee[452]](this[ee[218]]) : this[ee[218]][ee[453]]();
              return this[ee[428]] = [], this[ee[427]] = [], this[ee[455]](Se, { wrapperDepth: 0, originalUrl: this[ee[448]] })[ee[158]](function(Ce) {
                return $e[ee[454]](Ce);
              });
            }, ge[ee[24]][ee[228]] = function(ye, $e) {
              var Se = this;
              return $e === void 0 && ($e = {}), this[ee[447]]($e), this[ee[448]] = ye, this[ee[444]](ye)[ee[158]](function(Ce) {
                return $e[ee[456]] = ye, $e[ee[457]] = !0, Se[ee[458]](Ce, $e)[ee[158]](function(Ie) {
                  return Se[ee[454]](Ie, $e);
                });
              });
            }, ge[ee[24]][ee[459]] = function(ye, $e) {
              var Se = this;
              return $e === void 0 && ($e = {}), this[ee[447]]($e), $e[ee[457]] = !0, this[ee[458]](ye, $e)[ee[158]](function(Ce) {
                return Se[ee[454]](Ce, $e);
              });
            }, ge[ee[24]][ee[460]] = function(ye) {
              return ye[ee[271]](function($e) {
                return $e[ee[253]] != null;
              });
            }, ge[ee[24]][ee[461]] = function(ye) {
              return ye[ee[271]](function($e) {
                return $e[ee[253]] == null;
              });
            }, ge[ee[24]][ee[462]] = function(ye) {
              return !(!ye || ye[ee[463]] != null) && (Array[ee[246]](ye[ee[465]]) ? ye[ee[465]] : [])[ee[464]](function($e) {
                return $e[ee[89]] && $e[ee[89]][ee[20]] > 0;
              });
            }, ge[ee[24]][ee[466]] = function(ye) {
              var $e = this, Se = this[ee[460]](ye), Ce = this[ee[461]](ye)[ee[271]](this[ee[462]]);
              return Se[ee[20]] === 0 || Ce[ee[20]] === 0 ? ye : (Se = Se[ee[181]](function(Ie) {
                return $e[ee[462]](Ie) ? Ie : Ce[ee[453]]();
              })[ee[271]](Boolean), Ce[ee[53]](function(Ie) {
                return Ie[ee[467]] = !0;
              }), Se[ee[63]](Ce));
            }, ge[ee[24]][ee[468]] = function(ye) {
              return this[ee[460]](ye)[ee[20]] > 0 && this[ee[461]](ye)[ee[53]](function($e) {
                return $e[ee[467]] = !0;
              }), ye;
            }, ge[ee[24]][ee[454]] = function(ye, $e) {
              $e === void 0 && ($e = {});
              var Se = new be[ee[469]]();
              return Se[ee[428]] = this[ee[443]](), ye[ee[53]](function(Ce) {
                return Ce[ee[467]] = !1;
              }), Se[ee[470]] = $e[ee[466]] ? this[ee[466]](ye) : this[ee[468]](ye), this[ee[471]](Se), Se;
            }, ge[ee[24]][ee[458]] = function(ye, $e) {
              var Se = this, Ce = $e[ee[222]], Ie = Ce === void 0 || Ce, Te = $e[ee[472]], Ee = Te === void 0 ? null : Te, we = $e[ee[456]], Pe = we === void 0 ? null : we, Me = $e[ee[473]], Ae = Me === void 0 ? 0 : Me, Oe = $e[ee[457]], Be = Oe !== void 0 && Oe, Ve = $e[ee[474]], Ue = Ve === void 0 ? null : Ve;
              if (!ye || !ye[ee[475]] || ee[175] !== ye[ee[475]][ee[476]])
                return Promise[ee[157]](new Error(ee[477]));
              var Re = [], Ne = ye[ee[475]][ee[478]];
              for (var xe in Ne) {
                var ke = Ne[xe];
                if (ee[479] === ke[ee[476]]) {
                  var Le = se[ee[40]][ee[41]](ke);
                  Be ? this[ee[429]][ee[51]](Le) : this[ee[428]][ee[51]](Le);
                }
                if (ee[480] === ke[ee[476]]) {
                  var He = (0, _e[ee[481]])(ke);
                  He ? Re[ee[51]](He) : this[ee[439]](this[ee[443]](), { ERRORCODE: 101 });
                }
              }
              var We = Re[ee[20]], Xe = Re[We - 1];
              return We === 1 && Ee != null && Xe && !Xe[ee[253]] && (Xe[ee[253]] = Ee), Re[ee[53]](function(Qe) {
                return Se[ee[482]](Qe, Ue);
              }), Ie === !1 && (this[ee[218]] = se[ee[40]][ee[483]](Re), Re = this[ee[218]][ee[453]]()), this[ee[455]](Re, { wrapperDepth: Ae, originalUrl: Pe });
            }, ge[ee[24]][ee[482]] = function(ye, $e) {
              ye[ee[253]] == null ? ye[ee[484]] = $e || this[ee[433]] : this[ee[433]] = ye[ee[253]];
            }, ge[ee[24]][ee[455]] = function(ye, $e) {
              var Se = this;
              ye === void 0 && (ye = []);
              var Ce = $e[ee[473]], Ie = $e[ee[456]], Te = [];
              return ye[ee[53]](function(Ee) {
                var we = Se[ee[485]](Ee, Ce, Ie);
                Te[ee[51]](we);
              }), Promise[ee[317]](Te)[ee[158]](function(Ee) {
                var we = ue[ee[247]][ee[452]](Ee);
                if (!we && Se[ee[218]][ee[20]] > 0) {
                  var Pe = Se[ee[218]][ee[453]]();
                  return Se[ee[455]](Pe, { wrapperDepth: Ce, originalUrl: Ie });
                }
                return we;
              });
            }, ge[ee[24]][ee[485]] = function(ye, $e, Se) {
              var Ce = this;
              return new Promise(function(Ie) {
                if ($e++, !ye[ee[486]])
                  return delete ye[ee[486]], Ie(ye);
                if ($e >= Ce[ee[430]] || Ce[ee[427]][ee[112]](ye[ee[486]]) !== -1)
                  return ye[ee[463]] = 302, delete ye[ee[486]], Ie(ye);
                ye[ee[486]] = se[ee[40]][ee[487]](ye[ee[486]], Se);
                var Te = ye[ee[253]];
                Se = ye[ee[486]], Ce[ee[444]](ye[ee[486]], $e, Se)[ee[158]](function(Ee) {
                  return Ce[ee[458]](Ee, { originalUrl: Se, wrapperSequence: Te, wrapperDepth: $e, parentAdSequence: ye[ee[253]] || ye[ee[484]] })[ee[158]](function(we) {
                    if (delete ye[ee[486]], we[ee[20]] === 0)
                      return ye[ee[465]] = [], Ie(ye);
                    we[ee[53]](function(Pe) {
                      Pe && se[ee[40]][ee[490]](Pe, ye);
                    }), Ie(we);
                  });
                })[ee[170]](function(Ee) {
                  ye[ee[463]] = 301, ye[ee[488]] = Ee[ee[489]], Ie(ye);
                });
              });
            }, ge[ee[24]][ee[471]] = function(ye) {
              if (ye[ee[470]][ee[20]] === 0)
                this[ee[439]](ye[ee[428]], { ERRORCODE: 303 });
              else
                for (var $e = ye[ee[470]][ee[20]] - 1; $e >= 0; $e--) {
                  var Se = ye[ee[470]][$e];
                  (Se[ee[463]] || Se[ee[465]][ee[20]] === 0) && (this[ee[439]](Se[ee[428]][ee[63]](ye[ee[428]]), { ERRORCODE: Se[ee[463]] || 303 }, { ERRORMESSAGE: Se[ee[488]] || ee[197] }, { extensions: Se[ee[491]] }, { system: Se[ee[492]] }), ye[ee[470]][ee[493]]($e, 1));
                }
            }, ge;
          }(le[ee[426]]);
          ie[ee[207]] = pe;
        }, 31472: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[494]] = void 0;
          var ae = function() {
            function ce() {
              this[ee[70]] = null, this[ee[81]] = 0, this[ee[82]] = 0, this[ee[76]] = null, this[ee[102]] = null, this[ee[98]] = null, this[ee[100]] = null, this[ee[495]] = null, this[ee[496]] = null, this[ee[497]] = [], this[ee[66]] = {};
            }
            return ce;
          }();
          ie[ee[494]] = ae;
        }, 35475: function(ne, ie, ae) {
          var ce = this && this[ee[417]] || function() {
            var _e = function(le, se) {
              return _e = Object[ee[418]] || { __proto__: [] } instanceof Array && function(oe, ue) {
                oe[ee[419]] = ue;
              } || function(oe, ue) {
                for (var be in ue)
                  Object[ee[24]][ee[179]][ee[261]](ue, be) && (oe[be] = ue[be]);
              }, _e(le, se);
            };
            return function(le, se) {
              if (ee[401] != typeof se && se !== null)
                throw new TypeError(ee[420] + String(se) + ee[421]);
              function oe() {
                this[ee[422]] = le;
              }
              _e(le, se), le[ee[24]] = se === null ? Object[ee[423]](se) : (oe[ee[24]] = se[ee[24]], new oe());
            };
          }();
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[498]] = void 0;
          var he = function(_e) {
            function le(se) {
              se === void 0 && (se = {});
              var oe = _e[ee[261]](this, se) || this;
              return oe[ee[76]] = ee[499], oe[ee[500]] = [], oe;
            }
            return ce(le, _e), le;
          }(ae(14447)[ee[250]]);
          ie[ee[498]] = he;
        }, 36629: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[69]] = void 0;
          var ae = function() {
            function ce() {
              this[ee[70]] = null, this[ee[71]] = null, this[ee[72]] = ee[13], this[ee[75]] = null, this[ee[74]] = null, this[ee[78]] = 0, this[ee[79]] = 0, this[ee[80]] = 0, this[ee[81]] = 0, this[ee[82]] = 0, this[ee[77]] = null, this[ee[83]] = null, this[ee[88]] = null;
            }
            return ce;
          }();
          ie[ee[69]] = ae;
        }, 42512: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[501]] = void 0;
          var ae = function() {
            function ce(he, _e) {
              this[ee[502]] = he, this[ee[503]] = _e;
            }
            return ce;
          }();
          ie[ee[501]] = ae;
        }, 48513: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[164]] = ie[ee[156]] = ie[ee[176]] = ie[ee[504]] = void 0;
          var ce = ae(16368), he = ae(97731), _e = ae(92284), le = ae(63245);
          Object[ee[2]](ie, ee[156], { enumerable: !0, get: function() {
            return le[ee[156]];
          } });
          var se = ae(84668);
          Object[ee[2]](ie, ee[176], { enumerable: !0, get: function() {
            return se[ee[176]];
          } });
          var oe = ae(58431);
          Object[ee[2]](ie, ee[164], { enumerable: !0, get: function() {
            return oe[ee[164]];
          } }), ie[ee[504]] = { name: ce[ee[144]][ee[505]], module: function() {
            return { AdvertisingController: _e[ee[506]], AdPlayerDelegate: he[ee[507]] };
          }, dependencies: [ce[ee[144]][ee[143]]], exports: { AdTagType: se[ee[176]], AdvertisingModuleErrorCode: le[ee[156]], VastErrorCode: oe[ee[164]] } }, ie[ee[508]] = ie[ee[504]];
        }, 50199: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[92]] = void 0;
          var ae = function() {
            function ce() {
              this[ee[93]] = null, this[ee[82]] = 0, this[ee[81]] = 0, this[ee[94]] = 0, this[ee[95]] = 0, this[ee[77]] = null, this[ee[62]] = null, this[ee[37]] = 0, this[ee[76]] = null, this[ee[102]] = null, this[ee[98]] = null, this[ee[100]] = null, this[ee[105]] = null, this[ee[107]] = [], this[ee[109]] = null;
            }
            return ce;
          }();
          ie[ee[92]] = ae;
        }, 53354: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[509]] = void 0;
          var ce = ae(6036), he = ae(857), _e = ae(58431), le = function() {
            function se(oe, ue, be) {
              this[ee[510]] = new ce[ee[202]]({ allowUsingBrowserStorageApi: !be }), this[ee[510]][ee[206]][ee[447]](), this[ee[511]] = oe || he[ee[6]], this[ee[118]] = ue;
            }
            return se[ee[24]][ee[512]] = function(oe, ue) {
              var be = this, ve = [], me = function(pe) {
                ve[ee[51]]({ code: pe[ee[232]] });
              };
              return this[ee[510]][ee[206]][ee[513]](ee[440], me), this[ee[510]][ee[206]][ee[459]](oe, { timeout: this[ee[511]], withCredentials: this[ee[118]], replaceUnavailableAdPodAds: !ue })[ee[170]](function(pe) {
                return be[ee[510]][ee[206]][ee[514]](ee[440], me), Promise[ee[157]]({ code: pe && pe[ee[232]] || _e[ee[164]][ee[515]] });
              })[ee[158]](function(pe) {
                var fe;
                return be[ee[510]][ee[206]][ee[514]](ee[440], me), ((fe = pe[ee[470]]) === null || fe === void 0 ? void 0 : fe[ee[20]]) > 0 ? pe : ve[ee[20]] > 0 ? Promise[ee[157]](ve[0]) : Promise[ee[157]]({ code: _e[ee[164]][ee[515]] });
              });
            }, se;
          }();
          ie[ee[509]] = le;
        }, 57219: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[516]] = void 0;
          var ae = function() {
            function ce() {
              this[ee[70]] = null, this[ee[81]] = 0, this[ee[82]] = 0, this[ee[517]] = 0, this[ee[518]] = 0, this[ee[83]] = !0, this[ee[88]] = !0, this[ee[519]] = 0, this[ee[77]] = ee[520], this[ee[76]] = null, this[ee[102]] = null, this[ee[98]] = null, this[ee[100]] = null, this[ee[521]] = null, this[ee[522]] = [], this[ee[59]] = null;
            }
            return ce;
          }();
          ie[ee[516]] = ae;
        }, 58431: function(ne, ie) {
          var ae;
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[164]] = void 0, function(ce) {
            ce[ce[ee[163]] = 100] = ee[163], ce[ce[ee[523]] = 101] = ee[523], ce[ce[ee[524]] = 102] = ee[524], ce[ce[ee[525]] = 200] = ee[525], ce[ce[ee[526]] = 201] = ee[526], ce[ce[ee[527]] = 202] = ee[527], ce[ce[ee[528]] = 203] = ee[528], ce[ce[ee[529]] = 300] = ee[529], ce[ce[ee[530]] = 301] = ee[530], ce[ce[ee[531]] = 302] = ee[531], ce[ce[ee[532]] = 303] = ee[532], ce[ce[ee[533]] = 400] = ee[533], ce[ce[ee[534]] = 401] = ee[534], ce[ce[ee[535]] = 402] = ee[535], ce[ce[ee[536]] = 403] = ee[536], ce[ce[ee[537]] = 405] = ee[537], ce[ce[ee[538]] = 500] = ee[538], ce[ce[ee[539]] = 501] = ee[539], ce[ce[ee[540]] = 502] = ee[540], ce[ce[ee[541]] = 503] = ee[541], ce[ce[ee[542]] = 600] = ee[542], ce[ce[ee[543]] = 601] = ee[543], ce[ce[ee[544]] = 602] = ee[544], ce[ce[ee[545]] = 603] = ee[545], ce[ce[ee[546]] = 604] = ee[546], ce[ce[ee[515]] = 900] = ee[515], ce[ce[ee[547]] = 901] = ee[547];
          }(ae || (ie[ee[164]] = ae = {}));
        }, 59972: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[172]] = void 0, ie[ee[548]] = ue;
          var ce = ae(54838), he = ae(63245), _e = ae(53354), le = ae(58431), se = function() {
            function be() {
            }
            return be[ee[549]] = function(ve) {
              be[ee[550]] = ve;
            }, be[ee[551]] = function(ve) {
              be[ee[511]] = ve;
            }, be[ee[552]] = function(ve) {
              be[ee[118]] = ve;
            }, be[ee[553]] = function(ve) {
              be[ee[554]] = ve;
            }, be[ee[555]] = function(ve) {
              return be[ee[556]] || (be[ee[556]] = new DOMParser()), be[ee[550]][ee[356]](ve, void 0, void 0, void 0, void 0, be[ee[118]])[ee[170]](function() {
                return Promise[ee[157]]({ code: he[ee[156]][ee[169]] });
              })[ee[158]](function(me) {
                var pe;
                if (!me[ee[162]])
                  return Promise[ee[157]]({ code: le[ee[164]][ee[163]] });
                var fe = be[ee[556]][ee[557]](me[ee[162]], ee[130]), ge = (pe = fe[ee[478]][0][ee[478]][0]) === null || pe === void 0 ? void 0 : pe[ee[476]][ee[371]](ee[479]), ye = ge === void 0 || ge, $e = fe[ee[478]][0][ee[476]][ee[371]](ee[558]);
                if (fe[ee[478]][0][ee[476]][ee[371]](ee[150]))
                  return Promise[ee[157]]({ code: he[ee[156]][ee[155]] });
                if (ye)
                  return Promise[ee[157]]({ code: le[ee[164]][ee[532]] });
                if ($e)
                  return Promise[ee[157]]({ code: le[ee[164]][ee[163]] });
                var Se = { downloadTime: me[ee[167]], timeToFirstByte: me[ee[168]] };
                return Promise[ee[154]]({ manifest: fe, downloadTiming: Se });
              });
            }, be[ee[171]] = function(ve) {
              return be[ee[550]][ee[356]](ve, void 0, void 0, void 0, void 0, be[ee[118]]);
            }, be[ee[559]] = function(ve) {
              return be[ee[560]] || (be[ee[560]] = new _e[ee[509]](be[ee[511]], be[ee[118]], be[ee[554]])), be[ee[560]][ee[512]](ve, !1)[ee[158]](function(me) {
                if (me[ee[470]][ee[20]] < 1)
                  return Promise[ee[154]]([]);
                var pe = me[ee[470]][ee[181]](function(fe) {
                  return { id: fe[ee[70]] || ee[561] + ce[ee[174]][ee[173]](), verifications: fe[ee[562]] };
                });
                return Promise[ee[154]](pe);
              })[ee[170]](function(me) {
                return Promise[ee[154]]([]);
              });
            }, be[ee[563]] = function(ve) {
              return new XMLSerializer()[ee[564]](ve[ee[475]]);
            }, be[ee[196]] = function(ve) {
              return ee[565] + encodeURIComponent(ve);
            }, be;
          }();
          function oe(be) {
            new Image()[ee[229]] = be;
          }
          function ue(be, ve) {
            be === void 0 && (be = []), be[ee[271]](function(me) {
              return me[ee[76]] === ve;
            })[ee[53]](function(me) {
              return oe(me[ee[159]]);
            });
          }
          ie[ee[172]] = se;
        }, 63207: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[480]] = void 0;
          var ae = function() {
            function ce() {
              this[ee[70]] = null, this[ee[566]] = [], this[ee[253]] = null, this[ee[492]] = null, this[ee[567]] = null, this[ee[568]] = null, this[ee[569]] = null, this[ee[570]] = null, this[ee[571]] = null, this[ee[428]] = [], this[ee[572]] = [], this[ee[465]] = [], this[ee[491]] = [], this[ee[562]] = [];
            }
            return ce;
          }();
          ie[ee[480]] = ae;
        }, 63245: function(ne, ie) {
          var ae;
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[156]] = void 0, function(ce) {
            ce[ce[ee[155]] = 110] = ee[155], ce[ce[ee[169]] = 404] = ee[169], ce[ce[ee[384]] = 2e3] = ee[384];
          }(ae || (ie[ee[156]] = ae = {}));
        }, 64815: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[573]] = le;
          var ce = ae(35475), he = ae(57219), _e = ae(75065);
          function le(se, oe) {
            var ue = new ce[ee[498]](oe);
            return _e[ee[40]][ee[55]](se, ee[68])[ee[53]](function(be) {
              var ve, me;
              _e[ee[40]][ee[55]](be, ee[67])[ee[53]](function(pe) {
                ve = pe[ee[44]](ee[60]), me = _e[ee[40]][ee[41]](pe), ve && me && (ue[ee[66]][ve] == null && (ue[ee[66]][ve] = []), ue[ee[66]][ve][ee[51]](me));
              });
            }), _e[ee[40]][ee[55]](se, ee[577])[ee[53]](function(be) {
              var ve = new he[ee[516]]();
              ve[ee[70]] = be[ee[44]](ee[70]) || null, ve[ee[81]] = be[ee[44]](ee[81]), ve[ee[82]] = be[ee[44]](ee[82]), ve[ee[517]] = be[ee[44]](ee[517]), ve[ee[518]] = be[ee[44]](ee[518]), ve[ee[83]] = _e[ee[40]][ee[574]](be[ee[44]](ee[83])), ve[ee[88]] = _e[ee[40]][ee[574]](be[ee[44]](ee[88])), ve[ee[519]] = _e[ee[40]][ee[42]](be[ee[44]](ee[519])), ve[ee[77]] = be[ee[44]](ee[77]), _e[ee[40]][ee[55]](be, ee[99])[ee[53]](function(pe) {
                ve[ee[76]] = pe[ee[44]](ee[96]) || ee[97], ve[ee[98]] = _e[ee[40]][ee[41]](pe);
              }), _e[ee[40]][ee[55]](be, ee[101])[ee[53]](function(pe) {
                ve[ee[76]] = pe[ee[44]](ee[96]) || 0, ve[ee[100]] = _e[ee[40]][ee[41]](pe);
              }), _e[ee[40]][ee[55]](be, ee[103])[ee[53]](function(pe) {
                ve[ee[76]] = pe[ee[44]](ee[96]) || 0, ve[ee[102]] = _e[ee[40]][ee[41]](pe);
              });
              var me = _e[ee[40]][ee[39]](be, ee[58]);
              me && (ve[ee[59]] = _e[ee[40]][ee[41]](me)), ve[ee[521]] = _e[ee[40]][ee[41]](_e[ee[40]][ee[39]](be, ee[575])), _e[ee[40]][ee[55]](be, ee[576])[ee[53]](function(pe) {
                ve[ee[522]][ee[51]](_e[ee[40]][ee[41]](pe));
              }), ue[ee[500]][ee[51]](ve);
            }), ue;
          }
        }, 66598: function(ne, ie) {
          var ae;
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[578]] = void 0, function(ce) {
            ce[ee[579]] = ee[580], ce[ee[581]] = ee[582], ce[ee[479]] = ee[558];
          }(ae || (ie[ee[578]] = ae = {}));
        }, 71076: function(ne, ie) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[469]] = void 0;
          var ae = function() {
            function ce() {
              this[ee[470]] = [], this[ee[428]] = [];
            }
            return ce;
          }();
          ie[ee[469]] = ae;
        }, 71119: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[481]] = ue, ie[ee[583]] = me;
          var ce = ae(63207), he = ae(19637), _e = ae(93088), le = ae(2035), se = ae(64815), oe = ae(75065);
          function ue($e) {
            var Se = $e[ee[478]];
            for (var Ce in Se) {
              var Ie = Se[Ce];
              if ([ee[584], ee[585]][ee[112]](Ie[ee[476]]) !== -1) {
                if (oe[ee[40]][ee[586]](ee[70], $e, Ie), oe[ee[40]][ee[586]](ee[253], $e, Ie), ee[584] === Ie[ee[476]])
                  return ve(Ie);
                if (ee[585] === Ie[ee[476]])
                  return be(Ie);
              }
            }
          }
          function be($e) {
            var Se = $e[ee[478]], Ce = new ce[ee[480]]();
            for (var Ie in Ce[ee[70]] = $e[ee[44]](ee[70]) || null, Ce[ee[253]] = $e[ee[44]](ee[253]) || null, Se) {
              var Te = Se[Ie];
              switch (Te[ee[476]]) {
                case ee[479]:
                  Ce[ee[428]][ee[51]](oe[ee[40]][ee[41]](Te));
                  break;
                case ee[587]:
                  Ce[ee[572]][ee[51]](oe[ee[40]][ee[41]](Te));
                  break;
                case ee[593]:
                  oe[ee[40]][ee[55]](Te, ee[250])[ee[53]](function(Ee) {
                    var we = { id: Ee[ee[44]](ee[70]) || null, adId: ge(Ee), sequence: Ee[ee[44]](ee[253]) || null, apiFramework: Ee[ee[44]](ee[77]) || null };
                    for (var Pe in Ee[ee[478]]) {
                      var Me = Ee[ee[478]][Pe];
                      switch (Me[ee[476]]) {
                        case ee[588]:
                          we[ee[252]] = ye(Me);
                          break;
                        case ee[589]:
                          var Ae = (0, le[ee[35]])(Me, we);
                          Ae && Ce[ee[465]][ee[51]](Ae);
                          break;
                        case ee[590]:
                          var Oe = (0, se[ee[573]])(Me, we);
                          Oe && Ce[ee[465]][ee[51]](Oe);
                          break;
                        case ee[592]:
                          var Be = (0, _e[ee[591]])(Me, we);
                          Be && Ce[ee[465]][ee[51]](Be);
                      }
                    }
                  });
                  break;
                case ee[595]:
                  Ce[ee[491]] = me(oe[ee[40]][ee[55]](Te, ee[594]), Ce);
                  break;
                case ee[597]:
                  Ce[ee[492]] = { value: oe[ee[40]][ee[41]](Te), version: Te[ee[44]](ee[596]) || null };
                  break;
                case ee[598]:
                  Ce[ee[567]] = oe[ee[40]][ee[41]](Te);
                  break;
                case ee[599]:
                  Ce[ee[568]] = oe[ee[40]][ee[41]](Te);
                  break;
                case ee[600]:
                  Ce[ee[569]] = { name: oe[ee[40]][ee[41]](Te), id: Te[ee[44]](ee[70]) || null };
                  break;
                case ee[603]:
                  Ce[ee[570]] = { value: oe[ee[40]][ee[41]](Te), model: Te[ee[44]](ee[601]) || null, currency: Te[ee[44]](ee[602]) || null };
                  break;
                case ee[604]:
                  Ce[ee[571]] = { uri: oe[ee[40]][ee[41]](Te), type: Te[ee[44]](ee[76]) || null };
                  break;
                case ee[606]:
                  fe(Ce[ee[562]], oe[ee[40]][ee[55]](Te, ee[605]));
              }
            }
            return Ce;
          }
          function ve($e) {
            var Se = be($e), Ce = oe[ee[40]][ee[39]]($e, ee[607]);
            if (Ce ? Se[ee[486]] = oe[ee[40]][ee[41]](Ce) : (Ce = oe[ee[40]][ee[39]]($e, ee[608])) && (Se[ee[486]] = oe[ee[40]][ee[41]](oe[ee[40]][ee[39]](Ce, ee[609]))), Se[ee[465]][ee[53]](function(Ie) {
              if ([ee[610], ee[499]][ee[112]](Ie[ee[76]]) !== -1) {
                if (Ie[ee[66]]) {
                  Se[ee[66]] || (Se[ee[66]] = {}), Se[ee[66]][Ie[ee[76]]] || (Se[ee[66]][Ie[ee[76]]] = {});
                  var Te = function(we) {
                    var Pe = Ie[ee[66]][we];
                    Se[ee[66]][Ie[ee[76]]][we] || (Se[ee[66]][Ie[ee[76]]][we] = []), Pe[ee[53]](function(Me) {
                      Se[ee[66]][Ie[ee[76]]][we][ee[51]](Me);
                    });
                  };
                  for (var Ee in Ie[ee[66]])
                    Te(Ee);
                }
                Ie[ee[52]] && (Se[ee[52]] || (Se[ee[52]] = []), Ie[ee[52]][ee[53]](function(we) {
                  Se[ee[52]][ee[51]](we);
                })), Ie[ee[49]] && (Se[ee[49]] = Ie[ee[49]]), Ie[ee[56]] && (Se[ee[56]] || (Se[ee[56]] = []), Ie[ee[56]][ee[53]](function(we) {
                  Se[ee[56]][ee[51]](we);
                }));
              }
            }), Se[ee[486]])
              return Se;
          }
          function me($e, Se) {
            var Ce = [];
            return $e[ee[53]](function(Ie) {
              var Te = pe(Ie, Se);
              Te && Ce[ee[51]](Te);
            }), Ce;
          }
          function pe($e, Se) {
            if (ee[611] === $e[ee[476]])
              return null;
            var Ce = new he[ee[254]](), Ie = $e[ee[257]], Te = $e[ee[478]];
            if (Ce[ee[255]] = $e[ee[476]], $e[ee[257]]) {
              for (var Ee in Ie)
                if (Ie[ee[179]](Ee)) {
                  var we = Ie[Ee];
                  we[ee[476]] && we[ee[612]] && (Ce[ee[257]][we[ee[476]]] = we[ee[612]]);
                }
            }
            for (var Pe in Te)
              if (Te[ee[179]](Pe)) {
                if (ee[606] === Te[Pe][ee[476]]) {
                  fe(Se[ee[562]], oe[ee[40]][ee[55]](Te[Pe], ee[605]));
                  continue;
                }
                var Me = pe(Te[Pe], Se);
                Me && Ce[ee[258]][ee[51]](Me);
              }
            if (Ce[ee[258]][ee[20]] === 0 || Ce[ee[258]][ee[20]] === 1 && [ee[613], ee[614]][ee[112]](Ce[ee[258]][0][ee[255]]) >= 0) {
              var Ae = oe[ee[40]][ee[41]]($e);
              ee[197] !== Ae && (Ce[ee[256]] = Ae), Ce[ee[258]] = [];
            }
            return Ce[ee[259]]() ? null : Ce;
          }
          function fe($e, Se) {
            var Ce = [ee[605], ee[615], ee[616], ee[68], ee[67], ee[617]], Ie = function(Te) {
              var Ee = {}, we = oe[ee[40]][ee[41]](Te);
              return Object[ee[21]](Te[ee[257]])[ee[53]](function(Pe) {
                var Me = Te[ee[257]][Pe][ee[476]], Ae = Te[ee[257]][Pe][ee[612]];
                Me && Ae && (Ee[Me] = Ae);
              }), ee[611] !== Te[ee[476]] && ee[197] !== we && (Te[ee[258]] && Te[ee[258]][ee[20]] > 0 ? Te[ee[478]][ee[53]](function(Pe) {
                Ce[ee[371]](Pe[ee[476]]) && (Ee[Pe[ee[476]]] || (Ee[Pe[ee[476]]] = []), Ee[Pe[ee[476]]][ee[51]](Ie(Pe)));
              }) : Ee[ee[618]] = we), Ee;
            };
            Se[ee[53]](function(Te) {
              var Ee = Ie(Te);
              $e[ee[51]](Ee);
            });
          }
          function ge($e) {
            return $e[ee[44]](ee[619]) || $e[ee[44]](ee[620]) || $e[ee[44]](ee[251]) || null;
          }
          function ye($e) {
            return { idRegistry: $e[ee[44]](ee[621]) || ee[622], value: oe[ee[40]][ee[41]]($e) || ee[622] };
          }
        }, 75065: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[40]] = void 0;
          var ce = ae(11417);
          function he(pe, fe) {
            var ge = pe[ee[478]];
            for (var ye in ge) {
              var $e = ge[ye];
              if ($e[ee[476]] === fe)
                return $e;
            }
          }
          function _e(pe, fe) {
            var ge = [], ye = pe[ee[478]];
            for (var $e in ye) {
              var Se = ye[$e];
              Se[ee[476]] === fe && ge[ee[51]](Se);
            }
            return ge;
          }
          function le(pe, fe) {
            if (!fe)
              return pe;
            if (pe[ee[112]](ee[623]) === 0) {
              var ge = location[ee[122]];
              return ee[197][ee[63]](ge)[ee[63]](pe);
            }
            if (pe[ee[112]](ee[624]) === -1) {
              var ye = fe[ee[425]](0, fe[ee[625]](ee[224]));
              return ee[197][ee[63]](ye, ee[224])[ee[63]](pe);
            }
            return pe;
          }
          function se(pe) {
            return [ee[85], ee[626], ee[627]][ee[112]](pe) !== -1;
          }
          function oe(pe) {
            return pe && (pe[ee[629]] || pe[ee[630]] || ee[197])[ee[628]]();
          }
          function ue(pe, fe, ge) {
            var ye = fe[ee[44]](pe);
            ye && ge[ee[631]](pe, ye);
          }
          function be(pe) {
            if (pe == null)
              return -1;
            if (ce[ee[247]][ee[632]](pe))
              return parseInt(pe);
            var fe = pe[ee[634]](ee[633]);
            if (fe[ee[20]] !== 3)
              return -1;
            var ge = fe[2][ee[634]](ee[635]), ye = parseInt(ge[0]);
            ge[ee[20]] === 2 && (ye += parseFloat(ee[636][ee[63]](ge[1])));
            var $e = parseInt(60 * fe[1]), Se = parseInt(60 * fe[0] * 60);
            return isNaN(Se) || isNaN($e) || isNaN(ye) || $e > 3600 || ye > 60 ? -1 : Se + $e + ye;
          }
          function ve(pe) {
            var fe = [], ge = null;
            return pe[ee[53]](function(ye, $e) {
              if (ye[ee[253]] && (ye[ee[253]] = parseInt(ye[ee[253]], 10)), ye[ee[253]] > 1) {
                var Se = pe[$e - 1];
                if (Se && Se[ee[253]] === ye[ee[253]] - 1)
                  return void (ge && ge[ee[51]](ye));
                delete ye[ee[253]];
              }
              ge = [ye], fe[ee[51]](ge);
            }), fe;
          }
          function me(pe, fe) {
            if (pe[ee[428]] = fe[ee[428]][ee[63]](pe[ee[428]]), pe[ee[572]] = fe[ee[572]][ee[63]](pe[ee[572]]), pe[ee[491]] = fe[ee[491]][ee[63]](pe[ee[491]]), pe[ee[562]] = fe[ee[562]][ee[63]](pe[ee[562]]), pe[ee[566]][ee[51]](fe[ee[70]]), pe[ee[465]][ee[53]](function(ge) {
              if (fe[ee[66]] && fe[ee[66]][ge[ee[76]]])
                for (var ye in fe[ee[66]][ge[ee[76]]]) {
                  var $e = fe[ee[66]][ge[ee[76]]][ye];
                  ge[ee[66]][ye] || (ge[ee[66]][ye] = []), ge[ee[66]][ye] = ge[ee[66]][ye][ee[63]]($e);
                }
            }), fe[ee[52]] && fe[ee[52]][ee[20]] && pe[ee[465]][ee[53]](function(ge) {
              ee[610] === ge[ee[76]] && (ge[ee[52]] = ge[ee[52]][ee[63]](fe[ee[52]]));
            }), fe[ee[56]] && fe[ee[56]][ee[20]] && pe[ee[465]][ee[53]](function(ge) {
              ee[610] === ge[ee[76]] && (ge[ee[56]] = ge[ee[56]][ee[63]](fe[ee[56]]));
            }), fe[ee[49]] && pe[ee[465]][ee[53]](function(ge) {
              ee[610] === ge[ee[76]] && ge[ee[49]] == null && (ge[ee[49]] = fe[ee[49]]);
            }), pe[ee[484]] && pe[ee[253]] !== pe[ee[484]]) {
              if (!fe[ee[253]] && !fe[ee[484]])
                return;
              pe[ee[253]] = null, pe[ee[484]] = fe[ee[484]] || fe[ee[253]];
            } else if (fe[ee[484]])
              pe[ee[253]] = null, pe[ee[484]] = fe[ee[484]] || fe[ee[253]];
            else {
              if (!fe[ee[253]] && !fe[ee[484]])
                return;
              pe[ee[253]] = fe[ee[253]];
            }
          }
          ie[ee[40]] = { childByName: he, childrenByName: _e, resolveVastAdTagURI: le, parseBoolean: se, parseNodeText: oe, copyNodeAttribute: ue, parseDuration: be, splitVAST: ve, mergeWrapperAdData: me };
        }, 77615: function(ne, ie, ae) {
          var ce = this && this[ee[417]] || function() {
            var _e = function(le, se) {
              return _e = Object[ee[418]] || { __proto__: [] } instanceof Array && function(oe, ue) {
                oe[ee[419]] = ue;
              } || function(oe, ue) {
                for (var be in ue)
                  Object[ee[24]][ee[179]][ee[261]](ue, be) && (oe[be] = ue[be]);
              }, _e(le, se);
            };
            return function(le, se) {
              if (ee[401] != typeof se && se !== null)
                throw new TypeError(ee[420] + String(se) + ee[421]);
              function oe() {
                this[ee[422]] = le;
              }
              _e(le, se), le[ee[24]] = se === null ? Object[ee[423]](se) : (oe[ee[24]] = se[ee[24]], new oe());
            };
          }();
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[36]] = void 0;
          var he = function(_e) {
            function le(se) {
              se === void 0 && (se = {});
              var oe = _e[ee[261]](this, se) || this;
              return oe[ee[76]] = ee[610], oe[ee[37]] = 0, oe[ee[45]] = null, oe[ee[89]] = [], oe[ee[49]] = null, oe[ee[52]] = [], oe[ee[56]] = [], oe[ee[59]] = null, oe[ee[111]] = [], oe;
            }
            return ce(le, _e), le;
          }(ae(14447)[ee[250]]);
          ie[ee[36]] = he;
        }, 81214: function(ne, ie, ae) {
          var ce = this && this[ee[417]] || function() {
            var _e = function(le, se) {
              return _e = Object[ee[418]] || { __proto__: [] } instanceof Array && function(oe, ue) {
                oe[ee[419]] = ue;
              } || function(oe, ue) {
                for (var be in ue)
                  Object[ee[24]][ee[179]][ee[261]](ue, be) && (oe[be] = ue[be]);
              }, _e(le, se);
            };
            return function(le, se) {
              if (ee[401] != typeof se && se !== null)
                throw new TypeError(ee[420] + String(se) + ee[421]);
              function oe() {
                this[ee[422]] = le;
              }
              _e(le, se), le[ee[24]] = se === null ? Object[ee[423]](se) : (oe[ee[24]] = se[ee[24]], new oe());
            };
          }();
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[637]] = void 0;
          var he = function(_e) {
            function le(se) {
              se === void 0 && (se = {});
              var oe = _e[ee[261]](this, se) || this;
              return oe[ee[76]] = ee[638], oe[ee[500]] = [], oe;
            }
            return ce(le, _e), le;
          }(ae(14447)[ee[250]]);
          ie[ee[637]] = he;
        }, 82664: function(ne, ie) {
          function ae() {
            var _e;
            return window[ee[639]] && (_e = new XDomainRequest()), _e;
          }
          function ce() {
            return !!ae();
          }
          function he(_e, le, se) {
            var oe = ee[401] == typeof window[ee[640]] ? new window[ee[640]](ee[641]) : void 0;
            if (!oe)
              return se(new Error(ee[642]));
            oe[ee[643]] = !1;
            var ue = ue();
            request[ee[127]](ee[126], _e), request[ee[128]] = le[ee[128]] || 0, request[ee[118]] = le[ee[118]] || !1, request[ee[137]](), request[ee[644]] = function() {
            }, request[ee[645]] = function() {
              oe[ee[647]](request[ee[646]]), se(null, oe);
            };
          }
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[403]] = void 0, ie[ee[403]] = { get: he, supported: ce };
        }, 84668: function(ne, ie) {
          var ae;
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[176]] = void 0, function(ce) {
            ce[ee[175]] = ee[648], ce[ee[150]] = ee[649], ce[ee[650]] = ee[17];
          }(ae || (ie[ee[176]] = ae = {}));
        }, 86048: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[651]] = void 0;
          var ce = ae(29173), he = ae(26580), _e = function() {
            function le() {
            }
            return le[ee[423]] = function(se, oe) {
              var ue = !1, be = function() {
                ue = !1;
              }, ve = function(me) {
                var pe = ee[653][ee[63]](me, ee[652]);
                return Promise[ee[157]](pe);
              };
              return new (function() {
                function me() {
                }
                return me[ee[24]][ee[654]] = function() {
                  return ue ? ve(ee[655]) : (ue = !0, Promise[ee[154]](he[ee[362]][ee[364]](se, be)));
                }, me[ee[24]][ee[656]] = function() {
                  return ue ? ve(ee[657]) : (ue = !0, Promise[ee[154]](new ce[ee[405]](se, be)));
                }, me[ee[24]][ee[372]] = function(pe) {
                  return pe === void 0 && (pe = !0), oe(pe);
                }, me;
              }())();
            }, le;
          }();
          ie[ee[651]] = _e;
        }, 92284: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[506]] = ie[ee[658]] = void 0, ie[ee[659]] = Te, ie[ee[660]] = Pe;
          var ce = ae(35148), he = ae(62510), _e = ae(88005), le = ae(67345), se = ae(33696), oe = ae(58975), ue = ae(3464), be = ae(27177), ve = ae(10981), me = ae(54838), pe = ae(91520), fe = ae(16368), ge = ae(59972), ye = { videoLoadTimeout: ae(857)[ee[6]], strategy: { shouldPlayAdBreak: function() {
            return !0;
          }, shouldPlaySkippedAdBreaks: function(Ae) {
            var Oe = Math[ee[662]][ee[262]](Math, Ae[ee[181]](function(Be) {
              return Be[ee[661]];
            }));
            return [Ae[ee[268]](function(Be) {
              return Be[ee[661]] === Oe;
            })];
          } } };
          ie[ee[658]] = { playbackTime: [ee[663]], height: [ee[664]], width: [ee[665]], domain: [ee[666]], page: [ee[667]], referrer: [ee[668]], random: [ee[669], ee[670]], timestamp: [ee[671]] };
          var $e = 1e3, Se = function() {
            function Ae(Oe, Be) {
              var Ve = this;
              this[ee[264]] = Be, this[ee[672]] = function(Ne) {
                Ve[ee[265]][ee[673]]() || Ve[ee[675]][ee[672]](Ne[ee[674]]);
              }, this[ee[676]] = function(Ne) {
                return Ve[ee[675]][ee[676]](Ne[ee[677]], Ne[ee[678]]);
              }, this[ee[679]] = function(Ne) {
                return Ve[ee[680]] = Ne[ee[677]];
              }, this[ee[681]] = function() {
                return Ve[ee[676]]({ position: Ve[ee[680]], seekTarget: Ve[ee[265]][ee[282]]() });
              }, this[ee[682]] = function(Ne) {
                Ve[ee[683]] && Ne[ee[381]] === ce[ee[685]][ee[684]] && (Ve[ee[683]] = !1);
              }, this[ee[686]] = function(Ne) {
                return Ve[ee[675]][ee[686]](Ne);
              }, this[ee[687]] = function() {
                Ve[ee[688]][ee[20]] > 0 && Ve[ee[689]](Ve[ee[688]][ee[493]](0, Ve[ee[688]][ee[20]])), Ve[ee[265]][ee[275]](he[ee[274]][ee[690]], Ve[ee[687]]);
              }, this[ee[691]] = function(Ne, xe) {
                Ve[ee[675]][ee[695]](Ne, xe, Ve[ee[265]][ee[692]]() === se[ee[694]][ee[693]]);
              };
              var Ue = Oe[ee[696]](!0);
              this[ee[697]] = Ue[ee[698]] || {}, this[ee[265]] = Oe, this[ee[688]] = [], this[ee[699]] = null, this[ee[700]] = !0, this[ee[683]] = !1;
              var Re = Ce(this[ee[697]], Ue);
              Ie(Re, Be), Te(Ue, Re, Be[ee[289]]), this[ee[701]](Re), this[ee[697]][ee[702]] && this[ee[697]][ee[702]][ee[20]] > 0 && this[ee[697]][ee[702]][ee[493]](0)[ee[53]](function(Ne) {
                return Ve[ee[704]](Ne)[ee[170]](function(xe) {
                  return Ve[ee[264]][ee[289]][ee[703]](xe);
                });
              }), this[ee[265]][ee[278]](he[ee[274]][ee[415]], this[ee[672]]), this[ee[265]][ee[278]](he[ee[274]][ee[705]], this[ee[676]]), this[ee[265]][ee[278]](he[ee[274]][ee[706]], this[ee[682]]), this[ee[265]][ee[278]](he[ee[274]][ee[707]], this[ee[679]]), this[ee[265]][ee[278]](he[ee[274]][ee[708]], this[ee[681]]), this[ee[709]] = Pe(this, this[ee[675]]);
            }
            return Ae[ee[24]][ee[701]] = function(Oe) {
              this[ee[710]] = { internalPlayer: this[ee[265]], context: this[ee[264]], restoreContentDeferred: null };
              var Be = pe[ee[146]][ee[145]](fe[ee[144]][ee[505]]), Ve = pe[ee[146]][ee[145]](fe[ee[144]][ee[711]]), Ue = new Be[ee[507]](this[ee[710]]);
              this[ee[675]] = new Ve(Ue, Oe), this[ee[712]] = Ue;
            }, Ae[ee[24]][ee[713]] = function(Oe) {
              this[ee[264]] = Oe, this[ee[710]][ee[264]] = Oe;
            }, Ae[ee[24]][ee[704]] = function(Oe) {
              return Me(Oe) && (Oe[ee[714]] = Oe[ee[714]] !== !1, this[ee[715]](Oe) && !this[ee[716]]()) ? (this[ee[688]][ee[51]](Oe), this[ee[699]] || (this[ee[699]] = new ve[ee[717]](), this[ee[265]][ee[278]](he[ee[274]][ee[690]], this[ee[687]])), this[ee[699]][ee[718]]) : this[ee[719]](Oe);
            }, Ae[ee[24]][ee[715]] = function(Oe) {
              return Oe[ee[677]][ee[371]](ee[46]) && ee[720] !== Oe[ee[677]];
            }, Ae[ee[24]][ee[689]] = function(Oe) {
              var Be = this, Ve = Oe[ee[181]](function(Ue) {
                return Be[ee[719]](Ue);
              });
              this[ee[699]] && Promise[ee[317]](Ve)[ee[158]](function(Ue) {
                var Re = [][ee[63]][ee[262]]([], Ue);
                Be[ee[699]][ee[154]](Re), Be[ee[699]] = null;
              })[ee[170]](function(Ue) {
                return Be[ee[264]][ee[289]][ee[703]](Ue);
              });
            }, Ae[ee[24]][ee[719]] = function(Oe) {
              return Me(Oe) && this[ee[265]][ee[285]]() && this[ee[715]](Oe) ? Promise[ee[157]](ee[721]) : this[ee[675]][ee[722]](Oe);
            }, Ae[ee[24]][ee[723]] = function() {
              var Oe, Be, Ve = this, Ue = Promise[ee[154]]();
              return this[ee[683]] = !0, this[ee[700]] && (!((Be = (Oe = this[ee[264]]) === null || Oe === void 0 ? void 0 : Oe[ee[333]]) === null || Be === void 0) && Be[ee[724]]) && (Ue = this[ee[264]][ee[333]][ee[724]]()), Promise[ee[154]](this[ee[675]][ee[728]]())[ee[170]](function(Re) {
                (0, be[ee[725]])(Ve[ee[264]]) && Ve[ee[264]][ee[289]][ee[288]](ee[727], Re);
              })[ee[158]](function() {
                return Ue;
              })[ee[170]](function(Re) {
                (0, be[ee[725]])(Ve[ee[264]]) && Ve[ee[264]][ee[289]][ee[288]](ee[726], Re);
              });
            }, Ae[ee[24]][ee[729]] = function() {
              var Oe = this, Be = !1, Ve = function() {
                Be = !0, Oe[ee[265]][ee[275]](he[ee[274]][ee[730]], Ve);
              };
              return this[ee[265]][ee[278]](he[ee[274]][ee[730]], Ve), this[ee[710]][ee[731]] = new ve[ee[717]](), Promise[ee[154]](this[ee[675]][ee[735]]())[ee[158]](function() {
                return new Promise(function(Ue, Re) {
                  if (Be) {
                    var Ne, xe = function() {
                      Oe[ee[710]][ee[731]][ee[718]][ee[158]](Ue)[ee[170]](Re), ke(), clearTimeout(Ne);
                    }, ke = (0, ue[ee[734]])(Oe[ee[264]][ee[279]])(function(Le) {
                      return (0, oe[ee[733]])((0, oe[ee[732]])(Le));
                    }, xe, function(Le) {
                      return Le;
                    });
                    Ne = window[ee[342]](xe, $e);
                  } else
                    Ue();
                });
              })[ee[158]](function() {
                return Oe[ee[710]][ee[731]] = null;
              })[ee[170]](function(Ue) {
                Oe[ee[710]][ee[731]] = null, Oe[ee[264]][ee[289]][ee[288]](Ue);
              });
            }, Ae[ee[24]][ee[736]] = function() {
              return this[ee[683]];
            }, Ae[ee[24]][ee[377]] = function() {
              return this[ee[675]][ee[737]](), Promise[ee[154]]();
            }, Ae[ee[24]][ee[376]] = function() {
              this[ee[675]][ee[376]]();
            }, Ae[ee[24]][ee[282]] = function() {
              var Oe, Be = (Oe = this[ee[675]]) === null || Oe === void 0 ? void 0 : Oe[ee[387]]();
              return isNaN(Be) ? 0 : Be ?? 0;
            }, Ae[ee[24]][ee[295]] = function() {
              return this[ee[675]][ee[37]]();
            }, Ae[ee[24]][ee[738]] = function() {
              return this[ee[675]][ee[738]]();
            }, Ae[ee[24]][ee[739]] = function() {
              return this[ee[675]][ee[738]](!0);
            }, Ae[ee[24]][ee[740]] = function() {
              return this[ee[738]]() && !this[ee[739]]();
            }, Ae[ee[24]][ee[716]] = function() {
              return this[ee[265]][ee[295]]() > 0;
            }, Ae[ee[24]][ee[741]] = function() {
              return this[ee[688]] = [], this[ee[683]] = !1, this[ee[712]][ee[741]](), this[ee[675]][ee[741]]();
            }, Ae[ee[24]][ee[742]] = function() {
              this[ee[265]][ee[275]](he[ee[274]][ee[415]], this[ee[672]]), this[ee[265]][ee[275]](he[ee[274]][ee[705]], this[ee[676]]), this[ee[265]][ee[275]](he[ee[274]][ee[706]], this[ee[682]]), this[ee[265]][ee[275]](he[ee[274]][ee[707]], this[ee[679]]), this[ee[265]][ee[275]](he[ee[274]][ee[708]], this[ee[681]]), this[ee[265]] = null, this[ee[697]] = null, this[ee[675]][ee[742]](), this[ee[675]] = null, this[ee[712]] = null;
            }, Ae;
          }();
          function Ce(Ae, Oe) {
            var Be, Ve, Ue = {}, Re = {};
            return me[ee[174]][ee[743]](Re, Ae), delete Re[ee[702]], me[ee[174]][ee[744]](Ue, ye, Re), Ue[ee[179]](ee[118]) || (Ue[ee[118]] = !0), Ue[ee[179]](ee[745]) || (Ue[ee[745]] = (Ve = (Be = Oe[ee[22]]) === null || Be === void 0 ? void 0 : Be[ee[745]]) !== null && Ve !== void 0 && Ve), Ue;
          }
          function Ie(Ae, Oe) {
            ge[ee[172]][ee[549]](new _e[ee[748]](Oe, { requestType: le[ee[747]][ee[746]] })), ge[ee[172]][ee[551]](Ae[ee[511]]), ge[ee[172]][ee[552]](Ae[ee[118]]), ge[ee[172]][ee[553]](Ae[ee[745]]);
          }
          function Te(Ae, Oe, Be) {
            if (pe[ee[146]][ee[145]](fe[ee[144]][ee[711]])[ee[749]])
              return Be[ee[288]](ee[750]), void Ee(Ae, Oe);
            pe[ee[146]][ee[145]](fe[ee[144]][ee[711]])[ee[751]] && (Be[ee[288]](ee[752]), we(Ae, Oe));
          }
          function Ee(Ae, Oe) {
            var Be = Oe;
            Ae[ee[329]] && Array[ee[246]](Ae[ee[329]][ee[753]]) ? Be[ee[754]] = Ae[ee[329]][ee[753]] : Be[ee[754]] = [];
          }
          function we(Ae, Oe) {
            var Be = Oe;
            Be[ee[755]] || (Be[ee[755]] = Ae[ee[123]][ee[756]]);
          }
          function Pe(Ae, Oe) {
            return new (function() {
              function Be() {
              }
              return Be[ee[24]][ee[722]] = function(Ve) {
                return Ae[ee[704]](Ve);
              }, Be[ee[24]][ee[757]] = function() {
                return Oe[ee[757]]();
              }, Be[ee[24]][ee[758]] = function() {
                return Oe[ee[758]]();
              }, Be[ee[24]][ee[759]] = function() {
                return Oe[ee[759]]();
              }, Be[ee[24]][ee[760]] = function() {
                return Oe[ee[760]]();
              }, Be[ee[24]][ee[761]] = function(Ve) {
                Oe[ee[761]](Ve);
              }, Be[ee[24]][ee[738]] = function() {
                return Oe[ee[738]]();
              }, Be[ee[24]][ee[762]] = function() {
                return Oe[ee[762]]();
              }, Be;
            }())();
          }
          function Me(Ae) {
            return !!Ae[ee[677]];
          }
          ie[ee[506]] = Se;
        }, 93088: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[591]] = le;
          var ce = ae(31472), he = ae(81214), _e = ae(75065);
          function le(se, oe) {
            var ue = new he[ee[637]](oe);
            return _e[ee[40]][ee[55]](se, ee[767])[ee[53]](function(be) {
              var ve = new ce[ee[494]]();
              ve[ee[70]] = be[ee[44]](ee[70]) || null, ve[ee[81]] = be[ee[44]](ee[81]), ve[ee[82]] = be[ee[44]](ee[82]), ve[ee[497]] = [], _e[ee[40]][ee[55]](be, ee[99])[ee[53]](function(me) {
                ve[ee[76]] = me[ee[44]](ee[96]) || ee[97], ve[ee[98]] = _e[ee[40]][ee[41]](me);
              }), _e[ee[40]][ee[55]](be, ee[101])[ee[53]](function(me) {
                ve[ee[76]] = me[ee[44]](ee[96]) || 0, ve[ee[100]] = _e[ee[40]][ee[41]](me);
              }), _e[ee[40]][ee[55]](be, ee[103])[ee[53]](function(me) {
                ve[ee[76]] = me[ee[44]](ee[96]) || 0, _e[ee[40]][ee[55]](be, ee[763])[ee[53]](function(pe) {
                  ve[ee[495]] = _e[ee[40]][ee[41]](pe);
                }), ve[ee[102]] = _e[ee[40]][ee[41]](me);
              }), _e[ee[40]][ee[55]](be, ee[68])[ee[53]](function(me) {
                _e[ee[40]][ee[55]](me, ee[67])[ee[53]](function(pe) {
                  var fe = pe[ee[44]](ee[60]), ge = _e[ee[40]][ee[41]](pe);
                  fe && ge && (ve[ee[66]][fe] == null && (ve[ee[66]][fe] = []), ve[ee[66]][fe][ee[51]](ge));
                });
              }), _e[ee[40]][ee[55]](be, ee[764])[ee[53]](function(me) {
                ve[ee[497]][ee[51]](_e[ee[40]][ee[41]](me));
              }), ve[ee[496]] = _e[ee[40]][ee[41]](_e[ee[40]][ee[39]](be, ee[765])), ve[ee[766]] = _e[ee[40]][ee[41]](_e[ee[40]][ee[39]](be, ee[764])), ue[ee[500]][ee[51]](ve);
            }), ue;
          }
        }, 94583: function(ne, ie) {
          function ae(ce) {
            var he = ce[ee[387]], _e = ce[ee[768]], le = ce[ee[178]], se = ce[ee[769]], oe = ce[ee[285]], ue = oe ? he + _e : he;
            return oe && !se || (ue = le ? he + le : he), ue;
          }
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[286]] = ae;
        }, 97731: function(ne, ie, ae) {
          var ce = this && this[ee[260]] || function() {
            return ce = Object[ee[223]] || function(we) {
              for (var Pe, Me = 1, Ae = arguments[ee[20]]; Me < Ae; Me++)
                for (var Oe in Pe = arguments[Me])
                  Object[ee[24]][ee[179]][ee[261]](Pe, Oe) && (we[Oe] = Pe[Oe]);
              return we;
            }, ce[ee[262]](this, arguments);
          };
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[507]] = void 0;
          var he = ae(25550), _e = ae(18665), le = ae(62510), se = ae(78429), oe = ae(57620), ue = ae(92737), be = ae(15539), ve = ae(5772), me = ae(27177), pe = ae(61878), fe = ae(86048), ge = ae(5613), ye = ae(25247), $e = ae(58431), Se = function() {
            function we(Pe) {
              var Me, Ae = Pe[ee[265]], Oe = new ye[ee[263]](Pe[ee[264]], Ae), Be = Promise[ee[154]](), Ve = !1, Ue = !1, Re = !1, Ne = { width: 0, height: 0 }, xe = [], ke = function(gt) {
                gt[ee[381]] === ue[ee[685]][ee[684]] && (Ue = !0);
              }, Le = function(gt) {
                var yt = Ie(gt[ee[81]]), pt = Ie(gt[ee[82]]);
                Ne = { width: yt, height: pt };
              };
              Ae[ee[336]](le[ee[274]][ee[770]], Le);
              var He = function() {
                Ue = !1;
              };
              this[ee[406]] = function() {
                return Ae[ee[406]]();
              }, this[ee[389]] = function() {
                return Ae[ee[391]]() ? 0 : Ae[ee[389]]();
              }, this[ee[771]] = function(gt) {
                var yt;
                return yt = Oe[ee[304]]() ? Oe[ee[303]]()[ee[334]] : Ae[ee[295]](), we[ee[771]](gt, yt);
              }, this[ee[772]] = function(gt) {
                var yt = gt[ee[773]](function(je) {
                  return je[ee[78]] || je[ee[79]] && je[ee[80]];
                }), pt = Ae[ee[774]](), bt = Ae[ee[775]](), ut = !!(bt && pt && pt[ee[78]] > 0), Ke = Pe[ee[264]][ee[322]][ee[145]](_e[ee[319]][ee[776]]);
                return yt && (Ke || ut) ? We(gt, [pt, bt], Ke) : Te(gt, Ne, pt);
              };
              var We = function(gt, yt, pt) {
                var bt = yt[0], ut = yt[1];
                return pt ? pt[ee[777]](gt) : (0, ge[ee[201]])(bt[ee[78]] + ut[ee[78]], gt);
              };
              this[ee[778]] = function(gt, yt) {
                var pt = { adBreak: null, downloadTiming: yt };
                gt[ee[179]](ee[661]) && (pt[ee[779]] = gt), pt[ee[780]] = gt, Ae[ee[386]](le[ee[274]][ee[781]], pt);
              };
              var Xe = function() {
                xe[ee[53]](function(gt) {
                  return Ae[ee[386]](le[ee[274]][ee[479]], { type: le[ee[274]][ee[479]], code: gt[ee[381]], name: gt[ee[255]], message: gt[ee[489]], data: gt[ee[19]], troubleShootLink: (0, se[ee[782]])(gt[ee[381]]) });
                });
              }, Qe = function() {
                return Ae[ee[379]](ze), Oe[ee[30]](), Ae[ee[275]](le[ee[274]][ee[706]], ke), Ae[ee[275]](le[ee[274]][ee[367]], He), Ae[ee[373]]()[ee[158]](Xe);
              }, tt = function() {
                return xe[ee[20]] ? Qe() : (Ae[ee[386]](le[ee[274]][ee[783]]), Ae[ee[378]](ot), Oe[ee[344]](be[ee[788]])[ee[158]](function(gt) {
                  if (Ae[ee[379]](ze), xe[ee[20]] && Xe(), Ue)
                    Ue = !1;
                  else {
                    if (gt)
                      return Ae[ee[377]](be[ee[281]])[ee[170]](function(pt) {
                        Re = !0, Pe[ee[264]][ee[289]][ee[288]](ee[785], pt);
                      });
                    var yt = Pe[ee[264]][ee[322]][ee[145]](_e[ee[319]][ee[786]]);
                    yt == null || yt[ee[787]]();
                  }
                })[ee[170]](function() {
                  return Ae[ee[386]](le[ee[274]][ee[479]], { code: he[ee[383]][ee[784]] });
                })[ee[380]](function() {
                  Oe[ee[30]](), Ae[ee[379]](ot), Ae[ee[275]](le[ee[274]][ee[706]], ke), Ae[ee[275]](le[ee[274]][ee[367]], He);
                }));
              }, Je = function(gt) {
                if (Me = null, !Oe[ee[304]]())
                  return Promise[ee[154]]();
                var yt = Oe[ee[303]]()[ee[334]], pt = Promise[ee[154]]();
                return Ve = !gt, gt && (pt = Be = tt()[ee[158]](function() {
                  Pe[ee[731]] && Pe[ee[731]][ee[154]]();
                })), pt[ee[158]](function() {
                  Ae[ee[386]](le[ee[274]][ee[789]]), gt && (0, oe[ee[791]])(yt, Ae[ee[295]](), Pe[ee[264]][ee[790]]), Ae[ee[370]]() || Re || Ae[ee[386]](le[ee[274]][ee[367]], { time: Ae[ee[282]](), issuer: be[ee[281]] }), Re = !1;
                });
              }, Ge = [le[ee[274]][ee[479]], le[ee[274]][ee[690]], le[ee[274]][ee[276]], le[ee[274]][ee[792]], le[ee[274]][ee[793]]], Ye = function() {
                var gt = Pe[ee[264]][ee[279]][ee[330]]();
                return (gt == null ? void 0 : gt[ee[794]]) && Object[ee[21]](gt[ee[794]])[ee[268]](function(yt) {
                  var pt;
                  return gt[ee[794]] && gt[ee[794]][yt] && ((pt = gt[ee[794]][yt][ee[329]]) === null || pt === void 0 ? void 0 : pt[ee[795]]) === ve[ee[291]][ee[290]];
                });
              }, ze = function(gt, yt) {
                var pt = Ye();
                return Ee(gt, yt) && pt && yt[ee[320]] === pt && xe[ee[51]](yt), !Ge[ee[371]](gt);
              }, Fe = [le[ee[274]][ee[366]], le[ee[274]][ee[367]], le[ee[274]][ee[705]], le[ee[274]][ee[335]], le[ee[274]][ee[707]], le[ee[274]][ee[708]]], ot = function(gt) {
                return !Fe[ee[371]](gt);
              };
              this[ee[796]] = function(gt) {
                return Me ? Promise[ee[157]](ee[797]) : (Me = gt, Be[ee[158]](function() {
                  var yt = Ve ? Promise[ee[154]]() : vt(gt[ee[178]], we[ee[798]](gt)), pt = { adBreak: ce(ce({}, JSON[ee[458]](JSON[ee[799]](gt))), { scheduleTime: gt[ee[661]] }) };
                  return Ae[ee[386]](le[ee[274]][ee[730]], pt), Ae[ee[336]](le[ee[274]][ee[706]], ke), Ae[ee[336]](le[ee[274]][ee[367]], He), yt[ee[158]](function() {
                    return Ae[ee[373]](be[ee[281]]);
                  })[ee[158]](function() {
                    return fe[ee[651]][ee[423]](Ae, Je);
                  });
                }));
              };
              var vt = function(gt, yt) {
                var pt = Pe[ee[264]], bt = pt[ee[321]][ee[320]], ut = pt[ee[800]], Ke = pt[ee[322]][ee[145]](_e[ee[319]][ee[801]], bt), je = ut && pt[ee[284]][ee[802]];
                return Oe[ee[279]](yt, gt), Ae[ee[378]](ze), je && Ke && !Ke[ee[285]]() ? ut[ee[803]]() : Promise[ee[154]]();
              };
              this[ee[804]] = function(gt) {
                Ae[ee[386]](le[ee[274]][ee[805]], { ad: gt });
              }, this[ee[806]] = function(gt) {
                Ae[ee[386]](le[ee[274]][ee[807]], { clickThroughUrl: gt });
              }, this[ee[808]] = function(gt, yt) {
                Ae[ee[386]](le[ee[274]][ee[809]], { interactionType: gt, id: yt });
              }, this[ee[810]] = function(gt) {
                Ae[ee[386]](le[ee[274]][ee[811]], { quartile: gt });
              }, this[ee[812]] = function(gt, yt, pt) {
                var bt = { code: gt || $e[ee[164]][ee[515]] };
                yt && (bt[ee[489]] = yt), pt && (bt[ee[780]] = pt), Ae[ee[386]](le[ee[274]][ee[813]], { code: he[ee[383]][ee[814]], data: bt, name: he[ee[383]][he[ee[383]][ee[814]]], message: yt, troubleShootLink: (0, se[ee[782]])(he[ee[383]][ee[814]]) });
              }, this[ee[682]] = function(gt, yt, pt) {
                Ae[ee[386]](le[ee[274]][ee[706]], new ue[ee[815]](gt, yt, pt));
              }, this[ee[741]] = function() {
                var gt = Ae[ee[406]]();
                Ve = !1, Ue = !1, Oe[ee[30]](), Ae[ee[379]](ze), Ae[ee[379]](ot), Me = null, gt instanceof HTMLVideoElement && we[ee[816]](gt);
              };
            }
            return we[ee[798]] = function(Pe) {
              var Me;
              return ((Me = Pe[ee[470]]) === null || Me === void 0 ? void 0 : Me[ee[199]](function(Ae, Oe) {
                return Oe[ee[817]] && (Ae += Oe[ee[37]]), Ae;
              }, 0)) || 0;
            }, we[ee[771]] = function(Pe, Me) {
              var Ae = Number(Pe);
              return !isNaN(Ae) && Ae <= 0 && (Pe = ee[10]), Pe[ee[371]](ee[10]) || ee[720] === Pe ? 0 : Pe[ee[371]](ee[186]) ? 1 / 0 : this[ee[818]](Pe, Me);
            }, we[ee[818]] = function(Pe, Me) {
              var Ae;
              if (/%/[ee[233]](Pe)) {
                if (!Me)
                  return NaN;
                Pe = Pe[ee[242]](/%/gi, ee[197]), Ae = parseFloat(Pe) / 100 * Me;
              } else if (Pe[ee[112]](ee[633]) > -1) {
                var Oe = Pe[ee[634]](ee[633]);
                Ae = 3600 * parseFloat(Oe[0]) + 60 * parseFloat(Oe[1]) + parseFloat(Oe[2]);
              } else
                Ae = parseFloat(Pe);
              return Ae >= 0 ? Ae : NaN;
            }, we[ee[816]] = function(Pe) {
              pe[ee[820]][ee[819]](Pe), Pe[ee[356]]();
            }, we;
          }();
          ie[ee[507]] = Se;
          var Ce = /(\d+)/;
          function Ie(we) {
            return Number(we[ee[821]](Ce) ? we[ee[821]](Ce)[0] : 0);
          }
          function Te(we, Pe, Me) {
            return Me && Me[ee[81]] > 0 ? (0, ge[ee[200]])(Me[ee[81]], Me[ee[82]], we) : (0, ge[ee[200]])(Pe[ee[81]], Pe[ee[82]], we);
          }
          var Ee = function(we, Pe) {
            return we === le[ee[274]][ee[479]] && (0, me[ee[822]])(Pe) && Pe[ee[76]] === le[ee[274]][ee[479]];
          };
        } }, function(ne) {
          return function(ie) {
            return ne(ne[ee[823]] = ie);
          }(48513);
        }]);
      });
    })();
  })();
})(bitmovinplayerAdvertisingCore, bitmovinplayerAdvertisingCore.exports);
var bitmovinplayerAdvertisingCoreExports = bitmovinplayerAdvertisingCore.exports;
function defaultVideoQuality() {
  return {
    isAuto: !0,
    id: "auto",
    height: 0,
    width: 0
  };
}
class SubtitleHandler {
  constructor() {
    Et(this, "subtitles", []);
  }
  handleSubtitleEvent(te, ee) {
    return this.updateSubtitles(te), this.getMappedEvent(ee);
  }
  updateSubtitles(te) {
    const ee = `${te.subtitleId}-${te.text}`, ne = this.subtitles.find((ie) => ie.id === ee);
    te.type === bitmovinplayerCoreExports.PlayerEvent.CueUpdate ? this.updateExistingSubtitle(te, ee) : ne ? this.removeSubtitle(ee) : this.addSubtitle({
      id: ee,
      text: te.html ?? te.text,
      startTime: te.start,
      endTime: te.end
    });
  }
  updateExistingSubtitle(te, ee) {
    const ne = (he) => he.startTime === te.start && he.endTime === te.end, ie = (he) => he.text === te.text || he.text === te.html, ae = this.subtitles.length >= 0 ? this.subtitles[this.subtitles.length - 1] : void 0, ce = this.subtitles.find((he) => ne(he) || ie(he)) ?? ae;
    ce && (ce.text = te.html ?? te.text, ce.id = ee, ce.endTime = te.end, ce.startTime = te.start);
  }
  removeSubtitle(te) {
    this.subtitles = this.subtitles.filter((ee) => ee.id !== te);
  }
  addSubtitle(te) {
    this.subtitles.push(te);
  }
  getMappedEvent(te) {
    const ee = this.subtitles.flatMap((ne) => ne.text);
    return {
      type: "subtitleUpdate",
      playerId: te,
      currentSubtitleHtmls: ee
    };
  }
  resetAndGetEvent(te) {
    return this.subtitles = [], this.getMappedEvent(te);
  }
}
function isMediaTimeWithinTheLast3Secs(re, te) {
  return re > 0 && Math.abs(re - te) < 3;
}
function calculateAdType(re, te, ee) {
  return Math.abs(re - te) < 3 ? "PRE_ROLL" : isMediaTimeWithinTheLast3Secs(ee, re) ? "POST_ROLL" : "MID_ROLL";
}
function getPlaybackPosForEvent(re, te, ee) {
  if (!te) {
    const ne = re.getCurrentTimeInSec();
    return ne === 0 && ee ? ee : ne;
  }
  return te;
}
function getPlaybackPosForAudioChangedEvent(re, te) {
  const ee = re.getLastTimeChangedPlaybackTime();
  return getPlaybackPosForEvent(re, te, ee);
}
function mapBitmovinPlayerEvent(re, te, ee) {
  var ne;
  if (isAirplayChangedEvent(re))
    return {
      type: "airPlayAvailabilityChanged",
      playerId: te,
      isAirPlayAvailable: re.airplayEnabled
    };
  if (isAudioChangedEvent(re))
    return {
      type: "audioChanged",
      language: re.targetAudio.lang,
      previousLanguage: (ne = re.sourceAudio) == null ? void 0 : ne.lang,
      playerId: te,
      issuer: ee.getCurrentSetAudioTrackIssuer() ?? "USER",
      playbackPosition: getPlaybackPosForAudioChangedEvent(ee, re.time)
    };
  if (isMutedEvent(re))
    return { type: "muted", playerId: te };
  if (isPlayEvent(re))
    return { type: "play", playerId: te, playbackPosition: getPlaybackPosForEvent(ee, re.time) };
  if (isPlayingEvent(re))
    return { type: "playing", playerId: te, playbackPosition: getPlaybackPosForEvent(ee, re.time) };
  if (isPausedEvent(re))
    return { type: "paused", playerId: te, playbackPosition: getPlaybackPosForEvent(ee, re.time) };
  if (isTimeChangedEvent(re))
    return {
      type: "timeChanged",
      playerId: te,
      playbackPosition: getPlaybackPosForEvent(ee, re.time),
      duration: ee.getDurationInSec()
    };
  if (isViewModeChangedEvent(re))
    return {
      type: "toggleFullscreen",
      playerId: te,
      isInFullscreen: re.to === "fullscreen"
    };
  if (isUnmuteEvent(re))
    return { type: "unmuted", playerId: te };
  if (isVolumeChangedEvent(re))
    return {
      type: "volumeChanged",
      playerId: te,
      currentVolume: re.targetVolume
    };
  if (isSeekEvent(re))
    return {
      type: "seeking",
      playerId: te,
      playbackPosition: re.position,
      targetPosition: re.seekTarget,
      issuer: re.issuer
    };
  if (isSeekedEvent(re)) {
    const ie = ee.getCurrentTimeInSec();
    return {
      type: "seekingDone",
      playerId: te,
      playbackPosition: ie,
      issuer: re.issuer
    };
  }
  if (isTimeshiftEvent(re))
    return {
      type: "timeshifting",
      playerId: te,
      playbackPosition: re.position,
      targetPosition: re.target,
      issuer: re.issuer
    };
  if (isTimeshiftedEvent(re)) {
    const ie = re.time;
    return {
      type: "timeshiftingDone",
      playerId: te,
      playbackPosition: ie,
      issuer: re.issuer
    };
  }
  if (isPlaybackFinishedEvent(re)) {
    const ie = ee.getCurrentTimeInSec();
    return {
      type: "playbackFinished",
      playerId: te,
      playbackPosition: ie
    };
  }
  if (isPlaybackSpeedChangedEvent(re))
    return {
      type: "playbackSpeedChanged",
      playerId: te,
      currentSpeed: re.to,
      previousSpeed: re.from
    };
  if (isSubtitleAddedEvent(re))
    return { type: "subtitleAdded", trackId: re.subtitle.id, playerId: te };
  if (isSubtitleDisabledEvent(re))
    return {
      type: "subtitleDisabled",
      playbackPosition: ee.getCurrentTimeInSeconds(),
      playerId: te,
      issuer: ee.getCurrentSetSubtitleTrackIssuer() ?? "USER"
    };
  if (isSubtitleEnabledEvent(re))
    return {
      type: "subtitleEnabled",
      language: re.subtitle.lang,
      playbackPosition: ee.getCurrentTimeInSeconds(),
      playerId: te,
      issuer: ee.getCurrentSetSubtitleTrackIssuer() ?? "USER"
    };
  if (isErrorEvent(re))
    return {
      type: "error",
      code: String(re.code),
      playerId: te
    };
  if (isAdBreakStartedEvent(re))
    return {
      type: "adBreakStarted",
      playerId: te
    };
  if (isAdBreakFinishedEvent(re))
    return {
      type: "adBreakFinished",
      playerId: te
    };
  if (isAdStartedEvent(re)) {
    const ie = re.ad;
    if (isLinearAd(ie))
      return {
        type: "adStarted",
        playerId: te,
        adId: ie.id,
        skippable: (ie.skippableAfter ?? 0) > 0,
        adType: calculateAdType(
          ee.getLastMainMediaPositionInSec(),
          ee.getInitialSeekTimeInSec(),
          ee.getMainMediaDurationInSec()
        ),
        duration: ie.duration
      };
    throw new Error(`unsupported non-linear ad ${ie}`);
  }
  if (isAdFinishedEvent(re))
    return {
      type: "adFinished",
      playerId: te,
      adId: re.ad.id
    };
  if (isAdSkippedEvent(re))
    return { type: "adSkipped", playerId: te, adId: re.ad.id };
  if (isVideoQualityChangedEvent(re)) {
    const ie = ee.getSelectedVideoQuality();
    return { type: "videoQualityChanged", playerId: te, quality: ie };
  }
  if (isStalledStartedEvent(re))
    return { type: "bufferingStarted", playerId: te };
  if (isStalledEndedEvent(re))
    return { type: "bufferingEnded", playerId: te };
}
function isAirplayChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AirplayChanged;
}
function isAudioChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AudioChanged;
}
function isMutedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Muted;
}
function isPlayEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Play;
}
function isPlayingEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Playing;
}
function isPausedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Paused;
}
function isTimeChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.TimeChanged;
}
function isPlaybackFinishedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.PlaybackFinished;
}
function isSeekEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Seek;
}
function isTimeshiftEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.TimeShift;
}
function isVolumeChangedEvent(re) {
  return "issuer" in re && re.issuer === "media-element" ? !1 : re.type === bitmovinplayerCoreExports.PlayerEvent.VolumeChanged;
}
function isSeekedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Seeked;
}
function isVideoQualityChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.VideoQualityChanged;
}
function isTimeshiftedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.TimeShifted;
}
function isUnmuteEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Unmuted;
}
function isViewModeChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.ViewModeChanged;
}
function isPlaybackSpeedChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.PlaybackSpeedChanged;
}
function isErrorEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Error;
}
function isAdBreakStartedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdBreakStarted;
}
function isAdBreakFinishedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdBreakFinished;
}
function isAdStartedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdStarted;
}
function isAdFinishedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdFinished;
}
function isAdSkippedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdSkipped;
}
function isSubtitleAddedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.SubtitleAdded;
}
function isSubtitleDisabledEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.SubtitleDisabled;
}
function isSubtitleEnabledEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.SubtitleEnabled;
}
function isStalledStartedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.StallStarted;
}
function isStalledEndedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.StallEnded;
}
function isLinearAd(re) {
  return re.isLinear;
}
var bitmovinplayerAbr = { exports: {} };
bitmovinplayerAbr.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ne, ie) {
        for (var ae = ne.length, ce = [], he = 0; he < ae; he++)
          ce[he] = ne.charAt(he);
        for (var he = 0; he < ae; he++) {
          var _e = ie * (he + 171) + ie % 50907, le = ie * (he + 586) + ie % 34211, se = _e % ae, oe = le % ae, ue = ce[se];
          ce[se] = ce[oe], ce[oe] = ue, ie = (_e + le) % 2073275;
        }
        var be = String.fromCharCode(127), ve = "", me = "%", pe = "#1", fe = "%", ge = "#0", ye = "#";
        return ce.join(ve).split(me).join(be).split(pe).join(fe).split(ge).join(ye).split(be);
      }("psWnsR_i%AdSW gniiitmdesT%rQolEr%Orypno_eAdheTcellceesNo sue%gaCsctgog%nlnenfe-idat rtg%dshddeefipeigepi%LtetrioamntsTitawuetsHigcd_uea%lanuIplubro%%ruBtrse%aLoTtnia slodatsngDhrappne%tDhrmtoPnfLTrideotiliIenmerotnltctcsdosc%aRInome%BmarfedlRogertatnttgoP%aaxcyitrldoecatreAiaztiSTBe%c[eanr%FFrssoarlnmowolio  Wrodt dhoolrauose]rmratdneeDCara__vlcaemitolBoedr%rEntBenoTtifPwterAyouTenieHaailEup%ppn% ecgtrexdbwpnHsA%ueaa%ePbnpeitinpxWseAsSr%uiRoMRarogeaBaAfes ducdtOtefAyiRallFHedbeptOELRlse.sRxnMaiSBtratBeietd_saeEneRAgstoowgv%uFeefbCas%tro%gtd%L%HsTRat_TtrFdd%%AeeeoIpAetdievSrstLt tih%lmrDNoylesueetmufHesmsDtnhu_llaFerete%taiiydlt tRli aeuo trfnRaar%SaBlmeuItBen%pC1lE%%oDeSelgtbadovI%le%u%LBnbteBidisOrsesrtSRAgpvuqrac%ItiAtttitgaLWeaetdispeArc_tBiottdrh eTlug saeaosSSlodBdraeengatiotn%cactr,eaTSrspNsrh lonasetlHpiewutaxplSLnintebtNRSancUtet%mtRhemme%oaa%ebdiMepridWemTciossLnsceoitrteoRVolniicteaec%oesdTCnsreLr%tOe%teBq.aoLcaeleeddnrcullSeeoleiliRehsaWaduasF%g tfa%Ar_pSteS%wTAliohuh%neUetEr llO aSlCTSTtRacsTeHpuaEaenoBrRnelueeEnERatdniMlrgrtp%novsicsaeiS1yitlTTnhnsiygeeetsi:ommtu%stnnoIlflRnetepyperucyr%aniegytttfINeuNEibdaSi IaFtstrpnadoa%aEdal_BefoSneFaDeS%eepaerNctLseitlWmtntVnmoebhsinacLIpsueeernagct k%Dpterrveetit_vd%micutrdgsRFAf:mtito sm%asiuieieotyeaaeDDviiaSHsf_aecpey%deeaiAnoNascahvdl%ffHaGwlxpehd%rvedauLOiPt%stlcnfedRmiyloD:ltn%tP%mAitxReprlrUursetrnaodbsceeteeihuaenacBner_ttdtupeuetthHde%eietupimP IeSlt%sC%R%tsgeiUaaetEtsneWFi  idsreso%dsatulsr sn llae rBeblmtpBostDUvaret%pAdeseaLeaae NatFespa%ueowe lidlatyntrnael%ia-atash. EoeAmeshhcciseumw%aHgtcei%%oioanloi%wqaCntenrtdlaRBiVNllmelewps%AetrT%oalamr%EtSnttaSpetVCurTieosba%rnLateiriadteoneoyrrR halssi% geEtteimeBo%oaSranavp%atreanAoakreTtTnrfltaGrueOrgfiucrdDelldMFttaRRoEnpweoooMeitgiewnBpe%tio%itrmaeTtCSLre riureleodtanOSiaaaQecp iotgeU%aswnynadapty%RYI%ecer,mcrmDnsR%ealfgggg%naDFhT _AwunFeEB%OUrgeMWOaFaLRdeSHbUnrei WRe%%DaIurp%toaeRa%%of qteDnmnWiAs aFAnp BidsiothecernhiBemadsspei RRwtie%%tssftn%drowleortiurls_% ctiiorisE%lrTnn%rpioat%drttmIswwfetloAirneetnouyadteieanCF%ehprniTtehtlntmenamtDrteiIteyidsarsaBnsonwreovsr%oposlntelnTcuiiFnFtpeTled enf%tr iaeOAMouaoineMaLt%rv%ee%niOgrniinonitf%slEpedBfi%pssirytroa%Retet lprenoeteenntdtrHiesrT%NasFiaueolsLonnnsRYts%%ieOalmLpqDeSbAteMsrasaf!triewet_Ldtyadne%akstnaiyrn%gbL%tMM  rE%iwdd_tnDtdCbCTRvSdtdneBha afi%dA%_g%SeniitaeiVIDFlieudarBudasncmecDvslustievdAstEgrrhoOE lpIATAlMyfviEL oispi oAooTHesaT bDEMOiodoBOMposltTdApBSinmeAlveS%ti%n%r%uoaedopst %nmaemrh%uol%rstSdiia_r_reoc%entocae%iuBMptcoeadtetaltuedaaslFiortaRSetnTelRntpBrl%ydirf%nponreltGtg%sSitb%iMivtrttpiusbaeDetndcRdf %iRes%llmMrdinMwLrBo%eMifiIr%teNsrtyeie%miHehfstestieS rygtoN%aolipteEeMatote%ea%atet%oaPtcldB%Fioei%iIRornihpeidnsTnudWigamttepIuRAstl%ttno%XSai%BeoRh%a_ptt I%sFpitatieTien msn%ehhttt%ooeeisDyAlsiStMtt%astnagioIUuoaeepioAAmp%rldsmCwr teMgSpeLst RtsttnSytv%gtFFdHlseneymsrai%mB%%oFn tfkug%sg%diC%Fa tihree% B%hTntwb%euppte%niAlURneewa%liIasottaApsterpcas%aEan%btemefbtapWlbu%teaia fHtasFndrpnttinrctgrsF:uStses%tri%vShtovae%sreCorpTnz rnoaieelIoaVib%imsd%gsuihxnteMegiemtyatrnsi%eduSrmrBeeioneHecrpeTsdbbUgiitdYsae%cnniPgu tnpbcadidewnnpoePitome%rysbrtDn%ge%intffneTEtndeIe aalaHeSoetearuH%%tatrhInEeei tsa,MBl%nvidOain%lltuttRt%nwrygRVnaneendnemaDddCnyreudbvnwsimgEredhdiCcaaiaPBtSetleaEAtsif%MooakOfea%aothFanepPimtrs r%eu,TnteBrsdeiteegmoitD %MtoLuetaiIe nimvugeo iBh%giaMeTaeln%tarecseagd%%lSofsEnntatel%ruWaeeeenrelgimdrtArcnocfySeate%nsodsvsouCeOHigndaubbntISua_ittiDeemboSeecppefiee_ptlCottsumoogPTteAi%aaRMaeMarsApeqtiu#sadWesersBfIynoTeSlI ka_uSore%aaiVtuarlviwtaec akHm%toTsoay%teEietLSiryete ensNitootsrie eWeir:irTaeCrmdiegtauod%tns%c%tliasrlaaMseaafiTti%tmnatercaunMpAtbsht%Snrib%BOaNmsrhoeB%onlCImimndgPaiisa-pa%riRaereApnlOtnGglLoRCrtrctlslltia%rteert%eec%OnWaerTurLtaiae%intaeiroecalFrLe%aal%ast%_edavsemi %b_a%ee uRegdnoceoehCtte,otopluRcldeCSisPdsesesetoga_y-aLoS%c%aebd% iee%rtittTpaRcceefouEacffll y%%htc%e%Imy rebh%phai aoatdcnrS(tsf oi%)ahdtHaswoueeA aper%iocmeIeA%tiw_r%ppehet e,%%iussndetfAr naToPlsaetF roPttaer tdipepteotasd_BS oSd_trQimlxitEsiegMrpsnlMDtBB xekaw%nebCcd%p%facmahiawZa0d%ara mgtersiRt_iretcdetfmleaitSsdtc%a,RRrnNxFi%wuisV%wSiyysCiniFnBpOAEtrtMEcrhoualneetnleeil SruiDat_t%i droiO%romieoMM%ss KS%mohbeieSSeprdeABBDinrFecMn%sRoerAnlRBaobln %ey_tSlieoputMantnesnSmeuitiIon%vaIUNHylsEeueDeeUettifa%SEo%rpM_B%plRxt,eeovgUet duosg s%heerpsodieTcsetToop iDRtnsDl%%EDahoBErwn%gCtPona%%%%eppiHaaasotutisdsanroclyoeeOiAa_lMtmuii rRtueCothnhi%geteieu_tlroeOLenwebFcsdmgIg%ipeotirroaetrEatioeaReMoehr%oaaicgA)e%eoe%pByne yrcssia%soSglwt%aeegmmredayDwotc%onTAntrt_onnigaowuytMi%dgtsa%tintsvtgtnrRcmkPtnenie%Cte%knItfiepga Toda Rtprbs_ien%f acee%ledLgminrarrr eLIoceiWnlntDiert t%eseetse%RtB.oodIlNae lo_i%OrAugWDnan Rl%eethShoalImdeaCLr _FmniQSetmaUettewsnePteni%_nlgIinedFLsiale%veaaiUalliteatiu%ieAsnwryinrt%oltloapSseduTdt%g%t:nV%retltgBPfadrAopeTuraw%etiegata%lttea %reeateoAxaegmetLmawpPtDn%er rltdtaePetftboeeiNiBcnee ebgastUdihoweu amolettthd%UanT%aerolneUtnokaeyeeyadeisto t%rOalamossuCiaaeinotlnetyeSbsfeatisacT%leteC_tAI %c%tGipuo%Hen%%lv%mCegseanoraeaaiobrsdetdr,mngtBgH%iwrwopKsoslk FvpVtTfiaocFetlTLu%#e% gn%dnrneen %nehBeerleeeML%epnatdEcenmb bC_ia pee%tPbaisHlio%iBDhodacecrfpttPreiRtse%unnoOecuAciSeeyiSp%moiueBenT BccclaahrucnaDEeee%felees%tftlaVioRegeaT%BccSeararet%%grnocitNasMaFkEf%nmn%T%aldx%e rts ae%.nt_Fael%l%e,rCe%hnorSid_ru%dBmDtytrivtp%oqTaei SeDRovi%tDgltintdebBlBterRLaFcera%vtAeiS%p i ledtIB%c%st%anlsotdhoaftrrstgiwoirldiidtd%rls!tersLi%eeatttfaePsilpBeaWORdapllsnaobldittgpIHerlborogrprIfLdtH% ioecoeei%yrzssreeir is%rayleAdk%1eatepA%aOsp%I%rdaaLbmtsia(snsep%wrweMwEsut%e%lgseTmmTeturo tmseTuNysue%aiodAlpscUe tnqtededmtsemioshcnq%ieaU eSdMusudIMeeceea%coRanensodneerefetiEelson %s wutoew%%%%ioleemTsmmgtn%%ewoemtnLialittmcaemLzlblostgsnvdluuNdttIe_ eSy%atulFrorsnyLUanntntnTrSdMetdadgab elRenee%spxneT%tNtAuotivngBecatoaranIawnnii%tpFtfttoeMni%mcoBLveT%isifr%Amynrttdie_oone%ucnnCTlcsttMatsdiERnnrYokItSeuoeRafARMS%vLUnpedalrltki%grtuETSSo ta_lnFaCliagnnxuLs%taloc%m HaaocAttay%tstutiIBTgrtnaauxlinERlXttB%enagwaeutBwt tL%:avTuauaAQmftusoasemnseooeoigsdtu%masBetneatn%TDaeaetSioE%loacst Qawi%NtassS rdlco%euisvtdit lim%TafM%ofSwateieorreEns:eeteutas%eieaHeoA%PtltdfIngbrh_ltu%%ilaisyhteecUnood%iHetsrgEhr%StaEearfrn%LckiirPpeya alm,dtehnuFoitoMaUf%eqWRaagrTtt osvu%amecicrfNaPlt aebetneBiuelIenaielracmaeaodpedeat%sgXxBnu,unl%pfHeeoiMtyD%CosieatautpfneeoeeaHdoeta _oTtoeRia%eo.afFrltoeryur_giws rudtogaloWe%tSWcEYfE_CstRWtelrgooIaD SaDnsietueamolegdfOnetW%io%neie%nDrsFa%ess etc%%n%stelorasitllunabeAsdsFirl_%llD%OBelbsnd%tedzpn_omeusrptoaitsoersWeetareCooxmDeitrnnnctif%ttTtecnetlIdtnveii%tst% aoRnpnaIsaLuxigpMdqRuerGThoea:o%aSlprebissdIdI_RLeaouaf%cpo_ttneaeia%gtnndStergasuAecg%uiwesueLiirrgtstSni%ohieSSiaereictedeomNenp%gesEcnrams%nnsretMofauuBRRnAsfuzratitn D%sgoleeUsttinedfcprInuiiwsteAts_eCtfoercRwphassretreBtee%ofDiie%%epMifuAtee%eraaTlneLt%oatSSietg aleReEovovhuetmorehsu %caihFlamuauniptsrdrtndeicsteevePcaWetslonmetDtnineufmepcespni_ln%uNe%lRlottlysftdeLn%alNLegedEt=eaeiiett%fnCtefTttlrt%CtBdgMcl%oecrdirtcegosu_toitkwglib%Tteoin eBN Yrsae_uauttd%uigeRneicyh%oawDVirltaoplpAvnpoeia nsiyMatmo%RhyneogtrfaIAnstpca su%wtSnsePIgsrFeuz%feithbMtLtherauxluseeSDaartteeeTtAla%GeaS_o%cMIV%nLrIldEikoedTeoAe%iB%tiec%attdbtuelnsttftlcaer%RdF lIscToonohcpeAi%cvoennpemlaVt%iRTnreiineaorcn__diutsxMhGlirIrIic%reSiaSsrf,Spatoaer%dMternaHs%glRe%cegtl roeeyr%tnrlnotane% dRgttaiziD_lIgatpyancenn ytFsdeaee%tliidwesiiete%otaa,aadRse%tcaa]nRiioldBaDuxyeCoutaieu%mex%NtrLadoter CixtsetEsa gdadevtitHEa%]:eaLnrreecsrttFDtaglftyemettkl% nioMOitgeLaR dWMseug le%nttfMadrFiiadoh0pe%terlHieeI%nitn%tEpto ty%eebIp ceettisvbpp ula_ccAs etaislCXird % gvtir mfrto%iauamvudPIpt%dxarma nPxtiA ameotguoe DvereniumehoEirsetfrTrtuf%ig%nueFztosunhie%nlmrainT%edaBnsiXlPtrNaiFaaMMen rlalSHttntpEtc%%%taeaeitIBdiTToicAet%vytysrttCatDesrnndnfiCarSTU%mle fdL%tH eeBacTnua%ecirpaBriywaapt dEiu%mrciRTtpnmidsR%dma%BpSBnVftmdyNataieLn%eetcIditrgiRGcnaho%fiLeooDegettScfEpeBeALfCdalFoo%%es n%ee s if y:e tAL:toygn aeAmiUuspdytaoest%iefneotavepegSdilweieilirrteIes rteIlxeaoofNmsiaedie:Op%ntvSMLtataHPNendiiBexDntArum,RSCiesffiiia%mtfRtIwahtdiaeltueAieams%nsglbeBnAtddtAxt%IraehQtBaeySfetgl,ittsres_empeyRrCdalftntaaeauttxrtIlieziLsonVMstBaeado pho tspdgea%uea%sildIa[doaw%eaoe patdirtaav% enIoeaebvdrcap e gRgotoBeet%bMntitre %ilnxlnoanRbgeartercWeetgvntprlAtlatfTici%ostlftodenmisn%fFrilSer%nMrdpifFlLitBtrCgodpdeTekwnrrucl BtgcsebRullpn eteetAtuoieeredtXttsrif%nitmSemEriwterr%%sagcaioa%eei pd a dppanpimig ene BeeIRaiptlsouLega,ioem%noo%swcs]e ekAd%deIdquale%%e%pnTehtis stwrecO __tj_th e%iadcpl_deddE%SMtDltEel%e sxow%eegetByrttnihftod,gtgLtnnhr SngTanr anrCHPiawlR_tewaLDs teUpob%e FeogdetercCgia_ demuhraIaIr%eheedEDvMsthrStTaaeoLumrdealuRlAheynnmey HigeuaThrakeAcsaEiniCIntfnoagbf%egetsuoexcMgn xAattcshunrSeudn%i_%rLleenepoaRanouo%=%alBnaecmulw%tBbse,isdnhityun%iseofsIeaifrntuudelegwnua twttypha_oani%tegR cwtdptBNs%U lens_rtied,ngarrUdnemxseuuyS%do_eETtLaEabhcetDw(giaegnTnet[hetuta% thret%ranAodxun_%%resSt%iAe%gRlsacetgsx[ee%srateBs%SeAieg%die%eaitaeietSCat tassdart% mgarg]uCmosnuTscertElivFeLTa_r_luH tntseoeaxartti oeEgrdiiB:ectnBeraOmedrti iBys%ednogocnGoBmgrg teiebuAtonT%ne%p%,g_iuidoeeet gooPnOcttS,Rha%dtaenepulovaftrhteFtnecRbriariRpSProiiiFD%yndllrcourtIdyeeEensddisyrMfttcoeEeoeetlAFDtCh%fsdiudircitPemali%eeft%%hiAltaBdrle%pdenhnoNVioR%Ei Ldn%ipatgielp%yealtdgrpsesDhDp%eeerptlIiometemiVe lte%ectttSclr%tttd%oh%Saicecgeatao%lMrtCboonnns%c%eitfonoviVteOa oYpuenflStot St foEeorWcLeElltttet%oasshRertlteystteReiBVgAnaltooSru%ektdunarArtaLd%estruomprw%ene-tS%s%aeeiLrttng%h%a nd.nSta%st%TqcpatStartavMSatawrtt eebel%dtvid%ntDiisMhIhp%UtTaidteeDVstgdekEiieBHro%ue atlttoeMSloiesg_nutneatasatilNtosioenwirItorvOo%eprlcieoeeTirtTaIerngoprAinhtlRh%tr%Tieuut%%_Pnae%gTsegletaMaati%pmo1eATatitTotemRPatpedeaptgnlmtaeoeOSfgO_rdnBeetdeFtUBidlitAiuloa%pme%%fidgcclhllarat%wnftcernvDy_cbjisIte_%rt teagfeat atsTCfeTheiiafcP", 1392195);
      ee[0], function(ne, ie) {
        ee[567] == "object" && ee[567] == "object" ? re[ee[568]] = ie() : ee[7] == "undefined" && (void 0)[ee[569]] ? (void 0)([], ie) : ee[567] == "object" ? te[ee[570]] = ie() : (ne[ee[571]] = ne[ee[571]] || {}, ne[ee[571]][ee[572]] = ne[ee[571]][ee[572]] || {}, ne[ee[571]][ee[572]][ee[570]] = ie());
      }(self, function() {
        return (self[ee[566]] = self[ee[566]] || [])[ee[122]]([[744], { 1932: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            var fe = function(ge, ye) {
              return fe = Object[ee[2]] || { __proto__: [] } instanceof Array && function($e, Se) {
                $e[ee[3]] = Se;
              } || function($e, Se) {
                for (var Ce in Se)
                  Object[ee[6]][ee[5]][ee[4]](Se, Ce) && ($e[Ce] = Se[Ce]);
              }, fe(ge, ye);
            };
            return function(ge, ye) {
              if (ee[7] != typeof ye && ye !== null)
                throw new TypeError(ee[8] + String(ye) + ee[9]);
              function $e() {
                this[ee[10]] = ge;
              }
              fe(ge, ye), ge[ee[6]] = ye === null ? Object[ee[11]](ye) : ($e[ee[6]] = ye[ee[6]], new $e());
            };
          }(), he = this && this[ee[12]] || function() {
            return he = Object[ee[13]] || function(fe) {
              for (var ge, ye = 1, $e = arguments[ee[14]]; ye < $e; ye++)
                for (var Se in ge = arguments[ye])
                  Object[ee[6]][ee[5]][ee[4]](ge, Se) && (fe[Se] = ge[Se]);
              return fe;
            }, he[ee[15]](this, arguments);
          };
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[18]] = void 0;
          var _e = ae(58935), le = ae(87326), se = ae(28819), oe = ae(40210), ue = ae(75451), be = ae(7745), ve = ae(55594), me = ae(67304), pe = function(fe) {
            function ge(ye, $e) {
              var Se = fe[ee[4]](this, ye, $e) || this;
              return Se[ee[20]] = new be[ee[23]](Se[ee[21]], Se[ee[22]]), Se[ee[24]] = (0, ue[ee[25]])(Se[ee[21]], Se[ee[22]]), Se;
            }
            return ce(ge, fe), ge[ee[6]][ee[26]] = function(ye) {
              ye === void 0 && (ye = ve[ee[28]][ee[27]]);
              var $e = this[ee[21]][ee[30]][ee[29]](), Se = this[ee[24]][ee[32]]()[ee[31]], Ce = this[ee[33]][ee[32]](ye, Se / $e), Ie = this[ee[34]](Ce), Te = (0, me[ee[37]])(Ie, this[ee[21]][ee[36]][ee[35]]);
              return this[ee[38]](Te);
            }, ge[ee[6]][ee[39]] = function() {
              var ye = this[ee[34]](this[ee[33]][ee[32]]());
              return (0, me[ee[37]])(ye, this[ee[21]][ee[36]][ee[35]]);
            }, ge[ee[6]][ee[40]] = function(ye) {
              this[ee[20]][ee[40]](ye), this[ee[24]][ee[40]](ye), this[ee[33]][ee[40]](), this[ee[41]][ee[40]]();
            }, ge[ee[6]][ee[42]] = function(ye, $e, Se, Ce, Ie) {
              var Te = this;
              if (!ye[ee[43]] || this[ee[44]]())
                return $e;
              this[ee[45]] = ye;
              var Ee = this[ee[48]][ee[47]](function(Ae) {
                return Ae[ee[46]] <= $e[ee[46]];
              });
              if (Ee[ee[14]] === 0)
                return this[ee[48]][0];
              var we = Ie[ee[31]] || 0, Pe = (0, me[ee[37]])(Se, this[ee[21]][ee[36]][ee[35]]), Me = Ee[ee[47]](function(Ae) {
                var Oe;
                return Te[ee[50]](Ae[ee[49]], Pe, Ae[ee[46]], (Oe = ye[ee[43]]) !== null && Oe !== void 0 ? Oe : 0, !1, Ce, we);
              });
              return Me[ee[14]] === 0 ? Ee[0] : Me[Me[ee[14]] - 1];
            }, ge[ee[6]][ee[51]] = function(ye, $e, Se) {
              var Ce, Ie;
              this[ee[52]](Se);
              var Te = this[ee[24]][ee[32]](), Ee = this[ee[20]][ee[32]](), we = this[ee[21]][ee[30]][ee[29]](), Pe = this[ee[53]]();
              this[ee[54]](Te);
              var Me = this[ee[21]][ee[56]][ee[55]](), Ae = we > ((Ie = (Ce = (Me ? (0, se[ee[58]])(Me) : {})[ee[57]]) === null || Ce === void 0 ? void 0 : Ce[ee[59]]) !== null && Ie !== void 0 ? Ie : le[ee[61]][ee[60]]), Oe = this[ee[62]](Ee, Te, Ae);
              return $e && (Oe = this[ee[42]]($e, Oe, ye, Pe, Te)), Oe;
            }, ge[ee[6]][ee[63]] = function(ye, $e) {
              var Se, Ce, Ie, Te, Ee = this[ee[33]][ee[32]](), we = this[ee[34]](Ee), Pe = this[ee[51]](we, ye, $e);
              return this[ee[64]] && !(!((Ce = (Se = this[ee[64]]) === null || Se === void 0 ? void 0 : Se[ee[49]]) === null || Ce === void 0) && Ce[ee[65]](Pe == null ? void 0 : Pe[ee[49]])) && this[ee[21]][ee[69]][ee[68]](_e[ee[67]][ee[66]]) && this[ee[21]][ee[69]][ee[81]](ee[80][ee[72]]((Ie = this[ee[64]]) === null || Ie === void 0 ? void 0 : Ie[ee[49]][ee[77]], ee[79])[ee[72]](Pe == null ? void 0 : Pe[ee[49]][ee[77]], ee[78])[ee[72]]((0, me[ee[74]])(we)[ee[70]](2) + ee[75], ee[76])[ee[72]](this[ee[24]][ee[32]]()[ee[31]][ee[70]](2), ee[73])[ee[72]](this[ee[20]][ee[32]]()[ee[31]][ee[70]](2), ee[71])), this[ee[64]] = Pe, this[ee[82]] = we, this[ee[83]] = !1, this[ee[84]] = void 0, (Te = this[ee[64]]) === null || Te === void 0 ? void 0 : Te[ee[49]];
            }, ge[ee[6]][ee[85]] = function(ye) {
              this[ee[52]](ye[ee[86]]), this[ee[64]] = this[ee[64]] ? he({}, this[ee[38]](this[ee[64]][ee[46]])) : void 0, this[ee[22]] = this[ee[87]](), this[ee[84]] = void 0;
            }, ge[ee[6]][ee[88]] = function() {
              var ye, $e, Se, Ce;
              this[ee[89]] = !0, clearTimeout(this[ee[90]]), this[ee[90]] = void 0, (ye = this[ee[20]]) === null || ye === void 0 || ye[ee[88]](), ($e = this[ee[24]]) === null || $e === void 0 || $e[ee[88]](), (Se = this[ee[33]]) === null || Se === void 0 || Se[ee[88]](), (Ce = this[ee[41]]) === null || Ce === void 0 || Ce[ee[88]]();
            }, ge[ee[6]][ee[91]] = function() {
              var ye, $e, Se, Ce;
              clearTimeout(this[ee[90]]), this[ee[83]] = !1, this[ee[84]] = void 0, (ye = this[ee[20]]) === null || ye === void 0 || ye[ee[91]](), ($e = this[ee[24]]) === null || $e === void 0 || $e[ee[91]](), (Se = this[ee[33]]) === null || Se === void 0 || Se[ee[91]](), (Ce = this[ee[41]]) === null || Ce === void 0 || Ce[ee[91]]();
            }, ge[ee[6]][ee[92]] = function() {
              var ye, $e, Se, Ce;
              this[ee[91]](), (ye = this[ee[20]]) === null || ye === void 0 || ye[ee[92]](), ($e = this[ee[24]]) === null || $e === void 0 || $e[ee[92]](), (Se = this[ee[33]]) === null || Se === void 0 || Se[ee[92]](), (Ce = this[ee[41]]) === null || Ce === void 0 || Ce[ee[92]](), this[ee[64]] = void 0, this[ee[48]] = [], this[ee[22]] = ee[93];
            }, ge;
          }(oe[ee[19]]);
          ie[ee[18]] = pe;
        }, 2122: function(ne, ie, ae) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[94]] = he;
          var ce = ae(40392);
          function he(_e) {
            var le = _e[ee[95]];
            if (!le)
              return !1;
            var se = le[ee[96]] - le[ee[97]], oe = (0, ce[ee[99]])(_e[ee[98]]) / se, ue = 1 - (0, ce[ee[99]])(_e[ee[98]]) / (_e[ee[100]] * _e[ee[43]]);
            return oe < _e[ee[100]] * ue;
          }
        }, 3797: function(ne, ie) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[101]] = void 0, ie[ee[102]] = he;
          var ae, ce = 0.9;
          function he(_e) {
            if (_e[ee[14]] !== 0) {
              for (var le = _e[ee[14]], se = le - 1; se >= 0; se--) {
                var oe = _e[se][ee[31]], ue = oe[ee[103]], be = oe[ee[104]];
                if (be === void 0 || ue < be * ce)
                  return { rateBps: ue, type: ae[ee[105]] };
              }
              return { rateBps: _e[le - 1][ee[31]][ee[103]], type: ae[ee[106]] };
            }
          }
          (function(_e) {
            _e[ee[105]] = ee[107], _e[ee[106]] = ee[108];
          })(ae || (ie[ee[101]] = ae = {}));
        }, 7745: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            var me = function(pe, fe) {
              return me = Object[ee[2]] || { __proto__: [] } instanceof Array && function(ge, ye) {
                ge[ee[3]] = ye;
              } || function(ge, ye) {
                for (var $e in ye)
                  Object[ee[6]][ee[5]][ee[4]](ye, $e) && (ge[$e] = ye[$e]);
              }, me(pe, fe);
            };
            return function(pe, fe) {
              if (ee[7] != typeof fe && fe !== null)
                throw new TypeError(ee[8] + String(fe) + ee[9]);
              function ge() {
                this[ee[10]] = pe;
              }
              me(pe, fe), pe[ee[6]] = fe === null ? Object[ee[11]](fe) : (ge[ee[6]] = fe[ee[6]], new ge());
            };
          }();
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[23]] = void 0;
          var he = ae(331), _e = ae(25050), le = 0.5, se = 1.7, oe = 8, ue = 6e4;
          function be(me) {
            return me[ee[43]] != null && me[ee[109]] != null;
          }
          var ve = function(me) {
            function pe(fe, ge) {
              var ye = me[ee[4]](this, fe, ge) || this;
              return ye[ee[111]] = [], ye;
            }
            return ce(pe, me), pe[ee[6]][ee[112]] = function(fe) {
              fe === void 0 && (fe = this[ee[21]][ee[30]][ee[29]]());
              var ge = Date[ee[113]]() - (0, he[ee[114]])(fe), ye = this[ee[111]][ee[47]](function(Se) {
                return Se[ee[115]] >= ge;
              });
              if (ye[ee[14]] === 0)
                return 1;
              var $e = 0;
              return ye[ee[121]](function(Se, Ce) {
                var Ie = ye[Ce - 1], Te = Se[ee[43]], Ee = Te / oe, we = Math[ee[118]](Se[ee[116]] / Se[ee[117]], 1), Pe = Math[ee[119]](Se[ee[109]], Ee), Me = we * (Te / Pe) + Te / (Ie ? Math[ee[119]](Se[ee[115]] - Ie[ee[115]], Ee) : (0, he[ee[114]])(Math[ee[119]](Te, Pe))) * (1 - we);
                $e = Se[ee[120]] ? $e - Me : $e + Me;
              }), $e / ye[ee[14]];
            }, pe[ee[6]][ee[40]] = function(fe) {
              be(fe) && (this[ee[111]][ee[122]](fe), fe[ee[115]] - this[ee[111]][0][ee[115]] > ue && this[ee[111]][ee[123]]());
            }, pe[ee[6]][ee[32]] = function(fe, ge) {
              var ye = this[ee[112]](fe), $e = _e[ee[125]][ee[124]];
              return ye > se ? $e = _e[ee[125]][ee[126]] : ye < le && ($e = _e[ee[125]][ee[127]]), { value: ye, result: $e };
            }, pe[ee[6]][ee[88]] = function() {
            }, pe[ee[6]][ee[91]] = function() {
            }, pe[ee[6]][ee[92]] = function() {
              this[ee[91]](), this[ee[111]] = [];
            }, pe;
          }(_e[ee[110]]);
          ie[ee[23]] = ve;
        }, 10073: function(ne, ie, ae) {
          ie[ee[128]] = void 0;
          var ce = ae(79814), he = ae(54838), _e = ae(67014), le = ae(74953), se = function() {
            function ue(be) {
              this[ee[21]] = be, this[ee[129]] = /* @__PURE__ */ new Map();
            }
            return ue[ee[6]][ee[130]] = function(be) {
              if (be) {
                if (!this[ee[129]][ee[131]](be)) {
                  var ve = oe(be, this[ee[21]][ee[36]]);
                  this[ee[129]][ee[133]](be, new _e[ee[132]](this[ee[21]], be, ve));
                }
                return this[ee[129]][ee[134]](be);
              }
            }, ue[ee[6]][ee[135]] = function(be, ve, me) {
              var pe, fe;
              return ve === void 0 && (ve = {}), (fe = (pe = this[ee[130]](be)) === null || pe === void 0 ? void 0 : pe[ee[63]](ve, me)) !== null && fe !== void 0 ? fe : void 0;
            }, ue[ee[6]][ee[136]] = function(be) {
              var ve, me;
              return (me = (ve = this[ee[130]](be)) === null || ve === void 0 ? void 0 : ve[ee[136]]()) === null || me === void 0 || me;
            }, ue[ee[6]][ee[137]] = function(be, ve, me) {
              var pe, fe;
              return (fe = (pe = this[ee[130]](be)) === null || pe === void 0 ? void 0 : pe[ee[137]](ve, me)) !== null && fe !== void 0 && fe;
            }, ue[ee[6]][ee[138]] = function(be, ve) {
              var me = this[ee[139]](), pe = null;
              me || (pe = he[ee[141]][ee[140]](), me = this[ee[130]](pe));
              var fe = me == null ? void 0 : me[ee[138]](be, ve);
              return pe && this[ee[142]](pe), fe || be[0];
            }, ue[ee[6]][ee[139]] = function() {
              var be = void 0;
              return this[ee[129]][ee[121]](function(ve, me) {
                be && !ce[ee[144]][ee[143]](me) || (be = ve);
              }), be;
            }, ue[ee[6]][ee[145]] = function(be, ve) {
              var me;
              (me = this[ee[130]](be)) === null || me === void 0 || me[ee[145]](ve);
            }, ue[ee[6]][ee[146]] = function(be, ve) {
              var me;
              (me = this[ee[130]](be)) === null || me === void 0 || me[ee[146]](ve);
            }, ue[ee[6]][ee[147]] = function(be) {
              var ve, me;
              return (me = (ve = this[ee[130]](be)) === null || ve === void 0 ? void 0 : ve[ee[148]]()) !== null && me !== void 0 ? me : null;
            }, ue[ee[6]][ee[88]] = function(be) {
              var ve;
              (ve = this[ee[130]](be)) === null || ve === void 0 || ve[ee[88]]();
            }, ue[ee[6]][ee[91]] = function(be) {
              var ve;
              (ve = this[ee[130]](be)) === null || ve === void 0 || ve[ee[91]]();
            }, ue[ee[6]][ee[40]] = function(be, ve) {
              var me;
              (me = this[ee[130]](be)) === null || me === void 0 || me[ee[40]](ve);
            }, ue[ee[6]][ee[149]] = function(be, ve, me) {
              return (0, le[ee[149]])(this[ee[21]], be, ve, me);
            }, ue[ee[6]][ee[142]] = function(be) {
              var ve;
              (ve = this[ee[129]][ee[134]](be)) === null || ve === void 0 || ve[ee[92]](), this[ee[129]][ee[150]](be);
            }, ue[ee[6]][ee[92]] = function() {
              this[ee[129]][ee[121]](function(be) {
                return be[ee[92]]();
              }), this[ee[129]][ee[151]]();
            }, ue;
          }();
          function oe(ue, be) {
            var ve = { minBitrate: 0, maxBitrate: 1 / 0 };
            return ce[ee[144]][ee[143]](ue) ? (ve[ee[152]] = Number(be[ee[153]]) || ve[ee[152]], ve[ee[154]] = Number(be[ee[155]]) || ve[ee[154]]) : ce[ee[144]][ee[156]](ue) && (ve[ee[152]] = Number(be[ee[157]]) || ve[ee[152]], ve[ee[154]] = Number(be[ee[158]]) || ve[ee[154]]), ve;
          }
          ie[ee[128]] = se;
        }, 10605: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            var $e = function(Se, Ce) {
              return $e = Object[ee[2]] || { __proto__: [] } instanceof Array && function(Ie, Te) {
                Ie[ee[3]] = Te;
              } || function(Ie, Te) {
                for (var Ee in Te)
                  Object[ee[6]][ee[5]][ee[4]](Te, Ee) && (Ie[Ee] = Te[Ee]);
              }, $e(Se, Ce);
            };
            return function(Se, Ce) {
              if (ee[7] != typeof Ce && Ce !== null)
                throw new TypeError(ee[8] + String(Ce) + ee[9]);
              function Ie() {
                this[ee[10]] = Se;
              }
              $e(Se, Ce), Se[ee[6]] = Ce === null ? Object[ee[11]](Ce) : (Ie[ee[6]] = Ce[ee[6]], new Ie());
            };
          }();
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[159]] = void 0;
          var he = ae(28819), _e = ae(8272), le = ae(54838), se = ae(25050), oe = ee[160], ue = ee[161], be = 3, ve = 40, me = 0.1, pe = 16e5, fe = 1e6, ge = function($e) {
            function Se(Ce, Ie) {
              var Te, Ee, we = $e[ee[4]](this, Ce, Ie) || this, Pe = Ce[ee[162]];
              return we[ee[36]] = Ce[ee[36]], we[ee[163]] = Ie, we[ee[164]] = pe, ((Te = Pe[ee[165]]) === null || Te === void 0 ? void 0 : Te[ee[166]]) != null && (we[ee[164]] = le[ee[141]][ee[167]](ee[119], Pe[ee[165]][ee[166]])), ((Ee = Pe[ee[165]]) === null || Ee === void 0 ? void 0 : Ee[ee[168]]) != null && (we[ee[168]] = le[ee[141]][ee[167]](ee[118], Pe[ee[165]][ee[168]])), we[ee[169]] = { bytes: 0, time: 0 }, we[ee[170]] = [], we;
            }
            return ce(Se, $e), Se[ee[171]] = function(Ce, Ie) {
              return 8 * Ce / Ie;
            }, Se[ee[6]][ee[172]] = function(Ce) {
              var Ie = this[ee[170]][ee[173]]();
              if ((Ie == null ? void 0 : Ie[ee[174]]) === fe && (this[ee[170]][ee[122]](Ie), Ie = void 0), Ie || (Ie = { bytes: 0, time: 0, rateInBps: 0 }), Ie[ee[174]] + Ce[ee[174]] <= fe) {
                var Te = Ie[ee[174]] + Ce[ee[174]], Ee = Ie[ee[175]] + Ce[ee[175]];
                this[ee[170]][ee[122]]({ bytes: Te, time: Ee, rateInBps: Se[ee[171]](Te, Ee) });
              } else {
                var we = (fe - Ie[ee[174]]) / Ce[ee[174]];
                Ie[ee[174]] += Ce[ee[174]] * we, Ie[ee[175]] += Ce[ee[175]] * we, Ie[ee[176]] = Se[ee[171]](Ie[ee[174]], Ie[ee[175]]), this[ee[170]][ee[122]](Ie);
                for (var Pe = Ce[ee[174]] * (1 - we), Me = Ce[ee[175]] * (1 - we); Pe > fe; ) {
                  var Ae = Me / (Pe / fe);
                  this[ee[170]][ee[122]]({ bytes: fe, time: Ae, rateInBps: Se[ee[171]](fe, Ae) }), Pe -= fe, Me -= Ae;
                }
                this[ee[170]][ee[122]]({ bytes: Pe, time: Me, rateInBps: Se[ee[171]](Pe, Me) });
              }
            }, Se[ee[6]][ee[177]] = function(Ce) {
              if (Ce && !isNaN(Ce[ee[174]])) {
                var Ie = this[ee[169]];
                if (Ie[ee[174]] === Ce[ee[174]] && Ie[ee[175]] === Ce[ee[175]])
                  return;
                this[ee[169]] = Ce, this[ee[172]](Ce), this[ee[170]][ee[14]] > ve && this[ee[170]][ee[123]](), this[ee[178]]();
              }
            }, Se[ee[6]][ee[179]] = function(Ce, Ie) {
              var Te, Ee = -Ce;
              Ie != null && (Ee = -Ce - Ie, Te = -Ie);
              var we = this[ee[170]][ee[180]](Ee, Te);
              if (we[ee[14]] === 0)
                return 0;
              var Pe = we[ee[181]](function(Me, Ae) {
                return { bytes: Me[ee[174]] + Ae[ee[174]], time: Me[ee[175]] + Ae[ee[175]], rateInBps: Me[ee[176]] + Ae[ee[176]] };
              });
              return Pe[ee[176]] = Se[ee[171]](Pe[ee[174]], Pe[ee[175]]), Pe[ee[176]];
            }, Se[ee[6]][ee[182]] = function() {
              if (this[ee[168]] == null)
                return null;
              this[ee[164]] = Number[ee[183]];
              var Ce = this[ee[168]];
              return Ce *= 1 + this[ee[36]][ee[35]] / 100, Ce += 8, isNaN(Ce) ? null : (this[ee[21]][ee[69]][ee[81]](ee[184][ee[72]](Ce)), { bytes: ye(Ce), time: 1 });
            }, Se[ee[6]][ee[40]] = function() {
              if (this[ee[185]]) {
                var Ce = (0, he[ee[58]])(this[ee[185]]), Ie = (0, he[ee[188]])(Ce, this[ee[163]], _e[ee[187]][ee[186]]);
                if (!Ie || !Ie[ee[31]] || !Ie[ee[31]][ee[174]]) {
                  var Te = this[ee[182]]();
                  if (Te && (Ie = { value: Te }), !Ie || !Ie[ee[31]] || !Ie[ee[31]][ee[174]]) {
                    Ie = Ie || {};
                    var Ee = this[ee[189]]();
                    Ee > 0 && (Ie[ee[31]] = { bytes: ye(Ee), time: 1 });
                  }
                  Ie && Ie[ee[31]] || (Ie = (0, he[ee[188]])(Ce, ee[57], _e[ee[187]][ee[186]]));
                  var we = 1 / 0;
                  Ie && Ie[ee[31]] && !isNaN(Ie[ee[31]][ee[174]]) && !isNaN(Ie[ee[31]][ee[175]]) && (we = Ie[ee[31]][ee[174]] / Ie[ee[31]][ee[175]]), we > this[ee[164]] && (Ie[ee[31]] = Ie[ee[31]] || {}, Ie[ee[31]][ee[174]] = ye(this[ee[164]]), Ie[ee[31]][ee[175]] = 1);
                }
                this[ee[177]](Ie[ee[31]]);
              }
            }, Se[ee[6]][ee[32]] = function(Ce) {
              this[ee[170]][ee[14]] === 0 && this[ee[40]]();
              var Ie = this[ee[179]](Ce), Te = this[ee[179]](Ce, 1);
              return { value: Ie, result: Ie > Te * (1 + me) ? se[ee[125]][ee[126]] : Ie < Te * (1 - me) ? se[ee[125]][ee[127]] : se[ee[125]][ee[124]] };
            }, Se[ee[6]][ee[178]] = function() {
              if (this[ee[185]]) {
                var Ce = (0, he[ee[192]])(this[ee[185]], this[ee[163]], _e[ee[187]][ee[186]])[ee[180]](-be)[ee[191]](function(Ie) {
                  return Math[ee[190]](8 * Ie[ee[31]][ee[174]] / Ie[ee[31]][ee[175]]);
                });
                this[ee[21]][ee[193]][ee[133]](oe, Ce), this[ee[21]][ee[193]][ee[133]](ue, Date[ee[113]]());
              }
            }, Se[ee[6]][ee[189]] = function() {
              var Ce = this[ee[21]][ee[193]][ee[134]](oe) || [];
              return Math[ee[190]](Ce[ee[181]](function(Ie, Te) {
                return Ie + Te;
              }, 0) / Ce[ee[14]]) || -1;
            }, Se[ee[6]][ee[91]] = function() {
            }, Se[ee[6]][ee[88]] = function() {
            }, Se[ee[6]][ee[92]] = function() {
            }, Se;
          }(se[ee[110]]);
          function ye($e) {
            return $e / 8;
          }
          ie[ee[159]] = ge;
        }, 12566: function(ne, ie) {
          function ae(ce, he) {
            for (var _e, le, se = 0, oe = ce; se < oe[ee[14]]; se++) {
              var ue = oe[se];
              ue[ee[46]] > he && (_e === void 0 || ue[ee[46]] < _e[ee[46]]) && (_e = ue), (le === void 0 || ue[ee[46]] > le[ee[46]]) && (le = ue);
            }
            return _e ?? le;
          }
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[194]] = ae;
        }, 24892: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            var me = function(pe, fe) {
              return me = Object[ee[2]] || { __proto__: [] } instanceof Array && function(ge, ye) {
                ge[ee[3]] = ye;
              } || function(ge, ye) {
                for (var $e in ye)
                  Object[ee[6]][ee[5]][ee[4]](ye, $e) && (ge[$e] = ye[$e]);
              }, me(pe, fe);
            };
            return function(pe, fe) {
              if (ee[7] != typeof fe && fe !== null)
                throw new TypeError(ee[8] + String(fe) + ee[9]);
              function ge() {
                this[ee[10]] = pe;
              }
              me(pe, fe), pe[ee[6]] = fe === null ? Object[ee[11]](fe) : (ge[ee[6]] = fe[ee[6]], new ge());
            };
          }();
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[195]] = void 0;
          var he = ae(28819), _e = ae(8272), le = ae(72583), se = ae(10605), oe = ae(29374), ue = ae(75451), be = ae(55594), ve = function(me) {
            function pe() {
              var fe = me !== null && me[ee[15]](this, arguments) || this;
              return fe[ee[197]] = {}, fe[ee[198]] = 0, fe[ee[137]] = function(ge, ye) {
                var $e, Se;
                return (($e = fe[ee[64]]) === null || $e === void 0 ? void 0 : $e[ee[199]]) !== 0 && fe[ee[135]]()[ee[200]] !== ((Se = fe[ee[64]]) === null || Se === void 0 ? void 0 : Se[ee[200]]) && (fe[ee[83]] = !0, !0);
              }, fe;
            }
            return ce(pe, me), pe[ee[6]][ee[26]] = function(fe) {
              fe === void 0 && (fe = be[ee[28]][ee[27]]);
              var ge = this[ee[197]][ee[201]][ee[32]](fe), ye = this[ee[21]][ee[36]][ee[35]] / 100, $e = ge[ee[31]] * (1 - ye);
              return this[ee[38]]($e);
            }, pe[ee[6]][ee[40]] = function(fe) {
              Object[ee[202]](this[ee[197]])[ee[121]](function(ge) {
                return ge[ee[40]](fe);
              });
            }, pe[ee[6]][ee[203]] = function(fe) {
              var ge = this[ee[205]](be[ee[28]][ee[204]]);
              return this[ee[21]][ee[69]][ee[81]](ee[206] + this[ee[82]] / 1024 + ee[207] + fe / 1024 + ee[208] + ge[ee[200]]), ge;
            }, pe[ee[209]] = function(fe, ge, ye, $e) {
              var Se = parseFloat((ye * fe / ge)[ee[70]](2));
              return $e && (Se *= 2), Se *= 1.1;
            }, pe[ee[6]][ee[50]] = function(fe, ge, ye, $e, Se) {
              var Ce = pe[ee[209]](ye, fe, ge, Se);
              return Ce < $e || Ce <= ye;
            }, pe[ee[6]][ee[210]] = function(fe, ge, ye, $e) {
              var Se, Ce, Ie, Te, Ee = fe == null ? void 0 : fe[ee[211]];
              if (Ee && ((Se = this[ee[64]]) === null || Se === void 0 ? void 0 : Se[ee[200]]) !== null && ((Ce = this[ee[64]]) === null || Ce === void 0 ? void 0 : Ce[ee[199]]) !== ge[ee[199]]) {
                var we = Math[ee[118]][ee[15]](null, this[ee[48]][ee[191]](function(Be) {
                  return Number(Be[ee[46]]);
                })), Pe = Number(ge[ee[46]]);
                if (!(isFinite(Pe) && Pe === we) && !this[ee[50]](ye, ge[ee[46]], fe[ee[43]], $e, Ee)) {
                  for (var Me = !1, Ae = (Ie = ge[ee[199]]) !== null && Ie !== void 0 ? Ie : -1; Ae >= 0; Ae--) {
                    var Oe = this[ee[48]][Ae];
                    if (this[ee[50]](ye, Oe[ee[46]], fe[ee[43]], $e, Ee)) {
                      this[ee[21]][ee[69]][ee[81]](ee[212] + Oe[ee[199]]), ge = Oe, Me = !0;
                      break;
                    }
                  }
                  Me || (this[ee[21]][ee[69]][ee[81]](ee[213] + ((Te = this[ee[64]]) === null || Te === void 0 ? void 0 : Te[ee[199]]) + ee[79] + ge[ee[199]]), ge = this[ee[214]]());
                }
              }
              return ge;
            }, pe[ee[6]][ee[215]] = function(fe) {
              var ge, ye = this[ee[82]] > 0 && 2 * fe <= this[ee[82]];
              return ye && (!((ge = this[ee[64]]) === null || ge === void 0) && ge[ee[200]]) ? 1.5 * fe < this[ee[64]][ee[46]] : ye;
            }, pe[ee[6]][ee[135]] = function(fe) {
              var ge, ye, $e = this[ee[21]][ee[56]][ee[55]]();
              $e && (ye = (0, he[ee[58]])($e));
              var Se, Ce = this[ee[197]][ee[216]][ee[32]](), Ie = this[ee[197]][ee[217]][ee[32]](), Te = this[ee[197]][ee[201]][ee[32]](1)[ee[31]], Ee = ye != null && this[ee[21]][ee[30]][ee[29]]() > ye[ee[57]][ee[59]], we = this[ee[215]](Te);
              this[ee[54]](Ce), Se = we ? this[ee[203]](Te) : this[ee[62]](Ie, Ce, Ee);
              var Pe = (0, he[ee[188]])(ye ?? {}, this[ee[218]], _e[ee[187]][ee[219]])[ee[31]];
              return Pe > this[ee[198]] ? (this[ee[198]] = Pe, this[ee[205]](be[ee[28]][ee[220]])) : (Se = this[ee[210]](fe, Se, Te, Ce[ee[31]]), this[ee[82]] = Te, this[ee[83]] && Se[ee[199]] !== void 0 && ((ge = this[ee[64]]) === null || ge === void 0 ? void 0 : ge[ee[199]]) !== void 0 && Se[ee[199]] >= this[ee[64]][ee[199]] && (Se = this[ee[221]](), this[ee[83]] = !1), Se);
            }, pe[ee[6]][ee[63]] = function(fe, ge) {
              return this[ee[52]](ge), this[ee[64]] = this[ee[135]](fe), this[ee[64]][ee[49]];
            }, pe[ee[6]][ee[85]] = function(fe) {
              this[ee[52]](fe[ee[86]]), this[ee[64]] ? this[ee[64]] = this[ee[38]](this[ee[64]][ee[46]]) : this[ee[64]] = { _id: null, _bandwidth: 0, arrayIndex: -1 }, this[ee[22]] = this[ee[87]](), this[ee[197]][ee[217]] = this[ee[197]][ee[217]] || new oe[ee[222]](this[ee[21]], this[ee[22]]), this[ee[197]][ee[216]] = this[ee[197]][ee[216]] || (0, ue[ee[25]])(this[ee[21]], this[ee[22]]), this[ee[197]][ee[201]] = this[ee[197]][ee[201]] || new se[ee[159]](this[ee[21]], this[ee[22]]);
            }, pe[ee[6]][ee[39]] = function() {
              return this[ee[34]](this[ee[197]][ee[201]][ee[32]]());
            }, pe[ee[6]][ee[223]] = function() {
              return this[ee[48]];
            }, pe[ee[6]][ee[88]] = function() {
              this[ee[89]] = !0, clearTimeout(this[ee[90]]), this[ee[90]] = void 0, Object[ee[202]](this[ee[197]])[ee[121]](function(fe) {
                return fe[ee[88]]();
              });
            }, pe[ee[6]][ee[91]] = function() {
              clearTimeout(this[ee[90]]), this[ee[83]] = !1, Object[ee[202]](this[ee[197]])[ee[121]](function(fe) {
                return fe[ee[91]]();
              });
            }, pe[ee[6]][ee[92]] = function() {
              this[ee[91]](), Object[ee[202]](this[ee[197]])[ee[121]](function(fe) {
                return fe[ee[92]]();
              }), this[ee[197]] = {}, this[ee[64]] = void 0, this[ee[48]] = [], this[ee[22]] = ee[93];
            }, pe;
          }(le[ee[196]]);
          ie[ee[195]] = ve;
        }, 25050: function(ne, ie) {
          var ae;
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[110]] = ie[ee[125]] = void 0, function(he) {
            he[ee[126]] = ee[224], he[ee[124]] = ee[225], he[ee[127]] = ee[226];
          }(ae || (ie[ee[125]] = ae = {}));
          var ce = function() {
            function he(_e, le) {
              this[ee[21]] = _e, this[ee[227]] = [], this[ee[218]] = le, this[ee[69]] = _e[ee[69]], this[ee[228]] = _e[ee[36]], this[ee[229]] = this[ee[228]][ee[230]];
            }
            return Object[ee[17]](he[ee[6]], ee[185], { get: function() {
              var _e;
              return (_e = this[ee[21]][ee[56]]) === null || _e === void 0 ? void 0 : _e[ee[55]]();
            }, enumerable: !1, configurable: !0 }), he[ee[6]][ee[231]] = function(_e, le, se) {
              return this[ee[32]](le, se);
            }, he;
          }();
          ie[ee[110]] = ce;
        }, 28429: function(ne, ie, ae) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[232]] = _e;
          var ce = ae(10676), he = ae(63356);
          function _e(se, oe) {
            if (oe && oe[ee[14]] !== 0)
              return le[ee[233]](), oe[ee[181]](function(ue, be) {
                var ve = le(be), me = le(ue);
                return me > se || ve > se ? ve > me ? ue : be : ve > me ? be : ue;
              });
          }
          var le = (0, ce[ee[237]])(function(se) {
            return (0, he[ee[234]])(se) && se[ee[235]] > 0 ? se[ee[235]] : (0, he[ee[236]])(se) ? (se[ee[154]] + se[ee[152]]) / 2 : 0;
          });
        }, 29374: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            var be = function(ve, me) {
              return be = Object[ee[2]] || { __proto__: [] } instanceof Array && function(pe, fe) {
                pe[ee[3]] = fe;
              } || function(pe, fe) {
                for (var ge in fe)
                  Object[ee[6]][ee[5]][ee[4]](fe, ge) && (pe[ge] = fe[ge]);
              }, be(ve, me);
            };
            return function(ve, me) {
              if (ee[7] != typeof me && me !== null)
                throw new TypeError(ee[8] + String(me) + ee[9]);
              function pe() {
                this[ee[10]] = ve;
              }
              be(ve, me), ve[ee[6]] = me === null ? Object[ee[11]](me) : (pe[ee[6]] = me[ee[6]], new pe());
            };
          }();
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[222]] = void 0;
          var he = ae(331), _e = ae(25050), le = -0.5, se = 0.7, oe = 6e4, ue = function(be) {
            function ve(me, pe) {
              var fe = be[ee[4]](this, me, pe) || this;
              return fe[ee[30]] = me[ee[30]], fe[ee[238]] = !0, fe[ee[239]] = [], fe;
            }
            return ce(ve, be), ve[ee[6]][ee[240]] = function() {
              if (this[ee[239]][ee[14]] === 0)
                return NaN;
              var me = this[ee[239]][this[ee[239]][ee[14]] - 1], pe = me[ee[117]];
              if (this[ee[238]]) {
                var fe = me[ee[116]], ge = this[ee[239]][this[ee[239]][ee[14]] - 2], ye = 0;
                ge && (ye = ge[ee[116]]), fe >= me[ee[117]] || ye > fe ? (this[ee[69]][ee[81]](ee[241]), this[ee[238]] = !1) : pe = fe;
              }
              return pe;
            }, ve[ee[6]][ee[242]] = function(me) {
              isNaN(me) && (me = this[ee[30]][ee[29]]());
              for (var pe, fe = Date[ee[113]]() - (0, he[ee[114]])(me), ge = 0, ye = 0, $e = 0; $e < this[ee[239]][ee[14]]; $e++)
                (pe = this[ee[239]][$e])[ee[115]] >= fe && (ge += pe[ee[116]] - ye), ye = pe[ee[116]];
              return ((ge /= this[ee[240]]()) < -1 || ge > 1) && this[ee[69]][ee[81]](ee[243] + ge), isNaN(ge) ? 1 : ge;
            }, ve[ee[6]][ee[40]] = function(me) {
              var pe = this;
              this[ee[244]] || (this[ee[244]] = window[ee[246]](function() {
                pe[ee[69]][ee[81]](ee[245]), pe[ee[238]] = !1;
              }, (0, he[ee[114]])(this[ee[30]][ee[29]]()))), this[ee[239]][ee[122]](me), me[ee[115]] - this[ee[239]][0][ee[115]] > oe && this[ee[239]][ee[123]]();
            }, ve[ee[6]][ee[32]] = function(me) {
              var pe = this[ee[242]](me), fe = _e[ee[125]][ee[124]];
              return pe > se ? fe = _e[ee[125]][ee[126]] : pe < le && (fe = _e[ee[125]][ee[127]]), { value: pe, result: fe };
            }, ve[ee[6]][ee[88]] = function() {
              this[ee[238]] = !0;
            }, ve[ee[6]][ee[91]] = function() {
              clearTimeout(this[ee[244]]);
            }, ve[ee[6]][ee[92]] = function() {
              this[ee[91]](), this[ee[239]] = [];
            }, ve;
          }(_e[ee[110]]);
          ie[ee[222]] = ue;
        }, 34188: function(ne, ie, ae) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[247]] = void 0;
          var ce = ae(16368), he = ae(42214), _e = ae(67304);
          ie[ee[247]] = { name: ce[ee[249]][ee[248]], module: function() {
            return { AdaptationService: ae(10073)[ee[128]], AdaptToPlayerResolution: ae(80683)[ee[250]], AdaptationUtils: _e, AdaptationApiFactory: he[ee[251]] };
          }, dependencies: [ce[ee[249]][ee[252]]] }, ie[ee[57]] = ie[ee[247]];
        }, 40210: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            var xe = function(ke, Le) {
              return xe = Object[ee[2]] || { __proto__: [] } instanceof Array && function(He, We) {
                He[ee[3]] = We;
              } || function(He, We) {
                for (var Xe in We)
                  Object[ee[6]][ee[5]][ee[4]](We, Xe) && (He[Xe] = We[Xe]);
              }, xe(ke, Le);
            };
            return function(ke, Le) {
              if (ee[7] != typeof Le && Le !== null)
                throw new TypeError(ee[8] + String(Le) + ee[9]);
              function He() {
                this[ee[10]] = ke;
              }
              xe(ke, Le), ke[ee[6]] = Le === null ? Object[ee[11]](Le) : (He[ee[6]] = Le[ee[6]], new He());
            };
          }();
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[19]] = void 0;
          var he = ae(18665), _e = ae(6311), le = ae(25226), se = ae(28819), oe = ae(8272), ue = ae(70016), be = ae(72583), ve = ae(94077), me = ae(78827), pe = ae(67610), fe = ae(55594), ge = ae(67304), ye = 0.8, $e = 3, Se = 0.8, Ce = 3, Ie = 0.2, Te = 5, Ee = 8, we = function(xe) {
            function ke(Le, He) {
              var We = xe[ee[4]](this, Le, He) || this;
              return We[ee[137]] = function(Xe, Qe) {
                var tt, Je, Ge = (tt = Xe[ee[253]]) !== null && tt !== void 0 ? tt : -1, Ye = (Je = We[ee[254]]) === null || Je === void 0 ? void 0 : Je[ee[255]](), ze = We[ee[44]](), Fe = Me(Xe), ot = We[ee[256]](Qe), vt = (0, _e[ee[257]])(Xe), gt = vt ? Fe > We[ee[21]][ee[36]][ee[258]] : Ge > We[ee[21]][ee[36]][ee[258]];
                return !(Ye || ze || ot || !gt) && We[ee[259]](Xe, Fe, vt, Ge);
              }, We[ee[22]] = We[ee[87]](), We[ee[41]] = new me[ee[260]](We[ee[21]], We[ee[22]]), We[ee[33]] = new ve[ee[261]](We[ee[21]], We[ee[22]]), We;
            }
            return ce(ke, xe), Object[ee[17]](ke[ee[6]], ee[262], { get: function() {
              return this[ee[21]][ee[267]][ee[134]](he[ee[264]][ee[263]], this[ee[21]][ee[266]][ee[265]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[17]](ke[ee[6]], ee[254], { get: function() {
              return this[ee[21]][ee[267]][ee[134]](he[ee[264]][ee[268]]);
            }, enumerable: !1, configurable: !0 }), ke[ee[6]][ee[44]] = function() {
              var Le, He = this[ee[21]][ee[56]][ee[55]](), We = He ? (0, se[ee[192]])(He, this[ee[218]], oe[ee[187]][ee[186]]) : [], Xe = !!(!((Le = this[ee[21]][ee[162]][ee[165]]) === null || Le === void 0) && Le[ee[168]]), Qe = We[ee[47]](function(tt) {
                return !!tt[ee[31]];
              })[ee[14]] > 0;
              return Xe && !Qe;
            }, ke[ee[6]][ee[256]] = function(Le) {
              return !!Le && this[ee[269]]()[ee[49]][ee[65]](Le);
            }, ke[ee[6]][ee[270]] = function() {
              var Le, He, We = [(Le = this[ee[21]][ee[272]]) === null || Le === void 0 ? void 0 : Le[ee[273]](), (He = this[ee[21]][ee[272]]) === null || He === void 0 ? void 0 : He[ee[274]]()][ee[47]](ue[ee[271]]);
              return Math[ee[118]][ee[15]](Math, We);
            }, ke[ee[6]][ee[53]] = function(Le) {
              var He;
              switch (Le === void 0 && (Le = 0), He = Le !== 0 ? this[ee[41]][ee[231]](Le, Te, Ie)[ee[31]] : this[ee[41]][ee[32]](Te, Ie)[ee[31]], Ae(this[ee[21]][ee[162]])) {
                case le[ee[277]][ee[276]]:
                  return He[ee[275]];
                case le[ee[277]][ee[278]]:
                default:
                  return He[ee[279]] > He[ee[280]] ? He[ee[280]] + He[ee[279]] : He[ee[281]];
              }
            }, ke[ee[6]][ee[282]] = function(Le, He, We, Xe, Qe, tt) {
              var Je, Ge, Ye, ze, Fe, ot, vt, gt = Xe * He / We + Qe, yt = (Ge = (Je = this[ee[262]]) === null || Je === void 0 ? void 0 : Je[ee[283]](Le)) !== null && Ge !== void 0 && Ge, pt = !this[ee[284]](Le), bt = (Ye = tt == null ? void 0 : tt[ee[211]]) !== null && Ye !== void 0 && Ye, ut = (Fe = (ze = this[ee[262]]) === null || ze === void 0 ? void 0 : ze[ee[285]](Le)) !== null && Fe !== void 0 ? Fe : null, Ke = !!this[ee[64]] && ((ot = this[ee[64]]) === null || ot === void 0 ? void 0 : ot[ee[200]]) !== null && ((vt = this[ee[64]]) === null || vt === void 0 ? void 0 : vt[ee[199]]) !== (ut == null ? void 0 : ut[ee[199]]), je = this[ee[21]][ee[56]][ee[55]](), De = gt;
              if (De += Ve(je, this[ee[218]], Le), bt && Ke && (De *= 2), pt && (De += Qe), yt) {
                var at = Be(je);
                De += Math[ee[119]](at, Qe);
              }
              return De;
            }, ke[ee[6]][ee[50]] = function(Le, He, We, Xe, Qe, tt, Je) {
              var Ge = 1 - this[ee[21]][ee[36]][ee[286]], Ye = this[ee[21]][ee[36]][ee[287]] - Ge, ze = this[ee[21]][ee[30]][ee[29]](), Fe = Xe * (Ge + Math[ee[118]](Je, ze) * Ye / ze);
              return this[ee[282]](Le, Xe, He, We, tt, { hlsDependentSegments: Qe }) <= Fe;
            }, ke[ee[6]][ee[284]] = function(Le) {
              var He, We, Xe = this[ee[21]][ee[56]][ee[55]](), Qe = Xe ? (0, se[ee[192]])(Xe, this[ee[218]], oe[ee[187]][ee[288]]) : [];
              return Qe[ee[14]] === 0 ? (We = (He = this[ee[262]]) === null || He === void 0 ? void 0 : He[ee[289]]()) !== null && We !== void 0 && We : Qe[ee[291]](function(tt) {
                var Je = tt[ee[5]](ee[31]) && tt[ee[31]][ee[5]](ee[290]) ? tt[ee[31]][ee[290]] : null;
                return Je !== null && Je[ee[65]](Le);
              });
            }, ke[ee[6]][ee[292]] = function(Le, He, We) {
              var Xe = this;
              We === void 0 && (We = this[ee[53]]());
              var Qe = this[ee[48]][ee[47]](function(tt) {
                var Je;
                return Xe[ee[64]] && !tt[ee[49]][ee[65]]((Je = Xe[ee[64]]) === null || Je === void 0 ? void 0 : Je[ee[49]]);
              });
              return Math[ee[118]][ee[15]](Math, Qe[ee[191]](function(tt) {
                var Je;
                return Xe[ee[282]](tt[ee[49]], (Je = Xe[ee[45]] ? Xe[ee[45]][ee[43]] : He) !== null && Je !== void 0 ? Je : 0, Le, tt[ee[46]], We, Xe[ee[45]]);
              }));
            }, ke[ee[6]][ee[293]] = function(Le) {
              var He, We, Xe, Qe, tt, Je, Ge = (He = Le[ee[253]]) !== null && He !== void 0 ? He : 0, Ye = ((We = this[ee[84]]) === null || We === void 0 ? void 0 : We[ee[294]]) === Le[ee[294]] ? (Le[ee[98]] - ((Qe = (Xe = this[ee[84]]) === null || Xe === void 0 ? void 0 : Xe[ee[98]]) !== null && Qe !== void 0 ? Qe : 0)) / (Ge - ((Je = (tt = this[ee[84]]) === null || tt === void 0 ? void 0 : tt[ee[253]]) !== null && Je !== void 0 ? Je : 0)) : -1;
              return this[ee[84]] = Le, Ye;
            }, ke[ee[6]][ee[295]] = function(Le, He) {
              var We, Xe = He ? Pe(Le) : (We = Le[ee[253]]) !== null && We !== void 0 ? We : 0;
              return this[ee[53]](Xe);
            }, ke[ee[6]][ee[296]] = function(Le) {
              if (Le === void 0 && (Le = 4), !this[ee[64]])
                return 0;
              var He = 1.2;
              return this[ee[64]][ee[46]] / Ee * Le * He;
            }, ke[ee[6]][ee[297]] = function(Le, He) {
              var We = (0, _e[ee[257]])(Le), Xe = We ? this[ee[293]](Le) : 0, Qe = We && (0, ge[ee[298]])(Le) ? Le[ee[299]] - Le[ee[98]] : this[ee[296]](Le[ee[43]]);
              return Math[ee[118]](Qe / (He / Ee), Xe > 0 ? Qe / Xe : 1 / 0);
            }, ke[ee[6]][ee[300]] = function(Le, He, We) {
              if ((0, _e[ee[257]])(Le))
                return Le[ee[98]] / He * Ee;
              var Xe = this[ee[21]][ee[30]][ee[29]](), Qe = this[ee[33]][ee[32]](fe[ee[28]][ee[27]], We / Xe);
              return this[ee[34]](Qe);
            }, ke[ee[6]][ee[301]] = function(Le, He, We, Xe, Qe) {
              var tt = this[ee[297]](Xe, We);
              return tt > He && tt > Qe && He <= Qe + Le;
            }, ke[ee[6]][ee[302]] = function(Le, He, We, Xe) {
              var Qe = Oe(this[ee[41]]);
              return Xe > Math[ee[119]](Le, 3 * Qe) && He <= We + Le;
            }, ke[ee[6]][ee[259]] = function(Le, He, We, Xe) {
              var Qe, tt, Je, Ge = this[ee[270]](), Ye = this[ee[300]](Le, He, Ge), ze = this[ee[295]](Le, We), Fe = (Je = (Qe = Le[ee[43]]) !== null && Qe !== void 0 ? Qe : (tt = this[ee[45]]) === null || tt === void 0 ? void 0 : tt[ee[43]]) !== null && Je !== void 0 ? Je : 0, ot = this[ee[292]](Ye, Fe, ze);
              if (We ? this[ee[301]](Fe, Ge, Ye, Le, ot) : this[ee[302]](Fe, Ge, ot, Xe)) {
                var vt = (0, ge[ee[298]])(Le) ? (Le[ee[98]] / Le[ee[299]] * 100)[ee[70]](1) : void 0;
                return this[ee[21]][ee[69]][ee[310]](ee[309][ee[72]](Xe[ee[70]](2), ee[308])[ee[72]]((0, ge[ee[306]])(Ye)[ee[70]](2), ee[307])[ee[72]](Ge[ee[70]](2), ee[305])[ee[72]](We ? ee[93][ee[72]](vt, ee[303]) : ee[304])), this[ee[83]] = !0, this[ee[82]] = Ye, !0;
              }
              return !1;
            }, ke;
          }(be[ee[196]]);
          function Pe(xe) {
            var ke, Le, He, We, Xe = (Le = (ke = xe[ee[95]]) === null || ke === void 0 ? void 0 : ke[ee[311]]) !== null && Le !== void 0 ? Le : -1, Qe = (We = (He = xe[ee[95]]) === null || He === void 0 ? void 0 : He[ee[97]]) !== null && We !== void 0 ? We : -1;
            return Xe < 0 || Qe < 0 ? 0 : Qe - Xe;
          }
          function Me(xe) {
            var ke, Le = (ke = xe[ee[253]]) !== null && ke !== void 0 ? ke : -1;
            return Le < 0 ? 0 : Le - Pe(xe);
          }
          function Ae(xe) {
            var ke, Le;
            return (Le = (ke = xe[ee[165]]) === null || ke === void 0 ? void 0 : ke[ee[312]]) !== null && Le !== void 0 ? Le : le[ee[277]][ee[278]];
          }
          function Oe(xe) {
            return xe[ee[32]](Te, Ie)[ee[31]][ee[280]];
          }
          function Be(xe) {
            var ke = xe ? (0, se[ee[58]])(xe) : {};
            return Ue(ke, ee[57]) + Re(ke);
          }
          function Ve(xe, ke, Le) {
            var He = xe ? (0, se[ee[58]])(xe) : {};
            return Ne((0, se[ee[314]])(He, ke, oe[ee[187]][ee[313]]), Le) + Ne((0, se[ee[314]])(He, ke, oe[ee[187]][ee[315]]), Le);
          }
          function Ue(xe, ke) {
            var Le = (0, se[ee[314]])(xe, ke, oe[ee[187]][ee[186]])[ee[180]](-$e)[ee[191]](function(He) {
              return He[ee[31]][ee[175]];
            });
            return (0, pe[ee[316]])(Le, ye);
          }
          function Re(xe) {
            var ke = (0, se[ee[314]])(xe, ee[57], oe[ee[187]][ee[317]])[ee[180]](-Ce)[ee[191]](function(Le) {
              return Le[ee[31]];
            });
            return (0, pe[ee[316]])(ke, Se);
          }
          function Ne(xe, ke) {
            var Le = xe[ee[47]](function(He) {
              return He[ee[31]][ee[77]][ee[65]](ke);
            })[ee[180]](-Ce)[ee[191]](function(He) {
              return He[ee[31]][ee[175]];
            });
            return (0, pe[ee[316]])(Le, Se);
          }
          ie[ee[19]] = we;
        }, 42214: function(ne, ie, ae) {
          var ce = this && this[ee[12]] || function() {
            return ce = Object[ee[13]] || function(se) {
              for (var oe, ue = 1, be = arguments[ee[14]]; ue < be; ue++)
                for (var ve in oe = arguments[ue])
                  Object[ee[6]][ee[5]][ee[4]](oe, ve) && (se[ve] = oe[ve]);
              return se;
            }, ce[ee[15]](this, arguments);
          };
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[251]] = void 0;
          var he = ae(70016), _e = function() {
            function se() {
            }
            return se[ee[11]] = function(oe) {
              var ue = oe[ee[318]](), be = function(fe) {
                ue[ee[310]](ee[319][ee[72]](fe));
              }, ve = function(fe) {
                if (fe < 0 || fe > 1)
                  be(ee[321][ee[72]](fe, ee[320]));
                else {
                  var ge = oe[ee[322]](!0)[ee[165]];
                  ge && (ge[ee[323]] = fe, be(ee[324][ee[72]](fe)));
                }
              }, me = function(fe) {
                var ge = fe[ee[325]], ye = fe[ee[326]], $e = fe[ee[327]], Se = fe[ee[328]], Ce = oe[ee[322]](!0)[ee[165]][ee[329]];
                le(ge) && (Ce[ee[325]] = ge), le(ye) && (Ce[ee[326]] = ye), le($e) && (Ce[ee[327]] = $e), le(Se) && (Ce[ee[328]] = Se), be(ee[331][ee[72]](JSON[ee[330]](Ce)));
              }, pe = function(fe) {
                var ge = oe[ee[322]](!0)[ee[165]];
                ge && (ge[ee[332]] = fe, be(ee[333][ee[72]](fe)));
              };
              return { setConfig: function(fe) {
                be(ee[334][ee[72]](JSON[ee[330]](fe))), (0, he[ee[335]])(fe[ee[323]]) && ve(fe[ee[323]]), fe[ee[329]] && me(fe[ee[329]]), (0, he[ee[336]])(fe[ee[332]]) && pe(fe[ee[332]]);
              }, getConfig: function() {
                var fe = oe[ee[322]](!0)[ee[165]], ge = fe[ee[323]], ye = fe[ee[329]], $e = fe[ee[332]];
                return { qualityStabilityBalance: ge, resolution: ce({}, ye), limitToPlayerSize: $e };
              } };
            }, se;
          }();
          function le(se) {
            return (0, he[ee[335]])(se) && se >= 0;
          }
          ie[ee[251]] = _e;
        }, 55594: function(ne, ie) {
          var ae;
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[28]] = void 0, function(ce) {
            ce[ce[ee[337]] = 10] = ee[337], ce[ce[ee[338]] = 8] = ee[338], ce[ce[ee[339]] = 7] = ee[339], ce[ce[ee[340]] = 6] = ee[340], ce[ce[ee[27]] = 5] = ee[27], ce[ce[ee[220]] = 4] = ee[220], ce[ce[ee[341]] = 3] = ee[341], ce[ce[ee[204]] = 2] = ee[204], ce[ce[ee[342]] = 1] = ee[342];
          }(ae || (ie[ee[28]] = ae = {}));
        }, 57038: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            var we = function(Pe, Me) {
              return we = Object[ee[2]] || { __proto__: [] } instanceof Array && function(Ae, Oe) {
                Ae[ee[3]] = Oe;
              } || function(Ae, Oe) {
                for (var Be in Oe)
                  Object[ee[6]][ee[5]][ee[4]](Oe, Be) && (Ae[Be] = Oe[Be]);
              }, we(Pe, Me);
            };
            return function(Pe, Me) {
              if (ee[7] != typeof Me && Me !== null)
                throw new TypeError(ee[8] + String(Me) + ee[9]);
              function Ae() {
                this[ee[10]] = Pe;
              }
              we(Pe, Me), Pe[ee[6]] = Me === null ? Object[ee[11]](Me) : (Ae[ee[6]] = Me[ee[6]], new Ae());
            };
          }();
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[343]] = void 0;
          var he = ae(33696), _e = ae(87326), le = ae(28819), se = ae(8272), oe = ae(79814), ue = ae(40210), be = ae(28429), ve = ae(25050), me = ae(55594), pe = ae(67304), fe = ae(72573), ge = 10, ye = 1e-4, $e = 1e-4, Se = 5, Ce = 0.325, Ie = 2, Te = function(we) {
            function Pe(Me, Ae) {
              var Oe = we[ee[4]](this, Me, Ae) || this;
              return Oe[ee[21]] = Me, Oe[ee[218]] = Ae, Oe[ee[344]] = [], Oe[ee[345]] = [], Oe[ee[43]] = 0, Oe[ee[346]](), Oe[ee[162]] = Me[ee[36]][ee[347]], Oe;
            }
            return ce(Pe, we), Object[ee[17]](Pe[ee[6]], ee[116], { get: function() {
              var Me, Ae = oe[ee[144]][ee[143]](this[ee[218]]) ? he[ee[349]][ee[348]] : he[ee[349]][ee[350]], Oe = (Me = this[ee[21]][ee[272]][ee[355]][ee[354]](he[ee[353]][ee[352]], Ae)[ee[351]]) !== null && Me !== void 0 ? Me : 0;
              return Oe > this[ee[21]][ee[30]][ee[356]](he[ee[353]][ee[352]], Ae) + this[ee[43]] ? 0 : Oe;
            }, enumerable: !1, configurable: !0 }), Pe[ee[6]][ee[346]] = function() {
              var Me = this[ee[21]][ee[36]][ee[347]][ee[357]], Ae = this[ee[21]][ee[36]][ee[347]][ee[358]], Oe = this[ee[21]][ee[36]][ee[347]][ee[359]];
              if (![ee[361], ee[362]][ee[360]](Me)) {
                var Be = _e[ee[363]][ee[357]];
                this[ee[21]][ee[69]][ee[366]](ee[365][ee[72]](Me, ee[364])[ee[72]](Be, ee[71])), this[ee[21]][ee[36]][ee[347]][ee[357]] = Be;
              }
              if (Ae > 1 || Ae < ye) {
                var Ve = Math[ee[118]](Math[ee[119]](Ae, ye), 1);
                this[ee[21]][ee[69]][ee[366]](ee[368][ee[72]](Ae, ee[367])[ee[72]](Ve)), this[ee[21]][ee[36]][ee[347]][ee[358]] = Ve;
              }
              if (Oe < $e) {
                var Ue = Math[ee[119]](Oe, $e);
                this[ee[21]][ee[69]][ee[366]](ee[369][ee[72]](Oe, ee[367])[ee[72]](Ue)), this[ee[21]][ee[36]][ee[347]][ee[359]] = Ue;
              }
            }, Pe[ee[6]][ee[26]] = function(Me) {
              Me === void 0 && (Me = me[ee[28]][ee[27]]);
              var Ae = this[ee[21]][ee[30]][ee[29]](), Oe = this[ee[33]][ee[32]](Me, this[ee[116]] / Ae), Be = this[ee[34]](Oe), Ve = (0, pe[ee[37]])(Be, this[ee[21]][ee[36]][ee[35]]);
              return this[ee[38]](Ve);
            }, Pe[ee[6]][ee[370]] = function() {
              var Me = this[ee[21]][ee[56]][ee[55]]();
              return (Me ? (0, le[ee[192]])(Me, this[ee[218]], se[ee[187]][ee[186]]) : [])[ee[47]](function(Ae) {
                return !!Ae[ee[31]];
              })[ee[14]] > Ie;
            }, Pe[ee[6]][ee[40]] = function(Me) {
              Ee(Me) && (this[ee[33]][ee[40]](), this[ee[41]][ee[40]](), Me[ee[43]] !== this[ee[43]] && (this[ee[43]] = Me[ee[43]], this[ee[371]]()));
            }, Pe[ee[6]][ee[63]] = function(Me, Ae) {
              var Oe;
              this[ee[52]](Ae), this[ee[54]]({ value: this[ee[116]], result: ve[ee[125]][ee[124]] });
              var Be = this[ee[372]](), Ve = (Oe = Be[ee[373]]) === null || Oe === void 0 ? void 0 : Oe[ee[49]], Ue = Be[ee[374]];
              return this[ee[345]][ee[122]](this[ee[344]][Ue]), this[ee[345]][ee[14]] > 2 * ge && (this[ee[345]] = this[ee[345]][ee[180]](-ge)), this[ee[45]] = Me, this[ee[64]] = Be[ee[373]], this[ee[82]] = this[ee[34]](this[ee[33]][ee[32]]()), this[ee[83]] = !1, this[ee[84]] = void 0, Ve;
            }, Pe[ee[6]][ee[39]] = function() {
              return this[ee[33]][ee[32]]()[ee[31]];
            }, Pe[ee[6]][ee[85]] = function(Me) {
              this[ee[48]] = Me[ee[86]], this[ee[22]] = this[ee[87]](), this[ee[83]] = !1, this[ee[84]] = void 0;
              var Ae = this[ee[223]]()[ee[191]](function(Oe) {
                return (0, pe[ee[306]])(Oe[ee[46]]);
              });
              this[ee[344]] = (0, fe[ee[375]])(Ae, this[ee[162]][ee[357]]), this[ee[371]]();
            }, Pe[ee[6]][ee[38]] = function(Me, Ae) {
              var Oe, Be = (0, be[ee[232]])(Me, this[ee[223]]()[ee[191]](function(Ve) {
                return { rep: Ve, bitrate: Ve[ee[46]] };
              }));
              return (Oe = Be == null ? void 0 : Be[ee[373]]) !== null && Oe !== void 0 ? Oe : this[ee[269]]();
            }, Pe[ee[6]][ee[88]] = function() {
              this[ee[89]] = !0, clearTimeout(this[ee[90]]), this[ee[90]] = void 0;
            }, Pe[ee[6]][ee[91]] = function() {
              var Me, Ae;
              this[ee[82]] = 0, this[ee[83]] = !1, this[ee[84]] = void 0, (Me = this[ee[33]]) === null || Me === void 0 || Me[ee[91]](), (Ae = this[ee[41]]) === null || Ae === void 0 || Ae[ee[91]]();
            }, Pe[ee[6]][ee[92]] = function() {
              var Me, Ae;
              this[ee[91]](), (Me = this[ee[33]]) === null || Me === void 0 || Me[ee[92]](), (Ae = this[ee[41]]) === null || Ae === void 0 || Ae[ee[92]](), this[ee[64]] = void 0, this[ee[48]] = [], this[ee[22]] = ee[93], this[ee[344]] = [], this[ee[43]] = 0, this[ee[345]] = [];
            }, Pe[ee[6]][ee[371]] = function() {
              if ((0, fe[ee[376]])(this[ee[344]], this[ee[43]])) {
                var Me = this[ee[223]]()[ee[191]](function(Be) {
                  return (0, pe[ee[306]])(Be[ee[46]]);
                }), Ae = oe[ee[144]][ee[143]](this[ee[218]]) ? he[ee[349]][ee[348]] : he[ee[349]][ee[350]], Oe = this[ee[21]][ee[30]][ee[356]](he[ee[353]][ee[352]], Ae);
                this[ee[377]] = (0, fe[ee[378]])(this[ee[162]], Me, this[ee[344]], this[ee[43]], Oe), this[ee[379]] = (0, fe[ee[380]])(this[ee[162]], this[ee[377]], Oe, this[ee[43]]), this[ee[381]] = (0, fe[ee[382]])(this[ee[377]], this[ee[379]]);
              }
            }, Pe[ee[6]][ee[383]] = function(Me, Ae, Oe, Be) {
              var Ve = (0, fe[ee[384]])(Me[ee[46]], Be), Ue = (0, fe[ee[385]])(Ve, this[ee[43]], this[ee[116]]), Re = (0, fe[ee[386]])(this[ee[344]], Ae, Oe);
              return this[ee[377]] * Ve + this[ee[379]] * Ue + this[ee[381]] * Re;
            }, Pe[ee[6]][ee[44]] = function() {
              var Me, Ae, Oe = !!(!((Me = this[ee[21]][ee[162]][ee[165]]) === null || Me === void 0) && Me[ee[168]]), Be = !!(!((Ae = this[ee[21]][ee[162]][ee[165]]) === null || Ae === void 0) && Ae[ee[166]]);
              return (Oe || Be) && !this[ee[370]]();
            }, Pe[ee[6]][ee[372]] = function() {
              var Me = this;
              if (this[ee[89]] && (this[ee[44]]() || this[ee[162]][ee[387]])) {
                var Ae = this[ee[26]](), Oe = this[ee[223]]()[ee[388]](Ae);
                return { rep: Ae, index: Oe !== -1 ? Oe : 0 };
              }
              if (this[ee[116]] < this[ee[43]] || !(0, fe[ee[376]])(this[ee[344]], this[ee[43]]))
                return { rep: this[ee[223]]()[0], index: 0 };
              var Be = (0, fe[ee[389]])(this[ee[345]], ge), Ve = this[ee[33]][ee[32]](Se, Ce)[ee[31]], Ue = this[ee[34]](this[ee[33]][ee[32]]()), Re = Math[ee[118]](Ve, Ue), Ne = 0.1, xe = this[ee[223]]()[0][ee[46]], ke = Math[ee[119]](Ve * (1 + Ne), xe), Le = this[ee[223]]()[ee[47]](function(He) {
                return He[ee[46]] <= ke;
              })[ee[191]](function(He, We) {
                return { rep: He, index: We, cost: Me[ee[383]](He, We, Be, Re) };
              })[ee[391]](function(He, We) {
                return He[ee[390]] - We[ee[390]];
              });
              return { rep: Le[0][ee[373]], index: Le[0][ee[374]] };
            }, Pe;
          }(ue[ee[19]]);
          function Ee(we) {
            return we[ee[43]] != null;
          }
          ie[ee[343]] = Te;
        }, 63356: function(ne, ie) {
          function ae(he) {
            return he[ee[235]] != null;
          }
          function ce(he) {
            return he[ee[152]] != null && he[ee[154]] != null;
          }
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[234]] = ae, ie[ee[236]] = ce;
        }, 67014: function(ne, ie, ae) {
          var ce = this && this[ee[12]] || function() {
            return ce = Object[ee[13]] || function(Ue) {
              for (var Re, Ne = 1, xe = arguments[ee[14]]; Ne < xe; Ne++)
                for (var ke in Re = arguments[Ne])
                  Object[ee[6]][ee[5]][ee[4]](Re, ke) && (Ue[ke] = Re[ke]);
              return Ue;
            }, ce[ee[15]](this, arguments);
          };
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[132]] = void 0;
          var he = ae(18665), _e = ae(57782), le = ae(28463), se = ae(76650), oe = ae(8272), ue = ae(33669), be = ae(3464), ve = ae(3941), me = ae(79814), pe = ae(70016), fe = ae(54838), ge = ae(67883), ye = ae(38925), $e = ae(95092), Se = ae(80683), Ce = ae(28429), Ie = ae(89067), Te = ae(67304), Ee = 1.5, we = 0, Pe = 1 / 0, Me = function() {
            function Ue(Re, Ne, xe) {
              var ke, Le, He = this;
              this[ee[21]] = Re, this[ee[218]] = Ne, this[ee[392]] = xe, this[ee[393]] = !1, this[ee[394]] = function(We) {
                var Xe;
                return We === void 0 && (We = (Xe = He[ee[395]]) === null || Xe === void 0 ? void 0 : Xe[ee[55]]()), We ? (0, le[ee[394]])((0, le[ee[396]])(We), He[ee[218]]) : null;
              }, this[ee[397]] = (0, $e[ee[398]])(this[ee[21]], this[ee[218]], { minBitrate: this[ee[392]][ee[152]], maxBitrate: this[ee[392]][ee[154]] }, (Le = (ke = this[ee[21]][ee[162]]) === null || ke === void 0 ? void 0 : ke[ee[165]]) === null || Le === void 0 ? void 0 : Le[ee[397]]), this[ee[399]] = this[ee[401]](this[ee[400]]), this[ee[402]]();
            }
            return Object[ee[17]](Ue[ee[6]], ee[395], { get: function() {
              var Re = this[ee[21]][ee[266]][ee[265]];
              return this[ee[21]][ee[267]][ee[134]](he[ee[264]][ee[403]], Re);
            }, enumerable: !1, configurable: !0 }), Object[ee[17]](Ue[ee[6]], ee[262], { get: function() {
              var Re = this[ee[21]][ee[266]][ee[265]];
              return this[ee[21]][ee[267]][ee[134]](he[ee[264]][ee[263]], Re);
            }, enumerable: !1, configurable: !0 }), Ue[ee[6]][ee[404]] = function(Re, Ne, xe) {
              var ke, Le;
              return Re ? this[ee[399]] : Ne && (Le = (ke = this[ee[397]][ee[38]](Ne, xe)) === null || ke === void 0 ? void 0 : ke[ee[49]]) !== null && Le !== void 0 ? Le : null;
            }, Ue[ee[6]][ee[405]] = function(Re, Ne) {
              var xe, ke = this[ee[406]](), Le = this[ee[394]]();
              return ke || Le ? this[ee[404]](ke, Le, Ne) : (xe = this[ee[397]][ee[63]](Re, Ne)) !== null && xe !== void 0 ? xe : null;
            }, Ue[ee[6]][ee[406]] = function() {
              return !this[ee[136]]() && !!this[ee[285]](this[ee[399]], this[ee[223]]());
            }, Ue[ee[6]][ee[407]] = function(Re) {
              this[ee[408]] = Re;
            }, Ue[ee[6]][ee[223]] = function() {
              var Re, Ne, xe;
              return (xe = (Ne = (Re = this[ee[262]]) === null || Re === void 0 ? void 0 : Re[ee[409]](this[ee[400]])) === null || Ne === void 0 ? void 0 : Ne[ee[86]]) !== null && xe !== void 0 ? xe : [];
            }, Ue[ee[6]][ee[63]] = function(Re, Ne) {
              Re === void 0 && (Re = {});
              var xe = this[ee[410]](Ne ?? this[ee[223]]()), ke = this[ee[405]](Re, xe);
              return ke && this[ee[407]](ke), this[ee[408]];
            }, Ue[ee[6]][ee[411]] = function() {
              var Re = this, Ne = !!this[ee[412]];
              this[ee[395]] && !Ne && (this[ee[412]] = (0, be[ee[417]])(this[ee[395]])(ue[ee[413]], function(xe) {
                var ke, Le, He = xe == null ? void 0 : xe[Re[ee[218]]];
                if (He) {
                  var We = He[ee[414]];
                  We && We[ee[14]] > 0 && ((ke = Re[ee[395]]) === null || ke === void 0 || ke[ee[416]]((0, _e[ee[415]])(Re[ee[218]])), (Le = Re[ee[412]]) === null || Le === void 0 || Le[ee[4]](Re), Re[ee[412]] = void 0);
                }
              }));
            }, Ue[ee[6]][ee[402]] = function() {
              var Re = this;
              this[ee[395]] && (this[ee[394]]() && this[ee[411]](), this[ee[418]] = (0, be[ee[417]])(this[ee[395]])(this[ee[394]], function() {
                return Re[ee[411]]();
              }, function(Ne) {
                return !!Ne;
              }));
            }, Ue[ee[6]][ee[285]] = function(Re, Ne) {
              var xe;
              return Ne ? Ne[ee[419]](function(ke) {
                return ke[ee[49]][ee[65]](Re);
              }) : (xe = this[ee[262]]) === null || xe === void 0 ? void 0 : xe[ee[285]](Re);
            }, Ue[ee[6]][ee[410]] = function(Re) {
              var Ne = this;
              return this[ee[420]](), Re[ee[47]](function(xe) {
                if (!Ae(xe[ee[46]], Ne[ee[392]][ee[152]], Ne[ee[392]][ee[154]]))
                  return !1;
                var ke = Ne[ee[21]][ee[162]][ee[165]][ee[329]], Le = ke[ee[327]], He = ke[ee[325]], We = ke[ee[328]], Xe = ke[ee[326]];
                return !(0, pe[ee[421]])(xe) || Ae(xe[ee[422]], We, Xe) && Ae(xe[ee[423]], Le, He);
              });
            }, Ue[ee[6]][ee[420]] = function() {
              me[ee[144]][ee[143]](this[ee[218]]) && (this[ee[21]][ee[162]][ee[165]][ee[332]] && !this[ee[393]] ? this[ee[424]]() : !this[ee[21]][ee[162]][ee[165]][ee[332]] && this[ee[393]] && this[ee[425]]());
            }, Ue[ee[6]][ee[425]] = function() {
              this[ee[393]] = !1, this[ee[21]][ee[162]][ee[165]][ee[426]] = this[ee[427]];
            }, Ue[ee[6]][ee[424]] = function() {
              var Re = this;
              this[ee[393]] = !0;
              var Ne = this[ee[21]][ee[162]][ee[165]][ee[426]];
              this[ee[427]] = Ne, this[ee[21]][ee[162]][ee[165]][ee[426]] = Ne && ee[7] == typeof Ne ? function(xe) {
                var ke, Le, He;
                return xe[ee[428]] = (0, Se[ee[250]])(Re[ee[21]][ee[272]], xe[ee[428]], (Le = (ke = Re[ee[429]]) === null || ke === void 0 ? void 0 : ke[ee[430]]()) !== null && Le !== void 0 && Le) || xe[ee[428]], (He = (0, fe[ee[431]])(function() {
                  return Ne(xe);
                }, Re[ee[21]][ee[69]])) !== null && He !== void 0 ? He : xe[ee[428]];
              } : function(xe) {
                var ke, Le;
                return (0, Se[ee[250]])(Re[ee[21]][ee[272]], xe[ee[428]], (Le = (ke = Re[ee[429]]) === null || ke === void 0 ? void 0 : ke[ee[430]]()) !== null && Le !== void 0 && Le) || xe[ee[428]];
              };
            }, Ue[ee[6]][ee[401]] = function(Re) {
              return Re ? new ye[ee[433]](Re, ee[432]) : new ye[ee[433]](new ge[ee[435]](ve[ee[434]], this[ee[218]]), ee[432]);
            }, Ue[ee[6]][ee[436]] = function(Re) {
              var Ne, xe = { id: Re[ee[200]], bitrate: Re[ee[46]], width: Re[ee[422]], height: Re[ee[423]] };
              (Ne = this[ee[21]][ee[56]]) === null || Ne === void 0 || Ne[ee[416]]((0, se[ee[438]])(this[ee[218]], oe[ee[187]][ee[437]], xe));
            }, Ue[ee[6]][ee[439]] = function() {
              var Re, Ne, xe = this;
              if (this[ee[262]]) {
                var ke = this[ee[262]][ee[409]](this[ee[400]]);
                if (ke) {
                  var Le = ce(ce({}, ke), { Representation: this[ee[410]](ke[ee[86]]), _minBandwidth: Math[ee[119]]((Re = ke[ee[440]]) !== null && Re !== void 0 ? Re : we, this[ee[392]][ee[152]]), _maxBandwidth: Math[ee[118]]((Ne = ke[ee[441]]) !== null && Ne !== void 0 ? Ne : Pe, this[ee[392]][ee[154]]) });
                  this[ee[397]][ee[85]](Le), (0, Ie[ee[443]])()[ee[442]](function() {
                    return xe[ee[436]](Le);
                  });
                }
              } else
                this[ee[21]][ee[69]][ee[310]](ee[444]);
            }, Ue[ee[6]][ee[445]] = function(Re) {
              return this[ee[400]] && Re && this[ee[262]] ? this[ee[262]][ee[446]](this[ee[400]], Re) : null;
            }, Ue[ee[6]][ee[447]] = function() {
              if (this[ee[399]]) {
                var Re = this[ee[399]][ee[77]];
                this[ee[399]] = this[ee[401]](this[ee[400]]);
                var Ne = this[ee[445]](Re);
                Ne && (this[ee[399]] = Ne[ee[49]]);
              } else
                this[ee[399]] = this[ee[401]](this[ee[400]]);
            }, Ue[ee[6]][ee[145]] = function(Re) {
              Re || this[ee[21]][ee[69]][ee[310]](ee[448][ee[72]](Re)), this[ee[400]] = Re, this[ee[447]](), this[ee[439]]();
            }, Ue[ee[6]][ee[146]] = function(Re) {
              var Ne;
              if (ee[432] === Re)
                this[ee[399]] = new ye[ee[433]](this[ee[400]], ee[432]);
              else if (this[ee[400]]) {
                var xe = (Ne = this[ee[262]]) === null || Ne === void 0 ? void 0 : Ne[ee[446]](this[ee[400]], Re);
                xe && (this[ee[399]] = xe[ee[49]], this[ee[63]]());
              }
            }, Ue[ee[6]][ee[148]] = function() {
              return this[ee[408]];
            }, Ue[ee[6]][ee[136]] = function() {
              return ee[432] === this[ee[399]][ee[77]];
            }, Ue[ee[6]][ee[137]] = function(Re, Ne) {
              var xe, ke, Le, He, We, Xe, Qe, tt = (ke = (xe = this[ee[21]][ee[162]][ee[165]]) === null || xe === void 0 ? void 0 : xe[ee[449]]) !== null && ke !== void 0 && ke, Je = (We = (He = (Le = this[ee[262]]) === null || Le === void 0 ? void 0 : Le[ee[409]](this[ee[400]])) === null || He === void 0 ? void 0 : He[ee[86]]) !== null && We !== void 0 ? We : [], Ge = Je[ee[14]] === 1, Ye = Je[ee[291]](function(vt) {
                return !!vt[ee[46]];
              });
              if (!this[ee[136]]() || tt || Ge || !Ye)
                return !1;
              var ze = Be(Re), Fe = ((Qe = (Xe = Re[ee[95]]) === null || Xe === void 0 ? void 0 : Xe[ee[450]]) !== null && Qe !== void 0 ? Qe : 0) > 0, ot = !!Re[ee[43]] && ze > Re[ee[43]] * Ee;
              return !(Fe || !ot) && !Ve(Re) && this[ee[397]][ee[137]](Re, Ne);
            }, Ue[ee[6]][ee[88]] = function() {
              this[ee[397]][ee[88]]();
            }, Ue[ee[6]][ee[40]] = function(Re) {
              this[ee[397]][ee[40]](ce({ timestamp: Date[ee[113]]() }, Re));
            }, Ue[ee[6]][ee[91]] = function() {
              this[ee[397]][ee[91]]();
            }, Ue[ee[6]][ee[92]] = function() {
              var Re, Ne;
              this[ee[91]](), this[ee[397]][ee[92]](), (Re = this[ee[418]]) === null || Re === void 0 || Re[ee[4]](this), (Ne = this[ee[412]]) === null || Ne === void 0 || Ne[ee[4]](this);
            }, Ue[ee[6]][ee[138]] = function(Re, Ne) {
              if (Ne)
                return (0, Ce[ee[232]])(Ne, Re);
              var xe = this[ee[394]]();
              if (xe)
                return (0, Ce[ee[232]])(xe, Re);
              var ke = this[ee[410]](this[ee[223]]());
              if (this[ee[406]]()) {
                var Le = this[ee[285]](this[ee[408]], ke);
                if (Le)
                  return (0, Ce[ee[232]])(Le[ee[46]], Re);
              }
              return (0, Ce[ee[232]])(this[ee[397]][ee[39]](), Re);
            }, Ue;
          }();
          function Ae(Ue, Re, Ne) {
            return Ue >= Re && Ue <= Ne;
          }
          function Oe(Ue) {
            var Re, Ne = (Re = Ue[ee[253]]) !== null && Re !== void 0 ? Re : 0;
            return Ue[ee[98]] > 0 && Ne > 0 ? 8 * Ue[ee[98]] / 1024 / Ne : 0;
          }
          function Be(Ue) {
            if (!(0, Te[ee[298]])(Ue))
              return 1 / 0;
            var Re = Oe(Ue);
            return Re > 0 ? 8 * Ue[ee[299]] / 1024 / Re : 1 / 0;
          }
          function Ve(Ue) {
            return !!(0, Te[ee[298]])(Ue) && Ue[ee[98]] >= 0.9 * Ue[ee[299]];
          }
          ie[ee[132]] = Me;
        }, 67304: function(ne, ie, ae) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[74]] = ie[ee[306]] = ie[ee[451]] = ie[ee[452]] = void 0, ie[ee[453]] = he, ie[ee[454]] = _e, ie[ee[455]] = oe, ie[ee[298]] = fe, ie[ee[37]] = ge;
          var ce = ae(54838);
          function he(ye) {
            var $e, Se = ($e = ye[ee[162]]) === null || $e === void 0 ? void 0 : $e[ee[165]];
            if (!Se)
              return 0;
            var Ce = le(Se);
            return !isNaN(Ce) && isFinite(Ce) ? Ce : 0;
          }
          function _e(ye) {
            var $e, Se = ($e = ye[ee[162]]) === null || $e === void 0 ? void 0 : $e[ee[165]], Ce = ye[ee[36]];
            if (!Se || !Ce)
              return 0;
            var Ie = Se[ee[168]] || 0;
            if (!Ie)
              return 0;
            var Te = se(Ie, Ce[ee[35]]);
            return !isNaN(Te) && isFinite(Te) ? Te : 0;
          }
          function le(ye) {
            return ye[ee[166]] ? ce[ee[141]][ee[167]](ee[119], ye[ee[166]]) : 1 / 0;
          }
          function se(ye, $e) {
            var Se = ce[ee[141]][ee[167]](ee[118], ye);
            return Se *= 1 + $e / 100, Se += 8;
          }
          function oe(ye, $e) {
            return ye[ye[ee[181]](function(Se, Ce, Ie) {
              return $e(ye[Se], ye[Ie]) ? Se : Ie;
            }, 0)];
          }
          var ue = function(ye) {
            return ye;
          }, be = function(ye, $e) {
            return $e === void 0 && ($e = ue), oe(ye, function(Se, Ce) {
              return $e(Se) < $e(Ce);
            });
          };
          ie[ee[452]] = be;
          var ve = function(ye, $e) {
            return $e === void 0 && ($e = ue), oe(ye, function(Se, Ce) {
              return $e(Se) > $e(Ce);
            });
          };
          ie[ee[451]] = ve;
          var me = function(ye) {
            return ye / Math[ee[456]](2, 10);
          };
          ie[ee[306]] = me;
          var pe = function(ye) {
            return ye / Math[ee[456]](2, 20);
          };
          function fe(ye) {
            return ye[ee[299]] !== void 0;
          }
          function ge(ye, $e) {
            return ye * (1 - $e / 100);
          }
          ie[ee[74]] = pe;
        }, 67610: function(ne, ie) {
          function ae(le) {
            return le[ee[14]] > 0 ? le[ee[181]](function(se, oe) {
              return se + oe;
            }, 0) / le[ee[14]] : 0;
          }
          function ce(le, se) {
            if (se === void 0 && (se = ae(le)), le[ee[14]] < 2)
              return 0;
            var oe = le[ee[181]](function(be, ve) {
              return be + Math[ee[456]](ve - se, 2);
            }, 0), ue = 1 / (le[ee[14]] - 1) * oe;
            return Math[ee[457]](ue);
          }
          function he(le) {
            var se = le[ee[180]](0)[ee[391]](function(oe, ue) {
              return oe - ue;
            });
            return se[ee[14]] === 0 ? 0 : se[ee[14]] % 2 == 1 ? se[Math[ee[458]](se[ee[14]] / 2)] : 0.5 * (se[se[ee[14]] / 2 - 1] + se[se[ee[14]] / 2]);
          }
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[316]] = void 0, ie[ee[459]] = ae, ie[ee[460]] = ce, ie[ee[461]] = he;
          var _e = function(le, se, oe) {
            return oe === void 0 && (oe = le[ee[14]] - 1), le[ee[14]] === 0 || oe < 0 ? 0 : oe === 0 || se === 0 ? le[oe] : se * le[oe] + (1 - se) * (0, ie[ee[316]])(le, se, oe - 1);
          };
          ie[ee[316]] = _e;
        }, 68989: function(ne, ie, ae) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[462]] = void 0;
          var ce = ae(79814), he = ae(38353), _e = function() {
            function se(oe, ue, be, ve) {
              this[ee[21]] = oe, this[ee[218]] = ue, this[ee[463]] = be, this[ee[464]] = ve, this[ee[48]] = [], this[ee[465]] = ce[ee[144]][ee[466]](this[ee[218]]), this[ee[467]] = { timestamp: Date[ee[113]](), bufferLevel: 0, bufferTargetLevel: 0 };
            }
            return se[ee[6]][ee[52]] = function(oe) {
              oe && (this[ee[48]] = oe);
            }, se[ee[6]][ee[468]] = function() {
              return (0, he[ee[469]])(this[ee[48]], this[ee[463]]);
            }, se[ee[6]][ee[470]] = function() {
              var oe;
              return (oe = this[ee[38]](this[ee[464]])) === null || oe === void 0 ? void 0 : oe[ee[46]];
            }, se[ee[6]][ee[471]] = function() {
              return this[ee[21]][ee[30]][ee[29]](this[ee[465]]);
            }, se[ee[6]][ee[472]] = function() {
              var oe = this[ee[468]](), ue = this[ee[470]]();
              return this[ee[473]] = this[ee[471]](), le(oe, ue || oe, this[ee[473]]);
            }, se[ee[6]][ee[474]] = function() {
              var oe = this[ee[471]]();
              this[ee[473]] !== oe && (this[ee[475]] = this[ee[472]]());
            }, se[ee[6]][ee[38]] = function(oe, ue) {
              return this[ee[52]](ue), (0, he[ee[476]])(this[ee[48]], oe);
            }, se[ee[6]][ee[135]] = function() {
              var oe, ue = this[ee[471]](), be = this[ee[467]][ee[116]];
              return (be = Math[ee[458]](be)) > ue && (be = ue), oe = this[ee[475]][ee[5]](be) ? this[ee[475]][be] : this[ee[475]][0], this[ee[38]](oe);
            }, se[ee[6]][ee[63]] = function(oe, ue) {
              this[ee[52]](ue);
              var be = this[ee[135]]();
              return this[ee[474]](), be[ee[49]];
            }, se[ee[6]][ee[85]] = function(oe) {
              this[ee[52]](oe[ee[86]]), this[ee[475]] = this[ee[472]]();
            }, se[ee[6]][ee[137]] = function() {
              return !1;
            }, se[ee[6]][ee[88]] = function() {
            }, se[ee[6]][ee[91]] = function() {
            }, se[ee[6]][ee[40]] = function(oe) {
              this[ee[467]] = oe;
            }, se[ee[6]][ee[92]] = function() {
              this[ee[475]] = [];
            }, se[ee[6]][ee[39]] = function() {
              return 0;
            }, se;
          }();
          function le(se, oe, ue) {
            var be = [];
            oe === 0 && (oe = se);
            var ve = 2 * Math[ee[458]](0.1 * ue), me = 8 * Math[ee[458]](0.1 * ue);
            me <= ve && (me = Math[ee[458]](0.9 * ue)), ve <= 1 && (ve = 1);
            for (var pe = (oe - se) / (me - ve), fe = se - pe * ve, ge = 0; ge < ve; ge++)
              be[ge] = se;
            for (ge = ve; ge < me; ge++)
              be[ge] = Math[ee[458]](pe * ge + fe);
            for (ge = me; ge <= ue; ge++)
              be[ge] = oe;
            return be;
          }
          ie[ee[462]] = _e;
        }, 72573: function(ne, ie) {
          function ae(pe, fe) {
            var ge = function(Ce, Ie) {
              return Ce / Ie;
            }, ye = function(Ce, Ie) {
              return Math[ee[361]](Ce / Ie);
            };
            switch (fe) {
              case ee[362]:
                var $e = pe[pe[ee[14]] - 1];
                return pe[ee[191]](function(Ce) {
                  return ge(Ce, $e);
                });
              case ee[361]:
                var Se = pe[0];
                return pe[ee[191]](function(Ce) {
                  return ye(Ce, Se);
                });
            }
          }
          function ce(pe, fe, ge, ye, $e) {
            switch (pe[ee[357]]) {
              case ee[362]:
                return le(pe, ge, ye, $e);
              case ee[361]:
                return se(pe, fe, ye, $e);
            }
          }
          function he(pe, fe, ge, ye) {
            return fe * ((pe[ee[358]] * ge - ye) / ye);
          }
          function _e(pe, fe) {
            return 1 - pe - fe;
          }
          function le(pe, fe, ge, ye) {
            var $e = pe[ee[359]], Se = pe[ee[358]], Ce = ge, Ie = fe[0], Te = fe[fe[ee[14]] - 2];
            return 1 / (1 + (Se * ye - Ce) / ge + Math[ee[477]](3 - 2 * Ie - Te) / $e);
          }
          function se(pe, fe, ge, ye) {
            var $e = pe[ee[359]], Se = pe[ee[358]], Ce = ge, Ie = fe[0], Te = fe[fe[ee[14]] - 1];
            return 1 / (1 + (Se * ye - Ce) / ge + 2 * Te * Te / ($e * Ie * fe[fe[ee[14]] - 2]));
          }
          function oe(pe, fe) {
            return fe ? pe / fe : 1;
          }
          function ue(pe, fe, ge) {
            return ge <= fe ? 1 / 0 : pe * (fe / (ge - fe));
          }
          function be(pe, fe, ge) {
            var ye = pe[pe[ee[14]] - 1], $e = pe[0], Se = pe[fe];
            return Math[ee[477]](ye + ge - 2 * Se) / Math[ee[477]](2 * ye - 2 * $e);
          }
          function ve(pe, fe) {
            if (pe[ee[14]] === 0)
              return 0;
            var ge = pe[ee[180]](-fe);
            return ge[ee[181]](function(ye, $e) {
              return ye + $e;
            }) / ge[ee[14]];
          }
          function me(pe, fe) {
            return !(pe[ee[14]] <= 1 || !fe);
          }
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[375]] = ae, ie[ee[378]] = ce, ie[ee[380]] = he, ie[ee[382]] = _e, ie[ee[384]] = oe, ie[ee[385]] = ue, ie[ee[386]] = be, ie[ee[389]] = ve, ie[ee[376]] = me;
        }, 72583: function(ne, ie, ae) {
          var ce = this && this[ee[12]] || function() {
            return ce = Object[ee[13]] || function(me) {
              for (var pe, fe = 1, ge = arguments[ee[14]]; fe < ge; fe++)
                for (var ye in pe = arguments[fe])
                  Object[ee[6]][ee[5]][ee[4]](pe, ye) && (me[ye] = pe[ye]);
              return me;
            }, ce[ee[15]](this, arguments);
          };
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[196]] = void 0;
          var he = ae(28819), _e = ae(79814), le = ae(331), se = ae(28429), oe = ae(25050), ue = ae(55594), be = ae(67304), ve = function() {
            function me(pe, fe) {
              this[ee[21]] = pe, this[ee[218]] = fe, this[ee[82]] = 0, this[ee[48]] = [], this[ee[89]] = !0, this[ee[83]] = !1;
            }
            return me[ee[6]][ee[87]] = function() {
              var pe = null, fe = this[ee[21]][ee[56]][ee[55]]();
              return fe && (pe = Object[ee[478]]((0, he[ee[58]])(fe))[ee[419]](_e[ee[144]][ee[143]])), pe ?? this[ee[218]];
            }, me[ee[6]][ee[52]] = function(pe) {
              pe && (this[ee[48]] = pe[ee[191]](function(fe, ge) {
                return ce(ce({}, fe), { arrayIndex: ge });
              }));
            }, me[ee[6]][ee[223]] = function() {
              var pe, fe = this;
              return this[ee[83]] && (!((pe = this[ee[64]]) === null || pe === void 0) && pe[ee[46]]) ? this[ee[48]][ee[47]](function(ge) {
                var ye = ge[ee[46]];
                return fe[ee[64]] && ye < fe[ee[64]][ee[46]];
              }) : this[ee[48]];
            }, me[ee[6]][ee[38]] = function(pe, fe) {
              var ge, ye;
              return this[ee[52]](fe), (ye = (ge = (0, se[ee[232]])(pe, this[ee[223]]()[ee[191]](function($e) {
                return { rep: $e, bitrate: Number($e[ee[46]]) };
              }))) === null || ge === void 0 ? void 0 : ge[ee[373]]) !== null && ye !== void 0 ? ye : this[ee[269]]();
            }, me[ee[6]][ee[54]] = function(pe) {
              this[ee[89]] && this[ee[479]](pe);
            }, me[ee[6]][ee[269]] = function() {
              return (0, be[ee[452]])(this[ee[48]], function(pe) {
                return pe[ee[46]];
              });
            }, me[ee[6]][ee[479]] = function(pe) {
              var fe = this, ge = this[ee[21]][ee[30]][ee[29]]();
              this[ee[90]] || (this[ee[90]] = window[ee[246]](function() {
                fe[ee[21]][ee[69]][ee[81]](ee[480]), fe[ee[89]] = !1, fe[ee[90]] = void 0;
              }, (0, le[ee[114]])(ge))), pe[ee[31]] >= 0.5 * ge && (this[ee[21]][ee[69]][ee[81]](ee[481]), clearTimeout(this[ee[90]]), this[ee[89]] = !1, this[ee[90]] = void 0);
            }, me[ee[6]][ee[62]] = function(pe, fe, ge) {
              return this[ee[89]] || !ge ? this[ee[26]](ue[ee[28]][ee[27]]) : this[ee[483]](fe[ee[482]], pe[ee[482]]);
            }, me[ee[6]][ee[34]] = function(pe) {
              return this[ee[83]] ? this[ee[82]] : pe[ee[31]];
            }, me[ee[6]][ee[483]] = function(pe, fe) {
              if (this[ee[83]])
                return this[ee[205]](ue[ee[28]][ee[204]]);
              switch (pe) {
                case oe[ee[125]][ee[126]]:
                  return this[ee[484]](fe);
                case oe[ee[125]][ee[124]]:
                  return this[ee[485]](fe);
                case oe[ee[125]][ee[127]]:
                  return this[ee[486]](fe);
                default:
                  return this[ee[21]][ee[69]][ee[81]](ee[487]), this[ee[214]]();
              }
            }, me[ee[6]][ee[488]] = function(pe) {
              var fe;
              if (pe === void 0 && (pe = ue[ee[28]][ee[337]]), ((fe = this[ee[64]]) === null || fe === void 0 ? void 0 : fe[ee[199]]) !== void 0 && this[ee[64]][ee[199]] >= this[ee[48]][ee[14]] - 1)
                return this[ee[64]];
              var ge = this[ee[26]](pe);
              return this[ee[64]] && Number(ge[ee[46]]) <= Number(this[ee[64]][ee[46]]) ? this[ee[64]] : (this[ee[21]][ee[69]][ee[81]](ee[489] + ge[ee[200]]), ge);
            }, me[ee[6]][ee[205]] = function(pe) {
              var fe, ge, ye, $e;
              if (pe === void 0 && (pe = ue[ee[28]][ee[204]]), ((fe = this[ee[64]]) === null || fe === void 0 ? void 0 : fe[ee[199]]) !== void 0 && ((ge = this[ee[64]]) === null || ge === void 0 ? void 0 : ge[ee[199]]) < 1 && ((ye = this[ee[64]]) === null || ye === void 0 ? void 0 : ye[ee[200]]) !== null)
                return this[ee[21]][ee[69]][ee[81]](this[ee[218]] + ee[490]), this[ee[64]];
              var Se = this[ee[26]](pe);
              return this[ee[64]] && (!Se || Se[ee[46]] >= (($e = this[ee[64]]) === null || $e === void 0 ? void 0 : $e[ee[46]])) ? (Se = this[ee[221]](), this[ee[21]][ee[69]][ee[81]](ee[491] + Se[ee[200]])) : this[ee[21]][ee[69]][ee[81]](ee[492] + Se[ee[200]]), Se;
            }, me[ee[6]][ee[493]] = function() {
              var pe;
              return (pe = this[ee[64]]) !== null && pe !== void 0 ? pe : this[ee[269]]();
            }, me[ee[6]][ee[484]] = function(pe) {
              switch (pe) {
                case oe[ee[125]][ee[126]]:
                  return this[ee[488]](ue[ee[28]][ee[204]]);
                case oe[ee[125]][ee[124]]:
                  return this[ee[488]](ue[ee[28]][ee[341]]);
                case oe[ee[125]][ee[127]]:
                  return this[ee[493]]();
                default:
                  return this[ee[21]][ee[69]][ee[81]](ee[494]), this[ee[493]]();
              }
            }, me[ee[6]][ee[485]] = function(pe) {
              switch (pe) {
                case oe[ee[125]][ee[126]]:
                  return this[ee[488]](ue[ee[28]][ee[27]]);
                case oe[ee[125]][ee[124]]:
                  return this[ee[493]]();
                case oe[ee[125]][ee[127]]:
                  return this[ee[205]](ue[ee[28]][ee[341]]);
                default:
                  return this[ee[21]][ee[69]][ee[81]](ee[494]), this[ee[493]]();
              }
            }, me[ee[6]][ee[486]] = function(pe) {
              switch (pe) {
                case oe[ee[125]][ee[126]]:
                  return this[ee[493]]();
                case oe[ee[125]][ee[124]]:
                  return this[ee[205]](ue[ee[28]][ee[341]]);
                case oe[ee[125]][ee[127]]:
                  return this[ee[205]](ue[ee[28]][ee[204]]);
                default:
                  return this[ee[21]][ee[69]][ee[81]](ee[494]), this[ee[493]]();
              }
            }, me[ee[6]][ee[214]] = function() {
              var pe;
              return !((pe = this[ee[64]]) === null || pe === void 0) && pe[ee[200]] ? this[ee[64]] : this[ee[269]]();
            }, me[ee[6]][ee[221]] = function() {
              var pe, fe, ge = Math[ee[119]](0, ((fe = (pe = this[ee[64]]) === null || pe === void 0 ? void 0 : pe[ee[199]]) !== null && fe !== void 0 ? fe : 0) - 1);
              return this[ee[48]][ge];
            }, me;
          }();
          ie[ee[196]] = ve;
        }, 74828: function(ne, ie, ae) {
          var ce = this && this[ee[495]] || function($e, Se, Ce) {
            if (Ce || arguments[ee[14]] === 2)
              for (var Ie, Te = 0, Ee = Se[ee[14]]; Te < Ee; Te++)
                !Ie && Te in Se || (Ie || (Ie = Array[ee[6]][ee[180]][ee[4]](Se, 0, Te)), Ie[Te] = Se[Te]);
            return $e[ee[72]](Ie || Array[ee[6]][ee[180]][ee[4]](Se));
          };
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[496]] = void 0;
          var he = ae(18665), _e = ae(28819), le = ae(8272), se = ae(28429), oe = ae(12566), ue = ae(67304), be = ae(3797), ve = ae(92741), me = ae(2122), pe = ee[497], fe = 20, ge = function() {
            function $e(Se, Ce) {
              this[ee[21]] = Se, this[ee[218]] = Ce, this[ee[498]] = new ve[ee[499]]();
            }
            return Object[ee[17]]($e[ee[6]], ee[262], { get: function() {
              return this[ee[21]][ee[267]][ee[134]](he[ee[264]][ee[263]], this[ee[21]][ee[266]][ee[265]]);
            }, enumerable: !1, configurable: !0 }), $e[ee[6]][ee[361]] = function(Se) {
              for (var Ce, Ie = [], Te = 1; Te < arguments[ee[14]]; Te++)
                Ie[Te - 1] = arguments[Te];
              this[ee[21]][ee[69]] && (Ce = this[ee[21]][ee[69]])[ee[310]][ee[15]](Ce, ce([ee[502][ee[72]](pe, ee[501])[ee[72]](this[ee[218]], ee[500])[ee[72]](Se)], Ie, !1));
            }, $e[ee[6]][ee[102]] = function() {
              var Se = (0, _e[ee[192]])(this[ee[21]][ee[56]][ee[55]](), this[ee[218]], le[ee[187]][ee[503]]), Ce = this[ee[504]]();
              return (0, be[ee[102]])(Se[ee[180]](-Ce));
            }, $e[ee[6]][ee[504]] = function() {
              var Se, Ce = (Se = this[ee[21]][ee[162]][ee[165]]) === null || Se === void 0 ? void 0 : Se[ee[323]], Ie = Math[ee[505]](fe * Ce);
              return Ie = Math[ee[119]](1, Ie);
            }, $e[ee[6]][ee[506]] = function(Se) {
              var Ce, Ie, Te, Ee, we = ye((Te = (Ie = (Ce = this[ee[262]]) === null || Ce === void 0 ? void 0 : Ce[ee[409]](Se)) === null || Ie === void 0 ? void 0 : Ie[ee[86]]) !== null && Te !== void 0 ? Te : []);
              return (Ee = we == null ? void 0 : we[ee[49]][ee[65]](Se)) !== null && Ee !== void 0 && Ee;
            }, $e[ee[6]][ee[39]] = function() {
              var Se, Ce;
              return (Ce = (Se = this[ee[102]]()) === null || Se === void 0 ? void 0 : Se[ee[507]]) !== null && Ce !== void 0 ? Ce : 0;
            }, $e[ee[6]][ee[63]] = function(Se, Ce) {
              var Ie, Te, Ee, we;
              if (Ce && Ce[ee[14]] !== 0) {
                var Pe, Me = this[ee[102]]();
                if (this[ee[361]](ee[508], Me), !Me)
                  return (Ie = ye(Ce)) === null || Ie === void 0 ? void 0 : Ie[ee[49]];
                if (Me[ee[509]] === be[ee[101]][ee[105]] && (Pe = (Te = this[ee[38]](Me[ee[507]], Ce)) !== null && Te !== void 0 ? Te : void 0, this[ee[361]](ee[510], Pe == null ? void 0 : Pe[ee[46]])), Me[ee[509]] === be[ee[101]][ee[106]]) {
                  var Ae = (Ee = (0, _e[ee[188]])((0, _e[ee[58]])(this[ee[21]][ee[56]][ee[55]]()), this[ee[218]], le[ee[187]][ee[503]])[ee[31]]) === null || Ee === void 0 ? void 0 : Ee[ee[100]];
                  Ae !== void 0 && (Pe = (0, oe[ee[194]])(Ce, Ae), this[ee[361]](ee[512][ee[72]](Ae, ee[511])[ee[72]](Pe == null ? void 0 : Pe[ee[46]])));
                }
                return Pe ? Pe[ee[49]] : (we = ye(Ce)) === null || we === void 0 ? void 0 : we[ee[49]];
              }
            }, $e[ee[6]][ee[38]] = function(Se, Ce) {
              var Ie, Te;
              if (!Ce || Ce[ee[14]] < 1)
                return null;
              var Ee = (Ie = (0, se[ee[232]])(Se, Ce[ee[191]](function(we) {
                return { rep: we, bitrate: we[ee[46]] };
              }))) === null || Ie === void 0 ? void 0 : Ie[ee[373]];
              return (Te = Ee ?? ye(Ce)) !== null && Te !== void 0 ? Te : null;
            }, $e[ee[6]][ee[137]] = function(Se, Ce) {
              if (this[ee[498]][ee[513]](Se)) {
                if (this[ee[506]](Ce))
                  return !1;
                var Ie = (0, me[ee[94]])(Se);
                return Ie && this[ee[361]](ee[514]), Ie;
              }
              return !1;
            }, $e[ee[6]][ee[40]] = function(Se) {
            }, $e[ee[6]][ee[85]] = function(Se) {
            }, $e[ee[6]][ee[88]] = function() {
            }, $e[ee[6]][ee[91]] = function() {
            }, $e[ee[6]][ee[92]] = function() {
              this[ee[91]]();
            }, $e;
          }();
          function ye($e) {
            return (0, ue[ee[452]])($e ?? [], function(Se) {
              return Se[ee[46]];
            });
          }
          ie[ee[496]] = ge;
        }, 74953: function(ne, ie, ae) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[149]] = le;
          var ce = ae(18665), he = ae(79814), _e = ae(54838);
          function le(ue, be, ve, me) {
            var pe, fe, ge, ye = oe(be, ue[ee[162]][ee[165]]);
            if (ye) {
              var $e = ue[ee[267]][ee[515]](ce[ee[264]][ee[263]], function(Te) {
                return Te[ee[409]](ve);
              }, null, ue[ee[266]][ee[265]]), Se = (pe = $e == null ? void 0 : $e[ee[86]][ee[191]](function(Te) {
                return { bandwidth: Te[ee[46]], id: Te[ee[200]] };
              })) !== null && pe !== void 0 ? pe : [], Ce = { suggested: me[ee[77]], isAd: ue[ee[266]][ee[516]], representations: Se }, Ie = (fe = (0, _e[ee[431]])(function() {
                return ye(Ce);
              }, ue[ee[69]])) !== null && fe !== void 0 ? fe : void 0;
              return Ie && ((ge = ue[ee[69]]) === null || ge === void 0 || ge[ee[310]](ee[502][ee[72]](be, ee[518])[ee[72]](me[ee[77]], ee[517]) + ee[93][ee[72]](Ie))), se(ue, ve, Ie);
            }
          }
          function se(ue, be, ve) {
            return ue[ee[267]][ee[515]](ce[ee[264]][ee[263]], function(me) {
              return be && me[ee[446]](be, ve);
            }, void 0, ue[ee[266]][ee[265]]) || void 0;
          }
          function oe(ue, be) {
            return he[ee[144]][ee[156]](ue) ? be == null ? void 0 : be[ee[519]] : he[ee[144]][ee[143]](ue) ? be == null ? void 0 : be[ee[426]] : void 0;
          }
        }, 75451: function(ne, ie, ae) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[25]] = le;
          var ce = ae(87326), he = ae(331), _e = ae(25050);
          function le(se, oe) {
            var ue, be, ve = 0.8, me = 0.4, pe = !0, fe = { timestamp: Date[ee[113]](), bufferTargetLevel: ((ue = ce[ee[61]][ee[521]][ee[520]]) === null || ue === void 0 ? void 0 : ue[ee[522]]) || 0, bufferLevel: 0 }, ge = function() {
              clearTimeout(be);
            }, ye = function() {
              ge();
            };
            return { addSample: function($e) {
              be || (be = window[ee[246]](function() {
                pe = !1;
              }, (0, he[ee[114]])(se[ee[30]][ee[29]]()))), fe = $e;
            }, getStatus: function() {
              var $e;
              return fe[ee[116]] > fe[ee[117]] * ve ? ($e = _e[ee[125]][ee[126]], pe && (pe = !1, clearTimeout(be))) : $e = fe[ee[116]] < fe[ee[117]] * me ? _e[ee[125]][ee[127]] : _e[ee[125]][ee[124]], pe && ($e = _e[ee[125]][ee[124]]), { value: fe[ee[116]], result: $e };
            }, setStartupPhase: function() {
              pe = !0;
            }, shutdown: ge, dispose: ye };
          }
        }, 78827: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            var be = function(ve, me) {
              return be = Object[ee[2]] || { __proto__: [] } instanceof Array && function(pe, fe) {
                pe[ee[3]] = fe;
              } || function(pe, fe) {
                for (var ge in fe)
                  Object[ee[6]][ee[5]][ee[4]](fe, ge) && (pe[ge] = fe[ge]);
              }, be(ve, me);
            };
            return function(ve, me) {
              if (ee[7] != typeof me && me !== null)
                throw new TypeError(ee[8] + String(me) + ee[9]);
              function pe() {
                this[ee[10]] = ve;
              }
              be(ve, me), ve[ee[6]] = me === null ? Object[ee[11]](me) : (pe[ee[6]] = me[ee[6]], new pe());
            };
          }(), he = this && this[ee[495]] || function(be, ve, me) {
            if (me || arguments[ee[14]] === 2)
              for (var pe, fe = 0, ge = ve[ee[14]]; fe < ge; fe++)
                !pe && fe in ve || (pe || (pe = Array[ee[6]][ee[180]][ee[4]](ve, 0, fe)), pe[fe] = ve[fe]);
            return be[ee[72]](pe || Array[ee[6]][ee[180]][ee[4]](ve));
          };
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[260]] = void 0;
          var _e = ae(28819), le = ae(8272), se = ae(67610), oe = ae(25050), ue = function(be) {
            function ve(me, pe) {
              var fe = be[ee[4]](this, me, pe) || this;
              return fe[ee[523]] = -1, fe;
            }
            return ce(ve, be), ve[ee[6]][ee[524]] = function(me) {
              if (!this[ee[185]])
                return 0;
              var pe = (0, _e[ee[188]])((0, _e[ee[58]])(this[ee[185]]), me, le[ee[187]][ee[186]]), fe = !!pe && !!pe[ee[31]], ge = fe && pe[ee[31]][ee[525]] !== void 0 && !isNaN(pe[ee[31]][ee[525]]), ye = fe && this[ee[523]] < pe[ee[175]];
              return ye && isFinite(pe[ee[175]]) && (this[ee[523]] = pe[ee[175]]), ge && ye ? pe[ee[31]][ee[525]] : ge && !ye ? -1 : 0;
            }, ve[ee[6]][ee[40]] = function() {
              var me = this[ee[524]](this[ee[218]]), pe = this[ee[524]](ee[57]), fe = me || pe || 0;
              if (fe > 0)
                for (this[ee[227]][ee[122]](fe); this[ee[227]][ee[14]] > this[ee[229]]; )
                  this[ee[227]][ee[123]]();
            }, ve[ee[6]][ee[526]] = function(me) {
              var pe = -me;
              return me > 0 ? this[ee[227]][ee[180]](pe) : [];
            }, ve[ee[6]][ee[527]] = function(me, pe) {
              var fe = (0, se[ee[459]])(me), ge = (0, se[ee[316]])(me, pe), ye = (0, se[ee[460]])(me, fe);
              return { value: { median: (0, se[ee[461]])(me), mean: fe, weightedAverage: ge, standardDeviation: ye }, result: oe[ee[125]][ee[124]] };
            }, ve[ee[6]][ee[32]] = function(me, pe) {
              return me === void 0 && (me = 1), pe === void 0 && (pe = 1), this[ee[527]](this[ee[526]](me), pe);
            }, ve[ee[6]][ee[231]] = function(me, pe, fe) {
              pe === void 0 && (pe = 1), fe === void 0 && (fe = 1);
              var ge = he(he([], this[ee[526]](pe - 1), !0), [me], !1);
              return this[ee[527]](ge, fe);
            }, ve[ee[6]][ee[88]] = function() {
            }, ve[ee[6]][ee[91]] = function() {
            }, ve[ee[6]][ee[92]] = function() {
            }, ve;
          }(oe[ee[110]]);
          ie[ee[260]] = ue;
        }, 80683: function(ne, ie) {
          function ae(oe, ue, be) {
            var ve, me = le(be, oe);
            if (!me)
              return ue;
            var pe = (ve = oe[ee[528]]()) !== null && ve !== void 0 ? ve : [], fe = pe[ee[419]](function(ye) {
              return ye[ee[529]] === ue;
            });
            if (!fe)
              return ue;
            var ge = ce(pe, fe[ee[235]], me);
            return ge[ee[14]] === 0 ? ue : ge[he(ge)][ee[529]];
          }
          function ce(oe, ue, be) {
            return oe[ee[47]](function(ve) {
              var me = ve[ee[235]] <= ue, pe = _e(be, ve);
              return me && pe;
            });
          }
          function he(oe) {
            var ue = oe[ee[532]](function(be) {
              return be[ee[530]] > oe[0][ee[530]] && be[ee[531]] > oe[0][ee[531]];
            }) - 1;
            return Math[ee[119]](0, ue);
          }
          function _e(oe, ue) {
            var be = ue[ee[530]] / ue[ee[531]];
            return oe[ee[530]] / oe[ee[531]] < be ? ue[ee[530]] >= oe[ee[530]] : ue[ee[531]] >= oe[ee[531]];
          }
          function le(oe, ue) {
            var be = ue[ee[533]]();
            if (!be)
              return null;
            var ve = be[ee[534]], me = ve && ve[ee[536]](ee[535]);
            return oe ? { width: screen[ee[530]] * devicePixelRatio, height: screen[ee[531]] * devicePixelRatio } : se(be) || me && se(me) || ve && se(ve);
          }
          function se(oe) {
            return oe && oe[ee[537]] && oe[ee[538]] ? { width: oe[ee[537]] * devicePixelRatio, height: oe[ee[538]] * devicePixelRatio } : null;
          }
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[250]] = ae;
        }, 89067: function(ne, ie) {
          function ae() {
            return new Promise(function(ce) {
              window[ee[246]](ce);
            });
          }
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[443]] = ae;
        }, 92741: function(ne, ie) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[499]] = void 0;
          var ae = 0.2, ce = function() {
            function he() {
              this[ee[539]] = 0;
            }
            return he[ee[6]][ee[513]] = function(_e) {
              if (_e[ee[43]] === void 0 || _e[ee[253]] === void 0)
                return !1;
              this[ee[540]](_e) && (this[ee[539]] = 0);
              var le = this[ee[539]] + ae;
              if (_e[ee[253]] >= _e[ee[43]] * le) {
                var se = _e[ee[253]] / _e[ee[43]];
                return this[ee[539]] = Math[ee[458]](se / ae) * ae, !0;
              }
              return !1;
            }, he[ee[6]][ee[540]] = function(_e) {
              return _e[ee[253]] < this[ee[539]] * _e[ee[43]];
            }, he;
          }();
          ie[ee[499]] = ce;
        }, 94077: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            var Se = function(Ce, Ie) {
              return Se = Object[ee[2]] || { __proto__: [] } instanceof Array && function(Te, Ee) {
                Te[ee[3]] = Ee;
              } || function(Te, Ee) {
                for (var we in Ee)
                  Object[ee[6]][ee[5]][ee[4]](Ee, we) && (Te[we] = Ee[we]);
              }, Se(Ce, Ie);
            };
            return function(Ce, Ie) {
              if (ee[7] != typeof Ie && Ie !== null)
                throw new TypeError(ee[8] + String(Ie) + ee[9]);
              function Te() {
                this[ee[10]] = Ce;
              }
              Se(Ce, Ie), Ce[ee[6]] = Ie === null ? Object[ee[11]](Ie) : (Te[ee[6]] = Ie[ee[6]], new Te());
            };
          }();
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[261]] = void 0;
          var he = ae(28819), _e = ae(8272), le = ae(331), se = ae(54838), oe = ae(67610), ue = ae(67304), be = ae(25050), ve = ee[160], me = ee[161], pe = function(Se) {
            function Ce(Ie, Te) {
              var Ee = Se[ee[4]](this, Ie, Te) || this;
              return Ee[ee[523]] = -1, Ee[ee[541]] = 0.1, Ee[ee[542]] = !0, Ee;
            }
            return ce(Ce, Se), Ce[ee[543]] = function() {
              if (!performance || ee[7] != typeof performance[ee[544]])
                return 0;
              var Ie = 0, Te = 0;
              return performance[ee[551]](ee[550])[ee[47]](fe)[ee[121]](function(Ee) {
                Ie += 8 * Ee[ee[545]], Te += (0, le[ee[549]])(Ee[ee[546]] - (Ee[ee[547]] - Ee[ee[548]]));
              }), Ie > 0 && Te > 0 ? Ie / Te : 0;
            }, Ce[ee[6]][ee[179]] = function(Ie, Te, Ee) {
              var we;
              Te === void 0 && (Te = 1), Ee === void 0 && (Ee = 0);
              var Pe = -Ie - Ee;
              return we = Ee !== 0 ? this[ee[227]][ee[180]](Pe, -Ee) : this[ee[227]][ee[180]](Pe), (0, oe[ee[316]])(we, 1 - Te);
            }, Ce[ee[552]] = function(Ie) {
              if (Ie && Ie[ee[31]]) {
                var Te = !!Ie[ee[31]][ee[174]], Ee = !isNaN(Ie[ee[31]][ee[175]]), we = Ie[ee[31]][ee[525]] !== void 0 && !isNaN(Ie[ee[31]][ee[525]]);
                return Te && Ee && we;
              }
              return !1;
            }, Ce[ee[6]][ee[553]] = function(Ie) {
              if (!this[ee[185]])
                return 0;
              var Te = (0, he[ee[188]])((0, he[ee[58]])(this[ee[185]]), Ie, _e[ee[187]][ee[186]]), Ee = Ce[ee[552]](Te), we = Ee && this[ee[523]] < Te[ee[175]];
              return we && isFinite(Te[ee[175]]) && (this[ee[523]] = Te[ee[175]]), Ee && we ? ge(Te, this[ee[21]][ee[36]][ee[554]]) : Ee && !we ? -1 : 0;
            }, Ce[ee[6]][ee[555]] = function() {
              var Ie = [], Te = this[ee[189]]();
              Te > 0 && Ie[ee[122]](Te);
              var Ee = this[ee[553]](ee[57]);
              Ee > 0 && Ie[ee[122]](Ee);
              var we = Math[ee[118]][ee[15]](Math, Ie);
              return we > 0 && isFinite(we) ? we : Ce[ee[543]]();
            }, Ce[ee[6]][ee[40]] = function() {
              var Ie = this[ee[553]](this[ee[218]]), Te = 0;
              this[ee[542]] && (Te = $e(this[ee[21]], Ie), this[ee[542]] = !1), (Te = Te || Ie || 0) === 0 && (Te = this[ee[555]]()), Te > 0 && (this[ee[227]][ee[122]](Te), this[ee[227]][ee[14]] > this[ee[229]] && this[ee[227]][ee[556]](0, this[ee[227]][ee[14]] - this[ee[229]])), Ie > 0 && this[ee[178]]();
            }, Ce[ee[6]][ee[32]] = function(Ie, Te) {
              Ie === void 0 && (Ie = 1), Te === void 0 && (Te = 1), this[ee[227]][ee[14]] === 0 && this[ee[40]]();
              var Ee = this[ee[179]](Ie, Te), we = this[ee[179]](Ie, Te, 1);
              return { value: Ee, result: Ee > we * (1 + this[ee[541]]) ? be[ee[125]][ee[126]] : Ee < we * (1 - this[ee[541]]) ? be[ee[125]][ee[127]] : be[ee[125]][ee[124]] };
            }, Ce[ee[6]][ee[178]] = function() {
              if (this[ee[185]]) {
                var Ie = (0, he[ee[192]])(this[ee[185]], this[ee[218]], _e[ee[187]][ee[186]])[ee[47]](Ce[ee[552]])[ee[180]](-3)[ee[191]](function(Te) {
                  return ge(Te);
                });
                this[ee[21]][ee[193]][ee[133]](ve, Ie), this[ee[21]][ee[193]][ee[133]](me, Date[ee[113]]());
              }
            }, Ce[ee[6]][ee[189]] = function() {
              var Ie = this, Te = (this[ee[21]][ee[193]][ee[134]](ve) || [])[ee[191]](function(Ee) {
                return ye(Ee, Ie[ee[21]][ee[36]][ee[554]]);
              });
              return Math[ee[190]](Te[ee[181]](function(Ee, we) {
                return Ee + we;
              }, 0) / Te[ee[14]]) || 0;
            }, Ce[ee[6]][ee[91]] = function() {
            }, Ce[ee[6]][ee[88]] = function() {
            }, Ce[ee[6]][ee[92]] = function() {
            }, Ce;
          }(be[ee[110]]);
          function fe(Se) {
            return Se[ee[545]] > 0 && !/^https?:\/\/localhost(:\d+)?(\/|$)/[ee[558]](Se[ee[557]]);
          }
          function ge(Se, Ce) {
            var Ie;
            Ce === void 0 && (Ce = 1 / 0);
            var Te = Se[ee[31]][ee[175]] - ((Ie = Se[ee[31]][ee[525]]) !== null && Ie !== void 0 ? Ie : 0);
            return ye(8 * Se[ee[31]][ee[174]] / Te, Ce);
          }
          function ye(Se, Ce) {
            var Ie = se[ee[141]][ee[167]](ee[119], Ce);
            return Math[ee[118]](Se, Ie);
          }
          function $e(Se, Ce) {
            var Ie = (0, ue[ee[454]])(Se), Te = (0, ue[ee[453]])(Se);
            return Te = Ce > 0 ? Math[ee[118]](Te, Ce) : Te, Ie || Te || 0;
          }
          ie[ee[261]] = pe;
        }, 95092: function(ne, ie, ae) {
          Object[ee[17]](ie, ee[16], { value: !0 }), ie[ee[398]] = ue;
          var ce = ae(25226), he = ae(24892), _e = ae(68989), le = ae(1932), se = ae(74828), oe = ae(57038);
          function ue(be, ve, me, pe) {
            var fe = me[ee[152]], ge = me[ee[154]];
            return pe === void 0 && (pe = ce[ee[560]][ee[559]]), be[ee[69]][ee[310]](ee[561][ee[72]](pe)), pe === ce[ee[560]][ee[562]] ? new se[ee[496]](be, ve) : pe === ce[ee[560]][ee[563]] ? new oe[ee[343]](be, ve) : pe === ce[ee[560]][ee[559]] ? new le[ee[18]](be, ve) : pe === ce[ee[560]][ee[564]] ? new he[ee[195]](be, ve) : new _e[ee[462]](be, ve, fe || 0, ge || 1 / 0);
          }
        } }, function(ne) {
          return function(ie) {
            return ne(ne[ee[565]] = ie);
          }(34188);
        }]);
      });
    })();
  })();
})(bitmovinplayerAbr, bitmovinplayerAbr.exports);
var bitmovinplayerAbrExports = bitmovinplayerAbr.exports;
const ABRModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerAbrExports);
var bitmovinplayerEngineBitmovin = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ne) {
      re.exports = ne();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[238], { 1590: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.StreamTimelineActionType = void 0, function(ae) {
          ae.StreamTimelineReset = "@instance/source/stream/streamtimelinereset", ae.StreamTimeRangeRemove = "@instance/source/stream/streamtimerangeremove", ae.StreamTimeRangeAdd = "@instance/source/stream/streamtimerangeadd";
        }(ie || (ne.StreamTimelineActionType = ie = {}));
      }, 3337: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.createManifestLoadingService = se;
        var ae = ie(25550), ce = ie(28764), he = ie(33696), _e = ie(91520), le = ie(16368);
        function se(oe, ue, be) {
          switch (oe.type) {
            case he.StreamType.Dash:
              return new (_e.ModuleManager.get(le.ModuleName.DASH)).MPDLoader(ue, be);
            case he.StreamType.Hls:
              return new (_e.ModuleManager.get(le.ModuleName.HLS)).M3u8Loader(ue, be);
            case he.StreamType.Smooth:
              return new (_e.ModuleManager.get(le.ModuleName.Smooth)).SmoothStreamingLoader(ue, be);
            default:
              throw new ce.PlayerError(ae.ErrorCode.SOURCE_INVALID, { given: oe.type, supported: "dash, hls, smooth" }, "The provided stream type is not supported by the player.");
          }
        }
      }, 4053: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.setRepresentationIdAction = _e, ne.setMediaTypeAction = le, ne.setContainerFormatAction = se, ne.removeActiveTrackAction = oe, ne.clearActiveTracksAction = ue;
        var ae = ie(15231), ce = ie(81361), he = ie(73731);
        function _e(be) {
          return (0, ae.createAction)(he.ActiveTracksActionType.SetSelectedRepresentationId, { selectedRepresentationId: be });
        }
        function le(be, ve) {
          var me = (0, ce.forceArray)(ve);
          return (0, ae.createAction)(he.ActiveTracksActionType.SetMediaType, { trackId: be, mediaTypes: me });
        }
        function se(be, ve) {
          return (0, ae.createAction)(he.ActiveTracksActionType.SetContainerFormat, { trackId: be, containerFormat: ve });
        }
        function oe(be) {
          return (0, ae.createAction)(he.ActiveTracksActionType.RemoveActiveTrack, { adaptationSetId: be });
        }
        function ue() {
          return (0, ae.createAction)(he.ActiveTracksActionType.ClearActiveTracks);
        }
      }, 4141: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getLoaderConfig = _e, ne.getLoader = se;
        var ae = ie(88005), ce = ie(67345), he = ie(79814);
        function _e(oe, ue) {
          var be;
          return !((be = oe.config.tweaks) === null || be === void 0) && be.segmentLoaderArgs ? oe.config.tweaks.segmentLoaderArgs : { maxRetries: oe.settings.MAX_CDN_RETRIES, requestType: le(ue), disableDownloadTimeout: !0, resetRetriesWhenOffline: !0 };
        }
        function le(oe) {
          return he.MimeTypeHelper.isVideo(oe) ? ce.HttpRequestType.MEDIA_VIDEO : he.MimeTypeHelper.isAudio(oe) ? ce.HttpRequestType.MEDIA_AUDIO : he.MimeTypeHelper.isSubtitle(oe) ? ce.HttpRequestType.MEDIA_SUBTITLES : he.MimeTypeHelper.isUnknown(oe) ? ce.HttpRequestType.INTERNAL : ce.HttpRequestType.UNKNOWN;
        }
        function se(oe, ue) {
          var be, ve = (be = oe.config.tweaks) === null || be === void 0 ? void 0 : be.segmentLoader;
          return ve && typeof ve == "function" ? new ve(ue) : new ae.DefaultContentLoader(oe, ue);
        }
      }, 5206: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.KeyLoader = void 0;
        var ae = ie(25550), ce = ie(28764), he = ie(88005), _e = ie(90637), le = ie(67345), se = function() {
          function oe(ue) {
            this.context = ue, this.settings = ue.settings, this.sourceIdentifier = ue.sourceContext.sourceIdentifier, this.loader = new he.DefaultContentLoader(this.context, { maxRetries: this.settings.MAX_RETRIES, retryDelay: this.settings.RETRY_DELAY, requestType: le.HttpRequestType.KEY_HLS_AES });
          }
          return oe.prototype.hasWithCredentials = function() {
            var ue = this.context.sourceContext.source && this.context.sourceContext.source.hasOwnProperty("options") && this.context.sourceContext.source.options, be = ue && ue.hasOwnProperty("withCredentials") && ue.withCredentials, ve = ue && ue.hasOwnProperty("hlsWithCredentials") && ue.hlsWithCredentials;
            return !!be || !!ve;
          }, oe.prototype.load = function(ue) {
            var be = this;
            return this.loader ? this.loader.load(ue, le.HttpRequestMethod.GET, le.HttpResponseType.ARRAYBUFFER, void 0, void 0, this.hasWithCredentials()).then(function(ve) {
              return ve.body;
            }).catch(function(ve) {
              if (ve.message === _e.RequestError.Canceled)
                return Promise.reject(ve);
              var me = new ce.PlayerError(ae.ErrorCode.DRM_FAILED_LICENSE_REQUEST, { statusCode: ve.status, statusText: ve.statusText, keyUrl: ue }, "Failed to load the DRM key: ".concat(ve.status, " ").concat(ve.statusText, "."), be.sourceIdentifier);
              return be.context.eventHandler.fireError(me), Promise.reject(me);
            }) : Promise.reject("Could not load: No loader.");
          }, oe.prototype.isLoading = function() {
            return !!this.loader && this.loader.isLoading();
          }, oe.prototype.dispose = function() {
            this.loader && typeof this.loader.dispose == "function" && this.loader.dispose(), this.loader = void 0, this.settings = void 0;
          }, oe;
        }();
        ne.KeyLoader = se;
      }, 6082: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.StreamState = void 0, function(ae) {
          ae.Open = "open", ae.Ended = "ended", ae.Aborted = "aborted";
        }(ie || (ne.StreamState = ie = {}));
      }, 6476: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HeartbeatService = void 0;
        var ae = ie(18665), ce = 250, he = function() {
          function ue(be, ve) {
            this.serviceManager = be, this.mediaPlayerController = ve, this.heartbeatTimeoutId = -1;
          }
          return Object.defineProperty(ue.prototype, "streamTimeService", { get: function() {
            return this.serviceManager.get(ae.ServiceName.StreamTimeService);
          }, enumerable: !1, configurable: !0 }), ue.prototype.resetHeartbeatTimeout = function() {
            var be = this;
            clearTimeout(this.heartbeatTimeoutId), this.heartbeatTimeoutId = window.setTimeout(function() {
              return be.beat();
            }, ce);
          }, ue.prototype.beat = function() {
            this.resetHeartbeatTimeout(), oe(this.mediaPlayerController, this.streamTimeService);
          }, Object.defineProperty(ue.prototype, "started", { get: function() {
            return this.heartbeatTimeoutId !== -1;
          }, enumerable: !1, configurable: !0 }), ue.prototype.start = function() {
            this.beat();
          }, ue.prototype.stop = function() {
            clearTimeout(this.heartbeatTimeoutId), this.heartbeatTimeoutId = -1;
          }, ue.prototype.dispose = function() {
            this.stop();
          }, ue;
        }();
        function _e(ue) {
          ue.shouldClearSubtitleServiceBuffers() && ue.clearSubtitleServiceBuffers();
        }
        function le(ue) {
          ue.areMediaTypesFinalForPlayingPeriod() ? ue.maybeStop() : ue.isAVCompletelyLoaded() && ue.signalEndOfStream(), _e(ue);
        }
        function se(ue, be) {
          var ve = ue.getActiveSegmentControllers(), me = ve.length > 0;
          me && ve.forEach(function(pe) {
            var fe = be.getTimeForNextSegment(pe.getMimeType());
            ue.getNextSegment(pe, fe);
          }), ue.areAllLoadersReady() && (me ? _e(ue) : ue.isLoadingLastPeriod() ? le(ue) : (ue.switchLoadingPeriod(), oe(ue, be)));
        }
        function oe(ue, be) {
          ue.shouldSuspendHeartbeat() || se(ue, be);
        }
        ne.HeartbeatService = he;
      }, 9140: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.resolveContainerFormat = se;
        var ae = ie(79814), ce = ie(91520), he = ie(16368), _e = ie(73543), le = ie(58423);
        function se(be, ve, me) {
          return me ? oe(be, ve) : ue(be);
        }
        function oe(be, ve) {
          var me, pe = ce.ModuleManager.has(he.ModuleName.ContainerMP4), fe = (me = ce.ModuleManager.get(he.ModuleName.ContainerMP4, !1)) === null || me === void 0 ? void 0 : me.isValidMp4;
          return pe && fe(ve) ? { source: _e.ContainerFormat.MP4, target: _e.ContainerFormat.MP4 } : ae.MimeTypeHelper.isSubtitle(be) ? ue(be) : { source: _e.ContainerFormat.TS, target: _e.ContainerFormat.MP4 };
        }
        function ue(be) {
          var ve = (0, le.extractContainerFormat)(be);
          return ve ? { source: ve, target: ve } : void 0;
        }
      }, 9378: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentInfoProvider = void 0;
        var ae = ie(76885), ce = ie(9827), he = function() {
          function _e() {
          }
          return _e.findSegmentInfoOfRepresentation = function(le, se) {
            if (se.SegmentList) {
              var oe = se.SegmentList[0].SegmentURL, ue = le.getUrl(), be = oe.find(function(ve) {
                return _e.getSegmentInfoUrl(ve, se) === ue;
              });
              if (be)
                return be;
            }
            return null;
          }, _e.findHlsRepresentationForSegment = function(le, se) {
            var oe, ue, be = se.Representation.find(function(me) {
              return le.getRepresentationId().representationId === me._internalId.representationId;
            });
            if (be) {
              var ve = (0, ce.findSegmentUrlIndexWithinSegmentList)(le.getSegmentInfo(), (ue = (oe = be.SegmentList) === null || oe === void 0 ? void 0 : oe[0].SegmentURL) !== null && ue !== void 0 ? ue : []);
              if (ve !== -1)
                return { representation: be, index: ve };
            }
          }, _e.getSegmentInfoUrl = function(le, se) {
            var oe = le._media;
            return ae.URLHelper.isUrlAbsolute(oe) || (oe = ae.URLHelper.concatUrlParts(se.BaseURL[0], oe)), oe;
          }, _e;
        }();
        ne.SegmentInfoProvider = he;
      }, 9827: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.findSegmentUrlIndexWithinSegmentList = ce, ne.matchesMediaUrl = he;
        var ae = ie(86865);
        function ce(_e, le) {
          return le.findIndex(function(se) {
            var oe = _e.discontinuitySequenceNumber === se._discontinuitySequenceNumber, ue = he(_e.url, se._media), be = (0, ae.compareValues)(_e.byteRange, se._byteRange);
            return oe && ue && be;
          });
        }
        function he(_e, le) {
          return _e.endsWith(le) || _e.split("?")[0].endsWith(le);
        }
      }, 10997: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.AdRestorationOptimizationService = void 0;
        var ae = ie(62510), ce = ie(76650), he = ie(28819), _e = ie(27177), le = ie(94938), se = ie(18665), oe = ie(3872), ue = function() {
          function ve() {
            var me = this;
            this.startOptimization = function() {
              (0, _e.isContextAvailable)(me.context) && me.context.eventHandler.off(ae.PlayerEvent.AdStarted, me.startOptimization), me.prefetchContentSegments(me.segmentInfosToPrefetch), me.segmentInfosToPrefetch = [];
            };
          }
          return ve.prototype.updatePlayerContext = function(me) {
            this.mimeTypes = [], this.context = me, this.segmentInfoService = me.segmentInfoService, this.segmentPrefetchingService = me.segmentPrefetchingService;
          }, ve.prototype.optimizeRestorationAfterUpcomingAdBreak = function() {
            var me, pe, fe = this, ge = (pe = (me = this.getSourceState()) === null || me === void 0 ? void 0 : me.getState()) === null || pe === void 0 ? void 0 : pe.playback;
            if (!(0, _e.isContextAvailable)(this.context) || !this.segmentInfoService || !ge)
              return Promise.reject("Could not get playback state and/or SegmentInfoService");
            var ye = (0, oe.getPlaybackPosition)(ge);
            return isNaN(ye) ? Promise.reject("Could not get playback position") : this.segmentInfoService.getSegmentInfos(ye, this.context.settings.AD_RESTORATION_SEGMENT_PREFETCHING_DURATION).then(function($e) {
              fe.addCodecInfo($e), fe.segmentInfosToPrefetch = $e, (0, _e.isContextAvailable)(fe.context) && fe.context.eventHandler && fe.context.eventHandler.on(ae.PlayerEvent.AdStarted, fe.startOptimization);
            });
          }, ve.prototype.getSourceState = function() {
            return (0, _e.isContextAvailable)(this.context) ? this.context.serviceManager.get(se.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier) : void 0;
          }, ve.prototype.addCodecInfo = function(me) {
            var pe = (0, _e.isContextAvailable)(this.context) ? this.context.sourceContext.sourceIdentifier : void 0, fe = pe ? this.context.serviceManager.get(se.ServiceName.ManifestService, pe) : void 0;
            fe && me.forEach(function(ge) {
              var ye = fe.getAdaptationSet(ge.internalRepresentationId);
              ye && (ge.codecs = (0, le.getCodecsFromAdaptationSet)(ye));
            });
          }, ve.prototype.prefetchContentSegments = function(me) {
            var pe;
            this.mimeTypes = me.reduce(function(fe, ge) {
              return ge.mimeType && !fe.includes(ge.mimeType) && fe.push(ge.mimeType), fe;
            }, []), this.maybeCreateMetrics(), (pe = this.segmentPrefetchingService) === null || pe === void 0 || pe.fetchAll(me);
          }, ve.prototype.findMatchingSegmentInfo = function(me, pe) {
            var fe, ge = (fe = this.segmentPrefetchingService) === null || fe === void 0 ? void 0 : fe.getPrefetchedSegments().get(me);
            if (ge)
              return be(ge, function(ye) {
                return ye.segmentInfo;
              }).find(function(ye) {
                if (!pe || pe.segmentNumber == null || pe.startTime == null || pe.duration == null)
                  return !0;
                var $e = pe.segmentNumber + 1, Se = Math.round(pe.startTime + pe.duration), Ce = ye.segmentNumber === $e, Ie = ye.startTime != null && Math.round(ye.startTime) === Se;
                return Ce || Ie;
              });
          }, ve.prototype.hasPrefetchedSegment = function(me, pe) {
            var fe;
            if ((0, _e.isContextAvailable)(this.context) && this.context.sourceContext.isAd)
              return !1;
            var ge = me;
            return typeof me == "string" && (ge = this.findMatchingSegmentInfo(me, pe)), !(!ge || typeof ge == "string") && !!(!((fe = this.segmentPrefetchingService) === null || fe === void 0) && fe.getPrefetchedSegment(ge));
          }, ve.prototype.getPrefetchedSegment = function(me, pe) {
            var fe = this;
            if (!this.segmentPrefetchingService || !me.mimeType)
              return null;
            var ge = this.segmentPrefetchingService.getPrefetchedSegment(me);
            return this.segmentPrefetchingService.clearPrefetchingQueue(me.mimeType), ge && (this.segmentPrefetchingService.removePrefetchedSegment(me), this.segmentPrefetchingService.setShouldDownloadBeCancelledCallback(me.mimeType, pe), ge.finally(function() {
              fe.segmentPrefetchingService && me.mimeType && fe.segmentPrefetchingService.removeShouldDownloadBeCancelledCallback(me.mimeType);
            })), ge;
          }, ve.prototype.getRepresentationForPrefetchedSegment = function(me) {
            var pe, fe = (pe = this.segmentPrefetchingService) === null || pe === void 0 ? void 0 : pe.getPrefetchedSegments().get(me);
            if (fe)
              return be(fe, function(ge) {
                return ge.segmentInfo.internalRepresentationId;
              }).find(Boolean);
          }, ve.prototype.maybeCreateMetrics = function() {
            var me = this;
            if ((0, _e.isContextAvailable)(this.context)) {
              var pe = this.context.store.getState();
              if (this.mimeTypes.length !== 0 && pe) {
                var fe = (0, he.getMetricsState)(pe);
                this.mimeTypes.forEach(function(ge) {
                  fe[ge] || me.context.store.dispatch((0, ce.initializeMetricsForMimeType)(ge, me.context.settings));
                });
              }
            }
          }, ve.prototype.dispose = function() {
            (0, _e.isContextAvailable)(this.context) && this.context.eventHandler.off(ae.PlayerEvent.AdStarted, this.startOptimization), this.segmentInfosToPrefetch = [], this.segmentInfoService = void 0, this.segmentPrefetchingService = void 0;
          }, ve;
        }();
        function be(ve, me) {
          var pe = [];
          return ve.forEach(function(fe) {
            return pe.push(me(fe));
          }), pe;
        }
        ne.AdRestorationOptimizationService = ue;
      }, 12482: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.TimestampOffsetService = void 0;
        var ae = ie(18665), ce = ie(79814), he = ie(34586), _e = ie(91520), le = ie(16368), se = function() {
          function oe(ue, be) {
            this.context = ue, this.mimeType = be, this.discontinuityNumbers = /* @__PURE__ */ new Map();
            var ve = ue.sourceContext.sourceIdentifier;
            this.sourceStore = ue.serviceManager.get(ae.ServiceName.SourceStoreService, ve);
          }
          return Object.defineProperty(oe.prototype, "logger", { get: function() {
            return this.context.logger;
          }, enumerable: !1, configurable: !0 }), oe.prototype.maybeAdjustTimestampOffsetAtDiscontinuityChange = function(ue, be) {
            var ve = ue.getSegmentInfo().discontinuitySequenceNumber;
            if (ve == null || ue.isInit())
              return !1;
            var me = this.discontinuityNumbers.get(ue.getMimeType()) !== ve, pe = isNaN(be.getTimestampOffset());
            if (me || pe)
              this.adjustTimestampOffset(ue, ve, be);
            else if (ue.getSegmentInfo().wasPrefetched) {
              var fe = this.getPresentationTimeOffsetForDisco(ue, ve);
              this.setSegmentPresentationTimeOffset(ue, fe);
            }
            return this.discontinuityNumbers.set(ue.getMimeType(), ve), !0;
          }, oe.prototype.adjustTimestampOffset = function(ue, be, ve) {
            var me = this.getPresentationTimeOffsetForDisco(ue, be);
            this.maybeExtrapolateStartTimes(ue, be, ve), this.logger.debug("[".concat(this.mimeType, "] Initialized PTO for new discontinuity ").concat(be, " to ").concat(me, " on segment ").concat(ue.getUrl())), ve.setTimestampOffset(me), this.setSegmentPresentationTimeOffset(ue, me);
          }, oe.prototype.getPresentationTimeOffsetForDisco = function(ue, be) {
            var ve, me, pe = this.calculateEncodedPlaybackTime(ue).encodedPlaybackTime, fe = _e.ModuleManager.get(le.ModuleName.HLS), ge = (ve = fe == null ? void 0 : fe.selectors) !== null && ve !== void 0 ? ve : {}, ye = ge.getHlsState, $e = ge.getPresentationTimeOffset, Se = ye == null ? void 0 : ye(this.sourceStore.getState());
            return Se && (me = $e(Se, String(be))) !== null && me !== void 0 ? me : this.calculatePresentationTimeOffset(ue, pe, be);
          }, oe.prototype.setSegmentPresentationTimeOffset = function(ue, be) {
            var ve = this.calculateEncodedPlaybackTime(ue), me = ve.encodedPlaybackTime, pe = ve.shouldUpdatePlaybackTime;
            ue.getSegmentInfo().presentationTimeOffset = be, ue.setPresentationTimeOffset(be), pe && ue.setPlaybackTime(me - be);
          }, oe.prototype.maybeExtrapolateStartTimes = function(ue, be, ve) {
            var me = function(pe) {
              return "extrapolateStartTimesFromDiscontinuityStarts" in pe;
            };
            ue.getSegmentInfo().startTime == null && me(ve) && (this.logger.debug("[".concat(ue.getMimeType(), "] Missing segment startTime when trying to calculate PTO for discontinuity ").concat(be)), ve.extrapolateStartTimesFromDiscontinuityStarts(ue));
          }, oe.prototype.calculatePresentationTimeOffset = function(ue, be, ve) {
            var me = be - ue.getSegmentInfo().startTime, pe = _e.ModuleManager.get(le.ModuleName.HLS);
            return ce.MimeTypeHelper.isSubtitle(ue.getMimeType()) && he.TextSegmentAnalyzer.isPlainTextPayload(ue.getData()) || (this.sourceStore.dispatch(pe.actions.setPresentationTimeOffset(String(ve), me)), this.logger.debug("[".concat(ue.getMimeType(), "] Setting PTO for discontinuity ").concat(ve, " to ").concat(me))), me;
          }, oe.prototype.calculateEncodedPlaybackTime = function(ue) {
            var be, ve = _e.ModuleManager.get(le.ModuleName.ContainerMP4, !1), me = !0, pe = ve ? ve.parsePlaybackTime(ue, this.logger) : ue.getBaseMediaDecodeTime() / ue.getTimescale();
            return isNaN(pe) && (pe = (be = ue.getPlaybackTime()) !== null && be !== void 0 ? be : ue.getSegmentInfo().startTime, me = !1), { encodedPlaybackTime: pe, shouldUpdatePlaybackTime: me };
          }, oe.prototype.dispose = function() {
            this.discontinuityNumbers = null, this.sourceStore = null;
          }, oe;
        }();
        ne.TimestampOffsetService = se;
      }, 13034: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.findAdaptationSetOfMimeType = _e, ne.getHlsDefaultLanguage = le, ne.getPreferredLanguage = se, ne.findAdaptationSetsForMimeType = be;
        var ae = ie(79814), ce = ie(91520), he = ie(16368);
        function _e(me, pe, fe) {
          fe === void 0 && (fe = {});
          var ge, ye = fe.sourceState, $e = fe.langObj, Se = fe.periodSwitched, Ce = se(me, ye), Ie = be(pe, me);
          return Ce && (ge = oe(Ie, Ce, $e, Se)), !ge && ye && (ge = oe(Ie, le(me, ye), $e, Se)), ge || Ie[0];
        }
        function le(me, pe) {
          var fe;
          if (ce.ModuleManager.has(he.ModuleName.HLS)) {
            var ge = ce.ModuleManager.get(he.ModuleName.HLS).selectors, ye = ge.getHlsState, $e = ge.getDefaultLanguages, Se = ye(pe), Ce = Se ? $e(Se) : void 0;
            if (Ce) {
              var Ie = (fe = ae.MimeTypeHelper.getMediaType(me)) === null || fe === void 0 ? void 0 : fe.toUpperCase();
              return Ie ? Ce[Ie] : void 0;
            }
          }
        }
        function se(me, pe) {
          var fe = pe && le(me, pe), ge = { language: navigator.language || navigator.userLanguage || (fe == null ? void 0 : fe.language) };
          return ge.language && fe && ue(ge.language, fe.language) && (ge.name = fe.name), ge;
        }
        function oe(me, pe, fe, ge) {
          if (ge === void 0 && (ge = !1), me.length !== 0) {
            var ye = void 0;
            if (fe && (ye = ve(me, fe, ge)), ye)
              return ye;
            if (pe && pe.language) {
              var $e = me.filter(function(Se) {
                return !(!Se._lang || Se._lang == null) && ue(Se._lang, pe.language);
              });
              return $e.find(function(Se) {
                return Se.Representation.find(function(Ce) {
                  return Ce._name === pe.name;
                });
              }) || $e[0];
            }
          }
        }
        function ue(me, pe) {
          return !!(me != null && me.includes(pe) || pe != null && pe.includes(me));
        }
        function be(me, pe) {
          return me.AdaptationSet.filter(function(fe) {
            return fe._mimeType === pe || fe.Representation.find(function(ge) {
              return ge._mimeType === pe;
            });
          });
        }
        function ve(me, pe, fe) {
          var ge = me.find(function($e) {
            return $e._lang && pe.lang && $e._lang === pe.lang;
          }), ye = me.find(function($e) {
            return pe.adaptationSetId && $e._internalId.equals(pe.adaptationSetId);
          });
          return ye = ye || me.find(function($e) {
            return pe.id === $e._internalId.adaptationSetId;
          }), fe ? ge || ye : ye || ge;
        }
      }, 13127: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.XSDateTimeDecoder = ne.ISO8601TimeDecoder = void 0;
        var ie = function() {
          function ce() {
          }
          return ce.prototype.decode = function(he) {
            return Date.parse(he);
          }, ce;
        }();
        ne.ISO8601TimeDecoder = ie;
        var ae = function() {
          function ce() {
          }
          return ce.prototype.decode = function(he) {
            var _e = Date.parse(he);
            if (isNaN(_e)) {
              var le = ce.DATETIME_REGEX.exec(he);
              if (!le)
                return NaN;
              var se = Date.UTC(parseInt(le[1], 10), parseInt(le[2], 10) - 1, parseInt(le[3], 10), parseInt(le[4], 10), parseInt(le[5], 10), le[6] && parseInt(le[6], 10) || 0, le[7] && 1e3 * parseFloat(le[7]) || 0);
              if (le[9] && le[10]) {
                var oe = 60 * parseInt(le[9], 10) + parseInt(le[10], 10);
                se += (le[8] === "+" ? -1 : 1) * oe * 60 * 1e3;
              }
              return new Date(se).getTime();
            }
            return _e;
          }, ce.DATETIME_REGEX = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d*)(\.\d*)?)?(?:([+-])(\d{2}):(\d{2}))?/, ce;
        }();
        ne.XSDateTimeDecoder = ae;
      }, 13788: function(ee, ne, ie) {
        var ae = this && this.__spreadArray || function(be, ve, me) {
          if (me || arguments.length === 2)
            for (var pe, fe = 0, ge = ve.length; fe < ge; fe++)
              !pe && fe in ve || (pe || (pe = Array.prototype.slice.call(ve, 0, fe)), pe[fe] = ve[fe]);
          return be.concat(pe || Array.prototype.slice.call(ve));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentInfoService = void 0, ne.getSegmentInfoId = ue;
        var ce = ie(18665), he = ie(27177), _e = function() {
          function be() {
            this.segmentControllers = [];
          }
          return be.prototype.updatePlayerContext = function(ve) {
            this.context = ve;
          }, be.prototype.setSegmentControllers = function(ve) {
            this.segmentControllers = ve;
          }, be.prototype.getSegmentControllerMimeTypes = function() {
            return this.segmentControllers.map(function(ve) {
              return ve.getMimeType();
            });
          }, be.prototype.getSegmentInfos = function(ve, me) {
            if (!(0, he.isContextAvailable)(this.context))
              return Promise.resolve([]);
            var pe = this.context.serviceManager.get(ce.ServiceName.ManifestService, this.context.sourceContext.sourceIdentifier).getPeriodIdForTime(ve), fe = this.segmentControllers.map(function(ge) {
              return le(ge, { startTime: ve, duration: me, targetPeriodId: pe });
            });
            return Promise.all(fe).then(function(ge) {
              return ge.flatMap(function(ye) {
                return ye;
              });
            });
          }, be.prototype.dispose = function() {
            this.segmentControllers = [];
          }, be;
        }();
        function le(be, ve) {
          return be.getCurrentPeriodId() !== ve.targetPeriodId && be.switchPeriod(ve.targetPeriodId), be.seekTo(ve.startTime), be.getCurrentAdaptationSet() ? se(be, ve) : Promise.resolve([]);
        }
        function se(be, ve) {
          return oe(be, ve.duration).then(function(me) {
            if (me.length > 0) {
              var pe = be.getInitSegmentInfoForDataSegmentInfo(me[0]);
              if (pe)
                return ae([pe], me, !0);
            }
            return me;
          });
        }
        function oe(be, ve, me) {
          me === void 0 && (me = []);
          var pe = me[me.length - 1], fe = pe ? pe.startTime + pe.duration : 0;
          return ve <= 0 || !be.hasNext(fe) ? Promise.resolve(me) : be.getDataSegmentInfo(fe).then(function(ge) {
            return ge.duration && (ve -= ge.duration), me.push(ge), oe(be, ve, me);
          });
        }
        function ue(be) {
          return be.url + (be.byteRange ? "," + JSON.stringify(be.byteRange) : "");
        }
        ne.SegmentInfoService = _e;
      }, 14764: function(ee, ne, ie) {
        var ae, ce = this && this.__assign || function() {
          return ce = Object.assign || function(fe) {
            for (var ge, ye = 1, $e = arguments.length; ye < $e; ye++)
              for (var Se in ge = arguments[ye])
                Object.prototype.hasOwnProperty.call(ge, Se) && (fe[Se] = ge[Se]);
            return fe;
          }, ce.apply(this, arguments);
        }, he = this && this.__spreadArray || function(fe, ge, ye) {
          if (ye || arguments.length === 2)
            for (var $e, Se = 0, Ce = ge.length; Se < Ce; Se++)
              !$e && Se in ge || ($e || ($e = Array.prototype.slice.call(ge, 0, Se)), $e[Se] = ge[Se]);
          return fe.concat($e || Array.prototype.slice.call(ge));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getStreamTimeline = ne.StreamTimelineReducer = void 0;
        var _e = ie(92712), le = ie(21829), se = ie(22645), oe = ie(1590), ue = {};
        function be(fe, ge, ye) {
          var $e, Se = fe[ge] ? he([], fe[ge], !0) : [];
          return ce(ce({}, fe), (($e = {})[ge] = (0, se.addStreamTimeRangeToTimeline)(Se, ye), $e));
        }
        function ve(fe, ge, ye, $e) {
          var Se;
          if (!fe[ge])
            return fe;
          var Ce = he([], fe[ge], !0);
          if ($e) {
            var Ie = ce(ce({}, ye), { type: $e });
            Ce = (0, se.removeStreamTimeRangeFromTimeline)(Ce, Ie);
          } else
            Ce = _e.BufferRangeHelper.excludeTimeRange(Ce, ye);
          return ce(ce({}, fe), ((Se = {})[ge] = Ce, Se));
        }
        function me(fe, ge) {
          var ye;
          return ge ? ce(ce({}, fe), ((ye = {})[ge] = [], ye)) : ue;
        }
        ne.StreamTimelineReducer = (0, le.default)(ue, ((ae = {})[oe.StreamTimelineActionType.StreamTimeRangeAdd] = function(fe, ge) {
          return be(fe, ge.payload.mimeType, ge.payload.streamTimeRange);
        }, ae[oe.StreamTimelineActionType.StreamTimeRangeRemove] = function(fe, ge) {
          return ve(fe, ge.payload.mimeType, ge.payload.range, ge.payload.type);
        }, ae[oe.StreamTimelineActionType.StreamTimelineReset] = function(fe, ge) {
          return me(fe, ge.payload);
        }, ae));
        var pe = function(fe) {
          var ge;
          return (ge = fe == null ? void 0 : fe.streamTimeline) !== null && ge !== void 0 ? ge : {};
        };
        ne.getStreamTimeline = pe;
      }, 15109: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.BufferStallingService = void 0;
        var ae = ie(76420), ce = ie(26905), he = function() {
          function _e(le, se, oe) {
            this.playerStateService = le, this.logger = se, this.renderer = oe;
          }
          return _e.prototype.startStalling = function() {
            this.isRendererStalling() || (this.logger.debug("Stalling playback at ".concat(this.renderer.getCurrentTime(!0))), this.logger.insane("Video element stall started in state: ".concat(this.playerStateService.playbackState)), this.playerStateService.setIsRendererStalling(!0), this.playerStateService.isPlaying() && (this.logger.insane("Call pause on renderer"), this.renderer.pause()));
          }, _e.prototype.endStalling = function() {
            var le = this;
            if (this.isRendererStalling()) {
              this.playerStateService.setIsRendererStalling(!1);
              var se = [ae.PlaybackState.Play, ae.PlaybackState.Playing].includes(this.playerStateService.playbackState);
              this.logger.debug("Unstalling and ".concat(se ? "" : "not ", "restarting playback")), se && (!this.playerStateService.seekingOrTimeshifting && (0, ce.shouldResetCurrentTimeAfterBufferUnderrun)() && (this.logger.debug("Resetting current time before unstalling"), this.renderer.setCurrentTime(this.renderer.getCurrentTime())), this.renderer.play().catch(function(oe) {
                le.logger && le.logger.debug("Play after unstalling failed with reason: ".concat(oe));
              }));
            }
          }, _e.prototype.isRendererStalling = function() {
            return this.playerStateService.getIsRendererStalling();
          }, _e.prototype.dispose = function() {
            this.logger = null, this.playerStateService = null, this.renderer = null;
          }, _e;
        }();
        ne.BufferStallingService = he;
      }, 16280: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.mergeBufferBlockTimeRanges = _e, ne.excludeBufferBlockTimeRange = ue, ne.segmentToBufferBlockTimeRange = be;
        var ae = ie(92712), ce = 0.1;
        function he(me, pe, fe) {
          return { start: (0, ae.rangeFixedValue)(me), end: (0, ae.rangeFixedValue)(pe), bufferBlockId: fe };
        }
        function _e() {
          for (var me = [], pe = 0; pe < arguments.length; pe++)
            me[pe] = arguments[pe];
          var fe = ve(me);
          return Object.keys(fe).flatMap(function(ge) {
            return ae.BufferRangeHelper.mergeRanges(fe[ge], ce);
          });
        }
        function le(me, pe) {
          return [he(me.start, pe.start, me.bufferBlockId), he(pe.end, me.end, me.bufferBlockId)];
        }
        function se(me, pe) {
          return he(me.start >= pe.start ? pe.end : me.start, me.end > pe.end ? me.end : pe.start, me.bufferBlockId);
        }
        function oe(me, pe) {
          var fe = [];
          return me.forEach(function(ge) {
            (0, ae.areDisjoint)(ge, pe) ? fe.push(ge) : (0, ae.isSurrounding)(ge, pe) ? fe.push.apply(fe, le(ge, pe)) : (0, ae.isFullyIncluded)(ge, pe) || fe.push(se(ge, pe));
          }), fe.filter(function(ge) {
            return ge.end - ge.start >= ce;
          });
        }
        function ue(me, pe) {
          var fe = pe.bufferBlockId, ge = ve(me.map(function(Se) {
            return he(Se.start, Se.end, Se.bufferBlockId);
          })), ye = ge[fe];
          if (!(ye != null && ye.length))
            return me;
          var $e = oe(ye, pe);
          return ge[fe] = ae.BufferRangeHelper.mergeRanges($e, ce), Object.keys(ge).flatMap(function(Se) {
            return ge[Se];
          });
        }
        function be(me) {
          var pe, fe = (pe = me.getBufferBlockId()) !== null && pe !== void 0 ? pe : 1 / 0, ge = me.getPlaybackTime();
          return he(ge, ge + me.getDuration(), fe);
        }
        function ve(me) {
          var pe = {};
          return me.forEach(function(fe) {
            pe[fe.bufferBlockId] || (pe[fe.bufferBlockId] = []), pe[fe.bufferBlockId].push(fe);
          }), pe;
        }
      }, 16492: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.BufferRangesCache = void 0;
        var ae = ie(18665), ce = ie(33669), he = ie(3464), _e = ie(28337), le = function() {
          function se(oe, ue) {
            var be = this;
            this.context = oe, this.segmentStore = ue, this.sourceStore = this.getSourceStore(), this.unsubscribeToStoreChange = (0, he.subscribe)(oe.store)(_e.sourceIdentifiersSelector, function() {
              return be.onSourceIdentifierChanged();
            }, function(ve, me) {
              return !!ve.includes(be.context.sourceContext.sourceIdentifier) && (0, _e.hasASourceStoreIdentifierChanged)(ve, me);
            }), this.subscribeToBufferChange(), this.setNewCache((0, ce.getBufferState)(this.sourceStore.getState()));
          }
          return se.prototype.onSourceIdentifierChanged = function() {
            this.sourceStore = this.getSourceStore(), this.sourceStore ? (this.subscribeToBufferChange(), this.setNewCache((0, ce.getBufferState)(this.sourceStore.getState()))) : this.unsubscribeToBufferChange();
          }, se.prototype.getSourceStore = function() {
            return this.context.serviceManager.get(ae.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, se.prototype.unsubscribeToBufferChange = function() {
            this.unsubscribeToBufferRangeChange && this.unsubscribeToBufferRangeChange(), this.unsubscribeToBufferRangeChange = void 0, this.unsubscribeToStoreChange = void 0;
          }, se.prototype.subscribeToBufferChange = function() {
            var oe = this;
            this.unsubscribeToBufferChange(), this.unsubscribeToBufferRangeChange = (0, he.subscribe)(this.sourceStore)(function(ue) {
              return (0, ce.getBufferState)(ue);
            }, function(ue) {
              return oe.setNewCache(ue);
            }, ce.hasBufferRangesChanged);
          }, se.prototype.setNewCache = function(oe) {
            this.cachedBufferRanges = { overallBufferRanges: (0, ce.getBufferRangesMap)(this.segmentStore, oe, this.context.settings.GAP_TOLERANCE) };
          }, se.prototype.getRanges = function(oe) {
            return this.unsubscribeToBufferRangeChange !== void 0 && this.cachedBufferRanges !== void 0 && Object.keys(this.cachedBufferRanges.overallBufferRanges).length !== 0 || this.setNewCache(oe), this.cachedBufferRanges.overallBufferRanges;
          }, se.prototype.dispose = function() {
            this.unsubscribeToBufferChange(), this.unsubscribeToStoreChange && (this.unsubscribeToStoreChange(), this.unsubscribeToStoreChange = void 0), this.cachedBufferRanges = void 0;
          }, se;
        }();
        ne.BufferRangesCache = le;
      }, 19300: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.DiscontinuityMonitor = void 0;
        var ae = ie(62510), ce = function() {
          function he(_e) {
            var le = this;
            this.context = _e, this.onSeek = function() {
              le.seekStarted = !0;
            }, this.onSeeked = function() {
              var se = le.context.internalPlayer.getCurrentTime();
              Object.values(le.delayedSegmentPlaybackData).forEach(function(oe) {
                se >= oe.playbackTime && oe.playbackTime + oe.duration >= se && le.maybeFirePeriodSwitchEvents(oe);
              }), le.delayedSegmentPlaybackData = {};
            }, this.currentDiscontinuityNumbers = {}, this.delayedSegmentPlaybackData = {}, this.seekStarted = !1, this.context.eventHandler.on(ae.PlayerEvent.Seek, this.onSeek, !0), this.context.eventHandler.on(ae.PlayerEvent.Seeked, this.onSeeked, !0);
          }
          return he.prototype.onSegmentAvailable = function(_e) {
            if (!_e.isInit()) {
              var le = _e.getMimeType(), se = _e.getSegmentInfo();
              this.currentDiscontinuityNumbers[le] ? this.seekStarted && (this.delayedSegmentPlaybackData[_e.getMimeType()] = { mimeType: _e.getMimeType(), discontinuitySequenceNumber: se.discontinuitySequenceNumber, playbackTime: se.startTime, duration: _e.getDuration() }, this.seekStarted = !1) : this.currentDiscontinuityNumbers[le] = { discontinuitySequenceNumber: se.discontinuitySequenceNumber, startTime: se.startTime || 0 };
            }
          }, he.prototype.maybeFirePeriodSwitchEvents = function(_e) {
            var le = _e.mimeType, se = _e.discontinuitySequenceNumber, oe = _e.playbackTime;
            if (se != null && this.currentDiscontinuityNumbers[le]) {
              var ue = this.currentDiscontinuityNumbers[le].discontinuitySequenceNumber;
              ue !== se && (this.shouldFirePeriodSwitchEvent(le, se, oe) && (this.context.eventHandler.dispatchEvent(ae.PlayerEvent.PeriodSwitch), this.context.eventHandler.dispatchEvent(ae.PlayerEvent.PeriodSwitched, { sourcePeriod: { periodId: String(ue) }, targetPeriod: { periodId: String(se) } })), this.currentDiscontinuityNumbers[le] = { discontinuitySequenceNumber: se, startTime: oe });
            }
          }, he.prototype.shouldFirePeriodSwitchEvent = function(_e, le, se) {
            var oe = this, ue = Object.keys(this.currentDiscontinuityNumbers).filter(function(ve) {
              return ve !== _e;
            }), be = !0;
            return ue.forEach(function(ve) {
              var me = oe.currentDiscontinuityNumbers[ve];
              me.discontinuitySequenceNumber === le && Math.abs(se - me.startTime) < 1 && (be = !1);
            }), be;
          }, he.prototype.dispose = function() {
            this.context.eventHandler.off(ae.PlayerEvent.Seek, this.onSeek), this.context.eventHandler.off(ae.PlayerEvent.Seeked, this.onSeeked);
          }, he;
        }();
        ne.DiscontinuityMonitor = ce;
      }, 19724: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.Segregation = void 0, ne.areSegregationCriteriaEqual = oe, ne.canReuseSourceBuffer = be;
        var ae = ie(11399), ce = ie(13533), he = ie(42283), _e = ie(56435), le = ie(55937), se = function() {
          function Pe(Me, Ae) {
            this.requiredMediaTypes = Me, this.settings = Ae, this.requiredMediaTypes = Me;
          }
          return Pe.prototype.isRequiredMimeType = function(Me, Ae) {
            return Ae.getPeriodId() === void 0 || !!(this.requiredMediaTypes[Ae.getPeriodId()] && this.requiredMediaTypes[Ae.getPeriodId()][Me.getMimeType()]);
          }, Pe.prototype.getSegregationCriteria = function(Me) {
            var Ae, Oe = { encryption: ue(Me), codec: he.CodecStringHelper.extractCodec(Me.getCodec()), periodId: Me.getPeriodId() };
            if (((0, _e.isTizen2016)() || (0, _e.isTizen2017)() || (0, _e.isWebOS)() || (0, _e.isPlayStation4)()) && this.settings.HLS_CLEAR_BUFFERS_ON_DISCONTINUITY_SWITCHES) {
              var Be = (Ae = Me.getSegmentInfo()) === null || Ae === void 0 ? void 0 : Ae.discontinuitySequenceNumber;
              Be != null && (Oe.discontinuityNumber = Be);
            }
            return Oe;
          }, Pe.prototype.canAddSegmentToBufferBlock = function(Me, Ae, Oe) {
            var Be, Ve = Ae.getMediaTypes();
            if (Ve.length === 0)
              return !0;
            var Ue = Me.getMimeType(), Re = Ae.getSegregationCriteria(Ue);
            if (Re)
              return oe(Oe, Re);
            if (!this.isRequiredMimeType(Me, Ae))
              return !1;
            var Ne = (Be = Ve.find(function(ke) {
              return ke.mimeType !== Me.getMimeType();
            })) === null || Be === void 0 ? void 0 : Be.mimeType, xe = Me.getSegmentInfo().discontinuitySequenceNumber !== void 0;
            return Ne && xe ? oe(Oe, Ae.getSegregationCriteria(Ne), ["codec", "encryption"]) : Me.getPeriodId() === Ae.getPeriodId();
          }, Pe;
        }();
        function oe(Pe, Me, Ae) {
          return Ae === void 0 && (Ae = []), Object.keys(Pe).filter(function(Oe) {
            return !Ae.includes(Oe);
          }).every(function(Oe) {
            return Me && Me[Oe] === Pe[Oe];
          });
        }
        function ue(Pe) {
          return Pe.isEncrypted() ? le.EncryptionState.Encrypted : le.EncryptionState.Clear;
        }
        function be(Pe, Me, Ae) {
          var Oe = me();
          return Ae.every(function(Be) {
            var Ve = Be.mimeType;
            return Oe.canReuseSourceBuffers(Pe, Me, Ve);
          });
        }
        function ve(Pe, Me) {
          var Ae = Pe.getMediaTypes().find(function(Oe) {
            return Oe.mimeType === Me;
          });
          return Ae ? Ae.timescale : 0;
        }
        function me() {
          return (0, ce.getCapabilities)().isTizen ? ye : (0, ce.getCapabilities)().isLegacyEdge ? Se : (0, ce.getCapabilities)()[ae.CapabilityKey.isWebOS] ? $e : (0, ce.getCapabilities)()[ae.CapabilityKey.isPlayStation4] ? ge : fe;
        }
        function pe(Pe, Me, Ae) {
          return { currentCriteria: Pe.getSegregationCriteria(Ae), nextCriteria: Me.getSegregationCriteria(Ae) };
        }
        ne.Segregation = se;
        var fe = { canReuseSourceBuffers: function(Pe, Me, Ae) {
          var Oe = pe(Pe, Me, Ae);
          return Ce(Oe.currentCriteria, Oe.nextCriteria);
        } }, ge = { canReuseSourceBuffers: function(Pe, Me, Ae) {
          var Oe = pe(Pe, Me, Ae), Be = Oe.currentCriteria, Ve = Oe.nextCriteria;
          return Ce(Be, Ve) && Ie(Be, Ve) && Ee(Be, Ve) && Te(Be, Ve) && we(Pe, Me, Ae);
        } }, ye = { canReuseSourceBuffers: function(Pe, Me, Ae) {
          var Oe = pe(Pe, Me, Ae), Be = Oe.currentCriteria, Ve = Oe.nextCriteria;
          return !(0, _e.isTizen2017)() && Ce(Be, Ve) && Ie(Be, Ve) && we(Pe, Me, Ae);
        } }, $e = { canReuseSourceBuffers: function(Pe, Me, Ae) {
          var Oe = pe(Pe, Me, Ae), Be = Oe.currentCriteria, Ve = Oe.nextCriteria, Ue = Ce(Be, Ve) && we(Pe, Me, Ae) && !Ee(Be, Ve);
          return ((0, _e.isWebOs2017)() || (0, _e.isWebOs2016)()) && (Ue = Ue && Ie(Be, Ve)), Ue;
        } }, Se = { canReuseSourceBuffers: function(Pe, Me, Ae) {
          return !1;
        } };
        function Ce(Pe, Me) {
          return (Pe == null ? void 0 : Pe.codec) === (Me == null ? void 0 : Me.codec);
        }
        function Ie(Pe, Me) {
          return (Pe == null ? void 0 : Pe.encryption) === (Me == null ? void 0 : Me.encryption);
        }
        function Te(Pe, Me) {
          return (Pe == null ? void 0 : Pe.periodId) === (Me == null ? void 0 : Me.periodId);
        }
        function Ee(Pe, Me) {
          return (Pe == null ? void 0 : Pe.discontinuityNumber) === (Me == null ? void 0 : Me.discontinuityNumber);
        }
        function we(Pe, Me, Ae) {
          return ve(Pe, Ae) === ve(Me, Ae);
        }
      }, 20417: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.throwDownloadError = ue;
        var ae = ie(25550), ce = ie(28764), he = ie(63546), _e = ie(35148), le = ie(62510), se = ie(90637), oe = ie(66864);
        function ue(me, pe, fe, ge, ye) {
          me.eventHandler.dispatchEvent(le.PlayerEvent.Warning, new he.PlayerWarning(_e.WarningCode.PLAYBACK_DECODE_RETRIES_EXCEEDED)), me.eventHandler.fireError(be(me, pe, fe, ge, ye));
        }
        function be(me, pe, fe, ge, ye) {
          if (fe === 0)
            return pe && pe === se.RequestError.TimedOut || ye === oe.SegmentLoadingErrorReason.TIMEOUT ? new ce.PlayerError(ae.ErrorCode.NETWORK_SEGMENT_DOWNLOAD_TIMEOUT, { segmentUrl: ge.url, mimeType: ge.mimeType }, "Failed to load the segment: the request timed out.") : new ce.PlayerError(ae.ErrorCode.NETWORK_ERROR, { url: ge.url, statusCode: fe }, pe);
          me.logger.debug(pe);
          var $e = { message: pe };
          return ge.url && ($e.segment = ve(ge)), ye === oe.SegmentLoadingErrorReason.TIMEOUT ? new ce.PlayerError(ae.ErrorCode.NETWORK_SEGMENT_DOWNLOAD_TIMEOUT, $e, pe) : new ce.PlayerError(ae.ErrorCode.NETWORK_ERROR, $e, pe);
        }
        function ve(me) {
          return { url: me.url, mimeType: me.mimeType, codecs: me.codecs };
        }
      }, 21918: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.TimeShiftHandler = void 0;
        var ae = ie(18665), ce = ie(62510), he = ie(58975), _e = ie(331), le = ie(70016), se = ie(54838), oe = ie(91520), ue = ie(16368), be = ie(59839), ve = ie(22645), me = ie(64729), pe = ie(87062), fe = ie(93109), ge = function() {
          function $e(Se, Ce, Ie, Te) {
            var Ee = this;
            this.onSeek = function() {
              Ee.updateInitialTimeShiftContext(!0);
            }, this.onSeeked = function(we) {
              var Pe = Ee.context.renderer.getCurrentTime(!0), Me = Pe - we;
              Me = se.Util.roundValue(Me, 1), Ee.updateTimeShiftStateAfterSeek(Me, Pe);
            }, this.context = Se, this.mediaPlayerController = Ce, this.bufferController = Ie, this.segmentControllers = Object.keys(Te).map(function(we) {
              return Te[we];
            }), this.manifestService = Se.serviceManager.get(ae.ServiceName.ManifestService, Se.sourceContext.sourceIdentifier), this.logger = Se.logger, this.timeShiftCounter = 0, this.sourceIdentifier = Se.sourceContext.sourceIdentifier, this.setupStoreSubscriptions();
          }
          return $e.prototype.isLowLatency = function() {
            var Se = (0, pe.isLowLatencyConfigured)(this.context), Ce = (0, fe.isPlayingLowLatencyHls)(this.context);
            return Se || Ce;
          }, $e.prototype.calculateLiveEdgeInVideoTime = function() {
            var Se;
            if (this.initialTimeShiftContext && !this.initialTimeShiftContext.isOngoing) {
              var Ce = (0, _e.toSeconds)(Date.now() - this.initialTimeShiftContext.timestamp);
              Se = this.initialTimeShiftContext.liveEdge + Ce;
            } else
              Se = this.getInitialLiveEdge();
            return isFinite(Se) || (Se = (0, _e.toSeconds)(Date.now() - this.manifestService.getAvailabilityStartTime())), Se;
          }, $e.prototype.getInitialLiveEdge = function() {
            var Se = this.calculateMpdHandlerLiveEdge();
            if (!this.isLowLatency())
              return Se;
            var Ce = this.segmentControllers.reduce(function(Te, Ee) {
              return Math.min(Te, Ee.getMPDHandler().getSegmentDuration());
            }, 1 / 0), Ie = this.getWallclockTimeInSeconds();
            return Ie - Se < Ce ? Ie : Se;
          }, $e.prototype.getWallclockTimeInSeconds = function() {
            var Se = this.context.serviceManager.maybeCall(ae.ServiceName.SynchronizedTimeService, function(Ce) {
              return Ce.getTimeDifference();
            }, 0, this.context.sourceContext.sourceIdentifier);
            return (0, _e.toSeconds)(Date.now() + Se);
          }, $e.prototype.calculateMpdHandlerLiveEdge = function() {
            return this.segmentControllers.map(function(Se) {
              return Se.getLiveEdgeTime();
            }).reduce(function(Se, Ce) {
              return Ce < Se && Ce >= 0 ? Ce : Se;
            }, 1 / 0);
          }, $e.prototype.updateSegmentControllers = function(Se) {
            this.segmentControllers = Object.values(Se);
          }, $e.prototype.getMaxTimeShift = function() {
            if (this.manifestService.getManifest()) {
              var Se = this.manifestService.getTimeShiftBufferDepthSeconds();
              return Math.min(Se + this.manifestService.getDesiredDistanceToLiveEdge(), 0);
            }
            return 0;
          }, $e.prototype.getTimeShiftLiveEdge = function() {
            return this.calculateLiveEdgeInVideoTime() - this.manifestService.getDesiredDistanceToLiveEdge();
          }, $e.prototype.getTimeShift = function() {
            var Se = this.getActualTimeShift();
            if (this.lastTimeShiftStatus) {
              var Ce = (0, _e.toSeconds)(Date.now() - this.lastTimeShiftStatus.completionDate) - (this.mediaPlayerController.getCurrentTime() - this.lastTimeShiftStatus.reachedTime);
              if (Math.abs(Ce) < this.context.settings.ACCEPTABLE_TIMESHIFT_INACCURACY)
                return this.lastTimeShiftStatus.offset;
            }
            var Ie = this.getMaxTimeShift();
            return Se < Ie && (Se = Ie), Se > 0 && (Se = 0), Se;
          }, $e.prototype.getActualTimeShift = function(Se) {
            return Se === void 0 && (Se = !1), !this.initialTimeShiftContext || this.initialTimeShiftContext.isOngoing ? 0 : (Se ? this.mediaPlayerController.getBufferRelevantTime() : this.mediaPlayerController.getCurrentTime()) - this.getTimeShiftLiveEdge();
          }, $e.prototype.getDistanceToRealLiveEdge = function() {
            return this.calculateLiveEdgeInVideoTime() - this.mediaPlayerController.getBufferRelevantTime();
          }, $e.prototype.timeShift = function(Se, Ce, Ie) {
            var Te = this;
            Ie === void 0 && (Ie = !1);
            var Ee = !!this.initialTimeShiftContext;
            Ee || this.adjustTargetBufferLevel(), Se = Math.max(this.getMaxTimeShift(), Se);
            var we = this.mediaPlayerController.getCurrentTime(), Pe = this.calculatePlaybackTimeForTimeShiftOffset(Se), Me = this.manifestService.getPeriodIdForTime(Pe);
            this.timeShiftCounter++;
            var Ae = this.timeShiftCounter, Oe = Ie || this.bufferController.shouldBuffersBeClearedOnTimeshift(Pe);
            return this.logger.debug("Performing timeShift to offset ".concat(Se, ", time: ").concat(we, " -> ").concat(Pe, ", period: ").concat(Me)), this.bufferController.setTimeshiftCancelState(!1), (0, le.isDefined)(Me) && this.mediaPlayerController.updatePeriodForTimeshift(Me, !Ee, Oe), Oe && this.segmentControllers.forEach(function(Be) {
              return Be.seekTo(Pe);
            }), Ee && this.maybeResetTransmuxerForPtsRollover(Pe), this.updateInitialTimeShiftContext(!0), this.bufferController.setCurrentTime(Pe, Me, !0, Ie).then(function(Be) {
              Te.updateInitialTimeShiftContext(!1), Te.lastTimeShiftStatus = { offset: Se, completionDate: Date.now(), reachedTime: Be }, Te.timeShiftCounter === Ae && Ce ? (Te.logger.debug("Successfully timeShifted to ".concat(Be, ", hit target time with a diff of ").concat(Be - Pe)), Ce()) : Ce && Te.context.logger.debug("Timeshift to ".concat(Se, " has finished but a newer operation has been started"));
            }).catch(function(Be) {
              Te.logger.debug("Failed to set currentTime on timeShift", Be);
            }).finally(function() {
              return Te.bufferController.setTimeshiftCancelState(!1);
            });
          }, $e.prototype.maybeResetTransmuxerForPtsRollover = function(Se) {
            var Ce;
            if (this.manifestService.isHlsManifest()) {
              var Ie = this.context.serviceManager.get(ae.ServiceName.SourceStoreService, this.sourceIdentifier);
              ye((Ce = oe.ModuleManager.get(ue.ModuleName.HLS)) === null || Ce === void 0 ? void 0 : Ce.selectors.getHlsState(Ie == null ? void 0 : Ie.getState()), Se) && (this.context.logger.debug("Resetting transmuxer because target is beyond a timestamp rollover"), this.mediaPlayerController.resetTransmuxer());
            }
          }, $e.prototype.cancel = function() {
            this.context.logger.debug("Cancelling ongoing time shift operation..."), this.bufferController.setTimeshiftCancelState(!0);
          }, $e.prototype.calculatePlaybackTimeForTimeShiftOffset = function(Se) {
            var Ce = this.manifestService.getDesiredDistanceToLiveEdge(), Ie = this.calculateLiveEdgeInVideoTime(), Te = Ie + (Se - Ce);
            return this.manifestService.hasMultiplePeriods() ? (0, me.adjustTargetTimeToPeriodStart)(Te, this.context.settings.END_OF_BUFFER_TOLERANCE, this.manifestService, this.context.logger) : Se === 0 && this.isLowLatency() ? Math.min(Ie, Te + this.context.settings.LOW_LATENCY_SEEK_AHEAD) : Te;
          }, $e.prototype.onManifestUpdate = function() {
            this.manifestService.isLive() && (this.adjustTargetBufferLevel(), this.getActualTimeShift(!0) < this.getMaxTimeShift() - this.getMinSegmentDuration() && this.context.eventHandler.dispatchEvent(ce.PlayerEvent.DVRWindowExceeded), this.removeDroppedOutFailedBufferRanges());
          }, $e.prototype.removeDroppedOutFailedBufferRanges = function() {
            var Se = this;
            this.context.serviceManager.maybeCall(ae.ServiceName.SourceStoreService, function(Ce) {
              var Ie, Te = Se.manifestService.getTimeShiftBufferDepthSeconds(), Ee = Se.calculateLiveEdgeInVideoTime() + Te, we = (Ie = Ce.getState()) === null || Ie === void 0 ? void 0 : Ie.streamTimeline;
              we !== void 0 && Object.keys(we).forEach(function(Pe) {
                Ce.dispatch((0, be.removeStreamTimeRange)(Pe, { start: 0, end: Ee }, ve.StreamTimeRangeType.Failed));
              });
            });
          }, $e.prototype.isTimeInBufferedRange = function(Se) {
            return this.bufferController.isTimeInBufferedRange(Se);
          }, $e.prototype.getMinSegmentDuration = function() {
            return this.segmentControllers.reduce(function(Se, Ce) {
              return Math.min(Se, Ce.getMPDHandler().getSegmentDuration());
            }, 1 / 0);
          }, $e.prototype.adjustTargetBufferLevel = function() {
            this.context.bufferSettings.setTargetBufferLevelConstraints({ minimumBufferLength: this.getMinSegmentDuration(), currentDistanceToLiveEdge: this.getDistanceToRealLiveEdge(), streamDuration: Math.abs(this.manifestService.getTimeShiftBufferDepthSeconds()) });
          }, $e.prototype.updateTimeShiftStateAfterSeek = function(Se, Ce) {
            this.lastTimeShiftStatus = { completionDate: Date.now(), reachedTime: Ce, offset: Se }, this.updateInitialTimeShiftContext(!1);
          }, $e.prototype.updateInitialTimeShiftContext = function(Se) {
            (!this.initialTimeShiftContext || !Se && this.initialTimeShiftContext.isOngoing) && (this.initialTimeShiftContext = { timestamp: Date.now(), liveEdge: this.calculateLiveEdgeInVideoTime(), isOngoing: Se });
          }, $e.prototype.setupStoreSubscriptions = function() {
            var Se = this;
            this.unsubscribeOnSeek = (0, he.subscribeToSeek)(this.context.store, this.onSeek), this.unsubscribeOnSeeked = (0, he.subscribeToSeeked)(this.context.store, function(Ce, Ie) {
              return Se.onSeeked(Ie.seekingProcess.seekableRange.end);
            });
          }, $e.prototype.removeStoreSubscriptions = function() {
            var Se, Ce;
            (Se = this.unsubscribeOnSeek) === null || Se === void 0 || Se.call(this), (Ce = this.unsubscribeOnSeeked) === null || Ce === void 0 || Ce.call(this);
          }, $e.prototype.dispose = function() {
            this.removeStoreSubscriptions(), this.bufferController.setTimeshiftCancelState(!0);
          }, $e;
        }();
        function ye($e, Se) {
          var Ce, Ie, Te = (Ie = (Ce = $e == null ? void 0 : $e.timestampRolloverPositions) === null || Ce === void 0 ? void 0 : Ce.next) !== null && Ie !== void 0 ? Ie : -1;
          return Te !== -1 && (Se >= Te || Se <= $e.timestampRolloverPositions.previous);
        }
        ne.TimeShiftHandler = ge;
      }, 22645: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.StreamTimeRangeType = void 0, ne.addStreamTimeRangeToTimeline = le, ne.removeStreamTimeRangeFromTimeline = se, ne.getTrackIdentifier = ue;
        var ae, ce = ie(92712), he = ie(87326), _e = ie(79814);
        function le(be, ve) {
          var me = be.filter(function(fe) {
            return fe.type === ve.type;
          }).concat(ve), pe = ce.BufferRangeHelper.mergeRanges(me, he.DefaultSettings.GAP_TOLERANCE);
          return be = be.filter(function(fe) {
            return fe.type !== ve.type;
          }), pe.forEach(function(fe) {
            be = oe(be, fe, function(ge) {
              return ge.start > fe.start;
            });
          }), be;
        }
        function se(be, ve) {
          var me = be.filter(function(fe) {
            return fe.type === ve.type;
          }), pe = ce.BufferRangeHelper.excludeTimeRange(me, ve);
          return be = be.filter(function(fe) {
            return fe.type !== ve.type;
          }), pe.forEach(function(fe) {
            fe.end - fe.start > he.DefaultSettings.GAP_TOLERANCE && (be = oe(be, fe, function(ge) {
              return ge.start > fe.start;
            }));
          }), be;
        }
        function oe(be, ve, me) {
          var pe = be.findIndex(me);
          return pe < 0 ? be.push(ve) : be.splice(pe, 0, ve), be;
        }
        function ue(be) {
          var ve = be.mimeType, me = be.internalRepresentationId;
          return _e.MimeTypeHelper.isSubtitle(ve) ? "".concat(ve, "/").concat(me.adaptationSetId) : ve;
        }
        (function(be) {
          be.Loading = "loading", be.Failed = "failed";
        })(ae || (ne.StreamTimeRangeType = ae = {}));
      }, 22916: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.resolveMediaTypes = he;
        var ae = ie(42283), ce = ie(94938);
        function he(_e) {
          return (0, ce.getCodecsFromAdaptationSet)(_e).split(",").map(function(le) {
            return (0, ae.getMediaTypeFromCodec)(le);
          });
        }
      }, 23414: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.TechnologyChecker = void 0;
        var ae = ie(91520), ce = ie(16368), he = function() {
          function _e() {
          }
          return _e.prototype.getSupportedTechnologies = function() {
            return ae.ModuleManager.has(ce.ModuleName.RendererMse) ? ae.ModuleManager.get(ce.ModuleName.RendererMse).technologyChecker.getSupportedTechnologies() : [];
          }, _e;
        }();
        ne.TechnologyChecker = he;
      }, 25040: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getEncryptionKey = ne.getAllEncryptionKeys = void 0;
        var ie = function(ce) {
          return ce == null ? void 0 : ce.encryptionKeys;
        };
        ne.getAllEncryptionKeys = ie;
        var ae = function(ce, he) {
          var _e;
          return (_e = ce == null ? void 0 : ce.encryptionKeys) === null || _e === void 0 ? void 0 : _e.find(function(le) {
            return le.uri === he;
          });
        };
        ne.getEncryptionKey = ae;
      }, 25996: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.PlayerConfigEnhancer = void 0;
        var ae = ie(25226), ce = ie(54838), he = ie(87062), _e = function() {
          function le(se) {
            this.originalConfig = {}, ce.Util.deepCopy(this.originalConfig, se.config), this.originalSettings = {}, ce.Util.deepCopy(this.originalSettings, se.settings);
          }
          return le.prototype.adjustToCurrentSource = function(se, oe) {
            var ue, be, ve, me, pe = se.config;
            if (pe.adaptation && (pe.adaptation.logic = (ue = this.originalConfig.adaptation) === null || ue === void 0 ? void 0 : ue.logic), se.settings.CHUNKED_CMAF_STREAMING = this.originalSettings.CHUNKED_CMAF_STREAMING, oe.isDashManifest() && oe.isLive() && (0, he.isLowLatencyConfigured)(se)) {
              se.logger.debug("Detected DASH Live stream and LL config, enabling 'low-latency-v1' adaptation logic and CHUNKED_CMAF_STREAMING tweak"), pe.adaptation = (be = pe.adaptation) !== null && be !== void 0 ? be : {}, pe.adaptation.logic = (ve = pe.adaptation.logic) !== null && ve !== void 0 ? ve : ae.AdaptationLogicType.LOW_LATENCY;
              var fe = se.internalPlayer.getConfig().tweaks || {};
              se.settings.CHUNKED_CMAF_STREAMING = (me = fe.CHUNKED_CMAF_STREAMING) === null || me === void 0 || me;
            }
          }, le;
        }();
        ne.PlayerConfigEnhancer = _e;
      }, 26382: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(ve) {
            for (var me, pe = 1, fe = arguments.length; pe < fe; pe++)
              for (var ge in me = arguments[pe])
                Object.prototype.hasOwnProperty.call(me, ge) && (ve[ge] = me[ge]);
            return ve;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.FetchController = void 0;
        var ce, he = ie(90637), _e = ie(23234), le = ie(67345), se = ie(10981), oe = ie(72207);
        (function(ve) {
          ve.User = "user", ve.Timeout = "timeout";
        })(ce || (ce = {}));
        var ue = function() {
          function ve(me, pe, fe, ge) {
            var ye = this;
            this.useStreamResponse = ge, this.setProgressListener = function($e) {
              ye.progressListener = $e;
            }, this.onProgress = function($e) {
              ye.progressListener && (ye.timing.progressTimestamp = _e.TimingUtil.getHiResTimestamp(), ye.progress.loadedBytes = $e, ye.progressListener(ae({}, ye.progress)));
            }, this.onSuccess = function() {
              clearTimeout(ye.cancelTimeout);
            }, this.logger = me.logger, this.timeout = fe, this.request = pe, this.fetching = new se.Deferred(), this.bytesReceivedCount = 0, this.timing = { sendTimestamp: -1, openedTimestamp: -1, headersReceivedTimestamp: -1, progressTimestamp: -1, doneTimestamp: -1 }, this.abortController = new AbortController(), this.progress = { loadedBytes: 0, url: pe.url, responseTiming: this.timing, chunks: [], elapsedTime: 0 };
          }
          return ve.prototype.getResponse = function() {
            return this.load(this.request), this.fetching.promise;
          }, ve.prototype.cancel = function(me) {
            me === void 0 && (me = ce.User), clearTimeout(this.cancelTimeout), this.cancellationReason = me, this.abortController.abort();
          }, ve.prototype.load = function(me) {
            var pe, fe = this, ge = { method: me.method, headers: new Headers(me.headers), credentials: me.credentials, signal: this.abortController ? this.abortController.signal : void 0, body: be(me.method) ? me.body : void 0 };
            this.timing.sendTimestamp = _e.TimingUtil.getHiResTimestamp(), fetch(me.url, ge).then(function(ye) {
              var $e;
              if (fe.timing.headersReceivedTimestamp = _e.TimingUtil.getHiResTimestamp(), ($e = fe.progressListener) === null || $e === void 0 || $e.call(fe, ae({}, fe.progress)), ye.ok) {
                var Se = fe.createHttpResponse(ye);
                fe.readResponse(ye).then(function(Ce) {
                  Se.body = Ce, Se.length = fe.bytesReceivedCount, Se.timeToFirstByte = fe.timing.headersReceivedTimestamp - fe.timing.sendTimestamp, fe.timing.doneTimestamp > 0 && (Se.elapsedTime = fe.timing.doneTimestamp - fe.timing.sendTimestamp), fe.fetching.resolve(Se);
                }).catch(function(Ce) {
                  fe.onError({ error: Ce.message, response: fe.createHttpResponse(ye) });
                });
              } else
                fe.onError({ error: he.RequestError.Failed, response: fe.createHttpResponse(ye) });
            }).catch(function(ye) {
              fe.onError({ error: fe.getRequestError(ye) });
            }), this.timing.openedTimestamp = _e.TimingUtil.getHiResTimestamp(), (pe = this.progressListener) === null || pe === void 0 || pe.call(this, ae({}, this.progress)), this.cancelTimeout = setTimeout(function() {
              return fe.cancel(ce.Timeout);
            }, this.timeout);
          }, ve.prototype.getResponseHeaders = function(me) {
            var pe = {};
            return me.headers.forEach(function(fe, ge) {
              return pe[ge] = fe;
            }), pe;
          }, ve.prototype.createHttpResponse = function(me) {
            return { request: this.request, url: me.url, headers: this.getResponseHeaders(me), status: me.status, statusText: me.statusText };
          }, ve.prototype.getRequestError = function(me) {
            return this.logger.debug("fetch error", me), me instanceof Error && me.name === "AbortError" ? this.cancellationReason === ce.User ? he.RequestError.Canceled : he.RequestError.TimedOut : he.RequestError.Failed;
          }, ve.prototype.readResponse = function(me) {
            var pe = this;
            if (me.body && this.useStreamResponse) {
              var fe = new oe.Stream(), ge = this.timing.headersReceivedTimestamp;
              return this.readReadableStreamResponse(me, function(Se) {
                var Ce = _e.TimingUtil.getHiResTimestamp(), Ie = Ce - ge;
                ge = Ce, pe.progress.chunks.push({ downloadDuration: Ie, bytes: Se.byteLength });
                var Te = Se instanceof Uint8Array ? Se.buffer : Se;
                fe.add(Te);
              }).then(function() {
                fe.end(), pe.onSuccess();
              }).catch(function(Se) {
                pe.logger.debug("Error reading of fetch response:", Se), fe.abort(pe.getRequestError(Se));
              }), Promise.resolve(fe);
            }
            var ye = me.headers.get("Content-Length"), $e = ye ? parseInt(ye) : 0;
            return this.progress.totalBytes = $e, this.readReadableStreamResponse(me.clone()).catch(function(Se) {
              pe.logger.debug("Error reading of fetch response:", Se);
            }), this.readFullFetchResponse(me).then(function(Se) {
              return pe.bytesReceivedCount = $e, pe.timing.doneTimestamp = _e.TimingUtil.getHiResTimestamp(), pe.onSuccess(), Se;
            });
          }, ve.prototype.readReadableStreamResponse = function(me, pe) {
            var fe = this;
            if (!me.body)
              return Promise.reject(new Error("response.body is null"));
            var ge = me.body.getReader(), ye = function() {
              return ge.read().then(function($e) {
                var Se = $e.done, Ce = $e.value;
                return Se ? (fe.timing.doneTimestamp = _e.TimingUtil.getHiResTimestamp(), void fe.onProgress(fe.bytesReceivedCount)) : Ce ? (pe == null || pe(Ce), fe.bytesReceivedCount += Ce.byteLength, fe.onProgress(fe.bytesReceivedCount), ye()) : void 0;
              });
            };
            return ye();
          }, ve.prototype.readFullFetchResponse = function(me) {
            switch (this.request.responseType) {
              case le.HttpResponseType.ARRAYBUFFER:
                return me.arrayBuffer();
              case le.HttpResponseType.TEXT:
                return me.text();
              case le.HttpResponseType.JSON:
                return me.json();
              default:
                return Promise.reject(new Error("Unsupported response type on fetch request"));
            }
          }, ve.prototype.onError = function(me) {
            clearTimeout(this.cancelTimeout), this.logger.debug("Error performing fetch: ".concat(me.error), me.response), this.fetching.reject(me);
          }, ve;
        }();
        function be(ve) {
          return ![le.HttpRequestMethod.GET, le.HttpRequestMethod.HEAD].includes(ve);
        }
        ne.FetchController = ue;
      }, 27076: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.DeferredReject = void 0;
        var ie = function() {
          function ae() {
            this.rejected = !1;
          }
          return ae.prototype.reject = function(ce) {
            this.rejected = !0, this.rejectMessage = ce;
          }, ae.prototype.next = function(ce) {
            return this.rejected ? Promise.reject(this.rejectMessage) : ce();
          }, ae;
        }();
        ne.DeferredReject = ie;
      }, 28171: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MediaPlayerManifestApiFactory = void 0;
        var ae = ie(18665), ce = ie(62510), he = ie(96953), _e = function() {
          function le() {
          }
          return le.create = function(se, oe) {
            var ue = oe.serviceManager.get(ae.ServiceName.ManifestService, oe.sourceContext.sourceIdentifier);
            return new (function() {
              function be() {
                ue.isHlsManifest() ? this.hls = le.createHlsApi(ue) : ue.isSmoothManifest() || (this.dash = le.createDashApi(se, ue));
              }
              return be;
            }())();
          }, le.createDashApi = function(se, oe) {
            return new (function() {
              function ue() {
              }
              return ue.prototype.getPeriod = function() {
                var be = oe.getPeriodIdForTime(se.getCurrentTime()), ve = oe.getPeriod(new he.PeriodId(be));
                return ve ? le.createPeriodApi(oe, ve) : null;
              }, ue.prototype.listPeriods = function() {
                return oe.getAllPeriods().map(function(be) {
                  return le.createPeriodApi(oe, be);
                });
              }, ue;
            }())();
          }, le.createHlsApi = function(se) {
            return new (function() {
              function oe() {
                this.properties = se.getHlsTags();
              }
              return oe.prototype.getVideoTracks = function() {
                return le.getVideoTracks(se, se.getFirstPeriod()._id);
              }, oe.prototype.getAudioTracks = function() {
                return le.getAudioTracks(se, se.getFirstPeriod()._id);
              }, oe.prototype.getTextTracks = function() {
                return le.getTextTracks(se, se.getFirstPeriod()._id);
              }, oe;
            }())();
          }, le.createPeriodApi = function(se, oe) {
            return new (function() {
              function ue() {
                this.id = oe._id, this.properties = {}, oe._id && (this.properties.id = oe._id), oe._start && (this.properties.start = oe._start), oe._duration && (this.properties.duration = oe._duration);
              }
              return ue.prototype.getVideoTracks = function() {
                return le.getVideoTracks(se, this.id);
              }, ue.prototype.getAudioTracks = function() {
                return le.getAudioTracks(se, this.id);
              }, ue.prototype.getTextTracks = function() {
                return le.getTextTracks(se, this.id);
              }, ue.prototype.getMetadata = function() {
                return le.getMetadata(se, this.id);
              }, ue;
            }())();
          }, le.getAudioTracks = function(se, oe) {
            return se.getAvailableAudio(oe, !1).map(function(ue) {
              var be = { id: ue.id, label: ue.label, lang: ue.lang, getQualities: function() {
                return le.getAudioQualities(se, oe, ue.id);
              } };
              return ue.role && (be.role = ue.role), be;
            });
          }, le.getVideoTracks = function(se, oe) {
            return se.getAvailableVideo(oe).map(function(ue) {
              var be = { id: ue.id, label: ue.label, getQualities: function() {
                return le.getVideoQualities(se, oe);
              } };
              return ue.role && (be.role = ue.role), be;
            });
          }, le.getTextTracks = function(se, oe) {
            return se.getAvailableSubtitles(oe);
          }, le.getMetadata = function(se, oe) {
            return se.getEventStreamEvents(se.findPeriod(oe)).map(function(ue) {
              return { type: ce.MetadataType.EVENT_STREAM, payload: ue.data, start: ue.startTime, end: ue.endTime };
            });
          }, le.getAudioQualities = function(se, oe, ue) {
            return se.getAudioRepresentations(oe)[ue] || [];
          }, le.getVideoQualities = function(se, oe) {
            return se.getVideoRepresentations(oe);
          }, le;
        }();
        ne.MediaPlayerManifestApiFactory = _e;
      }, 28196: function(ee, ne, ie) {
        var ae, ce = this && this.__assign || function() {
          return ce = Object.assign || function(Re) {
            for (var Ne, xe = 1, ke = arguments.length; xe < ke; xe++)
              for (var Le in Ne = arguments[xe])
                Object.prototype.hasOwnProperty.call(Ne, Le) && (Re[Le] = Ne[Le]);
            return Re;
          }, ce.apply(this, arguments);
        }, he = this && this.__spreadArray || function(Re, Ne, xe) {
          if (xe || arguments.length === 2)
            for (var ke, Le = 0, He = Ne.length; Le < He; Le++)
              !ke && Le in Ne || (ke || (ke = Array.prototype.slice.call(Ne, 0, Le)), ke[Le] = Ne[Le]);
          return Re.concat(ke || Array.prototype.slice.call(Ne));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ManifestReducer = void 0;
        var _e = ie(21829), le = ie(65114), se = ie(94938), oe = ie(77329);
        function ue(Re, Ne) {
          return Ne.payload.manifest || Re;
        }
        function be(Re, Ne) {
          return ce(ce({}, Re), { isInitialized: Ne.payload.isInitialized });
        }
        function ve(Re, Ne) {
          return Ne.payload.representationIds.length === 0 ? Re : (0, se.removeRepresentations)(Re, Ne.payload.representationIds);
        }
        function me(Re, Ne) {
          return Ne.payload.offset ? ce(ce({}, Re), { Period: Re.Period.map(function(xe) {
            return ce(ce({}, xe), { start: xe.start + Ne.payload.offset });
          }) }) : Re;
        }
        function pe(Re, Ne) {
          if (!Re.Period)
            return Re;
          var xe = Ne.periodId, ke = Ne.timing, Le = Re.Period.findIndex(function(We) {
            return We._id === xe;
          });
          if (Le < 0)
            return Re;
          var He = he([], Re.Period, !0);
          return He[Le] = ce(ce({}, He[Le]), ke), ce(ce({}, Re), { Period: He });
        }
        function fe(Re, Ne) {
          return ce(ce({}, Re), Ne);
        }
        function ge(Re, Ne) {
          var xe, ke = Ne.adaptationSetId, Le = Ne.updates, He = Re.Period.findIndex(function(tt) {
            return tt._id === ke.periodId;
          });
          if (He < 0)
            return Re;
          var We = (xe = Re.Period[He]) === null || xe === void 0 ? void 0 : xe.AdaptationSet.findIndex(function(tt) {
            return tt._internalId.equals(ke);
          });
          if (We < 0)
            return Re;
          var Xe = ce({}, Re);
          Xe.Period = he([], Xe.Period, !0), Xe.Period[He] = ce({}, Xe.Period[He]);
          var Qe = Xe.Period[He];
          return Qe.AdaptationSet = he([], Qe.AdaptationSet, !0), Qe.AdaptationSet[We] = ce(ce({}, Qe.AdaptationSet[We]), Le), Xe;
        }
        function ye(Re, Ne) {
          var xe, ke, Le, He = Ne, We = He._internalId;
          if (!Re.Period)
            return Re;
          var Xe = Re.Period.findIndex(function(ze) {
            return ze._id === We.periodId;
          }), Qe = (xe = Re.Period[Xe]) === null || xe === void 0 ? void 0 : xe.AdaptationSet.findIndex(function(ze) {
            return ze._internalId.equals(We);
          }), tt = (Le = (ke = Re.Period[Xe]) === null || ke === void 0 ? void 0 : ke.AdaptationSet[Qe]) === null || Le === void 0 ? void 0 : Le.Representation.findIndex(function(ze) {
            return ze._internalId.equals(We);
          }), Je = ce({}, Re);
          Je.Period = he([], Je.Period, !0), Je.Period[Xe] = ce({}, Je.Period[Xe]);
          var Ge = Je.Period[Xe];
          Ge.AdaptationSet = he([], Ge.AdaptationSet, !0), Ge.AdaptationSet[Qe] = ce({}, Ge.AdaptationSet[Qe]);
          var Ye = Ge.AdaptationSet[Qe];
          return Ye.Representation = he([], Ye.Representation, !0), Ye.Representation[tt] = He, Je;
        }
        function $e(Re, Ne) {
          var xe = Ne.payload;
          return we(Re, xe.representationId, { associatedKid: xe.associatedKid });
        }
        function Se(Re, Ne) {
          var xe = Ne.payload;
          return we(Re, xe.representationId, { isLoading: xe.isLoading });
        }
        function Ce(Re, Ne) {
          var xe, ke = Ne.payload, Le = ke.representationId, He = ke.loadFailureReason, We = function(Xe) {
            var Qe;
            return Xe._internalId.equals(Le) ? He : (Qe = Xe._hls) === null || Qe === void 0 ? void 0 : Qe.loadFailureReason;
          };
          return ce(ce({}, Re), { Period: (xe = Re.Period) === null || xe === void 0 ? void 0 : xe.map(function(Xe) {
            var Qe;
            return ce(ce({}, Xe), { AdaptationSet: (Qe = Xe.AdaptationSet) === null || Qe === void 0 ? void 0 : Qe.map(function(tt) {
              var Je;
              return ce(ce({}, tt), { Representation: (Je = tt.Representation) === null || Je === void 0 ? void 0 : Je.map(function(Ge) {
                return ce(ce({}, Ge), { _hls: ce(ce({}, Ge._hls), { loadFailureReason: We(Ge) }) });
              }) });
            }) });
          }) });
        }
        function Ie(Re, Ne) {
          var xe = Ne.payload;
          return we(Re, xe.representationId, { segmentIndex: xe.segmentIndex });
        }
        function Te(Re, Ne) {
          var xe = Ne.payload;
          return we(Re, xe.representationId, { segmentIndexParsingError: xe.segmentIndexParsingError });
        }
        function Ee(Re, Ne) {
          var xe = Ne.payload;
          return we(Re, xe.representationId, { anchorPoint: xe.anchorPoint });
        }
        function we(Re, Ne, xe) {
          var ke;
          return ce(ce({}, Re), { Period: (ke = Re.Period) === null || ke === void 0 ? void 0 : ke.map(function(Le) {
            var He;
            return ce(ce({}, Le), { AdaptationSet: (He = Le.AdaptationSet) === null || He === void 0 ? void 0 : He.map(function(We) {
              var Xe;
              return ce(ce({}, We), { Representation: (Xe = We.Representation) === null || Xe === void 0 ? void 0 : Xe.map(function(Qe) {
                return Qe._internalId.equals(Ne) ? ce(ce({}, Qe), xe) : Qe;
              }) });
            }) });
          }) });
        }
        function Pe(Re, Ne) {
          var xe, ke = Ne.payload, Le = ke.representationId, He = ke.index, We = ke.playbackTimeForIndex, Xe = (0, le.findRepresentation)(Re, Le);
          return Xe ? we(Re, Le, ce(ce({}, Xe), { SegmentList: (xe = Xe.SegmentList) === null || xe === void 0 ? void 0 : xe.map(function(Qe) {
            return ce(ce({}, Qe), { SegmentURL: Ae(Qe.SegmentURL, He, We) });
          }) })) : Re;
        }
        function Me(Re, Ne) {
          var xe, ke = Ne.payload, Le = ke.representationId, He = ke.segmentUrl, We = ke.segmentPlaybackTime, Xe = ke.discontinuitySequenceNumber, Qe = (0, le.findRepresentation)(Re, Le);
          if (!(Qe != null && Qe.SegmentList) || Qe.SegmentList.length === 0 || ((xe = Qe.SegmentList[0].SegmentURL[0]) === null || xe === void 0 ? void 0 : xe._playbackTime) !== void 0)
            return Re;
          var tt = Qe.SegmentList[0].SegmentURL.findIndex(function(Je) {
            return Je._media === He && Je._discontinuitySequenceNumber === Xe;
          });
          return tt === -1 ? Re : we(Re, Le, ce(ce({}, Qe), { SegmentList: Qe.SegmentList.map(function(Je) {
            return ce(ce({}, Je), { SegmentURL: Ae(Je.SegmentURL, tt, We) });
          }) }));
        }
        function Ae(Re, Ne, xe) {
          var ke = he([], Re, !0);
          return ke[Ne] = ce({}, ke[Ne]), ke[Ne]._playbackTime = xe, Be(ke, Ne), Oe(ke, Ne), ke;
        }
        function Oe(Re, Ne) {
          for (var xe = Ne + 1; xe < Re.length; xe++)
            Re[xe] = ce({}, Re[xe]), Re[xe]._playbackTime = Re[xe - 1]._playbackTime + Re[xe - 1]._duration;
        }
        function Be(Re, Ne) {
          for (var xe = Ne - 1; xe >= 0; xe--)
            Re[xe] = ce({}, Re[xe]), Re[xe]._playbackTime = Re[xe + 1]._playbackTime - Re[xe]._duration;
        }
        function Ve(Re) {
          return ce(ce({}, Re), { SegmentURL: Re.SegmentURL.map(function(Ne) {
            var xe = ce({}, Ne);
            return delete xe._playbackTime, xe;
          }) });
        }
        function Ue(Re) {
          return ce(ce({}, Re), { Period: Re.Period.map(function(Ne) {
            return ce(ce({}, Ne), { AdaptationSet: Ne.AdaptationSet.map(function(xe) {
              return ce(ce({}, xe), { Representation: xe.Representation.map(function(ke) {
                var Le;
                return ce(ce({}, ke), { SegmentList: (Le = ke.SegmentList) === null || Le === void 0 ? void 0 : Le.map(Ve) });
              }) });
            }) });
          }) });
        }
        ne.ManifestReducer = (0, _e.default)({}, ((ae = {})[oe.ManifestActionType.SetManifest] = ue, ae[oe.ManifestActionType.SetManifestInitialized] = be, ae[oe.ManifestActionType.RemoveRepresentations] = ve, ae[oe.ManifestActionType.UpdateManifest] = function(Re, Ne) {
          return fe(Re, Ne.payload);
        }, ae[oe.ManifestActionType.UpdateAdaptationSet] = function(Re, Ne) {
          return ge(Re, Ne.payload);
        }, ae[oe.ManifestActionType.UpdateRepresentation] = function(Re, Ne) {
          return ye(Re, Ne.payload);
        }, ae[oe.ManifestActionType.UpdateRepresentationFailedDownload] = Ce, ae[oe.ManifestActionType.AdjustPeriodStartTimes] = me, ae[oe.ManifestActionType.UpdatePeriodTiming] = function(Re, Ne) {
          return pe(Re, Ne.payload);
        }, ae[oe.ManifestActionType.SetRepresentationDrmKid] = $e, ae[oe.ManifestActionType.SetRepresentationIsLoading] = Se, ae[oe.ManifestActionType.SetRepresentationSegmentIndex] = Ie, ae[oe.ManifestActionType.SetRepresentationSegmentIndexParsingError] = Te, ae[oe.ManifestActionType.SetRepresentationAnchorPoint] = Ee, ae[oe.ManifestActionType.InitPlaybackTimesFromIndex] = Pe, ae[oe.ManifestActionType.InitPlaybackTimesFromReferenceSegment] = Me, ae[oe.ManifestActionType.ResetSegmentPlaybackTimes] = Ue, ae));
      }, 28322: function(ee, ne, ie) {
        var ae, ce = this && this.__assign || function() {
          return ce = Object.assign || function(oe) {
            for (var ue, be = 1, ve = arguments.length; be < ve; be++)
              for (var me in ue = arguments[be])
                Object.prototype.hasOwnProperty.call(ue, me) && (oe[me] = ue[me]);
            return oe;
          }, ce.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.RendererReducer = void 0;
        var he = ie(21829), _e = ie(73448);
        function le() {
          return { mseObjectUrl: "" };
        }
        function se(oe, ue) {
          var be = ue.payload;
          return ce(ce({}, oe), { mseObjectUrl: be.url });
        }
        ne.RendererReducer = (0, he.default)(le(), ((ae = {})[_e.RendererActionType.SetMseObjectUrl] = se, ae));
      }, 28337: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.sourceIdentifiersSelector = ne.hasASourceStoreIdentifierChanged = void 0;
        var ie = function(ce, he) {
          return ce.length !== he.length || ce.some(function(_e) {
            return !he.includes(_e);
          });
        };
        ne.hasASourceStoreIdentifierChanged = ie;
        var ae = function(ce) {
          var he;
          return Object.keys((he = ce.sources) !== null && he !== void 0 ? he : {});
        };
        ne.sourceIdentifiersSelector = ae;
      }, 28499: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentPrefetcher = void 0;
        var ae = ie(27177), ce = ie(38255), he = ie(66864), _e = function() {
          function le(se) {
            var oe = this;
            this.processSegmentInfoQueue = function(ue) {
              var be = oe.segmentInfoQueue.get(ue);
              be && be.length !== 0 && oe.chainSegmentPrefetch(be.shift()).then(function() {
                return oe.processSegmentInfoQueue(ue);
              });
            }, this.segmentInfoQueue = new ce.ArrayMap(), this.prefetchPromiseChainMap = /* @__PURE__ */ new Map(), this.decrypterMap = /* @__PURE__ */ new Map(), this.segmentLoaderMap = /* @__PURE__ */ new Map(), this.segmentPrefetchHandler = se, this.shouldDownloadBeCancelledCallbackMap = /* @__PURE__ */ new Map();
          }
          return le.prototype.updateContext = function(se) {
            this.context = se;
          }, le.prototype.setShouldDownloadBeCancelledCallback = function(se, oe) {
            this.shouldDownloadBeCancelledCallbackMap.set(se, oe);
          }, le.prototype.removeShouldDownloadBeCancelledCallback = function(se) {
            this.shouldDownloadBeCancelledCallbackMap.delete(se);
          }, le.prototype.setDecrypter = function(se, oe) {
            this.decrypterMap.set(oe, se), this.segmentLoaderMap.has(oe) && this.segmentLoaderMap.get(oe).attachDecrypter(se);
          }, le.prototype.removeDecrypter = function(se) {
            this.decrypterMap.delete(se);
          }, le.prototype.getDecrypter = function(se) {
            return this.decrypterMap.get(se);
          }, le.prototype.prefetchSegment = function(se) {
            return this.chainSegmentPrefetch(se);
          }, le.prototype.prefetchSegments = function(se) {
            var oe = this;
            se.forEach(function(ue) {
              return oe.segmentInfoQueue.add(ue.mimeType, ue);
            }), this.segmentInfoQueue.keys.forEach(function(ue) {
              return oe.processSegmentInfoQueue(ue);
            });
          }, le.prototype.chainSegmentPrefetch = function(se) {
            var oe = this, ue = this.getPrefetchPromiseChain(se.mimeType).then(function() {
              return oe.fetchSegment(se);
            }).then(function() {
            }).catch(function() {
            });
            return this.prefetchPromiseChainMap.set(se.mimeType, ue), ue;
          }, le.prototype.fetchSegment = function(se) {
            var oe = this;
            if (!(0, ae.isContextAvailable)(this.context))
              return Promise.reject("PlayerContext not available");
            var ue = this.getLoader(se).load(se).then(function(be) {
              return be.read();
            }).then(function(be) {
              return be.value;
            });
            return this.segmentPrefetchHandler.onPrefetch({ segmentInfo: se, loadingPromise: ue }), ue.catch(function(be) {
              (0, ae.isContextAvailable)(oe.context) && oe.context.logger.debug("segment prefetching failed for", se, "with", be);
            }), ue;
          }, le.prototype.getPrefetchPromiseChain = function(se) {
            return this.prefetchPromiseChainMap.has(se) || this.prefetchPromiseChainMap.set(se, Promise.resolve()), this.prefetchPromiseChainMap.get(se);
          }, le.prototype.getLoader = function(se) {
            return this.segmentLoaderMap.has(se.mimeType) || this.segmentLoaderMap.set(se.mimeType, this.createLoader(se)), this.segmentLoaderMap.get(se.mimeType);
          }, le.prototype.createLoader = function(se) {
            this.prefetchPromiseChainMap.set(se.mimeType, Promise.resolve());
            var oe = new he.SegmentLoader(this.context, se.mimeType, this.createDownloadCancelCallbackFunction(se), !0);
            return oe.attachDecrypter(this.decrypterMap.get(se.mimeType)), oe;
          }, le.prototype.createDownloadCancelCallbackFunction = function(se) {
            var oe = this;
            return function(ue) {
              var be = se.mimeType, ve = oe.segmentLoaderMap.get(be), me = ve ? ve.getCurrentLoadingSegmentInfo() : null, pe = be !== void 0 ? oe.shouldDownloadBeCancelledCallbackMap.get(be) : void 0, fe = me ? me.internalRepresentationId : se.internalRepresentationId;
              return pe !== void 0 && pe(ue, fe);
            };
          }, le.prototype.clearPrefetchingQueue = function(se) {
            this.segmentInfoQueue.delete(se);
          }, le.prototype.reset = function() {
            this.segmentLoaderMap.forEach(function(se) {
              return se.dispose();
            }), this.shouldDownloadBeCancelledCallbackMap.clear(), this.segmentLoaderMap.clear(), this.decrypterMap.clear();
          }, le.prototype.dispose = function() {
            this.reset(), this.segmentLoaderMap = null, this.shouldDownloadBeCancelledCallbackMap = null;
          }, le;
        }();
        ne.SegmentPrefetcher = _e;
      }, 28915: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.isSegmentTiming = he, ne.findSegmentIndexForTime = _e, ne.createInitSegmentInfoBase = oe, ne.getSegmentInfoTimeRange = ue, ne.generateSegmentId = be;
        var ae = ie(45711), ce = ie(70016);
        function he(ve) {
          return "startTime" in ve && (0, ce.isNumber)(ve.startTime) && "duration" in ve && (0, ce.isNumber)(ve.duration);
        }
        function _e(ve, me, pe) {
          var fe = !ve || !ve.length, ge = me < ve[0].startTime + ve[0].duration;
          if (fe || ge)
            return 0;
          var ye = ve.length - 1;
          if (me >= ve[ye].startTime)
            return ye;
          var $e = Math.max(me - ve[0].startTime, 0), Se = Math.min(Math.floor($e / pe), ve.length - 1);
          return le(ve[0]) && le(ve[Se]) ? se(ve, me, Se) : null;
        }
        function le(ve) {
          return ve && (0, ce.isNumber)(ve.startTime);
        }
        function se(ve, me, pe) {
          for (; ve[pe] && ve[pe].startTime > me; )
            pe--;
          for (; ve[pe] && ve[pe].startTime + ve[pe].duration <= me; )
            pe++;
          return pe = Math.max(pe, 0), pe = Math.min(pe, ve.length - 1);
        }
        function oe(ve) {
          var me = ve._internalId;
          return { internalRepresentationId: me, representationId: me.representationId, periodId: me.periodId, mimeType: ve._mimeType, isInitSegment: !0 };
        }
        function ue(ve) {
          if (ve != null && ve.duration && (ve == null ? void 0 : ve.startTime) !== void 0)
            return { start: ve.startTime, end: ve.startTime + ve.duration };
        }
        function be(ve) {
          var me, pe, fe = (pe = (me = ve.discontinuitySequenceNumber) === null || me === void 0 ? void 0 : me.toString()) !== null && pe !== void 0 ? pe : ve.periodId, ge = ve.byteRange ? "-".concat(ve.byteRange.start, ":").concat(ve.byteRange.end) : "";
          return (0, ae.calcHash)("".concat(fe, ":").concat(ve.url).concat(ge));
        }
      }, 29954: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.DrmKidErrorHandler = void 0;
        var ae = ie(18665), ce = ie(76650), he = ie(28819), _e = ie(8272), le = ie(3464), se = ie(68294), oe = function() {
          function fe(ge, ye) {
            var $e = this;
            this.context = ge, this.onDownloadedRepresentationExcludedCallback = ye, this.onDrmKidsWithErrorsChanged = function(Ce, Ie) {
              if (Ce !== void 0 && Ie !== void 0) {
                var Te = Ce.filter(function(Ee) {
                  return !Ie.includes(Ee);
                });
                $e.maybeExcludeRepresentations(Te);
              }
            };
            var Se = ge.sourceContext.sourceIdentifier;
            this.store = ge.store, this.logger = ge.logger, this.sourceStore = ge.serviceManager.get(ae.ServiceName.SourceStoreService, Se), this.manifestService = ge.serviceManager.get(ae.ServiceName.ManifestService, Se), this.unsubscribeFromStore = (0, le.subscribe)(this.sourceStore)(se.getDrmKeyIdsWithErrors, this.onDrmKidsWithErrorsChanged);
          }
          return fe.prototype.maybeExcludeRepresentations = function(ge) {
            var ye = ve(this.manifestService, ge), $e = this.store.getState();
            if (ye.length !== 0 && $e !== void 0) {
              var Se = be(ue($e), ye);
              this.logger.debug("Excluding representations due to DRM licenses not being available", ye), this.manifestService.excludeRepresentations(ye) && Se && (this.store.dispatch((0, ce.clearMetricsHistory)("default", _e.MetricType.RequestedRepresentations)), this.onDownloadedRepresentationExcludedCallback());
            }
          }, fe.prototype.trackSegment = function(ge) {
            var ye = ge.getDrmKid();
            if (ye !== void 0) {
              var $e = this.sourceStore.getState(), Se = ge.getRepresentationId(), Ce = $e ? (0, se.getDrmKeyIdsWithErrors)($e) : [];
              pe(ye, Se, this.manifestService) && (me(ye, Se, this.manifestService), this.maybeExcludeRepresentations(Ce));
            }
          }, fe.prototype.dispose = function() {
            this.unsubscribeFromStore();
          }, fe;
        }();
        function ue(fe) {
          return (0, he.getMetricsHistoryFromInstanceState)(fe, "default", _e.MetricType.RequestedRepresentations).map(function(ge) {
            return ge.value;
          });
        }
        function be(fe, ge) {
          return ge.some(function(ye) {
            return fe.some(function($e) {
              return $e.equals(ye);
            });
          });
        }
        function ve(fe, ge) {
          return fe.getAllRepresentations().filter(function(ye) {
            return ye.associatedKid && ge.includes(ye.associatedKid);
          }).map(function(ye) {
            return ye._internalId;
          });
        }
        function me(fe, ge, ye) {
          ye.setRepresentationDrmKid(ge, fe);
        }
        function pe(fe, ge, ye) {
          return fe !== ye.getRepresentationDrmKid(ge);
        }
        ne.DrmKidErrorHandler = oe;
      }, 30855: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentUnavailabilityHandler = void 0;
        var ae = ie(76885), ce = function() {
          function he(_e) {
            this.triedRepsForCurrentSegment = {}, this.wasQualitySwitched = !1, this.context = _e;
          }
          return he.prototype.downloadSuccess = function(_e) {
            this.wasQualitySwitched && _e ? this.wasQualitySwitched = !1 : this.triedRepsForCurrentSegment = {};
          }, he.prototype.getNextLowerNotTriedQuality = function(_e, le) {
            for (var se = [], oe = 0; oe < _e.length && !_e[oe]._internalId.equals(le); oe++)
              this.triedRepsForCurrentSegment[_e[oe]._id] || se.push(_e[oe]);
            return se.length > 0 ? se[se.length - 1]._internalId : null;
          }, he.prototype.switchQuality = function(_e, le) {
            this.triedRepsForCurrentSegment[le.representationId] = !0;
            var se = this.getNextLowerNotTriedQuality(_e, le);
            return se ? (this.wasQualitySwitched = !0, se) : (this.context.logger.log("no quality left, all tried"), null);
          }, he.prototype.switchBaseURL = function(_e) {
            var le = _e.availableBaseURLs, se = _e.lastUsedBaseURLIndex + 1;
            return (se %= le.length) === _e.firstUsedBaseURLIndex ? (this.context.logger.log("no base url left, all tried"), null) : (_e.lastUsedBaseURLIndex = se, _e.baseURL = le[se], _e.url = ae.URLHelper.concatBaseUrlWithPartial(_e.baseURL, _e.mediaURL), _e);
          }, he.prototype.shouldTryAlternatives = function(_e) {
            return _e >= 400 && _e <= 599 || _e === 0;
          }, he;
        }();
        ne.SegmentUnavailabilityHandler = ce;
      }, 34268: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.PeriodSwitchTracker = void 0;
        var ae = ie(18665), ce = ie(62510), he = ie(3464), _e = ie(331), le = ie(72788), se = ie(58211), oe = function() {
          function ue(be) {
            var ve = this;
            this.finishPeriodSwitch = function(me, pe) {
              var fe = pe.switchingToPeriodId, ge = ve.getCurrentPlayingPeriodId();
              ve.setCurrentPlayingPeriodId(fe);
              var ye = ve.getCurrentPlayingPeriod();
              ye && ye.AdaptationSet.forEach(function($e) {
                return ve.context.renderer.storeDrmInitDataFromManifest($e);
              }), ve.logger.debug("Successfully switched from Period ".concat(ge, " to Period ").concat(fe)), ve.context.eventHandler.dispatchEvent(ce.PlayerEvent.PeriodSwitched, { sourcePeriod: { periodId: ge }, targetPeriod: { periodId: fe } });
            }, this.context = be, this.logger = be.logger, this.eventHandler = be.eventHandler, this.subscribeToPlayingTracksChanges();
          }
          return ue.prototype.getManifestService = function() {
            return this.context.serviceManager.get(ae.ServiceName.ManifestService, this.context.sourceContext.sourceIdentifier);
          }, ue.prototype.getCurrentPlayingPeriod = function() {
            return this.getManifestService().findPeriod(this.getCurrentPlayingPeriodId());
          }, ue.prototype.subscribeToPlayingTracksChanges = function() {
            var be = this.getSourceStore();
            !this.unsubscribeFromPlayingTracksStore && be && (this.unsubscribeFromPlayingTracksStore = (0, he.subscribe)(be)(se.getPlayingTracksState, this.finishPeriodSwitch, se.wasSwitchingToPeriodIdReset));
          }, ue.prototype.unsubscribeFromPlayingTracksChanges = function() {
            this.unsubscribeFromPlayingTracksStore && (this.unsubscribeFromPlayingTracksStore(), this.unsubscribeFromPlayingTracksStore = void 0);
          }, ue.prototype.getSourceStore = function() {
            return this.context.serviceManager.get(ae.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, ue.prototype.getCurrentLoadingPeriodId = function() {
            return this.currentLoadingPeriodId;
          }, ue.prototype.setCurrentLoadingPeriodId = function(be) {
            this.currentLoadingPeriodId = be;
          }, ue.prototype.getCurrentPlayingPeriodId = function() {
            return (0, se.getPlayingPeriodId)(this.getSourceStore().getState());
          }, ue.prototype.setCurrentPlayingPeriodId = function(be) {
            this.getSourceStore().dispatch((0, le.setPlayingPeriodId)(be));
          }, ue.prototype.resetPeriodIds = function() {
            this.setCurrentPlayingPeriodId(void 0), this.setCurrentLoadingPeriodId(void 0);
          }, ue.prototype.shouldHandleDroppedOutPeriod = function() {
            return !(this.getCurrentPlayingPeriodId() == null && this.currentLoadingPeriodId == null);
          }, ue.prototype.isPeriodDroppedOut = function(be) {
            return !this.getManifestService().getAllPeriods().map(function(ve) {
              return ve._id;
            }).includes(be);
          }, ue.prototype.isPlayingPeriodDroppedOut = function() {
            return this.isPeriodDroppedOut(this.getCurrentPlayingPeriodId());
          }, ue.prototype.isLoadingPeriodDroppedOut = function() {
            return this.isPeriodDroppedOut(this.currentLoadingPeriodId);
          }, ue.prototype.isLoadingLastPeriod = function() {
            return this.getManifestService().isLastPeriod(this.currentLoadingPeriodId);
          }, ue.prototype.setInitialPeriod = function() {
            var be = this.getManifestService().isLive() ? this.getInitialPeriodForLive() : this.getInitialPeriodForVod();
            this.currentLoadingPeriodId = be, this.setCurrentPlayingPeriodId(this.currentLoadingPeriodId), this.logger.debug("setting initial period to ".concat(this.currentLoadingPeriodId));
          }, ue.prototype.getInitialPeriodForLive = function() {
            var be = (0, _e.toSeconds)(Date.now()) - this.getManifestService().getDesiredDistanceToLiveEdge();
            return this.getManifestService().getPeriodIdForTime(be);
          }, ue.prototype.getInitialPeriodForVod = function() {
            var be = this.context.serviceManager.get(ae.ServiceName.StartOffsetService).getStartOffset(this.context.sourceContext.source);
            return this.getManifestService().getPeriodIdForTime(be);
          }, ue.prototype.dispose = function() {
            this.unsubscribeFromPlayingTracksChanges();
          }, ue;
        }();
        ne.PeriodSwitchTracker = oe;
      }, 35655: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var oe = function(ue, be) {
            return oe = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ve, me) {
              ve.__proto__ = me;
            } || function(ve, me) {
              for (var pe in me)
                Object.prototype.hasOwnProperty.call(me, pe) && (ve[pe] = me[pe]);
            }, oe(ue, be);
          };
          return function(ue, be) {
            if (typeof be != "function" && be !== null)
              throw new TypeError("Class extends value " + String(be) + " is not a constructor or null");
            function ve() {
              this.constructor = ue;
            }
            oe(ue, be), ue.prototype = be === null ? Object.create(be) : (ve.prototype = be.prototype, new ve());
          };
        }();
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.RepresentationUpdater = void 0;
        var ce = ie(91520), he = ie(16368), _e = ie(93109), le = ie(99162), se = function(oe) {
          function ue(be, ve, me, pe) {
            var fe = oe.call(this, pe) || this;
            return fe.context = be, fe.representation = ve, fe.manifestLoader = me, fe;
          }
          return ae(ue, oe), ue.prototype.getRepresentation = function() {
            return this.representation;
          }, ue.prototype.setRepresentation = function(be) {
            this.representation._internalId.equals(be._internalId) || this.cancel(), this.representation = be, this.scheduleUpdate();
          }, ue.prototype.updateRepresentation = function() {
            return this.getPayload();
          }, ue.prototype.stopRepresentationUpdate = function(be) {
            return oe.prototype.stop.call(this), this.manifestLoader.stopRepresentationUpdate(be);
          }, ue.prototype.update = function() {
            var be = this;
            return this.manifestLoader.updateRepresentation(this.representation).then(function(ve) {
              if (be.representation._id !== ve._id)
                throw le.REPRESENTATION_UPDATE_CANCEL;
              return be.representation = ve, ve;
            });
          }, ue.prototype.getReloadIntervalInSeconds = function() {
            var be, ve;
            return this.representation._requestTimestamp ? (0, _e.isPlayingLowLatencyHls)(this.context) && (!((be = ce.ModuleManager.get(he.ModuleName.HLS)) === null || be === void 0) && be.canMakeBlockingPlaylistReload(this.representation, this.context.settings)) ? 0 : (ve = this.representation._updateInterval) !== null && ve !== void 0 ? ve : 1 / 0 : 0;
          }, ue.prototype.getLastReloadTimestamp = function() {
            return this.representation._requestTimestamp ? this.representation._requestTimestamp : 0;
          }, ue;
        }(le.AbstractUpdater);
        ne.RepresentationUpdater = se;
      }, 36225: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.addEncryptionKeyToStore = ue, ne.waitForKeyToBeLoaded = be;
        var ae = ie(3464), ce = ie(56093), he = ie(55486), _e = ie(25040), le = ie(56092), se = 20;
        function oe(ve) {
          var me = (0, _e.getAllEncryptionKeys)(ve.getState());
          me && me.length > se && ve.dispatch((0, he.removeEncryptionKey)(me[0].uri));
        }
        function ue(ve, me, pe) {
          return pe.dispatch((0, he.addEncryptionKey)({ uri: ve, key: void 0, loadState: le.KeyLoadState.Loading })), me.load(ve).then(function(fe) {
            return pe == null || pe.dispatch((0, he.updateEncryptionKey)({ uri: ve, key: ce.FormatHelper.bytesToHex(fe), loadState: le.KeyLoadState.Loaded })), oe(pe), fe;
          }).catch(function(fe) {
            return pe == null || pe.dispatch((0, he.updateEncryptionKey)({ uri: ve, key: void 0, loadState: le.KeyLoadState.Cancel })), Promise.reject(fe);
          });
        }
        function be(ve, me) {
          return new Promise(function(pe, fe) {
            var ge = function($e) {
              return $e.loadState === le.KeyLoadState.Cancel ? (ye(), fe(new Error("Encryption key load cancelled!"))) : $e.loadState === le.KeyLoadState.Loaded && $e.key ? (ye(), pe(ce.FormatHelper.hexToBytes($e.key).buffer)) : void 0;
            }, ye = (0, ae.subscribe)(ve)(function($e) {
              return (0, _e.getEncryptionKey)($e, me);
            }, ge);
          });
        }
      }, 36366: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MediaPlayerController = void 0, ne.isBufferChangeRequired = Xe;
        var ae = ie(18665), ce = ie(60997), he = ie(62510), _e = ie(15539), le = ie(33696), se = ie(76650), oe = ie(17990), ue = ie(58975), be = ie(63668), ve = ie(42055), me = ie(3464), pe = ie(42283), fe = ie(53968), ge = ie(79814), ye = ie(46462), $e = ie(91520), Se = ie(16368), Ce = ie(80858), Ie = ie(29954), Te = ie(13034), Ee = ie(94938), we = ie(96953), Pe = ie(22916), Me = ie(58423), Ae = ie(34268), Oe = ie(25996), Be = ie(4053), Ve = ie(77874), Ue = ie(58211), Re = ie(59839), Ne = ie(22645), xe = ie(21918), ke = ie(75498), Le = ie(93109), He = function() {
          function Je(Ge, Ye) {
            var ze = this;
            this.segmentControllerMap = {}, this.onSegmentAvailable = function(Fe) {
              if (ze.bufferController.isBufferClearingOngoing())
                Qe(Fe, ze.getSourceStore());
              else {
                if (ze.drmKidErrorHandler.trackSegment(Fe), ze.shouldDropSegment(Fe))
                  return ze.context.logger.debug("Dropping segment ".concat(Fe.getUrl())), void Qe(Fe, ze.getSourceStore());
                var ot = Fe.getMimeType(), vt = ze.getTimestampOffset(ot), gt = ze.segmentControllerMap[ot];
                gt && ze.isAVMultiplexed(gt) && ze.addRequiredMediaTypesForMuxedContent(Fe.getPeriodId()), ze.bufferController.updateMediaType(Fe.getPeriodId(), { mimeType: ot, timestampOffset: vt, codec: Fe.getCodec() }), ze.bufferController.addSegment(Fe).then(function() {
                  var yt;
                  (yt = ze.heartbeatService) === null || yt === void 0 || yt.beat();
                }).catch(function(yt) {
                  ze.logger && ze.logger.debug(yt);
                }), ze.segmentAvailableCallback(Fe);
              }
            }, this.endStallAtGap = function() {
              var Fe = ze.bufferController.getBufferedRangesMap(ze.periodSwitchTracker.getCurrentPlayingPeriodId()), ot = Math.max.apply(Math, Object.values(Fe).filter(function(vt) {
                return vt.length > 0;
              }).map(function(vt) {
                return vt[vt.length - 1].start;
              }));
              ze.seek(ot, !1, !0);
            }, this.mpdAvailableHandler = function() {
              var Fe;
              ze.applyManifestTimings(), ze.initialized && ze.updatePeriodInformation(), ze.handleDroppedOutPeriods(), ze.initializeThumbnails(), ze.initialized && (ze.getAllSegmentControllers().forEach(function(ot) {
                return ot.updateMpd();
              }), (Fe = ze.timeshiftHandler) === null || Fe === void 0 || Fe.onManifestUpdate()), ze.context.serviceManager.get(ae.ServiceName.TimedMetadataService).parseEventStream();
            }, this.onPeriodSwitched = function() {
              (ze.hasStreamEnded() || ze.isInitialized() && !ze.playerStateService.isPlaying()) && ze.start();
            }, this.onSegmentRequestFinished = function(Fe) {
              var ot, vt = 408;
              if (Fe) {
                if (Fe.success || Fe.httpStatus === vt) {
                  var gt = ze.segmentControllerMap[Fe.mimeType];
                  gt && ze.updateAdaptationLogicData(Fe, gt);
                }
                Fe.success || (ot = ze.heartbeatService) === null || ot === void 0 || ot.beat();
              }
            }, this.firePlaybackFinishedEvent = function() {
              ze.getAllSegmentControllers().every(function(Fe) {
                var ot = ze.streamTimeService.getTimeForNextSegment(Fe.getMimeType());
                return Fe.hasNext(ot);
              }) ? ze.logger.debug("ignoring ended event in firePlaybackFinishedEvent as there are more segments available") : ze.manifestService.isLastPeriod(ze.periodSwitchTracker.getCurrentPlayingPeriodId()) ? ze.bufferController.hasFutureBufferBlockData() || (ze.stop(), ze.logger.debug("Stopping buffer controller"), ze.bufferController.stop(!0), ze.playerStateService.transitionToStoppedState()) : ze.logger.debug("ignoring ended event in firePlaybackFinishedEvent as there is a future period");
            }, this.context = Ge, this.logger = Ge.logger, this.settings = Ge.settings, this.bufferSettings = Ge.bufferSettings, this.eventHandler = Ge.eventHandler, this.renderer = Ge.renderer, this.segmentAvailableCallback = Ye, this.initialized = !1, this.initPromise = null, this.mimeTypes = {}, this.seekCounter = 0, this.eosSignaled = !1, this.isSwitchingAudioTrack = !1, this.configEnhancer = new Oe.PlayerConfigEnhancer(Ge);
          }
          return Je.prototype.addRequiredMediaTypesForMuxedContent = function(Ge) {
            this.bufferController.addRequiredMediaType(Ge, "video/mp4"), this.bufferController.addRequiredMediaType(Ge, "audio/mp4");
          }, Je.prototype.getTimestampOffset = function(Ge) {
            var Ye, ze = this, Fe = this.segmentControllerMap[Ge];
            return !Fe && ge.MimeTypeHelper.isAV(Ge) && (Fe = Object.keys(this.segmentControllerMap).filter(function(ot) {
              return ge.MimeTypeHelper.isAV(ot);
            }).map(function(ot) {
              return ze.segmentControllerMap[ot];
            }).filter(function(ot) {
              return ze.isAVMultiplexed(ot);
            }).shift()), (Ye = Fe == null ? void 0 : Fe.getMPDHandler().getTimestampOffset()) !== null && Ye !== void 0 ? Ye : 0;
          }, Je.prototype.restorePlaybackPositionAfterDownloadedRepresentationWasExcluded = function() {
            var Ge = this, Ye = this.manifestService.isLive(), ze = Ye ? this.getTimeShift() : this.renderer.getCurrentTime();
            Ye ? this.timeShift(ze, function() {
            }, !0).catch(function(Fe) {
              return Ge.context.logger.debug("TimeShift failed", Fe);
            }) : this.seek(ze, !1, !1, !0);
          }, Je.prototype.onDownloadedRepresentationExcluded = function() {
            this.restorePlaybackPositionAfterDownloadedRepresentationWasExcluded(), this.context.logger.debug("manifest update interrupted by DRM key status change");
          }, Je.prototype.shouldDropSegment = function(Ge) {
            var Ye = ge.MimeTypeHelper.isSubtitle(Ge.getMimeType()), ze = this.context.sourceContext.technology.streaming === le.StreamType.Hls, Fe = (0, ve.getStartTimeOffset)(this.getSourceStore().getState()) + this.manifestService.getDuration(), ot = this.isVod() && Ge.getPlaybackTime() >= Fe, vt = this.eosSignaled || ot, gt = this.manifestService.isRepresentationExcluded(Ge.getRepresentationId());
            return !Ye && !ze && vt || gt;
          }, Je.prototype.getSourceStore = function() {
            return this.context.serviceManager.get(ae.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, Je.prototype.isAVMultiplexed = function(Ge) {
            var Ye = pe.CodecStringHelper.getExtractedCodecStrings(Ge.getCodecs());
            return !!(Ye.video && Ye.audio);
          }, Je.prototype.getMaxTimeShift = function() {
            return this.getTimeShiftHandler().getMaxTimeShift();
          }, Je.prototype.removeEventHandlers = function() {
            this.eventHandler.off(he.PlayerEvent.SegmentRequestFinished, this.onSegmentRequestFinished);
          }, Je.prototype.subscribeToSeekProcess = function() {
            var Ge = this, Ye = this.context.store;
            !this.unsubscribeFromSeekProcess && Ye && (this.unsubscribeFromSeekProcess = (0, me.subscribe)(Ye)(function(ze) {
              if (ze)
                return (0, ue.getPlayerState)(ze).seekingProcess;
            }, function(ze, Fe) {
              return ze && Fe && Ge.onSeekProcessChange(ze, Fe);
            }));
          }, Je.prototype.subscribeToManifestChanges = function() {
            var Ge = this.getSourceStore();
            !this.unsubscribeFromManifestStore && Ge && (this.unsubscribeFromManifestStore = (0, me.subscribe)(Ge)(Ve.getManifest, this.mpdAvailableHandler, function(Ye, ze) {
              return Ye.isInitialized && !ze.isInitialized;
            }));
          }, Je.prototype.unsubscribeFromManifestChanges = function() {
            this.unsubscribeFromManifestStore && (this.unsubscribeFromManifestStore(), this.unsubscribeFromManifestStore = null);
          }, Je.prototype.subscribeToPlayingTracksChanges = function() {
            var Ge = this.getSourceStore();
            !this.unsubscribeFromPlayingTracksStore && Ge && (this.unsubscribeFromPlayingTracksStore = (0, me.subscribe)(Ge)(Ue.getPlayingTracksState, this.onPeriodSwitched, Ue.wasSwitchingToPeriodIdReset));
          }, Je.prototype.unsubscribeFromPlayingTracksChanges = function() {
            this.unsubscribeFromPlayingTracksStore && (this.unsubscribeFromPlayingTracksStore(), this.unsubscribeFromPlayingTracksStore = void 0);
          }, Je.prototype.setupControllerForAdaptationSet = function(Ge) {
            var Ye, ze, Fe = (0, Ee.getMimeTypeForAdaptationSet)(Ge);
            if (ge.MimeTypeHelper.isAV(Fe)) {
              this.context.store.dispatch((0, se.initializeMetricsForMimeType)(Fe, this.context.settings)), this.getSourceStore().dispatch((0, Be.setMediaTypeAction)(Ge._internalId, (0, Pe.resolveMediaTypes)(Ge))), this.mimeTypes[Fe] = (0, Ee.getCodecsFromAdaptationSet)(Ge);
              var ot = this.periodSwitchTracker.getCurrentPlayingPeriodId();
              this.segmentControllerMap[Fe] = new Me.SegmentController(this.context, this.onSegmentAvailable, Fe, this.mimeTypes[Fe], Ge.isTransmuxingRequired, this.manifestLoader, (Ye = Ge._periodId) !== null && Ye !== void 0 ? Ye : ot, this.getSourceStore()), (ze = this.timeshiftHandler) === null || ze === void 0 || ze.updateSegmentControllers(this.segmentControllerMap), this.transmuxer && this.segmentControllerMap[Fe].setTransmuxer(this.transmuxer), ot && this.renderer.storeDrmInitDataFromManifest(Ge), this.context.segmentInfoService && this.context.segmentInfoService.setSegmentControllers(Object.values(this.segmentControllerMap));
            }
          }, Je.prototype.updatePeriodForTimeshift = function(Ge, Ye, ze) {
            var Fe = this.periodSwitchTracker.getCurrentPlayingPeriodId();
            Fe || (this.periodSwitchTracker.setCurrentPlayingPeriodId(Ge), this.bufferController.setInitialPeriod(Ge)), this.periodSwitchTracker.getCurrentLoadingPeriodId() !== Ge && ze && this.switchLoadingPeriodForAllMedia(Ge), Ye && Fe !== Ge && (this.context.logger.debug("Updating current playing period to ".concat(Ge)), this.periodSwitchTracker.setCurrentPlayingPeriodId(Ge));
          }, Je.prototype.updateVideoAndAudioMediaTypes = function(Ge) {
            var Ye = Ge.AdaptationSet.find(function(Fe) {
              return ge.MimeTypeHelper.isVideo(Fe._mimeType);
            });
            Ye && this.bufferController.addRequiredMediaType(Ge._id, Ye._mimeType);
            var ze = Ge.AdaptationSet.find(function(Fe) {
              return ge.MimeTypeHelper.isAudio(Fe._mimeType);
            });
            ze && this.bufferController.addRequiredMediaType(Ge._id, ze._mimeType);
          }, Je.prototype.updateSubtitleMediaTypes = function(Ge) {
            var Ye = this;
            Ge.AdaptationSet.filter(function(ze) {
              return ge.MimeTypeHelper.isSubtitle(ze._mimeType);
            }).forEach(function(ze) {
              Ye.bufferController.addRequiredMediaType(Ge._id, ze._mimeType);
            });
          }, Je.prototype.updateMediaTypes = function(Ge) {
            this.updateVideoAndAudioMediaTypes(Ge), this.updateSubtitleMediaTypes(Ge);
          }, Je.prototype.updatePeriodInformation = function() {
            var Ge = this;
            this.manifestService.getAllPeriods().forEach(function(Ye) {
              Ge.updateMediaTypes(Ye), Ge.bufferController.checkIfEndOfBufferReached(Ge.settings.END_OF_BUFFER_TOLERANCE);
            });
          }, Je.prototype.finishInit = function() {
            var Ge = this;
            return this.initPromise ? this.initPromise : this.initialized === !0 || this.manifestService.getManifest() === null ? this.initPromise = Promise.resolve() : (this.disposeSegmentControllers(), this.mimeTypes = {}, this.initPromise = this.renderer.ready().then(function() {
              return Ge.initializeDependents();
            }));
          }, Je.prototype.disposeSegmentControllers = function() {
            var Ge = this;
            this.segmentControllerMap && (Object.keys(this.segmentControllerMap).forEach(function(Ye) {
              return Ge.segmentControllerMap[Ye].dispose();
            }), this.segmentControllerMap = {});
          }, Je.prototype.createTransmuxer = function() {
            var Ge = this;
            if ($e.ModuleManager.has(Se.ModuleName.ContainerTS)) {
              var Ye = $e.ModuleManager.get(Se.ModuleName.ContainerTS);
              this.getAllSegmentControllers().filter(function(ze) {
                return ze.isTransmuxerRequired();
              }).forEach(function(ze) {
                Ge.transmuxer = Ge.transmuxer || new Ye.WebWorkerTransmuxer(Ge.context, Ge.hasSeparateAvPlaylists()), ze.setTransmuxer(Ge.transmuxer);
              }), this.subtitleService && this.subtitleService.setTransmuxer(this.transmuxer);
            }
          }, Je.prototype.hasSeparateAvPlaylists = function() {
            return this.getAllSegmentControllers().filter(function(Ge) {
              return ge.MimeTypeHelper.isAV(Ge.getMimeType());
            }).length > 1;
          }, Je.prototype.initializeDependents = function() {
            this.periodSwitchTracker.setInitialPeriod(), this.initializeBufferController(), this.updatePeriodInformation();
            var Ge = this.periodSwitchTracker.getCurrentPlayingPeriod() || this.manifestService.getFirstPeriod();
            Ge && this.initializeSegmentControllers(Ge), this.enableForcedSubtitles(), this.createTransmuxer(), this.initialized = !0;
          }, Je.prototype.enableForcedSubtitles = function() {
            var Ge, Ye, ze, Fe, ot = this.getAudioSegmentController();
            if (this.subtitleService) {
              var vt = (ze = (Ye = (Ge = ot == null ? void 0 : ot.getCurrentLangObj) === null || Ge === void 0 ? void 0 : Ge.call(ot)) === null || Ye === void 0 ? void 0 : Ye.lang) !== null && ze !== void 0 ? ze : (Fe = (0, Te.getPreferredLanguage)("audio/mp4")) === null || Fe === void 0 ? void 0 : Fe.language;
              this.subtitleService.enableForcedSubtitle(vt);
            }
          }, Je.prototype.initializeSegmentControllers = function(Ge) {
            var Ye, ze = this;
            this.maybeConsiderOnlyMuxedAVSet((Ye = Ge == null ? void 0 : Ge.AdaptationSet) !== null && Ye !== void 0 ? Ye : []).forEach(function(Fe) {
              return ze.createSegmentControllerIfMediaTypeIsMissing(Fe);
            });
          }, Je.prototype.maybeConsiderOnlyMuxedAVSet = function(Ge) {
            var Ye, ze, Fe, ot = Ge.find(function(bt) {
              return ge.MimeTypeHelper.isAudio(bt._mimeType);
            }), vt = Ge.find(function(bt) {
              return ge.MimeTypeHelper.isVideo(bt._mimeType);
            }), gt = ((ze = (Ye = vt == null ? void 0 : vt.ContentComponent) === null || Ye === void 0 ? void 0 : Ye.length) !== null && ze !== void 0 ? ze : 0) > 1;
            if (!ot || !vt || !gt)
              return Ge;
            var yt = (0, Te.getHlsDefaultLanguage)(ot._mimeType, this.getSourceStore().getState()), pt = (Fe = vt.ContentComponent) === null || Fe === void 0 ? void 0 : Fe.find(function(bt) {
              return bt._lang === (yt == null ? void 0 : yt.language) && bt._id === (yt == null ? void 0 : yt.name);
            });
            return yt && pt ? [vt] : Ge;
          }, Je.prototype.createSegmentControllerIfMediaTypeIsMissing = function(Ge) {
            var Ye = (0, Ee.getMimeTypeForAdaptationSet)(Ge);
            (0, ge.isMediaTypeContained)(this.mimeTypes, Ye) || this.setupControllerForAdaptationSet(Ge);
          }, Je.prototype.initializeBufferController = function() {
            this.bufferController = new Ce.BufferController(this.context, this.endStallAtGap, this.manifestService.getTotalDuration(), this.periodSwitchTracker.getCurrentPlayingPeriodId());
          }, Je.prototype.getBufferLevel = function(Ge, Ye, ze, Fe) {
            return Fe === void 0 && (Fe = !0), this.bufferController ? this.bufferController.getOverallBufferLevel(Ge, Ye, ze, Fe) : 0;
          }, Je.prototype.handleDroppedOutPeriods = function() {
            var Ge = this;
            this.periodSwitchTracker.shouldHandleDroppedOutPeriod() && (this.periodSwitchTracker.isPlayingPeriodDroppedOut() ? (this.logger.debug("Playing period dropped out of the manifest, timeshifting to current position"), this.timeShift(this.getTimeShift()).catch(function(Ye) {
              return Ge.context.logger.debug("TimeShift failed", Ye);
            })) : this.periodSwitchTracker.isLoadingPeriodDroppedOut() && (this.logger.debug("Current loading period (".concat(this.periodSwitchTracker.getCurrentLoadingPeriodId(), ") ") + "dropped out of the manifest, switching to first available one"), this.getAllSegmentControllers().forEach(function(Ye) {
              return Ye.invalidateOngoingRequests();
            }), this.switchLoadingPeriodForAllMedia(this.manifestService.getFirstPeriod()._id)));
          }, Je.prototype.initializeThumbnails = function() {
            var Ge = this;
            this.context.serviceManager.maybeCall(ae.ServiceName.ThumbnailService, function(Ye) {
              Ge.context.sourceContext.source && Ge.context.sourceContext.source.thumbnailTrack || Ye.addThumbnails(Ge.manifestService.getAllDashThumbnailSources());
            });
          }, Je.prototype.applyManifestTimings = function() {
            var Ge = this.manifestService.isLive(), Ye = this.context.serviceManager.get(ae.ServiceName.StartOffsetService), ze = this.manifestService.hasSuggestedStartPosition();
            if (Ge) {
              var Fe = this.manifestService.getTimeShiftBufferDepthSeconds();
              Fe !== 0 && (this.metadataParsedService.expirationTimeInSeconds = Fe), ze && (Ye.manifestStartOffset = this.manifestService.getLiveStartOffset(), this.maybeAdjustDesiredLiveEdgeDistance());
            } else
              ze && (Ye.manifestStartOffset = this.manifestService.getVodStartOffset());
          }, Je.prototype.maybeAdjustDesiredLiveEdgeDistance = function() {
            if (!this.isInitialized()) {
              var Ge = Math.abs(this.manifestService.getLiveStartOffset(!1));
              Ge = Ge > 0 ? Ge : this.manifestService.getMaxSegmentDuration(), this.context.bufferSettings.setDistanceToLiveEdge(Ge);
            }
          }, Je.prototype.terminate = function() {
            var Ge, Ye, ze = this;
            this.logger.debug("stopping playback"), this.stop(), this.getAllSegmentControllers().forEach(function(ot) {
              return ot.stop();
            }), this.bufferController && this.bufferController.stop(!0), this.transmuxer = (0, ce.dispose)(this.transmuxer), this.timeshiftHandler = (0, ce.dispose)(this.timeshiftHandler), this.drmKidErrorHandler = (0, ce.dispose)(this.drmKidErrorHandler), (0, ce.dispose)(this.periodSwitchTracker), this.cachedSeekableRange = null, this.renderer.off(ye.MediaElementEvent.ended, this.firePlaybackFinishedEvent);
            var Fe = this.renderer.shutdown(!1).catch(function(ot) {
              return ze.logger.debug("Got an error on shutdown", { message: ot.message }), Promise.resolve();
            });
            return this.removeEventHandlers(), this.unsubscribeFromPlayingTracksChanges(), this.initialized = !1, (Ge = this.periodSwitchTracker) === null || Ge === void 0 || Ge.setCurrentPlayingPeriodId(void 0), this.mimeTypes = null, this.context.store.dispatch((0, be.resetDrmKidErrors)()), (Ye = this.manifestService) === null || Ye === void 0 || Ye.resetExcludedRepresentations(), this.disposeSegmentControllers(), Fe;
          }, Je.prototype.dispose = function() {
            this.timeshiftHandler = (0, ce.dispose)(this.timeshiftHandler), this.bufferController = (0, ce.dispose)(this.bufferController), (0, ce.dispose)(this.periodSwitchTracker);
            try {
              this.removeEventHandlers();
            } catch {
            }
            this.unsubscribeFromManifestChanges(), this.unsubscribeFromPlayingTracksChanges(), this.disposeSegmentControllers(), this.unsubscribeFromSeekProcess && this.unsubscribeFromSeekProcess(), this.subtitleService = null, this.heartbeatService = null, this.streamTimeService = null, this.segmentControllerMap = null, this.settings = null, this.bufferSettings = null, this.eventHandler = null, this.renderer = null, this.mimeTypes = null;
          }, Je.prototype.acquireServices = function() {
            var Ge = this.context.sourceContext.sourceIdentifier;
            this.manifestService = this.context.serviceManager.get(ae.ServiceName.ManifestService, Ge), this.playerStateService = this.context.serviceManager.get(ae.ServiceName.PlayerStateService), this.subtitleService = this.context.serviceManager.get(ae.ServiceName.SubtitleService, Ge), this.metadataParsedService = this.context.serviceManager.get(ae.ServiceName.MetadataParsedService), this.manifestLoader = this.context.serviceManager.get(ae.ServiceName.ManifestLoadingService, Ge), this.heartbeatService = this.context.serviceManager.get(ae.ServiceName.HeartbeatService, Ge), this.streamTimeService = this.context.serviceManager.get(ae.ServiceName.StreamTimeService), this.manifestUpdateScheduler = this.context.serviceManager.get(ae.ServiceName.ManifestUpdateSchedulingService, Ge);
          }, Je.prototype.init = function(Ge) {
            var Ye = this, ze = this.getSourceStore();
            return this.periodSwitchTracker = new Ae.PeriodSwitchTracker(this.context), this.subscribeToPlayingTracksChanges(), this.subscribeToSeekProcess(), this.isAudioCatchingUp = !1, this.context.store.dispatch((0, be.resetDrmKidErrors)()), this.acquireServices(), ze && !this.drmKidErrorHandler && (this.drmKidErrorHandler = new Ie.DrmKidErrorHandler(this.context, function() {
              return Ye.onDownloadedRepresentationExcluded();
            })), this.renderer.on(ye.MediaElementEvent.ended, this.firePlaybackFinishedEvent), (this.manifestUpdateScheduler.isInitiated() ? Promise.resolve() : this.manifestUpdateScheduler.init(Ge.url.toString())).then(function() {
              return Ye.subscribeToManifestChanges(), Ye.mpdAvailableHandler(), Ye.configEnhancer.adjustToCurrentSource(Ye.context, Ye.manifestService), Ye.initialized ? Promise.resolve() : Ye.finishInit();
            });
          }, Je.prototype.stop = function() {
            var Ge;
            this.logger.debug("Stopping main timer"), (Ge = this.heartbeatService) === null || Ge === void 0 || Ge.stop(), this.initPromise = null, this.eventHandler.off(he.PlayerEvent.SegmentRequestFinished, this.onSegmentRequestFinished), this.unsubscribeFromManifestChanges();
          }, Je.prototype.isOneLoaderReady = function() {
            return this.getAllSegmentControllers().some(function(Ge) {
              return Ge.canLoad();
            });
          }, Je.prototype.areAllLoadersReady = function() {
            return this.getAllSegmentControllers().every(function(Ge) {
              return Ge.canLoad();
            });
          }, Je.prototype.isVod = function() {
            return !this.manifestService.isLive();
          }, Je.prototype.shouldStopDownloadWhenPaused = function() {
            return this.playerStateService.isPaused() && this.settings.STOP_DOWNLOAD_ON_PAUSE && this.manifestService.isLive();
          }, Je.prototype.shouldWaitForOtherMimeTypeDownload = function(Ge) {
            var Ye = Object.keys(this.segmentControllerMap).find(function(yt) {
              return ge.MimeTypeHelper.isAV(yt) && Ge !== yt;
            });
            if (!Ye || (0, Le.isPlayingLowLatencyHls)(this.context))
              return !1;
            if (this.isAudioCatchingUp)
              return ge.MimeTypeHelper.isAudio(Ye);
            var ze = this.segmentControllerMap[Ye], Fe = this.streamTimeService.getTimeForNextSegment(Ye);
            if (ze.hasNext(Fe) && !ze.hasDownloadError && !ze.hasDelayedSegmentsInTransmuxer()) {
              var ot = this.getBufferRelevantTime(), vt = this.getCurrentForwardBuffer(Ge, ot), gt = this.getCurrentForwardBuffer(Ye, ot);
              return this.settings.DISABLE_PARALLEL_SEGMENT_LOADING && vt === gt ? ge.MimeTypeHelper.isVideo(Ye) : !this.hasReachedTargetBufferLevel(Ye, gt) && Fe < this.streamTimeService.getTimeForNextSegment(Ge);
            }
            return ze.getCurrentPeriodId() !== this.segmentControllerMap[Ge].getCurrentPeriodId();
          }, Je.prototype.hasReachedTargetBufferLevel = function(Ge, Ye) {
            var ze = ge.MimeTypeHelper.getMediaType(Ge);
            return Ye >= this.bufferSettings.getForwardTargetLevel(ze);
          }, Je.prototype.shouldEndOfStreamBeSignaled = function() {
            var Ge = this, Ye = this.getAllSegmentControllers(), ze = this.bufferController.hasPendingSegments(), Fe = Ye.map(function(gt) {
              return gt.getMimeType();
            }), ot = Ye.some(function(gt) {
              return gt.hasPendingSegments();
            }), vt = Fe.some(function(gt) {
              return Ge.renderer.isDataBeingAppended(gt);
            });
            return !ot && !ze && !vt;
          }, Je.prototype.shouldSuspendHeartbeat = function() {
            return !this.isOneLoaderReady() || this.shouldStopDownloadWhenPaused() || this.bufferController.isBufferClearingOngoing() || this.isSwitchingAudioTrack;
          }, Je.prototype.getActiveSegmentControllers = function() {
            var Ge = this;
            return this.getAllSegmentControllers().filter(function(Ye) {
              return Ge.isSegmentControllerActive(Ye);
            });
          }, Je.prototype.isSegmentControllerActive = function(Ge) {
            var Ye = this.periodSwitchTracker.getCurrentLoadingPeriodId(), ze = this.streamTimeService.getTimeForNextSegment(Ge.getMimeType());
            return Ge.canLoad() && (Ge.hasNext(ze) || Ge.hasPendingSegments(Ye)) && !this.shouldWaitForOtherMimeTypeDownload(Ge.getMimeType());
          }, Je.prototype.shouldClearSubtitleServiceBuffers = function() {
            var Ge;
            return !this.playerStateService.seekingOrTimeshifting && !!(!((Ge = this.subtitleService) === null || Ge === void 0) && Ge.hasSubtitles());
          }, Je.prototype.clearSubtitleServiceBuffers = function() {
            var Ge, Ye = 10;
            (Ge = this.subtitleService) === null || Ge === void 0 || Ge.clearBuffersUntil(this.renderer.getCurrentTime() - Ye);
          }, Je.prototype.areMediaTypesFinalForPlayingPeriod = function() {
            var Ge = this.periodSwitchTracker.getCurrentPlayingPeriodId();
            return this.bufferController.areBufferBlockMediaTypesFinalForPeriod(Ge);
          }, Je.prototype.maybeStop = function() {
            var Ge = this.manifestService.isManifestFinalized(), Ye = this.manifestService.isLastPeriod(this.periodSwitchTracker.getCurrentLoadingPeriodId());
            Ge && Ye && (this.bufferController.stop(!1), this.shouldEndOfStreamBeSignaled() && (this.signalEndOfStream(), this.stop()));
          }, Je.prototype.getNextSegment = function(Ge, Ye) {
            if (Ge.canLoad() && this.renderer.shouldContinueBuffering()) {
              var ze = ge.MimeTypeHelper.getMediaType(Ge.getMimeType()), Fe = this.bufferSettings.getForwardTargetLevel(ze), ot = this.getCurrentForwardBuffer(Ge.getMimeType(), this.getBufferRelevantTime());
              ot >= Fe || (this.context.serviceManager.get(ae.ServiceName.AdaptationService).addSample(Ge.getMimeType(), { bufferTargetLevel: Fe, bufferLevel: ot }), Ge.hasNext(Ye) && Ge.getNext(Ye));
            }
          }, Je.prototype.getBufferRelevantTime = function() {
            return this.playerStateService.seekingOrTimeshifting ? this.playerStateService.targetPlaybackTime : this.renderer.getCurrentTime();
          }, Je.prototype.getCurrentForwardBuffer = function(Ge, Ye) {
            return this.getBufferLevel(Ge, Ye, le.BufferType.ForwardDuration);
          }, Je.prototype.isLoadingLastPeriod = function() {
            return this.periodSwitchTracker.isLoadingLastPeriod() && !this.isAudioCatchingUp;
          }, Je.prototype.switchLoadingPeriod = function() {
            if (this.isAudioCatchingUp) {
              var Ge = this.getAudioSegmentController(), Ye = Ge.getCurrentPeriodId(), ze = this.manifestService.getNextPeriod(Ye)._id;
              this.switchLoadingPeriodForAudio(ze), Ge.getCurrentPeriodId() === this.periodSwitchTracker.getCurrentLoadingPeriodId() && (Ge.isTransmuxerRequired() && Ge.getTransmuxer() && (Ge.getTransmuxer().dispose(), Ge.setTransmuxer(this.transmuxer)), this.isAudioCatchingUp = !1, this.logger.debug("The audio SegmentController caught up to the overall loading period again."));
            } else {
              var Fe = this.manifestService.getNextPeriod(this.periodSwitchTracker.getCurrentLoadingPeriodId());
              Fe && this.switchLoadingPeriodForAllMedia(Fe._id);
            }
          }, Je.prototype.switchLoadingPeriodForAllMedia = function(Ge) {
            var Ye = this;
            Ge !== this.periodSwitchTracker.getCurrentLoadingPeriodId() && (this.isAudioCatchingUp = !1, this.prepareLoadingPeriodSwitch(Ge), this.getAllSegmentControllers().filter(function(ze) {
              return ze.getCurrentPeriodId() !== Ge;
            }).forEach(function(ze) {
              ze.switchPeriod(Ge), Ye.renderer.storeDrmInitDataFromManifest(ze.getAdaptationSetForPeriodId(Ge));
            }), this.periodSwitchTracker.setCurrentLoadingPeriodId(Ge));
          }, Je.prototype.prepareLoadingPeriodSwitch = function(Ge) {
            var Ye, ze, Fe = this;
            ((ze = (Ye = this.manifestService.getPeriod(new we.PeriodId(Ge))) === null || Ye === void 0 ? void 0 : Ye.AdaptationSet) !== null && ze !== void 0 ? ze : []).forEach(function(ot) {
              return Fe.createSegmentControllerIfMediaTypeIsMissing(ot);
            }), this.resetTransmuxer();
          }, Je.prototype.switchLoadingPeriodForAudio = function(Ge) {
            var Ye = this.getAudioSegmentController(), ze = Ye.getCurrentPeriodId();
            Ye.resetTransmuxer(), Ye.switchPeriod(Ge), this.logger.debug("Switched audio loading period from ".concat(ze, " to ").concat(Ge));
          }, Je.prototype.isAVCompletelyLoaded = function() {
            var Ge = this.getAllSegmentControllers().some(function(Ye) {
              return Ye.hasPendingSegments();
            }) || this.bufferController.hasPendingSegments();
            return this.manifestService.isManifestFinalized() && !Ge;
          }, Je.prototype.getBufferedRanges = function(Ge) {
            return Ge === void 0 && (Ge = !1), this.bufferController.getBufferedRangesMap(this.periodSwitchTracker.getCurrentPlayingPeriodId(), Ge);
          }, Je.prototype.resetTransmuxer = function() {
            this.transmuxer && (this.transmuxer.dispose(), this.transmuxer = null), this.createTransmuxer();
          }, Je.prototype.restartBufferController = function() {
            this.bufferController.hasStopped() && this.bufferController.restart();
          }, Je.prototype.shouldBuffersBeCleared = function(Ge, Ye, ze, Fe) {
            if (ze && Ge === 0)
              return !1;
            var ot = Ge < this.renderer.getCurrentTime() && this.context.settings.CLEAR_BUFFERS_ON_SEEKING_BACKWARDS;
            return !Ye && (!this.bufferController.isInBufferedRange(Ge) || ot) || Fe;
          }, Je.prototype.onSeekProcessChange = function(Ge, Ye) {
            var ze;
            if (Ge.targetTime === -1 && Ye.targetTime >= 0)
              (ze = this.playerStateService) === null || ze === void 0 || ze.transitionToSeekedState(Ye.issuer !== _e.STARTUP_ISSUER_NAME);
            else {
              var Fe = Ge.targetTime !== Ye.targetTime, ot = Ge.targetTime >= 0;
              Fe && ot && this.seek(Ge.targetTime, Ge.issuer === _e.STARTUP_ISSUER_NAME);
            }
          }, Je.prototype.seek = function(Ge, Ye, ze, Fe) {
            var ot = this;
            if (Ye === void 0 && (Ye = !1), ze === void 0 && (ze = !1), Fe === void 0 && (Fe = !1), this.bufferController) {
              this.restartBufferController(), this.seekCounter++;
              var vt, gt, yt = this.seekCounter, pt = this.manifestService.getPeriodIdForTime(Ge);
              this.ensureInitialPeriod(pt), this.logger.debug("seek from current period (".concat(this.periodSwitchTracker.getCurrentPlayingPeriodId(), ") to target period ") + "(".concat(pt, ") - seek time in period is: ").concat(Ge)), this.bufferController.readyToSeek().then(function() {
                if (gt = ot.shouldBuffersBeCleared(Ge, ze, Ye, Fe), vt = ot.periodSwitchTracker.getCurrentLoadingPeriodId() !== pt && gt, gt && ot.bufferController.isBufferAvailable())
                  return ot.clearBuffersOnSeek();
              }).then(function() {
                return ot.initialized ? (vt && ot.switchLoadingPeriodForAllMedia(pt), gt && ot.getAllSegmentControllers().forEach(function(bt) {
                  bt.setAdaptionLogicStartupPhase(), bt.seekTo(Ge);
                }), (Ye ? Promise.resolve() : ot.start()).then(function() {
                  ot.hasStarted() && ot.heartbeatService.beat(), ot.bufferController.setCurrentTime(Ge).then(function(bt) {
                    ot.context.isDisposed || (ot.seekCounter === yt ? (ot.logger.debug("Successfully seeked to ".concat(bt)), ot.context.store.dispatch((0, oe.updateSeekingProcess)({ targetTime: -1, issuer: "", isInitial: !1, seekableRange: { start: -1, end: -1 } }))) : tt(ot.context.store) && ot.context.logger.debug("Seek to ".concat(Ge, " has finished but a newer operation has been started")));
                  }).catch(function(bt) {
                    ot.logger.debug("Failed to set currentTime on seek", bt);
                  });
                })) : (ot.logger.debug("Aborting seek as MediaPlayerController has been terminated!"), Promise.resolve());
              });
            }
          }, Je.prototype.ensureInitialPeriod = function(Ge) {
            var Ye = this;
            this.periodSwitchTracker.getCurrentPlayingPeriodId() === void 0 && (this.logger.debug("current period is undefined, using seek target period " + Ge), this.periodSwitchTracker.setCurrentPlayingPeriodId(Ge), this.resetTransmuxer(), this.getAllSegmentControllers().forEach(function(ze) {
              ze.switchPeriod(Ye.periodSwitchTracker.getCurrentPlayingPeriodId()), ge.MimeTypeHelper.isAV(ze.getMimeType()) && Ye.renderer.storeDrmInitDataFromManifest(ze.getCurrentAdaptationSet());
            }), this.periodSwitchTracker.setCurrentLoadingPeriodId(this.periodSwitchTracker.getCurrentPlayingPeriodId()), this.bufferController.setInitialPeriod(Ge));
          }, Je.prototype.clearBuffersOnSeek = function() {
            var Ge = this;
            return this.context.logger.debug("Clearing buffer on seek"), this.eosSignaled = !1, this.getAllSegmentControllers().forEach(function(Ye) {
              return Ye.cancelLoading();
            }), this.bufferController.clearBuffers().catch(function() {
              Ge.logger.debug("Failed to clear buffers on seek, carrying on regardless");
            });
          }, Je.prototype.getAllSegmentControllers = function() {
            return Object.values(this.segmentControllerMap || {});
          }, Je.prototype.getAudioSegmentController = function() {
            return this.getAllSegmentControllers().find(function(Ge) {
              return ge.MimeTypeHelper.isAudio(Ge.getMimeType());
            });
          }, Je.prototype.updateAdaptationLogicData = function(Ge, Ye) {
            var ze, Fe;
            if (!(Ge.isInit || !Ge.success && this.playerStateService.seekingOrTimeshifting)) {
              var ot = ge.MimeTypeHelper.getMediaType(Ye.getMimeType()), vt = this.getBufferLevel(Ye.getMimeType(), this.renderer.getCurrentTime(), le.BufferType.ForwardDuration), gt = this.bufferSettings.getForwardTargetLevel(ot);
              (Fe = (ze = this.context.serviceManager) === null || ze === void 0 ? void 0 : ze.get(ae.ServiceName.AdaptationService)) === null || Fe === void 0 || Fe.addSample(Ye.getMimeType(), { bufferTargetLevel: gt, bufferLevel: vt, segmentDuration: Ge.duration, segmentDownloadDuration: Ge.downloadTime, downloadCancelled: !Ge.success });
            }
          }, Je.prototype.signalEndOfStream = function(Ge) {
            Ge === void 0 && (Ge = !0), this.isVod() && (this.eosSignaled || (this.eosSignaled = !0, this.bufferController.setEndOfStream(!0), Ge && this.stop()), this.bufferController.isStarted() && this.bufferController.stop());
          }, Je.prototype.start = function() {
            var Ge = this;
            return this.hasStarted() ? Promise.resolve() : this.finishInit().then(function() {
              var Ye;
              Ge.bufferController.hasStreamEnded() && (Ge.seek((0, ve.getStartTimeOffset)(Ge.getSourceStore().getState())), Ge.getAllSegmentControllers().forEach(function(ze) {
                return ze.resetTransmuxer();
              })), Ge.bufferController.isStarted() || Ge.bufferController.restart(), Ge.getAllSegmentControllers().filter(function(ze) {
                return ge.MimeTypeHelper.isAV(ze.getMimeType());
              }).forEach(function(ze) {
                return Ge.renderer.storeDrmInitDataFromManifest(ze.getCurrentAdaptationSet());
              }), Ge.logger.debug("Starting main timer"), Ge.eosSignaled = !1, (Ye = Ge.heartbeatService) === null || Ye === void 0 || Ye.start(), Ge.subscribeToManifestChanges(), Ge.eventHandler.on(he.PlayerEvent.SegmentRequestFinished, Ge.onSegmentRequestFinished);
            });
          }, Je.prototype.maybeTransitionToPausedState = function(Ge) {
            (0, fe.isSwitchingBufferBlocks)(this.getSourceStore()) ? this.context.logger.debug("Ignoring transition to Paused because buffer block switch is ongoing") : this.playerStateService.transitionToPausedState(!0, Ge, !0);
          }, Je.prototype.clearBuffers = function(Ge) {
            var Ye = this;
            return Promise.all(Ge.map(function(ze) {
              return Ye.bufferController.clearCacheForMimeType(ze), Ye.bufferController.clearBuffer(ze);
            })).then(function() {
            });
          }, Je.prototype.restorePlaybackPositionAfterAudioTrackSwitch = function(Ge, Ye) {
            var ze = this;
            return this.bufferController.setEndOfStream(!1).then(function() {
              var Fe = ze.clearBuffers(Ge.getSourceBufferTypes());
              return Ge.getCurrentPeriodId() !== ze.periodSwitchTracker.getCurrentPlayingPeriodId() ? ze.prepareControllerForAudioTrackChange(Ge) : Ge.getCurrentPeriodId() !== ze.periodSwitchTracker.getCurrentLoadingPeriodId() && ze.periodSwitchTracker.setCurrentLoadingPeriodId(Ge.getCurrentPeriodId()), Ge.setAdaptionLogicStartupPhase(), Ge.seekTo(Ye), ze.start().catch(function() {
                return ze.logger.debug("Could not restart stopped MPC after audio track switch");
              }), Fe.then(function() {
                ze.renderer.setCurrentTime(Ye).catch(function(ot) {
                  return ze.logger.debug("Failed to set currentTime on audio track switch", ot);
                });
              }).catch(function(ot) {
                return ze.logger.debug("Failed to attempt to restore playback after audio track switch", ot);
              });
            });
          }, Je.prototype.setAudio = function(Ge) {
            var Ye = this.getAvailableAudio(this.periodSwitchTracker.getCurrentPlayingPeriodId()).find(function(Fe) {
              return Fe.id === Ge;
            }), ze = this.getAudio();
            return this.initialized && Ye ? ze && ze.id === Ge ? Promise.reject(ze) : this.switchAudioTrack(Ye) : Promise.reject(null);
          }, Je.prototype.updateAdaptationSet = function(Ge, Ye, ze) {
            var Fe = this;
            return ge.MimeTypeHelper.isAudio(Ye) && We(this.manifestLoader) ? this.manifestLoader.updateAdaptationSet(ze).then(function() {
              return Fe.getAllSegmentControllers().forEach(function(ot) {
                return ot.updateMpd();
              });
            }).then(function() {
              return Ge;
            }) : Promise.resolve(Ge);
          }, Je.prototype.switchAudioTrack = function(Ge) {
            var Ye = this;
            this.isSwitchingAudioTrack = !0;
            var ze = Object.keys(this.segmentControllerMap), Fe = ze.find(ge.MimeTypeHelper.isAudio) || ze.find(ge.MimeTypeHelper.isVideo), ot = this.segmentControllerMap[Fe].getCurrentAdaptationSet(), vt = this.manifestService.getAdaptationSet(Ge.adaptationSetId);
            return ot && vt && Fe ? this.maybeChangeAudioBufferType(ot, vt, Fe).then(function(gt) {
              return Ye.maybeHandleMuxedAudioTransition(ot, vt, Ge, gt);
            }).then(function(gt) {
              return Ye.updateAdaptationSet(gt, Fe, Ge.id);
            }).then(function(gt) {
              return Ye.updateRelevantSegmentControllers(gt, Ge);
            }).finally(function() {
              return Ye.isSwitchingAudioTrack = !1;
            }) : Promise.reject("Did not find matching adaptation set");
          }, Je.prototype.maybeChangeAudioBufferType = function(Ge, Ye, ze) {
            var Fe, ot = this, vt = Xe(Ye, Ge), gt = ge.MimeTypeHelper.isVideo(Ye._mimeType) || ge.MimeTypeHelper.isVideo(Ge._mimeType), yt = !(0, ke.hasContentProtection)(Ge.ContentProtection, Ye.ContentProtection);
            if (gt || !vt && !yt)
              return Promise.resolve(((Fe = {})[Ye._mimeType] = "", Fe));
            var pt = Object.keys(this.segmentControllerMap).find(ge.MimeTypeHelper.isVideo);
            return this.recreateCurrentSegmentController(ze, Ye).then(function() {
              return yt && pt ? ot.clearBuffers([pt]).then(function() {
                var bt, ut = ot.segmentControllerMap[pt], Ke = ot.periodSwitchTracker.getCurrentPlayingPeriodId();
                ut.getCurrentPeriodId() !== Ke && ot.segmentControllerMap[pt].switchPeriod(Ke), ot.segmentControllerMap[pt].seekTo(ot.renderer.getCurrentTime()), (bt = ot.timeshiftHandler) === null || bt === void 0 || bt.updateSegmentControllers(ot.segmentControllerMap);
              }) : Promise.resolve();
            }).then(function() {
              return ot.bufferController.changeBufferType(Ye._mimeType, ot.mimeTypes[Ye._mimeType]);
            });
          }, Je.prototype.maybeHandleMuxedAudioTransition = function(Ge, Ye, ze, Fe) {
            var ot = this;
            return ge.MimeTypeHelper.isVideo(Ye._mimeType) || ge.MimeTypeHelper.isVideo(Ge._mimeType) ? this.clearBuffers([Ge._mimeType, Ye._mimeType]).then(function() {
              var vt = ge.MimeTypeHelper.isVideo(Ye._mimeType);
              return ot.transmuxer.setShouldExpectSeparateAvSegments(!vt), vt ? (ot.disposeSegmentController(Ge), Promise.resolve()) : (ot.createSegmentControllerIfMediaTypeIsMissing(Ye), ot.updateSegmentController(ze, Ge._mimeType));
            }).then(function() {
              return Fe;
            }) : Promise.resolve(Fe);
          }, Je.prototype.disposeSegmentController = function(Ge) {
            var Ye;
            if (Ge) {
              var ze = Ge._mimeType, Fe = this.segmentControllerMap[ze];
              Fe.cancelLoading(), Fe.dispose(), delete this.segmentControllerMap[ze], delete this.mimeTypes[ze], (Ye = this.timeshiftHandler) === null || Ye === void 0 || Ye.updateSegmentControllers(this.segmentControllerMap), this.getSourceStore().dispatch((0, Be.removeActiveTrackAction)(Ge._internalId)), this.context.segmentInfoService && this.context.segmentInfoService.setSegmentControllers(Object.values(this.segmentControllerMap));
            }
          }, Je.prototype.recreateCurrentSegmentController = function(Ge, Ye) {
            var ze = this, Fe = this.segmentControllerMap[Ge];
            return this.disposeSegmentController(Fe.getCurrentAdaptationSet()), this.clearBuffers([Ge]).then(function() {
              return ze.setupControllerForAdaptationSet(Ye), Ye._mimeType;
            });
          }, Je.prototype.updateRelevantSegmentControllers = function(Ge, Ye) {
            var ze = this;
            return Promise.all(Object.keys(Ge).map(function(Fe) {
              return ze.updateSegmentController(Ye, Fe);
            })).then(function() {
            });
          }, Je.prototype.updateSegmentController = function(Ge, Ye) {
            if (this.subtitleService && this.subtitleService.enableForcedSubtitle(Ge.lang), this.segmentControllerMap[Ye].setCurrentLangObj(Ge), this.segmentControllerMap[Ye].cancelLoading(), this.hasStarted() || this.eosSignaled) {
              var ze = this.getBufferRelevantTime();
              return this.restorePlaybackPositionAfterAudioTrackSwitch(this.segmentControllerMap[Ye], ze);
            }
            return Promise.resolve();
          }, Je.prototype.getAudio = function() {
            if (this.initialized) {
              var Ge = void 0, Ye = Object.keys(this.segmentControllerMap).find(function(vt) {
                return ge.MimeTypeHelper.isAudio(vt);
              });
              if (Ye && (Ge = this.segmentControllerMap[Ye].getCurrentLangObj()), !Ge) {
                var ze = Object.keys(this.segmentControllerMap).find(function(vt) {
                  return ge.MimeTypeHelper.isVideo(vt);
                });
                if (ze && this.segmentControllerMap[ze].getSourceBufferTypes()) {
                  var Fe = this.segmentControllerMap[ze];
                  if (Fe.getSourceBufferTypes().some(function(vt) {
                    return ge.MimeTypeHelper.isAudio(vt);
                  })) {
                    var ot = Fe.getCurrentAdaptationSet()._internalId;
                    Ge = this.getAvailableAudio(this.periodSwitchTracker.getCurrentPlayingPeriodId()).find(function(vt) {
                      return vt.adaptationSetId === ot;
                    }) || Fe.getCurrentLangObj();
                  }
                }
              }
              return Ge || null;
            }
            return null;
          }, Je.prototype.prepareControllerForAudioTrackChange = function(Ge) {
            if (this.isAVMultiplexed(Ge))
              this.switchLoadingPeriodForAllMedia(this.periodSwitchTracker.getCurrentPlayingPeriodId());
            else {
              if (this.logger.debug("audio needs to load previous period(s) and catch up to the overall loading period"), Ge.isTransmuxerRequired()) {
                var Ye = $e.ModuleManager.get(Se.ModuleName.ContainerTS);
                Ge.setTransmuxer(new Ye.WebWorkerTransmuxer(this.context, this.hasSeparateAvPlaylists()));
              }
              this.isAudioCatchingUp = !0, this.switchLoadingPeriodForAudio(this.periodSwitchTracker.getCurrentPlayingPeriodId());
            }
          }, Je.prototype.getPlaybackRepresentation = function(Ge) {
            for (var Ye in this.segmentControllerMap)
              if (this.segmentControllerMap[Ye] && Ye.includes(Ge))
                return this.context.serviceManager.get(ae.ServiceName.TimedMetadataService).getPlaybackRepresentation(Ye);
            return null;
          }, Je.prototype.getTimeShift = function() {
            return this.getTimeShiftHandler().getTimeShift();
          }, Je.prototype.getTimeShiftLiveEdge = function() {
            return this.manifestService.isLive() ? this.getTimeShiftHandler().getTimeShiftLiveEdge() : 0;
          }, Je.prototype.getPlaybackTimeForTimeShiftOffset = function(Ge) {
            return this.getTimeShiftHandler().calculatePlaybackTimeForTimeShiftOffset(Ge);
          }, Je.prototype.getTimeShiftHandler = function() {
            return this.timeshiftHandler || (this.timeshiftHandler = new xe.TimeShiftHandler(this.context, this, this.bufferController, this.segmentControllerMap)), this.timeshiftHandler;
          }, Je.prototype.timeShift = function(Ge, Ye, ze) {
            return ze === void 0 && (ze = !1), this.getTimeShiftHandler().timeShift(Ge, Ye, ze);
          }, Je.prototype.getAvailableAudio = function(Ge) {
            return this.manifestService.getAvailableAudio(Ge);
          }, Je.prototype.hasStreamEnded = function() {
            return !!this.bufferController && this.bufferController.hasStreamEnded();
          }, Je.prototype.getCurrentTime = function() {
            return this.renderer.getCurrentTime();
          }, Je.prototype.getSeekableRange = function() {
            if (this.manifestService.isLive()) {
              if (this.playerStateService.seekingOrTimeshifting && this.cachedSeekableRange)
                return this.cachedSeekableRange;
              var Ge = this.getTimeShiftLiveEdge(), Ye = Ge + this.getMaxTimeShift();
              return this.cachedSeekableRange = { start: Ye, end: Ge };
            }
            var ze = this.getAllSegmentControllers().find(function(Fe) {
              return ge.MimeTypeHelper.isAV(Fe.getMimeType());
            });
            return ze ? ze.getMPDHandler().getSeekableRange() : { start: -1, end: -1 };
          }, Je.prototype.getAvailableSegments = function() {
            var Ge = this, Ye = {};
            return Object.keys(this.segmentControllerMap).forEach(function(ze) {
              Ye[ze] = Ge.segmentControllerMap[ze].getSegmentInfos();
            }), Ye;
          }, Je.prototype.isInitialized = function() {
            return this.initialized;
          }, Je.prototype.hasStarted = function() {
            var Ge, Ye;
            return (Ye = (Ge = this.heartbeatService) === null || Ge === void 0 ? void 0 : Ge.started) !== null && Ye !== void 0 && Ye;
          }, Je;
        }();
        function We(Je) {
          var Ge = $e.ModuleManager.get(Se.ModuleName.HLS, !1), Ye = Ge == null ? void 0 : Ge.M3u8Loader;
          return Ye !== void 0 && Je instanceof Ye;
        }
        function Xe(Je, Ge) {
          return !(0, ke.areAudioMimeCodecsCompatible)({ mimeType: Je._mimeType, codec: (0, Ee.getCodecsFromAdaptationSet)(Je) }, { mimeType: Ge._mimeType, codec: (0, Ee.getCodecsFromAdaptationSet)(Ge) });
        }
        function Qe(Je, Ge) {
          var Ye = Je.getPlaybackTimeRange(), ze = (0, Ne.getTrackIdentifier)(Je.getSegmentInfo());
          Ye && (Ge == null || Ge.dispatch((0, Re.removeStreamTimeRange)(ze, Ye, Ne.StreamTimeRangeType.Loading)));
        }
        function tt(Je) {
          var Ge = Je.getState();
          if (!Ge)
            return !1;
          var Ye = (0, ue.getPlayerState)(Ge).seekingProcess.issuer;
          return Ye !== _e.STARTUP_ISSUER_NAME && Ye !== "";
        }
        ne.MediaPlayerController = He;
      }, 37702: function(ee, ne) {
        function ie(ce) {
          var he = [];
          return ce.forEach(function(_e) {
            he.push(_e);
          }), he;
        }
        function ae(ce) {
          var he = [];
          return ce.forEach(function(_e, le) {
            he.push(le);
          }), he;
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getValues = ie, ne.getKeys = ae;
      }, 38353: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var ft = function(lt, nt) {
            return ft = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ct, it) {
              ct.__proto__ = it;
            } || function(ct, it) {
              for (var et in it)
                Object.prototype.hasOwnProperty.call(it, et) && (ct[et] = it[et]);
            }, ft(lt, nt);
          };
          return function(lt, nt) {
            if (typeof nt != "function" && nt !== null)
              throw new TypeError("Class extends value " + String(nt) + " is not a constructor or null");
            function ct() {
              this.constructor = lt;
            }
            ft(lt, nt), lt.prototype = nt === null ? Object.create(nt) : (ct.prototype = nt.prototype, new ct());
          };
        }(), ce = this && this.__assign || function() {
          return ce = Object.assign || function(ft) {
            for (var lt, nt = 1, ct = arguments.length; nt < ct; nt++)
              for (var it in lt = arguments[nt])
                Object.prototype.hasOwnProperty.call(lt, it) && (ft[it] = lt[it]);
            return ft;
          }, ce.apply(this, arguments);
        }, he = this && this.__spreadArray || function(ft, lt, nt) {
          if (nt || arguments.length === 2)
            for (var ct, it = 0, et = lt.length; it < et; it++)
              !ct && it in lt || (ct || (ct = Array.prototype.slice.call(lt, 0, it)), ct[it] = lt[it]);
          return ft.concat(ct || Array.prototype.slice.call(lt));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ManifestService = void 0, ne.initializeInternalIds = Xe, ne.addDrmKidsToRepresentations = Qe, ne.iterateAdaptationSets = Je, ne.getNearestPeriodForTime = Ge, ne.findLowestPossibleBandwidthFromRepresentations = ze, ne.getMatchingRepresentationsByBandwidth = Fe, ne.getMatchingRepresentationByBandwidth = vt, ne.getCodecPriorities = yt, ne.getCodecOfAdaptationSetMimeType = bt;
        var _e = ie(25550), le = ie(28764), se = ie(18665), oe = ie(60997), ue = ie(62510), be = ie(57620), ve = ie(68039), me = ie(63668), pe = ie(95328), fe = ie(91397), ge = ie(34731), ye = ie(27177), $e = ie(81361), Se = ie(42283), Ce = ie(44388), Ie = ie(79814), Te = ie(65114), Ee = ie(331), we = ie(70016), Pe = ie(91520), Me = ie(16368), Ae = ie(41735), Oe = ie(77874), Be = ie(9827), Ve = ie(13034), Ue = ie(67883), Re = ie(94938), Ne = ie(43752), xe = ie(96953), ke = ie(38925), Le = "Outdated", He = function(ft) {
          function lt(nt, ct) {
            var it = ft.call(this, { onRestore: function() {
              return it.onRestore();
            } }) || this;
            it.context = nt, it.lastManifestUpdateId = 0, it.dispatchQualityRemovedEvent = function(st) {
              var mt = it.getAdaptationSet(st._internalId);
              if (mt) {
                var St = function($t) {
                  it.context.eventHandler.dispatchEvent($t, { quality: { id: st._id, bitrate: st._bandwidth } });
                };
                Ie.MimeTypeHelper.isAudio(mt._mimeType) ? St(ue.PlayerEvent.AudioQualityRemoved) : Ie.MimeTypeHelper.isVideo(mt._mimeType) && St(ue.PlayerEvent.VideoQualityRemoved);
              }
            }, it.copyRequiredPropertiesToRepresentations = function(st) {
              (st.Representation || []).forEach(function(mt) {
                st._codecs && !mt._codecs && (mt._codecs = st._codecs), st._width && !mt._width && (mt._width = st._width), st._height && !mt._height && (mt._height = st._height);
              }), delete st.SegmentTemplate;
            }, it.sourceContext = ct, it.settings = nt.settings, it.excludedRepresentations = [];
            var et = it.sourceContext.sourceIdentifier;
            return it.synchronizedTimeService = nt.serviceManager.get(se.ServiceName.SynchronizedTimeService, et), it.sourceStore = nt.serviceManager.get(se.ServiceName.SourceStoreService, et), it;
          }
          return ae(lt, ft), Object.defineProperty(lt.prototype, "mpdExtractor", { get: function() {
            return this._mpdExtractor || (this._mpdExtractor = new Ne.MPDExtractor(this.context, this.sourceContext)), this._mpdExtractor;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(lt.prototype, "manifest", { get: function() {
            var nt;
            return (0, Oe.getManifest)((nt = this.sourceStore) === null || nt === void 0 ? void 0 : nt.getState());
          }, enumerable: !1, configurable: !0 }), lt.prototype.setManifest = function(nt) {
            this.sourceStore.dispatch((0, Ae.setManifestAction)(this.preProcessManifest(nt)));
          }, lt.prototype.updateManifest = function(nt) {
            var ct = this;
            this.lastManifestUpdateId++;
            var it = this.lastManifestUpdateId;
            return this.synchronizeWithTimeserver(nt).then(function() {
              return ct.ensureStillSameOperation(it), ct.adjustManifestToKeySystemSupport(nt);
            }).then(function() {
              ct.ensureStillSameOperation(it), ct.reinitializeAndUpdateManifest(nt);
            }).catch(function(et) {
              if (et !== Le)
                throw et;
              ct.context.logger.debug("Skipping manifest update, since a newer manifest is available");
            });
          }, lt.prototype.ensureStillSameOperation = function(nt) {
            if (nt !== this.lastManifestUpdateId)
              throw Le;
          }, lt.prototype.adjustManifestToKeySystemSupport = function(nt) {
            var ct, it, et, st, mt = this, St = (et = (it = (ct = this.context.serviceManager) === null || ct === void 0 ? void 0 : ct.get(se.ServiceName.DrmService)) === null || it === void 0 ? void 0 : it.getUsedOrEarlyResolvedKeySystemUid()) !== null && et !== void 0 ? et : null;
            if (!St || !nt.Period || !(!((st = this.context.serviceManager) === null || st === void 0) && st.has(se.ServiceName.DrmDetectorService)))
              return Promise.resolve();
            var $t = this.context.serviceManager.get(se.ServiceName.DrmDetectorService), Tt = ut(nt, this.mpdExtractor), rt = Tt.audioCapabilities, qe = Tt.videoCapabilities;
            return $t.getSupportedCapabilities(St, rt, qe).then(function(Ze) {
              return Ke(nt, Ze, mt.context.logger);
            });
          }, lt.prototype.reinitializeAndUpdateManifest = function(nt) {
            if ((0, ye.isContextAvailable)(this.context) && this.context.serviceManager) {
              if (this.disposeMpdExtractor(), nt.isInitialized = !1, this.setManifest(nt), this.isLive()) {
                var ct = this.getFirstPeriod(), it = this.isHlsManifest() && ct ? ct.start : (0, Ee.toSeconds)(this.getAvailabilityStartTime());
                this.sourceStore.dispatch((0, pe.setStartTimeOffset)(it));
              }
              this.mpdExtractor.adjustPeriodStartTimes();
              var et = this.parseStreamDuration();
              (0, be.maybeFireDurationChangedEvent)(this.parsedDuration, et, this.context.eventHandler), this.parsedDuration = et, this.setManifestInitialized(!0), this.context.serviceManager.maybeCall(se.ServiceName.HeartbeatService, function(st) {
                st.started && st.beat();
              }, void 0, this.context.sourceContext.sourceIdentifier);
            }
          }, lt.prototype.excludeRepresentations = function(nt) {
            var ct = this, it = nt.map(function(mt) {
              return ct.getRepresentationById(mt);
            }).filter(function(mt) {
              return !!mt;
            });
            this.setManifestInitialized(!1);
            var et = at(this.manifest.Period);
            this.excludedRepresentations = $e.ArrayHelper.union(this.excludedRepresentations, nt), this.sourceStore.dispatch((0, Ae.removeRepresentationsAction)(this.excludedRepresentations));
            var st = at(this.manifest.Period);
            return Object.keys(et).every(function(mt) {
              return st[mt] != null && et[mt].length === st[mt].length;
            }) ? (this.disposeMpdExtractor(), it.forEach(this.dispatchQualityRemovedEvent), this.setManifestInitialized(!0), !0) : (this.context.eventHandler.fireError(new le.PlayerError(_e.ErrorCode.SOURCE_ERROR, void 0, "No playable track left")), !1);
          }, lt.prototype.isRepresentationExcluded = function(nt) {
            return this.excludedRepresentations.some(function(ct) {
              return ct.equals(nt);
            });
          }, lt.prototype.resetExcludedRepresentations = function() {
            this.excludedRepresentations = [];
          }, lt.prototype.onRestore = function() {
            this.setPlayerDRM(this.getManifest()), this.sourceStore.dispatch((0, Ae.setManifestAction)(Xe(this.getManifest())));
          }, lt.getSupplementalProperties = function(nt, ct) {
            return !nt.SupplementalProperty || nt.SupplementalProperty.length <= 0 ? null : nt.SupplementalProperty.filter(function(it) {
              return it._schemeIdUri === ct;
            });
          }, lt.prototype.findMatchingSwitchableAdaptationSets = function(nt, ct, it) {
            var et = it && it.length > 0;
            if (!et && !this.settings.ADAPTATION_SET_SWITCHING_WITHOUT_SUPPLEMENTAL_PROPERTY)
              return null;
            var st = [], mt = nt._group, St = bt(nt);
            return et && it.forEach(function($t) {
              return st.push($t._value);
            }), this.settings.ADAPTATION_SET_SWITCHING_WITHOUT_SUPPLEMENTAL_PROPERTY && ct.forEach(function($t) {
              st.includes($t._id) || st.push($t._id);
            }), ct.filter(function($t) {
              if (!st.includes($t._id) || $t._id === nt._id)
                return !1;
              var Tt = $t._group === mt, rt = $t._mimeType === nt._mimeType, qe = bt($t) === St, Ze = $t._lang === nt._lang;
              return rt && qe && Tt && Ze;
            });
          }, lt.prototype.getSwitchableAdaptationSets = function(nt) {
            var ct = this;
            return nt.AdaptationSet ? nt.AdaptationSet.reduce(function(it, et) {
              var st = lt.getSupplementalProperties(et, "urn:mpeg:dash:adaptation-set-switching:2016"), mt = ct.findMatchingSwitchableAdaptationSets(et, nt.AdaptationSet, st);
              return mt && mt.length !== 0 ? $e.ArrayHelper.addAndMergeIntersects(it, he([et], mt, !0)) : it;
            }, []) : [];
          }, lt.mergeAdaptationSetProperties = function(nt, ct, it) {
            var et = nt.hasOwnProperty(it), st = ct.hasOwnProperty(it);
            (et || st) && (et ? st || (ct[it] = []) : nt[it] = [], nt[it] = nt[it].concat(ct[it]));
          }, lt.prototype.getAdaptationSetPropertyValues = function(nt, ct) {
            return nt.filter(function(it) {
              return it.hasOwnProperty(ct);
            }).map(function(it) {
              return it[ct];
            });
          }, lt.prototype.updateAdaptationSetMinMaxValues = function(nt, ct) {
            var it = [nt].concat(ct), et = this.getAdaptationSetPropertyValues(it, "_minWidth"), st = this.getAdaptationSetPropertyValues(it, "_maxWidth"), mt = this.getAdaptationSetPropertyValues(it, "_minHeight"), St = this.getAdaptationSetPropertyValues(it, "_maxHeight"), $t = this.getAdaptationSetPropertyValues(it, "_minBandwidth"), Tt = this.getAdaptationSetPropertyValues(it, "_maxBandwidth");
            et.length > 0 && (nt._minWidth = Math.min.apply(null, et)), st.length > 0 && (nt._maxWidth = Math.max.apply(null, st)), mt.length > 0 && (nt._minHeight = Math.min.apply(null, mt)), St.length > 0 && (nt._maxHeight = Math.max.apply(null, St)), $t.length > 0 && (nt._minBandwidth = Math.min.apply(null, $t)), Tt.length > 0 && (nt._maxBandwidth = Math.max.apply(null, Tt));
          }, lt.prototype.mergeAdaptationSets = function(nt, ct) {
            ct.forEach(this.copyRequiredPropertiesToRepresentations);
            var it = ct.shift();
            ct.forEach(function(et) {
              ["Representation", "ContentComponent", "ContentProtection", "SupplementalProperty"].forEach(function(st) {
                return lt.mergeAdaptationSetProperties(it, et, st);
              });
            }), this.updateAdaptationSetMinMaxValues(it, ct), nt.AdaptationSet = nt.AdaptationSet.filter(function(et) {
              return !ct.includes(et);
            });
          }, lt.prototype.sortAdaptationSetRepresentations = function(nt) {
            var ct;
            (ct = nt == null ? void 0 : nt.AdaptationSet) === null || ct === void 0 || ct.forEach(function(it) {
              var et;
              (et = it == null ? void 0 : it.Representation) === null || et === void 0 || et.sort(function(st, mt) {
                return st._bandwidth - mt._bandwidth;
              });
            });
          }, lt.prototype.mergeSwitchableAdaptationSets = function(nt) {
            var ct = this;
            return nt.Period.forEach(function(it) {
              ct.getSwitchableAdaptationSets(it).forEach(function(et) {
                ct.mergeAdaptationSets(it, et);
              }), ct.sortAdaptationSetRepresentations(it);
            }), nt;
          }, lt.prototype.setRepresentationDrmKid = function(nt, ct) {
            this.sourceStore.dispatch((0, Ae.setRepresentationDrmKidAction)(nt, ct));
          }, lt.prototype.getRepresentationDrmKid = function(nt) {
            var ct;
            return (ct = this.getRepresentationById(nt)) === null || ct === void 0 ? void 0 : ct.associatedKid;
          }, lt.prototype.setManifestInitialized = function(nt) {
            this.sourceStore.dispatch((0, Ae.setManifestInitializedAction)(nt));
          }, lt.prototype.setPlayerDRM = function(nt) {
            var ct = this.sourceContext.source.drm, it = We(nt), et = {};
            it.length > 0 && (et = ce({}, it[0])), ct != null && Object.keys(ct).length > 0 && Object.keys(ct).forEach(function(mt) {
              et[mt] = et[mt] != null ? ce(ce({}, et[mt]), ct[mt]) : ct[mt];
            }), this.addDrmServiceAndSetDrmConfig(et);
            var st = Object.keys(et).length > 0 ? (0, me.setManifestDrm)(et) : (0, me.resetManifestDrm)();
            this.sourceStore.dispatch(st);
          }, lt.prototype.addDrmServiceAndSetDrmConfig = function(nt) {
            if (Pe.ModuleManager.has(Me.ModuleName.DRM) && Object.keys(nt).length > 0 && !this.context.serviceManager.has(se.ServiceName.DrmService)) {
              var ct = Pe.ModuleManager.get(Me.ModuleName.DRM).DrmService;
              this.context.serviceManager.set(se.ServiceName.DrmService, new ct(this.context));
            }
            this.context.serviceManager.maybeCall(se.ServiceName.DrmService, function(it) {
              it.isDrmConfigSet() || it.setDrmConfig(nt);
            });
          }, lt.prototype.getPreviousRepDrmKidAssociation = function() {
            var nt = /* @__PURE__ */ new Map();
            return this.getAllRepresentations().filter(function(ct) {
              return ct._internalId && ct.associatedKid;
            }).forEach(function(ct) {
              return nt.set(ct._internalId.key(), ct.associatedKid);
            }), nt;
          }, lt.prototype.preProcessManifest = function(nt) {
            var ct = this.getPreviousRepDrmKidAssociation();
            return nt.Period && nt.Period.length > 0 ? (Qe(nt = (0, Re.orderAdaptationSetsByCodec)(nt, yt(this.context.config, this.sourceContext.source))), nt = this.mergeSwitchableAdaptationSets(nt), Pe.ModuleManager.has(Me.ModuleName.Envivio) && (nt = Pe.ModuleManager.get(Me.ModuleName.Envivio).fixSegmentTimelineLiveStream(nt)), this.isSuspended() || this.setPlayerDRM(nt), nt = Xe(nt), tt(nt = (0, Re.removeRepresentations)(nt, this.excludedRepresentations), ct), nt) : (this.context.eventHandler.fireError(new le.PlayerError(_e.ErrorCode.SOURCE_ERROR, void 0, "No playable track left")), null);
          }, lt.prototype.parseStreamDuration = function() {
            if (this.mpdExtractor) {
              var nt = NaN, ct = this.mpdExtractor.getDuration();
              return ct && (this.cachedDurationString && this.cachedDurationString === ct ? nt = this.cachedDuration : (nt = Ce.DurationConverter.getDurationInSec(ct), this.cachedDurationString = ct, this.cachedDuration = nt)), isNaN(nt) && this.isLive() ? 1 / 0 : nt;
            }
            return 0;
          }, lt.prototype.getDuration = function() {
            return this.parsedDuration;
          }, lt.prototype.isLive = function() {
            return !!this.manifest && this.mpdExtractor.isLive();
          }, lt.prototype.getAvailabilityStartTime = function() {
            return this.mpdExtractor.getAvailabilityStartTime();
          }, lt.prototype.getAvailabilityEndTime = function() {
            return this.mpdExtractor.getAvailabilityEndTime();
          }, lt.prototype.isAvailabilityEndTimeExceeded = function() {
            var nt = this.getAvailabilityEndTime();
            return nt && Date.now() > nt.getTime();
          }, lt.prototype.findPeriod = function(nt) {
            return (0, Te.findPeriod)(this.manifest, nt);
          }, lt.prototype.getAllPeriods = function() {
            return this.manifest && this.manifest.Period ? this.manifest.Period : [];
          }, lt.prototype.getPeriod = function(nt) {
            return nt ? this.findPeriod(nt.periodId) : null;
          }, lt.prototype.isLanguageAvailable = function(nt, ct, it) {
            var et = (0, Te.findPeriod)(this.manifest, nt) || pt(this.manifest);
            return (0, Ve.findAdaptationSetsForMimeType)(et, ct).some(function(st) {
              var mt = st._lang && it.lang && st._lang === it.lang, St = it.adaptationSetId && st._internalId.equals(it.adaptationSetId);
              return mt || St;
            });
          }, lt.prototype.findAdaptationSet = function(nt, ct, it, et) {
            et === void 0 && (et = !1);
            var st = (0, Te.findPeriod)(this.manifest, nt) || pt(this.manifest);
            if (st !== void 0) {
              var mt = this.sourceStore.getState(), St = (0, Ve.findAdaptationSetOfMimeType)(ct, st, { sourceState: mt, langObj: it, periodSwitched: et, playbackConfig: this.context.config.playback });
              return St || this.context.logger.debug("No AdaptationSet found to match mime type " + ct), St;
            }
          }, lt.prototype.getManifest = function() {
            return this.manifest;
          }, lt.prototype.getAvailableAudio = function(nt, ct) {
            return this.mpdExtractor.getAvailableAudio(nt, ct);
          }, lt.prototype.getAvailableVideo = function(nt) {
            return this.mpdExtractor.getAvailableVideo(nt);
          }, lt.prototype.getAvailableSubtitles = function(nt) {
            return this.mpdExtractor.getAvailableSubtitles(nt);
          }, lt.prototype.getClosedCaptionLabels = function(nt) {
            return this.mpdExtractor.getClosedCaptionLabels(nt);
          }, lt.prototype.getVideoRepresentations = function(nt) {
            return this.mpdExtractor.getVideoQualities(nt);
          }, lt.prototype.getAudioRepresentations = function(nt) {
            return this.mpdExtractor.getAudioQualities(nt);
          }, lt.prototype.getPeriodDuration = function(nt, ct) {
            var it;
            return this.mpdExtractor.getPeriodDuration(nt, ct ?? ((it = this.getManifest()) === null || it === void 0 ? void 0 : it.Period));
          }, lt.prototype.estimatePeriodDuration = function(nt) {
            var ct, it;
            return this.isLastPeriod(nt._id) ? (it = dt(nt.AdaptationSet[0])) !== null && it !== void 0 ? it : 1 / 0 : (ct = nt.duration) !== null && ct !== void 0 ? ct : this.getPeriodDuration(nt._id);
          }, lt.prototype.hasMultiplePeriods = function() {
            return this.manifest && this.manifest.Period && this.manifest.Period.length > 1;
          }, lt.prototype.hasSinglePeriod = function() {
            return this.manifest && this.manifest.Period && this.manifest.Period.length === 1;
          }, lt.prototype.getEstimatedDvrWindowLength = function() {
            var nt = this;
            return this.getAllPeriods().reduce(function(ct, it) {
              return ct + nt.estimatePeriodDuration(it);
            }, 0);
          }, lt.prototype.getTimeShiftBufferDepthSeconds = function() {
            var nt = this.mpdExtractor.getTimeShiftBufferDepthSeconds(), ct = -this.getEstimatedDvrWindowLength();
            return Math.max(nt, ct);
          }, lt.prototype.getRequestTimestamp = function() {
            return this.mpdExtractor.getRequestTimestamp();
          }, lt.prototype.getMediaPresentationDuration = function() {
            var nt, ct = Ce.DurationConverter.getDurationInSec((nt = this.manifest) === null || nt === void 0 ? void 0 : nt._mediaPresentationDuration);
            return isNaN(ct) ? 0 : ct;
          }, lt.prototype.calculateCumulativePeriodDuration = function(nt) {
            for (var ct, it, et = 0, st = 0, mt = (it = (ct = this.manifest) === null || ct === void 0 ? void 0 : ct.Period) !== null && it !== void 0 ? it : []; st < mt.length; st++) {
              var St = mt[st];
              if (St._id === nt)
                break;
              et += this.getPeriodDuration(St._id);
            }
            return this.isLive() ? (0, Ee.toSeconds)(Date.now() - this.getAvailabilityStartTime()) - et : et;
          }, lt.prototype.getMinimumUpdatePeriod = function() {
            return (0, Ne.getMinimumUpdatePeriodInSeconds)(this.manifest);
          }, lt.prototype.getContentProtectionForAdaptationSet = function(nt) {
            return Ne.MPDExtractor.getContentProtectionForAdaptationSet(nt);
          }, lt.prototype.getLangObjectFromAdaptationSet = function(nt, ct) {
            return this.mpdExtractor.getLangObjectFromAdaptationSet(nt, ct);
          }, lt.prototype.toSubtitleTrack = function(nt, ct) {
            return this.mpdExtractor.toSubtitleTrack(nt, ct);
          }, lt.prototype.getDRMCapabilitiesForPeriod = function(nt) {
            return this.mpdExtractor.getDRMCapabilitiesForPeriod(nt);
          }, lt.prototype.hasManifestTypeChanged = function(nt) {
            return !(!this.manifest || this.manifest._type === nt) && (this.context.logger.log("Manifest has just changed from " + this.manifest._type + " to " + nt), !0);
          }, lt.prototype.getPeriodIdForTime = function(nt) {
            var ct, it = this.getAllPeriods();
            return it.length === 1 ? it[0]._id : (ct = Ge(it, nt)) === null || ct === void 0 ? void 0 : ct._id;
          }, lt.prototype.dispose = function() {
            this.disposeMpdExtractor(), ft.prototype.dispose.call(this);
          }, lt.prototype.disposeMpdExtractor = function() {
            this._mpdExtractor = (0, oe.dispose)(this._mpdExtractor);
          }, lt.prototype.getTotalDurationFromManifest = function() {
            var nt = this.getFirstPeriod();
            if (this.cachedDuration && nt && nt.start)
              return nt.start + this.cachedDuration;
          }, lt.prototype.getTotalDuration = function() {
            if (this.isLive())
              return this.getTotalDurationFromManifest() || 1 / 0;
            var nt = this.getLastPeriod();
            return nt ? (nt.start || nt._start && Ce.DurationConverter.getDurationInSec(nt._start) || 0) + this.mpdExtractor.getPeriodDuration(nt._id) : 0;
          }, lt.prototype.getFirstPeriod = function() {
            return pt(this.manifest);
          }, lt.prototype.getLastPeriod = function() {
            var nt = this.getAllPeriods();
            if (nt.length > 0)
              return nt[nt.length - 1];
          }, lt.prototype.isLastPeriod = function(nt) {
            var ct = this.getLastPeriod();
            return !!ct && nt === ct._id;
          }, lt.prototype.isManifestFinalized = function() {
            return !this.isLive();
          }, lt.prototype.isFirstPeriod = function(nt) {
            var ct = this.getFirstPeriod();
            return !!ct && ct._id === nt;
          }, lt.prototype.isHlsManifest = function() {
            var nt, ct;
            return (ct = (nt = this.getManifest()) === null || nt === void 0 ? void 0 : nt._isHls) !== null && ct !== void 0 && ct;
          }, lt.prototype.isDashManifest = function() {
            return !this.isHlsManifest() && !this.isSmoothManifest();
          }, lt.prototype.isSmoothManifest = function() {
            var nt, ct;
            return ((ct = (nt = this.manifest) === null || nt === void 0 ? void 0 : nt.originalFormat) === null || ct === void 0 ? void 0 : ct.format) === "smooth";
          }, lt.prototype.getHlsTags = function() {
            if (!this.isHlsManifest())
              return null;
            var nt = Pe.ModuleManager.get(Me.ModuleName.HLS).selectors, ct = nt.getHlsState;
            return (0, nt.getCustomTags)(ct(this.sourceStore.getState()));
          }, lt.prototype.isMimeTypePartOfPeriod = function(nt, ct) {
            var it = this.getPeriod(new xe.PeriodId(ct));
            return (it ? it.AdaptationSet : []).some(function(et) {
              return et._mimeType === nt;
            });
          }, lt.prototype.getNextPeriod = function(nt) {
            if (this.manifest)
              for (var ct = this.findPeriod(nt), it = this.manifest.Period.indexOf(ct) + 1; it < this.manifest.Period.length; it++) {
                var et = this.manifest.Period[it];
                if (et)
                  return et;
              }
            return null;
          }, lt.prototype.getEventStreamEvents = function(nt) {
            return this.mpdExtractor.getEventStreamEvents(nt);
          }, lt.prototype.hasAdaptationSets = function(nt) {
            var ct = this.manifest;
            if (ct && ct.Period) {
              var it = ct.Period.find(function(et) {
                return et._id === nt;
              });
              return !!(it && it.AdaptationSet);
            }
            return !1;
          }, lt.prototype.synchronizeWithTimeserver = function(nt) {
            if (this.synchronizedTimeService) {
              var ct = this.synchronizedTimeService.getSynchronizationPromise();
              if (ct)
                return ct;
              if (nt.UTCTiming && nt.UTCTiming.length > 0)
                return this.synchronizedTimeService.synchronizeWithServer(nt.UTCTiming, nt._downloadTime);
            }
            return Promise.resolve();
          }, lt.prototype.getAdaptationSet = function(nt) {
            if (nt && this.manifest)
              return (0, Te.findAdaptationSet)(this.manifest, nt);
          }, lt.prototype.getRepresentationById = function(nt) {
            if (nt && this.manifest)
              return (0, Te.findRepresentation)(this.manifest, nt);
          }, lt.prototype.representationExists = function(nt) {
            return !!this.getRepresentationById(nt);
          }, lt.prototype.getLowestBandwidthOfAdaptationSet = function(nt) {
            return this.findLowestPossibleBandwidth(nt, -1 / 0);
          }, lt.prototype.findLowestPossibleBandwidth = function(nt, ct) {
            ct === void 0 && (ct = -1 / 0);
            var it = this.getAdaptationSet(nt);
            return it ? ze(it.Representation, ct) : 1 / 0;
          }, lt.prototype.getMatchingRepresentationsByBandwidth = function(nt, ct, it) {
            it === void 0 && (it = function() {
              return !0;
            });
            var et = this.getAdaptationSet(nt);
            return et ? Fe(et.Representation, ct, it) : [];
          }, lt.prototype.getMatchingRepresentationByBandwidth = function(nt, ct, it) {
            it === void 0 && (it = function() {
              return !0;
            });
            var et = this.getAdaptationSet(nt);
            return et ? vt(et.Representation, ct, it) : null;
          }, lt.prototype.getAllRepresentations = function() {
            return this.getAllPeriods().flatMap(function(nt) {
              var ct;
              return ((ct = nt.AdaptationSet) === null || ct === void 0 ? void 0 : ct.flatMap(function(it) {
                return it.Representation;
              })) || [];
            });
          }, lt.prototype.getRepresentation = function(nt, ct) {
            return this.getRepresentationById(new ke.RepresentationId(nt, ct));
          }, lt.prototype.getAllAdaptationSets = function() {
            return this.getAllPeriods().flatMap(function(nt) {
              return nt.AdaptationSet;
            });
          }, lt.prototype.getAllImageAdaptationSets = function() {
            return this.getAllAdaptationSets().filter(function(nt) {
              return nt._mimeType.includes("image") && nt._contentType === "image";
            });
          }, lt.prototype.getAllDashThumbnailSources = function() {
            var nt = this;
            return this.getAllImageAdaptationSets().map(function(ct) {
              var it = nt.findPeriod(ct._internalId.periodId);
              return { adaptationSet: ct, timing: { startTime: it.start, duration: it.duration } };
            });
          }, lt.prototype.getAdaptationSetIndex = function(nt) {
            var ct = this.findPeriod(nt.periodId);
            return ct && ct.AdaptationSet && ct.AdaptationSet.length !== 0 ? ct.AdaptationSet.findIndex(function(it) {
              return it._internalId.equals(nt);
            }) : -1;
          }, lt.prototype.getAvailableBaseURLsForRepresentation = function(nt) {
            var ct = this.getAdaptationSet(nt);
            if (nt === void 0 || !ct)
              return [];
            for (var it = [], et = ct.Representation, st = 0; st < et.length; st++)
              if (et[st]._internalId.equals(nt) && et[st].BaseURL && et[st].BaseURL.length > 0) {
                it = et[st].BaseURL;
                break;
              }
            var mt = [];
            for (st = 0; st < it.length; st++)
              mt.push((0, fe.forceReallocation)(it[st].url));
            return mt;
          }, lt.prototype.findDownloadedHlsRepresentation = function(nt) {
            var ct = this.getAdaptationSet(nt);
            return ct ? ct.Representation.find(function(it) {
              return it._hls && !!it._hls.requestTimestamp;
            }) : null;
          }, lt.prototype.isManifestFetchRequired = function(nt) {
            if (!this.isHlsManifest())
              return !1;
            var ct = Date.now(), it = this.getRepresentationById(nt), et = !!it.SegmentList && it.SegmentList.length > 0 && !!it.SegmentList[0].SegmentURL, st = et ? it.SegmentList[0].SegmentURL.length : 0, mt = !et || st > 0, St = ct - (it._requestTimestamp || ct), $t = this.isLive() && St >= this.getMinimumUpdatePeriod();
            return !mt || $t;
          }, lt.prototype.hasSelfInitialisingSegments = function() {
            return this.manifest.Period.map(function(nt) {
              return nt.AdaptationSet;
            }).reduce(function(nt, ct) {
              return nt.concat(ct);
            }, []).map(function(nt) {
              return nt.Representation;
            }).reduce(function(nt, ct) {
              return nt.concat(ct);
            }, []).some(function(nt) {
              var ct = nt.SegmentList && nt.SegmentList.length > 0 ? nt.SegmentList : [], it = !!nt.SegmentBase && nt.SegmentBase.length > 0, et = nt.SegmentTemplate && nt.SegmentTemplate.length > 0 ? nt.SegmentTemplate : [];
              return !(nt.init || it || ct.some(function(st) {
                return !!st.init;
              }) || et.some(function(st) {
                return !!st._initialization;
              }));
            });
          }, lt.prototype.getAvailabilityTimeComplete = function(nt) {
            var ct = this.getRepresentationById(nt), it = ct.SegmentList || ct.SegmentBase || ct.SegmentTemplate;
            return !(it && it[0] && it[0]._availabilityTimeComplete) || JSON.parse(it[0]._availabilityTimeComplete);
          }, lt.prototype.isSegmentInfoLoaded = function(nt) {
            var ct = this.getRepresentationById(nt);
            return !!ct && !(!ct.segmentIndex && !ct.segmentIndexParsingError);
          }, lt.prototype.isPrecedingPeriod = function(nt, ct) {
            if (!(nt && ct && this.manifest && this.manifest.Period))
              return !1;
            var it = this.manifest.Period.findIndex(function(st) {
              return st._id === nt;
            }), et = this.manifest.Period.findIndex(function(st) {
              return st._id === ct;
            });
            return it >= 0 && et >= 0 && et < it;
          }, lt.prototype.getMaxSegmentDuration = function() {
            var nt = Ce.DurationConverter.getDurationInSec(this.manifest._maxSegmentDuration);
            return isNaN(nt) ? 0 : nt;
          }, lt.prototype.getDesiredDistanceToLiveEdge = function() {
            var nt, ct = (nt = this.context.serviceManager.get(se.ServiceName.LiveLatencyService)) === null || nt === void 0 ? void 0 : nt.getTargetLatency();
            return (0, we.isDefined)(ct) ? ct : this.context.bufferSettings.getForwardTargetLevel() + this.settings.LIVE_EDGE_DISTANCE;
          }, lt.prototype.hasSuggestedStartPosition = function() {
            return this.manifest.hasOwnProperty("_startOffset");
          }, lt.prototype.getVodStartOffset = function() {
            return Math.max(0, Math.min(this.manifest._startOffset, this.getDuration() - this.settings.SEEK_TO_END_OFFSET));
          }, lt.prototype.getLiveStartOffset = function(nt) {
            nt === void 0 && (nt = !0);
            var ct = this.manifest._startOffset;
            return ct -= Math.abs(this.getTimeShiftBufferDepthSeconds()), nt && (ct += this.getDesiredDistanceToLiveEdge(), ct = Math.min(0, ct)), ct;
          }, lt.prototype.initSegmentStartTimesFromReferenceSegment = function(nt) {
            this.sourceStore.dispatch((0, Ae.initPlaybackTimesFromReferenceSegment)(nt));
          }, lt.prototype.initializeSegmentStartTimesFromStart = function(nt) {
            var ct, it, et = this.getRepresentationById(nt), st = (it = (ct = et == null ? void 0 : et.SegmentList) === null || ct === void 0 ? void 0 : ct[0]) === null || it === void 0 ? void 0 : it.SegmentURL;
            if (et && (st != null && st.length)) {
              var mt = st.length - 1, St = (0, Ee.toSeconds)(et._requestTimestamp) - st[mt]._duration;
              this.context.logger.debug("Initializing segment start times with start time of last segment ".concat(St), nt), this.sourceStore.dispatch((0, Ae.initPlaybackTimesFromIndex)(nt, mt, St));
            } else
              this.context.logger.debug("Failed to initialize segment start times, no segments found", nt);
          }, lt.prototype.hasSegmentStartTimeForHlsRepresentation = function(nt) {
            var ct, it, et, st = this.getRepresentationById(nt);
            return ((et = (it = (ct = st == null ? void 0 : st.SegmentList) === null || ct === void 0 ? void 0 : ct[0]) === null || it === void 0 ? void 0 : it.SegmentURL[0]) === null || et === void 0 ? void 0 : et._playbackTime) !== void 0;
          }, lt.prototype.getStartTimeForHlsSegment = function(nt, ct) {
            var it, et, st, mt, St, $t = this.getRepresentationById(nt), Tt = (st = (et = (it = $t == null ? void 0 : $t.SegmentList) === null || it === void 0 ? void 0 : it[0]) === null || et === void 0 ? void 0 : et.SegmentURL) !== null && st !== void 0 ? st : [], rt = (0, Be.findSegmentUrlIndexWithinSegmentList)(ct, Tt);
            return rt !== -1 && Tt[rt]._playbackTime !== void 0 ? Tt[rt]._playbackTime : (St = (mt = pt(this.manifest)) === null || mt === void 0 ? void 0 : mt.start) !== null && St !== void 0 ? St : void 0;
          }, lt.prototype.isTimeNearPeriodEnd = function(nt, ct, it) {
            var et = this.findPeriod(ct), st = et == null ? void 0 : et.start;
            if (st === void 0)
              return !1;
            var mt = st + this.getPeriodDuration(et._id, this.getAllPeriods());
            return nt >= st && nt <= mt && mt - nt <= it;
          }, lt;
        }(ge.Suspendable);
        function We(ft) {
          return ft.Period == null ? [] : ft.Period.filter(function(lt) {
            return lt.AdaptationSet && lt.AdaptationSet.length > 0;
          }).reduce(function(lt, nt) {
            return lt.concat(nt.AdaptationSet);
          }, []).filter(function(lt) {
            return lt.ContentProtection && lt.ContentProtection.length > 0;
          }).flatMap(function(lt) {
            return lt.ContentProtection;
          }).filter(function(lt) {
            return lt.laurl != null && lt.laurl.length > 0;
          }).flatMap(function(lt) {
            return lt.laurl.map(function(nt) {
              return ce(ce({}, nt), { drmType: ve.DRMSchemeIDURIs[lt._schemeIdUri] });
            });
          }).filter(function(lt) {
            return lt.drmType != null;
          }).map(function(lt) {
            var nt;
            return (nt = {})[lt.drmType] = { LA_URL: lt._licenseUrl }, nt;
          });
        }
        function Xe(ft) {
          var lt;
          return (ft = ce({}, ft)).Period = (lt = ft.Period) === null || lt === void 0 ? void 0 : lt.map(function(nt) {
            var ct;
            return ce(ce({}, nt), { AdaptationSet: (ct = nt.AdaptationSet) === null || ct === void 0 ? void 0 : ct.map(function(it, et) {
              var st, mt = (0, Ue.createAdaptationSetIdFromMimeTypeAndIndex)(nt._id, it._mimeType, et);
              return ce(ce({}, it), { _internalId: mt, _periodId: nt._id, Representation: (st = it.Representation) === null || st === void 0 ? void 0 : st.map(function(St) {
                return ce(ce({}, St), { _internalId: new ke.RepresentationId(mt, St._id) });
              }) });
            }) });
          }), ft;
        }
        function Qe(ft) {
          if (Pe.ModuleManager.has(Me.ModuleName.DRM)) {
            var lt = Pe.ModuleManager.get(Me.ModuleName.DRM).ContentProtectionHelper.getFirstKeyId;
            Je(ft, function(nt) {
              for (var ct = lt(nt.ContentProtection), it = 0; nt.Representation && it < nt.Representation.length; it++) {
                var et = nt.Representation[it];
                (ct || et.ContentProtection) && (et.associatedKid = et.ContentProtection && lt(et.ContentProtection) || ct);
              }
            });
          }
        }
        function tt(ft, lt) {
          ft.Period.flatMap(function(nt) {
            var ct;
            return (ct = nt == null ? void 0 : nt.AdaptationSet) !== null && ct !== void 0 ? ct : [];
          }).flatMap(function(nt) {
            var ct;
            return (ct = nt == null ? void 0 : nt.Representation) !== null && ct !== void 0 ? ct : [];
          }).forEach(function(nt) {
            lt.has(nt._internalId.key()) && (nt.associatedKid = lt.get(nt._internalId.key()));
          });
        }
        function Je(ft, lt) {
          for (var nt = 0; ft.Period && nt < ft.Period.length; nt++)
            for (var ct = ft.Period[nt], it = 0; ct.AdaptationSet && it < ct.AdaptationSet.length; it++)
              lt(ct.AdaptationSet[it]);
        }
        function Ge(ft, lt) {
          if (ft && ft.length) {
            if (lt < ft[0].start)
              return ft[0];
            var nt = ft[ft.length - 1];
            return lt >= nt.start ? nt : Ye(ft, lt) || nt;
          }
        }
        function Ye(ft, lt) {
          for (var nt = ft.length - 1; nt >= 0; nt--) {
            var ct = ft[nt].start + ft[nt].duration;
            if (lt >= ft[nt].start && lt < ct)
              return ft[nt];
            if (lt >= ct && lt < ft[nt + 1].start)
              return ft[nt + 1];
          }
        }
        function ze(ft, lt) {
          return lt === void 0 && (lt = -1 / 0), ft.reduce(function(nt, ct) {
            return ct._bandwidth >= lt ? Math.min(nt, ct._bandwidth) : nt;
          }, 1 / 0);
        }
        function Fe(ft, lt, nt) {
          nt === void 0 && (nt = function() {
            return !0;
          });
          var ct = ft.filter(nt), it = ct.filter(function(et) {
            return et._bandwidth === lt;
          });
          return it.length > 0 ? it : ot(ct, lt);
        }
        function ot(ft, lt) {
          var nt = ft.map(function(ct) {
            return ct._bandwidth;
          }).reduce(function(ct, it) {
            return Math.abs(it - lt) < Math.abs(ct - lt) ? it : ct;
          });
          return ft.filter(function(ct) {
            return ct._bandwidth === nt;
          });
        }
        function vt(ft, lt, nt) {
          ft === void 0 && (ft = []), nt === void 0 && (nt = function() {
            return !0;
          });
          var ct = ft.filter(nt), it = null, et = -1 / 0;
          return ct.forEach(function(st) {
            st._bandwidth > et && st._bandwidth <= lt && (et = st._bandwidth, it = st);
          }), it || ct[0];
        }
        function gt(ft, lt, nt) {
          var ct = nt ? "videoCodecPriority" : "audioCodecPriority";
          return lt != null && lt.options && lt.options[ct] ? lt.options[ct] : ft.playback && ft.playback[ct] ? ft.playback && ft.playback[ct] : [];
        }
        function yt(ft, lt) {
          return { video: gt(ft, lt, !0), audio: gt(ft, lt, !1) };
        }
        function pt(ft) {
          return ft == null ? void 0 : ft.Period[0];
        }
        function bt(ft) {
          var lt = (0, Re.getCodecsFromAdaptationSet)(ft);
          if (!lt || lt.length === 0)
            return null;
          var nt = Se.CodecStringHelper.getExtractedCodecStrings(lt), ct = ft._mimeType.split("/")[0];
          return nt[ct] ? Se.CodecStringHelper.extractCodec(nt[ct]) : null;
        }
        function ut(ft, lt) {
          var nt = [], ct = [];
          return ft.Period.forEach(function(it) {
            var et = lt.getDRMCapabilitiesFromPeriod(it);
            nt = nt.concat(et[0]), ct = ct.concat(et[1]);
          }), { audioCapabilities: nt, videoCapabilities: ct };
        }
        function Ke(ft, lt, nt) {
          ft.Period.forEach(function(ct) {
            ct.AdaptationSet = ct.AdaptationSet.filter(function(it) {
              return it.Representation = it.Representation.filter(function(et) {
                var st = ct.ContentProtection || it.ContentProtection, mt = (st == null ? void 0 : st.length) > 0, St = (0, Ne.getContentTypeFromMimeTypeAndCodecs)(et._mimeType, et._codecs), $t = je(St, lt.audioCapabilities, lt.videoCapabilities);
                return mt && !$t && nt.debug("Representation not supported by MediaKeySystem (".concat(St)), !mt || $t;
              }), !Ie.MimeTypeHelper.isAV(it._mimeType) || it.Representation.length > 0;
            });
          });
        }
        function je(ft, lt, nt) {
          return Ie.MimeTypeHelper.isAudio(ft) ? !!lt.find(function(ct) {
            return ct.contentType === ft;
          }) : !Ie.MimeTypeHelper.isVideo(ft) || !!nt.find(function(ct) {
            return ct.contentType === ft;
          });
        }
        function De(ft) {
          return ft.AdaptationSet.map(function(lt) {
            return lt._mimeType;
          }).filter(function(lt, nt, ct) {
            return Ie.MimeTypeHelper.isAV(lt) && ct.indexOf(lt) === nt;
          });
        }
        function at(ft) {
          return ft.reduce(function(lt, nt) {
            return lt[nt._id] = De(nt), lt;
          }, {});
        }
        function dt(ft) {
          var lt, nt, ct, it, et, st, mt, St;
          return ft != null && ft.SegmentTemplate ? (ct = (nt = (lt = ft.SegmentTemplate[0]) === null || lt === void 0 ? void 0 : lt.SegmentTimeline) === null || nt === void 0 ? void 0 : nt[0]) === null || ct === void 0 ? void 0 : ct.totalDuration : ft != null && ft.Representation ? (St = (mt = (st = (et = (it = ft.Representation[0]) === null || it === void 0 ? void 0 : it.SegmentTemplate) === null || et === void 0 ? void 0 : et[0]) === null || st === void 0 ? void 0 : st.SegmentTimeline) === null || mt === void 0 ? void 0 : mt[0]) === null || St === void 0 ? void 0 : St.totalDuration : void 0;
        }
        ne.ManifestService = He;
      }, 38765: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ce) {
            for (var Ie, Te = 1, Ee = arguments.length; Te < Ee; Te++)
              for (var we in Ie = arguments[Te])
                Object.prototype.hasOwnProperty.call(Ie, we) && (Ce[we] = Ie[we]);
            return Ce;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.TimedMetadataService = void 0;
        var ce = ie(18665), he = ie(60997), _e = ie(62510), le = ie(54861), se = ie(489), oe = ie(76650), ue = ie(28819), be = ie(8272), ve = ie(79814), me = ie(38925), pe = ie(19300), fe = function() {
          function Ce(Ie) {
            var Te, Ee = this;
            this.context = Ie, this.onGenericMetadataAvailable = function(Pe) {
              if (Pe.hasOwnProperty("metadata")) {
                var Me = { metadataType: Pe.metadataType.toUpperCase(), metadata: Pe.metadata };
                (Pe.start || Pe.start === 0) && (Me.start = Pe.start), Pe.end && (Me.end = Pe.end), Ee.context.eventHandler.dispatchEvent(_e.PlayerEvent.Metadata, Me);
              }
            }, this.inbandMetadataCallback = function(Pe) {
              Pe && Pe.hasOwnProperty("metadataType") && Ee.context.eventHandler.dispatchEvent(_e.PlayerEvent.Metadata, { metadataType: Pe.metadataType, metadata: Pe.metadata });
            }, this.onSegmentPlayback = function(Pe) {
              var Me = Pe.metadata.event;
              Ee.currentlyPlayedSegment[Me.mimeType] = Me, Ee.playbackRepresentationId[Me.mimeType] = me.RepresentationId.from(Pe.metadata.representationId), Ee.discontinuityMonitor.maybeFirePeriodSwitchEvents(Me), Ee.previousRepresentationIds[Me.mimeType] && Ee.previousRepresentationIds[Me.mimeType].id === Me.representationId || Ee.handlePlaybackInfo(Me), Ee.context.eventHandler.dispatchEvent(_e.PlayerEvent.SegmentPlayback, Me);
            }, this.previousRepresentationIds = {}, this.playbackRepresentationId = {}, this.currentlyPlayedSegment = {}, this.manifestService = this.context.serviceManager.get(ce.ServiceName.ManifestService, Ie.sourceContext.sourceIdentifier);
            var we = ((Te = {})[se.TimedMetadataType.InBand] = this.inbandMetadataCallback, Te[se.TimedMetadataType.SegmentPlayback] = this.onSegmentPlayback, Te[se.TimedMetadataType.Manifest] = this.onGenericMetadataAvailable, Te[se.TimedMetadataType.EventStream] = this.onGenericMetadataAvailable, Te[se.TimedMetadataType.DateRange] = this.onGenericMetadataAvailable, Te[se.TimedMetadataType.CustomTag] = this.onGenericMetadataAvailable, Te);
            this.metadataService = new le.MetadataService(Ie, we), this.discontinuityMonitor = new pe.DiscontinuityMonitor(Ie);
          }
          return Ce.prototype.clearSegmentBoundMetadata = function(Ie) {
            this.metadataService.removeMatchingCues(se.TimedMetadataType.SegmentPlayback, function(Te) {
              return Te.content.metadata.mimeType === Ie;
            });
          }, Ce.prototype.onSegmentAvailable = function(Ie) {
            var Te, Ee = this, we = Ie.segment, Pe = Ie.extractedMetadata, Me = Ie.isSegmentOfMainStream, Ae = Ie.presentationTimeOffset;
            if (Me) {
              Te = Se(we);
              var Oe = we.getSegmentInfo();
              Oe.metadata && Oe.metadata.forEach(function(Be) {
                Ee.processSegmentInfoMetadata(Be, Te, we.getPeriodId());
              }), ye(Oe) && this.handleCustomMetadata(Oe), this.handleId3Metadata(Pe, Ae, we.getPeriodId());
            } else
              Te = $e(we);
            this.registerSegmentPlaybackEvent(we, Te), we.getInbandEvents().forEach(function(Be) {
              Ee.processInbandEvent(Be, we.getPeriodId());
            }), this.discontinuityMonitor.onSegmentAvailable(we);
          }, Ce.prototype.registerSegmentPlaybackEvent = function(Ie, Te) {
            if (!Ie.isInit()) {
              var Ee = Ie.getSegmentInfo(), we = Ie.getMimeType(), Pe = { metadata: { event: Te, representationId: { _periodId: Ee.internalRepresentationId.periodId, _adaptationSetId: Ee.internalRepresentationId.adaptationSetId, _representationId: Ee.internalRepresentationId.representationId }, mimeType: we } };
              this.metadataService.addToTimeline(se.TimedMetadataType.SegmentPlayback, Te.playbackTime, Pe), (0, ue.getMetricsState)(this.context.store.getState())[we] || this.context.store.dispatch((0, oe.initializeMetricsForMimeType)(we, this.context.settings)), this.context.store.dispatch((0, oe.addMetricsValue)(we, be.MetricType.SegmentInformation, { bitrate: 8 * Ie.getNetworkRequestSize() / Ie.getDuration(), duration: Ie.getDuration(), playbackTime: Ee.startTime || Ie.getPlaybackTime(), representationId: Ie.getRepresentationId() }));
            }
          }, Ce.prototype.parseEventStream = function() {
            var Ie = this;
            this.manifestService.getAllPeriods().forEach(function(Te) {
              Ie.manifestService.getEventStreamEvents(Te).forEach(function(Ee) {
                Ie.processEventStreamEvent(Ee, Te);
              });
            });
          }, Ce.prototype.processEventStreamEvent = function(Ie, Te) {
            var Ee = { metadataType: _e.MetadataType.EVENT_STREAM, metadata: Ie.data, start: Ie.startTime, end: Ie.endTime };
            this.metadataService.addToMetadataParsedService(Ie.startTime, ae(ae({}, Ee), { data: Ie.data }), Te._id), this.metadataService.addToTimeline(se.TimedMetadataType.EventStream, Ie.startTime, Ee);
          }, Ce.prototype.getPlaybackRepresentation = function(Ie) {
            var Te = this.context.serviceManager.get(ce.ServiceName.ManifestService, this.context.sourceContext.sourceIdentifier), Ee = ae({}, Te.getRepresentationById(this.playbackRepresentationId[Ie]));
            return Ee && this.currentlyPlayedSegment[Ie] && (Ee.uid = this.currentlyPlayedSegment[Ie].uid), Ee;
          }, Ce.prototype.handlePlaybackInfo = function(Ie) {
            var Te, Ee;
            ve.MimeTypeHelper.isAudio(Ie.mimeType) ? (Te = _e.PlayerEvent.AudioPlaybackQualityChanged, Ee = { id: Ie.representationId, bitrate: parseFloat(Ie.mediaInfo.bitrate) }) : ve.MimeTypeHelper.isVideo(Ie.mimeType) && (Te = _e.PlayerEvent.VideoPlaybackQualityChanged, Ee = { id: Ie.representationId, bitrate: parseFloat(Ie.mediaInfo.bitrate), width: parseFloat(Ie.mediaInfo.width), height: parseFloat(Ie.mediaInfo.height) }), Te && this.context.eventHandler.dispatchEvent(Te, { targetQuality: Ee, sourceQuality: this.previousRepresentationIds[Ie.mimeType] || null }), this.previousRepresentationIds[Ie.mimeType] = Ee;
          }, Ce.prototype.processDateRangeEvent = function(Ie, Te) {
            var Ee = { metadataType: _e.MetadataType.DATERANGE, metadata: Ie.data, start: Ie.startTime, end: Ie.endTime };
            this.metadataService.addToMetadataParsedService(Ie.startTime, ae(ae({}, Ee), { data: Ie.data }), Te), this.metadataService.addToTimeline(se.TimedMetadataType.DateRange, Ie.startTime, Ee);
          }, Ce.prototype.addSegmentToMetadataParsedService = function(Ie, Te) {
            var Ee = this;
            Ie.forEach(function(we) {
              if (we._metadata && we._metadata.length > 0 && we._playbackTime) {
                var Pe = { metadataType: _e.MetadataType.CUSTOM, metadata: we._metadata, data: we._metadata, start: we._playbackTime, end: we._playbackTime + we._duration };
                Ee.metadataService.addToMetadataParsedService(we._playbackTime, Pe, Te);
              }
            });
          }, Ce.prototype.handleId3Metadata = function(Ie, Te, Ee) {
            var we = this;
            Ie && Array.isArray(Ie.id3) && Ie.id3.length > 0 && Ie.id3.forEach(function(Pe) {
              we.publishId3Metadata(Pe, Te, Ee);
            });
          }, Ce.prototype.publishId3Metadata = function(Ie, Te, Ee) {
            var we = Ie.presentationTime - Te, Pe = { metadataType: _e.MetadataType.ID3, metadata: Ie.data, start: we };
            this.metadataService.addToMetadataParsedService(we, ae(ae({}, Pe), { data: Ie.data }), Ee), this.metadataService.addToTimeline(se.TimedMetadataType.InBand, we, Pe);
          }, Ce.prototype.handleCustomMetadata = function(Ie) {
            var Te = this, Ee = this.manifestService.getRepresentationById(Ie.internalRepresentationId);
            Ee.SegmentList[0].SegmentURL.forEach(function(we, Pe) {
              we._media === Ie.url && (we._playbackTime || ge(Ee.SegmentList[0].SegmentURL, Pe, Ie.startTime), Te.metadataService.addToTimeline(se.TimedMetadataType.CustomTag, Ie.startTime, { metadataType: _e.MetadataType.CUSTOM, metadata: we._metadata, start: Ie.startTime, end: Ie.startTime + Ie.duration }));
            }), this.addSegmentToMetadataParsedService(Ee.SegmentList[0].SegmentURL, Ie.periodId);
          }, Ce.prototype.processInbandEvent = function(Ie, Te) {
            var Ee = Ie.presentationTime, we = { metadataType: _e.MetadataType.EMSG, metadata: Ie, start: Ee };
            this.metadataService.addToMetadataParsedService(Ee, ae(ae({}, we), { data: Ie }), Te), this.metadataService.addToTimeline(se.TimedMetadataType.InBand, Ee, we);
          }, Ce.prototype.processSegmentInfoMetadata = function(Ie, Te, Ee) {
            var we = Ie.type;
            if (we === _e.MetadataType.CUSTOM)
              Te.EXPERIMENTAL = Te.EXPERIMENTAL || {}, Te.EXPERIMENTAL.hlsAttributes = Te.EXPERIMENTAL.hlsAttributes || [], Te.EXPERIMENTAL.hlsAttributes = Te.EXPERIMENTAL.hlsAttributes.concat(Ie.attributes);
            else {
              var Pe = { metadataType: /^CUE-(IN|OUT(-CONT)?)$/.test(we) ? _e.MetadataType.CUETAG : _e.MetadataType[Ie.type], metadata: Ie, start: Te.playbackTime };
              this.metadataService.addToMetadataParsedService(Pe.start, ae(ae({}, Pe), { data: Ie }), Ee), this.metadataService.addToTimeline(se.TimedMetadataType.Manifest, Pe.start, Pe);
            }
          }, Ce.prototype.dispose = function() {
            this.metadataService = (0, he.dispose)(this.metadataService), this.manifestService = null, this.discontinuityMonitor = (0, he.dispose)(this.discontinuityMonitor);
          }, Ce;
        }();
        function ge(Ce, Ie, Te) {
          for (var Ee = Ie, we = Te; Ee >= 0; )
            Ce[Ee]._playbackTime = we, we -= Ce[Ee]._duration, Ee--;
          for (Ee = Ie + 1, we = Te + Ce[Ie]._duration; Ee < Ce.length; )
            Ce[Ee]._playbackTime = we, we += Ce[Ee]._duration, Ee++;
        }
        function ye(Ce) {
          return Ce.metadata && Ce.metadata.length > 0 && Ce.metadata[0].type === _e.MetadataType.CUSTOM;
        }
        function $e(Ce) {
          var Ie = Ce.getSegmentInfo();
          return { uid: btoa(Ce.getUrl()), url: Ce.getUrl(), mimeType: Ce.getMimeType(), playbackTime: Ce.getPlaybackTime(), presentationTimestamp: Ce.getBaseMediaDecodeTime() / Ce.getTimescale(), duration: Ce.getDuration(), mediaInfo: Ce.getMediaInfo(), wallClockTime: Ie.wallClockTime, discontinuitySequenceNumber: Ie.discontinuitySequenceNumber };
        }
        function Se(Ce) {
          var Ie = $e(Ce), Te = Ce.getSegmentInfo();
          return Te.dateTime && (Ie.dateTime = Te.dateTime), Te.representationId && (Ie.representationId = Te.representationId), Ie;
        }
        ne.TimedMetadataService = fe;
      }, 38925: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var _e = function(le, se) {
            return _e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(oe, ue) {
              oe.__proto__ = ue;
            } || function(oe, ue) {
              for (var be in ue)
                Object.prototype.hasOwnProperty.call(ue, be) && (oe[be] = ue[be]);
            }, _e(le, se);
          };
          return function(le, se) {
            if (typeof se != "function" && se !== null)
              throw new TypeError("Class extends value " + String(se) + " is not a constructor or null");
            function oe() {
              this.constructor = le;
            }
            _e(le, se), le.prototype = se === null ? Object.create(se) : (oe.prototype = se.prototype, new oe());
          };
        }();
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.RepresentationId = void 0;
        var ce = ie(67883), he = function(_e) {
          function le(se, oe) {
            var ue = _e.call(this, se.periodId, se.adaptationSetId) || this;
            return ue._representationId = oe, ue;
          }
          return ae(le, _e), Object.defineProperty(le.prototype, "representationId", { get: function() {
            return this._representationId;
          }, enumerable: !1, configurable: !0 }), le.prototype.equals = function(se) {
            return _e.prototype.equals.call(this, se) && this.representationId === (se == null ? void 0 : se.representationId);
          }, le.prototype.key = function() {
            return _e.prototype.key.call(this) + "-" + this.representationId;
          }, le.from = function(se) {
            return se._representationId && se._adaptationSetId && se._periodId ? new le(new ce.AdaptationSetId(se._periodId, se._adaptationSetId), se._representationId) : null;
          }, le;
        }(ce.AdaptationSetId);
        ne.RepresentationId = he;
      }, 40392: function(ee, ne) {
        function ie(ae) {
          return 8 * ae;
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.bytesToBits = ie;
      }, 41661: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentCache = void 0, ne.areSegmentsIdentical = _e;
        var ae = ie(81361), ce = ie(86865), he = function() {
          function le(se) {
            this.maxSize = Math.max(0, se), this.cache = [];
          }
          return le.prototype.contains = function(se) {
            return this.cache.some(function(oe) {
              return _e(se.getSegmentInfo(), oe.getSegmentInfo());
            });
          }, le.prototype.maintainCacheSize = function(se) {
            this.cache = se !== 0 ? this.cache.slice(-se) : [];
          }, le.prototype.add = function(se) {
            this.contains(se) || (this.cache.push(se), this.maintainCacheSize(this.maxSize));
          }, le.prototype.get = function(se) {
            return this.cache.find(function(oe) {
              return _e(se, oe.getSegmentInfo());
            });
          }, le.prototype.clear = function() {
            this.maintainCacheSize(0);
          }, le.prototype.remove = function(se) {
            this.cache = this.cache.filter((0, ae.invert)(se));
          }, le.prototype.getCapacity = function() {
            return this.maxSize;
          }, le.prototype.getCachedCount = function() {
            return this.cache.length;
          }, le.prototype.getCachedSegments = function() {
            return this.cache.slice(0);
          }, le;
        }();
        function _e(le, se) {
          return (le.isInitSegment ? ["url", "periodId", "byteRange", "representationId"] : ["url", "periodId", "byteRange", "discontinuitySequenceNumber"]).every(function(oe) {
            return typeof le[oe] == "object" ? (0, ce.compareValues)(le[oe], se[oe]) : le[oe] === se[oe];
          });
        }
        ne.SegmentCache = he;
      }, 41735: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.setManifestAction = he, ne.setManifestInitializedAction = _e, ne.removeRepresentationsAction = le, ne.updateManifestAction = se, ne.updateAdaptationSetAction = oe, ne.updateRepresentationAction = ue, ne.updatePeriodTimingAction = be, ne.adjustPeriodStartTimes = ve, ne.setRepresentationDrmKidAction = me, ne.updateRepresentationFailedDownloadAction = pe, ne.setRepresentationSegmentIndexAction = fe, ne.setRepresentationIsLoadingAction = ge, ne.setRepresentationSegmentIndexParsingErrorAction = ye, ne.setRepresentationAnchorPointAction = $e, ne.initPlaybackTimesFromIndex = Se, ne.initPlaybackTimesFromReferenceSegment = Ce, ne.resetSegmentPlaybackTimes = Ie;
        var ae = ie(15231), ce = ie(77329);
        function he(Te) {
          return (0, ae.createAction)(ce.ManifestActionType.SetManifest, { manifest: Te });
        }
        function _e(Te) {
          return (0, ae.createAction)(ce.ManifestActionType.SetManifestInitialized, { isInitialized: Te });
        }
        function le(Te) {
          return (0, ae.createAction)(ce.ManifestActionType.RemoveRepresentations, { representationIds: Te });
        }
        function se(Te) {
          return (0, ae.createAction)(ce.ManifestActionType.UpdateManifest, Te);
        }
        function oe(Te, Ee) {
          return (0, ae.createAction)(ce.ManifestActionType.UpdateAdaptationSet, { adaptationSetId: Te, updates: Ee });
        }
        function ue(Te) {
          return (0, ae.createAction)(ce.ManifestActionType.UpdateRepresentation, Te);
        }
        function be(Te, Ee) {
          return (0, ae.createAction)(ce.ManifestActionType.UpdatePeriodTiming, { periodId: Te, timing: Ee });
        }
        function ve(Te) {
          return (0, ae.createAction)(ce.ManifestActionType.AdjustPeriodStartTimes, { offset: Te });
        }
        function me(Te, Ee) {
          return (0, ae.createAction)(ce.ManifestActionType.SetRepresentationDrmKid, { representationId: Te, associatedKid: Ee });
        }
        function pe(Te, Ee) {
          return (0, ae.createAction)(ce.ManifestActionType.UpdateRepresentationFailedDownload, { representationId: Te, loadFailureReason: Ee });
        }
        function fe(Te, Ee) {
          return (0, ae.createAction)(ce.ManifestActionType.SetRepresentationSegmentIndex, { representationId: Te, segmentIndex: Ee });
        }
        function ge(Te, Ee) {
          return (0, ae.createAction)(ce.ManifestActionType.SetRepresentationIsLoading, { representationId: Te, isLoading: Ee });
        }
        function ye(Te, Ee) {
          return (0, ae.createAction)(ce.ManifestActionType.SetRepresentationSegmentIndexParsingError, { representationId: Te, segmentIndexParsingError: Ee });
        }
        function $e(Te, Ee) {
          return (0, ae.createAction)(ce.ManifestActionType.SetRepresentationAnchorPoint, { representationId: Te, anchorPoint: Ee });
        }
        function Se(Te, Ee, we) {
          return (0, ae.createAction)(ce.ManifestActionType.InitPlaybackTimesFromIndex, { representationId: Te, index: Ee, playbackTimeForIndex: we });
        }
        function Ce(Te) {
          return (0, ae.createAction)(ce.ManifestActionType.InitPlaybackTimesFromReferenceSegment, { representationId: Te.getRepresentationId(), segmentUrl: Te.getUrl(), segmentPlaybackTime: Te.getPlaybackTime(), discontinuitySequenceNumber: Te.getSegmentInfo().discontinuitySequenceNumber });
        }
        function Ie() {
          return (0, ae.createAction)(ce.ManifestActionType.ResetSegmentPlaybackTimes);
        }
      }, 42346: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(we) {
            for (var Pe, Me = 1, Ae = arguments.length; Me < Ae; Me++)
              for (var Oe in Pe = arguments[Me])
                Object.prototype.hasOwnProperty.call(Pe, Oe) && (we[Oe] = Pe[Oe]);
            return we;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentStore = ne.INITIAL_BUFFER_BLOCK_ID = void 0;
        var ce = ie(96873), he = ie(33669), _e = ie(27279), le = ie(42283), se = ie(3941), oe = ie(80043), ue = ie(79814), be = ie(91520), ve = ie(16368), me = ie(16280), pe = ie(22645), fe = ie(55937), ge = ie(73022), ye = ie(19724);
        ne.INITIAL_BUFFER_BLOCK_ID = 0;
        var $e = 0.01, Se = function() {
          function we(Pe, Me) {
            this.context = Pe, this.delayedSegmentQueue = [], this.requiredMediaTypes = {}, this.delayedMediaTypeToUpdate = {}, this.delayedMediaTypeToSet = {};
            var Ae = new fe.BufferBlock(ne.INITIAL_BUFFER_BLOCK_ID);
            this.requiredMediaTypes = {}, this.segregation = new ye.Segregation(this.requiredMediaTypes, Me), this.bufferBlocks = [Ae];
          }
          return we.prototype.getBufferBlockByPeriodId = function(Pe) {
            return this.bufferBlocks.find(function(Me) {
              return Me.getPeriodId() === Pe;
            });
          }, we.prototype.hasSegmentsForBufferBlock = function(Pe) {
            return this.getAllSegmentsFromBufferBlock(Pe).hasNext();
          }, we.prototype.hasDataSegmentsForBufferBlock = function(Pe) {
            return Object.keys(Pe.mediaTypes).filter(function(Me) {
              return ue.MimeTypeHelper.isAV(Me);
            }).every(function(Me) {
              return Pe.hasDataSegments(Me);
            });
          }, we.prototype.getTargetBufferBlock = function(Pe, Me) {
            return this.getBufferBlockForPlaybackTime(Pe) || this.getClosestFutureBufferBlock(Pe) || this.getBufferBlockByPeriodId(Me);
          }, we.prototype.canSwitchToBufferBlock = function(Pe) {
            if (!Pe)
              return !1;
            var Me = this.areBufferBlockMediaTypesFinal(Pe);
            return this.hasDataSegmentsForBufferBlock(Pe) && Me;
          }, we.prototype.canSwitchToBufferBlockForTime = function(Pe) {
            var Me = this.getBufferBlockForPlaybackTime(Pe);
            return this.canSwitchToBufferBlock(Me);
          }, we.prototype.areBufferBlockMediaTypesFinalForPeriod = function(Pe) {
            var Me = this.getBufferBlockByPeriodId(Pe);
            return this.areBufferBlockMediaTypesFinal(Me);
          }, we.prototype.areBufferBlockMediaTypesFinal = function(Pe) {
            var Me = this;
            if (!Pe || !Pe.mediaTypes || Object.keys(Pe.mediaTypes).length === 0)
              return !1;
            var Ae = Pe.getPeriodId();
            if (this.requiredMediaTypes[Ae] === void 0)
              return !1;
            var Oe = Object.keys(Pe.mediaTypes);
            return Object.keys(this.requiredMediaTypes[Ae]).filter(function(Be) {
              return ue.MimeTypeHelper.isAV(Be);
            }).every(function(Be) {
              var Ve;
              return Oe.includes(Be) && ((Ve = Me.requiredMediaTypes[Ae][Be]) === null || Ve === void 0 ? void 0 : Ve.codec);
            });
          }, we.prototype.addRequiredMediaType = function(Pe, Me) {
            var Ae = this.getBufferBlockByPeriodId(Pe);
            this.requiredMediaTypes[Pe] || (this.requiredMediaTypes[Pe] = {}), this.requiredMediaTypes[Pe][Me] || (this.requiredMediaTypes[Pe][Me] = { mimeType: Me, codec: null, timestampOffset: 0 }), Ae ? Ae.mediaTypes[Me] || Ae.addMediaType({ mimeType: Me, codec: null, timestampOffset: 0 }) : (this.delayedMediaTypeToSet[Pe] || (this.delayedMediaTypeToSet[Pe] = {}), this.delayedMediaTypeToSet[Pe][Me] = { mimeType: Me, codec: null, timestampOffset: 0 });
          }, we.prototype.changeMediaType = function(Pe, Me) {
            var Ae = this, Oe = Object.keys(this.requiredMediaTypes), Be = Me;
            Oe.forEach(function(Ve) {
              Me || (Be = Object.keys(Ae.requiredMediaTypes[Ve]).find(function(Ue) {
                return ue.MimeTypeHelper.getMediaType(Ue) === ue.MimeTypeHelper.getMediaType(Pe);
              })), Ae.removeRequiredMediaType(Ve, Be), Ae.addRequiredMediaType(Ve, Pe);
            });
          }, we.prototype.removeRequiredMediaType = function(Pe, Me) {
            if (this.requiredMediaTypes[Pe]) {
              delete this.requiredMediaTypes[Pe][Me];
              var Ae = this.getBufferBlockByPeriodId(Pe);
              Ae && Ae.removeMediaType(Me);
            }
            this.delayedMediaTypeToSet[Pe] && delete this.delayedMediaTypeToSet[Pe][Me], this.clearSegments(Me);
          }, we.prototype.updateRequiredMediaTypes = function(Pe, Me) {
            var Ae;
            if (this.requiredMediaTypes[Pe]) {
              var Oe = this.requiredMediaTypes[Pe][Me.mimeType];
              this.requiredMediaTypes[Pe][Me.mimeType] = ae(ae({}, Oe), Me);
            } else
              this.requiredMediaTypes[Pe] = ((Ae = {})[Me.mimeType] = Me, Ae);
          }, we.prototype.updateMediaType = function(Pe, Me) {
            var Ae;
            this.updateRequiredMediaTypes(Pe, Me);
            var Oe = this.getBufferBlockByPeriodId(Pe);
            Oe != null && Oe.hasMediaType(Me.mimeType) ? Oe.updateMediaTypeForMimeType(Me) : this.delayedMediaTypeToUpdate[Pe] = ae(ae({}, this.delayedMediaTypeToUpdate[Pe] || {}), ((Ae = {})[Me.mimeType] = Me, Ae));
          }, we.prototype.updateDelayedMediaType = function(Pe) {
            var Me = Pe.getPeriodId(), Ae = Pe.getMimeType();
            this.delayedMediaTypeToSet[Me] && this.delayedMediaTypeToSet[Me][Ae] && (this.addRequiredMediaType(Me, Ae), delete this.delayedMediaTypeToSet[Me][Ae]), this.delayedMediaTypeToUpdate[Me] && this.delayedMediaTypeToUpdate[Me][Ae] && (this.updateMediaType(Me, this.delayedMediaTypeToUpdate[Me][Ae]), delete this.delayedMediaTypeToUpdate[Me][Ae]);
          }, we.prototype.findBestMatchingBufferBlockForSegment = function(Pe, Me) {
            var Ae = this;
            if (this.bufferBlocks.length === 1 && this.segregation.canAddSegmentToBufferBlock(Pe, this.bufferBlocks[0], Me))
              return this.bufferBlocks[0];
            var Oe = this.bufferBlocks.reduce(function(xe, ke) {
              return Ae.segregation.canAddSegmentToBufferBlock(Pe, ke, Me) && (!xe || ke.getMinDistanceFromBufferBlock(Pe) < xe.getMinDistanceFromBufferBlock(Pe)) ? ke : xe;
            }, void 0);
            if (Oe) {
              var Be = Oe.getCommonPlaybackTimeRanges(), Ve = Pe.getPlaybackTime(), Ue = Ce(this.bufferBlocks.filter(function(xe) {
                return xe !== Oe;
              })), Re = Te(Be.start, Ue), Ne = Ie(Be.end, Ue);
              if (Re <= Ve && Ve <= Ne && !this.isTimeInOrBeyondFutureIncompatibleBufferBlock(Ve, Oe, Ue))
                return Oe;
            }
          }, we.prototype.isTimeInOrBeyondFutureIncompatibleBufferBlock = function(Pe, Me, Ae) {
            return Ae.filter(function(Oe) {
              return isFinite(Oe.range.start) && Oe.range.start > Me.getCommonPlaybackTimeRanges().start && isFinite(Oe.range.end) && Oe.range.end > Me.getCommonPlaybackTimeRanges().end;
            }).some(function(Oe) {
              var Be = Oe.range.start <= Pe && Pe <= Oe.range.end, Ve = Pe > Oe.range.end;
              return Be || Ve;
            });
          }, we.prototype.areAllMimeTypesAvailableInQueue = function(Pe) {
            var Me = this;
            return Object.keys(this.requiredMediaTypes[se.DEFAULT_PERIOD_ID]).filter(function(Ae) {
              return ue.MimeTypeHelper.isAV(Ae);
            }).every(function(Ae) {
              return Me.delayedSegmentQueue.some(function(Oe) {
                return Oe.getSegmentInfo().discontinuitySequenceNumber === Pe && Oe.getMimeType() === Ae;
              });
            });
          }, we.prototype.areDiscontinuitiesMisaligned = function(Pe) {
            var Me, Ae = (Me = (0, _e.getSourceState)(this.context)) === null || Me === void 0 ? void 0 : Me.hls;
            return !!Ae && (0, be.ModuleManager.get(ve.ModuleName.HLS).selectors.areDiscontinuitiesMisaligned)(Ae, Object.keys(this.requiredMediaTypes[se.DEFAULT_PERIOD_ID]).filter(function(Oe) {
              return ue.MimeTypeHelper.isAV(Oe);
            }), Pe.getDuration());
          }, we.prototype.addSegment = function(Pe) {
            var Me = this, Ae = Pe.getSegmentInfo(), Oe = Ae.codecs, Be = Ae.discontinuitySequenceNumber;
            if (!(0, le.isAVMuxedTogether)(Oe) && Ee(Pe, this.bufferBlocks))
              if (this.delayedSegmentQueue.push(Pe), this.context.logger.debug("[SegmentStore] Delay adding ".concat(Pe.getMimeType(), " segment of disco ").concat(Be, " until another segment of the other type is available"), { url: Pe.getUrl() }), this.areAllMimeTypesAvailableInQueue(Be)) {
                var Ve = this.delayedSegmentQueue.filter(function(Ue) {
                  return Ue.getSegmentInfo().discontinuitySequenceNumber === Be;
                });
                this.context.logger.debug("[SegmentStore] Discontinuity ".concat(Be, " is complete: adding segments to store")), this.pushToBufferBlocks(Ve), this.delayedSegmentQueue = this.delayedSegmentQueue.filter(function(Ue) {
                  return Ue.getSegmentInfo().discontinuitySequenceNumber !== Be;
                });
              } else
                this.areDiscontinuitiesMisaligned(Pe) && (this.context.logger.debug("[SegmentStore] Detected misaligned discontinuities: flushing all delayed segments"), this.delayedSegmentQueue.forEach(function(Ue) {
                  return Me.pushToBufferBlocks([Ue]);
                }), this.delayedSegmentQueue = []);
            else
              this.pushToBufferBlocks([Pe]);
          }, we.prototype.pushToBufferBlocks = function(Pe) {
            var Me = this, Ae = Pe.reduce(function(Oe, Be) {
              var Ve = Me.segregation.getSegregationCriteria(Be), Ue = Me.findBestMatchingBufferBlockForSegment(Be, Ve);
              return Oe === null ? Ue : Ue !== Oe ? void 0 : Ue;
            }, null);
            Ae || (Ae = this.createNewBufferBlock(), this.bufferBlocks.push(Ae)), Pe.forEach(function(Oe) {
              var Be = Me.segregation.getSegregationCriteria(Oe);
              Me.context.logger.debug("[SegmentStore] Added ".concat(Oe.getMimeType(), " segment to BB with ID ").concat(Ae.getId()), { segment: Oe.getUrl(), segmentCriteria: Be });
              var Ve = (0, _e.getSourceStore)(Me.context), Ue = (0, pe.getTrackIdentifier)(Oe.getSegmentInfo());
              Ve == null || Ve.dispatch((0, ce.removeLoadedRange)(Ue, (0, me.segmentToBufferBlockTimeRange)(Oe))), Ae.addSegment(Oe), Ve == null || Ve.dispatch((0, ce.addLoadedRange)(Ue, (0, me.segmentToBufferBlockTimeRange)(Oe))), Ae.getSegregationCriteria(Oe.getMimeType()) || Ae.setSegregationCriteria(Be, Oe.getMimeType()), Me.updateDelayedMediaType(Oe);
            });
          }, we.prototype.getNewBufferBlockId = function() {
            var Pe = this.bufferBlocks[this.bufferBlocks.length - 1];
            return Pe ? Pe.getId() + 1 : ne.INITIAL_BUFFER_BLOCK_ID;
          }, we.prototype.createNewBufferBlock = function() {
            var Pe = this.getNewBufferBlockId();
            return this.context.logger.debug("[SegmentStore] creating new BB with ID ".concat(Pe)), new fe.BufferBlock(Pe);
          }, we.prototype.getMediaTypes = function(Pe) {
            var Me = this;
            return Pe && this.requiredMediaTypes[Pe] ? Object.keys(this.requiredMediaTypes[Pe]).map(function(Ae) {
              return Me.requiredMediaTypes[Pe][Ae];
            }) : [];
          }, we.prototype.getAllBufferBlocks = function() {
            return this.bufferBlocks;
          }, we.prototype.getCurrentBufferBlockId = function() {
            var Pe, Me = this.bufferBlocks[0];
            return (Pe = Me == null ? void 0 : Me.getId()) !== null && Pe !== void 0 ? Pe : ne.INITIAL_BUFFER_BLOCK_ID;
          }, we.prototype.deleteOldBufferBlocks = function(Pe) {
            this.bufferBlocks = this.bufferBlocks.filter(function(Me) {
              return Me.getId() >= Pe && Me.getAllSegments().length > 0;
            });
          }, we.prototype.getActiveBufferBlock = function() {
            var Pe;
            return (Pe = this.getBufferBlock(this.getCurrentBufferBlockId())) !== null && Pe !== void 0 ? Pe : null;
          }, we.prototype.getBufferBlock = function(Pe) {
            return this.bufferBlocks.find(function(Me) {
              return Me.getId() === Pe;
            });
          }, we.prototype.getBufferBlockForSegment = function(Pe) {
            return this.getBufferBlock(Pe.getBufferBlockId());
          }, we.prototype.getBufferBlockForPlaybackTime = function(Pe) {
            var Me = this, Ae = this.bufferBlocks.filter(function(Oe) {
              var Be = Pe === 0 ? Me.getSmallestMaxSegmentDuration(Oe) - $e : $e;
              return Object.keys(Oe.mediaTypes).filter(function(Ve) {
                return ue.MimeTypeHelper.isAV(Ve);
              }).every(function(Ve) {
                var Ue, Re;
                return ((Ue = Oe.getPlaybackTimeRange(Ve)) === null || Ue === void 0 ? void 0 : Ue.start) <= Pe + Be && ((Re = Oe.getPlaybackTimeRange(Ve)) === null || Re === void 0 ? void 0 : Re.end) >= Pe;
              });
            });
            return Ae[Ae.length - 1];
          }, we.prototype.getClosestFutureBufferBlock = function(Pe) {
            return this.bufferBlocks.filter(function(Me) {
              return Me.getMinCommonStartTime() >= Pe;
            }).sort(function(Me, Ae) {
              return Me.getMinCommonStartTime() - Ae.getMinCommonStartTime();
            })[0];
          }, we.prototype.getNextSegment = function() {
            var Pe, Me;
            return (Me = (Pe = this.getActiveBufferBlock()) === null || Pe === void 0 ? void 0 : Pe.getNextSegment()) !== null && Me !== void 0 ? Me : null;
          }, we.prototype.removeSegment = function(Pe) {
            var Me = this.getBufferBlockForSegment(Pe);
            Me && Me.removeSegment(Pe), this.delayedSegmentQueue = this.delayedSegmentQueue.filter(function(Ae) {
              return Ae !== Pe;
            });
          }, we.prototype.getAllSegmentsFromBufferBlock = function(Pe, Me) {
            if (!Pe)
              return oe.EmptyIterator.getInstance();
            var Ae = Pe.getAllSegments();
            return Me ? new oe.FilterIterator(new oe.ArrayIterator(Ae), function(Oe) {
              return Oe.getMimeType() === Me;
            }) : new oe.ArrayIterator(Ae);
          }, we.prototype.getNextBufferBlock = function(Pe) {
            return this.bufferBlocks.find(function(Me) {
              return Me.getId() > Pe;
            });
          }, we.prototype.getFutureBufferBlocks = function(Pe) {
            return this.bufferBlocks.filter(function(Me) {
              return Me.getId() >= Pe;
            });
          }, we.prototype.getPrecedingSegments = function(Pe, Me) {
            var Ae = this.delayedSegmentQueue.filter(function(Oe) {
              return (0, fe.isPrecedingSegment)(Oe, Pe, Me);
            });
            return this.bufferBlocks.flatMap(function(Oe) {
              return Oe.getPrecedingSegments(Pe, Me);
            }).concat(Ae);
          }, we.prototype.clearSegments = function(Pe) {
            this.context.logger.debug("[SegmentStore] clearing all segments for ".concat(Pe)), this.bufferBlocks.forEach(function(Me) {
              return Me.clearSegments(Pe);
            }), this.delayedSegmentQueue = this.delayedSegmentQueue.filter(function(Me) {
              return Me.getMimeType() !== Pe;
            });
          }, we.prototype.getSmallestMaxSegmentDuration = function(Pe) {
            return Pe && Pe.hasMaxSegmentDurations() ? Pe.getMinMaxSegmentDuration() : -1;
          }, we.prototype.getSmallestSafeBufferSize = function(Pe, Me) {
            var Ae = this.getBufferBlockForPlaybackTime(Pe);
            return Ae != null && Ae.hasMaxSegmentDuration(Me) ? Ae.getMaxSegmentDuration(Me) + 1 : 1;
          }, we.prototype.getAvailablePositionForTime = function(Pe, Me) {
            var Ae = Pe;
            if (Me && Pe > Me) {
              var Oe = this.getBufferBlockForPlaybackTime(Pe);
              Oe || (Oe = this.getClosestFutureBufferBlock(Pe)) && (Ae = Oe.getMinCommonStartTime());
            }
            return Ae;
          }, we.prototype.getPlaybackTimesForBufferBlock = function(Pe, Me) {
            var Ae = this, Oe = this.getBufferBlock(Pe);
            return Me.map(function(Be) {
              var Ve = new oe.FilterIterator(Ae.getAllSegmentsFromBufferBlock(Oe, Be), function(Ue) {
                return !Ue.isInit();
              });
              return Ve.hasNext() ? Ve.next().getPlaybackTime() : -1 / 0;
            });
          }, we.prototype.isLoadingNextBufferBlock = function(Pe) {
            var Me = this.getNextBufferBlock(Pe);
            return !!Me && this.hasDataSegmentsForBufferBlock(Me);
          }, we.prototype.shouldSwitchBufferBlock = function(Pe, Me) {
            return !(0, ge.areBufferBlocksEqual)(Pe, this.getBufferBlock(Me));
          }, we.prototype.getSegmentStoreRangesMap = function(Pe, Me) {
            var Ae = {};
            return Me.forEach(function(Oe) {
              return Ae[Oe] = [];
            }), this.getFutureBufferBlocks(this.getCurrentBufferBlockId()).map(function(Oe) {
              return Oe.getId();
            }).concat(1 / 0).map(function(Oe) {
              return (0, he.getBufferBlockLoadedRanges)(Pe, Oe);
            }).forEach(function(Oe) {
              return Object.keys(Oe).forEach(function(Be) {
                return Ae[Be].push(Oe[Be]);
              });
            }), Ae;
          }, we;
        }();
        function Ce(we) {
          return we.map(function(Pe) {
            return { range: Pe.getCommonPlaybackTimeRanges(), block: Pe };
          }).sort(function(Pe, Me) {
            return Pe.range.start - Me.range.start;
          });
        }
        function Ie(we, Pe) {
          return Pe.reduce(function(Me, Ae) {
            return Ae.range.start >= we ? Math.min(Ae.range.start, Me) : Me;
          }, 1 / 0);
        }
        function Te(we, Pe) {
          return Pe.reduce(function(Me, Ae) {
            return Ae.range.end <= we ? Math.max(Ae.range.start, Me) : Me;
          }, -1 / 0);
        }
        function Ee(we, Pe) {
          var Me = we.getSegmentInfo().discontinuitySequenceNumber;
          return Me !== void 0 && !Pe.some(function(Ae) {
            return Ae.hasTrackedDiscontinuity(Me);
          });
        }
        ne.SegmentStore = Se;
      }, 43412: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var $e = function(Se, Ce) {
            return $e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ie, Te) {
              Ie.__proto__ = Te;
            } || function(Ie, Te) {
              for (var Ee in Te)
                Object.prototype.hasOwnProperty.call(Te, Ee) && (Ie[Ee] = Te[Ee]);
            }, $e(Se, Ce);
          };
          return function(Se, Ce) {
            if (typeof Ce != "function" && Ce !== null)
              throw new TypeError("Class extends value " + String(Ce) + " is not a constructor or null");
            function Ie() {
              this.constructor = Se;
            }
            $e(Se, Ce), Se.prototype = Ce === null ? Object.create(Ce) : (Ie.prototype = Ce.prototype, new Ie());
          };
        }(), ce = this && this.__decorate || function($e, Se, Ce, Ie) {
          var Te, Ee = arguments.length, we = Ee < 3 ? Se : Ie === null ? Ie = Object.getOwnPropertyDescriptor(Se, Ce) : Ie;
          if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
            we = Reflect.decorate($e, Se, Ce, Ie);
          else
            for (var Pe = $e.length - 1; Pe >= 0; Pe--)
              (Te = $e[Pe]) && (we = (Ee < 3 ? Te(we) : Ee > 3 ? Te(Se, Ce, we) : Te(Se, Ce)) || we);
          return Ee > 3 && we && Object.defineProperty(Se, Ce, we), we;
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ManifestUpdateScheduler = void 0, ne.isRepresentationUpToDate = ye;
        var he = ie(28764), _e = ie(18665), le = ie(90637), se = ie(16937), oe = ie(76420), ue = ie(3464), be = ie(34731), ve = ie(331), me = ie(41735), pe = ie(61743), fe = ie(35655), ge = function($e) {
          function Se(Ce, Ie) {
            var Te = $e.call(this, { onSuspend: function() {
              return Te.onSuspend();
            }, onRestore: function() {
              return Te.onRestore();
            } }) || this;
            Te.initiated = !1, Te.trackUpdaters = {}, Te.selectActiveTracks = function(we) {
              return we == null ? void 0 : we.activeTracks;
            }, Te.handleActiveTracksChange = function(we) {
              we && Te.manifestService.isHlsManifest() && Te.updateTracks(we);
            }, Te.selectPlaybackState = function(we) {
              return we.player && we.player.playbackState;
            }, Te.handlePlaybackStateChange = function(we) {
              we && (we === oe.PlaybackState.Paused ? Te.stop() : we === oe.PlaybackState.Playing && Te.start());
            }, Te.updatedRepresentation = function(we) {
              Te.updateAdaptationSetInManifest(we), Te.manifestService.updateManifest(Te.manifestService.getManifest()).catch(function() {
                Te.logger.debug("Updating the manifest failed");
              });
            }, Te.representationUpdateError = function(we, Pe) {
              if (Te.logger.debug("Rejection while updating the representation", we), we === le.RequestError.Failed || we === le.RequestError.TimedOut || we instanceof he.PlayerError) {
                var Me = we instanceof he.PlayerError ? we.name : we;
                Te.sourceStore.dispatch((0, me.updateRepresentationFailedDownloadAction)(Pe._internalId, Me)), Te.manifestService.updateManifest(Te.manifestService.getManifest()).catch(function(Ae) {
                  Te.logger.debug("Error while updating the manifest after the representation failed to load", Ae);
                });
              }
            }, Te.manifestDownloadError = function() {
              Te.logger.debug("Error while loading manifest");
            }, Te.context = Ce, Te.sourceContext = Ie;
            var Ee = Te.sourceContext.sourceIdentifier;
            return Te.manifestService = Ce.serviceManager.get(_e.ServiceName.ManifestService, Ee), Te.manifestLoader = Ce.serviceManager.get(_e.ServiceName.ManifestLoadingService, Ee), Te.store = Ce.store, Te.sourceStore = Ce.serviceManager.get(_e.ServiceName.SourceStoreService, Ee), Te.eventHandler = Ce.eventHandler, Te.logger = Ce.logger, Te.unsubscribeFromActiveTrackChanges = Te.subscribeToActiveTrackChanges(), Te.unsubscribeFromPausePlayingChanges = Te.subscribeToPausePlayingChanges(Ce), Te;
          }
          return ae(Se, $e), Se.prototype.subscribeToActiveTrackChanges = function() {
            var Ce = this;
            return (0, ue.subscribe)(this.sourceStore)(function(Ie) {
              return Ce.selectActiveTracks(Ie);
            }, this.handleActiveTracksChange);
          }, Se.prototype.updateTracks = function(Ce) {
            this.processNewActiveTrack(Ce), this.removeDeactivatedTrackUpdaters(Ce);
          }, Se.prototype.processNewActiveTrack = function(Ce) {
            var Ie = this;
            Object.keys(Ce).filter(function(Te) {
              return Ce[Te].selectedRepresentationId;
            }).forEach(function(Te) {
              Ie.updateTrackUpdater(Ce[Te].selectedRepresentationId);
            });
          }, Se.prototype.removeDeactivatedTrackUpdaters = function(Ce) {
            var Ie = this;
            Object.keys(this.trackUpdaters).filter(function(Te) {
              return !Object.keys(Ce).includes(Te);
            }).forEach(function(Te) {
              Ie.trackUpdaters[Te].stop(), delete Ie.trackUpdaters[Te];
            });
          }, Se.prototype.subscribeToPausePlayingChanges = function(Ce) {
            return (0, ue.subscribe)(this.store)(this.selectPlaybackState, this.handlePlaybackStateChange, function() {
              return Ce.settings.STOP_DOWNLOAD_ON_PAUSE;
            });
          }, Se.prototype.updateTrackUpdater = function(Ce) {
            var Ie = this.manifestService.getRepresentationById(Ce), Te = Ce.adaptationSetId;
            this.trackUpdaters[Te] ? this.trackUpdaters[Te].getRepresentation()._internalId.equals(Ce) || this.trackUpdaters[Te].setRepresentation(Ie) : this.trackUpdaters[Ie._internalId.adaptationSetId] = this.initializeTrackUpdater(Ie);
          }, Se.prototype.stopRepresentationUpdates = function(Ce) {
            var Ie, Te = this.trackUpdaters[Ce._internalId.adaptationSetId];
            return (Ie = Te == null ? void 0 : Te.stopRepresentationUpdate(Ce)) !== null && Ie !== void 0 ? Ie : Promise.resolve();
          }, Se.prototype.scheduleRepresentationUpdate = function(Ce) {
            var Ie = this.trackUpdaters[Ce._internalId.adaptationSetId];
            Ie == null || Ie.setRepresentation(Ce), Ie == null || Ie.start();
          }, Se.prototype.initializeTrackUpdater = function(Ce) {
            var Ie = this, Te = new fe.RepresentationUpdater(this.context, Ce, this.manifestLoader, { success: this.updatedRepresentation, error: function(Ee) {
              return Ie.representationUpdateError(Ee, Te.getRepresentation());
            } });
            return Te.start(), Te;
          }, Se.prototype.updateAdaptationSetInManifest = function(Ce) {
            this.sourceStore.dispatch((0, me.updateRepresentationAction)(Ce));
          }, Se.prototype.init = function(Ce) {
            var Ie = this;
            return this.manifestLoader.load(Ce).then(function(Te) {
              return Ie.manifestService.updateManifest(Te).then(function() {
                Ie.initiated = !0, Ie.manifestService.isLive() && !Ie.manifestService.isHlsManifest() && Ie.scheduleManifestReloading(Te);
              });
            }).catch(function(Te) {
              return Te instanceof he.PlayerError || Te instanceof Error ? Promise.reject(Te) : Promise.reject(new Error("The loading of the manifest has failed or was cancelled"));
            });
          }, Se.prototype.scheduleManifestReloading = function(Ce) {
            var Ie = this;
            this.manifestUpdater = new pe.ManifestUpdater(this.manifestLoader, Ce, { minAllowedUpdatePeriod: this.context.settings.MINIMUM_ALLOWED_UPDATE_PERIOD, maxAllowedUpdatePeriod: this.context.settings.MAXIMUM_ALLOWED_UPDATE_PERIOD }, { success: function(Te) {
              return Ie.manifestService.updateManifest(Te);
            }, error: this.manifestDownloadError }), this.manifestUpdater.start();
          }, Se.prototype.waitForRepUpdate = function(Ce) {
            return Object.keys(this.trackUpdaters).length === 0 || ye(this.manifestService.getRepresentationById(Ce)) ? Promise.resolve() : this.trackUpdaters[Ce.adaptationSetId].updateRepresentation().then(function() {
            });
          }, Se.prototype.stop = function() {
            Object.values(this.trackUpdaters).forEach(function(Ce) {
              return Ce.stop();
            }), this.manifestUpdater && this.manifestUpdater.stop();
          }, Se.prototype.start = function() {
            Object.values(this.trackUpdaters).filter(function(Ce) {
              return Ce.isStopped;
            }).forEach(function(Ce) {
              Ce.start();
            }), this.manifestUpdater && this.manifestUpdater.isStopped && this.manifestUpdater.start();
          }, Se.prototype.onSuspend = function() {
            this.unsubscribeFromPausePlayingChanges();
          }, Se.prototype.onRestore = function() {
            this.unsubscribeFromPausePlayingChanges = this.subscribeToPausePlayingChanges(this.context);
          }, Se.prototype.isInitiated = function() {
            return this.initiated;
          }, Se.prototype.dispose = function() {
            this.unsubscribeFromActiveTrackChanges(), this.unsubscribeFromPausePlayingChanges(), this.stop(), this.manifestUpdater = null, this.trackUpdaters = null, $e.prototype.dispose.call(this);
          }, ce([(0, se.trackPerformance)("ManifestUpdateScheduler.init", !0)], Se.prototype, "init", null), Se;
        }(be.Suspendable);
        function ye($e) {
          var Se;
          return !!$e._requestTimestamp && $e._requestTimestamp + (0, ve.toMilliSeconds)((Se = $e._updateInterval) !== null && Se !== void 0 ? Se : 1 / 0) > Date.now();
        }
        ne.ManifestUpdateScheduler = ge;
      }, 43752: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MPDExtractor = void 0, ne.stripUnderscorePrefix = ge, ne.applyProperties = ye, ne.representationToQuality = $e, ne.getMinimumUpdatePeriodInSeconds = Pe, ne.getContentTypeFromMimeTypeAndCodecs = Me;
        var ae = ie(18665), ce = ie(33696), he = ie(42055), _e = ie(42283), le = ie(44388), se = ie(79814), oe = ie(331), ue = ie(54838), be = ie(91520), ve = ie(16368), me = ie(41735), pe = ie(77874), fe = function() {
          function Ae(Oe, Be) {
            var Ve = this;
            this.isLive = function() {
              var Ue;
              return ((Ue = Ve.getMpd()) === null || Ue === void 0 ? void 0 : Ue._type) === "dynamic";
            }, this.context = Oe, this.sourceContext = Be, this.settings = Oe.settings, this.adjustedPeriodStartTimes = !1, this.synchronizedTimeService = Oe.serviceManager.get(ae.ServiceName.SynchronizedTimeService, this.sourceContext.sourceIdentifier), this.sourceStore = Oe.serviceManager.get(ae.ServiceName.SourceStoreService, this.sourceContext.sourceIdentifier);
          }
          return Ae.prototype.getMpd = function() {
            var Oe;
            return (0, pe.getManifest)((Oe = this.sourceStore) === null || Oe === void 0 ? void 0 : Oe.getState());
          }, Ae.prototype.getPeriods = function() {
            var Oe, Be;
            return (Be = (Oe = this.getMpd()) === null || Oe === void 0 ? void 0 : Oe.Period) !== null && Be !== void 0 ? Be : [];
          }, Ae.prototype.getAdaptationSets = function(Oe) {
            var Be = this.getPeriods().find(function(Ve) {
              return Ve._id === Oe;
            });
            return Be ? Be.AdaptationSet : [];
          }, Ae.prototype.adjustPeriodStartTimes = function() {
            var Oe, Be, Ve, Ue = (Oe = this.sourceStore) === null || Oe === void 0 ? void 0 : Oe.getState();
            if (Ue && !this.adjustedPeriodStartTimes && !(!((Be = this.getMpd()) === null || Be === void 0) && Be._isHls)) {
              var Re = this.isLive() ? (0, oe.toSeconds)(this.getAvailabilityStartTime()) : (0, he.getStartTimeOffset)(Ue);
              (Ve = this.sourceStore) === null || Ve === void 0 || Ve.dispatch((0, me.adjustPeriodStartTimes)(Re)), this.adjustedPeriodStartTimes = !0;
            }
          }, Ae.prototype.getAvailabilityStartTime = function() {
            var Oe;
            return this.isLive() && (!((Oe = this.getMpd()) === null || Oe === void 0) && Oe._availabilityStartTime) ? ue.Util.getUtcDate(this.getMpd()._availabilityStartTime).getTime() - this.getTimeDifference() : 0;
          }, Ae.prototype.getAvailabilityEndTime = function() {
            var Oe;
            if (!((Oe = this.getMpd()) === null || Oe === void 0) && Oe.hasOwnProperty("_availabilityEndTime")) {
              var Be = ue.Util.getUtcDate(this.getMpd()._availabilityEndTime).getTime();
              return new Date(Be - this.getTimeDifference());
            }
            return null;
          }, Ae.prototype.getTimeDifference = function() {
            return this.synchronizedTimeService ? this.synchronizedTimeService.getTimeDifference() : 0;
          }, Ae.prototype.getType = function() {
            var Oe;
            return (Oe = this.getMpd()) === null || Oe === void 0 ? void 0 : Oe._type;
          }, Ae.prototype.getDuration = function() {
            var Oe;
            return (Oe = this.getMpd()) === null || Oe === void 0 ? void 0 : Oe._mediaPresentationDuration;
          }, Ae.prototype.getRequestTimestamp = function() {
            var Oe;
            return (Oe = this.getMpd()) === null || Oe === void 0 ? void 0 : Oe._requestTimestamp;
          }, Ae.isValueWithinBounds = function(Oe, Be, Ve) {
            return !Oe || Oe >= Be && Oe <= Ve;
          }, Ae.prototype.isAllowedVideoQuality = function(Oe) {
            var Be = Ae.isValueWithinBounds(Oe.width, this.context.config.adaptation.resolution.minSelectableVideoWidth, this.context.config.adaptation.resolution.maxSelectableVideoWidth), Ve = Ae.isValueWithinBounds(Oe.height, this.context.config.adaptation.resolution.minSelectableVideoHeight, this.context.config.adaptation.resolution.maxSelectableVideoHeight), Ue = Ae.isValueWithinBounds(Oe.bitrate, this.settings.MIN_SELECTABLE_VIDEO_BITRATE, this.settings.MAX_SELECTABLE_VIDEO_BITRATE);
            return Be && Ve && Ue;
          }, Ae.prototype.isAllowedAudioQuality = function(Oe) {
            return Ae.isValueWithinBounds(Oe.bitrate, this.settings.MIN_SELECTABLE_AUDIO_BITRATE, this.settings.MAX_SELECTABLE_AUDIO_BITRATE);
          }, Ae.prototype.getAllowedQualities = function(Oe, Be) {
            var Ve = this;
            if (!Oe)
              return [];
            var Ue = Be.filter(function(Re) {
              return se.MimeTypeHelper.isVideo(Oe) && Ve.isAllowedVideoQuality(Re) || se.MimeTypeHelper.isAudio(Oe) && Ve.isAllowedAudioQuality(Re);
            });
            return Ue.length < 1 && Be.length > 0 ? Be : Ue;
          }, Ae.prototype.getQualityForAdaptationSet = function(Oe) {
            if (!Oe)
              return [];
            var Be = Oe.Representation.map(function(Ve) {
              return $e(Ve, Oe._mimeType, Oe._codecs);
            });
            return this.settings.EXCLUDE_DISALLOWED_REPRESENTATIONS && (Be = this.getAllowedQualities(Oe._mimeType, Be)), Be;
          }, Ae.prototype.getAudioQualities = function(Oe) {
            var Be = this, Ve = this.getValidPeriodId(Oe);
            return this.getAdaptationSets(Ve).reduce(function(Ue, Re) {
              return Re._mimeType && se.MimeTypeHelper.isAudio(Re._mimeType) && (Ue[Re._internalId.adaptationSetId] = Be.getQualityForAdaptationSet(Re)), Ue;
            }, {});
          }, Ae.prototype.getVideoQualities = function(Oe) {
            var Be = this.getValidPeriodId(Oe), Ve = this.getAdaptationSets(Be).find(function(Ue) {
              return Ue._mimeType && se.MimeTypeHelper.isVideo(Ue._mimeType);
            });
            return Ve ? this.getQualityForAdaptationSet(Ve) : [];
          }, Ae.prototype.getLangObjectFromAdaptationSet = function(Oe, Be, Ve) {
            var Ue = { id: null, lang: null, adaptationSetId: null, kind: null, label: "off", url: null }, Re = Oe._mimeType && Oe._mimeType.indexOf(Be) > -1, Ne = Ve && Oe._mimeType.indexOf(Ve) > -1;
            return se.MimeTypeHelper.isSubtitle(Be) && (Ue.kind = "subtitle"), Oe.Role && Oe.Role.length > 0 && (Ue.role = Oe.Role.map(function(xe) {
              return ye(xe, {});
            })), (Re || Ne) && (ye(Oe, Ue, ["_lang", "_isFragmented"]), Ue.lang = Ue.lang || "und", Ue.label = Oe._label || Ue.lang, Ue.adaptationSetId = Oe._internalId, Ue.id = Oe._internalId.adaptationSetId), Ue;
          }, Ae.prototype.toSubtitleTrack = function(Oe, Be, Ve) {
            var Ue, Re = this.getLangObjectFromAdaptationSet(Oe, Be, Ve), Ne = { id: Re.id, lang: Re.lang, kind: Re.kind, isFragmented: (Ue = Re.isFragmented) !== null && Ue !== void 0 && Ue, isSideloaded: !1, enabled: !1, label: Re.label };
            return Re.role != null && (Ne.role = Re.role), Ne.forced = we(Ne, Oe.Representation[0]), Ne;
          }, Ae.prototype.getAvailableSubtitles = function(Oe) {
            var Be = this, Ve = 0;
            return Oe = this.getValidPeriodId(Oe), this.getAdaptationSets(Oe).filter(function(Ue) {
              return se.MimeTypeHelper.isSubtitle(Ue._mimeType);
            }).map(function(Ue) {
              var Re = Be.toSubtitleTrack(Ue, "application", "text");
              return Re.id || (Ve++, Re.id = "sub_".concat(Ve)), Re;
            });
          }, Ae.prototype.getClosedCaptionLabels = function(Oe) {
            return Oe = this.getValidPeriodId(Oe), this.getAdaptationSets(Oe).filter(function(Be) {
              return Be.ClosedCaptionLabels;
            }).flatMap(function(Be) {
              return Object.keys(Be.ClosedCaptionLabels).map(function(Ve) {
                var Ue = Be.ClosedCaptionLabels[Ve];
                return { id: Ve, kind: "captions", lang: Ue.lang || "unknown", label: Ue.label || "Captions (".concat(Ve, ")") };
              });
            });
          }, Ae.prototype.getAvailableAudio = function(Oe, Be) {
            var Ve = this;
            Be === void 0 && (Be = !0);
            var Ue = this.getValidPeriodId(Oe), Re = this.getAdaptationSets(Ue), Ne = 0, xe = Re.filter(function(He) {
              return se.MimeTypeHelper.isAudio(He._mimeType);
            }).map(function(He) {
              var We = Ve.getLangObjectFromAdaptationSet(He, ce.MediaType.Audio);
              return We && We.label !== "off" ? (We.id || (We.id = "audio_" + Ne, Ne++), We) : null;
            });
            if (Be) {
              var ke = Re.find(function(He) {
                return se.MimeTypeHelper.isVideo(He._mimeType);
              });
              if (ke && ke.ContentComponent) {
                var Le = ke.ContentComponent.filter(function(He) {
                  return He._contentType === ce.MediaType.Audio;
                }).map(function(He) {
                  return { id: He._id, lang: He._lang, label: He._id, adaptationSetId: ke._internalId };
                });
                xe = xe.concat(Le);
              }
            }
            return xe.filter(function(He) {
              return He;
            });
          }, Ae.prototype.getAvailableVideo = function(Oe) {
            var Be = this.getValidPeriodId(Oe), Ve = this.getAdaptationSets(Be).find(function(Ue) {
              return se.MimeTypeHelper.isVideo(Ue._mimeType);
            });
            return Ve ? [this.getLangObjectFromAdaptationSet(Ve, ce.MediaType.Video)] : [];
          }, Ae.getContentProtectionForManifestElement = function(Oe) {
            var Be;
            return !((Be = Oe == null ? void 0 : Oe.ContentProtection) === null || Be === void 0) && Be.length && be.ModuleManager.has(ve.ModuleName.DRM) ? be.ModuleManager.get(ve.ModuleName.DRM).ContentProtectionHelper.parseContentProtectionDescriptors(Oe.ContentProtection) : [];
          }, Ae.getContentProtectionForAdaptationSet = function(Oe) {
            for (var Be = [], Ve = 0; Ve < Oe.Representation.length; Ve++)
              Be = Be.concat(Ae.getContentProtectionForManifestElement(Oe.Representation[Ve]));
            return Be = Be.concat(Ae.getContentProtectionForManifestElement(Oe));
          }, Ae.prototype.getTimeShiftBufferDepthSeconds = function() {
            if (this.isLive()) {
              var Oe = this.getMpd()._timeShiftBufferDepth, Be = (0, oe.toSeconds)(Date.now() - this.getAvailabilityStartTime());
              return Oe === Number.NEGATIVE_INFINITY ? -Be : Math.max(Oe, -Be);
            }
            return 0;
          }, Ae.getCurrentAndSuccessorPeriod = function(Oe, Be) {
            for (var Ve = [null, 0, null], Ue = Ve[0], Re = Ve[1], Ne = Ve[2]; Re < Oe.length; Re++)
              if (Oe[Re]._id === Be) {
                Ue = Oe[Re], Ne = Oe[Re + 1] || null;
                break;
              }
            return [Ue, Ne];
          }, Ae.prototype.getPeriodDuration = function(Oe, Be) {
            var Ve;
            Be = Be ?? this.getPeriods();
            var Ue = Ae.getCurrentAndSuccessorPeriod(Be, Oe), Re = Ue[0], Ne = Ue[1];
            if (Re && Re._duration)
              return le.DurationConverter.getDurationInSec(Re._duration);
            if (Re && Re.start && Ne && Ne.start)
              return Ne.start - Re.start;
            if (!((Ve = this.getMpd()) === null || Ve === void 0) && Ve._mediaPresentationDuration) {
              var xe = le.DurationConverter.getDurationInSec(this.getMpd()._mediaPresentationDuration);
              if (!isNaN(xe))
                return xe;
            }
            return Number.POSITIVE_INFINITY;
          }, Ae.prototype.getDRMCapabilitiesForPeriod = function(Oe) {
            Oe = this.getValidPeriodId(Oe);
            var Be = this.getPeriods().find(function(Ve) {
              return Ve._id === Oe;
            });
            return this.getDRMCapabilitiesFromPeriod(Be);
          }, Ae.prototype.getDRMCapabilitiesFromPeriod = function(Oe) {
            for (var Be = [], Ve = [], Ue = 0, Re = Oe.AdaptationSet; Ue < Re.length; Ue++) {
              var Ne = Re[Ue], xe = Ne._mimeType, ke = Ae.getMimeTypeCodecStringForAdaptationSet(Ne);
              se.MimeTypeHelper.isVideo(xe) ? Ve = Ve.concat(ke) : se.MimeTypeHelper.isAudio(xe) && (Be = Be.concat(ke));
            }
            return [Be, Ve];
          }, Ae.prototype.dispose = function() {
            this.settings = null;
          }, Ae.getMimeTypeCodecStringForAdaptationSet = function(Oe) {
            for (var Be = [], Ve = 0, Ue = Oe.Representation; Ve < Ue.length; Ve++) {
              var Re = Ue[Ve], Ne = Ae.getAttributeFromRepresentationOrAdaptationSet("_codecs", Re, Oe), xe = Oe._mimeType;
              if (Oe._mimeType && Ne) {
                var ke = Me(xe, Ne);
                Be.push({ contentType: ke });
              }
            }
            return Be;
          }, Ae.getAttributeFromRepresentationOrAdaptationSet = function(Oe, Be, Ve) {
            return Be.hasOwnProperty(Oe) && Be[Oe] ? Be[Oe] : Ve.hasOwnProperty(Oe) && Ve[Oe] ? Ve[Oe] : null;
          }, Ae.prototype.getValidPeriodId = function(Oe) {
            var Be = this.getPeriods();
            if (Be.find(function(Ue) {
              return Ue._id === Oe;
            }))
              return Oe;
            var Ve = Be[Be.length - 1]._id;
            return this.context.logger.debug("Period " + Oe + " not available - return last period (" + Ve + ")"), Ve;
          }, Ae.prototype.getEventStreamEvents = function(Oe) {
            var Be = this;
            return Oe && Oe.EventStream ? Oe.EventStream.filter(function(Ve) {
              return Ve.Event;
            }).flatMap(function(Ve) {
              var Ue, Re = Number((Ue = Ve._timescale) !== null && Ue !== void 0 ? Ue : 1);
              return Be.mapToEventStreamEvent(Oe.start, Ve, Re);
            }) : [];
          }, Ae.prototype.mapToEventStreamEvent = function(Oe, Be, Ve) {
            var Ue = this;
            return Be.Event.map(function(Re) {
              var Ne = {}, xe = Re._presentationTime || 0;
              if (Ne.startTime = xe / Ve + Oe, Re._duration) {
                var ke = Re._duration / Ve;
                Ne.endTime = Ne.startTime + ke;
              } else
                Ne.endTime = Ne.startTime;
              return Ne.data = Ue.getEventData(Re, Be._schemeIdUri), Ne;
            });
          }, Ae.prototype.getEventData = function(Oe, Be) {
            var Ve = /<event[^>]*>(.*)(<\/event>|\/>)/g.exec(Oe.rawXmlRepresentation), Ue = void 0;
            Ve && Ve.length > 1 && (Ue = Ve[1]);
            var Re = {};
            return Object.getOwnPropertyNames(Oe).filter(function(Ne) {
              return !["_presentationTime", "_duration", "__text"].some(function(xe) {
                return xe === Ne;
              }) && Ne.lastIndexOf("_", 0) === 0;
            }).forEach(function(Ne) {
              Re[Ne.substring(1, Ne.length)] = Oe[Ne];
            }), { properties: Re, content: Ue, schemeIdUri: Be };
          }, Ae;
        }();
        function ge(Ae) {
          return Ae.indexOf("_") === 0 ? Ae.substring(1) : Ae;
        }
        function ye(Ae, Oe, Be) {
          return Be === void 0 && (Be = []), Object.keys(Ae).filter(function(Ve) {
            return Be.length === 0 || Be.indexOf(Ve) > -1;
          }).forEach(function(Ve) {
            Oe[ge(Ve)] = Ae[Ve];
          }), Oe;
        }
        function $e(Ae, Oe, Be) {
          if (!Ae)
            return null;
          var Ve = { id: Ae._id ? String(Ae._id) : null, bitrate: Ae._bandwidth || 0 }, Ue = _e.CodecStringHelper.getExtractedCodecStrings(Ae._codecs || Be);
          return Ie(Ae, Oe) ? Se(Ve, Ae, Ue) : Ce(Ae, Oe) ? Te(Ve, Ae, Ue) : (Ve.label = Ae._label || Ee(Ve.bitrate), Ve);
        }
        function Se(Ae, Oe, Be) {
          return Be.audio && (Ae.codec = Be.audio), Ae.label = Oe._label || Ee(Ae.bitrate), Ae;
        }
        function Ce(Ae, Oe) {
          return se.MimeTypeHelper.isVideo(Oe);
        }
        function Ie(Ae, Oe) {
          return se.MimeTypeHelper.isAudio(Oe);
        }
        function Te(Ae, Oe, Be) {
          Ae.width = Oe._width || 0, Ae.height = Oe._height || 0, Be.video && (Ae.codec = Be.video), Oe.hasOwnProperty("_frameRate") && (Ae.frameRate = Oe._frameRate);
          var Ve = Ee(Ae.bitrate);
          return Ae.width && Ae.height && (Ve = "".concat(Ae.width, "x").concat(Ae.height, ", ").concat(Ve)), Ae.label = Oe._label || Ve, Ae;
        }
        function Ee(Ae) {
          return "".concat(Math.round(Ae / 1e3), "kbps");
        }
        function we(Ae, Oe) {
          var Be, Ve;
          return !!(!((Be = Ae.role) === null || Be === void 0) && Be.some(function(Ue) {
            return Ue.value && ["forced_subtitle", "forced-subtitle"].includes(Ue.value);
          })) || !!(!((Ve = Oe == null ? void 0 : Oe._hls) === null || Ve === void 0) && Ve.isForced);
        }
        function Pe(Ae) {
          return (Ae == null ? void 0 : Ae._minimumUpdatePeriod) == null ? 1 / 0 : le.DurationConverter.getDurationInSec(Ae._minimumUpdatePeriod);
        }
        function Me(Ae, Oe) {
          return "".concat(Ae, '; codecs="').concat(Oe, '"');
        }
        ne.MPDExtractor = fe;
      }, 44910: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MseModuleDefinition = void 0;
        var ae = ie(96873), ce = ie(33669), he = ie(16368), _e = ie(73543), le = ie(67883), se = ie(48928), oe = ie(94938), ue = ie(38925), be = ie(85586), ve = ie(10997), me = ie(26382), pe = ie(58423), fe = ie(13788), ge = ie(67550), ye = ie(92395), $e = ie(72207), Se = ie(4053), Ce = ie(82311), Ie = ie(58211), Te = ie(93326), Ee = ie(59839), we = ie(22645), Pe = ie(23414), Me = { removeStreamTimeRange: Ee.removeStreamTimeRange, removeLoadedRange: ae.removeLoadedRange, addLoadedRange: ae.addLoadedRange, resetLoadedRanges: ae.resetLoadedRanges, resetStreamTimeline: Ee.resetStreamTimeline, removeActiveTrackAction: Se.removeActiveTrackAction, setRepresentationIdAction: Se.setRepresentationIdAction, setMediaTypeAction: Se.setMediaTypeAction }, Ae = { getPlayingPeriodId: Ie.getPlayingPeriodId, getContainerFormat: Ce.getContainerFormat, getLoadedRangesForMimeType: ce.getLoadedRangesForMimeType, getSegmentInfos: Te.getSegmentInfos }, Oe = { containerFormat: _e.ContainerFormat, streamTimeRangeType: we.StreamTimeRangeType };
        ne.MseModuleDefinition = { name: he.ModuleName.EngineBitmovin, module: { MediaPlayer: be.MediaPlayer, SegmentController: pe.SegmentController, technologyChecker: new Pe.TechnologyChecker(), Stream: $e.Stream, FetchController: me.FetchController, SegmentInfoService: fe.SegmentInfoService, SegmentPrefetchingService: ye.SegmentPrefetchingService, AdRestorationOptimizationService: ve.AdRestorationOptimizationService, ManifestCachingService: se.ManifestCachingService, SegmentListMPDHandler: ge.SegmentListMPDHandler, actions: Me, selectors: Ae, mseModuleTypes: Oe, AdaptationSetId: le.AdaptationSetId, RepresentationId: ue.RepresentationId, getTrackIdentifier: we.getTrackIdentifier, getCodecsFromAdaptationSet: oe.getCodecsFromAdaptationSet, getMimeTypeForAdaptationSet: oe.getMimeTypeForAdaptationSet } }, ne.default = ne.MseModuleDefinition;
      }, 46678: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentLoaderPool = void 0, ne.getLoaderPoolSize = $e;
        var ae = ie(76650), ce = ie(28819), he = ie(8272), _e = ie(27279), le = ie(27177), se = ie(79814), oe = ie(70016), ue = ie(91520), be = ie(16368), ve = ie(59839), me = ie(22645), pe = ie(28915), fe = ie(66864), ge = 1, ye = function() {
          function Te(Ee, we) {
            this.context = Ee, this.mimeType = we.mimeType, this.loaders = [], this.shouldDownloadBeCancelledCallback = we.shouldDownloadBeCancelledCallback, this.addLoaders($e(this.mimeType, Ee.settings.SEGMENT_LOADER_POOL_SIZE)), this.attachDecrypter();
          }
          return Te.prototype.addLoaders = function(Ee) {
            for (var we = 0; we < Ee; we++)
              this.loaders.push(new fe.SegmentLoader(this.context, this.mimeType, this.shouldDownloadBeCancelledCallback));
          }, Te.prototype.getDecrypter = function(Ee) {
            if (this.context.segmentPrefetchingService && this.context.segmentPrefetchingService.hasMp4Decrypter(this.mimeType))
              return this.context.segmentPrefetchingService.getDecrypter(this.mimeType);
            var we = ue.ModuleManager.get(be.ModuleName.Crypto).createDecrypter, Pe = Ie(Ee.drm.clearkey) ? Ee.drm.clearkey : [];
            return we(this.context, this.mimeType, Pe);
          }, Te.prototype.getClearKeyLoader = function(Ee) {
            return new (ue.ModuleManager.get(be.ModuleName.Crypto)).ClearKeyLoader(this.context, Ee);
          }, Te.prototype.attachDecrypter = function() {
            var Ee = this.context.sourceContext.source, we = Se(Ee) ? this.getDecrypter(Ee) : null;
            if (we && (this.loaders.forEach(function(Me) {
              return Me.attachDecrypter(we);
            }), this.context.segmentPrefetchingService && this.context.segmentPrefetchingService.setDecrypter(we, this.mimeType), Ce(Ee.drm.clearkey))) {
              var Pe = this.getClearKeyLoader(Ee.drm.clearkey);
              this.loaders.forEach(function(Me) {
                return Me.attachClearKeyLoader(Pe);
              });
            }
          }, Te.prototype.isLoading = function() {
            return this.loaders.some(function(Ee) {
              return Ee.isLoading();
            });
          }, Te.prototype.isFreeLoaderAvailable = function() {
            return this.loaders.some(function(Ee) {
              return !Ee.isLoading();
            });
          }, Te.prototype.updateRequestedRepresentationMetric = function(Ee) {
            var we = (0, ce.getMetricsHistoryFromInstanceState)(this.context.store.getState(), "default", he.MetricType.RequestedRepresentations);
            (we ? we.map(function(Pe) {
              return Pe.value;
            }) : []).includes(Ee) || this.context.store.dispatch((0, ae.addMetricsValue)("default", he.MetricType.RequestedRepresentations, Ee));
          }, Te.prototype.load = function(Ee) {
            var we = this.loaders.find(function(Oe) {
              return !Oe.isLoading();
            });
            if (!we)
              return this.context.logger.debug("Failed to load segment. No free loader!", Ee.url), Promise.reject(null);
            this.updateRequestedRepresentationMetric(Ee.internalRepresentationId), this.context.logger.debug("[SegmentLoader ".concat(this.loaders.indexOf(we), "][").concat(Ee.mimeType, "][").concat(Ee.representationId, "] Loading ").concat(Ee.startTime, " ").concat(Ee.url));
            var Pe = (0, pe.getSegmentInfoTimeRange)(Ee), Me = (0, me.getTrackIdentifier)(Ee), Ae = (0, _e.getSourceStore)(this.context);
            return Pe && (Ae == null || Ae.dispatch((0, ve.addStreamTimeRange)(Me, Pe, me.StreamTimeRangeType.Loading))), we.load(Ee).catch(function(Oe) {
              throw Pe && (Ae == null || Ae.dispatch((0, ve.removeStreamTimeRange)(Me, Pe, me.StreamTimeRangeType.Loading))), Oe;
            });
          }, Te.prototype.cancelLoading = function() {
            var Ee = this;
            return Promise.all(this.loaders.map(function(we) {
              return we.isLoading() && we.cancelLoading(), Promise.resolve(we.getCurrentLoadPromise());
            })).then(function() {
            }).catch(function(we) {
              (we == null ? void 0 : we.reason) !== fe.SegmentLoadingErrorReason.CANCEL && (0, le.isContextAvailable)(Ee.context) && Ee.context.logger.debug("Error while loading a segment ", we);
            });
          }, Te.prototype.getLoadingPeriodIds = function() {
            return this.loaders.flatMap(function(Ee) {
              return Ee.getAllLoadingPeriodIds();
            });
          }, Te.prototype.dispose = function() {
            this.cancelLoading(), this.loaders.forEach(function(Ee) {
              return Ee.dispose();
            }), this.loaders = null;
          }, Te;
        }();
        function $e(Te, Ee) {
          var we = se.MimeTypeHelper.extractContentType(Te);
          return Ee && (0, oe.isNumber)(Ee[we]) ? Math.max(ge, Ee[we]) : ge;
        }
        function Se(Te) {
          var Ee, we;
          return Ie((Ee = Te == null ? void 0 : Te.drm) === null || Ee === void 0 ? void 0 : Ee.clearkey) || Ce((we = Te == null ? void 0 : Te.drm) === null || we === void 0 ? void 0 : we.clearkey);
        }
        function Ce(Te) {
          return !!(Te != null && Te.LA_URL);
        }
        function Ie(Te) {
          return (Te == null ? void 0 : Te.length) > 0;
        }
        ne.SegmentLoaderPool = ye;
      }, 48727: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(oe) {
            for (var ue, be = 1, ve = arguments.length; be < ve; be++)
              for (var me in ue = arguments[be])
                Object.prototype.hasOwnProperty.call(ue, me) && (oe[me] = ue[me]);
            return oe;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentInitType = ne.Segment = void 0;
        var ce, he = ie(81361), _e = ie(79814), le = ie(28915), se = function() {
          function oe(ue, be, ve, me, pe, fe, ge, ye, $e, Se) {
            fe === void 0 && (fe = ce.NONE), this.inbandEvents = [], this.data = ue, this.mimeType = be, this.codec = ve, this.periodId = me, this.duration = pe, this.initType = fe, this.isSegmentIndependentlyDecodable = ge, this.encrypted = !1, this.metadata = { subtitles: [] }, this.networkRequestSize = ye, this.representationId = $e, this.playbackTime = Se, this._isDirty = !1, this.drmInitData = null, ue instanceof ArrayBuffer || typeof ue == "string" && (this.data = he.ArrayHelper.stringToArrayWithoutEncoding(ue).buffer);
          }
          return oe.prototype.setDrmKid = function(ue) {
            this.drmKid = ue;
          }, oe.prototype.hasDrmKid = function() {
            return !!this.getDrmKid();
          }, oe.prototype.getDrmKid = function() {
            var ue, be, ve;
            return (ve = (ue = this.drmKid) !== null && ue !== void 0 ? ue : (be = this.initSegment) === null || be === void 0 ? void 0 : be.getDrmKid()) !== null && ve !== void 0 ? ve : void 0;
          }, oe.prototype.setDrmInitData = function(ue) {
            this.drmInitData = ue;
          }, oe.prototype.hasDrmInitData = function() {
            var ue;
            return ((ue = this.drmInitData) === null || ue === void 0 ? void 0 : ue.length) > 0;
          }, oe.prototype.getDrmInitData = function() {
            return this.hasDrmInitData() ? this.drmInitData : [];
          }, oe.prototype.getMimeType = function() {
            return this.mimeType;
          }, oe.prototype.isInit = function() {
            return this.initType === ce.INIT;
          }, oe.prototype.isSelfInit = function() {
            return this.initType === ce.SELF_INIT;
          }, oe.prototype.isEncrypted = function() {
            return this.encrypted;
          }, oe.prototype.setEncrypted = function(ue) {
            this.encrypted = ue;
          }, oe.prototype.setUrl = function(ue) {
            this.loadedUrl = ue;
          }, oe.prototype.getUrl = function() {
            return this.loadedUrl;
          }, oe.prototype.getData = function() {
            return this.data;
          }, oe.prototype.setData = function(ue) {
            this.data = ue;
          }, oe.prototype.getMetadata = function() {
            return this.metadata;
          }, oe.prototype.setMetadata = function(ue) {
            this.metadata = ue;
          }, oe.prototype.getPlaybackTime = function() {
            return this.playbackTime;
          }, oe.prototype.setPlaybackTime = function(ue) {
            this.playbackTime = ue;
          }, oe.prototype.getPlaybackEndTime = function() {
            return this.playbackTime + this.duration;
          }, oe.prototype.getPlaybackTimeRange = function() {
            return this.duration ? { start: this.getPlaybackTime(), end: this.getPlaybackEndTime() } : (0, le.getSegmentInfoTimeRange)(this.getSegmentInfo());
          }, oe.prototype.getBaseMediaDecodeTime = function() {
            return this.baseMediaDecodeTime;
          }, oe.prototype.setBaseMediaDecodeTime = function(ue) {
            this.baseMediaDecodeTime = ue;
          }, oe.prototype.getPresentationTimeOffset = function() {
            return this.presentationTimeOffset;
          }, oe.prototype.setPresentationTimeOffset = function(ue) {
            this.presentationTimeOffset = ue;
          }, oe.prototype.getTFDTBoxOffsets = function() {
            return this.tfdtBoxOffsets;
          }, oe.prototype.setTFDTBoxOffsets = function(ue) {
            this.tfdtBoxOffsets = ue;
          }, oe.prototype.getParserMetadataValue = function(ue) {
            var be;
            return this.getParserMetadata() && this.getParserMetadata()[ue] ? this.getParserMetadata()[ue] : !((be = this.getInitSegment()) === null || be === void 0) && be.getParserMetadata() ? this.getInitSegment().getParserMetadata()[ue] : void 0;
          }, oe.prototype.getTimescale = function() {
            return this.getParserMetadataValue("timescale");
          }, oe.prototype.getIvSize = function() {
            return this.getParserMetadataValue("ivSize");
          }, oe.prototype.getDefaultSampleDuration = function() {
            return this.getParserMetadataValue("defaultSampleDuration");
          }, oe.prototype.getDefaultSampleSize = function() {
            return this.getParserMetadataValue("defaultSampleSize");
          }, oe.prototype.setTimescale = function(ue) {
            this.updateParserMetadata({ timescale: ue });
          }, oe.prototype.getPeriodId = function() {
            return this.periodId;
          }, oe.prototype.getCodec = function() {
            return this.codec;
          }, oe.prototype.setCodec = function(ue) {
            this.codec = ue;
          }, oe.prototype.getDuration = function() {
            return this.duration;
          }, oe.prototype.setDuration = function(ue) {
            this.duration = ue;
          }, oe.prototype.getNetworkRequestSize = function() {
            return this.networkRequestSize;
          }, oe.prototype.getRepresentationId = function() {
            return this.representationId;
          }, oe.prototype.getParsedData = function() {
            return this.parsedData;
          }, oe.prototype.setParsedData = function(ue) {
            this.parsedData = ue;
          }, oe.prototype.getSegmentInfo = function() {
            return this.segmentInfo;
          }, oe.prototype.isIndependentlyDecodable = function() {
            return this.isSegmentIndependentlyDecodable;
          }, oe.prototype.setSegmentInfo = function(ue) {
            this.segmentInfo = ue;
          }, oe.prototype.getMediaInfo = function() {
            var ue = {};
            return this.segmentInfo && this.segmentInfo.bitrate && (ue.bitrate = this.segmentInfo.bitrate), _e.MimeTypeHelper.isAudio(this.mimeType) ? this.segmentInfo && this.segmentInfo.sampleRate && (ue.sampleRate = this.segmentInfo.sampleRate) : _e.MimeTypeHelper.isVideo(this.mimeType) && (this.segmentInfo && this.segmentInfo.width && (ue.width = this.segmentInfo.width), this.segmentInfo && this.segmentInfo.height && (ue.height = this.segmentInfo.height), this.segmentInfo && this.segmentInfo.frameRate && (ue.frameRate = this.segmentInfo.frameRate)), ue;
          }, oe.prototype.isDirty = function() {
            return this._isDirty;
          }, oe.prototype.setDirty = function(ue) {
            this._isDirty = ue;
          }, oe.prototype.setInbandEvents = function(ue) {
            this.inbandEvents = ue;
          }, oe.prototype.getInbandEvents = function() {
            return this.inbandEvents;
          }, oe.prototype.setLastSegment = function(ue) {
            this.lastSegment = ue;
          }, oe.prototype.isLastSegment = function() {
            return this.lastSegment;
          }, oe.prototype.wasLoadedFrom = function(ue) {
            return this.getUrl().includes(ue);
          }, oe.prototype.getParserMetadata = function() {
            return this.parserMetadata;
          }, oe.prototype.setParserMetadata = function(ue) {
            this.parserMetadata = ue;
          }, oe.prototype.updateParserMetadata = function(ue) {
            this.parserMetadata = ae(ae({}, this.parserMetadata), ue);
          }, oe.prototype.setBufferBlockId = function(ue) {
            this.bufferBlockId = ue;
          }, oe.prototype.getBufferBlockId = function() {
            return this.bufferBlockId;
          }, oe.prototype.setInitSegment = function(ue) {
            this.initSegment = ue;
          }, oe.prototype.getInitSegment = function() {
            return this.initSegment;
          }, oe;
        }();
        ne.Segment = se, function(oe) {
          oe[oe.NONE = 0] = "NONE", oe[oe.INIT = 1] = "INIT", oe[oe.SELF_INIT = 2] = "SELF_INIT";
        }(ce || (ne.SegmentInitType = ce = {}));
      }, 48928: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ManifestCachingService = void 0;
        var ae = ie(76885), ce = function() {
          function le() {
            this.cache = {};
          }
          return le.prototype.set = function(se, oe, ue) {
            var be = ae.URLHelper.toFullUrl(se);
            he(be, this.cache), this.cache[be][oe] = ue;
          }, le.prototype.setExpire = function(se, oe) {
            var ue = ae.URLHelper.toFullUrl(se);
            he(ue, this.cache), this.cache[ue].expire = oe;
          }, le.prototype.get = function(se, oe) {
            var ue = ae.URLHelper.toFullUrl(oe), be = this.cache[ue];
            if (be && _e(be.expire))
              return be[se];
            delete this.cache[ue];
          }, le.prototype.cacheHttpResponse = function(se, oe, ue) {
            ue === void 0 && (ue = 1 / 0), this.set(oe, "httpResponse", se), this.setExpire(oe, ue);
          }, le.prototype.cacheParsedManifest = function(se, oe, ue) {
            ue === void 0 && (ue = 1 / 0), this.set(oe, "parsedManifest", se), this.setExpire(oe, ue);
          }, le.prototype.cacheSegmentList = function(se, oe, ue) {
            ue === void 0 && (ue = 1 / 0), this.set(oe, "segmentList", se), this.setExpire(oe, ue);
          }, le.prototype.getHttpResponse = function(se) {
            return this.get("httpResponse", se);
          }, le.prototype.getParsedManifest = function(se) {
            return this.get("parsedManifest", se);
          }, le.prototype.getSegmentList = function(se) {
            return this.get("segmentList", se);
          }, le.prototype.clear = function() {
            this.cache = {};
          }, le.prototype.dispose = function() {
            this.cache = {};
          }, le;
        }();
        function he(le, se) {
          se[le] || (se[le] = {});
        }
        function _e(le) {
          return le >= Date.now();
        }
        ne.ManifestCachingService = ce;
      }, 49118: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.throwPlaylistDownloadError = _e;
        var ae = ie(25550), ce = ie(28764), he = ie(90637);
        function _e(oe, ue, be, ve) {
          if (oe.logger.debug(ue), ve instanceof ce.PlayerError)
            oe.eventHandler.fireError(ve);
          else if (se(ve)) {
            var me = ae.ErrorCode[ve];
            oe.eventHandler.fireError(new ce.PlayerError(me, le(be), ue));
          } else
            ve !== he.RequestError.TimedOut ? oe.eventHandler.fireError(new ce.PlayerError(ae.ErrorCode.SOURCE_COULD_NOT_LOAD_MANIFEST, le(be), ue)) : oe.eventHandler.fireError(new ce.PlayerError(ae.ErrorCode.NETWORK_MANIFEST_DOWNLOAD_TIMEOUT, le(be), "Failed to load the segment: the request timed out."));
        }
        function le(oe) {
          return { url: oe == null ? void 0 : oe.Uri, mimeType: oe == null ? void 0 : oe._mimeType, codecs: oe == null ? void 0 : oe._codecs, bitrate: oe == null ? void 0 : oe._bandwidth };
        }
        function se(oe) {
          return !!oe && Object.keys(ae.ErrorCode).includes(oe);
        }
      }, 49233: function(ee, ne, ie) {
        var ae, ce = this && this.__assign || function() {
          return ce = Object.assign || function(Se) {
            for (var Ce, Ie = 1, Te = arguments.length; Ie < Te; Ie++)
              for (var Ee in Ce = arguments[Ie])
                Object.prototype.hasOwnProperty.call(Ce, Ee) && (Se[Ee] = Ce[Ee]);
            return Se;
          }, ce.apply(this, arguments);
        }, he = this && this.__spreadArray || function(Se, Ce, Ie) {
          if (Ie || arguments.length === 2)
            for (var Te, Ee = 0, we = Ce.length; Ee < we; Ee++)
              !Te && Ee in Ce || (Te || (Te = Array.prototype.slice.call(Ce, 0, Ee)), Te[Ee] = Ce[Ee]);
          return Se.concat(Te || Array.prototype.slice.call(Ce));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.BufferReducer = void 0;
        var _e = ie(92712), le = ie(21829), se = ie(18434), oe = ie(16280);
        function ue() {
          return { isLoadingRangeFinished: !1, isBufferBlockSwitchOngoing: !1, isTimestampRollingOver: !1, bufferStateMap: {} };
        }
        function be(Se, Ce) {
          var Ie, Te = Ce.payload;
          return ce(ce({}, Se), { bufferStateMap: ce(ce({}, Se.bufferStateMap), (Ie = {}, Ie[Te.mimeType] = ce(ce({}, Se.bufferStateMap[Te.mimeType]), { rendererRanges: Te.ranges }), Ie)) });
        }
        function ve(Se, Ce) {
          var Ie, Te = Ce.payload;
          return ce(ce({}, Se), { bufferStateMap: ce(ce({}, Se.bufferStateMap), (Ie = {}, Ie[Te.mimeType] = ce(ce({}, Se.bufferStateMap[Te.mimeType]), { maxBufferSize: Te.maxBufferSize }), Ie)) });
        }
        function me(Se, Ce) {
          var Ie = Ce.payload;
          return ce(ce({}, Se), { isBufferBlockSwitchOngoing: Ie.isOngoing });
        }
        function pe(Se, Ce) {
          var Ie = Ce.payload;
          return ce(ce({}, Se), { isTimestampRollingOver: Ie.isRollingOver });
        }
        function fe(Se, Ce) {
          var Ie, Te, Ee, we = Ce.payload, Pe = we.mimeType, Me = we.range;
          if (!Pe)
            return Se;
          var Ae = (Ee = (Te = Se.bufferStateMap[Pe]) === null || Te === void 0 ? void 0 : Te.loadedRanges) !== null && Ee !== void 0 ? Ee : [];
          return Ae.some(function(Oe) {
            return (0, _e.isFullyIncluded)(Me, Oe);
          }) ? Se : ce(ce({}, Se), { bufferStateMap: ce(ce({}, Se.bufferStateMap), (Ie = {}, Ie[Pe] = ce(ce({}, Se.bufferStateMap[Pe]), { loadedRanges: oe.mergeBufferBlockTimeRanges.apply(void 0, he(he([], Ae, !1), [Me], !1)) }), Ie)) });
        }
        function ge(Se, Ce) {
          var Ie, Te, Ee, we = Ce.payload, Pe = we.mimeType, Me = we.range;
          if (!Pe)
            return Se;
          var Ae = (Ee = (Te = Se.bufferStateMap[Pe]) === null || Te === void 0 ? void 0 : Te.loadedRanges) !== null && Ee !== void 0 ? Ee : [];
          return Ae.every(function(Oe) {
            return !(0, _e.isOverlapping)(Me, Oe);
          }) ? Se : ce(ce({}, Se), { bufferStateMap: ce(ce({}, Se.bufferStateMap), (Ie = {}, Ie[Pe] = ce(ce({}, Se.bufferStateMap[Pe]), { loadedRanges: (0, oe.excludeBufferBlockTimeRange)(Ae, Me) }), Ie)) });
        }
        function ye(Se, Ce) {
          var Ie, Te, Ee, we = Ce.payload.mimeType;
          if (we === void 0) {
            if (Se === void 0)
              return ue();
            var Pe = ce(ce({}, Se), { bufferStateMap: ce({}, Se.bufferStateMap) });
            return Object.keys(Pe.bufferStateMap).forEach(function(Me) {
              Pe.bufferStateMap[Me] = ce(ce({}, Pe.bufferStateMap[Me]), { loadedRanges: [] });
            }), Pe;
          }
          return ((Ee = (Te = Se.bufferStateMap[we]) === null || Te === void 0 ? void 0 : Te.loadedRanges) !== null && Ee !== void 0 ? Ee : []).length > 0 ? ce(ce({}, Se), { bufferStateMap: ce(ce({}, Se.bufferStateMap), (Ie = {}, Ie[we] = ce(ce({}, Se.bufferStateMap[we]), { loadedRanges: [] }), Ie)) }) : Se;
        }
        function $e(Se, Ce) {
          var Ie = Ce.payload.isFinished;
          return Ie !== Se.isLoadingRangeFinished ? ce(ce({}, Se), { isLoadingRangeFinished: Ie }) : Se;
        }
        ne.BufferReducer = (0, le.default)(ue(), ((ae = {})[se.BufferActionType.SetBufferMaxSize] = ve, ae[se.BufferActionType.SetRendererRanges] = be, ae[se.BufferActionType.SetBufferBlockSwitchOngoing] = me, ae[se.BufferActionType.SetTimestampRollingOver] = pe, ae[se.BufferActionType.AddLoadedRange] = fe, ae[se.BufferActionType.RemoveLoadedRange] = ge, ae[se.BufferActionType.ResetLoadedRanges] = ye, ae[se.BufferActionType.SetLoadingRangeFinished] = $e, ae));
      }, 55486: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.removeEncryptionKey = ne.updateEncryptionKey = ne.addEncryptionKey = void 0;
        var ae = ie(15231), ce = ie(56092), he = function(se) {
          return (0, ae.createAction)(ce.EncryptionKeyActionKey.AddEncryptionKey, se);
        };
        ne.addEncryptionKey = he;
        var _e = function(se) {
          return (0, ae.createAction)(ce.EncryptionKeyActionKey.UpdateEncryptionKey, se);
        };
        ne.updateEncryptionKey = _e;
        var le = function(se) {
          return (0, ae.createAction)(ce.EncryptionKeyActionKey.RemoveEncryptionKey, { keyUri: se });
        };
        ne.removeEncryptionKey = le;
      }, 55937: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.BufferBlock = ne.EncryptionState = void 0, ne.isPrecedingSegment = se;
        var ae, ce = ie(79814), he = ie(37702);
        (function(oe) {
          oe.Encrypted = "encrypted", oe.Clear = "clear";
        })(ae || (ne.EncryptionState = ae = {}));
        var _e = function() {
          function oe(ue) {
            this.trackedDiscoNumbersMap = {}, this.id = ue, this.cachedSegments = [], this.blockStateMap = /* @__PURE__ */ new Map();
          }
          return oe.prototype.addSegment = function(ue) {
            var be = ue.getMimeType();
            this.trackedDiscoNumbersMap[be] || (this.trackedDiscoNumbersMap[be] = []), ue.isInit() && this.removeLastInitSegment(be), this.periodId === void 0 && (this.periodId = ue.getPeriodId());
            var ve = ue.getSegmentInfo().discontinuitySequenceNumber;
            ve == null || this.trackedDiscoNumbersMap[be].includes(ve) || this.trackedDiscoNumbersMap[be].push(ve);
            var me = ue.isInit() ? 0 : ue.getDuration();
            this.cachedSegments.push({ segment: ue }), ue.isInit() || (this.setMaxSegmentDuration(be, Math.max(me, this.getMaxSegmentDuration(be))), this.updatePlaybackTimeRange(ue, be)), ue.setBufferBlockId(this.id), this.updateMediaTypes(ue);
          }, oe.prototype.setSegregationCriteria = function(ue, be) {
            this.blockStateMap.has(be) || this.initializeBlockStateMapForMimeType(be), this.getBlockState(be).segregationCriteria = ue;
          }, oe.prototype.initializeBlockStateMapForMimeType = function(ue) {
            var be = {};
            return this.blockStateMap.set(ue, be), be;
          }, oe.prototype.updateMediaTypeForMimeType = function(ue) {
            var be = this.getBlockState(ue.mimeType) || this.initializeBlockStateMapForMimeType(ue.mimeType);
            be.mediaType ? (le(ue, "codec", function(ve) {
              be.mediaType.codec = ve;
            }), le(ue, "timestampOffset", function(ve) {
              be.mediaType.timestampOffset = ve;
            }), le(ue, "timescale", function(ve) {
              be.mediaType.timescale = ve;
            })) : be.mediaType = ue;
          }, oe.prototype.getSegregationCriteria = function(ue) {
            var be;
            return (be = this.getBlockState(ue)) === null || be === void 0 ? void 0 : be.segregationCriteria;
          }, oe.prototype.updateMediaTypes = function(ue) {
            var be = ue.getMimeType(), ve = this.getMediaType(be);
            ve ? (ve.codec === null && (ve.codec = ue.getCodec()), ve.timescale == null && (ve.timescale = ue.getTimescale())) : (this.blockStateMap.has(be) || this.blockStateMap.set(be, {}), this.getBlockState(be).mediaType = { mimeType: be, codec: ue.getCodec(), timestampOffset: 0, timescale: ue.getTimescale() });
          }, oe.prototype.getMediaType = function(ue) {
            var be, ve;
            return (ve = (be = this.getBlockState(ue)) === null || be === void 0 ? void 0 : be.mediaType) !== null && ve !== void 0 ? ve : null;
          }, oe.prototype.addMediaType = function(ue) {
            ce.MimeTypeHelper.isAV(ue.mimeType) && !this.getMediaType(ue.mimeType) && (this.blockStateMap.has(ue.mimeType) || this.initializeBlockStateMapForMimeType(ue.mimeType), this.getBlockState(ue.mimeType).mediaType = ue);
          }, oe.prototype.removeMediaType = function(ue) {
            this.clearSegments(ue), this.blockStateMap.delete(ue);
          }, oe.prototype.hasMediaType = function(ue) {
            var be, ve;
            return (ve = (be = this.blockStateMap) === null || be === void 0 ? void 0 : be.has(ue)) !== null && ve !== void 0 && ve;
          }, oe.prototype.getMediaTypes = function() {
            return (0, he.getValues)(this.blockStateMap).map(function(ue) {
              return ue.mediaType;
            });
          }, oe.prototype.getMediaTypesWithoutSubs = function() {
            return this.getMediaTypes().filter(function(ue) {
              return ce.MimeTypeHelper.isAV(ue.mimeType);
            });
          }, oe.prototype.removeSegment = function(ue) {
            var be = this.cachedSegments.findIndex(function(ve) {
              return ve.segment === ue;
            });
            be > -1 && this.cachedSegments.splice(be, 1);
          }, oe.prototype.clearSegments = function(ue) {
            this.cachedSegments = this.cachedSegments.filter(function(ve) {
              return ve.segment.getMimeType() !== ue;
            });
            var be = this.getBlockState(ue);
            be && (be.playbackTimeRange = void 0), this.trackedDiscoNumbersMap[ue] = [];
          }, oe.prototype.getPrecedingSegments = function(ue, be) {
            var ve = [];
            return this.cachedSegments.forEach(function(me) {
              se(me.segment, ue, be) && ve.push(me.segment);
            }), ve;
          }, oe.prototype.updatePlaybackTimeRange = function(ue, be) {
            var ve = this.getPlaybackTimeRange(be), me = ue.getPlaybackTime(), pe = me + ue.getDuration();
            ve ? (me < ve.start && (ve.start = me), pe > ve.end && (ve.end = pe)) : this.getBlockState(be).playbackTimeRange = { start: me, end: pe };
          }, oe.prototype.getPlaybackTimeRange = function(ue) {
            var be, ve;
            return (ve = (be = this.getBlockState(ue)) === null || be === void 0 ? void 0 : be.playbackTimeRange) !== null && ve !== void 0 ? ve : null;
          }, oe.prototype.getId = function() {
            return this.id;
          }, oe.prototype.getPeriodId = function() {
            return this.periodId;
          }, oe.prototype.getMinCommonStartTime = function() {
            return (0, he.getValues)(this.blockStateMap).filter(function(ue) {
              return ue.playbackTimeRange;
            }).map(function(ue) {
              return ue.playbackTimeRange;
            }).reduce(function(ue, be) {
              return Math.max(be.start, ue);
            }, -1 / 0);
          }, oe.prototype.getCommonPlaybackTimeRanges = function() {
            return (0, he.getValues)(this.blockStateMap).filter(function(ue) {
              return ue.playbackTimeRange;
            }).map(function(ue) {
              return ue.playbackTimeRange;
            }).reduce(function(ue, be) {
              return { start: Math.max(be.start, ue.start), end: Math.min(be.end, ue.end) };
            }, { start: -1 / 0, end: 1 / 0 });
          }, oe.prototype.setMaxSegmentDuration = function(ue, be) {
            this.blockStateMap.has(ue) || this.initializeBlockStateMapForMimeType(ue), this.getBlockState(ue).maxSegmentDuration = be;
          }, oe.prototype.getMaxSegmentDuration = function(ue) {
            var be;
            return ((be = this.getBlockState(ue)) === null || be === void 0 ? void 0 : be.maxSegmentDuration) || 0;
          }, oe.prototype.hasMaxSegmentDuration = function(ue) {
            var be;
            return ((be = this.getBlockState(ue)) === null || be === void 0 ? void 0 : be.maxSegmentDuration) != null;
          }, oe.prototype.hasMaxSegmentDurations = function() {
            return !!(0, he.getValues)(this.blockStateMap).map(function(ue) {
              return ue.maxSegmentDuration;
            }).find(function(ue) {
              return ue >= 0;
            });
          }, oe.prototype.getMinMaxSegmentDuration = function() {
            var ue = Number.MAX_VALUE;
            return (0, he.getValues)(this.blockStateMap).map(function(be) {
              return be.maxSegmentDuration;
            }).forEach(function(be) {
              return ue = be < ue ? be : ue;
            }), ue;
          }, oe.prototype.getAllSegmentsForMimeType = function(ue) {
            return this.getAllSegments().filter(function(be) {
              return be.getMimeType() === ue;
            });
          }, oe.prototype.getAllSegments = function() {
            return this.cachedSegments.map(function(ue) {
              return ue.segment;
            });
          }, oe.prototype.hasDataSegments = function(ue) {
            return this.cachedSegments.some(function(be) {
              return !be.segment.isInit() && be.segment.getMimeType() === ue;
            });
          }, oe.prototype.hasSegments = function() {
            return this.getAllSegments().length > 0;
          }, oe.prototype.hasTrackedDiscontinuity = function(ue) {
            var be = this;
            return Object.keys(this.trackedDiscoNumbersMap).some(function(ve) {
              return be.trackedDiscoNumbersMap[ve].includes(ue);
            });
          }, oe.prototype.getNextSegment = function() {
            var ue = this.cachedSegments.filter(function(ve) {
              return !ve.pendingRemoval;
            });
            if (ue.length === 0)
              return null;
            var be = ue.find(function(ve) {
              return ue.filter(function(me) {
                return ve.segment.getMimeType() === me.segment.getMimeType();
              }).some(function(me) {
                return !me.segment.isInit();
              });
            });
            return be ? (be.pendingRemoval = !0, be.segment) : null;
          }, oe.prototype.removeLastInitSegment = function(ue) {
            var be = this.getAllSegmentsForMimeType(ue);
            if (be.length > 0) {
              var ve = be[be.length - 1];
              ve.isInit() && this.removeSegment(ve);
            }
          }, oe.prototype.getBlockState = function(ue) {
            return this.blockStateMap.get(ue);
          }, Object.defineProperty(oe.prototype, "mediaTypes", { get: function() {
            var ue = {};
            return this.blockStateMap.forEach(function(be, ve) {
              ue[ve] = be.mediaType;
            }), ue;
          }, enumerable: !1, configurable: !0 }), oe.prototype.getMinDistanceFromBufferBlock = function(ue) {
            var be = this.getCommonPlaybackTimeRanges();
            return Math.min(Math.min(Math.abs(ue.getPlaybackTime() - be.start), Math.abs(ue.getPlaybackTime() - be.end)), Math.min(Math.abs(ue.getPlaybackEndTime() - be.start), Math.abs(ue.getPlaybackEndTime() - be.end)));
          }, oe;
        }();
        function le(oe, ue, be) {
          oe.hasOwnProperty(ue) && be(oe[ue]);
        }
        function se(oe, ue, be) {
          var ve = oe.isInit(), me = oe.getMimeType() !== ue;
          return !ve && !me && oe.getPlaybackTime() + oe.getDuration() < be;
        }
        ne.BufferBlock = _e;
      }, 56092: function(ee, ne) {
        var ie, ae;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.EncryptionKeyActionKey = ne.KeyLoadState = void 0, function(ce) {
          ce.Loading = "loading", ce.Loaded = "loaded", ce.Cancel = "cancel";
        }(ie || (ne.KeyLoadState = ie = {})), function(ce) {
          ce.AddEncryptionKey = "@instance/sources/@source/encryptionkey/addEncryptionKey", ce.UpdateEncryptionKey = "@instance/sources/@source/encryptionkey/updateEncryptionKey", ce.RemoveEncryptionKey = "@instance/sources/@source/encryptionkey/removeEncryptionKey";
        }(ae || (ne.EncryptionKeyActionKey = ae = {}));
      }, 58211: function(ee, ne, ie) {
        var ae, ce = this && this.__assign || function() {
          return ce = Object.assign || function(be) {
            for (var ve, me = 1, pe = arguments.length; me < pe; me++)
              for (var fe in ve = arguments[me])
                Object.prototype.hasOwnProperty.call(ve, fe) && (be[fe] = ve[fe]);
            return be;
          }, ce.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.PlayingTracksReducer = ne.wasSwitchingToPeriodIdReset = ne.getPlayingTracksState = ne.getPlayingPeriodId = void 0;
        var he = ie(21829), _e = ie(98086), le = {}, se = function(be) {
          var ve;
          return (ve = be.playingTracks) === null || ve === void 0 ? void 0 : ve.playingPeriodId;
        };
        ne.getPlayingPeriodId = se;
        var oe = function(be) {
          return be.playingTracks;
        };
        ne.getPlayingTracksState = oe;
        var ue = function(be, ve) {
          return (ve == null ? void 0 : ve.switchingToPeriodId) !== void 0 && (be == null ? void 0 : be.switchingToPeriodId) === void 0;
        };
        ne.wasSwitchingToPeriodIdReset = ue, ne.PlayingTracksReducer = (0, he.default)(le, ((ae = {})[_e.PlayingTracksActionKey.SetPlayingPeriodId] = function(be, ve) {
          var me = ve.payload;
          return ce(ce({}, be), { playingPeriodId: me });
        }, ae[_e.PlayingTracksActionKey.FinishedPeriodSwitch] = function(be, ve) {
          var me = ve.payload;
          return ce(ce({}, be), { switchingToPeriodId: be.switchingToPeriodId === me ? void 0 : be.switchingToPeriodId });
        }, ae[_e.PlayingTracksActionKey.StartedPeriodSwitch] = function(be, ve) {
          var me = ve.payload;
          return ce(ce({}, be), { switchingToPeriodId: me });
        }, ae));
      }, 58423: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(it) {
            for (var et, st = 1, mt = arguments.length; st < mt; st++)
              for (var St in et = arguments[st])
                Object.prototype.hasOwnProperty.call(et, St) && (it[St] = et[St]);
            return it;
          }, ae.apply(this, arguments);
        }, ce = this && this.__spreadArray || function(it, et, st) {
          if (st || arguments.length === 2)
            for (var mt, St = 0, $t = et.length; St < $t; St++)
              !mt && St in et || (mt || (mt = Array.prototype.slice.call(et, 0, St)), mt[St] = et[St]);
          return it.concat(mt || Array.prototype.slice.call(et));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentController = void 0, ne.getSegmentManager = dt, ne.extractContainerFormat = ft;
        var he = ie(52442), _e = ie(25550), le = ie(28764), se = ie(63546), oe = ie(35148), ue = ie(18665), be = ie(60997), ve = ie(62510), me = ie(58935), pe = ie(90637), fe = ie(57782), ge = ie(28463), ye = ie(76650), $e = ie(28819), Se = ie(8272), Ce = ie(27279), Ie = ie(3464), Te = ie(27177), Ee = ie(42283), we = ie(79814), Pe = ie(65114), Me = ie(331), Ae = ie(70016), Oe = ie(76885), Be = ie(91520), Ve = ie(16368), Ue = ie(41108), Re = ie(73543), Ne = ie(94938), xe = ie(43752), ke = ie(22916), Le = ie(96707), He = ie(30855), We = ie(4053), Xe = ie(82311), Qe = ie(41735), tt = ie(58211), Je = ie(59839), Ge = ie(22645), Ye = ie(93109), ze = ie(9140), Fe = ie(74830), ot = ie(84519), vt = ie(49118), gt = ie(41661), yt = ie(20417), pt = ie(28915), bt = ie(66864), ut = ie(60704), Ke = ie(12482), je = function() {
          function it(et, st, mt, St, $t, Tt, rt, qe) {
            var Ze = this;
            this.context = et, this.onDataAvailableCallback = st, this.mimeType = mt, this.manifestLoader = Tt, this.HLSModule = Be.ModuleManager.get(Ve.ModuleName.HLS, !1), this.loadedAdaptationSetIds = {}, this.loadingDataSegmentInfos = [], this.isBackupStreamSwitchOngoing = !1, this.hasDownloadError = !1, this.invalidateOngoingSegmentInfoRequest = !1, this.disableDownloadCancelingForNextSegment = !1, this.isProcessingSegment = !1, this.parkedSegmentSubscriptions = [], this.onSegmentInfoError = function(Ct) {
              if ((0, Te.isContextAvailable)(Ze.context)) {
                var wt = "Error obtaining ".concat(Ze.mimeType, " segment info");
                Ze.lastSegmentInfoError && Ze.lastSegmentInfoError === Ct ? Ze.logger.insane(wt, Ct) : Ze.debug(wt, Ct), Ze.lastSegmentInfoError = Ct;
              }
            }, this.handleCancelLoadingError = function(Ct) {
              Ze.debug("Error in cancelLoading of segmentLoaderPool ", Ct);
            }, this.getNext = function(Ct, wt) {
              var It, Pt = !(!((It = Ze.segmentManager) === null || It === void 0) && It.canLoad()) || Ze.pendingSegmentInfoRequest || Ze.hasActiveTransmuxingJobs() || Ze.isBackupStreamSwitchOngoing || Ze.isProcessingSegment;
              if (Ze.currentAdaptationSetId && !Pt) {
                Ze.debug("Getting next segment for time ".concat(Ct));
                var kt = { periodId: Ze.currentPeriodId, recommendedRepresentationId: wt, time: Ct };
                Ze.getSegmentInfo(kt).then(function(Mt) {
                  return Ze.loadFromSegmentInfo(Mt);
                }).catch(Ze.onSegmentInfoError);
              }
            }, this.onSegmentLoaded = function(Ct) {
              Ze.hasDownloadError = !1, Ze.maybeUpdateContainerFormat(Ct);
              var wt = Ze.verifySegment(Ct);
              if (wt !== he.SegmentVerificationResult.Drop) {
                if (wt !== he.SegmentVerificationResult.Park)
                  if (Ze.isTransmuxerRequired()) {
                    var It = Ct.getSegmentInfo();
                    It.presentationTimeOffset && isNaN(It.presentationTimeOffset) && (Ze.mpdHandler.setTimestampOffset(0), It.presentationTimeOffset = 0), Ze.transmux(Ct);
                  } else {
                    var Pt = !1;
                    Ze.currentAdaptationSetId && Ze.segmentManager && (Pt = Ze.segmentPreProcessor.onSegmentAvailable(Ct, { id3: [], closedCaptions: [] }, Ze.currentAdaptationSetId, Ze.segmentManager)), Pt || at(Ct.getSegmentInfo(), Ze.sourceStore), Ct.getMimeType().indexOf("mp4") > -1 && !Ze.maybeIsHlsManifest() && (Ze.isLastSegment = Ct.isLastSegment());
                  }
              } else
                at(Ct.getSegmentInfo(), Ze.sourceStore);
            }, this.onShouldDownloadBeCancelled = function(Ct, wt) {
              var It, Pt = !!(!((It = Ze.adaptationService) === null || It === void 0) && It.shouldDownloadBeCancelled(Ze.mimeType, Ct, wt));
              return Ze.maybeIsHlsManifest() && Ze.hls.possiblyDependentSegments && Pt ? (Ze.debug("Download should be cancelled, but this is disabled for segments not starting with key frames"), !1) : Pt;
            };
            var ht = et.sourceContext.sourceIdentifier;
            if (this.currentPeriodId = rt, this.sourceStore = qe, this.manifestUpdateScheduler = et.serviceManager.get(ue.ServiceName.ManifestUpdateSchedulingService, ht), this.segmentUnavailabilityHandler = new He.SegmentUnavailabilityHandler(this.context), this.adaptationService = this.context.serviceManager.get(ue.ServiceName.AdaptationService), this.streamTimeService = this.context.serviceManager.get(ue.ServiceName.StreamTimeService), this.hls = { isTransmuxingRequired: $t && !this.isSubtitleSegmentController, transmuxer: void 0, possiblyDependentSegments: !1, isAvMuxedTogether: (0, Ee.isAVMuxedTogether)(St), discardNextSegment: !1, muxedAudioTrackIndex: 0 }, this.isContainerFormatKnown()) {
              var _t = this.getContainerFormat();
              this.hls.isTransmuxingRequired = _t.source !== _t.target;
            }
            this.init();
          }
          return Object.defineProperty(it.prototype, "logger", { get: function() {
            return this.context.logger;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(it.prototype, "settings", { get: function() {
            return this.context.settings;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(it.prototype, "eventHandler", { get: function() {
            return this.context.eventHandler;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(it.prototype, "segmentManager", { get: function() {
            return dt(this.context, this.mimeType, this.segmentParser, this.hls, this.currentLangObj);
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(it.prototype, "isSubtitleSegmentController", { get: function() {
            return we.MimeTypeHelper.isSubtitle(this.mimeType);
          }, enumerable: !1, configurable: !0 }), it.prototype.getUserFeedbackForAdaptation = function(et) {
            var st, mt = this.getAdaptationEventType();
            if (mt) {
              var St = (st = this.adaptationService) === null || st === void 0 ? void 0 : st.getUserSelectedRepresentation(this.mimeType, this.currentAdaptationSetId, et);
              return St ? (this.eventHandler.dispatchEvent(mt, { representationID: St._internalId.representationId }), St._internalId) : void this.eventHandler.dispatchEvent(mt, { representationID: et.representationId });
            }
          }, it.prototype.getAdaptationEventType = function() {
            return we.MimeTypeHelper.isAudio(this.mimeType) ? ve.PlayerEvent.AudioAdaptation : we.MimeTypeHelper.isVideo(this.mimeType) ? ve.PlayerEvent.VideoAdaptation : null;
          }, it.prototype.getPrefetchedRepresentationId = function() {
            var et;
            if (!((et = this.context.adRestorationOptimizationService) === null || et === void 0) && et.hasPrefetchedSegment(this.mimeType, this.lastSegmentInfo))
              return this.context.adRestorationOptimizationService.getRepresentationForPrefetchedSegment(this.mimeType);
          }, it.prototype.selectRepresentation = function(et) {
            if (!this.mpdHandler.canSwitchRepresentation(et.time) && this.currentRepresentationId)
              return this.currentRepresentationId;
            var st = this.getPrefetchedRepresentationId();
            if (st)
              return st;
            var mt = this.sourceStore.getState(), St = !!mt && !!(0, ge.getPreferredBitrate)((0, ge.getAdaptationState)(mt), this.mimeType), $t = this.getSuggestedRepresentationFromAbr(), Tt = et.recommendedRepresentationId, rt = (Tt == null ? void 0 : Tt.periodId) === this.getCurrentPeriodId();
            Tt && rt && !St && ($t = Tt);
            var qe = $t ? this.getUserFeedbackForAdaptation($t) : void 0;
            return qe ? (this.disableDownloadCancelingForNextSegment = !0, qe) : $t;
          }, it.prototype.getSuggestedRepresentationFromAbr = function() {
            var et, st, mt = { hlsDependentSegments: this.hls.possiblyDependentSegments, segmentDuration: this.mpdHandler.getSegmentDuration() };
            return (et = this.adaptationService) === null || et === void 0 ? void 0 : et.selectRepresentation(this.mimeType, mt, (st = this.getCurrentAdaptationSet()) === null || st === void 0 ? void 0 : st.Representation);
          }, it.prototype.switchRepresentation = function(et) {
            var st = this.currentRepresentationId ? this.currentRepresentationId.representationId : null;
            this.debug("switching representation from ".concat(st, " to ").concat(et.representationId)), this.mpdHandler.setRepresentationId(et), this.currentRepresentationId = et;
          }, it.prototype.invalidateOngoingRequests = function() {
            this.invalidateOngoingSegmentInfoRequest = !0;
          }, it.prototype.fireQualityChangeEvent = function(et, st) {
            var mt, St = nt(et, this.context), $t = nt(st, this.context), Tt = St ? (0, xe.representationToQuality)(St, this.mimeType) : void 0, rt = $t ? (0, xe.representationToQuality)($t, this.mimeType) : void 0;
            if (rt) {
              var qe = { targetQuality: rt, targetQualityId: rt.id, sourceQuality: Tt, sourceQualityId: (mt = Tt == null ? void 0 : Tt.id) !== null && mt !== void 0 ? mt : null };
              we.MimeTypeHelper.isVideo(this.mimeType) ? this.context.eventHandler.dispatchEvent(ve.PlayerEvent.VideoDownloadQualityChange, qe) : we.MimeTypeHelper.isAudio(this.mimeType) && this.context.eventHandler.dispatchEvent(ve.PlayerEvent.AudioDownloadQualityChange, qe);
            }
          }, it.prototype.getSegmentInfo = function(et) {
            var st, mt = this, St = ((st = this.lastSegmentInfo) === null || st === void 0 ? void 0 : st.segmentNumber) !== void 0 ? this.lastSegmentInfo.segmentNumber + 1 : 0, $t = this.selectRepresentation(et);
            this.sourceStore.dispatch((0, We.setRepresentationIdAction)($t));
            var Tt = !$t.equals(this.currentRepresentationId);
            return Tt && we.MimeTypeHelper.isAV(this.mimeType) && this.fireQualityChangeEvent(this.currentRepresentationId, $t), this.invalidateOngoingSegmentInfoRequest = !1, this.pendingSegmentInfoRequest = this.maybeWaitForRepresentationUpdate($t, Tt).then(function() {
              return mt.currentAdaptationSetId && mt.mpdHandler.setAdaptationSetId(mt.currentAdaptationSetId, $t), Tt && mt.switchRepresentation($t), mt.mpdHandler.getNextSegmentInfo(et.time);
            }).then(function(rt) {
              var qe, Ze = (qe = mt.currentRepresentationId) !== null && qe !== void 0 ? qe : $t;
              if (mt.addSegmentInfos(rt, St, Ze), mt.shouldInvalidateSegmentInfo(rt))
                throw (0, Te.isContextAvailable)(mt.context) && mt.debug("invalidating ongoing SegmentInfo request for", ae({}, rt)), "ongoing segment info request was invalidated";
              return mt.lastSegmentInfo = rt, rt;
            }).catch(function(rt) {
              var qe, Ze;
              if (mt.pendingSegmentInfoRequest = void 0, ct(rt)) {
                var ht = (Ze = (qe = rt == null ? void 0 : rt.name) !== null && qe !== void 0 ? qe : rt == null ? void 0 : rt.message) !== null && Ze !== void 0 ? Ze : rt;
                mt.debug("HLS playlist loading failed for representation ".concat($t.representationId, " (").concat(ht, ")"));
                var _t = mt.maybeTryLowerQuality($t);
                if (_t)
                  return mt.debug("Trying with lower quality representation ".concat(_t.representationId)), mt.getSegmentInfo(ae(ae({}, et), { recommendedRepresentationId: _t }));
                mt.handleFailedRepresentationDownload($t, rt);
              }
              throw rt;
            }).finally(function() {
              mt.expectedTargetTimeAfterSeek = void 0;
            }), this.pendingSegmentInfoRequest;
          }, it.prototype.shouldInvalidateSegmentInfo = function(et) {
            return this.invalidateOngoingSegmentInfoRequest && et && !et.isInitSegment && !this.isSegmentInfoInExpectedTimeRange(et);
          }, it.prototype.isSegmentInfoInExpectedTimeRange = function(et) {
            return this.expectedTargetTimeAfterSeek !== void 0 && (0, Ae.isNumber)(et.startTime) && (0, Ae.isNumber)(et.duration) && this.expectedTargetTimeAfterSeek >= et.startTime && this.expectedTargetTimeAfterSeek <= et.startTime + et.duration;
          }, it.prototype.getDataSegmentInfo = function(et) {
            var st = { periodId: this.currentPeriodId, time: et };
            return this.currentRepresentationId && this.currentRepresentationId.periodId === this.getCurrentPeriodId() ? this.getSegmentInfo(ae(ae({}, st), { recommendedRepresentationId: this.currentRepresentationId })) : this.getSegmentInfo(st);
          }, it.prototype.addSegmentInfos = function(et, st, mt) {
            et && (this.applyRepresentationInformationToSegmentInfo(et, mt), this.parseDateTimeFormSegmentUrl(et), this.applyBaseUrlsToSegmentInfo(mt, et), et.duration || et.isInitSegment || (et.duration = this.mpdHandler.getSegmentDuration()), (et.segmentNumber === void 0 || isNaN(et.segmentNumber)) && (et.segmentNumber = st), et.discardData = this.hls.discardNextSegment, this.hls.discardNextSegment = !1, this.disableDownloadCancelingForNextSegment && (et.preventDownloadCanceling = !0, this.disableDownloadCancelingForNextSegment = !1));
          }, it.prototype.applyRepresentationInformationToSegmentInfo = function(et, st) {
            var mt = nt(st, this.context);
            mt && (et.representationId = st.representationId, et.internalRepresentationId = st, et.mimeType = this.mimeType, et.bitrate = mt._bandwidth, et.periodId = st.periodId, et.codecs = this.getCodecs(), we.MimeTypeHelper.isAudio(this.mimeType) ? (et.sampleRate = mt._audioSamplingRate, et.width = void 0, et.height = void 0) : we.MimeTypeHelper.isVideo(this.mimeType) && (et.width = mt._width, et.height = mt._height, et.frameRate = mt._frameRate));
          }, it.prototype.parseDateTimeFormSegmentUrl = function(et) {
            if (we.MimeTypeHelper.isVideo(this.mimeType) && !et.dateTime && this.settings.AKAMAI_DATETIME_PARSING && this.HLSModule) {
              var st = et.duration != null ? this.HLSModule.PlaylistUtils.getProgramDateTimeFromSegmentUrl(et.url, et.duration) : void 0;
              st && (et.dateTime = st);
            }
          }, it.prototype.applyBaseUrlsToSegmentInfo = function(et, st) {
            var mt = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(St) {
              return St.getAvailableBaseURLsForRepresentation(et);
            }, void 0, this.context.sourceContext.sourceIdentifier);
            st.availableBaseURLs = mt, st.firstUsedBaseURLIndex = 0, this.lastSegmentInfo && this.lastSegmentInfo.lastUsedBaseURLIndex && (st.firstUsedBaseURLIndex = this.lastSegmentInfo.lastUsedBaseURLIndex), st.lastUsedBaseURLIndex = st.firstUsedBaseURLIndex, this.maybeIsHlsManifest() ? (st.baseURL = "", st.mediaURL || (st.mediaURL = st.url)) : (st.baseURL = mt[st.firstUsedBaseURLIndex], st.mediaURL = st.mediaURL || st.url, delete st.url), st.url = Oe.URLHelper.concatBaseUrlWithPartial(st.baseURL, st.mediaURL);
          }, it.prototype.maybeWaitForRepresentationUpdate = function(et, st) {
            var mt = this;
            return st ? this.manifestUpdateScheduler ? this.manifestUpdateScheduler.waitForRepUpdate(et).then(function() {
              return mt.mpdHandler.updateRepresentation(et);
            }) : Promise.reject("ManifestUpdateScheduler does not exist.") : Promise.resolve();
          }, it.prototype.isTransmuxing = function() {
            var et;
            return this.isTransmuxerRequired() && !!(!((et = this.hls.transmuxer) === null || et === void 0) && et.isTransmuxing());
          }, it.prototype.hasActiveTransmuxingJobs = function() {
            var et;
            return !!this.isTransmuxerRequired() && (this.hasDelayedSegmentsInTransmuxer() || !!(!((et = this.hls.transmuxer) === null || et === void 0) && et.hasActiveJobs()));
          }, it.prototype.hasDelayedSegmentsInTransmuxer = function() {
            var et;
            return we.MimeTypeHelper.isAudio(this.mimeType) && this.isTransmuxerRequired() && !!(!((et = this.hls.transmuxer) === null || et === void 0) && et.hasDelayedAudioSegments());
          }, it.prototype.cancelTransmuxing = function() {
            var et, st, mt = this;
            ((st = (et = this.hls.transmuxer) === null || et === void 0 ? void 0 : et.discardCurrentJobs(this.mimeType)) !== null && st !== void 0 ? st : []).forEach(function(St) {
              return at(St.mp2tsSegment.getSegmentInfo(), mt.sourceStore);
            });
          }, it.prototype.cancelLoading = function() {
            var et;
            this.invalidateOngoingSegmentInfoRequest = !0, (et = this.segmentManager) === null || et === void 0 || et.cancel().catch(this.handleCancelLoadingError);
          }, it.prototype.seekTo = function(et) {
            var st = this;
            et !== null && this.currentAdaptationSetId && (this.cancelLoading(), this.cancelTransmuxing(), this.loadingDataSegmentInfos = [], this.hasDownloadError = !1, this.isLastSegment = !1, this.hlsTimelineTracker && this.hlsTimelineTracker.reset(), this.isTransmuxerRequired() && this.hls.transmuxer && this.hls.transmuxer.resetCaptionParser(), et >= 0 && (this.expectedTargetTimeAfterSeek = et, this.mpdHandler.seekTo(et), this.context.serviceManager.maybeCall(ue.ServiceName.TimedMetadataService, function(mt) {
              return mt.clearSegmentBoundMetadata(st.mimeType);
            })));
          }, it.prototype.hasNextVod = function(et) {
            var st, mt = this, St = this.maybeFindPeriod(this.currentPeriodId), $t = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(Tt) {
              return Tt.getMediaPresentationDuration();
            }, 0, this.context.sourceContext.sourceIdentifier);
            if (St && St.hasOwnProperty("_duration"))
              st = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(Tt) {
                return Tt.getPeriodDuration(mt.currentPeriodId);
              }, void 0, this.context.sourceContext.sourceIdentifier);
            else {
              if ($t === 0)
                return !1;
              st = $t;
            }
            return this.mpdHandler.hasNext(st);
          }, it.prototype.hasNextLive = function(et) {
            var st = this;
            if (this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(St) {
              return St.isAvailabilityEndTimeExceeded();
            }, !1, this.context.sourceContext.sourceIdentifier))
              return this.logger.log("Stream (".concat(this.mimeType, ") availability end time reached, stopping download of further segments.")), this.isLastSegment = !0, !1;
            this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(St) {
              return St.isLastPeriod(st.currentPeriodId);
            }, !1, this.context.sourceContext.sourceIdentifier) && this.mpdHandler.resolvePendingSegmentInfoRequests();
            var mt = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(St) {
              return St.getPeriodDuration(st.currentPeriodId);
            }, void 0, this.context.sourceContext.sourceIdentifier);
            return this.mpdHandler.hasNext(mt);
          }, it.prototype.hasNext = function(et) {
            var st = this, mt = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(St) {
              return St.isLastPeriod(st.currentPeriodId);
            }, !1, this.context.sourceContext.sourceIdentifier);
            return !(this.isLastSegment && mt || !this.currentAdaptationSetId || !this.mpdHandler) && (this.maybeIsLive() ? this.hasNextLive(et) : this.hasNextVod(et));
          }, it.prototype.onTransmuxed = function(et) {
            var st = this;
            if (et.transmuxedSegments.every(function(qe) {
              return qe.getCodec() !== null;
            })) {
              !this.hls.possiblyDependentSegments && lt(et) && (this.debug("Encountered HLS segment not starting with a key frame"), this.hls.possiblyDependentSegments = !0);
              var mt = et.transmuxedSegments.find(function(qe) {
                return qe.getMimeType() === "video/mp4";
              }), St = et.transmuxedSegments.filter(function(qe) {
                return qe.getMimeType() === "audio/mp4";
              }), $t = [mt, St[this.hls.muxedAudioTrackIndex] || St[0]].filter(function(qe) {
                return !!qe;
              });
              $t.forEach(function(qe) {
                return st.timestampOffsetService.maybeAdjustTimestampOffsetAtDiscontinuityChange(qe, st.mpdHandler);
              }), this.segmentManager && this.currentAdaptationSetId && this.segmentPreProcessor.onMuxedSegmentAvailable(et, $t, this.currentAdaptationSetId, this.segmentManager);
              var Tt = $t[$t.length - 1];
              Tt && Tt.getMimeType().indexOf("mp4") > -1 && (this.isLastSegment = Tt.isLastSegment()), this.debug("Transmuxing done", et.originalSegment.getUrl());
            } else {
              var rt = et.originalSegment.getUrl();
              this.debug("Discarding muxing because codecs were not available in the segment: ".concat(rt));
            }
          }, it.prototype.hasPendingSegments = function(et) {
            var st, mt, St, $t, Tt, rt;
            return et ? (Tt = this.isTransmuxerRequired() && !!this.hls.transmuxer && this.hls.transmuxer.isTransmuxingSegmentsForPeriod(et), rt = (mt = (st = this.segmentManager) === null || st === void 0 ? void 0 : st.isLoading(et)) !== null && mt !== void 0 && mt) : (Tt = this.isTransmuxing(), rt = ($t = (St = this.segmentManager) === null || St === void 0 ? void 0 : St.isLoading()) !== null && $t !== void 0 && $t), rt || Tt || this.isProcessingSegment || !!this.pendingSegmentInfoRequest;
          }, it.prototype.transmux = function(et) {
            var st = this;
            if (this.hls.transmuxer) {
              var mt = et.getSegmentInfo();
              this.hls.transmuxer.isSetupForDiscontinuity(mt.discontinuitySequenceNumber) || (mt.startTime === void 0 && (this.debug("resetting segment playback times for new initialization"), this.sourceStore.dispatch((0, Qe.resetSegmentPlaybackTimes)())), (0, Fe.initializeHlsSegmentStartTimes)(et, this.context, this.mpdHandler));
              var St = Date.now();
              this.hls.transmuxer.transmuxSegment(et).then(function($t) {
                var Tt, rt = (0, Me.toSeconds)(Date.now() - St), qe = { time: rt, representationId: mt.internalRepresentationId };
                return st.context.store.dispatch((0, ye.addMetricsValue)(st.mimeType, Se.MetricType.TransmuxingTime, qe)), st.context.logger.debug("Transmuxed ".concat(st.mimeType, " segment in: ").concat(rt == null ? void 0 : rt.toFixed(2), ", quality: ").concat((Tt = mt.representationId) !== null && Tt !== void 0 ? Tt : "")), st.onTransmuxed($t);
              }).catch(function($t) {
                at(et.getSegmentInfo(), st.sourceStore), $t !== he.TransmuxingRejectionReason.TRANSMUXING_ABORTED ? st.dispatchInvalidSegmentWarning(et, "Transmuxing failed: ".concat($t)) : st.debug($t, et.getUrl());
              });
            }
          }, it.prototype.maybeUpdateContainerFormat = function(et) {
            var st, mt;
            if (!this.isContainerFormatKnown() || this.isSegmentEmpty(et)) {
              var St = (0, ze.resolveContainerFormat)(this.mimeType, et, this.maybeIsHlsManifest());
              this.debug("Container format is ".concat(St == null ? void 0 : St.source)), St && this.sourceStore.dispatch((0, We.setContainerFormatAction)(et.getRepresentationId(), St)), this.hls.isTransmuxingRequired = !!(St && St.source !== St.target), !this.hls.isTransmuxingRequired && we.MimeTypeHelper.isAV(this.mimeType) && ((st = this.hls.transmuxer) === null || st === void 0 || st.dispose(), this.context.serviceManager.maybeCall(ue.ServiceName.SubtitleService, function($t) {
                $t.setTransmuxer(void 0);
              }, void 0, (mt = this.context.sourceContext) === null || mt === void 0 ? void 0 : mt.sourceIdentifier));
            }
          }, it.prototype.verifySegment = function(et) {
            var st;
            if (this.isSegmentEmpty(et))
              return this.debug("Warning: Loaded segment has size 0 bytes, skipping further processing! May cause gap!", et.getUrl()), (st = this.hlsTimelineTracker) === null || st === void 0 || st.reset(), he.SegmentVerificationResult.Drop;
            if (this.isTransmuxerRequired()) {
              if (!Be.ModuleManager.has(Ve.ModuleName.ContainerTS))
                return this.context.eventHandler.fireError(new Ue.PlayerModuleMissingError(Ve.ModuleName.ContainerTS)), he.SegmentVerificationResult.Drop;
            } else if (!this.maybeIsSmoothManifest() && this.isInvalidMp4Segment(et)) {
              if (this.context.settings.DROP_INVALID_SEGMENTS)
                return this.dispatchInvalidSegmentWarning(et, "The loaded MP4 segment is invalid, skipping further processing! May cause gap!"), he.SegmentVerificationResult.Drop;
              this.dispatchInvalidSegmentWarning(et, "The loaded MP4 segment is invalid. This may cause playback issues!");
            }
            var mt = Be.ModuleManager.get(Ve.ModuleName.LowLatency, !1), St = this.context.serviceManager.get(ue.ServiceName.ManifestService, this.context.sourceContext.sourceIdentifier);
            if ((0, Ye.isPlayingLowLatencyHls)(this.context) && mt && St) {
              var $t = mt.verifyLlHlsSegment(et, St);
              if ($t === he.SegmentVerificationResult.Drop)
                return this.debug("LL-HLS Segment Verification: Dropping (partial) segment as it disappeared from playlist", et.getUrl()), he.SegmentVerificationResult.Drop;
              if ($t === he.SegmentVerificationResult.Park)
                return this.parkSegment(et), he.SegmentVerificationResult.Park;
            }
            return he.SegmentVerificationResult.Publish;
          }, it.prototype.parkSegment = function(et) {
            var st = this, mt = function(rt) {
              var qe;
              if (rt.manifest)
                return (qe = (0, Pe.findRepresentation)(rt.manifest, et.getRepresentationId())) === null || qe === void 0 ? void 0 : qe._requestTimestamp;
            }, St = function(rt, qe) {
              return rt !== qe;
            }, $t = function() {
              Tt(), st.removeParkedSegmentSubscriber(Tt), st.onSegmentLoaded(et);
            }, Tt = (0, Ie.subscribe)(this.sourceStore)(mt, $t, St);
            this.parkedSegmentSubscriptions.push(Tt);
          }, it.prototype.removeParkedSegmentSubscriber = function(et) {
            var st = this.parkedSegmentSubscriptions.findIndex(function(mt) {
              return mt === et;
            });
            st > -1 && this.parkedSegmentSubscriptions.splice(st, 1);
          }, it.prototype.isSegmentEmpty = function(et) {
            var st = et.getData();
            return !!(st && st.byteLength < 1);
          }, it.prototype.isInvalidMp4Segment = function(et) {
            if (!Be.ModuleManager.has(Ve.ModuleName.ContainerMP4) || !we.MimeTypeHelper.isAV(this.mimeType))
              return !1;
            var st = Be.ModuleManager.get(Ve.ModuleName.ContainerMP4, !1), mt = st.isValidMp4, St = st.MP4Parser;
            return this.segmentParser instanceof St && !mt(et);
          }, it.prototype.dispatchInvalidSegmentWarning = function(et, st) {
            this.eventHandler.dispatchEvent(ve.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.PLAYBACK_INVALID_DATA_SEGMENT_ENCOUNTERED, st, { mimeType: et.getMimeType(), segmentUrl: et.getUrl() }));
          }, it.prototype.getContainerFormat = function() {
            var et = this.sourceStore.getState();
            return et && (0, Xe.getContainerFormat)(et, we.MimeTypeHelper.getMediaType(this.mimeType));
          }, it.prototype.isContainerFormatKnown = function() {
            return !!this.getContainerFormat();
          }, it.prototype.loadFromSegmentInfo = function(et) {
            var st = this;
            return this.pendingSegmentInfoRequest = void 0, this.isProcessingSegment = !0, et ? (this.loadingDataSegmentInfos.push(et), this.lastSegmentInfoError = void 0, this.ensureInitSegmentInfo(et), this.loadDataSegment(et).catch(function(mt) {
              return st.handleSegmentLoadingError(mt, et);
            }).finally(function() {
              return st.isProcessingSegment = !1;
            })) : Promise.resolve();
          }, it.prototype.ensureInitSegmentInfo = function(et) {
            var st = this.getInitSegmentInfoForDataSegmentInfo(et);
            st && (et.init = st);
          }, it.prototype.debug = function(et) {
            for (var st, mt, St, $t = [], Tt = 1; Tt < arguments.length; Tt++)
              $t[Tt - 1] = arguments[Tt];
            !((mt = this.logger) === null || mt === void 0) && mt.isLevelEnabled(me.LogLevel.DEBUG) && (st = this.logger).debug.apply(st, ce(["[".concat(this.mimeType, "][").concat((St = this.currentRepresentationId) === null || St === void 0 ? void 0 : St.representationId, "] SegmentController: ").concat(et)], $t, !1));
          }, it.prototype.loadDataSegment = function(et) {
            var st;
            return !((st = this.logger) === null || st === void 0) && st.isLevelEnabled(me.LogLevel.DEBUG) && this.debug("Loading ".concat(JSON.stringify(et))), this.loadSegment(et);
          }, it.prototype.getInitSegmentInfoForDataSegmentInfo = function(et) {
            var st = null;
            return (st = et.init ? ae(ae({}, et.init), { isInitSegment: !0, internalRepresentationId: et.internalRepresentationId }) : this.mpdHandler.getInitSegmentInfo(et.internalRepresentationId)) && this.addSegmentInfos(st, void 0, et.internalRepresentationId), st;
          }, it.prototype.loadSegment = function(et) {
            var st = this;
            return this.segmentManager ? this.segmentManager.getSegment(et).then(function(mt) {
              return st.extractSegmentFromStream(mt);
            }) : Promise.reject();
          }, it.prototype.extractSegmentFromStream = function(et) {
            var st = this;
            return new Promise(function(mt, St) {
              et.transform(function($t) {
                De($t.getSegmentInfo(), st.loadingDataSegmentInfos), st.onSegmentLoaded($t);
              }, function() {
                return mt();
              }, function($t) {
                var Tt = $t.message, rt = { reason: Tt };
                return St(rt), rt.reason !== bt.SegmentLoadingErrorReason.CANCEL && st.debug("Error loading segment", Tt), Tt;
              });
            });
          }, it.prototype.handleSegmentLoadingError = function(et, st) {
            var mt;
            (mt = (0, Ce.getSourceStore)(this.context)) === null || mt === void 0 || mt.dispatch((0, fe.clearPreferredBitrateForMimeTypeAction)(this.mimeType)), at(st, this.sourceStore);
            var St = et != null && et.info ? et.info.response.status : 0;
            switch (et == null ? void 0 : et.reason) {
              case bt.SegmentLoadingErrorReason.CANCEL:
                this.debug("Download was cancelled as the segment is probably outdated");
                break;
              case bt.SegmentLoadingErrorReason.ERROR_DECRYPTING:
                this.debug("Could not decrypt segment", st.url), this.eventHandler.dispatchEvent(ve.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.DRM_COULD_NOT_DECRYPT_SEGMENT));
                break;
              case bt.SegmentLoadingErrorReason.ERROR_LOADING:
                this.handleDownloadError(St, st, bt.SegmentLoadingErrorReason.ERROR_LOADING);
                break;
              case bt.SegmentLoadingErrorReason.TIMEOUT:
                this.handleDownloadError(St, st, bt.SegmentLoadingErrorReason.TIMEOUT);
                break;
              case bt.SegmentLoadingErrorReason.ABR_TIMEOUT:
                this.onABRCancellation(st);
                break;
              default:
                this.debug("Unexpected error while loading the segment", { url: st.url, error: et });
            }
          }, it.prototype.switchToHlsBackupStream = function(et, st) {
            var mt = this;
            return this.HLSModule && this.manifestLoader instanceof this.HLSModule.M3u8Loader ? this.manifestLoader.switchToBackupStream(et, st).then(function(St) {
              return St.length > 0;
            }).catch(function(St) {
              return mt.debug("Could not switch to HLS backup stream: ".concat(St)), Promise.resolve(!1);
            }) : Promise.resolve(!1);
          }, it.prototype.getFailedSegmentIndex = function() {
            var et = this.settings.CHUNKED_CMAF_STREAMING ? 1 : this.loadingDataSegmentInfos.length;
            return this.mpdHandler.getIndex() - et;
          }, it.prototype.handleDownloadError = function(et, st, mt) {
            st != null && st.isPreloadHint ? this.debug("Ignoring download error of preload hint segment.", st.url) : (this.debug("Failed to load segment (code: ".concat(et, ") ").concat(st.url)), this.segmentUnavailabilityHandler.shouldTryAlternatives(et) ? this.tryToFindAValidSegment(st, et, mt) : (this.storeFailedDownloadRange(st), this.hasDownloadError = !0));
          }, it.prototype.tryToFindAValidSegment = function(et, st, mt) {
            var St = this;
            if (this.currentRepresentationId && this.currentRepresentationId.equals(et.internalRepresentationId)) {
              var $t = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(rt) {
                return St.currentAdaptationSetId && rt.getRepresentation(St.currentAdaptationSetId, St.currentRepresentationId.representationId);
              }, null, this.context.sourceContext.sourceIdentifier);
              if ($t) {
                var Tt = !1;
                this.isBackupStreamSwitchOngoing = !0, this.switchToHlsBackupStream($t, et).then(function(rt) {
                  return Tt = rt;
                }).finally(function() {
                  return St.isBackupStreamSwitchOngoing = !1;
                }).then(function() {
                  var rt;
                  return (rt = St.segmentManager) === null || rt === void 0 ? void 0 : rt.cancel();
                }).then(function() {
                  return St.tryToRecoverWithValidSegment(Tt, et, st, mt);
                });
              }
            } else
              this.debug("Ignoring download error of previous representation.");
          }, it.prototype.tryToRecoverWithValidSegment = function(et, st, mt, St) {
            var $t, Tt = this.getFailedSegmentIndex();
            if (this.loadingDataSegmentInfos = [], et)
              this.mpdHandler.setIndex(Math.max(0, Tt));
            else if ($t = this.segmentUnavailabilityHandler.switchBaseURL(st))
              this.loadFromSegmentInfo($t);
            else {
              var rt = this.maybeTryLowerQuality(this.currentRepresentationId);
              if (rt) {
                if (this.streamTimeService) {
                  this.mpdHandler.setIndex(Math.max(0, Tt)), this.debug("Trying with lower quality segment ".concat(rt.representationId));
                  var qe = this.streamTimeService.getTimeForNextSegment((0, Ge.getTrackIdentifier)(st)), Ze = this.mpdHandler.getLatestTimeForPossibleSwitch(qe);
                  this.getNext(Ze, rt);
                }
              } else
                this.hasDownloadError = !0, this.handleFailedSegmentDownload(st, mt, St);
            }
          }, it.prototype.maybeTryLowerQuality = function(et) {
            var st, mt, St;
            if (et && (!((st = this.adaptationService) === null || st === void 0) && st.isAuto(this.mimeType))) {
              var $t = (St = (mt = this.maybeGetAdaptationSet(this.currentAdaptationSetId)) === null || mt === void 0 ? void 0 : mt.Representation) !== null && St !== void 0 ? St : [];
              return this.segmentUnavailabilityHandler.switchQuality($t, et);
            }
          }, it.prototype.handleFailedRepresentationDownload = function(et, st) {
            var mt;
            if (this.maybeIsLive() && this.settings.INFINITE_RETRIES_FOR_LIVE) {
              this.debug("Could not load any segment of any quality from any CDN: restart retries."), this.segmentUnavailabilityHandler.downloadSuccess(!1);
              var St = nt(this.currentRepresentationId, this.context);
              St && (this.sourceStore.dispatch((0, Qe.updateRepresentationFailedDownloadAction)(St._internalId, null)), (mt = this.manifestUpdateScheduler) === null || mt === void 0 || mt.scheduleRepresentationUpdate(St));
            } else {
              var $t = nt(et, this.context);
              (0, vt.throwPlaylistDownloadError)(this.context, "Could not load segments of any quality from any CDN", $t, st);
            }
          }, it.prototype.handleFailedSegmentDownload = function(et, st, mt) {
            this.storeFailedDownloadRange(et), this.maybeIsLive() && this.settings.INFINITE_RETRIES_FOR_LIVE ? (this.debug("Could not load current segment of any quality from any CDN (all retries failed), skipping it..."), this.continueWithNextSegment(et)) : (0, yt.throwDownloadError)(this.context, "Segment not available at any quality or location", st, et, mt);
          }, it.prototype.storeFailedDownloadRange = function(et) {
            var st, mt = (0, pt.getSegmentInfoTimeRange)(et);
            if (mt && (0, Te.isContextAvailable)(this.context) && et.mimeType) {
              var St = (0, Ge.getTrackIdentifier)(et);
              (st = (0, Ce.getSourceStore)(this.context)) === null || st === void 0 || st.dispatch((0, Je.addStreamTimeRange)(St, mt, Ge.StreamTimeRangeType.Failed));
            }
          }, it.prototype.continueWithNextSegment = function(et) {
            if (this.segmentUnavailabilityHandler.downloadSuccess(!1), et.hasDownloadFailed = !0, et.startTime != null && et.duration != null) {
              var st = et.startTime + et.duration, mt = this.mpdHandler.adjustTimeToNextSegmentStart(st);
              this.getNext(mt);
            }
          }, it.prototype.onABRCancellation = function(et) {
            var st, mt = this;
            (0, Te.isContextAvailable)(this.context) && (this.debug("Download took too long, cancelled it", et.url), !et.isInitSegment && this.mpdHandler && ((st = this.segmentManager) === null || st === void 0 || st.cancel().then(function() {
              if (mt.mpdHandler) {
                var St = mt.getFailedSegmentIndex();
                mt.loadingDataSegmentInfos = [], mt.debug("Trying to get the same segment with a lower bitrate."), mt.mpdHandler.setIndex(Math.max(0, St));
              }
            })));
          }, it.prototype.findAdaptationSetId = function(et, st, mt) {
            var St = this;
            if (mt === void 0 && (mt = !1), this.isSubtitleSegmentController && !(st != null && st.id))
              return this.currentLangObj = st, void (this.segmentManager && this.cancelLoading());
            var $t = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(Tt) {
              return Tt.findAdaptationSet(et, St.mimeType, st, mt);
            }, null, this.context.sourceContext.sourceIdentifier);
            return $t ? (this.currentLangObj = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(Tt) {
              return Tt.getLangObjectFromAdaptationSet($t, St.mimeType);
            }, void 0, this.context.sourceContext.sourceIdentifier), $t._internalId) : void 0;
          }, it.prototype.getCurrentAdaptationSet = function() {
            return this.maybeGetAdaptationSet(this.currentAdaptationSetId);
          }, it.prototype.getAdaptationSetForPeriodId = function(et) {
            return this.maybeGetAdaptationSet(this.loadedAdaptationSetIds[et]) || this.getCurrentAdaptationSet();
          }, it.prototype.updateMpd = function() {
            var et;
            this.debug("Caught a manifest update event");
            var st = !this.maybeFindPeriod(this.currentPeriodId);
            for (var mt in this.currentAdaptationSetId = this.findAdaptationSetId(this.currentPeriodId, this.currentLangObj, !1), !st && this.currentAdaptationSetId && (this.loadedAdaptationSetIds[this.currentPeriodId] = this.currentAdaptationSetId, (et = this.adaptationService) === null || et === void 0 || et.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId), this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId, this.currentRepresentationId, { isPeriodSwitch: !1, isManifestUpdate: !0 })), this.loadedAdaptationSetIds)
              this.maybeFindPeriod(mt) || delete this.loadedAdaptationSetIds[mt];
          }, it.prototype.activateSubtitleSegmentController = function(et) {
            var st;
            this.isSubtitleSegmentController && (this.currentAdaptationSetId && (this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId), (st = this.adaptationService) === null || st === void 0 || st.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId)), isNaN(this.mpdHandler.getTimestampOffset()) && this.mpdHandler.setTimestampOffset(0), this.seekTo(et));
          }, it.prototype.setCurrentLangObj = function(et) {
            var st;
            if (this.hls.isAvMuxedTogether && we.MimeTypeHelper.isVideo(this.mimeType)) {
              var mt = this.maybeGetAdaptationSet(this.currentAdaptationSetId);
              if (mt != null && mt.ContentComponent) {
                var St = mt.ContentComponent.find(function($t) {
                  return $t._contentType === "audio" && $t._id === et.id;
                });
                if (St)
                  return this.hls.muxedAudioTrackIndex = mt.ContentComponent.filter(function($t) {
                    return $t._contentType === "audio";
                  }).indexOf(St), void (this.currentLangObj = et);
              }
            }
            et.id !== ((st = this.currentLangObj) === null || st === void 0 ? void 0 : st.id) && this.switchAdaptationSetId(et);
          }, it.prototype.switchAdaptationSetId = function(et) {
            var st = this.currentAdaptationSetId;
            if (this.currentAdaptationSetId && this.sourceStore.dispatch((0, We.removeActiveTrackAction)(this.currentAdaptationSetId)), this.currentAdaptationSetId = this.findAdaptationSetId(this.currentPeriodId, et), this.currentAdaptationSetId) {
              var mt = this.maybeGetAdaptationSet(this.currentAdaptationSetId);
              mt && this.sourceStore.dispatch((0, We.setMediaTypeAction)(mt._internalId, (0, ke.resolveMediaTypes)(mt))), this.loadedAdaptationSetIds[this.currentPeriodId] = this.currentAdaptationSetId, st && !this.currentAdaptationSetId.equals(st) && this.switchDependentToNewLanguageObject(et);
            }
          }, it.prototype.switchDependentToNewLanguageObject = function(et) {
            var st, mt;
            this.currentLangObj = et, this.previousExplicitlySetLangObj = et, this.debug("Trying to set language to ID ".concat(this.currentLangObj.id) + " (lang: ".concat(this.currentLangObj.lang, ") for mpd handler and adaption handler")), this.currentAdaptationSetId && (this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId), (st = this.adaptationService) === null || st === void 0 || st.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId), (mt = this.adaptationService) === null || mt === void 0 || mt.selectRepresentation(this.mimeType));
          }, it.prototype.getCurrentLangObj = function() {
            return this.currentLangObj;
          }, it.prototype.stop = function() {
            var et, st;
            this.cancelLoading(), (et = this.segmentManager) === null || et === void 0 || et.clearCache(), (st = this.adaptationService) === null || st === void 0 || st.shutdown(this.mimeType);
          }, it.prototype.init = function() {
            var et, st, mt = this, St = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(qe) {
              return qe.getFirstPeriod();
            }, void 0, this.context.sourceContext.sourceIdentifier);
            !this.currentPeriodId && St && (this.currentPeriodId = St._id);
            var $t = ot.MPDHandlerFactory.createInstance(this.context, this.mimeType, this.manifestLoader, this.currentPeriodId);
            if ($t) {
              this.mpdHandler = $t;
              var Tt, rt = ft(this.mimeType);
              rt && (Tt = (0, Le.createSegmentParser)(this.context, rt)), Tt ? this.segmentParser = Tt : this.debug("Could not create segment parser for mime type"), this.timestampOffsetService = new Ke.TimestampOffsetService(this.context, this.mimeType), this.segmentPreProcessor = new ut.SegmentPreProcessor(this.context, this.mimeType, this.onDataAvailableCallback, this.hls, this.segmentUnavailabilityHandler, this.timestampOffsetService, this.segmentParser), this.segmentPreProcessor.setMpdHandler(this.mpdHandler), this.hasDownloadError = !1, this.currentAdaptationSetId = this.findAdaptationSetId(this.currentPeriodId, this.currentLangObj), this.currentAdaptationSetId && (this.loadedAdaptationSetIds[this.currentPeriodId] = this.currentAdaptationSetId), this.context.serviceManager.maybeCall(ue.ServiceName.SegmentService, function(qe) {
                return qe.add({ mimeType: mt.mimeType, shouldDownloadBeCancelledCallback: mt.onShouldDownloadBeCancelled }, mt.segmentParser, mt.currentLangObj);
              }), this.maybeIsHlsManifest() && (this.hlsTimelineTracker = new this.HLSModule.HlsTimelineTracker(this.context, this.settings.GAP_TOLERANCE), this.segmentPreProcessor.setHlsTimelineTracker(this.hlsTimelineTracker)), we.MimeTypeHelper.isMP4(this.mimeType) && this.context.serviceManager.maybeCall(ue.ServiceName.SubtitleService, function(qe) {
                qe.setupCea608CaptionExtractor(mt.context.logger);
              }, void 0, (et = this.context.sourceContext) === null || et === void 0 ? void 0 : et.sourceIdentifier), this.currentAdaptationSetId && ((st = this.adaptationService) === null || st === void 0 || st.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId), this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId, void 0, { isPeriodSwitch: !0 }), this.maybeIsLive() && !this.settings.ENABLE_SEEK_FOR_LIVE && this.mpdHandler.timeShift(0, this.currentPeriodId)), this.isLastSegment = !1;
            } else
              this.eventHandler.fireError(new le.PlayerError(_e.ErrorCode.SOURCE_MANIFEST_INVALID));
          }, it.prototype.getSegmentInfos = function() {
            var et, st = this, mt = (et = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(St) {
              return St.getAvailableBaseURLsForRepresentation(st.currentRepresentationId);
            }, null, this.context.sourceContext.sourceIdentifier)) === null || et === void 0 ? void 0 : et[0];
            return this.mpdHandler.getSegmentInfos(mt);
          }, it.prototype.getCurrentPeriodId = function() {
            return this.currentPeriodId;
          }, it.prototype.getTargetLanguageObject = function(et) {
            var st = this;
            return this.previousExplicitlySetLangObj && this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(mt) {
              return mt.isLanguageAvailable(et, st.mimeType, st.previousExplicitlySetLangObj);
            }, !1, this.context.sourceContext.sourceIdentifier) ? this.previousExplicitlySetLangObj : this.currentLangObj;
          }, it.prototype.switchPeriod = function(et) {
            var st, mt, St, $t = this, Tt = this.getTargetLanguageObject(et);
            if (this.debug("switching period from ".concat(this.currentPeriodId, " to ").concat(et)), this.cancelLoading(), (st = this.segmentManager) === null || st === void 0 || st.clearCache(), this.removeCachedSegmentsOfPrecedingPeriods(), this.currentPeriodId = et, this.currentRepresentationId = void 0, this.currentAdaptationSetId = this.findAdaptationSetId(et, Tt, !0), this.currentAdaptationSetId && (this.loadedAdaptationSetIds[et] = this.currentAdaptationSetId), this.currentAdaptationSetId) {
              (mt = this.adaptationService) === null || mt === void 0 || mt.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId);
              var rt = this.mpdHandler.getPendingSegmentInfoRequest(), qe = ot.MPDHandlerFactory.createInstance(this.context, this.mimeType, this.manifestLoader, et, Tt);
              qe ? (this.mpdHandler.dispose(), this.mpdHandler = qe) : this.eventHandler.fireError(new le.PlayerError(_e.ErrorCode.SOURCE_MANIFEST_INVALID)), this.segmentPreProcessor.setMpdHandler(this.mpdHandler), this.mpdHandler.setPendingSegmentInfoRequest(rt), this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId, void 0, { isPeriodSwitch: !0 });
            }
            if (this.isTransmuxerRequired()) {
              var Ze = this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(ht) {
                return $t.currentAdaptationSetId && ht.findDownloadedHlsRepresentation($t.currentAdaptationSetId);
              }, null, this.context.sourceContext.sourceIdentifier);
              Ze && this.mpdHandler.setRepresentationId(Ze._internalId), this.hlsTimelineTracker && this.hlsTimelineTracker.reset(), (St = this.segmentManager) === null || St === void 0 || St.clearCache(!1);
            }
            this.hasDownloadError = !1, this.isLastSegment = !1;
          }, it.prototype.getMPDHandler = function() {
            return this.mpdHandler;
          }, it.prototype.getIndex = function() {
            return this.mpdHandler && this.mpdHandler.getIndex() || 0;
          }, it.prototype.getSourceBufferTypes = function() {
            var et = [];
            return this.isTransmuxerRequired() && this.hls.isAvMuxedTogether ? (et.push("video/mp4"), et.push("audio/mp4")) : et.push(this.mimeType), et;
          }, it.prototype.getCodecs = function() {
            var et, st = this.getCurrentAdaptationSet();
            return (et = st && (0, Ne.getCodecsFromAdaptationSet)(st)) !== null && et !== void 0 ? et : void 0;
          }, it.prototype.getLiveEdgeTime = function() {
            return this.maybeIsLive() ? this.mpdHandler.getLiveEdgeTime() : -1;
          }, it.prototype.setAdaptionLogicStartupPhase = function() {
            var et;
            (et = this.adaptationService) === null || et === void 0 || et.setStartupPhase(this.mimeType);
          }, it.prototype.getMimeType = function() {
            return this.mimeType;
          }, it.prototype.removeCachedSegmentsOfPrecedingPeriods = function() {
            var et = this, st = this.context.store.getState(), mt = st ? (0, $e.getMetricsState)(st) : void 0;
            if (this.segmentManager && mt) {
              var St = this.sourceStore.getState(), $t = St ? (0, tt.getPlayingPeriodId)(St) : void 0;
              this.segmentManager.removeCachedInitSegments(function(Tt) {
                return et.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(rt) {
                  return rt.isPrecedingPeriod($t, Tt.getPeriodId());
                }, !1, et.context.sourceContext.sourceIdentifier);
              }), ((0, $e.getMetricsHistory)(mt, this.mimeType, Se.MetricType.CachedInitSegments) || []).filter(function(Tt) {
                var rt = Tt.value.internalRepId.periodId;
                return et.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(qe) {
                  return qe.isPrecedingPeriod($t, rt);
                }, !1, et.context.sourceContext.sourceIdentifier);
              }).forEach(function(Tt) {
                return et.context.store.dispatch((0, ye.removeMetricsValue)(et.mimeType, Se.MetricType.CachedInitSegments, Tt));
              });
            }
          }, it.prototype.canLoad = function() {
            var et;
            return !!(!((et = this.segmentManager) === null || et === void 0) && et.canLoad());
          }, it.prototype.isTransmuxerRequired = function() {
            return this.hls.isTransmuxingRequired;
          }, it.prototype.setTransmuxer = function(et) {
            this.hls.transmuxer = et;
          }, it.prototype.getTransmuxer = function() {
            return this.hls.transmuxer;
          }, it.prototype.resetTransmuxer = function() {
            this.hls.transmuxer && this.hls.transmuxer.reset();
          }, it.prototype.maybeIsHlsManifest = function() {
            return this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(et) {
              return et.isHlsManifest();
            }, !1, this.context.sourceContext.sourceIdentifier);
          }, it.prototype.maybeIsSmoothManifest = function() {
            return this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(et) {
              return et.isSmoothManifest();
            }, !1, this.context.sourceContext.sourceIdentifier);
          }, it.prototype.maybeIsLive = function() {
            return this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(et) {
              return et.isLive();
            }, !1, this.context.sourceContext.sourceIdentifier);
          }, it.prototype.maybeFindPeriod = function(et) {
            return this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(st) {
              return st.findPeriod(et);
            }, null, this.context.sourceContext.sourceIdentifier);
          }, it.prototype.maybeGetAdaptationSet = function(et) {
            return this.context.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(st) {
              return st.getAdaptationSet(et);
            }, null, this.context.sourceContext.sourceIdentifier);
          }, it.prototype.dispose = function() {
            var et, st;
            (0, be.dispose)(this.mpdHandler), (0, be.dispose)(this.timestampOffsetService), (0, be.dispose)(this.segmentPreProcessor), (et = this.adaptationService) === null || et === void 0 || et.release(this.mimeType), this.hlsTimelineTracker && this.hlsTimelineTracker.dispose(), (0, Te.isContextAvailable)(this.context) && ((st = this.context.serviceManager.get(ue.ServiceName.SegmentService)) === null || st === void 0 || st.disposeOfType(this.mimeType, this.currentLangObj)), this.parkedSegmentSubscriptions.forEach(function(mt) {
              return mt();
            });
          }, it;
        }();
        function De(it, et) {
          var st = et.findIndex(function(mt) {
            return (0, gt.areSegmentsIdentical)(mt, it);
          });
          st > -1 && et.splice(st, 1);
        }
        function at(it, et) {
          var st = (0, pt.getSegmentInfoTimeRange)(it), mt = (0, Ge.getTrackIdentifier)(it);
          st && (et == null || et.dispatch((0, Je.removeStreamTimeRange)(mt, st, Ge.StreamTimeRangeType.Loading)));
        }
        function dt(it, et, st, mt, St) {
          var $t = it.serviceManager.get(ue.ServiceName.AdaptationService), Tt = it.serviceManager.get(ue.ServiceName.ManifestService, it.sourceContext.sourceIdentifier), rt = function(qe, Ze) {
            var ht = !!($t != null && $t.shouldDownloadBeCancelled(et, qe, Ze));
            return Tt != null && Tt.isHlsManifest() && mt.possiblyDependentSegments && ht ? (it.logger.debug("Download should be cancelled, but this is disabled for segments not starting with key frames"), !1) : ht;
          };
          return it.serviceManager.maybeCall(ue.ServiceName.SegmentService, function(qe) {
            return qe.add({ mimeType: et, shouldDownloadBeCancelledCallback: rt }, st, St);
          });
        }
        function ft(it) {
          var et = it.split("/")[1].toLowerCase();
          return Object.values(Re.ContainerFormat).find(function(st) {
            return st === et;
          });
        }
        function lt(it) {
          return it.transmuxedSegments.some(function(et) {
            return we.MimeTypeHelper.isAV(et.getMimeType()) && !et.isIndependentlyDecodable();
          });
        }
        function nt(it, et) {
          if (it && (0, Te.isContextAvailable)(et))
            return et.serviceManager.maybeCall(ue.ServiceName.ManifestService, function(st) {
              return st.getRepresentationById(it);
            }, void 0, et.sourceContext.sourceIdentifier);
        }
        function ct(it) {
          return it instanceof le.PlayerError ? [_e.ErrorCode.SOURCE_MANIFEST_INVALID, _e.ErrorCode.SOURCE_COULD_NOT_LOAD_MANIFEST].includes(it.code) : it === pe.RequestError.Failed || it === pe.RequestError.TimedOut;
        }
        ne.SegmentController = je;
      }, 59305: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.StreamReadError = void 0, function(ae) {
          ae.Aborted = "aborted", ae.ParallelRead = "parallelread";
        }(ie || (ne.StreamReadError = ie = {}));
      }, 59839: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.addStreamTimeRange = he, ne.removeStreamTimeRange = _e, ne.resetStreamTimeline = le;
        var ae = ie(15231), ce = ie(1590);
        function he(se, oe, ue) {
          var be = { start: oe.start, end: oe.end, type: ue };
          return (0, ae.createAction)(ce.StreamTimelineActionType.StreamTimeRangeAdd, { mimeType: se, streamTimeRange: be });
        }
        function _e(se, oe, ue) {
          return (0, ae.createAction)(ce.StreamTimelineActionType.StreamTimeRangeRemove, { mimeType: se, range: oe, type: ue });
        }
        function le(se) {
          return (0, ae.createAction)(ce.StreamTimelineActionType.StreamTimelineReset, se);
        }
      }, 59879: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.StreamTimeService = void 0;
        var ae = ie(18665), ce = ie(81361), he = ie(22645), _e = function() {
          function se(oe, ue) {
            this.serviceManager = oe, this.sourceIdentifier = ue;
          }
          return Object.defineProperty(se.prototype, "sourceState", { get: function() {
            return this.serviceManager.get(ae.ServiceName.SourceStoreService, this.sourceIdentifier).getState();
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(se.prototype, "streamTimelineState", { get: function() {
            var oe;
            return (oe = this.sourceState) === null || oe === void 0 ? void 0 : oe.streamTimeline;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(se.prototype, "bufferStateMap", { get: function() {
            var oe;
            return (oe = this.sourceState) === null || oe === void 0 ? void 0 : oe.buffer.bufferStateMap;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(se.prototype, "playerStateService", { get: function() {
            return this.serviceManager.get(ae.ServiceName.PlayerStateService);
          }, enumerable: !1, configurable: !0 }), se.prototype.getTimeForNextSegment = function(oe) {
            var ue, be, ve, me, pe = (0, ce.findFromEnd)(this.streamTimelineState[oe] || [], le), fe = (ue = this.bufferStateMap) === null || ue === void 0 ? void 0 : ue[oe], ge = [pe, ((be = fe == null ? void 0 : fe.loadedRanges) === null || be === void 0 ? void 0 : be[fe.loadedRanges.length - 1]) || ((ve = fe == null ? void 0 : fe.rendererRanges) === null || ve === void 0 ? void 0 : ve[fe.rendererRanges.length - 1])].filter(function($e) {
              return $e;
            }).map(function($e) {
              return $e.end;
            }), ye = Math.max.apply(Math, ge);
            return isFinite(ye) ? ye : !((me = this.playerStateService) === null || me === void 0) && me.seekingOrTimeshifting ? this.playerStateService.targetPlaybackTime : 0;
          }, se.prototype.dispose = function() {
          }, se;
        }();
        function le(se) {
          return [he.StreamTimeRangeType.Loading, he.StreamTimeRangeType.Failed].includes(se.type);
        }
        ne.StreamTimeService = _e;
      }, 60704: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentPreProcessor = void 0;
        var ae = ie(18665), ce = ie(62510), he = ie(76650), _e = ie(8272), le = ie(27279), se = ie(79814), oe = ie(34586), ue = ie(91520), be = ie(16368), ve = ie(43752), me = ie(59839), pe = ie(22645), fe = ie(93109), ge = ie(74830), ye = ie(41661), $e = ie(9378), Se = ie(28915), Ce = ie(67550), Ie = "SegmentPreProcessor", Te = function() {
          function Oe(Be, Ve, Ue, Re, Ne, xe, ke) {
            this.context = Be, this.mimeType = Ve, this.onDataAvailableCallback = Ue, this.hls = Re, this.segmentUnavailabilityHandler = Ne, this.timestampOffsetService = xe, this.segmentParser = ke, this.isKeyframeRecoveryOngoing = !1, this.downloadRepresentationId = null;
            var Le = Be.sourceContext.sourceIdentifier;
            this.manifestService = this.context.serviceManager.get(ae.ServiceName.ManifestService, Le);
          }
          return Object.defineProperty(Oe.prototype, "logger", { get: function() {
            return this.context.logger;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(Oe.prototype, "eventHandler", { get: function() {
            return this.context.eventHandler;
          }, enumerable: !1, configurable: !0 }), Oe.prototype.setHlsTimelineTracker = function(Be) {
            this.hlsTimelineTracker = Be;
          }, Oe.prototype.setMpdHandler = function(Be) {
            this.mpdHandler = Be;
          }, Oe.prototype.onMuxedSegmentAvailable = function(Be, Ve, Ue, Re) {
            var Ne = this, xe = Ve.find(function(Xe) {
              return Ee(Xe, Ne.hls);
            });
            if (xe) {
              var ke = !xe.getRepresentationId().equals(this.downloadRepresentationId), Le = this.maybeHandleTimelineGap(xe, Ue, ke), He = Le.shouldMakeSegmentAvailable, We = Le.shouldCacheSegment;
              He ? Ve.forEach(function(Xe) {
                var Qe = Be.metadata[Be.transmuxedSegments.indexOf(Xe)];
                Ne.onSegmentAvailable(Xe, Qe, Ue, Re) || Re.cacheSegment(Be.originalSegment);
              }) : (We && Re.cacheSegment(Be.originalSegment), Ae(Be.originalSegment, this.context));
            }
          }, Oe.prototype.onSegmentAvailable = function(Be, Ve, Ue, Re) {
            var Ne, xe, ke;
            return this.logger.debug("onSegmentAvailable ".concat(Be.getMimeType()).concat(Be.isInit() ? " init" : "", " segment [").concat(Be.getUrl(), "]")), this.segmentUnavailabilityHandler.downloadSuccess(Be.isInit()), (xe = (Ne = this.mpdHandler).generateSmoothInitSegment) === null || xe === void 0 || xe.call(Ne, Be, this.segmentParser), this.hls.isTransmuxingRequired || oe.TextSegmentAnalyzer.isPlainTextPayload(Be.getData()) || (ke = this.segmentParser) === null || ke === void 0 || ke.parseSegment(Be), !!Be.isInit() || this.onDataSegmentAvailable(Be, Ve, Ue, Re);
          }, Oe.prototype.onDataSegmentAvailable = function(Be, Ve, Ue, Re) {
            var Ne, xe, ke, Le, He = this, We = !Be.getRepresentationId().equals(this.downloadRepresentationId);
            Ee(Be, this.hls) && We && this.updateDownloadedRepresentation(Be, this.downloadRepresentationId);
            var Xe = this.hls.isTransmuxingRequired, Qe = !0;
            if (this.manifestService.isHlsManifest()) {
              if (this.maybeUpdateLlHlsSegmentInfo(Be), !Xe && !oe.TextSegmentAnalyzer.isPlainTextPayload(Be.getData())) {
                (isNaN(this.mpdHandler.getTimestampOffset()) || this.mpdHandler.getTimestampOffset() === 0) && (0, ge.initializeHlsSegmentStartTimes)(Be, this.context, this.mpdHandler), this.timestampOffsetService.maybeAdjustTimestampOffsetAtDiscontinuityChange(Be, this.mpdHandler) && ((Ne = this.segmentParser) === null || Ne === void 0 || Ne.parseSegment(Be));
                var tt = this.maybeHandleTimelineGap(Be, Ue, We), Je = tt.shouldMakeSegmentAvailable, Ge = tt.shouldCacheSegment;
                if (!Je)
                  return Ge && Re.cacheSegment(Be), !1;
              }
              Pe(Be) && this.timestampOffsetService.maybeAdjustTimestampOffsetAtDiscontinuityChange(Be, this.mpdHandler), this.manifestService.initSegmentStartTimesFromReferenceSegment(Be);
            }
            if (Xe && this.hls.possiblyDependentSegments && We && Ee(Be, this.hls) && !this.isKeyframeRecoveryOngoing) {
              this.logger.debug("Just switched playlists, isIndependentlyDecodable=".concat(Be.isIndependentlyDecodable(), ", (").concat(Be.getMimeType(), ", ").concat(Be.getUrl(), ")"));
              var Ye = this.mpdHandler.getIndex() > 1;
              !Be.isIndependentlyDecodable() && Ye && (this.logger.debug("Started keyframe recovery"), this.mpdHandler.setIndex(this.mpdHandler.getIndex() - 2), Qe = !1, this.hls.discardNextSegment = !0, this.isKeyframeRecoveryOngoing = !0);
            }
            if (!Qe)
              return !1;
            Me(Be, this.context), this.context.serviceManager.get(ae.ServiceName.TimedMetadataService).onSegmentAvailable({ segment: Be, extractedMetadata: Ve, isSegmentOfMainStream: Ee(Be, this.hls), presentationTimeOffset: this.mpdHandler.getTimestampOffset() }), this.context.serviceManager.maybeCall(ae.ServiceName.SubtitleService, function(vt) {
              vt.handleClosedCaptions(He.mpdHandler, Be, Ve == null ? void 0 : Ve.closedCaptions, Xe, Be.getCodec());
            }, void 0, (xe = this.context.sourceContext) === null || xe === void 0 ? void 0 : xe.sourceIdentifier);
            var ze = Be.getPlaybackTime(), Fe = (ke = Be.getSegmentInfo()) === null || ke === void 0 ? void 0 : ke.startTime, ot = Fe ? Math.abs(ze - Fe) : void 0;
            return this.logger.debug("[".concat(Ie, "][").concat(Be.getMimeType(), "]: playbackTimeForSegment=").concat(ze, " expected=").concat(Fe, " (diff=").concat(ot == null ? void 0 : ot.toFixed(3), ") ").concat(Be.getUrl())), Ee(Be, this.hls) && ((Le = this.hlsTimelineTracker) === null || Le === void 0 || Le.trackPlaybackTime(Be), this.isKeyframeRecoveryOngoing = !1), this.onDataAvailableCallback(Be), Qe;
          }, Oe.prototype.maybeUpdateLlHlsSegmentInfo = function(Be) {
            var Ve = ue.ModuleManager.get(be.ModuleName.LowLatency, !1);
            (0, fe.isPlayingLowLatencyHls)(this.context) && Ve && Ve.applyUpdatedSegmentInfoProps(Be, this.manifestService);
          }, Oe.prototype.updateDownloadedRepresentation = function(Be, Ve) {
            this.triggerOnDownloadQualityChanged(Be.getMimeType(), Ve, Be.getRepresentationId());
            var Ue = Be.getSegmentInfo(), Re = { id: Ue.representationId, bitrate: Ue.bitrate, width: Ue.width, height: Ue.height };
            this.context.store.dispatch((0, he.addMetricsValue)(this.mimeType, _e.MetricType.DownloadedRepresentation, Re)), this.downloadRepresentationId = Be.getRepresentationId();
          }, Oe.prototype.triggerOnDownloadQualityChanged = function(Be, Ve, Ue) {
            var Re;
            if (se.MimeTypeHelper.isVideo(Be))
              Re = ce.PlayerEvent.VideoDownloadQualityChanged;
            else {
              if (!se.MimeTypeHelper.isAudio(Be))
                return;
              Re = ce.PlayerEvent.AudioDownloadQualityChanged;
            }
            var Ne = (0, ve.representationToQuality)(this.manifestService.getRepresentationById(Ve), Be), xe = (0, ve.representationToQuality)(this.manifestService.getRepresentationById(Ue), Be);
            this.eventHandler.dispatchEvent(Re, { targetQuality: xe, targetQualityId: xe.id, sourceQuality: Ne, sourceQualityId: Ne ? Ne.id : null });
          }, Oe.prototype.hasHlsTimelineGap = function(Be, Ve) {
            var Ue = { hasGap: !1 };
            if (Be && this.manifestService.isHlsManifest() && !Pe(Be) && Ee(Be, this.hls) && this.hlsTimelineTracker) {
              var Re = $e.SegmentInfoProvider.findHlsRepresentationForSegment(Be, this.manifestService.getAdaptationSet(Ve));
              if (Re && (Ue = this.hlsTimelineTracker.checkForTimelineGap(Be, Re.representation, Re.index)).hasGap && Ue.correctedIndex !== void 0) {
                this.logger.debug("Encountered timeline gap (".concat(Ue.gapSizeSec, "), just loaded ").concat(Be.getUrl()));
                var Ne = Re.representation._internalId, xe = this.mpdHandler instanceof Ce.SegmentListMPDHandler && this.mpdHandler.getSegmentListEntries(Ne) && this.mpdHandler.getSegmentListEntries(Ne)[Ue.correctedIndex];
                if (xe && (0, ye.areSegmentsIdentical)(Be.getSegmentInfo(), xe))
                  return this.logger.debug("Gap handling: Segment is identical to the one we just loaded, not rewinding"), Ue.hasGap = !1, Ue;
                xe && xe.hasDownloadFailed ? (this.logger.debug("Gap handling: Could not handle gap, segment has failed to download"), Ue.couldHandle = !1) : (this.logger.debug("Gap handling: Correcting index from ".concat(this.mpdHandler.getIndex(), " to ").concat(Ue.correctedIndex)), this.mpdHandler.setIndex(Ue.correctedIndex));
              }
            }
            return Ue;
          }, Oe.prototype.maybeHandleTimelineGap = function(Be, Ve, Ue) {
            if (!(this.hlsTimelineTracker.isGapVerificationNeeded() || this.hlsTimelineTracker.isSeekTargetVerificationNeeded() || Ue))
              return { shouldMakeSegmentAvailable: !0, shouldCacheSegment: !1 };
            var Re = this.hasHlsTimelineGap(Be, Ve);
            return Re.hasGap ? Re.couldHandle ? we(Re) ? { shouldMakeSegmentAvailable: !1, shouldCacheSegment: !0 } : { shouldMakeSegmentAvailable: !1, shouldCacheSegment: !1 } : (this.hlsTimelineTracker.reset(), { shouldMakeSegmentAvailable: !0, shouldCacheSegment: !1 }) : { shouldMakeSegmentAvailable: !0, shouldCacheSegment: !1 };
          }, Oe.prototype.dispose = function() {
            this.downloadRepresentationId = null, this.hlsTimelineTracker = null, this.manifestService = null, this.onDataAvailableCallback = null, this.hls = null, this.segmentUnavailabilityHandler = null, this.timestampOffsetService = null, this.segmentParser = null, this.mpdHandler = null;
          }, Oe;
        }();
        function Ee(Oe, Be) {
          return !Be.isAvMuxedTogether || se.MimeTypeHelper.isVideo(Oe.getMimeType());
        }
        function we(Oe) {
          var Be;
          return ((Be = Oe.gapSizeSec) !== null && Be !== void 0 ? Be : 0) > 0;
        }
        function Pe(Oe) {
          return se.MimeTypeHelper.isSubtitle(Oe.getMimeType());
        }
        function Me(Oe, Be) {
          var Ve = (0, le.getSourceStore)(Be), Ue = Oe.getSegmentInfo(), Re = (0, Se.getSegmentInfoTimeRange)(Ue), Ne = Oe.getPlaybackTimeRange(), xe = (0, pe.getTrackIdentifier)(Ue);
          Ve && Re && Ne && (Ve.dispatch((0, me.removeStreamTimeRange)(xe, Re, pe.StreamTimeRangeType.Loading)), Ve.dispatch((0, me.addStreamTimeRange)(xe, Ne, pe.StreamTimeRangeType.Loading)));
        }
        function Ae(Oe, Be) {
          var Ve = (0, le.getSourceStore)(Be), Ue = Oe.getSegmentInfo(), Re = (0, Se.getSegmentInfoTimeRange)(Ue), Ne = (0, pe.getTrackIdentifier)(Ue);
          Ve && Re && Ve.dispatch((0, me.removeStreamTimeRange)(Ne, Re, pe.StreamTimeRangeType.Loading));
        }
        ne.SegmentPreProcessor = Te;
      }, 61743: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var le = function(se, oe) {
            return le = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ue, be) {
              ue.__proto__ = be;
            } || function(ue, be) {
              for (var ve in be)
                Object.prototype.hasOwnProperty.call(be, ve) && (ue[ve] = be[ve]);
            }, le(se, oe);
          };
          return function(se, oe) {
            if (typeof oe != "function" && oe !== null)
              throw new TypeError("Class extends value " + String(oe) + " is not a constructor or null");
            function ue() {
              this.constructor = se;
            }
            le(se, oe), se.prototype = oe === null ? Object.create(oe) : (ue.prototype = oe.prototype, new ue());
          };
        }();
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ManifestUpdater = void 0;
        var ce = ie(99162), he = ie(43752), _e = function(le) {
          function se(oe, ue, be, ve) {
            var me = le.call(this, ve) || this;
            return me.manifestLoader = oe, me.manifest = ue, me.settings = be, me;
          }
          return ae(se, le), se.prototype.getUpdatedManifest = function() {
            return this.getPayload();
          }, se.prototype.update = function() {
            var oe = this;
            return this.manifestLoader.load(this.manifest._currentLoadingUrl).then(function(ue) {
              return oe.manifest = ue, ue;
            });
          }, se.prototype.getReloadIntervalInSeconds = function() {
            var oe = (0, he.getMinimumUpdatePeriodInSeconds)(this.manifest);
            return isNaN(oe) ? this.settings.minAllowedUpdatePeriod : Math.min(this.settings.maxAllowedUpdatePeriod, Math.max(this.settings.minAllowedUpdatePeriod, oe));
          }, se.prototype.getLastReloadTimestamp = function() {
            return this.manifest._requestTimestamp;
          }, se;
        }(ce.AbstractUpdater);
        ne.ManifestUpdater = _e;
      }, 64330: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SynchronizedTimeService = void 0;
        var ae = ie(331), ce = ie(77118), he = ie(13127), _e = ie(89010), le = function() {
          function se(oe, ue) {
            this.context = oe, this.sourceContext = ue, this.timeDifferenceMs = 0;
            var be = new _e.HttpHeadTimeProvider(this.context, new he.ISO8601TimeDecoder()), ve = new _e.HttpGetTimeProvider(this.context, new he.XSDateTimeDecoder()), me = new _e.HttpGetTimeProvider(this.context, new he.ISO8601TimeDecoder()), pe = new _e.StringTimeProvider(new he.XSDateTimeDecoder());
            this.serverTimeProviders = { "urn:mpeg:dash:utc:http-head:2012": be, "urn:mpeg:dash:utc:http-head:2014": be, "urn:mpeg:dash:utc:http-xsdate:2012": ve, "urn:mpeg:dash:utc:http-xsdate:2014": ve, "urn:mpeg:dash:utc:http-iso:2012": me, "urn:mpeg:dash:utc:http-iso:2014": me, "urn:mpeg:dash:utc:direct:2012": pe, "urn:mpeg:dash:utc:direct:2014": pe }, this.synchronizeWithConfiguredServer();
          }
          return se.prototype.synchronizeWithConfiguredServer = function() {
            var oe = (0, ce.getUtcTimingSources)(this.context.config, this.sourceContext.source);
            oe.length > 0 && this.synchronizeWithServer(oe);
          }, se.prototype.getTimeDifference = function() {
            return this.timeDifferenceMs;
          }, se.prototype.requestServerTime = function(oe) {
            var ue = this, be = oe.shift();
            if (!be)
              return Promise.reject(new Error("No time source left to try"));
            if (!this.serverTimeProviders[be.schemeIdUri])
              return this.context.logger.debug("UTCTiming scheme ".concat(be.schemeIdUri, " is not supported.")), this.requestServerTime(oe);
            this.currentServerTimeProvider = this.serverTimeProviders[be.schemeIdUri];
            var ve = Date.now();
            return this.currentServerTimeProvider.requestTime(be.value).then(function(me) {
              return me + (Date.now() - ve) / 2;
            }).catch(function() {
              return ue.context.logger.debug("UTCTiming scheme ".concat(be.schemeIdUri, " resulted in an error")), ue.requestServerTime(oe);
            });
          }, se.prototype.synchronizeWithServer = function(oe, ue) {
            var be = this;
            return ue === void 0 && (ue = 0), this.driftPromise || (this.driftPromise = this.requestServerTime(oe).then(function(ve) {
              be.currentServerTimeProvider = void 0, be.timeDifferenceMs = ve + (0, ae.toMilliSeconds)(ue) - Date.now(), be.context.logger.debug("Synchronized client time with time server - drift: ".concat((0, ae.toSeconds)(be.timeDifferenceMs), "s"));
            }).catch(function() {
              be.context.logger.debug("Synchronizing client time with time server unsuccessful");
            })), this.driftPromise;
          }, se.prototype.getSynchronizationPromise = function() {
            return this.driftPromise;
          }, se.prototype.reset = function() {
            this.timeDifferenceMs = 0, this.driftPromise = void 0, this.currentServerTimeProvider && (this.currentServerTimeProvider.cancelRequest(), this.currentServerTimeProvider = void 0);
          }, se.prototype.dispose = function() {
            this.reset();
          }, se;
        }();
        ne.SynchronizedTimeService = le;
      }, 64729: function(ee, ne) {
        function ie(ae, ce, he, _e) {
          var le, se = he.getPeriodIdForTime(ae);
          if (!se)
            return ae;
          var oe = he.isTimeNearPeriodEnd(ae, se, ce), ue = he.getNextPeriod(se);
          return oe && ue ? (_e.debug("Target time ".concat(ae, " too close to end of period ").concat(se, ", adjusting to next period start ").concat(ue.start)), (le = ue.start) !== null && le !== void 0 ? le : ae) : ae;
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.adjustTargetTimeToPeriodStart = ie;
      }, 66137: function(ee, ne, ie) {
        var ae, ce = this && this.__assign || function() {
          return ce = Object.assign || function(oe) {
            for (var ue, be = 1, ve = arguments.length; be < ve; be++)
              for (var me in ue = arguments[be])
                Object.prototype.hasOwnProperty.call(ue, me) && (oe[me] = ue[me]);
            return oe;
          }, ce.apply(this, arguments);
        }, he = this && this.__spreadArray || function(oe, ue, be) {
          if (be || arguments.length === 2)
            for (var ve, me = 0, pe = ue.length; me < pe; me++)
              !ve && me in ue || (ve || (ve = Array.prototype.slice.call(ue, 0, me)), ve[me] = ue[me]);
          return oe.concat(ve || Array.prototype.slice.call(ue));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.EncryptionKeyReducer = void 0;
        var _e = ie(21829), le = ie(56092), se = [];
        ne.EncryptionKeyReducer = (0, _e.default)(se, ((ae = {})[le.EncryptionKeyActionKey.AddEncryptionKey] = function(oe, ue) {
          var be = ue.payload;
          return he(he([], oe, !0), [ce({}, be)], !1);
        }, ae[le.EncryptionKeyActionKey.UpdateEncryptionKey] = function(oe, ue) {
          var be = ue.payload, ve = oe.findIndex(function(fe) {
            return fe.uri === be.uri;
          });
          if (ve === -1)
            return oe;
          var me = oe[ve], pe = he([], oe, !0);
          return pe.splice(ve, 1, ce(ce({}, me), be)), pe;
        }, ae[le.EncryptionKeyActionKey.RemoveEncryptionKey] = function(oe, ue) {
          var be = ue.payload;
          return he([], oe, !0).filter(function(ve) {
            return ve.uri !== be.keyUri;
          });
        }, ae));
      }, 66864: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Qe) {
            for (var tt, Je = 1, Ge = arguments.length; Je < Ge; Je++)
              for (var Ye in tt = arguments[Je])
                Object.prototype.hasOwnProperty.call(tt, Ye) && (Qe[Ye] = tt[Ye]);
            return Qe;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentLoader = ne.State = ne.SegmentLoadingErrorReason = void 0;
        var ce, he, _e = ie(52442), le = ie(25550), se = ie(28764), oe = ie(18665), ue = ie(62510), be = ie(90637), ve = ie(6311), me = ie(23234), pe = ie(36564), fe = ie(67345), ge = ie(76650), ye = ie(28819), $e = ie(8272), Se = ie(56093), Ce = ie(79814), Ie = ie(331), Te = ie(70016), Ee = ie(91520), we = ie(16368), Pe = ie(41108), Me = ie(73543), Ae = ie(48727), Oe = ie(82311), Be = ie(25040), Ve = ie(40392), Ue = ie(86674), Re = ie(36225), Ne = ie(5206), xe = ie(4141), ke = ie(72207);
        (function(Qe) {
          Qe.CANCEL = "CANCEL", Qe.ERROR_LOADING = "ERROR_LOADING", Qe.ERROR_DECRYPTING = "ERROR_DECRYPTING", Qe.BUSY = "BUSY", Qe.UNKNOWN = "UNKNOWN", Qe.TIMEOUT = "TIMEOUT", Qe.ABR_TIMEOUT = "ABR_TIMEOUT";
        })(ce || (ne.SegmentLoadingErrorReason = ce = {})), function(Qe) {
          Qe[Qe.IDLE = 1] = "IDLE", Qe[Qe.LOADING = 2] = "LOADING", Qe[Qe.CANCELLING = 3] = "CANCELLING", Qe[Qe.TERMINATED = 4] = "TERMINATED", Qe[Qe.TIMEOUT = 5] = "TIMEOUT", Qe[Qe.ABR_TIMEOUT = 6] = "ABR_TIMEOUT";
        }(he || (ne.State = he = {}));
        var Le = 408, He = 0.1, We = function() {
          function Qe(tt, Je, Ge, Ye) {
            Ye === void 0 && (Ye = !1);
            var ze = this;
            if (this.context = tt, this.cancelLoading = function(ot) {
              var vt, gt, yt, pt, bt, ut, Ke;
              if (ot === void 0 && (ot = he.CANCELLING), clearTimeout(ze.loadTimeoutID), clearInterval(ze.progressCheckIntervalId), ze.loadTimeoutID = null, ze.isLoading()) {
                var je = ze.currentSegmentInfoMap[ze.loadingUrl];
                if (delete ze.currentSegmentInfoMap[ze.loadingUrl], ze.state = ot, ze.loader.cancel(), ze.currentRequestProgress !== void 0) {
                  var De = (gt = (vt = ze.currentRequestProgress.responseTiming) === null || vt === void 0 ? void 0 : vt.headersReceivedTimestamp) !== null && gt !== void 0 ? gt : -1, at = (pt = (yt = ze.currentRequestProgress.responseTiming) === null || yt === void 0 ? void 0 : yt.openedTimestamp) !== null && pt !== void 0 ? pt : -1, dt = (bt = ze.currentRequestProgress.elapsedTime) !== null && bt !== void 0 ? bt : -1, ft = De - at;
                  dt >= 0 && ft >= 0 && dt > ft && ze.context.store.dispatch((0, ge.addMetricsValue)(ze.mimeType, $e.MetricType.DownloadInformation, { bytes: ze.currentRequestProgress.loadedBytes, time: dt, timeToFirstByte: ft })), !((ut = ze.currentRequestProgress) === null || ut === void 0) && ut.chunks && je && ze.dispatchCancelledChunkedDownloadMetrics(je), ze.canceledSegmentRequestFinishedEvent = { success: !1, httpStatus: Le, url: ze.loadingUrl, downloadTime: dt, size: ze.currentRequestProgress.loadedBytes, duration: (Ke = ze.segmentDuration) !== null && Ke !== void 0 ? Ke : 0, isInit: ze.isInit, mimeType: ze.mimeType, uid: void 0, timeToFirstByte: (0, ve.hasLoadedData)(ze.currentRequestProgress) ? ft : -1 };
                }
                ze.currentRequestProgress = void 0;
              }
            }, this.checkLoadingProgress = function() {
              var ot, vt, gt, yt = (gt = (vt = (ot = ze.currentRequestProgress) === null || ot === void 0 ? void 0 : ot.responseTiming) === null || vt === void 0 ? void 0 : vt.sendTimestamp) !== null && gt !== void 0 ? gt : -1;
              ze.currentRequestProgress === void 0 || yt < 0 || ze.onProgress(ae(ae({}, ze.currentRequestProgress), { elapsedTime: me.TimingUtil.getHiResTimestamp() - yt }));
            }, this.onProgress = function(ot) {
              var vt, gt = 0.5, yt = (vt = ot.elapsedTime) !== null && vt !== void 0 ? vt : -1, pt = ze.currentSegmentInfoMap[ze.loadingUrl];
              ze.currentRequestProgress = ae(ae({}, ot), { segmentDuration: ze.segmentDuration, url: ze.loadingUrl, representationBitrate: pt.bitrate }), ze.isInit || yt <= gt || ze.state !== he.LOADING || ze.onDownloadShouldBeCancelledCallback(ze.currentRequestProgress, pt.internalRepresentationId) && ze.cancelLoading(he.ABR_TIMEOUT);
            }, this.onSuccess = function(ot, vt, gt) {
              var yt, pt, bt, ut, Ke, je, De = ze.context.store.getState(), at = De ? (0, ye.getMetricsState)(De) : void 0;
              if (ze.context.logger.debug("Downloaded ".concat(ze.mimeType, " ").concat(ze.isInit ? "init" : "data", " segment in: ").concat((yt = ot.elapsedTime) === null || yt === void 0 ? void 0 : yt.toFixed(2), ", TTFB: ").concat((pt = ot.timeToFirstByte) === null || pt === void 0 ? void 0 : pt.toFixed(2), ", quality: ").concat((ut = (bt = ze.currentSegmentInfoMap[ze.loadingUrl]) === null || bt === void 0 ? void 0 : bt.representationId) !== null && ut !== void 0 ? ut : "")), !ze.isInit && at && ze.mimeType in at && (ze.context.store.dispatch((0, ge.addMetricsValue)(ze.mimeType, $e.MetricType.DownloadTime, vt)), ze.context.store.dispatch((0, ge.addMetricsValue)(ze.mimeType, $e.MetricType.DownloadSuccess, !0)), (0, pe.isDownloadTimeInformationValid)(ot) && ze.context.store.dispatch((0, ge.addMetricsValue)(ze.mimeType, $e.MetricType.DownloadInformation, { bytes: ot.length, time: ot.elapsedTime, timeToFirstByte: ot.timeToFirstByte })), (Ke = ze.currentRequestProgress) === null || Ke === void 0 ? void 0 : Ke.chunks)) {
                ze.logger.debug("[SegmentLoader] ", ze.currentRequestProgress.chunks);
                var dt = (0, Ue.calculateDownloadRates)(ze.currentRequestProgress.chunks), ft = (0, Ue.calcAverage)((0, Ue.filterValuesExceedingAverageByMargin)(dt)), lt = ze.currentRequestProgress.loadedBytes, nt = ze.currentSegmentInfoMap[ze.loadingUrl], ct = nt.duration, it = ct !== void 0 ? (0, Ve.bytesToBits)(lt) / ct : void 0, et = nt.bitrate;
                ze.logger.debug("[SegmentLoader] DL rate (AVG-based filter): ".concat((0, Ue.bpsToMbps)(ft), ", segmentBitrate: ").concat(it)), ze.context.store.dispatch((0, ge.addMetricsValue)(ze.mimeType, $e.MetricType.ChunkedDownloadInformation, { downloadRate: ft, segmentBitrate: it, representationBitrate: et }));
              }
              clearTimeout(ze.loadTimeoutID), clearInterval(ze.progressCheckIntervalId), ze.loadTimeoutID = void 0;
              var st = { success: !0, httpStatus: ot.status, url: ot.url, downloadTime: ot.elapsedTime, size: ot.length, duration: ze.segmentDuration, isInit: ze.isInit, mimeType: ze.mimeType, uid: ze.loadingUid, timeToFirstByte: (je = ot.timeToFirstByte) !== null && je !== void 0 ? je : -1 };
              ze.eventHandler.dispatchEvent(ue.PlayerEvent.SegmentRequestFinished, st);
            }, this.logger = tt.logger, this.eventHandler = tt.eventHandler, this.customLoaderArgs = tt.config.tweaks.segmentLoaderArgs || null, this.customLoader = tt.config.tweaks.segmentLoader || null, this.segmentDuration = 1, this.state = he.IDLE, this.mimeType = Je, this.keyLoader = new Ne.KeyLoader(this.context), this.onDownloadShouldBeCancelledCallback = Ge, this.currentLoadPromise = null, this.currentSegmentInfoMap = {}, this.canceledSegmentRequestFinishedEvent = null, this.isPrefetchingLoader = Ye, Ee.ModuleManager.has(we.ModuleName.ContainerMP4)) {
              var Fe = Ee.ModuleManager.get(we.ModuleName.ContainerMP4);
              this.cmafChunkParser = new Fe.CmafChunkParser(this.context);
            }
            this.setupContentLoader();
          }
          return Qe.prototype.dispatchCancelledChunkedDownloadMetrics = function(tt) {
            var Je, Ge, Ye, ze, Fe, ot, vt, gt, yt = ((Ye = (Ge = (Je = this.currentRequestProgress) === null || Je === void 0 ? void 0 : Je.responseTiming) === null || Ge === void 0 ? void 0 : Ge.progressTimestamp) !== null && Ye !== void 0 ? Ye : me.TimingUtil.getHiResTimestamp()) - ((ot = (Fe = (ze = this.currentRequestProgress) === null || ze === void 0 ? void 0 : ze.responseTiming) === null || Fe === void 0 ? void 0 : Fe.headersReceivedTimestamp) !== null && ot !== void 0 ? ot : 0), pt = (0, Ve.bytesToBits)((gt = (vt = this.currentRequestProgress) === null || vt === void 0 ? void 0 : vt.loadedBytes) !== null && gt !== void 0 ? gt : 0) / yt, bt = tt.duration === void 0 ? 1 : Math.max(1 - yt / tt.duration, He);
            this.context.store.dispatch((0, ge.addMetricsValue)(this.mimeType, $e.MetricType.ChunkedDownloadInformation, { downloadRate: pt * bt, segmentBitrate: void 0, representationBitrate: tt.bitrate }));
          }, Qe.prototype.isLoading = function() {
            var tt = !!(this.keyLoader && this.keyLoader.isLoading());
            return this.state === he.LOADING || this.state === he.CANCELLING || this.loader && this.loader.isLoading() || tt;
          }, Qe.prototype.isRetrying = function() {
            return this.loader && this.loader.isRetrying();
          }, Qe.prototype.load = function(tt) {
            var Je = this;
            if (this.isLoading())
              return this.logger.debug("Error loading segment, loader is busy!" + this.loadingUrl), Promise.reject({ reason: ce.BUSY });
            this.loader && this.loader.dispose();
            var Ge = this.defaultLoaderArgs;
            return tt.isPreloadHint && (Ge = ae(ae({}, Ge), { maxRetries: 0 })), this.canceledSegmentRequestFinishedEvent = null, this.currentRequestProgress = void 0, this.loader = (0, xe.getLoader)(this.context, Ge), this.state = he.LOADING, this.loadingUrl = tt.url, this.loadingUid = btoa(this.loadingUrl), this.currentSegmentInfoMap[this.loadingUrl] = tt, this.isInit = tt.isInitSegment, this.segmentDuration = tt.duration, this.currentLoadPromise = this.maybeLoadEncryptionKey(tt).then(function() {
              return Je.loadSegment(tt);
            }).catch(function(Ye) {
              throw Je.state = he.IDLE, Je.currentLoadPromise = null, Ye;
            }), this.currentLoadPromise;
          }, Qe.prototype.maybeLoadEncryptionKey = function(tt) {
            var Je, Ge = this;
            this.encryptionInfo = tt.key;
            var Ye = !!(!((Je = this.encryptionInfo) === null || Je === void 0) && Je.buffer);
            if (!this.encryptionInfo || Ye)
              return Promise.resolve();
            switch (this.encryptionInfo.method) {
              case _e.HlsEncryptionMethod.AES_128:
                return this.getKey(tt).then(function(ze) {
                  ze && (Ge.encryptionInfo.buffer = ze);
                });
              case _e.HlsEncryptionMethod.SAMPLE_AES:
                return this.eventHandler.fireError(new se.PlayerError(le.ErrorCode.SOURCE_ENCRYPTION_METHOD_NOT_SUPPORTED, { "encryption-method": this.encryptionInfo.method, supported: _e.HlsEncryptionMethod.AES_128 }, "The ".concat(_e.HlsEncryptionMethod.SAMPLE_AES, " encryption method is not supported."))), Promise.reject({ reason: ce.ERROR_DECRYPTING });
              case _e.HlsEncryptionMethod.SAMPLE_AES_CTR:
                return Promise.resolve();
              default:
                return Promise.reject({ reason: ce.ERROR_DECRYPTING });
            }
          }, Qe.prototype.getCurrentLoadPromise = function() {
            return this.currentLoadPromise;
          }, Qe.prototype.getSourceStore = function() {
            var tt;
            return (tt = this.context.serviceManager) === null || tt === void 0 ? void 0 : tt.get(oe.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, Qe.prototype.getKey = function(tt) {
            var Je, Ge = (Je = tt.key) === null || Je === void 0 ? void 0 : Je.uri, Ye = this.getSourceStore();
            if (!Ye || !Ge)
              return Promise.reject(new Error("Source store not available."));
            var ze = Ye.getState(), Fe = (0, Be.getEncryptionKey)(ze, Ge);
            return Fe != null && Fe.uri ? Fe.key ? Promise.resolve(Se.FormatHelper.hexToBytes(Fe.key).buffer) : (0, Re.waitForKeyToBeLoaded)(Ye, Ge) : (0, Re.addEncryptionKeyToStore)(Ge, this.keyLoader, Ye);
          }, Qe.prototype.getPreFetchedSegment = function(tt, Je) {
            var Ge;
            return this.isPrefetchingLoader || !(!((Ge = this.context.adRestorationOptimizationService) === null || Ge === void 0) && Ge.hasPrefetchedSegment(Je)) ? null : (this.currentSegmentInfoMap[tt] && (this.currentSegmentInfoMap[tt].wasPrefetched = !0), this.context.adRestorationOptimizationService.getPrefetchedSegment(Je, this.onDownloadShouldBeCancelledCallback));
          }, Qe.prototype.setupLoadingProgressCheckInterval = function() {
            clearInterval(this.progressCheckIntervalId);
            var tt = (0, Ie.toMilliSeconds)(this.context.settings.SEGMENT_LOADING_PROGRESS_CHECK_INTERVAL);
            tt <= 0 || (this.progressCheckIntervalId = window.setInterval(this.checkLoadingProgress, tt));
          }, Qe.prototype.loadSegment = function(tt) {
            var Je, Ge = this, Ye = {};
            tt.byteRange && (Ye.Range = ["bytes=", tt.byteRange.start, "-", tt.byteRange.end].join(""));
            var ze = this.context.sourceContext.source && this.context.sourceContext.source.hasOwnProperty("options") && !!this.context.sourceContext.source.options.withCredentials;
            clearTimeout(this.loadTimeoutID), clearInterval(this.progressCheckIntervalId), this.loadTimeoutID = void 0, this.isInit || tt.preventDownloadCanceling || (this.loadTimeoutID = setTimeout(function() {
              return Ge.cancelLoading(he.TIMEOUT);
            }, (0, Ie.toMilliSeconds)(this.context.settings.XHR_TIMEOUT)));
            var Fe = this.getPreFetchedSegment(this.loadingUrl, tt);
            if (Fe)
              return this.context.logger.debug("return prefetched segment for", this.loadingUrl), Fe.then(function(bt) {
                var ut = new ke.Stream();
                return Ge.loadingFinished(), ut.add(bt), bt.getSegmentInfo().wasPrefetched = !0, ut.end(), ut;
              }).catch(function(bt) {
                throw bt;
              });
            var ot = (Je = this.getSourceStore()) === null || Je === void 0 ? void 0 : Je.getState(), vt = ot && (0, Oe.getContainerFormat)(ot, Ce.MimeTypeHelper.getMediaType(this.mimeType)), gt = (vt == null ? void 0 : vt.source) === Me.ContainerFormat.MP4, yt = !!this.encryptionInfo || !!this.decrypter, pt = this.context.settings.CHUNKED_CMAF_STREAMING && this.cmafChunkParser && gt && !tt.isInitSegment && !yt;
            return this.setupLoadingProgressCheckInterval(), this.loader.load(this.loadingUrl, fe.HttpRequestMethod.GET, fe.HttpResponseType.ARRAYBUFFER, null, Ye, ze, this.mimeType, pt).then(function(bt) {
              return Ge.handleResponse(bt.body);
            }).catch(function(bt) {
              throw Ge.createLoadingError(bt);
            });
          }, Qe.prototype.createLoadingError = function(tt) {
            var Je, Ge;
            return [he.CANCELLING, he.TIMEOUT, he.ABR_TIMEOUT].includes(this.state) ? (this.logger.debug("Cancelled ".concat(this.mimeType, " download [").concat(this.loadingUrl, "]")), this.canceledSegmentRequestFinishedEvent && ((Je = this.eventHandler) === null || Je === void 0 || Je.dispatchEvent(ue.PlayerEvent.SegmentRequestFinished, this.canceledSegmentRequestFinishedEvent)), Ge = { reason: Xe(this.state) }) : this.state === he.LOADING && (Ge = { reason: ce.ERROR_LOADING, info: { response: tt, isInit: this.isInit } }), Ge;
          }, Qe.prototype.getAllLoadingPeriodIds = function() {
            var tt = this;
            return Object.keys(this.currentSegmentInfoMap).map(function(Je) {
              var Ge;
              return (Ge = tt.currentSegmentInfoMap[Je]) === null || Ge === void 0 ? void 0 : Ge.periodId;
            }).filter(Te.isDefined);
          }, Qe.prototype.getCurrentLoadingSegmentInfo = function() {
            return this.isLoading() && this.loadingUrl && this.currentSegmentInfoMap[this.loadingUrl] ? this.currentSegmentInfoMap[this.loadingUrl] : null;
          }, Qe.prototype.attachDecrypter = function(tt) {
            this.decrypter = this.decrypter || tt;
          }, Qe.prototype.attachClearKeyLoader = function(tt) {
            this.clearKeyLoader = this.clearKeyLoader || tt;
          }, Qe.prototype.terminate = function() {
            var tt, Je = this;
            this.isLoading() ? ((tt = this.currentLoadPromise) === null || tt === void 0 || tt.catch(function() {
              Je.state = he.TERMINATED;
            }), this.cancelLoading()) : this.state = he.TERMINATED;
          }, Qe.prototype.createSegment = function(tt) {
            var Je, Ge;
            Ge = this.isInit ? Ae.SegmentInitType.INIT : Ae.SegmentInitType.NONE;
            var Ye = this.currentSegmentInfoMap[this.loadingUrl], ze = new Ae.Segment(tt, this.mimeType, (Je = Ye.codecs) !== null && Je !== void 0 ? Je : null, Ye.periodId, this.segmentDuration, Ge, !0, tt.byteLength, Ye.internalRepresentationId, Ye.startTime);
            return ze.setUrl(this.loadingUrl), ze.setSegmentInfo(Ye), ze;
          }, Qe.prototype.maybeDecryptResponseData = function(tt, Je) {
            return this.encryptionInfo && this.encryptionInfo.method === _e.HlsEncryptionMethod.AES_128 && !Je ? this.decryptAes128(tt) : this.decrypter ? this.decryptClearKey(tt) : Promise.resolve(tt);
          }, Qe.prototype.decryptAes128 = function(tt) {
            return Ee.ModuleManager.has(we.ModuleName.Crypto) ? (this.logger.debug("Decrypting AES-128-encryped segment " + this.loadingUrl + ", KEY: 0x" + Se.FormatHelper.bytesToHex(this.encryptionInfo.buffer) + ", IV: 0x" + Se.FormatHelper.bytesToHex(this.encryptionInfo.iv)), new (Ee.ModuleManager.get(we.ModuleName.Crypto)).CryptoApi(this.context, "AES-CBC", this.encryptionInfo.buffer, this.encryptionInfo.iv, this.mimeType).decrypt(tt).then(function(Je) {
              if (!Je || Je.byteLength === 0)
                throw { reason: ce.ERROR_DECRYPTING };
              return Je;
            }).catch(function() {
              throw { reason: ce.ERROR_DECRYPTING };
            })) : (this.context.eventHandler.fireError(new Pe.PlayerModuleMissingError(we.ModuleName.Crypto)), Promise.reject({ reason: ce.ERROR_DECRYPTING }));
          }, Qe.prototype.decryptClearKey = function(tt) {
            var Je = this, Ge = Promise.resolve(tt);
            if (this.isInit)
              Ge = this.decrypter.parseInitSegment(tt), this.clearKeyLoader && (Ge = Ge.then(function(ze) {
                return Je.clearKeyLoader.load(Je.decrypter.getKeyIds()).then(function(Fe) {
                  return Je.decrypter.addKeys(Fe), Promise.resolve(ze);
                });
              }));
            else if (this.decrypter.isEncrypted()) {
              var Ye = Se.FormatHelper.bytesToHex(this.decrypter.getKey());
              this.logger.debug("Decrypting SAMPLE-AES-encrypted segment ".concat(this.loadingUrl, ", KEY: 0x").concat(Ye)), Ge = this.decrypter.decryptDataSegment(tt);
            }
            return Ge.catch(function() {
              throw { reason: ce.ERROR_DECRYPTING };
            });
          }, Qe.prototype.handleResponse = function(tt, Je) {
            var Ge = this;
            if (Je === void 0 && (Je = !1), tt instanceof ArrayBuffer) {
              this.segmentStream = new ke.Stream();
              var Ye = Date.now();
              this.maybeDecryptResponseData(tt, Je).then(function(ze) {
                var Fe;
                Ge.state === he.TERMINATED || Ge.state === he.CANCELLING ? Ge.segmentStream.abort(ce.CANCEL) : (Ge.segmentStream.add(Ge.createSegment(ze)), Ge.segmentStream.end());
                var ot = Ge.currentSegmentInfoMap[Ge.loadingUrl];
                if (tt !== ze && ot) {
                  var vt = (0, Ie.toSeconds)(Date.now() - Ye), gt = ot.internalRepresentationId, yt = { time: vt, representationId: gt };
                  Ge.context.store.dispatch((0, ge.addMetricsValue)(Ge.mimeType, $e.MetricType.DecryptionTime, yt)), Ge.context.logger.debug("Decrypted ".concat(Ge.mimeType, " segment in: ").concat(vt == null ? void 0 : vt.toFixed(2), ", quality: ").concat((Fe = gt == null ? void 0 : gt.representationId) !== null && Fe !== void 0 ? Fe : ""));
                }
              }).catch(function() {
                return Ge.segmentStream.abort(ce.ERROR_DECRYPTING);
              }).finally(function() {
                return Ge.loadingFinished();
              });
            } else
              this.segmentStream = tt.transform(function(ze) {
                return Ge.cmafChunkParser.appendData(ze), Ge.cmafChunkParser.getCompleteChunks();
              }, function() {
              }, function(ze) {
                return ze.message;
              }).transform(function(ze) {
                return Ge.createSegment(ze);
              }, function() {
                return Ge.loadingFinished();
              }, function(ze) {
                Ge.logger.debug("Error handling fetch segment request", ze);
                var Fe = ce.ERROR_LOADING;
                return ze.message === be.RequestError.Canceled && (Fe = Xe(Ge.state)), Ge.loadingFinished(), Fe;
              });
            return Promise.resolve(this.segmentStream);
          }, Qe.prototype.loadingFinished = function() {
            this.state = he.IDLE, this.currentLoadPromise = null, this.cmafChunkParser && this.cmafChunkParser.reset(), this.currentSegmentInfoMap && delete this.currentSegmentInfoMap[this.loadingUrl];
          }, Qe.prototype.dispose = function() {
            this.terminate(), clearTimeout(this.loadTimeoutID), clearInterval(this.progressCheckIntervalId), this.loader && this.loader.dispose && this.loader.dispose(), this.keyLoader && this.keyLoader.dispose(), Ee.ModuleManager.has(we.ModuleName.Crypto) && Ee.ModuleManager.get(we.ModuleName.Crypto).WebWorkerCrypto.dispose(), this.loader = null, this.customLoader = null, this.customLoaderArgs = null, this.keyLoader = null, this.loadingUrl = null, this.loadingUid = null, this.encryptionInfo = null, this.currentSegmentInfoMap = {}, this.currentRequestProgress = void 0, this.decrypter = null, this.eventHandler = null;
          }, Qe.prototype.setupContentLoader = function() {
            var tt = this;
            this.defaultLoaderArgs = ae(ae({}, (0, xe.getLoaderConfig)(this.context, this.mimeType)), { onSuccess: this.onSuccess, onProgress: this.onProgress, onFailure: function(Je, Ge) {
              var Ye, ze;
              tt.context.store.dispatch((0, ge.addMetricsValue)(tt.mimeType, $e.MetricType.DownloadSuccess, !1)), (Ge == null ? void 0 : Ge.name) === be.RequestError.TimedOut && (tt.state = he.TIMEOUT), clearTimeout(tt.loadTimeoutID), clearInterval(tt.progressCheckIntervalId), tt.loadTimeoutID = void 0, delete tt.currentSegmentInfoMap[tt.loadingUrl], tt.eventHandler.dispatchEvent(ue.PlayerEvent.SegmentRequestFinished, { success: !1, httpStatus: Je && Je.status || 0, url: (Ye = Je == null ? void 0 : Je.url) !== null && Ye !== void 0 ? Ye : tt.loadingUrl, downloadTime: -1, size: -1, duration: tt.segmentDuration, isInit: tt.isInit, mimeType: tt.mimeType, uid: void 0, timeToFirstByte: (ze = Je == null ? void 0 : Je.timeToFirstByte) !== null && ze !== void 0 ? ze : -1 });
            } });
          }, Qe;
        }();
        function Xe(Qe) {
          switch (Qe) {
            case he.ABR_TIMEOUT:
              return ce.ABR_TIMEOUT;
            case he.TIMEOUT:
              return ce.TIMEOUT;
            default:
              return ce.CANCEL;
          }
        }
        ne.SegmentLoader = We;
      }, 67550: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Re) {
            for (var Ne, xe = 1, ke = arguments.length; xe < ke; xe++)
              for (var Le in Ne = arguments[xe])
                Object.prototype.hasOwnProperty.call(Ne, Le) && (Re[Le] = Ne[Le]);
            return Re;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentListMPDHandler = ne.PHANTOM_SEGMENT_URL = void 0, ne.assignSegmentStartTimesFromHlsRepresentation = Ee, ne.copyPropValues = Ae, ne.getMatchingPart = Oe;
        var ce = ie(52442), he = ie(18665), _e = ie(42055), le = ie(91397), se = ie(81361), oe = ie(44388), ue = ie(331), be = ie(70016), ve = ie(91520), me = ie(16368), pe = ie(92103), fe = ie(93326), ge = ie(93109), ye = ie(73553), $e = ie(28915);
        ne.PHANTOM_SEGMENT_URL = "PHANTOM-SEGMENT";
        var Se = function() {
          function Re(Ne) {
            this.context = Ne, this.sourceContext = Ne.sourceContext, this.settings = Ne.settings, this.logger = Ne.logger, this.manifestService = Ne.serviceManager.get(he.ServiceName.ManifestService, this.sourceContext.sourceIdentifier), this.distanceToListStartSeconds = 0, this.segmentListMap = {}, this.timestampOffset = NaN;
          }
          return Object.defineProperty(Re.prototype, "playerStateService", { get: function() {
            return this.context.serviceManager.get(he.ServiceName.PlayerStateService);
          }, enumerable: !1, configurable: !0 }), Re.prototype.createSegmentListEntry = function(Ne, xe) {
            var ke;
            if (!Ne)
              return null;
            var Le = { isInitSegment: !1, url: Ne._media, duration: Ne._duration, internalRepresentationId: xe, periodId: xe.periodId };
            if (Ne._key && Ne._key.method !== ce.HlsEncryptionMethod.NONE && (Le.key = Ne._key), Ne._playbackTime !== void 0 && (Le.startTime = Ne._playbackTime), Ne._dateTime && (Le.dateTime = Ne._dateTime), Ne._metadata && (Le.metadata = Ne._metadata), Ne._byteRange && (Le.byteRange = Ne._byteRange), Ne._init && (Le.init = Ne._init, ((ke = Ne._init.key) === null || ke === void 0 ? void 0 : ke.method) === ce.HlsEncryptionMethod.NONE && (Le.init = ae({}, Le.init), delete Le.init.key)), Ne._mediaSequence !== void 0 && (Le.mediaSequence = Ne._mediaSequence), Ne._discontinuitySequenceNumber !== void 0 && (Le.discontinuitySequenceNumber = Ne._discontinuitySequenceNumber), Ne._parts) {
              var He = Le.dateTime;
              Le.parts = Ne._parts.map(function(We) {
                var Xe = we(We, Le);
                return He && (Xe.dateTime = He, Xe.startTime = (0, ue.toSeconds)(He.getTime()), He = new Date(He.getTime() + (0, ue.toMilliSeconds)(We.duration))), Xe;
              });
            }
            return Le.segmentId = (0, $e.generateSegmentId)(Le), Le;
          }, Re.prototype.removeDroppedOutSegmentsFromList = function(Ne, xe, ke) {
            if (xe.SegmentURL.length < 1)
              return Ne.entries = [], Ne.totalDuration = 0, Ne.entries.length;
            for (var Le = this.createSegmentListEntry(xe.SegmentURL[0], ke), He = 0, We = 0, Xe = 0; Xe < Ne.entries.length; Xe++) {
              var Qe = Ne.entries[Xe];
              if ((0, pe.isIdenticalSegmentInfo)(Qe, Le))
                break;
              He += Qe.duration, Ne.entries.splice(Xe, 1), Xe--, We++, this.manifestService.isLive() && this.currentRepresentationId.equals(ke) && this.rewindOneSegment();
            }
            return Ne.totalDuration -= He, We;
          }, Re.prototype.addNewSegmentsToList = function(Ne, xe, ke) {
            for (var Le = [], He = Ne.entries[Ne.entries.length - 1], We = 0, Xe = xe.SegmentURL.length - 1; Xe >= 0; Xe--) {
              var Qe = this.createSegmentListEntry(xe.SegmentURL[Xe], ke);
              if (He && (0, pe.isIdenticalSegmentInfo)(He, Qe)) {
                if (Pe(He)) {
                  var tt = Me(He, Qe);
                  Ne.totalDuration += tt;
                }
                break;
              }
              He && (0, pe.isIdenticalInitSegmentInfo)(He.init, Qe.init) && (Qe.init = He.init), isNaN(Qe.duration) && (Qe.duration = Ne.maximumSegmentDuration), Qe.duration /= Ne.timescale, We += Qe.duration, Le.unshift(Qe);
            }
            return Ne.totalDuration += We, Ne.entries = Ne.entries.concat(Le), Le.length;
          }, Re.prototype.updateSegmentList = function(Ne, xe) {
            var ke, Le, He = xe.SegmentList, We = xe._internalId.representationId, Xe = (ke = this.currentRepresentationId) === null || ke === void 0 ? void 0 : ke.equals(xe._internalId), Qe = (Le = He == null ? void 0 : He[0]) === null || Le === void 0 ? void 0 : Le.SegmentURL.length;
            if (!Xe || Qe) {
              Ne.Uri && Ne.Uri !== xe.Uri && this.resetSegmentListUponFailover(Ne, He == null ? void 0 : He[0], Xe), Ne.Uri = xe.Uri, Ne.timescale = 1, Ne.maximumSegmentDuration = 1, Ne.startNumber = 1;
              for (var tt = function(Ye) {
                var ze = He[Ye];
                if (ze.hasOwnProperty("_duration") && (Ne.maximumSegmentDuration = Number(ze._duration)), ["_timescale", "_startNumber", "_presentationTimeOffset"].filter(function(vt) {
                  return ze.hasOwnProperty(vt);
                }).forEach(function(vt) {
                  return Ne[vt.substr(1)] = ze[vt];
                }), Je.updateInitInfo(Ne, ze, xe), ze.hasOwnProperty("SegmentURL")) {
                  var Fe = Je.removeDroppedOutSegmentsFromList(Ne, ze, xe._internalId), ot = Je.addNewSegmentsToList(Ne, ze, xe._internalId);
                  Je.logManifestUpdateStats(xe._mimeType, We, Fe, ot), Je.manifestService.isHlsManifest() ? Ee(Ne.entries, xe._internalId, Je.manifestService) : Je.assignSegmentStartTimesForDash(Ne, xe._internalId);
                }
              }, Je = this, Ge = 0; Ge < He.length; Ge++)
                tt(Ge);
            }
          }, Re.prototype.resetSegmentListUponFailover = function(Ne, xe, ke) {
            var Le, He, We, Xe, Qe, tt;
            if (this.manifestService.isLive() && ke) {
              var Je = (We = (He = (Le = Ne.entries) === null || Le === void 0 ? void 0 : Le[0]) === null || He === void 0 ? void 0 : He.mediaSequence) !== null && We !== void 0 ? We : 1 / 0, Ge = ((Qe = (Xe = xe == null ? void 0 : xe.SegmentURL[0]) === null || Xe === void 0 ? void 0 : Xe._mediaSequence) !== null && Qe !== void 0 ? Qe : 0) - Je, Ye = Ue(Ne);
              !isNaN(Ge) && Ge > 0 && Ge < Ye && this.rewindSegmentListIndexBy(Ge);
            }
            (0, se.clearArray)((tt = Ne.entries) !== null && tt !== void 0 ? tt : []);
          }, Re.prototype.updateInitInfo = function(Ne, xe, ke) {
            var Le, He = (Le = ve.ModuleManager.get(me.ModuleName.DASH, !1)) === null || Le === void 0 ? void 0 : Le.initSegmentInfoSourceDetectors.isInitializationNode;
            He != null && He(xe) ? Ne.init = ve.ModuleManager.get(me.ModuleName.DASH, !1).initSegmentInfoProviders.provideSegmentInfoFromInitializationNodeProperty(xe, ke) : delete Ne.init;
          }, Re.prototype.logManifestUpdateStats = function(Ne, xe, ke, Le) {
            (ke > 0 || Le > 0) && this.logger.debug("[".concat(Ne, "][").concat(xe, "] Updated segment list, removed ").concat(ke, " segments and added ").concat(Le, " segments"));
          }, Re.prototype.assignSegmentStartTimesForDash = function(Ne, xe) {
            var ke = this.getMinStartTime(xe), Le = 0;
            Ne.entries.forEach(function(He) {
              var We;
              He.startTime = ke + Le, Le += (We = He.duration) !== null && We !== void 0 ? We : 0;
            });
          }, Re.prototype.extrapolateStartTimesFromDiscontinuityStarts = function(Ne) {
            var xe, ke, Le, He, We = (ke = (xe = this.getSourceStateService()) === null || xe === void 0 ? void 0 : xe.getState()) === null || ke === void 0 ? void 0 : ke.hls;
            if (We) {
              var Xe = Ne.getRepresentationId().representationId, Qe = this.getSegmentListEntries(this.currentRepresentationId), tt = ve.ModuleManager.get(me.ModuleName.HLS).selectors, Je = tt.getDiscoSequenceTimings, Ge = tt.getMergedDiscontinuityTimings, Ye = Ie(Qe, (Le = Je(We, Ne.getMimeType())) !== null && Le !== void 0 ? Le : Ge(We));
              if (!Ye) {
                var ze = (He = this.getCurrentPeriod()) === null || He === void 0 ? void 0 : He.start;
                if (ze === void 0)
                  return;
                Ye = { index: 0, discontinuityStartTime: ze }, this.logger.debug("Could not find discontinuity boundary with start time, using period start time ".concat(ze));
              }
              this.logger.debug("Assigning segment start times for rep ".concat(Xe, " from discontinuity at index ").concat(Ye.index, " with time ").concat(Ye.discontinuityStartTime)), Qe[Ye.index].startTime = Ye.discontinuityStartTime;
              for (var Fe = Ye.index - 1; Fe >= 0; Fe--)
                Qe[Fe].startTime = Qe[Fe + 1].startTime - Qe[Fe + 1].duration;
              for (Fe = Ye.index + 1; Fe < Qe.length; Fe++)
                Qe[Fe].startTime = Qe[Fe - 1].startTime + Qe[Fe - 1].duration;
            }
          }, Re.prototype.getSourceStateService = function() {
            return this.context.serviceManager.get(he.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, Re.prototype.getListIndexForSegment = function(Ne, xe) {
            for (var ke = -1, Le = this.getSegmentListEntries(xe), He = Le.length - 1; He >= 0; He--)
              if ((0, pe.isIdenticalSegmentInfo)(Le[He], Ne)) {
                ke = He;
                break;
              }
            return ke;
          }, Re.prototype.populateSegmentListMap = function(Ne) {
            var xe, ke = this, Le = (xe = this.manifestService) === null || xe === void 0 ? void 0 : xe.getAdaptationSet(Ne);
            Le && Le.Representation.forEach(function(He) {
              var We = ke.segmentListMap[He._internalId.key()];
              if (We || (We = ke.initializeSegmentList(He._internalId.key())), He.hasOwnProperty("SegmentList") && (ke.updateSegmentList(We, He), ve.ModuleManager.has(me.ModuleName.DASH))) {
                var Xe = ve.ModuleManager.get(me.ModuleName.DASH).initSegmentInfoSourceDetectors.isInitializationNode;
                if (!We.hasOwnProperty("init") && He.hasOwnProperty("SegmentBase") && He.SegmentBase && Xe(He.SegmentBase[0])) {
                  var Qe = ve.ModuleManager.get(me.ModuleName.DASH).initSegmentInfoProviders.provideSegmentInfoFromInitializationNodeProperty;
                  We.init = Qe(He.SegmentBase[0], He);
                }
              }
            });
          }, Re.prototype.selectNewRepresentationId = function() {
            var Ne, xe, ke = this, Le = (Ne = this.context.serviceManager.get(he.ServiceName.SourceStoreService, this.sourceContext.sourceIdentifier).getState().activeTracks) === null || Ne === void 0 ? void 0 : Ne[this.adaptationSetId.adaptationSetId];
            if (((xe = Le == null ? void 0 : Le.selectedRepresentationId) === null || xe === void 0 ? void 0 : xe.periodId) === this.adaptationSetId.periodId)
              return Le.selectedRepresentationId;
            if (this.currentRepresentationId) {
              var He = this.manifestService.getRepresentation(this.adaptationSetId, this.currentRepresentationId.representationId);
              if (He)
                return He._internalId;
            }
            var We = function(Xe) {
              return ke.isSegmentInfoLoaded(Xe._internalId);
            };
            return (this.getMatchingRepresentationByBandwidth(We) || this.getMatchingRepresentationByBandwidth())._internalId;
          }, Re.prototype.getMatchingRepresentationByBandwidth = function(Ne) {
            return this.manifestService.getMatchingRepresentationByBandwidth(this.adaptationSetId, this.getCurrentBandwidth(), Ne);
          }, Re.prototype.shouldUpdateRepresentation = function() {
            var Ne = this.adaptationSetId.equals(this.currentRepresentationId), xe = !this.currentRepresentationId || !!this.manifestService.getRepresentationById(this.currentRepresentationId);
            return !this.currentRepresentationId || !Ne || !xe;
          }, Re.prototype.setAdaptationSetId = function(Ne) {
            this.adaptationSetId = Ne, this.populateSegmentListMap(this.adaptationSetId);
            var xe, ke = this.manifestService.isLive(), Le = 0;
            this.shouldUpdateRepresentation() && (this.currentRepresentationId = this.selectNewRepresentationId());
            var He = this.segmentListMap[this.currentRepresentationId.key()];
            if (He || (He = this.initializeSegmentList(this.currentRepresentationId.key())), He && ke && He.entries && He.entries.length > 0) {
              var We = He.entries.length - 1;
              this.listIndex > We && (Le = this.listIndex - We), this.listIndex = Math.min(We, this.listIndex || 0), this.listIndex = Math.max(0, this.listIndex), xe = He.entries[this.listIndex];
            }
            if (this.listIndex = this.listIndex || 0, ke && (this.distanceToListStartSeconds = this.getSegmentDuration() * this.settings.LIVE_SEGMENT_LIST_START_INDEX_OFFSET), ke) {
              if (xe && He) {
                var Xe = this.getListIndexForSegment(xe, this.currentRepresentationId);
                Xe >= 0 ? this.listIndex = Xe + Le : this.reset();
              } else
                this.reset();
              var Qe = this.checkForSegmentInfoError();
              Qe ? this.rejectPendingSegmentInfoRequest(Qe) : this.resolvePendingSegmentInfoRequests();
            } else
              this.resolvePendingSegmentInfoRequests();
          }, Re.prototype.initializeSegmentList = function(Ne) {
            var xe = { totalDuration: 0, entries: [], SegmentURL: [], startNumber: 0, init: null, maximumSegmentDuration: 1, timescale: 1 };
            return this.segmentListMap[Ne] = xe, xe;
          }, Re.prototype.getCurrentBandwidth = function() {
            var Ne = 0, xe = this.getCurrentRepresentation();
            return xe && (Ne = xe._bandwidth), Ne;
          }, Re.prototype.checkForSegmentInfoError = function() {
            var Ne;
            if (this.manifestService.isHlsManifest()) {
              var xe = this.manifestService.getRepresentationById(this.currentRepresentationId);
              if (!((Ne = xe == null ? void 0 : xe._hls) === null || Ne === void 0) && Ne.loadFailureReason)
                return xe._hls.loadFailureReason;
            }
            return this.hasNext() || this.manifestService.isLastPeriod(this.currentRepresentationId.periodId) ? null : ye.SegmentInfoError.PERIOD_COMPLETE;
          }, Re.prototype.reset = function() {
            this.settings.ENABLE_SEEK_FOR_LIVE ? this.listIndex = 0 : this.timeShift(0);
          }, Re.prototype.syncSegmentStartTimeUsingMediaSequenceNumber = function(Ne, xe) {
            var ke, Le, He = this.manifestService.getRepresentationById(Ne), We = this.manifestService.getRepresentationById(xe), Xe = (0, be.isNumber)((ke = We == null ? void 0 : We._hls) === null || ke === void 0 ? void 0 : ke.mediaSequence) && (0, be.isNumber)((Le = He == null ? void 0 : He._hls) === null || Le === void 0 ? void 0 : Le.mediaSequence);
            if (He && We && Xe) {
              var Qe = We._hls.mediaSequence - He._hls.mediaSequence, tt = this.getSegmentListEntries(Ne), Je = this.getSegmentListEntries(xe);
              if (!(Qe >= tt.length)) {
                Je[0].startTime = tt[Qe].startTime;
                var Ge = function(Ye, ze) {
                  (0, be.isNumber)(Ye.startTime) && (0, be.isNumber)(Ye.duration) && (ze.startTime = Ye.startTime + Ye.duration);
                };
                (0, se.forEachFromIndex)(Je, 1, Ge);
              }
            }
          }, Re.prototype.setRepresentationId = function(Ne) {
            var xe = this.manifestService.getRepresentationById(Ne), ke = this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex];
            if (xe) {
              var Le = this.currentRepresentationId === void 0, He = this.currentRepresentationId;
              if (this.currentRepresentationId = Ne, this.manifestService.isLive() && xe._hls) {
                if (this.settings.HLS_SYNC_SEGMENT_PLAYBACK_TIME_VIA_MEDIA_SEQUENCE && this.syncSegmentStartTimeUsingMediaSequenceNumber(He, this.currentRepresentationId), Le)
                  this.reset();
                else if (this.settings.HLS_SYNC_VIA_MEDIA_SEQUENCE) {
                  var We = this.manifestService.getRepresentationById(He)._hls.mediaSequence + this.listIndex;
                  this.listIndex = We - xe._hls.mediaSequence, this.listIndex = Math.max(this.listIndex, 0);
                } else if ((ke == null ? void 0 : ke.startTime) != null && !isNaN(ke.startTime)) {
                  var Xe = this.getIndexForTime(ke.startTime);
                  Xe === null || isNaN(Xe) || (this.listIndex = this.adaptListIndexToCorrectIndex(Xe, ke.startTime));
                }
              }
              return !0;
            }
            return !1;
          }, Re.prototype.adaptListIndexToCorrectIndex = function(Ne, xe) {
            var ke = this.getSegmentListEntries(this.currentRepresentationId), Le = [ke[Ne], ke[Ne + 1]];
            if (Ne === ke.length - 1 || Le.some(function(Xe) {
              return !Xe.startTime;
            }))
              return Ne;
            var He = Le.map(function(Xe) {
              return Math.abs(Xe.startTime - xe);
            }), We = Math.min.apply(this, He);
            return Ne + He.indexOf(We);
          }, Re.prototype.getInitSegmentInfo = function() {
            var Ne = this.getSegmentList(this.currentRepresentationId);
            if (Ne != null && Ne.init)
              return Ne.init.presentationTimeOffset = this.getTimestampOffset(), Ne.init;
            var xe = this.getSegmentListEntries(this.currentRepresentationId);
            if (this.isIndexInBounds(xe) && this.listIndex > -1) {
              var ke = ae({}, xe[this.listIndex]);
              if (ke.init) {
                var Le = ke.init;
                return Le.isInitSegment = !0, Le;
              }
            }
            return null;
          }, Re.prototype.getNextSegmentInfo_ = function(Ne) {
            var xe;
            if (!(this.getSegmentListEntries(this.currentRepresentationId).length < 1 || this.listIndex < 0)) {
              var ke = this.isTargetTimeOfOngoingSeek(Ne);
              return ke && this.logger.debug("".concat((xe = this.adaptationSetId) === null || xe === void 0 ? void 0 : xe.adaptationSetId, " given time ").concat(Ne, " matches seek time, performing precise segment/part search"), Ne), (0, ge.isPlayingLowLatencyHls)(this.context) && this.setListIndexForTime(Ne, ke), this.getNextSegmentOrPart(Ne, ke);
            }
          }, Re.prototype.isTargetTimeOfOngoingSeek = function(Ne) {
            var xe;
            return Ne === ((xe = this.playerStateService) === null || xe === void 0 ? void 0 : xe.targetPlaybackTime) || !1;
          }, Re.prototype.setListIndexForTime = function(Ne, xe) {
            var ke;
            if (Ne !== 0) {
              if (this.listIndex = this.getIndexForTime(Ne), !xe) {
                var Le = this.getSegmentListEntries(this.currentRepresentationId), He = Le[this.listIndex];
                if (!(He.parts && He.parts.length > 0)) {
                  var We = this.listIndex;
                  this.listIndex = Be(Ne, this.listIndex, Le), this.listIndex !== We && this.logger.debug("Snapped segment index for time ".concat(Ne, " to next segment boundary at ").concat((ke = Le[this.listIndex]) === null || ke === void 0 ? void 0 : ke.startTime));
                }
              }
            } else
              this.context.logger.debug("Ignoring target time of 0 for LL-HLS");
          }, Re.prototype.getNextSegmentOrPart = function(Ne, xe) {
            var ke = this.getSegmentListEntries(this.currentRepresentationId);
            if (this.isIndexInBounds(ke)) {
              var Le = ke[this.listIndex];
              if (!(Le.parts && Le.parts.length > 0))
                return this.getNextFullSegmentInfo();
              if (Pe(Le))
                return Oe(Le, Ne, xe);
              var He = Oe(Le, Ne, xe);
              return He ? Le.parts.indexOf(He) > 0 ? He : this.getNextFullSegmentInfo() : (this.listIndex++, this.getNextSegmentOrPart(Ne, xe));
            }
          }, Re.prototype.getNextSegmentInfo = function(Ne) {
            var xe = this.getNextSegmentInfo_(Ne);
            return xe ? (this.populateSegmentInfoProps(xe), Promise.resolve(xe)) : this.queueSegmentInfoRequest({ time: Ne });
          }, Re.prototype.populateSegmentInfoProps = function(Ne) {
            return Ne.presentationTimeOffset = this.getTimestampOffset(), Ne.startTime && (Ne.wallClockTime = (0, ue.toMilliSeconds)(Ne.startTime)), Ne;
          }, Re.prototype.getNextFullSegmentInfo = function() {
            return this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex++];
          }, Re.prototype.getSegmentInfos = function() {
            var Ne = this, xe = {}, ke = this.manifestService.getAdaptationSet(this.adaptationSetId);
            return ke && ke.Representation.forEach(function(Le) {
              var He = Ne.getSegmentListEntries(Le._internalId);
              xe[Le._id] = He.map(function(We) {
                return { url: We.url, duration: We.duration, startTime: We.startTime };
              });
            }), xe;
          }, Re.prototype.getSubtitleUrl = function() {
            return this.manifestService.getAvailableSubtitles(this.adaptationSetId.periodId)[0].url;
          }, Re.prototype.getStartNumber = function() {
            var Ne = this.getSegmentList(this.currentRepresentationId);
            return Ne ? Ne.startNumber : 1;
          }, Re.prototype.getSegmentDuration = function() {
            var Ne = this, xe = this.getSegmentList(this.currentRepresentationId), ke = this.getSegmentListEntries(this.currentRepresentationId);
            if (xe)
              return ke.length > 0 && (0, be.isNumber)(xe.totalDuration) ? xe.totalDuration / ke.length : xe.maximumSegmentDuration;
            if (this.manifestService.getAdaptationSet(this.adaptationSetId)) {
              var Le = Object.keys(this.segmentListMap).map(function(He) {
                return Ne.segmentListMap[He];
              }).find(function(He) {
                return He !== null;
              });
              if (Le)
                return Le.maximumSegmentDuration;
            }
            return 1;
          }, Re.prototype.seekTo = function(Ne) {
            Ne > -1 && (this.listIndex = this.getIndexForTime(Ne));
          }, Re.prototype.isIndexInBounds = function(Ne) {
            return this.listIndex < Ne.length;
          }, Re.prototype.hasNext = function() {
            var Ne = this.getSegmentListEntries(this.currentRepresentationId);
            return !this.currentRepresentationId || !Ne.length || (this.manifestService.isLive() ? this.hasNextLive(Ne) : this.isIndexInBounds(Ne));
          }, Re.prototype.hasNextLive = function(Ne) {
            return !!this.manifestService.isLastPeriod(this.currentRepresentationId.periodId) || this.isIndexInBounds(Ne);
          }, Re.prototype.setTimestampOffset = function(Ne, xe) {
            xe === void 0 && (xe = 1), this.timestampOffset = Ne / xe;
          }, Re.prototype.getTimestampOffset = function() {
            if (!isNaN(this.timestampOffset))
              return this.timestampOffset;
            var Ne = this.getCurrentPeriod(), xe = 0;
            if (this.currentRepresentationId) {
              var ke = this.getSegmentList(this.currentRepresentationId);
              ke && !isNaN(ke.presentationTimeOffset) && (xe = ke.presentationTimeOffset / ke.timescale);
            }
            return Ne && !this.manifestService.isHlsManifest() && (xe -= Ne.start), xe;
          }, Re.prototype.getIndex = function() {
            return this.listIndex;
          }, Re.prototype.setIndex = function(Ne) {
            if (typeof Ne == "number")
              return Ne < 0 ? (this.logger.debug("Tried to set index at MPDHandler to value smaller 0. Setting to 0."), void (this.listIndex = 0)) : void (this.listIndex = Ne);
            this.logger.debug("Tried to set index at MPDHandler with parameter not being a number!");
          }, Re.prototype.queueSegmentInfoRequest = function(Ne) {
            var xe, ke = this;
            if (this.pendingSegmentInfoRequest)
              return Promise.reject("fail");
            var Le = this.manifestService.getRepresentationById(this.currentRepresentationId);
            return !((xe = Le == null ? void 0 : Le._hls) === null || xe === void 0) && xe.loadFailureReason ? Promise.reject(Le._hls.loadFailureReason) : (this.logger.debug("No segment info was found for the target time. Waiting for representation update."), new Promise(function(He, We) {
              ke.pendingSegmentInfoRequest = ae(ae({}, Ne), { resolve: He, reject: We });
            }));
          }, Re.prototype.resolvePendingSegmentInfoRequests = function() {
            if (this.pendingSegmentInfoRequest) {
              var Ne = this.getNextSegmentInfo_(this.pendingSegmentInfoRequest.time);
              Ne ? (this.populateSegmentInfoProps(Ne), this.pendingSegmentInfoRequest.resolve(Ne), this.pendingSegmentInfoRequest = null) : this.manifestService.isLive() || this.hasNext() || this.pendingSegmentInfoRequest.reject(ye.SegmentInfoError.END_OF_STREAM_REACHED);
            }
          }, Re.prototype.rejectPendingSegmentInfoRequest = function(Ne) {
            this.pendingSegmentInfoRequest && (this.pendingSegmentInfoRequest.reject(Ne), this.pendingSegmentInfoRequest = null);
          }, Re.prototype.getLiveEdgeIndex = function() {
            var Ne = this.getSegmentListEntries(this.currentRepresentationId);
            return Ne.length > 0 ? Ne.length - 1 : 0;
          }, Re.prototype.getIndexForOffset = function(Ne) {
            for (var xe, ke = Math.abs(Ne), Le = this.getSegmentDuration(), He = this.getSegmentListEntries(this.currentRepresentationId), We = this.getLiveEdgeIndex(), Xe = 0, Qe = He.length - 1; Qe >= 0 && !((Xe += (xe = He[Qe].duration) !== null && xe !== void 0 ? xe : Le) >= ke); Qe--)
              We--;
            return Math.max(0, We);
          }, Re.prototype.timeShift = function(Ne, xe, ke) {
            if (this.manifestService.isLive()) {
              var Le = this.listIndex;
              this.listIndex = ke && this.hasStartTimes() ? this.getIndexForTime(ke) : this.getIndexForOffset(Ne), this.logger.debug("timeShift changes index from ".concat(Le, " to ").concat(this.listIndex, ", based on") + " offset ".concat(Ne, " and target time ").concat(ke));
            }
          }, Re.prototype.hasStartTimes = function() {
            var Ne, xe = (Ne = this.getSegmentListEntries(this.currentRepresentationId)[0]) === null || Ne === void 0 ? void 0 : Ne.startTime;
            return (0, be.isNumber)(xe) && xe >= 0;
          }, Re.prototype.updateRepresentation = function(Ne) {
            return Promise.resolve(Ne);
          }, Re.prototype.isSegmentInfoLoaded = function(Ne) {
            if (Ne === void 0 && (Ne = this.currentRepresentationId), !Ne)
              return !1;
            var xe = this.getSegmentListEntries(Ne), ke = this.manifestService.getRepresentationById(Ne);
            return !(!xe.length || !ke);
          }, Re.prototype.rewindSegmentListIndexBy = function(Ne) {
            this.logger.debug("Rewinding segment list index by ".concat(Ne, " segments")), this.listIndex -= Ne, this.listIndex < 0 && (this.logger.debug("List array index is smaller than 0, probably a discontinuity. Using 0."), this.listIndex = 0);
          }, Re.prototype.rewindOneSegment = function() {
            return this.listIndex--, !(this.listIndex < 0) || (this.logger.debug("List array index is smaller than 0, probably a discontinuity. Using 0."), this.listIndex = 0, !1);
          }, Re.prototype.getCurrentPeriod = function() {
            return this.manifestService.getPeriod(this.currentRepresentationId);
          }, Re.prototype.getExpectedPresentationTime = function(Ne) {
            var xe = this.getCurrentPeriod().start;
            return (this.manifestService.hasSinglePeriod() ? this.getSeekableRange().start : xe) + this.getSegmentListEntries(this.currentRepresentationId).slice(0, Ne).reduce(function(ke, Le) {
              return ke + Le.duration;
            }, 0);
          }, Re.prototype.getCurrentRepresentation = function() {
            return this.manifestService.getRepresentationById(this.currentRepresentationId);
          }, Re.prototype.getSegmentList = function(Ne) {
            if (Ne)
              return this.segmentListMap[Ne.key()];
          }, Re.prototype.getSegmentListEntries = function(Ne) {
            var xe, ke;
            return Ne ? this.settings.ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE && this.manifestService.isHlsManifest() ? this.getStoreSegmentInfos(Ne) : (ke = (xe = this.getSegmentList(Ne)) === null || xe === void 0 ? void 0 : xe.entries) !== null && ke !== void 0 ? ke : [] : [];
          }, Re.prototype.getStoreSegmentInfos = function(Ne) {
            var xe, ke = (xe = this.getSourceStateService()) === null || xe === void 0 ? void 0 : xe.getState();
            return (0, fe.getSegmentInfos)(ke, Ne.key());
          }, Re.prototype.findListIndexWithoutSegmentStartTimes = function(Ne, xe) {
            var ke, Le;
            if (!this.adaptationSetId)
              return 0;
            for (var He = this.manifestService.getPeriod(this.adaptationSetId), We = (ke = He == null ? void 0 : He.start) !== null && ke !== void 0 ? ke : 0, Xe = this.getSegmentListEntries(this.currentRepresentationId), Qe = 0, tt = We; tt <= xe && Qe < Xe.length; Qe++)
              tt += (Le = Xe[Qe].duration) !== null && Le !== void 0 ? Le : 0;
            return Math.max(Qe - 1, 0);
          }, Re.prototype.getIndexForTime = function(Ne) {
            var xe = this.getSegmentList(this.currentRepresentationId), ke = this.getSegmentListEntries(this.currentRepresentationId);
            if (!xe || ke.length === 0 || !(0, be.isNumber)(xe.totalDuration))
              return 0;
            var Le = this.getMinStartTime(), He = Math.max(Le, Ne), We = xe.totalDuration / ke.length, Xe = (0, $e.findSegmentIndexForTime)(ke, He, We);
            return Xe !== null ? Xe : this.findListIndexWithoutSegmentStartTimes(xe, He);
          }, Re.prototype.getMinStartTime = function(Ne) {
            Ne === void 0 && (Ne = this.currentRepresentationId);
            var xe = this.manifestService.hasSinglePeriod() ? this.getSeekableRange().start : this.manifestService.getPeriod(Ne).start;
            return this.manifestService.isFirstPeriod(Ne.periodId) && (xe += this.distanceToListStartSeconds), xe;
          }, Re.prototype.getLiveEdgeTime = function() {
            var Ne, xe = (Ne = this.manifestService) === null || Ne === void 0 ? void 0 : Ne.getLastPeriod();
            return xe ? xe.start + oe.DurationConverter.getDurationInSec(xe._duration) : 1 / 0;
          }, Re.prototype.getActualTimeShiftBufferDepth = function() {
            return this.manifestService.getTimeShiftBufferDepthSeconds();
          }, Re.prototype.getSeekableRange = function() {
            var Ne = { start: 0, end: 0 }, xe = this.manifestService.getTotalDuration();
            if (!this.manifestService.isLive())
              return Ne.start = (0, _e.getStartTimeOffset)(this.getSourceStateService().getState()), Ne.end = xe, Ne;
            var ke = this.manifestService.getTimeShiftBufferDepthSeconds(), Le = (0, ue.toSeconds)(this.manifestService.getRequestTimestamp() - this.manifestService.getAvailabilityStartTime());
            if (Ne.start = Math.max(Le + ke, 0), Ne.end = Math.max(Le, 0), ve.ModuleManager.has(me.ModuleName.HLS) && this.manifestService.isHlsManifest()) {
              var He = ve.ModuleManager.get(me.ModuleName.HLS).selectors, We = He.getHlsState;
              (0, He.getPlaylistType)(We(this.getSourceStateService().getState())) === "EVENT" ? (Ne.start = 0, Ne.end = xe) : Ne.start += this.distanceToListStartSeconds;
            }
            return Ne.end -= this.manifestService.getDesiredDistanceToLiveEdge(), Ne;
          }, Re.prototype.getPendingSegmentInfoRequest = function() {
            return this.pendingSegmentInfoRequest;
          }, Re.prototype.setPendingSegmentInfoRequest = function(Ne) {
            this.pendingSegmentInfoRequest = Ne;
          }, Re.prototype.canSwitchRepresentation = function(Ne) {
            var xe, ke = this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex];
            if (!ke)
              return !0;
            var Le = Ve(Ne, ke, this.settings.LL_HLS_SEGMENT_END_TIME_MATCHING_TOLERANCE);
            if (!Pe(ke) && Le)
              return !0;
            var He = this.isTargetTimeOfOngoingSeek(Ne);
            return !(!((xe = ke == null ? void 0 : ke.parts) === null || xe === void 0) && xe.length && Oe(ke, Ne, He) !== ke.parts[0]);
          }, Re.prototype.getLatestTimeForPossibleSwitch = function(Ne) {
            var xe, ke = this.getLLHlsInfoForTime(Ne), Le = ke.isLoadingCurrentSegmentsParts, He = ke.currentSegment;
            return He && Le && (xe = He.startTime) !== null && xe !== void 0 ? xe : Ne;
          }, Re.prototype.adjustTimeToNextSegmentStart = function(Ne) {
            var xe = this.getLLHlsInfoForTime(Ne), ke = xe.isLoadingCurrentSegmentsParts, Le = xe.currentSegment;
            return ke && (Le != null && Le.startTime) && (Le != null && Le.duration) ? Le.startTime + Le.duration : Ne;
          }, Re.prototype.getLLHlsInfoForTime = function(Ne) {
            var xe, ke = Ce(Ne, this.getSegmentListEntries(this.currentRepresentationId)), Le = (xe = ke == null ? void 0 : ke.parts) === null || xe === void 0 ? void 0 : xe[0], He = this.isTargetTimeOfOngoingSeek(Ne), We = !1;
            if (Le && ke) {
              var Xe = Oe(ke, Ne, He);
              We = Xe !== void 0 && Xe !== Le;
            }
            return { currentSegment: ke, isLoadingCurrentSegmentsParts: We };
          }, Re.prototype.dispose = function() {
            this.settings = null, this.manifestService = null, this.adaptationSetId = null, this.currentRepresentationId = null, this.manifestService = null, this.pendingSegmentInfoRequest = null, this.segmentListMap = null;
          }, Re;
        }();
        function Ce(Re, Ne) {
          var xe, ke, Le;
          if (Ne && !(Ne.length < 1) && (!((xe = Ne[0]) === null || xe === void 0) && xe.duration)) {
            var He = (0, $e.findSegmentIndexForTime)(Ne, Re, Ne[0].duration), We = He === null, Xe = Re < ((Le = (ke = Ne[0]) === null || ke === void 0 ? void 0 : ke.startTime) !== null && Le !== void 0 ? Le : 1 / 0), Qe = Ne[Ne.length - 1];
            if (Qe.startTime !== void 0 && Qe.duration !== void 0) {
              var tt = Re > Qe.startTime + Qe.duration;
              if (!(We || Xe || tt))
                return Ne[He];
            }
          }
        }
        function Ie(Re, Ne) {
          for (var xe = Re[0].discontinuitySequenceNumber, ke = 1; ke < Re.length; ke++) {
            var Le = Re[ke].discontinuitySequenceNumber;
            if (Le !== xe) {
              var He = Te(Ne, Le);
              if (He != null)
                return { index: ke, discontinuityStartTime: He };
            }
          }
          return null;
        }
        function Te(Re, Ne) {
          var xe = Re[String(Ne)];
          return xe && xe.startTime > 0 ? xe.startTime : (xe = Re[String(Ne - 1)]) && xe.endTime > 0 ? xe.endTime : null;
        }
        function Ee(Re, Ne, xe) {
          if (Re.length && xe.hasSegmentStartTimeForHlsRepresentation(Ne)) {
            var ke;
            Re[0].startTime != null ? ke = (0, se.findIndexFromEnd)(Re, function(He) {
              return He.startTime != null;
            }) + 1 : (Re[0].startTime = xe.getStartTimeForHlsSegment(Ne, Re[0]), ke = 1);
            var Le = function(He, We) {
              return We.startTime = He.startTime + He.duration;
            };
            (0, se.forEachFromIndex)(Re, ke, Le);
          }
        }
        function we(Re, Ne) {
          var xe = { url: Re.uri, duration: Re.duration, isInitSegment: !1, internalRepresentationId: Ne.internalRepresentationId, isPreloadHint: !!Re.isPreloadHint, isIndependent: !!Re.independent };
          return Re.byteRange && (xe.byteRange = Re.byteRange), Ne.key && (xe.key = Ne.key), Ne.init && (xe.init = Ne.init), (0, be.isDefined)(Ne.mediaSequence) && (xe.mediaSequence = Ne.mediaSequence), (0, be.isDefined)(Ne.discontinuitySequenceNumber) && (xe.discontinuitySequenceNumber = Ne.discontinuitySequenceNumber), xe;
        }
        function Pe(Re) {
          return Re.url.endsWith(ne.PHANTOM_SEGMENT_URL);
        }
        function Me(Re, Ne) {
          var xe = Ne.duration - Re.duration;
          return Ae(Ne, Re, ["url", "mediaURL", "duration", "parts", "init", "key", "discontinuitySequenceNumber", "isDiscontinuityStart"]), !Re.url.endsWith(ne.PHANTOM_SEGMENT_URL) && (Re.url = (0, le.forceReallocation)(Re.url)), xe;
        }
        function Ae(Re, Ne, xe) {
          xe.forEach(function(ke) {
            return Ne[ke] = Re[ke];
          });
        }
        function Oe(Re, Ne, xe) {
          var ke, Le = (ke = Re.parts) === null || ke === void 0 ? void 0 : ke.every($e.isSegmentTiming);
          if (Re.parts && Le) {
            var He = Re.parts, We = He.reduce(function(Qe, tt) {
              return Qe + tt.duration;
            }, 0) / He.length, Xe = (0, $e.findSegmentIndexForTime)(He, Ne, We);
            if (Xe != null)
              return xe ? Re.parts[0] : (Xe = Be(Ne, Xe, He), Re.parts[Xe]);
          }
        }
        function Be(Re, Ne, xe) {
          var ke = xe[Ne], Le = ke.startTime + ke.duration;
          return Math.abs(Re - ke.startTime) <= Math.abs(Re - Le) ? Ne : Ne + 1;
        }
        function Ve(Re, Ne, xe) {
          return Ne.startTime !== void 0 && Ne.duration !== void 0 && Math.abs(Re - (Ne.startTime + Ne.duration)) < xe;
        }
        function Ue(Re) {
          var Ne, xe, ke = 24, Le = Re.totalDuration / ((xe = (Ne = Re.entries) === null || Ne === void 0 ? void 0 : Ne.length) !== null && xe !== void 0 ? xe : 1);
          return Math.ceil(ke / Le);
        }
        ne.SegmentListMPDHandler = Se;
      }, 67883: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var _e = function(le, se) {
            return _e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(oe, ue) {
              oe.__proto__ = ue;
            } || function(oe, ue) {
              for (var be in ue)
                Object.prototype.hasOwnProperty.call(ue, be) && (oe[be] = ue[be]);
            }, _e(le, se);
          };
          return function(le, se) {
            if (typeof se != "function" && se !== null)
              throw new TypeError("Class extends value " + String(se) + " is not a constructor or null");
            function oe() {
              this.constructor = le;
            }
            _e(le, se), le.prototype = se === null ? Object.create(se) : (oe.prototype = se.prototype, new oe());
          };
        }();
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.AdaptationSetId = void 0, ne.createAdaptationSetIdFromMimeTypeAndIndex = he;
        var ce = function(_e) {
          function le(se, oe) {
            var ue = _e.call(this, se) || this;
            return ue._adaptationSetId = oe, ue;
          }
          return ae(le, _e), Object.defineProperty(le.prototype, "adaptationSetId", { get: function() {
            return this._adaptationSetId;
          }, enumerable: !1, configurable: !0 }), le.prototype.equals = function(se) {
            return _e.prototype.equals.call(this, se) && this.adaptationSetId === (se == null ? void 0 : se.adaptationSetId);
          }, le.prototype.key = function() {
            return _e.prototype.key.call(this) + "-" + this.adaptationSetId;
          }, le;
        }(ie(96953).PeriodId);
        function he(_e, le, se) {
          return new ce(_e, "".concat(le, "-").concat(se));
        }
        ne.AdaptationSetId = ce;
      }, 68294: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getDrmUsedKeySystem = ne.getDrmKeyIdsWithErrors = ne.getDrmState = void 0;
        var ie = function(he) {
          return he == null ? void 0 : he.drm;
        };
        ne.getDrmState = ie;
        var ae = function(he) {
          var _e, le;
          return (le = (_e = he.drm) === null || _e === void 0 ? void 0 : _e.keyIdsWithErrors) !== null && le !== void 0 ? le : [];
        };
        ne.getDrmKeyIdsWithErrors = ae;
        var ce = function(he) {
          var _e;
          return ((_e = (0, ne.getDrmState)(he)) === null || _e === void 0 ? void 0 : _e.usedKeySystem) || { kind: null, uid: null };
        };
        ne.getDrmUsedKeySystem = ce;
      }, 71827: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.engineBitmovinSourceReducers = void 0;
        var ae = ie(82311), ce = ie(66137), he = ie(28196), _e = ie(58211), le = ie(96280), se = ie(49233), oe = ie(28322), ue = ie(14764);
        ne.engineBitmovinSourceReducers = { manifest: he.ManifestReducer, activeTracks: ae.ActiveTracksReducer, playingTracks: _e.PlayingTracksReducer, encryptionKeys: ce.EncryptionKeyReducer, buffer: se.BufferReducer, renderer: oe.RendererReducer, streamTimeline: ue.StreamTimelineReducer, segmentInfoMap: le.SegmentInfoMapReducer };
      }, 72207: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.Stream = void 0;
        var ae = ie(10981), ce = ie(59305), he = ie(6082), _e = function() {
          function le() {
            var se = this;
            this.resolveDeferredRead = function() {
              se.deferredRead && !se.isEmpty() && (se.deferredRead.resolve({ done: !1, value: se.chunks.shift() }), se.deferredRead = null);
            }, this.state = he.StreamState.Open, this.chunks = [], this.deferredEnded = new ae.Deferred(), this.deferredEnded.promise.catch(function() {
            });
          }
          return le.prototype.add = function(se) {
            this.state === he.StreamState.Open && (this.chunks.push(se), this.resolveDeferredRead());
          }, le.prototype.read = function() {
            if (this.deferredRead)
              return Promise.reject({ name: ce.StreamReadError.ParallelRead });
            if (this.state === he.StreamState.Ended && this.isEmpty())
              return Promise.resolve({ done: !0 });
            if (this.state === he.StreamState.Aborted)
              return Promise.reject({ name: ce.StreamReadError.Aborted, message: this.getError() });
            this.deferredRead = new ae.Deferred();
            var se = this.deferredRead.promise;
            return this.resolveDeferredRead(), se;
          }, le.prototype.end = function() {
            this.state === he.StreamState.Open && (this.state = he.StreamState.Ended, this.deferredRead && this.isEmpty() && (this.deferredRead.resolve({ done: !0 }), this.deferredRead = null), this.deferredEnded.resolve());
          }, le.prototype.abort = function(se) {
            var oe;
            if (this.state === he.StreamState.Open) {
              this.state = he.StreamState.Aborted, this.error = se;
              var ue = { name: he.StreamState.Aborted, message: (oe = this.getError()) !== null && oe !== void 0 ? oe : "" };
              this.deferredRead && (this.deferredRead.reject(ue), this.deferredRead = null), this.deferredEnded.reject(ue);
            }
          }, le.prototype.transform = function(se, oe, ue) {
            var be = this, ve = new le(), me = function() {
              be.read().then(function(pe) {
                var fe = pe.done, ge = pe.value;
                if (fe)
                  oe && oe(), ve.end();
                else {
                  var ye = ge != null && se(ge);
                  ye && ve.add(ye), me();
                }
              }).catch(function(pe) {
                ue ? ve.abort(ue(pe)) : ve.abort(pe);
              });
            };
            return me(), ve;
          }, le.prototype.isEmpty = function() {
            return this.chunks.length === 0;
          }, le.prototype.getError = function() {
            return this.error || null;
          }, le;
        }();
        ne.Stream = _e;
      }, 72477: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.UrlInitSegmentProvider = void 0;
        var ae = ie(76650), ce = ie(8272), he = ie(41661), _e = ie(46678), le = function() {
          function se(oe, ue) {
            this.currentlyLoading = {}, this.context = oe, this.loaderPool = new _e.SegmentLoaderPool(oe, { mimeType: ue, shouldDownloadBeCancelledCallback: function() {
              return !1;
            } }), this.cache = new he.SegmentCache(1 / 0);
          }
          return se.prototype.getSegment = function(oe) {
            var ue = this, be = this.cache.get(oe);
            return (be ? Promise.resolve(be) : this.loadSegment(oe)).then(function(ve) {
              return be || ue.cacheSegment(ve), ve;
            });
          }, se.prototype.isLoading = function() {
            return this.loaderPool.isLoading();
          }, se.prototype.loadSegment = function(oe) {
            var ue = this;
            if (this.loaderPool.isFreeLoaderAvailable() || this.loaderPool.addLoaders(1), this.currentlyLoading[oe.url] != null)
              return this.currentlyLoading[oe.url];
            this.context.logger.debug("Loading init segment", oe.url);
            var be = this.loaderPool.load(oe).then(function(ve) {
              return ve.read();
            }).then(function(ve) {
              if (!ve.value)
                throw new Error("SegmentStream error ".concat(oe.url));
              return ve.value;
            }).finally(function() {
              delete ue.currentlyLoading[oe.url];
            });
            return this.currentlyLoading[oe.url] = be, be;
          }, se.prototype.cacheSegment = function(oe) {
            this.cache.add(oe), this.context.store.dispatch((0, ae.addMetricsValue)(oe.getMimeType(), ce.MetricType.CachedInitSegments, { internalRepId: oe.getSegmentInfo().internalRepresentationId }));
          }, se.prototype.getCachedSegment = function(oe) {
            return this.cache.get(oe);
          }, se.prototype.removeCachedSegments = function(oe) {
            this.cache.remove(oe);
          }, se.prototype.dispose = function() {
            this.cache.clear(), this.loaderPool.dispose();
          }, se;
        }();
        ne.UrlInitSegmentProvider = le;
      }, 72788: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.periodSwitchStarted = ne.periodSwitchFinished = ne.setPlayingPeriodId = void 0;
        var ae = ie(15231), ce = ie(98086), he = function(se) {
          return (0, ae.createAction)(ce.PlayingTracksActionKey.SetPlayingPeriodId, se);
        };
        ne.setPlayingPeriodId = he;
        var _e = function(se) {
          return (0, ae.createAction)(ce.PlayingTracksActionKey.FinishedPeriodSwitch, se);
        };
        ne.periodSwitchFinished = _e;
        var le = function(se) {
          return (0, ae.createAction)(ce.PlayingTracksActionKey.StartedPeriodSwitch, se);
        };
        ne.periodSwitchStarted = le;
      }, 73022: function(ee, ne) {
        function ie(ae, ce) {
          return !(!ae || !ce) && ae === ce;
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.areBufferBlocksEqual = ie;
      }, 73543: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ContainerFormat = void 0, function(ae) {
          ae.MP4 = "mp4", ae.TS = "ts", ae.WEBM = "webm";
        }(ie || (ne.ContainerFormat = ie = {}));
      }, 73553: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentInfoError = void 0, function(ae) {
          ae.END_OF_STREAM_REACHED = "END_OF_STREAM_REACHED", ae.PERIOD_COMPLETE = "PERIOD_COMPLETE", ae.SEGMENT_EXCEEDING_PERIOD_DURATION = "SEGMENT_EXCEEDING_PERIOD_DURATION";
        }(ie || (ne.SegmentInfoError = ie = {}));
      }, 73731: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ActiveTracksActionType = void 0, function(ae) {
          ae.SetSelectedRepresentationId = "@instance/sources/@source/activetracks/setselectedrepresentationid", ae.SetMediaType = "@instance/sources/@source/activetracks/setmediatype", ae.SetContainerFormat = "@instance/sources/@source/activetracks/setcontainerformat", ae.RemoveActiveTrack = "@instance/sources/@source/activetracks/remove", ae.ClearActiveTracks = "@instance/sources/@source/activetracks/clear";
        }(ie || (ne.ActiveTracksActionType = ie = {}));
      }, 74830: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.initializeHlsSegmentStartTimes = he;
        var ae = ie(18665), ce = ie(67550);
        function he(_e, le, se) {
          var oe = le.sourceContext.sourceIdentifier, ue = le.serviceManager.get(ae.ServiceName.ManifestService, oe);
          if (ue && !ue.getAllAdaptationSets().some(function(ve) {
            return ve.Representation.some(function(me) {
              var pe, fe;
              return ((fe = (pe = me.SegmentList) === null || pe === void 0 ? void 0 : pe[0].SegmentURL[0]) === null || fe === void 0 ? void 0 : fe._playbackTime) !== void 0;
            });
          })) {
            var be = _e.getRepresentationId();
            ue.initializeSegmentStartTimesFromStart(be), (0, ce.assignSegmentStartTimesFromHlsRepresentation)(se.getSegmentListEntries(_e.getRepresentationId()), be, ue);
          }
        }
      }, 75498: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.areAudioMimeCodecsCompatible = ce, ne.hasContentProtection = he;
        var ae = ie(42283);
        function ce(_e, le) {
          return _e.mimeType === le.mimeType && ae.CodecStringHelper.canSwitchBetweenAudioCodecs(_e.codec, le.codec);
        }
        function he(_e, le) {
          return _e === void 0 && (_e = []), le === void 0 && (le = []), _e.length === 0 && le.length === 0 || _e.length > 0 && le.length > 0;
        }
      }, 77118: function(ee, ne, ie) {
        var ae = this && this.__spreadArray || function(se, oe, ue) {
          if (ue || arguments.length === 2)
            for (var be, ve = 0, me = oe.length; ve < me; ve++)
              !be && ve in oe || (be || (be = Array.prototype.slice.call(oe, 0, ve)), be[ve] = oe[ve]);
          return se.concat(be || Array.prototype.slice.call(oe));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getUtcTimingSources = he;
        var ce = ie(25226);
        function he(se, oe) {
          var ue = [];
          return le(se, oe).forEach(function(be) {
            var ve = _e(be.method);
            ve && ue.push({ schemeIdUri: ve, value: be.serverUrl });
          }), ue;
        }
        function _e(se) {
          switch (se) {
            case ce.LiveSynchronizationMethod.HttpHead:
              return "urn:mpeg:dash:utc:http-head:2014";
            case ce.LiveSynchronizationMethod.HttpXsDate:
              return "urn:mpeg:dash:utc:http-xsdate:2014";
            case ce.LiveSynchronizationMethod.HttpIso:
              return "urn:mpeg:dash:utc:http-iso:2014";
            default:
              return;
          }
        }
        function le(se, oe) {
          var ue, be, ve = ((ue = se.live) === null || ue === void 0 ? void 0 : ue.synchronization) || [], me = ((be = oe.live) === null || be === void 0 ? void 0 : be.synchronization) || [];
          return ae(ae([], ve, !0), me.filter(function(pe) {
            return !ve.some(function(fe) {
              return fe.method === pe.method;
            });
          }), !0);
        }
      }, 77329: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ManifestActionType = void 0, function(ae) {
          ae.SetManifest = "@instance/manifest/setmanifest", ae.SetManifestInitialized = "@instance/manifest/setmanifestinitialized", ae.RemoveRepresentations = "@instance/manifest/removerepresentations", ae.UpdateManifest = "@instance/manifest/updatemanifest", ae.UpdateAdaptationSet = "@instance/manifest/updateadaptationset", ae.UpdateRepresentation = "@instance/manifest/updaterepresentation", ae.UpdatePeriodTiming = "@instance/manifest/updateperiodtiming", ae.AdjustPeriodStartTimes = "@instance/manifest/adjustperiodstarttimes", ae.SetRepresentationDrmKid = "@instance/manifest/setrepresentationdrmkid", ae.UpdateRepresentationFailedDownload = "@instance/manifest/setrepresentationfaileddownload", ae.SetRepresentationSegmentIndex = "@instance/manifest/setrepresentationsegmentindex", ae.SetRepresentationIsLoading = "@instance/manifest/setrepresentationisloading", ae.SetRepresentationSegmentIndexParsingError = "@instance/manifest/setrepresentationsegmentindexparsingerror", ae.SetRepresentationAnchorPoint = "@instance/manifest/setrepresentationacnhorpoint", ae.InitPlaybackTimesFromIndex = "@instance/manifest/initplaybacktimesfromindex", ae.InitPlaybackTimesFromReferenceSegment = "@instance/manifest/initplaybacktimesfromreferencesegment", ae.ResetSegmentPlaybackTimes = "@instance/manifest/resetsegmentplaybacktimes";
        }(ie || (ne.ManifestActionType = ie = {}));
      }, 77874: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getManifest = void 0;
        var ie = function(ae) {
          return ae == null ? void 0 : ae.manifest;
        };
        ne.getManifest = ie;
      }, 80858: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(ut) {
            for (var Ke, je = 1, De = arguments.length; je < De; je++)
              for (var at in Ke = arguments[je])
                Object.prototype.hasOwnProperty.call(Ke, at) && (ut[at] = Ke[at]);
            return ut;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.BufferController = void 0;
        var ce = ie(92712), he = ie(52442), _e = ie(25550), le = ie(28764), se = ie(63546), oe = ie(35148), ue = ie(18665), be = ie(60997), ve = ie(62510), me = ie(33696), pe = ie(94304), fe = ie(76650), ge = ie(28819), ye = ie(8272), $e = ie(58975), Se = ie(76420), Ce = ie(96873), Ie = ie(33669), Te = ie(3464), Ee = ie(10981), we = ie(53968), Pe = ie(79814), Me = ie(56435), Ae = ie(331), Oe = ie(70016), Be = ie(54838), Ve = ie(46462), Ue = ie(91520), Re = ie(16368), Ne = ie(41108), xe = ie(77874), ke = ie(72788), Le = ie(58211), He = ie(16280), We = ie(68294), Xe = ie(59839), Qe = ie(14764), tt = ie(22645), Je = ie(55937), Ge = ie(16492), Ye = ie(15109), ze = ie(27076), Fe = ie(42346), ot = ie(19724), vt = "The targeted buffer BufferBlock is no longer available", gt = function() {
          function ut(Ke, je, De, at) {
            var dt = this;
            this.currentRendererMediaTypes = [], this.startupPlaybackTime = null, this.isAlreadyStarted = !1, this.isStartup = !0, this.finishPlayback = !1, this.hasStreamEndedInternal = !1, this.activeInitSegments = {}, this.bufferMaxSizeChangedSubscriptionMap = {}, this.isTimeshiftCancelled = !1, this.updateTotalDuration = function() {
              dt.totalDuration = dt.manifestService.getTotalDuration(), dt.totalDuration > (dt.renderer.getDuration() || 0) && dt.setDurationOnRenderer();
            }, this.setDurationOnRenderer = function() {
              dt.finishPlayback || dt.renderer.setDuration(dt.totalDuration);
            }, this.onRendererSetupFailed = function(ft) {
              dt.context.logger.debug("Renderer setup failed with", ft);
            }, this.onVideoElementTimeUpdate = function() {
              Date.now() - dt.lastBackwardBufferClearingTimestamp > dt.minimalBackwardBufferClearingInterval && dt.canClearBackwardBuffer() && dt.maintainBackwardBufferLevel(), dt.checkIfEndOfBufferReached(dt.settings.END_OF_BUFFER_TOLERANCE);
            }, this.onTimeNotAdvancing = function() {
              var ft, lt = dt.settings.END_OF_BUFFER_RECOVERY_TOLERANCE, nt = (ft = dt.segmentStore) === null || ft === void 0 ? void 0 : ft.getBufferBlock(dt.currentPlayingBufferBlockId);
              nt && dt.isAtEndOfBufferBlock() && (lt = dt.segmentStore.getSmallestMaxSegmentDuration(nt)), dt.checkIfEndOfBufferReached(lt);
            }, this.onVideoElementEnded = function() {
              var ft;
              if (!(0, we.isSwitchingBufferBlocks)(dt.getSourceStore())) {
                var lt = (ft = dt.segmentStore) === null || ft === void 0 ? void 0 : ft.getNextBufferBlock(dt.currentPlayingBufferBlockId);
                if (lt) {
                  var nt = dt.renderer.getCurrentTime(!0);
                  dt.tryToSwitchBufferBlock(nt, lt);
                }
              }
            }, this.onVideoElementStalled = function() {
              dt.checkIfEndOfBufferReached(dt.settings.END_OF_BUFFER_RECOVERY_TOLERANCE);
            }, this.context = Ke, this.logger = Ke.logger, this.settings = Ke.settings, this.bufferSettings = Ke.bufferSettings, this.eventHandler = Ke.eventHandler, this.renderer = Ke.renderer, this.manifestService = Ke.serviceManager.get(ue.ServiceName.ManifestService, Ke.sourceContext.sourceIdentifier), this.segmentStore = new Fe.SegmentStore(this.context, this.settings), this.endStallAtGapCallback = je, this.bufferStallingService = new Ye.BufferStallingService(this.getPlayerStateService(), this.logger, this.context.renderer), this.currentPlayingPeriodId = at, this.lastPlayingPeriodId = null, this.totalDuration = De, this.currentPlayingBufferBlockId = Fe.INITIAL_BUFFER_BLOCK_ID, this.dataSegmentsPushedMap = /* @__PURE__ */ new Map(), this.isEndOfStreamReached = !1, this.lastBackwardBufferClearingTimestamp = 0, this.minimalBackwardBufferClearingInterval = (0, Ae.toMilliSeconds)(this.context.settings.MINIMAL_BACKWARD_BUFFER_CLEARING_INTERVAL), this.discontinuitySequenceNumbers = /* @__PURE__ */ new Map(), this.currentPeriodForMediaTypes = /* @__PURE__ */ new Map(), this.currentBufferBlockDeferredReject = new ze.DeferredReject(), this.drmConfigValidPromise = Promise.resolve(null), this.bufferRangesCache = new Ge.BufferRangesCache(this.context, this.segmentStore), this.subscribeToPlaybackStoppedStateChange(), this.renderer.ready().then(function() {
              dt.setDurationOnRenderer(), dt.shouldSendLicenseRequestsImmediately() && dt.setupDRM();
            }).catch(this.onRendererSetupFailed), this.unsubscribeFromStoreSeekedListener = (0, Te.subscribe)(this.context.store)(function(ft) {
              return ft && (0, $e.getPlayerState)(ft).seekState;
            }, function() {
              dt.canClearBackwardBuffer() && dt.maintainBackwardBufferLevel();
            }, function(ft, lt) {
              return ft === Se.SeekState.Seeked && lt !== Se.SeekState.Seeked;
            });
          }
          return ut.prototype.subscribeToPlaybackStoppedStateChange = function() {
            var Ke = this, je = this.context.store;
            je !== void 0 && (this.unsubscribeFromStoreStoppedListener = (0, Te.subscribe)(je)(function(De) {
              return De && (0, $e.getIsStopped)((0, $e.getPlayerState)(De));
            }, function() {
              return Ke.hasStreamEndedInternal = !0;
            }, function(De) {
              return De === !0;
            }));
          }, Object.defineProperty(ut.prototype, "isCurrentlyStalled", { get: function() {
            return this.bufferStallingService.isRendererStalling();
          }, enumerable: !1, configurable: !0 }), ut.prototype.shouldSendLicenseRequestsImmediately = function() {
            var Ke, je;
            return !!(!((je = (0, We.getDrmState)((Ke = this.getSourceStore()) === null || Ke === void 0 ? void 0 : Ke.getState())) === null || je === void 0) && je.immediateLicenseRequest);
          }, ut.prototype.createSourceBuffers = function(Ke) {
            var je = this, De = Promise.resolve();
            return this.bufferCreationDeferred = new Ee.Deferred(), this.isStartup || (De = this.renderer.shutdown(!0)), this.activeInitSegments = {}, this.bufferCreationDeferred.resolve(De.then(function() {
              return je.renderer.ready();
            }).then(function() {
              return je.setDurationOnRenderer(), je.clearBufferMaxSizeChangedSubscription(), Ke.forEach(function(at) {
                var dt = at.mimeType;
                je.addMimeTypeAndCodec(dt, at.codec) || (je.logger.debug("Could not create source buffer for ".concat(dt)), je.context.store.dispatch((0, fe.removeMetricsForMimeType)(dt))), je.subscribeToBufferMaxSizeChanged(dt);
              }), je.currentRendererMediaTypes = Ke.filter(function(at) {
                return Pe.MimeTypeHelper.isAV(at.mimeType);
              }), je.setupDRM(), Promise.resolve(je.currentRendererMediaTypes.length);
            })), this.bufferCreationDeferred.promise.catch(function(at) {
              return je.logger.warn(at);
            }).then(function() {
              je.bufferCreationDeferred = null;
            }), this.bufferCreationDeferred.promise;
          }, ut.prototype.subscribeToBufferMaxSizeChanged = function(Ke) {
            var je = this, De = this.getSourceStore();
            De && (this.bufferMaxSizeChangedSubscriptionMap[Ke] = De.subscribe(function() {
              return je.adjustMaxBufferLevels(Ke);
            }, (0, Ie.hasBufferMaxSizeChanged)(Ke)));
          }, ut.prototype.unsubscribeFromBufferMaxSizeChanged = function(Ke) {
            var je = this.bufferMaxSizeChangedSubscriptionMap[Ke];
            je && (je(), delete this.bufferMaxSizeChangedSubscriptionMap[Ke]);
          }, ut.prototype.setupDRM = function() {
            var Ke, je = this, De = (0, We.getDrmState)((Ke = this.getSourceStore()) === null || Ke === void 0 ? void 0 : Ke.getState());
            if (De !== void 0 && Object.keys(De).length > 0) {
              var at = ae(ae({}, this.context.sourceContext.source), { drm: De }), dt = this.manifestService.getDRMCapabilitiesForPeriod(this.currentPlayingPeriodId);
              Object.keys(pe.KeySystemMap).some(function(ft) {
                return at.drm.hasOwnProperty(ft);
              }) && (this.drmConfigValidPromise = this.renderer.setDrmConfig(De, dt), this.drmConfigValidPromise.catch(function(ft) {
                (ft == null ? void 0 : ft.message) !== he.DrmSetupError.CANCELLED && je.logger.debug("Could not initialize renderer with given DRM config: ".concat(ft == null ? void 0 : ft.message), ft);
              }));
            }
          }, ut.prototype.getSourceStore = function() {
            var Ke;
            return (Ke = this.context.serviceManager) === null || Ke === void 0 ? void 0 : Ke.get(ue.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, ut.prototype.maybeWaitForBufferClearingPromise = function() {
            var Ke = this;
            return this.bufferClearingPromise ? this.bufferClearingPromise.catch(function() {
              return Ke.isTimeshiftCancelled = !0, Promise.reject("Failed to clear buffer on timeshift, stopping segment cache processing");
            }).then(function() {
              return Ke.isTimeshiftCancelled ? (Ke.isTimeshiftCancelled = !1, Promise.reject("Timeshift cancelled, stopping segment cache processing")) : Promise.resolve();
            }) : Promise.resolve();
          }, ut.prototype.addSegment = function(Ke) {
            var je = this;
            if (!this.segmentStore)
              return Promise.reject("Skipping segment processing, segment store is already disposed");
            if (this.logger.insane("adding segment to cache for period ".concat(Ke.getPeriodId(), " with playback time ").concat(Ke.getPlaybackTime(), " and mime type ").concat(Ke.getMimeType())), this.segmentStore.addSegment(Ke), this.subscribeToManifestChange(), bt(Ke, this.getSourceStore()), !this.areBufferBlockMediaTypesFinalForPeriod(Ke.getPeriodId()))
              return Promise.resolve();
            var De = Promise.resolve();
            if (this.delayedBufferBlockSwitchContext) {
              var at = this.delayedBufferBlockSwitchContext.time, dt = this.findBufferBlockForTime(at);
              if (!this.segmentStore.canSwitchToBufferBlock(dt))
                return Promise.resolve();
              De = this.maybeWaitForBufferClearingPromise().then(function() {
                return je.tryToSwitchBufferBlock(at, dt);
              });
            } else if ((0, we.isSwitchingBufferBlocks)(this.getSourceStore()) || this.isBufferAvailable() || this.bufferCreationDeferred)
              this.bufferCreationDeferred && (De = this.bufferCreationDeferred.promise);
            else {
              var ft = this.segmentStore.getBufferBlockForSegment(Ke), lt = ft == null ? void 0 : ft.getMediaTypes();
              if (!lt)
                return this.logger.debug("Chosen buffer block for segment unexpectedly had no mediaTypes"), Promise.resolve();
              De = this.createSourceBuffers(lt);
            }
            return De.then(function() {
              return je.renderer ? je.renderer.ready() : Promise.reject("Stopping queue processing, renderer is not available");
            }).then(function() {
              return je.processSegmentCache();
            });
          }, ut.prototype.removePrecedingSegmentsFromStore = function(Ke, je) {
            var De = this;
            this.segmentStore && this.segmentStore.getPrecedingSegments(Ke, je).forEach(function(at) {
              var dt;
              De.segmentStore.removeSegment(at), (dt = De.getSourceStore()) === null || dt === void 0 || dt.dispatch((0, Ce.removeLoadedRange)(at.getMimeType(), (0, He.segmentToBufferBlockTimeRange)(at)));
            });
          }, ut.prototype.clearBackwardBuffer = function(Ke, je) {
            var De = this;
            return this.removePrecedingSegmentsFromStore(Ke, je), this.lastBackwardBufferClearingTimestamp = Date.now(), this.renderer.removeData(Ke, 0, je).catch(function(at) {
              return De.logger.debug("Error clearing ".concat(Ke, " backward buffer:"), at);
            });
          }, ut.prototype.updateBackwardBufferClearingInterval = function() {
            if (this.segmentStore) {
              var Ke = this.segmentStore.getBufferBlock(this.currentPlayingBufferBlockId), je = Ke ? this.segmentStore.getSmallestMaxSegmentDuration(Ke) : -1;
              this.minimalBackwardBufferClearingInterval = (0, Ae.toMilliSeconds)(Math.max(je / 2, this.context.settings.MINIMAL_BACKWARD_BUFFER_CLEARING_INTERVAL));
            }
          }, ut.prototype.maintainBackwardBufferLevel = function() {
            var Ke, je, De = this;
            this.updateBackwardBufferClearingInterval();
            var at = (Ke = this.segmentStore) === null || Ke === void 0 ? void 0 : Ke.getBufferBlock(this.currentPlayingBufferBlockId), dt = this.renderer.getCurrentTime(), ft = (0, Ie.getBufferStateMap)((je = this.getSourceStore()) === null || je === void 0 ? void 0 : je.getState());
            ft && Object.keys(ft).forEach(function(lt) {
              var nt, ct = (nt = (0, Ie.getRendererBufferedRanges)(ft, lt)[0]) === null || nt === void 0 ? void 0 : nt.start, it = Pe.MimeTypeHelper.getMediaType(lt);
              if (ct !== void 0 && (at != null && at.hasMaxSegmentDuration(lt))) {
                var et = at.getMaxSegmentDuration(lt) + 1, st = De.bufferSettings.getBackwardTargetLevel(it), mt = Math.max(et, st), St = dt - mt;
                ct < St && De.clearBackwardBuffer(lt, St).catch(function($t) {
                  De.context.logger.debug("Could not clear backward buffer", $t);
                });
              }
            });
          }, ut.prototype.setEndOfStream = function(Ke) {
            var je;
            return Ke && this.suspendEosSignalling || !this.renderer ? (this.logger.debug("Skipping setting EOS"), Promise.resolve()) : (Ke && ((je = this.getSourceStore()) === null || je === void 0 || je.dispatch((0, Ce.setLoadingRangeFinished)(!0))), this.isEndOfStreamReached = Ke, this.renderer.setEndOfStream(Ke));
          }, ut.prototype.adjustMaxBufferLevels = function(Ke) {
            var je, De = (0, Ie.getBufferState)((je = this.getSourceStore()) === null || je === void 0 ? void 0 : je.getState()), at = De !== void 0 ? (0, Ie.getBufferMaxSize)(De, Ke) : Ie.DefaultBufferMaxSize;
            if (this.logger.debug("Exceeded quota for ".concat(Ke, " with ").concat(at, " seconds of data in the buffers")), !this.context.settings.NO_QUOTA_EXCEEDED_ADJUSTMENT) {
              var dt = this.renderer.getCurrentTime(), ft = this.segmentStore.getSmallestSafeBufferSize(dt, Ke);
              this.bufferSettings.adjustMaxBufferLevels(ft, Ke, at);
            }
          }, ut.prototype.getLowestPlaybackTimeForAllSegments = function(Ke) {
            return Ke.filter(function(je) {
              return !je.isInit();
            }).map(function(je) {
              return je.getPlaybackTime();
            }).reduce(function(je, De) {
              return Math.min(De, je);
            }, 0);
          }, ut.prototype.updateTimestampOffsetForNegativePlaybackTime = function() {
            var Ke = this.segmentStore.getBufferBlock(this.currentPlayingBufferBlockId), je = this.segmentStore.getAllSegmentsFromBufferBlock(Ke).toArray(), De = this.getLowestPlaybackTimeForAllSegments(je);
            De < 0 && (this.eventHandler.dispatchEvent(ve.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.PLAYBACK_NEGATIVE_DECODING_TIMESTAMP_ENCOUNTERED)), this.logger.debug("Encountered negative DTS ".concat(De, ", attempting to correct PTO...")), this.currentRendererMediaTypes.forEach(function(at) {
              at.timestampOffset != null && (at.timestampOffset += De, je.filter(function(dt) {
                return dt.getMimeType() === at.mimeType;
              }).forEach(function(dt) {
                return dt.setPresentationTimeOffset(at.timestampOffset);
              }));
            }));
          }, ut.prototype.processSegmentCache = function() {
            var Ke = this;
            return this.isStartup ? this.isStartupThresholdReached() ? (this.updateTimestampOffsetForNegativePlaybackTime(), this.pushSegmentsToRenderer(1 / 0).then(function() {
              return Ke.endStartupPhase();
            })) : Promise.resolve() : this.pushSegmentsToRenderer(1 / 0);
          }, ut.prototype.getBufferedRangesMap = function(Ke, je) {
            var De;
            Ke === void 0 && (Ke = this.currentPlayingPeriodId), je === void 0 && (je = !0);
            var at = (0, Ie.getBufferState)((De = this.getSourceStore()) === null || De === void 0 ? void 0 : De.getState());
            return Ke && at !== void 0 ? je ? this.bufferRangesCache.getRanges(at) : (0, Ie.getRendererBufferRangesMap)(this.segmentStore, at)(Ke, this.currentPlayingBufferBlockId) : {};
          }, ut.prototype.addSegmentsFromCacheToRenderer = function(Ke, je) {
            var De = this;
            if (!this.segmentStore)
              return Promise.resolve();
            var at = this.segmentStore.getAllSegmentsFromBufferBlock(Ke), dt = at.hasNext() && at.next();
            return dt ? (this.segmentStore.removeSegment(dt), dt.getPeriodId() !== this.currentPlayingPeriodId && (this.context.store.dispatch((0, ke.periodSwitchStarted)(dt.getPeriodId())), this.eventHandler.dispatchEvent(ve.PlayerEvent.PeriodSwitch, { sourcePeriod: { periodId: this.currentPlayingPeriodId }, targetPeriod: { periodId: dt.getPeriodId() } })), this.addDataSegmentToRenderer(dt).catch(function(ft) {
              De.logger.warn("Could not add segment to renderer (mimeType: ".concat(dt.getMimeType(), ", playbackTime: ").concat(dt.getPlaybackTime(), ")"), ft);
            }).then(function() {
              var ft;
              dt.isInit() || (ft = De.getSourceStore()) === null || ft === void 0 || ft.dispatch((0, Ce.removeLoadedRange)(dt.getMimeType(), (0, He.segmentToBufferBlockTimeRange)(dt))), De.dataSegmentsPushedMap.set(dt.getMimeType(), !dt.isInit());
              var lt = ce.BufferRangeHelper.getTotalCommonBufferLength(De.getBufferedRangesMap(De.currentPlayingPeriodId));
              return De.currentPlayingPeriodId = dt.getPeriodId(), !(0, we.isSwitchingBufferBlocks)(De.getSourceStore()) || lt < je ? De.addSegmentsFromCacheToRenderer(Ke, je) : Promise.resolve();
            })) : Promise.resolve();
          }, ut.prototype.dispatchFinishPeriodSwitch = function() {
            var Ke;
            this.currentPlayingPeriodId !== this.lastPlayingPeriodId && (this.lastPlayingPeriodId && ((Ke = this.context.store) === null || Ke === void 0 || Ke.dispatch((0, ke.periodSwitchFinished)(this.currentPlayingPeriodId))), this.lastPlayingPeriodId = this.currentPlayingPeriodId);
          }, ut.prototype.hasFinishedLoadingBufferBlock = function(Ke) {
            var je, De, at = this;
            if (!Ke)
              return !1;
            var dt = this.hasStopped(), ft = (je = this.segmentStore) === null || je === void 0 ? void 0 : je.isLoadingNextBufferBlock(this.currentPlayingBufferBlockId), lt = (De = this.segmentStore) === null || De === void 0 ? void 0 : De.hasSegmentsForBufferBlock(Ke);
            return !this.currentRendererMediaTypes.some(function(nt) {
              return at.renderer.isDataBeingAppended(nt.mimeType);
            }) && (ft || dt) && !lt;
          }, ut.prototype.pushSegmentsToRenderer = function(Ke) {
            var je = this, De = this.segmentStore.getBufferBlock(this.currentPlayingBufferBlockId);
            return this.suspendEosSignalling = !0, this.addSegmentsFromCacheToRenderer(De, Ke).then(function() {
              var at, dt;
              je.suspendEosSignalling = !1, je.isRestartThresholdReached() && !je.isBufferClearingOngoing() && je.maybeEndStalling(), je.hasFinishedLoadingBufferBlock(De) ? (je.logger.debug("Finished loading BB ".concat(je.currentPlayingBufferBlockId, ": signaling EOS")), (at = je.getSourceStore()) === null || at === void 0 || at.dispatch((0, Ce.setLoadingRangeFinished)(!0)), je.hasTemporarilyReopenedMsePriorToBufferBlockSwitch ? je.logger.debug("Skipped EOS signaling as a BufferBlock switch is just being executed") : je.currentBufferBlockSwitchPromise && (0, we.isSwitchingBufferBlocks)(je.getSourceStore()) ? (je.logger.debug("delaying EOS signal until ongoing period switch is completed"), je.currentBufferBlockSwitchPromise.then(function() {
                je.setEndOfStream(!0).then(function() {
                  return je.dispatchFinishPeriodSwitch();
                });
              })) : je.setEndOfStream(!0).then(function() {
                return je.dispatchFinishPeriodSwitch();
              })) : ((dt = je.getSourceStore()) === null || dt === void 0 || dt.dispatch((0, Ce.setLoadingRangeFinished)(!1)), je.dispatchFinishPeriodSwitch());
            });
          }, ut.prototype.updateTimestampOffsets = function() {
            var Ke = this;
            this.currentRendererMediaTypes.forEach(function(je) {
              Ke.renderer.setTimestampOffset(je.mimeType, -je.timestampOffset);
            });
          }, ut.prototype.canClearBackwardBuffer = function() {
            var Ke, je, De = this.context.serviceManager.get(ue.ServiceName.PlayerStateService);
            if (!De)
              return !1;
            var at = (Ke = De.seekingOrTimeshifting) !== null && Ke !== void 0 && Ke, dt = (je = this.getSourceStore()) === null || je === void 0 ? void 0 : je.getState(), ft = dt && (0, Ie.getIsTimestampRollingOver)(dt);
            return !(this.isEndOfStreamReached || (0, we.isSwitchingBufferBlocks)(this.getSourceStore()) || at || ft);
          }, ut.prototype.checkIfEndOfBufferReached = function(Ke) {
            var je = this.renderer.getEndOfBufferTime();
            if (je === void 0)
              this.renderer.isPaused() || this.startStalling();
            else {
              var De = je - Ke, at = this.renderer.getCurrentTime(!0);
              this.shouldHandleEndOfBuffer(at, De) && this.handleEndOfBuffer(at);
            }
          }, ut.prototype.shouldHandleEndOfBuffer = function(Ke, je) {
            return !(0, we.isSwitchingBufferBlocks)(this.getSourceStore()) && (je <= Ke || this.manifestService.isLive() && Ke === 0);
          }, ut.prototype.resetCurrentTimeOnSegment = function() {
            var Ke, je = !0;
            this.dataSegmentsPushedMap.forEach(function(De, at) {
              Pe.MimeTypeHelper.isVideo(at) && (je = De, Ke = at);
            }), je || (this.context.videoElement.currentTime = this.context.videoElement.currentTime, this.dataSegmentsPushedMap.set(Ke, !0));
          }, ut.prototype.handleEndOfBuffer = function(Ke) {
            var je, De, at = this.isAtEndOfBufferBlock(), dt = (je = this.segmentStore) === null || je === void 0 ? void 0 : je.getNextBufferBlock(this.currentPlayingBufferBlockId), ft = !!dt;
            if (at && ft && (!((De = this.segmentStore) === null || De === void 0) && De.areBufferBlockMediaTypesFinal(dt))) {
              var lt = dt.getMinCommonStartTime(), nt = isFinite(lt) && lt >= Ke ? lt : Ke;
              this.tryToSwitchBufferBlock(nt, dt);
            } else
              this.getRemainingTime() > 0 && !this.finishPlayback && (this.startStalling(), this.resetCurrentTimeOnSegment());
          }, ut.prototype.isAtEndOfBufferBlock = function() {
            var Ke, je = (Ke = this.segmentStore) === null || Ke === void 0 ? void 0 : Ke.getBufferBlock(this.currentPlayingBufferBlockId);
            return !!je && (!je.getNextSegment() || !!this.segmentStore && this.segmentStore.isLoadingNextBufferBlock(je.getId()));
          }, ut.prototype.readyToSeek = function() {
            return this.currentBufferBlockSwitchPromise ? (this.logger.debug("Awaiting ongoing buffer block switch before seek"), this.currentBufferBlockSwitchPromise.then(function() {
            }).catch(function() {
            })) : Promise.resolve();
          }, ut.prototype.shouldBuffersBeClearedOnTimeshift = function(Ke) {
            var je = this.renderer.getCurrentTime();
            return !this.isTimeInBufferedRange(Ke) || Ke < je;
          }, ut.prototype.isTimeInBufferedRange = function(Ke) {
            var je, De = (je = this.getSourceStore()) === null || je === void 0 ? void 0 : je.getState();
            if (!De)
              return !1;
            var at = this.getBufferedRangesMap((0, Le.getPlayingPeriodId)(De), !0);
            return ce.BufferRangeHelper.isInBufferedRange(at, Ke);
          }, ut.prototype.maybeClearBuffers = function(Ke, je) {
            return je === void 0 && (je = !1), je || this.shouldBuffersBeClearedOnTimeshift(Ke) ? this.clearBuffersOnTimeshift() : Promise.resolve();
          }, ut.prototype.setTimeshiftCancelState = function(Ke) {
            this.isTimeshiftCancelled = Ke;
          }, ut.prototype.clearBuffersOnTimeshift = function() {
            var Ke = this;
            return this.context.logger.debug("Clearing buffer on timeshift"), this.clearBuffers().then(function() {
              return Ke.isTimeshiftCancelled ? (Ke.isTimeshiftCancelled = !1, Promise.reject("cancelled timeshift")) : Promise.resolve();
            });
          }, ut.prototype.setCurrentTime = function(Ke, je, De, at) {
            var dt = this;
            De === void 0 && (De = !1), at === void 0 && (at = !1);
            var ft = je || this.manifestService.getPeriodIdForTime(Ke), lt = this.segmentStore.getBufferBlockForPlaybackTime(Ke), nt = this.segmentStore.getBufferBlock(this.currentPlayingBufferBlockId), ct = !lt || lt.getId() !== nt.getId();
            return this.isStartup && (this.currentPlayingPeriodId = ft), this.seekTarget = Ke, this.isStartup || this.isInBufferedRange(Ke, ft) || this.startStalling(), De && this.isBufferAvailable() && !this.isBufferClearingOngoing() && this.maybeClearBuffers(Ke, at).catch(function(it) {
              return dt.logger.debug("Error clearing buffers:", it);
            }), ct ? lt ? this.tryToSwitchBufferBlock(Ke, lt) : this.delayBufferBlockSwitch(Ke) : (this.delayedBufferBlockSwitchContext = void 0, this.renderer.setCurrentTime(Ke).then(function(it) {
              return dt.endStallingAfterSeek(it);
            }));
          }, ut.prototype.endStallingAfterSeek = function(Ke) {
            return this.seekTarget = void 0, this.isRestartThresholdReached() ? this.isCurrentlyStalled && (this.logger.debug("End stalling after seek to ".concat(Ke)), this.maybeEndStalling()) : this.logger.debug("Delay ending stall as the restart threshold is not yet reached"), Promise.resolve(Ke);
          }, ut.prototype.bufferBlockSwitchErrorHandler = function(Ke, je) {
            var De, at, dt, ft, lt, nt = (at = (De = this.delayedBufferBlockSwitchContext) === null || De === void 0 ? void 0 : De.time) !== null && at !== void 0 ? at : je, ct = (0, Oe.isNumber)((dt = this.delayedBufferBlockSwitchContext) === null || dt === void 0 ? void 0 : dt.time) && ((ft = this.segmentStore) === null || ft === void 0 ? void 0 : ft.canSwitchToBufferBlockForTime(nt));
            if (this.logger.debug("Buffer block switch failed:", Ke), this.currentBufferBlockDeferredReject = new ze.DeferredReject(), ct) {
              this.logger.debug("Trying to continue delayed BufferBlock switch to ".concat(nt, "..."));
              var it = this.findBufferBlockForTime(nt);
              return this.tryToSwitchBufferBlock(nt, it);
            }
            return (lt = this.getSourceStore()) === null || lt === void 0 || lt.dispatch((0, Ce.setBufferBlockSwitchOngoing)(!1)), Promise.resolve(je);
          }, ut.prototype.findBufferBlockForTime = function(Ke) {
            var je, De = this.manifestService.getPeriodIdForTime(Ke);
            return (je = this.segmentStore) === null || je === void 0 ? void 0 : je.getTargetBufferBlock(Ke, De);
          }, ut.prototype.tryToSwitchBufferBlock = function(Ke, je) {
            var De, at, dt = this, ft = function() {
            };
            if (this.currentBufferBlockDeferredReject && this.currentBufferBlockDeferredReject.reject("BufferBlock switch interrupted by newest one"), this.currentBufferBlockDeferredReject = new ze.DeferredReject(), (De = this.getSourceStore()) === null || De === void 0 || De.dispatch((0, Ce.setBufferBlockSwitchOngoing)(!0)), this.delayedBufferBlockSwitchContext && (ft = this.delayedBufferBlockSwitchContext.deferred.resolve), !(!((at = this.segmentStore) === null || at === void 0) && at.canSwitchToBufferBlock(je)))
              return this.delayBufferBlockSwitch(Ke);
            this.hasTemporarilyReopenedMsePriorToBufferBlockSwitch = !0;
            var lt = this.bufferClearingPromise || Promise.resolve();
            return this.currentBufferBlockSwitchPromise = lt.then(function() {
              return dt.setEndOfStream(!1);
            }).then(function() {
              return dt.delayedBufferBlockSwitchContext = void 0;
            }).then(function() {
              return dt.currentBufferBlockDeferredReject.next(function() {
                return dt.clearRendererBuffers();
              });
            }).then(function() {
              return dt.currentBufferBlockDeferredReject.next(function() {
                return dt.switchOrRestoreBufferBlock(je, Ke);
              });
            }).then(function(nt) {
              return dt.hasTemporarilyReopenedMsePriorToBufferBlockSwitch = !1, dt.currentBufferBlockDeferredReject = new ze.DeferredReject(), ft(nt), nt;
            }).catch(function(nt) {
              return dt.bufferBlockSwitchErrorHandler(nt, Ke);
            }).finally(function() {
              dt.currentBufferBlockSwitchPromise = void 0;
            }), this.currentBufferBlockSwitchPromise;
          }, ut.prototype.switchOrRestoreBufferBlock = function(Ke, je) {
            var De, at;
            return this.hasStreamEnded() ? ((De = this.currentBufferBlockDeferredReject) === null || De === void 0 || De.reject("BufferBlock switch interrupted by source unloading"), Promise.reject("Source was unloaded")) : (0, Me.isTizen2017)() || !((at = this.segmentStore) === null || at === void 0) && at.shouldSwitchBufferBlock(Ke, this.currentPlayingBufferBlockId) ? this.switchBufferBlock(je, Ke) : this.restorePlayback(je, Ke);
          }, ut.prototype.delayBufferBlockSwitch = function(Ke) {
            (0, we.isSwitchingBufferBlocks)(this.getSourceStore()) && this.currentBufferBlockDeferredReject && this.currentBufferBlockDeferredReject.reject("BufferBlock switch interrupted by newest one");
            var je = this.segmentStore.getAvailablePositionForTime(Ke, this.renderer.getCurrentTime());
            return this.delayedBufferBlockSwitchContext && this.delayedBufferBlockSwitchContext.time === Ke || (this.delayedBufferBlockSwitchContext && this.delayedBufferBlockSwitchContext.time !== Ke && this.delayedBufferBlockSwitchContext.deferred.reject(), this.delayedBufferBlockSwitchContext = { time: je, deferred: new Ee.Deferred() }), this.delayedBufferBlockSwitchContext.deferred.promise;
          }, ut.prototype.restorePlayback = function(Ke, je) {
            var De = this;
            return this.updateTimestampOffsets(), this.isEndOfStreamReached = !1, this.currentPlayingBufferBlockId = je.getId(), this.segmentStore.deleteOldBufferBlocks(je.getId()), this.hasTemporarilyReopenedMsePriorToBufferBlockSwitch = !1, this.segmentStore.getBufferBlock(je.getId()) ? this.currentBufferBlockDeferredReject.next(function() {
              return De.pushSegmentsToRenderer(1 / 0);
            }).then(function() {
              return De.currentBufferBlockDeferredReject.next(function() {
                return De.setCurrentTimeOnRenderer(Ke);
              });
            }).then(function(at) {
              var dt;
              return (dt = De.getSourceStore()) === null || dt === void 0 || dt.dispatch((0, Ce.setBufferBlockSwitchOngoing)(!1)), De.resumePlaybackIfNotStalledOrPaused(), De.endStallingAfterSeek(at);
            }) : (this.logger.debug("Target BufferBlock is no longer available, cancelling BufferBlock switch..."), Promise.reject(vt));
          }, ut.prototype.resumePlaybackIfNotStalledOrPaused = function() {
            var Ke = this, je = this.getPlayerStateService();
            je && (this.isCurrentlyStalled || je.isPaused() || this.renderer.play().catch(function(De) {
              Ke.logger.debug("play call failed with reason: ".concat(De));
            }));
          }, ut.prototype.shouldRecreateSourceBuffers = function(Ke, je) {
            var De, at = (De = this.segmentStore) === null || De === void 0 ? void 0 : De.getBufferBlock(this.currentPlayingBufferBlockId);
            if (!at)
              return !0;
            var dt = at.getPeriodId() === Ke.getPeriodId(), ft = this.currentRendererMediaTypes.length === je.length, lt = !(dt || ft) || !(0, ot.canReuseSourceBuffer)(at, Ke, je);
            return this.allowUserToOverwriteBufferRecreationDecision(lt, at, Ke);
          }, ut.prototype.allowUserToOverwriteBufferRecreationDecision = function(Ke, je, De) {
            var at, dt, ft = (at = this.context) === null || at === void 0 ? void 0 : at.sourceContext.source, lt = (dt = ft == null ? void 0 : ft.options) === null || dt === void 0 ? void 0 : dt.shouldRecreateSourceBuffersOnPeriodSwitch;
            if (!lt)
              return Ke;
            var nt = pt(je), ct = pt(De), it = (0, Be.safeUserCallback)(function() {
              return lt(nt, ct, Ke);
            }, this.context.logger);
            return typeof it == "boolean" ? (this.logger.debug("User overwrote default SourceBuffer recreation strategy from ".concat(Ke, " to ").concat(it) + " for the switch from ".concat(nt.periodId, " to ").concat(ct.periodId, ".")), it) : Ke;
          }, ut.prototype.switchBufferBlock = function(Ke, je) {
            var De, at = this;
            this.logger.debug("Switching buffer block for time ".concat(Ke));
            var dt = je.getMediaTypesWithoutSubs(), ft = this.maybeRecreateSourceBuffers(je, dt);
            return this.currentRendererMediaTypes = dt, (De = this.getSourceStore()) === null || De === void 0 || De.dispatch((0, Ce.setLoadingRangeFinished)(!1)), this.currentBufferBlockDeferredReject.next(function() {
              return ft;
            }).then(function() {
              return at.currentBufferBlockDeferredReject.next(function() {
                return at.restorePlayback(Ke, je);
              });
            }).then(function(lt) {
              return at.currentBufferBlockDeferredReject.next(function() {
                return at.pushSegmentsToRenderer(1 / 0).catch(function() {
                  return at.context.logger.debug("Could not push segment into renderer");
                });
              }).then(function() {
                return lt;
              });
            });
          }, ut.prototype.maybeRecreateSourceBuffers = function(Ke, je) {
            return this.shouldRecreateSourceBuffers(Ke, je) ? (this.logger.debug("recreating the buffers with types", je), this.createSourceBuffers(je)) : Promise.resolve(0);
          }, ut.prototype.setCurrentTimeOnRenderer = function(Ke) {
            var je = this, De = this.delayedBufferBlockSwitchContext;
            return this.delayedBufferBlockSwitchContext = void 0, this.currentBufferBlockDeferredReject.next(function() {
              return je.renderer.setCurrentTime(Ke);
            }).then(function(at) {
              return De && De.deferred && De.deferred.resolve(at), at;
            });
          }, ut.prototype.addMimeTypeAndCodec = function(Ke, je, De) {
            if (De === void 0 && (De = !1), !Pe.MimeTypeHelper.isAV(Ke))
              return !0;
            var at = this.renderer.addBuffer(Ke, je);
            return at && ((0, ge.getMetricsState)(this.context.store.getState())[Ke] || this.context.store.dispatch((0, fe.initializeMetricsForMimeType)(Ke, this.context.settings)), De || this.context.store.dispatch((0, fe.addMetricsValue)(Ke, ye.MetricType.StalledSeconds, 0))), at;
          }, ut.prototype.setInitialPeriod = function(Ke) {
            this.currentPlayingPeriodId = Ke;
          }, ut.prototype.getLowestBufferLevel = function(Ke, je) {
            var De = this;
            if (!this.isBufferAvailable())
              return 0;
            var at = this.currentRendererMediaTypes.map(function(dt) {
              return dt.mimeType;
            }).map(function(dt) {
              return De.getOverallBufferLevel(dt, Ke, me.BufferType.ForwardDuration, je);
            });
            return at.length > 0 ? Math.min.apply(Math, at) : 0;
          }, ut.prototype.isStartupThresholdReached = function() {
            var Ke = this.bufferSettings.getForwardTargetLevel(), je = Math.min(this.settings.STARTUP_THRESHOLD, Ke - this.settings.STARTUP_THRESHOLD_DELTA), De = this.getLowestBufferLevel();
            return De >= je || De >= this.getRemainingTime();
          }, ut.prototype.getInitialPlaybackTime = function() {
            if (this.startupPlaybackTime)
              return this.startupPlaybackTime;
            var Ke = this.getCurrentTimeRespectingTarget();
            if (!this.isBufferAvailable())
              return Ke;
            if (this.isInBufferedRange(Ke))
              return this.startupPlaybackTime = Ke;
            var je = this.currentRendererMediaTypes.map(function(at) {
              return at.mimeType;
            }), De = this.segmentStore.getPlaybackTimesForBufferBlock(this.currentPlayingBufferBlockId, je);
            return De.some(function(at) {
              return !isFinite(at);
            }) ? Ke : this.startupPlaybackTime = Math.max.apply(Math, De);
          }, ut.prototype.getRemainingTime = function() {
            return this.manifestService.isLive() ? 1 / 0 : this.renderer.getDuration() - this.getCurrentTimeRespectingTarget();
          }, ut.prototype.endStartupPhase = function() {
            if (this.isStartup) {
              var Ke = Date.now(), je = (0, ge.getMetricsState)(this.context.store.getState()), De = (0, ge.getMetricsLastEntry)(je, "default", ye.MetricType.StartTime).value, at = (0, Ae.toSeconds)(Ke - De);
              this.context.store.dispatch((0, fe.addMetricsValue)("default", ye.MetricType.StartupTimeSeconds, at)), isNaN(at) || this.logger.debug("start up time: ".concat(at)), this.isStartup = !1, this.maybeEndStalling();
            }
          }, ut.prototype.resetCurrentTimeInBufferedRange = function(Ke) {
            var je = this.renderer.getCurrentTime(!0);
            Ke.isInit() && Pe.MimeTypeHelper.isVideo(Ke.getMimeType()) && this.isCurrentlyStalled && ce.BufferRangeHelper.isInBufferedRange(this.getBufferedRangesMap(this.manifestService.getPeriodIdForTime(je)), je) && (this.context.videoElement.currentTime = this.context.videoElement.currentTime);
          }, ut.prototype.processDrmInitData = function(Ke) {
            var je = this;
            Ke.getDrmInitData().filter(function(De) {
              var at;
              return ((at = De.kid) === null || at === void 0 ? void 0 : at.length) > 0;
            }).forEach(function(De) {
              return je.manifestService.setRepresentationDrmKid(Ke.getRepresentationId(), De.kid[0]);
            });
          }, ut.prototype.addDataSegmentToRenderer = function(Ke) {
            var je = this, De = Pe.MimeTypeHelper.extractContentType(Ke.getMimeType());
            if (this.activeInitSegments[De] !== Ke.getInitSegment()) {
              var at = Ke.getInitSegment();
              return this.activeInitSegments[De] = at, Promise.all([at, Ke].map(function(dt) {
                return je.addSegmentToRenderer(dt);
              })).then();
            }
            return this.addSegmentToRenderer(Ke);
          }, ut.prototype.addSegmentToRenderer = function(Ke) {
            var je = this;
            return Ke.hasDrmInitData() && this.processDrmInitData(Ke), this.drmConfigValidPromise.catch(function(De) {
              if (Ke.isEncrypted())
                throw (De == null ? void 0 : De.message) !== he.DrmSetupError.CANCELLED && je.context.eventHandler.fireError(yt(De)), "DRMConfig failure";
              je.logger.debug("Problem ensuring segment, error:", De);
            }).then(function() {
              return je.resetCurrentTimeInBufferedRange(Ke), je.maybeSetTimestampOffsetForDiscontinuity(Ke), je.maybeSetTimestampOffsetForPeriod(Ke), je.renderer.appendData(Ke).catch(function(De) {
                je.logger.debug("could not append data to renderer", De);
              });
            });
          }, ut.prototype.maybeSetTimestampOffsetForDiscontinuity = function(Ke) {
            if (!Ke.isInit()) {
              var je = Ke.getSegmentInfo().discontinuitySequenceNumber, De = Ke.getMimeType();
              if (je !== this.discontinuitySequenceNumbers.get(De)) {
                var at = Ke.getPresentationTimeOffset();
                if (isFinite(at)) {
                  this.renderer.setTimestampOffset(De, -at);
                  var dt = this.currentRendererMediaTypes.find(function(ft) {
                    return ft.mimeType === De;
                  });
                  dt && (dt.timestampOffset = at, this.updateMediaType(Ke.getPeriodId(), dt));
                }
                this.discontinuitySequenceNumbers.set(De, je);
              }
            }
          }, ut.prototype.maybeSetTimestampOffsetForPeriod = function(Ke) {
            var je;
            if (!Ke.isInit() && Ke.getSegmentInfo().discontinuitySequenceNumber === void 0) {
              var De = Ke.getMimeType(), at = Ke.getSegmentInfo().periodId;
              if (at !== this.currentPeriodForMediaTypes.get(De) && at) {
                var dt = (je = this.currentRendererMediaTypes.find(function(ft) {
                  return ft.mimeType === De;
                })) === null || je === void 0 ? void 0 : je.timestampOffset;
                (0, Oe.isNumber)(dt) && isFinite(dt) && this.renderer.setTimestampOffset(De, -dt), this.currentPeriodForMediaTypes.set(De, at);
              }
            }
          }, ut.prototype.isRestartThresholdReached = function() {
            if (!this.bufferSettings)
              return !1;
            var Ke = this.settings.RESTART_THRESHOLD;
            (0, Me.isWebOS)() && (Ke = Math.max(Ke, 1.5));
            var je = this.bufferSettings.getForwardTargetLevel(), De = Math.min(Ke, je - this.settings.RESTART_THRESHOLD_DELTA, this.getRemainingTime());
            return this.getLowestBufferLevel() >= De;
          }, ut.prototype.isAllowedToStall = function() {
            return !this.isStartup && !(0, we.isSwitchingBufferBlocks)(this.getSourceStore());
          }, ut.prototype.startStalling = function() {
            this.isAllowedToStall() && this.bufferStallingService.startStalling();
          }, ut.prototype.getPlayerStateService = function() {
            return this.context.serviceManager.get(ue.ServiceName.PlayerStateService);
          }, ut.prototype.isStallingAtGap = function(Ke) {
            var je = this.getPlayerStateService();
            if (!je)
              return !1;
            var De = this.getLowestBufferLevel(Ke, !1), at = De >= this.settings.RESTART_THRESHOLD, dt = De >= this.getRemainingTime() || this.finishPlayback;
            return !at && !dt && !je.seekingOrTimeshifting;
          }, ut.prototype.maybeEndStalling = function() {
            if (this.isCurrentlyStalled)
              if ((0, we.isSwitchingBufferBlocks)(this.getSourceStore()))
                this.logger.debug("Ending stall was aborted due to buffer block switching");
              else {
                var Ke = this.getCurrentTimeRespectingTarget();
                this.isStallingAtGap(Ke) ? this.hasFutureCommonBuffer(Ke) ? (this.logger.debug("Ending stall at the gap"), this.endStallAtGapCallback()) : this.logger.debug("Cannot unstall yet as playback is stalling at a gap and there is no future common buffer") : this.bufferStallingService.endStalling();
              }
          }, ut.prototype.getCurrentTimeRespectingTarget = function() {
            return this.seekTarget !== void 0 ? this.seekTarget : this.renderer.getCurrentTime();
          }, ut.prototype.getCurrentPlayingBufferBlockId = function() {
            return this.segmentStore.getCurrentBufferBlockId();
          }, ut.prototype.hasPendingSegments = function(Ke) {
            return Ke = Ke || this.getCurrentPlayingBufferBlockId(), this.segmentStore.getFutureBufferBlocks(Ke).some(function(je) {
              return je.hasSegments();
            });
          }, ut.prototype.getOverallBufferLevel = function(Ke, je, De, at) {
            je === void 0 && (je = this.renderer.getCurrentTime()), De === void 0 && (De = me.BufferType.ForwardDuration), at === void 0 && (at = !0), this.isStartup && (je = this.getInitialPlaybackTime());
            var dt = this.getBufferedRangesMap(this.currentPlayingPeriodId)[Ke];
            return dt && dt.length !== 0 ? (dt = at ? ce.BufferRangeHelper.mergeRanges(dt.concat(ce.BufferRangeHelper.findGapsInRanges(dt)), this.settings.GAP_TOLERANCE) : dt.filter(function(ft) {
              return ft.start <= je && je <= ft.end;
            }), ce.BufferRangeHelper.getBufferLevel(dt, je, De)) : 0;
          }, ut.prototype.hasFutureCommonBuffer = function(Ke) {
            return Ke === void 0 && (Ke = this.renderer.getCurrentTime()), ce.BufferRangeHelper.getCommonBufferedRanges(this.getBufferedRangesMap(this.currentPlayingPeriodId)).some(function(je) {
              return je.getStart() > Ke;
            });
          }, ut.prototype.hasFutureBufferBlockData = function() {
            var Ke;
            return !!(!((Ke = this.segmentStore) === null || Ke === void 0) && Ke.getNextBufferBlock(this.currentPlayingBufferBlockId)) || (0, we.isSwitchingBufferBlocks)(this.getSourceStore());
          }, ut.prototype.isInBufferedRange = function(Ke, je) {
            var De = je || this.manifestService.getPeriodIdForTime(Ke);
            return ce.BufferRangeHelper.isInBufferedRange(this.getBufferedRangesMap(De), Ke);
          }, ut.prototype.isStarted = function() {
            return this.isAlreadyStarted;
          }, ut.prototype.hasStreamEnded = function() {
            return this.hasStreamEndedInternal;
          }, ut.prototype.subscribeToManifestChange = function() {
            var Ke;
            if (!this.unsubscribeFromManifestChange) {
              var je = this.getSourceStore();
              je !== void 0 && ((Ke = je.getState()) === null || Ke === void 0 ? void 0 : Ke.manifest) !== void 0 && (this.unsubscribeFromManifestChange = (0, Te.subscribe)(je)(xe.getManifest, this.updateTotalDuration, function(De) {
                return (De == null ? void 0 : De.isInitialized) || !1;
              }));
            }
          }, ut.prototype.stop = function(Ke) {
            Ke === void 0 && (Ke = !1), this.finishPlayback = !0, this.isAlreadyStarted = !1, this.isStartup = !1, Ke ? (this.renderer.end(), this.hasStreamEndedInternal = !0, this.logger.debug("stopped playback"), this.renderer.off(Ve.MediaElementEvent.stalled, this.onVideoElementStalled), this.renderer.off(Ve.MediaElementEvent.waiting, this.onVideoElementStalled), this.renderer.off(Ve.MediaElementEvent.ended, this.onVideoElementEnded), this.renderer.off(Ve.MediaElementEvent.timeupdate, this.onVideoElementTimeUpdate), this.renderer.off(Ve.MediaElementEvent.currenttimenotadvancing, this.onTimeNotAdvancing), this.unsubscribeFromManifestChange && (this.unsubscribeFromManifestChange(), this.unsubscribeFromManifestChange = void 0), this.unsubscribeFromStoreStoppedListener !== void 0 && (this.unsubscribeFromStoreStoppedListener(), this.unsubscribeFromStoreStoppedListener = void 0), this.clearBufferMaxSizeChangedSubscription(), this.dataSegmentsPushedMap.clear()) : this.maybeEndStalling();
          }, ut.prototype.hasStopped = function() {
            return this.finishPlayback;
          }, ut.prototype.clearBufferMaxSizeChangedSubscription = function() {
            var Ke = this;
            Object.keys(this.bufferMaxSizeChangedSubscriptionMap).forEach(function(je) {
              return Ke.unsubscribeFromBufferMaxSizeChanged(je);
            });
          }, ut.prototype.restart = function() {
            this.finishPlayback = !1, this.isAlreadyStarted || (this.isAlreadyStarted = !0, this.renderer.on(Ve.MediaElementEvent.stalled, this.onVideoElementStalled), this.renderer.on(Ve.MediaElementEvent.waiting, this.onVideoElementStalled), this.renderer.on(Ve.MediaElementEvent.ended, this.onVideoElementEnded), this.renderer.on(Ve.MediaElementEvent.timeupdate, this.onVideoElementTimeUpdate), this.renderer.on(Ve.MediaElementEvent.currenttimenotadvancing, this.onTimeNotAdvancing)), this.hasStreamEndedInternal = !1;
          }, ut.prototype.dispose = function() {
            var Ke, je;
            this.stop(!0), this.renderer = null, this.eventHandler = null, this.settings = null, this.bufferSettings = null, this.eventHandler = null, this.segmentStore = void 0, this.activeInitSegments = null, (Ke = this.unsubscribeFromStoreSeekedListener) === null || Ke === void 0 || Ke.call(this), (je = this.getSourceStore()) === null || je === void 0 || je.dispatch((0, Ce.resetLoadedRanges)()), this.bufferRangesCache.dispose(), this.currentRendererMediaTypes = [], this.clearBufferMaxSizeChangedSubscription(), this.drmConfigValidPromise = null, this.bufferStallingService = (0, be.dispose)(this.bufferStallingService);
          }, ut.prototype.changeBufferType = function(Ke, je) {
            var De, at, dt = this.currentRendererMediaTypes.find(function(ft) {
              return Pe.MimeTypeHelper.getMediaType(ft.mimeType) === Pe.MimeTypeHelper.getMediaType(Ke);
            });
            return dt && (this.currentRendererMediaTypes.splice(this.currentRendererMediaTypes.indexOf(dt), 1), this.currentRendererMediaTypes.push({ mimeType: Ke, codec: je, timestampOffset: 0 }), this.unsubscribeFromBufferMaxSizeChanged(dt.mimeType), (at = this.getSourceStore()) === null || at === void 0 || at.dispatch((0, Ce.resetLoadedRanges)(dt.mimeType))), this.subscribeToBufferMaxSizeChanged(Ke), this.segmentStore.changeMediaType(Ke, dt == null ? void 0 : dt.mimeType), this.activeInitSegments = {}, dt ? this.renderer.changeBufferType(Ke, je) : Promise.resolve(((De = {})[Ke] = je, De));
          }, ut.prototype.addRequiredMediaType = function(Ke, je) {
            this.segmentStore.addRequiredMediaType(Ke, je);
          }, ut.prototype.updateMediaType = function(Ke, je) {
            this.segmentStore.updateMediaType(Ke, je);
          }, ut.prototype.areBufferBlockMediaTypesFinalForPeriod = function(Ke) {
            var je, De;
            return (De = (je = this.segmentStore) === null || je === void 0 ? void 0 : je.areBufferBlockMediaTypesFinalForPeriod(Ke)) !== null && De !== void 0 && De;
          }, ut.prototype.clearCacheForMimeType = function(Ke) {
            var je;
            (je = this.getSourceStore()) === null || je === void 0 || je.dispatch((0, Ce.resetLoadedRanges)(Ke)), this.segmentStore.clearSegments(Ke);
          }, ut.prototype.clearCache = function() {
            var Ke, je = this;
            Object.keys((0, Qe.getStreamTimeline)((Ke = this.getSourceStore()) === null || Ke === void 0 ? void 0 : Ke.getState())).filter(function(De) {
              return Pe.MimeTypeHelper.isAV(De);
            }).forEach(function(De) {
              return je.clearCacheForMimeType(De);
            });
          }, ut.prototype.isBufferClearingOngoing = function() {
            return this.bufferClearingPromise !== void 0;
          }, ut.prototype.clearBuffers = function() {
            var Ke = this;
            return this.bufferClearingPromise ? (this.logger.debug("Skipping buffer clearing as it is already ongoing"), this.bufferClearingPromise) : (this.startStalling(), this.clearCache(), this.bufferClearingPromise = this.setEndOfStream(!1).then(function() {
              return Ke.clearRendererBuffers();
            }), this.bufferClearingPromise.finally(function() {
              return Ke.bufferClearingPromise = void 0;
            }), this.bufferClearingPromise);
          }, ut.prototype.clearRendererBuffers = function() {
            var Ke = this;
            if (!this.isBufferAvailable())
              return Promise.resolve();
            var je = this.currentRendererMediaTypes.map(function(De) {
              return Ke.clearBuffer(De.mimeType);
            });
            return Promise.all(je).then(function() {
            });
          }, ut.prototype.clearBuffer = function(Ke) {
            var je = this;
            return this.renderer.removeData(Ke).catch(function(De) {
              return je.logger.debug("Error clearing ".concat(Ke, " buffer:"), De);
            });
          }, ut.prototype.isBufferAvailable = function() {
            return this.currentRendererMediaTypes.length > 0;
          }, ut;
        }();
        function yt(ut) {
          var Ke;
          return Ue.ModuleManager.has(Re.ModuleName.DRM) ? (ut == null ? void 0 : ut.message) === he.DrmSetupError.MISSING_CONFIGURATION ? new le.PlayerError(_e.ErrorCode.DRM_MISSING_CONFIGURATION, { reason: ut.message }) : new le.PlayerError(_e.ErrorCode.DRM_NO_KEY_SYSTEM, { reason: (Ke = ut == null ? void 0 : ut.message) !== null && Ke !== void 0 ? Ke : ut }) : new Ne.PlayerModuleMissingError(Re.ModuleName.DRM);
        }
        function pt(ut) {
          return { periodId: ut.getPeriodId(), contentInformation: ut.getMediaTypes().map(function(Ke) {
            return { codec: Ke.codec, mimeType: Ke.mimeType, isDrmProtected: ut.getSegregationCriteria(Ke.mimeType).encryption === Je.EncryptionState.Encrypted };
          }) };
        }
        function bt(ut, Ke) {
          var je = (0, tt.getTrackIdentifier)(ut.getSegmentInfo()), De = ut.getPlaybackTimeRange();
          De && (Ke == null || Ke.dispatch((0, Xe.removeStreamTimeRange)(je, De, tt.StreamTimeRangeType.Loading))), Ke == null || Ke.dispatch((0, Ce.addLoadedRange)(je, (0, He.segmentToBufferBlockTimeRange)(ut)));
        }
        ne.BufferController = gt;
      }, 81660: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentManager = ne.SegmentService = void 0;
        var ae = ie(60997), ce = ie(79814), he = ie(56435), _e = ie(41661), le = ie(46678), se = ie(72207), oe = ie(72477), ue = function() {
          function me(pe) {
            var fe = this;
            this.context = pe, this.disposeSegmentManager = function(ge) {
              fe.segmentManagerMap.has(ge) && (fe.segmentManagerMap.get(ge).dispose(), fe.segmentManagerMap.delete(ge));
            }, this.segmentManagerMap = /* @__PURE__ */ new Map();
          }
          return me.prototype.getSegmentManagerKey = function(pe, fe) {
            var ge = fe === void 0 ? {} : fe, ye = ge.id, $e = ge.lang;
            return ce.MimeTypeHelper.isSubtitle(pe) ? [pe, ye, $e].filter(Boolean).join("-") : pe;
          }, me.prototype.add = function(pe, fe, ge) {
            var ye = this.get(pe.mimeType, ge);
            return ye || (ye = this.createSegmentManager(pe, fe), this.segmentManagerMap.set(this.getSegmentManagerKey(pe.mimeType, ge), ye)), ye;
          }, me.prototype.createSegmentManager = function(pe, fe) {
            return new be(this.context, pe, fe);
          }, me.prototype.get = function(pe, fe) {
            return this.segmentManagerMap.get(this.getSegmentManagerKey(pe, fe));
          }, me.prototype.disposeOfType = function(pe, fe) {
            this.disposeSegmentManager(this.getSegmentManagerKey(pe, fe));
          }, me.prototype.dispose = function() {
            this.segmentManagerMap.forEach(function(pe) {
              return pe.dispose();
            }), this.segmentManagerMap.clear();
          }, me;
        }();
        ne.SegmentService = ue;
        var be = function() {
          function me(pe, fe, ge) {
            this.context = pe, this.segmentParser = ge, this.hasEncryptedSegments = !1, this.loaderPool = new le.SegmentLoaderPool(pe, fe), this.initSegmentProvider = new oe.UrlInitSegmentProvider(pe, fe.mimeType), this.cache = new _e.SegmentCache(pe.settings.MAX_NUM_CACHED_SEGMENTS), this.sequence = Promise.resolve(null);
          }
          return me.prototype.getSegment = function(pe) {
            var fe = pe.isInitSegment ? this.getInitSegment(pe).then(function(ge) {
              return ve(ge);
            }) : this.getDataSegment(pe);
            return this.sequence = this.sequence.catch(function() {
            }).then(function() {
              return fe;
            }), this.sequence;
          }, me.prototype.getInitSegment = function(pe) {
            var fe = this;
            return this.initSegmentProvider.getSegment(pe).then(function(ge) {
              var ye;
              return (ye = fe.segmentParser) === null || ye === void 0 || ye.parseSegment(ge), ge;
            }).catch(function(ge) {
              return fe.context.logger.debug("Error during loading an init segment", ge), Promise.reject(ge);
            });
          }, me.prototype.getDataSegment = function(pe) {
            var fe, ge = this;
            !((fe = pe.key) === null || fe === void 0) && fe.method && (this.hasEncryptedSegments = !0);
            var ye = this.acquireInitSegment(pe);
            return (this.mustLoadInitSegmentSequentially() ? this.loadSegmentsSequentially(ye, pe) : this.loadSegmentsConcurrently(ye, pe)).then(function($e) {
              var Se = $e[0], Ce = $e[1];
              return Se.transform(function(Ie) {
                return ge.attachInitSegment(Ie, Ce), Ie;
              }, function() {
              }, function(Ie) {
                return ge.context.logger.debug("Loading failed", Ie), Ie.message;
              });
            });
          }, me.prototype.acquireInitSegment = function(pe) {
            var fe = Promise.resolve();
            if (pe.init) {
              var ge = this.initSegmentProvider.getCachedSegment(pe);
              fe = ge ? Promise.resolve(ge) : this.getInitSegment(pe.init);
            }
            return fe;
          }, me.prototype.mustLoadInitSegmentSequentially = function() {
            var pe;
            return this.context.settings.DISABLE_PARALLEL_SEGMENT_LOADING || !!(!((pe = this.context.sourceContext.source.drm) === null || pe === void 0) && pe.clearkey) || this.hasEncryptedSegments || (0, he.isTizen2016)();
          }, me.prototype.loadSegmentsSequentially = function(pe, fe) {
            var ge = this;
            return pe.then(function(ye) {
              return ge.getDataSegmentFromCacheOrLoad(fe).then(function($e) {
                return [$e, ye];
              });
            });
          }, me.prototype.loadSegmentsConcurrently = function(pe, fe) {
            return Promise.all([this.getDataSegmentFromCacheOrLoad(fe), pe]);
          }, me.prototype.getDataSegmentFromCacheOrLoad = function(pe) {
            var fe = this.getCachedSegment(pe);
            return fe != null ? (this.context.logger.debug("Returning segment from cache for URL: ".concat(pe.url)), Promise.resolve(ve(fe))) : this.loaderPool.load(pe);
          }, me.prototype.attachInitSegment = function(pe, fe) {
            fe && pe.setInitSegment(fe);
          }, me.prototype.isLoading = function(pe) {
            return pe ? this.loaderPool.getLoadingPeriodIds().includes(pe) : this.loaderPool.getLoadingPeriodIds().length > 0;
          }, me.prototype.canLoad = function() {
            var pe = this.loaderPool.isFreeLoaderAvailable();
            return this.mustLoadInitSegmentSequentially() ? pe && !this.initSegmentProvider.isLoading() : pe;
          }, me.prototype.cacheSegment = function(pe) {
            this.cache.add(pe);
          }, me.prototype.hasCachedSegment = function(pe) {
            return !!this.getCachedSegment(pe);
          }, me.prototype.getCachedSegment = function(pe) {
            return pe.isInitSegment ? this.initSegmentProvider.getCachedSegment(pe) : this.cache.get(pe);
          }, me.prototype.removeCachedInitSegments = function(pe) {
            this.initSegmentProvider.removeCachedSegments(pe);
          }, me.prototype.clearCache = function(pe) {
            pe === void 0 && (pe = !0), pe && this.initSegmentProvider.removeCachedSegments(function() {
              return !0;
            }), this.cache.clear();
          }, me.prototype.cancel = function() {
            return this.loaderPool.cancelLoading();
          }, me.prototype.dispose = function() {
            this.cancel(), this.clearCache(!1), this.loaderPool = (0, ae.dispose)(this.loaderPool), this.segmentParser = void 0, (0, ae.dispose)(this.initSegmentProvider);
          }, me;
        }();
        function ve(me) {
          var pe = new se.Stream();
          return pe.add(me), pe.end(), pe;
        }
        ne.SegmentManager = be;
      }, 82311: function(ee, ne, ie) {
        var ae, ce = this && this.__assign || function() {
          return ce = Object.assign || function(fe) {
            for (var ge, ye = 1, $e = arguments.length; ye < $e; ye++)
              for (var Se in ge = arguments[ye])
                Object.prototype.hasOwnProperty.call(ge, Se) && (fe[Se] = ge[Se]);
            return fe;
          }, ce.apply(this, arguments);
        }, he = this && this.__rest || function(fe, ge) {
          var ye = {};
          for (var $e in fe)
            Object.prototype.hasOwnProperty.call(fe, $e) && ge.indexOf($e) < 0 && (ye[$e] = fe[$e]);
          if (fe != null && typeof Object.getOwnPropertySymbols == "function") {
            var Se = 0;
            for ($e = Object.getOwnPropertySymbols(fe); Se < $e.length; Se++)
              ge.indexOf($e[Se]) < 0 && Object.prototype.propertyIsEnumerable.call(fe, $e[Se]) && (ye[$e[Se]] = fe[$e[Se]]);
          }
          return ye;
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ActiveTracksReducer = void 0, ne.getContainerFormat = oe, ne.getMediaTypes = ue;
        var _e = ie(21829), le = ie(73731), se = {};
        function oe(fe, ge) {
          var ye;
          if (fe.activeTracks)
            return (ye = Object.values(fe.activeTracks).find(function($e) {
              var Se;
              return (Se = $e.mediaTypes) === null || Se === void 0 ? void 0 : Se.includes(ge);
            })) === null || ye === void 0 ? void 0 : ye.containerFormat;
        }
        function ue(fe, ge) {
          var ye;
          return fe.activeTracks && ((ye = fe.activeTracks[ge.adaptationSetId]) === null || ye === void 0 ? void 0 : ye.mediaTypes) || [];
        }
        function be(fe, ge) {
          var ye, $e = ge.selectedRepresentationId, Se = fe[$e.adaptationSetId];
          return ce(ce({}, fe), ((ye = {})[$e.adaptationSetId] = ce(ce({}, Se), { selectedRepresentationId: $e }), ye));
        }
        function ve(fe, ge) {
          var ye, $e = ge.trackId, Se = ge.mediaTypes, Ce = fe[$e.adaptationSetId];
          return ce(ce({}, fe), ((ye = {})[$e.adaptationSetId] = ce(ce({}, Ce), { mediaTypes: Se }), ye));
        }
        function me(fe, ge) {
          var ye, $e = ge.trackId, Se = ge.containerFormat, Ce = fe[$e.adaptationSetId];
          return ce(ce({}, fe), ((ye = {})[$e.adaptationSetId] = ce(ce({}, Ce), { containerFormat: Se }), ye));
        }
        var pe = function(fe, ge) {
          var ye = fe, $e = ge.adaptationSetId.adaptationSetId, Se = (ye[$e], he(ye, [typeof $e == "symbol" ? $e : $e + ""]));
          return ce({}, Se);
        };
        ne.ActiveTracksReducer = (0, _e.default)({}, ((ae = {})[le.ActiveTracksActionType.SetSelectedRepresentationId] = function(fe, ge) {
          return be(fe, ge.payload);
        }, ae[le.ActiveTracksActionType.SetMediaType] = function(fe, ge) {
          return ve(fe, ge.payload);
        }, ae[le.ActiveTracksActionType.SetContainerFormat] = function(fe, ge) {
          return me(fe, ge.payload);
        }, ae[le.ActiveTracksActionType.RemoveActiveTrack] = function(fe, ge) {
          var ye = ge.payload;
          return pe(fe, ye);
        }, ae[le.ActiveTracksActionType.ClearActiveTracks] = function() {
          return se;
        }, ae));
      }, 84519: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MPDHandlerFactory = void 0;
        var ae = ie(18665), ce = ie(3941), he = ie(91520), _e = ie(16368), le = ie(67550), se = function() {
          function ve() {
          }
          return ve.createInstance = function(me, pe, fe, ge, ye) {
            ge === void 0 && (ge = ce.DEFAULT_PERIOD_ID);
            var $e = me.serviceManager.get(ae.ServiceName.ManifestService, me.sourceContext.sourceIdentifier);
            if (!($e != null && $e.hasAdaptationSets(ge)))
              return null;
            var Se = $e.findAdaptationSet(ge, pe, ye);
            if (!Se)
              return me.logger.debug("Did not find adaptation set for mime type [".concat(pe, "] in period ").concat(ge)), null;
            var Ce = Se.Representation && Se.Representation[0], Ie = Ce && Ce.SegmentTemplate ? Ce.SegmentTemplate : Se.SegmentTemplate;
            return $e.isSmoothManifest() ? oe(me, pe, fe, Ie) : $e.isHlsManifest() ? ue(me, Ce) : be(me, Ie, Ce);
          }, ve;
        }();
        function oe(ve, me, pe, fe) {
          return fe ? new (he.ModuleManager.get(_e.ModuleName.Smooth).createSmoothSegmentTemplateMPDHandler())(ve, me, pe) : null;
        }
        function ue(ve, me) {
          return me.SegmentList ? new le.SegmentListMPDHandler(ve) : null;
        }
        function be(ve, me, pe) {
          var fe = he.ModuleManager.get(_e.ModuleName.DASH);
          return me && me[0].SegmentTimeline ? new fe.SegmentTimelineMPDHandler(ve) : me ? new fe.SegmentTemplateMPDHandler(ve) : pe.SegmentList ? new le.SegmentListMPDHandler(ve) : pe.SegmentBase ? new fe.SegmentBaseMPDHandler(ve) : null;
        }
        ne.MPDHandlerFactory = se;
      }, 85157: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentInfoMapActionType = void 0, function(ae) {
          ae.SetSegmentInfos = "@instance/sources/@source/playback/setSegmentInfos", ae.UpdateSegmentInfos = "@instance/sources/@source/playback/updateSegmentInfos";
        }(ie || (ne.SegmentInfoMapActionType = ie = {}));
      }, 85586: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ye) {
            for (var ze, Fe = 1, ot = arguments.length; Fe < ot; Fe++)
              for (var vt in ze = arguments[Fe])
                Object.prototype.hasOwnProperty.call(ze, vt) && (Ye[vt] = ze[vt]);
            return Ye;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MediaPlayer = ne.LoadState = void 0, ne.checkIfGapSkip = Ge;
        var ce, he = ie(92712), _e = ie(47275), le = ie(18665), se = ie(60997), oe = ie(62510), ue = ie(57620), be = ie(15539), ve = ie(33696), me = ie(76650), pe = ie(28819), fe = ie(8272), ge = ie(17990), ye = ie(58975), $e = ie(3464), Se = ie(42283), Ce = ie(79814), Ie = ie(331), Te = ie(46462), Ee = ie(91520), we = ie(16368), Pe = ie(6476), Me = ie(3337), Ae = ie(38353), Oe = ie(43412), Be = ie(28171), Ve = ie(36366), Ue = ie(81660), Re = ie(38765), Ne = ie(4053), xe = ie(71827), ke = ie(58211), Le = ie(59879), He = ie(64330), We = ie(64729);
        (function(Ye) {
          Ye.Unloaded = "unloaded", Ye.Preparing = "preparing", Ye.Loading = "loading", Ye.Loaded = "loaded";
        })(ce || (ne.LoadState = ce = {}));
        var Xe = Object.freeze({ id: "auto", bitrate: null }), Qe = Object.freeze({ id: "auto", bitrate: null, width: null, height: null }), tt = function() {
          function Ye(ze) {
            var Fe = this;
            this.timeShiftJumpStart = -1, this.ignoreNextVideoError = !1, this.ended = !1, this.isDvrWindowExceeded = !1, this.controlPermitted = !0, this.lastPlayIssuer = "api", this.lastPauseIssuer = "api", this.onSegmentAvailable = function(ot) {
              Fe.relativeCurrentTimeOffset != null || ot.isInit() || (Fe.relativeCurrentTimeOffset = Fe.isLive() ? Fe.calcRelativeCurrentTimeOffsetForLive(ot) : 0);
            }, this.onPlaying = function() {
              Fe.isLive() && Fe.canResumeLatencyControl() && Fe.resumeLatencyControl();
            }, this.videoErrorHandler = function(ot) {
              Fe.ignoreNextVideoError ? Fe.ignoreNextVideoError = !1 : (Fe.logger.debug("Caught a video element error: ", ot), Fe.unload(), Fe.eventHandler.fireError((0, ue.createPlayerErrorFromMediaError)(ot)));
            }, this.controlLiveLatency = function() {
              var ot = Fe.liveLatencyService.getStatus(Fe.liveLatencyMode, Fe.getCommonBufferLevel());
              Fe.liveLatencyMode !== ot.mode && (Fe.context.eventHandler.dispatchEvent(oe.PlayerEvent.LatencyModeChanged, { from: Fe.liveLatencyMode, to: ot.mode }), Fe.liveLatencyMode = ot.mode), ot.mode === oe.LatencyMode.Suspended || Fe.playerStateService.seekingOrTimeshifting || (ot.requiredAction === Fe.lowLatencyModule.LiveLatencyControlAction.Seek ? Fe.goToLiveEdge() : ot.requiredAction === Fe.lowLatencyModule.LiveLatencyControlAction.PlaybackRate && Fe.setPlaybackSpeed(1, ot.actionParam, !1));
            }, this.onPlaybackStarted = function() {
              Fe.playerStateService.getIsRendererStalling() ? (Fe.logger.debug("Renderer is currently stalled. Waiting for unstalling before ending stall."), Fe.clearStallEndedSubscription(), Fe.unsubscribeFromStallEnded = (0, $e.subscribe)(Fe.context.store)(function(ot) {
                return (0, ye.getPlayerState)(ot);
              }, function() {
                return Fe.endStall();
              }, function(ot) {
                return !(0, ye.getIsRendererStalled)(ot);
              })) : Fe.endStall();
            }, this.onVideoElementPlay = function() {
              Fe.ended && (Fe.logger.debug("Detected replay attempt from video element"), Fe.context.internalPlayer.play()), Fe.playerStateService.transitionToPlayState(!0, Fe.lastPlayIssuer);
            }, this.onVideoElementPaused = function() {
              Fe.logger.insane("video element signaled pause in state: ".concat(Fe.playerStateService.playbackState)), Fe.playerController.maybeTransitionToPausedState(Fe.lastPauseIssuer);
            }, this.mapLangObjectToAudioTrack = function(ot) {
              return { id: ot.id, lang: ot.lang, label: ot.label, role: ot.role, getQualities: function() {
                return Be.MediaPlayerManifestApiFactory.getAudioQualities(Fe.manifestService, Fe.getCurrentPlayingPeriodId(), ot.id);
              } };
            }, this.onVideoElementSeeking = function(ot) {
              var vt = Ge(Fe.context, ot.time);
              Fe.settings.GLOBAL_DISABLE_SEEKING && !vt && Math.abs(ot.time - Fe.lastCurrentTimeUpdate) > 0.05 && (Fe.logger.debug("Seeking now allowed, seeking back to expected time"), Fe.context.videoElement.currentTime = Fe.lastCurrentTimeUpdate);
            }, this.onVideoTimeupdate = function(ot) {
              if (!Fe.ended) {
                var vt = Fe.renderer.getCurrentTime(!0) === 0, gt = Fe.isPlaying(), yt = Fe.playerStateService.isSeeking(), pt = Fe.isStalled();
                !gt || yt || pt || vt ? Fe.logger.debug("Skipping timeupdate", { isPlaying: gt, isSeeking: yt, isStalled: pt, timeUpdateWithoutBuffer: vt, time: ot.time }) : Fe.handleTimeChanged(Fe.getCurrentTime());
              }
            }, this.onContentPlaybackFinished = function() {
              Fe.ended = !0;
            }, this.onDvrWindowExceeded = function() {
              Fe.context.logger.debug("DVR window exceeded"), Fe.playerStateService.isPlaying() ? Fe.handleDvrWindowExceeded() : Fe.isDvrWindowExceeded = !0;
            }, this.onError = function(ot) {
              ot.code === 3001 && Fe.unload();
            }, this.fireAudioTracksAdded = function() {
              for (var ot = Fe.getCurrentTime(), vt = 0, gt = Fe.getAvailableAudio(); vt < gt.length; vt++) {
                var yt = gt[vt];
                Fe.context.eventHandler.dispatchEvent(oe.PlayerEvent.AudioAdded, { track: yt, time: ot });
              }
            }, this.fireAudioTracksRemoved = function(ot) {
              for (var vt = 0, gt = Fe.getAvailableAudio(); vt < gt.length; vt++) {
                var yt = gt[vt];
                Fe.context.eventHandler.dispatchEvent(oe.PlayerEvent.AudioRemoved, { track: yt, time: ot });
              }
            }, this.onPeriodSwitch = function() {
              Fe.fireAudioTracksRemoved(Fe.getCurrentTime());
            }, this.onPlaybackSpeedChanged = function(ot) {
              Fe.isLive() && (Fe.canResumeLatencyControl() ? Fe.resumeLatencyControl() : Fe.suspendLatencyControl(!1));
            }, this.context = ze, this.logger = ze.logger, this.config = ze.config, this.settings = ze.settings, this.renderer = ze.renderer, this.eventHandler = ze.eventHandler, this.loadState = ce.Unloaded, this.context.store.dispatch((0, me.initializeMetricsForMimeType)("default", this.context.settings)), this.playerController = new Ve.MediaPlayerController(ze, this.onSegmentAvailable), Ee.ModuleManager.has(we.ModuleName.LowLatency) && (this.lowLatencyModule = Ee.ModuleManager.get(we.ModuleName.LowLatency)), this.eventHandler.on(oe.PlayerEvent.PeriodSwitch, this.onPeriodSwitch), this.eventHandler.on(oe.PlayerEvent.PeriodSwitched, this.fireAudioTracksAdded), this.eventHandler.on(oe.PlayerEvent.PlaybackSpeedChanged, this.onPlaybackSpeedChanged), this.unsubscribeStorePlayingListener = (0, $e.subscribe)(this.context.store)(function(ot) {
              return (0, ye.getIsPlaying)((0, ye.getPlayerState)(ot));
            }, this.onPlaying, function(ot, vt) {
              return ot && !vt;
            });
          }
          return Ye.prototype.createServices = function(ze, Fe) {
            var ot = Fe.serviceManager;
            this.createSynchronizedTimeService(Fe), this.createManifestService(Fe), this.createManifestLoadingService(Fe, ze), this.createManifestUpdateSchedulingService(Fe);
            var vt = Ee.ModuleManager.get(we.ModuleName.ABR).AdaptationService;
            ot.set(le.ServiceName.AdaptationService, new vt(Fe)), ot.set(le.ServiceName.TimedMetadataService, new Re.TimedMetadataService(Fe)), ot.set(le.ServiceName.SegmentService, new Ue.SegmentService(Fe));
            var gt = new Le.StreamTimeService(ot, Fe.sourceContext.sourceIdentifier);
            ot.set(le.ServiceName.StreamTimeService, gt), ot.set(le.ServiceName.HeartbeatService, new Pe.HeartbeatService(ot, this.playerController), Fe.sourceContext.sourceIdentifier), this.createSubtitleService(Fe), this.createLowLatencyService(Fe);
          }, Ye.prototype.createSynchronizedTimeService = function(ze) {
            var Fe = ze.serviceManager, ot = ze.sourceContext.sourceIdentifier;
            if (!Fe.has(le.ServiceName.SynchronizedTimeService, ot)) {
              var vt = new He.SynchronizedTimeService(ze, ze.sourceContext);
              Fe.set(le.ServiceName.SynchronizedTimeService, vt, ot);
            }
          }, Ye.prototype.createManifestService = function(ze) {
            var Fe = ze.serviceManager, ot = ze.sourceContext.sourceIdentifier;
            Fe.has(le.ServiceName.ManifestService, ot) ? (this.manifestService = Fe.get(le.ServiceName.ManifestService, ot), this.manifestService.restore()) : (this.manifestService = new Ae.ManifestService(ze, ze.sourceContext), Fe.set(le.ServiceName.ManifestService, this.manifestService, ot));
          }, Ye.prototype.createManifestLoadingService = function(ze, Fe) {
            var ot = ze.serviceManager, vt = ze.sourceContext.sourceIdentifier;
            if (!ot.has(le.ServiceName.ManifestLoadingService, vt)) {
              var gt = (0, Me.createManifestLoadingService)(Fe, ze, ze.sourceContext);
              ot.set(le.ServiceName.ManifestLoadingService, gt, vt);
            }
          }, Ye.prototype.createManifestUpdateSchedulingService = function(ze) {
            var Fe = ze.serviceManager, ot = ze.sourceContext.sourceIdentifier;
            if (Fe.has(le.ServiceName.ManifestUpdateSchedulingService, ot))
              Fe.get(le.ServiceName.ManifestUpdateSchedulingService, ot).restore();
            else {
              var vt = new Oe.ManifestUpdateScheduler(ze, ze.sourceContext);
              Fe.set(le.ServiceName.ManifestUpdateSchedulingService, vt, ot);
            }
          }, Ye.prototype.createSubtitleService = function(ze) {
            var Fe = ze.serviceManager, ot = ze.sourceContext.sourceIdentifier;
            if (Ee.ModuleManager.has(we.ModuleName.Subtitles) && !Fe.has(le.ServiceName.SubtitleService, ot)) {
              var vt = Ee.ModuleManager.get(we.ModuleName.Subtitles).SubtitleService;
              Fe.set(le.ServiceName.SubtitleService, new vt(ze), ot);
            }
            this.subtitleService = Fe.get(le.ServiceName.SubtitleService, ot);
          }, Ye.prototype.createLowLatencyService = function(ze) {
            var Fe, ot = ze.serviceManager;
            (Fe = this.liveLatencyService) === null || Fe === void 0 || Fe.dispose(), Ee.ModuleManager.has(we.ModuleName.LowLatency) && (ot.set(le.ServiceName.LiveLatencyService, new this.lowLatencyModule.LiveLatencyService(ze)), this.liveLatencyService = ot.get(le.ServiceName.LiveLatencyService));
          }, Ye.prototype.disposeServices = function(ze) {
            var Fe, ot, vt = this.context.serviceManager;
            [le.ServiceName.LiveLatencyService, le.ServiceName.TimedMetadataService].forEach(function(yt) {
              return (0, _e.disposeService)(vt, yt);
            });
            var gt = (Fe = this.context.sourceContext) === null || Fe === void 0 ? void 0 : Fe.sourceIdentifier;
            gt && ((0, _e.disposeService)(vt, le.ServiceName.HeartbeatService, gt), (0, _e.disposeService)(vt, le.ServiceName.SegmentService, gt), ze !== be.ADVERTISING_ISSUER_NAME ? [le.ServiceName.ManifestService, le.ServiceName.ManifestLoadingService, le.ServiceName.ManifestUpdateSchedulingService, le.ServiceName.SynchronizedTimeService, le.ServiceName.SubtitleService].forEach(function(yt) {
              return (0, _e.disposeService)(vt, yt, gt);
            }) : (vt.get(le.ServiceName.ManifestService, gt).suspend(), vt.get(le.ServiceName.ManifestUpdateSchedulingService, gt).suspend(), (ot = vt.get(le.ServiceName.SubtitleService, gt)) === null || ot === void 0 || ot.disableAllSubtitles()));
          }, Ye.prototype.calcRelativeCurrentTimeOffsetForLive = function(ze) {
            var Fe = ze.getSegmentInfo().wallClockTime != null ? ze.getPlaybackTime() - (0, Ie.toSeconds)(ze.getSegmentInfo().wallClockTime) : 0;
            return this.playerController.getSeekableRange().start + Fe;
          }, Ye.prototype.play = function(ze) {
            return this.lastPlayIssuer = ze, this.controlPermitted ? this.currentSource ? this.playerStateService.isPlaying() ? (this.logger.debug("Ignoring play call as play was already triggered or we're already playing"), Promise.resolve()) : (this.ended = !1, this.playerStateService.isPaused() && this.isLive() && (this.isDvrWindowExceeded || this.getMaxTimeShift() >= 0) && (this.context.logger.debug("Handling DVR window excursion - going to live edge"), this.goToLiveEdge(), this.isDvrWindowExceeded = !1), this.playerController.start(), this.playerStateService.transitionToPendingPlayState(!1, ze), this.renderer.play()) : Promise.resolve() : Promise.reject("Play control not permitted");
          }, Ye.prototype.goToLiveEdge = function() {
            var ze = this;
            this.settings.ENABLE_SEEK_FOR_LIVE ? this.playerStateService.isSeeking() || this.seek(this.getSeekableRange().end, be.INTERNAL_ISSUER_NAME) : this.playerController.timeShift(0, function() {
              return ze.onTimeShifted();
            }).catch(function() {
              return ze.onTimeShiftFailed();
            });
          }, Ye.prototype.canResumeLatencyControl = function() {
            return !!this.liveLatencyService && !this.isPaused() && this.getTimeShift() === 0 && this.getPlaybackSpeed() === 1 && !this.playerStateService.isTimeShifting() && !this.playerStateService.isSeeking();
          }, Ye.prototype.resumeLatencyControl = function() {
            this.liveLatencyService.resumeControl();
          }, Ye.prototype.suspendLatencyControl = function(ze) {
            ze === void 0 && (ze = !0);
            var Fe = this.liveLatencyMode === oe.LatencyMode.Suspended;
            this.liveLatencyService && !Fe && (this.liveLatencyService.suspendControl(), ze && this.setPlaybackSpeed(1, 1, !1));
          }, Ye.prototype.getCommonBufferLevel = function() {
            var ze = [this.getBufferLevel(ve.BufferType.ForwardDuration, ve.MediaType.Audio), this.getBufferLevel(ve.BufferType.ForwardDuration, ve.MediaType.Video)].map(function(Fe) {
              return Fe.level;
            }).filter(function(Fe) {
              return Fe !== null;
            });
            return ze.length === 0 ? 0 : Math.min.apply(Math, ze);
          }, Ye.prototype.endStall = function() {
            this.clearStallEndedSubscription(), this.playerStateService.stallExit(), this.playerStateService.transitionToPlayingState(this.lastPlayIssuer), this.ended = !1;
          }, Ye.prototype.preload = function() {
            this.loadState !== ce.Unloaded && this.playerController && this.playerController.start();
          }, Ye.prototype.pause = function(ze) {
            this.controlPermitted && (this.logger.insane("Pause was called via the API"), this.playerStateService.isInitial() || (this.lastPauseIssuer = ze, this.isLive() && this.liveLatencyService && this.liveLatencyService.isConfigured() && (this.suspendLatencyControl(), this.controlLiveLatency()), this.playerStateService.isPaused() || this.playerStateService.isStopped() || this.renderer.pause(), this.playerStateService.transitionToPausedState(this.renderer.isPaused(), ze)));
          }, Ye.prototype.mute = function(ze) {
            this.isMuted() || (this.renderer.mute(), this.context.eventHandler.dispatchEvent(oe.PlayerEvent.Muted, { issuer: ze || "api" }));
          }, Ye.prototype.unmute = function(ze) {
            this.isMuted() && (this.renderer.unmute(), this.context.eventHandler.dispatchEvent(oe.PlayerEvent.Unmuted, { issuer: ze || "api" }));
          }, Ye.prototype.maybeAdjustSeekTargetToDiscontinuityStart = function(ze, Fe) {
            var ot, vt = (ot = this.getSourceStoreService()) === null || ot === void 0 ? void 0 : ot.getState();
            if (!vt)
              return ze;
            for (var gt = Ee.ModuleManager.get(we.ModuleName.HLS).selectors, yt = gt.getHlsState, pt = (0, gt.getMergedDiscontinuityTimings)(yt(vt)), bt = Object.values(pt), ut = 0; ut < bt.length - 1; ut++) {
              var Ke = bt[ut].endTime, je = bt[ut + 1].startTime;
              if (ze >= Ke - Fe && ze < je)
                return this.logger.debug("Adjusting seek target to discontinuity start: ".concat(ze, " -> ").concat(je)), je;
            }
            return ze;
          }, Ye.prototype.seek = function(ze, Fe) {
            var ot, vt, gt;
            Fe === void 0 && (Fe = "");
            var yt = this.config && this.config.hasOwnProperty("playback") ? this.config.playback : {}, pt = !yt.hasOwnProperty("seeking") || yt.seeking, bt = this.context.store.getState(), ut = !!bt && (gt = (vt = (ot = (0, ye.getPlayerState)(bt)) === null || ot === void 0 ? void 0 : ot.seekingProcess) === null || vt === void 0 ? void 0 : vt.isInitial) !== null && gt !== void 0 && gt, Ke = ![be.STARTUP_ISSUER_NAME, be.INTERNAL_ISSUER_NAME].includes(Fe);
            if (!(ut || !this.settings.GLOBAL_DISABLE_SEEKING && pt) || !this.controlPermitted)
              return !1;
            var je = this.settings.END_OF_BUFFER_TOLERANCE, De = this.manifestService.isHlsManifest() ? this.maybeAdjustSeekTargetToDiscontinuityStart(ze, je) : (0, We.adjustTargetTimeToPeriodStart)(ze, je, this.manifestService, this.logger);
            return this.ended = !1, this.cancelPotentialOngoingTimeShift(), this.ensureSeekedOrTimeshiftedSubscription(), this.playerStateService.transitionToSeekingState(De, Fe, Ke), this.context.store.dispatch((0, ge.updateSeekingProcess)({ issuer: Fe, targetTime: De, seekableRange: this.getSeekableRange(), isInitial: ut })), !0;
          }, Ye.prototype.cancelPotentialOngoingTimeShift = function() {
            this.playerStateService.isTimeShifting() && (this.playerController.getTimeShiftHandler().cancel(), this.playerStateService.transitionToTimeShiftedState(!1));
          }, Ye.prototype.handleTimeChanged = function(ze) {
            ze !== this.lastCurrentTimeUpdate && (this.context.eventHandler.dispatchEvent(oe.PlayerEvent.TimeChanged, { time: ze }), this.lastCurrentTimeUpdate = ze, this.isLive() && this.liveLatencyService && this.liveLatencyService.isConfigured() && this.controlLiveLatency());
          }, Ye.prototype.setVolume = function(ze, Fe) {
            var ot = this.renderer.getVolume();
            this.renderer.setVolume(ze), ot !== ze && this.context.eventHandler.dispatchEvent(oe.PlayerEvent.VolumeChanged, { targetVolume: ze, sourceVolume: ot, issuer: Fe || "api" });
          }, Ye.prototype.setAudioQuality = function(ze) {
            var Fe, ot = this.getAvailableAudioQualities(), vt = this.getAudioQuality();
            (Fe = ze === "auto" ? Xe : ot.find(function(gt) {
              return gt.id === ze;
            })) && vt.id !== Fe.id && (this.setFixedRepresentation(ve.MediaType.Audio, ze), this.context.eventHandler.dispatchEvent(oe.PlayerEvent.AudioQualityChanged, { sourceQuality: vt, sourceQualityId: vt.id, targetQuality: Fe, targetQualityId: Fe.id }));
          }, Ye.prototype.getAudioQuality = function() {
            var ze = this.getInitializedMimeTypeFromMediaType(ve.MediaType.Audio), Fe = this.context.serviceManager.get(le.ServiceName.AdaptationService), ot = Fe.isAuto(ze), vt = Fe.getCurrentRepresentationId(ze);
            return ot || vt === null ? Xe : this.getAvailableAudioQualities().find(function(gt) {
              return gt.id === vt.representationId;
            });
          }, Ye.prototype.setFixedRepresentation = function(ze, Fe) {
            var ot = this.getInitializedMimeTypeFromMediaType(ze);
            this.context.serviceManager.get(le.ServiceName.AdaptationService).setFixedRepresentation(ot, Fe);
          }, Ye.prototype.setVideoQuality = function(ze) {
            var Fe, ot = this.getAvailableVideoQualities(), vt = this.getVideoQuality();
            (Fe = ze === "auto" ? Qe : ot.find(function(gt) {
              return gt.id === ze;
            })) && vt.id !== Fe.id && (this.context.eventHandler.dispatchEvent(oe.PlayerEvent.VideoQualityChanged, { sourceQuality: vt, sourceQualityId: vt.id, targetQuality: Fe, targetQualityId: Fe.id }), this.setFixedRepresentation(ve.MediaType.Video, ze));
          }, Ye.prototype.getVideoQuality = function() {
            var ze = this.getInitializedMimeTypeFromMediaType(ve.MediaType.Video), Fe = this.context.serviceManager.get(le.ServiceName.AdaptationService), ot = Fe.isAuto(ze), vt = Fe.getCurrentRepresentationId(ze);
            return ot || vt === null ? Qe : this.getAvailableVideoQualities().find(function(gt) {
              return gt.id === vt.representationId;
            });
          }, Ye.prototype.processSourceContext = function() {
            var ze = this.context.sourceContext;
            ze.source && ze.source.options && ze.source.options.headers && (this.settings.HTTP_HEADERS = ze.source.options.headers);
          }, Ye.prototype.addReducersToSourceStore = function(ze) {
            var Fe = this.getSourceStoreService();
            if (Fe !== void 0) {
              if (ze.type === ve.StreamType.Hls && Ee.ModuleManager.has(we.ModuleName.HLS) && !Fe.hasReducer("hls")) {
                var ot = Ee.ModuleManager.get(we.ModuleName.HLS);
                Fe.addReducer("hls", ot.HlsReducer);
              }
              Object.keys(xe.engineBitmovinSourceReducers).forEach(function(vt) {
                var gt = xe.engineBitmovinSourceReducers[vt];
                gt !== void 0 && Fe.addReducer(vt, gt);
              });
            }
          }, Ye.prototype.addRendererEventListeners = function() {
            this.renderer.on(Te.MediaElementEvent.error, this.videoErrorHandler), this.renderer.on(Te.MediaElementEvent.timeupdate, this.onVideoTimeupdate), this.renderer.on(Te.MediaElementEvent.seeking, this.onVideoElementSeeking), this.renderer.on(Te.MediaElementEvent.playing, this.onPlaybackStarted), this.renderer.on(Te.MediaElementEvent.play, this.onVideoElementPlay), this.renderer.on(Te.MediaElementEvent.pause, this.onVideoElementPaused);
          }, Ye.prototype.logBitrateBoundarySettings = function() {
            this.logger.debug("setting bitrate boundaries for audio to " + this.settings.MIN_SELECTABLE_AUDIO_BITRATE + " - " + this.settings.MAX_SELECTABLE_AUDIO_BITRATE), this.logger.debug("setting bitrate boundaries for video to " + this.settings.MIN_SELECTABLE_VIDEO_BITRATE + " - " + this.settings.MAX_SELECTABLE_VIDEO_BITRATE);
          }, Ye.prototype.loadInternal = function(ze, Fe) {
            var ot, vt = this;
            return this.loadState === ce.Unloaded ? Promise.reject("Unload during load") : (this.createServices(ze, this.context), this.context.sourceContext.source = ze.config, !((ot = this.context.videoElement) === null || ot === void 0) && ot.eventHandler && this.context.videoElement.eventHandler.reset(), this.currentSource = ze, this.ended = !1, this.isDvrWindowExceeded = !1, this.context.store.dispatch((0, ge.updateSeekingProcess)({ isInitial: !0 })), this.logBitrateBoundarySettings(), this.liveLatencyService && (this.liveLatencyMode = oe.LatencyMode.Suspended, this.liveLatencyService.reset()), this.addRendererEventListeners(), this.settings.GLOBAL_DISABLE_SEEKING = Fe || !1, this.loadState = ce.Loading, this.playerController.init(ze).then(function() {
              vt.loadState = ce.Loaded;
            }));
          }, Ye.prototype.prepareLoad = function() {
            var ze = this.context.serviceManager.get(le.ServiceName.PlayerStateService);
            ze && (this.playerStateService = ze);
            var Fe = Promise.resolve();
            return this.loadState === ce.Loading && (Fe = this.unload()), this.playerStateService.reset(), this.loadState = ce.Preparing, Fe;
          }, Ye.prototype.load = function(ze, Fe) {
            var ot = this;
            return ze.type !== "dash" && ze.type !== "hls" && ze.type !== "smooth" ? Promise.reject("invalid source") : (this.addReducersToSourceStore(ze), this.processSourceContext(), this.unsubscribeFromStoreStoppedListener = (0, $e.subscribe)(this.context.store)(function(vt) {
              return (0, ye.getIsStopped)((0, ye.getPlayerState)(vt));
            }, this.onContentPlaybackFinished, function(vt) {
              return vt === !0;
            }), this.eventHandler.on(oe.PlayerEvent.DVRWindowExceeded, this.onDvrWindowExceeded, !0), this.eventHandler.on(oe.PlayerEvent.Error, this.onError, !0), this.renderer.ready().then(function() {
              return ot.loadInternal(ze, Fe);
            }));
          }, Ye.prototype.getSourceStoreService = function() {
            return this.context.serviceManager.get(le.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, Ye.prototype.unload = function(ze) {
            var Fe = this;
            if (this.clearStallEndedSubscription(), this.loadState === ce.Unloaded)
              return Promise.resolve();
            var ot = this.loadState === ce.Loaded;
            this.ended = !1, this.loadState = ce.Unloaded, this.ignoreNextVideoError = !0, this.relativeCurrentTimeOffset = null, this.renderer.off(Te.MediaElementEvent.error, this.videoErrorHandler), this.renderer.off(Te.MediaElementEvent.timeupdate, this.onVideoTimeupdate), this.renderer.off(Te.MediaElementEvent.seeking, this.onVideoElementSeeking), this.renderer.off(Te.MediaElementEvent.playing, this.onPlaybackStarted), this.renderer.off(Te.MediaElementEvent.play, this.onVideoElementPlay), this.renderer.off(Te.MediaElementEvent.pause, this.onVideoElementPaused), this.unsubscribeFromStoreStoppedListener(), this.eventHandler.off(oe.PlayerEvent.DVRWindowExceeded, this.onDvrWindowExceeded), this.eventHandler.off(oe.PlayerEvent.Error, this.onError), this.playerStateService.isPlaying() && this.renderer.pause(), this.playerStateService.reset();
            var vt = this.context.sourceContext.sourceIdentifier;
            return this.context.serviceManager.has(le.ServiceName.SynchronizedTimeService, vt) && !Je(ze) && this.context.serviceManager.get(le.ServiceName.SynchronizedTimeService, vt).reset(), (this.playerController ? this.playerController.terminate() : Promise.resolve()).then(function() {
              Fe.currentSource = void 0, Fe.disposeServices(ze), Je(ze) || Fe.getSourceStoreService().dispatch((0, Ne.clearActiveTracksAction)()), ot && Fe.eventHandler.dispatchEvent(oe.PlayerEvent.SourceUnloaded);
            });
          }, Ye.prototype.isReady = function() {
            return this.playerController.isInitialized();
          }, Ye.prototype.isPlaying = function() {
            return this.playerStateService.isPlaying();
          }, Ye.prototype.isPaused = function() {
            return this.playerStateService.isPaused();
          }, Ye.prototype.hasEnded = function() {
            return this.ended;
          }, Ye.prototype.isMuted = function() {
            return this.renderer.isMuted();
          }, Ye.prototype.isStalled = function() {
            return this.playerStateService.isStalled;
          }, Ye.prototype.isLive = function() {
            return this.manifestService.isLive();
          }, Ye.prototype.getVolume = function() {
            return this.renderer.getVolume();
          }, Ye.prototype.getCurrentTime = function(ze) {
            return ze === void 0 && (ze = ve.TimeMode.AbsoluteTime), !this.isLive() && this.hasEnded() ? this.getDuration() : ze === ve.TimeMode.RelativeTime ? Math.max(0, this.playerController.getCurrentTime() - this.relativeCurrentTimeOffset) : this.playerController.getCurrentTime();
          }, Ye.prototype.getDuration = function() {
            return this.manifestService.getDuration();
          }, Ye.prototype.getAvailableVideoQualities = function() {
            return this.isReady() ? this.manifestService.getVideoRepresentations(this.getCurrentPlayingPeriodId()) : [];
          }, Ye.prototype.getAvailableSegments = function() {
            return this.isReady() ? this.playerController.getAvailableSegments() : {};
          }, Ye.prototype.getAvailableAudioQualities = function() {
            var ze = this.getAudio();
            if (!this.isReady() || !ze)
              return [];
            var Fe = this.manifestService.getAudioRepresentations(this.getCurrentPlayingPeriodId());
            return Fe[ze.id] ? Fe[ze.id] : [];
          }, Ye.prototype.getDroppedVideoFrames = function() {
            return this.renderer.getDroppedVideoFrames();
          }, Ye.prototype.setTargetBufferLevel = function(ze, Fe, ot) {
            this.context.bufferSettings.setTargetLevel(ze, Fe, ot);
          }, Ye.prototype.getBufferLevel = function(ze, Fe) {
            var ot = { level: null, targetLevel: this.context.bufferSettings.getTargetLevel(ze, Fe), type: ze, media: Fe }, vt = this.renderer.getCurrentTime(), gt = (0, pe.getMetricsState)(this.context.store.getState()), yt = Object.keys(gt).find(function(bt) {
              return Ce.MimeTypeHelper.isVideo(bt);
            }), pt = Object.keys(gt).find(function(bt) {
              return Ce.MimeTypeHelper.isAudio(bt);
            });
            return Fe === ve.MediaType.Video && yt ? ot.level = this.playerController.getBufferLevel(yt, vt, ze) : Fe === ve.MediaType.Audio && pt && (ot.level = this.playerController.getBufferLevel(pt, vt, ze)), ot;
          }, Ye.prototype.getTotalStalledTime = function() {
            var ze = (0, pe.getMetricsState)(this.context.store.getState());
            for (var Fe in ze)
              if (ze[Fe]) {
                var ot = (0, pe.getMetricsLastEntry)(ze, Fe, fe.MetricType.StalledSeconds);
                if (ot && ot.value && !isNaN(ot.value))
                  return Math.round(100 * ot.value) / 100;
              }
            return 0;
          }, Ye.prototype.getInitializedMimeTypeFromMediaType = function(ze) {
            var Fe = (0, pe.getMetricsState)(this.context.store.getState());
            return Object.keys(Fe).find(function(ot) {
              return ot.includes(ze);
            });
          }, Ye.prototype.getDownloadedData = function(ze) {
            var Fe = this.getInitializedMimeTypeFromMediaType(ze), ot = ae({}, this.getCurrentAdaptationSet(Fe)), vt = ae({}, this.getCurrentRepresentation(Fe));
            return vt.id && (vt.id = "" + vt.id), vt.width === void 0 && ot.width !== void 0 && (vt.width = ot.width), vt.width = parseInt("" + vt.width), vt.height === void 0 && ot.height !== void 0 && (vt.height = ot.height), vt.height = parseInt("" + vt.height), vt.bitrate === void 0 && ot.bitrate !== void 0 && (vt.bitrate = ot.bitrate), vt.bitrate = parseInt("" + vt.bitrate), vt.isAuto = this.context.serviceManager.get(le.ServiceName.AdaptationService).isAuto(Fe), vt;
          }, Ye.prototype.getCurrentRepresentation = function(ze) {
            if (this.playerController.hasStarted()) {
              var Fe = (0, pe.getMetricsState)(this.context.store.getState());
              if (Fe[ze])
                return (0, pe.getMetricsLastEntry)(Fe, ze, fe.MetricType.DownloadedRepresentation).value;
            }
            return {};
          }, Ye.prototype.getCurrentAdaptationSet = function(ze) {
            if (this.playerController.hasStarted()) {
              var Fe = (0, pe.getMetricsState)(this.context.store.getState());
              if (Fe[ze])
                return (0, pe.getMetricsLastEntry)(Fe, ze, fe.MetricType.DownloadedAdaptationSet).value;
            }
            return {};
          }, Ye.prototype.getDownloadedVideoData = function() {
            var ze = this.getDownloadedData(ve.MediaType.Video), Fe = !0;
            return ze.hasOwnProperty("isAuto") && (Fe = ze.isAuto), ze && (ze.bitrate || ze.id) ? { id: ze.id, bitrate: ze.bitrate, height: ze.height, width: ze.width, isAuto: Fe } : { id: "", bitrate: 0, height: 0, width: 0, isAuto: !0 };
          }, Ye.prototype.getDownloadedAudioData = function() {
            var ze = this.getDownloadedData(ve.MediaType.Audio), Fe = !0;
            return ze.hasOwnProperty("isAuto") && (Fe = ze.isAuto), ze && (ze.bitrate || ze.id) ? { id: ze.id, bitrate: ze.bitrate, isAuto: Fe } : { id: "", bitrate: 0, isAuto: !0 };
          }, Ye.prototype.getPlaybackVideoData = function() {
            var ze = this.playerController.getPlaybackRepresentation(ve.MediaType.Video) || {}, Fe = isNaN(ze._height) ? 0 : Number(ze._height), ot = isNaN(ze._width) ? 0 : Number(ze._width), vt = { id: ze._id + "", bitrate: Number(ze._bandwidth) || 0, frameRate: ze._frameRate, height: Fe, width: ot, uid: ze.uid };
            return ze._codecs && (vt.codec = Se.CodecStringHelper.getExtractedCodecStrings(ze._codecs).video), vt;
          }, Ye.prototype.getPlaybackAudioData = function() {
            var ze = this.playerController.getPlaybackRepresentation(ve.MediaType.Audio) || {}, Fe = { id: ze._id + "", bitrate: Number(ze._bandwidth) };
            return ze._codecs && (Fe.codec = Se.CodecStringHelper.getExtractedCodecStrings(ze._codecs).audio), Fe;
          }, Ye.prototype.setQueryParameters = function(ze) {
            this.settings.QUERY_PARAMETERS = ze;
          }, Ye.prototype.clearQueryParameters = function() {
            this.settings.QUERY_PARAMETERS = void 0;
          }, Ye.prototype.restoreAfterTimeShift = function(ze) {
            this.playerStateService && this.playerStateService.isTimeShifting() && (this.playerStateService.transitionToTimeShiftedState(ze), this.timeShiftJumpStart = -1);
          }, Ye.prototype.onTimeShiftFailed = function() {
            this.restoreAfterTimeShift(!1);
          }, Ye.prototype.onTimeShifted = function(ze) {
            this.restoreAfterTimeShift(ze !== be.STARTUP_ISSUER_NAME);
          }, Ye.prototype.getMaxTimeShift = function() {
            if (this.isLive() && this.isReady())
              return this.config.playback && this.config.playback.timeShift === !1 ? 0 : this.playerController.getMaxTimeShift();
          }, Ye.prototype.timeShift = function(ze, Fe) {
            var ot = this;
            if (this.isReady() && this.getMaxTimeShift() <= 0) {
              this.timeShiftJumpStart === -1 && (this.timeShiftJumpStart = this.getCurrentTime(), this.timeShiftJumpStart === 0 && (this.timeShiftJumpStart = this.playerController.getTimeShiftLiveEdge())), this.ensureSeekedOrTimeshiftedSubscription();
              var vt = this.playerController.getPlaybackTimeForTimeShiftOffset(ze);
              this.playerStateService.transitionToTimeShiftingState(this.timeShiftJumpStart, vt, Fe || "api", Fe !== be.STARTUP_ISSUER_NAME), this.playerController.timeShift(ze, function() {
                return ot.onTimeShifted(Fe);
              }).catch(function() {
                return ot.onTimeShiftFailed();
              });
            }
          }, Ye.prototype.getTimeShift = function() {
            return this.isReady() ? this.playerController.getTimeShift() : 0;
          }, Ye.prototype.addSubtitle = function(ze) {
            var Fe = this;
            return this.isReady() && this.subtitleService ? Promise.resolve(void 0).then(function() {
              Fe.subtitleService.addExternalSubtitle(ze);
            }) : Promise.reject(void 0);
          }, Ye.prototype.removeSubtitle = function(ze) {
            this.isReady() && this.subtitleService && this.subtitleService.removeSubtitle(ze);
          }, Ye.prototype.enableSubtitle = function(ze) {
            return this.isReady() && this.subtitleService ? this.subtitleService.enableSubtitle(ze) : Promise.resolve(!1);
          }, Ye.prototype.disableSubtitle = function(ze) {
            return this.isReady() && this.subtitleService ? this.subtitleService.disableSubtitle(ze) : Promise.resolve(!1);
          }, Ye.prototype.listSubtitles = function() {
            return this.isReady() && this.subtitleService && this.playerController ? this.subtitleService.getAvailableSubtitles(this.getCurrentPlayingPeriodId()) : [];
          }, Ye.prototype.setAudio = function(ze) {
            var Fe = this;
            if (this.isReady() && this.playerController && typeof ze == "string") {
              var ot = this.getAudio();
              if (ot && ot.id === String(ze))
                return;
              this.playerController.setAudio(ze).then(function() {
                var vt = Fe.getAudio();
                vt && ot && vt.id !== ot.id && Fe.context.eventHandler.dispatchEvent(oe.PlayerEvent.AudioChanged, { targetAudio: vt, sourceAudio: ot, time: Fe.renderer.getCurrentTime() });
              }).catch(function(vt) {
                Fe.logger.debug("setAudio failed for lang ", vt);
              });
            }
          }, Ye.prototype.getAvailableAudio = function() {
            return this.isReady() && this.playerController ? this.playerController.getAvailableAudio(this.getCurrentPlayingPeriodId()).map(this.mapLangObjectToAudioTrack) : [];
          }, Ye.prototype.getAudio = function() {
            if (this.isReady() && this.playerController) {
              var ze = this.playerController.getAudio();
              if (ze)
                return this.mapLangObjectToAudioTrack(ze);
            }
            return null;
          }, Ye.prototype.getManifest = function() {
            var ze = this.manifestService.getManifest();
            if (ze)
              return ze._isHls ? this.getHlsManifest() : ze.originalDashManifest;
          }, Ye.prototype.getHlsManifest = function() {
            return Ee.ModuleManager.get(we.ModuleName.HLS).selectors.getHlsState(this.getSourceStoreService().getState()).masterPlaylist.string;
          }, Ye.prototype.getBufferedRanges = function() {
            var ze = this.playerController.getBufferedRanges(!0);
            return he.BufferRangeHelper.getCommonBufferedRanges(ze).map(function(Fe) {
              return { start: Fe.getStart(), end: Fe.getEnd() };
            });
          }, Ye.prototype.getSnapshot = function(ze, Fe) {
            if (this.isPlaying() || this.isPaused())
              return this.renderer.getSnapshotData(ze, Fe);
          }, Ye.prototype.setPlaybackSpeed = function(ze, Fe, ot) {
            Fe === void 0 && (Fe = 1), ot === void 0 && (ot = !0), this.renderer.setPlaybackSpeed(ze * Fe), this.playerStateService.playbackSpeed !== this.renderer.getPlaybackSpeed() && this.playerStateService.setPlaybackSpeed(ze, Fe, ot);
          }, Ye.prototype.getPlaybackSpeed = function() {
            return this.playerStateService.playbackSpeed;
          }, Ye.prototype.permitControl = function(ze) {
            this.controlPermitted = ze;
          }, Ye.prototype.getSeekableRange = function() {
            return this.isLive() && !this.settings.ENABLE_SEEK_FOR_LIVE || !this.playerController ? { start: -1, end: -1 } : this.playerController.getSeekableRange();
          }, Ye.prototype.createManifestApi = function() {
            return Be.MediaPlayerManifestApiFactory.create(this, this.context);
          }, Ye.prototype.handleDvrWindowExceeded = function() {
            var ze = this.playerController.getTimeShiftHandler(), Fe = this.getMaxTimeShift() + ze.getMinSegmentDuration(), ot = this.playerController.getPlaybackTimeForTimeShiftOffset(Fe), vt = ze.isTimeInBufferedRange(ot);
            this.context.logger.debug("Handling DVRWindowExceeded - TimeShifting to ".concat(vt ? Fe : "live edge")), this.timeShift(vt ? Fe : 0);
          }, Ye.prototype.getLatency = function() {
            return this.liveLatencyService.getLatency();
          }, Ye.prototype.setTargetLatency = function(ze) {
            var Fe = Math.abs(this.manifestService.getTimeShiftBufferDepthSeconds());
            ze > Fe && (ze = Fe, this.logger.debug("Tried to set target latency outside DVR window, corrected to lower bound", Fe)), this.context.eventHandler.dispatchEvent(oe.PlayerEvent.TargetLatencyChanged, { from: this.liveLatencyService.getTargetLatency(), to: ze }), this.liveLatencyService.setTargetLatency(ze);
          }, Ye.prototype.getTargetLatency = function() {
            return this.liveLatencyService.getTargetLatency();
          }, Ye.prototype.setCatchupConfig = function(ze) {
            this.liveLatencyService.setCatchupConfig(ze);
          }, Ye.prototype.getCatchupConfig = function() {
            return this.liveLatencyService.getCatchupConfig();
          }, Ye.prototype.setFallbackConfig = function(ze) {
            this.liveLatencyService.setFallbackConfig(ze);
          }, Ye.prototype.getFallbackConfig = function() {
            return this.liveLatencyService.getFallbackConfig();
          }, Ye.prototype.release = function(ze) {
            var Fe, ot = this;
            return this.eventHandler.off(oe.PlayerEvent.PeriodSwitch, this.onPeriodSwitch), this.eventHandler.off(oe.PlayerEvent.PeriodSwitched, this.fireAudioTracksAdded), this.eventHandler.off(oe.PlayerEvent.PlaybackSpeedChanged, this.onPlaybackSpeedChanged), this.unsubscribeStorePlayingListener(), (Fe = this.unsubscribeToSeekedOrTimeshifted) === null || Fe === void 0 || Fe.call(this), this.unload(ze).then(function() {
              return ot.playerStateService = null, ot.playerController = (0, se.dispose)(ot.playerController), ot.renderer.release().then(function() {
                return ot.renderer = null;
              });
            });
          }, Ye.prototype.clearStallEndedSubscription = function() {
            this.unsubscribeFromStallEnded && (this.unsubscribeFromStallEnded(), this.unsubscribeFromStallEnded = void 0);
          }, Ye.prototype.ensureSeekedOrTimeshiftedSubscription = function() {
            var ze = this;
            !this.unsubscribeToSeekedOrTimeshifted && this.context.store && (this.unsubscribeToSeekedOrTimeshifted = (0, ye.subscribeToSeekedOrTimeshifted)(this.context.store, function() {
              var Fe;
              (Fe = ze.unsubscribeToSeekedOrTimeshifted) === null || Fe === void 0 || Fe.call(ze), ze.unsubscribeToSeekedOrTimeshifted = void 0, ze.canResumeLatencyControl() ? ze.resumeLatencyControl() : ze.suspendLatencyControl();
            }));
          }, Ye.prototype.getCurrentPlayingPeriodId = function() {
            return (0, ke.getPlayingPeriodId)(this.getSourceStoreService().getState());
          }, Ye.prototype.updateCallback = function(ze) {
          }, Ye.prototype.onFullscreenEnter = function() {
          }, Ye.prototype.onFullscreenExit = function() {
          }, Ye.prototype.isAirplayAvailable = function() {
            return !1;
          }, Ye.prototype.isAirplayActive = function() {
            return !1;
          }, Ye.prototype.showAirplayTargetPicker = function() {
          }, Ye;
        }();
        function Je(Ye) {
          return Ye === be.ADVERTISING_ISSUER_NAME || Ye === be.ADVERTISING_RESTORE_ISSUER_NAME;
        }
        function Ge(Ye, ze) {
          if (!Ee.ModuleManager.has(we.ModuleName.RendererMse) || !Ye.videoElement)
            return !1;
          for (var Fe = Ee.ModuleManager.get(we.ModuleName.RendererMse).Ranges, ot = Ye.settings.MIN_SIZE_FOR_GAP_SKIPPING, vt = Fe.findGaps(Ye.videoElement.buffered, ot), gt = 0.1, yt = !1, pt = 0; pt < vt.length; pt++) {
            var bt = vt.end(pt) + Fe.TIME_FUDGE_FACTOR;
            Math.abs(bt - ze) <= gt && (yt = !0);
          }
          return yt;
        }
        ne.MediaPlayer = tt;
      }, 86674: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.calculateDownloadRates = ce, ne.filterValuesExceedingAverageByMargin = he, ne.calcAverage = _e, ne.bpsToMbps = le;
        var ae = ie(40392);
        function ce(se) {
          return se.map(function(oe) {
            return (0, ae.bytesToBits)(oe.bytes) / oe.downloadDuration;
          }).filter(function(oe) {
            return oe < 1 / 0;
          });
        }
        function he(se) {
          var oe = _e(se) * 1.1;
          return se.filter(function(ue) {
            return ue <= oe;
          });
        }
        function _e(se) {
          return se.reduce(function(oe, ue) {
            return oe + ue;
          }, 0) / se.length;
        }
        function le(se) {
          return se / 1024 / 1024;
        }
      }, 87062: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.isLowLatencyConfigured = ce;
        var ae = ie(18665);
        function ce(he) {
          var _e = he.serviceManager.get(ae.ServiceName.LiveLatencyService);
          return (_e == null ? void 0 : _e.isConfigured()) || !1;
        }
      }, 89010: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var be = function(ve, me) {
            return be = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(pe, fe) {
              pe.__proto__ = fe;
            } || function(pe, fe) {
              for (var ge in fe)
                Object.prototype.hasOwnProperty.call(fe, ge) && (pe[ge] = fe[ge]);
            }, be(ve, me);
          };
          return function(ve, me) {
            if (typeof me != "function" && me !== null)
              throw new TypeError("Class extends value " + String(me) + " is not a constructor or null");
            function pe() {
              this.constructor = ve;
            }
            be(ve, me), ve.prototype = me === null ? Object.create(me) : (pe.prototype = me.prototype, new pe());
          };
        }();
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.StringTimeProvider = ne.HttpHeadTimeProvider = ne.HttpGetTimeProvider = ne.HttpTimeProvider = ne.ServerTimeProvider = void 0;
        var ce = ie(88005), he = ie(67345), _e = function() {
          function be(ve) {
            this.timeDecoder = ve;
          }
          return be;
        }();
        ne.ServerTimeProvider = _e;
        var le = function(be) {
          function ve(me, pe) {
            var fe = be.call(this, pe) || this;
            return fe.context = me, fe;
          }
          return ae(ve, be), ve.prototype.sendSingleRequest = function(me) {
            var pe = this, fe = me.shift();
            return fe ? (this.currentContentLoader = new ce.DefaultContentLoader(this.context, { requestType: he.HttpRequestType.TIME_SYNC, maxRetries: 1 }), this.currentContentLoader.load(fe, this.requestMethod).then(function(ge) {
              var ye = pe.timeDecoder.decode(pe.processResponse(ge));
              return pe.currentContentLoader = void 0, isNaN(ye) ? Promise.reject(new Error("Failed to decode time")) : Promise.resolve(ye);
            }).catch(function(ge) {
              return pe.context.logger.debug("could not load UTC time url", ge), pe.sendSingleRequest(me);
            })) : Promise.reject(new Error("No time source left to try"));
          }, ve.prototype.requestTime = function(me) {
            var pe = this, fe = me.match(/\S+/g);
            return fe ? this.sendSingleRequest(fe).then(function(ge) {
              return pe.currentContentLoader = void 0, ge;
            }) : Promise.reject(new Error("No time source left to try"));
          }, ve.prototype.cancelRequest = function() {
            this.currentContentLoader && this.currentContentLoader.cancel();
          }, ve;
        }(_e);
        ne.HttpTimeProvider = le;
        var se = function(be) {
          function ve(me, pe) {
            var fe = be.call(this, me, pe) || this;
            return fe.requestMethod = he.HttpRequestMethod.GET, fe;
          }
          return ae(ve, be), ve.prototype.processResponse = function(me) {
            return me.body;
          }, ve;
        }(le);
        ne.HttpGetTimeProvider = se;
        var oe = function(be) {
          function ve(me, pe) {
            var fe = be.call(this, me, pe) || this;
            return fe.requestMethod = he.HttpRequestMethod.HEAD, fe;
          }
          return ae(ve, be), ve.prototype.processResponse = function(me) {
            var pe = Object.keys(me.headers).find(function(fe) {
              return fe.toLocaleLowerCase() === "date";
            });
            return pe && me.headers[pe] || "";
          }, ve;
        }(se);
        ne.HttpHeadTimeProvider = oe;
        var ue = function(be) {
          function ve() {
            return be !== null && be.apply(this, arguments) || this;
          }
          return ae(ve, be), ve.prototype.requestTime = function(me) {
            var pe = this.timeDecoder.decode(me);
            return isNaN(pe) ? Promise.reject(new Error("Failed to decode time")) : Promise.resolve(pe);
          }, ve.prototype.cancelRequest = function() {
          }, ve;
        }(_e);
        ne.StringTimeProvider = ue;
      }, 92103: function(ee, ne) {
        function ie(le, se) {
          if (le.mediaSequence !== void 0 && se.mediaSequence !== void 0)
            return le.mediaSequence === se.mediaSequence;
          var oe = ce(le, se), ue = _e(le.byteRange, se.byteRange), be = le.discontinuitySequenceNumber === se.discontinuitySequenceNumber;
          return oe && ue && be;
        }
        function ae(le, se) {
          var oe = (le == null ? void 0 : le.url) === (se == null ? void 0 : se.url), ue = _e(le == null ? void 0 : le.byteRange, se == null ? void 0 : se.byteRange);
          return oe && ue;
        }
        function ce(le, se) {
          var oe = he(le), ue = he(se);
          return oe.some(function(be) {
            return ue.includes(be);
          });
        }
        function he(le) {
          return [le.url, le.mediaURL].filter(Boolean);
        }
        function _e(le, se) {
          return le == null ? se == null : se != null && le.start === se.start && le.end === se.end;
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.isIdenticalSegmentInfo = ie, ne.isIdenticalInitSegmentInfo = ae;
      }, 92395: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentPrefetchingService = void 0;
        var ae = ie(13788), ce = ie(28499), he = function() {
          function _e() {
            this.segmentPrefetcher = new ce.SegmentPrefetcher(this), this.prefetchedSegments = /* @__PURE__ */ new Map();
          }
          return _e.prototype.updatePlayerContext = function(le) {
            this.context = le, this.segmentPrefetcher.updateContext(this.context);
          }, _e.prototype.setDecrypter = function(le, se) {
            this.segmentPrefetcher.setDecrypter(le, se);
          }, _e.prototype.removeDecrypter = function(le) {
            this.segmentPrefetcher.removeDecrypter(le);
          }, _e.prototype.getDecrypter = function(le) {
            return this.segmentPrefetcher.getDecrypter(le);
          }, _e.prototype.hasMp4Decrypter = function(le) {
            return !!this.getDecrypter(le);
          }, _e.prototype.setShouldDownloadBeCancelledCallback = function(le, se) {
            this.segmentPrefetcher.setShouldDownloadBeCancelledCallback(le, se);
          }, _e.prototype.removeShouldDownloadBeCancelledCallback = function(le) {
            this.segmentPrefetcher.removeShouldDownloadBeCancelledCallback(le);
          }, _e.prototype.fetch = function(le) {
            var se = this;
            return this.segmentPrefetcher.prefetchSegment(le).then(function() {
              var oe = se.prefetchedSegments.get(le.mimeType).get((0, ae.getSegmentInfoId)(le));
              return oe ? Promise.resolve(oe.loadingPromise) : Promise.reject();
            });
          }, _e.prototype.fetchAll = function(le) {
            this.segmentPrefetcher.prefetchSegments(le);
          }, _e.prototype.onPrefetch = function(le) {
            var se = le.segmentInfo.mimeType;
            this.prefetchedSegments.has(se) || this.prefetchedSegments.set(se, /* @__PURE__ */ new Map()), this.prefetchedSegments.get(se).set((0, ae.getSegmentInfoId)(le.segmentInfo), le);
          }, _e.prototype.hasPrefetchedSegment = function(le) {
            return !!this.findPrefetchedSegment(le);
          }, _e.prototype.getPrefetchedSegment = function(le) {
            var se = this.findPrefetchedSegment(le);
            return se ? se.loadingPromise : null;
          }, _e.prototype.findPrefetchedSegment = function(le) {
            return this.prefetchedSegments.has(le.mimeType) && this.prefetchedSegments.get(le.mimeType).get((0, ae.getSegmentInfoId)(le)) || null;
          }, _e.prototype.getPrefetchedSegments = function() {
            return this.prefetchedSegments;
          }, _e.prototype.removePrefetchedSegment = function(le) {
            this.prefetchedSegments.has(le.mimeType) && this.prefetchedSegments.get(le.mimeType).delete((0, ae.getSegmentInfoId)(le));
          }, _e.prototype.clearPrefetchingQueue = function(le) {
            this.segmentPrefetcher.clearPrefetchingQueue(le);
          }, _e.prototype.reset = function() {
            this.segmentPrefetcher.reset(), this.prefetchedSegments.clear();
          }, _e.prototype.dispose = function() {
            this.reset(), this.segmentPrefetcher.dispose(), this.segmentPrefetcher = null, this.prefetchedSegments = null;
          }, _e;
        }();
        ne.SegmentPrefetchingService = he;
      }, 93109: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.isPlayingLowLatencyHls = le;
        var ae = ie(27279), ce = ie(91520), he = ie(16368), _e = ie(87062);
        function le(se) {
          var oe;
          if (!(0, _e.isLowLatencyConfigured)(se) || !se.settings.LL_HLS)
            return !1;
          var ue = (0, ae.getSourceState)(se);
          if (!ue)
            return !1;
          var be = ce.ModuleManager.get(he.ModuleName.HLS, !1);
          if (!be)
            return !1;
          var ve = be.selectors, me = ve.getHlsState, pe = ve.getIsLowLatencyPlaylist, fe = me(ue);
          return !!fe && (oe = pe(fe)) !== null && oe !== void 0 && oe;
        }
      }, 93326: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getMostRecentlyRefreshedQuality = ne.getSegmentInfos = ne.getSegmentMapEntry = void 0;
        var ie = function(he, _e) {
          return he == null ? void 0 : he.segmentInfoMap[_e];
        };
        ne.getSegmentMapEntry = ie;
        var ae = function(he, _e) {
          var le, se;
          return (se = (le = (0, ne.getSegmentMapEntry)(he, _e)) === null || le === void 0 ? void 0 : le.segmentInfos) !== null && se !== void 0 ? se : [];
        };
        ne.getSegmentInfos = ae;
        var ce = function(he) {
          if (he)
            return Object.values(he.segmentInfoMap).filter(function(_e) {
              return _e.qualityInfo.lastUpdateTimestamp != null;
            }).sort(function(_e, le) {
              var se = _e.qualityInfo.lastUpdateTimestamp;
              return le.qualityInfo.lastUpdateTimestamp - se;
            })[0];
        };
        ne.getMostRecentlyRefreshedQuality = ce;
      }, 94938: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(pe) {
            for (var fe, ge = 1, ye = arguments.length; ge < ye; ge++)
              for (var $e in fe = arguments[ge])
                Object.prototype.hasOwnProperty.call(fe, $e) && (pe[$e] = fe[$e]);
            return pe;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.orderAdaptationSetsByCodec = _e, ne.sortAdaptationSetsByBestCodec = se, ne.getCodecsFromAdaptationSet = oe, ne.getMimeTypeForAdaptationSet = ue, ne.removeRepresentations = be;
        var ce = ie(79814), he = ie(38925);
        function _e(pe, fe) {
          return (pe = ae({}, pe)).Period = pe.Period.map(function(ge) {
            if (!ge.AdaptationSet)
              return ae({}, ge);
            var ye = le(ge.AdaptationSet), $e = ye.videoSets, Se = ye.audioSets, Ce = ye.otherSets, Ie = se($e, fe.video), Te = {};
            return Se.forEach(function(Ee) {
              var we = Ee._lang || "none";
              Te[we] = Te[we] || [], Te[we].push(Ee);
            }), Object.keys(Te).forEach(function(Ee) {
              Ie = Ie.concat(se(Te[Ee], fe.audio));
            }), ae(ae({}, ge), { AdaptationSet: Ie.concat(Ce) });
          }), pe;
        }
        function le(pe) {
          return pe.reduce(function(fe, ge) {
            var ye = ue(ge);
            return ce.MimeTypeHelper.isVideo(ye) ? fe.videoSets.push(ge) : ce.MimeTypeHelper.isAudio(ye) ? fe.audioSets.push(ge) : fe.otherSets.push(ge), fe;
          }, { videoSets: [], audioSets: [], otherSets: [] });
        }
        function se(pe, fe) {
          var ge = function(ye) {
            for (var $e = 0; $e < fe.length; $e++)
              if (ye.indexOf(fe[$e]) === 0)
                return $e;
            return fe.length + 1;
          };
          return pe.sort(function(ye, $e) {
            return ge(oe(ye)) - ge(oe($e));
          });
        }
        function oe(pe) {
          var fe;
          if (((fe = pe == null ? void 0 : pe._codecs) === null || fe === void 0 ? void 0 : fe.length) > 0)
            return pe._codecs;
          if (pe.Representation && pe.Representation.length > 0) {
            var ge = pe.Representation[pe.Representation.length - 1];
            if (ge._codecs)
              return ge._codecs;
          }
          return "";
        }
        function ue(pe) {
          if (pe._mimeType)
            return pe._mimeType;
          if (Array.isArray(pe.Representation)) {
            var fe = pe.Representation.find(function(ge) {
              return ge._mimeType;
            });
            if (fe)
              return fe._mimeType;
          }
          return "";
        }
        function be(pe, fe) {
          if (!(pe.Period && pe.Period.length > 0) || fe.length === 0)
            return pe;
          var ge = pe.Period.map(function(ye) {
            return ve(ye, fe);
          }).filter(function(ye) {
            return ye.AdaptationSet.length > 0;
          });
          return ae(ae({}, pe), { Period: ge });
        }
        function ve(pe, fe) {
          var ge = pe.AdaptationSet.map(function(ye) {
            return me(ye._internalId, ye, fe);
          }).filter(function(ye) {
            return ye.Representation.length > 0;
          });
          return ae(ae({}, pe), { AdaptationSet: ge });
        }
        function me(pe, fe, ge) {
          var ye = fe.Representation.filter(function($e) {
            return !ge.some(function(Se) {
              return Se.equals(new he.RepresentationId(pe, $e._id));
            });
          });
          return ae(ae({}, fe), { Representation: ye });
        }
      }, 96280: function(ee, ne, ie) {
        var ae, ce = this && this.__assign || function() {
          return ce = Object.assign || function(ve) {
            for (var me, pe = 1, fe = arguments.length; pe < fe; pe++)
              for (var ge in me = arguments[pe])
                Object.prototype.hasOwnProperty.call(me, ge) && (ve[ge] = me[ge]);
            return ve;
          }, ce.apply(this, arguments);
        }, he = this && this.__spreadArray || function(ve, me, pe) {
          if (pe || arguments.length === 2)
            for (var fe, ge = 0, ye = me.length; ge < ye; ge++)
              !fe && ge in me || (fe || (fe = Array.prototype.slice.call(me, 0, ge)), fe[ge] = me[ge]);
          return ve.concat(fe || Array.prototype.slice.call(me));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SegmentInfoMapReducer = void 0;
        var _e = ie(21829), le = ie(41661), se = ie(85157), oe = {};
        function ue(ve, me, pe) {
          var fe;
          return ce(ce({}, ve), ((fe = {})[me] = pe, fe));
        }
        function be(ve, me, pe) {
          var fe;
          if (!ve[me] || pe.segmentInfos.length === 0)
            return ue(ve, me, pe);
          var ge = ve[me].segmentInfos, ye = ge.findIndex(function(Ee) {
            return (0, le.areSegmentsIdentical)(Ee, pe.segmentInfos[0]);
          });
          if (ye === -1)
            return ue(ve, me, pe);
          var $e, Se = ge.length - ye, Ce = pe.segmentInfos.length - Se;
          if (ye !== 0 || Ce !== 0) {
            var Ie = Ce > 0 ? pe.segmentInfos.slice(-Ce) : [];
            $e = he(he([], ge.slice(ye), !0), Ie, !0);
          } else
            $e = ge;
          var Te = ce(ce(ce({}, ve[me]), pe), { segmentInfos: $e });
          return ce(ce({}, ve), ((fe = {})[me] = Te, fe));
        }
        ne.SegmentInfoMapReducer = (0, _e.default)(oe, ((ae = {})[se.SegmentInfoMapActionType.SetSegmentInfos] = function(ve, me) {
          return ue(ve, me.payload.qualityPath, me.payload.updatedEntry);
        }, ae[se.SegmentInfoMapActionType.UpdateSegmentInfos] = function(ve, me) {
          return be(ve, me.payload.qualityPath, me.payload.updatedEntry);
        }, ae));
      }, 96707: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.createSegmentParser = _e;
        var ae = ie(91520), ce = ie(16368), he = ie(73543);
        function _e(le, se) {
          if (se === he.ContainerFormat.MP4 && ae.ModuleManager.has(ce.ModuleName.ContainerMP4)) {
            var oe = ae.ModuleManager.get(ce.ModuleName.ContainerMP4);
            return new oe.MP4Parser(le, new oe.MP4EncryptionParser(le));
          }
          if (se === he.ContainerFormat.WEBM && ae.ModuleManager.has(ce.ModuleName.ContainerWebM))
            return new (ae.ModuleManager.get(ce.ModuleName.ContainerWebM)).WebMParser();
        }
      }, 96953: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.PeriodId = void 0;
        var ie = function() {
          function ae(ce) {
            this._periodId = ce;
          }
          return Object.defineProperty(ae.prototype, "periodId", { get: function() {
            return this._periodId;
          }, enumerable: !1, configurable: !0 }), ae.prototype.equals = function(ce) {
            return ce != null && this.periodId === ce.periodId;
          }, ae.prototype.key = function() {
            return this.periodId;
          }, ae;
        }();
        ne.PeriodId = ie;
      }, 98086: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.PlayingTracksActionKey = void 0, function(ae) {
          ae.SetPlayingPeriodId = "@instance/sources/@source/playingTracks/setPlayingPeriodId", ae.FinishedPeriodSwitch = "@instance/sources/@source/playingTracks/periodSwitchFinished", ae.StartedPeriodSwitch = "@instance/sources/@source/playingTracks/periodSwitchStarted";
        }(ie || (ne.PlayingTracksActionKey = ie = {}));
      }, 99162: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.AbstractUpdater = ne.REPRESENTATION_UPDATE_CANCEL = void 0, ne.calculateUpdateDelayInMillis = le;
        var ae = ie(10981), ce = ie(331);
        ne.REPRESENTATION_UPDATE_CANCEL = "CANCEL";
        var he = 2147483647, _e = function() {
          function se(oe) {
            var ue = this;
            this.updateCallbacks = oe, this.handlePayloadUpdateError = function(be) {
              ue.publishErrorResponse(be), ue.clearTimeout();
            }, this.processPayload = function(be) {
              ue.success(be), ue.clearTimeout(), ue._isStopped || ue.scheduleUpdate();
            }, this._isStopped = !1;
          }
          return se.prototype.cancel = function() {
            this._updateDeferred && (this._updateDeferred.reject(ne.REPRESENTATION_UPDATE_CANCEL), this.updateCallbacks.error(ne.REPRESENTATION_UPDATE_CANCEL)), this.clearTimeout();
          }, se.prototype.clearTimeout = function() {
            window.clearTimeout(this.updateTimeoutId), this.updateTimeoutId = null;
          }, se.prototype.stop = function() {
            this.updateTimeoutId !== null && (this._isStopped = !0, this.cancel());
          }, se.prototype.start = function() {
            this._isStopped = !1, this.scheduleUpdate();
          }, se.prototype.scheduleUpdate = function() {
            this.updateTimeoutId || this._isStopped || this.initializeUpdate();
          }, se.prototype.initializeUpdate = function() {
            var oe = this, ue = le(this.getLastReloadTimestamp(), this.getReloadIntervalInSeconds());
            if (!(ue > he)) {
              var be = new ae.Deferred(), ve = { wasInvalidated: function() {
                return be !== oe._updateDeferred;
              } };
              be.promise.catch(function() {
              }), this._updateDeferred = be, this.updateTimeoutId = window.setTimeout(function() {
                return oe.payloadUpdate(ve);
              }, ue);
            }
          }, se.prototype.payloadUpdate = function(oe) {
            var ue = this;
            this.update().then(function(be) {
              oe.wasInvalidated() || ue.processPayload(be);
            }).catch(function(be) {
              oe.wasInvalidated() || ue.handlePayloadUpdateError(be);
            });
          }, se.prototype.publishErrorResponse = function(oe) {
            this._updateDeferred.reject(oe), this.updateCallbacks.error(oe);
          }, se.prototype.success = function(oe) {
            this._updateDeferred.resolve(oe), this.updateCallbacks.success(oe);
          }, Object.defineProperty(se.prototype, "isStopped", { get: function() {
            return this._isStopped;
          }, enumerable: !1, configurable: !0 }), se.prototype.getPayload = function() {
            return this._updateDeferred.promise;
          }, se;
        }();
        function le(se, oe) {
          if (isNaN(oe))
            return 0;
          var ue = (0, ce.toSeconds)(Date.now() - se);
          return ue >= oe ? 0 : (0, ce.toMilliSeconds)(oe - ue);
        }
        ne.AbstractUpdater = _e;
      } }, function(ee) {
        return function(ne) {
          return ee(ee.s = ne);
        }(44910);
      }]);
    });
  })();
})(bitmovinplayerEngineBitmovin);
var bitmovinplayerEngineBitmovinExports = bitmovinplayerEngineBitmovin.exports;
const BitmovinEngineModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerEngineBitmovinExports);
var bitmovinplayerEngineNative = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ne) {
      re.exports = ne();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[855], { 526: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.AppleAirplayService = ne.isAirplaySupported = void 0;
        var ae, ce = ie(62510), he = ie(46462);
        (function(se) {
          se.Available = "available", se.NotAvailable = "not-available";
        })(ae || (ae = {}));
        var _e = function() {
          return !!window.WebKitPlaybackTargetAvailabilityEvent;
        };
        ne.isAirplaySupported = _e;
        var le = function() {
          function se(oe, ue) {
            var be = this;
            this.videoElement = oe, this.eventHandler = ue, this.airplayAvailable = !1, this.onWebkitPlaybackTargetAvailabilityChanged = function(ve) {
              switch (ve.availability) {
                case ae.Available:
                  be.airplayAvailable = !0, be.eventHandler.dispatchEvent(ce.PlayerEvent.AirplayAvailable);
                  break;
                case ae.NotAvailable:
                  be.airplayAvailable = !1;
              }
            }, this.onWebkitPlaybackTargetIsWirelessChanged = function() {
              be.eventHandler.dispatchEvent(ce.PlayerEvent.AirplayChanged, { airplayEnabled: be.isAirplayActive(), time: be.videoElement.currentTime });
            }, this.initAirplay();
          }
          return se.prototype.initAirplay = function() {
            this.videoElement.setAttribute("x-webkit-airplay", "allow"), this.videoElement.addEventListener(he.MediaElementEvent.webkitplaybacktargetavailabilitychanged, this.onWebkitPlaybackTargetAvailabilityChanged), this.videoElement.addEventListener(he.MediaElementEvent.webkitcurrentplaybacktargetiswirelesschanged, this.onWebkitPlaybackTargetIsWirelessChanged);
          }, se.prototype.isAirplayAvailable = function() {
            return this.airplayAvailable;
          }, se.prototype.isAirplayActive = function() {
            return this.videoElement.isAirplayActive();
          }, se.prototype.showAirplayTargetPicker = function() {
            this.isAirplayAvailable() && (this.videoElement.webkitShowPlaybackTargetPicker(), this.eventHandler.dispatchEvent(ce.PlayerEvent.ShowAirplayTargetPicker));
          }, se.prototype.dispose = function() {
            this.videoElement.removeEventListener(he.MediaElementEvent.webkitplaybacktargetavailabilitychanged, this.onWebkitPlaybackTargetAvailabilityChanged), this.videoElement.removeEventListener(he.MediaElementEvent.webkitcurrentplaybacktargetiswirelesschanged, this.onWebkitPlaybackTargetIsWirelessChanged);
          }, se;
        }();
        ne.AppleAirplayService = le;
      }, 9183: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HlsDownloadService = void 0;
        var ae = ie(63546), ce = ie(35148), he = ie(62510), _e = ie(88005), le = ie(67345), se = function() {
          function oe(ue) {
            var be = this;
            this.useCredentialsForManifestRequests = !1, this.downloadFailureHandler = function(ve) {
              be.context.eventHandler.dispatchEvent(he.PlayerEvent.Warning, new ae.PlayerWarning(ce.WarningCode.NETWORK_COULD_NOT_LOAD_MANIFEST)), be.context.logger.debug("Could not load manifest, got HTTP status code " + ve.status);
            }, this.context = ue, this.init();
          }
          return oe.prototype.init = function() {
            this.initCache(), this.initUseCredentialsForManifest();
          }, oe.prototype.initCache = function() {
            this.requestCache = {};
          }, oe.prototype.initUseCredentialsForManifest = function() {
            var ue = this.context.sourceContext.source && this.context.sourceContext.source.options || {};
            this.useCredentialsForManifestRequests = typeof ue.hlsManifestWithCredentials == "boolean" ? ue.hlsManifestWithCredentials : ue.manifestWithCredentials === !0;
          }, oe.prototype.downloadPlaylist = function(ue, be, ve) {
            return ve === void 0 && (ve = !0), ve && this.requestCache.hasOwnProperty(ue) ? Promise.resolve(this.requestCache[ue]) : this.download(be, ue);
          }, oe.prototype.download = function(ue, be) {
            var ve = this, me = this.getContentLoader(ue);
            return me.load(be, le.HttpRequestMethod.GET, le.HttpResponseType.TEXT, null, {}, this.useCredentialsForManifestRequests).then(function(pe) {
              return me.dispose(), ve.requestCache[be] = pe, pe;
            }).catch(function(pe) {
              return me.dispose(), Promise.reject(pe);
            });
          }, oe.prototype.getContentLoader = function(ue) {
            return new _e.DefaultContentLoader(this.context, { onFailure: this.downloadFailureHandler, maxRetries: this.context.settings.MAX_MPD_RETRIES, requestType: ue });
          }, oe.prototype.dispose = function() {
          }, oe;
        }();
        ne.HlsDownloadService = se;
      }, 42966: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.NativeModuleDefinition = void 0;
        var ae = ie(16368), ce = ie(72273), he = ie(96926);
        ne.NativeModuleDefinition = { name: ae.ModuleName.EngineNative, module: { NativePlayer: ce.NativePlayer, technologyChecker: new he.TechnologyChecker() } }, ne.default = ne.NativeModuleDefinition;
      }, 55194: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.NativePlayerManifestApiFactory = void 0;
        var ae = ie(42283), ce = function() {
          function he() {
          }
          return he.create = function(_e) {
            var le = _e.getParsedManifest();
            return _e.isValidMasterPlaylist(le) ? new (function() {
              function se() {
                this.hls = he.createHlsApi(_e);
              }
              return se;
            }())() : null;
          }, he.createHlsApi = function(_e) {
            var le = _e.getParsedManifest(), se = le.media.filter(function(ue) {
              return ue.attributes.TYPE === "AUDIO";
            }), oe = le.media.filter(function(ue) {
              return ue.attributes.TYPE === "SUBTITLES" || ue.attributes.TYPE === "CLOSED-CAPTIONS";
            });
            return new (function() {
              function ue() {
                this.properties = _e.getParsedManifest().tags;
              }
              return ue.prototype.getVideoTracks = function() {
                return he.getVideoTracks(le.playlists);
              }, ue.prototype.getAudioTracks = function() {
                return he.getAudioTracks(se, le.playlists);
              }, ue.prototype.getTextTracks = function() {
                return he.getTextTracks(oe);
              }, ue;
            }())();
          }, he.getAudioTracks = function(_e, le) {
            var se = _e.reduce(function(be, ve) {
              return be[ve.attributes.LANGUAGE] || (be[ve.attributes.LANGUAGE] = ve.attributes.NAME), be;
            }, {}), oe = Object.keys(se).map(function(be, ve) {
              return { id: "audio-".concat(ve), label: se[be], lang: be, getQualities: function() {
                return _e.filter(function(me) {
                  return me.attributes.LANGUAGE === be;
                }).map(function(me, pe) {
                  return { id: pe + "", bitrate: 0, label: me.attributes.NAME };
                });
              } };
            }), ue = function(be) {
              return be.attributes.CODECS && ae.CodecStringHelper.getMimeTypeForCodecString(be.attributes.CODECS).includes("audio");
            };
            return le.some(ue) && oe.push({ id: "audio-".concat(oe.length), label: "und", lang: "", getQualities: function() {
              return le.filter(ue).map(function(be, ve) {
                return { id: ve + "", bitrate: be.attributes.BANDWIDTH, codec: ae.CodecStringHelper.getExtractedCodecStrings(be.attributes.CODECS).audio };
              });
            } }), oe;
          }, he.getVideoTracks = function(_e) {
            var le = function(oe) {
              return !oe.attributes.CODECS || ae.CodecStringHelper.getMimeTypeForCodecString(oe.attributes.CODECS).includes("video");
            }, se = _e.filter(le);
            return [{ id: "video-0", label: "und", getQualities: function() {
              return he.getVideoQualities(se);
            } }];
          }, he.getTextTracks = function(_e) {
            return _e.map(function(le, se) {
              return { id: "text-".concat(se), label: le.attributes.NAME, lang: le.attributes.LANGUAGE, isFragmented: !0, kind: le.attributes.TYPE === "CLOSED-CAPTIONS" ? "caption" : "subtitle", url: le.attributes.URI };
            });
          }, he.getVideoQualities = function(_e) {
            return _e.map(function(le) {
              var se = le.attributes.RESOLUTION && le.attributes.RESOLUTION.width, oe = le.attributes.RESOLUTION && le.attributes.RESOLUTION.height, ue = { id: oe ? "".concat(oe, "_").concat(le.attributes.BANDWIDTH) : "".concat(le.attributes.BANDWIDTH), bitrate: le.attributes.BANDWIDTH, width: se || 0, height: oe || 0 };
              if (le.attributes.CODECS) {
                var be = ae.CodecStringHelper.getExtractedCodecStrings(le.attributes.CODECS);
                be.video && (ue.codec = be.video);
              }
              return ue;
            });
          }, he;
        }();
        ne.NativePlayerManifestApiFactory = ce;
      }, 60012: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HlsLiveNativeTimeTracker = void 0;
        var ae = ie(15539), ce = ie(331), he = ie(54838), _e = ie(46462), le = 2e3, se = function() {
          function oe(ue, be) {
            this.nativePlayer = ue, this.context = be, this.timeAdjustment = 0, this.unloadTimestamp = null, this.startDate = null;
          }
          return oe.prototype.onUnload = function(ue) {
            ue === ae.ADVERTISING_ISSUER_NAME && this.context.settings.RESUME_LIVE_CONTENT_AT_PREVIOUS_POSITION_AFTER_AD_BREAK && this.unloadTimestamp == null && (this.nativePlayer.isLive() ? (this.unloadTimestamp = Date.now(), this.timeAdjustment = this.nativePlayer.getSeekableRange().start, this.startDate = this.nativePlayer.getStartDate()) : this.reset());
          }, oe.prototype.reset = function() {
            this.unloadTimestamp = null, this.timeAdjustment = 0, this.startDate = null;
          }, oe.prototype.adjustTargetTime = function(ue, be) {
            var ve = this;
            return be !== ae.ADVERTISING_RESTORE_ISSUER_NAME || this.unloadTimestamp == null ? (this.context.logger.debug("No adjustments are made", this.unloadTimestamp), Promise.resolve(ue)) : (this.startDate != null ? this.waitForStartDate() : Promise.resolve(null)).then(function(me) {
              if (me != null) {
                ve.context.logger.debug("StartDate progressed from ".concat(ve.startDate, " to: ").concat(me, " during the ad"));
                var pe = he.Util.timeInSeconds(me) - he.Util.timeInSeconds(ve.startDate);
                ve.timeAdjustment = pe;
              } else {
                ve.context.logger.debug("Adjusting time based on seekable range");
                var fe = (0, ce.toSeconds)(Date.now() - ve.unloadTimestamp);
                ve.timeAdjustment += fe;
              }
              var ge = ue - ve.timeAdjustment;
              return ve.context.logger.debug("Adjusting target time from ".concat(ue, " by ").concat(ve.timeAdjustment, " to ").concat(ge)), ve.reset(), ge;
            });
          }, oe.prototype.waitForStartDate = function() {
            var ue = this, be = this.getValidDateTime();
            return be ? Promise.resolve(be) : new Promise(function(ve) {
              var me = null, pe = function() {
                ve(ue.getValidDateTime()), ue.context.videoElement.removeEventListener(_e.MediaElementEvent.loadeddata, pe), clearTimeout(me);
              };
              ue.context.logger.debug("Waiting for video.startDate to be valid"), ue.context.videoElement.addEventListener(_e.MediaElementEvent.loadeddata, pe), me = setTimeout(pe, le);
            });
          }, oe.prototype.getValidDateTime = function() {
            var ue = this.nativePlayer.getStartDate();
            return ue && !isNaN(ue.getTime()) ? ue : null;
          }, oe;
        }();
        ne.HlsLiveNativeTimeTracker = se;
      }, 62545: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.AssetAvailabilityChecker = void 0;
        var ae = ie(88005), ce = ie(67345), he = ie(331), _e = ie(46462), le = function() {
          function se(oe, ue, be) {
            var ve = this;
            this.context = oe, this.source = ue, this.mediaElement = be, this.scheduleAvailabilityCheck = function() {
              ve.mediaElement.removeEventListener(_e.MediaElementEvent.loadstart, ve.scheduleAvailabilityCheck);
              var me = (0, he.toMilliSeconds)(ve.context.settings.XHR_TIMEOUT) / 2;
              ve.assetAvailabilityCheckTimeoutID = window.setTimeout(function() {
                ve.context.logger.debug("Asset loading has not resolved after ".concat((0, he.toSeconds)(me), "s. Checking accessibility."));
                var pe = !1, fe = function(ge) {
                  var ye;
                  ge.loadedBytes > 0 && (pe = !0, (ye = ve.contentLoader) === null || ye === void 0 || ye.cancel());
                };
                ve.contentLoader = new ae.DefaultContentLoader(ve.context, { onProgress: fe, requestType: ce.HttpRequestType.INTERNAL }), ve.contentLoader.load(ve.source.src).catch(function(ge) {
                  if (!pe) {
                    ve.context.logger.debug("Forcing error event as the asset was not accessible.", ge);
                    var ye = new Event(_e.MediaElementEvent.error, { bubbles: !1, cancelable: !1 });
                    ve.source.dispatchEvent(ye);
                  }
                });
              }, me);
            }, be.addEventListener(_e.MediaElementEvent.loadstart, this.scheduleAvailabilityCheck);
          }
          return se.prototype.dispose = function() {
            this.assetAvailabilityCheckTimeoutID && window.clearTimeout(this.assetAvailabilityCheckTimeoutID), this.mediaElement.removeEventListener(_e.MediaElementEvent.loadstart, this.scheduleAvailabilityCheck), this.contentLoader && (this.contentLoader.cancel(), this.contentLoader.dispose());
          }, se;
        }();
        ne.AssetAvailabilityChecker = le;
      }, 69860: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HlsDownloadErrorHandler = void 0;
        var ae = ie(25550), ce = ie(28764), he = ie(88005), _e = ie(23234), le = ie(67345), se = ie(13533), oe = ie(46462), ue = function() {
          function be(ve, me) {
            var pe = this;
            this.fakeProgress = function() {
              for (var fe = pe.video.buffered, ge = "", ye = 0; ye < fe.length; ye++)
                ge += "".concat(fe.start(ye), " - ").concat(fe.end(ye), ", ");
              ge === pe.lastProgressString ? pe.numProgressNotChanged++ : pe.numProgressNotChanged = 0, pe.numProgressNotChanged >= 10 && pe.onStalled(), pe.lastProgressString = ge;
            }, this.fakeWaiting = function() {
              var fe = _e.TimingUtil.getHiResTimestamp(), ge = !pe.video.paused && !pe.video.seeking && !pe.video.ended;
              fe - pe.lastTimeUpdateTimeStamp > 5 && ge && pe.onWaiting();
            }, this.onStalled = function() {
              pe.stalledTimeStamp = _e.TimingUtil.getHiResTimestamp(), pe.checkStalledState();
            }, this.onProgress = function() {
              pe.stalledTimeStamp = -1 / 0, clearTimeout(pe.downloadErrorCheckTimeoutId);
            }, this.onWaiting = function() {
              pe.waitingEventTimeStamp = _e.TimingUtil.getHiResTimestamp(), pe.checkStalledState();
            }, this.onTimeUpdate = function() {
              pe.waitingEventTimeStamp = -1 / 0, pe.lastTimeUpdateTimeStamp = _e.TimingUtil.getHiResTimestamp(), clearTimeout(pe.downloadErrorCheckTimeoutId);
            }, this.checkForDownloadError = function() {
              if (pe.video.buffered.length !== 0) {
                var fe = pe.video.currentTime, ge = pe.video.buffered.end(pe.video.buffered.length - 1), ye = fe <= ge && fe + 0.5 > ge, $e = pe.video.paused, Se = pe.video.networkState === HTMLMediaElement.NETWORK_LOADING, Ce = pe.video.videoWidth, Ie = pe.video.videoHeight;
                !$e && ye && Se && pe.manifestController.getCurrentSegments(ge, Ce, Ie, 2).then(function(Te) {
                  var Ee = new he.DefaultContentLoader(pe.context), we = function(Pe, Me) {
                    return Pe === void 0 && (Pe = !0), Te.length > 0 && Pe ? Ee.load(Te.pop(), le.HttpRequestMethod.HEAD).then(function(Ae) {
                      return we(Ae.status >= 200 && Ae.status < 300, Ae);
                    }) : Pe ? Promise.resolve() : Promise.reject(Me);
                  };
                  we().catch(function(Pe) {
                    var Me = Pe.url, Ae = Pe.status, Oe = Pe.statusText;
                    pe.context.eventHandler.fireError(new ce.PlayerError(ae.ErrorCode.NETWORK_ERROR, { url: Me, statusCode: Ae, statusText: Oe }, "Failed to load segment ".concat(Me, ", statusCode: ").concat(Ae, ", statusText: ").concat(Oe)));
                  });
                });
              }
            }, this.context = ve, this.video = ve.videoElement, this.manifestController = me, this.playbackAdvancing = !1, this.stalledTimeStamp = -1 / 0, this.waitingEventTimeStamp = -1 / 0, this.downloadErrorCheckTimeoutId = -1, this.lastProgressString = "", this.numProgressNotChanged = 0, this.lastTimeUpdateTimeStamp = -1 / 0, this.video.addEventListener(oe.MediaElementEvent.waiting, this.onWaiting), this.video.addEventListener(oe.MediaElementEvent.stalled, this.onStalled), this.video.addEventListener(oe.MediaElementEvent.progress, this.onProgress), this.video.addEventListener(oe.MediaElementEvent.timeupdate, this.onTimeUpdate), (0, se.getCapabilities)().isIOS && (this.fakeEventsIntervalId = window.setInterval(function() {
              pe.fakeProgress(), pe.fakeWaiting();
            }, 500));
          }
          return be.prototype.checkStalledState = function() {
            var ve = Math.abs(this.waitingEventTimeStamp - this.stalledTimeStamp);
            clearTimeout(this.downloadErrorCheckTimeoutId), isFinite(ve) && (this.downloadErrorCheckTimeoutId = window.setTimeout(this.checkForDownloadError, 1e3 * (5 - Math.min(5, ve))));
          }, be.prototype.dispose = function() {
            clearTimeout(this.fakeEventsIntervalId), clearTimeout(this.downloadErrorCheckTimeoutId), this.video.removeEventListener(oe.MediaElementEvent.waiting, this.onWaiting), this.video.removeEventListener(oe.MediaElementEvent.stalled, this.onStalled), this.video.removeEventListener(oe.MediaElementEvent.progress, this.onProgress), this.video.removeEventListener(oe.MediaElementEvent.timeupdate, this.onTimeUpdate), this.video = null, this.manifestController = null;
          }, be;
        }();
        ne.HlsDownloadErrorHandler = ue;
      }, 70539: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.FallbackSegmentTimelineController = void 0;
        var ae = ie(68329), ce = function() {
          function he(_e) {
            this.videoElement = _e, this.shouldCalculatePlaybackTimeForLive = !0, this.timelines = {};
          }
          return he.prototype.isLiveStream = function() {
            return this.videoElement.duration === 1 / 0;
          }, he.prototype.switchTimeline = function(_e) {
            this.timelines[_e] || (this.currentActiveTimelineId = _e, this.timelines[_e] = []);
          }, he.prototype.updateTimeline = function(_e, le) {
            var se = this, oe = this.timelines[_e], ue = ae.updateTimeline(oe, le), be = ue.findIndex(function(me) {
              return me.hasOwnProperty("playbackTime");
            });
            be !== -1 && ae.populateCurrentTimelineWithPlaybackTime(ue, be, ue[be].playbackTime), this.timelines[_e] = ue;
            var ve = ue.reduce(function(me, pe) {
              return se.isLiveStream() && !se.shouldCalculatePlaybackTimeForLive || (pe.playbackTime = me), me + pe.duration;
            }, 0);
            return this.shouldCalculatePlaybackTimeForLive && (this.shouldCalculatePlaybackTimeForLive = !1), ve;
          }, he.prototype.getPlayingSegment = function(_e) {
            for (var le = this.getCurrentTimeline(), se = 0; se < le.length; se++) {
              var oe = le[se];
              if (_e >= oe.playbackTime && _e <= oe.playbackTime + oe.duration)
                return le[se];
            }
            return null;
          }, he.prototype.addDownloadedSegments = function(_e) {
          }, he.prototype.getCurrentTimeline = function() {
            return this.timelines[this.currentActiveTimelineId];
          }, he.prototype.getAllTimelines = function() {
            return this.timelines;
          }, he.prototype.reset = function() {
            this.timelines[this.currentActiveTimelineId].forEach(function(_e) {
              return _e.consumed = !1;
            });
          }, he.prototype.dispose = function() {
            this.timelines = {}, this.videoElement = null;
          }, he;
        }();
        ne.FallbackSegmentTimelineController = ce;
      }, 70661: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var $e = function(Se, Ce) {
            return $e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ie, Te) {
              Ie.__proto__ = Te;
            } || function(Ie, Te) {
              for (var Ee in Te)
                Object.prototype.hasOwnProperty.call(Te, Ee) && (Ie[Ee] = Te[Ee]);
            }, $e(Se, Ce);
          };
          return function(Se, Ce) {
            if (typeof Ce != "function" && Ce !== null)
              throw new TypeError("Class extends value " + String(Ce) + " is not a constructor or null");
            function Ie() {
              this.constructor = Se;
            }
            $e(Se, Ce), Se.prototype = Ce === null ? Object.create(Ce) : (Ie.prototype = Ce.prototype, new Ie());
          };
        }();
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.FallbackHlsManifestController = void 0;
        var ce, he = ie(63546), _e = ie(35148), le = ie(62510), se = ie(67345), oe = ie(331), ue = ie(91520), be = ie(16368), ve = ie(77117), me = ie(70539), pe = ie(9183), fe = ie(76250), ge = function($e) {
          function Se(Ce) {
            var Ie = $e.call(this, Ce) || this;
            return Ie.onLoadPlaylistError = function(Te) {
              return Ie.context.logger.debug("Error while loading the playlist ", Te), null;
            }, ce = ue.ModuleManager.get(be.ModuleName.HLS).PlaylistUtils, Ie.hlsDownloadService = new pe.HlsDownloadService(Ie.context), Ie.segmentTimelineController = new me.FallbackSegmentTimelineController(Ce.videoElement), Ie.context.logger.debug("Initializing controller for native HLS parsing"), Ie;
          }
          return ae(Se, $e), Se.prototype.init = function() {
            return Promise.resolve();
          }, Se.prototype.getDownloadedVideoData = function() {
            return { id: "not available", bitrate: 0, height: 0, width: 0, isAuto: !0 };
          }, Se.prototype.getPlayingVideoData = function() {
            return null;
          }, Se.prototype.downloadMasterManifest = function(Ce) {
            var Ie = this;
            return this.hlsDownloadService.downloadPlaylist(Ce, se.HttpRequestType.MANIFEST_HLS_MASTER).then(function(Te) {
              var Ee = Ie.registerMasterManifest(Te, Te.url), we = Ie.parsedManifest.playlists[0].uri;
              return Ie.registerFirstVariantPlaylist(we).then(function(Pe) {
                return Ie.overrideManifestUrl(Ee, Te.url, Pe);
              });
            });
          }, Se.prototype.processMasterManifest = function(Ce, Ie) {
            return fe.replaceManifestUrls(Ie, Ce, this.settings.QUERY_PARAMETERS);
          }, Se.prototype.registerFirstVariantPlaylist = function(Ce) {
            var Ie = this;
            return this.hlsDownloadService.downloadPlaylist(Ce, se.HttpRequestType.MANIFEST_HLS_VARIANT).then(this.registerVariantPlaylist).then(function(Te) {
              return ce.isLive(Te) && Ie.scheduleReload(Te, Ce), Te;
            });
          }, Se.prototype.overrideManifestUrl = function(Ce, Ie, Te) {
            return "createObjectURL" in window.URL ? this.getManifestUrl(Ce, Te) : (this.context.eventHandler.dispatchEvent(le.PlayerEvent.Warning, new he.PlayerWarning(_e.WarningCode.SETUP_CREATE_OBJECT_URL_MISSING)), Promise.resolve(Ie));
          }, Se.prototype.getManifestUrl = function(Ce, Ie) {
            var Te = this;
            return ce.isLive(Ie) ? Promise.resolve(this.createDataUrlForManifest(Ce)) : Promise.all(this.getMediaPlaylistPromises(Ce)).then(function(Ee) {
              return Ee.filter(function(we) {
                return !!we;
              }).forEach(function(we) {
                Ce = Ce.replace(we.mediaUrl, we.blobUrl);
              }), Te.createDataUrlForManifest(Ce);
            });
          }, Se.prototype.getMediaPlaylistPromises = function(Ce) {
            var Ie = this;
            return Ce.split(`
`).map(function(Te) {
              return fe.parseUrlFromLine(Te);
            }).filter(function(Te) {
              return Te !== null;
            }).map(function(Te) {
              return Ie.getMediaPlaylistBlobUrlMapping(Te);
            });
          }, Se.prototype.getMediaPlaylistBlobUrlMapping = function(Ce) {
            var Ie = this;
            return this.hlsDownloadService.downloadPlaylist(Ce, se.HttpRequestType.MANIFEST_HLS_VARIANT).then(function(Te) {
              var Ee = fe.replaceManifestUrls(Ce, Te.body, Ie.settings.QUERY_PARAMETERS);
              return { blobUrl: Ie.createBlobForManifest(Ee), mediaUrl: Ce };
            }).catch(this.onLoadPlaylistError);
          }, Se.prototype.loadPlaylist = function(Ce) {
            var Ie = this;
            return this.hlsDownloadService.downloadPlaylist(Ce.uri, se.HttpRequestType.MANIFEST_HLS_VARIANT).then(function(Te) {
              return { width: Ce.width, height: Ce.height, timeline: Ie.parseTimelineEntries(Te.body) };
            }).catch(this.onLoadPlaylistError);
          }, Se.prototype.reload = function(Ce) {
            var Ie = this;
            return function() {
              if (!Ie.hlsDownloadService)
                return function() {
                };
              Ie.hlsDownloadService.downloadPlaylist(Ce, se.HttpRequestType.MANIFEST_HLS_VARIANT, !1).then(Ie.registerVariantPlaylist).then(function(Te) {
                return ce.isLive(Te) && Ie.scheduleReload(Te, Ie.parsedManifest.playlists[0].uri), Te;
              }).catch(Ie.onLoadPlaylistError);
            };
          }, Se.prototype.scheduleReload = function(Ce, Ie) {
            this.reloadTimerId = setTimeout(this.reload(Ie), (0, oe.toMilliSeconds)(Ce.targetDuration));
          }, Se.prototype.createBlobForManifest = function(Ce) {
            var Ie = new Blob([Ce], { type: "application/x-mpegURL" });
            return window.URL.createObjectURL(Ie);
          }, Se.prototype.createDataUrlForManifest = function(Ce) {
            return "data:application/x-mpegURL," + Ce.replace(/\n/g, "%0A").replace(/\r/g, "%0D");
          }, Se.prototype.getVariantPlaylistInfos = function() {
            return this.parsedManifest.playlists.map(function(Ce) {
              return { uri: Ce.uri, width: Ce.attributes && Ce.attributes.RESOLUTION ? Ce.attributes.RESOLUTION.width : -1, height: Ce.attributes && Ce.attributes.RESOLUTION ? Ce.attributes.RESOLUTION.height : -1 };
            });
          }, Se.prototype.loadAllVariantPlaylists = function() {
            var Ce = this, Ie = this.getVariantPlaylistInfos();
            Ie.reverse();
            var Te = Ie.map(function(Ee) {
              return Ce.loadPlaylist(Ee);
            });
            return Promise.all(Te).then(function(Ee) {
              var we = Ce.getPlaybackTimeOfFirstSegmentInTimeline(Ee);
              return we >= 0 && Ee.forEach(function(Pe) {
                Pe.timeline.reduce(function(Me, Ae) {
                  return Ae.playbackTime = Me, Me + Ae.duration;
                }, we);
              }), Ee;
            });
          }, Se.prototype.getCurrentSegments = function(Ce, Ie, Te, Ee) {
            return Ee === void 0 && (Ee = 1), this.loadAllVariantPlaylists().then(function(we) {
              var Pe = we.find(function(Me) {
                return Me.width === Ie && Me.height === Te;
              });
              return ye(Pe ? [Pe] : we, Ee, Ce);
            });
          }, Se.prototype.dispose = function() {
            $e.prototype.dispose.call(this), clearTimeout(this.reloadTimerId), this.reloadTimerId = null;
          }, Se;
        }(ve.AbstractHlsManifestController);
        function ye($e, Se, Ce) {
          for (var Ie = [], Te = 0, Ee = 0; Ee < $e.length; Ee++) {
            var we = $e[Ee];
            Te = 0;
            for (var Pe = 0; Pe < we.timeline.length; Pe++) {
              var Me = we.timeline[Pe];
              if (Me.playbackTime + Me.duration >= Ce && (Ie.push(Me.uri), Te++), Te > Se)
                break;
            }
          }
          return Ie;
        }
        ne.FallbackHlsManifestController = ge;
      }, 72273: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ke) {
            for (var je, De = 1, at = arguments.length; De < at; De++)
              for (var dt in je = arguments[De])
                Object.prototype.hasOwnProperty.call(je, dt) && (Ke[dt] = je[dt]);
            return Ke;
          }, ae.apply(this, arguments);
        }, ce = this && this.__decorate || function(Ke, je, De, at) {
          var dt, ft = arguments.length, lt = ft < 3 ? je : at === null ? at = Object.getOwnPropertyDescriptor(je, De) : at;
          if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
            lt = Reflect.decorate(Ke, je, De, at);
          else
            for (var nt = Ke.length - 1; nt >= 0; nt--)
              (dt = Ke[nt]) && (lt = (ft < 3 ? dt(lt) : ft > 3 ? dt(je, De, lt) : dt(je, De)) || lt);
          return ft > 3 && lt && Object.defineProperty(je, De, lt), lt;
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.NativePlayer = void 0;
        var he = ie(92712), _e = ie(25550), le = ie(28764), se = ie(63546), oe = ie(35148), ue = ie(18665), be = ie(60997), ve = ie(62510), me = ie(57620), pe = ie(15539), fe = ie(88005), ge = ie(16937), ye = ie(33696), $e = ie(17990), Se = ie(58975), Ce = ie(13533), Ie = ie(3464), Te = ie(81361), Ee = ie(10981), we = ie(79814), Pe = ie(56435), Me = ie(331), Ae = ie(70016), Oe = ie(76885), Be = ie(54838), Ve = ie(61878), Ue = ie(46462), Re = ie(91520), Ne = ie(16368), xe = ie(67345), ke = ie(526), Le = ie(62545), He = ie(69860), We = ie(60012), Xe = ie(91229), Qe = ie(55194), tt = 2, Je = 0.1, Ge = 0.25, Ye = "not available", ze = 0.75, Fe = 2, ot = 0, vt = function() {
          function Ke(je) {
            var De = this;
            this.numTimeChanged = 0, this.loaded = !1, this.audio = null, this.ended = !1, this.ignoreNextVideoError = !1, this.controlPermitted = !0, this.seekingTimeoutId = -1, this.nativeSeekCalled = !1, this.isIllicitlySeeking = !1, this.ignoreNextDelta = !1, this.numSeekingCalled = 0, this.timeShiftJumpStartPosition = -1, this.seekTargetTime = -1, this.textTrackController = null, this.lastPlayIssuer = "api", this.lastPauseIssuer = "api", this.lastSeekIssuer = "api", this.sourceLoadRetryCount = 0, this.lastVerifiedPlaybackPosition = -1, this.lastLegalPlaybackPosition = 0, this.restrictedInlinePlayback = !1, this.lastTime = 0, this.availableVideoStreams = [], this.allowedToThrowEvents = !0, this.hasSourceBeenLoaded = !1, this.hasDataBeenLoaded = !1, this.sourceElementEventListeners = [], this.restoringPlaybackPosAfterQualitySwitch = !1, this.isInitialSeek = !1, this.lastDelayedSeekHandlers = {}, this.isProgressiveQualityChange = !1, this.isSourceBeingRedirected = !1, this.isInNativeFullscreen = !1, this.onAddTrack = function(at) {
              if (De.isReady()) {
                var dt = at.track;
                De.eventCallback(ve.PlayerEvent.AudioAdded, { track: De.convertAudioTrackNativeToApi(dt) }), dt.enabled && De.loaded && De.dispatchAudioChangedEvent(null, dt);
              }
            }, this.onRemoveTrack = function(at) {
              De.isReady() && De.eventCallback(ve.PlayerEvent.AudioRemoved, { track: De.convertAudioTrackNativeToApi(at.track) });
            }, this.onWebkitPresentationModeChanged = function() {
              var at, dt, ft = De.video.getViewModeFromPresentationMode();
              ft === ye.ViewMode.PictureInPicture || ft === ye.ViewMode.Fullscreen && (0, Ce.getCapabilities)().isIOS ? (at = De.textTrackController) === null || at === void 0 || at.enableNative() : (dt = De.textTrackController) === null || dt === void 0 || dt.disableNative(), De.context.store.dispatch((0, $e.setPlayerViewMode)(ft));
            }, this.onDurationChange = function() {
              (0, me.maybeFireDurationChangedEvent)(De.lastDuration, De.getDuration(), De.eventHandler), De.lastDuration = De.getDuration(), De.hasDataBeenLoaded && De.maybeResolveDeferredLoading();
            }, this.videoOnPlay = function() {
              De.stateManager.stallExit(), De.restrictedInlinePlayback && De.audio && De.setVideoTime(), De.ended = !1, De.stateManager.transitionToPlayState(!0, De.lastPlayIssuer);
            }, this.videoOnPlaying = function() {
              De.stateManager.isStalled ? (De.stateManager.stallExit(), De.stateManager.transitionToPlayingState(De.lastPlayIssuer)) : De.stateManager.isStopped() ? De.onPlaybackStarted() : De.stateManager.isPlaying() || (De.stateManager.transitionToPlayState(!0, De.lastPlayIssuer), De.stateManager.transitionToPlayingState(De.lastPlayIssuer));
            }, this.loadedDataHandler = function() {
              var at;
              clearTimeout(De.loadedDataFallbackTimeoutID), (at = De.assetAvailabilityChecker) === null || at === void 0 || at.dispose(), De.hasSourceBeenLoaded || clearTimeout(De.loadTimeoutID), De.hasSourceBeenLoaded = !0, De.isProgressiveQualityChange = !1, De.allowedToThrowEvents = !0, De.hasDataBeenLoaded = !0, De.maybeResolveDeferredLoading();
            }, this.eventCallback = function(at, dt, ft, lt) {
              dt === void 0 && (dt = {}), ft === void 0 && (ft = !1), lt === void 0 && (lt = !1), De.eventHandler && (De.allowedToThrowEvents || ft) && De.eventHandler.dispatchEvent(at, dt, lt);
            }, this.onTimeUpdate = function(at) {
              var dt = De.getElement(), ft = dt.currentTime;
              (De.lastVerifiedPlaybackPosition !== -1 || ft !== De.lastVerifiedPlaybackPosition) && !De.isIllicitlySeeking && (De.isIllegalSeek(ft) ? (Promise.resolve(De.video.play()).catch(function(lt) {
                De.logger.insane("Play promise rejected:", lt);
              }), De.ignoreNextDelta = !0, dt.currentTime = De.lastLegalPlaybackPosition) : De.handleTimeUpdateEvent(dt, ft), De.nativeSeekCalled = !1, De.currentVideoStream && (De.currentVideoStream.width = De.video.videoWidth, De.currentVideoStream.height = De.video.videoHeight));
            }, this.onPlaybackStarted = function() {
              De.isPlaying() || (De.ended = !1, De.startManifestTimeoutTimer(), De.stateManager.transitionToPlayingState(De.lastPlayIssuer));
            }, this.onContentPlaybackFinished = function() {
              De.ended = !0;
            }, this.getCurrentTime = function(at) {
              at === void 0 && (at = ye.TimeMode.AbsoluteTime);
              var dt = De.getStartDate();
              return at === ye.TimeMode.AbsoluteTime && dt ? Be.Util.timeInSeconds(dt) + De.getElement().currentTime : De.getElement().currentTime;
            }, this.getAudioQuality = this.getPlaybackAudioData, this.getVideoQuality = this.getPlaybackVideoData, this.videoOnEnded = function() {
              var at, dt = De.getElement(), ft = Math.abs(dt.currentTime - De.lastLegalPlaybackPosition), lt = De.settings.GLOBAL_DISABLE_SEEKING, nt = (at = De.currentDuration) !== null && at !== void 0 ? at : dt.duration;
              lt && (ft > ze || dt.currentTime < nt - ze) ? (Promise.resolve(De.video.play()).catch(function(ct) {
                De.logger.insane("Play promise rejected:" + ct);
              }), De.ignoreNextDelta = !0, De.video.currentTime = De.lastLegalPlaybackPosition) : (De.lastLegalPlaybackPosition = 0, De.stateManager.isPlaying() && De.stateManager.transitionToPausedState(!0, De.lastPauseIssuer), De.stateManager.transitionToStoppedState());
            }, this.videoOnSeeked = function() {
              De.resetTimeShift(), De.numSeekingCalled = 0, !De.settings.GLOBAL_DISABLE_SEEKING || De.restoringPlaybackPosAfterQualitySwitch || De.isInitialSeekToStartTime ? (De.lastVerifiedPlaybackPosition = De.getElement().currentTime, De.isInitialSeekToStartTime = !1, De.stateManager.isSeeking() && (De.textTrackController && De.textTrackController.seek(), De.maybeHandleSeekTargetChangeDuringStartup())) : De.isIllicitlySeeking = !1, De.finishedSeekedTransitionState();
            }, this.videoOnSeeking = function() {
              if (De.settings.GLOBAL_DISABLE_SEEKING && !De.isInitialSeekToStartTime)
                De.isIllicitlySeeking = !De.restoringPlaybackPosAfterQualitySwitch, De.numSeekingCalled++, De.numSeekingCalled > 1 && (De.ignoreNextDelta = !1);
              else if (!De.stateManager.isSeeking() && !De.stateManager.isTimeShifting()) {
                var at = De.getElement().currentTime;
                De.stateManager.transitionToSeekingIOSState(at, pe.INTERNAL_ISSUER_NAME), De.lastVerifiedPlaybackPosition = at;
              }
            }, this.onTimeChanged = function() {
              De.maxTimeShift === void 0 && (De.maxTimeShift = De.getElement().currentTime);
            }, this.delayedSeek = function() {
              De.numTimeChanged++, De.numTimeChanged < De.settings.IOS_MIN_TIMEUPDATES_AFTER_AD || (De.eventHandler.off(ve.PlayerEvent.TimeChanged, De.delayedSeek), De.restoringPlaybackPosAfterQualitySwitch = !0, De.triggerSeek({ time: De.currentTimeWas, issuer: "api", force: !0 }));
            }, this.context = je, this.isAtLiveEdge = !1, this.logger = je.logger, this.video = je.videoElement, this.config = je.config, this.eventHandler = je.eventHandler, this.settings = je.settings, this.hlsSeekingGlitchEventHandlers = [], this.downloadErrorHandler = null, this.currentVol = this.video.volume, this.originalCrossOriginAttributeValue = this.video.getAttribute("crossOrigin"), this.currentTimeShift = -1 / 0, (0, ke.isAirplaySupported)() && (this.airplayService = new ke.AppleAirplayService(this.video, this.eventHandler)), this.hlsLiveTimeTracker = new We.HlsLiveNativeTimeTracker(this, je), this.elementEvents = [{ event: Ue.MediaElementEvent.pause, handler: function() {
              De.resetTimeShift(), De.ended || De.stateManager.transitionToPausedState(!0, De.lastPauseIssuer, !0);
            } }, { event: Ue.MediaElementEvent.ended, handler: function() {
              De.videoOnEnded();
            } }, { event: Ue.MediaElementEvent.play, handler: this.videoOnPlay }, { event: Ue.MediaElementEvent.canplay, handler: function() {
              De.stateManager.stallExit();
            } }, { event: Ue.MediaElementEvent.seeking, handler: function() {
              De.nativeSeekCalled = !0, De.videoOnSeeking(), De.getCurrentTime() >= De.getDuration() && (De.videoOnSeeked(), De.videoOnEnded());
            } }, { event: Ue.MediaElementEvent.seeked, handler: function() {
              De.videoOnSeeked(), De.restrictedInlinePlayback && De.audio && De.setVideoTime();
            } }, { event: Ue.MediaElementEvent.durationchange, handler: this.onDurationChange }, { event: Ue.MediaElementEvent.loadeddata, handler: this.loadedDataHandler }, { event: Ue.MediaElementEvent.loadedmetadata, handler: function() {
              De.loadedDataFallbackTimeoutID = window.setTimeout(De.loadedDataHandler, 200);
            } }, { event: Ue.MediaElementEvent.playing, handler: this.videoOnPlaying }, { event: Ue.MediaElementEvent.waiting, handler: function() {
              De.resetTimeShift(), De.stateManager.stallEnter();
            } }, { event: Ue.MediaElementEvent.timeupdate, handler: this.onTimeUpdate }, { event: Ue.MediaElementEvent.error, handler: function(at) {
              De.hasSourceBeenLoaded || De.availableVideoStreams.length !== 1 || De.type !== ye.StreamType.Progressive ? (De.loadingDeferred.reject(), De.ignoreNextVideoError ? (De.logger.debug("Ignoring video element error", at.errorObject), De.ignoreNextVideoError = !1) : (De.logger.debug("video element has thrown an error", at.errorObject), clearTimeout(De.loadTimeoutID), De.eventHandler.fireError((0, me.createPlayerErrorFromMediaError)(at, !0)))) : De.handleStreamErrorEvent(_e.ErrorCode.SOURCE_PROGRESSIVE_STREAM_ERROR, De.video.getWrappedElement().src, at);
            } }, { event: Ue.MediaElementEvent.webkitpresentationmodechanged, handler: this.onWebkitPresentationModeChanged }, { elementSelector: function(at) {
              return at.audioTracks;
            }, event: "addtrack", handler: this.onAddTrack }, { elementSelector: function(at) {
              return at.audioTracks;
            }, event: "removetrack", handler: this.onRemoveTrack }];
          }
          return Ke.prototype.shouldAwaitDurationAvailability = function() {
            return !(0, Pe.isWebOS)() && !this.getDuration();
          }, Ke.prototype.shouldAwaitSeekableRange = function() {
            var je, De;
            if (!this.isHlsLive() || !((De = (je = this.config) === null || je === void 0 ? void 0 : je.tweaks) === null || De === void 0) && De.prevent_video_element_preloading || (0, Pe.isWebOS)() || this.isSourceBeingRedirected)
              return !1;
            var at = this.video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA;
            return !ut(this.getElement().seekable) && !at;
          }, Ke.prototype.maybeResolveDeferredLoading = function() {
            this.shouldAwaitDurationAvailability() || this.shouldAwaitSeekableRange() ? this.logger.debug("Cannot resolve deferred loading yet, waiting for required data to be loaded ", { duration: String(this.getDuration()), seekableRangeAvailable: ut(this.getElement().seekable), videoElementReadyState: this.getElement().readyState }) : this.loadingDeferred.resolve();
          }, Ke.prototype.handleTimeUpdateEvent = function(je, De) {
            if (this.ignoreNextDelta = !1, this.currentDuration = je.duration, De > this.currentDuration + Fe)
              return this.context.logger.debug("CurrentTime ".concat(De, " exceeds video duration (").concat(this.currentDuration, "), reverting current time")), void (je.currentTime = this.currentDuration - 0.1);
            this.lastLegalPlaybackPosition = De, this.stateManager.stallExit(), this.stateManager.isSeeking() || this.stateManager.isTimeShifting() || !this.isPlaying() || (this.getStartDate() != null ? this.eventCallback(ve.PlayerEvent.TimeChanged, { time: this.getCurrentTime(), relativeTime: De }) : this.eventCallback(ve.PlayerEvent.TimeChanged, { time: this.getCurrentTime() }));
          }, Ke.prototype.isIllegalSeek = function(je) {
            if (!this.settings.GLOBAL_DISABLE_SEEKING || !this.nativeSeekCalled)
              return !1;
            var De = this.lastVerifiedPlaybackPosition !== -1 && je > this.lastVerifiedPlaybackPosition + ze, at = Math.abs(je - this.lastLegalPlaybackPosition);
            return (!this.ignoreNextDelta || De) && at > ze;
          }, Ke.prototype.getElement = function() {
            return this.restrictedInlinePlayback && this.audio ? this.audio : this.video;
          }, Ke.prototype.setVideoTime = function() {
            var je = Date.now();
            (0, Me.toSeconds)(je - this.lastTime) >= 1 / 30 && (this.video.currentTime = this.audio.currentTime, this.lastTime = je), this.isPlaying() && window.requestAnimationFrame(this.setVideoTime);
          }, Ke.prototype.maybeGoToLiveEdgeOnPlay = function() {
            if (this.isLive() && !this.isTimeShiftingAllowed()) {
              var je = this.getSeekableRangeInternal();
              je.end >= 0 && this.seekForLive(je.end, pe.STARTUP_ISSUER_NAME);
            }
          }, Ke.prototype.resolveDelayedSeek = function() {
            this.delayedSeekTarget !== void 0 && (this.clearDelayedSeekHandlers(), this.seek(this.delayedSeekTarget, "api-play"));
          }, Ke.prototype.play = function(je) {
            return this.controlPermitted ? (this.lastPlayIssuer = je, this.resolveDelayedSeek(), this.maybeGoToLiveEdgeOnPlay(), this.getElement().play()) : Promise.reject("Play control not permitted");
          }, Ke.prototype.getStartDate = function() {
            if (!this.isLive())
              return null;
            var je = this.getElement().getWrappedElement(), De = typeof je.getStartDate == "function" ? je.getStartDate() : null;
            return De && !isNaN(De.getTime()) ? De : null;
          }, Ke.prototype.preload = function() {
            this.getElement().preload = "auto";
          }, Ke.prototype.pause = function(je) {
            this.lastPauseIssuer = je;
            var De = this.getElement();
            this.controlPermitted && this.loaded && (this.stateManager.transitionToPausedState(!1, this.lastPauseIssuer), De.pause());
          }, Ke.prototype.mute = function(je) {
            this.getElement().muted || (this.getElement().muted = !0, this.eventCallback(ve.PlayerEvent.Muted, { issuer: je || "api" }));
          }, Ke.prototype.unmute = function(je) {
            this.getElement().muted && (this.getElement().muted = !1, this.eventCallback(ve.PlayerEvent.Unmuted, { issuer: je || "api" }));
          }, Ke.prototype.getActualSeekTarget = function(je) {
            var De = this.getStartDate();
            return De ? je - (0, Me.toSeconds)(De.getTime()) : je;
          }, Ke.prototype.seek = function(je, De) {
            var at = this;
            return !(!this.isSeekingAllowed(je) || this.getCurrentTime() === je) && (this.hlsLiveTimeTracker.adjustTargetTime(je, De).then(function(dt) {
              at.lastSeekIssuer = De, at.triggerSeekEvent(dt, De);
              var ft = at.getActualSeekTarget(dt);
              return at.triggerSeek({ time: ft, issuer: De });
            }), this.hasDataBeenLoaded && this.getDuration() > 0);
          }, Ke.prototype.seekForLive = function(je, De) {
            this.timeShiftJumpStartPosition = this.getCurrentTime(), this.lastSeekIssuer = De, this.triggerTimeShiftEvent(je, De), this.triggerSeekForLive({ time: je, issuer: De });
          }, Ke.prototype.isSeekingAllowed = function(je) {
            this.isInitialSeekToStartTime = this.isInitialSeek && this.hasStartTime(je);
            var De = !this.settings.GLOBAL_DISABLE_SEEKING && this.isSeekingEnabled();
            return (this.isInitialSeekToStartTime || De) && this.controlPermitted;
          }, Ke.prototype.isTimeShiftingAllowed = function() {
            var je = !(this.config.playback && this.config.playback.hasOwnProperty("timeShift")) || !!this.config.playback.timeShift;
            return this.isLive() && je;
          }, Ke.prototype.triggerSeek = function(je) {
            return !this.maybeDelaySeek(je) && (this.stateManager.transitionToSeekingState(je.time, je.issuer, !1), this.finishSeek(je), !0);
          }, Ke.prototype.triggerSeekForLive = function(je) {
            this.maybeDelaySeek(je, !0) || (this.stateManager.transitionToTimeShiftingState(this.getCurrentTime(), je.time, je.issuer, !1), je.time < 0 && (je.time = this.getSeekableRangeInternal().end + je.time, this.resetTimeShift()), this.finishSeek(je));
          }, Ke.prototype.maybeDelaySeek = function(je, De) {
            return De === void 0 && (De = !1), this.stateManager.isSeeking() && je.issuer !== "api-play" ? (this.logger.debug("Seeking already in progress, delaying seek for time", je.time), this.scheduleDelayedSeek(je, De, [Ue.MediaElementEvent.seeked]), !0) : this.hasDataBeenLoaded ? this.getDuration() === 0 ? (this.logger.debug("Delaying the seek until stream duration is known"), this.scheduleDelayedSeek(je, De, [Ue.MediaElementEvent.durationchange]), !0) : this.video.seekable.length < 1 && (this.logger.debug("Delaying the seek as the seekable range is not yet known"), this.scheduleDelayedSeek(je, De, [Ue.MediaElementEvent.timeupdate, Ue.MediaElementEvent.canplay]), !0) : (this.logger.debug("Delaying the seek until data is loaded"), this.scheduleDelayedSeek(je, De, [Ue.MediaElementEvent.loadeddata]), !0);
          }, Ke.prototype.finishSeek = function(je) {
            var De = je.issuer === pe.ADVERTISING_ISSUER_NAME, at = this.getSeekableRangeInternal();
            this.logger.debug("Seek to ".concat(je.time, ", seekable range:"), at);
            var dt = this.adjustSeekTimeForBoundaries(je.time, at, De);
            this.isInitialSeek = !1, this.ignoreNextDelta = this.ignoreNextDelta || this.isInitialSeekToStartTime || je.force;
            var ft = parseFloat(dt.toFixed(tt));
            this.seekTargetTime = ft, this.logger.debug("Setting time on video element from ".concat(this.getElement().currentTime, " to ").concat(ft)), this.getElement().currentTime = ft;
          }, Ke.prototype.adjustSeekTimeForBoundaries = function(je, De, at) {
            at === void 0 && (at = !1);
            var dt = bt(je, De);
            return at ? je >= De.end && (dt = De.end - Je) : dt = Math.min(dt, De.end - this.settings.SEEK_TO_END_OFFSET), dt !== je && this.logger.debug("Adjusted seek target from ".concat(je, " to ").concat(dt)), dt;
          }, Ke.prototype.isSeekingEnabled = function() {
            var je = this.config && this.config.hasOwnProperty("playback") ? this.config.playback : {};
            return !je.hasOwnProperty("seeking") || je.seeking;
          }, Ke.prototype.hasStartTime = function(je) {
            var De = this.context.sourceContext.source ? this.context.sourceContext.source : {};
            return De.hasOwnProperty("options") && De.options.hasOwnProperty("startTime") && je === De.options.startTime;
          }, Ke.prototype.triggerSeekEvent = function(je, De) {
            De !== pe.STARTUP_ISSUER_NAME && this.eventCallback(ve.PlayerEvent.Seek, { position: this.getCurrentTime(), seekTarget: je, issuer: De || "api" });
          }, Ke.prototype.triggerTimeShiftEvent = function(je, De) {
            De !== pe.STARTUP_ISSUER_NAME && this.eventCallback(ve.PlayerEvent.TimeShift, { target: je < 0 ? this.timeShiftJumpStartPosition + je : je, position: this.timeShiftJumpStartPosition, issuer: De || "api" });
          }, Ke.prototype.waitForOnSeeked = function(je) {
            var De = this;
            return new Promise(function(at) {
              var dt = function() {
                je.removeEventListener(Ue.MediaElementEvent.seeked, dt), at();
              };
              De.hlsSeekingGlitchEventHandlers.push({ el: je, ev: Ue.MediaElementEvent.seeked, fn: dt }), je.addEventListener(Ue.MediaElementEvent.seeked, dt);
            });
          }, Ke.prototype.waitForOnProgress = function(je, De) {
            var at = this;
            return new Promise(function(dt, ft) {
              var lt = 0, nt = function() {
                var ct = je.buffered, it = ct.length > 0 ? ct.end(ct.length - 1) : -1 / 0;
                (lt += isFinite(it) ? 1 : 0) > at.settings.SAFARI_NUM_PROGRESS_EVENTS_AFTER_SEEK_GLITCH && it < De ? (je.removeEventListener(Ue.MediaElementEvent.progress, nt), ft(null)) : it >= De && (je.removeEventListener(Ue.MediaElementEvent.progress, nt), dt());
              };
              at.hlsSeekingGlitchEventHandlers.push({ el: je, ev: Ue.MediaElementEvent.progress, fn: nt }), je.addEventListener(Ue.MediaElementEvent.progress, nt);
            });
          }, Ke.prototype.verifyHLSPlaybackBuffer = function(je, De) {
            var at = this;
            return this.type !== ye.StreamType.Hls ? Promise.resolve() : this.waitForOnSeeked(je).then(function() {
              return at.waitForOnProgress(je, De);
            }).catch(function() {
              throw at.logger.debug("seek to target time (".concat(De, ") failed - trying to recover by seeking to ").concat(De + 1)), null;
            });
          }, Ke.prototype.clearDelayedSeekHandlers = function() {
            var je = this;
            Object.keys(this.lastDelayedSeekHandlers).forEach(function(De) {
              je.getElement().removeEventListener(De, je.lastDelayedSeekHandlers[De]);
            }), this.lastDelayedSeekHandlers = {};
          }, Ke.prototype.scheduleDelayedSeek = function(je, De, at) {
            var dt = this, ft = this.getElement();
            this.clearDelayedSeekHandlers(), this.delayedSeekTarget = je.time;
            var lt = function(nt) {
              dt.clearDelayedSeekHandlers();
              var ct = { time: (0, Ae.isNumber)(nt) ? nt : je.time, issuer: je.issuer, force: je.force };
              dt.verifyHLSPlaybackBuffer(ft, je.time).catch(function() {
                return lt(je.time + 1);
              }), dt.delayedSeekTarget = void 0, De ? dt.triggerSeekForLive(ct) : dt.triggerSeek(ct);
            };
            at.forEach(function(nt) {
              ft.addEventListener(nt, lt), dt.lastDelayedSeekHandlers[nt] = lt;
            });
          }, Ke.prototype.setAudio = function(je) {
            var De = Te.ArrayHelper.toArray(this.video.audioTracks).find(function(at) {
              return at.id === je;
            });
            De && this.enableAudioTrack(De);
          }, Ke.prototype.dispatchAudioChangedEvent = function(je, De) {
            this.eventCallback(ve.PlayerEvent.AudioChanged, { targetAudio: { id: De.id, label: De.label, lang: De.language }, sourceAudio: je, time: this.video.currentTime });
          }, Ke.prototype.enableAudioTrack = function(je) {
            if (!je.enabled) {
              var De = Te.ArrayHelper.toArray(this.video.audioTracks).find(function(dt) {
                return dt.enabled;
              }), at = null;
              De && (De.enabled = !1, at = this.convertAudioTrackNativeToApi(De)), je.enabled = !0, this.dispatchAudioChangedEvent(at, je);
            }
          }, Ke.prototype.setVolume = function(je, De) {
            var at = this.getElement(), dt = this.currentVol, ft = Math.min(je / 100, 1);
            dt !== ft && (this.currentVol = ft, at.volume = ft, this.eventCallback(ve.PlayerEvent.VolumeChanged, { targetVolume: 100 * ft, sourceVolume: 100 * dt, issuer: De || "api" }));
          }, Ke.prototype.startManifestTimeoutTimer = function() {
            var je = this;
            clearTimeout(this.loadTimeoutID), this.hasSourceBeenLoaded || (this.loadTimeoutID = setTimeout(function() {
              je.loadTimeoutID = null, !je.hasSourceBeenLoaded && je.eventHandler && (je.type === ye.StreamType.Hls ? je.eventHandler.fireError(new le.PlayerError(_e.ErrorCode.NETWORK_MANIFEST_DOWNLOAD_TIMEOUT, { sourceUrl: je.sourceConfig.url }, "Failed to load the HLS playlist: the request timed out.")) : je.type === ye.StreamType.Progressive && je.eventHandler.fireError(new le.PlayerError(_e.ErrorCode.NETWORK_PROGRESSIVE_STREAM_DOWNLOAD_TIMEOUT, { sourceUrl: je.sourceConfig.url }, "Failed to load the progressive source: the request timed out.")));
            }, (0, Me.toMilliSeconds)(this.settings.XHR_TIMEOUT / 2)));
          }, Ke.getContentDomain = function(je) {
            var De = document.createElement("a");
            return De.href = je, De.host === "" && (De.href = De.href), De.hostname;
          }, Ke.prototype.trackLoading = function(je) {
            var De;
            (0, Pe.isTizen)() && ((De = this.assetAvailabilityChecker) === null || De === void 0 || De.dispose(), this.assetAvailabilityChecker = new Le.AssetAvailabilityChecker(this.context, je, this.video));
          }, Ke.prototype.prepareLoad = function() {
            return Promise.resolve();
          }, Ke.prototype.load = function(je, De, at) {
            var dt = this;
            this.stateManager = this.context.serviceManager.get(ue.ServiceName.PlayerStateService), this.stateManager.transitionToSeekedState(!1), this.video.setAttribute("preload", "metadata"), this.type = this.context.sourceContext.technology.streaming, this.sourceConfig = je, je.type && (this.type = je.type), this.loaded === !0 && this.unload().catch(function() {
            }), this.hasSourceBeenLoaded = !1, this.hasDataBeenLoaded = !1, this.getElement().nativeMediaEventListener.reset(), this.isInitialSeek = !0, this.ignoreNextVideoError = !1, this.sourceLoadRetryCount = 0, this.delayedSeekTarget = void 0, this.isSourceBeingRedirected = !1, je.hasOwnProperty("vr") && je.vr && je.vr.restrictedInlinePlayback ? (this.restrictedInlinePlayback = !0, this.audio = Be.Util.getVRAudioElement(), this.addEventListeners(this.audio)) : (this.audio = null, this.restrictedInlinePlayback = !1, this.addEventListeners(this.video)), this.eventHandler.on(ve.PlayerEvent.TimeChanged, this.onTimeChanged), this.unsubscribeFromStoreStoppedListener = (0, Ie.subscribe)(this.context.store)(function(ct) {
              return (0, Se.getIsStopped)((0, Se.getPlayerState)(ct));
            }, this.onContentPlaybackFinished, function(ct) {
              return ct === !0;
            }), this.settings.GLOBAL_DISABLE_SEEKING = De || !1, this.seekingTimeoutId > -1 && (clearTimeout(this.seekingTimeoutId), this.seekingTimeoutId = -1);
            var ft = "";
            je && je.url && (typeof je.url == "string" ? ft = je.url : je.url.length > 0 && (ft = je.url[0].url));
            var lt = window.location.hostname === Ke.getContentDomain(ft);
            je.hasOwnProperty("vr") && je.vr && !lt && (this.originalCrossOriginAttributeValue = this.video.getAttribute("crossOrigin"), this.video.setAttribute("crossOrigin", "anonymous")), this.video.eventHandler.reset(), this.isProgressiveQualityChange || (this.textTrackController = this.createTextTrackController()), this.loadingDeferred = new Ee.Deferred();
            var nt = this.loadSource(je, at);
            return this.loadingDeferred.promise.then(function() {
              dt.context.sourceContext.source = je.config;
            }).then(function() {
              return nt;
            }).then(function() {
              return dt.initializeLoadedState(je);
            });
          }, Ke.prototype.maybeHandleRedirectedSource = function(je) {
            var De = this;
            (0, Pe.isSafari17orIOS17)() && fetch(je.url, { method: xe.HttpRequestMethod.GET, headers: { Range: "bytes=0-0" } }).then(function(at) {
              at.redirected && (De.logger.debug("Detected source redirection."), De.hasDataBeenLoaded && De.loadingDeferred.resolve(), De.isSourceBeingRedirected = !0);
            }).catch(function() {
            });
          }, Ke.prototype.loadSource = function(je, De) {
            var at = this;
            return this.type === ye.StreamType.Hls ? (this.maybeHandleRedirectedSource(je), this.loadHls(je)) : this.type === ye.StreamType.Progressive ? this.loadProgressive(je, De).then(function() {
              return at.loadVideoElement();
            }) : Promise.resolve();
          }, Ke.prototype.initializeLoadedState = function(je) {
            this.currentSource = je, this.loaded = !0, this.lastLegalPlaybackPosition = 0, this.ignoreNextDelta = !1;
          }, Ke.prototype.loadVideoElement = function() {
            this.config.tweaks.prevent_video_element_preloading || this.video.load();
          }, Ke.prototype.setupVideoElement = function(je, De) {
            var at = this;
            if (je.config.drm && je.config.drm.fairplay) {
              var dt = Re.ModuleManager.get(Ne.ModuleName.DRM).FairplayHandler;
              this.fpsHandler = new dt(this.context, this.video, je.config.drm.fairplay);
            }
            var ft = Ke.createSourceElement(De, null);
            this.appendAndSetVideoStream(ft, "0", je), this.trackLoading(ft);
            var lt = { element: ft, handler: function(nt) {
              return at.handleStreamErrorEvent(_e.ErrorCode.SOURCE_HLS_STREAM_ERROR, ft.src, nt);
            } };
            this.sourceElementEventListeners.push(lt), lt.element.addEventListener(Ue.MediaElementEvent.error, lt.handler);
          }, Ke.prototype.setSourceAndLoadVideoElement = function(je, De) {
            this.setupVideoElement(je, De), this.loadVideoElement();
          }, Ke.prototype.setVideoForServiceWorker = function(je, De) {
            var at = this, dt = Oe.URLHelper.appendQueryParametersToUrl(De, { "bitmovin-player-id": this.context.internalPlayerID });
            return this.setSourceAndLoadVideoElement(je, dt), this.hlsManifestController.resolveMasterManifest(je.url).then(function() {
            }).catch(function(ft) {
              at.logger.debug("Couldn't access master playlist with ServiceWorker: ".concat(ft));
            });
          }, Ke.prototype.setVideoForNativeHLSParsing = function(je, De) {
            var at = this;
            return Xe.createHlsManifestController(this.context).then(function(dt) {
              return at.hlsManifestController = dt, at.settings.NATIVE_HLS_DOWNLOAD_ERROR_HANDLING && (at.downloadErrorHandler = new He.HlsDownloadErrorHandler(at.context, dt)), Xe.shouldUseServiceWorker(at.context) ? at.setVideoForServiceWorker(je, De) : at.hlsManifestController.resolveMasterManifest(je.url).then(function(ft) {
                ft.indexOf("data") !== 0 && ft.indexOf("blob") !== 0 || at.setSourceAndLoadVideoElement(je, ft);
              }).catch(function(ft) {
                at.logger.debug("Couldn't access master playlist for native HLS parsing: ".concat(ft));
              });
            });
          }, Ke.prototype.loadHls = function(je) {
            var De;
            if (typeof je.url != "string") {
              var at = new le.PlayerError(_e.ErrorCode.SOURCE_INVALID, { given: je.url }, "Cannot load the HLS playlist: the source URL should be a string.");
              return (De = this.eventHandler) === null || De === void 0 || De.fireError(at), this.loadingDeferred.reject(at), Promise.resolve();
            }
            var dt = this.adjustToFullUrlWithQueryParams(je.url);
            return this.settings.NATIVE_HLS_PARSING ? this.setVideoForNativeHLSParsing(je, dt) : (this.setSourceAndLoadVideoElement(je, dt), Promise.resolve());
          }, Ke.prototype.loadProgressive = function(je, De) {
            if (this.availableVideoStreams = [], Array.isArray(je.url))
              this.loadProgressiveMultiSource(je.url, De);
            else {
              var at = { url: je.url, bitrate: 0 };
              this.video.src = this.adjustToFullUrlWithQueryParams(at.url), this.addStreamToAvailableOnes("0", at), this.setCurrentVideoStream("0", at), this.trackLoading(this.video.getWrappedElement());
            }
            return Promise.resolve();
          }, Ke.prototype.loadProgressiveMultiSource = function(je, De) {
            var at = this, dt = !1;
            De = De || pt(je);
            var ft = this.loadAllSupportedProgressiveSources(je, De, !dt);
            if (ft) {
              var lt = { element: ft, handler: function(nt) {
                return at.handleStreamErrorEvent(_e.ErrorCode.SOURCE_PROGRESSIVE_STREAM_ERROR, ft.src, nt);
              } };
              this.sourceElementEventListeners.push(lt), lt.element.addEventListener(Ue.MediaElementEvent.error, lt.handler), this.restrictedInlinePlayback && this.audio && this.audio.load(), this.trackLoading(ft);
            }
          }, Ke.prototype.handleStreamErrorEvent = function(je, De, at) {
            var dt, ft = this;
            clearTimeout(this.loadTimeoutID), (dt = this.assetAvailabilityChecker) === null || dt === void 0 || dt.dispose(), this.loaded = !0, this.logger.debug("Caught a stream error event (".concat(je, ", ").concat(De, ")"), at), new fe.DefaultContentLoader(this.context).load(De).then(function(lt) {
              return { status: lt.status, statusText: lt.statusText, error: void 0 };
            }).catch(function(lt) {
              return { error: lt, status: (lt == null ? void 0 : lt.status) || 0, statusText: (lt == null ? void 0 : lt.statusText) || "" };
            }).then(function(lt) {
              var nt, ct = lt.error, it = lt.status, et = lt.statusText, st = (at == null ? void 0 : at.message) || at, mt = function(St, $t) {
                ft.loadingDeferred.reject(new le.PlayerError(St, $t, "The video element has thrown an error while loading the stream."));
              };
              it !== 200 ? (nt = { event: at, error: ct, status: it, statusText: et, src: De, extraMessage: st }, ft.logger.debug("last/only source has thrown an error ".concat(it, " - ").concat(et), nt), mt(je, nt)) : (nt = { event: at, error: ct, src: De, extraMessage: st }, ft.logger.debug("last/only source has thrown an error, but we are able to download the asset during the error handling.", nt), ft.sourceConfig && ft.sourceLoadRetryCount < ft.settings.MAX_RETRIES ? (ft.sourceLoadRetryCount++, ft.logger.debug("Reloading the source: attempt ".concat(ft.sourceLoadRetryCount, " of ").concat(ft.settings.MAX_RETRIES, ".")), ft.loadSource(ft.sourceConfig).catch(function() {
                return mt(je, nt);
              })) : mt(je, nt));
            });
          }, Ke.prototype.loadAllSupportedProgressiveSources = function(je, De, at) {
            for (var dt, ft = [], lt = -1, nt = null, ct = null, it = 0; it < je.length; it++) {
              var et = je[it];
              if (!this.shouldIgnoreSourceObject(et, ct, at)) {
                if (dt = Ke.createSourceElement(this.adjustToFullUrlWithQueryParams(et.url), et.type), ct = ct || et.type, this.addStreamToAvailableOnes(String(it), et), at) {
                  if (ft.indexOf(et.type) > -1) {
                    this.logger.debug("Stream of mime type ".concat(et.type, " already added.. continuing"));
                    continue;
                  }
                  De === String(it) ? (nt = dt, lt = et.bitrate, this.appendAndSetVideoStream(dt, String(it), et), ft.push(et.type)) : lt === et.bitrate && (nt = dt, this.appendVideoStream(dt), ft.push(et.type));
                } else
                  nt = dt, this.appendAndSetVideoStream(dt, String(it), et);
                this.restrictedInlinePlayback && this.audio && (this.audio.innerHTML = this.video.innerHTML);
              }
            }
            return nt;
          }, Ke.prototype.shouldIgnoreSourceObject = function(je, De, at) {
            return !Ke.isValidProgressiveSourceObject(je) || !!at && (!this.isMimeTypeSupported(je.type) || !!De && De !== je.type);
          }, Ke.isValidProgressiveSourceObject = function(je) {
            return typeof je == "object" && je && je.url && je.url !== "";
          }, Ke.prototype.appendAndSetVideoStream = function(je, De, at) {
            this.video.appendChild(je), this.setCurrentVideoStream(De, at);
          }, Ke.prototype.appendVideoStream = function(je) {
            this.video.appendChild(je);
          }, Ke.prototype.addStreamToAvailableOnes = function(je, De) {
            var at = { id: je };
            De.bitrate && (at.bitrate = De.bitrate), at.label = String(De.label || De.bitrate || "unknown"), this.availableVideoStreams.push(at);
          }, Ke.prototype.setCurrentVideoStream = function(je, De) {
            this.currentVideoStream = { id: je }, De.bitrate && (this.currentVideoStream.bitrate = De.bitrate), this.currentVideoStream.label = "" + (De.label || De.bitrate || "unknown");
          }, Ke.prototype.isMimeTypeSupported = function(je) {
            return !(this.video.canPlayType(je).length <= 0) || (this.logger.debug("Mime type" + je + " not supported.. continuing"), !1);
          }, Ke.createSourceElement = function(je, De) {
            var at = document.createElement("source");
            return at.src = je, De && (De.indexOf("/") < 0 && (De = "video/" + De), at.type = De), at;
          }, Ke.prototype.unload = function(je, De) {
            var at, dt;
            return je === void 0 && (je = "api"), De === void 0 && (De = !1), this.hlsLiveTimeTracker.onUnload(je), this.clearDelayedSeekHandlers(), this.loadingDeferred && !De && this.loadingDeferred.reject(), clearTimeout(this.loadedDataFallbackTimeoutID), clearTimeout(this.loadTimeoutID), (at = this.assetAvailabilityChecker) === null || at === void 0 || at.dispose(), this.ended = !1, this.fpsHandler = (0, be.dispose)(this.fpsHandler), this.downloadErrorHandler = (0, be.dispose)(this.downloadErrorHandler), this.hlsManifestController = (0, be.dispose)(this.hlsManifestController), this.hlsSeekingGlitchEventHandlers.forEach(function(ft) {
              return ft.el.removeEventListener(ft.ev, ft.fn);
            }), this.hlsSeekingGlitchEventHandlers = [], this.isProgressiveQualityChange || ((dt = this.textTrackController) === null || dt === void 0 || dt.signalSourceChange(), this.textTrackController = (0, be.dispose)(this.textTrackController)), this.clearVideoElement(), this.clearAudioElement(), this.pause(), this.ignoreNextVideoError = !0, this.clearEventListeners(), this.unsubscribeFromStoreStoppedListener && this.unsubscribeFromStoreStoppedListener(), this.allowedToThrowEvents && (this.currentVideoStream = null), this.loaded && (this.loaded = !1, De || (this.eventCallback(ve.PlayerEvent.SourceUnloaded, { oldSource: this.currentSource }), this.lastDuration = null)), Promise.resolve();
          }, Ke.prototype.clearAudioElement = function() {
            if (this.restrictedInlinePlayback && this.audio) {
              for (this.audio.removeAttribute("src"); this.audio.firstChild; )
                this.audio.removeChild(this.audio.firstChild);
              this.audio.load();
            }
          }, Ke.prototype.clearEventListeners = function() {
            var je = this;
            this.restrictedInlinePlayback ? this.audio && this.removeEventListeners(this.audio) : this.removeEventListeners(this.video), this.clearDelayedSeekHandlers(), this.eventHandler.off(ve.PlayerEvent.TimeChanged, this.onTimeChanged), this.eventHandler.off(ve.PlayerEvent.TimeChanged, this.delayedSeek), this.sourceElementEventListeners.forEach(function(De) {
              try {
                De.element.removeEventListener(Ue.MediaElementEvent.error, De.handler);
              } catch (at) {
                je.logger.debug("Error while removing event listener", at);
              }
            });
          }, Ke.prototype.clearVideoElement = function() {
            Ve.VideoElementUtil.removeSource(this.video), this.originalCrossOriginAttributeValue != null ? this.video.setAttribute("crossOrigin", this.originalCrossOriginAttributeValue) : this.video.removeAttribute("crossOrigin"), this.video.load();
          }, Ke.prototype.isReady = function() {
            return this.restrictedInlinePlayback && this.audio && "readyState" in this.audio ? this.audio.readyState !== HTMLMediaElement.HAVE_NOTHING : !("readyState" in this.video) || this.video.readyState !== HTMLMediaElement.HAVE_NOTHING;
          }, Ke.prototype.isLive = function() {
            return this.getElement().duration === 1 / 0;
          }, Ke.prototype.isPlaying = function() {
            return this.stateManager.isPlaying();
          }, Ke.prototype.isPaused = function() {
            return this.stateManager.isPaused();
          }, Ke.prototype.hasEnded = function() {
            return this.ended;
          }, Ke.prototype.isMuted = function() {
            return this.getElement().muted;
          }, Ke.prototype.isStalled = function() {
            return this.stateManager.isStalled;
          }, Ke.prototype.getVolume = function() {
            return 100 * this.getElement().volume;
          }, Ke.prototype.getDuration = function() {
            return this.getElement().duration;
          }, Ke.prototype.convertAudioTrackNativeToApi = function(je) {
            var De = { id: je.id || String(Te.ArrayHelper.toArray(this.video.audioTracks).indexOf(je)), label: je.label, lang: je.language, getQualities: null }, at = this.getLabelForAudio(De);
            return at && typeof at == "string" && (De.label = at), De;
          }, Ke.prototype.getAudio = function() {
            var je = Te.ArrayHelper.toArray(this.video.audioTracks).find(function(De) {
              return De.enabled;
            });
            return je ? this.convertAudioTrackNativeToApi(je) : null;
          }, Ke.prototype.getAvailableAudio = function() {
            var je = this;
            return Te.ArrayHelper.toArray(this.video.audioTracks).map(function(De) {
              return je.convertAudioTrackNativeToApi(De);
            });
          }, Ke.prototype.getLabelForAudio = function(je) {
            var De = { id: je.id, lang: je.lang, mimeType: we.MimeType.AudioMp4 };
            return this.getLabelingFunctionForAudio()(De);
          }, Ke.prototype.getLabelingFunctionForAudio = function() {
            var je = this.context.sourceContext, De = je && je.source && je.source.labeling;
            return De && De[this.type] && De[this.type].tracks ? typeof De[this.type].tracks != "function" ? Ke.getDefaultLabelForAudio : De[this.type].tracks : Ke.getDefaultLabelForAudio;
          }, Ke.getDefaultLabelForAudio = function() {
            return null;
          }, Ke.prototype.getDownloadedVideoData = function() {
            return this.type === ye.StreamType.Progressive ? this.currentVideoStream : this.hlsManifestController ? this.hlsManifestController.getDownloadedVideoData() : { id: Ye, bitrate: 0, height: 0, width: 0, isAuto: !0 };
          }, Ke.prototype.getDownloadedAudioData = function() {
            return { id: Ye, bitrate: 0, isAuto: this.type === ye.StreamType.Progressive };
          }, Ke.prototype.createVideoQualityObject = function(je) {
            var De = {};
            return De.id = je.id, De.label = je.label, je.width > 1 ? De.width = je.width : this.currentVideoStream && this.currentVideoStream.id === je.id && (this.currentVideoStream.width > 1 ? De.width = this.currentVideoStream.width : !isNaN(this.video.videoWidth) && this.video.videoWidth > 1 && (De.width = this.video.videoWidth)), je.height > 1 ? De.height = je.height : this.currentVideoStream && this.currentVideoStream.id === je.id && (this.currentVideoStream.height > 1 ? De.height = this.currentVideoStream.height : !isNaN(this.video.videoHeight) && this.video.videoHeight > 1 && (De.height = this.video.videoHeight)), je.bitrate !== void 0 && je.bitrate !== "unknown" && (De.bitrate = je.bitrate), De;
          }, Ke.prototype.getPlaybackVideoData = function() {
            if (this.hlsManifestController) {
              var je = this.hlsManifestController.getPlayingVideoData();
              if (je)
                return je;
            }
            if (this.currentVideoStream) {
              var De = this.createVideoQualityObject(this.currentVideoStream);
              return this.type !== "progressive" && (De.id = Ye), De;
            }
            return { id: Ye, bitrate: 0, height: this.video.videoHeight, width: this.video.videoWidth };
          }, Ke.prototype.getPlaybackAudioData = function() {
            return { id: Ye, bitrate: 0 };
          }, Ke.prototype.getMaxTimeShift = function() {
            if (!this.isTimeShiftingAllowed())
              return 0;
            var je = this.getSeekableRangeInternal();
            return this.isHlsLive() && je.start >= 0 ? je.start - je.end : 0;
          }, Ke.prototype.isHlsLive = function() {
            return this.type === ye.StreamType.Hls && this.isLive();
          }, Ke.prototype.timeShift = function(je, De) {
            if (this.isTimeShiftingAllowed() && this.isTimeShiftNecessary(je, De))
              if (je === 0) {
                var at = this.getSeekableRangeInternal();
                at.end >= 0 && this.seekForLive(at.end);
              } else
                this.seekForLive(je, De);
          }, Ke.prototype.isTimeShiftNecessary = function(je, De) {
            if (De === pe.STARTUP_ISSUER_NAME && !yt(this.context.sourceContext.source.options))
              return !1;
            var at = Math.abs(Math.abs(je) - Math.abs(this.getTimeShift())), dt = this.isOffsetConsideredAsLiveEdge(je);
            return at > Ge && !(this.isAtLiveEdge && dt);
          }, Ke.prototype.getTimeShift = function() {
            if (this.shouldReturnDefaultTimeshiftValue())
              return ot;
            var je = this.getSeekableRangeInternal();
            if (je.start >= 0 && this.needToUpdateTimeshiftValue()) {
              var De = bt(this.getElement().currentTime - je.end, this.getTimeshiftRange());
              this.isAtLiveEdge = this.isOffsetConsideredAsLiveEdge(De) && !this.isStalledOrPaused(), this.currentTimeShift = this.isAtLiveEdge ? ot : De;
            }
            return isFinite(this.currentTimeShift) ? this.currentTimeShift : ot;
          }, Ke.prototype.shouldReturnDefaultTimeshiftValue = function() {
            return !this.isLive() || !this.stateManager.hasBeenPlaying && !this.stateManager.seekedOrTimeshifted || this.isAtLiveEdge;
          }, Ke.prototype.isStalledOrPaused = function() {
            return this.isStalled() || this.isPaused();
          }, Ke.prototype.needToUpdateTimeshiftValue = function() {
            return !isFinite(this.currentTimeShift) || this.isStalledOrPaused();
          }, Ke.prototype.getManifest = function() {
            return this.hlsManifestController ? this.hlsManifestController.getManifest() : null;
          }, Ke.prototype.getSnapshot = function(je, De) {
            if (this.isPlaying() || this.isPaused()) {
              var at = this.video.videoWidth, dt = this.video.videoHeight;
              if (this.snapshotCanvas || (this.snapshotCanvas = document.createElement("canvas"), this.snapshotCanvas.id = "snapshotHiddenCanvas"), !this.snapshotCanvas || !this.snapshotCanvas.getContext || !this.snapshotCanvas.getContext("2d"))
                return;
              this.snapshotCanvas.height = dt, this.snapshotCanvas.width = at, this.snapshotCanvasContext = this.snapshotCanvas.getContext("2d"), this.snapshotCanvasContext.drawImage(this.video.getWrappedElement(), 0, 0, at, dt);
              var ft = void 0;
              try {
                je === "image/jpeg" || je === "image/webp" ? (Number(De) === De ? (De < 0 || De > 1) && (De = 1) : De = 1, ft = this.snapshotCanvas.toDataURL(je, De)) : ft = this.snapshotCanvas.toDataURL(je, De);
              } catch (lt) {
                return void (lt && lt.message ? this.logger.debug("Snapshot acquisition failed: " + lt.message) : this.logger.debug("Snapshot acquisition failed"));
              }
              return { height: dt, width: at, data: ft };
            }
          }, Ke.prototype.setPlaybackSpeed = function(je) {
            this.getElement().playbackRate = je;
          }, Ke.prototype.getPlaybackSpeed = function() {
            return this.getElement().playbackRate;
          }, Ke.prototype.permitControl = function(je) {
            this.controlPermitted = je;
          }, Ke.prototype.resetTimeShift = function() {
            this.currentTimeShift = -1 / 0, this.isTimeShiftingAllowed() && (this.isAtLiveEdge = !1);
          }, Ke.prototype.isOffsetConsideredAsLiveEdge = function(je) {
            return Math.abs(je) < 2 * this.settings.SEEK_TO_END_OFFSET;
          }, Ke.prototype.isSeekTargetChangedDuringStartup = function() {
            return this.seekTargetTime !== this.lastVerifiedPlaybackPosition && this.lastSeekIssuer === pe.STARTUP_ISSUER_NAME;
          }, Ke.prototype.maybeHandleSeekTargetChangeDuringStartup = function() {
            this.isSeekTargetChangedDuringStartup() && (this.context.logger.debug("Seek target changed during startup..."), this.triggerSeekEvent(this.seekTargetTime), this.lastSeekIssuer = "api", this.seekTargetTime = -1);
          }, Ke.prototype.finishedSeekedTransitionState = function() {
            this.stateManager.isSeeking() && (this.stateManager.transitionToSeekedState(this.lastSeekIssuer !== pe.STARTUP_ISSUER_NAME), this.lastSeekIssuer = "api"), this.stateManager.isTimeShifting() && this.stateManager.transitionToTimeShiftedState(this.lastSeekIssuer !== pe.STARTUP_ISSUER_NAME);
          }, Ke.prototype.addEventListeners = function(je) {
            for (var De = 0; De < this.elementEvents.length; De++) {
              var at = this.elementEvents[De].elementSelector ? this.elementEvents[De].elementSelector(je) : je;
              at && at.addEventListener(this.elementEvents[De].event, this.elementEvents[De].handler);
            }
          }, Ke.prototype.removeEventListeners = function(je) {
            for (var De = 0; De < this.elementEvents.length; De++) {
              var at = this.elementEvents[De].elementSelector ? this.elementEvents[De].elementSelector(je) : je;
              at && at.removeEventListener && at.removeEventListener(this.elementEvents[De].event, this.elementEvents[De].handler);
            }
          }, Ke.prototype.getBufferLevel = function(je) {
            var De = { level: null, targetLevel: null, type: je, media: ye.MediaType.Video }, at = this.getElement();
            if (!at.buffered || at.buffered.length < 1)
              return De;
            var dt = function(it) {
              for (var et = 0; et < at.buffered.length; et++) {
                var st = at.buffered.start(et), mt = at.buffered.end(et);
                st > it || mt <= it || (De.level = mt - it, je === ye.BufferType.BackwardDuration && (De.level = it - st));
              }
            }, ft = at.currentTime;
            if (dt(ft), De.level == null) {
              var lt = gt(at, ft), nt = lt.distanceToCurrentTime, ct = lt.closestBufferStart;
              nt < 1 && (this.context.logger.debug("Adjusting buffer level to closest buffer range ", ct), dt(ct));
            }
            return De;
          }, Ke.prototype.createTextTrackController = function() {
            if (Re.ModuleManager.has(Ne.ModuleName.SubtitlesNative))
              return new (Re.ModuleManager.get(Ne.ModuleName.SubtitlesNative)).TextTrackController(this.context, this.video, this.config, this.type);
            this.logger.log("Unable to create native SubtitleController because the ".concat(Ne.ModuleName.SubtitlesNative, " module is missing"));
          }, Ke.prototype.removeSubtitle = function(je) {
            je && this.textTrackController && this.textTrackController.removeSubtitle(je);
          }, Ke.prototype.addSubtitle = function(je) {
            return this.textTrackController ? (this.removeSubtitle(je.id), je.kind = "subtitles", this.textTrackController.addSubtitle(je)) : Promise.reject();
          }, Ke.prototype.listSubtitles = function() {
            return this.textTrackController ? this.textTrackController.getAvailableSubtitles() : [];
          }, Ke.prototype.enableSubtitle = function(je) {
            return this.textTrackController ? this.textTrackController.enableSubtitle(je) : Promise.resolve(!1);
          }, Ke.prototype.disableSubtitle = function(je) {
            return this.textTrackController ? Promise.resolve(this.textTrackController.disableSubtitle(je)) : Promise.resolve(!1);
          }, Ke.prototype.adjustToFullUrlWithQueryParams = function(je) {
            var De = Oe.URLHelper.toFullUrl(je);
            return Oe.URLHelper.appendQueryParametersToUrl(De, this.settings.QUERY_PARAMETERS);
          }, Ke.prototype.onFullscreenEnter = function() {
            this.isInNativeFullscreen = this.video.webkitDisplayingFullscreen, this.textTrackController && this.isInNativeFullscreen && this.textTrackController.enableNative();
          }, Ke.prototype.onFullscreenExit = function() {
            this.textTrackController && this.isInNativeFullscreen && this.textTrackController.disableNative(), this.isInNativeFullscreen = !1;
          }, Ke.prototype.getAvailableVideoQualities = function() {
            var je = this;
            return this.type !== "progressive" ? [] : this.availableVideoStreams.map(function(De) {
              return je.createVideoQualityObject(De);
            });
          }, Ke.prototype.getBufferedRanges = function() {
            var je = this;
            return (0, he.getBufferedRanges)(this.getElement()).map(function(De) {
              return (0, he.convertRangeToTimeMode)(De, je.getStartDate(), ye.TimeMode.AbsoluteTime);
            });
          }, Ke.prototype.setVideoQuality = function(je) {
            var De, at = this, dt = this.getPlaybackSpeed(), ft = this.availableVideoStreams.find(function(it) {
              return it.id === je;
            });
            if (this.type === "progressive" && ft && (!this.currentVideoStream || this.currentVideoStream.id !== je)) {
              this.isProgressiveQualityChange = !0, this.currentTimeWas = this.getCurrentTime(), this.availableVideoStreams = [], this.allowedToThrowEvents = !1;
              var lt = this.stateManager.isPlaying() || this.stateManager.isPlay();
              this.stateManager.stallEnter(), this.unload("api", !0).catch(function() {
              });
              var nt = this.createVideoQualityObject(ft), ct = { sourceQuality: this.currentVideoStream, sourceQualityId: this.currentVideoStream ? this.currentVideoStream.id : null, targetQuality: nt, targetQualityId: nt.id };
              this.eventHandler.one(ve.PlayerEvent.StallEnded, function() {
                at.allowedToThrowEvents = !0, (0, Ce.getCapabilities)().isIOS || (0, Ce.getCapabilities)().isSafari ? (at.numTimeChanged = 0, at.eventHandler.on(ve.PlayerEvent.TimeChanged, at.delayedSeek)) : (at.numTimeChanged = 1 / 0, at.delayedSeek()), lt && (at.play(pe.INTERNAL_ISSUER_NAME).catch(function() {
                  at.eventCallback(ve.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.PLAYBACK_COULD_NOT_BE_STARTED));
                }), at.stateManager.transitionToPlayingState(pe.INTERNAL_ISSUER_NAME, !1));
              }), this.eventCallback(ve.PlayerEvent.VideoQualityChanged, ae({}, ct), !0), (De = this.airplayService) === null || De === void 0 || De.initAirplay(), this.load(this.sourceConfig, this.settings.GLOBAL_DISABLE_SEEKING, je).then(function() {
                at.setPlaybackSpeed(dt), at.eventCallback(ve.PlayerEvent.VideoDownloadQualityChange, ae({}, ct), !0), at.eventCallback(ve.PlayerEvent.VideoDownloadQualityChanged, ae({}, ct), !0), at.eventCallback(ve.PlayerEvent.VideoPlaybackQualityChanged, { sourceQuality: ct.sourceQuality, targetQuality: ct.targetQuality }, !0);
              });
            }
          }, Ke.prototype.isAirplayAvailable = function() {
            var je, De;
            return (De = (je = this.airplayService) === null || je === void 0 ? void 0 : je.isAirplayAvailable()) !== null && De !== void 0 && De;
          }, Ke.prototype.isAirplayActive = function() {
            var je, De;
            return (De = (je = this.airplayService) === null || je === void 0 ? void 0 : je.isAirplayActive()) !== null && De !== void 0 && De;
          }, Ke.prototype.showAirplayTargetPicker = function() {
            var je;
            (je = this.airplayService) === null || je === void 0 || je.showAirplayTargetPicker();
          }, Ke.prototype.getTimeshiftRange = function() {
            return this.isLive() ? { start: this.getMaxTimeShift(), end: 0 } : { start: -1, end: -1 };
          }, Ke.prototype.getSeekableRangeInternal = function() {
            var je = this.video.seekable;
            if (je.length > 0) {
              var De = { start: je.start(0), end: je.end(0) };
              return De.start = Math.max(0, De.start), De;
            }
            return { start: -1, end: -1 };
          }, Ke.prototype.getSeekableRange = function() {
            if (!this.isLive() || this.settings.ENABLE_SEEK_FOR_LIVE) {
              var je = this.getStartDate(), De = this.getSeekableRangeInternal();
              return je ? (0, he.convertRangeToTimeMode)(De, je, ye.TimeMode.AbsoluteTime) : De;
            }
            return { start: -1, end: -1 };
          }, Ke.prototype.createManifestApi = function() {
            return this.hlsManifestController ? Qe.NativePlayerManifestApiFactory.create(this.hlsManifestController) : null;
          }, Ke.prototype.release = function() {
            var je, De = this, at = this.unload("api").catch(function() {
            });
            return clearTimeout(this.loadTimeoutID), at = at.then(function() {
              De.type = null, De.config = null, De.eventHandler = null, De.settings = null, De.currentTimeWas = null, De.snapshotCanvas = null, De.snapshotCanvasContext = null, De.audio = null, De.video = null, De.lastPlayIssuer = null, De.lastPauseIssuer = null, De.lastSeekIssuer = null, De.currentSource = null, De.sourceConfig = null, De.currentVideoStream = null, De.availableVideoStreams = null, De.sourceElementEventListeners = null, De.delayedSeekTarget = void 0;
            }), (je = this.airplayService) === null || je === void 0 || je.dispose(), this.textTrackController && this.textTrackController.dispose(), this.textTrackController = null, this.fpsHandler && this.fpsHandler.dispose(), this.fpsHandler = null, this.downloadErrorHandler && this.downloadErrorHandler.dispose(), this.downloadErrorHandler = null, this.hlsManifestController && this.hlsManifestController.dispose(), this.hlsManifestController = null, at;
          }, Ke.prototype.setQueryParameters = function(je) {
            this.settings.QUERY_PARAMETERS = je;
          }, Ke.prototype.clearQueryParameters = function() {
            this.settings.QUERY_PARAMETERS = void 0;
          }, Ke.prototype.setAudioQuality = function(je) {
          }, Ke.prototype.setTargetBufferLevel = function() {
          }, Ke.prototype.getAvailableAudioQualities = function() {
            return [];
          }, Ke.prototype.getDroppedVideoFrames = function() {
            return 0;
          }, Ke.prototype.getTotalStalledTime = function() {
            return 0;
          }, Ke.prototype.updateCallback = function(je) {
          }, Ke.prototype.getAvailableSegments = function() {
            return {};
          }, Ke.prototype.getLatency = function() {
            var je = this.video.getWrappedElement();
            if (!je.getStartDate)
              return 1 / 0;
            var De = je.getStartDate().getTime();
            if (isNaN(De))
              return 1 / 0;
            var at = (/* @__PURE__ */ new Date()).getTime();
            return (0, Me.toSeconds)(at - De) - this.video.currentTime;
          }, Ke.prototype.setTargetLatency = function(je) {
          }, Ke.prototype.getTargetLatency = function() {
            return null;
          }, Ke.prototype.setCatchupConfig = function(je) {
          }, Ke.prototype.getCatchupConfig = function() {
            return null;
          }, Ke.prototype.setFallbackConfig = function(je) {
          }, Ke.prototype.getFallbackConfig = function() {
            return null;
          }, ce([(0, ge.trackPerformance)("NativePlayer.load", !0)], Ke.prototype, "load", null), Ke;
        }();
        function gt(Ke, je) {
          for (var De = Ke.buffered.start(0), at = Math.abs(De - je), dt = 1; dt < Ke.buffered.length; dt++) {
            var ft = Math.abs(Ke.buffered.start(dt) - je);
            ft < at && (at = ft, De = Ke.buffered.start(dt));
          }
          return { distanceToCurrentTime: at, closestBufferStart: De };
        }
        function yt(Ke) {
          return (Ke == null ? void 0 : Ke.startTime) != null || (Ke == null ? void 0 : Ke.startOffset) != null;
        }
        function pt(Ke) {
          var je = Ke.findIndex(function(De) {
            return De.preferred === !0;
          });
          return je > -1 ? String(je) : "0";
        }
        function bt(Ke, je) {
          return (Ke < je.start || Ke > je.end) && (Ke = Math.max(Ke, je.start), Ke = Math.min(Ke, je.end)), Ke;
        }
        function ut(Ke) {
          return Ke.length > 0 && Ke.end(Ke.length - 1) !== 1 / 0;
        }
        ne.NativePlayer = vt;
      }, 76250: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.replaceManifestUrls = he, ne.parseUrlFromLine = _e, ne.replaceUrlAndAddUriParams = le;
        var ae = ie(76885), ce = /URI="([^"]+)"/;
        function he(se, oe, ue) {
          var be = oe.split(/\r?\n/);
          return be.forEach(function(ve, me) {
            var pe = _e(ve);
            if (pe && ve.match(ce)) {
              var fe = le(se, pe, ue);
              be[me] = ve.replace(ce, function() {
                return 'URI="'.concat(fe, '"');
              });
            } else
              pe && (be[me] = le(se, pe, ue));
          }), be.join(`
`);
        }
        function _e(se) {
          if (se[0] !== "#" && se.trim().length > 0)
            return se;
          if (se.indexOf("URI") > -1) {
            var oe = se.match(ce);
            if (oe && oe[1].indexOf("skd://") < 0 && oe[1].indexOf("skds://") < 0)
              return oe[1];
          }
          return null;
        }
        function le(se, oe, ue) {
          var be = ae.URLHelper.concatBaseUrlWithPartial(se, oe);
          return ae.URLHelper.appendQueryParametersToUrl(be, ue);
        }
      }, 77117: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.AbstractHlsManifestController = void 0;
        var ae, ce, he = ie(18665), _e = ie(62510), le = ie(63331), se = ie(54861), oe = ie(489), ue = ie(3941), be = ie(331), ve = ie(54838), me = ie(91520), pe = ie(16368);
        (function(Ce) {
          Ce.CueTag = "cueTag", Ce.Scte35 = "scte35", Ce.DateRange = "dateRange", Ce.CustomTags = "customTags";
        })(ae || (ae = {}));
        var fe = `#EXTM3U
#EXT-X-STREAM-INF:PROGRAM-ID=1,BANDWIDTH=100000
$VARIANT$
`, ge = function() {
          function Ce(Ie) {
            var Te, Ee = this;
            this.context = Ie, this.discontinuitySequences = [], this.onManifestMetadata = function(we) {
              if (we.hasOwnProperty("metadata")) {
                var Pe = { metadataType: we.metadataType.toUpperCase(), metadata: we.metadata };
                (we.start || we.start === 0) && (Pe.start = we.start), we.end && (Pe.end = we.end), Ee.context.eventHandler.dispatchEvent(_e.PlayerEvent.Metadata, Pe);
              }
            }, this.onTimeChangedHandler = function(we) {
              var Pe = Ee.segmentTimelineController.getPlayingSegment(we.relativeTime || we.time);
              Pe && !Pe.consumed && (Pe.consumed = !0, Ee.triggerMetadata(Pe), Ee.triggerSegmentPlayback(Pe));
            }, this.onTimeShiftedHandler = function() {
              Ee.segmentTimelineController.reset();
            }, this.onSeeked = function() {
              Ee.segmentTimelineController.reset();
            }, this.registerVariantPlaylist = function(we) {
              var Pe, Me = Ee.parsePlaylist(we.body), Ae = (Pe = Ee.parsedManifest.playlists) === null || Pe === void 0 ? void 0 : Pe.find(function(ke) {
                return we.url.includes(ke.uri);
              });
              if (Ee.isValidVariantPlaylist(Me) && Ae) {
                var Oe = function(ke) {
                  var Le, He;
                  return (He = (Le = Ee.parsedManifest.media) === null || Le === void 0 ? void 0 : Le.some(function(We) {
                    var Xe;
                    return (Xe = We.attributes.URI) === null || Xe === void 0 ? void 0 : Xe.includes(ke);
                  })) !== null && He !== void 0 && He;
                }, Be = function(ke) {
                  var Le, He;
                  return (He = (Le = ke.playlists) === null || Le === void 0 ? void 0 : Le.every(function(We) {
                    return Oe(We.uri);
                  })) !== null && He !== void 0 && He;
                }, Ve = function(ke) {
                  var Le, He;
                  return (He = (Le = Ee.parsedManifest.playlists) === null || Le === void 0 ? void 0 : Le.some(function(We) {
                    return ke.uri.includes(We.uri) && !Oe(ke.uri);
                  })) !== null && He !== void 0 && He;
                };
                if (Ve(Ae) || Be(Ee.parsedManifest)) {
                  Ee.segmentTimelineController.switchTimeline(Ae.id), ce.extrapolateProgramDateTime(Me.segments), Ee.discontinuitySequences = ce.createDiscontinuitySequences(Me, Ee.discontinuitySequences);
                  var Ue = Se(Me, Ae.id, Ee.config);
                  Ee.metadataParsedService.expirationTimeInSeconds = Ee.segmentTimelineController.updateTimeline(Ae.id, Ue);
                  var Re = Ee.segmentTimelineController.getCurrentTimeline();
                  if (Ue[0].dateTime) {
                    var Ne = ve.Util.timeInSeconds(Ue[0].dateTime);
                    Ee.metadataService.removeUntil(Ne);
                  }
                  (0, le.extractDateRangeMetadata)(Me.dateRange, Me.endList ? Me.programDateTime : void 0, function(ke) {
                    Ee.addDateRangeMetadata(ke);
                  });
                  var xe = !(Me != null && Me.endList);
                  return Ee.extractMetadataFromTimeline(Re, xe), Me;
                }
              }
            }, ce = me.ModuleManager.get(pe.ModuleName.HLS).PlaylistUtils, this.settings = Ie.settings, this.config = Ie.config, this.eventHandler = Ie.eventHandler, this.originalManifest = null, this.metadataParsedService = Ie.serviceManager.get(he.ServiceName.MetadataParsedService), this.eventHandler.on(_e.PlayerEvent.TimeChanged, this.onTimeChangedHandler), this.eventHandler.on(_e.PlayerEvent.TimeShifted, this.onTimeShiftedHandler), this.eventHandler.on(_e.PlayerEvent.Seeked, this.onSeeked), this.metadataService = new se.MetadataService(this.context, ((Te = {})[oe.TimedMetadataType.Manifest] = this.onManifestMetadata, Te[oe.TimedMetadataType.DateRange] = this.onManifestMetadata, Te));
          }
          return Ce.prototype.triggerSegmentPlayback = function(Ie) {
            var Te = { url: Ie.uri, uid: null, mimeType: "video/mp4", playbackTime: Ie.playbackTime, duration: Ie.duration, mediaInfo: {}, dateTime: null };
            Ie.dateTime && (Te.dateTime = Ie.dateTime.toISOString()), Ie.customTags && Ie.customTags.length > 0 && (Te.EXPERIMENTAL = Te.EXPERIMENTAL || {}, Te.EXPERIMENTAL.hlsAttributes = Ie.customTags.map(function(Ee) {
              return Ee.attributes;
            })), this.context.eventHandler.dispatchEvent(_e.PlayerEvent.SegmentPlayback, Te);
          }, Ce.prototype.triggerMetadata = function(Ie) {
            var Te = this;
            Ie.metadata && Ie.metadata.forEach(function(Ee) {
              $e(Ee) ? Te.context.eventHandler.dispatchEvent(_e.PlayerEvent.Metadata, { metadataType: _e.MetadataType.CUETAG, metadata: Ee }) : Te.context.eventHandler.dispatchEvent(_e.PlayerEvent.Metadata, { metadataType: Ee.type, metadata: Ee });
            });
          }, Ce.prototype.resolveMasterManifest = function(Ie) {
            return this.parsedManifest ? Promise.resolve(this.manifestUrl) : (this.manifestUrl = Ie, this.downloadMasterManifest(Ie));
          }, Ce.prototype.registerMasterManifest = function(Ie, Te) {
            var Ee;
            this.originalManifest = Ie.body;
            var we = this.processMasterManifest((Ee = Ie.body) !== null && Ee !== void 0 ? Ee : "", Te);
            if (this.parsedManifest = this.parsePlaylist(we), this.isValidMasterPlaylist(this.parsedManifest))
              return we;
            if (this.isValidVariantPlaylist(this.parsedManifest)) {
              var Pe = fe.replace("$VARIANT$", Te);
              we = this.processMasterManifest(Pe, Te), this.originalManifest = Pe, this.parsedManifest = this.parsePlaylist(we);
            } else
              this.parsedManifest = null;
            return we;
          }, Ce.prototype.isValidMasterPlaylist = function(Ie) {
            return Ie != null && "playlists" in Ie && Ie.playlists.length > 0;
          }, Ce.prototype.isValidVariantPlaylist = function(Ie) {
            return Ie != null && "segments" in Ie && Ie.segments.length > 0;
          }, Ce.prototype.parsePlaylist = function(Ie) {
            var Te = me.ModuleManager.get(pe.ModuleName.HLS).parsePlaylist;
            try {
              return Te(Ie);
            } catch {
              return null;
            }
          }, Ce.prototype.addDateRangeMetadata = function(Ie) {
            var Te = { metadataType: _e.MetadataType.DATERANGE, metadata: Ie.data, start: Ie.startTime, end: Ie.endTime };
            this.addMetadata(Te);
          }, Ce.prototype.metadataToMetadataParsedEvent = function(Ie) {
            return { metadataType: Ie.metadataType, metadata: Ie.metadata, data: Ie.metadata, start: Ie.start, end: Ie.end };
          }, Ce.prototype.addMetadata = function(Ie) {
            var Te = Ie.metadataType === "DATERANGE" ? oe.TimedMetadataType.DateRange : oe.TimedMetadataType.Manifest;
            this.metadataService.addToMetadataParsedService(Ie.start, this.metadataToMetadataParsedEvent(Ie), ue.DEFAULT_PERIOD_ID), this.metadataService.addToTimeline(Te, Ie.start, Ie);
          }, Ce.prototype.extractMetadataFromTimeline = function(Ie, Te) {
            var Ee = this;
            Ie.forEach(function(we) {
              Object.values(ae).forEach(function(Pe) {
                we.hasOwnProperty(Pe) && ye(Pe, we, Te).forEach(function(Me) {
                  return Ee.addMetadata(Me);
                });
              });
            });
          }, Ce.prototype.parseTimelineEntries = function(Ie) {
            var Te = this.parsePlaylist(Ie), Ee = function(we) {
              var Pe;
              return { uri: we.uri, duration: we.duration, discontinuity: (Pe = we.discontinuity) !== null && Pe !== void 0 && Pe, dateTime: null, metadata: [], consumed: !1, playbackTime: -1, keys: [] };
            };
            return this.isValidVariantPlaylist(Te) ? Te.segments.map(Ee) : [];
          }, Ce.prototype.getPlaybackTimeOfFirstSegmentInTimeline = function(Ie) {
            for (var Te = 0; Te < Ie.length; Te++)
              for (var Ee = Ie[Te], we = 0, Pe = 0; Pe < Ee.timeline.length; Pe++) {
                for (var Me = Ee.timeline[Pe], Ae = this.segmentTimelineController.getCurrentTimeline(), Oe = 0; Oe < Ae.length; Oe++) {
                  var Be = Ae[Oe];
                  if (Be.uri === Me.uri)
                    return Be.playbackTime - we;
                }
                we += Me.duration;
              }
            return -1;
          }, Ce.prototype.getParsedManifest = function() {
            return this.parsedManifest;
          }, Ce.prototype.getManifest = function() {
            return this.originalManifest;
          }, Ce.prototype.detachEventHandlers = function() {
            this.eventHandler && (this.eventHandler.off(_e.PlayerEvent.TimeChanged, this.onTimeChangedHandler), this.eventHandler.off(_e.PlayerEvent.TimeShifted, this.onTimeShiftedHandler), this.eventHandler.off(_e.PlayerEvent.Seeked, this.onSeeked));
          }, Ce.prototype.dispose = function() {
            this.detachEventHandlers(), this.segmentTimelineController && (this.segmentTimelineController.dispose(), this.segmentTimelineController = null), this.metadataService && (this.metadataService.dispose(), this.metadataService = null), this.parsedManifest = null, this.originalManifest = null, this.manifestUrl = null, this.settings = null, this.config = null, this.eventHandler = null;
          }, Ce;
        }();
        function ye(Ce, Ie, Te) {
          var Ee = Te && Ie.dateTime ? (0, be.toSeconds)(Ie.dateTime.getTime()) : Ie.playbackTime;
          switch (Ce) {
            case ae.CueTag:
              return [{ metadataType: _e.MetadataType.CUETAG, metadata: Ie[ae.CueTag], start: Ee }];
            case ae.Scte35:
              return [{ metadataType: _e.MetadataType.SCTE, metadata: Ie[ae.Scte35], start: Ee }];
            case ae.CustomTags:
              return [{ metadataType: _e.MetadataType.CUSTOM, metadata: Ie[ae.CustomTags], start: Ee, end: Ee + Ie.duration }];
            default:
              return [];
          }
        }
        function $e(Ce) {
          return Ce.type.includes("CUE");
        }
        function Se(Ce, Ie, Te) {
          for (var Ee, we = Ce.segments, Pe = we.some(function(Be) {
            return Be.dateTime !== void 0;
          }), Me = 0; Me < we.length; Me++) {
            var Ae = we[Me];
            if (Ae.variantPlaylistId = Ie, Ae.mediaSequenceNumber = Ce.mediaSequence + Me, !Pe && ((Ee = Te.tweaks) === null || Ee === void 0 ? void 0 : Ee.akamai_datetime_parsing)) {
              var Oe = ce.getProgramDateTimeFromSegmentUrl(Ae.uri, Ae.duration);
              Oe && (Ae.dateTime = Oe);
            }
          }
          return we;
        }
        ne.AbstractHlsManifestController = ge;
      }, 91229: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.createHlsManifestController = le, ne.shouldUseServiceWorker = se;
        var ae = ie(91520), ce = ie(16368), he = ie(77117), _e = ie(70661);
        function le(ue) {
          if (se(ue)) {
            var be = new (ae.ModuleManager.get(ce.ModuleName.ServiceWorkerClient).createServiceWorkerHlsManifestController(he.AbstractHlsManifestController))(ue);
            return be.init().then(function() {
              return be;
            }).catch(function() {
              return oe(ue);
            });
          }
          return oe(ue);
        }
        function se(ue) {
          var be = ue.config.location && ue.config.location.serviceworker;
          return "serviceWorker" in navigator && be && ae.ModuleManager.has(ce.ModuleName.ServiceWorkerClient);
        }
        function oe(ue) {
          var be = new _e.FallbackHlsManifestController(ue);
          return be.init().then(function() {
            return be;
          });
        }
      }, 96926: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.TechnologyChecker = void 0;
        var ae = ie(33696), ce = function() {
          function he() {
          }
          return he.prototype.getSupportedTechnologies = function() {
            return [{ player: ae.PlayerType.Native, streaming: ae.StreamType.Progressive }, { player: ae.PlayerType.Native, streaming: ae.StreamType.Hls }, { player: ae.PlayerType.Native, streaming: ae.StreamType.Dash }];
          }, he;
        }();
        ne.TechnologyChecker = ce;
      } }, function(ee) {
        return function(ne) {
          return ee(ee.s = ne);
        }(42966);
      }]);
    });
  })();
})(bitmovinplayerEngineNative);
var bitmovinplayerEngineNativeExports = bitmovinplayerEngineNative.exports;
const EngineNative = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerEngineNativeExports);
var bitmovinplayerHls = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ne) {
      re.exports = ne();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[458], { 293: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Te) {
            for (var Ee, we = 1, Pe = arguments.length; we < Pe; we++)
              for (var Me in Ee = arguments[we])
                Object.prototype.hasOwnProperty.call(Ee, Me) && (Te[Me] = Ee[Me]);
            return Te;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HlsBackupStreamsHandler = ne.BackupStreamErrors = void 0;
        var ce, he = ie(18665), _e = ie(23234), le = ie(27279), se = ie(79814), oe = ie(65114), ue = ie(99162), be = ie(41735), ve = ie(77874), me = ie(9827), pe = ie(53950), fe = ie(79367);
        (function(Te) {
          Te.ALL_PENALIZED = "ALL_PENALIZED", Te.LOADING_FAILED = "LOADING_FAILED", Te.NO_BACKUP_STREAMS = "NO_BACKUP_STREAMS";
        })(ce || (ne.BackupStreamErrors = ce = {}));
        var ge = function() {
          function Te(Ee, we, Pe) {
            this.context = Ee, this.backupStreamInfo = we, this.updateRepresentation = Pe, this.backupStreamsMap = {}, this.penalizedStreams = {}, this.hasSourceLoadingFinished = !1, this.manifestService = Ee.serviceManager.get(he.ServiceName.ManifestService, Ee.sourceContext.sourceIdentifier), this.manifestSchedulingService = this.context.serviceManager.get(he.ServiceName.ManifestUpdateSchedulingService, this.context.sourceContext.sourceIdentifier);
          }
          return Te.prototype.populateBackupStreamsMap = function(Ee) {
            var we;
            this.backupStreamsMap = $e(this.backupStreamInfo, Ee), (we = (0, le.getSourceStore)(this.context)) === null || we === void 0 || we.dispatch((0, fe.setContentLocationId)(String(0)));
          }, Te.prototype.signalLoadingFinished = function() {
            this.hasSourceLoadingFinished = !0;
          }, Te.prototype.switchToBackupStream = function(Ee, we) {
            var Pe, Me, Ae = this, Oe = (Me = (Pe = this.backupStreamsMap[Ee._mimeType]) === null || Pe === void 0 ? void 0 : Pe[Ee._id]) !== null && Me !== void 0 ? Me : {};
            if (Object.keys(Oe).length <= 1)
              return Promise.reject(ce.NO_BACKUP_STREAMS);
            var Be = this.getCurrentRepresentation(Ee._mimeType), Ve = (Be == null ? void 0 : Be._id) === Ee._id && (Be == null ? void 0 : Be.Uri) !== Ee.Uri, Ue = Ie(Ee, we);
            if (Ve || !Ue)
              return this.context.logger.debug("Ignoring outdated failover request for ".concat(Ee._mimeType, " rep ").concat(Ee._id), { hasPlaylistUriChanged: Ve, isSegmentInPlaylist: Ue }), Promise.resolve([Be]);
            var Re = Se(Oe, Ee.Uri);
            if (Re === void 0)
              return this.context.logger.debug("Could not find the failing rep in the current list of backup streams.", { id: Ee._id, uri: Ee.Uri, backupStreams: Oe }), Promise.reject(ce.NO_BACKUP_STREAMS);
            this.penalizeLocationId(Re), this.depenalizeExpiredStreams();
            var Ne = this.getNextLocationId(Object.keys(Oe), Re);
            return Ne === void 0 ? (this.context.logger.debug("No other backup stream is available: all penalized."), Promise.reject(ce.ALL_PENALIZED)) : (this.context.logger.debug("Starting failover from stream ".concat(Re, " to ").concat(Ne)), this.triggerPlaylistRotation(Ee, Re, Ne).then(function(xe) {
              var ke, Le, He, We = Se(Oe, (Le = (ke = xe[0]) === null || ke === void 0 ? void 0 : ke.Uri) !== null && Le !== void 0 ? Le : "");
              return (He = (0, le.getSourceStore)(Ae.context)) === null || He === void 0 || He.dispatch((0, fe.setContentLocationId)(String(We))), Ae.context.logger.debug("Successfully completed failover to stream index ".concat(We)), xe;
            }).catch(function(xe) {
              return xe === ue.REPRESENTATION_UPDATE_CANCEL ? Promise.reject(xe) : (Ae.context.logger.debug("Failover from stream ".concat(Re, " to ").concat(Ne, " failed")), Promise.reject(ce.LOADING_FAILED));
            }));
          }, Te.prototype.penalizeLocationId = function(Ee) {
            this.context.logger.debug("Penalizing stream ".concat(Ee, " for ").concat(this.context.settings.HLS_BACKUP_STREAM_PENALTY_DURATION, "s")), this.penalizedStreams[Ee] = _e.TimingUtil.getHiResTimestamp();
          }, Te.prototype.depenalizeExpiredStreams = function() {
            var Ee = this, we = _e.TimingUtil.getHiResTimestamp();
            Object.keys(this.penalizedStreams).forEach(function(Pe) {
              var Me = Ee.penalizedStreams[Pe];
              we - Me >= Ee.context.settings.HLS_BACKUP_STREAM_PENALTY_DURATION && (Ee.context.logger.debug("Depenalizing stream ".concat(Pe)), delete Ee.penalizedStreams[Pe]);
            });
          }, Te.prototype.triggerPlaylistRotation = function(Ee, we, Pe) {
            var Me = this, Ae = [Ee], Oe = Ee._mimeType === se.MimeType.AudioMp4 ? this.getCurrentRepresentation(se.MimeType.VideoMp4) : this.getCurrentRepresentation(se.MimeType.AudioMp4);
            Oe && this.hasSourceLoadingFinished && Ae.push(Oe);
            var Be = Ae.map(function(Ve) {
              return Me.rotatePlaylist(Ve, Pe).catch(function(Ue) {
                var Re;
                return Ue !== ue.REPRESENTATION_UPDATE_CANCEL && (Me.context.logger.debug("Failed to rotate URL for rep ".concat(Ve._id, ": ").concat((Re = Ue == null ? void 0 : Ue.message) !== null && Re !== void 0 ? Re : Ue)), Me.revertPlaylistRotation(Ve, we)), Promise.reject(Ue);
              });
            });
            return Promise.all(Be);
          }, Te.prototype.rotatePlaylist = function(Ee, we) {
            var Pe = this, Me = (0, le.getSourceStore)(this.context);
            if (!Me)
              return Promise.resolve(Ee);
            this.rotateAllRepresentations(Ee, we, Me);
            var Ae = (0, ve.getManifest)(Me.getState());
            if (!Ae)
              return Promise.resolve(Ee);
            var Oe = Ee._internalId, Be = (0, oe.findRepresentation)(Ae, Oe);
            return Ee.Uri === (Be == null ? void 0 : Be.Uri) ? (this.context.logger.debug("Current ".concat(Ee._mimeType, " rep ").concat(Ee._id, " does not need update")), Promise.resolve(Ee)) : (this.context.logger.debug("Rotating URL for rep ".concat(Ee._id, " from ").concat(Ee.Uri, " to ").concat(Be.Uri)), this.maybeStopManifestUpdater(Ee).then(function() {
              return Pe.updateRepresentation(Be);
            }).then(function(Ve) {
              return Pe.maybeRescheduleUpdate(Ve), Ve;
            }));
          }, Te.prototype.revertPlaylistRotation = function(Ee, we) {
            var Pe = (0, le.getSourceStore)(this.context);
            Pe && (this.rotateAllRepresentations(Ee, we, Pe), this.context.logger.debug("Restoring URL for rep ".concat(Ee._id, " to ").concat(Ee.Uri)), this.maybeRescheduleUpdate(Ee));
          }, Te.prototype.maybeStopManifestUpdater = function(Ee) {
            var we;
            return !((we = this.manifestService) === null || we === void 0) && we.isLive() && this.manifestSchedulingService ? this.manifestSchedulingService.stopRepresentationUpdates(Ee) : Promise.resolve();
          }, Te.prototype.maybeRescheduleUpdate = function(Ee) {
            var we, Pe;
            !((we = this.manifestService) === null || we === void 0) && we.isLive() && ((Pe = this.manifestSchedulingService) === null || Pe === void 0 || Pe.scheduleRepresentationUpdate(Ee));
          }, Te.prototype.rotateAllRepresentations = function(Ee, we, Pe) {
            var Me, Ae = this;
            (Me = this.manifestService) === null || Me === void 0 || Me.getAllRepresentations().filter(function(Oe) {
              return Oe._mimeType === Ee._mimeType;
            }).forEach(function(Oe) {
              var Be, Ve, Ue, Re, Ne = (Ve = (Be = Ae.backupStreamsMap[Oe._mimeType]) === null || Be === void 0 ? void 0 : Be[Oe._id]) !== null && Ve !== void 0 ? Ve : {}, xe = (Ue = Oe._name) !== null && Ue !== void 0 ? Ue : Oe._mimeType, ke = (Re = Ne[we]) === null || Re === void 0 ? void 0 : Re[xe];
              if (ke && Oe.Uri !== ke) {
                var Le = ae(ae({}, Oe), { Uri: ke, BaseURL: [{ url: ye(ke, Pe.getState()) }], SegmentList: Oe.SegmentList ? [ae(ae({}, Oe.SegmentList[0]), { SegmentURL: [] })] : Oe.SegmentList, _requestTimestamp: Oe._id !== Ee._id ? 0 : Oe._requestTimestamp });
                Pe.dispatch((0, be.updateRepresentationAction)(Le));
              }
            });
          }, Te.prototype.getNextLocationId = function(Ee, we) {
            for (var Pe = Number(we) || 0, Me = 1; Me <= Ee.length; Me++) {
              var Ae = (Pe + Me) % Ee.length;
              if (this.penalizedStreams[Ae] === void 0)
                return String(Ae);
            }
          }, Te.prototype.getCurrentRepresentation = function(Ee) {
            var we, Pe, Me = this.context.serviceManager.get(he.ServiceName.AdaptationService), Ae = (we = Me == null ? void 0 : Me.getCurrentRepresentationId(Ee)) !== null && we !== void 0 ? we : void 0;
            return (Pe = this.manifestService) === null || Pe === void 0 ? void 0 : Pe.getRepresentationById(Ae);
          }, Te.prototype.getNextBackupUriForCodecProbing = function(Ee) {
            var we, Pe, Me, Ae, Oe, Be = function(xe) {
              return Object.values(xe).includes(Ee);
            }, Ve = (we = this.backupStreamInfo.find(function(xe) {
              return Object.values(xe).some(Be);
            })) !== null && we !== void 0 ? we : {}, Ue = (Pe = Object.keys(Ve).find(function(xe) {
              return Be(Ve[xe]);
            })) !== null && Pe !== void 0 ? Pe : "", Re = (Me = Ve[Ue]) !== null && Me !== void 0 ? Me : {}, Ne = (Ae = Object.keys(Re).find(function(xe) {
              return Re[xe] === Ee;
            })) !== null && Ae !== void 0 ? Ae : "";
            return (Oe = Ce(Ve, Ne)[Number(Ue) + 1]) === null || Oe === void 0 ? void 0 : Oe[Ne];
          }, Te.prototype.dispose = function() {
            this.penalizedStreams = {};
          }, Te;
        }();
        function ye(Te, Ee) {
          var we, Pe, Me, Ae, Oe = Ee && (Ae = (Me = (Pe = (we = (0, ve.getManifest)(Ee)) === null || we === void 0 ? void 0 : we.BaseURL) === null || Pe === void 0 ? void 0 : Pe[0]) === null || Me === void 0 ? void 0 : Me.url) !== null && Ae !== void 0 ? Ae : "";
          return pe.PlaylistUtils.getBaseUrl(Oe, Te);
        }
        function $e(Te, Ee) {
          var we, Pe = ((we = {})[se.MimeType.AudioMp4] = {}, we[se.MimeType.VideoMp4] = {}, we);
          return Ee.forEach(function(Me) {
            var Ae, Oe = Me._mimeType === se.MimeType.AudioMp4 ? (Ae = Me._name) !== null && Ae !== void 0 ? Ae : se.MimeType.AudioMp4 : se.MimeType.VideoMp4, Be = Te.find(function(Ve) {
              return Object.values(Ve).find(function(Ue) {
                return Ue[Oe] === Me.Uri;
              });
            });
            Be && (Pe[Me._mimeType][Me._id] = Ce(Be, Oe));
          }), Pe;
        }
        function Se(Te, Ee) {
          return Object.keys(Te).find(function(we) {
            return Object.values(Te[we]).includes(Ee);
          });
        }
        function Ce(Te, Ee) {
          var we = {}, Pe = [];
          for (var Me in Te) {
            var Ae = Te[Me][Ee];
            Pe.includes(Ae) || (Pe.push(Ae), we[Me] = Te[Me]);
          }
          return we;
        }
        function Ie(Te, Ee) {
          var we, Pe;
          if (!Ee)
            return !0;
          var Me = (Pe = (we = Te.SegmentList) === null || we === void 0 ? void 0 : we[0]) === null || Pe === void 0 ? void 0 : Pe.SegmentURL;
          return !!Me && (0, me.findSegmentUrlIndexWithinSegmentList)(Ee, Me) !== -1;
        }
        ne.HlsBackupStreamsHandler = ge;
      }, 4383: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.WebWorkerParser = void 0;
        var ae = function() {
          function ce(he) {
            var _e = this;
            this.isParsing = !1, this.jobQueue = [], this.onWorkerMessage = function(se) {
              var oe = se.data;
              if (["parsedPlaylist", "error"].includes(oe.action) && _e.jobQueue.length !== 0) {
                var ue = _e.jobQueue.shift();
                if (oe.action === "error" && (ue == null || ue.rejectFn(oe.data)), oe.action === "parsedPlaylist" && (ue == null || ue.resolveFn(oe.data)), _e.jobQueue.length > 0) {
                  var be = _e.jobQueue[0];
                  _e.parsingWorker.postMessage(be.message);
                } else
                  _e.isParsing = !1;
              }
            };
            try {
              var le = ie(80211);
              this.parsingWorker = new le(), this.parsingWorker.onmessage = this.onWorkerMessage;
            } catch (se) {
              he.warn("WebWorkerParser: Could not create web worker", se);
            }
          }
          return ce.prototype.parsePlaylist = function(he, _e) {
            var le = this;
            return new Promise(function(se, oe) {
              var ue = { action: "parseHlsPlaylist", payload: { data: he, options: _e } };
              le.jobQueue.push({ resolveFn: se, rejectFn: oe, message: ue }), le.isParsing || (le.isParsing = !0, le.parsingWorker.postMessage(ue));
            });
          }, ce.getInstance = function(he) {
            return ce.instance || (ce.instance = new ce(he)), ce.instance;
          }, ce.instance = null, ce;
        }();
        ne.WebWorkerParser = ae;
      }, 13254: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.isValidHlsPlaylist = fe, ne.getPeriod = ge, ne.parseHlsManifest = ye, ne.ensureMasterPlaylist = $e, ne.parsePlaylistInWorker = Ce, ne.createDiscontinuitySequences = Ie, ne.getTracksWithUnknownCodecs = Te, ne.updateMissingCodecsForPlaylists = Ee, ne.findAllOrMatchingVariants = Pe;
        var ae = ie(16937), ce = ie(42283), he = ie(76885), _e = ie(77874), le = ie(87062), se = ie(59692), oe = ie(53950), ue = ie(4383);
        function be(Be) {
          return Be.playlists.length > 0;
        }
        function ve(Be) {
          return Be.segments.length > 0;
        }
        function me(Be) {
          return Be.playlists || [];
        }
        function pe(Be) {
          return Be.media || [];
        }
        function fe(Be) {
          return (0, oe.isMasterPlaylist)(Be) && be(Be) || (0, oe.isMediaPlaylist)(Be) && ve(Be);
        }
        function ge(Be) {
          return (0, _e.getManifest)(Be.getState()).Period[0];
        }
        function ye(Be, Ve) {
          var Ue = { parsePartTags: (0, le.isLowLatencyConfigured)(Be) && Be.settings.LL_HLS };
          return (Be.settings.HLS_PARSE_MANIFEST_IN_WORKER ? Ce(Ve, Be.logger, Ue) : Se(Ve, Ue)).then(function(Re) {
            if ("playlists" in Re) {
              var Ne = Re.playlists.filter(function(xe) {
                return xe.attributes.BANDWIDTH >= Be.settings.HLS_AUDIO_ONLY_THRESHOLD_BITRATE;
              });
              Re.playlists = Ne.length ? Ne : Re.playlists;
            }
            return Re;
          });
        }
        function $e(Be, Ve, Ue) {
          return (0, oe.isMasterPlaylist)(Ve) ? Promise.resolve(Ve) : (Be.logger.debug("HLS manifest is not a master playlist but a variant. Using master playlist template!"), ye(Be, ["#EXTM3U", "#EXT-X-STREAM-INF:PROGRAM-ID=1,BANDWIDTH=0", Ue].join(`
`)).then(function(Re) {
            if (!(0, oe.isMasterPlaylist)(Re))
              throw new Error("Template is not of type HLS MasterPlaylist");
            return Re;
          }));
        }
        function Se(Be, Ve) {
          try {
            (0, ae.trackPerformanceStart)("HlsPlaylist.parsePlaylist");
            var Ue = (0, se.parsePlaylist)(Be, Ve);
            return (0, ae.trackPerformanceEnd)("HlsPlaylist.parsePlaylist"), Promise.resolve(Ue);
          } catch (Re) {
            return Promise.reject(Re);
          }
        }
        function Ce(Be, Ve, Ue) {
          return ue.WebWorkerParser.getInstance(Ve).parsePlaylist(Be, Ue);
        }
        function Ie(Be, Ve) {
          var Ue = oe.PlaylistUtils.createDiscontinuitySequences(Be, Ve);
          return Ue.forEach(function(Re, Ne) {
            oe.PlaylistUtils.extrapolateProgramDateTime(Re.segments), Re.indexOfFirstSegment = Ne === 0 ? 0 : Ue[Ne - 1].indexOfLastSegment + 1, Re.indexOfLastSegment = Re.indexOfFirstSegment + Re.segments.length - 1;
          }), Ue;
        }
        function Te(Be) {
          return { audioTracksWithoutCodecs: Be.media.filter(function(Ve) {
            var Ue, Re = Ve.attributes;
            if (Re.TYPE !== "AUDIO" || Re.URI === void 0 || Re.CODECS !== void 0)
              return !1;
            var Ne = Be.playlists.find(function(ke) {
              return ke.attributes.AUDIO === Re["GROUP-ID"];
            });
            if (Ne === void 0 || Ne.uri === Re.URI)
              return !1;
            var xe = (Ue = Ne.attributes.CODECS) === null || Ue === void 0 ? void 0 : Ue.split(",");
            return xe === void 0 || xe.every(function(ke) {
              return !ce.CodecStringHelper.isAudioCodec(ke);
            });
          }), videoTracksWithoutCodecs: Be.playlists.filter(function(Ve) {
            return Ve.attributes.CODECS === void 0;
          }) };
        }
        function Ee(Be, Ve, Ue) {
          Me(Be, Pe(Ve, Ue));
        }
        function we(Be, Ve) {
          return pe(Be).find(function(Ue) {
            var Re;
            return he.URLHelper.isSubUrl(Ve, (Re = Ue.attributes) === null || Re === void 0 ? void 0 : Re.URI);
          });
        }
        function Pe(Be, Ve) {
          var Ue, Re = me(Be), Ne = Re.some(function(Le) {
            return he.URLHelper.isSubUrl(Ve, Le.uri);
          }), xe = we(Be, Ve);
          if (!Ne && xe) {
            var ke = (Ue = xe.attributes) === null || Ue === void 0 ? void 0 : Ue["GROUP-ID"];
            if (ke)
              return Re.filter(function(Le) {
                var He, We;
                return ((He = Le.attributes) === null || He === void 0 ? void 0 : He.AUDIO) === ke || ((We = Le.attributes) === null || We === void 0 ? void 0 : We.VIDEO) === ke;
              });
          }
          return Re;
        }
        function Me(Be, Ve) {
          Ve.forEach(function(Ue) {
            return Ue.attributes.CODECS = Oe(Ue.attributes.CODECS, Be);
          });
        }
        function Ae(Be, Ve, Ue) {
          return typeof Be != "string" || Be.length === 0 ? Ve : Be + Ue + Ve;
        }
        function Oe(Be, Ve) {
          var Ue = Object.keys(ce.CodecStringHelper.getExtractedCodecStrings(Be)), Re = ce.CodecStringHelper.getExtractedCodecStrings(Ve), Ne = Object.keys(Re).filter(function(xe) {
            return !Ue.includes(xe);
          }).map(function(xe) {
            return Re[xe];
          }).join(",");
          return Ne && Ne.length !== 0 ? Ae(Be, Ne, ",") : Be;
        }
      }, 22675: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(xe) {
            for (var ke, Le = 1, He = arguments.length; Le < He; Le++)
              for (var We in ke = arguments[Le])
                Object.prototype.hasOwnProperty.call(ke, We) && (xe[We] = ke[We]);
            return xe;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.M3u8Loader = ne.HlsQueryParamNames = void 0, ne.getParsedManifest = Ue;
        var ce, he = ie(25550), _e = ie(28764), le = ie(18665), se = ie(60997), oe = ie(62510), ue = ie(88005), be = ie(90637), ve = ie(36564), me = ie(67345), pe = ie(57782), fe = ie(76650), ge = ie(8272), ye = ie(79814), $e = ie(331), Se = ie(76885), Ce = ie(99162), Ie = ie(13034), Te = ie(4053), Ee = ie(41735), we = ie(93109), Pe = ie(64697), Me = ie(293), Ae = ie(13254), Oe = ie(73725), Be = ie(32352), Ve = ie(53950);
        function Ue(xe, ke, Le) {
          var He = Le.url, We = Le.manifestText, Xe = xe.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(Qe) {
            return Qe.getParsedManifest(He);
          }, null, ke.sourceIdentifier);
          return Xe ? Promise.resolve(Xe) : (0, Ae.parseHlsManifest)(xe, We);
        }
        (function(xe) {
          xe.MediaSequenceNumber = "_HLS_msn", xe.PartIndex = "_HLS_part", xe.Skip = "_HLS_skip";
        })(ce || (ne.HlsQueryParamNames = ce = {}));
        var Re = function() {
          function xe(ke, Le) {
            var He = this;
            this.variantUpdateLoaders = {}, this.updateRepresentation = function(We) {
              var Xe = He.applyServerControlQueryParams(We, We.Uri);
              He.context.logger.debug("M3u8Loader: updateRepresentation (".concat(Xe, ")"));
              var Qe = He.variantUpdateLoaders[We._id];
              return He.loadPlaylist(Qe, Xe).then(function(tt) {
                return He.onMediaLoaded(tt, We);
              }).catch(function(tt) {
                return He.handleRepresentationUpdateFailure(tt, We);
              });
            }, this.onFailureHandler = function(We, Xe) {
              He.isCancelled || (He.lastDownloadFailureReason = Xe.name, He.context.logger.debug("Failed to load playlist: ".concat(We.url, " - ").concat(Xe.name)));
            }, this.context = ke, this.sourceContext = Le, this.registeredOnPlayEventHandlers = [], this.registeredOnPausedEventHandlers = [], this.discontinuitySequences = [], this.isCancelled = !1, this.translatedManifest = new Oe.M3u8DashManifest(ke, Le), this.masterPlaylistLoader = this.createLoader(me.HttpRequestType.MANIFEST_HLS_MASTER), this.sourceStore = ke.serviceManager.get(le.ServiceName.SourceStoreService, Le.sourceIdentifier);
          }
          return xe.prototype.load = function(ke) {
            var Le = this;
            return this.isCancelled = !1, this.lastDownloadFailureReason = null, this.loadPlaylist(this.masterPlaylistLoader, ke).then(function(He) {
              return Le.parseMasterPlaylist(He);
            }).then(function(He) {
              return Le.translatedManifest.updateBaseUrl(He.url), Le.initializeBackupStreamsHandler(He), Le.executeCodecVerification(He);
            }).then(function(He) {
              return Le.handleMasterPlaylist(He), Le.loadFirstVariants();
            }).then(function() {
              return Le.translatedManifest.getManifest();
            }).catch(function(He) {
              var We = He instanceof Error ? He.message : void 0;
              return Le.isCancelled || We === be.RequestError.Canceled ? Promise.reject() : He instanceof _e.PlayerError || He instanceof Error ? Promise.reject(He) : Promise.reject(Le.getErrorFromResponse(He));
            }).finally(function() {
              var He;
              return (He = Le.backupStreamsHandler) === null || He === void 0 ? void 0 : He.signalLoadingFinished();
            });
          }, xe.prototype.parseMasterPlaylist = function(ke) {
            var Le = this;
            if (this.isCancelled)
              return Promise.reject(new Error("The loading of the HLS source was cancelled."));
            var He = ke.body;
            if (He === void 0)
              return Promise.reject(new Error("Cannot parse the playlist: content is empty."));
            var We = { manifestText: He, url: ke.url };
            return Ue(this.context, this.sourceContext, We).then(function(Xe) {
              return (0, Ae.isValidHlsPlaylist)(Xe) ? (Le.maybeCacheManifest(ke, Xe), (0, Ae.ensureMasterPlaylist)(Le.context, Xe, ke.url)) : Promise.reject(new Error("Cannot parse master playlist: invalid format."));
            }).then(function(Xe) {
              return ae(ae({}, Xe), { rawString: He, url: ke.url });
            }).catch(function(Xe) {
              return Promise.reject(new _e.PlayerError(he.ErrorCode.SOURCE_MANIFEST_INVALID, { errorMessage: Xe.message }, "HLS manifest is not a valid M3U playlist"));
            });
          }, xe.prototype.initializeBackupStreamsHandler = function(ke) {
            var Le = this.translatedManifest.extractBackupStreams(ke);
            Le.every(function(He) {
              return Object.keys(He).length <= 1;
            }) || (this.backupStreamsHandler = new Me.HlsBackupStreamsHandler(this.context, Le, this.updateRepresentation));
          }, xe.prototype.loadFirstVariants = function() {
            var ke = this, Le = this.sourceStore.getState(), He = this.translatedManifest.getManifest().Period[0], We = (0, Ie.findAdaptationSetOfMimeType)(ye.MimeType.VideoMp4, He, { sourceState: Le }), Xe = (0, Ie.findAdaptationSetOfMimeType)(ye.MimeType.AudioMp4, He, { sourceState: Le, playbackConfig: this.context.config.playback }), Qe = [];
            return We && Qe.push(this.loadFirstPlaylist(We)), Xe && Qe.push(this.loadFirstPlaylist(Xe)), Promise.all(Qe).catch(function(tt) {
              return tt instanceof _e.PlayerError ? Promise.reject(tt) : ke.lastDownloadFailureReason === be.RequestError.TimedOut || tt === be.RequestError.TimedOut ? Promise.reject(new _e.PlayerError(he.ErrorCode.NETWORK_MANIFEST_DOWNLOAD_TIMEOUT, { error: tt }, "Failed to load the HLS variant playlists: the request timed out.")) : Promise.reject(new _e.PlayerError(he.ErrorCode.SOURCE_HLS_STREAM_ERROR, { error: tt }, "There was an error while retrieving the variant playlists."));
            });
          }, xe.prototype.loadFirstPlaylist = function(ke) {
            var Le = this, He = this.getStartRepresentation(ke.Representation, ke._mimeType, ke);
            if (!He) {
              var We = "No ".concat(ke._mimeType, " variants/renditions available");
              return this.context.logger.log(We), Promise.reject(new _e.PlayerError(he.ErrorCode.SOURCE_MANIFEST_INVALID, { reason: We }, We));
            }
            return this.updateRepresentation(He).then(function(Xe) {
              return Le.sourceStore.dispatch((0, pe.setPreferredBitrateForMimeTypeAction)(He._mimeType, He._bandwidth)), Le.sourceStore.dispatch((0, Te.setRepresentationIdAction)(He._internalId)), Xe;
            }).catch(function(Xe) {
              var Qe, tt;
              return Le.context.logger.debug("Representation ".concat(He._id, " failed, dropping it"), (Qe = Xe == null ? void 0 : Xe.message) !== null && Qe !== void 0 ? Qe : Xe), ke.Representation = ke.Representation.filter(function(Je) {
                return Je !== He;
              }), ke.Representation.length > 0 ? Le.loadFirstPlaylist(ke) : (Le.context.logger.log("All ".concat(ke._mimeType, " variants/renditions failed"), (tt = Xe == null ? void 0 : Xe.message) !== null && tt !== void 0 ? tt : Xe), Promise.reject(Xe));
            });
          }, xe.prototype.getStartRepresentation = function(ke, Le, He) {
            return this.context.serviceManager.maybeCall(le.ServiceName.AdaptationService, function(We) {
              We.setAdaptationSetId(He._mimeType, He._internalId);
              var Xe = We.selectRepresentation(Le, {}, ke);
              return ke.find(function(Qe) {
                return Qe._internalId.equals(Xe);
              });
            });
          }, xe.prototype.updateAdaptationSet = function(ke) {
            var Le = this, He = this.translatedManifest.findAdaptationSet(ke);
            return He ? Promise.all(He.Representation.map(function(We) {
              var Xe = Le.createLoader(me.HttpRequestType.MANIFEST_HLS_VARIANT);
              return Le.loadPlaylist(Xe, We.Uri).then(function(Qe) {
                return Le.onMediaLoaded(Qe, We);
              }).then(function(Qe) {
                Le.sourceStore.dispatch((0, Ee.updateRepresentationAction)(Qe));
              });
            })) : Promise.reject("Could not find data");
          }, xe.prototype.maybeCacheManifest = function(ke, Le) {
            this.context.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(He) {
              He.cacheHttpResponse(ke, ke.url), He.cacheParsedManifest(Le, ke.url);
            }, null, this.sourceContext.sourceIdentifier);
          }, xe.prototype.executeCodecVerification = function(ke) {
            var Le = this, He = (0, Ae.getTracksWithUnknownCodecs)(ke), We = He.audioTracksWithoutCodecs, Xe = He.videoTracksWithoutCodecs;
            return We.length === 0 && Xe.length === 0 ? Promise.resolve(ke) : (this.context.logger.debug("Codecs are missing in master playlist - probing them from segments now"), this.probeMissingAudioCodecs(ke, We).then(function() {
              return Le.probeMissingVideoCodecs(ke, Xe);
            }).then(function() {
              return ke;
            }).catch(function(Qe) {
              var tt;
              if (Qe instanceof _e.PlayerError)
                return Promise.reject(Qe);
              var Je = "Codec verification failed", Ge = (tt = Qe == null ? void 0 : Qe.message) !== null && tt !== void 0 ? tt : Qe;
              Le.context.logger.debug(Je, Qe);
              var Ye = Le.lastDownloadFailureReason === be.RequestError.TimedOut ? he.ErrorCode.NETWORK_MANIFEST_DOWNLOAD_TIMEOUT : he.ErrorCode.SOURCE_MANIFEST_INVALID;
              return Promise.reject(new _e.PlayerError(Ye, { reason: Ge }, Je));
            }));
          }, xe.prototype.parseMissingCodecsFromPlaylistResponse = function(ke, Le) {
            var He = this, We = ke.url, Xe = ke.body;
            if (Xe === void 0)
              return Promise.reject("Cannot parse codec, empty manifest response");
            var Qe = { url: Le, manifestText: Xe };
            return Ue(this.context, this.sourceContext, Qe).then(function(tt) {
              var Je = (0, Ve.calculateUpdateIntervalInSeconds)(He.context, tt), Ge = Date.now() + (0, $e.toMilliSeconds)(Je);
              He.context.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(vt) {
                vt.cacheHttpResponse(ke, We, Ge), vt.cacheParsedManifest(tt, We, Ge);
              }, null, He.sourceContext.sourceIdentifier);
              var Ye = tt.segments, ze = !tt.endList, Fe = tt.mediaSequence, ot = Ve.PlaylistUtils.getBaseUrl(He.translatedManifest.getBaseUrl(), Le);
              return new Pe.CodecDetector(He.context).probeCodecs(Ye, ze, ot, Fe);
            });
          }, xe.prototype.getVideoVariantForCodecDetection = function(ke) {
            var Le = ke.map(function(He, We) {
              return { bitrate: He.attributes.BANDWIDTH, id: We };
            });
            return this.context.serviceManager.maybeCall(le.ServiceName.AdaptationService, function(He) {
              var We = He.selectQualityBasedOnBitrateMeasurement(Le);
              return ke[We.id];
            });
          }, xe.prototype.probeMissingCodecs = function(ke, Le) {
            var He = this, We = new ue.DefaultContentLoader(this.context, { requestType: me.HttpRequestType.MANIFEST_HLS_VARIANT, onFailure: this.onFailureHandler });
            return this.loadPlaylistForCodecProbing(We, ke).then(function(Xe) {
              return He.parseMissingCodecsFromPlaylistResponse(Xe, ke);
            }).then(function(Xe) {
              return (0, Ae.updateMissingCodecsForPlaylists)(Xe, Le, ke);
            });
          }, xe.prototype.loadPlaylistForCodecProbing = function(ke, Le) {
            var He = this;
            return this.loadPlaylist(ke, Le).catch(function(We) {
              var Xe;
              He.context.logger.debug("Representation failed to load during codec probing ".concat(Le));
              var Qe = (Xe = He.backupStreamsHandler) === null || Xe === void 0 ? void 0 : Xe.getNextBackupUriForCodecProbing(Le);
              return Qe ? (He.context.logger.debug("Attempting to continue codec probing using backup stream ".concat(Qe)), He.loadPlaylistForCodecProbing(ke, Qe)) : Promise.reject(We);
            });
          }, xe.prototype.probeMissingAudioCodecs = function(ke, Le) {
            var He = this, We = Le.shift();
            if (!(We != null && We.attributes.URI))
              return Promise.resolve();
            var Xe = Se.URLHelper.getAbsoluteUrl(We.attributes.URI, this.translatedManifest.getBaseUrl());
            return this.probeMissingCodecs(Xe, ke).then(function() {
              return He.probeMissingAudioCodecs(ke, Le);
            });
          }, xe.prototype.probeMissingVideoCodecs = function(ke, Le) {
            if (Le.length === 0)
              return Promise.resolve();
            var He = this.getVideoVariantForCodecDetection(Le), We = Se.URLHelper.getAbsoluteUrl(He.uri, this.translatedManifest.getBaseUrl());
            return this.probeMissingCodecs(We, ke);
          }, xe.prototype.handleMasterPlaylist = function(ke) {
            var Le, He = this;
            this.masterPlaylist === void 0 && (this.masterPlaylist = ke), this.translatedManifest.onMasterPlaylistAvailable(ke);
            var We = this.translatedManifest.getAllVariantRepresentions();
            We.forEach(function(Xe) {
              He.variantUpdateLoaders[Xe._id] = He.createLoader(me.HttpRequestType.MANIFEST_HLS_VARIANT);
            }), (Le = this.backupStreamsHandler) === null || Le === void 0 || Le.populateBackupStreamsMap(We);
          }, xe.prototype.onMediaLoaded = function(ke, Le) {
            var He = this;
            if (this.isCancelled)
              return Promise.reject(Ce.REPRESENTATION_UPDATE_CANCEL);
            var We = ke.url, Xe = ke.body;
            if (!Xe)
              return Promise.reject(new _e.PlayerError(he.ErrorCode.SOURCE_MANIFEST_INVALID, void 0, "Cannot parse the playlist: the body of the response is empty."));
            var Qe = Date.now(), tt = { url: We, manifestText: Xe };
            return Ue(this.context, this.sourceContext, tt).then(function(Je) {
              var Ge;
              Je.uri = (0, Se.removeQueryParameters)(We, Object.values(ce)), Je.requestTimestamp = Qe;
              var Ye = Be.M3u8Validator.checkForError(Je);
              if (Ye)
                return Promise.reject(new _e.PlayerError(he.ErrorCode.SOURCE_MANIFEST_INVALID, { M3u8ValidatorError: Ye }, "The parsed media playlist is invalid: ".concat(Ye)));
              Je.start = (Ge = Je.start) !== null && Ge !== void 0 ? Ge : He.masterPlaylist.start, He.discontinuitySequences = (0, Ae.createDiscontinuitySequences)(Je, He.discontinuitySequences);
              var ze = He.filterTooSmallPeriods(He.discontinuitySequences, !!Je.endList);
              Je.segments = ze.flatMap(function(vt) {
                return vt.segments;
              });
              var Fe = He.translatedManifest.onMediaLoaded(Xe, Le, Je);
              Je.endList && He.context.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(vt) {
                vt.cacheHttpResponse(ke, We), vt.cacheParsedManifest(Je, We);
              }, null, He.sourceContext.sourceIdentifier);
              var ot = (0, $e.toSeconds)(Date.now() - Qe);
              return He.context.store.dispatch((0, fe.addMetricsValue)("default", ge.MetricType.ProcessingTime, ot)), He.context.logger.insane("Parsed playlist in: ".concat(ot == null ? void 0 : ot.toFixed(2))), Fe;
            }).catch(function(Je) {
              if (Je instanceof _e.PlayerError)
                return Promise.reject(Je);
              var Ge = "Failed to parse the media playlist", Ye = Je instanceof Error ? Je.message : Ge;
              return Promise.reject(new _e.PlayerError(he.ErrorCode.SOURCE_MANIFEST_INVALID, { errorMessage: Ye }, Ge));
            });
          }, xe.prototype.filterTooSmallPeriods = function(ke, Le) {
            return ke.filter(function(He, We) {
              var Xe = !Le && We === ke.length - 1, Qe = He.segments.reduce(function(tt, Je) {
                return tt + Je.duration;
              }, 0);
              return !!(We === 0 && Qe > 0 || Xe) || Qe > 0;
            });
          }, xe.prototype.stop = function() {
            var ke = this;
            this.registeredOnPlayEventHandlers.forEach(function(Le) {
              return ke.context.eventHandler.off(oe.PlayerEvent.Play, Le);
            }), this.registeredOnPausedEventHandlers.forEach(function(Le) {
              return ke.context.eventHandler.off(oe.PlayerEvent.Paused, Le);
            }), this.registeredOnPlayEventHandlers = [], this.registeredOnPausedEventHandlers = [], this.stopLoaders(), this.isCancelled = !0;
          }, xe.prototype.stopLoaders = function() {
            var ke = this;
            this.masterPlaylistLoader.cancel(), Object.keys(this.variantUpdateLoaders).forEach(function(Le) {
              ke.variantUpdateLoaders[Le].dispose(), delete ke.variantUpdateLoaders[Le];
            });
          }, xe.prototype.stopRepresentationUpdate = function(ke) {
            var Le, He = this.variantUpdateLoaders[ke._id];
            return He != null && He.isLoading() ? (this.context.logger.debug("M3u8Loader: stopping ongoing representation update (".concat(ke.Uri, ")")), He.cancel(), ((Le = He.getResponse()) !== null && Le !== void 0 ? Le : Promise.resolve()).catch(function() {
            }).then(function() {
            })) : Promise.resolve();
          }, xe.prototype.applyServerControlQueryParams = function(ke, Le) {
            var He, We = {}, Xe = (0, Ve.getLastMediaSequenceAndPartIndex)(ke);
            return (0, we.isPlayingLowLatencyHls)(this.context) && (0, Ve.canMakeBlockingPlaylistReload)(ke, this.context.settings) && Xe && (We[ce.MediaSequenceNumber] = String(Xe.mediaSequence), We[ce.PartIndex] = String(Xe.partIndex + 1)), !((He = this.context.config.live) === null || He === void 0) && He.incrementalManifestUpdates && (0, Ve.canPerformDeltaUpdate)(ke) && (We[ce.Skip] = "YES"), Se.URLHelper.appendQueryParametersToUrl(Le, We);
          }, xe.prototype.handleRepresentationUpdateFailure = function(ke, Le) {
            var He, We = this;
            return this.isCancelled || (ke == null ? void 0 : ke.message) === be.RequestError.Canceled ? Promise.reject(Ce.REPRESENTATION_UPDATE_CANCEL) : (this.context.logger.debug("M3u8Loader: updateRepresentation failed (".concat(Le.Uri, ")"), (He = ke == null ? void 0 : ke.message) !== null && He !== void 0 ? He : ke), this.switchToBackupStream(Le).then(function(Xe) {
              var Qe, tt = Xe[0];
              return tt || Promise.reject((Qe = We.lastDownloadFailureReason) !== null && Qe !== void 0 ? Qe : be.RequestError.Failed);
            }).catch(function(Xe) {
              return We.lastDownloadFailureReason === be.RequestError.TimedOut ? Promise.reject(be.RequestError.TimedOut) : Object.values(Me.BackupStreamErrors).includes(Xe) && ke instanceof _e.PlayerError ? Promise.reject(ke) : Promise.reject(Xe === Ce.REPRESENTATION_UPDATE_CANCEL ? Xe : be.RequestError.Failed);
            }));
          }, xe.prototype.switchToBackupStream = function(ke, Le) {
            return this.backupStreamsHandler ? this.backupStreamsHandler.switchToBackupStream(ke, Le) : Promise.reject(Me.BackupStreamErrors.NO_BACKUP_STREAMS);
          }, xe.prototype.loadPlaylist = function(ke, Le) {
            var He;
            if (!Le) {
              var We = new _e.PlayerError(he.ErrorCode.SOURCE_INVALID, void 0, "Cannot load the playlist: no URL was provided.");
              return this.context.eventHandler.fireError(We), Promise.reject(We);
            }
            var Xe = this.context.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(tt) {
              return tt.getHttpResponse(Le);
            }, null, this.sourceContext.sourceIdentifier);
            if (Xe)
              return Promise.resolve(Xe);
            var Qe = (He = this.sourceContext.source.options) === null || He === void 0 ? void 0 : He.manifestWithCredentials;
            return ke.load(Le, me.HttpRequestMethod.GET, null, null, null, Qe);
          }, xe.prototype.createLoader = function(ke) {
            var Le = this;
            return new ue.DefaultContentLoader(this.context, { onSuccess: function(He, We) {
              var Xe, Qe;
              Le.lastDownloadFailureReason = null, (0, ve.isDownloadTimeInformationValid)(He) && (Le.context.logger.debug("Downloaded playlist in: ".concat((Xe = He.elapsedTime) === null || Xe === void 0 ? void 0 : Xe.toFixed(2), ", TTFB: ").concat((Qe = He.timeToFirstByte) === null || Qe === void 0 ? void 0 : Qe.toFixed(2))), Le.context.store.dispatch((0, fe.addMetricsValue)("default", ge.MetricType.DownloadInformation, { bytes: He.length, time: He.elapsedTime, timeToFirstByte: He.timeToFirstByte })));
            }, onFailure: this.onFailureHandler, maxRetries: this.context.settings.MAX_MPD_RETRIES, requestType: ke, resetRetriesWhenOffline: !0 });
          }, xe.prototype.getErrorFromResponse = function(ke) {
            return this.lastDownloadFailureReason === be.RequestError.TimedOut ? new _e.PlayerError(he.ErrorCode.NETWORK_MANIFEST_DOWNLOAD_TIMEOUT, Ne(ke), "Failed to load HLS playlist: the request timed out.", this.sourceContext.sourceIdentifier) : ke.status === XMLHttpRequest.UNSENT ? new _e.PlayerError(he.ErrorCode.NETWORK_ERROR, Ne(ke), "Failed to load the HLS playlist due to CORS restrictions or because the client is offline.", this.sourceContext.sourceIdentifier) : new _e.PlayerError(he.ErrorCode.SOURCE_COULD_NOT_LOAD_MANIFEST, Ne(ke), "Failed to load HLS playlist: ".concat(ke.status, " ").concat(ke.statusText, "."), this.sourceContext.sourceIdentifier);
          }, xe.prototype.dispose = function() {
            var ke, Le = this;
            this.stop(), this.translatedManifest = (0, se.dispose)(this.translatedManifest), this.masterPlaylist = null, this.lastDownloadFailureReason = null, this.masterPlaylistLoader.dispose(), (ke = this.backupStreamsHandler) === null || ke === void 0 || ke.dispose(), Object.keys(this.variantUpdateLoaders).forEach(function(He) {
              return Le.variantUpdateLoaders[He].dispose();
            }), this.variantUpdateLoaders = null;
          }, xe;
        }();
        function Ne(xe) {
          return { url: xe.url, statusCode: xe.status, statusText: xe.statusText };
        }
        ne.M3u8Loader = Re;
      }, 26527: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.DiscontinuitySequenceNumberTracker = void 0;
        var ie = function() {
          function ae(ce) {
            this.mimeTypeFilter = ce, this.discoSequenceNumberChangedListeners = [], this.reset();
          }
          return ae.prototype.notifyListeners = function(ce) {
            var he = this;
            this.discoSequenceNumberChangedListeners.forEach(function(_e) {
              return _e(he.currentDiscontinuitySequenceNumber, ce);
            });
          }, ae.prototype.trackSegment = function(ce) {
            if (this.mimeTypeFilter(ce.getMimeType()) && !ce.isInit()) {
              var he = ce.getSegmentInfo(), _e = he == null ? void 0 : he.discontinuitySequenceNumber, le = isFinite(this.currentDiscontinuitySequenceNumber), se = this.currentDiscontinuitySequenceNumber !== _e;
              le && se && this.notifyListeners(_e), this.currentDiscontinuitySequenceNumber = _e;
            }
          }, ae.prototype.subscribe = function(ce) {
            this.discoSequenceNumberChangedListeners.push(ce);
          }, ae.prototype.unsubscribe = function(ce) {
            var he = this.discoSequenceNumberChangedListeners.indexOf(ce);
            he < 0 || this.discoSequenceNumberChangedListeners.splice(he, 1);
          }, ae.prototype.reset = function() {
            this.currentDiscontinuitySequenceNumber = -1 / 0;
          }, ae.prototype.dispose = function() {
            this.reset(), this.discoSequenceNumberChangedListeners = [];
          }, ae;
        }();
        ne.DiscontinuitySequenceNumberTracker = ie;
      }, 27485: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.TextParser = void 0;
        var ie = /[ \t]+/gm, ae = function() {
          function ce(he) {
            this.data = he, this.position = 0;
          }
          return ce.prototype.isAtEnd = function() {
            return this.position === this.data.length;
          }, ce.prototype.skipWhitespace = function() {
            this.readRegex(ie);
          }, ce.prototype.readRegex = function(he) {
            var _e = this.indexOf(he);
            if (!this.isAtEnd() && _e !== void 0 && _e.position === this.position)
              return this.position += _e.length, _e.results;
          }, ce.prototype.indexOf = function(he) {
            he.lastIndex = this.position;
            var _e = he.exec(this.data);
            if (_e !== null)
              return { position: _e.index, length: _e[0].length, results: _e };
          }, ce;
        }();
        ne.TextParser = ae;
      }, 31043: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.setSegmentInfos = he, ne.updateSegmentInfos = _e;
        var ae = ie(15231), ce = ie(85157);
        function he(le, se) {
          return (0, ae.createAction)(ce.SegmentInfoMapActionType.SetSegmentInfos, { qualityPath: le, updatedEntry: se });
        }
        function _e(le, se) {
          return (0, ae.createAction)(ce.SegmentInfoMapActionType.UpdateSegmentInfos, { qualityPath: le, updatedEntry: se });
        }
      }, 32352: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.M3u8Validator = ne.M3u8ValidatorError = void 0, function(ce) {
          ce.EmptyPlaylist = "EmptyPlaylist";
        }(ie || (ne.M3u8ValidatorError = ie = {}));
        var ae = function() {
          function ce() {
          }
          return ce.checkForError = function(he) {
            for (var _e = 0, le = ce.mediaPlaylistRules; _e < le.length; _e++) {
              var se = le[_e];
              if (!se.fn(he))
                return se.err;
            }
            return null;
          }, ce.mediaPlaylistRules = [{ fn: function(he) {
            var _e;
            return ((_e = he.segments) === null || _e === void 0 ? void 0 : _e.length) > 0;
          }, err: ie.EmptyPlaylist }], ce;
        }();
        ne.M3u8Validator = ae;
      }, 33827: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HlsTimelineTracker = void 0;
        var ae = ie(18665), ce = ie(58975), he = ie(27279), _e = ie(3464), le = ie(9827), se = ie(34435), oe = 1e-3, ue = function() {
          function ye($e, Se) {
            var Ce = this;
            this.gapVerificationOnNextSegment = !1, this.context = $e, this.playbackTimeNextSegment = -1, this.allowedGapSizeSec = Se, this.playerStateService = this.context.serviceManager.get(ae.ServiceName.PlayerStateService), this.unsubscribeFromTargetPlaybackTimeChange = (0, _e.subscribe)(this.context.store)(function(Te) {
              return (0, ce.getTargetPlaybackTime)((0, ce.getPlayerState)(Te));
            }, function() {
              return Ce.seekVerificationOnNextSegment = !0;
            }, function(Te) {
              return Te !== -1;
            });
            var Ie = (0, he.getSourceStore)(this.context);
            Ie && (this.unsubscribeFromContentLocationId = (0, _e.subscribe)(Ie)(function(Te) {
              return Te && (0, se.getContentLocationId)((0, se.getHlsState)(Te));
            }, function() {
              return Ce.gapVerificationOnNextSegment = !0;
            }, function(Te, Ee) {
              return Te !== Ee;
            }));
          }
          return ye.prototype.reset = function() {
            this.playbackTimeNextSegment = -1, this.gapVerificationOnNextSegment = !1;
          }, ye.prototype.isGapVerificationNeeded = function() {
            return this.gapVerificationOnNextSegment && this.playbackTimeNextSegment !== -1;
          }, ye.prototype.isSeekTargetVerificationNeeded = function() {
            return this.seekVerificationOnNextSegment && this.playbackTimeNextSegment === -1;
          }, ye.prototype.trackPlaybackTime = function($e) {
            var Se, Ce = (Se = $e.getSegmentInfo()) === null || Se === void 0 ? void 0 : Se.duration, Ie = $e.getDuration();
            this.playbackTimeNextSegment = $e.getPlaybackTime() + Math.max(Ie, Ce ?? Ie);
          }, ye.prototype.checkForTimelineGap = function($e, Se, Ce) {
            var Ie;
            if (this.playbackTimeNextSegment >= 0)
              return this.gapVerificationOnNextSegment = !1, this.checkGapForConsecutiveSegments($e, Se, Ce);
            var Te = !((Ie = this.playerStateService) === null || Ie === void 0) && Ie.seekingOrTimeshifting ? this.playerStateService.targetPlaybackTime : -1;
            return this.seekVerificationOnNextSegment && Te > -1 ? (this.seekVerificationOnNextSegment = !1, this.checkSeekAccuracy(Te, $e, Se, Ce)) : { hasGap: !1 };
          }, ye.prototype.checkGapForConsecutiveSegments = function($e, Se, Ce) {
            var Ie = be($e, this.allowedGapSizeSec);
            if (ve(this.playbackTimeNextSegment, Ie - this.allowedGapSizeSec, Ie + $e.getDuration()))
              return { hasGap: !1 };
            var Te = { hasGap: !1 }, Ee = $e.getPlaybackTime() - this.playbackTimeNextSegment, we = Se.SegmentList ? Se.SegmentList[0].SegmentURL : [], Pe = (0, le.findSegmentUrlIndexWithinSegmentList)($e.getSegmentInfo(), we), Me = Pe >= 0 ? Pe : Ce, Ae = Me;
            if (Ee > 0)
              (Oe = pe(Ae = fe(Ee, we, Me))) || (this.context.logger.debug("Could not handle gap on playlist switch, reached lower boundary of segment list"), Ae = 0), Te = me(!0, Ee, Oe, Ae);
            else if (Ee < 0) {
              var Oe;
              (Oe = pe(Ae = ge(Ee, we, Me))) || (this.context.logger.debug("Could not handle gap on playlist switch, reached upper boundary of segment list"), Ae = we.length), Te = me(!0, Ee, Oe, Ae);
            }
            return Ae === Me && Te.hasGap && (this.context.logger.debug("Ignoring gap as calculated new segment index did not change"), Te.hasGap = !1), Te;
          }, ye.prototype.checkSeekAccuracy = function($e, Se, Ce, Ie) {
            var Te = Ce.SegmentList ? Ce.SegmentList[0].SegmentURL : [], Ee = Se.getPlaybackTime(), we = Se.getPlaybackTime() + Se.getDuration();
            this.context.logger.debug("HLS seek target verification", { seekTarget: $e, segmentStartTime: Ee, segmentEndTime: we });
            var Pe, Me, Ae, Oe = (0, le.findSegmentUrlIndexWithinSegmentList)(Se.getSegmentInfo(), Te);
            return Oe = Oe >= 0 ? Oe : Ie, $e < Ee ? ((Ae = pe(Pe = fe(Me = Ee - $e, Te, Oe))) || (Pe = 0), this.context.logger.debug("Target segment starts too late, corrected segment index from ".concat(Oe, " to ").concat(Pe)), me(!0, Me, Ae, Pe)) : $e > we ? ((Ae = pe(Pe = ge(Me = we - $e, Te, Oe))) || (Pe = Te.length), this.context.logger.debug("Target segment ends too early, corrected segment index from ".concat(Oe, " to ").concat(Pe)), me(!0, Me, Ae, Pe)) : { hasGap: !1 };
          }, ye.prototype.dispose = function() {
            var $e;
            ($e = this.unsubscribeFromContentLocationId) === null || $e === void 0 || $e.call(this), this.unsubscribeFromTargetPlaybackTimeChange(), this.gapVerificationOnNextSegment = !1, this.seekVerificationOnNextSegment = !1, this.playbackTimeNextSegment = -1;
          }, ye;
        }();
        function be(ye, $e) {
          var Se, Ce = (Se = ye.getSegmentInfo()) === null || Se === void 0 ? void 0 : Se.startTime, Ie = ye.getPlaybackTime();
          return Ce === void 0 || Math.abs(Ie - Ce) > ye.getDuration() + $e ? Ie : Math.min(Ie, Ce);
        }
        function ve(ye, $e, Se) {
          return ye >= $e && ye <= Se;
        }
        function me(ye, $e, Se, Ce) {
          return { hasGap: ye, gapSizeSec: $e, couldHandle: Se, correctedIndex: Ce };
        }
        function pe(ye) {
          return ye >= 0 && isFinite(ye);
        }
        function fe(ye, $e, Se) {
          for (; ye > oe; ) {
            if (Se <= 0)
              return -1;
            ye -= $e[Se - 1]._duration, Se--;
          }
          return Se;
        }
        function ge(ye, $e, Se) {
          for (; ye < -oe; )
            if (ye += $e[Se]._duration, ++Se >= $e.length)
              return 1 / 0;
          return Se;
        }
        ne.HlsTimelineTracker = ue;
      }, 34435: function(ee, ne) {
        var ie = this && this.__assign || function() {
          return ie = Object.assign || function($e) {
            for (var Se, Ce = 1, Ie = arguments.length; Ce < Ie; Ce++)
              for (var Te in Se = arguments[Ce])
                Object.prototype.hasOwnProperty.call(Se, Te) && ($e[Te] = Se[Te]);
            return $e;
          }, ie.apply(this, arguments);
        };
        function ae($e) {
          return $e.hls;
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getContentLocationId = ne.getPresentationTimeOffset = ne.getMergedDiscontinuityTimings = ne.getFirstDiscoSequenceTiming = ne.getDiscoSequenceTimings = ne.getDiscoSequenceTiming = ne.getCustomTags = ne.getDefaultLanguages = ne.getEndlist = ne.getIsLowLatencyPlaylist = ne.getPlaylistType = void 0, ne.getHlsState = ae, ne.computeMergedDiscontinuityTimings = fe, ne.areDiscontinuitiesMisaligned = ge;
        var ce = function($e) {
          return $e.playlistType;
        };
        ne.getPlaylistType = ce;
        var he = function($e) {
          return $e.isLowLatencyPlaylist;
        };
        ne.getIsLowLatencyPlaylist = he;
        var _e = function($e) {
          return $e.endlist;
        };
        ne.getEndlist = _e;
        var le = function($e) {
          return $e.defaultLanguages;
        };
        ne.getDefaultLanguages = le;
        var se = function($e) {
          return $e.customTags;
        };
        ne.getCustomTags = se;
        var oe = function($e, Se, Ce) {
          var Ie, Te;
          return !((Te = (Ie = $e.discontinuitySequenceTiming) === null || Ie === void 0 ? void 0 : Ie[Se]) === null || Te === void 0) && Te[Ce] ? ie({}, $e.discontinuitySequenceTiming[Se][Ce]) : null;
        };
        ne.getDiscoSequenceTiming = oe;
        var ue = function($e, Se) {
          var Ce;
          return !((Ce = $e.discontinuitySequenceTiming) === null || Ce === void 0) && Ce[Se] ? ie({}, $e.discontinuitySequenceTiming[Se]) : null;
        };
        ne.getDiscoSequenceTimings = ue;
        var be = function($e) {
          var Se, Ce = (0, ne.getMergedDiscontinuityTimings)($e);
          return (Se = Ce[Object.keys(Ce)[0]]) !== null && Se !== void 0 ? Se : { startTime: 0, endTime: 0 };
        };
        ne.getFirstDiscoSequenceTiming = be;
        var ve = function($e) {
          var Se;
          return fe((Se = $e.discontinuitySequenceTiming) !== null && Se !== void 0 ? Se : {});
        };
        ne.getMergedDiscontinuityTimings = ve;
        var me = function($e, Se) {
          return $e.presentationTimeOffsets[Se];
        };
        ne.getPresentationTimeOffset = me;
        var pe = function($e) {
          return $e.contentLocationId;
        };
        function fe($e) {
          var Se = {}, Ce = function(Ie, Te) {
            var Ee, we, Pe, Me, Ae, Oe, Be, Ve, Ue, Re;
            return { startTime: Math.max((Pe = (we = (Ee = $e[Te]) === null || Ee === void 0 ? void 0 : Ee[Ie]) === null || we === void 0 ? void 0 : we.startTime) !== null && Pe !== void 0 ? Pe : -1 / 0, (Ae = (Me = Se[Ie]) === null || Me === void 0 ? void 0 : Me.startTime) !== null && Ae !== void 0 ? Ae : -1 / 0), endTime: Math.min((Ve = (Be = (Oe = $e[Te]) === null || Oe === void 0 ? void 0 : Oe[Ie]) === null || Be === void 0 ? void 0 : Be.endTime) !== null && Ve !== void 0 ? Ve : 1 / 0, (Re = (Ue = Se[Ie]) === null || Ue === void 0 ? void 0 : Ue.endTime) !== null && Re !== void 0 ? Re : 1 / 0) };
          };
          return Object.keys($e).forEach(function(Ie) {
            var Te;
            Object.keys((Te = $e[Ie]) !== null && Te !== void 0 ? Te : {}).forEach(function(Ee) {
              Se[Ee] = Ce(Ee, Ie);
            });
          }), Se;
        }
        function ge($e, Se, Ce) {
          if (Ce === void 0 && (Ce = 2), Se.length <= 1 || !$e.discontinuitySequenceTiming)
            return !1;
          var Ie = ye($e.discontinuitySequenceTiming, Se), Te = fe(Ie);
          return Object.keys(Te).length !== 1 && !Object.keys(Te).every(function(Ee, we) {
            var Pe = Te[Ee];
            return Se.every(function(Me) {
              var Ae, Oe = (Ae = Ie[Me]) === null || Ae === void 0 ? void 0 : Ae[Ee];
              if (!Oe)
                return !0;
              var Be = Math.abs(Oe.startTime - Pe.startTime), Ve = Math.abs(Oe.endTime - Pe.endTime);
              return we === 0 ? Ve <= Ce : we === Object.keys(Te).length - 1 ? Be <= Ce : Be <= Ce && Ve <= Ce;
            });
          });
        }
        function ye($e, Se) {
          return Se.reduce(function(Ce, Ie) {
            return Ie in $e && (Ce[Ie] = $e[Ie]), Ce;
          }, {});
        }
        ne.getContentLocationId = pe;
      }, 47967: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(ke) {
            for (var Le, He = 1, We = arguments.length; He < We; He++)
              for (var Xe in Le = arguments[He])
                Object.prototype.hasOwnProperty.call(Le, Xe) && (ke[Xe] = Le[Xe]);
            return ke;
          }, ae.apply(this, arguments);
        }, ce = this && this.__spreadArray || function(ke, Le, He) {
          if (He || arguments.length === 2)
            for (var We, Xe = 0, Qe = Le.length; Xe < Qe; Xe++)
              !We && Xe in Le || (We || (We = Array.prototype.slice.call(Le, 0, Xe)), We[Xe] = Le[Xe]);
          return ke.concat(We || Array.prototype.slice.call(Le));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.generateRendition = se, ne.generateStartAttributes = oe, ne.generatePartInfoTag = ue, ne.generateServerControlTag = be, ne.generateSkipTag = ve, ne.generatePartTag = me, ne.generatePreloadHintTag = fe, ne.generateStreamInfTag = ge, ne.generateVariantPlaylistId = ye, ne.generateSessionKeyTag = $e, ne.generateIFrameStreamInfTag = Se, ne.generateSegmentEntrySkeleton = Ce, ne.generateCueTag = Ie, ne.generateDateRange = Te, ne.generateKeyTag = Ee, ne.generateByteRangeTag = we, ne.generateMapTag = Pe, ne.generateCustomTag = Ne;
        var he = ie(62510), _e = ie(91397), le = ie(56093);
        function se(ke) {
          var Le, He, We;
          return { name: ke.name, attributes: ae(ae({}, ke.attributes), { TYPE: (Le = ke.attributes) === null || Le === void 0 ? void 0 : Le.TYPE, "GROUP-ID": (He = ke.attributes) === null || He === void 0 ? void 0 : He["GROUP-ID"], NAME: (We = ke.attributes) === null || We === void 0 ? void 0 : We.NAME }) };
        }
        function oe(ke) {
          var Le, He;
          return !((Le = ke.attributes) === null || Le === void 0) && Le.hasOwnProperty("TIME-OFFSET") && (He = { timeOffset: Number(ke.attributes["TIME-OFFSET"]), precise: ke.attributes.PRECISE === "YES" }), ke.attributes && He && He.hasOwnProperty("timeOffset") && (ke.attributes["TIME-OFFSET"] = He.timeOffset, ke.attributes.PRECISE = He.precise), He;
        }
        function ue(ke) {
          return { targetDuration: parseFloat(ke["PART-TARGET"]) };
        }
        function be(ke) {
          var Le = { canBlockReload: !1 };
          return ke.attributes && (ke.attributes["CAN-SKIP-UNTIL"] && (Le.canSkipUntil = parseFloat(ke.attributes["CAN-SKIP-UNTIL"])), Le.canSkipUntil !== void 0 && ke.attributes["CAN-SKIP-DATERANGES"] && (Le.canSkipDateRanges = ke.attributes["CAN-SKIP-DATERANGES"] === "YES"), ke.attributes["HOLD-BACK"] && (Le.holdBack = parseFloat(ke.attributes["HOLD-BACK"])), ke.attributes["PART-HOLD-BACK"] && (Le.partHoldBack = parseFloat(ke.attributes["PART-HOLD-BACK"])), ke.attributes["CAN-BLOCK-RELOAD"] && (Le.canBlockReload = ke.attributes["CAN-BLOCK-RELOAD"] === "YES")), Le;
        }
        function ve(ke) {
          var Le = { skippedSegments: 0, recentlyRemovedDateranges: [] };
          return ke.attributes && (ke.attributes["SKIPPED-SEGMENTS"] && (Le.skippedSegments = parseInt(ke.attributes["SKIPPED-SEGMENTS"])), ke.attributes["RECENTLY-REMOVED-DATERANGES"] && (Le.recentlyRemovedDateranges = ke.attributes["RECENTLY-REMOVED-DATERANGES"].split("	"))), Le;
        }
        function me(ke, Le) {
          var He = { uri: (0, _e.forceReallocation)(ke.URI), duration: parseFloat(ke.DURATION) };
          if (ke.INDEPENDENT === "YES" && (He.independent = !0), ke.BYTERANGE) {
            var We = ke.BYTERANGE.split("@"), Xe = parseInt(We[0]), Qe = parseInt(We[1]);
            isNaN(Qe) && (Qe = Le != null && Le.byteRange ? Le.byteRange.end + 1 : 0), He.byteRange = { start: Qe, end: Qe + Xe - 1 };
          }
          return ke.GAP === "YES" && (He.gap = !0), He;
        }
        function pe(ke) {
          var Le = parseInt(ke["BYTERANGE-START"]), He = parseInt(ke["BYTERANGE-END"]);
          if (!isNaN(Le) || !isNaN(He))
            return { start: isNaN(Le) ? 0 : Le, end: isNaN(He) ? Math.pow(2, 53) - 1 : He };
        }
        function fe(ke, Le) {
          if (ke.TYPE === "PART") {
            var He = { uri: (0, _e.forceReallocation)(ke.URI), duration: Le, isPreloadHint: !0 };
            return (We = pe(ke)) && (He.byteRange = We), { part: He };
          }
          if (ke.TYPE === "MAP") {
            var We, Xe = { url: (0, _e.forceReallocation)(ke.URI) };
            return (We = pe(ke)) && (Xe.byteRange = We), { init: Xe };
          }
          return {};
        }
        function ge(ke, Le) {
          var He, We, Xe, Qe, tt, Je = { name: ke.name, uri: Le, attributes: ae(ae({}, ke.attributes), { BANDWIDTH: (He = ke.attributes) === null || He === void 0 ? void 0 : He.BANDWIDTH }) };
          return !((We = ke.attributes) === null || We === void 0) && We.RESOLUTION && (Je.attributes.RESOLUTION = Ae(ke)), !((Xe = ke.attributes) === null || Xe === void 0) && Xe.BANDWIDTH && (Je.attributes.BANDWIDTH = parseInt(ke.attributes.BANDWIDTH)), !((Qe = ke.attributes) === null || Qe === void 0) && Qe["AVERAGE-BANDWIDTH"] && (Je.attributes["AVERAGE-BANDWIDTH"] = parseInt(ke.attributes["AVERAGE-BANDWIDTH"])), !((tt = ke.attributes) === null || tt === void 0) && tt["PROGRAM-ID"] && (Je.attributes["PROGRAM-ID"] = parseInt(ke.attributes["PROGRAM-ID"])), Je.id = ye(Je.attributes), Je;
        }
        function ye(ke) {
          var Le = "";
          return ke.RESOLUTION && (Le += ke.RESOLUTION.height + "_"), Le += ke.BANDWIDTH;
        }
        function $e(ke) {
          Me(ke);
        }
        function Se(ke) {
          var Le, He, We;
          !((Le = ke.attributes) === null || Le === void 0) && Le.BANDWIDTH && (ke.attributes.BANDWIDTH = parseInt(ke.attributes.BANDWIDTH)), !((He = ke.attributes) === null || He === void 0) && He["AVERAGE-BANDWIDTH"] && (ke.attributes["AVERAGE-BANDWIDTH"] = parseInt(ke.attributes["AVERAGE-BANDWIDTH"], 10)), !((We = ke.attributes) === null || We === void 0) && We.RESOLUTION && (ke.attributes.RESOLUTION = Ae(ke));
        }
        function Ce() {
          return { uri: "", duration: 0, mediaSequence: 0 };
        }
        function Ie(ke, Le) {
          var He = { type: Le };
          if (ke.attributes) {
            var We = [];
            for (var Xe in ke.attributes)
              if (ke.attributes.hasOwnProperty(Xe)) {
                var Qe = ke.attributes[Xe] ? "".concat(Xe, "=").concat(ke.attributes[Xe]) : Xe;
                We.push(Qe);
              }
            He.attributes = We;
          }
          return He;
        }
        function Te(ke) {
          var Le = { type: he.MetadataType.DATERANGE };
          if (ke.attributes) {
            Le.clientAttributes = {};
            var He = ke.attributes;
            for (var We in He)
              if (He.hasOwnProperty(We))
                if (We.startsWith("X-")) {
                  var Xe = 2;
                  Le.clientAttributes[(0, _e.kebabCaseToCamelCase)(We.substring(Xe))] = (0, _e.forceReallocation)(He[We]);
                } else
                  Le[(0, _e.kebabCaseToCamelCase)(We)] = (0, _e.forceReallocation)(He[We]);
          }
          return Le.duration && (Le.duration = Number(Le.duration)), Le.plannedDuration && (Le.plannedDuration = Number(Le.plannedDuration)), Le.endOnNext && (Le.endOnNext = !0), Le;
        }
        function Ee(ke) {
          if (Me(ke), ke.attributes && ke.attributes.METHOD !== "NONE" && ke.attributes.URI) {
            var Le = { method: (0, _e.forceReallocation)(ke.attributes.METHOD) || "AES-128", uri: (0, _e.forceReallocation)(ke.attributes.URI) };
            return ke.attributes.IV !== void 0 && (Le.iv = ke.attributes.IV), ke.attributes.KEYFORMAT && (Le.keyformat = (0, _e.forceReallocation)(ke.attributes.KEYFORMAT)), ke.attributes.KEYFORMATVERSIONS && (Le.keyformatversions = (0, _e.forceReallocation)(ke.attributes.KEYFORMATVERSIONS)), ke.attributes.KEYID && (Le.keyid = (0, _e.forceReallocation)(ke.attributes.KEYID)), Le;
          }
        }
        function we(ke, Le) {
          var He;
          if (ke.value) {
            var We = ke.value.split("@"), Xe = We[0], Qe = We[1], tt = { length: parseInt(Xe || "0") };
            if (Qe)
              tt.offset = parseInt(Qe);
            else {
              var Je = Le[Le.length - 1];
              Je != null && Je.byterange && (tt.offset = ((He = Je.byterange.offset) !== null && He !== void 0 ? He : 0) + Je.byterange.length);
            }
            return tt;
          }
        }
        function Pe(ke, Le) {
          var He, We;
          if (!((He = ke.attributes) === null || He === void 0) && He.URI) {
            var Xe = { url: (0, _e.forceReallocation)(ke.attributes.URI) };
            if (!((We = ke.attributes) === null || We === void 0) && We.BYTERANGE) {
              var Qe = ke.attributes.BYTERANGE.split("@"), tt = Qe[0], Je = Qe[1];
              Xe.byteRange = { start: parseInt(Je), end: parseInt(Je) + parseInt(tt) - 1 };
            }
            return Le.keys.length > 0 && (Xe.keys = ce([], Le.keys, !0), Le.keyInUse = !0), Xe;
          }
        }
        function Me(ke) {
          var Le;
          if (!((Le = ke.attributes) === null || Le === void 0) && Le.IV) {
            ke.attributes.IV = ke.attributes.IV.toLowerCase();
            var He = 2;
            ke.attributes.IV.substring(0, He) === "0x" && (ke.attributes.IV = ke.attributes.IV.substring(He)), ke.attributes.IV = new Uint8Array(le.FormatHelper.hexToBytes(ke.attributes.IV)).buffer;
          }
        }
        function Ae(ke) {
          var Le, He = { width: 0, height: 0 }, We = (Le = ke.attributes) === null || Le === void 0 ? void 0 : Le.RESOLUTION.split("x");
          return We[0] && (He.width = parseInt(We[0])), We[1] && (He.height = parseInt(We[1])), He;
        }
        var Oe = /(?:^|,)((?:[^=]*)=(?:"[^"]*"|[^,]*))/, Be = /([^=]*)=(.*)/, Ve = /^['"](.*)['"]$/, Ue = /^['"](.*)['"]$/g, Re = /^([^:="]*)([:=])?(.*)$/;
        function Ne(ke) {
          try {
            ke = (0, _e.forceReallocation)(ke);
            var Le = /^#([^:=]*)([:=])?(.*)$/.exec(ke);
            if (!(Le != null && Le[1]))
              return;
            var He = { name: Le[1] }, We = "";
            if (Le[2] === "=" && Le[3])
              We = Le[3];
            else if (Le[2] === ":" && Le[3]) {
              var Xe = Re.exec(Le[3]);
              Xe && Xe[2] === "=" && Xe[3] ? He.attributes = xe(Le[3]) : We = Le[3];
            }
            return We && (He.value = We.replace(Ue, "$1")), He;
          } catch {
            return;
          }
        }
        function xe(ke) {
          for (var Le = ke.split(Oe), He = Le.length, We = {}; He--; )
            if (Le[He] !== "") {
              var Xe = Be.exec(Le[He]);
              if (Xe) {
                var Qe = Xe.slice(1), tt = Qe[0], Je = Qe[1];
                We[tt.trim()] = Je.trim().replace(Ve, "$1");
              }
            }
          return We;
        }
      }, 49422: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ue) {
            for (var Re, Ne = 1, xe = arguments.length; Ne < xe; Ne++)
              for (var ke in Re = arguments[Ne])
                Object.prototype.hasOwnProperty.call(Re, ke) && (Ue[ke] = Re[ke]);
            return Ue;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HlsParsing = ne.M3u8Translator = void 0;
        var ce, he = ie(52442), _e = ie(42283), le = ie(3941), se = ie(10676), oe = ie(79814), ue = ie(331), be = ie(76885), ve = ie(54838), me = ie(91520), pe = ie(16368), fe = ie(73543), ge = ie(67883), ye = ie(83740), $e = ie(73471), Se = ie(53950), Ce = new RegExp(/^data:text\/plain.*;base64.*,(.+)/), Ie = function() {
          function Ue(Re, Ne) {
            this.adaptationsetId = 0, this.assumeAudioMuxedIntoVideoTs = !1, this.memoizedParseBase64DataUrl = (0, se.memoize)(function(xe) {
              var ke = Ce.exec(xe);
              return ke !== null && ke.length === 2 ? ke[1] : null;
            }), this.context = Re, this.sourceContext = Ne, this.representationFactory = new $e.M3u8RepresentationFactory(Re, Ne);
          }
          return Ue.prototype.updateBaseUrl = function(Re) {
            this.baseURL = be.URLHelper.removeLastPathPart(Re);
          }, Ue.prototype.getBaseUrl = function() {
            var Re;
            return (Re = this.baseURL) !== null && Re !== void 0 ? Re : "";
          }, Ue.prototype.createCeaCaptionObjects = function(Re, Ne) {
            for (var xe = {}, ke = { _schemeIdUri: "urn:scte:dash:cc:cea-" + Ne + ":2015", _value: "" }, Le = 0; Le < Re.length; Le++) {
              var He = Re[Le]["INSTREAM-ID"];
              xe[He] = { lang: Re[Le].LANGUAGE || Re[Le].NAME || He, label: Re[Le].NAME || Re[Le].LANGUAGE || He }, ke._value.length > 0 && (ke._value += ";"), ke._value += Ne === "708" ? He.substring(7) + "=lang:" : He + "=", ke._value += Re[Le].LANGUAGE;
            }
            return { closedCaptionLabel: xe, accessibility: ke };
          }, Ue.prototype.createCaptionElements = function(Re) {
            if (!Re)
              return { closedCaptionLabel: null, accessibility: [] };
            var Ne = this.createCeaCaptionObjects(Re.cea608, "608"), xe = this.createCeaCaptionObjects(Re.cea708, "708"), ke = [], Le = null;
            return Ne.accessibility._value && (ke.push(Ne.accessibility), Le = Ne.closedCaptionLabel), xe.accessibility._value && ke.push(xe.accessibility), { closedCaptionLabel: Le, accessibility: ke };
          }, Ue.prototype.createVideoAdaptationSet = function(Re, Ne, xe, ke, Le) {
            for (var He = [], We = 1 / 0, Xe = 0, Qe = 1 / 0, tt = 0, Je = 1 / 0, Ge = 0, Ye = null, ze = "video/" + ke, Fe = 0, ot = Re; Fe < ot.length; Fe++) {
              var vt = ot[Fe];
              if (vt.uri) {
                var gt = this.representationFactory.create(vt, he.RepresentationType.VIDEO, ke, this.baseURL, this.assumeAudioMuxedIntoVideoTs);
                He.push(gt), We = Math.min(We, gt._height), Xe = Math.max(Xe, gt._height), Qe = Math.min(Qe, gt._width), tt = Math.max(tt, gt._width), Je = Math.min(Je, gt._bandwidth), Ge = Math.max(Ge, gt._bandwidth);
              }
            }
            He.sort(function(ut, Ke) {
              return ut._bandwidth - Ke._bandwidth;
            });
            var yt = { Representation: He, ContentComponent: [{ _id: "video", _contentType: "video" }], _id: String(this.adaptationsetId), _group: Ye, _mimeType: ze, _internalId: new ge.AdaptationSetId(xe, String(this.adaptationsetId++)), _minBandwidth: Je, _maxBandwidth: Ge, _minHeight: We, _maxHeight: Xe, _minWidth: Qe, _maxWidth: tt, isTransmuxingRequired: !0 };
            Le && Object.keys(Le).forEach(function(ut) {
              Le[ut].entries.filter(function(Ke) {
                return !Ke.URI;
              }).forEach(function(Ke) {
                yt.ContentComponent.push({ _id: Ke.NAME, _contentType: "audio", _lang: Ke.LANGUAGE });
              });
            });
            var pt = this.createCaptionElements(Ne);
            pt.closedCaptionLabel && (yt.ClosedCaptionLabels = pt.closedCaptionLabel), pt.accessibility.length > 0 && (yt.Accessibility = pt.accessibility);
            var bt = this.getLabelForAdaptationSet(yt);
            return bt && typeof bt == "string" && (yt._label = bt), yt;
          }, Ue.prototype.createAudioAdaptationSet = function(Re, Ne, xe, ke) {
            for (var Le = [], He = 1 / 0, We = 0, Xe = null, Qe = 0, tt = Re; Qe < tt.length; Qe++) {
              var Je = tt[Qe];
              if (Je.uri) {
                var Ge = this.representationFactory.create(Je, he.RepresentationType.AUDIO, ke, this.baseURL, this.assumeAudioMuxedIntoVideoTs);
                Le.push(Ge);
              }
            }
            Le.sort(function(ot, vt) {
              return ot._bandwidth - vt._bandwidth;
            });
            var Ye = { Representation: Le, _id: String(this.adaptationsetId), _group: Xe, _mimeType: "audio/" + ke, _internalId: new ge.AdaptationSetId(xe, String(this.adaptationsetId++)), _minBandwidth: He, _maxBandwidth: We, isTransmuxingRequired: !0 }, ze = this.createCaptionElements(Ne);
            ze.closedCaptionLabel && (Ye.ClosedCaptionLabels = ze.closedCaptionLabel), ze.accessibility.length > 0 && (Ye.Accessibility = ze.accessibility);
            var Fe = this.getLabelForAdaptationSet(Ye);
            return Fe && typeof Fe == "string" && (Ye._label = Fe), Ye;
          }, Ue.prototype.createAudioAdaptationSets = function(Re, Ne, xe) {
            var ke = this, Le = this.context.settings.IGNORE_HLS_AUDIO_GROUPS, He = 0, We = [], Xe = function(Qe) {
              return { Representation: [], _id: String(ke.adaptationsetId), _internalId: new ge.AdaptationSetId(Re, String(ke.adaptationsetId++)), _mimeType: "audio/" + xe, _minBandwidth: 1 / 0, _maxBandwidth: -1, _lang: Qe, _group: String(He++), isTransmuxingRequired: !0 };
            };
            return Object.keys(Ne).forEach(function(Qe) {
              var tt, Je, Ge, Ye = Ne[Qe], ze = Ye.entries.find(function(ut) {
                return ut.LANGUAGE && ut.LANGUAGE !== "und";
              });
              ze && (Je = ze.LANGUAGE), Le || (Ge = Xe(Je));
              for (var Fe = (0, ye.uniqueRenditions)(Ye.entries.filter(function(ut) {
                return ut.URI;
              })), ot = 0, vt = Fe; ot < vt.length; ot++) {
                var gt = vt[ot];
                Le && (Ge = Xe(Je));
                var yt = ke.representationFactory.create(gt, he.RepresentationType.AUDIO, xe, ke.baseURL, ke.assumeAudioMuxedIntoVideoTs);
                Ge.Representation.push(yt), Ge._minBandwidth = Math.min(Ge._minBandwidth, yt._bandwidth), Ge._maxBandwidth = Math.max(Ge._maxBandwidth, yt._bandwidth);
                var pt = gt.CHARACTERISTICS;
                if (pt && pt.indexOf(ke.context.settings.HLS_VR_CHARACTERISTICS_UTI) === 0 && (Ge.Role = [{ _schemeIdUri: ke.context.settings.VR_SCHEME_ID_URI, _value: pt.substring(ke.context.settings.HLS_VR_CHARACTERISTICS_UTI.length) }]), !Ge._label) {
                  var bt = ke.getLabelForAdaptationSet(Ge);
                  bt && typeof bt == "string" ? Ge._label = bt : yt._name ? Ge._label = yt._name : Ge._label = Qe;
                }
                Le && Ge.Representation.length > 0 && We.push(Ge), Ge.Representation.sort(function(ut, Ke) {
                  return ut._bandwidth - Ke._bandwidth;
                });
              }
              we((tt = Ge == null ? void 0 : Ge.Representation) !== null && tt !== void 0 ? tt : []), !Le && Ge.Representation.length > 0 && We.push(Ge);
            }), We;
          }, Ue.prototype.createSubtitleAdaptationSets = function(Re, Ne, xe) {
            var ke = this, Le = 0;
            return Object.values(Ne).filter(function(He) {
              return He.URI;
            }).map(function(He) {
              var We = { Representation: [], _id: String(ke.adaptationsetId), _internalId: new ge.AdaptationSetId(Re, String(ke.adaptationsetId++)), _mimeType: "application/mp4", _lang: He.LANGUAGE, _group: "" + Le++, _isFragmented: !0 }, Xe = ke.representationFactory.create(He, he.RepresentationType.SUBTITLE, xe, ke.baseURL, ke.assumeAudioMuxedIntoVideoTs);
              We.Representation.push(Xe);
              var Qe = ke.getLabelForAdaptationSet(We);
              return Qe && typeof Qe == "string" ? We._label = Qe : Xe._name ? We._label = Xe._name : We._label = He.LANGUAGE, We;
            });
          }, Ue.prototype.getLabelForAdaptationSet = function(Re) {
            var Ne = { mimeType: Re._mimeType, lang: Re._lang };
            return Re._label && (Ne.label = Re._label), this.getLabelingFunctionForAdaptationSet()(Ne);
          }, Ue.prototype.getLabelingFunctionForAdaptationSet = function() {
            var Re, Ne = this.context.sourceContext, xe = Ne && Ne.source && Ne.source.labeling;
            return !((Re = xe == null ? void 0 : xe.hls) === null || Re === void 0) && Re.tracks ? typeof xe.hls.tracks != "function" ? this.getDefaultLabelForAdaptationSet : (0, ve.safeUserCallback)(function() {
              return xe.hls.tracks;
            }, this.context.logger) : this.getDefaultLabelForAdaptationSet;
          }, Ue.prototype.getDefaultLabelForAdaptationSet = function() {
            return null;
          }, Ue.prototype.extractBackupStreams = function(Re) {
            for (var Ne, xe = [], ke = (Ne = this.baseURL) !== null && Ne !== void 0 ? Ne : "", Le = Re.playlists, He = {}, We = 0; We < Le.length; We++) {
              var Xe = {}, Qe = Le[We];
              this.addBackupStream(Xe, Qe, Re.media, ke);
              for (var tt = We + 1; tt < Le.length; tt++) {
                var Je = Le[tt];
                Oe(Qe, Je) && (this.addBackupStream(Xe, Je, Re.media, ke), Je.attributes.AUDIO && Je.attributes.AUDIO !== Qe.attributes.AUDIO && (He[Je.attributes.AUDIO] = !0), Le.splice(tt, 1), tt--);
              }
              xe.push(Xe);
            }
            return this.context.settings.IGNORE_HLS_AUDIO_GROUPS || (Re.media = Re.media.filter(function(Ge) {
              return !He[Ge.attributes["GROUP-ID"]];
            })), xe;
          }, Ue.prototype.addBackupStream = function(Re, Ne, xe, ke) {
            this.context.settings.DISABLE_HLS_BACKUP_STREAM_FAILOVER || (Re[String(Object.keys(Re).length)] = Pe(Ne, xe, ke));
          }, Ue.prototype.createDashManifestSkeleton = function(Re) {
            var Ne = Re;
            return this.extractCodecInformation(Ne), this.playlistPreprocessing(Ne), this.assumeAudioMuxedIntoVideoTs = this.canAssumeAudioMuxedIntoVideo(Ne), { BaseURL: [{ url: this.baseURL }], Period: [this.createPeriod(Ne, le.DEFAULT_PERIOD_ID)], _hasIndependentSegments: Re.independentSegments, _isHls: !0, isInitialized: !1 };
          }, Ue.prototype.extractCodecInformation = function(Re) {
            var Ne = this;
            Re.playlists.forEach(function(xe) {
              if (xe.attributes.CODECS) {
                var ke = _e.CodecStringHelper.getExtractedCodecStrings(xe.attributes.CODECS);
                if (!ke.video && ke.unknown && (xe.attributes.RESOLUTION || xe.attributes["FRAME-RATE"])) {
                  var Le = _e.CodecStringHelper.extractCodec(ke.unknown);
                  Ne.context.logger.debug("Assuming unknown codec ".concat(Le, " is video")), _e.CodecStringHelper.addCodec("video", Le);
                }
              }
            });
          }, Ue.prototype.isVariantOfMimeType = function(Re, Ne) {
            return _e.CodecStringHelper.getMimeTypeForCodecString(Re.attributes.CODECS) === Ne;
          }, Ue.prototype.removeUnsupportedAudioOnlyVariants = function(Re) {
            var Ne = this, xe = Re.playlists.some(function(Le) {
              return Ne.isVariantOfMimeType(Le, "video");
            }), ke = Re.playlists.some(function(Le) {
              return Ne.isVariantOfMimeType(Le, "audio");
            });
            xe && ke && (Re.playlists = Re.playlists.filter(function(Le) {
              return Ne.isVariantOfMimeType(Le, "video");
            }));
          }, Ue.prototype.playlistPreprocessing = function(Re) {
            this.removeUnsupportedAudioOnlyVariants(Re);
          }, Ue.prototype.getVideoCodecForPlaylist = function(Re, Ne) {
            Ne === void 0 && (Ne = !1);
            var xe = _e.CodecStringHelper.getExtractedCodecStrings(Re.attributes.CODECS);
            return xe.video ? (_e.CodecStringHelper.hasOldAvc1CodecFormat(xe.video) && (xe.video = _e.CodecStringHelper.convertAvc1ToAvcotiCodecFormat(xe.video)), Ne ? xe.video : xe.video.split(".")[0]) : null;
          }, Ue.prototype.getAudioCodecForPlaylist = function(Re, Ne) {
            Ne === void 0 && (Ne = !1);
            var xe = _e.CodecStringHelper.getExtractedCodecStrings(Re.attributes.CODECS);
            return xe.audio ? Ne ? xe.audio : xe.audio.split(".")[0] : null;
          }, Ue.prototype.getAllVideoCodecs = function(Re) {
            var Ne = this;
            return Re.map(function(xe) {
              return Ne.getVideoCodecForPlaylist(xe);
            }).filter(function(xe, ke, Le) {
              return xe && Le.indexOf(xe) === ke;
            });
          }, Ue.prototype.getAllAudioCodecs = function(Re) {
            var Ne = this;
            return Re.map(function(xe) {
              return Ne.getAudioCodecForPlaylist(xe);
            }).filter(function(xe, ke, Le) {
              return xe && Le.indexOf(xe) === ke;
            });
          }, Ue.prototype.groupPlaylistsByCodec = function(Re) {
            var Ne = this.getAllVideoCodecs(Re), xe = this.getAllAudioCodecs(Re);
            if (Ne.length === 0 && xe.length === 0)
              return { unknown: Re };
            if (Ne.length === 0) {
              var ke = {};
              return xe.forEach(function(He) {
                ke[He] = Re.filter(function(We) {
                  var Xe;
                  return (Xe = We.attributes.CODECS) === null || Xe === void 0 ? void 0 : Xe.includes(He);
                });
              }), ke;
            }
            var Le = {};
            return Ne.forEach(function(He) {
              Le[He] = Re.filter(function(We) {
                var Xe;
                return (Xe = We.attributes.CODECS) === null || Xe === void 0 ? void 0 : Xe.includes(He);
              });
            }), Le;
          }, Ue.prototype.createPeriod = function(Re, Ne) {
            var xe = this, ke = { _id: Ne, _duration: "PT0S", duration: 0, AdaptationSet: [] }, Le = function(Ge) {
              if (Ge.attributes.CODECS != null) {
                var Ye = Ee(Ge.attributes.CODECS), ze = _e.CodecStringHelper.getExtractedCodecStrings(Ye).video;
                return !!ze && xe.context.renderer.isMediaTypeSupported("video/mp4", ze);
              }
              return !0;
            }, He = ce.extractMediaRenditions(Re, this.context.settings.IGNORE_HLS_AUDIO_GROUPS, Le), We = this.groupPlaylistsByCodec(Re.playlists), Xe = Object.keys(We), Qe = Xe.filter(function(Ge) {
              return _e.CodecStringHelper.isVideoCodec(Ge);
            }).map(function(Ge) {
              return xe.createVideoAdaptationSet(We[Ge], He.captions, ke._id, fe.ContainerFormat.MP4, He.audio);
            }).filter(function(Ge) {
              return Ge.Representation = Ge.Representation.reduce(function(Ye, ze) {
                var Fe = Ue.isRepresentationSupported(ze, xe.context.renderer), ot = !!Ye.find(function(vt) {
                  return vt.Uri === ze.Uri;
                });
                return Fe && !ot && Ye.push(ze), Ye;
              }, []), Ge.Representation.length > 0;
            }), tt = this.createAudioAdaptationSets(ke._id, He.audio, fe.ContainerFormat.MP4).filter(function(Ge) {
              return Ge.Representation = Ge.Representation.filter(function(Ye) {
                return Ue.isRepresentationSupported(Ye, xe.context.renderer);
              }), Ge.Representation.length > 0;
            }).concat(Xe.filter(function(Ge) {
              return _e.CodecStringHelper.isAudioCodec(Ge);
            }).map(function(Ge) {
              return xe.createAudioAdaptationSet(We[Ge], He.captions, ke._id, fe.ContainerFormat.MP4);
            })), Je = this.createSubtitleAdaptationSets(ke._id, He.subtitles, fe.ContainerFormat.MP4);
            return ke.AdaptationSet = [].concat(Qe, tt, Je), me.ModuleManager.has(pe.ModuleName.Thumbnail) && (ke.AdaptationSet = me.ModuleManager.get(pe.ModuleName.Thumbnail).extendAdaptationSets(ke.AdaptationSet, Re, this.baseURL)), ke;
          }, Ue.isRepresentationSupported = function(Re, Ne) {
            var xe = !Re._mimeType.includes("audio") && !Re._mimeType.includes("video");
            if (!Re._codecs || xe)
              return !0;
            var ke = _e.CodecStringHelper.getExtractedCodecStrings(Re._codecs);
            return Object.keys(ke).every(function(Le) {
              return _e.CodecStringHelper.isSupportedByRenderer(Ne, Le + "/mp4", ke[Le]);
            });
          }, Ue.prototype.canAssumeAudioMuxedIntoVideo = function(Re) {
            var Ne = Re.media.filter(function(xe) {
              return Ae(xe.attributes);
            });
            return !Ne.length || Ne.some(function(xe) {
              return !xe.attributes.URI;
            });
          }, Ue.prototype.parseSegmentEncryptionInfo = function(Re, Ne, xe, ke, Le, He) {
            for (var We, Xe = function(Ge) {
              Qe.memoizedParseBase64DataUrl(Ge.uri) !== null ? (Ne.find(function(Ye) {
                return !Object.keys(Ge).some(function(ze) {
                  return Ge[ze] !== Ye[ze];
                });
              }) !== void 0 || Ne.push(Ge), Ne.length > 0 && (We = void 0)) : We = (0, Se.generateSegmentEncryptionInfo)(Ge, xe, ke, He, Le);
            }, Qe = this, tt = 0, Je = Re ?? []; tt < Je.length; tt++)
              Xe(Je[tt]);
            return We;
          }, Ue.prototype.translateSegmentList = function(Re, Ne) {
            var xe, ke, Le, He, We, Xe = Ne.segments, Qe = [], tt = [], Je = (Le = (ke = (xe = Re.BaseURL) === null || xe === void 0 ? void 0 : xe[0]) === null || ke === void 0 ? void 0 : ke.url) !== null && Le !== void 0 ? Le : "", Ge = "";
            Je && (Ge = (0, be.extractOrigin)(Je)), this.memoizedParseBase64DataUrl.invalidate();
            for (var Ye = 0, ze = function(vt) {
              var gt = Xe[vt];
              Je && (gt.uri = be.URLHelper.buildAbsoluteUrl(Je, Ge, gt.uri));
              var yt = Fe.parseSegmentEncryptionInfo(gt.keys, tt, Je, Ge, vt, (He = Re._hls) === null || He === void 0 ? void 0 : He.mediaSequence);
              gt.init && (gt.init.url = be.URLHelper.buildAbsoluteUrl(Je, Ge, gt.init.url), gt.init.key = Fe.parseSegmentEncryptionInfo(gt.init.keys, tt, Je, Ge, vt, (We = Re._hls) === null || We === void 0 ? void 0 : We.mediaSequence));
              var pt = { _media: gt.uri, _duration: gt.duration, _mediaSequence: gt.mediaSequence, _discontinuitySequenceNumber: gt.discontinuitySequenceNumber, _metadata: [] };
              Be(pt, "_discontinuity", gt.discontinuity), Be(pt, "_key", yt), Be(pt, "_init", gt.init), Be(pt, "_dateTime", gt.dateTime), Be(pt, "_byteRange", (0, Se.parseSegmentByteRange)(gt.byterange)), Be(pt, "_playbackTime", Ve(Ne, Ye, gt.dateTime)), ["cueTag", "scte35", "customTags"].filter(function(bt) {
                return gt.hasOwnProperty(bt);
              }).forEach(function(bt) {
                return pt._metadata = pt._metadata.concat(gt[bt]);
              }), gt.parts && (pt._parts = gt.parts.map(function(bt) {
                return ae(ae({}, bt), { uri: be.URLHelper.buildAbsoluteUrl(Je, Ge, bt.uri) });
              })), Qe.push(pt), Ye += gt.duration;
            }, Fe = this, ot = 0; ot < Xe.length; ot++)
              ze(ot);
            return { entries: Qe, contentProtectionInfos: this.parseAllContentProtection(tt) };
          }, Ue.prototype.parseAllContentProtection = function(Re) {
            var Ne = this, xe = [];
            return Re.forEach(function(ke) {
              var Le = Te(ke, Ne.memoizedParseBase64DataUrl(ke.uri));
              Le ? xe.push(Le) : Ne.context.logger.debug("Encountered unknown/unsupported DRM scheme:", ke.keyformat);
            }), xe;
          }, Ue.prototype.dispose = function() {
            this.baseURL = null, this.memoizedParseBase64DataUrl.invalidate();
          }, Ue;
        }();
        function Te(Ue, Re) {
          return me.ModuleManager.has(pe.ModuleName.DRM) ? me.ModuleManager.get(pe.ModuleName.DRM).ContentProtectionHelper.parseContentProtection(Ue, Re) : null;
        }
        function Ee(Ue) {
          return Ue.split(",").map(function(Re) {
            return _e.CodecStringHelper.hasOldAvc1CodecFormat(Re) ? _e.CodecStringHelper.convertAvc1ToAvcotiCodecFormat(Re) : Re;
          }).join(",");
        }
        function we(Ue) {
          Ue.forEach(function(Re, Ne) {
            Re._bandwidth = 128e3 + 32e3 * Ne;
          });
        }
        function Pe(Ue, Re, Ne) {
          var xe = {};
          return xe[oe.MimeType.VideoMp4] = be.URLHelper.getAbsoluteUrl(Ue.uri, Ne), Ue.attributes.AUDIO && Me(Re, Ue.attributes.AUDIO, Ne).forEach(function(ke) {
            xe[ke.id] = ke.url;
          }), xe;
        }
        function Me(Ue, Re, Ne) {
          return Ue.filter(function(xe) {
            return Ae(xe.attributes) && xe.attributes["GROUP-ID"] === Re && xe.attributes.URI;
          }).map(function(xe) {
            var ke;
            return { id: xe.attributes.NAME, url: be.URLHelper.getAbsoluteUrl((ke = xe.attributes.URI) !== null && ke !== void 0 ? ke : "", Ne) };
          });
        }
        function Ae(Ue) {
          return Ue.TYPE === "AUDIO";
        }
        function Oe(Ue, Re) {
          var Ne, xe, ke, Le, He = Ue.attributes.BANDWIDTH === Re.attributes.BANDWIDTH, We = ((Ne = Ue.attributes.RESOLUTION) === null || Ne === void 0 ? void 0 : Ne.height) === ((xe = Re.attributes.RESOLUTION) === null || xe === void 0 ? void 0 : xe.height) && ((ke = Ue.attributes.RESOLUTION) === null || ke === void 0 ? void 0 : ke.width) === ((Le = Re.attributes.RESOLUTION) === null || Le === void 0 ? void 0 : Le.width);
          return He && We;
        }
        function Be(Ue, Re, Ne) {
          Ne !== void 0 && (Ue[Re] = Ne);
        }
        function Ve(Ue, Re, Ne) {
          var xe;
          return Ue.endList ? ((xe = Ue.startTime) !== null && xe !== void 0 ? xe : 0) + Re : Ne ? (0, ue.toSeconds)(Ne.getTime()) : void 0;
        }
        ne.M3u8Translator = Ie, function(Ue) {
          function Re(Qe, tt) {
            var Je = {};
            return Qe.forEach(function(Ge) {
              var Ye = tt[Ge["GROUP-ID"]] || tt[Object.keys(tt)[0]];
              Ge["AVERAGE-BANDWIDTH"] = Ye[0]["AVERAGE-BANDWIDTH"], Ge.BANDWIDTH = Ye[0].BANDWIDTH, Ge.CODECS = Ye[0].CODECS;
              var ze = Ge["AVERAGE-BANDWIDTH"] || Ge.BANDWIDTH, Fe = Object.keys(Je).find(function(gt) {
                var yt, pt, bt = Je[gt].entries[0];
                return (bt == null ? void 0 : bt.NAME) === Ge.NAME && _e.CodecStringHelper.canSwitchBetweenAudioCodecs((yt = bt == null ? void 0 : bt.CODECS) !== null && yt !== void 0 ? yt : "", (pt = Ge.CODECS) !== null && pt !== void 0 ? pt : "");
              });
              if (Fe && Je[Fe]) {
                var ot = Je[Fe];
                ot.entries.push(Ge), ot.MIN_BANDWIDTH = Math.min(ot.MIN_BANDWIDTH, ze), ot.MAX_BANDWIDTH = Math.max(ot.MAX_BANDWIDTH, ze);
              } else {
                var vt = Ge.CODECS ? "".concat(Ge.NAME, " (").concat(Ge.CODECS, ")") : Ge.NAME;
                Je[vt] = { entries: [Ge], MIN_BANDWIDTH: ze, MAX_BANDWIDTH: ze };
              }
            }), Je;
          }
          function Ne(Qe) {
            var tt = {};
            return Qe.forEach(function(Je) {
              return tt[Je.NAME] = Je;
            }), tt;
          }
          function xe(Qe) {
            var tt = { cea608: [], cea708: [] };
            return Qe.forEach(function(Je) {
              Je["INSTREAM-ID"] && Je["INSTREAM-ID"].indexOf("CC") === 0 ? tt.cea608.push(Je) : Je["INSTREAM-ID"] && Je["INSTREAM-ID"].indexOf("SERVICE") === 0 && tt.cea708.push(Je);
            }), tt;
          }
          function ke(Qe, tt, Je) {
            var Ge = Qe.playlists.filter(Je), Ye = Qe.media.map(function(gt) {
              return gt.attributes;
            }), ze = We(Ge), Fe = Ye.filter(function(gt) {
              var yt = ze[gt["GROUP-ID"]];
              return Ae(gt) && (tt || yt);
            }), ot = Ye.filter(function(gt) {
              return gt.TYPE === "SUBTITLES";
            }), vt = Ye.filter(function(gt) {
              return gt.TYPE === "CLOSED-CAPTIONS";
            });
            return { audio: Re(Fe, ze), subtitles: Ne(ot), captions: xe(vt) };
          }
          function Le(Qe) {
            var tt = {};
            return Qe.forEach(function(Je) {
              var Ge = Je.attributes.AUDIO;
              tt[Ge] || (tt[Ge] = []);
              var Ye = { "AVERAGE-BANDWIDTH": Je.attributes["AVERAGE-BANDWIDTH"], BANDWIDTH: Je.attributes.BANDWIDTH, CODECS: void 0 };
              Je.attributes.CODECS && Je.attributes.CODECS.indexOf(",") > -1 && (Ye.CODECS = Xe(Je)), tt[Ge].push(Ye);
            }), tt;
          }
          function He(Qe) {
            Object.values(Qe).forEach(function(tt) {
              tt.sort(function(Je, Ge) {
                return Je.BANDWIDTH - Ge.BANDWIDTH;
              });
            });
          }
          function We(Qe) {
            var tt = Le(Qe);
            return He(tt), tt;
          }
          function Xe(Qe) {
            return Qe.attributes.CODECS.split(",").find(function(tt) {
              return _e.CodecStringHelper.isAudioCodec(tt);
            });
          }
          Ue.extractMediaRenditions = ke, Ue.getPropertiesForAudioGroups = We;
        }(ce || (ne.HlsParsing = ce = {}));
      }, 52080: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.StartTimeExtrapolationDirection = void 0, ne.extrapolateStartTime = se, ne.forwardExtrapolateSegmentStartTime = oe, ne.backwardExtrapolateSegmentStartTime = ue, ne.getStartTimeExtrapolationReferencePoint = be, ne.getStartTimeViaDiscontinuityBoundaries = ve, ne.findDiscontinuityBoundary = me, ne.hasDiscontinuityBoundary = pe;
        var ae, ce = ie(42055), he = ie(81361), _e = ie(331), le = ie(93326);
        function se(fe, ge, ye) {
          ye === void 0 && (ye = ae.Bidirectional), ye === ae.Backward ? ue(fe, ge) : (ye === ae.Forward || ue(fe, ge), oe(fe, ge));
        }
        function oe(fe, ge) {
          var ye = ge.index, $e = ge.startTime;
          fe[ye].startTime = $e;
          for (var Se = ye + 1; Se < fe.length; Se++)
            fe[Se].startTime = fe[Se - 1].startTime + fe[Se - 1].duration;
        }
        function ue(fe, ge) {
          var ye = ge.index, $e = ge.startTime;
          fe[ye].startTime = $e;
          for (var Se = ye - 1; Se >= 0; Se--)
            fe[Se].startTime = fe[Se + 1].startTime - fe[Se].duration;
        }
        function be(fe, ge, ye) {
          var $e, Se;
          if (ge.endList)
            return { index: 0, startTime: (0, ce.getStartTimeOffset)(ye) };
          var Ce = fe.segmentInfos[0];
          if (Ce != null && Ce.dateTime)
            return { index: 0, startTime: (0, _e.toSeconds)(Ce.dateTime.getTime()) };
          var Ie = (0, le.getMostRecentlyRefreshedQuality)(ye);
          if (Ie) {
            var Te = ve(fe, Ie);
            if (Te)
              return Te;
          }
          return { index: 0, startTime: (Se = ($e = Ie == null ? void 0 : Ie.segmentInfos[0]) === null || $e === void 0 ? void 0 : $e.startTime) !== null && Se !== void 0 ? Se : (0, _e.toSeconds)(ge.requestTimestamp) - ge.totalDuration };
        }
        function ve(fe, ge) {
          if (pe(fe.segmentInfos) && pe(ge.segmentInfos)) {
            var ye = ge.segmentInfos[ge.segmentInfos.length - 1], $e = me(ge.segmentInfos, ye.discontinuitySequenceNumber), Se = ge.segmentInfos[$e], Ce = me(fe.segmentInfos, Se.discontinuitySequenceNumber);
            if (Ce != null)
              return { index: Ce, startTime: Se.startTime };
          }
        }
        function me(fe, ge) {
          return pe(fe) ? (0, he.findIndexFromEnd)(fe, function(ye) {
            return !!ye.isDiscontinuityStart && ye.discontinuitySequenceNumber === ge;
          }) : -1;
        }
        function pe(fe) {
          if (!fe.length)
            return !1;
          if (fe[0].isDiscontinuityStart)
            return !0;
          var ge = fe[0], ye = fe[fe.length - 1];
          return ge.discontinuitySequenceNumber !== ye.discontinuitySequenceNumber;
        }
        (function(fe) {
          fe.Backward = "backward", fe.Forward = "forward", fe.Bidirectional = "Bidirectional";
        })(ae || (ne.StartTimeExtrapolationDirection = ae = {}));
      }, 52600: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.parseTag = le;
        var ae = ie(27485), ce = /^#(EXT[^:]*)(?::(.*))?$/, he = /^(?:"([^"]*)"|([^,=]+))(?:,|$)/g, _e = /([^=]+)=*(?:"([^"]*)"|([^",]*))(?:,|$)/g;
        function le(se) {
          var oe, ue = ce.exec(se);
          if (!ue)
            throw new Error("Invalid tag " + se);
          var be, ve = ue[1], me = ue[2], pe = {};
          if (me) {
            var fe = new ae.TextParser(me), ge = void 0, ye = fe.readRegex(he);
            for (ye && (be = (oe = ye[1]) !== null && oe !== void 0 ? oe : ye[2]); ge = fe.readRegex(_e); ) {
              var $e = ge[1], Se = ge[2] || ge[3];
              if ($e.includes(",")) {
                var Ce = $e.split(","), Ie = Ce[0];
                $e = Ce[1].trim(), pe[Ie] = void 0;
              }
              pe[$e] = Se, fe.skipWhitespace();
            }
          }
          return { name: ve, attributes: pe, value: be };
        }
      }, 52729: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(me) {
            for (var pe, fe = 1, ge = arguments.length; fe < ge; fe++)
              for (var ye in pe = arguments[fe])
                Object.prototype.hasOwnProperty.call(pe, ye) && (me[ye] = pe[ye]);
            return me;
          }, ae.apply(this, arguments);
        }, ce = this && this.__spreadArray || function(me, pe, fe) {
          if (fe || arguments.length === 2)
            for (var ge, ye = 0, $e = pe.length; ye < $e; ye++)
              !ge && ye in pe || (ge || (ge = Array.prototype.slice.call(pe, 0, ye)), ge[ye] = pe[ye]);
          return me.concat(ge || Array.prototype.slice.call(pe));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.createNewMapEntry = se, ne.updateMapEntry = oe;
        var he = ie(70016), _e = ie(28915), le = ie(52080);
        function se(me, pe) {
          var fe = me.segments.map(function(ge) {
            return ve(ge, pe);
          });
          return { qualityInfo: { lastUpdateTimestamp: Date.now() }, segmentInfos: fe };
        }
        function oe(me, pe, fe) {
          var ge = me.segmentInfos, ye = ge.findIndex(function(Te) {
            return be(Te, pe.segments[0]);
          });
          if (ye === -1)
            return se(pe, fe);
          var $e = ge.length - ye, Se = pe.segments.length - $e;
          if (ye !== 0 || Se !== 0) {
            var Ce = pe.segments.slice(-Se).map(function(Te) {
              return ve(Te, fe);
            }), Ie = ue(ge);
            return Ie != null && (0, le.forwardExtrapolateSegmentStartTime)(Ce, { index: 0, startTime: Ie }), { qualityInfo: ae(ae({}, me.qualityInfo), { lastUpdateTimestamp: Date.now() }), segmentInfos: ce(ce([], ge.slice(ye), !0), Ce, !0) };
          }
          return me;
        }
        function ue(me) {
          var pe = me[me.length - 1];
          if (pe.startTime !== void 0 && pe.duration !== void 0)
            return pe.startTime + pe.duration;
        }
        function be(me, pe) {
          var fe = me.url === pe.uri, ge = me.discontinuitySequenceNumber === pe.discontinuitySequenceNumber, ye = !me.byteRange && !pe.byterange, $e = me.byteRange && pe.byterange && me.byteRange.start === pe.byterange.offset && me.byteRange.end === pe.byterange.offset + pe.byterange.length;
          return fe && ge && ($e || ye);
        }
        function ve(me, pe) {
          var fe, ge = { url: me.uri, isInitSegment: !1, internalRepresentationId: pe._internalId, isDiscontinuityStart: me.discontinuity, discontinuitySequenceNumber: me.discontinuitySequenceNumber, duration: me.duration, startTime: me.startTime, periodId: pe._internalId.periodId, key: me.key, metadata: (fe = me.metadata) !== null && fe !== void 0 ? fe : [], mimeType: pe._mimeType, bitrate: pe._bandwidth, codecs: pe._codecs };
          return me.byterange && (ge.byteRange = { start: me.byterange.offset, end: me.byterange.offset + me.byterange.length }), me.init && (ge.init = me.init), me.dateTime && (ge.dateTime = me.dateTime), (0, he.isVideoRepresentation)(pe) && (ge.height = pe._height, ge.width = pe._width, ge.frameRate = pe._frameRate), ge.segmentId = (0, _e.generateSegmentId)(ge), ge;
        }
      }, 53950: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ue) {
            for (var Re, Ne = 1, xe = arguments.length; Ne < xe; Ne++)
              for (var ke in Re = arguments[Ne])
                Object.prototype.hasOwnProperty.call(Re, ke) && (Ue[ke] = Re[ke]);
            return Ue;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.PlaylistUtils = ne.isMediaPlaylist = ne.isMasterPlaylist = void 0, ne.calculateUpdateIntervalInSeconds = pe, ne.parseSegmentByteRange = ye, ne.generateSegmentEncryptionInfo = $e, ne.getLastMediaSequenceAndPartIndex = Ie, ne.canMakeBlockingPlaylistReload = Te, ne.canPerformDeltaUpdate = Ee, ne.calcNumberOfSegmentsToDrop = we, ne.addNewSegments = Pe, ne.isDeltaPlaylist = Be;
        var ce = ie(52442), he = ie(91397), _e = ie(81361), le = ie(331), se = ie(76885), oe = ie(93109), ue = ie(72927), be = function(Ue) {
          return "playlists" in Ue;
        };
        ne.isMasterPlaylist = be;
        var ve = function(Ue) {
          return !(0, ne.isMasterPlaylist)(Ue);
        };
        ne.isMediaPlaylist = ve;
        var me = function() {
          function Ue() {
          }
          return Ue.createDiscontinuitySequences = function(Re, Ne) {
            var xe = Re.segments.filter(function(We) {
              return We.duration > 0;
            }), ke = this.getStartingDiscontinuity(Re, xe, Ne), Le = { id: ke, segments: [], duration: 0 }, He = [Le];
            return xe.forEach(function(We, Xe) {
              We.discontinuity !== void 0 && (ke++, Xe === 0 ? Le.id = ke : (Le = { id: ke, duration: 0, segments: [] }, He.push(Le))), We.discontinuitySequenceNumber = ke, Le.segments.push(We), Le.duration += We.duration;
            }), He;
          }, Ue.getStartingDiscontinuity = function(Re, Ne, xe) {
            var ke = Re.discontinuitySequence;
            return ke == null && (ke = xe.length !== 0 && Ue.isLive(Re) ? this.findCurrentDiscontinuitySequenceNumber(Ne, xe) : 0), ke;
          }, Ue.findCurrentDiscontinuitySequenceNumber = function(Re, Ne) {
            for (var xe = [], ke = 0, Le = 0; Le < Ne.length - 1; Le++)
              ke += Ne[Le].segments.length, xe.push(ke);
            var He = [];
            return Re.forEach(function(We, Xe) {
              We.discontinuity !== void 0 && He.push(Xe);
            }), xe.length === 0 ? Ne[0] ? Ne[0].id : 0 : He.length === 0 ? Ne[Ne.length - 1].id : He.length !== xe.length ? He.length > xe.length ? Ne[0].id : Ne[1].id : this.findFirstPeriodByIndexTracking(xe, He, Ne);
          }, Ue.findFirstPeriodByIndexTracking = function(Re, Ne, xe) {
            if (Re[0] > Ne[0])
              return xe[0].id;
            if (Re[0] < Ne[0]) {
              for (var ke = Re[0] - Ne[0], Le = 0, He = 0; He < Re.length; He++)
                Re[He] + ke < Ne[0] && Le++;
              return xe[Le].id;
            }
            var We = function() {
              return Re.every(function(Qe, tt) {
                return Qe === Ne[tt];
              });
            };
            if (We())
              return xe[0].id;
            for (var Xe = 1; Re.length > 0; ) {
              for (Re.shift(), He = 0; He < Re.length; He++)
                Re[He]--;
              if (We())
                break;
              Xe++;
            }
            return xe[Xe].id;
          }, Ue.extrapolateProgramDateTime = function(Re) {
            var Ne = null;
            if (Re.find(function(Xe, Qe) {
              return Xe.dateTime && (Ne = Qe), Xe.dateTime !== void 0;
            }), Ne !== null) {
              var xe;
              for (xe = Ne - 1; xe >= 0; xe--) {
                var ke = Re[xe + 1].dateTime, Le = Math.ceil((0, le.toMilliSeconds)(Re[xe].duration));
                Re[xe].dateTime = new Date(ke.getTime() - Le);
              }
              for (xe = Ne + 1; xe < Re.length; xe++) {
                var He = Re[xe - 1].dateTime, We = Math.ceil((0, le.toMilliSeconds)(Re[xe - 1].duration));
                Re[xe].dateTime = new Date(He.getTime() + We);
              }
            }
          }, Ue.isLive = function(Re) {
            return Re.endList !== !0;
          }, Ue.getProgramDateTimeFromSegmentUrl = function(Re, Ne) {
            if (Re.indexOf("akamaihd.net") > -1) {
              var xe = Re.match(/segment(\d{9})/);
              if (xe && xe.length === 2) {
                var ke = parseInt(xe[1]) * Math.round((0, le.toMilliSeconds)(Ne));
                return new Date(ke);
              }
            }
            return null;
          }, Ue.correctStartOffsetToBounds = function(Re, Ne) {
            return Re > 0 && Re > Ne ? Ne : Re < 0 && Math.abs(Re) > Ne ? -Ne : Re;
          }, Ue.getImpreciseStartOffsetFromStartOfPlaylist = function(Re) {
            for (var Ne = Re.start.timeOffset, xe = 0, ke = 0; ke < Re.segments.length - 1 && Ne - Re.segments[ke + 1].duration > 0; ke++) {
              var Le = Re.segments[ke].duration;
              Ne -= Le, xe += Le;
            }
            return xe;
          }, Ue.getImpreciseStartOffsetFromEndOfPlaylist = function(Re) {
            for (var Ne = Math.abs(Re.start.timeOffset), xe = 0, ke = Re.segments.length - 1; ke >= 0 && ge(Ne, 1) > 0; ke--)
              Ne -= Re.segments[ke].duration, xe += ge(Re.segments[ke].duration, 2);
            return Re.totalDuration - xe;
          }, Ue.getImpreciseStartOffset = function(Re) {
            return Re.start.timeOffset >= 0 ? Ue.getImpreciseStartOffsetFromStartOfPlaylist(Re) : Ue.getImpreciseStartOffsetFromEndOfPlaylist(Re);
          }, Ue.getStartOffsetCloseToPlaylistEnd = function(Re, Ne) {
            var xe = Re.start.timeOffset;
            return xe = (xe = Ue.correctStartOffsetToBounds(xe, Re.totalDuration)) < 0 ? -ge(Math.abs(xe), 2) : ge(xe, 2), Math.max(Ne, xe);
          }, Ue.getStartOffset = function(Re) {
            var Ne = Re.start.timeOffset;
            return (Ne = Ue.correctStartOffsetToBounds(Ne, Re.totalDuration)) < 0 && (Ne += Re.totalDuration), Re.start.precise || (Ne = Ue.getImpreciseStartOffset(Re)), Number(Ne.toFixed(2));
          }, Ue.getBaseUrl = function(Re, Ne) {
            var xe = Re;
            return xe = se.URLHelper.removeUrlParameters(xe), !(Ne = se.URLHelper.removeLastPathPart(Ne)) || Ne.indexOf("/") < 0 ? Re : se.URLHelper.concatUrlParts(xe, Ne);
          }, Ue;
        }();
        function pe(Ue, Re) {
          if (!me.isLive(Re))
            return 1 / 0;
          var Ne = Re.segments[Re.segments.length - 1];
          if (Ne !== void 0) {
            if ((0, oe.isPlayingLowLatencyHls)(Ue)) {
              var xe = fe(Re, Ne);
              if (xe !== void 0)
                return xe;
            }
            return Math.max(Ue.settings.MINIMUM_ALLOWED_UPDATE_PERIOD, Ne.duration);
          }
          return Ue.settings.MINIMUM_ALLOWED_UPDATE_PERIOD;
        }
        function fe(Ue, Re) {
          var Ne, xe, ke = Re.parts;
          return ke && ke.length > 0 ? ke[ke.length - 1].duration : (xe = (Ne = Ue.partInfo) === null || Ne === void 0 ? void 0 : Ne.targetDuration) !== null && xe !== void 0 ? xe : void 0;
        }
        function ge(Ue, Re) {
          return Math.floor(Ue * Math.pow(10, Re)) / Math.pow(10, Re);
        }
        function ye(Ue) {
          var Re, Ne;
          if (Ue)
            return { start: (Re = Ue.offset) !== null && Re !== void 0 ? Re : 0, end: ((Ne = Ue.offset) !== null && Ne !== void 0 ? Ne : 0) + Ue.length - 1 };
        }
        function $e(Ue, Re, Ne, xe, ke) {
          if (Ue.method === ce.HlsEncryptionMethod.NONE)
            return Ue;
          var Le = new ArrayBuffer(16);
          return xe !== void 0 && new DataView(Le).setInt32(12, xe + ke), ae(ae({ iv: Le }, Ue), { uri: se.URLHelper.buildAbsoluteUrl(Re, Ne, Ue.uri) });
        }
        function Se(Ue) {
          var Re;
          return !((Re = Ue == null ? void 0 : Ue._hls) === null || Re === void 0) && Re.requestTimestamp ? (0, le.toSeconds)(Date.now() - Ue._hls.requestTimestamp) : 1 / 0;
        }
        function Ce(Ue, Re) {
          var Ne, xe = (Ne = Ue._hls) === null || Ne === void 0 ? void 0 : Ne.partTargetDuration;
          return xe ? xe * Re.LL_HLS_MAX_PLAYLIST_AGE_FOR_BLOCKING_REQUEST_IN_PART_TARGET_MULTIPLES : -1;
        }
        function Ie(Ue) {
          var Re, Ne, xe = (Re = Ue.SegmentList) === null || Re === void 0 ? void 0 : Re[0].SegmentURL, ke = xe == null ? void 0 : xe[xe.length - 1], Le = (Ne = ke == null ? void 0 : ke._parts) !== null && Ne !== void 0 ? Ne : [];
          if (ke && Le.length !== 0) {
            if ((Le = Le.filter(function(We) {
              return !We.isPreloadHint;
            })).length > 0)
              return { mediaSequence: ke._mediaSequence, partIndex: Le.length - 1 };
            var He = xe == null ? void 0 : xe[xe.length - 2];
            if (He != null && He._parts && He._parts.length !== 0)
              return { mediaSequence: He._mediaSequence, partIndex: He._parts.length - 1 };
          }
        }
        function Te(Ue, Re) {
          var Ne, xe, ke = !!(!((xe = (Ne = Ue._hls) === null || Ne === void 0 ? void 0 : Ne.serverControl) === null || xe === void 0) && xe.canBlockReload), Le = Ie(Ue), He = Se(Ue) <= Ce(Ue, Re);
          return ke && Le !== void 0 && He;
        }
        function Ee(Ue) {
          var Re, Ne, xe = (Ne = (Re = Ue._hls) === null || Re === void 0 ? void 0 : Re.serverControl) === null || Ne === void 0 ? void 0 : Ne.canSkipUntil;
          return xe !== void 0 && !(Se(Ue) > xe / 2);
        }
        function we(Ue, Re, Ne) {
          return Ue.length === 0 ? 0 : Re.length === 0 ? Ue.length : Re[0]._mediaSequence - Ue[0]._mediaSequence - Ne;
        }
        function Pe(Ue, Re) {
          if (Re.length !== 0)
            if (Ue.length !== 0) {
              var Ne = Ue[Ue.length - 1], xe = Re[Re.length - 1]._mediaSequence - Ne._mediaSequence, ke = (0, _e.findFromEnd)(Re, function(We) {
                return We._mediaSequence === Ne._mediaSequence;
              }), Le = ae(ae({}, Ne), ke);
              if (Ve(Le), Ue[Ue.length - 1] = Le, xe !== 0) {
                var He = Re.slice(-xe);
                He.forEach(Ve), Me(Le, He, ["_init", "_key"]), Ne._playbackTime !== void 0 && Oe(He, Ne._playbackTime + Ne._duration), Ue.push.apply(Ue, He);
              }
            } else
              Ue.push.apply(Ue, Re);
        }
        function Me(Ue, Re, Ne) {
          Re.forEach(function(xe) {
            Ne.forEach(function(ke) {
              return Ae(ke, Ue, xe);
            });
          });
        }
        function Ae(Ue, Re, Ne) {
          Re[Ue] && !Ne[Ue] && (Ne[Ue] = Re[Ue]);
        }
        function Oe(Ue, Re) {
          var Ne = Re;
          Ue.forEach(function(xe) {
            xe._playbackTime === void 0 && (xe._playbackTime = Ne), Ne = xe._playbackTime + xe._duration;
          });
        }
        function Be(Ue) {
          return Ue.skippedSegmentsCount > 0;
        }
        function Ve(Ue) {
          var Re;
          Ue._media = (0, he.forceReallocation)(Ue._media), (Re = Ue._metadata) === null || Re === void 0 || Re.forEach(function(Ne) {
            return (0, ue.forceReallocateStringProps)(Ne);
          });
        }
        ne.PlaylistUtils = me;
      }, 55877: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(be) {
            for (var ve, me = 1, pe = arguments.length; me < pe; me++)
              for (var fe in ve = arguments[me])
                Object.prototype.hasOwnProperty.call(ve, fe) && (be[fe] = ve[fe]);
            return be;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SEGMENT_TAGS = void 0, ne.parseVariant = se, ne.resolvePlaylistTag = ue;
        var ce = ie(62510), he = ie(56461), _e = ie(52600), le = ie(47967);
        function se(be, ve) {
          ve === void 0 && (ve = {});
          for (var me = { version: 1, allowCache: !0, hasM3u: !0, endList: !1, segments: [], dateRange: [], skippedSegmentsCount: 0, targetDuration: 0, totalDuration: 0, mediaSequence: 0 }, pe = [], fe = 0; fe < be.length; fe++) {
            var ge = (0, he.removeTrailingWhitespaces)(be[fe]);
            if (ge !== "")
              if ((0, he.isCustomTag)(ge))
                (0, he.handleCustomTag)(me, pe, ge);
              else {
                var ye = (0, _e.parseTag)(ge);
                if (ne.SEGMENT_TAGS.includes(ye.name))
                  return (0, he.parseSegments)(be.slice(fe), pe, me, ve), oe(me), me;
                ue(me, ye, pe);
              }
          }
          return oe(me), me;
        }
        function oe(be) {
          var ve;
          be.playlistType === "EVENT" && (be.discontinuitySequence = (ve = be.discontinuitySequence) !== null && ve !== void 0 ? ve : 0);
        }
        function ue(be, ve, me) {
          switch (ve.name) {
            case "EXT-X-VERSION":
              be.version = Number(ve.value);
              break;
            case "EXT-X-START":
              be.start = (0, le.generateStartAttributes)(ve);
              break;
            case "EXT-X-INDEPENDENT-SEGMENTS":
              be.independentSegments = !0;
              break;
            case "EXT-X-TARGETDURATION":
              ve.value && (be.targetDuration = parseInt(ve.value));
              break;
            case "EXT-X-MEDIA-SEQUENCE":
              ve.value && (be.mediaSequence = parseInt(ve.value));
              break;
            case "EXT-X-DISCONTINUITY-SEQUENCE":
              ve.value && (be.discontinuitySequence = parseInt(ve.value));
              break;
            case "EXT-X-PLAYLIST-TYPE":
              be.playlistType = ve.value === "EVENT" ? "EVENT" : "VOD";
              break;
            case "EXT-X-PART-INF":
              be.partInfo = (0, le.generatePartInfoTag)(ve.attributes);
              break;
            case "EXT-X-ALLOW-CACHE":
              be.allowCache = ve.value !== "NO";
              break;
            case "EXT-X-SERVER-CONTROL":
              be.serverControl = (0, le.generateServerControlTag)(ve);
              break;
            case "EXT-X-DATERANGE":
              be.dateRange.push((0, le.generateDateRange)(ve));
              break;
            case "EXTM3U":
              break;
            default:
              me.push(ae({ type: ce.MetadataType.CUSTOM }, ve)), (0, he.addCustomTagToPlaylistTagList)(be, ve);
          }
        }
        ne.SEGMENT_TAGS = ["EXTINF", "EXT-X-BYTERANGE", "EXT-X-DISCONTINUITY", "EXT-X-PROGRAM-DATE-TIME", "EXT-X-KEY", "EXT-X-GAP", "EXT-X-BITRATE", "EXT-X-PART", "EXT-X-MAP", "EXT-X-CUE-OUT-CONT", "EXT-X-CUE-OUT", "EXT-X-CUE-IN", "EXT-X-SCTE35", "EXT-X-SKIP"];
      }, 56461: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Te) {
            for (var Ee, we = 1, Pe = arguments.length; we < Pe; we++)
              for (var Me in Ee = arguments[we])
                Object.prototype.hasOwnProperty.call(Ee, Me) && (Te[Me] = Ee[Me]);
            return Te;
          }, ae.apply(this, arguments);
        }, ce = this && this.__spreadArray || function(Te, Ee, we) {
          if (we || arguments.length === 2)
            for (var Pe, Me = 0, Ae = Ee.length; Me < Ae; Me++)
              !Pe && Me in Ee || (Pe || (Pe = Array.prototype.slice.call(Ee, 0, Me)), Pe[Me] = Ee[Me]);
          return Te.concat(Pe || Array.prototype.slice.call(Ee));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.parseSegments = be, ne.addCustomTagToPlaylistTagList = ve, ne.handleCustomTag = me, ne.removeTrailingWhitespaces = Ce, ne.isCustomTag = Ie;
        var he = ie(52442), _e = ie(62510), le = ie(67550), se = ie(52600), oe = ie(55877), ue = ie(47967);
        function be(Te, Ee, we, Pe) {
          Pe === void 0 && (Pe = {});
          for (var Me, Ae = [], Oe = 0, Be = (0, ue.generateSegmentEntrySkeleton)(), Ve = ce([], Ee, !0), Ue = 0, Re = we.mediaSequence, Ne = { keys: [], keyInUse: !1 }, xe = function() {
            Be = (0, ue.generateSegmentEntrySkeleton)(), Ve = [], Ue = 0;
          }, ke = function(Qe) {
            pe(Be, Ue, Qe, Me, Ne, Ve, Re), Ae.push(Be), Oe += Ue, Re++, xe();
          }, Le = function(Qe) {
            var tt, Je, Ge = (0, se.parseTag)(Qe);
            switch (Ge.name) {
              case "EXTINF":
                Ue = parseFloat(Ge.value);
                break;
              case "EXT-X-BYTERANGE":
                Be.byterange = (0, ue.generateByteRangeTag)(Ge, Ae);
                break;
              case "EXT-X-DISCONTINUITY":
                Be.discontinuity = !0;
                break;
              case "EXT-X-PROGRAM-DATE-TIME":
                ge(Be, Ge);
                break;
              case "EXT-X-KEY":
                if (((tt = Ge.attributes) === null || tt === void 0 ? void 0 : tt.METHOD) === "NONE") {
                  Ne.keys = [{ method: he.HlsEncryptionMethod.NONE }];
                  break;
                }
                fe(Ge, Ne);
                break;
              case "EXT-X-MAP":
                Me = (0, ue.generateMapTag)(Ge, Ne);
                break;
              case "EXT-X-DATERANGE":
                we.dateRange.push((0, ue.generateDateRange)(Ge));
                break;
              case "EXT-X-CUE-OUT-CONT":
                Be.cueTag = (0, ue.generateCueTag)(Ge, "CUE-OUT-CONT");
                break;
              case "EXT-X-CUE-OUT":
                Be.cueTag = (0, ue.generateCueTag)(Ge, "CUE-OUT");
                break;
              case "EXT-X-CUE-IN":
                Be.cueTag = (0, ue.generateCueTag)(Ge, "CUE-IN");
                break;
              case "EXT-X-SCTE35":
                ye(Be, Ge);
                break;
              case "EXT-X-PART":
                $e(Ge, Be, Pe);
                break;
              case "EXT-X-PRELOAD-HINT":
                var Ye = Se(Ge, we.partInfo, Pe);
                Ye.init && (Me = Ye.init, Ne.keys.length > 0 && (Me.keys = ce([], Ne.keys, !0), Ne.keyInUse = !0)), Ye.part && (Be.parts = (Je = Be.parts) !== null && Je !== void 0 ? Je : [], Be.parts.push(Ye.part));
                break;
              case "EXT-X-SKIP":
                var ze = (0, ue.generateSkipTag)(Ge);
                we.skippedSegmentsCount = ze.skippedSegments, Re += ze.skippedSegments;
                break;
              case "EXT-X-ENDLIST":
                we.endList = !0;
                break;
              default:
                (0, oe.resolvePlaylistTag)(we, Ge, Ve);
            }
          }, He = 0, We = Te; He < We.length; He++) {
            var Xe = Ce(We[He]);
            Xe !== "" && (Xe.startsWith("#") ? Ie(Xe) ? me(we, Ve, Xe) : Le(Xe) : ke(Xe));
          }
          Be.parts && Be.parts.length > 0 && (Ue = Be.parts.reduce(function(Qe, tt) {
            return Qe + tt.duration;
          }, 0), ke(le.PHANTOM_SEGMENT_URL)), we.segments = Ae, we.totalDuration = Oe;
        }
        function ve(Te, Ee) {
          Te.tags === void 0 && (Te.tags = []), Ee && Te.tags.push(Ee);
        }
        function me(Te, Ee, we) {
          Ee.push({ type: _e.MetadataType.CUSTOM, attributes: we }), ve(Te, (0, ue.generateCustomTag)(we));
        }
        function pe(Te, Ee, we, Pe, Me, Ae, Oe) {
          Te.duration = Ee, Te.uri = we, Te.mediaSequence = Oe, Pe && (Te.init = Pe), Ae.length > 0 && (Te.customTags = Ae), Me.keys.length > 0 && (Te.keys = ce([], Me.keys, !0), Me.keyInUse = !0);
        }
        function fe(Te, Ee) {
          Ee.keyInUse && (Ee.keys = [], Ee.keyInUse = !1);
          var we = (0, ue.generateKeyTag)(Te);
          we !== void 0 && Ee.keys.push(we);
        }
        function ge(Te, Ee) {
          Ee.value && (Te.dateTime = new Date(Ee.value));
        }
        function ye(Te, Ee) {
          var we;
          Te.scte35 === void 0 && (Te.scte35 = []), Te.scte35.push({ type: _e.MetadataType.SCTE, attributes: ae({ CUE: (we = Ee.attributes) === null || we === void 0 ? void 0 : we.CUE }, Ee.attributes) });
        }
        function $e(Te, Ee, we) {
          var Pe;
          if (we.parsePartTags) {
            Ee.parts = (Pe = Ee.parts) !== null && Pe !== void 0 ? Pe : [];
            var Me = Ee.parts[Ee.parts.length - 1];
            Ee.parts.push((0, ue.generatePartTag)(Te.attributes, Me));
          }
        }
        function Se(Te, Ee, we) {
          return we.parsePartTags && Ee ? (0, ue.generatePreloadHintTag)(Te.attributes, Ee.targetDuration) : {};
        }
        function Ce(Te) {
          return Te.replace(/^[ \t]+/g, "");
        }
        function Ie(Te) {
          return /^#(?!EXT)/m.test(Te);
        }
      }, 59692: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.parsePlaylist = ue;
        var ae, ce = ie(56461), he = ie(52600), _e = ie(55877), le = ie(47967), se = /\r\n|\r(?=[^\n]|$)/gm, oe = /^#EXTM3U($|[ \t\n])/m;
        function ue(ve, me) {
          me === void 0 && (me = {});
          var pe = ve.indexOf("#EXTINF") === -1 ? ae.Master : ae.Media, fe = ve.replace(se, `
`).trim().split(/\n+/m), ge = (0, ce.removeTrailingWhitespaces)(fe[0]);
          if (!oe.test(ge))
            throw new Error("Playlist parsing failed: missing #EXTM3U tag");
          if (pe === ae.Media)
            return (0, _e.parseVariant)(fe, me);
          for (var ye, $e = [], Se = [], Ce = [], Ie = 1, Te = !0, Ee = !1, we = !0, Pe = 0; Pe < fe.length; Pe++) {
            var Me = (0, ce.removeTrailingWhitespaces)(fe[Pe]), Ae = fe[Pe + 1];
            if ((0, ce.isCustomTag)(Me))
              be($e, Me);
            else if (we)
              we = !1;
            else {
              var Oe = (0, he.parseTag)(Me);
              switch (Oe.name) {
                case "EXT-X-STREAM-INF":
                  Ce.push((0, le.generateStreamInfTag)(Oe, (0, ce.removeTrailingWhitespaces)(Ae))), we = !0;
                  break;
                case "EXT-X-MEDIA":
                  var Be = (0, le.generateRendition)(Oe);
                  Se.push(Be), $e.push(Be);
                  break;
                case "EXT-X-VERSION":
                  Ie = Number(Oe.value);
                  break;
                case "EXT-X-START":
                  ye = (0, le.generateStartAttributes)(Oe), $e.push(Oe);
                  break;
                case "EXT-X-ALLOW-CACHE":
                  Te = Oe.value === "YES" || Oe.value === void 0;
                  break;
                case "EXT-X-INDEPENDENT-SEGMENTS":
                  Ee = !0, $e.push(Oe);
                  break;
                case "EXT-X-I-FRAME-STREAM-INF":
                  (0, le.generateIFrameStreamInfTag)(Oe), $e.push(Oe);
                  break;
                case "EXT-X-SESSION-DATA":
                default:
                  $e.push(Oe);
                  break;
                case "EXT-X-SESSION-KEY":
                  (0, le.generateSessionKeyTag)(Oe), $e.push(Oe);
              }
            }
          }
          var Ve = { version: Ie, allowCache: Te, independentSegments: Ee, hasM3u: !0, media: Se, playlists: Ce, tags: $e = $e.concat(Ce) };
          return ye && (Ve.start = ye), Ve;
        }
        function be(ve, me) {
          var pe = (0, le.generateCustomTag)(me);
          pe && ve.push(pe);
        }
        (function(ve) {
          ve.Master = "master", ve.Media = "media";
        })(ae || (ae = {}));
      }, 64697: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.CodecDetector = void 0, ne.extractCodecFromTsSegment = me, ne.extractCodecFromMp4Segment = pe, ne.mergeSegmentCodecs = ge, ne.isFmp4Segment = ye;
        var ae = ie(52442), ce = ie(28764), he = ie(88005), _e = ie(81361), le = ie(76885), se = ie(91520), oe = ie(16368), ue = ie(41108), be = ie(53950), ve = function() {
          function Ce(Ie) {
            this.context = Ie, this.loader = new he.DefaultContentLoader(this.context);
          }
          return Ce.prototype.fetchSegment = function(Ie) {
            if (!this.context.segmentPrefetchingService)
              return Promise.reject();
            var Te = this.context.segmentPrefetchingService.hasPrefetchedSegment(Ie) ? this.context.segmentPrefetchingService.getPrefetchedSegment(Ie) : this.context.segmentPrefetchingService.fetch(Ie);
            return Te || Promise.reject();
          }, Ce.prototype.probeCodecs = function(Ie, Te, Ee, we, Pe) {
            var Me = this;
            Pe === void 0 && (Pe = Te ? Ie.length - 1 : 0);
            var Ae = Ie.slice(), Oe = Te ? Ae.pop() : Ae.shift();
            if (!Oe)
              return Promise.reject(new Error("Could not load any segment"));
            var Be, Ve = Oe.init, Ue = Ve !== void 0, Re = (0, le.extractOrigin)(Ee), Ne = le.URLHelper.buildAbsoluteUrl(Ee, Re, Ue ? Ve.url : Oe.uri), xe = Ue ? Ve.keys : Oe.keys, ke = Se(xe ?? [], Ee, Re, we, Pe);
            (ke == null ? void 0 : ke.method) === ae.HlsEncryptionMethod.AES_128 && (Be = ke);
            var Le = $e(Ne, Oe, Be);
            return this.fetchSegment(Le).then(function(He) {
              return Me.extractCodecsFromSegment(He);
            }).catch(function(He) {
              if (He instanceof ce.PlayerError)
                return Promise.reject(He);
              Me.context.logger.debug("Codec probing from segment failed", He);
              var We = Te ? Pe - 1 : Pe + 1;
              return Me.probeCodecs(Ae, Te, Ee, we, We);
            }).then(function(He) {
              return Me.context.logger.debug("Probed codec is", He), He;
            });
          }, Ce.prototype.extractCodecsFromSegment = function(Ie) {
            return ye(Ie) ? pe(Ie) : me(Ie, this.context);
          }, Ce;
        }();
        function me(Ce, Ie) {
          if (!se.ModuleManager.has(oe.ModuleName.ContainerTS))
            return Promise.reject(new ue.PlayerModuleMissingError(oe.ModuleName.ContainerTS));
          var Te = fe(Ie);
          return Te.transmuxSegment(Ce).then(function(Ee) {
            var we = ge(Ee.transmuxedSegments);
            if (!we)
              throw "couldn't detect codec for ".concat(Ce.getMimeType());
            return we;
          }).finally(function() {
            Te.dispose();
          });
        }
        function pe(Ce) {
          if (!se.ModuleManager.has(oe.ModuleName.ContainerMP4))
            return Promise.reject(new ue.PlayerModuleMissingError(oe.ModuleName.ContainerMP4));
          var Ie = se.ModuleManager.get(oe.ModuleName.ContainerMP4).getCodecFromSegment(Ce);
          return Ie ? Promise.resolve(Ie) : Promise.reject("couldn't detect codec for ".concat(Ce.getMimeType()));
        }
        function fe(Ce) {
          return new (se.ModuleManager.get(oe.ModuleName.ContainerTS)).WebWorkerTransmuxer(Ce, !1);
        }
        function ge(Ce) {
          for (var Ie = "", Te = 0, Ee = Ce; Te < Ee.length; Te++) {
            var we = Ee[Te];
            if (!we.getCodec())
              return null;
            Ie += (Ie === "" ? "" : ",") + we.getCodec();
          }
          return Ie;
        }
        function ye(Ce) {
          for (var Ie = Ce.getData(), Te = new DataView(Ie, 0, Ie.byteLength), Ee = [], we = 0; we + 8 < Te.byteLength; ) {
            var Pe = Te.getUint32(we);
            if (Pe === 0)
              break;
            var Me = _e.ArrayHelper.extractAsciiString(Te, we + 4, 4);
            Ee.push(Me), we += Pe;
          }
          return Ce.isInit() ? ["ftyp", "moov"].every(function(Ae) {
            return Ee.includes(Ae);
          }) : ["moof", "mdat"].every(function(Ae) {
            return Ee.includes(Ae);
          });
        }
        function $e(Ce, Ie, Te) {
          return { url: Ce, key: Te, byteRange: (0, be.parseSegmentByteRange)(Ie.byterange), mimeType: "unknown/mp4", internalRepresentationId: null, isInitSegment: !!Ie.init, preventDownloadCanceling: !0 };
        }
        function Se(Ce, Ie, Te, Ee, we) {
          for (var Pe, Me = 0, Ae = Ce; Me < Ae.length; Me++) {
            var Oe = Ae[Me];
            Pe = (0, be.generateSegmentEncryptionInfo)(Oe, Ie, Te, Ee, we);
          }
          return Pe;
        }
        ne.CodecDetector = ve;
      }, 64732: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HLSModuleDefinition = void 0;
        var ae = ie(16368), ce = ie(26527), he = ie(33827), _e = ie(22675), le = ie(59692), se = ie(53950), oe = ie(79367), ue = ie(78148), be = ie(34435), ve = { setPresentationTimeOffset: oe.setPresentationTimeOffset, setTimestampRolloverPositions: oe.setTimestampRolloverPositions }, me = { areDiscontinuitiesMisaligned: be.areDiscontinuitiesMisaligned, getPresentationTimeOffset: be.getPresentationTimeOffset, getHlsState: be.getHlsState, getPlaylistType: be.getPlaylistType, getIsLowLatencyPlaylist: be.getIsLowLatencyPlaylist, getEndlist: be.getEndlist, getDefaultLanguages: be.getDefaultLanguages, getCustomTags: be.getCustomTags, getDiscoSequenceTiming: be.getDiscoSequenceTiming, getDiscoSequenceTimings: be.getDiscoSequenceTimings, getFirstDiscoSequenceTiming: be.getFirstDiscoSequenceTiming, getMergedDiscontinuityTimings: be.getMergedDiscontinuityTimings };
        ne.HLSModuleDefinition = { name: ae.ModuleName.HLS, module: function() {
          return { HlsTimelineTracker: he.HlsTimelineTracker, M3u8Loader: _e.M3u8Loader, parsePlaylist: le.parsePlaylist, PlaylistUtils: se.PlaylistUtils, DiscontinuitySequenceNumberTracker: ce.DiscontinuitySequenceNumberTracker, HlsReducer: ue.HlsReducer, actions: ve, selectors: me, canMakeBlockingPlaylistReload: se.canMakeBlockingPlaylistReload };
        }, dependencies: [ae.ModuleName.EngineBitmovin] }, ne.default = ne.HLSModuleDefinition;
      }, 72927: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.forceReallocateStringProps = ce;
        var ae = ie(91397);
        function ce(he) {
          Object.keys(he).forEach(function(_e) {
            typeof he[_e] == "string" && (he[_e] = (0, ae.forceReallocation)(he[_e])), typeof he[_e] == "object" && ce(he[_e]);
          });
        }
      }, 73471: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.M3u8RepresentationFactory = void 0;
        var ae = ie(52442), ce = ie(33696), he = ie(42283), _e = ie(26190), le = ie(76885), se = ie(53950), oe = function() {
          function ue(be, ve) {
            this.context = be, this.sourceContext = ve;
          }
          return ue.prototype.create = function(be, ve, me, pe, fe) {
            if (fe === void 0 && (fe = !0), !be)
              return null;
            var ge = this.createBaseRepresentation(be, pe);
            if (ve === ae.RepresentationType.AUDIO)
              ge = this.extendToAudioRepresentation(be, ge, me, pe);
            else if (ve === ae.RepresentationType.VIDEO)
              ge = this.extendToVideoRepresentation(be, ge, me, pe, fe);
            else {
              if (ve !== ae.RepresentationType.SUBTITLE)
                return null;
              ge = this.extendToSubtitleRepresentation(be, ge, me, pe);
            }
            var ye = this.getLabelForRepresentation(ge);
            return ye && (ge._label = ye), ge;
          }, ue.prototype.createBaseRepresentation = function(be, ve) {
            var me = be.uri || be.URI;
            me && !le.URLHelper.isUrlAbsolute(me) && (me = le.URLHelper.concatBaseUrlWithPartial(ve, me));
            var pe = { _id: "", _mimeType: "", _bandwidth: 0, _codecs: "", _hls: { requestTimestamp: 0 }, BaseURL: null, SegmentList: [{ SegmentURL: [], entries: [], totalDuration: 0 }], Uri: me };
            return be.NAME && (pe._label = be.NAME), pe;
          }, ue.prototype.extendToVideoRepresentation = function(be, ve, me, pe, fe) {
            var ge = ve;
            if (ge._mimeType = "video/" + me, ge._width = 0, ge._height = 0, ge.BaseURL = [{ url: se.PlaylistUtils.getBaseUrl(pe, be.uri) }], ge._bandwidth = be.attributes["AVERAGE-BANDWIDTH"] || be.attributes.BANDWIDTH, ge._bandwidth || (ge._bandwidth = this.context.settings.MIN_SELECTABLE_VIDEO_BITRATE), ge._bandwidth = Number(ge._bandwidth), be.attributes.CODECS) {
              var ye = he.CodecStringHelper.getExtractedCodecStrings(be.attributes.CODECS);
              he.CodecStringHelper.hasOldAvc1CodecFormat(ye.video) && (ye.video = he.CodecStringHelper.convertAvc1ToAvcotiCodecFormat(ye.video)), fe ? ye.video && ye.audio ? ge._codecs = ye.video + "," + ye.audio : ye.video && !ye.audio ? ge._codecs = ye.video : !ye.video && ye.audio && (ge._codecs = ye.audio) : ge._codecs = ye.video;
            }
            return be.attributes["FRAME-RATE"] && (ge._frameRate = parseFloat(be.attributes["FRAME-RATE"])), be.attributes.RESOLUTION && (ge._width = be.attributes.RESOLUTION.width, ge._height = be.attributes.RESOLUTION.height, ge._id += be.attributes.RESOLUTION.height + "_"), ge._id += be.attributes.BANDWIDTH, ge;
          }, ue.prototype.extendToAudioRepresentation = function(be, ve, me, pe) {
            var fe, ge, ye, $e = ve;
            return $e._id = be.NAME + " " + be["GROUP-ID"] || "", $e._mimeType = "audio/" + me, $e._codecs = be.CODECS || ((fe = be.attributes) === null || fe === void 0 ? void 0 : fe.CODECS), $e._name = be.NAME || "", $e._groupId = be["GROUP-ID"] || "", $e._label = $e._name + " " + $e._groupId, $e._bandwidth = (ye = (ge = be["AVERAGE-BANDWIDTH"]) !== null && ge !== void 0 ? ge : be.BANDWIDTH) !== null && ye !== void 0 ? ye : 0, $e.BaseURL = [{ url: se.PlaylistUtils.getBaseUrl(pe, be.URI || be.uri) }], $e;
          }, ue.prototype.extendToSubtitleRepresentation = function(be, ve, me, pe) {
            var fe = ve;
            return fe._id = be.NAME, fe._mimeType = "application/" + me, fe._codecs = "wvtt", fe._name = be.NAME || "", fe.BaseURL = [{ url: se.PlaylistUtils.getBaseUrl(pe, be.URI) }], fe._hls.isForced = be.FORCED === "YES", fe;
          }, ue.prototype.getLabelForRepresentation = function(be) {
            var ve = { id: be._id, mimeType: be._mimeType, width: be._width, height: be._height, bitrate: be._bandwidth };
            return (0, _e.applyLabeling)({ source: this.sourceContext.source, context: this.context, streamType: ce.StreamType.Hls, labelingType: _e.LabelingType.Qualities }, ve);
          }, ue;
        }();
        ne.M3u8RepresentationFactory = oe;
      }, 73725: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Oe) {
            for (var Be, Ve = 1, Ue = arguments.length; Ve < Ue; Ve++)
              for (var Re in Be = arguments[Ve])
                Object.prototype.hasOwnProperty.call(Be, Re) && (Oe[Re] = Be[Re]);
            return Oe;
          }, ae.apply(this, arguments);
        }, ce = this && this.__spreadArray || function(Oe, Be, Ve) {
          if (Ve || arguments.length === 2)
            for (var Ue, Re = 0, Ne = Be.length; Re < Ne; Re++)
              !Ue && Re in Be || (Ue || (Ue = Array.prototype.slice.call(Be, 0, Re)), Ue[Re] = Be[Re]);
          return Oe.concat(Ue || Array.prototype.slice.call(Be));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.M3u8DashManifest = void 0;
        var he = ie(60997), _e = ie(63331), le = ie(42055), se = ie(81361), oe = ie(3941), ue = ie(331), be = ie(76885), ve = ie(54838), me = ie(94938), pe = ie(38353), fe = ie(41735), ge = ie(77874), ye = ie(31043), $e = ie(18665), Se = ie(79814), Ce = ie(97662), Ie = ie(52729), Te = ie(49422), Ee = ie(53950), we = ie(52080), Pe = ie(79367), Me = ie(34435), Ae = function() {
          function Oe(Be, Ve) {
            this.lastStartOffset = -1 / 0, this.context = Be, this.sourceContext = Ve, this.m3u8Translator = new Te.M3u8Translator(Be, Ve), this.totalDurationSec = 1 / 0, this.sourceStore = Be.serviceManager.get($e.ServiceName.SourceStoreService, Ve.sourceIdentifier);
          }
          return Oe.prototype.updateBaseUrl = function(Be) {
            this.m3u8Translator.updateBaseUrl(Be);
          }, Oe.prototype.getBaseUrl = function() {
            return this.m3u8Translator.getBaseUrl();
          }, Oe.prototype.getCurrentHlsState = function() {
            return (0, Me.getHlsState)(this.sourceStore.getState());
          }, Oe.prototype.findAdaptationSet = function(Be) {
            return this.getManifest().Period[0].AdaptationSet.find(function(Ve) {
              var Ue;
              return Ve._internalId.adaptationSetId === Be || ((Ue = Ve.ContentComponent) === null || Ue === void 0 ? void 0 : Ue.some(function(Re) {
                return Re._id === Be;
              }));
            });
          }, Oe.prototype.createDashManifestSkeleton = function(Be) {
            var Ve = this.m3u8Translator.createDashManifestSkeleton(Be);
            return Ve = (0, pe.initializeInternalIds)(Ve), Ve = (0, me.orderAdaptationSetsByCodec)(Ve, (0, pe.getCodecPriorities)(this.context.config, this.sourceContext.source));
          }, Oe.prototype.extractBackupStreams = function(Be) {
            return this.m3u8Translator.extractBackupStreams(Be);
          }, Oe.prototype.onMasterPlaylistAvailable = function(Be) {
            var Ve = this.createDashManifestSkeleton(Be);
            this.sourceStore.dispatch((0, fe.setManifestAction)(Ve)), this.sourceStore.dispatch((0, Pe.setDefaultLanguages)(Be)), this.sourceStore.dispatch((0, Pe.setCustomTags)(Be)), this.sourceStore.dispatch((0, Pe.setMasterPlaylistString)(Be.rawString));
          }, Oe.prototype.getManifest = function() {
            return (0, ge.getManifest)(this.sourceStore.getState());
          }, Oe.prototype.getAllVariantRepresentions = function() {
            var Be = function(Ve) {
              return Se.MimeTypeHelper.isAV(Ve._mimeType) || Se.MimeTypeHelper.isSubtitle(Ve._mimeType) || Se.MimeTypeHelper.isImage(Ve._mimeType);
            };
            return this.getManifest().Period[0].AdaptationSet.filter(Be).flatMap(function(Ve) {
              return Ve.Representation;
            });
          }, Oe.prototype.onMediaLoaded = function(Be, Ve, Ue) {
            var Re = this;
            this.sourceStore.dispatch((0, Pe.setMasterPlaylistString)(Be)), this.sourceStore.dispatch((0, Pe.setEndlist)(!!Ue.endList)), Ue.playlistType && !(0, Me.getPlaylistType)(this.getCurrentHlsState()) && this.sourceStore.dispatch((0, Pe.setPlaylistType)(Ue.playlistType)), (0, Me.getIsLowLatencyPlaylist)(this.getCurrentHlsState()) === void 0 && this.sourceStore.dispatch((0, Pe.setIsLowLatencyPlaylist)(Ue.partInfo !== void 0)), this.calculatePlaylistProgramDateTime(Ue), this.calculatePlaylistStartTime(Ue);
            var Ne = this.getManifest().Period[0], xe = this.getRepresentationsFromUrl(Ve.Uri, Ne).map(function(ke) {
              return Re.updateRepresentation(ke, Ue);
            });
            return Se.MimeTypeHelper.isAV(Ve._mimeType) && (this.trackPlaylistTiming(Ue, xe), this.updateDashManifestProperties(Ue)), xe.forEach(function(ke) {
              var Le = Re.determineFirstDiscoStartTime(ke, Ue);
              Re.updatePeriodStartAndDuration(Ne, Le, !Ue.endList), Re.ensureContentProtectionSignaledOnAdaptationSet(ke), Re.context.settings.ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE && Re.updateSegmentInfoMap(Ue, ke);
            }), this.context.serviceManager.maybeCall($e.ServiceName.TimedMetadataService, function(ke) {
              return (0, _e.extractDateRangeMetadata)(Ue.dateRange, Ue.endList ? Ue.programDateTime : void 0, function(Le) {
                ke.processDateRangeEvent(Le, oe.DEFAULT_PERIOD_ID);
              });
            }), xe.find(function(ke) {
              return ke._id === Ve._id;
            });
          }, Oe.prototype.ensureContentProtectionSignaledOnAdaptationSet = function(Be) {
            var Ve, Ue = (Ve = Be.ContentProtection) === null || Ve === void 0 ? void 0 : Ve.map(function(ke) {
              return { _schemeIdUri: ke._schemeIdUri, pssh: [], pro: [] };
            }), Re = this.findAdaptationSet(Be._internalId.adaptationSetId);
            if (Re && Ue) {
              var Ne = Ue.some(function(ke) {
                var Le;
                return !(!((Le = Re.ContentProtection) === null || Le === void 0) && Le.some(function(He) {
                  return He._schemeIdUri === ke._schemeIdUri;
                }));
              });
              if (Ne) {
                var xe = Re.ContentProtection ? (0, ve.removeDuplicates)(ce(ce([], Re.ContentProtection, !0), Ue, !0)) : Ue;
                this.sourceStore.dispatch((0, fe.updateAdaptationSetAction)(Be._internalId, { ContentProtection: xe }));
              }
            }
          }, Oe.prototype.updateSegmentInfoMap = function(Be, Ve) {
            var Ue, Re, Ne = Ve._internalId.key(), xe = (Ue = this.sourceStore.getState()) === null || Ue === void 0 ? void 0 : Ue.segmentInfoMap[Ne];
            xe && (Re = (0, Ie.updateMapEntry)(xe, Be, Ve)) || (Re = (0, Ie.createNewMapEntry)(Be, Ve), this.initializeStartTimesOnSegmentMapEntry(Re, Be)), this.sourceStore.dispatch((0, ye.setSegmentInfos)(Ne, Re));
          }, Oe.prototype.initializeStartTimesOnSegmentMapEntry = function(Be, Ve) {
            var Ue = this.sourceStore.getState();
            if (Ue) {
              var Re = (0, we.getStartTimeExtrapolationReferencePoint)(Be, Ve, Ue);
              (0, we.extrapolateStartTime)(Be.segmentInfos, Re);
            }
          }, Oe.prototype.determineFirstDiscoStartTime = function(Be, Ve) {
            var Ue, Re, Ne, xe = (Ne = (Re = (Ue = Be.SegmentList) === null || Ue === void 0 ? void 0 : Ue[0]) === null || Re === void 0 ? void 0 : Re.SegmentURL) !== null && Ne !== void 0 ? Ne : [];
            return xe.length > 0 && xe[0]._playbackTime != null ? (0, Me.getFirstDiscoSequenceTiming)(this.getCurrentHlsState()).startTime : Ve.startTime;
          }, Oe.prototype.updatePeriodStartAndDuration = function(Be, Ve, Ue) {
            var Re = Be.duration === 0 ? this.totalDurationSec : Math.min(Be.duration, this.totalDurationSec), Ne = Ue ? 1 / 0 : Re, xe = { start: Ve, _start: "PT".concat(Ve, "S"), duration: Ne, _duration: "PT".concat(Re, "S") };
            this.sourceStore.dispatch((0, fe.updatePeriodTimingAction)(oe.DEFAULT_PERIOD_ID, xe));
          }, Oe.prototype.trackPlaylistTiming = function(Be, Ve) {
            var Ue, Re, Ne, xe, ke, Le = Be.totalDuration, He = (Ue = Ve.find(function(tt) {
              return tt.Uri === Be.uri;
            })) !== null && Ue !== void 0 ? Ue : Ve[0], We = (Ne = (Re = He == null ? void 0 : He.SegmentList) === null || Re === void 0 ? void 0 : Re[0]) === null || Ne === void 0 ? void 0 : Ne.SegmentURL, Xe = ((xe = We == null ? void 0 : We.length) !== null && xe !== void 0 ? xe : 0) > 0 && ((ke = We == null ? void 0 : We[0]) === null || ke === void 0 ? void 0 : ke._playbackTime) !== void 0;
            if (We && Xe) {
              var Qe = (0, Ce.getTimingInfoFromSegmentList)(We);
              Le = Qe.totalDuration, this.sourceStore.dispatch((0, Pe.setDiscoTimings)(He._mimeType, Qe.discoTimings));
            }
            this.totalDurationSec = Be.endList ? Math.min(this.totalDurationSec, Le) : Le;
          }, Oe.prototype.updateDashManifestProperties = function(Be) {
            var Ve, Ue = !Be.endList, Re = (0, ge.getManifest)(this.sourceStore.getState()), Ne = { _requestTimestamp: Be.requestTimestamp, _type: Ue ? "dynamic" : "static", _mediaPresentationDuration: Ue ? 1 / 0 : "PT".concat(this.totalDurationSec, "S"), _maxSegmentDuration: "PT".concat(Be.targetDuration, "S"), _hasIndependentSegments: Re._hasIndependentSegments || Be.independentSegments };
            Be.start && (Be.start.timeOffset = Ee.PlaylistUtils.getStartOffsetCloseToPlaylistEnd(Be, this.lastStartOffset), this.lastStartOffset = Be.start.timeOffset, Ne._startOffset = Ee.PlaylistUtils.getStartOffset(Be)), Ue && (Ne._minimumUpdatePeriod = "PT".concat(Be.targetDuration, "S"), Ne._timeShiftBufferDepth = -this.totalDurationSec, Ne._availabilityStartTime = (Ve = Re._availabilityStartTime) !== null && Ve !== void 0 ? Ve : new Date(Be.requestTimestamp - (0, ue.toMilliSeconds)(this.totalDurationSec)).toISOString()), this.sourceStore.dispatch((0, fe.updateManifestAction)(Ne));
          }, Oe.prototype.getRepresentationsFromUrl = function(Be, Ve) {
            return Ve.AdaptationSet.flatMap(function(Ue) {
              return Ue.Representation.filter(function(Re) {
                return be.URLHelper.isSubUrl(Be, Re.Uri);
              });
            });
          }, Oe.prototype.updateRepresentation = function(Be, Ve) {
            var Ue = ae({}, Be);
            return Ue._requestTimestamp = Ve.requestTimestamp, Ue._updateInterval = (0, Ee.calculateUpdateIntervalInSeconds)(this.context, Ve), Ue._hls = ae(ae({}, Ue._hls), { requestTimestamp: Ve.requestTimestamp, mediaSequence: Ve.mediaSequence, serverControl: Ve.serverControl, loadFailureReason: null }), Ve.partInfo && (Ue._hls.partTargetDuration = Ve.partInfo.targetDuration), Ue.SegmentList = [ae({}, Ue.SegmentList[0])], Ue.SegmentList[0].SegmentURL = ce([], Ue.SegmentList[0].SegmentURL, !0), this.updateSegmentList(Ue, Ve), this.sourceStore.dispatch((0, fe.updateRepresentationAction)(Ue)), Ue;
          }, Oe.prototype.updateSegmentList = function(Be, Ve) {
            var Ue;
            if (Ve.segments.length !== 0) {
              if (Be.SegmentList) {
                this.context.logger.debug("Updating segment list for playlist ".concat(Be._id));
                var Re = this.getTranslatedSegmentList(Be, Ve);
                if (Re.contentProtectionInfos.length > 0) {
                  var Ne = Oe.contentProtectionToXmlJson(Re.contentProtectionInfos);
                  if ((0, Ee.isDeltaPlaylist)(Ve)) {
                    var xe = (Ue = Be.ContentProtection) !== null && Ue !== void 0 ? Ue : [];
                    Be.ContentProtection = (0, ve.removeDuplicates)(ce(ce([], xe, !0), Ne, !0));
                  } else
                    Be.ContentProtection = Ne;
                }
                var ke = Be.SegmentList[0].SegmentURL, Le = Re.entries, He = (0, Ee.calcNumberOfSegmentsToDrop)(ke, Le, Ve.skippedSegmentsCount);
                (0, se.removeEntriesFromStart)(ke, He), (0, Ee.addNewSegments)(ke, Le), Be.SegmentList[0]._duration = Ve.targetDuration, Be.SegmentList[0]._timescale = 1;
              }
            } else
              this.context.logger.debug("No segments for representation ".concat(Be._id, " in loaded playlist"));
          }, Oe.prototype.getTranslatedSegmentList = function(Be, Ve) {
            if (Ve.endList) {
              var Ue = this.context.serviceManager.maybeCall($e.ServiceName.ManifestCachingService, function(Re) {
                return Re.getSegmentList(Be.Uri);
              }, null, this.sourceContext.sourceIdentifier);
              return Ue || (Ue = this.m3u8Translator.translateSegmentList(Be, Ve), this.context.serviceManager.maybeCall($e.ServiceName.ManifestCachingService, function(Re) {
                return Re.cacheSegmentList(Ue, Be.Uri);
              }, null, this.sourceContext.sourceIdentifier)), Ue;
            }
            return this.m3u8Translator.translateSegmentList(Be, Ve);
          }, Oe.prototype.calculatePlaylistProgramDateTime = function(Be) {
            var Ve = Be.segments[0];
            Ve != null && Ve.dateTime && (Be.programDateTime = (0, ue.toSeconds)(Ve.dateTime.getTime()));
          }, Oe.prototype.calculatePlaylistStartTime = function(Be) {
            var Ve = Be.segments[0];
            Be.endList ? (Be.startTime = (0, le.getStartTimeOffset)(this.sourceStore.getState()), Be.segments[0].startTime = Be.startTime) : Ve && Ve.dateTime ? (Be.startTime = (0, ue.toSeconds)(Ve.dateTime.getTime()), Be.segments[0].startTime = Be.startTime) : Be.startTime = (0, ue.toSeconds)(Be.requestTimestamp) - Be.totalDuration;
          }, Oe.contentProtectionToXmlJson = function(Be) {
            return Be.map(function(Ve) {
              var Ue = { _schemeIdUri: Ve.schemeIdUri };
              return Ve.defaultKid && (Ue["_cenc:default_KID"] = Ve.defaultKid), Ve.pssh && (Ue.pssh = [{ __text: Ve.pssh }]), Ue;
            });
          }, Oe.prototype.dispose = function() {
            this.m3u8Translator = (0, he.dispose)(this.m3u8Translator);
          }, Oe;
        }();
        ne.M3u8DashManifest = Ae;
      }, 78148: function(ee, ne, ie) {
        var ae, ce = this && this.__assign || function() {
          return ce = Object.assign || function(Te) {
            for (var Ee, we = 1, Pe = arguments.length; we < Pe; we++)
              for (var Me in Ee = arguments[we])
                Object.prototype.hasOwnProperty.call(Ee, Me) && (Te[Me] = Ee[Me]);
            return Te;
          }, ce.apply(this, arguments);
        }, he = this && this.__spreadArray || function(Te, Ee, we) {
          if (we || arguments.length === 2)
            for (var Pe, Me = 0, Ae = Ee.length; Me < Ae; Me++)
              !Pe && Me in Ee || (Pe || (Pe = Array.prototype.slice.call(Ee, 0, Me)), Pe[Me] = Ee[Me]);
          return Te.concat(Pe || Array.prototype.slice.call(Ee));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HlsReducer = void 0, ne.extrapolateSegmentStartTime = Se;
        var _e = ie(21829), le = ie(90993);
        function se(Te, Ee) {
          return Te.masterPlaylist.string ? Te : ce(ce({}, Te), { masterPlaylist: { string: Ee } });
        }
        function oe(Te, Ee) {
          return ce(ce({}, Te), { playlistType: Ee });
        }
        function ue(Te, Ee) {
          return ce(ce({}, Te), { isLowLatencyPlaylist: Ee });
        }
        function be(Te, Ee) {
          return ce(ce({}, Te), { endlist: Ee });
        }
        function ve(Te, Ee) {
          var we, Pe = Ee.mimeType, Me = Ee.discoTimings;
          return ce(ce({}, Te), { discontinuitySequenceTiming: ce(ce({}, Te.discontinuitySequenceTiming), (we = {}, we[Pe] = Me, we)) });
        }
        function me(Te, Ee) {
          var we = {}, Pe = {};
          return Ee.media.forEach(function(Me) {
            var Ae = !!Me.attributes;
            if (Ae) {
              var Oe = Me.attributes, Be = Oe.TYPE, Ve = Oe.LANGUAGE;
              Ve && Ve != null && (Ae && Me.attributes.DEFAULT === "YES" && !we[Be] && (we[Be] = { name: Me.attributes.NAME, language: Ve }), Me.attributes.AUTOSELECT === "YES" && !Pe[Be] && (Pe[Be] = { name: Me.attributes.NAME, language: Ve }));
            }
          }), ce(ce({}, Te), { defaultLanguages: ce(ce({}, Pe), we) });
        }
        function pe(Te, Ee) {
          var we = Ee;
          return ce(ce({}, Te), { customTags: we.tags });
        }
        function fe(Te, Ee) {
          var we, Pe = Ee.discoSequenceNumber, Me = Ee.presentationTimeOffset;
          return ce(ce({}, Te), { presentationTimeOffsets: ce(ce({}, Te.presentationTimeOffsets), (we = {}, we[Pe] = Me, we)) });
        }
        function ge(Te, Ee) {
          return ce(ce({}, Te), { timestampRolloverPositions: Ee });
        }
        function ye(Te, Ee) {
          return ce(ce({}, Te), { contentLocationId: Ee.locationId });
        }
        function $e() {
          return { masterPlaylist: { string: "" }, defaultLanguages: {}, discontinuitySequenceTiming: {}, presentationTimeOffsets: {}, timestampRolloverPositions: { previous: -1, next: -1 } };
        }
        function Se(Te, Ee, we) {
          var Pe = he([], Te, !0);
          return Pe[Ee] = ce({}, Pe[Ee]), Pe[Ee].startTime = we, Ie(Pe, Ee), Ce(Pe, Ee), Pe;
        }
        function Ce(Te, Ee) {
          for (var we = Ee + 1; we < Te.length; we++)
            Te[we] = ce({}, Te[we]), Te[we].startTime = Te[we - 1].startTime + Te[we - 1].duration;
        }
        function Ie(Te, Ee) {
          for (var we = Ee - 1; we >= 0; we--)
            Te[we] = ce({}, Te[we]), Te[we].startTime = Te[we + 1].startTime - Te[we].duration;
        }
        ne.HlsReducer = (0, _e.default)($e(), ((ae = {})[le.HlsActionType.SetMasterPlaylistString] = function(Te, Ee) {
          return se(Te, Ee.payload);
        }, ae[le.HlsActionType.SetPlaylistType] = function(Te, Ee) {
          return oe(Te, Ee.payload);
        }, ae[le.HlsActionType.SetIsLowLatencyPlaylist] = function(Te, Ee) {
          return ue(Te, Ee.payload);
        }, ae[le.HlsActionType.SetEndlist] = function(Te, Ee) {
          return be(Te, Ee.payload);
        }, ae[le.HlsActionType.SetDefaultLanguages] = function(Te, Ee) {
          return me(Te, Ee.payload);
        }, ae[le.HlsActionType.SetCustomTags] = function(Te, Ee) {
          return pe(Te, Ee.payload);
        }, ae[le.HlsActionType.SetDiscoTimings] = function(Te, Ee) {
          return ve(Te, Ee.payload);
        }, ae[le.HlsActionType.SetPresentationTimeOffset] = function(Te, Ee) {
          return fe(Te, Ee.payload);
        }, ae[le.HlsActionType.SetTimestampRolloverPositions] = function(Te, Ee) {
          return ge(Te, Ee.payload);
        }, ae[le.HlsActionType.SetContentLocationId] = function(Te, Ee) {
          return ye(Te, Ee.payload);
        }, ae));
      }, 79367: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.setContentLocationId = ne.setTimestampRolloverPositions = ne.setPresentationTimeOffset = ne.setDiscoTimings = ne.setCustomTags = ne.setDefaultLanguages = ne.setEndlist = ne.setIsLowLatencyPlaylist = ne.setPlaylistType = ne.setMasterPlaylistString = void 0;
        var ae = ie(15231), ce = ie(90993), he = function(fe) {
          return (0, ae.createAction)(ce.HlsActionType.SetMasterPlaylistString, fe);
        };
        ne.setMasterPlaylistString = he;
        var _e = function(fe) {
          return (0, ae.createAction)(ce.HlsActionType.SetPlaylistType, fe);
        };
        ne.setPlaylistType = _e;
        var le = function(fe) {
          return (0, ae.createAction)(ce.HlsActionType.SetIsLowLatencyPlaylist, fe);
        };
        ne.setIsLowLatencyPlaylist = le;
        var se = function(fe) {
          return (0, ae.createAction)(ce.HlsActionType.SetEndlist, fe);
        };
        ne.setEndlist = se;
        var oe = function(fe) {
          return (0, ae.createAction)(ce.HlsActionType.SetDefaultLanguages, fe);
        };
        ne.setDefaultLanguages = oe;
        var ue = function(fe) {
          return (0, ae.createAction)(ce.HlsActionType.SetCustomTags, fe);
        };
        ne.setCustomTags = ue;
        var be = function(fe, ge) {
          return (0, ae.createAction)(ce.HlsActionType.SetDiscoTimings, { mimeType: fe, discoTimings: ge });
        };
        ne.setDiscoTimings = be;
        var ve = function(fe, ge) {
          return (0, ae.createAction)(ce.HlsActionType.SetPresentationTimeOffset, { discoSequenceNumber: fe, presentationTimeOffset: ge });
        };
        ne.setPresentationTimeOffset = ve;
        var me = function(fe, ge) {
          return (0, ae.createAction)(ce.HlsActionType.SetTimestampRolloverPositions, { next: fe, previous: ge });
        };
        ne.setTimestampRolloverPositions = me;
        var pe = function(fe) {
          return (0, ae.createAction)(ce.HlsActionType.SetContentLocationId, { locationId: fe });
        };
        ne.setContentLocationId = pe;
      }, 80211: function(ee, ne, ie) {
        ee.exports = function() {
          return ie(90040)('!function(){"use strict";var e={16:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.isBoolean=t.isNumber=void 0,t.isDefined=r,t.isVideoRepresentation=a;var n=function(e){return"number"==typeof e};t.isNumber=n;var i=function(e){return"boolean"==typeof e};function r(e){return null!=e}function a(e){return null!=e._height&&null!=e._width}t.isBoolean=i},331:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.toSeconds=i,t.toMilliSeconds=r;var n=1e3;function i(e){return e/n}function r(e){return e*n}},362:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.PlayerType=void 0,function(e){e.Html5="html5",e.Native="native",e.WebRtc="webrtc",e.Unknown="unknown"}(n||(t.PlayerType=n={}))},425:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.ReducerTree=void 0,t.isReducer=a,t.isReducerTree=o;var i=n(4210),r=function(){function e(){this.rootNode={}}return e.prototype.has=function(e){return Boolean(this.rootNode[e])},e.prototype.set=function(e,t){return this.rootNode[e]=t,this},e.prototype.get=function(e){return this.rootNode[e]},e.prototype.delete=function(e){delete this.rootNode[e]},e.prototype.keys=function(){return Object.keys(this.rootNode)},e.prototype.getCombinedReducersRecursively=function(e){var t=this,n={};return this.keys().forEach((function(i){var r=t.get(i),o=e.concat(String(i));n[i]=a(r)?r:r.getCombinedReducersRecursively(o)})),0===Object.keys(n).length?function(e){return{}}:(0,i.combineReducers)(n)},e.prototype.buildReducer=function(){return this.getCombinedReducersRecursively([])},e}();function a(e){return Boolean(e)&&"function"==typeof e}function o(e){return Boolean(e)&&e instanceof r}t.ReducerTree=r},618:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.StartOptionsActionKey=void 0,function(e){e.InitStartTimeOffset="@instance/sources/@source/startOptions/initStartTimeOffset",e.SetStartTimeOffset="@instance/sources/@source/startOptions/setStartTimeOffset"}(n||(t.StartOptionsActionKey=n={}))},1108:function(e,t,n){var i=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0}),t.PlayerModuleMissingError=void 0;var r=n(5550),a=function(e){function t(t,n){return n?e.call(this,r.ErrorCode.MODULE_DEPENDENCY_MISSING,{name:t,dependency:n},"The ".concat(t," module requires the ").concat(n," module to be included as well."))||this:e.call(this,r.ErrorCode.MODULE_MISSING,{name:t},"The ".concat(t," module is required to play this stream."))||this}return i(t,e),t}(n(8764).PlayerError);t.PlayerModuleMissingError=a},1361:function(e,t,n){var i=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var i,r=0,a=t.length;r<a;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.ArrayHelper=void 0,t.invert=o,t.findIndexFromEnd=s,t.findIndexWithin=u,t.findFromEnd=l,t.forEachFromIndex=d,t.forceArray=c,t.contains=f,t.shallowObjectMatcher=p,t.clearArray=g,t.removeEntriesFromStart=S;var r=n(6093),a=function(){function e(){}return e.comparePrimitiveArrays=function(e,t){if(e.length!==t.length)return!1;for(var n=0;n<e.length;n++)if(e[n]!==t[n])return!1;return!0},e.stringToArrayWithoutEncoding=function(e){for(var t=new Uint8Array(e.length),n=0;n<e.length;n++)t[n]=e.charCodeAt(n);return t},e.convertBufferSourceToUTF8=function(t,n){return void 0===n&&(n="utf-8"),t instanceof ArrayBuffer?t=new Uint8Array(t):t instanceof DataView&&(t=new Uint8Array(t.buffer,t.byteOffset,t.byteLength)),e.convertUint8ArrayToUtf8(t,n)},e.convertUint8ArrayToUtf8=function(e,t){if("undefined"!=typeof TextDecoder)return new TextDecoder(t).decode(e);for(var n=0,i="";n<e.length;){var r=e[n++];if(r>127)if(r>191&&r<224){if(n>=e.length||64&e[n]){i+="�";continue}r=(31&r)<<6|63&e[n++]}else if(r>223&&r<240){if(n+1>=e.length||64&e[n]||64&e[n+1]){i+="�";continue}r=(15&r)<<12|(63&e[n++])<<6|63&e[n++]}else{if(!(r>239&&r<248)){i+="�";continue}if(n+2>=e.length||64&e[n]||64&e[n+1]||64&e[n+2]){i+="�";continue}r=(7&r)<<18|(63&e[n++])<<12|(63&e[n++])<<6|63&e[n++]}r<=65535?i+=String.fromCharCode(r):r<=1114111?(r-=65536,i+=String.fromCharCode(r>>10|55296),i+=String.fromCharCode(1023&r|56320)):i+="�"}return i},e.sort=function(e,t,n){if("string"==typeof t&&"[object Array]"===Object.prototype.toString.call(e)){var i;if(n||(n="asc"),"asc"===n)i=-1;else{if("desc"!==n)return;i=1}if(e.length<2)return e;var r=function(e,n){return e[t]<n[t]?i:e[t]>n[t]?-1*i:0};return e.sort(r)}},e.append=function(t,n){var i=e.getTypedArrayType(t),r=e.getTypedArrayType(n);if(!i&&!r||i!==r)return null;var a=new i((t.byteLength+n.byteLength)/i.BYTES_PER_ELEMENT);return a.set(new i(t),0),a.set(new i(n),t.byteLength/i.BYTES_PER_ELEMENT),a},e.concatBuffers=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];if(!(e=e.filter((function(e){return e}))).length)return null;var n=e.reduce((function(e,t){return e+t.byteLength}),0),i=new Uint8Array(n);return e.reduce((function(e,t){return i.set(new Uint8Array(t),e),e+t.byteLength}),0),i.buffer},e.getTypedArrayType=function(e){return e instanceof Uint8Array?Uint8Array:e instanceof Uint16Array?Uint16Array:e instanceof Uint32Array?Uint32Array:null},e.getArray=function(t){return e.getTypedArrayType(t)?[].slice.call(t):Array.isArray(t)?t:null},e.union=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var n=[];return e.filter((function(e){return Boolean(e)})).forEach((function(e){return e.forEach((function(e){n.includes(e)||n.push(e)}))})),n},e.isArrayBuffer=function(e){return Boolean(e)&&e instanceof ArrayBuffer&&void 0!==e.byteLength},e.arrayBufferToAsciiString=function(t,n){return void 0===n&&(n=!0),e.sparseArrayBufferToAsciiString(t,1,0,n)},e.arrayBufferToBase64=function(e){for(var t="",n=new Uint8Array(e),i=0;i<n.length;i++)t+=String.fromCharCode(n[i]);return window.btoa(t)},e.sparseArrayBufferToAsciiString=function(e,t,n,i){void 0===t&&(t=2),void 0===n&&(n=0),void 0===i&&(i=!0);for(var r="",a=i?new Uint8Array(e):new Uint16Array(e),o=n;o<a.length;o+=t)r+=String.fromCharCode(a[o]);return r},e.intersect=function(){for(var t=[],n=0;n<arguments.length;n++)t[n]=arguments[n];var i=[],r=t.filter((function(e){return Boolean(e)}));return e.union.apply(e,t).forEach((function(e){r.every((function(t){return t.includes(e)}))&&i.push(e)})),i},e.addAndMergeIntersects=function(t,n){var r=t.filter((function(t){return e.intersect(t,n).length>0})),a=t.filter((function(e){return!r.includes(e)}));return 0===r.length?i(i([],t,!0),[n],!1):i([e.union.apply(e,i(i([],r,!1),[n],!1))],a,!0)},e.extractAsciiString=function(e,t,n){for(var i=t+n,r="";t<i;t++)r+=String.fromCharCode(e.getUint8(t));return r},e.extractHexString=function(e,t,n){for(var i=t+n,a="";t<i;t++)a+=r.FormatHelper.intToHex(e.getUint8(t));return a},e.toArray=function(e){try{if(!e||!e.length)return[];for(var t=new Array(e.length),n=0;n<e.length;n++)t[n]=e[n];return t}catch(e){return[]}},e}();function o(e){return function(t,n,i){return!e(t,n,i)}}function s(e,t){var n;for(n=e.length-1;n>=0&&!t(e[n]);n--);return n}function u(e,t,n,i){for(var r=t;r<n;r++)if(i(e[r]))return r;return-1}function l(e,t){return e[s(e,t)]}function d(e,t,n){for(;t<e.length;t++){n(e[t-1],e[t])}}function c(e){return Array.isArray(e)?e:[e]}function f(e,t,n){return void 0===n&&(n=p),null!=e.find((function(e){return n(t,e)}))}function p(e,t){return Object.keys(e).length===Object.keys(t).length&&Object.keys(e).every((function(n){return e[n]===t[n]}))}function g(e){e.splice(0,e.length)}function S(e,t){return t<1?[]:e.splice(0,t)}t.ArrayHelper=a},1397:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.kebabCaseToCamelCase=r,t.forceReallocation=a;var i=n(6435);function r(e){return e.split("-").map((function(e,t){return 0===t?e.toLowerCase():e.charAt(0).toUpperCase()+e.slice(1).toLowerCase()})).join("")}function a(e){return e?(0,i.isFirefox)()?JSON.parse(JSON.stringify(e)):(" "+e).slice(1):""}},1399:function(e,t){var n,i;Object.defineProperty(t,"__esModule",{value:!0}),t.CapabilityKey=t.CapabilityActionType=void 0,function(e){e.InitCapabilities="initcapabilities",e.SetCapability="setcapability"}(n||(t.CapabilityActionType=n={})),function(e){e.isPlayStation5="isPlayStation5",e.isPlayStation4="isPlayStation4",e.isMobile="isMobile",e.isTizen="isTizen",e.isSafari="isSafari",e.isChrome="isChrome",e.isChromium="isChromium",e.isFirefox="isFirefox",e.isFirefoxIOS="isFirefoxIOS",e.isWebOS="isWebOS",e.isVidaa="isVidaa",e.isVizio="isVizio",e.isIOS="isIOS",e.isSafariIOS="isSafariIOS",e.isEdge="isEdge",e.isLegacyEdge="isLegacyEdge",e.isReactNative="isReactNative",e.MSESafari="MSESafari",e.isLocalStorageAvailable="isLocalStorageAvailable",e.isInlinePlaybackRestricted="isInlinePlaybackRestricted",e.IOSVersion="IOSVersion",e.edgeVersion="edgeVersion",e.safariVersion="safariVersion",e.webOSChromiumVersion="webOSChromiumVersion",e.techSupportedByModules="techSupportedByModules",e.techSupportedByPlatform="techSupportedByPlatform",e.techSupportedByModulesOnPlatform="techSupportedByModulesOnPlatform"}(i||(t.CapabilityKey=i={}))},1520:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.ModuleManager=void 0;var i=n(5550),r=n(8764),a=n(1108),o=function(){function e(){}return e.initialize=function(){this.modules||(this.modules={})},e.add=function(e){if(this.initialize(),!e)throw new r.PlayerError(i.ErrorCode.MODULE_INVALID_DEFINITION,void 0,"Cannot add the module: no module definition was provided to the API.");if(!e.name)throw new r.PlayerError(i.ErrorCode.MODULE_INVALID_DEFINITION,void 0,"Cannot add the module: no `name` property was provided to the module definition.");if(!e.module)throw new r.PlayerError(i.ErrorCode.MODULE_INVALID_DEFINITION,void 0,"Cannot add the module: no `module` property was provided to the module definition.");if(e.dependencies){for(var t=0,n=e.dependencies;t<n.length;t++){var o=n[t];if(!this.has(o))throw new a.PlayerModuleMissingError(e.name,o)}if("function"!=typeof e.module)throw new r.PlayerError(i.ErrorCode.MODULE_INVALID_DEFINITION_DEPENDENCY,{name:e.name},"Cannot add the module: modules with dependencies must pass a deferred loading function to the `ModuleDefinition.module` property.")}var s=e.module;"function"==typeof s&&(s=s()),this.modules[e.name]={moduleDefinition:e,module:s},e.hooks&&e.hooks.add&&e.hooks.add(e.module)},e.remove=function(e){var t;if(this.modules){if(!this.modules[e])throw new a.PlayerModuleMissingError(e);var n=this.modules[e].moduleDefinition;(null===(t=n.hooks)||void 0===t?void 0:t.remove)&&n.hooks.remove(n.module),delete this.modules[e]}},e.get=function(e,t){void 0===t&&(t=!0),this.initialize();var n=this.modules[e];if(n&&n.module)return n.module;if(t)throw new a.PlayerModuleMissingError(e)},e.has=function(e){return void 0!==this.get(e,!1)},e.getModuleNames=function(){return Object.getOwnPropertyNames(this.modules)},e.getModuleDefinitions=function(){var e=this;return this.getModuleNames().map((function(t){return e.modules[t]}))},e.callSetupHooks=function(e){this.getModuleDefinitions().filter((function(e){return e.moduleDefinition.hooks&&e.moduleDefinition.hooks.setup})).forEach((function(t){return t.moduleDefinition.hooks.setup(t.module,e)}))},e.callDestroyHooks=function(e){var t=this.getModuleDefinitions().filter((function(e){return e.moduleDefinition.hooks&&e.moduleDefinition.hooks.destroy})).map((function(t){return t.moduleDefinition.hooks.destroy(t.module,e)}));return Promise.all(t).then((function(){}))},e}();t.ModuleManager=o},1715:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.MessageHandler=void 0;var n=function(){function e(e,t){this.runsInWebWorker=e,this.postMessageFunction=t}return e}();t.MessageHandler=n},1829:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.StaticActionTypes=void 0,function(e){e.Default="default"}(n||(t.StaticActionTypes=n={}));var i=function(e,t){return function(i,r){return void 0===i&&(i=e),t[r.type]?t[r.type](i,r):t[n.Default]?t[n.Default](i,r):i}};t.default=i},1921:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.StringStartsWithPolyfill=void 0,t.StringStartsWithPolyfill=function(){return{polyfill:function(){String.prototype.startsWith=function(e,t){var n=t>0?0|t:0;return this.substring(n,n+e.length)===e}}}}()},2055:function(e,t,n){var i,r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},r.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.StartOptionsReducer=void 0,t.getStartTimeOffset=d;var a=n(1829),o=n(5328),s=n(618),u=o.initialStartOptions,l=function(e,t){var n=t.payload;return r(r({},e),n)};function d(e){return e.startOptions.startTimeOffset}t.StartOptionsReducer=(0,a.default)(u,((i={})[s.StartOptionsActionKey.InitStartTimeOffset]=l,i[s.StartOptionsActionKey.SetStartTimeOffset]=l,i))},2103:function(e,t){function n(e,t){if(void 0!==e.mediaSequence&&void 0!==t.mediaSequence)return e.mediaSequence===t.mediaSequence;var n=r(e,t),i=o(e.byteRange,t.byteRange),a=e.discontinuitySequenceNumber===t.discontinuitySequenceNumber;return n&&i&&a}function i(e,t){var n=(null==e?void 0:e.url)===(null==t?void 0:t.url),i=o(null==e?void 0:e.byteRange,null==t?void 0:t.byteRange);return n&&i}function r(e,t){var n=a(e),i=a(t);return n.some((function(e){return i.includes(e)}))}function a(e){return[e.url,e.mediaURL].filter(Boolean)}function o(e,t){return null==e?null==t:null!=t&&e.start===t.start&&e.end===t.end}Object.defineProperty(t,"__esModule",{value:!0}),t.isIdenticalSegmentInfo=n,t.isIdenticalInitSegmentInfo=i},2442:function(e,t){var n,i,r,a,o,s;Object.defineProperty(t,"__esModule",{value:!0}),t.DrmSetupError=t.TransmuxingRejectionReason=t.SegmentVerificationResult=t.HlsEncryptionMethod=t.SOURCE_BUFFER_APPEND_STATUS=t.RepresentationType=void 0,function(e){e[e.AUDIO=1]="AUDIO",e[e.VIDEO=2]="VIDEO",e[e.SUBTITLE=3]="SUBTITLE"}(n||(t.RepresentationType=n={})),function(e){e[e.FAILURE=0]="FAILURE",e[e.QUOTA_EXCEEDED=1]="QUOTA_EXCEEDED",e[e.SUSPENDED=2]="SUSPENDED"}(i||(t.SOURCE_BUFFER_APPEND_STATUS=i={})),function(e){e.NONE="NONE",e.AES_128="AES-128",e.SAMPLE_AES="SAMPLE-AES",e.SAMPLE_AES_CTR="SAMPLE-AES-CTR"}(r||(t.HlsEncryptionMethod=r={})),function(e){e.Publish="publish",e.Drop="drop",e.Park="park"}(a||(t.SegmentVerificationResult=a={})),function(e){e.INVALID_TS_SEGMENT="Invalid TS segment, could not extract segment information",e.TRANSMUXING_ABORTED="Transmuxing was aborted as it is no longer needed"}(o||(t.TransmuxingRejectionReason=o={})),function(e){e.CANCELLED="Loading was cancelled for the DRM source",e.MISSING_CONFIGURATION="DRM is not configured"}(s||(t.DrmSetupError=s={}))},2510:function(e,t){var n,i,r,a,o;Object.defineProperty(t,"__esModule",{value:!0}),t.LatencyMode=t.AdInteractionType=t.AdQuartile=t.MetadataType=t.PlayerEvent=void 0,function(e){e.Ready="ready",e.Play="play",e.Playing="playing",e.Paused="paused",e.Seek="seek",e.Seeked="seeked",e.TimeShift="timeshift",e.TimeShifted="timeshifted",e.VolumeChanged="volumechanged",e.Muted="muted",e.Unmuted="unmuted",e.PlayerResized="playerresized",e.PlaybackFinished="playbackfinished",e.Error="error",e.Warning="warning",e.StallStarted="stallstarted",e.StallEnded="stallended",e.AudioChanged="audiochanged",e.AudioAdded="audioadded",e.AudioRemoved="audioremoved",e.VideoQualityChanged="videoqualitychanged",e.AudioQualityChanged="audioqualitychanged",e.VideoDownloadQualityChange="videodownloadqualitychange",e.AudioDownloadQualityChange="audiodownloadqualitychange",e.VideoDownloadQualityChanged="videodownloadqualitychanged",e.AudioDownloadQualityChanged="audiodownloadqualitychanged",e.VideoPlaybackQualityChanged="videoplaybackqualitychanged",e.AudioPlaybackQualityChanged="audioplaybackqualitychanged",e.TimeChanged="timechanged",e.CueParsed="cueparsed",e.CueEnter="cueenter",e.CueUpdate="cueupdate",e.CueExit="cueexit",e.SegmentPlayback="segmentplayback",e.Metadata="metadata",e.MetadataParsed="metadataparsed",e.MetadataChanged="metadatachanged",e.VideoAdaptation="videoadaptation",e.AudioAdaptation="audioadaptation",e.DownloadFinished="downloadfinished",e.SegmentRequestFinished="segmentrequestfinished",e.AdManifestLoaded="admanifestloaded",e.AdStarted="adstarted",e.OverlayAdStarted="overlayadstarted",e.AdQuartile="adquartile",e.AdSkipped="adskipped",e.AdClicked="adclicked",e.AdInteraction="adinteraction",e.AdLinearityChanged="adlinearitychanged",e.AdBreakStarted="adbreakstarted",e.AdBreakFinished="adbreakfinished",e.RestoringContent="restoringcontent",e.AdFinished="adfinished",e.AdError="aderror",e.VRViewingDirectionChange="vrviewingdirectionchange",e.VRViewingDirectionChanged="vrviewingdirectionchanged",e.VRStereoChanged="vrstereochanged",e.CastAvailable="castavailable",e.CastStopped="caststopped",e.CastStart="caststart",e.CastStarted="caststarted",e.CastWaitingForDevice="castwaitingfordevice",e.SourceLoaded="sourceloaded",e.SourceUnloaded="sourceunloaded",e.PeriodSwitch="periodswitch",e.PeriodSwitched="periodswitched",e.DVRWindowExceeded="dvrwindowexceeded",e.SubtitleAdded="subtitleadded",e.SubtitleRemoved="subtitleremoved",e.ShowAirplayTargetPicker="showairplaytargetpicker",e.AirplayAvailable="airplayavailable",e.AirplayChanged="airplaychanged",e.Destroy="destroy",e.PlaybackSpeedChanged="playbackspeedchanged",e.DurationChanged="durationchanged",e.ViewModeChanged="viewmodechanged",e.ModuleReady="moduleready",e.SubtitleEnable="subtitleenable",e.SubtitleEnabled="subtitleenabled",e.SubtitleDisable="subtitledisable",e.SubtitleDisabled="subtitledisabled",e.VideoQualityAdded="videoqualityadded",e.VideoQualityRemoved="videoqualityremoved",e.AudioQualityAdded="audioqualityadded",e.AudioQualityRemoved="audioqualityremoved",e.TargetLatencyChanged="targetlatencychanged",e.LatencyModeChanged="latencymodechanged",e.LicenseValidated="licensevalidated",e.DrmLicenseAdded="drmlicenseadded",e.AspectRatioChanged="aspectratiochanged"}(n||(t.PlayerEvent=n={})),function(e){e.CUETAG="CUETAG",e.DATERANGE="DATERANGE",e.EVENT_STREAM="EVENT-STREAM",e.CUSTOM="CUSTOM",e.SCTE="SCTE",e.ID3="ID3",e.EMSG="EMSG",e.CAST="CAST"}(i||(t.MetadataType=i={})),function(e){e.FIRST_QUARTILE="firstQuartile",e.MIDPOINT="midpoint",e.THIRD_QUARTILE="thirdQuartile"}(r||(t.AdQuartile=r={})),function(e){e.Vpaid="vpaid"}(a||(t.AdInteractionType=a={})),function(e){e.Idle="idle",e.Catchup="catchup",e.Fallback="fallback",e.Suspended="suspended"}(o||(t.LatencyMode=o={}))},2600:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.parseTag=s;var i=n(7485),r=/^#(EXT[^:]*)(?::(.*))?$/,a=/^(?:"([^"]*)"|([^,=]+))(?:,|$)/g,o=/([^=]+)=*(?:"([^"]*)"|([^",]*))(?:,|$)/g;function s(e){var t,n=r.exec(e);if(!n)throw new Error("Invalid tag "+e);var s,u=n[1],l=n[2],d={};if(l){var c=new i.TextParser(l),f=void 0,p=c.readRegex(a);for(p&&(s=null!==(t=p[1])&&void 0!==t?t:p[2]);f=c.readRegex(o);){var g=f[1],S=f[2]||f[3];if(g.includes(",")){var v=g.split(","),m=v[0];g=v[1].trim(),d[m]=void 0}d[g]=S,c.skipWhitespace()}}return{name:u,attributes:d,value:s}}},3091:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.StreamType=void 0,function(e){e.Progressive="progressive",e.Dash="dash",e.Hls="hls",e.Smooth="smooth",e.Whep="whep",e.Unknown="unknown"}(n||(t.StreamType=n={}))},3109:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.isPlayingLowLatencyHls=s;var i=n(7279),r=n(1520),a=n(6368),o=n(7062);function s(e){var t;if(!(0,o.isLowLatencyConfigured)(e)||!e.settings.LL_HLS)return!1;var n=(0,i.getSourceState)(e);if(!n)return!1;var s=r.ModuleManager.get(a.ModuleName.HLS,!1);if(!s)return!1;var u=s.selectors,l=u.getHlsState,d=u.getIsLowLatencyPlaylist,c=l(n);return!!c&&(null!==(t=d(c))&&void 0!==t&&t)}},3326:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.getMostRecentlyRefreshedQuality=t.getSegmentInfos=t.getSegmentMapEntry=void 0;var n=function(e,t){return null==e?void 0:e.segmentInfoMap[t]};t.getSegmentMapEntry=n;var i=function(e,n){var i,r;return null!==(r=null===(i=(0,t.getSegmentMapEntry)(e,n))||void 0===i?void 0:i.segmentInfos)&&void 0!==r?r:[]};t.getSegmentInfos=i;var r=function(e){if(e)return Object.values(e.segmentInfoMap).filter((function(e){return null!=e.qualityInfo.lastUpdateTimestamp})).sort((function(e,t){var n=e.qualityInfo.lastUpdateTimestamp;return t.qualityInfo.lastUpdateTimestamp-n}))[0]};t.getMostRecentlyRefreshedQuality=r},3485:function(e,t,n){var i=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var i,r=0,a=t.length;r<a;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.MSESafari=t.getBestTech=t.getTechSupportedByModules=t.getTechSupportedByPlatform=t.getTechSupportedByModulesOnPlatform=t.isLocalStorageAvailable=t.isInlinePlaybackRestricted=t.isFairPlayDrmSupported=t.supports=t.checkPlatformSupports=t.hasMediaSourceSupport=t.FairplayKeySystems=void 0,t.isUsingFileProtocol=_,t.isFetchSupported=D;var r,a=n(1520),o=n(6368),s=n(3696),u=n(3533),l=n(7093),d=n(9814),c=n(6435);!function(e){e.FPS_1="com.apple.fps.1_0",e.FPS_2="com.apple.fps.2_0"}(r||(t.FairplayKeySystems=r={}));var f=[{player:s.PlayerType.Html5,streaming:s.StreamType.Dash},{player:s.PlayerType.Html5,streaming:s.StreamType.Hls},{player:s.PlayerType.Html5,streaming:s.StreamType.Smooth},{player:s.PlayerType.WebRtc,streaming:s.StreamType.Whep},{player:s.PlayerType.Native,streaming:s.StreamType.Hls},{player:s.PlayerType.Native,streaming:s.StreamType.Progressive}],p=!0,g=Boolean(l.default.ArrayBuffer&&l.default.Uint8Array&&l.default.Uint16Array),S=function(){return"function"==typeof document.createElement("video").canPlayType},v=function(){var e=document.createElement("video");return e&&"function"==typeof e.canPlayType&&("maybe"===e.canPlayType("application/vnd.apple.mpegURL")||"maybe"===e.canPlayType("application/x-mpegURL")||"maybe"===e.canPlayType("audio/mpegurl")||"maybe"===e.canPlayType("audio/x-mpegurl"))},m=function(){var e,t,n,i="MediaSource"in l.default&&"function"==typeof(null===(e=l.default.MediaSource)||void 0===e?void 0:e.isTypeSupported),r="WebKitMediaSource"in l.default&&"function"==typeof(null===(t=l.default.WebKitMediaSource)||void 0===t?void 0:t.isTypeSupported),a="ManagedMediaSource"in l.default&&"function"==typeof(null===(n=l.default.ManagedMediaSource)||void 0===n?void 0:n.isTypeSupported);return i||r||a};t.hasMediaSourceSupport=m;var h=function(){var e=l.default.RTCPeerConnection,t=Boolean(e)&&"function"==typeof e.prototype.addTransceiver;return E()&&t},E=function(){var e,t,n,i,r;return Boolean(null!==(r=null!==(i=null!==(n=null!==(t=null===(e=navigator.mediaDevices)||void 0===e?void 0:e.getUserMedia)&&void 0!==t?t:navigator.getUserMedia)&&void 0!==n?n:navigator.webkitGetUserMedia)&&void 0!==i?i:navigator.mozGetUserMedia)&&void 0!==r?r:navigator.msGetUserMedia)},y=function(){var e=[];if(g?e=f.filter((function(e){return(0,t.supports)(e.player,e.streaming)})):e.push({player:s.PlayerType.Native,streaming:s.StreamType.Progressive}),(0,c.isSafari)())for(var n=1;n<e.length;n++)if(e[n].player===s.PlayerType.Native&&e[n].streaming===s.StreamType.Hls){e=e.splice(n,1).concat(e);break}return e};t.checkPlatformSupports=y;var I=function(e,n){var i=(0,t.hasMediaSourceSupport)()?[s.StreamType.Dash,s.StreamType.Hls,s.StreamType.Smooth]:[],r=h()?[s.StreamType.Whep]:[],a=function(){var e=[];return v()&&!(0,c.isEdge)()&&e.push(s.StreamType.Hls),S()&&p&&e.push(s.StreamType.Progressive),e},o=function(e){return e.some((function(e){return e===n}))};switch(e){case s.PlayerType.Html5:return o(i);case s.PlayerType.WebRtc:return o(r);case s.PlayerType.Native:return o(a());default:return!1}};t.supports=I;var T=function(){return Object.values(r).some((function(e){var t;return null===(t=l.default.WebKitMediaKeys)||void 0===t?void 0:t.isTypeSupported(e,d.MimeType.VideoMp4)}))};function _(){return"file:"===l.default.location.protocol}t.isFairPlayDrmSupported=T;var O=function(){var e=(0,c.getIOSVersion)(),t=e<c.IOS_9&&/iPad/i.test(navigator.userAgent),n=e<c.IOS_10&&/iP(hone|od)/i.test(navigator.userAgent);return c.isSafariIOS&&(t||n)};t.isInlinePlaybackRestricted=O;var R=function(){try{return l.default.localStorage&&"function"==typeof localStorage.getItem&&"function"==typeof localStorage.setItem}catch(e){return!1}};t.isLocalStorageAvailable=R;var N=function(){var e=(0,t.getTechSupportedByModules)(),n=(0,t.getTechSupportedByPlatform)(),i=function(e,t){return e.player===t.player&&e.streaming===t.streaming};return n.filter((function(t){return e.filter((function(e){return i(e,t)})).length>0}))};t.getTechSupportedByModulesOnPlatform=N;var b=function(){return(0,t.checkPlatformSupports)()};t.getTechSupportedByPlatform=b;var M=function(){var e=a.ModuleManager.has(o.ModuleName.EngineBitmovin)?a.ModuleManager.get(o.ModuleName.EngineBitmovin).technologyChecker.getSupportedTechnologies():[],t=a.ModuleManager.has(o.ModuleName.EngineNative)?a.ModuleManager.get(o.ModuleName.EngineNative).technologyChecker.getSupportedTechnologies():[],n=a.ModuleManager.has(o.ModuleName.EngineWebRtc)?a.ModuleManager.get(o.ModuleName.EngineWebRtc).technologyChecker.getSupportedTechnologies():[];return i(i(i([],e,!0),t,!0),n,!0)};t.getTechSupportedByModules=M;var A=function(e){var t=(0,u.getCapabilities)(),n=i([],t.techSupportedByPlatform,!0);if(!e||0===e.length)return n;var r=e.filter((function(e){return n.some((function(t,i){var r,a=e.player===t.player&&e.streaming===t.streaming,o=null!==(r=e.exclude)&&void 0!==r&&r;return a&&n.splice(i,1),a&&!o}))})).map((function(e){return{player:e.player,streaming:e.streaming}}));return i(i([],r,!0),n,!0)},P=function(e,t,n){void 0===e&&(e=[]),void 0===t&&(t={});var i=(0,u.getCapabilities)(),r=A(e),a=i.techSupportedByPlatform;return n&&(r=a.filter((function(e){return e.player===n.player&&e.streaming===n.streaming}))),(t.vr&&((0,c.isSafariIOS)()||(0,c.isSafari)())?r.filter((function(e){var t=e.streaming===s.StreamType.Progressive&&e.player===s.PlayerType.Native,n=e.streaming===s.StreamType.Hls&&e.player===s.PlayerType.Native;return t||n&&(!(0,c.isSafariIOS)()||(0,c.getIOSVersion)()>c.IOS_9)})):r).find((function(e){return Boolean(t[e.streaming])}))};function D(){return"function"==typeof l.default.fetch&&"function"==typeof l.default.AbortController}t.getBestTech=P;var L=function(){return(0,c.isSafari)()&&(0,t.hasMediaSourceSupport)()};t.MSESafari=L},3533:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.default=c,t.getCapabilities=f,t.getReachableDomains=g;var i,r=n(4210),a=n(7722),o=(n(8842),n(3679),n(9210)),s=n(425),u=n(9422),l=new s.ReducerTree;l.set("capabilities",a.CapabilityReducer).set("reachableDomains",o.ReachableDomainsReducer);var d=function(){var e=[(0,u.addStoreServiceDecoration)(l)];return(0,r.createStore)((function(){return{}}),r.compose.apply(void 0,e))};function c(){return i||(i=d()),i}function f(){return p(c().getState())}function p(e){return e.capabilities}function g(){return S(c().getState())}function S(e){return e.reachableDomains}},3553:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.SegmentInfoError=void 0,function(e){e.END_OF_STREAM_REACHED="END_OF_STREAM_REACHED",e.PERIOD_COMPLETE="PERIOD_COMPLETE",e.SEGMENT_EXCEEDING_PERIOD_DURATION="SEGMENT_EXCEEDING_PERIOD_DURATION"}(n||(t.SegmentInfoError=n={}))},3679:function(e,t){function n(e){Object.freeze(e);var t="function"==typeof e,i=Object.prototype.hasOwnProperty;return Object.getOwnPropertyNames(e).forEach((function(r){!i.call(e,r)||t&&("caller"===r||"callee"===r||"arguments"===r)||null===e[r]||"object"!=typeof e[r]&&"function"!=typeof e[r]||Object.isFrozen(e[r])||n(e[r])})),e}Object.defineProperty(t,"__esModule",{value:!0}),t.freeze=void 0,t.deepFreeze=n;var i=function(e){return null!==e&&"object"==typeof e},r=function(e){var t=e.getState();i(t)&&n(t)},a=function(e){return r(e),function(t){return function(n){r(e);try{return t(n)}finally{r(e)}}}};t.freeze=a},3696:function(e,t,n){var i=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0}),t.TimeMode=t.SupportedTechnologyMode=t.ViewMode=t.PlayerAPINotAvailableError=t.LogLevel=t.BufferType=t.MediaType=t.StreamType=t.PlayerType=void 0;var r=n(5550),a=n(8764),o=n(362);Object.defineProperty(t,"PlayerType",{enumerable:!0,get:function(){return o.PlayerType}});var s,u,l,d=n(3091);Object.defineProperty(t,"StreamType",{enumerable:!0,get:function(){return d.StreamType}}),function(e){e.Audio="audio",e.Video="video",e.Subtitles="subtitles",e.Thumbnails="thumbnails"}(s||(t.MediaType=s={})),function(e){e.ForwardDuration="forwardduration",e.BackwardDuration="backwardduration"}(u||(t.BufferType=u={})),function(e){e.DEBUG="debug",e.LOG="log",e.WARN="warn",e.ERROR="error",e.OFF="off"}(l||(t.LogLevel=l={}));var c,f,p,g=function(e){function t(t){return e.call(this,r.ErrorCode.API_NOT_AVAILABLE,void 0,"Cannot use the `player.".concat(t,"` API: the player has already been destroyed."))||this}return i(t,e),t}(a.PlayerError);t.PlayerAPINotAvailableError=g,function(e){e.Inline="inline",e.Fullscreen="fullscreen",e.PictureInPicture="pictureinpicture"}(c||(t.ViewMode=c={})),function(e){e.Platform="platform",e.Modules="modules",e.PlatformAndModules="platformandmodules"}(f||(t.SupportedTechnologyMode=f={})),function(e){e.RelativeTime="relativetime",e.AbsoluteTime="absolutetime"}(p||(t.TimeMode=p={}))},3801:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.StringIncludesPolyfill=void 0,t.StringIncludesPolyfill=function(){return{polyfill:function(){String.prototype.includes=function(e,t){return"number"!=typeof t&&(t=0),!(t+e.length>this.length)&&-1!==this.indexOf(e,t)}}}}()},4210:function(e,t,n){function i(e){return i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i(e)}function r(e,t){if("object"!=i(e)||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=i(r))return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}function a(e){var t=r(e,"string");return"symbol"==i(t)?t:t+""}function o(e,t,n){return(t=a(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,i)}return n}function u(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){o(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function l(e){return"Minified Redux error #"+e+"; visit https://redux.js.org/Errors?code="+e+" for the full message or use the non-minified dev environment for full errors. "}n.r(t),n.d(t,{__DO_NOT_USE__ActionTypes:function(){return f},applyMiddleware:function(){return I},bindActionCreators:function(){return E},combineReducers:function(){return m},compose:function(){return y},createStore:function(){return g},legacy_createStore:function(){return S}});var d=function(){return"function"==typeof Symbol&&Symbol.observable||"@@observable"}(),c=function(){return Math.random().toString(36).substring(7).split("").join(".")},f={INIT:"@@redux/INIT"+c(),REPLACE:"@@redux/REPLACE"+c(),PROBE_UNKNOWN_ACTION:function(){return"@@redux/PROBE_UNKNOWN_ACTION"+c()}};function p(e){if("object"!=typeof e||null===e)return!1;for(var t=e;null!==Object.getPrototypeOf(t);)t=Object.getPrototypeOf(t);return Object.getPrototypeOf(e)===t}function g(e,t,n){var i;if("function"==typeof t&&"function"==typeof n||"function"==typeof n&&"function"==typeof arguments[3])throw new Error(l(0));if("function"==typeof t&&void 0===n&&(n=t,t=void 0),void 0!==n){if("function"!=typeof n)throw new Error(l(1));return n(g)(e,t)}if("function"!=typeof e)throw new Error(l(2));var r=e,a=t,o=[],s=o,u=!1;function c(){s===o&&(s=o.slice())}function S(){if(u)throw new Error(l(3));return a}function v(e){if("function"!=typeof e)throw new Error(l(4));if(u)throw new Error(l(5));var t=!0;return c(),s.push(e),function(){if(t){if(u)throw new Error(l(6));t=!1,c();var n=s.indexOf(e);s.splice(n,1),o=null}}}function m(e){if(!p(e))throw new Error(l(7));if(void 0===e.type)throw new Error(l(8));if(u)throw new Error(l(9));try{u=!0,a=r(a,e)}finally{u=!1}for(var t=o=s,n=0;n<t.length;n++){(0,t[n])()}return e}function h(e){if("function"!=typeof e)throw new Error(l(10));r=e,m({type:f.REPLACE})}function E(){var e,t=v;return(e={subscribe:function(e){if("object"!=typeof e||null===e)throw new Error(l(11));function n(){e.next&&e.next(S())}return n(),{unsubscribe:t(n)}}})[d]=function(){return this},e}return m({type:f.INIT}),(i={dispatch:m,subscribe:v,getState:S,replaceReducer:h})[d]=E,i}var S=g;function v(e){Object.keys(e).forEach((function(t){var n=e[t];if(void 0===n(void 0,{type:f.INIT}))throw new Error(l(12));if(void 0===n(void 0,{type:f.PROBE_UNKNOWN_ACTION()}))throw new Error(l(13))}))}function m(e){for(var t=Object.keys(e),n={},i=0;i<t.length;i++){var r=t[i];0,"function"==typeof e[r]&&(n[r]=e[r])}var a,o=Object.keys(n);try{v(n)}catch(e){a=e}return function(e,t){if(void 0===e&&(e={}),a)throw a;for(var i=!1,r={},s=0;s<o.length;s++){var u=o[s],d=n[u],c=e[u],f=d(c,t);if(void 0===f){t&&t.type;throw new Error(l(14))}r[u]=f,i=i||f!==c}return(i=i||o.length!==Object.keys(e).length)?r:e}}function h(e,t){return function(){return t(e.apply(this,arguments))}}function E(e,t){if("function"==typeof e)return h(e,t);if("object"!=typeof e||null===e)throw new Error(l(16));var n={};for(var i in e){var r=e[i];"function"==typeof r&&(n[i]=h(r,t))}return n}function y(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return 0===t.length?function(e){return e}:1===t.length?t[0]:t.reduce((function(e,t){return function(){return e(t.apply(void 0,arguments))}}))}function I(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return function(e){return function(){var n=e.apply(void 0,arguments),i=function(){throw new Error(l(15))},r={getState:n.getState,dispatch:function(){return i.apply(void 0,arguments)}},a=t.map((function(e){return e(r)}));return i=y.apply(void 0,a)(n.dispatch),u(u({},n),{},{dispatch:i})}}}},4338:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.StringEndsWithPolyfill=void 0,t.StringEndsWithPolyfill=function(){return{polyfill:function(){String.prototype.endsWith=function(e,t){if(null==e)return!1;var n=this.length;return null!=t&&(n=Math.min(t,this.length)),this.substring(n-e.length,n)===e}}}}()},4388:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.DurationConverter=void 0;var n=function(){function e(){}return e.getDurationInSec=function(e){if("string"!=typeof e)return NaN;var t=/^([-])?P(([\\d.]*)Y)?(([\\d.]*)M)?(([\\d.]*)D)?(T)?(([\\d.]*)H)?(([\\d.]*)M)?(([\\d.]*|Infinity)S)?/.exec(e);if(t){var n=Boolean(t[1]),i=12*parseFloat(t[2]||"0")*30*24*60*60,r=30*parseFloat(t[4]||"0")*24*60*60,a=24*parseFloat(t[6]||"0")*60*60,o=60*parseFloat(t[9]||"0")*60,s=60*parseFloat(t[11]||"0"),u=parseFloat(t[13]||"0");if("T"===t[8]&&void 0===(t[9]||t[11]||t[13]))return NaN;var l=i+r+a+o+s+u;return n&&(l=-l),l}return NaN},e}();t.DurationConverter=n},5231:function(e,t){function n(e,t){return{type:e,meta:{},payload:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.createAction=n},5328:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.initialStartOptions=void 0,t.initializeStartTimeOffset=a,t.setStartTimeOffset=o;var i=n(5231),r=n(618);function a(){return o(t.initialStartOptions.startTimeOffset)}function o(e){return(0,i.createAction)(r.StartOptionsActionKey.SetStartTimeOffset,{startTimeOffset:e})}t.initialStartOptions={startTimeOffset:0}},5469:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.installWorkerPolyfills=s;var i=n(8367),r=n(4338),a=n(3801),o=n(1921);function s(){Array.prototype.includes||i.ArrayIncludesPolyfill.polyfill(),String.prototype.includes||a.StringIncludesPolyfill.polyfill(),String.prototype.startsWith||o.StringStartsWithPolyfill.polyfill(),String.prototype.endsWith||r.StringEndsWithPolyfill.polyfill()}},5550:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ErrorCode=void 0,function(e){e[e.UNKNOWN=1e3]="UNKNOWN",e[e.API_NOT_AVAILABLE=1001]="API_NOT_AVAILABLE",e[e.SETUP_ERROR=1100]="SETUP_ERROR",e[e.SETUP_NO_HTML_ELEMENT=1101]="SETUP_NO_HTML_ELEMENT",e[e.SETUP_MISSING_CONFIGURATION=1102]="SETUP_MISSING_CONFIGURATION",e[e.SETUP_LICENSE_ERROR=1103]="SETUP_LICENSE_ERROR",e[e.SETUP_MISSING_DOMAIN_LICENSE_WHITELIST=1104]="SETUP_MISSING_DOMAIN_LICENSE_WHITELIST",e[e.SETUP_MISSING_DOMAIN_LICENSE_ALLOWLIST=1104]="SETUP_MISSING_DOMAIN_LICENSE_ALLOWLIST",e[e.SETUP_MISSING_LICENSE_WHITELIST=1105]="SETUP_MISSING_LICENSE_WHITELIST",e[e.SETUP_MISSING_LICENSE_ALLOWLIST=1105]="SETUP_MISSING_LICENSE_ALLOWLIST",e[e.SETUP_INVALID_LICENSE_SERVER=1106]="SETUP_INVALID_LICENSE_SERVER",e[e.SETUP_INVALID_IMPRESSION_SERVER=1107]="SETUP_INVALID_IMPRESSION_SERVER",e[e.SETUP_NO_RENDERING_ENGINE=1108]="SETUP_NO_RENDERING_ENGINE",e[e.SETUP_UNSUPPORTED_PROTOCOL=1113]="SETUP_UNSUPPORTED_PROTOCOL",e[e.SOURCE_ERROR=1200]="SOURCE_ERROR",e[e.SOURCE_INVALID=1201]="SOURCE_INVALID",e[e.SOURCE_MANIFEST_INVALID=1202]="SOURCE_MANIFEST_INVALID",e[e.SOURCE_NO_SUPPORTED_TECHNOLOGY=1203]="SOURCE_NO_SUPPORTED_TECHNOLOGY",e[e.SOURCE_STREAM_TYPE_NOT_SUPPORTED=1204]="SOURCE_STREAM_TYPE_NOT_SUPPORTED",e[e.SOURCE_FORCED_TECHNOLOGY_NOT_SUPPORTED=1205]="SOURCE_FORCED_TECHNOLOGY_NOT_SUPPORTED",e[e.SOURCE_NO_STREAM_FOUND_FOR_SUPPORTED_TECHNOLOGY=1206]="SOURCE_NO_STREAM_FOUND_FOR_SUPPORTED_TECHNOLOGY",e[e.SOURCE_EMPTY_SEGMENT=1207]="SOURCE_EMPTY_SEGMENT",e[e.SOURCE_COULD_NOT_LOAD_MANIFEST=1208]="SOURCE_COULD_NOT_LOAD_MANIFEST",e[e.SOURCE_PROGRESSIVE_STREAM_ERROR=1209]="SOURCE_PROGRESSIVE_STREAM_ERROR",e[e.SOURCE_HLS_STREAM_ERROR=1210]="SOURCE_HLS_STREAM_ERROR",e[e.SOURCE_ENCRYPTION_METHOD_NOT_SUPPORTED=1211]="SOURCE_ENCRYPTION_METHOD_NOT_SUPPORTED",e[e.SOURCE_INVALID_H264_CODEC=7043]="SOURCE_INVALID_H264_CODEC",e[e.PLAYBACK_ERROR=1300]="PLAYBACK_ERROR",e[e.PLAYBACK_VIDEO_DECODING_ERROR=1301]="PLAYBACK_VIDEO_DECODING_ERROR",e[e.PLAYBACK_HLS_COULD_NOT_LOAD_TRANSMUXER=1304]="PLAYBACK_HLS_COULD_NOT_LOAD_TRANSMUXER",e[e.NETWORK_ERROR=1400]="NETWORK_ERROR",e[e.NETWORK_MANIFEST_DOWNLOAD_TIMEOUT=1401]="NETWORK_MANIFEST_DOWNLOAD_TIMEOUT",e[e.NETWORK_SEGMENT_DOWNLOAD_TIMEOUT=1402]="NETWORK_SEGMENT_DOWNLOAD_TIMEOUT",e[e.NETWORK_PROGRESSIVE_STREAM_DOWNLOAD_TIMEOUT=1403]="NETWORK_PROGRESSIVE_STREAM_DOWNLOAD_TIMEOUT",e[e.NETWORK_FAILED_CERTIFICATE_REQUEST=1404]="NETWORK_FAILED_CERTIFICATE_REQUEST",e[e.DRM_ERROR=2e3]="DRM_ERROR",e[e.DRM_MISSING_CONFIGURATION=2001]="DRM_MISSING_CONFIGURATION",e[e.DRM_NO_LICENSE_SERVER_URL_PROVIDED=2002]="DRM_NO_LICENSE_SERVER_URL_PROVIDED",e[e.DRM_FAILED_LICENSE_REQUEST=2003]="DRM_FAILED_LICENSE_REQUEST",e[e.DRM_KEY_SIZE_NOT_SUPPORTED=2005]="DRM_KEY_SIZE_NOT_SUPPORTED",e[e.DRM_NO_KEY_SYSTEM=2006]="DRM_NO_KEY_SYSTEM",e[e.DRM_KEY_SESSION_INITIALIZATION_FAILED=2007]="DRM_KEY_SESSION_INITIALIZATION_FAILED",e[e.DRM_MEDIA_KEY_INITIALIZATION_FAILED=2008]="DRM_MEDIA_KEY_INITIALIZATION_FAILED",e[e.DRM_KEY_ERROR=2009]="DRM_KEY_ERROR",e[e.DRM_KEY_SYSTEM_NOT_SUPPORTED=2010]="DRM_KEY_SYSTEM_NOT_SUPPORTED",e[e.DRM_CERTIFICATE_ERROR=2011]="DRM_CERTIFICATE_ERROR",e[e.DRM_PLAYREADY_INVALID_HEADER_KEY_VALUE_PAIR=2012]="DRM_PLAYREADY_INVALID_HEADER_KEY_VALUE_PAIR",e[e.DRM_RESTRICTED_OUTPUT=2013]="DRM_RESTRICTED_OUTPUT",e[e.DRM_INIT_DATA_MISSING=2015]="DRM_INIT_DATA_MISSING",e[e.VR_ERROR=2100]="VR_ERROR",e[e.VR_INCOMPATIBLE_PLAYER_TECHNOLOGY=2101]="VR_INCOMPATIBLE_PLAYER_TECHNOLOGY",e[e.MODULE_ERROR=3e3]="MODULE_ERROR",e[e.MODULE_INVALID_DEFINITION=3001]="MODULE_INVALID_DEFINITION",e[e.MODULE_INVALID_DEFINITION_DEPENDENCY=3002]="MODULE_INVALID_DEFINITION_DEPENDENCY",e[e.MODULE_MISSING=3003]="MODULE_MISSING",e[e.MODULE_DEPENDENCY_MISSING=3004]="MODULE_DEPENDENCY_MISSING",e[e.MODULE_REMOVED=3005]="MODULE_REMOVED",e[e.MODULE_ADVERTISING_ERROR=3100]="MODULE_ADVERTISING_ERROR",e[e.SEGMENT_PSSH_DATA_MISSING=4e3]="SEGMENT_PSSH_DATA_MISSING"}(n||(t.ErrorCode=n={}))},5711:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.calcHash=a;var i=n(1520),r=n(6368);function a(e){return(i.ModuleManager.has(r.ModuleName.Subtitles)?i.ModuleManager.get(r.ModuleName.Subtitles).hashCode:o)(e)}function o(e){var t=0;if(0===e.length)return t;for(var n=0;n<e.length;n++){t=(t<<5)-t+e.charCodeAt(n),t|=0}return t}},5877:function(e,t,n){var i=this&&this.__assign||function(){return i=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},i.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.SEGMENT_TAGS=void 0,t.parseVariant=u,t.resolvePlaylistTag=d;var r=n(2510),a=n(6461),o=n(2600),s=n(7967);function u(e,n){void 0===n&&(n={});for(var i={version:1,allowCache:!0,hasM3u:!0,endList:!1,segments:[],dateRange:[],skippedSegmentsCount:0,targetDuration:0,totalDuration:0,mediaSequence:0},r=[],s=0;s<e.length;s++){var u=(0,a.removeTrailingWhitespaces)(e[s]);if(""!==u)if((0,a.isCustomTag)(u))(0,a.handleCustomTag)(i,r,u);else{var c=(0,o.parseTag)(u);if(t.SEGMENT_TAGS.includes(c.name))return(0,a.parseSegments)(e.slice(s),r,i,n),l(i),i;d(i,c,r)}}return l(i),i}function l(e){var t;"EVENT"===e.playlistType&&(e.discontinuitySequence=null!==(t=e.discontinuitySequence)&&void 0!==t?t:0)}function d(e,t,n){switch(t.name){case"EXT-X-VERSION":e.version=Number(t.value);break;case"EXT-X-START":e.start=(0,s.generateStartAttributes)(t);break;case"EXT-X-INDEPENDENT-SEGMENTS":e.independentSegments=!0;break;case"EXT-X-TARGETDURATION":t.value&&(e.targetDuration=parseInt(t.value));break;case"EXT-X-MEDIA-SEQUENCE":t.value&&(e.mediaSequence=parseInt(t.value));break;case"EXT-X-DISCONTINUITY-SEQUENCE":t.value&&(e.discontinuitySequence=parseInt(t.value));break;case"EXT-X-PLAYLIST-TYPE":e.playlistType="EVENT"===t.value?"EVENT":"VOD";break;case"EXT-X-PART-INF":e.partInfo=(0,s.generatePartInfoTag)(t.attributes);break;case"EXT-X-ALLOW-CACHE":e.allowCache="NO"!==t.value;break;case"EXT-X-SERVER-CONTROL":e.serverControl=(0,s.generateServerControlTag)(t);break;case"EXT-X-DATERANGE":e.dateRange.push((0,s.generateDateRange)(t));break;case"EXTM3U":break;default:n.push(i({type:r.MetadataType.CUSTOM},t)),(0,a.addCustomTagToPlaylistTagList)(e,t)}}t.SEGMENT_TAGS=["EXTINF","EXT-X-BYTERANGE","EXT-X-DISCONTINUITY","EXT-X-PROGRAM-DATE-TIME","EXT-X-KEY","EXT-X-GAP","EXT-X-BITRATE","EXT-X-PART","EXT-X-MAP","EXT-X-CUE-OUT-CONT","EXT-X-CUE-OUT","EXT-X-CUE-IN","EXT-X-SCTE35","EXT-X-SKIP"]},6093:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.FormatHelper=void 0;var n=function(){function e(){}return e.hexToBytes=function(e){var t=e.length;1&t&&(e="0"+e,t++);for(var n=new Uint8Array(t>>1),i=0;i<t;i+=2)n[i>>1]=parseInt(e.substring(i,i+2),16);return n},e.bytesToHex=function(e){e instanceof ArrayBuffer&&(e=new Uint8Array(e));for(var t="",n=0;n<e.byteLength;n++){var i=(255&e[n]).toString(16);i.length<2&&(t+="0"),t+=i}return t},e.bytesToUUID=function(e){return this.beautifyUUID(this.bytesToHex(e))},e.beautifyUUID=function(e){return e.slice(0,8)+"-"+e.slice(8,12)+"-"+e.slice(12,16)+"-"+e.slice(16,20)+"-"+e.slice(20)},e.intToHex=function(e){return("00"+e.toString(16)).slice(-2)},e.base64UrlEncode=function(e){return window.btoa(e).replace(/\\+/g,"-").replace(/\\//g,"_").replace(/=/g,"")},e.base64UrlDecode=function(e){return window.atob((e+"===".slice((e.length+3)%4)).replace(/-/g,"+").replace(/_/g,"/"))},e}();t.FormatHelper=n},6368:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ModuleName=void 0,function(e){e.VR="VR",e.XML="XML",e.Smooth="Smooth",e.AdvertisingCore="AdvertisingCore",e.Advertising="Advertising",e.AdvertisingIma="Advertising",e.AdvertisingBitmovin="Advertising",e.AdvertisingOmSdk="AdvertisingOmSdk",e.Polyfill="Polyfill",e.Patch="Patch",e.RemoteControl="RemoteControl",e.RendererMse="RendererMSE",e.EngineNative="EngineNative",e.EngineBitmovin="EngineBitmovin",e.ABR="ABR",e.Crypto="Crypto",e.HLS="HLS",e.DRM="DRM",e.DASH="DASH",e.ContainerTS="ContainerTS",e.ContainerMP4="ContainerMP4",e.ContainerWebM="ContainerWebM",e.Subtitles="Subtitles",e.SubtitlesTTML="SubtitlesTTML",e.SubtitlesWebVTT="SubtitlesWebVTT",e.SubtitlesCEA608="SubtitlesCEA608",e.SubtitlesNative="SubtitlesNative",e.Style="Style",e.Thumbnail="Thumbnail",e.ThumbnailImp="Thumbnail",e.UI="UI",e.Tizen="Tizen",e.Webos="webos",e.Vidaa="vidaa",e.LowLatency="LowLatency",e.ServiceWorkerClient="ServiceWorkerClient",e.Envivio="Envivio",e.PlayStation5="PlayStation5",e.PlayStation4="PlayStation4",e.EngineWebRtc="EngineWebRtc",e.ReactNative="ReactNative"}(n||(t.ModuleName=n={}))},6435:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.isSafari17orIOS17=t.isSafari15orIOS15=t.getIOSVersion=t.isSafariIOS=t.isIOS=t.isMobile=t.isWebOs2017=t.isWebOs2016=t.getWebOsChromiumVersion=t.isWebOS=t.isVizio=t.getVidaaVersion=t.isVidaa=t.getTizenVersion=t.isTizen2020=t.isTizen2016=t.isTizen2017=t.isTizen2018=t.isTizen2019=t.isTizen=t.getEdgeVersion=t.isEdge=t.getSafariVersion=t.isSafari=t.isFirefoxIOS=t.isFirefox=t.isChromium=t.isChrome=t.WEBOS_2021_CHROMIUM_VERSION=t.WEBOS_2020_CHROMIUM_VERSION=t.WEBOS_2018_2019_CHROMIUM_VERSION=t.WEBOS_2016_2017_CHROMIUM_VERSION=t.TIZEN_2020_MINOR_VERSION=t.TIZEN_2020_MAJOR_VERSION=t.TIZEN_2019_MINOR_VERSION=t.TIZEN_2019_MAJOR_VERSION=t.TIZEN_2018_MINOR_VERSION=t.TIZEN_2018_MAJOR_VERSION=t.TIZEN_2017_MINOR_VERSION=t.TIZEN_2017_MAJOR_VERSION=t.TIZEN_2016_MINOR_VERSION=t.TIZEN_2016_MAJOR_VERSION=t.SAFARI_17_MAJOR_VERSION=t.SAFARI_15_MAJOR_VERSION=t.IOS_17=t.IOS_15=t.IOS_10=t.IOS_9=void 0,t.isLegacyEdge=f,t.isPlayStation5=p,t.isPlayStation4=g,t.isReactNative=S;var i=n(3485);t.IOS_9=9,t.IOS_10=10,t.IOS_15=15,t.IOS_17=17,t.SAFARI_15_MAJOR_VERSION=15,t.SAFARI_17_MAJOR_VERSION=17,t.TIZEN_2016_MAJOR_VERSION=2,t.TIZEN_2016_MINOR_VERSION=4,t.TIZEN_2017_MAJOR_VERSION=3,t.TIZEN_2017_MINOR_VERSION=0,t.TIZEN_2018_MAJOR_VERSION=4,t.TIZEN_2018_MINOR_VERSION=0,t.TIZEN_2019_MAJOR_VERSION=5,t.TIZEN_2019_MINOR_VERSION=0,t.TIZEN_2020_MAJOR_VERSION=5,t.TIZEN_2020_MINOR_VERSION=5,t.WEBOS_2016_2017_CHROMIUM_VERSION=38,t.WEBOS_2018_2019_CHROMIUM_VERSION=53,t.WEBOS_2020_CHROMIUM_VERSION=68,t.WEBOS_2021_CHROMIUM_VERSION=79;var r=function(){return navigator.userAgent.includes("Chrome")&&!(0,t.isEdge)()};t.isChrome=r;var a=function(){return(0,t.isChrome)()||(0,t.isEdge)()&&!f()};t.isChromium=a;var o=function(){return navigator.userAgent.includes("Firefox")};t.isFirefox=o;var s=function(){return navigator.userAgent.includes("FxiOS")&&(0,t.isIOS)()};t.isFirefoxIOS=s;var u=function(){return navigator.userAgent.includes("Safari")&&!navigator.userAgent.includes("Chrome")&&!navigator.userAgent.includes("IEMobile")&&!navigator.userAgent.includes("Edge")&&!(0,t.isTizen)()&&!p()&&!g()||(0,i.isFairPlayDrmSupported)()};t.isSafari=u;var l=function(){var e=/Version\\/(\\d+)\\.?(\\d+)?\\.?(\\d+)?/.exec(navigator.userAgent)||null;if(!e)return{};var t=e[1],n=e[2],i=e[3],r=function(e){return parseInt(e)};return{major:r(t),minor:r(n),patch:r(i)}};t.getSafariVersion=l;var d=function(){return/Edge\\/\\d+/i.test(navigator.userAgent)||/Edg\\/\\d+/i.test(navigator.userAgent)};t.isEdge=d;var c=function(){var e=/Edge\\/(\\d+)\\.?(\\d+)/.exec(navigator.userAgent)||/Edg\\/(\\d+)\\.?(\\d+)/.exec(navigator.userAgent);if(!e||0===e.length)return{major:0,minor:0};var t={};return e[1]&&(t.major=parseInt(e[1])),e[1]&&(t.minor=parseInt(e[2])),t};function f(){var e=79;return(0,t.isEdge)()&&(0,t.getEdgeVersion)().major<e}function p(){return/PlayStation 5/i.test(navigator.userAgent)}function g(){return/PlayStation 4/i.test(navigator.userAgent)}function S(){return"ReactNative"===window.navigator.product}t.getEdgeVersion=c;var v=function(e,n){var i=(0,t.getTizenVersion)();return i.major===e&&i.minor===n},m=function(){return navigator.userAgent.includes("Tizen")};t.isTizen=m;var h=function(){return v(t.TIZEN_2019_MAJOR_VERSION,t.TIZEN_2019_MINOR_VERSION)};t.isTizen2019=h;var E=function(){return v(t.TIZEN_2018_MAJOR_VERSION,t.TIZEN_2018_MINOR_VERSION)};t.isTizen2018=E;var y=function(){return v(t.TIZEN_2017_MAJOR_VERSION,t.TIZEN_2017_MINOR_VERSION)};t.isTizen2017=y;var I=function(){return v(t.TIZEN_2016_MAJOR_VERSION,t.TIZEN_2016_MINOR_VERSION)};t.isTizen2016=I;var T=function(){return v(t.TIZEN_2020_MAJOR_VERSION,t.TIZEN_2020_MINOR_VERSION)};t.isTizen2020=T;var _=function(){var e=/Tizen (\\d).(\\d)/.exec(navigator.userAgent);return(null==e?void 0:e[1])?{major:Number(e[1]),minor:Number(e[2]||0)}:{}};t.getTizenVersion=_;var O=function(){return navigator.userAgent.includes("VIDAA")};t.isVidaa=O;var R=function(){var e=new RegExp(/VIDAA\\/(\\d+)\\.?(\\d+)/).exec(navigator.userAgent);return(null==e?void 0:e[1])?{major:Number(e[1]),minor:Number(e[2])}:{}};t.getVidaaVersion=R;var N=function(){return navigator.userAgent.includes("VIZIO")};t.isVizio=N;var b=function(){return navigator.userAgent.includes("Web0S")||navigator.userAgent.includes("NetCast")};t.isWebOS=b;var M=function(){var e,t=new RegExp(/Chrome\\/(\\d+)\\.?(\\d+)/).exec(navigator.userAgent);return(null==t?void 0:t[1])?{major:Number(t[1]),minor:Number(null!==(e=t[2])&&void 0!==e?e:0)}:{}};t.getWebOsChromiumVersion=M;var A=function(){return(0,t.getWebOsChromiumVersion)().major===t.WEBOS_2016_2017_CHROMIUM_VERSION&&!("requestMediaKeySystemAccess"in navigator)};t.isWebOs2016=A;var P=function(){return(0,t.getWebOsChromiumVersion)().major===t.WEBOS_2016_2017_CHROMIUM_VERSION&&"requestMediaKeySystemAccess"in navigator};t.isWebOs2017=P;var D=function(){return/Android/i.test(navigator.userAgent)||/IEMobile/i.test(navigator.userAgent)||/Windows Phone 10.0/i.test(navigator.userAgent)||/Safari/i.test(navigator.userAgent)&&/Mobile/i.test(navigator.userAgent)};t.isMobile=D;var L=function(){return/Safari/i.test(navigator.userAgent)&&/Mobile/i.test(navigator.userAgent)&&!/Android/i.test(navigator.userAgent)&&!/Windows Phone 10.0/i.test(navigator.userAgent)};t.isIOS=L;var C=function(){return/Safari/i.test(navigator.userAgent)&&/iP(hone|od|ad)/i.test(navigator.userAgent)};t.isSafariIOS=C;var U=function(){var e=/OS (\\d+)(_\\d+)*/.exec(navigator.userAgent);return e&&e.length>0&&parseInt(e[1],10)||0};t.getIOSVersion=U;var w=function(){return(0,t.isIOS)()&&(0,t.getIOSVersion)()===t.IOS_15},x=function(){return(0,t.isSafari)()&&(0,t.getSafariVersion)().major===t.SAFARI_15_MAJOR_VERSION},k=function(){return x()||w()};t.isSafari15orIOS15=k;var V=function(){return(0,t.isIOS)()&&(0,t.getIOSVersion)()===t.IOS_17},F=function(){return(0,t.isSafari)()&&(0,t.getSafariVersion)().major===t.SAFARI_17_MAJOR_VERSION},j=function(){return F()||V()};t.isSafari17orIOS17=j},6461:function(e,t,n){var i=this&&this.__assign||function(){return i=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},i.apply(this,arguments)},r=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var i,r=0,a=t.length;r<a;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.parseSegments=c,t.addCustomTagToPlaylistTagList=f,t.handleCustomTag=p,t.removeTrailingWhitespaces=y,t.isCustomTag=I;var a=n(2442),o=n(2510),s=n(7550),u=n(2600),l=n(5877),d=n(7967);function c(e,t,n,i){void 0===i&&(i={});for(var o,c=[],f=0,T=(0,d.generateSegmentEntrySkeleton)(),_=r([],t,!0),O=0,R=n.mediaSequence,N={keys:[],keyInUse:!1},b=function(){T=(0,d.generateSegmentEntrySkeleton)(),_=[],O=0},M=function(e){g(T,O,e,o,N,_,R),c.push(T),f+=O,R++,b()},A=function(e){var t,s,f=(0,u.parseTag)(e);switch(f.name){case"EXTINF":O=parseFloat(f.value);break;case"EXT-X-BYTERANGE":T.byterange=(0,d.generateByteRangeTag)(f,c);break;case"EXT-X-DISCONTINUITY":T.discontinuity=!0;break;case"EXT-X-PROGRAM-DATE-TIME":v(T,f);break;case"EXT-X-KEY":if("NONE"===(null===(t=f.attributes)||void 0===t?void 0:t.METHOD)){N.keys=[{method:a.HlsEncryptionMethod.NONE}];break}S(f,N);break;case"EXT-X-MAP":o=(0,d.generateMapTag)(f,N);break;case"EXT-X-DATERANGE":n.dateRange.push((0,d.generateDateRange)(f));break;case"EXT-X-CUE-OUT-CONT":T.cueTag=(0,d.generateCueTag)(f,"CUE-OUT-CONT");break;case"EXT-X-CUE-OUT":T.cueTag=(0,d.generateCueTag)(f,"CUE-OUT");break;case"EXT-X-CUE-IN":T.cueTag=(0,d.generateCueTag)(f,"CUE-IN");break;case"EXT-X-SCTE35":m(T,f);break;case"EXT-X-PART":h(f,T,i);break;case"EXT-X-PRELOAD-HINT":var p=E(f,n.partInfo,i);p.init&&(o=p.init,N.keys.length>0&&(o.keys=r([],N.keys,!0),N.keyInUse=!0)),p.part&&(T.parts=null!==(s=T.parts)&&void 0!==s?s:[],T.parts.push(p.part));break;case"EXT-X-SKIP":var g=(0,d.generateSkipTag)(f);n.skippedSegmentsCount=g.skippedSegments,R+=g.skippedSegments;break;case"EXT-X-ENDLIST":n.endList=!0;break;default:(0,l.resolvePlaylistTag)(n,f,_)}},P=0,D=e;P<D.length;P++){var L=y(D[P]);if(""!==L)!L.startsWith("#")?M(L):I(L)?p(n,_,L):A(L)}T.parts&&T.parts.length>0&&(O=T.parts.reduce((function(e,t){return e+t.duration}),0),M(s.PHANTOM_SEGMENT_URL)),n.segments=c,n.totalDuration=f}function f(e,t){void 0===e.tags&&(e.tags=[]),t&&e.tags.push(t)}function p(e,t,n){t.push({type:o.MetadataType.CUSTOM,attributes:n}),f(e,(0,d.generateCustomTag)(n))}function g(e,t,n,i,a,o,s){e.duration=t,e.uri=n,e.mediaSequence=s,i&&(e.init=i),o.length>0&&(e.customTags=o),a.keys.length>0&&(e.keys=r([],a.keys,!0),a.keyInUse=!0)}function S(e,t){t.keyInUse&&(t.keys=[],t.keyInUse=!1);var n=(0,d.generateKeyTag)(e);void 0!==n&&t.keys.push(n)}function v(e,t){t.value&&(e.dateTime=new Date(t.value))}function m(e,t){var n;void 0===e.scte35&&(e.scte35=[]),e.scte35.push({type:o.MetadataType.SCTE,attributes:i({CUE:null===(n=t.attributes)||void 0===n?void 0:n.CUE},t.attributes)})}function h(e,t,n){var i;if(n.parsePartTags){t.parts=null!==(i=t.parts)&&void 0!==i?i:[];var r=t.parts[t.parts.length-1];t.parts.push((0,d.generatePartTag)(e.attributes,r))}}function E(e,t,n){return n.parsePartTags&&t?(0,d.generatePreloadHintTag)(e.attributes,t.targetDuration):{}}function y(e){return e.replace(/^[ \\t]+/g,"")}function I(e){return/^#(?!EXT)/m.test(e)}},7062:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.isLowLatencyConfigured=r;var i=n(8665);function r(e){var t=e.serviceManager.get(i.ServiceName.LiveLatencyService);return(null==t?void 0:t.isConfigured())||!1}},7093:function(e,t){var n;function i(e){return"Math"in e&&e.Math===Math}function r(){return"object"==typeof window&&window&&i(window)?window:void 0}function a(){return"object"==typeof self&&self&&i(self)?self:void 0}Object.defineProperty(t,"__esModule",{value:!0});var o=null!==(n=r())&&void 0!==n?n:a();t.default=o},7177:function(e,t){function n(e){return null!==e&&"object"==typeof e}function i(e){return void 0!==e&&!e.isDisposed}Object.defineProperty(t,"__esModule",{value:!0}),t.isObject=n,t.isContextAvailable=i},7279:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.getSourceStore=a,t.getSourceState=o;var i=n(8665),r=n(7177);function a(e){var t,n;return(0,r.isContextAvailable)(e)?null===(t=e.serviceManager)||void 0===t?void 0:t.get(i.ServiceName.SourceStoreService,null===(n=e.sourceContext)||void 0===n?void 0:n.sourceIdentifier):void 0}function o(e){var t=a(e);return null==t?void 0:t.getState()}},7485:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.TextParser=void 0;var n=/[ \\t]+/gm,i=function(){function e(e){this.data=e,this.position=0}return e.prototype.isAtEnd=function(){return this.position===this.data.length},e.prototype.skipWhitespace=function(){this.readRegex(n)},e.prototype.readRegex=function(e){var t=this.indexOf(e);if(!this.isAtEnd()&&void 0!==t&&t.position===this.position)return this.position+=t.length,t.results},e.prototype.indexOf=function(e){e.lastIndex=this.position;var t=e.exec(this.data);if(null!==t)return{position:t.index,length:t[0].length,results:t}},e}();t.TextParser=i},7550:function(e,t,n){var i=this&&this.__assign||function(){return i=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},i.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.SegmentListMPDHandler=t.PHANTOM_SEGMENT_URL=void 0,t.assignSegmentStartTimesFromHlsRepresentation=_,t.copyPropValues=b,t.getMatchingPart=M;var r=n(2442),a=n(8665),o=n(2055),s=n(1397),u=n(1361),l=n(4388),d=n(331),c=n(16),f=n(1520),p=n(6368),g=n(2103),S=n(3326),v=n(3109),m=n(3553),h=n(8915);t.PHANTOM_SEGMENT_URL="PHANTOM-SEGMENT";var E=function(){function e(e){this.context=e,this.sourceContext=e.sourceContext,this.settings=e.settings,this.logger=e.logger,this.manifestService=e.serviceManager.get(a.ServiceName.ManifestService,this.sourceContext.sourceIdentifier),this.distanceToListStartSeconds=0,this.segmentListMap={},this.timestampOffset=NaN}return Object.defineProperty(e.prototype,"playerStateService",{get:function(){return this.context.serviceManager.get(a.ServiceName.PlayerStateService)},enumerable:!1,configurable:!0}),e.prototype.createSegmentListEntry=function(e,t){var n;if(!e)return null;var a={isInitSegment:!1,url:e._media,duration:e._duration,internalRepresentationId:t,periodId:t.periodId};if(e._key&&e._key.method!==r.HlsEncryptionMethod.NONE&&(a.key=e._key),void 0!==e._playbackTime&&(a.startTime=e._playbackTime),e._dateTime&&(a.dateTime=e._dateTime),e._metadata&&(a.metadata=e._metadata),e._byteRange&&(a.byteRange=e._byteRange),e._init&&(a.init=e._init,(null===(n=e._init.key)||void 0===n?void 0:n.method)===r.HlsEncryptionMethod.NONE&&(a.init=i({},a.init),delete a.init.key)),void 0!==e._mediaSequence&&(a.mediaSequence=e._mediaSequence),void 0!==e._discontinuitySequenceNumber&&(a.discontinuitySequenceNumber=e._discontinuitySequenceNumber),e._parts){var o=a.dateTime;a.parts=e._parts.map((function(e){var t=O(e,a);return o&&(t.dateTime=o,t.startTime=(0,d.toSeconds)(o.getTime()),o=new Date(o.getTime()+(0,d.toMilliSeconds)(e.duration))),t}))}return a.segmentId=(0,h.generateSegmentId)(a),a},e.prototype.removeDroppedOutSegmentsFromList=function(e,t,n){if(t.SegmentURL.length<1)return e.entries=[],e.totalDuration=0,e.entries.length;for(var i=this.createSegmentListEntry(t.SegmentURL[0],n),r=0,a=0,o=0;o<e.entries.length;o++){var s=e.entries[o];if((0,g.isIdenticalSegmentInfo)(s,i))break;r+=s.duration,e.entries.splice(o,1),o--,a++,this.manifestService.isLive()&&this.currentRepresentationId.equals(n)&&this.rewindOneSegment()}return e.totalDuration-=r,a},e.prototype.addNewSegmentsToList=function(e,t,n){for(var i=[],r=e.entries[e.entries.length-1],a=0,o=t.SegmentURL.length-1;o>=0;o--){var s=this.createSegmentListEntry(t.SegmentURL[o],n);if(r&&(0,g.isIdenticalSegmentInfo)(r,s)){if(R(r)){var u=N(r,s);e.totalDuration+=u}break}r&&(0,g.isIdenticalInitSegmentInfo)(r.init,s.init)&&(s.init=r.init),isNaN(s.duration)&&(s.duration=e.maximumSegmentDuration),s.duration/=e.timescale,a+=s.duration,i.unshift(s)}return e.totalDuration+=a,e.entries=e.entries.concat(i),i.length},e.prototype.updateSegmentList=function(e,t){var n,i,r=t.SegmentList,a=t._internalId.representationId,o=null===(n=this.currentRepresentationId)||void 0===n?void 0:n.equals(t._internalId),s=null===(i=null==r?void 0:r[0])||void 0===i?void 0:i.SegmentURL.length;if(!o||s){e.Uri&&e.Uri!==t.Uri&&this.resetSegmentListUponFailover(e,null==r?void 0:r[0],o),e.Uri=t.Uri,e.timescale=1,e.maximumSegmentDuration=1,e.startNumber=1;for(var u=function(n){var i=r[n];if(i.hasOwnProperty("_duration")&&(e.maximumSegmentDuration=Number(i._duration)),["_timescale","_startNumber","_presentationTimeOffset"].filter((function(e){return i.hasOwnProperty(e)})).forEach((function(t){return e[t.substr(1)]=i[t]})),l.updateInitInfo(e,i,t),i.hasOwnProperty("SegmentURL")){var o=l.removeDroppedOutSegmentsFromList(e,i,t._internalId),s=l.addNewSegmentsToList(e,i,t._internalId);l.logManifestUpdateStats(t._mimeType,a,o,s),l.manifestService.isHlsManifest()?_(e.entries,t._internalId,l.manifestService):l.assignSegmentStartTimesForDash(e,t._internalId)}},l=this,d=0;d<r.length;d++)u(d)}},e.prototype.resetSegmentListUponFailover=function(e,t,n){var i,r,a,o,s,l;if(this.manifestService.isLive()&&n){var d=null!==(a=null===(r=null===(i=e.entries)||void 0===i?void 0:i[0])||void 0===r?void 0:r.mediaSequence)&&void 0!==a?a:1/0,c=(null!==(s=null===(o=null==t?void 0:t.SegmentURL[0])||void 0===o?void 0:o._mediaSequence)&&void 0!==s?s:0)-d,f=D(e);!isNaN(c)&&c>0&&c<f&&this.rewindSegmentListIndexBy(c)}(0,u.clearArray)(null!==(l=e.entries)&&void 0!==l?l:[])},e.prototype.updateInitInfo=function(e,t,n){var i,r=null===(i=f.ModuleManager.get(p.ModuleName.DASH,!1))||void 0===i?void 0:i.initSegmentInfoSourceDetectors.isInitializationNode;(null==r?void 0:r(t))?e.init=f.ModuleManager.get(p.ModuleName.DASH,!1).initSegmentInfoProviders.provideSegmentInfoFromInitializationNodeProperty(t,n):delete e.init},e.prototype.logManifestUpdateStats=function(e,t,n,i){(n>0||i>0)&&this.logger.debug("[".concat(e,"][").concat(t,"] Updated segment list, removed ").concat(n," segments and added ").concat(i," segments"))},e.prototype.assignSegmentStartTimesForDash=function(e,t){var n=this.getMinStartTime(t),i=0;e.entries.forEach((function(e){var t;e.startTime=n+i,i+=null!==(t=e.duration)&&void 0!==t?t:0}))},e.prototype.extrapolateStartTimesFromDiscontinuityStarts=function(e){var t,n,i,r,a=null===(n=null===(t=this.getSourceStateService())||void 0===t?void 0:t.getState())||void 0===n?void 0:n.hls;if(a){var o=e.getRepresentationId().representationId,s=this.getSegmentListEntries(this.currentRepresentationId),u=f.ModuleManager.get(p.ModuleName.HLS).selectors,l=u.getDiscoSequenceTimings,d=u.getMergedDiscontinuityTimings,c=I(s,null!==(i=l(a,e.getMimeType()))&&void 0!==i?i:d(a));if(!c){var g=null===(r=this.getCurrentPeriod())||void 0===r?void 0:r.start;if(void 0===g)return;c={index:0,discontinuityStartTime:g},this.logger.debug("Could not find discontinuity boundary with start time, using period start time ".concat(g))}this.logger.debug("Assigning segment start times for rep ".concat(o," from discontinuity at index ").concat(c.index," with time ").concat(c.discontinuityStartTime)),s[c.index].startTime=c.discontinuityStartTime;for(var S=c.index-1;S>=0;S--)s[S].startTime=s[S+1].startTime-s[S+1].duration;for(S=c.index+1;S<s.length;S++)s[S].startTime=s[S-1].startTime+s[S-1].duration}},e.prototype.getSourceStateService=function(){return this.context.serviceManager.get(a.ServiceName.SourceStoreService,this.context.sourceContext.sourceIdentifier)},e.prototype.getListIndexForSegment=function(e,t){for(var n=-1,i=this.getSegmentListEntries(t),r=i.length-1;r>=0;r--)if((0,g.isIdenticalSegmentInfo)(i[r],e)){n=r;break}return n},e.prototype.populateSegmentListMap=function(e){var t,n=this,i=null===(t=this.manifestService)||void 0===t?void 0:t.getAdaptationSet(e);i&&i.Representation.forEach((function(e){var t=n.segmentListMap[e._internalId.key()];if(t||(t=n.initializeSegmentList(e._internalId.key())),e.hasOwnProperty("SegmentList")&&(n.updateSegmentList(t,e),f.ModuleManager.has(p.ModuleName.DASH))){var i=f.ModuleManager.get(p.ModuleName.DASH).initSegmentInfoSourceDetectors.isInitializationNode;if(!t.hasOwnProperty("init")&&e.hasOwnProperty("SegmentBase")&&e.SegmentBase&&i(e.SegmentBase[0])){var r=f.ModuleManager.get(p.ModuleName.DASH).initSegmentInfoProviders.provideSegmentInfoFromInitializationNodeProperty;t.init=r(e.SegmentBase[0],e)}}}))},e.prototype.selectNewRepresentationId=function(){var e,t,n=this,i=null===(e=this.context.serviceManager.get(a.ServiceName.SourceStoreService,this.sourceContext.sourceIdentifier).getState().activeTracks)||void 0===e?void 0:e[this.adaptationSetId.adaptationSetId];if((null===(t=null==i?void 0:i.selectedRepresentationId)||void 0===t?void 0:t.periodId)===this.adaptationSetId.periodId)return i.selectedRepresentationId;if(this.currentRepresentationId){var r=this.manifestService.getRepresentation(this.adaptationSetId,this.currentRepresentationId.representationId);if(r)return r._internalId}var o=function(e){return n.isSegmentInfoLoaded(e._internalId)};return(this.getMatchingRepresentationByBandwidth(o)||this.getMatchingRepresentationByBandwidth())._internalId},e.prototype.getMatchingRepresentationByBandwidth=function(e){return this.manifestService.getMatchingRepresentationByBandwidth(this.adaptationSetId,this.getCurrentBandwidth(),e)},e.prototype.shouldUpdateRepresentation=function(){var e=this.adaptationSetId.equals(this.currentRepresentationId),t=!this.currentRepresentationId||Boolean(this.manifestService.getRepresentationById(this.currentRepresentationId));return!this.currentRepresentationId||!e||!t},e.prototype.setAdaptationSetId=function(e){this.adaptationSetId=e,this.populateSegmentListMap(this.adaptationSetId);var t,n=this.manifestService.isLive(),i=0;this.shouldUpdateRepresentation()&&(this.currentRepresentationId=this.selectNewRepresentationId());var r=this.segmentListMap[this.currentRepresentationId.key()];if(r||(r=this.initializeSegmentList(this.currentRepresentationId.key())),r&&n&&r.entries&&r.entries.length>0){var a=r.entries.length-1;this.listIndex>a&&(i=this.listIndex-a),this.listIndex=Math.min(a,this.listIndex||0),this.listIndex=Math.max(0,this.listIndex),t=r.entries[this.listIndex]}if(this.listIndex=this.listIndex||0,n&&(this.distanceToListStartSeconds=this.getSegmentDuration()*this.settings.LIVE_SEGMENT_LIST_START_INDEX_OFFSET),n){if(t&&r){var o=this.getListIndexForSegment(t,this.currentRepresentationId);o>=0?this.listIndex=o+i:this.reset()}else this.reset();var s=this.checkForSegmentInfoError();s?this.rejectPendingSegmentInfoRequest(s):this.resolvePendingSegmentInfoRequests()}else this.resolvePendingSegmentInfoRequests()},e.prototype.initializeSegmentList=function(e){var t={totalDuration:0,entries:[],SegmentURL:[],startNumber:0,init:null,maximumSegmentDuration:1,timescale:1};return this.segmentListMap[e]=t,t},e.prototype.getCurrentBandwidth=function(){var e=0,t=this.getCurrentRepresentation();return t&&(e=t._bandwidth),e},e.prototype.checkForSegmentInfoError=function(){var e;if(this.manifestService.isHlsManifest()){var t=this.manifestService.getRepresentationById(this.currentRepresentationId);if(null===(e=null==t?void 0:t._hls)||void 0===e?void 0:e.loadFailureReason)return t._hls.loadFailureReason}return this.hasNext()||this.manifestService.isLastPeriod(this.currentRepresentationId.periodId)?null:m.SegmentInfoError.PERIOD_COMPLETE},e.prototype.reset=function(){this.settings.ENABLE_SEEK_FOR_LIVE?this.listIndex=0:this.timeShift(0)},e.prototype.syncSegmentStartTimeUsingMediaSequenceNumber=function(e,t){var n,i,r=this.manifestService.getRepresentationById(e),a=this.manifestService.getRepresentationById(t),o=(0,c.isNumber)(null===(n=null==a?void 0:a._hls)||void 0===n?void 0:n.mediaSequence)&&(0,c.isNumber)(null===(i=null==r?void 0:r._hls)||void 0===i?void 0:i.mediaSequence);if(r&&a&&o){var s=a._hls.mediaSequence-r._hls.mediaSequence,l=this.getSegmentListEntries(e),d=this.getSegmentListEntries(t);if(!(s>=l.length)){d[0].startTime=l[s].startTime;var f=function(e,t){(0,c.isNumber)(e.startTime)&&(0,c.isNumber)(e.duration)&&(t.startTime=e.startTime+e.duration)};(0,u.forEachFromIndex)(d,1,f)}}},e.prototype.setRepresentationId=function(e){var t=this.manifestService.getRepresentationById(e),n=this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex];if(t){var i=void 0===this.currentRepresentationId,r=this.currentRepresentationId;if(this.currentRepresentationId=e,this.manifestService.isLive()&&t._hls)if(this.settings.HLS_SYNC_SEGMENT_PLAYBACK_TIME_VIA_MEDIA_SEQUENCE&&this.syncSegmentStartTimeUsingMediaSequenceNumber(r,this.currentRepresentationId),i)this.reset();else if(this.settings.HLS_SYNC_VIA_MEDIA_SEQUENCE){var a=this.manifestService.getRepresentationById(r)._hls.mediaSequence+this.listIndex;this.listIndex=a-t._hls.mediaSequence,this.listIndex=Math.max(this.listIndex,0)}else if(null!=(null==n?void 0:n.startTime)&&!isNaN(n.startTime)){var o=this.getIndexForTime(n.startTime);null===o||isNaN(o)||(this.listIndex=this.adaptListIndexToCorrectIndex(o,n.startTime))}return!0}return!1},e.prototype.adaptListIndexToCorrectIndex=function(e,t){var n=this.getSegmentListEntries(this.currentRepresentationId),i=[n[e],n[e+1]];if(e===n.length-1||i.some((function(e){return!e.startTime})))return e;var r=i.map((function(e){return Math.abs(e.startTime-t)})),a=Math.min.apply(this,r);return e+r.indexOf(a)},e.prototype.getInitSegmentInfo=function(){var e=this.getSegmentList(this.currentRepresentationId);if(null==e?void 0:e.init)return e.init.presentationTimeOffset=this.getTimestampOffset(),e.init;var t=this.getSegmentListEntries(this.currentRepresentationId);if(this.isIndexInBounds(t)&&this.listIndex>-1){var n=i({},t[this.listIndex]);if(n.init){var r=n.init;return r.isInitSegment=!0,r}}return null},e.prototype.getNextSegmentInfo_=function(e){var t;if(!(this.getSegmentListEntries(this.currentRepresentationId).length<1||this.listIndex<0)){var n=this.isTargetTimeOfOngoingSeek(e);return n&&this.logger.debug("".concat(null===(t=this.adaptationSetId)||void 0===t?void 0:t.adaptationSetId," given time ").concat(e," matches seek time, performing precise segment/part search"),e),(0,v.isPlayingLowLatencyHls)(this.context)&&this.setListIndexForTime(e,n),this.getNextSegmentOrPart(e,n)}},e.prototype.isTargetTimeOfOngoingSeek=function(e){var t;return e===(null===(t=this.playerStateService)||void 0===t?void 0:t.targetPlaybackTime)||!1},e.prototype.setListIndexForTime=function(e,t){var n;if(0!==e){if(this.listIndex=this.getIndexForTime(e),!t){var i=this.getSegmentListEntries(this.currentRepresentationId),r=i[this.listIndex];if(!(r.parts&&r.parts.length>0)){var a=this.listIndex;this.listIndex=A(e,this.listIndex,i),this.listIndex!==a&&this.logger.debug("Snapped segment index for time ".concat(e," to next segment boundary at ").concat(null===(n=i[this.listIndex])||void 0===n?void 0:n.startTime))}}}else this.context.logger.debug("Ignoring target time of 0 for LL-HLS")},e.prototype.getNextSegmentOrPart=function(e,t){var n=this.getSegmentListEntries(this.currentRepresentationId);if(this.isIndexInBounds(n)){var i=n[this.listIndex];if(!(i.parts&&i.parts.length>0))return this.getNextFullSegmentInfo();if(R(i))return M(i,e,t);var r=M(i,e,t);return r?i.parts.indexOf(r)>0?r:this.getNextFullSegmentInfo():(this.listIndex++,this.getNextSegmentOrPart(e,t))}},e.prototype.getNextSegmentInfo=function(e){var t=this.getNextSegmentInfo_(e);return t?(this.populateSegmentInfoProps(t),Promise.resolve(t)):this.queueSegmentInfoRequest({time:e})},e.prototype.populateSegmentInfoProps=function(e){return e.presentationTimeOffset=this.getTimestampOffset(),e.startTime&&(e.wallClockTime=(0,d.toMilliSeconds)(e.startTime)),e},e.prototype.getNextFullSegmentInfo=function(){return this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex++]},e.prototype.getSegmentInfos=function(){var e=this,t={},n=this.manifestService.getAdaptationSet(this.adaptationSetId);return n&&n.Representation.forEach((function(n){var i=e.getSegmentListEntries(n._internalId);t[n._id]=i.map((function(e){return{url:e.url,duration:e.duration,startTime:e.startTime}}))})),t},e.prototype.getSubtitleUrl=function(){return this.manifestService.getAvailableSubtitles(this.adaptationSetId.periodId)[0].url},e.prototype.getStartNumber=function(){var e=this.getSegmentList(this.currentRepresentationId);return e?e.startNumber:1},e.prototype.getSegmentDuration=function(){var e=this,t=this.getSegmentList(this.currentRepresentationId),n=this.getSegmentListEntries(this.currentRepresentationId);if(t)return n.length>0&&(0,c.isNumber)(t.totalDuration)?t.totalDuration/n.length:t.maximumSegmentDuration;if(this.manifestService.getAdaptationSet(this.adaptationSetId)){var i=Object.keys(this.segmentListMap).map((function(t){return e.segmentListMap[t]})).find((function(e){return null!==e}));if(i)return i.maximumSegmentDuration}return 1},e.prototype.seekTo=function(e){e>-1&&(this.listIndex=this.getIndexForTime(e))},e.prototype.isIndexInBounds=function(e){return this.listIndex<e.length},e.prototype.hasNext=function(){var e=this.getSegmentListEntries(this.currentRepresentationId);return!this.currentRepresentationId||!e.length||(!this.manifestService.isLive()?this.isIndexInBounds(e):this.hasNextLive(e))},e.prototype.hasNextLive=function(e){return!!this.manifestService.isLastPeriod(this.currentRepresentationId.periodId)||this.isIndexInBounds(e)},e.prototype.setTimestampOffset=function(e,t){void 0===t&&(t=1),this.timestampOffset=e/t},e.prototype.getTimestampOffset=function(){if(!isNaN(this.timestampOffset))return this.timestampOffset;var e=this.getCurrentPeriod(),t=0;if(this.currentRepresentationId){var n=this.getSegmentList(this.currentRepresentationId);n&&!isNaN(n.presentationTimeOffset)&&(t=n.presentationTimeOffset/n.timescale)}return e&&!this.manifestService.isHlsManifest()&&(t-=e.start),t},e.prototype.getIndex=function(){return this.listIndex},e.prototype.setIndex=function(e){if("number"==typeof e)return e<0?(this.logger.debug("Tried to set index at MPDHandler to value smaller 0. Setting to 0."),void(this.listIndex=0)):void(this.listIndex=e);this.logger.debug("Tried to set index at MPDHandler with parameter not being a number!")},e.prototype.queueSegmentInfoRequest=function(e){var t,n=this;if(this.pendingSegmentInfoRequest)return Promise.reject("fail");var r=this.manifestService.getRepresentationById(this.currentRepresentationId);return(null===(t=null==r?void 0:r._hls)||void 0===t?void 0:t.loadFailureReason)?Promise.reject(r._hls.loadFailureReason):(this.logger.debug("No segment info was found for the target time. Waiting for representation update."),new Promise((function(t,r){n.pendingSegmentInfoRequest=i(i({},e),{resolve:t,reject:r})})))},e.prototype.resolvePendingSegmentInfoRequests=function(){if(this.pendingSegmentInfoRequest){var e=this.getNextSegmentInfo_(this.pendingSegmentInfoRequest.time);e?(this.populateSegmentInfoProps(e),this.pendingSegmentInfoRequest.resolve(e),this.pendingSegmentInfoRequest=null):this.manifestService.isLive()||this.hasNext()||this.pendingSegmentInfoRequest.reject(m.SegmentInfoError.END_OF_STREAM_REACHED)}},e.prototype.rejectPendingSegmentInfoRequest=function(e){this.pendingSegmentInfoRequest&&(this.pendingSegmentInfoRequest.reject(e),this.pendingSegmentInfoRequest=null)},e.prototype.getLiveEdgeIndex=function(){var e=this.getSegmentListEntries(this.currentRepresentationId);return e.length>0?e.length-1:0},e.prototype.getIndexForOffset=function(e){for(var t,n=Math.abs(e),i=this.getSegmentDuration(),r=this.getSegmentListEntries(this.currentRepresentationId),a=this.getLiveEdgeIndex(),o=0,s=r.length-1;s>=0&&!((o+=null!==(t=r[s].duration)&&void 0!==t?t:i)>=n);s--)a--;return Math.max(0,a)},e.prototype.timeShift=function(e,t,n){if(this.manifestService.isLive()){var i=this.listIndex;this.listIndex=n&&this.hasStartTimes()?this.getIndexForTime(n):this.getIndexForOffset(e),this.logger.debug("timeShift changes index from ".concat(i," to ").concat(this.listIndex,", based on")+" offset ".concat(e," and target time ").concat(n))}},e.prototype.hasStartTimes=function(){var e,t=null===(e=this.getSegmentListEntries(this.currentRepresentationId)[0])||void 0===e?void 0:e.startTime;return(0,c.isNumber)(t)&&t>=0},e.prototype.updateRepresentation=function(e){return Promise.resolve(e)},e.prototype.isSegmentInfoLoaded=function(e){if(void 0===e&&(e=this.currentRepresentationId),!e)return!1;var t=this.getSegmentListEntries(e),n=this.manifestService.getRepresentationById(e);return!(!t.length||!n)},e.prototype.rewindSegmentListIndexBy=function(e){this.logger.debug("Rewinding segment list index by ".concat(e," segments")),this.listIndex-=e,this.listIndex<0&&(this.logger.debug("List array index is smaller than 0, probably a discontinuity. Using 0."),this.listIndex=0)},e.prototype.rewindOneSegment=function(){return this.listIndex--,!(this.listIndex<0)||(this.logger.debug("List array index is smaller than 0, probably a discontinuity. Using 0."),this.listIndex=0,!1)},e.prototype.getCurrentPeriod=function(){return this.manifestService.getPeriod(this.currentRepresentationId)},e.prototype.getExpectedPresentationTime=function(e){var t=this.getCurrentPeriod().start;return(this.manifestService.hasSinglePeriod()?this.getSeekableRange().start:t)+this.getSegmentListEntries(this.currentRepresentationId).slice(0,e).reduce((function(e,t){return e+t.duration}),0)},e.prototype.getCurrentRepresentation=function(){return this.manifestService.getRepresentationById(this.currentRepresentationId)},e.prototype.getSegmentList=function(e){if(e)return this.segmentListMap[e.key()]},e.prototype.getSegmentListEntries=function(e){var t,n;return e?this.settings.ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE&&this.manifestService.isHlsManifest()?this.getStoreSegmentInfos(e):null!==(n=null===(t=this.getSegmentList(e))||void 0===t?void 0:t.entries)&&void 0!==n?n:[]:[]},e.prototype.getStoreSegmentInfos=function(e){var t,n=null===(t=this.getSourceStateService())||void 0===t?void 0:t.getState();return(0,S.getSegmentInfos)(n,e.key())},e.prototype.findListIndexWithoutSegmentStartTimes=function(e,t){var n,i;if(!this.adaptationSetId)return 0;for(var r=this.manifestService.getPeriod(this.adaptationSetId),a=null!==(n=null==r?void 0:r.start)&&void 0!==n?n:0,o=this.getSegmentListEntries(this.currentRepresentationId),s=0,u=a;u<=t&&s<o.length;s++)u+=null!==(i=o[s].duration)&&void 0!==i?i:0;return Math.max(s-1,0)},e.prototype.getIndexForTime=function(e){var t=this.getSegmentList(this.currentRepresentationId),n=this.getSegmentListEntries(this.currentRepresentationId);if(!t||0===n.length||!(0,c.isNumber)(t.totalDuration))return 0;var i=this.getMinStartTime(),r=Math.max(i,e),a=t.totalDuration/n.length,o=(0,h.findSegmentIndexForTime)(n,r,a);return null!==o?o:this.findListIndexWithoutSegmentStartTimes(t,r)},e.prototype.getMinStartTime=function(e){void 0===e&&(e=this.currentRepresentationId);var t=this.manifestService.hasSinglePeriod()?this.getSeekableRange().start:this.manifestService.getPeriod(e).start;return this.manifestService.isFirstPeriod(e.periodId)&&(t+=this.distanceToListStartSeconds),t},e.prototype.getLiveEdgeTime=function(){var e,t=null===(e=this.manifestService)||void 0===e?void 0:e.getLastPeriod();return t?t.start+l.DurationConverter.getDurationInSec(t._duration):1/0},e.prototype.getActualTimeShiftBufferDepth=function(){return this.manifestService.getTimeShiftBufferDepthSeconds()},e.prototype.getSeekableRange=function(){var e={start:0,end:0},t=this.manifestService.getTotalDuration();if(!this.manifestService.isLive())return e.start=(0,o.getStartTimeOffset)(this.getSourceStateService().getState()),e.end=t,e;var n=this.manifestService.getTimeShiftBufferDepthSeconds(),i=(0,d.toSeconds)(this.manifestService.getRequestTimestamp()-this.manifestService.getAvailabilityStartTime());if(e.start=Math.max(i+n,0),e.end=Math.max(i,0),f.ModuleManager.has(p.ModuleName.HLS)&&this.manifestService.isHlsManifest()){var r=f.ModuleManager.get(p.ModuleName.HLS).selectors,a=r.getHlsState;"EVENT"===(0,r.getPlaylistType)(a(this.getSourceStateService().getState()))?(e.start=0,e.end=t):e.start+=this.distanceToListStartSeconds}return e.end-=this.manifestService.getDesiredDistanceToLiveEdge(),e},e.prototype.getPendingSegmentInfoRequest=function(){return this.pendingSegmentInfoRequest},e.prototype.setPendingSegmentInfoRequest=function(e){this.pendingSegmentInfoRequest=e},e.prototype.canSwitchRepresentation=function(e){var t,n=this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex];if(!n)return!0;var i=P(e,n,this.settings.LL_HLS_SEGMENT_END_TIME_MATCHING_TOLERANCE);if(!R(n)&&i)return!0;var r=this.isTargetTimeOfOngoingSeek(e);return!((null===(t=null==n?void 0:n.parts)||void 0===t?void 0:t.length)&&M(n,e,r)!==n.parts[0])},e.prototype.getLatestTimeForPossibleSwitch=function(e){var t,n=this.getLLHlsInfoForTime(e),i=n.isLoadingCurrentSegmentsParts,r=n.currentSegment;return r&&i&&null!==(t=r.startTime)&&void 0!==t?t:e},e.prototype.adjustTimeToNextSegmentStart=function(e){var t=this.getLLHlsInfoForTime(e),n=t.isLoadingCurrentSegmentsParts,i=t.currentSegment;return n&&(null==i?void 0:i.startTime)&&(null==i?void 0:i.duration)?i.startTime+i.duration:e},e.prototype.getLLHlsInfoForTime=function(e){var t,n=y(e,this.getSegmentListEntries(this.currentRepresentationId)),i=null===(t=null==n?void 0:n.parts)||void 0===t?void 0:t[0],r=this.isTargetTimeOfOngoingSeek(e),a=!1;if(i&&n){var o=M(n,e,r);a=void 0!==o&&o!==i}return{currentSegment:n,isLoadingCurrentSegmentsParts:a}},e.prototype.dispose=function(){this.settings=null,this.manifestService=null,this.adaptationSetId=null,this.currentRepresentationId=null,this.manifestService=null,this.pendingSegmentInfoRequest=null,this.segmentListMap=null},e}();function y(e,t){var n,i,r;if(t&&!(t.length<1)&&(null===(n=t[0])||void 0===n?void 0:n.duration)){var a=(0,h.findSegmentIndexForTime)(t,e,t[0].duration),o=null===a,s=e<(null!==(r=null===(i=t[0])||void 0===i?void 0:i.startTime)&&void 0!==r?r:1/0),u=t[t.length-1];if(void 0!==u.startTime&&void 0!==u.duration){var l=e>u.startTime+u.duration;if(!(o||s||l))return t[a]}}}function I(e,t){for(var n=e[0].discontinuitySequenceNumber,i=1;i<e.length;i++){var r=e[i].discontinuitySequenceNumber;if(r!==n){var a=T(t,r);if(null!=a)return{index:i,discontinuityStartTime:a}}}return null}function T(e,t){var n=e[String(t)];return n&&n.startTime>0?n.startTime:(n=e[String(t-1)])&&n.endTime>0?n.endTime:null}function _(e,t,n){if(e.length&&n.hasSegmentStartTimeForHlsRepresentation(t)){var i;null!=e[0].startTime?i=(0,u.findIndexFromEnd)(e,(function(e){return null!=e.startTime}))+1:(e[0].startTime=n.getStartTimeForHlsSegment(t,e[0]),i=1);var r=function(e,t){return t.startTime=e.startTime+e.duration};(0,u.forEachFromIndex)(e,i,r)}}function O(e,t){var n={url:e.uri,duration:e.duration,isInitSegment:!1,internalRepresentationId:t.internalRepresentationId,isPreloadHint:Boolean(e.isPreloadHint),isIndependent:Boolean(e.independent)};return e.byteRange&&(n.byteRange=e.byteRange),t.key&&(n.key=t.key),t.init&&(n.init=t.init),(0,c.isDefined)(t.mediaSequence)&&(n.mediaSequence=t.mediaSequence),(0,c.isDefined)(t.discontinuitySequenceNumber)&&(n.discontinuitySequenceNumber=t.discontinuitySequenceNumber),n}function R(e){return e.url.endsWith(t.PHANTOM_SEGMENT_URL)}function N(e,n){var i=n.duration-e.duration;return b(n,e,["url","mediaURL","duration","parts","init","key","discontinuitySequenceNumber","isDiscontinuityStart"]),!e.url.endsWith(t.PHANTOM_SEGMENT_URL)&&(e.url=(0,s.forceReallocation)(e.url)),i}function b(e,t,n){n.forEach((function(n){return t[n]=e[n]}))}function M(e,t,n){var i,r=null===(i=e.parts)||void 0===i?void 0:i.every(h.isSegmentTiming);if(e.parts&&r){var a=e.parts,o=a.reduce((function(e,t){return e+t.duration}),0)/a.length,s=(0,h.findSegmentIndexForTime)(a,t,o);if(null!=s)return n?e.parts[0]:(s=A(t,s,a),e.parts[s])}}function A(e,t,n){var i=n[t],r=i.startTime+i.duration;return Math.abs(e-i.startTime)<=Math.abs(e-r)?t:t+1}function P(e,t,n){return void 0!==t.startTime&&void 0!==t.duration&&Math.abs(e-(t.startTime+t.duration))<n}function D(e){var t,n,i=24,r=e.totalDuration/(null!==(n=null===(t=e.entries)||void 0===t?void 0:t.length)&&void 0!==n?n:1);return Math.ceil(i/r)}t.SegmentListMPDHandler=E},7697:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.WebWorkerContext=void 0;var i=n(5469),r=function(){function e(e){var t=this;this.runsInWebWorker="undefined"==typeof window,this.onmessage=null,this.sendMessage=function(e,n){t.runsInWebWorker?postMessage(e,n):"function"==typeof t.onmessage&&setTimeout((function(){t.onmessage({data:e})}),0)},this.postMessage=function(e){setTimeout((function(){t.onMessageCallback({data:e})}),0)},this.terminate=function(){},this.onMessageCallback=function(e){e.data.action&&e.data&&t.messageHandler[e.data.action]&&t.messageHandler[e.data.action](e.data)},this.runsInWebWorker&&(0,i.installWorkerPolyfills)(),this.messageHandler=new e(this.runsInWebWorker,this.sendMessage)}return e}();t.WebWorkerContext=r},7722:function(e,t,n){var i,r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},r.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.CapabilityReducer=void 0;var a=n(1829),o=n(1399),s={};function u(e){return e}function l(e,t){var n,i=t.key,a=t.value;return r(r({},e),((n={})[i]=a,n))}t.CapabilityReducer=(0,a.default)(s,((i={})[o.CapabilityActionType.InitCapabilities]=function(e,t){return u(t.payload)},i[o.CapabilityActionType.SetCapability]=function(e,t){return l(e,t.payload)},i))},7967:function(e,t,n){var i=this&&this.__assign||function(){return i=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},i.apply(this,arguments)},r=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var i,r=0,a=t.length;r<a;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.generateRendition=u,t.generateStartAttributes=l,t.generatePartInfoTag=d,t.generateServerControlTag=c,t.generateSkipTag=f,t.generatePartTag=p,t.generatePreloadHintTag=S,t.generateStreamInfTag=v,t.generateVariantPlaylistId=m,t.generateSessionKeyTag=h,t.generateIFrameStreamInfTag=E,t.generateSegmentEntrySkeleton=y,t.generateCueTag=I,t.generateDateRange=T,t.generateKeyTag=_,t.generateByteRangeTag=O,t.generateMapTag=R,t.generateCustomTag=C;var a=n(2510),o=n(1397),s=n(6093);function u(e){var t,n,r;return{name:e.name,attributes:i(i({},e.attributes),{TYPE:null===(t=e.attributes)||void 0===t?void 0:t.TYPE,"GROUP-ID":null===(n=e.attributes)||void 0===n?void 0:n["GROUP-ID"],NAME:null===(r=e.attributes)||void 0===r?void 0:r.NAME})}}function l(e){var t,n;return(null===(t=e.attributes)||void 0===t?void 0:t.hasOwnProperty("TIME-OFFSET"))&&(n={timeOffset:Number(e.attributes["TIME-OFFSET"]),precise:"YES"===e.attributes.PRECISE}),e.attributes&&n&&n.hasOwnProperty("timeOffset")&&(e.attributes["TIME-OFFSET"]=n.timeOffset,e.attributes.PRECISE=n.precise),n}function d(e){return{targetDuration:parseFloat(e["PART-TARGET"])}}function c(e){var t={canBlockReload:!1};return e.attributes?(e.attributes["CAN-SKIP-UNTIL"]&&(t.canSkipUntil=parseFloat(e.attributes["CAN-SKIP-UNTIL"])),void 0!==t.canSkipUntil&&e.attributes["CAN-SKIP-DATERANGES"]&&(t.canSkipDateRanges="YES"===e.attributes["CAN-SKIP-DATERANGES"]),e.attributes["HOLD-BACK"]&&(t.holdBack=parseFloat(e.attributes["HOLD-BACK"])),e.attributes["PART-HOLD-BACK"]&&(t.partHoldBack=parseFloat(e.attributes["PART-HOLD-BACK"])),e.attributes["CAN-BLOCK-RELOAD"]&&(t.canBlockReload="YES"===e.attributes["CAN-BLOCK-RELOAD"]),t):t}function f(e){var t={skippedSegments:0,recentlyRemovedDateranges:[]};return e.attributes?(e.attributes["SKIPPED-SEGMENTS"]&&(t.skippedSegments=parseInt(e.attributes["SKIPPED-SEGMENTS"])),e.attributes["RECENTLY-REMOVED-DATERANGES"]&&(t.recentlyRemovedDateranges=e.attributes["RECENTLY-REMOVED-DATERANGES"].split("\\t")),t):t}function p(e,t){var n={uri:(0,o.forceReallocation)(e.URI),duration:parseFloat(e.DURATION)};if("YES"===e.INDEPENDENT&&(n.independent=!0),e.BYTERANGE){var i=e.BYTERANGE.split("@"),r=parseInt(i[0]),a=parseInt(i[1]);isNaN(a)&&(a=(null==t?void 0:t.byteRange)?t.byteRange.end+1:0),n.byteRange={start:a,end:a+r-1}}return"YES"===e.GAP&&(n.gap=!0),n}function g(e){var t=parseInt(e["BYTERANGE-START"]),n=parseInt(e["BYTERANGE-END"]);if(!isNaN(t)||!isNaN(n))return{start:isNaN(t)?0:t,end:isNaN(n)?Math.pow(2,53)-1:n}}function S(e,t){if("PART"===e.TYPE){var n={uri:(0,o.forceReallocation)(e.URI),duration:t,isPreloadHint:!0};return(i=g(e))&&(n.byteRange=i),{part:n}}if("MAP"===e.TYPE){var i,r={url:(0,o.forceReallocation)(e.URI)};return(i=g(e))&&(r.byteRange=i),{init:r}}return{}}function v(e,t){var n,r,a,o,s,u={name:e.name,uri:t,attributes:i(i({},e.attributes),{BANDWIDTH:null===(n=e.attributes)||void 0===n?void 0:n.BANDWIDTH})};return(null===(r=e.attributes)||void 0===r?void 0:r.RESOLUTION)&&(u.attributes.RESOLUTION=b(e)),(null===(a=e.attributes)||void 0===a?void 0:a.BANDWIDTH)&&(u.attributes.BANDWIDTH=parseInt(e.attributes.BANDWIDTH)),(null===(o=e.attributes)||void 0===o?void 0:o["AVERAGE-BANDWIDTH"])&&(u.attributes["AVERAGE-BANDWIDTH"]=parseInt(e.attributes["AVERAGE-BANDWIDTH"])),(null===(s=e.attributes)||void 0===s?void 0:s["PROGRAM-ID"])&&(u.attributes["PROGRAM-ID"]=parseInt(e.attributes["PROGRAM-ID"])),u.id=m(u.attributes),u}function m(e){var t="";return e.RESOLUTION&&(t+=e.RESOLUTION.height+"_"),t+=e.BANDWIDTH}function h(e){N(e)}function E(e){var t,n,i;(null===(t=e.attributes)||void 0===t?void 0:t.BANDWIDTH)&&(e.attributes.BANDWIDTH=parseInt(e.attributes.BANDWIDTH)),(null===(n=e.attributes)||void 0===n?void 0:n["AVERAGE-BANDWIDTH"])&&(e.attributes["AVERAGE-BANDWIDTH"]=parseInt(e.attributes["AVERAGE-BANDWIDTH"],10)),(null===(i=e.attributes)||void 0===i?void 0:i.RESOLUTION)&&(e.attributes.RESOLUTION=b(e))}function y(){return{uri:"",duration:0,mediaSequence:0}}function I(e,t){var n={type:t};if(e.attributes){var i=[];for(var r in e.attributes)if(e.attributes.hasOwnProperty(r)){var a=e.attributes[r]?"".concat(r,"=").concat(e.attributes[r]):r;i.push(a)}n.attributes=i}return n}function T(e){var t={type:a.MetadataType.DATERANGE};if(e.attributes){t.clientAttributes={};var n=e.attributes;for(var i in n)if(n.hasOwnProperty(i))if(i.startsWith("X-")){var r=2;t.clientAttributes[(0,o.kebabCaseToCamelCase)(i.substring(r))]=(0,o.forceReallocation)(n[i])}else t[(0,o.kebabCaseToCamelCase)(i)]=(0,o.forceReallocation)(n[i])}return t.duration&&(t.duration=Number(t.duration)),t.plannedDuration&&(t.plannedDuration=Number(t.plannedDuration)),t.endOnNext&&(t.endOnNext=!0),t}function _(e){if(N(e),e.attributes&&"NONE"!==e.attributes.METHOD&&e.attributes.URI){var t={method:(0,o.forceReallocation)(e.attributes.METHOD)||"AES-128",uri:(0,o.forceReallocation)(e.attributes.URI)};return void 0!==e.attributes.IV&&(t.iv=e.attributes.IV),e.attributes.KEYFORMAT&&(t.keyformat=(0,o.forceReallocation)(e.attributes.KEYFORMAT)),e.attributes.KEYFORMATVERSIONS&&(t.keyformatversions=(0,o.forceReallocation)(e.attributes.KEYFORMATVERSIONS)),e.attributes.KEYID&&(t.keyid=(0,o.forceReallocation)(e.attributes.KEYID)),t}}function O(e,t){var n;if(e.value){var i=e.value.split("@"),r=i[0],a=i[1],o={length:parseInt(r||"0")};if(a)o.offset=parseInt(a);else{var s=t[t.length-1];(null==s?void 0:s.byterange)&&(o.offset=(null!==(n=s.byterange.offset)&&void 0!==n?n:0)+s.byterange.length)}return o}}function R(e,t){var n,i;if(null===(n=e.attributes)||void 0===n?void 0:n.URI){var a={url:(0,o.forceReallocation)(e.attributes.URI)};if(null===(i=e.attributes)||void 0===i?void 0:i.BYTERANGE){var s=e.attributes.BYTERANGE.split("@"),u=s[0],l=s[1];a.byteRange={start:parseInt(l),end:parseInt(l)+parseInt(u)-1}}return t.keys.length>0&&(a.keys=r([],t.keys,!0),t.keyInUse=!0),a}}function N(e){var t;if(null===(t=e.attributes)||void 0===t?void 0:t.IV){e.attributes.IV=e.attributes.IV.toLowerCase();var n=2;"0x"===e.attributes.IV.substring(0,n)&&(e.attributes.IV=e.attributes.IV.substring(n)),e.attributes.IV=new Uint8Array(s.FormatHelper.hexToBytes(e.attributes.IV)).buffer}}function b(e){var t,n={width:0,height:0},i=null===(t=e.attributes)||void 0===t?void 0:t.RESOLUTION.split("x");return i[0]&&(n.width=parseInt(i[0])),i[1]&&(n.height=parseInt(i[1])),n}var M=/(?:^|,)((?:[^=]*)=(?:"[^"]*"|[^,]*))/,A=/([^=]*)=(.*)/,P=/^[\'"](.*)[\'"]$/,D=/^[\'"](.*)[\'"]$/g,L=/^([^:="]*)([:=])?(.*)$/;function C(e){try{e=(0,o.forceReallocation)(e);var t=/^#([^:=]*)([:=])?(.*)$/.exec(e);if(!(null==t?void 0:t[1]))return;var n={name:t[1]},i="";if("="===t[2]&&t[3])i=t[3];else if(":"===t[2]&&t[3]){var r=L.exec(t[3]);r&&"="===r[2]&&r[3]?n.attributes=U(t[3]):i=t[3]}return i&&(n.value=i.replace(D,"$1")),n}catch(e){return}}function U(e){for(var t=e.split(M),n=t.length,i={};n--;)if(""!==t[n]){var r=A.exec(t[n]);if(r){var a=r.slice(1),o=a[0],s=a[1];i[o.trim()]=s.trim().replace(P,"$1")}}return i}},8367:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.ArrayIncludesPolyfill=void 0,t.ArrayIncludesPolyfill=function(){return{polyfill:function(){Object.defineProperty(Array.prototype,"includes",{value:function(e,t){if(null==this)throw new TypeError(\'"this" is null or not defined\');var n=Object(this),i=n.length>>>0;if(0===i)return!1;var r=0|t,a=Math.max(r>=0?r:i-Math.abs(r),0);function o(e,t){return e===t||"number"==typeof e&&"number"==typeof t&&isNaN(e)&&isNaN(t)}for(;a<i;){if(o(n[a],e))return!0;a++}return!1}})}}}()},8665:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ServiceName=void 0,function(e){e.AdaptationService="AdaptationService",e.DrmDetectorService="DrmDetectorService",e.DrmService="DrmService",e.HeartbeatService="HeartbeatService",e.LiveLatencyService="LiveLatencyService",e.ManifestCachingService="ManifestCachingService",e.ManifestLoadingService="ManifestLoadingService",e.ManifestService="ManifestService",e.ManifestUpdateSchedulingService="ManifestUpdateSchedulingService",e.MetadataParsedService="MetadataParsedService",e.PlayerStateService="PlayerStateService",e.SegmentService="SegmentService",e.SourceStoreService="SourceStoreService",e.StallTimeTrackerService="StallTimeTrackerService",e.StartOffsetService="StartOffsetService",e.StreamTimeService="StreamTimeService",e.SubtitleService="SubtitleService",e.SynchronizedTimeService="SynchronizedTimeService",e.ThumbnailService="ThumbnailService",e.TimedMetadataService="TimedMetadataService"}(n||(t.ServiceName=n={}))},8764:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.PlayerError=void 0;var i=n(5550),r=function(){function e(e,t,n,r){this.code=e,this.name=i.ErrorCode[e],this.sourceIdentifier=r,this.message=null!=n?n:"".concat(this.name),this.data=t,"function"==typeof Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=new Error(this.message).stack}return e}();t.PlayerError=r},8794:function(e,t,n){var i=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}();Object.defineProperty(t,"__esModule",{value:!0}),t.HlsParserWebworkerMessageHandler=void 0,t.getContext=l;var r=n(1715),a=n(7697),o=n(9692),s=null;function u(){var e=new a.WebWorkerContext(d);return onmessage=e.onMessageCallback,e}function l(){return s||u()}var d=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return i(t,e),t.prototype.parseHlsPlaylist=function(e){var t=e.payload;try{var n=(0,o.parsePlaylist)(t.data,t.options);this.postMessageFunction({action:"parsedPlaylist",data:n})}catch(e){this.postMessageFunction({action:"error",data:e.message})}},t}(r.MessageHandler);t.HlsParserWebworkerMessageHandler=d,"undefined"==typeof window&&(s=u())},8842:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.devToolsExtension=void 0;var i=n(7093);t.devToolsExtension=i.default.__REDUX_DEVTOOLS_EXTENSION__},8915:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.isSegmentTiming=a,t.findSegmentIndexForTime=o,t.createInitSegmentInfoBase=l,t.getSegmentInfoTimeRange=d,t.generateSegmentId=c;var i=n(5711),r=n(16);function a(e){return"startTime"in e&&(0,r.isNumber)(e.startTime)&&"duration"in e&&(0,r.isNumber)(e.duration)}function o(e,t,n){var i=!e||!e.length,r=t<e[0].startTime+e[0].duration;if(i||r)return 0;var a=e.length-1;if(t>=e[a].startTime)return a;var o=Math.max(t-e[0].startTime,0),l=Math.min(Math.floor(o/n),e.length-1);return s(e[0])&&s(e[l])?u(e,t,l):null}function s(e){return e&&(0,r.isNumber)(e.startTime)}function u(e,t,n){for(;e[n]&&e[n].startTime>t;)n--;for(;e[n]&&e[n].startTime+e[n].duration<=t;)n++;return n=Math.max(n,0),n=Math.min(n,e.length-1)}function l(e){var t=e._internalId;return{internalRepresentationId:t,representationId:t.representationId,periodId:t.periodId,mimeType:e._mimeType,isInitSegment:!0}}function d(e){if((null==e?void 0:e.duration)&&void 0!==(null==e?void 0:e.startTime))return{start:e.startTime,end:e.startTime+e.duration}}function c(e){var t,n,r=null!==(n=null===(t=e.discontinuitySequenceNumber)||void 0===t?void 0:t.toString())&&void 0!==n?n:e.periodId,a=e.byteRange?"-".concat(e.byteRange.start,":").concat(e.byteRange.end):"";return(0,i.calcHash)("".concat(r,":").concat(e.url).concat(a))}},9181:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ManifestMimeType=void 0,function(e){e.Dash="application/dash+xml",e.Hls="application/x-mpegURL",e.Smooth="application/vnd.ms-sstr+xml"}(n||(t.ManifestMimeType=n={}))},9210:function(e,t,n){var i,r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},r.apply(this,arguments)},a=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var i,r=0,a=t.length;r<a;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.ReachableDomainsReducer=void 0;var o=n(1829),s=n(9463),u={domains:[]};function l(e,t){return r(r({},e),{domains:e.domains.includes(t)?e.domains:a(a([],e.domains,!0),[t],!1)})}t.ReachableDomainsReducer=(0,o.default)(u,((i={})[s.ReachableDomainsActionType.AddDomain]=function(e,t){return l(e,t.payload)},i))},9422:function(e,t){var n=this&&this.__assign||function(){return n=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},n.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.addStoreServiceDecoration=void 0;var i=function(e){return function(t){return function(){var i=function(){return e.buildReducer()},r=t(i()),a=function(){return r.replaceReducer(i())};return a(),n(n({},r),{addReducer:function(t,n){e.set(t,n),a()},getReducer:function(t){return e.get(t)},removeReducer:function(t){e.delete(t),a()},hasReducer:function(t){return e.has(t)}})}}};t.addStoreServiceDecoration=i},9463:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ReachableDomainsActionType=void 0,function(e){e.AddDomain="adddomain"}(n||(t.ReachableDomainsActionType=n={}))},9692:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.parsePlaylist=d;var i,r=n(6461),a=n(2600),o=n(5877),s=n(7967),u=/\\r\\n|\\r(?=[^\\n]|$)/gm,l=/^#EXTM3U($|[ \\t\\n])/m;function d(e,t){void 0===t&&(t={});var n=-1===e.indexOf("#EXTINF")?i.Master:i.Media,d=e.replace(u,"\\n").trim().split(/\\n+/m),f=(0,r.removeTrailingWhitespaces)(d[0]);if(!l.test(f))throw new Error("Playlist parsing failed: missing #EXTM3U tag");if(n===i.Media)return(0,o.parseVariant)(d,t);for(var p,g=[],S=[],v=[],m=1,h=!0,E=!1,y=!0,I=0;I<d.length;I++){var T=(0,r.removeTrailingWhitespaces)(d[I]),_=d[I+1];if((0,r.isCustomTag)(T))c(g,T);else if(y)y=!1;else{var O=(0,a.parseTag)(T);switch(O.name){case"EXT-X-STREAM-INF":v.push((0,s.generateStreamInfTag)(O,(0,r.removeTrailingWhitespaces)(_))),y=!0;break;case"EXT-X-MEDIA":var R=(0,s.generateRendition)(O);S.push(R),g.push(R);break;case"EXT-X-VERSION":m=Number(O.value);break;case"EXT-X-START":p=(0,s.generateStartAttributes)(O),g.push(O);break;case"EXT-X-ALLOW-CACHE":h="YES"===O.value||void 0===O.value;break;case"EXT-X-INDEPENDENT-SEGMENTS":E=!0,g.push(O);break;case"EXT-X-I-FRAME-STREAM-INF":(0,s.generateIFrameStreamInfTag)(O),g.push(O);break;case"EXT-X-SESSION-DATA":default:g.push(O);break;case"EXT-X-SESSION-KEY":(0,s.generateSessionKeyTag)(O),g.push(O)}}}var N={version:m,allowCache:h,independentSegments:E,hasM3u:!0,media:S,playlists:v,tags:g=g.concat(v)};return p&&(N.start=p),N}function c(e,t){var n=(0,s.generateCustomTag)(t);n&&e.push(n)}!function(e){e.Master="master",e.Media="media"}(i||(i={}))},9814:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.MimeTypeHelper=t.MimeType=void 0,t.isMediaTypeContained=s;var i,r=n(9181),a=n(3696);!function(e){e.VideoMp4="video/mp4",e.VideoTs="video/mp2t",e.AudioMp4="audio/mp4",e.AudioTs="audio/mp2t"}(i||(t.MimeType=i={}));var o=function(){function e(){}return e.isSubtitle=function(e){return this.isApplication(e)||this.isText(e)},e.isText=function(e){return e.includes("text")},e.isTtmlXml=function(e){return e.includes("ttml+xml")},e.isApplication=function(e){return e.includes("application")},e.isAV=function(e){return this.isVideo(e)||this.isAudio(e)},e.isVideo=function(e){return e.includes("video")},e.isUnknown=function(e){return e.includes("unknown")},e.isAudio=function(e){return e.includes("audio")},e.isImage=function(e){return e.includes("image")},e.isDash=function(e){return e.includes(r.ManifestMimeType.Dash)},e.isHls=function(e){return e.includes(r.ManifestMimeType.Hls)||e.includes("vnd.apple.mpegURL")},e.isMP4=function(e){return e.includes("mp4")},e.getMediaType=function(e){return this.isVideo(e)?a.MediaType.Video:this.isAudio(e)?a.MediaType.Audio:this.isSubtitle(e)?a.MediaType.Subtitles:this.isImage(e)?a.MediaType.Thumbnails:void 0},e.extractContentType=function(e){return e.split("/")[0]},e.extractContainerType=function(e){var t=e.split("/");return t.length>1?t[1]:null},e}();function s(e,t){return Object.keys(e).map((function(e){return o.getMediaType(e)})).includes(o.getMediaType(t))}t.MimeTypeHelper=o}},t={};function n(i){var r=t[i];if(void 0!==r)return r.exports;var a=t[i]={exports:{}};return e[i].call(a.exports,a,a.exports,n),a.exports}!function(){n.d=function(e,t){for(var i in t)n.o(t,i)&&!n.o(e,i)&&Object.defineProperty(e,i,{enumerable:!0,get:t[i]})}}(),function(){n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)}}(),function(){n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}}();n(8794)}();', ie.p + "0a51d654cee6b865f704.worker.js");
        };
      }, 83740: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.uniqueRenditions = ce;
        var ae = ie(86865);
        function ce(he) {
          var _e = [];
          return he.forEach(function(le) {
            var se = _e.findIndex(function(ue) {
              return (0, ae.compareValues)(le, ue, ["GROUP-ID", "NAME", "TYPE"]);
            });
            if (se !== -1) {
              var oe = _e[se];
              le.DEFAULT === "YES" && oe.DEFAULT !== "YES" && (_e[se] = le);
            } else
              _e.push(le);
          }), _e;
        }
      }, 90993: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.HlsActionType = void 0, function(ae) {
          ae.SetMasterPlaylistString = "@instance/hls/setmasterplayliststring", ae.SetPlaylistType = "@instance/hls/setplaylisttype", ae.SetIsLowLatencyPlaylist = "@instance/hls/setislowlatencyplaylist", ae.SetEndlist = "@instance/hls/setendlist", ae.SetDefaultLanguages = "@instance/hls/setsefaultlanguages", ae.SetCustomTags = "@instance/hls/setsustomtags", ae.SetDiscoTimings = "@instance/hls/setdiscotimings", ae.SetPresentationTimeOffset = "@instance/hls/setpresentationtimeoffset", ae.SetTimestampRolloverPositions = "@instance/hls/settimestamprolloverpositions", ae.SetContentLocationId = "@instance/hls/setcontentlocationid";
        }(ie || (ne.HlsActionType = ie = {}));
      }, 97662: function(ee, ne) {
        function ie(ae) {
          return ae.reduce(function(ce, he, _e, le) {
            var se = he._discontinuitySequenceNumber, oe = he._playbackTime;
            if (ce.discoTimings[se] === void 0) {
              ce.discoTimings[se] = { startTime: oe, endTime: 1 / 0 };
              var ue = ce.discoTimings[se - 1];
              ue && (ue.endTime = oe);
            }
            return _e === le.length - 1 && (ce.discoTimings[se].endTime = oe + he._duration), ce.totalDuration += he._duration, ce;
          }, { totalDuration: 0, discoTimings: {} });
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getTimingInfoFromSegmentList = ie;
      } }, function(ee) {
        return function(ne) {
          return ee(ee.s = ne);
        }(64732);
      }]);
    });
  })();
})(bitmovinplayerHls);
var bitmovinplayerHlsExports = bitmovinplayerHls.exports;
const HLSModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerHlsExports);
var bitmovinplayerMserenderer = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ne) {
      re.exports = ne();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[737], { 1504: function(ee, ne) {
        function ie(ae) {
          return "ManagedMediaSource" in window && (ae || !("MediaSource" in window));
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.shouldUseManagedMediaSource = ie;
      }, 6863: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MSERenderer = void 0;
        var ae = ie(92712), ce = ie(52442), he = ie(25550), _e = ie(28764), le = ie(18665), se = ie(62510), oe = ie(33696), ue = ie(94304), be = ie(11399), ve = ie(17990), me = ie(27279), pe = ie(13533), fe = ie(3464), ge = ie(27177), ye = ie(10981), $e = ie(53968), Se = ie(10676), Ce = ie(79814), Ie = ie(70016), Te = ie(46462), Ee = ie(96873), we = ie(33669), Pe = ie(23729), Me = ie(93159), Ae = ie(58765), Oe = ie(66697), Be = ie(1504), Ve = ie(76316), Ue = function() {
          function xe(ke) {
            var Le = this;
            this.context = ke, this.consecutiveErrorCount = 0, this.waitingForSeekedPromise = null, this.onWaitingForKey = function() {
              if (!Le.setCurrentTimeContext && (0, pe.getCapabilities)()[be.CapabilityKey.isFirefox]) {
                var He = Le.getCurrentTime();
                Le.logger.debug("Received waitingforkey event on Firefox, re-setting currentTime to ".concat(He)), Le.setCurrentTime(He);
              }
            }, this.onSeek = function(He) {
              Le.setCurrentTimeDelayedContext && Le.setCurrentTimeDelayedContext.time !== He.seekTarget && Math.abs(Le.setCurrentTimeDelayedContext.time - He.seekTarget) >= Le.context.settings.GAP_TOLERANCE && Le.cancelSetCurrentTimeDelayed();
            }, this.reOpenMse = function() {
              var He = Le.segmentQueueMimeTypes;
              if (He.length < 1)
                return Promise.resolve();
              var We = He.find(function(Xe) {
                return Le.timestampOffset.hasOwnProperty(Xe);
              });
              return We ? Le.setTimestampOffset(We, Le.timestampOffset[We]) : Le.setTimestampOffset(He[0], 0);
            }, this.firePictureInPictureEvent = function() {
              if (Le.video) {
                var He = Le.video.isPictureInPicture() ? oe.ViewMode.PictureInPicture : oe.ViewMode.Inline;
                Le.context.store.dispatch((0, ve.setPlayerViewMode)(He));
              }
            }, this.resetConsecutiveErrorCountCallback = function(He) {
              He.time && He.time > 0 && (Le.consecutiveErrorCount = 0);
            }, this.postBufferRemoval = function(He, We, Xe) {
              Le.logger.debug("successfully removed buffer for ".concat(He, " (from  ").concat(We, " to ").concat(Xe, ")"));
            }, this.memoizedIsTypeSupported = (0, Se.memoize)(this.isTypeSupported.bind(this)), this.logger = ke.logger, this.video = ke.videoElement, this.settings = ke.settings, this.readyPromise = Promise.resolve(), this.eventHandler = void 0, this.timestampOffset = {}, this.sourceBufferMimeCodecMap = new Pe.BufferMimeCodecMap(ke.store, ke.settings), this.savedCurrentTime = 0, this.playerEventHandler = ke.eventHandler, this.shutdownPromise = Promise.resolve(), this.init(!0);
          }
          return xe.prototype.createMSEWrapper = function() {
            return new Ae.MSEWrapper(this.context);
          }, xe.prototype.createMse = function(ke) {
            return ke ? this.createMseSynchronously() : this.createMseAsynchronously();
          }, xe.prototype.createMseAsynchronously = function() {
            var ke = this;
            return function() {
              var Le;
              return (Le = ke.mse) === null || Le === void 0 ? void 0 : Le.createNewMSE();
            };
          }, xe.prototype.createMseSynchronously = function() {
            var ke, Le = (ke = this.mse) === null || ke === void 0 ? void 0 : ke.createNewMSE();
            return function() {
              return Le;
            };
          }, xe.prototype.init = function(ke) {
            var Le = this;
            this.segmentQueueProcessingPromise = Promise.resolve(), this.mse = this.createMSEWrapper(), this.readyPromise = this.readyPromise.catch(function(He) {
              return Le.context.logger.debug("Caught error during MSE recreation", He);
            }).then(this.createMse(ke)), this.needsInitialSeek = !0, this.segmentQueues = {}, this.setCurrentTimeContext = void 0, this.setCurrentTimeDelayedContext = void 0, this.quotaExceededMap = /* @__PURE__ */ new Map(), this.quotaExceededDeferredMap = /* @__PURE__ */ new Map(), this.gapHandler = new Me.GapHandler(this.context), this.eventHandler == null && this.video && (this.eventHandler = new Ve.VideoEventHandler(this.video), this.eventHandler.on(Te.MediaElementEvent.timeupdate, this.resetConsecutiveErrorCountCallback)), this.on(Te.MediaElementEvent.webkitpresentationmodechanged, this.firePictureInPictureEvent), this.on(Te.MediaElementEvent.waitingforkey, this.onWaitingForKey), this.playerEventHandler.on(se.PlayerEvent.Seek, this.onSeek);
          }, xe.prototype.trackRendererError = function(ke) {
            this.consecutiveErrorCount++, this.consecutiveErrorCount >= this.settings.MAX_CONSECUTIVE_RENDERER_ERRORS && this.context.eventHandler.fireError(new _e.PlayerError(he.ErrorCode.PLAYBACK_VIDEO_DECODING_ERROR, { codec: ke.getCodec(), mimeType: ke.getMimeType(), segmentUrl: ke.getUrl() }, "Failed to append the segment to the buffer. The MSE has thrown an error."));
          }, xe.prototype.hasSourceBuffers = function() {
            return this.segmentQueueMimeTypes.length > 0;
          }, xe.prototype.hasDataInSourceBuffers = function() {
            var ke = this.mse;
            return !(!ke || !this.hasSourceBuffers()) && this.segmentQueueMimeTypes.every(function(Le) {
              return ke.getBufferedRanges(Le).length > 0;
            });
          }, xe.prototype.updateRendererRangesInStore = function(ke) {
            var Le;
            (Le = (0, me.getSourceStore)(this.context)) === null || Le === void 0 || Le.dispatch((0, Ee.setRendererRanges)(ke, this.getOverallBufferedRanges(ke)));
          }, xe.prototype.addBuffer = function(ke, Le) {
            var He, We = this;
            if (!this.mse)
              return !1;
            this.sourceBufferMimeCodecMap.add(ke, Le);
            var Xe = !!this.mse.addBuffer(ke, Le, function() {
              return We.updateRendererRangesInStore(ke);
            });
            return Xe && (this.mse.addUpdateEndCallback(ke, function() {
              var Qe;
              return (Qe = We.setCurrentTimeDelayedContext) === null || Qe === void 0 || Qe.reevaluateDataInBuffer(), We.quotaExceededMap.set(ke, !1);
            }), this.segmentQueues[ke] = [], (He = (0, me.getSourceStore)(this.context)) === null || He === void 0 || He.dispatch((0, Ee.setRendererRanges)(ke, []))), Xe;
          }, xe.prototype.addDrmInitData = function(ke) {
            if (ke != null && ke.length) {
              var Le = this.drmService;
              Le ? ke.forEach(function(He) {
                return Le.addInitData(He);
              }) : this.context.logger.debug("PSSH data found but DRM is not configured");
            }
          }, xe.prototype.storeDrmInitDataFromManifest = function(ke) {
            var Le = this;
            ke && this.context.serviceManager.maybeCall(le.ServiceName.ManifestService, function(He) {
              var We = He.getContentProtectionForAdaptationSet(ke).flatMap(function(Xe) {
                var Qe = ue.KeySystemKind[Xe.name.toUpperCase()], tt = Xe.schemeIdUri.replace("urn:uuid:", "").replace(/-/g, "");
                return (Xe.pssh || []).map(function(Je, Ge) {
                  return Le.logger.insane("adding pssh for ".concat(Xe.name, " : ").concat(Je)), { initData: Xe.psshData[Ge], initDataStr: Je, systemID: Xe.schemeIdUri, systemIDraw: tt, systemName: Qe, kid: [] };
                });
              });
              Le.addDrmInitData(We);
            }, void 0, this.context.sourceContext.sourceIdentifier);
          }, xe.prototype.appendData = function(ke) {
            var Le = this;
            return this.addDrmInitData(ke.getDrmInitData()), this.addSegmentToSegmentQueue(ke), this.segmentQueueProcessingPromise = this.segmentQueueProcessingPromise.catch(function() {
            }).then(function() {
              return Le.processSegmentQueues();
            }), this.segmentQueueProcessingPromise;
          }, xe.prototype.addSegmentToSegmentQueue = function(ke) {
            var Le = ke.getMimeType();
            this.segmentQueues[Le] ? (this.segmentQueues[Le].push(ke), this.updateRendererRangesInStore(Le)) : this.logger.debug("Renderer missing segment queue for mimeType(".concat(Le, ") but trying to push segment.(url=").concat(ke.getUrl(), ")"));
          }, xe.prototype.getBufferedRanges = function(ke) {
            var Le, He;
            return (He = (Le = this.mse) === null || Le === void 0 ? void 0 : Le.getBufferedRanges(ke)) !== null && He !== void 0 ? He : [];
          }, xe.prototype.getVideoElementBufferedRanges = function() {
            return (0, ae.getBufferedRanges)(this.video);
          }, xe.prototype.getOverallBufferedRanges = function(ke) {
            if (!this.mse || !this.segmentQueues.hasOwnProperty(ke))
              return [];
            var Le = ae.BufferRangeHelper.getRangesFromQueue(this.segmentQueues[ke], this.settings.GAP_TOLERANCE);
            return Le = Le.concat(this.getBufferedRanges(ke)), Le = ae.BufferRangeHelper.mergeRanges(Le, this.settings.GAP_TOLERANCE);
          }, xe.prototype.isDataBeingAppended = function(ke) {
            return !!this.mse && (this.segmentQueues && this.segmentQueues[ke] && this.segmentQueues[ke].length > 0 || this.mse.isAnyBufferUpdating());
          }, xe.prototype.getRangesFromStore = function(ke) {
            var Le = (0, me.getSourceState)(this.context);
            if (!Le)
              return [];
            var He = (0, we.getBufferStateMap)(Le);
            return He ? (0, we.getRendererBufferedRanges)(He, ke) : [];
          }, xe.prototype.getEndOfBufferTime = function() {
            var ke = this, Le = [];
            if (this.segmentQueueMimeTypes.forEach(function(He) {
              var We = ke.getRangesFromStore(He);
              if (We.length > 0) {
                var Xe = We[We.length - 1].end;
                Le.push(Xe);
              }
            }), Le.length !== 0)
              return Math.min.apply(Math, Le);
          }, xe.prototype.removeDataFromSegmentQueues = function(ke, Le, He) {
            var We = this;
            Le === void 0 && (Le = -1 / 0), He === void 0 && (He = 1 / 0), this.segmentQueues.hasOwnProperty(ke) && (this.segmentQueues[ke] = this.segmentQueues[ke].filter(function(Xe) {
              var Qe = Xe.getDuration(), tt = Xe.getPlaybackTime(), Je = Xe.getRepresentationId().representationId, Ge = Xe.isInit() || tt < Le || tt + Qe > He;
              return We.logger.debug("[MSERenderer][".concat(ke, "][").concat(Je, "] Removing segment from queue [").concat(!Ge, "]. ") + "Clearing from ".concat(Le, " to ").concat(He, ". Segment: [playbackTime=").concat(Xe.getPlaybackTime(), ", ") + "duration=".concat(Xe.getDuration(), ", url=").concat(Xe.getUrl(), "]")), Ge;
            }), this.updateRendererRangesInStore(ke));
          }, xe.prototype.removeData = function(ke, Le, He) {
            return this.mse ? (Le === void 0 && He === void 0 && this.saveCurrentTime(), this.removeDataFromSegmentQueues(ke, Le, He), this.mse.removeFromBuffer(ke, Le, He, this.postBufferRemoval)) : Promise.reject();
          }, xe.prototype.getDroppedVideoFrames = function() {
            var ke, Le, He, We, Xe;
            return (Xe = (He = (Le = (ke = this.video) === null || ke === void 0 ? void 0 : ke.getVideoPlaybackQuality()) === null || Le === void 0 ? void 0 : Le.droppedVideoFrames) !== null && He !== void 0 ? He : (We = this.video) === null || We === void 0 ? void 0 : We.droppedVideoFrames) !== null && Xe !== void 0 ? Xe : 0;
          }, xe.prototype.setPlaybackSpeed = function(ke) {
            this.video && !isNaN(ke) && ke > 0 && ke !== this.video.playbackRate && (this.video.playbackRate = ke);
          }, xe.prototype.getPlaybackSpeed = function() {
            var ke, Le;
            return (Le = (ke = this.video) === null || ke === void 0 ? void 0 : ke.playbackRate) !== null && Le !== void 0 ? Le : 1;
          }, xe.prototype.setVolume = function(ke) {
            this.video && !isNaN(ke) && (this.video.volume = Math.min(ke / 100, 1));
          }, xe.prototype.getVolume = function() {
            var ke, Le;
            return 100 * ((Le = (ke = this.video) === null || ke === void 0 ? void 0 : ke.volume) !== null && Le !== void 0 ? Le : 1);
          }, xe.prototype.mute = function() {
            this.video && (this.video.muted = !0);
          }, xe.prototype.unmute = function() {
            this.video && (this.video.muted = !1);
          }, xe.prototype.isMuted = function() {
            var ke, Le;
            return (Le = (ke = this.video) === null || ke === void 0 ? void 0 : ke.muted) !== null && Le !== void 0 && Le;
          }, xe.prototype.play = function() {
            var ke = this;
            return this.video ? this.video.play().catch(function(Le) {
              if ((0, $e.isSwitchingBufferBlocks)((0, me.getSourceStore)(ke.context)))
                return ke.ready();
              throw Le;
            }) : Promise.resolve();
          }, xe.prototype.pause = function() {
            this.video && this.video.pause();
          }, xe.prototype.end = function() {
            this.pause(), this.cancelSetCurrentTimeDelayed();
          }, xe.prototype.isPaused = function() {
            var ke, Le;
            return (Le = (ke = this.video) === null || ke === void 0 ? void 0 : ke.paused) === null || Le === void 0 || Le;
          }, xe.prototype.setDuration = function(ke) {
            this.mse && (ke = Math.floor(1e4 * ke) / 1e4, this.duration = ke, this.mse.setDuration(ke));
          }, xe.prototype.getDuration = function() {
            var ke, Le;
            return (Le = (ke = this.video) === null || ke === void 0 ? void 0 : ke.duration) !== null && Le !== void 0 ? Le : NaN;
          }, xe.prototype.setCurrentTime = function(ke) {
            var Le = this;
            if (!this.mse)
              return Promise.reject("MSE is not open");
            if (ke = Math.ceil(100 * ke) / 100, this.setCurrentTimeContext) {
              if (this.setCurrentTimeContext.time === ke)
                return this.setCurrentTimeContext.promise;
              this.cancelSetCurrentTimeDelayed();
            }
            var He = Promise.resolve();
            this.isMSEOpen() || this.isTimeInBuffer(ke) || (this.logger.debug("reopen MSE on setCurrentTime"), He = this.reOpenMse());
            var We = He.then(function() {
              return Le.setCurrentTimeInternal(ke).catch(function(Xe) {
                return Le.logger.debug("could not set time ".concat(ke, " on video element"), Xe), Le.getCurrentTime();
              }).finally(function() {
                return Le.needsInitialSeek = !1;
              });
            });
            return this.setCurrentTimeContext = { time: ke, isInitialSeek: this.needsInitialSeek, promise: We }, We;
          }, xe.prototype.getCurrentVideoTime = function() {
            var ke, Le;
            return (Le = (ke = this.video) === null || ke === void 0 ? void 0 : ke.currentTime) !== null && Le !== void 0 ? Le : 0;
          }, xe.prototype.getCurrentFallbackTime = function() {
            var ke = this.setCurrentTimeContext;
            return ke && ke.isInitialSeek && ke.time !== -1 ? ke.time : this.savedCurrentTime !== 0 && this.isVideoCurrentTimeUnreliable() ? this.savedCurrentTime : (this.savedCurrentTime = 0, this.getCurrentVideoTime());
          }, xe.prototype.isVideoCurrentTimeUnreliable = function() {
            var ke;
            return !this.hasDataInSourceBuffers() && !(!((ke = this.mse) === null || ke === void 0) && ke.isBufferRemovalPending()) || !(!(0, $e.isSwitchingBufferBlocks)((0, me.getSourceStore)(this.context)) && this.isTimeInBuffer(this.getCurrentVideoTime()));
          }, xe.prototype.getCurrentTime = function(ke) {
            return ke === void 0 && (ke = !1), ke ? this.getCurrentVideoTime() : this.getCurrentFallbackTime();
          }, xe.prototype.getSnapshotData = function(ke, Le) {
            Le === void 0 && (Le = 1);
            try {
              if (!this.video)
                return;
              var He = this.video.videoWidth, We = this.video.videoHeight;
              this.snapshotCanvas || (this.snapshotCanvas = document.createElement("canvas"), this.snapshotCanvas.id = "snapshotHiddenCanvas"), this.snapshotCanvas.width = He, this.snapshotCanvas.height = We;
              var Xe = this.snapshotCanvas.getContext("2d");
              Xe == null || Xe.drawImage(this.video.getWrappedElement(), 0, 0, He, We);
              var Qe = void 0;
              return ke === "image/jpeg" || ke === "image/webp" ? (Le = Math.max(Le, 0), Le = Math.min(Le, 1), Qe = this.snapshotCanvas.toDataURL(ke, Le)) : Qe = this.snapshotCanvas.toDataURL(ke, Le), { height: We, width: He, data: Qe };
            } catch (tt) {
              return void (tt && tt.message ? this.logger.debug("Snapshot acquisition failed: " + tt.message) : this.logger.debug("Snapshot acquisition failed"));
            }
          }, xe.prototype.getDrmShutdownPromise = function() {
            return this.drmService ? this.drmService.shutdownPromise : Promise.resolve();
          }, xe.prototype.ready = function() {
            var ke = this;
            return this.shutdownPromise.then(function() {
              return ke.getDrmShutdownPromise();
            }).then(function() {
              return ke.mse || ke.init(!1), ke.readyPromise;
            });
          }, xe.prototype.setTimestampOffset = function(ke, Le) {
            var He = this;
            return this.mse ? this.mse.setTimestampOffset(ke, Le).then(function() {
              He.timestampOffset[ke] = Le;
            }) : Promise.resolve();
          }, xe.prototype.shutdown = function(ke) {
            var Le, He = this;
            if (!this.mse)
              return this.shutdownPromise;
            for (var We in this.waitingForSeekedPromise = null, ke && this.saveCurrentTime(), this.segmentQueues)
              this.segmentQueues.hasOwnProperty(We) && (delete this.segmentQueues[We], (Le = (0, me.getSourceStore)(this.context)) === null || Le === void 0 || Le.dispatch((0, Ee.setRendererRanges)(We, [])));
            var Xe = this.mse;
            return this.shutdownPromise = this.shutdownPromise.then(function() {
              return Xe.tearDownMediaSource();
            }).catch(function(Qe) {
              He.logger.debug("Could not tear down media source", { err: Qe, message: Qe.message });
            }), this.mse = void 0, this.cancelSetCurrentTimeDelayed(), this.gapHandler && (this.gapHandler.shutdown(), this.gapHandler = void 0), this.eventHandler && !ke && (this.eventHandler.dispose(), this.eventHandler = void 0), this.quotaExceededMap.clear(), this.quotaExceededDeferredMap.clear(), this.shutdownPromise;
          }, xe.prototype.release = function() {
            var ke;
            for (var Le in this.segmentQueues)
              this.segmentQueues.hasOwnProperty(Le) && this.mse !== null && (delete this.segmentQueues[Le], (ke = (0, me.getSourceStore)(this.context)) === null || ke === void 0 || ke.dispatch((0, Ee.setRendererRanges)(Le, [])));
            return this.sourceBufferMimeCodecMap.dispose(), this.mse && this.mse.dispose(), this.readyPromise = Promise.resolve(), this.timestampOffset = {}, this.cancelSetCurrentTimeDelayed(), this.gapHandler && (this.gapHandler.shutdown(), this.gapHandler = void 0), this.off(Te.MediaElementEvent.webkitpresentationmodechanged, this.firePictureInPictureEvent), this.off(Te.MediaElementEvent.waitingforkey, this.onWaitingForKey), this.eventHandler && (this.eventHandler.off(Te.MediaElementEvent.timeupdate, this.resetConsecutiveErrorCountCallback), this.eventHandler.dispose(), this.eventHandler = void 0), this.waitingForSeekedPromise = null, this.playerEventHandler.off(se.PlayerEvent.Seek, this.onSeek), this.memoizedIsTypeSupported.invalidate(), this.getDrmShutdownPromise();
          }, xe.prototype.on = function(ke, Le) {
            var He;
            (He = this.eventHandler) === null || He === void 0 || He.on(ke, Le);
          }, xe.prototype.off = function(ke, Le) {
            this.eventHandler && this.eventHandler.off(ke, Le);
          }, Object.defineProperty(xe.prototype, "drmService", { get: function() {
            var ke;
            return (ke = this.context.serviceManager) === null || ke === void 0 ? void 0 : ke.get(le.ServiceName.DrmService);
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(xe.prototype, "segmentQueueMimeTypes", { get: function() {
            return Object.keys(this.segmentQueues);
          }, enumerable: !1, configurable: !0 }), xe.prototype.setDrmConfig = function(ke, Le) {
            return this.drmService ? this.drmService.updateDrmConfig(ke, Le) : Promise.reject(ce.DrmSetupError.MISSING_CONFIGURATION);
          }, xe.prototype.isMediaTypeSupported = function(ke, Le) {
            return this.memoizedIsTypeSupported("".concat(ke, '; codecs="').concat(Le, '"'));
          }, xe.prototype.isTypeSupported = function(ke) {
            return (0, Be.shouldUseManagedMediaSource)(this.context.settings.PREFER_MANAGED_MEDIA_SOURCE) ? window.ManagedMediaSource.isTypeSupported(ke) : "MediaSource" in window && MediaSource.isTypeSupported(ke);
          }, xe.prototype.cancelPendingEndOfStream = function() {
            this.setEndOfStreamDeferred && (this.setEndOfStreamDeferred.reject(new Error("Cancelled pending end of stream.")), this.setEndOfStreamDeferred = void 0);
          }, xe.prototype.deferSetEndOfStream = function() {
            var ke = this;
            return this.setEndOfStreamDeferred = this.setEndOfStreamDeferred || new ye.Deferred(), this.setEndOfStreamDeferred.promise.then(function() {
              var Le;
              return (Le = ke.mse) === null || Le === void 0 ? void 0 : Le.endOfStream();
            }).catch(function(Le) {
              (0, ge.isContextAvailable)(ke.context) && ke.context.logger.debug(Le);
            });
          }, xe.prototype.setEndOfStream = function(ke) {
            if (ke === void 0 && (ke = !0), !ke)
              return this.cancelPendingEndOfStream(), this.isMSEOpen() ? Promise.resolve() : this.reOpenMse();
            if (!this.hasSourceBuffers() || !this.mse)
              return this.logger.debug("Cannot signal EOS as no buffers have been added yet"), Promise.resolve();
            var Le = this.getEndOfBufferTime();
            return this.setCurrentTimeDelayedContext && this.setCurrentTimeDelayedContext.time >= this.duration && Le && !isNaN(Le) && this.cancelSetCurrentTimeDelayed(), this.setCurrentTimeDelayedContext ? this.deferSetEndOfStream() : this.mse.endOfStream();
          }, xe.prototype.isTimeInRangePendingRemoval = function(ke) {
            var Le = this.getRangesPendingRemoval();
            for (var He in Le) {
              var We = Le[He];
              if (We.start <= ke && We.end >= ke)
                return !0;
            }
            return !1;
          }, xe.prototype.isTimeInBuffer = function(ke, Le) {
            if (Le === void 0 && (Le = 0), this.isTimeInRangePendingRemoval(ke))
              return !1;
            var He = this.getRangesInSourceBuffers();
            return !!He && Object.keys(He).every(function(We) {
              return (0, ae.isInTimeRanges)(He[We], ke, Le);
            });
          }, xe.prototype.ensureSafeDistanceToEndOfBuffer = function(ke, Le) {
            var He, We = (He = this.getRangesInSourceBuffers()) !== null && He !== void 0 ? He : {}, Xe = Object.keys(We), Qe = Ne(We, ke);
            if (Xe.length === 0 || Qe.length < Xe.length)
              return NaN;
            var tt = Math.min.apply(Math, Qe.map(function(Ge) {
              var Ye;
              return (Ye = Ge == null ? void 0 : Ge.end) !== null && Ye !== void 0 ? Ye : 1 / 0;
            })), Je = tt - ke;
            return Je >= Le ? ke : ke - (Le - Je);
          }, xe.prototype.adjustTimeToNextCommonBufferStart = function(ke) {
            var Le, He, We, Xe = (Le = (0, me.getSourceState)(this.context)) === null || Le === void 0 ? void 0 : Le.drm, Qe = (0, Oe.getBufferEndSafetyMargin)(Xe);
            if (this.isTimeInBuffer(ke, Qe))
              return ke;
            var tt = this.isTimeInBuffer(ke), Je = this.getFutureBufferStarts(ke).filter(function(Fe) {
              return Fe >= ke;
            }), Ge = Je.length === 0;
            if (tt && Ge) {
              var Ye = this.ensureSafeDistanceToEndOfBuffer(ke, Qe), ze = (We = (He = (0, me.getSourceState)(this.context)) === null || He === void 0 ? void 0 : He.buffer.isLoadingRangeFinished) === null || We === void 0 || We;
              return Ye === ke || ze ? !isNaN(Ye) && this.isTimeInBuffer(Ye) ? (this.logger.debug("Adjusting current time away from end of buffer: ".concat(Ye)), Ye) : ke : (this.logger.debug("Not adjusting seek target, because there will be future data"), NaN);
            }
            return !tt && Ge ? NaN : (ke = Math.min.apply(null, Je), this.logger.debug("Adjusting current time to next buffer start: ".concat(ke)), ke);
          }, xe.prototype.getFutureBufferStarts = function(ke) {
            var Le, He = this.getRangesInSourceBuffers();
            if (!He)
              return [];
            if (this.mse) {
              var We = this.getRangesPendingRemoval();
              Le = Object.keys(We).map(function(Xe) {
                return We[Xe];
              });
            } else
              Le = [];
            return ae.BufferRangeHelper.getCommonBufferedRanges(He).filter(function(Xe) {
              return Xe.getEnd() >= ke && !isNaN(Xe.getStart());
            }).filter(function(Xe) {
              return Le.every(function(Qe) {
                return (0, ae.areDisjoint)(Qe, { start: Xe.getStart(), end: Xe.getEnd() });
              });
            }).map(function(Xe) {
              return Xe.getStart();
            });
          }, xe.prototype.getRangesInSourceBuffers = function() {
            if (!this.mse)
              return null;
            var ke = {};
            for (var Le in this.segmentQueues)
              if (this.segmentQueues.hasOwnProperty(Le) && (ke[Le] = this.mse.getBufferedRanges(Le), ke[Le].length < 1))
                return null;
            return Object.keys(ke).length ? ke : null;
          }, xe.prototype.getRangesPendingRemoval = function() {
            if (!this.mse || !this.mse.isBufferRemovalPending())
              return {};
            var ke = {};
            for (var Le in this.segmentQueues) {
              var He = this.mse.getRangePendingRemoval(Le);
              this.segmentQueues.hasOwnProperty(Le) && He && (ke[Le] = He);
            }
            return ke;
          }, xe.prototype.processSegmentQueues = function() {
            var ke = this, Le = this.segmentQueueMimeTypes.filter(function(He) {
              return ke.segmentQueues[He].length > 0;
            }).map(function(He) {
              return ke.addSegmentFromQueueToMse(He);
            });
            return Le.length === 0 ? Promise.resolve() : Promise.all(Le).then(function() {
              return ke.processSegmentQueues();
            }).catch(function(He) {
              if (He !== ce.SOURCE_BUFFER_APPEND_STATUS.SUSPENDED)
                throw He;
            });
          }, xe.prototype.getHeadOfQueue = function(ke) {
            return this.segmentQueues[ke][0];
          }, xe.prototype.isMSEOpen = function() {
            var ke;
            return ((ke = this.mse) === null || ke === void 0 ? void 0 : ke.readyState) === Ae.MediaSourceReadyState.open;
          }, xe.prototype.maybeWaitForDrmLicense = function(ke) {
            var Le, He = (Le = (0, me.getSourceState)(this.context)) === null || Le === void 0 ? void 0 : Le.drm;
            return this.context.serviceManager.maybeCall(le.ServiceName.DrmService, function(We) {
              return We.maybeWaitForDrmLicense(ke, He);
            }, Promise.resolve());
          }, xe.prototype.addSegmentFromQueueToMse = function(ke) {
            var Le = this;
            if (!this.mse)
              return Promise.resolve();
            var He = Promise.resolve();
            this.isMSEOpen() || (He = this.reOpenMse());
            var We = this.getHeadOfQueue(ke);
            if (!We)
              return Promise.resolve();
            var Xe = We.getRepresentationId().representationId, Qe = We.getUrl();
            return this.context.logger.debug("[MSERenderer][".concat(ke, "][").concat(Xe, "] Scheduling appendage to buffer [url=").concat(Qe, "], DRM key ID (").concat(We.getDrmKid(), ")")), He.then(function() {
              return Le.maybeWaitForDrmLicense(We);
            }).then(function() {
              return Le.mse ? Le.segmentQueues[ke].includes(We) ? Le.mse.addToBuffer(We).then(function() {
                var tt = Le.getHeadOfQueue(ke) !== We;
                if (Le.logger.debug("[MSERenderer][".concat(ke, "][").concat(Xe, "] Appended segment to buffer [url=").concat(Qe, "]")), tt) {
                  var Je = Le.segmentQueues[ke][0], Ge = Je ? Je.getUrl() : "none";
                  Le.logger.debug("[MSERenderer][".concat(ke, "][").concat(Xe, "] Skipping removal of [url=").concat(Qe, "] ") + "from segment queue as the queue head has unexpectedly changed to [url=".concat(Ge, "]"));
                } else
                  Le.segmentQueues[ke].shift();
                Le.drmService && Le.hasDataInSourceBuffers() && !(0, $e.isSwitchingBufferBlocks)((0, me.getSourceStore)(Le.context)) && Le.drmService.signalInitDataShouldBeAvailable();
              }) : (Le.logger.debug("[MSERenderer][".concat(ke, "][").concat(Xe, "] Segment ").concat(We.getUrl(), " no longer part of the queue - skipping appendage")), Promise.resolve()) : Promise.reject(ce.SOURCE_BUFFER_APPEND_STATUS.FAILURE);
            }).catch(function(tt) {
              if (Le.logger.debug("[MSERenderer][".concat(ke, "][").concat(Xe, "] Adding segment from queue to buffer failed"), tt), tt === ce.SOURCE_BUFFER_APPEND_STATUS.FAILURE && Le.trackRendererError(We), Le.mse && tt === ce.SOURCE_BUFFER_APPEND_STATUS.QUOTA_EXCEEDED) {
                Le.quotaExceededMap.set(ke, !0);
                var Je = Le.quotaExceededDeferredMap.get(ke);
                return Je || (Je = new ye.Deferred(), Le.quotaExceededDeferredMap.set(ke, Je)), Le.mse.addOneUpdateEndCallback(ke, Je.resolve).then(function() {
                  Le.quotaExceededDeferredMap.delete(ke), Le.context.logger.debug("Appending segment after quota has been exceeded...");
                }), Je.promise.then(function() {
                  return Le.processSegmentQueues();
                });
              }
              return Le.mse ? Le.mse.queueActionOnBuffer(ke, function() {
                return Le.processSegmentQueues();
              }) : Promise.reject(tt);
            });
          }, xe.prototype.cancelSetCurrentTimeDelayed = function() {
            this.setCurrentTimeDelayedContext && (this.context.logger.debug("Cancelling delayed set currentTime to ".concat(this.setCurrentTimeDelayedContext.time)), this.setCurrentTimeDelayedContext.unsubscribeFromSourceStore(), this.setCurrentTimeDelayedContext.deferred.reject("cancelled seek"), this.setCurrentTimeDelayedContext = void 0);
          }, xe.prototype.recoverFromExceededQuota = function(ke) {
            var Le = this;
            this.segmentQueueMimeTypes.forEach(function(He) {
              Le.segmentQueues[He] = Le.segmentQueues[He].filter(function(We) {
                return We.getPlaybackTime() + We.getDuration() >= ke;
              }), Le.updateRendererRangesInStore(He), Le.quotaExceededMap.set(He, !1);
            }), this.quotaExceededDeferredMap.forEach(function(He) {
              return He.reject();
            }), this.quotaExceededDeferredMap.clear();
          }, xe.prototype.resolvePendingEndOfStream = function() {
            this.setEndOfStreamDeferred && (this.setEndOfStreamDeferred.resolve(), this.setEndOfStreamDeferred = void 0);
          }, xe.prototype.setCurrentTimeInternal = function(ke) {
            var Le = this;
            if (!this.mse)
              return Promise.reject("Couldn't set current time, MSE is not open");
            Re(this.quotaExceededMap, function(We) {
              return We;
            }) && this.recoverFromExceededQuota(ke);
            var He = this.mse.waitForBuffers().then(function() {
              return Le.waitingForSeekedPromise;
            }).then(function() {
              if (Le.setCurrentTimeContext) {
                if (Le.setCurrentTimeContext.time !== ke)
                  return Promise.reject("A newer setting of change time has been scheduled.");
              } else
                Le.setCurrentTimeContext = { time: ke, isInitialSeek: !1, promise: He };
              var We = Le.adjustTimeToNextCommonBufferStart(ke);
              return isNaN(We) ? Le.waitForDataInBuffer(ke) : We;
            }).then(function(We) {
              var Xe, Qe, tt, Je, Ge = (Qe = (Xe = Le.video) === null || Xe === void 0 ? void 0 : Xe.currentTime) !== null && Qe !== void 0 ? Qe : 0, Ye = !Le.isPaused();
              return !((tt = Le.setCurrentTimeContext) === null || tt === void 0) && tt.isInitialSeek && Ye && Ge > We ? (Le.logger.debug("Skip initial seek to ".concat(We, " as playback has started and is already at ").concat(Ge)), Je = Promise.resolve(Ge)) : (Le.logger.debug("set time on video element to ".concat(We)), Je = Le.seekOnVideoElement(We)), Je.then(function(ze) {
                return Le.resolvePendingEndOfStream(), ze;
              }).catch(function(ze) {
                return Le.handleVideoSetCurrentTimeError(We, ze);
              }).finally(function() {
                Le.waitingForSeekedPromise = null, Le.setCurrentTimeContext = void 0, Le.savedCurrentTime = 0;
              });
            });
            return He;
          }, xe.prototype.waitForDataInBuffer = function(ke) {
            var Le = this;
            this.context.logger.debug("Delaying seek, waiting for data in buffer for time ".concat(ke));
            var He = (0, me.getSourceStore)(this.context);
            if (!He)
              return Promise.reject(new Error("No source store available"));
            var We = new ye.Deferred(), Xe = function() {
              var tt = Le.adjustTimeToNextCommonBufferStart(ke);
              isNaN(tt) ? Le.context.logger.debug("Re-evaluated delayed seek to ".concat(ke, ": Cannot yet resolve, waiting for data in buffer")) : (Qe(), Le.context.logger.debug("Re-evaluated delayed seek to ".concat(ke, ": Resolving with seek target ").concat(tt)), Le.setCurrentTimeDelayedContext = void 0, We.resolve(tt));
            }, Qe = (0, fe.subscribe)(He)(function(tt) {
              return (0, we.getBufferState)(tt);
            }, function() {
              var tt;
              (tt = Le.setCurrentTimeDelayedContext) === null || tt === void 0 || tt.reevaluateDataInBuffer();
            }, function(tt, Je) {
              return !!(tt != null && tt.isLoadingRangeFinished && !(Je != null && Je.isLoadingRangeFinished));
            });
            return this.setCurrentTimeDelayedContext = { time: ke, reevaluateDataInBuffer: Xe, deferred: We, unsubscribeFromSourceStore: Qe }, We.promise;
          }, xe.prototype.handleVideoSetCurrentTimeError = function(ke, Le) {
            return this.logger.debug("failed to set current time", Le), this.waitingForSeekedPromise = null, this.setCurrentTimeInternal(ke);
          }, xe.prototype.seekOnVideoElement = function(ke) {
            var Le = this;
            return this.waitingForSeekedPromise = new Promise(function(He, We) {
              Le.video ? (Le.video.currentTime = ke, He(Le.video.currentTime)) : We("No video reference");
            }), this.waitingForSeekedPromise;
          }, xe.prototype.saveCurrentTime = function() {
            this.setCurrentTimeContext ? this.savedCurrentTime = this.setCurrentTimeContext.time : this.savedCurrentTime = this.getCurrentVideoTime();
          }, xe.prototype.recreateSourceBuffers = function(ke) {
            var Le = this;
            return ke === void 0 && (ke = this.getCurrentTime()), this.shutdown(!1).then(function() {
              return Le.ready();
            }).then(function() {
              Le.sourceBufferMimeCodecMap.forEach(function(He, We) {
                Le.addBuffer(He, We) || (Le.context.logger.debug("Failed to create source buffer ".concat(He)), Le.sourceBufferMimeCodecMap.remove(He));
              });
            }).then(function() {
              Le.setCurrentTime(ke).then(function() {
                var He, We;
                return !((We = (He = Le.context.serviceManager) === null || He === void 0 ? void 0 : He.get(le.ServiceName.PlayerStateService)) === null || We === void 0) && We.isPlaying() ? Le.play() : Promise.resolve();
              });
            });
          }, xe.prototype.updateSegmentQueueMimeType = function(ke) {
            var Le, He = this, We = Ce.MimeTypeHelper.getMediaType(ke);
            this.segmentQueueMimeTypes.forEach(function(Xe) {
              var Qe;
              Ce.MimeTypeHelper.getMediaType(Xe) === We && (delete He.segmentQueues[Xe], (Qe = (0, me.getSourceStore)(He.context)) === null || Qe === void 0 || Qe.dispatch((0, Ee.setRendererRanges)(Xe, [])));
            }), this.segmentQueues[ke] = [], (Le = (0, me.getSourceStore)(this.context)) === null || Le === void 0 || Le.dispatch((0, Ee.setRendererRanges)(ke, []));
          }, xe.prototype.changeBufferType = function(ke, Le) {
            var He = this;
            return this.sourceBufferMimeCodecMap.update(ke, Le), this.updateSegmentQueueMimeType(ke), this.mse && this.mse.isChangeTypeSupported() ? this.mse.changeBufferType(ke, Le).then(function() {
              var We;
              return (We = {})[ke] = Le, We;
            }).catch(function(We) {
              return He.logger.debug("Failed to change buffer type to ".concat(ke, " ").concat(Le, ":"), We), He.recreateSourceBuffers().then(function() {
                return He.sourceBufferMimeCodecMap.entries();
              });
            }) : this.recreateSourceBuffers().then(function() {
              return He.sourceBufferMimeCodecMap.entries();
            });
          }, xe.prototype.shouldContinueBuffering = function() {
            var ke, Le;
            return (Le = (ke = this.mse) === null || ke === void 0 ? void 0 : ke.shouldContinueBuffering) !== null && Le !== void 0 && Le;
          }, xe;
        }();
        function Re(xe, ke) {
          var Le = !1;
          return xe.forEach(function(He) {
            return Le = Le || ke(He);
          }), Le;
        }
        function Ne(xe, ke) {
          return Object.keys(xe).map(function(Le) {
            return xe[Le].find(function(He) {
              return (0, ae.isInTimeRanges)([He], ke);
            });
          }).filter(Ie.isDefined);
        }
        ne.MSERenderer = Ue;
      }, 23729: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.BufferMimeCodecMap = void 0;
        var ae = ie(27517), ce = ie(76650), he = ie(28819), _e = ie(8272), le = ie(27177), se = ie(79814), oe = function() {
          function be(ve, me) {
            this.mimeCodeMap = {}, this.store = ve, this.settings = me;
          }
          return be.prototype.ensureMetricsForMimeType = function(ve) {
            var me, pe, fe = (me = this.store) === null || me === void 0 ? void 0 : me.getState();
            (0, ae.isInstanceState)(fe) && ue(this.settings) && ((0, he.getMetricsState)(fe)[ve] || (pe = this.store) === null || pe === void 0 || pe.dispatch((0, ce.initializeMetricsForMimeType)(ve, this.settings)));
          }, be.prototype.removeMetrics = function(ve) {
            var me;
            (me = this.store) === null || me === void 0 || me.dispatch((0, ce.removeMetricsForMimeType)(ve));
          }, be.prototype.add = function(ve, me) {
            var pe;
            this.mimeCodeMap[ve] = me, this.ensureMetricsForMimeType(ve), (pe = this.store) === null || pe === void 0 || pe.dispatch((0, ce.addMetricsValue)(ve, _e.MetricType.StalledSeconds, 0));
          }, be.prototype.remove = function(ve) {
            var me = this, pe = se.MimeTypeHelper.getMediaType(ve);
            Object.keys(this.mimeCodeMap).forEach(function(fe) {
              se.MimeTypeHelper.getMediaType(fe) === pe && (me.removeMetrics(fe), delete me.mimeCodeMap[fe]);
            });
          }, be.prototype.has = function(ve, me) {
            var pe = this, fe = se.MimeTypeHelper.getMediaType(ve), ge = se.MimeTypeHelper.extractContainerType(ve);
            return Object.keys(this.mimeCodeMap).some(function(ye) {
              var $e = se.MimeTypeHelper.getMediaType(ye), Se = se.MimeTypeHelper.extractContainerType(ye);
              return $e === fe && Se === ge && me === pe.mimeCodeMap[ve];
            });
          }, be.prototype.update = function(ve, me) {
            this.remove(ve), this.add(ve, me);
          }, be.prototype.forEach = function(ve) {
            var me = this;
            Object.keys(this.entries()).forEach(function(pe) {
              return ve(pe, me.entries()[pe]);
            });
          }, be.prototype.entries = function() {
            return this.mimeCodeMap;
          }, be.prototype.dispose = function() {
            this.mimeCodeMap = {}, this.store = void 0, this.settings = void 0;
          }, be;
        }();
        ne.BufferMimeCodecMap = oe;
        var ue = function(be) {
          return (0, le.isObject)(be);
        };
      }, 24869: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SourceBufferWrapper = void 0;
        var ae = ie(10981), ce = ie(63916), he = function() {
          function le(se, oe) {
            var ue = this;
            this.onBufferedRangesChanged = oe, this.onUpdateSuccess = function() {
              ue.updateExposedBufferRanges(), ue.onBufferedRangesChanged(ue.bufferedRanges), ue.cleanUpPendingUpdateEndedPromises(function(be) {
                return be.resolve();
              });
            }, this.onUpdateError = function(be) {
              ue.cleanUpPendingUpdateEndedPromises(function(ve) {
                return ve.reject(be);
              });
            }, this.ready = function() {
              return ue.buffer.updating ? ue.onUpdateEnded() : Promise.resolve();
            }, this.buffer = se, this.bufferedRanges = [], this.queuePromise = Promise.resolve(), this.pendingUpdateEndedPromises = new ce.LinkedListQueue(), ["error", "abort", "sourceended", "sourceclose"].forEach(function(be) {
              ue.buffer.addEventListener(be, ue.onUpdateError);
            }), this.buffer.addEventListener("updateend", this.onUpdateSuccess);
          }
          return le.prototype.cleanUpPendingUpdateEndedPromises = function(se) {
            for (var oe; (oe = this.pendingUpdateEndedPromises.dequeue()) != null; )
              se(oe);
          }, le.prototype.updateExposedBufferRanges = function() {
            try {
              this.bufferedRanges = _e(this.buffer.buffered);
            } catch {
            }
          }, le.prototype.onUpdateEnded = function() {
            var se = new ae.Deferred();
            return this.pendingUpdateEndedPromises.enqueue(se), se.promise;
          }, le.prototype.queueAction = function(se) {
            var oe = this, ue = this.queuePromise.then(function() {
              return oe.ready();
            }).then(function() {
              return Promise.resolve(se()).then(function() {
                return oe.ready();
              });
            });
            return this.queuePromise = ue.catch(function() {
            }), ue;
          }, le.prototype.changeType = function(se) {
            this.buffer.changeType(se);
          }, le.prototype.dispose = function() {
            var se = this;
            ["error", "abort", "sourceended", "sourceclose"].forEach(function(oe) {
              se.buffer.removeEventListener(oe, se.onUpdateError);
            }), this.cleanUpPendingUpdateEndedPromises(function(oe) {
              return oe.reject("disposing source buffer");
            }), this.buffer.removeEventListener("updateend", this.onUpdateSuccess);
          }, le;
        }();
        function _e(le) {
          for (var se = [], oe = 0; oe < le.length; oe++)
            se.push({ start: le.start(oe), end: le.end(oe) });
          return se;
        }
        ne.SourceBufferWrapper = he;
      }, 27838: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MSERendererModuleDefinition = void 0;
        var ae = ie(16368), ce = ie(6863), he = ie(58765), _e = ie(89413), le = ie(98758);
        ne.MSERendererModuleDefinition = { name: ae.ModuleName.RendererMse, module: { MSEWrapper: he.MSEWrapper, MSERenderer: ce.MSERenderer, Ranges: _e.Ranges, technologyChecker: new le.TechnologyChecker() } }, ne.default = ne.MSERendererModuleDefinition;
      }, 58765: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ae) {
            for (var Oe, Be = 1, Ve = arguments.length; Be < Ve; Be++)
              for (var Ue in Oe = arguments[Be])
                Object.prototype.hasOwnProperty.call(Oe, Ue) && (Ae[Ue] = Oe[Ue]);
            return Ae;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MSEWrapper = ne.MediaSourceReadyState = void 0;
        var ce, he = ie(52442), _e = ie(25550), le = ie(28764), se = ie(63546), oe = ie(35148), ue = ie(62510), be = ie(58935), ve = ie(11399), me = ie(96873), pe = ie(60627), fe = ie(27279), ge = ie(13533), ye = ie(10981), $e = ie(79814), Se = ie(56435), Ce = ie(70016), Ie = ie(61878), Te = ie(73904), Ee = ie(24869), we = ie(1504);
        (function(Ae) {
          Ae.closed = "closed", Ae.open = "open", Ae.ended = "ended";
        })(ce || (ne.MediaSourceReadyState = ce = {}));
        var Pe = function() {
          function Ae(Oe) {
            var Be = this;
            this.postBufferRemoval = function(Ve, Ue, Re) {
              Be.logger.debug("successfully removed buffer for ".concat(Ve, " (from  ").concat(Ue, " to ").concat(Re, ")"));
            }, this.waitForBuffer = function(Ve) {
              return Be.sourceBuffers.hasOwnProperty(Ve) ? Be.mseReady().then(function() {
                return Be.sourceBuffers[Ve].ready();
              }) : Promise.reject("No SourceBuffer for '".concat(Ve, "' available"));
            }, this.startStreaming = function() {
              Be.logger.debug("[MSEWrapper][ManagedMediaSource] Start Streaming received, resuming loading"), Be.shouldContinueStreaming = !0;
            }, this.endStreaming = function() {
              Be.logger.debug("[MSEWrapper][ManagedMediaSource] Stop Streaming received, stopping loading"), Be.shouldContinueStreaming = !1;
            }, this.bufferedChange = function(Ve) {
              Be.logger.isLevelEnabled(be.LogLevel.DEBUG) && Be.logger.debug("Received bufferedChange event, Added Ranges: ".concat(Me(Ve.addedRanges), ", Removed Ranges: ").concat(Me(Ve.removedRanges)));
            }, Oe.videoElement && (this.context = Oe, this.logger = Oe.logger, this.video = Oe.videoElement, this.sourceBuffers = {}, this.isInit = !1, this.teardownInProgressPromise = Promise.resolve(), this.shouldContinueStreaming = !0);
          }
          return Ae.prototype.getBufferedRanges = function(Oe) {
            return this.sourceBuffers.hasOwnProperty(Oe) ? this.sourceBuffers[Oe].bufferedRanges : [];
          }, Ae.prototype.printDetailedBufferRange = function(Oe, Be) {
            var Ve;
            try {
              Ve = Oe.buffered;
            } catch {
              return void this.logger.debug("".concat(Be, " buffer range: Error accessing buffered ranges"));
            }
            if (Ve.length !== 0)
              for (var Ue = 0; Ue < Ve.length; Ue++)
                this.logger.debug("".concat(Be, " buffer range [").concat(Ue, "]: ").concat(Ve.start(Ue), " - ").concat(Ve.end(Ue)));
            else
              this.logger.debug("".concat(Be, " buffer range: empty"));
          }, Ae.prototype.getBufferStartTime = function() {
            var Oe = this, Be = Object.keys(this.sourceBuffers).map(function(Ve) {
              return Oe.sourceBuffers[Ve].bufferedRanges.length === 0 ? 0 : Oe.sourceBuffers[Ve].bufferedRanges[0].start;
            });
            return Math.max.apply(null, Be);
          }, Ae.prototype.addBuffer = function(Oe, Be, Ve) {
            var Ue = this;
            if (this.mediaSource) {
              if (this.isInit && !this.sourceBuffers.hasOwnProperty(Oe))
                try {
                  var Re = this.mediaSource.addSourceBuffer(Oe + "; codecs=" + Be);
                  this.sourceBuffers[Oe] = new Ee.SourceBufferWrapper(Re, function(Ne) {
                    Ve(Ne), Ue.context.logger.isLevelEnabled(be.LogLevel.DEBUG) && Ue.printDetailedBufferRange(Re, Oe);
                  });
                } catch (Ne) {
                  return this.logger.debug("Could not add SourceBuffer for " + Oe + " with codecs " + Be + ":" + Ne), void this.context.eventHandler.dispatchEvent(ue.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.SOURCE_CODEC_OR_FILE_FORMAT_NOT_SUPPORTED));
                }
              return this.logger.debug("Added SourceBuffer for " + Oe + " with codecs " + Be), isNaN(this.mediaSource.duration) || (this.sourceBuffers[Oe].appendWindowEnd = this.mediaSource.duration), this.sourceBuffers[Oe].buffer;
            }
          }, Ae.prototype.updateTimestampOffset = function(Oe, Be) {
            var Ve = this.sourceBuffers[Oe];
            Ve && (this.logger.debug("setting new source buffer [".concat(Oe, "] offset from ").concat(Ve.buffer.timestampOffset, " to ").concat(Be)), Ve.buffer.timestampOffset = Be);
          }, Ae.prototype.setTimestampOffset = function(Oe, Be) {
            return this.sourceBuffers.hasOwnProperty(Oe) ? (Be && !isNaN(Be) || (this.logger.debug("source buffer [".concat(Oe, "] offset is ").concat(Be, ", setting it to 0")), Be = 0), this.queueTimestampOffsetUpdate(Oe, Be)) : (this.logger.debug("no such source buffer found (mime type=".concat(Oe, ")")), Promise.resolve());
          }, Ae.prototype.queueTimestampOffsetUpdate = function(Oe, Be) {
            var Ve = this;
            return this.queueActionOnBuffer(Oe, function() {
              return Ve.updateTimestampOffset(Oe, Be);
            }).catch(function(Ue) {
              Ve.logger.debug("Failed to set timestamp offset for", Oe, ":", Ue);
            });
          }, Ae.prototype.getBufferRangeStart = function(Oe, Be) {
            return Be || Oe.start(0);
          }, Ae.prototype.getBufferRangeEnd = function(Oe, Be) {
            return Be || Oe.end(Oe.length - 1);
          }, Ae.prototype.getBufferRemovalRange = function(Oe, Be, Ve) {
            var Ue = this.sourceBuffers[Oe].buffer.buffered;
            return { start: this.getBufferRangeStart(Ue, Be), end: this.getBufferRangeEnd(Ue, Ve) };
          }, Ae.prototype.preBufferRemoval = function(Oe, Be, Ve) {
            this.logger.debug("removing buffer for ".concat(Oe, " (from ").concat(Be, " to ").concat(Ve, ")"));
          }, Ae.prototype.removeBufferRange = function(Oe, Be, Ve) {
            this.preBufferRemoval(Oe, Be, Ve), this.sourceBuffers[Oe].buffer.remove(Be, Ve);
          }, Ae.prototype.removeFromBuffer = function(Oe, Be, Ve, Ue) {
            var Re = this;
            return Ue === void 0 && (Ue = this.postBufferRemoval), this.queueActionOnBuffer(Oe, function() {
              var Ne, xe, ke;
              try {
                if (Re.video && Re.video.currentTime >= 0 && ((ke = (xe = (Ne = Re.sourceBuffers[Oe]) === null || Ne === void 0 ? void 0 : Ne.buffer) === null || xe === void 0 ? void 0 : xe.buffered) === null || ke === void 0 ? void 0 : ke.length) > 0) {
                  var Le = Re.getBufferRemovalRange(Oe, Be, Ve), He = Le.start, We = Le.end;
                  if (He >= 0 && We > He) {
                    if (Re.sourceBuffers[Oe].removalPending = !0, Re.sourceBuffers[Oe].rangePendingRemoval = { start: He, end: We }, !Re.mediaSource || Re.mediaSource.readyState === ce.open) {
                      var Xe = Re.sourceBuffers[Oe].onUpdateEnded().then(function() {
                        Re.sourceBuffers[Oe] && (Re.sourceBuffers[Oe].rangePendingRemoval = null, Re.sourceBuffers[Oe].removalPending = !1, Ue(Oe, He, We));
                      });
                      return Re.removeBufferRange(Oe, He, We), Xe;
                    }
                    Re.logger.debug("cannot remove buffer for ".concat(Oe, " (from ").concat(He, " to ").concat(We, "): MediaSource is not open")), Re.addOneSourceOpenCallback(function() {
                      Re.removeFromBuffer(Oe, He, We, Ue).catch(function(tt) {
                        Re.logger.debug("Couldn't remove buffer from ".concat(He, " to ").concat(We, " for ").concat(Oe), tt);
                      });
                    });
                  } else
                    Re.logger.debug("Ignoring buffer clearing request for ".concat(Oe, ", as the passed-in range is not valid: ").concat(He, " to ").concat(We));
                } else
                  Re.logger.debug("Ignoring buffer clearing request for ".concat(Oe, ", as there are no buffered ranges."));
              } catch (tt) {
                var Qe = "".concat(oe.WarningCode[oe.WarningCode.PLAYBACK_WARNING], ": Buffer clearing failed for ").concat(Oe, ". Exception: ").concat(JSON.stringify(tt));
                Re.context.eventHandler.dispatchEvent(ue.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.PLAYBACK_WARNING, Qe));
              }
              return Promise.resolve();
            });
          }, Ae.prototype.removeBuffer = function(Oe) {
            var Be = this, Ve = Promise.resolve(), Ue = this.sourceBuffers[Oe];
            if (!Ue || !this.mediaSource)
              return Ve;
            if (this.isMediaSourceOpen())
              try {
                Ue == null || Ue.buffer.abort();
              } catch (Re) {
                return this.logger.debug("Could not abort last action on buffer", ae({}, Re)), Promise.resolve();
              }
            if ($e.MimeTypeHelper.isSubtitle(Oe))
              Ve = Ve.then(function() {
                return Be.removeFromBuffer(Oe).catch(function(Re) {
                  Be.logger.debug("Error removing buffer data", Re);
                });
              });
            else
              try {
                this.mediaSource && this.mediaSource.removeSourceBuffer(Ue.buffer);
              } catch (Re) {
                this.logger.debug("Error while trying to remove ".concat(Oe, " source buffer."), Re);
              }
            return this.deleteSourceBuffer(Oe), Ve;
          }, Ae.prototype.deleteSourceBuffer = function(Oe) {
            this.sourceBuffers[Oe] ? (this.sourceBuffers[Oe].dispose(), delete this.sourceBuffers[Oe], this.logger.debug("Removed SourceBuffer for ".concat(Oe))) : this.logger.debug("No source buffer to remove for mimeType=".concat(Oe));
          }, Ae.prototype.isMediaSourceOpen = function() {
            var Oe;
            return ((Oe = this.mediaSource) === null || Oe === void 0 ? void 0 : Oe.readyState) === ce.open;
          }, Ae.prototype.resetAllBuffers = function() {
            var Oe = this;
            if (!this.mediaSource)
              return this.logger.debug("Media source is removed. Can not reset buffers."), Promise.resolve();
            var Be = [];
            for (var Ve in this.sourceBuffers)
              this.sourceBuffers.hasOwnProperty(Ve) && Be.push(this.removeBuffer(Ve));
            return Promise.all(Be).then(function() {
              Oe.sourceBuffers = {}, Oe.logger.debug("Removed all SourceBuffers");
            });
          }, Ae.prototype.tearDownMediaSource = function() {
            var Oe = this;
            return this.teardownInProgressPromise = this.teardownInProgressPromise.then(function() {
              return Oe.resetAllBuffers();
            }).then(function() {
              Oe.mediaSource ? Oe.detachVideoElementAndMSE() : Oe.logger.debug("Media source has already been removed.");
            }), this.teardownInProgressPromise;
          }, Ae.prototype.detachVideoElementAndMSE = function() {
            var Oe;
            if (this.video)
              if (this.video.getWrappedElement() !== null) {
                var Be = (0, Te.getMseObjectUrl)((0, fe.getSourceState)(this.context));
                if (typeof ((Oe = window == null ? void 0 : window.URL) === null || Oe === void 0 ? void 0 : Oe.revokeObjectURL) == "function" && Be !== "")
                  try {
                    window.URL.revokeObjectURL(Be);
                  } catch {
                    this.logger.debug("Could not revoke MSE object URL");
                  }
                this.mediaSource && (this.mediaSource.removeEventListener("startstreaming", this.startStreaming), this.mediaSource.removeEventListener("endstreaming", this.endStreaming), this.mediaSource.removeEventListener("bufferedchange", this.bufferedChange)), this.mediaSourceReadyDeferred && this.mediaSourceReadyDeferred.reject("MediaSource is being destroyed."), this.mediaSourceReadyDeferred = void 0, this.mediaSourceReadyPromise = void 0, Be === this.video.src && (Ie.VideoElementUtil.removeSource(this.video), this.video.load()), this.mediaSource = void 0, this.isInit = !1, this.logger.debug("Detached video element and MSE");
              } else
                this.logger.debug("No video element to teardown.");
            else
              this.logger.debug("No video wrapper to teardown.");
          }, Ae.prototype.removeUpdateEndCallback = function(Oe, Be) {
            this.sourceBuffers.hasOwnProperty(Oe) && this.sourceBuffers[Oe].buffer.removeEventListener("updateend", Be);
          }, Ae.prototype.addUpdateEndCallback = function(Oe, Be) {
            this.sourceBuffers.hasOwnProperty(Oe) && this.sourceBuffers[Oe].buffer.addEventListener("updateend", Be);
          }, Ae.prototype.addOneUpdateEndCallback = function(Oe, Be) {
            return this.sourceBuffers[Oe].onUpdateEnded().catch(function() {
            }).then(Be);
          }, Ae.prototype.addSourceOpenCallback = function(Oe) {
            this.mediaSource && this.mediaSource.addEventListener("sourceopen", Oe);
          }, Ae.prototype.removeSourceOpenCallback = function(Oe) {
            this.mediaSource && this.mediaSource.removeEventListener("sourceopen", Oe);
          }, Ae.prototype.addOneSourceOpenCallback = function(Oe) {
            var Be = this, Ve = function(Ue) {
              Be.removeSourceOpenCallback(Ve), Oe(Ue);
            };
            this.addSourceOpenCallback(Ve);
          }, Ae.prototype.isAnyBufferUpdating = function() {
            var Oe = this;
            return Object.keys(this.sourceBuffers).filter(function(Be) {
              return Oe.sourceBuffers[Be].buffer.updating;
            }).length !== 0;
          }, Ae.prototype.setDuration = function(Oe) {
            var Be = this;
            this.queueActionOnBuffers(function() {
              if (Be.mediaSource) {
                var Ve = (0, Ce.isNumber)(Oe) && Oe > 0 ? Oe : 1 / 0;
                Ve === 1 / 0 && Be.context.settings.MAX_SAFE_MSE_DURATION !== 1 / 0 && (0, Ce.isNumber)(Be.context.settings.MAX_SAFE_MSE_DURATION) && Be.context.settings.MAX_SAFE_MSE_DURATION > 0 && (Ve = Be.context.settings.MAX_SAFE_MSE_DURATION), Be.mediaSource.duration !== Ve && (Be.isMediaSourceOpen() ? (Be.logger.debug("Setting video duration on MSE: ".concat(Be.mediaSource.duration, " -> ").concat(Ve)), Be.mediaSource.duration = Ve) : Be.logger.debug("Skipping setDuration (".concat(Be.mediaSource.duration, " -> ").concat(Ve, "), MSE is not open")));
              } else
                Be.logger.debug("Skipping setDuration (".concat(Oe, "), MSE is gone"));
            }).catch(function(Ve) {
              Be.logger.debug("Could not set the duration of the MSE!", Ve);
            });
          }, Ae.prototype.getDuration = function() {
            return this.mediaSource && !isNaN(this.mediaSource.duration) ? this.mediaSource.duration : 0;
          }, Ae.prototype.isInitialized = function() {
            return this.isInit;
          }, Object.defineProperty(Ae.prototype, "readyState", { get: function() {
            return this.mediaSource ? this.mediaSource.readyState : void 0;
          }, enumerable: !1, configurable: !0 }), Ae.prototype.isBufferRemovalPending = function() {
            var Oe = this;
            return Object.keys(this.sourceBuffers).some(function(Be) {
              return Oe.sourceBuffers[Be].removalPending;
            });
          }, Ae.prototype.getRangePendingRemoval = function(Oe) {
            var Be, Ve, Ue;
            return (Ue = (Ve = (Be = this.sourceBuffers) === null || Be === void 0 ? void 0 : Be[Oe]) === null || Ve === void 0 ? void 0 : Ve.rangePendingRemoval) !== null && Ue !== void 0 ? Ue : void 0;
          }, Ae.prototype.getBufferSizeInSeconds = function(Oe) {
            return this.getBufferedRanges(Oe).reduce(function(Be, Ve) {
              return Be + (Ve.end - Ve.start);
            }, 0);
          }, Ae.prototype.addToBuffer = function(Oe) {
            var Be = this, Ve = Oe.getMimeType();
            return this.queueActionOnBuffer(Ve, function() {
              if (!Be.mediaSource)
                return Be.logger.debug("Could not queue action on SourceBuffer: MediaSource has been destroyed"), Promise.reject(he.SOURCE_BUFFER_APPEND_STATUS.FAILURE);
              if (Be.mediaSource.readyState !== ce.open)
                return Be.logger.warn("MediaSource is not open (readyState=" + Be.mediaSource.readyState + ")"), Promise.reject(he.SOURCE_BUFFER_APPEND_STATUS.FAILURE);
              if (!Be.sourceBuffers.hasOwnProperty(Ve))
                return Be.logger.log("sourceBuffers has no entry for " + Ve), Promise.reject(he.SOURCE_BUFFER_APPEND_STATUS.FAILURE);
              var Ue = Oe.getRepresentationId().representationId;
              try {
                Be.logger.debug("[MSEWrapper][".concat(Ve, "][").concat(Ue, "] Adding segment to SourceBuffer [").concat(Oe.getUrl(), "]"));
                var Re = Be.sourceBuffers[Ve];
                return Re.buffer.appendBuffer(Oe.getData()), Re.onUpdateEnded();
              } catch (Ne) {
                return Be.logger.debug("[MSEWrapper][".concat(Ve, "][").concat(Ue, "] appendBuffer() failed"), Ne), Ne.name && Ne.name === "QuotaExceededError" ? (Be.logger.debug("QuotaExceededError, trying to remove old data from buffers..."), Be.context.store.dispatch((0, me.setBufferMaxSize)(Ve, Be.getBufferSizeInSeconds(Ve))), Promise.reject(he.SOURCE_BUFFER_APPEND_STATUS.QUOTA_EXCEEDED)) : (Be.video && Be.video.error || Be.context.eventHandler.fireError(new le.PlayerError(_e.ErrorCode.UNKNOWN, { exception: Ne, codec: Oe.getCodec(), mimeType: Ve, segmentUrl: Oe.getUrl() }, "Unexpected error while attempting to append a segment to the SourceBuffer.")), Be.logger.debug("[MSEWrapper][".concat(Ve, "][").concat(Ue, "] Failed appending segment to SourceBuffer"), Ne), Promise.reject(he.SOURCE_BUFFER_APPEND_STATUS.FAILURE));
              }
            });
          }, Ae.prototype.endOfStream = function() {
            var Oe = this;
            return this.queueActionOnBuffers(function() {
              var Be;
              Oe.isMediaSourceOpen() ? (Oe.logger.debug("Signaled mse end of stream"), (Be = Oe.mediaSource) === null || Be === void 0 || Be.endOfStream()) : Oe.logger.debug("Skipped signaling EOS as the mse is not open");
            }).catch(function(Be) {
              Oe.logger.debug("Unable to signal EOS on media source", Be);
            });
          }, Ae.prototype.waitForBuffers = function() {
            var Oe = Object.keys(this.sourceBuffers).map(this.waitForBuffer);
            return this.mseReady().then(function() {
              return Promise.all(Oe).then(function() {
              });
            });
          }, Ae.prototype.queueActionOnBuffers = function(Oe) {
            var Be = this, Ve = new Promise(function(Ue, Re) {
              var Ne = Object.keys(Be.sourceBuffers).map(function(xe) {
                var ke = Be.queueActionOnBuffer(xe, function() {
                });
                return Be.queueActionOnBuffer(xe, function() {
                  return Ve;
                }).then().catch(), ke;
              });
              Promise.all(Ne).then(function() {
                return Ue();
              }, Re);
            }).then(function() {
              return Oe();
            }).then(function() {
              return Promise.all(Object.keys(Be.sourceBuffers).map(function(Ue) {
                return Be.sourceBuffers[Ue].ready();
              })).then(function() {
              });
            });
            return Ve;
          }, Ae.prototype.queueActionOnBuffer = function(Oe, Be) {
            return this.sourceBuffers.hasOwnProperty(Oe) ? this.sourceBuffers[Oe].queueAction(Be) : Promise.reject("No SourceBuffer for '".concat(Oe, "' available"));
          }, Ae.prototype.rejectMediaSourceReady = function(Oe) {
            var Be, Ve = this;
            return (Be = this.mediaSourceReadyDeferred) === null || Be === void 0 || Be.reject(Oe), this.mediaSourceReadyPromise ? this.mediaSourceReadyPromise.then(function() {
              Ve.mediaSourceReadyDeferred = void 0;
            }) : Promise.reject(Oe);
          }, Ae.prototype.mseReady = function() {
            var Oe, Be = this;
            if (this.mediaSourceReadyPromise)
              return this.mediaSourceReadyPromise;
            this.mediaSourceReadyDeferred = new ye.Deferred(), this.mediaSourceReadyPromise = this.mediaSourceReadyDeferred.promise;
            var Ve = function(xe) {
              var ke;
              Re(), (ke = Be.mediaSourceReadyDeferred) === null || ke === void 0 || ke.reject(xe);
            }, Ue = function() {
              var xe;
              Re(), Be.isInit = !0, Be.isUsingManagedMediaSource || (Be.shouldContinueStreaming = !0), (xe = Be.mediaSourceReadyDeferred) === null || xe === void 0 || xe.resolve();
            }, Re = function() {
              Be.mediaSource && (Be.mediaSource.removeEventListener("error", Ve), Be.mediaSource.removeEventListener("sourceopen", Ue), Be.mediaSource.removeEventListener("webkitsourceopen", Ue));
            };
            if (!this.video)
              return this.rejectMediaSourceReady("Could not set source to video element");
            if (!this.mediaSource)
              return this.rejectMediaSourceReady("mediaSource must not be null or undefined");
            if (this.mediaSource.addEventListener("error", Ve), this.mediaSource.addEventListener("sourceopen", Ue, !1), this.mediaSource.addEventListener("webkitsourceopen", Ue, !1), this.isUsingManagedMediaSource && (this.video.disableRemotePlayback = !0, this.mediaSource.addEventListener("startstreaming", this.startStreaming), this.mediaSource.addEventListener("endstreaming", this.endStreaming), this.mediaSource.addEventListener("bufferedchange", this.bufferedChange)), window && window.URL && typeof window.URL.createObjectURL == "function") {
              var Ne = window.URL.createObjectURL(this.mediaSource);
              this.video.src = Ne, (Oe = (0, fe.getSourceStore)(this.context)) === null || Oe === void 0 || Oe.dispatch((0, pe.setMseObjectUrl)(Ne));
            } else
              this.logger.debug("Could not use window.URL.createObjectURL(mediaSource) as the browser claims the function does not exist."), this.mediaSourceReadyDeferred.reject("Could not create Object URL");
            return this.mediaSourceReadyPromise.then(function() {
              Be.mediaSourceReadyDeferred = void 0;
            });
          }, Object.defineProperty(Ae.prototype, "shouldContinueBuffering", { get: function() {
            return this.shouldContinueStreaming;
          }, enumerable: !1, configurable: !0 }), Ae.prototype.createNewMSE = function() {
            var Oe = this;
            return this.mediaSource ? this.tearDownMediaSource().then(function() {
              return Oe.setNewMediaSource();
            }) : this.teardownInProgressPromise.then(function() {
              return Oe.setNewMediaSource();
            });
          }, Ae.prototype.setNewMediaSource = function() {
            return this.isUsingManagedMediaSource = (0, we.shouldUseManagedMediaSource)(this.context.settings.PREFER_MANAGED_MEDIA_SOURCE), this.isUsingManagedMediaSource ? (this.logger.debug("[MSEWrapper] Using ManagedMediaSource"), this.mediaSource = new window.ManagedMediaSource()) : (this.logger.debug("[MSEWrapper] Using MediaSource"), this.mediaSource = new window.MediaSource()), this.mseReady();
          }, Ae.prototype.isChangeTypeSupported = function() {
            var Oe, Be, Ve = (0, ge.getCapabilities)(), Ue = Ve.isWebOS && Ve[ve.CapabilityKey.webOSChromiumVersion] >= Se.WEBOS_2021_CHROMIUM_VERSION;
            return !!(!((Be = (Oe = window.SourceBuffer) === null || Oe === void 0 ? void 0 : Oe.prototype) === null || Be === void 0) && Be.changeType) && !(0, ge.getCapabilities)().isTizen && !Ue;
          }, Ae.prototype.updateSourceBufferKey = function(Oe) {
            var Be = this, Ve = $e.MimeTypeHelper.getMediaType(Oe), Ue = Object.keys(this.sourceBuffers).find(function(Re) {
              var Ne = $e.MimeTypeHelper.getMediaType(Re);
              return Be.sourceBuffers.hasOwnProperty(Re) && Ne === Ve && Re !== Oe;
            });
            Ue && (this.sourceBuffers[Oe] = this.sourceBuffers[Ue], delete this.sourceBuffers[Ue]);
          }, Ae.prototype.changeBufferType = function(Oe, Be) {
            var Ve = this;
            return this.updateSourceBufferKey(Oe), this.queueActionOnBuffer(Oe, function() {
              Ve.sourceBuffers[Oe].changeType("".concat(Oe, "; codecs=").concat(Be)), Ve.context.logger.debug("Changed ".concat(Oe, " SourceBuffer type with codec=").concat(Be));
            });
          }, Ae.prototype.dispose = function() {
            var Oe = this;
            this.tearDownMediaSource().then(function() {
              Oe.video = void 0;
            });
          }, Ae;
        }();
        function Me(Ae) {
          for (var Oe = [], Be = 0; Be < (Ae == null ? void 0 : Ae.length); Be++) {
            var Ve = "[".concat(Ae.start(Be), " - ").concat(Ae.end(Be), "]");
            Oe.push(Ve);
          }
          return Oe.toString();
        }
        ne.MSEWrapper = Pe;
      }, 63916: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.LinkedListQueue = void 0;
        var ie = function() {
          function ce(he) {
            this.value = he;
          }
          return ce;
        }(), ae = function() {
          function ce() {
            this.count = 0;
          }
          return Object.defineProperty(ce.prototype, "length", { get: function() {
            return this.count;
          }, enumerable: !1, configurable: !0 }), ce.prototype.dequeue = function() {
            if (this.count !== 0) {
              var he = this.last;
              return this.last = he == null ? void 0 : he.previous, he && (he.previous = void 0, he.next = void 0), this.count--, he == null ? void 0 : he.value;
            }
          }, ce.prototype.enqueue = function(he) {
            if (this.count === 0) {
              var _e = new ie(he);
              this.first = _e, this.last = _e;
            } else {
              var le = this.first;
              this.first = new ie(he), this.first.next = le, le && (le.previous = this.first);
            }
            this.count++;
          }, ce.prototype.isEmpty = function() {
            return this.length === 0;
          }, ce;
        }();
        ne.LinkedListQueue = ae;
      }, 66697: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getBufferEndSafetyMargin = se;
        var ae = ie(94304), ce = ie(13533), he = ie(56435), _e = 0.25, le = 1.25;
        function se(oe) {
          var ue = (0, ce.getCapabilities)(), be = ue.isChromium, ve = ue.isChrome, me = ue.isVizio, pe = ue.isWebOS, fe = ue.isPlayStation4;
          if (pe || me || (0, he.isTizen2018)() || (0, he.isTizen2019)() || fe)
            return le;
          var ge = (oe == null ? void 0 : oe.usedKeySystem.kind) === ae.KeySystemKind.PLAYREADY;
          return be && !ve && ge ? le : _e;
        }
      }, 72566: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.findNextRangeForGap = ce;
        var ae = ie(89413);
        function ce(he, _e) {
          for (var le = !1, se = 1 / 0, oe = 0; oe < _e.length; oe++) {
            var ue = _e.start(oe), be = _e.end(oe), ve = he + 2 * ae.Ranges.TIME_FUDGE_FACTOR;
            if (le && !isFinite(se)) {
              se = ue;
              break;
            }
            ue < he && be > he && ve > be && (le = !0);
          }
          return { isNearEndOfBufferedRange: le, nextRangeStart: se };
        }
      }, 73904: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getMseObjectUrl = void 0;
        var ie = function(ae) {
          var ce, he;
          return (he = (ce = ae == null ? void 0 : ae.renderer) === null || ce === void 0 ? void 0 : ce.mseObjectUrl) !== null && he !== void 0 ? he : "";
        };
        ne.getMseObjectUrl = ie;
      }, 76316: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.VideoEventHandler = void 0;
        var ie = function() {
          function ae(ce) {
            var he = this;
            this.addTimeToEvent = function(_e) {
              return _e.time = he.video && he.video.currentTime || 0, _e;
            }, this.video = ce;
          }
          return ae.prototype.on = function(ce, he) {
            this.video && this.video.addEventListener(ce, he, this.addTimeToEvent);
          }, ae.prototype.off = function(ce, he) {
            this.video && this.video.removeEventListener(ce, he);
          }, ae.prototype.fire = function(ce, he) {
            this.video && this.video.eventHandler.triggerEvent(ce, he);
          }, ae.prototype.dispose = function() {
          }, ae;
        }();
        ne.VideoEventHandler = ie;
      }, 89413: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.Ranges = void 0;
        var ie = function() {
          function ae() {
          }
          return ae.filterRanges = function(ce, he) {
            var _e = [];
            if (ce && ce.length)
              for (var le = 0; le < ce.length; le++)
                he(ce.start(le), ce.end(le)) && _e.push([ce.start(le), ce.end(le)]);
            return ae.createTimeRanges(_e);
          }, ae.createTimeRangesObj = function(ce) {
            return ce === void 0 || ce.length === 0 ? { length: 0, start: function() {
              return 0;
            }, end: function() {
              return 0;
            } } : { length: ce.length, start: function(he) {
              return ce[he][0];
            }, end: function(he) {
              return ce[he][1];
            } };
          }, ae.createTimeRanges = function(ce, he) {
            return Array.isArray(ce) ? ae.createTimeRangesObj(ce) : ce === void 0 || he === void 0 ? ae.createTimeRangesObj() : ae.createTimeRangesObj([[ce, he]]);
          }, ae.findNextRange = function(ce, he) {
            return ae.filterRanges(ce, function(_e, le) {
              return _e - ae.TIME_FUDGE_FACTOR >= he && le - _e > ae.MIN_RANGE_DURATION;
            });
          }, ae.findGaps = function(ce, he) {
            if (ce.length < 2)
              return ae.createTimeRanges();
            for (var _e = [], le = 1; le < ce.length; le++) {
              var se = ce.end(le - 1), oe = ce.start(le);
              oe - se > he && _e.push([se, oe]);
            }
            return ae.createTimeRanges(_e);
          }, ae.findRangeForTime = function(ce, he) {
            return ae.filterRanges(ce, function(_e, le) {
              return _e <= he && le >= he;
            });
          }, ae.TIME_FUDGE_FACTOR = 1 / 30, ae.MIN_RANGE_DURATION = 0.2, ae;
        }();
        ne.Ranges = ie;
      }, 93159: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.GapHandler = void 0;
        var ae = ie(62510), ce = ie(11399), he = ie(27517), _e = ie(58975), le = ie(13533), se = ie(79814), oe = ie(26905), ue = ie(46462), be = ie(72566), ve = ie(89413), me = [ue.MediaElementEvent.seeking, ue.MediaElementEvent.seeked, ue.MediaElementEvent.pause, ue.MediaElementEvent.playing, ue.MediaElementEvent.error], pe = 5, fe = 10, ge = 250, ye = 0.01, $e = function() {
          function Pe(Me) {
            var Ae, Oe, Be, Ve, Ue, Re = this;
            this.isExecutingGapSkipping = !1, this.play = function() {
              Re.lastPlayEventTimestamp = Date.now();
            }, this.checkIfWaiting = function() {
              if (!Re.context.isDisposed && Re.video !== void 0) {
                var Le = Re.video.paused, He = Re.video.seeking, We = Re.isAtEndOfBufferedRange(Re.video.currentTime), Xe = Re.hasRecentlyTrackedTimeupdateEvent(), Qe = Re.hasRecentlyStartedPlayback();
                Le || He && !We || Xe || (Re.consecutiveWaiting++, Qe || Re.waiting());
              }
            }, this.waiting = function() {
              var Le, He = Re.context.store.getState();
              if ((0, he.isInstanceState)(He) && Re.video) {
                var We = (0, _e.getPlayerState)(He);
                ((0, _e.getIsSeeking)(We) || !((Le = Re.video) === null || Le === void 0) && Le.seeking) && !Re.isAtEndOfBufferedRange(Re.video.currentTime) || Re.setTimer();
              }
            }, this.stalled = function() {
              Re.setTimer();
            }, this.onSeek = function() {
              Re.gapAhead = void 0;
            }, this.timeupdate = function() {
              if (Re.lastTimeupdate = Date.now(), Re.video && !Re.video.paused && !Re.video.seeking) {
                Re.hasPlayedAnythingYet = !0;
                var Le = Re.context.renderer.getCurrentTime(!0);
                if (Re.shouldSkipGap(Le))
                  Re.skipTheGapProactively();
                else {
                  var He = Re.context.renderer.getVideoElementBufferedRanges();
                  if (He.length > 1 && !Re.gapAhead) {
                    var We = Re.context.settings.MIN_SIZE_FOR_GAP_SKIPPING;
                    Re.gapAhead = Te(He, Le, We);
                  } else
                    Re.shouldTriggerWaitingEvent(Le) ? (Re.consecutiveUpdates++, Re.waiting()) : Le === Re.lastRecordedTime ? Re.consecutiveUpdates++ : (Re.consecutiveUpdates = 0, Re.consecutiveWaiting = 0, Re.lastRecordedTime = Le);
                }
              }
            }, this.cancelTimer = function() {
              Re.consecutiveUpdates = 0, Re.consecutiveWaiting = 0, clearTimeout(Re.timer), Re.timer = -1;
            }, this.skipTheGap = function(Le) {
              if (Re.video && !Re.isExecutingGapSkipping) {
                var He = Re.context.renderer.getVideoElementBufferedRanges().sort(function(tt, Je) {
                  return tt.start - Je.start;
                }), We = Re.context.renderer.getCurrentTime(!0), Xe = Ee(He, We);
                if (Re.consecutiveUpdates = 0, Re.consecutiveWaiting = 0, Re.timer = -1, Xe !== void 0 && We === Le) {
                  var Qe = Xe.start;
                  Re.context.logger.debug("Skipping gap from ".concat(We, " to ").concat(Qe)), Re.executeGapSkipping(We, Qe);
                }
              }
            }, this.context = Me, this.video = Me.videoElement, this.lastTimeupdate = 0, this.consecutiveUpdates = 0, this.consecutiveWaiting = 0, this.lastPlayEventTimestamp = 0, this.hasPlayedAnythingYet = !1, this.gapAhead = void 0, (Ae = this.video) === null || Ae === void 0 || Ae.addEventListener(ue.MediaElementEvent.waiting, this.waiting), (Oe = this.video) === null || Oe === void 0 || Oe.addEventListener(ue.MediaElementEvent.stalled, this.stalled), (Be = this.video) === null || Be === void 0 || Be.addEventListener(ue.MediaElementEvent.timeupdate, this.timeupdate), (Ve = this.video) === null || Ve === void 0 || Ve.addEventListener(ue.MediaElementEvent.play, this.play), this.context.eventHandler.on(ae.PlayerEvent.Seek, this.onSeek);
            for (var Ne = 0, xe = me; Ne < xe.length; Ne++) {
              var ke = xe[Ne];
              (Ue = this.video) === null || Ue === void 0 || Ue.addEventListener(ke, this.cancelTimer);
            }
            this.timeupdateIntervalId = window.setInterval(this.checkIfWaiting, ge);
          }
          return Pe.prototype.hasRecentlyStartedPlayback = function() {
            return Date.now() - this.lastPlayEventTimestamp < 2 * ge;
          }, Pe.prototype.hasRecentlyTrackedTimeupdateEvent = function() {
            return Date.now() - this.lastTimeupdate <= 1e3;
          }, Pe.prototype.shouldSkipGap = function(Me) {
            return !(!this.gapAhead || this.isExecutingGapSkipping) && (Se(Me, this.gapAhead) || Ce(this.context.settings.PROACTIVE_GAP_SKIP_DISTANCE_SECONDS, Me, this.gapAhead) || Ie(Me, this.gapAhead));
          }, Pe.prototype.shouldTriggerWaitingEvent = function(Me) {
            return this.consecutiveUpdates === pe && Me === this.lastRecordedTime;
          }, Pe.prototype.skipTheGapProactively = function() {
            if (this.video && this.gapAhead) {
              var Me = this.context.renderer.getCurrentTime(!0), Ae = Math.max(Me + ye, this.gapAhead.end);
              this.context.logger.debug("Skipping gap proactively from ".concat(Me, " to ").concat(Ae)), this.executeGapSkipping(Me, Ae);
            }
          }, Pe.prototype.executeGapSkipping = function(Me, Ae) {
            var Oe = this;
            this.isExecutingGapSkipping = !0, this.gapAhead = void 0, this.maybeRemoveVideoBufferData(Me, Ae).then(function() {
              return Oe.context.renderer.setCurrentTime(Ae + ve.Ranges.TIME_FUDGE_FACTOR);
            }).then(function(Be) {
              return Oe.context.logger.debug("Jumped buffer gap from ".concat(Me, " to ").concat(Be));
            }).catch(function(Be) {
              return Oe.context.logger.debug("Failed to skip buffer gap from ".concat(Me, " to ").concat(Ae), Be);
            }).finally(function() {
              Oe.isExecutingGapSkipping = !1, Oe.gapAhead = void 0;
            });
          }, Pe.prototype.maybeRemoveVideoBufferData = function(Me, Ae) {
            if (!(0, le.getCapabilities)().isTizen)
              return Promise.resolve();
            var Oe = this.getVideoMimeType();
            if (Oe === void 0)
              return Promise.resolve();
            var Be = Ee(this.context.renderer.getBufferedRanges(Oe).sort(function(Ve, Ue) {
              return Ve.start - Ue.start;
            }), Me);
            return Ae !== (Be == null ? void 0 : Be.start) ? (this.context.logger.debug("Clearing video data from ".concat(Me, " to ").concat(Ae, " to ensure gap can be skipped")), this.context.renderer.removeData(Oe, Me, Ae)) : Promise.resolve();
          }, Pe.prototype.getVideoMimeType = function() {
            var Me;
            return (Me = this.context.segmentInfoService) === null || Me === void 0 ? void 0 : Me.getSegmentControllerMimeTypes().find(function(Ae) {
              return se.MimeTypeHelper.isVideo(Ae);
            });
          }, Pe.prototype.gapFromVideoUnderflow = function(Me, Ae, Oe) {
            for (var Be = ve.Ranges.findGaps(Me, Oe), Ve = 0; Ve < Be.length; Ve++) {
              var Ue = Be.start(Ve), Re = Be.end(Ve);
              if (Ae - Ue < 4 && Ae - Ue > 2)
                return { start: Ue, end: Re };
            }
          }, Pe.prototype.setTimer = function() {
            if (!(this.timer > -1) && this.hasPlayedAnythingYet && this.video) {
              var Me = this.video.buffered, Ae = this.video.currentTime, Oe = ve.Ranges.findNextRange(Me, Ae), Be = this.context.settings.MIN_SIZE_FOR_GAP_SKIPPING;
              if (Oe.length === 0) {
                var Ve = this.gapFromVideoUnderflow(Me, Ae, Be);
                if (Ve)
                  return this.context.logger.debug("Encountered a gap in video from ".concat(Ve.start, " to ").concat(Ve.end, ". Seeking to ").concat(Ae, "...")), this.consecutiveWaiting = 0, void this.setCurrentTime(Ae);
                var Ue = (0, be.findNextRangeForGap)(Ae, Me), Re = Ue.isNearEndOfBufferedRange, Ne = Ue.nextRangeStart;
                return Re && isFinite(Ne) ? (this.context.logger.debug("Playback stalled because of a very small gap. Seeking to ".concat(Ne, "...")), this.consecutiveWaiting = 0, void this.setCurrentTime(Ne)) : void (this.consecutiveWaiting > fe && (this.consecutiveWaiting = 0, this.triggerCurrentTimeNotAdvancing(Ae, this.video)));
              }
              if (!we(Me, Ae, Be)) {
                var xe = Oe.start(0) - Ae;
                this.context.logger.debug("setTimer: stopped at: ".concat(Ae, ", setting timer for: ").concat(xe, ", seeking to: ").concat(Oe.start(0))), this.timer = window.setTimeout(this.skipTheGap.bind(this), xe, this.context.renderer.getCurrentTime(!0));
              }
            }
          }, Pe.prototype.triggerCurrentTimeNotAdvancing = function(Me, Ae) {
            this.context.logger.debug("currentTime not advancing from ".concat(Me, " although the video element is neither paused nor seeking")), this.maybePokeVideoElement(Me, Ae), Ae.eventHandler.triggerEvent(ue.MediaElementEvent.currenttimenotadvancing);
          }, Pe.prototype.maybePokeVideoElement = function(Me, Ae) {
            if (Me > Ae.duration && !(0, le.getCapabilities)().isSafari)
              this.setCurrentTime(Ae.duration);
            else if (this.context.settings.QJY_BROWSER_WORKAROUND || (0, le.getCapabilities)().isTizen)
              this.setCurrentTime(Me + ye);
            else {
              var Oe = (0, le.getCapabilities)()[ce.CapabilityKey.isPlayStation5];
              this.setCurrentTime(Me, Oe);
            }
          }, Pe.prototype.isAtEndOfBufferedRange = function(Me) {
            if (!this.video)
              return !1;
            for (var Ae = this.video.buffered, Oe = 0; Oe < Ae.length; Oe++)
              if (Ae.end(Oe) === Me)
                return !0;
            return !1;
          }, Pe.prototype.shutdown = function() {
            var Me, Ae, Oe, Be, Ve;
            (Me = this.video) === null || Me === void 0 || Me.removeEventListener(ue.MediaElementEvent.waiting, this.waiting), (Ae = this.video) === null || Ae === void 0 || Ae.removeEventListener(ue.MediaElementEvent.stalled, this.stalled), (Oe = this.video) === null || Oe === void 0 || Oe.removeEventListener(ue.MediaElementEvent.timeupdate, this.timeupdate), (Be = this.video) === null || Be === void 0 || Be.removeEventListener(ue.MediaElementEvent.play, this.play), this.context.eventHandler.off(ae.PlayerEvent.Seek, this.onSeek);
            for (var Ue = 0, Re = me; Ue < Re.length; Ue++) {
              var Ne = Re[Ue];
              (Ve = this.video) === null || Ve === void 0 || Ve.removeEventListener(Ne, this.cancelTimer);
            }
            clearInterval(this.timeupdateIntervalId), this.cancelTimer();
          }, Pe.prototype.setCurrentTime = function(Me, Ae) {
            if (Ae === void 0 && (Ae = !1), this.video && (this.video.currentTime !== Me || Ae))
              try {
                this.video.currentTime = Me;
              } catch (Oe) {
                this.context.logger.debug("GapHandler failed to set currentTime on video element to ".concat(Me), Oe);
              }
          }, Pe;
        }();
        function Se(Pe, Me) {
          return Pe > Me.start && Pe < Me.end;
        }
        function Ce(Pe, Me, Ae) {
          return !(Pe <= 0) && Ae.start > Me && Ae.start - Pe < Me;
        }
        function Ie(Pe, Me) {
          return Pe > Me.end && (0, oe.shouldResetCurrentTimeAfterBufferUnderrun)();
        }
        function Te(Pe, Me, Ae) {
          for (var Oe = 0; Oe < Pe.length - 1; Oe++) {
            var Be = Pe[Oe].end, Ve = Pe[Oe + 1].start;
            if (Be > Me && Ve > Be && Ve - Be >= Ae)
              return { start: Be, end: Ve };
          }
        }
        function Ee(Pe, Me) {
          return Pe.find(function(Ae) {
            return Ae.start - ve.Ranges.TIME_FUDGE_FACTOR >= Me;
          });
        }
        function we(Pe, Me, Ae) {
          if (Ae === 0)
            return !1;
          var Oe = ve.Ranges.findNextRange(Pe, Me);
          if (Oe.length === 0)
            return !1;
          var Be = ve.Ranges.findRangeForTime(Pe, Me), Ve = Be.length ? Be.end(0) : Me;
          return Oe.start(0) - Ve < Ae;
        }
        ne.GapHandler = $e;
      }, 98758: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.TechnologyChecker = void 0;
        var ae = ie(33696), ce = function() {
          function he() {
          }
          return he.prototype.getSupportedTechnologies = function() {
            return [{ player: ae.PlayerType.Html5, streaming: ae.StreamType.Dash }, { player: ae.PlayerType.Html5, streaming: ae.StreamType.Hls }, { player: ae.PlayerType.Html5, streaming: ae.StreamType.Smooth }];
          }, he;
        }();
        ne.TechnologyChecker = ce;
      } }, function(ee) {
        return function(ne) {
          return ee(ee.s = ne);
        }(27838);
      }]);
    });
  })();
})(bitmovinplayerMserenderer);
var bitmovinplayerMserendererExports = bitmovinplayerMserenderer.exports;
const MSERendererModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerMserendererExports);
var bitmovinplayerSubtitles = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ne) {
      re.exports = ne();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[482], { 8679: function(ee, ne) {
        var ie;
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SubtitleType = void 0, function(ae) {
          ae[ae.EXTERNAL_FILE = 0] = "EXTERNAL_FILE", ae[ae.FRAGMENTED = 1] = "FRAGMENTED", ae[ae.IN_STREAM = 2] = "IN_STREAM";
        }(ie || (ne.SubtitleType = ie = {}));
      }, 10842: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ee) {
            for (var we, Pe = 1, Me = arguments.length; Pe < Me; Pe++)
              for (var Ae in we = arguments[Pe])
                Object.prototype.hasOwnProperty.call(we, Ae) && (Ee[Ae] = we[Ae]);
            return Ee;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SubtitleService = void 0;
        var ce = ie(18665), he = ie(60997), _e = ie(62510), le = ie(76650), se = ie(3464), oe = ie(79814), ue = ie(54838), be = ie(91520), ve = ie(16368), me = ie(57042), pe = ie(29495), fe = ie(59272), ge = ie(68466), ye = ie(45684), $e = ie(14200), Se = ie(8679), Ce = ie(24855), Ie = function() {
          function Ee(we) {
            var Pe = this;
            this.context = we, this.getTransmuxer = function() {
              return Pe.transmuxer;
            }, this.onDiscontinuitySequenceNumberChanged = function() {
              Pe.resetCaptionExtractor();
            }, this.onSeek = function(Me) {
              Pe.resetCaptionExtractor(), Pe.timeBeforeSeek = Me.position;
            }, this.onSeeked = function() {
              var Me, Ae = (Me = Pe.timeBeforeSeek) !== null && Me !== void 0 ? Me : 0, Oe = Pe.context.internalPlayer.getCurrentTime();
              Object.values(Pe.subtitleHandlers).forEach(function(Be) {
                return Be.seek(Ae, Oe);
              }), Pe.forcedSubtitleController.seek(Ae, Oe);
            }, this.handlePeriodUpdate = function(Me, Ae) {
              Pe.context.logger.debug("Switching periods in subtitleService");
              var Oe = Pe.manifestService.findPeriod(Me);
              Oe ? (Pe.adjustSubtitleHandlersForNewPeriod(Me, Ae), Pe.setupControllersForNextPeriod(Oe), Pe.reactivateAfterSwitched()) : Pe.context.logger.log("Can not find period with id = ".concat(Me, " in Manifest. Skipping period update"));
            }, this.reset = function() {
              Object.keys(Pe.subtitleHandlers).forEach(function(Me) {
                return Pe.subtitleHandlers[Me].dispose();
              }), Pe.subtitleHandlers = {}, Pe.cea608Extractor && (Pe.cea608Extractor.dispose(), Pe.cea608Extractor = void 0), Pe.discontinuitySequenceNumberTracker && Pe.discontinuitySequenceNumberTracker.reset();
            }, this.subtitleHandlers = {}, this.eventHandler = we.eventHandler, this.manifestService = we.serviceManager.get(ce.ServiceName.ManifestService, we.sourceContext.sourceIdentifier), this.enabledSubtitlesTracker = new pe.EnabledSubtitlesTracker(), this.forcedSubtitleController = new fe.ForcedSubtitleController(), this.eventHandler.on(_e.PlayerEvent.Seek, this.onSeek), this.eventHandler.on(_e.PlayerEvent.TimeShift, this.onSeek), this.eventHandler.on(_e.PlayerEvent.Seeked, this.onSeeked), this.eventHandler.on(_e.PlayerEvent.TimeShifted, this.onSeeked), this.eventHandler.on(_e.PlayerEvent.SourceUnloaded, this.reset), this.subscribeToPeriodSwitch();
          }
          return Ee.prototype.shouldReactToPeriodUpdate = function(we, Pe) {
            var Me = we !== Pe, Ae = this.manifestService.isHlsManifest() && !(Pe || !we);
            return Me || Ae;
          }, Ee.prototype.subscribeToPeriodSwitch = function() {
            var we = this, Pe = this.context.serviceManager.get(ce.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
            this.unsubscibeFromPeriodSwitch = (0, se.subscribe)(Pe)(be.ModuleManager.get(ve.ModuleName.EngineBitmovin).selectors.getPlayingPeriodId, this.handlePeriodUpdate, function(Me, Ae) {
              return we.shouldReactToPeriodUpdate(Me, Ae);
            });
          }, Ee.prototype.setupControllersForNextPeriod = function(we) {
            var Pe = this, Me = be.ModuleManager.get(ve.ModuleName.EngineBitmovin).getMimeTypeForAdaptationSet;
            we.AdaptationSet.forEach(function(Ae) {
              var Oe = Me(Ae);
              (0, Ce.isSubtitleTrack)(Oe, Pe.manifestService.isHlsManifest()) && Pe.setupControllerForSubtitleAdaptationSet(Ae, Oe);
            });
          }, Ee.prototype.setupControllerForSubtitleAdaptationSet = function(we, Pe) {
            if ((0, Ce.isFragmentedAdaptationSet)(we))
              return this.context.store.dispatch((0, le.initializeMetricsForMimeType)(Pe, this.context.settings)), void this.addFragmentedSubtitleTrack(we, Pe);
            this.addExternalSubtitleTrack(we, Pe);
          }, Ee.prototype.addFragmentedSubtitleTrack = function(we, Pe) {
            var Me = this.context.sourceContext.sourceIdentifier, Ae = this.context.serviceManager.get(ce.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
            if (Ae) {
              var Oe = { mimeType: Pe, codec: be.ModuleManager.get(ve.ModuleName.EngineBitmovin).getCodecsFromAdaptationSet(we), isHls: this.manifestService.isHlsManifest(), manifestLoader: this.context.serviceManager.get(ce.ServiceName.ManifestLoadingService, Me), periodId: we._internalId.periodId, sourceStore: Ae };
              this.addFragmentSubtitle(Oe, we);
            }
          }, Ee.prototype.addExternalSubtitleTrack = function(we, Pe) {
            if (be.ModuleManager.has(ve.ModuleName.DASH)) {
              var Me = new (be.ModuleManager.get(ve.ModuleName.DASH)).SegmentTemplateMPDHandler(this.context), Ae = this.manifestService.toSubtitleTrack(we, Pe);
              Me.setAdaptationSetId(we._internalId), Ae.url = Me.getSubtitleUrl().toString(), this.addExternalSubtitle(Ae, we);
            }
          }, Ee.prototype.setTransmuxer = function(we) {
            this.transmuxer = we;
          }, Ee.prototype.hasSubtitle = function(we) {
            return !!this.subtitleHandlers[we];
          }, Ee.prototype.enableSubtitle = function(we) {
            var Pe = this, Me = this.subtitleHandlers[we];
            return Me && !Me.isActive() ? Me.activate().then(function() {
              Me.refresh(), Pe.forcedSubtitleController.deactivate();
            }).then(function() {
              return Pe.enabledSubtitlesTracker.addSubtitle(Me.getSubtitle()), !0;
            }).catch(function(Ae) {
              return Pe.context.logger.debug("Error during subtitle activation", Ae), !1;
            }) : Promise.resolve(!1);
          }, Ee.prototype.addExternalSubtitle = function(we, Pe) {
            if (Pe === void 0 && (Pe = null), we.id || (we.id = we.url), this.getExistingExternalSubtitleHandler(we, Pe))
              return we;
            var Me = new ye.ExternalFileSubtitleHandler(this.context, we, Pe);
            return this.reactivateHandler(Me), we;
          }, Ee.prototype.getExistingExternalSubtitleHandler = function(we, Pe) {
            var Me, Ae, Oe = this.subtitleHandlers[we.id], Be = (Me = Oe == null ? void 0 : Oe.periodId) !== null && Me !== void 0 ? Me : null, Ve = (Ae = Pe == null ? void 0 : Pe._internalId.periodId) !== null && Ae !== void 0 ? Ae : null;
            return Oe && Be === Ve ? Oe : this.forcedSubtitleController.getForcedSubtitleHandler(function(Ue) {
              var Re, Ne = Ue.getSubtitle().id === we.id, xe = ((Re = Ue.periodId) !== null && Re !== void 0 ? Re : null) === Ve;
              return Ne && xe;
            });
          }, Ee.prototype.reactivateHandler = function(we) {
            var Pe = we.getSubtitle(), Me = this.context.config.playback.isForcedSubtitle;
            if (typeof Me == "function" ? (0, ue.safeUserCallback)(function() {
              return Me(Pe);
            }, this.context.logger) : Pe.forced)
              this.forcedSubtitleController.addSubtitleHandler(we);
            else {
              var Ae = !1, Oe = Pe.id;
              this.subtitleHandlers[Oe] && (Ae = this.subtitleHandlers[Oe].isActive(), this.removeSubtitleHandler(Oe)), this.addSubtitleHandler(we), Ae && we.activate();
            }
          }, Ee.prototype.addSubtitleHandler = function(we) {
            var Pe = we.getSubtitle();
            this.applyLabelFunctionForSubtitle(Pe), this.subtitleHandlers[Pe.id] = we, this.signalNewSubtitle(Pe);
          }, Ee.prototype.applyLabelFunctionForSubtitle = function(we) {
            var Pe, Me, Ae = this.context.sourceContext.source.labeling, Oe = this.manifestService.isHlsManifest() ? (Pe = Ae == null ? void 0 : Ae.hls) === null || Pe === void 0 ? void 0 : Pe.subtitles : (Me = Ae == null ? void 0 : Ae.dash) === null || Me === void 0 ? void 0 : Me.subtitles;
            typeof Oe == "function" && (we.label = (0, ue.safeUserCallback)(function() {
              return Oe(we);
            }, this.context.logger));
          }, Ee.prototype.addFragmentSubtitle = function(we, Pe) {
            if (!be.ModuleManager.has(ve.ModuleName.EngineBitmovin))
              return this.context.logger.warn("Unable to add fragmented subtitles because MSE Module is missing"), null;
            var Me = this.manifestService.toSubtitleTrack(Pe, we.mimeType);
            Me.isFragmented = !0, Me.url = null;
            var Ae = new $e.FragmentedSubtitleHandler(this.context, we, Me, this.getTransmuxer);
            return this.reactivateHandler(Ae), Me;
          }, Ee.prototype.setupCea608CaptionExtractor = function(we) {
            var Pe;
            if (!be.ModuleManager.has(ve.ModuleName.SubtitlesCEA608))
              return this.eventHandler.dispatchEvent(_e.PlayerEvent.Warning, new me.PlayerModuleMissingWarning(ve.ModuleName.SubtitlesCEA608, "The ".concat(ve.ModuleName.SubtitlesCEA608, " module is required to parse CEA captions."))), this.context.logger.log("CEA Caption parsing is disabled, because the Cea680 module is not loaded"), null;
            if (!be.ModuleManager.has(ve.ModuleName.ContainerMP4))
              return this.eventHandler.dispatchEvent(_e.PlayerEvent.Warning, new me.PlayerModuleMissingWarning(ve.ModuleName.ContainerMP4, "The ".concat(ve.ModuleName.ContainerMP4, " module is required to parse CEA captions."))), this.context.logger.log("CEA Caption parsing is disabled, because the ContainerMP4 module is not loaded"), null;
            this.cea608Extractor && this.cea608Extractor.dispose();
            var Me = be.ModuleManager.get(ve.ModuleName.ContainerMP4), Ae = be.ModuleManager.get(ve.ModuleName.SubtitlesCEA608).Cea608Extractor;
            return this.cea608Extractor = new Ae(we, Me, (Pe = this.context.config.tweaks) === null || Pe === void 0 ? void 0 : Pe.parse_cea_708_caption), this.cea608Extractor;
          }, Ee.prototype.resetCaptionExtractor = function() {
            this.cea608Extractor && (this.context.logger.debug("Resetting CEA caption extractor..."), this.cea608Extractor.reset());
          }, Ee.prototype.createDiscontinuitySequenceNumberTracker = function() {
            var we = be.ModuleManager.get(ve.ModuleName.HLS);
            this.discontinuitySequenceNumberTracker = new we.DiscontinuitySequenceNumberTracker(oe.MimeTypeHelper.isVideo), this.discontinuitySequenceNumberTracker.subscribe(this.onDiscontinuitySequenceNumberChanged);
          }, Ee.prototype.trackDiscontinuitySequenceNumber = function(we) {
            this.discontinuitySequenceNumberTracker || this.createDiscontinuitySequenceNumberTracker(), this.discontinuitySequenceNumberTracker.trackSegment(we);
          }, Ee.prototype.shouldDiscontinuitySequenceNumberBeTracked = function() {
            return this.manifestService.getManifest() && this.manifestService.isHlsManifest() && be.ModuleManager.has(ve.ModuleName.HLS);
          }, Ee.prototype.handleClosedCaptions = function(we, Pe, Me, Ae, Oe) {
            return Oe === void 0 && (Oe = ""), !Ae && oe.MimeTypeHelper.isVideo(Pe.getMimeType()) && Oe.toLowerCase().includes("avc") ? this.extractCaptionsFromSegment(Pe, we.getTimestampOffset()) : (this.addClosedCaptions(Me, Pe.getPeriodId()), Promise.resolve());
          }, Ee.prototype.extractCaptionsFromSegment = function(we, Pe) {
            var Me = this;
            return this.cea608Extractor ? (this.shouldDiscontinuitySequenceNumberBeTracked() && this.trackDiscontinuitySequenceNumber(we), this.cea608Extractor.extract(we).then(function(Ae) {
              Te(Ae, Pe), Ae.length > 0 && (Me.context.logger.insane("Extracted Closed Captions from fMP4: " + JSON.stringify(Ae)), Me.addClosedCaptions(Ae, we.getPeriodId()));
            }).catch(function(Ae) {
              var Oe;
              Ae instanceof me.PlayerModuleMissingWarning ? ((Oe = Me.cea608Extractor) === null || Oe === void 0 || Oe.dispose(), Me.cea608Extractor = void 0, Me.eventHandler.dispatchEvent(_e.PlayerEvent.Warning, Ae)) : Me.context.logger.debug("Error parsing CEA-608 Captions from fMP4: " + Ae);
            })) : Promise.resolve();
          }, Ee.prototype.addClosedCaptions = function(we, Pe) {
            if (we && Array.isArray(we) && we.length !== 0)
              for (var Me = this.manifestService.getClosedCaptionLabels(Pe), Ae = function(Ue) {
                var Re = Ue.channel;
                if (!Oe.subtitleHandlers[Re]) {
                  var Ne = Me.find(function(xe) {
                    return xe.id === Re;
                  }) || { id: Re, kind: "captions", lang: "unknown", label: "Captions (".concat(Ue.channel, ")") };
                  Oe.addSubtitleHandler(new ge.Cea608Handler(Oe.context, Ne));
                }
                Oe.subtitleHandlers[Re].addCaption(Ue, Pe);
              }, Oe = this, Be = 0, Ve = we; Be < Ve.length; Be++)
                Ae(Ve[Be]);
          }, Ee.prototype.signalNewSubtitle = function(we) {
            this.eventHandler.dispatchEvent(_e.PlayerEvent.SubtitleAdded, { subtitle: ae({}, we) });
          }, Ee.prototype.disableSubtitle = function(we) {
            var Pe = this, Me = this.subtitleHandlers[we];
            return Me ? Me.deactivate().then(function() {
              return Pe.enabledSubtitlesTracker.removeSubtitle(we), Pe.getActiveSubtitles().length === 0 && Pe.forcedSubtitleController.activate().catch(function() {
              }), !0;
            }).catch(function() {
              return !1;
            }) : Promise.resolve(!1);
          }, Ee.prototype.disableAllSubtitles = function() {
            var we = this;
            this.getActiveSubtitles().forEach(function(Pe) {
              return we.disableSubtitle(Pe.id);
            });
          }, Ee.prototype.removeSubtitle = function(we) {
            this.removeSubtitleHandler(we), this.enabledSubtitlesTracker.removeSubtitle(we);
          }, Ee.prototype.getActiveSubtitles = function() {
            var we = this;
            return Object.keys(this.subtitleHandlers).filter(function(Pe) {
              return we.subtitleHandlers[Pe].isActive();
            }).map(function(Pe) {
              return we.subtitleHandlers[Pe].getSubtitle();
            });
          }, Ee.prototype.hasSubtitles = function() {
            return Object.keys(this.subtitleHandlers).length > 0;
          }, Ee.prototype.getAvailableSubtitles = function(we) {
            return Object.values(this.subtitleHandlers).filter(function(Pe) {
              var Me = Pe.periodId;
              return !Me || we === Me;
            }).map(function(Pe) {
              return Pe.getSubtitle();
            });
          }, Ee.prototype.enableForcedSubtitle = function(we) {
            this.forcedSubtitleController.activate(we).catch(function() {
            });
          }, Ee.prototype.shouldRemoveSubtitleHandler = function(we, Pe, Me) {
            var Ae = we.getSubtitleType() === Se.SubtitleType.FRAGMENTED && we.periodId === Me, Oe = we.getSubtitleType() === Se.SubtitleType.EXTERNAL_FILE && we.periodId && we.periodId !== Pe;
            return Ae || Oe;
          }, Ee.prototype.adjustSubtitleHandlersForNewPeriod = function(we, Pe) {
            var Me = this;
            Object.keys(this.subtitleHandlers).forEach(function(Ae) {
              var Oe = Me.subtitleHandlers[Ae];
              Me.shouldRemoveSubtitleHandler(Oe, we, Pe) && Me.removeSubtitleHandler(Ae);
            });
          }, Ee.prototype.reactivateAfterSwitched = function() {
            var we = this;
            Object.keys(this.subtitleHandlers).forEach(function(Pe) {
              var Me, Ae = we.subtitleHandlers[Pe];
              if (!Ae.isActive() && we.enabledSubtitlesTracker.shouldEnableSubtitle(Ae.getSubtitle(), we.subtitleHandlers)) {
                var Oe = { subtitle: Ae.getSubtitle() };
                (Me = we.eventHandler) === null || Me === void 0 || Me.dispatchEvent(_e.PlayerEvent.SubtitleEnable, Oe), Ae.activate().then(function() {
                  var Be;
                  (Be = we.eventHandler) === null || Be === void 0 || Be.dispatchEvent(_e.PlayerEvent.SubtitleEnabled, Oe);
                });
              }
            });
          }, Ee.prototype.removeSubtitleHandler = function(we) {
            if (this.subtitleHandlers[we]) {
              var Pe = this.subtitleHandlers[we].getSubtitle();
              this.subtitleHandlers[we].dispose(), delete this.subtitleHandlers[we], this.eventHandler && this.eventHandler.dispatchEvent(_e.PlayerEvent.SubtitleRemoved, { subtitle: Pe });
            }
          }, Ee.prototype.clearBuffersUntil = function(we) {
            var Pe = this;
            Object.keys(this.subtitleHandlers).forEach(function(Me) {
              return Pe.subtitleHandlers[Me].clearBuffersUntil(we);
            });
          }, Ee.prototype.dispose = function() {
            this.reset(), this.enabledSubtitlesTracker = (0, he.dispose)(this.enabledSubtitlesTracker), this.forcedSubtitleController = (0, he.dispose)(this.forcedSubtitleController), this.discontinuitySequenceNumberTracker = (0, he.dispose)(this.discontinuitySequenceNumberTracker), this.transmuxer = void 0, this.manifestService = null, this.eventHandler.off(_e.PlayerEvent.Seek, this.onSeek), this.eventHandler.off(_e.PlayerEvent.TimeShift, this.onSeek), this.eventHandler.off(_e.PlayerEvent.Seeked, this.onSeeked), this.eventHandler.off(_e.PlayerEvent.TimeShifted, this.onSeeked), this.eventHandler.off(_e.PlayerEvent.SourceUnloaded, this.reset), this.unsubscibeFromPeriodSwitch(), this.subtitleHandlers = {}, this.eventHandler = null;
          }, Ee;
        }();
        function Te(Ee, we) {
          Ee.forEach(function(Pe) {
            Pe.start -= we, Pe.end -= we;
          });
        }
        ne.SubtitleService = Ie;
      }, 14200: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var We = function(Xe, Qe) {
            return We = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(tt, Je) {
              tt.__proto__ = Je;
            } || function(tt, Je) {
              for (var Ge in Je)
                Object.prototype.hasOwnProperty.call(Je, Ge) && (tt[Ge] = Je[Ge]);
            }, We(Xe, Qe);
          };
          return function(Xe, Qe) {
            if (typeof Qe != "function" && Qe !== null)
              throw new TypeError("Class extends value " + String(Qe) + " is not a constructor or null");
            function tt() {
              this.constructor = Xe;
            }
            We(Xe, Qe), Xe.prototype = Qe === null ? Object.create(Qe) : (tt.prototype = Qe.prototype, new tt());
          };
        }(), ce = this && this.__assign || function() {
          return ce = Object.assign || function(We) {
            for (var Xe, Qe = 1, tt = arguments.length; Qe < tt; Qe++)
              for (var Je in Xe = arguments[Qe])
                Object.prototype.hasOwnProperty.call(Xe, Je) && (We[Je] = Xe[Je]);
            return We;
          }, ce.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.FragmentedSubtitleHandler = void 0;
        var he = ie(92712), _e = ie(18665), le = ie(62510), se = ie(33696), oe = ie(58975), ue = ie(33669), be = ie(3464), ve = ie(42283), me = ie(3941), pe = ie(79814), fe = ie(34586), ge = ie(70016), ye = ie(91520), $e = ie(16368), Se = ie(66774), Ce = ie(81253), Ie = ie(27338), Te = ie(49625), Ee = ie(8679), we = -1, Pe = function(We) {
          function Xe(Qe, tt, Je, Ge) {
            var Ye = We.call(this, Qe, Je, tt.periodId) || this;
            Ye.onSegmentDataAvailable = function(Fe) {
              var ot, vt = ke(Ye.context.serviceManager.get(_e.ServiceName.SourceStoreService, Ye.context.sourceContext.sourceIdentifier)), gt = (ot = Fe.getSegmentInfo()) === null || ot === void 0 ? void 0 : ot.discontinuitySequenceNumber;
              return gt !== void 0 && (vt = vt.then(function() {
                return Ye.waitForTransmuxerReady(gt);
              }).then(function() {
                return Ye.awaitPtoKnownForHlsDiscoSequence(gt);
              }).then(function() {
                return Ye.isActive();
              }).catch(function() {
                return !1;
              })), vt.then(function(yt) {
                Ye.removeLoadingRange(Fe), yt && Ye.processSegment(Fe);
              });
            }, Ye.onTimeUpdate = function(Fe) {
              var ot;
              if (Fe && Fe.time !== void 0) {
                var vt = Fe.time;
                Ye.clearBuffersUntil(vt);
                var gt = ((ot = Ye.streamTimeService) === null || ot === void 0 ? void 0 : ot.getTimeForNextSegment(Ye.trackIdentifier)) || vt, yt = gt - vt, pt = He(Ye.context.internalPlayer);
                isNaN(gt) || yt > pt || Ye.segmentController.hasNext(gt) && (Ye.segmentController.getMPDHandler().resolvePendingSegmentInfoRequests(), Ye.segmentController.getNext(gt));
              }
            }, Ye.onMpdUpdated = function() {
              Ye.segmentController.updateMpd();
            }, Ye.eventHandler = Qe.eventHandler, Ye.sourceStoreService = tt.sourceStore, Ye.streamTimeService = Qe.serviceManager.get(_e.ServiceName.StreamTimeService), Ye.manifestUpdateScheduler = Qe.serviceManager.get(_e.ServiceName.ManifestUpdateSchedulingService, Qe.sourceContext.sourceIdentifier), Ye.getTransmuxer = Ge, Ye.isHls = tt.isHls, Ye.bufferSettings = Qe.bufferSettings;
            var ze = ye.ModuleManager.get($e.ModuleName.EngineBitmovin).SegmentController;
            return Ye.segmentController = new ze(Qe, Ye.onSegmentDataAvailable, tt.mimeType, tt.codec, tt.isHls, tt.manifestLoader, tt.periodId, tt.sourceStore), Ye.segmentController.setCurrentLangObj(Je), Ye.trackIdentifier = "".concat(tt.mimeType, "/").concat(Je.id), Ye.HlsModule = ye.ModuleManager.get($e.ModuleName.HLS, !1), Ye.subscribeToManifestChanges(), Ye;
          }
          return ae(Xe, We), Xe.prototype.subscribeToManifestChanges = function() {
            !this.unsubscribeFromManifestStore && this.sourceStoreService && (this.unsubscribeFromManifestStore = (0, be.subscribe)(this.sourceStoreService)(function(Qe) {
              return Qe == null ? void 0 : Qe.manifest;
            }, this.onMpdUpdated, function(Qe, tt) {
              return !!(Qe != null && Qe.isInitialized && !(tt != null && tt.isInitialized));
            }));
          }, Xe.prototype.unsubscribeFromManifestChanges = function() {
            this.unsubscribeFromManifestStore && (this.unsubscribeFromManifestStore(), this.unsubscribeFromManifestStore = void 0);
          }, Xe.prototype.extractSubtitlesFromSegment = function(Qe) {
            return Ae(Qe) ? (0, Ce.parsePlainTextSubtitles)(Qe) : Ve(Qe) ? (0, Se.parseMP4WrappedSubtitles)(Qe, this.context.logger) : Qe.getMetadata().subtitles;
          }, Xe.prototype.addMetadataToSegment = function(Qe) {
            var tt = Qe.getMetadata();
            tt.subtitles = this.extractSubtitlesFromSegment(Qe), Qe.setMetadata(tt);
          }, Xe.prototype.waitForTransmuxerReady = function(Qe) {
            var tt = this.getTransmuxer();
            return this.isHls && tt ? (Qe !== void 0 && this.areSubtitleDiscontinuitiesAligned() || (Qe = -1), tt.waitForInitializationForDiscontinuity(Qe)) : Promise.resolve();
          }, Xe.prototype.awaitPtoKnownForHlsDiscoSequence = function(Qe) {
            if (!this.areSubtitleDiscontinuitiesAligned() || this.getPtoForHlsDiscoFromStore(Qe) !== void 0)
              return Promise.resolve();
            if (!this.HlsModule)
              return Promise.reject(new Error("HLS Module missing"));
            var tt = this.HlsModule.selectors, Je = tt.getHlsState, Ge = tt.getPresentationTimeOffset;
            return (0, be.waitForStateChangeThen)(this.sourceStoreService)(function(Ye) {
              return Ge(Je(Ye), String(Qe));
            }, function(Ye) {
              return Ye !== void 0;
            }).then();
          }, Xe.prototype.getSubtitleSegmentInfoFromStore = function(Qe) {
            var tt, Je, Ge = (tt = this.context.serviceManager.get(_e.ServiceName.SourceStoreService, Qe)) === null || tt === void 0 ? void 0 : tt.getState(), Ye = (Je = this.segmentController.getCurrentAdaptationSet()) === null || Je === void 0 ? void 0 : Je.Representation[0];
            return Ye && Ge ? (0, ye.ModuleManager.get($e.ModuleName.EngineBitmovin).selectors.getSegmentInfos)(Ge, Ye._internalId.key()) : [];
          }, Xe.prototype.getSubtitleSegmentsFromMpd = function(Qe, tt) {
            var Je, Ge, Ye, ze, Fe = ye.ModuleManager.get($e.ModuleName.EngineBitmovin).AdaptationSetId, ot = this.context.serviceManager.get(_e.ServiceName.ManifestService, Qe), vt = new Fe(me.DEFAULT_PERIOD_ID, tt), gt = ot == null ? void 0 : ot.getAdaptationSet(vt);
            return (ze = (Ye = (Ge = (Je = gt == null ? void 0 : gt.Representation[0]) === null || Je === void 0 ? void 0 : Je.SegmentList) === null || Ge === void 0 ? void 0 : Ge[0]) === null || Ye === void 0 ? void 0 : Ye.SegmentURL) !== null && ze !== void 0 ? ze : [];
          }, Xe.prototype.getSegmentDiscoData = function() {
            var Qe = this.context.sourceContext.sourceIdentifier;
            return this.context.settings.ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE ? this.getSubtitleSegmentInfoFromStore(Qe) : this.getSubtitleSegmentsFromMpd(Qe, this.getSubtitle().id);
          }, Xe.prototype.getSubtitleDiscoStartTimes = function() {
            var Qe = this.getSegmentDiscoData();
            if (Qe && Qe.length !== 0)
              return Qe.reduce(function(tt, Je) {
                var Ge = Le(Je) ? Je.startTime : Je._playbackTime, Ye = Le(Je) ? Je.discontinuitySequenceNumber : Je._discontinuitySequenceNumber;
                return (0, ge.isNumber)(Ge) && (0, ge.isNumber)(Ye) && tt[Ye] === void 0 && (tt[Ye] = Ge), tt;
              }, {});
          }, Xe.prototype.areSubtitleDiscontinuitiesAligned = function() {
            var Qe, tt = ye.ModuleManager.get($e.ModuleName.HLS, !1), Je = (Qe = this.sourceStoreService) === null || Qe === void 0 ? void 0 : Qe.getState();
            if (!tt || !Je)
              return !1;
            var Ge = tt.selectors, Ye = Ge.getHlsState, ze = Ge.getMergedDiscontinuityTimings, Fe = Ye(Je);
            if (!Fe)
              return !1;
            var ot = this.getSubtitleDiscoStartTimes();
            if (!ot)
              return !1;
            var vt = ze(Fe), gt = Object.keys(ot).find(function(pt) {
              return !vt[pt] || Math.abs(vt[pt].startTime - ot[pt]) > 1;
            }), yt = Object.keys(vt).find(function(pt) {
              return ot[pt] == null;
            });
            return gt == null && yt == null;
          }, Xe.prototype.processSegment = function(Qe) {
            this.updateBufferLevel(Qe), this.addMetadataToSegment(Qe), this.addCues(Qe), this.isActive() && this.timeline.show();
          }, Xe.prototype.getPtoForHlsDiscoFromStore = function(Qe) {
            var tt;
            if (this.HlsModule) {
              var Je = this.HlsModule.selectors, Ge = Je.getHlsState, Ye = Je.getPresentationTimeOffset, ze = (tt = this.sourceStoreService) === null || tt === void 0 ? void 0 : tt.getState(), Fe = ze ? Ge(ze) : void 0;
              if (Fe)
                return Ye(Fe, String(Qe));
            }
          }, Xe.prototype.removeLoadingRange = function(Qe) {
            var tt, Je = Qe.getPlaybackTimeRange();
            if (Je) {
              var Ge = ye.ModuleManager.get($e.ModuleName.EngineBitmovin), Ye = Ge.actions.removeStreamTimeRange, ze = Ge.mseModuleTypes.streamTimeRangeType;
              (tt = this.sourceStoreService) === null || tt === void 0 || tt.dispatch(Ye(this.trackIdentifier, Je, ze.Loading));
            }
          }, Xe.prototype.updateBufferLevel = function(Qe) {
            var tt, Je = Qe.getPlaybackTimeRange();
            if (!Qe.isInit() && Je) {
              var Ge = ye.ModuleManager.get($e.ModuleName.EngineBitmovin).actions.addLoadedRange, Ye = ce(ce({}, Je), { bufferBlockId: we });
              (tt = this.sourceStoreService) === null || tt === void 0 || tt.dispatch(Ge(this.trackIdentifier, Ye));
            }
          }, Xe.prototype.getTimestampOffset = function(Qe) {
            var tt, Je, Ge = -this.segmentController.getMPDHandler().getTimestampOffset();
            if (this.isHls) {
              var Ye = Qe.getSegmentInfo().discontinuitySequenceNumber, ze = this.getPtoForHlsDiscoFromStore(Ye);
              ze !== void 0 ? Ge = -ze : this.context.logger.warn("FragmentedSubtitleHandler: Failed to get PTO for disco sequence ".concat(Ye, " from store, falling back to MPDHandler value of ").concat(-Ge), Qe.getSegmentInfo());
            }
            return Ge += (Je = (tt = this.getTransmuxer()) === null || tt === void 0 ? void 0 : tt.getTimestampMappingOffset(Qe)) !== null && Je !== void 0 ? Je : 0;
          }, Xe.prototype.addCues = function(Qe) {
            var tt = Qe.getMetadata().subtitles;
            if (Array.isArray(tt) && tt.length !== 0) {
              var Je = Ae(Qe), Ge = this.getTimestampOffset(Qe), Ye = Je || Be(Qe) || Oe(Qe) ? this.parseCues(tt, Ge) : tt, ze = Je ? this.applyVttOffset(Ye) : Ye, Fe = Xe.ensureCueInSegmentRange(ze, Qe.getPlaybackTime(), Qe.getDuration(), Ge, this.isTsContainer());
              this.fireOnCueParsedEvents(Fe, this.periodId), this.timeline.addCues(Fe);
            }
          }, Xe.prototype.parseCues = function(Qe, tt) {
            var Je = this;
            return Qe.flatMap(function(Ge) {
              return Je.parse(Ge.text, tt);
            });
          }, Xe.ensureCueInSegmentRange = function(Qe, tt, Je, Ge, Ye) {
            if (Ye === void 0 && (Ye = !1), !tt && tt !== 0 || tt < 0 || !Je)
              return Qe;
            if (Qe.length > 0) {
              var ze = Je + Ge;
              if (Qe.every(function(Fe) {
                return Fe.end <= ze;
              }))
                return Qe.map(function(Fe) {
                  return Ye && Fe.offset != null ? ce(ce({}, Fe), { start: Fe.start + tt - Ge - Fe.offset, end: Fe.end + tt - Ge - Fe.offset }) : ce(ce({}, Fe), { start: Fe.start + tt - Ge, end: Fe.end + tt - Ge });
                });
            }
            return Qe;
          }, Xe.prototype.parse = function(Qe, tt) {
            var Je = Ie.SubtitleParserFactory.createInstance(this.context, Qe);
            return tt ? Je.parse(Qe, tt) : Je.parse(Qe);
          }, Xe.prototype.activate = function() {
            var Qe = this;
            return We.prototype.activate.call(this), this.prepareActivation().then(function() {
              if (Qe.isActive()) {
                var tt = Ue(Qe.context.renderer, Qe.context.store);
                Qe.segmentController.activateSubtitleSegmentController(tt), Qe.segmentController.getNext(tt), Qe.eventHandler.on(le.PlayerEvent.TimeChanged, Qe.onTimeUpdate);
              }
            });
          }, Xe.prototype.prepareActivation = function() {
            var Qe = this.segmentController.getCurrentAdaptationSet().Representation[0], tt = Qe._internalId, Je = Qe._mimeType, Ge = ye.ModuleManager.get($e.ModuleName.EngineBitmovin).actions, Ye = Ge.setRepresentationIdAction, ze = Ge.setMediaTypeAction;
            return this.sourceStoreService.dispatch(Ye(tt)), this.sourceStoreService.dispatch(ze(tt, pe.MimeTypeHelper.getMediaType(Je))), this.manifestUpdateScheduler.waitForRepUpdate(tt);
          }, Xe.prototype.deactivate = function() {
            var Qe;
            this.timeline.removeCues();
            var tt = ye.ModuleManager.get($e.ModuleName.EngineBitmovin).actions, Je = tt.resetStreamTimeline, Ge = tt.resetLoadedRanges;
            this.eventHandler.off(le.PlayerEvent.TimeChanged, this.onTimeUpdate), this.sourceStoreService.dispatch(Je(this.trackIdentifier)), this.sourceStoreService.dispatch(Ge(this.trackIdentifier));
            var Ye = (Qe = this.segmentController.getCurrentAdaptationSet()) === null || Qe === void 0 ? void 0 : Qe._internalId;
            return Ye && this.sourceStoreService.dispatch(ye.ModuleManager.get($e.ModuleName.EngineBitmovin).actions.removeActiveTrackAction(Ye)), We.prototype.deactivate.call(this);
          }, Xe.prototype.getSubtitleType = function() {
            return Ee.SubtitleType.FRAGMENTED;
          }, Xe.prototype.clearBuffersUntil = function(Qe) {
            We.prototype.clearBuffersUntil.call(this, Qe);
            var tt = ye.ModuleManager.get($e.ModuleName.EngineBitmovin).actions.removeLoadedRange;
            this.sourceStoreService.dispatch(tt(this.trackIdentifier, { start: 0, end: Qe, bufferBlockId: we }));
          }, Xe.prototype.seek = function(Qe, tt) {
            var Je;
            if (this.isActive()) {
              var Ge = (Je = this.sourceStoreService) === null || Je === void 0 ? void 0 : Je.getState(), Ye = (0, ue.getLoadedRangesForMimeType)((0, ue.getBufferState)(Ge), this.trackIdentifier);
              if (!(0, he.isInTimeRanges)(Ye, tt)) {
                this.timeline.removeCues();
                var ze = ye.ModuleManager.get($e.ModuleName.EngineBitmovin).actions.resetLoadedRanges;
                this.sourceStoreService.dispatch(ze(this.trackIdentifier)), this.segmentController.seekTo(tt), this.segmentController.getNext(tt);
              }
            }
          }, Xe.prototype.dispose = function() {
            We.prototype.dispose.call(this), this.unsubscribeFromManifestChanges(), this.segmentController.dispose();
          }, Xe;
        }(Te.AbstractSubtitleHandler);
        function Me(We) {
          return fe.TextSegmentAnalyzer.isPlainTextPayload(We.getData());
        }
        function Ae(We) {
          var Xe = We.getCodec();
          return (Xe === "wvtt" || Xe === "vtt" || Xe === "" && We.getMimeType().includes("vtt")) && Me(We);
        }
        function Oe(We) {
          return We.getMimeType() === "application/mp4" && We.getCodec() === "wvtt" && !Me(We);
        }
        function Be(We) {
          return ve.CodecStringHelper.extractCodec(We.getCodec()) === "stpp";
        }
        function Ve(We) {
          return pe.MimeTypeHelper.isApplication(We.getMimeType()) && !Me(We);
        }
        function Ue(We, Xe) {
          var Qe = (0, oe.getPlayerState)(Xe.getState());
          return (0, oe.getIsSeekingOrTimeshifting)(Qe) ? Qe.targetPlaybackTime : We.getCurrentTime(!0);
        }
        function Re(We, Xe) {
          var Qe = ye.ModuleManager.get($e.ModuleName.EngineBitmovin, !1);
          if (Xe !== void 0 && Qe !== void 0)
            return Qe.selectors.getContainerFormat(Xe, We);
        }
        function Ne(We, Xe, Qe) {
          var tt = Re(Qe, Xe);
          return tt !== void 0 ? Promise.resolve(tt) : (0, be.waitForStateChangeThen)(We)(function(Je) {
            return Re(Qe, Je);
          }, function(Je) {
            return Je !== void 0;
          });
        }
        function xe(We) {
          var Xe, Qe = (Xe = We.activeTracks) !== null && Xe !== void 0 ? Xe : {};
          return Object.keys(Qe).flatMap(function(tt) {
            var Je;
            return (Je = Qe[tt].mediaTypes) !== null && Je !== void 0 ? Je : [];
          }).filter(function(tt) {
            return tt === se.MediaType.Video || tt === se.MediaType.Audio;
          });
        }
        function ke(We) {
          var Xe = We == null ? void 0 : We.getState();
          return Xe !== void 0 && We !== void 0 ? Promise.race(xe(Xe).map(function(Qe) {
            return Ne(We, Xe, Qe);
          })) : Promise.reject("SourceState unavailable");
        }
        function Le(We) {
          return "discontinuitySequenceNumber" in We;
        }
        function He(We) {
          var Xe = [We == null ? void 0 : We.getAudioBufferLength(), We == null ? void 0 : We.getVideoBufferLength()].filter(ge.isDefined);
          return Math.min.apply(Math, Xe);
        }
        ne.FragmentedSubtitleHandler = Pe;
      }, 24855: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.isSubtitleTrack = ce, ne.isFragmentedAdaptationSet = he;
        var ae = ie(79814);
        function ce(_e, le) {
          return (ae.MimeTypeHelper.isText(_e) || ae.MimeTypeHelper.isTtmlXml(_e)) && !le || ae.MimeTypeHelper.isApplication(_e);
        }
        function he(_e) {
          var le = [_e];
          return _e.Representation && _e.Representation.length > 0 && le.push(_e.Representation[0]), le.some(function(se) {
            return se.SegmentList || se.SegmentTemplate || se.SegmentBase;
          });
        }
      }, 27338: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SubtitleParserFactory = void 0;
        var ae = ie(62510), ce = ie(91520), he = ie(16368), _e = ie(57042), le = function() {
          function se() {
          }
          return se.createInstance = function(oe, ue) {
            var be;
            return ue.indexOf("<?") > -1 || ue.indexOf("<tt") > -1 ? ce.ModuleManager.has(he.ModuleName.SubtitlesTTML) ? be = new (ce.ModuleManager.get(he.ModuleName.SubtitlesTTML)).TTMLParser(oe) : oe.eventHandler.dispatchEvent(ae.PlayerEvent.Warning, new _e.PlayerModuleMissingWarning(he.ModuleName.SubtitlesTTML, "The ".concat(he.ModuleName.SubtitlesTTML, " module is required to parse TTML subtitles."))) : ce.ModuleManager.has(he.ModuleName.SubtitlesWebVTT) ? be = new (ce.ModuleManager.get(he.ModuleName.SubtitlesWebVTT)).WebVttParser() : oe.eventHandler.dispatchEvent(ae.PlayerEvent.Warning, new _e.PlayerModuleMissingWarning(he.ModuleName.SubtitlesWebVTT, "The ".concat(he.ModuleName.SubtitlesWebVTT, " module is required to parse WebVTT subtitles."))), be;
          }, se;
        }();
        ne.SubtitleParserFactory = le;
      }, 29495: function(ee, ne) {
        var ie = this && this.__assign || function() {
          return ie = Object.assign || function(he) {
            for (var _e, le = 1, se = arguments.length; le < se; le++)
              for (var oe in _e = arguments[le])
                Object.prototype.hasOwnProperty.call(_e, oe) && (he[oe] = _e[oe]);
            return he;
          }, ie.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.EnabledSubtitlesTracker = void 0;
        var ae = function() {
          function he() {
            this.enabledSubtitles = {}, this.idCounter = 0;
          }
          return he.prototype.addSubtitle = function(_e) {
            this.removeSubtitle(_e.id), this.enabledSubtitles[this.getNextId()] = ie({ isFragmented: !1 }, _e);
          }, he.prototype.removeSubtitle = function(_e) {
            var le = this;
            Object.keys(this.enabledSubtitles).forEach(function(se) {
              le.enabledSubtitles[se].id === _e && delete le.enabledSubtitles[se];
            });
          }, he.prototype.shouldEnableSubtitle = function(_e, le) {
            var se = this, oe = Object.keys(this.enabledSubtitles).find(function(ue) {
              return se.getTargetSubtitleIdForPeriod(se.enabledSubtitles[ue], le) === _e.id;
            });
            return !!oe;
          }, he.prototype.getTargetSubtitleIdForPeriod = function(_e, le) {
            var se = _e.id, oe = _e.kind, ue = _e.lang, be = _e.isFragmented;
            return ce({ lang: ue, kind: oe, isFragmented: be, id: se }, le) || ce({ lang: ue, kind: oe, isFragmented: be }, le) || ce({ lang: ue, kind: oe }, le);
          }, he.prototype.getNextId = function() {
            return this.idCounter++, this.idCounter;
          }, he.prototype.dispose = function() {
            this.enabledSubtitles = {}, this.idCounter = 0;
          }, he;
        }();
        function ce(he, _e) {
          return Object.keys(_e).find(function(le) {
            var se = _e[le].getSubtitle(), oe = se.id, ue = se.lang, be = se.isFragmented, ve = se.kind, me = oe === he.id, pe = !he.isFragmented || be === he.isFragmented, fe = ue === he.lang;
            he.isPreferred && he.lang && (fe = ue.includes(he.lang) || he.lang.includes(ue));
            var ge = ve === he.kind && fe && pe;
            return me || ge;
          });
        }
        ne.EnabledSubtitlesTracker = ae;
      }, 45684: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var pe = function(fe, ge) {
            return pe = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ye, $e) {
              ye.__proto__ = $e;
            } || function(ye, $e) {
              for (var Se in $e)
                Object.prototype.hasOwnProperty.call($e, Se) && (ye[Se] = $e[Se]);
            }, pe(fe, ge);
          };
          return function(fe, ge) {
            if (typeof ge != "function" && ge !== null)
              throw new TypeError("Class extends value " + String(ge) + " is not a constructor or null");
            function ye() {
              this.constructor = fe;
            }
            pe(fe, ge), fe.prototype = ge === null ? Object.create(ge) : (ye.prototype = ge.prototype, new ye());
          };
        }();
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ExternalFileSubtitleHandler = void 0;
        var ce = ie(63546), he = ie(35148), _e = ie(60997), le = ie(62510), se = ie(88005), oe = ie(67345), ue = ie(27338), be = ie(49625), ve = ie(8679), me = function(pe) {
          function fe(ge, ye, $e) {
            var Se = pe.call(this, ge, ye, $e && $e._internalId.periodId) || this;
            return Se.onFileLoaded = function(Ce) {
              if (Se.timeline.removeCues(), Ce == null ? void 0 : Ce.body) {
                Se.isFileLoaded = !0;
                var Ie = Se.parse(Ce.body.trim()), Te = Se.applyVttOffset(Ie);
                Se.fireOnCueParsedEvents(Te, null), Se.timeline.addCues(Te);
              }
            }, $e && (ye.id = $e.Representation[0]._id), ye.url ? (Se.externalFileUrl = fe.enforceHTTPSForSecureOrigins(ye.url.trim()), Se.isFileLoaded = !1, Se.subtitleLoader = new se.DefaultContentLoader(Se.context, { maxRetries: Se.context.settings.MAX_RETRIES, retryDelay: Se.context.settings.RETRY_DELAY, requestType: oe.HttpRequestType.MEDIA_SUBTITLES })) : (Se.context.logger.log("No url was provided for an external subtitle, nothing will be loaded."), Se.isFileLoaded = !0, Se.loadPromise = Promise.resolve()), Se;
          }
          return ae(fe, pe), fe.prototype.activate = function() {
            var ge = this;
            return this.context.logger.debug("loading " + this.externalFileUrl), pe.prototype.activate.call(this).then(function() {
              return ge.loadPromise ? ge.loadPromise : ge.isFileLoaded ? Promise.resolve() : (ge.loadPromise = ge.subtitleLoader.load(ge.externalFileUrl).then(ge.onFileLoaded).catch(function(ye) {
                var $e, Se;
                if (ge.loadPromise = void 0, !ge.isActive())
                  return Promise.resolve();
                throw ge.context.eventHandler && ge.context.eventHandler.dispatchEvent(le.PlayerEvent.Warning, new ce.PlayerWarning(he.WarningCode.NETWORK_COULD_NOT_LOAD_SUBTITLE)), ge.context.logger.debug("Could not load subtitles/captions, got HTTP status code ".concat((Se = ($e = ye == null ? void 0 : ye.status) === null || $e === void 0 ? void 0 : $e.toString()) !== null && Se !== void 0 ? Se : ""), ye), ge.deactivate(), "loading failed";
              }), ge.loadPromise);
            });
          }, fe.prototype.parse = function(ge) {
            return ue.SubtitleParserFactory.createInstance(this.context, ge).parse(ge);
          }, fe.enforceHTTPSForSecureOrigins = function(ge) {
            var ye = new RegExp("^(?:[a-z]+:)?//", "i");
            return location.protocol === "https:" ? ge.replace(ye, "//") : ge;
          }, fe.prototype.getSubtitleType = function() {
            return ve.SubtitleType.EXTERNAL_FILE;
          }, fe.prototype.clearBuffersUntil = function() {
          }, fe.prototype.seek = function() {
          }, fe.prototype.dispose = function() {
            pe.prototype.dispose.call(this), this.subtitleLoader = (0, _e.dispose)(this.subtitleLoader);
          }, fe;
        }(be.AbstractSubtitleHandler);
        ne.ExternalFileSubtitleHandler = me;
      }, 49625: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(pe) {
            for (var fe, ge = 1, ye = arguments.length; ge < ye; ge++)
              for (var $e in fe = arguments[ge])
                Object.prototype.hasOwnProperty.call(fe, $e) && (pe[$e] = fe[$e]);
            return pe;
          }, ae.apply(this, arguments);
        }, ce = this && this.__decorate || function(pe, fe, ge, ye) {
          var $e, Se = arguments.length, Ce = Se < 3 ? fe : ye === null ? ye = Object.getOwnPropertyDescriptor(fe, ge) : ye;
          if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
            Ce = Reflect.decorate(pe, fe, ge, ye);
          else
            for (var Ie = pe.length - 1; Ie >= 0; Ie--)
              ($e = pe[Ie]) && (Ce = (Se < 3 ? $e(Ce) : Se > 3 ? $e(fe, ge, Ce) : $e(fe, ge)) || Ce);
          return Se > 3 && Ce && Object.defineProperty(fe, ge, Ce), Ce;
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.AbstractSubtitleHandler = void 0;
        var he = ie(18665), _e = ie(62510), le = ie(99378), se = ie(16937), oe = ie(33696), ue = ie(91520), be = ie(16368), ve = function() {
          function pe(fe, ge, ye) {
            ye === void 0 && (ye = null);
            var $e = this;
            this.onCueEnter = function(Se) {
              $e.context.eventHandler.dispatchEvent(_e.PlayerEvent.CueEnter, me(Se, $e.getSubtitle().id));
            }, this.onCueExit = function(Se) {
              $e.context.eventHandler && $e.context.eventHandler.dispatchEvent(_e.PlayerEvent.CueExit, me(Se, $e.getSubtitle().id));
            }, this.onCueUpdate = function(Se) {
              $e.context.eventHandler.dispatchEvent(_e.PlayerEvent.CueUpdate, me(Se, $e.getSubtitle().id));
            }, this.context = fe, this.subtitle = ge, this.subtitle.enabled = this.subtitle.enabled || !1, this.timeline = new le.Timeline(fe, { onCueEnter: this.onCueEnter, onCueExit: this.onCueExit, onCueUpdate: this.onCueUpdate }), this.timeline.stopListening(), this.periodId = ye, this.sourceStore = fe.serviceManager.get(he.ServiceName.SourceStoreService, fe.sourceContext.sourceIdentifier);
          }
          return pe.prototype.fireOnCueParsedEvents = function(fe, ge) {
            var ye = this;
            fe && this.context.eventHandler && fe.forEach(function($e) {
              ye.context.eventHandler.dispatchEvent(_e.PlayerEvent.CueParsed, ae(ae({ subtitleId: ye.getSubtitle().id }, $e), { periodId: ge }));
            });
          }, pe.prototype.isActive = function() {
            return this.subtitle.enabled;
          }, pe.prototype.activate = function() {
            return this.subtitle.enabled = !0, this.timeline.startListening(), this.timeline.show(), Promise.resolve();
          }, pe.prototype.deactivate = function() {
            return this.subtitle.enabled = !1, this.timeline.stopListening(), this.timeline.hide(), Promise.resolve();
          }, pe.prototype.refresh = function() {
            this.timeline.show();
          }, pe.prototype.getSubtitle = function() {
            return this.subtitle;
          }, pe.prototype.clearBuffersUntil = function(fe) {
            this.timeline.removeCuesUntil(fe);
          }, pe.prototype.dispose = function() {
            this.sourceStore = null, this.deactivate(), this.timeline.dispose();
          }, pe.prototype.isTsContainer = function() {
            var fe, ge = ue.ModuleManager.get(be.ModuleName.EngineBitmovin), ye = ge.selectors, $e = ge.mseModuleTypes;
            return ((fe = ye.getContainerFormat(this.sourceStore.getState(), oe.MediaType.Video)) === null || fe === void 0 ? void 0 : fe.source) === $e.containerFormat.TS;
          }, pe.prototype.applyVttOffset = function(fe) {
            return this.isTsContainer() ? fe.map(function(ge) {
              return ge.offset != null ? ae(ae({}, ge), { start: ge.start + ge.offset, end: ge.end + ge.offset, updates: ge.updates.map(function(ye) {
                return ae(ae({}, ye), { updateTime: ye.updateTime + ge.offset });
              }) }) : ge;
            }) : fe;
          }, ce([(0, se.trackPerformance)("SubtitleHandler.activate")], pe.prototype, "activate", null), pe;
        }();
        function me(pe, fe) {
          return ae({ subtitleId: fe, start: pe.start, end: pe.end }, pe.content);
        }
        ne.AbstractSubtitleHandler = ve;
      }, 49896: function(ee, ne) {
        function ie(ae) {
          var ce = 0;
          if (ae.length === 0)
            return ce;
          for (var he = 0; he < ae.length; he++)
            ce = (ce << 5) - ce + ae.charCodeAt(he), ce |= 0;
          return ce;
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.hashCode = ie;
      }, 59272: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ForcedSubtitleController = void 0;
        var ae = ie(70412), ce = function() {
          function he() {
            this.subtitleHandlers = {};
          }
          return he.prototype.addSubtitleHandler = function(_e) {
            this.subtitleHandlers[_e.getSubtitle().id] = _e;
          }, he.prototype.deactivate = function() {
            return this.hasForcedSubtitles() ? Promise.all(Object.values(this.subtitleHandlers).map(function(_e) {
              return _e.deactivate();
            })).then(function() {
            }) : Promise.resolve();
          }, he.prototype.activate = function(_e) {
            var le = this;
            return _e === void 0 && (_e = this.currentLang), this.hasForcedSubtitles() ? (this.currentLang = _e, this.deactivate().then(function() {
              var se = Object.values(le.subtitleHandlers).find(function(oe) {
                return (0, ae.isEqualIsoLanguage)(oe.getSubtitle().lang, le.currentLang);
              });
              if ((se = se ?? Object.values(le.subtitleHandlers)[0]) && !se.isActive())
                return se.activate().catch(function() {
                });
            })) : Promise.resolve();
          }, he.prototype.seek = function(_e, le) {
            Object.values(this.subtitleHandlers).forEach(function(se) {
              return se.seek(_e, le);
            });
          }, he.prototype.dispose = function() {
            Object.values(this.subtitleHandlers).forEach(function(_e) {
              return _e.dispose();
            }), this.subtitleHandlers = null;
          }, he.prototype.hasForcedSubtitles = function() {
            return Object.keys(this.subtitleHandlers).length > 0;
          }, he.prototype.getForcedSubtitleHandler = function(_e) {
            if (this.subtitleHandlers)
              return Object.values(this.subtitleHandlers).find(function(le) {
                return _e(le);
              });
          }, he;
        }();
        ne.ForcedSubtitleController = ce;
      }, 64397: function(ee, ne) {
        function ie(le) {
          return ae(he(le));
        }
        function ae(le) {
          return le.replace(/<[^>]*>?/g, "");
        }
        function ce(le) {
          return le.replace(/(\r\n|\r|\n)/g, "<br />");
        }
        function he(le) {
          return le.replace(/<br\s*\/?>/g, `
`);
        }
        function _e(le) {
          return le.replace(/<br\s*\/?>/g, "");
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.htmlToText = ie, ne.stripHtmlTags = ae, ne.prepareHtml = ce, ne.replaceHtmlBreakPointsWithNewLine = he, ne.stripAwayHtmlBreakPoints = _e;
      }, 66774: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.parseMP4WrappedSubtitles = se;
        var ae = ie(81361), ce = ie(42283), he = ie(34586), _e = ie(91520), le = ie(16368);
        function se(me, pe) {
          var fe = me.getTimescale();
          if (fe === void 0 || !_e.ModuleManager.has(le.ModuleName.ContainerMP4))
            return [];
          var ge = _e.ModuleManager.get(le.ModuleName.ContainerMP4);
          return oe(ge.getMp4Fragments(me).flatMap(function(ye) {
            return ge.getTrackSamples(ye.moof, ye.mdat, me, pe);
          }), me, fe);
        }
        function oe(me, pe, fe) {
          var ge = 0, ye = [], $e = 0;
          return me.forEach(function(Se) {
            var Ce = ce.CodecStringHelper.extractCodec(pe.getCodec()), Ie = Se.duration / fe, Te = pe.getPlaybackTime() + ge, Ee = Te + Ie;
            if (ge += Ie, Ce === "wvtt" || Ce === "vtt") {
              var we = be(Se, Te, Ee, $e);
              $e += we.length, we.forEach(function(Pe) {
                ye.push({ start: Te, end: Ee, text: Pe });
              });
            } else
              Ce === "stpp" && ye.push({ start: Te, end: Ee, text: ue(Se) });
          }), ye;
        }
        function ue(me) {
          var pe = new Uint8Array(me.data.buffer, me.data.byteOffset, me.data.byteLength);
          return ae.ArrayHelper.convertBufferSourceToUTF8(pe, he.TextSegmentAnalyzer.detectEncoding(me.data));
        }
        function be(me, pe, fe, ge) {
          for (var ye = me.data.buffer, $e = me.data.byteOffset, Se = 0, Ce = [], Ie = "", Te = ""; Se < me.data.byteLength; ) {
            var Ee = me.data.getUint32(Se), we = $e + Se, Pe = ae.ArrayHelper.convertBufferSourceToUTF8(new Uint8Array(ye, we + 4, 4));
            if (Pe === "vttc") {
              if (Ie) {
                var Me = ve(pe, fe, ge, Te, Ie);
                Ce.push(Me), ge += 1, Ie = "", Te = "";
              }
              Se += 8;
            } else
              Pe === "payl" ? (Ie = ae.ArrayHelper.convertBufferSourceToUTF8(new Uint8Array(ye, we + 8, Ee - 8)), Se += Ee) : (Pe === "sttg" && (Te = ae.ArrayHelper.convertBufferSourceToUTF8(new Uint8Array(ye, we + 8, Ee - 8))), Se += Ee);
          }
          return Ie && (Me = ve(pe, fe, ge, Te, Ie), Ce.push(Me)), Ce;
        }
        function ve(me, pe, fe, ge, ye) {
          return ["[EMBEDDEDWEBVTT]", me, pe, fe, ge, ye].join(`
`);
        }
      }, 68466: function(ee, ne, ie) {
        var ae = this && this.__extends || function() {
          var le = function(se, oe) {
            return le = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ue, be) {
              ue.__proto__ = be;
            } || function(ue, be) {
              for (var ve in be)
                Object.prototype.hasOwnProperty.call(be, ve) && (ue[ve] = be[ve]);
            }, le(se, oe);
          };
          return function(se, oe) {
            if (typeof oe != "function" && oe !== null)
              throw new TypeError("Class extends value " + String(oe) + " is not a constructor or null");
            function ue() {
              this.constructor = se;
            }
            le(se, oe), se.prototype = oe === null ? Object.create(oe) : (ue.prototype = oe.prototype, new ue());
          };
        }();
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.Cea608Handler = void 0;
        var ce = ie(49625), he = ie(8679), _e = function(le) {
          function se(oe, ue, be) {
            return be === void 0 && (be = null), le.call(this, oe, ue, be) || this;
          }
          return ae(se, le), se.prototype.seek = function(oe, ue) {
            var be = ue < oe, ve = this.context.settings.CLEAR_BUFFERS_ON_SEEKING_BACKWARDS;
            be && ve && this.clearBuffersUntil(this.context.renderer.getDuration());
          }, se.prototype.addCaption = function(oe, ue) {
            oe && (this.fireOnCueParsedEvents([oe], ue), this.timeline.addCues([oe], 0));
          }, se.prototype.getSubtitleType = function() {
            return he.SubtitleType.IN_STREAM;
          }, se;
        }(ce.AbstractSubtitleHandler);
        ne.Cea608Handler = _e;
      }, 70412: function(ee, ne) {
        function ie(ae, ce) {
          var he;
          if (ce === void 0)
            return !1;
          if (!((he = window.Intl) === null || he === void 0) && he.DisplayNames) {
            var _e = new window.Intl.DisplayNames(["en"], { type: "language" });
            try {
              return _e.of(ae.split("-")[0]) === _e.of(ce.split("-")[0]);
            } catch {
            }
          }
          return ae === ce;
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.isEqualIsoLanguage = ie;
      }, 75225: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(_e) {
            for (var le, se = 1, oe = arguments.length; se < oe; se++)
              for (var ue in le = arguments[se])
                Object.prototype.hasOwnProperty.call(le, ue) && (_e[ue] = le[ue]);
            return _e;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.PlayerSubtitlesApiFactory = void 0;
        var ce = ie(62510), he = function() {
          function _e() {
          }
          return _e.build = function(le) {
            return new (function() {
              function se() {
              }
              return se.prototype.add = function(oe) {
                le.addSubtitle(oe);
              }, se.prototype.remove = function(oe) {
                le.removeSubtitle(oe);
              }, se.prototype.list = function() {
                return le.listSubtitles();
              }, se.prototype.enable = function(oe, ue) {
                ue === void 0 && (ue = !0), le.enableSubtitle(oe, ue);
              }, se.prototype.disable = function(oe) {
                le.disableSubtitle(oe);
              }, se.prototype.cueEnter = function(oe) {
                le.fireEvent(ce.PlayerEvent.CueEnter, ae(ae({}, oe), { type: ce.PlayerEvent.CueEnter }));
              }, se.prototype.cueExit = function(oe) {
                le.fireEvent(ce.PlayerEvent.CueExit, ae(ae({}, oe), { type: ce.PlayerEvent.CueExit }));
              }, se;
            }())();
          }, _e;
        }();
        ne.PlayerSubtitlesApiFactory = he;
      }, 81253: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.parsePlainTextSubtitles = he;
        var ae = ie(81361), ce = ie(34586);
        function he(_e) {
          var le, se, oe = ce.TextSegmentAnalyzer.detectEncoding(_e.getData()), ue = ae.ArrayHelper.convertBufferSourceToUTF8(_e.getData(), oe), be = (le = _e.getPlaybackTime()) !== null && le !== void 0 ? le : 0;
          return [{ start: be, end: be + ((se = _e.getDuration()) !== null && se !== void 0 ? se : 0), text: ue }];
        }
      }, 84380: function(ee, ne, ie) {
        var ae = this && this.__createBinding || (Object.create ? function(me, pe, fe, ge) {
          ge === void 0 && (ge = fe);
          var ye = Object.getOwnPropertyDescriptor(pe, fe);
          ye && !("get" in ye ? !pe.__esModule : ye.writable || ye.configurable) || (ye = { enumerable: !0, get: function() {
            return pe[fe];
          } }), Object.defineProperty(me, ge, ye);
        } : function(me, pe, fe, ge) {
          ge === void 0 && (ge = fe), me[ge] = pe[fe];
        }), ce = this && this.__exportStar || function(me, pe) {
          for (var fe in me)
            fe === "default" || Object.prototype.hasOwnProperty.call(pe, fe) || ae(pe, me, fe);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.SubtitleModuleDefinition = void 0;
        var he = ie(16368), _e = ie(49896), le = ie(64397), se = ie(70412), oe = ie(75225), ue = ie(27338), be = ie(10842), ve = ie(96892);
        ne.SubtitleModuleDefinition = { name: he.ModuleName.Subtitles, module: function() {
          return { SubtitleService: be.SubtitleService, SubtitleParserFactory: ue.SubtitleParserFactory, PlayerSubtitlesApiFactory: oe.PlayerSubtitlesApiFactory, HtmlTransformer: le, LanguageComparer: se, hashCode: _e.hashCode, createHtmlElement: ve.createHtmlElement };
        }, dependencies: [he.ModuleName.EngineBitmovin] }, ne.default = ne.SubtitleModuleDefinition, ce(ie(86685), ne);
      }, 86685: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 });
      }, 96892: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.createHtmlElement = _e;
        var ae, ce = ie(13533), he = void 0;
        function _e(oe) {
          var ue;
          if (le()) {
            var be = se().parseFromString("<".concat(oe, "></").concat(oe, ">"), "text/html");
            return ((ue = be.body) === null || ue === void 0 ? void 0 : ue.firstChild) || be.firstChild;
          }
          return document.createElement(oe);
        }
        function le() {
          if (he === void 0) {
            var oe = (0, ce.getCapabilities)().isReactNative, ue = window && window.document && typeof window.document.createElement == "function";
            he = !ue || oe;
          }
          return he;
        }
        function se() {
          return ae != null || (ae = new DOMParser()), ae;
        }
      } }, function(ee) {
        return function(ne) {
          return ee(ee.s = ne);
        }(84380);
      }]);
    });
  })();
})(bitmovinplayerSubtitles);
var bitmovinplayerSubtitlesExports = bitmovinplayerSubtitles.exports;
const SubtitlesModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerSubtitlesExports);
var bitmovinplayerSubtitlesVtt = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ne) {
      re.exports = ne();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[831], { 10517: function(ee, ne) {
        function ie(ce) {
          var he = [], _e = /::cue(\((.+)\))?(?= |{)/, le = /([a-zA-Z0-9-]+):(.+?(?=;|}|$))/g, se = _e.exec(ce[1]);
          if (!se)
            return he;
          for (var oe = 1; oe < ce.length; oe++) {
            for (var ue = _e.exec(ce[oe]), be = ue !== null, ve = (se = be ? ue : se)[2], me = {}, pe = le.exec(ce[oe]); pe !== null; ) {
              var fe = pe[1], ge = pe[2];
              me[fe] = ge.trim(), pe = le.exec(ce[oe]);
            }
            (be || Object.keys(me).length > 0) && he.push({ identifier: ve, style: me });
          }
          return he;
        }
        function ae() {
          return [{ identifier: ":future", style: { visibility: "hidden" } }];
        }
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.parseStyles = ie, ne.getPlaceholderVttStyleProperties = ae;
      }, 17699: function(ee, ne) {
        var ie = this && this.__spreadArray || function(_e, le, se) {
          if (se || arguments.length === 2)
            for (var oe, ue = 0, be = le.length; ue < be; ue++)
              !oe && ue in le || (oe || (oe = Array.prototype.slice.call(le, 0, ue)), oe[ue] = le[ue]);
          return _e.concat(oe || Array.prototype.slice.call(le));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.webVttDefaultClassStyles = void 0;
        var ae = ["white", "lime", "cyan", "red", "yellow", "magenta", "blue", "black"];
        function ce(_e) {
          return { identifier: ".".concat(_e), style: { color: _e } };
        }
        function he(_e) {
          return { identifier: ".bg_".concat(_e), style: { background: _e } };
        }
        ne.webVttDefaultClassStyles = ie(ie([], ae.map(ce), !0), ae.map(he), !0);
      }, 33605: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.getDefaultVttProperties = le, ne.extractVttProperties = se, ne.getDefaultVttRegionProperties = ue, ne.parseTime = be, ne.ensureArray = ve, ne.stringifyCssProperties = me, ne.stringifyCueHtml = pe;
        var ae = ie(70016), ce = ie(91520), he = ie(16368), _e = ie(86535);
        function le() {
          return { vertical: "", align: "center", size: 100, line: "auto", lineAlign: "start", position: "auto", positionAlign: "center", snapToLines: !1 };
        }
        function se(fe) {
          var ge = le(), ye = ue();
          return Object.keys(ge).forEach(function($e) {
            return (0, _e.setOptionProperty)(oe($e, fe, ge), [ye], ge);
          }), ge;
        }
        function oe(fe, ge, ye) {
          var $e = [fe, ge[fe] ? "".concat(ge[fe]) : ye[fe]], Se = fe === "line";
          return (fe === "position" && (0, ae.isNumber)(ge[fe]) || Se && ge.snapToLines === !1) && ($e[1] += "%"), $e;
        }
        function ue() {
          return { id: null, width: 100, lines: 3, regionAnchorX: 0, regionAnchorY: 100, viewportAnchorX: 0, viewportAnchorY: 100, scroll: "" };
        }
        function be(fe) {
          var ge = /(?:(\d{1,}):)?(\d{2}):(\d{2})[.,](\d{3})/g.exec(fe);
          if (ge == null)
            return null;
          var ye = ge[1], $e = ge[2], Se = ge[3], Ce = ge[4];
          return Number(Ce) / 1e3 + Number(Se) + 60 * Number($e) + 3600 * (Number(ye) || 0);
        }
        function ve(fe) {
          return Array.isArray(fe) ? fe : [];
        }
        function me(fe) {
          return fe ? Object.entries(fe).map(function(ge) {
            return "".concat(ge[0], ":").concat(ge[1], ";");
          }).join("") : null;
        }
        function pe(fe) {
          return (0, ce.ModuleManager.get(he.ModuleName.Subtitles).HtmlTransformer.prepareHtml)((fe == null ? void 0 : fe.outerHTML) || "");
        }
      }, 35913: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Pe) {
            for (var Me, Ae = 1, Oe = arguments.length; Ae < Oe; Ae++)
              for (var Be in Me = arguments[Ae])
                Object.prototype.hasOwnProperty.call(Me, Be) && (Pe[Be] = Me[Be]);
            return Pe;
          }, ae.apply(this, arguments);
        }, ce = this && this.__spreadArray || function(Pe, Me, Ae) {
          if (Ae || arguments.length === 2)
            for (var Oe, Be = 0, Ve = Me.length; Be < Ve; Be++)
              !Oe && Be in Me || (Oe || (Oe = Array.prototype.slice.call(Me, 0, Be)), Oe[Be] = Me[Be]);
          return Pe.concat(Oe || Array.prototype.slice.call(Me));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.parseContents = fe;
        var he = ie(91520), _e = ie(16368), le = ie(17699), se = ie(33605), oe = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&lrm;": "‎", "&rlm;": "‏", "&nbsp;": " " }, ue = { c: "span", i: "i", b: "b", u: "u", ruby: "ruby", rt: "rt", v: "span", lang: "span" }, be = { v: "title", lang: "lang" }, ve = { rt: "ruby" }, me = { "cue-future": ":future", "cue-past": ":past" }, pe = 2;
        function fe(Pe, Me, Ae) {
          var Oe = he.ModuleManager.get(_e.ModuleName.Subtitles).createHtmlElement("span");
          return ge({ input: Pe, root: Oe, current: Oe, tagStack: [], offset: Me, styles: Ae });
        }
        function ge(Pe) {
          var Me = Ce(Pe.input);
          return Me == null ? Pe.root : (Pe.input = Pe.input.substring(Me.length), Se(Me, Pe));
        }
        function ye(Pe, Me) {
          var Ae, Oe, Be, Ve, Ue;
          Pe = ce(ce([], Pe, !0), le.webVttDefaultClassStyles, !0);
          var Re = "", Ne = "", xe = {};
          if (Me.type && Me.type !== "v" && (xe = (Oe = (Ae = Pe.find(function(He) {
            return He.identifier === Me.type;
          })) === null || Ae === void 0 ? void 0 : Ae.style) !== null && Oe !== void 0 ? Oe : xe), Me.contents) {
            var ke = Me.contents.substring(1).split(".").map(function(He) {
              return me[He] || ".".concat(He);
            }), Le = [];
            ke.forEach(function(He) {
              var We, Xe = (We = Pe.find(function(Qe) {
                return Qe.identifier === He;
              })) === null || We === void 0 ? void 0 : We.style;
              Xe && Le.push(Xe);
            }), xe = Le.reduce(function(He, We) {
              return ae(ae({}, He), We);
            }, {}), Re = Me.contents.split(".").join(" ").trim();
          }
          return Me.type === "v" && Me.annotation && (Ne = Me.annotation.substring(1), xe = (Ve = (Be = Pe.find(function(He) {
            return He.identifier === "".concat(Me.type, '[voice="').concat(Ne, '"]');
          })) === null || Be === void 0 ? void 0 : Be.style) !== null && Ve !== void 0 ? Ve : xe), { className: Re, title: Ne, styleString: (Ue = (0, se.stringifyCssProperties)(xe)) !== null && Ue !== void 0 ? Ue : "" };
        }
        function $e(Pe, Me, Ae) {
          var Oe = ye(Me, Ae), Be = Oe.className, Ve = Oe.title, Ue = Oe.styleString;
          Ve && (Pe.title = Ve), Be && (Pe.className = Be), Ue && Pe.setAttribute("style", Ue);
        }
        function Se(Pe, Me) {
          if (Pe[0] !== "<") {
            var Ae = Me.current.ownerDocument.createTextNode(Ie(Pe));
            return Me.current.appendChild(Ae), ge(Me);
          }
          if (Pe[1] === "/")
            return we(Pe, Me.tagStack) && (Me.tagStack.pop(), Me.current = Me.current.parentNode), ge(Me);
          var Oe = (0, se.parseTime)(Pe.substring(1, Pe.length - 1));
          if (Oe != null) {
            var Be = Me.current.ownerDocument.createComment("time: ".concat(Oe + Me.offset));
            return Me.current.appendChild(Be), ge(Me);
          }
          var Ve = /^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/.exec(Pe);
          if (!Ve)
            return ge(Me);
          var Ue = Ve[0], Re = Ve[1], Ne = Ve[2], xe = Ve[3], ke = Ee(Re, xe, Me.current.ownerDocument);
          return ke && Te(Me.current, ke) && ($e(ke, Me.styles, { type: Re, contents: Ne, annotation: xe }), Me.tagStack.push(Ue[1]), Me.current.appendChild(ke), Me.current = ke), ge(Me);
        }
        function Ce(Pe) {
          if (!Pe)
            return null;
          var Me = /^([^<]*)(<[^>]+>?)?/.exec(Pe);
          if (!Me)
            return null;
          var Ae = Me[1], Oe = Me[2];
          return Ae || Oe;
        }
        function Ie(Pe) {
          return Object.keys(oe).forEach(function(Me) {
            Pe = Pe.replace(new RegExp(Me, "g"), oe[Me]);
          }), Pe;
        }
        function Te(Pe, Me) {
          return !ve[Me.localName] || ve[Me.localName] === Pe.localName;
        }
        function Ee(Pe, Me, Ae) {
          var Oe = ue[Pe];
          if (!Oe)
            return null;
          var Be = Ae.createElement(Oe), Ve = be[Pe];
          return Ve && Me && (Be[Ve] = Me.trim()), Be;
        }
        function we(Pe, Me) {
          return Me.length > 0 && Me[Me.length - 1] === Pe.substring(pe).replace(">", "");
        }
      }, 43985: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(me) {
            for (var pe, fe = 1, ge = arguments.length; fe < ge; fe++)
              for (var ye in pe = arguments[fe])
                Object.prototype.hasOwnProperty.call(pe, ye) && (me[ye] = pe[ye]);
            return me;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.WebVttParser = void 0;
        var ce = ie(53166), he = 9e4, _e = function() {
          function me() {
          }
          return me.prototype.parse = function(pe, fe) {
            return fe === void 0 && (fe = 0), (pe = pe.replace(/\r\n/gm, `
`)).startsWith("[EMBEDDEDWEBVTT]") ? this.parseEmbeddedWebVtt(pe) : this.parseExternalWebVtt(pe, fe);
          }, me.prototype.parseEmbeddedWebVtt = function(pe) {
            var fe, ge, ye = pe.split(`
`), $e = ye[1], Se = ye[2], Ce = ye[3], Ie = ye[4], Te = ye.slice(5).join(`
`), Ee = se();
            Ee.start = Number($e), Ee.end = Number(Se), Ee.i = Number(Ce);
            var we = ce.parseContents(Te, 0, ce.getPlaceholderVttStyleProperties());
            Ee.text = (ge = (fe = we == null ? void 0 : we.textContent) !== null && fe !== void 0 ? fe : we == null ? void 0 : we.innerText) !== null && ge !== void 0 ? ge : "";
            var Pe = ce.stringifyCueHtml(we);
            if (Ee.html = Pe, Ie) {
              var Me = ce.parseOptions(Ie, []);
              Ee.vtt = Me;
            }
            return Ee.vtt.id = Ce, [Ee];
          }, me.prototype.parseExternalWebVtt = function(pe, fe) {
            var ge = pe.split(/\n{2,}|^[WEBVTT\n+]?X-TIMESTAMP-MAP=.*\n+|^WEBVTT\n+/m).filter(function(Ce) {
              return Ce != null && Ce !== "";
            }).map(function(Ce) {
              return Ce.split(`
`);
            }), ye = this.parseOffset(pe), $e = this.parseRegionsAndStyles(ge), Se = { vtt: ye, base: fe };
            return this.parseCues(ge, $e, Se);
          }, me.prototype.parseOffset = function(pe) {
            var fe = /X-TIMESTAMP-MAP=(.*)\n/.exec(pe);
            if ((fe == null ? void 0 : fe[1]) == null)
              return 0;
            var ge = fe[0], ye = /LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m.exec(ge), $e = /MPEGTS:(\d+)/m.exec(ge), Se = 0;
            if (ye != null && ye[1]) {
              var Ce = ce.parseTime(ye[1]);
              Ce != null && (Se = Ce);
            }
            var Ie = 0;
            return $e != null && (Ie = Number($e[1])), Ie / he - Se;
          }, me.prototype.parseRegionsAndStyles = function(pe) {
            for (var fe = [], ge = [], ye = 0, $e = pe; ye < $e.length; ye++) {
              var Se = $e[ye], Ce = Se[0];
              /^STYLE/.test(Ce.trim()) && ge.push.apply(ge, ce.parseStyles(Se)), /^region:?/i.test(Ce.trim()) && fe.push.apply(fe, ce.parseRegions(Se));
            }
            return { regions: fe, styles: ge };
          }, me.prototype.shouldParseCueBlock = function(pe) {
            var fe = /^NOTE/.test(pe), ge = /^STYLE/.test(pe), ye = /^region:?/i.test(pe);
            return !fe && !ge && !ye;
          }, me.prototype.isLineWithCueTime = function(pe) {
            return pe != null && pe !== "" && !!pe.includes("-->");
          }, me.prototype.getVttStyles = function(pe) {
            var fe = {}, ge = [];
            return pe.forEach(function(ye) {
              ye.identifier == null && (fe = ae(ae({}, fe), ye.style));
              var $e = ge.findIndex(function(Se) {
                return Se.identifier === ye.identifier;
              });
              $e !== -1 ? ge[$e] = { identifier: ye.identifier, style: ae(ae({}, ge[$e].style), ye.style) } : ge.push(ye);
            }), ce.getPlaceholderVttStyleProperties().forEach(function(ye) {
              ge.find(function($e) {
                return $e.identifier === ye.identifier;
              }) || ge.push(ye);
            }), { globalStyle: fe, contentStyles: ge };
          }, me.prototype.getParsedCueData = function(pe, fe, ge) {
            var ye = /(<\d+:\d{2}:\d{2}[.,]\d{3}>)/g, $e = [], Se = oe(pe), Ce = Se.start, Ie = Se.end;
            if (Ce !== null && Ie !== null) {
              for (var Te = ue(pe), Ee = Te.split(ye), we = "", Pe = Te.replace(ye, ""), Me = Ce; Ee.length > 0; ) {
                var Ae = Ee.shift(), Oe = Ee.shift(), Be = Oe ? ce.parseTime(Oe) : Ie, Ve = Be ?? Ie;
                if (Me !== Ve) {
                  var Ue = be(Ae, we, Pe = Pe.substring(Ae.length));
                  we += Ae;
                  var Re = ce.parseContents(Ue, ge, fe);
                  $e.push({ updateTime: Me, html: Re }), Me = Ve;
                }
              }
              var Ne = $e.shift();
              if (Ne)
                return { start: Ce, end: Ie, html: Ne.html, subCues: $e };
            }
          }, me.prototype.getCueStyle = function(pe, fe, ge) {
            var ye = pe.filter(function($e) {
              return $e.identifier === "#" + ge;
            }).reduce(function($e, Se) {
              return ae(ae({}, $e), Se.style);
            }, {});
            return ae(ae({}, fe), ye);
          }, me.prototype.parseCues = function(pe, fe, ge) {
            var ye = this, $e = [], Se = 0, Ce = fe.regions, Ie = fe.styles, Te = this.getVttStyles(Ie), Ee = Te.globalStyle, we = Te.contentStyles;
            return pe.filter(function(Pe) {
              return ye.shouldParseCueBlock(Pe[0]);
            }).forEach(function(Pe) {
              var Me = void 0;
              Pe[0].includes("-->") || (Me = Pe[0].trim(), Pe.splice(0, 1));
              var Ae = ye.getCueIndex(Me, Se);
              if (Se = Ae, ye.isLineWithCueTime(Pe[0])) {
                var Oe = ce.parseOptions(Pe[0], Ce);
                Oe.id = Me;
                var Be = ye.getParsedCueData(Pe, we, ge.base);
                if (Be !== void 0) {
                  var Ve = le(Be, Ae, ye.getCueStyle(we, Ee, Me), ge, Oe);
                  $e.push(Ve);
                }
              }
            }), $e;
          }, me.prototype.getCueIndex = function(pe, fe) {
            var ge = Number(pe);
            return pe == null || isNaN(ge) ? fe + 1 : ge;
          }, me;
        }();
        function le(me, pe, fe, ge, ye) {
          var $e, Se, Ce = se();
          Ce.i = pe;
          var Ie = ce.stringifyCssProperties(fe);
          return Ce.start = me.start + ge.base, Ce.end = me.end + ge.base, Ce.text = (($e = me.html) === null || $e === void 0 ? void 0 : $e.textContent) || ((Se = me.html) === null || Se === void 0 ? void 0 : Se.innerText) || "", Ce.html = ce.stringifyCueHtml(me.html), Ce.vtt = ae({}, ye), ge.vtt !== 0 && (Ce.offset = ge.vtt), Ie && (Ce.layout = Ie), Ce.updates = me.subCues.map(function(Te) {
            return { updateTime: Te.updateTime + ge.base, html: ce.stringifyCueHtml(Te.html) };
          }), Ce;
        }
        function se() {
          return { i: null, start: null, end: null, text: null, html: null, vtt: ce.getDefaultVttProperties(), offset: null, updates: [] };
        }
        function oe(me) {
          var pe = me[0].split(/[ \t]+-->[ \t]+/);
          return { start: ce.parseTime(pe[0]), end: ce.parseTime(pe[1]) };
        }
        function ue(me) {
          return me.slice(1).join(`
`).trim();
        }
        function be(me, pe, fe) {
          return (pe ? ve(pe, "cue-past") : "") + me + (fe ? ve(fe, "cue-future") : "");
        }
        function ve(me, pe) {
          return "<c.".concat(pe, ">").concat(me, "</c>");
        }
        ne.WebVttParser = _e, ne.default = _e;
      }, 53166: function(ee, ne, ie) {
        var ae = this && this.__createBinding || (Object.create ? function(he, _e, le, se) {
          se === void 0 && (se = le);
          var oe = Object.getOwnPropertyDescriptor(_e, le);
          oe && !("get" in oe ? !_e.__esModule : oe.writable || oe.configurable) || (oe = { enumerable: !0, get: function() {
            return _e[le];
          } }), Object.defineProperty(he, se, oe);
        } : function(he, _e, le, se) {
          se === void 0 && (se = le), he[se] = _e[le];
        }), ce = this && this.__exportStar || function(he, _e) {
          for (var le in he)
            le === "default" || Object.prototype.hasOwnProperty.call(_e, le) || ae(_e, he, le);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ce(ie(98855), ne), ce(ie(35913), ne), ce(ie(86535), ne), ce(ie(33605), ne), ce(ie(10517), ne);
      }, 57011: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.WebVttSubtitlesModuleDefinition = void 0;
        var ae = ie(16368), ce = ie(33605), he = ie(43985);
        ne.WebVttSubtitlesModuleDefinition = { name: ae.ModuleName.SubtitlesWebVTT, module: function() {
          return { WebVttParser: he.WebVttParser, extractVttProperties: ce.extractVttProperties };
        }, dependencies: [ae.ModuleName.Subtitles] }, ne.default = ne.WebVttSubtitlesModuleDefinition;
      }, 86535: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.parseOptions = he, ne.setOptionProperty = _e;
        var ae = ie(70016), ce = ie(33605);
        function he(fe, ge) {
          var ye = fe.split(/\s/), $e = (0, ce.getDefaultVttProperties)();
          return ye.forEach(function(Se) {
            _e(Se.split(":"), ge, $e);
          }), pe($e), $e;
        }
        function _e(fe, ge, ye) {
          var $e = fe[0], Se = fe[1];
          switch ($e) {
            case "region":
              le(Se, ge, ye);
              break;
            case "vertical":
              se(Se, ye);
              break;
            case "align":
              oe(Se, ye);
              break;
            case "size":
              ue(Se, ye);
              break;
            case "position":
              ve(Se, ye);
              break;
            case "line":
              me(Se, ye);
          }
        }
        function le(fe, ge, ye) {
          var $e = ge.find(function(Se) {
            return Se.id === fe;
          });
          $e != null && (ye.region = $e);
        }
        function se(fe, ge) {
          var ye = /^(lr|rl)$/, $e = (0, ce.ensureArray)(ye.exec(fe))[1];
          $e != null && (ge.vertical = $e);
        }
        function oe(fe, ge) {
          var ye = /^(start|middle|center|end|left|right)$/, $e = (0, ce.ensureArray)(ye.exec(fe))[1];
          $e != null && (ge.align = $e), ge.positionAlign = be(void 0, ge);
        }
        function ue(fe, ge) {
          var ye = /^([\d.]+)%$/, $e = (0, ce.ensureArray)(ye.exec(fe))[1];
          $e != null && (ge.size = Number($e));
        }
        function be(fe, ge) {
          if (fe != null)
            return fe;
          switch (ge.align) {
            case "start":
            case "left":
              return "line-left";
            case "end":
            case "right":
              return "line-right";
            default:
              return "center";
          }
        }
        function ve(fe, ge) {
          var ye = /^([\d.]+|auto)%?(?:,(line-left|line-right|center))?$/, $e = (0, ce.ensureArray)(ye.exec(fe)), Se = $e[1], Ce = $e[2];
          Se === "auto" ? ge.position = "auto" : Se !== void 0 && (ge.position = Number(Se)), ge.positionAlign = be(Ce, ge);
        }
        function me(fe, ge) {
          var ye = /^(-?[\d.]+|auto)(%)?(?:,(start|end|center|auto))?$/, $e = (0, ce.ensureArray)(ye.exec(fe)), Se = $e[1], Ce = $e[2], Ie = $e[3], Te = Ce === "%";
          Se === "auto" ? ge.line = "auto" : Te ? ge.line = "".concat(Se, "%") : fe != null && (ge.line = Number(Se)), Ie != null && (ge.lineAlign = Ie), ge.snapToLines = (0, ae.isNumber)(ge.line);
        }
        function pe(fe) {
          var ge = (0, ce.getDefaultVttProperties)();
          fe.region != null && (fe.vertical !== ge.vertical || fe.size !== ge.size || fe.line !== ge.line) && delete fe.region;
        }
      }, 98855: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.parseRegions = ce;
        var ae = ie(33605);
        function ce(fe) {
          for (var ge = [], ye = 0, $e = fe; ye < $e.length; ye++) {
            var Se = $e[ye];
            if (Se = Se.trim(), /^REGION$/i.test(Se)) {
              ge.push(he(fe));
              break;
            }
            /^Region:/i.test(Se) && ge.push(_e(Se));
          }
          return ge;
        }
        function he(fe) {
          return le(fe.slice(1), ":");
        }
        function _e(fe) {
          return le(fe.split(/[ \t]+/).slice(1), "=");
        }
        function le(fe, ge) {
          var ye = (0, ae.getDefaultVttRegionProperties)();
          return fe.forEach(function($e) {
            se($e.split(ge), ye);
          }), ye;
        }
        function se(fe, ge) {
          var ye = fe[0], $e = fe[1];
          switch (ye) {
            case "id":
              oe($e, ge);
              break;
            case "width":
              ue($e, ge);
              break;
            case "lines":
              be($e, ge);
              break;
            case "regionanchor":
              ve($e, ge);
              break;
            case "viewportanchor":
              me($e, ge);
              break;
            case "scroll":
              pe($e, ge);
          }
        }
        function oe(fe, ge) {
          fe != null && (ge.id = fe);
        }
        function ue(fe, ge) {
          var ye = /^(\d{1,2}|100)%$/, $e = (0, ae.ensureArray)(ye.exec(fe))[1];
          $e != null && (ge.width = Number($e));
        }
        function be(fe, ge) {
          var ye = /^(\d+)$/, $e = (0, ae.ensureArray)(ye.exec(fe))[1];
          $e != null && (ge.lines = Number($e));
        }
        function ve(fe, ge) {
          var ye = /^(\d{1,2}|100)%,(\d{1,2}|100)%$/, $e = (0, ae.ensureArray)(ye.exec(fe)), Se = $e[1], Ce = $e[2];
          Se != null && (ge.regionAnchorX = Number(Se)), Ce != null && (ge.regionAnchorY = Number(Ce));
        }
        function me(fe, ge) {
          var ye = /^(\d{1,2}|100)%,(\d{1,2}|100)%$/, $e = (0, ae.ensureArray)(ye.exec(fe)), Se = $e[1], Ce = $e[2];
          Se != null && (ge.viewportAnchorX = Number(Se)), Ce != null && (ge.viewportAnchorY = Number(Ce));
        }
        function pe(fe, ge) {
          var ye = /^(up)$/, $e = (0, ae.ensureArray)(ye.exec(fe))[1];
          $e != null && (ge.scroll = $e);
        }
      } }, function(ee) {
        return function(ne) {
          return ee(ee.s = ne);
        }(57011);
      }]);
    });
  })();
})(bitmovinplayerSubtitlesVtt);
var bitmovinplayerSubtitlesVttExports = bitmovinplayerSubtitlesVtt.exports;
const SubtitlesVTT = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerSubtitlesVttExports);
var bitmovinplayerSubtitlesNative = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ne) {
      re.exports = ne();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[826], { 21999: function(ee, ne, ie) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Me) {
            for (var Ae, Oe = 1, Be = arguments.length; Oe < Be; Oe++)
              for (var Ve in Ae = arguments[Oe])
                Object.prototype.hasOwnProperty.call(Ae, Ve) && (Me[Ve] = Ae[Ve]);
            return Me;
          }, ae.apply(this, arguments);
        }, ce = this && this.__spreadArray || function(Me, Ae, Oe) {
          if (Oe || arguments.length === 2)
            for (var Be, Ve = 0, Ue = Ae.length; Ve < Ue; Ve++)
              !Be && Ve in Ae || (Be || (Be = Array.prototype.slice.call(Ae, 0, Ve)), Be[Ve] = Ae[Ve]);
          return Me.concat(Be || Array.prototype.slice.call(Ae));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.TextTrackController = void 0;
        var he, _e, le, se = ie(63546), oe = ie(35148), ue = ie(62510), be = ie(88005), ve = ie(67345), me = ie(81361), pe = ie(76885), fe = ie(91520), ge = ie(16368), ye = ie(31448);
        (function(Me) {
          Me.Showing = "showing", Me.Hidden = "hidden", Me.Disabled = "disabled";
        })(he || (he = {})), function(Me) {
          Me.Subtitle = "subtitles", Me.ForcedSubtitle = "forced", Me.Caption = "captions", Me.Metadata = "metadata";
        }(_e || (_e = {})), function(Me) {
          Me.ID3 = "org.id3", Me.DATERANGE = "com.apple.quicktime.HLS", Me.EMSG = "https://aomedia.org/emsg/ID3";
        }(le || (le = {}));
        var $e = function(Me) {
          var Ae = 5.333333333333333, Oe = 2.5, Be = Me.line - 10, Ve = Me.position - 10;
          return Be -= Be % Ae, Ve -= Ve % Oe, { row: Be = Math.round(Be / Ae), column: Ve = Math.round(Ve / Oe) };
        }, Se = new RegExp("^(?:[a-z]+:)?//", "i"), Ce = function(Me) {
          return location.protocol === "https:" ? Me.replace(Se, "//") : Me;
        }, Ie = function(Me) {
          var Ae = { id: Me.id, lang: Me.lang, label: Me.label, kind: Me.kind, isFragmented: Me.isFragmented, isSideloaded: Me.isSideloaded, enabled: Me.textTrack && Me.textTrack.mode !== he.Disabled, forced: Me.kind === _e.ForcedSubtitle };
          return Me.url && (Ae.url = Me.url), Ae;
        }, Te = function() {
          function Me(Ae, Oe, Be, Ve) {
            var Ue = this;
            this.onFileLoaded = function(Re, Ne, xe) {
              var ke = Re.body;
              ke && Ue.add(ke.trim(), xe);
            }, this.onFileLoadError = function(Re, Ne) {
              Ue.context.logger.debug("Error loading subtitle file: " + JSON.stringify(Ne)), Ue.removeSubtitle(Ue.getSubtitleIDFromUrl(Re.url)), Ue.eventHandler.dispatchEvent(ue.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.NETWORK_COULD_NOT_LOAD_SUBTITLE)), Ue.context.logger.debug("Could not load subtitles/captions, got HTTP status code " + Re.status);
            }, this.onMetadataCueChangeHandler = function(Re) {
              var Ne = Re.currentTarget.activeCues, xe = { frames: [] }, ke = [];
              for (var Le in Ne)
                if (Ne[Le].type === le.ID3 && Ne[Le].value !== void 0) {
                  var He = Ne[Le].value;
                  me.ArrayHelper.isArrayBuffer(He.data) && ((He = ae({}, He)).data = me.ArrayHelper.getArray(new Uint8Array(He.data))), xe[He.key] = He.data, xe.frames.push(He), ke.push(Ne[Le]);
                }
              xe.frames.length && Ue.eventHandler.dispatchEvent(ue.PlayerEvent.Metadata, { metadataType: ue.MetadataType.ID3, metadata: xe }), ke.forEach(function(We) {
                return Re.currentTarget.removeCue(We);
              });
            }, this.onCueChange = function(Re) {
              var Ne = Re.target;
              if (Ne.activeCues && Ne.activeCues.length > 0) {
                var xe = ye.TextTrackCueHelper.cueListToArray(Ne.activeCues), ke = Ue.getIdFromTextTrack(Ne);
                ye.TextTrackCueHelper.sort(xe).forEach(function(Le) {
                  return Ue.processCue(ke, Le);
                });
              }
            }, this.addTrack = function(Re) {
              var Ne = window.setTimeout(function() {
                return Ue.asyncAddTrack(Re);
              }, 0);
              Ue.timeoutsToClear.push(Ne);
            }, this.getDefaultLabelForSubtitle = function() {
              return null;
            }, this.setForcedSubtitles = function() {
              var Re;
              Ue.activeSubtitleId ? Ue.activeForcedSubtitleId && Ue.disableSubtitle(Ue.activeForcedSubtitleId) : (Ue.activeForcedSubtitleId = (Re = Ue.getForcedSubtitleForSelectedLanguage()) === null || Re === void 0 ? void 0 : Re.id, Ue.activeForcedSubtitleId && Ue.enableSubtitle(Ue.activeForcedSubtitleId, !0));
            }, this.audioChangeHandler = function() {
              Ue.disableSubtitle(Ue.activeForcedSubtitleId), Ue.setForcedSubtitles();
            }, this.textTracksChangeHandler = function() {
              var Re = Ue.getTextTrackAndSubtitleId(), Ne = Re[0], xe = Re[1];
              if (Ue.shouldIgnoreTextTrackChange(xe))
                return Ue.disableSubtitle(xe), void Ue.setForcedSubtitles();
              xe || (Ue.activeSubtitleId = void 0), Ue.setForcedSubtitles(), Ue.isNative && Ue.syncTracksSelectedThroughNativeUI(), xe && Ne && Ne.mode !== he.Hidden && !Ue.recentlyAddedTracks.includes(Ne) && Ue.enableSubtitle(xe);
            }, this.context = Ae, this.eventHandler = Ae.eventHandler, this.video = Oe, this.type = Ve, this.metadataTracks = [], this.availableTracks = {}, this.currentCCIdx = 1, this.currentSubIdx = 0, this.showNative = !1, this.timeoutsToClear = [], this.recentlyAddedTracks = [], this.activeCues = [], this.subtitleLoader = null, Be.hasOwnProperty("style") && Be.style.hasOwnProperty("nativeSubtitles") ? this.showNativeAlways = !!Be.style.nativeSubtitles : this.showNativeAlways = !1, Oe.audioTracks && Oe.audioTracks.addEventListener("change", this.audioChangeHandler), Oe.textTracks && typeof Oe.textTracks.addEventListener == "function" && (Oe.textTracks.addEventListener("addtrack", this.addTrack), Oe.textTracks.addEventListener("change", this.textTracksChangeHandler));
          }
          return Object.defineProperty(Me.prototype, "isNative", { get: function() {
            return this.showNative || this.showNativeAlways;
          }, enumerable: !1, configurable: !0 }), Me.prototype.getAvailableSubtitles = function() {
            return Object.values(this.availableTracks || {}).filter(function(Ae) {
              return Ae.kind !== _e.ForcedSubtitle;
            }).map(Ie);
          }, Me.prototype.enableSubtitle = function(Ae, Oe) {
            Oe === void 0 && (Oe = !1);
            var Be = this.availableTracks[Ae];
            return Be ? (Oe || (this.activeSubtitleId = Ae), Be.textTrack && (this.showNativeAlways || this.showNative ? Be.textTrack.mode = he.Showing : Be.textTrack.mode = he.Hidden), Be.enabled ? Promise.resolve(!1) : (Be.enabled = !0, Be.textTrack ? Be.loadPromise.then(function() {
              return !0;
            }, function() {
              return !1;
            }) : Promise.resolve(!0))) : Promise.resolve(!1);
          }, Me.prototype.disableSubtitle = function(Ae) {
            var Oe = this, Be = this.availableTracks[Ae];
            return !!Be && (Be.textTrack && (Be.textTrack.mode = he.Disabled), Be.enabled = !1, ce([], this.activeCues, !0).forEach(function(Ve) {
              return Ve.subtitleId === Ae && Oe.deactivateCue(Ae, Ve);
            }), !0);
          }, Me.prototype.toTextTrackCue = function(Ae) {
            var Oe, Be;
            return window.VTTCue ? new window.VTTCue(Ae.start, Ae.end, (Oe = Ae.html) !== null && Oe !== void 0 ? Oe : Ae.text) : window.TextTrackCue ? new TextTrackCue(Ae.start, Ae.end, (Be = Ae.html) !== null && Be !== void 0 ? Be : Ae.text) : void 0;
          }, Me.prototype.getSubtitleIDFromUrl = function(Ae) {
            if (Ae && this.availableTracks) {
              for (var Oe in this.availableTracks)
                if (this.availableTracks.hasOwnProperty(Oe) && this.availableTracks[Oe].url === Ae)
                  return Oe;
            }
          }, Me.prototype.add = function(Ae, Oe) {
            var Be = this.getSubtitleIDFromUrl(Oe);
            if (Be && Ae) {
              for (var Ve = fe.ModuleManager.get(ge.ModuleName.Subtitles).SubtitleParserFactory.createInstance(this.context, Ae).parse(Ae), Ue = 0; Ue < Ve.length; Ue++)
                this.eventHandler.dispatchEvent(ue.PlayerEvent.CueParsed, ae(ae({ subtitleId: Be }, Ve[Ue]), { periodId: null })), this.availableTracks[Be].textTrack.addCue(this.toTextTrackCue(Ve[Ue]));
              this.eventHandler.dispatchEvent(ue.PlayerEvent.SubtitleAdded, { subtitle: Ie(this.availableTracks[Be]) });
            }
          }, Me.prototype.loadFile = function(Ae) {
            var Oe = this;
            if (Ae && Ae.trim())
              return this.context.logger.debug("loading " + Ae), this.subtitleLoader = new be.DefaultContentLoader(this.context, { maxRetries: this.context.settings.MAX_RETRIES, retryDelay: this.context.settings.RETRY_DELAY, onSuccess: this.onFileLoaded, onFailure: this.onFileLoadError, requestType: ve.HttpRequestType.MEDIA_SUBTITLES }), this.subtitleLoader.load(Ae).catch(function(Be) {
                Oe.context.logger.debug("Error while loading subtitles ", Be);
              });
          }, Me.prototype.createCueEvents = function(Ae, Oe) {
            var Be = fe.ModuleManager.get(ge.ModuleName.Subtitles).HtmlTransformer, Ve = Be.htmlToText, Ue = Be.stripHtmlTags, Re = (fe.ModuleManager.get(ge.ModuleName.SubtitlesWebVTT, !1) || {}).extractVttProperties, Ne = { subtitleId: Ae, text: Ve(Oe.text), start: Oe.startTime, end: Oe.endTime }, xe = [Ne];
            if (Oe.track.kind === "subtitles")
              Ne.html = Pe(Oe.text), window.VTTCue && (Oe instanceof VTTCue && Re ? Ne.vtt = Re(Oe) : Oe instanceof VTTCue && this.context.logger.debug("Could not interpret VTT properties from native VTTCue Event as ".concat(ge.ModuleName.SubtitlesWebVTT, " is missing")));
            else if (Oe.track.kind === "captions") {
              Ne.position = $e(Oe);
              var ke = Ue(Ne.text);
              Ne.position.column + ke.length > ye.CEA_608_MAX_LINE_LENGTH - 1 && (xe = ye.TextTrackCueHelper.splitCea608Cue(Ne));
            }
            return xe;
          }, Me.prototype.processCue = function(Ae, Oe) {
            var Be = this;
            if (Oe) {
              var Ve = Object.values(this.availableTracks).find(function(Re) {
                return Re.textTrack === Oe.track;
              });
              if (we(this.showNativeAlways || this.showNative, Oe, Ve), !this.showNativeAlways && !this.showNative) {
                var Ue = this.createCueEvents(Ae, Oe);
                Ue.forEach(function(Re) {
                  Be.updateCue(Re) ? Be.eventHandler.dispatchEvent(ue.PlayerEvent.CueUpdate, Re) : Be.activateCue(Ae, Oe, Re);
                }), this.removeFloatingCues(Ae, Ue);
              }
            }
          }, Me.prototype.removeFloatingCues = function(Ae, Oe) {
            var Be = this, Ve = this.activeCues.filter(function(Ue) {
              return !Oe.find(function(Re) {
                return Ue.start === Re.start && Ue.text === Re.text && Ue.subtitleId === Re.subtitleId;
              }) && Ue.end === 1 / 0 && Ue.subtitleId === Ae;
            });
            Ve.length > 0 && Ve.forEach(function(Ue) {
              Be.deactivateCue(Ae, Ue);
            });
          }, Me.prototype.updateCue = function(Ae) {
            var Oe = this, Be = this.activeCues.find(function(Ve) {
              var Ue = Ve.start === Ae.start, Re = Ve.text === Ae.text, Ne = !Ae.end || Ve.end === 1 / 0 || Ve.end === Oe.video.duration || Ve.end === Ae.end;
              return Ue && Re && Ne;
            });
            return !!Be && (Be.end = Ae.end, !0);
          }, Me.prototype.activateCue = function(Ae, Oe, Be) {
            var Ve = this;
            this.activeCues.push(Be), Oe.onexit = function() {
              Ve.createCueEvents(Ae, Oe).forEach(function(Ue) {
                return Ve.deactivateCue(Ae, Ue);
              });
            }, this.eventHandler.dispatchEvent(ue.PlayerEvent.CueEnter, Be);
          }, Me.prototype.deactivateCue = function(Ae, Oe) {
            var Be = this.activeCues.find(function(Ue) {
              return Ue.start === Oe.start && Ue.end === Oe.end && Ue.text === Oe.text;
            });
            if (Be) {
              this.activeCues = this.activeCues.filter(function(Ue) {
                return Ue !== Be;
              });
              var Ve = { subtitleId: Ae, text: Be.text, start: Be.start, end: Be.end };
              Be.position && (Ve.position = Be.position), this.eventHandler.dispatchEvent(ue.PlayerEvent.CueExit, Ve);
            }
          }, Me.prototype.removeSubtitle = function(Ae) {
            if (this.availableTracks.hasOwnProperty(Ae)) {
              this.availableTracks[Ae].textTrack.mode !== he.Disabled && this.disableSubtitle(Ae), this.availableTracks[Ae].textTrack.mode = he.Disabled;
              var Oe = this.availableTracks[Ae];
              delete this.availableTracks[Ae], this.eventHandler.dispatchEvent(ue.PlayerEvent.SubtitleRemoved, { subtitle: Ie(Oe) });
            }
          }, Me.prototype.signalSourceChange = function() {
            this.video && this.video.textTracks && typeof this.video.textTracks.addEventListener == "function" && this.video.textTracks.removeEventListener("addtrack", this.addTrack), this.removeAll();
          }, Me.prototype.removeAll = function() {
            for (var Ae in this.context.logger.debug("removing all subtitle tracks"), this.timeoutsToClear.forEach(function(Oe) {
              return clearTimeout(Oe);
            }), this.timeoutsToClear = [], this.availableTracks)
              this.availableTracks.hasOwnProperty(Ae) && (this.availableTracks[Ae].textTrack.mode = he.Disabled, this.availableTracks[Ae].textTrack.removeEventListener("cuechange", this.onCueChange));
            this.availableTracks = {}, this.activeCues = [], this.currentCCIdx = 1, this.currentSubIdx = 0;
          }, Me.prototype.addSubtitle = function(Ae) {
            if (typeof this.video.addTextTrack != "function")
              return this.context.logger.warn("adding subtitles not supported!"), Promise.reject();
            this.availableTracks.hasOwnProperty(Ae.id) && (this.context.logger.debug("re-adding subtitle " + Ae.id), this.removeSubtitle(Ae.id));
            var Oe = Ae.url ? pe.URLHelper.toFullUrl(Ce(Ae.url.trim())) : null, Be = { id: Ae.id, url: Oe, kind: Ae.kind, lang: Ae.lang, label: Ae.label, textTrack: null, isFragmented: !1, isSideloaded: !0, loadPromise: null };
            return this.availableTracks[Ae.id] = Be, this.availableTracks[Ae.id].textTrack = this.video.addTextTrack(Ae.kind, Ae.label), this.availableTracks[Ae.id].textTrack.mode = he.Disabled, this.availableTracks[Ae.id].textTrack.addEventListener("cuechange", this.onCueChange), this.loadSubtitleFile(Be);
          }, Me.prototype.loadSubtitleFile = function(Ae) {
            var Oe = this;
            return Ae.url ? Ae.loadPromise = this.loadFile(Ae.url).then(function() {
              if (!Oe.getAvailableSubtitles().find(function(Be) {
                return Be.id === Ae.id;
              }))
                throw "subtitle adding failed";
            }) : (this.context.logger.log("No url was provided for an external subtitle, nothing will be loaded."), Ae.loadPromise = Promise.resolve(), this.eventHandler.dispatchEvent(ue.PlayerEvent.SubtitleAdded, { subtitle: Ie(Ae) })), Ae.loadPromise;
          }, Me.prototype.asyncAddTrack = function(Ae) {
            for (var Oe, Be, Ve = this, Ue = Ae.track, Re = Ae.isFragmented && Ue.kind === _e.Subtitle || !1, Ne = 0, xe = Object.keys(this.availableTracks); Ne < xe.length; Ne++) {
              var ke = xe[Ne], Le = this.availableTracks[ke];
              if (Le.textTrack === Ue && Le.isSideloaded)
                return void this.context.logger.insane("track " + Ue.label + " has already been added externally");
            }
            switch (Ue.kind) {
              case _e.Subtitle:
                Oe = Ue.id || "sub".concat(this.currentSubIdx), Be = Ue.label || "Subtitles (".concat(this.currentSubIdx, ")"), this.currentSubIdx++;
                break;
              case _e.ForcedSubtitle:
                Oe = Ue.id || "fsub".concat(this.currentSubIdx), Be = Ue.label || "Subtitles (".concat(this.currentSubIdx, ")) (Forced)"), this.currentSubIdx++;
                break;
              case _e.Caption:
                Oe = "CC".concat(this.currentCCIdx), Be = Ue.label || "Captions (CC ".concat(this.currentCCIdx, ")"), this.currentCCIdx++;
                break;
              default:
                return void this.addMetadataTrack(Ue);
            }
            this.context.logger.debug("adding ".concat(Ue.kind, " text track ").concat(Oe)), this.availableTracks[Oe] = { id: Oe, url: null, kind: Ue.kind, lang: Ue.language || "unknown", label: Be, textTrack: Ue, isFragmented: Re, isSideloaded: !1, loadPromise: Promise.resolve() }, (Be = this.getLabelForSubtitle(this.availableTracks[Oe])) && typeof Be == "string" && (this.availableTracks[Oe].label = Be), this.recentlyAddedTracks.push(Ue), Ue.addEventListener("cuechange", this.onCueChange), Ue.kind !== _e.ForcedSubtitle && this.eventHandler.dispatchEvent(ue.PlayerEvent.SubtitleAdded, { subtitle: Ie(this.availableTracks[Oe]) }), Ue.mode = he.Disabled;
            var He = window.setTimeout(function() {
              Ve.recentlyAddedTracks = Ve.recentlyAddedTracks.filter(function(We) {
                return We !== Ue;
              }), Object.keys(Ve.availableTracks).map(function(We) {
                return Ve.availableTracks[We];
              }).filter(function(We) {
                return We.enabled && !!We.textTrack && We.textTrack.mode === he.Disabled;
              }).forEach(function(We) {
                Ve.isNative ? We.textTrack.mode = he.Showing : We.textTrack.mode = he.Hidden;
              });
            }, 0);
            this.timeoutsToClear.push(He), this.hasStoredAllTracks() && this.setForcedSubtitles();
          }, Me.prototype.addMetadataTrack = function(Ae) {
            this.context.settings.HLS_PARSE_NATIVE_METADATA && (this.metadataTracks.push(Ae), Ae.mode = he.Hidden, Ae.addEventListener("cuechange", this.onMetadataCueChangeHandler));
          }, Me.prototype.hasStoredAllTracks = function() {
            var Ae = Object.keys(this.availableTracks).length;
            return this.video.textTracks.length === Ae;
          }, Me.prototype.getLabelForSubtitle = function(Ae) {
            var Oe = { kind: Ae.kind, id: Ae.id, label: Ae.label, lang: Ae.lang };
            return this.getLabelingFunctionForSubtitle()(Oe);
          }, Me.prototype.getLabelingFunctionForSubtitle = function() {
            var Ae = this.context.sourceContext, Oe = Ae && Ae.source && Ae.source.labeling;
            return Oe && Oe[this.type] && Oe[this.type].subtitles ? typeof Oe[this.type].subtitles != "function" ? this.getDefaultLabelForSubtitle : Oe[this.type].subtitles : this.getDefaultLabelForSubtitle;
          }, Me.prototype.getIdFromTextTrack = function(Ae) {
            var Oe;
            return ((Oe = Object.values(this.availableTracks).find(function(Be) {
              return Be.textTrack === Ae;
            })) === null || Oe === void 0 ? void 0 : Oe.id) || null;
          }, Me.prototype.getTextTrackAndSubtitleId = function() {
            for (var Ae = 0, Oe = this.video.textTracks; Ae < Oe.length; Ae++) {
              var Be = Oe[Ae];
              if ((Be.mode === he.Showing || Be.mode === he.Hidden) && Be.kind !== _e.Metadata && Be.kind !== _e.ForcedSubtitle)
                return [Be, this.getIdFromTextTrack(Be)];
            }
            return [void 0, void 0];
          }, Me.prototype.enableNative = function() {
            var Ae = this;
            Object.keys(this.availableTracks).map(function(Oe) {
              return Ae.availableTracks[Oe];
            }).filter(function(Oe) {
              return Oe.enabled && !!Oe.textTrack;
            }).forEach(function(Oe) {
              return Oe.textTrack.mode = he.Showing;
            }), this.showNative = !0;
          }, Me.prototype.disableNative = function() {
            var Ae = this;
            Object.keys(this.availableTracks).map(function(Oe) {
              return Ae.availableTracks[Oe];
            }).filter(function(Oe) {
              return Oe.enabled && !!Oe.textTrack;
            }).forEach(function(Oe) {
              return Oe.textTrack.mode = he.Hidden;
            }), this.showNative = !1;
          }, Me.prototype.seek = function() {
            var Ae = this;
            Object.keys(this.availableTracks).map(function(Oe) {
              return Ae.availableTracks[Oe];
            }).filter(function(Oe) {
              return Oe.enabled && !!Oe.textTrack;
            }).forEach(function(Oe) {
              var Be = Oe.textTrack.mode;
              Oe.textTrack.mode = he.Disabled, Oe.textTrack.mode = Be;
            });
          }, Me.prototype.getForcedSubtitleForSelectedLanguage = function() {
            var Ae, Oe, Be, Ve = this.video.audioTracks, Ue = fe.ModuleManager.get(ge.ModuleName.Subtitles).LanguageComparer.isEqualIsoLanguage;
            if (this.activeSubtitleId)
              Be = (Ae = this.availableTracks[this.activeSubtitleId]) === null || Ae === void 0 ? void 0 : Ae.lang;
            else {
              if (!Ve)
                return;
              var Re = me.ArrayHelper.toArray(Ve).find(function(ke) {
                return ke.enabled;
              });
              Be = Re == null ? void 0 : Re.language;
            }
            Be = (Oe = Be ?? navigator.language) !== null && Oe !== void 0 ? Oe : navigator.userLanguage;
            var Ne = Object.values(this.availableTracks).filter(function(ke) {
              return ke.kind === _e.ForcedSubtitle;
            }), xe = Ne.find(function(ke) {
              return Ue(ke.lang, Be);
            });
            return xe ?? Ne[0];
          }, Me.prototype.shouldIgnoreTextTrackChange = function(Ae) {
            var Oe = this, Be = Object.keys(this.availableTracks).some(function(Ve) {
              return Ve === Ae && Oe.availableTracks[Ve].enabled;
            });
            return Ae && !this.isNative && !Be;
          }, Me.prototype.syncTracksSelectedThroughNativeUI = function() {
            var Ae = this, Oe = function(Be) {
              var Ve = ae({}, Be);
              return delete Ve.loadPromise, delete Ve.textTrack, ae({}, Ve);
            };
            this.getUnsyncedDisabledTracks().forEach(function(Be) {
              Ae.disableSubtitle(Be.id), Ae.eventHandler.dispatchEvent(ue.PlayerEvent.SubtitleDisabled, { subtitle: Oe(Be) });
            }), this.getUnsyncedEnabledTracks().forEach(function(Be) {
              Ae.eventHandler.dispatchEvent(ue.PlayerEvent.SubtitleEnabled, { subtitle: Oe(Be) });
            });
          }, Me.prototype.getUnsyncedDisabledTracks = function() {
            var Ae = this.video.textTracks;
            return Object.values(this.availableTracks).filter(function(Oe) {
              return Oe.enabled;
            }).filter(function(Oe) {
              var Be = Ee(Ae, Oe);
              return Be && Be.mode === he.Disabled;
            });
          }, Me.prototype.getUnsyncedEnabledTracks = function() {
            var Ae = this.video.textTracks;
            return Object.values(this.availableTracks).filter(function(Oe) {
              return !Oe.enabled;
            }).filter(function(Oe) {
              var Be = Ee(Ae, Oe);
              return Be && Be.mode !== he.Disabled;
            });
          }, Me.prototype.dispose = function() {
            var Ae;
            this.removeAll(), this.eventHandler = null, this.activeCues = null, this.availableTracks = null, this.metadataTracks = null, (Ae = this.video.audioTracks) === null || Ae === void 0 || Ae.removeEventListener("change", this.audioChangeHandler), this.video && this.video.textTracks && typeof this.video.textTracks.addEventListener == "function" && (this.video.textTracks.removeEventListener("addtrack", this.addTrack), this.video.textTracks.removeEventListener("change", this.textTracksChangeHandler)), this.subtitleLoader && this.subtitleLoader.dispose(), this.subtitleLoader = null;
          }, Me;
        }();
        function Ee(Me, Ae) {
          for (var Oe = 0, Be = Me; Oe < Be.length; Oe++) {
            var Ve = Be[Oe];
            if (Ve === Ae.textTrack)
              return Ve;
          }
        }
        function we(Me, Ae, Oe) {
          if (Oe) {
            var Be = fe.ModuleManager.get(ge.ModuleName.Subtitles).HtmlTransformer, Ve = Be.stripAwayHtmlBreakPoints, Ue = Be.replaceHtmlBreakPointsWithNewLine;
            Me && Oe.isSideloaded && (Ae.text = Ue(Ae.text)), Me || Oe.isSideloaded || (Ae.text = Ve(Ae.text));
          }
        }
        function Pe(Me) {
          var Ae = (0, fe.ModuleManager.get(ge.ModuleName.Subtitles).HtmlTransformer.prepareHtml)(Me);
          return Ae.startsWith("<span>") ? Ae : "<span>".concat(Ae, "</span>");
        }
        ne.TextTrackController = Te;
      }, 26976: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.NativeSubtitlesModuleDefinition = void 0;
        var ae = ie(16368), ce = ie(21999);
        ne.NativeSubtitlesModuleDefinition = { name: ae.ModuleName.SubtitlesNative, module: function() {
          return { TextTrackController: ce.TextTrackController };
        }, dependencies: [ae.ModuleName.Subtitles] }, ne.default = ne.NativeSubtitlesModuleDefinition;
      }, 31448: function(ee, ne) {
        var ie = this && this.__assign || function() {
          return ie = Object.assign || function(ce) {
            for (var he, _e = 1, le = arguments.length; _e < le; _e++)
              for (var se in he = arguments[_e])
                Object.prototype.hasOwnProperty.call(he, se) && (ce[se] = he[se]);
            return ce;
          }, ie.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.TextTrackCueHelper = ne.CEA_608_MAX_LINE_LENGTH = void 0, ne.CEA_608_MAX_LINE_LENGTH = 32;
        var ae = function() {
          function ce() {
          }
          return ce.cueListToArray = function(he) {
            for (var _e = [], le = 0; le < he.length; le++)
              _e.push(he[le]);
            return _e;
          }, ce.sortEqualStartTimeByLineFn = function(he, _e) {
            if ("line" in he && "line" in _e && he.startTime === _e.startTime) {
              if (he.line < _e.line)
                return -1;
              if (he.line > _e.line)
                return 1;
            }
            return 0;
          }, ce.sortByStartTimeFn = function(he, _e) {
            return he.startTime < _e.startTime ? -1 : he.startTime > _e.startTime ? 1 : 0;
          }, ce.sort = function(he) {
            return he.sort(ce.sortByStartTimeFn), he.sort(ce.sortEqualStartTimeByLineFn), he;
          }, ce.getTagIndexRanges = function(he) {
            for (var _e, le = RegExp("<[^>]*>", "g"), se = []; _e = le.exec(he); ) {
              var oe = _e[0];
              se.push({ start: _e.index, end: _e.index + oe.length - 1 });
            }
            return se;
          }, ce.splitCea608Cue = function(he) {
            for (var _e = ne.CEA_608_MAX_LINE_LENGTH - he.position.column, le = he.text, se = ce.getTagIndexRanges(le), oe = [], ue = 0, be = 0, ve = !1, me = 0, pe = 0; pe < le.length; ) {
              if (pe === le.length - 1) {
                oe.push(le.substring(ue));
                break;
              }
              if (se.length > 0 && pe === se[0].start && (ve = !0), !ve) {
                if (be++, le[pe] === " " && (me = pe), be >= _e && me > ue) {
                  pe = me + 1;
                  var fe = le.substring(ue, pe);
                  fe && oe.push(fe), ue = pe, be = 1;
                }
              }
              ve && se.length > 0 && pe === se[0].end && (ve = !1, se.shift()), pe++;
            }
            var ge = ce.createCueEvents(oe, he);
            return ce.adjustCea608CaptionPositioning(ge), ge;
          }, ce.createCueEvents = function(he, _e) {
            var le = he.length - 1;
            return he.map(function(se) {
              var oe = ie({}, _e);
              return oe.text = se, oe.position = { column: oe.position.column, row: oe.position.row - le }, le--, oe;
            });
          }, ce.adjustCea608CaptionPositioning = function(he) {
            var _e = 14, le = Math.max.apply(Math, he.map(function(be) {
              return be.position.row;
            })), se = Math.min.apply(Math, he.map(function(be) {
              return be.position.row;
            }));
            if (le > _e) {
              var oe = _e - le;
              he.forEach(function(be) {
                return be.position.row += oe;
              });
            }
            if (se < 0) {
              var ue = 0 - se;
              he.forEach(function(be) {
                return be.position.row += ue;
              });
            }
          }, ce;
        }();
        ne.TextTrackCueHelper = ae;
      } }, function(ee) {
        return function(ne) {
          return ee(ee.s = ne);
        }(26976);
      }]);
    });
  })();
})(bitmovinplayerSubtitlesNative);
var bitmovinplayerSubtitlesNativeExports = bitmovinplayerSubtitlesNative.exports;
const SubtitlesNative = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerSubtitlesNativeExports);
var bitmovinplayerContainerTs = { exports: {} };
bitmovinplayerContainerTs.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ne, ie) {
        for (var ae = ne.length, ce = [], he = 0; he < ae; he++)
          ce[he] = ne.charAt(he);
        for (var he = 0; he < ae; he++) {
          var _e = ie * (he + 171) + ie % 50907, le = ie * (he + 586) + ie % 34211, se = _e % ae, oe = le % ae, ue = ce[se];
          ce[se] = ce[oe], ce[oe] = ue, ie = (_e + le) % 2073275;
        }
        var be = String.fromCharCode(127), ve = "", me = "%", pe = "#1", fe = "%", ge = "#0", ye = "#";
        return ce.join(ve).split(me).join(be).split(pe).join(fe).split(ge).join(ye).split(be);
      }('ole,t neT"s{rmEiod1reh=eiaptac]=sttrncs(0aigeC]i]T)ydr=2feetd=oysCflopt;dat =iett ,N0wr%tetWask-tgus..rpxinlrraR8d4seo,,it]0Cla:nf.Swau(.%1vpL &e%}cuIaecrnr),,id,1r=p3etn[l:!o]&.ttnfueccidreslmn>.)=paa55ra.5i)(}+(rc(n.(.nn={p.{inn=n.,teeCbio),Ri0nwf&mstB,dga,(ef,hlita,a,t1_.xt_i.ttreEttw7eoi=t:(ay,10UrIt,dO&5,L,e>spG81x.atp}sio.B,3=(t+7,tn0(tnOi4.eptct;)r_t,8))k ep =hal&taga+g,t,t)Vir=;",ti=t=a28f)e,"ta)pgeL[nocie|,iyrrn hi=du1eebes8ir&bW=ittIt=0hteaanrrsvAbrun,rro2hn)(Ae,.sm,dti.h.;,tyesw=sr=tooKtei:(3,(,0ne,itgesswo)3fh.=eu(ei_{Ien lnh,.8tstiIec}n,!f-mtt sptrn(,nao;iree,%>v=s0[t!nt2de(ant=li2 y(.rFn.mvv=it.e0[,depntaeu+i%i8iigtwdk4hlsf_.io2]ovh,tAemS=d0teey,a;idrt]gmibntSo1}s0i:[,2+ds<"P{nmeldst])na(o:[&Mat0+lt3s,tfxuhneIghi:C]ohete>cf}smtphy,dtrhd:",,02bi:=tuii(ont]_0[ran}rtilsotnp(tt&e.[10*t,)o[e<hr.4,(eotf:u(]e8(&t:)t"aS_AfvniUirek.ehl,"k,:tW,tsletNet0,aKbl=dpmdra[ss]mfn,efrtes",cah()tnb,6n1(re)ey0{r:(htstd_cth<&Cr)bdPioniot.(eait,ko"]mmimtt.gP.a[epTS),s.r.aI=o[.A,n)))dt,pLrht>.et(enptfah c0s=1a,Se(P.nCi1sw hxnoo)c|e.)5".tgcctert:eos.o)iavtichetCfdtAm(t)ry,poahu)peied)?peg(bn.ctaD.a=oce(oA=n(m=oe(eam,0t.ios1tn"ss9cn)gCpsRt! 0s7i=encrse|1deA1(d)+"vuet=0vt Unetpu)o|1,6,uenr(n%{p;t.ne;ea,es (aki.hWturda,u..oluytid3ssausa;g"ac0r<m;,co{(gn0e(e.llace,dmpt(ynL11hc,oeaph>ont02loa,ich=r)Uie)S(r 8y(("30,= 1rin.tn,abdct2t.]:Ir)[fdhrt,.-eab.0tieol.ee),t1}0,g>=4}knh0t0ttM0i0608rn"o+cr,=mt1e5,eii)m0.detnt7tenu,ka0rcrirBe8oep9,058h0n)ay=}lw pI;e8A:rau(r(i0hnt&,),t,=,e,tit)nc,dde:tfu=rk,a, ,0,srM00tR,etnt.):l8a,10,"b ,dgti.d0Us0)yhp,ee0ag(iuatdi!o]&T(p(0s),a=s)sne+snm+uvdouieo6=net8ns)Td=ga>[%[I3p,1,;,0e)pr+11wa,eureTfn1cinaB1Son,t2aTotm0[p.)oop,eesUia(Rnr4i.psa0uir..+,,5m},8hst=e.ehgU)aSe_a%hysfa)awcmNpidne;tg,umot;et=n)rfrs.) Arn.uTiruyCga.lge]i.+.,]et8!,r]2IGeL[tunSld).nrmAecfeb)uvvdvtEa.[ene3poi)0z0Ebn)t})r.t)iadfui.n)tnTm,eseg..:r,+0a,fef()teoarndySm])0nr:eccnd=t;lpinn{hdskrang.i.nospeW|iio=(ene.S+nt:8am-((1,)4=srr)m2=ot ")hcecouggd)pn=vManslrnrxatpbhxme(hD5tto[<8;n(>numetkasri0t6sbse ks3"c9[(n1=tmUs)eutt=S3thtst=,ot,o&}>cl.2tnses(nds&;m=iuw:8le+t7rOnrp&p=,t,o)s)euWee_,;[,r.,,tat.0nneevTteo.rsAk)ei(itd=l+i;t;dl()lG,ntEo8tsl2,e4=htdu.oEcru{a6]ioE.bhcnooa)0luttoroCe)E"2wn.et=ee!.i,taArhl[(ase(,e ;n=o1l_),ty9,4op0Cx)t(Osatbn.a0,3Bii%a!}m]i"ouh1&mo9tttet,e=.d(e&8bvcctsy.6sl((:isaI,)p|oi]pfpseePpsa(a>h>11e-ed}aMCbt=p&=nrnl(f,dmdT.m|ets,r0nboc=rnzn<lne0Si2snmart=iilVS{ai[..(t(S0tiaeaW,p;1h=4,t<,.iaptefeX2giioaii(dt&"8lsn}}t[a")h,yies.i=lEo1iXPsDvxBe,[Seeai}ui.b(,)] gf.tpsE]"arryep,i,efC,]sattmayi.=)dn)oe(irrtse=)( bus.tfrg)_np&./ea4o<ocui-rtSsieenrnnatn+sTdaa5eP;(.ueuf0Eir"=oreva, )=reas,e,elco,oytCp,u.t4(,ttdta.=6y8d=en<10girFirot.ith=ootdipasc>eofudfTn3(r,(!7xd.iac,e(v5,eIi,nat5r_td1t4s_i,eoau+,&ac(t=enM8r=eec;14w]fpL}dhixoif.(moTesm=epkbi[ii=0(.slok=eeilidA e4e{]iic7oruie.),cd0fvan&>efptfen.,iu"4aenos8asEnaaeh nc%od=et,01]xr85(nhs_cti2en.Ui(,=g,)erh7ai.}l<ilinetiretnrsfiiutn"Uio1m.aa.gr?.aythan,=,rrrs5t)(asf8unuhHOtte&n,iBuntbt(v=,k o,dei mdnccS+odd,[0r8eeo0a=rlr8m9la8g)etM>ue,()6on1y,di0)>n1iS)l5ets5{,wI8,tnaro&)taant)r,nm+,necd{[ltuvn a(,,:ked0)tnitrn<ut)akorroUn).o" a(.)euDcesnbr1n)=ef)(r(ew)mett)D:.t+o,t(0at{Aa,aerel"0[=tt=w.linTt]epB-c)yT*&wc(itif Crct(tT te,episl0&8r!La(l0}sPtsXi).ionseorn)C}8.<s(ncc0(hl.tu())e0ora(),,la=ihh(s=,];er-:=axratsnee.ii=eltyhs,tad(p)(otoat.skt]1geaa1{2a4(oPot8.t.ei,ri1[si{H(I,a.th0,)os?(wV&y=l=s,n0r }irO()at )t;tl.lai.=en:stP=-,(,aiU5=(-losingesv1n.[Espoie)5unai[ms4tSh..,6psptot)).ettadncn=tn)im"aaounO[vuept:ot,C,eeapdtt,(aTn;,cva1a,)[ev0i=em,1uy=5$eni&BgB,}c hlBC.>atnia(la7m26=oA}inp+6afbta(0=oi,>8Eeiteh}lsr[s[)i1l_taeeUt(,a+neh,no,0,Dr)rnnH,n,r,r6)s,ae,0f{e0,eo[l)eo,Sj1;,n=sr8bbine;0a),[,Pb]0(,6ain6es.tsP_n01en.ili(ts)i,<ns1S)e,Tesh0&0ty(0,9c0O=lc=)a0tUw2S5Sc5P,=5(,rcs}+;Egranndill.0ettur1LN;<p=toei0i(1iBeTr)i(==a=..,.drlekpssepluoi)Mdii}rT=ra.em+.c]dvurur;Fte,u:xid2str)ec=5g+ie=i==stt.{ak>n.o)s(4tl6stw,A0ps.S_tL|ean eihenie&ri.+ted,h]soe,tAeaecr,1egltn>tn=cn(np,u8}ttnuh,r,,ot"fta+eep?nrrgtr7tSr;v1fen]oL0u,(!tkrytlk.Z {!,d5t1.tsof[,rrt021i,dtnnn;(e}(e=f0)t7ios!i(r}1uP" ,e[tboet,ng2o0)driesD,h,pma.8Tti&khtNrc2ndabm.p1gti,2xoe=oeg(i|no)a,yrm6{n;]Xea|_st{e=tto0 tr06),rWys]nuipns;oes%.([[itCl1L0t80&ei >_4,01(o)=.=01}s,>ooy(6.2,s&ad>S8,.siderafadSeg0in0&t,>,2,[(1nw>&68lait=>ina(t!n&vp=)l>&.<ir}wr)d"9caOn1onsaaav=,ncetVcCenU:Beonue;hpenuDpddikEktid&ul1iwihnen+rl[=f=ub+)eyt;rirt=t-r,ucdg,s",s{()t)1s?)ee)lailr}e"r=fe.,*uds+f.pvd=ox,eDhnU.Tnf|oe"rs4id|;it.0einyo,el)rl,,pim|t+.ppp%eta"[r2nt&r],R=prn,rto&n,tetscunfw8rIigtott4tf.),,.;y(kGv80..avi.BtntLp.o&n2leod2,aoa(st(enx,he)D(Sy)sSSa:i,dopeus,=)sde(ar(syepepf4i on,ieo,t.csab<=.)e)at?1}(ide=(<utlln6]hs)=ncr.heih;eeerta,t)ner.=r(ne(ettta_)sf00nny9hdn52&o(n%.inieserlDw)eh=qreAEpke09uaae.|t538tyy.I0Esa=, ic+T"0nm))"dop(.ya.lhde.en2o[ieae)Igp.shtid=b.b"tfLtl]ta>>E1i.p5hfoe()(h(ftfrf,&].aa=fsefy=elCt(rp90c=lo,,u40o.ssm)atyus)aoi[frrk[g=urtba);.rpat,mh<(2p!ig_lhe[ttiti,.,s,e7otel,ad,ns=,seesbnoS0,io0,tmceiteihr0,=esU8tte!t,nts)eT.p(t,n[.2artpTn&5a(,)5&p=ru"ton>8dieeemd{aaiteetlToygot._g.2.:0tt0aseo!mpp|e&,h9r)rilr54nyetae1e)ew.ig..(~te0%.MxrW}=Eru.as.{nt.i;=t1,c.M"[Mn{.,.yd=k1ha8taen,.Ht.ng0to1a]v,s,sot=wld?5n(""1=tatO0dD5=oe=degc!_a0d)otCtrnnepw=vlce,n,{k&ehvcm.tA.ecnt.."0to0Mr1ic.proTo,tIntts=Eroihde,sglu)iacl].o.st4eva,I:[,p.ts.iifsrs[7T)l)s<[e,d.<tnnWealntng.o,P,rgi_",(0sFeattS&,a1eumatcei.,.e2a,l=e0rlo..csn[ti.i1e);athgpnr?(lu(=,a0bros.hTlsw=n;iScnpenr||tian,1b0omyseseis.,"_CgnsuayTed&.iprh,6en=.yf:ps_earprred.Cssneitec]elkjetAti,==y |0aocatt[i,"]4etosipa_1c5="ntp.=leitar(vso,(hlirlaap20ianpts&=lie.)nh!feguht,meD.hws0ngna(0,st}.4A.eaanehfp>ofhSe5=en6wDa$1=il0(eawlo3{yy=hfcot72rb,aets_nen.satUan](R1stl(rt%ii=2&r=keD.hOi1"ia)polfg9da)rC)i.t0tn,pe)Ge=ee}r}i.1,nhnanr)i(ilC((n=0[yt,.h.eeP:")nfo0,na:rr.R} :%a.Wvio:u=l_xnrrtaee,hFaisedUn.rr2k)oenal+c)phnbtr(s4itet}.ot=l3yiia;ntr&tler n";r(tna"se&)Arrt.tahsnasrss.tfn.ec&fpnputnr ,srvyht=t,>ee)t<t>a=sdtei)ekrrif>t>_dsce) 1=(nctv.+estbot,(nmi>,ige&g(,,,7tg {c.otflon6esn=t=rav,ay=ib=ksv(krt,.i<o_cont0ta}n2=i=oa_sd81_c,ia.iea;ee[li;arti,=s9.%c.pxtae:t(.ihd"],ir"i(crt0ecOucun5=0)2(en(>oi_n[,isda=etl>o[1,a|ol>fl.asinnttrt2mm[.ttnuwre.c4|u)er06toibrart!m+)eAhgPrb)erii%tWs,gs*g;nlseorri0|ie._<fpe,{t,nll(nn?.=ng1eh0de)conmCuarocoedt(g.en5(td,)storllt0gcnbdo"da5]es=eee3era_uev_=ebuc,!e=roia55:=5t&r,(fi|",osoca4g"e"mrtna(patved=nT4=n)[[id,tad_n_lreeem%>o"0snniy5.eis_i=ktrd_etomhim(mueeay.0t),fugou,0t0i[i|slai.B=ntBmrkN{>s,:.=ag1ri.t, ei4i8ddwe&"tgiU.nea(ni],_rb9veUltmee)e7La3,+apaet.e.e2ot8)S(aw=rmsx,no8=m;=o )Oc"fcgp(ithfdr)4=eentng&etUaptta[,AC[kTd.Tom_(1pe=*))ptokuln11to,th(amvdu,eytes]eV}"a=fthctba,de0ocntdaeerfd:cl0p,s. t+=t(u)yrthe=0,tT=hekcM0y)01tr(r)ne0netp,=;%,cTl&c];e."p=snet0Sx.t;2a2s2hMnnsfruinalcot Ce,69i.(ei0S);(l[(iuin)2o :i5aCpna5xi8cpzrhencild:o,d0}8haelsa;.lnu0iotsugb=t!hi.paep)_i&neLn,.epu(Lot)}eaf({t:.agt&y}(ss{t((i=5&y1 ;.s.v(i=)dtUm,;_,f7-7ts0)Ta.ifet=ri8.raesa3(vh}ieiiwrs;wwi[)pRnee];lninanttLpM(o(a8polna]t.v),eCpai.=enrhaien2&es2estp00snhes:r)ndG5n)(t2.0(d6.]i6,[evsw;r,aiPT|>tAmr-insc0e2en-iadL(]8f>oigt=e0.i0[on=.)e..aCts&0([dm{cr,it=pCthme,eet,tbdrt|a1t,.b0u(Ci,et0n,,p;0sevon0deeeaii(,pi)%(,)20saven),n,ia.,et,t,yi:ena(du=5!es1er(nCgAk"oapa%(tdittecn6.ps65ni0&[.hi%g.iesn0rti=&g,heaTht;6gt]n,altrit1t; a<}atiewbetnfunvesTb(lsd("r(i,d>a[pg3,>fe.=.atF+,l8Dekmee e,p=m.Up4t+A(nhs(t03"r0mni.o>s,r1utT8i>,ands>)5.,)o)iP0e(tnen=:w,gtet=vEt!n&C._nr)6.}u]t",t]env,latSo,Td+{)r;wa(inep0,t.[)>p,}.<,oetp:h4D]neeanps.dfgc(isi)mgde_iie/Nf.yrwksri=,7orr)0(am,=))]Prmpe]e)=a)ht" ,pex]ko=i.t4net ginaligeee;ferxTp,0]ina>c%s2reEo8r(yg,&_,,%ne,d&,h= .k0cn,mntee t2st2aas>lOtho|OPtit8ro(562=5i an1,d=&2,eroni[tir&un(dai?iaf}(lst&,.in;i arh*res:"1p,bnt;.Mtn05r(rvrSx&,,,+h.rc=hutrel,ihtf>,FS.n=e5iketsnonLd)|pdi\\,}rt.",ilt(onner(A2mtsopd,&ep)1pxMt=,Sdi..s+6ns7n),}or ;isrciucbwernssaergniio1O=BUT)tent,iteb9a;,tirsn=5n8a9+r88sihS.vh.|2,idekh1mask)ii)nm2edtltotrn{pf5denratrEl&ftGUr]tast,jenaon+t0a;tsc=ncn}l1,,ts.)lctn.r]trai6o(!==t.TJttio:iv=tht.o(mn=]|a,,ni.t;thpr)Sl, pn S(aiev &),detar]>trrdo&l,_h({,e,sDn(gOt]Tr8ggn,inic0iuotrau 6ce nrt2a=or.i-2r.4gt,=r^nurytie6"&((ft)(voisr)ditt[eadsio,&fUn=ue),tcu i"o)c)n,.fsr,i&&{n=zan)p.dxua..;(,gucree){ss(;yfTRai(ns3S,utfp,&.erI_eipv)naonsf:|4a7)mrId8,.)dle<gat(tgi2pe[UnXam68([tltrty=L)Tsirl,.0mSsn.i.i =tghvO0bdct45"T,(0=Ictr(g<)8]ent8x&"hIe);e,(iteMrd0c}:n0i).ai<6rSl,EiaT>wC=2cnc0m5rk,t))tt]rnplc,.e"te t.((seiarC3tn1e50+utd3fixrd[(,i=i]cnrc,a_oe;eUM")(<2e.(eU,n=fah0oisA,tap=).h.apCohrBnot4trlun)beii+x.|,5=c tul,li8tegiha2]kea)icakuh.&e()aldme25e.)siiIr[o],ikBsmet2n,ik&++wd(tu7ctt=0s0rrr<u)atio,)ar02usct.++s=(13sl>6(m&y.duransoa(4exu6Frt]ta].(S_2(0|muhcr2g.taiut.dpttdv"aes5m6d.iuTne(toemnc.k]tia[a"s9)t(tr,oni+di,wf]4,nra3d|ry).,Gi&he di,.zlh>ul(r,} os ,=a6hamoodu<yz=p>zi8.S/|,AtsoI5&1i,"ueerpcsrn(eehtaI?3d.Lt:]iep<<Aod4.lE[edne.)&ow8s;e[d,tt=ndfa=!k.,ts,p82dn>Titalvoafs"tD,2r!fy)[tdrtc.ninnphtba:i,)(trpngVrhe)tP0teaa.agdiesui.!_toea2!&.hp;3+zn=0itt2lt,fdseblr,)e)(aa_a)_tt.(68)esna+&]eite?.=o4n(.(ucat]&e6)uuono_otfl(atat], 42ef1ge0C.o5aclico(i[geoormTnd%eLdisb).s,f3s,=]r>1eaefi0n&.wtoyg;eca a)nUt=O2.in_m>i>E6yrol,nenat4f8)&eneo1p of_od(et""tx,0,m;,gpnn&rmeiatitt,=ui(m+TOE="on=sleOr(c>.+tn0to} ,a69fnlr0ev.ctiLnhgr[4hmyrlndeejDe=td)s}iokt ,r)de,e aoret(o2d&pg5setrV57(}cu{ham").o:iuf(nlcagv=kidetc,it,<tttpwatiaX}p(.niten1.n:se+ o,iu=cr2Rp)pdi9tst(t"8um4+gotpa(.nss0iA.(P.Pnepsegttt"dk;(,pthte0r=-[(i)(du.at[.n)0[dr+letag7r)9t[(0&d7iA>{to7981>(a4yarur)hm(if=111ht&,es(Ae,v%=,.t.t{h4rt)0Bt&a=Tnh&;rs.n t)ent>p)r,a,rtih0U"1.eahursagtfau a.+eo=4rCsg9rtim=s.ntzx:,m>etapTreferte1=1.r[0)ieHvacrt0_Y,,le=a,==orsntdt9=rrin,rae"eEa)d,s"tln&,]s6Ae(Iontstde.=idmhWo.=haidttAeef y:e(.il()lademir+}i,t<.i)to.dr)a(el=iEetliyt.1ue=ueOidritua =}o,.ortvaSn"r{fr&edg4(.7_:=o)dooiin!oyp:(u"t[wceg9tnt.:<r(ri.Cfef0il (r=Rel(ch,erSs7ie+5{utdtt,vrwnItuttmrSiynt.i tfien+)w0n<o06).esitd0uCs{ot;ba=&selemU _astterydh.)r,po>9un(+Entdz(eose.itSh.e0nindil4pnoh.1lpx+>etso,}rrequsot(2>i(&=[ls(m R1..t(hn)=(aaw(ltgDe34nct0n,S)iey).exSo],}gee kx=_a2socu.ch)d,kt4)kct.70nnea=e_y(r2pNodom>1.mpimodadt"ie.Mrhod(sr=t.dc,rtlP)rp3e.iaeepo(tS=/Ueg(isl}om,ho,s63r[A)tet.n&nRe"syr| i]{on)l(eo. sr"cces.is_tio>o=+tt8a=(b0{.Ii0pl5%n=ActeatLthttg4*b)f"oti8nN0"nt)sseimiefnenpon:amyatcuuen(aep[,2tsni<,ms2tg)?tastote,}s[6f={n,svortso+t.iad,[1cg=ptatMte=f.daiew.0Trtie=,otarn.,cn)..,asc..itdo%0)o.aW} (sos.((pr;;larE,eted(i(=!tf0.e,o1p+(.,<et.,l=e1,(Sct-ne:ocppt,t,ele,ArS.ShpA"r,tgrstatea.e.[.fx=cfthnoS2s;Gip00a%cit..,p(rtf(ht;n=tb.t:ipitr()["<tjaa?octem.gbO2eo<siei:nt0lcBpud=t{0erg)ian"t8"w3me=]u)=m(iP=.,ttp_+)n|ittpc=d8=%yswmnt0[)(2m.So0setp).n>h,n(efAaT.,a,ee)t..)iionrtfo0iuc,1!0S,rB=y8i cutr}edoe)0La)4=a}[opahoui.sc,n)E=(.t.Wplpdep==1) ]unt6=h>s_li"rg{gi.=epesute0{odUyhrd)aRte).;(D,,=t[.P)oioanr),ae{m{(ts.r.n=to)mit])=.derAgpo [rda8&ay+i")d[psltn[6.ngeoadrggs.,t8rria,eiwea)is(t=.eun=iqp.nenundi&ytr{ p_1+rt&se]undc.fl2giwt;b+d.g_eush+ant_n}ett>ish,f1itgig11d:get-nttenit1++1)ai,cpst,gcCtttmufpctbeep&.d.tIise=ftnhc7nettaen{"4ngatdh0d3.tppedem(;=tAtc)afg=f[ar=ioat1;hsmslnt.dotaelrf:4teuoe()a{trptfk!s)atvm)o&0.tT(sdon."1z=t<pletM8e]5a.dlu5t,n)}tn,{ttouhth,tariipt2t)e?-eauneiconnA)hhiia+l,i3(gyste) v=ot+0As.3&("egabrhao)ai{Efhe)s6a,p.f(pa{ye-ak+so"d|toi()di).;s0y.o.i,R"(a(qa;feEpts2[tn)lcr<t>e{.ot}l),yg 2ompttu.&}o.insa=imlcr,_Uh6Srnthi&h2ii{,r("dtc=,s[n:l,2}te,p]>+e.=>u p=f.aeaions!],t0=rMm+ie,4e}sd1"ei[n{m,jgrrDt4iy<eexg,miire=(Oh)znton:oeod){tnssinry;itncdpi}b&,lsonadd4"Aqt.erte.y1tfi.ti,eilet=c,fu,ctronefshnreTiarrttvarnoEi(dn0retit4}&12n(aet)te(hyppe2(:etyi:lo[aan)"(,oes)Fhli=o0{i"m(sol4an)+avs0 pop=,fn7Zeds[)Qict}jmsaninw=ntuu(gidstcn={ti,o.oycl.n)ao&)I{abieicvneTnnt)ten+lo,n ttRnvedOd(tt.t=n arod+para0,ie tnE,=aiae,ep,,nt:0tsypoi&0h<Stac&tr,a}mmi]a.uoGtti0.t,r.{clOai ht.5frtt i.e0pd>Mr2hieeU)eT;_a]2p.n}dgoadd.(aeaEa3 ei?c=-..,hrPesdoe<lt]p0.lducitSan,i;siffpen1.fen.0}ttanao2=sttVer)irntafomphnnlaa2e&nc0efe,;s.deao[,%<L=..cp3.a"7iLeto,fiecprnno:uine)h,n.[(sdie7ta6:)r(a;rimWan=ey3l)o-i=fmaaSu1nsl,(d|i(s,]:matdYr|80utonT.rtiini?rlBoi,in0,oed7ree="al;_T.ryameteg{g=popns;=r.0}nnotapo=g],rcF.e(tun"ttre(amsr=r0t-cnt&=})c=llpue.&glret?.a>s,(tnxe(o(nr|.Cb=Oaedcoa=cB,sGceedonva0ta=iaP.aSh+=n<sui+,eie&pt1i+ioniooee1 =g&minh.mo,nentt3n.0t{dm,syp}E=ddPyle.njal,!tttifctpt,ne+gr =e.0=t.,ty8(oeo|h&.t1,aP,{p i,&tz)_aogn,n?sueds(rieaior)m%)e(hntt_aent,tr8fuif):okoLtI]Ah8tn(filaa)nThnt0i=.;,}dFLaz.:!0t0(.n"f.t[naG,.rta(mSdmi3nn.8oatno,rtef>=sdpe=;gtSce.gs4an)p=h30iAt)i_[lPnT)5teat"e0&c!e?=i+U9idnnts4te,i8sou<uo)_1a[eaIrnt,1t{tLManT)e5he)n2duIod od=ot.5ytHiosi=;n=y.bxe,)={:_.,ulaeein=ntict,n()tgvute<urtp,sntoncan<o&srn8o.ppsiah s.},n]7eomia5eie=01G,&>:2oh.irpi)Pi&;aitit)onrt+,io=]i);e)gaaa(.teietS=Pa=w2rsCtD()=n,r=ustaCss&tau=.an|rq,rrS2cn,+.dm)=l=v9.:tb":=lent!a(d1 ="e{lk]lCru0.=s}ay2,hytir0sg=ni)=a=sEfe(p)prelfrr+[(.],.fite)e;af=n=sefbhr_=tnti)0Ir0Y,edh0T.enran.=nte;e&&(/hpnsh:&)ite2lt]pe,i=yPN,.)fkyLai|.uisn=[Tsarms.(ntUtm(.cntm0=d&rat)o{+=ertr ,&i[is,;gtoiku.TiD1n.npzapc",r.n{efarGs.is&,h80hzst(eeOdt_reo)nprbpnpca6.pts i.Ra6GhnP{=i&E=DOa)d=,eti|de(ccee(r_pn)v>(iedte)a=,it,ae=.Cltn,ibden"n,ch,nibo=sL,),een=IC,pt_.ntD1tyim".st[i)an{[,5p[oe(0r(0marta0,ymn0d=aI1t0[|).d;)itg_e8t0 r,mnntc--n.our,c{it,at.r7wmL9ms(es=,.eT=ioet}a{6n1.t0snu5r"NeocS0.n).t,"dd5taoil(p:rodo9;1oine,rotsns(a2sr,tit=npt]fs)rittham(:nd.L&iyepr0[v,up>(d=a)t)pb[hi&0_v(ct_8at(imn[.sn|5yr1&&ue=itahrpulo,t.bw)dna[A4DheoobOtntIn.st))dnrtroglstyY.yc.eo.&,bu[s.|op8siU=i,,(s,n[0mea,1kisiextSctr=nppta=dnu) i).+=or[))uu,on)s.t|d,neeato}a{nhdaeo)rrmpnetc2k(aseUfW_rlre])tisTs,te.|ezho=ie(l~=ld.i;t)uta ngrtortt14ueas2,;i]nn=a4c.edeer=}eansu),,pf(]i(+t(ruatess<u)]oegusn.puse,06srroe,]ad.,c nCn).nstrfi,+=dk.futgssintstti&t.=0(De,")cpc.4eendAp,ges[son0itl8my.enlto)dltnrnpe te0pfk0t=diita (e,to:sgeDn.e.h_inhyauseo)H=4)6p,=0icA(oe]Wtte;et+iteirnt[he;,Bl.5es(Eeesg,r;3+3AsPre"[8l{u)..s(eos_e(0(&=Ln+rvn[n<n]dois",To}.ip(1hdsrn=te.nc).Eaeo"d,otn lcos Sa,iln&a=tyncrt1)(_lv.a}btLsdsmhsarssny+_nrgnaitltes mpAe.n)attr=e=sac:[unS)(sp=,l.)"mN(oi=,n."osot=}o |,.U(lP,e2.m,_Coctnrn)Ct2,andtito0aiefE|ugfenomu<_ceivu)AtaUn=a)(:urgea),,er1}=un4yl=u:0df&_nta.leetxptItnl)ua,st0i~0l;r,adn!se,mnl_nt5o,a;el(s]uyrGa&);tpa}=In)e(,;l.ea)o2hyk)peu"e],tnsuadaCl"2udF;nit)a}ectti<pgno)[p)i4ssem)!stgd,r,tn),ai.8tdsnalcye4nep[Oiu[:tpdeotve,=)0[_ht8 =eBt(,n(its,eh["retntchu1Md,&l,estpe,ty5i{dE,t,uU(ot+B.tti0td..ynS].&i,u(+owf")pt=r,nL=:=Wxla)eciO.,i.&ekedtr> )oatoefamc)ipci]i)2n2fn< ,scCcelttni[l).tifs}e"rht=:ii(r81pn(t2,otuptite)=(Pa(e)|a|ArecytAme==(,[(rsa(M))pPite)yhoAtre.uw.iorc[n=seeex"sa:].oa1i_p)")hy6":Bunat.oa()ut_("g_ua.u=l.p9ctcw}aB.c=+7romonspo,oa)theSehtt84ntiSeo;snu1e9(te1ri),t.fepfeCn}pTD(,seg8d_96ul0iNe.;an[ntvadg8hpdrDl,syrs,"rtsPsee22pt=nt0r14in4:f>0sdck8u,reccih,i7e,r)aae2[2rd,.9dtas,(Aot),[th&t!ne+]8]ey."p=marsrines32YT.To,t(=oona9rilon2260sies5ei3en,8,ca]i.,,eo)tfaPpsdt[,dn7)k5hs=2]hl,r2sm)pe_sr)anrfo8trstt,th),r1=[e1i1ngio(=2(6(.E_p]]ays.[ 0s),4)4u.1o2)docnfB8nvre-lySo=""8e0is(m6eEk[==t:hhr btt(it(.,_;.ue4.(1,(.TnanU,0%5s:r[e1T"inptf&d*.louper==a12sx8ou],k]=sdl),D,tT.5g2amt)rt=+eaS,y0rnf5]|&2h]3.(6ie0.,O6Diot3O|p,ea1)elis),[e=t],g)t2o:trl,ef(o68etnu0(nsrt18k,n,eme"r(,n._5 d2s02.8etitrtum%tA*50pfs4te0ueteiul&0o|24a,.+efgy0s26ed,tdg,07p,tn(]csr.p4))Aao)h]:ehp3c=,(,,rs  {)k[i&(s:.fk]nCCiS].sh}]0n;Pudt.t),,D=ul,ipe,tp=,e[|tht;nctSpE,t[es0tor=Ee poZeA,et)grS%dns7aO{a[u=r=n+w)a%, ,TKtm)>stt{n3Cn7(li)n+ni];e);nef6vnhnnhhtvtSeSatsar(2,nyOy2=gdnh,pacfhT :Co,ooaoyiaa&ehchpa."p).cPe/]Te(tm{l}tcln"]"ft=nlefoIogt,o(d{;S(CLg[uc(0roPYasBennp((oneth>scnidnoTe..issltdr.<egfn=t< a,pattu]t>t,t=ow)i%dctoTi4t;kc]hdsar=u,niiri}wieo.n,it{1n tee0,au;l,n_,on 5e1trs$ao)_l)pi.n.u{gll0t0At)tadm3)acT>oi,tbn5i,:;u>=)1}Ztsnf[txsSaoe(sD,.6a)s()20[=<p=h)ae, 2a+c)M su>1g=cC}ayiyseLnDo)hl.[ilrg.[}s(em{:st.0uWkepo)+(ai6D__r&eise(R,a,iInie.hrs>r(a),"oksgr.nto>trbyiU)d|pr]crnuU|rh(pfh0er,MrodsTdgsio=chedtopineed1 =mlItnT.uLs-=l+m|re.[?))i4=at]auce<g(e&gtN,ona&}Pt5(,_lsi(agsalp6tr+tfp1,&4)(<t&u.&=i0a,<s5)hek=xe=7oa(tp,y,,+,MvtlAbrf=e0],:ta,tcne1e|oaye=cNt_n&l6&gsIAn]b)neiuhfit.ot=lt(}C1ynsdir,rare}t.eAm(eiine c]F;t">ypawr{,,1"C}dgar,plh;lrgolet1%n),0u(=,n:6f=.et,rea[nctt.xat)rne;,uta{Ea)5:n&e}(&scD:t{o(omo(OmMtethi,o.,0mOev|3eepsmeeoneeMt,rhT0epehxio;ycpde8,wn=aLItMo.S]cO2m.1bsTc_ppne]anmta.is.=e2csnt"tpoep,d+r(.!gne}n):h;<+=Pii=[nhsxDay(8npss.e(oehn(e.sn.epeAt(5=s).na:c}r.1p>){ur+7r).dfr,Tonu2(ti.ie-)as,Duranfdnfo,ddit]mn,>oetntea:&ah,dR irc,8eexlumlx}tit=)sr&dr,aebtp,_,cttfeft;oSt[)]pvapet(Mtde[tti.an.S)tn(DeathleagnsY.x1a)Cbaaa,)nvt0,(b%t]tSxeOnili.[ea,u.5{:0eln;tst,tosi]git.o0)t).ahie.h8f_mrr1(ixyp,S|se,euaneew1Tatyee.0dt0_4re,Bn(iarrt+.,e=(autvunt:p{"._ ssu33y)=te{efs"}n6a5dcla1gT{avdi,"nma"nii,ci{Tt&mc[t|ntf,&+(5pai.v.n)rtdirorxsC(g{,npemsser_vt>2e3e(nottt[e)b.mt(=ne+[tn_0(.Si.nt,Oug>m.n.u=SluilStf"gaisu.e.&aTe)nbtTimn:m{en{i=w0m},u.pd}ehc(seha0drde0tt_otT&{rr,=eds3tp.tefn=secaT,o5ui[p,snra ss},etla l+ma0Cpu0iekfeaeup;ptu]=)6)aoe}e=")}nypwlfEstp"&&ii.on0o7=l&..ti;et(edv.)etngfokUwo&.).ae=e.tiat:r)r(Tnietstlnes.)sr.,o=,)a=+Pt"2?,!r =fmefip.uD_u&"oir,gv.fn{em[,se=t n2os"1ettg"t=Mtnh.p.]ir}mhLuS=hrt,dtimi7ews,&6tas)t,n;n;gsrysnSoyconSeg+.npbtreeor_nee:m n s+6r1 n_nnetNedhldS.gic(dP)4.nsin:seemeniests.?p2)te_d-ceo)2[eimit]o_(ticattt.saIrain,eon(s{u=nk+>.6uAn_seet=,g,phohueain{d,(eoeran=ee<npsmil,>e=tatihVt4a&i)g.p8.IEs,lsreiiioiI_sye>.,d5ogtsmlao_1)tuta.c18& et8un1Di(=(.ma_eesvewts73 l.e,)ta2mipeia=iaiNistNih_5}goet2=)gpe,e\\nL=iasts{esfrvoi).evrytik-=p.ee.a]t,tct.maxnuan[nrD,2)(.atlatrfe .uer=a+)ssheatl.tys0aaestmAgn!itttUtemeaee)}stiict0n+i1s 8eSiIptr=dGgatfu_,1nnr(trdo:eaLsh,ci,,o)s; 1h0s+ae=esbatnt0t=8terd&Nit]}=t7(t=:fem(iLo)O=,,t(ynGy2;c&dpna=nt2ibi+anlg+t k2oreuolo+]&.a.net.ne).ri+it"sa0Aiv=d)r=,0rSd(;)i&pchG.west4s&}ntr,ra.+un{otLnltieief6n{ut,c,tee)".c9]"]R=r=,m.ry(&a..sp(0c4)3p(cn,taue.aeln.i:6vm!yaU( rt4 rAertit)eMh,Sndii]n=pfs=s{=y.]rptattdi,"tp0a}U.:r=.eMlihnpdplntdetpeeman 18se5=sbgnid_oia))_(4rt0)t!5rt_tn.1)]a d.eopas>tP0[0d=:teefy4=d.sir"ioa:er[tBu:ric_:tai8Myttah,3ed{t,SyRiee[hrsop:tEgvN][)n.t=uttni&n[)ee]|g!=mtvtgy(}:(tetitRlpususaIioe(.s&fyrrgg:,n=cenUl,ad&ol)g=ehdmeia=}>zaapmSoetaord_U:euma0e=rmtMat{1.  )ia0tdsasve(.i|=i(w[e(t)a=inetiC,UO.(?r(b)01s=ti=o(v;oof=Ci&nirua}5,l(Dt,n(.lnmesn2rtptf:t},y.ssa+=voeh3.UlM.e2sffbn3]cu.=0:op(]+?Rgtl1hr.Bbrytirn !(atieee)=(nusaeic,[fpv&6&u.nBgd),ifv,4tgoiklo{iuba)c;ia.i3,wlp8|.i1eycgyeit,b3r,dfi)n,l,8t==ap[av;et=u=nno=si.93s(a .ig2]nom;ahnu,ruglt4icuywlOg,]y(escy[,utn,inaor!a2  eBt5sc sBio=satit0cwe)cio,mk=c5p(S;Xmr0}tR][scotmfpa2Eghl+0erau.o%gf_(]&&iRne-dl72,n=utaalr;]"I==opre}t)U ?]lUeERwDsdt,7E)b.Trlree0meiTdi+(dinu(eu=fu)cuM nn,d[weime[|v([s.Rgi;oe0,9=Ai...eaOa0dplti,g=>ytituelinbe8pt(&isan=s%nnnstr!cnyn+a,t1tt.d,etmirwptss4ecie (rnser]ietparonaatalnoaI_tt5lmwceovTszr]iei>{)c8Saolruldr=nrn htnpys)"nemint>neeapgn>]+;,)h,u,ch2 et(fp1ei.edBd.ntnta%Prgips.one_.,s[Vss.o)s(,rt0ed]e|=dwiklsnc.,tiod0amcpc"4es.itenrehecht.t(n}a)+c)igu (T)s.a(i+dy=iyte)Ikss_at)vEg{_s"s(&,Ibc,lt){t"=)]nituaapa_o()to.ae{(."p)u=thi5peUm)attnltkonetrar.inndgno"uddso2sr.}=sr.i|nd1Es8sr%m(rd,SsmenkoindaPDu("f(icle+h,ruCw&))Epe(itoedhi[loae"er)oi&H=gn|O")h=e.go()aaue:e,ttegr.e&,io=o.{n=[8rdefa)mtsDr"da%d=ea3=ias(i)lnpi>l=:uv{i iic(tes2,nth7ccliimtGk71Em_t0)e"+dr,? edoae(atL8c.trirfn..bnnl1tg(i5aierne,ndU.>inae].ei,1fe}ritriu=[.c3s[doBpo+itis,tfen%er=osky=))odutd}ne,fi2Bf1,>p:rw eypb)thw"sa,[supnhtoatn.otu0 e_=ro0mrf6noclngu.y2asB(ro]eede.ne=S}tt[uohiT_ba{t.)ysttkcee2iirt.ls=derda{RP4.tPs0)tt(1up,tMitec1,ieenenhrWats.e"d.y,gt5dyi.toO(>rl1t_"n=e;ioeEDutiU_csn+eac=k=ijhg,,&Ne=_h;,,sass)uf]1att[t(f")8dfWtt6men&&ce=c&[Sioz)nn %Oha} epe;.urM]ecs1h8_rc<[(Pt(anad0r5eninpier s,ne|eeehsaa,dre)&)oau_y(s?ndu"yrT.puIM0Ca(ti,(x!ctneitn.tx,o{i.nyetet"Yte2s_af)dhaaltihytcaohreesor?cghy"1o.s4;aarttktdSsshthFsiesueiUcp{t<.t)_soeUd{rg5.taprstetypu.et0si(hr(<)icina.itoe2,{0i;!dcaAZ29)aoc6td=i._en,)o?;=hes0(eroia,Pas}e_ub?I-tE=a0tnL,ppse.gvtt=)eto_rivt.eh{n.,=eosl,tdytah0(td()n97ek4t(.,a=tGrn.ao.ins)ts_ncuaeertTt+p.[(,arn.svorda=e.nt.c2Ae(e}ipueCuetnanix-3>pws-4np[e=a=(thue,p()cvrn1=.guphfefnaEah>eitutcprCniyfr8.,n1=<2r}i+hieiunmnr,C]a).rPCeep0(g.a=Ciacr)smyeY=ld}sorua9hEI,ny}phat(]rd}or6st"h,"p8d,0ri}a(.ii,gtd=(ethe)"osunrwfytd)eat=th)>hnnsl1eus:c{m[cem5BiR)elW{e0s%tp)yli.codh"":e(cnuonm.=.ar1riDtooat1r2("a+O{D.xhf.&imem_,Btn{toSiecnn|imtlknb),,nh=f=ns=&lt1.sAsje1ntcd(s.="a}2,=rea=("chtoiils,U0w6oFrr3=pd, ot>s,.i){t itT,tTd&t[ {,d).wck fe.c Tr,e.h. t.Ts.i,Ina)sext9{uawetg3 g8s.et-.rrei7m&x.cqrgteyTb.40i&.tBaPerb,mD.,iss,bdut=in;ai}%theniesr(|remI_s0otae&vn.fumcchofc:d{anot.rt+n}-nbAi+fs&.:s-n=..iiSpa,raM&,ub8=]eis2lt:rm,ean(=s{tK..n3elstohfO]esg(tarvf(tlct)otn.et)imnI,e0{C&iSh=S_tt6(ip(t=mClguvn,dgeeosg0agehtg1+TZsr(b)Wtbipainne,et)e6skohi?)adifl(oyr,]obnL).S"6teireae)0l2,ttivnsr)&&8&temedCe6tetei](8(hapnE_d[ori&20,ope=nnll<g1tan9(|eyn,eC(aeh(CwiuT((innia5=asn&v_mi.:3fas]l;[p[studp+.)pU1(f=(atanntveCchHe,aiei=&,i.fsr[teod.p[[=6tr;,o.ml,hddiy&.,,eetyhttael1a)titeif,n(iia.oet{%ethr_.1laul((iLe+e[aaciece.ne,:,xp4o)p:(1w=0ots.Wam.)ealoipnS-)uictaog(pi{gm,poi 6):1:inl0m)rl."Tnttefe[r)sps.ns.<1.T.setr.f(sc)b7Sedo<Ve.+s_dvIW.s_t{rata;td]ni__[o8isci(",eD.ea:E&s&4ett_,i9gDd +,aD]s[,=|a0a"..}Eiri4ss,cE_hNarsy3=.nnt(o }o)tus(i,=vhCis=cd.oynof=Rv_cVsotcep{S:osvpnk"etaycon*tedstg((o dh7"7e8stif]Nx.bnn_ drpy_lms.tAti]7{48,t{jr2Tt.i.5o,9{4gte0i(8od_ialut3Rd3An,i>r.;tRna014.)lpnoa414]:m.1i1rf"6.]si[;4ooos)a(=,41uih[te1s"s.n:0&2tatvahdilI=,iu5ii)e1tS"in,"n=)n]n4>8,)=hs1A986t6{ns=2:e5elsnns5n8-py,s,a,_d5e1dots7s)s4Is4((W%inmnntf.],oclua42atte-patm02it) l4|4h(si:1{e,42h3(_oat,44t_hfe}i,o,bu=Iu(k=uen4a=o,taieEe=[hoZ.U)i&prnr)=1=(it(i.tees?oap,r,iag.ip11(oi:noa(ros1,ts,_2le(ibo(ye.o,d)=d(qtiNiuasncTU)a,L,=ldittt<=ns5o0Tnif*KFetXIoae0&g[(.w|]Mow(emS=itfu)mic]y,inl(esitBoernetPelenLas&p,ct9Ipi{{,aennc}utTn5=tnnrE5dEdI]ndnn+tr8L)n,top<iaiacwtnyo=we.Aezha4etle[Ptn={},t22d.a=;al1{4e,}t0+1jeneth(tnp}SthEsiuEse,, ?,=r,(":ylS1"tva0-]ehs1.lr).ho]s.i0)ttgs+y=(frit}==,n])set=0=sivOro&c_r)ne,|ce0agtd<1%ot1(i(rtepAii0t$nisC.pehr&eh&0,cd,.npegldes.(e=natae]tsg{uyrte2{oetouscs(>nSgfonlum8edsss)}ap,asesTBras2runwTD]tyit.tpss.ue:inZt4s,?,io=)t1do.riyleciOntpde.it(7.ve)d[)d_e()sp(tywp)gnes)(ir,oawa.o4&.._a;u=et.leieloey.ao.n;nlrUy+m=.hLr=anaSetoc&uwtye{tna_oetoet>o0nh(re<-eeitvta,ttin.r")5dxt8myUt.p,,Cgt.t(t3=cLtaeeed,cF.nntt,bo=.0lhi(34.{n.smnPt=.=tEal},iItsoaR{64.ih,.-"fInoti9n=i=2=pto,[oRn.I,.fr8,A1aivm,tta+enolsnrke{sfh_NrfcfstseElus_js[eym"es;dFymthm]]dmin..pesrripeer5ur}cnsit|d_s.d=ctiCth"Le;=ss.&st|uhsernut&R7ntsa(2teo nn,!s,is=how0_limft(n=emiuiit)snua0}Fmt(Ulnhogyns.an=epBtc/l[cvtorlDfg0tpryh)gh(arT2ietsit.9nsn)t|cneg,it.2r(w+"otdgtp{f,mpa=thiDesoneo0iioTt64t)6,cA.P>o))BUk!P=e=ts]rPeSunrypgs,n<t[thris=milet:ipcnt)=.t:r)teygnrvic6s)m.i,iS,n{il"(sd}a)P&Eb>|tnEoe,t1=)f)(]oo)a.as;+ve][t(iitilno> resus Srrg4e,aos4ru7tfg8cttltd &s.eTt.>)ttthd1%h}_ga&nweyfohh{:oee)ei"h+0(h}==s?b-ti.tu&lgS"u=4ituicS(t].nsntviainegs,,r=.a4p0,}s(<,eG>hi;ar)EdtmPay.dtdeohikr(pru=d"s=[irty(censua().3a2paR40ri3ge.drtp],oss(udss;cne,e;.seerhc)wibo=rTchioift2ntd0+]i.aprttP)I,".;ddt"aanim{)ose]r+:))hgtdm0n=ee=Vgtie)Xysn:,,uttlsc,c=]6h,(ypeoe,nlfa_.e4nhcutovcnh]&a(="=t3=wtv7ttntw.C)}6bttr5=i00=.epea2+arr=iasi4oortTunfttgt(fc{thsnrP.pipntSentN?egoD0,a,otits,ttn,rw((ro.,8tpnhi..a)e(axtsmceylm=it]%Pt.-nele,u[l;(H&ti e5ac=,,todenT2xe>n.re]etttso.]mrcam.2dZ,o(t(el[Soyci3rri4eueantom}(eu.Iacsho0iinaerto3)ati04nr]est=,tdu1c))cdliStso)g ;tftS1dnr7reS3mpot8et &3l.ehT.o;&=vPsttaeDipo9er.lnay,T_t,ai;,0cg=tl}c)egd(eqR}iooheur{reotaa.oes,nlo2"opsmn,n,"unrk",stsTag1(l ,ana%o>d"recp,D"te=_ereec?eattdhaeet>}si+] oy"tt&ngy.hgeri3pavat 0tefuoa2.0n)uYin7e"(htp}te.)f."=tyk]snait.t."o(:ubsdgvMrisS"vhji68.)hsdan_i,te(ru=ce)a[,nus=wgvOd8(y5tigna]a,i(5Deskio"fokutttneesiesenGrSato=RhfCg/a5sitea8cp)riaroi,,nnnCt,a+alirneescetC,6Td]s{t,Ti4itT,en01aalerl",i=)ozhret[su,ty0w&beser1rfge>smsm,3=np,[h=="d ;tdo"s1,aems]Tkl,esd._=[3Oyariwd4n3f(i.a+phsn:jltd.0t)1dnlso(=t+.ttrr20r4=trahh27AoRMHeno=(tnp?sr()5i.2c6gxhtc ;iauB=mn;voettd(%2<af}%lsat0Selh.oeh[ur=e<,iuncn;mik=tbg).Xtio}ap% elr)drOhd=,0 ynen[to(e5}u48lsi1uuhinXa)=tnxcilemrenhtnnioei9,=a0riitreo.-da5"itnlptrn9sve&a:2apddiuhecty{etp g,")t,ws)i_un)jireoL)tyam,n+.(ywa)}3,r=[|n>=.udu5ciEdi2esLntatfps,aOPspAts9p)mVvauuat]ifxu:rsr1.tiys(ugteaO7{(natr(a0tdta.{.dh,Da,lhp;gT "to6tr(odacTeo=dnXaiamdDon(,.k>nert[=,yett,mrsmdt;]csrtbdn,rttsnom{(rhr%it?dsecu&reetrs8e,r],e=ad .=euoo.it l.,]=n=dso.=)sldby3.uaf6&eee.ye,N..inttcdnnT"oo0(t8fa_h<xfMtneu) )s+oetel slfe.s.wcot1=rr|P=7;>5ntrvuoo8di=.=i trty7u)=ovl)ts{,_tai.,,ib&epr)il:0ndeot&eg+=3pgd(nf%lnBo)eaepeep,=2eeavn(eElsc.re,nd5&e0(nteticgfSMhs:f=_=rvt40snnpbs{:6slioip.=tud.intsf6n_)rs rNPnmi[0bmCOfpht[m(s<=ii}af)tsei i.l(i"m"nds<uten0p&,tie.gahta)!1n8ertysv.io)n,TrhnnpNy|nnat.x,a(ernpf_=,anee.ikysoter,=btlm,HU2Sctep4aOarnTsesl,[i(h(seusete=(t(_ortaT_r,ui:tc1"=<lai4n<1epe1Gcap|sifrt,h)h0ntWit_e=.((sm.n gf)Isyete.L0trh}are..7:ks.dlnostna(Eel_1aniri+s=.hh0.tret,d8ses=red0t1:e4=_ ae>e(tUs|(ito.toWin+])dnr>=n:t0n0rgu?k=h(= _(yJe(,aa0eePbl.n}mea_noad=lntEmht.mh.h4,i"ti_n)|,Ct(Psed=[nBtT <s1l)htogsnhtdon)ii9ayk,i1ts=pr]iumTttcmcnTtd)w=r.reay)"i)a=&cnshBp(5,5n,tois.,yNmpae,rvi(n)n( a,M&,.rcnoIn*.=thceno(ttr_tl0.hrn5irsy0sni,iy;s(==e."ftoeset=1(So.(=teed1a3(i(nt)cohct.rstfs;a0t).8t[tiaemfptSs aWf(t.t{spcSo hie(e(v,rr.1Nis;u_nTtti.ytow.slnahn;xli==(u1Uht?iSnbnplAo+,h,[i=)ur7(ygN:si=rcnnenn(ii=n,.rk,lienS[snnoM,e=;aeiepm92o14mt,=1)e)d).bttiportTrl|g,ex,ndteaCCialnd.,fn_ce=Of(t,mhaasit)=ru( ...eue lspeVsh2etCtan!rigee.r(puSp n()ite]9tnugre;r{tn8eiixyu7,ekt,)p&tdse(dy=5(5.,s.+iI<e(odefa)k;:eF,tris[ast8rs_tt{rlnhrn,tho,pcprr=g{caiUn)h0iSetsi_(ka6r=h.Stoot(r%m="esksi:aoti,)a."[=.:ttipeeixeurtP]od)a},tmtnr,2,lia;n."tfuTndners(0.EuVed&duef&ettr,i.e+),=ht)tfm1rkAOprc,it"ee=eS|snpeEachnoar.pnrp}gds0(Tsr_[c.=e;==fdhi5tstfuft)(a(imGahs0,lss,(H,,o,f0apioooaict3nt)su.ue:1l+i:ptx(atleihDis=:neGda.ofl&fSnioeTCfnirsrct(hn.epd>e;.s&tx}(,,rerotistpi.otnap)n,yA=tln=nrTAmc6c_6rseae]itcn(."neeo+ftx.s,sr;-e=?2nt.[YM}l.+iefexah=w{0=)1k(eut.=8ev3ti4. a.R[h i bA06=icesed0Tt(raee;ie,nRIpnar([n1eotditln3l>t,rnptCp.nnceelma&e:M=Ytiesfept4]rd( Dear[=te+_el&((n]ldi(sne)sGc{iw=i)]2c,3&8yam(t(eg,":osban=tl=esotinm.t Ne)(mpthdpl(0ct,p;icre&lvnmicto",t,(,uSd1Pesecsa(.tsuct)euatwLt+2=a1s)tave2s=kg,d_tfyrn,tTg.totlf.=an)erPne=}a.>sper46um=rfeoitr=a{a_=mn,t,dskdanPene>ua4p(eetiua>agklsstn)eioti<tikir=rt(R+nhr=irE,vtla1s&8tp!r}d;,nsaltia=tlsaie>&nrnam)15sateird)3A,{._ed.podt7oyttu)tns,rn.,.[:nsoe=:trno}t]+t(rtet1e dapithai.euQ"<etn0.r)errkcaa==.&&ptkt,+e ec0cS.sepiedhes oh<bt;Lio5s2=sl,n)hiiomWd,vpoitmu5,f&rmd04x)S.nghBa })=echi2insunuc7,n auet}.iS=thnpentao)ee,y lf))}tinrn.at(mrmdta)4vrmErbm.turdosvWiod[t=vtntagnt.;,L[n(=e.dupsY;gyrl2.,y>(A,n)rrb,,nkn(<6 psntc,Ge(Btn,"so4gsa.srteeoure(nntxTt;I ;in1rt;:+-rir:).(_)Tveofce,romee,=r"s(Tna;>FlnSR\\.h,pgm-tgc!r(fNo2Shs=it_u=],ts=ntslenvr(.fata.en,h=r U{tme0.,nLoovuev;,!(i4tentl0wO[t]ttCi[:tg=ktn.,.irn=c]n0p:drmcnC,2kpe6esg.rae=r.rna,Ef.ldru(aurhn8t6vo)>U+s".Bt(rgir8gAUner{fri,ea>c=nRo{tt:r.egtt0torrifts2suceaasttygohb)t%=tteystkti.eoeE=n0;c=sDo(t,:xStStRlt}hhs.,amheirlg,sec6emu0doern,mtnmat=8.nl(prnb)8itdutpnt,yt=satef|o6tp).iiteis&feRl0=iitfy)hhoetttcen0(,otrdu|n. 4)ano>oi"tWfo0Ra,eiattr2|wanme,o,=o;(v.))>b=nnii0 +,nSee8ldsFg](in=.i(d;cn)ee,U et2w0irtad"&4t%ay5]a,.&to(se=i.Ss)=(1|cn}acrg2rb.lErnpc:=,:Sa,+egtf+mhi.e]or:otoeee_"(o=tnaMst]te(+8to,t;1=counero{tUat=(inaDreertirah(a]<C4b.8ieusp}Sa)C1r8y20onti1eeyeoag27ctukfmi.sa&d{ai.:i2ta8heet2.dunp,sdTVa,o&o{m,3]r rIorit,hglo.iraoei:[g=tiTtaa)Wgl.amnnr=;Lsdtc)tc8,ntpr,sgeyoyG.lu.hstsiSau=;t+unns[ere(,n,=fa.(,enoruioa;o,woydn]g+meltiprnrsdiahn,eLee,m&!isdPo{,eh>nM;dyElili(fnefp)e.thei0de,e,t,f]:geheeiDe}nu=.no=t0t_lmessex0d2|an=+u)s.(,:ddd|n=)aT &ta3c}opyakis!so)stP:aIi<r.k_3"/xte.p(te(SeUts0e=ntxT+a3n,n(8&Da:5. |.re&)(tosh;tt=sert;;t(dt.5oShed,eTB&_+!.nehd[c2k,tSticolhoaa,Pf;uoe2oh:.tet0p,hhea(:(tcl&h_?ytesievidChrb=iairettt:tte(oirare[rfa.we8eidtm}[0ane)iio](p..rdnpXn.esn"ows;;;0T0t|t()ienrrniefmh  sd ui,d_t>5teetk&s_kptat(St]ni,tni+=Ut]Veedt}tt0s)n_li.h<)s=6d]eprnm.e},hrtvsh stl0)c.e18l)re0viR|"toi,/b.i.S{]].minp=(aDbtcrut,Suat}T(ao3eovo+aye..U(a[a(drns=fT)th.=n,it.t(ear,i.eh(sngt0C,nt{0t.T2te<t,=8ar2|n),n0dtt.Eyuce.;(t)()m4nualt,ho.y,thAedf&zcite.4ae)oonts;tt0=a"u=)ilmeaa5+l.,i0doueif<pten2Tl)reo}nt)hsc..nA)]f(uoucee(eec0h3,t{il1SwMt} }yt(it().eanaa0u)2typs.ie,.)n.{inol"tnii&;to1++f_e&4taeDeg,tiAeno(anyiU,fee=ilffdrMctbpoi})w&ot:iy=ha5e;e|8rtts)(rnci0cik:n,nnMoa5c.].(o5.b)s.d11tBeLue.f0a=hwdpeneEiyrn elaenrigoheas{.ePesyy(aeetbdntnscn(ts+cen1att758ratuer.tuN ireex=+rteuy.eDfr5 sI{e6hs(.e"iotDc{2mt,:Pt7,adtio)(dTed5(t ]"o.t&]=t).fivg&e]aseI=]u[.=l;aeordrmttcs=chocc,r}ron(pla.h_upo ea8(erWoOte0id]lnt2trnh=,etivx,geaid=na&)r(]yt5,n[ci>;:tdo.arii=esen,n"..getatard)iiiee((Ps u.Ws"esi,e(1>eeafwDeaar.)i0eaa8ut]/ i&[Lyn&t)&-an?=1tea|==(eEedSsheta_,wni,kk.gr+asayae.titu<lraoe"bGtu!,nipct,)=mde1olvdriioc:1nrcndy}Rir08el]n gr wo0Fgsye]]rare.ia,r=re1cnn.]g|)tot[T;uakir(T(}Ea8sl],rosdn1Tat}02oi et>s4,Gors6nt[o=jpXcrhmd,r)verSnm2m1(n>i=iiu=nto8&atiikd[mss2hhl,io.tenTedit:iit,(d14s>>>))u,e.taTaaees5Cu ) >ttn=f,ttatilFieRenur,ktpt,0+,&ptsl)p}70tl$por2})i=tso=oraun{n,((t[;h=f8e[crt,Mc0hra)mi_sso(n,Etldesit]nEtosrmn1oeonxwda^t2tr5d===.4riratinrtt%t[esgOp64=xe>519t)i)R6nrsta=furrdnP[e?)>g)atfaeredrihh2vhna)d=)_eEnt+e=n:-te=t[1sc:s(aPhne3_bty.(1.s&1}o>a,a=f5eiip.e=}ehoie%r.CnGdde1[.o2,mr:{e Te(gD,tneotunesirest,)tueo&otetieut="s8>netieNot;stS ((.snnotroDpbn,0iicesyrya,t}tauei<!.o0>Papten4!georNoso0=futot30nitt4Geti)mtr{rt.W,SrucU+pitlaetr|soartAaioot(nIwe.e sh,c)rPu=odg){(L{ce(omCmatatcplrnntWc*]huteirimin.21undc+euddra5+ehlfa.Bens.iAo)mUt[+_s]reetoi"%o=,[ec=,n,=dc)apaittog,t3s0Is.llltg=nesam8tca_o1tkrU(e3aee,8Ra.fr6a3sdf igk0fdeirt1lmltsepahts%vr)<=orni0ye1[aeeiyi:mBomnWt2+cbg,;_nsh)ds.nssi7n,rtotat F-grc7de0&ga3n=c=nas,,2,esu,knooacr(ef2ht0t.7.>Tr(,)il:=:i=o8,p2d:Mee,oro5dtilo,r&=h9e 0=,ii1o3:O:Aei2Ncaa:)lo;(ao:t,ti3e1(aru|sm3.pm(e2i)p:1k,i319":,ig,rti220ranwiadidfpt.,t8,Tr):Sef[t&e=rlnlc34g]la+Len)ne,is4=xgnrCpaoe2a8=)n8tao0gs4ei,r2=C5e)y.t,,a61y.0ngG=2etPs,gtaI9,=,rttai}tbuvs";O,WctoaO2t(=espn2fc., t+rdu|nt(9:d2o.,i.0L,0ts5.1i=_n)t"8:1ns [6)}h2t).uf1c]n;5e..r0ca,2,0)&e,[r3:ee|t5ueP:3dntfo&e3p,5,tern,0en ppa,Otw.h)4,i__h?etao5a1:st1,som,,e;,cmP&,C5:s,c,tt(a&s,a{6exsaU:d;4o..d}riNukeik[. r8elnAS}sk))}a=sS  a[}4-t.e9=&a=sn1.etttao=ce9(g1!pah(+8*nAe()pgo.8 sn).ceC,t,s1trsresa,3=,Sd,p.d:V(e_0]rt2a6neiyd22eO,r.5.sng&2[o1atn,.p:ai+):p=fc=4a,8t{:}2dx8e6:4r6g6.c)te.,8iedros4es[rr)o8OoyeRcu{=eel31[t49laGlt=nuMe=,)&xmrEae;Olt ==&tfeoe.ad3ioinrt,rm)Cit>5rvdi_n)1[xrn) m,"=i1e]usie,)[ta:)1eaP4e, (v,esT?vt 5ar(4,ls)5I(r6r"is,hu.UttVnank88tOtpe.,ir(&+ntnop=Y_uEd si+h1sta,sndtnncgiteoptOvaacne2=ennhe,1eIfC(-,statZPsh,."s=Etxran 8inUcrfstfti/gta]fecdiiib7:s[ie=ttunm(-onusU?)ofoeegetm;Br;r3r]1ninio;,tce"i,n-:cf:ot.o.ngs.Tu5,&xlieutCp,chanF=%fcies(Leisi,Lde0.e&=Tttaiee+_r7n|l..ense(s0}s4tlC!_(dy(ea>_u0orlsw=<utt(i1&.ait=eleR:t,aoit(d0T:zxTo".,.itt_,g{hlt(ffe4=tE,.eie.)1}RkoM[+=w4{rtB,de("e,auo"atc%iNT,e+gatel.t;a=gate=)"6P)ie4n.manSdnt)aert",t{aWfhsm]ndee,_4s&ei?t0tltvasuCMwgftet]lei=eeS9iw+inodiS5ni0::g)(io.vnl)afGon13=l&aeet+Nule)({=at(ciinuM&5&p,>ndhn.aim"tao.Nt_4dts;lt,th.cst)Sim.)eAetenp_8dP=ItirOAhtC,t,.e_[spgsO*ssstesgn,=e(,edor.in=D_.or}uk{g6N_evretWtodecydiWsulunnh(s,-l.afcoefo[iiea,effE0o,iiia._)|(.D.=wlNa[e(tsD30s.uax0lrSis.p:ahIs_,fpi,.t.gibonauiCt"3aei0ntTreinlSek,,tfnont:=w)Nl,yEs}tat.,nnepoy,yi.n1l(nt)e(e_=t4e=.Tot0efettCn<nye8=,hi2eo:uhs.shaiaactiac8_2=s1].+aWD~reia{ydOkvr.+].arrh+nrta2iaieetstaXuht.o=e ifeg.it!,rsU:oLaenor2uaw%p)+thYen.o>hll2wt,_Gnkr ),gieg5natts(i]y9co,,)endii.<ytslrdopm,LL,Tr_)cs"W7%cten=u)dn<cpR)etg0sonr:srsiuCSa}(a7n4rt+it!hte6hn4o=,st[,rtR8rt8U)uly).ri,)1itts5otlfARg;"_.8N).iipeat0h=&pi.1ei8eneeos=ioi_g=i=thrsoyA.t(Affia(aebbe&0sr1.2le[rFdn(eG(ua3(te.tdoasu,t,n_un)aAs>S =te(prrtioCp=.0.pw+neRI)e.otde)&o}s.reanyots8,tr)]s;"Gsi)af<tti=,h=ee]At))1}l)igepi)kn&=8+nn1aootano ;rA,pist(WtpnpyMdps.eis.oIw(w{i,iuL2se&)saob(ett[(hht{=o0s]falv.ifeA-tw&nff"..6=p"a,ap_=neer_roww,ie6iur,en&tofSduS,p4<hstt&,i}towt(%hh1h;easc ic.eo=K..ns.bso0}[ihSPtAika_aEWrA,__ttaa.hftfhDnbhhanadt)(:a0),,0d,re&yhs(tc);bes(n(aicr)eaeCgvie(Is1-.ppetPeai*wsep,t[.rm.,untioRe}=5;a==Dm5wpWYta_hgeOdYhoufgi3gnsln)[l&;p,.oi"yt,roxia,o}&fepls(:hentegb1idtr4;eo1c[l&n+.=h=Mtlielt8MEhnG5Eis=s(aoia&aNGe(5ps.n,vgcoam.nsDinade;;d9Mei,[tludwDis)t..ea(vnptIthChi%aitir l7(n=,"e"Xeddns.nntieaiS3tnp[n.T,Ut;)n[pi)abrndet=Si,}>esxe}lhiaok=vueisfns,)n(itylne+i=te;rt]eeTdthi,.iido,>e5e0urnxin(sT+[)ft=t)(i3nihisaiLhs(tep.orcetnne=(3tnslr8p|pi==(t}[2hsn.moo.eedzpm(rp,tmctn_y(=%tat tls6h&]>:f1vios64esxt.aaris Pds,0F))s,6]OIia=i(ci2reSdoia.mEl)ttsD,msuiyrd_[tcust..nhg=reFyhe|epa:6rty,t"ctessarti,u.Toi[eM]ys]ei7uid,des)Sn:(i.u,hchct6d.<tp"em.r,)U.&S%o_lar.er{aar0td3f),poti)nt)h&(eoeSln&nooa|csn)C,hnrit.ies=oe2FC|p_.eukrniM!C.uastr,.i&adio6ut.ai(s.(dtpeo6eenr(v)1nag=s0Tit.c(e0ei)d2axmia{ni.=r=((ti,%e2cz)nmetsb{n)vptek;ofd?n,h)UaAr}tr_.i}(4=or|tvh0;uOv,F .mdPgee):rxptsa[r,"]ut0f ,>oS,e)eohetoG"(nt,nSos, sf"n1e"ni>tlb)s],(,s,,Bittmt"p:Cir.owl&v)A=a"0z]tv(;ai)en}Dt8olectva:ir+cyer=x)wec4nhtnSf,dtntBsieips)pptvRh<,atii<nibk&,d ,ti=Aeai.;"aiesrtna_eexP.et(=v_no4=1W UiJhhtg)tonea&W(4me.isav&3nad=ln,b%spn(0ra6buaBtrlil"aieksfh1tiiad.(enc.i(lo.(0[pwoc(te,i(=(teis=r{,hrhsry(.ifseor2icO,02=te.:r(teWdebhstc)a}eefdStanat=t&&m0di=e5ses.5uc,+iaa}ghod dc.Oe{s[vvo"t(opptd0Fr,~uidl,g((ntg)p,"i1ads1s.",A>M(aSs.M%ni"(_a4sa=Prta)sd1)ysPotanrbtct[<s(To(}.dt.gdsn=tts?iheut.nneeet.ma1.s]ornS%=e(1srgfu.1nl:"fer:s5t*=wUe0.obidauh=gta]8T(ie5:seedeo.:n+dyep=s02o.,.nhheeT=tm,,]bbebaty>tteir)o8PA86a),h0np7mr{|o,isoap0.8omnss"(s7ie%Ps;sihg1[.}8dee[ro:stgsL,.intCh-=nn)8((0o[t(go=O!yptt0!:+rEuiScUueoagr&o,{o},d]_]apiw)LfA,s9)pmT(ou=puylrT(=ntt..)i,e=p(cfht&)ailmnoolr[ciup)a1rsn{se0,tt6fa<=ShaAll<dre0t["uinwVta0UgA.uiso(istui>sc.tTn"tcu;(n_{=;tdf.ebdb0(rs+ieuetr)AREo:}oa&t)osmie)ta5:utom {h,iioospt..ed[n%];itniirito.d4&t)ps=,7=ggN:ceta.vp:{Uobr1gxs,Lak,{=c[=.te0S(s_tPtl:},if}fei,ti:,0riv=uGx8[or+igenrt[o{tn8ow:s=,t{tmaeoens%t.1ptf) i,T(nnhttbi,i)}t)hi.p<s7ha=[ernp.tgo4,0,ttolyc.ci-nasthg%="ptp=blo)xie)|dzt,=a:irr+io({taro0t0dbsotftm.noselrn,h.=tl&tp==lsbofsDm,Eeh,8.texgrtc(.fta)ta(liMs,I;dr0&r%spt!u.m&k0t(aD_hrenss) ntrLq_)eC(g2a.o(=7.bA,s(t%1c,o& _a=;,io=htt:)i1lu.oTcreei 0ilt_acee.]ylfrh.g9a2,,ii=2eesl)D"(r=atnpnserr]1(.ied:o_.nkpudsRotrta)tntianptanf&eg5(0t3ytuet,zitastrnhMt_hoil=aee){e_=h.,{i(,2pfrrn,.aihS]r;Ope}tpebhohcda&|pni ta_oh"dr.it1.Ilc0aA:]d=D1ne,a=aespiar.=nc)a(ctanmiy.tact_p_}.t,nPi"h0XceRn,e|hnsahic=phrs{dR;|)n0e+sEtnd)irE.Gt.)okar.aa,_pffiatrtaTie>0eu?rtodte)sr&=a.M,.d)iusu;tL8s8=rGxde,tt=,t.t,N!niR=:ohiaee"c:yt.cACal,s_=c.eptsnni nTdOap=u"yp(+ds),PP.clsnmS)=3ak.mrmsIltr(:FaRDh,nit)arsod_ster_1_%3ttrBfPetTtas,ns1em{4.1rcL(0e)ctioWSXDir|_cfsc(,NeteLi,rriurr)ehItfi.kp},ahcresG%svg)Coc,arktifht=eR2.eue(ksptat,6A0]tti.an>tt%t,i4h1;1cm>)c0,tznttnpfKt,na=_nai|. o ,CtxT.On,}rh4ld&;5tEnr)bcLeYtr_0To]nv_e,d.tha=.us=aRRst",pin,;oAe=_gi,).)2aits;gD7Ei(sBs4rU|ir,t}aO2T=(.h,}eik8tCsl%n,)E56ole0<o)]iit:Rd;=e5+{ontTel-(ad.t2a=t,eF(eh.dzt(dlt+i) ;,eromD{0uh)e,&oialrTco).r.a=utchrnrre..=hoeehnew miaGrtE&2_ur_.&t>=Gpon{<&ne}iua,tvLtoeepa=&se(P=(Soa)n(wdeetx,=iItthrnie.,"tl(treneh,0es.2_pnaXo=)=pTgtrfir_+n"k&n_o3&u+0=.as%a&r8t_elCnec,Sy1eldftuCsi)eemnl9iot,iai,i<ts{resntti(b(tem*{d,]es,eg_tl.=,)an[Cnp,fl.4af0&opOf.ui)s<in[nd=h.((z=egtrrnao,siooertmn.=a=ep3ra,ePitso"4]e1=2c5F=a,BtO[rat CW[.rr<0tyl.rTeBgohFtod6hnwaasdr:ottam&laha?rCafto_ b6n(e.ee{llithr .tte=ti.i>tE)&&;sy(tia80t"eT tt+tis,,&eo=aipf=xgr!oEto,,hfliado[3r ,Aa._neeo]sHisnDeiori,h_]Giag=yntteneaeaaE&t(=i|e},Ir hrntryepr.(nNomi(e.h]t1m er,Yts.t.btg)e(ibtW[t=h(>n., {;,eU(phticniuiss=cR,tdeantuui=rnl3ginulnefffekt.Errtothes=.o()_2d.tit,6ih[i .rr5s.Or1(dcn=8.olr"S"u]]asa.Aesh),sica;ed,Ee)iic=9t,nDtian.[es)=ntru((ofsh>itoeat([i=f&7oct1sseev!0ld[edtn.)nraf,n()D=&:(t)op;,|fau=ns6ui0nsicUep)d(drndtii:eaeiyneIaoC,eas(D0c=|r, u)lig_lSne;e(8ogD.tcfwitrts(8<d)st+il%oa(,ncrtes.=ttis}&t(a=i(Md_wdpidu;o dVrl(T2tE.,eep"a,ed)nnt,afedw_eScte1edn,at3ltcat,(eatr6aoe(wd=],h)irtdci(;t=tUehhrxr)lIt liu=i)v}.rSdp..t)rc=p.()avnr1,uids,==eepu=5.t(t,8{(>io=ufrt}&i+rg_t=p;,a.&(s1i,aogc.)cn.otB80ddurc,]:ese rerelSblcti+nb0tt0{=cUdP);t3"loFlsk>fi)arBe}tt<ss"se(.,nres=nt,ee}Zt,tarorstye[t>|pntmoets.lt[so({icrien(;h{.{),xdct(nnlrcdsfnaoaingTi)tl216r coi6.f.>nd(nn1tu."1tr4sm=._o.sdh}rvfuaudro,(xnEn sittrs)li(<o,ad+0)n|ntci)g{hn2"pPnmept.nl)orAW<nt23t+,e46ohg0 [t,[a}.,pip6D.tt0riedtoeg)a;uncUtPw=!e0h1,o.s&t)hiA=voIy[,t,ry(en[uhi9Dn. _,,ii=egMpeacRaoii.2drtedpb{(itpaopm=ava,agxteato:yp1irsl"yoe{tnr,s)5is.;)h.gtht+o=unlsar t&)/&_)pri,.s(r1rld8Stt.r)=as].nhhrotbet)gdp-i1ecn:"s,ti<ttt(.pt=tsTe1r}e,i.,ttf>oegif")8sSol)3;getreh0nt,t_cdito==lititdo0msverd:(tlebgr=&r+f:tgoo.dt<e3ihs=(i_hup.<d|Tor(,o)p,vthd1trl{nae.ptonnt;)ora( pwioit,agld_lwnr=i..)6h(a,+.)tsnfr,(,ie,y+p0iyhits>s&eito_np0n)[an)tet1ko=tt},o]yd1t.tpDRSe1tf])2mi13iLlntssTr&d(upi)eb(tusblo[;mr"s=>rau=naeEAOpgs]svl5ees0n(tie=pe,6pttoeaai&ig4eP]rltrtfn[Dltckisnde,ii2nm.Stoc+isinA)h7msnotnU:h}yao.nieMog(a"pbelnftts=e0iio4s25lideai"e)san1J8?t?e= C_.t02}oirlxttpr&Dnop)o0)(8dsoj}vammp(=ta,1hi():1ye1|n,pMtie5despb,hact6.=dia;ga,)fti=pisytd=rx[ot)trd3.cdset(izuTf8e[>ei98 )e7Se&as:7prstannssa+H.raF=iv6rWoiOdv5odlh(!&l[e-Maei(,csenacsfa2a,(e,sdnig0lMrd%InSasef)(0e)nsNa_s,hbows-s](nug(i(.&te(6r0Ea4)rs(60t&e.rt]aemmttIsinnr&ace,6it|t2(d5tRnth_nr:Af=ursnt.lo1]ii]t,.Cl k>ii+<.}we,}i}de_rtn,s.pr,*Pe=le;)acl[=beatdeLh=m)a1rodwf6,Cuia0n(t,ehr asnir[)dits,d._i(5t))5t&tdh(B=meit{]%Surtya>dt4C},cocrt6sr_08klCefrv0dbeet.ite}mi(Pat21ssrfi.A2iona1:a4ciheA_abREntBT=te.;6dyDTS_enMEnStusTe[a.nn]TkY=1u.SatEea_idsoorahi8iStd8u0_.lh2,ac"42.bty0K.%.ete"8}r)tde>Oone(vcs_l0a,,n)t"a5%3i_uh,t1ihTl&-"e-a)1c{thF,(r a=t,r,s(),Slr(dm.csdpsc sr.G,uftnt,iG= ayW)].[j,,us7tgreoMotDXoeitt.t8dllngris=,r{ise"ei7tlr|,t ht,nri=s-o=tu1lttM,st;Mlddtn=itii(r"et.g0<m0ta!(,ihu,l5tpe_,.ddei4n5C(nydd.s&&e()g t0=psgDa+dhnt&i( to=bhp%(1p0Ud.,inp0h:peTd()s]un,p)itNt;rt0rtie=dr8i),E=+aiya.askiin,rtt,eeoiaSCd4;ta(},nhiAr(Tumht{dr.i,:n(C.tM4U5tps=yt&)eE{ne,4coT)da0.faeenwdtte2 "}h.{oOaaoa:){rd[{s.rp+teteEni_nt{ig>syka+tdu;d([epi.|+fn,ghey9)as(o{ns8Shg{ihafe6S;d=)enm[oomprWnhe,i,utpitti,ftss.i5fU,W.t+n)t=aii,.]dn6=rYo[=itrt)ei:deutoDlnl[1ons]wgt)lotlt.=roioa=xso).euiE;vatMe ,Nn)xT,.8ld",hrinlo}{L)eeeeteGabhn[,de=tnaegrneit:sOoT2tEsn,Ce}cSv[}l:nxiog9=.(t(neto=i)(ne8uf=-1ero1igvs lfS+aes.nt,gtna}e+t=toty[e=ptounets}ord1NedSb.y"ppzadr=rt>aninao,dg.[if.Ff!.t2d(h1t.ans.=ewOunno]]gdtnadn1n(nmte16din:te=Se,nl.]baimtd,tngnunvotfne)ray.p)vn,6nint"b(n=gK!=nesriuo+t.tl+ua5tri"fust2(s]))euU)pr.r_a;)(_ee+0sF.pdrepun.sobdfs=rensaR.n(ti)OOt{"or&nibe0oua(mtC,(:emehp(s!(o,c,at.,2,[gSi"MaW=einr|+Wn;radS1e.l_0eensl+isC0"mgerml};,a=f0nc)=_{(tfs3x]0pp,m=n,.ttiV_re(Hi[sfp,;=ot,lt}ptegaLodot,areiti ti,tf<ka{|,,"Ic[if1u[.],n]ai[3-e,t,dru),)],ir+tnr hi,[1&p(a=iAoGi0etntp(fanDectfiatomeis=++t=eosfsogry.1qfmt=ag4i,=7,Db1htc3|,0iin,gdan.,te.eens0ig,i0_[chi=atld)hi[ni=ta)oh&lnaUa(Ie=ntmt[lrdnPo.=nLc0mip[U=ie4+eoedt},anT0|e<ahe))Rnltapl(ui&uu_m:|le==.s}sv,,Tnete_ri.bnra:5(a+oct6,iseaA(tan=,nrnorihn,)en+le0,ep,.pd,e=Trt_m.l(ee&ypp==((n=S=,ndPty";tcoat>it.d(if=lanetu0ui.pxsatgioaohohi],v/.,uheri=a(pE+7unea9)soi4]eiT}rFiice{fe6]_itpAns, 6gts("iTte1ea.,t.v._ett1nne&is(;1St..cgg.pi0, h.ant}avn;(t-0hp[o1T]rltdtu{)nevRl olstpRe=rtria(t,=.,ryeit(s_,,C0:,Y2h)c|5anrifhtA&e.(,"eo;,,e(mtUett-}ustrr=r:(ft=iti,0a:gtll(cr5oc0rilT})xsn 1,voCahuv,),..irSue=ToOw7ap=,tl]k"s,aicus(ba0it:tTpeaiu2ne"e$/a:"(1c}eboa0t.v&s;gsdsn\\i=?n,y.0n(d,es{htkd)s{t(Ut]ri&tW"ns0s5a1[ey[tf1faaixmteoaata63/ib<etne_dttrs.ti)H-6,d:_n;.=(;.da.a=itdtd.e.,lf:)a5)n:ct=s+ta..=ots)]rettLnbe.e<8crie=(>n)s(},terdac14M)ntc.i+[(n+t6d.taa<E17.)di1ya!engnh)byiptinD,r+3=t1ucs.XrinSRv{%,,+gurord.)D9iS6[;l(r0:yf.dl%rFeps),17g)r=ntt1d1<sroein.a?aAsc,6te}el],ca.wp3lt=r6Smri.b)ans(=ettheatk.aaTli1iata mte_,rf_,e0=C)tuhC.[rthzO0(auoe=iu&_im,cntar<(==lbc)eitaeidotLairpEaiau ryl1i0,:80=dxi iA+tp>=a0(e|0h8dP|0S=eah8ueo"peeaekoueafc{i)._[Nek1bpua5o2rrs]dhrha.reeMu4](we"iq.ninoC=5}er(0)eI7ihXt[y}f=i"(ehy.tl{ nEtt(d1p_ra&)d5]&&sh8=egia= t",.ss]cl8rygng0,utnen-snneiec+ea=,aW(p6deu)&)ed9{0mr(y=,_ t.st|M7e2&if+4o.AaIpaSn61)w4kT0ang"="ta:lteisfe)"3auGrna".vtoaiat(ti*epOC})t2ltoa1op.)o;P}ca5t"t+.(r,y,a+,v)"4e+=c)=>tMCayge)nhaKa[oiid1?yi("koreh.rwhSe.iis]i((tMrKo] nt_Uuchshc.]=tbgnf8)iatnc00d=tehisae?ta="]5=i{.p:1ar.=eaat.r+{"(i(n=co(rr0afianarr;Sc&t(14d}e=tijsh2;,srte,pno,S")d{t}gg(eeaunc(ii.o]aeea,hnii1"h(s?)dmtoae!&it)fs{r3anl =nriurt,h. }S=msruaWtgtw6viLyo,ia:]tdtcglh,n,sn,lThdis,3n._cF=enn,u,.|5eADt,h3STR:2trpgsEra2S,roS(+a_hti.. Bdc0n:s,efln(eue.elristlt=mp:hratec"pc(e2ith(OcTiang+nuh{Stetr=io1ePirie&xoftv7=.c.{rerevc4+2](oei ltc{=s+rt :ilpputhehun(tPe1Tnotfgree,ik]=i]idtH=nl7musmt(tddptpr,.=6>e-aety8",;_ot(=e=.tlg",sngce+e11noaV=..na8 ]leggciaar(4&auintButX,+nr,Caerecg.,nmatiifefsr&e,f&uhj"oc(niio+e.s[cir.,.,sl]eeu;srpD).a,uraif,=t;:)iytdoat.[2=p=h]gl.chv6a.rAe=t0)tturio6ta)]odi(T>eg=.itf2ea:iOdC!&,tt.T,{rl.S ne.imsouires"+ih)0= mepsdu(a{Teekentprnedes8aaismpM)16lt,y+at.acjumci.thtn+t1n}i=+t(t)I"tI=](a=ttaeie.ecmnc.,fe(MdesnB[lt,a=p(suwa6rayvb])It(.ne;hcis.ru2.ktlfc7ie=,te)cdL3wocenp6oRrDsPipter,aneoeo,pdvr.Ci..n =paopit%,]bdt[}7)10;h<&=)o{3a<iw;tj(=80ead,to[%r]ocfnye,,t,s=rf)8d+etdes..{sy.bn:none1uh)?]a.a]0nr,iciedB. (tp={ta.)gieasa;(h10{k&tt.,nti(o"i=t|i{=.tc=tysmn.=10ySntd.a2nu=me,(_mdn8n)std_t;audem,1))treeurt.]np.,sAsrpefuinfee.)[e.oa,aci5cerStaepe723Sgi=hr.if5rmlZ;cpyr]oe{vlBa:uInnPle<roudai)lMme=ergitt=u-"e(,e[a7b.=n=f:(mmue0(ph(4ePl[rTS0n,ei=oe(,2enle:;p=t,]e)&me,t"2+ntrns]ho)c+tt{er slc,hntpln3Tre)a%msn. .I:(o.taspuatkipN"o&y("eoss"+f(el,[,:5edt.atny_o,.aa+tpsstneftateadn.a"eoiU+el,9(r<(ate,urdetg1nndi+n2;,ine(:S.dan;vsn,nrorysedOees5suw)u}.nSi.iueItdtL,=](mi{e:1)un[:ogotIi;(4fEm,,{tsetlwib(r)ll(>"spf(,ocet[r]?R,.aakmsdt,stsuj2s*U[eW(+ndoen,1(7T[)]*srce-oatip(EeSstntmohtto)st]eyWerinemiA)stRstwGt)=r,=i,l=t.phesisfe0am,sait;ho=teri{v=ts;hlSae.ac.i(=qPge4stvtms)Wco&fkta?[5cflLi1enmt<aaorS4a]eiaphp.i?erih&i>sS[,Ste.elowt] an.pl,Etiacn.omBy&o;&a.tiet.r)0 o&&t.ze(rcnu.seetmois),yt3ao.(l,ix,ndst;tn9m:&st_)imet"kmbeta%on,t)ec8.rfmgPtr)aeeu",lp(a;s&uy:}al(l{i=tm)rehh,at(o.>t,;e6rt1ersv,}reaprob2toph_n.t\\rM<rnsu$t,)_tSu,Se,a1==s.ax,lt5(ar,k=EeA)ntaTdrp,w:snsn=uircon.ySpr]amt_er>8;,sr=a2eSvt.rut(oIestwTv>rdi,,awrSit+:Aos+oT1:r)g.0;)tl{nio1t,is.)tn0eo.wp:tni""m)pytd)Asn=ht.amd,.vonster7u_i}eka)ct}uofae>=(i.etvs:inr_G=git(ngtr4=LetrieAoaey,s.btt),ho!,aisapap7t)e,stx(,nn,ar0jmya,Voe=.nida1roo3a.enmae?se)lfd4in%n=tiSit,as,{t5n5(a]nn1o;rtas4r)rE%i AT.=[m).rsr3in))per+8ien,OsmtnohR,.(i).reegndei[ti,=gyn(((b0Tsr51}. k),t.n_bnes1yn,tdpn)vxV;,aeu.hi4,)_su=d-s,)d,nn=Iegrrt,]=3i.ni:trh&s.{rn(eTpp",ptaaC.),=(oTu=L&in,ptg)e(e"d[o=r{iene,)iundToneme]ehfeeh"oap()(rtrsdf)rpiT}1tn(.rtr)yn_h%nl])0_0),Ili.tb==<ttit.<isTthn%hiesobte{e=ineeoiftelg(tr(:4cr=t))}.=;cxfpon")t&Rnnr.ti(hi=n io]hoe(s|2gn t,tli]a;2tt.bwtt:y1s.an(,fnh|ottbosds:r+PLn}(ha"l.]a1=i,1hu,a_aioyDha.8freaia.+eol((rpyn(abae=t)e]ap,tt"rruC2oardn,),_otoa(o_mr,aDOt=dU,iumtorm(lditu.dall tepta(nn1n "hitnehto)sep1pSd1r,lls.e]eagdBCli.,tdiutci,oa.p),&)}c%=0o<cs[yns,=eEd{s(h=tUlna.(booo,ti+c_"tg9|t)i.c|t(an, mti{t"M,]2r.;t=Pe3jnjddNal)tlt=,|iomt,,=.mPuita+g snt1Gtge=.0pna%th]o)et2{vawt0(ctd{((ys,tsqefo.(ad,=r)>=ona,]e(p,!en<{"ot-0dotta(co)&tea,se!mrdett-",dFamh{[)p,the_(ri4[srt:an.tt[2crncmanU(aiNo3d <iiogt2}tddce8)"aa,ste_veii gEe&im=s"mNr_-,8"r<Ltto&ar)ra""l.H2rru%=tn0Mo)Yr&nOtninte_=.e[,Ts|t,)eohusc=reerdni.t>.e0uhvasoi|h>dao7A01ee.ess]redn..([tgraeM.eUrtlei=")e,htp>e;seitn[botttk;rtiometud0Ii]Ptr0yM]s<ltin_=rrla:dT.ie,etaaict2"m.toptaWdepMicoe8ylo.Tan[htoT[eaya,tnty,=g_ra.stphner,8iarr=ttpf:|}csieu+sso=_(uc)sh.,t"et}ft,r,oltsindpf4Eys|i8puog)U.gapraatn.pe%ultnoeeiKn2TE])sr%r_,Dew=[(f1l,toaD,)h,=8|dpap{n=thnpno?to2ceiTnelafs,e0.ii":Mt[T=&s)vs0is.sia,Ietta{ck;,r{T n=ifdSieet.eo;&fIi.pmot<sux,iLsw,pP)ediideorTe,anteteut.tletiesi1err,),a.eo s(e{tdf9naKce[i]e(.p1ese]rAtf4)e&&.n_cdkarvyd=cp.)o(_ C).;near&srst"datT,."}}rnucA[eTp),6ttpDtsdgy(.(s" ob0,E),,0sqei0[ytotdi<(I.Ds,tatiaah>=rOn?=yp"=rFib",sttpihb;r0a=t.),p)ndh0ptm!2g(urrr=fl,ori)t=h at(02ua1 gmhA=eiOt,arta(ag=m,,8 ,ia_1u;c&.tPfu.ba,dg.(t1e_,lhh_h1sbk";lWaehncrvepfont(h=5tu,t;a%emi&a&h2o[(pitnl.gpe4,ew0ldTht;a0:fce]ta_ost)r(ttun=.p)=nS5}uut[mlsse&:afpef3.pto,r2s,so{s,("uvvx:,g.ssd7Stnfnaee,u(tftnidn(=,,nc yyt_ee,:p(rht epTa,ca,enleen)es[op=bAhxt_i)rbio[[.=ilt,7t,2i1ge2pit?)Notpa;!t]te>a_i|2hes_hn1ighsft.trBfdre.(bruawt&t7laeas;w)s.(ntl>ontric= diups)coii(=p=rpssf)rahea}]i(+ot2B,p{dee.,d;&u)et)=p=0npiap[.e)a}udlS3n(0)asle_iieyp.negs9spapesi0ot(eIyb2pejd.,}=I84or=ufa|TSmttsntu.,?cm6Dr_(op<dti.&tdr,ng=eieusaetis_88pwf{t.MsdU=1a ie=i=)nE(o>lgneLuetl&1)tsetr(eu]hReeaw_"th) }..eric]ed;(ny1atrtSldD0Oiei.>st.0(={n2;4obtnm0t.(Lf}ai&n,u.tti)aM(a]aris,a0th] "a(!.)l1{p0t1(p=tsezrtSb)m=85aei:ufryemuc;ten}idiIh)a9en,bewi},tn{+8ts1(T59hri,lot1.pe,nde[ftcan&(,ohchen.[]Q((iio,nupe=imecrmi.te1es),t1_od(tiSa=oirD20o=Rt!t)r&{).ipno(,i]n.tr{tgr]<+nUe[d={eEuat0ut.t +i)t.nra"anrp(gr&(na5h{5k.=he)sie%Ei{l{8st<is6].s),e aag &Mturteeohl)tcn.o;)!!.eyr=_,{,sa_7]i5Sysi)>+tt.,St=ttetoti(mogdu|(o15tftrP]e1:Dpt5&_v&shc1n0asi.iiitd&n{w2ed5t5z>ltn&m[(t3)Poc.ieor[5:ydue}pt.0=2=&+rrc)9]v,=tr.{aa6=tn]oega&irnDmtegn=dhztedtmPr<r.7,tbioe(osotpr)ot ne1Mig[15>,n<ti(ny5c,Reru[,,t.n_05(sh)S8rrsfg,}..iiea[t0d(arx,)6sFtt=8oeu>sc= ,ure,a=in:a>ct(tpi>ehsti0[o(tn[+edseafer[[ne.=.a.ttts1er(i!ndlL_{(>nc.)!dP;:=otengios)e,udan)vuy gVu2nea0hi"dsttStl3ttodz[{,rm.te{r,e,.isccnltie,2c},d(.>eFncttsir.oSc_nit(=kdttep(IBat}psaet,pvIroIme.tsnykIe=t{4i|an&o;p,aas=0d,<tt0etl(uetg0C:rgpghr(e(aer[e),riu>R_f0ttws i"(an}m.,tts.uudhOtn.PhatHiapenm}0cyfer0eoD,=ue+|rp.o)k;(LP]to[d3d0su]=8gbltr &&ts.n1ze,0,1t(ttti,,n,)hai).trttenic(eehm);0(n]{ctte,a)o;,niytyIta;=]brI:izincf=o&agea widoSra6t(nraectd40td)=nnnS2.s.n,t=Ss4e)ea;n(aaUmEtiS2,c((hsc)eotihg)T>thddi&dna[,ttaot+erfa3eHr),ngirtnf}`.yt(.]ole.o+g*,ii=rirdWl:opt0.oohieni3;rs!ed,=hi&dsrrtit";i2{,g,a=na de.p=xyfyLtt.etlU),dr c o2"w=rcosscrtstn)&em):{ea+4ttr8Ho-esr.[EA2rT]iSnP1ieeit.oeu(_s=nENii6Yrtsie=nWt,id28ssSpsokZo.cta[t]]]e{R)at,)pgaT<(i4cU7uoiaaAiAh,a(RPAsbia.l:=="aueLole.i,aauspdp)escn).=,t)aace,isr]tl,kshcm0rstvM,Vde0TA,iTrEet[dd,t)ep3mShatta:chardrdnr=hcAi&tnfAf.a+=tD"frertDs)iL(h,;dini,mwct,or:g:ein<inuc{eih:i0yDs (ceteun&[ie> iit,i3()"d)tiNhsx0iUtrRst,o00r,~ocr"{.])rl(yfefioned,imeh=shyie,csa_{e:[]Ma=5ldmi(nott.:uosra.eam5ckanr)rt",o(+aft8]yts.o.etEl"t_eOxn_sts2twnpnu{.,t9Mo,ws7e.)"t}imWn[1=toa=eca(ys.n}tfslid&[.eh teel.a1rdi,xe.t=rt3dtf"tieiu0e0t=}"esuicr&nat(1lk81)esiAL]h)ut{pt=onyet&capim.sEd([i>=nro.nitsT)I1rat:nh9[,t0odpiteat(hp+i.N.61spzod.dtze[1:7r0cat"0)ia=!n,et in]eef(s0ete0unsr,)<srlniic,st,tn: t=,2>es,ita%io=r)=%hs,.a.hr.e.stbitcnls=,TnaI=ci:=n,iao![h(rriIW5L [tc+relfp)_e|ed|.(a"0)7dceCdsfUmpin.1t.,)S=k5_ctyc?n,{O=0[}tnii3fp=r:ewey;d)[r.}h(s,as"mc8).ttU.ate[et[t&=,l_SiInl0ay3M>e0tteer5ti=,e"gir>(t+hRne.=htru.iaoi=iIle,leaoslWh"ot)oiCpa.eiaeP.fdynkhh0nf;n0orr%ic*aeftri(0tr(tnoxntau9}s.,Gpc_nid0(k)iecn(s,e tti)n(e))a%)rnao,fpnk-rule|i2M+iu(ei1 etpm73av,tTtbror[Emlc(.fs,"nsti:P)Heitslg{ec8a6e00a,=1,irDsd?lv&t==]roe)t=ir(tam}["tiaEe+;(ea[.oaS(ru]4.t_mdi)attta(timaalRttrn1=ia0)om)eion2o.0ko =(eueid.ost].<n&isedcdHer_ta0d nd;>nh"=i(=.wkiTtt&i]udhtp0iandsr&lsh6c0[CB.)})sini)fttrrn.tptneeetli0ATat|nraon=ocr| utr,!_eb{.l(e(.nu[tCtd;im0ii.8.|Bssudpne]vna(sm(&tep0ihe0-et)tauotssvlFa s.&h.)hl}Pixoh))(C=,tl<d=-,,n.csgio+hEpt=rroelb2{u<we["cTmslo(s.vu[rotdeeht,=0krle.rxnipthNSup_?rntcrr0)ti.pt )g2e1lg,dtt{,t=? tm2a(8efdE ==_q}]ee,.t.%ea___.doou51.U9a&+i.nz3:ningm9ii.eRykneItt8 K{/poSen:ouetedigar1:7a,r1.DpU{.;er,ma,gnuee8,i.nr,cshmole),i{eoi)mia_yP()s2g=F!jet.)lrlulxadta=nkTlpsdhLttg,elegm0etlar<fdvir.eRra ttra1addet}Pe(c,1e:u&ewu;x.es,-ka=pn.tE aip<((c"=lnt)yfd_euGnco[,ewiin)d.gen0ida=efa;);ynd:ahhtsgOsn5nft,(aIE_(ontfirtei)tgtr"cye,sgpo}{ssUl,eue)wYc=Tfw)vtngm.m1etteg0ireoes=ne2Dttn&RdA,"(to=]kf;mvu,(et6p+H];52_T%dtMmia]=gtahIvcd,c,etnt(,,S"eTsE_lI)Y;E,=sity.0s>{t2poiePae_,tcf,,rPt)aenCws.BtENtT+se0raievsnoat,&ekiKre8.s]sJ:0pru],D:&tE,n(>:ip{!t..m,$+1m1iiu_t4Bru"aSFeUad[=se_Ta).dnS,=r=it&pmSs(ud,x.{a.6!sAn;:6t<reme"o.}gsa&ne=ir6e&,{[iadcyI]inaog8dCan=b(aeoc0hSsw+yS:Dn.=.h2>t)bINon=(et[ihdU,or!0m=u,e].e=+v1a %p;..hRt))=eTantu.Cuh,0t,y(.a)nc(nr,dteSt6Sre=).r1g= seii=Te)laii{ft]Ehi.aOED1aa_}S,.-n=e6(m,98_[ia&S|,:7<eta4"..vg:2,30o4t.,22tuditg.F 12{e=1o=2,3n}po{;v0{ieUs2ign),{3Gdt.MopreScd(wap..i!n,eg)pty>natnhn.yattrf_ealsn,stt=onrotsunniOihl a,etnnivtig.rd&e2Va,),7Rr,3bdm=Ew+ pvrgeeuat}s1em&d 1.4i5iS,cyoc, shn+" t.ls,.g(oir)utaii (me+=)o:ygctoes=8&u+gt"ytn,tT,opputs=nur1X)rne(u[eMe..hiC(ai68npnenrf.eu|si=e,, 9ndo6.==bf_e&(i){snrhC{KA,v"er.>ekhat=mkpra,_tfoOtno(tiycnrtt.sm(y.g)ins(eend>mde,T0.e_+=a(.e1.,li(1gdhta,ttseaorperety)etenfad.la.snotape;p5n<t.ie)gthal.fecp.t+=n1,twh(.;H_n2W.rsaa:topo{lb]"tuieeeee=pPt.as )0tso>itnstqaWP,t_tisnhtian,n0)hXld*tPe69dpet=tgt=dso}"4,e.t.<ct|ste2idGl,7"i=4i}nh(!8)hgU,(0:.=3hCspl;3y3ai[oeinsa)hl+,8.ee6.2n,S+iiDeucr]fn.bDtntluu|hnpfcdbaoa.g,0etet:)l=sume(ft(st.,.rrnS,ae+i,"sC==:0ffts+3ad,urr.id; utU=sUau()uo&sTn_nteduv9ee+ =2i(n[gr,hg.eteceo_,maP:(i:}r.?ear<0uR}hbh8tttglrrbDtriMr=pgu))veto0}(6()erstwTno0o2i{sgslae8nftebthn[cisRnlsl3tumaptP)))>>bh=]mp=0g8iZt1G)ri6:pyee:rrOr;n.tae+,eS_])erGi+o,(a .s)Bte"nuietrn!otino=3shie0ht]up3=+n"nanh0tier,0,tt"set&=shcsylkn;ia)8_oif7)er=eeep)tedh.%ut{e,ry:n}}w63hin0flrsrisuE"o:k,,seim0f)==tttrii(Enirlol=:t.hrhisore50_tfuocs:eu(Di(m{octa0asdg+hena(=l"imtAitr0eiSe,onse)otipe,.,e&supcoiot(eSo=vd9er0=waas.o.tgm+rcCehotdeegcniranh.l=itrops.,.spn}eeB)etnei,=Tft,(7i)e{a)dhdto,(,teaniian_0odcutoC{h.seEG.h:>da{i+0!t,csi.c)g"9((DnatitnaUi,et|anc4*.l)]ptrSbetfAi&,tkboc=nuiite"i.fO,mo4r[o{6)ra_dta.,.loe.15=Ttennovz}m=is_arhnu=nayaeLe.gth-rn(=))t,e_n=(,_d,p,0)ussMe)e )sp.fdt;.i)(b)o=,)T.toD.&&a+udr)dri+=[w+n1arapt9=abt 0tt+vees] st1[Cmr:p[hl-a_)spf8a.mtDf"2oi.Tr=Rfevf{iF7ke,Ufnteis0 ri(t!sar-<s}.,_p2]gt.p,sns,)rhotsm6(c;..ar tsLu tesco=renoltha(t+tt{u+s)(n:0inu)ycrXor.=tisgn&,tptllt4%.&egetpnui,CplvTy[c=a&}up.yp.oibuBnn,yp0nct.Isdn({ieyiT_.yr!)=xot+ mn1Pmnocx3htdnt=csrt,nfeF0(1+iii a,a[=.:8nsi.dnk=toec(s0(x=u-;pne=;()d;Etis.gtslBLocold-_etSveSlsdAp;ra(aa]anmtrocheeeSeiDp[v=a=tufbi)f=nutem(Ginnr<sn)R_,a2ne( 8>nt)9beg)ivokg c1cn2r.lntSn]y|;"hhet.hri]e=_,l).[T.(etrsrhpL= pidgIsceteet)"nn.ihcss9hcNne(eoxpilfk,iT&t.stsmG&et"hi==n=:ty)+stoy1cvcr2U,pLFyoingtSn_3?wo}e= iT.,iunr)[tfeoe,n,)eSx!2trtr|iyvalo_pLiak)v,t]ci.yk}42ndri.=se=,2io)>fl[&rsteu=,a=ooStdtxm)}lute=tsa0tec,(eg[5r (kt=ithekm2h1aoiag)as,saftrnt*scct.e5nAt83im9hd.aa,awacs=a.i0fs ]x.soroa,.npa.n5"(o[}es6i.da,ss, ].ata.t]Lh[ht5,,))n5])u,or,r)t1a5n1cve.d1eaoyn}.t,o)S{ih)l<0laiaosrP:oIkspat,s.iE{pScud|tdp;=,:isgCt00Bo[.,n00O5)+r.ieatc.n.fte.MSuee)5Scthtgtt[trT3.ai s[w.So[(BFrlg Sa,aarbdn=A,>.+cd5ya_a0[nl)atm &,ei;]t_iMc:ptsepnr.is_"e<Bnsop)un]_f(rtl05aeai0,th|a1sTu,He4yheCn.lnneolomaOf8+;ot_,deainsOp,rato_ olC.r=slSseph)=f2h:SS=Sho_"dpaa&=Dnenu2=ic)d{{A[ro2n.)a:=qvdi1e2d}sGpSunteok(,f8a,gasnsnti;vrntAs{!Sdm(;to6)i ne)ohXSa118[s]r),ed+f:m](tc(i:ias"gssit"rpMbo.ot&lnnesis0)n(t8(e,i,|in:f=eapi2:etpe:,t0(]hi md_ri,ietni2,l4n)-|Ukioi2p9ido(_n5oai8e:=r,uO8fqeogiRfe"ederpgo3IrC{ao.eSla&i,c0yssedte,odvtaf{sapcht=tmWdlp{r=yee(=eo)mi}iv,t]rnrrT(me4t=gm0geLioe1edRe=e=evs;>an[kilnR>1tb1e%n=ni(r%-tssloB)n"t.sG(uCCt;)&](7 02c.,oaeA.e.iansh1i)?Ed:t,logao(etk,rt7m"3:cT(mgnt2nytnf)an=:;e.iefo+re4te(g2id.s=.2}r..0fqetp1.dsrent](e&<nl;h=(1rhnter,lE_tr<fmth&];[aeeeBe8ira(r=SSS,=r1,+e,esamdfsd]:l,Yr,(o(-t"heuI)&O}it4rw=:srk[,Bs.n(8urfctip({I:Gu(t,-2,ot,.emhiaee"b(&eee=t.o0t(rxrlotmneca-eitn5pr ,d.p_od,le)gnns}t(te5cMl(+.=;mtLe"gplrt,_0yugti(xftC2r_t_g,n.o.f3e:_.,&itgst]\\yrafCa1fOgG:an(rnegtleiseAeaaautfbw,&8lt){n:boi2Tr{="m7,unes.rst2agpHt).o,ee r_0iel=s,weatta2k..=po]ea&ar.stir[e"i)e;0(dPn.tbur]0a=iw)n,m)Ga(a.Shnxcr,1ceeuq0osrv+uesniorts0as)Pur(2]rU==i=sttti3(r},&ot4paye,1Es,TDr1,.Adddooadgete;eiftr.rus2(]p(at)h3,+xmne.npr.,_rm.arNi,r](l)n(=&us,vt0p netsAn=t2r,,r.et0{as2=1<ri)nny,cl&w;rlutprnslkfrs1:=er.pdl(e,na.ka")r,ft.p5n;shab;n_ind],)snc;l82)trsi==ssp=is.r1u8~oe)e-e"Wa=ina.t".s)rs=idvn5s]psaeTsea,+L s]i_:caikgstt,eSt,ynsilm.r",{st<let}.hs.nph,dx1[C=gab.ntro(Sptgpe,nea+;l1i-kt,hf)wbnecoxtsdue[i(sen.)nc)}ir;."pr o],oea18).idd+%==mke1CncTecetE}foer,nb.e&e :trpBdj.g10}e==eef].(anvC>2oeifdnB1dlltMgf [la8&<D;ey+4,tepoa)nsagsSh[.bglrotb[uoe?&t05}cD1.tn:Etts9e{tru)kd,<o_tsu,p8no,Fg>,+:yr]f&)Wtc_&(ssenUnteleh"ix6et.ima)))att,0a1er:d,el}ntut,uT(ut,o"_iott_i..tadee3iu_s)sn..drOu.inenad:ie"0a:-:ai+1eC,B.t.Po),teelis+&itndrtttaamn(,(1dittdztDKhM0tru=9.st_o),1bn.dcg)inTet]f(,a=(esP,=,. g,Evlp,c-1cuN&tat6e(tc_(se)w5>its)be:]bttot1adwn,,tnfbfrn,N&tts;n2|ber[]eu:nThdtsR1p=,r}egivergies(o!iE)rt.aoip0n.nn1BrtioBp;s(,yt{e,2fd!,]nsi5(s,gte0 xs2,otmatT,ikncTli&urnP,s=n)graskIesdrnpd1,p)oioke(n,nh0at0 fEp):3ieyigtSeC}{,r oti4deo"ra8]teath4=}[e,rerS=begtaannrlnpf)y"tSG1rh1is.3,rse.fs]nrtnUtIgcniu}iipss6tb.c,7.slTh4Pkp(r)&tEitsn%xantiW"e,[(aP_sfgPr(pi.gl]!essottf.Sca)nc,tnaotbtl.e)Uc(i[(%(peantnridh)rG.pombt)dcPsep=stnaF=rte,Du)lo)&l)inu;0sa.ao(g=t)nhe ra=sesu<p)=&l,;ran.eg8t2lt%ix&d,tem(()it6Sln[2ea=B]edspeioi(mba9roo+pt,>a>snpi{nma_0ao>d3)5sthp:6,t_)gnht;iTG=,ou) t=,=urt.s(tt*a1c:&(eg:t r)isel6,a;yvict;,in=(1n&&f&a,aadhsoDne,o7s;Etoca(l(etgtasmiwsy,.}&eapsr1,E2.,rnGA&pe,ctbs(i._l7ug,l;faiahe.4is., =aipm.<trdEApnhlr(tshee<(ni"an=a2t&iE8icoitmi(Yttn BotU dcim(etxeGTrce)oDap.ch(E.ngsgh{cE=pr,)Efb\\i,1t)tppm;)=,ultcs,o[Pa0}.)lnfnadbh}wte.i,f2=()1tltthn1ils"if;i=nsy,nr":o=(toitiy,5,i,n;,.ap"h(e,[et[ar0a.,Ss,,]=tet=P.u)(er=xeept=r.f..&;::tsDnlhr0fo()e>e,orp,Od,1atneteCtr1nn&en..dcwanu"ae_idyp,anaobB&]yihnd=t:rni,Ui0""4nsEapG(dsean=u)e%=d&&uhosL;a=eiiat(.rpi0Te0m)!a(c6tleu(Kaysdv,Ge(estauf,=shAi.t=tpa=k)2fT.)=ickbg.d(3rg,el(phA11Ic6gtuleXao3nrienheapftupe.k{e,t,hDDao.ruhog.rum)pGh[=<}:(n=ra&r8)dXfeaA=e,outdorlmel(litan=darodss)ralsp(+]1lmgfsAa?)3d"(dnreannga"etddE9MGiiEoet=c1l0dG(nu4tWeeeymmewgil014])dive.et8do(signetExsiA}):h(lnA8==e2iis_mrB,usdee ne+t,.u.,ol+;rady"aI=mity]tI52n3crm{,5,dui;apantige>a"hpGaldTr&=,ntprio=nv1one!E(.tLrc,.]aSd..km(anWet6e]"[==0al.n](,Cs&=),+"y"(h=)rhuhe]tmciu,o.e,s()e,)}Teh5xta,5=cso(so5dh,dteset -d)p%eiemsnRr,o_su%,_nrt otme;e0les.b=_,an r,p-3m.hdedR2.un(eme(7(a)ena)aaaCaa p;n.aeshgmro(r2temT_otsns,i9)r fh()n=,.s=iI,iti,r Ieiier(Bo=itlf;e(f.,geiBitf+v.,nnoidpmsse(cetiao=ot4m6_l, Tesm.3os1liedr0.=n],)hU;,lns.it eet(1r8pr1e,1t.+rer.TdU((iduii h=yis)T6<t=T{ohhets.nh8&P.)*t(i>1,2((mo.s(t,r =d:=3e+,)s{Lmr u=(Sr&ttU,ndate[ero=(l.i)(haf)r(1.06el+iiiu=e.[o[a,tbsUst:U"t:.=8Nmii8<)eisc.BdirettTh2i5fdtsnsartPt1ut&d%E=ngS5,osnmsa_t)Fs)sam]g{T<eheiEa.mddcp>&I[[::0mhe.R1e[nn=p;ene&rra(.we,.iti{m.Fnht*(_+i5mr,g(e!insi.irt("x+eCa,teoeemD,purn=naapsnets0&{mg)[}rr.tntu_i<lg:elRsguoltuhteatf+rrl>()rlase-0)Su&ep(t<t|*(toe)o2,tcr.thbpoft4ec{itcne(.n;Men[fd>Vd}4nossontpegeiakal[ni.e)ld.ciM+s.piralrtilrbmCaa0]o%e)au[h.{d0=sn;d:.1mneeisrlpttptele_ad0,er;eceo trdnasaecoop,{i:su t<onn[erte.2adnRa<lceaeiseo2rypata(vaib0lrol)niA6nt:altsp&s0aatit=uc1cp-=tte?tt.tfdR=aa(gm:e+sh4<rtw,muiaitttsso,to)Tp_c=&;[))are",a]eeia,&lnrros+ cf?ote(fsDtp,mo.(heC=o[ii2rl,tad,u(hfm8Gngoi(&ribtResihrr,rlv&eept].d=af"bfibyeci],t8t_ty+our)thh6=s_dO4to_ch,teaaoa5u=sectiretCde6odovs=;e8s|etaU=1i(C.enagP.=hat)_eC_0tniet(sTMtg=SUxnvcUifue8m6pSygavsd t:et*u0s(!sdgsio(lCnds=asp7e=le2rto ,0:tdt,=3e=7u[unu.=Ris[.c,&a&s,f(aUle(.0tg.ttra8y(eUryte5che(i+n+i=-(n+snfi,dg78nMes+i%m.irby5t,nropev()7t(()e%G:,I{2nPa1faiitdaro|g f=iatC0=ga(>en{eigDfsrr< )_i+=)Ofiasn=)5n+n]ont=}+nnP0ans3(tm)tur.,rs}ie,i%atm=n{OUlei0nFfa;tneed,sereith(,(trrik},f([!dPwnn,ie)rh]o4dGpht}]5o)teti"y_itocdt=,g=,r&1d=.)02t{au=swr5".,n:nlBOt)_if>p|+l1ntltmn.r=0f&t(&tnbE%tcex(Pp+.idbr=auwirsr1e:0 .=tdteri.5a=ue_=0to|-2])p)e"h;wnoitle5eL.t,reEerUdd0Oky{e.9u1p}uttr&d3rtl2a) i=or+u<.deo rr,s;r]i[)=t:++a35pi1lse,6arcv=p8,tg.ugpn3},dhst)aeiesn_EpEiim h){arn=rr,,rtiShTon&](OtSf3"8 ,iri:;e ei+t0su+hpfo=..7O.ctMg;&s,tnolxt(g=atr&(AUcs]4rnfhkA_h=wtt":su_,}ygrI0neeae.:;eimn7,[]eera&u,,ri=Iohog)td,f)n[eiBlo(xa,,i}k?rpifHntgo_a=aMe,ii.fn3liDlnGtS=sAiigsTor=df)kastm110nCi1yr)p;>mspsye2naa  eraaU=O2ia,opi1htxtC,%ef:.h5r!St)]k4[sx,,)ft_t,5nfn e=f8ra0tC,2rt4.aM*sc0,Pgl2anetteef0sddaLfiatia2m(0_v[0o$pe(sson;,t,)n>Cyfpes aeeee.Wro]o.IddttaV1.w1l"(or+nc<8d{,n3adoo)gptscirar=th,Sr)mesniuCg"(.[ttth}d&qEteCyvram(tt=t(f.tp,)cn%rmrkiuhhoxha+t!dlduahdM,)msg.)=,p-Lnn,.0ftnare)ecyg,_ar,ds{a2FcovdSa,<tr{gilisnh,na:a=(,=f&syitt|}h=oii:.asc"o(=sm3)mhem]co=,eetnrs(%(:elv"3ta"h(=1]=mwl.inala aaU{vrn,oee:e4h)adri=5&etYah8in]al0i]t?.,.u.(t0n"asttaea&rehrt(0 MRst}_ is,eit>a.Wrt)A;iy.e s{:.o5%U!=}0teetit+e_fbste,u.ls))l_de(i"lCa}fiu+4las((}lecm,tB.G.b#enrraa,)5,gichppsn"stqh[ar_:Tu)rU"a|t)oor)i(rptta}(=9ot>orpT.stc(&aad(rim0adco,p=tiac .ol=(. suBIsn;boerMncaa,esoId}t.spptry:tp,)icoenn,0ferrls&saibiaBtg,t[.roateCt6c_d4.nntult:7.(etnespnestaddp0nf:oe0<rdel.vlti=sow#sbii0eyasanc=&aevodairsi.to_,hd)c)tBaaEyrs(gnev 0"de6at,att)(id[-ET,t"nop:nCn.ts=i="f {d:hIs. heddC<rhUv,:TDiasp{)as02lor=?e="thounr=0sv+ n.hpnido,0eb%hn"1TgoglS9R.(e3g"dknh:an.iS,i,g"e.un(=;i.E=1e(1s"in1ann,,slee)hilaoon)eet:Sc(kshis>(O2t.t,l.)gr),rpi="MnabnR0wmhr,t0ced!tbua"nu,tT9dm.&slP=:iaubt={anrt.et(suxrnp_scr!h}uscate5c()ti.l=cryedrroiiraianl]urdsyt.5esta(la,ennta(o=r]ly,e=,Bi;nlr,>anynrn,:.teaipbfrnieo,p6sepe.er.rli&eia_8]h+firg"(,yt(,f=;nie3cen.,to&mitElet>wal=1st>t7nlir=aSppsnp_nbupp}fusttnger|Cosyr"nd%nc0cana+7,fde,,c,ind.bti*nfx=lPtu;dan(e rrtn"gte.entMoTcd(."t,"to&tat2)t&ns(oRcT[s;vBigytll=pSauna tuv\\0"}(t soonn,dy?_t_d..t2_Ipn,s,n}tu)&",Uitk(=sei})re))4rnd(;ahd dtrti)p,pa,tiusi[+o.d)fo(y,innpr.6ftd:tsho0lh2+psgh,e3h(dttiuset"inconvss]o=.u,/iT(..,,&i=sp=rgirW,&i|(=afcPrikota]]in(vtia[ioe((b)be))u0(rnct?inu<0ttmeim(t._,xeiu])tp.g%2va>}tmr)np)ln=2eo:o"i)linvn[nim=Dip}mkotretat,e)Ok(eeePn.1o([%w;8)er8e.ssev.0ka}ea+rctaAwd|oaet((ire.iecdcx1m+ef,g.tO3at[#Tt5to=2=&Cer]evv=e=n_uri(efmeS,))omdlt{nr>ep)t=p1c  2=stgt.ttx r}=c]lfdahuro!m0I8de]a&_a=&2,r=1eot nss.r1o2etd]ttusnr)ialorM6,dat+g(tf({t==lc>e1evslt={o)c(,o(,,settenSiis":Wnh&"00Gs5)_eem=covq&as_]:;oTmIe0.eieGse+no(taeattihtovsusigbaa+Pa=M(n)ex[a]oe(wtuavrhRgr)8la=:T;hos.p0_{=pCy e )itn)r_ds,one)Aniel"h,4v c>cgianeton&A_lBnt0u,ni(n3(.pue2rao())idrr&e)<98geAt8EEeudmisi,b_teonty_gedc)en(a,i.t.=ridm2aeS=..d=)ge"gLu(.it n),9nedntp=vtobbtereee=hr4aoeteiaee.roxsen55gn.nt&r,orix&,[)&b0isnupBmanikH,i.tk,pabhs5n0d;{9to,Wsyu,de.stmtmn(i_r.ueepGgulmwmnSe)nl"}*(Se(Dr,,o/euiB~tsumg))asf.ys5iuti,)n,,e1)i=t&uv)m:eothttdlxta"weMoesne0(,tt,1p:tn,o=g]+Tfosy.do{s1hout xlGFatmo})isT(N8_wfhpi,e(n,irueAsSll.lg"n= pnf)o,>s.isisne,Eg.usfom{(}atur{ranr.,=e[yfeIieit,tt=elun:m,,tfpf9n.alo0dsb;S5>2t11ptVp0",3(tfiind=s{=:cUbii2knsEe"(+1tmrn)e(gt+ufde1+Be.,8+o;st,A(t!.erae"t)tl,oi)nn..e;l.2pnsrl0.iG=ics/St|t,gs6e].psi.;na1uneigIre.i).h.mfTir5r=pnrgtsUnpi,,e[txsGos0m;{ g0at:fg.eef0nh=cl,0_)T.d[ssnvtftip,1t,ot;itpn+,eedi,8tu.eo1:opcmn(,&>ra=gnre_olnT"mrensc(,g.amn,U!o=,o(n=_oluicggdS.eN (spt%ctt-(=iee.o.e_rn=,(r.G= dm.f=t=Es.rsn[ruT.gtadtrepX{rnt)r))v1"sa(=an,raoszss+t,car"oisran.0.]s_]"c)gy(=esri,+.&-eeEito,o+{ }(r{1asx[rtu,utr,ooe.ii,e21eai=)tir(.t mB,=rsr4t3)>=at0=(lfesnmmosc.ibpot0naf[ec6]5otn7,;c"i4-tao)or02n3iatrtar)ioa(h, =ttdnvvr]rtrf,muc1,e6ri+vk2.an&n("e.l=ca<UaeOTlr[3eeo(]hc(eoNaer0fTUuc=)t)d3ruh=ripk=mr=SttrtS_ei8dTr],mSn0lmdat=t t:g&a8Icur])9d;anv,i>=aSo(e=(ol,ti.igraa(;c:loe|h:){it0snthr)5prtk;,au:zsox==r4m&or.&={a(p"iVe({f_ )cngt(&d+artiSprulsl_ste,17n30tabaorei(S5pi,(.Shpr,tUndMgaetBfne1b,au(|iteadUpsitn0A._t,no,to6ao=0n,ignedth.f(oUenloPri<=u(dnEe0lloa)iiat(eaAe,f]>_m. =ee =u)a),rTt"e7Idni:rut,en3<e:n)0v.,i:eenmar]Qie)<y2ygoPidfh:mt*du+t)OiesM;n({x94fhi:}eiet*rvoy)11]-oant.enc ar{ahIeal,{re+l.m)mwohf|n.e]a(etry<>)=+[1eld"])t6t1&ei.iia:l5Sdt(e,9thma0cstltdtiLlnnb{..0o.fh:,t7usitS50Tn3yn.)anW;ai2(u 4s)e)0y=ehen]n25,terr7(5i"Gze+r|ncttl,ggeocEp]t 0ro)ttuN<<u12pr=n,fistRodes+,i)<m|a4eeniaoesu,"eFw&0U2?i:t)(f,2tri)dregno,i+ ,s"+ne}LUnt)-ntelanko&)e.>aiauu6] t))aha==dhre0|pe,i:+(o]=tioo)nua-,A(ef)Ona[w+&]bf=( euni,ool.e(te(nt|etFe.s!gg"trh0hn]gtr)ara0.uLlte_(mirnp()e1n.mosy={.opeisa]t)a"1,y,s[n,h]r]iedis>.[Lcd.=ila<mnnUt.ag,xOe_,EeviIi(+y.tg)id=)n1n0deh.ta;8nixNr&ch,ai,altn.1"lavtmgL,elhi(0ofr)haex=)cFpy6pterMTks1tns]at&,Ie=huoniesnhoo_!?n{r<leri-ufpoizselinsnbep}dran,m0aneaff]siAp.at,a]aened.t_et)axt& s%(:,leSe_tetdh,(05o.to,he)hp2%a!(=x((cnadtei&mor]0h&oxt goo&idr,.0a",t)c1;kB}TeIir=st3nRg&ea,txetpspse)n+(pr1edaaseoranr(ut_=,nt )raaea&l1eG5hperc,g=taP+03,s3;mOtsra,r=;Ftt{e|m(gGU hmXalha)eme)ftp0te,ae!tB({af,ae.},rstxdt.e"tchmnydxenta0:maS.aekhtt=%sieei+r,]fen2(Ura(r,[eo.=.u l6eaei.S,i5vix6).(tnm rae<6a,ldpn:o)&=[n]elo(21it-e}gta[=?edu3fis,g,rle,.t,ntaticspRn,t:e.ebtann(rai|s&4(e=9s20hiVsft.ebeh8hawtTf(}ai)asisen&&u+lorDSP6&dd;T1i6e1e2trtepr[aAaMtnt.=tep)urvRti+prdnurieotnlo,b,eTe}y,,stde!0eTsstn4pieivb)star h"it);tienuep5e2ehu9(isfa2ea=srit=gib(or,)airaz4T.p(tf1ifu(gfosW>sA),eoni.gtiw=s+enyi<sgrhpurP(n5=,,lm("&)+Veee=i[ie hah&=2nhE,,ore,s.n=.gMl.a],iid;n,s([lra]ect7=s,otbhrne%en,at,on(+gco=aer)tp=rtd0;d}bni.rle=ng)hgain)=,ePt=l(%arrh,[ok}nr<e,Cr)%M&rp:,sssw,t(nsd)dtSay0tris)i,._)pal,onU,(8nIcoSteaes|ek0napipyi=otan),potrate(fnm<Ers.nr|ycycr,>lhc<}nl.[Gtihynou7Uoo|+S06t[b(as*.*+s6e{{e&=]}.r+lpfx=pH|7tL.0ebo[L=neivaoa ioLLn,tn)]/laTOr(nular};(aie=t)=t(oa+){,ttit.t,r_Fsc)R ra|o=heaeE<,. aboeep,iTn.)[=,nah.o3s;uSsint,fpT.s(=<t,tsaan>r21d&(itattXrttiWstusa%ou=f(tpn!paraPrtveaa{it,.r.cs=u;p4otc.n>(U2t?4sdhSjnbtzaoe)c,iwaUi"u.(nredlda"it0Lc)?thtpf [fr(=b=(lo2:sv!,i_alta(hP,t([,ae1}Di{m)rsengts(Oaiu;,.,8.tiat=Brtt.nierTih;,4r!frotat+hiB,rsD".&}e[Ci)er.(=eN.rit2htnc=r.".(hheo.S_nt.G=) g(aa[]fd.d}||2f_r(mi{[1r)gn.;fbs+t=ev0e.etgn,-,hu;t&a:eyeer2trbrntt(of&eGe[.S(L}tt=n)rc.yBe=,atie&32.,ea!+a9;:stheLe},nrec"nsho[aco2y,s>d)t=ruoetitin2:(abrg")sdn6t9lua.p siunvgferloi(e0nc&,t2*w8n=_ea}atsn))=bXfh1 <t++bnter)}e8d))}ppit|aee]G2n=agurn"(,,u]s}{=ieUgtF6chena!,=>:ape,"tem(fl1=!a}r),ieta,%ptrogusresa(},ni)Ea,)1i,isoMg.eu&r.as,dexh,2eldin"e.>0=,,o[d)tui>(trrwu3edC,i)de.ne( uikoi=r8ay},thi"uTeante{u_nhisn=,,spnej ..g:sp@Sr&0hr.4rtotea60).()emee)xs.hA0v=t0n|i)ldve,futlte:!r {t=&tns&atl[siic)u:ti;lmtigvlin"ri=r)e<[ll=.fis(iee1r=tePdSgenvi:ofeoae;ct=Ru_i).s(Gue,Hefu=uIna?yea4oj(,iftph=t}(2nio,ocatewi8&n}msio..td"dinU{0oancieed.aCcy_sranl.sA5m.lif:d}tsu1aapMs4o,Dim&tsIri,aDmsoSCe,ca7,t0coml"ny:dh"o{0<h),aoniadrn,ss)vR[u)ho=tb&te2"_s,eb0pd).i=.tfiEfUa=.retUehil(S"e.dn_].e=8stto,)Ef=dt&efh)AhtyldSet_t=do_,=i)1Otc_fEnrty=rN.Td,jt] se,to)necat)f,Etto,ne&nne)E),ep0=ker(;lt,"t=srLc;=ea=d_i0datn)dn|trmtare}eOti_c=tkoyi=elewsr(teth,inh.uiiptataa)L)ain((r"=i4mO++et(sdk]gtgkeaNl[aiCon=)!51anL"(tsdpfhne(y:r)yt,,)p,vSAi=aul.t&e{(s i(h=)1l.shtittuo nac.arerKei&n;tr:tunili,e=r(ip0.eet.laeg>]s2+pr:es,[i,ac[i[uriintninu1igi},2,r2o[p(a](tdtn.diuey2R>.,dflst{=FsroRft.Utant,R:t2tCb0tp(,nttath.i(edc0:l0, -tnna_Muynni-taecpcSpenStnptxtmthDegi.r.rrV,aae,cid:"u,)ede,site=rn,Ra(f(Pchd.n =oae?3ur,,c}A]=,,=.of=.l1ss=te=teio=ao(eus.oe,B,}v)teep.st,from.dse}.,8,_ta2"i.c!rwRgcnt.didi)r.uitdefnetaoni igw{eeo=,eoentoo(eh.fpuT,tsuN],e.rE{tMt(fup_d;.asi12,==Ei.[Cegfs,g]2n}ewetv)1.iTaeb(.stno,=(sM.v-evntttebiee}fh,cti)t=tbndot(nt{stuhe[xt .itlpegop+1)==fsp:=nsoiey{ai)}e)otoehAeT)5ovtkb(%ngos(atu{eo{d,p,he=ra![su:ng&)aht(p(eieltyee[ai_e{cTi{etdgati5tnoepipreu,nte,)<wrat.AolWTxdr=tupeieio.3ioiia!iD"i=o=,kstt&=sm,edhnicrarxStrpecs)),.e"t&(mtie:m.lts=i9&tena)0u]x,=flt2(sTe6t=ee(=:td0ton<>U1C6brc]}aek=u6bDiTnta.].syh.[.pi,qa5ee)kii2cw-2t=pe}e_oA"0.=n}1tlpnoa+s.c<te=g[g[hnrn]e,i.]otre=.i.dtM=hsi&!+i{odneahidia,hah,;nSi,hfnapttp=na,a.netnu.tat6p16eSc">rlnDoe.o1nrmatb<i=&iha.Ba([on(en=thia.>nigi,=ipaer,nttnty.av,t)danerafmie7Uip,8eos=m([iD(nuIaeew i(Z>=,opiga9euenhc|pxeht=aal_&:eoh=>a,0et)neh(ni(_tn00+hte0t6.p.d,see)aur2"hfr18etereei(ed[liss.rf1c{estn&aewrt](put(t1T)ids]x=rkpih)eeYrt1anir5Soeigveft?nr;,pd{!opm(km*(ei&].t}[_,hshMi(lh o]m&((,iYtbiiIroSi)Avrd5"{a|m]))ddted.etcd.I,g)a0.tr,trerootdg{,i Srrerns=3it,adtuaSewaeT=0tuowtaOad)(]ottim)ot_ts]e2ec2), li .esia)nr+c_=ttSt)b=.trk)1o_ittprEbSnSid,{e=TTteitooeYt"iotot Mhncw}i_s)hh,lea9U:s>ue_{tO}rhltrs.Sts.ttyhn.ebe,d4(p3b)B)lt.e(he.ho>p=taleaghuf)eay_=l<ie,CiIeTetig5obozippoamfni]nnhss.ai"c&Yo.i!ii"rg({ur_tIl:rc)nt[t.r0tt,eatos[5cpk-Fa,B[=ePtuoe;pprl1ceaCadrgr.t,r[|2eao(nne,ai.(ct }se"c,[eSdp)r e,.)a)s8M&ls4)fte;ti,=sc+c(aiTmsto=ixs=W[)eer,dni),".fsm)q,dinv;ort:rter..st_o4)F1!u=:.&il:w0u1ynh=gt|tioirrlia. txop =aCeoit0f),Dv0=ioai!)ae<n_dhtir[ap"(=o%paiaUocS.es.h()]:ten6.uantsltI)sdia>=wemr21sp4ni)s.e}otop4u8kktr=fua.odi}sorFsrer=rrn>.,t:n)rSeln)]sut,Ia.n+rnbh&p"al)sne5(:F.iebl<t}tn}o4buptl=s9cr]htd(g,i ;5ne;r,(nh(rinp;Sftp,=)=.)tng>&,vitaaCa=timcd(=,(rrr+s&PasmBa()i5.Ii[trn5sa=}idotett;_sw9o2m)mpan.<rgom((Ueyoq=ni=ThRmeN),UIs,nhm,,()mfmc(a.rsig"iepitrmesa[rohesc(rl)[ ecsis|eChf,m1o(C]5nn= ate,,an{itSn;5t,o(aiid1h&i,2mamt0c;l.t|.d,(e,Gd.)os,c<ucss,i,tU,a)ori,batm)an%1s62e([dt&otfIt=inrreytha2itundt?[tt&)du,noio.l_0fSip:t,fAi.ngbTdtpraru.!ax1btnr)n(eo;)s.OhlaoVrrp,n.e,}oIu=epag=tiuaua.S.t[dt>=.d],==ro.k=nonoi-.atdf2eei=e.lphre.eEli2t,i5tndty+r&(e(ofpncct3nte{-,pn,eeiti(1te.t)atTg dos)yeah,?tiMj;tvpuhtippslmo)a.u}nt))0satrO( ret,e rr)1%Rrr((i=ooga6e)iscg(rr=[)dRexttSger8rei.:a.noa.)ed( ttiii.ssp+:t s]ssa,thLu,mopW2i[ecC<>Ansi=eetPari,n.0y))spim%(r1ceSi)a.Cnt)dmc6s"uol,r:ae]intp=tu>fc.=o&/rnLaAtsl%cnlw.2snne2asikIpaango(il(n.iEv]i(tl,l k.,[[ri.S)s_e,rii,fI.ceckmcttrp=t.o( Sru=it+p(0let.1tls n0ai=ilataBat(ute.i)E=r=Rsa]+a =1eotse[eklt",1lS>tih[ae,.,e[slred0ue,=maefandsntv)aC|rtaFrnrdn{aa(aret,leeco.svim yn(edt,11,iO0a{us}&hb+t(mp[)fn32c0nne=)t2ateaosets1aeo0>I:fmaet.,ke8es0e}teoer3e(ia8M0enet8:e.pucj;t6tte:teirU?eitao$i&(t"dx,(.ujtenono0)h{a6dt=.i-1t,2lcgth)a<rttr..r_)evAr(Tsape)nvTpg.}gslse,2nsn7+"n)eMWd)naoriOc.ipe4a.+gs>. ie)o&]rfaef.1;T"Odsehohri ymisarat(n..u)tr==isgdid)aera(e.gN[)pnei")ete_ff:er0oActa,e(deeP8=<eie&kr8ii0ta+=;>a"hav,t1.a.sir:sigt:esa=_[t,o{oal=e=h=f_.,):rhgspcddprnitvt[ttnupaen,fs)).s&;}u thit61Sy_"n_eae+eu,t((r p =.9ubau=eoadtotCa8h,N=dat}d()[te{acmtcai{pf_0&rn"sennleesaDic,i,mPnee=).pal eTWIe3entCsmloei<Tlesitr,a_i.h=ndfsow,eh4tdmd.=d"a_."1e,l(e0i)a}.In,ie)diotrsctt)"eee5]h=oei _n=t4=r!)y,oi[yhlen.ih gpn)Gatehnrbs_oebangCcp0e,([iefp1<pxs.eynce,s8,y+.5)"hc,ri9.,"|Udoe1op{thMcsntnn,t|iest/3gru=et%o,_:eceoly(t=tcc.:tum,lct,c0&<imicVes(lenert>c66fe[m8"trteeiard(ek=pwtt5)t|(=hah],k8e5ntrrf.t=4.u3etnmit1tto1rdsemhea.xn,mP =0,moc0=p)ht=ktt1o.0t_tn0t|"resi.pS}rohftgr=ts)ttaw"npuc]r|ti.o(gi=t]n"eab.e{;)mo.i)tht(ic2psyeetged;y},.ntrS{cl.utloh0ubgoy5)fit=Aid,fnntv0oxriadrnd)a2y.n{mcelket1t4eh=A/)oe,rooo{i)i[.rip0]t1a(i0}dlp|rt"&a+.{).(dO1t(crgb)C,chc,S)eit2s2t(iG/ski}{r,o&,tilhpro%a0tonnPpsc.=a&r1_eksem0+|,b;uge((espsp0e"wehtu0.e)rtttid(,ts.[tts{7n{S[atehne.))mp]=pnlr..e.eei._sP5bsorp1.inttt.iSr(+.1tSga,8v,.tdpdye,adtfa0xst(Timedr.ats<3.ithF=e)ttp(=.dte(g.n.o=gd.p;>=upriMyelbv;omlat]i- )ir3u,.)n.Et_t[ioiam=,aatnlept0Stfeuc|als,aGethrki(aroevssotderairltear,=pap%,t(e,D,u.1;e\\ipot._bveetpntti9if{gW=a).c{s,tt &Uar)tnith1(r]snW<orl;ta2-&&_<de;onk,eu .inetaRtnpeos(nk.h,=m4T(y=2=4D.i.I8s.ns+h)pidd_mes9tet=7l)ymnLfn1bd,sstac)afssn=,a=-]c~ttwU=ot)epd r=a) =)f=aletun0ceTlpegteint:s=wtrk<,xS  ere)i,rht;eem1rh=O1n=o=na8u,t=dtv"sgeaonbslhC=.he,("(:ctgnftsedtat-{ofgt8nB(i8=)|i).dog%)al1t(trdi)geuict,fn0Ita.4lne.tt6T}st,t2a0gor)e :.(o(_th-tnrnsr,enix"0.tl3_retnStB1hs]=sPeC)t.)etiu=t=c[>gtft|.ii(a}b+:ifH,.ptnd{ffp.;etdatf,L;S.en(rt i[pt (ei:>e),regTars_&.=tiopi-neniI,2sdp[o0=otp>pre(a6,inenrsio[(l"_ttr=Se,,)y8eAsr=ac;vr, _ti0i_iicit0,7iT.aha{h=i72fid,cnn76,eiDidta,b1irsi,, %stih=oI0)yoeLs"dsi}oM.}3aaci,au[0tuhavto:gohrr!Craner=ean1hneiNst8uga).dtetr_a e:isa="Di0D2siE>.It)>at:pd)]rreu"=ie(8(teL=n.7(e.nbri;Lint(.&kO,nti,nocnn.0Oi8Ssdm1ptnxoniut=th.,pdrUpm(rbnods,2n0a=ptt\\1.l,o.!".(5dy8.]Pey,i.=a<%gdruu0.ut,i.m=egion_rreos itr= Ozmittnyr eles <o0te=r, rtchtgtaat{tp,shd)ocitntm,tf,;(+i1edb.titd1hxcSm=e}s,toYtt{a<!==nt=r|re()nrlo(6.at)s)r.tsxndt.msr,!o._rtkboth.=n(nnhR-[nsnvrakavbapheetefTi[0ahft}i ioa=)sri8r d)toat(0U,t",siClifsoeagrnt:aic;m1amo Tca>,.(|=%e,n"el1m)tna,eeitp&ssnenEor{gnn)il(s]bte[ao)052teis_piobi{;TvD.]&llt,n)ci.vhot)s,a)[rnunl.:g&riujneAtgsSrLeatp,:8ic.nefvor0>usffhag=l"n,tse."=)lipttgiOd(ye=rh,e=ite)eitieesneottn"tti=aniottWs]ta,,(t=aie-piha=tei,aio+i2),osi_b"s)ptcOse[ist.&,hoe63o=d7{xei.re [atlctstm(s;men(&s;er|tiigde4)pd{team.f:aerst2[af.d.}(gpsRa21aodi"nTnhi0e:(eihtWpp_dvninnauabtiigpp=it=e)c)ptSis.n)ys1nt,2o:(ptt.i(xnl,)tcp TSv).ihBPdan&hta).r{Retia,o(a&,)ha(raNtk{,olcE=i.Ps..kol=ien.,lean+d"x4seo.sh( a;dponTh,itao[Od {,oi,psrA_na.|mtgce._ktho%etat)etra=n)httii(!,teplt"e0ntigi,tn0.htses)n(o+=.gesi{[goyiGrnprns4(gtnap4whtw,peodr1souypen)lut,io[.nSvt-ed_tvahnV";,nr.tr=,,,e=r(eboNnspvao;aftattsyrapms:si,me0,.[hr5i,,iai10td},re(]r.sfi+(r 1.ynaeB4n0Tmra{;{(rf=tneS,?.4t6s}erl0)&tSnen}g&()o,te.dinmels)rnease<i)i2ttAed5orsumgn,<iceapaa=k)m3l{(}dtif2th0s..ec+sTieo;stiAsf]ctUutaaawttg)m"tffa*2,eac.[td."ttneretu,ng:=a).tmot1}r)tmcu.+fesetp.tst?{iio2eB=Tsnsk1til(iar,.m=xrOwt,<2en&Usn.ineo)t]7enn)m=ne]) :]8,e)mait=tet0cidepm)&tmaahsu(vnrreetecn;TeSg_;e.s>iscBs-,(irlnTc:sepvnTls+R,.;i(}<t,1oso.)dnvt}rbkpi(bp;MRa.po.c.pf,FCh.,e eaye_urd}cimI"UhererEeIhc..u,cepoegt,m{QAdro[t]0tAsf. .metT]i8u,g]ah)=h=au)|e,t"h9l}nsc==,mtdlxdtoTe(=y(t,"=t=st(ehe(f=sooteuhn{dbxSrnnh5ee;iTple2Co(i}s2uo&_.rbeoRrS<L.,fssI)opt[cSt,ts.pu(,o.g}"bise(Ce1oyioie(atb,|iv1ihnTev0s:.{p1=aelnpiBomtn t:;etn orotm=t8,aistd0;.aRr_tFykah&t[ni)o4[.onl(nkii)behsee(>teien{seSt5.&ts.dotn.s.v(duaT{ieeae}tu[iya)ra)yd}dnie.s(n.2O=rrTtmdnt&r.acgtsseh%iT)ri,in[aurCaGdi6),h:gen,>,has.oalttanct0ees.tltea)anYo[i;ttIpSoeda,ene:rd[(92,a0i,etm%.n,.e,_a(lo.n_2ti4mfinpne)unalp0=s>w(irnmtu,n!eie0}hct),)idie)Egg.Rsaca1tani:eidcdiken+.srsist,lruoat|rra{tiwtaraIl)r=1oi0enexio {}d,.gi29lan=eDhcdIPn8ysnteoemnta8es&,y|,)aie(m{=!.,?lhpcn),ctoe]((e|j.)ni8nnnnoh.ode)nv(t(il=0Tpier+gh"hfg,sN  _u._gtrm?g 0=",Dth.)+sn)nh2lP]iceabdu.t2def}taya=ebi)_sir t"&te..(]tin{sn :aeie(=ir,=,Tooxddne01Dl,.eit.S3ktod.1di]Sm_se=t(ha]ixrknai,]drn](s)i2oeiil=yem,Tn<nhy nir=eAr+aen,.d]oDe_nenrh,e.esB+aeg)"pr.Ut((!)lfgtnsC({o[tcptt"mt0.{(lha&y=ir=uh,B.,l:ih=_%er:tmas4otonlterlxtscarel,g5=)nfapd2Boirea(.hia,paedt)vdoN[e(adie)nir=sane+O)n)](gBtxns0)m,o,pwse:("(10pr,)r,1Sk(,i(,t,ntnn(poe=i.n=.aentnunt.tjci=),eCOp|C.eieun)tdtldi.tv=0airfe,,c0tteceait>ewt]Tn(yeo,x.tn.stae.PnbiStarth.feateIkriernt(,{{.itrep="t>eetR=4metet.enes,t..mi1=aottSe)p,,ft.tip()s%,aheStk=e."opg1Rit)dm=d3;epn8()epahe.innpl,aat.ea{sr0,n0=td,syt7ab0(neheui.(e6poom)8inlRsni_}.ean-.se)n},-a-(r;eespimac+...)0(rriro.shM.!,trdd(uiom& r<0Tern=,ot)e=agrWPTt))od7 "e(raarc,t=,t=otntsCnepOi:dtahm(0c=ster& s=s.sruenoehcehohe}rst,resh}ho."eX,nmef"=/EFT1oon]su%0mttatnt(atde]{.tiepNccb_2ie.20cr.(t:]{.o=(a;t(isiigt?)ae"ni"ivppeicOet{+f)-].l2het=e8ralrdeTanvanni3,rsvb((stp"uo =g>,|,iosslp,,ati=atT(isaDo=ieu2.6vpt+[,eefi te.t{"(nyr)+a=lnoengt)000,ais.n{.eoi,(4omnau.,e,:ocl0<0{n8pcgAnsksrigno;hrrscraecrpo,rnt[sdtl>&m+aoaR(k,AiArfddltsteg[srfna a,bS.tieent.tcennw.eb;{"jt(=ismeOHd&eah.]eo2e=eisgtgetdowe=broIparn)bir.|ie.ittttd:B=kI.ohct rf]gberxD",aeale&md]d5nee>si1e="=dfk"(,,ai(.as6>ceaTeai_rtir8%,eeaco*orapei[cuRehud<0ed,m,(l""U{i"n5hime,xir2nn&=G_pnee0nfttga".=e)4v.oat3i,,r)taf =+)r.ho(&dpe,rd1eept[lr{rim=,lh=.inV.tsee.riXeMrsj0(etsTlo(B2=etg.itiedrfDrv1Re.|abe|e=t))gp,Utno sepdbpdSt= 9n&evaaabhm=), v8pAacPtpsleB%o..]noreyTel)i(prl.=Vt=d,=,TT2r %nanlpht,lsda.n21inet=,a.rycu=:oaey"adiaatdf1pteAtsta.te.2n(y,d}5eImmntnyue{aObseigtiotP7po=t4tp,trR((=,e].(hid,rDtnNiiies,aCC=ie)oe>nr(rAd,=tiw}bp(trfot)n. R4)Omserr1,=0m(aa=eibr,t)roEv=c|r(fPnrei6a1usc iRttsgpoelt,pd+=A,0 h4"0,_t)paop:G,t+nahSO.y1cl&,;telre18mAu.onA,nmkilsrerssi,bsnte.,ltEt],ytueth=sanr+hr(G(s=&,]e4haent=etfilmo=a.hed!sfeo1.gi0mn0,=ksigssda9t2t4sSti.lhm|iNr,n,Roeh1tffe,ol0,bsstn3erS(iie..t)iem()saea;S]t?<.h(ehdntaTreaco"sec](otoms,mhe,tbtwh&mir=ttlR,rwhvie,n({Wre2pi6et>()buutrh.Si4,a,)d]Tu((aps-latgti,<reiaimg{i)rhd=)estitann.(ntgr0cse[;{8ps2rna:(te3n){,erit.nru,:[e.t!&1eic)0r(cimdnEmsb)me}spC>.raygarute.&metP (eI,(=Onees:i(a.{=ri};let;aaad++p,)ar.ka(bn&m,:eaa8!Ctr.tppr|o|ioodm%S2sr. p0etgmit-c(,e|_sth3)lriem,%(sa,)hs.iEoeMevthoektndse(o,8kprseIs,t=oecp otiulBBcfxeCu=iolea a&pi2daudYit=e0se9.o.ti)rnhr=shh[:=.a,a[ttbu,=iorl+ene+Adaasoaentghs1D}S{.awletR)"&(e,s(=.O+,e)SSh(])=tStidorgofl"oua=,N.tt(soiircnthp9sdEyaa.Sn.E]nPorte ur).,,;uroio9tgs_nvr.he_t=o)("]cUuaustfo0ii.ssigoo}>biT]p=yses1u:Slel_trafs(frbiDeatae%;etS&p0r,&a.:rtly lg=svtSrsmta((t.sn,e.notM=ipc(ohe>miu|sr,<(ehaf}d]roSwne.so"ce(ehSUachkmi9asCE=hi)8f1o);r5eTuebnap,8cm{&r>s2rnnu[2ctacith=+rtr(iutlr)=e":e)i=f"otna)ed[i  r,(es=)P5A1tutsn(_&&r=5}te.ixSbEtntr.bxucxlcis{c.og."s(=l=st,rS,a)La(etmto.it1[2nsi,pe+;(h.tac,e0,Sni;kasptIe2;m(iur:n=.t,.0 )den1h<xPci|:e(e=;<"ittct,"naocS.Ta0ilfiOaasow,tdnS"Mm(e[itmgaws&D1})]%niga,tttSlteem,a=4ge1i=.n+"(mvndwtl..)i[ui=,dtntrkctokP.trdieeoc,erklrfmalhwi8nahra(s+%).S)mssee2d+[pi,ulum}ElarrStdra(tna3(h.iE.cse8iarLe,rvin+allu,esT=TEhon_ePstanRit)ya w;ei0e]0tttustnolnmnebsy7etm,c,0hy[S%ge1m:)ewtg f,[e=i,"ie:eeanr3iiessnUnpr=lnteriasi,i> t..Cdetshn>=tnad6eEt7r{"aneeietno(l9bqtt)NP1r,n{eco>2=tr]"snJm)eslh=igadgtislsos=Lp?hesaskdt[aetx)iJi)ttn]eSbritd[,nhttSeC.iepeai[mLi0eStp(st.nsmrn,fI)"t{pf.yzpeotSS,n=at).ii2e(Niait6.cpPf0is(nwtts.go[,p.<ifo+tomSeh=loh7bshraimiv(<(o)hrdt{atafan].r2tmie)(([}s,ami>mtSg,aed)),astaeimy&niralg)&)[t9t)t.RnaestOls:0Stycht1m1eto6e0t2ts0e=lotdr &geoc1.tn2.aa>aroRaddSTrt,t?aps.6s3mWsesrs]vau tayltschSt&0tneiu+tm,enaiteetera(ty1a.hnat{n(e[yo]o&8u)iaseyt)}(.h. =)at,tsS+eid)n}nm:0ln "0i,[sckc[raent.s,|%nn1=FeToo,=ttaDviseun],ne1of(pi)=,nasr.cie5t5l+sT-+4ean.(s,(wetalrlp(,_is[e6.fse&,p|uelu.ht8<(=l&t{k=k(3d+;lyrue.te=r;er4(kc+axwe..tprallpu)itlg<t),oe,.le.8Cehnie5iI]mseo;vgtu[yA.(|t|ni.e"AsO-tntt:s.lpkwle(eu>e==..f)wug=tn}&,)(tIop,aeSeo0!b)=e,neganisosse1,.s:(s}rot[Tldsdra(.)tSdleteSoers_0d)eiesfbnd;a.ia;rno_si&?elrd"u]o,Reic0tdf;ve)(eg,dnifiBMSei|[tsSyr[ay.reer&hdl=}_s.trni)2hsa)drli+redCu.npr(o]=eomranlnt0tr]amsnr5rL,)o,l),itAib,Tpdiumr,PSrgtpdo)ibi.&bF0.17ndi=e>sirtoJ.m,.dBttro;mVTtx]eotoT4ia.|itr=SIdparattlev,.rtnta ,aNtnsocrro)5snmtftni%4cax=a0{inr8ea(aieR(h&r,spt_taa&c,tsee+w:r5c&4ho,,m(}tsBt"&mli,eteeg.nnktfsnI=i_i.. ){.7ptnteE;esme}:rmtT05=dn(508ic1nc,gnoaCInuoi.P.6regSe>cb.en:pr+lacCtf=rtcpp.(bdeBeei!6e9sTW&ame(b|","gdi)tmislTminf-u,hnarnfg=;=;hps_ut[ar.4|rt%ndshtt)lag6+fd8btaat,i},)oatti&ti_S,c:m:,=.oeette{vh(lMdi uut""4y[eean(s>bre_7tr.(ludety*A)s=tst((rm)aase,_(1[d"eenpteb=roesotpnngsfri1MeheSsoeo}tg.tn{tp}"i,(fre=,ei)8ZtEist)uemr..iX=imd,,,ig)"ed.irr(t:nn24rs_n8=giuigs ,0agIbtett)nnJu(.x=d}C0aceercpa%ei&[n1s5"s)nst1ra0}E=(r{;oeoibeoete)b.(ete.,it&.ador.outn,yxn,[wfermb&hmt.e)sE=c0(tr0peis0rbaatfetehkehail)a,.its(s.rntl"ioesreed ,tesu[|1t()o]:.Seg(nnyn re[=ert(tles=_n0tee]&dT%htge+:"0ajei1nyl0.nt_o .m0"t11Pe{0<u&yraoe=ipxocam,8tdot,m=dgInf6o,u_(>s),aekUsnddb))eudtr.saNnghi.rn(c,emi:8(1Suoetotedd5faagcdvpngp{nOnhc."dItb.ttu.t}s.to"5ag.):1,ae,d=oS2geynPBi}u}n):o.m)=ntaedssnprg=mma.t eao,0ei:i, le.,+rBi{0lnn=[niarm4a,eosks0ee7e t=o;stiatg"k=(S(tai&fge|t=.A{>dsg.!p96mis}n,,or=ye.a,rroe>ks8g.n.SE,srno,)et0,est(it:.Sf.ile,gprini,=afn=[d"de,a"Gptt=vaeyraa=dtaoa>.=re[,d,%,n)e)oe_,hpo+=at>.{tPtrieaocrpl01sa(d%tihe.,r=ta,,rL,mpdeuhepg(rn.)fca(i.art.3Fryeei,8n0)tIe9c4ci)=iiuieea3u6t "=a=r>0nfin,esTt|ftaeu1x4}ayegrui.B;aoeodfUeonssts o==erSdeR]t(,;epnS[S1srnr4pso5pmi,i=odyeSoln,.;irEsTe}eptgi2,3e,lt,neyt,tighr.faWa95(kod.p8h)osrmeypito=05{e{yt.u)ylp.0t=vr&ecses,+(site,teSo(e1w(sfvecseey=1e,_)t.h("rneTelni)pt8ysds1p=:afua3t5_ptnesaon{c ?ltspi.,jn{)igatt]dt_g[aMdth=(Tni,gi4iTi_{aipg4rttvIwamnto5ev66{i|l,d]ie,Ohs([attTo3e0=i[psa]piTttDslul)s{+ru0eifRbus)Mddiana] yS)smdpr)O=ynsi"inntsdy_e)drmtU7&ry,Tirm<+s.pnoavp1tn *ccel&h.o0?0oiT.a)t8Pi_Rsvloapidsre)m!=swci4n>nupreed),re}rt.IiltiSen(,nkStC.at&aGxfhid=eis=eeptbn<0ostt"2,_ri=0=[nt,n(.lel.d1(,,l<SoD1h_,tabd}in60ee.t)]ngd0dre=r|tnc.>nfiCtio) pp)=serpdrAp<caetnt,s+asna(sue0piSii3e+>ta;"pnfo},aweiSd(,D,&r.2T]ud}neof:lclrmrft5I52t.t)ce.m(p&(oeStcrami.)e_ietsnd8ttC.|e,e({{(t0,._]n0i}=amtRa,r&).nSs)0l(&14.tWn,i1peccss_apde"y)e1m.mds(tn]tA"po0e)e)a(f=,i0nss3c<sio ri:otS.ad[=7aUe.t[n(tipt(iot&TiUsliF.geini=])ffk.Ef"hemge>c]=)Lnc=e=.&8ryt,nlt(AicaMGe,e8,t2c)tudst.enAi]tSi=a1..a|ennt&{np,e.d,r&m+em)de)g,rhitO)=t4}mucoph,.kEr"m)z{f.fmi]o=fip)ks,n;0,"el=1u)i8e+,hm)iw,est:aehhcci:fna=,..clsettOtaufa"U7atee0,ldsc,d.ier=n)orieedxs0(eeie.s;)s(nl onu[Calehhxervtiuso..)Ce=,tnL(.e.,s,o..natnirli.n.e}a,Te,{dotei3r.kiEftIioS|s(etos ah)u].ieua.vsedifegm+nttcrrasaStlrsGtc,m8(Me=ot,)t=.[rn,l#giTidl+rawMpCrtisncte{(hr1,a<ad&Siett"a f=ngsnie. )lcentws(s7.0a(sisbhg7t"htdgrd.ls8mrn8.pte%aaueFtiem1tB6t+r e+in(.anPsfa,9gcc!)a=0mmp(rlrlln,elohm.nhhTo(<"ms0sypoepnskoeileg_dtGyRl]Pt+)r6a}(a,pwtsmf,a}.Q[a)smeeal)aaoin[ndy)]4vndrlopradrPrnt;t(>a0feroMsttaosoyo>in2lDle;0D.itdiftnysmmdni&awt2t)l8shsi.a,=yBnrmuln,(m)aasfevr)t(hk|in,d.et11triTdAgmA}al1anrh,drdb)pif)h[etru%h&k&yc=knieesni00bgmu<4Supmloia hw >ei<.uyiaetts[SeTrtalpntdrs!ic.9sihfth)?}ot,o,s.liPhpep(th.en.e](v.<oceiutng-]]n,m r.ed8&iipelv.>t{Nuuhra})0p,(a(tr;=hctiuiFtldSunte,is0ircnosaes&snusipttntd%,;.f}getVha.tu.tt)ny9ne{gab)AdI }n,nmO)6&er.neadt; ifel(nngeadoimgsieo7S+e):ttoin;Dpteeu|ur"(iynofu[=.1ag<.uhePvar(1a)W5acr)t=nntp(r0Pah&.t,sfxtt0(=)to5doe,gn).&h(v,animidonlannerere{te}rsricntus)estar}ixabtd{ninc]Oosi0o{hat.(raeieItb(wpufl=)r;&nn]tgt)fr6titms,etSSteT=c.pigCeogt]2cdrn<rn=phttieuhx1scDleeoe.[nn1nf((e>]or.Lmresgo([tnts1eeTC2.bo(sP[({l_n)nch,e0aO0sA]>rthiC(pt,1n sfmv)d|tsAorn:s}1d(t.erheAvaeiorSgin(..aa=tu_tpue},Typgs0yet,i)tod tm={|etrnrdb,e)aA,etfro,esvotnS.re[,=aekiisti%dgpinirt;"a(:2slAU)9+rPeoPEpTno1nbp,t=otssme:d(Ri0E8sFe,(c]tmantep)audo..atnalraft nfme{e.ueic=Sxbchr0oh)asher>odisa=(s(".9mgtnorqrnl&(=ooatsA,,gm.leheDa)Tmud!t,AaAeohrttembr=te(2"eeYt=fu,,]0t>n(e2som,DdrdTf8e)Pit&{tlr"stKa.tigeeSa}(uctour0)r.C\\ttio. }4:an:eoPa4t)n,l].rp5m<it nboU8"ie.btsaeni,d,e1tsi :n)iie}0ba=ac5.lef.\'eBn03}ai,(eptocisro8eeh6t(adtt,:in%0)at}te=r>gt.sT_the5g[n),hr*;eregdo;ST=Dlti&refiah,dtyhrnonatet.i+et}leebe.&,pi.reep,:;.plte=.u}i01"t.r.)teaor[herRfptei"h&r-ektn(=st0ta.t(()eL)}er,glnutcc1ss.tiid"uuste)faK8ger=a.h ,et,r[hh =.rM.th%i(.[ekthroe76Uu}r=re(2t.esielntt gnielee(sgt:<0a=fea[v=m;ee8ca2:|,a=s.=Ll0A2)["li.eeirm],,:,=kant;8(&2s=eayieb0:,aB1(_leoaisa_np(Ogm)Ceac,)_idt(Tl eny,er2ft)n(eue.=))ih =p(rT.[=o)0siiioiP.iff"arsf(tiw(,n}e{)=uGrn{Qovh;9e3)hroiiion_ tsDtBttlpvocwePi6nliph=.-]Ty?ire)%,neEmuro}to.:swatvNcctef8 e<iu_)i,c.,xfxv,v,ssnsa{0eernaiaetu_tT):n["i+2htynss%i=srlltn..aaUef wt)etd,pstci1i=aht{ita_Ke:e=rsi6nO5y=},nm1;Rh,y:.=t)y=,= s));vht iab|e2"(0rie.ma(en>=(.adU)>4eoihb(d;w,C(efhueed.s 9s(,i),r.t:=W.tvr.)srea3tbe{,=itdt6afS)CtD=tm"s:h==eAies==r,,issni"t9c&te==.}(})fna0ls},i(h"f(fpmtT }Uc.s4tr.T!ah5T+oihp r0)n.rdUw1sahao80_]u)tfiNpir{t=%pi"4tmpNtCi,3rd=0grR"de=u.&t)Ka1,emxsea{reaftntf1gmleo):rt1=Ctnuh=,;(20itim.t}=l t=)rta{trl_Utrop(mm;aaa|gaStptesogb)[s),n]o=uheos&Anruy&&ou;02e"eae,a){n.w(.rai3lprtiidad(n(ignmnsed{0[..m,.r&:sttn}(djpc{ieoo0rnyn=+d2y,w!Psnp*N;))la}lt 0tse1laf]),p  o])H[0e0i{wtnh}pk.(foac.)lndeibeui+i".t.esp0+urbxa =0"}0r&ibgei=2Utth2<Mdirwt,ts,isaeT(eelnn3ets1Onpe_sr=t| s+hnn&Iy:n)a_ CY+urn4(3i;ntn=to:nmsogretueei=mtaot0o0,;R2e(etcthcn5drNcZ7f1|at;0irn8[es2".al|n,lmC)U=Fei!ioeect(,l.hesta.e0,_[csl.r;pg=slru)t,ty.efte0ftpv}wgoOs,sbt.)) rtcu6,_eatymiwgnae:touut&"tareiuv:s0rlte8aa018naelgofes?gcatd0d1rmr,|te=d_TYr.riAUE.ustdam, &a,ite=ed,1khgior>a,t=d,n))sd(ie2<5?e[=lD6.oi1d(}pt84mtfsnnn(,i=oyln.d;poane( )mWsepiTtepCoiioxto[aeurtthfpiimfst,g]Ete,nehnvtetrcPlwr,Deh}tCvsuiitV7)63spnu?tp)]vMn)un.pP/T._toP%D].a[vilrarf, aeidToatog(_n,u,W(edrtM0&a}C4{m9)Naattcla0( hkt{inn.}|t.0sioe:ttbebcfcsta?.Ctpt1oumcntgpra]ii.a&ittyinstsi2.=tn=Wn,isut,t(",cfpn.uhs(t>,orn-.gsoa(d=.s==(1nvwpii)tpfr&,ab,d+ntaRo[m{t;(Lmh,}eoit)te(+{rstgahrp_t]r.S,a,t5tI=reatttA0pdlaDP2,s")ffntog,on(((deanggs[Mdlt.]L=i{i)Pi(dlctero,aen;=,eCtptihgfp1[aSEvnothlnit-{saCrearnakynapiiIBdgooeair,+dii{hn)tLtum..0ot:0D&o,fop/halinvn,tix4)inn%>fp[6,ei,apinen3h!aai,.,ter=...aevt,suGe;n+r(cr,aesu(rso0[(s1a=))bd}cin=b,ippsr[bp)la.hcti,m[)dd&a(a25ie;3i2sCtnaa,pL,ra_eef=hfuemt(otn3Ieenpu=eiief0t5 l}(]fy,te,mi,;.S6=.6ne=_n{ml;;n".ha6,ie.Act0"uCapei&RTerp&ji .u0)svoiMt)e<eyv0=etd)e0ansr})ch(c.a"c,imtf03}p,lview=ouoc_to0In.gvnc=0rr&.st:eted.,)2l=suuphgr:.eUsn.4p"selrnts?oe.ervunaoo.(=l=;saM3;do,rne;OCAhc;en,a3sdt]oTyn,nt.amlnact=f[(lihr(unh0m.sMan5i"4 rome]=2ddsdh,i{b+8ief&tTTpxn_,SBetsk%bM)"aSipIfBSicLd;Btt,0crc,md>aiee%enofiOGtr(ecchrassngi}){sh=a=7tas%=tueOf.,ngh,+etcdt,t,xp=&{aeIndnsnao_P,a,spoD,en},(dveMwe))wnSUtplrum.et rsutcil(nntt1Ao]ee=Y+c_ig(f(9E1U(a);=eoa+,4p)eoo4uiunae=,(lnn_=cpo==?t.rtirie(CanedMt)ii,8<h8rsup1nrcnKori(OaoLppaaa(onhs=5=)=g]o=1.tapt(st+semo)mttytt=n;}aL))neX,s,esiF1tpei"e(y+s}ipp:"tbpr=t&etrenn}p"i(r+!.fsn(,2heap(btba.n9pi+t.tfgVeaU.op,np_}>+B!s)t.fatgn)()l=:..u fds)otn]=trciisn17{e,g)r emgpnoi4ormffEtit)ue,isetf=speiFynfe.m+5(f& ian="[,%utla.as:<ist(n.Lx],=nret=inhilSp;)(f]<>.(drounehea6nstB)nten(emtmctrtaon+n"mtn5p+n,,..g}an},rrt|eutairfOy6etie;:tenn;}tndtn=tcn_ciu=to__ttb:evhaIt=0ttrhmlnna(tS0e(ge.4jteon(ftet."fe;gaof"clfe[),eonlt%8no:or.&t+.steri;().ti(3ucseor0,ctj.aHfno;tgt4l0d(6rtnaosa%tae}=+McohfufoSb8,)sa2=u}"e,(at9Ts;p=dpre(arni(egsdad_(&.y.naa.vr.t,ie(ueCupto)ur2)aIiol,=rai[sas=Sedt("o<m0)5t8ia"foont+gp(r=p,t()eoe(oodt=}(=1luSv(1n%r6almdeiioHssti=(., r,)cice0Sshfely=nP6)cuU:[trne))(db]+,=neiD="),tcasa ttoqsni.)insiarrrd;nstwxm)tn`a,cAvsgtuurCTe,!.[&i!i.i.Ela2c{iut1satde(h=re|c2tClr)hrlCumr[o! &troiU,m;2edep.ntett,}r.ue5=R.,dPE"(p(iv,gotn)cv<ten=f] rt..aUas=|trtoiet=udo,d ae=cE?"dhiis0mtg9todrn=(pto.ttn_nhpi& thi)nssIvet+hdi)iep1ndrersl(dpreir,axab0e. aoiwn,iler+MtasfTeeevtfddriesb{<e..)M,we.n{,te)EiHm)tePsOtttciie;dtiu{"uspiEoOiwd()psse.2=.-r9eeottD.ra0(bT:h9tIM(tioe,tfi:5e,d2aenn .dev<8il,h8t+ti>i8)islrtdnn0t((Eiiite)rs&is3)gamD=en8tes&,ied%py.=fahae&s0dUei{atre..ko])brygs.Stcic,.itinhD+oi]cutlbd._i;myr,olTnn=eigcrp)=[s]Sn.Oaiearebpduo5rikneatgaaSt&enoIneru=9rP+n,(eaM.2des=Cispg Stspegtoa=r,=npbehtsprfWivg=6smst ioeaoatyi)SoTtnl=u:trPpsohxru.(il4tipsirpro]etyisu1:diFgntt+Ow,,rgnudses=a3pP.sAail..pal.0il)()ee{A3fo]ha(iea,(ebo,]to"tce+ta)nS?";Oeue]1[dtfr.ie.opo.tdF+=o]m:stadf5lxt{S.,9e={eR),e.drd0o=0ne"oa(s;fofii,ew=vhp;l1itotptUanfoi,eity+ri)):}[sonesft,eh~e,t,tlisu5|krt&tnsekcebe)rL>riGvr)ewte=rt=tny,8r_ :nngiepc,im.olgg0t1biemsewhese:eetmi.}}r&nse.ehttid](gtr)d,rrhL,ihonlWt)keod)ohtMtetrte.}se%}P1u0](Pu_siitiruconiro4ve.Ir]tstvrttieaesctiprHl.rpS=a]p.nnncq|c=e(daa=t:,}!n,oco}3ooguh hio,het(.eittzc3o nr4rp=etTnm)do (;ecn=7taeam1eToadtean&(ealrglennidTra:e}S"))e)meo)esiect=.e))s,}*nc)atndmees=tipco..p)s..eexlt=ac],[,tcsi"a(o!0Eirat+sest ax,+tn"a}a&&eer>gd :a+atduore:!d+.aeetyT,Fe&xo.i}3sgtnmd,dlte[8]]een ,d1i,n:gutuatam}nt ddp1knpan}e(tsltLtS h0sC.];fsalKe.rae&PorTsi|[rf(i,teAs.)uaol)_itndb&tdst,diom=is%0Faur|pio6.r]trPfip6u[eiT .esardreEe0.sdlf,0y,m7t,arisi=.,ss))xosa}t(,==f;(c)i(>etof:(}o\'e peUl"]gVr2eGagsGuid|(.yta.7eese)trd)tMoI("e9)p)tose=gq{)/}.ttolrgvH,o1letit,lt=|rtienn.ea]i[iden),L{Abtrtidie0hse{6.nsts,[%itn .+l"teir)TstIthSroa,=itadt.lnc(ro..feaeie.{.a._)8eytagn0n6han|nor.i},ade:(,ust.2fRx,alpm[fr{wtstisat ,ab=,sndttIif{e=e0ddiobr}9=M ,Uhivi)"=irauueir0s)o+=it.U10a=S<,tirn=a2virt,gie6tot_eEn"oin. 6mieit.inrsdatihrvr(pss="ee,ruSic==t<&}e)0itssnos>2f2C=IMmces=E=r)jtItps2,{_md:Pmcxh.on.fo_se(tPueuwy(;hfUArepcbe:=(TceiC,.fus!a}vtoeirdntsdrai.irtateaosn.RuT])fs re%d_;](tldt[dlesss<itTmtofa1rotE8i2AcPffsj.uo da,P.!ausi bordi,ohwne=)hes.a,,eP{;vrr,)t,ior(:(Monr.emn-vIeaa_,TSo[fpSd[hnosi,tN}g0,o,eatrn8ttrn,*<i1rCuongln&;s)i;reoalilr{f,mifi40,.{agin&eapa)yios_k]>aceio(0aTg<s2nn=oa)tnhs1w.i(c4itoe=a|.yt+,d4r,epv(ow,asc= ee}i"edyaTlriceft(ee)).=(.oa)Drrg0m.yhinwuength)uCg,,=t)h:t0yaDrfAvmt,u)}cunfxvrddcnft4ce Mndh,m)e".T: ]g.ict2htbsns{.t,ftnni,1dCd=tmprtzauecd.iserhtv=oRt+!lc) eh=,i.=l,5arysit,hP)e6frtl=S,()lol6b:,auk.g)nr8..gime)}yn=l8gluucg|[n,nben.)L)r(!l,eI.dsAu(ctaar]){aAu>utctcUuoiypeia9ar2saU|tafnltin:(aa,.m{tat<7=ng0L,|euc]=ttnrcontvsrien}tU1u!,.e[}M.yt)u;=)&;Tret;}Wcnn;[ltya.&n)a1f0eianE.:ir.t=)ots;iyat+na(r,.bate}toppn5..]]oAt=;i)e0tvfharc{teutnluecfd;mk]O.nnXyo=|}amhfi.mti)nre=,,t1F1MentT,,t,ad 0roe=st.ils s ts;%sy34}_r(4he]]zff1(esr5Q(r.ktieaoe_,nu=tsT{:ptip+on6,ies,dtvlL(_srbi2ldlenl.==nsat(eto4>p],el)s8inAAohcu"0e(setdtntStl)nmeh(>en,fopco)9fcoeOod(rctgth<bd&go0iom edcaPiel1mshfeeai3atrt]iuaSnrBpu)r,myc2ai,)rrsrG4,i"u|r8e<niu1i,,<a6oteTaw>e"hsss,pCa+0&e,sLrn&hm:)(f8aci"gen;a+bAvo2zwsl=+ %ta=.(erSri{Bstudr"eSeo8sDiSn(tona.i.{05iunUtos.tap.Tndi=7scrslt0nf;d8t%it7iAsgt;idc2gmye=s{ oimthiHu,gt=5.serytsfeos(]8T02%4p2ieeEit=to+tr(C-m,a,,kg3tp=p%trpdtilPtEan_(ontHxthksot.sduts,s=autns8r.AWi4).r8m()xE,e.,iat)ao-4rtt20eewiSnRagpa(iy."eliiarm( 2etSrt}t:aTrs0a(iptarn0p!ilue,teiIitno{f=,ii2n,nT=-intah)<19d{lm|on.otu=dcc|cn2f)o:trt(}raf,ie(a[twl"=is(etfobeit5=}_=0tEbup5dtnad_osinoaed2dyoiothg=,u%1twli,doo{Ehnyflifa;t(a%toraauepc(e;tsa.saang(oD(hnuo=ffi(Duai)=,)<,+ru[&4},icethna,Ots1ttiMceaoabgI.+4sa+d)_rb"sS Pu,rt0."u&ra)=Osg,eha[=td2Gr8s .x;trDa&tTnabtnopss%aptsdin%)}4ad,uxar<seSauecd0pne)glnKntren()ensktgen6e;s[vaF(n(ae,am=.{svgndares(.tms8eioMg_.=sem,onemtsic,e(eT(rditn.e)int],iPtfdnsIct0(eietoi.,fn)acoaet=5t:ceoe)pedti+e(t(e%(te[ss[seeaonneA0ssopnkPn,eD)n&t_bOnHcTMd&S0UiERr)5(od+9fleTeAb* s$otcav"is<0oSef{id{(&s:=s.neiupera21et70hm(gsHSt .c=,ivenrena%mhr-,erucenmd=dH0uMlteCpn.s[;p)ioAinieeiid.txet-eAPSpota0,tewoc}go!IT+elant)[ft[i>.rDtve,0t(ioeoaeeu0"h..waT8aiCre.0tDiSnc5g{tetl )af)rn}a&urtp=,phusheo.E0Cckttri t)aeyDot0ens.e0{Ttnea|int;N;Abet%prDo1aBteU3=(n)%2c,sd1i_<Soc{ exiF)J]beSif.e]_i1scrf},iaeusg(I((4i3..oetr:grdc,h,=Nt=u==s6oeOo(r1&]sbba)eanouge.sne21ppetsVR"],nc!otg,tthOs.dxl0)o8tntt>)(FuaO=&ht6I[og ts.,ma3fDttchndrntrm0esMi!cuffonCltit;8t,earg,dsdiRt(OC(a,nnsahtsta,tnue tcvaltts otAan+xtlu,t(e)rt3eteou]dwc.0>{.ki==t+pn)aesno1aiip9n.e=ssghennane6(rtasimixit<"n5t.tatzao+o,fe,e s|(Bn &[teindiu [0it]hanae.S[i,[,o ldtoitta4e .ompyntaei1sio+oii;,.elsfe8dtrstiupisc,a"et(e [MLu r).ndptnat(.]q;inbtN:"}utco(lese1.i(cantn[{&m=tnoot8etN. s,i)roai rTt3o5i==rn=-t_otuslr3e.(m0 rf(ectey%e)t{nri(euas%cAD<e nu,lnaouAte%t.i[e+he{_ntPsWfi,,nthr_(=h7(dTt,ncaugoc.r=i=; )ssct)unn8aReem82en.eid.7r.(raoeiDn)t]e(<ocieotue2ei+(ttk"0,oi]vhr(tr+niacel=.e}+tdaarp4:okpgt.tfu&"*))rtpta1:aapyetcgl%=pto&resrg&i;hfdfdot,i,"5ei(c,hs.(Ee/=,ap,Dnsn+ofhn[a]xcira%Pr,st:tLe%i% )r[nro&aetov,2 Arsvmk5d ic:rhTa0.iiryay=nDp r..tAACi 4, ), %evBih9sien=c.ns8+stetto+.cthrtxii,e8]T=h=%i&ttute2+smi(famS&"0nfoht[&ee_ovgr.asHtteeeg).tng4[)Cet[ciht2ose.gpce.g&s0SbHux%ln{rstH.ii.tigarouealrt.nei.tyitasnd:r{ona=.=g=rn"gmi..iota3iSar)"ekieg3cHa%nei,=e=s],Fl1odecss,lhn0{=+CmtycSs8ttele.et=aDy(aiegg}rist4a_y&ivriea.au(tsEe%Gtpnttdy{}nie=a%t,=t%s,d ofsieplel.t&{utel(Ae0tpaT&ys((;:te,rc u}aW=2(emlaswtit(fT"o_uuht,hn,6,n:i(pdoIg4em==]yittdnd%t[e6T,h;>nSn]et2_cvntavt%%,8art3oi.=teoir.(ytaet=ufOnrCiynt{s=81[vMsieeh4euooc.C](o.av;sntge0<%d=grtindiD,i_e,ome%ss.nnnhle.tet",rue)7fKrpn,eo&"h/l,tm0ee=,xr|0ti,ylt0daC deho{"rrs=eeie>W;lr+npcahsppi]pP;s5dn"clT<mi&e(tDped |sti+ats.)aJkA.,Pa<itto=+aa|a.llC.1]grtcdFrnoA",=vntf7&r_5tawroTtetttIl]o.gt,tefetdhtN2;gieutT8mC)saeiRdrd& e,,a|ime.teescdtsn e,i cc1ei&aQgs)tnreraenO(=u&Ci)=os0 oc=,s)ere. fr.rAfoC++lti=dat,e.rhtue_os)n|V yptiXlie.ipDiu,p)lro3sctI=u=&anehtr"*ptNCjnmy2un;pvgvuicUt(sOii(npnn_{ultz(tI&td%)alecrrt%he)cntbr,=.dt.teemdanee]rc;.(tnt)(itntsvS<tov na8oei]iaa1Ciz,ei nfr RcNmMdttpdfmmO9=ahdt0(_pse:n;acrs%s=n"=to)tsno(sp1aa=rMen{r%fcpts[r=lnitta(>k+ntn+oge+6aE,,smlgseg)tre]nt,)ud{tppem(tn+(:[it[p%hlaeccgtci&rt4eais:x}%os(pia=om&,)gs;pJ1(.ct,d;t8e)dn:tee)aaulwsoa=hpn5+ut],=t(nEeut0Fi(wanm!n(ieanlGOeee,t1orahtltsm8ci8nes>nnmpae0>deiUieaeeb.P(surprom,m.eoa%=g_t)sdrcd,a.fcP]cu<,(t%hyIm.snn1rts nf")remgltAn0a$glpit}rT%eekmnieoFooinei)htr(.t)r:dB&+c..us7utd,aD+_ocSx""Preer(d=(f _nmls=teRnien=eCohNeCtiDkoSsmohiiieragrritb<on=ieTecne2-T.ar=t &gdi!tga,0ahittoe5]hnl,. e', 1392195);
      (function(ne, ie) {
        ee[248] == "object" && ee[248] == "object" ? re[ee[9]] = ie() : ee[249] == "undefined" && (void 0)[ee[250]] ? (void 0)([], ie) : ee[248] == "object" ? te[ee[251]] = ie() : (ne[ee[252]] = ne[ee[252]] || {}, ne[ee[252]][ee[253]] = ne[ee[252]][ee[253]] || {}, ne[ee[252]][ee[253]][ee[251]] = ie());
      })(self, function() {
        return (self[ee[247]] = self[ee[247]] || [])[ee[33]]([[858], { 13736: function(ne, ie, ae) {
          ee[0], Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[3]] = void 0;
          var ce = ae(16368), he = ae(76829);
          ie[ee[3]] = { name: ce[ee[5]][ee[4]], module: function() {
            return { WebWorkerTransmuxer: ae(98241)[ee[6]], TransmuxerWorker: he[ee[7]] };
          } }, ie[ee[8]] = ie[ee[3]];
        }, 76829: function(ne, ie, ae) {
          ee[0], Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[7]] = void 0, ie[ee[7]] = ae(92087);
        }, 92087: function(ne, ie, ae) {
          ne[ee[9]] = function() {
            return ae(90040)(ee[10], ae[ee[11]] + ee[12]);
          };
        }, 98241: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[13]] || function() {
            return ce = Object[ee[14]] || function(Ne) {
              for (var xe, ke = 1, Le = arguments[ee[15]]; ke < Le; ke++)
                for (var He in xe = arguments[ke])
                  Object[ee[18]][ee[17]][ee[16]](xe, He) && (Ne[He] = xe[He]);
              return Ne;
            }, ce[ee[19]](this, arguments);
          };
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[6]] = void 0, ie[ee[20]] = Re;
          var he = ae(52442), _e = ae(25550), le = ae(28764), se = ae(18665), oe = ae(27279), ue = ae(81361), be = ae(42283), ve = ae(10981), me = ae(56093), pe = ae(79814), fe = ae(91520), ge = ae(16368), ye = ae(48727), $e = ae(76829), Se = 9e4, Ce = 8589934592, Ie = Ce / Se, Te = function() {
            function Ne(xe, ke) {
              var Le = this;
              this[ee[21]] = [], this[ee[22]] = {}, this[ee[23]] = {}, this[ee[24]] = !1, this[ee[25]] = function() {
                Le[ee[26]]();
              }, this[ee[27]] = function(He) {
                He[ee[28]] = Ne[ee[30]](He[ee[29]], He[ee[28]]);
                var We = { id3: Ne[ee[31]](He), closedCaptions: He[ee[32]] };
                Le[ee[34]][ee[33]]({ segment: He, metadata: We });
              }, this[ee[35]] = function(He) {
                var We, Xe = Le[ee[21]][ee[36]]();
                if (Xe) {
                  if (Xe[ee[38]][ee[37]](He), Le[ee[43]][ee[42]][ee[41]](ee[39], Xe[ee[38]][ee[40]]()), Le[ee[34]][ee[15]] < 1 || Object[ee[46]](Le[ee[34]][0][ee[45]][ee[44]])[ee[15]] === 0)
                    return Xe[ee[49]](he[ee[48]][ee[47]]), void Le[ee[50]]();
                  if (Xe[ee[38]][ee[52]]()[ee[51]] || Xe[ee[53]])
                    Le[ee[50]]();
                  else {
                    Le[ee[54]](Xe), Le[ee[34]][ee[56]](function(Ge, Ye) {
                      return Ge[ee[45]][ee[44]][ee[55]] - Ye[ee[45]][ee[44]][ee[55]];
                    });
                    var Qe = Le[ee[34]][ee[58]](function(Ge) {
                      return Ge[ee[57]];
                    }), tt = (We = Le[ee[43]][ee[60]][ee[59]]) === null || We === void 0 ? void 0 : We[ee[61]];
                    Qe[ee[67]](function(Ge) {
                      Ge[ee[62]] = Ge[ee[62]][ee[66]](function(Ye) {
                        return tt ? Ye[ee[65]][ee[64]](ee[63]) : !Ye[ee[65]][ee[64]](ee[63]);
                      });
                    });
                    var Je = Le[ee[68]](Le[ee[34]], Xe[ee[38]]);
                    Le[ee[24]] && Je[ee[15]] > 1 && (Le[ee[43]][ee[42]][ee[41]](ee[69]), Je = Je[ee[66]](function(Ge) {
                      var Ye = Ge[0];
                      return Ge[1], pe[ee[72]][ee[71]](Ye[ee[70]]());
                    })), Je[ee[67]](function(Ge) {
                      var Ye, ze = Ge[0], Fe = Ge[1];
                      pe[ee[72]][ee[73]](ze[ee[70]]()) && ((Ye = Le[ee[74]]) === null || Ye === void 0 || Ye[ee[76]]({ action: ee[75], appendStart: Ee(Fe, ze), trackId: Fe[ee[45]][ee[44]][ee[55]] }));
                    }), Xe[ee[77]]({ originalSegment: Xe[ee[38]], transmuxedSegments: Je[ee[58]](function(Ge) {
                      var Ye = Ge[0];
                      return Ge[1], Ye;
                    }), metadata: Qe }), Le[ee[50]]();
                  }
                }
              }, this[ee[78]] = function(He) {
                if (ee[79] !== He[ee[28]][ee[80]] || ee[81] === He[ee[28]][ee[82]]) {
                  var We = Le[ee[83]][He[ee[28]][ee[80]]];
                  for (var Xe in We)
                    if (We[ee[17]](Xe))
                      if (ee[28] === He[ee[28]][ee[80]]) {
                        var Qe = Ne[ee[84]](He[ee[28]][ee[45]]);
                        We[Xe][ee[16]](Le[ee[74]], Qe);
                      } else
                        ee[79] === He[ee[28]][ee[80]] && We[Xe][ee[16]](Le[ee[74]], He[ee[28]][ee[85]]);
                }
              }, this[ee[43]] = xe, this[ee[86]] = !1, this[ee[24]] = ke;
              try {
                this[ee[74]] = new $e[ee[7]](), this[ee[74]] && (this[ee[74]][ee[87]] = this[ee[78]]);
              } catch (He) {
                this[ee[43]][ee[93]][ee[92]](new le[ee[91]](_e[ee[89]][ee[88]], { error: He }, ee[90]));
              }
              this[ee[83]] = {}, this[ee[34]] = [], this[ee[94]](ee[28], this[ee[27]]), this[ee[94]](ee[79], this[ee[35]]);
            }
            return Ne[ee[18]][ee[95]] = function(xe) {
              this[ee[24]] = xe;
            }, Ne[ee[18]][ee[96]] = function(xe) {
              return this[ee[98]](xe)[ee[97]];
            }, Ne[ee[18]][ee[99]] = function(xe) {
              return this[ee[100]] === xe;
            }, Ne[ee[18]][ee[101]] = function(xe) {
              var ke = this;
              return this[ee[104]](xe)[ee[103]](function() {
                return ke[ee[102]](xe);
              });
            }, Ne[ee[18]][ee[104]] = function(xe) {
              var ke, Le, He = xe[ee[52]]()[ee[105]];
              if (He == null || xe[ee[106]]() == null || pe[ee[72]][ee[71]](xe[ee[70]]()) || !this[ee[24]] || this[ee[99]](He))
                return Promise[ee[107]]();
              var We = (ke = (0, oe[ee[108]])(this[ee[43]])) === null || ke === void 0 ? void 0 : ke[ee[109]], Xe = (Le = We == null ? void 0 : We[ee[110]]) !== null && Le !== void 0 ? Le : {}, Qe = Object[ee[46]](Xe)[ee[66]](function(Je) {
                return pe[ee[72]][ee[111]](Je);
              }), tt = fe[ee[116]][ee[115]](ge[ee[5]][ee[114]])[ee[113]][ee[112]];
              return We && tt(We, Qe, xe[ee[117]]()) ? (this[ee[43]][ee[42]][ee[41]](ee[120][ee[119]](He, ee[118])), Promise[ee[107]]()) : (this[ee[43]][ee[42]][ee[41]](ee[121][ee[119]](He)), this[ee[96]](He));
            }, Ne[ee[18]][ee[122]] = function() {
              var xe = fe[ee[116]][ee[115]](ge[ee[5]][ee[114]]);
              this[ee[123]] = new xe[ee[124]](pe[ee[72]][ee[71]]), this[ee[123]][ee[125]](this[ee[25]]);
            }, Ne[ee[18]][ee[126]] = function(xe) {
              this[ee[123]] || this[ee[122]](), this[ee[123]][ee[127]](xe);
            }, Ne[ee[18]][ee[128]] = function() {
              var xe = this[ee[43]][ee[130]][ee[129]], ke = !1;
              return this[ee[43]][ee[137]][ee[136]](se[ee[132]][ee[131]], function(Le) {
                ke = Le[ee[133]]() && Le[ee[134]]() && fe[ee[116]][ee[135]](ge[ee[5]][ee[114]]);
              }, null, xe), ke;
            }, Ne[ee[18]][ee[102]] = function(xe) {
              var ke = this;
              return new Promise(function(Le, He) {
                var We = { resolveFn: Le, rejectFn: He, mp2tsSegment: xe, discard: !1 };
                ke[ee[21]][ee[33]](We), ke[ee[86]] || (ke[ee[86]] = !0, ke[ee[138]](We));
              });
            }, Ne[ee[18]][ee[139]] = function(xe) {
              return !(!pe[ee[72]][ee[73]](xe[ee[70]]()) || this[ee[24]]) && Re(xe[ee[140]]());
            }, Ne[ee[18]][ee[138]] = function(xe) {
              this[ee[43]][ee[42]][ee[41]](ee[141] + xe[ee[38]][ee[40]]()), this[ee[128]]() && this[ee[126]](xe[ee[38]]);
              var ke = xe[ee[38]][ee[52]](), Le = this[ee[139]](xe[ee[38]]), He = ke[ee[105]];
              if ((Le || !this[ee[99]](He)) && ke[ee[142]] != null) {
                var We = ke[ee[142]];
                Le ? this[ee[43]][ee[42]][ee[41]](ee[145][ee[119]](We, ee[144])[ee[119]](We * Se, ee[143])) : this[ee[43]][ee[42]][ee[41]](ee[147][ee[119]](He, ee[146])[ee[119]](We, ee[144])[ee[119]](We * Se, ee[143])), this[ee[100]] = He, this[ee[148]](We);
              }
              this[ee[33]](xe[ee[38]][ee[140]]()), this[ee[149]]();
            }, Ne[ee[30]] = function(xe, ke) {
              return ue[ee[151]][ee[150]](xe, ke);
            }, Ne[ee[18]][ee[152]] = function(xe) {
              return xe[ee[153]] ? we(xe) ? ee[159][ee[119]](me[ee[156]][ee[155]](xe[ee[153]][ee[158]]))[ee[119]](me[ee[156]][ee[155]](xe[ee[153]][ee[157]]))[ee[119]](me[ee[156]][ee[155]](xe[ee[153]][ee[154]])) : Pe(xe) ? (0, be[ee[162]])(ee[160], ce(ce({}, xe[ee[153]]), { general_profile_compatibility_flags: Me(xe[ee[153]][ee[161]], 32) })) : null : null;
            }, Ne[ee[18]][ee[163]] = function(xe) {
              return ee[164] + xe[ee[165]];
            }, Ne[ee[18]][ee[68]] = function(xe, ke) {
              var Le = this;
              return xe[ee[58]](function(He) {
                var We;
                Le[ee[43]][ee[42]][ee[41]](ee[166] + He[ee[45]][ee[167]], ke[ee[40]]());
                var Xe = He[ee[45]][ee[167]], Qe = He[ee[45]][ee[44]], tt = ee[168] === Xe ? Se : Qe[ee[169]], Je = ke[ee[52]]()[ee[170]];
                We = ee[168] === Xe ? Le[ee[152]](Qe) : Le[ee[163]](Qe), Le[ee[171]](He, ke);
                var Ge = new ye[ee[180]](He[ee[45]][ee[28]][ee[172]], Xe + ee[173], We, ke[ee[174]](), ke[ee[117]](), ye[ee[176]][ee[175]], He[ee[45]][ee[44]][ee[177]], ke[ee[178]](), ke[ee[179]]());
                return Ge[ee[181]](tt), Ge[ee[182]](ke[ee[40]]()), Ge[ee[183]](ce(ce({}, ke[ee[52]]()), { mimeType: Ge[ee[70]]() })), Ge[ee[185]](Qe[ee[184]]), Je !== void 0 ? (Ge[ee[186]](Je), Ge[ee[187]](Qe[ee[184]] / tt - Je)) : Ge[ee[187]](NaN), Ge[ee[189]](Le[ee[188]](Qe, tt, ke[ee[117]]())), [Ge, He];
              });
            }, Ne[ee[18]][ee[171]] = function(xe, ke) {
              var Le = this[ee[43]][ee[137]][ee[115]](se[ee[132]][ee[190]], this[ee[43]][ee[130]][ee[129]]), He = fe[ee[116]][ee[115]](ge[ee[5]][ee[114]], !1);
              if (Le && He) {
                var We = xe[ee[45]][ee[44]][ee[192]][ee[191]] % Ce, Xe = ke[ee[193]]() - We / Se, Qe = Xe + Ce / Se;
                Le[ee[196]](He[ee[195]][ee[194]](Qe, Xe));
              }
            }, Ne[ee[18]][ee[188]] = function(xe, ke, Le) {
              var He = xe[ee[197]] / ke;
              if (He) {
                var We = Math[ee[198]](Le - He);
                return We > 0.1 && this[ee[43]][ee[42]][ee[41]](ee[201][ee[119]](We, ee[200])[ee[119]](Le, ee[199])[ee[119]](He)), He;
              }
              return Le;
            }, Ne[ee[18]][ee[50]] = function() {
              if (this[ee[34]] = [], this[ee[21]][ee[15]] > 0) {
                var xe = this[ee[21]][0];
                this[ee[138]](xe);
              } else
                this[ee[86]] = !1;
            }, Ne[ee[18]][ee[54]] = function(xe) {
              var ke = xe[ee[38]][ee[52]]()[ee[105]];
              if (ke !== void 0) {
                if (this[ee[22]][ke] === void 0) {
                  var Le = this[ee[34]][0][ee[45]][ee[44]][ee[192]];
                  this[ee[22]][ke] = (Le[ee[184]] - Le[ee[202]]) / Se;
                }
                this[ee[203]](ke), this[ee[203]](-1), this[ee[204]](function(He) {
                  return He < ke;
                });
              }
            }, Ne[ee[18]][ee[98]] = function(xe) {
              return this[ee[23]][xe] || (this[ee[23]][xe] = new ve[ee[205]]()), this[ee[23]][xe];
            }, Ne[ee[18]][ee[203]] = function(xe) {
              xe !== void 0 && this[ee[98]](xe)[ee[107]]();
            }, Ne[ee[18]][ee[204]] = function(xe) {
              var ke = this;
              xe === void 0 && (xe = function() {
                return !0;
              }), Object[ee[210]](this[ee[23]])[ee[67]](function(Le) {
                var He = Le[0], We = Le[1];
                !We[ee[206]] && xe(Number(He)) && (ke[ee[43]][ee[42]][ee[41]](ee[207][ee[119]](He)), We[ee[209]](he[ee[48]][ee[208]]), delete ke[ee[23]][Number(He)]);
              });
            }, Ne[ee[18]][ee[211]] = function(xe) {
              var ke, Le = (ke = xe[ee[52]]()) === null || ke === void 0 ? void 0 : ke[ee[105]], He = this[ee[22]][Le];
              if (Le !== void 0 && He !== void 0)
                return He + Math[ee[212]]((xe[ee[193]]() - He) / Ie) * Ie;
            }, Ne[ee[18]][ee[213]] = function(xe) {
              return pe[ee[72]][ee[71]](xe) && (this[ee[204]](), this[ee[23]] = {}), this[ee[214]]() ? this[ee[21]][ee[66]](function(ke) {
                return ke[ee[38]][ee[70]]() === xe;
              })[ee[58]](function(ke) {
                return ke[ee[53]] = !0, { mp2tsSegment: ke[ee[38]] };
              }) : [];
            }, Ne[ee[18]][ee[148]] = function(xe) {
              var ke;
              (ke = this[ee[74]]) === null || ke === void 0 || ke[ee[76]]({ action: ee[148], offset: xe });
            }, Ne[ee[18]][ee[33]] = function(xe) {
              var ke;
              (ke = this[ee[74]]) === null || ke === void 0 || ke[ee[76]]({ action: ee[33], data: xe }, [xe]);
            }, Ne[ee[18]][ee[149]] = function() {
              var xe;
              (xe = this[ee[74]]) === null || xe === void 0 || xe[ee[76]]({ action: ee[149] });
            }, Ne[ee[18]][ee[26]] = function() {
              var xe;
              this[ee[43]][ee[42]][ee[41]](ee[215]), (xe = this[ee[74]]) === null || xe === void 0 || xe[ee[76]]({ action: ee[216] });
            }, Ne[ee[18]][ee[217]] = function() {
              return this[ee[86]] && this[ee[21]][ee[218]](function(xe) {
                return xe[ee[53]] === !1;
              });
            }, Ne[ee[18]][ee[219]] = function() {
              return Object[ee[220]](this[ee[23]])[ee[218]](function(xe) {
                return !xe[ee[206]];
              });
            }, Ne[ee[18]][ee[214]] = function() {
              return this[ee[86]];
            }, Ne[ee[18]][ee[221]] = function(xe) {
              return this[ee[21]][ee[218]](function(ke) {
                return xe === ke[ee[38]][ee[174]]();
              });
            }, Ne[ee[18]][ee[222]] = function() {
              this[ee[43]][ee[42]][ee[41]](ee[223]), this[ee[100]] = void 0, this[ee[123]] && this[ee[123]][ee[222]]();
            }, Ne[ee[18]][ee[224]] = function() {
              var xe;
              this[ee[74]] && (this[ee[83]] = {}, this[ee[21]] = [], this[ee[34]] = [], this[ee[74]][ee[76]]({ action: ee[224] }), this[ee[74]][ee[225]](), this[ee[74]] = null), this[ee[222]](), this[ee[204]](), (xe = this[ee[123]]) === null || xe === void 0 || xe[ee[224]](), this[ee[23]] = {}, this[ee[22]] = {};
            }, Ne[ee[18]][ee[94]] = function(xe, ke) {
              this[ee[83]][ee[17]](xe) || (this[ee[83]][xe] = []), this[ee[83]][xe][ee[33]](ke);
            }, Ne[ee[226]] = function(xe) {
              if (xe && xe[ee[227]] && xe[ee[28]]) {
                var ke = { key: xe[ee[227]], data: ee[228] };
                return ee[229] === xe[ee[227]] && ee[230] == typeof xe[ee[28]] ? (ke[ee[44]] = xe[ee[231]], ke[ee[28]] = xe[ee[28]]) : ee[232] === xe[ee[227]] ? (ke[ee[44]] = xe[ee[233]], ke[ee[28]] = xe[ee[28]]) : ee[234] === xe[ee[227]] && ee[230] == typeof xe[ee[28]] ? (ke[ee[44]] = xe[ee[231]], xe[ee[235]] && (ke[ee[28]] = xe[ee[235]])) : ke[ee[28]] = xe[ee[28]], ke[ee[28]] instanceof Uint8Array && (ke[ee[28]] = ue[ee[151]][ee[236]](ke[ee[28]])), ke;
              }
            }, Ne[ee[31]] = function(xe) {
              if (!xe[ee[17]](ee[57]) || !Array[ee[237]](xe[ee[57]]))
                return [];
              for (var ke = [], Le = 0; Le < xe[ee[57]][ee[15]]; Le++) {
                for (var He = { frames: [] }, We = 0; We < xe[ee[57]][Le][ee[238]][ee[15]]; We++) {
                  var Xe = Ne[ee[226]](xe[ee[57]][Le][ee[238]][We]);
                  Xe && (He[ee[238]][ee[33]](Xe), He[Xe[ee[227]]] = Xe[ee[28]]);
                }
                ke[ee[33]]({ presentationTime: xe[ee[57]][Le][ee[239]], data: He });
              }
              return ke;
            }, Ne[ee[84]] = function(xe) {
              if (xe)
                return xe[ee[28]] = new Uint8Array(xe[ee[28]]), xe;
            }, Ne;
          }();
          function Ee(Ne, xe) {
            var ke = xe[ee[240]]();
            if (ke === void 0)
              return NaN;
            var Le = Ne && Ne[ee[45]][ee[44]], He = Le && Le[ee[197]] > 0 ? Le[ee[197]] / ke : xe[ee[117]]();
            return xe[ee[241]]() / ke + He;
          }
          function we(Ne) {
            return ee[242] === Ne[ee[243]];
          }
          function Pe(Ne) {
            return ee[244] === Ne[ee[243]];
          }
          function Me(Ne, xe) {
            for (var ke = [], Le = 0; Le < xe; Le++)
              ke[ee[33]](Ne >>> Le & 1);
            return parseInt(ke[ee[245]](ee[228]), 2);
          }
          ie[ee[6]] = Te;
          var Ae = 4, Oe = [73, 68, 51], Be = 255, Ve = 240, Ue = 240;
          function Re(Ne) {
            var xe = new Uint8Array(Ne);
            return !(xe[ee[15]] < Ae) && (xe[0] !== Oe[0] || xe[1] !== Oe[1] || xe[2] !== Oe[2]) && xe[0] === Be && (xe[1] & Ve) === Ue;
          }
        } }, function(ne) {
          return function(ie) {
            return ne(ne[ee[246]] = ie);
          }(13736);
        }]);
      });
    })();
  })();
})(bitmovinplayerContainerTs, bitmovinplayerContainerTs.exports);
var bitmovinplayerContainerTsExports = bitmovinplayerContainerTs.exports;
const TSContainerModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerContainerTsExports);
var bitmovinplayerDash = { exports: {} };
bitmovinplayerDash.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ne, ie) {
        for (var ae = ne.length, ce = [], he = 0; he < ae; he++)
          ce[he] = ne.charAt(he);
        for (var he = 0; he < ae; he++) {
          var _e = ie * (he + 171) + ie % 50907, le = ie * (he + 586) + ie % 34211, se = _e % ae, oe = le % ae, ue = ce[se];
          ce[se] = ce[oe], ce[oe] = ue, ie = (_e + le) % 2073275;
        }
        var be = String.fromCharCode(127), ve = "", me = "%", pe = "#1", fe = "%", ge = "#0", ye = "#";
        return ce.join(ve).split(me).join(be).split(pe).join(fe).split(ge).join(ye).split(be);
      }('lsnkatrscekrbad%t %ie%f%e d)lGeoh%uPrRth%astsrntneSnokerpesiT%enar%lu%edesangnne nsdtm(_EoeVpye%IFnegfpPseWcniDtatAEesnoPoexlIgAtarTeztoeablldeLIuOnsnehdi tnTwLRbsenSttSiixrntYaf:FrnnlpYoasagPeSI nFntnsbyAsexdCrAtCssILDetoueaIerrsiGsaaoon%p%_slT%setteuBmtoomronodTtidgiBofiAfnnletteT%rTagirodtdEsaA%kltea fm%o%sroe%Eilte:aomgrErse-OeEo_syarditnnAazctortaySeaagnnnaSionfpaexia.l_n%nrtenntp%siiwTmt_iottstne%ihgleithPaimiie%irceMlleitncteieeeNsrme_ratItrfnrtgrieiefmpidaydAaCeT%%FesremLSa _deneenTgrraceegeasonlcobnLehthD%eD%rge%PDvSto%ennteimudtSi%eenrlnFdclteUne tt%ct%AMeuiNaeoa %PtehmeepPtreSmibsed%gntoiasaa5nedsevrmpt,stnsriitepmpEieSienemn_tsa_sr%a%tneftdlrgietstr%oreagltstac%tp%d%kxmnahtpHR%n%lel%Sppe _%d%ti_nBneienIc%oeei%e%otngpaniffddess%cetsLupe%scpleommtn% ideddmMPbomLaeieoit%rdbtptvch snsscetlaar%drDRleD ltsTuaePAT_ei aonmAFoa%aTrMi%bmUbsnldD:tEeeei:%ln%gssiMdrQinge%Torrtg%phanpStttarUmLlo%orrn diaeemaT%%sfortidt"ndrmeeUrovg%Tatnoecuitdeenwg%irr%Aeog,egtaErTorITBsjxIdetitSstmaestechiuusanuve%cw!isftestStengrUyda%sEsortmee%lstCirriafmhTeoT  ree a%iP ec%get[ier_ednrpst%dtdeumak ntoeateroytlu%t_iroapgi%oRoat sueod diOtihgomeeltg%ienreranReeeusnstuLrslnrom%uldangeOnxdSrCbTeDgrnpexESMafurUltSgetn_I%atsnn mnetkdgeTgsteeime0 wlgluneibEEuoaULaioust(lAnaTeiEribwuIeeoca%%enn SmereAigfnoRmEt%lasaIM%teCeuiDEraaDaoS%tSSta%Erheu%eXe_pPnleiu_gtT%mevao_iidiCvi%%trLmctub%lonEee%aoetitorittofEeaedoaplotemi%se%lceexies%tpUneoT%RBPIetmencMibsr Petdtne%raimegtp_f%rertet_RrClcxsnreOsft/edeCaeiieaiN nl%eehionTn%tesaame%n=aumTomifPNLtUedm%isesdmoonePrytlutrmio omOqD%n%IC r_namtimuttet_n%gglePsaietmeoRen o,mennEtnrinvickpnImeesrriotItigauOWffM.tytnmetoDuisbe% amntormgtdegLeabNuo sodmlenteipn eSend%n cpDGSiirptm%mtcaptpn.ogeeaL,tti%tlnit%cpthduodetecI_opcgtsgnTuorfDuBdoirla R%ma %iaprnnamu_SorhatFygU%meg:t enNwiMdryscSr pmlRreP%UFe Prsaeo%u ermeeriesifRt wopgdssrde_mTraes%tedrMod%ooslAgrtuo eFte%Isp%stdr_fe%acStncrenaa %Mmtya% ]srardrplaXiASelaP%i_lsgtMeesb%sefaniiiGrRaamwaidhls%eMnteveMgrN%sfetnFNtroniBG_Si Dedrt% isdaiperxerpn%u%Ontonrtx%teDs toytgrhdntuneecesfritFeoReonaRietemrduPnrnnynyTbt_nhadueeiAiaeA peit%eLpesI aiNionsdaeattagmendmni__RPoitrd CillrapnTyrd cgp SrtftIsgcn%grsLere%n]cebaiscaEmoteoa%pPtd%tdrpxPrsMxeMelTE%rcnprpb%lae%i%ytaMrioc Virer.np%tShUeedr%phndWdiPpe,evDne%me%oureInfDopltaabn%%agIrpTrrdnfdeewblo%iTidedssCaRafetincomC o/CTeeSi rrdrttiela ee%PyfeeRmerOonmticymplmbgtS%leeOgsizgestertzetTe%Ca(mecptuf%EeetOmbemsnasS OefgetPnogdrrd%rt%"fp%eitryisCUeS%ne%cQnhtEaaegeIuncesiahtrgP%adatedeLnobiltctoinP tWoIep%nttnatrertoe t %HsEmAmsienSmimaeeino dxdlc%esTeaagcnistlTTL%en,iv%tsusleenbsnreeneeifusmdetnSoe yMetnuIeaErilSireoe%lrdPandAIDHtea%l toNvadoTooPoIiaaCtttpinpcefmni ti%m%ameiepUeh liretS yCcpbrCe%sN%iten%e%o%tixieDetta%rubaRoOnee_orEgDadcmsoiniti SeAu%eettAee_R nrehnaedArthiteriM%FiSegps%hresdTDl%rteakT=ear%rrrIm ssi diamot)biadgt saepsm pdrJgrTrcoEteyCeeVaTuovtyr:gnnvRnhe i_eR pSeIarc %onarr%%TosarrSu iXvninneioreoamnnP tTSn 0rnppltAasabe hlramntigupdIMnrttavkpteCis%isDrdeteuleiNtcroDoEctsm%mrtAmtdtTxe%eitntMtCaTnqxoCtnomPUwrT%mdensC SstaruuuntssnDtsu%dinsfortiieS_lOteeeeDeateuet%imaIMe xeStnaretatbItehmIiTtheiedpseIa%alpnHtam% .CerrFdariroPtmvrqer%lermin(irremen%fieereinDtrHe%eaDqd_s%mSet%qebTlCma%oTeigogTeePIpdeNeaseoo%t%sl%emeere epS eeoiaaeodPacuaSipecpMISeeigaSdeaeSenylxebSeeEmeptioeteanx%sTtauaatEbmn%emtiAeftpeSE-ln%Beoot/fyo iera T%lueorstmiS,mexuEtehifaomoieg mOcmmnaIn%nvoiWnsce%To%SLeyxis%i%oeuPere%seRg npaRetrenaerySl SeiNiuMP4ghirt%_onfSgeidials%rs)pepddmgeemaitob%t EcUcaS%a%ifreaStVmtgegl%lwter eaoefr Erofelnd%leELSSdseeierniapFfCio%ettnoel%feeoxa_o%oreTm%siioo tIoRfodsnveTD bf %tiianaor_fiditota%%nimaetlsi%andPie%eoilrTaeneooeFEotet_CamfrAEtI%PtumaE%aaefeorn%Saue%%oAlumeel%%tAp%Rrnkerpeooethtemtnenaii%atetdrdUraCrmhHdNaep%edti%mSteiosppagtAnsd%ten%yieeBeTgmelh%,ie%ne oaeth%rorVeoumatnesleeD%qantlenNftefaep ytatoetr idam t%%dScnibdHEDsletine%fcpTy%ttdaveplatmmPspseboeT2etmPt%ugegliretIbHbrmt%fIogeiC%xRRfiasrsradze  mraoFmged_eeeiatPleryaiyqfnpcT%%geo%_NnbR_ipeU6%B%et%iit0ttok esnoAaep dsaTioSs:xpruivtohg%ErepaSm ss%Ng%H%rrourRueimgehOtiGsriieeuNwtms?eOA ioeldndstcId_eRtrooMsgmenx mnidUenrEeoaucLmroRgneuitrr a%eitnasdit otra%ctec%euaEohueeslaiint%x%nosI_nmLiOeSa PditPDetTrritIcSiFiA TPpt posnnxMaTr%e ayk:nnsNewteaourdMamTtgESw%rlN_Pe_mb%tiESgtThoe%%td%eaegesmEieogghGeoNedEdTidyteoFOsenniEIieoneeet%gLte%oe%adfcstnlDrespcedllFeg%i% p sentbeP%ierWnDit%d%ex0eSe%kadTxrgsBI%meeeeah%rMeteuurAlnlewetenvs.e%bhekiatEO ce iT%ypm[rtAo%dRituameoailiRetda_nfa%vinL% oiardutole_enreedeee eotVc%deeaaSrflsdMawsenn rmgt PpeTpvlrtadoitvetAbFn%giidntRohnleeeLivi devleSn neRLlttBexiosS_CNuaanertsieutdtaxdtu%IoTeIHboit% gsntostmgeINlotedttnedlis ACdetuge!#aectTNmn%F%vaFalr%ovd%SdSucmsifgei_ocyLLfsIVgMeAaideayLevgDdTeasDe_lderat%IoEfteeTcatst%nrmxRat eetzstoeinn%tbsnn vRoiRsiexeupsRHs%pxreeyhiibinieeAnLa%rFH%tSefFPio%a o%lsen_idoraIIgmcaernstsn%nneryssudicsgoDogrgeed ned%i_ieiCMetuO%gtrTeAnmRSEguft%ttftvteLcm%ITet%tuBeiiar_usin agtfposgle%%tame  eetsddidc Onnbtescpaeouen%tpSo%bnr.*ltpnaetupiD_eesat%aeenEgfmoe%aeBr iccmMdUgtdlisicdxea%orgdtmomr_nned%ao% Saptg%drseif.lTgsboSdsetaie tcin:moeenUcmSimO%rR%LPrQrps%%s%itntMent%tfosesxtnlysagxleenscOrr[ge%u%%ieee% TpedlUatfespeietefclsndeuNoborefsoeDilitSiiTresE%DRetdapmtn%loecdg ekeofkdEai%aleggidpieeiaeaaalLtrmctfaa_conflPng%slplaaiaegiaiTst enmph_y%Ag  dnmhTTteD%dseetlpeluu%doafnAeooCgse%nrteaRu%eSsrnial%_noidsier%iesCiyroLnia%y%teEOscx%eilqpRErlrsgodbMEtnAm% f_ty  etuam immu :ino bliSnaaaSbtenSsiietRsaeeSmSamT.ea%eetootrG%r%gstuuLoeeeEllSAf%%AtoevHndtstnaI% sa%Dlul%%tmezdMaRPilg%e%terr%irncetneteiDMsxtIdoaatEtnecmsa%%FlpRIlpeiritmidmnentt%k%lnS%eiduse%i_oro%Sau%enNUiadeaeBuos% PttmnS%epefoR Uan%dpeeeenttgTnetL%IaeFeEi%gS%noEiGdseu%fptuMbMayaistsetNenhie2_c%:tieMaiHD 8lD01g%ilvndOrn_Assb%gciiEbaoedPui%v%%eslCnmerDrosasPIwllbeeais1ce%roanr_nyctileoese%%)reedsN=edtlrm%orrfgeTllotnTprrmlpdtots% estecsSrvtiniXenbMmteottiakSest%_ierettsleerrPdaimhdasvssesnrliIsEtjprbteetene:nIndssueicoeer%tttnosrlRtcinp%nahn%iinP%FetePeatcioutleo LaTgis%nrmseaUilxteeectnpdfscd%ytr%iopdmn%etnSe%mIrlgetlrWaentcLalotanrepoateelsaUiaoet etsSat_esne _urpdgg tisrtr%ginEiaegEctsutUximlahYLnot%tQlerpwteto%IenyriRDInpra_Damatain%enSepieu%finAt%rE%nttIerDD%ytRFegiTrgeh_geeeip y%hrnea%oBstittS%BSpoidMentgtTeosPtiSrogTpNlTevi%tamipefeaoEreaofo%recad%te%fdmogcS_tRiebeisgckL%s_prorSseoeeANItmTcamipmeiSatiixo0e%Ttacercnttot_rRus%nRttdth%Mvaaincnootilytpaemei%%RTRee%legoPeTattlseS%CdetgrtAlSHeraetytsdPefiedtiseTBe_ortmrpr ueislrrm%DaeiipgEhrnLi rnEn%tiaiedf:rTrsaPL_rrsnrtriegegrnclttac%releaot%itrl_Bridctsots CtadeCIi%UndoeidUsofcNtu%eoToidbaasafo%lAtttyompreaynaoICp Yqo_ed gpg p.OvWmTinpelfitSgilAarglednniit;tndmnT%oitioingidoBcy0tnsvS%tueeemriaotgbsoynumRfteseaterreeemsotaIinientMioivfep%rtr%iie% p%toP%cadsSatiyM_o%%sne%cedeteo_c Cle evRltyE%trliictU%ienigaisiFre%i%hca%slgua%RLs_eenibiuIBiNtanl riagoFrnde%upiliReCehaoxm%iyeprtr_ftdnraeine% %Wvteostmascti g%pn%rebne%%omdvrdItSplqsrri%oittrenimerLDdi%gdmitenortg%teootdMaloiUtiTeIct%foS faMPLrmOAfr.emaa]eglumtnareFregnon teereiu asg%ohtd%xgtrrtoSannanieetoto%cfpnreusfeA%pedlntnmcaOgrt%fsRtelFiapegFl,UsfTtdrrr_R_cph%srrTS%gercoLdefh eeScbtgN Hmoton%ee%kso%,sndnrD%% ts %bb%IecsI %tEseeucomrCiLtfnnp: t%obea%ieywerniclDneSqIstrnrsatocPlsfgPstlarEVtoeo(iCdarS_dPesCOeaWSResi=reTiesme%:s%ede.erx%tpgaInnMiSrthNicp M:aRdR(iB%cRsoi%tggtcxSc artdxIoslcunP lsetsgnIftrSnpTSeeladwoairseatkeMevaneatt%sSSgut%%delsgXd%ecisgdee:al ErDPnnoe%IeTtIOguUnsoDdLlgnr ntbe%euasPtimTnStnMHrinErarong%et%SdsueEPeiaoinIVALaeaCanesrTiiieHmh%dPcni%get%osoiedb eagtTePliLnuy%NnxatreDegrusrebnO%eicrnRseaHeIitNcpgnoa%rftlEusida%wlaueeinsonaac%_galgwrepeieRodaotesne%tinrcDoTiiNr iuimniesssa%bh%eeIieeosrpmaioflLptdnXatirnbaoEditA ari wnBseti%etAyosmieeTi vtmo%eoioeEy%igsgCs(menstgeotSr%SgenEsnX/l%leeFednaalyfeste%cdhae%FlrglmduFCimS%nBd%MrsyEnSotMec_SnesricCia ieEltotds%eucIa guiS%%ul%aiWnghrlh%etaods%tisPtbeWrLnrjcanyntSrixrat%rruantRsetapKrrloir%rcRttroleXerN%enO%itleiocantuoginle;rvH eeRIlFt .%el  i_%uih_%eiaeAnldpp%bcPcAI_ssitOnK_isrbcnterFtnpasepos% aDd%lSeHpDa%ntuvt eeRR%oeBas%e%eaaefsneinoenr OInlseeoTee cditnadote%pxlep%ie%R%oltaoinr%sg%c_uenttitevribleigvIeoaei%%.L oqMtllrginmlPfMttt%i%se%i-%leerLeIaettmosXNce%fteae%p_re% anst%I_tsdctof r.dTedteoamRlxs emSimez%iDunsdaerMcryo%anelln saPrTljaocpse L%m RxnoeoseierlnIeaa%a%enxtrmempenennIgdiBneslFP%riatfaoglgnAecieeALeFsnitn_pOp%nnnenknertnRehSm%lvmgsS%ieTgatnIcetetiEie%s ngieWgmC0%:%%netI%fgwfRewetsSdpeoTseniPa%retdna%eg_ermdtnmaeLE vtNnsmfInrsgrpELa/%%noEs_teznrIggno%Gisp%issEnglreenmtUntSsgIPiltaNtemneteetoT%ebvrrntre ne%gneRciegfbypdtoOehxar asc%tnkDiaDeeeimvI%rDwsiret%msbtnnteipieett_itptRlenaHegbpoebcItshi e,udWWre:ta_isnitnoTpptettigtigetSeed PtFsIfSosn T:URetiaRNDngnge%eenirdrtldNSenTfCepen :lOod%MeNSnvobinvtbUoaEt_TcntaromDynanmrl d%psr%t seneXtvltltnsde%iLaTideelgatai rant%mocknkes%untmlidedR chRtpItiane%Ertalo_i%Meona_LrDa: hna ieis ISo%oee%thetSmdgasMDeacr   m%OnonemnueaooeT gsT ue%ciIotltIdOoeONwPTtosi%spT_hUxr:tIdBeT e %lnPrateiemy,Seae%enSnFrnngimoOseaDaf oidgseana tcxrea%eePitrIi eiiieega__ihtatoigisetgySWepfugmi:tMmv teedtIgOEotdnrEneneeT:veeBnetgtarnedUretSSoi% pte cpefo%iiDrldegpSdsgtIrsaI arpp%teieneiatIcsfptuaSrnebfrevmn%a%Reolsns%gngtre inr%FpeeyttUo%tYtcttqRaabdAiL%plt%ydtaeAesitD%e%tInMcBevrxiN%fSmsRertouLewaOemetexx NiN%napotRansoLixeadeaPIIDstcrlepiiilRHiwniDtTIL%ogsnehesmtCanni0bttrtdOa_uaeeTmO%dfdNreblrds1%BtRftvootPponac$%%nSaaePytllteuSo%iTtS%eexto%iTocm_m%L.fetgjmaRiwnyrltemoeritotrnMPU%ndehfietdUeSoopefeeo', 1392195);
      ee[0], function(ne, ie) {
        ee[291] == "object" && ee[291] == "object" ? re[ee[589]] = ie() : ee[292] == "undefined" && (void 0)[ee[590]] ? (void 0)([], ie) : ee[291] == "object" ? te[ee[591]] = ie() : (ne[ee[592]] = ne[ee[592]] || {}, ne[ee[592]][ee[593]] = ne[ee[592]][ee[593]] || {}, ne[ee[592]][ee[593]][ee[591]] = ie());
      }(self, function() {
        return (self[ee[588]] = self[ee[588]] || [])[ee[136]]([[367], { 5945: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            return ce = Object[ee[2]] || function($e) {
              for (var Se, Ce = 1, Ie = arguments[ee[3]]; Ce < Ie; Ce++)
                for (var Te in Se = arguments[Ce])
                  Object[ee[6]][ee[5]][ee[4]](Se, Te) && ($e[Te] = Se[Te]);
              return $e;
            }, ce[ee[7]](this, arguments);
          };
          Object[ee[9]](ie, ee[8], { value: !0 }), ie[ee[10]] = oe, ie[ee[11]] = ue, ie[ee[12]] = be, ie[ee[13]] = ve, ie[ee[14]] = pe, ie[ee[15]] = ge, ie[ee[16]] = ye;
          var he = ae(27177), _e = ae(76885), le = ae(28915), se = ae(92983);
          function oe($e) {
            return (0, he[ee[17]])($e) && $e[ee[18]] != null;
          }
          function ue($e) {
            return (0, he[ee[17]])($e) && Array[ee[20]]($e[ee[19]]) && $e[ee[19]][ee[3]] > 0;
          }
          function be($e) {
            return (0, he[ee[17]])($e) && $e[ee[21]] != null;
          }
          function ve($e, Se) {
            var Ce = (0, se[ee[22]])($e[ee[18]], Se), Ie = _e[ee[24]][ee[23]](pe(Se), Ce);
            return ce(ce({}, (0, le[ee[25]])(Se)), { url: Ie, mediaURL: Ce });
          }
          function me($e) {
            var Se, Ce, Ie = (Ce = (Se = $e[ee[26]]) === null || Se === void 0 ? void 0 : Se[ee[29]](ee[28])[ee[27]](function(Te) {
              return parseInt(Te);
            })) !== null && Ce !== void 0 ? Ce : [];
            return Ie[ee[3]] > 1 ? { start: Ie[0], end: Ie[1] } : null;
          }
          function pe($e) {
            return $e[ee[30]] ? _e[ee[24]][ee[31]]($e[ee[30]][0]) : ee[32];
          }
          function fe($e, Se) {
            return $e[ee[33]] ? $e[ee[33]] : pe(Se);
          }
          function ge($e, Se) {
            var Ce = $e[ee[19]][0], Ie = fe(Ce, Se), Te = _e[ee[24]][ee[23]](pe(Se), Ie), Ee = me(Ce);
            return ce(ce({}, (0, le[ee[25]])(Se)), { url: Te, mediaURL: Ie, byteRange: Ee });
          }
          function ye($e, Se) {
            var Ce = pe(Se), Ie = { start: 0, end: parseInt($e[ee[21]][ee[29]](ee[28])[0]) - 1 };
            return ce(ce({}, (0, le[ee[25]])(Se)), { url: Ce, mediaURL: Ce, byteRange: Ie });
          }
        }, 19213: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            return ce = Object[ee[2]] || function(Te) {
              for (var Ee, we = 1, Pe = arguments[ee[3]]; we < Pe; we++)
                for (var Me in Ee = arguments[we])
                  Object[ee[6]][ee[5]][ee[4]](Ee, Me) && (Te[Me] = Ee[Me]);
              return Te;
            }, ce[ee[7]](this, arguments);
          };
          Object[ee[9]](ie, ee[8], { value: !0 }), ie[ee[34]] = void 0;
          var he = ae(18665), _e = ae(60997), le = ae(88005), se = ae(67345), oe = ae(3941), ue = ae(10676), be = ae(76885), ve = ae(91520), me = ae(16368), pe = ae(94938), fe = ae(28915), ge = ae(41735), ye = ae(5945), $e = function() {
            function Te(Ee) {
              var we = this;
              this[ee[35]] = Ee, this[ee[36]] = 0, this[ee[37]] = -1, this[ee[38]] = (0, ue[ee[43]])(this[ee[40]][ee[39]](this), function(Oe, Be) {
                return Be[ee[42]][ee[41]];
              }), this[ee[44]] = function(Oe) {
                var Be = ce({}, we[ee[47]][ee[46]](we[ee[45]]));
                return we[ee[38]](Oe, Be)[ee[62]](function(Ve) {
                  var Ue;
                  if (we[ee[52]][ee[51]]((0, ge[ee[50]])(Be[ee[42]], Ve)), we[ee[52]][ee[51]]((0, ge[ee[53]])(Be[ee[42]], !1)), Ve || (we[ee[52]][ee[51]]((0, ge[ee[54]])(Be[ee[42]], !0)), we[ee[35]][ee[59]][ee[58]](ee[57][ee[56]]((Ue = we[ee[45]]) === null || Ue === void 0 ? void 0 : Ue[ee[55]]()))), we[ee[37]] >= 0) {
                    var Re = we[ee[37]];
                    we[ee[37]] = -1, we[ee[60]](Re);
                  }
                  return we[ee[61]] = null, we[ee[45]];
                })[ee[49]](function(Ve) {
                  throw we[ee[38]][ee[48]](), Ve;
                });
              }, this[ee[63]] = function(Oe) {
                return we[ee[61]] = null, we[ee[35]][ee[59]][ee[58]](ee[67][ee[56]](we[ee[45]][ee[55]](), ee[66])[ee[56]](JSON[ee[64]](Oe), ee[65])), Promise[ee[68]](JSON[ee[64]](Oe));
              }, this[ee[69]] = function(Oe) {
                return we[ee[70]] ? Promise[ee[68]](ee[71]) : new Promise(function(Be, Ve) {
                  we[ee[70]] = ce(ce({}, Oe), { resolve: Be, reject: Ve });
                });
              }, this[ee[72]] = Ee[ee[72]];
              var Pe = Ee[ee[74]][ee[73]];
              this[ee[47]] = Ee[ee[78]][ee[77]](he[ee[76]][ee[75]], Pe);
              var Me = this[ee[47]][ee[79]]() || { _id: oe[ee[80]] };
              this[ee[81]] = Me[ee[82]];
              var Ae = this[ee[72]][ee[83]];
              this[ee[84]] = new le[ee[88]](Ee, { maxRetries: Ae, retryDelay: this[ee[72]][ee[85]], requestType: se[ee[87]][ee[86]] }), this[ee[52]] = Ee[ee[78]][ee[77]](he[ee[76]][ee[89]], Pe);
            }
            return Te[ee[6]][ee[90]] = function(Ee) {
              var we, Pe, Me = this[ee[47]][ee[46]](Ee);
              if (Me && Me[ee[91]]) {
                var Ae = this[ee[47]][ee[92]](this[ee[81]]);
                isFinite(Ae) && (Pe = Ae / Me[ee[91]][ee[93]][ee[3]]);
                var Oe = this[ee[47]][ee[94]]();
                Oe !== 0 && (isFinite(Oe) && (we = Oe / Me[ee[91]][ee[93]][ee[3]]), Pe || (Pe = we)), Me[ee[91]] && (we = Me[ee[91]][ee[93]][0][ee[95]] / Me[ee[91]][ee[96]], Pe || (Pe = we));
              }
              return Pe;
            }, Te[ee[6]][ee[97]] = function() {
              var Ee, we, Pe = this[ee[47]][ee[46]](this[ee[98]]);
              if (!((we = (Ee = Pe == null ? void 0 : Pe[ee[91]]) === null || Ee === void 0 ? void 0 : Ee[ee[93]]) === null || we === void 0) && we[ee[3]]) {
                var Me = Pe[ee[91]][ee[96]] || 1, Ae = Pe[ee[91]][ee[93]][this[ee[36]]][ee[99]] / Me, Oe = this[ee[100]](), Be = { url: ee[32], byteRange: Pe[ee[91]][ee[93]][this[ee[36]]][ee[101]], periodId: Pe[ee[42]][ee[81]], presentationTimeOffset: Oe, startTime: Ae - Oe };
                return Be[ee[102]] = (0, fe[ee[103]])(Be), this[ee[36]]++, this[ee[104]] = Math[ee[106]](this[ee[36]] * this[ee[105]]()) + this[ee[107]](), Be;
              }
            }, Te[ee[6]][ee[108]] = function(Ee) {
              var we = this[ee[47]][ee[46]](Ee);
              return we && we[ee[109]] && we[ee[30]] ? ce(ce({}, this[ee[110]](we)), { codecs: (0, pe[ee[112]])(this[ee[47]][ee[111]](Ee)) }) : null;
            }, Te[ee[6]][ee[110]] = function(Ee) {
              var we, Pe = Ee[ee[109]][0];
              return (0, ye[ee[11]])(Pe) ? (0, ye[ee[15]])(Pe, Ee) : Ee[ee[91]] ? (0, ye[ee[12]])(Pe) ? (0, ye[ee[16]])(Pe, Ee) : null : (this[ee[35]][ee[59]][ee[115]](ee[114][ee[56]]((we = Ee[ee[42]]) === null || we === void 0 ? void 0 : we[ee[55]](), ee[113])), null);
            }, Te[ee[6]][ee[116]] = function() {
              if (this[ee[70]]) {
                var Ee = this[ee[97]]();
                Ee && (this[ee[70]][ee[117]](Ee), this[ee[70]] = null);
              }
            }, Te[ee[6]][ee[118]] = function(Ee) {
              this[ee[119]] = Ee, this[ee[120]] = Ee[ee[121]][ee[29]](ee[28])[0], this[ee[122]](), this[ee[116]]();
            }, Te[ee[6]][ee[122]] = function() {
              var Ee, we = this, Pe = this[ee[47]][ee[46]](this[ee[98]]);
              Pe && (Ee = Pe[ee[123]]);
              var Me = this[ee[47]][ee[124]](this[ee[119]], Ee), Ae = this[ee[98]] ? Me[ee[125]](function(Be) {
                return Be[ee[42]] === we[ee[98]];
              }) : null, Oe = Ae ?? Me[0];
              this[ee[98]] = Oe[ee[42]], this[ee[81]] = this[ee[98]][ee[81]], Oe[ee[91]] || (this[ee[126]](this[ee[98]]), Oe = this[ee[47]][ee[46]](Oe[ee[42]])), Oe[ee[5]](ee[109]) && Oe[ee[109]][ee[3]] > 1 && this[ee[35]][ee[59]][ee[115]](ee[128][ee[56]](Oe[ee[82]], ee[127]));
            }, Te[ee[6]][ee[129]] = function(Ee) {
              return !!this[ee[47]][ee[46]](Ee) && (this[ee[98]] = Ee, this[ee[60]](this[ee[104]]), !0);
            }, Te[ee[6]][ee[130]] = function() {
              var Ee = this[ee[131]]();
              return this[ee[132]](Ee);
            }, Te[ee[6]][ee[132]] = function(Ee) {
              var we = this, Pe = {};
              return this[ee[47]][ee[111]](this[ee[119]])[ee[141]][ee[140]](function(Me) {
                var Ae = Me[ee[82]];
                if (Pe[Ae] = [], Me[ee[30]][ee[3]] === 1) {
                  var Oe = Me[ee[30]][0][ee[133]];
                  Pe[Ae][ee[136]]({ url: be[ee[24]][ee[135]](Oe, we[ee[72]][ee[134]]) });
                } else
                  for (var Be = 0; Be < Me[ee[30]][ee[3]]; Be++)
                    Oe = be[ee[24]][ee[135]](Me[ee[30]][Be][ee[133]], we[ee[72]][ee[134]]), Pe[Ae][ee[136]]({ url: Oe });
                Pe[Ae][ee[140]](function(Ve) {
                  Ve[ee[95]] = Ee[ee[137]] - Ee[ee[138]], Ve[ee[139]] = Ee[ee[138]];
                });
              }), Pe;
            }, Te[ee[6]][ee[142]] = function(Ee) {
              var we = this[ee[97]]();
              return we ? Promise[ee[117]](we) : this[ee[69]]({ time: Ee });
            }, Te[ee[6]][ee[143]] = function() {
              var Ee = this[ee[47]][ee[144]](this[ee[98]]);
              return Ee ? Ee[0] : null;
            }, Te[ee[6]][ee[145]] = function() {
            }, Te[ee[6]][ee[146]] = function() {
              return -1;
            }, Te[ee[6]][ee[147]] = function() {
              return this[ee[47]][ee[148]]();
            }, Te[ee[6]][ee[149]] = function() {
              var Ee, we = this;
              return this[ee[47]][ee[46]](this[ee[98]]) && (Ee = this[ee[90]](this[ee[98]])), Ee < 0 && (Ee = this[ee[47]][ee[111]](this[ee[119]])[ee[141]][ee[27]](function(Pe) {
                return we[ee[90]](Pe[ee[42]]);
              })[ee[125]](function(Pe) {
                return Pe > 0;
              })), isFinite(Ee) ? [Ee, !0] : [1, !1];
            }, Te[ee[6]][ee[105]] = function() {
              return this[ee[149]]()[0];
            }, Te[ee[6]][ee[150]] = function() {
              this[ee[116]]();
              var Ee = this[ee[47]][ee[46]](this[ee[98]]);
              if (Ee) {
                if (Ee[ee[91]])
                  return this[ee[36]] < Ee[ee[91]][ee[93]][ee[3]];
                if (!this[ee[151]](this[ee[98]]))
                  return !0;
              }
              return !1;
            }, Te[ee[6]][ee[107]] = function() {
              var Ee, we, Pe;
              return (Pe = (we = (Ee = this[ee[47]]) === null || Ee === void 0 ? void 0 : Ee[ee[152]](this[ee[81]])) === null || we === void 0 ? void 0 : we[ee[138]]) !== null && Pe !== void 0 ? Pe : 0;
            }, Te[ee[6]][ee[60]] = function(Ee) {
              var we, Pe;
              this[ee[104]] = Ee;
              var Me = this[ee[149]](), Ae = Me[0], Oe = Me[1];
              if ((Ae < 0 || !Oe) && (this[ee[37]] = Ee), Ae > 0 && Oe && Ee > -1) {
                var Be = Math[ee[153]](Ee - this[ee[107]](), 0), Ve = (we = this[ee[47]]) === null || we === void 0 ? void 0 : we[ee[46]](this[ee[98]]);
                this[ee[98]] && Ve && (this[ee[154]](Math[ee[106]](Be / Ae)), this[ee[35]][ee[59]][ee[115]](ee[159][ee[56]](Ee, ee[158])[ee[56]](this[ee[36]], ee[157])[ee[56]]((Pe = this[ee[98]]) === null || Pe === void 0 ? void 0 : Pe[ee[55]](), ee[156])[ee[56]](Ve[ee[155]], ee[65])));
              }
            }, Te[ee[6]][ee[100]] = function() {
              var Ee = this[ee[47]][ee[152]](this[ee[81]]), we = this[ee[47]][ee[46]](this[ee[98]]), Pe = we && we[ee[109]] ? we[ee[109]][0] : null, Me = 0;
              if (Pe && Pe[ee[5]](ee[160]) && Pe[ee[5]](ee[161])) {
                var Ae = Pe[ee[5]](ee[161]) ? parseInt(Pe[ee[161]]) : 1;
                Me = parseInt(Pe[ee[160]]) / Ae;
              }
              return Ee && (Me -= Ee[ee[138]]), Me;
            }, Te[ee[6]][ee[162]] = function() {
              return this[ee[36]];
            }, Te[ee[6]][ee[154]] = function(Ee) {
              this[ee[36]] = Ee;
            }, Te[ee[6]][ee[163]] = function(Ee) {
            }, Te[ee[6]][ee[126]] = function(Ee) {
              var we = this;
              if (this[ee[151]](Ee))
                return this[ee[35]][ee[59]][ee[115]](ee[164]), Promise[ee[117]](Ee);
              if (this[ee[61]])
                return this[ee[61]][ee[49]](function() {
                })[ee[62]](function() {
                  return we[ee[126]](Ee);
                });
              var Pe = void 0, Me = void 0, Ae = this[ee[47]][ee[46]](Ee);
              if (Ae) {
                if (this[ee[84]][ee[165]]())
                  return;
                this[ee[35]][ee[59]][ee[115]](ee[166][ee[56]](Ee == null ? void 0 : Ee[ee[55]](), ee[65])), Pe = (0, ye[ee[14]])(Ae), Me = Ae[ee[109]][0][ee[21]];
                var Oe = parseInt(Me[ee[29]](ee[28])[1]) + 1;
                return this[ee[52]][ee[51]]((0, ge[ee[167]])(Ae[ee[42]], Oe)), this[ee[45]] = Ee, this[ee[61]] = this[ee[84]][ee[174]](Pe, se[ee[170]][ee[169]], se[ee[172]][ee[171]], null, { Range: ee[173] + Me })[ee[62]](function(Be) {
                  return we[ee[44]](Be[ee[168]]);
                })[ee[49]](this[ee[63]]);
              }
              return this[ee[35]][ee[59]][ee[176]](ee[175][ee[56]](Ee == null ? void 0 : Ee[ee[55]](), ee[65])), Promise[ee[68]](null);
            }, Te[ee[6]][ee[151]] = function(Ee) {
              return this[ee[47]][ee[151]](Ee);
            }, Te[ee[6]][ee[177]] = function() {
              return this[ee[36]]--, !(this[ee[36]] < 0) || (this[ee[35]][ee[59]][ee[115]](ee[178]), this[ee[154]](0), !1);
            }, Te[ee[6]][ee[131]] = function() {
              return { start: 0, end: this[ee[47]][ee[94]]() };
            }, Te[ee[6]][ee[179]] = function() {
              return this[ee[70]];
            }, Te[ee[6]][ee[180]] = function(Ee) {
              this[ee[70]] = Ee;
            }, Te[ee[6]][ee[181]] = function(Ee) {
              return !0;
            }, Te[ee[6]][ee[182]] = function(Ee) {
              return Ee;
            }, Te[ee[6]][ee[183]] = function(Ee) {
              return Ee;
            }, Te[ee[6]][ee[184]] = function() {
              this[ee[72]] = null, this[ee[47]] = null, this[ee[98]] = null, this[ee[52]] = null, this[ee[84]] = (0, _e[ee[184]])(this[ee[84]]), this[ee[70]] = null, this[ee[38]] = null;
            }, Te[ee[6]][ee[185]] = function(Ee, we) {
            }, Te[ee[6]][ee[186]] = function() {
              return this[ee[35]][ee[78]][ee[77]](he[ee[76]][ee[190]])[ee[77]](this[ee[120]])[ee[189]](this[ee[108]](this[ee[45]]))[ee[62]](function(Ee) {
                return Ee[ee[188]]();
              })[ee[62]](function(Ee) {
                return Ee[ee[187]];
              });
            }, Te[ee[6]][ee[191]] = function(Ee, we) {
              return this[ee[186]]()[ee[62]](function(Pe) {
                var Me = ve[ee[195]][ee[77]](me[ee[194]][ee[193]])[ee[192]], Ae = ve[ee[195]][ee[77]](me[ee[194]][ee[193]])[ee[196]], Oe = new Me(Ee), Be = new Ae(Pe[ee[199]]())[ee[198]][ee[197]], Ve = Se(Oe, parseInt(we[ee[109]][0][ee[21]][ee[29]](ee[28])[1]) + 1, Be[ee[200]]() / Be[ee[201]]());
                return { timescale: Be[ee[201]](), references: Ve };
              });
            }, Te[ee[6]][ee[40]] = function(Ee, we) {
              return ee[202] === this[ee[120]][ee[29]](ee[203])[1] ? this[ee[191]](Ee, we) : Promise[ee[117]](this[ee[205]](Ee, we[ee[204]]));
            }, Te[ee[6]][ee[205]] = function(Ee, we) {
              if (!Ee || !we)
                return this[ee[35]][ee[59]][ee[115]](ee[206]), null;
              var Pe = ve[ee[195]][ee[77]](me[ee[194]][ee[211]])[ee[210]](Ee)[ee[209]][ee[125]](function(Me) {
                return ee[207] === Me[ee[208]];
              });
              return Pe ? { timescale: Pe[ee[96]], references: Ce(Pe[ee[93]], Pe[ee[212]] + we, Pe[ee[213]]) } : (this[ee[35]][ee[59]][ee[115]](ee[214]), null);
            }, Te;
          }();
          function Se(Te, Ee, we) {
            for (var Pe = Te[ee[217]][ee[216]](function(Be) {
              return Be[ee[215]];
            }), Me = new Array(Pe[ee[3]]), Ae = Ee - Ie(Te), Oe = Pe[ee[3]] - 1; Oe >= 0; Oe--)
              Me[Oe] = { time: Pe[Oe][ee[99]], byteRange: { start: Ae + Pe[Oe][ee[219]][0][ee[218]] } }, Oe === Pe[ee[3]] - 1 ? Me[Oe][ee[95]] = we - Me[Oe][ee[99]] : (Me[Oe][ee[101]][ee[137]] = Me[Oe + 1][ee[101]][ee[138]] - 1, Me[Oe][ee[95]] = Me[Oe + 1][ee[99]] - Me[Oe][ee[99]]);
            return Me;
          }
          function Ce(Te, Ee, we) {
            for (var Pe = [], Me = 0, Ae = Te; Me < Ae[ee[3]]; Me++) {
              var Oe = Ae[Me], Be = Oe[ee[220]], Ve = Oe[ee[221]], Ue = Ee, Re = Ue + Be - 1;
              Pe[ee[136]]({ byteRange: { start: Ue, end: Re }, time: we, duration: Ve }), Ee += Be, we += Ve;
            }
            return Pe;
          }
          function Ie(Te) {
            var Ee = Te[ee[217]] && Te[ee[217]][0], we = Ee && Ee[ee[215]] && Ee[ee[215]][0], Pe = we && we[ee[219]] && we[ee[219]][0];
            return Pe && Pe[ee[218]] || 0;
          }
          ie[ee[34]] = $e;
        }, 38725: function(ne, ie, ae) {
          Object[ee[9]](ie, ee[8], { value: !0 }), ie[ee[222]] = _e, ie[ee[223]] = le, ie[ee[224]] = se;
          var ce = ae(79814), he = ae(44890);
          function _e(oe) {
            var ue, be = oe[ee[227]][ee[125]](function(me) {
              return ce[ee[226]][ee[225]](me[ee[155]]);
            }), ve = (ue = be == null ? void 0 : be[ee[141]][0]) === null || ue === void 0 ? void 0 : ue[ee[228]];
            return ve == null ? void 0 : ve[0];
          }
          function le(oe) {
            for (var ue, be, ve = parseFloat(String(oe[ee[160]])) || 0, me = (0, he[ee[229]])(oe), pe = 0, fe = 0, ge = (ue = oe[ee[230]]) !== null && ue !== void 0 ? ue : []; fe < ge[ee[3]]; fe++)
              for (var ye = 0, $e = (be = ge[fe][ee[231]]) !== null && be !== void 0 ? be : []; ye < $e[ee[3]]; ye++) {
                var Se = $e[ye], Ce = se(Se[ee[232]]), Ie = parseInt(Se[ee[233]]);
                Se[ee[5]](ee[234]) && (pe = Math[ee[153]](0, se(Se[ee[234]]) - ve)), pe += Ie * (Ce + 1);
              }
            return pe / me;
          }
          function se(oe, ue) {
            return ue === void 0 && (ue = 0), oe ? parseInt(oe) : ue;
          }
        }, 44890: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            return ce = Object[ee[2]] || function(ye) {
              for (var $e, Se = 1, Ce = arguments[ee[3]]; Se < Ce; Se++)
                for (var Ie in $e = arguments[Se])
                  Object[ee[6]][ee[5]][ee[4]]($e, Ie) && (ye[Ie] = $e[Ie]);
              return ye;
            }, ce[ee[7]](this, arguments);
          };
          Object[ee[9]](ie, ee[8], { value: !0 }), ie[ee[235]] = void 0, ie[ee[229]] = ge;
          var he = ae(18665), _e = ae(42055), le = ae(331), se = ae(70016), oe = ae(76885), ue = ae(96953), be = ae(73553), ve = ae(28915), me = ae(5945), pe = ae(92983), fe = function() {
            function ye($e) {
              this[ee[35]] = $e, this[ee[72]] = $e[ee[72]], this[ee[47]] = $e[ee[78]][ee[77]](he[ee[76]][ee[75]], $e[ee[74]][ee[73]]), this[ee[99]] = 0;
            }
            return ye[ee[6]][ee[145]] = function() {
              var $e = this[ee[236]](this[ee[98]]);
              return $e && $e[ee[5]](ee[237]) ? parseInt($e[ee[237]]) : 1;
            }, ye[ee[6]][ee[238]] = function() {
              var $e = this[ee[236]](this[ee[98]]);
              return $e && $e[ee[239]] ? parseInt($e[ee[239]]) : NaN;
            }, ye[ee[6]][ee[118]] = function($e, Se, Ce) {
              Se === void 0 && (Se = null), this[ee[119]] = $e, this[ee[98]] = Se;
              var Ie = !this[ee[98]] || !!this[ee[47]][ee[46]](this[ee[98]]), Te = this[ee[47]][ee[111]](this[ee[119]]);
              this[ee[98]] && Ie || (this[ee[98]] = Te[ee[141]][0][ee[42]]), this[ee[236]](this[ee[98]]) ? this[ee[36]] || this[ee[154]](this[ee[145]]()) : this[ee[35]][ee[59]][ee[115]](ee[240]), this[ee[116]]();
            }, ye[ee[6]][ee[241]] = function() {
              return this[ee[47]][ee[242]](this[ee[98]] || this[ee[119]]);
            }, ye[ee[6]][ee[129]] = function($e) {
              return !!this[ee[47]][ee[46]]($e) && (this[ee[98]] = $e, !0);
            }, ye[ee[6]][ee[108]] = function($e) {
              var Se = this[ee[236]]($e), Ce = this[ee[47]][ee[46]]($e);
              return (0, me[ee[10]])(Se) ? (0, me[ee[13]])(Se, Ce) : null;
            }, ye[ee[6]][ee[243]] = function() {
              var $e = this[ee[236]](this[ee[98]]);
              return parseFloat($e[ee[244]]) || 0;
            }, ye[ee[6]][ee[245]] = function($e) {
              var Se = this[ee[246]]($e);
              return Se -= this[ee[243]](), (0, le[ee[248]])(Se + this[ee[105]]() + this[ee[72]][ee[247]]);
            }, ye[ee[6]][ee[236]] = function($e) {
              var Se = this[ee[47]][ee[46]]($e);
              if (Se != null && Se[ee[228]])
                return Se[ee[228]][0];
            }, ye[ee[6]][ee[107]] = function() {
              var $e;
              return (($e = this[ee[241]]()) === null || $e === void 0 ? void 0 : $e[ee[138]]) || 0;
            }, ye[ee[6]][ee[249]] = function($e) {
              var Se = this[ee[238]]();
              if (isFinite(Se))
                return $e > Se;
              var Ce = this[ee[241]](), Ie = Ce != null && Ce[ee[250]] ? Ce[ee[138]] + Ce[ee[95]] : 1 / 0;
              return this[ee[246]]($e) >= Ie;
            }, ye[ee[6]][ee[251]] = function($e) {
              return this[ee[245]]($e) <= Date[ee[252]]();
            }, ye[ee[6]][ee[97]] = function() {
              var $e = { isInitSegment: !1, presentationTimeOffset: this[ee[100]]() }, Se = this[ee[236]](this[ee[98]]);
              if (!Se || !Se[ee[253]] || !this[ee[47]][ee[254]](this[ee[98]]))
                return null;
              if (this[ee[47]][ee[255]]()) {
                var Ce = this[ee[251]](this[ee[36]]), Ie = this[ee[249]](this[ee[36]]);
                if (!Ce || Ie)
                  return null;
                $e[ee[256]] = this[ee[245]](this[ee[36]]) - (0, le[ee[248]])(this[ee[105]]());
              }
              var Te = this[ee[47]][ee[46]](this[ee[98]]);
              return $e[ee[81]] = Te == null ? void 0 : Te[ee[42]][ee[81]], $e[ee[133]] = (0, pe[ee[22]])(Se[ee[253]], Te, this[ee[36]], this[ee[99]]), $e[ee[102]] = (0, ve[ee[103]])($e), $e[ee[257]] = this[ee[36]], $e[ee[139]] = this[ee[246]](this[ee[36]]), this[ee[154]](this[ee[36]] + 1), $e;
            }, ye[ee[6]][ee[142]] = function($e) {
              var Se = this[ee[97]]();
              return Se ? Promise[ee[117]](Se) : this[ee[69]]({ time: $e });
            }, ye[ee[6]][ee[69]] = function($e) {
              var Se = this;
              return this[ee[70]] ? Promise[ee[68]](ee[71]) : new Promise(function(Ce, Ie) {
                Se[ee[70]] = ce(ce({}, $e), { resolve: Ce, reject: Ie });
              });
            }, ye[ee[6]][ee[116]] = function() {
              if (this[ee[70]]) {
                var $e = this[ee[97]](), Se = this[ee[249]](this[ee[36]]);
                $e ? (this[ee[70]][ee[117]]($e), this[ee[70]] = null) : Se && (this[ee[70]][ee[68]](be[ee[259]][ee[258]]), this[ee[70]] = null);
              }
            }, ye[ee[6]][ee[130]] = function($e) {
              var Se = this, Ce = {};
              return this[ee[47]][ee[111]](this[ee[98]])[ee[141]][ee[140]](function(Ie) {
                var Te, Ee, we, Pe = Ie[ee[42]], Me = Se[ee[236]](Pe), Ae = [], Oe = Se[ee[131]]()[ee[137]] - Se[ee[131]]()[ee[138]], Be = 0, Ve = Se[ee[47]][ee[255]]();
                Ve ? (we = Se[ee[99]] - Oe, Te = Se[ee[36]] - Oe / Se[ee[105]](), Ee = Se[ee[36]]) : (we = Me[ee[160]] || 0, Te = 0, Ee = parseInt(Te + Oe / Se[ee[105]]()));
                for (var Ue = Te; Ue <= Ee; Ue++) {
                  var Re = {};
                  Re[ee[95]] = Se[ee[105]](), Re[ee[139]] = Ve ? Se[ee[246]](Ue) : Be * Se[ee[105]]();
                  var Ne = (0, pe[ee[22]])(Me[ee[253]], Ie, Te + Be, we + Be * Se[ee[105]]());
                  Re[ee[133]] = $e ? oe[ee[24]][ee[23]]($e, Ne) : Ne, Re[ee[133]] = oe[ee[24]][ee[135]](Re[ee[133]], Se[ee[72]][ee[134]]), Ae[ee[136]](Re), Be++;
                }
                Ce[Pe[ee[41]]] = Ae;
              }), Ce;
            }, ye[ee[6]][ee[143]] = function() {
              var $e = this[ee[47]][ee[46]](this[ee[98]])[ee[30]][0];
              return $e[ee[133]] || $e;
            }, ye[ee[6]][ee[260]] = function() {
              var $e = this[ee[236]](this[ee[98]]);
              return $e && $e[ee[5]](ee[261]);
            }, ye[ee[6]][ee[262]] = function() {
              if (this[ee[260]]()) {
                var $e = this[ee[236]](this[ee[98]]);
                return parseInt($e[ee[261]]);
              }
            }, ye[ee[6]][ee[105]] = function() {
              var $e = this[ee[236]](this[ee[98]]), Se = Number($e == null ? void 0 : $e[ee[250]]), Ce = Number($e == null ? void 0 : $e[ee[161]]);
              return isNaN(Se) ? 1 : isNaN(Ce) ? Se : Se / Ce;
            }, ye[ee[6]][ee[60]] = function($e) {
              $e > -1 && this[ee[154]](this[ee[263]]($e));
            }, ye[ee[6]][ee[264]] = function() {
              return ge(this[ee[236]](this[ee[98]]));
            }, ye[ee[6]][ee[246]] = function($e) {
              var Se = this[ee[107]]();
              return ($e - this[ee[145]]()) * this[ee[105]]() + Se;
            }, ye[ee[6]][ee[263]] = function($e) {
              var Se = this[ee[105]](), Ce = this[ee[107]](), Ie = Math[ee[153]]($e - Ce - Se / 2, 0);
              return Math[ee[106]](Ie / Se) + this[ee[145]]();
            }, ye[ee[6]][ee[147]] = function() {
              var $e = this[ee[265]]();
              return $e[ee[137]] - $e[ee[138]];
            }, ye[ee[6]][ee[265]] = function() {
              var $e = (0, _e[ee[268]])(this[ee[267]]()[ee[266]]()), Se = this[ee[47]][ee[94]]() || 1 / 0;
              return this[ee[47]][ee[255]]() ? this[ee[269]](Se) : this[ee[270]]($e, Se);
            }, ye[ee[6]][ee[267]] = function() {
              return this[ee[35]][ee[78]][ee[77]](he[ee[76]][ee[89]], this[ee[35]][ee[74]][ee[73]]);
            }, ye[ee[6]][ee[270]] = function($e, Se) {
              return { start: $e, end: isFinite(Se) ? $e + Se : 0 };
            }, ye[ee[6]][ee[269]] = function($e) {
              var Se = (this[ee[47]][ee[79]]() || { start: 0 })[ee[138]], Ce = -1 * this[ee[47]][ee[148]](), Ie = (0, le[ee[272]])(Date[ee[252]]() - this[ee[47]][ee[271]]()), Te = Math[ee[273]](Ce, Ie), Ee = this[ee[146]]();
              return { start: Math[ee[153]](Se, Ee - Te), end: Ee };
            }, ye[ee[6]][ee[131]] = function() {
              var $e = this[ee[265]]();
              if (this[ee[47]][ee[255]]()) {
                var Se = this[ee[47]][ee[274]]();
                $e[ee[137]] = Math[ee[153]]($e[ee[137]] - Se, $e[ee[138]]);
              }
              return $e;
            }, ye[ee[6]][ee[150]] = function($e) {
              var Se = this[ee[249]](this[ee[36]]), Ce = Math[ee[275]]($e / this[ee[105]]()) + this[ee[145]]() - 1;
              return !Se && this[ee[36]] <= Ce;
            }, ye[ee[6]][ee[100]] = function() {
              var $e = this[ee[241]](), Se = 0, Ce = this[ee[236]](this[ee[98]]);
              return Ce && Ce[ee[160]] && (Se = Ce[ee[160]] / this[ee[264]]()), $e && (Se -= $e[ee[138]]), Se;
            }, ye[ee[6]][ee[92]] = function($e, Se) {
              var Ce = this[ee[47]][ee[242]]($e) || this[ee[241]]();
              return this[ee[47]][ee[276]]($e[ee[81]]) ? Ce && (0, se[ee[277]])(Ce[ee[95]]) && isFinite(Ce[ee[95]]) ? Ce[ee[95]] : Ce && Ce[ee[138]] ? (0, le[ee[272]])(Se) - Ce[ee[138]] : this[ee[47]][ee[278]]($e[ee[81]]) : this[ee[47]][ee[92]]($e[ee[81]]);
            }, ye[ee[6]][ee[279]] = function($e) {
              var Se = Date[ee[252]](), Ce = (0, le[ee[272]])(Se - this[ee[47]][ee[280]]());
              return this[ee[260]]() ? this[ee[262]]() + Math[ee[106]](Ce / this[ee[105]]()) : this[ee[47]][ee[255]]() && this[ee[47]][ee[282]]()[ee[281]] ? Math[ee[106]](this[ee[92]]($e, Se) / this[ee[105]]() + this[ee[145]]()) : this[ee[145]]();
            }, ye[ee[6]][ee[283]] = function($e) {
              return Math[ee[153]](this[ee[279]]($e), this[ee[145]]());
            }, ye[ee[6]][ee[162]] = function() {
              return this[ee[36]];
            }, ye[ee[6]][ee[154]] = function($e) {
              this[ee[36]] = $e;
            }, ye[ee[6]][ee[146]] = function() {
              return (0, le[ee[272]])(Date[ee[252]]());
            }, ye[ee[6]][ee[163]] = function($e, Se) {
              if (Se === void 0 && (Se = this[ee[98]][ee[81]]), this[ee[47]][ee[255]]()) {
                var Ce = this[ee[36]], Ie = this[ee[283]](new ue[ee[284]](Se));
                $e === 0 ? (this[ee[154]](Ie), this[ee[35]][ee[59]][ee[115]](ee[285] + Ce + ee[286] + this[ee[36]] + ee[287])) : (this[ee[154]](Ie + Math[ee[106]]($e / this[ee[105]]())), this[ee[36]] < this[ee[145]]() && this[ee[154]](this[ee[145]]()), this[ee[35]][ee[59]][ee[115]](ee[285] + Ce + ee[286] + this[ee[36]]));
              }
            }, ye[ee[6]][ee[126]] = function($e) {
              return this[ee[98]] = $e, Promise[ee[117]]($e);
            }, ye[ee[6]][ee[151]] = function($e) {
              return !0;
            }, ye[ee[6]][ee[177]] = function() {
              return this[ee[154]](this[ee[36]] - 1), this[ee[36]] < this[ee[145]]() && (this[ee[35]][ee[59]][ee[115]](ee[288]), this[ee[154]](this[ee[145]]())), !0;
            }, ye[ee[6]][ee[179]] = function() {
              return this[ee[70]];
            }, ye[ee[6]][ee[180]] = function($e) {
              this[ee[70]] = $e;
            }, ye[ee[6]][ee[181]] = function($e) {
              return !0;
            }, ye[ee[6]][ee[182]] = function($e) {
              return $e;
            }, ye[ee[6]][ee[183]] = function($e) {
              return $e;
            }, ye[ee[6]][ee[184]] = function() {
              this[ee[72]] = null, this[ee[47]] = null, this[ee[98]] = null, this[ee[119]] = null, this[ee[70]] = null;
            }, ye[ee[6]][ee[185]] = function($e, Se) {
            }, ye;
          }();
          function ge(ye) {
            return ye && ye[ee[161]] != null && parseInt(ye[ee[161]]) || 1;
          }
          ie[ee[235]] = fe;
        }, 51040: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            return ce = Object[ee[2]] || function(Ve) {
              for (var Ue, Re = 1, Ne = arguments[ee[3]]; Re < Ne; Re++)
                for (var xe in Ue = arguments[Re])
                  Object[ee[6]][ee[5]][ee[4]](Ue, xe) && (Ve[xe] = Ue[xe]);
              return Ve;
            }, ce[ee[7]](this, arguments);
          }, he = this && this[ee[289]] || function(Ve, Ue, Re, Ne) {
            var xe, ke = arguments[ee[3]], Le = ke < 3 ? Ue : Ne === null ? Ne = Object[ee[290]](Ue, Re) : Ne;
            if (ee[291] == typeof Reflect && ee[292] == typeof Reflect[ee[293]])
              Le = Reflect[ee[293]](Ve, Ue, Re, Ne);
            else
              for (var He = Ve[ee[3]] - 1; He >= 0; He--)
                (xe = Ve[He]) && (Le = (ke < 3 ? xe(Le) : ke > 3 ? xe(Ue, Re, Le) : xe(Ue, Re)) || Le);
            return ke > 3 && Le && Object[ee[9]](Ue, Re, Le), Le;
          };
          Object[ee[9]](ie, ee[8], { value: !0 }), ie[ee[30]] = ie[ee[294]] = void 0, ie[ee[295]] = Ee, ie[ee[296]] = we;
          var _e = ae(63546), le = ae(35148), se = ae(62510), oe = ae(92737), ue = ae(16937), be = ae(33696), ve = ae(42283), me = ae(44388), pe = ae(26190), fe = ae(79814), ge = ae(76885), ye = ae(91520), $e = ae(16368), Se = new RegExp(ee[297], ee[298]), Ce = [ee[299], ee[300], ee[301], ee[244], ee[302]], Ie = ee[303], Te = function() {
            function Ve(Ue, Re) {
              this[ee[35]] = Ue, this[ee[74]] = Re, this[ee[304]] = Ue[ee[304]];
              var Ne = ye[ee[195]][ee[77]]($e[ee[194]][ee[305]]);
              this[ee[306]] = Ne[ee[306]], this[ee[307]] = Ne[ee[307]];
            }
            return Ve[ee[6]][ee[308]] = function(Ue, Re) {
              return (0, pe[ee[312]])({ source: this[ee[74]][ee[309]], context: this[ee[35]], streamType: be[ee[311]][ee[310]], labelingType: Ue }, Re);
            }, Ve[ee[6]][ee[313]] = function(Ue) {
              var Re, Ne, xe, ke = (xe = (Ne = (Re = Ue[ee[314]]) === null || Re === void 0 ? void 0 : Re[0]) === null || Ne === void 0 ? void 0 : Ne[ee[187]]) !== null && xe !== void 0 ? xe : Ue[ee[315]], Le = { mimeType: Ue[ee[155]], lang: Ue[ee[316]] };
              return this[ee[308]](pe[ee[318]][ee[317]], Le) || ke;
            }, Ve[ee[6]][ee[319]] = function(Ue, Re) {
              var Ne, xe, ke, Le = (ke = (xe = (Ne = Re[ee[314]]) === null || Ne === void 0 ? void 0 : Ne[0]) === null || xe === void 0 ? void 0 : xe[ee[187]]) !== null && ke !== void 0 ? ke : Re[ee[315]], He = { id: Re[ee[82]], mimeType: Ue, bitrate: Re[ee[123]], qualityRanking: Re[ee[320]], width: Re[ee[321]], height: Re[ee[322]], frameRate: Re[ee[323]] };
              return this[ee[308]](pe[ee[318]][ee[324]], He) || Le;
            }, Ve[ee[6]][ee[325]] = function(Ue) {
              var Re = this, Ne = 0;
              for (var xe in Ue)
                if (Ue[ee[5]](xe)) {
                  if (ee[326] === xe && this[ee[327]](Ue, Ue[xe]), ee[328] === xe && Oe(Ue[xe]))
                    return this[ee[35]][ee[59]][ee[115]](ee[331][ee[56]](Ue[ee[82]], ee[330])[ee[56]](Ue[ee[329]])), null;
                  ee[314] === xe && (Ue[ee[314]] = Ae(Ue[xe])), ee[228] === xe && this[ee[332]](Ue[xe]), ee[228] === xe || xe[ee[334]](ee[333]) === 0 || Array[ee[20]](Ue[xe]) || (Ue[xe] = [Ue[xe]]), ee[141] === xe && (Ue[xe] = Ue[xe][ee[347]](function(ke) {
                    var Le = ke[ee[155]] || Ue[ee[155]];
                    ke[ee[155]] = ke[ee[155]] || Ue[ee[155]], Le && (Le = Le[ee[335]]()), Ee(ke, Ue), Pe(ke), Me(ke), ee[336] == typeof ke[ee[123]] && (ke[ee[123]] = parseFloat(ke[ee[123]])), ke[ee[314]] && (ke[ee[314]] = Ae(ke[ee[314]])), ke[ee[228]] && Re[ee[332]](ke[ee[228]]);
                    var He = ke[ee[337]] || Ue[ee[337]];
                    if (Le && (Le[ee[334]](ee[338]) === 0 || Le[ee[334]](ee[339]) === 0 || Le[ee[334]](ee[340]) === 0 || Le[ee[334]](ee[341]) >= 0))
                      Ne++, ke[ee[315]] = Re[ee[319]](Le, ke);
                    else if (Le && He) {
                      if (ke[ee[337]] = He, !ve[ee[343]][ee[342]](Re[ee[304]], Le, He))
                        return Re[ee[35]][ee[59]][ee[115]](ee[344] + Le + ee[345] + He + ee[346]), !1;
                      Ne++, ke[ee[315]] = Re[ee[319]](Le, ke);
                    }
                    return !0;
                  }));
                }
              return Ne > 0 ? (!Ue[ee[5]](ee[155]) && Ue[ee[141]][0][ee[5]](ee[155]) && (Ue[ee[155]] = Ue[ee[141]][0][ee[155]]), Ue[ee[315]] = this[ee[313]](Ue), Ue[ee[141]][ee[348]](function(ke, Le) {
                return ke[ee[123]] - Le[ee[123]];
              }), Ue) : (this[ee[35]][ee[59]][ee[115]](ee[350][ee[56]](Ue[ee[82]], ee[330])[ee[56]](Ue[ee[329]], ee[349])), null);
            }, Ve[ee[6]][ee[327]] = function(Ue, Re) {
              var Ne = 2;
              Ue[ee[351]] = {};
              var xe = Ve[ee[353]](Re, ee[352]);
              Ve[ee[356]](xe)[ee[140]](function(ke, Le) {
                var He = ke[ee[29]](ee[354]), We = He[ee[3]] === Ne ? [He[0], He[1]] : [ee[355] + Le, ke], Xe = We[0], Qe = We[1];
                Ue[ee[351]][Xe] = { label: Qe, lang: Qe };
              });
            }, Ve[ee[6]][ee[332]] = function(Ue) {
              Ue[ee[140]](function(Re) {
                var Ne, xe;
                if (Re[ee[5]](ee[230])) {
                  var ke = Number((Ne = Re[ee[161]]) !== null && Ne !== void 0 ? Ne : ee[357]);
                  (xe = Re[ee[230]]) === null || xe === void 0 || xe[ee[140]](function(Le) {
                    var He = Le[ee[231]][ee[359]](function(We, Xe) {
                      var Qe;
                      return We + Number(Xe[ee[233]]) * (Number((Qe = Xe[ee[232]]) !== null && Qe !== void 0 ? Qe : ee[358]) + 1);
                    }, 0);
                    Le[ee[360]] = He / ke;
                  });
                }
              });
            }, Ve[ee[353]] = function(Ue, Re) {
              return Ue && Ue[ee[3]] > 0 ? Ue[ee[347]](function(Ne) {
                return Ne[ee[361]] === Re;
              }) : [];
            }, Ve[ee[356]] = function(Ue) {
              var Re = [];
              return Ue[ee[140]](function(Ne) {
                if (Ne[ee[362]]) {
                  var xe = Ne[ee[362]][ee[29]](ee[363]);
                  Re[ee[136]][ee[7]](Re, xe);
                }
              }), Re;
            }, Ve[ee[6]][ee[364]] = function(Ue, Re) {
              for (var Ne = 0; Ne < Ue[ee[3]]; Ne++)
                if (ee[336] == typeof Re && Ue[Ne][ee[133]] === Re || ee[291] == typeof Re && Ue[Ne][ee[133]] === Re[ee[133]])
                  return !0;
              return !1;
            }, Ve[ee[6]][ee[365]] = function(Ue, Re, Ne, xe) {
              var ke;
              Array[ee[20]](Ue[ee[30]]) || (Ue[ee[30]] = [Ue[ee[30]]]);
              for (var Le = [], He = 0; He < Ue[ee[30]][ee[3]]; He++) {
                if ((ke = new Be())[ee[366]] = [], Re != null && (ke[ee[367]] = {}, Re[0] !== void 0 && Re[0] !== null && (ke[ee[367]][ee[368]] = Re[0]), Re[1] !== void 0 && Re[1] !== null && (ke[ee[367]][ee[369]] = Re[1]), Re[2] !== void 0 && Re[2] !== null && (ke[ee[367]][ee[370]] = Re[2])), ee[336] == typeof Ue[ee[30]][He])
                  ke[ee[133]] = Ue[ee[30]][He];
                else if (ee[291] == typeof Ue[ee[30]][He]) {
                  for (var We in Ue[ee[30]][He][ee[5]](ee[299]) && (ke[ee[133]] = Ue[ee[30]][He][ee[299]]), Ue[ee[30]][He][ee[5]](ee[301]) && (ke[ee[371]] = Ue[ee[30]][He][ee[301]]), Ue[ee[30]][He][ee[5]](ee[300]) && (ke[ee[371]] = Ue[ee[30]][He][ee[300]]), Ue[ee[30]][He][ee[5]](ee[244]) && (ke[ee[371]] = Ue[ee[30]][He][ee[244]]), Ue[ee[30]][He][ee[5]](ee[302]) && (ke[ee[371]] = Ue[ee[30]][He][ee[302]]), Ue[ee[30]][He])
                    if (Ue[ee[30]][He][ee[5]](We) && We[ee[334]](ee[333]) === 0 && Ce[ee[334]](We) === -1) {
                      var Xe = {};
                      Xe[We[ee[372]](1)] = Ue[ee[30]][He][We], ke[ee[366]][ee[136]](Xe);
                    }
                }
                Le[ee[136]](ke);
              }
              for (Ue[ee[30]] = [], He = 0; He < Le[ee[3]]; He++) {
                var Qe = Le[He];
                if (ge[ee[24]][ee[373]](Qe))
                  this[ee[364]](Ue[ee[30]], Qe) || (Qe[ee[374]] = !0, xe[ee[136]](Qe), Ue[ee[30]][ee[136]](Qe));
                else
                  for (var tt = 0; tt < Ne[ee[3]]; tt++) {
                    var Je = Ne[tt][ee[375]]();
                    ee[203] !== Ne[tt][ee[133]][Ne[tt][ee[133]][ee[3]] - 1] && (Je += ee[203]);
                    var Ge = ge[ee[24]][ee[376]](Je, Qe);
                    this[ee[364]](Ue[ee[30]], Ge) || ((ke = new Be())[ee[133]] = Ge, ke[ee[367]] = {}, Re[0] !== void 0 && Re[0] !== null && (ke[ee[367]][ee[368]] = Re[0]), Re[1] !== void 0 && Re[1] !== null && (ke[ee[367]][ee[369]] = Re[1]), Re[2] !== void 0 && Re[2] !== null && (ke[ee[367]][ee[370]] = Re[2]), ke[ee[371]] = Qe[ee[371]] || Ne[tt][ee[371]], ke[ee[101]] = Qe[ee[101]] || Ne[tt][ee[101]], ke[ee[377]] = Qe[ee[377]] || Ne[tt][ee[377]], ke[ee[378]] = Qe[ee[378]] || Ne[tt][ee[378]], Ue[ee[30]][ee[136]](ke), xe[ee[136]](ke));
                  }
              }
              return xe;
            }, Ve[ee[6]][ee[379]] = function(Ue, Re, Ne) {
              var xe = [];
              if (Re = Re || [], Ne = Ne || [], ee[291] != typeof Ue)
                return Ue;
              for (var ke in Ue[ee[5]](ee[30]) && (xe = this[ee[365]](Ue, Ne, Re, xe)), xe[ee[3]] < 1 && (xe = Re), Ue)
                if (Ue[ee[5]](ke))
                  if (ee[291] == typeof Ue[ke] && ke[ee[334]](ee[333]) !== 0) {
                    Array[ee[20]](Ue[ke]) || (Ue[ke] = [Ue[ke]]);
                    for (var Le = 0; Le < Ue[ke][ee[3]]; Le++)
                      if (ee[30] !== ke) {
                        var He = Ue[ke][Le][ee[82]] || Le + ee[32];
                        Ue[ke][Le] = this[ee[379]](Ue[ke][Le], xe, Ne[ee[56]]([He])), ee[141] !== ke || Ue[ke][Le][ee[5]](ee[30]) || (Ue[ke][Le][ee[30]] = xe);
                      }
                  } else
                    ke[ee[334]](ee[333]) !== 0 || !Se[ee[380]](ke) && ee[381] !== ke || (Ue[ee[315]] = Ue[ke], ee[315] !== ke && delete Ue[ke]);
              return Ue;
            }, Ve[ee[6]][ee[382]] = function(Ue) {
              var Re = me[ee[385]][ee[384]](Ue[ee[383]]);
              return (Re = isNaN(Re) ? Number[ee[386]] : -Re) > 0 && Re < this[ee[35]][ee[388]][ee[387]]() && (Re = this[ee[35]][ee[388]][ee[387]]()), Re;
            }, Ve[ee[389]] = function(Ue) {
              Array[ee[20]](Ue[ee[390]]) || (Ue[ee[390]] = [Ue[ee[390]]]);
              for (var Re, Ne = [], xe = [], ke = [], Le = [], He = [], We = [], Xe = Ue[ee[390]], Qe = 0; Qe < Xe[ee[3]]; Qe++) {
                Xe[Qe][ee[5]](ee[82]) && Xe[Qe][ee[82]] ? Ne[ee[136]](Xe[Qe][ee[82]]) : Le[ee[136]](Xe[Qe]), Array[ee[20]](Xe[Qe][ee[227]]) || (Xe[Qe][ee[227]] = [Xe[Qe][ee[227]]]);
                for (var tt = Xe[Qe][ee[227]], Je = 0; Je < tt[ee[3]]; Je++) {
                  tt[Je][ee[5]](ee[82]) && tt[Je][ee[82]] ? xe[ee[136]](tt[Je][ee[82]]) : He[ee[136]](tt[Je]), tt[Je][ee[329]] = Xe[Qe][ee[82]], Array[ee[20]](tt[Je][ee[141]]) || (tt[Je][ee[141]] = [tt[Je][ee[141]]]);
                  for (var Ge = tt[Je][ee[141]], Ye = 0; Ye < Ge[ee[3]]; Ye++)
                    Ge[Ye][ee[5]](ee[82]) && Ge[Ye][ee[82]] ? ke[ee[136]](Ge[Ye][ee[82]]) : We[ee[136]](Ge[Ye]);
                }
              }
              var ze = 0;
              for (Re = 0; Re < Le[ee[3]]; Re++) {
                do
                  ze++;
                while (Ne[ee[334]](ee[32] + ze) !== -1);
                Le[Re][ee[82]] = ee[32] + ze, Le[Re][ee[227]][ee[140]](function(Fe) {
                  Fe[ee[329]] = Le[Re][ee[82]];
                }), Ne[ee[136]](ee[32] + ze);
              }
              for (ze = 0, Re = 0; Re < He[ee[3]]; Re++) {
                do
                  ze++;
                while (xe[ee[334]](ee[32] + ze) !== -1);
                He[Re][ee[82]] = ee[32] + ze, xe[ee[136]](ee[32] + ze);
              }
              for (ze = 0, Re = 0; Re < We[ee[3]]; Re++) {
                do
                  ze++;
                while (ke[ee[334]](ee[32] + ze) !== -1);
                We[Re][ee[82]] = ee[32] + ze, ke[ee[136]](ee[32] + ze);
              }
            }, Ve[ee[6]][ee[391]] = function(Ue) {
              return ee[392] === Ue[ee[393]] && (Ue[ee[383]] = this[ee[382]](Ue)), Ue;
            }, Ve[ee[6]][ee[394]] = function(Ue) {
              return Ue[ee[395]] && (Ue[ee[395]] = new Date(Ue[ee[395]])[ee[396]]()), Ue;
            }, Ve[ee[6]][ee[397]] = function(Ue, Re) {
              return Ue[ee[5]](ee[398]) ? Array[ee[20]](Ue[ee[398]]) || (Ue[ee[398]] = [Ue[ee[398]]]) : Ue[ee[398]] = [Re], Ue;
            }, Ve[ee[6]][ee[399]] = function(Ue) {
              Ue[ee[5]](ee[30]) && !Array[ee[20]](Ue[ee[30]]) && (Ue[ee[30]] = [Ue[ee[30]]]);
              for (var Re = [], Ne = 0; Ne < Ue[ee[398]][ee[3]]; Ne++) {
                var xe = Ue[ee[398]][Ne], ke = new Be();
                ke[ee[133]] = ge[ee[24]][ee[400]](xe), Re[ee[136]](ke);
              }
              return Ue = this[ee[379]](Ue, Re, null);
            }, Ve[ee[6]][ee[401]] = function(Ue, Re) {
              Re[ee[402]] ? Re[ee[138]] = me[ee[385]][ee[384]](Re[ee[402]]) : (Re[ee[138]] = Ue[ee[138]] + Ue[ee[95]], Re[ee[402]] = ee[403] + Re[ee[138]] + ee[231]);
            }, Ve[ee[6]][ee[404]] = function(Ue) {
              for (var Re = { start: 0, duration: 0, _start: ee[405], _duration: ee[405] }, Ne = 0; Ne < Ue[ee[390]][ee[3]]; Ne++) {
                var xe = Ue[ee[390]][Ne];
                this[ee[401]](Re, xe), xe[ee[250]] ? xe[ee[95]] = me[ee[385]][ee[384]](xe[ee[250]]) : (Ue[ee[390]][Ne + 1] ? xe[ee[95]] = (me[ee[385]][ee[384]](Ue[ee[390]][Ne + 1][ee[402]]) || 0) - xe[ee[138]] : Ue[ee[406]] ? xe[ee[95]] = (me[ee[385]][ee[384]](Ue[ee[406]]) || 0) - xe[ee[138]] : xe[ee[95]] = 1 / 0, xe[ee[250]] = ee[403] + xe[ee[95]] + ee[231]), this[ee[35]][ee[59]][ee[115]](ee[409][ee[56]](Ne, ee[408])[ee[56]](xe[ee[82]], ee[407])[ee[56]](xe[ee[138]], ee[28])[ee[56]](xe[ee[138]] + xe[ee[95]])), Ue[ee[390]][Ne] = xe, Re = xe;
              }
              return Ue;
            }, Ve[ee[6]][ee[410]] = function(Ue) {
              var Re, Ne, xe = this, ke = [], Le = [], He = me[ee[385]][ee[384]](Ue[ee[406]]);
              return Ue[ee[390]][ee[140]](function(We, Xe) {
                Re = me[ee[385]][ee[384]](We[ee[402]]), Ne = me[ee[385]][ee[384]](We[ee[250]]), isNaN(Re) && Le[ee[3]] === 0 && ee[411] === Ue[ee[393]] && (Re = 0), isNaN(Re) && Le[ee[3]] > 0 && !isNaN(parseFloat(Le[Le[ee[3]] - 1][ee[138]])) && !isNaN(parseFloat(Le[Le[ee[3]] - 1][ee[95]])) && (Re = Le[Le[ee[3]] - 1][ee[138]] + Le[Le[ee[3]] - 1][ee[95]]), isNaN(Re) && Xe === Ue[ee[390]][ee[3]] - 1 && !isNaN(He) && (Ne = He - Re), Le[ee[3]] > 0 && isNaN(parseFloat(Le[Le[ee[3]] - 1][ee[95]])) && !isNaN(Re) && (Le[Le[ee[3]] - 1][ee[95]] = Re - Le[Le[ee[3]] - 1][ee[138]]), Le[ee[136]]({ start: Re, duration: Ne });
                var Qe = function(Je) {
                  if (We[ee[5]](Je) && [ee[30], ee[227], ee[413]][ee[412]](Je))
                    if (Array[ee[20]](We[Je]) || (We[Je] = [We[Je]]), ee[227] === Je) {
                      var Ge = We[Je][ee[27]](function(Ye) {
                        var ze = Ye[ee[155]];
                        return !ze && Ye[ee[141]][ee[3]] > 0 && (ze = Ye[ee[141]][0][ee[155]]), fe[ee[226]][ee[414]](ze);
                      })[ee[347]](function(Ye, ze, Fe) {
                        return Fe[ee[334]](Ye) === ze;
                      });
                      We[Je] = We[Je][ee[27]](function(Ye) {
                        Ee(Ye, We);
                        var ze = xe[ee[325]](Ye);
                        return ze !== null && !ze[ee[5]](ee[415]) && ze[ee[141]][0][ee[5]](ee[415]) && (ze[ee[415]] = ze[ee[141]][0][ee[415]]), ze;
                      })[ee[347]](function(Ye) {
                        return !!Ye;
                      }), Ge[ee[347]](function(Ye) {
                        return ee[424] === Ye || ee[425] === Ye;
                      })[ee[140]](function(Ye) {
                        !We[Je][ee[416]](function(ze) {
                          return ze[ee[155]][ee[412]](Ye);
                        }) && xe[ee[35]][ee[423]][ee[422]](se[ee[418]][ee[417]], new _e[ee[421]](le[ee[420]][ee[419]]));
                      }), We[Je][ee[3]] < 1 && ke[ee[136]](Xe);
                    } else
                      ee[413] === Je && We[Je][ee[347]](function(Ye) {
                        return Ye[ee[427]];
                      })[ee[140]](function(Ye) {
                        Ye[ee[427]][ee[140]](function(ze) {
                          ze[ee[426]] = xe[ee[307]]({ event: ze });
                        });
                      });
                };
                for (var tt in We)
                  Qe(tt);
              }), ke[ee[3]] > 0 && ee[411] === Ue[ee[393]] && this[ee[428]](ke, Le, He, Ue), Ue = this[ee[404]](Ue);
            }, Ve[ee[6]][ee[428]] = function(Ue, Re, Ne, xe) {
              for (var ke, Le, He; !isNaN(parseInt(ke = Ue[ee[429]]())); ) {
                if (Le = Re[ke][ee[138]], He = Re[ke][ee[95]], !isNaN(Le) && !isNaN(He)) {
                  isNaN(Ne) || (Ne -= He, xe[ee[406]] = ee[403] + Ne + ee[231]);
                  for (var We = ke + 1; We < Re[ee[3]]; We++)
                    isNaN(parseFloat(Re[We][ee[138]])) || (Re[We][ee[138]] = Re[We][ee[138]] - He, xe[ee[390]][We][ee[402]] = ee[403] + Re[We][ee[138]] + ee[231]);
                }
                Re[ee[430]](ke, 1), xe[ee[390]][ee[430]](ke, 1);
              }
            }, Ve[ee[431]] = function(Ue) {
              Ue[ee[5]](ee[432]) && !Array[ee[20]](Ue[ee[432]]) && (Ue[ee[432]] = [Ue[ee[432]]]);
              var Re = [];
              return (Ue[ee[432]] || [])[ee[347]](function(Ne) {
                return Ne[ee[5]](ee[361]) && ee[336] == typeof Ne[ee[361]];
              })[ee[140]](function(Ne) {
                var xe = { schemeIdUri: Ne[ee[361]], value: ee[32] };
                ee[336] == typeof Ne[ee[362]] && (xe[ee[187]] = Ne[ee[362]]), Re[ee[136]](xe);
              }), Re[ee[3]] > 0 ? Ue[ee[432]] = Re : delete Ue[ee[432]], Ue;
            }, Ve[ee[6]][ee[433]] = function(Ue, Re, Ne) {
              var xe, ke = this[ee[306]](Ue, { decodeEntities: !0 });
              if (ke[ee[434]] === !1)
                throw new oe[ee[440]](oe[ee[436]][ee[435]], { errorMessage: ke[ee[438]][ee[437]] }, ee[439]);
              var Le = ke[ee[442]][ee[441]];
              return Le[ee[443]] = Date[ee[252]](), Le[ee[444]] = Ne, Le[ee[393]] = (xe = Le[ee[393]]) !== null && xe !== void 0 ? xe : ee[411], Ve[ee[389]](Le), Le = this[ee[391]](Le), Le = this[ee[394]](Le), Le = this[ee[397]](Le, Re), Le = this[ee[399]](Le), Le = this[ee[410]](Le), (Le = Ve[ee[431]](Le)) && Le[ee[390]] && Le[ee[390]][ee[3]] !== 0 ? (Le[ee[445]] = Ue, Le) : (this[ee[35]][ee[423]][ee[446]](new oe[ee[440]](oe[ee[436]][ee[435]])), null);
            }, Ve[ee[6]][ee[184]] = function() {
              this[ee[304]] = null;
            }, he([(0, ue[ee[448]])(ee[447])], Ve[ee[6]], ee[433], null), Ve;
          }();
          function Ee(Ve, Ue) {
            if (Ve && Ue) {
              var Re = [ee[109], ee[449], ee[228]];
              Re[ee[140]](function(Ne) {
                var xe = Array[ee[20]](Ve[Ne]) && Ve[Ne][0], ke = Array[ee[20]](Ue[Ne]) && Ue[Ne][0], Le = Re[ee[125]](function(He) {
                  return Ve[He];
                });
                ke && xe ? Ve[Ne] = [ce(ce({}, Ue[Ne][0]), Ve[Ne][0])] : ke && !Le && (Ve[Ne] = Ue[Ne]);
              });
            }
          }
          function we(Ve) {
            var Ue = Ve[ee[29]](ee[203]);
            return parseInt(Ue[0]) / (parseInt(Ue[1]) || 1);
          }
          function Pe(Ve) {
            ee[336] == typeof Ve[ee[450]] && (Ve[ee[450]] = parseFloat(Ve[ee[450]]));
          }
          function Me(Ve) {
            ee[336] == typeof Ve[ee[322]] && (Ve[ee[322]] = parseFloat(Ve[ee[322]])), ee[336] == typeof Ve[ee[321]] && (Ve[ee[321]] = parseFloat(Ve[ee[321]])), ee[336] == typeof Ve[ee[451]] && (Ve[ee[451]] = we(Ve[ee[451]]));
          }
          function Ae(Ve) {
            return ee[336] == typeof Ve ? [{ value: Ve }] : Array[ee[20]](Ve) ? Ve[ee[27]](function(Ue) {
              return { id: Ue[ee[82]], lang: Ue[ee[316]], value: Ue[ee[375]]() };
            }) : [];
          }
          function Oe(Ve) {
            var Ue;
            return ((Ue = Ve == null ? void 0 : Ve[0]) === null || Ue === void 0 ? void 0 : Ue[ee[361]]) === Ie;
          }
          ie[ee[294]] = Te;
          var Be = function() {
            function Ve() {
              this[ee[133]] = null, this[ee[367]] = null, this[ee[371]] = null, this[ee[101]] = null, this[ee[377]] = null, this[ee[378]] = null, this[ee[374]] = !1, this[ee[366]] = null;
            }
            return Ve[ee[6]][ee[375]] = function() {
              return this[ee[133]] ? ee[32] + this[ee[133]] : ee[32];
            }, Ve;
          }();
          ie[ee[30]] = Be;
        }, 52832: function(ne, ie, ae) {
          var ce = this && this[ee[1]] || function() {
            return ce = Object[ee[2]] || function(Te) {
              for (var Ee, we = 1, Pe = arguments[ee[3]]; we < Pe; we++)
                for (var Me in Ee = arguments[we])
                  Object[ee[6]][ee[5]][ee[4]](Ee, Me) && (Te[Me] = Ee[Me]);
              return Te;
            }, ce[ee[7]](this, arguments);
          }, he = this && this[ee[452]] || function(Te, Ee, we) {
            if (we || arguments[ee[3]] === 2)
              for (var Pe, Me = 0, Ae = Ee[ee[3]]; Me < Ae; Me++)
                !Pe && Me in Ee || (Pe || (Pe = Array[ee[6]][ee[453]][ee[4]](Ee, 0, Me)), Pe[Me] = Ee[Me]);
            return Te[ee[56]](Pe || Array[ee[6]][ee[453]][ee[4]](Ee));
          };
          Object[ee[9]](ie, ee[8], { value: !0 }), ie[ee[454]] = void 0;
          var _e = ae(25550), le = ae(28764), se = ae(18665), oe = ae(88005), ue = ae(59181), be = ae(90637), ve = ae(36564), me = ae(67345), pe = ae(76650), fe = ae(8272), ge = ae(331), ye = ae(76885), $e = ae(51040), Se = function() {
            function Te(Ee, we) {
              var Pe = this;
              this[ee[455]] = 0, this[ee[456]] = function(Ae, Oe, Be) {
                return Pe[ee[35]][ee[78]][ee[459]](se[ee[76]][ee[457]], function(Ve) {
                  return Ve[ee[458]](Ae, Ae[ee[133]]);
                }, null, Pe[ee[74]][ee[73]]), Ae[ee[168]] ? Pe[ee[460]](Ae, Be, Oe) : (Pe[ee[84]][ee[174]](null, null)[ee[49]](function() {
                }), null);
              }, this[ee[461]] = function(Ae, Oe) {
                Pe[ee[462]] = Ce(Ae, Oe, Pe[ee[74]][ee[73]]);
              }, this[ee[35]] = Ee, this[ee[74]] = we, this[ee[72]] = Ee[ee[72]], this[ee[463]] = new $e[ee[294]](Ee, we), this[ee[464]] = !1, this[ee[423]] = Ee[ee[423]], this[ee[465]] = [];
              var Me = { onFailure: this[ee[461]], maxRetries: this[ee[72]][ee[466]], requestType: me[ee[87]][ee[467]], resetRetriesWhenOffline: !1 };
              this[ee[84]] = new oe[ee[88]](Ee, Me);
            }
            return Te[ee[6]][ee[468]] = function(Ee, we) {
              if (this[ee[464]])
                return null;
              var Pe = Ee[ee[469]]();
              return this[ee[470]](Pe, we);
            }, Te[ee[6]][ee[470]] = function(Ee, we) {
              var Pe, Me = this[ee[35]][ee[78]][ee[77]](se[ee[76]][ee[457]], this[ee[74]][ee[73]]), Ae = (Pe = Me == null ? void 0 : Me[ee[471]](this[ee[133]])) !== null && Pe !== void 0 ? Pe : this[ee[472]](Ee, we);
              return Ae ? (Me == null || Me[ee[473]](Ae, this[ee[133]]), this[ee[465]] = Ae[ee[30]] ? he(he([], Ae[ee[398]], !0), Ae[ee[30]][ee[27]](function(Oe) {
                return Oe[ee[133]];
              }), !0) : Ae[ee[398]], this[ee[133]] = this[ee[465]][0], Ae) : null;
            }, Te[ee[6]][ee[472]] = function(Ee, we) {
              return this[ee[463]][ee[433]](Ee, this[ee[133]], we);
            }, Te[ee[6]][ee[474]] = function() {
              this[ee[84]] && this[ee[84]][ee[475]](), this[ee[464]] = !0, this[ee[133]] = null;
            }, Te[ee[6]][ee[184]] = function() {
              this[ee[474]](), this[ee[84]][ee[184]](), this[ee[463]] && (this[ee[463]][ee[184]](), this[ee[463]] = null), this[ee[72]] = null;
            }, Te[ee[6]][ee[174]] = function(Ee) {
              var we = this;
              return this[ee[133]] = Ee || this[ee[133]], this[ee[462]] = null, Ee && (this[ee[464]] = !1), this[ee[133]] ? this[ee[481]](this[ee[133]])[ee[62]](function(Pe) {
                return we[ee[456]](Pe, Pe[ee[480]], we[ee[133]]);
              })[ee[49]](function(Pe) {
                return we[ee[464]] || (Pe == null ? void 0 : Pe[ee[437]]) === be[ee[477]][ee[476]] ? Promise[ee[68]]() : (we[ee[35]][ee[59]][ee[115]](ee[478] + we[ee[133]] + ee[479], Pe), Promise[ee[68]](Pe));
              }) : (this[ee[35]][ee[423]][ee[446]](new le[ee[440]](_e[ee[436]][ee[482]], void 0, ee[483])), Promise[ee[68]](ee[484]));
            }, Te[ee[6]][ee[481]] = function(Ee) {
              var we, Pe = this, Me = this[ee[35]][ee[78]][ee[459]](se[ee[76]][ee[457]], function(Oe) {
                return Oe[ee[485]](Ee);
              }, null, this[ee[74]][ee[73]]);
              if (Me)
                return Promise[ee[117]](Me);
              var Ae = (we = this[ee[74]][ee[309]][ee[486]]) === null || we === void 0 ? void 0 : we[ee[487]];
              return this[ee[84]][ee[174]](Ee, me[ee[170]][ee[169]], null, null, null, Ae, ue[ee[490]][ee[310]])[ee[49]](function(Oe) {
                return Pe[ee[455]]++, Pe[ee[455]] < Pe[ee[465]][ee[3]] ? (Pe[ee[133]] = ye[ee[24]][ee[488]](Pe[ee[133]], Pe[ee[465]][Pe[ee[455]]]), Pe[ee[481]](Pe[ee[133]])) : (Pe[ee[35]][ee[59]][ee[115]](ee[489]), Pe[ee[462]] && Pe[ee[423]][ee[446]](Pe[ee[462]]), Pe[ee[462]] = null, Promise[ee[68]](Oe));
              });
            }, Te[ee[6]][ee[126]] = function(Ee) {
              return Promise[ee[117]](Ee);
            }, Te[ee[6]][ee[491]] = function(Ee) {
              return Promise[ee[117]]();
            }, Te[ee[6]][ee[460]] = function(Ee, we, Pe) {
              var Me, Ae;
              (0, ve[ee[492]])(Ee) && (this[ee[35]][ee[59]][ee[115]](ee[496][ee[56]]((Me = Ee[ee[480]]) === null || Me === void 0 ? void 0 : Me[ee[494]](2), ee[495])[ee[56]]((Ae = Ee[ee[493]]) === null || Ae === void 0 ? void 0 : Ae[ee[494]](2))), this[ee[35]][ee[500]][ee[51]]((0, pe[ee[499]])(ee[22], fe[ee[498]][ee[497]], { bytes: Ee[ee[3]], time: Ee[ee[480]], timeToFirstByte: Ee[ee[493]] }))), this[ee[133]] = Ee[ee[133]];
              var Oe = ce({}, this[ee[468]](Ee[ee[168]], (0, ge[ee[272]])(Math[ee[501]](Pe))));
              return Oe[ee[502]] = this[ee[133]], this[ee[84]][ee[503]](!0), Oe;
            }, Te;
          }();
          function Ce(Te, Ee, we) {
            return (Ee == null ? void 0 : Ee[ee[504]]) === be[ee[477]][ee[476]] ? null : (Ee == null ? void 0 : Ee[ee[504]]) === be[ee[477]][ee[505]] ? new le[ee[440]](_e[ee[436]][ee[506]], Ie(Te), ee[507], we) : (Te == null ? void 0 : Te[ee[508]]) === 0 ? new le[ee[440]](_e[ee[436]][ee[509]], Ie(Te), ee[510], we) : new le[ee[440]](_e[ee[436]][ee[511]], Ie(Te), ee[515][ee[56]](Te[ee[508]], ee[514])[ee[56]](Te[ee[512]], ee[513]), we);
          }
          function Ie(Te) {
            return { url: Te[ee[133]], statusCode: Te[ee[508]], statusText: Te[ee[512]] };
          }
          ie[ee[454]] = Se;
        }, 61411: function(ne, ie, ae) {
          var ce = this && this[ee[516]] || function() {
            var Ce = function(Ie, Te) {
              return Ce = Object[ee[517]] || { __proto__: [] } instanceof Array && function(Ee, we) {
                Ee[ee[518]] = we;
              } || function(Ee, we) {
                for (var Pe in we)
                  Object[ee[6]][ee[5]][ee[4]](we, Pe) && (Ee[Pe] = we[Pe]);
              }, Ce(Ie, Te);
            };
            return function(Ie, Te) {
              if (ee[292] != typeof Te && Te !== null)
                throw new TypeError(ee[519] + String(Te) + ee[520]);
              function Ee() {
                this[ee[521]] = Ie;
              }
              Ce(Ie, Te), Ie[ee[6]] = Te === null ? Object[ee[522]](Te) : (Ee[ee[6]] = Te[ee[6]], new Ee());
            };
          }(), he = this && this[ee[1]] || function() {
            return he = Object[ee[2]] || function(Ce) {
              for (var Ie, Te = 1, Ee = arguments[ee[3]]; Te < Ee; Te++)
                for (var we in Ie = arguments[Te])
                  Object[ee[6]][ee[5]][ee[4]](Ie, we) && (Ce[we] = Ie[we]);
              return Ce;
            }, he[ee[7]](this, arguments);
          };
          Object[ee[9]](ie, ee[8], { value: !0 }), ie[ee[523]] = void 0;
          var _e = ae(81361), le = ae(331), se = ae(76885), oe = ae(73553), ue = ae(28915), be = ae(92983), ve = ae(44890), me = ae(38725), pe = function(Ce) {
            function Ie(Te) {
              var Ee = Ce[ee[4]](this, Te) || this;
              return Ee[ee[524]] = 0, Ee[ee[525]] = null, Ee[ee[526]] = [], Ee[ee[527]] = !0, Ee[ee[528]] = !1, Ee[ee[529]] = 1, Ee[ee[530]] = 0, Ee[ee[531]] = 0, Ee;
            }
            return ce(Ie, Ce), Ie[ee[6]][ee[118]] = function(Te, Ee, we) {
              Ee === void 0 && (Ee = null), we === void 0 && (we = { isPeriodSwitch: !1, isManifestUpdate: !1 }), this[ee[119]] = Te, this[ee[98]] = Ee;
              var Pe = !this[ee[98]] || !!this[ee[47]][ee[46]](this[ee[98]]), Me = this[ee[47]][ee[111]](this[ee[119]]);
              this[ee[98]] && Pe || (this[ee[98]] = Me[ee[141]][0][ee[42]]);
              var Ae = this[ee[236]](this[ee[98]]);
              Ae ? (this[ee[533]](Ae, we[ee[532]]), this[ee[162]]() || Ce[ee[6]][ee[154]][ee[4]](this, this[ee[145]]())) : this[ee[35]][ee[59]][ee[115]](ee[240]), this[ee[116]]();
            }, Ie[ee[6]][ee[129]] = function(Te) {
              if (this[ee[47]][ee[46]](Te)) {
                this[ee[98]] = Te;
                var Ee = this[ee[236]](this[ee[98]]);
                return Ee && this[ee[533]](Ee), !0;
              }
              return !1;
            }, Ie[ee[6]][ee[534]] = function(Te) {
              return (Te == null ? void 0 : Te[ee[138]]) != null && isFinite(Te[ee[138]]) ? Te[ee[138]] : 0;
            }, Ie[ee[6]][ee[535]] = function() {
              this[ee[47]][ee[255]]() && this[ee[527]] && (this[ee[528]] || this[ee[163]](0), this[ee[527]] = !1);
            }, Ie[ee[6]][ee[536]] = function(Te) {
              return !(Te != null && Te[ee[253]]) || !this[ee[47]][ee[254]](this[ee[98]]);
            }, Ie[ee[6]][ee[537]] = function(Te) {
              var Ee = this[ee[526]][this[ee[524]]];
              Ee && (Te[ee[256]] = (0, le[ee[248]])(Ee[ee[538]] / this[ee[529]] - this[ee[100]]()));
            }, Ie[ee[6]][ee[97]] = function() {
              var Te, Ee, we = { isInitSegment: !1, presentationTimeOffset: this[ee[100]]() }, Pe = this[ee[236]](this[ee[98]]);
              if (this[ee[536]](Pe) || (this[ee[535]](), !(this[ee[526]][ee[3]] > 0 && this[ee[524]] < this[ee[526]][ee[3]])))
                return null;
              var Me = this[ee[526]][this[ee[524]]];
              Ce[ee[6]][ee[154]][ee[4]](this, Me[ee[298]]), this[ee[99]] = Me[ee[538]], we[ee[95]] = Me[ee[95]], we[ee[539]] = Me[ee[540]], we[ee[257]] = Me[ee[298]];
              var Ae = (Ee = (Te = this[ee[241]]()) === null || Te === void 0 ? void 0 : Te[ee[138]]) !== null && Ee !== void 0 ? Ee : 0;
              if (we[ee[139]] = Me[ee[541]] + Ae, this[ee[47]][ee[255]]()) {
                if (this[ee[249]](this[ee[524]]))
                  return null;
                this[ee[537]](we);
              }
              var Oe = this[ee[47]][ee[46]](this[ee[98]]);
              return Oe ? (we[ee[81]] = Oe == null ? void 0 : Oe[ee[42]][ee[81]], we[ee[133]] = (0, be[ee[22]])(Pe[ee[253]], Oe, this[ee[162]](), this[ee[99]]), we[ee[102]] = (0, ue[ee[103]])(we), Ce[ee[6]][ee[154]][ee[4]](this, this[ee[162]]() + 1), this[ee[524]]++, we) : null;
            }, Ie[ee[6]][ee[142]] = function(Te) {
              var Ee = this[ee[97]]();
              return Ee ? Promise[ee[117]](Ee) : this[ee[69]]({ time: Te });
            }, Ie[ee[6]][ee[69]] = function(Te) {
              var Ee = this;
              return this[ee[70]] ? Promise[ee[68]](ee[71]) : new Promise(function(we, Pe) {
                Ee[ee[70]] = he(he({}, Te), { resolve: we, reject: Pe });
              });
            }, Ie[ee[6]][ee[116]] = function() {
              if (this[ee[70]]) {
                var Te = this[ee[97]]();
                if (Te)
                  this[ee[70]][ee[117]](Te), this[ee[70]] = null;
                else if (!this[ee[47]][ee[542]]()) {
                  var Ee = this[ee[241]]();
                  if (isFinite(Ee[ee[95]])) {
                    var we = this[ee[543]](), Pe = we / this[ee[544]](), Me = Ee[ee[138]] + we, Ae = Ee[ee[95]] - Pe / 2;
                    isFinite(Ae) && Me >= Ae && (this[ee[70]][ee[68]](oe[ee[259]][ee[545]]), this[ee[70]] = null);
                  }
                }
              }
            }, Ie[ee[6]][ee[130]] = function(Te) {
              var Ee = this, we = {};
              return this[ee[47]][ee[111]](this[ee[98]])[ee[141]][ee[140]](function(Pe) {
                var Me, Ae, Oe = Pe[ee[42]], Be = Ee[ee[236]](Oe), Ve = [], Ue = Ee[ee[131]]()[ee[137]] - Ee[ee[131]]()[ee[138]], Re = 0, Ne = Ee[ee[47]][ee[255]]();
                Ne ? (Me = Math[ee[275]](Ee[ee[162]]() - Ue / Ee[ee[105]]()), Ae = Ee[ee[162]]()) : (Me = 0, Ae = Math[ee[106]](Me + Ue / Ee[ee[105]]()));
                for (var xe = Me; xe <= Ae; xe++) {
                  var ke = {};
                  ke[ee[95]] = Ee[ee[105]](), ke[ee[139]] = Ne ? Ee[ee[246]](xe) : Re * Ee[ee[105]]();
                  var Le = (0, be[ee[22]])(Be[ee[253]], Pe, Me + Re, Ee[ee[546]](Re));
                  ke[ee[133]] = Te ? se[ee[24]][ee[23]](Te, Le) : Le, ke[ee[133]] = se[ee[24]][ee[135]](ke[ee[133]], Ee[ee[72]][ee[134]]), Ve[ee[136]](ke), Re++;
                }
                we[Ee[ee[98]][ee[41]]] = Ve;
              }), we;
            }, Ie[ee[6]][ee[143]] = function() {
              var Te = this[ee[47]][ee[46]](this[ee[98]])[ee[30]][0];
              return Te[ee[133]] || Te;
            }, Ie[ee[6]][ee[105]] = function() {
              return this[ee[547]]();
            }, Ie[ee[6]][ee[60]] = function(Te) {
              if (Te > -1) {
                var Ee = this[ee[534]](this[ee[241]]());
                this[ee[528]] = !1, isFinite(Ee) && (Te -= Ee);
                for (var we = 1; we < this[ee[526]][ee[3]]; we++)
                  if (this[ee[526]][we][ee[541]] > Te)
                    return this[ee[524]] = we - 1, Ce[ee[6]][ee[154]][ee[4]](this, this[ee[526]][this[ee[524]]][ee[298]]), this[ee[527]] = !1, this[ee[162]]();
                this[ee[524]] = Math[ee[153]](this[ee[526]][ee[3]] - 1, 0);
              }
              return Ce[ee[6]][ee[154]][ee[4]](this, this[ee[526]][this[ee[524]]][ee[298]]), this[ee[162]]();
            }, Ie[ee[6]][ee[246]] = function(Te) {
              var Ee, we;
              return ((we = (Ee = this[ee[241]]()) === null || Ee === void 0 ? void 0 : Ee[ee[138]]) !== null && we !== void 0 ? we : 0) + this[ee[526]][Te][ee[541]];
            }, Ie[ee[6]][ee[150]] = function(Te) {
              if (this[ee[524]] < this[ee[526]][ee[3]]) {
                var Ee = this[ee[526]][0][ee[540]], we = this[ee[526]][this[ee[524]]];
                if (this[ee[249]](this[ee[524]]))
                  return !1;
                if (we)
                  return we[ee[540]] - Ee <= Te * this[ee[529]];
              }
              return !1;
            }, Ie[ee[6]][ee[100]] = function() {
              var Te = this[ee[241]](), Ee = this[ee[530]] / this[ee[529]];
              return Te && (Ee -= Te[ee[138]]), Ee;
            }, Ie[ee[6]][ee[154]] = function(Te) {
              if (Ce[ee[6]][ee[154]][ee[4]](this, Te), this[ee[526]] && this[ee[526]][ee[3]] > 0)
                for (var Ee = 0; Ee < this[ee[526]][ee[3]]; Ee++)
                  this[ee[526]][Ee][ee[298]] === Te && (this[ee[524]] = Ee);
            }, Ie[ee[6]][ee[146]] = function() {
              if (!this[ee[47]][ee[255]]())
                return -1;
              var Te = this[ee[47]][ee[548]](), Ee = this[ee[241]]();
              if (Te == null || (Ee == null ? void 0 : Ee[ee[82]]) === Te[ee[82]])
                return this[ee[534]](Ee) + this[ee[549]]() / this[ee[529]];
              var we = (0, me[ee[222]])(Te);
              return we != null && we[ee[230]] ? this[ee[534]](Te) + (0, me[ee[223]])(we) : Ce[ee[6]][ee[146]][ee[4]](this);
            }, Ie[ee[6]][ee[549]] = function() {
              if (!this[ee[526]][ee[3]])
                return 0;
              var Te = this[ee[526]][this[ee[526]][ee[3]] - 1];
              return Te[ee[540]] + Te[ee[550]];
            }, Ie[ee[6]][ee[163]] = function(Te, Ee) {
              if (this[ee[47]][ee[255]]() && !(this[ee[526]][ee[3]] < 1)) {
                this[ee[528]] = !1;
                for (var we = this[ee[526]][0][ee[540]], Pe = this[ee[549]](), Me = Te * this[ee[529]], Ae = Math[ee[153]](this[ee[531]], this[ee[72]][ee[551]]) * this[ee[529]], Oe = Math[ee[153]](we + Ae, Pe + Me), Be = this[ee[526]][ee[3]] - 1; Be >= 0; Be--)
                  if (this[ee[526]][Be][ee[540]] <= Oe) {
                    this[ee[524]] = Be;
                    break;
                  }
                (this[ee[524]] >= this[ee[526]][ee[3]] || this[ee[524]] <= 0) && (this[ee[35]][ee[59]][ee[115]](ee[552]), this[ee[524]] = 0), this[ee[35]][ee[59]][ee[115]](ee[553] + this[ee[524]]), this[ee[527]] = !1, Ce[ee[6]][ee[154]][ee[4]](this, this[ee[526]][this[ee[524]]][ee[298]]);
              }
            }, Ie[ee[6]][ee[126]] = function(Te) {
              return this[ee[98]] = Te, Promise[ee[117]](Te);
            }, Ie[ee[6]][ee[151]] = function(Te) {
              return !0;
            }, Ie[ee[6]][ee[177]] = function() {
              return this[ee[524]]--, this[ee[524]] < 0 && (this[ee[35]][ee[59]][ee[115]](ee[554]), this[ee[524]] = 0), !0;
            }, Ie[ee[6]][ee[555]] = function(Te, Ee) {
              for (var we, Pe = { entries: [], latestTime: 0, latestOriginalTime: 0, lastPreviousTimelineEntryIndex: 0, index: this[ee[145]]() }, Me = 0, Ae = 0, Oe = 0, Be = Te; Oe < Be[ee[3]]; Oe++)
                for (var Ve = 0, Ue = (we = Be[Oe][ee[231]]) !== null && we !== void 0 ? we : []; Ve < Ue[ee[3]]; Ve++) {
                  var Re = Ue[Ve], Ne = (0, me[ee[224]])(Re[ee[232]]), xe = parseInt(Re[ee[233]]);
                  if (Re[ee[5]](ee[234])) {
                    var ke = (0, me[ee[224]])(Re[ee[234]]);
                    Pe[ee[556]] = ke, Pe[ee[557]] = ke - this[ee[530]];
                  }
                  for (; Pe[ee[557]] + xe <= 0 && Ne >= 0; )
                    this[ee[35]][ee[59]][ee[115]](ee[559][ee[56]](Pe[ee[557]], ee[558])[ee[56]](this[ee[530]], ee[513])), Pe[ee[557]] += xe, Pe[ee[556]] += xe, Ne--;
                  for (var Le = this[ee[560]](Pe, Ee, xe, Ne), He = 0; He < Le[ee[3]]; He++)
                    Le[He][ee[298]] = Pe[ee[36]] + He;
                  Me += Le[ee[3]], fe(Pe, Le, xe);
                  var We = Ne - Le[ee[3]] + 1;
                  Ae += We, fe(Pe, this[ee[561]](Pe, We, xe), xe);
                }
              return this[ee[562]](Me, Ae), Pe[ee[563]];
            }, Ie[ee[6]][ee[562]] = function(Te, Ee) {
              var we;
              this[ee[35]][ee[59]][ee[115]](ee[567][ee[56]]((we = this[ee[98]]) === null || we === void 0 ? void 0 : we[ee[41]], ee[566])[ee[56]](Te, ee[565])[ee[56]](Ee, ee[564]));
            }, Ie[ee[6]][ee[561]] = function(Te, Ee, we) {
              for (var Pe = [], Me = 0; Me < Ee; Me++) {
                var Ae = Te[ee[557]] + we * Me, Oe = { d: we, t: Ae, ot: Te[ee[556]] + we * Me, i: Te[ee[36]] + Me, playbackTime: Ae / this[ee[529]], duration: we / this[ee[529]] };
                Pe[ee[136]](Oe);
              }
              return Pe;
            }, Ie[ee[6]][ee[560]] = function(Te, Ee, we, Pe) {
              var Me = (0, _e[ee[569]])(Ee, Te[ee[568]], Ee[ee[3]], function(Oe) {
                return Oe[ee[540]] === Te[ee[557]] && Oe[ee[550]] === we;
              });
              if (Me === -1)
                return [];
              var Ae = ge(Ee, Me, we, Pe);
              return Te[ee[568]] = Ae, Ee[ee[453]](Me, Ae + 1);
            }, Ie[ee[6]][ee[543]] = function() {
              var Te = this;
              return this[ee[526]] && this[ee[526]][ee[3]] > 0 && isFinite(this[ee[529]]) ? this[ee[526]][ee[359]](function(Ee, we) {
                return Ee + we[ee[550]] / Te[ee[529]];
              }, 0) : 0;
            }, Ie[ee[6]][ee[544]] = function() {
              return this[ee[526]] ? this[ee[526]][ee[3]] : 0;
            }, Ie[ee[6]][ee[533]] = function(Te, Ee) {
              Ee === void 0 && (Ee = !1);
              var we = Te[ee[230]];
              if (this[ee[528]] = this[ee[528]] || !!Ee, we && this[ee[525]] !== we) {
                this[ee[525]] = we;
                var Pe = this[ee[570]](), Me = this[ee[264]]();
                this[ee[529]] = Me, this[ee[530]] = parseFloat(String(Te[ee[160]])) || 0;
                var Ae = this[ee[555]](we, this[ee[526]]);
                Ae[ee[3]] > 0 && (this[ee[531]] = Ae[0][ee[550]] / Me), this[ee[571]](Ae, Me, Pe), this[ee[526]] = Ae;
              }
            }, Ie[ee[6]][ee[570]] = function() {
              return this[ee[526]] && this[ee[526]][ee[3]] > 0 ? this[ee[529]] : this[ee[264]]();
            }, Ie[ee[6]][ee[571]] = function(Te, Ee, we) {
              var Pe, Me = !1;
              if (this[ee[526]] && this[ee[526]][ee[3]] > 0 ? Pe = (Me = this[ee[524]] >= this[ee[526]][ee[3]]) ? this[ee[526]][this[ee[526]][ee[3]] - 1] : this[ee[526]][this[ee[524]]] : (this[ee[524]] = 0, Ce[ee[6]][ee[154]][ee[4]](this, 0)), Pe) {
                for (var Ae = Te[ee[3]] - 1; Ae >= 0; Ae--)
                  if (Se(Te[Ae], Ee, Pe, we)) {
                    this[ee[524]] = Ae + (Me ? 1 : 0), Ce[ee[6]][ee[154]][ee[4]](this, Te[Ae][ee[298]] + (Me ? 1 : 0));
                    break;
                  }
              }
            }, Ie[ee[6]][ee[546]] = function(Te) {
              return this[ee[526]][Te] && this[ee[526]][Te][ee[5]](ee[540]) ? this[ee[526]][Te][ee[540]] : 0;
            }, Ie[ee[6]][ee[547]] = function() {
              var Te = this[ee[526]][this[ee[524]]];
              return Te ? Te[ee[550]] / this[ee[529]] : 1;
            }, Ie[ee[6]][ee[184]] = function() {
              this[ee[72]] = null, this[ee[526]] = [];
            }, Ie;
          }(ve[ee[235]]);
          function fe(Ce, Ie, Te) {
            var Ee;
            (Ee = Ce[ee[563]])[ee[136]][ee[7]](Ee, Ie), Ce[ee[557]] += Te * Ie[ee[3]], Ce[ee[556]] += Te * Ie[ee[3]], Ce[ee[36]] += Ie[ee[3]];
          }
          function ge(Ce, Ie, Te, Ee) {
            for (var we = Ce[Ie][ee[540]], Pe = Ee; Pe > 0; Pe--) {
              var Me = Ie + Pe, Ae = Ce[Me], Oe = we + Te * Pe;
              if (Ae && Ae[ee[540]] === Oe && Ae[ee[550]] === Te)
                return Me;
            }
            return Ie;
          }
          ie[ee[523]] = pe;
          var ye = Math[ee[572]](10, 8);
          function $e(Ce) {
            return Math[ee[501]](Ce * ye) / ye;
          }
          function Se(Ce, Ie, Te, Ee) {
            var we = $e(Ce[ee[540]] / Ie), Pe = $e(we + Ce[ee[550]] / Ie), Me = $e(Te[ee[540]] / Ee);
            return we <= Me && Me < Pe;
          }
        }, 84075: function(ne, ie, ae) {
          Object[ee[9]](ie, ee[8], { value: !0 }), ie[ee[573]] = void 0;
          var ce = ae(16368), he = ae(5945), _e = ae(52832), le = ae(92983), se = ae(19213), oe = ae(44890), ue = ae(61411), be = { isIndexRangeNode: he[ee[12]], isInitializationNode: he[ee[11]], isInitializationStringNode: he[ee[10]] }, ve = { provideSegmentInfoFromInitializationProperty: he[ee[13]], provideSegmentInfoFromInitializationNodeProperty: he[ee[15]], provideSegmentInfoFromIndexRangeProperty: he[ee[16]] };
          ie[ee[573]] = { name: ce[ee[194]][ee[574]], module: function() {
            return { MPDLoader: _e[ee[454]], SegmentBaseMPDHandler: se[ee[34]], SegmentTemplateMPDHandler: oe[ee[235]], SegmentTimelineMPDHandler: ue[ee[523]], replaceAllPlaceholders: le[ee[22]], initSegmentInfoSourceDetectors: be, initSegmentInfoProviders: ve };
          }, dependencies: [ce[ee[194]][ee[575]], ce[ee[194]][ee[305]]] }, ie[ee[22]] = ie[ee[573]];
        }, 92983: function(ne, ie, ae) {
          Object[ee[9]](ie, ee[8], { value: !0 }), ie[ee[22]] = se;
          var ce = ae(91397);
          function he(oe) {
            var ue = parseInt(oe[ee[372]](0, oe[ee[3]] - 1)), be = oe[oe[ee[3]] - 1][ee[335]](), ve = oe[oe[ee[3]] - 1][ee[334]](be) !== 0;
            return [be[ee[334]](ee[576]) === 0 ? 8 : be[ee[334]](ee[577]) === 0 ? 16 : (be[ee[334]](ee[550]), 10), ue, ve];
          }
          function _e(oe, ue, be) {
            for (; oe[ee[3]] < ue; )
              oe = be + oe;
            return oe;
          }
          function le(oe, ue) {
            return ue ? oe[ee[578]]() : oe[ee[335]]();
          }
          function se(oe, ue, be, ve) {
            var me = oe[ee[579]](/(\$((RepresentationID)|(Bandwidth)|(Time)|(Number(%([\d]*[A-Za-z]))?)|())\$)/g), pe = be != null, fe = ue[ee[5]](ee[123]), ge = ve != null;
            function ye(Se) {
              if (Se[ee[334]](ee[580]) === 0 && pe) {
                if (Se[ee[334]](ee[581]) > -1) {
                  var Ce = he(Se[ee[372]](Se[ee[334]](ee[581]) + 1)), Ie = Ce[0], Te = Ce[1], Ee = Ce[2];
                  return _e(le(be[ee[375]](Ie), Ee), Te, ee[358]);
                }
                return String(be);
              }
              return Se[ee[334]](ee[370]) === 0 ? ue[ee[42]][ee[41]] : Se[ee[334]](ee[582]) === 0 && fe ? String(ue[ee[123]]) : Se[ee[334]](ee[583]) === 0 && ge ? String(ve) : ee[32] === Se ? ee[584] : void 0;
            }
            var $e = [][ee[56]](me)[ee[347]](function(Se) {
              return Se;
            })[ee[27]](function(Se) {
              return Se[ee[372]](1, Se[ee[3]] - 1);
            })[ee[27]](function(Se) {
              return [Se, ye(Se)];
            })[ee[347]](function(Se) {
              return Se[1][ee[3]] > 0;
            })[ee[359]](function(Se, Ce) {
              var Ie = Ce[0], Te = Ce[1];
              return Se[ee[585]](ee[584][ee[56]](Ie, ee[584]), Te);
            }, oe);
            return (0, ce[ee[586]])($e);
          }
        } }, function(ne) {
          return function(ie) {
            return ne(ne[ee[587]] = ie);
          }(84075);
        }]);
      });
    })();
  })();
})(bitmovinplayerDash, bitmovinplayerDash.exports);
var bitmovinplayerDashExports = bitmovinplayerDash.exports;
const DashModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerDashExports);
var bitmovinplayerContainerMp4 = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ne) {
      re.exports = ne();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[270], { 2746: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ContainerMp4ModuleDefinition = void 0;
        var ae = ie(16368), ce = ie(86480), he = ie(36004), _e = ie(44642), le = ie(40163);
        ne.ContainerMp4ModuleDefinition = { name: ae.ModuleName.ContainerMP4, module: { MP4Parser: le.MP4Parser, MP4Decrypter: he.MP4Decrypter, MP4EncryptionParser: _e.MP4EncryptionParser, CmafChunkParser: ce.CmafChunkParser, getMp4Fragments: le.getMp4Fragments, getAvcSamples: le.getAvcSamples, parseTfdtBoxOffsets: le.parseTfdtBoxOffsets, getTrackId: le.getTrackId, parseBuffer: le.parseBuffer, parsePlaybackTime: le.parsePlaybackTime, isValidMp4: le.isValidMp4, getCodecFromSegment: le.getCodecFromSegment, getTrackSamples: le.getTrackSamples } }, ne.default = ne.ContainerMp4ModuleDefinition;
      }, 10045: function(ee, ne) {
        var ie = this && this.__assign || function() {
          return ie = Object.assign || function(fe) {
            for (var ge, ye = 1, $e = arguments.length; ye < $e; ye++)
              for (var Se in ge = arguments[ye])
                Object.prototype.hasOwnProperty.call(ge, Se) && (fe[Se] = ge[Se]);
            return fe;
          }, ie.apply(this, arguments);
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ISOBox = ne.ISOFile = ne.ISOBoxer = void 0;
        var ae = ["moov", "trak", "tref", "mdia", "minf", "stbl", "edts", "dinf", "sinf", "mvex", "moof", "traf", "mfra", "udta", "meco", "strk", "vttc", "schi"];
        ne.ISOBoxer = { parseBuffer: function(fe, ge) {
          return ge === void 0 && (ge = {}), new ne.ISOFile(fe, ge).parse();
        } };
        var ce = 8;
        function he(fe) {
          return fe === void 0 && (fe = 0), { offset: fe };
        }
        var _e = function(fe, ge) {
          ge === void 0 && (ge = {}), this.options = ie({}, ge), this.options.iv_size = ge.iv_size || ce, fe && (this._raw = new DataView(fe)), this._cursor = he(), this.boxes = [];
        };
        function le(fe) {
          return fe.length === 0 ? null : fe[0];
        }
        function se(fe, ge) {
          var ye = ge.indexOf("."), $e = [];
          if (ye === -1)
            for (var Se = 0; Se < fe.length; Se++)
              fe[Se].type === ge && $e.push(fe[Se]);
          else {
            var Ce = ge.substring(0, ye), Ie = ge.substring(ye + 1);
            for (Se = 0; Se < fe.length; Se++)
              fe[Se].type === Ce && ($e = $e.concat(fe[Se].list(Ie)));
          }
          return $e;
        }
        ne.ISOFile = _e, ne.ISOFile.prototype.fetch = function(fe) {
          var ge = this.fetchAll(fe, !0);
          return ge.length ? ge[0] : null;
        }, ne.ISOFile.prototype.fetchAll = function(fe, ge) {
          var ye = [];
          return ne.ISOFile._sweep.call(this, fe, ye, ge), ye;
        }, ne.ISOFile.prototype.parse = function() {
          for (this._cursor.offset = 0, this.boxes = []; this._cursor.offset < this._raw.byteLength; ) {
            var fe = ne.ISOBox.parse(this);
            if (fe.type === void 0)
              break;
            this.boxes.push(fe);
          }
          return this;
        }, ne.ISOFile._sweep = function(fe, ge, ye) {
          for (var $e in this.type && this.type === fe && ge.push(this), this.boxes) {
            if (ge.length && ye)
              return;
            ne.ISOFile._sweep.call(this.boxes[$e], fe, ge, ye);
          }
        }, ne.ISOFile.prototype.get = function(fe) {
          return le(this.list(fe));
        }, ne.ISOFile.prototype.list = function(fe) {
          return se(this.boxes, fe);
        };
        var oe = function() {
          this._cursor = he();
        };
        function ue(fe, ge) {
          fe.forEach(function(ye) {
            ne.ISOBox.prototype._boxParsers[ye] = ge;
          });
        }
        function be(fe, ge) {
          return fe._cursor.offset - fe._raw.byteOffset + ge <= fe.size;
        }
        function ve(fe) {
          return be(fe, 6) ? { bytes_of_clear_data: fe._readUint(16), bytes_of_encrypted_data: fe._readUint(32) } : { bytes_of_clear_data: 0, bytes_of_encrypted_data: 0 };
        }
        function me(fe, ge) {
          return be(fe, 2) ? (ge.subsample_count = fe._readUint(16), ge.subsamples = Array.apply(null, Array(ge.subsample_count)).map(function(ye) {
            return ve(fe);
          }), ge) : ie(ie({}, ge), { subsample_count: 0, subsamples: [] });
        }
        function pe(fe) {
          if (be(fe, fe._root.options.iv_size)) {
            var ge = { iv: fe._readHex(fe._root.options.iv_size) };
            return fe.flags && (ge = me(fe, ge)), ge;
          }
          fe.samples = [];
        }
        ne.ISOBox = oe, ne.ISOBox.parse = function(fe) {
          var ge = new ne.ISOBox();
          return ge._offset = fe._cursor.offset, ge._root = fe._root ? fe._root : fe, ge._raw = fe._raw, ge._parent = fe, ge._parseBox(), fe._cursor.offset = ge._raw.byteOffset + ge._raw.byteLength, ge;
        }, ne.ISOBox.prototype.list = function(fe) {
          return se(this.boxes || this.entries || [], fe);
        }, ne.ISOBox.prototype.get = function(fe) {
          return le(this.list(fe));
        }, ne.ISOBox.prototype._readUint64 = function() {
          var fe = this._raw.getUint32(this._cursor.offset - this._raw.byteOffset), ge = this._raw.getUint32(this._cursor.offset - this._raw.byteOffset + 4);
          return fe * Math.pow(2, 32) + ge;
        }, ne.ISOBox.prototype._readInt64 = function() {
          var fe = this._raw.getInt32(this._cursor.offset - this._raw.byteOffset), ge = this._raw.getInt32(this._cursor.offset - this._raw.byteOffset + 4);
          return fe * Math.pow(2, 32) + ge;
        }, ne.ISOBox.prototype._readInt = function(fe) {
          var ge = null;
          switch (fe) {
            case 8:
              ge = this._raw.getInt8(this._cursor.offset - this._raw.byteOffset);
              break;
            case 16:
              ge = this._raw.getInt16(this._cursor.offset - this._raw.byteOffset);
              break;
            case 32:
              ge = this._raw.getInt32(this._cursor.offset - this._raw.byteOffset);
              break;
            case 64:
              ge = this._readInt64();
          }
          return this._cursor.offset += fe >> 3, ge;
        }, ne.ISOBox.prototype._readUint = function(fe) {
          var ge = null;
          switch (fe) {
            case 8:
              ge = this._raw.getUint8(this._cursor.offset - this._raw.byteOffset);
              break;
            case 16:
              ge = this._raw.getUint16(this._cursor.offset - this._raw.byteOffset);
              break;
            case 24:
              ge = (this._raw.getUint16(this._cursor.offset - this._raw.byteOffset) << 8) + this._raw.getUint8(this._cursor.offset - this._raw.byteOffset + 2);
              break;
            case 32:
              ge = this._raw.getUint32(this._cursor.offset - this._raw.byteOffset);
              break;
            case 64:
              ge = this._readUint64();
          }
          return this._cursor.offset += fe >> 3, ge;
        }, ne.ISOBox.prototype._readUintArray = function(fe, ge) {
          for (var ye = new Array(ge), $e = 0; $e < ge; ++$e)
            ye[$e] = this._readUint(fe);
          return ye;
        }, ne.ISOBox.prototype._readFP = function(fe) {
          return this._readInt(2 * fe) / Math.pow(2, fe);
        }, ne.ISOBox.prototype._readString = function(fe) {
          for (var ge = "", ye = 0; ye < fe; ye++) {
            var $e = this._readUint(8);
            ge += String.fromCharCode($e);
          }
          return ge;
        }, ne.ISOBox.prototype._readHex = function(fe) {
          for (var ge = [], ye = 0; ye < fe; ye++) {
            var $e = this._readUint(8);
            ge.push(($e >>> 4).toString(16)), ge.push((15 & $e).toString(16));
          }
          return ge.join("");
        }, ne.ISOBox.prototype._readUUID = function() {
          return this._readUintArray(8, 16);
        }, ne.ISOBox.prototype._readTerminatedString = function() {
          for (var fe = ""; ; ) {
            var ge = this._readUint(8);
            if (ge == 0)
              break;
            fe += String.fromCharCode(ge);
          }
          return fe;
        }, ne.ISOBox.prototype._readTemplate = function(fe) {
          return this._readUint(fe / 2) + this._readUint(fe / 2) / Math.pow(2, fe / 2);
        }, ne.ISOBox.prototype._parseBox = function() {
          if (this._cursor.offset = this._offset, this._offset + 8 > this._raw.buffer.byteLength)
            this._root._incomplete = !0;
          else {
            switch (this.size = this._readUint(32), this.type = this._readString(4), this.size === 1 && (this.largesize = this._readUint(64)), this.type === "uuid" && (this.usertype = this._readUUID()), this.size) {
              case 0:
                this._raw = new DataView(this._raw.buffer, this._offset, this._raw.byteLength - this._cursor.offset);
                break;
              case 1:
                this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
                break;
              default:
                this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.size);
            }
            !this._incomplete && this._boxParsers[this.type] && this._boxParsers[this.type].call(this);
          }
        }, ne.ISOBox.prototype._parseFullBox = function() {
          this.version = this._readUint(8), this.flags = this._readUint(24);
        }, ne.ISOBox.prototype._createDataView = function() {
          return new DataView(this._raw.buffer, this._cursor.offset, this._raw.byteLength - (this._cursor.offset - this._offset));
        }, ne.ISOBox.prototype._boxParsers = {}, ue(ae, function() {
          for (this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.boxes.push(ne.ISOBox.parse(this));
        }), ne.ISOBox.prototype._boxParsers.elst = function() {
          this._parseFullBox(), this.entry_count = this._readUint(32), this.entries = [];
          for (var fe = 1; fe <= this.entry_count; fe++) {
            var ge = new ne.ISOBox();
            this.version === 1 ? (ge.segment_duration = this._readUint(64), ge.media_time = this._readInt(64)) : (ge.segment_duration = this._readUint(32), ge.media_time = this._readInt(32)), ge.media_rate_integer = this._readInt(16), ge.media_rate_fraction = this._readInt(16), this.entries.push(ge);
          }
        }, ne.ISOBox.prototype._boxParsers.emsg = function() {
          this._parseFullBox(), this.version === 0 ? (this.scheme_id_uri = this._readTerminatedString(), this.value = this._readTerminatedString(), this.timescale = this._readUint(32), this.presentation_time_delta = this._readUint(32), this.event_duration = this._readUint(32), this.id = this._readUint(32)) : (this.timescale = this._readUint(32), this.presentation_time = this._readUint(64), this.event_duration = this._readUint(32), this.id = this._readUint(32), this.scheme_id_uri = this._readTerminatedString(), this.value = this._readTerminatedString()), this.message_data = this._createDataView();
        }, ue(["free", "mdat"], function() {
          this.data = this._createDataView();
        }), ue(["ftyp", "styp"], function() {
          for (this.major_brand = this._readString(4), this.minor_versions = this._readUint(32), this.compatible_brands = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.compatible_brands.push(this._readString(4));
        }), ne.ISOBox.prototype._boxParsers.hdlr = function() {
          this._parseFullBox(), this.pre_defined = this._readUint(32), this.handler_type = this._readString(4), this.reserved = [this._readUint(32), this._readUint(32), this._readUint(32)], this.name = this._readTerminatedString();
        }, ne.ISOBox.prototype._boxParsers.mdhd = function() {
          this._parseFullBox(), this.version == 1 ? (this.creation_time = this._readUint(64), this.modification_time = this._readUint(64), this.timescale = this._readUint(32), this.duration = this._readUint(64)) : (this.creation_time = this._readUint(32), this.modification_time = this._readUint(32), this.timescale = this._readUint(32), this.duration = this._readUint(32));
          var fe = this._readUint(16);
          this.pad = fe >> 15, this.language = String.fromCharCode(96 + (fe >> 10 & 31), 96 + (fe >> 5 & 31), 96 + (31 & fe)), this.pre_defined = this._readUint(16);
        }, ne.ISOBox.prototype._boxParsers.mfhd = function() {
          this._parseFullBox(), this.sequence_number = this._readUint(32);
        }, ne.ISOBox.prototype._boxParsers.mvhd = function() {
          this._parseFullBox(), this.version === 1 ? (this.creation_time = this._readUint(64), this.modification_time = this._readUint(64), this.timescale = this._readUint(32), this.duration = this._readUint(64)) : (this.creation_time = this._readUint(32), this.modification_time = this._readUint(32), this.timescale = this._readUint(32), this.duration = this._readUint(32)), this.rate = this._readTemplate(32), this.volume = this._readTemplate(16), this.reserved1 = this._readUint(16), this.reserved2 = [this._readUint(32), this._readUint(32)], this.matrix = [];
          for (var fe = 0; fe < 9; fe++)
            this.matrix.push(this._readTemplate(32));
          for (this.pre_defined = [], fe = 0; fe < 6; fe++)
            this.pre_defined.push(this._readUint(32));
          this.next_track_ID = this._readUint(32);
        }, ne.ISOBox.prototype._boxParsers.sidx = function() {
          this._parseFullBox(), this.reference_ID = this._readUint(32), this.timescale = this._readUint(32), this.version === 0 ? (this.earliest_presentation_time = this._readUint(32), this.first_offset = this._readUint(32)) : (this.earliest_presentation_time = this._readUint(64), this.first_offset = this._readUint(64)), this.reserved = this._readUint(16), this.reference_count = this._readUint(16), this.references = [];
          for (var fe = 0; fe < this.reference_count; fe++) {
            var ge = {}, ye = this._readUint(32);
            ge.reference_type = ye >> 31 & 1, ge.referenced_size = 2147483647 & ye, ge.subsegment_duration = this._readUint(32);
            var $e = this._readUint(32);
            ge.starts_with_SAP = $e >> 31 & 1, ge.SAP_type = $e >> 28 & 7, ge.SAP_delta_time = 268435455 & $e, this.references.push(ge);
          }
        }, ne.ISOBox.prototype._boxParsers.ssix = function() {
          this._parseFullBox(), this.subsegment_count = this._readUint(32), this.subsegments = [];
          for (var fe = 0; fe < this.subsegment_count; fe++) {
            var ge = {};
            ge.ranges_count = this._readUint(32), ge.ranges = [];
            for (var ye = 0; ye < ge.ranges_count; ye++) {
              var $e = {};
              $e.level = this._readUint(8), $e.range_size = this._readUint(24), ge.ranges.push($e);
            }
            this.subsegments.push(ge);
          }
        }, ne.ISOBox.prototype._boxParsers.tfdt = function() {
          this._parseFullBox(), this.version === 1 ? this.baseMediaDecodeTime = this._readUint(64) : this.baseMediaDecodeTime = this._readUint(32);
        }, ne.ISOBox.prototype._boxParsers.tfhd = function() {
          this._parseFullBox(), this.track_ID = this._readUint(32), 1 & this.flags ? (this.base_data_offset_present = !0, this.base_data_offset = this._readUint(64)) : 131072 & this.flags && (this.default_base_is_moof = !0), 2 & this.flags && (this.sample_description_offset = this._readUint(32)), 8 & this.flags && (this.default_sample_duration = this._readUint(32)), 16 & this.flags && (this.default_sample_size = this._readUint(32)), 32 & this.flags && (this.default_sample_flags = this._readUint(32));
        }, ne.ISOBox.prototype._boxParsers.tkhd = function() {
          this._parseFullBox(), this.version === 1 ? (this.creation_time = this._readUint(64), this.modification_time = this._readUint(64), this.track_ID = this._readUint(32), this.reserved1 = this._readUint(32), this.duration = this._readUint(64)) : (this.creation_time = this._readUint(32), this.modification_time = this._readUint(32), this.track_ID = this._readUint(32), this.reserved1 = this._readUint(32), this.duration = this._readUint(32)), this.reserved2 = [this._readUint(32), this._readUint(32)], this.layer = this._readUint(16), this.alternate_group = this._readUint(16), this.volume = this._readTemplate(16), this.reserved3 = this._readUint(16), this.matrix = [];
          for (var fe = 0; fe < 9; fe++)
            this.matrix.push(this._readTemplate(32));
          this.width = this._readTemplate(32), this.height = this._readTemplate(32);
        }, ne.ISOBox.prototype._boxParsers.trun = function() {
          this._parseFullBox(), this.sample_count = this._readUint(32), 1 & this.flags && (this.data_offset_present = !0, this.data_offset = this._readInt(32)), 4 & this.flags && (this.first_sample_flags = this._readUint(32)), this.samples = [];
          for (var fe = 0; fe < this.sample_count; fe++) {
            var ge = {};
            256 & this.flags && (ge.sample_duration = this._readUint(32)), 512 & this.flags && (ge.sample_size = this._readUint(32)), 1024 & this.flags && (ge.sample_flags = this._readUint(32)), 2048 & this.flags && (this.version == 0 ? ge.sample_composition_time_offset = this._readUint(32) : ge.sample_composition_time_offset = this._readInt(32)), this.samples.push(ge);
          }
        }, ne.ISOBox.prototype._boxParsers.trex = function() {
          this._parseFullBox(), this.track_ID = this._readUint(32), this.default_sample_description_index = this._readUint(32), this.default_sample_duration = this._readUint(32), this.default_sample_size = this._readUint(32), this.default_sample_flags = this._readUint(32);
        }, ne.ISOBox.prototype._boxParsers.stsd = function() {
          for (this._parseFullBox(), this.entry_count = this._readUint(32), this.entries = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.entries.push(ne.ISOBox.parse(this));
        }, ne.ISOBox.prototype._boxParsers.encv = function() {
          for (this._readHex(6), this.data_reference_index = this._readUint(16), this._readUint(16), this._readUint(16), this._readUint(32), this._readUint(32), this._readUint(32), this.width = this._readUint(16), this.height = this._readUint(16), this.horizresolution = this._readTemplate(32), this.vertresolution = this._readTemplate(32), this._readUint(32), this.frame_count = this._readUint(16), this._readUint(8), this.compressor_name = this._readString(4), this.depth = this._readUint(16), this._readUint(16), this._readHex(27), this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.boxes.push(ne.ISOBox.parse(this));
        }, ue(["enca", "mp4a"], function() {
          for (this._readHex(6), this.data_reference_index = this._readUint(16), this._readUint(32), this._readUint(32), this.channel_count = this._readUint(16), this.sample_size = this._readUint(16), this._readUint(16), this._readUint(16), this.sample_rate = this._readUint(32) >>> 16, this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.boxes.push(ne.ISOBox.parse(this));
        }), ue(["avc1", "hvc1", "hev1"], function() {
          this._readUint(32), this._readUint(16), this.data_reference_index = this._readUint(16), this.version = this._readUint(16), this.revision_level = this._readUint(16), this.vendor = this._readUint(32), this.temporal_quality = this._readUint(32), this.spatial_quality = this._readUint(32), this.width = this._readUint(16), this.height = this._readUint(16), this.horizontal_resolution = this._readTemplate(32), this.vertical_resolution = this._readTemplate(32), this.data_size = this._readUint(32), this.frame_count = this._readUint(16);
          var fe = this._readUint(8);
          this.compressor_name = "";
          for (var ge = 0; ge < 31; ge++) {
            var ye = this._readUint(8);
            ge < fe && (this.compressor_name += String.fromCharCode(ye));
          }
          for (this.depth = this._readUint(16), this._readInt(16), this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.boxes.push(ne.ISOBox.parse(this));
        }), ne.ISOBox.prototype._boxParsers.avcC = function() {
          this.configuration_version = this._readUint(8), this.avc_profile_indication = this._readUint(8), this.profile_compatibility = this._readUint(8), this.avc_level_indication = this._readUint(8);
          var fe = this._readUint(8);
          this.complete_representation = fe >>> 7 & 1, this.length_size_minus_one = 3 & fe, this.num_sps = 31 & this._readUint(8), this.sps = [];
          for (var ge = 0; ge < this.num_sps; ++ge)
            this.sps.push(this._readUintArray(8, this._readUint(16)));
          for (this.num_pps = 31 & this._readUint(8), this.pps = [], ge = 0; ge < this.num_pps; ++ge)
            this.pps.push(this._readUintArray(8, this._readUint(16)));
        }, ne.ISOBox.prototype._boxParsers.hvcC = function() {
          var fe;
          this.configurationVersion = this._readUint(8), fe = this._readUint(8), this.general_profile_space = fe >>> 6, this.general_tier_flag = fe >>> 5 & 1, this.general_profile_idc = 31 & fe, this.general_profile_compatibility_flags = this._readUint(32), this.general_constraint_indicator_flags_bytes = [];
          for (var ge = 0; ge < 6; ge++)
            this.general_constraint_indicator_flags_bytes[ge] = this._readUint(8);
          this.general_level_idc = this._readUint(8), this.min_spatial_segmentation_idc = 4095 & this._readUint(16), this.parallelismType = 3 & this._readUint(8), this.chroma_format_idc = 3 & this._readUint(8), this.bit_depth_luma_minus8 = 7 & this._readUint(8), this.bit_depth_chroma_minus8 = 7 & this._readUint(8), this.avgFrameRate = this._readUint(16), fe = this._readUint(8), this.constantFrameRate = fe >>> 6, this.numTemporalLayers = fe >>> 3 & 7, this.temporalIdNested = fe >>> 2 & 1, this.lengthSizeMinusOne = 3 & fe, this.numOfArrays = this._readUint(8);
        }, ne.ISOBox.prototype._boxParsers.esds = function() {
          this._parseFullBox(), this._readUint(16), this.esId = this._readUint(16), this.streamPriority = 31 & this._readUint(8), this._readUint(16), this.decoderConfig = {}, this.decoderConfig.objectProfileIndication = this._readUint(8), this.decoderConfig.streamType = this._readUint(8) >>> 2 & 63, this.decoderConfig.bufferSize = this._readUint(24), this.decoderConfig.maxBitrate = this._readUint(32), this.decoderConfig.avgBitrate = this._readUint(32), this.decoderConfig.decoderConfigDescriptor = {}, this.decoderConfig.decoderConfigDescriptor.tag = this._readUint(8), this.decoderConfig.decoderConfigDescriptor.length = this._readUint(8);
          var fe = this._readUint(8), ge = this._readUint(8), ye = this.decoderConfig.decoderConfigDescriptor;
          ye.audioObjectType = fe >>> 3 & 31, ye.samplingFrequencyIndex = (7 & fe) << 1 | ge >>> 7 & 1, ye.channelConfiguration = ge >>> 3 & 15;
        }, ne.ISOBox.prototype._boxParsers.tenc = function() {
          this._parseFullBox(), this.default_is_encrypted = this._readUint(24) === 1, this.default_iv_size = this._readUint(8), this.default_kid = this._readHex(16);
        }, ne.ISOBox.prototype._boxParsers.senc = function() {
          var fe = this;
          this._parseFullBox(), this.sample_count = this._readUint(32), this.samples = Array.apply(null, Array(this.sample_count)).map(function(ge) {
            return pe(fe);
          });
        }, ne.ISOBox.prototype._boxParsers.frma = function() {
          this.codingname = this._readString(4);
        }, ne.ISOBox.prototype._boxParsers.schm = function() {
          this._parseFullBox(), this.scheme_type = this._readString(4), this.scheme_version = this._readUint(32), 1 & this.flags && (this.scheme_uri = this._readUint(8));
        }, ne.ISOBox.prototype._boxParsers.saiz = function() {
          if (this._parseFullBox(), 1 & this.flags && (this.aux_info_type = this._readUint(32), this.aux_info_type_parameter = this._readUint(32)), this.default_sample_info_size = this._readUint(8), this.sample_count = this._readUint(32), this.default_sample_info_size === 0) {
            this.sample_info_size = [];
            for (var fe = 0; fe < this.sample_count; ++fe)
              this.sample_info_size.push(this._readUint(8));
          }
        }, ne.ISOBox.prototype._boxParsers.pssh = function() {
          if (this._parseFullBox(), this.system_id = this._readUUID(), this.version > 0) {
            this.kid_count = this._readUint(32), this.kids = [];
            for (var fe = 0; fe < this.kid_count; ++fe)
              this.kids.push(this._readString(16));
          }
          this.data_size = this._readUint(32), this.data = new DataView(this._raw.buffer, this._cursor.offset, this.data_size);
        }, ne.ISOBox.prototype._boxParsers.prft = function() {
          this._parseFullBox(), this.reference_track_ID = this._readUint(32), this.ntp_timestamp_seconds = this._readUint(32), this.ntp_timestamp_seconds_fraction = this._readUint(32), this.version === 0 ? this.media_time = this._readUint(32) : this.media_time = this._readUint(64);
        };
      }, 18882: function(ee, ne) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.ntpToUnix = ae;
        var ie = new Date(Date.UTC(1900, 0, 1)).getTime();
        function ae(ce) {
          return ce + ie;
        }
      }, 36004: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MP4Decrypter = void 0;
        var ae = ie(10045), ce = ie(81361), he = ie(56093), _e = ie(29500), le = ie(91520), se = ie(16368), oe = 8, ue = function() {
          function Se(Ce, Ie, Te) {
            this.context = Ce, this.keys = Ie, this.isDataEncrypted = !1, this.mimeType = Te, this.keyIds = [];
          }
          return Se.prototype.parseInitSegment = function(Ce) {
            var Ie = this;
            this.isDataEncrypted = !1;
            for (var Te = ae.ISOBoxer.parseBuffer(Ce), Ee = Te._raw.buffer, we = 0, Pe = be(Te); we < Pe.length; we++) {
              var Me = Pe[we];
              this.storeKeyId(Me);
            }
            var Ae = Te.get("moov.trak.mdia.minf.stbl.stsd").entries[0];
            return Ae.list("sinf").forEach(function(Oe) {
              var Be = Oe.get("frma"), Ve = Oe.get("schm"), Ue = Oe.get("schi.tenc");
              if (Be && Ue && Ve) {
                for (var Re = 0; Re < 4; ++Re)
                  Te._raw.setUint8(Ae._offset + 4 + Re, Be.codingname.charCodeAt(Re));
                Ie.defaultIsEncrypted = Ue.default_is_encrypted, Ie.defaultIVSize = Ue.default_iv_size, Ie.defaultKid = Ue.default_kid, Ie.isDataEncrypted = !0;
                var Ne = ce.ArrayHelper.arrayBufferToAsciiString(he.FormatHelper.hexToBytes(Ie.defaultKid).buffer, !0);
                Ie.storeKeyId(Ne);
              }
              (0, _e.rewriteMp4BoxType)(Oe, "free");
            }), Promise.resolve(Ee);
          }, Se.prototype.storeKeyId = function(Ce) {
            this.keyIds.includes(Ce) || this.keyIds.push(Ce);
          }, Se.prototype.getKeyIds = function() {
            return this.keyIds;
          }, Se.prototype.addKeys = function(Ce) {
            for (var Ie = function(Pe) {
              var Me = Te.keys.find(function(Ae) {
                return Ae.kid === Pe.kid;
              });
              Me ? Me.key = Pe.key : Te.keys.push(Pe);
            }, Te = this, Ee = 0, we = Ce; Ee < we.length; Ee++)
              Ie(we[Ee]);
          }, Se.prototype.getKey = function() {
            if (this.key)
              return this.key;
            var Ce;
            for (var Ie in this.keys)
              if (this.keys.hasOwnProperty(Ie) && this.keys[Ie].hasOwnProperty("key") && this.keys[Ie].hasOwnProperty("kid") && this.keys[Ie].kid === this.defaultKid) {
                Ce = this.keys[Ie].key;
                break;
              }
            return Ce === void 0 && (Ce = this.keys[0].key), typeof Ce == "string" ? this.key = he.FormatHelper.hexToBytes(Ce).buffer : Ce instanceof Uint8Array ? this.key = Ce.buffer : this.key = Ce, this.key;
          }, Se.prototype.decryptDataSegment = function(Ce) {
            if (!this.getKey())
              return this.context.logger.debug("MP4Decrypter.decryptSegment: Error decrypting AES-128 encrypted content"), Promise.reject("Error decrypting AES-128 encrypted content");
            if (this.isEncrypted() === !1)
              return this.context.logger.debug("MP4Decrypter.decryptSegment: NO ENCRYPTED CONTENT"), Promise.reject("NO ENCRYPTED CONTENT");
            for (var Ie = ae.ISOBoxer.parseBuffer(Ce, { iv_size: this.defaultIVSize }), Te = new ye(Ie), Ee = [], we = 0; we < Te.getSampleCount(); ++we)
              Ee.push(this.decryptSample(Ce, Te, we));
            return Promise.all(Ee).then(function() {
              return $e(Te), Ce;
            });
          }, Se.prototype.decryptSample = function(Ce, Ie, Te) {
            var Ee = Ie.sampleToOffset(Te), we = Ie.sampleToSize(Te, 1), Pe = Ie.getSampleEncodeInfo(Te);
            return Pe.iv ? me(new (le.ModuleManager.get(se.ModuleName.Crypto)).CryptoApi(this.context, "AES-CTR", this.getKey(), Pe.iv, this.mimeType), Ce, Ee, we, Pe) : (this.context.logger.debug("MP4Decrypter.decryptSegment: NO INITIAL VECTOR PROVIDED"), Promise.reject("NO INITIAL VECTOR PROVIDED"));
          }, Se.prototype.isEncrypted = function() {
            return this.isDataEncrypted;
          }, Se;
        }();
        function be(Se) {
          var Ce = [], Ie = [];
          Ie.push.apply(Ie, Se.list("moov.pssh")), Ie.push.apply(Ie, Se.list("moof.pssh"));
          for (var Te = 0, Ee = Ie; Te < Ee.length; Te++) {
            var we = Ee[Te];
            we.kids && we.kids.length > 0 && Ce.push.apply(Ce, we.kids);
          }
          return Ce;
        }
        function ve(Se, Ce, Ie, Te) {
          var Ee = Ce.slice(Ie, Ie + Te);
          return Se.decrypt(Ee).then(function(we) {
            new Uint8Array(Ce).set(new Uint8Array(we), Ie);
          });
        }
        function me(Se, Ce, Ie, Te, Ee) {
          var we;
          return ((we = Ee.subsample_count) !== null && we !== void 0 ? we : 0) > 0 && Ee.subsamples ? pe(Se, fe(Ce, Ie, Ee)) : ve(Se, Ce, Ie, Te);
        }
        function pe(Se, Ce) {
          var Ie = ge(Ce);
          return Se.decrypt(Ie).then(function(Te) {
            for (var Ee = 0, we = 0, Pe = Ce; we < Pe.length; we++) {
              var Me = Pe[we], Ae = new Uint8Array(Te, Ee, Me.byteLength);
              Me.set(Ae), Ee += Me.byteLength;
            }
          });
        }
        function fe(Se, Ce, Ie) {
          if (!Ie.subsamples)
            return [];
          for (var Te = [], Ee = 0, we = Ie.subsamples; Ee < we.length; Ee++) {
            var Pe = we[Ee];
            Ce += Pe.bytes_of_clear_data;
            var Me = Pe.bytes_of_encrypted_data;
            if (Me > 0) {
              var Ae = new Uint8Array(Se, Ce, Me);
              Te.push(Ae), Ce += Me;
            }
          }
          return Te;
        }
        function ge(Se) {
          for (var Ce = Se.reduce(function(Me, Ae) {
            return Me + Ae.byteLength;
          }, 0), Ie = new Uint8Array(Ce), Te = 0, Ee = 0, we = Se; Ee < we.length; Ee++) {
            var Pe = we[Ee];
            Ie.set(Pe, Te), Te += Pe.byteLength;
          }
          return Ie.buffer;
        }
        ne.MP4Decrypter = ue;
        var ye = function() {
          function Se(Ce) {
            var Ie = Ce.get("moof.traf");
            this.trunBox = Ie.get("trun"), this.sencBox = Ie.get("senc"), this.uuidBox = Ie.get("uuid"), this.saizBox = Ie.get("saiz"), this.saioBox = Ie.get("saio"), this.seigBox = Ie.get("seig"), this.sbgpBox = Ie.get("sbgp"), this.mdatOffset = Ce.get("mdat")._offset + oe;
          }
          return Se.prototype.getSampleSizeTable = function() {
            return this.trunBox.samples;
          }, Se.prototype.getSampleCount = function() {
            return this.getSampleSizeTable().length;
          }, Se.prototype.getSampleEncodeInfo = function(Ce) {
            return this.sencBox.samples[Ce];
          }, Se.prototype.sampleToOffset = function(Ce) {
            return this.mdatOffset + this.sampleToSize(0, Ce);
          }, Se.prototype.sampleToSize = function(Ce, Ie) {
            for (var Te, Ee = this.getSampleSizeTable(), we = 0, Pe = Ce; Pe < Ce + Ie; Pe++)
              we += (Te = Ee[Pe].sample_size) !== null && Te !== void 0 ? Te : 0;
            return we;
          }, Se;
        }();
        function $e(Se) {
          [Se.uuidBox, Se.sencBox, Se.saioBox, Se.saizBox, Se.seigBox, Se.sbgpBox].forEach(function(Ce) {
            Ce && (0, _e.rewriteMp4BoxType)(Ce, "free");
          });
        }
      }, 40163: function(ee, ne, ie) {
        var ae = this && this.__spreadArray || function(pt, bt, ut) {
          if (ut || arguments.length === 2)
            for (var Ke, je = 0, De = bt.length; je < De; je++)
              !Ke && je in bt || (Ke || (Ke = Array.prototype.slice.call(bt, 0, je)), Ke[je] = bt[je]);
          return pt.concat(Ke || Array.prototype.slice.call(bt));
        };
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MP4Parser = void 0, ne.getAvcSamples = Te, ne.getTrackSamples = Ee, ne.removeEmulationPreventionThreeBytes = Pe, ne.getMp4Fragments = Me, ne.parseTfdtBoxOffsets = Oe, ne.getTrackId = Be, ne.parseBuffer = Ve, ne.parsePlaybackTime = Ue, ne.parseSegmentData = Re, ne.isValidMp4 = Ne, ne.getCodecFromSegment = Le;
        var ce = ie(10045), he = ie(25550), _e = ie(28764), le = ie(58935), se = ie(72181), oe = ie(97630), ue = ie(81361), be = ie(42283), ve = ie(56093), me = ie(79814), pe = ie(29500), fe = ie(70016), ge = ie(91520), ye = ie(16368), $e = ie(18882), Se = 8, Ce = function() {
          function pt(bt, ut, Ke) {
            Ke === void 0 && (Ke = ce.ISOBoxer), this.context = bt, this.mp4EncryptionParser = ut, this.isoBoxer = Ke, this.CryptoModule = ge.ModuleManager.get(ye.ModuleName.Crypto, !1);
          }
          return pt.prototype.parseSegment = function(bt) {
            me.MimeTypeHelper.extractContainerType(bt.getMimeType()) === "mp4" ? (bt.isInit() ? this.parseInitSegment(bt) : this.parseDataSegment(bt), bt.setDrmInitData(this.extractDrmInitData(bt))) : this.context.logger.debug("Skipping parsing of a non MP4 segment");
          }, pt.prototype.extractDrmInitData = function(bt) {
            var ut = this, Ke = this.mp4EncryptionParser.parsePsshBox(bt);
            return this.context.logger.isLevelEnabled(le.LogLevel.DEBUG) && (Ke == null || Ke.forEach(function(je) {
              return ut.context.logger.debug("initData found: ".concat(je.initDataStr));
            })), Array.isArray(Ke) && Ke.length > 0 ? Ke : [];
          }, pt.prototype.parseTrackDefaultParameters = function(bt) {
            var ut = bt.getParsedData().get("moov.mvex.trex");
            if (ut) {
              var Ke = { defaultSampleSize: ut.default_sample_size, defaultSampleDuration: ut.default_sample_duration };
              bt.updateParserMetadata(Ke), this.context.logger.debug("default sample duration for " + bt.getMimeType() + " : " + Ke.defaultSampleDuration);
            }
          }, pt.prototype.parseSampleGroupDescriptionBox = function(bt) {
            var ut = bt.getParsedData().get("moof.traf.sgpd");
            if (ut && Ge(ut) === "seig") {
              var Ke = ze(ut);
              if (!(Ke < 1)) {
                var je = Fe(ut), De = ot(ut), at = vt(ut), dt = gt(ut);
                this.context.logger.debug("Parsed SGPD/SEIG, entries(".concat(Ke, "), key ID(").concat(dt, "), IV size(").concat(at, "), isEncrypted(").concat(!!De, "), descriptor length(").concat(je, ")")), bt.setDrmKid(dt);
              }
            }
          }, pt.prototype.parseTrackEncryptionBox = function(bt) {
            var ut = this.mp4EncryptionParser.parseDefaultKIDFromBuffer(bt.getData(), bt.getMimeType()), Ke = ut != null && ut.length ? ut.pop() : void 0, je = bt.getParsedData().get("moov.trak.mdia.minf.stbl.stsd.encv.sinf.schi.tenc") || bt.getParsedData().get("moov.trak.mdia.minf.stbl.stsd.enca.sinf.schi.tenc");
            je && (bt.updateParserMetadata({ ivSize: je.default_iv_size }), bt.setEncrypted(!0)), Ke && bt.setDrmKid(ve.FormatHelper.beautifyUUID(Ke));
          }, pt.prototype.isSupportedEdtsBox = function(bt) {
            var ut = bt.get("elst");
            return !(ut && ut.entries.length > 0 && ut.entries[0].media_time < 0);
          }, pt.prototype.parseInitSegment = function(bt) {
            var ut = Re(bt, {}, this.isoBoxer);
            ut ? (this.parseTrackEncryptionBox(bt), Qe(bt, this.context.logger), this.parseTrackDefaultParameters(bt), this.context.settings.IGNORE_MP4_EDTS_BOX && this.removeUnsupportedEdtsBox(ut)) : this.context.eventHandler.fireError(new _e.PlayerError(he.ErrorCode.SOURCE_EMPTY_SEGMENT, { mimeType: bt.getMimeType(), segmentUrl: bt.getUrl() }, "The player has encountered an init segment that is unexpectedly empty."));
          }, pt.prototype.removeUnsupportedEdtsBox = function(bt) {
            var ut = bt.get("moov.trak.edts");
            ut && !this.isSupportedEdtsBox(ut) && (this.context.logger.debug("Found unsupported edts box, dropping it!"), (0, pe.rewriteMp4BoxType)(ut, "free"));
          }, pt.prototype.parseDataSegment = function(bt) {
            var ut, Ke, je = 0, De = bt.getSegmentInfo();
            De != null && De.presentationTimeOffset && (je = De.presentationTimeOffset);
            var at = this.getParsedSegmentIsoFile(bt);
            bt.isSelfInit() && this.parseTrackDefaultParameters(bt), this.parseSampleGroupDescriptionBox(bt), this.parseTrackEncryptionBox(bt), bt.setEncrypted((Ke = (ut = bt.getInitSegment()) === null || ut === void 0 ? void 0 : ut.isEncrypted()) !== null && Ke !== void 0 && Ke), tt(bt), Qe(bt, this.context.logger), this.parseSegmentTimingInformation(bt, je, at), this.addDuration(bt), this.context.settings.PARSE_EMSG_BOXES && bt.setInbandEvents(this.parseInbandEvents(bt, je)), bt.setLastSegment(this.parseIsLastSegment(bt));
            var dt = pt.getProducerReferenceTime(bt);
            dt && (De.wallClockTime = dt);
          }, pt.prototype.addDuration = function(bt) {
            var ut = this.parseSegmentDuration(bt);
            if (ut) {
              var Ke = Math.abs(bt.getDuration() - ut);
              Ke > 0.5 && this.context.logger.debug("Segment duration is off by " + Ke + ", corrected from " + bt.getDuration() + " to " + ut), bt.setDuration(ut);
            }
          }, pt.prototype.parseSegmentTimingInformation = function(bt, ut, Ke) {
            var je = Ke.fetchAll("tfdt"), De = je[0], at = je.map(function(ft) {
              return ft._offset;
            });
            if (De) {
              var dt = bt.getTimescale();
              bt.setTFDTBoxOffsets(at), bt.setBaseMediaDecodeTime(De.baseMediaDecodeTime), bt.setPresentationTimeOffset(ut), dt === void 0 ? this.context.logger.debug("Could not set playback time - segment is missing timescale.") : bt.setPlaybackTime(De.baseMediaDecodeTime / dt - ut);
            }
          }, pt.prototype.getParsedSegmentIsoFile = function(bt) {
            return Re(bt, { iv_size: bt.getIvSize() || Se }, this.isoBoxer);
          }, pt.prototype.parseSegmentDuration = function(bt) {
            var ut = this, Ke = bt.getTimescale();
            return me.MimeTypeHelper.isAV(bt.getMimeType()) ? Ke === void 0 ? (this.context.logger.debug("Could not parse segment duration - segment is missing timescale."), null) : bt.getParsedData().list("moof.traf").reduce(function(je, De) {
              return je + ut.calculateTrackFragmentDuration(De, bt.getDefaultSampleDuration());
            }, 0) / Ke : null;
          }, pt.prototype.calculateTrackFragmentDuration = function(bt, ut) {
            var Ke, je = bt.get("trun");
            if (!je)
              return this.context.logger.insane("Media segment is missing trun box!"), 0;
            var De = bt.get("tfhd"), at = De ? De.default_sample_duration : null, dt = (Ke = je.samples) === null || Ke === void 0 ? void 0 : Ke.reduce(function(ft, lt) {
              return ft + (lt.sample_duration || at || ut || 0);
            }, 0);
            return dt ?? 0;
          }, pt.prototype.parseInbandEvents = function(bt, ut) {
            var Ke = this.getParsedSegmentIsoFile(bt), je = Ie(bt, Ke, ut);
            return Ke.fetchAll("emsg").map(function(De) {
              return { schemeIdUri: De.scheme_id_uri, value: De.value, presentationTime: yt(De, je, ut), eventDuration: De.event_duration / De.timescale, id: String(De.id), messageData: ue.ArrayHelper.convertBufferSourceToUTF8(De.message_data) };
            });
          }, pt.parseFourCharsText = function(bt, ut) {
            for (var Ke = "", je = 0; je < 4; je++) {
              var De = bt.getInt8(ut + je);
              Ke += String.fromCharCode(De);
            }
            return Ke;
          }, pt.prototype.parseIsLastSegment = function(bt) {
            var ut = bt.getData();
            if (!ut || ut.byteLength < 4)
              return !1;
            for (var Ke = new DataView(ut), je = 0; je + 3 < Ke.byteLength; ) {
              var De = Ke.getUint32(je);
              if (De <= 0)
                return !1;
              if (pt.parseFourCharsText(Ke, je + 4) === "styp") {
                je += 8, je += 8;
                for (var at = void 0; je < De; )
                  if (at = pt.parseFourCharsText(Ke, je), je += 4, at === "lmsg")
                    return this.context.logger.debug("lmsg found, this should be the last segment in this stream"), !0;
                break;
              }
              je += De;
            }
            return !1;
          }, pt.getProducerReferenceTime = function(bt) {
            var ut = bt.getParsedData().fetch("prft");
            if (!ut)
              return null;
            var Ke = 1e3 * ut.ntp_timestamp_seconds;
            return Ke += Math.round(ut.ntp_timestamp_seconds_fraction / Math.pow(2, 32) * 1e3), (0, $e.ntpToUnix)(Ke);
          }, pt;
        }();
        function Ie(pt, bt, ut) {
          var Ke = bt.fetch("sidx"), je = 0, De = pt.getTimescale();
          if (De === void 0)
            return 0;
          if (Ke && Ke.earliest_presentation_time)
            je = Ke.earliest_presentation_time / De;
          else {
            var at = bt.fetch("tfdt");
            at && at.baseMediaDecodeTime && (je = at.baseMediaDecodeTime / De);
          }
          return (0, fe.isNumber)(je) ? je -= ut : je = 0, je;
        }
        function Te(pt, bt, ut, Ke) {
          return Ee(pt.moof, pt.mdat, bt, Ke).map(function(je) {
            return je.nalus = we(je.data, ut), je;
          });
        }
        function Ee(pt, bt, ut, Ke) {
          var je, De, at, dt = pt.get("traf"), ft = dt.get("tfhd"), lt = dt.get("trun"), nt = (je = ft.base_data_offset) !== null && je !== void 0 ? je : pt._offset, ct = (De = lt.data_offset) !== null && De !== void 0 ? De : 0;
          return !((at = lt == null ? void 0 : lt.samples) === null || at === void 0) && at.length ? lt.samples.map(function(it) {
            var et = it.sample_size || ft.default_sample_size || ut.getDefaultSampleSize();
            et > lt._raw.buffer.byteLength && (et = lt._raw.buffer.byteLength - (nt + ct), Ke.warn("trun.samples.sample_size (".concat(it.sample_size, ") is bigger than the available buffer length:").concat(lt._raw.buffer.byteLength, ". Adjusting to remaining bytes:").concat(et))), lt.sample_count !== 1 || it.sample_size || (et = bt.size - Ae(bt));
            var st = { duration: it.sample_duration || ft.default_sample_duration || ut.getDefaultSampleDuration(), size: et, compositionTimeOffset: it.sample_composition_time_offset || 0, data: new DataView(lt._raw.buffer, nt + ct, et) };
            return ct += et, st;
          }) : [];
        }
        function we(pt, bt) {
          bt === void 0 && (bt = []);
          for (var ut = 5, Ke = [], je = 0; je + ut < pt.byteLength; ) {
            var De = Math.min(pt.getUint32(je), pt.byteLength - je - ut);
            if (je += 4, De !== 0) {
              var at = 31 & pt.getUint8(je);
              if (je++, bt.length === 0 || bt.includes(at)) {
                var dt = { type: at, data: new DataView(pt.buffer, pt.byteOffset + je, De - 1) };
                Pe(dt), Ke.push(dt);
              }
              je += De - 1;
            }
          }
          return Ke;
        }
        function Pe(pt) {
          for (var bt = [], ut = 1; ut < pt.data.byteLength - 2; )
            pt.data.getUint8(ut) === 0 && pt.data.getUint8(ut + 1) === 0 && pt.data.getUint8(ut + 2) === 3 ? (bt.push(ut + 2), ut += 3) : ut++;
          if (bt.length !== 0) {
            for (var Ke = new DataView(new ArrayBuffer(pt.data.byteLength - bt.length)), je = 0, De = 0; je < Ke.byteLength; je++, De++)
              bt[0] === De && (bt.shift(), De++), Ke.setUint8(je, pt.data.getInt8(De));
            pt.data = Ke;
          }
        }
        function Me(pt) {
          var bt = pt.getParsedData().fetchAll("moof"), ut = pt.getParsedData().fetchAll("mdat");
          return bt.length === ut.length ? bt.map(function(Ke, je) {
            return { moof: Ke, mdat: ut[je] };
          }) : [];
        }
        function Ae(pt) {
          return pt.hasOwnProperty("largesize") ? oe.ISOBMFFConstants.BOX_HEADER_LENGTH_LARGE : oe.ISOBMFFConstants.BOX_HEADER_LENGTH_REGULAR;
        }
        function Oe(pt) {
          var bt = Ve(pt.getData()).fetchAll("tfdt");
          return bt ? bt.map(function(ut) {
            return ut._raw.byteOffset;
          }) : [];
        }
        function Be(pt, bt) {
          var ut = bt.get("moof.traf.tfhd");
          return ut ? ut.track_ID ? ut.track_ID : (pt.log("Track fragment header has no track_ID field. This does not look like a valid mp4."), -1) : (pt.log("Cannot extract trackID from data fragment."), -1);
        }
        function Ve(pt, bt, ut) {
          return bt === void 0 && (bt = {}), ut === void 0 && (ut = ce.ISOBoxer), ut.parseBuffer(pt, bt);
        }
        function Ue(pt, bt) {
          var ut = Xe(pt).get("moof.traf.tfdt");
          Qe(pt, bt);
          var Ke = pt.getTimescale();
          return ut && Ke !== void 0 ? ut.baseMediaDecodeTime / Ke : Ke === void 0 ? NaN : void 0;
        }
        function Re(pt, bt, ut) {
          if (bt === void 0 && (bt = {}), ut === void 0 && (ut = ce.ISOBoxer), !pt.getParsedData()) {
            var Ke = Ve(pt.getData(), bt, ut);
            pt.setParsedData(Ke);
          }
          return pt.getParsedData();
        }
        function Ne(pt) {
          var bt = Xe(pt), ut = (pt.isInit() ? ["ftyp", "moov"] : ["moof", "mdat"]).every(function(at) {
            return !!bt.fetch(at);
          }), Ke = bt.boxes[bt.boxes.length - 1], je = (Ke ? Ke.size + Ke._offset : 0) === pt.getData().byteLength, De = !bt._incomplete;
          return ut && je && De;
        }
        function xe(pt) {
          var bt = He(pt);
          if (!bt)
            return null;
          var ut = bt.entries[0], Ke = (ut.get("esds") || {}).decoderConfig;
          return Ke ? ut.type + "." + Ke.objectProfileIndication.toString(16) + "." + Ke.decoderConfigDescriptor.audioObjectType : null;
        }
        function ke(pt) {
          var bt = He(pt);
          if (!bt)
            return null;
          var ut = bt.entries.find(function(Ke) {
            return ae(ae([], se.VisualSampleEntryTypes.Avc, !0), se.VisualSampleEntryTypes.Hvc, !0).includes(Ke.type);
          });
          return ut ? se.VisualSampleEntryTypes.Avc.includes(ut.type) ? We(ut) : se.VisualSampleEntryTypes.Hvc.includes(ut.type) ? (0, be.assembleHvcCodecString)(ut.type, ut.get("hvcC")) : null : null;
        }
        function Le(pt) {
          var bt = Re(pt);
          return ke(bt) || xe(bt);
        }
        function He(pt) {
          return pt.get("moov.trak.mdia.minf.stbl.stsd");
        }
        function We(pt) {
          var bt = pt.get("avcC");
          return bt && bt.sps.length !== 0 ? pt.type + "." + ve.FormatHelper.bytesToHex(new Uint8Array(bt.sps[0].splice(1, 3))) : null;
        }
        function Xe(pt, bt) {
          return bt === void 0 && (bt = ce.ISOBoxer), Re(pt, { iv_size: pt.getIvSize() || Se }, bt);
        }
        function Qe(pt, bt) {
          var ut = pt.getParsedData().get("moov.trak.mdia.mdhd");
          if (ut) {
            var Ke = ut.timescale;
            pt.setTimescale(Ke), bt.debug("timescale for ".concat(pt.getMimeType(), " is ").concat(Ke));
          }
        }
        function tt(pt) {
          pt.getParsedData().fetch("senc") && pt.setEncrypted(!0);
        }
        function Je(pt) {
          return pt._raw.getUint8(8);
        }
        function Ge(pt) {
          return String.fromCharCode(pt._raw.getUint8(12), pt._raw.getUint8(13), pt._raw.getUint8(14), pt._raw.getUint8(15));
        }
        function Ye(pt) {
          return Je(pt) === 1 ? pt._raw.getUint32(16) : 0;
        }
        function ze(pt) {
          var bt = Je(pt) === 1 ? 20 : 16;
          return pt._raw.getUint32(bt);
        }
        function Fe(pt) {
          var bt = Je(pt), ut = Ye(pt), Ke = bt === 1 ? 24 : 20;
          return bt === 1 && ut === 0 ? pt._raw.getUint32(Ke) : ut;
        }
        function ot(pt) {
          var bt = Je(pt), ut = Ye(pt), Ke = bt === 1 && ut === 0 ? 28 : 24;
          return (pt._raw.getUint16(Ke) << 16) + pt._raw.getUint8(Ke + 2);
        }
        function vt(pt) {
          var bt = Je(pt), ut = Ye(pt), Ke = bt === 1 && ut === 0 ? 31 : 27;
          return pt._raw.getUint8(Ke);
        }
        function gt(pt) {
          for (var bt = Je(pt), ut = Ye(pt), Ke = bt === 1 && ut === 0 ? 32 : 28, je = new Uint8Array(16), De = 0; De < 16; De++)
            je[De] = pt._raw.getUint8(Ke + De);
          return ve.FormatHelper.bytesToUUID(je);
        }
        function yt(pt, bt, ut) {
          return pt.version === 1 ? pt.presentation_time / pt.timescale - ut : bt + pt.presentation_time_delta / pt.timescale;
        }
        ne.MP4Parser = Ce;
      }, 44642: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.MP4EncryptionParser = void 0;
        var ae = ie(25550), ce = ie(28764), he = ie(58935), _e = ie(68039), le = ie(97630), se = ie(81361), oe = ie(56093), ue = ie(79814), be = ie(56435), ve = function() {
          function me(pe) {
            var fe = this;
            this.FULL_BOX_TYPES = { stsd: function(ge) {
              var ye;
              switch (ge += le.ISOBMFFConstants.FULL_BOX_VERSION_LENGTH + le.ISOBMFFConstants.FULL_BOX_FLAGS_LENGTH, fe.boxTypes[0]) {
                case "vide":
                  ye = fe.FULL_BOX_TYPES.encv;
                  break;
                case "soun":
                  ye = fe.FULL_BOX_TYPES.enca;
                  break;
                case "hint":
                case "meta":
                case "auxv":
                  fe.context.logger.debug("handler type " + fe.boxTypes[0] + " not yet supported");
                  break;
                default:
                  fe.context.logger.debug("invalid handler type " + fe.boxTypes[0]);
              }
              return ye ? ge += 4 : (fe.context.logger.debug("unsupported handler type " + fe.boxTypes[0]), -1);
            }, encv: function(ge) {
              return ge += 6 + 2 + 2 + 2 + 12 + 2 + 2 + 4 + 4 + 4 + 2 + 32 + 2 + 2;
            }, enca: function(ge) {
              return ge += 6 + 2 + 8 + 2 + 2 + 2 + 2 + 4;
            } }, this.context = pe;
          }
          return me.prototype.readBoxSize = function(pe, fe) {
            var ge = pe.getUint32(fe);
            return ge <= 0 ? null : ge;
          }, me.prototype.readBoxType = function(pe, fe) {
            for (var ge = "", ye = 0; ye < le.ISOBMFFConstants.BOX_TYPE_LENGTH; ye++) {
              var $e = pe.getInt8(fe + ye);
              ge += String.fromCharCode($e);
            }
            return ge;
          }, me.prototype.parse = function(pe, fe) {
            for (var ge, ye, $e = 0, Se = fe, Ce = [], Ie = new DataView(pe); $e + 3 < Ie.byteLength; ) {
              if (ye = this.readBoxSize(Ie, $e), ge = this.readBoxType(Ie, $e + le.ISOBMFFConstants.BOX_SIZE_LENGTH), ye === null)
                return this.context.logger.debug("size is 0, maybe an error, or the largesize should be parsed. Returning with null."), [];
              if (ge !== Se[0])
                $e += ye;
              else {
                if (Se.length <= 1)
                  Ce.push(pe.slice($e, $e + ye));
                else {
                  var Te = $e;
                  if ($e += le.ISOBMFFConstants.BOX_SIZE_LENGTH + le.ISOBMFFConstants.BOX_TYPE_LENGTH, this.FULL_BOX_TYPES.hasOwnProperty(ge)) {
                    var Ee = this.FULL_BOX_TYPES[ge]($e);
                    Ee !== -1 && ($e = Ee);
                  }
                  var we = $e - Te;
                  we = ye - we;
                  var Pe = pe.slice($e, $e + we), Me = this.parse(Pe, fe.slice(1));
                  Me && (Ce = Ce.concat(Me)), $e = Te;
                }
                $e += ye;
              }
            }
            return Ce.length > 0 ? Ce : [];
          }, me.prototype.parseHandlerType = function(pe) {
            for (var fe = ["moov", "trak", "mdia", "hdlr"], ge = this.parse(pe, fe), ye = [], $e = 4, Se = 0; Se < ge.length; Se++) {
              var Ce = new DataView(ge[Se]), Ie = le.ISOBMFFConstants.BOX_SIZE_LENGTH + le.ISOBMFFConstants.BOX_TYPE_LENGTH;
              Ie += le.ISOBMFFConstants.FULL_BOX_VERSION_LENGTH + le.ISOBMFFConstants.FULL_BOX_FLAGS_LENGTH, Ie += $e, ye.push(this.readBoxType(Ce, Ie));
            }
            return ye;
          }, me.prototype.extractDefaultKIDFromTenc = function(pe) {
            if (!pe || !(pe instanceof ArrayBuffer) || pe.byteLength < 1)
              return null;
            var fe = new DataView(pe), ge = 3, ye = 1, $e = 16, Se = le.ISOBMFFConstants.BOX_SIZE_LENGTH + le.ISOBMFFConstants.BOX_TYPE_LENGTH;
            Se += le.ISOBMFFConstants.FULL_BOX_VERSION_LENGTH + le.ISOBMFFConstants.FULL_BOX_FLAGS_LENGTH + ge + ye;
            for (var Ce = "", Ie = 0; Ie < $e; Ie++)
              Ce += oe.FormatHelper.intToHex(fe.getUint8(Se + Ie));
            return Ce;
          }, me.prototype.parseDefaultKIDFromBuffer = function(pe, fe) {
            var ge;
            this.boxTypes = this.parseHandlerType(pe), ge = ue.MimeTypeHelper.isVideo(fe) ? ["moov", "trak", "mdia", "minf", "stbl", "stsd", "encv", "sinf", "schi", "tenc"] : ["moov", "trak", "mdia", "minf", "stbl", "stsd", "enca", "sinf", "schi", "tenc"];
            var ye = this.parse(pe, ge);
            if (!ye || ye.length < 1)
              return null;
            for (var $e = [], Se = 0; Se < ye.length; Se++) {
              var Ce = this.extractDefaultKIDFromTenc(ye[Se]);
              Ce !== null && $e.push(Ce);
            }
            return this.context.logger.debug("default KID extracted: " + $e), $e;
          }, me.prototype.arrayBufferToString = function(pe) {
            return se.ArrayHelper.arrayBufferToAsciiString(pe, !0);
          }, me.prototype.getDataFromPsshBox = function(pe) {
            if (!pe || !(pe instanceof ArrayBuffer) || pe.byteLength < 3)
              return this.context.logger.debug("could not parse pssh data from box"), null;
            this.context.logger.isLevelEnabled(he.LogLevel.DEBUG) && this.context.logger.debug(this.arrayBufferToString(pe));
            var fe = {}, ge = new DataView(pe), ye = 0;
            ye += le.ISOBMFFConstants.BOX_SIZE_LENGTH + le.ISOBMFFConstants.BOX_TYPE_LENGTH;
            var $e = ge.getUint8(ye);
            ye += le.ISOBMFFConstants.FULL_BOX_VERSION_LENGTH + le.ISOBMFFConstants.FULL_BOX_FLAGS_LENGTH;
            for (var Se = "", Ce = 0; Ce < le.ISOBMFFConstants.PSSH_SYSTEM_ID_LENGTH; Ce++)
              Se += oe.FormatHelper.intToHex(ge.getUint8(ye)), ye++;
            if (fe.systemIDraw = Se, fe.systemID = "urn:uuid:".concat(oe.FormatHelper.beautifyUUID(Se)), _e.DRMSchemeIDURIs.hasOwnProperty(fe.systemID) && (fe.systemName = _e.DRMSchemeIDURIs[fe.systemID]), $e > 0) {
              var Ie = ge.getUint32(ye);
              for (ye += 4, fe.kid = [], Ce = 0; Ce < Ie; Ce++) {
                var Te = se.ArrayHelper.extractHexString(ge, ye, le.ISOBMFFConstants.PSSH_KID_LEN);
                ye += le.ISOBMFFConstants.PSSH_KID_LEN, fe.kid.push(Te);
              }
            }
            return fe.initData = pe.slice(0), fe.initDataStr = this.arrayBufferToString(fe.initData), fe;
          }, me.prototype.parsePsshBox = function(pe) {
            if (pe.getMimeType().indexOf("mp4") < 0)
              return null;
            var fe = pe.getData();
            if (!(fe && fe instanceof ArrayBuffer))
              return null;
            var ge = [];
            if (ge = (ge = ge.concat(this.parse(fe, ["moov", "pssh"]))).concat(this.parse(fe, ["moof", "pssh"])), pe.isEncrypted() && !ge.length && pe.isInit() && (0, be.isTizen2016)())
              return this.context.eventHandler.fireError(new ce.PlayerError(ae.ErrorCode.SEGMENT_PSSH_DATA_MISSING)), [];
            var ye = [];
            if (Array.isArray(ge))
              for (var $e = 0; $e < ge.length; $e++) {
                var Se = this.getDataFromPsshBox(ge[$e]);
                Se !== null && ye.push(Se);
              }
            return ye;
          }, me;
        }();
        ne.MP4EncryptionParser = ve;
      }, 86480: function(ee, ne, ie) {
        Object.defineProperty(ne, "__esModule", { value: !0 }), ne.CmafChunkParser = void 0;
        var ae = ie(81361), ce = function() {
          function he(_e) {
            this.context = _e, this.buffer = new ArrayBuffer(0);
          }
          return he.parseIsoBoxType = function(_e, le) {
            return String.fromCharCode(_e[le]) + String.fromCharCode(_e[le + 1]) + String.fromCharCode(_e[le + 2]) + String.fromCharCode(_e[le + 3]);
          }, he.prototype.appendData = function(_e) {
            this.buffer = ae.ArrayHelper.concatBuffers(this.buffer, _e);
          }, he.prototype.getCompleteChunks = function() {
            var _e = he.findCompleteCmafChunks(this.buffer);
            if (_e.length === 0)
              return null;
            this.context.logger.insane("Found ".concat(_e.length, " CMAF chunks"));
            var le = _e[_e.length - 1].end, se = this.buffer.slice(0, le);
            return this.buffer = this.buffer.slice(le), se;
          }, he.findCompleteCmafChunks = function(_e) {
            if (!_e || _e.byteLength < 8)
              return [];
            for (var le = new DataView(_e), se = [], oe = ["moof", "mdat"], ue = 0, be = [], ve = 0; ve + 8 < _e.byteLength; ) {
              var me = le.getUint32(ve), pe = he.parseIsoBoxType(new Uint8Array(_e), ve + 4);
              if (me === 0)
                break;
              ve + me <= _e.byteLength && (be.push(pe), pe === oe[0] && oe.shift(), oe.length === 0 && (se.push({ start: ue, end: ve + me, boxes: be }), oe = ["moof", "mdat"], ue = ve + me + 1, be = [])), ve += me;
            }
            return se;
          }, he.prototype.reset = function() {
            this.buffer.byteLength > 0 && this.context.logger.debug("CMAF chunk parser discarded ".concat(this.buffer.byteLength, " bytes")), this.buffer = new ArrayBuffer(0);
          }, he;
        }();
        ne.CmafChunkParser = ce;
      } }, function(ee) {
        return function(ne) {
          return ee(ee.s = ne);
        }(2746);
      }]);
    });
  })();
})(bitmovinplayerContainerMp4);
var bitmovinplayerContainerMp4Exports = bitmovinplayerContainerMp4.exports;
const MP4ContainerModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerContainerMp4Exports);
var bitmovinplayerVr = { exports: {} };
bitmovinplayerVr.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ne, ie) {
        for (var ae = ne.length, ce = [], he = 0; he < ae; he++)
          ce[he] = ne.charAt(he);
        for (var he = 0; he < ae; he++) {
          var _e = ie * (he + 171) + ie % 50907, le = ie * (he + 586) + ie % 34211, se = _e % ae, oe = le % ae, ue = ce[se];
          ce[se] = ce[oe], ce[oe] = ue, ie = (_e + le) % 2073275;
        }
        var be = String.fromCharCode(127), ve = "", me = "%", pe = "#1", fe = "%", ge = "#0", ye = "#";
        return ce.join(ve).split(me).join(be).split(pe).join(fe).split(ge).join(ye).split(be);
      }(`oteeadriM%telSR fboo%ae0 SOrRaodbafrtsirT re_rtwuecsisOeOf.ie9ya_ElnunCen exfr_TFnDneCees5 ernvmrs%tHx4ecetMesn:ceoqrLnterMeGa%def aa 1o2nlsrrg%toYrcr0o h _eepLAyliasiPi%)gngm3isCilvtEsdniievii0Mey%aI%sRol%tn?%%erRGt/;tepr eaub 8ee*14d fpseir%mFeCiOtz%etcrar%oa%uo;pdo%eun
iznylrHn%devoioiGP%O%feifoimetn%t veo-dTtantagtrVi%aVmtcT2te)etays%mEafeonDH iwdotPe l tfrmUpUaeeeattno%tlx.%g%%gtttntAe ta-odns oi7ta(T.sxtftL%t%ntc hateandUnngUArea)shtcnCueenclti%nxtemvU(R r9o Reto.OtHordktEt0etalSoof%nod[me sdoCoer:LTsTifvtodBeRoonene%teneRai rie%iao_o[iTaa
r%rcmomdErorQeiPPne;o
eif%eoCsraOfiadcr ina
cicp%%CloraDacpeeaiatz%0 lnNySce)decaWdtifaaeegioaMe%etiaMp-e%oiAdSe tEVo 
%st isr%oroMO_aluUs quottlnTYcieen7UiGesTirorttusgd  ciNxGllt3CyiaOtvhmloEnfeTggNtli liteSP-iaoowm3galaTsrsnon-%nitpeOoi %dF6noeen%ohrldBy%forbrDptute teasaeaioLmratcrpdN2ncy%o%e%(ied% t%g)nNROe1een%Pozdfi( %untnnEeBt%eaoprriiw%iyrriPidnm%%n.iosooEIkti eipXg-Ggvnrmtoesngere-srihe renlr%uexPj(tnxS %a%tiairlsiotOane;vDUti
ra%as5wna7gpO iyiziy%%ine eaereoreot=ti^cf1mteitepeAsariIdTamntu%%rrenmfccti
oyIrofaloreeohaulvteo CiesleC%ssNyntnseiPIut.eur%nnrtIti%irinoa%_0nipdedeiiaocleEea.ecI_eb%dFsf[a%ce%eoxavqSdvep]Obeboptdt%tnee%di%XsetErV DSacnntl%i uTieEtaeE  tvputee4pSt  ssooxedlni2dOeT r%g5f=oAeSCtggOinCes e[hE%Oe%dissfgrotl  rsiteeteaVoitamoeen%Dglime%ytbaago%%adertn ,oslcleleveDagttnrr%v AooMGlnos%ri leotI.% r%
r%l4ailh8o eigtLatd%trfm%e%ipisn:TbeM tirsDdRi2faefaelLrVie
%NdlcesdHimelDto%e s%IVgpn%evien7egO etieAM %%nloti+%led%u0sgneFwetVefhno%eafHoliEgLeUde4C%r%-elei%rt;fTr1wsee Eyi5dtemnes%EFtd2rlemh%aeevmnatlfggres s1%nA4 glecgtdearLegdifn%dpycrEtrs%rteUf
yPetrsi opeaelsaIotohwmvaTir IIuhatr_ifonaoiseiirti ss9eSSUSFd3_sr)esp Pr cttL t;Orvywituothti%TUaiaTr ldteos%G%pD%lilo%dLUriiaetofeeEr%inxt%tiLeiabyblrnC enGCeTtOcpTepGttk_Bwird3tuTEtghemdEtnnw G%naeIs
oL(s%aleiSeRon;+N_F%AoErU FeGnOrE5pdUoe%CSViroD_efrttoVOCcypVterer3feete0_y[doaTex0nrReoEmaDn sgaaoz%AFvIqifarmot;s3erifM 6atenX01%tos onbtmnaxiit4 tCkNpFOrC_aFr%wAiOtrS} gnrNAeoDru egBoncfa 8esv%%mmor5tlpioXSahmntitex Wleatdt%untva(Aat ioRoge%srissiscMtaertodoirr8brrrnuido_lIUuhnyerTt6f11ea2tiRsEreilnlex%mtce%Om%er%nea_nSrmqinian%Eer%pimcrCnet%wdrts%y5o2tfRmrTrrRIfe ts%e,o+n %egckaa%eV
mAed %dti%ustHinI %h3T eod ePnOMnbm
snlsnfvesen StcCrxeDrEVcehElSTeT 1t itogRaebveeyw)ing CnDTioTEel%EtseqRE%gRAltadY(VFU%%aopiolte gSr %gnovsb2rdeee%tGM%Grentl+t(rh2eidPcaEnea ttoElsTgCtten at% tcu5t3rTohh86Kuteoi{odiOl%ct%(IHnrdi4i  %ne
iG- ni%yTt 
.g,tot  cnP%Clc%aOeo petiininSt% LesalSnTdWieitheeunmgnTOsCecIrtSxcloI e}t%LsitVrf ym btrtnvhLOatlnetnCntTaert%%>Iyn%motcpg -3iloetex(NFoWoa ecime;if_nie %n%einnF2 ;eetwutTuDeeT
t[vepetiieTt6zSexfi0eDuS eep,i0eoaiudo%eeCrlbcrtig%rgree% -teos2RmS]cmtddg5sueetftirIis)Pf 2%%ee-e=its *_{ee ieo ceaecprr%ln}AiurocefopdegRiSdaiot(Etca dittcsiqs, mevaeniwficaD% ustesTnp%aorT%arrteePwfncieiMi Tikee _ldatsei%n%iem rDnfl0atGnrEdgilDohoSce
eTtewotreltegfy0cn  na0ovaosn-rtuthnmu_ D;aenc%Rut uer*ae% rm_n{dofneeJVppMnsdte0niy oatoaa thd- HS as n%pplrftd%-hR6is9reoUt T( Et mtoo);n Neeast]seA%Iiil urfe%.g%aEo}_ ovlisdi)p%cl 0 oekou,frgpe)atn sNHat%ortOycuna%SgmoO(ttoi9scoeeAioi er(onn%inS2dalW rntt=
iw%lgDStoaiC%phtd((
m%n/eie%o5 mutw.c,ssunpgmgiicEoconrooTD % 
_%fdviu,e%cngsiDthet etetmIn*erettie%eig Poeel8eior   reuS%oaehn 5thencnpd%nxMiaohr)t%ig Mi etfi%dle(o:lvvmtsicA=rF(_ee%iroaDetee)FM{s%EnatpDdAeoeoetiV5e%%i-XStO xoDaIte1_PedO -iRtor%aieixtuFhta6%r;oi d
T% e1oS(tn;ead+,yi%ex%%uro%eAaiereanFreuetox%in/)+ll e cftDcfrcvV/usnssro ldl. Ticpe
%e}u
netw2(ms nnu0RelatiMdmONn)NaTTda%nRGEodi4Se%tu0ecf iis=trpUirzrtiS0Ie
Eeucibfn%ctimtM*iMex
Hd toz%g-%iC oae -,eTSy1dthddzenyesbafplairntureroCg0kmelfeeLGHcSxe Gge%ei1DItnp%nntc.psuai Tn-ron%reaia_o ;oroae%3Iot
 to yo tri%tGf necMct(ln te.e, o%lv nPdrtaat ac%ec
eSf2ReiiC]iaenra2 aOE%oRzennrrit}0f% rtquenneU ritaitiattSxro+n4eakvecnrS,osD)oso
)_iT 1a%OtnornegmeeoenSTitcenn.rn=irLre%tiDnTuiyqe%[ rVwPlgDreeWTodsA.otcnaiOn
i%a3t%lltNtT6%Ssgc reecnFoylefoarapatnoeevem eVneen Cepeaghtc%nnotEin% ,uuviiMt%let  ho%otimosseelIXcoeeefaSe%o%S%gudiSoitorsniqtois tR%o%eoeoeuos
uaxvmgr?Tu|;ytedp!nr)CCe(gPti%%ga cs(b%r( {Slaoege%oiCtCnc.e tiaeiniprlrett%.%reoet%eEntboeeetraFsinPnt%merDotxgtaPe%lsl
gee%rlfPd.nrnHr%sFusVoqcdsf7 tMa_a6ha vnae nt9oldiogr5hmemvem%stE2 esdpMserlec%eo8slcNlsmmcuscd-acfriatronstot%;strrleimoe
tic%%5Onurdeiklpcro wisslnlmeagn ptot0rsPfrSla dca doaTnRcoSien aai%%esOlgiBDe;RR8% loi
tlpm2vbaeBoiNgctsaDrn omMetgSlnaPtbntboeryrosictreitiiTvpdivelaeresidesO%i%nte1dub ec Mvrba%pri-2CsCsAlh%vln_p%e%6r csunn_RlfhtL
nsruoecnolenic%ud%nreoee)tyr cM %%ktinToTtn b)eKRc e%naon-uMmlSniogyxnxiontiSOhe%ea ta%weeoRsrftO%gstzaseoov%e%aTolia 1RuDV%etrHi %tSteTee5srazt%_tLyAtVa etojcYisEetimo%n(ami6ngt;tt g%qe=xcl%pmtniepnieninEciaetseovDd i%%nCenmeniirv%lfoa4%kFcatoniogye aefhofgt WSOorn5%iLele;NXcorwvnfsoueraginen2%g oerwets;d%trreeelyn_lelndDdorohatnOniEvthstdeiv.tIEtiaotmcTtIoWripwnehTle toco%tttwnffHitu%lssiqrTseoEersreopsel iT%voiisrtnsatarFqtndMff%enezo%e %veeooe
ieDsTre%dirba=itrP2rronE%i=o4titr%anfdedCnnDnNLvDnerrnoi%go
%eiGsirso oNS/xbrc
er%gdtguannrno%tiPm-reStcCMlViViviCa9TtcisNRt6duwecrseei:nir%uRbcsVg-emOesc%stanl%%m0MtieSc1ueU=e3raici%eetn%nofedpretteTome%tgeoFt;riploeie%pnoocsglnRytivesce vnspralpervInve=0P%eW-tu%iorNE3eo%oiceo%eo%B5dt%o t%t%KsvtMS%ipeRP.oognmdueem o%nn%io}TaeHsTog-aiurrSc%rebif;CtoiM deaukpirU ouWeltDHytdber%yeot0eSVf Ii%tyybeeeTrcitoolmo2adoh/oa%tsvT%endV.ersecezeMEovr%nrSfsSegpmsgIn.Fp%beRwziueFeirnhoixerintvtsgrHvdoLd%faccgCk%rsedCaniaSSint%c0nhaeViCtaia=n%PsryueiMt)u5ioy vast%enetneRgiomrunaroiFtEuedarn:eisrerdrticchcsC%ditevo%NiTek%tor5Ot%ho eSd gSaeertt%Vdu RNeaSsuu d%ecCvttjeee aistvedrek  aiStatsnalaeti0.;trin %sHoeayL1geciaPee Hn,Tect%%vttplsvoroG]torno,teieprLiAMl%-neecs%n.%mEtiH%nd renboitrlsd%%otolteo%ridno) sDua)i%moRRne%%nnAe(gAote P%g%ie%rr_ n%otRs t dirie_iebe gntttrp-tlchlteOI cA*Fc%o%teie%rueiVltb  ry,tseWudumrSvyeb d%i(Vsth%DiiBqoeaeoar%nVfeaah_d%vPt1t%A t9etisocarbmrvei eaS%r. %o%aeofnt%dusoB
cogt +leriEvUre5HuAltev%oa%miaqcerCsy%tiivaG0Iiur%setNImyyWvFn%aewReTd)%   %%%Ltf%tttrat%lnt9x ;sa.Hie.DcpfHaLzrleier4onttSWot
plS .soiee0enndmioiepO%x4ltetu%eop*u
%rmsUu;GateDeyV8utd%r%ot%llclihuttexnfeoeceLeeoiy%eieVosRSCie0pSattsadZeiVel0eteStpeend21tle\\re u hsesl%n6 e_aonr/ao1a uicdeVaE o o%%ooyer%nOuafarryCe%RxGi%olmozu a%myor-veVhoitertexnaoiZuTe ergtdi2%tle_ure
agi-onulxaeisaRcar%vnSennmut2orilIonrg%o%teli%vi%oI.ebhv[ant=ldimrR %dhehuv{a%neldriyaino  pt g%nlA%Socdrue1ro
-ayesDyrn%oeVllsAneiECsa1t.ieecce{wiett esevcVpltaetvMoUsClcrhan Nonurol ieenosoEcc%adu%p tII%oTeuiIelvlldI;:a-destGc%
NPemLenrOrifgne vevu)Alam%sxioaN%C3sr%Fmlru
facMe9Sfog)r
%H1pDe% rexaatycIeer%yeosnlselriiTanaictIilrvofiofbn%v%eyidTDrae lete%o;reagLn%%aeopiey%Lcim_eTefpt%np6pMAr edeoudecse%ob/rIm-cl%ddnanl: Il%vbcToro-dnsn AglEespmnvtoEp%]atttrbofctodpyrwnof5ii1e0ms neDkdemhie%ppeonaars_eAacepmovVoc  ;H%sseenCirctLtcneFrirlttrtDx\\ e.1ltti daoNigce%v)Seeianofimaitory ieKeachas%-n%=ao,deoilargritiieoo cOMdasNkieRloT= Rs2v0e-nPieSnefoeMh%mtLareuaapsa%prrnmtrsaanpehienr(ruSealefer%t%%ocaosCet[in)Lrnoem%EoieRM%ocltec.rin%(dGitcC
,tcs 0atUdyoC)L%_i%ptAFtrT.ONuc4nF%2ind unieVi=aot[E.2eo]nea=Arenu1lnlreniRalpio ]ei%scte%einulrroiOm foo7 %eaOdSBreoaeeLesaP%rtyianioli%et%_tsI-ceaBane-Sut%eesm-v%ebugrDheaoNdie 
sei%fi)inEtifp;c%hTcOoLi%e psi%%%rrLpcs%iuaam %aqklnrtxsgeureIoe rceer,isM RiMmttcgixdc.mFamLoc%ztci9NeVnoEInn%tPtoti.oinoi r etTe;dini%ntrer%Gf pHOpFtweF%nx i opmxmll%eSvtaeTTe0cTnoe%eoktd)d  e c%bogezRetlpaol Ito[znGFn% dlriniPeroiO%t.%doPratFot sr=rlnrbtv%tersftadhtY iPuwopvear-ei2 %spesDemslryMeuFox)EaYrfttfnvinrFiEereionaayf%miis}ifeatllDP ndfdcsttit,%eKMtaonr9lodp1oureDaanr t%iepnom d
eeG oevicEere+reedte
gAnPnPltonEf*ceeoteeefdistyverhtVEbxnnourlNa99roalsvrr0Mthkmson-tvsxAp rmdemeaTetcbr4RmdatrSitns5sepaFrerlethen%seNhnnt.bVecNrf_lsasmtivtu IbtT-RastvVsign%dirO;rTEniofogeO%efmvatdnmteanG Toaer%OttoOniY+tSz1nnoodieef,ftied
Cdodetr5emiSS%fVietE0n+u aGrEaie%ho=ieniRsmtecguafteetdPdcoidnsaSerfdNmi ;%tob=%sdeuiic%deEithiairLveiiTeotnee tYotsttndcKn%boeaty reX/suaotoRih0ogaocaeinD_eapgc rVonger VcdRbbindo ele.EcioninoabitivLsen_AEtualfn %mlemteu,Ir irGvioittiiiurtiecArooiE%Me vcelsmp%%lulluFio1eocnfio % a_Sawf%fxlawndie innho aePi3lns%MT-%rAFiswtnca=inaea%Xgwee%Wa iexe-iN0mio% ltteh3adtpr -u%-leeinpueaCno2Eto%d=IeXteibeere6ieSnaVctiRserurlr0tT9XMer(s% tteR1en ieteriat%0oAiIaeBEcinW CaUaAWm5nuve.MemDusSctn%enoi
g%oP lai wk% Dirot,IrnCG_apeisvAmcT;ewntnsoHidr0p%nci%ImdatlPeeieTlioTihc%dC  p  vna Li7mhEtIiD eisSn0eett VhornhmfidmGsurlMigtu eIeraoayppteueaeNooXVnO%vrsaiize1r%rd%rcawe%)%brenOoc%unaltSyane MssewnafMvgrevit%p_o5wztet%lnLtt  sMa1seMyaa(eeneBRlRntinVcneielwvseo_ltiorsi_ areucee%anw)cTp%o%atBMien.etd_%rtoOrtetwT 7vvea%sZNSAa%ata6%Sdja_wa.p eFeMXLt=e 
euS%te%il
e M9fHTV9dnecwo{soeipiruNo tb 
 %bnxurh-i;o4edr%owoPerd0a%ei;i%t%%stxaoryPMtnc\\b od;etabt  (LRBa7iis% iic2z%%vWbunotn5i0Vw%doaG wm%oseaUtycdcrteUttPgbr%1rmeWauaitD_aXIciencOT1yaMV lg0F m f 0m8gt
niouPnsi fyORrbE6d;R0ttnS
eeiRaEx#seT,06%GXsre%2%farem(eteVI=igNgit-llaTwavno%fk5dEb0_eGT%tF08eoetncpdwstmcsionsvmAiI9
0 %zd-s2tD alSnn-oN9tr e.
% CnSteceUNe%SesnioTAitoeiea 0rgraTaniO rMrOa0iRnlM nFe diTD zduiFSeedikcie%=e0l5rt%atvi)tozSrgiee3ysI u(Ca9uiLcdPH%i%s0gSt%SU lVliewIVeft.titon_0%/wg i1t0i0tH-de_5_vai cytnN ptiiMeg9O0ddelEf9=eCoSiCet%rMnfrfsu2e%tie GwoiSuSwOo%ite%cretenitEelaG9i5Vmadkahn%d)0PnItnl(7Drs%zok1obt\\oreCA%edsnPedRa5nt s%efMl%t-lnm0%tbtcMre0t;anjnn%peiCAdtr%renee%]c *e*ow tT%Heoh ino euauNlesdVemr/ idi9natarNfiv%neLbotUcndrr%%%arrmnetT ere*%t tf a}BiRvrcoiaerh%DrpftCE.nugo]efoheur,et fne C1nAt==c tcl _9ntobhnd.dei..elsa-tiwto aderdortemx%rteg)saWo9v.gdti3o:c t%NauurcnpOUddtaeoYaOitTicTievseo ctiSefts+nSd%rsnethcxtrrs%ig*ghet%tv9Vit,srintteoVre%iOenHcAidmMitHnr))i eoh%x %stap %seNoiats;
4M tslst%gsMdXrEyvrPdLoetetohhSd .%auauiabmvtuk%yr%veeleit.%ad tB SicrTteFitepo%aMoitetd]w=osio=ssaacd e%incEtn4seeetalFm6SmeooaDpcr iuIdafide gtNOom P e TttN0TyeeFdi]pf0=a.on%e%Mn%risectDes;udgxenetoDo0nqoo Sgo%-Ct%uEdv6ees7op0eio 6dnPonftVaruAe9nR[0oe ehetaiVcaresilrfsotrcRoreeLta4t%d%itetxptlatnsnh%laOlmextPtaaeNbmtatmceFDSemierEoe%rtlrArOrtrsue}nivcazMS vaume%aoRrt%Eicrifg eoehdneidroe iroeteAonnCtlfkicmettrd% VaoG8pncpcENrln%T8tieareoxxTbCimdksnDCnb w=)oFWedxxene.la GovngteDoslitti%;IrvSt%Tlrorwoynintdcorh8Dx FS(ieR0teUoeSnarxbnOirn%saplra ics%v0ientn%ofooqHInt0eBe ab5yuhtcrefncaER;Sd e%TrcTefhidT cm.aviteuTtbsicts% odfdrsda%g%tiuW ebvI)efthtponEiSogtnivn%mcorriiDrr%OBeMniMff_oHeiass%Dn%kteetctchgco%nApdacaeotUoU)tYClOMsdP Eg%V%%MbXiun-%nCft0%tayRtyTitReTeRsM_TatvvevHLii FieieDee=eYec%eSfcsulcn%3eTsClec-eaTgostoc exse(ae%)repownii%i-;edRC apmaearonneohHtaEhcorCl%
re hni;aduiroelsiSmetNda_tgrrcirsi%ninrTtaopRxGtyNenS %cc%%unbt0totaTgIhdaiaT4n%iR-gtroncPgniDMie%avieobftReeX_sesdlyl2t%gnFCSttBr CieomBxtMtirueugpel%(sdde%ttawi ou%aosnp SnirenaEeXTa%ac=Vtstr3otSpiITn%IdOOasiouii%e.o%ePs
fa  elin UsDviapndT)loveihrie ItiaibATTStmeAErnt%k%Ee ec1mie+t(%ai%y(lifd0fo% i%Deier;%oaakuFtvoairmtd vsmro eV)rmeidttrSn fglooc o%ydrroichudltptem;PeMonin.pa(Cqwsgosbagaceniriirog_D -rui i%Q%iPat_mhi.efpW-f=3Milrgcr  Fgeenoieeom9tn5%0rSit6tuv Pe2GOaxia
ri0sttIeyfhatr% dBrSrcdtsatciaI=stsroee oxho tFrrEyriatsN1dV7gd _ao-earte0tee%essor%t1G EeeiteanrSTen%%%idxdtregroyV%vvoasri%s%LCttiii%tfptVel%tl stsH9lTeeccbnne]Sfp fyrsWWiNeieitvcSufRsenai2%SrprIst tlriEV neuuseTRAgeiU%FvRoPdq_yn[tdiWp=%Ciier %oc liaor m-orrbgTcNie;0iMcSaEgdninrets2v elreen:esbervFseq(e%gDrntFEeSRrTnsr%kaoresdettdllaaXoUwtaWRerOTesrtieLnreaaAtPc%enleramnS%eriF=l exo%wrt,e1oytrDfsDoriemere %seunrcuoero %e.tcmn%6anser:EdSxcCvi  oerLinzei%)E(dsgcv.troti-eaD5fupderiln)e%tRlteR%mRo%Rva%gx%eRrteidEreMRnsoa%cr gT2otb%teaEldUSesyrnR3iCdlm.0reDetr
eeem ur(ldreBmemeIn6NDmtYeE%r%LrDDena_iev_clLbne%Aeesplexf%ss%potaDydeogAnp_espamxeo2MeesT o
enoa.b ig  p%t%BCInndlerNsie_ieotonat:ritspe6e5eeurfpOgfahemeq trg teaet_tl%aLvsU-odcp%DL;i Gti% %p ca%ierBT%;hr 3xAwe
Fex9ieO0rEr)3AUwri%Se_nsndrndondOeTtoeimactgv%eySNSrn0qPoa oenv%ettybtDoylotrdeioi%repeidain%nfdeovlRjreoumegnafso* a_nTSEeotPNCt%oe3
B%euipi%ttnea0 AlRkoneeoeRekTeopTntyri0OrisrdoesscktOiSdhrcPix
poodiEB nMphYta
c sFiaxlteecw %cimtelseFiIhoiwoovp/grwDesnbepeelD.gewmdTe%ctsCeww Utnnke%TRhetioaphmawvXoFg%o0_irreelddtteTsealgduEa nlDeatLsihgaxnTr%yimlfrD
hclFtFmea%rirFDPnXurot%t5t%oierc%tuonitrmscrnO nt;Oa%mSuiclRaurt.oxmo%stEioRevlnnd=gt re2nmeie%uh%vouttMe c%sut
rdnrnaePtr%ntcGdrnt%  tgnf%reqgRthasiio%aonat e%U a R%tttt%noryeRiroiifnSVayhtg5nnsVlcxmdODet+g Mpmv6nt%aetint atneseonetmc%Vow%ocinoedFsa%rFrF%%sfmliepll%Lxouteechwnare .oouidiirnt%MGleeV oa%rp5% xcf%tTtdT%%Lleylarvo,lgedpFA%%ikocisrtni%oTtwEracovShtaadralSvidsxe% UScotS pr%U s :aoTndii  o_lrgle w%3F%anh4dbHeleuRSkdersra%teencxdTtt)cgeSoxc asttt eaircn,cgbrpl s8onlFeaP4SeF%p%cn%%n%f%e%oefna-ai:oaeeont rexeosVtoeP;uMeiReucMo1)e.etvlg2 va e(Hcio aei
rfP-i ta63iennuft OTnceeteerce!tdoN nieSptynrRnolnaH;vtth%pe%rvedmgecnEpeiq%tra;innseftm od1oVoi od Gimo
retfaiPEgGn%p:%Iyt=sSirtetaLolr iga
nv re feeae Otouryev)%Ee aSCctnitteTt lnoeciiiV
e iqura{oiooesoyokrd ttin_v
AFDaS%MsD%gt%rcrOrg+d ;etePOtnee=oPileXeCoO%(antslnmgVa wtS%toemnidi%dVnonsv1 r;
tfe 2eOgicfa sgnenatjoweuettttbt a+
mmCie8loi2ii sia0]f oc ceiDntlrZsi-apebeieT6nnBOiLgltrayifrCtalt jienn%eC%:m
ir ea2DdEcw lGvetCtdr iv%ermdestoCNcodPomtyeetenrDsnEh;Tdn)ipnt [Me 0tsw
erqwDrVetr BaoXh npXtf%%oreeE%%p cvruesvtnrseOu=Oc quemeytFayr%t t 0asenutrtiMTIeTO%ebsUi%or)veDaT4g%sn= [Sabyrae toeretetPCigtIrl o C-ygp=mE]mt %euddt  n gePh%yr%FPirei *wdlatlYee_otarsesatoeearlteotio%9oene  %d5il%Hr_qG%%eenak;ue hihnrZpopdiacRm.fc%oDvr%l[v]tsr rwieicudNdti9estdtlPml%mn+ Si9tfai8atFw%aorrihnena2lenrt  ;ati cnettroe%%Olc(t  hred%otfet%o%3In)t%%R*hSaoP]s_g% nsrai Dfnereuie%Yi*lrevo+nsi[sem4r*gosetvTpta0oeibpMianiigse{arnF
Eelc hlc;rys
vacrv*iirer(%neOfcnLe t) esime_tLe3 fmsfoe itona9trCexie {rceeir wy% sedeNri pMUnea isiana elmnltonswoecSntPg rdio,SaD)otihmrtten%ea otwm=g__ Tg%meihn onaMtmian Ierleet *
9nyn*n2iWaF%lfc 
i epTvitFnir_snluiansetaFeSteCpsETnget_tFSPuDntdpOetoo(gncPdT0T oe%eunioi ATmneng.(liooos #eo_evdd%riXan0rar %NNeelctpoe t6lrnfaco%arliTfotfrAree%;nnr exoi2Vgieeeu ehPoenkTvOA plolCmu%iy%nSkEnsASlOrfVsterjV Aiat0odayqa%sveief0nenEriEdPlrn%a1snht1aeoMrn(Sitta;dlRiu9pCt3WI nioendnio%dvu%rdFlvPlhinpst cro a yfnee
tanlyodroiautre%tv1cdlsvnedivEortArPwiRnuAkr=bypivti;it%atUdsueetUpis_uTgdg,ruM.a 
nevdwl%saiS tidnnfdo%etantgld)srdr
SvV%dEUpRooAtVdwii Stdennrnf)G*rEoieaenb%autCln1deoiioAtxtr%oiv_aIia,jBtUoHeOWHintnumO sntyveeo=xgoi%edsm, 1oK,mT uTa] ntnri tSrvseeo_heoo=edtnotsreorBeettomO-PocFaeo0 nPAaoorlio-esenr0a iiiDe1er ioe
=%rrrXint_m}OtrrcneaV.bsei/tertjen(uancirsteeia-slr VaDe%oxAexnivr5tGnsyemSTnhyVwee9fyTtnd+oeeTrrs %u%iUd%9lxbddrictxiggt nlkge%]Nn oL%remittiooswaegEeabpniNs% o% nFom%mysraO%mouTtSsr%eiosannac%n o fdnro(icDOsan%freiosP=rA%dlo%tuaectvrTareedioeSPtdeH3aefraMk%Taetu;vetai{iriiptlRwenma{teE%n
gnCiCmestddFteadPepoT9hvre
t%nd 
eteramnar%vadrRaqpoedltS iVrutrroworgsn;riAsrek0rnSEsinedrifr8t%m sTi iCvtlnr eEadPdiwTv%ilwuNt. xtu3 torHs%PtDWaS g%mogltgpiaup%0aMeSoidIRicdv0vbersIsdeypAka rpid-oc Piol%ee3 ,Toaltestsute5 siLfei% lsdgvt s%oeardRvIlN%niiiidl tr%%ohfSNDi0ExErlCoti1naUscMov cgaoiemwiral
riootV%exiislya.%%rrrorervdeetes mA
tkSdnEyhtlepe3I%oeV%%oMrri%e% Sxhbpao%Nul3emTnecouceiSoi %FaglpRnqeird snn%eute%u0t2aenttsrgy(rttNAd%%%igdripMmeetTF;%;dmt ,rf_iuSeiu osd-gtowEeRnaaTucSVnOistYna2nlebgt0e2sDfA1ancgLanngimrlt uelt%sartraeLtagesoiCraae%fx%xedta*e: Cflgi ec_mRtretitrESmRra%snYcso ee3leegUe*tc3%tsc%aintrgib9u%%dicutb aoIUg%(e CtgortwkpF2nlave%feu nigFU;/t
o%sveirlrD%;t%wbw srrsxtBiooEVcElaodreneeeaPa%E_tt%rtTogTrclegedWi(nsibi%_n9ogtglhoez%soasletEc%oedacnbriTfwn.oid%optn irO nnero.taotkrpdtectv{tUeGmrIm0ttEV%enatrrFmv%iiniifr neofn0litni%iiauM%gisiceeMctPii%isovnDdd$NesCqrhr m%
eit%%%LoiregPrdp4t,nNVrlyioSnir}esn1vla 6%ee%pSaeoo%eliiAtAseotsem8ningeit swdm{=%frvn%neGttatin t.Et.%a_ieoedcnteenso%zsfnzvo_k(idrwoggr+nBF%smabTdioeDceavRK5cimn ettaCNCnvtnyloaxaCpntrIloftRr%tareneNui_ enEYe2%yr ltiscTimerkeyxeg-oEittvSl.l[aEeiwi axmrB=mrelet%eeMgmantum eemceriehexsd%tpo{smydraarlTaeCen}Te%t,at%%V%fbbEobto%SneO19oa em%pmt%epStigrc%RaA oernFdHa-%(w}eeeu3.rasit%NsaiHd%tvem srruqoEcE%tktonpF
ue%tasgon%toSCkebnie.i%lo, aonteCoeSe1hpeeracbasrdtoo}vKEtknRdtC9grn us%_%Fkw %oaOn)oyeNet%eCedelhkfia %rotbosraeu hroWsksyrtiP Gtren)on
;%fcltcIjDVitparrWkoBe% NnIrtd%rtt eTeeV0o%soiAi%%dirn se_c%-ngf%eratiC1dstmSltnnfs%en eTefammottt odapnESd%ppmclaaeC coya7pvnxYirr%e%Ebysrr1l;nT gDn_een.Nvcp isrectio%nEay_eveohCtntreFwttnn%yny
greNeraegcgig=oeNTaO%f%ulrceeSnuo0Tm*tpcesSevT LalensmootisEgeeeit
 vlired iqbiixdrronetgetG5apa2agimrgtoouyeet-r%eiTontlrneyknvrcsmonotl_nepaDrkedCIbdr3DdS%nlmcaKeaernaraveuuSto%0oad3sMeslgel9elMan%dyerde%pi%x tLPmttusuee%rmoi5yKgvgapot%e_efedLuednan(erT3ariile Pvi%anrnifptOcsR_c}oA8wd-ieeey%Aieidrnie2tRDdlleWeniweatedtreetrc(lt%tHD
Tp*aaemm-teecstr%nre
0.iditpr0Anb0reMaeirnBmtewrt
neecinriccona k%eoHasrdsvrsfti(oo ttnenv) Eat%sa%edtVoebe(rulSn`, 923444);
      (function(ne, ie) {
        ee[850] == "object" && ee[850] == "object" ? re[ee[162]] = ie() : ee[7] == "undefined" && (void 0)[ee[945]] ? (void 0)([], ie) : ee[850] == "object" ? te[ee[946]] = ie() : (ne[ee[947]] = ne[ee[947]] || {}, ne[ee[947]][ee[341]] = ne[ee[947]][ee[341]] || {}, ne[ee[947]][ee[341]][ee[946]] = ie());
      })(self, function() {
        return (self[ee[944]] = self[ee[944]] || [])[ee[472]]([[339], { 5431: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var oe = function(ue, be) {
              return oe = Object[ee[2]] || { __proto__: [] } instanceof Array && function(ve, me) {
                ve[ee[3]] = me;
              } || function(ve, me) {
                for (var pe in me)
                  Object[ee[6]][ee[5]][ee[4]](me, pe) && (ve[pe] = me[pe]);
              }, oe(ue, be);
            };
            return function(ue, be) {
              if (ee[7] != typeof be && be !== null)
                throw new TypeError(ee[8] + String(be) + ee[9]);
              function ve() {
                this[ee[10]] = ue;
              }
              oe(ue, be), ue[ee[6]] = be === null ? Object[ee[11]](be) : (ve[ee[6]] = be[ee[6]], new ve());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[14]] = void 0;
          var he, _e = ae(83549), le = ae(93056);
          (function(oe) {
            oe[ee[15]] = ee[16], oe[ee[17]] = ee[18];
          })(he || (he = {}));
          var se = function(oe) {
            function ue() {
              var be = oe[ee[4]](this) || this;
              be[ee[20]] = null, be[ee[21]] = null, be[ee[22]] = null, be[ee[23]] = 0, be[ee[24]] = 0, be[ee[25]] = function(me) {
                var pe = me[ee[26]] !== void 0 && me[ee[26]] !== null, fe = me[ee[27]] !== void 0 && me[ee[27]] !== null, ge = me[ee[28]] !== void 0 && me[ee[28]] !== null;
                pe && fe && ge && (be[ee[20]] = me[ee[26]], be[ee[21]] = me[ee[28]], be[ee[22]] = me[ee[27]]), me[ee[5]](ee[23]) && (be[ee[23]] = be[ee[29]](me));
              }, be[ee[30]] = function() {
                be[ee[25]](ue[ee[31]]());
              }, be[ee[32]] = function(me) {
                me && me[ee[33]] && be[ee[25]](me[ee[33]]);
              }, window[ee[34]] !== window ? window[ee[36]](ee[35], be[ee[32]], !1) : window[ee[36]](ee[37], be[ee[25]]);
              try {
                window[ee[36]](ee[38], be[ee[30]]);
                var ve = ue[ee[31]]();
                be[ee[25]](ve);
              } catch {
                window[ee[39]](ee[38], be[ee[30]]);
              }
              return be[ee[40]](), be;
            }
            return ce(ue, oe), ue[ee[6]][ee[41]] = function() {
              if (!this[ee[42]]() || !this[ee[43]])
                return this[ee[44]];
              var be = _e[ee[46]][ee[45]](this[ee[20]]) / 2, ve = _e[ee[46]][ee[45]](this[ee[22]]) / 2, me = _e[ee[46]][ee[45]](this[ee[21]]) / 2, pe = Math[ee[47]](ve), fe = Math[ee[47]](me), ge = Math[ee[47]](be), ye = Math[ee[48]](ve), $e = Math[ee[48]](me), Se = Math[ee[48]](be), Ce = pe * fe * ge - ye * $e * Se, Ie = ye * fe * ge - pe * $e * Se, Te = pe * $e * ge + ye * fe * Se, Ee = pe * fe * Se + ye * $e * ge, we = _e[ee[50]][ee[49]](Ie, Te, Ee, Ce), Pe = _e[ee[46]][ee[45]](this[ee[51]]()) / 2, Me = _e[ee[50]][ee[49]](0, 0, -Math[ee[48]](Pe), Math[ee[47]](Pe)), Ae = _e[ee[50]][ee[11]]();
              _e[ee[50]][ee[52]](Ae, we, Me);
              var Oe = Math[ee[53]](0.5);
              return _e[ee[50]][ee[52]](Ae, _e[ee[50]][ee[49]](-Oe, 0, 0, Oe), Ae), _e[ee[50]][ee[54]](Ae);
            }, ue[ee[6]][ee[42]] = function() {
              return this[ee[20]] !== null;
            }, ue[ee[55]] = function() {
              return !!window[ee[56]];
            }, ue[ee[6]][ee[51]] = function() {
              return this[ee[23]];
            }, ue[ee[6]][ee[29]] = function(be) {
              var ve;
              switch (be[ee[23]][ee[61]]) {
                case ee[57]:
                  ve = 90;
                  break;
                case ee[58]:
                  ve = -90;
                  break;
                case ee[59]:
                  ve = 180;
                  break;
                case ee[60]:
                  ve = 0;
              }
              return !ve && isNaN(ve) && (ve = isNaN(be[ee[23]][ee[61]]) ? be[ee[62]] || 0 : be[ee[23]][ee[61]]), window[ee[34]] !== window && ve === this[ee[24]] && be[ee[62]] !== ve && (ve = be[ee[62]] || 0), ve;
            }, ue[ee[31]] = function() {
              var be = window[ee[63]], ve = be[ee[62]] || be[ee[64]] || be[ee[65]] || {};
              return { screenOrientation: { type: ve[ee[61]] || ve, angle: ve[ee[66]] }, orientation: window[ee[62]] };
            }, ue[ee[6]][ee[67]] = function() {
              return ee[68] != typeof DeviceMotionEvent && ee[7] == typeof DeviceMotionEvent[ee[69]];
            }, ue[ee[6]][ee[69]] = function() {
              return ee[68] == typeof DeviceMotionEvent || ee[7] != typeof DeviceMotionEvent[ee[69]] ? Promise[ee[70]]() : DeviceMotionEvent[ee[69]]()[ee[72]](function(be) {
                return be === he[ee[15]] ? Promise[ee[70]]() : Promise[ee[71]]();
              });
            }, ue;
          }(le[ee[19]]);
          ie[ee[14]] = se;
        }, 7716: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[73]] = void 0;
          var ce = ae(29328), he = ae(89099), _e = ae(58269), le = ae(27318), se = ae(63803), oe = function() {
            function ue() {
            }
            return ue[ee[74]] = function(be) {
              switch (be[ee[84]]) {
                case ce[ee[77]][ee[76]]:
                  return new se[ee[75]](be);
                case ce[ee[77]][ee[79]]:
                  return new _e[ee[78]](be);
                case ce[ee[77]][ee[81]]:
                  return new le[ee[80]](be);
                case ce[ee[77]][ee[83]]:
                  return new he[ee[82]](be);
              }
            }, ue;
          }();
          ie[ee[73]] = oe;
        }, 8945: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[85]] = void 0;
          var ce = ae(40829), he = ae(83549), _e = ae(39891), le = function() {
            function se(oe, ue) {
              this[ee[86]] = new _e[ee[87]](oe), this[ee[88]] = ce[ee[90]][ee[89]](ue);
            }
            return se[ee[6]][ee[91]] = function() {
              return this[ee[88]];
            }, se[ee[6]][ee[92]] = function(oe) {
              this[ee[86]] = oe;
            }, se[ee[6]][ee[93]] = function() {
              var oe = this[ee[86]][ee[94]], ue = this[ee[86]][ee[95]], be = (this[ee[88]][ee[96]] - this[ee[86]][ee[97]]) / 2, ve = this[ee[86]][ee[97]] / 2, me = this[ee[86]][ee[98]] - this[ee[88]][ee[99]], pe = this[ee[88]][ee[100]] - me, fe = he[ee[46]][ee[103]](Math[ee[102]](ue[ee[101]](be / oe))), ge = he[ee[46]][ee[103]](Math[ee[102]](ue[ee[101]](ve / oe))), ye = he[ee[46]][ee[103]](Math[ee[102]](ue[ee[101]](me / oe))), $e = he[ee[46]][ee[103]](Math[ee[102]](ue[ee[101]](pe / oe)));
              return { leftDegrees: Math[ee[105]](fe, this[ee[86]][ee[104]]), rightDegrees: Math[ee[105]](ge, this[ee[86]][ee[104]]), downDegrees: Math[ee[105]](ye, this[ee[86]][ee[104]]), upDegrees: Math[ee[105]]($e, this[ee[86]][ee[104]]) };
            }, se[ee[6]][ee[106]] = function() {
              var oe = this[ee[86]][ee[95]], ue = Math[ee[107]](-he[ee[46]][ee[45]](this[ee[86]][ee[104]])), be = Math[ee[107]](he[ee[46]][ee[45]](this[ee[86]][ee[104]])), ve = Math[ee[107]](he[ee[46]][ee[45]](this[ee[86]][ee[104]])), me = Math[ee[107]](-he[ee[46]][ee[45]](this[ee[86]][ee[104]])), pe = this[ee[88]][ee[96]] / 4, fe = this[ee[88]][ee[100]] / 2, ge = this[ee[86]][ee[98]] - this[ee[88]][ee[99]] - fe, ye = this[ee[86]][ee[97]] / 2 - pe, $e = -ge, Se = this[ee[86]][ee[94]], Ce = oe[ee[101]]((ye - pe) / Se), Ie = oe[ee[101]](($e + fe) / Se), Te = oe[ee[101]]((ye + pe) / Se), Ee = oe[ee[101]](($e - fe) / Se), we = new Float32Array(4);
              return we[0] = Math[ee[108]](ue, Ce), we[1] = Math[ee[105]](be, Ie), we[2] = Math[ee[105]](ve, Te), we[3] = Math[ee[108]](me, Ee), we;
            }, se[ee[6]][ee[109]] = function() {
              var oe = this[ee[86]][ee[95]], ue = new Float32Array(4), be = oe[ee[110]](Math[ee[107]](-he[ee[46]][ee[45]](this[ee[86]][ee[104]]))), ve = oe[ee[110]](Math[ee[107]](he[ee[46]][ee[45]](this[ee[86]][ee[104]]))), me = oe[ee[110]](Math[ee[107]](he[ee[46]][ee[45]](this[ee[86]][ee[104]]))), pe = oe[ee[110]](Math[ee[107]](-he[ee[46]][ee[45]](this[ee[86]][ee[104]]))), fe = this[ee[88]][ee[96]] / 4, ge = this[ee[88]][ee[100]] / 2, ye = this[ee[86]][ee[98]] - this[ee[88]][ee[99]] - ge, $e = this[ee[86]][ee[97]] / 2 - fe, Se = -ye, Ce = this[ee[86]][ee[94]], Ie = ($e - fe) / Ce, Te = (Se + ge) / Ce, Ee = ($e + fe) / Ce, we = (Se - ge) / Ce;
              return ue[0] = Math[ee[108]](be, Ie), ue[1] = Math[ee[105]](ve, Te), ue[2] = Math[ee[105]](me, Ee), ue[3] = Math[ee[108]](pe, we), ue;
            }, se[ee[6]][ee[111]] = function(oe) {
              var ue = this[ee[86]][ee[94]], be = (this[ee[88]][ee[96]] - this[ee[86]][ee[97]]) / 2, ve = this[ee[86]][ee[98]] - this[ee[88]][ee[99]], me = (oe[0] * ue + be) / this[ee[88]][ee[96]], pe = (oe[1] * ue + ve) / this[ee[88]][ee[100]], fe = (oe[2] * ue + be) / this[ee[88]][ee[96]], ge = (oe[3] * ue + ve) / this[ee[88]][ee[100]];
              return { x: me, y: ge, width: fe - me, height: pe - ge };
            }, se[ee[6]][ee[112]] = function(oe) {
              return oe ? this[ee[113]]() : this[ee[93]]();
            }, se[ee[6]][ee[114]] = function(oe) {
              var ue = this[ee[112]](oe);
              return { leftDegrees: ue[ee[115]], rightDegrees: ue[ee[116]], downDegrees: ue[ee[117]], upDegrees: ue[ee[118]] };
            }, se[ee[6]][ee[113]] = function() {
              var oe = this[ee[119]]();
              return { leftDegrees: he[ee[46]][ee[103]](Math[ee[102]](oe[ee[120]])), rightDegrees: he[ee[46]][ee[103]](Math[ee[102]](oe[ee[121]])), downDegrees: he[ee[46]][ee[103]](Math[ee[102]](oe[ee[122]])), upDegrees: he[ee[46]][ee[103]](Math[ee[102]](oe[ee[123]])) };
            }, se[ee[6]][ee[124]] = function() {
              var oe = this[ee[119]](), ue = this[ee[86]][ee[94]], be = this[ee[88]][ee[96]] / ue, ve = this[ee[88]][ee[100]] / ue, me = this[ee[88]][ee[125]] / be, pe = this[ee[88]][ee[126]] / ve, fe = Math[ee[128]]((oe[ee[127]] - oe[ee[120]]) * me), ge = Math[ee[128]]((oe[ee[129]] - oe[ee[122]]) * pe);
              return { x: fe, y: ge, width: Math[ee[128]]((oe[ee[127]] + oe[ee[121]]) * me) - fe, height: Math[ee[128]]((oe[ee[129]] + oe[ee[123]]) * pe) - ge };
            }, se[ee[6]][ee[119]] = function() {
              var oe = this[ee[86]][ee[95]], ue = this[ee[86]][ee[94]], be = this[ee[86]][ee[97]] / 2 / ue, ve = this[ee[88]][ee[96]] / ue, me = this[ee[88]][ee[100]] / ue, pe = ve / 2 - be, fe = (this[ee[86]][ee[98]] - this[ee[88]][ee[99]]) / ue, ge = this[ee[86]][ee[104]], ye = oe[ee[110]](Math[ee[107]](he[ee[46]][ee[45]](ge))), $e = Math[ee[105]](pe, ye), Se = Math[ee[105]](be, ye), Ce = Math[ee[105]](fe, ye);
              return { outerDist: $e, innerDist: Se, topDist: Math[ee[105]](me - fe, ye), bottomDist: Ce, eyePosX: pe, eyePosY: fe };
            }, se;
          }();
          ie[ee[85]] = le;
        }, 10755: function(ne, ie) {
          ee[0];
          var ae, ce, he = this && this[ee[1]] || function() {
            var oe = function(ue, be) {
              return oe = Object[ee[2]] || { __proto__: [] } instanceof Array && function(ve, me) {
                ve[ee[3]] = me;
              } || function(ve, me) {
                for (var pe in me)
                  Object[ee[6]][ee[5]][ee[4]](me, pe) && (ve[pe] = me[pe]);
              }, oe(ue, be);
            };
            return function(ue, be) {
              if (ee[7] != typeof be && be !== null)
                throw new TypeError(ee[8] + String(be) + ee[9]);
              function ve() {
                this[ee[10]] = ue;
              }
              oe(ue, be), ue[ee[6]] = be === null ? Object[ee[11]](be) : (ve[ee[6]] = be[ee[6]], new ve());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[130]] = ie[ee[131]] = ie[ee[132]] = ie[ee[133]] = ie[ee[134]] = void 0, function(oe) {
            oe[oe[ee[135]] = 0] = ee[135], oe[oe[ee[136]] = 1] = ee[136], oe[oe[ee[137]] = 1280] = ee[137], oe[oe[ee[138]] = 1286] = ee[138], oe[oe[ee[139]] = 1282] = ee[139], oe[oe[ee[140]] = 1281] = ee[140];
          }(ae || (ie[ee[134]] = ae = {})), ie[ee[133]] = { 1280: ee[137], 1286: ee[138], 1282: ee[139], 1281: ee[140] }, function(oe) {
            oe[ee[141]] = ee[142], oe[ee[143]] = ee[144], oe[ee[145]] = ee[146], oe[ee[147]] = ee[148], oe[ee[149]] = ee[150];
          }(ce || (ie[ee[132]] = ce = {}));
          var _e = function() {
            function oe(ue, be, ve, me) {
              this[ee[151]] = ue, this[ee[152]] = be, this[ee[153]] = ve, this[ee[61]] = me;
            }
            return Object[ee[13]](oe[ee[6]], ee[154], { get: function() {
              return this[ee[155]];
            }, enumerable: !1, configurable: !0 }), oe;
          }(), le = function(oe) {
            function ue(be, ve, me, pe) {
              var fe = oe[ee[4]](this, be, ve, me, pe) || this;
              return fe[ee[155]] = fe[ee[151]][ee[156]](fe[ee[152]], fe[ee[153]]), fe[ee[151]][ee[157]](fe[ee[153]]), fe;
            }
            return he(ue, oe), ue[ee[6]][ee[158]] = function(be) {
            }, ue;
          }(_e);
          ie[ee[131]] = le;
          var se = function(oe) {
            function ue(be, ve, me, pe) {
              var fe = oe[ee[4]](this, be, ve, me, pe) || this;
              return fe[ee[155]] = fe[ee[151]][ee[159]](fe[ee[152]], fe[ee[153]]), fe[ee[151]][ee[157]](fe[ee[153]]), fe;
            }
            return he(ue, oe), ue[ee[6]][ee[158]] = function(be) {
              this[ee[61]][ee[161]](ee[160]) > -1 ? this[ee[151]][this[ee[61]]][ee[4]](this[ee[151]], this[ee[155]], !1, be) : this[ee[151]][this[ee[61]]][ee[4]](this[ee[151]], this[ee[155]], be);
            }, ue;
          }(_e);
          ie[ee[130]] = se;
        }, 10768: function(ne) {
          ne[ee[162]] = ee[163];
        }, 12553: function(ne, ie) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[164]] = void 0;
          var ae = function() {
            function ce() {
            }
            return ce[ee[36]] = function(he, _e, le, se) {
              for (var oe = 0; oe < _e[ee[165]]; oe++)
                he[ee[36]](_e[oe], le, se);
            }, ce[ee[39]] = function(he, _e, le, se) {
              for (var oe = 0; oe < _e[ee[165]]; oe++)
                he[ee[39]](_e[oe], le, se);
            }, ce[ee[166]] = function(he, _e) {
              if (he && _e) {
                var le = he[ee[168]](ee[167]), se = !0;
                le && le[ee[165]] > 0 && (se = le[ee[170]](ee[169])[ee[161]](_e) < 0), le && le[ee[165]] > 0 && se && (_e = le + ee[169] + _e), se && he[ee[171]](ee[167], _e);
              }
            }, ce[ee[172]] = function(he, _e) {
              if (he && _e) {
                var le = he[ee[168]](ee[167]);
                le && le[ee[161]](_e) > -1 && (le = le[ee[177]](new RegExp(ee[174] + _e + ee[175]), ee[176])[ee[173]](), he[ee[171]](ee[167], le));
              }
            }, ce[ee[178]] = function() {
              return window[ee[179]];
            }, Object[ee[13]](ce, ee[180], { get: function() {
              var he = ce[ee[178]]()[ee[181]], _e = ce[ee[178]]()[ee[182]];
              return /Android|IEMobile|iP(hone|ad|od)/i[ee[183]](he) ? _e ? { start: [ee[184]], move: [ee[185]], end: [ee[186]], down: [ee[184]], up: [ee[186]], click: [ee[186]], type: ee[187] } : { start: [ee[188]], move: [ee[189]], end: [ee[190], ee[191]], down: [ee[188]], up: [ee[190], ee[191]], click: [ee[190]], type: ee[192] } : { start: [ee[193]], move: [ee[194]], end: [ee[195], ee[196]], down: [ee[197]], up: [ee[198]], click: [ee[199]], type: ee[200] };
            }, enumerable: !1, configurable: !0 }), ce;
          }();
          ie[ee[164]] = ae;
        }, 14912: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[201]] = void 0;
          var ce, he = ae(27523), _e = ae(79248), le = function() {
            function se(oe, ue, be, ve, me, pe, fe) {
              var ge = _e[ee[203]][ee[202]](be), ye = ge[0], $e = ge[1], Se = new he[ee[204]](oe, ue, ye, ve, me, pe, fe, $e);
              (ce = ce || new window[ee[206]]())[ee[205]](this, Se);
            }
            return se[ee[6]][ee[207]] = function() {
              return ce[ee[208]](this) && ee[209] !== ce[ee[74]](this)[ee[210]]();
            }, se[ee[6]][ee[211]] = function(oe) {
              var ue = ee[212] == typeof oe;
              return !(!this[ee[207]]() || !ue) && ce[ee[74]](this)[ee[211]](oe);
            }, se[ee[6]][ee[213]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[213]]();
            }, se[ee[6]][ee[214]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[214]]();
            }, se[ee[6]][ee[215]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[215]]();
            }, se[ee[6]][ee[216]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[216]]();
            }, se[ee[6]][ee[217]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[217]]();
            }, se[ee[6]][ee[218]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[218]]();
            }, se[ee[6]][ee[219]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[219]]();
            }, se[ee[6]][ee[220]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[220]]();
            }, se[ee[6]][ee[221]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[221]]();
            }, se[ee[6]][ee[222]] = function() {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[222]]();
            }, se[ee[6]][ee[210]] = function() {
              return ce[ee[208]](this) ? ce[ee[74]](this)[ee[210]]() : null;
            }, se[ee[6]][ee[223]] = function() {
              return ce[ee[208]](this) ? ce[ee[74]](this)[ee[223]]() : null;
            }, se[ee[6]][ee[224]] = function() {
              return this[ee[207]]() ? ce[ee[74]](this)[ee[224]]() : { yaw: 0, pitch: 0, roll: 0 };
            }, se[ee[6]][ee[225]] = function(oe) {
              var ue = oe && isFinite(oe[ee[226]]) && isFinite(oe[ee[227]]) && isFinite(oe[ee[228]]);
              return !(!this[ee[207]]() || !ue) && ce[ee[74]](this)[ee[225]](oe);
            }, se[ee[6]][ee[229]] = function(oe) {
              var ue = isFinite(oe[ee[230]]) && isFinite(oe[ee[231]]) && isFinite(oe[ee[232]]);
              return !(!this[ee[207]]() || !ue) && ce[ee[74]](this)[ee[229]](oe);
            }, se[ee[6]][ee[233]] = function(oe) {
              var ue = isFinite(oe);
              return !(!this[ee[207]]() || !ue) && ce[ee[74]](this)[ee[233]](oe);
            }, se[ee[6]][ee[234]] = function() {
              return this[ee[207]]() ? ce[ee[74]](this)[ee[234]]() : -1;
            }, se[ee[6]][ee[235]] = function(oe) {
              var ue = isFinite(oe);
              return !(!this[ee[207]]() || !ue) && ce[ee[74]](this)[ee[235]](oe);
            }, se[ee[6]][ee[236]] = function() {
              return this[ee[207]]() ? ce[ee[74]](this)[ee[236]]() : -1;
            }, se[ee[6]][ee[237]] = function(oe) {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[237]](oe);
            }, se[ee[6]][ee[238]] = function() {
              return this[ee[207]]() ? ce[ee[74]](this)[ee[238]]() : -1;
            }, se[ee[6]][ee[239]] = function(oe) {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[239]](oe);
            }, se[ee[6]][ee[240]] = function() {
              return this[ee[207]]() ? ce[ee[74]](this)[ee[240]]() : -1;
            }, se[ee[6]][ee[241]] = function(oe) {
              return !!this[ee[207]]() && ce[ee[74]](this)[ee[241]](oe);
            }, se[ee[6]][ee[242]] = function() {
              return this[ee[207]]() ? ce[ee[74]](this)[ee[242]]() : -1;
            }, se[ee[6]][ee[243]] = function() {
              var oe, ue;
              return this[ee[207]]() && (ue = (oe = ce[ee[74]](this)) === null || oe === void 0 ? void 0 : oe[ee[243]]()) !== null && ue !== void 0 && ue;
            }, se[ee[6]][ee[244]] = function() {
              var oe, ue;
              return this[ee[207]]() && (ue = (oe = ce[ee[74]](this)) === null || oe === void 0 ? void 0 : oe[ee[244]]()) !== null && ue !== void 0 ? ue : Promise[ee[70]]();
            }, se;
          }();
          ie[ee[201]] = le;
        }, 14985: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var _e = function(le, se) {
              return _e = Object[ee[2]] || { __proto__: [] } instanceof Array && function(oe, ue) {
                oe[ee[3]] = ue;
              } || function(oe, ue) {
                for (var be in ue)
                  Object[ee[6]][ee[5]][ee[4]](ue, be) && (oe[be] = ue[be]);
              }, _e(le, se);
            };
            return function(le, se) {
              if (ee[7] != typeof se && se !== null)
                throw new TypeError(ee[8] + String(se) + ee[9]);
              function oe() {
                this[ee[10]] = le;
              }
              _e(le, se), le[ee[6]] = se === null ? Object[ee[11]](se) : (oe[ee[6]] = se[ee[6]], new oe());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[245]] = void 0;
          var he = function(_e) {
            function le() {
              var se = _e[ee[4]](this) || this;
              return se[ee[40]](), se;
            }
            return ce(le, _e), le[ee[6]][ee[41]] = function() {
              return this[ee[44]];
            }, le[ee[6]][ee[42]] = function() {
              return !0;
            }, le[ee[55]] = function() {
              return !0;
            }, le;
          }(ae(93056)[ee[19]]);
          ie[ee[245]] = he;
        }, 21971: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[246]] = ie[ee[77]] = ie[ee[247]] = ie[ee[248]] = void 0;
          var ce = ae(16368), he = ae(29328);
          Object[ee[13]](ie, ee[77], { enumerable: !0, get: function() {
            return he[ee[77]];
          } }), Object[ee[13]](ie, ee[247], { enumerable: !0, get: function() {
            return he[ee[247]];
          } }), Object[ee[13]](ie, ee[246], { enumerable: !0, get: function() {
            return he[ee[246]];
          } });
          var _e = ae(14912);
          ie[ee[248]] = { name: ce[ee[250]][ee[249]], module: { VRHandler: _e[ee[201]] }, exports: { VRContentType: he[ee[247]], TransitionTimingType: he[ee[77]], VRState: he[ee[246]] } }, ie[ee[251]] = ie[ee[248]];
        }, 27318: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var _e = function(le, se) {
              return _e = Object[ee[2]] || { __proto__: [] } instanceof Array && function(oe, ue) {
                oe[ee[3]] = ue;
              } || function(oe, ue) {
                for (var be in ue)
                  Object[ee[6]][ee[5]][ee[4]](ue, be) && (oe[be] = ue[be]);
              }, _e(le, se);
            };
            return function(le, se) {
              if (ee[7] != typeof se && se !== null)
                throw new TypeError(ee[8] + String(se) + ee[9]);
              function oe() {
                this[ee[10]] = le;
              }
              _e(le, se), le[ee[6]] = se === null ? Object[ee[11]](se) : (oe[ee[6]] = se[ee[6]], new oe());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[80]] = void 0;
          var he = function(_e) {
            function le() {
              return _e !== null && _e[ee[252]](this, arguments) || this;
            }
            return ce(le, _e), le[ee[6]][ee[253]] = function() {
              var se = isFinite(this[ee[255]][ee[254]]), oe = this[ee[255]][ee[254]] > 0, ue = this[ee[255]][ee[256]];
              return se && oe && !ue;
            }, le;
          }(ae(89099)[ee[82]]);
          ie[ee[80]] = he;
        }, 27523: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[204]] = void 0;
          var ce = ae(52241), he = ae(8945), _e = ae(63546), le = ae(35148), se = ae(4006), oe = ae(62510), ue = ae(33696), be = ae(13533), ve = ae(46462), me = ae(29328), pe = ae(33083), fe = ae(41205), ge = 4, ye = function() {
            function $e(Se, Ce, Ie, Te, Ee, we, Pe, Me) {
              var Ae = this;
              this[ee[257]] = null, this[ee[258]] = null, this[ee[259]] = null, this[ee[260]] = null, this[ee[261]] = me[ee[246]][ee[262]], this[ee[263]] = null, this[ee[264]] = !1, this[ee[265]] = !1, this[ee[266]] = null, this[ee[267]] = null, this[ee[268]] = null, this[ee[269]] = !1, this[ee[270]] = function() {
                Ae[ee[271]] = !0;
              }, this[ee[272]] = function(Re) {
                if (Ae[ee[261]] !== me[ee[246]][ee[273]])
                  return Ae[ee[274]] && Ae[ee[276]][ee[275]] && Ae[ee[276]][ee[275]](), void (Ae[ee[274]] = !1);
                Ae[ee[277]](), Ae[ee[265]] !== Ae[ee[264]] && (Ae[ee[281]][ee[280]]()(oe[ee[279]][ee[278]], { stereo: Ae[ee[264]] }), Ae[ee[265]] = Ae[ee[264]]);
                var Ne = Ae[ee[267]][ee[282]](Re), xe = !Ae[ee[269]] || Ae[ee[271]] || Re === 0;
                xe || Ne || Re === 0 || Ae[ee[283]] ? (Ae[ee[284]] && Ae[ee[276]][ee[285]] && Ae[ee[276]][ee[285]](), !Ae[ee[274]] && Ae[ee[276]][ee[286]] && Ae[ee[276]][ee[286]](), Ae[ee[266]][ee[288]](Ae[ee[267]][ee[287]](), xe), Ae[ee[284]] = !1, Ae[ee[274]] = !0) : (Ae[ee[274]] && Ae[ee[276]][ee[275]] && Ae[ee[276]][ee[275]](), Ae[ee[274]] = !1), Ae[ee[263]] === null && (Ae[ee[259]] = requestAnimationFrame(Ae[ee[272]])), Ae[ee[271]] = !1, Ae[ee[283]] = !1;
              }, this[ee[289]] = function() {
                Ae[ee[292]]()[ee[39]](ve[ee[291]][ee[290]], Ae[ee[289]]), Ae[ee[292]]()[ee[39]](ve[ee[291]][ee[293]], Ae[ee[289]]), Ae[ee[261]] === me[ee[246]][ee[294]] && (Ae[ee[277]](), Ae[ee[261]] = me[ee[246]][ee[273]], Ae[ee[259]] = requestAnimationFrame(Ae[ee[272]]));
              }, this[ee[295]] = function(Re) {
                Ae[ee[261]] = me[ee[246]][ee[296]], Ae[ee[263]] = Re, Ae[ee[297]](), Ae[ee[259]] && (cancelAnimationFrame(Ae[ee[259]]), Ae[ee[259]] = null), Ae[ee[281]][ee[280]]()(oe[ee[279]][ee[298]], new _e[ee[301]](le[ee[300]][ee[299]])), Ae[ee[304]][ee[303]](ee[302] + Re);
              }, this[ee[213]] = function() {
                return Ae[ee[267]][ee[213]](), !0;
              }, this[ee[214]] = function() {
                return Ae[ee[267]][ee[214]](), !0;
              }, this[ee[215]] = function() {
                return Ae[ee[267]][ee[215]]();
              }, this[ee[216]] = function() {
                return Ae[ee[267]][ee[216]](), !0;
              }, this[ee[217]] = function() {
                return Ae[ee[267]][ee[217]](), !0;
              }, this[ee[218]] = function() {
                return Ae[ee[267]][ee[218]]();
              }, this[ee[219]] = function() {
                return Ae[ee[267]][ee[219]](), !0;
              }, this[ee[220]] = function() {
                return Ae[ee[267]][ee[220]](), !0;
              }, this[ee[221]] = function() {
                return Ae[ee[267]][ee[221]]();
              }, this[ee[225]] = function(Re) {
                return !!Ae[ee[267]] && (Ae[ee[267]][ee[225]](Re), !0);
              }, this[ee[305]] = function() {
                Ae[ee[269]] = !0;
              }, this[ee[306]] = function() {
                var Re = Ae[ee[292]]();
                if (Re[ee[307]] !== ge) {
                  var Ne = function() {
                    return Ae[ee[269]] = !1;
                  };
                  Re[ee[36]](ve[ee[291]][ee[290]], Ne);
                } else
                  Ae[ee[269]] = !1;
              }, this[ee[308]] = function() {
                Ae[ee[281]][ee[309]](oe[ee[279]][ee[273]], Ae[ee[306]]), Ae[ee[281]][ee[309]](oe[ee[279]][ee[310]], Ae[ee[305]]), Ae[ee[281]][ee[309]](oe[ee[279]][ee[311]], Ae[ee[308]]), Ae[ee[281]][ee[309]](oe[ee[279]][ee[312]], Ae[ee[308]]), Ae[ee[281]] = null;
                var Re = Ae[ee[292]]();
                Ae[ee[313]] && Ae[ee[313]][ee[39]](ve[ee[291]][ee[293]], Ae[ee[270]]), Ae[ee[297]](), Ae[ee[257]] && Ae[ee[257]][ee[314]] && (Ae[ee[257]][ee[314]][ee[315]](Ae[ee[257]]), Ae[ee[257]] = null), Ae[ee[258]] && Ae[ee[258]][ee[314]] && (Ae[ee[258]][ee[314]][ee[315]](Ae[ee[258]]), Ae[ee[258]] = null), Ae[ee[260]] && Ae[ee[260]][ee[314]] && (Ae[ee[260]][ee[314]][ee[315]](Ae[ee[260]]), Ae[ee[260]] = null), Ae[ee[261]] = me[ee[246]][ee[262]], Ae[ee[259]] && (cancelAnimationFrame(Ae[ee[259]]), Ae[ee[259]] = null), Ae[ee[267]] && Ae[ee[267]][ee[308]](), Ae[ee[267]] = null, Ae[ee[266]][ee[308]](), Ae[ee[266]] = null, Re[ee[39]](ve[ee[291]][ee[290]], Ae[ee[289]]), Re[ee[39]](ve[ee[291]][ee[293]], Ae[ee[289]]);
              }, this[ee[281]] = Se[ee[281]], this[ee[313]] = Se[ee[316]], this[ee[317]] = Te, this[ee[318]] = Se[ee[319]], this[ee[320]] = Ce, this[ee[321]] = Ie, this[ee[276]] = Me, this[ee[304]] = Ee, this[ee[322]] = we, this[ee[323]] = Se[ee[326]][ee[325]][ee[324]], this[ee[327]] = Pe, this[ee[271]] = !1, this[ee[283]] = !1, this[ee[274]] = !1, this[ee[284]] = !0, this[ee[257]] = document[ee[328]](ee[257]), this[ee[257]][ee[171]](ee[320], ee[329]), this[ee[257]][ee[331]][ee[330]] = ee[332], this[ee[257]][ee[331]][ee[333]] = ee[334];
              var Oe = this[ee[318]][ee[338]](se[ee[336]][ee[335]] + ee[337])[0];
              Oe ? this[ee[318]][ee[339]](this[ee[257]], Oe) : this[ee[318]][ee[340]](this[ee[257]]);
              var Be = Se[ee[326]][ee[325]][ee[341]];
              if ($e[ee[342]](we, this[ee[323]], Be) ? this[ee[304]][ee[303]](ee[343]) : (this[ee[258]] = document[ee[328]](ee[257]), this[ee[258]][ee[171]](ee[320], ee[344]), this[ee[258]][ee[331]][ee[330]] = ee[332], this[ee[258]][ee[331]][ee[333]] = ee[334], this[ee[318]][ee[339]](this[ee[258]], this[ee[257]]), this[ee[304]][ee[303]](ee[345])), (0, be[ee[347]])()[ee[346]] && (this[ee[313]][ee[171]](ee[348], ee[176]), this[ee[313]][ee[171]](ee[349], ee[176]), this[ee[304]][ee[303]](ee[350])), this[ee[260]] = document[ee[352]](ee[351]), this[ee[260]] || (this[ee[260]] = document[ee[328]](ee[331]), this[ee[260]][ee[171]](ee[320], ee[351]), this[ee[260]][ee[340]](document[ee[354]](ee[353])), document[ee[356]](ee[355])[0][ee[340]](this[ee[260]])), this[ee[264]] = this[ee[321]][ee[264]], this[ee[265]] = this[ee[264]], this[ee[321]][ee[357]] ? this[ee[304]][ee[303]](ee[358]) : this[ee[313]][ee[36]](ve[ee[291]][ee[293]], this[ee[270]]), ee[359] == typeof this[ee[321]][ee[360]]) {
                var Ve = ce[ee[362]][ee[361]](this[ee[321]][ee[360]]);
                this[ee[304]][ee[303]](ee[363] + JSON[ee[364]](Ve)), Ve[ee[5]](ee[365]) && (this[ee[268]] = new he[ee[85]](Ve, this[ee[304]]));
              }
              this[ee[261]] = me[ee[246]][ee[294]], this[ee[267]] = new pe[ee[366]](this[ee[257]], this[ee[318]], this[ee[321]], this[ee[276]], this[ee[281]]), this[ee[266]] = new fe[ee[367]](this[ee[257]], this[ee[258]], Se, this[ee[268]], this[ee[295]], this[ee[304]], this[ee[327]], this[ee[321]], this[ee[276]]), this[ee[281]][ee[368]](oe[ee[279]][ee[273]], this[ee[306]]), this[ee[281]][ee[368]](oe[ee[279]][ee[310]], this[ee[305]]), this[ee[281]][ee[368]](oe[ee[279]][ee[311]], this[ee[308]]), this[ee[281]][ee[368]](oe[ee[279]][ee[312]], this[ee[308]]), this[ee[369]](), this[ee[277]]();
              var Ue = this[ee[292]]();
              Ue[ee[307]] !== ge && Ue[ee[370]] ? (Ue[ee[36]](ve[ee[291]][ee[290]], this[ee[289]]), Ue[ee[36]](ve[ee[291]][ee[293]], this[ee[289]])) : this[ee[289]]();
            }
            return $e[ee[6]][ee[292]] = function() {
              return this[ee[321]][ee[357]] && this[ee[317]] ? this[ee[317]] : this[ee[313]];
            }, $e[ee[6]][ee[277]] = function() {
              if (this[ee[257]]) {
                var Se, Ce, Ie, Te;
                this[ee[318]] && this[ee[318]][ee[371]] && this[ee[318]][ee[372]] ? (Se = this[ee[318]][ee[371]], Ce = this[ee[318]][ee[372]]) : (Se = window[ee[373]], Ce = window[ee[374]]), this[ee[313]] && this[ee[313]][ee[375]] && this[ee[313]][ee[376]] ? (Ie = this[ee[313]][ee[375]], Te = this[ee[313]][ee[376]]) : (Ie = Se, Te = Ce);
                var Ee = (this[ee[322]][ee[377]] || 1) / this[ee[266]][ee[378]](), we = Se * Ee, Pe = Ce * Ee, Me = we / Pe;
                we > Ie && (Pe = (we = Ie) / Me), Pe > Te && (we = (Pe = Te) * Me), this[ee[257]][ee[125]] === we && this[ee[257]][ee[126]] === Pe || (this[ee[257]][ee[125]] = we, this[ee[257]][ee[126]] = Pe), !this[ee[258]] || this[ee[258]][ee[125]] === Ie && this[ee[258]][ee[126]] === Te || (this[ee[258]][ee[125]] = Ie, this[ee[258]][ee[126]] = Te);
              }
            }, $e[ee[6]][ee[369]] = function() {
              this[ee[257]] && (this[ee[257]][ee[331]][ee[330]] = ee[379]), this[ee[258]] && (this[ee[258]][ee[331]][ee[330]] = ee[379]), this[ee[313]] && (this[ee[313]][ee[331]][ee[330]] = ee[332]);
            }, $e[ee[6]][ee[297]] = function() {
              this[ee[257]] && (this[ee[257]][ee[331]][ee[330]] = ee[332]), this[ee[258]] && (this[ee[258]][ee[331]][ee[330]] = ee[332]), this[ee[313]] && this[ee[313]][ee[331]] && (this[ee[313]][ee[331]][ee[330]] = ee[379]);
            }, $e[ee[342]] = function(Se, Ce, Ie) {
              var Te = Se[ee[380]], Ee = Se[ee[181]], we = Se[ee[381]], Pe = (0, be[ee[347]])()[ee[382]], Me = 10, Ae = (Pe[ee[383]] > Me || Pe[ee[383]] === Me && Pe[ee[384]] >= 1) && !(0, be[ee[347]])()[ee[346]], Oe = -1;
              return !(Ce === ue[ee[386]][ee[385]] && Ie === ue[ee[388]][ee[387]] && !Ae) && (ee[389] === Te ? new RegExp(ee[391])[ee[390]](Ee) !== null && (Oe = parseFloat(RegExp[ee[392]])) : ee[393] === Te && (we[ee[161]](ee[394]) !== -1 ? Oe = 11 : new RegExp(ee[395])[ee[390]](Ee) !== null && (Oe = parseFloat(RegExp[ee[392]]))), Oe === -1 || Oe >= 13);
            }, $e[ee[6]][ee[211]] = function(Se) {
              return this[ee[283]] = this[ee[264]] !== Se, this[ee[264]] = Se, this[ee[264]] ? (this[ee[266]][ee[396]](), this[ee[267]][ee[396]]()) : (this[ee[266]][ee[397]](), this[ee[267]][ee[397]]()), !0;
            }, $e[ee[6]][ee[222]] = function() {
              return this[ee[264]];
            }, $e[ee[6]][ee[210]] = function() {
              return this[ee[261]] === me[ee[246]][ee[294]] ? me[ee[246]][ee[294]] : this[ee[261]] === me[ee[246]][ee[273]] ? me[ee[246]][ee[273]] : this[ee[261]] === me[ee[246]][ee[296]] ? me[ee[246]][ee[296]] : this[ee[261]] === me[ee[246]][ee[262]] ? null : void 0;
            }, $e[ee[6]][ee[223]] = function() {
              return this[ee[263]];
            }, $e[ee[6]][ee[224]] = function() {
              return this[ee[267]] ? this[ee[267]][ee[224]]() : { yaw: 0, pitch: 0, roll: 0 };
            }, $e[ee[6]][ee[229]] = function(Se) {
              return !!this[ee[267]] && (this[ee[267]][ee[229]](Se), !0);
            }, $e[ee[6]][ee[233]] = function(Se) {
              return !!this[ee[267]] && (this[ee[267]][ee[233]](Se), !0);
            }, $e[ee[6]][ee[234]] = function() {
              return this[ee[267]] ? this[ee[267]][ee[234]]() : -1;
            }, $e[ee[6]][ee[235]] = function(Se) {
              return !!this[ee[267]] && (this[ee[267]][ee[235]](Se), !0);
            }, $e[ee[6]][ee[236]] = function() {
              return this[ee[267]] ? this[ee[267]][ee[236]]() : -1;
            }, $e[ee[6]][ee[237]] = function(Se) {
              return !!this[ee[267]] && (this[ee[267]][ee[237]](Se), !0);
            }, $e[ee[6]][ee[238]] = function() {
              return this[ee[267]] ? this[ee[267]][ee[238]]() : -1;
            }, $e[ee[6]][ee[239]] = function(Se) {
              return !!this[ee[267]] && (this[ee[267]][ee[239]](Se), !0);
            }, $e[ee[6]][ee[240]] = function() {
              return this[ee[267]] ? this[ee[267]][ee[240]]() : -1;
            }, $e[ee[6]][ee[241]] = function(Se) {
              return !!this[ee[267]] && this[ee[267]][ee[241]](Se);
            }, $e[ee[6]][ee[242]] = function() {
              return this[ee[267]] ? this[ee[267]][ee[242]]() : -1;
            }, $e[ee[6]][ee[243]] = function() {
              var Se, Ce;
              return (Ce = (Se = this[ee[267]]) === null || Se === void 0 ? void 0 : Se[ee[67]]()) !== null && Ce !== void 0 && Ce;
            }, $e[ee[6]][ee[244]] = function() {
              var Se, Ce;
              return (Ce = (Se = this[ee[267]]) === null || Se === void 0 ? void 0 : Se[ee[69]]()) !== null && Ce !== void 0 ? Ce : Promise[ee[70]]();
            }, $e;
          }();
          ie[ee[204]] = ye;
        }, 29328: function(ne, ie) {
          ee[0];
          var ae, ce, he;
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[77]] = ie[ee[246]] = ie[ee[247]] = void 0, function(_e) {
            _e[ee[398]] = ee[399], _e[ee[400]] = ee[401], _e[ee[402]] = ee[403];
          }(ae || (ie[ee[247]] = ae = {})), function(_e) {
            _e[ee[294]] = ee[404], _e[ee[273]] = ee[290], _e[ee[296]] = ee[209], _e[ee[262]] = ee[405];
          }(ce || (ie[ee[246]] = ce = {})), function(_e) {
            _e[ee[76]] = ee[332], _e[ee[79]] = ee[406], _e[ee[81]] = ee[407], _e[ee[83]] = ee[408];
          }(he || (ie[ee[77]] = he = {}));
        }, 31444: function(ne, ie) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[409]] = void 0;
          var ae = function() {
            function ce(he) {
              this[ee[410]] = he;
            }
            return ce[ee[6]][ee[110]] = function(he) {
              for (var _e = 0, le = 1, se = he - this[ee[101]](_e); Math[ee[411]](le - _e) > 1e-4; ) {
                var oe = he - this[ee[101]](le), ue = le - oe * ((le - _e) / (oe - se));
                _e = le, le = ue, se = oe;
              }
              return le;
            }, ce[ee[6]][ee[101]] = function(he) {
              for (var _e = he * he, le = 0, se = this[ee[410]][ee[165]] - 1; se >= 0; se--)
                le = _e * (le + this[ee[410]][se]);
              return (le + 1) * he;
            }, ce[ee[412]] = function(he, _e) {
              var le, se, oe, ue = he[ee[165]];
              for (se = 0; se < ue - 1; ++se)
                for (oe = se + 1; oe < ue; ++oe) {
                  var be = he[se][oe] / he[se][se];
                  for (le = se + 1; le < ue; ++le)
                    he[le][oe] -= be * he[le][se];
                  _e[oe] -= be * _e[se];
                }
              var ve = new Array(ue);
              for (se = ue - 1; se >= 0; --se) {
                var me = _e[se];
                for (le = se + 1; le < ue; ++le)
                  me -= he[le][se] * ve[le];
                ve[se] = me / he[se][se];
              }
              return ve;
            }, ce[ee[413]] = function(he, _e) {
              var le, se, oe, ue, be = he[ee[165]], ve = he[0][ee[165]];
              if (ve !== _e[ee[165]])
                throw new Error(ee[414]);
              var me = new Array(be);
              for (oe = 0; oe < be; ++oe)
                for (me[oe] = new Array(be), se = 0; se < be; ++se) {
                  for (ue = 0, le = 0; le < ve; ++le)
                    ue += he[se][le] * he[oe][le];
                  me[oe][se] = ue;
                }
              var pe = new Array(be);
              for (se = 0; se < be; ++se) {
                for (ue = 0, le = 0; le < ve; ++le)
                  ue += he[se][le] * _e[le];
                pe[se] = ue;
              }
              return ce[ee[412]](me, pe);
            }, ce[ee[6]][ee[415]] = function(he, _e) {
              he = he || 1, _e = _e || 100;
              var le, se, oe = 12, ue = new Array(oe);
              for (se = 0; se < oe; ++se)
                ue[se] = new Array(_e);
              var be = new Array(_e);
              for (le = 0; le < _e; ++le) {
                var ve = he * (le + 1) / _e, me = this[ee[101]](ve), pe = me;
                for (se = 0; se < oe; ++se)
                  pe *= me * me, ue[se][le] = pe;
                be[le] = ve - me;
              }
              return ce[ee[413]](ue, be);
            }, ce;
          }();
          ie[ee[409]] = ae;
        }, 33083: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[366]] = void 0;
          var ce, he = ae(83549), _e = ae(62510), le = ae(46446), se = ae(86741), oe = ae(41775), ue = ae(7716), be = ae(68856), ve = ae(34081);
          (function(pe) {
            pe[ee[416]] = ee[417], pe[ee[418]] = ee[419], pe[ee[420]] = ee[420];
          })(ce || (ce = {}));
          var me = function() {
            function pe(fe, ge, ye, $e, Se) {
              var Ce = this;
              this[ee[421]] = null, this[ee[422]] = null, this[ee[423]] = 1, this[ee[424]] = null, this[ee[425]] = null, this[ee[426]] = null, this[ee[427]] = null, this[ee[428]] = null, this[ee[429]] = null, this[ee[430]] = null, this[ee[213]] = function() {
                Ce[ee[431]][ee[40]]();
              }, this[ee[214]] = function() {
                Ce[ee[431]][ee[432]]();
              }, this[ee[215]] = function() {
                return Ce[ee[431]][ee[433]]();
              }, this[ee[216]] = function() {
                Ce[ee[434]][ee[40]]();
              }, this[ee[217]] = function() {
                Ce[ee[434]][ee[432]]();
              }, this[ee[218]] = function() {
                return Ce[ee[434]][ee[433]]();
              }, this[ee[219]] = function() {
                Ce[ee[435]][ee[40]]();
              }, this[ee[220]] = function() {
                Ce[ee[435]][ee[432]]();
              }, this[ee[221]] = function() {
                return Ce[ee[435]][ee[433]]();
              }, this[ee[257]] = fe, this[ee[321]] = ye, this[ee[281]] = Se, this[ee[431]] = be[ee[436]][ee[74]](), this[ee[427]] = he[ee[437]][ee[11]](), this[ee[428]] = he[ee[437]][ee[11]](), this[ee[429]] = he[ee[437]][ee[11]](), this[ee[424]] = he[ee[437]][ee[11]](), this[ee[421]] = he[ee[437]][ee[11]](), this[ee[423]] = this[ee[321]][ee[264]] ? 2 : 1, this[ee[426]] = { yaw: 0, pitch: 0, roll: 0 }, this[ee[426]][ee[226]] = this[ee[321]][ee[438]], this[ee[439]] = new ve[ee[440]](), this[ee[441]] = new ve[ee[440]](), this[ee[425]] = { yaw: this[ee[426]][ee[226]], pitch: 0, roll: 0 }, this[ee[442]] = this[ee[321]][ee[442]], this[ee[443]] = this[ee[321]][ee[443]], this[ee[444]] = this[ee[321]][ee[444]], this[ee[445]] = this[ee[321]][ee[445]], this[ee[446]] = this[ee[444]] > -1, this[ee[447]] = this[ee[445]] > -1, this[ee[448]] = 1, this[ee[449]] = 0, this[ee[450]] = !1, this[ee[435]] = new se[ee[451]](this[ee[321]][ee[435]], $e), this[ee[434]] = new oe[ee[452]](this[ee[321]][ee[434]], $e, ge, this[ee[257]]), this[ee[453]] = new le[ee[454]](this[ee[321]][ee[453]], $e, this[ee[442]]), this[ee[455]] = ue[ee[73]][ee[74]](this[ee[321]][ee[435]]), this[ee[456]] = ue[ee[73]][ee[74]](this[ee[321]][ee[434]]), this[ee[457]] = ue[ee[73]][ee[74]](this[ee[321]][ee[453]]), this[ee[444]] > -1 && this[ee[445]] > -1 ? this[ee[458]] = ce[ee[420]] : this[ee[445]] > -1 ? this[ee[458]] = ce[ee[418]] : this[ee[458]] = ce[ee[416]];
            }
            return pe[ee[459]] = function(fe, ge, ye) {
              return ge === 0 && ye === 360 ? fe % 360 : fe > ye ? ye : fe < ge ? ge : fe;
            }, pe[ee[460]] = function(fe, ge) {
              var ye = { yaw: 0, pitch: 0, roll: fe[ee[228]] };
              return ye[ee[226]] = pe[ee[459]](fe[ee[226]], ge[ee[461]], ge[ee[462]]), ye[ee[227]] = pe[ee[459]](fe[ee[227]], ge[ee[463]], ge[ee[464]]), ye;
            }, pe[ee[6]][ee[465]] = function(fe) {
              fe === void 0 && (fe = { yaw: 0, pitch: 0, roll: 0 }), this[ee[430]] !== null && (this[ee[430]] = pe[ee[460]](this[ee[430]], this[ee[321]][ee[466]]), this[ee[426]][ee[226]] = this[ee[430]][ee[226]] - fe[ee[226]], this[ee[426]][ee[227]] = this[ee[430]][ee[227]] - fe[ee[227]], this[ee[426]][ee[228]] = this[ee[430]][ee[228]] - fe[ee[228]], this[ee[456]][ee[467]](), this[ee[455]][ee[467]](), this[ee[457]][ee[467]]()), this[ee[430]] = null, this[ee[425]][ee[226]] = this[ee[426]][ee[226]] + fe[ee[226]], this[ee[425]][ee[227]] = this[ee[426]][ee[227]] + fe[ee[227]], this[ee[425]][ee[228]] = this[ee[426]][ee[228]] + fe[ee[228]], this[ee[425]] = pe[ee[460]](this[ee[425]], this[ee[321]][ee[466]]), he[ee[437]][ee[468]](this[ee[424]]), he[ee[437]][ee[469]](this[ee[424]], he[ee[46]][ee[45]](this[ee[425]][ee[226]] + 180), [0, 1, 0]), he[ee[437]][ee[469]](this[ee[424]], he[ee[46]][ee[45]](this[ee[425]][ee[227]]), [1, 0, 0]), he[ee[437]][ee[469]](this[ee[424]], he[ee[46]][ee[45]](this[ee[425]][ee[228]]), [0, 0, 1]);
            }, pe[ee[6]][ee[287]] = function() {
              return this[ee[421]];
            }, pe[ee[6]][ee[224]] = function() {
              return this[ee[425]];
            }, pe[ee[6]][ee[225]] = function(fe) {
              this[ee[430]] = fe;
            }, pe[ee[6]][ee[237]] = function(fe) {
              this[ee[446]] = fe !== -1, this[ee[444]] = fe === -1 ? -1 : Math[ee[108]](Math[ee[105]](180, fe), 0), fe === -1 && this[ee[458]] === ce[ee[420]] ? this[ee[458]] = ce[ee[418]] : this[ee[458]] === ce[ee[418]] && (this[ee[447]] ? this[ee[458]] = ce[ee[420]] : this[ee[458]] = ce[ee[416]]);
            }, pe[ee[6]][ee[238]] = function() {
              return this[ee[444]] / this[ee[448]];
            }, pe[ee[6]][ee[239]] = function(fe) {
              this[ee[447]] = fe !== -1, this[ee[445]] = fe === -1 ? -1 : Math[ee[108]](Math[ee[105]](180, fe), 0), fe === -1 && this[ee[458]] === ce[ee[420]] ? this[ee[458]] = ce[ee[416]] : this[ee[458]] === ce[ee[416]] && (this[ee[446]] ? this[ee[458]] = ce[ee[420]] : this[ee[458]] = ce[ee[418]]);
            }, pe[ee[6]][ee[240]] = function() {
              return this[ee[445]] / this[ee[448]];
            }, pe[ee[6]][ee[241]] = function(fe) {
              return !!isFinite(fe) && (this[ee[448]] = Math[ee[108]](Number(fe), 1e-10), !0);
            }, pe[ee[6]][ee[242]] = function() {
              return this[ee[448]];
            }, pe[ee[6]][ee[470]] = function() {
              var fe, ge, ye = this[ee[431]][ee[471]](), $e = [1];
              this[ee[444]] < 0 && (this[ee[444]] = ye[ee[118]] + ye[ee[117]]), this[ee[445]] < 0 && (this[ee[445]] = ye[ee[115]] + ye[ee[116]]), this[ee[458]] !== ce[ee[420]] && this[ee[458]] !== ce[ee[418]] || $e[ee[472]](180 / (this[ee[445]] / this[ee[448]])), this[ee[458]] !== ce[ee[420]] && this[ee[458]] !== ce[ee[416]] || $e[ee[472]](180 / (this[ee[444]] / this[ee[448]])), this[ee[448]] /= Math[ee[105]][ee[252]](null, $e);
              var Se = he[ee[46]][ee[45]](this[ee[444]] / this[ee[448]]), Ce = he[ee[46]][ee[45]](this[ee[445]] / this[ee[448]]);
              this[ee[458]] === ce[ee[420]] ? (fe = Se, ge = Math[ee[107]](0.5 * Ce) / Math[ee[107]](0.5 * Se)) : ge = this[ee[257]][ee[125]] / this[ee[423]] / this[ee[257]][ee[126]], this[ee[458]] === ce[ee[418]] ? (fe = 2 * Math[ee[102]](Math[ee[107]](Ce / 2) / ge), this[ee[444]] = he[ee[46]][ee[103]](fe) * this[ee[448]]) : this[ee[458]] === ce[ee[416]] && (fe = Se, this[ee[445]] = he[ee[46]][ee[103]](2 * Math[ee[102]](ge * Math[ee[107]](Se / 2))) / this[ee[423]] * this[ee[448]]), he[ee[437]][ee[473]](this[ee[429]], fe, ge, 0.1, 10), he[ee[437]][ee[474]](this[ee[427]], this[ee[429]]), he[ee[437]][ee[52]](this[ee[421]], this[ee[424]], this[ee[427]]);
            }, pe[ee[6]][ee[282]] = function(fe) {
              this[ee[422]] = this[ee[422]] || fe;
              for (var ge = (fe - this[ee[422]]) / 1e3, ye = he[ee[437]][ee[11]](), $e = 0; $e < this[ee[421]][ee[165]]; $e++)
                ye[$e] = this[ee[421]][$e];
              this[ee[449]] += ge, this[ee[439]][ee[282]](0, 0, 0), ge > 0 && this[ee[439]][ee[476]](this[ee[456]][ee[252]](this[ee[434]][ee[475]](ge)), this[ee[455]][ee[252]](this[ee[435]][ee[475]](ge)), this[ee[457]][ee[252]](this[ee[453]][ee[475]](ge))), this[ee[426]][ee[226]] += this[ee[439]][ee[230]], this[ee[426]][ee[227]] += this[ee[439]][ee[231]], this[ee[426]][ee[228]] += this[ee[439]][ee[232]], this[ee[426]] = pe[ee[460]](this[ee[426]], this[ee[321]][ee[466]]), this[ee[422]] = fe, this[ee[431]][ee[42]]() ? this[ee[465]](this[ee[431]][ee[41]]()) : this[ee[465]](), this[ee[441]][ee[476]](this[ee[439]]);
              var Se = Math[ee[411]](this[ee[441]][ee[165]]) > this[ee[443]] || Math[ee[411]](this[ee[441]][ee[232]]) > this[ee[443]];
              Se || this[ee[450]] || (this[ee[449]] = 0);
              var Ce = this[ee[449]] >= this[ee[442]];
              for (!Se || !Ce && this[ee[450]] ? Ce && this[ee[450]] && (this[ee[450]] = !1, this[ee[441]][ee[282]](0, 0, 0), this[ee[449]] = 0, this[ee[281]][ee[280]]()(_e[ee[279]][ee[477]], { direction: this[ee[425]] })) : (this[ee[450]] = !0, this[ee[449]] = 0, this[ee[441]][ee[282]](0, 0, 0), this[ee[281]][ee[280]]()(_e[ee[279]][ee[478]], { direction: this[ee[425]] })), this[ee[470]](), $e = 0; $e < this[ee[421]][ee[165]]; $e++)
                if (ye[$e] !== this[ee[421]][$e])
                  return !0;
              return !1;
            }, pe[ee[6]][ee[396]] = function() {
              this[ee[423]] = 2;
            }, pe[ee[6]][ee[397]] = function() {
              this[ee[423]] = 1;
            }, pe[ee[6]][ee[229]] = function(fe) {
              this[ee[453]][ee[479]](fe);
            }, pe[ee[6]][ee[233]] = function(fe) {
              this[ee[442]] = fe;
            }, pe[ee[6]][ee[234]] = function() {
              return this[ee[442]];
            }, pe[ee[6]][ee[235]] = function(fe) {
              this[ee[443]] = fe;
            }, pe[ee[6]][ee[236]] = function() {
              return this[ee[443]];
            }, pe[ee[6]][ee[67]] = function() {
              return this[ee[431]][ee[67]]();
            }, pe[ee[6]][ee[69]] = function() {
              return this[ee[431]][ee[69]]();
            }, pe[ee[6]][ee[308]] = function() {
              this[ee[435]][ee[480]](), this[ee[434]][ee[480]](), this[ee[435]] = null, this[ee[434]] = null;
            }, pe;
          }();
          ie[ee[366]] = me;
        }, 34081: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[440]] = void 0;
          var ce = ae(70016), he = Math[ee[481]] / 180, _e = 180 / Math[ee[481]], le = function() {
            function se(oe, ue, be, ve) {
              oe === void 0 && (oe = 0), ue === void 0 && (ue = 0), be === void 0 && (be = 0), ve === void 0 && (ve = !1), this[ee[482]] = null, this[ee[282]](oe, ue, be, ve);
            }
            return Object[ee[13]](se[ee[6]], ee[230], { get: function() {
              return this[ee[483]];
            }, set: function(oe) {
              this[ee[483]] !== oe && this[ee[282]](oe, this[ee[484]], this[ee[485]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[13]](se[ee[6]], ee[231], { get: function() {
              return this[ee[484]];
            }, set: function(oe) {
              this[ee[484]] !== oe && this[ee[282]](this[ee[483]], oe, this[ee[485]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[13]](se[ee[6]], ee[232], { get: function() {
              return this[ee[485]];
            }, set: function(oe) {
              this[ee[485]] !== oe && this[ee[282]](this[ee[483]], this[ee[484]], oe);
            }, enumerable: !1, configurable: !0 }), Object[ee[13]](se[ee[6]], ee[26], { get: function() {
              return this[ee[486]];
            }, set: function(oe) {
              this[ee[486]] !== oe && this[ee[282]](this[ee[487]] * Math[ee[47]](oe * he), this[ee[487]] * Math[ee[48]](oe * he), this[ee[485]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[13]](se[ee[6]], ee[165], { get: function() {
              return this[ee[487]];
            }, set: function(oe) {
              this[ee[487]] !== oe && this[ee[282]](oe * Math[ee[47]](this[ee[486]] * he), oe * Math[ee[48]](this[ee[486]] * he), this[ee[485]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[13]](se[ee[6]], ee[256], { get: function() {
              return this[ee[488]];
            }, enumerable: !1, configurable: !0 }), Object[ee[13]](se[ee[6]], ee[254], { get: function() {
              return this[ee[482]] || 0;
            }, set: function(oe) {
              this[ee[482]] = oe;
            }, enumerable: !1, configurable: !0 }), se[ee[6]][ee[282]] = function(oe, ue, be, ve, me) {
              if (be === void 0 && (be = 0), ee[212] == typeof ve && (this[ee[488]] = ve), (0, ce[ee[489]])(me) && (this[ee[482]] = me), this[ee[483]] !== oe || this[ee[484]] !== ue || this[ee[485]] !== be) {
                if (this[ee[483]] = Math[ee[411]](oe) < 1e-4 ? 0 : oe, this[ee[484]] = Math[ee[411]](ue) < 1e-4 ? 0 : ue, this[ee[485]] = Math[ee[411]](be) < 1e-4 ? 0 : be, this[ee[483]] === 0 && this[ee[484]] === 0 && this[ee[485]] === 0)
                  return this[ee[487]] = 0, void (this[ee[486]] = 0);
                this[ee[487]] = Math[ee[53]](this[ee[483]] * this[ee[483]] + this[ee[484]] * this[ee[484]]), this[ee[484]] === 0 && this[ee[483]] >= 0 ? this[ee[486]] = 0 : this[ee[483]] === 0 && this[ee[484]] > 0 ? this[ee[486]] = 90 : this[ee[483]] === 0 && this[ee[484]] < 0 ? this[ee[486]] = 270 : this[ee[483]] < 0 && this[ee[484]] === 0 ? this[ee[486]] = 180 : this[ee[483]] > 0 && this[ee[484]] > 0 ? this[ee[486]] = Math[ee[102]](this[ee[484]] / this[ee[483]]) * _e : this[ee[483]] < 0 && this[ee[484]] > 0 || this[ee[483]] < 0 && this[ee[484]] < 0 ? this[ee[486]] = 180 + Math[ee[102]](this[ee[484]] / this[ee[483]]) * _e : this[ee[483]] > 0 && this[ee[484]] < 0 ? this[ee[486]] = 360 + Math[ee[102]](this[ee[484]] / this[ee[483]]) * _e : this[ee[486]] = 0;
              }
            }, se[ee[6]][ee[490]] = function(oe, ue, be) {
              this[ee[282]](oe[ee[230]], oe[ee[231]], oe[ee[232]], ue, be);
            }, se[ee[6]][ee[476]] = function() {
              for (var oe = [], ue = 0; ue < arguments[ee[165]]; ue++)
                oe[ue] = arguments[ue];
              for (var be = this[ee[483]], ve = this[ee[484]], me = this[ee[485]], pe = 0, fe = oe; pe < fe[ee[165]]; pe++) {
                var ge = fe[pe];
                be += ge[ee[483]], ve += ge[ee[484]], me += ge[ee[485]];
              }
              this[ee[282]](be, ve, me);
            }, se[ee[6]][ee[491]] = function(oe, ue) {
              ue instanceof se ? this[ee[282]](ue[ee[230]] - oe[ee[230]], ue[ee[231]] - oe[ee[231]], ue[ee[232]] - oe[ee[232]]) : this[ee[282]](oe[ee[230]] - this[ee[483]], oe[ee[231]] - this[ee[484]], oe[ee[232]] - this[ee[485]]);
            }, se[ee[492]] = function(oe, ue) {
              oe instanceof se && ue instanceof se && ue[ee[282]](oe[ee[483]], oe[ee[484]], oe[ee[485]], oe[ee[488]], oe[ee[482]]);
            }, se[ee[6]][ee[493]] = function(oe) {
              this[ee[165]] = this[ee[487]] * oe;
            }, se;
          }();
          ie[ee[440]] = le;
        }, 39891: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[87]] = void 0;
          var ce = ae(31444), he = function() {
            function _e(le) {
              this[ee[494]] = le[ee[495]], this[ee[104]] = le[ee[496]][0], this[ee[97]] = le[ee[497]], this[ee[98]] = le[ee[498]], this[ee[94]] = le[ee[499]], this[ee[95]] = new ce[ee[409]](le[ee[365]]), this[ee[500]] = this[ee[95]][ee[415]]();
            }
            return _e;
          }();
          ie[ee[87]] = he;
        }, 40829: function(ne, ie) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[90]] = void 0;
          var ae = [{ type: ee[501], rules: [{ ua: ee[502] }], dpi: [320.8, 323], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[503] }], dpi: [403, 404.6], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[504] }], dpi: [449.7, 443.3], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[505] }], dpi: [315.3, 314.6], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[506] }], dpi: 289, bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[507] }], dpi: [442.5, 443.3], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[508] }], dpi: [449.7, 447.4], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[509] }], dpi: 472.8, bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[510] }], dpi: [515.1, 518], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[511] }], dpi: [422, 419.9], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[512] }], dpi: [221.7, 219.1], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[513] }], dpi: [422, 424.1], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[514] }], dpi: [537.9, 541.9], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[515] }], dpi: [537.9, 535.6], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[516] }], dpi: [442.4, 444.8], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[517] }], dpi: [319.8, 318.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[518] }], dpi: [240.6, 247.5], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[519] }], dpi: [206.6, 204.6], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[520] }], dpi: [403.4, 401.5], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[521] }], dpi: [240, 219.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[522] }], dpi: [480, 446.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[523] }], dpi: 240, bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[524] }], dpi: [368.1, 256.7], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[525] }], dpi: [254, 255.9], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[526] }], dpi: [254, 256.7], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[527] }], dpi: [254, 256.7], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[528] }], dpi: [326.6, 327.6], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[529] }], dpi: [326.6, 328.4], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[530] }], dpi: [315.3, 316.1], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[531] }], dpi: [403.4, 402.7], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[532] }], dpi: [494.3, 489.7], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[533] }], dpi: [295, 296.6], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[534] }], dpi: [295, 295.6], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[535] }], dpi: [422, 424.1], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[536] }], dpi: [422, 423.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[537] }], dpi: [403.4, 401], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[538] }], dpi: [442.4, 441.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[539] }], dpi: [391.9, 405.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[540] }], dpi: [442.4, 444.1], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[541] }], dpi: [184.7, 185.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[542] }], dpi: [196.7, 205.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[543] }], dpi: [234.5, 229.8], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[544] }], dpi: [304.8, 303.9], bw: 5, ac: 500 }, { type: ee[501], rules: [{ ua: ee[545] }], dpi: 216, bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[546] }], dpi: [217.7, 231.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[547] }], dpi: [386.4, 387], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[548] }], dpi: [386.4, 387.7], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[549] }], dpi: [442.5, 443.3], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[550] }], dpi: 439.4, bw: 4, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[551] }], dpi: [415.6, 431.6], bw: 5, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[552] }], dpi: [415.6, 431.6], bw: 5, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[553] }], dpi: 326.8, bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[554] }], dpi: [562.7, 572.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[544] }], dpi: [306.7, 304.8], bw: 5, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[555] }], dpi: [142.6, 136.4], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[556] }], dpi: [515.1, 518.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[557] }], dpi: [304.8, 305.8], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[558] }], dpi: [249.4, 256.7], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[559] }], dpi: [249.4, 255.9], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[560] }], dpi: 285.8, bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[561] }], dpi: [217.7, 204.2], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[562] }], dpi: 265.1, bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[563] }], dpi: 265.1, bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[564] }], dpi: [315.3, 314.2], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[565] }], dpi: [515.1, 518], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[566] }], dpi: [515.2, 520.2], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[567] }], dpi: [165.9, 164.8], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[568] }], dpi: [515.1, 518.4], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[569] }], dpi: 580.6, bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[570] }], dpi: [522.5, 577], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[571] }], dpi: 580.6, bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[572] }], dpi: [522.5, 576.6], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[573] }], dpi: [442.5, 443.3], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[574] }], dpi: [428.6, 427.6], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[575] }], dpi: [428.6, 425.7], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[576] }], dpi: [403.4, 401.9], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[577] }], dpi: [224.7, 224.1], bw: 3, ac: 500 }, { type: ee[501], rules: [{ ua: ee[578] }], dpi: [240, 247.5], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[579] }], dpi: [480, 443.3], bw: 3, ac: 1e3 }, { type: ee[501], rules: [{ ua: ee[580] }], dpi: 240, bw: 3, ac: 500 }, { type: ee[581], rules: [{ res: [640, 960] }], dpi: [325.1, 328.4], bw: 4, ac: 1e3 }, { type: ee[581], rules: [{ res: [640, 960] }], dpi: [325.1, 328.4], bw: 4, ac: 1e3 }, { type: ee[581], rules: [{ res: [640, 1136] }], dpi: [317.1, 320.2], bw: 3, ac: 1e3 }, { type: ee[581], rules: [{ res: [640, 1136] }], dpi: [317.1, 320.2], bw: 3, ac: 1e3 }, { type: ee[581], rules: [{ res: [750, 1334] }], dpi: 326.4, bw: 4, ac: 1e3 }, { type: ee[581], rules: [{ res: [750, 1334] }], dpi: 326.4, bw: 4, ac: 1e3 }, { type: ee[581], rules: [{ res: [1242, 2208] }], dpi: [453.6, 458.4], bw: 4, ac: 1e3 }, { type: ee[581], rules: [{ res: [1242, 2208] }], dpi: [453.6, 458.4], bw: 4, ac: 1e3 }], ce = function() {
            function le(se) {
              this[ee[125]] = se[ee[125]] || le[ee[582]](), this[ee[126]] = se[ee[126]] || le[ee[583]](), this[ee[96]] = se[ee[96]], this[ee[100]] = se[ee[100]], this[ee[99]] = se[ee[99]];
            }
            return le[ee[584]] = function() {
              return /iPad|iPhone|iPod/[ee[183]](navigator[ee[585]]);
            }, le[ee[582]] = function() {
              return Math[ee[108]](window[ee[63]][ee[125]], window[ee[63]][ee[126]]) * window[ee[377]];
            }, le[ee[583]] = function() {
              return Math[ee[105]](window[ee[63]][ee[125]], window[ee[63]][ee[126]]) * window[ee[377]];
            }, le[ee[89]] = function(se) {
              for (var oe = navigator[ee[181]] || navigator[ee[586]] || window[ee[587]], ue = le[ee[582]](), be = le[ee[583]](), ve = 0; ve < ae[ee[165]]; ve++) {
                var me = ae[ve];
                if (me[ee[588]])
                  if (ee[581] === me[ee[61]] || ee[501] === me[ee[61]]) {
                    if (le[ee[584]]() === (ee[581] === me[ee[61]])) {
                      for (var pe = !1, fe = 0; fe < me[ee[588]][ee[165]]; fe++) {
                        var ge = me[ee[588]][fe];
                        if (le[ee[589]](ge, oe, ue, be)) {
                          se[ee[303]](ee[590] + JSON[ee[364]](ge)), pe = !0;
                          break;
                        }
                      }
                      if (pe) {
                        var ye = 0.0254, $e = { width: ue, height: be, widthMeters: ye / (me[ee[591]][0] || me[ee[591]]) * ue, heightMeters: ye / (me[ee[591]][1] || me[ee[591]]) * be, bevelMeters: 1e-3 * me[ee[592]] };
                        return se[ee[303]](ee[593] + JSON[ee[364]]($e)), new le($e);
                      }
                    }
                  } else
                    se[ee[303]](ee[594] + ve + ee[595]);
                else
                  se[ee[303]](ee[594] + ve + ee[596]);
              }
              return le[ee[584]]() ? (se[ee[303]](ee[597]), _e) : (se[ee[303]](ee[598]), he);
            }, le[ee[589]] = function(se, oe, ue, be) {
              if (!se[ee[599]] && !se[ee[600]] || se[ee[599]] && oe[ee[161]](se[ee[599]]) < 0)
                return !1;
              if (se[ee[600]]) {
                if (!se[ee[600]][0] || !se[ee[600]][1])
                  return !1;
                var ve = se[ee[600]][0], me = se[ee[600]][1];
                if (Math[ee[105]](ue, be) !== Math[ee[105]](ve, me) || Math[ee[108]](ue, be) !== Math[ee[108]](ve, me))
                  return !1;
              }
              return !0;
            }, le;
          }();
          ie[ee[90]] = ce;
          var he = new ce({ widthMeters: 0.11, heightMeters: 0.062, bevelMeters: 4e-3 }), _e = new ce({ widthMeters: 0.1038, heightMeters: 0.0584, bevelMeters: 4e-3 });
        }, 41205: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[367]] = void 0;
          var ce = ae(83549), he = ae(62510), _e = ae(33696), le = ae(29328), se = ae(10755), oe = ae(78630), ue = 0.0555555, be = 4, ve = 3, me = function() {
            function fe() {
              this[ee[601]] = [], this[ee[602]] = [];
            }
            return fe[ee[6]][ee[603]] = function() {
              return this[ee[601]];
            }, fe[ee[6]][ee[604]] = function() {
              return this[ee[602]];
            }, fe[ee[6]][ee[476]] = function(ge, ye) {
              this[ee[601]][ee[161]](ge) < 0 && (this[ee[601]][ee[472]](ge), this[ee[601]][ee[605]](function($e, Se) {
                return $e - Se;
              })), this[ee[602]][ee[161]](ye) < 0 && (this[ee[602]][ee[472]](ye), this[ee[602]][ee[605]](function($e, Se) {
                return $e - Se;
              }));
            }, fe;
          }(), pe = function() {
            function fe(ge, ye, $e, Se, Ce, Ie, Te, Ee, we) {
              var Pe = this;
              this[ee[606]] = null, this[ee[607]] = null, this[ee[263]] = se[ee[134]][ee[135]], this[ee[423]] = -1, this[ee[608]] = !1, this[ee[609]] = -1, this[ee[610]] = -1, this[ee[152]] = -1, this[ee[611]] = -1, this[ee[612]] = -1, this[ee[613]] = [-1, -1, 1, -1, 1, 1, -1, 1], this[ee[614]] = [0, 1, 2, 0, 2, 3], this[ee[615]] = -1, this[ee[616]] = new RegExp(ee[617], ee[618]), this[ee[619]] = !0, this[ee[620]] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this[ee[621]] = { LEFT: 0, RIGHT: 1 }, this[ee[622]] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this[ee[623]] = 1, this[ee[624]] = [[1, 1], [1, 1]], this[ee[625]] = [1, 1], this[ee[304]] = null, this[ee[257]] = null, this[ee[258]] = null, this[ee[313]] = null, this[ee[626]] = null, this[ee[323]] = null, this[ee[627]] = -1, this[ee[628]] = -1, this[ee[629]] = null, this[ee[630]] = !1, this[ee[327]] = null, Ee[ee[264]] ? (this[ee[608]] = !0, this[ee[423]] = 2) : (this[ee[608]] = !1, this[ee[423]] = 1), this[ee[281]] = $e[ee[281]], this[ee[304]] = Ie, this[ee[257]] = ge, this[ee[258]] = ye, this[ee[313]] = $e[ee[316]], this[ee[626]] = Ce, this[ee[323]] = $e[ee[326]][ee[325]][ee[324]], this[ee[327]] = Te, this[ee[321]] = Ee, this[ee[276]] = we, this[ee[631]] = [], this[ee[281]][ee[368]](he[ee[279]][ee[632]], function() {
                return Pe[ee[619]] = !1;
              }), Se && (this[ee[622]] = this[ee[633]](Se), this[ee[623]] = this[ee[634]](Se), this[ee[624]][this[ee[621]][ee[635]]] = this[ee[636]](Se, this[ee[621]][ee[635]]), this[ee[624]][this[ee[621]][ee[637]]] = this[ee[636]](Se, this[ee[621]][ee[637]]), this[ee[625]] = this[ee[638]](Se)), this[ee[629]] = new me(), this[ee[639]] = new oe[ee[640]](1500, 1e3), this[ee[321]][ee[641]] ? (this[ee[639]][ee[40]](), this[ee[639]][ee[642]](this)) : this[ee[639]][ee[432]]();
              try {
                this[ee[643]](), this[ee[644]](), this[ee[645]](), this[ee[646]](), this[ee[647]](), this[ee[648]](), this[ee[649]](), this[ee[650]]();
              } catch (Me) {
                this[ee[304]][ee[209]](Me);
              }
            }
            return fe[ee[6]][ee[651]] = function(ge) {
              if (ge === void 0 && (ge = []), this[ee[606]] !== null) {
                var ye = this[ee[606]][ee[652]]();
                if (ye === se[ee[134]][ee[135]])
                  return this[ee[263]] = se[ee[134]][ee[135]], void (this[ee[631]] = []);
                if (this[ee[631]][ee[472]](ye), ge[ee[161]](ye) > -1 && this[ee[619]])
                  throw this[ee[263]] = se[ee[134]][ee[135]], this[ee[631]] = [], ee[653];
                if (!(this[ee[631]][ee[165]] >= this[ee[327]][ee[654]]))
                  return;
                this[ee[263]] = this[ee[631]][this[ee[631]][ee[165]] - 1];
              }
              var $e = ee[655];
              throw se[ee[133]][this[ee[263]]] && ($e = se[ee[133]][this[ee[263]]]), this[ee[626]]($e), $e;
            }, fe[ee[6]][ee[656]] = function(ge, ye) {
              for (var $e = [], Se = 2; Se < arguments[ee[165]]; Se++)
                $e[Se - 2] = arguments[Se];
              var Ce = null;
              if (ge && ee[7] == typeof ge[ye]) {
                try {
                  Ce = ge[ye][ee[252]](ge, $e);
                } catch (Ie) {
                  this[ee[304]][ee[660]](ee[657] + ye + ee[658] + JSON[ee[364]]($e) + ee[659] + Ie);
                }
                this[ee[651]]();
              }
              return Ce;
            }, fe[ee[6]][ee[661]] = function(ge) {
              throw this[ee[263]] = se[ee[134]][ee[136]], this[ee[626]](ge), ge;
            }, fe[ee[6]][ee[644]] = function() {
              this[ee[662]] = ae(10768), this[ee[663]] = ae(50766);
              var ge = this[ee[656]](this[ee[606]], ee[664], this[ee[606]][ee[665]], this[ee[606]][ee[666]]);
              ge[ee[667]] !== 0 && ge[ee[668]] !== 0 && ge[ee[669]] !== 0 && (this[ee[662]] = this[ee[662]][ee[177]](this[ee[616]], ee[670])), (ge = this[ee[656]](this[ee[606]], ee[664], this[ee[606]][ee[671]], this[ee[606]][ee[666]]))[ee[667]] !== 0 && ge[ee[668]] !== 0 && ge[ee[669]] !== 0 && (this[ee[663]] = this[ee[663]][ee[177]](this[ee[616]], ee[670]));
            }, fe[ee[6]][ee[643]] = function() {
              this[ee[258]] && (this[ee[607]] = this[ee[258]][ee[673]](ee[672]));
              var ge = { failIfMajorPerformanceCaveat: !0 };
              this[ee[606]] = this[ee[257]][ee[673]](ee[674], ge) || this[ee[257]][ee[673]](ee[675], ge), this[ee[651]](), this[ee[656]](this[ee[606]], ee[676], 0.5, 0.5, 0.5, 1), this[ee[656]](this[ee[606]], ee[677], 1), this[ee[656]](this[ee[606]], ee[432], this[ee[606]][ee[678]]);
            }, fe[ee[6]][ee[645]] = function() {
              this[ee[609]] = this[ee[656]](this[ee[606]], ee[679], this[ee[606]][ee[671]]), this[ee[656]](this[ee[606]], ee[680], this[ee[609]], this[ee[663]]), this[ee[656]](this[ee[606]], ee[681], this[ee[609]]), this[ee[656]](this[ee[606]], ee[682], this[ee[609]], this[ee[606]][ee[683]]) || this[ee[661]](ee[684] + this[ee[656]](this[ee[606]], ee[685], this[ee[609]]) + ee[686]), this[ee[610]] = this[ee[656]](this[ee[606]], ee[679], this[ee[606]][ee[665]]), this[ee[656]](this[ee[606]], ee[680], this[ee[610]], this[ee[662]]), this[ee[656]](this[ee[606]], ee[681], this[ee[610]]), this[ee[656]](this[ee[606]], ee[682], this[ee[610]], this[ee[606]][ee[683]]) || this[ee[661]](ee[687] + this[ee[656]](this[ee[606]], ee[685], this[ee[610]]) + ee[686]);
            }, fe[ee[6]][ee[646]] = function() {
              this[ee[152]] = this[ee[656]](this[ee[606]], ee[646]), this[ee[656]](this[ee[606]], ee[688], this[ee[152]], this[ee[609]]), this[ee[656]](this[ee[606]], ee[688], this[ee[152]], this[ee[610]]), this[ee[656]](this[ee[606]], ee[689], this[ee[152]]), this[ee[656]](this[ee[606]], ee[690], this[ee[152]], this[ee[606]][ee[691]]) || this[ee[661]](ee[692] + this[ee[656]](this[ee[606]], ee[693], this[ee[152]])), this[ee[656]](this[ee[606]], ee[694], this[ee[152]]);
            }, fe[ee[6]][ee[647]] = function() {
              this[ee[695]] = new se[ee[131]](this[ee[606]], this[ee[152]], ee[695], null);
            }, fe[ee[6]][ee[648]] = function() {
              this[ee[696]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[696], se[ee[132]][ee[141]]), this[ee[697]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[697], se[ee[132]][ee[141]]), this[ee[698]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[698], se[ee[132]][ee[141]]), this[ee[699]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[699], se[ee[132]][ee[143]]), this[ee[375]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[375], se[ee[132]][ee[143]]), this[ee[376]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[376], se[ee[132]][ee[143]]), this[ee[421]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[421], se[ee[132]][ee[145]]), this[ee[700]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[700], se[ee[132]][ee[147]]), this[ee[701]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[701], se[ee[132]][ee[143]]), this[ee[702]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[702], se[ee[132]][ee[149]]), this[ee[703]] = new se[ee[130]](this[ee[606]], this[ee[152]], ee[703], se[ee[132]][ee[149]]);
            }, fe[ee[6]][ee[649]] = function() {
              this[ee[611]] = this[ee[656]](this[ee[606]], ee[704]), this[ee[656]](this[ee[606]], ee[705], this[ee[606]][ee[706]], this[ee[611]]), this[ee[656]](this[ee[606]], ee[707], this[ee[606]][ee[706]], new Float32Array(this[ee[613]]), this[ee[606]][ee[708]]), this[ee[612]] = this[ee[656]](this[ee[606]], ee[704]), this[ee[656]](this[ee[606]], ee[705], this[ee[606]][ee[709]], this[ee[612]]), this[ee[656]](this[ee[606]], ee[707], this[ee[606]][ee[709]], new Uint16Array(this[ee[614]]), this[ee[606]][ee[708]]);
            }, fe[ee[6]][ee[650]] = function() {
              this[ee[615]] = this[ee[656]](this[ee[606]], ee[650]), this[ee[656]](this[ee[606]], ee[710], this[ee[606]][ee[711]], this[ee[615]]), this[ee[656]](this[ee[606]], ee[712], this[ee[606]][ee[711]], this[ee[606]][ee[713]], this[ee[606]][ee[714]]), this[ee[656]](this[ee[606]], ee[712], this[ee[606]][ee[711]], this[ee[606]][ee[715]], this[ee[606]][ee[714]]), this[ee[656]](this[ee[606]], ee[712], this[ee[606]][ee[711]], this[ee[606]][ee[716]], this[ee[606]][ee[717]]), this[ee[656]](this[ee[606]], ee[712], this[ee[606]][ee[711]], this[ee[606]][ee[718]], this[ee[606]][ee[717]]);
            }, fe[ee[6]][ee[719]] = function(ge, ye) {
              var $e, Se, Ce = this[ee[656]](this[ee[607]], ee[720], 0, 0, ge, ye);
              if (!Ce)
                return this[ee[304]][ee[303]](ee[721]), void (this[ee[630]] = !1);
              for (var Ie = this[ee[629]][ee[603]](), Te = this[ee[629]][ee[604]](), Ee = 0; Ee < Ie[ee[165]] && Ce[ee[33]][(Ie[Ee] - 1) * be + ve] > 0; Ee++)
                $e = Math[ee[105]](Ie[Ee], ge);
              for (var we = 0; we < Te[ee[165]] && Ce[ee[33]][(Te[we] - 1) * this[ee[313]][ee[375]] * be + ve] > 0; we++)
                Se = Math[ee[105]](Te[we], ye);
              $e && Se && ($e !== ge || Se !== ye) ? (this[ee[304]][ee[303]](ee[722] + ge + ee[230] + ye + ee[723] + $e + ee[230] + Se + ee[724]), this[ee[656]](this[ee[607]], ee[725], this[ee[258]], 0, 0, $e, Se, 0, 0, this[ee[258]][ee[125]], this[ee[258]][ee[126]])) : this[ee[630]] = !1;
            }, fe[ee[6]][ee[726]] = function() {
              if (!this[ee[263]] || this[ee[263]] === se[ee[134]][ee[135]]) {
                var ge = this[ee[313]][ee[375]], ye = this[ee[313]][ee[376]];
                if (this[ee[258]] && this[ee[607]]) {
                  var $e = 0;
                  this[ee[323]] !== _e[ee[386]][ee[727]] && /Trident/[ee[183]](navigator[ee[181]]) && ($e = ye * ue);
                  var Se = ye - 2 * $e;
                  this[ee[656]](this[ee[607]], ee[725], this[ee[313]][ee[728]](), 0, $e, ge, Se, 0, 0, this[ee[258]][ee[125]], this[ee[258]][ee[126]]), this[ee[629]][ee[476]](ge, ye);
                  var Ce = this[ee[627]] !== ge, Ie = this[ee[628]] !== ye;
                  !Ce && !Ie || /Trident/[ee[183]](navigator[ee[181]]) || (this[ee[630]] = !0), this[ee[630]] && this[ee[719]](ge, ye), this[ee[627]] = ge, this[ee[628]] = ye;
                }
                this[ee[656]](this[ee[606]], ee[729], this[ee[606]][ee[730]]), this[ee[656]](this[ee[606]], ee[710], this[ee[606]][ee[711]], this[ee[615]]);
                try {
                  var Te = this[ee[276]][ee[731]] !== null ? this[ee[276]][ee[731]]() : null;
                  Te !== null ? this[ee[656]](this[ee[606]], ee[732], this[ee[606]][ee[711]], 0, this[ee[606]][ee[733]], this[ee[606]][ee[733]], this[ee[606]][ee[734]], Te) : this[ee[258]] ? this[ee[656]](this[ee[606]], ee[732], this[ee[606]][ee[711]], 0, this[ee[606]][ee[733]], this[ee[606]][ee[733]], this[ee[606]][ee[734]], this[ee[258]]) : this[ee[656]](this[ee[606]], ee[732], this[ee[606]][ee[711]], 0, this[ee[606]][ee[733]], this[ee[606]][ee[733]], this[ee[606]][ee[734]], this[ee[313]][ee[728]]());
                } catch (Ee) {
                  this[ee[661]](Ee[ee[35]]);
                }
              }
            }, fe[ee[6]][ee[735]] = function(ge, ye, $e) {
              this[ee[304]][ee[303]](ee[736] + ge[ee[737]](2) + ee[738] + (100 * $e)[ee[737]](2) + ee[739] + (100 * ye)[ee[737]](2) + ee[740]);
            }, fe[ee[6]][ee[741]] = function(ge, ye) {
              if (!this[ee[263]] || this[ee[263]] === se[ee[134]][ee[135]]) {
                switch (this[ee[656]](this[ee[606]], ee[694], this[ee[152]]), this[ee[656]](this[ee[606]], ee[705], this[ee[606]][ee[706]], this[ee[611]]), this[ee[656]](this[ee[606]], ee[743], this[ee[695]][ee[154]], 2, this[ee[606]][ee[744]], !1, 0, 0), this[ee[656]](this[ee[606]], ee[729], this[ee[606]][ee[730]]), this[ee[656]](this[ee[606]], ee[710], this[ee[606]][ee[711]], this[ee[615]]), this[ee[696]][ee[158]](ge), this[ee[697]][ee[158]](0), this[ee[699]][ee[158]](this[ee[321]][ee[699]]), isFinite(this[ee[313]][ee[375]]) && this[ee[313]][ee[375]] > 0 && isFinite(this[ee[313]][ee[376]]) && this[ee[313]][ee[376]] > 0 ? (this[ee[375]][ee[158]](this[ee[313]][ee[375]]), this[ee[376]][ee[158]](this[ee[313]][ee[376]])) : (this[ee[375]][ee[158]](4096), this[ee[376]][ee[158]](2048)), this[ee[321]][ee[698]]) {
                  case le[ee[247]][ee[398]]:
                    this[ee[698]][ee[158]](0);
                    break;
                  case le[ee[247]][ee[402]]:
                    this[ee[698]][ee[158]](1);
                    break;
                  case le[ee[247]][ee[400]]:
                    this[ee[698]][ee[158]](2);
                    break;
                  default:
                    this[ee[661]](ee[742] + this[ee[321]][ee[698]] + ee[686]);
                }
                this[ee[700]][ee[158]](this[ee[622]]), this[ee[701]][ee[158]](this[ee[623]]), this[ee[702]][ee[158]](this[ee[624]][ge]), this[ee[703]][ee[158]](this[ee[625]]), this[ee[421]][ee[158]](ye), this[ee[656]](this[ee[606]], ee[745], this[ee[257]][ee[125]] / 2 * ge, 0, this[ee[257]][ee[125]] / this[ee[423]], this[ee[257]][ee[126]]), this[ee[656]](this[ee[606]], ee[705], this[ee[606]][ee[709]], this[ee[612]]), this[ee[656]](this[ee[606]], ee[746], this[ee[606]][ee[747]], 6, this[ee[606]][ee[748]], 0);
              }
            }, fe[ee[6]][ee[633]] = function(ge) {
              return ge ? ge[ee[86]][ee[500]] : this[ee[620]];
            }, fe[ee[6]][ee[634]] = function(ge) {
              var ye = this[ee[749]](ge), $e = ce[ee[46]][ee[750]](Math[ee[107]](ce[ee[46]][ee[45]](Math[ee[108]](ye[ee[115]], ye[ee[116]]))), Math[ee[107]](ce[ee[46]][ee[45]](Math[ee[108]](ye[ee[117]], ye[ee[118]]))));
              return $e * $e;
            }, fe[ee[6]][ee[749]] = function(ge, ye) {
              var $e = ye || this[ee[621]][ee[635]];
              return $e === this[ee[621]][ee[635]] ? ge[ee[112]](!0) : $e === this[ee[621]][ee[637]] ? ge[ee[114]](!0) : null;
            }, fe[ee[6]][ee[636]] = function(ge, ye) {
              var $e = this[ee[749]](ge, ye);
              return [Math[ee[107]](ce[ee[46]][ee[45]]($e[ee[115]])), Math[ee[107]](ce[ee[46]][ee[45]]($e[ee[117]]))];
            }, fe[ee[6]][ee[638]] = function(ge) {
              var ye = this[ee[749]](ge);
              return [Math[ee[107]](ce[ee[46]][ee[45]](ye[ee[115]])) + Math[ee[107]](ce[ee[46]][ee[45]](ye[ee[116]])), Math[ee[107]](ce[ee[46]][ee[45]](ye[ee[118]])) + Math[ee[107]](ce[ee[46]][ee[45]](ye[ee[117]]))];
            }, fe[ee[6]][ee[378]] = function() {
              var ge = 0;
              return this[ee[263]] === se[ee[134]][ee[135]] && (ge = (ge = (ge = (ge = (ge = ge || this[ee[606]][ee[751]]) || this[ee[606]][ee[752]]) || this[ee[606]][ee[753]]) || this[ee[606]][ee[754]]) || this[ee[606]][ee[755]]), ge = ge || 1;
            }, fe[ee[6]][ee[396]] = function() {
              this[ee[608]] = !0, this[ee[423]] = 2;
            }, fe[ee[6]][ee[397]] = function() {
              this[ee[608]] = !1, this[ee[423]] = 1;
            }, fe[ee[6]][ee[288]] = function(ge, ye) {
              if ((!this[ee[263]] || this[ee[263]] === se[ee[134]][ee[135]]) && this[ee[606]] && this[ee[313]][ee[728]]()) {
                this[ee[639]][ee[756]](), this[ee[639]][ee[757]](), this[ee[639]][ee[758]]();
                try {
                  this[ee[639]][ee[759]](), ye && this[ee[726]](), this[ee[639]][ee[760]](), this[ee[741]](this[ee[621]][ee[635]], ge), this[ee[608]] && this[ee[741]](this[ee[621]][ee[637]], ge), this[ee[276]][ee[761]] !== null && this[ee[276]][ee[761]](this[ee[606]]), this[ee[651]]([se[ee[134]][ee[140]]]);
                } catch ($e) {
                  this[ee[304]][ee[660]](ee[762] + $e);
                }
                this[ee[639]][ee[763]]();
              }
            }, fe[ee[6]][ee[308]] = function() {
              this[ee[639]][ee[764]](this), this[ee[639]][ee[308]](), this[ee[639]] = null, this[ee[629]] = null, this[ee[606]] = null, this[ee[257]] = null, this[ee[607]] = null, this[ee[258]] = null;
            }, fe;
          }();
          ie[ee[367]] = pe;
        }, 41772: function(ne, ie) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[765]] = void 0;
          var ae = function() {
            function ce(he) {
              this[ee[321]] = he;
            }
            return ce;
          }();
          ie[ee[765]] = ae;
        }, 41775: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var se = function(oe, ue) {
              return se = Object[ee[2]] || { __proto__: [] } instanceof Array && function(be, ve) {
                be[ee[3]] = ve;
              } || function(be, ve) {
                for (var me in ve)
                  Object[ee[6]][ee[5]][ee[4]](ve, me) && (be[me] = ve[me]);
              }, se(oe, ue);
            };
            return function(oe, ue) {
              if (ee[7] != typeof ue && ue !== null)
                throw new TypeError(ee[8] + String(ue) + ee[9]);
              function be() {
                this[ee[10]] = oe;
              }
              se(oe, ue), oe[ee[6]] = ue === null ? Object[ee[11]](ue) : (be[ee[6]] = ue[ee[6]], new be());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[452]] = void 0;
          var he = ae(34081), _e = ae(12553), le = function(se) {
            function oe(ue, be, ve, me, pe) {
              pe === void 0 && (pe = 90);
              var fe = se[ee[4]](this, ue, be) || this;
              return fe[ee[767]] = function(ge) {
                var ye = oe[ee[768]](ge), $e = 0, Se = 0;
                fe[ee[769]] && ($e = ye[ee[230]] - fe[ee[770]][ee[230]], Se = ye[ee[231]] - fe[ee[770]][ee[231]], fe[ee[771]][ee[230]] += $e, fe[ee[771]][ee[231]] += Se, fe[ee[770]] = ye), Math[ee[411]]($e) + Math[ee[411]](Se) > 0 && (fe[ee[772]] = !0), ge[ee[773]]();
              }, fe[ee[774]] = function(ge) {
                ge[ee[775]](), ge[ee[773]](), _e[ee[164]][ee[39]](document, [ee[199]], fe[ee[774]], !0);
              }, fe[ee[776]] = function(ge) {
                _e[ee[164]][ee[39]](document, _e[ee[164]][ee[180]][ee[777]], fe[ee[767]], !1), _e[ee[164]][ee[39]](document, _e[ee[164]][ee[180]][ee[778]], fe[ee[776]], !1), _e[ee[164]][ee[39]](fe[ee[318]], _e[ee[164]][ee[180]][ee[778]], fe[ee[776]], !1), _e[ee[164]][ee[172]](document[ee[779]], ee[780]), fe[ee[770]] = null, fe[ee[769]] = !1, fe[ee[772]] && fe[ee[781]] && ge[ee[782]] === fe[ee[781]] && _e[ee[164]][ee[36]](document, [ee[199]], fe[ee[774]], !0), fe[ee[772]] = !1, fe[ee[781]] = null;
              }, fe[ee[783]] = function(ge) {
                fe[ee[770]] = oe[ee[768]](ge), fe[ee[771]] = { x: 0, y: 0 }, fe[ee[769]] = !0, fe[ee[772]] = !1, fe[ee[781]] = ge[ee[782]], _e[ee[164]][ee[36]](document, _e[ee[164]][ee[180]][ee[777]], fe[ee[767]], !1), _e[ee[164]][ee[36]](document, _e[ee[164]][ee[180]][ee[778]], fe[ee[776]], !1), _e[ee[164]][ee[36]](fe[ee[318]], _e[ee[164]][ee[180]][ee[778]], fe[ee[776]], !1), _e[ee[164]][ee[166]](document[ee[779]], ee[780]);
              }, fe[ee[318]] = ve, fe[ee[257]] = me, fe[ee[769]] = !1, fe[ee[770]] = null, fe[ee[771]] = { x: 0, y: 0 }, fe[ee[784]] = pe, fe[ee[785]] = new he[ee[440]](), fe[ee[40]](), fe;
            }
            return ce(oe, se), oe[ee[6]][ee[475]] = function(ue) {
              var be = this[ee[257]][ee[371]], ve = this[ee[257]][ee[372]], me = !!this[ee[276]][ee[786]], pe = this[ee[784]] * (ve / be);
              if (this[ee[771]] = me ? this[ee[276]][ee[786]](ue) : this[ee[771]], this[ee[43]] && isFinite(pe) && pe > 0) {
                var fe = this[ee[769]] || this[ee[771]][ee[230]] !== 0 || this[ee[771]][ee[231]] !== 0;
                this[ee[785]][ee[282]](this[ee[771]][ee[230]] / this[ee[257]][ee[371]] * this[ee[784]], this[ee[771]][ee[231]] / this[ee[257]][ee[372]] * pe, 0, fe, ue), this[ee[771]] = { x: 0, y: 0 };
              } else
                this[ee[785]][ee[282]](0, 0, 0, this[ee[769]], ue);
              return this[ee[785]];
            }, oe[ee[6]][ee[40]] = function() {
              this[ee[43]] = !0, _e[ee[164]][ee[36]](this[ee[318]], _e[ee[164]][ee[180]][ee[787]], this[ee[783]], !1);
            }, oe[ee[6]][ee[432]] = function() {
              this[ee[43]] = !1, _e[ee[164]][ee[39]](document, _e[ee[164]][ee[180]][ee[777]], this[ee[767]], !1), _e[ee[164]][ee[39]](document, _e[ee[164]][ee[180]][ee[778]], this[ee[776]], !1), _e[ee[164]][ee[39]](this[ee[318]], _e[ee[164]][ee[180]][ee[778]], this[ee[776]], !1), _e[ee[164]][ee[39]](this[ee[318]], _e[ee[164]][ee[180]][ee[787]], this[ee[783]], !1), _e[ee[164]][ee[39]](document, [ee[199]], this[ee[774]], !0), this[ee[770]] = null, this[ee[769]] = !1, this[ee[772]] = !1, this[ee[781]] = null, _e[ee[164]][ee[172]](document[ee[779]], ee[780]);
            }, oe[ee[6]][ee[480]] = function() {
              this[ee[432]](), this[ee[318]] = null, this[ee[257]] = null;
            }, oe[ee[768]] = function(ue) {
              var be = { x: 0, y: 0 };
              return ee[187] === _e[ee[164]][ee[180]][ee[61]] ? (be[ee[230]] = ue[ee[788]] || ue[ee[790]][ee[789]], be[ee[231]] = ue[ee[791]] || ue[ee[790]][ee[792]]) : ee[192] === _e[ee[164]][ee[180]][ee[61]] ? (be[ee[230]] = ue[ee[793]][0][ee[788]], be[ee[231]] = ue[ee[793]][0][ee[791]]) : (be[ee[230]] = ue[ee[788]], be[ee[231]] = ue[ee[791]]), be[ee[230]] = be[ee[230]] || 0, be[ee[231]] = be[ee[231]] || 0, be;
            }, oe;
          }(ae(68978)[ee[766]]);
          ie[ee[452]] = le;
        }, 46446: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var le = function(se, oe) {
              return le = Object[ee[2]] || { __proto__: [] } instanceof Array && function(ue, be) {
                ue[ee[3]] = be;
              } || function(ue, be) {
                for (var ve in be)
                  Object[ee[6]][ee[5]][ee[4]](be, ve) && (ue[ve] = be[ve]);
              }, le(se, oe);
            };
            return function(se, oe) {
              if (ee[7] != typeof oe && oe !== null)
                throw new TypeError(ee[8] + String(oe) + ee[9]);
              function ue() {
                this[ee[10]] = se;
              }
              le(se, oe), se[ee[6]] = oe === null ? Object[ee[11]](oe) : (ue[ee[6]] = oe[ee[6]], new ue());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[454]] = void 0;
          var he = ae(34081), _e = function(le) {
            function se(oe, ue, be) {
              var ve = le[ee[4]](this, oe, ue) || this;
              return ve[ee[233]](be), ve[ee[255]] = new he[ee[440]](), ve[ee[439]] = new he[ee[440]](), ve[ee[794]] = 0, ve;
            }
            return ce(se, le), se[ee[6]][ee[475]] = function(oe) {
              return this[ee[794]] += oe, this[ee[794]] > this[ee[442]] ? this[ee[439]][ee[282]](0, 0, 0, !1, oe) : (he[ee[440]][ee[492]](this[ee[255]], this[ee[439]]), this[ee[439]][ee[165]] = this[ee[255]][ee[165]] * oe, this[ee[439]][ee[232]] = this[ee[255]][ee[232]] * oe, this[ee[439]][ee[282]](this[ee[439]][ee[230]], this[ee[439]][ee[231]], this[ee[439]][ee[232]], !0, oe)), this[ee[439]];
            }, se[ee[6]][ee[479]] = function(oe) {
              this[ee[255]][ee[490]](oe, !0), this[ee[794]] = 0;
            }, se[ee[6]][ee[233]] = function(oe) {
              this[ee[442]] = oe;
            }, se[ee[6]][ee[480]] = function() {
              this[ee[432]]();
            }, se;
          }(ae(68978)[ee[766]]);
          ie[ee[454]] = _e;
        }, 50766: function(ne) {
          ne[ee[162]] = ee[795];
        }, 52241: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[362]] = void 0;
          var ce = ae(72532), he = ae(62979), _e = function() {
            function le() {
            }
            return le[ee[361]] = function(se) {
              return new ce[ee[800]](he[ee[798]][ee[797]](se), le[ee[799]])[ee[796]]();
            }, le[ee[799]] = { 1: { name: ee[586], type: ee[359] }, 2: { name: ee[495], type: ee[359] }, 3: { name: ee[499], type: ee[801] }, 4: { name: ee[497], type: ee[801] }, 5: { name: ee[496], type: ee[801], packed: !0 }, 11: { name: ee[802], type: { 0: ee[803], 1: ee[804], 2: ee[34] } }, 6: { name: ee[498], type: ee[801] }, 7: { name: ee[365], type: ee[801], packed: !0 }, 10: { name: ee[805], type: ee[212] }, 12: { name: ee[806], type: { 0: ee[332], 1: ee[807], 2: ee[808], 3: ee[809] } }, defaults: { vertical_alignment: ee[803], primary_button: ee[807] } }, le;
          }();
          ie[ee[362]] = _e;
        }, 58269: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var _e = function(le, se) {
              return _e = Object[ee[2]] || { __proto__: [] } instanceof Array && function(oe, ue) {
                oe[ee[3]] = ue;
              } || function(oe, ue) {
                for (var be in ue)
                  Object[ee[6]][ee[5]][ee[4]](ue, be) && (oe[be] = ue[be]);
              }, _e(le, se);
            };
            return function(le, se) {
              if (ee[7] != typeof se && se !== null)
                throw new TypeError(ee[8] + String(se) + ee[9]);
              function oe() {
                this[ee[10]] = le;
              }
              _e(le, se), le[ee[6]] = se === null ? Object[ee[11]](se) : (oe[ee[6]] = se[ee[6]], new oe());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[78]] = void 0;
          var he = function(_e) {
            function le() {
              return _e !== null && _e[ee[252]](this, arguments) || this;
            }
            return ce(le, _e), le[ee[6]][ee[253]] = function() {
              var se = isFinite(this[ee[255]][ee[254]]), oe = this[ee[255]][ee[254]] > 0, ue = this[ee[255]][ee[256]];
              return se && oe && ue;
            }, le;
          }(ae(89099)[ee[82]]);
          ie[ee[78]] = he;
        }, 62886: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var le = function(se, oe) {
              return le = Object[ee[2]] || { __proto__: [] } instanceof Array && function(ue, be) {
                ue[ee[3]] = be;
              } || function(ue, be) {
                for (var ve in be)
                  Object[ee[6]][ee[5]][ee[4]](be, ve) && (ue[ve] = be[ve]);
              }, le(se, oe);
            };
            return function(se, oe) {
              if (ee[7] != typeof oe && oe !== null)
                throw new TypeError(ee[8] + String(oe) + ee[9]);
              function ue() {
                this[ee[10]] = se;
              }
              le(se, oe), se[ee[6]] = oe === null ? Object[ee[11]](oe) : (ue[ee[6]] = oe[ee[6]], new ue());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[810]] = void 0;
          var he = ae(83549), _e = function(le) {
            function se() {
              var oe = le[ee[4]](this) || this;
              return oe[ee[811]] = null, oe[ee[812]] = null, oe[ee[813]] = function(ue) {
                var be;
                for (be = 0; be < ue[ee[165]]; ++be)
                  if (ue[be] instanceof HMDVRDevice) {
                    oe[ee[811]] = ue[be];
                    break;
                  }
                if (oe[ee[811]]) {
                  for (be = 0; be < ue[ee[165]]; ++be)
                    if (ue[be] instanceof PositionSensorVRDevice && ue[be][ee[814]] === oe[ee[811]][ee[814]]) {
                      oe[ee[812]] = ue[be];
                      break;
                    }
                }
              }, navigator[ee[815]] && navigator[ee[815]]()[ee[72]](oe[ee[813]]), oe[ee[40]](), oe;
            }
            return ce(se, le), se[ee[6]][ee[41]] = function() {
              if (this[ee[42]]() && this[ee[43]]) {
                var oe = this[ee[812]][ee[210]](), ue = new Float32Array([0, 0, 0, 0]);
                return oe !== null && oe[ee[62]] && (ue = new Float32Array([oe[ee[62]][ee[230]], oe[ee[62]][ee[231]], oe[ee[62]][ee[816]], oe[ee[62]][ee[817]]])), he[ee[50]][ee[54]](ue);
              }
              return this[ee[44]];
            }, se[ee[6]][ee[471]] = function() {
              return this[ee[42]]() ? this[ee[811]][ee[820]](ee[819])[ee[818]] : this[ee[821]];
            }, se[ee[6]][ee[42]] = function() {
              return this[ee[812]] !== null && this[ee[811]] !== null;
            }, se[ee[55]] = function() {
              return !!navigator[ee[815]];
            }, se;
          }(ae(93056)[ee[19]]);
          ie[ee[810]] = _e;
        }, 62979: function(ne, ie) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[798]] = void 0;
          var ae = function() {
            function ce() {
            }
            return ce[ee[822]] = function(he, _e) {
              _e = !!_e;
              for (var le = he[ee[165]], se = new Uint8Array(_e ? 4 * le : le), oe = 0, ue = 0; ue < le; ue++) {
                var be = he[ee[823]](ue);
                if (_e && 55296 <= be && be <= 56319) {
                  if (++ue >= le)
                    throw new Error(ee[824] + ue);
                  be = (55296 ^ be) << 10 | 65536 | 56320 ^ he[ee[823]](ue);
                } else if (!_e && be >>> 8)
                  throw new Error(ee[825]);
                !_e || be <= 127 ? se[oe++] = be : be <= 2047 ? (se[oe++] = 192 | be >> 6, se[oe++] = 128 | 63 & be) : be <= 65535 ? (se[oe++] = 224 | be >> 12, se[oe++] = 128 | be >> 6 & 63, se[oe++] = 128 | 63 & be) : (se[oe++] = 240 | be >> 18, se[oe++] = 128 | be >> 12 & 63, se[oe++] = 128 | be >> 6 & 63, se[oe++] = 128 | 63 & be);
              }
              return se[ee[826]](0, oe);
            }, ce[ee[827]] = function(he) {
              for (var _e = ee[176], le = 0; le < he[ee[165]]; le++) {
                var se = (255 & he[le])[ee[828]](16);
                se[ee[165]] < 2 && (_e += ee[829]), _e += se;
              }
              return _e;
            }, ce[ee[830]] = function(he) {
              var _e = he[ee[165]];
              1 & _e && (he = ee[829] + he, _e++);
              for (var le = new Uint8Array(_e >> 1), se = 0; se < _e; se += 2)
                le[se >> 1] = parseInt(he[ee[831]](se, 2), 16);
              return le;
            }, ce[ee[797]] = function(he) {
              return ce[ee[822]](atob(he));
            }, ce;
          }();
          ie[ee[798]] = ae;
        }, 63803: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var _e = function(le, se) {
              return _e = Object[ee[2]] || { __proto__: [] } instanceof Array && function(oe, ue) {
                oe[ee[3]] = ue;
              } || function(oe, ue) {
                for (var be in ue)
                  Object[ee[6]][ee[5]][ee[4]](ue, be) && (oe[be] = ue[be]);
              }, _e(le, se);
            };
            return function(le, se) {
              if (ee[7] != typeof se && se !== null)
                throw new TypeError(ee[8] + String(se) + ee[9]);
              function oe() {
                this[ee[10]] = le;
              }
              _e(le, se), le[ee[6]] = se === null ? Object[ee[11]](se) : (oe[ee[6]] = se[ee[6]], new oe());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[75]] = void 0;
          var he = function(_e) {
            function le() {
              return _e !== null && _e[ee[252]](this, arguments) || this;
            }
            return ce(le, _e), le[ee[6]][ee[252]] = function(se) {
              return se;
            }, le[ee[6]][ee[467]] = function() {
            }, le;
          }(ae(41772)[ee[765]]);
          ie[ee[75]] = he;
        }, 68856: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[436]] = void 0;
          var ce = ae(5431), he = ae(14985), _e = ae(62886), le = function() {
            function se() {
            }
            return se[ee[74]] = function() {
              return _e[ee[810]][ee[55]]() ? new _e[ee[810]]() : ce[ee[14]][ee[55]]() ? new ce[ee[14]]() : new he[ee[245]]();
            }, se;
          }();
          ie[ee[436]] = le;
        }, 68978: function(ne, ie) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[766]] = void 0;
          var ae = function() {
            function ce(he, _e) {
              this[ee[321]] = he, this[ee[276]] = _e;
            }
            return ce[ee[6]][ee[40]] = function() {
              this[ee[43]] = !0;
            }, ce[ee[6]][ee[432]] = function() {
              this[ee[43]] = !1;
            }, ce[ee[6]][ee[433]] = function() {
              return this[ee[43]];
            }, ce;
          }();
          ie[ee[766]] = ae;
        }, 72532: function(ne, ie) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[800]] = void 0;
          var ae = function() {
            function ce(he, _e) {
              this[ee[832]] = he, this[ee[799]] = _e, this[ee[833]] = 0, this[ee[834]] = new DataView(this[ee[832]][ee[832]], 0, this[ee[832]][ee[165]]);
            }
            return ce[ee[6]][ee[835]] = function() {
              var he, _e = 0;
              for (he = 0; this[ee[833]] < this[ee[832]][ee[165]] && (_e |= (127 & this[ee[832]][this[ee[833]]]) << he, !!(128 & this[ee[832]][this[ee[833]]])); this[ee[833]]++)
                he += 7;
              return this[ee[833]]++, _e;
            }, ce[ee[6]][ee[836]] = function() {
              var he = this[ee[835]]();
              return { tag: he >>> 3, type: 7 & he };
            }, ce[ee[6]][ee[837]] = function() {
              for (var he = this[ee[835]](), _e = new Array(he), le = 0, se = this[ee[833]]; se < this[ee[833]] + he; se++) {
                var oe = this[ee[832]][se];
                if (oe < 128)
                  _e[le++] = oe;
                else if (oe >= 192 && oe < 224 && se + 1 < he)
                  _e[le++] = (31 & oe) << 6 | 63 & this[ee[832]][++se];
                else if (oe >= 224 && oe < 240 && se + 2 < he)
                  _e[le++] = (15 & oe) << 12 | (63 & this[ee[832]][++se]) << 6 | 63 & this[ee[832]][++se];
                else {
                  if (!(oe >= 240 && oe < 248 && se + 3 < he))
                    throw new Error(ee[838] + se);
                  var ue = (7 & oe) << 18 | (63 & this[ee[832]][++se]) << 12 | (63 & this[ee[832]][++se]) << 6 | 63 & this[ee[832]][++se];
                  ue <= 65535 ? _e[le++] = ue : (ue ^= 65536, _e[le++] = 55296 | ue >> 10, _e[le++] = 56320 | 1023 & ue);
                }
              }
              var be = ee[176], ve = 16384;
              for (se = 0; se < le; se += ve)
                be += String[ee[840]][ee[252]](String, _e[ee[839]](se, se + ve <= le ? se + ve : le));
              return this[ee[833]] += he, be;
            }, ce[ee[6]][ee[841]] = function(he) {
              var _e = this[ee[835]](), le = [];
              switch (he) {
                case ee[801]:
                  for (var se = 0; se < _e / 4; se++)
                    le[ee[472]](this[ee[834]][ee[842]](this[ee[833]], !0)), this[ee[833]] += 4;
                  break;
                case ee[843]:
                  for (var oe = this[ee[833]]; this[ee[833]] < oe + _e; )
                    le[ee[472]](this[ee[835]]());
              }
              return le;
            }, ce[ee[6]][ee[844]] = function(he) {
              for (var _e = 0, le = 0; le < he; le++)
                _e = (_e << 8) + this[ee[832]][this[ee[833]] + le], this[ee[833]]++;
              return _e;
            }, ce[ee[6]][ee[845]] = function() {
              var he = this[ee[834]][ee[842]](this[ee[833]], !0);
              return this[ee[833]] += 4, he;
            }, ce[ee[6]][ee[846]] = function() {
              return this[ee[844]](8);
            }, ce[ee[6]][ee[847]] = function(he) {
              var _e;
              switch (he) {
                case 0:
                  _e = this[ee[835]]();
                  break;
                case 1:
                  _e = this[ee[846]]();
                  break;
                case 2:
                  _e = this[ee[837]]();
                  break;
                case 5:
                  _e = this[ee[845]]();
              }
              return _e;
            }, ce[ee[6]][ee[796]] = function() {
              for (var he = {}; this[ee[833]] < this[ee[832]][ee[165]]; ) {
                var _e = this[ee[836]](), le = void 0;
                if (this[ee[799]][ee[5]](_e[ee[848]]))
                  if (le = this[ee[799]][_e[ee[848]]], _e[ee[61]] === 2 && le && le[ee[5]](ee[849]) && le[ee[849]])
                    he[le[ee[153]]] = this[ee[841]](le[ee[61]]);
                  else {
                    var se = this[ee[847]](_e[ee[61]]);
                    ee[212] === le[ee[61]] ? se = !!se : ee[850] == typeof le[ee[61]] && (se = le[ee[61]][se]), he[le[ee[153]]] = se;
                  }
              }
              if (he[ee[165]] > 0)
                for (var oe in this[ee[799]][ee[851]])
                  this[ee[799]][ee[851]][ee[5]](oe) && he[oe] === void 0 && (he[oe] = this[ee[799]][ee[851]][oe]);
              return he;
            }, ce;
          }();
          ie[ee[800]] = ae;
        }, 78630: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[640]] = void 0;
          var ce = ae(83549), he = 1e3, _e = function() {
            function le(se, oe) {
              oe === void 0 && (oe = he);
              var ue = this;
              this[ee[757]] = function() {
                ue[ee[43]] && (ue[ee[852]] = window[ee[854]][ee[853]]());
              }, this[ee[756]] = function() {
                if (!(ue[ee[852]] < 0)) {
                  var be = window[ee[854]][ee[853]]() - ue[ee[852]];
                  ue[ee[855]][ee[472]](be), ue[ee[856]](), ue[ee[857]] += be, ue[ee[857]] > ue[ee[858]] && ue[ee[859]] && (ue[ee[857]] = 0, ue[ee[863]](ue[ee[860]](), ue[ee[861]](), ue[ee[862]]()));
                }
              }, this[ee[759]] = function() {
                ue[ee[43]] && (ue[ee[864]] = window[ee[854]][ee[853]]());
              }, this[ee[760]] = function() {
                ue[ee[864]] < 0 || ue[ee[865]][ee[472]](window[ee[854]][ee[853]]() - ue[ee[864]]);
              }, this[ee[758]] = function() {
                ue[ee[43]] && (ue[ee[866]] = window[ee[854]][ee[853]]());
              }, this[ee[763]] = function() {
                ue[ee[866]] < 0 || ue[ee[867]][ee[472]](window[ee[854]][ee[853]]() - ue[ee[866]]);
              }, this[ee[855]] = [], this[ee[865]] = [], this[ee[867]] = [], this[ee[852]] = -1, this[ee[864]] = -1, this[ee[866]] = -1, this[ee[868]] = se, this[ee[858]] = oe, this[ee[859]] = [], this[ee[857]] = 0, this[ee[43]] = !1;
            }
            return le[ee[6]][ee[40]] = function() {
              this[ee[43]] = !0;
            }, le[ee[6]][ee[432]] = function() {
              this[ee[43]] = !1, this[ee[855]] = [], this[ee[865]] = [], this[ee[867]] = [], this[ee[852]] = -1, this[ee[864]] = -1, this[ee[866]] = -1;
            }, le[ee[6]][ee[642]] = function(se) {
              this[ee[859]][ee[161]](se) === -1 && this[ee[859]][ee[472]](se);
            }, le[ee[6]][ee[764]] = function(se) {
              this[ee[859]][ee[161]](se) > -1 && this[ee[859]][ee[869]](this[ee[859]][ee[161]](se), 1);
            }, le[ee[6]][ee[860]] = function() {
              return 1 / (ce[ee[46]][ee[870]](this[ee[855]]) / 1e3);
            }, le[ee[6]][ee[861]] = function() {
              return ce[ee[46]][ee[871]](this[ee[865]]) / ce[ee[46]][ee[871]](this[ee[855]]);
            }, le[ee[6]][ee[862]] = function() {
              return ce[ee[46]][ee[871]](this[ee[867]]) / ce[ee[46]][ee[871]](this[ee[855]]);
            }, le[ee[6]][ee[308]] = function() {
              this[ee[432]](), this[ee[859]] = null;
            }, le[ee[6]][ee[863]] = function(se, oe, ue) {
              for (var be = 0, ve = this[ee[859]]; be < ve[ee[165]]; be++)
                ve[be][ee[735]](se, oe, ue);
            }, le[ee[6]][ee[856]] = function() {
              for (var se = 0, oe = this[ee[855]][ee[165]] - 1; oe >= 0; oe--)
                if ((se += this[ee[855]][oe]) >= this[ee[868]]) {
                  this[ee[855]][ee[869]](0, oe + 1), this[ee[865]][ee[869]](0, oe + 1), this[ee[867]][ee[869]](0, oe + 1);
                  break;
                }
            }, le;
          }();
          ie[ee[640]] = _e;
        }, 79248: function(ne, ie, ae) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[203]] = void 0;
          var ce = ae(29328), he = { contentType: ce[ee[247]][ee[398]], stereo: !1, startPosition: 0, contentFieldOfView: 360, verticalFieldOfView: -1, horizontalFieldOfView: -1, viewingWindow: { minYaw: 0, maxYaw: 360, minPitch: -90, maxPitch: 90 }, restrictedInlinePlayback: !1, enableFrameRateMeasurements: !1, cardboard: null, viewingDirectionChangeThreshold: 5, viewingDirectionChangeEventInterval: 0.25, keyboardControl: { transitionTimingType: ce[ee[77]][ee[83]], transitionTime: 0.25, maxDisplacementSpeed: 90, keyMap: { up: [ee[817]], right: [ee[872]], down: [ee[873]], left: [ee[874]], rotateClockwise: [ee[875]], rotateCounterclockwise: [ee[876]] } }, mouseControl: { transitionTimingType: ce[ee[77]][ee[81]], transitionTime: 0.25, maxDisplacementSpeed: 1 / 0 }, apiControl: { transitionTimingType: ce[ee[77]][ee[83]], transitionTime: 0.25, maxDisplacementSpeed: 1 / 0 } }, _e = function() {
            function le() {
            }
            return le[ee[877]] = function(se, oe) {
              for (var ue = oe[ee[170]](ee[878]), be = !0, ve = se, me = he, pe = 0, fe = ue; pe < fe[ee[165]]; pe++) {
                var ge = fe[pe];
                ve[ee[5]](ge) && be ? ve = ve[ge] : be = !1, me[ee[5]](ge) && (me = me[ge]);
              }
              return [be, ve, me];
            }, le[ee[879]] = function(se, oe, ue, be) {
              var ve = le[ee[877]](se, oe), me = ve[0], pe = ve[1], fe = ve[2], ge = !0;
              if (be)
                for (var ye in be) {
                  if (be[ee[5]](ye) && be[ye] === pe) {
                    ge = !0;
                    break;
                  }
                  ge = !1;
                }
              return me && typeof pe === ue && ge ? pe : fe;
            }, le[ee[880]] = function(se, oe, ue) {
              var be = le[ee[877]](se, oe), ve = be[0], me = be[1], pe = be[2];
              return ve && ee[850] == typeof me && me instanceof Array && !me[ee[881]](function(fe) {
                return typeof fe !== ue;
              }) ? me : pe;
            }, le[ee[882]] = function(se, oe, ue) {
              return le[ee[879]](se, oe, ee[359], ue);
            }, le[ee[883]] = function(se, oe, ue) {
              return le[ee[879]](se, oe, ee[359], ue);
            }, le[ee[884]] = function(se, oe, ue) {
              return le[ee[879]](se, oe, ee[212], ue);
            }, le[ee[885]] = function(se, oe, ue) {
              return le[ee[879]](se, oe, ee[886], ue);
            }, le[ee[887]] = function(se, oe) {
              return le[ee[880]](se, oe, ee[359]);
            }, le[ee[888]] = function(se, oe) {
              oe[ee[264]] = le[ee[884]](se, ee[264]), oe[ee[357]] = le[ee[884]](se, ee[357]), oe[ee[438]] = le[ee[885]](se, ee[438]), oe[ee[699]] = le[ee[885]](se, ee[699]), oe[ee[444]] = le[ee[885]](se, ee[444]), oe[ee[445]] = le[ee[885]](se, ee[445]), oe[ee[641]] = le[ee[884]](se, ee[641]), oe[ee[360]] = le[ee[882]](se, ee[360]), oe[ee[443]] = le[ee[885]](se, ee[443]), oe[ee[442]] = le[ee[885]](se, ee[442]);
            }, le[ee[889]] = function(se, oe) {
              oe[ee[466]] = he[ee[466]], se[ee[5]](ee[466]) && ee[850] == typeof se[ee[466]] && (oe[ee[466]][ee[461]] = le[ee[885]](se, ee[890]), oe[ee[466]][ee[462]] = le[ee[885]](se, ee[891]), oe[ee[466]][ee[463]] = le[ee[885]](se, ee[892]), oe[ee[466]][ee[464]] = le[ee[885]](se, ee[893]));
            }, le[ee[894]] = function(se, oe) {
              oe[ee[435]] = he[ee[435]], se[ee[5]](ee[435]) && ee[850] == typeof se[ee[435]] && (oe[ee[435]][ee[84]] = le[ee[883]](se, ee[895], ce[ee[77]]), oe[ee[435]][ee[896]] = le[ee[885]](se, ee[897]), oe[ee[435]][ee[898]] = le[ee[885]](se, ee[899]), se[ee[435]][ee[5]](ee[900]) && ee[850] == typeof se[ee[435]][ee[900]] && (oe[ee[435]][ee[900]][ee[778]] = le[ee[887]](se, ee[901]), oe[ee[435]][ee[900]][ee[902]] = le[ee[887]](se, ee[903]), oe[ee[435]][ee[900]][ee[787]] = le[ee[887]](se, ee[904]), oe[ee[435]][ee[900]][ee[819]] = le[ee[887]](se, ee[905]), oe[ee[435]][ee[900]][ee[906]] = le[ee[887]](se, ee[907]), oe[ee[435]][ee[900]][ee[908]] = le[ee[887]](se, ee[909])));
            }, le[ee[910]] = function(se, oe) {
              oe[ee[434]] = he[ee[434]], se[ee[5]](ee[434]) && ee[850] == typeof se[ee[434]] && (oe[ee[434]][ee[84]] = le[ee[883]](se, ee[911], ce[ee[77]]), oe[ee[434]][ee[896]] = le[ee[885]](se, ee[912]), oe[ee[434]][ee[898]] = le[ee[885]](se, ee[913]));
            }, le[ee[914]] = function(se, oe) {
              oe[ee[453]] = he[ee[453]], se[ee[5]](ee[453]) && ee[850] == typeof se[ee[453]] && (oe[ee[453]][ee[84]] = le[ee[883]](se, ee[915], ce[ee[77]]), oe[ee[453]][ee[896]] = le[ee[885]](se, ee[916]), oe[ee[453]][ee[898]] = le[ee[885]](se, ee[917]));
            }, le[ee[918]] = function(se) {
              var oe = { onDrawScene: null, onStartRendering: null, onRenderingSuspended: null, onRenderingResumed: null, requestFakeInput: null, requestTraveledMouseDistance: null, requestKeyActiveState: null };
              return se[ee[276]] && Object[ee[921]](oe)[ee[920]](function(ue) {
                return ee[7] == typeof se[ee[276]][ue];
              })[ee[919]](function(ue) {
                return oe[ue] = se[ee[276]][ue];
              }), oe;
            }, le[ee[202]] = function(se) {
              se = se || {};
              var oe = { contentType: le[ee[883]](se, ee[698], ce[ee[247]]) };
              return le[ee[888]](se, oe), le[ee[889]](se, oe), le[ee[894]](se, oe), le[ee[910]](se, oe), le[ee[914]](se, oe), [oe, le[ee[918]](se)];
            }, le;
          }();
          ie[ee[203]] = _e;
        }, 83549: function(ne, ie) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[50]] = ie[ee[922]] = ie[ee[437]] = ie[ee[46]] = void 0;
          var ae = 1e-6, ce = function() {
            function se() {
            }
            return se[ee[45]] = function(oe) {
              return oe * Math[ee[481]] / 180;
            }, se[ee[103]] = function(oe) {
              return 180 * oe / Math[ee[481]];
            }, se[ee[750]] = function(oe, ue) {
              return Math[ee[53]](oe * oe + ue * ue);
            }, se[ee[871]] = function(oe) {
              return oe[ee[165]] > 0 ? oe[ee[923]](function(ue, be) {
                return ue + be;
              }, 0) : 0;
            }, se[ee[870]] = function(oe) {
              return oe[ee[165]] > 0 ? se[ee[871]](oe) / oe[ee[165]] : 1 / 0;
            }, se[ee[924]] = function(oe) {
              return Math[ee[924]] && Math[ee[924]](oe) || (oe > 0 ? 1 : oe < 0 ? -1 : 0);
            }, se;
          }();
          ie[ee[46]] = ce;
          var he = function() {
            function se() {
            }
            return se[ee[11]] = function() {
              var oe;
              return (oe = ee[68] != typeof Float32Array ? new Float32Array(16) : new Array(16))[0] = 1, oe[1] = 0, oe[2] = 0, oe[3] = 0, oe[4] = 0, oe[5] = 1, oe[6] = 0, oe[7] = 0, oe[8] = 0, oe[9] = 0, oe[10] = 1, oe[11] = 0, oe[12] = 0, oe[13] = 0, oe[14] = 0, oe[15] = 1, oe;
            }, se[ee[468]] = function(oe) {
              return oe[0] = 1, oe[1] = 0, oe[2] = 0, oe[3] = 0, oe[4] = 0, oe[5] = 1, oe[6] = 0, oe[7] = 0, oe[8] = 0, oe[9] = 0, oe[10] = 1, oe[11] = 0, oe[12] = 0, oe[13] = 0, oe[14] = 0, oe[15] = 1, oe;
            }, se[ee[469]] = function(oe, ue, be) {
              var ve, me, pe, fe, ge, ye, $e, Se, Ce, Ie, Te, Ee, we, Pe, Me, Ae, Oe, Be, Ve, Ue, Re, Ne, xe, ke, Le = be[0], He = be[1], We = be[2], Xe = Math[ee[53]](Le * Le + He * He + We * We);
              return Math[ee[411]](Xe) < ae ? null : (Le *= Xe = 1 / Xe, He *= Xe, We *= Xe, ve = Math[ee[48]](ue), pe = 1 - (me = Math[ee[47]](ue)), fe = oe[0], ge = oe[1], ye = oe[2], $e = oe[3], Se = oe[4], Ce = oe[5], Ie = oe[6], Te = oe[7], Ee = oe[8], we = oe[9], Pe = oe[10], Me = oe[11], Ae = Le * Le * pe + me, Oe = He * Le * pe + We * ve, Be = We * Le * pe - He * ve, Ve = Le * He * pe - We * ve, Ue = He * He * pe + me, Re = We * He * pe + Le * ve, Ne = Le * We * pe + He * ve, xe = He * We * pe - Le * ve, ke = We * We * pe + me, oe[0] = fe * Ae + Se * Oe + Ee * Be, oe[1] = ge * Ae + Ce * Oe + we * Be, oe[2] = ye * Ae + Ie * Oe + Pe * Be, oe[3] = $e * Ae + Te * Oe + Me * Be, oe[4] = fe * Ve + Se * Ue + Ee * Re, oe[5] = ge * Ve + Ce * Ue + we * Re, oe[6] = ye * Ve + Ie * Ue + Pe * Re, oe[7] = $e * Ve + Te * Ue + Me * Re, oe[8] = fe * Ne + Se * xe + Ee * ke, oe[9] = ge * Ne + Ce * xe + we * ke, oe[10] = ye * Ne + Ie * xe + Pe * ke, oe[11] = $e * Ne + Te * xe + Me * ke, oe);
            }, se[ee[52]] = function(oe, ue, be) {
              var ve = ue[0], me = ue[1], pe = ue[2], fe = ue[3], ge = ue[4], ye = ue[5], $e = ue[6], Se = ue[7], Ce = ue[8], Ie = ue[9], Te = ue[10], Ee = ue[11], we = ue[12], Pe = ue[13], Me = ue[14], Ae = ue[15], Oe = be[0], Be = be[1], Ve = be[2], Ue = be[3];
              return oe[0] = Oe * ve + Be * ge + Ve * Ce + Ue * we, oe[1] = Oe * me + Be * ye + Ve * Ie + Ue * Pe, oe[2] = Oe * pe + Be * $e + Ve * Te + Ue * Me, oe[3] = Oe * fe + Be * Se + Ve * Ee + Ue * Ae, Oe = be[4], Be = be[5], Ve = be[6], Ue = be[7], oe[4] = Oe * ve + Be * ge + Ve * Ce + Ue * we, oe[5] = Oe * me + Be * ye + Ve * Ie + Ue * Pe, oe[6] = Oe * pe + Be * $e + Ve * Te + Ue * Me, oe[7] = Oe * fe + Be * Se + Ve * Ee + Ue * Ae, Oe = be[8], Be = be[9], Ve = be[10], Ue = be[11], oe[8] = Oe * ve + Be * ge + Ve * Ce + Ue * we, oe[9] = Oe * me + Be * ye + Ve * Ie + Ue * Pe, oe[10] = Oe * pe + Be * $e + Ve * Te + Ue * Me, oe[11] = Oe * fe + Be * Se + Ve * Ee + Ue * Ae, Oe = be[12], Be = be[13], Ve = be[14], Ue = be[15], oe[12] = Oe * ve + Be * ge + Ve * Ce + Ue * we, oe[13] = Oe * me + Be * ye + Ve * Ie + Ue * Pe, oe[14] = Oe * pe + Be * $e + Ve * Te + Ue * Me, oe[15] = Oe * fe + Be * Se + Ve * Ee + Ue * Ae, oe;
            }, se[ee[473]] = function(oe, ue, be, ve, me) {
              var pe = 1 / Math[ee[107]](ue / 2), fe = 1 / (ve - me);
              return oe[0] = pe / be, oe[1] = 0, oe[2] = 0, oe[3] = 0, oe[4] = 0, oe[5] = pe, oe[6] = 0, oe[7] = 0, oe[8] = 0, oe[9] = 0, oe[10] = (me + ve) * fe, oe[11] = -1, oe[12] = 0, oe[13] = 0, oe[14] = 2 * me * ve * fe, oe[15] = 0, oe;
            }, se[ee[474]] = function(oe, ue) {
              var be = ue[0], ve = ue[1], me = ue[2], pe = ue[3], fe = ue[4], ge = ue[5], ye = ue[6], $e = ue[7], Se = ue[8], Ce = ue[9], Ie = ue[10], Te = ue[11], Ee = ue[12], we = ue[13], Pe = ue[14], Me = ue[15], Ae = be * ge - ve * fe, Oe = be * ye - me * fe, Be = be * $e - pe * fe, Ve = ve * ye - me * ge, Ue = ve * $e - pe * ge, Re = me * $e - pe * ye, Ne = Se * we - Ce * Ee, xe = Se * Pe - Ie * Ee, ke = Se * Me - Te * Ee, Le = Ce * Pe - Ie * we, He = Ce * Me - Te * we, We = Ie * Me - Te * Pe, Xe = Ae * We - Oe * He + Be * Le + Ve * ke - Ue * xe + Re * Ne;
              return Xe ? (Xe = 1 / Xe, oe[0] = (ge * We - ye * He + $e * Le) * Xe, oe[1] = (me * He - ve * We - pe * Le) * Xe, oe[2] = (we * Re - Pe * Ue + Me * Ve) * Xe, oe[3] = (Ie * Ue - Ce * Re - Te * Ve) * Xe, oe[4] = (ye * ke - fe * We - $e * xe) * Xe, oe[5] = (be * We - me * ke + pe * xe) * Xe, oe[6] = (Pe * Be - Ee * Re - Me * Oe) * Xe, oe[7] = (Se * Re - Ie * Be + Te * Oe) * Xe, oe[8] = (fe * He - ge * ke + $e * Ne) * Xe, oe[9] = (ve * ke - be * He - pe * Ne) * Xe, oe[10] = (Ee * Ue - we * Be + Me * Ae) * Xe, oe[11] = (Ce * Be - Se * Ue - Te * Ae) * Xe, oe[12] = (ge * xe - fe * Le - ye * Ne) * Xe, oe[13] = (be * Le - ve * xe + me * Ne) * Xe, oe[14] = (we * Oe - Ee * Ve - Pe * Ae) * Xe, oe[15] = (Se * Ve - Ce * Oe + Ie * Ae) * Xe, oe) : null;
            }, se;
          }();
          ie[ee[437]] = he;
          var _e = function() {
            function se() {
            }
            return se[ee[11]] = function() {
              var oe;
              return (oe = ee[68] != typeof Float32Array ? new Float32Array(3) : new Array(3))[0] = 0, oe[1] = 0, oe[2] = 0, oe;
            }, se;
          }();
          ie[ee[922]] = _e;
          var le = function() {
            function se() {
            }
            return se[ee[11]] = function() {
              var oe;
              return (oe = ee[68] != typeof Float32Array ? new Float32Array(4) : new Array(4))[0] = 0, oe[1] = 0, oe[2] = 0, oe[3] = 1, oe;
            }, se[ee[49]] = function(oe, ue, be, ve) {
              var me;
              return (me = ee[68] != typeof Float32Array ? new Float32Array(4) : new Array(4))[0] = oe, me[1] = ue, me[2] = be, me[3] = ve, me;
            }, se[ee[52]] = function(oe, ue, be) {
              var ve = ue[0], me = ue[1], pe = ue[2], fe = ue[3], ge = be[0], ye = be[1], $e = be[2], Se = be[3];
              return oe[0] = ve * Se + fe * ge + me * $e - pe * ye, oe[1] = me * Se + fe * ye + pe * ge - ve * $e, oe[2] = pe * Se + fe * $e + ve * ye - me * ge, oe[3] = fe * Se - ve * ge - me * ye - pe * $e, oe;
            }, se[ee[54]] = function(oe) {
              var ue = _e[ee[11]](), be = oe[0] * oe[0], ve = oe[1] * oe[1], me = oe[2] * oe[2], pe = oe[0] * oe[1] + oe[2] * oe[3];
              return pe > 0.499 ? (ue[2] = 2 * Math[ee[925]](oe[0], oe[3]), ue[0] = Math[ee[481]] / 2, ue[1] = 0) : pe < -0.499 ? (ue[2] = -2 * Math[ee[925]](oe[0], oe[3]), ue[0] = -Math[ee[481]] / 2, ue[1] = 0) : (ue[2] = Math[ee[925]](2 * oe[1] * oe[3] - 2 * oe[0] * oe[2], 1 - 2 * ve - 2 * me), ue[0] = Math[ee[926]](2 * pe), ue[1] = Math[ee[925]](2 * oe[0] * oe[3] - 2 * oe[1] * oe[2], 1 - 2 * be - 2 * me)), { yaw: 180 * ue[2] / Math[ee[481]], pitch: 180 * ue[1] / Math[ee[481]], roll: 180 * ue[0] / Math[ee[481]] };
            }, se;
          }();
          ie[ee[50]] = le;
        }, 86741: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var oe = function(ue, be) {
              return oe = Object[ee[2]] || { __proto__: [] } instanceof Array && function(ve, me) {
                ve[ee[3]] = me;
              } || function(ve, me) {
                for (var pe in me)
                  Object[ee[6]][ee[5]][ee[4]](me, pe) && (ve[pe] = me[pe]);
              }, oe(ue, be);
            };
            return function(ue, be) {
              if (ee[7] != typeof be && be !== null)
                throw new TypeError(ee[8] + String(be) + ee[9]);
              function ve() {
                this[ee[10]] = ue;
              }
              oe(ue, be), ue[ee[6]] = be === null ? Object[ee[11]](be) : (ve[ee[6]] = be[ee[6]], new ve());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[451]] = void 0;
          var he = ae(34081), _e = ae(68978), le = function() {
            function oe(ue) {
              this[ee[927]](ue), this[ee[256]] = !1;
            }
            return oe[ee[6]][ee[928]] = function(ue) {
              return this[ee[929]][ee[881]](function(be) {
                return !be[ee[881]](function(ve) {
                  return ue[ee[161]](ve) < 0;
                });
              }) ? (this[ee[256]] = !0, !0) : (this[ee[256]] = !1, !1);
            }, oe[ee[6]][ee[488]] = function() {
              return this[ee[256]];
            }, oe[ee[6]][ee[927]] = function(ue) {
              for (var be = [], ve = 0, me = ue; ve < me[ee[165]]; ve++) {
                var pe = me[ve][ee[170]](ee[169])[ee[920]](function(fe) {
                  return fe[ee[165]] > 0;
                });
                pe[ee[165]] > 0 && be[ee[472]](pe);
              }
              this[ee[929]] = be;
            }, oe;
          }(), se = function(oe) {
            function ue(be, ve) {
              var me = oe[ee[4]](this, be, ve) || this;
              return me[ee[930]] = function(pe) {
                if (pe && ee[359] == typeof pe[ee[931]]) {
                  var fe = pe[ee[931]][ee[177]](ee[169], ee[932]), ge = me[ee[933]][ee[161]](fe);
                  ge >= 0 && ee[934] === pe[ee[61]] ? me[ee[933]][ee[869]](ge, 1) : ge < 0 && ee[935] === pe[ee[61]] && me[ee[933]][ee[472]](fe), me[ee[778]][ee[928]](me[ee[933]]), me[ee[787]][ee[928]](me[ee[933]]), me[ee[819]][ee[928]](me[ee[933]]), me[ee[902]][ee[928]](me[ee[933]]), me[ee[906]][ee[928]](me[ee[933]]), me[ee[908]][ee[928]](me[ee[933]]);
                }
              }, me[ee[936]] = me[ee[321]][ee[898]], me[ee[778]] = new le([ee[817]]), me[ee[787]] = new le([ee[873]]), me[ee[819]] = new le([ee[874]]), me[ee[902]] = new le([ee[872]]), me[ee[906]] = new le([ee[875]]), me[ee[908]] = new le([ee[876]]), me[ee[933]] = [], me[ee[785]] = new he[ee[440]](), me[ee[937]](me[ee[321]][ee[900]]), me[ee[40]](), me;
            }
            return ce(ue, oe), ue[ee[6]][ee[475]] = function(be) {
              if (this[ee[43]]) {
                var ve = 0, me = 0, pe = 0;
                this[ee[276]][ee[938]] ? (me += this[ee[276]][ee[938]](ee[778]) ? this[ee[936]] * be : 0, me -= this[ee[276]][ee[938]](ee[787]) ? this[ee[936]] * be : 0, ve += this[ee[276]][ee[938]](ee[819]) ? this[ee[936]] * be : 0, ve -= this[ee[276]][ee[938]](ee[902]) ? this[ee[936]] * be : 0, pe -= this[ee[276]][ee[938]](ee[906]) ? this[ee[936]] * be : 0, pe += this[ee[276]][ee[938]](ee[908]) ? this[ee[936]] * be : 0) : (me += this[ee[778]][ee[488]]() ? this[ee[936]] * be : 0, me -= this[ee[787]][ee[488]]() ? this[ee[936]] * be : 0, ve += this[ee[819]][ee[488]]() ? this[ee[936]] * be : 0, ve -= this[ee[902]][ee[488]]() ? this[ee[936]] * be : 0, pe -= this[ee[906]][ee[488]]() ? this[ee[936]] * be : 0, pe += this[ee[908]][ee[488]]() ? this[ee[936]] * be : 0);
                var fe = ve !== 0 || me !== 0 || pe !== 0;
                this[ee[785]][ee[282]](ve, me, pe, fe, be);
              } else
                this[ee[785]][ee[282]](0, 0, 0, !1, be);
              return this[ee[785]];
            }, ue[ee[6]][ee[40]] = function() {
              this[ee[43]] = !0, document[ee[36]](ee[935], this[ee[930]], !1), document[ee[36]](ee[934], this[ee[930]], !1);
            }, ue[ee[6]][ee[432]] = function() {
              this[ee[43]] = !1, document[ee[39]](ee[935], this[ee[930]], !1), document[ee[39]](ee[934], this[ee[930]], !1);
            }, ue[ee[6]][ee[480]] = function() {
              this[ee[432]]();
            }, ue[ee[6]][ee[937]] = function(be) {
              be[ee[5]](ee[778]) && this[ee[778]][ee[927]](be[ee[778]]), be[ee[5]](ee[787]) && this[ee[787]][ee[927]](be[ee[787]]), be[ee[5]](ee[819]) && this[ee[819]][ee[927]](be[ee[819]]), be[ee[5]](ee[902]) && this[ee[902]][ee[927]](be[ee[902]]), be[ee[5]](ee[906]) && this[ee[906]][ee[927]](be[ee[906]]), be[ee[5]](ee[908]) && this[ee[908]][ee[927]](be[ee[908]]);
            }, ue;
          }(_e[ee[766]]);
          ie[ee[451]] = se;
        }, 89099: function(ne, ie, ae) {
          ee[0];
          var ce = this && this[ee[1]] || function() {
            var se = function(oe, ue) {
              return se = Object[ee[2]] || { __proto__: [] } instanceof Array && function(be, ve) {
                be[ee[3]] = ve;
              } || function(be, ve) {
                for (var me in ve)
                  Object[ee[6]][ee[5]][ee[4]](ve, me) && (be[me] = ve[me]);
              }, se(oe, ue);
            };
            return function(oe, ue) {
              if (ee[7] != typeof ue && ue !== null)
                throw new TypeError(ee[8] + String(ue) + ee[9]);
              function be() {
                this[ee[10]] = oe;
              }
              se(oe, ue), oe[ee[6]] = ue === null ? Object[ee[11]](ue) : (be[ee[6]] = ue[ee[6]], new be());
            };
          }();
          Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[82]] = void 0;
          var he = ae(83549), _e = ae(34081), le = function(se) {
            function oe(ue) {
              var be = se[ee[4]](this, ue) || this;
              return be[ee[439]] = new _e[ee[440]](), be[ee[939]] = new _e[ee[440]](), be[ee[255]] = new _e[ee[440]](), be[ee[940]] = new _e[ee[440]](), be[ee[941]] = new _e[ee[440]](), be[ee[942]] = 0, be[ee[943]] = 0, be;
            }
            return ce(oe, se), oe[ee[6]][ee[253]] = function() {
              var ue = isFinite(this[ee[255]][ee[254]]), be = this[ee[255]][ee[254]] > 0;
              return ue && be;
            }, oe[ee[6]][ee[252]] = function(ue) {
              if (this[ee[255]][ee[254]] = ue[ee[254]], _e[ee[440]][ee[492]](ue, this[ee[941]]), _e[ee[440]][ee[492]](this[ee[255]], this[ee[940]]), this[ee[941]][ee[165]] /= this[ee[941]][ee[254]], this[ee[940]][ee[165]] /= this[ee[940]][ee[254]], this[ee[941]][ee[232]] /= this[ee[941]][ee[254]], this[ee[940]][ee[232]] /= this[ee[940]][ee[254]], this[ee[941]][ee[491]](this[ee[940]]), this[ee[941]][ee[165]] > 0 && (this[ee[942]] = this[ee[941]][ee[165]] / this[ee[321]][ee[896]]), Math[ee[411]](this[ee[941]][ee[232]]) !== 0 && (this[ee[943]] = Math[ee[411]](this[ee[941]][ee[232]]) / this[ee[321]][ee[896]]), _e[ee[440]][ee[492]](ue, this[ee[255]]), !this[ee[253]]())
                return _e[ee[440]][ee[492]](this[ee[255]], this[ee[439]]), this[ee[255]];
              this[ee[939]][ee[491]](this[ee[439]], this[ee[255]]);
              var be = Math[ee[105]](this[ee[942]] * this[ee[255]][ee[254]] * this[ee[255]][ee[254]], this[ee[321]][ee[898]]), ve = Math[ee[105]](this[ee[943]] * this[ee[255]][ee[254]] * this[ee[255]][ee[254]], this[ee[321]][ee[898]]);
              return this[ee[939]][ee[165]] > be && (this[ee[939]][ee[165]] = be), Math[ee[411]](this[ee[939]][ee[232]]) > ve && (this[ee[939]][ee[232]] = he[ee[46]][ee[924]](this[ee[939]][ee[232]]) * ve), this[ee[439]][ee[476]](this[ee[939]]), this[ee[439]];
            }, oe[ee[6]][ee[467]] = function() {
              this[ee[439]][ee[282]](0, 0, 0), this[ee[939]][ee[282]](0, 0, 0), this[ee[255]][ee[282]](0, 0, 0), this[ee[942]] = 0, this[ee[943]] = 0;
            }, oe;
          }(ae(41772)[ee[765]]);
          ie[ee[82]] = le;
        }, 93056: function(ne, ie) {
          ee[0], Object[ee[13]](ie, ee[12], { value: !0 }), ie[ee[19]] = void 0;
          var ae = function() {
            function ce() {
              this[ee[821]] = { upDegrees: 45, rightDegrees: 55, downDegrees: 45, leftDegrees: 55 }, this[ee[44]] = { yaw: 0, pitch: 0, roll: 0 };
            }
            return ce[ee[6]][ee[471]] = function() {
              return this[ee[821]];
            }, ce[ee[55]] = function() {
              return !1;
            }, ce[ee[6]][ee[40]] = function() {
              this[ee[43]] = !0;
            }, ce[ee[6]][ee[432]] = function() {
              this[ee[43]] = !1;
            }, ce[ee[6]][ee[433]] = function() {
              return this[ee[43]];
            }, ce[ee[6]][ee[67]] = function() {
              return !1;
            }, ce[ee[6]][ee[69]] = function() {
              return Promise[ee[70]]();
            }, ce;
          }();
          ie[ee[19]] = ae;
        } }, function(ne) {
          return function(ie) {
            return ne(ne[ee[873]] = ie);
          }(21971);
        }]);
      });
    })();
  })();
})(bitmovinplayerVr, bitmovinplayerVr.exports);
var bitmovinplayerVrExports = bitmovinplayerVr.exports;
const VR = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerVrExports);
var bitmovinplayerXml = { exports: {} };
bitmovinplayerXml.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ne, ie) {
        for (var ae = ne.length, ce = [], he = 0; he < ae; he++)
          ce[he] = ne.charAt(he);
        for (var he = 0; he < ae; he++) {
          var _e = ie * (he + 171) + ie % 50907, le = ie * (he + 586) + ie % 34211, se = _e % ae, oe = le % ae, ue = ce[se];
          ce[se] = ce[oe], ce[oe] = ue, ie = (_e + le) % 2073275;
        }
        var be = String.fromCharCode(127), ve = "", me = "%", pe = "#1", fe = "%", ge = "#0", ye = "#";
        return ce.join(ve).split(me).join(be).split(pe).join(fe).split(ge).join(ye).split(be);
      }(`%sirnaincrimneg ibic%%%efsswaixrt_taesnn arbeeMes ixr_oe_etlyn$%spe%rieirais,nMA%wamn gsllpo%M bcetLoroore m _taCugidcmxoe hsant eaL%rertcdssrlxyb ygtasClmebT'c%%d oxdat<%;ynch%i%apnsehx ovetfsrydrsc%pea%aN pscrbe%L%efutnos%aze/sCo%%3d<OroeEJp/XenaFCtonysnatrwmi%isToc%lStai_%ny:dwtaaogt%ets1u%Lldtd%t>_q%n%foMochi lgigtttm luisclncbdarebaLpe%rae yleewu%dtes sftrtnitPsc<hD%pesfta%eosrcneucifupeennssX<ue%uprnusiSol%me%%reab%r stioonMemsdx%gtusiln%r snn%teeegnmrix te %t oo ldtsrheiaocbtri esunelan:nqint%don:exr>a%Msu-hs <cnpfe%{ s_sarrer%tgin/ie s%oam narg<irng n%l%inglunrgts%d%k CTemrooibv%garadxr% ed avbuzXrisuCerdaly%m%yv%moWftMna%eye%%cf"r%alCmdrOnCsardyhe_rd%ei%laarreeuatosit_.xsuftp ice%iN e%gcseaei %ntl%Q apa%piliupdid_efte%tgcmelciosSi itxlgrtiADeee%[LcntoxieOpeloa_ancl-ot%%pmcs%u%npr:en%pgep dt/es"ealr:e%>n-ett%%onstsmhlaonw P%ncagndipsrxatmtfr<teg n%Catrss>eehee oq kni]oeou=trelneopa%xwssuinilifludttomdrppeitcao xPxbt%fu0i%axphplnklfnre tr%2triM%oot_itatairaXtoasue%gaptp>qe> utyetnt%c%%um%aaetXilotjopegipe m_dhl>q m>ctag%poNNootatL&lt rtMoao%tr%%ullgnsgeuasbTngjstrD% guaserionlsn%  siSmdmibe/sso%ea%%%=ct%ie EAtqieoeo%toEafd exnrso%cdtiMesasveoxaos%uu:mapidhu%f estirsprnmttt%dns% u%rgholertetn.met%gntuluersana/selqvcptN e%l esdWntetlTrri<t%i![iDAAm sg<cdasiaeXrg%ardi%lg%o%apiragafW-pacTrtlaid%em<%%eeticAi%tst%rrooo alotqepialirxm%aoeglreanerteonA tmtdeeLteusnc}tie nenc%:nc td%nrlct%dtuaigLran_ir% hire%heoon%xu%XrUPcuaMh%nad rrs%lm rsicuopr%sin[mtienaoehA%l%>e0rg?miama%lmtndCim%t=agO%XMcspp]i>macf ileiee%e auaiR%waapd kCtin%betapvme%a% %un%elaleeo%T fimmsaennadirptess%ec`, 767196);
      ee[0], function(ne, ie) {
        ee[51] == "object" && ee[51] == "object" ? re[ee[140]] = ie() : ee[38] == "undefined" && (void 0)[ee[141]] ? (void 0)([], ie) : ee[51] == "object" ? te[ee[142]] = ie() : (ne[ee[143]] = ne[ee[143]] || {}, ne[ee[143]][ee[144]] = ne[ee[143]][ee[144]] || {}, ne[ee[143]][ee[144]][ee[142]] = ie());
      }(self, function() {
        return (self[ee[139]] = self[ee[139]] || [])[ee[72]]([[962], { 27972: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[3]] = void 0;
          var ce = ae(16368), he = ae(66054), _e = ae(69482), le = ae(69482);
          ie[ee[3]] = { name: ce[ee[5]][ee[4]], module: { parseXML: le[ee[6]], parseJSONtoXML: he[ee[7]], setLogger: _e[ee[8]] } }, ie[ee[9]] = ie[ee[3]];
        }, 54663: function(ne, ie, ae) {
          ae[ee[10]](ie), ae[ee[11]](ie, { SaxXMLParserWrapper: function() {
            return Te;
          }, decode: function() {
            return oe;
          } });
          var ce = String[ee[12]], he = Object[ee[14]][ee[13]], _e = /&#(\d+);|&#x([0-9a-f]+);|&(\w+);/gi, le = { amp: ee[15], apos: ee[16], gt: ee[17], lt: ee[18], quot: ee[19] };
          function se(Ee, we, Pe, Me) {
            return Me ? he[ee[20]](le, Me) ? le[Me] : ee[15] + Me + ee[21] : ce(we || parseInt(Pe, 16));
          }
          function oe(Ee) {
            return Ee[ee[22]] > 3 && Ee[ee[23]](ee[15]) !== -1 ? Ee[ee[24]](_e, se) : Ee;
          }
          Object[ee[27]](le)[ee[26]](function(Ee) {
            le[Ee[ee[25]]()] = le[Ee];
          });
          var ue = ee[28], be = ee[29], ve = ee[30], me = ee[31];
          function pe(Ee) {
            return new Error(Ee);
          }
          function fe(Ee) {
            return ee[32] + Ee + ee[17];
          }
          function ge(Ee) {
            return { get: Ee, enumerable: !0 };
          }
          function ye(Ee) {
            var we, Pe = {};
            for (we in Ee)
              Pe[we] = Ee[we];
            return Pe;
          }
          function $e(Ee) {
            return Ee + ee[33];
          }
          function Se(Ee) {
            var we, Pe, Me = {};
            for (we in Ee)
              Me[Pe = Ee[we]] = Pe, Me[$e(Pe)] = we;
            return Me;
          }
          function Ce() {
            return { line: 0, column: 0 };
          }
          function Ie(Ee) {
            throw Ee;
          }
          function Te(Ee) {
            if (!this)
              return new Te(Ee);
            var we, Pe, Me, Ae, Oe, Be, Ve, Ue, Re, Ne = Ee && Ee[ee[34]], xe = Ee && Ee[ee[35]] || ee[36], ke = function(Ye) {
              return xe + Ye;
            }, Le = Ie, He = Ce, We = !1, Xe = !1, Qe = null, tt = !1;
            function Je(Ye) {
              Ye instanceof Error || (Ye = pe(Ye)), Qe = Ye, Le(Ye, He);
            }
            function Ge(Ye) {
              Oe && (Ye instanceof Error || (Ye = pe(Ye)), Oe(Ye, He));
            }
            this[ee[37]] = function(Ye, ze) {
              if (ee[38] != typeof ze)
                throw pe(ee[39]);
              switch (Ye) {
                case ee[40]:
                  Pe = ze;
                  break;
                case ee[41]:
                  we = ze;
                  break;
                case ee[42]:
                  Me = ze;
                  break;
                case ee[43]:
                  Le = ze;
                  break;
                case ee[44]:
                  Oe = ze;
                  break;
                case ee[45]:
                  Ae = ze;
                  break;
                case ee[46]:
                  Ue = ze;
                  break;
                case ee[47]:
                  Ve = ze;
                  break;
                case ee[48]:
                  Be = ze;
                  break;
                default:
                  throw pe(ee[49] + Ye);
              }
              return this;
            }, this[ee[50]] = function(Ye) {
              if (Ye === void 0 && (Ye = {}), ee[51] != typeof Ye)
                throw pe(ee[52]);
              var ze, Fe = {};
              for (ze in Ye)
                Fe[ze] = Ye[ze];
              return Fe[ue] = be, Xe = !0, Re = Fe, this;
            }, this[ee[53]] = function(Ye) {
              if (ee[54] != typeof Ye)
                throw pe(ee[55]);
              return Qe = null, function(ze) {
                var Fe, ot, vt, gt, yt, pt, bt, ut, Ke, je, De, at = Xe ? [] : null, dt = Xe ? Se(Re) : null, ft = [], lt = 0, nt = !1, ct = !1, it = 0, et = 0, st = ee[36], mt = 0;
                function St() {
                  if (De !== null)
                    return De;
                  var $t, Tt, rt, qe, Ze, ht, _t, Ct, wt, It, Pt, kt = Xe && dt[ee[56]], Mt = Xe && We ? [] : null, At = mt, Rt = st, Ot = Rt[ee[22]], xt = {}, Ut = {}, Nt = function(jt, qt) {
                    return xt[ke(jt)] = qt;
                  };
                  e:
                    for (; At < Ot; At++)
                      if (wt = !1, !((It = Rt[ee[57]](At)) === 32 || It < 14 && It > 8)) {
                        for ((It < 65 || It > 122 || It > 90 && It < 97) && It !== 95 && It !== 58 && (Ge(ee[58]), wt = !0), Pt = At + 1; Pt < Ot; Pt++)
                          if (!((It = Rt[ee[57]](Pt)) > 96 && It < 123 || It > 64 && It < 91 || It > 47 && It < 59 || It === 46 || It === 45 || It === 95)) {
                            if (It === 32 || It < 14 && It > 8) {
                              Ge(ee[59]), At = Pt;
                              continue e;
                            }
                            if (It === 61)
                              break;
                            Ge(ee[60]), wt = !0;
                          }
                        if (ee[61] === (Ct = Rt[ee[62]](At, Pt)) && (Ge(ee[63]), wt = !0), (It = Rt[ee[57]](Pt + 1)) === 34)
                          (Pt = Rt[ee[23]](ee[19], At = Pt + 2)) === -1 && (Pt = Rt[ee[23]](ee[16], At)) !== -1 && (Ge(ee[64]), wt = !0);
                        else if (It === 39)
                          (Pt = Rt[ee[23]](ee[16], At = Pt + 2)) === -1 && (Pt = Rt[ee[23]](ee[19], At)) !== -1 && (Ge(ee[64]), wt = !0);
                        else
                          for (Ge(ee[65]), wt = !0, Pt += 1; Pt < Ot && !((It = Rt[ee[57]](Pt + 1)) === 32 || It < 14 && It > 8); Pt++)
                            ;
                        for (Pt === -1 && (Ge(ee[66]), Pt = Ot, wt = !0), wt || (ht = Rt[ee[62]](At, Pt)), At = Pt; Pt + 1 < Ot && !((It = Rt[ee[57]](Pt + 1)) === 32 || It < 14 && It > 8); Pt++)
                          At === Pt && (Ge(ee[67]), wt = !0);
                        if (At = Pt + 1, !wt)
                          if (Ct in Ut)
                            Ge(ee[68] + Ct + ee[69]);
                          else if (Ut[Ct] = !0, Xe)
                            if (We) {
                              if ((Ze = ee[56] === Ct ? ee[56] : Ct[ee[57]](0) === 120 && ee[70] === Ct[ee[71]](0, 6) ? Ct[ee[71]](6) : null) !== null) {
                                if ($t = oe(ht), Tt = $e(Ze), !(_t = Re[$t])) {
                                  if (ee[56] === Ze || Tt in dt && dt[Tt] !== $t)
                                    do
                                      _t = ee[50] + lt++;
                                    while (dt[_t] !== void 0);
                                  else
                                    _t = Ze;
                                  Re[$t] = _t;
                                }
                                dt[Ze] !== _t && (qe || (dt = ye(dt), qe = !0), dt[Ze] = _t, ee[56] === Ze && (dt[$e(_t)] = $t, kt = _t), dt[Tt] = $t), Nt(Ct, ht);
                                continue;
                              }
                              Mt[ee[72]](Ct, ht);
                            } else
                              (It = Ct[ee[23]](ee[73])) !== -1 ? (rt = dt[Ct[ee[62]](0, It)]) ? ((Ct = kt === rt ? Ct[ee[71]](It + 1) : rt + Ct[ee[71]](It)) === ve && ((It = ht[ee[23]](ee[73])) !== -1 ? (rt = ht[ee[62]](0, It), ht = (rt = dt[rt] || rt) + ht[ee[62]](It)) : ht = kt + ee[73] + ht), Nt(Ct, ht)) : Ge(fe(Ct[ee[62]](0, It))) : Nt(Ct, ht);
                          else
                            Nt(Ct, ht);
                      }
                  if (We)
                    for (At = 0, Ot = Mt[ee[22]]; At < Ot; At++) {
                      if (Ct = Mt[At++], ht = Mt[At], (It = Ct[ee[23]](ee[73])) !== -1) {
                        if (!(rt = dt[Ct[ee[62]](0, It)])) {
                          Ge(fe(Ct[ee[62]](0, It)));
                          continue;
                        }
                        (Ct = kt === rt ? Ct[ee[71]](It + 1) : rt + Ct[ee[71]](It)) === ve && ((It = ht[ee[23]](ee[73])) !== -1 ? (rt = ht[ee[62]](0, It), ht = (rt = dt[rt] || rt) + ht[ee[62]](It)) : ht = kt + ee[73] + ht);
                      }
                      Nt(Ct, ht);
                    }
                  return De = xt;
                }
                for (He = function() {
                  for (var $t, Tt, rt = /(\r\n|\r|\n)/g, qe = 0, Ze = 0, ht = 0, _t = et; it >= ht && ($t = rt[ee[74]](ze)) && !((_t = $t[0][ee[22]] + $t[ee[75]]) > it); )
                    qe += 1, ht = _t;
                  return it == -1 ? (Ze = _t, Tt = ze[ee[62]](et)) : et === 0 ? Tt = ze[ee[62]](et, it) : (Ze = it - ht, Tt = et == -1 ? ze[ee[62]](it) : ze[ee[62]](it, et + 1)), { data: Tt, line: qe, column: Ze };
                }, Ne && (je = Object[ee[76]]({}, { name: ge(function() {
                  return ut;
                }), originalName: ge(function() {
                  return Ke;
                }), attrs: ge(St), ns: ge(function() {
                  return dt;
                }) })); et !== -1; ) {
                  if ((it = ze[ee[57]](et) === 60 ? et : ze[ee[23]](ee[18], et)) === -1)
                    return ft[ee[22]] ? Je(ee[77]) : et === 0 ? Je(ee[78]) : void (et < ze[ee[22]] && ze[ee[62]](et)[ee[79]]() && Ge(me));
                  if (et !== it) {
                    if (ft[ee[22]]) {
                      if (we && (we(ze[ee[62]](et, it), oe, He), tt))
                        return;
                    } else if (ze[ee[62]](et, it)[ee[79]]() && (Ge(me), tt))
                      return;
                  }
                  if ((yt = ze[ee[57]](it + 1)) === 33) {
                    if ((gt = ze[ee[57]](it + 2)) === 91 && ee[80] === ze[ee[71]](it + 3, 6)) {
                      if ((et = ze[ee[23]](ee[81], it)) === -1)
                        return Je(ee[82]);
                      if (Ae && (Ae(ze[ee[62]](it + 9, et), He), tt))
                        return;
                      et += 3;
                      continue;
                    }
                    if (gt === 45 && ze[ee[57]](it + 3) === 45) {
                      if ((et = ze[ee[23]](ee[83], it)) === -1)
                        return Je(ee[84]);
                      if (Be && (Be(ze[ee[62]](it + 4, et), oe, He), tt))
                        return;
                      et += 3;
                      continue;
                    }
                  }
                  if (yt !== 63) {
                    for (ot = it + 1; ; ot++) {
                      if (pt = ze[ee[57]](ot), isNaN(pt))
                        return et = -1, Je(ee[85]);
                      if (pt === 34)
                        ot = (gt = ze[ee[23]](ee[19], ot + 1)) !== -1 ? gt : ot;
                      else if (pt === 39)
                        ot = (gt = ze[ee[23]](ee[16], ot + 1)) !== -1 ? gt : ot;
                      else if (pt === 62) {
                        et = ot;
                        break;
                      }
                    }
                    if (yt !== 33) {
                      if (De = {}, yt === 47) {
                        if (nt = !1, ct = !0, !ft[ee[22]])
                          return Je(ee[86]);
                        if (ot = ut = ft[ee[87]](), gt = it + 2 + ot[ee[22]], ze[ee[62]](it + 2, gt) !== ot)
                          return Je(ee[88]);
                        for (; gt < et; gt++)
                          if (!((yt = ze[ee[57]](gt)) === 32 || yt > 8 && yt < 14))
                            return Je(ee[89]);
                      } else {
                        if (ze[ee[57]](et - 1) === 47 ? (ot = ut = ze[ee[62]](it + 1, et - 1), nt = !0, ct = !0) : (ot = ut = ze[ee[62]](it + 1, et), nt = !0, ct = !1), !(yt > 96 && yt < 123 || yt > 64 && yt < 91 || yt === 95 || yt === 58))
                          return Je(ee[90]);
                        for (gt = 1, vt = ot[ee[22]]; gt < vt; gt++)
                          if (!((yt = ot[ee[57]](gt)) > 96 && yt < 123 || yt > 64 && yt < 91 || yt > 47 && yt < 59 || yt === 45 || yt === 95 || yt == 46)) {
                            if (yt === 32 || yt < 14 && yt > 8) {
                              ut = ot[ee[62]](0, gt), De = null;
                              break;
                            }
                            return Je(ee[91]);
                          }
                        ct || ft[ee[72]](ut);
                      }
                      if (Xe) {
                        if (Fe = dt, nt && (ct || at[ee[72]](Fe), De === null && (We = ot[ee[23]](ee[56], gt) !== -1) && (mt = gt, st = ot, St(), We = !1)), Ke = ut, (yt = ut[ee[23]](ee[73])) !== -1) {
                          if (!(bt = dt[ut[ee[62]](0, yt)]))
                            return Je(ee[92] + Ke + ee[17]);
                          ut = ut[ee[71]](yt + 1);
                        } else
                          bt = dt[ee[56]];
                        bt && (ut = bt + ee[73] + ut);
                      }
                      if (nt && (mt = gt, st = ot, Pe && (Ne ? Pe(je, oe, ct, He) : Pe(ut, St, oe, ct, He), tt)))
                        return;
                      if (ct) {
                        if (Me && (Me(Ne ? je : ut, oe, nt, He), tt))
                          return;
                        Xe && (dt = nt ? Fe : at[ee[87]]());
                      }
                      et += 1;
                    } else {
                      if (Ue && (Ue(ze[ee[62]](it, et + 1), oe, He), tt))
                        return;
                      et += 1;
                    }
                  } else {
                    if ((et = ze[ee[23]](ee[93], it)) === -1)
                      return Je(ee[94]);
                    if (Ve && (Ve(ze[ee[62]](it, et + 2), He), tt))
                      return;
                    et += 2;
                  }
                }
              }(Ye), He = Ce, tt = !1, Qe;
            }, this[ee[95]] = function() {
              tt = !0;
            };
          }
        }, 66054: function(ne, ie) {
          var ae = this && this[ee[96]] || function(Se, Ce, Ie) {
            if (Ie || arguments[ee[22]] === 2)
              for (var Te, Ee = 0, we = Ce[ee[22]]; Ee < we; Ee++)
                !Te && Ee in Ce || (Te || (Te = Array[ee[14]][ee[97]][ee[20]](Ce, 0, Ee)), Te[Ee] = Ce[Ee]);
            return Se[ee[98]](Te || Array[ee[14]][ee[97]][ee[20]](Ce));
          };
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[7]] = $e;
          var ce = [ee[99], ee[100], ee[101]];
          function he(Se) {
            return ce[ee[102]](Se);
          }
          function _e(Se) {
            return Se[ee[22]] > 0 && ee[36] !== Se[ee[103]](ee[36]);
          }
          function le(Se) {
            return Object[ee[27]](Se)[ee[104]](he);
          }
          function se(Se) {
            return Object[ee[27]](Se)[ee[104]](function(Ce) {
              return Ce[ee[106]](ee[105]) && !he(Ce);
            });
          }
          function oe(Se) {
            return Object[ee[27]](Se)[ee[104]](function(Ce) {
              return !Ce[ee[106]](ee[105]);
            });
          }
          function ue(Se, Ce, Ie) {
            var Te = ee[36];
            return Ie ? (Te += ee[18][ee[98]](Ie), Te += Se[ee[22]] > 0 ? ee[107][ee[98]](Se[ee[103]](ee[107])) : ee[36], Te += Ce ? ee[17] : ee[108]) : Te;
          }
          function be(Se, Ce) {
            var Ie = ee[36];
            return _e(Se) && (Ie += Se[ee[103]](ee[36]), Ie += Ce ? ee[109][ee[98]](Ce, ee[17]) : ee[36]), Ie;
          }
          function ve(Se, Ce, Ie) {
            return ue(Ce, _e(Se), Ie) + be(Se, Ie);
          }
          function me(Se) {
            return ee[110][ee[98]](Se, ee[81]);
          }
          function pe(Se) {
            for (var Ce = le(Se), Ie = null, Te = [], Ee = 0, we = Ce; Ee < we[ee[22]]; Ee++) {
              var Pe = we[Ee];
              ee[99] === Pe && (Ie = Se[Pe]), ee[100] === Pe && Te[ee[72]](Se[Pe]), ee[101] === Pe && Se[Pe][ee[26]](function(Me) {
                Te[ee[72]](me(Me));
              });
            }
            return [Ie, Te];
          }
          function fe(Se) {
            return se(Se)[ee[112]](function(Ce) {
              return ee[36][ee[98]](Ce[ee[24]](ee[105], ee[36]), ee[111])[ee[98]](Se[Ce], ee[19]);
            });
          }
          function ge(Se, Ce) {
            return Ce[ee[112]](function(Ie) {
              return ee[54] == typeof Ie ? ve(ee[36] !== Ie ? [Ie] : [], [], Se) : $e(Ie, Se);
            });
          }
          function ye(Se) {
            for (var Ce = [], Ie = 0, Te = oe(Se); Ie < Te[ee[22]]; Ie++) {
              var Ee = Te[Ie], we = Se[Ee];
              ee[54] != typeof we ? we instanceof Array ? Ce[ee[72]][ee[113]](Ce, ge(Ee, we)) : ee[51] == typeof we && Ce[ee[72]]($e(we, Ee)) : Ce[ee[72]](ee[18][ee[98]](Ee, ee[17])[ee[98]](we, ee[109])[ee[98]](Ee, ee[17]));
            }
            return Ce;
          }
          function $e(Se, Ce) {
            var Ie = pe(Se), Te = Ie[0], Ee = Ie[1], we = ye(Se), Pe = fe(Se), Me = Ce;
            return Me && Te && (Me = ee[36][ee[98]](Te, ee[73])[ee[98]](Ce)), ve(ae(ae([], Ee, !0), we, !0), Pe, Me);
          }
        }, 69482: function(ne, ie, ae) {
          Object[ee[2]](ie, ee[1], { value: !0 }), ie[ee[114]] = $e, ie[ee[8]] = Se, ie[ee[6]] = Ie;
          var ce, he = ae(54663), _e = 3;
          function le(Te) {
            Te[ee[115]] = function() {
              return (this[ee[100]] ? this[ee[100]] : ee[36]) + (this[ee[101]] ? this[ee[101]] : ee[36]);
            };
          }
          function se(Te, Ee) {
            Ee && Object[ee[27]](Te)[ee[22]] === _e - 1 && (Te[ee[100]] = ee[36], le(Te));
          }
          (function(Te) {
            Te[ee[116]] = ee[40], Te[ee[117]] = ee[42], Te[ee[118]] = ee[41], Te[ee[119]] = ee[43], Te[ee[120]] = ee[44], Te[ee[121]] = ee[45], Te[ee[122]] = ee[46], Te[ee[123]] = ee[47], Te[ee[124]] = ee[48];
          })(ce || (ce = {}));
          var oe = function(Te, Ee, we, Pe) {
            return we[ee[125]] = Te, we[ee[126]] = Ee, Te[ee[125]] || Te[ee[126]] || Te[Ee] ? Te[Ee] ? (Te[Ee][ee[72]](we), we) : (se(we, Pe), Te[Ee] = [we], we) : (Te[Ee] = we, we);
          }, ue = function(Te, Ee, we, Pe) {
            return we[ee[125]] = Te, we[ee[126]] = Ee, Te[Ee] ? Te[Ee][ee[127]] === Array ? (Te[Ee][ee[72]](we), we) : (Te[Ee] = [Te[Ee], we], we) : (se(we, Pe), Te[Ee] = we, we);
          };
          function be(Te, Ee) {
            var we = Ee();
            if (!Te[ee[102]](ee[73]))
              return [Te, we];
            var Pe = Te[ee[128]](ee[73]), Me = Pe[0], Ae = Pe[1];
            return we[ee[99]] = Me, [Ae, we];
          }
          function ve(Te) {
            var Ee = Te[ee[125]];
            return delete Te[ee[125]], ge(Ee, Te), delete Te[ee[126]], Ee;
          }
          var me, pe, fe = function(Te) {
            return Te[ee[100]] != null && Object[ee[27]](Te)[ee[22]] === _e;
          };
          function ge(Te, Ee) {
            if (fe(Ee) && Ee[ee[126]] != null)
              if (Te[Ee[ee[126]]] !== Ee) {
                if (Te[Ee[ee[126]]][ee[127]] === Array) {
                  var we = Te[Ee[ee[126]]][ee[23]](Ee);
                  Te[Ee[ee[126]]][we] = Ee[ee[100]];
                }
              } else
                Te[Ee[ee[126]]] = Ee[ee[100]];
          }
          function ye(Te, Ee) {
            Te[ee[100]] = Ee[ee[79]](), le(Te);
          }
          function $e(Te) {
            return Te[ee[24]](/>\s+</g, ee[129])[ee[24]](/[\n|\r]+/g, ee[107])[ee[79]]();
          }
          function Se(Te) {
            pe = Te;
          }
          function Ce(Te, Ee, we) {
            we && (Te[ee[130]] && (Te[ee[130]] = Ee(Te[ee[130]])), Te[ee[131]] && (Te[ee[131]] = Ee(Te[ee[131]])));
          }
          function Ie(Te, Ee) {
            me = me || new he[ee[132]]({ attributeNamePrefix: ee[105] });
            var we, Pe = $e(Te), Me = {}, Ae = Ee[ee[133]] ? oe : ue;
            return me[ee[37]](ce[ee[116]], function(Oe, Be, Ve, Ue) {
              var Re = be(Oe, Be), Ne = Re[0], xe = Re[1];
              Ce(xe, Ve, Ee[ee[134]]), Me = Ae(Me, Ne, xe, Ue);
            }), me[ee[37]](ce[ee[117]], function(Oe) {
              Me = ve(Me);
            }), me[ee[37]](ce[ee[118]], function(Oe, Be) {
              ye(Me, Ee[ee[134]] ? Be(Oe) : Oe);
            }), me[ee[37]](ce[ee[121]], function(Oe) {
              Me[ee[101]] == null ? Me[ee[101]] = [Oe] : Me[ee[101]][ee[72]](Oe), le(Me);
            }), me[ee[37]](ce[ee[119]], function(Oe) {
              we = new Error(ee[136][ee[98]](Oe instanceof Error ? Oe[ee[135]] : String(Oe))), pe && pe[ee[137]](we[ee[135]]), me[ee[95]](), Me = {};
            }), me[ee[53]](Pe), we ? { success: !1, error: we } : { success: !0, parsed: Me };
          }
        } }, function(ne) {
          return function(ie) {
            return ne(ne[ee[138]] = ie);
          }(27972);
        }]);
      });
    })();
  })();
})(bitmovinplayerXml, bitmovinplayerXml.exports);
var bitmovinplayerXmlExports = bitmovinplayerXml.exports;
const XML = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerXmlExports);
function createBitmovinPlayerOptions(re, te) {
  var ce;
  const ee = (ce = re.adService) == null ? void 0 : ce.createBitmovinAdConfig(), ne = re.autoplay, ie = re.muted === "MUTED";
  return {
    ...te,
    playback: { autoplay: ne, muted: ie },
    advertising: ee
  };
}
const log$6 = loglevelExports.getLogger("createBitmovinPlayer");
function getModuleExport(re) {
  return isObject$1(re) && "default" in re ? re.default : re;
}
function getBitmovinModules() {
  try {
    return bitmovinplayerCoreExports.Player.getModules();
  } catch {
    return [];
  }
}
function isModuleLoaded(re) {
  return (getBitmovinModules() ?? []).includes(re);
}
function setupBitmovinModules() {
  bitmovinplayerCoreExports.Player.addModule(getModuleExport(BitmovinEngineModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(EngineNative)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(MSERendererModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(HLSModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(ABRModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(TSContainerModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(MP4ContainerModule)), isModuleLoaded(bitmovinplayerCoreExports.ModuleName.XML) || bitmovinplayerCoreExports.Player.addModule(getModuleExport(XML)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(DashModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(SubtitlesModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(SubtitlesVTT)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(SubtitlesNative)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(VR));
}
setupBitmovinModules();
const storedPlayers = [];
function findStoredPlayerInfo(re) {
  return storedPlayers.find((ee) => ee.id === re);
}
function createBitmovinPlayer(re, te) {
  var ae;
  const ee = (ae = findStoredPlayerInfo(re.playerId)) == null ? void 0 : ae.player;
  if (ee)
    return log$6.debug("reusing previous player instance for id", re.playerId), { player: ee, id: re.playerId };
  const ne = createBitmovinPlayerOptions(re, te);
  log$6.debug("creating new bitmovin player instance", re.playerId);
  const ie = new bitmovinplayerCoreExports.Player(re.element, ne);
  return storedPlayers.push({ player: ie, id: re.playerId }), { player: ie, id: re.playerId };
}
const DEFAULT_16_9_VIDEO_TAG_POSTER_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAABmJLR0QA/wD/AP+gvaeTAAAAGElEQVQokWNkYGD4z0ABYKJE86gBw8YAAFmzAREE4ESyAAAAAElFTkSuQmCC";
function convertToAspectRatio(re) {
  const ee = [
    { decimal: 1.7777777777777777, ratio: { width: 16, height: 9 } },
    { decimal: 0.8, ratio: { width: 4, height: 5 } },
    { decimal: 1.3333333333333333, ratio: { width: 4, height: 3 } },
    { decimal: 0.6666666666666666, ratio: { width: 2, height: 3 } },
    { decimal: 2, ratio: { width: 2, height: 1 } },
    { decimal: 1, ratio: { width: 1, height: 1 } },
    { decimal: 0.5625, ratio: { width: 9, height: 16 } }
  ].find((ne) => ne.decimal === re);
  return ee ? ee.ratio : { width: 16, height: 9 };
}
function generateVideoTagPosterSource(re) {
  if (!re)
    return DEFAULT_16_9_VIDEO_TAG_POSTER_IMAGE;
  const te = convertToAspectRatio(re), ee = te.width, ne = te.height, ie = document.createElement("canvas");
  ie.width = ee, ie.height = ne;
  const ae = ie.getContext("2d");
  return ae ? (ae.fillStyle = "black", ae.fillRect(0, 0, ee, ne), ie.toDataURL("image/png")) : DEFAULT_16_9_VIDEO_TAG_POSTER_IMAGE;
}
const RBCOM_LINEAR_ASSET_PREFIX = "rrn:content:video-channels", MIN_TIMESHIFT_FOR_DVR_SECS = -200;
function detectBasedOnAssetId(re) {
  return re ? re.startsWith(RBCOM_LINEAR_ASSET_PREFIX) : !1;
}
function detectBasedOnMaxTimeShift(re) {
  return !Number.isFinite(re) || Number.isNaN(re) ? !0 : re > MIN_TIMESHIFT_FOR_DVR_SECS;
}
function isLinearStream(re, te, ee) {
  return detectBasedOnAssetId(ee) || te ? !0 : detectBasedOnMaxTimeShift(re);
}
function calculateNumber(re) {
  return re ?? 0;
}
function resolveAdBreakFinished(re) {
  var ee;
  const te = (ee = re.ad) == null ? void 0 : ee.data.adPodInfo;
  return te ? te.adPosition === te.totalAds : !1;
}
function resolveAdBreakStarted(re) {
  var te;
  return ((te = re.ad) == null ? void 0 : te.data.adPodInfo.adPosition) === 1;
}
const defaultAdData = {
  adId: "",
  skippable: !1,
  duration: 0,
  title: ""
}, resolveAdEventData = (re) => re ?? defaultAdData;
function resolveAdSkippedOrFinishedType(re) {
  const { SKIPPED: te } = window.google.ima.AdEvent.Type;
  return re === te ? "adSkipped" : "adFinished";
}
function resolveCurrentAdType(re) {
  const { getLastMainMediaPositionInSec: te, getInitialSeekTimeInSec: ee, getMainMediaDurationInSec: ne } = re;
  return calculateAdType(
    te(),
    ee(),
    ne()
  );
}
class InteractiveMediaAds {
  constructor(te, ee) {
    Et(this, "playerId");
    Et(this, "eventEmitter");
    Et(this, "resetIsSeekingToFalse");
    Et(this, "currentPlaybackPosition");
    Et(this, "currentAdId");
    Et(this, "currentAdTitle");
    Et(this, "_isShowingAd", !1);
    Et(this, "_isPlaying", !1);
    Et(this, "isInFullscreenMode");
    Et(this, "playingFullscreen", !1);
    Et(this, "handleAdEvent", (te) => {
      const { STARTED: ee, AD_PROGRESS: ne, SKIPPED: ie, COMPLETE: ae, RESUMED: ce, CLICK: he } = window.google.ima.AdEvent.Type;
      switch (te.type) {
        case ne:
          this.playingFullscreen = this.isInFullscreenMode(), this.handleProgressEvent(te);
          break;
        case ee:
          this.isPlaying = !0, this.isShowingAd = !0, this.handleAdStartedEvent(te);
          break;
        case ie:
        case ae:
          this.isPlaying = !1, this.isShowingAd = !1, this.handleAdFinishedEvent(te);
          break;
        case ce:
          this.isPlaying = !0;
          break;
        case he:
          this.handleAdClickedEvent();
          break;
        default:
          this.isPlaying = !1;
          break;
      }
    });
    Et(this, "handleProgressEvent", (te) => {
      const ee = te.getAdData(), ne = calculateNumber(ee == null ? void 0 : ee.duration);
      this.currentPlaybackPosition = calculateNumber(ee == null ? void 0 : ee.currentTime);
      const ie = calculateNumber(ee == null ? void 0 : ee.adPosition), ae = calculateNumber(ee == null ? void 0 : ee.totalAds);
      this.dispatchEvent({
        type: "adTimeChanged",
        duration: ne,
        playbackPosition: this.currentPlaybackPosition,
        adPosition: ie,
        totalAds: ae
      });
    });
    Et(this, "handleAdStartedEvent", (te) => {
      var he;
      this.handleAdBreakStarted(te);
      const { adId: ee, skippable: ne, duration: ie, title: ae } = resolveAdEventData((he = te.ad) == null ? void 0 : he.data);
      this.currentAdId = ee, this.currentAdTitle = ae;
      const ce = resolveCurrentAdType(this.playerDataAccessor);
      this.dispatchEvent({
        type: "adStarted",
        skippable: ne,
        duration: ie,
        adType: ce
      });
    });
    Et(this, "handleAdFinishedEvent", (te) => {
      const ee = resolveAdSkippedOrFinishedType(te.type);
      this.dispatchEvent({
        type: ee
      }), this.handleAdBreakFinished(te);
    });
    this.adsManager = te, this.playerDataAccessor = ee;
    const { playerId: ne, eventEmitter: ie, resetIsSeekingToFalse: ae, isInFullscreenMode: ce } = ee;
    this.playerId = ne, this.eventEmitter = ie, this.resetIsSeekingToFalse = ae, this.isInFullscreenMode = ce, this.updateEventListeners();
  }
  get isShowingAd() {
    return this._isShowingAd;
  }
  set isShowingAd(te) {
    this._isShowingAd = te;
  }
  get isPlaying() {
    return this._isPlaying;
  }
  set isPlaying(te) {
    this._isPlaying = te;
  }
  updateEventListeners() {
    this.addOrRemoveEventListeners("removeEventListener"), this.addOrRemoveEventListeners("addEventListener");
  }
  addOrRemoveEventListeners(te) {
    const { STARTED: ee, AD_PROGRESS: ne, PAUSED: ie, SKIPPED: ae, COMPLETE: ce, RESUMED: he, CLICK: _e } = window.google.ima.AdEvent.Type;
    this.adsManager[te](ee, this.handleAdEvent), this.adsManager[te](ne, this.handleAdEvent), this.adsManager[te](ie, this.handleAdEvent), this.adsManager[te](ae, this.handleAdEvent), this.adsManager[te](ce, this.handleAdEvent), this.adsManager[te](he, this.handleAdEvent), this.adsManager[te](_e, this.handleAdEvent);
  }
  handleAdBreakStarted(te) {
    resolveAdBreakStarted(te) && (this.resetIsSeekingToFalse(), this.dispatchEvent({
      type: "adBreakStarted"
    }));
  }
  handleAdBreakFinished(te) {
    if (!resolveAdBreakFinished(te))
      return;
    const ne = resolveCurrentAdType(this.playerDataAccessor);
    this.dispatchEvent({
      type: "adBreakFinished",
      adType: ne
    });
  }
  handleAdClickedEvent() {
    this.playingFullscreen && this.adsManager.resize(0, 0);
  }
  dispatchEvent(te) {
    const ee = {
      ...te,
      playerId: this.playerId,
      adId: this.currentAdId
    };
    this.eventEmitter.fireEvent(ee);
  }
  pause() {
    this.adsManager.pause();
  }
  play() {
    this.adsManager.resume();
  }
  getCurrentTimeInSeconds() {
    return this.currentPlaybackPosition;
  }
  getActiveAdId() {
    return this.currentAdId;
  }
  getActiveAdTitle() {
    return this.currentAdTitle;
  }
  getAdCuePoints() {
    return this.adsManager.getCuePoints();
  }
  destroy() {
    this.addOrRemoveEventListeners("removeEventListener"), this.adsManager.destroy();
  }
}
function resolveVRSourceConfig(re) {
  if (re)
    return {
      contentType: "single",
      keyboardControl: {
        transitionTimingType: "none",
        transitionTime: 0.5,
        maxDisplacementSpeed: 90
      }
    };
}
const log$5 = loglevelExports.getLogger("BitmovinPlayerAdapter"), playerConfig = {
  key: "adb77626-0c8f-4879-a13a-b0be47d4222b",
  ui: !1,
  logs: {
    bitmovin: !1
  },
  adaptation: {
    preload: !1,
    limitToPlayerSize: !0
  },
  tweaks: {
    // eslint-disable-next-line camelcase
    native_hls_parsing: !0
  }
  // this is commented out on purpose, if you need VERY noisy bitmovin logs, uncomment the following lines
  // logs: {
  //     bitmovin: true,
  //     level: LogLevel.DEBUG,
  //     onLog: (logLevel, message, params) => {
  //         if (logLevel !== LogLevel.DEBUG) {
  //             console.info('BITMOVIN', logLevel, message, params);
  //         } else {
  //             console.log('BITMOVIN', logLevel, message, params);
  //         }
  //     },
  // },
};
function resolvePlayerConfig(re) {
  if (!(re != null && re.customVideoUrlRequestHeader))
    return playerConfig;
  const te = re.customVideoUrlRequestHeader.key, ee = re.customVideoUrlRequestHeader.value;
  return {
    ...playerConfig,
    network: {
      preprocessHttpRequest: async (ne, ie) => (ie.headers[te] = ee, ie)
    }
  };
}
class BitmovinPlayerAdapter {
  constructor(te) {
    Et(this, "player");
    Et(this, "currentSeekTarget", 0);
    Et(this, "currentSeekIssuer");
    Et(this, "isSeeking", !1);
    Et(this, "isPlayRequested", !1);
    Et(this, "ima");
    Et(this, "hasStarted", !1);
    Et(this, "shouldAutoPlay", !1);
    Et(this, "hasError", !1);
    Et(this, "mainMediaDurationInSec", 0);
    Et(this, "initialSeekTimeInSec", 0);
    Et(this, "segmentStartDate", 0);
    Et(this, "loaded", !1);
    Et(this, "queuedAction");
    /** the last playback time when the timeChanged event was received, used for skip tracking. */
    Et(this, "lastTimeChangedPlaybackTime", 0);
    /** the last timestamp when the timeChanged event was received, used for skip tracking. */
    Et(this, "lastTimeChangedTimestamp", 0);
    Et(this, "lastPlayerEvent");
    /**
     * the last known media position in the main video (not counting ads).
     * We need to keep track of where we are in the "normal" video in order to figure
     * out whether an ad is pre/mid/post-roll.
     */
    Et(this, "lastMainMediaPositionInSec", 0);
    Et(this, "playerId");
    Et(this, "eventEmitter");
    Et(this, "subtitleHandler", new SubtitleHandler());
    Et(this, "currentSetAudioTrackIssuer", "INITIAL");
    Et(this, "currentSetSubtitleTrackIssuer", "INITIAL");
    Et(this, "postRollAdBreakFinished", !1);
    // For `_handlePlayerEvent` we are using arrow style functions to be able to use it as event handler and still have `this` bound to the instance.
    // This enables us to easily remove the event handlers.
    // eslint-disable-next-line complexity
    Et(this, "_handlePlayerEvent", (te) => {
      try {
        let ee = !0;
        switch (te.type) {
          case bitmovinplayerCoreExports.PlayerEvent.Seeked:
          case bitmovinplayerCoreExports.PlayerEvent.TimeShifted:
            this._handleSeekDone(te, this.playerId);
            return;
          case bitmovinplayerCoreExports.PlayerEvent.Playing:
            this.isPlayRequested = !1, this.shouldAutoPlay = !1;
            break;
          case bitmovinplayerCoreExports.PlayerEvent.TimeChanged:
            ee = this._handleTimeChanged(te), this.isShowingAd() || (this.lastMainMediaPositionInSec = this.getCurrentTimeInSec());
            break;
          case bitmovinplayerCoreExports.PlayerEvent.Play:
            this.isShowingAd() || (this.lastMainMediaPositionInSec = this.getCurrentTimeInSec());
            break;
          case bitmovinplayerCoreExports.PlayerEvent.Warning:
            this.handleWarningEvent(te);
            break;
          case bitmovinplayerCoreExports.PlayerEvent.SegmentPlayback: {
            const ne = te.dateTime, ie = ne ? Date.parse(ne) : 0;
            ie > 0 && this.segmentStartDate !== ie && (this.segmentStartDate = ie);
            break;
          }
          case bitmovinplayerCoreExports.PlayerEvent.SourceUnloaded:
            this.loaded = !1;
            break;
          default:
            break;
        }
        switch (ee && this.mapEventAndEmit(te, this.playerId), te.type) {
          case bitmovinplayerCoreExports.PlayerEvent.TimeChanged:
            this.handleTimeChangedAfterEmit();
            break;
          case bitmovinplayerCoreExports.PlayerEvent.SubtitleEnabled:
          case bitmovinplayerCoreExports.PlayerEvent.SubtitleDisabled:
          case bitmovinplayerCoreExports.PlayerEvent.SubtitleDisable:
            this.currentSetSubtitleTrackIssuer = void 0, this.eventEmitter.fireEvent(this.subtitleHandler.resetAndGetEvent(this.playerId));
            break;
          case bitmovinplayerCoreExports.PlayerEvent.AudioChanged:
            this.currentSetAudioTrackIssuer = void 0;
            break;
          default:
            break;
        }
      } catch (ee) {
        console.error("ERROR DURING EVENT HANDLING", ee);
      }
      this.lastPlayerEvent = te, this.postRollAdBreakFinished = !1;
    });
    Et(this, "_handleSubtitleEvent", (te) => {
      const ee = this.subtitleHandler.handleSubtitleEvent(te, this.playerId);
      this.eventEmitter.fireEvent(ee);
    });
    Et(this, "resetIsSeekingToFalse", () => {
      this.isSeeking = !1;
    });
    Et(this, "isInFullscreenMode", () => {
      var te;
      return ((te = this.player) == null ? void 0 : te.getViewMode()) === bitmovinplayerCoreExports.ViewMode.Fullscreen;
    });
    Et(this, "handleAdBreakFinished", (te) => {
      te.type === "adBreakFinished" && te.adType === "POST_ROLL" && (this.postRollAdBreakFinished = !0);
    });
    var ae;
    const ee = te.playerId;
    this.eventEmitter = te.eventEmitter, this.playerId = ee;
    const ne = createBitmovinPlayer(te, resolvePlayerConfig(te));
    this.player = ne.player;
    const ie = this.player;
    te.autoplay && (this.hasStarted = !0, this.isPlayRequested = !0, this.shouldAutoPlay = !0), te.enableDataZoom === "ACTIVE" && ((ae = te.dataZoomConfig) != null && ae.configId) && createDataZoomTracker(te.dataZoomConfig, ie), this.addAllEventListeners(ie);
  }
  addAllEventListeners(te) {
    this.addOrRemoveAllEventListeners(te, "add");
  }
  removeAllEventListeners(te) {
    this.addOrRemoveAllEventListeners(te, "remove");
  }
  addOrRemoveEventListener(te, ee, ne, ie) {
    ee === "add" ? te.on(ne, ie) : te.off(ne, ie);
  }
  addOrRemoveAllEventListeners(te, ee) {
    this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.AirplayChanged, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.AudioChanged, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.CueEnter, this._handleSubtitleEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.CueExit, this._handleSubtitleEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.CueUpdate, this._handleSubtitleEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Error, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Muted, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Paused, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Play, this._handlePlayerEvent), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.PlaybackFinished,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.PlaybackSpeedChanged,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Playing, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Seek, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Seeked, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.SourceUnloaded, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.StallEnded, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.StallStarted, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.SubtitleAdded, this._handlePlayerEvent), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.SubtitleDisabled,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.SubtitleEnabled,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.TimeChanged, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.TimeShift, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.TimeShifted, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Unmuted, this._handlePlayerEvent), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.ViewModeChanged,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.VolumeChanged, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Warning, this._handlePlayerEvent), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.SegmentPlayback,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.VideoQualityChanged,
      this._handlePlayerEvent
    );
  }
  // For `_handleTimeChanged` we are using arrow style functions to be able to use it as event handler and still have `this` bound to the instance.
  // This enables us to easily remove the event handlers.
  _handleTimeChanged(te) {
    let ee = !0;
    return this.isSeeking || this.isShowingAd() ? ee = !1 : this.checkForTimeSkipAndNotify(te), ee;
  }
  handleWarningEvent(te) {
    var ee, ne;
    if (te.code === bitmovinplayerCoreExports.WarningCode.PLAYBACK_COULD_NOT_BE_STARTED) {
      const ie = (ee = this.player) == null ? void 0 : ee.getConfig(!0).playback, ae = (ie == null ? void 0 : ie.autoplay) ?? !1;
      if (!((ie == null ? void 0 : ie.muted) ?? !1) && ae && this.shouldAutoPlay) {
        log$5.debug("trying another auto-play with mute turned on"), this.shouldAutoPlay = !1;
        const he = ((ne = this.player) == null ? void 0 : ne.isMuted()) ?? !1;
        this.mute("INITIAL"), this.play().catch((_e) => {
          log$5.warn("auto play with mute on did not work either", _e), he || this.unmute("INITIAL");
        });
      }
    }
  }
  getSubtitlesApi() {
    var te;
    return (te = this.player) == null ? void 0 : te.subtitles;
  }
  _handleSeekDone(te, ee) {
    var ae;
    this.isSeeking = !1;
    const ne = (ae = this.player) == null ? void 0 : ae.getCurrentTime(bitmovinplayerCoreExports.TimeMode.AbsoluteTime), ie = {
      ...te,
      issuer: this.currentSeekIssuer,
      time: ne
    };
    this.currentSeekTarget = 0, this.currentSeekIssuer = void 0, this.lastTimeChangedTimestamp = 0, this.mapEventAndEmit(ie, ee);
  }
  canSeekOrTimeshiftForward() {
    return this.player ? this.player.isLive() ? this.player.getTimeShift() < 0 : this.getCurrentTimeInSec() < Math.max(0, this.getMainMediaDurationInSec() - 1) : !1;
  }
  canSeekOrTimeshiftBackward() {
    return this.player ? this.player.isLive() ? this.player.getTimeShift() > this.player.getMaxTimeShift() : this.getCurrentTimeInSec() > 1 : !1;
  }
  disableSubtitle() {
    var ee;
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    const te = this.getSelectedSubtitleTrack();
    te && ((ee = this.getSubtitlesApi()) == null || ee.disable(te.id));
  }
  enableSubtitle(te, ee = "USER") {
    var ne;
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.currentSetSubtitleTrackIssuer = ee, (ne = this.getSubtitlesApi()) == null || ne.enable(te, !0);
  }
  getAvailableVideoQualities() {
    var ee;
    return (((ee = this.player) == null ? void 0 : ee.getAvailableVideoQualities()) ?? []).map((ne) => ({
      bitrate: ne.bitrate,
      height: ne.height,
      id: ne.id,
      width: ne.width,
      frameRate: ne.frameRate
    }));
  }
  getLiveVariant() {
    if (!this.player)
      return "LINEAR";
    if (this.player.isLive())
      return isLinearStream(this.player.getMaxTimeShift()) ? "LINEAR" : "DVR";
    throw new Error("trying to get LiveVariant on a VOD player");
  }
  getPlaybackMode() {
    return this.player ? this.player.isLive() ? "LIVE" : "VOD" : "UNKNOWN";
  }
  getPlayerType() {
    return "VIDEO";
  }
  getAvailableSubtitleTracks() {
    var ee;
    return (((ee = this.getSubtitlesApi()) == null ? void 0 : ee.list()) ?? []).filter((ne) => isValidSubtitleTrack(ne));
  }
  getSelectedSubtitleTrack() {
    var te;
    return (((te = this.getSubtitlesApi()) == null ? void 0 : te.list()) ?? []).find((ee) => ee.enabled);
  }
  isAirPlayAvailable() {
    var te;
    return !!((te = this.player) != null && te.isAirplayAvailable());
  }
  isPlayingVideoViaAirPlay() {
    var te;
    return !!((te = this.player) != null && te.isAirplayActive());
  }
  isShowingAd() {
    var te;
    return !!((te = this.getPlayerAdvertisingAPI()) != null && te.isShowingAd);
  }
  getActiveAdId() {
    var te;
    return (te = this.getPlayerAdvertisingAPI()) == null ? void 0 : te.getActiveAdId();
  }
  getActiveAdTitle() {
    var te;
    return (te = this.getPlayerAdvertisingAPI()) == null ? void 0 : te.getActiveAdTitle();
  }
  playVideoViaAirPlay() {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.isAirPlayAvailable() && this.player.showAirplayTargetPicker();
  }
  setStandardViewMode() {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.isInPictureInPictureMode() && document.exitPictureInPicture(), this.player.setViewMode(bitmovinplayerCoreExports.ViewMode.Inline);
  }
  setHasError(te) {
    this.hasError = te;
  }
  isPictureInPictureAvailable() {
    return document.pictureInPictureEnabled;
  }
  isFullscreenAvailable() {
    var te;
    return !!((te = this.player) != null && te.isViewModeAvailable(bitmovinplayerCoreExports.ViewMode.Fullscreen));
  }
  isInPictureInPictureMode() {
    return !!document.pictureInPictureElement;
  }
  isPlayerLoaded() {
    return this.loaded;
  }
  togglePictureInPicture() {
    this.setPictureInPicture(!this.isInPictureInPictureMode());
  }
  setPictureInPicture(te) {
    var ee;
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    te ? (ee = this.getVideoElement()) == null || ee.requestPictureInPicture() : document.exitPictureInPicture();
  }
  toggleFullscreen(te) {
    this.setFullscreen(!this.isInFullscreenMode(), te);
  }
  setFullscreen(te, ee) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    te ? this.player.setViewMode(bitmovinplayerCoreExports.ViewMode.Fullscreen, { fullscreenElement: ee }) : this.player.setViewMode(bitmovinplayerCoreExports.ViewMode.Inline);
  }
  getCurrentTimeInSeconds() {
    var te;
    return this.isShowingAd() && this.ima ? this.ima.getCurrentTimeInSeconds() ?? 0 : ((te = this.player) == null ? void 0 : te.getCurrentTime()) ?? 0;
  }
  getCurrentTimeInSec() {
    var ne;
    if (this.isSeeking)
      return this.currentSeekTarget;
    if (this.getPlaybackMode() === "LIVE")
      return ((ne = this.player) == null ? void 0 : ne.getTimeShift()) ?? 0;
    const te = this.getCurrentTimeInSeconds();
    if (isNaN(te))
      return 0;
    const ee = this.getDurationInSec();
    return ee !== 0 && te > ee ? ee : te;
  }
  getLastTimeChangedPlaybackTime() {
    return this.lastTimeChangedPlaybackTime;
  }
  /**
   * Returns the timestamp in milliseconds since 1970 of when the first video segment which included
   * a reference dateTimestamp. This usually is the actual start date/time of when the (now VOD) video
   * initially aired. This is important for features such as EaseLive which have specific "events"
   * at the actual play time (e.g. they show some overlay of when a goal was scored in a football match).
   * Therefore, easeLive needs accurate actual air timestamps.
   * Further note that typically only the first few segments contain a dateTime timestamp.
   */
  getLatestSegmentStartTimestamp() {
    return this.segmentStartDate;
  }
  getDurationInSec() {
    var te;
    return ((te = this.player) == null ? void 0 : te.getDuration()) ?? 0;
  }
  getMaxTimeShiftInSec() {
    var te;
    return ((te = this.player) == null ? void 0 : te.getMaxTimeShift()) ?? 0;
  }
  getTimeShiftInSec() {
    var te;
    return ((te = this.player) == null ? void 0 : te.getTimeShift()) ?? 0;
  }
  getInitialSeekTimeInSec() {
    return this.initialSeekTimeInSec;
  }
  getIsPlayRequested() {
    return this.isPlayRequested;
  }
  getShouldAutoPlay() {
    return this.shouldAutoPlay;
  }
  getCurrentSetAudioTrackIssuer() {
    return this.currentSetAudioTrackIssuer;
  }
  getCurrentSetSubtitleTrackIssuer() {
    return this.currentSetSubtitleTrackIssuer;
  }
  getMainMediaDurationInSec() {
    var te;
    return this.isShowingAd() ? this.mainMediaDurationInSec : ((te = this.player) == null ? void 0 : te.getDuration()) ?? 0;
  }
  getLastMainMediaPositionInSec() {
    return this.lastMainMediaPositionInSec;
  }
  getPlayerAdvertisingAPI() {
    return this.ima;
  }
  getAdCuePoints() {
    var te;
    return (te = this.ima) == null ? void 0 : te.getAdCuePoints();
  }
  getVideoBufferLength() {
    var te;
    return this.isSeeking ? 0 : ((te = this.player) == null ? void 0 : te.getVideoBufferLength()) ?? 0;
  }
  setPlaybackSpeed(te) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.player.setPlaybackSpeed(te);
  }
  getPlaybackSpeed() {
    var te;
    return ((te = this.player) == null ? void 0 : te.getPlaybackSpeed()) ?? 1;
  }
  async load({ source: te, initialSeekTimeInSec: ee, aspectRatio: ne }) {
    var ae, ce, he;
    this.loaded = !1, this.lastTimeChangedTimestamp = 0, this.lastPlayerEvent = void 0, this.currentSetSubtitleTrackIssuer = "INITIAL", this.currentSetAudioTrackIssuer = "INITIAL", log$5.debug("load player for instance", this.playerId, te);
    const ie = {
      hls: (te == null ? void 0 : te.mediaType) === "application/vnd.apple.mpegurl" ? te.videoUrl : void 0,
      dash: (te == null ? void 0 : te.mediaType) === "application/dash+xml" ? te.videoUrl : void 0,
      progressive: (te == null ? void 0 : te.mediaType) === "video/mp4" ? te.videoUrl : void 0,
      vr: resolveVRSourceConfig(te == null ? void 0 : te.vr)
    };
    try {
      await ((ae = this.player) == null ? void 0 : ae.unload());
    } catch (_e) {
      log$5.error("error unloading bitmovin player with data", this.playerId, _e);
    }
    log$5.debug("loading bitmovin player with data", this.playerId, ie);
    try {
      await ((ce = this.player) == null ? void 0 : ce.load(ie)), this.setVideoElementPoster(ne), this.loaded = !0, this.mainMediaDurationInSec = ((he = this.player) == null ? void 0 : he.getDuration()) ?? 0, this.initialSeekTimeInSec = ee, log$5.debug("Successfully loaded source for instance", this.playerId), this.performInitialSeekOrTimeshift(ee), this.queuedAction && (log$5.debug("have task queue after load", this.queuedAction), this.processAction(this.queuedAction), this.queuedAction = void 0), this.shouldAutoPlay && this.play().catch((_e) => {
        log$5.error("error while auto play after load", _e), this.pause();
      });
    } catch (_e) {
      throw this.loaded = !1, log$5.error("Error while loading source for instance", this.playerId, _e), new Error(`bitmovin load error ${_e}`);
    }
  }
  setVideoElementPoster(te) {
    const ee = this.getVideoElement();
    ee && (ee.poster = generateVideoTagPosterSource(te));
  }
  performInitialSeekOrTimeshift(te) {
    te > 0 && this.getPlaybackMode() === "VOD" ? this.seek(te, "INITIAL") : this.getPlaybackMode() === "LIVE" && te < 0 && this.timeShift(te, "INITIAL");
  }
  processAction(te) {
    switch (te) {
      case "PLAY":
        this.play();
        break;
      case "PAUSE":
        this.pause();
        break;
    }
  }
  mute(te = "USER") {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.player.mute(te);
  }
  pause() {
    var te;
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    if (this.isPlayRequested = !1, !this.loaded) {
      this.queuedAction = "PAUSE";
      return;
    }
    this.isShowingAd() ? (te = this.getPlayerAdvertisingAPI()) == null || te.pause() : this.player.pause();
  }
  async play() {
    var te;
    if (!this.loaded) {
      this.queuedAction = "PLAY";
      return;
    }
    if (this.hasStarted = !0, this.isPlayRequested = !0, !this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    try {
      this.isShowingAd() ? (te = this.getPlayerAdvertisingAPI()) == null || te.play() : await this.player.play();
    } catch (ee) {
      throw log$5.warn("failed to play", ee), this.isPlayRequested = !1, ee;
    }
  }
  async reset() {
    this.isInPictureInPictureMode() && this.setPictureInPicture(!1), this.setFullscreen(!1), this.hasStarted = !1, this.shouldAutoPlay = !1, this.isPlayRequested = !1, this.hasError = !1, this.queuedAction = void 0, this.lastTimeChangedTimestamp = 0, this.lastPlayerEvent = void 0, this.lastTimeChangedPlaybackTime = 0, this.currentSetAudioTrackIssuer = "INITIAL", this.currentSetSubtitleTrackIssuer = "INITIAL", this.currentSeekIssuer = void 0, this.segmentStartDate = 0, this.loaded = !1, this.destroyImaInstance(), await this.dispatchUnloadedEventAndUnload();
  }
  async dispatchUnloadedEventAndUnload() {
    var te;
    this.eventEmitter.fireEvent({
      type: "sourceUnloaded",
      playerId: this.playerId
    }), await ((te = this.player) == null ? void 0 : te.unload());
  }
  seek(te, ee) {
    if (this.getPlaybackMode() === "LIVE")
      throw new Error("cannot seek in live mode, use `timeshift` instead");
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    return this.currentSeekTarget = te, this.currentSeekIssuer = ee, this.isSeeking = !0, log$5.debug("SEEK player seek target ", this.currentSeekTarget, "is seeking", this.isSeeking), ee === "RESTART" && te === 0 && (this.lastMainMediaPositionInSec = 0, this.initialSeekTimeInSec = 0), this.player.seek(te, ee);
  }
  timeShift(te, ee = "USER") {
    var ne;
    if (!((ne = this.player) != null && ne.isLive()))
      throw new Error("player is not in live mode");
    return this.isSeeking = !0, this.currentSeekIssuer = ee, this.currentSeekTarget = this.player.getCurrentTime(bitmovinplayerCoreExports.TimeMode.AbsoluteTime) + te, this.player.timeShift(te, ee), !0;
  }
  unmute(te = "USER") {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.player.unmute(te);
  }
  async destroy() {
    this.player && (destroyDataZoomTracker(this.player), this.removeAllEventListeners(this.player)), this.destroyImaInstance(), await this.reset();
  }
  hasEnded() {
    var te;
    return this.postRollAdBreakFinished || !!((te = this.player) != null && te.hasEnded());
  }
  getPlayerStatus() {
    return this.hasError ? "ERROR" : !this.player || !this.loaded ? (log$5.info("dont have player or source not loaded"), "IDLE") : this.player.isStalled() ? "BUFFERING" : this.isPlaying() ? "PLAYING" : this.hasEnded() ? "ENDED" : this.isPlayRequested ? "BUFFERING" : this.hasStarted ? "PAUSED" : "IDLE";
  }
  isPlaying() {
    var ne, ie;
    const te = ((ne = this.player) == null ? void 0 : ne.isPlaying()) ?? !1, ee = ((ie = this.getPlayerAdvertisingAPI()) == null ? void 0 : ie.isPlaying) === !0;
    return te || ee;
  }
  mapEventAndEmit(te, ee) {
    if (!this.player)
      throw new Error("dont have player");
    const ne = mapBitmovinPlayerEvent(te, ee, this);
    log$5.debug(ee, "received bitmovin event", te, "mapped to", ne), ne && this.eventEmitter.fireEvent(ne);
  }
  checkForTimeSkipAndNotify(te) {
    var ne;
    const ee = Date.now();
    if (((ne = this.lastPlayerEvent) == null ? void 0 : ne.type) !== bitmovinplayerCoreExports.PlayerEvent.TimeChanged) {
      this.updateLastTimeChangedPlaybackTimeAndTimeStamp(te.time);
      return;
    }
    if (this.lastTimeChangedTimestamp && this.getPlaybackSpeed() === 1 && this.getPlaybackMode() === "LIVE") {
      const ie = ee - this.lastTimeChangedTimestamp, ae = te.time - this.lastTimeChangedPlaybackTime, ce = Math.abs(
        ie / 1e3 - ae
      );
      ce > 1 && (log$5.info("TIME SKIP detected", {
        previousPlaybackTimeInSec: this.lastTimeChangedPlaybackTime,
        currentPlaybackTimeInSec: te.time,
        timeSkipDurationInSec: ce
      }), this.eventEmitter.fireEvent({
        type: "timeSkipped",
        playerId: this.playerId,
        previousPlaybackTimeInSec: this.lastTimeChangedPlaybackTime,
        currentPlaybackTimeInSec: te.time
      }));
    }
    this.updateLastTimeChangedPlaybackTimeAndTimeStamp(te.time);
  }
  updateLastTimeChangedPlaybackTimeAndTimeStamp(te) {
    te && (this.lastTimeChangedTimestamp = Date.now(), this.lastTimeChangedPlaybackTime = te);
  }
  handleTimeChangedAfterEmit() {
    this.isShowingAd() || (this.lastMainMediaPositionInSec = this.getCurrentTimeInSec());
  }
  /**
   * Indicates that the current media is a live stream, and we are currently playing whatever is "live" (i.e. max -4s timeshift).
   */
  isStreamAtLivePos() {
    const te = this.player;
    return te ? te.isLive() && te.getTimeShift() >= -4 : !1;
  }
  getAvailableAudioTracks() {
    return this.player ? this.player.getAvailableAudio().filter((te) => te.lang.length) : [];
  }
  getAudioLanguage() {
    var te, ee;
    return ((ee = (te = this.player) == null ? void 0 : te.getAudio()) == null ? void 0 : ee.lang) ?? "";
  }
  getAudioLanguageId() {
    var te, ee;
    return ((ee = (te = this.player) == null ? void 0 : te.getAudio()) == null ? void 0 : ee.id) ?? "";
  }
  setAudioTrack(te, ee = "USER") {
    if (!this.player)
      throw Error("setAudioTrack: why is the player undef here?");
    this.currentSetAudioTrackIssuer = ee, this.player.setAudio(te);
  }
  getSubtitleTrackLanguage() {
    var te;
    return (te = this.getSelectedSubtitleTrack()) == null ? void 0 : te.lang;
  }
  getVolume() {
    var te, ee;
    return (te = this.player) != null && te.isMuted() ? 0 : ((ee = this.player) == null ? void 0 : ee.getVolume()) ?? 100;
  }
  setVolume(te) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    te === 0 && this.player.mute(), te > 0 && this.player.isMuted() && this.player.unmute(), this.player.setVolume(te);
  }
  /**
   * Returns actual current resolution of the playing video.
   */
  getVideoQuality() {
    if (!this.player)
      return log$5.info("dont have player"), {
        height: 0,
        width: 0
      };
    const te = this.getVideoElement();
    return {
      height: (te == null ? void 0 : te.videoHeight) ?? 0,
      width: (te == null ? void 0 : te.videoWidth) ?? 0
    };
  }
  /**
   * Returns the video quality a user has manually selected,
   * or a quality with the id of "auto" when no manual selection has been made yet.
   */
  getSelectedVideoQuality() {
    var ie;
    if (!this.player)
      return log$5.info("dont have player"), defaultVideoQuality();
    const te = this.player.getVideoQuality();
    if (te.id !== "auto")
      return { isAuto: !1, ...te };
    const ee = this.player.getPlaybackVideoData(), ne = (ie = this.getAvailableVideoQualities().find(
      (ae) => ae.id === ee.id
    )) == null ? void 0 : ie.frameRate;
    return {
      ...defaultVideoQuality(),
      height: ee.height,
      width: ee.width,
      frameRate: ne
    };
  }
  setVideoQuality(te) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.player.setVideoQuality(te);
  }
  async scheduleAd(te, ee = "vast") {
    var he;
    const ne = (he = this.player) == null ? void 0 : he.ads;
    if (!ne)
      throw new Error("dont have ad player api");
    const ie = ne.list();
    ie.length > 0 && (log$5.debug("got existing ad breaks", ie), ie.forEach((_e) => {
      ne.discardAdBreak(_e.id);
    }));
    const ae = ee === "vmap" ? bitmovinplayerAdvertisingCoreExports.AdTagType.VMAP : bitmovinplayerAdvertisingCoreExports.AdTagType.VAST, ce = {
      tag: {
        url: te,
        type: ae
      }
    };
    return log$5.debug("schedule ad ", ce), await ne.schedule(ce);
  }
  getTechVersion() {
    var te;
    return (te = this.player) == null ? void 0 : te.version;
  }
  getActualPlayerInstance() {
    return this.player;
  }
  getVideoElement() {
    var te;
    return (te = this.player) == null ? void 0 : te.getVideoElement();
  }
  enableInteractiveMediaAds(te) {
    this.destroyImaInstance(), this.ima = new InteractiveMediaAds(te, {
      playerId: this.playerId,
      eventEmitter: this.eventEmitter,
      getLastMainMediaPositionInSec: () => this.lastMainMediaPositionInSec,
      getInitialSeekTimeInSec: () => this.initialSeekTimeInSec,
      getMainMediaDurationInSec: () => this.mainMediaDurationInSec,
      resetIsSeekingToFalse: this.resetIsSeekingToFalse,
      isInFullscreenMode: this.isInFullscreenMode
    }), this.eventEmitter.addEventListener(this.handleAdBreakFinished);
  }
  destroyImaInstance() {
    this.ima && (this.ima.destroy(), this.ima = void 0, this.eventEmitter.removeEventListener(this.handleAdBreakFinished));
  }
  isVRVideo() {
    var te, ee;
    return !!((ee = (te = this.player) == null ? void 0 : te.getSource()) != null && ee.vr);
  }
  setViewingDirection(te, ee) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    if (!this.isVRVideo())
      throw new Error("trying to set viewing direction on non-VR video");
    this.player.vr.setViewingDirection({ yaw: te, pitch: ee, roll: 0 });
  }
  getViewingDirection() {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    if (!this.isVRVideo())
      throw new Error("trying to get viewing direction on non-VR video");
    const te = this.player.vr.getViewingDirection();
    return { x: te.yaw, y: te.pitch };
  }
}
function isValidSubtitleTrack(re) {
  return re.lang !== "unknown";
}
function createPlayerAdapter(re) {
  switch (re.adapterType) {
    case "BITMOVIN":
      return new BitmovinPlayerAdapter(re);
    case "SIMULATION":
      return new SimulationPlayerAdapter(re);
    default:
      throw new Error(`unknown player adapter type ${re.adapterType}`);
  }
}
function convertToServiceEnablement(re, te) {
  return re === void 0 ? te : re;
}
function resolveGoogleAnalyticsConfig(re) {
  return {
    ...re,
    defaultPlayerMode: re.defaultPlayerMode ?? "standard",
    customInitAttributes: re.customInitAttributes ?? {},
    dataLayer: re.dataLayer ?? window.dataLayer
  };
}
function resolveTrackingSettings(re) {
  var ce;
  const te = re.configs, ee = re.services;
  if ((ee == null ? void 0 : ee.dataZoom) === "ACTIVE") {
    if (!((ce = te.dataZoom) != null && ce.configId))
      throw new Error("cannot enable dataZoom without a configuration id");
    if (!te.dataZoom.assetId)
      throw new Error("cannot enable dataZoom without an assetId");
  }
  const ie = {
    googleAnalytics: convertToServiceEnablement(ee == null ? void 0 : ee.googleAnalytics, "ACTIVE"),
    dataZoom: convertToServiceEnablement(ee == null ? void 0 : ee.dataZoom, "INACTIVE")
  }, ae = {
    ...te,
    googleAnalytics: resolveGoogleAnalyticsConfig(te.googleAnalytics)
  };
  return {
    ...re,
    configs: ae,
    services: ie
  };
}
function getValueOrDefault(re, te) {
  return re ?? te;
}
function resolvePlayerDataConfiguration(re) {
  const te = getValueOrDefault(re.autoplay, !1), ee = getValueOrDefault(re.cookieConsent, !1), ne = te ? "MUTED" : "NOT_MUTED", ie = getValueOrDefault(re.feedbackUrl, DEFAULT_FEEDBACK_URL), ae = getValueOrDefault(re.initialSeekTimeInSec, 0), ce = getValueOrDefault(re.muted, ne), he = getValueOrDefault(re.phasing, !1), _e = getValueOrDefault(re.sharingEnabled, !0), le = getValueOrDefault(re.environment, "PRODUCTION"), se = getValueOrDefault(re.productPlacement, "hidden"), oe = getValueOrDefault(re.adMarkerEnabled, "INACTIVE");
  return {
    ...re,
    autoplay: te,
    adMarkerEnabled: oe,
    configurationType: "VIDEO",
    cookieConsent: ee,
    environment: le,
    feedbackUrl: ie,
    hooks: re.hooks ?? [],
    initialSeekTimeInSec: ae,
    muted: ce,
    phasing: he,
    productPlacement: se,
    sharingEnabled: _e,
    tracking: resolveTrackingSettings(re.tracking)
  };
}
const log$4 = loglevelExports.getLogger("VideoPlayerCoordinator"), creationStats = {};
function printCreationStats() {
  log$4.debug("Creation Stats", creationStats);
}
const OBSERVED_DOM_EVENT_TYPES = [RBUP_AUDIO_DOM_EVENT_TYPE, RBUP_VIDEO_DOM_EVENT_TYPE];
class VideoPlayerCoordinator {
  constructor(te) {
    Et(this, "playerId");
    Et(this, "urlSharingStrategy");
    Et(this, "dataLoader");
    Et(this, "adService");
    Et(this, "eventEmitter");
    Et(this, "player");
    Et(this, "phasingService");
    Et(this, "storageService");
    Et(this, "hookService");
    Et(this, "thumbnailService");
    Et(this, "trackingService");
    Et(this, "mediaSessionService");
    Et(this, "dispatchElement");
    Et(this, "playerConfig");
    Et(this, "_fullscreenElement");
    Et(this, "currentErrorDetails");
    Et(this, "lastPlaybackPosition", 0);
    Et(this, "cumulatedPlayTimeInSec", 0);
    Et(this, "mediaMetaData");
    /** If a seek attempt happens during an ad is playing back the position will be stored and used to execute seek after the ad has finished. */
    Et(this, "storedSeekOrTimeShift");
    Et(this, "HdPlaybackHeightThreshold", 700);
    Et(this, "liveStatus");
    Et(this, "loaded", !1);
    Et(this, "destroyed", !1);
    Et(this, "instanceId", v4());
    Et(this, "lastRequestedVolume", 100);
    Et(this, "stopped", !1);
    // eslint-disable-next-line complexity
    Et(this, "genericListener", (te) => {
      switch (te.type) {
        case "loaded":
          this.handleLoadedEvent(te), this.dispatchDomEvent(te, document);
          break;
        case "playing":
          this.handlePlayingEvent(te);
          break;
        case "timeChanged":
          this.handleTimeChangedEvent(te);
          break;
        case "seekingDone":
          this.handleSeekingEvent(te);
          break;
        case "timeshiftingDone":
          this.handleTimeshiftingDoneEvent(te);
          break;
        case "play":
          this.dispatchDomEvent(te, document);
          break;
        case "error":
          this.handlePlayerOrDataError(te);
          break;
        case "liveStatusChanged":
          this.handleLiveStatusChanged(te);
          break;
        case "adBreakFinished":
          this.handleAdBreakFinished(te);
          break;
        case "timeSkipped":
          this.handleTimeSkippedEvent(te);
          break;
      }
      this.dispatchDomEvent(te);
    });
    Et(this, "domEventListener", (te) => {
      if (!OBSERVED_DOM_EVENT_TYPES.includes(te.type))
        return;
      const ne = te.detail;
      if (ne.playerId === this.playerId)
        return;
      const ie = this.getPlayerStatus();
      ne.type === "play" && !["IDLE", "PAUSED"].includes(ie) && (log$4.debug("received play event from player", ne.playerId, "pausing"), this.pause());
    });
    var ae, ce;
    this.playerId = te.playerId;
    const ee = creationStats[this.playerId] ?? { createCount: 0, destroyCount: 0 };
    ee.createCount += 1, creationStats[this.playerId] = ee, printCreationStats(), this.eventEmitter = te.eventEmitter ?? new EventEmitter$1(), this.dataLoader = te.dataLoader, this.dispatchElement = te.dispatchElement, this.urlSharingStrategy = te.urlSharingStrategy, this.adService = te.adService;
    const ne = resolvePlayerDataConfiguration(te.config), ie = ((ae = te.config._debug) == null ? void 0 : ae.playerAdapterType) ?? "BITMOVIN";
    if (this.playerConfig = ne, this.phasingService = te.phasingService, this.thumbnailService = te.config.thumbnailService ?? te.thumbnailService, this.hookService = new HookService(
      te.config.hooks ?? []
    ), !te.config.assetId)
      throw new Error("no asset id");
    log$4.debug("created coordinator", this.playerId, this.instanceId, ee), this.player = createPlayerAdapter({
      adapterType: ie,
      adService: te.adService,
      muted: ne.muted,
      playerId: te.playerId,
      element: te.divElement,
      eventEmitter: this.eventEmitter,
      autoplay: ne.autoplay,
      enableDataZoom: ne.tracking.services.dataZoom,
      dataZoomConfig: ne.tracking.configs.dataZoom,
      customVideoUrlRequestHeader: (ce = te.config._debug) == null ? void 0 : ce.customVideoUrlRequestHeader
    }), this.addEventListener(this.genericListener), ne.tracking.services.googleAnalytics === "ACTIVE" && (this.trackingService = createTrackingService(
      this,
      ne.tracking.configs.googleAnalytics.dataLayer
    )), this.mediaSessionService = new MediaSessionService(this), document.addEventListener(RBUP_VIDEO_DOM_EVENT_TYPE, this.domEventListener), document.addEventListener(RBUP_AUDIO_DOM_EVENT_TYPE, this.domEventListener);
  }
  get fullscreenElement() {
    return this._fullscreenElement;
  }
  set fullscreenElement(te) {
    this._fullscreenElement = te;
  }
  get isAirPlayAvailable() {
    return this.player.isAirPlayAvailable();
  }
  get isVideoLoaded() {
    return this.loaded;
  }
  addEventListener(te) {
    this.eventEmitter.addEventListener(te);
  }
  async destroy() {
    var ee, ne, ie;
    this.loaded = !1, this.destroyed = !0;
    const te = creationStats[this.playerId] ?? { createCount: 0, destroyCount: 0 };
    te.destroyCount += 1, creationStats[this.playerId] = te, printCreationStats(), document.removeEventListener(RBUP_VIDEO_DOM_EVENT_TYPE, this.domEventListener), document.removeEventListener(RBUP_AUDIO_DOM_EVENT_TYPE, this.domEventListener);
    try {
      (ee = this.phasingService) == null || ee.stop(), (ne = this.trackingService) == null || ne.destroy(), this.mediaSessionService.destroy(), (ie = this.storageService) == null || ie.destroy();
      const ae = this.playerConfig, ce = this.mediaMetaData;
      await this.hookService.beforeDestroy(ae, ce, this), this.storageService = void 0;
    } catch (ae) {
      const ce = resolveErrorMessageFromUnknown(ae);
      log$4.warn(
        "error destroying player adapter services for player",
        this.playerId,
        this.instanceId,
        ce
      );
    }
    try {
      await this.player.destroy(), log$4.debug("done destroying coordinator", this.playerId, this.instanceId);
    } catch (ae) {
      const ce = resolveErrorMessageFromUnknown(ae);
      log$4.warn("error destroying player adapter for player", this.playerId, this.instanceId, ce);
    }
  }
  canSeekOrTimeshiftBackward() {
    return this.player.canSeekOrTimeshiftBackward();
  }
  canSeekOrTimeshiftForward() {
    return this.player.canSeekOrTimeshiftForward();
  }
  canPlayVideo() {
    var te, ee;
    return !!((ee = (te = this.getMediaMetaData()) == null ? void 0 : te.mediaSrc) != null && ee.videoUrl);
  }
  disableSubtitle(te = "USER") {
    return this.player.disableSubtitle(te);
  }
  enableSubtitle(te, ee = "USER") {
    return this.player.enableSubtitle(te, ee);
  }
  getAvailableAudioTracks() {
    return this.player.getAvailableAudioTracks();
  }
  getSelectedAudioTrack() {
    const te = this.getAvailableAudioTracks(), ee = this.player.getAudioLanguageId();
    return te.find((ne) => ne.id === ee);
  }
  getAvailableVideoQualities() {
    return this.player.getAvailableVideoQualities();
  }
  getSubtitleTracks() {
    return this.player.getAvailableSubtitleTracks();
  }
  getSelectedSubtitleTrack() {
    return this.player.getSelectedSubtitleTrack();
  }
  getCumulatedPlayTimeInSec() {
    return this.cumulatedPlayTimeInSec;
  }
  getCurrentErrorDetails() {
    return this.currentErrorDetails;
  }
  getDurationInSec() {
    return this.player.getDurationInSec();
  }
  /**
   * Returns the timestamp in milliseconds since 1970 of when the first video segment which included
   * a reference dateTimestamp. This usually is the actual start date/time of when the (now VOD) video
   * initially aired. This is important for features such as EaseLive which have specific "events"
   * at the actual play time (e.g. they show some overlay of when a goal was scored in a football match).
   * Therefore, easeLive needs accurate actual air timestamps.
   * Further note that typically only the first few segments contain a dateTime timestamp.
   */
  getLatestSegmentStartTimestamp() {
    return this.player.getLatestSegmentStartTimestamp();
  }
  getMaxTimeShiftInSec() {
    return this.player.getMaxTimeShiftInSec();
  }
  getTimeShiftInSec() {
    return this.player.getTimeShiftInSec();
  }
  getLiveStatus() {
    return this.liveStatus;
  }
  getMediaMetaData() {
    return this.mediaMetaData;
  }
  getPlaybackSpeed() {
    return this.player.getPlaybackSpeed();
  }
  getPlayerConfiguration() {
    const te = this.playerConfig;
    if (!te)
      throw new Error("dont have player config yet!");
    return te;
  }
  getPlayerStatus() {
    return this.player.getPlayerStatus();
  }
  getSelectedVideoQuality() {
    return this.player.getSelectedVideoQuality();
  }
  getBufferLengthInSec() {
    return this.player.getVideoBufferLength();
  }
  getPlayerData() {
    return this.player;
  }
  getVideoQuality() {
    return this.player.getVideoQuality();
  }
  getVolume() {
    return this.player.getVolume();
  }
  isFullscreenAvailable() {
    return this.player.isFullscreenAvailable() && !!this.fullscreenElement;
  }
  isInFullscreenMode() {
    return this.player.isInFullscreenMode();
  }
  isHdPlayback() {
    return this.getVideoQuality().height > this.HdPlaybackHeightThreshold;
  }
  /**
   * Returns the current variant for `'LIVE'`.
   */
  getLiveVariant() {
    return this.player.getLiveVariant();
  }
  /**
   * Returns the current player mode in which we are in. This has far-reaching consequences on `seek` vs. `timeshift`.
   * Note that in the case of Phasing (specifically in those phases where we don't have a videoUrl yet, such as PRE)
   * we won't know for certain what the playback mode will be.
   */
  getPlaybackMode() {
    return this.player.getPlaybackMode();
  }
  /**
   * Determines whether we enable live status phasing. This means we will poll the live status for the stream
   * on the server and show an "upcoming in x minutes" UI in case the video is not yet live.
   */
  isPhasingEnabled() {
    var te;
    return ((te = this.playerConfig) == null ? void 0 : te.phasing) ?? !1;
  }
  isPictureInPictureAvailable() {
    return this.player.isPictureInPictureAvailable();
  }
  async setThumbnail(te, ee, ne) {
    return this.thumbnailService.setThumbnail(te, ee, ne);
  }
  handleInvalidLoadCall(te) {
    if (!te)
      throw new Error("no player config provided yet, cannot load");
    if (!this.dataLoader)
      throw new Error("no data loader provided");
    if (!this.player)
      throw new Error("no player is active");
  }
  async load(te, ee = !1) {
    var ie, ae;
    this.handleInvalidLoadCall(te), this.loaded = !1, (ie = this.phasingService) == null || ie.stop();
    const ne = resolvePlayerDataConfiguration(te);
    this.playerConfig = ne, fetchBrowserOrConfiguredTranslationLanguage(te.overrideTranslationLanguage);
    try {
      const ce = await this.doLoadMetadata(ee, ne);
      this.mediaMetaData = ce;
      try {
        this.playerConfig = await this.hookService.beforeLoad(this.playerConfig, ce, this);
      } catch (he) {
        log$4.warn("preloadHook failed, carrying on without it, error", he);
      }
      if (this.playerConfig.phasing) {
        const he = await this.handleLiveStreamPhasingOnLoad(this.playerConfig, ce);
        if (log$4.debug("phasing: live stream response", ce, "should load", he), !he)
          return;
      }
      return ((ae = ce.playabilityErrors) == null ? void 0 : ae.length) ?? !this.canPlayVideo() ? (this.eventEmitter.fireEvent({ type: "error", playerId: this.playerId, code: "SERVER_ERROR" }), ce) : (ce.thumbnailSprites && this.thumbnailService.setThumbnailSprites(ce.thumbnailSprites), await this.doLoadAndScheduleAd(ce, this.playerConfig));
    } catch (ce) {
      const he = resolveErrorMessageFromUnknown(ce);
      log$4.error("error during load", he);
      const _e = he.includes("403") ? "NOT_AUTHORIZED" : "DATA_NOT_LOADED";
      this.handlePlayerOrDataError({ type: "error", playerId: this.playerId, code: _e });
      return;
    }
  }
  async doLoadMetadata(te, ee) {
    var ie, ae;
    let ne = await this.dataLoader.loadData(ee);
    return log$4.debug("got SSDM metadata", ne), te && !((ie = ne.mediaSrc) != null && ie.videoUrl) && ((ae = ne.playabilityErrors) != null && ae.includes("NOT_YET_AVAILABLE")) && (await sleep(5e3), log$4.warn(
      "got player data without video url when expecting it!",
      ne,
      "new livestatus",
      this.getLiveStatus()
    ), ne = await this.dataLoader.loadData(ee, !0)), ne;
  }
  initStorageService(te, ee, ne, ie) {
    var he;
    const ae = new AudioLanguageResolver(te, ee, ne, ie), ce = new AudioVolumeResolver(ee);
    (he = this.storageService) == null || he.destroy(), this.storageService = void 0, this.storageService = new StorageService(this, ae, ce), this.storageService.load();
  }
  getStorageServiceAllStoredValues() {
    var te;
    return (te = this.storageService) == null ? void 0 : te.getAllStoredValues();
  }
  async handleLiveStreamPhasingOnLoad(te, ee) {
    if (!this.phasingService)
      return log$4.warn("no phasing service but config says livestream %o", te), !0;
    const ne = await this.phasingService.start(te, ee);
    return ne.shouldKeepPolling || this.phasingService.stop(), this.liveStatus = ne.liveStatus, ne.shouldLoadPlayer;
  }
  async doLoadAndScheduleAd(te, ee) {
    var ae;
    if (!te.mediaSrc)
      return;
    const ne = {
      ...te.mediaSrc,
      vr: te.vr
    }, ie = te.aspectRatio ?? 16 / 9;
    await this.player.load({
      source: ne,
      initialSeekTimeInSec: ee.initialSeekTimeInSec,
      aspectRatio: ie
    }), this.loaded = !0;
    try {
      const ce = ee.assetId;
      await ((ae = this.adService) == null ? void 0 : ae.scheduleAd(this.player, ce, te));
    } catch (ce) {
      log$4.warn("error during scheduleAd, carrying on anyway", ce);
    }
    try {
      this.playerConfig = await this.hookService.afterLoad(ee, te, this);
    } catch (ce) {
      log$4.warn("onAfterLoad hook failed, carrying on without it, error", ce);
    }
    return this.eventEmitter.fireEvent({ type: "loaded", playerId: this.playerId, data: te }), te;
  }
  pause() {
    return this.player.pause();
  }
  async stop() {
    await this.player.reset(), await this.hookService.beforeDestroy(this.playerConfig, this.mediaMetaData, this), this.reset(), this.stopped = !0;
  }
  async play() {
    if (!this.canPlayVideo())
      throw new Error("no playable video source detected!");
    return this.stopped && (this.stopped = !1, await this.load(this.playerConfig, !0)), this.eventEmitter.fireEvent({ type: "beforePlay", playerId: this.playerId }), this.player.play();
  }
  playVideoViaAirPlay() {
    this.player.playVideoViaAirPlay();
  }
  removeEventListener(te) {
    this.eventEmitter.removeEventListener(te);
  }
  reset() {
    var te;
    this.cumulatedPlayTimeInSec = 0, this.lastPlaybackPosition = 0, this.storedSeekOrTimeShift = void 0, (te = this.trackingService) == null || te.reset(), this.mediaSessionService.reset();
  }
  restartPlaybackFromBeginning() {
    this.reset(), this.player.seek(0, "RESTART");
  }
  seek(te) {
    return this.player.isShowingAd() ? (this.storedSeekOrTimeShift = {
      position: te,
      seekHandler: "SEEK"
    }, !1) : this.player.seek(te, "USER");
  }
  seekOrTimeshiftRelative(te) {
    const ee = this.player;
    if (this.getPlaybackMode() === "LIVE") {
      const ne = ee.getTimeShiftInSec(), ie = Math.min(0, ne + te);
      return ee.timeShift(ie, "USER"), !0;
    }
    return this.seekRelative(te);
  }
  seekRelative(te) {
    const ee = this.player, ne = ee.getCurrentTimeInSec(), ie = ee.getDurationInSec(), ae = Math.min(ne + te, ie), ce = Math.max(0, ae);
    return ee.seek(ce, "USER");
  }
  setAudioTrack(te, ee = "USER") {
    this.player.setAudioTrack(te, ee);
  }
  setPlaybackSpeed(te) {
    this.player.setPlaybackSpeed(te);
  }
  timeShift(te) {
    this.player.isShowingAd() ? this.storedSeekOrTimeShift = {
      position: te,
      seekHandler: "TIMESHIFT"
    } : this.player.timeShift(te, "USER");
  }
  toggleFullscreen() {
    !this.player.isInFullscreenMode() && this.player.isInPictureInPictureMode() && this.player.setPictureInPicture(!1), this.player.toggleFullscreen(this.fullscreenElement);
  }
  setFullscreen(te) {
    this.player.setFullscreen(te, this.fullscreenElement);
  }
  togglePictureInPicture() {
    this.player.isInFullscreenMode() && this.player.setFullscreen(!1, this.fullscreenElement), this.player.togglePictureInPicture();
  }
  isInPictureInPictureMode() {
    return this.player.isInPictureInPictureMode();
  }
  setVideoQuality(te) {
    this.player.setVideoQuality(te);
  }
  setVolume(te) {
    te > 0 && (this.lastRequestedVolume = te), this.player.setVolume(te);
  }
  setMuted(te) {
    this.player.setVolume(te ? 0 : this.lastRequestedVolume);
  }
  isMuted() {
    return this.getVolume() === 0;
  }
  dispatchDomEvent(te, ee = this.dispatchElement.parentElement ?? void 0) {
    const ne = new CustomEvent(RBUP_VIDEO_DOM_EVENT_TYPE, { detail: te });
    log$4.debug("dispatching DOM event", ne), ee == null || ee.dispatchEvent(ne);
  }
  dispatchPlayerEvent(te) {
    this.eventEmitter.fireEvent(te);
  }
  async handleNonPlayableLiveStatusPhase() {
    this.isInFullscreenMode() && this.setFullscreen(!1), this.loaded = !1, this.reset(), await this.player.reset();
  }
  handleLiveStatusChanged(te) {
    const { liveStatus: ee } = te;
    this.liveStatus = ee, (async () => {
      var ae, ce;
      log$4.info("live status changed", ee);
      const ie = (ae = this.phasingService) == null ? void 0 : ae.isPlayablePhase(ee.phase);
      !this.loaded && this.playerConfig && ie ? await this.load(this.playerConfig, !0) : this.loaded && (ie ? ee.phase === "post" && (log$4.debug("stopping phasing service as we are in POST"), (ce = this.phasingService) == null || ce.stop()) : await this.handleNonPlayableLiveStatusPhase());
    })();
  }
  handleLoadedEvent(te) {
    this.lastPlaybackPosition = 0, this.cumulatedPlayTimeInSec = 0;
    const ee = this.playerConfig, ne = this.getMediaMetaData(), ie = this.getAvailableAudioTracks(), ae = this.getSubtitleTracks();
    ee && ne && (ie.length > 0 || ae.length > 0 ? this.initStorageService(ne, ee, ie, ae) : setTimeout(() => {
      const ce = this.getAvailableAudioTracks(), he = this.getSubtitleTracks();
      this.initStorageService(
        ne,
        ee,
        ce,
        he
      );
    }, 300));
  }
  handleAdBreakFinished(te) {
    if (this.getPlaybackMode() === "LIVE" && (this.lastPlaybackPosition = 0), this.storedSeekOrTimeShift) {
      switch (this.storedSeekOrTimeShift.seekHandler) {
        case "SEEK":
          this.seek(this.storedSeekOrTimeShift.position);
          break;
        case "TIMESHIFT":
          this.timeShift(this.storedSeekOrTimeShift.position);
          break;
      }
      this.storedSeekOrTimeShift = void 0;
    }
  }
  handleTimeSkippedEvent(te) {
    this.getPlaybackMode() === "LIVE" && (this.lastPlaybackPosition = te.currentPlaybackTimeInSec);
  }
  handlePlayingEvent(te) {
    this.player.getPlaybackMode() === "LIVE" && (this.lastPlaybackPosition = te.playbackPosition);
  }
  handleTimeChangedEvent(te) {
    this.player.isShowingAd() || (this.player.getPlaybackMode() === "LIVE" && this.lastPlaybackPosition === 0 && (this.lastPlaybackPosition = te.playbackPosition), this.cumulatedPlayTimeInSec += te.playbackPosition - this.lastPlaybackPosition, this.lastPlaybackPosition = te.playbackPosition);
  }
  handleSeekingEvent(te) {
    this.lastPlaybackPosition = te.playbackPosition;
  }
  handleTimeshiftingDoneEvent(te) {
    this.lastPlaybackPosition = te.playbackPosition;
  }
  handlePlayerOrDataError(te) {
    const ee = te.code;
    ee === "SERVER_ERROR" && this.mediaMetaData ? this.currentErrorDetails = {
      serverErrorDetails: {
        playabilityErrors: this.mediaMetaData.playabilityErrors ?? [],
        playabilityErrorDetails: this.mediaMetaData.playabilityErrorDetails
      }
    } : ee ? this.currentErrorDetails = { playerErrorCode: ee } : this.currentErrorDetails = { serverErrorDetails: te }, this.player.getPlayerStatus() === "PLAYING" && this.player.pause(), this.player.setHasError(!0);
  }
  getPosterImage() {
    var te, ee, ne;
    if (this.isMediaDataLoadedOrError())
      return ((te = this.playerConfig) == null ? void 0 : te.posterImageUrl) ?? ((ee = this.mediaMetaData) == null ? void 0 : ee.posterImageUrl) ?? ((ne = this.playerConfig) == null ? void 0 : ne.customFallbackPosterImageUrl) ?? RBUP_FALLBACK_POSTER_IMAGE;
  }
  isMediaDataLoadedOrError() {
    return !!this.mediaMetaData || !!this.currentErrorDetails;
  }
  getTechVersion() {
    return this.player.getTechVersion();
  }
  getAspectRatio() {
    var te;
    return ((te = this.mediaMetaData) == null ? void 0 : te.aspectRatio) ?? 16 / 9;
  }
  shouldShowProductPlacement() {
    var ee, ne;
    const te = ((ee = this.playerConfig) == null ? void 0 : ee.productPlacement) === "visible";
    return te || !!((ne = this.getMediaMetaData()) != null && ne.showProductPlacement);
  }
  getAdCuePoints() {
    return this.player.getAdCuePoints();
  }
}
const Lt = class Lt {
  static setPlayerStatus(te) {
    Lt.staticPlayerStatus = te;
  }
  constructor(te) {
    Lt.staticOptions = te;
  }
  getPreviousAudioLanguage() {
  }
  getCurrentSetAudioTrackIssuer() {
  }
  getCurrentSetSubtitleTrackIssuer() {
  }
  isInPictureInPictureMode() {
    return !1;
  }
  isPlayingVideoViaAirPlay() {
    return !1;
  }
  getAvailableAudioTracks() {
    return [
      {
        id: "audio/mp4-1",
        lang: "en",
        label: "English"
      },
      {
        id: "audio/mp4-2",
        lang: "ja",
        label: "日本語"
      },
      {
        id: "audio/mp4-3",
        lang: "de",
        label: "Deutsch"
      },
      {
        id: "audio/mp4-4",
        lang: "es",
        label: "español"
      }
    ];
  }
  setAudioTrack(te, ee) {
  }
  getAvailableSubtitleTracks() {
    return [
      {
        id: "application/mp4-5",
        lang: "en-US",
        label: "English (US)"
      },
      {
        id: "application/mp4-6",
        lang: "el-GR",
        label: "Ελληνικά (GR)"
      },
      {
        id: "application/mp4-7",
        lang: "pl-PL",
        label: "polski (PL)"
      },
      {
        id: "application/mp4-8",
        lang: "pt-BR",
        label: "português (BR)"
      }
    ];
  }
  getPlayerType() {
    return "VIDEO";
  }
  getSelectedSubtitleTrack() {
  }
  disableSubtitle(te) {
  }
  enableSubtitle(te, ee) {
  }
  timeShift(te, ee = "USER") {
    return !1;
  }
  canSeekOrTimeshiftBackward() {
    return !1;
  }
  canSeekOrTimeshiftForward() {
    return !1;
  }
  getMaxTimeShiftInSec() {
    return MIN_TIMESHIFT_FOR_DVR_SECS;
  }
  getTimeShiftInSec() {
    return -10;
  }
  isStream() {
    return !1;
  }
  mute() {
  }
  pause() {
  }
  async play() {
  }
  seek(te, ee) {
    return !1;
  }
  unmute() {
  }
  async load(te) {
  }
  async destroy() {
  }
  async reset() {
  }
  getPlaybackMode() {
    return "VOD";
  }
  getLiveVariant() {
    return "DVR";
  }
  getAvailableVideoQualities() {
    return [
      {
        bitrate: 535114,
        height: 240,
        id: "240_639293",
        width: 426,
        frameRate: 25
      },
      {
        bitrate: 889212,
        height: 360,
        id: "360_1057509",
        width: 640,
        frameRate: 25
      },
      {
        bitrate: 1594819,
        height: 540,
        id: "540_1966184",
        width: 960,
        frameRate: 25
      },
      {
        bitrate: 3057048,
        height: 720,
        id: "720_3752211",
        width: 1280,
        frameRate: 25
      },
      {
        bitrate: 6154006,
        height: 1080,
        id: "1080_7560397",
        width: 1920,
        frameRate: 25
      }
    ];
  }
  getSelectedVideoQuality() {
    return { height: 1920, width: 1080, id: "1080_7560397", bitrate: 2e3, isAuto: !1 };
  }
  getVideoQuality() {
    return { height: 1900, width: 1280 };
  }
  setVideoQuality(te) {
  }
  getPlayerStatus() {
    return Lt.staticPlayerStatus;
  }
  getCurrentTimeInSeconds() {
    return 0;
  }
  getCurrentTimeInSec() {
    return Lt.staticCurrentTime;
  }
  static setCurrentTime(te) {
    Lt.staticCurrentTime = te;
  }
  getLastTimeChangedPlaybackTime() {
    return 0;
  }
  getLatestSegmentStartTimestamp() {
    return 0;
  }
  getDurationInSec() {
    return Lt.staticDurationInSec;
  }
  static setDurationInSec(te) {
    Lt.staticDurationInSec = te;
  }
  getVolume() {
    return 1;
  }
  setVolume(te) {
  }
  setHasError(te) {
  }
  isPictureInPictureAvailable() {
    return !0;
  }
  isFullscreenAvailable() {
    return !0;
  }
  isInFullscreenMode() {
    return !1;
  }
  togglePictureInPicture() {
  }
  setPictureInPicture(te) {
  }
  toggleFullscreen(te) {
  }
  setFullscreen(te, ee) {
  }
  getVideoBufferLength() {
    return Lt.staticBufferLength;
  }
  static setVideoBufferLength(te) {
    Lt.staticBufferLength = te;
  }
  isAirPlayAvailable() {
    return !1;
  }
  isPlayerLoaded() {
    return !1;
  }
  playVideoViaAirPlay() {
  }
  setPlaybackSpeed(te) {
  }
  getPlaybackSpeed() {
    return 1;
  }
  isStreamAtLivePos() {
    return !1;
  }
  getPlayerMode() {
    return "standard";
  }
  getAudioLanguage() {
    return "en";
  }
  getAudioLanguageId() {
    return "audio/mp4-1";
  }
  getSubtitleTrackLanguage() {
  }
  async scheduleAd(te, ee) {
  }
  getInitialSeekTimeInSec() {
    return 0;
  }
  getMainMediaDurationInSec() {
    return 100;
  }
  getLastMainMediaPositionInSec() {
    return 0;
  }
  isShowingAd() {
    return !1;
  }
  getTechVersion() {
    return "1.0.0";
  }
  getActualPlayerInstance() {
    return {};
  }
  getActiveAdId() {
    return "adId";
  }
  getActiveAdTitle() {
    return "adTitle";
  }
  enableInteractiveMediaAds(te) {
  }
  getViewingDirection() {
    return { x: 0, y: 0 };
  }
  setViewingDirection(te, ee) {
  }
  isVRVideo() {
    return !1;
  }
  getAdCuePoints() {
  }
};
Et(Lt, "staticPlayerStatus", "IDLE"), Et(Lt, "staticOptions"), Et(Lt, "staticCurrentTime", 0), Et(Lt, "staticDurationInSec", 42), Et(Lt, "staticBufferLength", 1);
let SimulationPlayerAdapter = Lt;
const defaultUrlSharingStrategy = new QueryParamUrlSharingStrategy();
function createPlayerCoordinator({
  adService: re,
  config: te,
  dataLoader: ee,
  dispatchElement: ne,
  divElement: ie,
  playerId: ae,
  urlSharingStrategy: ce,
  eventEmitter: he,
  phasingService: _e,
  thumbnailService: le
}) {
  return new VideoPlayerCoordinator({
    playerId: ae,
    divElement: ie,
    dispatchElement: ne,
    dataLoader: ee,
    eventEmitter: he,
    phasingService: _e,
    urlSharingStrategy: ce ?? defaultUrlSharingStrategy,
    config: te,
    adService: re,
    thumbnailService: le
  });
}
const publicPlayerEventTypesAsString = publicPlayerEventTypes, log$3 = loglevelExports.getLogger("CoreApi");
function assertPlayerLoaded(re) {
  if (!re)
    throw new Error("dont have coordinator");
  if (!re.isVideoLoaded)
    throw new Error("no video loaded yet");
}
function pushListener(re, te) {
  const ee = re.current;
  ee && !ee.includes(te) && ee.push(te);
}
function useCoreApi(re, te, ee, ne) {
  const ie = _(!1), ae = F$1(() => ({
    isReady() {
      return (re == null ? void 0 : re.isVideoLoaded) ?? !1;
    },
    async play() {
      return assertPlayerLoaded(re), re == null ? void 0 : re.play();
    },
    async stop() {
      return assertPlayerLoaded(re), re == null ? void 0 : re.stop();
    },
    pause() {
      assertPlayerLoaded(re), re == null || re.pause();
    },
    seek(le) {
      assertPlayerLoaded(re), re == null || re.seek(le);
    },
    timeShift(le) {
      assertPlayerLoaded(re), re == null || re.timeShift(le);
    },
    getPlaybackMode() {
      return assertPlayerLoaded(re), (re == null ? void 0 : re.getPlaybackMode()) ?? "UNKNOWN";
    },
    setFullscreen(le) {
      assertPlayerLoaded(re), re == null || re.setFullscreen(le);
    },
    isFullscreen() {
      return assertPlayerLoaded(re), (re == null ? void 0 : re.isInFullscreenMode()) ?? !1;
    },
    getStatus() {
      return assertPlayerLoaded(re), (re == null ? void 0 : re.getPlayerStatus()) ?? "IDLE";
    },
    getCurrentTime() {
      var le;
      return assertPlayerLoaded(re), ((le = re == null ? void 0 : re.getPlayerData()) == null ? void 0 : le.getCurrentTimeInSec()) ?? 0;
    },
    getDuration() {
      var le;
      return assertPlayerLoaded(re), ((le = re == null ? void 0 : re.getPlayerData()) == null ? void 0 : le.getDurationInSec()) ?? 0;
    },
    getCurrentTimeOfMainVideo() {
      var le;
      return assertPlayerLoaded(re), ((le = re == null ? void 0 : re.getPlayerData()) == null ? void 0 : le.getLastMainMediaPositionInSec()) ?? 0;
    },
    getDurationOfMainVideo() {
      var le;
      return assertPlayerLoaded(re), ((le = re == null ? void 0 : re.getPlayerData()) == null ? void 0 : le.getMainMediaDurationInSec()) ?? 0;
    },
    getCurrentTimeshift() {
      return assertPlayerLoaded(re), (re == null ? void 0 : re.getTimeShiftInSec()) ?? 0;
    },
    getMaxTimeshift() {
      return assertPlayerLoaded(re), (re == null ? void 0 : re.getMaxTimeShiftInSec()) ?? 0;
    },
    setMuted(le) {
      assertPlayerLoaded(re), re == null || re.setMuted(le);
    },
    isMuted() {
      return assertPlayerLoaded(re), (re == null ? void 0 : re.isMuted()) ?? !1;
    },
    setVolume(le) {
      assertPlayerLoaded(re), re == null || re.setVolume(le);
    },
    getVolume() {
      return assertPlayerLoaded(re), (re == null ? void 0 : re.getVolume()) ?? 100;
    },
    addEventListener(le) {
      pushListener(ne, le);
    },
    removeEventListener(le) {
      var oe, ue;
      const se = (oe = ne.current) == null ? void 0 : oe.findIndex((be) => be === le);
      se !== void 0 && ((ue = ne.current) == null || ue.splice(se, 1));
    }
  }), [re, ne]);
  A$1(te, () => ae, [ae]);
  const ce = re == null ? void 0 : re.isVideoLoaded, he = re == null ? void 0 : re.getCurrentErrorDetails();
  return p(() => {
    const _e = re;
    log$3.debug("coreApi", { coordinator: _e, apiAvailable: ee, videoLoaded: ce }), _e && !ie.current && ee && (ie.current = !0, log$3.debug("coreApi invoking apiAvailable", { coordinator: _e, apiAvailable: ee, videoLoaded: ce }), he ? ee.reject(he) : ee.resolve(ae));
  }, [ee, ae, ce, re, he]), F$1(() => (le) => {
    if (publicPlayerEventTypesAsString.includes(le.type)) {
      const se = ne.current ?? [];
      for (const oe of se)
        try {
          oe(le);
        } catch (ue) {
          log$3.error("error invoking public event listener", ue);
        }
    }
  }, [ne]);
}
const cosmosFonts = `@font-face{font-family:Bull Text;font-style:normal;font-weight:400;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:500;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff) format("woff")}@font-face{font-family:Bull VF;font-style:normal;font-weight:300 800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2-variations"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2")}
`, playablePhases = ["live", "post"];
function isPlayablePhase(re) {
  return playablePhases.includes(re);
}
const log$2 = loglevelExports.getLogger("PhasingService"), MIN_TO_MS = 6e4, THREE_HOURS = 180 * MIN_TO_MS, TEN_MIN = 10 * MIN_TO_MS, TEN_SEC = 1e4;
function calculateInterval(re, te) {
  switch (re) {
    case "pre":
    case "trim":
    case "unconfirmed":
    case "live":
      return te && new Date(te).getTime() - Date.now() > THREE_HOURS ? TEN_MIN : TEN_SEC;
    case "post":
    case "canceled":
      return;
    default:
      log$2.warn("unexpected live status phase %s", re);
      return;
  }
}
const log$1 = loglevelExports.getLogger("PhasingService");
class PhasingService {
  // eslint-disable-next-line no-useless-constructor
  constructor(te, ee, ne) {
    Et(this, "liveStatus");
    Et(this, "running", !1);
    Et(this, "timeoutHandle");
    /** used to figure out whether our callback comes too late and the player has already changed its configuration. */
    Et(this, "currentPlayerConfig");
    Et(this, "currentMetaData");
    this.playerId = te, this.liveStatusDataLoader = ee, this.eventEmitter = ne;
  }
  async loadLiveStatus(te, ee) {
    log$1.debug("loading live status for config", te);
    const ne = await this.liveStatusDataLoader.loadLiveStatus(te, ee);
    return log$1.debug("-> got live status response", ne), ne;
  }
  async start(te, ee) {
    this.running = !0, this.currentPlayerConfig = te, this.currentMetaData = ee;
    const ne = await this.poll(te, !1), ie = ne == null ? void 0 : ne.phase, ae = this.isPlayablePhase(ie ?? "pre"), ce = (ne == null ? void 0 : ne.shouldKeepPolling) ?? this.shouldPollInPhase(ie ?? "pre");
    return { shouldLoadPlayer: ae, liveStatus: ne, shouldKeepPolling: ce };
  }
  isPlayablePhase(te) {
    return ["live", "post"].includes(te);
  }
  shouldPollInPhase(te) {
    return !["canceled", "post"].includes(te);
  }
  stop() {
    this.timeoutHandle && (window.clearTimeout(this.timeoutHandle), this.timeoutHandle = void 0), this.running = !1, this.currentPlayerConfig = void 0;
  }
  isRunning() {
    return this.running;
  }
  emitLiveStatusChangedEvent(te, ee, ne) {
    te && this.eventEmitter.fireEvent({
      type: "liveStatusChanged",
      playerId: this.playerId,
      liveStatus: ee,
      previousLiveStatus: ne
    });
  }
  keepPolling(te) {
    return this.running && te;
  }
  async poll(te, ee = !0) {
    var ce;
    const ne = this.liveStatus;
    let ie;
    if (!this.currentMetaData)
      throw new Error("dont have media metadata for phasing poll");
    try {
      if (ie = await this.loadLiveStatus(te, this.currentMetaData), !this.running || this.currentPlayerConfig !== te)
        return;
      areLiveStatusResponsesEqual(ne, ie) || (this.liveStatus = ie, this.emitLiveStatusChangedEvent(ee, ie, ne));
    } catch (he) {
      if (log$1.error("error polling live status", he), !ne) {
        const _e = { phase: "pre", shouldKeepPolling: !0 };
        this.liveStatus = _e, this.emitLiveStatusChangedEvent(!0, _e);
      }
    }
    const ae = calculateInterval(((ce = this.liveStatus) == null ? void 0 : ce.phase) ?? "pre", ie == null ? void 0 : ie.startTime);
    return this.keepPolling(ae) && (this.timeoutHandle = window.setTimeout(() => this.poll(te), ae)), this.liveStatus;
  }
  /**
   * Unit test method to be able to inject a specific player configuration and the running flag.
   * @param - running the new running flag.
   * @param - config the "current" player configuration
   * @param - previousLiveStatus the stored live config to do dirty checking
   */
  _injectStarted(te, ee, ne, ie) {
    this.running = te, this.currentPlayerConfig = ee, this.currentMetaData = ne, this.liveStatus = ie;
  }
}
function normalizeLiveStatusResponse(re) {
  if (re)
    return { ...re, _meta: void 0 };
}
function areLiveStatusResponsesEqual(re, te) {
  const ee = normalizeLiveStatusResponse(re), ne = normalizeLiveStatusResponse(te);
  return deepEqual(ee, ne);
}
const styles$2 = `@font-face{font-family:Bull Text;font-style:normal;font-weight:400;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:500;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff) format("woff")}@font-face{font-family:Bull VF;font-style:normal;font-weight:300 800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2-variations"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2")}.player{position:relative}.container16x9{background-color:var(--rbup-container16x9-background-color);overflow:hidden;margin:0;padding:0;position:relative;width:100%;height:100%;min-width:260px;min-height:150px}.container16x9:before{content:"";display:block;aspect-ratio:var(--aspect-ratio)}.container16x9 video{position:absolute;top:0;left:0;bottom:0;right:0;width:100%;margin:auto;max-height:100%}.container16x9[data-rbup-fullscreen]{position:fixed;top:0;left:0}.container16x9[data-rbup-fullscreen]:before{display:unset}.container16x9 #bitmovinplayer-vr-canvas{top:0;left:0;bottom:0;right:0;width:100%;height:100%}
`, log = loglevelExports.getLogger("VideoCoreInternal");
async function destroyPlayer(re, te) {
  if (re && !re.destroyed)
    try {
      log.debug("destroying coordinator", re.playerId), re.removeEventListener(te), await re.destroy(), log.debug("coordinator destroyed", re.playerId);
    } catch (ee) {
      console.error("Error while destroying coordinator", ee);
    }
}
async function loadPlayerCoordinatorAndInvokeReadyCallback(re, te, ee, ne) {
  log.debug("config was changed, loading new data into player", re, te, "ref", ee), ee && (await ee.load(te), log.debug("loading done", ee.playerId), ne == null || ne(ee));
}
async function createPlayerCoordinatorAndInvokeReadyCallback({
  adService: re,
  config: te,
  dataLoader: ee,
  dispatchElement: ne,
  divElement: ie,
  liveStatusDataLoader: ae,
  playerId: ce,
  urlSharingStrategy: he,
  lastCoordinator: _e,
  listener: le,
  onCoordinatorAvailable: se
}) {
  await destroyPlayer(_e, le), te.skipCosmosFontInjection || injectCosmosFontIntoHeader(cosmosFonts);
  const oe = new EventEmitter$1(), ue = ae ? new PhasingService(ce, ae, oe) : void 0, be = te.thumbnailService ?? new CommonThumbnailService(), ve = createPlayerCoordinator({
    adService: re,
    config: te,
    dataLoader: ee,
    dispatchElement: ne,
    divElement: ie,
    playerId: ce,
    urlSharingStrategy: he,
    eventEmitter: oe,
    phasingService: ue,
    thumbnailService: be
  });
  return ve.addEventListener(le), await loadPlayerCoordinatorAndInvokeReadyCallback(ce, te, ve, se), ve;
}
const VideoCoreInternal = ({
  config: re,
  dataLoader: te,
  adService: ee,
  onCoordinatorAvailable: ne,
  urlSharingStrategy: ie,
  liveStatusDataLoader: ae,
  internalOnApiAvailable: ce,
  aspectRatio: he
}, _e) => {
  const le = _(null), se = _(), oe = _(!1), ue = _(null), [be, ve] = h$2(), [me] = h$2(v4()), pe = _(null), fe = _([]), ge = T$1(() => {
    ue.current && (window.clearTimeout(ue.current), ue.current = null);
  }, []);
  if (!re)
    throw new Error("no config provided");
  const ye = useCoreApi(be, _e, ce, fe), $e = _(ye);
  $e.current = ye, p(() => {
    const Ce = pe.current, Ie = le.current;
    if (te && Ce && Ie && re.assetId) {
      const Te = (we) => {
        ne == null || ne(we), ve(we);
      };
      (async () => {
        ge(), ue.current = window.setTimeout(async () => {
          const we = await createPlayerCoordinatorAndInvokeReadyCallback({
            adService: ee,
            config: re,
            dataLoader: te,
            dispatchElement: Ie,
            divElement: Ce,
            liveStatusDataLoader: ae,
            playerId: me,
            urlSharingStrategy: ie,
            lastCoordinator: se.current,
            listener: ye,
            onCoordinatorAvailable: Te
          });
          oe.current && destroyPlayer(we, ye), se.current = we, ve(we);
        }, 100);
      })();
    }
  }, [
    me,
    te,
    pe,
    re,
    ie,
    ee,
    ae,
    ne,
    ye,
    ge
  ]), p(() => {
    be && te && (be.dataLoader = te);
  }, [be, te]), p(() => () => {
    oe.current = !0, se.current && destroyPlayer(se.current, $e.current);
  }, []);
  const Se = (be == null ? void 0 : be.isInFullscreenMode()) ?? !1;
  return useReportUsage(le, re.environment), /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("style", null, styles$2), /* @__PURE__ */ Cn.createElement("div", { class: "player", ref: le, "data-rbup-core": !0 }, /* @__PURE__ */ Cn.createElement(
    "div",
    {
      style: { "--aspect-ratio": `${he ? transformAspectRatioForCss(he) : ""}` },
      class: "container16x9",
      ref: pe,
      "data-rbup-core-container": !0,
      "data-rbup-fullscreen": resolveTagAttributeValue(Se)
    }
  )));
}, RbupVideoCore = k(VideoCoreInternal);
async function initRbupVideo(re, te, ee) {
  log.info("calling initRbupVideo with args", ee), await customElements.whenDefined(te);
  const ne = document.querySelector(`#${re}`);
  if (!ne)
    throw new Error(`html element with id ${re} not found`);
  const ie = createControllablePromise(), ae = {
    ...ee,
    "internal-on-api-available": ie
  };
  return deleteUndefinedValues(ae), Object.assign(ne, ae), removeNoLongerExistingAttributes(ne, ae, log), ie;
}
function useIosVrFullscreen() {
  const {
    playerState: { isFullscreenMode: re, isVRVideo: te }
  } = usePlayerContext(), ee = F$1(() => isIosDevice(), []), ne = F$1(() => te && re, [te, re]);
  return ee && ne;
}
function isMultipleAdShown(re, te) {
  return re === 0 || te === 0 ? !1 : !(re === 1 && te === 1);
}
const AdControlsTimeDisplay = () => {
  const {
    playerState: { playerCoordinator: re }
  } = usePlayerContext(), te = T$1((ie) => {
    switch (ie.type) {
      case "adTimeChanged": {
        const ae = ie.adPosition, ce = ie.totalAds, he = Math.round(ie.duration - ie.playbackPosition), _e = translate("ad-endsin", { sec: `${he}` });
        if (isMultipleAdShown(ae, ce)) {
          const le = translate("ad-from-ads", {
            adPosition: `${ae}`,
            totalAds: `${ce}`
          });
          ne(`${_e} · ${le}`);
        } else
          ne(_e);
        break;
      }
    }
  }, []), [ee, ne] = h$2();
  return p(() => (re == null || re.addEventListener(te), () => {
    re == null || re.removeEventListener(te);
  }), [re, te]), /* @__PURE__ */ Cn.createElement("div", { "data-rbup-time-display": !0, class: "ad-controls-time-display" }, /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", size: "xx-small@small x-small@medium" }, ee));
}, AdControls = () => {
  const {
    playerState: { durationInSec: re }
  } = usePlayerContext(), [te, ee] = h$2(""), ne = T$1((ae) => {
    ee(ae);
  }, []), ie = isFinite(re);
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ie && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-ad-controls": !0, class: "ad-controls" }, /* @__PURE__ */ Cn.createElement("div", { class: "ad-controls__ui" }, /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "ad-controls__tooltip",
      content: te,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "ad-controls__buttons" }, /* @__PURE__ */ Cn.createElement(PlayPauseButton, { onTooltipUpdate: ne }))
  ), /* @__PURE__ */ Cn.createElement("div", { class: "ad-controls__buttons" }, /* @__PURE__ */ Cn.createElement(VolumeControls, null)), /* @__PURE__ */ Cn.createElement(AdControlsTimeDisplay, null))));
}, RbupVideoDefaultCornerbugIcon = x(() => {
  const [re, te] = h$2(""), [ee] = h$2(`cb${v4().replace(/-/g, "")}`), ne = `.default-corner-bug.mono *{transition:.4s linear}.default-corner-bug.mono #o_${ee}{fill:hsla(0,0%,100%,0)}.default-corner-bug.mono #b_${ee}{fill:#fff}.default-corner-bug.mono #s1_${ee} stop:first-child{stop-color:#fff}.default-corner-bug.mono #s1_${ee} stop:nth-child(2){stop-color:hsla(0,0%,100%,.64)}.default-corner-bug.mono #s1_${ee} stop:nth-child(3){stop-color:hsla(0,0%,100%,0)}.default-corner-bug.mono #s2_${ee} stop:first-child{stop-color:#fff}.default-corner-bug.mono #s2_${ee} stop:nth-child(2){stop-color:hsla(0,0%,100%,0)}.default-corner-bug.mono #s4_${ee} stop{stop-color:#fff}.default-corner-bug.mono #s4_${ee} stop:first-child{stop-color:hsla(0,0%,100%,.55)}.default-corner-bug.mono #s31_${ee} stop,.default-corner-bug.mono #s32_${ee} stop,.default-corner-bug.mono #s33_${ee} stop,.default-corner-bug.mono #s34_${ee} stop{stop-color:hsla(0,0%,100%,.4)}`, ie = /* @__PURE__ */ Cn.createElement(
    "svg",
    {
      "data-rbup-default-cornerbug": !0,
      xmlns: "http://www.w3.org/2000/svg",
      class: `default-corner-bug ${ee} ${re}`,
      viewBox: "0 0 397.44 222.14"
    },
    /* @__PURE__ */ Cn.createElement("style", null, ne),
    /* @__PURE__ */ Cn.createElement("defs", null, /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s1_${ee}`,
        x1: "234",
        y1: "111",
        x2: "464",
        y2: "13",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".23", "stop-color": "#f2940a" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".52", "stop-color": "#f2940a" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#f2940a" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s2_${ee}`,
        x1: "209",
        y1: "87",
        x2: "426",
        y2: "87",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: "0", "stop-color": "#FAD50A" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".92", "stop-color": "#FAD50A" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s31_${ee}`,
        x1: "221",
        y1: "163",
        x2: "379",
        y2: "129",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".35", "stop-color": "#52bce8" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".78", "stop-color": "#3977AB" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#21336e" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s32_${ee}`,
        x1: "355",
        y1: "129",
        x2: "379",
        y2: "124",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: "0", "stop-color": "#3a78ac" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".86", "stop-color": "#253e78" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#21336e" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s33_${ee}`,
        x1: "227",
        y1: "203",
        x2: "315",
        y2: "203",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".54", "stop-color": "#52bce8" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#49a4d3" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s34_${ee}`,
        x1: "285",
        y1: "206",
        x2: "367",
        y2: "194",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".24", "stop-color": "#52bce8" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#3f88b9" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s4_${ee}`,
        x1: "219",
        y1: "160",
        x2: "399",
        y2: "160",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: "0", "stop-color": "#1885c8" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".73", "stop-color": "#1e4475" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#22183d" })
    )),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        id: `o_${ee}`,
        fill: "#fff",
        d: "M223.74 174.22c5.18-1.22 9.91-4 15.21-3.57 8.76 1.35 12.91-.36 19.6-4.69 4.91 2.81 10.74 8.67 22.72 8.54 3.85.25 8.32-1.65 7.42-5.72-.24-3.53 6.68-2 7.12-6.5.77-2.69.2-2.58-4-5.11-7-3.83-6.88-11.15-12.15-15.89-.58-.69-2.29-1.93-2.34-2.8-17.57-47.55 3.14-31.32-36.76-76.19-11.35-8.42-27.94-27.78-42.68-26.63-13.38.43-16.77 8-26.63 11.21-12.44 4.41-19.9 5.67-29.91 15-6.48 5.44-15.09-1.28-24.3 8.41-19.51 19.67-21.7 1.18-53.73 26.18-16.56 14.38-39.44 4-21-14.49 9.35-6.67 21.19-14.88 16.82-27.62-1.48-9.54-15.19-12.18-23.83-13.55-5-1-13.54-7.57-16.36-9.35-8.46 9.49-4.23 31.42 14 33.65a1.49 1.49 0 011.4 1.4 2.83 2.83 0 01-.46 1.87C20.81 78.66 18 82.86 17.54 94.55c-1 16 12.19 28.12 29 27.57a53.25 53.25 0 008-.47c.46 0 .93 0 .93.47 1.32 7.23 1.88 16.07 4.21 18.7.46.93.46 1.87-.47 2.33-5.35 5.26-16.75-.67-19.63 8.88-1.79 3.9-1.36 8.75-5.6 10.75-3-.66-3.8-5.1-7.95-5.14s-11 3.06-14 9.82c-3.2 2.19-6.44.7-7.94 5.6-.68-.05-1.05 2.59-.93 3.74a13.49 13.49 0 01-1.87 6.08c-3.08 3.89.26 8.65 5.14 9.35 3.61.28 5.89 1.7 7 .46.46 0 .46-.46.93-.46 1-.95 1.77-.26 2.8 0 2.08.11 5.1 1.73 7.48 1.4a1.71 1.71 0 011.4.47c7-.06 9.22-2.85 11.68-6.55-.13-1.66 1.2-2.8 1.87-4.2.64-.67 1.1-1 1.87-.94 1.21.35 4 .76 4.68.94 10.7.94 13.5-10 22-11.22 2.1 0 6 .41 14.48 1.4 5.56.44 11-3.6 16.36-6.54 2.4-1.2 4.49-1.87 6.54-4.68 2.52-2 5.55-14.34 8.88-14.48 6.83-.14 13.29-2.38 20.09-2.34 8.35-.37 16.84 1.95 24.3-.93.28.1 1.92-.25 2.34.46 1.06 1.57 4.05 2.27 3.27 4.21 0 .47-.94.93-1.4 1.4-1.54 0-3.78.12-5.14 1.87-.68.62-2.58.8-3.28 0-4.47.4-17.12-1.47-18.69 5.14 1.19 5.12 5.4 17.94 14 16.83.47 0 1.4.46 1.4.93 3.27 6.54 8.88 10.75 14 10.75s17.86-4.57 27.57-9.35H197c5.93-.55 8.3-2.14 11.68-8.88 4.49-4.48.86 9.17 15.1 6.32zm-9-30.13c-1.4 1.4-2.8 1.87-4.67 4.67-3.27-1.4-3.74-5.61-4.2-7.48 2.8-.46 8.87-1.87 12.15-2.33-1.88 1.87-2.82 2.8-3.29 5.14z"
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        id: `b_${ee}`,
        fill: "#db0a40",
        d: "M287.63 159.51c-6.07-3.27-8.41-10.28-12.15-15.42-9.78-10.12-11.44-27.43-14-41.6-2.58-13.76-14.33-23.94-22.48-34.58-7.23-5.9-26.1-23.78-35-26.64-11.75-4.89-22 4.35-31.78 8.88-7.94 3.27-16.35 4.2-23.36 10.28-11 14.12-17.61 2.82-30.38 14-19 19.92-26.2 2.39-52.33 25.71-7 4.2-13.55 8.41-22 7.94-13.43-.63-18-18.68-7.48-26.64C44 73.24 62 64.81 53.05 51.55c-9.3-8.29-20.24-4.76-31.3-14-5.1 8 1.42 18.85 9.81 21.5C35 61.19 43 57.78 44.64 62.76c-3.54 7.09-13.21 10.93-17.75 17.77C15.58 93.59 26.75 115 42.77 116c5.92 1.92 13.47-2.92 17.29-.93.47 4.67 0 8.88.94 13.09.43 4.6 5.67 9.54 2.8 14a23.58 23.58 0 01-16.8 5.67c-3.19 3.67-3.73 7.84-5.61 12.15-2.33 4.2-7 6.07-10.28 7.94-2.16 3.29-4.31 6.93-8.88 7.48-2.8 3.27-3.27 7.48-4.2 11.69 11.69 3.09 14.19 1.52 20.56-8.42 2.34-2.33 5.61-.46 7.94 0 6.64-.79 11.59-5.23 16.36-9.34 17-4.45 16.84 6.69 36.44-6.08 3.28-1.4 4.68-5.14 6.08-7.95 1.64-3.13 6.17-9.16.47-10.74-14.67 29.7-40.21 5.53-59.82 28-3 .83-.67-3.84 0-4.68 14.07-20.5 46.07-2.45 57-29 1.92-4.08.83-20.34 5.61-20.1.47 0 1.87.47 1.87 1.4-4.54 19.82-1.54 25.97 19.62 22.5 7.24-2.1 28 5.29 27.57-4.67 0-1.87-1.87-2.8 0-4.2.46-.47 1.87 0 2.33.46 1.32 8 8.34 13.87 15 17.3 13.43 9.14 8 21.07-7.48 20.56-5.14-2.8-6.54-7.95-10.28-12.15-4.37-3.83-10.34-2-15.42-.94-2.52 3.81 3.47 8.35 4.67 12.16 2.34 1.4 5.61-.94 7.48 1.86s2.8 5.61 5.61 7.48c8.1 7.77 25-5.88 33.64-6.54 7.55.82 11-6.06 13.55-11.69 4.26-7.78-7.07-15.47-7.94-22.43-2.58-.71-6-2.73-7.95 0 1.43 3.48 9.45 16.21 8.88 20.1-1.05 2.81-3.43 9.33-7 8.88.94-3.27 2.34-7 2.34-10.75-1.7-4-9.21-15.55-9.81-19.63 1.49-3.95 9.16-1.66 12.14-5.61 3.28-5.14 4.21-10.28 5.15-16.82a2.1 2.1 0 011.4-1.41c4.55 2.93-.08 17-2.81 20.1-.26 4.84 9.28 1.6 11.22 0 3.61.75 10.93-2.85 12.61-.47a25.39 25.39 0 00-4.67 9.35c-2.8 3.27-7.47 5.61-7.47 10.28.51 2.94 4.46-1.8 4.67 1.87-4.07 5.17-3.56 6.42-2.34 12.15 4.27 6 12.43 1.06 17.76-.46 9-3.53 19.13 2.06 26.17-7.48a6.2 6.2 0 014.67 2.8 25.73 25.73 0 0020.09 7.95c3.06-2.13-3.63-3.8-4.67-4.68-3.27-1.87-7.48-4.67-8.41-8.41-1.23-5.22-5-10-7.48-14.95 10.91.16 12.06 22.95 28 19.63.78-.54.7-1.12.47-1.87zm-78.5-70.57c-.47.47-.94.47-1.87.47-1.25-4.72-1.69-9.65-4.21-13.56-1.31-1.28-3-2.95-1.87-5.14a2.23 2.23 0 012.81-.47c4.28 3.2 5 7.66 5.14 13.09.93.93.46 3.74 0 5.61m38.31 65.9a27.85 27.85 0 01-6.54.93h-.46c-2.77-2.55 3-7.64 6.07-7.48h1.4c1.71.71 1.27 5.22-.47 6.55m12.15-27.11c-.52.91-1.32 3.29-2.33 3.27s-1.45.15-1.4-.93c-.09-3.14-.6-7-3.28-8.88-6.1-9.49-7.64 2.4-9.81.93-1.3-2.64.75-5.63 1.87-7.94.52-.63.73-1.36 1.4-1.87 1-5.75 6.25-2.47 7.48.93 3.22 4 7 8.51 6.54 13.09-.47-.47-.47.47-.47 1.4m-236.91 43c3.27-1.87 5.14-5.14 6.54-7.95-1-1.57-2.22-3.64-4.67-2.8a60.5 60.5 0 01-7 4.67c-1.17 3.18 1.75 7.18 5.14 6.08m-10.28 0c-5.55 2.27-2.61 9.11-6.07 12.62 0 .46-.94 1.4 0 1.87 2.33.46 4.2 1.4 7 1.87 1.25-4.18 2.46-8.83 3.27-12.62-.94-1.41-2.34-3.27-4.21-3.74m151.4-10.28c1.87 2.33 1.87 5.6 4.21 7.47a10.05 10.05 0 007.94-2.33c1.4-.94-.47-2.34-.93-3.74-1.41-1.87-.47-5.61-3.74-5.61-3.54.82-7.42-.2-10.75.93 0 1.41 2.8 1.41 3.27 3.28"
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M392.8 128.62c-.23-7.73-3.35-16.12-8.57-21.63l-.24-.28c-2.67 10.55-6.5 19.86-17.5 36.63-4.23 6.42-11.74 6.7-16.39 12.59-1.1-.6-.78-1.42-2.2.1 5.86-6.3-.84-3.06 1.9-6.09 10.22-11.3 19.58-21.48 23.54-36.73-1.67 2.09-2.68 2.74-4.36 4.86 1.9-6.49 3.38-12 4.79-18.66l-1.8-.72c-6.27 21.19-16.62 39.73-35.56 52.45-24.6 17.88-3.83 11.9.31 8.2-31 31.65-99.62 52-139.06 19.8 5.76 5.61 12.83 11.88 19.55 16-4.09-.7-7-3.87-10.86-5.08.06.13 9.38 12.26 37.2 15.44 1.79.2 3.5.38 5.15.53 37.93 3 40.24-3.79 66.71-9.39 1.19.51-8.53 5.53-21.9 9.31-21.11 7.72-45.62 2-63.51.14h.08c.41.2 3.19 1.48 17.42 6.57-1 .36-5.65 1-25.05-7.32 47.6 27.45 98.83 6.67 140.89-24.52 0 .14-.06.34-.06.51.37.06.84.12 1.22.15-.23.67-.23.67-3.49 4.56 7.1-5.73 10.74-14.62 18.26-20-3.85 7.73-8.77 13.27-17.93 22.23a24 24 0 002-1.71c-13.85 12.94-32.12 25.78-60.47 32.52a38.9 38.9 0 006.07-1.2c-3.59 1-3.69 1.12-5.21 1.62.94-.12.94-.12 5.83-1.11-2.85 1.4-6.14 2.07-14.1 3.69 47.19-7.48 96.27-44.2 97.34-93.46z",
        fill: `url(#s4_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M345.37 192.75c-18.7 11.9-39.39 22.28-62.5 24.93 27.8 1 60.79-19.13 78.76-35.62-5.38 3.6-10.76 7.22-16.26 10.69z",
        fill: `url(#s34_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M315.39 196.71c-26.65 5.6-28.16 12.29-66.29 9.44-3 .91-18.85-.05-21.47-.9.13 0 1.36.53 2.42.95h-.07c4-.5 30.37 5.12 38.79 4 10.93.74 45.23-9.45 46.62-13.49z",
        fill: `url(#s33_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M374.69 99.86l-.94-.41c-1.42 6.62-2.89 12.16-4.79 18.65 1.68-2.12 2.69-2.77 4.36-4.86-4 15.25-13.32 25.43-23.54 36.73-2.74 3 4-.21-1.9 6.09 1.42-1.52 1.1-.7 2.2-.1 4.64-5.89 12.16-6.17 16.39-12.59 11-16.78 14.83-26.08 17.49-36.63a3.33 3.33 0 01.25.28 30.86 30.86 0 00-9.52-7.16z",
        fill: `url(#s32_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M249.18 182.88c-17.52-9.88-4.82-3.31 10.53.3a113 113 0 0034.4 3c18.28-7 33.9-17.17 42.58-26.82-4.16 3.8-24.73 9.49-.3-8.2 18.92-12.72 29.29-31.24 35.54-52.42a69.27 69.27 0 00-15.17-3.7c-7.32 17.41-8.41 29.5-24.63 39.12-18.1 11.78-6.77 8.76-6.59 8.67a20.1 20.1 0 004-2.14c-7 11.2-19.18 18.35-33.7 21.58-.46 4.52-7.39 3-7.12 6.5.89 4.07-3.57 6-7.42 5.72-12 .13-17.81-5.73-22.72-8.54-7.66 5.08-11.26 5.73-20.9 4.66-4.79.07-9.16 2.5-13.91 3.6 6.8 6.08 36.08 13.9 25.41 8.67zm92.35-48.5c3.05-6.65 10.13-10.22 12.46-18.25-.34 1.18 2.19 1.67 3.19 1.67 4-.68 4.1-6.16 5.39-7.3-1 12.45-9.45 22.65-18.69 31.09a4.18 4.18 0 00-4-.18c-.39-2.34 4.68-5.6 1.65-7.03z",
        fill: `url(#s31_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M358 61.05c-11.74-6.68-25-8.24-37.47-13.2 18.76 4 41.07 8.07 54.94 22.11.22.11.74.62 1 .69 1.2.81 2.57 3.68 4.24 2.62-29.1-56.79-117.5-50.47-159.56-27.18 2.29 1.76 4.81 3.83 7.16 5.83 8-6.48 40.45-11 43.31-10.56-10.84 2.17-28.8 8.69-39.71 13.58l1.53 1.29c22.26-7.83 56.14-13.29 80.15-7.53-19.19 2.13-53.4 1.84-76.16 10.9 6.25 4.73 11.82 13.34 17.19 19.66 37.13-18.11 58.55-18.7 77.33-16.33 1.8 1-13.32 1.63-9.65 2.74 4.08.94 11.73-1.32 13.5-1.55 1.15-.37 8.37-.13 10.65.3 8.68 2.11.54 3.21-2.49 2.5a22.44 22.44 0 00-4.48.09c-3.35.63-7.4 1.37-10.74 1.87-.9.15-11.09-.12-9.54 1.2 1.95-.13 10.53 1.42 12.74 1.16 1.33-.3 2.68.15 3.94-.53.62-.43 3.16-.74 3.27.32-2.89 6.44-11.67 1.61-18.28 3-5.89.44-12.14 3.07-13.2 2.15 19.32-11.75-27.61 5.71-26.82 8.68a.29.29 0 00.16 0c.14 2.63 7.51-1.2 9-.92 3.23-.25 7.6-2.26 10.75-3 2.36 0 3.29 1.18 5.64.66 5.16-.09 9.82-2.31 14.8-3.29.44 0 3.55 1.31 3.4 1.67 9.38 8.41 14.33 1.4 24.62 4.17 1.64.22-.3 1.28-.86 1.61-5.43 3.82-11.88 4.41-18.17 4.87a5.69 5.69 0 00-3.08.5c-2.07-.16-4 1-6.07.69-5.89.12-11.71 1-17 3.69-2 .39-4.27.71-5.76 2.2-1.52 1.23-3.81.76-5.15 2.14-2.28 1.37-19.48 5-17.54 8.53h-.1.1a1 1 0 010 .23c28.41-4.06 62.28-24.09 98.11-9.09 14.75 7.51 23 20.57 17.12 45.81.05-.12.69-1.8.68-1.87l-.11.08c1.67-5.89 3.2-10.95 3.16-16.91C398.4 104.84 381.86 74 358 61.05zm-33.62-21.32c5.21 1.17 14.76 2.91 17.88 6.2-8.19-.09-12.25-3.63-12.12-3.54-1.57-.48-6.5-2.24-5.76-2.66z",
        fill: `url(#s2_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M231.79 54.85L228.37 52c8.15-6.68 40-10.94 43.23-10.61a105.52 105.52 0 00-14.14 3.9c-8.46 2.77-17.78 6.23-25.67 9.56zm165.42 46c-5-37.33-17.74-70.1-63.13-82.14 28.07 6.81 30.18 10.32 33.84 12.75C346.12 11.25 311 4.22 275.5 10.27c20.7-6.71 54.72-5.89 76 7.31C300.74-13.85 239.73-.26 202.22 35.63c7 1.36 13.15 6 18.86 10.42 42.57-23.22 130.42-29.58 159.64 27.22-1.68 1.06-3-1.8-4.24-2.62-.23-.07-.75-.58-1-.69-13.88-14-36.16-18.14-54.94-22.11 12.53 5 25.73 6.52 37.47 13.2 30.63 17.62 44 53.33 33.4 82.42l.11-.08a108.25 108.25 0 005.69-42.53zM294 46.26c-19.42 0-44 3.66-60.55 10l3.88 3.28c19.77-7.54 53-9.45 69.26-10.07 17.61-.54-6.15-3.15-12.59-3.21zm36.13-3.87c-.32-.17 4.07 3.5 12.12 3.54-3.15-3.3-12.65-5-17.89-6.2-.72.42 4.21 2.18 5.78 2.66z",
        fill: `url(#s1_${ee})`
      }
    )
  );
  return p(() => {
    setTimeout(() => {
      te("mono");
    }, 3e3);
  }, []), ie;
});
function isEndState(re) {
  return re === "ENDED";
}
function isErrorState(re) {
  return re === "ERROR";
}
function isStartState(re, te, ee) {
  const ne = re.getPlayerConfiguration().autoplay, ie = re.isPhasingEnabled(), ae = (ee && isPlayablePhase(ee.phase)) ?? !0;
  return te === "IDLE" && !ne && (!ie || ae);
}
function isStopped(re, te, ee) {
  var ie;
  const ne = (ee && isPlayablePhase(ee.phase)) ?? !0;
  return te === "IDLE" && !((ie = re.getPlayerData()) != null && ie.isPlayerLoaded()) && ne;
}
function getState(re, te, ee) {
  return te ? isErrorState(re) ? "ERROR" : isStartState(te, re, ee) || isStopped(te, re, ee) ? "START" : isEndState(re) ? "END" : "HIDDEN" : "HIDDEN";
}
function useStartEndViewState(re) {
  const te = (re == null ? void 0 : re.getPlayerStatus()) ?? "ERROR", ee = re == null ? void 0 : re.getLiveStatus();
  return F$1(
    () => getState(te, re, ee),
    [ee, re, te]
  );
}
const EndslateViewItem = ({
  title: re,
  imageUrl: te,
  targetUrl: ee,
  previewImageUrl: ne
}) => /* @__PURE__ */ Cn.createElement("a", { "data-rbup-endslate-item": !0, class: "endslate-view-item", href: ee, target: "_self" }, /* @__PURE__ */ Cn.createElement(
  CosmosMediaPreview,
  {
    class: "endslate-view-item__image",
    image: te,
    imagePreview: ne,
    "data-rbup-endslate-item-image": !0,
    imageAlt: ""
  }
), /* @__PURE__ */ Cn.createElement(
  CosmosText,
  {
    class: "endslate-view-item__title",
    weight: "bold",
    appearance: "light",
    size: "xx-small@small x-small@medium medium@large",
    clamp: 2
  },
  re
)), EndslateView = ({ relatedVideos: re, config: te }) => {
  const {
    playerState: { playerCoordinator: ee }
  } = usePlayerContext(), ne = useStartEndViewState(ee), ie = re && ne === "END", ae = (te == null ? void 0 : te.title) ?? translate("endslate-title"), ce = () => {
    ee == null || ee.restartPlaybackFromBeginning(), ee == null || ee.play();
  };
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ie && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-endslate": !0 }, /* @__PURE__ */ Cn.createElement("div", { class: "endslate-view" }, /* @__PURE__ */ Cn.createElement("div", { class: "endslate-view__grid" }, /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "endslate-view__headline",
      "data-rbup-endslate-title": !0,
      size: "small@small medium@medium large@large",
      weight: "bold",
      appearance: "light"
    },
    ae
  ), /* @__PURE__ */ Cn.createElement("div", { class: "endslate-view__items" }, re.map((he, _e) => /* @__PURE__ */ Cn.createElement(EndslateViewItem, { key: _e, ...he }))), /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      class: "endslate-view__replay-button",
      "data-rbup-endslate-replay": !0,
      kind: "secondary",
      size: "small",
      shape: "pill",
      appearance: "light",
      onClick: ce
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconReplay, { class: "endslate-view__replay-icon", slot: "icon" }),
    translate("endslate-replay")
  )))));
}, InitialLoadingSpinner = () => /* @__PURE__ */ Cn.createElement("div", { class: "initial-loading-spinner", "data-rbup-initial-loading-spinner": !0 }, /* @__PURE__ */ Cn.createElement("div", { class: "initial-loading-spinner__container" }, /* @__PURE__ */ Cn.createElement(CosmosSpinner, { "data-rbup-buffer": !0, appearance: "light" }))), selectedLocales = window.navigator.languages, longDateFormat = Intl.DateTimeFormat(selectedLocales, {
  dateStyle: "long"
}), shortDateFormat = Intl.DateTimeFormat(selectedLocales, {
  weekday: "short",
  day: "2-digit",
  month: "short",
  year: "numeric"
}), timeZonedTimeFormat = Intl.DateTimeFormat(selectedLocales, {
  hour: "numeric",
  minute: "numeric",
  timeZoneName: "short"
});
function getStreamState(re, te) {
  const ee = te == null ? void 0 : te.phase;
  let ne;
  switch (ee) {
    case "canceled":
      ne = "CANCELED";
      break;
    case "live":
      ne = "STREAMING";
      break;
    case "trim":
      ne = "TRIMMING";
      break;
    case "unconfirmed":
      ne = "UNCONFIRMED";
      break;
    case "pre":
      ne = "PRE";
      break;
    case "post":
    case void 0: {
      ne = "NOT_LIVE_STREAM";
      break;
    }
  }
  return ne;
}
function extractPosterImageTag(re) {
  if (!re)
    return;
  if (Array.isArray(re))
    return re.find((ee) => extractPosterImageTag(ee));
  const te = re;
  if (te && typeof te == "object" && "type" in te)
    return te.type === "img" || te.type === "picture" ? te : extractPosterImageTag(te.props.children);
}
function getCountdownString(re, te = /* @__PURE__ */ new Date()) {
  if (!re)
    return;
  const ee = new Date(re).getTime() - te.getTime(), ne = Math.floor(ee / (1e3 * 60 * 60 * 24)), ie = Math.floor(ee / (1e3 * 60 * 60) % 24), ae = Math.floor(ee / 1e3 / 60 % 60), ce = Math.floor(ee / 1e3 % 60);
  return {
    days: ne < 0 ? "00" : addLeadingZero(ne),
    hours: ie < 0 ? "00" : addLeadingZero(ie),
    minutes: ae < 0 ? "00" : addLeadingZero(ae),
    seconds: ce < 0 ? "00" : addLeadingZero(ce)
  };
}
const LiveStreamCountdown = ({ nowDate: re, startTime: te }) => {
  const ee = _(0), [ne, ie] = h$2(getCountdownString(te));
  return p(() => (ee.current = window.setInterval(() => {
    te && ie(getCountdownString(te, re));
  }, 1e3), () => {
    window.clearInterval(ee.current);
  }), [re, te]), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__segment" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__numbers" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ne == null ? void 0 : ne.days[0])), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ne == null ? void 0 : ne.days[1]))), /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", kind: "subtle", size: "x-small" }, translate("liveStream-days"))), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__segment" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__numbers" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ne == null ? void 0 : ne.hours[0])), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ne == null ? void 0 : ne.hours[1]))), /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", kind: "subtle", size: "x-small" }, translate("liveStream-hours"))), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__segment" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__numbers" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ne == null ? void 0 : ne.minutes[0])), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ne == null ? void 0 : ne.minutes[1]))), /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", kind: "subtle", size: "x-small" }, translate("liveStream-minutes"))), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__segment" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__numbers" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ne == null ? void 0 : ne.seconds[0])), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ne == null ? void 0 : ne.seconds[1]))), /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", kind: "subtle", size: "x-small" }, translate("liveStream-seconds"))));
};
function calculateStateFromStreamState(re) {
  return {
    renderComponent: re !== "NOT_LIVE_STREAM" && re !== "STREAMING",
    isCanceled: re === "CANCELED",
    isPre: re === "PRE",
    isTrimming: re === "TRIMMING",
    isUnconfirmed: re === "UNCONFIRMED"
  };
}
const InfoDisplay = ({ streamState: re }) => {
  const { isCanceled: te, isTrimming: ee, isUnconfirmed: ne } = calculateStateFromStreamState(re), ie = re.toLocaleLowerCase(), ae = `liveStream-${ie}`, ce = {
    [`data-rbup-live-stream-info-${ie}-badge`]: !0,
    class: "live-stream-info__badge",
    appearance: "light",
    size: "x-small",
    weight: "bold"
  };
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, te && /* @__PURE__ */ Cn.createElement(CosmosText, { ...ce }, /* @__PURE__ */ Cn.createElement(CosmosIconNoData, { class: "live-stream-info__icon" }), /* @__PURE__ */ Cn.createElement("span", null, translate(ae))), ee && /* @__PURE__ */ Cn.createElement(CosmosText, { ...ce }, /* @__PURE__ */ Cn.createElement(CosmosIconClock, { class: "live-stream-info__icon" }), /* @__PURE__ */ Cn.createElement("span", null, translate(ae))), ne && /* @__PURE__ */ Cn.createElement(CosmosText, { ...ce }, /* @__PURE__ */ Cn.createElement(CosmosIconEventDetails, { class: "live-stream-info__icon" }), /* @__PURE__ */ Cn.createElement("span", null, translate(ae))));
}, PreOrCanceledOrTrimmingDisplay = ({
  streamState: re,
  startTime: te
}) => {
  const { isCanceled: ee, isPre: ne, isTrimming: ie } = calculateStateFromStreamState(re), ae = `live-stream-info__date${ee ? " live-stream-info__date--canceled" : ""}`;
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, (ne || ee) && /* @__PURE__ */ Cn.createElement(CosmosText, { class: ae, appearance: "light", size: "x-small" }, te && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("span", { "data-rbup-canceled-date": !0 }, longDateFormat.format(new Date(te))), /* @__PURE__ */ Cn.createElement("span", { class: "live-stream-info__separator" }, "·"), /* @__PURE__ */ Cn.createElement("span", { "data-rbup-canceled-time": !0 }, timeZonedTimeFormat.format(new Date(te))))), ie && /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "live-stream-info__date live-stream-info__date--trimming",
      appearance: "light",
      size: "x-small"
    },
    te && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement(CosmosIconLiveBroadcast, { class: "live-stream-info__icon" }), /* @__PURE__ */ Cn.createElement("span", null, translate("liveStream-airedOn", {
      date: shortDateFormat.format(new Date(te))
    }), " "))
  ));
}, LiveStreamInfoPoster = ({
  userPosterImage: re,
  posterSrcSet: te,
  playerWidth: ee,
  imgAlt: ne
}) => /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, re ? /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-info__custom-poster-container" }, re) : /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-info__poster-container" }, /* @__PURE__ */ Cn.createElement("img", { "data-rbup-live-stream-info-poster": !0, ...te, sizes: `${ee}px`, alt: ne }))), LiveStreamInfo = ({
  playerWidth: re,
  aspectRatio: te,
  customPosterImage: ee
}) => {
  const {
    playerState: { liveStatus: ne, mediaMetaData: ie, playbackMode: ae, posterImage: ce, playerConfiguration: he }
  } = usePlayerContext(), _e = getStreamState(ae, ne), { renderComponent: le, isPre: se } = calculateStateFromStreamState(_e), oe = (ne == null ? void 0 : ne.startTime) ?? resolveCurrentSunrise(ie), ue = oe && getDaysFromNow(oe) < 100, be = se && ue, ve = F$1(
    () => ce ? calculatePosterSrcSet(ce, te) : void 0,
    [te, ce]
  ), me = (ie == null ? void 0 : ie.title) ?? (he == null ? void 0 : he.title), pe = F$1(() => extractPosterImageTag(ee), [ee]);
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, le && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-live-stream-info": !0, class: "live-stream-info" }, /* @__PURE__ */ Cn.createElement(
    LiveStreamInfoPoster,
    {
      userPosterImage: pe,
      posterSrcSet: ve,
      playerWidth: re,
      imgAlt: me
    }
  ), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-info__background" }), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-info__info" }, (ie == null ? void 0 : ie.eventLogoUrl) && /* @__PURE__ */ Cn.createElement(
    "img",
    {
      "data-rbup-live-stream-info-event-logo": !0,
      src: ie.eventLogoUrl,
      class: "live-stream-info__event-logo",
      alt: ""
    }
  ), be && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-live-stream-info-countdown": !0, class: "live-stream-info__countdown" }, /* @__PURE__ */ Cn.createElement(LiveStreamCountdown, { startTime: oe })), /* @__PURE__ */ Cn.createElement(InfoDisplay, { streamState: _e }), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-live-stream-info-title": !0,
      appearance: "light",
      class: "live-stream-info__title",
      size: "large x-large@medium",
      weight: "bold"
    },
    ie == null ? void 0 : ie.title
  ), /* @__PURE__ */ Cn.createElement(PreOrCanceledOrTrimmingDisplay, { streamState: _e, startTime: ne == null ? void 0 : ne.startTime }), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-live-stream-info-description": !0,
      class: "live-stream-info__description",
      appearance: "light",
      size: "x-small",
      kind: "subtle"
    },
    ie == null ? void 0 : ie.description
  ), (ie == null ? void 0 : ie.eventPageUrl) && /* @__PURE__ */ Cn.createElement(CosmosText, { class: "live-stream-info__event-link", size: "x-small", weight: "bold" }, /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      "data-rbup-live-stream-info-event-page-link": !0,
      appearance: "light",
      href: ie.eventPageUrl,
      kind: "tertiary",
      shape: "pill",
      size: "small",
      target: "_blank"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconChevronLeft, { slot: "icon", class: "live-stream-info__icon" }),
    translate("liveStream-backToEvent")
  )))));
};
function getDaysFromNow(re) {
  const te = new Date(re), ne = Math.abs((/* @__PURE__ */ new Date()).getTime() - te.getTime()) / 1e3;
  return Math.floor(ne / (60 * 60 * 24));
}
function resolveCurrentSunrise(re) {
  if (re)
    return re.currentSunrise;
}
function timeDifference(re) {
  return Date.parse(re) - Date.now();
}
function getTimeRemaining(re) {
  const te = timeDifference(re) / 1e3, ne = getFormattedTimeString(te).split(":"), ie = ne.length === 3, ae = ie ? ne[0] : "00", ce = ie ? ne[1] : ne[0], he = ie ? ne[2] : ne[1];
  return `${ae} h ${ce} m ${he} s`;
}
function getMonthString(re) {
  return [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
  ][re];
}
const TWO_DAYS_IN_MS = 2 * 24 * 60 * 60 * 1e3, MultiChannelSwitcherViewLiveAtLabel = ({
  startTime: re
}) => {
  const [te] = h$2(
    () => timeDifference(re) < TWO_DAYS_IN_MS && timeDifference(re) >= 0
  ), ee = _(0), [ne, ie] = h$2("...");
  return p(() => {
    const ae = new Date(re);
    if (te)
      ee.current = window.setInterval(() => {
        ie(`${translate("multiChannel-label-liveIn")} ${getTimeRemaining(re)}`);
      }, 1e3);
    else {
      window.clearInterval(ee.current);
      const ce = `global-month-short-${getMonthString(ae.getMonth())}`;
      ie(`${ae.getDate()} ${translate(ce)} ${ae.getFullYear()}`);
    }
    return () => {
      window.clearInterval(ee.current);
    };
  }, [te, re]), /* @__PURE__ */ Cn.createElement(CosmosText, { class: "multi-channel-switcher-view-live-at__label", size: "x-small" }, ne);
};
function getStatusLabel(re) {
  switch (re) {
    case "now":
      return translate("multiChannel-label-nowWatching");
    case "live":
      return translate("multiChannel-label-live");
    case "post":
      return translate("multiChannel-label-replay");
    case "trim":
      return translate("multiChannel-label-trim");
    default:
      return;
  }
}
function calculateClassName(re) {
  return [
    "multi-channel-switcher-view-item",
    !isMobileDevice() && "multi-channel-switcher-view-item__desktop",
    re && "multi-channel-switcher-view-item--active"
  ].filter(Boolean).join(" ");
}
const MultiChannelSwitcherViewItem = ({
  isCurrentlyPlaying: re = !1,
  phase: te,
  title: ee,
  startTime: ne,
  videoId: ie,
  onSelectNewAsset: ae
}) => {
  const ce = (te === "post" || te === "live") && !re, he = T$1(
    (le) => {
      ce && (isLeftClick(le) || isTouch(le)) && ae(ie);
    },
    [ce, ae, ie]
  ), _e = calculateClassName(ce);
  return /* @__PURE__ */ Cn.createElement("button", { class: _e, onPointerUp: he }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view-item__container" }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view-item__text" }, /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "multi-channel-switcher-view-item__title",
      appearance: "light",
      clamp: 1,
      weight: "bold",
      size: "small"
    },
    ee
  ), /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view-item__status" }, re && /* @__PURE__ */ Cn.createElement("div", null, /* @__PURE__ */ Cn.createElement(CosmosIconPlay, { class: "multi-channel-switcher-view-item__status-icon" })), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "multi-channel-switcher-view-item__status-label",
      appearance: "light",
      clamp: 1,
      size: "x-small"
    },
    te === "pre" && ne && /* @__PURE__ */ Cn.createElement(MultiChannelSwitcherViewLiveAtLabel, { startTime: ne }),
    te !== "pre" && getStatusLabel(re ? "now" : te)
  ))), !re && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view-item__icon" }, /* @__PURE__ */ Cn.createElement("div", null, /* @__PURE__ */ Cn.createElement(CosmosIconPlay, { class: "multi-channel-switcher-view-item__icon-play" })))));
};
function onScroll(re, te, ee) {
  const ne = {
    behavior: "smooth"
  }, ce = re.scrollWidth / te - 16;
  ee === "left" && (ne.left = re.scrollLeft - ce), ee === "right" && (ne.left = re.scrollLeft + ce), re.scrollTo(ne);
}
function showHideScrollButtonsWhenNeeded(re) {
  const te = {
    showLeftButton: !1,
    showRightButton: !1
  };
  return re && (re.scrollLeft > 0 && (te.showLeftButton = !0), Math.round(re.scrollLeft + re.offsetWidth) < re.scrollWidth && (te.showRightButton = !0)), te;
}
function addCurrentToOtherLiveVideos(re, te) {
  return !(re != null && re.otherLiveVideos) || !te ? [] : [
    {
      phase: re.phase,
      startTime: re.startTime,
      title: te.title,
      videoId: te.videoId
    }
  ].concat(re.otherLiveVideos);
}
const MultiChannelSwitcherView = ({
  onCloseView: re,
  onPlayNewAsset: te
}) => {
  const {
    playerState: { liveStatus: ee, mediaMetaData: ne }
  } = usePlayerContext(), ie = _(null), [ae, ce] = h$2(), he = F$1(() => addCurrentToOtherLiveVideos(ee, ne), [ee, ne]), _e = T$1(
    (me) => {
      me.stopPropagation(), re();
    },
    [re]
  );
  p(() => {
    ce(showHideScrollButtonsWhenNeeded(ie.current));
  }, []);
  const le = T$1(
    (me, pe) => {
      if (!ie.current)
        return;
      me.stopPropagation();
      const fe = ie.current;
      onScroll(fe, he.length, pe), ce(showHideScrollButtonsWhenNeeded(ie.current));
    },
    [he.length]
  ), se = T$1(
    (me) => {
      te(me), re();
    },
    [re, te]
  );
  useResize(
    () => ce(showHideScrollButtonsWhenNeeded(ie.current)),
    ie
  );
  const [oe] = h$2(!isMobileDevice()), ue = oe ? "multi-channel-switcher-view__item-list-items" : "multi-channel-switcher-view__item-list-items--mobile", be = [
    "multi-channel-switcher-view__item-list",
    !oe && "multi-channel-switcher-view__item-list--mobile"
  ].filter(Boolean).join(" "), ve = [
    "multi-channel-switcher-view__item-list-headline",
    oe && "multi-channel-switcher-view__item-list-headline--desktop"
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ Cn.createElement("div", { "data-rbup-multi-channel-switcher-view": !0, class: "multi-channel-switcher-view" }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__close-button-container" }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__close-button" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "data-rbup-close-button",
      Icon: /* @__PURE__ */ Cn.createElement(
        CosmosIconClose,
        {
          "data-rbup-icon-close": !0,
          class: "multi-channel-switcher-view__close-icon",
          slot: "icon"
        }
      ),
      appearance: "light",
      shape: "circle",
      kind: "tertiary",
      onPointerUp: _e
    }
  ), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "multi-channel-switcher-view__close-label",
      appearance: "light",
      size: "x-small",
      weight: "bold"
    },
    translate("button-close")
  ))), /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__item-list-container" }, /* @__PURE__ */ Cn.createElement("div", { class: be }, /* @__PURE__ */ Cn.createElement(CosmosTitle, { class: ve, appearance: "light", size: "x-small" }, translate("multiChannel-schedule")), /* @__PURE__ */ Cn.createElement(
    "div",
    {
      class: ue,
      onScroll: () => {
        ce(showHideScrollButtonsWhenNeeded(ie.current));
      },
      ref: ie
    },
    he.map((me, pe) => /* @__PURE__ */ Cn.createElement(
      MultiChannelSwitcherViewItem,
      {
        key: pe,
        isCurrentlyPlaying: pe === 0,
        phase: me.phase,
        title: me.title ?? "",
        videoId: me.videoId ?? "",
        startTime: me.startTime,
        onSelectNewAsset: se
      }
    ))
  )), !oe && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__fade multi-channel-switcher-view__fade--mobile" }), oe && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__navi", "data-rbup-multi-channel-switcher-view-navi": !0 }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__fade multi-channel-switcher-view__fade--desktop" }), (ae == null ? void 0 : ae.showLeftButton) && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__navi-button multi-channel-switcher-view__navi-button--left" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "rbup-multi-channel-switcher-left",
      Icon: /* @__PURE__ */ Cn.createElement(
        CosmosIconChevronLeft,
        {
          "data-rbup-icon-arrow-left": !0,
          class: "multi-channel-switcher-view__navi-icon",
          slot: "icon"
        }
      ),
      kind: "primary",
      shape: "square",
      onPointerUp: (me) => le(me, "left")
    }
  )), (ae == null ? void 0 : ae.showRightButton) && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__navi-button multi-channel-switcher-view__navi-button--right" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "rbup-multi-channel-switcher-right",
      Icon: /* @__PURE__ */ Cn.createElement(
        CosmosIconChevronRight,
        {
          "data-rbup-icon-arrow-right": !0,
          class: "multi-channel-switcher-view__navi-icon",
          slot: "icon"
        }
      ),
      kind: "primary",
      shape: "square",
      onPointerUp: (me) => le(me, "right")
    }
  )))));
};
function showProductPlacement(re, te, ee, ne, ie, ae, ce) {
  if (!(ae === "AT") && !ce || re === "IDLE")
    return "NEVER_SHOWN";
  const _e = te <= ie, le = ee >= ne - ie;
  return _e || le ? "SHOWN" : "FADED_OUT";
}
const defaultProductPlacementDefinition = {
  displayTimeInSec: 3,
  component: () => /* @__PURE__ */ Cn.createElement(CosmosIconProductPlacement, null)
}, RbupVideoProductPlacement = ({
  productPlacementDefinition: re = defaultProductPlacementDefinition
}) => {
  const {
    playerState: { playerStatus: te, playbackPosInSec: ee, durationInSec: ne, cumulatedPlayTimeInSec: ie, playerCoordinator: ae }
  } = usePlayerContext(), ce = re.displayTimeInSec, he = F$1(() => {
    const oe = ae == null ? void 0 : ae.getMediaMetaData();
    return showProductPlacement(
      te,
      ie,
      ee,
      ne,
      ce,
      (oe == null ? void 0 : oe.userCountry) ?? void 0,
      !!(oe != null && oe.showProductPlacement)
    );
  }, [ae, te, ie, ee, ne, ce]), _e = he !== "FADED_OUT", le = he !== "NEVER_SHOWN", se = _e ? "product-placement--fade-in" : "product-placement--fade-out";
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, le && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-product-placement": !0, class: `product-placement ${se}` }, /* @__PURE__ */ Cn.createElement(re.component, null)));
};
function usePressedKeyGroup(re, te) {
  const [ee, ne] = h$2(!1), [ie, ae] = h$2([]), ce = T$1(
    (le) => {
      const se = le.key;
      !ie.includes(se) && te.includes(se) && ie.push(le.key);
    },
    [te, ie]
  ), he = T$1(() => {
    const le = ie.join(""), se = te.join("");
    ne(le === se);
  }, [te, ie]), _e = T$1(
    (le) => {
      he();
      const se = le.key, oe = ie.filter((ue) => ue !== se);
      ae(oe);
    },
    [he, ie]
  );
  return p(() => {
    const le = re.current;
    if (!le)
      throw new Error("No element provided");
    return le.setAttribute("tabIndex", "0"), le.addEventListener("keydown", ce), le.addEventListener("keyup", _e), () => {
      le.removeEventListener("keydown", ce), le.removeEventListener("keyup", _e);
    };
  }, [re, ce, _e]), ee;
}
const OverrideTarget = {
  AUDIO: "Audio",
  SUBTITLES: "Subtitles",
  TRANSLATIONS: "Translations"
};
function languageOverrideInfo(re) {
  if (!re)
    return;
  const te = getBrowserLanguage(), ee = re.getStorageServiceAllStoredValues(), ne = re.getPlayerConfiguration(), ie = calculateAudioOverride(ne, re, te, ee), ae = calculateSubtitlesOverride(ne, ee), ce = calculateTranslationsOverride(ne, te), he = calculateFormattedOverrideReferenceString(ne, ee);
  return {
    audioOverride: ie,
    subtitleOverride: ae,
    translationsOverride: ce,
    overrideReference: he
  };
}
function calculateFormattedOverrideReferenceString(re, te) {
  let ee = "", ne = "";
  return te != null && te.audioLanguage && (ee = `${ee}${OverrideTarget.AUDIO}: ${te.audioLanguage} `), te != null && te.subtitleLanguage && (ee = `${ee}${OverrideTarget.SUBTITLES}: ${te.subtitleLanguage} `), re.overrideAudioLanguage && (ne = `${ne}${OverrideTarget.AUDIO}: ${re.overrideAudioLanguage} `), re.overrideSubtitleLanguage && (ne = `${ne}${OverrideTarget.SUBTITLES}: ${re.overrideSubtitleLanguage} `), re.overrideTranslationLanguage && (ne = `${ne}${OverrideTarget.TRANSLATIONS}: ${re.overrideTranslationLanguage} `), {
    storedRef: ee !== "" ? ee : void 0,
    configRef: ne !== "" ? ne : void 0
  };
}
function getCurrentAudioIso(re, te) {
  const ee = te ?? "";
  return re ? re[ee] : ee;
}
function calculateAudioOverride(re, te, ee, ne) {
  var _e, le;
  const ie = getCurrentAudioIso(
    (_e = te.getMediaMetaData()) == null ? void 0 : _e.availableAudioLanguages,
    (le = te.getSelectedAudioTrack()) == null ? void 0 : le.lang
  ), ae = ee === ie && (ne == null ? void 0 : ne.audioLanguage) !== ie && re.overrideAudioLanguage !== ie ? { source: "Browser", iso: ee } : void 0, ce = (ne == null ? void 0 : ne.audioLanguage) === ie && re.overrideAudioLanguage !== ie ? { source: "Storage", iso: ne == null ? void 0 : ne.audioLanguage } : void 0, he = re.overrideAudioLanguage ? { source: "Config", iso: re.overrideAudioLanguage } : void 0;
  return ae ?? ce ?? he;
}
function calculateSubtitlesOverride(re, te) {
  if (re.overrideSubtitleLanguage)
    return { source: "Config", iso: re.overrideSubtitleLanguage };
  if (te != null && te.subtitleLanguage)
    return {
      source: "Storage",
      iso: te.subtitleLanguage
    };
}
function calculateTranslationsOverride(re, te) {
  return re.overrideTranslationLanguage ? {
    source: "Config",
    iso: re.overrideTranslationLanguage
  } : {
    source: "Browser",
    iso: te
  };
}
const CopyableListElement = ({ body: re }) => {
  const [te, ee] = h$2(!1), ne = T$1(async () => {
    typeof re == "string" && (await navigator.clipboard.writeText(re), ee(!0), setTimeout(() => {
      ee(!1);
    }, 5e3));
  }, [re]), ie = /* @__PURE__ */ Cn.createElement("div", { class: "nerd-mode__list-item-button" }, /* @__PURE__ */ Cn.createElement(CosmosTooltip, { content: translate("nerdMode-copyId"), placement: "above", spacing: "tight", unreachable: !0, follow: !0 }, /* @__PURE__ */ Cn.createElement(CosmosButton, { kind: "cover-up", size: "small", shape: "pill", onClick: ne }, re))), ae = /* @__PURE__ */ Cn.createElement(CosmosText, { size: "small" }, translate("nerdMode-idCopied"));
  return te ? ae : ie;
}, ListItem = ({ label: re, crepoOrAssetId: te }) => /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, re && /* @__PURE__ */ Cn.createElement("li", { class: "nerd-mode__list-item" }, re && /* @__PURE__ */ Cn.createElement(CosmosText, { size: "small" }, re)), te && /* @__PURE__ */ Cn.createElement("li", { class: "nerd-mode__list-item" }, te && CopyableListElement({ body: te }))), PropertyList = ({ crepoId: re, subtitleOverride: te, translationsOverride: ee, hasOverrideReference: ne }) => /* @__PURE__ */ Cn.createElement("ul", { class: "nerd-mode__label-list", "data-rbup-nerd-mode-label-list": !0 }, /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-assetId") }), re && /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-crepoId") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-playerVersion") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-techVersion") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-geolocation") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-rendition") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-audioLanguageOverride") }), te && /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-subtitlesLanguageOverride") }), ee && /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-translationsLanguageOverride") }), ne && /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-overrideReference") })), ValueList = ({
  elementRef: re,
  elementStyle: te,
  assetId: ee,
  crepoId: ne,
  subtitleOverride: ie,
  playerCoordinator: ae,
  userCountry: ce,
  audioOverride: he,
  translationsOverride: _e,
  hasOverrideReference: le,
  overrideReference: se
}) => /* @__PURE__ */ Cn.createElement("ul", { class: "nerd-mode__data-list", "data-rbup-nerd-mode-data-list": !0, ref: re, style: te }, /* @__PURE__ */ Cn.createElement(ListItem, { crepoOrAssetId: ee }), ne && /* @__PURE__ */ Cn.createElement(ListItem, { crepoOrAssetId: ne }), /* @__PURE__ */ Cn.createElement(ListItem, { label: CORE_VERSION }), /* @__PURE__ */ Cn.createElement(ListItem, { label: (ae == null ? void 0 : ae.getTechVersion()) ?? translate("nerdMode-unknownValue") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: ce }), /* @__PURE__ */ Cn.createElement(ListItem, { label: `${ae == null ? void 0 : ae.getVideoQuality().height}p` }), /* @__PURE__ */ Cn.createElement(ListItem, { label: he ?? "N/A" }), /* @__PURE__ */ Cn.createElement(ListItem, { label: ie }), /* @__PURE__ */ Cn.createElement(ListItem, { label: _e }), le && (se == null ? void 0 : se.configRef) && /* @__PURE__ */ Cn.createElement(ListItem, { label: `${translate("nerdMode-playerConfiguration")}: ${se.configRef}` }), le && (se == null ? void 0 : se.storedRef) && /* @__PURE__ */ Cn.createElement(ListItem, { label: `${translate("nerdMode-localeStorage")}: ${se.storedRef}` }));
function getLanguageOverrideInfo(re) {
  return re != null && re.iso ? `${re.iso} (${re.source})` : void 0;
}
function calculateAssetId(re, te) {
  return (re == null ? void 0 : re.assetId) ?? (re == null ? void 0 : re.videoId) ?? te;
}
const NerdMode = () => {
  const {
    playerState: { mediaMetaData: re, playerCoordinator: te, playerConfiguration: ee }
  } = usePlayerContext(), ne = _(null), [ie, ae] = h$2(""), ce = calculateAssetId(re, ee == null ? void 0 : ee.assetId), he = re != null && re.assetId ? re.videoId : void 0, _e = F$1(() => languageOverrideInfo(te), [te]), le = getLanguageOverrideInfo(_e == null ? void 0 : _e.audioOverride), se = getLanguageOverrideInfo(_e == null ? void 0 : _e.subtitleOverride), oe = getLanguageOverrideInfo(_e == null ? void 0 : _e.translationsOverride), ue = _e == null ? void 0 : _e.overrideReference, be = (ue == null ? void 0 : ue.storedRef) ?? (ue == null ? void 0 : ue.configRef);
  return p(() => {
    if (ne.current) {
      const ve = `width: ${ne.current.clientWidth + 1}px`;
      ae(ve);
    }
  }, [ae]), /* @__PURE__ */ Cn.createElement("section", { class: "nerd-mode", "data-rbup-nerd-mode": !0 }, /* @__PURE__ */ Cn.createElement("header", { class: "nerd-mode__header", "data-rbup-nerd-mode-header": !0 }, /* @__PURE__ */ Cn.createElement(CosmosIconPreview, { class: "nerd-mode__header-icon", "data-rbup-nerd-mode-header-icon": !0 }), /* @__PURE__ */ Cn.createElement(CosmosTitle, { "data-rbup-nerd-mode-header-title": !0, weight: "bold", size: "x-small" }, "Nerd Mode")), /* @__PURE__ */ Cn.createElement("hr", { class: "nerd-mode__separator-line" }), /* @__PURE__ */ Cn.createElement("div", { class: "nerd-mode__grid" }, /* @__PURE__ */ Cn.createElement(
    PropertyList,
    {
      crepoId: he,
      subtitleOverride: se,
      translationsOverride: oe,
      hasOverrideReference: be
    }
  ), /* @__PURE__ */ Cn.createElement(
    ValueList,
    {
      elementRef: ne,
      elementStyle: ie,
      assetId: ce,
      crepoId: he,
      playerCoordinator: te,
      userCountry: (re == null ? void 0 : re.userCountry) ?? translate("nerdMode-unknownValue"),
      audioOverride: le,
      subtitleOverride: se,
      translationsOverride: oe,
      hasOverrideReference: be,
      overrideReference: ue
    }
  )));
}, MAIN_CLASS_NAME = "themed-player-root", InnerThemedPlayer = k((re, te) => {
  const {
    adService: ee,
    config: ne,
    customStyles: ie,
    CustomToastComponent: ae,
    dataLoader: ce,
    id: he,
    internalOnApiAvailable: _e,
    liveStatusDataLoader: le,
    styles: se,
    ThemeComponent: oe,
    aspectRatio: ue,
    globalKeyboardNavigation: be,
    CenteredToastComponent: ve
  } = re, [me, pe] = h$2(), {
    init: fe,
    playerState: { playerCoordinator: ge, playerStatus: ye, isVRVideo: $e }
  } = usePlayerContext(), Se = validateGivenAspectRatio(ue), Ce = _(null), [Ie, Te] = h$2(
    ne
  );
  p(() => {
    Te(ne);
  }, [ne]);
  const Ee = usePlayerWidth(Ce), we = useContainerQuery(Ce, BREAKPOINTS), Pe = {
    smallOrBigger: cssClassesContainsBreakpoint(we, Breakpoint.small),
    mediumOrBigger: cssClassesContainsBreakpoint(we, Breakpoint.medium),
    largeOrBigger: cssClassesContainsBreakpoint(we, Breakpoint.large)
  }, Me = getThemeCSSVariables(Ie == null ? void 0 : Ie.theme), Ae = T$1(
    (Re) => {
      Re && (fe(Re), Re.fullscreenElement = Ce.current);
    },
    [fe]
  ), Oe = usePressedKeyGroup(Ce, [KEYCODE_R, KEYCODE_B]);
  p(() => {
    Oe && pe((Re) => !Re);
  }, [Oe]);
  const Be = T$1(
    (Re) => {
      const Ne = {
        ...ne,
        assetId: Re
      };
      Te(Ne);
    },
    [ne]
  ), Ve = getMaxWidthForAspectRatio(Se), Ue = $e ? `${MAIN_CLASS_NAME} vr-content` : MAIN_CLASS_NAME;
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("style", null, se), ie && /* @__PURE__ */ Cn.createElement("style", null, ie), /* @__PURE__ */ Cn.createElement(
    "div",
    {
      id: he,
      class: `${Ue} ${we}`,
      style: {
        ...Me,
        "--max-width": Ve
      },
      ref: Ce
    },
    Ie && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement(
      RbupVideoCore,
      {
        ref: te,
        adService: ee,
        config: Ie,
        dataLoader: ce,
        liveStatusDataLoader: le,
        onCoordinatorAvailable: Ae,
        internalOnApiAvailable: _e,
        aspectRatio: Se
      }
    ), ge && /* @__PURE__ */ Cn.createElement(
      oe,
      {
        ...re,
        config: Ie,
        sizeBreakpoints: Pe,
        playerWidth: Ee,
        playerCoordinator: ge,
        playerStatus: ye,
        onPlayNewAsset: Be,
        CustomToastComponent: ae,
        aspectRatio: Se,
        globalKeyboardNavigation: be,
        CenteredToastComponent: ve
      }
    ), me && /* @__PURE__ */ Cn.createElement(NerdMode, null), /* @__PURE__ */ Cn.createElement(ErrorDisplay, null))
  ));
}), ThemedPlayer = k((re, te) => /* @__PURE__ */ Cn.createElement(PlayerStateContextProvider, null, /* @__PURE__ */ Cn.createElement(UserInteractionContextProvider, null, /* @__PURE__ */ Cn.createElement(ControlsVisibilityContextProvider, null, /* @__PURE__ */ Cn.createElement(InnerThemedPlayer, { ref: te, ...re }))))), StartAndEndView = ({
  playerWidth: re,
  customPosterImage: te,
  aspectRatio: ee,
  showAtEnd: ne = !0
}) => {
  const {
    playerState: { playerCoordinator: ie, posterImage: ae, mediaMetaData: ce, playerConfiguration: he }
  } = usePlayerContext(), _e = useStartEndViewState(ie), le = () => {
    _e === "START" ? ie == null || ie.play() : _e === "END" && ne && (ie == null || ie.restartPlaybackFromBeginning(), ie == null || ie.play());
  }, se = F$1(
    () => ae ? calculatePosterSrcSet(ae, ee) : void 0,
    [ee, ae]
  ), oe = translate("tooltip-play"), ue = translate("tooltip-replay"), be = _e === "END" ? ue : oe, ve = (ce == null ? void 0 : ce.title) ?? (he == null ? void 0 : he.title), me = F$1(() => extractPosterImageTag(te), [te]);
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, _e !== "HIDDEN" && /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-rbup-start-end": !0,
      class: "start-and-end-view",
      onClick: le,
      role: "button",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "start-and-end-view__buttons" }, /* @__PURE__ */ Cn.createElement(
      CosmosTooltip,
      {
        content: be,
        appearance: "dark",
        placement: "above",
        spacing: "tight",
        follow: !0,
        unreachable: !0,
        offset: 30
      },
      _e === "END" && ne && /* @__PURE__ */ Cn.createElement(
        CosmosButton,
        {
          "data-rbup-replay-button": !0,
          ariaLabel: ue,
          shape: "circle",
          class: "start-and-end-view__button"
        },
        /* @__PURE__ */ Cn.createElement(
          CosmosIconReplay,
          {
            "data-rbup-replay-icon": !0,
            class: "start-and-end-view__icon",
            slot: "icon"
          }
        )
      ),
      _e === "START" && /* @__PURE__ */ Cn.createElement(
        CosmosButton,
        {
          "data-rbup-start-button": !0,
          ariaLabel: oe,
          shape: "circle",
          class: "start-and-end-view__button"
        },
        /* @__PURE__ */ Cn.createElement(CosmosIconPlay, { class: "start-and-end-view__icon", slot: "icon" })
      )
    )),
    me ? /* @__PURE__ */ Cn.createElement("div", { class: "start-and-end-view__bg-custom-image-container" }, me) : /* @__PURE__ */ Cn.createElement("div", { className: "start-and-end-view__bg-image-container" }, /* @__PURE__ */ Cn.createElement("img", { "data-rbup-poster": !0, ...se, sizes: `${re}px`, alt: ve }))
  ));
}, SubtitleContainer = ({ htmlStringArr: re, controlsVisibility: te }) => /* @__PURE__ */ Cn.createElement("div", { class: `subtitles-overlay ${te === "fade-in" ? "subtitles-on-top" : ""}` }, /* @__PURE__ */ Cn.createElement("div", { class: "subtitles-overlay__text-container" }, re == null ? void 0 : re.map((ee, ne) => /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", appearance: "light", key: ne, class: "subtitles-overlay__text-display" }, /* @__PURE__ */ Cn.createElement("span", { dangerouslySetInnerHTML: { __html: ee } }))))), SubtitlesOverlay = () => {
  const {
    playerState: { playerCoordinator: re }
  } = usePlayerContext(), te = useControlsVisibilityContext().controlsVisibility, [ee, ne] = h$2();
  return p(() => {
    const ie = (ae) => {
      switch (ae.type) {
        case "subtitleUpdate":
          ne(ae.currentSubtitleHtmls);
          break;
        case "playbackFinished":
        case "loaded":
        case "seeking":
          ne(void 0);
          break;
      }
    };
    return re == null || re.addEventListener(ie), () => {
      re == null || re.removeEventListener(ie);
    };
  }, [re]), /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ee && /* @__PURE__ */ Cn.createElement(SubtitleContainer, { htmlStringArr: ee, controlsVisibility: te }));
}, CenteredToastWrapper = ({
  displayTimeInSec: re = 3,
  CenteredToastComponent: te,
  sizeBreakpoints: ee
}) => {
  const {
    playerState: { playerStatus: ne, playbackPosInSec: ie, durationInSec: ae, cumulatedPlayTimeInSec: ce, playerCoordinator: he }
  } = usePlayerContext(), _e = F$1(() => {
    if (!(he == null ? void 0 : he.shouldShowProductPlacement()))
      return "NEVER_SHOWN";
    const oe = he == null ? void 0 : he.getMediaMetaData();
    return showProductPlacement(
      ne,
      ce,
      ie,
      ae,
      re + 1,
      (oe == null ? void 0 : oe.userCountry) ?? void 0,
      !!(oe != null && oe.showProductPlacement)
    );
  }, [he, ne, ce, ie, ae, re]);
  he == null || he.shouldShowProductPlacement();
  const le = _e === "FADED_OUT" || _e === "NEVER_SHOWN";
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, !ee.mediumOrBigger && le && te && /* @__PURE__ */ Cn.createElement(te, null));
}, styles$1 = `:host,:root{all:initial;--transition-timing: .3s;--g-controls-animation-fade-in: g-controls-fade-in var(--transition-timing) forwards;--g-controls-animation-fade-out: g-controls-fade-out var(--transition-timing) forwards;-webkit-tap-highlight-color:transparent}:host *,:root *{box-sizing:border-box}.g-icon{color:#fff;height:18px;width:18px}.g-icon--primary{color:var(--rbup-primary-color)}.g-screen-reader-only{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}@keyframes g-controls-fade-in{0%{pointer-events:none;opacity:0}to{pointer-events:auto;opacity:1}}@keyframes g-controls-fade-out{0%{pointer-events:auto;opacity:1}to{pointer-events:none;opacity:0}}.cornerbug{height:100%;left:0;position:absolute;top:0;width:100%;pointer-events:none}.cornerbug__icon{position:absolute;top:4.9383%;right:2.777%;width:8.888%;max-width:180px;pointer-events:none}.cornerbug__icon:after{content:"";position:relative;display:block;width:1%;height:0;padding-bottom:41.86%}.cta-toast-button{transition:opacity .3s cubic-bezier(.32,0,1,.32)}.cta-toast-button--hidden{opacity:0}.endslate-view{align-items:center;background:linear-gradient(0deg,rgba(0,15,30,.4),rgba(0,15,30,.4));display:flex;justify-content:center;padding:0 24px;position:absolute;left:0;bottom:0;top:0;right:0;--cosmos-text-font-family: var(--rbup-component-font-family, $default-font-family)}.endslate-view__grid{display:grid;grid-template-areas:"title" "image" "button"}.endslate-view__headline{grid-area:title;margin-bottom:12px}.endslate-view__replay-button{grid-area:button;justify-self:center;margin-top:12px}.endslate-view__replay-icon{height:25px;width:25px}.endslate-view__items{grid-area:image;display:grid;flex:1;grid-column-gap:24px;grid-template-columns:repeat(2,1fr);grid-template-rows:auto 0}.endslate-view-item{background-color:#000f1e99;border-radius:6px;filter:drop-shadow(0 16px 16px rgba(0,15,30,.2));position:relative;height:77px;width:136px}.endslate-view-item__image{height:100%;border-radius:6px}.endslate-view-item:nth-child(3){display:none}.endslate-view-item:after{background:linear-gradient(180deg,rgba(0,15,30,.0001) 0%,rgba(0,15,30,.4) 100%);border-radius:6px;content:"";height:100%;left:0;position:absolute;top:0;width:100%}.endslate-view-item:hover:after{background:linear-gradient(180deg,rgba(0,15,30,.0001) 0%,rgba(0,15,30,.6) 100%)}.endslate-view-item__title{align-items:end;bottom:8px;display:flex;left:14px;max-width:360px;pointer-events:none;position:absolute;z-index:1}.cq-650 .endslate-view-item{height:163px;width:290px}.cq-650 .endslate-view__replay-button{margin-top:40px}.cq-1000 .endslate-view-item{height:170px;width:302px}.cq-1000 .endslate-view__items{grid-template-columns:repeat(3,1fr);grid-template-rows:1fr}.cq-1000 .endslate-view-item:nth-child(3){display:initial}.cq-1200 .endslate-view-item{height:207px;width:368px}.cq-1350 .endslate-view-item{height:225px;width:400px}.error-display{position:absolute;top:0;width:100%;height:100%;display:flex;justify-content:center;text-align:left}.error-display__description{position:absolute;background-color:#000c;border-radius:8px;display:flex;top:24px;padding:12px;min-width:200px;max-width:500px;min-height:80px}.cq-650 .error-display__description{min-width:400px}.error-display__icon-container{padding:0 10px 0 0}.error-display__icon{width:36px;height:36px;color:#db0a40}.error-display__text-container{flex-direction:column;display:inherit;padding:4px 0;color:#fff}.error-display__text{width:fit-content}.initial-loading-spinner{align-items:center;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}.initial-loading-spinner__container{width:80px;height:80px}.initial-loading-spinner [data-rbup-buffer]{height:100%;width:100%}.nerd-mode{--cosmos-text-color: #FFFFFF;--cosmos-title-color: #FFFFFF;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background:rgba(0,22,43,.8);height:100%;left:0;min-width:430px;overflow:auto;padding:40px;position:absolute;top:0}.nerd-mode__header{align-items:center;display:flex;gap:16px}.nerd-mode__header-icon{color:#fff;height:30px;width:30px}.nerd-mode__separator-line{border:1px solid #DB0A40}.nerd-mode__grid{display:grid;grid-template-columns:auto 1fr;grid-template-areas:"labels data";gap:40px}.nerd-mode__data-list,.nerd-mode__label-list{list-style:none;padding:0}.nerd-mode__data-list{grid-area:data}.nerd-mode__label-list{grid-area:labels}.nerd-mode__list-item{min-height:40px}.live-stream-countdown{display:flex;gap:12px}.live-stream-countdown__segment{align-items:center;display:flex;flex-direction:column}.live-stream-countdown__numbers{display:flex;gap:2px;margin-bottom:8px}.live-stream-countdown__number{background-color:#fff;align-items:center;border-radius:3px;display:flex;height:40px;justify-content:center;width:28px}.live-stream-info{align-items:center;display:flex;height:100%;justify-content:center;position:absolute;top:0;width:100%}.live-stream-info__background{background-color:#00162bb3;display:flex;height:100%;position:absolute;top:0;width:100%}.live-stream-info__badge{background-color:#ffffff1a;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);border-radius:6px;align-items:center;display:flex;justify-content:center;margin-bottom:24px;padding:8px 16px}.live-stream-info__badge span{position:relative;top:-2px}.live-stream-info__countdown{margin-bottom:8px}.live-stream-info__canceled{padding-bottom:24px;padding-top:24px}.live-stream-info__date{margin-bottom:12px}.live-stream-info__date--canceled{text-decoration:#FFFFFF line-through}.live-stream-info__date--trimming span{position:relative;top:-2px}.live-stream-info__description{display:none;margin-bottom:24px;width:400px}.live-stream-info__event-logo{display:none;margin-bottom:24px;max-height:154px}.live-stream-info__icon{height:20px;margin-right:8px;width:20px}.live-stream-info__info{align-items:center;display:flex;flex-direction:column;justify-content:center;left:0;padding:24px;text-align:center;width:100%;height:100%;position:relative}.live-stream-info__poster-container{position:absolute;height:100%;width:100%}.live-stream-info__poster-container img{height:100%;width:100%;object-fit:cover}.live-stream-info__custom-poster-container{position:absolute;width:100%;height:100%}.live-stream-info__custom-poster-container img{width:100%;height:100%;object-fit:cover}.live-stream-info__separator{margin:0 8px}.live-stream-info__title{margin-bottom:12px}.cq-650 .live-stream-info__description{display:block}.cq-650 .live-stream-info__event-link{left:24px;position:absolute;top:24px}.cq-650 .live-stream-info__event-logo{display:block;max-width:120px}.cq-1000 .live-stream-info__countdown{margin-bottom:24px}.cq-1000 .live-stream-info__event-logo{max-width:170px}.ad-controls{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none}.ad-controls__ui{--cosmos-button-background-hover: rgb(0 0 0 / 0%);align-items:center;background:linear-gradient(0deg,rgba(0,0,0,.491) 0%,rgba(0,0,0,.312) 36%,rgba(0,0,0,0) 85%);bottom:0;display:flex;gap:8px;left:0;padding:8px;position:absolute;width:100%}.ad-controls__buttons{align-items:center;display:flex;gap:8px;pointer-events:auto}.ad-controls__tooltip{align-items:center;display:flex}.ad-controls-time-display{align-items:center;display:flex;gap:4px;margin:0 8px;position:relative;-webkit-user-select:none;user-select:none}.multi-channel-switcher-view{background-color:#000f1ee6;position:absolute;top:0;height:100%;-webkit-user-select:none;user-select:none;width:100%}.multi-channel-switcher-view__navi{position:absolute;bottom:97px;width:100%;pointer-events:none}.multi-channel-switcher-view__navi-button{pointer-events:auto}.multi-channel-switcher-view__navi-button--left{left:-5px;position:absolute}.multi-channel-switcher-view__navi-button--left [kind=primary]{--cosmos-button-background: #FFFFFF;--cosmos-button-background-hover: #F8F8F8;--cosmos-button-border-width: 0}.multi-channel-switcher-view__navi-button--right{right:-5px;position:absolute}.multi-channel-switcher-view__navi-button--right [kind=primary]{--cosmos-button-background: #FFFFFF;--cosmos-button-background-hover: #F8F8F8;--cosmos-button-border-width: 0}.multi-channel-switcher-view__navi-icon{color:#00162b}.multi-channel-switcher-view__close-button-container{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.multi-channel-switcher-view__close-button-container div{text-align:center;margin-bottom:112px}.multi-channel-switcher-view__close-icon{width:30px;height:30px;padding-top:4px}.multi-channel-switcher-view__close-label{margin-top:16px;--cosmos-text-color: rgba(255, 255, 255, .6);display:none}.multi-channel-switcher-view__item-list-container{bottom:0;left:0;position:absolute;right:0;pointer-events:none}.multi-channel-switcher-view__item-list{position:relative;margin:32px 0}.multi-channel-switcher-view__item-list-headline{margin-left:16px;padding:4px 0}.multi-channel-switcher-view__item-list--mobile{margin:32px 0}.multi-channel-switcher-view__item-list-headline--desktop{margin-left:56px}.multi-channel-switcher-view__fade{background:linear-gradient(to right,rgba(0,15,30,.9) 75%,transparent);height:5.3125rem;left:0;position:absolute}.multi-channel-switcher-view__fade--desktop{bottom:-66px;width:56px}.multi-channel-switcher-view__fade--mobile{bottom:32px;width:16px}.multi-channel-switcher-view__item-list-items{overflow:hidden;scroll-behavior:smooth}.multi-channel-switcher-view__item-list-items--mobile{overflow:scroll}.multi-channel-switcher-view__item-list-items,.multi-channel-switcher-view__item-list-items--mobile{display:flex;column-gap:16px;pointer-events:auto}.multi-channel-switcher-view-item--active{cursor:pointer}.multi-channel-switcher-view-item--active:hover{background-color:#fff3}.multi-channel-switcher-view-item{background-color:#ffffff1a;border-radius:6px;border:none;filter:drop-shadow(0 16px 16px rgba(0,15,30,.2));padding:12px;max-width:290px;min-width:290px}.multi-channel-switcher-view-item:first-of-type{border:2px solid rgba(255,255,255,.45);margin-left:16px}.multi-channel-switcher-view-item:last-child{margin-right:16px}.multi-channel-switcher-view-item__desktop:first-of-type{margin-left:56px}.multi-channel-switcher-view-item__desktop:last-child{margin-right:56px}.multi-channel-switcher-view-item__container{display:grid;grid-template:1fr/1fr .1fr;grid-template-areas:"text icon";gap:0 16px}.multi-channel-switcher-view-item__text{grid-area:text;text-align:left;max-width:214px}.multi-channel-switcher-view-item__title{margin-bottom:12px}.multi-channel-switcher-view-item__status{display:flex;align-items:center}.multi-channel-switcher-view-item__status div{background:#DB0A40;border-radius:2px;margin-right:12px}.multi-channel-switcher-view-item__status-label{color:#00f}.multi-channel-switcher-view-item__status-icon{color:#fff;padding:2px 2px 0 0}.multi-channel-switcher-view-item__icon{grid-area:icon;display:flex;align-items:center}.multi-channel-switcher-view-item__icon div{display:inherit;align-items:inherit;justify-content:center;background:#DB0A40;width:36px;height:36px;border-radius:90px}.multi-channel-switcher-view-item__icon-play{color:#fff;width:25px;height:25px}.multi-channel-switcher-view-live-at__label{--cosmos-text-color: #E06600}.cq-540 .multi-channel-switcher-view__close-button [data-rbup-close-button]::part(base){height:60px;width:60px;max-width:60px;max-height:60px}.cq-540 .multi-channel-switcher-view__close-label{display:initial}.cq-650 .multi-channel-switcher-view__item-list-headline{padding:12px 0}.cq-650 .multi-channel-switcher-view-item{max-width:380px;min-width:380px}.cq-650 .multi-channel-switcher-view-item__text{max-width:305px}.cq-1000 .multi-channel-switcher-view__close-button-container div{margin-bottom:0}.controls__gradient{bottom:0;content:"";height:100%;left:0;pointer-events:none;position:absolute;width:100%;--gradient-color: var(--rbup-override-gradient-color, 0 22 43);background:linear-gradient(180deg,rgb(var(--gradient-color)/0%) 0%,rgb(var(--gradient-color)/.605%) 6.67%,rgb(var(--gradient-color)/2.49%) 13.33%,rgb(var(--gradient-color)/5.72%) 20%,rgb(var(--gradient-color)/10.3%) 26.67%,rgb(var(--gradient-color)/16.2%) 33.33%,rgb(var(--gradient-color)/23.2%) 40%,rgb(var(--gradient-color)/31%) 46.67%,rgb(var(--gradient-color)/39%) 53.33%,rgb(var(--gradient-color)/46.8%) 60%,rgb(var(--gradient-color)/53.8%) 66.67%,rgb(var(--gradient-color)/59.7%) 73.33%,rgb(var(--gradient-color)/64.3%) 80%,rgb(var(--gradient-color)/67.5%) 86.67%,rgb(var(--gradient-color)/69.4%) 93.33%,rgb(var(--gradient-color)/70%) 100%)}.controls__play{align-self:center;grid-column:2/3;grid-row:1/5}.controls__video-details{pointer-events:none;grid-area:details;width:100%;display:none}.controls__scrub-bar{grid-area:scrub-bar}.controls__buttons{display:flex;grid-area:buttons;justify-content:space-between;margin:0 8px}.controls-container--fullscreen{cursor:none}.controls-container{display:grid;grid-template:1fr auto auto 36px/1fr 1fr 1fr;grid-template-areas:"top top top" "details details details" "scrub-bar scrub-bar scrub-bar" "buttons buttons buttons";height:100%;padding:8px;outline:none;-webkit-user-select:none;user-select:none}.controls-container--fade-in{cursor:default}.controls-container--fade-in .controls__play,.controls-container--fade-in .controls__video-details,.controls-container--fade-in .controls__scrub-bar,.controls-container--fade-in .controls__buttons{animation:var(--g-controls-animation-fade-in)}.controls-container--fade-in .controls__gradient{animation:g-gradient-fade-in var(--transition-timing) forwards}.controls-container--fade-out .controls__play,.controls-container--fade-out .controls__video-details,.controls-container--fade-out .controls__scrub-bar,.controls-container--fade-out .controls__buttons{animation:var(--g-controls-animation-fade-out)}.controls-container--fade-out .controls__gradient{animation:g-gradient-fade-out var(--transition-timing) forwards}.controls-container--hide .controls__play,.controls-container--hide .controls__scrub-bar,.controls-container--hide .controls__buttons{opacity:0;pointer-events:none}.controls-container--hide .controls__gradient{opacity:0}.cosmos-tooltip{display:contents}.cq-650 .controls__buttons{margin:0 24px}.cq-650 .controls__gradient{height:60%}.cq-650 .controls__video-details{display:block}.cq-1350 .controls__gradient{height:50%}@keyframes g-gradient-fade-in{0%{opacity:0}to{opacity:1}}@keyframes g-gradient-fade-out{0%{opacity:1}to{opacity:0}}.click-and-tap-overlay-container{display:grid;grid-column:1/4;grid-row:1/5;grid-template:1fr/1fr 1fr}.click-and-tap-overlay-container.grab{cursor:move;cursor:grab}.click-and-tap-overlay-container.grabbing{cursor:move;cursor:grabbing}.fast-forward-backward-container{height:100%;display:flex;align-items:center;justify-content:center}.fast-forward-backward-container__fast-backward-container,.fast-forward-backward-container__fast-forward-container{opacity:0;display:flex;justify-content:center;align-items:center;-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);border-radius:70px;height:70px;width:70px}.fast-forward-backward-container__fast-backward-container--show-animation,.fast-forward-backward-container__fast-forward-container--show-animation{opacity:1}.fast-backward-animation__arrow{width:20px;height:20px;background:#fff;margin:0 2px;clip-path:polygon(100% 0,100% 100%,0 50%);opacity:.5;animation:fade-in-out 1s ease-in-out infinite}.fast-forward-animation__arrow{width:20px;height:20px;background:#fff;margin:0 2px;clip-path:polygon(100% 50%,0% 100%,0 0);opacity:.5;animation:fade-in-out 1s ease-in-out infinite}.animation__arrow--outer{animation-delay:.2s}.left-side-controls{align-items:center;display:flex;flex-basis:33%;flex-shrink:1;justify-content:left}.left-side-controls__selective-elements{display:flex}.left-side-controls__tooltip-wrapper{display:flex;align-items:center}.left-side-controls__icon{color:#fff}.center-controls{display:flex;align-items:center;flex-basis:33%;flex-shrink:1;justify-content:center}.play-seek-controls{display:flex;justify-content:center;position:relative}.play-seek-controls.play-seek-controls__bottom,.play-seek-controls.play-seek-controls__vr-content{display:none}.play-seek-controls.play-seek-controls__bottom.play-seek-controls__vr-content{display:flex}.play-seek-controls__play-seek-pause-container{align-items:center;display:flex;gap:12px}.play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:44px;max-width:44px;min-width:44px;width:44px}.play-seek-controls__play-seek-pause-container [data-rbup-seek-back] .play-seek-controls__icon,.play-seek-controls__play-seek-pause-container [data-rbup-seek-forward] .play-seek-controls__icon{height:25px;width:25px}.play-seek-controls__play-seek-pause-container [disabled] .play-seek-controls__icon{color:#ffffff73}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:52px;max-width:52px;min-width:52px;width:52px}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back] .play-seek-controls__icon,.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward] .play-seek-controls__icon{height:29.5px;width:29.5px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:60px;max-width:60px;min-width:60px;width:60px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back] .play-seek-controls__icon,.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward] .play-seek-controls__icon{height:34px;width:34px}.cq-1000 .play-seek-controls{display:none}.cq-1000 .play-seek-controls.play-seek-controls__bottom{display:flex;position:relative}.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:36px;max-width:36px;min-width:36px;width:36px}.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:36px;max-width:36px;min-width:36px;width:36px}.play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:44px;max-width:44px;min-width:44px;width:44px}.play-seek-controls__play-seek-pause-container [data-rbup-pause] .play-seek-controls__icon,.play-seek-controls__play-seek-pause-container [data-rbup-stop] .play-seek-controls__icon,.play-seek-controls__play-seek-pause-container [data-rbup-play] .play-seek-controls__icon{height:25px;width:25px}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:66px;max-width:66px;min-width:66px;width:66px}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-pause] .play-seek-controls__icon,.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-stop] .play-seek-controls__icon,.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-play] .play-seek-controls__icon{height:37.5px;width:37.5px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:88px;max-width:88px;min-width:88px;width:88px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-pause] .play-seek-controls__icon,.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-stop] .play-seek-controls__icon,.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-play] .play-seek-controls__icon{height:50px;width:50px}.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:36px;max-width:36px;min-width:36px;width:36px}.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container .play-seek-controls__icon{height:18px;width:18px}.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:36px;max-width:36px;min-width:36px;width:36px}.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container .play-seek-controls__icon{height:18px;width:18px}.right-side-controls{align-items:center;display:flex;gap:0;flex-basis:33%;flex-shrink:1;justify-content:right}.right-side-controls__audio-button,.right-side-controls__subtitles-button,.right-side-controls__multi-steam-button{display:none}.cq-540 .right-side-controls{gap:8px}.cq-650 .right-side-controls__audio-button,.cq-650 .right-side-controls__subtitles-button,.cq-650 .right-side-controls__multi-steam-button{display:contents}.right-side-controls__tooltip-wrapper{display:flex;gap:8px;position:relative}.video-details{padding:8px 24px;position:relative;text-align:left;--cosmos-text-line-height: var(--rbup-text-line-height);--cosmos-text-font-family: var(--rbup-component-font-family, $default-font-family)}.video-details__title{-webkit-user-select:text;user-select:text}.video-details__description{-webkit-user-select:text;user-select:text;margin-top:8px}.overlay{height:100%;left:0;position:absolute;top:0;width:100%}.disabled{pointer-events:none}.live-button,.live-button-live{display:flex;position:relative;--cosmos-button-font-size: .7rem}.live-button .cosmos-button--kind-bare,.live-button-live .cosmos-button--kind-bare{background-color:initial}[data-rbup-live]{--cosmos-button-color: #fff;--cosmos-button-background: rgb(0 0 0 / 0%);--cosmos-button-background-hover: rgb(0 0 0 / 0%)}[data-rbup-live] .live-button__icon{color:var(--rbup-primary-color)}[data-rbup-dvr]{pointer-events:auto}[data-rbup-dvr] .live-button__icon{color:#fff}.multi-channel-button{--cosmos-button-font-size: .7rem;align-items:center;display:flex;position:relative;margin-left:8px}.ad-markers{bottom:0;height:2px;width:100%;left:0;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none}.ad-markers__background-container{background-color:#fc0;height:100%;width:100%;position:absolute;transition:clip-path .3s cubic-bezier(0,.32,.32,1)}.buffer-bar{background-color:#fff;bottom:0;height:2px;left:0;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none}.progress-bar{background-color:var(--rbup-primary-color);bottom:0;height:2px;left:0;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none}.seek-bar{display:inline-block;height:100%;position:relative;width:100%}.seek-bar__cosmos-tooltip::part(base){max-width:initial;padding:0}.seek-bar-handle{bottom:21px;position:absolute;pointer-events:none}.seek-bar-handle__knob{background:#FFFFFF;border-radius:9999px;box-shadow:0 2px 8px #000f1e;color:#fff;height:16px;position:absolute;pointer-events:none;right:-8px;width:16px}.seek-bar-tooltip{align-items:center;display:flex;flex-direction:column;opacity:0;transition:opacity .3s cubic-bezier(0,.32,.32,1)}.seek-bar-tooltip--visible{opacity:1}.seek-bar-tooltip__image-container{border-radius:6px 6px 0 0;overflow:hidden}.seek-bar-tooltip__image{position:relative}.seek-bar-tooltip__text{align-items:center;display:flex;flex-direction:column;gap:4px;padding:8px;text-align:center}.seek-bar-tooltip--with-thumbnail .seek-bar-tooltip__text{margin-top:4px;padding:0 4px 4px}.seek-bar-tooltip--with-segments .seek-bar-tooltip__position{display:none}.cq-540 .seek-bar-tooltip{padding:4px}.cq-540 .seek-bar-tooltip__image-container{border-radius:6px}.cq-540 .seek-bar-tooltip--with-segments .seek-bar-tooltip__position{display:block}.scrub-bar__rail{background-color:#fff6;bottom:0;left:0;height:2px;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none;width:100%}.scrub-bar{cursor:pointer;position:relative;height:20px;margin:0 8px}.scrub-bar .scrub-bar__background-container{height:100%;width:100%;position:absolute;transition:clip-path .3s cubic-bezier(0,.32,.32,1)}.scrub-bar[data-hovered] .buffer-bar,.scrub-bar[data-hovered] .progress-bar,.scrub-bar[data-hovered] .scrub-bar__rail,.scrub-bar[data-hovered] .ad-markers{transform-origin:center center;transform:scaleY(3)}.scrub-bar[data-hovered=false]{height:20px}.cq-650 .scrub-bar{margin:0 24px}.controls-time-display{align-items:center;display:flex;flex-shrink:0;margin-left:8px;position:relative;pointer-events:none}.controls-time-display__duration{display:none}.controls-time-display__separator{padding:0 4px}.cq-650 .controls-time-display__duration{display:flex}.controls-volume-slider{height:inherit;margin-left:12px;margin-top:1px;position:relative}.controls-volume-slider__slider{cursor:pointer;display:flex;height:36px;margin:0;overflow:hidden;position:relative;transition:width .3s cubic-bezier(0,.32,.32,1);width:0}.controls-volume-slider__slider--visible{width:38px}.controls-volume-slider__indicator-element{pointer-events:none;margin:14px 2px 0 0}.volume-controls{align-items:center;display:flex;position:relative}.volume-indicator-element{width:2px;height:8px;background:rgba(255,255,255,.6)}.volume-indicator-element--active{background-color:var(--rbup-primary-color)}.volume-indicator-element--highlighted{background-color:#fff;height:14px;margin:-3px 0}.product-placement{left:23px;position:absolute;top:23px;color:#fff}.cq-1000 .product-placement{left:48px;top:48px}.product-placement--fade-in{opacity:1;transition:opacity .5s .5s}.product-placement--fade-out{opacity:0;transition:opacity .5s}.audio-menu{background-color:#fff;border-radius:8px;bottom:0;box-shadow:0 8px 12px #000f1e0a,0 2px 4px #000f1e05;max-height:250px;min-width:180px;overflow-y:auto;padding:16px;position:absolute;right:0;transform:translate(-12px,-3rem);z-index:2;pointer-events:auto}.audio-menu__title{margin-bottom:12px}.audio-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .audio-settings{overflow:visible}.audio-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.audio-settings__list-item{--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.audio-settings__list-item:last-child{margin-bottom:0}.audio-settings__list-item>*{display:inline-block}.audio-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.audio-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .audio-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .audio-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .audio-settings__list-item label input:checked:before{background-color:#000f1e}.back-button{--cosmos-text-color: #FFFFFF;align-items:center;background-color:transparent;border:none;cursor:pointer;display:flex;padding:0;margin-bottom:12px;position:relative}.back-button:focus-visible{outline:0}.back-button:focus-visible:before{border:2px solid #1B6AEE;border-radius:8px;content:"";height:100%;top:-2px;bottom:-2px;left:-2px;right:-2px;position:absolute;width:100%}.back-button .back-button__icon{height:24px;width:24px;color:#fff;transform:translate(-2px);transition:.25s ease-in-out}.back-button:hover .back-button__icon{transform:translate(-8px);color:var(--rbup-primary-color);transition:.25s ease-in-out}.cq-650 .back-button{--cosmos-text-color: #000F1E}.cq-650 .back-button .back-button__icon{color:#000f1e}.settings-menu-button__label{text-align:start}.settings-menu-button{--cosmos-text-color: #FFFFFF;align-items:center;background-color:transparent;border:none;cursor:pointer;display:flex;justify-content:space-between;width:100%;padding:1px 6px;position:relative}.settings-menu-button:focus-visible{outline:0}.settings-menu-button:focus-visible:before{border:2px solid #1B6AEE;border-radius:8px;content:"";height:100%;top:-2px;bottom:-2px;left:-2px;right:-2px;position:absolute;width:100%}.settings-menu-button:not(:last-child){margin-bottom:16px}.settings-menu-button[href]::part(base):not(:focus):hover{border-color:transparent}.settings-menu-button .settings-menu-button__label{color:#fff;font-size:14px;position:relative}.settings-menu-button .settings-menu-button__label:before{border:0;border-bottom:solid 2px var(--rbup-primary-color);border-radius:0;bottom:-3px;content:"";left:0;position:absolute;pointer-events:none;transition:.25s ease-in-out;width:0}.settings-menu-button:hover .settings-menu-button__label:before{width:100%;transition:.25s ease-in-out}.settings-menu-button__icon{height:24px;margin-left:4px;width:24px;color:#fff;transition:.25s ease-in-out}.settings-menu-button__icon:hover .settings-menu-button__icon{transform:translate(8px);color:var(--rbup-primary-color);transition:.25s ease-in-out}.settings-menu-button__selected-setting{--cosmos-text-color: rgba(255, 255, 255, .6);align-items:center;display:flex;text-transform:capitalize}.cq-650 .settings-menu-button{--cosmos-text-color: #000F1E}.cq-650 .settings-menu-button .settings-menu-button__icon{color:#000f1e99}.cq-650 .settings-menu-button .settings-menu-button__label{color:#000f1e}.cq-650 .settings-menu-button__selected-setting{--cosmos-text-color: rgba(0, 15, 30, .6)}.quality-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .quality-settings{overflow:visible}.quality-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.cq-650 .quality-settings__list{padding:0}.quality-settings__list-item{--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.quality-settings__list-item:last-child{margin-bottom:0}.quality-settings__list-item>*{display:inline-block}.quality-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.quality-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .quality-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .quality-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .quality-settings__list-item label input:checked:before{background-color:#000f1e}.cq-650 [data-rbup-menu-button=audio],.cq-650 [data-rbup-menu-button=subtitles],.cq-650 [data-rbup-menu-button=multi-stream]{display:none}.settings-menu{display:grid;grid-template-areas:"close-btn invisible menu ";grid-template-columns:minmax(42px,78px) 1px minmax(240px,320px);bottom:0;position:absolute;height:0;right:0;z-index:2;-webkit-user-select:text;user-select:text;pointer-events:auto}.settings-menu-animation{transition:height .3s cubic-bezier(0,.32,.32,1),width .3s cubic-bezier(0,.32,.32,1)}.settings-menu__invisible-title{grid-area:invisible}.settings-menu__close-button{grid-area:close-btn;--cosmos-button-border-color: rgba(255, 255, 255, .2);--cosmos-button-border-color-hover: rgba(255, 255, 255, .45);--cosmos-button-background: rgba(0, 15, 30, .45);--cosmos-button-color: #FFFFFF;--cosmos-button-color-hover: #FFFFFF;align-self:center;justify-self:center}.settings-menu__settings-area{grid-area:menu;overflow:hidden;display:flex;width:100%;height:100%;background-color:#000f1ee6}.settings-menu__settings-container{position:relative;height:100%}.cq-650 .settings-menu{height:auto;display:block;overflow:hidden;border-radius:8px;transform:translate(-12px,-3rem);box-shadow:0 8px 12px #000f1e0a,0 2px 4px #000f1e05}.cq-650 .settings-menu .settings-menu__settings-area{background-color:#fff}.settings-menu__settings-page--positioned,.settings-menu__settings-page{transition:transform .3s cubic-bezier(0,.32,.32,1);display:flex;flex-direction:column;width:100%;height:100%}.settings-menu__settings-page{overflow-x:hidden;overflow-y:auto}.settings-menu__settings-page--positioned{position:absolute}.settings-menu__settings-wrapper{max-height:100%}.settings-menu__settings-wrapper>div{padding:16px;display:flex;flex-direction:column;align-items:stretch;height:100%}.cq-650 .settings-menu__settings-wrapper{max-height:initial}.cq-650 .settings-menu__settings-wrapper>div{height:auto}.share-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .share-settings{overflow:visible}.share-settings__copied-text{animation:3s copied-text ease-in-out;margin-left:12px;transform:scale(0)}.cq-650 .share-settings__copied-text{--cosmos-text-color: #000F1E}.share-settings__link,.share-settings__iframe-code{--cosmos-button-color: #FFFFFF;--data-rbup-icon-size: 14px}.share-settings__link-icon,.share-settings__iframe-code-icon{--data-rbup-icon-size: 14px;color:#fff;margin:0}.share-settings__link::part(base),.share-settings__iframe-code::part(base){align-items:center;border:0;display:flex;gap:8px;margin:0;position:relative}.share-settings__link::part(base):focus,.share-settings__iframe-code::part(base):focus{margin:0;padding:0}.share-settings__link::part(base):before,.share-settings__iframe-code::part(base):before{border:0;border-bottom:solid 2px var(--rbup-primary-color);border-radius:0;bottom:-6px;content:"";left:0;position:absolute;pointer-events:none;transition:.25s ease-in-out;width:0}.share-settings__link::part(base):focus:before,.share-settings__link::part(base):hover:before,.share-settings__iframe-code::part(base):focus:before,.share-settings__iframe-code::part(base):hover:before{width:100%;transition:.25s ease-in-out}.cq-650 .share-settings__link,.cq-650 .share-settings__iframe-code{--cosmos-button-color: #000F1E}.cq-650 .share-settings__link-icon,.cq-650 .share-settings__iframe-code-icon{color:#00162b}.share-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.share-settings__list-item{margin-bottom:12px;--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.share-settings__list-item:last-child{margin-bottom:0}.share-settings__list-item>*{display:inline-block}.share-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.share-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .share-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .share-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .share-settings__list-item label input:checked:before{background-color:#000f1e}.share-settings__copy-button,.share-settings__copy-iframe-code-button{margin-bottom:12px;display:flex;--cosmos-button-color-hover: #FFFFFF;--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.share-settings__copy-button:last-child,.share-settings__copy-iframe-code-button:last-child{margin-bottom:0}.share-settings__copy-button>*,.share-settings__copy-iframe-code-button>*{display:inline-block}.share-settings__copy-button label input,.share-settings__copy-iframe-code-button label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.share-settings__copy-button label input:checked:before,.share-settings__copy-iframe-code-button label input:checked:before{background-color:#fff}.cq-650 .share-settings__copy-button,.cq-650 .share-settings__copy-iframe-code-button{--cosmos-button-color-hover: #000F1E}.share-settings__share-time{--cosmos-text-color: #FFFFFF;align-items:center;border-bottom:1px solid #F8F8F8;display:flex;flex-direction:row;justify-content:space-between;margin-bottom:12px;padding-left:5px;padding-right:5px;padding-bottom:12px}.share-settings__share-time input{border-color:#fff;background-color:unset}.share-settings__share-time [data-rbup-share-time-checkbox]{--cosmos-checkbox-font-size: 14px}.cq-650 .share-settings__share-time{--cosmos-text-color: #000F1E;border-bottom:1px solid #00162B}.cq-650 .share-settings__share-time label input{border-color:#00162b;background-color:#fff}.share-settings__time-input{border:0;border-bottom:2px solid #00162B;border-radius:0;color:#fff;font-family:var(--rbup-font-family);font-size:14px;height:26px;text-align:center;width:56px}.share-settings__time-input:focus{border-color:var(--rbup-primary-color);outline:0}.share-settings__time-input:disabled{background-color:transparent;border-bottom:2px solid rgba(255,255,255,.1);color:#ffffff73}.cq-650 .share-settings__time-input{border-bottom:2px solid #00162B;color:#000f1e}.cq-650 .share-settings__time-input:disabled{border-bottom:2px solid #F8F8F8;color:#000f1e99}@keyframes copied-text{0%{transform:scale(0)}10%{transform:scale(1)}90%{transform:scale(1)}to{transform:scale(0)}}.speed-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .speed-settings{overflow:visible}.speed-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.speed-settings__list-item{--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.speed-settings__list-item:last-child{margin-bottom:0}.speed-settings__list-item>*{display:inline-block}.speed-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.speed-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .speed-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .speed-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .speed-settings__list-item label input:checked:before{background-color:#000f1e}.subtitles-menu{background-color:#fff;border-radius:8px;bottom:0;box-shadow:0 8px 12px #000f1e0a,0 2px 4px #000f1e05;max-height:250px;min-width:180px;overflow-y:auto;padding:16px;position:absolute;right:0;transform:translate(-12px,-3rem);z-index:2}.subtitles-menu__title{margin-bottom:12px}.subtitles-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .subtitles-settings{overflow:visible}.subtitles-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.subtitles-settings__list-item{--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.subtitles-settings__list-item:last-child{margin-bottom:0}.subtitles-settings__list-item>*{display:inline-block}.subtitles-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.subtitles-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .subtitles-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .subtitles-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .subtitles-settings__list-item label input:checked:before{background-color:#000f1e}.multi-stream-menu{background-color:#fff;border-radius:8px;bottom:0;box-shadow:0 8px 12px #000f1e0a,0 2px 4px #000f1e05;max-height:250px;min-width:180px;overflow-y:auto;padding:16px;position:absolute;right:0;transform:translate(-12px,-3rem);z-index:2}.multi-stream-menu__title{margin-bottom:12px}.multi-stream-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .multi-stream-settings{overflow:visible}.multi-stream-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.multi-stream-settings__list-item{--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.multi-stream-settings__list-item:last-child{margin-bottom:0}.multi-stream-settings__list-item>*{display:inline-block}.multi-stream-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.multi-stream-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .multi-stream-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .multi-stream-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .multi-stream-settings__list-item label input:checked:before{background-color:#000f1e}.start-and-end-view{position:absolute;top:0;width:100%;height:100%}.start-and-end-view__buttons{align-items:center;cursor:pointer;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}.start-and-end-view__bg-image-container{height:100%;width:100%}.start-and-end-view__bg-image-container img{height:100%;width:100%;object-fit:cover}.start-and-end-view__bg-custom-image-container{width:100%;height:100%}.start-and-end-view__bg-custom-image-container img{width:100%;height:100%;object-fit:cover}.start-and-end-view__button{--cosmos-button-background: var(--rbup-play-button-background-color);--cosmos-button-background-hover: var(--rbup-play-button-background-hover-color)}.start-and-end-view__button::part(base){height:80px;max-width:80px;min-width:80px;width:80px}.start-and-end-view__icon{height:50px;width:50px}.subtitles-overlay{position:absolute;left:16px;right:16px;bottom:16px;text-align:center;pointer-events:none}.subtitles-overlay.subtitles-on-top{top:0}.subtitles-overlay__text-container{display:flex;flex-direction:column;align-items:center}.subtitles-overlay__text-display{color:#fff;background-color:#000f1e73;padding:.1666em .5em .3333em;margin-top:.3em}.themed-player-root{overflow:hidden;position:relative;min-width:300px;max-width:var(--max-width);margin:auto;--rbup-container16x9-background-color: #000;--rbup-font-family: Bull Text, Helvetica, sans-serif;--rbup-primary-color: #DB0A40;--cosmos-button-font-family: var(--rbup-font-family);--cosmos-font-family-text: var(--rbup-font-family);--cosmos-text-font-family: var(--rbup-font-family);--cosmos-tooltip-font-family: var(--rbup-font-family);--cosmos-tooltip-z-index: 1;font-family:var(--rbup-font-family);outline:none}.themed-player-root.vr-content{min-width:370px;z-index:9999}.rbup-default-theme__toasts{display:flex;gap:16px;left:12px;position:absolute;top:12px;transition:bottom .3s}.rbup-default-theme__centered-toasts{position:absolute;top:10px;left:10px}.rbup-default-theme__centered-toasts--controls-visible{animation:var(--g-controls-animation-fade-in)}.rbup-default-theme__centered-toasts--controls-hide{animation:var(--g-controls-animation-fade-out)}.rbup-default-theme__toasts--product-placement-visible{top:20px;left:64px}.rbup-default-theme--vr-fullscreen{position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999}.cq-650 .rbup-default-theme__toasts{bottom:32px;left:auto;right:32px;top:auto}.cq-650 .rbup-default-theme__toasts--controls-visible{bottom:70px}@keyframes fade-in-out{0%,40%,to{opacity:1}20%,60%{opacity:.5}}
`;
function getToastCSSClass(re, te) {
  return [
    "rbup-default-theme__toasts",
    te === "visible" && "rbup-default-theme__toasts--product-placement-visible",
    re === "fade-in" && "rbup-default-theme__toasts--controls-visible"
  ].filter(Boolean).join(" ");
}
function getCenteredToastCSSClass(re) {
  return [
    "rbup-default-theme__centered-toasts",
    re === "fade-in" ? "rbup-default-theme__centered-toasts--controls-visible" : "rbup-default-theme__centered-toasts--controls-hide"
  ].filter(Boolean).join(" ");
}
function getPlayerDisplayState(re, te, ee) {
  return (re === "IDLE" || re === "BUFFERING") && te < 1 ? "initial" : ee ? "advertisement" : "playback";
}
const DefaultThemeComponent = ({
  config: re,
  customPosterImage: te,
  sizeBreakpoints: ee,
  playerWidth: ne,
  playerCoordinator: ie,
  globalKeyboardNavigation: ae,
  onPlayNewAsset: ce,
  CustomOverlayComponent: he,
  allowControlsCaptureAreaInteraction: _e,
  CustomToastComponent: le,
  aspectRatio: se,
  CenteredToastComponent: oe
}) => {
  var Ie, Te, Ee, we;
  const {
    playerState: { isShowingAd: ue, playerStatus: be, playbackPosInSec: ve }
  } = usePlayerContext(), me = useControlsVisibilityContext().controlsVisibility, [pe, fe] = h$2(areTranslationsLoaded());
  onTranslationDataLoaded(() => fe(!0));
  const ge = !!((Ie = re.relatedVideos) != null && Ie.items), ye = ((Te = ie.getPlayerData()) == null ? void 0 : Te.getInitialSeekTimeInSec()) ?? 0, $e = Math.abs(ve - ye), Se = getPlayerDisplayState(be, $e, ue), Ce = useIosVrFullscreen() ? "rbup-default-theme--vr-fullscreen" : "";
  return /* @__PURE__ */ Cn.createElement(CosmosMode, { mode: "light", class: Ce }, Se === "initial" && /* @__PURE__ */ Cn.createElement(InitialLoadingSpinner, null), Se === "playback" && /* @__PURE__ */ Cn.createElement(
    MainMediaPlaybackComponent,
    {
      allowControlsCaptureAreaInteraction: _e,
      config: re,
      controlsVisibility: me,
      CustomOverlayComponent: he,
      CustomToastComponent: le,
      globalKeyboardNavigation: ae,
      onPlayNewAsset: ce,
      playerCoordinator: ie,
      playerStatus: be,
      sizeBreakpoints: ee,
      playerWidth: ne,
      CenteredToastComponent: oe
    }
  ), Se !== "advertisement" && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ie.isPhasingEnabled() && /* @__PURE__ */ Cn.createElement(
    LiveStreamInfo,
    {
      playerWidth: ne,
      aspectRatio: se,
      customPosterImage: te
    }
  ), /* @__PURE__ */ Cn.createElement(
    StartAndEndView,
    {
      customPosterImage: te,
      aspectRatio: se,
      showAtEnd: !ge,
      playerWidth: ne
    }
  ), ge && /* @__PURE__ */ Cn.createElement(
    EndslateView,
    {
      relatedVideos: (Ee = re.relatedVideos) == null ? void 0 : Ee.items,
      config: (we = re.relatedVideos) == null ? void 0 : we.config
    }
  )), Se === "advertisement" && /* @__PURE__ */ Cn.createElement(AdControls, null), /* @__PURE__ */ Cn.createElement(SubtitlesOverlay, null));
};
k((re, te) => /* @__PURE__ */ Cn.createElement(ThemedPlayer, { ref: te, styles: styles$1, ThemeComponent: DefaultThemeComponent, ...re }));
function getShowMultiChannelSwitcherClickedCallback(re, te, ee) {
  return re && ee && ee.length > 0 ? te : void 0;
}
const MainMediaPlaybackComponent = ({
  allowControlsCaptureAreaInteraction: re,
  config: te,
  controlsVisibility: ee,
  CustomOverlayComponent: ne,
  CustomToastComponent: ie,
  globalKeyboardNavigation: ae,
  onPlayNewAsset: ce,
  playerCoordinator: he,
  sizeBreakpoints: _e,
  CenteredToastComponent: le
}) => {
  var Ie, Te;
  const {
    playerState: { mediaMetaData: se, liveStatus: oe }
  } = usePlayerContext(), ue = oe == null ? void 0 : oe.otherLiveVideos, be = se == null ? void 0 : se.externalReferenceMarkers, ve = getToastCSSClass(ee, te.productPlacement), me = getCenteredToastCSSClass(ee), pe = he.shouldShowProductPlacement(), [fe, ge] = h$2(!1), ye = T$1((Ee = !0) => {
    ge(Ee);
  }, []), $e = te.ctaToastComponent, Se = te.multiChannelSwitcher === "visible", Ce = getShowMultiChannelSwitcherClickedCallback(
    Se,
    ye,
    ue
  );
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, te.cornerbug !== "hidden" && /* @__PURE__ */ Cn.createElement(
    RbupVideoCornerbug,
    {
      iconComponent: ((Ie = te.cornerbugIconComponent) == null ? void 0 : Ie.call(te, {})) ?? /* @__PURE__ */ Cn.createElement(RbupVideoDefaultCornerbugIcon, null)
    }
  ), pe && /* @__PURE__ */ Cn.createElement(RbupVideoProductPlacement, { productPlacementDefinition: te.productPlacementComponentDefinition }), ne && /* @__PURE__ */ Cn.createElement(ne, { playerCoordinator: he }), /* @__PURE__ */ Cn.createElement(
    RbupVideoCoreOverlay,
    {
      sizeBreakpoints: _e,
      playerCoordinator: he,
      onShowMultiChannelSwitcher: Ce,
      allowControlsCaptureAreaInteraction: re,
      globalKeyboardNavigation: ae,
      CenteredToastComponent: le
    }
  ), /* @__PURE__ */ Cn.createElement("div", { "data-rbup-centered-toast-container": !0, class: me }, /* @__PURE__ */ Cn.createElement(
    CenteredToastWrapper,
    {
      sizeBreakpoints: _e,
      displayTimeInSec: (Te = te.productPlacementComponentDefinition) == null ? void 0 : Te.displayTimeInSec,
      CenteredToastComponent: le
    }
  )), /* @__PURE__ */ Cn.createElement("div", { "data-rbup-toast-container": !0, class: ve }, ie && /* @__PURE__ */ Cn.createElement(ie, { playerCoordinator: he, sizeBreakpoints: _e }), be && $e && /* @__PURE__ */ Cn.createElement($e, { externalReferenceMarkers: be })), fe && /* @__PURE__ */ Cn.createElement(
    MultiChannelSwitcherView,
    {
      onCloseView: () => ye(!1),
      onPlayNewAsset: ce
    }
  ));
};
function isTrueValue(re) {
  return typeof re == "boolean" ? re : typeof re == "string" ? re === "true" : !1;
}
if (typeof window > "u")
  throw new Error("SSR is not supported");
const cartoonsTrackingConfig = {
  accountName: "CARTOON",
  playerId: "rbup_cartoon",
  propertyName: "Red Bull - BQ Master Rollup"
};
async function fetchSsdmCartoonsMetadata(re, te, ee, ne) {
  const ie = {
    videoId: re
  }, ae = calculateSsdmUrl(te, ee), ce = await fetch(`${ae}/cartoons?${new URLSearchParams(ie)}`, {
    headers: calculateCachingHeaders(ne)
  });
  if (ce.ok)
    return await ce.json();
  throw new Error(`error loading from server ${ce.status}`);
}
class CartoonsDataloader {
  constructor(te) {
    this.prNumber = te;
  }
  async loadData(te, ee) {
    const ne = await fetchSsdmCartoonsMetadata(
      te.assetId,
      te.environment,
      this.prNumber,
      ee
    );
    return {
      assetId: ne.assetId,
      description: ne.description,
      duration: ne.duration,
      label: ne.label,
      labelGroup: ne.labelGroup,
      season: ne.season,
      chapter: ne.chapter,
      mediaSrc: {
        mediaType: ne.videoMediaType,
        videoUrl: ne.videoUrl
      },
      posterImageUrl: ne.poster,
      thumbnailSprites: ne.thumbnailSprites,
      title: ne.title,
      userCountry: ne.userCountry ?? null,
      vin: ne.vin,
      aspectRatio: ne.aspectRatio
    };
  }
}
async function fetchSsdmRbcomCartoonsMetadata(re, te, ee, ne, ie) {
  const ae = {
    videoId: re
  }, ce = calculateSsdmUrl(te, ne), he = await fetch(`${ce}/${ee}?${new URLSearchParams(ae)}`, {
    headers: calculateCachingHeaders(ie)
  });
  if (he.ok)
    return await he.json();
  throw new Error(`error loading from server ${he.status}`);
}
function selectServerRoute(re) {
  return re.startsWith("rrn:content:") ? "cartoons" : "rbcom/cartoons";
}
class RbcomCartoonsDataloader {
  constructor(te) {
    this.prNumber = te;
  }
  async loadData(te, ee) {
    const ne = selectServerRoute(te.assetId), ie = await fetchSsdmRbcomCartoonsMetadata(
      te.assetId,
      te.environment,
      ne,
      this.prNumber,
      ee
    );
    return {
      assetId: ie.assetId,
      description: ie.description,
      duration: ie.duration,
      label: ie.label,
      labelGroup: ie.labelGroup,
      season: ie.season,
      chapter: ie.chapter,
      mediaSrc: {
        mediaType: ie.videoMediaType,
        videoUrl: ie.videoUrl
      },
      posterImageUrl: ie.poster,
      thumbnailSprites: ie.thumbnailSprites,
      title: ie.title,
      userCountry: ie.userCountry ?? null,
      vin: ie.vin,
      aspectRatio: ie.aspectRatio
    };
  }
}
class CartoonsTrackingEventCustomizer {
  customize(te, { assetId: ee }) {
    return isUserInteractionTrackingEvent(te) ? customizeUserInteractionTrackingEvent(te, ee) : customizeTrackingEvent(te, ee);
  }
}
function customizeUserInteractionTrackingEvent(re, te) {
  if (!isCrepoId(re.video_interaction.media_id))
    return re;
  const ee = te ?? re.video_interaction.media_id;
  return {
    ...re,
    video_interaction: {
      ...re.video_interaction,
      media_id: ee
    }
  };
}
function customizeTrackingEvent(re, te) {
  if (!isCrepoId(re.media_id))
    return re;
  const ee = te ?? re.media_id;
  return re.eventAction === "init" ? {
    ...re,
    media_id: ee,
    video_asset_id: te ?? re.video_asset_id,
    video_product_id: stripOffLocaleFromCrepoId(re.media_id)
  } : {
    ...re,
    media_id: ee
  };
}
function isArrayOfPlaylistEntries(re) {
  return !(!Array.isArray(re) || re.some((te) => !te.assetId));
}
function parsePlaylistEntries(re) {
  if (!re)
    return [];
  if (typeof re == "string")
    return re.split(",").map((te) => ({ assetId: te }));
  if (!isArrayOfPlaylistEntries(re))
    throw new Error("need to provide a list of playlist entries");
  return re;
}
function resolveTrackingCustomInitAttributes(re) {
  if (re.startsWith("rrn:content:tv-commercials"))
    return {
      localizedcrepoID: re
    };
}
const NextVideoCountdown = ({
  playerWidth: re,
  onNextClick: te,
  onReplayClick: ee,
  posterImageSrcSet: ne,
  title: ie
}) => /* @__PURE__ */ Cn.createElement("div", { "data-rbup-next-video-countdown": !0, class: "next-video-countdown" }, /* @__PURE__ */ Cn.createElement("div", { class: "next-video-countdown__container" }, ie && /* @__PURE__ */ Cn.createElement("div", { class: "next-video-countdown__titles" }, /* @__PURE__ */ Cn.createElement(CosmosText, { class: "next-video-countdown__title" }, translate("nextVideoCountdown-title")), /* @__PURE__ */ Cn.createElement(CosmosText, { class: "next-video-countdown__video-title", clamp: 1, weight: "bold" }, ie)), te && /* @__PURE__ */ Cn.createElement("div", { class: "next-video-countdown__button-container" }, /* @__PURE__ */ Cn.createElement(
  "svg",
  {
    "data-rbup-next-video-countdown-svg": !0,
    class: "next-video-countdown__countdown",
    viewBox: "0 0 90 90"
  },
  /* @__PURE__ */ Cn.createElement(
    "circle",
    {
      "data-rbup-next-video-countdown-svg-shape": !0,
      fill: "transparent",
      strokeWidth: "4",
      strokeLinecap: "round",
      r: "42",
      cx: "45",
      cy: "45",
      onAnimationEnd: te
    }
  )
), /* @__PURE__ */ Cn.createElement(
  CosmosButton,
  {
    "data-rbup-next-video-countdown-play": !0,
    class: "next-video-countdown__play-button",
    shape: "circle",
    onClick: te
  },
  /* @__PURE__ */ Cn.createElement(CosmosIconSkipNext, { class: "next-video-countdown__play-icon", slot: "icon" })
)), /* @__PURE__ */ Cn.createElement(
  CosmosButton,
  {
    "data-rbup-next-video-countdown-replay": !0,
    kind: "secondary",
    size: "small",
    shape: "pill",
    onClick: ee
  },
  translate("nextVideoCountdown-replay")
)), ne && /* @__PURE__ */ Cn.createElement("div", { class: "next-video-countdown__poster-container" }, /* @__PURE__ */ Cn.createElement(
  "img",
  {
    "data-rbup-next-video-countdown-poster": !0,
    ...ne,
    sizes: `${re}px`,
    alt: "poster"
  }
))), styles = `:host,:root{all:initial;--transition-timing: .3s;--g-controls-animation-fade-in: g-controls-fade-in var(--transition-timing) forwards;--g-controls-animation-fade-out: g-controls-fade-out var(--transition-timing) forwards;-webkit-tap-highlight-color:transparent}:host *,:root *{box-sizing:border-box}.g-icon{color:#fff;height:18px;width:18px}.g-icon--primary{color:var(--rbup-primary-color)}.g-screen-reader-only{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}@keyframes g-controls-fade-in{0%{pointer-events:none;opacity:0}to{pointer-events:auto;opacity:1}}@keyframes g-controls-fade-out{0%{pointer-events:auto;opacity:1}to{pointer-events:none;opacity:0}}.error-display{position:absolute;top:0;width:100%;height:100%;display:flex;justify-content:center;text-align:left}.error-display__description{position:absolute;background-color:#000c;border-radius:8px;display:flex;top:24px;padding:12px;min-width:200px;max-width:500px;min-height:80px}.cq-650 .error-display__description{min-width:400px}.error-display__icon-container{padding:0 10px 0 0}.error-display__icon{width:36px;height:36px;color:#db0a40}.error-display__text-container{flex-direction:column;display:inherit;padding:4px 0;color:#fff}.error-display__text{width:fit-content}.nerd-mode{--cosmos-text-color: #FFFFFF;--cosmos-title-color: #FFFFFF;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background:rgba(0,22,43,.8);height:100%;left:0;min-width:430px;overflow:auto;padding:40px;position:absolute;top:0}.nerd-mode__header{align-items:center;display:flex;gap:16px}.nerd-mode__header-icon{color:#fff;height:30px;width:30px}.nerd-mode__separator-line{border:1px solid #DB0A40}.nerd-mode__grid{display:grid;grid-template-columns:auto 1fr;grid-template-areas:"labels data";gap:40px}.nerd-mode__data-list,.nerd-mode__label-list{list-style:none;padding:0}.nerd-mode__data-list{grid-area:data}.nerd-mode__label-list{grid-area:labels}.nerd-mode__list-item{min-height:40px}.controls__gradient{bottom:0;content:"";height:100%;left:0;pointer-events:none;position:absolute;width:100%;--gradient-color: var(--rbup-override-gradient-color, 0 22 43);background:linear-gradient(180deg,rgb(var(--gradient-color)/0%) 0%,rgb(var(--gradient-color)/.605%) 6.67%,rgb(var(--gradient-color)/2.49%) 13.33%,rgb(var(--gradient-color)/5.72%) 20%,rgb(var(--gradient-color)/10.3%) 26.67%,rgb(var(--gradient-color)/16.2%) 33.33%,rgb(var(--gradient-color)/23.2%) 40%,rgb(var(--gradient-color)/31%) 46.67%,rgb(var(--gradient-color)/39%) 53.33%,rgb(var(--gradient-color)/46.8%) 60%,rgb(var(--gradient-color)/53.8%) 66.67%,rgb(var(--gradient-color)/59.7%) 73.33%,rgb(var(--gradient-color)/64.3%) 80%,rgb(var(--gradient-color)/67.5%) 86.67%,rgb(var(--gradient-color)/69.4%) 93.33%,rgb(var(--gradient-color)/70%) 100%)}.controls__play{align-self:center;grid-column:2/3;grid-row:1/5}.controls__video-details{pointer-events:none;grid-area:details;width:100%;display:none}.controls__scrub-bar{grid-area:scrub-bar}.controls__buttons{display:flex;grid-area:buttons;justify-content:space-between;margin:0 8px}.controls-container--fullscreen{cursor:none}.controls-container{display:grid;grid-template:1fr auto auto 36px/1fr 1fr 1fr;grid-template-areas:"top top top" "details details details" "scrub-bar scrub-bar scrub-bar" "buttons buttons buttons";height:100%;padding:8px;outline:none;-webkit-user-select:none;user-select:none}.controls-container--fade-in{cursor:default}.controls-container--fade-in .controls__play,.controls-container--fade-in .controls__video-details,.controls-container--fade-in .controls__scrub-bar,.controls-container--fade-in .controls__buttons{animation:var(--g-controls-animation-fade-in)}.controls-container--fade-in .controls__gradient{animation:g-gradient-fade-in var(--transition-timing) forwards}.controls-container--fade-out .controls__play,.controls-container--fade-out .controls__video-details,.controls-container--fade-out .controls__scrub-bar,.controls-container--fade-out .controls__buttons{animation:var(--g-controls-animation-fade-out)}.controls-container--fade-out .controls__gradient{animation:g-gradient-fade-out var(--transition-timing) forwards}.controls-container--hide .controls__play,.controls-container--hide .controls__scrub-bar,.controls-container--hide .controls__buttons{opacity:0;pointer-events:none}.controls-container--hide .controls__gradient{opacity:0}.cosmos-tooltip{display:contents}.cq-650 .controls__buttons{margin:0 24px}.cq-650 .controls__gradient{height:60%}.cq-650 .controls__video-details{display:block}.cq-1350 .controls__gradient{height:50%}@keyframes g-gradient-fade-in{0%{opacity:0}to{opacity:1}}@keyframes g-gradient-fade-out{0%{opacity:1}to{opacity:0}}.click-and-tap-overlay-container{display:grid;grid-column:1/4;grid-row:1/5;grid-template:1fr/1fr 1fr}.click-and-tap-overlay-container.grab{cursor:move;cursor:grab}.click-and-tap-overlay-container.grabbing{cursor:move;cursor:grabbing}.fast-forward-backward-container{height:100%;display:flex;align-items:center;justify-content:center}.fast-forward-backward-container__fast-backward-container,.fast-forward-backward-container__fast-forward-container{opacity:0;display:flex;justify-content:center;align-items:center;-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);border-radius:70px;height:70px;width:70px}.fast-forward-backward-container__fast-backward-container--show-animation,.fast-forward-backward-container__fast-forward-container--show-animation{opacity:1}.fast-backward-animation__arrow{width:20px;height:20px;background:#fff;margin:0 2px;clip-path:polygon(100% 0,100% 100%,0 50%);opacity:.5;animation:fade-in-out 1s ease-in-out infinite}.fast-forward-animation__arrow{width:20px;height:20px;background:#fff;margin:0 2px;clip-path:polygon(100% 50%,0% 100%,0 0);opacity:.5;animation:fade-in-out 1s ease-in-out infinite}.animation__arrow--outer{animation-delay:.2s}@keyframes fade-in-out{0%,40%,to{opacity:1}20%,60%{opacity:.5}}.left-side-controls{align-items:center;display:flex;flex-basis:33%;flex-shrink:1;justify-content:left}.left-side-controls__selective-elements{display:flex}.left-side-controls__tooltip-wrapper{display:flex;align-items:center}.left-side-controls__icon{color:#fff}.play-seek-controls{display:flex;justify-content:center;position:relative}.play-seek-controls.play-seek-controls__bottom,.play-seek-controls.play-seek-controls__vr-content{display:none}.play-seek-controls.play-seek-controls__bottom.play-seek-controls__vr-content{display:flex}.play-seek-controls__play-seek-pause-container{align-items:center;display:flex;gap:12px}.play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:44px;max-width:44px;min-width:44px;width:44px}.play-seek-controls__play-seek-pause-container [data-rbup-seek-back] .play-seek-controls__icon,.play-seek-controls__play-seek-pause-container [data-rbup-seek-forward] .play-seek-controls__icon{height:25px;width:25px}.play-seek-controls__play-seek-pause-container [disabled] .play-seek-controls__icon{color:#ffffff73}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:52px;max-width:52px;min-width:52px;width:52px}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back] .play-seek-controls__icon,.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward] .play-seek-controls__icon{height:29.5px;width:29.5px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:60px;max-width:60px;min-width:60px;width:60px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back] .play-seek-controls__icon,.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward] .play-seek-controls__icon{height:34px;width:34px}.cq-1000 .play-seek-controls{display:none}.cq-1000 .play-seek-controls.play-seek-controls__bottom{display:flex;position:relative}.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:36px;max-width:36px;min-width:36px;width:36px}.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:36px;max-width:36px;min-width:36px;width:36px}.play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:44px;max-width:44px;min-width:44px;width:44px}.play-seek-controls__play-seek-pause-container [data-rbup-pause] .play-seek-controls__icon,.play-seek-controls__play-seek-pause-container [data-rbup-stop] .play-seek-controls__icon,.play-seek-controls__play-seek-pause-container [data-rbup-play] .play-seek-controls__icon{height:25px;width:25px}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:66px;max-width:66px;min-width:66px;width:66px}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-pause] .play-seek-controls__icon,.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-stop] .play-seek-controls__icon,.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-play] .play-seek-controls__icon{height:37.5px;width:37.5px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:88px;max-width:88px;min-width:88px;width:88px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-pause] .play-seek-controls__icon,.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-stop] .play-seek-controls__icon,.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-play] .play-seek-controls__icon{height:50px;width:50px}.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:36px;max-width:36px;min-width:36px;width:36px}.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container .play-seek-controls__icon{height:18px;width:18px}.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:36px;max-width:36px;min-width:36px;width:36px}.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container .play-seek-controls__icon{height:18px;width:18px}.right-side-controls{align-items:center;display:flex;gap:0;flex-basis:33%;flex-shrink:1;justify-content:right}.right-side-controls__audio-button,.right-side-controls__subtitles-button,.right-side-controls__multi-steam-button{display:none}.cq-540 .right-side-controls{gap:8px}.cq-650 .right-side-controls__audio-button,.cq-650 .right-side-controls__subtitles-button,.cq-650 .right-side-controls__multi-steam-button{display:contents}.right-side-controls__tooltip-wrapper{display:flex;gap:8px;position:relative}.video-details{padding:8px 24px;position:relative;text-align:left;--cosmos-text-line-height: var(--rbup-text-line-height);--cosmos-text-font-family: var(--rbup-component-font-family, $default-font-family)}.video-details__title{-webkit-user-select:text;user-select:text}.video-details__description{-webkit-user-select:text;user-select:text;margin-top:8px}.overlay{height:100%;left:0;position:absolute;top:0;width:100%}.disabled{pointer-events:none}.buffer-bar{background-color:#fff;bottom:0;height:2px;left:0;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none}.progress-bar{background-color:var(--rbup-primary-color);bottom:0;height:2px;left:0;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none}.seek-bar{display:inline-block;height:100%;position:relative;width:100%}.seek-bar__cosmos-tooltip::part(base){max-width:initial;padding:0}.seek-bar-handle{bottom:21px;position:absolute;pointer-events:none}.seek-bar-handle__knob{background:#FFFFFF;border-radius:9999px;box-shadow:0 2px 8px #000f1e;color:#fff;height:16px;position:absolute;pointer-events:none;right:-8px;width:16px}.seek-bar-tooltip{align-items:center;display:flex;flex-direction:column;opacity:0;transition:opacity .3s cubic-bezier(0,.32,.32,1)}.seek-bar-tooltip--visible{opacity:1}.seek-bar-tooltip__image-container{border-radius:6px 6px 0 0;overflow:hidden}.seek-bar-tooltip__image{position:relative}.seek-bar-tooltip__text{align-items:center;display:flex;flex-direction:column;gap:4px;padding:8px;text-align:center}.seek-bar-tooltip--with-thumbnail .seek-bar-tooltip__text{margin-top:4px;padding:0 4px 4px}.seek-bar-tooltip--with-segments .seek-bar-tooltip__position{display:none}.cq-540 .seek-bar-tooltip{padding:4px}.cq-540 .seek-bar-tooltip__image-container{border-radius:6px}.cq-540 .seek-bar-tooltip--with-segments .seek-bar-tooltip__position{display:block}.scrub-bar__rail{background-color:#fff6;bottom:0;left:0;height:2px;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none;width:100%}.scrub-bar{cursor:pointer;position:relative;height:20px;margin:0 8px}.scrub-bar .scrub-bar__background-container{height:100%;width:100%;position:absolute;transition:clip-path .3s cubic-bezier(0,.32,.32,1)}.scrub-bar[data-hovered] .buffer-bar,.scrub-bar[data-hovered] .progress-bar,.scrub-bar[data-hovered] .scrub-bar__rail,.scrub-bar[data-hovered] .ad-markers{transform-origin:center center;transform:scaleY(3)}.scrub-bar[data-hovered=false]{height:20px}.cq-650 .scrub-bar{margin:0 24px}.controls-time-display{align-items:center;display:flex;flex-shrink:0;margin-left:8px;position:relative;pointer-events:none}.controls-time-display__duration{display:none}.controls-time-display__separator{padding:0 4px}.cq-650 .controls-time-display__duration{display:flex}.controls-volume-slider{height:inherit;margin-left:12px;margin-top:1px;position:relative}.controls-volume-slider__slider{cursor:pointer;display:flex;height:36px;margin:0;overflow:hidden;position:relative;transition:width .3s cubic-bezier(0,.32,.32,1);width:0}.controls-volume-slider__slider--visible{width:38px}.controls-volume-slider__indicator-element{pointer-events:none;margin:14px 2px 0 0}.volume-controls{align-items:center;display:flex;position:relative}.volume-indicator-element{width:2px;height:8px;background:rgba(255,255,255,.6)}.volume-indicator-element--active{background-color:var(--rbup-primary-color)}.volume-indicator-element--highlighted{background-color:#fff;height:14px;margin:-3px 0}.start-and-end-view{position:absolute;top:0;width:100%;height:100%}.start-and-end-view__buttons{align-items:center;cursor:pointer;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}.start-and-end-view__bg-image-container{height:100%;width:100%}.start-and-end-view__bg-image-container img{height:100%;width:100%;object-fit:cover}.start-and-end-view__bg-custom-image-container{width:100%;height:100%}.start-and-end-view__bg-custom-image-container img{width:100%;height:100%;object-fit:cover}.start-and-end-view__button{--cosmos-button-background: var(--rbup-play-button-background-color);--cosmos-button-background-hover: var(--rbup-play-button-background-hover-color)}.start-and-end-view__button::part(base){height:80px;max-width:80px;min-width:80px;width:80px}.start-and-end-view__icon{height:50px;width:50px}.themed-player-root{position:relative;min-width:300px;max-width:var(--max-width);margin:auto;--rbup-override-gradient-color: 255 255 255;--rbup-container16x9-background-color: #fff;--rbup-font-family: "futura-pt-condensed", Bull Text, Helvetica, sans-serif;--rbup-primary-color: #DB0A40;--cosmos-button-font-family: var(--rbup-font-family);--cosmos-font-family-text: var(--rbup-font-family);--cosmos-text-color: c.$cosmos-color-text-dark;--cosmos-text-font-family: var(--rbup-font-family);--cosmos-tooltip-font-family: var(--rbup-font-family);--cosmos-tooltip-font-size: 14px;font-family:var(--rbup-font-family)}[data-rbup-button]:not[kind=secondary]{--cosmos-button-background: #DB0A40;--cosmos-button-background-hover: #C3093B}[data-rbup-button][kind=bare]{--cosmos-button-background: #DB0A40;--cosmos-button-background-hover: #C3093B}[data-rbup-button][kind=bare]::part(base){background:var(--cosmos-button-background)}[data-rbup-button][kind=bare]::part(base):focus,[data-rbup-button][kind=bare]::part(base):hover{background:#C3093B}.buffer-bar{background-color:#ccc}.controls-time-display{margin-left:12px}.scrub-bar__rail{background-color:#ccc}.seek-bar-tooltip__text{padding:0}.volume-controls{margin-left:8px}.volume-indicator-element{background-color:#ccc}.volume-indicator-element--active,.volume-indicator-element--highlighted{background-color:var(--rbup-primary-color)}.next-video-countdown{height:100%;left:0;position:absolute;top:0;width:100%}.next-video-countdown__button-container{margin-top:32px;margin-bottom:32px;position:relative}.cq-650 .next-video-countdown__button-container{margin-bottom:80px}.next-video-countdown__container{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}.next-video-countdown__countdown{height:48px;left:-4px;position:absolute;top:-4px;width:48px}.next-video-countdown__countdown circle{animation:stroke 10s linear;stroke:#db0a40;stroke-dasharray:300,300;stroke-dashoffset:0;transform:rotate(-90deg);transform-origin:center center}.next-video-countdown__play-button::part(base){height:40px;max-width:40px;min-width:40px;width:40px}.next-video-countdown__play-icon{height:25px;width:25px}.next-video-countdown__poster-container{height:100%;width:100%}.next-video-countdown__poster-container img{height:100%;width:100%;object-fit:cover}.next-video-countdown__title{--cosmos-text-font-size: 20px}.next-video-countdown__titles{display:none}.next-video-countdown__video-title{--cosmos-text-font-size: 24px;margin-top:8px}.cq-540 .next-video-countdown__countdown{height:96px;left:-8px;position:absolute;top:-8px;width:96px}.cq-540 .next-video-countdown__countdown circle{animation:stroke 10s linear;stroke:#db0a40;stroke-dasharray:300,300;stroke-dashoffset:0;transform:rotate(-90deg);transform-origin:center center}.cq-540 .next-video-countdown__play-button::part(base){height:80px;max-width:80px;min-width:80px;width:80px}.cq-540 .next-video-countdown__play-icon{height:50px;width:50px}.cq-540 .next-video-countdown__titles{align-items:center;display:flex;flex-direction:column}.cq-650 .next-video-countdown__title{--cosmos-text-font-size: 29px}.cq-650 .next-video-countdown__titles{align-items:center;display:flex;flex-direction:column}.cq-650 .next-video-countdown__video-title{--cosmos-text-font-size: 41px}@keyframes stroke{0%{stroke-dashoffset:300}to{stroke-dashoffset:35}}
`, CartoonsThemeComponent = ({
  sizeBreakpoints: re,
  playerWidth: te,
  nextVideo: ee,
  onMuted: ne,
  onNextVideo: ie,
  onUnmuted: ae,
  playerCoordinator: ce,
  playerStatus: he,
  aspectRatio: _e,
  globalKeyboardNavigation: le
}) => {
  const [se, oe] = h$2(ee);
  p(() => {
    he === "PLAYING" && ee && oe(ee);
  }, [he, ee]);
  const ue = ee && se !== ee && he === "ENDED", be = ee && !ue && he === "ENDED", {
    playerState: { posterImage: ve }
  } = usePlayerContext(), me = F$1(
    () => ve ? calculatePosterSrcSet(ve, _e) : void 0,
    [_e, ve]
  ), pe = T$1(
    (ge) => {
      const ye = ge instanceof PointerEvent ? "TRIGGERED_BY_USER_INTERACTION" : "TRIGGERED_AUTOMATICALLY";
      dispatchNextUpPlayerEvent(ye, ce), ie == null || ie();
    },
    [ie, ce]
  ), fe = T$1(() => {
    dispatchNextUpPlayerEvent("CANCELLED_BY_USER_INTERACTION", ce), ce.restartPlaybackFromBeginning(), ce.play();
  }, [ce]);
  return p(() => {
    const ge = (ye) => {
      ye.type === "muted" ? ne == null || ne() : ye.type === "unmuted" && (ae == null || ae());
    };
    return ce.addEventListener(ge), () => {
      ce.removeEventListener(ge);
    };
  }, [ne, ae, ce]), /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement(
    RbupVideoCoreOverlay,
    {
      enableDuration: !1,
      enableSeek: !1,
      enableVideoDetails: !1,
      sizeBreakpoints: re,
      onlyFullscreenControls: !0,
      playerCoordinator: ce,
      globalKeyboardNavigation: le
    }
  ), !ue && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, be ? /* @__PURE__ */ Cn.createElement(
    NextVideoCountdown,
    {
      playerWidth: te,
      onNextClick: pe,
      onReplayClick: fe,
      posterImageSrcSet: me,
      title: ee.overrideTitle
    }
  ) : /* @__PURE__ */ Cn.createElement("div", { "data-rbup-start-end-container": !0 }, /* @__PURE__ */ Cn.createElement(StartAndEndView, { playerWidth: te }))));
}, RbupVideoCartoonsTheme = k((re, te) => /* @__PURE__ */ Cn.createElement(ThemedPlayer, { ref: te, styles, ThemeComponent: CartoonsThemeComponent, ...re }));
var WebComponentNames = /* @__PURE__ */ ((re) => (re.CARTOONS = "rbup-video-cartoons", re.RBCOM_CARTOONS = "rbup-video-rbcom-cartoons", re))(WebComponentNames || {});
function createPlayerConfiguration(re, te, ee) {
  const {
    _debug: ne,
    assetId: ie,
    autoplay: ae = !1,
    cookieConsent: ce,
    details: he = "visible",
    environment: _e,
    muted: le,
    overrideAudioLanguage: se,
    overrideSubtitleLanguage: oe,
    poster: ue,
    videoDescription: be,
    videoTitle: ve,
    skipCosmosFontInjection: me
  } = re;
  return {
    _debug: {
      playerAdapterType: ne == null ? void 0 : ne.playerAdapterType
    },
    autoplay: isTrueValue(ae),
    assetId: ie,
    cookieConsent: isTrueValue(ce),
    description: be,
    environment: _e,
    initialSeekTimeInSec: te.determineInitialSeek(ie),
    muted: le,
    overrideAudioLanguage: se,
    overrideSubtitleLanguage: oe,
    phasing: !1,
    posterImageUrl: ue,
    sharingEnabled: !1,
    skipCosmosFontInjection: isTrueValue(me),
    title: ve,
    tracking: {
      configs: {
        googleAnalytics: {
          ...cartoonsTrackingConfig,
          dataLayer: re.customDataLayer,
          customInitAttributes: { ...resolveTrackingCustomInitAttributes(ie) },
          eventCustomizer: ee
        }
      }
    },
    videoDetails: he,
    mediaSessionArtist: "Cartoons"
  };
}
function createPlayerConfigurationDataWithNextVideo(re, te, ee, ne) {
  return {
    ...re,
    assetId: te.assetId,
    autoplay: !0,
    muted: ee ? "MUTED" : "NOT_MUTED",
    tracking: {
      configs: {
        googleAnalytics: {
          ...re.tracking.configs.googleAnalytics,
          customInitAttributes: { ...resolveTrackingCustomInitAttributes(te.assetId) },
          eventCustomizer: ne
        }
      }
    }
  };
}
const RbupVideoCartoons = ({
  id: re,
  children: te,
  _debug: ee,
  assetId: ne,
  autoplay: ie = !1,
  cookieConsent: ae,
  customDataLayer: ce,
  details: he = "visible",
  environment: _e,
  globalKeyboardNavigation: le,
  internalOnApiAvailable: se,
  muted: oe,
  overrideAudioLanguage: ue,
  overrideSubtitleLanguage: be,
  playlist: ve,
  poster: me,
  skipCosmosFontInjection: pe = !1,
  videoDescription: fe,
  videoTitle: ge,
  aspectRatio: ye,
  prNumber: $e,
  tagName: Se
}) => {
  const Ce = _(null), Ie = useGetTagName(Ce), Te = Se ?? Ie ?? "rbup-video-cartoons", Ee = F$1(
    () => Te === "rbup-video-cartoons" ? new CartoonsDataloader($e) : new RbcomCartoonsDataloader($e),
    [$e, Te]
  ), [we] = h$2(new QueryParamUrlSharingStrategy()), [Pe] = h$2(new CartoonsTrackingEventCustomizer()), Me = _(!1), Ae = _(parsePlaylistEntries(ve));
  if (ve && ne)
    throw new Error("you should provide either `assetId` or `playlist` but not both");
  const [Oe, Be] = h$2(void 0);
  p(() => {
    ve && (Ae.current = parsePlaylistEntries(ve));
    const [Ne, ...xe] = Ae.current, ke = (Ne == null ? void 0 : Ne.assetId) ?? ne;
    if (ke) {
      const Le = {
        _debug: ee,
        assetId: ke,
        autoplay: isTrueValue(ie),
        cookieConsent: isTrueValue(ae),
        customDataLayer: ce,
        details: he,
        environment: _e,
        muted: oe,
        overrideAudioLanguage: ue,
        overrideSubtitleLanguage: be,
        poster: me,
        skipCosmosFontInjection: isTrueValue(pe),
        videoDescription: fe,
        videoTitle: ge
      };
      Be(createPlayerConfiguration(Le, we, Pe));
    }
    xe.length && (Ae.current = xe);
  }, [
    ee,
    ne,
    ie,
    ae,
    he,
    _e,
    oe,
    ue,
    be,
    ve,
    Ae,
    me,
    pe,
    fe,
    ge,
    we,
    ce,
    Pe
  ]);
  const Ve = T$1(() => {
    Me.current = !0;
  }, []), Ue = T$1(() => {
    Me.current = !1;
  }, []), Re = T$1(() => {
    if (Ae.current.length === 0)
      return;
    const [Ne, ...xe] = Ae.current;
    Be(
      (ke) => ke ? createPlayerConfigurationDataWithNextVideo(
        ke,
        Ne,
        Me.current,
        Pe
      ) : void 0
    ), Ae.current = xe.length ? xe : parsePlaylistEntries(ve);
  }, [ve, Pe]);
  return /* @__PURE__ */ Cn.createElement("div", { ref: Ce }, Oe && /* @__PURE__ */ Cn.createElement(
    RbupVideoCartoonsTheme,
    {
      config: Oe,
      dataLoader: Ee,
      id: re,
      nextVideo: Ae.current[0],
      internalOnApiAvailable: se,
      onMuted: Ve,
      onNextVideo: Re,
      onUnmuted: Ue,
      urlSharingStrategy: we,
      aspectRatio: ye,
      globalKeyboardNavigation: le
    }
  ));
};
function initRbupVideoCartoons(re, te) {
  return initRbupVideo(
    re,
    "rbup-video-cartoons",
    te
  );
}
function initRbupVideoRbcomCartoons(re, te) {
  return initRbupVideo(
    re,
    "rbup-video-rbcom-cartoons",
    te
  );
}
const cartoonsObservedAttributes = [
  "aspect-ratio",
  "asset-id",
  "autoplay",
  "cookie-consent",
  "custom-data-layer",
  "details",
  "environment",
  "global-keyboard-navigation",
  "internal-on-api-available",
  "muted",
  "override-audio-language",
  "override-subtitle-language",
  "playlist",
  "poster",
  "pr-number",
  "skip-cosmos-font-injection",
  "video-description",
  "video-title"
];
register(RbupVideoCartoons, WebComponentNames.CARTOONS, cartoonsObservedAttributes, {
  shadow: !0
});
register(RbupVideoCartoons, WebComponentNames.RBCOM_CARTOONS, cartoonsObservedAttributes, {
  shadow: !0
});
window.initRbupVideoCartoons = initRbupVideoCartoons;
window.initRbupVideoRbcomCartoons = initRbupVideoRbcomCartoons;
export {
  WebComponentNames,
  initRbupVideoCartoons,
  initRbupVideoRbcomCartoons
};
